export default [
  {
    zip: "501",
    ST: "NY",
    cityWithStateAbbr: "Holtsville, NY",
  },
  {
    zip: "544",
    ST: "NY",
    cityWithStateAbbr: "Holtsville, NY",
  },
  {
    zip: "601",
    ST: "PR",
    cityWithStateAbbr: "Adjuntas, PR",
  },
  {
    zip: "602",
    ST: "PR",
    cityWithStateAbbr: "Aguada, PR",
  },
  {
    zip: "603",
    ST: "PR",
    cityWithStateAbbr: "Aguadilla, PR",
  },
  {
    zip: "604",
    ST: "PR",
    cityWithStateAbbr: "Aguadilla, PR",
  },
  {
    zip: "605",
    ST: "PR",
    cityWithStateAbbr: "Aguadilla, PR",
  },
  {
    zip: "606",
    ST: "PR",
    cityWithStateAbbr: "Maricao, PR",
  },
  {
    zip: "610",
    ST: "PR",
    cityWithStateAbbr: "Anasco, PR",
  },
  {
    zip: "611",
    ST: "PR",
    cityWithStateAbbr: "Angeles, PR",
  },
  {
    zip: "612",
    ST: "PR",
    cityWithStateAbbr: "Arecibo, PR",
  },
  {
    zip: "613",
    ST: "PR",
    cityWithStateAbbr: "Arecibo, PR",
  },
  {
    zip: "614",
    ST: "PR",
    cityWithStateAbbr: "Arecibo, PR",
  },
  {
    zip: "616",
    ST: "PR",
    cityWithStateAbbr: "Bajadero, PR",
  },
  {
    zip: "617",
    ST: "PR",
    cityWithStateAbbr: "Barceloneta, PR",
  },
  {
    zip: "622",
    ST: "PR",
    cityWithStateAbbr: "Boqueron, PR",
  },
  {
    zip: "623",
    ST: "PR",
    cityWithStateAbbr: "Cabo Rojo, PR",
  },
  {
    zip: "624",
    ST: "PR",
    cityWithStateAbbr: "Penuelas, PR",
  },
  {
    zip: "627",
    ST: "PR",
    cityWithStateAbbr: "Camuy, PR",
  },
  {
    zip: "631",
    ST: "PR",
    cityWithStateAbbr: "Castaner, PR",
  },
  {
    zip: "636",
    ST: "PR",
    cityWithStateAbbr: "Rosario, PR",
  },
  {
    zip: "637",
    ST: "PR",
    cityWithStateAbbr: "Sabana Grande, PR",
  },
  {
    zip: "638",
    ST: "PR",
    cityWithStateAbbr: "Ciales, PR",
  },
  {
    zip: "641",
    ST: "PR",
    cityWithStateAbbr: "Utuado, PR",
  },
  {
    zip: "646",
    ST: "PR",
    cityWithStateAbbr: "Dorado, PR",
  },
  {
    zip: "647",
    ST: "PR",
    cityWithStateAbbr: "Ensenada, PR",
  },
  {
    zip: "650",
    ST: "PR",
    cityWithStateAbbr: "Florida, PR",
  },
  {
    zip: "652",
    ST: "PR",
    cityWithStateAbbr: "Garrochales, PR",
  },
  {
    zip: "653",
    ST: "PR",
    cityWithStateAbbr: "Guanica, PR",
  },
  {
    zip: "656",
    ST: "PR",
    cityWithStateAbbr: "Guayanilla, PR",
  },
  {
    zip: "659",
    ST: "PR",
    cityWithStateAbbr: "Hatillo, PR",
  },
  {
    zip: "660",
    ST: "PR",
    cityWithStateAbbr: "Hormigueros, PR",
  },
  {
    zip: "662",
    ST: "PR",
    cityWithStateAbbr: "Isabela, PR",
  },
  {
    zip: "664",
    ST: "PR",
    cityWithStateAbbr: "Jayuya, PR",
  },
  {
    zip: "667",
    ST: "PR",
    cityWithStateAbbr: "Lajas, PR",
  },
  {
    zip: "669",
    ST: "PR",
    cityWithStateAbbr: "Lares, PR",
  },
  {
    zip: "670",
    ST: "PR",
    cityWithStateAbbr: "Las Marias, PR",
  },
  {
    zip: "674",
    ST: "PR",
    cityWithStateAbbr: "Manati, PR",
  },
  {
    zip: "676",
    ST: "PR",
    cityWithStateAbbr: "Moca, PR",
  },
  {
    zip: "677",
    ST: "PR",
    cityWithStateAbbr: "Rincon, PR",
  },
  {
    zip: "678",
    ST: "PR",
    cityWithStateAbbr: "Quebradillas, PR",
  },
  {
    zip: "680",
    ST: "PR",
    cityWithStateAbbr: "Mayaguez, PR",
  },
  {
    zip: "681",
    ST: "PR",
    cityWithStateAbbr: "Mayaguez, PR",
  },
  {
    zip: "682",
    ST: "PR",
    cityWithStateAbbr: "Mayaguez, PR",
  },
  {
    zip: "683",
    ST: "PR",
    cityWithStateAbbr: "San German, PR",
  },
  {
    zip: "685",
    ST: "PR",
    cityWithStateAbbr: "San Sebastian, PR",
  },
  {
    zip: "687",
    ST: "PR",
    cityWithStateAbbr: "Morovis, PR",
  },
  {
    zip: "688",
    ST: "PR",
    cityWithStateAbbr: "Sabana Hoyos, PR",
  },
  {
    zip: "690",
    ST: "PR",
    cityWithStateAbbr: "San Antonio, PR",
  },
  {
    zip: "692",
    ST: "PR",
    cityWithStateAbbr: "Vega Alta, PR",
  },
  {
    zip: "693",
    ST: "PR",
    cityWithStateAbbr: "Vega Baja, PR",
  },
  {
    zip: "694",
    ST: "PR",
    cityWithStateAbbr: "Vega Baja, PR",
  },
  {
    zip: "698",
    ST: "PR",
    cityWithStateAbbr: "Yauco, PR",
  },
  {
    zip: "703",
    ST: "PR",
    cityWithStateAbbr: "Aguas Buenas, PR",
  },
  {
    zip: "704",
    ST: "PR",
    cityWithStateAbbr: "Aguirre, PR",
  },
  {
    zip: "705",
    ST: "PR",
    cityWithStateAbbr: "Aibonito, PR",
  },
  {
    zip: "707",
    ST: "PR",
    cityWithStateAbbr: "Maunabo, PR",
  },
  {
    zip: "714",
    ST: "PR",
    cityWithStateAbbr: "Arroyo, PR",
  },
  {
    zip: "715",
    ST: "PR",
    cityWithStateAbbr: "Mercedita, PR",
  },
  {
    zip: "716",
    ST: "PR",
    cityWithStateAbbr: "Ponce, PR",
  },
  {
    zip: "717",
    ST: "PR",
    cityWithStateAbbr: "Ponce, PR",
  },
  {
    zip: "718",
    ST: "PR",
    cityWithStateAbbr: "Naguabo, PR",
  },
  {
    zip: "719",
    ST: "PR",
    cityWithStateAbbr: "Naranjito, PR",
  },
  {
    zip: "720",
    ST: "PR",
    cityWithStateAbbr: "Orocovis, PR",
  },
  {
    zip: "721",
    ST: "PR",
    cityWithStateAbbr: "Palmer, PR",
  },
  {
    zip: "723",
    ST: "PR",
    cityWithStateAbbr: "Patillas, PR",
  },
  {
    zip: "725",
    ST: "PR",
    cityWithStateAbbr: "Caguas, PR",
  },
  {
    zip: "726",
    ST: "PR",
    cityWithStateAbbr: "Caguas, PR",
  },
  {
    zip: "727",
    ST: "PR",
    cityWithStateAbbr: "Caguas, PR",
  },
  {
    zip: "728",
    ST: "PR",
    cityWithStateAbbr: "Ponce, PR",
  },
  {
    zip: "729",
    ST: "PR",
    cityWithStateAbbr: "Canovanas, PR",
  },
  {
    zip: "730",
    ST: "PR",
    cityWithStateAbbr: "Ponce, PR",
  },
  {
    zip: "731",
    ST: "PR",
    cityWithStateAbbr: "Ponce, PR",
  },
  {
    zip: "732",
    ST: "PR",
    cityWithStateAbbr: "Ponce, PR",
  },
  {
    zip: "733",
    ST: "PR",
    cityWithStateAbbr: "Ponce, PR",
  },
  {
    zip: "734",
    ST: "PR",
    cityWithStateAbbr: "Ponce, PR",
  },
  {
    zip: "735",
    ST: "PR",
    cityWithStateAbbr: "Ceiba, PR",
  },
  {
    zip: "736",
    ST: "PR",
    cityWithStateAbbr: "Cayey, PR",
  },
  {
    zip: "737",
    ST: "PR",
    cityWithStateAbbr: "Cayey, PR",
  },
  {
    zip: "738",
    ST: "PR",
    cityWithStateAbbr: "Fajardo, PR",
  },
  {
    zip: "739",
    ST: "PR",
    cityWithStateAbbr: "Cidra, PR",
  },
  {
    zip: "740",
    ST: "PR",
    cityWithStateAbbr: "Puerto Real, PR",
  },
  {
    zip: "741",
    ST: "PR",
    cityWithStateAbbr: "Punta Santiago, PR",
  },
  {
    zip: "742",
    ST: "PR",
    cityWithStateAbbr: "Roosevelt Roads, PR",
  },
  {
    zip: "744",
    ST: "PR",
    cityWithStateAbbr: "Rio Blanco, PR",
  },
  {
    zip: "745",
    ST: "PR",
    cityWithStateAbbr: "Rio Grande, PR",
  },
  {
    zip: "751",
    ST: "PR",
    cityWithStateAbbr: "Salinas, PR",
  },
  {
    zip: "754",
    ST: "PR",
    cityWithStateAbbr: "San Lorenzo, PR",
  },
  {
    zip: "757",
    ST: "PR",
    cityWithStateAbbr: "Santa Isabel, PR",
  },
  {
    zip: "765",
    ST: "PR",
    cityWithStateAbbr: "Vieques, PR",
  },
  {
    zip: "766",
    ST: "PR",
    cityWithStateAbbr: "Villalba, PR",
  },
  {
    zip: "767",
    ST: "PR",
    cityWithStateAbbr: "Yabucoa, PR",
  },
  {
    zip: "769",
    ST: "PR",
    cityWithStateAbbr: "Coamo, PR",
  },
  {
    zip: "771",
    ST: "PR",
    cityWithStateAbbr: "Las Piedras, PR",
  },
  {
    zip: "772",
    ST: "PR",
    cityWithStateAbbr: "Loiza, PR",
  },
  {
    zip: "773",
    ST: "PR",
    cityWithStateAbbr: "Luquillo, PR",
  },
  {
    zip: "775",
    ST: "PR",
    cityWithStateAbbr: "Culebra, PR",
  },
  {
    zip: "777",
    ST: "PR",
    cityWithStateAbbr: "Juncos, PR",
  },
  {
    zip: "778",
    ST: "PR",
    cityWithStateAbbr: "Gurabo, PR",
  },
  {
    zip: "780",
    ST: "PR",
    cityWithStateAbbr: "Coto Laurel, PR",
  },
  {
    zip: "782",
    ST: "PR",
    cityWithStateAbbr: "Comerio, PR",
  },
  {
    zip: "783",
    ST: "PR",
    cityWithStateAbbr: "Corozal, PR",
  },
  {
    zip: "784",
    ST: "PR",
    cityWithStateAbbr: "Guayama, PR",
  },
  {
    zip: "785",
    ST: "PR",
    cityWithStateAbbr: "Guayama, PR",
  },
  {
    zip: "786",
    ST: "PR",
    cityWithStateAbbr: "La Plata, PR",
  },
  {
    zip: "791",
    ST: "PR",
    cityWithStateAbbr: "Humacao, PR",
  },
  {
    zip: "792",
    ST: "PR",
    cityWithStateAbbr: "Humacao, PR",
  },
  {
    zip: "794",
    ST: "PR",
    cityWithStateAbbr: "Barranquitas, PR",
  },
  {
    zip: "795",
    ST: "PR",
    cityWithStateAbbr: "Juana Diaz, PR",
  },
  {
    zip: "801",
    ST: "VI",
    cityWithStateAbbr: "St Thomas, VI",
  },
  {
    zip: "802",
    ST: "VI",
    cityWithStateAbbr: "St Thomas, VI",
  },
  {
    zip: "803",
    ST: "VI",
    cityWithStateAbbr: "St Thomas, VI",
  },
  {
    zip: "804",
    ST: "VI",
    cityWithStateAbbr: "St Thomas, VI",
  },
  {
    zip: "805",
    ST: "VI",
    cityWithStateAbbr: "St Thomas, VI",
  },
  {
    zip: "820",
    ST: "VI",
    cityWithStateAbbr: "Christiansted, VI",
  },
  {
    zip: "821",
    ST: "VI",
    cityWithStateAbbr: "Christiansted, VI",
  },
  {
    zip: "822",
    ST: "VI",
    cityWithStateAbbr: "Christiansted, VI",
  },
  {
    zip: "823",
    ST: "VI",
    cityWithStateAbbr: "Christiansted, VI",
  },
  {
    zip: "824",
    ST: "VI",
    cityWithStateAbbr: "Christiansted, VI",
  },
  {
    zip: "830",
    ST: "VI",
    cityWithStateAbbr: "St John, VI",
  },
  {
    zip: "831",
    ST: "VI",
    cityWithStateAbbr: "St John, VI",
  },
  {
    zip: "840",
    ST: "VI",
    cityWithStateAbbr: "Frederiksted, VI",
  },
  {
    zip: "841",
    ST: "VI",
    cityWithStateAbbr: "Frederiksted, VI",
  },
  {
    zip: "850",
    ST: "VI",
    cityWithStateAbbr: "Kingshill, VI",
  },
  {
    zip: "851",
    ST: "VI",
    cityWithStateAbbr: "Kingshill, VI",
  },
  {
    zip: "901",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "902",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "906",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "907",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "908",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "909",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "910",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "911",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "912",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "913",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "914",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "915",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "916",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "917",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "918",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "919",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "920",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "921",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "922",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "923",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "924",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "925",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "926",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "927",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "928",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "929",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "930",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "931",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "933",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "934",
    ST: "PR",
    cityWithStateAbbr: "Fort Buchanan, PR",
  },
  {
    zip: "935",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "936",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "937",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "939",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "940",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "949",
    ST: "PR",
    cityWithStateAbbr: "Toa Baja, PR",
  },
  {
    zip: "950",
    ST: "PR",
    cityWithStateAbbr: "Toa Baja, PR",
  },
  {
    zip: "951",
    ST: "PR",
    cityWithStateAbbr: "Toa Baja, PR",
  },
  {
    zip: "952",
    ST: "PR",
    cityWithStateAbbr: "Sabana Seca, PR",
  },
  {
    zip: "953",
    ST: "PR",
    cityWithStateAbbr: "Toa Alta, PR",
  },
  {
    zip: "954",
    ST: "PR",
    cityWithStateAbbr: "Toa Alta, PR",
  },
  {
    zip: "955",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "956",
    ST: "PR",
    cityWithStateAbbr: "Bayamon, PR",
  },
  {
    zip: "957",
    ST: "PR",
    cityWithStateAbbr: "Bayamon, PR",
  },
  {
    zip: "958",
    ST: "PR",
    cityWithStateAbbr: "Bayamon, PR",
  },
  {
    zip: "959",
    ST: "PR",
    cityWithStateAbbr: "Bayamon, PR",
  },
  {
    zip: "960",
    ST: "PR",
    cityWithStateAbbr: "Bayamon, PR",
  },
  {
    zip: "961",
    ST: "PR",
    cityWithStateAbbr: "Bayamon, PR",
  },
  {
    zip: "962",
    ST: "PR",
    cityWithStateAbbr: "Catano, PR",
  },
  {
    zip: "963",
    ST: "PR",
    cityWithStateAbbr: "Catano, PR",
  },
  {
    zip: "965",
    ST: "PR",
    cityWithStateAbbr: "Guaynabo, PR",
  },
  {
    zip: "966",
    ST: "PR",
    cityWithStateAbbr: "Guaynabo, PR",
  },
  {
    zip: "968",
    ST: "PR",
    cityWithStateAbbr: "Guaynabo, PR",
  },
  {
    zip: "969",
    ST: "PR",
    cityWithStateAbbr: "Guaynabo, PR",
  },
  {
    zip: "970",
    ST: "PR",
    cityWithStateAbbr: "Guaynabo, PR",
  },
  {
    zip: "971",
    ST: "PR",
    cityWithStateAbbr: "Guaynabo, PR",
  },
  {
    zip: "975",
    ST: "PR",
    cityWithStateAbbr: "San Juan, PR",
  },
  {
    zip: "976",
    ST: "PR",
    cityWithStateAbbr: "Trujillo Alto, PR",
  },
  {
    zip: "977",
    ST: "PR",
    cityWithStateAbbr: "Trujillo Alto, PR",
  },
  {
    zip: "978",
    ST: "PR",
    cityWithStateAbbr: "Saint Just, PR",
  },
  {
    zip: "979",
    ST: "PR",
    cityWithStateAbbr: "Carolina, PR",
  },
  {
    zip: "981",
    ST: "PR",
    cityWithStateAbbr: "Carolina, PR",
  },
  {
    zip: "982",
    ST: "PR",
    cityWithStateAbbr: "Carolina, PR",
  },
  {
    zip: "983",
    ST: "PR",
    cityWithStateAbbr: "Carolina, PR",
  },
  {
    zip: "984",
    ST: "PR",
    cityWithStateAbbr: "Carolina, PR",
  },
  {
    zip: "985",
    ST: "PR",
    cityWithStateAbbr: "Carolina, PR",
  },
  {
    zip: "986",
    ST: "PR",
    cityWithStateAbbr: "Carolina, PR",
  },
  {
    zip: "987",
    ST: "PR",
    cityWithStateAbbr: "Carolina, PR",
  },
  {
    zip: "988",
    ST: "PR",
    cityWithStateAbbr: "Carolina, PR",
  },
  {
    zip: "1001",
    ST: "MA",
    cityWithStateAbbr: "Agawam, MA",
  },
  {
    zip: "1002",
    ST: "MA",
    cityWithStateAbbr: "Amherst, MA",
  },
  {
    zip: "1003",
    ST: "MA",
    cityWithStateAbbr: "Amherst, MA",
  },
  {
    zip: "1004",
    ST: "MA",
    cityWithStateAbbr: "Amherst, MA",
  },
  {
    zip: "1005",
    ST: "MA",
    cityWithStateAbbr: "Barre, MA",
  },
  {
    zip: "1007",
    ST: "MA",
    cityWithStateAbbr: "Belchertown, MA",
  },
  {
    zip: "1008",
    ST: "MA",
    cityWithStateAbbr: "Blandford, MA",
  },
  {
    zip: "1009",
    ST: "MA",
    cityWithStateAbbr: "Bondsville, MA",
  },
  {
    zip: "1010",
    ST: "MA",
    cityWithStateAbbr: "Brimfield, MA",
  },
  {
    zip: "1011",
    ST: "MA",
    cityWithStateAbbr: "Chester, MA",
  },
  {
    zip: "1012",
    ST: "MA",
    cityWithStateAbbr: "Chesterfield, MA",
  },
  {
    zip: "1013",
    ST: "MA",
    cityWithStateAbbr: "Chicopee, MA",
  },
  {
    zip: "1014",
    ST: "MA",
    cityWithStateAbbr: "Chicopee, MA",
  },
  {
    zip: "1020",
    ST: "MA",
    cityWithStateAbbr: "Chicopee, MA",
  },
  {
    zip: "1021",
    ST: "MA",
    cityWithStateAbbr: "Chicopee, MA",
  },
  {
    zip: "1022",
    ST: "MA",
    cityWithStateAbbr: "Chicopee, MA",
  },
  {
    zip: "1026",
    ST: "MA",
    cityWithStateAbbr: "Cummington, MA",
  },
  {
    zip: "1027",
    ST: "MA",
    cityWithStateAbbr: "Easthampton, MA",
  },
  {
    zip: "1028",
    ST: "MA",
    cityWithStateAbbr: "East Longmeadow, MA",
  },
  {
    zip: "1029",
    ST: "MA",
    cityWithStateAbbr: "East Otis, MA",
  },
  {
    zip: "1030",
    ST: "MA",
    cityWithStateAbbr: "Feeding Hills, MA",
  },
  {
    zip: "1031",
    ST: "MA",
    cityWithStateAbbr: "Gilbertville, MA",
  },
  {
    zip: "1032",
    ST: "MA",
    cityWithStateAbbr: "Goshen, MA",
  },
  {
    zip: "1033",
    ST: "MA",
    cityWithStateAbbr: "Granby, MA",
  },
  {
    zip: "1034",
    ST: "MA",
    cityWithStateAbbr: "Granville, MA",
  },
  {
    zip: "1035",
    ST: "MA",
    cityWithStateAbbr: "Hadley, MA",
  },
  {
    zip: "1036",
    ST: "MA",
    cityWithStateAbbr: "Hampden, MA",
  },
  {
    zip: "1037",
    ST: "MA",
    cityWithStateAbbr: "Hardwick, MA",
  },
  {
    zip: "1038",
    ST: "MA",
    cityWithStateAbbr: "Hatfield, MA",
  },
  {
    zip: "1039",
    ST: "MA",
    cityWithStateAbbr: "Haydenville, MA",
  },
  {
    zip: "1040",
    ST: "MA",
    cityWithStateAbbr: "Holyoke, MA",
  },
  {
    zip: "1041",
    ST: "MA",
    cityWithStateAbbr: "Holyoke, MA",
  },
  {
    zip: "1050",
    ST: "MA",
    cityWithStateAbbr: "Huntington, MA",
  },
  {
    zip: "1053",
    ST: "MA",
    cityWithStateAbbr: "Leeds, MA",
  },
  {
    zip: "1054",
    ST: "MA",
    cityWithStateAbbr: "Leverett, MA",
  },
  {
    zip: "1056",
    ST: "MA",
    cityWithStateAbbr: "Ludlow, MA",
  },
  {
    zip: "1057",
    ST: "MA",
    cityWithStateAbbr: "Monson, MA",
  },
  {
    zip: "1059",
    ST: "MA",
    cityWithStateAbbr: "North Amherst, MA",
  },
  {
    zip: "1060",
    ST: "MA",
    cityWithStateAbbr: "Northampton, MA",
  },
  {
    zip: "1061",
    ST: "MA",
    cityWithStateAbbr: "Northampton, MA",
  },
  {
    zip: "1062",
    ST: "MA",
    cityWithStateAbbr: "Florence, MA",
  },
  {
    zip: "1063",
    ST: "MA",
    cityWithStateAbbr: "Northampton, MA",
  },
  {
    zip: "1066",
    ST: "MA",
    cityWithStateAbbr: "North Hatfield, MA",
  },
  {
    zip: "1068",
    ST: "MA",
    cityWithStateAbbr: "Oakham, MA",
  },
  {
    zip: "1069",
    ST: "MA",
    cityWithStateAbbr: "Palmer, MA",
  },
  {
    zip: "1070",
    ST: "MA",
    cityWithStateAbbr: "Plainfield, MA",
  },
  {
    zip: "1071",
    ST: "MA",
    cityWithStateAbbr: "Russell, MA",
  },
  {
    zip: "1072",
    ST: "MA",
    cityWithStateAbbr: "Shutesbury, MA",
  },
  {
    zip: "1073",
    ST: "MA",
    cityWithStateAbbr: "Southampton, MA",
  },
  {
    zip: "1074",
    ST: "MA",
    cityWithStateAbbr: "South Barre, MA",
  },
  {
    zip: "1075",
    ST: "MA",
    cityWithStateAbbr: "South Hadley, MA",
  },
  {
    zip: "1077",
    ST: "MA",
    cityWithStateAbbr: "Southwick, MA",
  },
  {
    zip: "1079",
    ST: "MA",
    cityWithStateAbbr: "Thorndike, MA",
  },
  {
    zip: "1080",
    ST: "MA",
    cityWithStateAbbr: "Three Rivers, MA",
  },
  {
    zip: "1081",
    ST: "MA",
    cityWithStateAbbr: "Wales, MA",
  },
  {
    zip: "1082",
    ST: "MA",
    cityWithStateAbbr: "Ware, MA",
  },
  {
    zip: "1083",
    ST: "MA",
    cityWithStateAbbr: "Warren, MA",
  },
  {
    zip: "1084",
    ST: "MA",
    cityWithStateAbbr: "West Chesterfield, MA",
  },
  {
    zip: "1085",
    ST: "MA",
    cityWithStateAbbr: "Westfield, MA",
  },
  {
    zip: "1086",
    ST: "MA",
    cityWithStateAbbr: "Westfield, MA",
  },
  {
    zip: "1088",
    ST: "MA",
    cityWithStateAbbr: "West Hatfield, MA",
  },
  {
    zip: "1089",
    ST: "MA",
    cityWithStateAbbr: "West Springfield, MA",
  },
  {
    zip: "1090",
    ST: "MA",
    cityWithStateAbbr: "West Springfield, MA",
  },
  {
    zip: "1092",
    ST: "MA",
    cityWithStateAbbr: "West Warren, MA",
  },
  {
    zip: "1093",
    ST: "MA",
    cityWithStateAbbr: "Whately, MA",
  },
  {
    zip: "1094",
    ST: "MA",
    cityWithStateAbbr: "Wheelwright, MA",
  },
  {
    zip: "1095",
    ST: "MA",
    cityWithStateAbbr: "Wilbraham, MA",
  },
  {
    zip: "1096",
    ST: "MA",
    cityWithStateAbbr: "Williamsburg, MA",
  },
  {
    zip: "1097",
    ST: "MA",
    cityWithStateAbbr: "Woronoco, MA",
  },
  {
    zip: "1098",
    ST: "MA",
    cityWithStateAbbr: "Worthington, MA",
  },
  {
    zip: "1101",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1102",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1103",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1104",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1105",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1106",
    ST: "MA",
    cityWithStateAbbr: "Longmeadow, MA",
  },
  {
    zip: "1107",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1108",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1109",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1111",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1115",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1116",
    ST: "MA",
    cityWithStateAbbr: "Longmeadow, MA",
  },
  {
    zip: "1118",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1119",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1128",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1129",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1138",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1139",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1144",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1151",
    ST: "MA",
    cityWithStateAbbr: "Indian Orchard, MA",
  },
  {
    zip: "1152",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1199",
    ST: "MA",
    cityWithStateAbbr: "Springfield, MA",
  },
  {
    zip: "1201",
    ST: "MA",
    cityWithStateAbbr: "Pittsfield, MA",
  },
  {
    zip: "1202",
    ST: "MA",
    cityWithStateAbbr: "Pittsfield, MA",
  },
  {
    zip: "1203",
    ST: "MA",
    cityWithStateAbbr: "Pittsfield, MA",
  },
  {
    zip: "1220",
    ST: "MA",
    cityWithStateAbbr: "Adams, MA",
  },
  {
    zip: "1222",
    ST: "MA",
    cityWithStateAbbr: "Ashley Falls, MA",
  },
  {
    zip: "1223",
    ST: "MA",
    cityWithStateAbbr: "Becket, MA",
  },
  {
    zip: "1224",
    ST: "MA",
    cityWithStateAbbr: "Berkshire, MA",
  },
  {
    zip: "1225",
    ST: "MA",
    cityWithStateAbbr: "Cheshire, MA",
  },
  {
    zip: "1226",
    ST: "MA",
    cityWithStateAbbr: "Dalton, MA",
  },
  {
    zip: "1227",
    ST: "MA",
    cityWithStateAbbr: "Dalton, MA",
  },
  {
    zip: "1229",
    ST: "MA",
    cityWithStateAbbr: "Glendale, MA",
  },
  {
    zip: "1230",
    ST: "MA",
    cityWithStateAbbr: "Great Barrington, MA",
  },
  {
    zip: "1235",
    ST: "MA",
    cityWithStateAbbr: "Hinsdale, MA",
  },
  {
    zip: "1236",
    ST: "MA",
    cityWithStateAbbr: "Housatonic, MA",
  },
  {
    zip: "1237",
    ST: "MA",
    cityWithStateAbbr: "Lanesboro, MA",
  },
  {
    zip: "1238",
    ST: "MA",
    cityWithStateAbbr: "Lee, MA",
  },
  {
    zip: "1240",
    ST: "MA",
    cityWithStateAbbr: "Lenox, MA",
  },
  {
    zip: "1242",
    ST: "MA",
    cityWithStateAbbr: "Lenox Dale, MA",
  },
  {
    zip: "1243",
    ST: "MA",
    cityWithStateAbbr: "Middlefield, MA",
  },
  {
    zip: "1244",
    ST: "MA",
    cityWithStateAbbr: "Mill River, MA",
  },
  {
    zip: "1245",
    ST: "MA",
    cityWithStateAbbr: "Monterey, MA",
  },
  {
    zip: "1247",
    ST: "MA",
    cityWithStateAbbr: "North Adams, MA",
  },
  {
    zip: "1252",
    ST: "MA",
    cityWithStateAbbr: "North Egremont, MA",
  },
  {
    zip: "1253",
    ST: "MA",
    cityWithStateAbbr: "Otis, MA",
  },
  {
    zip: "1254",
    ST: "MA",
    cityWithStateAbbr: "Richmond, MA",
  },
  {
    zip: "1255",
    ST: "MA",
    cityWithStateAbbr: "Sandisfield, MA",
  },
  {
    zip: "1256",
    ST: "MA",
    cityWithStateAbbr: "Savoy, MA",
  },
  {
    zip: "1257",
    ST: "MA",
    cityWithStateAbbr: "Sheffield, MA",
  },
  {
    zip: "1258",
    ST: "MA",
    cityWithStateAbbr: "South Egremont, MA",
  },
  {
    zip: "1259",
    ST: "MA",
    cityWithStateAbbr: "Southfield, MA",
  },
  {
    zip: "1260",
    ST: "MA",
    cityWithStateAbbr: "South Lee, MA",
  },
  {
    zip: "1262",
    ST: "MA",
    cityWithStateAbbr: "Stockbridge, MA",
  },
  {
    zip: "1263",
    ST: "MA",
    cityWithStateAbbr: "Stockbridge, MA",
  },
  {
    zip: "1264",
    ST: "MA",
    cityWithStateAbbr: "Tyringham, MA",
  },
  {
    zip: "1266",
    ST: "MA",
    cityWithStateAbbr: "West Stockbridge, MA",
  },
  {
    zip: "1267",
    ST: "MA",
    cityWithStateAbbr: "Williamstown, MA",
  },
  {
    zip: "1270",
    ST: "MA",
    cityWithStateAbbr: "Windsor, MA",
  },
  {
    zip: "1301",
    ST: "MA",
    cityWithStateAbbr: "Greenfield, MA",
  },
  {
    zip: "1302",
    ST: "MA",
    cityWithStateAbbr: "Greenfield, MA",
  },
  {
    zip: "1330",
    ST: "MA",
    cityWithStateAbbr: "Ashfield, MA",
  },
  {
    zip: "1331",
    ST: "MA",
    cityWithStateAbbr: "Athol, MA",
  },
  {
    zip: "1337",
    ST: "MA",
    cityWithStateAbbr: "Bernardston, MA",
  },
  {
    zip: "1338",
    ST: "MA",
    cityWithStateAbbr: "Buckland, MA",
  },
  {
    zip: "1339",
    ST: "MA",
    cityWithStateAbbr: "Charlemont, MA",
  },
  {
    zip: "1340",
    ST: "MA",
    cityWithStateAbbr: "Colrain, MA",
  },
  {
    zip: "1341",
    ST: "MA",
    cityWithStateAbbr: "Conway, MA",
  },
  {
    zip: "1342",
    ST: "MA",
    cityWithStateAbbr: "Deerfield, MA",
  },
  {
    zip: "1343",
    ST: "MA",
    cityWithStateAbbr: "Drury, MA",
  },
  {
    zip: "1344",
    ST: "MA",
    cityWithStateAbbr: "Erving, MA",
  },
  {
    zip: "1346",
    ST: "MA",
    cityWithStateAbbr: "Heath, MA",
  },
  {
    zip: "1347",
    ST: "MA",
    cityWithStateAbbr: "Lake Pleasant, MA",
  },
  {
    zip: "1349",
    ST: "MA",
    cityWithStateAbbr: "Millers Falls, MA",
  },
  {
    zip: "1350",
    ST: "MA",
    cityWithStateAbbr: "Monroe Bridge, MA",
  },
  {
    zip: "1351",
    ST: "MA",
    cityWithStateAbbr: "Montague, MA",
  },
  {
    zip: "1354",
    ST: "MA",
    cityWithStateAbbr: "Gill, MA",
  },
  {
    zip: "1355",
    ST: "MA",
    cityWithStateAbbr: "New Salem, MA",
  },
  {
    zip: "1360",
    ST: "MA",
    cityWithStateAbbr: "Northfield, MA",
  },
  {
    zip: "1364",
    ST: "MA",
    cityWithStateAbbr: "Orange, MA",
  },
  {
    zip: "1366",
    ST: "MA",
    cityWithStateAbbr: "Petersham, MA",
  },
  {
    zip: "1367",
    ST: "MA",
    cityWithStateAbbr: "Rowe, MA",
  },
  {
    zip: "1368",
    ST: "MA",
    cityWithStateAbbr: "Royalston, MA",
  },
  {
    zip: "1370",
    ST: "MA",
    cityWithStateAbbr: "Shelburne Falls, MA",
  },
  {
    zip: "1373",
    ST: "MA",
    cityWithStateAbbr: "South Deerfield, MA",
  },
  {
    zip: "1375",
    ST: "MA",
    cityWithStateAbbr: "Sunderland, MA",
  },
  {
    zip: "1376",
    ST: "MA",
    cityWithStateAbbr: "Turners Falls, MA",
  },
  {
    zip: "1378",
    ST: "MA",
    cityWithStateAbbr: "Warwick, MA",
  },
  {
    zip: "1379",
    ST: "MA",
    cityWithStateAbbr: "Wendell, MA",
  },
  {
    zip: "1380",
    ST: "MA",
    cityWithStateAbbr: "Wendell Depot, MA",
  },
  {
    zip: "1420",
    ST: "MA",
    cityWithStateAbbr: "Fitchburg, MA",
  },
  {
    zip: "1430",
    ST: "MA",
    cityWithStateAbbr: "Ashburnham, MA",
  },
  {
    zip: "1431",
    ST: "MA",
    cityWithStateAbbr: "Ashby, MA",
  },
  {
    zip: "1432",
    ST: "MA",
    cityWithStateAbbr: "Ayer, MA",
  },
  {
    zip: "1434",
    ST: "MA",
    cityWithStateAbbr: "Devens, MA",
  },
  {
    zip: "1436",
    ST: "MA",
    cityWithStateAbbr: "Baldwinville, MA",
  },
  {
    zip: "1438",
    ST: "MA",
    cityWithStateAbbr: "East Templeton, MA",
  },
  {
    zip: "1440",
    ST: "MA",
    cityWithStateAbbr: "Gardner, MA",
  },
  {
    zip: "1441",
    ST: "MA",
    cityWithStateAbbr: "Westminster, MA",
  },
  {
    zip: "1450",
    ST: "MA",
    cityWithStateAbbr: "Groton, MA",
  },
  {
    zip: "1451",
    ST: "MA",
    cityWithStateAbbr: "Harvard, MA",
  },
  {
    zip: "1452",
    ST: "MA",
    cityWithStateAbbr: "Hubbardston, MA",
  },
  {
    zip: "1453",
    ST: "MA",
    cityWithStateAbbr: "Leominster, MA",
  },
  {
    zip: "1460",
    ST: "MA",
    cityWithStateAbbr: "Littleton, MA",
  },
  {
    zip: "1462",
    ST: "MA",
    cityWithStateAbbr: "Lunenburg, MA",
  },
  {
    zip: "1463",
    ST: "MA",
    cityWithStateAbbr: "Pepperell, MA",
  },
  {
    zip: "1464",
    ST: "MA",
    cityWithStateAbbr: "Shirley, MA",
  },
  {
    zip: "1467",
    ST: "MA",
    cityWithStateAbbr: "Still River, MA",
  },
  {
    zip: "1468",
    ST: "MA",
    cityWithStateAbbr: "Templeton, MA",
  },
  {
    zip: "1469",
    ST: "MA",
    cityWithStateAbbr: "Townsend, MA",
  },
  {
    zip: "1471",
    ST: "MA",
    cityWithStateAbbr: "Groton, MA",
  },
  {
    zip: "1472",
    ST: "MA",
    cityWithStateAbbr: "West Groton, MA",
  },
  {
    zip: "1473",
    ST: "MA",
    cityWithStateAbbr: "Westminster, MA",
  },
  {
    zip: "1474",
    ST: "MA",
    cityWithStateAbbr: "West Townsend, MA",
  },
  {
    zip: "1475",
    ST: "MA",
    cityWithStateAbbr: "Winchendon, MA",
  },
  {
    zip: "1477",
    ST: "MA",
    cityWithStateAbbr: "Winchendon Springs, MA",
  },
  {
    zip: "1501",
    ST: "MA",
    cityWithStateAbbr: "Auburn, MA",
  },
  {
    zip: "1503",
    ST: "MA",
    cityWithStateAbbr: "Berlin, MA",
  },
  {
    zip: "1504",
    ST: "MA",
    cityWithStateAbbr: "Blackstone, MA",
  },
  {
    zip: "1505",
    ST: "MA",
    cityWithStateAbbr: "Boylston, MA",
  },
  {
    zip: "1506",
    ST: "MA",
    cityWithStateAbbr: "Brookfield, MA",
  },
  {
    zip: "1507",
    ST: "MA",
    cityWithStateAbbr: "Charlton, MA",
  },
  {
    zip: "1508",
    ST: "MA",
    cityWithStateAbbr: "Charlton City, MA",
  },
  {
    zip: "1509",
    ST: "MA",
    cityWithStateAbbr: "Charlton Depot, MA",
  },
  {
    zip: "1510",
    ST: "MA",
    cityWithStateAbbr: "Clinton, MA",
  },
  {
    zip: "1515",
    ST: "MA",
    cityWithStateAbbr: "East Brookfield, MA",
  },
  {
    zip: "1516",
    ST: "MA",
    cityWithStateAbbr: "Douglas, MA",
  },
  {
    zip: "1517",
    ST: "MA",
    cityWithStateAbbr: "East Princeton, MA",
  },
  {
    zip: "1518",
    ST: "MA",
    cityWithStateAbbr: "Fiskdale, MA",
  },
  {
    zip: "1519",
    ST: "MA",
    cityWithStateAbbr: "Grafton, MA",
  },
  {
    zip: "1520",
    ST: "MA",
    cityWithStateAbbr: "Holden, MA",
  },
  {
    zip: "1521",
    ST: "MA",
    cityWithStateAbbr: "Holland, MA",
  },
  {
    zip: "1522",
    ST: "MA",
    cityWithStateAbbr: "Jefferson, MA",
  },
  {
    zip: "1523",
    ST: "MA",
    cityWithStateAbbr: "Lancaster, MA",
  },
  {
    zip: "1524",
    ST: "MA",
    cityWithStateAbbr: "Leicester, MA",
  },
  {
    zip: "1525",
    ST: "MA",
    cityWithStateAbbr: "Linwood, MA",
  },
  {
    zip: "1526",
    ST: "MA",
    cityWithStateAbbr: "Manchaug, MA",
  },
  {
    zip: "1527",
    ST: "MA",
    cityWithStateAbbr: "Millbury, MA",
  },
  {
    zip: "1529",
    ST: "MA",
    cityWithStateAbbr: "Millville, MA",
  },
  {
    zip: "1531",
    ST: "MA",
    cityWithStateAbbr: "New Braintree, MA",
  },
  {
    zip: "1532",
    ST: "MA",
    cityWithStateAbbr: "Northborough, MA",
  },
  {
    zip: "1534",
    ST: "MA",
    cityWithStateAbbr: "Northbridge, MA",
  },
  {
    zip: "1535",
    ST: "MA",
    cityWithStateAbbr: "North Brookfield, MA",
  },
  {
    zip: "1536",
    ST: "MA",
    cityWithStateAbbr: "North Grafton, MA",
  },
  {
    zip: "1537",
    ST: "MA",
    cityWithStateAbbr: "North Oxford, MA",
  },
  {
    zip: "1538",
    ST: "MA",
    cityWithStateAbbr: "North Uxbridge, MA",
  },
  {
    zip: "1540",
    ST: "MA",
    cityWithStateAbbr: "Oxford, MA",
  },
  {
    zip: "1541",
    ST: "MA",
    cityWithStateAbbr: "Princeton, MA",
  },
  {
    zip: "1542",
    ST: "MA",
    cityWithStateAbbr: "Rochdale, MA",
  },
  {
    zip: "1543",
    ST: "MA",
    cityWithStateAbbr: "Rutland, MA",
  },
  {
    zip: "1545",
    ST: "MA",
    cityWithStateAbbr: "Shrewsbury, MA",
  },
  {
    zip: "1546",
    ST: "MA",
    cityWithStateAbbr: "Shrewsbury, MA",
  },
  {
    zip: "1550",
    ST: "MA",
    cityWithStateAbbr: "Southbridge, MA",
  },
  {
    zip: "1560",
    ST: "MA",
    cityWithStateAbbr: "South Grafton, MA",
  },
  {
    zip: "1561",
    ST: "MA",
    cityWithStateAbbr: "South Lancaster, MA",
  },
  {
    zip: "1562",
    ST: "MA",
    cityWithStateAbbr: "Spencer, MA",
  },
  {
    zip: "1564",
    ST: "MA",
    cityWithStateAbbr: "Sterling, MA",
  },
  {
    zip: "1566",
    ST: "MA",
    cityWithStateAbbr: "Sturbridge, MA",
  },
  {
    zip: "1568",
    ST: "MA",
    cityWithStateAbbr: "Upton, MA",
  },
  {
    zip: "1569",
    ST: "MA",
    cityWithStateAbbr: "Uxbridge, MA",
  },
  {
    zip: "1570",
    ST: "MA",
    cityWithStateAbbr: "Webster, MA",
  },
  {
    zip: "1571",
    ST: "MA",
    cityWithStateAbbr: "Dudley, MA",
  },
  {
    zip: "1580",
    ST: "MA",
    cityWithStateAbbr: "Westborough, MA",
  },
  {
    zip: "1581",
    ST: "MA",
    cityWithStateAbbr: "Westborough, MA",
  },
  {
    zip: "1582",
    ST: "MA",
    cityWithStateAbbr: "Westborough, MA",
  },
  {
    zip: "1583",
    ST: "MA",
    cityWithStateAbbr: "West Boylston, MA",
  },
  {
    zip: "1585",
    ST: "MA",
    cityWithStateAbbr: "West Brookfield, MA",
  },
  {
    zip: "1586",
    ST: "MA",
    cityWithStateAbbr: "West Millbury, MA",
  },
  {
    zip: "1588",
    ST: "MA",
    cityWithStateAbbr: "Whitinsville, MA",
  },
  {
    zip: "1590",
    ST: "MA",
    cityWithStateAbbr: "Sutton, MA",
  },
  {
    zip: "1601",
    ST: "MA",
    cityWithStateAbbr: "Worcester, MA",
  },
  {
    zip: "1602",
    ST: "MA",
    cityWithStateAbbr: "Worcester, MA",
  },
  {
    zip: "1603",
    ST: "MA",
    cityWithStateAbbr: "Worcester, MA",
  },
  {
    zip: "1604",
    ST: "MA",
    cityWithStateAbbr: "Worcester, MA",
  },
  {
    zip: "1605",
    ST: "MA",
    cityWithStateAbbr: "Worcester, MA",
  },
  {
    zip: "1606",
    ST: "MA",
    cityWithStateAbbr: "Worcester, MA",
  },
  {
    zip: "1607",
    ST: "MA",
    cityWithStateAbbr: "Worcester, MA",
  },
  {
    zip: "1608",
    ST: "MA",
    cityWithStateAbbr: "Worcester, MA",
  },
  {
    zip: "1609",
    ST: "MA",
    cityWithStateAbbr: "Worcester, MA",
  },
  {
    zip: "1610",
    ST: "MA",
    cityWithStateAbbr: "Worcester, MA",
  },
  {
    zip: "1611",
    ST: "MA",
    cityWithStateAbbr: "Cherry Valley, MA",
  },
  {
    zip: "1612",
    ST: "MA",
    cityWithStateAbbr: "Paxton, MA",
  },
  {
    zip: "1613",
    ST: "MA",
    cityWithStateAbbr: "Worcester, MA",
  },
  {
    zip: "1614",
    ST: "MA",
    cityWithStateAbbr: "Worcester, MA",
  },
  {
    zip: "1615",
    ST: "MA",
    cityWithStateAbbr: "Worcester, MA",
  },
  {
    zip: "1653",
    ST: "MA",
    cityWithStateAbbr: "Worcester, MA",
  },
  {
    zip: "1654",
    ST: "MA",
    cityWithStateAbbr: "Worcester, MA",
  },
  {
    zip: "1655",
    ST: "MA",
    cityWithStateAbbr: "Worcester, MA",
  },
  {
    zip: "1701",
    ST: "MA",
    cityWithStateAbbr: "Framingham, MA",
  },
  {
    zip: "1702",
    ST: "MA",
    cityWithStateAbbr: "Framingham, MA",
  },
  {
    zip: "1703",
    ST: "MA",
    cityWithStateAbbr: "Framingham, MA",
  },
  {
    zip: "1704",
    ST: "MA",
    cityWithStateAbbr: "Framingham, MA",
  },
  {
    zip: "1705",
    ST: "MA",
    cityWithStateAbbr: "Framingham, MA",
  },
  {
    zip: "1718",
    ST: "MA",
    cityWithStateAbbr: "Village Of Nagog Woods, MA",
  },
  {
    zip: "1719",
    ST: "MA",
    cityWithStateAbbr: "Boxborough, MA",
  },
  {
    zip: "1720",
    ST: "MA",
    cityWithStateAbbr: "Acton, MA",
  },
  {
    zip: "1721",
    ST: "MA",
    cityWithStateAbbr: "Ashland, MA",
  },
  {
    zip: "1730",
    ST: "MA",
    cityWithStateAbbr: "Bedford, MA",
  },
  {
    zip: "1731",
    ST: "MA",
    cityWithStateAbbr: "Hanscom Afb, MA",
  },
  {
    zip: "1740",
    ST: "MA",
    cityWithStateAbbr: "Bolton, MA",
  },
  {
    zip: "1741",
    ST: "MA",
    cityWithStateAbbr: "Carlisle, MA",
  },
  {
    zip: "1742",
    ST: "MA",
    cityWithStateAbbr: "Concord, MA",
  },
  {
    zip: "1745",
    ST: "MA",
    cityWithStateAbbr: "Fayville, MA",
  },
  {
    zip: "1746",
    ST: "MA",
    cityWithStateAbbr: "Holliston, MA",
  },
  {
    zip: "1747",
    ST: "MA",
    cityWithStateAbbr: "Hopedale, MA",
  },
  {
    zip: "1748",
    ST: "MA",
    cityWithStateAbbr: "Hopkinton, MA",
  },
  {
    zip: "1749",
    ST: "MA",
    cityWithStateAbbr: "Hudson, MA",
  },
  {
    zip: "1752",
    ST: "MA",
    cityWithStateAbbr: "Marlborough, MA",
  },
  {
    zip: "1754",
    ST: "MA",
    cityWithStateAbbr: "Maynard, MA",
  },
  {
    zip: "1756",
    ST: "MA",
    cityWithStateAbbr: "Mendon, MA",
  },
  {
    zip: "1757",
    ST: "MA",
    cityWithStateAbbr: "Milford, MA",
  },
  {
    zip: "1760",
    ST: "MA",
    cityWithStateAbbr: "Natick, MA",
  },
  {
    zip: "1770",
    ST: "MA",
    cityWithStateAbbr: "Sherborn, MA",
  },
  {
    zip: "1772",
    ST: "MA",
    cityWithStateAbbr: "Southborough, MA",
  },
  {
    zip: "1773",
    ST: "MA",
    cityWithStateAbbr: "Lincoln, MA",
  },
  {
    zip: "1775",
    ST: "MA",
    cityWithStateAbbr: "Stow, MA",
  },
  {
    zip: "1776",
    ST: "MA",
    cityWithStateAbbr: "Sudbury, MA",
  },
  {
    zip: "1778",
    ST: "MA",
    cityWithStateAbbr: "Wayland, MA",
  },
  {
    zip: "1784",
    ST: "MA",
    cityWithStateAbbr: "Woodville, MA",
  },
  {
    zip: "1801",
    ST: "MA",
    cityWithStateAbbr: "Woburn, MA",
  },
  {
    zip: "1803",
    ST: "MA",
    cityWithStateAbbr: "Burlington, MA",
  },
  {
    zip: "1805",
    ST: "MA",
    cityWithStateAbbr: "Burlington, MA",
  },
  {
    zip: "1807",
    ST: "MA",
    cityWithStateAbbr: "Woburn, MA",
  },
  {
    zip: "1810",
    ST: "MA",
    cityWithStateAbbr: "Andover, MA",
  },
  {
    zip: "1812",
    ST: "MA",
    cityWithStateAbbr: "Andover, MA",
  },
  {
    zip: "1813",
    ST: "MA",
    cityWithStateAbbr: "Woburn, MA",
  },
  {
    zip: "1815",
    ST: "MA",
    cityWithStateAbbr: "Woburn, MA",
  },
  {
    zip: "1821",
    ST: "MA",
    cityWithStateAbbr: "Billerica, MA",
  },
  {
    zip: "1822",
    ST: "MA",
    cityWithStateAbbr: "Billerica, MA",
  },
  {
    zip: "1824",
    ST: "MA",
    cityWithStateAbbr: "Chelmsford, MA",
  },
  {
    zip: "1826",
    ST: "MA",
    cityWithStateAbbr: "Dracut, MA",
  },
  {
    zip: "1827",
    ST: "MA",
    cityWithStateAbbr: "Dunstable, MA",
  },
  {
    zip: "1830",
    ST: "MA",
    cityWithStateAbbr: "Haverhill, MA",
  },
  {
    zip: "1831",
    ST: "MA",
    cityWithStateAbbr: "Haverhill, MA",
  },
  {
    zip: "1832",
    ST: "MA",
    cityWithStateAbbr: "Haverhill, MA",
  },
  {
    zip: "1833",
    ST: "MA",
    cityWithStateAbbr: "Georgetown, MA",
  },
  {
    zip: "1834",
    ST: "MA",
    cityWithStateAbbr: "Groveland, MA",
  },
  {
    zip: "1835",
    ST: "MA",
    cityWithStateAbbr: "Haverhill, MA",
  },
  {
    zip: "1840",
    ST: "MA",
    cityWithStateAbbr: "Lawrence, MA",
  },
  {
    zip: "1841",
    ST: "MA",
    cityWithStateAbbr: "Lawrence, MA",
  },
  {
    zip: "1842",
    ST: "MA",
    cityWithStateAbbr: "Lawrence, MA",
  },
  {
    zip: "1843",
    ST: "MA",
    cityWithStateAbbr: "Lawrence, MA",
  },
  {
    zip: "1844",
    ST: "MA",
    cityWithStateAbbr: "Methuen, MA",
  },
  {
    zip: "1845",
    ST: "MA",
    cityWithStateAbbr: "North Andover, MA",
  },
  {
    zip: "1850",
    ST: "MA",
    cityWithStateAbbr: "Lowell, MA",
  },
  {
    zip: "1851",
    ST: "MA",
    cityWithStateAbbr: "Lowell, MA",
  },
  {
    zip: "1852",
    ST: "MA",
    cityWithStateAbbr: "Lowell, MA",
  },
  {
    zip: "1853",
    ST: "MA",
    cityWithStateAbbr: "Lowell, MA",
  },
  {
    zip: "1854",
    ST: "MA",
    cityWithStateAbbr: "Lowell, MA",
  },
  {
    zip: "1860",
    ST: "MA",
    cityWithStateAbbr: "Merrimac, MA",
  },
  {
    zip: "1862",
    ST: "MA",
    cityWithStateAbbr: "North Billerica, MA",
  },
  {
    zip: "1863",
    ST: "MA",
    cityWithStateAbbr: "North Chelmsford, MA",
  },
  {
    zip: "1864",
    ST: "MA",
    cityWithStateAbbr: "North Reading, MA",
  },
  {
    zip: "1865",
    ST: "MA",
    cityWithStateAbbr: "Nutting Lake, MA",
  },
  {
    zip: "1866",
    ST: "MA",
    cityWithStateAbbr: "Pinehurst, MA",
  },
  {
    zip: "1867",
    ST: "MA",
    cityWithStateAbbr: "Reading, MA",
  },
  {
    zip: "1876",
    ST: "MA",
    cityWithStateAbbr: "Tewksbury, MA",
  },
  {
    zip: "1879",
    ST: "MA",
    cityWithStateAbbr: "Tyngsboro, MA",
  },
  {
    zip: "1880",
    ST: "MA",
    cityWithStateAbbr: "Wakefield, MA",
  },
  {
    zip: "1885",
    ST: "MA",
    cityWithStateAbbr: "West Boxford, MA",
  },
  {
    zip: "1886",
    ST: "MA",
    cityWithStateAbbr: "Westford, MA",
  },
  {
    zip: "1887",
    ST: "MA",
    cityWithStateAbbr: "Wilmington, MA",
  },
  {
    zip: "1888",
    ST: "MA",
    cityWithStateAbbr: "Woburn, MA",
  },
  {
    zip: "1889",
    ST: "MA",
    cityWithStateAbbr: "North Reading, MA",
  },
  {
    zip: "1890",
    ST: "MA",
    cityWithStateAbbr: "Winchester, MA",
  },
  {
    zip: "1899",
    ST: "MA",
    cityWithStateAbbr: "Andover, MA",
  },
  {
    zip: "1901",
    ST: "MA",
    cityWithStateAbbr: "Lynn, MA",
  },
  {
    zip: "1902",
    ST: "MA",
    cityWithStateAbbr: "Lynn, MA",
  },
  {
    zip: "1903",
    ST: "MA",
    cityWithStateAbbr: "Lynn, MA",
  },
  {
    zip: "1904",
    ST: "MA",
    cityWithStateAbbr: "Lynn, MA",
  },
  {
    zip: "1905",
    ST: "MA",
    cityWithStateAbbr: "Lynn, MA",
  },
  {
    zip: "1906",
    ST: "MA",
    cityWithStateAbbr: "Saugus, MA",
  },
  {
    zip: "1907",
    ST: "MA",
    cityWithStateAbbr: "Swampscott, MA",
  },
  {
    zip: "1908",
    ST: "MA",
    cityWithStateAbbr: "Nahant, MA",
  },
  {
    zip: "1910",
    ST: "MA",
    cityWithStateAbbr: "Lynn, MA",
  },
  {
    zip: "1913",
    ST: "MA",
    cityWithStateAbbr: "Amesbury, MA",
  },
  {
    zip: "1915",
    ST: "MA",
    cityWithStateAbbr: "Beverly, MA",
  },
  {
    zip: "1921",
    ST: "MA",
    cityWithStateAbbr: "Boxford, MA",
  },
  {
    zip: "1922",
    ST: "MA",
    cityWithStateAbbr: "Byfield, MA",
  },
  {
    zip: "1923",
    ST: "MA",
    cityWithStateAbbr: "Danvers, MA",
  },
  {
    zip: "1929",
    ST: "MA",
    cityWithStateAbbr: "Essex, MA",
  },
  {
    zip: "1930",
    ST: "MA",
    cityWithStateAbbr: "Gloucester, MA",
  },
  {
    zip: "1931",
    ST: "MA",
    cityWithStateAbbr: "Gloucester, MA",
  },
  {
    zip: "1936",
    ST: "MA",
    cityWithStateAbbr: "Hamilton, MA",
  },
  {
    zip: "1937",
    ST: "MA",
    cityWithStateAbbr: "Hathorne, MA",
  },
  {
    zip: "1938",
    ST: "MA",
    cityWithStateAbbr: "Ipswich, MA",
  },
  {
    zip: "1940",
    ST: "MA",
    cityWithStateAbbr: "Lynnfield, MA",
  },
  {
    zip: "1944",
    ST: "MA",
    cityWithStateAbbr: "Manchester, MA",
  },
  {
    zip: "1945",
    ST: "MA",
    cityWithStateAbbr: "Marblehead, MA",
  },
  {
    zip: "1949",
    ST: "MA",
    cityWithStateAbbr: "Middleton, MA",
  },
  {
    zip: "1950",
    ST: "MA",
    cityWithStateAbbr: "Newburyport, MA",
  },
  {
    zip: "1951",
    ST: "MA",
    cityWithStateAbbr: "Newbury, MA",
  },
  {
    zip: "1952",
    ST: "MA",
    cityWithStateAbbr: "Salisbury, MA",
  },
  {
    zip: "1960",
    ST: "MA",
    cityWithStateAbbr: "Peabody, MA",
  },
  {
    zip: "1961",
    ST: "MA",
    cityWithStateAbbr: "Peabody, MA",
  },
  {
    zip: "1965",
    ST: "MA",
    cityWithStateAbbr: "Prides Crossing, MA",
  },
  {
    zip: "1966",
    ST: "MA",
    cityWithStateAbbr: "Rockport, MA",
  },
  {
    zip: "1969",
    ST: "MA",
    cityWithStateAbbr: "Rowley, MA",
  },
  {
    zip: "1970",
    ST: "MA",
    cityWithStateAbbr: "Salem, MA",
  },
  {
    zip: "1971",
    ST: "MA",
    cityWithStateAbbr: "Salem, MA",
  },
  {
    zip: "1982",
    ST: "MA",
    cityWithStateAbbr: "South Hamilton, MA",
  },
  {
    zip: "1983",
    ST: "MA",
    cityWithStateAbbr: "Topsfield, MA",
  },
  {
    zip: "1984",
    ST: "MA",
    cityWithStateAbbr: "Wenham, MA",
  },
  {
    zip: "1985",
    ST: "MA",
    cityWithStateAbbr: "West Newbury, MA",
  },
  {
    zip: "2018",
    ST: "MA",
    cityWithStateAbbr: "Accord, MA",
  },
  {
    zip: "2019",
    ST: "MA",
    cityWithStateAbbr: "Bellingham, MA",
  },
  {
    zip: "2020",
    ST: "MA",
    cityWithStateAbbr: "Brant Rock, MA",
  },
  {
    zip: "2021",
    ST: "MA",
    cityWithStateAbbr: "Canton, MA",
  },
  {
    zip: "2025",
    ST: "MA",
    cityWithStateAbbr: "Cohasset, MA",
  },
  {
    zip: "2026",
    ST: "MA",
    cityWithStateAbbr: "Dedham, MA",
  },
  {
    zip: "2027",
    ST: "MA",
    cityWithStateAbbr: "Dedham, MA",
  },
  {
    zip: "2030",
    ST: "MA",
    cityWithStateAbbr: "Dover, MA",
  },
  {
    zip: "2031",
    ST: "MA",
    cityWithStateAbbr: "East Mansfield, MA",
  },
  {
    zip: "2032",
    ST: "MA",
    cityWithStateAbbr: "East Walpole, MA",
  },
  {
    zip: "2035",
    ST: "MA",
    cityWithStateAbbr: "Foxboro, MA",
  },
  {
    zip: "2038",
    ST: "MA",
    cityWithStateAbbr: "Franklin, MA",
  },
  {
    zip: "2040",
    ST: "MA",
    cityWithStateAbbr: "Greenbush, MA",
  },
  {
    zip: "2041",
    ST: "MA",
    cityWithStateAbbr: "Green Harbor, MA",
  },
  {
    zip: "2043",
    ST: "MA",
    cityWithStateAbbr: "Hingham, MA",
  },
  {
    zip: "2044",
    ST: "MA",
    cityWithStateAbbr: "Hingham, MA",
  },
  {
    zip: "2045",
    ST: "MA",
    cityWithStateAbbr: "Hull, MA",
  },
  {
    zip: "2047",
    ST: "MA",
    cityWithStateAbbr: "Humarock, MA",
  },
  {
    zip: "2048",
    ST: "MA",
    cityWithStateAbbr: "Mansfield, MA",
  },
  {
    zip: "2050",
    ST: "MA",
    cityWithStateAbbr: "Marshfield, MA",
  },
  {
    zip: "2051",
    ST: "MA",
    cityWithStateAbbr: "Marshfield Hills, MA",
  },
  {
    zip: "2052",
    ST: "MA",
    cityWithStateAbbr: "Medfield, MA",
  },
  {
    zip: "2053",
    ST: "MA",
    cityWithStateAbbr: "Medway, MA",
  },
  {
    zip: "2054",
    ST: "MA",
    cityWithStateAbbr: "Millis, MA",
  },
  {
    zip: "2055",
    ST: "MA",
    cityWithStateAbbr: "Minot, MA",
  },
  {
    zip: "2056",
    ST: "MA",
    cityWithStateAbbr: "Norfolk, MA",
  },
  {
    zip: "2059",
    ST: "MA",
    cityWithStateAbbr: "North Marshfield, MA",
  },
  {
    zip: "2060",
    ST: "MA",
    cityWithStateAbbr: "North Scituate, MA",
  },
  {
    zip: "2061",
    ST: "MA",
    cityWithStateAbbr: "Norwell, MA",
  },
  {
    zip: "2062",
    ST: "MA",
    cityWithStateAbbr: "Norwood, MA",
  },
  {
    zip: "2065",
    ST: "MA",
    cityWithStateAbbr: "Ocean Bluff, MA",
  },
  {
    zip: "2066",
    ST: "MA",
    cityWithStateAbbr: "Scituate, MA",
  },
  {
    zip: "2067",
    ST: "MA",
    cityWithStateAbbr: "Sharon, MA",
  },
  {
    zip: "2070",
    ST: "MA",
    cityWithStateAbbr: "Sheldonville, MA",
  },
  {
    zip: "2071",
    ST: "MA",
    cityWithStateAbbr: "South Walpole, MA",
  },
  {
    zip: "2072",
    ST: "MA",
    cityWithStateAbbr: "Stoughton, MA",
  },
  {
    zip: "2081",
    ST: "MA",
    cityWithStateAbbr: "Walpole, MA",
  },
  {
    zip: "2090",
    ST: "MA",
    cityWithStateAbbr: "Westwood, MA",
  },
  {
    zip: "2093",
    ST: "MA",
    cityWithStateAbbr: "Wrentham, MA",
  },
  {
    zip: "2108",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2109",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2110",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2111",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2112",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2113",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2114",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2115",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2116",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2117",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2118",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2119",
    ST: "MA",
    cityWithStateAbbr: "Roxbury, MA",
  },
  {
    zip: "2120",
    ST: "MA",
    cityWithStateAbbr: "Roxbury Crossing, MA",
  },
  {
    zip: "2121",
    ST: "MA",
    cityWithStateAbbr: "Dorchester, MA",
  },
  {
    zip: "2122",
    ST: "MA",
    cityWithStateAbbr: "Dorchester, MA",
  },
  {
    zip: "2123",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2124",
    ST: "MA",
    cityWithStateAbbr: "Dorchester Center, MA",
  },
  {
    zip: "2125",
    ST: "MA",
    cityWithStateAbbr: "Dorchester, MA",
  },
  {
    zip: "2126",
    ST: "MA",
    cityWithStateAbbr: "Mattapan, MA",
  },
  {
    zip: "2127",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2128",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2129",
    ST: "MA",
    cityWithStateAbbr: "Charlestown, MA",
  },
  {
    zip: "2130",
    ST: "MA",
    cityWithStateAbbr: "Jamaica Plain, MA",
  },
  {
    zip: "2131",
    ST: "MA",
    cityWithStateAbbr: "Roslindale, MA",
  },
  {
    zip: "2132",
    ST: "MA",
    cityWithStateAbbr: "West Roxbury, MA",
  },
  {
    zip: "2133",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2134",
    ST: "MA",
    cityWithStateAbbr: "Allston, MA",
  },
  {
    zip: "2135",
    ST: "MA",
    cityWithStateAbbr: "Brighton, MA",
  },
  {
    zip: "2136",
    ST: "MA",
    cityWithStateAbbr: "Hyde Park, MA",
  },
  {
    zip: "2137",
    ST: "MA",
    cityWithStateAbbr: "Readville, MA",
  },
  {
    zip: "2138",
    ST: "MA",
    cityWithStateAbbr: "Cambridge, MA",
  },
  {
    zip: "2139",
    ST: "MA",
    cityWithStateAbbr: "Cambridge, MA",
  },
  {
    zip: "2140",
    ST: "MA",
    cityWithStateAbbr: "Cambridge, MA",
  },
  {
    zip: "2141",
    ST: "MA",
    cityWithStateAbbr: "Cambridge, MA",
  },
  {
    zip: "2142",
    ST: "MA",
    cityWithStateAbbr: "Cambridge, MA",
  },
  {
    zip: "2143",
    ST: "MA",
    cityWithStateAbbr: "Somerville, MA",
  },
  {
    zip: "2144",
    ST: "MA",
    cityWithStateAbbr: "Somerville, MA",
  },
  {
    zip: "2145",
    ST: "MA",
    cityWithStateAbbr: "Somerville, MA",
  },
  {
    zip: "2148",
    ST: "MA",
    cityWithStateAbbr: "Malden, MA",
  },
  {
    zip: "2149",
    ST: "MA",
    cityWithStateAbbr: "Everett, MA",
  },
  {
    zip: "2150",
    ST: "MA",
    cityWithStateAbbr: "Chelsea, MA",
  },
  {
    zip: "2151",
    ST: "MA",
    cityWithStateAbbr: "Revere, MA",
  },
  {
    zip: "2152",
    ST: "MA",
    cityWithStateAbbr: "Winthrop, MA",
  },
  {
    zip: "2153",
    ST: "MA",
    cityWithStateAbbr: "Medford, MA",
  },
  {
    zip: "2155",
    ST: "MA",
    cityWithStateAbbr: "Medford, MA",
  },
  {
    zip: "2156",
    ST: "MA",
    cityWithStateAbbr: "West Medford, MA",
  },
  {
    zip: "2163",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2169",
    ST: "MA",
    cityWithStateAbbr: "Quincy, MA",
  },
  {
    zip: "2170",
    ST: "MA",
    cityWithStateAbbr: "Quincy, MA",
  },
  {
    zip: "2171",
    ST: "MA",
    cityWithStateAbbr: "Quincy, MA",
  },
  {
    zip: "2176",
    ST: "MA",
    cityWithStateAbbr: "Melrose, MA",
  },
  {
    zip: "2180",
    ST: "MA",
    cityWithStateAbbr: "Stoneham, MA",
  },
  {
    zip: "2184",
    ST: "MA",
    cityWithStateAbbr: "Braintree, MA",
  },
  {
    zip: "2185",
    ST: "MA",
    cityWithStateAbbr: "Braintree, MA",
  },
  {
    zip: "2186",
    ST: "MA",
    cityWithStateAbbr: "Milton, MA",
  },
  {
    zip: "2187",
    ST: "MA",
    cityWithStateAbbr: "Milton Village, MA",
  },
  {
    zip: "2188",
    ST: "MA",
    cityWithStateAbbr: "Weymouth, MA",
  },
  {
    zip: "2189",
    ST: "MA",
    cityWithStateAbbr: "East Weymouth, MA",
  },
  {
    zip: "2190",
    ST: "MA",
    cityWithStateAbbr: "South Weymouth, MA",
  },
  {
    zip: "2191",
    ST: "MA",
    cityWithStateAbbr: "North Weymouth, MA",
  },
  {
    zip: "2196",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2199",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2201",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2203",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2204",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2205",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2206",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2210",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2211",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2212",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2215",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2217",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2222",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2228",
    ST: "MA",
    cityWithStateAbbr: "East Boston, MA",
  },
  {
    zip: "2238",
    ST: "MA",
    cityWithStateAbbr: "Cambridge, MA",
  },
  {
    zip: "2241",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2266",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2269",
    ST: "MA",
    cityWithStateAbbr: "Quincy, MA",
  },
  {
    zip: "2283",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2284",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2293",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2295",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2297",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2298",
    ST: "MA",
    cityWithStateAbbr: "Boston, MA",
  },
  {
    zip: "2301",
    ST: "MA",
    cityWithStateAbbr: "Brockton, MA",
  },
  {
    zip: "2302",
    ST: "MA",
    cityWithStateAbbr: "Brockton, MA",
  },
  {
    zip: "2303",
    ST: "MA",
    cityWithStateAbbr: "Brockton, MA",
  },
  {
    zip: "2304",
    ST: "MA",
    cityWithStateAbbr: "Brockton, MA",
  },
  {
    zip: "2305",
    ST: "MA",
    cityWithStateAbbr: "Brockton, MA",
  },
  {
    zip: "2322",
    ST: "MA",
    cityWithStateAbbr: "Avon, MA",
  },
  {
    zip: "2324",
    ST: "MA",
    cityWithStateAbbr: "Bridgewater, MA",
  },
  {
    zip: "2325",
    ST: "MA",
    cityWithStateAbbr: "Bridgewater, MA",
  },
  {
    zip: "2327",
    ST: "MA",
    cityWithStateAbbr: "Bryantville, MA",
  },
  {
    zip: "2330",
    ST: "MA",
    cityWithStateAbbr: "Carver, MA",
  },
  {
    zip: "2331",
    ST: "MA",
    cityWithStateAbbr: "Duxbury, MA",
  },
  {
    zip: "2332",
    ST: "MA",
    cityWithStateAbbr: "Duxbury, MA",
  },
  {
    zip: "2333",
    ST: "MA",
    cityWithStateAbbr: "East Bridgewater, MA",
  },
  {
    zip: "2334",
    ST: "MA",
    cityWithStateAbbr: "Easton, MA",
  },
  {
    zip: "2337",
    ST: "MA",
    cityWithStateAbbr: "Elmwood, MA",
  },
  {
    zip: "2338",
    ST: "MA",
    cityWithStateAbbr: "Halifax, MA",
  },
  {
    zip: "2339",
    ST: "MA",
    cityWithStateAbbr: "Hanover, MA",
  },
  {
    zip: "2340",
    ST: "MA",
    cityWithStateAbbr: "Hanover, MA",
  },
  {
    zip: "2341",
    ST: "MA",
    cityWithStateAbbr: "Hanson, MA",
  },
  {
    zip: "2343",
    ST: "MA",
    cityWithStateAbbr: "Holbrook, MA",
  },
  {
    zip: "2344",
    ST: "MA",
    cityWithStateAbbr: "Middleboro, MA",
  },
  {
    zip: "2345",
    ST: "MA",
    cityWithStateAbbr: "Manomet, MA",
  },
  {
    zip: "2346",
    ST: "MA",
    cityWithStateAbbr: "Middleboro, MA",
  },
  {
    zip: "2347",
    ST: "MA",
    cityWithStateAbbr: "Lakeville, MA",
  },
  {
    zip: "2348",
    ST: "MA",
    cityWithStateAbbr: "Lakeville, MA",
  },
  {
    zip: "2349",
    ST: "MA",
    cityWithStateAbbr: "Middleboro, MA",
  },
  {
    zip: "2350",
    ST: "MA",
    cityWithStateAbbr: "Monponsett, MA",
  },
  {
    zip: "2351",
    ST: "MA",
    cityWithStateAbbr: "Abington, MA",
  },
  {
    zip: "2355",
    ST: "MA",
    cityWithStateAbbr: "North Carver, MA",
  },
  {
    zip: "2356",
    ST: "MA",
    cityWithStateAbbr: "North Easton, MA",
  },
  {
    zip: "2357",
    ST: "MA",
    cityWithStateAbbr: "North Easton, MA",
  },
  {
    zip: "2358",
    ST: "MA",
    cityWithStateAbbr: "North Pembroke, MA",
  },
  {
    zip: "2359",
    ST: "MA",
    cityWithStateAbbr: "Pembroke, MA",
  },
  {
    zip: "2360",
    ST: "MA",
    cityWithStateAbbr: "Plymouth, MA",
  },
  {
    zip: "2361",
    ST: "MA",
    cityWithStateAbbr: "Plymouth, MA",
  },
  {
    zip: "2362",
    ST: "MA",
    cityWithStateAbbr: "Plymouth, MA",
  },
  {
    zip: "2364",
    ST: "MA",
    cityWithStateAbbr: "Kingston, MA",
  },
  {
    zip: "2366",
    ST: "MA",
    cityWithStateAbbr: "South Carver, MA",
  },
  {
    zip: "2367",
    ST: "MA",
    cityWithStateAbbr: "Plympton, MA",
  },
  {
    zip: "2368",
    ST: "MA",
    cityWithStateAbbr: "Randolph, MA",
  },
  {
    zip: "2370",
    ST: "MA",
    cityWithStateAbbr: "Rockland, MA",
  },
  {
    zip: "2375",
    ST: "MA",
    cityWithStateAbbr: "South Easton, MA",
  },
  {
    zip: "2379",
    ST: "MA",
    cityWithStateAbbr: "West Bridgewater, MA",
  },
  {
    zip: "2381",
    ST: "MA",
    cityWithStateAbbr: "White Horse Beach, MA",
  },
  {
    zip: "2382",
    ST: "MA",
    cityWithStateAbbr: "Whitman, MA",
  },
  {
    zip: "2420",
    ST: "MA",
    cityWithStateAbbr: "Lexington, MA",
  },
  {
    zip: "2421",
    ST: "MA",
    cityWithStateAbbr: "Lexington, MA",
  },
  {
    zip: "2445",
    ST: "MA",
    cityWithStateAbbr: "Brookline, MA",
  },
  {
    zip: "2446",
    ST: "MA",
    cityWithStateAbbr: "Brookline, MA",
  },
  {
    zip: "2447",
    ST: "MA",
    cityWithStateAbbr: "Brookline Village, MA",
  },
  {
    zip: "2451",
    ST: "MA",
    cityWithStateAbbr: "Waltham, MA",
  },
  {
    zip: "2452",
    ST: "MA",
    cityWithStateAbbr: "Waltham, MA",
  },
  {
    zip: "2453",
    ST: "MA",
    cityWithStateAbbr: "Waltham, MA",
  },
  {
    zip: "2454",
    ST: "MA",
    cityWithStateAbbr: "Waltham, MA",
  },
  {
    zip: "2455",
    ST: "MA",
    cityWithStateAbbr: "North Waltham, MA",
  },
  {
    zip: "2456",
    ST: "MA",
    cityWithStateAbbr: "New Town, MA",
  },
  {
    zip: "2457",
    ST: "MA",
    cityWithStateAbbr: "Babson Park, MA",
  },
  {
    zip: "2458",
    ST: "MA",
    cityWithStateAbbr: "Newton, MA",
  },
  {
    zip: "2459",
    ST: "MA",
    cityWithStateAbbr: "Newton Center, MA",
  },
  {
    zip: "2460",
    ST: "MA",
    cityWithStateAbbr: "Newtonville, MA",
  },
  {
    zip: "2461",
    ST: "MA",
    cityWithStateAbbr: "Newton Highlands, MA",
  },
  {
    zip: "2462",
    ST: "MA",
    cityWithStateAbbr: "Newton Lower Falls, MA",
  },
  {
    zip: "2464",
    ST: "MA",
    cityWithStateAbbr: "Newton Upper Falls, MA",
  },
  {
    zip: "2465",
    ST: "MA",
    cityWithStateAbbr: "West Newton, MA",
  },
  {
    zip: "2466",
    ST: "MA",
    cityWithStateAbbr: "Auburndale, MA",
  },
  {
    zip: "2467",
    ST: "MA",
    cityWithStateAbbr: "Chestnut Hill, MA",
  },
  {
    zip: "2468",
    ST: "MA",
    cityWithStateAbbr: "Waban, MA",
  },
  {
    zip: "2471",
    ST: "MA",
    cityWithStateAbbr: "Watertown, MA",
  },
  {
    zip: "2472",
    ST: "MA",
    cityWithStateAbbr: "Watertown, MA",
  },
  {
    zip: "2474",
    ST: "MA",
    cityWithStateAbbr: "Arlington, MA",
  },
  {
    zip: "2475",
    ST: "MA",
    cityWithStateAbbr: "Arlington Heights, MA",
  },
  {
    zip: "2476",
    ST: "MA",
    cityWithStateAbbr: "Arlington, MA",
  },
  {
    zip: "2477",
    ST: "MA",
    cityWithStateAbbr: "Watertown, MA",
  },
  {
    zip: "2478",
    ST: "MA",
    cityWithStateAbbr: "Belmont, MA",
  },
  {
    zip: "2479",
    ST: "MA",
    cityWithStateAbbr: "Waverley, MA",
  },
  {
    zip: "2481",
    ST: "MA",
    cityWithStateAbbr: "Wellesley Hills, MA",
  },
  {
    zip: "2482",
    ST: "MA",
    cityWithStateAbbr: "Wellesley, MA",
  },
  {
    zip: "2492",
    ST: "MA",
    cityWithStateAbbr: "Needham, MA",
  },
  {
    zip: "2493",
    ST: "MA",
    cityWithStateAbbr: "Weston, MA",
  },
  {
    zip: "2494",
    ST: "MA",
    cityWithStateAbbr: "Needham Heights, MA",
  },
  {
    zip: "2495",
    ST: "MA",
    cityWithStateAbbr: "Nonantum, MA",
  },
  {
    zip: "2532",
    ST: "MA",
    cityWithStateAbbr: "Buzzards Bay, MA",
  },
  {
    zip: "2534",
    ST: "MA",
    cityWithStateAbbr: "Cataumet, MA",
  },
  {
    zip: "2535",
    ST: "MA",
    cityWithStateAbbr: "Chilmark, MA",
  },
  {
    zip: "2536",
    ST: "MA",
    cityWithStateAbbr: "East Falmouth, MA",
  },
  {
    zip: "2537",
    ST: "MA",
    cityWithStateAbbr: "East Sandwich, MA",
  },
  {
    zip: "2538",
    ST: "MA",
    cityWithStateAbbr: "East Wareham, MA",
  },
  {
    zip: "2539",
    ST: "MA",
    cityWithStateAbbr: "Edgartown, MA",
  },
  {
    zip: "2540",
    ST: "MA",
    cityWithStateAbbr: "Falmouth, MA",
  },
  {
    zip: "2541",
    ST: "MA",
    cityWithStateAbbr: "Falmouth, MA",
  },
  {
    zip: "2542",
    ST: "MA",
    cityWithStateAbbr: "Buzzards Bay, MA",
  },
  {
    zip: "2543",
    ST: "MA",
    cityWithStateAbbr: "Woods Hole, MA",
  },
  {
    zip: "2552",
    ST: "MA",
    cityWithStateAbbr: "Menemsha, MA",
  },
  {
    zip: "2553",
    ST: "MA",
    cityWithStateAbbr: "Monument Beach, MA",
  },
  {
    zip: "2554",
    ST: "MA",
    cityWithStateAbbr: "Nantucket, MA",
  },
  {
    zip: "2556",
    ST: "MA",
    cityWithStateAbbr: "North Falmouth, MA",
  },
  {
    zip: "2557",
    ST: "MA",
    cityWithStateAbbr: "Oak Bluffs, MA",
  },
  {
    zip: "2558",
    ST: "MA",
    cityWithStateAbbr: "Onset, MA",
  },
  {
    zip: "2559",
    ST: "MA",
    cityWithStateAbbr: "Pocasset, MA",
  },
  {
    zip: "2561",
    ST: "MA",
    cityWithStateAbbr: "Sagamore, MA",
  },
  {
    zip: "2562",
    ST: "MA",
    cityWithStateAbbr: "Sagamore Beach, MA",
  },
  {
    zip: "2563",
    ST: "MA",
    cityWithStateAbbr: "Sandwich, MA",
  },
  {
    zip: "2564",
    ST: "MA",
    cityWithStateAbbr: "Siasconset, MA",
  },
  {
    zip: "2565",
    ST: "MA",
    cityWithStateAbbr: "Silver Beach, MA",
  },
  {
    zip: "2568",
    ST: "MA",
    cityWithStateAbbr: "Vineyard Haven, MA",
  },
  {
    zip: "2571",
    ST: "MA",
    cityWithStateAbbr: "Wareham, MA",
  },
  {
    zip: "2573",
    ST: "MA",
    cityWithStateAbbr: "West Chop, MA",
  },
  {
    zip: "2574",
    ST: "MA",
    cityWithStateAbbr: "West Falmouth, MA",
  },
  {
    zip: "2575",
    ST: "MA",
    cityWithStateAbbr: "West Tisbury, MA",
  },
  {
    zip: "2576",
    ST: "MA",
    cityWithStateAbbr: "West Wareham, MA",
  },
  {
    zip: "2584",
    ST: "MA",
    cityWithStateAbbr: "Nantucket, MA",
  },
  {
    zip: "2601",
    ST: "MA",
    cityWithStateAbbr: "Hyannis, MA",
  },
  {
    zip: "2630",
    ST: "MA",
    cityWithStateAbbr: "Barnstable, MA",
  },
  {
    zip: "2631",
    ST: "MA",
    cityWithStateAbbr: "Brewster, MA",
  },
  {
    zip: "2632",
    ST: "MA",
    cityWithStateAbbr: "Centerville, MA",
  },
  {
    zip: "2633",
    ST: "MA",
    cityWithStateAbbr: "Chatham, MA",
  },
  {
    zip: "2634",
    ST: "MA",
    cityWithStateAbbr: "Centerville, MA",
  },
  {
    zip: "2635",
    ST: "MA",
    cityWithStateAbbr: "Cotuit, MA",
  },
  {
    zip: "2637",
    ST: "MA",
    cityWithStateAbbr: "Cummaquid, MA",
  },
  {
    zip: "2638",
    ST: "MA",
    cityWithStateAbbr: "Dennis, MA",
  },
  {
    zip: "2639",
    ST: "MA",
    cityWithStateAbbr: "Dennis Port, MA",
  },
  {
    zip: "2641",
    ST: "MA",
    cityWithStateAbbr: "East Dennis, MA",
  },
  {
    zip: "2642",
    ST: "MA",
    cityWithStateAbbr: "Eastham, MA",
  },
  {
    zip: "2643",
    ST: "MA",
    cityWithStateAbbr: "East Orleans, MA",
  },
  {
    zip: "2644",
    ST: "MA",
    cityWithStateAbbr: "Forestdale, MA",
  },
  {
    zip: "2645",
    ST: "MA",
    cityWithStateAbbr: "Harwich, MA",
  },
  {
    zip: "2646",
    ST: "MA",
    cityWithStateAbbr: "Harwich Port, MA",
  },
  {
    zip: "2647",
    ST: "MA",
    cityWithStateAbbr: "Hyannis Port, MA",
  },
  {
    zip: "2648",
    ST: "MA",
    cityWithStateAbbr: "Marstons Mills, MA",
  },
  {
    zip: "2649",
    ST: "MA",
    cityWithStateAbbr: "Mashpee, MA",
  },
  {
    zip: "2650",
    ST: "MA",
    cityWithStateAbbr: "North Chatham, MA",
  },
  {
    zip: "2651",
    ST: "MA",
    cityWithStateAbbr: "North Eastham, MA",
  },
  {
    zip: "2652",
    ST: "MA",
    cityWithStateAbbr: "North Truro, MA",
  },
  {
    zip: "2653",
    ST: "MA",
    cityWithStateAbbr: "Orleans, MA",
  },
  {
    zip: "2655",
    ST: "MA",
    cityWithStateAbbr: "Osterville, MA",
  },
  {
    zip: "2657",
    ST: "MA",
    cityWithStateAbbr: "Provincetown, MA",
  },
  {
    zip: "2659",
    ST: "MA",
    cityWithStateAbbr: "South Chatham, MA",
  },
  {
    zip: "2660",
    ST: "MA",
    cityWithStateAbbr: "South Dennis, MA",
  },
  {
    zip: "2661",
    ST: "MA",
    cityWithStateAbbr: "South Harwich, MA",
  },
  {
    zip: "2662",
    ST: "MA",
    cityWithStateAbbr: "South Orleans, MA",
  },
  {
    zip: "2663",
    ST: "MA",
    cityWithStateAbbr: "South Wellfleet, MA",
  },
  {
    zip: "2664",
    ST: "MA",
    cityWithStateAbbr: "South Yarmouth, MA",
  },
  {
    zip: "2666",
    ST: "MA",
    cityWithStateAbbr: "Truro, MA",
  },
  {
    zip: "2667",
    ST: "MA",
    cityWithStateAbbr: "Wellfleet, MA",
  },
  {
    zip: "2668",
    ST: "MA",
    cityWithStateAbbr: "West Barnstable, MA",
  },
  {
    zip: "2669",
    ST: "MA",
    cityWithStateAbbr: "West Chatham, MA",
  },
  {
    zip: "2670",
    ST: "MA",
    cityWithStateAbbr: "West Dennis, MA",
  },
  {
    zip: "2671",
    ST: "MA",
    cityWithStateAbbr: "West Harwich, MA",
  },
  {
    zip: "2672",
    ST: "MA",
    cityWithStateAbbr: "West Hyannisport, MA",
  },
  {
    zip: "2673",
    ST: "MA",
    cityWithStateAbbr: "West Yarmouth, MA",
  },
  {
    zip: "2675",
    ST: "MA",
    cityWithStateAbbr: "Yarmouth Port, MA",
  },
  {
    zip: "2702",
    ST: "MA",
    cityWithStateAbbr: "Assonet, MA",
  },
  {
    zip: "2703",
    ST: "MA",
    cityWithStateAbbr: "Attleboro, MA",
  },
  {
    zip: "2712",
    ST: "MA",
    cityWithStateAbbr: "Chartley, MA",
  },
  {
    zip: "2713",
    ST: "MA",
    cityWithStateAbbr: "Cuttyhunk, MA",
  },
  {
    zip: "2714",
    ST: "MA",
    cityWithStateAbbr: "Dartmouth, MA",
  },
  {
    zip: "2715",
    ST: "MA",
    cityWithStateAbbr: "Dighton, MA",
  },
  {
    zip: "2717",
    ST: "MA",
    cityWithStateAbbr: "East Freetown, MA",
  },
  {
    zip: "2718",
    ST: "MA",
    cityWithStateAbbr: "East Taunton, MA",
  },
  {
    zip: "2719",
    ST: "MA",
    cityWithStateAbbr: "Fairhaven, MA",
  },
  {
    zip: "2720",
    ST: "MA",
    cityWithStateAbbr: "Fall River, MA",
  },
  {
    zip: "2721",
    ST: "MA",
    cityWithStateAbbr: "Fall River, MA",
  },
  {
    zip: "2722",
    ST: "MA",
    cityWithStateAbbr: "Fall River, MA",
  },
  {
    zip: "2723",
    ST: "MA",
    cityWithStateAbbr: "Fall River, MA",
  },
  {
    zip: "2724",
    ST: "MA",
    cityWithStateAbbr: "Fall River, MA",
  },
  {
    zip: "2725",
    ST: "MA",
    cityWithStateAbbr: "Somerset, MA",
  },
  {
    zip: "2726",
    ST: "MA",
    cityWithStateAbbr: "Somerset, MA",
  },
  {
    zip: "2738",
    ST: "MA",
    cityWithStateAbbr: "Marion, MA",
  },
  {
    zip: "2739",
    ST: "MA",
    cityWithStateAbbr: "Mattapoisett, MA",
  },
  {
    zip: "2740",
    ST: "MA",
    cityWithStateAbbr: "New Bedford, MA",
  },
  {
    zip: "2741",
    ST: "MA",
    cityWithStateAbbr: "New Bedford, MA",
  },
  {
    zip: "2742",
    ST: "MA",
    cityWithStateAbbr: "New Bedford, MA",
  },
  {
    zip: "2743",
    ST: "MA",
    cityWithStateAbbr: "Acushnet, MA",
  },
  {
    zip: "2744",
    ST: "MA",
    cityWithStateAbbr: "New Bedford, MA",
  },
  {
    zip: "2745",
    ST: "MA",
    cityWithStateAbbr: "New Bedford, MA",
  },
  {
    zip: "2746",
    ST: "MA",
    cityWithStateAbbr: "New Bedford, MA",
  },
  {
    zip: "2747",
    ST: "MA",
    cityWithStateAbbr: "North Dartmouth, MA",
  },
  {
    zip: "2748",
    ST: "MA",
    cityWithStateAbbr: "South Dartmouth, MA",
  },
  {
    zip: "2760",
    ST: "MA",
    cityWithStateAbbr: "North Attleboro, MA",
  },
  {
    zip: "2761",
    ST: "MA",
    cityWithStateAbbr: "North Attleboro, MA",
  },
  {
    zip: "2762",
    ST: "MA",
    cityWithStateAbbr: "Plainville, MA",
  },
  {
    zip: "2763",
    ST: "MA",
    cityWithStateAbbr: "Attleboro Falls, MA",
  },
  {
    zip: "2764",
    ST: "MA",
    cityWithStateAbbr: "North Dighton, MA",
  },
  {
    zip: "2766",
    ST: "MA",
    cityWithStateAbbr: "Norton, MA",
  },
  {
    zip: "2767",
    ST: "MA",
    cityWithStateAbbr: "Raynham, MA",
  },
  {
    zip: "2768",
    ST: "MA",
    cityWithStateAbbr: "Raynham Center, MA",
  },
  {
    zip: "2769",
    ST: "MA",
    cityWithStateAbbr: "Rehoboth, MA",
  },
  {
    zip: "2770",
    ST: "MA",
    cityWithStateAbbr: "Rochester, MA",
  },
  {
    zip: "2771",
    ST: "MA",
    cityWithStateAbbr: "Seekonk, MA",
  },
  {
    zip: "2777",
    ST: "MA",
    cityWithStateAbbr: "Swansea, MA",
  },
  {
    zip: "2779",
    ST: "MA",
    cityWithStateAbbr: "Berkley, MA",
  },
  {
    zip: "2780",
    ST: "MA",
    cityWithStateAbbr: "Taunton, MA",
  },
  {
    zip: "2783",
    ST: "MA",
    cityWithStateAbbr: "Taunton, MA",
  },
  {
    zip: "2790",
    ST: "MA",
    cityWithStateAbbr: "Westport, MA",
  },
  {
    zip: "2791",
    ST: "MA",
    cityWithStateAbbr: "Westport Point, MA",
  },
  {
    zip: "2801",
    ST: "RI",
    cityWithStateAbbr: "Adamsville, RI",
  },
  {
    zip: "2802",
    ST: "RI",
    cityWithStateAbbr: "Albion, RI",
  },
  {
    zip: "2804",
    ST: "RI",
    cityWithStateAbbr: "Ashaway, RI",
  },
  {
    zip: "2806",
    ST: "RI",
    cityWithStateAbbr: "Barrington, RI",
  },
  {
    zip: "2807",
    ST: "RI",
    cityWithStateAbbr: "Block Island, RI",
  },
  {
    zip: "2808",
    ST: "RI",
    cityWithStateAbbr: "Bradford, RI",
  },
  {
    zip: "2809",
    ST: "RI",
    cityWithStateAbbr: "Bristol, RI",
  },
  {
    zip: "2812",
    ST: "RI",
    cityWithStateAbbr: "Carolina, RI",
  },
  {
    zip: "2813",
    ST: "RI",
    cityWithStateAbbr: "Charlestown, RI",
  },
  {
    zip: "2814",
    ST: "RI",
    cityWithStateAbbr: "Chepachet, RI",
  },
  {
    zip: "2815",
    ST: "RI",
    cityWithStateAbbr: "Clayville, RI",
  },
  {
    zip: "2816",
    ST: "RI",
    cityWithStateAbbr: "Coventry, RI",
  },
  {
    zip: "2817",
    ST: "RI",
    cityWithStateAbbr: "West Greenwich, RI",
  },
  {
    zip: "2818",
    ST: "RI",
    cityWithStateAbbr: "East Greenwich, RI",
  },
  {
    zip: "2822",
    ST: "RI",
    cityWithStateAbbr: "Exeter, RI",
  },
  {
    zip: "2823",
    ST: "RI",
    cityWithStateAbbr: "Fiskeville, RI",
  },
  {
    zip: "2824",
    ST: "RI",
    cityWithStateAbbr: "Forestdale, RI",
  },
  {
    zip: "2825",
    ST: "RI",
    cityWithStateAbbr: "Foster, RI",
  },
  {
    zip: "2826",
    ST: "RI",
    cityWithStateAbbr: "Glendale, RI",
  },
  {
    zip: "2827",
    ST: "RI",
    cityWithStateAbbr: "Greene, RI",
  },
  {
    zip: "2828",
    ST: "RI",
    cityWithStateAbbr: "Greenville, RI",
  },
  {
    zip: "2829",
    ST: "RI",
    cityWithStateAbbr: "Harmony, RI",
  },
  {
    zip: "2830",
    ST: "RI",
    cityWithStateAbbr: "Harrisville, RI",
  },
  {
    zip: "2831",
    ST: "RI",
    cityWithStateAbbr: "Hope, RI",
  },
  {
    zip: "2832",
    ST: "RI",
    cityWithStateAbbr: "Hope Valley, RI",
  },
  {
    zip: "2833",
    ST: "RI",
    cityWithStateAbbr: "Hopkinton, RI",
  },
  {
    zip: "2835",
    ST: "RI",
    cityWithStateAbbr: "Jamestown, RI",
  },
  {
    zip: "2836",
    ST: "RI",
    cityWithStateAbbr: "Kenyon, RI",
  },
  {
    zip: "2837",
    ST: "RI",
    cityWithStateAbbr: "Little Compton, RI",
  },
  {
    zip: "2838",
    ST: "RI",
    cityWithStateAbbr: "Manville, RI",
  },
  {
    zip: "2839",
    ST: "RI",
    cityWithStateAbbr: "Mapleville, RI",
  },
  {
    zip: "2840",
    ST: "RI",
    cityWithStateAbbr: "Newport, RI",
  },
  {
    zip: "2841",
    ST: "RI",
    cityWithStateAbbr: "Newport, RI",
  },
  {
    zip: "2842",
    ST: "RI",
    cityWithStateAbbr: "Middletown, RI",
  },
  {
    zip: "2852",
    ST: "RI",
    cityWithStateAbbr: "North Kingstown, RI",
  },
  {
    zip: "2857",
    ST: "RI",
    cityWithStateAbbr: "North Scituate, RI",
  },
  {
    zip: "2858",
    ST: "RI",
    cityWithStateAbbr: "Oakland, RI",
  },
  {
    zip: "2859",
    ST: "RI",
    cityWithStateAbbr: "Pascoag, RI",
  },
  {
    zip: "2860",
    ST: "RI",
    cityWithStateAbbr: "Pawtucket, RI",
  },
  {
    zip: "2861",
    ST: "RI",
    cityWithStateAbbr: "Pawtucket, RI",
  },
  {
    zip: "2862",
    ST: "RI",
    cityWithStateAbbr: "Pawtucket, RI",
  },
  {
    zip: "2863",
    ST: "RI",
    cityWithStateAbbr: "Central Falls, RI",
  },
  {
    zip: "2864",
    ST: "RI",
    cityWithStateAbbr: "Cumberland, RI",
  },
  {
    zip: "2865",
    ST: "RI",
    cityWithStateAbbr: "Lincoln, RI",
  },
  {
    zip: "2871",
    ST: "RI",
    cityWithStateAbbr: "Portsmouth, RI",
  },
  {
    zip: "2872",
    ST: "RI",
    cityWithStateAbbr: "Prudence Island, RI",
  },
  {
    zip: "2873",
    ST: "RI",
    cityWithStateAbbr: "Rockville, RI",
  },
  {
    zip: "2874",
    ST: "RI",
    cityWithStateAbbr: "Saunderstown, RI",
  },
  {
    zip: "2875",
    ST: "RI",
    cityWithStateAbbr: "Shannock, RI",
  },
  {
    zip: "2876",
    ST: "RI",
    cityWithStateAbbr: "Slatersville, RI",
  },
  {
    zip: "2877",
    ST: "RI",
    cityWithStateAbbr: "Slocum, RI",
  },
  {
    zip: "2878",
    ST: "RI",
    cityWithStateAbbr: "Tiverton, RI",
  },
  {
    zip: "2879",
    ST: "RI",
    cityWithStateAbbr: "Wakefield, RI",
  },
  {
    zip: "2880",
    ST: "RI",
    cityWithStateAbbr: "Wakefield, RI",
  },
  {
    zip: "2881",
    ST: "RI",
    cityWithStateAbbr: "Kingston, RI",
  },
  {
    zip: "2882",
    ST: "RI",
    cityWithStateAbbr: "Narragansett, RI",
  },
  {
    zip: "2883",
    ST: "RI",
    cityWithStateAbbr: "Peace Dale, RI",
  },
  {
    zip: "2885",
    ST: "RI",
    cityWithStateAbbr: "Warren, RI",
  },
  {
    zip: "2886",
    ST: "RI",
    cityWithStateAbbr: "Warwick, RI",
  },
  {
    zip: "2887",
    ST: "RI",
    cityWithStateAbbr: "Warwick, RI",
  },
  {
    zip: "2888",
    ST: "RI",
    cityWithStateAbbr: "Warwick, RI",
  },
  {
    zip: "2889",
    ST: "RI",
    cityWithStateAbbr: "Warwick, RI",
  },
  {
    zip: "2891",
    ST: "RI",
    cityWithStateAbbr: "Westerly, RI",
  },
  {
    zip: "2892",
    ST: "RI",
    cityWithStateAbbr: "West Kingston, RI",
  },
  {
    zip: "2893",
    ST: "RI",
    cityWithStateAbbr: "West Warwick, RI",
  },
  {
    zip: "2894",
    ST: "RI",
    cityWithStateAbbr: "Wood River Junction, RI",
  },
  {
    zip: "2895",
    ST: "RI",
    cityWithStateAbbr: "Woonsocket, RI",
  },
  {
    zip: "2896",
    ST: "RI",
    cityWithStateAbbr: "North Smithfield, RI",
  },
  {
    zip: "2898",
    ST: "RI",
    cityWithStateAbbr: "Wyoming, RI",
  },
  {
    zip: "2901",
    ST: "RI",
    cityWithStateAbbr: "Providence, RI",
  },
  {
    zip: "2902",
    ST: "RI",
    cityWithStateAbbr: "Providence, RI",
  },
  {
    zip: "2903",
    ST: "RI",
    cityWithStateAbbr: "Providence, RI",
  },
  {
    zip: "2904",
    ST: "RI",
    cityWithStateAbbr: "Providence, RI",
  },
  {
    zip: "2905",
    ST: "RI",
    cityWithStateAbbr: "Providence, RI",
  },
  {
    zip: "2906",
    ST: "RI",
    cityWithStateAbbr: "Providence, RI",
  },
  {
    zip: "2907",
    ST: "RI",
    cityWithStateAbbr: "Providence, RI",
  },
  {
    zip: "2908",
    ST: "RI",
    cityWithStateAbbr: "Providence, RI",
  },
  {
    zip: "2909",
    ST: "RI",
    cityWithStateAbbr: "Providence, RI",
  },
  {
    zip: "2910",
    ST: "RI",
    cityWithStateAbbr: "Cranston, RI",
  },
  {
    zip: "2911",
    ST: "RI",
    cityWithStateAbbr: "North Providence, RI",
  },
  {
    zip: "2912",
    ST: "RI",
    cityWithStateAbbr: "Providence, RI",
  },
  {
    zip: "2914",
    ST: "RI",
    cityWithStateAbbr: "East Providence, RI",
  },
  {
    zip: "2915",
    ST: "RI",
    cityWithStateAbbr: "Riverside, RI",
  },
  {
    zip: "2916",
    ST: "RI",
    cityWithStateAbbr: "Rumford, RI",
  },
  {
    zip: "2917",
    ST: "RI",
    cityWithStateAbbr: "Smithfield, RI",
  },
  {
    zip: "2918",
    ST: "RI",
    cityWithStateAbbr: "Providence, RI",
  },
  {
    zip: "2919",
    ST: "RI",
    cityWithStateAbbr: "Johnston, RI",
  },
  {
    zip: "2920",
    ST: "RI",
    cityWithStateAbbr: "Cranston, RI",
  },
  {
    zip: "2921",
    ST: "RI",
    cityWithStateAbbr: "Cranston, RI",
  },
  {
    zip: "2940",
    ST: "RI",
    cityWithStateAbbr: "Providence, RI",
  },
  {
    zip: "3031",
    ST: "NH",
    cityWithStateAbbr: "Amherst, NH",
  },
  {
    zip: "3032",
    ST: "NH",
    cityWithStateAbbr: "Auburn, NH",
  },
  {
    zip: "3033",
    ST: "NH",
    cityWithStateAbbr: "Brookline, NH",
  },
  {
    zip: "3034",
    ST: "NH",
    cityWithStateAbbr: "Candia, NH",
  },
  {
    zip: "3036",
    ST: "NH",
    cityWithStateAbbr: "Chester, NH",
  },
  {
    zip: "3037",
    ST: "NH",
    cityWithStateAbbr: "Deerfield, NH",
  },
  {
    zip: "3038",
    ST: "NH",
    cityWithStateAbbr: "Derry, NH",
  },
  {
    zip: "3040",
    ST: "NH",
    cityWithStateAbbr: "East Candia, NH",
  },
  {
    zip: "3041",
    ST: "NH",
    cityWithStateAbbr: "East Derry, NH",
  },
  {
    zip: "3042",
    ST: "NH",
    cityWithStateAbbr: "Epping, NH",
  },
  {
    zip: "3043",
    ST: "NH",
    cityWithStateAbbr: "Francestown, NH",
  },
  {
    zip: "3044",
    ST: "NH",
    cityWithStateAbbr: "Fremont, NH",
  },
  {
    zip: "3045",
    ST: "NH",
    cityWithStateAbbr: "Goffstown, NH",
  },
  {
    zip: "3046",
    ST: "NH",
    cityWithStateAbbr: "Dunbarton, NH",
  },
  {
    zip: "3047",
    ST: "NH",
    cityWithStateAbbr: "Greenfield, NH",
  },
  {
    zip: "3048",
    ST: "NH",
    cityWithStateAbbr: "Greenville, NH",
  },
  {
    zip: "3049",
    ST: "NH",
    cityWithStateAbbr: "Hollis, NH",
  },
  {
    zip: "3051",
    ST: "NH",
    cityWithStateAbbr: "Hudson, NH",
  },
  {
    zip: "3052",
    ST: "NH",
    cityWithStateAbbr: "Litchfield, NH",
  },
  {
    zip: "3053",
    ST: "NH",
    cityWithStateAbbr: "Londonderry, NH",
  },
  {
    zip: "3054",
    ST: "NH",
    cityWithStateAbbr: "Merrimack, NH",
  },
  {
    zip: "3055",
    ST: "NH",
    cityWithStateAbbr: "Milford, NH",
  },
  {
    zip: "3057",
    ST: "NH",
    cityWithStateAbbr: "Mont Vernon, NH",
  },
  {
    zip: "3060",
    ST: "NH",
    cityWithStateAbbr: "Nashua, NH",
  },
  {
    zip: "3061",
    ST: "NH",
    cityWithStateAbbr: "Nashua, NH",
  },
  {
    zip: "3062",
    ST: "NH",
    cityWithStateAbbr: "Nashua, NH",
  },
  {
    zip: "3063",
    ST: "NH",
    cityWithStateAbbr: "Nashua, NH",
  },
  {
    zip: "3064",
    ST: "NH",
    cityWithStateAbbr: "Nashua, NH",
  },
  {
    zip: "3070",
    ST: "NH",
    cityWithStateAbbr: "New Boston, NH",
  },
  {
    zip: "3071",
    ST: "NH",
    cityWithStateAbbr: "New Ipswich, NH",
  },
  {
    zip: "3073",
    ST: "NH",
    cityWithStateAbbr: "North Salem, NH",
  },
  {
    zip: "3076",
    ST: "NH",
    cityWithStateAbbr: "Pelham, NH",
  },
  {
    zip: "3077",
    ST: "NH",
    cityWithStateAbbr: "Raymond, NH",
  },
  {
    zip: "3079",
    ST: "NH",
    cityWithStateAbbr: "Salem, NH",
  },
  {
    zip: "3082",
    ST: "NH",
    cityWithStateAbbr: "Lyndeborough, NH",
  },
  {
    zip: "3084",
    ST: "NH",
    cityWithStateAbbr: "Temple, NH",
  },
  {
    zip: "3086",
    ST: "NH",
    cityWithStateAbbr: "Wilton, NH",
  },
  {
    zip: "3087",
    ST: "NH",
    cityWithStateAbbr: "Windham, NH",
  },
  {
    zip: "3101",
    ST: "NH",
    cityWithStateAbbr: "Manchester, NH",
  },
  {
    zip: "3102",
    ST: "NH",
    cityWithStateAbbr: "Manchester, NH",
  },
  {
    zip: "3103",
    ST: "NH",
    cityWithStateAbbr: "Manchester, NH",
  },
  {
    zip: "3104",
    ST: "NH",
    cityWithStateAbbr: "Manchester, NH",
  },
  {
    zip: "3105",
    ST: "NH",
    cityWithStateAbbr: "Manchester, NH",
  },
  {
    zip: "3106",
    ST: "NH",
    cityWithStateAbbr: "Hooksett, NH",
  },
  {
    zip: "3107",
    ST: "NH",
    cityWithStateAbbr: "Manchester, NH",
  },
  {
    zip: "3108",
    ST: "NH",
    cityWithStateAbbr: "Manchester, NH",
  },
  {
    zip: "3109",
    ST: "NH",
    cityWithStateAbbr: "Manchester, NH",
  },
  {
    zip: "3110",
    ST: "NH",
    cityWithStateAbbr: "Bedford, NH",
  },
  {
    zip: "3111",
    ST: "NH",
    cityWithStateAbbr: "Manchester, NH",
  },
  {
    zip: "3215",
    ST: "NH",
    cityWithStateAbbr: "Waterville Valley, NH",
  },
  {
    zip: "3216",
    ST: "NH",
    cityWithStateAbbr: "Andover, NH",
  },
  {
    zip: "3217",
    ST: "NH",
    cityWithStateAbbr: "Ashland, NH",
  },
  {
    zip: "3218",
    ST: "NH",
    cityWithStateAbbr: "Barnstead, NH",
  },
  {
    zip: "3220",
    ST: "NH",
    cityWithStateAbbr: "Belmont, NH",
  },
  {
    zip: "3221",
    ST: "NH",
    cityWithStateAbbr: "Bradford, NH",
  },
  {
    zip: "3222",
    ST: "NH",
    cityWithStateAbbr: "Bristol, NH",
  },
  {
    zip: "3223",
    ST: "NH",
    cityWithStateAbbr: "Campton, NH",
  },
  {
    zip: "3224",
    ST: "NH",
    cityWithStateAbbr: "Canterbury, NH",
  },
  {
    zip: "3225",
    ST: "NH",
    cityWithStateAbbr: "Center Barnstead, NH",
  },
  {
    zip: "3226",
    ST: "NH",
    cityWithStateAbbr: "Center Harbor, NH",
  },
  {
    zip: "3227",
    ST: "NH",
    cityWithStateAbbr: "Center Sandwich, NH",
  },
  {
    zip: "3229",
    ST: "NH",
    cityWithStateAbbr: "Contoocook, NH",
  },
  {
    zip: "3230",
    ST: "NH",
    cityWithStateAbbr: "Danbury, NH",
  },
  {
    zip: "3231",
    ST: "NH",
    cityWithStateAbbr: "East Andover, NH",
  },
  {
    zip: "3233",
    ST: "NH",
    cityWithStateAbbr: "Elkins, NH",
  },
  {
    zip: "3234",
    ST: "NH",
    cityWithStateAbbr: "Epsom, NH",
  },
  {
    zip: "3235",
    ST: "NH",
    cityWithStateAbbr: "Franklin, NH",
  },
  {
    zip: "3237",
    ST: "NH",
    cityWithStateAbbr: "Gilmanton, NH",
  },
  {
    zip: "3238",
    ST: "NH",
    cityWithStateAbbr: "Glencliff, NH",
  },
  {
    zip: "3240",
    ST: "NH",
    cityWithStateAbbr: "Grafton, NH",
  },
  {
    zip: "3241",
    ST: "NH",
    cityWithStateAbbr: "Hebron, NH",
  },
  {
    zip: "3242",
    ST: "NH",
    cityWithStateAbbr: "Henniker, NH",
  },
  {
    zip: "3243",
    ST: "NH",
    cityWithStateAbbr: "Hill, NH",
  },
  {
    zip: "3244",
    ST: "NH",
    cityWithStateAbbr: "Hillsborough, NH",
  },
  {
    zip: "3245",
    ST: "NH",
    cityWithStateAbbr: "Holderness, NH",
  },
  {
    zip: "3246",
    ST: "NH",
    cityWithStateAbbr: "Laconia, NH",
  },
  {
    zip: "3247",
    ST: "NH",
    cityWithStateAbbr: "Laconia, NH",
  },
  {
    zip: "3249",
    ST: "NH",
    cityWithStateAbbr: "Gilford, NH",
  },
  {
    zip: "3251",
    ST: "NH",
    cityWithStateAbbr: "Lincoln, NH",
  },
  {
    zip: "3252",
    ST: "NH",
    cityWithStateAbbr: "Lochmere, NH",
  },
  {
    zip: "3253",
    ST: "NH",
    cityWithStateAbbr: "Meredith, NH",
  },
  {
    zip: "3254",
    ST: "NH",
    cityWithStateAbbr: "Moultonborough, NH",
  },
  {
    zip: "3255",
    ST: "NH",
    cityWithStateAbbr: "Newbury, NH",
  },
  {
    zip: "3256",
    ST: "NH",
    cityWithStateAbbr: "New Hampton, NH",
  },
  {
    zip: "3257",
    ST: "NH",
    cityWithStateAbbr: "New London, NH",
  },
  {
    zip: "3258",
    ST: "NH",
    cityWithStateAbbr: "Chichester, NH",
  },
  {
    zip: "3259",
    ST: "NH",
    cityWithStateAbbr: "North Sandwich, NH",
  },
  {
    zip: "3260",
    ST: "NH",
    cityWithStateAbbr: "North Sutton, NH",
  },
  {
    zip: "3261",
    ST: "NH",
    cityWithStateAbbr: "Northwood, NH",
  },
  {
    zip: "3262",
    ST: "NH",
    cityWithStateAbbr: "North Woodstock, NH",
  },
  {
    zip: "3263",
    ST: "NH",
    cityWithStateAbbr: "Pittsfield, NH",
  },
  {
    zip: "3264",
    ST: "NH",
    cityWithStateAbbr: "Plymouth, NH",
  },
  {
    zip: "3266",
    ST: "NH",
    cityWithStateAbbr: "Rumney, NH",
  },
  {
    zip: "3268",
    ST: "NH",
    cityWithStateAbbr: "Salisbury, NH",
  },
  {
    zip: "3269",
    ST: "NH",
    cityWithStateAbbr: "Sanbornton, NH",
  },
  {
    zip: "3272",
    ST: "NH",
    cityWithStateAbbr: "South Newbury, NH",
  },
  {
    zip: "3273",
    ST: "NH",
    cityWithStateAbbr: "South Sutton, NH",
  },
  {
    zip: "3274",
    ST: "NH",
    cityWithStateAbbr: "Stinson Lake, NH",
  },
  {
    zip: "3275",
    ST: "NH",
    cityWithStateAbbr: "Suncook, NH",
  },
  {
    zip: "3276",
    ST: "NH",
    cityWithStateAbbr: "Tilton, NH",
  },
  {
    zip: "3278",
    ST: "NH",
    cityWithStateAbbr: "Warner, NH",
  },
  {
    zip: "3279",
    ST: "NH",
    cityWithStateAbbr: "Warren, NH",
  },
  {
    zip: "3280",
    ST: "NH",
    cityWithStateAbbr: "Washington, NH",
  },
  {
    zip: "3281",
    ST: "NH",
    cityWithStateAbbr: "Weare, NH",
  },
  {
    zip: "3282",
    ST: "NH",
    cityWithStateAbbr: "Wentworth, NH",
  },
  {
    zip: "3284",
    ST: "NH",
    cityWithStateAbbr: "Springfield, NH",
  },
  {
    zip: "3285",
    ST: "NH",
    cityWithStateAbbr: "Thornton, NH",
  },
  {
    zip: "3287",
    ST: "NH",
    cityWithStateAbbr: "Wilmot, NH",
  },
  {
    zip: "3289",
    ST: "NH",
    cityWithStateAbbr: "Winnisquam, NH",
  },
  {
    zip: "3290",
    ST: "NH",
    cityWithStateAbbr: "Nottingham, NH",
  },
  {
    zip: "3291",
    ST: "NH",
    cityWithStateAbbr: "West Nottingham, NH",
  },
  {
    zip: "3293",
    ST: "NH",
    cityWithStateAbbr: "Woodstock, NH",
  },
  {
    zip: "3298",
    ST: "NH",
    cityWithStateAbbr: "Tilton, NH",
  },
  {
    zip: "3299",
    ST: "NH",
    cityWithStateAbbr: "Tilton, NH",
  },
  {
    zip: "3301",
    ST: "NH",
    cityWithStateAbbr: "Concord, NH",
  },
  {
    zip: "3302",
    ST: "NH",
    cityWithStateAbbr: "Concord, NH",
  },
  {
    zip: "3303",
    ST: "NH",
    cityWithStateAbbr: "Concord, NH",
  },
  {
    zip: "3304",
    ST: "NH",
    cityWithStateAbbr: "Bow, NH",
  },
  {
    zip: "3305",
    ST: "NH",
    cityWithStateAbbr: "Concord, NH",
  },
  {
    zip: "3307",
    ST: "NH",
    cityWithStateAbbr: "Loudon, NH",
  },
  {
    zip: "3431",
    ST: "NH",
    cityWithStateAbbr: "Keene, NH",
  },
  {
    zip: "3435",
    ST: "NH",
    cityWithStateAbbr: "Keene, NH",
  },
  {
    zip: "3440",
    ST: "NH",
    cityWithStateAbbr: "Antrim, NH",
  },
  {
    zip: "3441",
    ST: "NH",
    cityWithStateAbbr: "Ashuelot, NH",
  },
  {
    zip: "3442",
    ST: "NH",
    cityWithStateAbbr: "Bennington, NH",
  },
  {
    zip: "3443",
    ST: "NH",
    cityWithStateAbbr: "Chesterfield, NH",
  },
  {
    zip: "3444",
    ST: "NH",
    cityWithStateAbbr: "Dublin, NH",
  },
  {
    zip: "3445",
    ST: "NH",
    cityWithStateAbbr: "Sullivan, NH",
  },
  {
    zip: "3446",
    ST: "NH",
    cityWithStateAbbr: "Swanzey, NH",
  },
  {
    zip: "3447",
    ST: "NH",
    cityWithStateAbbr: "Fitzwilliam, NH",
  },
  {
    zip: "3448",
    ST: "NH",
    cityWithStateAbbr: "Gilsum, NH",
  },
  {
    zip: "3449",
    ST: "NH",
    cityWithStateAbbr: "Hancock, NH",
  },
  {
    zip: "3450",
    ST: "NH",
    cityWithStateAbbr: "Harrisville, NH",
  },
  {
    zip: "3451",
    ST: "NH",
    cityWithStateAbbr: "Hinsdale, NH",
  },
  {
    zip: "3452",
    ST: "NH",
    cityWithStateAbbr: "Jaffrey, NH",
  },
  {
    zip: "3455",
    ST: "NH",
    cityWithStateAbbr: "Marlborough, NH",
  },
  {
    zip: "3456",
    ST: "NH",
    cityWithStateAbbr: "Marlow, NH",
  },
  {
    zip: "3457",
    ST: "NH",
    cityWithStateAbbr: "Nelson, NH",
  },
  {
    zip: "3458",
    ST: "NH",
    cityWithStateAbbr: "Peterborough, NH",
  },
  {
    zip: "3461",
    ST: "NH",
    cityWithStateAbbr: "Rindge, NH",
  },
  {
    zip: "3462",
    ST: "NH",
    cityWithStateAbbr: "Spofford, NH",
  },
  {
    zip: "3464",
    ST: "NH",
    cityWithStateAbbr: "Stoddard, NH",
  },
  {
    zip: "3465",
    ST: "NH",
    cityWithStateAbbr: "Troy, NH",
  },
  {
    zip: "3466",
    ST: "NH",
    cityWithStateAbbr: "West Chesterfield, NH",
  },
  {
    zip: "3467",
    ST: "NH",
    cityWithStateAbbr: "Westmoreland, NH",
  },
  {
    zip: "3468",
    ST: "NH",
    cityWithStateAbbr: "West Peterborough, NH",
  },
  {
    zip: "3469",
    ST: "NH",
    cityWithStateAbbr: "West Swanzey, NH",
  },
  {
    zip: "3470",
    ST: "NH",
    cityWithStateAbbr: "Winchester, NH",
  },
  {
    zip: "3561",
    ST: "NH",
    cityWithStateAbbr: "Littleton, NH",
  },
  {
    zip: "3570",
    ST: "NH",
    cityWithStateAbbr: "Berlin, NH",
  },
  {
    zip: "3574",
    ST: "NH",
    cityWithStateAbbr: "Bethlehem, NH",
  },
  {
    zip: "3575",
    ST: "NH",
    cityWithStateAbbr: "Bretton Woods, NH",
  },
  {
    zip: "3576",
    ST: "NH",
    cityWithStateAbbr: "Colebrook, NH",
  },
  {
    zip: "3579",
    ST: "ME",
    cityWithStateAbbr: "Errol, ME",
  },
  {
    zip: "3580",
    ST: "NH",
    cityWithStateAbbr: "Franconia, NH",
  },
  {
    zip: "3581",
    ST: "NH",
    cityWithStateAbbr: "Gorham, NH",
  },
  {
    zip: "3582",
    ST: "NH",
    cityWithStateAbbr: "Groveton, NH",
  },
  {
    zip: "3583",
    ST: "NH",
    cityWithStateAbbr: "Jefferson, NH",
  },
  {
    zip: "3584",
    ST: "NH",
    cityWithStateAbbr: "Lancaster, NH",
  },
  {
    zip: "3585",
    ST: "NH",
    cityWithStateAbbr: "Lisbon, NH",
  },
  {
    zip: "3586",
    ST: "NH",
    cityWithStateAbbr: "Sugar Hill, NH",
  },
  {
    zip: "3588",
    ST: "NH",
    cityWithStateAbbr: "Milan, NH",
  },
  {
    zip: "3589",
    ST: "NH",
    cityWithStateAbbr: "Mount Washington, NH",
  },
  {
    zip: "3590",
    ST: "NH",
    cityWithStateAbbr: "North Stratford, NH",
  },
  {
    zip: "3592",
    ST: "NH",
    cityWithStateAbbr: "Pittsburg, NH",
  },
  {
    zip: "3593",
    ST: "NH",
    cityWithStateAbbr: "Randolph, NH",
  },
  {
    zip: "3595",
    ST: "NH",
    cityWithStateAbbr: "Twin Mountain, NH",
  },
  {
    zip: "3597",
    ST: "NH",
    cityWithStateAbbr: "West Stewartstown, NH",
  },
  {
    zip: "3598",
    ST: "NH",
    cityWithStateAbbr: "Whitefield, NH",
  },
  {
    zip: "3601",
    ST: "NH",
    cityWithStateAbbr: "Acworth, NH",
  },
  {
    zip: "3602",
    ST: "NH",
    cityWithStateAbbr: "Alstead, NH",
  },
  {
    zip: "3603",
    ST: "NH",
    cityWithStateAbbr: "Charlestown, NH",
  },
  {
    zip: "3604",
    ST: "NH",
    cityWithStateAbbr: "Drewsville, NH",
  },
  {
    zip: "3605",
    ST: "NH",
    cityWithStateAbbr: "Lempster, NH",
  },
  {
    zip: "3607",
    ST: "NH",
    cityWithStateAbbr: "South Acworth, NH",
  },
  {
    zip: "3608",
    ST: "NH",
    cityWithStateAbbr: "Walpole, NH",
  },
  {
    zip: "3609",
    ST: "NH",
    cityWithStateAbbr: "North Walpole, NH",
  },
  {
    zip: "3740",
    ST: "NH",
    cityWithStateAbbr: "Bath, NH",
  },
  {
    zip: "3741",
    ST: "NH",
    cityWithStateAbbr: "Canaan, NH",
  },
  {
    zip: "3743",
    ST: "NH",
    cityWithStateAbbr: "Claremont, NH",
  },
  {
    zip: "3745",
    ST: "NH",
    cityWithStateAbbr: "Cornish, NH",
  },
  {
    zip: "3746",
    ST: "NH",
    cityWithStateAbbr: "Cornish Flat, NH",
  },
  {
    zip: "3748",
    ST: "NH",
    cityWithStateAbbr: "Enfield, NH",
  },
  {
    zip: "3749",
    ST: "NH",
    cityWithStateAbbr: "Enfield Center, NH",
  },
  {
    zip: "3750",
    ST: "NH",
    cityWithStateAbbr: "Etna, NH",
  },
  {
    zip: "3751",
    ST: "NH",
    cityWithStateAbbr: "Georges Mills, NH",
  },
  {
    zip: "3752",
    ST: "NH",
    cityWithStateAbbr: "Goshen, NH",
  },
  {
    zip: "3753",
    ST: "NH",
    cityWithStateAbbr: "Grantham, NH",
  },
  {
    zip: "3754",
    ST: "NH",
    cityWithStateAbbr: "Guild, NH",
  },
  {
    zip: "3755",
    ST: "NH",
    cityWithStateAbbr: "Hanover, NH",
  },
  {
    zip: "3756",
    ST: "NH",
    cityWithStateAbbr: "Lebanon, NH",
  },
  {
    zip: "3765",
    ST: "NH",
    cityWithStateAbbr: "Haverhill, NH",
  },
  {
    zip: "3766",
    ST: "NH",
    cityWithStateAbbr: "Lebanon, NH",
  },
  {
    zip: "3768",
    ST: "NH",
    cityWithStateAbbr: "Lyme, NH",
  },
  {
    zip: "3769",
    ST: "NH",
    cityWithStateAbbr: "Lyme Center, NH",
  },
  {
    zip: "3770",
    ST: "NH",
    cityWithStateAbbr: "Meriden, NH",
  },
  {
    zip: "3771",
    ST: "NH",
    cityWithStateAbbr: "Monroe, NH",
  },
  {
    zip: "3773",
    ST: "NH",
    cityWithStateAbbr: "Newport, NH",
  },
  {
    zip: "3774",
    ST: "NH",
    cityWithStateAbbr: "North Haverhill, NH",
  },
  {
    zip: "3777",
    ST: "NH",
    cityWithStateAbbr: "Orford, NH",
  },
  {
    zip: "3779",
    ST: "NH",
    cityWithStateAbbr: "Piermont, NH",
  },
  {
    zip: "3780",
    ST: "NH",
    cityWithStateAbbr: "Pike, NH",
  },
  {
    zip: "3781",
    ST: "NH",
    cityWithStateAbbr: "Plainfield, NH",
  },
  {
    zip: "3782",
    ST: "NH",
    cityWithStateAbbr: "Sunapee, NH",
  },
  {
    zip: "3784",
    ST: "NH",
    cityWithStateAbbr: "West Lebanon, NH",
  },
  {
    zip: "3785",
    ST: "NH",
    cityWithStateAbbr: "Woodsville, NH",
  },
  {
    zip: "3801",
    ST: "NH",
    cityWithStateAbbr: "Portsmouth, NH",
  },
  {
    zip: "3802",
    ST: "NH",
    cityWithStateAbbr: "Portsmouth, NH",
  },
  {
    zip: "3803",
    ST: "NH",
    cityWithStateAbbr: "Portsmouth, NH",
  },
  {
    zip: "3804",
    ST: "NH",
    cityWithStateAbbr: "Portsmouth, NH",
  },
  {
    zip: "3805",
    ST: "ME",
    cityWithStateAbbr: "Newington, ME",
  },
  {
    zip: "3809",
    ST: "NH",
    cityWithStateAbbr: "Alton, NH",
  },
  {
    zip: "3810",
    ST: "NH",
    cityWithStateAbbr: "Alton Bay, NH",
  },
  {
    zip: "3811",
    ST: "NH",
    cityWithStateAbbr: "Atkinson, NH",
  },
  {
    zip: "3812",
    ST: "NH",
    cityWithStateAbbr: "Bartlett, NH",
  },
  {
    zip: "3813",
    ST: "NH",
    cityWithStateAbbr: "Center Conway, NH",
  },
  {
    zip: "3814",
    ST: "NH",
    cityWithStateAbbr: "Center Ossipee, NH",
  },
  {
    zip: "3815",
    ST: "NH",
    cityWithStateAbbr: "Center Strafford, NH",
  },
  {
    zip: "3816",
    ST: "NH",
    cityWithStateAbbr: "Center Tuftonboro, NH",
  },
  {
    zip: "3817",
    ST: "NH",
    cityWithStateAbbr: "Chocorua, NH",
  },
  {
    zip: "3818",
    ST: "NH",
    cityWithStateAbbr: "Conway, NH",
  },
  {
    zip: "3819",
    ST: "NH",
    cityWithStateAbbr: "Danville, NH",
  },
  {
    zip: "3820",
    ST: "NH",
    cityWithStateAbbr: "Dover, NH",
  },
  {
    zip: "3821",
    ST: "NH",
    cityWithStateAbbr: "Dover, NH",
  },
  {
    zip: "3822",
    ST: "NH",
    cityWithStateAbbr: "Dover, NH",
  },
  {
    zip: "3823",
    ST: "NH",
    cityWithStateAbbr: "Madbury, NH",
  },
  {
    zip: "3824",
    ST: "NH",
    cityWithStateAbbr: "Durham, NH",
  },
  {
    zip: "3825",
    ST: "NH",
    cityWithStateAbbr: "Barrington, NH",
  },
  {
    zip: "3826",
    ST: "NH",
    cityWithStateAbbr: "East Hampstead, NH",
  },
  {
    zip: "3827",
    ST: "NH",
    cityWithStateAbbr: "East Kingston, NH",
  },
  {
    zip: "3830",
    ST: "NH",
    cityWithStateAbbr: "East Wakefield, NH",
  },
  {
    zip: "3832",
    ST: "NH",
    cityWithStateAbbr: "Eaton Center, NH",
  },
  {
    zip: "3833",
    ST: "NH",
    cityWithStateAbbr: "Exeter, NH",
  },
  {
    zip: "3835",
    ST: "NH",
    cityWithStateAbbr: "Farmington, NH",
  },
  {
    zip: "3836",
    ST: "NH",
    cityWithStateAbbr: "Freedom, NH",
  },
  {
    zip: "3837",
    ST: "NH",
    cityWithStateAbbr: "Gilmanton Iron Works, NH",
  },
  {
    zip: "3838",
    ST: "NH",
    cityWithStateAbbr: "Glen, NH",
  },
  {
    zip: "3839",
    ST: "NH",
    cityWithStateAbbr: "Rochester, NH",
  },
  {
    zip: "3840",
    ST: "NH",
    cityWithStateAbbr: "Greenland, NH",
  },
  {
    zip: "3841",
    ST: "NH",
    cityWithStateAbbr: "Hampstead, NH",
  },
  {
    zip: "3842",
    ST: "NH",
    cityWithStateAbbr: "Hampton, NH",
  },
  {
    zip: "3843",
    ST: "NH",
    cityWithStateAbbr: "Hampton, NH",
  },
  {
    zip: "3844",
    ST: "NH",
    cityWithStateAbbr: "Hampton Falls, NH",
  },
  {
    zip: "3845",
    ST: "NH",
    cityWithStateAbbr: "Intervale, NH",
  },
  {
    zip: "3846",
    ST: "NH",
    cityWithStateAbbr: "Jackson, NH",
  },
  {
    zip: "3847",
    ST: "NH",
    cityWithStateAbbr: "Kearsarge, NH",
  },
  {
    zip: "3848",
    ST: "NH",
    cityWithStateAbbr: "Kingston, NH",
  },
  {
    zip: "3849",
    ST: "NH",
    cityWithStateAbbr: "Madison, NH",
  },
  {
    zip: "3850",
    ST: "NH",
    cityWithStateAbbr: "Melvin Village, NH",
  },
  {
    zip: "3851",
    ST: "NH",
    cityWithStateAbbr: "Milton, NH",
  },
  {
    zip: "3852",
    ST: "NH",
    cityWithStateAbbr: "Milton Mills, NH",
  },
  {
    zip: "3853",
    ST: "NH",
    cityWithStateAbbr: "Mirror Lake, NH",
  },
  {
    zip: "3854",
    ST: "NH",
    cityWithStateAbbr: "New Castle, NH",
  },
  {
    zip: "3855",
    ST: "NH",
    cityWithStateAbbr: "New Durham, NH",
  },
  {
    zip: "3856",
    ST: "NH",
    cityWithStateAbbr: "Newfields, NH",
  },
  {
    zip: "3857",
    ST: "NH",
    cityWithStateAbbr: "Newmarket, NH",
  },
  {
    zip: "3858",
    ST: "NH",
    cityWithStateAbbr: "Newton, NH",
  },
  {
    zip: "3859",
    ST: "NH",
    cityWithStateAbbr: "Newton Junction, NH",
  },
  {
    zip: "3860",
    ST: "NH",
    cityWithStateAbbr: "North Conway, NH",
  },
  {
    zip: "3861",
    ST: "NH",
    cityWithStateAbbr: "Lee, NH",
  },
  {
    zip: "3862",
    ST: "NH",
    cityWithStateAbbr: "North Hampton, NH",
  },
  {
    zip: "3864",
    ST: "NH",
    cityWithStateAbbr: "Ossipee, NH",
  },
  {
    zip: "3865",
    ST: "NH",
    cityWithStateAbbr: "Plaistow, NH",
  },
  {
    zip: "3866",
    ST: "NH",
    cityWithStateAbbr: "Rochester, NH",
  },
  {
    zip: "3867",
    ST: "NH",
    cityWithStateAbbr: "Rochester, NH",
  },
  {
    zip: "3868",
    ST: "NH",
    cityWithStateAbbr: "Rochester, NH",
  },
  {
    zip: "3869",
    ST: "NH",
    cityWithStateAbbr: "Rollinsford, NH",
  },
  {
    zip: "3870",
    ST: "NH",
    cityWithStateAbbr: "Rye, NH",
  },
  {
    zip: "3871",
    ST: "NH",
    cityWithStateAbbr: "Rye Beach, NH",
  },
  {
    zip: "3872",
    ST: "NH",
    cityWithStateAbbr: "Sanbornville, NH",
  },
  {
    zip: "3873",
    ST: "NH",
    cityWithStateAbbr: "Sandown, NH",
  },
  {
    zip: "3874",
    ST: "NH",
    cityWithStateAbbr: "Seabrook, NH",
  },
  {
    zip: "3875",
    ST: "NH",
    cityWithStateAbbr: "Silver Lake, NH",
  },
  {
    zip: "3878",
    ST: "NH",
    cityWithStateAbbr: "Somersworth, NH",
  },
  {
    zip: "3882",
    ST: "NH",
    cityWithStateAbbr: "Effingham, NH",
  },
  {
    zip: "3883",
    ST: "NH",
    cityWithStateAbbr: "South Tamworth, NH",
  },
  {
    zip: "3884",
    ST: "NH",
    cityWithStateAbbr: "Strafford, NH",
  },
  {
    zip: "3885",
    ST: "NH",
    cityWithStateAbbr: "Stratham, NH",
  },
  {
    zip: "3886",
    ST: "NH",
    cityWithStateAbbr: "Tamworth, NH",
  },
  {
    zip: "3887",
    ST: "NH",
    cityWithStateAbbr: "Union, NH",
  },
  {
    zip: "3890",
    ST: "NH",
    cityWithStateAbbr: "West Ossipee, NH",
  },
  {
    zip: "3894",
    ST: "NH",
    cityWithStateAbbr: "Wolfeboro, NH",
  },
  {
    zip: "3896",
    ST: "NH",
    cityWithStateAbbr: "Wolfeboro Falls, NH",
  },
  {
    zip: "3897",
    ST: "NH",
    cityWithStateAbbr: "Wonalancet, NH",
  },
  {
    zip: "3901",
    ST: "ME",
    cityWithStateAbbr: "Berwick, ME",
  },
  {
    zip: "3902",
    ST: "ME",
    cityWithStateAbbr: "Cape Neddick, ME",
  },
  {
    zip: "3903",
    ST: "ME",
    cityWithStateAbbr: "Eliot, ME",
  },
  {
    zip: "3904",
    ST: "ME",
    cityWithStateAbbr: "Kittery, ME",
  },
  {
    zip: "3905",
    ST: "ME",
    cityWithStateAbbr: "Kittery Point, ME",
  },
  {
    zip: "3906",
    ST: "ME",
    cityWithStateAbbr: "North Berwick, ME",
  },
  {
    zip: "3907",
    ST: "ME",
    cityWithStateAbbr: "Ogunquit, ME",
  },
  {
    zip: "3908",
    ST: "ME",
    cityWithStateAbbr: "South Berwick, ME",
  },
  {
    zip: "3909",
    ST: "ME",
    cityWithStateAbbr: "York, ME",
  },
  {
    zip: "3910",
    ST: "ME",
    cityWithStateAbbr: "York Beach, ME",
  },
  {
    zip: "3911",
    ST: "ME",
    cityWithStateAbbr: "York Harbor, ME",
  },
  {
    zip: "4001",
    ST: "ME",
    cityWithStateAbbr: "Acton, ME",
  },
  {
    zip: "4002",
    ST: "ME",
    cityWithStateAbbr: "Alfred, ME",
  },
  {
    zip: "4003",
    ST: "ME",
    cityWithStateAbbr: "Bailey Island, ME",
  },
  {
    zip: "4004",
    ST: "ME",
    cityWithStateAbbr: "Bar Mills, ME",
  },
  {
    zip: "4005",
    ST: "ME",
    cityWithStateAbbr: "Biddeford, ME",
  },
  {
    zip: "4006",
    ST: "ME",
    cityWithStateAbbr: "Biddeford Pool, ME",
  },
  {
    zip: "4007",
    ST: "ME",
    cityWithStateAbbr: "Biddeford, ME",
  },
  {
    zip: "4008",
    ST: "ME",
    cityWithStateAbbr: "Bowdoinham, ME",
  },
  {
    zip: "4009",
    ST: "ME",
    cityWithStateAbbr: "Bridgton, ME",
  },
  {
    zip: "4010",
    ST: "ME",
    cityWithStateAbbr: "Brownfield, ME",
  },
  {
    zip: "4011",
    ST: "ME",
    cityWithStateAbbr: "Brunswick, ME",
  },
  {
    zip: "4013",
    ST: "ME",
    cityWithStateAbbr: "Bustins Island, ME",
  },
  {
    zip: "4014",
    ST: "ME",
    cityWithStateAbbr: "Cape Porpoise, ME",
  },
  {
    zip: "4015",
    ST: "ME",
    cityWithStateAbbr: "Casco, ME",
  },
  {
    zip: "4016",
    ST: "ME",
    cityWithStateAbbr: "Center Lovell, ME",
  },
  {
    zip: "4017",
    ST: "ME",
    cityWithStateAbbr: "Chebeague Island, ME",
  },
  {
    zip: "4019",
    ST: "ME",
    cityWithStateAbbr: "Cliff Island, ME",
  },
  {
    zip: "4020",
    ST: "ME",
    cityWithStateAbbr: "Cornish, ME",
  },
  {
    zip: "4021",
    ST: "ME",
    cityWithStateAbbr: "Cumberland Center, ME",
  },
  {
    zip: "4022",
    ST: "ME",
    cityWithStateAbbr: "Denmark, ME",
  },
  {
    zip: "4024",
    ST: "ME",
    cityWithStateAbbr: "East Baldwin, ME",
  },
  {
    zip: "4027",
    ST: "ME",
    cityWithStateAbbr: "Lebanon, ME",
  },
  {
    zip: "4028",
    ST: "ME",
    cityWithStateAbbr: "East Parsonsfield, ME",
  },
  {
    zip: "4029",
    ST: "ME",
    cityWithStateAbbr: "Sebago, ME",
  },
  {
    zip: "4030",
    ST: "ME",
    cityWithStateAbbr: "East Waterboro, ME",
  },
  {
    zip: "4032",
    ST: "ME",
    cityWithStateAbbr: "Freeport, ME",
  },
  {
    zip: "4033",
    ST: "ME",
    cityWithStateAbbr: "Freeport, ME",
  },
  {
    zip: "4034",
    ST: "ME",
    cityWithStateAbbr: "Freeport, ME",
  },
  {
    zip: "4037",
    ST: "ME",
    cityWithStateAbbr: "Fryeburg, ME",
  },
  {
    zip: "4038",
    ST: "ME",
    cityWithStateAbbr: "Gorham, ME",
  },
  {
    zip: "4039",
    ST: "ME",
    cityWithStateAbbr: "Gray, ME",
  },
  {
    zip: "4040",
    ST: "ME",
    cityWithStateAbbr: "Harrison, ME",
  },
  {
    zip: "4041",
    ST: "ME",
    cityWithStateAbbr: "Hiram, ME",
  },
  {
    zip: "4042",
    ST: "ME",
    cityWithStateAbbr: "Hollis Center, ME",
  },
  {
    zip: "4043",
    ST: "ME",
    cityWithStateAbbr: "Kennebunk, ME",
  },
  {
    zip: "4046",
    ST: "ME",
    cityWithStateAbbr: "Kennebunkport, ME",
  },
  {
    zip: "4047",
    ST: "ME",
    cityWithStateAbbr: "Parsonsfield, ME",
  },
  {
    zip: "4048",
    ST: "ME",
    cityWithStateAbbr: "Limerick, ME",
  },
  {
    zip: "4049",
    ST: "ME",
    cityWithStateAbbr: "Limington, ME",
  },
  {
    zip: "4050",
    ST: "ME",
    cityWithStateAbbr: "Long Island, ME",
  },
  {
    zip: "4051",
    ST: "ME",
    cityWithStateAbbr: "Lovell, ME",
  },
  {
    zip: "4054",
    ST: "ME",
    cityWithStateAbbr: "Moody, ME",
  },
  {
    zip: "4055",
    ST: "ME",
    cityWithStateAbbr: "Naples, ME",
  },
  {
    zip: "4056",
    ST: "ME",
    cityWithStateAbbr: "Newfield, ME",
  },
  {
    zip: "4057",
    ST: "ME",
    cityWithStateAbbr: "North Bridgton, ME",
  },
  {
    zip: "4061",
    ST: "ME",
    cityWithStateAbbr: "North Waterboro, ME",
  },
  {
    zip: "4062",
    ST: "ME",
    cityWithStateAbbr: "Windham, ME",
  },
  {
    zip: "4063",
    ST: "ME",
    cityWithStateAbbr: "Ocean Park, ME",
  },
  {
    zip: "4064",
    ST: "ME",
    cityWithStateAbbr: "Old Orchard Beach, ME",
  },
  {
    zip: "4066",
    ST: "ME",
    cityWithStateAbbr: "Orrs Island, ME",
  },
  {
    zip: "4068",
    ST: "ME",
    cityWithStateAbbr: "Porter, ME",
  },
  {
    zip: "4069",
    ST: "ME",
    cityWithStateAbbr: "Pownal, ME",
  },
  {
    zip: "4070",
    ST: "ME",
    cityWithStateAbbr: "Scarborough, ME",
  },
  {
    zip: "4071",
    ST: "ME",
    cityWithStateAbbr: "Raymond, ME",
  },
  {
    zip: "4072",
    ST: "ME",
    cityWithStateAbbr: "Saco, ME",
  },
  {
    zip: "4073",
    ST: "ME",
    cityWithStateAbbr: "Sanford, ME",
  },
  {
    zip: "4074",
    ST: "ME",
    cityWithStateAbbr: "Scarborough, ME",
  },
  {
    zip: "4076",
    ST: "ME",
    cityWithStateAbbr: "Shapleigh, ME",
  },
  {
    zip: "4077",
    ST: "ME",
    cityWithStateAbbr: "South Casco, ME",
  },
  {
    zip: "4078",
    ST: "ME",
    cityWithStateAbbr: "South Freeport, ME",
  },
  {
    zip: "4079",
    ST: "ME",
    cityWithStateAbbr: "Harpswell, ME",
  },
  {
    zip: "4082",
    ST: "ME",
    cityWithStateAbbr: "South Windham, ME",
  },
  {
    zip: "4083",
    ST: "ME",
    cityWithStateAbbr: "Springvale, ME",
  },
  {
    zip: "4084",
    ST: "ME",
    cityWithStateAbbr: "Standish, ME",
  },
  {
    zip: "4085",
    ST: "ME",
    cityWithStateAbbr: "Steep Falls, ME",
  },
  {
    zip: "4086",
    ST: "ME",
    cityWithStateAbbr: "Topsham, ME",
  },
  {
    zip: "4087",
    ST: "ME",
    cityWithStateAbbr: "Waterboro, ME",
  },
  {
    zip: "4088",
    ST: "ME",
    cityWithStateAbbr: "Waterford, ME",
  },
  {
    zip: "4090",
    ST: "ME",
    cityWithStateAbbr: "Wells, ME",
  },
  {
    zip: "4091",
    ST: "ME",
    cityWithStateAbbr: "West Baldwin, ME",
  },
  {
    zip: "4092",
    ST: "ME",
    cityWithStateAbbr: "Westbrook, ME",
  },
  {
    zip: "4093",
    ST: "ME",
    cityWithStateAbbr: "Buxton, ME",
  },
  {
    zip: "4094",
    ST: "ME",
    cityWithStateAbbr: "West Kennebunk, ME",
  },
  {
    zip: "4095",
    ST: "ME",
    cityWithStateAbbr: "West Newfield, ME",
  },
  {
    zip: "4096",
    ST: "ME",
    cityWithStateAbbr: "Yarmouth, ME",
  },
  {
    zip: "4097",
    ST: "ME",
    cityWithStateAbbr: "North Yarmouth, ME",
  },
  {
    zip: "4098",
    ST: "ME",
    cityWithStateAbbr: "Westbrook, ME",
  },
  {
    zip: "4101",
    ST: "ME",
    cityWithStateAbbr: "Portland, ME",
  },
  {
    zip: "4102",
    ST: "ME",
    cityWithStateAbbr: "Portland, ME",
  },
  {
    zip: "4103",
    ST: "ME",
    cityWithStateAbbr: "Portland, ME",
  },
  {
    zip: "4104",
    ST: "ME",
    cityWithStateAbbr: "Portland, ME",
  },
  {
    zip: "4105",
    ST: "ME",
    cityWithStateAbbr: "Falmouth, ME",
  },
  {
    zip: "4106",
    ST: "ME",
    cityWithStateAbbr: "South Portland, ME",
  },
  {
    zip: "4107",
    ST: "ME",
    cityWithStateAbbr: "Cape Elizabeth, ME",
  },
  {
    zip: "4108",
    ST: "ME",
    cityWithStateAbbr: "Peaks Island, ME",
  },
  {
    zip: "4109",
    ST: "ME",
    cityWithStateAbbr: "Portland, ME",
  },
  {
    zip: "4110",
    ST: "ME",
    cityWithStateAbbr: "Cumberland Foreside, ME",
  },
  {
    zip: "4112",
    ST: "ME",
    cityWithStateAbbr: "Portland, ME",
  },
  {
    zip: "4116",
    ST: "ME",
    cityWithStateAbbr: "South Portland, ME",
  },
  {
    zip: "4122",
    ST: "ME",
    cityWithStateAbbr: "Portland, ME",
  },
  {
    zip: "4123",
    ST: "ME",
    cityWithStateAbbr: "Portland, ME",
  },
  {
    zip: "4124",
    ST: "ME",
    cityWithStateAbbr: "Portland, ME",
  },
  {
    zip: "4210",
    ST: "ME",
    cityWithStateAbbr: "Auburn, ME",
  },
  {
    zip: "4211",
    ST: "ME",
    cityWithStateAbbr: "Auburn, ME",
  },
  {
    zip: "4212",
    ST: "ME",
    cityWithStateAbbr: "Auburn, ME",
  },
  {
    zip: "4216",
    ST: "ME",
    cityWithStateAbbr: "Andover, ME",
  },
  {
    zip: "4217",
    ST: "ME",
    cityWithStateAbbr: "Bethel, ME",
  },
  {
    zip: "4219",
    ST: "ME",
    cityWithStateAbbr: "Bryant Pond, ME",
  },
  {
    zip: "4220",
    ST: "ME",
    cityWithStateAbbr: "Buckfield, ME",
  },
  {
    zip: "4221",
    ST: "ME",
    cityWithStateAbbr: "Canton, ME",
  },
  {
    zip: "4222",
    ST: "ME",
    cityWithStateAbbr: "Durham, ME",
  },
  {
    zip: "4223",
    ST: "ME",
    cityWithStateAbbr: "Danville, ME",
  },
  {
    zip: "4224",
    ST: "ME",
    cityWithStateAbbr: "Dixfield, ME",
  },
  {
    zip: "4225",
    ST: "ME",
    cityWithStateAbbr: "Dryden, ME",
  },
  {
    zip: "4226",
    ST: "ME",
    cityWithStateAbbr: "East Andover, ME",
  },
  {
    zip: "4227",
    ST: "ME",
    cityWithStateAbbr: "East Dixfield, ME",
  },
  {
    zip: "4228",
    ST: "ME",
    cityWithStateAbbr: "East Livermore, ME",
  },
  {
    zip: "4230",
    ST: "ME",
    cityWithStateAbbr: "East Poland, ME",
  },
  {
    zip: "4231",
    ST: "ME",
    cityWithStateAbbr: "Stoneham, ME",
  },
  {
    zip: "4234",
    ST: "ME",
    cityWithStateAbbr: "East Wilton, ME",
  },
  {
    zip: "4236",
    ST: "ME",
    cityWithStateAbbr: "Greene, ME",
  },
  {
    zip: "4237",
    ST: "ME",
    cityWithStateAbbr: "Hanover, ME",
  },
  {
    zip: "4238",
    ST: "ME",
    cityWithStateAbbr: "Hebron, ME",
  },
  {
    zip: "4239",
    ST: "ME",
    cityWithStateAbbr: "Jay, ME",
  },
  {
    zip: "4240",
    ST: "ME",
    cityWithStateAbbr: "Lewiston, ME",
  },
  {
    zip: "4241",
    ST: "ME",
    cityWithStateAbbr: "Lewiston, ME",
  },
  {
    zip: "4243",
    ST: "ME",
    cityWithStateAbbr: "Lewiston, ME",
  },
  {
    zip: "4250",
    ST: "ME",
    cityWithStateAbbr: "Lisbon, ME",
  },
  {
    zip: "4252",
    ST: "ME",
    cityWithStateAbbr: "Lisbon Falls, ME",
  },
  {
    zip: "4253",
    ST: "ME",
    cityWithStateAbbr: "Livermore, ME",
  },
  {
    zip: "4254",
    ST: "ME",
    cityWithStateAbbr: "Livermore Falls, ME",
  },
  {
    zip: "4255",
    ST: "ME",
    cityWithStateAbbr: "Greenwood, ME",
  },
  {
    zip: "4256",
    ST: "ME",
    cityWithStateAbbr: "Mechanic Falls, ME",
  },
  {
    zip: "4257",
    ST: "ME",
    cityWithStateAbbr: "Mexico, ME",
  },
  {
    zip: "4258",
    ST: "ME",
    cityWithStateAbbr: "Minot, ME",
  },
  {
    zip: "4259",
    ST: "ME",
    cityWithStateAbbr: "Monmouth, ME",
  },
  {
    zip: "4260",
    ST: "ME",
    cityWithStateAbbr: "New Gloucester, ME",
  },
  {
    zip: "4261",
    ST: "ME",
    cityWithStateAbbr: "Newry, ME",
  },
  {
    zip: "4262",
    ST: "ME",
    cityWithStateAbbr: "North Jay, ME",
  },
  {
    zip: "4263",
    ST: "ME",
    cityWithStateAbbr: "Leeds, ME",
  },
  {
    zip: "4265",
    ST: "ME",
    cityWithStateAbbr: "North Monmouth, ME",
  },
  {
    zip: "4266",
    ST: "ME",
    cityWithStateAbbr: "North Turner, ME",
  },
  {
    zip: "4267",
    ST: "ME",
    cityWithStateAbbr: "North Waterford, ME",
  },
  {
    zip: "4268",
    ST: "ME",
    cityWithStateAbbr: "Norway, ME",
  },
  {
    zip: "4270",
    ST: "ME",
    cityWithStateAbbr: "Oxford, ME",
  },
  {
    zip: "4271",
    ST: "ME",
    cityWithStateAbbr: "Paris, ME",
  },
  {
    zip: "4274",
    ST: "ME",
    cityWithStateAbbr: "Poland, ME",
  },
  {
    zip: "4275",
    ST: "ME",
    cityWithStateAbbr: "Roxbury, ME",
  },
  {
    zip: "4276",
    ST: "ME",
    cityWithStateAbbr: "Rumford, ME",
  },
  {
    zip: "4280",
    ST: "ME",
    cityWithStateAbbr: "Sabattus, ME",
  },
  {
    zip: "4281",
    ST: "ME",
    cityWithStateAbbr: "South Paris, ME",
  },
  {
    zip: "4282",
    ST: "ME",
    cityWithStateAbbr: "Turner, ME",
  },
  {
    zip: "4284",
    ST: "ME",
    cityWithStateAbbr: "Wayne, ME",
  },
  {
    zip: "4285",
    ST: "ME",
    cityWithStateAbbr: "Weld, ME",
  },
  {
    zip: "4286",
    ST: "ME",
    cityWithStateAbbr: "West Bethel, ME",
  },
  {
    zip: "4287",
    ST: "ME",
    cityWithStateAbbr: "Bowdoin, ME",
  },
  {
    zip: "4288",
    ST: "ME",
    cityWithStateAbbr: "West Minot, ME",
  },
  {
    zip: "4289",
    ST: "ME",
    cityWithStateAbbr: "West Paris, ME",
  },
  {
    zip: "4290",
    ST: "ME",
    cityWithStateAbbr: "Peru, ME",
  },
  {
    zip: "4291",
    ST: "ME",
    cityWithStateAbbr: "West Poland, ME",
  },
  {
    zip: "4292",
    ST: "ME",
    cityWithStateAbbr: "Sumner, ME",
  },
  {
    zip: "4294",
    ST: "ME",
    cityWithStateAbbr: "Wilton, ME",
  },
  {
    zip: "4330",
    ST: "ME",
    cityWithStateAbbr: "Augusta, ME",
  },
  {
    zip: "4332",
    ST: "ME",
    cityWithStateAbbr: "Augusta, ME",
  },
  {
    zip: "4333",
    ST: "ME",
    cityWithStateAbbr: "Augusta, ME",
  },
  {
    zip: "4336",
    ST: "ME",
    cityWithStateAbbr: "Augusta, ME",
  },
  {
    zip: "4338",
    ST: "ME",
    cityWithStateAbbr: "Augusta, ME",
  },
  {
    zip: "4341",
    ST: "ME",
    cityWithStateAbbr: "Coopers Mills, ME",
  },
  {
    zip: "4342",
    ST: "ME",
    cityWithStateAbbr: "Dresden, ME",
  },
  {
    zip: "4343",
    ST: "ME",
    cityWithStateAbbr: "East Winthrop, ME",
  },
  {
    zip: "4344",
    ST: "ME",
    cityWithStateAbbr: "Farmingdale, ME",
  },
  {
    zip: "4345",
    ST: "ME",
    cityWithStateAbbr: "Gardiner, ME",
  },
  {
    zip: "4346",
    ST: "ME",
    cityWithStateAbbr: "Randolph, ME",
  },
  {
    zip: "4347",
    ST: "ME",
    cityWithStateAbbr: "Hallowell, ME",
  },
  {
    zip: "4348",
    ST: "ME",
    cityWithStateAbbr: "Jefferson, ME",
  },
  {
    zip: "4349",
    ST: "ME",
    cityWithStateAbbr: "Kents Hill, ME",
  },
  {
    zip: "4350",
    ST: "ME",
    cityWithStateAbbr: "Litchfield, ME",
  },
  {
    zip: "4351",
    ST: "ME",
    cityWithStateAbbr: "Manchester, ME",
  },
  {
    zip: "4352",
    ST: "ME",
    cityWithStateAbbr: "Mount Vernon, ME",
  },
  {
    zip: "4353",
    ST: "ME",
    cityWithStateAbbr: "Whitefield, ME",
  },
  {
    zip: "4354",
    ST: "ME",
    cityWithStateAbbr: "Palermo, ME",
  },
  {
    zip: "4355",
    ST: "ME",
    cityWithStateAbbr: "Readfield, ME",
  },
  {
    zip: "4357",
    ST: "ME",
    cityWithStateAbbr: "Richmond, ME",
  },
  {
    zip: "4358",
    ST: "ME",
    cityWithStateAbbr: "South China, ME",
  },
  {
    zip: "4359",
    ST: "ME",
    cityWithStateAbbr: "South Gardiner, ME",
  },
  {
    zip: "4360",
    ST: "ME",
    cityWithStateAbbr: "Vienna, ME",
  },
  {
    zip: "4363",
    ST: "ME",
    cityWithStateAbbr: "Windsor, ME",
  },
  {
    zip: "4364",
    ST: "ME",
    cityWithStateAbbr: "Winthrop, ME",
  },
  {
    zip: "4401",
    ST: "ME",
    cityWithStateAbbr: "Bangor, ME",
  },
  {
    zip: "4402",
    ST: "ME",
    cityWithStateAbbr: "Bangor, ME",
  },
  {
    zip: "4406",
    ST: "ME",
    cityWithStateAbbr: "Abbot, ME",
  },
  {
    zip: "4408",
    ST: "ME",
    cityWithStateAbbr: "Aurora, ME",
  },
  {
    zip: "4410",
    ST: "ME",
    cityWithStateAbbr: "Bradford, ME",
  },
  {
    zip: "4411",
    ST: "ME",
    cityWithStateAbbr: "Bradley, ME",
  },
  {
    zip: "4412",
    ST: "ME",
    cityWithStateAbbr: "Brewer, ME",
  },
  {
    zip: "4413",
    ST: "ME",
    cityWithStateAbbr: "Brookton, ME",
  },
  {
    zip: "4414",
    ST: "ME",
    cityWithStateAbbr: "Brownville, ME",
  },
  {
    zip: "4415",
    ST: "ME",
    cityWithStateAbbr: "Brownville Junction, ME",
  },
  {
    zip: "4416",
    ST: "ME",
    cityWithStateAbbr: "Bucksport, ME",
  },
  {
    zip: "4417",
    ST: "ME",
    cityWithStateAbbr: "Burlington, ME",
  },
  {
    zip: "4418",
    ST: "ME",
    cityWithStateAbbr: "Greenbush, ME",
  },
  {
    zip: "4419",
    ST: "ME",
    cityWithStateAbbr: "Carmel, ME",
  },
  {
    zip: "4420",
    ST: "ME",
    cityWithStateAbbr: "Castine, ME",
  },
  {
    zip: "4421",
    ST: "ME",
    cityWithStateAbbr: "Castine, ME",
  },
  {
    zip: "4422",
    ST: "ME",
    cityWithStateAbbr: "Charleston, ME",
  },
  {
    zip: "4424",
    ST: "ME",
    cityWithStateAbbr: "Danforth, ME",
  },
  {
    zip: "4426",
    ST: "ME",
    cityWithStateAbbr: "Dover Foxcroft, ME",
  },
  {
    zip: "4427",
    ST: "ME",
    cityWithStateAbbr: "Corinth, ME",
  },
  {
    zip: "4428",
    ST: "ME",
    cityWithStateAbbr: "Eddington, ME",
  },
  {
    zip: "4429",
    ST: "ME",
    cityWithStateAbbr: "Holden, ME",
  },
  {
    zip: "4430",
    ST: "ME",
    cityWithStateAbbr: "East Millinocket, ME",
  },
  {
    zip: "4431",
    ST: "ME",
    cityWithStateAbbr: "East Orland, ME",
  },
  {
    zip: "4434",
    ST: "ME",
    cityWithStateAbbr: "Etna, ME",
  },
  {
    zip: "4435",
    ST: "ME",
    cityWithStateAbbr: "Exeter, ME",
  },
  {
    zip: "4438",
    ST: "ME",
    cityWithStateAbbr: "Frankfort, ME",
  },
  {
    zip: "4441",
    ST: "ME",
    cityWithStateAbbr: "Greenville, ME",
  },
  {
    zip: "4442",
    ST: "ME",
    cityWithStateAbbr: "Greenville Junction, ME",
  },
  {
    zip: "4443",
    ST: "ME",
    cityWithStateAbbr: "Guilford, ME",
  },
  {
    zip: "4444",
    ST: "ME",
    cityWithStateAbbr: "Hampden, ME",
  },
  {
    zip: "4448",
    ST: "ME",
    cityWithStateAbbr: "Howland, ME",
  },
  {
    zip: "4449",
    ST: "ME",
    cityWithStateAbbr: "Hudson, ME",
  },
  {
    zip: "4450",
    ST: "ME",
    cityWithStateAbbr: "Kenduskeag, ME",
  },
  {
    zip: "4451",
    ST: "ME",
    cityWithStateAbbr: "Kingman, ME",
  },
  {
    zip: "4453",
    ST: "ME",
    cityWithStateAbbr: "Lagrange, ME",
  },
  {
    zip: "4454",
    ST: "ME",
    cityWithStateAbbr: "Lambert Lake, ME",
  },
  {
    zip: "4455",
    ST: "ME",
    cityWithStateAbbr: "Lee, ME",
  },
  {
    zip: "4456",
    ST: "ME",
    cityWithStateAbbr: "Levant, ME",
  },
  {
    zip: "4457",
    ST: "ME",
    cityWithStateAbbr: "Lincoln, ME",
  },
  {
    zip: "4459",
    ST: "ME",
    cityWithStateAbbr: "Mattawamkeag, ME",
  },
  {
    zip: "4460",
    ST: "ME",
    cityWithStateAbbr: "Medway, ME",
  },
  {
    zip: "4461",
    ST: "ME",
    cityWithStateAbbr: "Milford, ME",
  },
  {
    zip: "4462",
    ST: "ME",
    cityWithStateAbbr: "Millinocket, ME",
  },
  {
    zip: "4463",
    ST: "ME",
    cityWithStateAbbr: "Milo, ME",
  },
  {
    zip: "4464",
    ST: "ME",
    cityWithStateAbbr: "Monson, ME",
  },
  {
    zip: "4468",
    ST: "ME",
    cityWithStateAbbr: "Old Town, ME",
  },
  {
    zip: "4469",
    ST: "ME",
    cityWithStateAbbr: "Orono, ME",
  },
  {
    zip: "4471",
    ST: "ME",
    cityWithStateAbbr: "Orient, ME",
  },
  {
    zip: "4472",
    ST: "ME",
    cityWithStateAbbr: "Orland, ME",
  },
  {
    zip: "4473",
    ST: "ME",
    cityWithStateAbbr: "Orono, ME",
  },
  {
    zip: "4474",
    ST: "ME",
    cityWithStateAbbr: "Orrington, ME",
  },
  {
    zip: "4475",
    ST: "ME",
    cityWithStateAbbr: "Passadumkeag, ME",
  },
  {
    zip: "4476",
    ST: "ME",
    cityWithStateAbbr: "Penobscot, ME",
  },
  {
    zip: "4478",
    ST: "ME",
    cityWithStateAbbr: "Rockwood, ME",
  },
  {
    zip: "4479",
    ST: "ME",
    cityWithStateAbbr: "Sangerville, ME",
  },
  {
    zip: "4481",
    ST: "ME",
    cityWithStateAbbr: "Sebec, ME",
  },
  {
    zip: "4485",
    ST: "ME",
    cityWithStateAbbr: "Shirley Mills, ME",
  },
  {
    zip: "4487",
    ST: "ME",
    cityWithStateAbbr: "Springfield, ME",
  },
  {
    zip: "4488",
    ST: "ME",
    cityWithStateAbbr: "Stetson, ME",
  },
  {
    zip: "4489",
    ST: "ME",
    cityWithStateAbbr: "Stillwater, ME",
  },
  {
    zip: "4490",
    ST: "ME",
    cityWithStateAbbr: "Topsfield, ME",
  },
  {
    zip: "4491",
    ST: "ME",
    cityWithStateAbbr: "Vanceboro, ME",
  },
  {
    zip: "4492",
    ST: "ME",
    cityWithStateAbbr: "Waite, ME",
  },
  {
    zip: "4493",
    ST: "ME",
    cityWithStateAbbr: "West Enfield, ME",
  },
  {
    zip: "4495",
    ST: "ME",
    cityWithStateAbbr: "Winn, ME",
  },
  {
    zip: "4496",
    ST: "ME",
    cityWithStateAbbr: "Winterport, ME",
  },
  {
    zip: "4497",
    ST: "ME",
    cityWithStateAbbr: "Wytopitlock, ME",
  },
  {
    zip: "4530",
    ST: "ME",
    cityWithStateAbbr: "Bath, ME",
  },
  {
    zip: "4535",
    ST: "ME",
    cityWithStateAbbr: "Alna, ME",
  },
  {
    zip: "4537",
    ST: "ME",
    cityWithStateAbbr: "Boothbay, ME",
  },
  {
    zip: "4538",
    ST: "ME",
    cityWithStateAbbr: "Boothbay Harbor, ME",
  },
  {
    zip: "4539",
    ST: "ME",
    cityWithStateAbbr: "Bristol, ME",
  },
  {
    zip: "4541",
    ST: "ME",
    cityWithStateAbbr: "Chamberlain, ME",
  },
  {
    zip: "4543",
    ST: "ME",
    cityWithStateAbbr: "Damariscotta, ME",
  },
  {
    zip: "4544",
    ST: "ME",
    cityWithStateAbbr: "East Boothbay, ME",
  },
  {
    zip: "4547",
    ST: "ME",
    cityWithStateAbbr: "Friendship, ME",
  },
  {
    zip: "4548",
    ST: "ME",
    cityWithStateAbbr: "Georgetown, ME",
  },
  {
    zip: "4549",
    ST: "ME",
    cityWithStateAbbr: "Isle Of Springs, ME",
  },
  {
    zip: "4551",
    ST: "ME",
    cityWithStateAbbr: "Bremen, ME",
  },
  {
    zip: "4553",
    ST: "ME",
    cityWithStateAbbr: "Newcastle, ME",
  },
  {
    zip: "4554",
    ST: "ME",
    cityWithStateAbbr: "New Harbor, ME",
  },
  {
    zip: "4555",
    ST: "ME",
    cityWithStateAbbr: "Nobleboro, ME",
  },
  {
    zip: "4556",
    ST: "ME",
    cityWithStateAbbr: "Edgecomb, ME",
  },
  {
    zip: "4558",
    ST: "ME",
    cityWithStateAbbr: "Pemaquid, ME",
  },
  {
    zip: "4562",
    ST: "ME",
    cityWithStateAbbr: "Phippsburg, ME",
  },
  {
    zip: "4563",
    ST: "ME",
    cityWithStateAbbr: "Cushing, ME",
  },
  {
    zip: "4564",
    ST: "ME",
    cityWithStateAbbr: "Round Pond, ME",
  },
  {
    zip: "4565",
    ST: "ME",
    cityWithStateAbbr: "Sebasco Estates, ME",
  },
  {
    zip: "4568",
    ST: "ME",
    cityWithStateAbbr: "South Bristol, ME",
  },
  {
    zip: "4570",
    ST: "ME",
    cityWithStateAbbr: "Squirrel Island, ME",
  },
  {
    zip: "4571",
    ST: "ME",
    cityWithStateAbbr: "Trevett, ME",
  },
  {
    zip: "4572",
    ST: "ME",
    cityWithStateAbbr: "Waldoboro, ME",
  },
  {
    zip: "4573",
    ST: "ME",
    cityWithStateAbbr: "Walpole, ME",
  },
  {
    zip: "4574",
    ST: "ME",
    cityWithStateAbbr: "Washington, ME",
  },
  {
    zip: "4575",
    ST: "ME",
    cityWithStateAbbr: "West Boothbay Harbor, ME",
  },
  {
    zip: "4576",
    ST: "ME",
    cityWithStateAbbr: "Southport, ME",
  },
  {
    zip: "4578",
    ST: "ME",
    cityWithStateAbbr: "Wiscasset, ME",
  },
  {
    zip: "4579",
    ST: "ME",
    cityWithStateAbbr: "Woolwich, ME",
  },
  {
    zip: "4605",
    ST: "ME",
    cityWithStateAbbr: "Ellsworth, ME",
  },
  {
    zip: "4606",
    ST: "ME",
    cityWithStateAbbr: "Addison, ME",
  },
  {
    zip: "4607",
    ST: "ME",
    cityWithStateAbbr: "Gouldsboro, ME",
  },
  {
    zip: "4609",
    ST: "ME",
    cityWithStateAbbr: "Bar Harbor, ME",
  },
  {
    zip: "4611",
    ST: "ME",
    cityWithStateAbbr: "Beals, ME",
  },
  {
    zip: "4612",
    ST: "ME",
    cityWithStateAbbr: "Bernard, ME",
  },
  {
    zip: "4613",
    ST: "ME",
    cityWithStateAbbr: "Birch Harbor, ME",
  },
  {
    zip: "4614",
    ST: "ME",
    cityWithStateAbbr: "Blue Hill, ME",
  },
  {
    zip: "4616",
    ST: "ME",
    cityWithStateAbbr: "Brooklin, ME",
  },
  {
    zip: "4617",
    ST: "ME",
    cityWithStateAbbr: "Brooksville, ME",
  },
  {
    zip: "4619",
    ST: "ME",
    cityWithStateAbbr: "Calais, ME",
  },
  {
    zip: "4622",
    ST: "ME",
    cityWithStateAbbr: "Cherryfield, ME",
  },
  {
    zip: "4623",
    ST: "ME",
    cityWithStateAbbr: "Columbia Falls, ME",
  },
  {
    zip: "4624",
    ST: "ME",
    cityWithStateAbbr: "Corea, ME",
  },
  {
    zip: "4625",
    ST: "ME",
    cityWithStateAbbr: "Cranberry Isles, ME",
  },
  {
    zip: "4626",
    ST: "ME",
    cityWithStateAbbr: "Cutler, ME",
  },
  {
    zip: "4627",
    ST: "ME",
    cityWithStateAbbr: "Deer Isle, ME",
  },
  {
    zip: "4628",
    ST: "ME",
    cityWithStateAbbr: "Dennysville, ME",
  },
  {
    zip: "4629",
    ST: "ME",
    cityWithStateAbbr: "East Blue Hill, ME",
  },
  {
    zip: "4630",
    ST: "ME",
    cityWithStateAbbr: "East Machias, ME",
  },
  {
    zip: "4631",
    ST: "ME",
    cityWithStateAbbr: "Eastport, ME",
  },
  {
    zip: "4634",
    ST: "ME",
    cityWithStateAbbr: "Franklin, ME",
  },
  {
    zip: "4635",
    ST: "ME",
    cityWithStateAbbr: "Frenchboro, ME",
  },
  {
    zip: "4637",
    ST: "ME",
    cityWithStateAbbr: "Grand Lake Stream, ME",
  },
  {
    zip: "4640",
    ST: "ME",
    cityWithStateAbbr: "Hancock, ME",
  },
  {
    zip: "4642",
    ST: "ME",
    cityWithStateAbbr: "Harborside, ME",
  },
  {
    zip: "4643",
    ST: "ME",
    cityWithStateAbbr: "Harrington, ME",
  },
  {
    zip: "4644",
    ST: "ME",
    cityWithStateAbbr: "Hulls Cove, ME",
  },
  {
    zip: "4645",
    ST: "ME",
    cityWithStateAbbr: "Isle Au Haut, ME",
  },
  {
    zip: "4646",
    ST: "ME",
    cityWithStateAbbr: "Islesford, ME",
  },
  {
    zip: "4648",
    ST: "ME",
    cityWithStateAbbr: "Jonesboro, ME",
  },
  {
    zip: "4649",
    ST: "ME",
    cityWithStateAbbr: "Jonesport, ME",
  },
  {
    zip: "4650",
    ST: "ME",
    cityWithStateAbbr: "Little Deer Isle, ME",
  },
  {
    zip: "4652",
    ST: "ME",
    cityWithStateAbbr: "Lubec, ME",
  },
  {
    zip: "4653",
    ST: "ME",
    cityWithStateAbbr: "Bass Harbor, ME",
  },
  {
    zip: "4654",
    ST: "ME",
    cityWithStateAbbr: "Machias, ME",
  },
  {
    zip: "4655",
    ST: "ME",
    cityWithStateAbbr: "Machiasport, ME",
  },
  {
    zip: "4657",
    ST: "ME",
    cityWithStateAbbr: "Meddybemps, ME",
  },
  {
    zip: "4658",
    ST: "ME",
    cityWithStateAbbr: "Milbridge, ME",
  },
  {
    zip: "4660",
    ST: "ME",
    cityWithStateAbbr: "Mount Desert, ME",
  },
  {
    zip: "4662",
    ST: "ME",
    cityWithStateAbbr: "Northeast Harbor, ME",
  },
  {
    zip: "4664",
    ST: "ME",
    cityWithStateAbbr: "Sullivan, ME",
  },
  {
    zip: "4666",
    ST: "ME",
    cityWithStateAbbr: "Pembroke, ME",
  },
  {
    zip: "4667",
    ST: "ME",
    cityWithStateAbbr: "Perry, ME",
  },
  {
    zip: "4668",
    ST: "ME",
    cityWithStateAbbr: "Princeton, ME",
  },
  {
    zip: "4669",
    ST: "ME",
    cityWithStateAbbr: "Prospect Harbor, ME",
  },
  {
    zip: "4671",
    ST: "ME",
    cityWithStateAbbr: "Robbinston, ME",
  },
  {
    zip: "4672",
    ST: "ME",
    cityWithStateAbbr: "Salsbury Cove, ME",
  },
  {
    zip: "4673",
    ST: "ME",
    cityWithStateAbbr: "Sargentville, ME",
  },
  {
    zip: "4674",
    ST: "ME",
    cityWithStateAbbr: "Seal Cove, ME",
  },
  {
    zip: "4675",
    ST: "ME",
    cityWithStateAbbr: "Seal Harbor, ME",
  },
  {
    zip: "4676",
    ST: "ME",
    cityWithStateAbbr: "Sedgwick, ME",
  },
  {
    zip: "4677",
    ST: "ME",
    cityWithStateAbbr: "Sorrento, ME",
  },
  {
    zip: "4679",
    ST: "ME",
    cityWithStateAbbr: "Southwest Harbor, ME",
  },
  {
    zip: "4680",
    ST: "ME",
    cityWithStateAbbr: "Steuben, ME",
  },
  {
    zip: "4681",
    ST: "ME",
    cityWithStateAbbr: "Stonington, ME",
  },
  {
    zip: "4683",
    ST: "ME",
    cityWithStateAbbr: "Sunset, ME",
  },
  {
    zip: "4684",
    ST: "ME",
    cityWithStateAbbr: "Surry, ME",
  },
  {
    zip: "4685",
    ST: "ME",
    cityWithStateAbbr: "Swans Island, ME",
  },
  {
    zip: "4686",
    ST: "ME",
    cityWithStateAbbr: "Wesley, ME",
  },
  {
    zip: "4691",
    ST: "ME",
    cityWithStateAbbr: "Whiting, ME",
  },
  {
    zip: "4693",
    ST: "ME",
    cityWithStateAbbr: "Winter Harbor, ME",
  },
  {
    zip: "4694",
    ST: "ME",
    cityWithStateAbbr: "Baileyville, ME",
  },
  {
    zip: "4730",
    ST: "ME",
    cityWithStateAbbr: "Houlton, ME",
  },
  {
    zip: "4732",
    ST: "ME",
    cityWithStateAbbr: "Ashland, ME",
  },
  {
    zip: "4733",
    ST: "ME",
    cityWithStateAbbr: "Benedicta, ME",
  },
  {
    zip: "4734",
    ST: "ME",
    cityWithStateAbbr: "Blaine, ME",
  },
  {
    zip: "4735",
    ST: "ME",
    cityWithStateAbbr: "Bridgewater, ME",
  },
  {
    zip: "4736",
    ST: "ME",
    cityWithStateAbbr: "Caribou, ME",
  },
  {
    zip: "4737",
    ST: "ME",
    cityWithStateAbbr: "Clayton Lake, ME",
  },
  {
    zip: "4738",
    ST: "ME",
    cityWithStateAbbr: "Crouseville, ME",
  },
  {
    zip: "4739",
    ST: "ME",
    cityWithStateAbbr: "Eagle Lake, ME",
  },
  {
    zip: "4740",
    ST: "ME",
    cityWithStateAbbr: "Easton, ME",
  },
  {
    zip: "4741",
    ST: "ME",
    cityWithStateAbbr: "Estcourt Station, ME",
  },
  {
    zip: "4742",
    ST: "ME",
    cityWithStateAbbr: "Fort Fairfield, ME",
  },
  {
    zip: "4743",
    ST: "ME",
    cityWithStateAbbr: "Fort Kent, ME",
  },
  {
    zip: "4744",
    ST: "ME",
    cityWithStateAbbr: "Fort Kent Mills, ME",
  },
  {
    zip: "4745",
    ST: "ME",
    cityWithStateAbbr: "Frenchville, ME",
  },
  {
    zip: "4746",
    ST: "ME",
    cityWithStateAbbr: "Grand Isle, ME",
  },
  {
    zip: "4747",
    ST: "ME",
    cityWithStateAbbr: "Island Falls, ME",
  },
  {
    zip: "4750",
    ST: "ME",
    cityWithStateAbbr: "Limestone, ME",
  },
  {
    zip: "4751",
    ST: "ME",
    cityWithStateAbbr: "Limestone, ME",
  },
  {
    zip: "4756",
    ST: "ME",
    cityWithStateAbbr: "Madawaska, ME",
  },
  {
    zip: "4757",
    ST: "ME",
    cityWithStateAbbr: "Mapleton, ME",
  },
  {
    zip: "4758",
    ST: "ME",
    cityWithStateAbbr: "Mars Hill, ME",
  },
  {
    zip: "4760",
    ST: "ME",
    cityWithStateAbbr: "Monticello, ME",
  },
  {
    zip: "4761",
    ST: "ME",
    cityWithStateAbbr: "New Limerick, ME",
  },
  {
    zip: "4762",
    ST: "ME",
    cityWithStateAbbr: "New Sweden, ME",
  },
  {
    zip: "4763",
    ST: "ME",
    cityWithStateAbbr: "Oakfield, ME",
  },
  {
    zip: "4764",
    ST: "ME",
    cityWithStateAbbr: "Oxbow, ME",
  },
  {
    zip: "4765",
    ST: "ME",
    cityWithStateAbbr: "Patten, ME",
  },
  {
    zip: "4766",
    ST: "ME",
    cityWithStateAbbr: "Perham, ME",
  },
  {
    zip: "4768",
    ST: "ME",
    cityWithStateAbbr: "Portage, ME",
  },
  {
    zip: "4769",
    ST: "ME",
    cityWithStateAbbr: "Presque Isle, ME",
  },
  {
    zip: "4772",
    ST: "ME",
    cityWithStateAbbr: "Saint Agatha, ME",
  },
  {
    zip: "4773",
    ST: "ME",
    cityWithStateAbbr: "Saint David, ME",
  },
  {
    zip: "4774",
    ST: "ME",
    cityWithStateAbbr: "Saint Francis, ME",
  },
  {
    zip: "4775",
    ST: "ME",
    cityWithStateAbbr: "Sheridan, ME",
  },
  {
    zip: "4776",
    ST: "ME",
    cityWithStateAbbr: "Sherman, ME",
  },
  {
    zip: "4777",
    ST: "ME",
    cityWithStateAbbr: "Stacyville, ME",
  },
  {
    zip: "4779",
    ST: "ME",
    cityWithStateAbbr: "Sinclair, ME",
  },
  {
    zip: "4780",
    ST: "ME",
    cityWithStateAbbr: "Smyrna Mills, ME",
  },
  {
    zip: "4781",
    ST: "ME",
    cityWithStateAbbr: "Wallagrass, ME",
  },
  {
    zip: "4783",
    ST: "ME",
    cityWithStateAbbr: "Stockholm, ME",
  },
  {
    zip: "4785",
    ST: "ME",
    cityWithStateAbbr: "Van Buren, ME",
  },
  {
    zip: "4786",
    ST: "ME",
    cityWithStateAbbr: "Washburn, ME",
  },
  {
    zip: "4787",
    ST: "ME",
    cityWithStateAbbr: "Westfield, ME",
  },
  {
    zip: "4841",
    ST: "ME",
    cityWithStateAbbr: "Rockland, ME",
  },
  {
    zip: "4843",
    ST: "ME",
    cityWithStateAbbr: "Camden, ME",
  },
  {
    zip: "4846",
    ST: "ME",
    cityWithStateAbbr: "Glen Cove, ME",
  },
  {
    zip: "4847",
    ST: "ME",
    cityWithStateAbbr: "Hope, ME",
  },
  {
    zip: "4848",
    ST: "ME",
    cityWithStateAbbr: "Islesboro, ME",
  },
  {
    zip: "4849",
    ST: "ME",
    cityWithStateAbbr: "Lincolnville, ME",
  },
  {
    zip: "4850",
    ST: "ME",
    cityWithStateAbbr: "Lincolnville Center, ME",
  },
  {
    zip: "4851",
    ST: "ME",
    cityWithStateAbbr: "Matinicus, ME",
  },
  {
    zip: "4852",
    ST: "ME",
    cityWithStateAbbr: "Monhegan, ME",
  },
  {
    zip: "4853",
    ST: "ME",
    cityWithStateAbbr: "North Haven, ME",
  },
  {
    zip: "4854",
    ST: "ME",
    cityWithStateAbbr: "Owls Head, ME",
  },
  {
    zip: "4855",
    ST: "ME",
    cityWithStateAbbr: "Port Clyde, ME",
  },
  {
    zip: "4856",
    ST: "ME",
    cityWithStateAbbr: "Rockport, ME",
  },
  {
    zip: "4858",
    ST: "ME",
    cityWithStateAbbr: "South Thomaston, ME",
  },
  {
    zip: "4859",
    ST: "ME",
    cityWithStateAbbr: "Spruce Head, ME",
  },
  {
    zip: "4860",
    ST: "ME",
    cityWithStateAbbr: "Tenants Harbor, ME",
  },
  {
    zip: "4861",
    ST: "ME",
    cityWithStateAbbr: "Thomaston, ME",
  },
  {
    zip: "4862",
    ST: "ME",
    cityWithStateAbbr: "Union, ME",
  },
  {
    zip: "4863",
    ST: "ME",
    cityWithStateAbbr: "Vinalhaven, ME",
  },
  {
    zip: "4864",
    ST: "ME",
    cityWithStateAbbr: "Warren, ME",
  },
  {
    zip: "4865",
    ST: "ME",
    cityWithStateAbbr: "West Rockport, ME",
  },
  {
    zip: "4901",
    ST: "ME",
    cityWithStateAbbr: "Waterville, ME",
  },
  {
    zip: "4903",
    ST: "ME",
    cityWithStateAbbr: "Waterville, ME",
  },
  {
    zip: "4910",
    ST: "ME",
    cityWithStateAbbr: "Albion, ME",
  },
  {
    zip: "4911",
    ST: "ME",
    cityWithStateAbbr: "Anson, ME",
  },
  {
    zip: "4912",
    ST: "ME",
    cityWithStateAbbr: "Athens, ME",
  },
  {
    zip: "4915",
    ST: "ME",
    cityWithStateAbbr: "Belfast, ME",
  },
  {
    zip: "4917",
    ST: "ME",
    cityWithStateAbbr: "Belgrade, ME",
  },
  {
    zip: "4918",
    ST: "ME",
    cityWithStateAbbr: "Belgrade Lakes, ME",
  },
  {
    zip: "4920",
    ST: "ME",
    cityWithStateAbbr: "Bingham, ME",
  },
  {
    zip: "4921",
    ST: "ME",
    cityWithStateAbbr: "Brooks, ME",
  },
  {
    zip: "4922",
    ST: "ME",
    cityWithStateAbbr: "Burnham, ME",
  },
  {
    zip: "4923",
    ST: "ME",
    cityWithStateAbbr: "Cambridge, ME",
  },
  {
    zip: "4924",
    ST: "ME",
    cityWithStateAbbr: "Canaan, ME",
  },
  {
    zip: "4925",
    ST: "ME",
    cityWithStateAbbr: "Caratunk, ME",
  },
  {
    zip: "4926",
    ST: "ME",
    cityWithStateAbbr: "China Village, ME",
  },
  {
    zip: "4927",
    ST: "ME",
    cityWithStateAbbr: "Clinton, ME",
  },
  {
    zip: "4928",
    ST: "ME",
    cityWithStateAbbr: "Corinna, ME",
  },
  {
    zip: "4929",
    ST: "ME",
    cityWithStateAbbr: "Detroit, ME",
  },
  {
    zip: "4930",
    ST: "ME",
    cityWithStateAbbr: "Dexter, ME",
  },
  {
    zip: "4932",
    ST: "ME",
    cityWithStateAbbr: "Dixmont, ME",
  },
  {
    zip: "4933",
    ST: "ME",
    cityWithStateAbbr: "East Newport, ME",
  },
  {
    zip: "4935",
    ST: "ME",
    cityWithStateAbbr: "East Vassalboro, ME",
  },
  {
    zip: "4936",
    ST: "ME",
    cityWithStateAbbr: "Eustis, ME",
  },
  {
    zip: "4937",
    ST: "ME",
    cityWithStateAbbr: "Fairfield, ME",
  },
  {
    zip: "4938",
    ST: "ME",
    cityWithStateAbbr: "Farmington, ME",
  },
  {
    zip: "4939",
    ST: "ME",
    cityWithStateAbbr: "Garland, ME",
  },
  {
    zip: "4940",
    ST: "ME",
    cityWithStateAbbr: "Farmington Falls, ME",
  },
  {
    zip: "4941",
    ST: "ME",
    cityWithStateAbbr: "Freedom, ME",
  },
  {
    zip: "4942",
    ST: "ME",
    cityWithStateAbbr: "Harmony, ME",
  },
  {
    zip: "4943",
    ST: "ME",
    cityWithStateAbbr: "Hartland, ME",
  },
  {
    zip: "4944",
    ST: "ME",
    cityWithStateAbbr: "Hinckley, ME",
  },
  {
    zip: "4945",
    ST: "ME",
    cityWithStateAbbr: "Jackman, ME",
  },
  {
    zip: "4947",
    ST: "ME",
    cityWithStateAbbr: "Kingfield, ME",
  },
  {
    zip: "4949",
    ST: "ME",
    cityWithStateAbbr: "Liberty, ME",
  },
  {
    zip: "4950",
    ST: "ME",
    cityWithStateAbbr: "Madison, ME",
  },
  {
    zip: "4951",
    ST: "ME",
    cityWithStateAbbr: "Monroe, ME",
  },
  {
    zip: "4952",
    ST: "ME",
    cityWithStateAbbr: "Morrill, ME",
  },
  {
    zip: "4953",
    ST: "ME",
    cityWithStateAbbr: "Newport, ME",
  },
  {
    zip: "4954",
    ST: "ME",
    cityWithStateAbbr: "New Portland, ME",
  },
  {
    zip: "4955",
    ST: "ME",
    cityWithStateAbbr: "New Sharon, ME",
  },
  {
    zip: "4956",
    ST: "ME",
    cityWithStateAbbr: "New Vineyard, ME",
  },
  {
    zip: "4957",
    ST: "ME",
    cityWithStateAbbr: "Norridgewock, ME",
  },
  {
    zip: "4958",
    ST: "ME",
    cityWithStateAbbr: "North Anson, ME",
  },
  {
    zip: "4961",
    ST: "ME",
    cityWithStateAbbr: "New Portland, ME",
  },
  {
    zip: "4962",
    ST: "ME",
    cityWithStateAbbr: "North Vassalboro, ME",
  },
  {
    zip: "4963",
    ST: "ME",
    cityWithStateAbbr: "Oakland, ME",
  },
  {
    zip: "4964",
    ST: "ME",
    cityWithStateAbbr: "Oquossoc, ME",
  },
  {
    zip: "4965",
    ST: "ME",
    cityWithStateAbbr: "Palmyra, ME",
  },
  {
    zip: "4966",
    ST: "ME",
    cityWithStateAbbr: "Phillips, ME",
  },
  {
    zip: "4967",
    ST: "ME",
    cityWithStateAbbr: "Pittsfield, ME",
  },
  {
    zip: "4969",
    ST: "ME",
    cityWithStateAbbr: "Plymouth, ME",
  },
  {
    zip: "4970",
    ST: "ME",
    cityWithStateAbbr: "Rangeley, ME",
  },
  {
    zip: "4971",
    ST: "ME",
    cityWithStateAbbr: "Saint Albans, ME",
  },
  {
    zip: "4972",
    ST: "ME",
    cityWithStateAbbr: "Sandy Point, ME",
  },
  {
    zip: "4973",
    ST: "ME",
    cityWithStateAbbr: "Searsmont, ME",
  },
  {
    zip: "4974",
    ST: "ME",
    cityWithStateAbbr: "Searsport, ME",
  },
  {
    zip: "4975",
    ST: "ME",
    cityWithStateAbbr: "Shawmut, ME",
  },
  {
    zip: "4976",
    ST: "ME",
    cityWithStateAbbr: "Skowhegan, ME",
  },
  {
    zip: "4978",
    ST: "ME",
    cityWithStateAbbr: "Smithfield, ME",
  },
  {
    zip: "4979",
    ST: "ME",
    cityWithStateAbbr: "Solon, ME",
  },
  {
    zip: "4981",
    ST: "ME",
    cityWithStateAbbr: "Stockton Springs, ME",
  },
  {
    zip: "4982",
    ST: "ME",
    cityWithStateAbbr: "Stratton, ME",
  },
  {
    zip: "4983",
    ST: "ME",
    cityWithStateAbbr: "Strong, ME",
  },
  {
    zip: "4984",
    ST: "ME",
    cityWithStateAbbr: "Temple, ME",
  },
  {
    zip: "4985",
    ST: "ME",
    cityWithStateAbbr: "West Forks, ME",
  },
  {
    zip: "4986",
    ST: "ME",
    cityWithStateAbbr: "Thorndike, ME",
  },
  {
    zip: "4987",
    ST: "ME",
    cityWithStateAbbr: "Troy, ME",
  },
  {
    zip: "4988",
    ST: "ME",
    cityWithStateAbbr: "Unity, ME",
  },
  {
    zip: "4989",
    ST: "ME",
    cityWithStateAbbr: "Vassalboro, ME",
  },
  {
    zip: "4992",
    ST: "ME",
    cityWithStateAbbr: "West Farmington, ME",
  },
  {
    zip: "5001",
    ST: "VT",
    cityWithStateAbbr: "White River Junction, VT",
  },
  {
    zip: "5009",
    ST: "VT",
    cityWithStateAbbr: "White River Junction, VT",
  },
  {
    zip: "5030",
    ST: "VT",
    cityWithStateAbbr: "Ascutney, VT",
  },
  {
    zip: "5031",
    ST: "VT",
    cityWithStateAbbr: "Barnard, VT",
  },
  {
    zip: "5032",
    ST: "VT",
    cityWithStateAbbr: "Bethel, VT",
  },
  {
    zip: "5033",
    ST: "VT",
    cityWithStateAbbr: "Bradford, VT",
  },
  {
    zip: "5034",
    ST: "VT",
    cityWithStateAbbr: "Bridgewater, VT",
  },
  {
    zip: "5035",
    ST: "VT",
    cityWithStateAbbr: "Bridgewater Corners, VT",
  },
  {
    zip: "5036",
    ST: "VT",
    cityWithStateAbbr: "Brookfield, VT",
  },
  {
    zip: "5037",
    ST: "VT",
    cityWithStateAbbr: "Brownsville, VT",
  },
  {
    zip: "5038",
    ST: "VT",
    cityWithStateAbbr: "Chelsea, VT",
  },
  {
    zip: "5039",
    ST: "VT",
    cityWithStateAbbr: "Corinth, VT",
  },
  {
    zip: "5040",
    ST: "VT",
    cityWithStateAbbr: "East Corinth, VT",
  },
  {
    zip: "5041",
    ST: "VT",
    cityWithStateAbbr: "East Randolph, VT",
  },
  {
    zip: "5042",
    ST: "VT",
    cityWithStateAbbr: "East Ryegate, VT",
  },
  {
    zip: "5043",
    ST: "VT",
    cityWithStateAbbr: "East Thetford, VT",
  },
  {
    zip: "5045",
    ST: "VT",
    cityWithStateAbbr: "Fairlee, VT",
  },
  {
    zip: "5046",
    ST: "VT",
    cityWithStateAbbr: "Groton, VT",
  },
  {
    zip: "5047",
    ST: "VT",
    cityWithStateAbbr: "Hartford, VT",
  },
  {
    zip: "5048",
    ST: "VT",
    cityWithStateAbbr: "Hartland, VT",
  },
  {
    zip: "5049",
    ST: "VT",
    cityWithStateAbbr: "Hartland Four Corners, VT",
  },
  {
    zip: "5050",
    ST: "VT",
    cityWithStateAbbr: "Mc Indoe Falls, VT",
  },
  {
    zip: "5051",
    ST: "VT",
    cityWithStateAbbr: "Newbury, VT",
  },
  {
    zip: "5052",
    ST: "VT",
    cityWithStateAbbr: "North Hartland, VT",
  },
  {
    zip: "5053",
    ST: "VT",
    cityWithStateAbbr: "North Pomfret, VT",
  },
  {
    zip: "5054",
    ST: "VT",
    cityWithStateAbbr: "North Thetford, VT",
  },
  {
    zip: "5055",
    ST: "VT",
    cityWithStateAbbr: "Norwich, VT",
  },
  {
    zip: "5056",
    ST: "VT",
    cityWithStateAbbr: "Plymouth, VT",
  },
  {
    zip: "5058",
    ST: "VT",
    cityWithStateAbbr: "Post Mills, VT",
  },
  {
    zip: "5059",
    ST: "VT",
    cityWithStateAbbr: "Quechee, VT",
  },
  {
    zip: "5060",
    ST: "VT",
    cityWithStateAbbr: "Randolph, VT",
  },
  {
    zip: "5061",
    ST: "VT",
    cityWithStateAbbr: "Randolph Center, VT",
  },
  {
    zip: "5062",
    ST: "VT",
    cityWithStateAbbr: "Reading, VT",
  },
  {
    zip: "5065",
    ST: "VT",
    cityWithStateAbbr: "Sharon, VT",
  },
  {
    zip: "5067",
    ST: "VT",
    cityWithStateAbbr: "South Pomfret, VT",
  },
  {
    zip: "5068",
    ST: "VT",
    cityWithStateAbbr: "South Royalton, VT",
  },
  {
    zip: "5069",
    ST: "VT",
    cityWithStateAbbr: "South Ryegate, VT",
  },
  {
    zip: "5070",
    ST: "VT",
    cityWithStateAbbr: "South Strafford, VT",
  },
  {
    zip: "5071",
    ST: "VT",
    cityWithStateAbbr: "South Woodstock, VT",
  },
  {
    zip: "5072",
    ST: "VT",
    cityWithStateAbbr: "Strafford, VT",
  },
  {
    zip: "5073",
    ST: "VT",
    cityWithStateAbbr: "Taftsville, VT",
  },
  {
    zip: "5074",
    ST: "VT",
    cityWithStateAbbr: "Thetford, VT",
  },
  {
    zip: "5075",
    ST: "VT",
    cityWithStateAbbr: "Thetford Center, VT",
  },
  {
    zip: "5076",
    ST: "VT",
    cityWithStateAbbr: "Topsham, VT",
  },
  {
    zip: "5077",
    ST: "VT",
    cityWithStateAbbr: "Tunbridge, VT",
  },
  {
    zip: "5079",
    ST: "VT",
    cityWithStateAbbr: "Vershire, VT",
  },
  {
    zip: "5081",
    ST: "VT",
    cityWithStateAbbr: "Wells River, VT",
  },
  {
    zip: "5083",
    ST: "VT",
    cityWithStateAbbr: "West Fairlee, VT",
  },
  {
    zip: "5084",
    ST: "VT",
    cityWithStateAbbr: "West Hartford, VT",
  },
  {
    zip: "5085",
    ST: "VT",
    cityWithStateAbbr: "West Newbury, VT",
  },
  {
    zip: "5086",
    ST: "VT",
    cityWithStateAbbr: "West Topsham, VT",
  },
  {
    zip: "5088",
    ST: "VT",
    cityWithStateAbbr: "Wilder, VT",
  },
  {
    zip: "5089",
    ST: "VT",
    cityWithStateAbbr: "Windsor, VT",
  },
  {
    zip: "5091",
    ST: "VT",
    cityWithStateAbbr: "Woodstock, VT",
  },
  {
    zip: "5101",
    ST: "VT",
    cityWithStateAbbr: "Bellows Falls, VT",
  },
  {
    zip: "5141",
    ST: "VT",
    cityWithStateAbbr: "Cambridgeport, VT",
  },
  {
    zip: "5142",
    ST: "VT",
    cityWithStateAbbr: "Cavendish, VT",
  },
  {
    zip: "5143",
    ST: "VT",
    cityWithStateAbbr: "Chester, VT",
  },
  {
    zip: "5144",
    ST: "VT",
    cityWithStateAbbr: "Chester Depot, VT",
  },
  {
    zip: "5146",
    ST: "VT",
    cityWithStateAbbr: "Grafton, VT",
  },
  {
    zip: "5148",
    ST: "VT",
    cityWithStateAbbr: "Londonderry, VT",
  },
  {
    zip: "5149",
    ST: "VT",
    cityWithStateAbbr: "Ludlow, VT",
  },
  {
    zip: "5150",
    ST: "VT",
    cityWithStateAbbr: "North Springfield, VT",
  },
  {
    zip: "5151",
    ST: "VT",
    cityWithStateAbbr: "Perkinsville, VT",
  },
  {
    zip: "5152",
    ST: "VT",
    cityWithStateAbbr: "Peru, VT",
  },
  {
    zip: "5153",
    ST: "VT",
    cityWithStateAbbr: "Proctorsville, VT",
  },
  {
    zip: "5154",
    ST: "VT",
    cityWithStateAbbr: "Saxtons River, VT",
  },
  {
    zip: "5155",
    ST: "VT",
    cityWithStateAbbr: "South Londonderry, VT",
  },
  {
    zip: "5156",
    ST: "VT",
    cityWithStateAbbr: "Springfield, VT",
  },
  {
    zip: "5158",
    ST: "VT",
    cityWithStateAbbr: "Westminster, VT",
  },
  {
    zip: "5159",
    ST: "VT",
    cityWithStateAbbr: "Westminster Station, VT",
  },
  {
    zip: "5161",
    ST: "VT",
    cityWithStateAbbr: "Weston, VT",
  },
  {
    zip: "5201",
    ST: "VT",
    cityWithStateAbbr: "Bennington, VT",
  },
  {
    zip: "5250",
    ST: "VT",
    cityWithStateAbbr: "Arlington, VT",
  },
  {
    zip: "5251",
    ST: "VT",
    cityWithStateAbbr: "Dorset, VT",
  },
  {
    zip: "5252",
    ST: "VT",
    cityWithStateAbbr: "East Arlington, VT",
  },
  {
    zip: "5253",
    ST: "VT",
    cityWithStateAbbr: "East Dorset, VT",
  },
  {
    zip: "5254",
    ST: "VT",
    cityWithStateAbbr: "Manchester, VT",
  },
  {
    zip: "5255",
    ST: "VT",
    cityWithStateAbbr: "Manchester Center, VT",
  },
  {
    zip: "5257",
    ST: "VT",
    cityWithStateAbbr: "North Bennington, VT",
  },
  {
    zip: "5260",
    ST: "VT",
    cityWithStateAbbr: "North Pownal, VT",
  },
  {
    zip: "5261",
    ST: "VT",
    cityWithStateAbbr: "Pownal, VT",
  },
  {
    zip: "5262",
    ST: "VT",
    cityWithStateAbbr: "Shaftsbury, VT",
  },
  {
    zip: "5301",
    ST: "VT",
    cityWithStateAbbr: "Brattleboro, VT",
  },
  {
    zip: "5302",
    ST: "VT",
    cityWithStateAbbr: "Brattleboro, VT",
  },
  {
    zip: "5303",
    ST: "VT",
    cityWithStateAbbr: "Brattleboro, VT",
  },
  {
    zip: "5304",
    ST: "VT",
    cityWithStateAbbr: "Brattleboro, VT",
  },
  {
    zip: "5340",
    ST: "VT",
    cityWithStateAbbr: "Bondville, VT",
  },
  {
    zip: "5341",
    ST: "VT",
    cityWithStateAbbr: "East Dover, VT",
  },
  {
    zip: "5342",
    ST: "VT",
    cityWithStateAbbr: "Jacksonville, VT",
  },
  {
    zip: "5343",
    ST: "VT",
    cityWithStateAbbr: "Jamaica, VT",
  },
  {
    zip: "5344",
    ST: "VT",
    cityWithStateAbbr: "Marlboro, VT",
  },
  {
    zip: "5345",
    ST: "VT",
    cityWithStateAbbr: "Newfane, VT",
  },
  {
    zip: "5346",
    ST: "VT",
    cityWithStateAbbr: "Putney, VT",
  },
  {
    zip: "5350",
    ST: "VT",
    cityWithStateAbbr: "Readsboro, VT",
  },
  {
    zip: "5351",
    ST: "VT",
    cityWithStateAbbr: "South Newfane, VT",
  },
  {
    zip: "5352",
    ST: "VT",
    cityWithStateAbbr: "Stamford, VT",
  },
  {
    zip: "5353",
    ST: "VT",
    cityWithStateAbbr: "Townshend, VT",
  },
  {
    zip: "5354",
    ST: "VT",
    cityWithStateAbbr: "Vernon, VT",
  },
  {
    zip: "5355",
    ST: "VT",
    cityWithStateAbbr: "Wardsboro, VT",
  },
  {
    zip: "5356",
    ST: "VT",
    cityWithStateAbbr: "West Dover, VT",
  },
  {
    zip: "5357",
    ST: "VT",
    cityWithStateAbbr: "West Dummerston, VT",
  },
  {
    zip: "5358",
    ST: "VT",
    cityWithStateAbbr: "West Halifax, VT",
  },
  {
    zip: "5359",
    ST: "VT",
    cityWithStateAbbr: "West Townshend, VT",
  },
  {
    zip: "5360",
    ST: "VT",
    cityWithStateAbbr: "West Wardsboro, VT",
  },
  {
    zip: "5361",
    ST: "VT",
    cityWithStateAbbr: "Whitingham, VT",
  },
  {
    zip: "5362",
    ST: "VT",
    cityWithStateAbbr: "Williamsville, VT",
  },
  {
    zip: "5363",
    ST: "VT",
    cityWithStateAbbr: "Wilmington, VT",
  },
  {
    zip: "5401",
    ST: "VT",
    cityWithStateAbbr: "Burlington, VT",
  },
  {
    zip: "5402",
    ST: "VT",
    cityWithStateAbbr: "Burlington, VT",
  },
  {
    zip: "5403",
    ST: "VT",
    cityWithStateAbbr: "South Burlington, VT",
  },
  {
    zip: "5404",
    ST: "VT",
    cityWithStateAbbr: "Winooski, VT",
  },
  {
    zip: "5405",
    ST: "VT",
    cityWithStateAbbr: "Burlington, VT",
  },
  {
    zip: "5406",
    ST: "VT",
    cityWithStateAbbr: "Burlington, VT",
  },
  {
    zip: "5407",
    ST: "VT",
    cityWithStateAbbr: "South Burlington, VT",
  },
  {
    zip: "5408",
    ST: "VT",
    cityWithStateAbbr: "Burlington, VT",
  },
  {
    zip: "5439",
    ST: "VT",
    cityWithStateAbbr: "Colchester, VT",
  },
  {
    zip: "5440",
    ST: "VT",
    cityWithStateAbbr: "Alburgh, VT",
  },
  {
    zip: "5441",
    ST: "VT",
    cityWithStateAbbr: "Bakersfield, VT",
  },
  {
    zip: "5442",
    ST: "VT",
    cityWithStateAbbr: "Belvidere Center, VT",
  },
  {
    zip: "5443",
    ST: "VT",
    cityWithStateAbbr: "Bristol, VT",
  },
  {
    zip: "5444",
    ST: "VT",
    cityWithStateAbbr: "Cambridge, VT",
  },
  {
    zip: "5445",
    ST: "VT",
    cityWithStateAbbr: "Charlotte, VT",
  },
  {
    zip: "5446",
    ST: "VT",
    cityWithStateAbbr: "Colchester, VT",
  },
  {
    zip: "5447",
    ST: "VT",
    cityWithStateAbbr: "East Berkshire, VT",
  },
  {
    zip: "5448",
    ST: "VT",
    cityWithStateAbbr: "East Fairfield, VT",
  },
  {
    zip: "5449",
    ST: "VT",
    cityWithStateAbbr: "Colchester, VT",
  },
  {
    zip: "5450",
    ST: "VT",
    cityWithStateAbbr: "Enosburg Falls, VT",
  },
  {
    zip: "5451",
    ST: "VT",
    cityWithStateAbbr: "Essex, VT",
  },
  {
    zip: "5452",
    ST: "VT",
    cityWithStateAbbr: "Essex Junction, VT",
  },
  {
    zip: "5453",
    ST: "VT",
    cityWithStateAbbr: "Essex Junction, VT",
  },
  {
    zip: "5454",
    ST: "VT",
    cityWithStateAbbr: "Fairfax, VT",
  },
  {
    zip: "5455",
    ST: "VT",
    cityWithStateAbbr: "Fairfield, VT",
  },
  {
    zip: "5456",
    ST: "VT",
    cityWithStateAbbr: "Ferrisburgh, VT",
  },
  {
    zip: "5457",
    ST: "VT",
    cityWithStateAbbr: "Franklin, VT",
  },
  {
    zip: "5458",
    ST: "VT",
    cityWithStateAbbr: "Grand Isle, VT",
  },
  {
    zip: "5459",
    ST: "VT",
    cityWithStateAbbr: "Highgate Center, VT",
  },
  {
    zip: "5460",
    ST: "VT",
    cityWithStateAbbr: "Highgate Springs, VT",
  },
  {
    zip: "5461",
    ST: "VT",
    cityWithStateAbbr: "Hinesburg, VT",
  },
  {
    zip: "5462",
    ST: "VT",
    cityWithStateAbbr: "Huntington, VT",
  },
  {
    zip: "5463",
    ST: "VT",
    cityWithStateAbbr: "Isle La Motte, VT",
  },
  {
    zip: "5464",
    ST: "VT",
    cityWithStateAbbr: "Jeffersonville, VT",
  },
  {
    zip: "5465",
    ST: "VT",
    cityWithStateAbbr: "Jericho, VT",
  },
  {
    zip: "5466",
    ST: "VT",
    cityWithStateAbbr: "Jonesville, VT",
  },
  {
    zip: "5468",
    ST: "VT",
    cityWithStateAbbr: "Milton, VT",
  },
  {
    zip: "5469",
    ST: "VT",
    cityWithStateAbbr: "Monkton, VT",
  },
  {
    zip: "5470",
    ST: "VT",
    cityWithStateAbbr: "Montgomery, VT",
  },
  {
    zip: "5471",
    ST: "VT",
    cityWithStateAbbr: "Montgomery Center, VT",
  },
  {
    zip: "5472",
    ST: "VT",
    cityWithStateAbbr: "New Haven, VT",
  },
  {
    zip: "5473",
    ST: "VT",
    cityWithStateAbbr: "North Ferrisburgh, VT",
  },
  {
    zip: "5474",
    ST: "VT",
    cityWithStateAbbr: "North Hero, VT",
  },
  {
    zip: "5476",
    ST: "VT",
    cityWithStateAbbr: "Richford, VT",
  },
  {
    zip: "5477",
    ST: "VT",
    cityWithStateAbbr: "Richmond, VT",
  },
  {
    zip: "5478",
    ST: "VT",
    cityWithStateAbbr: "Saint Albans, VT",
  },
  {
    zip: "5479",
    ST: "VT",
    cityWithStateAbbr: "Saint Albans, VT",
  },
  {
    zip: "5481",
    ST: "VT",
    cityWithStateAbbr: "Saint Albans Bay, VT",
  },
  {
    zip: "5482",
    ST: "VT",
    cityWithStateAbbr: "Shelburne, VT",
  },
  {
    zip: "5483",
    ST: "VT",
    cityWithStateAbbr: "Sheldon, VT",
  },
  {
    zip: "5485",
    ST: "VT",
    cityWithStateAbbr: "Sheldon Springs, VT",
  },
  {
    zip: "5486",
    ST: "VT",
    cityWithStateAbbr: "South Hero, VT",
  },
  {
    zip: "5487",
    ST: "VT",
    cityWithStateAbbr: "Starksboro, VT",
  },
  {
    zip: "5488",
    ST: "VT",
    cityWithStateAbbr: "Swanton, VT",
  },
  {
    zip: "5489",
    ST: "VT",
    cityWithStateAbbr: "Underhill, VT",
  },
  {
    zip: "5490",
    ST: "VT",
    cityWithStateAbbr: "Underhill Center, VT",
  },
  {
    zip: "5491",
    ST: "VT",
    cityWithStateAbbr: "Vergennes, VT",
  },
  {
    zip: "5492",
    ST: "VT",
    cityWithStateAbbr: "Waterville, VT",
  },
  {
    zip: "5494",
    ST: "VT",
    cityWithStateAbbr: "Westford, VT",
  },
  {
    zip: "5495",
    ST: "VT",
    cityWithStateAbbr: "Williston, VT",
  },
  {
    zip: "5501",
    ST: "MA",
    cityWithStateAbbr: "Andover, MA",
  },
  {
    zip: "5544",
    ST: "MA",
    cityWithStateAbbr: "Andover, MA",
  },
  {
    zip: "5601",
    ST: "VT",
    cityWithStateAbbr: "Montpelier, VT",
  },
  {
    zip: "5602",
    ST: "VT",
    cityWithStateAbbr: "Montpelier, VT",
  },
  {
    zip: "5603",
    ST: "VT",
    cityWithStateAbbr: "Montpelier, VT",
  },
  {
    zip: "5604",
    ST: "VT",
    cityWithStateAbbr: "Montpelier, VT",
  },
  {
    zip: "5609",
    ST: "VT",
    cityWithStateAbbr: "Montpelier, VT",
  },
  {
    zip: "5620",
    ST: "VT",
    cityWithStateAbbr: "Montpelier, VT",
  },
  {
    zip: "5633",
    ST: "VT",
    cityWithStateAbbr: "Montpelier, VT",
  },
  {
    zip: "5640",
    ST: "VT",
    cityWithStateAbbr: "Adamant, VT",
  },
  {
    zip: "5641",
    ST: "VT",
    cityWithStateAbbr: "Barre, VT",
  },
  {
    zip: "5647",
    ST: "VT",
    cityWithStateAbbr: "Cabot, VT",
  },
  {
    zip: "5648",
    ST: "VT",
    cityWithStateAbbr: "Calais, VT",
  },
  {
    zip: "5649",
    ST: "VT",
    cityWithStateAbbr: "East Barre, VT",
  },
  {
    zip: "5650",
    ST: "VT",
    cityWithStateAbbr: "East Calais, VT",
  },
  {
    zip: "5651",
    ST: "VT",
    cityWithStateAbbr: "East Montpelier, VT",
  },
  {
    zip: "5652",
    ST: "VT",
    cityWithStateAbbr: "Eden, VT",
  },
  {
    zip: "5653",
    ST: "VT",
    cityWithStateAbbr: "Eden Mills, VT",
  },
  {
    zip: "5654",
    ST: "VT",
    cityWithStateAbbr: "Graniteville, VT",
  },
  {
    zip: "5655",
    ST: "VT",
    cityWithStateAbbr: "Hyde Park, VT",
  },
  {
    zip: "5656",
    ST: "VT",
    cityWithStateAbbr: "Johnson, VT",
  },
  {
    zip: "5657",
    ST: "VT",
    cityWithStateAbbr: "Lake Elmore, VT",
  },
  {
    zip: "5658",
    ST: "VT",
    cityWithStateAbbr: "Marshfield, VT",
  },
  {
    zip: "5660",
    ST: "VT",
    cityWithStateAbbr: "Moretown, VT",
  },
  {
    zip: "5661",
    ST: "VT",
    cityWithStateAbbr: "Morrisville, VT",
  },
  {
    zip: "5662",
    ST: "VT",
    cityWithStateAbbr: "Moscow, VT",
  },
  {
    zip: "5663",
    ST: "VT",
    cityWithStateAbbr: "Northfield, VT",
  },
  {
    zip: "5664",
    ST: "VT",
    cityWithStateAbbr: "Northfield Falls, VT",
  },
  {
    zip: "5665",
    ST: "VT",
    cityWithStateAbbr: "North Hyde Park, VT",
  },
  {
    zip: "5666",
    ST: "VT",
    cityWithStateAbbr: "North Montpelier, VT",
  },
  {
    zip: "5667",
    ST: "VT",
    cityWithStateAbbr: "Plainfield, VT",
  },
  {
    zip: "5669",
    ST: "VT",
    cityWithStateAbbr: "Roxbury, VT",
  },
  {
    zip: "5670",
    ST: "VT",
    cityWithStateAbbr: "South Barre, VT",
  },
  {
    zip: "5671",
    ST: "VT",
    cityWithStateAbbr: "Waterbury, VT",
  },
  {
    zip: "5672",
    ST: "VT",
    cityWithStateAbbr: "Stowe, VT",
  },
  {
    zip: "5673",
    ST: "VT",
    cityWithStateAbbr: "Waitsfield, VT",
  },
  {
    zip: "5674",
    ST: "VT",
    cityWithStateAbbr: "Warren, VT",
  },
  {
    zip: "5675",
    ST: "VT",
    cityWithStateAbbr: "Washington, VT",
  },
  {
    zip: "5676",
    ST: "VT",
    cityWithStateAbbr: "Waterbury, VT",
  },
  {
    zip: "5677",
    ST: "VT",
    cityWithStateAbbr: "Waterbury Center, VT",
  },
  {
    zip: "5678",
    ST: "VT",
    cityWithStateAbbr: "Websterville, VT",
  },
  {
    zip: "5679",
    ST: "VT",
    cityWithStateAbbr: "Williamstown, VT",
  },
  {
    zip: "5680",
    ST: "VT",
    cityWithStateAbbr: "Wolcott, VT",
  },
  {
    zip: "5681",
    ST: "VT",
    cityWithStateAbbr: "Woodbury, VT",
  },
  {
    zip: "5682",
    ST: "VT",
    cityWithStateAbbr: "Worcester, VT",
  },
  {
    zip: "5701",
    ST: "VT",
    cityWithStateAbbr: "Rutland, VT",
  },
  {
    zip: "5702",
    ST: "VT",
    cityWithStateAbbr: "Rutland, VT",
  },
  {
    zip: "5730",
    ST: "VT",
    cityWithStateAbbr: "Belmont, VT",
  },
  {
    zip: "5731",
    ST: "VT",
    cityWithStateAbbr: "Benson, VT",
  },
  {
    zip: "5732",
    ST: "VT",
    cityWithStateAbbr: "Bomoseen, VT",
  },
  {
    zip: "5733",
    ST: "VT",
    cityWithStateAbbr: "Brandon, VT",
  },
  {
    zip: "5734",
    ST: "VT",
    cityWithStateAbbr: "Bridport, VT",
  },
  {
    zip: "5735",
    ST: "VT",
    cityWithStateAbbr: "Castleton, VT",
  },
  {
    zip: "5736",
    ST: "VT",
    cityWithStateAbbr: "Center Rutland, VT",
  },
  {
    zip: "5737",
    ST: "VT",
    cityWithStateAbbr: "Chittenden, VT",
  },
  {
    zip: "5738",
    ST: "VT",
    cityWithStateAbbr: "Cuttingsville, VT",
  },
  {
    zip: "5739",
    ST: "VT",
    cityWithStateAbbr: "Danby, VT",
  },
  {
    zip: "5740",
    ST: "VT",
    cityWithStateAbbr: "East Middlebury, VT",
  },
  {
    zip: "5741",
    ST: "VT",
    cityWithStateAbbr: "East Poultney, VT",
  },
  {
    zip: "5742",
    ST: "VT",
    cityWithStateAbbr: "East Wallingford, VT",
  },
  {
    zip: "5743",
    ST: "VT",
    cityWithStateAbbr: "Fair Haven, VT",
  },
  {
    zip: "5744",
    ST: "VT",
    cityWithStateAbbr: "Florence, VT",
  },
  {
    zip: "5745",
    ST: "VT",
    cityWithStateAbbr: "Forest Dale, VT",
  },
  {
    zip: "5746",
    ST: "VT",
    cityWithStateAbbr: "Gaysville, VT",
  },
  {
    zip: "5747",
    ST: "VT",
    cityWithStateAbbr: "Granville, VT",
  },
  {
    zip: "5748",
    ST: "VT",
    cityWithStateAbbr: "Hancock, VT",
  },
  {
    zip: "5750",
    ST: "VT",
    cityWithStateAbbr: "Hydeville, VT",
  },
  {
    zip: "5751",
    ST: "VT",
    cityWithStateAbbr: "Killington, VT",
  },
  {
    zip: "5753",
    ST: "VT",
    cityWithStateAbbr: "Middlebury, VT",
  },
  {
    zip: "5757",
    ST: "VT",
    cityWithStateAbbr: "Middletown Springs, VT",
  },
  {
    zip: "5758",
    ST: "VT",
    cityWithStateAbbr: "Mount Holly, VT",
  },
  {
    zip: "5759",
    ST: "VT",
    cityWithStateAbbr: "North Clarendon, VT",
  },
  {
    zip: "5760",
    ST: "VT",
    cityWithStateAbbr: "Orwell, VT",
  },
  {
    zip: "5761",
    ST: "VT",
    cityWithStateAbbr: "Pawlet, VT",
  },
  {
    zip: "5762",
    ST: "VT",
    cityWithStateAbbr: "Pittsfield, VT",
  },
  {
    zip: "5763",
    ST: "VT",
    cityWithStateAbbr: "Pittsford, VT",
  },
  {
    zip: "5764",
    ST: "VT",
    cityWithStateAbbr: "Poultney, VT",
  },
  {
    zip: "5765",
    ST: "VT",
    cityWithStateAbbr: "Proctor, VT",
  },
  {
    zip: "5766",
    ST: "VT",
    cityWithStateAbbr: "Ripton, VT",
  },
  {
    zip: "5767",
    ST: "VT",
    cityWithStateAbbr: "Rochester, VT",
  },
  {
    zip: "5768",
    ST: "VT",
    cityWithStateAbbr: "Rupert, VT",
  },
  {
    zip: "5769",
    ST: "VT",
    cityWithStateAbbr: "Salisbury, VT",
  },
  {
    zip: "5770",
    ST: "VT",
    cityWithStateAbbr: "Shoreham, VT",
  },
  {
    zip: "5772",
    ST: "VT",
    cityWithStateAbbr: "Stockbridge, VT",
  },
  {
    zip: "5773",
    ST: "VT",
    cityWithStateAbbr: "Wallingford, VT",
  },
  {
    zip: "5774",
    ST: "VT",
    cityWithStateAbbr: "Wells, VT",
  },
  {
    zip: "5775",
    ST: "VT",
    cityWithStateAbbr: "West Pawlet, VT",
  },
  {
    zip: "5776",
    ST: "VT",
    cityWithStateAbbr: "West Rupert, VT",
  },
  {
    zip: "5777",
    ST: "VT",
    cityWithStateAbbr: "West Rutland, VT",
  },
  {
    zip: "5778",
    ST: "VT",
    cityWithStateAbbr: "Whiting, VT",
  },
  {
    zip: "5819",
    ST: "VT",
    cityWithStateAbbr: "Saint Johnsbury, VT",
  },
  {
    zip: "5820",
    ST: "VT",
    cityWithStateAbbr: "Albany, VT",
  },
  {
    zip: "5821",
    ST: "VT",
    cityWithStateAbbr: "Barnet, VT",
  },
  {
    zip: "5822",
    ST: "VT",
    cityWithStateAbbr: "Barton, VT",
  },
  {
    zip: "5823",
    ST: "VT",
    cityWithStateAbbr: "Beebe Plain, VT",
  },
  {
    zip: "5824",
    ST: "VT",
    cityWithStateAbbr: "Concord, VT",
  },
  {
    zip: "5825",
    ST: "VT",
    cityWithStateAbbr: "Coventry, VT",
  },
  {
    zip: "5826",
    ST: "VT",
    cityWithStateAbbr: "Craftsbury, VT",
  },
  {
    zip: "5827",
    ST: "VT",
    cityWithStateAbbr: "Craftsbury Common, VT",
  },
  {
    zip: "5828",
    ST: "VT",
    cityWithStateAbbr: "Danville, VT",
  },
  {
    zip: "5829",
    ST: "VT",
    cityWithStateAbbr: "Derby, VT",
  },
  {
    zip: "5830",
    ST: "VT",
    cityWithStateAbbr: "Derby Line, VT",
  },
  {
    zip: "5832",
    ST: "VT",
    cityWithStateAbbr: "East Burke, VT",
  },
  {
    zip: "5833",
    ST: "VT",
    cityWithStateAbbr: "East Charleston, VT",
  },
  {
    zip: "5836",
    ST: "VT",
    cityWithStateAbbr: "East Hardwick, VT",
  },
  {
    zip: "5837",
    ST: "VT",
    cityWithStateAbbr: "East Haven, VT",
  },
  {
    zip: "5838",
    ST: "VT",
    cityWithStateAbbr: "East Saint Johnsbury, VT",
  },
  {
    zip: "5839",
    ST: "VT",
    cityWithStateAbbr: "Glover, VT",
  },
  {
    zip: "5840",
    ST: "VT",
    cityWithStateAbbr: "Granby, VT",
  },
  {
    zip: "5841",
    ST: "VT",
    cityWithStateAbbr: "Greensboro, VT",
  },
  {
    zip: "5842",
    ST: "VT",
    cityWithStateAbbr: "Greensboro Bend, VT",
  },
  {
    zip: "5843",
    ST: "VT",
    cityWithStateAbbr: "Hardwick, VT",
  },
  {
    zip: "5845",
    ST: "VT",
    cityWithStateAbbr: "Irasburg, VT",
  },
  {
    zip: "5846",
    ST: "VT",
    cityWithStateAbbr: "Island Pond, VT",
  },
  {
    zip: "5847",
    ST: "VT",
    cityWithStateAbbr: "Lowell, VT",
  },
  {
    zip: "5848",
    ST: "VT",
    cityWithStateAbbr: "Lower Waterford, VT",
  },
  {
    zip: "5849",
    ST: "VT",
    cityWithStateAbbr: "Lyndon, VT",
  },
  {
    zip: "5850",
    ST: "VT",
    cityWithStateAbbr: "Lyndon Center, VT",
  },
  {
    zip: "5851",
    ST: "VT",
    cityWithStateAbbr: "Lyndonville, VT",
  },
  {
    zip: "5853",
    ST: "VT",
    cityWithStateAbbr: "Morgan, VT",
  },
  {
    zip: "5855",
    ST: "VT",
    cityWithStateAbbr: "Newport, VT",
  },
  {
    zip: "5857",
    ST: "VT",
    cityWithStateAbbr: "Newport Center, VT",
  },
  {
    zip: "5858",
    ST: "VT",
    cityWithStateAbbr: "North Concord, VT",
  },
  {
    zip: "5859",
    ST: "VT",
    cityWithStateAbbr: "North Troy, VT",
  },
  {
    zip: "5860",
    ST: "VT",
    cityWithStateAbbr: "Orleans, VT",
  },
  {
    zip: "5861",
    ST: "VT",
    cityWithStateAbbr: "Passumpsic, VT",
  },
  {
    zip: "5862",
    ST: "VT",
    cityWithStateAbbr: "Peacham, VT",
  },
  {
    zip: "5863",
    ST: "VT",
    cityWithStateAbbr: "Saint Johnsbury Center, VT",
  },
  {
    zip: "5866",
    ST: "VT",
    cityWithStateAbbr: "Sheffield, VT",
  },
  {
    zip: "5867",
    ST: "VT",
    cityWithStateAbbr: "Sutton, VT",
  },
  {
    zip: "5868",
    ST: "VT",
    cityWithStateAbbr: "Troy, VT",
  },
  {
    zip: "5871",
    ST: "VT",
    cityWithStateAbbr: "West Burke, VT",
  },
  {
    zip: "5872",
    ST: "VT",
    cityWithStateAbbr: "West Charleston, VT",
  },
  {
    zip: "5873",
    ST: "VT",
    cityWithStateAbbr: "West Danville, VT",
  },
  {
    zip: "5874",
    ST: "VT",
    cityWithStateAbbr: "Westfield, VT",
  },
  {
    zip: "5875",
    ST: "VT",
    cityWithStateAbbr: "Barton, VT",
  },
  {
    zip: "5901",
    ST: "VT",
    cityWithStateAbbr: "Averill, VT",
  },
  {
    zip: "5902",
    ST: "VT",
    cityWithStateAbbr: "Beecher Falls, VT",
  },
  {
    zip: "5903",
    ST: "VT",
    cityWithStateAbbr: "Canaan, VT",
  },
  {
    zip: "5904",
    ST: "VT",
    cityWithStateAbbr: "Gilman, VT",
  },
  {
    zip: "5905",
    ST: "VT",
    cityWithStateAbbr: "Guildhall, VT",
  },
  {
    zip: "5906",
    ST: "VT",
    cityWithStateAbbr: "Lunenburg, VT",
  },
  {
    zip: "5907",
    ST: "VT",
    cityWithStateAbbr: "Norton, VT",
  },
  {
    zip: "6001",
    ST: "CT",
    cityWithStateAbbr: "Avon, CT",
  },
  {
    zip: "6002",
    ST: "CT",
    cityWithStateAbbr: "Bloomfield, CT",
  },
  {
    zip: "6006",
    ST: "CT",
    cityWithStateAbbr: "Windsor, CT",
  },
  {
    zip: "6010",
    ST: "CT",
    cityWithStateAbbr: "Bristol, CT",
  },
  {
    zip: "6011",
    ST: "CT",
    cityWithStateAbbr: "Bristol, CT",
  },
  {
    zip: "6013",
    ST: "CT",
    cityWithStateAbbr: "Burlington, CT",
  },
  {
    zip: "6016",
    ST: "CT",
    cityWithStateAbbr: "Broad Brook, CT",
  },
  {
    zip: "6018",
    ST: "CT",
    cityWithStateAbbr: "Canaan, CT",
  },
  {
    zip: "6019",
    ST: "CT",
    cityWithStateAbbr: "Canton, CT",
  },
  {
    zip: "6020",
    ST: "CT",
    cityWithStateAbbr: "Canton Center, CT",
  },
  {
    zip: "6021",
    ST: "CT",
    cityWithStateAbbr: "Colebrook, CT",
  },
  {
    zip: "6022",
    ST: "CT",
    cityWithStateAbbr: "Collinsville, CT",
  },
  {
    zip: "6023",
    ST: "CT",
    cityWithStateAbbr: "East Berlin, CT",
  },
  {
    zip: "6024",
    ST: "CT",
    cityWithStateAbbr: "East Canaan, CT",
  },
  {
    zip: "6025",
    ST: "CT",
    cityWithStateAbbr: "East Glastonbury, CT",
  },
  {
    zip: "6026",
    ST: "CT",
    cityWithStateAbbr: "East Granby, CT",
  },
  {
    zip: "6027",
    ST: "CT",
    cityWithStateAbbr: "East Hartland, CT",
  },
  {
    zip: "6028",
    ST: "CT",
    cityWithStateAbbr: "East Windsor Hill, CT",
  },
  {
    zip: "6029",
    ST: "CT",
    cityWithStateAbbr: "Ellington, CT",
  },
  {
    zip: "6030",
    ST: "CT",
    cityWithStateAbbr: "Farmington, CT",
  },
  {
    zip: "6031",
    ST: "CT",
    cityWithStateAbbr: "Falls Village, CT",
  },
  {
    zip: "6032",
    ST: "CT",
    cityWithStateAbbr: "Farmington, CT",
  },
  {
    zip: "6033",
    ST: "CT",
    cityWithStateAbbr: "Glastonbury, CT",
  },
  {
    zip: "6034",
    ST: "CT",
    cityWithStateAbbr: "Farmington, CT",
  },
  {
    zip: "6035",
    ST: "CT",
    cityWithStateAbbr: "Granby, CT",
  },
  {
    zip: "6037",
    ST: "CT",
    cityWithStateAbbr: "Berlin, CT",
  },
  {
    zip: "6039",
    ST: "CT",
    cityWithStateAbbr: "Lakeville, CT",
  },
  {
    zip: "6040",
    ST: "CT",
    cityWithStateAbbr: "Manchester, CT",
  },
  {
    zip: "6041",
    ST: "CT",
    cityWithStateAbbr: "Manchester, CT",
  },
  {
    zip: "6042",
    ST: "CT",
    cityWithStateAbbr: "Manchester, CT",
  },
  {
    zip: "6043",
    ST: "CT",
    cityWithStateAbbr: "Bolton, CT",
  },
  {
    zip: "6045",
    ST: "CT",
    cityWithStateAbbr: "Manchester, CT",
  },
  {
    zip: "6050",
    ST: "CT",
    cityWithStateAbbr: "New Britain, CT",
  },
  {
    zip: "6051",
    ST: "CT",
    cityWithStateAbbr: "New Britain, CT",
  },
  {
    zip: "6052",
    ST: "CT",
    cityWithStateAbbr: "New Britain, CT",
  },
  {
    zip: "6053",
    ST: "CT",
    cityWithStateAbbr: "New Britain, CT",
  },
  {
    zip: "6057",
    ST: "CT",
    cityWithStateAbbr: "New Hartford, CT",
  },
  {
    zip: "6058",
    ST: "CT",
    cityWithStateAbbr: "Norfolk, CT",
  },
  {
    zip: "6059",
    ST: "CT",
    cityWithStateAbbr: "North Canton, CT",
  },
  {
    zip: "6060",
    ST: "CT",
    cityWithStateAbbr: "North Granby, CT",
  },
  {
    zip: "6061",
    ST: "CT",
    cityWithStateAbbr: "Pine Meadow, CT",
  },
  {
    zip: "6062",
    ST: "CT",
    cityWithStateAbbr: "Plainville, CT",
  },
  {
    zip: "6063",
    ST: "CT",
    cityWithStateAbbr: "Barkhamsted, CT",
  },
  {
    zip: "6064",
    ST: "CT",
    cityWithStateAbbr: "Poquonock, CT",
  },
  {
    zip: "6065",
    ST: "CT",
    cityWithStateAbbr: "Riverton, CT",
  },
  {
    zip: "6066",
    ST: "CT",
    cityWithStateAbbr: "Vernon Rockville, CT",
  },
  {
    zip: "6067",
    ST: "CT",
    cityWithStateAbbr: "Rocky Hill, CT",
  },
  {
    zip: "6068",
    ST: "CT",
    cityWithStateAbbr: "Salisbury, CT",
  },
  {
    zip: "6069",
    ST: "CT",
    cityWithStateAbbr: "Sharon, CT",
  },
  {
    zip: "6070",
    ST: "CT",
    cityWithStateAbbr: "Simsbury, CT",
  },
  {
    zip: "6071",
    ST: "CT",
    cityWithStateAbbr: "Somers, CT",
  },
  {
    zip: "6072",
    ST: "CT",
    cityWithStateAbbr: "Somersville, CT",
  },
  {
    zip: "6073",
    ST: "CT",
    cityWithStateAbbr: "South Glastonbury, CT",
  },
  {
    zip: "6074",
    ST: "CT",
    cityWithStateAbbr: "South Windsor, CT",
  },
  {
    zip: "6075",
    ST: "CT",
    cityWithStateAbbr: "Stafford, CT",
  },
  {
    zip: "6076",
    ST: "CT",
    cityWithStateAbbr: "Stafford Springs, CT",
  },
  {
    zip: "6077",
    ST: "CT",
    cityWithStateAbbr: "Staffordville, CT",
  },
  {
    zip: "6078",
    ST: "CT",
    cityWithStateAbbr: "Suffield, CT",
  },
  {
    zip: "6079",
    ST: "CT",
    cityWithStateAbbr: "Taconic, CT",
  },
  {
    zip: "6080",
    ST: "CT",
    cityWithStateAbbr: "Suffield, CT",
  },
  {
    zip: "6081",
    ST: "CT",
    cityWithStateAbbr: "Tariffville, CT",
  },
  {
    zip: "6082",
    ST: "CT",
    cityWithStateAbbr: "Enfield, CT",
  },
  {
    zip: "6083",
    ST: "CT",
    cityWithStateAbbr: "Enfield, CT",
  },
  {
    zip: "6084",
    ST: "CT",
    cityWithStateAbbr: "Tolland, CT",
  },
  {
    zip: "6085",
    ST: "CT",
    cityWithStateAbbr: "Unionville, CT",
  },
  {
    zip: "6087",
    ST: "CT",
    cityWithStateAbbr: "Unionville, CT",
  },
  {
    zip: "6088",
    ST: "CT",
    cityWithStateAbbr: "East Windsor, CT",
  },
  {
    zip: "6089",
    ST: "CT",
    cityWithStateAbbr: "Weatogue, CT",
  },
  {
    zip: "6090",
    ST: "CT",
    cityWithStateAbbr: "West Granby, CT",
  },
  {
    zip: "6091",
    ST: "CT",
    cityWithStateAbbr: "West Hartland, CT",
  },
  {
    zip: "6092",
    ST: "CT",
    cityWithStateAbbr: "West Simsbury, CT",
  },
  {
    zip: "6093",
    ST: "CT",
    cityWithStateAbbr: "West Suffield, CT",
  },
  {
    zip: "6094",
    ST: "CT",
    cityWithStateAbbr: "Winchester Center, CT",
  },
  {
    zip: "6095",
    ST: "CT",
    cityWithStateAbbr: "Windsor, CT",
  },
  {
    zip: "6096",
    ST: "CT",
    cityWithStateAbbr: "Windsor Locks, CT",
  },
  {
    zip: "6098",
    ST: "CT",
    cityWithStateAbbr: "Winsted, CT",
  },
  {
    zip: "6101",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6102",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6103",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6104",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6105",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6106",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6107",
    ST: "CT",
    cityWithStateAbbr: "West Hartford, CT",
  },
  {
    zip: "6108",
    ST: "CT",
    cityWithStateAbbr: "East Hartford, CT",
  },
  {
    zip: "6109",
    ST: "CT",
    cityWithStateAbbr: "Wethersfield, CT",
  },
  {
    zip: "6110",
    ST: "CT",
    cityWithStateAbbr: "West Hartford, CT",
  },
  {
    zip: "6111",
    ST: "CT",
    cityWithStateAbbr: "Newington, CT",
  },
  {
    zip: "6112",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6114",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6115",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6117",
    ST: "CT",
    cityWithStateAbbr: "West Hartford, CT",
  },
  {
    zip: "6118",
    ST: "CT",
    cityWithStateAbbr: "East Hartford, CT",
  },
  {
    zip: "6119",
    ST: "CT",
    cityWithStateAbbr: "West Hartford, CT",
  },
  {
    zip: "6120",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6123",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6126",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6127",
    ST: "CT",
    cityWithStateAbbr: "West Hartford, CT",
  },
  {
    zip: "6128",
    ST: "CT",
    cityWithStateAbbr: "East Hartford, CT",
  },
  {
    zip: "6129",
    ST: "CT",
    cityWithStateAbbr: "Wethersfield, CT",
  },
  {
    zip: "6131",
    ST: "CT",
    cityWithStateAbbr: "Newington, CT",
  },
  {
    zip: "6132",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6133",
    ST: "CT",
    cityWithStateAbbr: "West Hartford, CT",
  },
  {
    zip: "6134",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6137",
    ST: "CT",
    cityWithStateAbbr: "West Hartford, CT",
  },
  {
    zip: "6138",
    ST: "CT",
    cityWithStateAbbr: "East Hartford, CT",
  },
  {
    zip: "6140",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6141",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6142",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6143",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6144",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6145",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6146",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6147",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6150",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6151",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6152",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6153",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6154",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6155",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6156",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6160",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6161",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6167",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6176",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6180",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6183",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6199",
    ST: "CT",
    cityWithStateAbbr: "Hartford, CT",
  },
  {
    zip: "6226",
    ST: "CT",
    cityWithStateAbbr: "Willimantic, CT",
  },
  {
    zip: "6230",
    ST: "CT",
    cityWithStateAbbr: "Abington, CT",
  },
  {
    zip: "6231",
    ST: "CT",
    cityWithStateAbbr: "Amston, CT",
  },
  {
    zip: "6232",
    ST: "CT",
    cityWithStateAbbr: "Andover, CT",
  },
  {
    zip: "6233",
    ST: "CT",
    cityWithStateAbbr: "Ballouville, CT",
  },
  {
    zip: "6234",
    ST: "CT",
    cityWithStateAbbr: "Brooklyn, CT",
  },
  {
    zip: "6235",
    ST: "CT",
    cityWithStateAbbr: "Chaplin, CT",
  },
  {
    zip: "6237",
    ST: "CT",
    cityWithStateAbbr: "Columbia, CT",
  },
  {
    zip: "6238",
    ST: "CT",
    cityWithStateAbbr: "Coventry, CT",
  },
  {
    zip: "6239",
    ST: "CT",
    cityWithStateAbbr: "Danielson, CT",
  },
  {
    zip: "6241",
    ST: "CT",
    cityWithStateAbbr: "Dayville, CT",
  },
  {
    zip: "6242",
    ST: "CT",
    cityWithStateAbbr: "Eastford, CT",
  },
  {
    zip: "6243",
    ST: "CT",
    cityWithStateAbbr: "East Killingly, CT",
  },
  {
    zip: "6244",
    ST: "CT",
    cityWithStateAbbr: "East Woodstock, CT",
  },
  {
    zip: "6245",
    ST: "CT",
    cityWithStateAbbr: "Fabyan, CT",
  },
  {
    zip: "6246",
    ST: "CT",
    cityWithStateAbbr: "Grosvenor Dale, CT",
  },
  {
    zip: "6247",
    ST: "CT",
    cityWithStateAbbr: "Hampton, CT",
  },
  {
    zip: "6248",
    ST: "CT",
    cityWithStateAbbr: "Hebron, CT",
  },
  {
    zip: "6249",
    ST: "CT",
    cityWithStateAbbr: "Lebanon, CT",
  },
  {
    zip: "6250",
    ST: "CT",
    cityWithStateAbbr: "Mansfield Center, CT",
  },
  {
    zip: "6251",
    ST: "CT",
    cityWithStateAbbr: "Mansfield Depot, CT",
  },
  {
    zip: "6254",
    ST: "CT",
    cityWithStateAbbr: "North Franklin, CT",
  },
  {
    zip: "6255",
    ST: "CT",
    cityWithStateAbbr: "North Grosvenordale, CT",
  },
  {
    zip: "6256",
    ST: "CT",
    cityWithStateAbbr: "North Windham, CT",
  },
  {
    zip: "6258",
    ST: "CT",
    cityWithStateAbbr: "Pomfret, CT",
  },
  {
    zip: "6259",
    ST: "CT",
    cityWithStateAbbr: "Pomfret Center, CT",
  },
  {
    zip: "6260",
    ST: "CT",
    cityWithStateAbbr: "Putnam, CT",
  },
  {
    zip: "6262",
    ST: "CT",
    cityWithStateAbbr: "Quinebaug, CT",
  },
  {
    zip: "6263",
    ST: "CT",
    cityWithStateAbbr: "Rogers, CT",
  },
  {
    zip: "6264",
    ST: "CT",
    cityWithStateAbbr: "Scotland, CT",
  },
  {
    zip: "6265",
    ST: "CT",
    cityWithStateAbbr: "South Willington, CT",
  },
  {
    zip: "6266",
    ST: "CT",
    cityWithStateAbbr: "South Windham, CT",
  },
  {
    zip: "6267",
    ST: "CT",
    cityWithStateAbbr: "South Woodstock, CT",
  },
  {
    zip: "6268",
    ST: "CT",
    cityWithStateAbbr: "Storrs Mansfield, CT",
  },
  {
    zip: "6269",
    ST: "CT",
    cityWithStateAbbr: "Storrs Mansfield, CT",
  },
  {
    zip: "6277",
    ST: "CT",
    cityWithStateAbbr: "Thompson, CT",
  },
  {
    zip: "6278",
    ST: "CT",
    cityWithStateAbbr: "Ashford, CT",
  },
  {
    zip: "6279",
    ST: "CT",
    cityWithStateAbbr: "Willington, CT",
  },
  {
    zip: "6280",
    ST: "CT",
    cityWithStateAbbr: "Windham, CT",
  },
  {
    zip: "6281",
    ST: "CT",
    cityWithStateAbbr: "Woodstock, CT",
  },
  {
    zip: "6282",
    ST: "CT",
    cityWithStateAbbr: "Woodstock Valley, CT",
  },
  {
    zip: "6320",
    ST: "CT",
    cityWithStateAbbr: "New London, CT",
  },
  {
    zip: "6330",
    ST: "CT",
    cityWithStateAbbr: "Baltic, CT",
  },
  {
    zip: "6331",
    ST: "CT",
    cityWithStateAbbr: "Canterbury, CT",
  },
  {
    zip: "6332",
    ST: "CT",
    cityWithStateAbbr: "Central Village, CT",
  },
  {
    zip: "6333",
    ST: "CT",
    cityWithStateAbbr: "East Lyme, CT",
  },
  {
    zip: "6334",
    ST: "CT",
    cityWithStateAbbr: "Bozrah, CT",
  },
  {
    zip: "6335",
    ST: "CT",
    cityWithStateAbbr: "Gales Ferry, CT",
  },
  {
    zip: "6336",
    ST: "CT",
    cityWithStateAbbr: "Gilman, CT",
  },
  {
    zip: "6338",
    ST: "CT",
    cityWithStateAbbr: "Mashantucket, CT",
  },
  {
    zip: "6339",
    ST: "CT",
    cityWithStateAbbr: "Ledyard, CT",
  },
  {
    zip: "6340",
    ST: "CT",
    cityWithStateAbbr: "Groton, CT",
  },
  {
    zip: "6349",
    ST: "CT",
    cityWithStateAbbr: "Groton, CT",
  },
  {
    zip: "6350",
    ST: "CT",
    cityWithStateAbbr: "Hanover, CT",
  },
  {
    zip: "6351",
    ST: "CT",
    cityWithStateAbbr: "Jewett City, CT",
  },
  {
    zip: "6353",
    ST: "CT",
    cityWithStateAbbr: "Montville, CT",
  },
  {
    zip: "6354",
    ST: "CT",
    cityWithStateAbbr: "Moosup, CT",
  },
  {
    zip: "6355",
    ST: "CT",
    cityWithStateAbbr: "Mystic, CT",
  },
  {
    zip: "6357",
    ST: "CT",
    cityWithStateAbbr: "Niantic, CT",
  },
  {
    zip: "6359",
    ST: "CT",
    cityWithStateAbbr: "North Stonington, CT",
  },
  {
    zip: "6360",
    ST: "CT",
    cityWithStateAbbr: "Norwich, CT",
  },
  {
    zip: "6365",
    ST: "CT",
    cityWithStateAbbr: "Preston, CT",
  },
  {
    zip: "6370",
    ST: "CT",
    cityWithStateAbbr: "Oakdale, CT",
  },
  {
    zip: "6371",
    ST: "CT",
    cityWithStateAbbr: "Old Lyme, CT",
  },
  {
    zip: "6372",
    ST: "CT",
    cityWithStateAbbr: "Old Mystic, CT",
  },
  {
    zip: "6373",
    ST: "CT",
    cityWithStateAbbr: "Oneco, CT",
  },
  {
    zip: "6374",
    ST: "CT",
    cityWithStateAbbr: "Plainfield, CT",
  },
  {
    zip: "6375",
    ST: "CT",
    cityWithStateAbbr: "Quaker Hill, CT",
  },
  {
    zip: "6376",
    ST: "CT",
    cityWithStateAbbr: "South Lyme, CT",
  },
  {
    zip: "6377",
    ST: "CT",
    cityWithStateAbbr: "Sterling, CT",
  },
  {
    zip: "6378",
    ST: "CT",
    cityWithStateAbbr: "Stonington, CT",
  },
  {
    zip: "6379",
    ST: "CT",
    cityWithStateAbbr: "Pawcatuck, CT",
  },
  {
    zip: "6380",
    ST: "CT",
    cityWithStateAbbr: "Taftville, CT",
  },
  {
    zip: "6382",
    ST: "CT",
    cityWithStateAbbr: "Uncasville, CT",
  },
  {
    zip: "6383",
    ST: "CT",
    cityWithStateAbbr: "Versailles, CT",
  },
  {
    zip: "6384",
    ST: "CT",
    cityWithStateAbbr: "Voluntown, CT",
  },
  {
    zip: "6385",
    ST: "CT",
    cityWithStateAbbr: "Waterford, CT",
  },
  {
    zip: "6387",
    ST: "CT",
    cityWithStateAbbr: "Wauregan, CT",
  },
  {
    zip: "6388",
    ST: "CT",
    cityWithStateAbbr: "West Mystic, CT",
  },
  {
    zip: "6389",
    ST: "CT",
    cityWithStateAbbr: "Yantic, CT",
  },
  {
    zip: "6390",
    ST: "NY",
    cityWithStateAbbr: "Fishers Island, NY",
  },
  {
    zip: "6401",
    ST: "CT",
    cityWithStateAbbr: "Ansonia, CT",
  },
  {
    zip: "6403",
    ST: "CT",
    cityWithStateAbbr: "Beacon Falls, CT",
  },
  {
    zip: "6404",
    ST: "CT",
    cityWithStateAbbr: "Botsford, CT",
  },
  {
    zip: "6405",
    ST: "CT",
    cityWithStateAbbr: "Branford, CT",
  },
  {
    zip: "6408",
    ST: "CT",
    cityWithStateAbbr: "Cheshire, CT",
  },
  {
    zip: "6409",
    ST: "CT",
    cityWithStateAbbr: "Centerbrook, CT",
  },
  {
    zip: "6410",
    ST: "CT",
    cityWithStateAbbr: "Cheshire, CT",
  },
  {
    zip: "6411",
    ST: "CT",
    cityWithStateAbbr: "Cheshire, CT",
  },
  {
    zip: "6412",
    ST: "CT",
    cityWithStateAbbr: "Chester, CT",
  },
  {
    zip: "6413",
    ST: "CT",
    cityWithStateAbbr: "Clinton, CT",
  },
  {
    zip: "6414",
    ST: "CT",
    cityWithStateAbbr: "Cobalt, CT",
  },
  {
    zip: "6415",
    ST: "CT",
    cityWithStateAbbr: "Colchester, CT",
  },
  {
    zip: "6416",
    ST: "CT",
    cityWithStateAbbr: "Cromwell, CT",
  },
  {
    zip: "6417",
    ST: "CT",
    cityWithStateAbbr: "Deep River, CT",
  },
  {
    zip: "6418",
    ST: "CT",
    cityWithStateAbbr: "Derby, CT",
  },
  {
    zip: "6419",
    ST: "CT",
    cityWithStateAbbr: "Killingworth, CT",
  },
  {
    zip: "6420",
    ST: "CT",
    cityWithStateAbbr: "Salem, CT",
  },
  {
    zip: "6422",
    ST: "CT",
    cityWithStateAbbr: "Durham, CT",
  },
  {
    zip: "6423",
    ST: "CT",
    cityWithStateAbbr: "East Haddam, CT",
  },
  {
    zip: "6424",
    ST: "CT",
    cityWithStateAbbr: "East Hampton, CT",
  },
  {
    zip: "6426",
    ST: "CT",
    cityWithStateAbbr: "Essex, CT",
  },
  {
    zip: "6437",
    ST: "CT",
    cityWithStateAbbr: "Guilford, CT",
  },
  {
    zip: "6438",
    ST: "CT",
    cityWithStateAbbr: "Haddam, CT",
  },
  {
    zip: "6439",
    ST: "CT",
    cityWithStateAbbr: "Hadlyme, CT",
  },
  {
    zip: "6440",
    ST: "CT",
    cityWithStateAbbr: "Hawleyville, CT",
  },
  {
    zip: "6441",
    ST: "CT",
    cityWithStateAbbr: "Higganum, CT",
  },
  {
    zip: "6442",
    ST: "CT",
    cityWithStateAbbr: "Ivoryton, CT",
  },
  {
    zip: "6443",
    ST: "CT",
    cityWithStateAbbr: "Madison, CT",
  },
  {
    zip: "6444",
    ST: "CT",
    cityWithStateAbbr: "Marion, CT",
  },
  {
    zip: "6447",
    ST: "CT",
    cityWithStateAbbr: "Marlborough, CT",
  },
  {
    zip: "6450",
    ST: "CT",
    cityWithStateAbbr: "Meriden, CT",
  },
  {
    zip: "6451",
    ST: "CT",
    cityWithStateAbbr: "Meriden, CT",
  },
  {
    zip: "6455",
    ST: "CT",
    cityWithStateAbbr: "Middlefield, CT",
  },
  {
    zip: "6456",
    ST: "CT",
    cityWithStateAbbr: "Middle Haddam, CT",
  },
  {
    zip: "6457",
    ST: "CT",
    cityWithStateAbbr: "Middletown, CT",
  },
  {
    zip: "6459",
    ST: "CT",
    cityWithStateAbbr: "Middletown, CT",
  },
  {
    zip: "6460",
    ST: "CT",
    cityWithStateAbbr: "Milford, CT",
  },
  {
    zip: "6461",
    ST: "CT",
    cityWithStateAbbr: "Milford, CT",
  },
  {
    zip: "6467",
    ST: "CT",
    cityWithStateAbbr: "Milldale, CT",
  },
  {
    zip: "6468",
    ST: "CT",
    cityWithStateAbbr: "Monroe, CT",
  },
  {
    zip: "6469",
    ST: "CT",
    cityWithStateAbbr: "Moodus, CT",
  },
  {
    zip: "6470",
    ST: "CT",
    cityWithStateAbbr: "Newtown, CT",
  },
  {
    zip: "6471",
    ST: "CT",
    cityWithStateAbbr: "North Branford, CT",
  },
  {
    zip: "6472",
    ST: "CT",
    cityWithStateAbbr: "Northford, CT",
  },
  {
    zip: "6473",
    ST: "CT",
    cityWithStateAbbr: "North Haven, CT",
  },
  {
    zip: "6474",
    ST: "CT",
    cityWithStateAbbr: "North Westchester, CT",
  },
  {
    zip: "6475",
    ST: "CT",
    cityWithStateAbbr: "Old Saybrook, CT",
  },
  {
    zip: "6477",
    ST: "CT",
    cityWithStateAbbr: "Orange, CT",
  },
  {
    zip: "6478",
    ST: "CT",
    cityWithStateAbbr: "Oxford, CT",
  },
  {
    zip: "6479",
    ST: "CT",
    cityWithStateAbbr: "Plantsville, CT",
  },
  {
    zip: "6480",
    ST: "CT",
    cityWithStateAbbr: "Portland, CT",
  },
  {
    zip: "6481",
    ST: "CT",
    cityWithStateAbbr: "Rockfall, CT",
  },
  {
    zip: "6482",
    ST: "CT",
    cityWithStateAbbr: "Sandy Hook, CT",
  },
  {
    zip: "6483",
    ST: "CT",
    cityWithStateAbbr: "Seymour, CT",
  },
  {
    zip: "6484",
    ST: "CT",
    cityWithStateAbbr: "Shelton, CT",
  },
  {
    zip: "6487",
    ST: "CT",
    cityWithStateAbbr: "South Britain, CT",
  },
  {
    zip: "6488",
    ST: "CT",
    cityWithStateAbbr: "Southbury, CT",
  },
  {
    zip: "6489",
    ST: "CT",
    cityWithStateAbbr: "Southington, CT",
  },
  {
    zip: "6491",
    ST: "CT",
    cityWithStateAbbr: "Stevenson, CT",
  },
  {
    zip: "6492",
    ST: "CT",
    cityWithStateAbbr: "Wallingford, CT",
  },
  {
    zip: "6493",
    ST: "CT",
    cityWithStateAbbr: "Wallingford, CT",
  },
  {
    zip: "6494",
    ST: "CT",
    cityWithStateAbbr: "Wallingford, CT",
  },
  {
    zip: "6495",
    ST: "CT",
    cityWithStateAbbr: "Wallingford, CT",
  },
  {
    zip: "6498",
    ST: "CT",
    cityWithStateAbbr: "Westbrook, CT",
  },
  {
    zip: "6501",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6502",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6503",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6504",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6505",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6506",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6507",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6508",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6509",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6510",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6511",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6512",
    ST: "CT",
    cityWithStateAbbr: "East Haven, CT",
  },
  {
    zip: "6513",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6514",
    ST: "CT",
    cityWithStateAbbr: "Hamden, CT",
  },
  {
    zip: "6515",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6516",
    ST: "CT",
    cityWithStateAbbr: "West Haven, CT",
  },
  {
    zip: "6517",
    ST: "CT",
    cityWithStateAbbr: "Hamden, CT",
  },
  {
    zip: "6518",
    ST: "CT",
    cityWithStateAbbr: "Hamden, CT",
  },
  {
    zip: "6519",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6520",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6521",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6524",
    ST: "CT",
    cityWithStateAbbr: "Bethany, CT",
  },
  {
    zip: "6525",
    ST: "CT",
    cityWithStateAbbr: "Woodbridge, CT",
  },
  {
    zip: "6530",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6531",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6532",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6533",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6534",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6535",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6536",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6537",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6538",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6540",
    ST: "CT",
    cityWithStateAbbr: "New Haven, CT",
  },
  {
    zip: "6601",
    ST: "CT",
    cityWithStateAbbr: "Bridgeport, CT",
  },
  {
    zip: "6602",
    ST: "CT",
    cityWithStateAbbr: "Bridgeport, CT",
  },
  {
    zip: "6604",
    ST: "CT",
    cityWithStateAbbr: "Bridgeport, CT",
  },
  {
    zip: "6605",
    ST: "CT",
    cityWithStateAbbr: "Bridgeport, CT",
  },
  {
    zip: "6606",
    ST: "CT",
    cityWithStateAbbr: "Bridgeport, CT",
  },
  {
    zip: "6607",
    ST: "CT",
    cityWithStateAbbr: "Bridgeport, CT",
  },
  {
    zip: "6608",
    ST: "CT",
    cityWithStateAbbr: "Bridgeport, CT",
  },
  {
    zip: "6610",
    ST: "CT",
    cityWithStateAbbr: "Bridgeport, CT",
  },
  {
    zip: "6611",
    ST: "CT",
    cityWithStateAbbr: "Trumbull, CT",
  },
  {
    zip: "6612",
    ST: "CT",
    cityWithStateAbbr: "Easton, CT",
  },
  {
    zip: "6614",
    ST: "CT",
    cityWithStateAbbr: "Stratford, CT",
  },
  {
    zip: "6615",
    ST: "CT",
    cityWithStateAbbr: "Stratford, CT",
  },
  {
    zip: "6673",
    ST: "CT",
    cityWithStateAbbr: "Bridgeport, CT",
  },
  {
    zip: "6699",
    ST: "CT",
    cityWithStateAbbr: "Bridgeport, CT",
  },
  {
    zip: "6701",
    ST: "CT",
    cityWithStateAbbr: "Waterbury, CT",
  },
  {
    zip: "6702",
    ST: "CT",
    cityWithStateAbbr: "Waterbury, CT",
  },
  {
    zip: "6703",
    ST: "CT",
    cityWithStateAbbr: "Waterbury, CT",
  },
  {
    zip: "6704",
    ST: "CT",
    cityWithStateAbbr: "Waterbury, CT",
  },
  {
    zip: "6705",
    ST: "CT",
    cityWithStateAbbr: "Waterbury, CT",
  },
  {
    zip: "6706",
    ST: "CT",
    cityWithStateAbbr: "Waterbury, CT",
  },
  {
    zip: "6708",
    ST: "CT",
    cityWithStateAbbr: "Waterbury, CT",
  },
  {
    zip: "6710",
    ST: "CT",
    cityWithStateAbbr: "Waterbury, CT",
  },
  {
    zip: "6712",
    ST: "CT",
    cityWithStateAbbr: "Prospect, CT",
  },
  {
    zip: "6716",
    ST: "CT",
    cityWithStateAbbr: "Wolcott, CT",
  },
  {
    zip: "6720",
    ST: "CT",
    cityWithStateAbbr: "Waterbury, CT",
  },
  {
    zip: "6721",
    ST: "CT",
    cityWithStateAbbr: "Waterbury, CT",
  },
  {
    zip: "6722",
    ST: "CT",
    cityWithStateAbbr: "Waterbury, CT",
  },
  {
    zip: "6723",
    ST: "CT",
    cityWithStateAbbr: "Waterbury, CT",
  },
  {
    zip: "6724",
    ST: "CT",
    cityWithStateAbbr: "Waterbury, CT",
  },
  {
    zip: "6725",
    ST: "CT",
    cityWithStateAbbr: "Waterbury, CT",
  },
  {
    zip: "6726",
    ST: "CT",
    cityWithStateAbbr: "Waterbury, CT",
  },
  {
    zip: "6749",
    ST: "CT",
    cityWithStateAbbr: "Waterbury, CT",
  },
  {
    zip: "6750",
    ST: "CT",
    cityWithStateAbbr: "Bantam, CT",
  },
  {
    zip: "6751",
    ST: "CT",
    cityWithStateAbbr: "Bethlehem, CT",
  },
  {
    zip: "6752",
    ST: "CT",
    cityWithStateAbbr: "Bridgewater, CT",
  },
  {
    zip: "6753",
    ST: "CT",
    cityWithStateAbbr: "Cornwall, CT",
  },
  {
    zip: "6754",
    ST: "CT",
    cityWithStateAbbr: "Cornwall Bridge, CT",
  },
  {
    zip: "6755",
    ST: "CT",
    cityWithStateAbbr: "Gaylordsville, CT",
  },
  {
    zip: "6756",
    ST: "CT",
    cityWithStateAbbr: "Goshen, CT",
  },
  {
    zip: "6757",
    ST: "CT",
    cityWithStateAbbr: "Kent, CT",
  },
  {
    zip: "6758",
    ST: "CT",
    cityWithStateAbbr: "Lakeside, CT",
  },
  {
    zip: "6759",
    ST: "CT",
    cityWithStateAbbr: "Litchfield, CT",
  },
  {
    zip: "6762",
    ST: "CT",
    cityWithStateAbbr: "Middlebury, CT",
  },
  {
    zip: "6763",
    ST: "CT",
    cityWithStateAbbr: "Morris, CT",
  },
  {
    zip: "6770",
    ST: "CT",
    cityWithStateAbbr: "Naugatuck, CT",
  },
  {
    zip: "6776",
    ST: "CT",
    cityWithStateAbbr: "New Milford, CT",
  },
  {
    zip: "6777",
    ST: "CT",
    cityWithStateAbbr: "New Preston Marble Dale, CT",
  },
  {
    zip: "6778",
    ST: "CT",
    cityWithStateAbbr: "Northfield, CT",
  },
  {
    zip: "6779",
    ST: "CT",
    cityWithStateAbbr: "Oakville, CT",
  },
  {
    zip: "6781",
    ST: "CT",
    cityWithStateAbbr: "Pequabuck, CT",
  },
  {
    zip: "6782",
    ST: "CT",
    cityWithStateAbbr: "Plymouth, CT",
  },
  {
    zip: "6783",
    ST: "CT",
    cityWithStateAbbr: "Roxbury, CT",
  },
  {
    zip: "6784",
    ST: "CT",
    cityWithStateAbbr: "Sherman, CT",
  },
  {
    zip: "6785",
    ST: "CT",
    cityWithStateAbbr: "South Kent, CT",
  },
  {
    zip: "6786",
    ST: "CT",
    cityWithStateAbbr: "Terryville, CT",
  },
  {
    zip: "6787",
    ST: "CT",
    cityWithStateAbbr: "Thomaston, CT",
  },
  {
    zip: "6790",
    ST: "CT",
    cityWithStateAbbr: "Torrington, CT",
  },
  {
    zip: "6791",
    ST: "CT",
    cityWithStateAbbr: "Harwinton, CT",
  },
  {
    zip: "6792",
    ST: "CT",
    cityWithStateAbbr: "Torrington, CT",
  },
  {
    zip: "6793",
    ST: "CT",
    cityWithStateAbbr: "Washington, CT",
  },
  {
    zip: "6794",
    ST: "CT",
    cityWithStateAbbr: "Washington Depot, CT",
  },
  {
    zip: "6795",
    ST: "CT",
    cityWithStateAbbr: "Watertown, CT",
  },
  {
    zip: "6796",
    ST: "CT",
    cityWithStateAbbr: "West Cornwall, CT",
  },
  {
    zip: "6798",
    ST: "CT",
    cityWithStateAbbr: "Woodbury, CT",
  },
  {
    zip: "6801",
    ST: "CT",
    cityWithStateAbbr: "Bethel, CT",
  },
  {
    zip: "6804",
    ST: "CT",
    cityWithStateAbbr: "Brookfield, CT",
  },
  {
    zip: "6807",
    ST: "CT",
    cityWithStateAbbr: "Cos Cob, CT",
  },
  {
    zip: "6810",
    ST: "CT",
    cityWithStateAbbr: "Danbury, CT",
  },
  {
    zip: "6811",
    ST: "CT",
    cityWithStateAbbr: "Danbury, CT",
  },
  {
    zip: "6812",
    ST: "CT",
    cityWithStateAbbr: "New Fairfield, CT",
  },
  {
    zip: "6813",
    ST: "CT",
    cityWithStateAbbr: "Danbury, CT",
  },
  {
    zip: "6814",
    ST: "CT",
    cityWithStateAbbr: "Danbury, CT",
  },
  {
    zip: "6816",
    ST: "CT",
    cityWithStateAbbr: "Danbury, CT",
  },
  {
    zip: "6817",
    ST: "CT",
    cityWithStateAbbr: "Danbury, CT",
  },
  {
    zip: "6820",
    ST: "CT",
    cityWithStateAbbr: "Darien, CT",
  },
  {
    zip: "6824",
    ST: "CT",
    cityWithStateAbbr: "Fairfield, CT",
  },
  {
    zip: "6825",
    ST: "CT",
    cityWithStateAbbr: "Fairfield, CT",
  },
  {
    zip: "6828",
    ST: "CT",
    cityWithStateAbbr: "Fairfield, CT",
  },
  {
    zip: "6829",
    ST: "CT",
    cityWithStateAbbr: "Georgetown, CT",
  },
  {
    zip: "6830",
    ST: "CT",
    cityWithStateAbbr: "Greenwich, CT",
  },
  {
    zip: "6831",
    ST: "CT",
    cityWithStateAbbr: "Greenwich, CT",
  },
  {
    zip: "6836",
    ST: "CT",
    cityWithStateAbbr: "Greenwich, CT",
  },
  {
    zip: "6838",
    ST: "CT",
    cityWithStateAbbr: "Greens Farms, CT",
  },
  {
    zip: "6840",
    ST: "CT",
    cityWithStateAbbr: "New Canaan, CT",
  },
  {
    zip: "6850",
    ST: "CT",
    cityWithStateAbbr: "Norwalk, CT",
  },
  {
    zip: "6851",
    ST: "CT",
    cityWithStateAbbr: "Norwalk, CT",
  },
  {
    zip: "6852",
    ST: "CT",
    cityWithStateAbbr: "Norwalk, CT",
  },
  {
    zip: "6853",
    ST: "CT",
    cityWithStateAbbr: "Norwalk, CT",
  },
  {
    zip: "6854",
    ST: "CT",
    cityWithStateAbbr: "Norwalk, CT",
  },
  {
    zip: "6855",
    ST: "CT",
    cityWithStateAbbr: "Norwalk, CT",
  },
  {
    zip: "6856",
    ST: "CT",
    cityWithStateAbbr: "Norwalk, CT",
  },
  {
    zip: "6857",
    ST: "CT",
    cityWithStateAbbr: "Norwalk, CT",
  },
  {
    zip: "6858",
    ST: "CT",
    cityWithStateAbbr: "Norwalk, CT",
  },
  {
    zip: "6859",
    ST: "CT",
    cityWithStateAbbr: "Norwalk, CT",
  },
  {
    zip: "6860",
    ST: "CT",
    cityWithStateAbbr: "Norwalk, CT",
  },
  {
    zip: "6870",
    ST: "CT",
    cityWithStateAbbr: "Old Greenwich, CT",
  },
  {
    zip: "6875",
    ST: "CT",
    cityWithStateAbbr: "Redding Center, CT",
  },
  {
    zip: "6876",
    ST: "CT",
    cityWithStateAbbr: "Redding Ridge, CT",
  },
  {
    zip: "6877",
    ST: "CT",
    cityWithStateAbbr: "Ridgefield, CT",
  },
  {
    zip: "6878",
    ST: "CT",
    cityWithStateAbbr: "Riverside, CT",
  },
  {
    zip: "6879",
    ST: "CT",
    cityWithStateAbbr: "Ridgefield, CT",
  },
  {
    zip: "6880",
    ST: "CT",
    cityWithStateAbbr: "Westport, CT",
  },
  {
    zip: "6881",
    ST: "CT",
    cityWithStateAbbr: "Westport, CT",
  },
  {
    zip: "6883",
    ST: "CT",
    cityWithStateAbbr: "Weston, CT",
  },
  {
    zip: "6888",
    ST: "CT",
    cityWithStateAbbr: "Westport, CT",
  },
  {
    zip: "6889",
    ST: "CT",
    cityWithStateAbbr: "Westport, CT",
  },
  {
    zip: "6890",
    ST: "CT",
    cityWithStateAbbr: "Southport, CT",
  },
  {
    zip: "6896",
    ST: "CT",
    cityWithStateAbbr: "Redding, CT",
  },
  {
    zip: "6897",
    ST: "CT",
    cityWithStateAbbr: "Wilton, CT",
  },
  {
    zip: "6901",
    ST: "CT",
    cityWithStateAbbr: "Stamford, CT",
  },
  {
    zip: "6902",
    ST: "CT",
    cityWithStateAbbr: "Stamford, CT",
  },
  {
    zip: "6903",
    ST: "CT",
    cityWithStateAbbr: "Stamford, CT",
  },
  {
    zip: "6904",
    ST: "CT",
    cityWithStateAbbr: "Stamford, CT",
  },
  {
    zip: "6905",
    ST: "CT",
    cityWithStateAbbr: "Stamford, CT",
  },
  {
    zip: "6906",
    ST: "CT",
    cityWithStateAbbr: "Stamford, CT",
  },
  {
    zip: "6907",
    ST: "CT",
    cityWithStateAbbr: "Stamford, CT",
  },
  {
    zip: "6910",
    ST: "CT",
    cityWithStateAbbr: "Stamford, CT",
  },
  {
    zip: "6911",
    ST: "CT",
    cityWithStateAbbr: "Stamford, CT",
  },
  {
    zip: "6912",
    ST: "CT",
    cityWithStateAbbr: "Stamford, CT",
  },
  {
    zip: "6913",
    ST: "CT",
    cityWithStateAbbr: "Stamford, CT",
  },
  {
    zip: "6920",
    ST: "CT",
    cityWithStateAbbr: "Stamford, CT",
  },
  {
    zip: "6921",
    ST: "CT",
    cityWithStateAbbr: "Stamford, CT",
  },
  {
    zip: "6922",
    ST: "CT",
    cityWithStateAbbr: "Stamford, CT",
  },
  {
    zip: "6925",
    ST: "CT",
    cityWithStateAbbr: "Stamford, CT",
  },
  {
    zip: "6926",
    ST: "CT",
    cityWithStateAbbr: "Stamford, CT",
  },
  {
    zip: "6927",
    ST: "CT",
    cityWithStateAbbr: "Stamford, CT",
  },
  {
    zip: "6928",
    ST: "CT",
    cityWithStateAbbr: "Stamford, CT",
  },
  {
    zip: "7001",
    ST: "NJ",
    cityWithStateAbbr: "Avenel, NJ",
  },
  {
    zip: "7002",
    ST: "NJ",
    cityWithStateAbbr: "Bayonne, NJ",
  },
  {
    zip: "7003",
    ST: "NJ",
    cityWithStateAbbr: "Bloomfield, NJ",
  },
  {
    zip: "7004",
    ST: "NJ",
    cityWithStateAbbr: "Fairfield, NJ",
  },
  {
    zip: "7005",
    ST: "NJ",
    cityWithStateAbbr: "Boonton, NJ",
  },
  {
    zip: "7006",
    ST: "NJ",
    cityWithStateAbbr: "Caldwell, NJ",
  },
  {
    zip: "7007",
    ST: "NJ",
    cityWithStateAbbr: "Caldwell, NJ",
  },
  {
    zip: "7008",
    ST: "NJ",
    cityWithStateAbbr: "Carteret, NJ",
  },
  {
    zip: "7009",
    ST: "NJ",
    cityWithStateAbbr: "Cedar Grove, NJ",
  },
  {
    zip: "7010",
    ST: "NJ",
    cityWithStateAbbr: "Cliffside Park, NJ",
  },
  {
    zip: "7011",
    ST: "NJ",
    cityWithStateAbbr: "Clifton, NJ",
  },
  {
    zip: "7012",
    ST: "NJ",
    cityWithStateAbbr: "Clifton, NJ",
  },
  {
    zip: "7013",
    ST: "NJ",
    cityWithStateAbbr: "Clifton, NJ",
  },
  {
    zip: "7014",
    ST: "NJ",
    cityWithStateAbbr: "Clifton, NJ",
  },
  {
    zip: "7015",
    ST: "NJ",
    cityWithStateAbbr: "Clifton, NJ",
  },
  {
    zip: "7016",
    ST: "NJ",
    cityWithStateAbbr: "Cranford, NJ",
  },
  {
    zip: "7017",
    ST: "NJ",
    cityWithStateAbbr: "East Orange, NJ",
  },
  {
    zip: "7018",
    ST: "NJ",
    cityWithStateAbbr: "East Orange, NJ",
  },
  {
    zip: "7019",
    ST: "NJ",
    cityWithStateAbbr: "East Orange, NJ",
  },
  {
    zip: "7020",
    ST: "NJ",
    cityWithStateAbbr: "Edgewater, NJ",
  },
  {
    zip: "7021",
    ST: "NJ",
    cityWithStateAbbr: "Essex Fells, NJ",
  },
  {
    zip: "7022",
    ST: "NJ",
    cityWithStateAbbr: "Fairview, NJ",
  },
  {
    zip: "7023",
    ST: "NJ",
    cityWithStateAbbr: "Fanwood, NJ",
  },
  {
    zip: "7024",
    ST: "NJ",
    cityWithStateAbbr: "Fort Lee, NJ",
  },
  {
    zip: "7026",
    ST: "NJ",
    cityWithStateAbbr: "Garfield, NJ",
  },
  {
    zip: "7027",
    ST: "NJ",
    cityWithStateAbbr: "Garwood, NJ",
  },
  {
    zip: "7028",
    ST: "NJ",
    cityWithStateAbbr: "Glen Ridge, NJ",
  },
  {
    zip: "7029",
    ST: "NJ",
    cityWithStateAbbr: "Harrison, NJ",
  },
  {
    zip: "7030",
    ST: "NJ",
    cityWithStateAbbr: "Hoboken, NJ",
  },
  {
    zip: "7031",
    ST: "NJ",
    cityWithStateAbbr: "North Arlington, NJ",
  },
  {
    zip: "7032",
    ST: "NJ",
    cityWithStateAbbr: "Kearny, NJ",
  },
  {
    zip: "7033",
    ST: "NJ",
    cityWithStateAbbr: "Kenilworth, NJ",
  },
  {
    zip: "7034",
    ST: "NJ",
    cityWithStateAbbr: "Lake Hiawatha, NJ",
  },
  {
    zip: "7035",
    ST: "NJ",
    cityWithStateAbbr: "Lincoln Park, NJ",
  },
  {
    zip: "7036",
    ST: "NJ",
    cityWithStateAbbr: "Linden, NJ",
  },
  {
    zip: "7039",
    ST: "NJ",
    cityWithStateAbbr: "Livingston, NJ",
  },
  {
    zip: "7040",
    ST: "NJ",
    cityWithStateAbbr: "Maplewood, NJ",
  },
  {
    zip: "7041",
    ST: "NJ",
    cityWithStateAbbr: "Millburn, NJ",
  },
  {
    zip: "7042",
    ST: "NJ",
    cityWithStateAbbr: "Montclair, NJ",
  },
  {
    zip: "7043",
    ST: "NJ",
    cityWithStateAbbr: "Montclair, NJ",
  },
  {
    zip: "7044",
    ST: "NJ",
    cityWithStateAbbr: "Verona, NJ",
  },
  {
    zip: "7045",
    ST: "NJ",
    cityWithStateAbbr: "Montville, NJ",
  },
  {
    zip: "7046",
    ST: "NJ",
    cityWithStateAbbr: "Mountain Lakes, NJ",
  },
  {
    zip: "7047",
    ST: "NJ",
    cityWithStateAbbr: "North Bergen, NJ",
  },
  {
    zip: "7050",
    ST: "NJ",
    cityWithStateAbbr: "Orange, NJ",
  },
  {
    zip: "7051",
    ST: "NJ",
    cityWithStateAbbr: "Orange, NJ",
  },
  {
    zip: "7052",
    ST: "NJ",
    cityWithStateAbbr: "West Orange, NJ",
  },
  {
    zip: "7054",
    ST: "NJ",
    cityWithStateAbbr: "Parsippany, NJ",
  },
  {
    zip: "7055",
    ST: "NJ",
    cityWithStateAbbr: "Passaic, NJ",
  },
  {
    zip: "7057",
    ST: "NJ",
    cityWithStateAbbr: "Wallington, NJ",
  },
  {
    zip: "7058",
    ST: "NJ",
    cityWithStateAbbr: "Pine Brook, NJ",
  },
  {
    zip: "7059",
    ST: "NJ",
    cityWithStateAbbr: "Warren, NJ",
  },
  {
    zip: "7060",
    ST: "NJ",
    cityWithStateAbbr: "Plainfield, NJ",
  },
  {
    zip: "7061",
    ST: "NJ",
    cityWithStateAbbr: "Plainfield, NJ",
  },
  {
    zip: "7062",
    ST: "NJ",
    cityWithStateAbbr: "Plainfield, NJ",
  },
  {
    zip: "7063",
    ST: "NJ",
    cityWithStateAbbr: "Plainfield, NJ",
  },
  {
    zip: "7064",
    ST: "NJ",
    cityWithStateAbbr: "Port Reading, NJ",
  },
  {
    zip: "7065",
    ST: "NJ",
    cityWithStateAbbr: "Rahway, NJ",
  },
  {
    zip: "7066",
    ST: "NJ",
    cityWithStateAbbr: "Clark, NJ",
  },
  {
    zip: "7067",
    ST: "NJ",
    cityWithStateAbbr: "Colonia, NJ",
  },
  {
    zip: "7068",
    ST: "NJ",
    cityWithStateAbbr: "Roseland, NJ",
  },
  {
    zip: "7069",
    ST: "NJ",
    cityWithStateAbbr: "Watchung, NJ",
  },
  {
    zip: "7070",
    ST: "NJ",
    cityWithStateAbbr: "Rutherford, NJ",
  },
  {
    zip: "7071",
    ST: "NJ",
    cityWithStateAbbr: "Lyndhurst, NJ",
  },
  {
    zip: "7072",
    ST: "NJ",
    cityWithStateAbbr: "Carlstadt, NJ",
  },
  {
    zip: "7073",
    ST: "NJ",
    cityWithStateAbbr: "East Rutherford, NJ",
  },
  {
    zip: "7074",
    ST: "NJ",
    cityWithStateAbbr: "Moonachie, NJ",
  },
  {
    zip: "7075",
    ST: "NJ",
    cityWithStateAbbr: "Wood Ridge, NJ",
  },
  {
    zip: "7076",
    ST: "NJ",
    cityWithStateAbbr: "Scotch Plains, NJ",
  },
  {
    zip: "7077",
    ST: "NJ",
    cityWithStateAbbr: "Sewaren, NJ",
  },
  {
    zip: "7078",
    ST: "NJ",
    cityWithStateAbbr: "Short Hills, NJ",
  },
  {
    zip: "7079",
    ST: "NJ",
    cityWithStateAbbr: "South Orange, NJ",
  },
  {
    zip: "7080",
    ST: "NJ",
    cityWithStateAbbr: "South Plainfield, NJ",
  },
  {
    zip: "7081",
    ST: "NJ",
    cityWithStateAbbr: "Springfield, NJ",
  },
  {
    zip: "7082",
    ST: "NJ",
    cityWithStateAbbr: "Towaco, NJ",
  },
  {
    zip: "7083",
    ST: "NJ",
    cityWithStateAbbr: "Union, NJ",
  },
  {
    zip: "7086",
    ST: "NJ",
    cityWithStateAbbr: "Weehawken, NJ",
  },
  {
    zip: "7087",
    ST: "NJ",
    cityWithStateAbbr: "Union City, NJ",
  },
  {
    zip: "7088",
    ST: "NJ",
    cityWithStateAbbr: "Vauxhall, NJ",
  },
  {
    zip: "7090",
    ST: "NJ",
    cityWithStateAbbr: "Westfield, NJ",
  },
  {
    zip: "7091",
    ST: "NJ",
    cityWithStateAbbr: "Westfield, NJ",
  },
  {
    zip: "7092",
    ST: "NJ",
    cityWithStateAbbr: "Mountainside, NJ",
  },
  {
    zip: "7093",
    ST: "NJ",
    cityWithStateAbbr: "West New York, NJ",
  },
  {
    zip: "7094",
    ST: "NJ",
    cityWithStateAbbr: "Secaucus, NJ",
  },
  {
    zip: "7095",
    ST: "NJ",
    cityWithStateAbbr: "Woodbridge, NJ",
  },
  {
    zip: "7096",
    ST: "NJ",
    cityWithStateAbbr: "Secaucus, NJ",
  },
  {
    zip: "7097",
    ST: "NJ",
    cityWithStateAbbr: "Jersey City, NJ",
  },
  {
    zip: "7099",
    ST: "NJ",
    cityWithStateAbbr: "Kearny, NJ",
  },
  {
    zip: "7101",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7102",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7103",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7104",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7105",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7106",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7107",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7108",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7109",
    ST: "NJ",
    cityWithStateAbbr: "Belleville, NJ",
  },
  {
    zip: "7110",
    ST: "NJ",
    cityWithStateAbbr: "Nutley, NJ",
  },
  {
    zip: "7111",
    ST: "NJ",
    cityWithStateAbbr: "Irvington, NJ",
  },
  {
    zip: "7112",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7114",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7175",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7184",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7188",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7189",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7191",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7192",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7193",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7195",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7198",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7199",
    ST: "NJ",
    cityWithStateAbbr: "Newark, NJ",
  },
  {
    zip: "7201",
    ST: "NJ",
    cityWithStateAbbr: "Elizabeth, NJ",
  },
  {
    zip: "7202",
    ST: "NJ",
    cityWithStateAbbr: "Elizabeth, NJ",
  },
  {
    zip: "7203",
    ST: "NJ",
    cityWithStateAbbr: "Roselle, NJ",
  },
  {
    zip: "7204",
    ST: "NJ",
    cityWithStateAbbr: "Roselle Park, NJ",
  },
  {
    zip: "7205",
    ST: "NJ",
    cityWithStateAbbr: "Hillside, NJ",
  },
  {
    zip: "7206",
    ST: "NJ",
    cityWithStateAbbr: "Elizabethport, NJ",
  },
  {
    zip: "7207",
    ST: "NJ",
    cityWithStateAbbr: "Elizabeth, NJ",
  },
  {
    zip: "7208",
    ST: "NJ",
    cityWithStateAbbr: "Elizabeth, NJ",
  },
  {
    zip: "7302",
    ST: "NJ",
    cityWithStateAbbr: "Jersey City, NJ",
  },
  {
    zip: "7303",
    ST: "NJ",
    cityWithStateAbbr: "Jersey City, NJ",
  },
  {
    zip: "7304",
    ST: "NJ",
    cityWithStateAbbr: "Jersey City, NJ",
  },
  {
    zip: "7305",
    ST: "NJ",
    cityWithStateAbbr: "Jersey City, NJ",
  },
  {
    zip: "7306",
    ST: "NJ",
    cityWithStateAbbr: "Jersey City, NJ",
  },
  {
    zip: "7307",
    ST: "NJ",
    cityWithStateAbbr: "Jersey City, NJ",
  },
  {
    zip: "7308",
    ST: "NJ",
    cityWithStateAbbr: "Jersey City, NJ",
  },
  {
    zip: "7310",
    ST: "NJ",
    cityWithStateAbbr: "Jersey City, NJ",
  },
  {
    zip: "7311",
    ST: "NJ",
    cityWithStateAbbr: "Jersey City, NJ",
  },
  {
    zip: "7395",
    ST: "NJ",
    cityWithStateAbbr: "Jersey City, NJ",
  },
  {
    zip: "7399",
    ST: "NJ",
    cityWithStateAbbr: "Jersey City, NJ",
  },
  {
    zip: "7401",
    ST: "NJ",
    cityWithStateAbbr: "Allendale, NJ",
  },
  {
    zip: "7403",
    ST: "NJ",
    cityWithStateAbbr: "Bloomingdale, NJ",
  },
  {
    zip: "7405",
    ST: "NJ",
    cityWithStateAbbr: "Butler, NJ",
  },
  {
    zip: "7407",
    ST: "NJ",
    cityWithStateAbbr: "Elmwood Park, NJ",
  },
  {
    zip: "7410",
    ST: "NJ",
    cityWithStateAbbr: "Fair Lawn, NJ",
  },
  {
    zip: "7416",
    ST: "NJ",
    cityWithStateAbbr: "Franklin, NJ",
  },
  {
    zip: "7417",
    ST: "NJ",
    cityWithStateAbbr: "Franklin Lakes, NJ",
  },
  {
    zip: "7418",
    ST: "NJ",
    cityWithStateAbbr: "Glenwood, NJ",
  },
  {
    zip: "7419",
    ST: "NJ",
    cityWithStateAbbr: "Hamburg, NJ",
  },
  {
    zip: "7420",
    ST: "NJ",
    cityWithStateAbbr: "Haskell, NJ",
  },
  {
    zip: "7421",
    ST: "NJ",
    cityWithStateAbbr: "Hewitt, NJ",
  },
  {
    zip: "7422",
    ST: "NJ",
    cityWithStateAbbr: "Highland Lakes, NJ",
  },
  {
    zip: "7423",
    ST: "NJ",
    cityWithStateAbbr: "Ho Ho Kus, NJ",
  },
  {
    zip: "7424",
    ST: "NJ",
    cityWithStateAbbr: "Little Falls, NJ",
  },
  {
    zip: "7428",
    ST: "NJ",
    cityWithStateAbbr: "Mc Afee, NJ",
  },
  {
    zip: "7430",
    ST: "NJ",
    cityWithStateAbbr: "Mahwah, NJ",
  },
  {
    zip: "7432",
    ST: "NJ",
    cityWithStateAbbr: "Midland Park, NJ",
  },
  {
    zip: "7435",
    ST: "NJ",
    cityWithStateAbbr: "Newfoundland, NJ",
  },
  {
    zip: "7436",
    ST: "NJ",
    cityWithStateAbbr: "Oakland, NJ",
  },
  {
    zip: "7438",
    ST: "NJ",
    cityWithStateAbbr: "Oak Ridge, NJ",
  },
  {
    zip: "7439",
    ST: "NJ",
    cityWithStateAbbr: "Ogdensburg, NJ",
  },
  {
    zip: "7440",
    ST: "NJ",
    cityWithStateAbbr: "Pequannock, NJ",
  },
  {
    zip: "7442",
    ST: "NJ",
    cityWithStateAbbr: "Pompton Lakes, NJ",
  },
  {
    zip: "7444",
    ST: "NJ",
    cityWithStateAbbr: "Pompton Plains, NJ",
  },
  {
    zip: "7446",
    ST: "NJ",
    cityWithStateAbbr: "Ramsey, NJ",
  },
  {
    zip: "7450",
    ST: "NJ",
    cityWithStateAbbr: "Ridgewood, NJ",
  },
  {
    zip: "7451",
    ST: "NJ",
    cityWithStateAbbr: "Ridgewood, NJ",
  },
  {
    zip: "7452",
    ST: "NJ",
    cityWithStateAbbr: "Glen Rock, NJ",
  },
  {
    zip: "7456",
    ST: "NJ",
    cityWithStateAbbr: "Ringwood, NJ",
  },
  {
    zip: "7457",
    ST: "NJ",
    cityWithStateAbbr: "Riverdale, NJ",
  },
  {
    zip: "7458",
    ST: "NJ",
    cityWithStateAbbr: "Saddle River, NJ",
  },
  {
    zip: "7460",
    ST: "NJ",
    cityWithStateAbbr: "Stockholm, NJ",
  },
  {
    zip: "7461",
    ST: "NJ",
    cityWithStateAbbr: "Sussex, NJ",
  },
  {
    zip: "7462",
    ST: "NJ",
    cityWithStateAbbr: "Vernon, NJ",
  },
  {
    zip: "7463",
    ST: "NJ",
    cityWithStateAbbr: "Waldwick, NJ",
  },
  {
    zip: "7465",
    ST: "NJ",
    cityWithStateAbbr: "Wanaque, NJ",
  },
  {
    zip: "7470",
    ST: "NJ",
    cityWithStateAbbr: "Wayne, NJ",
  },
  {
    zip: "7474",
    ST: "NJ",
    cityWithStateAbbr: "Wayne, NJ",
  },
  {
    zip: "7480",
    ST: "NJ",
    cityWithStateAbbr: "West Milford, NJ",
  },
  {
    zip: "7481",
    ST: "NJ",
    cityWithStateAbbr: "Wyckoff, NJ",
  },
  {
    zip: "7495",
    ST: "NJ",
    cityWithStateAbbr: "Mahwah, NJ",
  },
  {
    zip: "7501",
    ST: "NJ",
    cityWithStateAbbr: "Paterson, NJ",
  },
  {
    zip: "7502",
    ST: "NJ",
    cityWithStateAbbr: "Paterson, NJ",
  },
  {
    zip: "7503",
    ST: "NJ",
    cityWithStateAbbr: "Paterson, NJ",
  },
  {
    zip: "7504",
    ST: "NJ",
    cityWithStateAbbr: "Paterson, NJ",
  },
  {
    zip: "7505",
    ST: "NJ",
    cityWithStateAbbr: "Paterson, NJ",
  },
  {
    zip: "7506",
    ST: "NJ",
    cityWithStateAbbr: "Hawthorne, NJ",
  },
  {
    zip: "7507",
    ST: "NJ",
    cityWithStateAbbr: "Hawthorne, NJ",
  },
  {
    zip: "7508",
    ST: "NJ",
    cityWithStateAbbr: "Haledon, NJ",
  },
  {
    zip: "7509",
    ST: "NJ",
    cityWithStateAbbr: "Paterson, NJ",
  },
  {
    zip: "7510",
    ST: "NJ",
    cityWithStateAbbr: "Paterson, NJ",
  },
  {
    zip: "7511",
    ST: "NJ",
    cityWithStateAbbr: "Totowa, NJ",
  },
  {
    zip: "7512",
    ST: "NJ",
    cityWithStateAbbr: "Totowa, NJ",
  },
  {
    zip: "7513",
    ST: "NJ",
    cityWithStateAbbr: "Paterson, NJ",
  },
  {
    zip: "7514",
    ST: "NJ",
    cityWithStateAbbr: "Paterson, NJ",
  },
  {
    zip: "7522",
    ST: "NJ",
    cityWithStateAbbr: "Paterson, NJ",
  },
  {
    zip: "7524",
    ST: "NJ",
    cityWithStateAbbr: "Paterson, NJ",
  },
  {
    zip: "7533",
    ST: "NJ",
    cityWithStateAbbr: "Paterson, NJ",
  },
  {
    zip: "7538",
    ST: "NJ",
    cityWithStateAbbr: "Haledon, NJ",
  },
  {
    zip: "7543",
    ST: "NJ",
    cityWithStateAbbr: "Paterson, NJ",
  },
  {
    zip: "7544",
    ST: "NJ",
    cityWithStateAbbr: "Paterson, NJ",
  },
  {
    zip: "7601",
    ST: "NJ",
    cityWithStateAbbr: "Hackensack, NJ",
  },
  {
    zip: "7602",
    ST: "NJ",
    cityWithStateAbbr: "Hackensack, NJ",
  },
  {
    zip: "7603",
    ST: "NJ",
    cityWithStateAbbr: "Bogota, NJ",
  },
  {
    zip: "7604",
    ST: "NJ",
    cityWithStateAbbr: "Hasbrouck Heights, NJ",
  },
  {
    zip: "7605",
    ST: "NJ",
    cityWithStateAbbr: "Leonia, NJ",
  },
  {
    zip: "7606",
    ST: "NJ",
    cityWithStateAbbr: "South Hackensack, NJ",
  },
  {
    zip: "7607",
    ST: "NJ",
    cityWithStateAbbr: "Maywood, NJ",
  },
  {
    zip: "7608",
    ST: "NJ",
    cityWithStateAbbr: "Teterboro, NJ",
  },
  {
    zip: "7620",
    ST: "NJ",
    cityWithStateAbbr: "Alpine, NJ",
  },
  {
    zip: "7621",
    ST: "NJ",
    cityWithStateAbbr: "Bergenfield, NJ",
  },
  {
    zip: "7624",
    ST: "NJ",
    cityWithStateAbbr: "Closter, NJ",
  },
  {
    zip: "7626",
    ST: "NJ",
    cityWithStateAbbr: "Cresskill, NJ",
  },
  {
    zip: "7627",
    ST: "NJ",
    cityWithStateAbbr: "Demarest, NJ",
  },
  {
    zip: "7628",
    ST: "NJ",
    cityWithStateAbbr: "Dumont, NJ",
  },
  {
    zip: "7630",
    ST: "NJ",
    cityWithStateAbbr: "Emerson, NJ",
  },
  {
    zip: "7631",
    ST: "NJ",
    cityWithStateAbbr: "Englewood, NJ",
  },
  {
    zip: "7632",
    ST: "NJ",
    cityWithStateAbbr: "Englewood Cliffs, NJ",
  },
  {
    zip: "7640",
    ST: "NJ",
    cityWithStateAbbr: "Harrington Park, NJ",
  },
  {
    zip: "7641",
    ST: "NJ",
    cityWithStateAbbr: "Haworth, NJ",
  },
  {
    zip: "7642",
    ST: "NJ",
    cityWithStateAbbr: "Hillsdale, NJ",
  },
  {
    zip: "7643",
    ST: "NJ",
    cityWithStateAbbr: "Little Ferry, NJ",
  },
  {
    zip: "7644",
    ST: "NJ",
    cityWithStateAbbr: "Lodi, NJ",
  },
  {
    zip: "7645",
    ST: "NJ",
    cityWithStateAbbr: "Montvale, NJ",
  },
  {
    zip: "7646",
    ST: "NJ",
    cityWithStateAbbr: "New Milford, NJ",
  },
  {
    zip: "7647",
    ST: "NJ",
    cityWithStateAbbr: "Northvale, NJ",
  },
  {
    zip: "7648",
    ST: "NJ",
    cityWithStateAbbr: "Norwood, NJ",
  },
  {
    zip: "7649",
    ST: "NJ",
    cityWithStateAbbr: "Oradell, NJ",
  },
  {
    zip: "7650",
    ST: "NJ",
    cityWithStateAbbr: "Palisades Park, NJ",
  },
  {
    zip: "7652",
    ST: "NJ",
    cityWithStateAbbr: "Paramus, NJ",
  },
  {
    zip: "7653",
    ST: "NJ",
    cityWithStateAbbr: "Paramus, NJ",
  },
  {
    zip: "7656",
    ST: "NJ",
    cityWithStateAbbr: "Park Ridge, NJ",
  },
  {
    zip: "7657",
    ST: "NJ",
    cityWithStateAbbr: "Ridgefield, NJ",
  },
  {
    zip: "7660",
    ST: "NJ",
    cityWithStateAbbr: "Ridgefield Park, NJ",
  },
  {
    zip: "7661",
    ST: "NJ",
    cityWithStateAbbr: "River Edge, NJ",
  },
  {
    zip: "7662",
    ST: "NJ",
    cityWithStateAbbr: "Rochelle Park, NJ",
  },
  {
    zip: "7663",
    ST: "NJ",
    cityWithStateAbbr: "Saddle Brook, NJ",
  },
  {
    zip: "7666",
    ST: "NJ",
    cityWithStateAbbr: "Teaneck, NJ",
  },
  {
    zip: "7670",
    ST: "NJ",
    cityWithStateAbbr: "Tenafly, NJ",
  },
  {
    zip: "7675",
    ST: "NJ",
    cityWithStateAbbr: "Westwood, NJ",
  },
  {
    zip: "7676",
    ST: "NJ",
    cityWithStateAbbr: "Township Of Washington, NJ",
  },
  {
    zip: "7677",
    ST: "NJ",
    cityWithStateAbbr: "Woodcliff Lake, NJ",
  },
  {
    zip: "7699",
    ST: "NJ",
    cityWithStateAbbr: "Teterboro, NJ",
  },
  {
    zip: "7701",
    ST: "NJ",
    cityWithStateAbbr: "Red Bank, NJ",
  },
  {
    zip: "7702",
    ST: "NJ",
    cityWithStateAbbr: "Shrewsbury, NJ",
  },
  {
    zip: "7703",
    ST: "NJ",
    cityWithStateAbbr: "Fort Monmouth, NJ",
  },
  {
    zip: "7704",
    ST: "NJ",
    cityWithStateAbbr: "Fair Haven, NJ",
  },
  {
    zip: "7709",
    ST: "NJ",
    cityWithStateAbbr: "Red Bank, NJ",
  },
  {
    zip: "7710",
    ST: "NJ",
    cityWithStateAbbr: "Adelphia, NJ",
  },
  {
    zip: "7711",
    ST: "NJ",
    cityWithStateAbbr: "Allenhurst, NJ",
  },
  {
    zip: "7712",
    ST: "NJ",
    cityWithStateAbbr: "Asbury Park, NJ",
  },
  {
    zip: "7715",
    ST: "NJ",
    cityWithStateAbbr: "Belmar, NJ",
  },
  {
    zip: "7716",
    ST: "NJ",
    cityWithStateAbbr: "Atlantic Highlands, NJ",
  },
  {
    zip: "7717",
    ST: "NJ",
    cityWithStateAbbr: "Avon By The Sea, NJ",
  },
  {
    zip: "7718",
    ST: "NJ",
    cityWithStateAbbr: "Belford, NJ",
  },
  {
    zip: "7719",
    ST: "NJ",
    cityWithStateAbbr: "Belmar, NJ",
  },
  {
    zip: "7720",
    ST: "NJ",
    cityWithStateAbbr: "Bradley Beach, NJ",
  },
  {
    zip: "7721",
    ST: "NJ",
    cityWithStateAbbr: "Cliffwood, NJ",
  },
  {
    zip: "7722",
    ST: "NJ",
    cityWithStateAbbr: "Colts Neck, NJ",
  },
  {
    zip: "7723",
    ST: "NJ",
    cityWithStateAbbr: "Deal, NJ",
  },
  {
    zip: "7724",
    ST: "NJ",
    cityWithStateAbbr: "Eatontown, NJ",
  },
  {
    zip: "7726",
    ST: "NJ",
    cityWithStateAbbr: "Englishtown, NJ",
  },
  {
    zip: "7727",
    ST: "NJ",
    cityWithStateAbbr: "Farmingdale, NJ",
  },
  {
    zip: "7728",
    ST: "NJ",
    cityWithStateAbbr: "Freehold, NJ",
  },
  {
    zip: "7730",
    ST: "NJ",
    cityWithStateAbbr: "Hazlet, NJ",
  },
  {
    zip: "7731",
    ST: "NJ",
    cityWithStateAbbr: "Howell, NJ",
  },
  {
    zip: "7732",
    ST: "NJ",
    cityWithStateAbbr: "Highlands, NJ",
  },
  {
    zip: "7733",
    ST: "NJ",
    cityWithStateAbbr: "Holmdel, NJ",
  },
  {
    zip: "7734",
    ST: "NJ",
    cityWithStateAbbr: "Keansburg, NJ",
  },
  {
    zip: "7735",
    ST: "NJ",
    cityWithStateAbbr: "Keyport, NJ",
  },
  {
    zip: "7737",
    ST: "NJ",
    cityWithStateAbbr: "Leonardo, NJ",
  },
  {
    zip: "7738",
    ST: "NJ",
    cityWithStateAbbr: "Lincroft, NJ",
  },
  {
    zip: "7739",
    ST: "NJ",
    cityWithStateAbbr: "Little Silver, NJ",
  },
  {
    zip: "7740",
    ST: "NJ",
    cityWithStateAbbr: "Long Branch, NJ",
  },
  {
    zip: "7746",
    ST: "NJ",
    cityWithStateAbbr: "Marlboro, NJ",
  },
  {
    zip: "7747",
    ST: "NJ",
    cityWithStateAbbr: "Matawan, NJ",
  },
  {
    zip: "7748",
    ST: "NJ",
    cityWithStateAbbr: "Middletown, NJ",
  },
  {
    zip: "7750",
    ST: "NJ",
    cityWithStateAbbr: "Monmouth Beach, NJ",
  },
  {
    zip: "7751",
    ST: "NJ",
    cityWithStateAbbr: "Morganville, NJ",
  },
  {
    zip: "7752",
    ST: "NJ",
    cityWithStateAbbr: "Navesink, NJ",
  },
  {
    zip: "7753",
    ST: "NJ",
    cityWithStateAbbr: "Neptune, NJ",
  },
  {
    zip: "7754",
    ST: "NJ",
    cityWithStateAbbr: "Neptune, NJ",
  },
  {
    zip: "7755",
    ST: "NJ",
    cityWithStateAbbr: "Oakhurst, NJ",
  },
  {
    zip: "7756",
    ST: "NJ",
    cityWithStateAbbr: "Ocean Grove, NJ",
  },
  {
    zip: "7757",
    ST: "NJ",
    cityWithStateAbbr: "Oceanport, NJ",
  },
  {
    zip: "7758",
    ST: "NJ",
    cityWithStateAbbr: "Port Monmouth, NJ",
  },
  {
    zip: "7760",
    ST: "NJ",
    cityWithStateAbbr: "Rumson, NJ",
  },
  {
    zip: "7762",
    ST: "NJ",
    cityWithStateAbbr: "Spring Lake, NJ",
  },
  {
    zip: "7763",
    ST: "NJ",
    cityWithStateAbbr: "Tennent, NJ",
  },
  {
    zip: "7764",
    ST: "NJ",
    cityWithStateAbbr: "West Long Branch, NJ",
  },
  {
    zip: "7765",
    ST: "NJ",
    cityWithStateAbbr: "Wickatunk, NJ",
  },
  {
    zip: "7799",
    ST: "NJ",
    cityWithStateAbbr: "Eatontown, NJ",
  },
  {
    zip: "7801",
    ST: "NJ",
    cityWithStateAbbr: "Dover, NJ",
  },
  {
    zip: "7802",
    ST: "NJ",
    cityWithStateAbbr: "Dover, NJ",
  },
  {
    zip: "7803",
    ST: "NJ",
    cityWithStateAbbr: "Mine Hill, NJ",
  },
  {
    zip: "7806",
    ST: "NJ",
    cityWithStateAbbr: "Picatinny Arsenal, NJ",
  },
  {
    zip: "7820",
    ST: "NJ",
    cityWithStateAbbr: "Allamuchy, NJ",
  },
  {
    zip: "7821",
    ST: "NJ",
    cityWithStateAbbr: "Andover, NJ",
  },
  {
    zip: "7822",
    ST: "NJ",
    cityWithStateAbbr: "Augusta, NJ",
  },
  {
    zip: "7823",
    ST: "NJ",
    cityWithStateAbbr: "Belvidere, NJ",
  },
  {
    zip: "7825",
    ST: "NJ",
    cityWithStateAbbr: "Blairstown, NJ",
  },
  {
    zip: "7826",
    ST: "NJ",
    cityWithStateAbbr: "Branchville, NJ",
  },
  {
    zip: "7827",
    ST: "NJ",
    cityWithStateAbbr: "Montague, NJ",
  },
  {
    zip: "7828",
    ST: "NJ",
    cityWithStateAbbr: "Budd Lake, NJ",
  },
  {
    zip: "7829",
    ST: "NJ",
    cityWithStateAbbr: "Buttzville, NJ",
  },
  {
    zip: "7830",
    ST: "NJ",
    cityWithStateAbbr: "Califon, NJ",
  },
  {
    zip: "7831",
    ST: "NJ",
    cityWithStateAbbr: "Changewater, NJ",
  },
  {
    zip: "7832",
    ST: "NJ",
    cityWithStateAbbr: "Columbia, NJ",
  },
  {
    zip: "7833",
    ST: "NJ",
    cityWithStateAbbr: "Delaware, NJ",
  },
  {
    zip: "7834",
    ST: "NJ",
    cityWithStateAbbr: "Denville, NJ",
  },
  {
    zip: "7836",
    ST: "NJ",
    cityWithStateAbbr: "Flanders, NJ",
  },
  {
    zip: "7837",
    ST: "NJ",
    cityWithStateAbbr: "Glasser, NJ",
  },
  {
    zip: "7838",
    ST: "NJ",
    cityWithStateAbbr: "Great Meadows, NJ",
  },
  {
    zip: "7839",
    ST: "NJ",
    cityWithStateAbbr: "Greendell, NJ",
  },
  {
    zip: "7840",
    ST: "NJ",
    cityWithStateAbbr: "Hackettstown, NJ",
  },
  {
    zip: "7842",
    ST: "NJ",
    cityWithStateAbbr: "Hibernia, NJ",
  },
  {
    zip: "7843",
    ST: "NJ",
    cityWithStateAbbr: "Hopatcong, NJ",
  },
  {
    zip: "7844",
    ST: "NJ",
    cityWithStateAbbr: "Hope, NJ",
  },
  {
    zip: "7845",
    ST: "NJ",
    cityWithStateAbbr: "Ironia, NJ",
  },
  {
    zip: "7846",
    ST: "NJ",
    cityWithStateAbbr: "Johnsonburg, NJ",
  },
  {
    zip: "7847",
    ST: "NJ",
    cityWithStateAbbr: "Kenvil, NJ",
  },
  {
    zip: "7848",
    ST: "NJ",
    cityWithStateAbbr: "Lafayette, NJ",
  },
  {
    zip: "7849",
    ST: "NJ",
    cityWithStateAbbr: "Lake Hopatcong, NJ",
  },
  {
    zip: "7850",
    ST: "NJ",
    cityWithStateAbbr: "Landing, NJ",
  },
  {
    zip: "7851",
    ST: "NJ",
    cityWithStateAbbr: "Layton, NJ",
  },
  {
    zip: "7852",
    ST: "NJ",
    cityWithStateAbbr: "Ledgewood, NJ",
  },
  {
    zip: "7853",
    ST: "NJ",
    cityWithStateAbbr: "Long Valley, NJ",
  },
  {
    zip: "7855",
    ST: "NJ",
    cityWithStateAbbr: "Middleville, NJ",
  },
  {
    zip: "7856",
    ST: "NJ",
    cityWithStateAbbr: "Mount Arlington, NJ",
  },
  {
    zip: "7857",
    ST: "NJ",
    cityWithStateAbbr: "Netcong, NJ",
  },
  {
    zip: "7860",
    ST: "NJ",
    cityWithStateAbbr: "Newton, NJ",
  },
  {
    zip: "7863",
    ST: "NJ",
    cityWithStateAbbr: "Oxford, NJ",
  },
  {
    zip: "7865",
    ST: "NJ",
    cityWithStateAbbr: "Port Murray, NJ",
  },
  {
    zip: "7866",
    ST: "NJ",
    cityWithStateAbbr: "Rockaway, NJ",
  },
  {
    zip: "7869",
    ST: "NJ",
    cityWithStateAbbr: "Randolph, NJ",
  },
  {
    zip: "7870",
    ST: "NJ",
    cityWithStateAbbr: "Schooleys Mountain, NJ",
  },
  {
    zip: "7871",
    ST: "NJ",
    cityWithStateAbbr: "Sparta, NJ",
  },
  {
    zip: "7874",
    ST: "NJ",
    cityWithStateAbbr: "Stanhope, NJ",
  },
  {
    zip: "7875",
    ST: "NJ",
    cityWithStateAbbr: "Stillwater, NJ",
  },
  {
    zip: "7876",
    ST: "NJ",
    cityWithStateAbbr: "Succasunna, NJ",
  },
  {
    zip: "7877",
    ST: "NJ",
    cityWithStateAbbr: "Swartswood, NJ",
  },
  {
    zip: "7878",
    ST: "NJ",
    cityWithStateAbbr: "Mount Tabor, NJ",
  },
  {
    zip: "7879",
    ST: "NJ",
    cityWithStateAbbr: "Tranquility, NJ",
  },
  {
    zip: "7880",
    ST: "NJ",
    cityWithStateAbbr: "Vienna, NJ",
  },
  {
    zip: "7881",
    ST: "NJ",
    cityWithStateAbbr: "Wallpack Center, NJ",
  },
  {
    zip: "7882",
    ST: "NJ",
    cityWithStateAbbr: "Washington, NJ",
  },
  {
    zip: "7885",
    ST: "NJ",
    cityWithStateAbbr: "Wharton, NJ",
  },
  {
    zip: "7890",
    ST: "NJ",
    cityWithStateAbbr: "Branchville, NJ",
  },
  {
    zip: "7901",
    ST: "NJ",
    cityWithStateAbbr: "Summit, NJ",
  },
  {
    zip: "7902",
    ST: "NJ",
    cityWithStateAbbr: "Summit, NJ",
  },
  {
    zip: "7920",
    ST: "NJ",
    cityWithStateAbbr: "Basking Ridge, NJ",
  },
  {
    zip: "7921",
    ST: "NJ",
    cityWithStateAbbr: "Bedminster, NJ",
  },
  {
    zip: "7922",
    ST: "NJ",
    cityWithStateAbbr: "Berkeley Heights, NJ",
  },
  {
    zip: "7924",
    ST: "NJ",
    cityWithStateAbbr: "Bernardsville, NJ",
  },
  {
    zip: "7926",
    ST: "NJ",
    cityWithStateAbbr: "Brookside, NJ",
  },
  {
    zip: "7927",
    ST: "NJ",
    cityWithStateAbbr: "Cedar Knolls, NJ",
  },
  {
    zip: "7928",
    ST: "NJ",
    cityWithStateAbbr: "Chatham, NJ",
  },
  {
    zip: "7930",
    ST: "NJ",
    cityWithStateAbbr: "Chester, NJ",
  },
  {
    zip: "7931",
    ST: "NJ",
    cityWithStateAbbr: "Far Hills, NJ",
  },
  {
    zip: "7932",
    ST: "NJ",
    cityWithStateAbbr: "Florham Park, NJ",
  },
  {
    zip: "7933",
    ST: "NJ",
    cityWithStateAbbr: "Gillette, NJ",
  },
  {
    zip: "7934",
    ST: "NJ",
    cityWithStateAbbr: "Gladstone, NJ",
  },
  {
    zip: "7935",
    ST: "NJ",
    cityWithStateAbbr: "Green Village, NJ",
  },
  {
    zip: "7936",
    ST: "NJ",
    cityWithStateAbbr: "East Hanover, NJ",
  },
  {
    zip: "7938",
    ST: "NJ",
    cityWithStateAbbr: "Liberty Corner, NJ",
  },
  {
    zip: "7939",
    ST: "NJ",
    cityWithStateAbbr: "Lyons, NJ",
  },
  {
    zip: "7940",
    ST: "NJ",
    cityWithStateAbbr: "Madison, NJ",
  },
  {
    zip: "7945",
    ST: "NJ",
    cityWithStateAbbr: "Mendham, NJ",
  },
  {
    zip: "7946",
    ST: "NJ",
    cityWithStateAbbr: "Millington, NJ",
  },
  {
    zip: "7950",
    ST: "NJ",
    cityWithStateAbbr: "Morris Plains, NJ",
  },
  {
    zip: "7960",
    ST: "NJ",
    cityWithStateAbbr: "Morristown, NJ",
  },
  {
    zip: "7961",
    ST: "NJ",
    cityWithStateAbbr: "Convent Station, NJ",
  },
  {
    zip: "7962",
    ST: "NJ",
    cityWithStateAbbr: "Morristown, NJ",
  },
  {
    zip: "7963",
    ST: "NJ",
    cityWithStateAbbr: "Morristown, NJ",
  },
  {
    zip: "7970",
    ST: "NJ",
    cityWithStateAbbr: "Mount Freedom, NJ",
  },
  {
    zip: "7974",
    ST: "NJ",
    cityWithStateAbbr: "New Providence, NJ",
  },
  {
    zip: "7976",
    ST: "NJ",
    cityWithStateAbbr: "New Vernon, NJ",
  },
  {
    zip: "7977",
    ST: "NJ",
    cityWithStateAbbr: "Peapack, NJ",
  },
  {
    zip: "7978",
    ST: "NJ",
    cityWithStateAbbr: "Pluckemin, NJ",
  },
  {
    zip: "7979",
    ST: "NJ",
    cityWithStateAbbr: "Pottersville, NJ",
  },
  {
    zip: "7980",
    ST: "NJ",
    cityWithStateAbbr: "Stirling, NJ",
  },
  {
    zip: "7981",
    ST: "NJ",
    cityWithStateAbbr: "Whippany, NJ",
  },
  {
    zip: "7999",
    ST: "NJ",
    cityWithStateAbbr: "Whippany, NJ",
  },
  {
    zip: "8001",
    ST: "NJ",
    cityWithStateAbbr: "Alloway, NJ",
  },
  {
    zip: "8002",
    ST: "NJ",
    cityWithStateAbbr: "Cherry Hill, NJ",
  },
  {
    zip: "8003",
    ST: "NJ",
    cityWithStateAbbr: "Cherry Hill, NJ",
  },
  {
    zip: "8004",
    ST: "NJ",
    cityWithStateAbbr: "Atco, NJ",
  },
  {
    zip: "8005",
    ST: "NJ",
    cityWithStateAbbr: "Barnegat, NJ",
  },
  {
    zip: "8006",
    ST: "NJ",
    cityWithStateAbbr: "Barnegat Light, NJ",
  },
  {
    zip: "8007",
    ST: "NJ",
    cityWithStateAbbr: "Barrington, NJ",
  },
  {
    zip: "8008",
    ST: "NJ",
    cityWithStateAbbr: "Beach Haven, NJ",
  },
  {
    zip: "8009",
    ST: "NJ",
    cityWithStateAbbr: "Berlin, NJ",
  },
  {
    zip: "8010",
    ST: "NJ",
    cityWithStateAbbr: "Beverly, NJ",
  },
  {
    zip: "8011",
    ST: "NJ",
    cityWithStateAbbr: "Birmingham, NJ",
  },
  {
    zip: "8012",
    ST: "NJ",
    cityWithStateAbbr: "Blackwood, NJ",
  },
  {
    zip: "8014",
    ST: "NJ",
    cityWithStateAbbr: "Bridgeport, NJ",
  },
  {
    zip: "8015",
    ST: "NJ",
    cityWithStateAbbr: "Browns Mills, NJ",
  },
  {
    zip: "8016",
    ST: "NJ",
    cityWithStateAbbr: "Burlington, NJ",
  },
  {
    zip: "8018",
    ST: "NJ",
    cityWithStateAbbr: "Cedar Brook, NJ",
  },
  {
    zip: "8019",
    ST: "NJ",
    cityWithStateAbbr: "Chatsworth, NJ",
  },
  {
    zip: "8020",
    ST: "NJ",
    cityWithStateAbbr: "Clarksboro, NJ",
  },
  {
    zip: "8021",
    ST: "NJ",
    cityWithStateAbbr: "Clementon, NJ",
  },
  {
    zip: "8022",
    ST: "NJ",
    cityWithStateAbbr: "Columbus, NJ",
  },
  {
    zip: "8023",
    ST: "NJ",
    cityWithStateAbbr: "Deepwater, NJ",
  },
  {
    zip: "8025",
    ST: "NJ",
    cityWithStateAbbr: "Ewan, NJ",
  },
  {
    zip: "8026",
    ST: "NJ",
    cityWithStateAbbr: "Gibbsboro, NJ",
  },
  {
    zip: "8027",
    ST: "NJ",
    cityWithStateAbbr: "Gibbstown, NJ",
  },
  {
    zip: "8028",
    ST: "NJ",
    cityWithStateAbbr: "Glassboro, NJ",
  },
  {
    zip: "8029",
    ST: "NJ",
    cityWithStateAbbr: "Glendora, NJ",
  },
  {
    zip: "8030",
    ST: "NJ",
    cityWithStateAbbr: "Gloucester City, NJ",
  },
  {
    zip: "8031",
    ST: "NJ",
    cityWithStateAbbr: "Bellmawr, NJ",
  },
  {
    zip: "8032",
    ST: "NJ",
    cityWithStateAbbr: "Grenloch, NJ",
  },
  {
    zip: "8033",
    ST: "NJ",
    cityWithStateAbbr: "Haddonfield, NJ",
  },
  {
    zip: "8034",
    ST: "NJ",
    cityWithStateAbbr: "Cherry Hill, NJ",
  },
  {
    zip: "8035",
    ST: "NJ",
    cityWithStateAbbr: "Haddon Heights, NJ",
  },
  {
    zip: "8036",
    ST: "NJ",
    cityWithStateAbbr: "Hainesport, NJ",
  },
  {
    zip: "8037",
    ST: "NJ",
    cityWithStateAbbr: "Hammonton, NJ",
  },
  {
    zip: "8038",
    ST: "NJ",
    cityWithStateAbbr: "Hancocks Bridge, NJ",
  },
  {
    zip: "8039",
    ST: "NJ",
    cityWithStateAbbr: "Harrisonville, NJ",
  },
  {
    zip: "8041",
    ST: "NJ",
    cityWithStateAbbr: "Jobstown, NJ",
  },
  {
    zip: "8042",
    ST: "NJ",
    cityWithStateAbbr: "Juliustown, NJ",
  },
  {
    zip: "8043",
    ST: "NJ",
    cityWithStateAbbr: "Voorhees, NJ",
  },
  {
    zip: "8045",
    ST: "NJ",
    cityWithStateAbbr: "Lawnside, NJ",
  },
  {
    zip: "8046",
    ST: "NJ",
    cityWithStateAbbr: "Willingboro, NJ",
  },
  {
    zip: "8048",
    ST: "NJ",
    cityWithStateAbbr: "Lumberton, NJ",
  },
  {
    zip: "8049",
    ST: "NJ",
    cityWithStateAbbr: "Magnolia, NJ",
  },
  {
    zip: "8050",
    ST: "NJ",
    cityWithStateAbbr: "Manahawkin, NJ",
  },
  {
    zip: "8051",
    ST: "NJ",
    cityWithStateAbbr: "Mantua, NJ",
  },
  {
    zip: "8052",
    ST: "NJ",
    cityWithStateAbbr: "Maple Shade, NJ",
  },
  {
    zip: "8053",
    ST: "NJ",
    cityWithStateAbbr: "Marlton, NJ",
  },
  {
    zip: "8054",
    ST: "NJ",
    cityWithStateAbbr: "Mount Laurel, NJ",
  },
  {
    zip: "8055",
    ST: "NJ",
    cityWithStateAbbr: "Medford, NJ",
  },
  {
    zip: "8056",
    ST: "NJ",
    cityWithStateAbbr: "Mickleton, NJ",
  },
  {
    zip: "8057",
    ST: "NJ",
    cityWithStateAbbr: "Moorestown, NJ",
  },
  {
    zip: "8059",
    ST: "NJ",
    cityWithStateAbbr: "Mount Ephraim, NJ",
  },
  {
    zip: "8060",
    ST: "NJ",
    cityWithStateAbbr: "Mount Holly, NJ",
  },
  {
    zip: "8061",
    ST: "NJ",
    cityWithStateAbbr: "Mount Royal, NJ",
  },
  {
    zip: "8062",
    ST: "NJ",
    cityWithStateAbbr: "Mullica Hill, NJ",
  },
  {
    zip: "8063",
    ST: "NJ",
    cityWithStateAbbr: "National Park, NJ",
  },
  {
    zip: "8064",
    ST: "NJ",
    cityWithStateAbbr: "New Lisbon, NJ",
  },
  {
    zip: "8065",
    ST: "NJ",
    cityWithStateAbbr: "Palmyra, NJ",
  },
  {
    zip: "8066",
    ST: "NJ",
    cityWithStateAbbr: "Paulsboro, NJ",
  },
  {
    zip: "8067",
    ST: "NJ",
    cityWithStateAbbr: "Pedricktown, NJ",
  },
  {
    zip: "8068",
    ST: "NJ",
    cityWithStateAbbr: "Pemberton, NJ",
  },
  {
    zip: "8069",
    ST: "NJ",
    cityWithStateAbbr: "Penns Grove, NJ",
  },
  {
    zip: "8070",
    ST: "NJ",
    cityWithStateAbbr: "Pennsville, NJ",
  },
  {
    zip: "8071",
    ST: "NJ",
    cityWithStateAbbr: "Pitman, NJ",
  },
  {
    zip: "8072",
    ST: "NJ",
    cityWithStateAbbr: "Quinton, NJ",
  },
  {
    zip: "8073",
    ST: "NJ",
    cityWithStateAbbr: "Rancocas, NJ",
  },
  {
    zip: "8074",
    ST: "NJ",
    cityWithStateAbbr: "Richwood, NJ",
  },
  {
    zip: "8075",
    ST: "NJ",
    cityWithStateAbbr: "Riverside, NJ",
  },
  {
    zip: "8076",
    ST: "NJ",
    cityWithStateAbbr: "Riverton, NJ",
  },
  {
    zip: "8077",
    ST: "NJ",
    cityWithStateAbbr: "Riverton, NJ",
  },
  {
    zip: "8078",
    ST: "NJ",
    cityWithStateAbbr: "Runnemede, NJ",
  },
  {
    zip: "8079",
    ST: "NJ",
    cityWithStateAbbr: "Salem, NJ",
  },
  {
    zip: "8080",
    ST: "NJ",
    cityWithStateAbbr: "Sewell, NJ",
  },
  {
    zip: "8081",
    ST: "NJ",
    cityWithStateAbbr: "Sicklerville, NJ",
  },
  {
    zip: "8083",
    ST: "NJ",
    cityWithStateAbbr: "Somerdale, NJ",
  },
  {
    zip: "8084",
    ST: "NJ",
    cityWithStateAbbr: "Stratford, NJ",
  },
  {
    zip: "8085",
    ST: "NJ",
    cityWithStateAbbr: "Swedesboro, NJ",
  },
  {
    zip: "8086",
    ST: "NJ",
    cityWithStateAbbr: "Thorofare, NJ",
  },
  {
    zip: "8087",
    ST: "NJ",
    cityWithStateAbbr: "Tuckerton, NJ",
  },
  {
    zip: "8088",
    ST: "NJ",
    cityWithStateAbbr: "Vincentown, NJ",
  },
  {
    zip: "8089",
    ST: "NJ",
    cityWithStateAbbr: "Waterford Works, NJ",
  },
  {
    zip: "8090",
    ST: "NJ",
    cityWithStateAbbr: "Wenonah, NJ",
  },
  {
    zip: "8091",
    ST: "NJ",
    cityWithStateAbbr: "West Berlin, NJ",
  },
  {
    zip: "8092",
    ST: "NJ",
    cityWithStateAbbr: "West Creek, NJ",
  },
  {
    zip: "8093",
    ST: "NJ",
    cityWithStateAbbr: "Westville, NJ",
  },
  {
    zip: "8094",
    ST: "NJ",
    cityWithStateAbbr: "Williamstown, NJ",
  },
  {
    zip: "8095",
    ST: "NJ",
    cityWithStateAbbr: "Winslow, NJ",
  },
  {
    zip: "8096",
    ST: "NJ",
    cityWithStateAbbr: "Woodbury, NJ",
  },
  {
    zip: "8097",
    ST: "NJ",
    cityWithStateAbbr: "Woodbury Heights, NJ",
  },
  {
    zip: "8098",
    ST: "NJ",
    cityWithStateAbbr: "Woodstown, NJ",
  },
  {
    zip: "8099",
    ST: "NJ",
    cityWithStateAbbr: "Bellmawr, NJ",
  },
  {
    zip: "8101",
    ST: "NJ",
    cityWithStateAbbr: "Camden, NJ",
  },
  {
    zip: "8102",
    ST: "NJ",
    cityWithStateAbbr: "Camden, NJ",
  },
  {
    zip: "8103",
    ST: "NJ",
    cityWithStateAbbr: "Camden, NJ",
  },
  {
    zip: "8104",
    ST: "NJ",
    cityWithStateAbbr: "Camden, NJ",
  },
  {
    zip: "8105",
    ST: "NJ",
    cityWithStateAbbr: "Camden, NJ",
  },
  {
    zip: "8106",
    ST: "NJ",
    cityWithStateAbbr: "Audubon, NJ",
  },
  {
    zip: "8107",
    ST: "NJ",
    cityWithStateAbbr: "Oaklyn, NJ",
  },
  {
    zip: "8108",
    ST: "NJ",
    cityWithStateAbbr: "Collingswood, NJ",
  },
  {
    zip: "8109",
    ST: "NJ",
    cityWithStateAbbr: "Merchantville, NJ",
  },
  {
    zip: "8110",
    ST: "NJ",
    cityWithStateAbbr: "Pennsauken, NJ",
  },
  {
    zip: "8201",
    ST: "NJ",
    cityWithStateAbbr: "Absecon, NJ",
  },
  {
    zip: "8202",
    ST: "NJ",
    cityWithStateAbbr: "Avalon, NJ",
  },
  {
    zip: "8203",
    ST: "NJ",
    cityWithStateAbbr: "Brigantine, NJ",
  },
  {
    zip: "8204",
    ST: "NJ",
    cityWithStateAbbr: "Cape May, NJ",
  },
  {
    zip: "8205",
    ST: "NJ",
    cityWithStateAbbr: "Absecon, NJ",
  },
  {
    zip: "8210",
    ST: "NJ",
    cityWithStateAbbr: "Cape May Court House, NJ",
  },
  {
    zip: "8212",
    ST: "NJ",
    cityWithStateAbbr: "Cape May Point, NJ",
  },
  {
    zip: "8213",
    ST: "NJ",
    cityWithStateAbbr: "Cologne, NJ",
  },
  {
    zip: "8214",
    ST: "NJ",
    cityWithStateAbbr: "Dennisville, NJ",
  },
  {
    zip: "8215",
    ST: "NJ",
    cityWithStateAbbr: "Egg Harbor City, NJ",
  },
  {
    zip: "8217",
    ST: "NJ",
    cityWithStateAbbr: "Elwood, NJ",
  },
  {
    zip: "8218",
    ST: "NJ",
    cityWithStateAbbr: "Goshen, NJ",
  },
  {
    zip: "8219",
    ST: "NJ",
    cityWithStateAbbr: "Green Creek, NJ",
  },
  {
    zip: "8220",
    ST: "NJ",
    cityWithStateAbbr: "Leeds Point, NJ",
  },
  {
    zip: "8221",
    ST: "NJ",
    cityWithStateAbbr: "Linwood, NJ",
  },
  {
    zip: "8223",
    ST: "NJ",
    cityWithStateAbbr: "Marmora, NJ",
  },
  {
    zip: "8224",
    ST: "NJ",
    cityWithStateAbbr: "New Gretna, NJ",
  },
  {
    zip: "8225",
    ST: "NJ",
    cityWithStateAbbr: "Northfield, NJ",
  },
  {
    zip: "8226",
    ST: "NJ",
    cityWithStateAbbr: "Ocean City, NJ",
  },
  {
    zip: "8230",
    ST: "NJ",
    cityWithStateAbbr: "Ocean View, NJ",
  },
  {
    zip: "8231",
    ST: "NJ",
    cityWithStateAbbr: "Oceanville, NJ",
  },
  {
    zip: "8232",
    ST: "NJ",
    cityWithStateAbbr: "Pleasantville, NJ",
  },
  {
    zip: "8234",
    ST: "NJ",
    cityWithStateAbbr: "Egg Harbor Township, NJ",
  },
  {
    zip: "8240",
    ST: "NJ",
    cityWithStateAbbr: "Pomona, NJ",
  },
  {
    zip: "8241",
    ST: "NJ",
    cityWithStateAbbr: "Port Republic, NJ",
  },
  {
    zip: "8242",
    ST: "NJ",
    cityWithStateAbbr: "Rio Grande, NJ",
  },
  {
    zip: "8243",
    ST: "NJ",
    cityWithStateAbbr: "Sea Isle City, NJ",
  },
  {
    zip: "8244",
    ST: "NJ",
    cityWithStateAbbr: "Somers Point, NJ",
  },
  {
    zip: "8245",
    ST: "NJ",
    cityWithStateAbbr: "South Dennis, NJ",
  },
  {
    zip: "8246",
    ST: "NJ",
    cityWithStateAbbr: "South Seaville, NJ",
  },
  {
    zip: "8247",
    ST: "NJ",
    cityWithStateAbbr: "Stone Harbor, NJ",
  },
  {
    zip: "8248",
    ST: "NJ",
    cityWithStateAbbr: "Strathmere, NJ",
  },
  {
    zip: "8250",
    ST: "NJ",
    cityWithStateAbbr: "Tuckahoe, NJ",
  },
  {
    zip: "8251",
    ST: "NJ",
    cityWithStateAbbr: "Villas, NJ",
  },
  {
    zip: "8252",
    ST: "NJ",
    cityWithStateAbbr: "Whitesboro, NJ",
  },
  {
    zip: "8260",
    ST: "NJ",
    cityWithStateAbbr: "Wildwood, NJ",
  },
  {
    zip: "8270",
    ST: "NJ",
    cityWithStateAbbr: "Woodbine, NJ",
  },
  {
    zip: "8302",
    ST: "NJ",
    cityWithStateAbbr: "Bridgeton, NJ",
  },
  {
    zip: "8310",
    ST: "NJ",
    cityWithStateAbbr: "Buena, NJ",
  },
  {
    zip: "8311",
    ST: "NJ",
    cityWithStateAbbr: "Cedarville, NJ",
  },
  {
    zip: "8312",
    ST: "NJ",
    cityWithStateAbbr: "Clayton, NJ",
  },
  {
    zip: "8313",
    ST: "NJ",
    cityWithStateAbbr: "Deerfield Street, NJ",
  },
  {
    zip: "8314",
    ST: "NJ",
    cityWithStateAbbr: "Delmont, NJ",
  },
  {
    zip: "8315",
    ST: "NJ",
    cityWithStateAbbr: "Dividing Creek, NJ",
  },
  {
    zip: "8316",
    ST: "NJ",
    cityWithStateAbbr: "Dorchester, NJ",
  },
  {
    zip: "8317",
    ST: "NJ",
    cityWithStateAbbr: "Dorothy, NJ",
  },
  {
    zip: "8318",
    ST: "NJ",
    cityWithStateAbbr: "Elmer, NJ",
  },
  {
    zip: "8319",
    ST: "NJ",
    cityWithStateAbbr: "Estell Manor, NJ",
  },
  {
    zip: "8320",
    ST: "NJ",
    cityWithStateAbbr: "Fairton, NJ",
  },
  {
    zip: "8321",
    ST: "NJ",
    cityWithStateAbbr: "Fortescue, NJ",
  },
  {
    zip: "8322",
    ST: "NJ",
    cityWithStateAbbr: "Franklinville, NJ",
  },
  {
    zip: "8323",
    ST: "NJ",
    cityWithStateAbbr: "Greenwich, NJ",
  },
  {
    zip: "8324",
    ST: "NJ",
    cityWithStateAbbr: "Heislerville, NJ",
  },
  {
    zip: "8326",
    ST: "NJ",
    cityWithStateAbbr: "Landisville, NJ",
  },
  {
    zip: "8327",
    ST: "NJ",
    cityWithStateAbbr: "Leesburg, NJ",
  },
  {
    zip: "8328",
    ST: "NJ",
    cityWithStateAbbr: "Malaga, NJ",
  },
  {
    zip: "8329",
    ST: "NJ",
    cityWithStateAbbr: "Mauricetown, NJ",
  },
  {
    zip: "8330",
    ST: "NJ",
    cityWithStateAbbr: "Mays Landing, NJ",
  },
  {
    zip: "8332",
    ST: "NJ",
    cityWithStateAbbr: "Millville, NJ",
  },
  {
    zip: "8340",
    ST: "NJ",
    cityWithStateAbbr: "Milmay, NJ",
  },
  {
    zip: "8341",
    ST: "NJ",
    cityWithStateAbbr: "Minotola, NJ",
  },
  {
    zip: "8342",
    ST: "NJ",
    cityWithStateAbbr: "Mizpah, NJ",
  },
  {
    zip: "8343",
    ST: "NJ",
    cityWithStateAbbr: "Monroeville, NJ",
  },
  {
    zip: "8344",
    ST: "NJ",
    cityWithStateAbbr: "Newfield, NJ",
  },
  {
    zip: "8345",
    ST: "NJ",
    cityWithStateAbbr: "Newport, NJ",
  },
  {
    zip: "8346",
    ST: "NJ",
    cityWithStateAbbr: "Newtonville, NJ",
  },
  {
    zip: "8347",
    ST: "NJ",
    cityWithStateAbbr: "Norma, NJ",
  },
  {
    zip: "8348",
    ST: "NJ",
    cityWithStateAbbr: "Port Elizabeth, NJ",
  },
  {
    zip: "8349",
    ST: "NJ",
    cityWithStateAbbr: "Port Norris, NJ",
  },
  {
    zip: "8350",
    ST: "NJ",
    cityWithStateAbbr: "Richland, NJ",
  },
  {
    zip: "8352",
    ST: "NJ",
    cityWithStateAbbr: "Rosenhayn, NJ",
  },
  {
    zip: "8353",
    ST: "NJ",
    cityWithStateAbbr: "Shiloh, NJ",
  },
  {
    zip: "8360",
    ST: "NJ",
    cityWithStateAbbr: "Vineland, NJ",
  },
  {
    zip: "8361",
    ST: "NJ",
    cityWithStateAbbr: "Vineland, NJ",
  },
  {
    zip: "8362",
    ST: "NJ",
    cityWithStateAbbr: "Vineland, NJ",
  },
  {
    zip: "8401",
    ST: "NJ",
    cityWithStateAbbr: "Atlantic City, NJ",
  },
  {
    zip: "8402",
    ST: "NJ",
    cityWithStateAbbr: "Margate City, NJ",
  },
  {
    zip: "8403",
    ST: "NJ",
    cityWithStateAbbr: "Longport, NJ",
  },
  {
    zip: "8404",
    ST: "NJ",
    cityWithStateAbbr: "Atlantic City, NJ",
  },
  {
    zip: "8405",
    ST: "NJ",
    cityWithStateAbbr: "Atlantic City, NJ",
  },
  {
    zip: "8406",
    ST: "NJ",
    cityWithStateAbbr: "Ventnor City, NJ",
  },
  {
    zip: "8501",
    ST: "NJ",
    cityWithStateAbbr: "Allentown, NJ",
  },
  {
    zip: "8502",
    ST: "NJ",
    cityWithStateAbbr: "Belle Mead, NJ",
  },
  {
    zip: "8504",
    ST: "NJ",
    cityWithStateAbbr: "Blawenburg, NJ",
  },
  {
    zip: "8505",
    ST: "NJ",
    cityWithStateAbbr: "Bordentown, NJ",
  },
  {
    zip: "8510",
    ST: "NJ",
    cityWithStateAbbr: "Millstone Township, NJ",
  },
  {
    zip: "8511",
    ST: "NJ",
    cityWithStateAbbr: "Cookstown, NJ",
  },
  {
    zip: "8512",
    ST: "NJ",
    cityWithStateAbbr: "Cranbury, NJ",
  },
  {
    zip: "8514",
    ST: "NJ",
    cityWithStateAbbr: "Cream Ridge, NJ",
  },
  {
    zip: "8515",
    ST: "NJ",
    cityWithStateAbbr: "Chesterfield, NJ",
  },
  {
    zip: "8518",
    ST: "NJ",
    cityWithStateAbbr: "Florence, NJ",
  },
  {
    zip: "8520",
    ST: "NJ",
    cityWithStateAbbr: "Hightstown, NJ",
  },
  {
    zip: "8525",
    ST: "NJ",
    cityWithStateAbbr: "Hopewell, NJ",
  },
  {
    zip: "8526",
    ST: "NJ",
    cityWithStateAbbr: "Imlaystown, NJ",
  },
  {
    zip: "8527",
    ST: "NJ",
    cityWithStateAbbr: "Jackson, NJ",
  },
  {
    zip: "8528",
    ST: "NJ",
    cityWithStateAbbr: "Kingston, NJ",
  },
  {
    zip: "8530",
    ST: "NJ",
    cityWithStateAbbr: "Lambertville, NJ",
  },
  {
    zip: "8533",
    ST: "NJ",
    cityWithStateAbbr: "New Egypt, NJ",
  },
  {
    zip: "8534",
    ST: "NJ",
    cityWithStateAbbr: "Pennington, NJ",
  },
  {
    zip: "8535",
    ST: "NJ",
    cityWithStateAbbr: "Millstone Township, NJ",
  },
  {
    zip: "8536",
    ST: "NJ",
    cityWithStateAbbr: "Plainsboro, NJ",
  },
  {
    zip: "8540",
    ST: "NJ",
    cityWithStateAbbr: "Princeton, NJ",
  },
  {
    zip: "8541",
    ST: "NJ",
    cityWithStateAbbr: "Princeton, NJ",
  },
  {
    zip: "8542",
    ST: "NJ",
    cityWithStateAbbr: "Princeton, NJ",
  },
  {
    zip: "8543",
    ST: "NJ",
    cityWithStateAbbr: "Princeton, NJ",
  },
  {
    zip: "8544",
    ST: "NJ",
    cityWithStateAbbr: "Princeton, NJ",
  },
  {
    zip: "8550",
    ST: "NJ",
    cityWithStateAbbr: "Princeton Junction, NJ",
  },
  {
    zip: "8551",
    ST: "NJ",
    cityWithStateAbbr: "Ringoes, NJ",
  },
  {
    zip: "8553",
    ST: "NJ",
    cityWithStateAbbr: "Rocky Hill, NJ",
  },
  {
    zip: "8554",
    ST: "NJ",
    cityWithStateAbbr: "Roebling, NJ",
  },
  {
    zip: "8555",
    ST: "NJ",
    cityWithStateAbbr: "Roosevelt, NJ",
  },
  {
    zip: "8556",
    ST: "NJ",
    cityWithStateAbbr: "Rosemont, NJ",
  },
  {
    zip: "8557",
    ST: "NJ",
    cityWithStateAbbr: "Sergeantsville, NJ",
  },
  {
    zip: "8558",
    ST: "NJ",
    cityWithStateAbbr: "Skillman, NJ",
  },
  {
    zip: "8559",
    ST: "NJ",
    cityWithStateAbbr: "Stockton, NJ",
  },
  {
    zip: "8560",
    ST: "NJ",
    cityWithStateAbbr: "Titusville, NJ",
  },
  {
    zip: "8561",
    ST: "NJ",
    cityWithStateAbbr: "Windsor, NJ",
  },
  {
    zip: "8562",
    ST: "NJ",
    cityWithStateAbbr: "Wrightstown, NJ",
  },
  {
    zip: "8601",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8602",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8603",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8604",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8605",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8606",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8607",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8608",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8609",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8610",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8611",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8618",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8619",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8620",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8625",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8628",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8629",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8638",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8640",
    ST: "NJ",
    cityWithStateAbbr: "Fort Dix, NJ",
  },
  {
    zip: "8641",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8645",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8646",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8647",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8648",
    ST: "NJ",
    cityWithStateAbbr: "Lawrence Township, NJ",
  },
  {
    zip: "8650",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8666",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8690",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8691",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8695",
    ST: "NJ",
    cityWithStateAbbr: "Trenton, NJ",
  },
  {
    zip: "8701",
    ST: "NJ",
    cityWithStateAbbr: "Lakewood, NJ",
  },
  {
    zip: "8720",
    ST: "NJ",
    cityWithStateAbbr: "Allenwood, NJ",
  },
  {
    zip: "8721",
    ST: "NJ",
    cityWithStateAbbr: "Bayville, NJ",
  },
  {
    zip: "8722",
    ST: "NJ",
    cityWithStateAbbr: "Beachwood, NJ",
  },
  {
    zip: "8723",
    ST: "NJ",
    cityWithStateAbbr: "Brick, NJ",
  },
  {
    zip: "8724",
    ST: "NJ",
    cityWithStateAbbr: "Brick, NJ",
  },
  {
    zip: "8730",
    ST: "NJ",
    cityWithStateAbbr: "Brielle, NJ",
  },
  {
    zip: "8731",
    ST: "NJ",
    cityWithStateAbbr: "Forked River, NJ",
  },
  {
    zip: "8732",
    ST: "NJ",
    cityWithStateAbbr: "Island Heights, NJ",
  },
  {
    zip: "8733",
    ST: "NJ",
    cityWithStateAbbr: "Lakehurst, NJ",
  },
  {
    zip: "8734",
    ST: "NJ",
    cityWithStateAbbr: "Lanoka Harbor, NJ",
  },
  {
    zip: "8735",
    ST: "NJ",
    cityWithStateAbbr: "Lavallette, NJ",
  },
  {
    zip: "8736",
    ST: "NJ",
    cityWithStateAbbr: "Manasquan, NJ",
  },
  {
    zip: "8738",
    ST: "NJ",
    cityWithStateAbbr: "Mantoloking, NJ",
  },
  {
    zip: "8739",
    ST: "NJ",
    cityWithStateAbbr: "Normandy Beach, NJ",
  },
  {
    zip: "8740",
    ST: "NJ",
    cityWithStateAbbr: "Ocean Gate, NJ",
  },
  {
    zip: "8741",
    ST: "NJ",
    cityWithStateAbbr: "Pine Beach, NJ",
  },
  {
    zip: "8742",
    ST: "NJ",
    cityWithStateAbbr: "Point Pleasant Beach, NJ",
  },
  {
    zip: "8750",
    ST: "NJ",
    cityWithStateAbbr: "Sea Girt, NJ",
  },
  {
    zip: "8751",
    ST: "NJ",
    cityWithStateAbbr: "Seaside Heights, NJ",
  },
  {
    zip: "8752",
    ST: "NJ",
    cityWithStateAbbr: "Seaside Park, NJ",
  },
  {
    zip: "8753",
    ST: "NJ",
    cityWithStateAbbr: "Toms River, NJ",
  },
  {
    zip: "8754",
    ST: "NJ",
    cityWithStateAbbr: "Toms River, NJ",
  },
  {
    zip: "8755",
    ST: "NJ",
    cityWithStateAbbr: "Toms River, NJ",
  },
  {
    zip: "8756",
    ST: "NJ",
    cityWithStateAbbr: "Toms River, NJ",
  },
  {
    zip: "8757",
    ST: "NJ",
    cityWithStateAbbr: "Toms River, NJ",
  },
  {
    zip: "8758",
    ST: "NJ",
    cityWithStateAbbr: "Waretown, NJ",
  },
  {
    zip: "8759",
    ST: "NJ",
    cityWithStateAbbr: "Manchester Township, NJ",
  },
  {
    zip: "8801",
    ST: "NJ",
    cityWithStateAbbr: "Annandale, NJ",
  },
  {
    zip: "8802",
    ST: "NJ",
    cityWithStateAbbr: "Asbury, NJ",
  },
  {
    zip: "8803",
    ST: "NJ",
    cityWithStateAbbr: "Baptistown, NJ",
  },
  {
    zip: "8804",
    ST: "NJ",
    cityWithStateAbbr: "Bloomsbury, NJ",
  },
  {
    zip: "8805",
    ST: "NJ",
    cityWithStateAbbr: "Bound Brook, NJ",
  },
  {
    zip: "8807",
    ST: "NJ",
    cityWithStateAbbr: "Bridgewater, NJ",
  },
  {
    zip: "8808",
    ST: "NJ",
    cityWithStateAbbr: "Broadway, NJ",
  },
  {
    zip: "8809",
    ST: "NJ",
    cityWithStateAbbr: "Clinton, NJ",
  },
  {
    zip: "8810",
    ST: "NJ",
    cityWithStateAbbr: "Dayton, NJ",
  },
  {
    zip: "8812",
    ST: "NJ",
    cityWithStateAbbr: "Dunellen, NJ",
  },
  {
    zip: "8816",
    ST: "NJ",
    cityWithStateAbbr: "East Brunswick, NJ",
  },
  {
    zip: "8817",
    ST: "NJ",
    cityWithStateAbbr: "Edison, NJ",
  },
  {
    zip: "8818",
    ST: "NJ",
    cityWithStateAbbr: "Edison, NJ",
  },
  {
    zip: "8820",
    ST: "NJ",
    cityWithStateAbbr: "Edison, NJ",
  },
  {
    zip: "8821",
    ST: "NJ",
    cityWithStateAbbr: "Flagtown, NJ",
  },
  {
    zip: "8822",
    ST: "NJ",
    cityWithStateAbbr: "Flemington, NJ",
  },
  {
    zip: "8823",
    ST: "NJ",
    cityWithStateAbbr: "Franklin Park, NJ",
  },
  {
    zip: "8824",
    ST: "NJ",
    cityWithStateAbbr: "Kendall Park, NJ",
  },
  {
    zip: "8825",
    ST: "NJ",
    cityWithStateAbbr: "Frenchtown, NJ",
  },
  {
    zip: "8826",
    ST: "NJ",
    cityWithStateAbbr: "Glen Gardner, NJ",
  },
  {
    zip: "8827",
    ST: "NJ",
    cityWithStateAbbr: "Hampton, NJ",
  },
  {
    zip: "8828",
    ST: "NJ",
    cityWithStateAbbr: "Helmetta, NJ",
  },
  {
    zip: "8829",
    ST: "NJ",
    cityWithStateAbbr: "High Bridge, NJ",
  },
  {
    zip: "8830",
    ST: "NJ",
    cityWithStateAbbr: "Iselin, NJ",
  },
  {
    zip: "8831",
    ST: "NJ",
    cityWithStateAbbr: "Monroe Township, NJ",
  },
  {
    zip: "8832",
    ST: "NJ",
    cityWithStateAbbr: "Keasbey, NJ",
  },
  {
    zip: "8833",
    ST: "NJ",
    cityWithStateAbbr: "Lebanon, NJ",
  },
  {
    zip: "8834",
    ST: "NJ",
    cityWithStateAbbr: "Little York, NJ",
  },
  {
    zip: "8835",
    ST: "NJ",
    cityWithStateAbbr: "Manville, NJ",
  },
  {
    zip: "8836",
    ST: "NJ",
    cityWithStateAbbr: "Martinsville, NJ",
  },
  {
    zip: "8837",
    ST: "NJ",
    cityWithStateAbbr: "Edison, NJ",
  },
  {
    zip: "8840",
    ST: "NJ",
    cityWithStateAbbr: "Metuchen, NJ",
  },
  {
    zip: "8844",
    ST: "NJ",
    cityWithStateAbbr: "Hillsborough, NJ",
  },
  {
    zip: "8846",
    ST: "NJ",
    cityWithStateAbbr: "Middlesex, NJ",
  },
  {
    zip: "8848",
    ST: "NJ",
    cityWithStateAbbr: "Milford, NJ",
  },
  {
    zip: "8850",
    ST: "NJ",
    cityWithStateAbbr: "Milltown, NJ",
  },
  {
    zip: "8852",
    ST: "NJ",
    cityWithStateAbbr: "Monmouth Junction, NJ",
  },
  {
    zip: "8853",
    ST: "NJ",
    cityWithStateAbbr: "Neshanic Station, NJ",
  },
  {
    zip: "8854",
    ST: "NJ",
    cityWithStateAbbr: "Piscataway, NJ",
  },
  {
    zip: "8855",
    ST: "NJ",
    cityWithStateAbbr: "Piscataway, NJ",
  },
  {
    zip: "8857",
    ST: "NJ",
    cityWithStateAbbr: "Old Bridge, NJ",
  },
  {
    zip: "8858",
    ST: "NJ",
    cityWithStateAbbr: "Oldwick, NJ",
  },
  {
    zip: "8859",
    ST: "NJ",
    cityWithStateAbbr: "Parlin, NJ",
  },
  {
    zip: "8861",
    ST: "NJ",
    cityWithStateAbbr: "Perth Amboy, NJ",
  },
  {
    zip: "8862",
    ST: "NJ",
    cityWithStateAbbr: "Perth Amboy, NJ",
  },
  {
    zip: "8863",
    ST: "NJ",
    cityWithStateAbbr: "Fords, NJ",
  },
  {
    zip: "8865",
    ST: "NJ",
    cityWithStateAbbr: "Phillipsburg, NJ",
  },
  {
    zip: "8867",
    ST: "NJ",
    cityWithStateAbbr: "Pittstown, NJ",
  },
  {
    zip: "8868",
    ST: "NJ",
    cityWithStateAbbr: "Quakertown, NJ",
  },
  {
    zip: "8869",
    ST: "NJ",
    cityWithStateAbbr: "Raritan, NJ",
  },
  {
    zip: "8870",
    ST: "NJ",
    cityWithStateAbbr: "Readington, NJ",
  },
  {
    zip: "8871",
    ST: "NJ",
    cityWithStateAbbr: "Sayreville, NJ",
  },
  {
    zip: "8872",
    ST: "NJ",
    cityWithStateAbbr: "Sayreville, NJ",
  },
  {
    zip: "8873",
    ST: "NJ",
    cityWithStateAbbr: "Somerset, NJ",
  },
  {
    zip: "8875",
    ST: "NJ",
    cityWithStateAbbr: "Somerset, NJ",
  },
  {
    zip: "8876",
    ST: "NJ",
    cityWithStateAbbr: "Somerville, NJ",
  },
  {
    zip: "8879",
    ST: "NJ",
    cityWithStateAbbr: "South Amboy, NJ",
  },
  {
    zip: "8880",
    ST: "NJ",
    cityWithStateAbbr: "South Bound Brook, NJ",
  },
  {
    zip: "8882",
    ST: "NJ",
    cityWithStateAbbr: "South River, NJ",
  },
  {
    zip: "8884",
    ST: "NJ",
    cityWithStateAbbr: "Spotswood, NJ",
  },
  {
    zip: "8885",
    ST: "NJ",
    cityWithStateAbbr: "Stanton, NJ",
  },
  {
    zip: "8886",
    ST: "NJ",
    cityWithStateAbbr: "Stewartsville, NJ",
  },
  {
    zip: "8887",
    ST: "NJ",
    cityWithStateAbbr: "Three Bridges, NJ",
  },
  {
    zip: "8888",
    ST: "NJ",
    cityWithStateAbbr: "Whitehouse, NJ",
  },
  {
    zip: "8889",
    ST: "NJ",
    cityWithStateAbbr: "Whitehouse Station, NJ",
  },
  {
    zip: "8890",
    ST: "NJ",
    cityWithStateAbbr: "Zarephath, NJ",
  },
  {
    zip: "8899",
    ST: "NJ",
    cityWithStateAbbr: "Edison, NJ",
  },
  {
    zip: "8901",
    ST: "NJ",
    cityWithStateAbbr: "New Brunswick, NJ",
  },
  {
    zip: "8902",
    ST: "NJ",
    cityWithStateAbbr: "North Brunswick, NJ",
  },
  {
    zip: "8903",
    ST: "NJ",
    cityWithStateAbbr: "New Brunswick, NJ",
  },
  {
    zip: "8904",
    ST: "NJ",
    cityWithStateAbbr: "Highland Park, NJ",
  },
  {
    zip: "8905",
    ST: "NJ",
    cityWithStateAbbr: "New Brunswick, NJ",
  },
  {
    zip: "8906",
    ST: "NJ",
    cityWithStateAbbr: "New Brunswick, NJ",
  },
  {
    zip: "8933",
    ST: "NJ",
    cityWithStateAbbr: "New Brunswick, NJ",
  },
  {
    zip: "8989",
    ST: "NJ",
    cityWithStateAbbr: "New Brunswick, NJ",
  },
  {
    zip: "10001",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10002",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10003",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10004",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10005",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10006",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10007",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10008",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10009",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10010",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10011",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10012",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10013",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10014",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10016",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10017",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10018",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10019",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10020",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10021",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10022",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10023",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10024",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10025",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10026",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10027",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10028",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10029",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10030",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10031",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10032",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10033",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10034",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10035",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10036",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10037",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10038",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10039",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10040",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10041",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10043",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10044",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10045",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10055",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10060",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10065",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10069",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10072",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10075",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10080",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10081",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10087",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10090",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10095",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10101",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10102",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10103",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10104",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10105",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10106",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10107",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10108",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10109",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10110",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10111",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10112",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10113",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10114",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10115",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10116",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10117",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10118",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10119",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10120",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10121",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10122",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10123",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10124",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10125",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10126",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10128",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10129",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10130",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10131",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10132",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10133",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10138",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10150",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10151",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10152",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10153",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10154",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10155",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10156",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10157",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10158",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10159",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10160",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10161",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10162",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10163",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10164",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10165",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10166",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10167",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10168",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10169",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10170",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10171",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10172",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10173",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10174",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10175",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10176",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10177",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10178",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10179",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10185",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10199",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10203",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10211",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10212",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10213",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10242",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10249",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10256",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10259",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10260",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10261",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10265",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10268",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10269",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10270",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10271",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10272",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10273",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10274",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10275",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10276",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10277",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10278",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10279",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10280",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10281",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10282",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10285",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10286",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10292",
    ST: "NY",
    cityWithStateAbbr: "New York, NY",
  },
  {
    zip: "10301",
    ST: "NY",
    cityWithStateAbbr: "Staten Island, NY",
  },
  {
    zip: "10302",
    ST: "NY",
    cityWithStateAbbr: "Staten Island, NY",
  },
  {
    zip: "10303",
    ST: "NY",
    cityWithStateAbbr: "Staten Island, NY",
  },
  {
    zip: "10304",
    ST: "NY",
    cityWithStateAbbr: "Staten Island, NY",
  },
  {
    zip: "10305",
    ST: "NY",
    cityWithStateAbbr: "Staten Island, NY",
  },
  {
    zip: "10306",
    ST: "NY",
    cityWithStateAbbr: "Staten Island, NY",
  },
  {
    zip: "10307",
    ST: "NY",
    cityWithStateAbbr: "Staten Island, NY",
  },
  {
    zip: "10308",
    ST: "NY",
    cityWithStateAbbr: "Staten Island, NY",
  },
  {
    zip: "10309",
    ST: "NY",
    cityWithStateAbbr: "Staten Island, NY",
  },
  {
    zip: "10310",
    ST: "NY",
    cityWithStateAbbr: "Staten Island, NY",
  },
  {
    zip: "10311",
    ST: "NY",
    cityWithStateAbbr: "Staten Island, NY",
  },
  {
    zip: "10312",
    ST: "NY",
    cityWithStateAbbr: "Staten Island, NY",
  },
  {
    zip: "10313",
    ST: "NY",
    cityWithStateAbbr: "Staten Island, NY",
  },
  {
    zip: "10314",
    ST: "NY",
    cityWithStateAbbr: "Staten Island, NY",
  },
  {
    zip: "10451",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10452",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10453",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10454",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10455",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10456",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10457",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10458",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10459",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10460",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10461",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10462",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10463",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10464",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10465",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10466",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10467",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10468",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10469",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10470",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10471",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10472",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10473",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10474",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10475",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10499",
    ST: "NY",
    cityWithStateAbbr: "Bronx, NY",
  },
  {
    zip: "10501",
    ST: "NY",
    cityWithStateAbbr: "Amawalk, NY",
  },
  {
    zip: "10502",
    ST: "NY",
    cityWithStateAbbr: "Ardsley, NY",
  },
  {
    zip: "10503",
    ST: "NY",
    cityWithStateAbbr: "Ardsley On Hudson, NY",
  },
  {
    zip: "10504",
    ST: "NY",
    cityWithStateAbbr: "Armonk, NY",
  },
  {
    zip: "10505",
    ST: "NY",
    cityWithStateAbbr: "Baldwin Place, NY",
  },
  {
    zip: "10506",
    ST: "NY",
    cityWithStateAbbr: "Bedford, NY",
  },
  {
    zip: "10507",
    ST: "NY",
    cityWithStateAbbr: "Bedford Hills, NY",
  },
  {
    zip: "10509",
    ST: "NY",
    cityWithStateAbbr: "Brewster, NY",
  },
  {
    zip: "10510",
    ST: "NY",
    cityWithStateAbbr: "Briarcliff Manor, NY",
  },
  {
    zip: "10511",
    ST: "NY",
    cityWithStateAbbr: "Buchanan, NY",
  },
  {
    zip: "10512",
    ST: "NY",
    cityWithStateAbbr: "Carmel, NY",
  },
  {
    zip: "10514",
    ST: "NY",
    cityWithStateAbbr: "Chappaqua, NY",
  },
  {
    zip: "10516",
    ST: "NY",
    cityWithStateAbbr: "Cold Spring, NY",
  },
  {
    zip: "10517",
    ST: "NY",
    cityWithStateAbbr: "Crompond, NY",
  },
  {
    zip: "10518",
    ST: "NY",
    cityWithStateAbbr: "Cross River, NY",
  },
  {
    zip: "10519",
    ST: "NY",
    cityWithStateAbbr: "Croton Falls, NY",
  },
  {
    zip: "10520",
    ST: "NY",
    cityWithStateAbbr: "Croton On Hudson, NY",
  },
  {
    zip: "10521",
    ST: "NY",
    cityWithStateAbbr: "Croton On Hudson, NY",
  },
  {
    zip: "10522",
    ST: "NY",
    cityWithStateAbbr: "Dobbs Ferry, NY",
  },
  {
    zip: "10523",
    ST: "NY",
    cityWithStateAbbr: "Elmsford, NY",
  },
  {
    zip: "10524",
    ST: "NY",
    cityWithStateAbbr: "Garrison, NY",
  },
  {
    zip: "10526",
    ST: "NY",
    cityWithStateAbbr: "Goldens Bridge, NY",
  },
  {
    zip: "10527",
    ST: "NY",
    cityWithStateAbbr: "Granite Springs, NY",
  },
  {
    zip: "10528",
    ST: "NY",
    cityWithStateAbbr: "Harrison, NY",
  },
  {
    zip: "10530",
    ST: "NY",
    cityWithStateAbbr: "Hartsdale, NY",
  },
  {
    zip: "10532",
    ST: "NY",
    cityWithStateAbbr: "Hawthorne, NY",
  },
  {
    zip: "10533",
    ST: "NY",
    cityWithStateAbbr: "Irvington, NY",
  },
  {
    zip: "10535",
    ST: "NY",
    cityWithStateAbbr: "Jefferson Valley, NY",
  },
  {
    zip: "10536",
    ST: "NY",
    cityWithStateAbbr: "Katonah, NY",
  },
  {
    zip: "10537",
    ST: "NY",
    cityWithStateAbbr: "Lake Peekskill, NY",
  },
  {
    zip: "10538",
    ST: "NY",
    cityWithStateAbbr: "Larchmont, NY",
  },
  {
    zip: "10540",
    ST: "NY",
    cityWithStateAbbr: "Lincolndale, NY",
  },
  {
    zip: "10541",
    ST: "NY",
    cityWithStateAbbr: "Mahopac, NY",
  },
  {
    zip: "10542",
    ST: "NY",
    cityWithStateAbbr: "Mahopac Falls, NY",
  },
  {
    zip: "10543",
    ST: "NY",
    cityWithStateAbbr: "Mamaroneck, NY",
  },
  {
    zip: "10545",
    ST: "NY",
    cityWithStateAbbr: "Maryknoll, NY",
  },
  {
    zip: "10546",
    ST: "NY",
    cityWithStateAbbr: "Millwood, NY",
  },
  {
    zip: "10547",
    ST: "NY",
    cityWithStateAbbr: "Mohegan Lake, NY",
  },
  {
    zip: "10548",
    ST: "NY",
    cityWithStateAbbr: "Montrose, NY",
  },
  {
    zip: "10549",
    ST: "NY",
    cityWithStateAbbr: "Mount Kisco, NY",
  },
  {
    zip: "10550",
    ST: "NY",
    cityWithStateAbbr: "Mount Vernon, NY",
  },
  {
    zip: "10551",
    ST: "NY",
    cityWithStateAbbr: "Mount Vernon, NY",
  },
  {
    zip: "10552",
    ST: "NY",
    cityWithStateAbbr: "Mount Vernon, NY",
  },
  {
    zip: "10553",
    ST: "NY",
    cityWithStateAbbr: "Mount Vernon, NY",
  },
  {
    zip: "10560",
    ST: "NY",
    cityWithStateAbbr: "North Salem, NY",
  },
  {
    zip: "10562",
    ST: "NY",
    cityWithStateAbbr: "Ossining, NY",
  },
  {
    zip: "10566",
    ST: "NY",
    cityWithStateAbbr: "Peekskill, NY",
  },
  {
    zip: "10567",
    ST: "NY",
    cityWithStateAbbr: "Cortlandt Manor, NY",
  },
  {
    zip: "10570",
    ST: "NY",
    cityWithStateAbbr: "Pleasantville, NY",
  },
  {
    zip: "10573",
    ST: "NY",
    cityWithStateAbbr: "Port Chester, NY",
  },
  {
    zip: "10576",
    ST: "NY",
    cityWithStateAbbr: "Pound Ridge, NY",
  },
  {
    zip: "10577",
    ST: "NY",
    cityWithStateAbbr: "Purchase, NY",
  },
  {
    zip: "10578",
    ST: "NY",
    cityWithStateAbbr: "Purdys, NY",
  },
  {
    zip: "10579",
    ST: "NY",
    cityWithStateAbbr: "Putnam Valley, NY",
  },
  {
    zip: "10580",
    ST: "NY",
    cityWithStateAbbr: "Rye, NY",
  },
  {
    zip: "10583",
    ST: "NY",
    cityWithStateAbbr: "Scarsdale, NY",
  },
  {
    zip: "10587",
    ST: "NY",
    cityWithStateAbbr: "Shenorock, NY",
  },
  {
    zip: "10588",
    ST: "NY",
    cityWithStateAbbr: "Shrub Oak, NY",
  },
  {
    zip: "10589",
    ST: "NY",
    cityWithStateAbbr: "Somers, NY",
  },
  {
    zip: "10590",
    ST: "NY",
    cityWithStateAbbr: "South Salem, NY",
  },
  {
    zip: "10591",
    ST: "NY",
    cityWithStateAbbr: "Tarrytown, NY",
  },
  {
    zip: "10594",
    ST: "NY",
    cityWithStateAbbr: "Thornwood, NY",
  },
  {
    zip: "10595",
    ST: "NY",
    cityWithStateAbbr: "Valhalla, NY",
  },
  {
    zip: "10596",
    ST: "NY",
    cityWithStateAbbr: "Verplanck, NY",
  },
  {
    zip: "10597",
    ST: "NY",
    cityWithStateAbbr: "Waccabuc, NY",
  },
  {
    zip: "10598",
    ST: "NY",
    cityWithStateAbbr: "Yorktown Heights, NY",
  },
  {
    zip: "10601",
    ST: "NY",
    cityWithStateAbbr: "White Plains, NY",
  },
  {
    zip: "10602",
    ST: "NY",
    cityWithStateAbbr: "White Plains, NY",
  },
  {
    zip: "10603",
    ST: "NY",
    cityWithStateAbbr: "White Plains, NY",
  },
  {
    zip: "10604",
    ST: "NY",
    cityWithStateAbbr: "West Harrison, NY",
  },
  {
    zip: "10605",
    ST: "NY",
    cityWithStateAbbr: "White Plains, NY",
  },
  {
    zip: "10606",
    ST: "NY",
    cityWithStateAbbr: "White Plains, NY",
  },
  {
    zip: "10607",
    ST: "NY",
    cityWithStateAbbr: "White Plains, NY",
  },
  {
    zip: "10610",
    ST: "NY",
    cityWithStateAbbr: "White Plains, NY",
  },
  {
    zip: "10701",
    ST: "NY",
    cityWithStateAbbr: "Yonkers, NY",
  },
  {
    zip: "10702",
    ST: "NY",
    cityWithStateAbbr: "Yonkers, NY",
  },
  {
    zip: "10703",
    ST: "NY",
    cityWithStateAbbr: "Yonkers, NY",
  },
  {
    zip: "10704",
    ST: "NY",
    cityWithStateAbbr: "Yonkers, NY",
  },
  {
    zip: "10705",
    ST: "NY",
    cityWithStateAbbr: "Yonkers, NY",
  },
  {
    zip: "10706",
    ST: "NY",
    cityWithStateAbbr: "Hastings On Hudson, NY",
  },
  {
    zip: "10707",
    ST: "NY",
    cityWithStateAbbr: "Tuckahoe, NY",
  },
  {
    zip: "10708",
    ST: "NY",
    cityWithStateAbbr: "Bronxville, NY",
  },
  {
    zip: "10709",
    ST: "NY",
    cityWithStateAbbr: "Eastchester, NY",
  },
  {
    zip: "10710",
    ST: "NY",
    cityWithStateAbbr: "Yonkers, NY",
  },
  {
    zip: "10801",
    ST: "NY",
    cityWithStateAbbr: "New Rochelle, NY",
  },
  {
    zip: "10802",
    ST: "NY",
    cityWithStateAbbr: "New Rochelle, NY",
  },
  {
    zip: "10803",
    ST: "NY",
    cityWithStateAbbr: "Pelham, NY",
  },
  {
    zip: "10804",
    ST: "NY",
    cityWithStateAbbr: "New Rochelle, NY",
  },
  {
    zip: "10805",
    ST: "NY",
    cityWithStateAbbr: "New Rochelle, NY",
  },
  {
    zip: "10901",
    ST: "NY",
    cityWithStateAbbr: "Suffern, NY",
  },
  {
    zip: "10910",
    ST: "NY",
    cityWithStateAbbr: "Arden, NY",
  },
  {
    zip: "10911",
    ST: "NY",
    cityWithStateAbbr: "Bear Mountain, NY",
  },
  {
    zip: "10912",
    ST: "NY",
    cityWithStateAbbr: "Bellvale, NY",
  },
  {
    zip: "10913",
    ST: "NY",
    cityWithStateAbbr: "Blauvelt, NY",
  },
  {
    zip: "10914",
    ST: "NY",
    cityWithStateAbbr: "Blooming Grove, NY",
  },
  {
    zip: "10915",
    ST: "NY",
    cityWithStateAbbr: "Bullville, NY",
  },
  {
    zip: "10916",
    ST: "NY",
    cityWithStateAbbr: "Campbell Hall, NY",
  },
  {
    zip: "10917",
    ST: "NY",
    cityWithStateAbbr: "Central Valley, NY",
  },
  {
    zip: "10918",
    ST: "NY",
    cityWithStateAbbr: "Chester, NY",
  },
  {
    zip: "10919",
    ST: "NY",
    cityWithStateAbbr: "Circleville, NY",
  },
  {
    zip: "10920",
    ST: "NY",
    cityWithStateAbbr: "Congers, NY",
  },
  {
    zip: "10921",
    ST: "NY",
    cityWithStateAbbr: "Florida, NY",
  },
  {
    zip: "10922",
    ST: "NY",
    cityWithStateAbbr: "Fort Montgomery, NY",
  },
  {
    zip: "10923",
    ST: "NY",
    cityWithStateAbbr: "Garnerville, NY",
  },
  {
    zip: "10924",
    ST: "NY",
    cityWithStateAbbr: "Goshen, NY",
  },
  {
    zip: "10925",
    ST: "NY",
    cityWithStateAbbr: "Greenwood Lake, NY",
  },
  {
    zip: "10926",
    ST: "NY",
    cityWithStateAbbr: "Harriman, NY",
  },
  {
    zip: "10927",
    ST: "NY",
    cityWithStateAbbr: "Haverstraw, NY",
  },
  {
    zip: "10928",
    ST: "NY",
    cityWithStateAbbr: "Highland Falls, NY",
  },
  {
    zip: "10930",
    ST: "NY",
    cityWithStateAbbr: "Highland Mills, NY",
  },
  {
    zip: "10931",
    ST: "NY",
    cityWithStateAbbr: "Hillburn, NY",
  },
  {
    zip: "10932",
    ST: "NY",
    cityWithStateAbbr: "Howells, NY",
  },
  {
    zip: "10933",
    ST: "NY",
    cityWithStateAbbr: "Johnson, NY",
  },
  {
    zip: "10940",
    ST: "NY",
    cityWithStateAbbr: "Middletown, NY",
  },
  {
    zip: "10941",
    ST: "NY",
    cityWithStateAbbr: "Middletown, NY",
  },
  {
    zip: "10949",
    ST: "NY",
    cityWithStateAbbr: "Monroe, NY",
  },
  {
    zip: "10950",
    ST: "NY",
    cityWithStateAbbr: "Monroe, NY",
  },
  {
    zip: "10952",
    ST: "NY",
    cityWithStateAbbr: "Monsey, NY",
  },
  {
    zip: "10953",
    ST: "NY",
    cityWithStateAbbr: "Mountainville, NY",
  },
  {
    zip: "10954",
    ST: "NY",
    cityWithStateAbbr: "Nanuet, NY",
  },
  {
    zip: "10956",
    ST: "NY",
    cityWithStateAbbr: "New City, NY",
  },
  {
    zip: "10958",
    ST: "NY",
    cityWithStateAbbr: "New Hampton, NY",
  },
  {
    zip: "10959",
    ST: "NY",
    cityWithStateAbbr: "New Milford, NY",
  },
  {
    zip: "10960",
    ST: "NY",
    cityWithStateAbbr: "Nyack, NY",
  },
  {
    zip: "10962",
    ST: "NY",
    cityWithStateAbbr: "Orangeburg, NY",
  },
  {
    zip: "10963",
    ST: "NY",
    cityWithStateAbbr: "Otisville, NY",
  },
  {
    zip: "10964",
    ST: "NY",
    cityWithStateAbbr: "Palisades, NY",
  },
  {
    zip: "10965",
    ST: "NY",
    cityWithStateAbbr: "Pearl River, NY",
  },
  {
    zip: "10968",
    ST: "NY",
    cityWithStateAbbr: "Piermont, NY",
  },
  {
    zip: "10969",
    ST: "NY",
    cityWithStateAbbr: "Pine Island, NY",
  },
  {
    zip: "10970",
    ST: "NY",
    cityWithStateAbbr: "Pomona, NY",
  },
  {
    zip: "10973",
    ST: "NY",
    cityWithStateAbbr: "Slate Hill, NY",
  },
  {
    zip: "10974",
    ST: "NY",
    cityWithStateAbbr: "Sloatsburg, NY",
  },
  {
    zip: "10975",
    ST: "NY",
    cityWithStateAbbr: "Southfields, NY",
  },
  {
    zip: "10976",
    ST: "NY",
    cityWithStateAbbr: "Sparkill, NY",
  },
  {
    zip: "10977",
    ST: "NY",
    cityWithStateAbbr: "Spring Valley, NY",
  },
  {
    zip: "10979",
    ST: "NY",
    cityWithStateAbbr: "Sterling Forest, NY",
  },
  {
    zip: "10980",
    ST: "NY",
    cityWithStateAbbr: "Stony Point, NY",
  },
  {
    zip: "10981",
    ST: "NY",
    cityWithStateAbbr: "Sugar Loaf, NY",
  },
  {
    zip: "10982",
    ST: "NY",
    cityWithStateAbbr: "Tallman, NY",
  },
  {
    zip: "10983",
    ST: "NY",
    cityWithStateAbbr: "Tappan, NY",
  },
  {
    zip: "10984",
    ST: "NY",
    cityWithStateAbbr: "Thiells, NY",
  },
  {
    zip: "10985",
    ST: "NY",
    cityWithStateAbbr: "Thompson Ridge, NY",
  },
  {
    zip: "10986",
    ST: "NY",
    cityWithStateAbbr: "Tomkins Cove, NY",
  },
  {
    zip: "10987",
    ST: "NY",
    cityWithStateAbbr: "Tuxedo Park, NY",
  },
  {
    zip: "10988",
    ST: "NY",
    cityWithStateAbbr: "Unionville, NY",
  },
  {
    zip: "10989",
    ST: "NY",
    cityWithStateAbbr: "Valley Cottage, NY",
  },
  {
    zip: "10990",
    ST: "NY",
    cityWithStateAbbr: "Warwick, NY",
  },
  {
    zip: "10992",
    ST: "NY",
    cityWithStateAbbr: "Washingtonville, NY",
  },
  {
    zip: "10993",
    ST: "NY",
    cityWithStateAbbr: "West Haverstraw, NY",
  },
  {
    zip: "10994",
    ST: "NY",
    cityWithStateAbbr: "West Nyack, NY",
  },
  {
    zip: "10996",
    ST: "NY",
    cityWithStateAbbr: "West Point, NY",
  },
  {
    zip: "10997",
    ST: "NY",
    cityWithStateAbbr: "West Point, NY",
  },
  {
    zip: "10998",
    ST: "NY",
    cityWithStateAbbr: "Westtown, NY",
  },
  {
    zip: "11001",
    ST: "NY",
    cityWithStateAbbr: "Floral Park, NY",
  },
  {
    zip: "11002",
    ST: "NY",
    cityWithStateAbbr: "Floral Park, NY",
  },
  {
    zip: "11003",
    ST: "NY",
    cityWithStateAbbr: "Elmont, NY",
  },
  {
    zip: "11004",
    ST: "NY",
    cityWithStateAbbr: "Glen Oaks, NY",
  },
  {
    zip: "11005",
    ST: "NY",
    cityWithStateAbbr: "Floral Park, NY",
  },
  {
    zip: "11010",
    ST: "NY",
    cityWithStateAbbr: "Franklin Square, NY",
  },
  {
    zip: "11020",
    ST: "NY",
    cityWithStateAbbr: "Great Neck, NY",
  },
  {
    zip: "11021",
    ST: "NY",
    cityWithStateAbbr: "Great Neck, NY",
  },
  {
    zip: "11022",
    ST: "NY",
    cityWithStateAbbr: "Great Neck, NY",
  },
  {
    zip: "11023",
    ST: "NY",
    cityWithStateAbbr: "Great Neck, NY",
  },
  {
    zip: "11024",
    ST: "NY",
    cityWithStateAbbr: "Great Neck, NY",
  },
  {
    zip: "11026",
    ST: "NY",
    cityWithStateAbbr: "Great Neck, NY",
  },
  {
    zip: "11030",
    ST: "NY",
    cityWithStateAbbr: "Manhasset, NY",
  },
  {
    zip: "11040",
    ST: "NY",
    cityWithStateAbbr: "New Hyde Park, NY",
  },
  {
    zip: "11042",
    ST: "NY",
    cityWithStateAbbr: "New Hyde Park, NY",
  },
  {
    zip: "11050",
    ST: "NY",
    cityWithStateAbbr: "Port Washington, NY",
  },
  {
    zip: "11051",
    ST: "NY",
    cityWithStateAbbr: "Port Washington, NY",
  },
  {
    zip: "11052",
    ST: "NY",
    cityWithStateAbbr: "Port Washington, NY",
  },
  {
    zip: "11053",
    ST: "NY",
    cityWithStateAbbr: "Port Washington, NY",
  },
  {
    zip: "11054",
    ST: "NY",
    cityWithStateAbbr: "Port Washington, NY",
  },
  {
    zip: "11055",
    ST: "NY",
    cityWithStateAbbr: "Port Washington, NY",
  },
  {
    zip: "11096",
    ST: "NY",
    cityWithStateAbbr: "Inwood, NY",
  },
  {
    zip: "11101",
    ST: "NY",
    cityWithStateAbbr: "Long Island City, NY",
  },
  {
    zip: "11102",
    ST: "NY",
    cityWithStateAbbr: "Astoria, NY",
  },
  {
    zip: "11103",
    ST: "NY",
    cityWithStateAbbr: "Astoria, NY",
  },
  {
    zip: "11104",
    ST: "NY",
    cityWithStateAbbr: "Sunnyside, NY",
  },
  {
    zip: "11105",
    ST: "NY",
    cityWithStateAbbr: "Astoria, NY",
  },
  {
    zip: "11106",
    ST: "NY",
    cityWithStateAbbr: "Astoria, NY",
  },
  {
    zip: "11109",
    ST: "NY",
    cityWithStateAbbr: "Long Island City, NY",
  },
  {
    zip: "11120",
    ST: "NY",
    cityWithStateAbbr: "Long Island City, NY",
  },
  {
    zip: "11201",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11202",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11203",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11204",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11205",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11206",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11207",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11208",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11209",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11210",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11211",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11212",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11213",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11214",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11215",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11216",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11217",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11218",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11219",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11220",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11221",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11222",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11223",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11224",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11225",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11226",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11228",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11229",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11230",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11231",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11232",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11233",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11234",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11235",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11236",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11237",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11238",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11239",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11241",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11242",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11243",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11245",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11247",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11249",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11251",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11252",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11256",
    ST: "NY",
    cityWithStateAbbr: "Brooklyn, NY",
  },
  {
    zip: "11351",
    ST: "NY",
    cityWithStateAbbr: "Flushing, NY",
  },
  {
    zip: "11352",
    ST: "NY",
    cityWithStateAbbr: "Flushing, NY",
  },
  {
    zip: "11354",
    ST: "NY",
    cityWithStateAbbr: "Flushing, NY",
  },
  {
    zip: "11355",
    ST: "NY",
    cityWithStateAbbr: "Flushing, NY",
  },
  {
    zip: "11356",
    ST: "NY",
    cityWithStateAbbr: "College Point, NY",
  },
  {
    zip: "11357",
    ST: "NY",
    cityWithStateAbbr: "Whitestone, NY",
  },
  {
    zip: "11358",
    ST: "NY",
    cityWithStateAbbr: "Flushing, NY",
  },
  {
    zip: "11359",
    ST: "NY",
    cityWithStateAbbr: "Bayside, NY",
  },
  {
    zip: "11360",
    ST: "NY",
    cityWithStateAbbr: "Bayside, NY",
  },
  {
    zip: "11361",
    ST: "NY",
    cityWithStateAbbr: "Bayside, NY",
  },
  {
    zip: "11362",
    ST: "NY",
    cityWithStateAbbr: "Little Neck, NY",
  },
  {
    zip: "11363",
    ST: "NY",
    cityWithStateAbbr: "Little Neck, NY",
  },
  {
    zip: "11364",
    ST: "NY",
    cityWithStateAbbr: "Oakland Gardens, NY",
  },
  {
    zip: "11365",
    ST: "NY",
    cityWithStateAbbr: "Fresh Meadows, NY",
  },
  {
    zip: "11366",
    ST: "NY",
    cityWithStateAbbr: "Fresh Meadows, NY",
  },
  {
    zip: "11367",
    ST: "NY",
    cityWithStateAbbr: "Flushing, NY",
  },
  {
    zip: "11368",
    ST: "NY",
    cityWithStateAbbr: "Corona, NY",
  },
  {
    zip: "11369",
    ST: "NY",
    cityWithStateAbbr: "East Elmhurst, NY",
  },
  {
    zip: "11370",
    ST: "NY",
    cityWithStateAbbr: "East Elmhurst, NY",
  },
  {
    zip: "11371",
    ST: "NY",
    cityWithStateAbbr: "Flushing, NY",
  },
  {
    zip: "11372",
    ST: "NY",
    cityWithStateAbbr: "Jackson Heights, NY",
  },
  {
    zip: "11373",
    ST: "NY",
    cityWithStateAbbr: "Elmhurst, NY",
  },
  {
    zip: "11374",
    ST: "NY",
    cityWithStateAbbr: "Rego Park, NY",
  },
  {
    zip: "11375",
    ST: "NY",
    cityWithStateAbbr: "Forest Hills, NY",
  },
  {
    zip: "11377",
    ST: "NY",
    cityWithStateAbbr: "Woodside, NY",
  },
  {
    zip: "11378",
    ST: "NY",
    cityWithStateAbbr: "Maspeth, NY",
  },
  {
    zip: "11379",
    ST: "NY",
    cityWithStateAbbr: "Middle Village, NY",
  },
  {
    zip: "11380",
    ST: "NY",
    cityWithStateAbbr: "Elmhurst, NY",
  },
  {
    zip: "11381",
    ST: "NY",
    cityWithStateAbbr: "Flushing, NY",
  },
  {
    zip: "11385",
    ST: "NY",
    cityWithStateAbbr: "Ridgewood, NY",
  },
  {
    zip: "11386",
    ST: "NY",
    cityWithStateAbbr: "Ridgewood, NY",
  },
  {
    zip: "11390",
    ST: "NY",
    cityWithStateAbbr: "Flushing, NY",
  },
  {
    zip: "11405",
    ST: "NY",
    cityWithStateAbbr: "Jamaica, NY",
  },
  {
    zip: "11411",
    ST: "NY",
    cityWithStateAbbr: "Cambria Heights, NY",
  },
  {
    zip: "11412",
    ST: "NY",
    cityWithStateAbbr: "Saint Albans, NY",
  },
  {
    zip: "11413",
    ST: "NY",
    cityWithStateAbbr: "Springfield Gardens, NY",
  },
  {
    zip: "11414",
    ST: "NY",
    cityWithStateAbbr: "Howard Beach, NY",
  },
  {
    zip: "11415",
    ST: "NY",
    cityWithStateAbbr: "Kew Gardens, NY",
  },
  {
    zip: "11416",
    ST: "NY",
    cityWithStateAbbr: "Ozone Park, NY",
  },
  {
    zip: "11417",
    ST: "NY",
    cityWithStateAbbr: "Ozone Park, NY",
  },
  {
    zip: "11418",
    ST: "NY",
    cityWithStateAbbr: "Richmond Hill, NY",
  },
  {
    zip: "11419",
    ST: "NY",
    cityWithStateAbbr: "South Richmond Hill, NY",
  },
  {
    zip: "11420",
    ST: "NY",
    cityWithStateAbbr: "South Ozone Park, NY",
  },
  {
    zip: "11421",
    ST: "NY",
    cityWithStateAbbr: "Woodhaven, NY",
  },
  {
    zip: "11422",
    ST: "NY",
    cityWithStateAbbr: "Rosedale, NY",
  },
  {
    zip: "11423",
    ST: "NY",
    cityWithStateAbbr: "Hollis, NY",
  },
  {
    zip: "11424",
    ST: "NY",
    cityWithStateAbbr: "Jamaica, NY",
  },
  {
    zip: "11425",
    ST: "NY",
    cityWithStateAbbr: "Jamaica, NY",
  },
  {
    zip: "11426",
    ST: "NY",
    cityWithStateAbbr: "Bellerose, NY",
  },
  {
    zip: "11427",
    ST: "NY",
    cityWithStateAbbr: "Queens Village, NY",
  },
  {
    zip: "11428",
    ST: "NY",
    cityWithStateAbbr: "Queens Village, NY",
  },
  {
    zip: "11429",
    ST: "NY",
    cityWithStateAbbr: "Queens Village, NY",
  },
  {
    zip: "11430",
    ST: "NY",
    cityWithStateAbbr: "Jamaica, NY",
  },
  {
    zip: "11431",
    ST: "NY",
    cityWithStateAbbr: "Jamaica, NY",
  },
  {
    zip: "11432",
    ST: "NY",
    cityWithStateAbbr: "Jamaica, NY",
  },
  {
    zip: "11433",
    ST: "NY",
    cityWithStateAbbr: "Jamaica, NY",
  },
  {
    zip: "11434",
    ST: "NY",
    cityWithStateAbbr: "Jamaica, NY",
  },
  {
    zip: "11435",
    ST: "NY",
    cityWithStateAbbr: "Jamaica, NY",
  },
  {
    zip: "11436",
    ST: "NY",
    cityWithStateAbbr: "Jamaica, NY",
  },
  {
    zip: "11439",
    ST: "NY",
    cityWithStateAbbr: "Jamaica, NY",
  },
  {
    zip: "11451",
    ST: "NY",
    cityWithStateAbbr: "Jamaica, NY",
  },
  {
    zip: "11499",
    ST: "NY",
    cityWithStateAbbr: "Jamaica, NY",
  },
  {
    zip: "11501",
    ST: "NY",
    cityWithStateAbbr: "Mineola, NY",
  },
  {
    zip: "11507",
    ST: "NY",
    cityWithStateAbbr: "Albertson, NY",
  },
  {
    zip: "11509",
    ST: "NY",
    cityWithStateAbbr: "Atlantic Beach, NY",
  },
  {
    zip: "11510",
    ST: "NY",
    cityWithStateAbbr: "Baldwin, NY",
  },
  {
    zip: "11514",
    ST: "NY",
    cityWithStateAbbr: "Carle Place, NY",
  },
  {
    zip: "11516",
    ST: "NY",
    cityWithStateAbbr: "Cedarhurst, NY",
  },
  {
    zip: "11518",
    ST: "NY",
    cityWithStateAbbr: "East Rockaway, NY",
  },
  {
    zip: "11520",
    ST: "NY",
    cityWithStateAbbr: "Freeport, NY",
  },
  {
    zip: "11530",
    ST: "NY",
    cityWithStateAbbr: "Garden City, NY",
  },
  {
    zip: "11531",
    ST: "NY",
    cityWithStateAbbr: "Garden City, NY",
  },
  {
    zip: "11535",
    ST: "NY",
    cityWithStateAbbr: "Garden City, NY",
  },
  {
    zip: "11542",
    ST: "NY",
    cityWithStateAbbr: "Glen Cove, NY",
  },
  {
    zip: "11545",
    ST: "NY",
    cityWithStateAbbr: "Glen Head, NY",
  },
  {
    zip: "11547",
    ST: "NY",
    cityWithStateAbbr: "Glenwood Landing, NY",
  },
  {
    zip: "11548",
    ST: "NY",
    cityWithStateAbbr: "Greenvale, NY",
  },
  {
    zip: "11549",
    ST: "NY",
    cityWithStateAbbr: "Hempstead, NY",
  },
  {
    zip: "11550",
    ST: "NY",
    cityWithStateAbbr: "Hempstead, NY",
  },
  {
    zip: "11551",
    ST: "NY",
    cityWithStateAbbr: "Hempstead, NY",
  },
  {
    zip: "11552",
    ST: "NY",
    cityWithStateAbbr: "West Hempstead, NY",
  },
  {
    zip: "11553",
    ST: "NY",
    cityWithStateAbbr: "Uniondale, NY",
  },
  {
    zip: "11554",
    ST: "NY",
    cityWithStateAbbr: "East Meadow, NY",
  },
  {
    zip: "11555",
    ST: "NY",
    cityWithStateAbbr: "Uniondale, NY",
  },
  {
    zip: "11556",
    ST: "NY",
    cityWithStateAbbr: "Uniondale, NY",
  },
  {
    zip: "11557",
    ST: "NY",
    cityWithStateAbbr: "Hewlett, NY",
  },
  {
    zip: "11558",
    ST: "NY",
    cityWithStateAbbr: "Island Park, NY",
  },
  {
    zip: "11559",
    ST: "NY",
    cityWithStateAbbr: "Lawrence, NY",
  },
  {
    zip: "11560",
    ST: "NY",
    cityWithStateAbbr: "Locust Valley, NY",
  },
  {
    zip: "11561",
    ST: "NY",
    cityWithStateAbbr: "Long Beach, NY",
  },
  {
    zip: "11563",
    ST: "NY",
    cityWithStateAbbr: "Lynbrook, NY",
  },
  {
    zip: "11565",
    ST: "NY",
    cityWithStateAbbr: "Malverne, NY",
  },
  {
    zip: "11566",
    ST: "NY",
    cityWithStateAbbr: "Merrick, NY",
  },
  {
    zip: "11568",
    ST: "NY",
    cityWithStateAbbr: "Old Westbury, NY",
  },
  {
    zip: "11569",
    ST: "NY",
    cityWithStateAbbr: "Point Lookout, NY",
  },
  {
    zip: "11570",
    ST: "NY",
    cityWithStateAbbr: "Rockville Centre, NY",
  },
  {
    zip: "11571",
    ST: "NY",
    cityWithStateAbbr: "Rockville Centre, NY",
  },
  {
    zip: "11572",
    ST: "NY",
    cityWithStateAbbr: "Oceanside, NY",
  },
  {
    zip: "11575",
    ST: "NY",
    cityWithStateAbbr: "Roosevelt, NY",
  },
  {
    zip: "11576",
    ST: "NY",
    cityWithStateAbbr: "Roslyn, NY",
  },
  {
    zip: "11577",
    ST: "NY",
    cityWithStateAbbr: "Roslyn Heights, NY",
  },
  {
    zip: "11579",
    ST: "NY",
    cityWithStateAbbr: "Sea Cliff, NY",
  },
  {
    zip: "11580",
    ST: "NY",
    cityWithStateAbbr: "Valley Stream, NY",
  },
  {
    zip: "11581",
    ST: "NY",
    cityWithStateAbbr: "Valley Stream, NY",
  },
  {
    zip: "11582",
    ST: "NY",
    cityWithStateAbbr: "Valley Stream, NY",
  },
  {
    zip: "11590",
    ST: "NY",
    cityWithStateAbbr: "Westbury, NY",
  },
  {
    zip: "11596",
    ST: "NY",
    cityWithStateAbbr: "Williston Park, NY",
  },
  {
    zip: "11598",
    ST: "NY",
    cityWithStateAbbr: "Woodmere, NY",
  },
  {
    zip: "11599",
    ST: "NY",
    cityWithStateAbbr: "Garden City, NY",
  },
  {
    zip: "11690",
    ST: "NY",
    cityWithStateAbbr: "Far Rockaway, NY",
  },
  {
    zip: "11691",
    ST: "NY",
    cityWithStateAbbr: "Far Rockaway, NY",
  },
  {
    zip: "11692",
    ST: "NY",
    cityWithStateAbbr: "Arverne, NY",
  },
  {
    zip: "11693",
    ST: "NY",
    cityWithStateAbbr: "Far Rockaway, NY",
  },
  {
    zip: "11694",
    ST: "NY",
    cityWithStateAbbr: "Rockaway Park, NY",
  },
  {
    zip: "11695",
    ST: "NY",
    cityWithStateAbbr: "Far Rockaway, NY",
  },
  {
    zip: "11697",
    ST: "NY",
    cityWithStateAbbr: "Breezy Point, NY",
  },
  {
    zip: "11701",
    ST: "NY",
    cityWithStateAbbr: "Amityville, NY",
  },
  {
    zip: "11702",
    ST: "NY",
    cityWithStateAbbr: "Babylon, NY",
  },
  {
    zip: "11703",
    ST: "NY",
    cityWithStateAbbr: "North Babylon, NY",
  },
  {
    zip: "11704",
    ST: "NY",
    cityWithStateAbbr: "West Babylon, NY",
  },
  {
    zip: "11705",
    ST: "NY",
    cityWithStateAbbr: "Bayport, NY",
  },
  {
    zip: "11706",
    ST: "NY",
    cityWithStateAbbr: "Bay Shore, NY",
  },
  {
    zip: "11707",
    ST: "NY",
    cityWithStateAbbr: "West Babylon, NY",
  },
  {
    zip: "11709",
    ST: "NY",
    cityWithStateAbbr: "Bayville, NY",
  },
  {
    zip: "11710",
    ST: "NY",
    cityWithStateAbbr: "Bellmore, NY",
  },
  {
    zip: "11713",
    ST: "NY",
    cityWithStateAbbr: "Bellport, NY",
  },
  {
    zip: "11714",
    ST: "NY",
    cityWithStateAbbr: "Bethpage, NY",
  },
  {
    zip: "11715",
    ST: "NY",
    cityWithStateAbbr: "Blue Point, NY",
  },
  {
    zip: "11716",
    ST: "NY",
    cityWithStateAbbr: "Bohemia, NY",
  },
  {
    zip: "11717",
    ST: "NY",
    cityWithStateAbbr: "Brentwood, NY",
  },
  {
    zip: "11718",
    ST: "NY",
    cityWithStateAbbr: "Brightwaters, NY",
  },
  {
    zip: "11719",
    ST: "NY",
    cityWithStateAbbr: "Brookhaven, NY",
  },
  {
    zip: "11720",
    ST: "NY",
    cityWithStateAbbr: "Centereach, NY",
  },
  {
    zip: "11721",
    ST: "NY",
    cityWithStateAbbr: "Centerport, NY",
  },
  {
    zip: "11722",
    ST: "NY",
    cityWithStateAbbr: "Central Islip, NY",
  },
  {
    zip: "11724",
    ST: "NY",
    cityWithStateAbbr: "Cold Spring Harbor, NY",
  },
  {
    zip: "11725",
    ST: "NY",
    cityWithStateAbbr: "Commack, NY",
  },
  {
    zip: "11726",
    ST: "NY",
    cityWithStateAbbr: "Copiague, NY",
  },
  {
    zip: "11727",
    ST: "NY",
    cityWithStateAbbr: "Coram, NY",
  },
  {
    zip: "11729",
    ST: "NY",
    cityWithStateAbbr: "Deer Park, NY",
  },
  {
    zip: "11730",
    ST: "NY",
    cityWithStateAbbr: "East Islip, NY",
  },
  {
    zip: "11731",
    ST: "NY",
    cityWithStateAbbr: "East Northport, NY",
  },
  {
    zip: "11732",
    ST: "NY",
    cityWithStateAbbr: "East Norwich, NY",
  },
  {
    zip: "11733",
    ST: "NY",
    cityWithStateAbbr: "East Setauket, NY",
  },
  {
    zip: "11735",
    ST: "NY",
    cityWithStateAbbr: "Farmingdale, NY",
  },
  {
    zip: "11736",
    ST: "NY",
    cityWithStateAbbr: "Farmingdale, NY",
  },
  {
    zip: "11737",
    ST: "NY",
    cityWithStateAbbr: "Farmingdale, NY",
  },
  {
    zip: "11738",
    ST: "NY",
    cityWithStateAbbr: "Farmingville, NY",
  },
  {
    zip: "11739",
    ST: "NY",
    cityWithStateAbbr: "Great River, NY",
  },
  {
    zip: "11740",
    ST: "NY",
    cityWithStateAbbr: "Greenlawn, NY",
  },
  {
    zip: "11741",
    ST: "NY",
    cityWithStateAbbr: "Holbrook, NY",
  },
  {
    zip: "11742",
    ST: "NY",
    cityWithStateAbbr: "Holtsville, NY",
  },
  {
    zip: "11743",
    ST: "NY",
    cityWithStateAbbr: "Huntington, NY",
  },
  {
    zip: "11746",
    ST: "NY",
    cityWithStateAbbr: "Huntington Station, NY",
  },
  {
    zip: "11747",
    ST: "NY",
    cityWithStateAbbr: "Melville, NY",
  },
  {
    zip: "11749",
    ST: "NY",
    cityWithStateAbbr: "Islandia, NY",
  },
  {
    zip: "11751",
    ST: "NY",
    cityWithStateAbbr: "Islip, NY",
  },
  {
    zip: "11752",
    ST: "NY",
    cityWithStateAbbr: "Islip Terrace, NY",
  },
  {
    zip: "11753",
    ST: "NY",
    cityWithStateAbbr: "Jericho, NY",
  },
  {
    zip: "11754",
    ST: "NY",
    cityWithStateAbbr: "Kings Park, NY",
  },
  {
    zip: "11755",
    ST: "NY",
    cityWithStateAbbr: "Lake Grove, NY",
  },
  {
    zip: "11756",
    ST: "NY",
    cityWithStateAbbr: "Levittown, NY",
  },
  {
    zip: "11757",
    ST: "NY",
    cityWithStateAbbr: "Lindenhurst, NY",
  },
  {
    zip: "11758",
    ST: "NY",
    cityWithStateAbbr: "Massapequa, NY",
  },
  {
    zip: "11760",
    ST: "NY",
    cityWithStateAbbr: "Melville, NY",
  },
  {
    zip: "11762",
    ST: "NY",
    cityWithStateAbbr: "Massapequa Park, NY",
  },
  {
    zip: "11763",
    ST: "NY",
    cityWithStateAbbr: "Medford, NY",
  },
  {
    zip: "11764",
    ST: "NY",
    cityWithStateAbbr: "Miller Place, NY",
  },
  {
    zip: "11765",
    ST: "NY",
    cityWithStateAbbr: "Mill Neck, NY",
  },
  {
    zip: "11766",
    ST: "NY",
    cityWithStateAbbr: "Mount Sinai, NY",
  },
  {
    zip: "11767",
    ST: "NY",
    cityWithStateAbbr: "Nesconset, NY",
  },
  {
    zip: "11768",
    ST: "NY",
    cityWithStateAbbr: "Northport, NY",
  },
  {
    zip: "11769",
    ST: "NY",
    cityWithStateAbbr: "Oakdale, NY",
  },
  {
    zip: "11770",
    ST: "NY",
    cityWithStateAbbr: "Ocean Beach, NY",
  },
  {
    zip: "11771",
    ST: "NY",
    cityWithStateAbbr: "Oyster Bay, NY",
  },
  {
    zip: "11772",
    ST: "NY",
    cityWithStateAbbr: "Patchogue, NY",
  },
  {
    zip: "11773",
    ST: "NY",
    cityWithStateAbbr: "Syosset, NY",
  },
  {
    zip: "11774",
    ST: "NY",
    cityWithStateAbbr: "Farmingdale, NY",
  },
  {
    zip: "11775",
    ST: "NY",
    cityWithStateAbbr: "Melville, NY",
  },
  {
    zip: "11776",
    ST: "NY",
    cityWithStateAbbr: "Port Jefferson Station, NY",
  },
  {
    zip: "11777",
    ST: "NY",
    cityWithStateAbbr: "Port Jefferson, NY",
  },
  {
    zip: "11778",
    ST: "NY",
    cityWithStateAbbr: "Rocky Point, NY",
  },
  {
    zip: "11779",
    ST: "NY",
    cityWithStateAbbr: "Ronkonkoma, NY",
  },
  {
    zip: "11780",
    ST: "NY",
    cityWithStateAbbr: "Saint James, NY",
  },
  {
    zip: "11782",
    ST: "NY",
    cityWithStateAbbr: "Sayville, NY",
  },
  {
    zip: "11783",
    ST: "NY",
    cityWithStateAbbr: "Seaford, NY",
  },
  {
    zip: "11784",
    ST: "NY",
    cityWithStateAbbr: "Selden, NY",
  },
  {
    zip: "11786",
    ST: "NY",
    cityWithStateAbbr: "Shoreham, NY",
  },
  {
    zip: "11787",
    ST: "NY",
    cityWithStateAbbr: "Smithtown, NY",
  },
  {
    zip: "11788",
    ST: "NY",
    cityWithStateAbbr: "Hauppauge, NY",
  },
  {
    zip: "11789",
    ST: "NY",
    cityWithStateAbbr: "Sound Beach, NY",
  },
  {
    zip: "11790",
    ST: "NY",
    cityWithStateAbbr: "Stony Brook, NY",
  },
  {
    zip: "11791",
    ST: "NY",
    cityWithStateAbbr: "Syosset, NY",
  },
  {
    zip: "11792",
    ST: "NY",
    cityWithStateAbbr: "Wading River, NY",
  },
  {
    zip: "11793",
    ST: "NY",
    cityWithStateAbbr: "Wantagh, NY",
  },
  {
    zip: "11794",
    ST: "NY",
    cityWithStateAbbr: "Stony Brook, NY",
  },
  {
    zip: "11795",
    ST: "NY",
    cityWithStateAbbr: "West Islip, NY",
  },
  {
    zip: "11796",
    ST: "NY",
    cityWithStateAbbr: "West Sayville, NY",
  },
  {
    zip: "11797",
    ST: "NY",
    cityWithStateAbbr: "Woodbury, NY",
  },
  {
    zip: "11798",
    ST: "NY",
    cityWithStateAbbr: "Wyandanch, NY",
  },
  {
    zip: "11801",
    ST: "NY",
    cityWithStateAbbr: "Hicksville, NY",
  },
  {
    zip: "11802",
    ST: "NY",
    cityWithStateAbbr: "Hicksville, NY",
  },
  {
    zip: "11803",
    ST: "NY",
    cityWithStateAbbr: "Plainview, NY",
  },
  {
    zip: "11804",
    ST: "NY",
    cityWithStateAbbr: "Old Bethpage, NY",
  },
  {
    zip: "11815",
    ST: "NY",
    cityWithStateAbbr: "Hicksville, NY",
  },
  {
    zip: "11819",
    ST: "NY",
    cityWithStateAbbr: "Hicksville, NY",
  },
  {
    zip: "11854",
    ST: "NY",
    cityWithStateAbbr: "Hicksville, NY",
  },
  {
    zip: "11901",
    ST: "NY",
    cityWithStateAbbr: "Riverhead, NY",
  },
  {
    zip: "11930",
    ST: "NY",
    cityWithStateAbbr: "Amagansett, NY",
  },
  {
    zip: "11931",
    ST: "NY",
    cityWithStateAbbr: "Aquebogue, NY",
  },
  {
    zip: "11932",
    ST: "NY",
    cityWithStateAbbr: "Bridgehampton, NY",
  },
  {
    zip: "11933",
    ST: "NY",
    cityWithStateAbbr: "Calverton, NY",
  },
  {
    zip: "11934",
    ST: "NY",
    cityWithStateAbbr: "Center Moriches, NY",
  },
  {
    zip: "11935",
    ST: "NY",
    cityWithStateAbbr: "Cutchogue, NY",
  },
  {
    zip: "11937",
    ST: "NY",
    cityWithStateAbbr: "East Hampton, NY",
  },
  {
    zip: "11939",
    ST: "NY",
    cityWithStateAbbr: "East Marion, NY",
  },
  {
    zip: "11940",
    ST: "NY",
    cityWithStateAbbr: "East Moriches, NY",
  },
  {
    zip: "11941",
    ST: "NY",
    cityWithStateAbbr: "Eastport, NY",
  },
  {
    zip: "11942",
    ST: "NY",
    cityWithStateAbbr: "East Quogue, NY",
  },
  {
    zip: "11944",
    ST: "NY",
    cityWithStateAbbr: "Greenport, NY",
  },
  {
    zip: "11946",
    ST: "NY",
    cityWithStateAbbr: "Hampton Bays, NY",
  },
  {
    zip: "11947",
    ST: "NY",
    cityWithStateAbbr: "Jamesport, NY",
  },
  {
    zip: "11948",
    ST: "NY",
    cityWithStateAbbr: "Laurel, NY",
  },
  {
    zip: "11949",
    ST: "NY",
    cityWithStateAbbr: "Manorville, NY",
  },
  {
    zip: "11950",
    ST: "NY",
    cityWithStateAbbr: "Mastic, NY",
  },
  {
    zip: "11951",
    ST: "NY",
    cityWithStateAbbr: "Mastic Beach, NY",
  },
  {
    zip: "11952",
    ST: "NY",
    cityWithStateAbbr: "Mattituck, NY",
  },
  {
    zip: "11953",
    ST: "NY",
    cityWithStateAbbr: "Middle Island, NY",
  },
  {
    zip: "11954",
    ST: "NY",
    cityWithStateAbbr: "Montauk, NY",
  },
  {
    zip: "11955",
    ST: "NY",
    cityWithStateAbbr: "Moriches, NY",
  },
  {
    zip: "11956",
    ST: "NY",
    cityWithStateAbbr: "New Suffolk, NY",
  },
  {
    zip: "11957",
    ST: "NY",
    cityWithStateAbbr: "Orient, NY",
  },
  {
    zip: "11958",
    ST: "NY",
    cityWithStateAbbr: "Peconic, NY",
  },
  {
    zip: "11959",
    ST: "NY",
    cityWithStateAbbr: "Quogue, NY",
  },
  {
    zip: "11960",
    ST: "NY",
    cityWithStateAbbr: "Remsenburg, NY",
  },
  {
    zip: "11961",
    ST: "NY",
    cityWithStateAbbr: "Ridge, NY",
  },
  {
    zip: "11962",
    ST: "NY",
    cityWithStateAbbr: "Sagaponack, NY",
  },
  {
    zip: "11963",
    ST: "NY",
    cityWithStateAbbr: "Sag Harbor, NY",
  },
  {
    zip: "11964",
    ST: "NY",
    cityWithStateAbbr: "Shelter Island, NY",
  },
  {
    zip: "11965",
    ST: "NY",
    cityWithStateAbbr: "Shelter Island Heights, NY",
  },
  {
    zip: "11967",
    ST: "NY",
    cityWithStateAbbr: "Shirley, NY",
  },
  {
    zip: "11968",
    ST: "NY",
    cityWithStateAbbr: "Southampton, NY",
  },
  {
    zip: "11969",
    ST: "NY",
    cityWithStateAbbr: "Southampton, NY",
  },
  {
    zip: "11970",
    ST: "NY",
    cityWithStateAbbr: "South Jamesport, NY",
  },
  {
    zip: "11971",
    ST: "NY",
    cityWithStateAbbr: "Southold, NY",
  },
  {
    zip: "11972",
    ST: "NY",
    cityWithStateAbbr: "Speonk, NY",
  },
  {
    zip: "11973",
    ST: "NY",
    cityWithStateAbbr: "Upton, NY",
  },
  {
    zip: "11975",
    ST: "NY",
    cityWithStateAbbr: "Wainscott, NY",
  },
  {
    zip: "11976",
    ST: "NY",
    cityWithStateAbbr: "Water Mill, NY",
  },
  {
    zip: "11977",
    ST: "NY",
    cityWithStateAbbr: "Westhampton, NY",
  },
  {
    zip: "11978",
    ST: "NY",
    cityWithStateAbbr: "Westhampton Beach, NY",
  },
  {
    zip: "11980",
    ST: "NY",
    cityWithStateAbbr: "Yaphank, NY",
  },
  {
    zip: "12007",
    ST: "NY",
    cityWithStateAbbr: "Alcove, NY",
  },
  {
    zip: "12008",
    ST: "NY",
    cityWithStateAbbr: "Alplaus, NY",
  },
  {
    zip: "12009",
    ST: "NY",
    cityWithStateAbbr: "Altamont, NY",
  },
  {
    zip: "12010",
    ST: "NY",
    cityWithStateAbbr: "Amsterdam, NY",
  },
  {
    zip: "12015",
    ST: "NY",
    cityWithStateAbbr: "Athens, NY",
  },
  {
    zip: "12016",
    ST: "NY",
    cityWithStateAbbr: "Auriesville, NY",
  },
  {
    zip: "12017",
    ST: "NY",
    cityWithStateAbbr: "Austerlitz, NY",
  },
  {
    zip: "12018",
    ST: "NY",
    cityWithStateAbbr: "Averill Park, NY",
  },
  {
    zip: "12019",
    ST: "NY",
    cityWithStateAbbr: "Ballston Lake, NY",
  },
  {
    zip: "12020",
    ST: "NY",
    cityWithStateAbbr: "Ballston Spa, NY",
  },
  {
    zip: "12022",
    ST: "NY",
    cityWithStateAbbr: "Berlin, NY",
  },
  {
    zip: "12023",
    ST: "NY",
    cityWithStateAbbr: "Berne, NY",
  },
  {
    zip: "12024",
    ST: "NY",
    cityWithStateAbbr: "Brainard, NY",
  },
  {
    zip: "12025",
    ST: "NY",
    cityWithStateAbbr: "Broadalbin, NY",
  },
  {
    zip: "12027",
    ST: "NY",
    cityWithStateAbbr: "Burnt Hills, NY",
  },
  {
    zip: "12028",
    ST: "NY",
    cityWithStateAbbr: "Buskirk, NY",
  },
  {
    zip: "12029",
    ST: "NY",
    cityWithStateAbbr: "Canaan, NY",
  },
  {
    zip: "12031",
    ST: "NY",
    cityWithStateAbbr: "Carlisle, NY",
  },
  {
    zip: "12032",
    ST: "NY",
    cityWithStateAbbr: "Caroga Lake, NY",
  },
  {
    zip: "12033",
    ST: "NY",
    cityWithStateAbbr: "Castleton On Hudson, NY",
  },
  {
    zip: "12035",
    ST: "NY",
    cityWithStateAbbr: "Central Bridge, NY",
  },
  {
    zip: "12036",
    ST: "NY",
    cityWithStateAbbr: "Charlotteville, NY",
  },
  {
    zip: "12037",
    ST: "NY",
    cityWithStateAbbr: "Chatham, NY",
  },
  {
    zip: "12040",
    ST: "NY",
    cityWithStateAbbr: "Cherry Plain, NY",
  },
  {
    zip: "12041",
    ST: "NY",
    cityWithStateAbbr: "Clarksville, NY",
  },
  {
    zip: "12042",
    ST: "NY",
    cityWithStateAbbr: "Climax, NY",
  },
  {
    zip: "12043",
    ST: "NY",
    cityWithStateAbbr: "Cobleskill, NY",
  },
  {
    zip: "12045",
    ST: "NY",
    cityWithStateAbbr: "Coeymans, NY",
  },
  {
    zip: "12046",
    ST: "NY",
    cityWithStateAbbr: "Coeymans Hollow, NY",
  },
  {
    zip: "12047",
    ST: "NY",
    cityWithStateAbbr: "Cohoes, NY",
  },
  {
    zip: "12050",
    ST: "NY",
    cityWithStateAbbr: "Columbiaville, NY",
  },
  {
    zip: "12051",
    ST: "NY",
    cityWithStateAbbr: "Coxsackie, NY",
  },
  {
    zip: "12052",
    ST: "NY",
    cityWithStateAbbr: "Cropseyville, NY",
  },
  {
    zip: "12053",
    ST: "NY",
    cityWithStateAbbr: "Delanson, NY",
  },
  {
    zip: "12054",
    ST: "NY",
    cityWithStateAbbr: "Delmar, NY",
  },
  {
    zip: "12055",
    ST: "NY",
    cityWithStateAbbr: "Dormansville, NY",
  },
  {
    zip: "12056",
    ST: "NY",
    cityWithStateAbbr: "Duanesburg, NY",
  },
  {
    zip: "12057",
    ST: "NY",
    cityWithStateAbbr: "Eagle Bridge, NY",
  },
  {
    zip: "12058",
    ST: "NY",
    cityWithStateAbbr: "Earlton, NY",
  },
  {
    zip: "12059",
    ST: "NY",
    cityWithStateAbbr: "East Berne, NY",
  },
  {
    zip: "12060",
    ST: "NY",
    cityWithStateAbbr: "East Chatham, NY",
  },
  {
    zip: "12061",
    ST: "NY",
    cityWithStateAbbr: "East Greenbush, NY",
  },
  {
    zip: "12062",
    ST: "NY",
    cityWithStateAbbr: "East Nassau, NY",
  },
  {
    zip: "12063",
    ST: "NY",
    cityWithStateAbbr: "East Schodack, NY",
  },
  {
    zip: "12064",
    ST: "NY",
    cityWithStateAbbr: "East Worcester, NY",
  },
  {
    zip: "12065",
    ST: "NY",
    cityWithStateAbbr: "Clifton Park, NY",
  },
  {
    zip: "12066",
    ST: "NY",
    cityWithStateAbbr: "Esperance, NY",
  },
  {
    zip: "12067",
    ST: "NY",
    cityWithStateAbbr: "Feura Bush, NY",
  },
  {
    zip: "12068",
    ST: "NY",
    cityWithStateAbbr: "Fonda, NY",
  },
  {
    zip: "12069",
    ST: "NY",
    cityWithStateAbbr: "Fort Hunter, NY",
  },
  {
    zip: "12070",
    ST: "NY",
    cityWithStateAbbr: "Fort Johnson, NY",
  },
  {
    zip: "12071",
    ST: "NY",
    cityWithStateAbbr: "Fultonham, NY",
  },
  {
    zip: "12072",
    ST: "NY",
    cityWithStateAbbr: "Fultonville, NY",
  },
  {
    zip: "12073",
    ST: "NY",
    cityWithStateAbbr: "Gallupville, NY",
  },
  {
    zip: "12074",
    ST: "NY",
    cityWithStateAbbr: "Galway, NY",
  },
  {
    zip: "12075",
    ST: "NY",
    cityWithStateAbbr: "Ghent, NY",
  },
  {
    zip: "12076",
    ST: "NY",
    cityWithStateAbbr: "Gilboa, NY",
  },
  {
    zip: "12077",
    ST: "NY",
    cityWithStateAbbr: "Glenmont, NY",
  },
  {
    zip: "12078",
    ST: "NY",
    cityWithStateAbbr: "Gloversville, NY",
  },
  {
    zip: "12082",
    ST: "NY",
    cityWithStateAbbr: "Grafton, NY",
  },
  {
    zip: "12083",
    ST: "NY",
    cityWithStateAbbr: "Greenville, NY",
  },
  {
    zip: "12084",
    ST: "NY",
    cityWithStateAbbr: "Guilderland, NY",
  },
  {
    zip: "12085",
    ST: "NY",
    cityWithStateAbbr: "Guilderland Center, NY",
  },
  {
    zip: "12086",
    ST: "NY",
    cityWithStateAbbr: "Hagaman, NY",
  },
  {
    zip: "12087",
    ST: "NY",
    cityWithStateAbbr: "Hannacroix, NY",
  },
  {
    zip: "12089",
    ST: "NY",
    cityWithStateAbbr: "Hoosick, NY",
  },
  {
    zip: "12090",
    ST: "NY",
    cityWithStateAbbr: "Hoosick Falls, NY",
  },
  {
    zip: "12092",
    ST: "NY",
    cityWithStateAbbr: "Howes Cave, NY",
  },
  {
    zip: "12093",
    ST: "NY",
    cityWithStateAbbr: "Jefferson, NY",
  },
  {
    zip: "12094",
    ST: "NY",
    cityWithStateAbbr: "Johnsonville, NY",
  },
  {
    zip: "12095",
    ST: "NY",
    cityWithStateAbbr: "Johnstown, NY",
  },
  {
    zip: "12106",
    ST: "NY",
    cityWithStateAbbr: "Kinderhook, NY",
  },
  {
    zip: "12107",
    ST: "NY",
    cityWithStateAbbr: "Knox, NY",
  },
  {
    zip: "12108",
    ST: "NY",
    cityWithStateAbbr: "Lake Pleasant, NY",
  },
  {
    zip: "12110",
    ST: "NY",
    cityWithStateAbbr: "Latham, NY",
  },
  {
    zip: "12115",
    ST: "NY",
    cityWithStateAbbr: "Malden Bridge, NY",
  },
  {
    zip: "12116",
    ST: "NY",
    cityWithStateAbbr: "Maryland, NY",
  },
  {
    zip: "12117",
    ST: "NY",
    cityWithStateAbbr: "Mayfield, NY",
  },
  {
    zip: "12118",
    ST: "NY",
    cityWithStateAbbr: "Mechanicville, NY",
  },
  {
    zip: "12120",
    ST: "NY",
    cityWithStateAbbr: "Medusa, NY",
  },
  {
    zip: "12121",
    ST: "NY",
    cityWithStateAbbr: "Melrose, NY",
  },
  {
    zip: "12122",
    ST: "NY",
    cityWithStateAbbr: "Middleburgh, NY",
  },
  {
    zip: "12123",
    ST: "NY",
    cityWithStateAbbr: "Nassau, NY",
  },
  {
    zip: "12124",
    ST: "NY",
    cityWithStateAbbr: "New Baltimore, NY",
  },
  {
    zip: "12125",
    ST: "NY",
    cityWithStateAbbr: "New Lebanon, NY",
  },
  {
    zip: "12128",
    ST: "NY",
    cityWithStateAbbr: "Newtonville, NY",
  },
  {
    zip: "12130",
    ST: "NY",
    cityWithStateAbbr: "Niverville, NY",
  },
  {
    zip: "12131",
    ST: "NY",
    cityWithStateAbbr: "North Blenheim, NY",
  },
  {
    zip: "12132",
    ST: "NY",
    cityWithStateAbbr: "North Chatham, NY",
  },
  {
    zip: "12133",
    ST: "NY",
    cityWithStateAbbr: "North Hoosick, NY",
  },
  {
    zip: "12134",
    ST: "NY",
    cityWithStateAbbr: "Northville, NY",
  },
  {
    zip: "12136",
    ST: "NY",
    cityWithStateAbbr: "Old Chatham, NY",
  },
  {
    zip: "12137",
    ST: "NY",
    cityWithStateAbbr: "Pattersonville, NY",
  },
  {
    zip: "12138",
    ST: "NY",
    cityWithStateAbbr: "Petersburg, NY",
  },
  {
    zip: "12139",
    ST: "NY",
    cityWithStateAbbr: "Piseco, NY",
  },
  {
    zip: "12140",
    ST: "NY",
    cityWithStateAbbr: "Poestenkill, NY",
  },
  {
    zip: "12141",
    ST: "NY",
    cityWithStateAbbr: "Quaker Street, NY",
  },
  {
    zip: "12143",
    ST: "NY",
    cityWithStateAbbr: "Ravena, NY",
  },
  {
    zip: "12144",
    ST: "NY",
    cityWithStateAbbr: "Rensselaer, NY",
  },
  {
    zip: "12147",
    ST: "NY",
    cityWithStateAbbr: "Rensselaerville, NY",
  },
  {
    zip: "12148",
    ST: "NY",
    cityWithStateAbbr: "Rexford, NY",
  },
  {
    zip: "12149",
    ST: "NY",
    cityWithStateAbbr: "Richmondville, NY",
  },
  {
    zip: "12150",
    ST: "NY",
    cityWithStateAbbr: "Rotterdam Junction, NY",
  },
  {
    zip: "12151",
    ST: "NY",
    cityWithStateAbbr: "Round Lake, NY",
  },
  {
    zip: "12153",
    ST: "NY",
    cityWithStateAbbr: "Sand Lake, NY",
  },
  {
    zip: "12154",
    ST: "NY",
    cityWithStateAbbr: "Schaghticoke, NY",
  },
  {
    zip: "12155",
    ST: "NY",
    cityWithStateAbbr: "Schenevus, NY",
  },
  {
    zip: "12156",
    ST: "NY",
    cityWithStateAbbr: "Schodack Landing, NY",
  },
  {
    zip: "12157",
    ST: "NY",
    cityWithStateAbbr: "Schoharie, NY",
  },
  {
    zip: "12158",
    ST: "NY",
    cityWithStateAbbr: "Selkirk, NY",
  },
  {
    zip: "12159",
    ST: "NY",
    cityWithStateAbbr: "Slingerlands, NY",
  },
  {
    zip: "12160",
    ST: "NY",
    cityWithStateAbbr: "Sloansville, NY",
  },
  {
    zip: "12161",
    ST: "NY",
    cityWithStateAbbr: "South Bethlehem, NY",
  },
  {
    zip: "12164",
    ST: "NY",
    cityWithStateAbbr: "Speculator, NY",
  },
  {
    zip: "12165",
    ST: "NY",
    cityWithStateAbbr: "Spencertown, NY",
  },
  {
    zip: "12166",
    ST: "NY",
    cityWithStateAbbr: "Sprakers, NY",
  },
  {
    zip: "12167",
    ST: "NY",
    cityWithStateAbbr: "Stamford, NY",
  },
  {
    zip: "12168",
    ST: "NY",
    cityWithStateAbbr: "Stephentown, NY",
  },
  {
    zip: "12169",
    ST: "NY",
    cityWithStateAbbr: "Stephentown, NY",
  },
  {
    zip: "12170",
    ST: "NY",
    cityWithStateAbbr: "Stillwater, NY",
  },
  {
    zip: "12172",
    ST: "NY",
    cityWithStateAbbr: "Stottville, NY",
  },
  {
    zip: "12173",
    ST: "NY",
    cityWithStateAbbr: "Stuyvesant, NY",
  },
  {
    zip: "12174",
    ST: "NY",
    cityWithStateAbbr: "Stuyvesant Falls, NY",
  },
  {
    zip: "12175",
    ST: "NY",
    cityWithStateAbbr: "Summit, NY",
  },
  {
    zip: "12176",
    ST: "NY",
    cityWithStateAbbr: "Surprise, NY",
  },
  {
    zip: "12177",
    ST: "NY",
    cityWithStateAbbr: "Tribes Hill, NY",
  },
  {
    zip: "12180",
    ST: "NY",
    cityWithStateAbbr: "Troy, NY",
  },
  {
    zip: "12181",
    ST: "NY",
    cityWithStateAbbr: "Troy, NY",
  },
  {
    zip: "12182",
    ST: "NY",
    cityWithStateAbbr: "Troy, NY",
  },
  {
    zip: "12183",
    ST: "NY",
    cityWithStateAbbr: "Troy, NY",
  },
  {
    zip: "12184",
    ST: "NY",
    cityWithStateAbbr: "Valatie, NY",
  },
  {
    zip: "12185",
    ST: "NY",
    cityWithStateAbbr: "Valley Falls, NY",
  },
  {
    zip: "12186",
    ST: "NY",
    cityWithStateAbbr: "Voorheesville, NY",
  },
  {
    zip: "12187",
    ST: "NY",
    cityWithStateAbbr: "Warnerville, NY",
  },
  {
    zip: "12188",
    ST: "NY",
    cityWithStateAbbr: "Waterford, NY",
  },
  {
    zip: "12189",
    ST: "NY",
    cityWithStateAbbr: "Watervliet, NY",
  },
  {
    zip: "12190",
    ST: "NY",
    cityWithStateAbbr: "Wells, NY",
  },
  {
    zip: "12192",
    ST: "NY",
    cityWithStateAbbr: "West Coxsackie, NY",
  },
  {
    zip: "12193",
    ST: "NY",
    cityWithStateAbbr: "Westerlo, NY",
  },
  {
    zip: "12194",
    ST: "NY",
    cityWithStateAbbr: "West Fulton, NY",
  },
  {
    zip: "12195",
    ST: "NY",
    cityWithStateAbbr: "West Lebanon, NY",
  },
  {
    zip: "12196",
    ST: "NY",
    cityWithStateAbbr: "West Sand Lake, NY",
  },
  {
    zip: "12197",
    ST: "NY",
    cityWithStateAbbr: "Worcester, NY",
  },
  {
    zip: "12198",
    ST: "NY",
    cityWithStateAbbr: "Wynantskill, NY",
  },
  {
    zip: "12201",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12202",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12203",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12204",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12205",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12206",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12207",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12208",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12209",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12210",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12211",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12212",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12214",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12220",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12222",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12223",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12224",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12225",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12226",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12227",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12228",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12229",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12230",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12231",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12232",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12233",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12234",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12235",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12236",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12237",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12238",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12239",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12240",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12241",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12242",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12243",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12244",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12245",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12246",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12247",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12248",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12249",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12250",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12252",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12255",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12256",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12257",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12260",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12261",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12288",
    ST: "NY",
    cityWithStateAbbr: "Albany, NY",
  },
  {
    zip: "12301",
    ST: "NY",
    cityWithStateAbbr: "Schenectady, NY",
  },
  {
    zip: "12302",
    ST: "NY",
    cityWithStateAbbr: "Schenectady, NY",
  },
  {
    zip: "12303",
    ST: "NY",
    cityWithStateAbbr: "Schenectady, NY",
  },
  {
    zip: "12304",
    ST: "NY",
    cityWithStateAbbr: "Schenectady, NY",
  },
  {
    zip: "12305",
    ST: "NY",
    cityWithStateAbbr: "Schenectady, NY",
  },
  {
    zip: "12306",
    ST: "NY",
    cityWithStateAbbr: "Schenectady, NY",
  },
  {
    zip: "12307",
    ST: "NY",
    cityWithStateAbbr: "Schenectady, NY",
  },
  {
    zip: "12308",
    ST: "NY",
    cityWithStateAbbr: "Schenectady, NY",
  },
  {
    zip: "12309",
    ST: "NY",
    cityWithStateAbbr: "Schenectady, NY",
  },
  {
    zip: "12325",
    ST: "NY",
    cityWithStateAbbr: "Schenectady, NY",
  },
  {
    zip: "12345",
    ST: "NY",
    cityWithStateAbbr: "Schenectady, NY",
  },
  {
    zip: "12401",
    ST: "NY",
    cityWithStateAbbr: "Kingston, NY",
  },
  {
    zip: "12402",
    ST: "NY",
    cityWithStateAbbr: "Kingston, NY",
  },
  {
    zip: "12404",
    ST: "NY",
    cityWithStateAbbr: "Accord, NY",
  },
  {
    zip: "12405",
    ST: "NY",
    cityWithStateAbbr: "Acra, NY",
  },
  {
    zip: "12406",
    ST: "NY",
    cityWithStateAbbr: "Arkville, NY",
  },
  {
    zip: "12407",
    ST: "NY",
    cityWithStateAbbr: "Ashland, NY",
  },
  {
    zip: "12409",
    ST: "NY",
    cityWithStateAbbr: "Bearsville, NY",
  },
  {
    zip: "12410",
    ST: "NY",
    cityWithStateAbbr: "Big Indian, NY",
  },
  {
    zip: "12411",
    ST: "NY",
    cityWithStateAbbr: "Bloomington, NY",
  },
  {
    zip: "12412",
    ST: "NY",
    cityWithStateAbbr: "Boiceville, NY",
  },
  {
    zip: "12413",
    ST: "NY",
    cityWithStateAbbr: "Cairo, NY",
  },
  {
    zip: "12414",
    ST: "NY",
    cityWithStateAbbr: "Catskill, NY",
  },
  {
    zip: "12416",
    ST: "NY",
    cityWithStateAbbr: "Chichester, NY",
  },
  {
    zip: "12417",
    ST: "NY",
    cityWithStateAbbr: "Connelly, NY",
  },
  {
    zip: "12418",
    ST: "NY",
    cityWithStateAbbr: "Cornwallville, NY",
  },
  {
    zip: "12419",
    ST: "NY",
    cityWithStateAbbr: "Cottekill, NY",
  },
  {
    zip: "12420",
    ST: "NY",
    cityWithStateAbbr: "Cragsmoor, NY",
  },
  {
    zip: "12421",
    ST: "NY",
    cityWithStateAbbr: "Denver, NY",
  },
  {
    zip: "12422",
    ST: "NY",
    cityWithStateAbbr: "Durham, NY",
  },
  {
    zip: "12423",
    ST: "NY",
    cityWithStateAbbr: "East Durham, NY",
  },
  {
    zip: "12424",
    ST: "NY",
    cityWithStateAbbr: "East Jewett, NY",
  },
  {
    zip: "12427",
    ST: "NY",
    cityWithStateAbbr: "Elka Park, NY",
  },
  {
    zip: "12428",
    ST: "NY",
    cityWithStateAbbr: "Ellenville, NY",
  },
  {
    zip: "12429",
    ST: "NY",
    cityWithStateAbbr: "Esopus, NY",
  },
  {
    zip: "12430",
    ST: "NY",
    cityWithStateAbbr: "Fleischmanns, NY",
  },
  {
    zip: "12431",
    ST: "NY",
    cityWithStateAbbr: "Freehold, NY",
  },
  {
    zip: "12432",
    ST: "NY",
    cityWithStateAbbr: "Glasco, NY",
  },
  {
    zip: "12433",
    ST: "NY",
    cityWithStateAbbr: "Glenford, NY",
  },
  {
    zip: "12434",
    ST: "NY",
    cityWithStateAbbr: "Grand Gorge, NY",
  },
  {
    zip: "12435",
    ST: "NY",
    cityWithStateAbbr: "Greenfield Park, NY",
  },
  {
    zip: "12436",
    ST: "NY",
    cityWithStateAbbr: "Haines Falls, NY",
  },
  {
    zip: "12438",
    ST: "NY",
    cityWithStateAbbr: "Halcottsville, NY",
  },
  {
    zip: "12439",
    ST: "NY",
    cityWithStateAbbr: "Hensonville, NY",
  },
  {
    zip: "12440",
    ST: "NY",
    cityWithStateAbbr: "High Falls, NY",
  },
  {
    zip: "12441",
    ST: "NY",
    cityWithStateAbbr: "Highmount, NY",
  },
  {
    zip: "12442",
    ST: "NY",
    cityWithStateAbbr: "Hunter, NY",
  },
  {
    zip: "12443",
    ST: "NY",
    cityWithStateAbbr: "Hurley, NY",
  },
  {
    zip: "12444",
    ST: "NY",
    cityWithStateAbbr: "Jewett, NY",
  },
  {
    zip: "12446",
    ST: "NY",
    cityWithStateAbbr: "Kerhonkson, NY",
  },
  {
    zip: "12448",
    ST: "NY",
    cityWithStateAbbr: "Lake Hill, NY",
  },
  {
    zip: "12449",
    ST: "NY",
    cityWithStateAbbr: "Lake Katrine, NY",
  },
  {
    zip: "12450",
    ST: "NY",
    cityWithStateAbbr: "Lanesville, NY",
  },
  {
    zip: "12451",
    ST: "NY",
    cityWithStateAbbr: "Leeds, NY",
  },
  {
    zip: "12452",
    ST: "NY",
    cityWithStateAbbr: "Lexington, NY",
  },
  {
    zip: "12453",
    ST: "NY",
    cityWithStateAbbr: "Malden On Hudson, NY",
  },
  {
    zip: "12454",
    ST: "NY",
    cityWithStateAbbr: "Maplecrest, NY",
  },
  {
    zip: "12455",
    ST: "NY",
    cityWithStateAbbr: "Margaretville, NY",
  },
  {
    zip: "12456",
    ST: "NY",
    cityWithStateAbbr: "Mount Marion, NY",
  },
  {
    zip: "12457",
    ST: "NY",
    cityWithStateAbbr: "Mount Tremper, NY",
  },
  {
    zip: "12458",
    ST: "NY",
    cityWithStateAbbr: "Napanoch, NY",
  },
  {
    zip: "12459",
    ST: "NY",
    cityWithStateAbbr: "New Kingston, NY",
  },
  {
    zip: "12460",
    ST: "NY",
    cityWithStateAbbr: "Oak Hill, NY",
  },
  {
    zip: "12461",
    ST: "NY",
    cityWithStateAbbr: "Olivebridge, NY",
  },
  {
    zip: "12463",
    ST: "NY",
    cityWithStateAbbr: "Palenville, NY",
  },
  {
    zip: "12464",
    ST: "NY",
    cityWithStateAbbr: "Phoenicia, NY",
  },
  {
    zip: "12465",
    ST: "NY",
    cityWithStateAbbr: "Pine Hill, NY",
  },
  {
    zip: "12466",
    ST: "NY",
    cityWithStateAbbr: "Port Ewen, NY",
  },
  {
    zip: "12468",
    ST: "NY",
    cityWithStateAbbr: "Prattsville, NY",
  },
  {
    zip: "12469",
    ST: "NY",
    cityWithStateAbbr: "Preston Hollow, NY",
  },
  {
    zip: "12470",
    ST: "NY",
    cityWithStateAbbr: "Purling, NY",
  },
  {
    zip: "12471",
    ST: "NY",
    cityWithStateAbbr: "Rifton, NY",
  },
  {
    zip: "12472",
    ST: "NY",
    cityWithStateAbbr: "Rosendale, NY",
  },
  {
    zip: "12473",
    ST: "NY",
    cityWithStateAbbr: "Round Top, NY",
  },
  {
    zip: "12474",
    ST: "NY",
    cityWithStateAbbr: "Roxbury, NY",
  },
  {
    zip: "12475",
    ST: "NY",
    cityWithStateAbbr: "Ruby, NY",
  },
  {
    zip: "12477",
    ST: "NY",
    cityWithStateAbbr: "Saugerties, NY",
  },
  {
    zip: "12480",
    ST: "NY",
    cityWithStateAbbr: "Shandaken, NY",
  },
  {
    zip: "12481",
    ST: "NY",
    cityWithStateAbbr: "Shokan, NY",
  },
  {
    zip: "12482",
    ST: "NY",
    cityWithStateAbbr: "South Cairo, NY",
  },
  {
    zip: "12483",
    ST: "NY",
    cityWithStateAbbr: "Spring Glen, NY",
  },
  {
    zip: "12484",
    ST: "NY",
    cityWithStateAbbr: "Stone Ridge, NY",
  },
  {
    zip: "12485",
    ST: "NY",
    cityWithStateAbbr: "Tannersville, NY",
  },
  {
    zip: "12486",
    ST: "NY",
    cityWithStateAbbr: "Tillson, NY",
  },
  {
    zip: "12487",
    ST: "NY",
    cityWithStateAbbr: "Ulster Park, NY",
  },
  {
    zip: "12489",
    ST: "NY",
    cityWithStateAbbr: "Wawarsing, NY",
  },
  {
    zip: "12490",
    ST: "NY",
    cityWithStateAbbr: "West Camp, NY",
  },
  {
    zip: "12491",
    ST: "NY",
    cityWithStateAbbr: "West Hurley, NY",
  },
  {
    zip: "12492",
    ST: "NY",
    cityWithStateAbbr: "West Kill, NY",
  },
  {
    zip: "12493",
    ST: "NY",
    cityWithStateAbbr: "West Park, NY",
  },
  {
    zip: "12494",
    ST: "NY",
    cityWithStateAbbr: "West Shokan, NY",
  },
  {
    zip: "12495",
    ST: "NY",
    cityWithStateAbbr: "Willow, NY",
  },
  {
    zip: "12496",
    ST: "NY",
    cityWithStateAbbr: "Windham, NY",
  },
  {
    zip: "12498",
    ST: "NY",
    cityWithStateAbbr: "Woodstock, NY",
  },
  {
    zip: "12501",
    ST: "NY",
    cityWithStateAbbr: "Amenia, NY",
  },
  {
    zip: "12502",
    ST: "NY",
    cityWithStateAbbr: "Ancram, NY",
  },
  {
    zip: "12503",
    ST: "NY",
    cityWithStateAbbr: "Ancramdale, NY",
  },
  {
    zip: "12504",
    ST: "NY",
    cityWithStateAbbr: "Annandale On Hudson, NY",
  },
  {
    zip: "12506",
    ST: "NY",
    cityWithStateAbbr: "Bangall, NY",
  },
  {
    zip: "12507",
    ST: "NY",
    cityWithStateAbbr: "Barrytown, NY",
  },
  {
    zip: "12508",
    ST: "NY",
    cityWithStateAbbr: "Beacon, NY",
  },
  {
    zip: "12510",
    ST: "NY",
    cityWithStateAbbr: "Billings, NY",
  },
  {
    zip: "12511",
    ST: "NY",
    cityWithStateAbbr: "Castle Point, NY",
  },
  {
    zip: "12512",
    ST: "NY",
    cityWithStateAbbr: "Chelsea, NY",
  },
  {
    zip: "12513",
    ST: "NY",
    cityWithStateAbbr: "Claverack, NY",
  },
  {
    zip: "12514",
    ST: "NY",
    cityWithStateAbbr: "Clinton Corners, NY",
  },
  {
    zip: "12515",
    ST: "NY",
    cityWithStateAbbr: "Clintondale, NY",
  },
  {
    zip: "12516",
    ST: "NY",
    cityWithStateAbbr: "Copake, NY",
  },
  {
    zip: "12517",
    ST: "NY",
    cityWithStateAbbr: "Copake Falls, NY",
  },
  {
    zip: "12518",
    ST: "NY",
    cityWithStateAbbr: "Cornwall, NY",
  },
  {
    zip: "12520",
    ST: "NY",
    cityWithStateAbbr: "Cornwall On Hudson, NY",
  },
  {
    zip: "12521",
    ST: "NY",
    cityWithStateAbbr: "Craryville, NY",
  },
  {
    zip: "12522",
    ST: "NY",
    cityWithStateAbbr: "Dover Plains, NY",
  },
  {
    zip: "12523",
    ST: "NY",
    cityWithStateAbbr: "Elizaville, NY",
  },
  {
    zip: "12524",
    ST: "NY",
    cityWithStateAbbr: "Fishkill, NY",
  },
  {
    zip: "12525",
    ST: "NY",
    cityWithStateAbbr: "Gardiner, NY",
  },
  {
    zip: "12526",
    ST: "NY",
    cityWithStateAbbr: "Germantown, NY",
  },
  {
    zip: "12527",
    ST: "NY",
    cityWithStateAbbr: "Glenham, NY",
  },
  {
    zip: "12528",
    ST: "NY",
    cityWithStateAbbr: "Highland, NY",
  },
  {
    zip: "12529",
    ST: "NY",
    cityWithStateAbbr: "Hillsdale, NY",
  },
  {
    zip: "12530",
    ST: "NY",
    cityWithStateAbbr: "Hollowville, NY",
  },
  {
    zip: "12531",
    ST: "NY",
    cityWithStateAbbr: "Holmes, NY",
  },
  {
    zip: "12533",
    ST: "NY",
    cityWithStateAbbr: "Hopewell Junction, NY",
  },
  {
    zip: "12534",
    ST: "NY",
    cityWithStateAbbr: "Hudson, NY",
  },
  {
    zip: "12537",
    ST: "NY",
    cityWithStateAbbr: "Hughsonville, NY",
  },
  {
    zip: "12538",
    ST: "NY",
    cityWithStateAbbr: "Hyde Park, NY",
  },
  {
    zip: "12540",
    ST: "NY",
    cityWithStateAbbr: "Lagrangeville, NY",
  },
  {
    zip: "12541",
    ST: "NY",
    cityWithStateAbbr: "Livingston, NY",
  },
  {
    zip: "12542",
    ST: "NY",
    cityWithStateAbbr: "Marlboro, NY",
  },
  {
    zip: "12543",
    ST: "NY",
    cityWithStateAbbr: "Maybrook, NY",
  },
  {
    zip: "12544",
    ST: "NY",
    cityWithStateAbbr: "Mellenville, NY",
  },
  {
    zip: "12545",
    ST: "NY",
    cityWithStateAbbr: "Millbrook, NY",
  },
  {
    zip: "12546",
    ST: "NY",
    cityWithStateAbbr: "Millerton, NY",
  },
  {
    zip: "12547",
    ST: "NY",
    cityWithStateAbbr: "Milton, NY",
  },
  {
    zip: "12548",
    ST: "NY",
    cityWithStateAbbr: "Modena, NY",
  },
  {
    zip: "12549",
    ST: "NY",
    cityWithStateAbbr: "Montgomery, NY",
  },
  {
    zip: "12550",
    ST: "NY",
    cityWithStateAbbr: "Newburgh, NY",
  },
  {
    zip: "12551",
    ST: "NY",
    cityWithStateAbbr: "Newburgh, NY",
  },
  {
    zip: "12552",
    ST: "NY",
    cityWithStateAbbr: "Newburgh, NY",
  },
  {
    zip: "12553",
    ST: "NY",
    cityWithStateAbbr: "New Windsor, NY",
  },
  {
    zip: "12555",
    ST: "NY",
    cityWithStateAbbr: "Newburgh, NY",
  },
  {
    zip: "12561",
    ST: "NY",
    cityWithStateAbbr: "New Paltz, NY",
  },
  {
    zip: "12563",
    ST: "NY",
    cityWithStateAbbr: "Patterson, NY",
  },
  {
    zip: "12564",
    ST: "NY",
    cityWithStateAbbr: "Pawling, NY",
  },
  {
    zip: "12565",
    ST: "NY",
    cityWithStateAbbr: "Philmont, NY",
  },
  {
    zip: "12566",
    ST: "NY",
    cityWithStateAbbr: "Pine Bush, NY",
  },
  {
    zip: "12567",
    ST: "NY",
    cityWithStateAbbr: "Pine Plains, NY",
  },
  {
    zip: "12568",
    ST: "NY",
    cityWithStateAbbr: "Plattekill, NY",
  },
  {
    zip: "12569",
    ST: "NY",
    cityWithStateAbbr: "Pleasant Valley, NY",
  },
  {
    zip: "12570",
    ST: "NY",
    cityWithStateAbbr: "Poughquag, NY",
  },
  {
    zip: "12571",
    ST: "NY",
    cityWithStateAbbr: "Red Hook, NY",
  },
  {
    zip: "12572",
    ST: "NY",
    cityWithStateAbbr: "Rhinebeck, NY",
  },
  {
    zip: "12574",
    ST: "NY",
    cityWithStateAbbr: "Rhinecliff, NY",
  },
  {
    zip: "12575",
    ST: "NY",
    cityWithStateAbbr: "Rock Tavern, NY",
  },
  {
    zip: "12577",
    ST: "NY",
    cityWithStateAbbr: "Salisbury Mills, NY",
  },
  {
    zip: "12578",
    ST: "NY",
    cityWithStateAbbr: "Salt Point, NY",
  },
  {
    zip: "12580",
    ST: "NY",
    cityWithStateAbbr: "Staatsburg, NY",
  },
  {
    zip: "12581",
    ST: "NY",
    cityWithStateAbbr: "Stanfordville, NY",
  },
  {
    zip: "12582",
    ST: "NY",
    cityWithStateAbbr: "Stormville, NY",
  },
  {
    zip: "12583",
    ST: "NY",
    cityWithStateAbbr: "Tivoli, NY",
  },
  {
    zip: "12584",
    ST: "NY",
    cityWithStateAbbr: "Vails Gate, NY",
  },
  {
    zip: "12585",
    ST: "NY",
    cityWithStateAbbr: "Verbank, NY",
  },
  {
    zip: "12586",
    ST: "NY",
    cityWithStateAbbr: "Walden, NY",
  },
  {
    zip: "12588",
    ST: "NY",
    cityWithStateAbbr: "Walker Valley, NY",
  },
  {
    zip: "12589",
    ST: "NY",
    cityWithStateAbbr: "Wallkill, NY",
  },
  {
    zip: "12590",
    ST: "NY",
    cityWithStateAbbr: "Wappingers Falls, NY",
  },
  {
    zip: "12592",
    ST: "NY",
    cityWithStateAbbr: "Wassaic, NY",
  },
  {
    zip: "12594",
    ST: "NY",
    cityWithStateAbbr: "Wingdale, NY",
  },
  {
    zip: "12601",
    ST: "NY",
    cityWithStateAbbr: "Poughkeepsie, NY",
  },
  {
    zip: "12602",
    ST: "NY",
    cityWithStateAbbr: "Poughkeepsie, NY",
  },
  {
    zip: "12603",
    ST: "NY",
    cityWithStateAbbr: "Poughkeepsie, NY",
  },
  {
    zip: "12604",
    ST: "NY",
    cityWithStateAbbr: "Poughkeepsie, NY",
  },
  {
    zip: "12701",
    ST: "NY",
    cityWithStateAbbr: "Monticello, NY",
  },
  {
    zip: "12719",
    ST: "NY",
    cityWithStateAbbr: "Barryville, NY",
  },
  {
    zip: "12720",
    ST: "NY",
    cityWithStateAbbr: "Bethel, NY",
  },
  {
    zip: "12721",
    ST: "NY",
    cityWithStateAbbr: "Bloomingburg, NY",
  },
  {
    zip: "12722",
    ST: "NY",
    cityWithStateAbbr: "Burlingham, NY",
  },
  {
    zip: "12723",
    ST: "NY",
    cityWithStateAbbr: "Callicoon, NY",
  },
  {
    zip: "12724",
    ST: "NY",
    cityWithStateAbbr: "Callicoon Center, NY",
  },
  {
    zip: "12725",
    ST: "NY",
    cityWithStateAbbr: "Claryville, NY",
  },
  {
    zip: "12726",
    ST: "NY",
    cityWithStateAbbr: "Cochecton, NY",
  },
  {
    zip: "12727",
    ST: "NY",
    cityWithStateAbbr: "Cochecton Center, NY",
  },
  {
    zip: "12729",
    ST: "NY",
    cityWithStateAbbr: "Cuddebackville, NY",
  },
  {
    zip: "12732",
    ST: "NY",
    cityWithStateAbbr: "Eldred, NY",
  },
  {
    zip: "12733",
    ST: "NY",
    cityWithStateAbbr: "Fallsburg, NY",
  },
  {
    zip: "12734",
    ST: "NY",
    cityWithStateAbbr: "Ferndale, NY",
  },
  {
    zip: "12736",
    ST: "NY",
    cityWithStateAbbr: "Fremont Center, NY",
  },
  {
    zip: "12737",
    ST: "NY",
    cityWithStateAbbr: "Glen Spey, NY",
  },
  {
    zip: "12738",
    ST: "NY",
    cityWithStateAbbr: "Glen Wild, NY",
  },
  {
    zip: "12740",
    ST: "NY",
    cityWithStateAbbr: "Grahamsville, NY",
  },
  {
    zip: "12741",
    ST: "NY",
    cityWithStateAbbr: "Hankins, NY",
  },
  {
    zip: "12742",
    ST: "NY",
    cityWithStateAbbr: "Harris, NY",
  },
  {
    zip: "12743",
    ST: "NY",
    cityWithStateAbbr: "Highland Lake, NY",
  },
  {
    zip: "12745",
    ST: "NY",
    cityWithStateAbbr: "Hortonville, NY",
  },
  {
    zip: "12746",
    ST: "NY",
    cityWithStateAbbr: "Huguenot, NY",
  },
  {
    zip: "12747",
    ST: "NY",
    cityWithStateAbbr: "Hurleyville, NY",
  },
  {
    zip: "12748",
    ST: "NY",
    cityWithStateAbbr: "Jeffersonville, NY",
  },
  {
    zip: "12749",
    ST: "NY",
    cityWithStateAbbr: "Kauneonga Lake, NY",
  },
  {
    zip: "12750",
    ST: "NY",
    cityWithStateAbbr: "Kenoza Lake, NY",
  },
  {
    zip: "12751",
    ST: "NY",
    cityWithStateAbbr: "Kiamesha Lake, NY",
  },
  {
    zip: "12752",
    ST: "NY",
    cityWithStateAbbr: "Lake Huntington, NY",
  },
  {
    zip: "12754",
    ST: "NY",
    cityWithStateAbbr: "Liberty, NY",
  },
  {
    zip: "12758",
    ST: "NY",
    cityWithStateAbbr: "Livingston Manor, NY",
  },
  {
    zip: "12759",
    ST: "NY",
    cityWithStateAbbr: "Loch Sheldrake, NY",
  },
  {
    zip: "12760",
    ST: "NY",
    cityWithStateAbbr: "Long Eddy, NY",
  },
  {
    zip: "12762",
    ST: "NY",
    cityWithStateAbbr: "Mongaup Valley, NY",
  },
  {
    zip: "12763",
    ST: "NY",
    cityWithStateAbbr: "Mountain Dale, NY",
  },
  {
    zip: "12764",
    ST: "NY",
    cityWithStateAbbr: "Narrowsburg, NY",
  },
  {
    zip: "12765",
    ST: "NY",
    cityWithStateAbbr: "Neversink, NY",
  },
  {
    zip: "12766",
    ST: "NY",
    cityWithStateAbbr: "North Branch, NY",
  },
  {
    zip: "12767",
    ST: "NY",
    cityWithStateAbbr: "Obernburg, NY",
  },
  {
    zip: "12768",
    ST: "NY",
    cityWithStateAbbr: "Parksville, NY",
  },
  {
    zip: "12769",
    ST: "NY",
    cityWithStateAbbr: "Phillipsport, NY",
  },
  {
    zip: "12770",
    ST: "NY",
    cityWithStateAbbr: "Pond Eddy, NY",
  },
  {
    zip: "12771",
    ST: "NY",
    cityWithStateAbbr: "Port Jervis, NY",
  },
  {
    zip: "12775",
    ST: "NY",
    cityWithStateAbbr: "Rock Hill, NY",
  },
  {
    zip: "12776",
    ST: "NY",
    cityWithStateAbbr: "Roscoe, NY",
  },
  {
    zip: "12777",
    ST: "NY",
    cityWithStateAbbr: "Forestburgh, NY",
  },
  {
    zip: "12778",
    ST: "NY",
    cityWithStateAbbr: "Smallwood, NY",
  },
  {
    zip: "12779",
    ST: "NY",
    cityWithStateAbbr: "South Fallsburg, NY",
  },
  {
    zip: "12780",
    ST: "NY",
    cityWithStateAbbr: "Sparrow Bush, NY",
  },
  {
    zip: "12781",
    ST: "NY",
    cityWithStateAbbr: "Summitville, NY",
  },
  {
    zip: "12783",
    ST: "NY",
    cityWithStateAbbr: "Swan Lake, NY",
  },
  {
    zip: "12784",
    ST: "NY",
    cityWithStateAbbr: "Thompsonville, NY",
  },
  {
    zip: "12785",
    ST: "NY",
    cityWithStateAbbr: "Westbrookville, NY",
  },
  {
    zip: "12786",
    ST: "NY",
    cityWithStateAbbr: "White Lake, NY",
  },
  {
    zip: "12787",
    ST: "NY",
    cityWithStateAbbr: "White Sulphur Springs, NY",
  },
  {
    zip: "12788",
    ST: "NY",
    cityWithStateAbbr: "Woodbourne, NY",
  },
  {
    zip: "12789",
    ST: "NY",
    cityWithStateAbbr: "Woodridge, NY",
  },
  {
    zip: "12790",
    ST: "NY",
    cityWithStateAbbr: "Wurtsboro, NY",
  },
  {
    zip: "12791",
    ST: "NY",
    cityWithStateAbbr: "Youngsville, NY",
  },
  {
    zip: "12792",
    ST: "NY",
    cityWithStateAbbr: "Yulan, NY",
  },
  {
    zip: "12801",
    ST: "NY",
    cityWithStateAbbr: "Glens Falls, NY",
  },
  {
    zip: "12803",
    ST: "NY",
    cityWithStateAbbr: "South Glens Falls, NY",
  },
  {
    zip: "12804",
    ST: "NY",
    cityWithStateAbbr: "Queensbury, NY",
  },
  {
    zip: "12808",
    ST: "NY",
    cityWithStateAbbr: "Adirondack, NY",
  },
  {
    zip: "12809",
    ST: "NY",
    cityWithStateAbbr: "Argyle, NY",
  },
  {
    zip: "12810",
    ST: "NY",
    cityWithStateAbbr: "Athol, NY",
  },
  {
    zip: "12811",
    ST: "NY",
    cityWithStateAbbr: "Bakers Mills, NY",
  },
  {
    zip: "12812",
    ST: "NY",
    cityWithStateAbbr: "Blue Mountain Lake, NY",
  },
  {
    zip: "12814",
    ST: "NY",
    cityWithStateAbbr: "Bolton Landing, NY",
  },
  {
    zip: "12815",
    ST: "NY",
    cityWithStateAbbr: "Brant Lake, NY",
  },
  {
    zip: "12816",
    ST: "NY",
    cityWithStateAbbr: "Cambridge, NY",
  },
  {
    zip: "12817",
    ST: "NY",
    cityWithStateAbbr: "Chestertown, NY",
  },
  {
    zip: "12819",
    ST: "NY",
    cityWithStateAbbr: "Clemons, NY",
  },
  {
    zip: "12820",
    ST: "NY",
    cityWithStateAbbr: "Cleverdale, NY",
  },
  {
    zip: "12821",
    ST: "NY",
    cityWithStateAbbr: "Comstock, NY",
  },
  {
    zip: "12822",
    ST: "NY",
    cityWithStateAbbr: "Corinth, NY",
  },
  {
    zip: "12823",
    ST: "NY",
    cityWithStateAbbr: "Cossayuna, NY",
  },
  {
    zip: "12824",
    ST: "NY",
    cityWithStateAbbr: "Diamond Point, NY",
  },
  {
    zip: "12827",
    ST: "NY",
    cityWithStateAbbr: "Fort Ann, NY",
  },
  {
    zip: "12828",
    ST: "NY",
    cityWithStateAbbr: "Fort Edward, NY",
  },
  {
    zip: "12831",
    ST: "NY",
    cityWithStateAbbr: "Gansevoort, NY",
  },
  {
    zip: "12832",
    ST: "NY",
    cityWithStateAbbr: "Granville, NY",
  },
  {
    zip: "12833",
    ST: "NY",
    cityWithStateAbbr: "Greenfield Center, NY",
  },
  {
    zip: "12834",
    ST: "NY",
    cityWithStateAbbr: "Greenwich, NY",
  },
  {
    zip: "12835",
    ST: "NY",
    cityWithStateAbbr: "Hadley, NY",
  },
  {
    zip: "12836",
    ST: "NY",
    cityWithStateAbbr: "Hague, NY",
  },
  {
    zip: "12837",
    ST: "NY",
    cityWithStateAbbr: "Hampton, NY",
  },
  {
    zip: "12838",
    ST: "NY",
    cityWithStateAbbr: "Hartford, NY",
  },
  {
    zip: "12839",
    ST: "NY",
    cityWithStateAbbr: "Hudson Falls, NY",
  },
  {
    zip: "12841",
    ST: "NY",
    cityWithStateAbbr: "Huletts Landing, NY",
  },
  {
    zip: "12842",
    ST: "NY",
    cityWithStateAbbr: "Indian Lake, NY",
  },
  {
    zip: "12843",
    ST: "NY",
    cityWithStateAbbr: "Johnsburg, NY",
  },
  {
    zip: "12844",
    ST: "NY",
    cityWithStateAbbr: "Kattskill Bay, NY",
  },
  {
    zip: "12845",
    ST: "NY",
    cityWithStateAbbr: "Lake George, NY",
  },
  {
    zip: "12846",
    ST: "NY",
    cityWithStateAbbr: "Lake Luzerne, NY",
  },
  {
    zip: "12847",
    ST: "NY",
    cityWithStateAbbr: "Long Lake, NY",
  },
  {
    zip: "12848",
    ST: "NY",
    cityWithStateAbbr: "Middle Falls, NY",
  },
  {
    zip: "12849",
    ST: "NY",
    cityWithStateAbbr: "Middle Granville, NY",
  },
  {
    zip: "12850",
    ST: "NY",
    cityWithStateAbbr: "Middle Grove, NY",
  },
  {
    zip: "12851",
    ST: "NY",
    cityWithStateAbbr: "Minerva, NY",
  },
  {
    zip: "12852",
    ST: "NY",
    cityWithStateAbbr: "Newcomb, NY",
  },
  {
    zip: "12853",
    ST: "NY",
    cityWithStateAbbr: "North Creek, NY",
  },
  {
    zip: "12854",
    ST: "NY",
    cityWithStateAbbr: "North Granville, NY",
  },
  {
    zip: "12855",
    ST: "NY",
    cityWithStateAbbr: "North Hudson, NY",
  },
  {
    zip: "12856",
    ST: "NY",
    cityWithStateAbbr: "North River, NY",
  },
  {
    zip: "12857",
    ST: "NY",
    cityWithStateAbbr: "Olmstedville, NY",
  },
  {
    zip: "12858",
    ST: "NY",
    cityWithStateAbbr: "Paradox, NY",
  },
  {
    zip: "12859",
    ST: "NY",
    cityWithStateAbbr: "Porter Corners, NY",
  },
  {
    zip: "12860",
    ST: "NY",
    cityWithStateAbbr: "Pottersville, NY",
  },
  {
    zip: "12861",
    ST: "NY",
    cityWithStateAbbr: "Putnam Station, NY",
  },
  {
    zip: "12862",
    ST: "NY",
    cityWithStateAbbr: "Riparius, NY",
  },
  {
    zip: "12863",
    ST: "NY",
    cityWithStateAbbr: "Rock City Falls, NY",
  },
  {
    zip: "12864",
    ST: "NY",
    cityWithStateAbbr: "Sabael, NY",
  },
  {
    zip: "12865",
    ST: "NY",
    cityWithStateAbbr: "Salem, NY",
  },
  {
    zip: "12866",
    ST: "NY",
    cityWithStateAbbr: "Saratoga Springs, NY",
  },
  {
    zip: "12870",
    ST: "NY",
    cityWithStateAbbr: "Schroon Lake, NY",
  },
  {
    zip: "12871",
    ST: "NY",
    cityWithStateAbbr: "Schuylerville, NY",
  },
  {
    zip: "12872",
    ST: "NY",
    cityWithStateAbbr: "Severance, NY",
  },
  {
    zip: "12873",
    ST: "NY",
    cityWithStateAbbr: "Shushan, NY",
  },
  {
    zip: "12874",
    ST: "NY",
    cityWithStateAbbr: "Silver Bay, NY",
  },
  {
    zip: "12878",
    ST: "NY",
    cityWithStateAbbr: "Stony Creek, NY",
  },
  {
    zip: "12879",
    ST: "NY",
    cityWithStateAbbr: "Newcomb, NY",
  },
  {
    zip: "12883",
    ST: "NY",
    cityWithStateAbbr: "Ticonderoga, NY",
  },
  {
    zip: "12884",
    ST: "NY",
    cityWithStateAbbr: "Victory Mills, NY",
  },
  {
    zip: "12885",
    ST: "NY",
    cityWithStateAbbr: "Warrensburg, NY",
  },
  {
    zip: "12886",
    ST: "NY",
    cityWithStateAbbr: "Wevertown, NY",
  },
  {
    zip: "12887",
    ST: "NY",
    cityWithStateAbbr: "Whitehall, NY",
  },
  {
    zip: "12901",
    ST: "NY",
    cityWithStateAbbr: "Plattsburgh, NY",
  },
  {
    zip: "12903",
    ST: "NY",
    cityWithStateAbbr: "Plattsburgh, NY",
  },
  {
    zip: "12910",
    ST: "NY",
    cityWithStateAbbr: "Altona, NY",
  },
  {
    zip: "12911",
    ST: "NY",
    cityWithStateAbbr: "Keeseville, NY",
  },
  {
    zip: "12912",
    ST: "NY",
    cityWithStateAbbr: "Au Sable Forks, NY",
  },
  {
    zip: "12913",
    ST: "NY",
    cityWithStateAbbr: "Bloomingdale, NY",
  },
  {
    zip: "12914",
    ST: "NY",
    cityWithStateAbbr: "Bombay, NY",
  },
  {
    zip: "12915",
    ST: "NY",
    cityWithStateAbbr: "Brainardsville, NY",
  },
  {
    zip: "12916",
    ST: "NY",
    cityWithStateAbbr: "Brushton, NY",
  },
  {
    zip: "12917",
    ST: "NY",
    cityWithStateAbbr: "Burke, NY",
  },
  {
    zip: "12918",
    ST: "NY",
    cityWithStateAbbr: "Cadyville, NY",
  },
  {
    zip: "12919",
    ST: "NY",
    cityWithStateAbbr: "Champlain, NY",
  },
  {
    zip: "12920",
    ST: "NY",
    cityWithStateAbbr: "Chateaugay, NY",
  },
  {
    zip: "12921",
    ST: "NY",
    cityWithStateAbbr: "Chazy, NY",
  },
  {
    zip: "12922",
    ST: "NY",
    cityWithStateAbbr: "Childwold, NY",
  },
  {
    zip: "12923",
    ST: "NY",
    cityWithStateAbbr: "Churubusco, NY",
  },
  {
    zip: "12924",
    ST: "NY",
    cityWithStateAbbr: "Keeseville, NY",
  },
  {
    zip: "12926",
    ST: "NY",
    cityWithStateAbbr: "Constable, NY",
  },
  {
    zip: "12927",
    ST: "NY",
    cityWithStateAbbr: "Cranberry Lake, NY",
  },
  {
    zip: "12928",
    ST: "NY",
    cityWithStateAbbr: "Crown Point, NY",
  },
  {
    zip: "12929",
    ST: "NY",
    cityWithStateAbbr: "Dannemora, NY",
  },
  {
    zip: "12930",
    ST: "NY",
    cityWithStateAbbr: "Dickinson Center, NY",
  },
  {
    zip: "12932",
    ST: "NY",
    cityWithStateAbbr: "Elizabethtown, NY",
  },
  {
    zip: "12933",
    ST: "NY",
    cityWithStateAbbr: "Ellenburg, NY",
  },
  {
    zip: "12934",
    ST: "NY",
    cityWithStateAbbr: "Ellenburg Center, NY",
  },
  {
    zip: "12935",
    ST: "NY",
    cityWithStateAbbr: "Ellenburg Depot, NY",
  },
  {
    zip: "12936",
    ST: "NY",
    cityWithStateAbbr: "Essex, NY",
  },
  {
    zip: "12937",
    ST: "NY",
    cityWithStateAbbr: "Fort Covington, NY",
  },
  {
    zip: "12939",
    ST: "NY",
    cityWithStateAbbr: "Gabriels, NY",
  },
  {
    zip: "12941",
    ST: "NY",
    cityWithStateAbbr: "Jay, NY",
  },
  {
    zip: "12942",
    ST: "NY",
    cityWithStateAbbr: "Keene, NY",
  },
  {
    zip: "12943",
    ST: "NY",
    cityWithStateAbbr: "Keene Valley, NY",
  },
  {
    zip: "12944",
    ST: "NY",
    cityWithStateAbbr: "Keeseville, NY",
  },
  {
    zip: "12945",
    ST: "NY",
    cityWithStateAbbr: "Lake Clear, NY",
  },
  {
    zip: "12946",
    ST: "NY",
    cityWithStateAbbr: "Lake Placid, NY",
  },
  {
    zip: "12949",
    ST: "NY",
    cityWithStateAbbr: "Lawrenceville, NY",
  },
  {
    zip: "12950",
    ST: "NY",
    cityWithStateAbbr: "Lewis, NY",
  },
  {
    zip: "12952",
    ST: "NY",
    cityWithStateAbbr: "Lyon Mountain, NY",
  },
  {
    zip: "12953",
    ST: "NY",
    cityWithStateAbbr: "Malone, NY",
  },
  {
    zip: "12955",
    ST: "NY",
    cityWithStateAbbr: "Lyon Mountain, NY",
  },
  {
    zip: "12956",
    ST: "NY",
    cityWithStateAbbr: "Mineville, NY",
  },
  {
    zip: "12957",
    ST: "NY",
    cityWithStateAbbr: "Moira, NY",
  },
  {
    zip: "12958",
    ST: "NY",
    cityWithStateAbbr: "Mooers, NY",
  },
  {
    zip: "12959",
    ST: "NY",
    cityWithStateAbbr: "Mooers Forks, NY",
  },
  {
    zip: "12960",
    ST: "NY",
    cityWithStateAbbr: "Moriah, NY",
  },
  {
    zip: "12961",
    ST: "NY",
    cityWithStateAbbr: "Moriah Center, NY",
  },
  {
    zip: "12962",
    ST: "NY",
    cityWithStateAbbr: "Morrisonville, NY",
  },
  {
    zip: "12964",
    ST: "NY",
    cityWithStateAbbr: "New Russia, NY",
  },
  {
    zip: "12965",
    ST: "NY",
    cityWithStateAbbr: "Nicholville, NY",
  },
  {
    zip: "12966",
    ST: "NY",
    cityWithStateAbbr: "North Bangor, NY",
  },
  {
    zip: "12967",
    ST: "NY",
    cityWithStateAbbr: "North Lawrence, NY",
  },
  {
    zip: "12969",
    ST: "NY",
    cityWithStateAbbr: "Owls Head, NY",
  },
  {
    zip: "12970",
    ST: "NY",
    cityWithStateAbbr: "Paul Smiths, NY",
  },
  {
    zip: "12972",
    ST: "NY",
    cityWithStateAbbr: "Peru, NY",
  },
  {
    zip: "12973",
    ST: "NY",
    cityWithStateAbbr: "Piercefield, NY",
  },
  {
    zip: "12974",
    ST: "NY",
    cityWithStateAbbr: "Port Henry, NY",
  },
  {
    zip: "12975",
    ST: "NY",
    cityWithStateAbbr: "Port Kent, NY",
  },
  {
    zip: "12976",
    ST: "NY",
    cityWithStateAbbr: "Rainbow Lake, NY",
  },
  {
    zip: "12977",
    ST: "NY",
    cityWithStateAbbr: "Ray Brook, NY",
  },
  {
    zip: "12978",
    ST: "NY",
    cityWithStateAbbr: "Redford, NY",
  },
  {
    zip: "12979",
    ST: "NY",
    cityWithStateAbbr: "Rouses Point, NY",
  },
  {
    zip: "12980",
    ST: "NY",
    cityWithStateAbbr: "Saint Regis Falls, NY",
  },
  {
    zip: "12981",
    ST: "NY",
    cityWithStateAbbr: "Saranac, NY",
  },
  {
    zip: "12983",
    ST: "NY",
    cityWithStateAbbr: "Saranac Lake, NY",
  },
  {
    zip: "12985",
    ST: "NY",
    cityWithStateAbbr: "Schuyler Falls, NY",
  },
  {
    zip: "12986",
    ST: "NY",
    cityWithStateAbbr: "Tupper Lake, NY",
  },
  {
    zip: "12987",
    ST: "NY",
    cityWithStateAbbr: "Upper Jay, NY",
  },
  {
    zip: "12989",
    ST: "NY",
    cityWithStateAbbr: "Vermontville, NY",
  },
  {
    zip: "12992",
    ST: "NY",
    cityWithStateAbbr: "West Chazy, NY",
  },
  {
    zip: "12993",
    ST: "NY",
    cityWithStateAbbr: "Westport, NY",
  },
  {
    zip: "12995",
    ST: "NY",
    cityWithStateAbbr: "Whippleville, NY",
  },
  {
    zip: "12996",
    ST: "NY",
    cityWithStateAbbr: "Willsboro, NY",
  },
  {
    zip: "12997",
    ST: "NY",
    cityWithStateAbbr: "Wilmington, NY",
  },
  {
    zip: "12998",
    ST: "NY",
    cityWithStateAbbr: "Witherbee, NY",
  },
  {
    zip: "13020",
    ST: "NY",
    cityWithStateAbbr: "Apulia Station, NY",
  },
  {
    zip: "13021",
    ST: "NY",
    cityWithStateAbbr: "Auburn, NY",
  },
  {
    zip: "13022",
    ST: "NY",
    cityWithStateAbbr: "Auburn, NY",
  },
  {
    zip: "13024",
    ST: "NY",
    cityWithStateAbbr: "Auburn, NY",
  },
  {
    zip: "13026",
    ST: "NY",
    cityWithStateAbbr: "Aurora, NY",
  },
  {
    zip: "13027",
    ST: "NY",
    cityWithStateAbbr: "Baldwinsville, NY",
  },
  {
    zip: "13028",
    ST: "NY",
    cityWithStateAbbr: "Bernhards Bay, NY",
  },
  {
    zip: "13029",
    ST: "NY",
    cityWithStateAbbr: "Brewerton, NY",
  },
  {
    zip: "13030",
    ST: "NY",
    cityWithStateAbbr: "Bridgeport, NY",
  },
  {
    zip: "13031",
    ST: "NY",
    cityWithStateAbbr: "Camillus, NY",
  },
  {
    zip: "13032",
    ST: "NY",
    cityWithStateAbbr: "Canastota, NY",
  },
  {
    zip: "13033",
    ST: "NY",
    cityWithStateAbbr: "Cato, NY",
  },
  {
    zip: "13034",
    ST: "NY",
    cityWithStateAbbr: "Cayuga, NY",
  },
  {
    zip: "13035",
    ST: "NY",
    cityWithStateAbbr: "Cazenovia, NY",
  },
  {
    zip: "13036",
    ST: "NY",
    cityWithStateAbbr: "Central Square, NY",
  },
  {
    zip: "13037",
    ST: "NY",
    cityWithStateAbbr: "Chittenango, NY",
  },
  {
    zip: "13039",
    ST: "NY",
    cityWithStateAbbr: "Cicero, NY",
  },
  {
    zip: "13040",
    ST: "NY",
    cityWithStateAbbr: "Cincinnatus, NY",
  },
  {
    zip: "13041",
    ST: "NY",
    cityWithStateAbbr: "Clay, NY",
  },
  {
    zip: "13042",
    ST: "NY",
    cityWithStateAbbr: "Cleveland, NY",
  },
  {
    zip: "13043",
    ST: "NY",
    cityWithStateAbbr: "Clockville, NY",
  },
  {
    zip: "13044",
    ST: "NY",
    cityWithStateAbbr: "Constantia, NY",
  },
  {
    zip: "13045",
    ST: "NY",
    cityWithStateAbbr: "Cortland, NY",
  },
  {
    zip: "13051",
    ST: "NY",
    cityWithStateAbbr: "Delphi Falls, NY",
  },
  {
    zip: "13052",
    ST: "NY",
    cityWithStateAbbr: "De Ruyter, NY",
  },
  {
    zip: "13053",
    ST: "NY",
    cityWithStateAbbr: "Dryden, NY",
  },
  {
    zip: "13054",
    ST: "NY",
    cityWithStateAbbr: "Durhamville, NY",
  },
  {
    zip: "13056",
    ST: "NY",
    cityWithStateAbbr: "East Homer, NY",
  },
  {
    zip: "13057",
    ST: "NY",
    cityWithStateAbbr: "East Syracuse, NY",
  },
  {
    zip: "13060",
    ST: "NY",
    cityWithStateAbbr: "Elbridge, NY",
  },
  {
    zip: "13061",
    ST: "NY",
    cityWithStateAbbr: "Erieville, NY",
  },
  {
    zip: "13062",
    ST: "NY",
    cityWithStateAbbr: "Etna, NY",
  },
  {
    zip: "13063",
    ST: "NY",
    cityWithStateAbbr: "Fabius, NY",
  },
  {
    zip: "13064",
    ST: "NY",
    cityWithStateAbbr: "Fair Haven, NY",
  },
  {
    zip: "13065",
    ST: "NY",
    cityWithStateAbbr: "Fayette, NY",
  },
  {
    zip: "13066",
    ST: "NY",
    cityWithStateAbbr: "Fayetteville, NY",
  },
  {
    zip: "13068",
    ST: "NY",
    cityWithStateAbbr: "Freeville, NY",
  },
  {
    zip: "13069",
    ST: "NY",
    cityWithStateAbbr: "Fulton, NY",
  },
  {
    zip: "13071",
    ST: "NY",
    cityWithStateAbbr: "Genoa, NY",
  },
  {
    zip: "13072",
    ST: "NY",
    cityWithStateAbbr: "Georgetown, NY",
  },
  {
    zip: "13073",
    ST: "NY",
    cityWithStateAbbr: "Groton, NY",
  },
  {
    zip: "13074",
    ST: "NY",
    cityWithStateAbbr: "Hannibal, NY",
  },
  {
    zip: "13076",
    ST: "NY",
    cityWithStateAbbr: "Hastings, NY",
  },
  {
    zip: "13077",
    ST: "NY",
    cityWithStateAbbr: "Homer, NY",
  },
  {
    zip: "13078",
    ST: "NY",
    cityWithStateAbbr: "Jamesville, NY",
  },
  {
    zip: "13080",
    ST: "NY",
    cityWithStateAbbr: "Jordan, NY",
  },
  {
    zip: "13081",
    ST: "NY",
    cityWithStateAbbr: "King Ferry, NY",
  },
  {
    zip: "13082",
    ST: "NY",
    cityWithStateAbbr: "Kirkville, NY",
  },
  {
    zip: "13083",
    ST: "NY",
    cityWithStateAbbr: "Lacona, NY",
  },
  {
    zip: "13084",
    ST: "NY",
    cityWithStateAbbr: "La Fayette, NY",
  },
  {
    zip: "13087",
    ST: "NY",
    cityWithStateAbbr: "Little York, NY",
  },
  {
    zip: "13088",
    ST: "NY",
    cityWithStateAbbr: "Liverpool, NY",
  },
  {
    zip: "13089",
    ST: "NY",
    cityWithStateAbbr: "Liverpool, NY",
  },
  {
    zip: "13090",
    ST: "NY",
    cityWithStateAbbr: "Liverpool, NY",
  },
  {
    zip: "13092",
    ST: "NY",
    cityWithStateAbbr: "Locke, NY",
  },
  {
    zip: "13093",
    ST: "NY",
    cityWithStateAbbr: "Lycoming, NY",
  },
  {
    zip: "13101",
    ST: "NY",
    cityWithStateAbbr: "Mc Graw, NY",
  },
  {
    zip: "13102",
    ST: "NY",
    cityWithStateAbbr: "Mc Lean, NY",
  },
  {
    zip: "13103",
    ST: "NY",
    cityWithStateAbbr: "Mallory, NY",
  },
  {
    zip: "13104",
    ST: "NY",
    cityWithStateAbbr: "Manlius, NY",
  },
  {
    zip: "13107",
    ST: "NY",
    cityWithStateAbbr: "Maple View, NY",
  },
  {
    zip: "13108",
    ST: "NY",
    cityWithStateAbbr: "Marcellus, NY",
  },
  {
    zip: "13110",
    ST: "NY",
    cityWithStateAbbr: "Marietta, NY",
  },
  {
    zip: "13111",
    ST: "NY",
    cityWithStateAbbr: "Martville, NY",
  },
  {
    zip: "13112",
    ST: "NY",
    cityWithStateAbbr: "Memphis, NY",
  },
  {
    zip: "13113",
    ST: "NY",
    cityWithStateAbbr: "Meridian, NY",
  },
  {
    zip: "13114",
    ST: "NY",
    cityWithStateAbbr: "Mexico, NY",
  },
  {
    zip: "13115",
    ST: "NY",
    cityWithStateAbbr: "Minetto, NY",
  },
  {
    zip: "13116",
    ST: "NY",
    cityWithStateAbbr: "Minoa, NY",
  },
  {
    zip: "13117",
    ST: "NY",
    cityWithStateAbbr: "Montezuma, NY",
  },
  {
    zip: "13118",
    ST: "NY",
    cityWithStateAbbr: "Moravia, NY",
  },
  {
    zip: "13119",
    ST: "NY",
    cityWithStateAbbr: "Mottville, NY",
  },
  {
    zip: "13120",
    ST: "NY",
    cityWithStateAbbr: "Nedrow, NY",
  },
  {
    zip: "13121",
    ST: "NY",
    cityWithStateAbbr: "New Haven, NY",
  },
  {
    zip: "13122",
    ST: "NY",
    cityWithStateAbbr: "New Woodstock, NY",
  },
  {
    zip: "13123",
    ST: "NY",
    cityWithStateAbbr: "North Bay, NY",
  },
  {
    zip: "13124",
    ST: "NY",
    cityWithStateAbbr: "North Pitcher, NY",
  },
  {
    zip: "13126",
    ST: "NY",
    cityWithStateAbbr: "Oswego, NY",
  },
  {
    zip: "13131",
    ST: "NY",
    cityWithStateAbbr: "Parish, NY",
  },
  {
    zip: "13132",
    ST: "NY",
    cityWithStateAbbr: "Pennellville, NY",
  },
  {
    zip: "13134",
    ST: "NY",
    cityWithStateAbbr: "Peterboro, NY",
  },
  {
    zip: "13135",
    ST: "NY",
    cityWithStateAbbr: "Phoenix, NY",
  },
  {
    zip: "13136",
    ST: "NY",
    cityWithStateAbbr: "Pitcher, NY",
  },
  {
    zip: "13137",
    ST: "NY",
    cityWithStateAbbr: "Plainville, NY",
  },
  {
    zip: "13138",
    ST: "NY",
    cityWithStateAbbr: "Pompey, NY",
  },
  {
    zip: "13139",
    ST: "NY",
    cityWithStateAbbr: "Poplar Ridge, NY",
  },
  {
    zip: "13140",
    ST: "NY",
    cityWithStateAbbr: "Port Byron, NY",
  },
  {
    zip: "13141",
    ST: "NY",
    cityWithStateAbbr: "Preble, NY",
  },
  {
    zip: "13142",
    ST: "NY",
    cityWithStateAbbr: "Pulaski, NY",
  },
  {
    zip: "13143",
    ST: "NY",
    cityWithStateAbbr: "Red Creek, NY",
  },
  {
    zip: "13144",
    ST: "NY",
    cityWithStateAbbr: "Richland, NY",
  },
  {
    zip: "13145",
    ST: "NY",
    cityWithStateAbbr: "Sandy Creek, NY",
  },
  {
    zip: "13146",
    ST: "NY",
    cityWithStateAbbr: "Savannah, NY",
  },
  {
    zip: "13147",
    ST: "NY",
    cityWithStateAbbr: "Scipio Center, NY",
  },
  {
    zip: "13148",
    ST: "NY",
    cityWithStateAbbr: "Seneca Falls, NY",
  },
  {
    zip: "13152",
    ST: "NY",
    cityWithStateAbbr: "Skaneateles, NY",
  },
  {
    zip: "13153",
    ST: "NY",
    cityWithStateAbbr: "Skaneateles Falls, NY",
  },
  {
    zip: "13154",
    ST: "NY",
    cityWithStateAbbr: "South Butler, NY",
  },
  {
    zip: "13155",
    ST: "NY",
    cityWithStateAbbr: "South Otselic, NY",
  },
  {
    zip: "13156",
    ST: "NY",
    cityWithStateAbbr: "Sterling, NY",
  },
  {
    zip: "13157",
    ST: "NY",
    cityWithStateAbbr: "Sylvan Beach, NY",
  },
  {
    zip: "13158",
    ST: "NY",
    cityWithStateAbbr: "Truxton, NY",
  },
  {
    zip: "13159",
    ST: "NY",
    cityWithStateAbbr: "Tully, NY",
  },
  {
    zip: "13160",
    ST: "NY",
    cityWithStateAbbr: "Union Springs, NY",
  },
  {
    zip: "13162",
    ST: "NY",
    cityWithStateAbbr: "Verona Beach, NY",
  },
  {
    zip: "13163",
    ST: "NY",
    cityWithStateAbbr: "Wampsville, NY",
  },
  {
    zip: "13164",
    ST: "NY",
    cityWithStateAbbr: "Warners, NY",
  },
  {
    zip: "13165",
    ST: "NY",
    cityWithStateAbbr: "Waterloo, NY",
  },
  {
    zip: "13166",
    ST: "NY",
    cityWithStateAbbr: "Weedsport, NY",
  },
  {
    zip: "13167",
    ST: "NY",
    cityWithStateAbbr: "West Monroe, NY",
  },
  {
    zip: "13201",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13202",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13203",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13204",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13205",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13206",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13207",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13208",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13209",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13210",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13211",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13212",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13214",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13215",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13217",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13218",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13219",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13220",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13221",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13224",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13225",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13235",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13244",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13250",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13251",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13252",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13261",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13290",
    ST: "NY",
    cityWithStateAbbr: "Syracuse, NY",
  },
  {
    zip: "13301",
    ST: "NY",
    cityWithStateAbbr: "Alder Creek, NY",
  },
  {
    zip: "13302",
    ST: "NY",
    cityWithStateAbbr: "Altmar, NY",
  },
  {
    zip: "13303",
    ST: "NY",
    cityWithStateAbbr: "Ava, NY",
  },
  {
    zip: "13304",
    ST: "NY",
    cityWithStateAbbr: "Barneveld, NY",
  },
  {
    zip: "13305",
    ST: "NY",
    cityWithStateAbbr: "Beaver Falls, NY",
  },
  {
    zip: "13308",
    ST: "NY",
    cityWithStateAbbr: "Blossvale, NY",
  },
  {
    zip: "13309",
    ST: "NY",
    cityWithStateAbbr: "Boonville, NY",
  },
  {
    zip: "13310",
    ST: "NY",
    cityWithStateAbbr: "Bouckville, NY",
  },
  {
    zip: "13312",
    ST: "NY",
    cityWithStateAbbr: "Brantingham, NY",
  },
  {
    zip: "13313",
    ST: "NY",
    cityWithStateAbbr: "Bridgewater, NY",
  },
  {
    zip: "13314",
    ST: "NY",
    cityWithStateAbbr: "Brookfield, NY",
  },
  {
    zip: "13315",
    ST: "NY",
    cityWithStateAbbr: "Burlington Flats, NY",
  },
  {
    zip: "13316",
    ST: "NY",
    cityWithStateAbbr: "Camden, NY",
  },
  {
    zip: "13317",
    ST: "NY",
    cityWithStateAbbr: "Canajoharie, NY",
  },
  {
    zip: "13318",
    ST: "NY",
    cityWithStateAbbr: "Cassville, NY",
  },
  {
    zip: "13319",
    ST: "NY",
    cityWithStateAbbr: "Chadwicks, NY",
  },
  {
    zip: "13320",
    ST: "NY",
    cityWithStateAbbr: "Cherry Valley, NY",
  },
  {
    zip: "13321",
    ST: "NY",
    cityWithStateAbbr: "Clark Mills, NY",
  },
  {
    zip: "13322",
    ST: "NY",
    cityWithStateAbbr: "Clayville, NY",
  },
  {
    zip: "13323",
    ST: "NY",
    cityWithStateAbbr: "Clinton, NY",
  },
  {
    zip: "13324",
    ST: "NY",
    cityWithStateAbbr: "Cold Brook, NY",
  },
  {
    zip: "13325",
    ST: "NY",
    cityWithStateAbbr: "Constableville, NY",
  },
  {
    zip: "13326",
    ST: "NY",
    cityWithStateAbbr: "Cooperstown, NY",
  },
  {
    zip: "13327",
    ST: "NY",
    cityWithStateAbbr: "Croghan, NY",
  },
  {
    zip: "13328",
    ST: "NY",
    cityWithStateAbbr: "Deansboro, NY",
  },
  {
    zip: "13329",
    ST: "NY",
    cityWithStateAbbr: "Dolgeville, NY",
  },
  {
    zip: "13331",
    ST: "NY",
    cityWithStateAbbr: "Eagle Bay, NY",
  },
  {
    zip: "13332",
    ST: "NY",
    cityWithStateAbbr: "Earlville, NY",
  },
  {
    zip: "13333",
    ST: "NY",
    cityWithStateAbbr: "East Springfield, NY",
  },
  {
    zip: "13334",
    ST: "NY",
    cityWithStateAbbr: "Eaton, NY",
  },
  {
    zip: "13335",
    ST: "NY",
    cityWithStateAbbr: "Edmeston, NY",
  },
  {
    zip: "13337",
    ST: "NY",
    cityWithStateAbbr: "Fly Creek, NY",
  },
  {
    zip: "13338",
    ST: "NY",
    cityWithStateAbbr: "Forestport, NY",
  },
  {
    zip: "13339",
    ST: "NY",
    cityWithStateAbbr: "Fort Plain, NY",
  },
  {
    zip: "13340",
    ST: "NY",
    cityWithStateAbbr: "Frankfort, NY",
  },
  {
    zip: "13341",
    ST: "NY",
    cityWithStateAbbr: "Franklin Springs, NY",
  },
  {
    zip: "13342",
    ST: "NY",
    cityWithStateAbbr: "Garrattsville, NY",
  },
  {
    zip: "13343",
    ST: "NY",
    cityWithStateAbbr: "Glenfield, NY",
  },
  {
    zip: "13345",
    ST: "NY",
    cityWithStateAbbr: "Greig, NY",
  },
  {
    zip: "13346",
    ST: "NY",
    cityWithStateAbbr: "Hamilton, NY",
  },
  {
    zip: "13348",
    ST: "NY",
    cityWithStateAbbr: "Hartwick, NY",
  },
  {
    zip: "13350",
    ST: "NY",
    cityWithStateAbbr: "Herkimer, NY",
  },
  {
    zip: "13352",
    ST: "NY",
    cityWithStateAbbr: "Hinckley, NY",
  },
  {
    zip: "13353",
    ST: "NY",
    cityWithStateAbbr: "Hoffmeister, NY",
  },
  {
    zip: "13354",
    ST: "NY",
    cityWithStateAbbr: "Holland Patent, NY",
  },
  {
    zip: "13355",
    ST: "NY",
    cityWithStateAbbr: "Hubbardsville, NY",
  },
  {
    zip: "13357",
    ST: "NY",
    cityWithStateAbbr: "Ilion, NY",
  },
  {
    zip: "13360",
    ST: "NY",
    cityWithStateAbbr: "Inlet, NY",
  },
  {
    zip: "13361",
    ST: "NY",
    cityWithStateAbbr: "Jordanville, NY",
  },
  {
    zip: "13362",
    ST: "NY",
    cityWithStateAbbr: "Knoxboro, NY",
  },
  {
    zip: "13363",
    ST: "NY",
    cityWithStateAbbr: "Lee Center, NY",
  },
  {
    zip: "13364",
    ST: "NY",
    cityWithStateAbbr: "Leonardsville, NY",
  },
  {
    zip: "13365",
    ST: "NY",
    cityWithStateAbbr: "Little Falls, NY",
  },
  {
    zip: "13367",
    ST: "NY",
    cityWithStateAbbr: "Lowville, NY",
  },
  {
    zip: "13368",
    ST: "NY",
    cityWithStateAbbr: "Lyons Falls, NY",
  },
  {
    zip: "13401",
    ST: "NY",
    cityWithStateAbbr: "Mc Connellsville, NY",
  },
  {
    zip: "13402",
    ST: "NY",
    cityWithStateAbbr: "Madison, NY",
  },
  {
    zip: "13403",
    ST: "NY",
    cityWithStateAbbr: "Marcy, NY",
  },
  {
    zip: "13404",
    ST: "NY",
    cityWithStateAbbr: "Martinsburg, NY",
  },
  {
    zip: "13406",
    ST: "NY",
    cityWithStateAbbr: "Middleville, NY",
  },
  {
    zip: "13407",
    ST: "NY",
    cityWithStateAbbr: "Mohawk, NY",
  },
  {
    zip: "13408",
    ST: "NY",
    cityWithStateAbbr: "Morrisville, NY",
  },
  {
    zip: "13409",
    ST: "NY",
    cityWithStateAbbr: "Munnsville, NY",
  },
  {
    zip: "13410",
    ST: "NY",
    cityWithStateAbbr: "Nelliston, NY",
  },
  {
    zip: "13411",
    ST: "NY",
    cityWithStateAbbr: "New Berlin, NY",
  },
  {
    zip: "13413",
    ST: "NY",
    cityWithStateAbbr: "New Hartford, NY",
  },
  {
    zip: "13415",
    ST: "NY",
    cityWithStateAbbr: "New Lisbon, NY",
  },
  {
    zip: "13416",
    ST: "NY",
    cityWithStateAbbr: "Newport, NY",
  },
  {
    zip: "13417",
    ST: "NY",
    cityWithStateAbbr: "New York Mills, NY",
  },
  {
    zip: "13418",
    ST: "NY",
    cityWithStateAbbr: "North Brookfield, NY",
  },
  {
    zip: "13420",
    ST: "NY",
    cityWithStateAbbr: "Old Forge, NY",
  },
  {
    zip: "13421",
    ST: "NY",
    cityWithStateAbbr: "Oneida, NY",
  },
  {
    zip: "13424",
    ST: "NY",
    cityWithStateAbbr: "Oriskany, NY",
  },
  {
    zip: "13425",
    ST: "NY",
    cityWithStateAbbr: "Oriskany Falls, NY",
  },
  {
    zip: "13426",
    ST: "NY",
    cityWithStateAbbr: "Orwell, NY",
  },
  {
    zip: "13428",
    ST: "NY",
    cityWithStateAbbr: "Palatine Bridge, NY",
  },
  {
    zip: "13431",
    ST: "NY",
    cityWithStateAbbr: "Poland, NY",
  },
  {
    zip: "13433",
    ST: "NY",
    cityWithStateAbbr: "Port Leyden, NY",
  },
  {
    zip: "13435",
    ST: "NY",
    cityWithStateAbbr: "Prospect, NY",
  },
  {
    zip: "13436",
    ST: "NY",
    cityWithStateAbbr: "Raquette Lake, NY",
  },
  {
    zip: "13437",
    ST: "NY",
    cityWithStateAbbr: "Redfield, NY",
  },
  {
    zip: "13438",
    ST: "NY",
    cityWithStateAbbr: "Remsen, NY",
  },
  {
    zip: "13439",
    ST: "NY",
    cityWithStateAbbr: "Richfield Springs, NY",
  },
  {
    zip: "13440",
    ST: "NY",
    cityWithStateAbbr: "Rome, NY",
  },
  {
    zip: "13441",
    ST: "NY",
    cityWithStateAbbr: "Rome, NY",
  },
  {
    zip: "13442",
    ST: "NY",
    cityWithStateAbbr: "Rome, NY",
  },
  {
    zip: "13450",
    ST: "NY",
    cityWithStateAbbr: "Roseboom, NY",
  },
  {
    zip: "13452",
    ST: "NY",
    cityWithStateAbbr: "Saint Johnsville, NY",
  },
  {
    zip: "13454",
    ST: "NY",
    cityWithStateAbbr: "Salisbury Center, NY",
  },
  {
    zip: "13455",
    ST: "NY",
    cityWithStateAbbr: "Sangerfield, NY",
  },
  {
    zip: "13456",
    ST: "NY",
    cityWithStateAbbr: "Sauquoit, NY",
  },
  {
    zip: "13457",
    ST: "NY",
    cityWithStateAbbr: "Schuyler Lake, NY",
  },
  {
    zip: "13459",
    ST: "NY",
    cityWithStateAbbr: "Sharon Springs, NY",
  },
  {
    zip: "13460",
    ST: "NY",
    cityWithStateAbbr: "Sherburne, NY",
  },
  {
    zip: "13461",
    ST: "NY",
    cityWithStateAbbr: "Sherrill, NY",
  },
  {
    zip: "13464",
    ST: "NY",
    cityWithStateAbbr: "Smyrna, NY",
  },
  {
    zip: "13465",
    ST: "NY",
    cityWithStateAbbr: "Solsville, NY",
  },
  {
    zip: "13468",
    ST: "NY",
    cityWithStateAbbr: "Springfield Center, NY",
  },
  {
    zip: "13469",
    ST: "NY",
    cityWithStateAbbr: "Stittville, NY",
  },
  {
    zip: "13470",
    ST: "NY",
    cityWithStateAbbr: "Stratford, NY",
  },
  {
    zip: "13471",
    ST: "NY",
    cityWithStateAbbr: "Taberg, NY",
  },
  {
    zip: "13472",
    ST: "NY",
    cityWithStateAbbr: "Thendara, NY",
  },
  {
    zip: "13473",
    ST: "NY",
    cityWithStateAbbr: "Turin, NY",
  },
  {
    zip: "13475",
    ST: "NY",
    cityWithStateAbbr: "Van Hornesville, NY",
  },
  {
    zip: "13476",
    ST: "NY",
    cityWithStateAbbr: "Vernon, NY",
  },
  {
    zip: "13477",
    ST: "NY",
    cityWithStateAbbr: "Vernon Center, NY",
  },
  {
    zip: "13478",
    ST: "NY",
    cityWithStateAbbr: "Verona, NY",
  },
  {
    zip: "13479",
    ST: "NY",
    cityWithStateAbbr: "Washington Mills, NY",
  },
  {
    zip: "13480",
    ST: "NY",
    cityWithStateAbbr: "Waterville, NY",
  },
  {
    zip: "13482",
    ST: "NY",
    cityWithStateAbbr: "West Burlington, NY",
  },
  {
    zip: "13483",
    ST: "NY",
    cityWithStateAbbr: "Westdale, NY",
  },
  {
    zip: "13484",
    ST: "NY",
    cityWithStateAbbr: "West Eaton, NY",
  },
  {
    zip: "13485",
    ST: "NY",
    cityWithStateAbbr: "West Edmeston, NY",
  },
  {
    zip: "13486",
    ST: "NY",
    cityWithStateAbbr: "Westernville, NY",
  },
  {
    zip: "13488",
    ST: "NY",
    cityWithStateAbbr: "Westford, NY",
  },
  {
    zip: "13489",
    ST: "NY",
    cityWithStateAbbr: "West Leyden, NY",
  },
  {
    zip: "13490",
    ST: "NY",
    cityWithStateAbbr: "Westmoreland, NY",
  },
  {
    zip: "13491",
    ST: "NY",
    cityWithStateAbbr: "West Winfield, NY",
  },
  {
    zip: "13492",
    ST: "NY",
    cityWithStateAbbr: "Whitesboro, NY",
  },
  {
    zip: "13493",
    ST: "NY",
    cityWithStateAbbr: "Williamstown, NY",
  },
  {
    zip: "13494",
    ST: "NY",
    cityWithStateAbbr: "Woodgate, NY",
  },
  {
    zip: "13495",
    ST: "NY",
    cityWithStateAbbr: "Yorkville, NY",
  },
  {
    zip: "13501",
    ST: "NY",
    cityWithStateAbbr: "Utica, NY",
  },
  {
    zip: "13502",
    ST: "NY",
    cityWithStateAbbr: "Utica, NY",
  },
  {
    zip: "13503",
    ST: "NY",
    cityWithStateAbbr: "Utica, NY",
  },
  {
    zip: "13504",
    ST: "NY",
    cityWithStateAbbr: "Utica, NY",
  },
  {
    zip: "13505",
    ST: "NY",
    cityWithStateAbbr: "Utica, NY",
  },
  {
    zip: "13599",
    ST: "NY",
    cityWithStateAbbr: "Utica, NY",
  },
  {
    zip: "13601",
    ST: "NY",
    cityWithStateAbbr: "Watertown, NY",
  },
  {
    zip: "13602",
    ST: "NY",
    cityWithStateAbbr: "Fort Drum, NY",
  },
  {
    zip: "13603",
    ST: "NY",
    cityWithStateAbbr: "Watertown, NY",
  },
  {
    zip: "13605",
    ST: "NY",
    cityWithStateAbbr: "Adams, NY",
  },
  {
    zip: "13606",
    ST: "NY",
    cityWithStateAbbr: "Adams Center, NY",
  },
  {
    zip: "13607",
    ST: "NY",
    cityWithStateAbbr: "Alexandria Bay, NY",
  },
  {
    zip: "13608",
    ST: "NY",
    cityWithStateAbbr: "Antwerp, NY",
  },
  {
    zip: "13611",
    ST: "NY",
    cityWithStateAbbr: "Belleville, NY",
  },
  {
    zip: "13612",
    ST: "NY",
    cityWithStateAbbr: "Black River, NY",
  },
  {
    zip: "13613",
    ST: "NY",
    cityWithStateAbbr: "Brasher Falls, NY",
  },
  {
    zip: "13614",
    ST: "NY",
    cityWithStateAbbr: "Brier Hill, NY",
  },
  {
    zip: "13615",
    ST: "NY",
    cityWithStateAbbr: "Brownville, NY",
  },
  {
    zip: "13616",
    ST: "NY",
    cityWithStateAbbr: "Calcium, NY",
  },
  {
    zip: "13617",
    ST: "NY",
    cityWithStateAbbr: "Canton, NY",
  },
  {
    zip: "13618",
    ST: "NY",
    cityWithStateAbbr: "Cape Vincent, NY",
  },
  {
    zip: "13619",
    ST: "NY",
    cityWithStateAbbr: "Carthage, NY",
  },
  {
    zip: "13620",
    ST: "NY",
    cityWithStateAbbr: "Castorland, NY",
  },
  {
    zip: "13621",
    ST: "NY",
    cityWithStateAbbr: "Chase Mills, NY",
  },
  {
    zip: "13622",
    ST: "NY",
    cityWithStateAbbr: "Chaumont, NY",
  },
  {
    zip: "13623",
    ST: "NY",
    cityWithStateAbbr: "Chippewa Bay, NY",
  },
  {
    zip: "13624",
    ST: "NY",
    cityWithStateAbbr: "Clayton, NY",
  },
  {
    zip: "13625",
    ST: "NY",
    cityWithStateAbbr: "Colton, NY",
  },
  {
    zip: "13626",
    ST: "NY",
    cityWithStateAbbr: "Copenhagen, NY",
  },
  {
    zip: "13627",
    ST: "NY",
    cityWithStateAbbr: "Deer River, NY",
  },
  {
    zip: "13628",
    ST: "NY",
    cityWithStateAbbr: "Deferiet, NY",
  },
  {
    zip: "13630",
    ST: "NY",
    cityWithStateAbbr: "De Kalb Junction, NY",
  },
  {
    zip: "13631",
    ST: "NY",
    cityWithStateAbbr: "Denmark, NY",
  },
  {
    zip: "13632",
    ST: "NY",
    cityWithStateAbbr: "Depauville, NY",
  },
  {
    zip: "13633",
    ST: "NY",
    cityWithStateAbbr: "De Peyster, NY",
  },
  {
    zip: "13634",
    ST: "NY",
    cityWithStateAbbr: "Dexter, NY",
  },
  {
    zip: "13635",
    ST: "NY",
    cityWithStateAbbr: "Edwards, NY",
  },
  {
    zip: "13636",
    ST: "NY",
    cityWithStateAbbr: "Ellisburg, NY",
  },
  {
    zip: "13637",
    ST: "NY",
    cityWithStateAbbr: "Evans Mills, NY",
  },
  {
    zip: "13638",
    ST: "NY",
    cityWithStateAbbr: "Felts Mills, NY",
  },
  {
    zip: "13639",
    ST: "NY",
    cityWithStateAbbr: "Fine, NY",
  },
  {
    zip: "13640",
    ST: "NY",
    cityWithStateAbbr: "Wellesley Island, NY",
  },
  {
    zip: "13641",
    ST: "NY",
    cityWithStateAbbr: "Fishers Landing, NY",
  },
  {
    zip: "13642",
    ST: "NY",
    cityWithStateAbbr: "Gouverneur, NY",
  },
  {
    zip: "13643",
    ST: "NY",
    cityWithStateAbbr: "Great Bend, NY",
  },
  {
    zip: "13645",
    ST: "NY",
    cityWithStateAbbr: "Hailesboro, NY",
  },
  {
    zip: "13646",
    ST: "NY",
    cityWithStateAbbr: "Hammond, NY",
  },
  {
    zip: "13647",
    ST: "NY",
    cityWithStateAbbr: "Hannawa Falls, NY",
  },
  {
    zip: "13648",
    ST: "NY",
    cityWithStateAbbr: "Harrisville, NY",
  },
  {
    zip: "13649",
    ST: "NY",
    cityWithStateAbbr: "Helena, NY",
  },
  {
    zip: "13650",
    ST: "NY",
    cityWithStateAbbr: "Henderson, NY",
  },
  {
    zip: "13651",
    ST: "NY",
    cityWithStateAbbr: "Henderson Harbor, NY",
  },
  {
    zip: "13652",
    ST: "NY",
    cityWithStateAbbr: "Hermon, NY",
  },
  {
    zip: "13654",
    ST: "NY",
    cityWithStateAbbr: "Heuvelton, NY",
  },
  {
    zip: "13655",
    ST: "NY",
    cityWithStateAbbr: "Hogansburg, NY",
  },
  {
    zip: "13656",
    ST: "NY",
    cityWithStateAbbr: "La Fargeville, NY",
  },
  {
    zip: "13657",
    ST: "NY",
    cityWithStateAbbr: "Limerick, NY",
  },
  {
    zip: "13658",
    ST: "NY",
    cityWithStateAbbr: "Lisbon, NY",
  },
  {
    zip: "13659",
    ST: "NY",
    cityWithStateAbbr: "Lorraine, NY",
  },
  {
    zip: "13660",
    ST: "NY",
    cityWithStateAbbr: "Madrid, NY",
  },
  {
    zip: "13661",
    ST: "NY",
    cityWithStateAbbr: "Mannsville, NY",
  },
  {
    zip: "13662",
    ST: "NY",
    cityWithStateAbbr: "Massena, NY",
  },
  {
    zip: "13664",
    ST: "NY",
    cityWithStateAbbr: "Morristown, NY",
  },
  {
    zip: "13665",
    ST: "NY",
    cityWithStateAbbr: "Natural Bridge, NY",
  },
  {
    zip: "13666",
    ST: "NY",
    cityWithStateAbbr: "Newton Falls, NY",
  },
  {
    zip: "13667",
    ST: "NY",
    cityWithStateAbbr: "Norfolk, NY",
  },
  {
    zip: "13668",
    ST: "NY",
    cityWithStateAbbr: "Norwood, NY",
  },
  {
    zip: "13669",
    ST: "NY",
    cityWithStateAbbr: "Ogdensburg, NY",
  },
  {
    zip: "13670",
    ST: "NY",
    cityWithStateAbbr: "Oswegatchie, NY",
  },
  {
    zip: "13671",
    ST: "NY",
    cityWithStateAbbr: "Oxbow, NY",
  },
  {
    zip: "13672",
    ST: "NY",
    cityWithStateAbbr: "Parishville, NY",
  },
  {
    zip: "13673",
    ST: "NY",
    cityWithStateAbbr: "Philadelphia, NY",
  },
  {
    zip: "13674",
    ST: "NY",
    cityWithStateAbbr: "Pierrepont Manor, NY",
  },
  {
    zip: "13675",
    ST: "NY",
    cityWithStateAbbr: "Plessis, NY",
  },
  {
    zip: "13676",
    ST: "NY",
    cityWithStateAbbr: "Potsdam, NY",
  },
  {
    zip: "13677",
    ST: "NY",
    cityWithStateAbbr: "Pyrites, NY",
  },
  {
    zip: "13678",
    ST: "NY",
    cityWithStateAbbr: "Raymondville, NY",
  },
  {
    zip: "13679",
    ST: "NY",
    cityWithStateAbbr: "Redwood, NY",
  },
  {
    zip: "13680",
    ST: "NY",
    cityWithStateAbbr: "Rensselaer Falls, NY",
  },
  {
    zip: "13681",
    ST: "NY",
    cityWithStateAbbr: "Richville, NY",
  },
  {
    zip: "13682",
    ST: "NY",
    cityWithStateAbbr: "Rodman, NY",
  },
  {
    zip: "13683",
    ST: "NY",
    cityWithStateAbbr: "Rooseveltown, NY",
  },
  {
    zip: "13684",
    ST: "NY",
    cityWithStateAbbr: "Russell, NY",
  },
  {
    zip: "13685",
    ST: "NY",
    cityWithStateAbbr: "Sackets Harbor, NY",
  },
  {
    zip: "13687",
    ST: "NY",
    cityWithStateAbbr: "South Colton, NY",
  },
  {
    zip: "13690",
    ST: "NY",
    cityWithStateAbbr: "Star Lake, NY",
  },
  {
    zip: "13691",
    ST: "NY",
    cityWithStateAbbr: "Theresa, NY",
  },
  {
    zip: "13692",
    ST: "NY",
    cityWithStateAbbr: "Thousand Island Park, NY",
  },
  {
    zip: "13693",
    ST: "NY",
    cityWithStateAbbr: "Three Mile Bay, NY",
  },
  {
    zip: "13694",
    ST: "NY",
    cityWithStateAbbr: "Waddington, NY",
  },
  {
    zip: "13695",
    ST: "NY",
    cityWithStateAbbr: "Wanakena, NY",
  },
  {
    zip: "13696",
    ST: "NY",
    cityWithStateAbbr: "West Stockholm, NY",
  },
  {
    zip: "13697",
    ST: "NY",
    cityWithStateAbbr: "Winthrop, NY",
  },
  {
    zip: "13699",
    ST: "NY",
    cityWithStateAbbr: "Potsdam, NY",
  },
  {
    zip: "13730",
    ST: "NY",
    cityWithStateAbbr: "Afton, NY",
  },
  {
    zip: "13731",
    ST: "NY",
    cityWithStateAbbr: "Andes, NY",
  },
  {
    zip: "13732",
    ST: "NY",
    cityWithStateAbbr: "Apalachin, NY",
  },
  {
    zip: "13733",
    ST: "NY",
    cityWithStateAbbr: "Bainbridge, NY",
  },
  {
    zip: "13734",
    ST: "NY",
    cityWithStateAbbr: "Barton, NY",
  },
  {
    zip: "13736",
    ST: "NY",
    cityWithStateAbbr: "Berkshire, NY",
  },
  {
    zip: "13737",
    ST: "NY",
    cityWithStateAbbr: "Bible School Park, NY",
  },
  {
    zip: "13738",
    ST: "NY",
    cityWithStateAbbr: "Blodgett Mills, NY",
  },
  {
    zip: "13739",
    ST: "NY",
    cityWithStateAbbr: "Bloomville, NY",
  },
  {
    zip: "13740",
    ST: "NY",
    cityWithStateAbbr: "Bovina Center, NY",
  },
  {
    zip: "13743",
    ST: "NY",
    cityWithStateAbbr: "Candor, NY",
  },
  {
    zip: "13744",
    ST: "NY",
    cityWithStateAbbr: "Castle Creek, NY",
  },
  {
    zip: "13745",
    ST: "NY",
    cityWithStateAbbr: "Chenango Bridge, NY",
  },
  {
    zip: "13746",
    ST: "NY",
    cityWithStateAbbr: "Chenango Forks, NY",
  },
  {
    zip: "13747",
    ST: "NY",
    cityWithStateAbbr: "Colliersville, NY",
  },
  {
    zip: "13748",
    ST: "NY",
    cityWithStateAbbr: "Conklin, NY",
  },
  {
    zip: "13749",
    ST: "NY",
    cityWithStateAbbr: "Corbettsville, NY",
  },
  {
    zip: "13750",
    ST: "NY",
    cityWithStateAbbr: "Davenport, NY",
  },
  {
    zip: "13751",
    ST: "NY",
    cityWithStateAbbr: "Davenport Center, NY",
  },
  {
    zip: "13752",
    ST: "NY",
    cityWithStateAbbr: "Delancey, NY",
  },
  {
    zip: "13753",
    ST: "NY",
    cityWithStateAbbr: "Delhi, NY",
  },
  {
    zip: "13754",
    ST: "NY",
    cityWithStateAbbr: "Deposit, NY",
  },
  {
    zip: "13755",
    ST: "NY",
    cityWithStateAbbr: "Downsville, NY",
  },
  {
    zip: "13756",
    ST: "NY",
    cityWithStateAbbr: "East Branch, NY",
  },
  {
    zip: "13757",
    ST: "NY",
    cityWithStateAbbr: "East Meredith, NY",
  },
  {
    zip: "13758",
    ST: "NY",
    cityWithStateAbbr: "East Pharsalia, NY",
  },
  {
    zip: "13760",
    ST: "NY",
    cityWithStateAbbr: "Endicott, NY",
  },
  {
    zip: "13761",
    ST: "NY",
    cityWithStateAbbr: "Endicott, NY",
  },
  {
    zip: "13762",
    ST: "NY",
    cityWithStateAbbr: "Endwell, NY",
  },
  {
    zip: "13763",
    ST: "NY",
    cityWithStateAbbr: "Endicott, NY",
  },
  {
    zip: "13774",
    ST: "NY",
    cityWithStateAbbr: "Fishs Eddy, NY",
  },
  {
    zip: "13775",
    ST: "NY",
    cityWithStateAbbr: "Franklin, NY",
  },
  {
    zip: "13776",
    ST: "NY",
    cityWithStateAbbr: "Gilbertsville, NY",
  },
  {
    zip: "13777",
    ST: "NY",
    cityWithStateAbbr: "Glen Aubrey, NY",
  },
  {
    zip: "13778",
    ST: "NY",
    cityWithStateAbbr: "Greene, NY",
  },
  {
    zip: "13780",
    ST: "NY",
    cityWithStateAbbr: "Guilford, NY",
  },
  {
    zip: "13782",
    ST: "NY",
    cityWithStateAbbr: "Hamden, NY",
  },
  {
    zip: "13783",
    ST: "NY",
    cityWithStateAbbr: "Hancock, NY",
  },
  {
    zip: "13784",
    ST: "NY",
    cityWithStateAbbr: "Harford, NY",
  },
  {
    zip: "13786",
    ST: "NY",
    cityWithStateAbbr: "Harpersfield, NY",
  },
  {
    zip: "13787",
    ST: "NY",
    cityWithStateAbbr: "Harpursville, NY",
  },
  {
    zip: "13788",
    ST: "NY",
    cityWithStateAbbr: "Hobart, NY",
  },
  {
    zip: "13790",
    ST: "NY",
    cityWithStateAbbr: "Johnson City, NY",
  },
  {
    zip: "13794",
    ST: "NY",
    cityWithStateAbbr: "Killawog, NY",
  },
  {
    zip: "13795",
    ST: "NY",
    cityWithStateAbbr: "Kirkwood, NY",
  },
  {
    zip: "13796",
    ST: "NY",
    cityWithStateAbbr: "Laurens, NY",
  },
  {
    zip: "13797",
    ST: "NY",
    cityWithStateAbbr: "Lisle, NY",
  },
  {
    zip: "13801",
    ST: "NY",
    cityWithStateAbbr: "Mc Donough, NY",
  },
  {
    zip: "13802",
    ST: "NY",
    cityWithStateAbbr: "Maine, NY",
  },
  {
    zip: "13803",
    ST: "NY",
    cityWithStateAbbr: "Marathon, NY",
  },
  {
    zip: "13804",
    ST: "NY",
    cityWithStateAbbr: "Masonville, NY",
  },
  {
    zip: "13806",
    ST: "NY",
    cityWithStateAbbr: "Meridale, NY",
  },
  {
    zip: "13807",
    ST: "NY",
    cityWithStateAbbr: "Milford, NY",
  },
  {
    zip: "13808",
    ST: "NY",
    cityWithStateAbbr: "Morris, NY",
  },
  {
    zip: "13809",
    ST: "NY",
    cityWithStateAbbr: "Mount Upton, NY",
  },
  {
    zip: "13810",
    ST: "NY",
    cityWithStateAbbr: "Mount Vision, NY",
  },
  {
    zip: "13811",
    ST: "NY",
    cityWithStateAbbr: "Newark Valley, NY",
  },
  {
    zip: "13812",
    ST: "NY",
    cityWithStateAbbr: "Nichols, NY",
  },
  {
    zip: "13813",
    ST: "NY",
    cityWithStateAbbr: "Nineveh, NY",
  },
  {
    zip: "13814",
    ST: "NY",
    cityWithStateAbbr: "North Norwich, NY",
  },
  {
    zip: "13815",
    ST: "NY",
    cityWithStateAbbr: "Norwich, NY",
  },
  {
    zip: "13820",
    ST: "NY",
    cityWithStateAbbr: "Oneonta, NY",
  },
  {
    zip: "13825",
    ST: "NY",
    cityWithStateAbbr: "Otego, NY",
  },
  {
    zip: "13826",
    ST: "NY",
    cityWithStateAbbr: "Ouaquaga, NY",
  },
  {
    zip: "13827",
    ST: "NY",
    cityWithStateAbbr: "Owego, NY",
  },
  {
    zip: "13830",
    ST: "NY",
    cityWithStateAbbr: "Oxford, NY",
  },
  {
    zip: "13832",
    ST: "NY",
    cityWithStateAbbr: "Plymouth, NY",
  },
  {
    zip: "13833",
    ST: "NY",
    cityWithStateAbbr: "Port Crane, NY",
  },
  {
    zip: "13834",
    ST: "NY",
    cityWithStateAbbr: "Portlandville, NY",
  },
  {
    zip: "13835",
    ST: "NY",
    cityWithStateAbbr: "Richford, NY",
  },
  {
    zip: "13838",
    ST: "NY",
    cityWithStateAbbr: "Sidney, NY",
  },
  {
    zip: "13839",
    ST: "NY",
    cityWithStateAbbr: "Sidney Center, NY",
  },
  {
    zip: "13840",
    ST: "NY",
    cityWithStateAbbr: "Smithboro, NY",
  },
  {
    zip: "13841",
    ST: "NY",
    cityWithStateAbbr: "Smithville Flats, NY",
  },
  {
    zip: "13842",
    ST: "NY",
    cityWithStateAbbr: "South Kortright, NY",
  },
  {
    zip: "13843",
    ST: "NY",
    cityWithStateAbbr: "South New Berlin, NY",
  },
  {
    zip: "13844",
    ST: "NY",
    cityWithStateAbbr: "South Plymouth, NY",
  },
  {
    zip: "13845",
    ST: "NY",
    cityWithStateAbbr: "Tioga Center, NY",
  },
  {
    zip: "13846",
    ST: "NY",
    cityWithStateAbbr: "Treadwell, NY",
  },
  {
    zip: "13847",
    ST: "NY",
    cityWithStateAbbr: "Trout Creek, NY",
  },
  {
    zip: "13848",
    ST: "NY",
    cityWithStateAbbr: "Tunnel, NY",
  },
  {
    zip: "13849",
    ST: "NY",
    cityWithStateAbbr: "Unadilla, NY",
  },
  {
    zip: "13850",
    ST: "NY",
    cityWithStateAbbr: "Vestal, NY",
  },
  {
    zip: "13851",
    ST: "NY",
    cityWithStateAbbr: "Vestal, NY",
  },
  {
    zip: "13856",
    ST: "NY",
    cityWithStateAbbr: "Walton, NY",
  },
  {
    zip: "13859",
    ST: "NY",
    cityWithStateAbbr: "Wells Bridge, NY",
  },
  {
    zip: "13860",
    ST: "NY",
    cityWithStateAbbr: "West Davenport, NY",
  },
  {
    zip: "13861",
    ST: "NY",
    cityWithStateAbbr: "West Oneonta, NY",
  },
  {
    zip: "13862",
    ST: "NY",
    cityWithStateAbbr: "Whitney Point, NY",
  },
  {
    zip: "13863",
    ST: "NY",
    cityWithStateAbbr: "Willet, NY",
  },
  {
    zip: "13864",
    ST: "NY",
    cityWithStateAbbr: "Willseyville, NY",
  },
  {
    zip: "13865",
    ST: "NY",
    cityWithStateAbbr: "Windsor, NY",
  },
  {
    zip: "13901",
    ST: "NY",
    cityWithStateAbbr: "Binghamton, NY",
  },
  {
    zip: "13902",
    ST: "NY",
    cityWithStateAbbr: "Binghamton, NY",
  },
  {
    zip: "13903",
    ST: "NY",
    cityWithStateAbbr: "Binghamton, NY",
  },
  {
    zip: "13904",
    ST: "NY",
    cityWithStateAbbr: "Binghamton, NY",
  },
  {
    zip: "13905",
    ST: "NY",
    cityWithStateAbbr: "Binghamton, NY",
  },
  {
    zip: "14001",
    ST: "NY",
    cityWithStateAbbr: "Akron, NY",
  },
  {
    zip: "14004",
    ST: "NY",
    cityWithStateAbbr: "Alden, NY",
  },
  {
    zip: "14005",
    ST: "NY",
    cityWithStateAbbr: "Alexander, NY",
  },
  {
    zip: "14006",
    ST: "NY",
    cityWithStateAbbr: "Angola, NY",
  },
  {
    zip: "14008",
    ST: "NY",
    cityWithStateAbbr: "Appleton, NY",
  },
  {
    zip: "14009",
    ST: "NY",
    cityWithStateAbbr: "Arcade, NY",
  },
  {
    zip: "14010",
    ST: "NY",
    cityWithStateAbbr: "Athol Springs, NY",
  },
  {
    zip: "14011",
    ST: "NY",
    cityWithStateAbbr: "Attica, NY",
  },
  {
    zip: "14012",
    ST: "NY",
    cityWithStateAbbr: "Barker, NY",
  },
  {
    zip: "14013",
    ST: "NY",
    cityWithStateAbbr: "Basom, NY",
  },
  {
    zip: "14020",
    ST: "NY",
    cityWithStateAbbr: "Batavia, NY",
  },
  {
    zip: "14021",
    ST: "NY",
    cityWithStateAbbr: "Batavia, NY",
  },
  {
    zip: "14024",
    ST: "NY",
    cityWithStateAbbr: "Bliss, NY",
  },
  {
    zip: "14025",
    ST: "NY",
    cityWithStateAbbr: "Boston, NY",
  },
  {
    zip: "14026",
    ST: "NY",
    cityWithStateAbbr: "Bowmansville, NY",
  },
  {
    zip: "14027",
    ST: "NY",
    cityWithStateAbbr: "Brant, NY",
  },
  {
    zip: "14028",
    ST: "NY",
    cityWithStateAbbr: "Burt, NY",
  },
  {
    zip: "14029",
    ST: "NY",
    cityWithStateAbbr: "Centerville, NY",
  },
  {
    zip: "14030",
    ST: "NY",
    cityWithStateAbbr: "Chaffee, NY",
  },
  {
    zip: "14031",
    ST: "NY",
    cityWithStateAbbr: "Clarence, NY",
  },
  {
    zip: "14032",
    ST: "NY",
    cityWithStateAbbr: "Clarence Center, NY",
  },
  {
    zip: "14033",
    ST: "NY",
    cityWithStateAbbr: "Colden, NY",
  },
  {
    zip: "14034",
    ST: "NY",
    cityWithStateAbbr: "Collins, NY",
  },
  {
    zip: "14035",
    ST: "NY",
    cityWithStateAbbr: "Collins Center, NY",
  },
  {
    zip: "14036",
    ST: "NY",
    cityWithStateAbbr: "Corfu, NY",
  },
  {
    zip: "14037",
    ST: "NY",
    cityWithStateAbbr: "Cowlesville, NY",
  },
  {
    zip: "14038",
    ST: "NY",
    cityWithStateAbbr: "Crittenden, NY",
  },
  {
    zip: "14039",
    ST: "NY",
    cityWithStateAbbr: "Dale, NY",
  },
  {
    zip: "14040",
    ST: "NY",
    cityWithStateAbbr: "Darien Center, NY",
  },
  {
    zip: "14041",
    ST: "NY",
    cityWithStateAbbr: "Dayton, NY",
  },
  {
    zip: "14042",
    ST: "NY",
    cityWithStateAbbr: "Delevan, NY",
  },
  {
    zip: "14043",
    ST: "NY",
    cityWithStateAbbr: "Depew, NY",
  },
  {
    zip: "14047",
    ST: "NY",
    cityWithStateAbbr: "Derby, NY",
  },
  {
    zip: "14048",
    ST: "NY",
    cityWithStateAbbr: "Dunkirk, NY",
  },
  {
    zip: "14051",
    ST: "NY",
    cityWithStateAbbr: "East Amherst, NY",
  },
  {
    zip: "14052",
    ST: "NY",
    cityWithStateAbbr: "East Aurora, NY",
  },
  {
    zip: "14054",
    ST: "NY",
    cityWithStateAbbr: "East Bethany, NY",
  },
  {
    zip: "14055",
    ST: "NY",
    cityWithStateAbbr: "East Concord, NY",
  },
  {
    zip: "14056",
    ST: "NY",
    cityWithStateAbbr: "East Pembroke, NY",
  },
  {
    zip: "14057",
    ST: "NY",
    cityWithStateAbbr: "Eden, NY",
  },
  {
    zip: "14058",
    ST: "NY",
    cityWithStateAbbr: "Elba, NY",
  },
  {
    zip: "14059",
    ST: "NY",
    cityWithStateAbbr: "Elma, NY",
  },
  {
    zip: "14060",
    ST: "NY",
    cityWithStateAbbr: "Farmersville Station, NY",
  },
  {
    zip: "14061",
    ST: "NY",
    cityWithStateAbbr: "Farnham, NY",
  },
  {
    zip: "14062",
    ST: "NY",
    cityWithStateAbbr: "Forestville, NY",
  },
  {
    zip: "14063",
    ST: "NY",
    cityWithStateAbbr: "Fredonia, NY",
  },
  {
    zip: "14065",
    ST: "NY",
    cityWithStateAbbr: "Freedom, NY",
  },
  {
    zip: "14066",
    ST: "NY",
    cityWithStateAbbr: "Gainesville, NY",
  },
  {
    zip: "14067",
    ST: "NY",
    cityWithStateAbbr: "Gasport, NY",
  },
  {
    zip: "14068",
    ST: "NY",
    cityWithStateAbbr: "Getzville, NY",
  },
  {
    zip: "14069",
    ST: "NY",
    cityWithStateAbbr: "Glenwood, NY",
  },
  {
    zip: "14070",
    ST: "NY",
    cityWithStateAbbr: "Gowanda, NY",
  },
  {
    zip: "14072",
    ST: "NY",
    cityWithStateAbbr: "Grand Island, NY",
  },
  {
    zip: "14075",
    ST: "NY",
    cityWithStateAbbr: "Hamburg, NY",
  },
  {
    zip: "14080",
    ST: "NY",
    cityWithStateAbbr: "Holland, NY",
  },
  {
    zip: "14081",
    ST: "NY",
    cityWithStateAbbr: "Irving, NY",
  },
  {
    zip: "14082",
    ST: "NY",
    cityWithStateAbbr: "Java Center, NY",
  },
  {
    zip: "14083",
    ST: "NY",
    cityWithStateAbbr: "Java Village, NY",
  },
  {
    zip: "14085",
    ST: "NY",
    cityWithStateAbbr: "Lake View, NY",
  },
  {
    zip: "14086",
    ST: "NY",
    cityWithStateAbbr: "Lancaster, NY",
  },
  {
    zip: "14091",
    ST: "NY",
    cityWithStateAbbr: "Lawtons, NY",
  },
  {
    zip: "14092",
    ST: "NY",
    cityWithStateAbbr: "Lewiston, NY",
  },
  {
    zip: "14094",
    ST: "NY",
    cityWithStateAbbr: "Lockport, NY",
  },
  {
    zip: "14095",
    ST: "NY",
    cityWithStateAbbr: "Lockport, NY",
  },
  {
    zip: "14098",
    ST: "NY",
    cityWithStateAbbr: "Lyndonville, NY",
  },
  {
    zip: "14101",
    ST: "NY",
    cityWithStateAbbr: "Machias, NY",
  },
  {
    zip: "14102",
    ST: "NY",
    cityWithStateAbbr: "Marilla, NY",
  },
  {
    zip: "14103",
    ST: "NY",
    cityWithStateAbbr: "Medina, NY",
  },
  {
    zip: "14105",
    ST: "NY",
    cityWithStateAbbr: "Middleport, NY",
  },
  {
    zip: "14107",
    ST: "NY",
    cityWithStateAbbr: "Model City, NY",
  },
  {
    zip: "14108",
    ST: "NY",
    cityWithStateAbbr: "Newfane, NY",
  },
  {
    zip: "14109",
    ST: "NY",
    cityWithStateAbbr: "Niagara University, NY",
  },
  {
    zip: "14110",
    ST: "NY",
    cityWithStateAbbr: "North Boston, NY",
  },
  {
    zip: "14111",
    ST: "NY",
    cityWithStateAbbr: "North Collins, NY",
  },
  {
    zip: "14112",
    ST: "NY",
    cityWithStateAbbr: "North Evans, NY",
  },
  {
    zip: "14113",
    ST: "NY",
    cityWithStateAbbr: "North Java, NY",
  },
  {
    zip: "14120",
    ST: "NY",
    cityWithStateAbbr: "North Tonawanda, NY",
  },
  {
    zip: "14125",
    ST: "NY",
    cityWithStateAbbr: "Oakfield, NY",
  },
  {
    zip: "14126",
    ST: "NY",
    cityWithStateAbbr: "Olcott, NY",
  },
  {
    zip: "14127",
    ST: "NY",
    cityWithStateAbbr: "Orchard Park, NY",
  },
  {
    zip: "14129",
    ST: "NY",
    cityWithStateAbbr: "Perrysburg, NY",
  },
  {
    zip: "14130",
    ST: "NY",
    cityWithStateAbbr: "Pike, NY",
  },
  {
    zip: "14131",
    ST: "NY",
    cityWithStateAbbr: "Ransomville, NY",
  },
  {
    zip: "14132",
    ST: "NY",
    cityWithStateAbbr: "Sanborn, NY",
  },
  {
    zip: "14133",
    ST: "NY",
    cityWithStateAbbr: "Sandusky, NY",
  },
  {
    zip: "14134",
    ST: "NY",
    cityWithStateAbbr: "Sardinia, NY",
  },
  {
    zip: "14135",
    ST: "NY",
    cityWithStateAbbr: "Sheridan, NY",
  },
  {
    zip: "14136",
    ST: "NY",
    cityWithStateAbbr: "Silver Creek, NY",
  },
  {
    zip: "14138",
    ST: "NY",
    cityWithStateAbbr: "South Dayton, NY",
  },
  {
    zip: "14139",
    ST: "NY",
    cityWithStateAbbr: "South Wales, NY",
  },
  {
    zip: "14140",
    ST: "NY",
    cityWithStateAbbr: "Spring Brook, NY",
  },
  {
    zip: "14141",
    ST: "NY",
    cityWithStateAbbr: "Springville, NY",
  },
  {
    zip: "14143",
    ST: "NY",
    cityWithStateAbbr: "Stafford, NY",
  },
  {
    zip: "14144",
    ST: "NY",
    cityWithStateAbbr: "Stella Niagara, NY",
  },
  {
    zip: "14145",
    ST: "NY",
    cityWithStateAbbr: "Strykersville, NY",
  },
  {
    zip: "14150",
    ST: "NY",
    cityWithStateAbbr: "Tonawanda, NY",
  },
  {
    zip: "14151",
    ST: "NY",
    cityWithStateAbbr: "Tonawanda, NY",
  },
  {
    zip: "14166",
    ST: "NY",
    cityWithStateAbbr: "Van Buren Point, NY",
  },
  {
    zip: "14167",
    ST: "NY",
    cityWithStateAbbr: "Varysburg, NY",
  },
  {
    zip: "14168",
    ST: "NY",
    cityWithStateAbbr: "Versailles, NY",
  },
  {
    zip: "14169",
    ST: "NY",
    cityWithStateAbbr: "Wales Center, NY",
  },
  {
    zip: "14170",
    ST: "NY",
    cityWithStateAbbr: "West Falls, NY",
  },
  {
    zip: "14171",
    ST: "NY",
    cityWithStateAbbr: "West Valley, NY",
  },
  {
    zip: "14172",
    ST: "NY",
    cityWithStateAbbr: "Wilson, NY",
  },
  {
    zip: "14173",
    ST: "NY",
    cityWithStateAbbr: "Yorkshire, NY",
  },
  {
    zip: "14174",
    ST: "NY",
    cityWithStateAbbr: "Youngstown, NY",
  },
  {
    zip: "14201",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14202",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14203",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14204",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14205",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14206",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14207",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14208",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14209",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14210",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14211",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14212",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14213",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14214",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14215",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14216",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14217",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14218",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14219",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14220",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14221",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14222",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14223",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14224",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14225",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14226",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14227",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14228",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14231",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14233",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14240",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14241",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14260",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14261",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14263",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14264",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14265",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14267",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14269",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14270",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14272",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14273",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14276",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14280",
    ST: "NY",
    cityWithStateAbbr: "Buffalo, NY",
  },
  {
    zip: "14301",
    ST: "NY",
    cityWithStateAbbr: "Niagara Falls, NY",
  },
  {
    zip: "14302",
    ST: "NY",
    cityWithStateAbbr: "Niagara Falls, NY",
  },
  {
    zip: "14303",
    ST: "NY",
    cityWithStateAbbr: "Niagara Falls, NY",
  },
  {
    zip: "14304",
    ST: "NY",
    cityWithStateAbbr: "Niagara Falls, NY",
  },
  {
    zip: "14305",
    ST: "NY",
    cityWithStateAbbr: "Niagara Falls, NY",
  },
  {
    zip: "14410",
    ST: "NY",
    cityWithStateAbbr: "Adams Basin, NY",
  },
  {
    zip: "14411",
    ST: "NY",
    cityWithStateAbbr: "Albion, NY",
  },
  {
    zip: "14413",
    ST: "NY",
    cityWithStateAbbr: "Alton, NY",
  },
  {
    zip: "14414",
    ST: "NY",
    cityWithStateAbbr: "Avon, NY",
  },
  {
    zip: "14415",
    ST: "NY",
    cityWithStateAbbr: "Bellona, NY",
  },
  {
    zip: "14416",
    ST: "NY",
    cityWithStateAbbr: "Bergen, NY",
  },
  {
    zip: "14418",
    ST: "NY",
    cityWithStateAbbr: "Branchport, NY",
  },
  {
    zip: "14420",
    ST: "NY",
    cityWithStateAbbr: "Brockport, NY",
  },
  {
    zip: "14422",
    ST: "NY",
    cityWithStateAbbr: "Byron, NY",
  },
  {
    zip: "14423",
    ST: "NY",
    cityWithStateAbbr: "Caledonia, NY",
  },
  {
    zip: "14424",
    ST: "NY",
    cityWithStateAbbr: "Canandaigua, NY",
  },
  {
    zip: "14425",
    ST: "NY",
    cityWithStateAbbr: "Farmington, NY",
  },
  {
    zip: "14427",
    ST: "NY",
    cityWithStateAbbr: "Castile, NY",
  },
  {
    zip: "14428",
    ST: "NY",
    cityWithStateAbbr: "Churchville, NY",
  },
  {
    zip: "14429",
    ST: "NY",
    cityWithStateAbbr: "Clarendon, NY",
  },
  {
    zip: "14430",
    ST: "NY",
    cityWithStateAbbr: "Clarkson, NY",
  },
  {
    zip: "14432",
    ST: "NY",
    cityWithStateAbbr: "Clifton Springs, NY",
  },
  {
    zip: "14433",
    ST: "NY",
    cityWithStateAbbr: "Clyde, NY",
  },
  {
    zip: "14435",
    ST: "NY",
    cityWithStateAbbr: "Conesus, NY",
  },
  {
    zip: "14437",
    ST: "NY",
    cityWithStateAbbr: "Dansville, NY",
  },
  {
    zip: "14441",
    ST: "NY",
    cityWithStateAbbr: "Dresden, NY",
  },
  {
    zip: "14443",
    ST: "NY",
    cityWithStateAbbr: "East Bloomfield, NY",
  },
  {
    zip: "14445",
    ST: "NY",
    cityWithStateAbbr: "East Rochester, NY",
  },
  {
    zip: "14449",
    ST: "NY",
    cityWithStateAbbr: "East Williamson, NY",
  },
  {
    zip: "14450",
    ST: "NY",
    cityWithStateAbbr: "Fairport, NY",
  },
  {
    zip: "14452",
    ST: "NY",
    cityWithStateAbbr: "Fancher, NY",
  },
  {
    zip: "14453",
    ST: "NY",
    cityWithStateAbbr: "Fishers, NY",
  },
  {
    zip: "14454",
    ST: "NY",
    cityWithStateAbbr: "Geneseo, NY",
  },
  {
    zip: "14456",
    ST: "NY",
    cityWithStateAbbr: "Geneva, NY",
  },
  {
    zip: "14461",
    ST: "NY",
    cityWithStateAbbr: "Gorham, NY",
  },
  {
    zip: "14462",
    ST: "NY",
    cityWithStateAbbr: "Groveland, NY",
  },
  {
    zip: "14463",
    ST: "NY",
    cityWithStateAbbr: "Hall, NY",
  },
  {
    zip: "14464",
    ST: "NY",
    cityWithStateAbbr: "Hamlin, NY",
  },
  {
    zip: "14466",
    ST: "NY",
    cityWithStateAbbr: "Hemlock, NY",
  },
  {
    zip: "14467",
    ST: "NY",
    cityWithStateAbbr: "Henrietta, NY",
  },
  {
    zip: "14468",
    ST: "NY",
    cityWithStateAbbr: "Hilton, NY",
  },
  {
    zip: "14469",
    ST: "NY",
    cityWithStateAbbr: "Bloomfield, NY",
  },
  {
    zip: "14470",
    ST: "NY",
    cityWithStateAbbr: "Holley, NY",
  },
  {
    zip: "14471",
    ST: "NY",
    cityWithStateAbbr: "Honeoye, NY",
  },
  {
    zip: "14472",
    ST: "NY",
    cityWithStateAbbr: "Honeoye Falls, NY",
  },
  {
    zip: "14475",
    ST: "NY",
    cityWithStateAbbr: "Ionia, NY",
  },
  {
    zip: "14476",
    ST: "NY",
    cityWithStateAbbr: "Kendall, NY",
  },
  {
    zip: "14477",
    ST: "NY",
    cityWithStateAbbr: "Kent, NY",
  },
  {
    zip: "14478",
    ST: "NY",
    cityWithStateAbbr: "Keuka Park, NY",
  },
  {
    zip: "14479",
    ST: "NY",
    cityWithStateAbbr: "Knowlesville, NY",
  },
  {
    zip: "14480",
    ST: "NY",
    cityWithStateAbbr: "Lakeville, NY",
  },
  {
    zip: "14481",
    ST: "NY",
    cityWithStateAbbr: "Leicester, NY",
  },
  {
    zip: "14482",
    ST: "NY",
    cityWithStateAbbr: "Le Roy, NY",
  },
  {
    zip: "14485",
    ST: "NY",
    cityWithStateAbbr: "Lima, NY",
  },
  {
    zip: "14486",
    ST: "NY",
    cityWithStateAbbr: "Linwood, NY",
  },
  {
    zip: "14487",
    ST: "NY",
    cityWithStateAbbr: "Livonia, NY",
  },
  {
    zip: "14488",
    ST: "NY",
    cityWithStateAbbr: "Livonia Center, NY",
  },
  {
    zip: "14489",
    ST: "NY",
    cityWithStateAbbr: "Lyons, NY",
  },
  {
    zip: "14502",
    ST: "NY",
    cityWithStateAbbr: "Macedon, NY",
  },
  {
    zip: "14504",
    ST: "NY",
    cityWithStateAbbr: "Manchester, NY",
  },
  {
    zip: "14505",
    ST: "NY",
    cityWithStateAbbr: "Marion, NY",
  },
  {
    zip: "14506",
    ST: "NY",
    cityWithStateAbbr: "Mendon, NY",
  },
  {
    zip: "14507",
    ST: "NY",
    cityWithStateAbbr: "Middlesex, NY",
  },
  {
    zip: "14508",
    ST: "NY",
    cityWithStateAbbr: "Morton, NY",
  },
  {
    zip: "14510",
    ST: "NY",
    cityWithStateAbbr: "Mount Morris, NY",
  },
  {
    zip: "14511",
    ST: "NY",
    cityWithStateAbbr: "Mumford, NY",
  },
  {
    zip: "14512",
    ST: "NY",
    cityWithStateAbbr: "Naples, NY",
  },
  {
    zip: "14513",
    ST: "NY",
    cityWithStateAbbr: "Newark, NY",
  },
  {
    zip: "14514",
    ST: "NY",
    cityWithStateAbbr: "North Chili, NY",
  },
  {
    zip: "14515",
    ST: "NY",
    cityWithStateAbbr: "North Greece, NY",
  },
  {
    zip: "14516",
    ST: "NY",
    cityWithStateAbbr: "North Rose, NY",
  },
  {
    zip: "14517",
    ST: "NY",
    cityWithStateAbbr: "Nunda, NY",
  },
  {
    zip: "14518",
    ST: "NY",
    cityWithStateAbbr: "Oaks Corners, NY",
  },
  {
    zip: "14519",
    ST: "NY",
    cityWithStateAbbr: "Ontario, NY",
  },
  {
    zip: "14520",
    ST: "NY",
    cityWithStateAbbr: "Ontario Center, NY",
  },
  {
    zip: "14521",
    ST: "NY",
    cityWithStateAbbr: "Ovid, NY",
  },
  {
    zip: "14522",
    ST: "NY",
    cityWithStateAbbr: "Palmyra, NY",
  },
  {
    zip: "14525",
    ST: "NY",
    cityWithStateAbbr: "Pavilion, NY",
  },
  {
    zip: "14526",
    ST: "NY",
    cityWithStateAbbr: "Penfield, NY",
  },
  {
    zip: "14527",
    ST: "NY",
    cityWithStateAbbr: "Penn Yan, NY",
  },
  {
    zip: "14529",
    ST: "NY",
    cityWithStateAbbr: "Perkinsville, NY",
  },
  {
    zip: "14530",
    ST: "NY",
    cityWithStateAbbr: "Perry, NY",
  },
  {
    zip: "14532",
    ST: "NY",
    cityWithStateAbbr: "Phelps, NY",
  },
  {
    zip: "14533",
    ST: "NY",
    cityWithStateAbbr: "Piffard, NY",
  },
  {
    zip: "14534",
    ST: "NY",
    cityWithStateAbbr: "Pittsford, NY",
  },
  {
    zip: "14536",
    ST: "NY",
    cityWithStateAbbr: "Portageville, NY",
  },
  {
    zip: "14537",
    ST: "NY",
    cityWithStateAbbr: "Port Gibson, NY",
  },
  {
    zip: "14538",
    ST: "NY",
    cityWithStateAbbr: "Pultneyville, NY",
  },
  {
    zip: "14539",
    ST: "NY",
    cityWithStateAbbr: "Retsof, NY",
  },
  {
    zip: "14541",
    ST: "NY",
    cityWithStateAbbr: "Romulus, NY",
  },
  {
    zip: "14542",
    ST: "NY",
    cityWithStateAbbr: "Rose, NY",
  },
  {
    zip: "14543",
    ST: "NY",
    cityWithStateAbbr: "Rush, NY",
  },
  {
    zip: "14544",
    ST: "NY",
    cityWithStateAbbr: "Rushville, NY",
  },
  {
    zip: "14545",
    ST: "NY",
    cityWithStateAbbr: "Scottsburg, NY",
  },
  {
    zip: "14546",
    ST: "NY",
    cityWithStateAbbr: "Scottsville, NY",
  },
  {
    zip: "14547",
    ST: "NY",
    cityWithStateAbbr: "Seneca Castle, NY",
  },
  {
    zip: "14548",
    ST: "NY",
    cityWithStateAbbr: "Shortsville, NY",
  },
  {
    zip: "14549",
    ST: "NY",
    cityWithStateAbbr: "Silver Lake, NY",
  },
  {
    zip: "14550",
    ST: "NY",
    cityWithStateAbbr: "Silver Springs, NY",
  },
  {
    zip: "14551",
    ST: "NY",
    cityWithStateAbbr: "Sodus, NY",
  },
  {
    zip: "14555",
    ST: "NY",
    cityWithStateAbbr: "Sodus Point, NY",
  },
  {
    zip: "14556",
    ST: "NY",
    cityWithStateAbbr: "Sonyea, NY",
  },
  {
    zip: "14557",
    ST: "NY",
    cityWithStateAbbr: "South Byron, NY",
  },
  {
    zip: "14558",
    ST: "NY",
    cityWithStateAbbr: "South Lima, NY",
  },
  {
    zip: "14559",
    ST: "NY",
    cityWithStateAbbr: "Spencerport, NY",
  },
  {
    zip: "14560",
    ST: "NY",
    cityWithStateAbbr: "Springwater, NY",
  },
  {
    zip: "14561",
    ST: "NY",
    cityWithStateAbbr: "Stanley, NY",
  },
  {
    zip: "14563",
    ST: "NY",
    cityWithStateAbbr: "Union Hill, NY",
  },
  {
    zip: "14564",
    ST: "NY",
    cityWithStateAbbr: "Victor, NY",
  },
  {
    zip: "14568",
    ST: "NY",
    cityWithStateAbbr: "Walworth, NY",
  },
  {
    zip: "14569",
    ST: "NY",
    cityWithStateAbbr: "Warsaw, NY",
  },
  {
    zip: "14571",
    ST: "NY",
    cityWithStateAbbr: "Waterport, NY",
  },
  {
    zip: "14572",
    ST: "NY",
    cityWithStateAbbr: "Wayland, NY",
  },
  {
    zip: "14580",
    ST: "NY",
    cityWithStateAbbr: "Webster, NY",
  },
  {
    zip: "14585",
    ST: "NY",
    cityWithStateAbbr: "West Bloomfield, NY",
  },
  {
    zip: "14586",
    ST: "NY",
    cityWithStateAbbr: "West Henrietta, NY",
  },
  {
    zip: "14588",
    ST: "NY",
    cityWithStateAbbr: "Willard, NY",
  },
  {
    zip: "14589",
    ST: "NY",
    cityWithStateAbbr: "Williamson, NY",
  },
  {
    zip: "14590",
    ST: "NY",
    cityWithStateAbbr: "Wolcott, NY",
  },
  {
    zip: "14591",
    ST: "NY",
    cityWithStateAbbr: "Wyoming, NY",
  },
  {
    zip: "14592",
    ST: "NY",
    cityWithStateAbbr: "York, NY",
  },
  {
    zip: "14602",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14603",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14604",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14605",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14606",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14607",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14608",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14609",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14610",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14611",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14612",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14613",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14614",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14615",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14616",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14617",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14618",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14619",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14620",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14621",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14622",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14623",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14624",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14625",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14626",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14627",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14638",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14639",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14642",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14643",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14644",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14646",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14647",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14649",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14650",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14651",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14652",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14653",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14692",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14694",
    ST: "NY",
    cityWithStateAbbr: "Rochester, NY",
  },
  {
    zip: "14701",
    ST: "NY",
    cityWithStateAbbr: "Jamestown, NY",
  },
  {
    zip: "14702",
    ST: "NY",
    cityWithStateAbbr: "Jamestown, NY",
  },
  {
    zip: "14706",
    ST: "NY",
    cityWithStateAbbr: "Allegany, NY",
  },
  {
    zip: "14707",
    ST: "NY",
    cityWithStateAbbr: "Allentown, NY",
  },
  {
    zip: "14708",
    ST: "NY",
    cityWithStateAbbr: "Alma, NY",
  },
  {
    zip: "14709",
    ST: "NY",
    cityWithStateAbbr: "Angelica, NY",
  },
  {
    zip: "14710",
    ST: "NY",
    cityWithStateAbbr: "Ashville, NY",
  },
  {
    zip: "14711",
    ST: "NY",
    cityWithStateAbbr: "Belfast, NY",
  },
  {
    zip: "14712",
    ST: "NY",
    cityWithStateAbbr: "Bemus Point, NY",
  },
  {
    zip: "14714",
    ST: "NY",
    cityWithStateAbbr: "Black Creek, NY",
  },
  {
    zip: "14715",
    ST: "NY",
    cityWithStateAbbr: "Bolivar, NY",
  },
  {
    zip: "14716",
    ST: "NY",
    cityWithStateAbbr: "Brocton, NY",
  },
  {
    zip: "14717",
    ST: "NY",
    cityWithStateAbbr: "Caneadea, NY",
  },
  {
    zip: "14718",
    ST: "NY",
    cityWithStateAbbr: "Cassadaga, NY",
  },
  {
    zip: "14719",
    ST: "NY",
    cityWithStateAbbr: "Cattaraugus, NY",
  },
  {
    zip: "14720",
    ST: "NY",
    cityWithStateAbbr: "Celoron, NY",
  },
  {
    zip: "14721",
    ST: "NY",
    cityWithStateAbbr: "Ceres, NY",
  },
  {
    zip: "14722",
    ST: "NY",
    cityWithStateAbbr: "Chautauqua, NY",
  },
  {
    zip: "14723",
    ST: "NY",
    cityWithStateAbbr: "Cherry Creek, NY",
  },
  {
    zip: "14724",
    ST: "NY",
    cityWithStateAbbr: "Clymer, NY",
  },
  {
    zip: "14726",
    ST: "NY",
    cityWithStateAbbr: "Conewango Valley, NY",
  },
  {
    zip: "14727",
    ST: "NY",
    cityWithStateAbbr: "Cuba, NY",
  },
  {
    zip: "14728",
    ST: "NY",
    cityWithStateAbbr: "Dewittville, NY",
  },
  {
    zip: "14729",
    ST: "NY",
    cityWithStateAbbr: "East Otto, NY",
  },
  {
    zip: "14730",
    ST: "NY",
    cityWithStateAbbr: "East Randolph, NY",
  },
  {
    zip: "14731",
    ST: "NY",
    cityWithStateAbbr: "Ellicottville, NY",
  },
  {
    zip: "14732",
    ST: "NY",
    cityWithStateAbbr: "Ellington, NY",
  },
  {
    zip: "14733",
    ST: "NY",
    cityWithStateAbbr: "Falconer, NY",
  },
  {
    zip: "14735",
    ST: "NY",
    cityWithStateAbbr: "Fillmore, NY",
  },
  {
    zip: "14736",
    ST: "NY",
    cityWithStateAbbr: "Findley Lake, NY",
  },
  {
    zip: "14737",
    ST: "NY",
    cityWithStateAbbr: "Franklinville, NY",
  },
  {
    zip: "14738",
    ST: "NY",
    cityWithStateAbbr: "Frewsburg, NY",
  },
  {
    zip: "14739",
    ST: "NY",
    cityWithStateAbbr: "Friendship, NY",
  },
  {
    zip: "14740",
    ST: "NY",
    cityWithStateAbbr: "Gerry, NY",
  },
  {
    zip: "14741",
    ST: "NY",
    cityWithStateAbbr: "Great Valley, NY",
  },
  {
    zip: "14742",
    ST: "NY",
    cityWithStateAbbr: "Greenhurst, NY",
  },
  {
    zip: "14743",
    ST: "NY",
    cityWithStateAbbr: "Hinsdale, NY",
  },
  {
    zip: "14744",
    ST: "NY",
    cityWithStateAbbr: "Houghton, NY",
  },
  {
    zip: "14745",
    ST: "NY",
    cityWithStateAbbr: "Hume, NY",
  },
  {
    zip: "14747",
    ST: "NY",
    cityWithStateAbbr: "Kennedy, NY",
  },
  {
    zip: "14748",
    ST: "NY",
    cityWithStateAbbr: "Kill Buck, NY",
  },
  {
    zip: "14750",
    ST: "NY",
    cityWithStateAbbr: "Lakewood, NY",
  },
  {
    zip: "14751",
    ST: "NY",
    cityWithStateAbbr: "Leon, NY",
  },
  {
    zip: "14752",
    ST: "NY",
    cityWithStateAbbr: "Lily Dale, NY",
  },
  {
    zip: "14753",
    ST: "NY",
    cityWithStateAbbr: "Limestone, NY",
  },
  {
    zip: "14754",
    ST: "NY",
    cityWithStateAbbr: "Little Genesee, NY",
  },
  {
    zip: "14755",
    ST: "NY",
    cityWithStateAbbr: "Little Valley, NY",
  },
  {
    zip: "14756",
    ST: "NY",
    cityWithStateAbbr: "Maple Springs, NY",
  },
  {
    zip: "14757",
    ST: "NY",
    cityWithStateAbbr: "Mayville, NY",
  },
  {
    zip: "14758",
    ST: "NY",
    cityWithStateAbbr: "Niobe, NY",
  },
  {
    zip: "14760",
    ST: "NY",
    cityWithStateAbbr: "Olean, NY",
  },
  {
    zip: "14766",
    ST: "NY",
    cityWithStateAbbr: "Otto, NY",
  },
  {
    zip: "14767",
    ST: "NY",
    cityWithStateAbbr: "Panama, NY",
  },
  {
    zip: "14769",
    ST: "NY",
    cityWithStateAbbr: "Portland, NY",
  },
  {
    zip: "14770",
    ST: "NY",
    cityWithStateAbbr: "Portville, NY",
  },
  {
    zip: "14772",
    ST: "NY",
    cityWithStateAbbr: "Randolph, NY",
  },
  {
    zip: "14774",
    ST: "NY",
    cityWithStateAbbr: "Richburg, NY",
  },
  {
    zip: "14775",
    ST: "NY",
    cityWithStateAbbr: "Ripley, NY",
  },
  {
    zip: "14777",
    ST: "NY",
    cityWithStateAbbr: "Rushford, NY",
  },
  {
    zip: "14778",
    ST: "NY",
    cityWithStateAbbr: "Saint Bonaventure, NY",
  },
  {
    zip: "14779",
    ST: "NY",
    cityWithStateAbbr: "Salamanca, NY",
  },
  {
    zip: "14781",
    ST: "NY",
    cityWithStateAbbr: "Sherman, NY",
  },
  {
    zip: "14782",
    ST: "NY",
    cityWithStateAbbr: "Sinclairville, NY",
  },
  {
    zip: "14783",
    ST: "NY",
    cityWithStateAbbr: "Steamburg, NY",
  },
  {
    zip: "14784",
    ST: "NY",
    cityWithStateAbbr: "Stockton, NY",
  },
  {
    zip: "14785",
    ST: "NY",
    cityWithStateAbbr: "Stow, NY",
  },
  {
    zip: "14786",
    ST: "NY",
    cityWithStateAbbr: "West Clarksville, NY",
  },
  {
    zip: "14787",
    ST: "NY",
    cityWithStateAbbr: "Westfield, NY",
  },
  {
    zip: "14788",
    ST: "NY",
    cityWithStateAbbr: "Westons Mills, NY",
  },
  {
    zip: "14801",
    ST: "NY",
    cityWithStateAbbr: "Addison, NY",
  },
  {
    zip: "14802",
    ST: "NY",
    cityWithStateAbbr: "Alfred, NY",
  },
  {
    zip: "14803",
    ST: "NY",
    cityWithStateAbbr: "Alfred Station, NY",
  },
  {
    zip: "14804",
    ST: "NY",
    cityWithStateAbbr: "Almond, NY",
  },
  {
    zip: "14805",
    ST: "NY",
    cityWithStateAbbr: "Alpine, NY",
  },
  {
    zip: "14806",
    ST: "NY",
    cityWithStateAbbr: "Andover, NY",
  },
  {
    zip: "14807",
    ST: "NY",
    cityWithStateAbbr: "Arkport, NY",
  },
  {
    zip: "14808",
    ST: "NY",
    cityWithStateAbbr: "Atlanta, NY",
  },
  {
    zip: "14809",
    ST: "NY",
    cityWithStateAbbr: "Avoca, NY",
  },
  {
    zip: "14810",
    ST: "NY",
    cityWithStateAbbr: "Bath, NY",
  },
  {
    zip: "14812",
    ST: "NY",
    cityWithStateAbbr: "Beaver Dams, NY",
  },
  {
    zip: "14813",
    ST: "NY",
    cityWithStateAbbr: "Belmont, NY",
  },
  {
    zip: "14814",
    ST: "NY",
    cityWithStateAbbr: "Big Flats, NY",
  },
  {
    zip: "14815",
    ST: "NY",
    cityWithStateAbbr: "Bradford, NY",
  },
  {
    zip: "14816",
    ST: "NY",
    cityWithStateAbbr: "Breesport, NY",
  },
  {
    zip: "14817",
    ST: "NY",
    cityWithStateAbbr: "Brooktondale, NY",
  },
  {
    zip: "14818",
    ST: "NY",
    cityWithStateAbbr: "Burdett, NY",
  },
  {
    zip: "14819",
    ST: "NY",
    cityWithStateAbbr: "Cameron, NY",
  },
  {
    zip: "14820",
    ST: "NY",
    cityWithStateAbbr: "Cameron Mills, NY",
  },
  {
    zip: "14821",
    ST: "NY",
    cityWithStateAbbr: "Campbell, NY",
  },
  {
    zip: "14822",
    ST: "NY",
    cityWithStateAbbr: "Canaseraga, NY",
  },
  {
    zip: "14823",
    ST: "NY",
    cityWithStateAbbr: "Canisteo, NY",
  },
  {
    zip: "14824",
    ST: "NY",
    cityWithStateAbbr: "Cayuta, NY",
  },
  {
    zip: "14825",
    ST: "NY",
    cityWithStateAbbr: "Chemung, NY",
  },
  {
    zip: "14826",
    ST: "NY",
    cityWithStateAbbr: "Cohocton, NY",
  },
  {
    zip: "14827",
    ST: "NY",
    cityWithStateAbbr: "Coopers Plains, NY",
  },
  {
    zip: "14830",
    ST: "NY",
    cityWithStateAbbr: "Corning, NY",
  },
  {
    zip: "14831",
    ST: "NY",
    cityWithStateAbbr: "Corning, NY",
  },
  {
    zip: "14836",
    ST: "NY",
    cityWithStateAbbr: "Dalton, NY",
  },
  {
    zip: "14837",
    ST: "NY",
    cityWithStateAbbr: "Dundee, NY",
  },
  {
    zip: "14838",
    ST: "NY",
    cityWithStateAbbr: "Erin, NY",
  },
  {
    zip: "14839",
    ST: "NY",
    cityWithStateAbbr: "Greenwood, NY",
  },
  {
    zip: "14840",
    ST: "NY",
    cityWithStateAbbr: "Hammondsport, NY",
  },
  {
    zip: "14841",
    ST: "NY",
    cityWithStateAbbr: "Hector, NY",
  },
  {
    zip: "14842",
    ST: "NY",
    cityWithStateAbbr: "Himrod, NY",
  },
  {
    zip: "14843",
    ST: "NY",
    cityWithStateAbbr: "Hornell, NY",
  },
  {
    zip: "14845",
    ST: "NY",
    cityWithStateAbbr: "Horseheads, NY",
  },
  {
    zip: "14846",
    ST: "NY",
    cityWithStateAbbr: "Hunt, NY",
  },
  {
    zip: "14847",
    ST: "NY",
    cityWithStateAbbr: "Interlaken, NY",
  },
  {
    zip: "14850",
    ST: "NY",
    cityWithStateAbbr: "Ithaca, NY",
  },
  {
    zip: "14851",
    ST: "NY",
    cityWithStateAbbr: "Ithaca, NY",
  },
  {
    zip: "14852",
    ST: "NY",
    cityWithStateAbbr: "Ithaca, NY",
  },
  {
    zip: "14853",
    ST: "NY",
    cityWithStateAbbr: "Ithaca, NY",
  },
  {
    zip: "14854",
    ST: "NY",
    cityWithStateAbbr: "Jacksonville, NY",
  },
  {
    zip: "14855",
    ST: "NY",
    cityWithStateAbbr: "Jasper, NY",
  },
  {
    zip: "14856",
    ST: "NY",
    cityWithStateAbbr: "Kanona, NY",
  },
  {
    zip: "14857",
    ST: "NY",
    cityWithStateAbbr: "Lakemont, NY",
  },
  {
    zip: "14858",
    ST: "NY",
    cityWithStateAbbr: "Lindley, NY",
  },
  {
    zip: "14859",
    ST: "NY",
    cityWithStateAbbr: "Lockwood, NY",
  },
  {
    zip: "14860",
    ST: "NY",
    cityWithStateAbbr: "Lodi, NY",
  },
  {
    zip: "14861",
    ST: "NY",
    cityWithStateAbbr: "Lowman, NY",
  },
  {
    zip: "14863",
    ST: "NY",
    cityWithStateAbbr: "Mecklenburg, NY",
  },
  {
    zip: "14864",
    ST: "NY",
    cityWithStateAbbr: "Millport, NY",
  },
  {
    zip: "14865",
    ST: "NY",
    cityWithStateAbbr: "Montour Falls, NY",
  },
  {
    zip: "14867",
    ST: "NY",
    cityWithStateAbbr: "Newfield, NY",
  },
  {
    zip: "14869",
    ST: "NY",
    cityWithStateAbbr: "Odessa, NY",
  },
  {
    zip: "14870",
    ST: "NY",
    cityWithStateAbbr: "Painted Post, NY",
  },
  {
    zip: "14871",
    ST: "NY",
    cityWithStateAbbr: "Pine City, NY",
  },
  {
    zip: "14872",
    ST: "NY",
    cityWithStateAbbr: "Pine Valley, NY",
  },
  {
    zip: "14873",
    ST: "NY",
    cityWithStateAbbr: "Prattsburgh, NY",
  },
  {
    zip: "14874",
    ST: "NY",
    cityWithStateAbbr: "Pulteney, NY",
  },
  {
    zip: "14876",
    ST: "NY",
    cityWithStateAbbr: "Reading Center, NY",
  },
  {
    zip: "14877",
    ST: "NY",
    cityWithStateAbbr: "Rexville, NY",
  },
  {
    zip: "14878",
    ST: "NY",
    cityWithStateAbbr: "Rock Stream, NY",
  },
  {
    zip: "14879",
    ST: "NY",
    cityWithStateAbbr: "Savona, NY",
  },
  {
    zip: "14880",
    ST: "NY",
    cityWithStateAbbr: "Scio, NY",
  },
  {
    zip: "14881",
    ST: "NY",
    cityWithStateAbbr: "Slaterville Springs, NY",
  },
  {
    zip: "14882",
    ST: "NY",
    cityWithStateAbbr: "Lansing, NY",
  },
  {
    zip: "14883",
    ST: "NY",
    cityWithStateAbbr: "Spencer, NY",
  },
  {
    zip: "14884",
    ST: "NY",
    cityWithStateAbbr: "Swain, NY",
  },
  {
    zip: "14885",
    ST: "NY",
    cityWithStateAbbr: "Troupsburg, NY",
  },
  {
    zip: "14886",
    ST: "NY",
    cityWithStateAbbr: "Trumansburg, NY",
  },
  {
    zip: "14887",
    ST: "NY",
    cityWithStateAbbr: "Tyrone, NY",
  },
  {
    zip: "14889",
    ST: "NY",
    cityWithStateAbbr: "Van Etten, NY",
  },
  {
    zip: "14891",
    ST: "NY",
    cityWithStateAbbr: "Watkins Glen, NY",
  },
  {
    zip: "14892",
    ST: "NY",
    cityWithStateAbbr: "Waverly, NY",
  },
  {
    zip: "14893",
    ST: "NY",
    cityWithStateAbbr: "Wayne, NY",
  },
  {
    zip: "14894",
    ST: "NY",
    cityWithStateAbbr: "Wellsburg, NY",
  },
  {
    zip: "14895",
    ST: "NY",
    cityWithStateAbbr: "Wellsville, NY",
  },
  {
    zip: "14897",
    ST: "NY",
    cityWithStateAbbr: "Whitesville, NY",
  },
  {
    zip: "14898",
    ST: "NY",
    cityWithStateAbbr: "Woodhull, NY",
  },
  {
    zip: "14901",
    ST: "NY",
    cityWithStateAbbr: "Elmira, NY",
  },
  {
    zip: "14902",
    ST: "NY",
    cityWithStateAbbr: "Elmira, NY",
  },
  {
    zip: "14903",
    ST: "NY",
    cityWithStateAbbr: "Elmira, NY",
  },
  {
    zip: "14904",
    ST: "NY",
    cityWithStateAbbr: "Elmira, NY",
  },
  {
    zip: "14905",
    ST: "NY",
    cityWithStateAbbr: "Elmira, NY",
  },
  {
    zip: "14925",
    ST: "NY",
    cityWithStateAbbr: "Elmira, NY",
  },
  {
    zip: "15001",
    ST: "PA",
    cityWithStateAbbr: "Aliquippa, PA",
  },
  {
    zip: "15003",
    ST: "PA",
    cityWithStateAbbr: "Ambridge, PA",
  },
  {
    zip: "15004",
    ST: "PA",
    cityWithStateAbbr: "Atlasburg, PA",
  },
  {
    zip: "15005",
    ST: "PA",
    cityWithStateAbbr: "Baden, PA",
  },
  {
    zip: "15006",
    ST: "PA",
    cityWithStateAbbr: "Bairdford, PA",
  },
  {
    zip: "15007",
    ST: "PA",
    cityWithStateAbbr: "Bakerstown, PA",
  },
  {
    zip: "15009",
    ST: "PA",
    cityWithStateAbbr: "Beaver, PA",
  },
  {
    zip: "15010",
    ST: "PA",
    cityWithStateAbbr: "Beaver Falls, PA",
  },
  {
    zip: "15012",
    ST: "PA",
    cityWithStateAbbr: "Belle Vernon, PA",
  },
  {
    zip: "15014",
    ST: "PA",
    cityWithStateAbbr: "Brackenridge, PA",
  },
  {
    zip: "15015",
    ST: "PA",
    cityWithStateAbbr: "Bradfordwoods, PA",
  },
  {
    zip: "15017",
    ST: "PA",
    cityWithStateAbbr: "Bridgeville, PA",
  },
  {
    zip: "15018",
    ST: "PA",
    cityWithStateAbbr: "Buena Vista, PA",
  },
  {
    zip: "15019",
    ST: "PA",
    cityWithStateAbbr: "Bulger, PA",
  },
  {
    zip: "15020",
    ST: "PA",
    cityWithStateAbbr: "Bunola, PA",
  },
  {
    zip: "15021",
    ST: "PA",
    cityWithStateAbbr: "Burgettstown, PA",
  },
  {
    zip: "15022",
    ST: "PA",
    cityWithStateAbbr: "Charleroi, PA",
  },
  {
    zip: "15024",
    ST: "PA",
    cityWithStateAbbr: "Cheswick, PA",
  },
  {
    zip: "15025",
    ST: "PA",
    cityWithStateAbbr: "Clairton, PA",
  },
  {
    zip: "15026",
    ST: "PA",
    cityWithStateAbbr: "Clinton, PA",
  },
  {
    zip: "15027",
    ST: "PA",
    cityWithStateAbbr: "Conway, PA",
  },
  {
    zip: "15028",
    ST: "PA",
    cityWithStateAbbr: "Coulters, PA",
  },
  {
    zip: "15030",
    ST: "PA",
    cityWithStateAbbr: "Creighton, PA",
  },
  {
    zip: "15031",
    ST: "PA",
    cityWithStateAbbr: "Cuddy, PA",
  },
  {
    zip: "15032",
    ST: "PA",
    cityWithStateAbbr: "Curtisville, PA",
  },
  {
    zip: "15033",
    ST: "PA",
    cityWithStateAbbr: "Donora, PA",
  },
  {
    zip: "15034",
    ST: "PA",
    cityWithStateAbbr: "Dravosburg, PA",
  },
  {
    zip: "15035",
    ST: "PA",
    cityWithStateAbbr: "East Mc Keesport, PA",
  },
  {
    zip: "15037",
    ST: "PA",
    cityWithStateAbbr: "Elizabeth, PA",
  },
  {
    zip: "15038",
    ST: "PA",
    cityWithStateAbbr: "Elrama, PA",
  },
  {
    zip: "15042",
    ST: "PA",
    cityWithStateAbbr: "Freedom, PA",
  },
  {
    zip: "15043",
    ST: "PA",
    cityWithStateAbbr: "Georgetown, PA",
  },
  {
    zip: "15044",
    ST: "PA",
    cityWithStateAbbr: "Gibsonia, PA",
  },
  {
    zip: "15045",
    ST: "PA",
    cityWithStateAbbr: "Glassport, PA",
  },
  {
    zip: "15046",
    ST: "PA",
    cityWithStateAbbr: "Crescent, PA",
  },
  {
    zip: "15047",
    ST: "PA",
    cityWithStateAbbr: "Greenock, PA",
  },
  {
    zip: "15049",
    ST: "PA",
    cityWithStateAbbr: "Harwick, PA",
  },
  {
    zip: "15050",
    ST: "PA",
    cityWithStateAbbr: "Hookstown, PA",
  },
  {
    zip: "15051",
    ST: "PA",
    cityWithStateAbbr: "Indianola, PA",
  },
  {
    zip: "15052",
    ST: "PA",
    cityWithStateAbbr: "Industry, PA",
  },
  {
    zip: "15053",
    ST: "PA",
    cityWithStateAbbr: "Joffre, PA",
  },
  {
    zip: "15054",
    ST: "PA",
    cityWithStateAbbr: "Langeloth, PA",
  },
  {
    zip: "15055",
    ST: "PA",
    cityWithStateAbbr: "Lawrence, PA",
  },
  {
    zip: "15056",
    ST: "PA",
    cityWithStateAbbr: "Leetsdale, PA",
  },
  {
    zip: "15057",
    ST: "PA",
    cityWithStateAbbr: "Mc Donald, PA",
  },
  {
    zip: "15059",
    ST: "PA",
    cityWithStateAbbr: "Midland, PA",
  },
  {
    zip: "15060",
    ST: "PA",
    cityWithStateAbbr: "Midway, PA",
  },
  {
    zip: "15061",
    ST: "PA",
    cityWithStateAbbr: "Monaca, PA",
  },
  {
    zip: "15062",
    ST: "PA",
    cityWithStateAbbr: "Monessen, PA",
  },
  {
    zip: "15063",
    ST: "PA",
    cityWithStateAbbr: "Monongahela, PA",
  },
  {
    zip: "15064",
    ST: "PA",
    cityWithStateAbbr: "Morgan, PA",
  },
  {
    zip: "15065",
    ST: "PA",
    cityWithStateAbbr: "Natrona Heights, PA",
  },
  {
    zip: "15066",
    ST: "PA",
    cityWithStateAbbr: "New Brighton, PA",
  },
  {
    zip: "15067",
    ST: "PA",
    cityWithStateAbbr: "New Eagle, PA",
  },
  {
    zip: "15068",
    ST: "PA",
    cityWithStateAbbr: "New Kensington, PA",
  },
  {
    zip: "15069",
    ST: "PA",
    cityWithStateAbbr: "New Kensington, PA",
  },
  {
    zip: "15071",
    ST: "PA",
    cityWithStateAbbr: "Oakdale, PA",
  },
  {
    zip: "15072",
    ST: "PA",
    cityWithStateAbbr: "Pricedale, PA",
  },
  {
    zip: "15074",
    ST: "PA",
    cityWithStateAbbr: "Rochester, PA",
  },
  {
    zip: "15075",
    ST: "PA",
    cityWithStateAbbr: "Rural Ridge, PA",
  },
  {
    zip: "15076",
    ST: "PA",
    cityWithStateAbbr: "Russellton, PA",
  },
  {
    zip: "15077",
    ST: "PA",
    cityWithStateAbbr: "Shippingport, PA",
  },
  {
    zip: "15078",
    ST: "PA",
    cityWithStateAbbr: "Slovan, PA",
  },
  {
    zip: "15081",
    ST: "PA",
    cityWithStateAbbr: "South Heights, PA",
  },
  {
    zip: "15082",
    ST: "PA",
    cityWithStateAbbr: "Sturgeon, PA",
  },
  {
    zip: "15083",
    ST: "PA",
    cityWithStateAbbr: "Sutersville, PA",
  },
  {
    zip: "15084",
    ST: "PA",
    cityWithStateAbbr: "Tarentum, PA",
  },
  {
    zip: "15085",
    ST: "PA",
    cityWithStateAbbr: "Trafford, PA",
  },
  {
    zip: "15086",
    ST: "PA",
    cityWithStateAbbr: "Warrendale, PA",
  },
  {
    zip: "15087",
    ST: "PA",
    cityWithStateAbbr: "Webster, PA",
  },
  {
    zip: "15088",
    ST: "PA",
    cityWithStateAbbr: "West Elizabeth, PA",
  },
  {
    zip: "15089",
    ST: "PA",
    cityWithStateAbbr: "West Newton, PA",
  },
  {
    zip: "15090",
    ST: "PA",
    cityWithStateAbbr: "Wexford, PA",
  },
  {
    zip: "15091",
    ST: "PA",
    cityWithStateAbbr: "Wildwood, PA",
  },
  {
    zip: "15095",
    ST: "PA",
    cityWithStateAbbr: "Warrendale, PA",
  },
  {
    zip: "15096",
    ST: "PA",
    cityWithStateAbbr: "Warrendale, PA",
  },
  {
    zip: "15101",
    ST: "PA",
    cityWithStateAbbr: "Allison Park, PA",
  },
  {
    zip: "15102",
    ST: "PA",
    cityWithStateAbbr: "Bethel Park, PA",
  },
  {
    zip: "15104",
    ST: "PA",
    cityWithStateAbbr: "Braddock, PA",
  },
  {
    zip: "15106",
    ST: "PA",
    cityWithStateAbbr: "Carnegie, PA",
  },
  {
    zip: "15108",
    ST: "PA",
    cityWithStateAbbr: "Coraopolis, PA",
  },
  {
    zip: "15110",
    ST: "PA",
    cityWithStateAbbr: "Duquesne, PA",
  },
  {
    zip: "15112",
    ST: "PA",
    cityWithStateAbbr: "East Pittsburgh, PA",
  },
  {
    zip: "15116",
    ST: "PA",
    cityWithStateAbbr: "Glenshaw, PA",
  },
  {
    zip: "15120",
    ST: "PA",
    cityWithStateAbbr: "Homestead, PA",
  },
  {
    zip: "15122",
    ST: "PA",
    cityWithStateAbbr: "West Mifflin, PA",
  },
  {
    zip: "15123",
    ST: "PA",
    cityWithStateAbbr: "West Mifflin, PA",
  },
  {
    zip: "15126",
    ST: "PA",
    cityWithStateAbbr: "Imperial, PA",
  },
  {
    zip: "15127",
    ST: "PA",
    cityWithStateAbbr: "Ingomar, PA",
  },
  {
    zip: "15129",
    ST: "PA",
    cityWithStateAbbr: "South Park, PA",
  },
  {
    zip: "15131",
    ST: "PA",
    cityWithStateAbbr: "Mckeesport, PA",
  },
  {
    zip: "15132",
    ST: "PA",
    cityWithStateAbbr: "Mckeesport, PA",
  },
  {
    zip: "15133",
    ST: "PA",
    cityWithStateAbbr: "Mckeesport, PA",
  },
  {
    zip: "15134",
    ST: "PA",
    cityWithStateAbbr: "Mckeesport, PA",
  },
  {
    zip: "15135",
    ST: "PA",
    cityWithStateAbbr: "Mckeesport, PA",
  },
  {
    zip: "15136",
    ST: "PA",
    cityWithStateAbbr: "Mc Kees Rocks, PA",
  },
  {
    zip: "15137",
    ST: "PA",
    cityWithStateAbbr: "North Versailles, PA",
  },
  {
    zip: "15139",
    ST: "PA",
    cityWithStateAbbr: "Oakmont, PA",
  },
  {
    zip: "15140",
    ST: "PA",
    cityWithStateAbbr: "Pitcairn, PA",
  },
  {
    zip: "15142",
    ST: "PA",
    cityWithStateAbbr: "Presto, PA",
  },
  {
    zip: "15143",
    ST: "PA",
    cityWithStateAbbr: "Sewickley, PA",
  },
  {
    zip: "15144",
    ST: "PA",
    cityWithStateAbbr: "Springdale, PA",
  },
  {
    zip: "15145",
    ST: "PA",
    cityWithStateAbbr: "Turtle Creek, PA",
  },
  {
    zip: "15146",
    ST: "PA",
    cityWithStateAbbr: "Monroeville, PA",
  },
  {
    zip: "15147",
    ST: "PA",
    cityWithStateAbbr: "Verona, PA",
  },
  {
    zip: "15148",
    ST: "PA",
    cityWithStateAbbr: "Wilmerding, PA",
  },
  {
    zip: "15201",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15202",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15203",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15204",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15205",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15206",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15207",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15208",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15209",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15210",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15211",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15212",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15213",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15214",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15215",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15216",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15217",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15218",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15219",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15220",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15221",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15222",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15223",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15224",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15225",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15226",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15227",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15228",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15229",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15230",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15231",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15232",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15233",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15234",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15235",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15236",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15237",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15238",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15239",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15240",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15241",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15242",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15243",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15244",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15250",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15251",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15252",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15253",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15254",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15255",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15257",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15258",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15259",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15260",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15261",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15262",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15264",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15265",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15267",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15268",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15270",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15272",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15274",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15275",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15276",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15277",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15278",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15279",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15281",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15282",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15283",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15286",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15289",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15290",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15295",
    ST: "PA",
    cityWithStateAbbr: "Pittsburgh, PA",
  },
  {
    zip: "15301",
    ST: "PA",
    cityWithStateAbbr: "Washington, PA",
  },
  {
    zip: "15310",
    ST: "PA",
    cityWithStateAbbr: "Aleppo, PA",
  },
  {
    zip: "15311",
    ST: "PA",
    cityWithStateAbbr: "Amity, PA",
  },
  {
    zip: "15312",
    ST: "PA",
    cityWithStateAbbr: "Avella, PA",
  },
  {
    zip: "15313",
    ST: "PA",
    cityWithStateAbbr: "Beallsville, PA",
  },
  {
    zip: "15314",
    ST: "PA",
    cityWithStateAbbr: "Bentleyville, PA",
  },
  {
    zip: "15315",
    ST: "PA",
    cityWithStateAbbr: "Bobtown, PA",
  },
  {
    zip: "15316",
    ST: "PA",
    cityWithStateAbbr: "Brave, PA",
  },
  {
    zip: "15317",
    ST: "PA",
    cityWithStateAbbr: "Canonsburg, PA",
  },
  {
    zip: "15320",
    ST: "PA",
    cityWithStateAbbr: "Carmichaels, PA",
  },
  {
    zip: "15321",
    ST: "PA",
    cityWithStateAbbr: "Cecil, PA",
  },
  {
    zip: "15322",
    ST: "PA",
    cityWithStateAbbr: "Clarksville, PA",
  },
  {
    zip: "15323",
    ST: "PA",
    cityWithStateAbbr: "Claysville, PA",
  },
  {
    zip: "15324",
    ST: "PA",
    cityWithStateAbbr: "Cokeburg, PA",
  },
  {
    zip: "15325",
    ST: "PA",
    cityWithStateAbbr: "Crucible, PA",
  },
  {
    zip: "15327",
    ST: "PA",
    cityWithStateAbbr: "Dilliner, PA",
  },
  {
    zip: "15329",
    ST: "PA",
    cityWithStateAbbr: "Prosperity, PA",
  },
  {
    zip: "15330",
    ST: "PA",
    cityWithStateAbbr: "Eighty Four, PA",
  },
  {
    zip: "15331",
    ST: "PA",
    cityWithStateAbbr: "Ellsworth, PA",
  },
  {
    zip: "15332",
    ST: "PA",
    cityWithStateAbbr: "Finleyville, PA",
  },
  {
    zip: "15333",
    ST: "PA",
    cityWithStateAbbr: "Fredericktown, PA",
  },
  {
    zip: "15334",
    ST: "PA",
    cityWithStateAbbr: "Garards Fort, PA",
  },
  {
    zip: "15336",
    ST: "PA",
    cityWithStateAbbr: "Gastonville, PA",
  },
  {
    zip: "15337",
    ST: "PA",
    cityWithStateAbbr: "Graysville, PA",
  },
  {
    zip: "15338",
    ST: "PA",
    cityWithStateAbbr: "Greensboro, PA",
  },
  {
    zip: "15339",
    ST: "PA",
    cityWithStateAbbr: "Hendersonville, PA",
  },
  {
    zip: "15340",
    ST: "PA",
    cityWithStateAbbr: "Hickory, PA",
  },
  {
    zip: "15341",
    ST: "PA",
    cityWithStateAbbr: "Holbrook, PA",
  },
  {
    zip: "15342",
    ST: "PA",
    cityWithStateAbbr: "Houston, PA",
  },
  {
    zip: "15344",
    ST: "PA",
    cityWithStateAbbr: "Jefferson, PA",
  },
  {
    zip: "15345",
    ST: "PA",
    cityWithStateAbbr: "Marianna, PA",
  },
  {
    zip: "15346",
    ST: "PA",
    cityWithStateAbbr: "Mather, PA",
  },
  {
    zip: "15347",
    ST: "PA",
    cityWithStateAbbr: "Meadow Lands, PA",
  },
  {
    zip: "15348",
    ST: "PA",
    cityWithStateAbbr: "Millsboro, PA",
  },
  {
    zip: "15349",
    ST: "PA",
    cityWithStateAbbr: "Mount Morris, PA",
  },
  {
    zip: "15350",
    ST: "PA",
    cityWithStateAbbr: "Muse, PA",
  },
  {
    zip: "15351",
    ST: "PA",
    cityWithStateAbbr: "Nemacolin, PA",
  },
  {
    zip: "15352",
    ST: "PA",
    cityWithStateAbbr: "New Freeport, PA",
  },
  {
    zip: "15353",
    ST: "PA",
    cityWithStateAbbr: "Nineveh, PA",
  },
  {
    zip: "15357",
    ST: "PA",
    cityWithStateAbbr: "Rices Landing, PA",
  },
  {
    zip: "15358",
    ST: "PA",
    cityWithStateAbbr: "Richeyville, PA",
  },
  {
    zip: "15359",
    ST: "PA",
    cityWithStateAbbr: "Rogersville, PA",
  },
  {
    zip: "15360",
    ST: "PA",
    cityWithStateAbbr: "Scenery Hill, PA",
  },
  {
    zip: "15361",
    ST: "PA",
    cityWithStateAbbr: "Southview, PA",
  },
  {
    zip: "15362",
    ST: "PA",
    cityWithStateAbbr: "Spraggs, PA",
  },
  {
    zip: "15363",
    ST: "PA",
    cityWithStateAbbr: "Strabane, PA",
  },
  {
    zip: "15364",
    ST: "PA",
    cityWithStateAbbr: "Sycamore, PA",
  },
  {
    zip: "15365",
    ST: "PA",
    cityWithStateAbbr: "Taylorstown, PA",
  },
  {
    zip: "15366",
    ST: "PA",
    cityWithStateAbbr: "Van Voorhis, PA",
  },
  {
    zip: "15367",
    ST: "PA",
    cityWithStateAbbr: "Venetia, PA",
  },
  {
    zip: "15368",
    ST: "PA",
    cityWithStateAbbr: "Vestaburg, PA",
  },
  {
    zip: "15370",
    ST: "PA",
    cityWithStateAbbr: "Waynesburg, PA",
  },
  {
    zip: "15376",
    ST: "PA",
    cityWithStateAbbr: "West Alexander, PA",
  },
  {
    zip: "15377",
    ST: "PA",
    cityWithStateAbbr: "West Finley, PA",
  },
  {
    zip: "15378",
    ST: "PA",
    cityWithStateAbbr: "Westland, PA",
  },
  {
    zip: "15379",
    ST: "PA",
    cityWithStateAbbr: "West Middletown, PA",
  },
  {
    zip: "15380",
    ST: "PA",
    cityWithStateAbbr: "Wind Ridge, PA",
  },
  {
    zip: "15401",
    ST: "PA",
    cityWithStateAbbr: "Uniontown, PA",
  },
  {
    zip: "15410",
    ST: "PA",
    cityWithStateAbbr: "Adah, PA",
  },
  {
    zip: "15411",
    ST: "PA",
    cityWithStateAbbr: "Addison, PA",
  },
  {
    zip: "15412",
    ST: "PA",
    cityWithStateAbbr: "Allenport, PA",
  },
  {
    zip: "15413",
    ST: "PA",
    cityWithStateAbbr: "Allison, PA",
  },
  {
    zip: "15415",
    ST: "PA",
    cityWithStateAbbr: "Brier Hill, PA",
  },
  {
    zip: "15416",
    ST: "PA",
    cityWithStateAbbr: "Brownfield, PA",
  },
  {
    zip: "15417",
    ST: "PA",
    cityWithStateAbbr: "Brownsville, PA",
  },
  {
    zip: "15419",
    ST: "PA",
    cityWithStateAbbr: "California, PA",
  },
  {
    zip: "15420",
    ST: "PA",
    cityWithStateAbbr: "Cardale, PA",
  },
  {
    zip: "15421",
    ST: "PA",
    cityWithStateAbbr: "Chalk Hill, PA",
  },
  {
    zip: "15422",
    ST: "PA",
    cityWithStateAbbr: "Chestnut Ridge, PA",
  },
  {
    zip: "15423",
    ST: "PA",
    cityWithStateAbbr: "Coal Center, PA",
  },
  {
    zip: "15424",
    ST: "PA",
    cityWithStateAbbr: "Confluence, PA",
  },
  {
    zip: "15425",
    ST: "PA",
    cityWithStateAbbr: "Connellsville, PA",
  },
  {
    zip: "15427",
    ST: "PA",
    cityWithStateAbbr: "Daisytown, PA",
  },
  {
    zip: "15428",
    ST: "PA",
    cityWithStateAbbr: "Dawson, PA",
  },
  {
    zip: "15429",
    ST: "PA",
    cityWithStateAbbr: "Denbo, PA",
  },
  {
    zip: "15430",
    ST: "PA",
    cityWithStateAbbr: "Dickerson Run, PA",
  },
  {
    zip: "15431",
    ST: "PA",
    cityWithStateAbbr: "Dunbar, PA",
  },
  {
    zip: "15432",
    ST: "PA",
    cityWithStateAbbr: "Dunlevy, PA",
  },
  {
    zip: "15433",
    ST: "PA",
    cityWithStateAbbr: "East Millsboro, PA",
  },
  {
    zip: "15434",
    ST: "PA",
    cityWithStateAbbr: "Elco, PA",
  },
  {
    zip: "15435",
    ST: "PA",
    cityWithStateAbbr: "Fairbank, PA",
  },
  {
    zip: "15436",
    ST: "PA",
    cityWithStateAbbr: "Fairchance, PA",
  },
  {
    zip: "15437",
    ST: "PA",
    cityWithStateAbbr: "Farmington, PA",
  },
  {
    zip: "15438",
    ST: "PA",
    cityWithStateAbbr: "Fayette City, PA",
  },
  {
    zip: "15439",
    ST: "PA",
    cityWithStateAbbr: "Gans, PA",
  },
  {
    zip: "15440",
    ST: "PA",
    cityWithStateAbbr: "Gibbon Glade, PA",
  },
  {
    zip: "15442",
    ST: "PA",
    cityWithStateAbbr: "Grindstone, PA",
  },
  {
    zip: "15443",
    ST: "PA",
    cityWithStateAbbr: "Hibbs, PA",
  },
  {
    zip: "15444",
    ST: "PA",
    cityWithStateAbbr: "Hiller, PA",
  },
  {
    zip: "15445",
    ST: "PA",
    cityWithStateAbbr: "Hopwood, PA",
  },
  {
    zip: "15446",
    ST: "PA",
    cityWithStateAbbr: "Indian Head, PA",
  },
  {
    zip: "15447",
    ST: "PA",
    cityWithStateAbbr: "Isabella, PA",
  },
  {
    zip: "15448",
    ST: "PA",
    cityWithStateAbbr: "Jacobs Creek, PA",
  },
  {
    zip: "15449",
    ST: "PA",
    cityWithStateAbbr: "Keisterville, PA",
  },
  {
    zip: "15450",
    ST: "PA",
    cityWithStateAbbr: "La Belle, PA",
  },
  {
    zip: "15451",
    ST: "PA",
    cityWithStateAbbr: "Lake Lynn, PA",
  },
  {
    zip: "15454",
    ST: "PA",
    cityWithStateAbbr: "Leckrone, PA",
  },
  {
    zip: "15455",
    ST: "PA",
    cityWithStateAbbr: "Leisenring, PA",
  },
  {
    zip: "15456",
    ST: "PA",
    cityWithStateAbbr: "Lemont Furnace, PA",
  },
  {
    zip: "15458",
    ST: "PA",
    cityWithStateAbbr: "Mc Clellandtown, PA",
  },
  {
    zip: "15459",
    ST: "PA",
    cityWithStateAbbr: "Markleysburg, PA",
  },
  {
    zip: "15460",
    ST: "PA",
    cityWithStateAbbr: "Martin, PA",
  },
  {
    zip: "15461",
    ST: "PA",
    cityWithStateAbbr: "Masontown, PA",
  },
  {
    zip: "15462",
    ST: "PA",
    cityWithStateAbbr: "Melcroft, PA",
  },
  {
    zip: "15463",
    ST: "PA",
    cityWithStateAbbr: "Merrittstown, PA",
  },
  {
    zip: "15464",
    ST: "PA",
    cityWithStateAbbr: "Mill Run, PA",
  },
  {
    zip: "15465",
    ST: "PA",
    cityWithStateAbbr: "Mount Braddock, PA",
  },
  {
    zip: "15466",
    ST: "PA",
    cityWithStateAbbr: "Newell, PA",
  },
  {
    zip: "15467",
    ST: "PA",
    cityWithStateAbbr: "New Geneva, PA",
  },
  {
    zip: "15468",
    ST: "PA",
    cityWithStateAbbr: "New Salem, PA",
  },
  {
    zip: "15469",
    ST: "PA",
    cityWithStateAbbr: "Normalville, PA",
  },
  {
    zip: "15470",
    ST: "PA",
    cityWithStateAbbr: "Ohiopyle, PA",
  },
  {
    zip: "15472",
    ST: "PA",
    cityWithStateAbbr: "Oliver, PA",
  },
  {
    zip: "15473",
    ST: "PA",
    cityWithStateAbbr: "Perryopolis, PA",
  },
  {
    zip: "15474",
    ST: "PA",
    cityWithStateAbbr: "Point Marion, PA",
  },
  {
    zip: "15475",
    ST: "PA",
    cityWithStateAbbr: "Republic, PA",
  },
  {
    zip: "15476",
    ST: "PA",
    cityWithStateAbbr: "Ronco, PA",
  },
  {
    zip: "15477",
    ST: "PA",
    cityWithStateAbbr: "Roscoe, PA",
  },
  {
    zip: "15478",
    ST: "PA",
    cityWithStateAbbr: "Smithfield, PA",
  },
  {
    zip: "15479",
    ST: "PA",
    cityWithStateAbbr: "Smithton, PA",
  },
  {
    zip: "15480",
    ST: "PA",
    cityWithStateAbbr: "Smock, PA",
  },
  {
    zip: "15482",
    ST: "PA",
    cityWithStateAbbr: "Star Junction, PA",
  },
  {
    zip: "15483",
    ST: "PA",
    cityWithStateAbbr: "Stockdale, PA",
  },
  {
    zip: "15484",
    ST: "PA",
    cityWithStateAbbr: "Uledi, PA",
  },
  {
    zip: "15485",
    ST: "PA",
    cityWithStateAbbr: "Ursina, PA",
  },
  {
    zip: "15486",
    ST: "PA",
    cityWithStateAbbr: "Vanderbilt, PA",
  },
  {
    zip: "15488",
    ST: "PA",
    cityWithStateAbbr: "Waltersburg, PA",
  },
  {
    zip: "15489",
    ST: "PA",
    cityWithStateAbbr: "West Leisenring, PA",
  },
  {
    zip: "15490",
    ST: "PA",
    cityWithStateAbbr: "White, PA",
  },
  {
    zip: "15492",
    ST: "PA",
    cityWithStateAbbr: "Wickhaven, PA",
  },
  {
    zip: "15501",
    ST: "PA",
    cityWithStateAbbr: "Somerset, PA",
  },
  {
    zip: "15502",
    ST: "PA",
    cityWithStateAbbr: "Hidden Valley, PA",
  },
  {
    zip: "15510",
    ST: "PA",
    cityWithStateAbbr: "Somerset, PA",
  },
  {
    zip: "15520",
    ST: "PA",
    cityWithStateAbbr: "Acosta, PA",
  },
  {
    zip: "15521",
    ST: "PA",
    cityWithStateAbbr: "Alum Bank, PA",
  },
  {
    zip: "15522",
    ST: "PA",
    cityWithStateAbbr: "Bedford, PA",
  },
  {
    zip: "15530",
    ST: "PA",
    cityWithStateAbbr: "Berlin, PA",
  },
  {
    zip: "15531",
    ST: "PA",
    cityWithStateAbbr: "Boswell, PA",
  },
  {
    zip: "15532",
    ST: "PA",
    cityWithStateAbbr: "Boynton, PA",
  },
  {
    zip: "15533",
    ST: "PA",
    cityWithStateAbbr: "Breezewood, PA",
  },
  {
    zip: "15534",
    ST: "PA",
    cityWithStateAbbr: "Buffalo Mills, PA",
  },
  {
    zip: "15535",
    ST: "PA",
    cityWithStateAbbr: "Clearville, PA",
  },
  {
    zip: "15536",
    ST: "PA",
    cityWithStateAbbr: "Crystal Spring, PA",
  },
  {
    zip: "15537",
    ST: "PA",
    cityWithStateAbbr: "Everett, PA",
  },
  {
    zip: "15538",
    ST: "PA",
    cityWithStateAbbr: "Fairhope, PA",
  },
  {
    zip: "15539",
    ST: "PA",
    cityWithStateAbbr: "Fishertown, PA",
  },
  {
    zip: "15540",
    ST: "PA",
    cityWithStateAbbr: "Fort Hill, PA",
  },
  {
    zip: "15541",
    ST: "PA",
    cityWithStateAbbr: "Friedens, PA",
  },
  {
    zip: "15542",
    ST: "PA",
    cityWithStateAbbr: "Garrett, PA",
  },
  {
    zip: "15544",
    ST: "PA",
    cityWithStateAbbr: "Gray, PA",
  },
  {
    zip: "15545",
    ST: "PA",
    cityWithStateAbbr: "Hyndman, PA",
  },
  {
    zip: "15546",
    ST: "PA",
    cityWithStateAbbr: "Jenners, PA",
  },
  {
    zip: "15547",
    ST: "PA",
    cityWithStateAbbr: "Jennerstown, PA",
  },
  {
    zip: "15548",
    ST: "PA",
    cityWithStateAbbr: "Kantner, PA",
  },
  {
    zip: "15549",
    ST: "PA",
    cityWithStateAbbr: "Listie, PA",
  },
  {
    zip: "15550",
    ST: "PA",
    cityWithStateAbbr: "Manns Choice, PA",
  },
  {
    zip: "15551",
    ST: "PA",
    cityWithStateAbbr: "Markleton, PA",
  },
  {
    zip: "15552",
    ST: "PA",
    cityWithStateAbbr: "Meyersdale, PA",
  },
  {
    zip: "15553",
    ST: "PA",
    cityWithStateAbbr: "New Baltimore, PA",
  },
  {
    zip: "15554",
    ST: "PA",
    cityWithStateAbbr: "New Paris, PA",
  },
  {
    zip: "15555",
    ST: "PA",
    cityWithStateAbbr: "Quecreek, PA",
  },
  {
    zip: "15557",
    ST: "PA",
    cityWithStateAbbr: "Rockwood, PA",
  },
  {
    zip: "15558",
    ST: "PA",
    cityWithStateAbbr: "Salisbury, PA",
  },
  {
    zip: "15559",
    ST: "PA",
    cityWithStateAbbr: "Schellsburg, PA",
  },
  {
    zip: "15560",
    ST: "PA",
    cityWithStateAbbr: "Shanksville, PA",
  },
  {
    zip: "15561",
    ST: "PA",
    cityWithStateAbbr: "Sipesville, PA",
  },
  {
    zip: "15562",
    ST: "PA",
    cityWithStateAbbr: "Springs, PA",
  },
  {
    zip: "15563",
    ST: "PA",
    cityWithStateAbbr: "Stoystown, PA",
  },
  {
    zip: "15564",
    ST: "PA",
    cityWithStateAbbr: "Wellersburg, PA",
  },
  {
    zip: "15565",
    ST: "PA",
    cityWithStateAbbr: "West Salisbury, PA",
  },
  {
    zip: "15601",
    ST: "PA",
    cityWithStateAbbr: "Greensburg, PA",
  },
  {
    zip: "15605",
    ST: "PA",
    cityWithStateAbbr: "Greensburg, PA",
  },
  {
    zip: "15606",
    ST: "PA",
    cityWithStateAbbr: "Greensburg, PA",
  },
  {
    zip: "15610",
    ST: "PA",
    cityWithStateAbbr: "Acme, PA",
  },
  {
    zip: "15611",
    ST: "PA",
    cityWithStateAbbr: "Adamsburg, PA",
  },
  {
    zip: "15612",
    ST: "PA",
    cityWithStateAbbr: "Alverton, PA",
  },
  {
    zip: "15613",
    ST: "PA",
    cityWithStateAbbr: "Apollo, PA",
  },
  {
    zip: "15615",
    ST: "PA",
    cityWithStateAbbr: "Ardara, PA",
  },
  {
    zip: "15616",
    ST: "PA",
    cityWithStateAbbr: "Armbrust, PA",
  },
  {
    zip: "15617",
    ST: "PA",
    cityWithStateAbbr: "Arona, PA",
  },
  {
    zip: "15618",
    ST: "PA",
    cityWithStateAbbr: "Avonmore, PA",
  },
  {
    zip: "15619",
    ST: "PA",
    cityWithStateAbbr: "Bovard, PA",
  },
  {
    zip: "15620",
    ST: "PA",
    cityWithStateAbbr: "Bradenville, PA",
  },
  {
    zip: "15621",
    ST: "PA",
    cityWithStateAbbr: "Calumet, PA",
  },
  {
    zip: "15622",
    ST: "PA",
    cityWithStateAbbr: "Champion, PA",
  },
  {
    zip: "15623",
    ST: "PA",
    cityWithStateAbbr: "Claridge, PA",
  },
  {
    zip: "15624",
    ST: "PA",
    cityWithStateAbbr: "Crabtree, PA",
  },
  {
    zip: "15625",
    ST: "PA",
    cityWithStateAbbr: "Darragh, PA",
  },
  {
    zip: "15626",
    ST: "PA",
    cityWithStateAbbr: "Delmont, PA",
  },
  {
    zip: "15627",
    ST: "PA",
    cityWithStateAbbr: "Derry, PA",
  },
  {
    zip: "15628",
    ST: "PA",
    cityWithStateAbbr: "Donegal, PA",
  },
  {
    zip: "15629",
    ST: "PA",
    cityWithStateAbbr: "East Vandergrift, PA",
  },
  {
    zip: "15631",
    ST: "PA",
    cityWithStateAbbr: "Everson, PA",
  },
  {
    zip: "15632",
    ST: "PA",
    cityWithStateAbbr: "Export, PA",
  },
  {
    zip: "15633",
    ST: "PA",
    cityWithStateAbbr: "Forbes Road, PA",
  },
  {
    zip: "15634",
    ST: "PA",
    cityWithStateAbbr: "Grapeville, PA",
  },
  {
    zip: "15635",
    ST: "PA",
    cityWithStateAbbr: "Hannastown, PA",
  },
  {
    zip: "15636",
    ST: "PA",
    cityWithStateAbbr: "Harrison City, PA",
  },
  {
    zip: "15637",
    ST: "PA",
    cityWithStateAbbr: "Herminie, PA",
  },
  {
    zip: "15638",
    ST: "PA",
    cityWithStateAbbr: "Hostetter, PA",
  },
  {
    zip: "15639",
    ST: "PA",
    cityWithStateAbbr: "Hunker, PA",
  },
  {
    zip: "15640",
    ST: "PA",
    cityWithStateAbbr: "Hutchinson, PA",
  },
  {
    zip: "15641",
    ST: "PA",
    cityWithStateAbbr: "Hyde Park, PA",
  },
  {
    zip: "15642",
    ST: "PA",
    cityWithStateAbbr: "Irwin, PA",
  },
  {
    zip: "15644",
    ST: "PA",
    cityWithStateAbbr: "Jeannette, PA",
  },
  {
    zip: "15646",
    ST: "PA",
    cityWithStateAbbr: "Jones Mills, PA",
  },
  {
    zip: "15647",
    ST: "PA",
    cityWithStateAbbr: "Larimer, PA",
  },
  {
    zip: "15650",
    ST: "PA",
    cityWithStateAbbr: "Latrobe, PA",
  },
  {
    zip: "15655",
    ST: "PA",
    cityWithStateAbbr: "Laughlintown, PA",
  },
  {
    zip: "15656",
    ST: "PA",
    cityWithStateAbbr: "Leechburg, PA",
  },
  {
    zip: "15658",
    ST: "PA",
    cityWithStateAbbr: "Ligonier, PA",
  },
  {
    zip: "15660",
    ST: "PA",
    cityWithStateAbbr: "Lowber, PA",
  },
  {
    zip: "15661",
    ST: "PA",
    cityWithStateAbbr: "Loyalhanna, PA",
  },
  {
    zip: "15662",
    ST: "PA",
    cityWithStateAbbr: "Luxor, PA",
  },
  {
    zip: "15663",
    ST: "PA",
    cityWithStateAbbr: "Madison, PA",
  },
  {
    zip: "15664",
    ST: "PA",
    cityWithStateAbbr: "Mammoth, PA",
  },
  {
    zip: "15665",
    ST: "PA",
    cityWithStateAbbr: "Manor, PA",
  },
  {
    zip: "15666",
    ST: "PA",
    cityWithStateAbbr: "Mount Pleasant, PA",
  },
  {
    zip: "15668",
    ST: "PA",
    cityWithStateAbbr: "Murrysville, PA",
  },
  {
    zip: "15670",
    ST: "PA",
    cityWithStateAbbr: "New Alexandria, PA",
  },
  {
    zip: "15671",
    ST: "PA",
    cityWithStateAbbr: "New Derry, PA",
  },
  {
    zip: "15672",
    ST: "PA",
    cityWithStateAbbr: "New Stanton, PA",
  },
  {
    zip: "15673",
    ST: "PA",
    cityWithStateAbbr: "North Apollo, PA",
  },
  {
    zip: "15674",
    ST: "PA",
    cityWithStateAbbr: "Norvelt, PA",
  },
  {
    zip: "15675",
    ST: "PA",
    cityWithStateAbbr: "Penn, PA",
  },
  {
    zip: "15676",
    ST: "PA",
    cityWithStateAbbr: "Pleasant Unity, PA",
  },
  {
    zip: "15677",
    ST: "PA",
    cityWithStateAbbr: "Rector, PA",
  },
  {
    zip: "15678",
    ST: "PA",
    cityWithStateAbbr: "Rillton, PA",
  },
  {
    zip: "15679",
    ST: "PA",
    cityWithStateAbbr: "Ruffs Dale, PA",
  },
  {
    zip: "15680",
    ST: "PA",
    cityWithStateAbbr: "Salina, PA",
  },
  {
    zip: "15681",
    ST: "PA",
    cityWithStateAbbr: "Saltsburg, PA",
  },
  {
    zip: "15682",
    ST: "PA",
    cityWithStateAbbr: "Schenley, PA",
  },
  {
    zip: "15683",
    ST: "PA",
    cityWithStateAbbr: "Scottdale, PA",
  },
  {
    zip: "15684",
    ST: "PA",
    cityWithStateAbbr: "Slickville, PA",
  },
  {
    zip: "15685",
    ST: "PA",
    cityWithStateAbbr: "Southwest, PA",
  },
  {
    zip: "15686",
    ST: "PA",
    cityWithStateAbbr: "Spring Church, PA",
  },
  {
    zip: "15687",
    ST: "PA",
    cityWithStateAbbr: "Stahlstown, PA",
  },
  {
    zip: "15688",
    ST: "PA",
    cityWithStateAbbr: "Tarrs, PA",
  },
  {
    zip: "15689",
    ST: "PA",
    cityWithStateAbbr: "United, PA",
  },
  {
    zip: "15690",
    ST: "PA",
    cityWithStateAbbr: "Vandergrift, PA",
  },
  {
    zip: "15691",
    ST: "PA",
    cityWithStateAbbr: "Wendel, PA",
  },
  {
    zip: "15692",
    ST: "PA",
    cityWithStateAbbr: "Westmoreland City, PA",
  },
  {
    zip: "15693",
    ST: "PA",
    cityWithStateAbbr: "Whitney, PA",
  },
  {
    zip: "15695",
    ST: "PA",
    cityWithStateAbbr: "Wyano, PA",
  },
  {
    zip: "15696",
    ST: "PA",
    cityWithStateAbbr: "Youngstown, PA",
  },
  {
    zip: "15697",
    ST: "PA",
    cityWithStateAbbr: "Youngwood, PA",
  },
  {
    zip: "15698",
    ST: "PA",
    cityWithStateAbbr: "Yukon, PA",
  },
  {
    zip: "15701",
    ST: "PA",
    cityWithStateAbbr: "Indiana, PA",
  },
  {
    zip: "15705",
    ST: "PA",
    cityWithStateAbbr: "Indiana, PA",
  },
  {
    zip: "15710",
    ST: "PA",
    cityWithStateAbbr: "Alverda, PA",
  },
  {
    zip: "15711",
    ST: "PA",
    cityWithStateAbbr: "Anita, PA",
  },
  {
    zip: "15712",
    ST: "PA",
    cityWithStateAbbr: "Arcadia, PA",
  },
  {
    zip: "15713",
    ST: "PA",
    cityWithStateAbbr: "Aultman, PA",
  },
  {
    zip: "15714",
    ST: "PA",
    cityWithStateAbbr: "Northern Cambria, PA",
  },
  {
    zip: "15715",
    ST: "PA",
    cityWithStateAbbr: "Big Run, PA",
  },
  {
    zip: "15716",
    ST: "PA",
    cityWithStateAbbr: "Black Lick, PA",
  },
  {
    zip: "15717",
    ST: "PA",
    cityWithStateAbbr: "Blairsville, PA",
  },
  {
    zip: "15720",
    ST: "PA",
    cityWithStateAbbr: "Brush Valley, PA",
  },
  {
    zip: "15721",
    ST: "PA",
    cityWithStateAbbr: "Burnside, PA",
  },
  {
    zip: "15722",
    ST: "PA",
    cityWithStateAbbr: "Carrolltown, PA",
  },
  {
    zip: "15723",
    ST: "PA",
    cityWithStateAbbr: "Chambersville, PA",
  },
  {
    zip: "15724",
    ST: "PA",
    cityWithStateAbbr: "Cherry Tree, PA",
  },
  {
    zip: "15725",
    ST: "PA",
    cityWithStateAbbr: "Clarksburg, PA",
  },
  {
    zip: "15727",
    ST: "PA",
    cityWithStateAbbr: "Clune, PA",
  },
  {
    zip: "15728",
    ST: "PA",
    cityWithStateAbbr: "Clymer, PA",
  },
  {
    zip: "15729",
    ST: "PA",
    cityWithStateAbbr: "Commodore, PA",
  },
  {
    zip: "15730",
    ST: "PA",
    cityWithStateAbbr: "Coolspring, PA",
  },
  {
    zip: "15731",
    ST: "PA",
    cityWithStateAbbr: "Coral, PA",
  },
  {
    zip: "15732",
    ST: "PA",
    cityWithStateAbbr: "Creekside, PA",
  },
  {
    zip: "15733",
    ST: "PA",
    cityWithStateAbbr: "De Lancey, PA",
  },
  {
    zip: "15734",
    ST: "PA",
    cityWithStateAbbr: "Dixonville, PA",
  },
  {
    zip: "15736",
    ST: "PA",
    cityWithStateAbbr: "Elderton, PA",
  },
  {
    zip: "15737",
    ST: "PA",
    cityWithStateAbbr: "Elmora, PA",
  },
  {
    zip: "15738",
    ST: "PA",
    cityWithStateAbbr: "Emeigh, PA",
  },
  {
    zip: "15739",
    ST: "PA",
    cityWithStateAbbr: "Ernest, PA",
  },
  {
    zip: "15741",
    ST: "PA",
    cityWithStateAbbr: "Gipsy, PA",
  },
  {
    zip: "15742",
    ST: "PA",
    cityWithStateAbbr: "Glen Campbell, PA",
  },
  {
    zip: "15744",
    ST: "PA",
    cityWithStateAbbr: "Hamilton, PA",
  },
  {
    zip: "15745",
    ST: "PA",
    cityWithStateAbbr: "Heilwood, PA",
  },
  {
    zip: "15746",
    ST: "PA",
    cityWithStateAbbr: "Hillsdale, PA",
  },
  {
    zip: "15747",
    ST: "PA",
    cityWithStateAbbr: "Home, PA",
  },
  {
    zip: "15748",
    ST: "PA",
    cityWithStateAbbr: "Homer City, PA",
  },
  {
    zip: "15750",
    ST: "PA",
    cityWithStateAbbr: "Josephine, PA",
  },
  {
    zip: "15752",
    ST: "PA",
    cityWithStateAbbr: "Kent, PA",
  },
  {
    zip: "15753",
    ST: "PA",
    cityWithStateAbbr: "La Jose, PA",
  },
  {
    zip: "15754",
    ST: "PA",
    cityWithStateAbbr: "Lucernemines, PA",
  },
  {
    zip: "15756",
    ST: "PA",
    cityWithStateAbbr: "Mc Intyre, PA",
  },
  {
    zip: "15757",
    ST: "PA",
    cityWithStateAbbr: "Mahaffey, PA",
  },
  {
    zip: "15758",
    ST: "PA",
    cityWithStateAbbr: "Marchand, PA",
  },
  {
    zip: "15759",
    ST: "PA",
    cityWithStateAbbr: "Marion Center, PA",
  },
  {
    zip: "15760",
    ST: "PA",
    cityWithStateAbbr: "Marsteller, PA",
  },
  {
    zip: "15761",
    ST: "PA",
    cityWithStateAbbr: "Mentcle, PA",
  },
  {
    zip: "15762",
    ST: "PA",
    cityWithStateAbbr: "Nicktown, PA",
  },
  {
    zip: "15763",
    ST: "PA",
    cityWithStateAbbr: "Northpoint, PA",
  },
  {
    zip: "15764",
    ST: "PA",
    cityWithStateAbbr: "Oliveburg, PA",
  },
  {
    zip: "15765",
    ST: "PA",
    cityWithStateAbbr: "Penn Run, PA",
  },
  {
    zip: "15767",
    ST: "PA",
    cityWithStateAbbr: "Punxsutawney, PA",
  },
  {
    zip: "15770",
    ST: "PA",
    cityWithStateAbbr: "Ringgold, PA",
  },
  {
    zip: "15771",
    ST: "PA",
    cityWithStateAbbr: "Rochester Mills, PA",
  },
  {
    zip: "15772",
    ST: "PA",
    cityWithStateAbbr: "Rossiter, PA",
  },
  {
    zip: "15773",
    ST: "PA",
    cityWithStateAbbr: "Saint Benedict, PA",
  },
  {
    zip: "15774",
    ST: "PA",
    cityWithStateAbbr: "Shelocta, PA",
  },
  {
    zip: "15775",
    ST: "PA",
    cityWithStateAbbr: "Spangler, PA",
  },
  {
    zip: "15776",
    ST: "PA",
    cityWithStateAbbr: "Sprankle Mills, PA",
  },
  {
    zip: "15777",
    ST: "PA",
    cityWithStateAbbr: "Starford, PA",
  },
  {
    zip: "15778",
    ST: "PA",
    cityWithStateAbbr: "Timblin, PA",
  },
  {
    zip: "15779",
    ST: "PA",
    cityWithStateAbbr: "Torrance, PA",
  },
  {
    zip: "15780",
    ST: "PA",
    cityWithStateAbbr: "Valier, PA",
  },
  {
    zip: "15781",
    ST: "PA",
    cityWithStateAbbr: "Walston, PA",
  },
  {
    zip: "15783",
    ST: "PA",
    cityWithStateAbbr: "West Lebanon, PA",
  },
  {
    zip: "15784",
    ST: "PA",
    cityWithStateAbbr: "Worthville, PA",
  },
  {
    zip: "15801",
    ST: "PA",
    cityWithStateAbbr: "Du Bois, PA",
  },
  {
    zip: "15821",
    ST: "PA",
    cityWithStateAbbr: "Benezett, PA",
  },
  {
    zip: "15822",
    ST: "PA",
    cityWithStateAbbr: "Brandy Camp, PA",
  },
  {
    zip: "15823",
    ST: "PA",
    cityWithStateAbbr: "Brockport, PA",
  },
  {
    zip: "15824",
    ST: "PA",
    cityWithStateAbbr: "Brockway, PA",
  },
  {
    zip: "15825",
    ST: "PA",
    cityWithStateAbbr: "Brookville, PA",
  },
  {
    zip: "15827",
    ST: "PA",
    cityWithStateAbbr: "Byrnedale, PA",
  },
  {
    zip: "15828",
    ST: "PA",
    cityWithStateAbbr: "Clarington, PA",
  },
  {
    zip: "15829",
    ST: "PA",
    cityWithStateAbbr: "Corsica, PA",
  },
  {
    zip: "15831",
    ST: "PA",
    cityWithStateAbbr: "Dagus Mines, PA",
  },
  {
    zip: "15832",
    ST: "PA",
    cityWithStateAbbr: "Driftwood, PA",
  },
  {
    zip: "15834",
    ST: "PA",
    cityWithStateAbbr: "Emporium, PA",
  },
  {
    zip: "15840",
    ST: "PA",
    cityWithStateAbbr: "Falls Creek, PA",
  },
  {
    zip: "15841",
    ST: "PA",
    cityWithStateAbbr: "Force, PA",
  },
  {
    zip: "15845",
    ST: "PA",
    cityWithStateAbbr: "Johnsonburg, PA",
  },
  {
    zip: "15846",
    ST: "PA",
    cityWithStateAbbr: "Kersey, PA",
  },
  {
    zip: "15847",
    ST: "PA",
    cityWithStateAbbr: "Knox Dale, PA",
  },
  {
    zip: "15848",
    ST: "PA",
    cityWithStateAbbr: "Luthersburg, PA",
  },
  {
    zip: "15849",
    ST: "PA",
    cityWithStateAbbr: "Penfield, PA",
  },
  {
    zip: "15851",
    ST: "PA",
    cityWithStateAbbr: "Reynoldsville, PA",
  },
  {
    zip: "15853",
    ST: "PA",
    cityWithStateAbbr: "Ridgway, PA",
  },
  {
    zip: "15856",
    ST: "PA",
    cityWithStateAbbr: "Rockton, PA",
  },
  {
    zip: "15857",
    ST: "PA",
    cityWithStateAbbr: "Saint Marys, PA",
  },
  {
    zip: "15860",
    ST: "PA",
    cityWithStateAbbr: "Sigel, PA",
  },
  {
    zip: "15861",
    ST: "PA",
    cityWithStateAbbr: "Sinnamahoning, PA",
  },
  {
    zip: "15863",
    ST: "PA",
    cityWithStateAbbr: "Stump Creek, PA",
  },
  {
    zip: "15864",
    ST: "PA",
    cityWithStateAbbr: "Summerville, PA",
  },
  {
    zip: "15865",
    ST: "PA",
    cityWithStateAbbr: "Sykesville, PA",
  },
  {
    zip: "15866",
    ST: "PA",
    cityWithStateAbbr: "Troutville, PA",
  },
  {
    zip: "15868",
    ST: "PA",
    cityWithStateAbbr: "Weedville, PA",
  },
  {
    zip: "15870",
    ST: "PA",
    cityWithStateAbbr: "Wilcox, PA",
  },
  {
    zip: "15901",
    ST: "PA",
    cityWithStateAbbr: "Johnstown, PA",
  },
  {
    zip: "15902",
    ST: "PA",
    cityWithStateAbbr: "Johnstown, PA",
  },
  {
    zip: "15904",
    ST: "PA",
    cityWithStateAbbr: "Johnstown, PA",
  },
  {
    zip: "15905",
    ST: "PA",
    cityWithStateAbbr: "Johnstown, PA",
  },
  {
    zip: "15906",
    ST: "PA",
    cityWithStateAbbr: "Johnstown, PA",
  },
  {
    zip: "15907",
    ST: "PA",
    cityWithStateAbbr: "Johnstown, PA",
  },
  {
    zip: "15909",
    ST: "PA",
    cityWithStateAbbr: "Johnstown, PA",
  },
  {
    zip: "15915",
    ST: "PA",
    cityWithStateAbbr: "Johnstown, PA",
  },
  {
    zip: "15920",
    ST: "PA",
    cityWithStateAbbr: "Armagh, PA",
  },
  {
    zip: "15921",
    ST: "PA",
    cityWithStateAbbr: "Beaverdale, PA",
  },
  {
    zip: "15922",
    ST: "PA",
    cityWithStateAbbr: "Belsano, PA",
  },
  {
    zip: "15923",
    ST: "PA",
    cityWithStateAbbr: "Bolivar, PA",
  },
  {
    zip: "15924",
    ST: "PA",
    cityWithStateAbbr: "Cairnbrook, PA",
  },
  {
    zip: "15925",
    ST: "PA",
    cityWithStateAbbr: "Cassandra, PA",
  },
  {
    zip: "15926",
    ST: "PA",
    cityWithStateAbbr: "Central City, PA",
  },
  {
    zip: "15927",
    ST: "PA",
    cityWithStateAbbr: "Colver, PA",
  },
  {
    zip: "15928",
    ST: "PA",
    cityWithStateAbbr: "Davidsville, PA",
  },
  {
    zip: "15929",
    ST: "PA",
    cityWithStateAbbr: "Dilltown, PA",
  },
  {
    zip: "15930",
    ST: "PA",
    cityWithStateAbbr: "Dunlo, PA",
  },
  {
    zip: "15931",
    ST: "PA",
    cityWithStateAbbr: "Ebensburg, PA",
  },
  {
    zip: "15934",
    ST: "PA",
    cityWithStateAbbr: "Elton, PA",
  },
  {
    zip: "15935",
    ST: "PA",
    cityWithStateAbbr: "Hollsopple, PA",
  },
  {
    zip: "15936",
    ST: "PA",
    cityWithStateAbbr: "Hooversville, PA",
  },
  {
    zip: "15937",
    ST: "PA",
    cityWithStateAbbr: "Jerome, PA",
  },
  {
    zip: "15938",
    ST: "PA",
    cityWithStateAbbr: "Lilly, PA",
  },
  {
    zip: "15940",
    ST: "PA",
    cityWithStateAbbr: "Loretto, PA",
  },
  {
    zip: "15942",
    ST: "PA",
    cityWithStateAbbr: "Mineral Point, PA",
  },
  {
    zip: "15943",
    ST: "PA",
    cityWithStateAbbr: "Nanty Glo, PA",
  },
  {
    zip: "15944",
    ST: "PA",
    cityWithStateAbbr: "New Florence, PA",
  },
  {
    zip: "15945",
    ST: "PA",
    cityWithStateAbbr: "Parkhill, PA",
  },
  {
    zip: "15946",
    ST: "PA",
    cityWithStateAbbr: "Portage, PA",
  },
  {
    zip: "15948",
    ST: "PA",
    cityWithStateAbbr: "Revloc, PA",
  },
  {
    zip: "15949",
    ST: "PA",
    cityWithStateAbbr: "Robinson, PA",
  },
  {
    zip: "15951",
    ST: "PA",
    cityWithStateAbbr: "Saint Michael, PA",
  },
  {
    zip: "15952",
    ST: "PA",
    cityWithStateAbbr: "Salix, PA",
  },
  {
    zip: "15953",
    ST: "PA",
    cityWithStateAbbr: "Seanor, PA",
  },
  {
    zip: "15954",
    ST: "PA",
    cityWithStateAbbr: "Seward, PA",
  },
  {
    zip: "15955",
    ST: "PA",
    cityWithStateAbbr: "Sidman, PA",
  },
  {
    zip: "15956",
    ST: "PA",
    cityWithStateAbbr: "South Fork, PA",
  },
  {
    zip: "15957",
    ST: "PA",
    cityWithStateAbbr: "Strongstown, PA",
  },
  {
    zip: "15958",
    ST: "PA",
    cityWithStateAbbr: "Summerhill, PA",
  },
  {
    zip: "15959",
    ST: "PA",
    cityWithStateAbbr: "Tire Hill, PA",
  },
  {
    zip: "15960",
    ST: "PA",
    cityWithStateAbbr: "Twin Rocks, PA",
  },
  {
    zip: "15961",
    ST: "PA",
    cityWithStateAbbr: "Vintondale, PA",
  },
  {
    zip: "15962",
    ST: "PA",
    cityWithStateAbbr: "Wilmore, PA",
  },
  {
    zip: "15963",
    ST: "PA",
    cityWithStateAbbr: "Windber, PA",
  },
  {
    zip: "16001",
    ST: "PA",
    cityWithStateAbbr: "Butler, PA",
  },
  {
    zip: "16002",
    ST: "PA",
    cityWithStateAbbr: "Butler, PA",
  },
  {
    zip: "16003",
    ST: "PA",
    cityWithStateAbbr: "Butler, PA",
  },
  {
    zip: "16016",
    ST: "PA",
    cityWithStateAbbr: "Boyers, PA",
  },
  {
    zip: "16017",
    ST: "PA",
    cityWithStateAbbr: "Boyers, PA",
  },
  {
    zip: "16018",
    ST: "PA",
    cityWithStateAbbr: "Boyers, PA",
  },
  {
    zip: "16020",
    ST: "PA",
    cityWithStateAbbr: "Boyers, PA",
  },
  {
    zip: "16021",
    ST: "PA",
    cityWithStateAbbr: "Branchton, PA",
  },
  {
    zip: "16022",
    ST: "PA",
    cityWithStateAbbr: "Bruin, PA",
  },
  {
    zip: "16023",
    ST: "PA",
    cityWithStateAbbr: "Cabot, PA",
  },
  {
    zip: "16024",
    ST: "PA",
    cityWithStateAbbr: "Callery, PA",
  },
  {
    zip: "16025",
    ST: "PA",
    cityWithStateAbbr: "Chicora, PA",
  },
  {
    zip: "16027",
    ST: "PA",
    cityWithStateAbbr: "Connoquenessing, PA",
  },
  {
    zip: "16028",
    ST: "PA",
    cityWithStateAbbr: "East Brady, PA",
  },
  {
    zip: "16029",
    ST: "PA",
    cityWithStateAbbr: "East Butler, PA",
  },
  {
    zip: "16030",
    ST: "PA",
    cityWithStateAbbr: "Eau Claire, PA",
  },
  {
    zip: "16033",
    ST: "PA",
    cityWithStateAbbr: "Evans City, PA",
  },
  {
    zip: "16034",
    ST: "PA",
    cityWithStateAbbr: "Fenelton, PA",
  },
  {
    zip: "16035",
    ST: "PA",
    cityWithStateAbbr: "Forestville, PA",
  },
  {
    zip: "16036",
    ST: "PA",
    cityWithStateAbbr: "Foxburg, PA",
  },
  {
    zip: "16037",
    ST: "PA",
    cityWithStateAbbr: "Harmony, PA",
  },
  {
    zip: "16038",
    ST: "PA",
    cityWithStateAbbr: "Harrisville, PA",
  },
  {
    zip: "16039",
    ST: "PA",
    cityWithStateAbbr: "Herman, PA",
  },
  {
    zip: "16040",
    ST: "PA",
    cityWithStateAbbr: "Hilliards, PA",
  },
  {
    zip: "16041",
    ST: "PA",
    cityWithStateAbbr: "Karns City, PA",
  },
  {
    zip: "16045",
    ST: "PA",
    cityWithStateAbbr: "Lyndora, PA",
  },
  {
    zip: "16046",
    ST: "PA",
    cityWithStateAbbr: "Mars, PA",
  },
  {
    zip: "16048",
    ST: "PA",
    cityWithStateAbbr: "North Washington, PA",
  },
  {
    zip: "16049",
    ST: "PA",
    cityWithStateAbbr: "Parker, PA",
  },
  {
    zip: "16050",
    ST: "PA",
    cityWithStateAbbr: "Petrolia, PA",
  },
  {
    zip: "16051",
    ST: "PA",
    cityWithStateAbbr: "Portersville, PA",
  },
  {
    zip: "16052",
    ST: "PA",
    cityWithStateAbbr: "Prospect, PA",
  },
  {
    zip: "16053",
    ST: "PA",
    cityWithStateAbbr: "Renfrew, PA",
  },
  {
    zip: "16054",
    ST: "PA",
    cityWithStateAbbr: "Saint Petersburg, PA",
  },
  {
    zip: "16055",
    ST: "PA",
    cityWithStateAbbr: "Sarver, PA",
  },
  {
    zip: "16056",
    ST: "PA",
    cityWithStateAbbr: "Saxonburg, PA",
  },
  {
    zip: "16057",
    ST: "PA",
    cityWithStateAbbr: "Slippery Rock, PA",
  },
  {
    zip: "16058",
    ST: "PA",
    cityWithStateAbbr: "Turkey City, PA",
  },
  {
    zip: "16059",
    ST: "PA",
    cityWithStateAbbr: "Valencia, PA",
  },
  {
    zip: "16061",
    ST: "PA",
    cityWithStateAbbr: "West Sunbury, PA",
  },
  {
    zip: "16063",
    ST: "PA",
    cityWithStateAbbr: "Zelienople, PA",
  },
  {
    zip: "16066",
    ST: "PA",
    cityWithStateAbbr: "Cranberry Township, PA",
  },
  {
    zip: "16101",
    ST: "PA",
    cityWithStateAbbr: "New Castle, PA",
  },
  {
    zip: "16102",
    ST: "PA",
    cityWithStateAbbr: "New Castle, PA",
  },
  {
    zip: "16103",
    ST: "PA",
    cityWithStateAbbr: "New Castle, PA",
  },
  {
    zip: "16105",
    ST: "PA",
    cityWithStateAbbr: "New Castle, PA",
  },
  {
    zip: "16107",
    ST: "PA",
    cityWithStateAbbr: "New Castle, PA",
  },
  {
    zip: "16108",
    ST: "PA",
    cityWithStateAbbr: "New Castle, PA",
  },
  {
    zip: "16110",
    ST: "PA",
    cityWithStateAbbr: "Adamsville, PA",
  },
  {
    zip: "16111",
    ST: "PA",
    cityWithStateAbbr: "Atlantic, PA",
  },
  {
    zip: "16112",
    ST: "PA",
    cityWithStateAbbr: "Bessemer, PA",
  },
  {
    zip: "16113",
    ST: "PA",
    cityWithStateAbbr: "Clark, PA",
  },
  {
    zip: "16114",
    ST: "PA",
    cityWithStateAbbr: "Clarks Mills, PA",
  },
  {
    zip: "16115",
    ST: "PA",
    cityWithStateAbbr: "Darlington, PA",
  },
  {
    zip: "16116",
    ST: "PA",
    cityWithStateAbbr: "Edinburg, PA",
  },
  {
    zip: "16117",
    ST: "PA",
    cityWithStateAbbr: "Ellwood City, PA",
  },
  {
    zip: "16120",
    ST: "PA",
    cityWithStateAbbr: "Enon Valley, PA",
  },
  {
    zip: "16121",
    ST: "PA",
    cityWithStateAbbr: "Farrell, PA",
  },
  {
    zip: "16123",
    ST: "PA",
    cityWithStateAbbr: "Fombell, PA",
  },
  {
    zip: "16124",
    ST: "PA",
    cityWithStateAbbr: "Fredonia, PA",
  },
  {
    zip: "16125",
    ST: "PA",
    cityWithStateAbbr: "Greenville, PA",
  },
  {
    zip: "16127",
    ST: "PA",
    cityWithStateAbbr: "Grove City, PA",
  },
  {
    zip: "16130",
    ST: "PA",
    cityWithStateAbbr: "Hadley, PA",
  },
  {
    zip: "16131",
    ST: "PA",
    cityWithStateAbbr: "Hartstown, PA",
  },
  {
    zip: "16132",
    ST: "PA",
    cityWithStateAbbr: "Hillsville, PA",
  },
  {
    zip: "16133",
    ST: "PA",
    cityWithStateAbbr: "Jackson Center, PA",
  },
  {
    zip: "16134",
    ST: "PA",
    cityWithStateAbbr: "Jamestown, PA",
  },
  {
    zip: "16136",
    ST: "PA",
    cityWithStateAbbr: "Koppel, PA",
  },
  {
    zip: "16137",
    ST: "PA",
    cityWithStateAbbr: "Mercer, PA",
  },
  {
    zip: "16140",
    ST: "PA",
    cityWithStateAbbr: "New Bedford, PA",
  },
  {
    zip: "16141",
    ST: "PA",
    cityWithStateAbbr: "New Galilee, PA",
  },
  {
    zip: "16142",
    ST: "PA",
    cityWithStateAbbr: "New Wilmington, PA",
  },
  {
    zip: "16143",
    ST: "PA",
    cityWithStateAbbr: "Pulaski, PA",
  },
  {
    zip: "16145",
    ST: "PA",
    cityWithStateAbbr: "Sandy Lake, PA",
  },
  {
    zip: "16146",
    ST: "PA",
    cityWithStateAbbr: "Sharon, PA",
  },
  {
    zip: "16148",
    ST: "PA",
    cityWithStateAbbr: "Hermitage, PA",
  },
  {
    zip: "16150",
    ST: "PA",
    cityWithStateAbbr: "Sharpsville, PA",
  },
  {
    zip: "16151",
    ST: "PA",
    cityWithStateAbbr: "Sheakleyville, PA",
  },
  {
    zip: "16153",
    ST: "PA",
    cityWithStateAbbr: "Stoneboro, PA",
  },
  {
    zip: "16154",
    ST: "PA",
    cityWithStateAbbr: "Transfer, PA",
  },
  {
    zip: "16155",
    ST: "PA",
    cityWithStateAbbr: "Villa Maria, PA",
  },
  {
    zip: "16156",
    ST: "PA",
    cityWithStateAbbr: "Volant, PA",
  },
  {
    zip: "16157",
    ST: "PA",
    cityWithStateAbbr: "Wampum, PA",
  },
  {
    zip: "16159",
    ST: "PA",
    cityWithStateAbbr: "West Middlesex, PA",
  },
  {
    zip: "16160",
    ST: "PA",
    cityWithStateAbbr: "West Pittsburg, PA",
  },
  {
    zip: "16161",
    ST: "PA",
    cityWithStateAbbr: "Wheatland, PA",
  },
  {
    zip: "16172",
    ST: "PA",
    cityWithStateAbbr: "New Wilmington, PA",
  },
  {
    zip: "16201",
    ST: "PA",
    cityWithStateAbbr: "Kittanning, PA",
  },
  {
    zip: "16210",
    ST: "PA",
    cityWithStateAbbr: "Adrian, PA",
  },
  {
    zip: "16211",
    ST: "PA",
    cityWithStateAbbr: "Beyer, PA",
  },
  {
    zip: "16212",
    ST: "PA",
    cityWithStateAbbr: "Cadogan, PA",
  },
  {
    zip: "16213",
    ST: "PA",
    cityWithStateAbbr: "Callensburg, PA",
  },
  {
    zip: "16214",
    ST: "PA",
    cityWithStateAbbr: "Clarion, PA",
  },
  {
    zip: "16217",
    ST: "PA",
    cityWithStateAbbr: "Cooksburg, PA",
  },
  {
    zip: "16218",
    ST: "PA",
    cityWithStateAbbr: "Cowansville, PA",
  },
  {
    zip: "16220",
    ST: "PA",
    cityWithStateAbbr: "Crown, PA",
  },
  {
    zip: "16221",
    ST: "PA",
    cityWithStateAbbr: "Curllsville, PA",
  },
  {
    zip: "16222",
    ST: "PA",
    cityWithStateAbbr: "Dayton, PA",
  },
  {
    zip: "16223",
    ST: "PA",
    cityWithStateAbbr: "Distant, PA",
  },
  {
    zip: "16224",
    ST: "PA",
    cityWithStateAbbr: "Fairmount City, PA",
  },
  {
    zip: "16225",
    ST: "PA",
    cityWithStateAbbr: "Fisher, PA",
  },
  {
    zip: "16226",
    ST: "PA",
    cityWithStateAbbr: "Ford City, PA",
  },
  {
    zip: "16228",
    ST: "PA",
    cityWithStateAbbr: "Ford Cliff, PA",
  },
  {
    zip: "16229",
    ST: "PA",
    cityWithStateAbbr: "Freeport, PA",
  },
  {
    zip: "16230",
    ST: "PA",
    cityWithStateAbbr: "Hawthorn, PA",
  },
  {
    zip: "16232",
    ST: "PA",
    cityWithStateAbbr: "Knox, PA",
  },
  {
    zip: "16233",
    ST: "PA",
    cityWithStateAbbr: "Leeper, PA",
  },
  {
    zip: "16234",
    ST: "PA",
    cityWithStateAbbr: "Limestone, PA",
  },
  {
    zip: "16235",
    ST: "PA",
    cityWithStateAbbr: "Lucinda, PA",
  },
  {
    zip: "16236",
    ST: "PA",
    cityWithStateAbbr: "Mc Grann, PA",
  },
  {
    zip: "16238",
    ST: "PA",
    cityWithStateAbbr: "Manorville, PA",
  },
  {
    zip: "16239",
    ST: "PA",
    cityWithStateAbbr: "Marienville, PA",
  },
  {
    zip: "16240",
    ST: "PA",
    cityWithStateAbbr: "Mayport, PA",
  },
  {
    zip: "16242",
    ST: "PA",
    cityWithStateAbbr: "New Bethlehem, PA",
  },
  {
    zip: "16244",
    ST: "PA",
    cityWithStateAbbr: "Nu Mine, PA",
  },
  {
    zip: "16245",
    ST: "PA",
    cityWithStateAbbr: "Oak Ridge, PA",
  },
  {
    zip: "16246",
    ST: "PA",
    cityWithStateAbbr: "Plumville, PA",
  },
  {
    zip: "16248",
    ST: "PA",
    cityWithStateAbbr: "Rimersburg, PA",
  },
  {
    zip: "16249",
    ST: "PA",
    cityWithStateAbbr: "Rural Valley, PA",
  },
  {
    zip: "16250",
    ST: "PA",
    cityWithStateAbbr: "Sagamore, PA",
  },
  {
    zip: "16253",
    ST: "PA",
    cityWithStateAbbr: "Seminole, PA",
  },
  {
    zip: "16254",
    ST: "PA",
    cityWithStateAbbr: "Shippenville, PA",
  },
  {
    zip: "16255",
    ST: "PA",
    cityWithStateAbbr: "Sligo, PA",
  },
  {
    zip: "16256",
    ST: "PA",
    cityWithStateAbbr: "Smicksburg, PA",
  },
  {
    zip: "16257",
    ST: "PA",
    cityWithStateAbbr: "Snydersburg, PA",
  },
  {
    zip: "16258",
    ST: "PA",
    cityWithStateAbbr: "Strattanville, PA",
  },
  {
    zip: "16259",
    ST: "PA",
    cityWithStateAbbr: "Templeton, PA",
  },
  {
    zip: "16260",
    ST: "PA",
    cityWithStateAbbr: "Vowinckel, PA",
  },
  {
    zip: "16261",
    ST: "PA",
    cityWithStateAbbr: "Widnoon, PA",
  },
  {
    zip: "16262",
    ST: "PA",
    cityWithStateAbbr: "Worthington, PA",
  },
  {
    zip: "16263",
    ST: "PA",
    cityWithStateAbbr: "Yatesboro, PA",
  },
  {
    zip: "16301",
    ST: "PA",
    cityWithStateAbbr: "Oil City, PA",
  },
  {
    zip: "16311",
    ST: "PA",
    cityWithStateAbbr: "Carlton, PA",
  },
  {
    zip: "16312",
    ST: "PA",
    cityWithStateAbbr: "Chandlers Valley, PA",
  },
  {
    zip: "16313",
    ST: "PA",
    cityWithStateAbbr: "Clarendon, PA",
  },
  {
    zip: "16314",
    ST: "PA",
    cityWithStateAbbr: "Cochranton, PA",
  },
  {
    zip: "16316",
    ST: "PA",
    cityWithStateAbbr: "Conneaut Lake, PA",
  },
  {
    zip: "16317",
    ST: "PA",
    cityWithStateAbbr: "Cooperstown, PA",
  },
  {
    zip: "16319",
    ST: "PA",
    cityWithStateAbbr: "Cranberry, PA",
  },
  {
    zip: "16321",
    ST: "PA",
    cityWithStateAbbr: "East Hickory, PA",
  },
  {
    zip: "16322",
    ST: "PA",
    cityWithStateAbbr: "Endeavor, PA",
  },
  {
    zip: "16323",
    ST: "PA",
    cityWithStateAbbr: "Franklin, PA",
  },
  {
    zip: "16326",
    ST: "PA",
    cityWithStateAbbr: "Fryburg, PA",
  },
  {
    zip: "16327",
    ST: "PA",
    cityWithStateAbbr: "Guys Mills, PA",
  },
  {
    zip: "16328",
    ST: "PA",
    cityWithStateAbbr: "Hydetown, PA",
  },
  {
    zip: "16329",
    ST: "PA",
    cityWithStateAbbr: "Irvine, PA",
  },
  {
    zip: "16331",
    ST: "PA",
    cityWithStateAbbr: "Kossuth, PA",
  },
  {
    zip: "16332",
    ST: "PA",
    cityWithStateAbbr: "Lickingville, PA",
  },
  {
    zip: "16333",
    ST: "PA",
    cityWithStateAbbr: "Ludlow, PA",
  },
  {
    zip: "16334",
    ST: "PA",
    cityWithStateAbbr: "Marble, PA",
  },
  {
    zip: "16335",
    ST: "PA",
    cityWithStateAbbr: "Meadville, PA",
  },
  {
    zip: "16340",
    ST: "PA",
    cityWithStateAbbr: "Pittsfield, PA",
  },
  {
    zip: "16341",
    ST: "PA",
    cityWithStateAbbr: "Pleasantville, PA",
  },
  {
    zip: "16342",
    ST: "PA",
    cityWithStateAbbr: "Polk, PA",
  },
  {
    zip: "16343",
    ST: "PA",
    cityWithStateAbbr: "Reno, PA",
  },
  {
    zip: "16344",
    ST: "PA",
    cityWithStateAbbr: "Rouseville, PA",
  },
  {
    zip: "16345",
    ST: "PA",
    cityWithStateAbbr: "Russell, PA",
  },
  {
    zip: "16346",
    ST: "PA",
    cityWithStateAbbr: "Seneca, PA",
  },
  {
    zip: "16347",
    ST: "PA",
    cityWithStateAbbr: "Sheffield, PA",
  },
  {
    zip: "16350",
    ST: "PA",
    cityWithStateAbbr: "Sugar Grove, PA",
  },
  {
    zip: "16351",
    ST: "PA",
    cityWithStateAbbr: "Tidioute, PA",
  },
  {
    zip: "16352",
    ST: "PA",
    cityWithStateAbbr: "Tiona, PA",
  },
  {
    zip: "16353",
    ST: "PA",
    cityWithStateAbbr: "Tionesta, PA",
  },
  {
    zip: "16354",
    ST: "PA",
    cityWithStateAbbr: "Titusville, PA",
  },
  {
    zip: "16360",
    ST: "PA",
    cityWithStateAbbr: "Townville, PA",
  },
  {
    zip: "16361",
    ST: "PA",
    cityWithStateAbbr: "Tylersburg, PA",
  },
  {
    zip: "16362",
    ST: "PA",
    cityWithStateAbbr: "Utica, PA",
  },
  {
    zip: "16364",
    ST: "PA",
    cityWithStateAbbr: "Venus, PA",
  },
  {
    zip: "16365",
    ST: "PA",
    cityWithStateAbbr: "Warren, PA",
  },
  {
    zip: "16366",
    ST: "PA",
    cityWithStateAbbr: "Warren, PA",
  },
  {
    zip: "16367",
    ST: "PA",
    cityWithStateAbbr: "Warren, PA",
  },
  {
    zip: "16368",
    ST: "PA",
    cityWithStateAbbr: "Warren, PA",
  },
  {
    zip: "16369",
    ST: "PA",
    cityWithStateAbbr: "Warren, PA",
  },
  {
    zip: "16370",
    ST: "PA",
    cityWithStateAbbr: "West Hickory, PA",
  },
  {
    zip: "16371",
    ST: "PA",
    cityWithStateAbbr: "Youngsville, PA",
  },
  {
    zip: "16372",
    ST: "PA",
    cityWithStateAbbr: "Clintonville, PA",
  },
  {
    zip: "16373",
    ST: "PA",
    cityWithStateAbbr: "Emlenton, PA",
  },
  {
    zip: "16374",
    ST: "PA",
    cityWithStateAbbr: "Kennerdell, PA",
  },
  {
    zip: "16375",
    ST: "PA",
    cityWithStateAbbr: "Lamartine, PA",
  },
  {
    zip: "16388",
    ST: "PA",
    cityWithStateAbbr: "Meadville, PA",
  },
  {
    zip: "16401",
    ST: "PA",
    cityWithStateAbbr: "Albion, PA",
  },
  {
    zip: "16402",
    ST: "PA",
    cityWithStateAbbr: "Bear Lake, PA",
  },
  {
    zip: "16403",
    ST: "PA",
    cityWithStateAbbr: "Cambridge Springs, PA",
  },
  {
    zip: "16404",
    ST: "PA",
    cityWithStateAbbr: "Centerville, PA",
  },
  {
    zip: "16405",
    ST: "PA",
    cityWithStateAbbr: "Columbus, PA",
  },
  {
    zip: "16406",
    ST: "PA",
    cityWithStateAbbr: "Conneautville, PA",
  },
  {
    zip: "16407",
    ST: "PA",
    cityWithStateAbbr: "Corry, PA",
  },
  {
    zip: "16410",
    ST: "PA",
    cityWithStateAbbr: "Cranesville, PA",
  },
  {
    zip: "16411",
    ST: "PA",
    cityWithStateAbbr: "East Springfield, PA",
  },
  {
    zip: "16412",
    ST: "PA",
    cityWithStateAbbr: "Edinboro, PA",
  },
  {
    zip: "16413",
    ST: "PA",
    cityWithStateAbbr: "Elgin, PA",
  },
  {
    zip: "16415",
    ST: "PA",
    cityWithStateAbbr: "Fairview, PA",
  },
  {
    zip: "16416",
    ST: "PA",
    cityWithStateAbbr: "Garland, PA",
  },
  {
    zip: "16417",
    ST: "PA",
    cityWithStateAbbr: "Girard, PA",
  },
  {
    zip: "16420",
    ST: "PA",
    cityWithStateAbbr: "Grand Valley, PA",
  },
  {
    zip: "16421",
    ST: "PA",
    cityWithStateAbbr: "Harborcreek, PA",
  },
  {
    zip: "16422",
    ST: "PA",
    cityWithStateAbbr: "Harmonsburg, PA",
  },
  {
    zip: "16423",
    ST: "PA",
    cityWithStateAbbr: "Lake City, PA",
  },
  {
    zip: "16424",
    ST: "PA",
    cityWithStateAbbr: "Linesville, PA",
  },
  {
    zip: "16426",
    ST: "PA",
    cityWithStateAbbr: "Mc Kean, PA",
  },
  {
    zip: "16427",
    ST: "PA",
    cityWithStateAbbr: "Mill Village, PA",
  },
  {
    zip: "16428",
    ST: "PA",
    cityWithStateAbbr: "North East, PA",
  },
  {
    zip: "16430",
    ST: "PA",
    cityWithStateAbbr: "North Springfield, PA",
  },
  {
    zip: "16432",
    ST: "PA",
    cityWithStateAbbr: "Riceville, PA",
  },
  {
    zip: "16433",
    ST: "PA",
    cityWithStateAbbr: "Saegertown, PA",
  },
  {
    zip: "16434",
    ST: "PA",
    cityWithStateAbbr: "Spartansburg, PA",
  },
  {
    zip: "16435",
    ST: "PA",
    cityWithStateAbbr: "Springboro, PA",
  },
  {
    zip: "16436",
    ST: "PA",
    cityWithStateAbbr: "Spring Creek, PA",
  },
  {
    zip: "16438",
    ST: "PA",
    cityWithStateAbbr: "Union City, PA",
  },
  {
    zip: "16440",
    ST: "PA",
    cityWithStateAbbr: "Venango, PA",
  },
  {
    zip: "16441",
    ST: "PA",
    cityWithStateAbbr: "Waterford, PA",
  },
  {
    zip: "16442",
    ST: "PA",
    cityWithStateAbbr: "Wattsburg, PA",
  },
  {
    zip: "16443",
    ST: "PA",
    cityWithStateAbbr: "West Springfield, PA",
  },
  {
    zip: "16444",
    ST: "PA",
    cityWithStateAbbr: "Edinboro, PA",
  },
  {
    zip: "16475",
    ST: "PA",
    cityWithStateAbbr: "Albion, PA",
  },
  {
    zip: "16501",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16502",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16503",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16504",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16505",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16506",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16507",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16508",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16509",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16510",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16511",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16512",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16514",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16515",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16522",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16530",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16531",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16534",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16538",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16541",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16544",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16546",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16550",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16553",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16563",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16565",
    ST: "PA",
    cityWithStateAbbr: "Erie, PA",
  },
  {
    zip: "16601",
    ST: "PA",
    cityWithStateAbbr: "Altoona, PA",
  },
  {
    zip: "16602",
    ST: "PA",
    cityWithStateAbbr: "Altoona, PA",
  },
  {
    zip: "16603",
    ST: "PA",
    cityWithStateAbbr: "Altoona, PA",
  },
  {
    zip: "16611",
    ST: "PA",
    cityWithStateAbbr: "Alexandria, PA",
  },
  {
    zip: "16613",
    ST: "PA",
    cityWithStateAbbr: "Ashville, PA",
  },
  {
    zip: "16616",
    ST: "PA",
    cityWithStateAbbr: "Beccaria, PA",
  },
  {
    zip: "16617",
    ST: "PA",
    cityWithStateAbbr: "Bellwood, PA",
  },
  {
    zip: "16619",
    ST: "PA",
    cityWithStateAbbr: "Blandburg, PA",
  },
  {
    zip: "16620",
    ST: "PA",
    cityWithStateAbbr: "Brisbin, PA",
  },
  {
    zip: "16621",
    ST: "PA",
    cityWithStateAbbr: "Broad Top, PA",
  },
  {
    zip: "16622",
    ST: "PA",
    cityWithStateAbbr: "Calvin, PA",
  },
  {
    zip: "16623",
    ST: "PA",
    cityWithStateAbbr: "Cassville, PA",
  },
  {
    zip: "16624",
    ST: "PA",
    cityWithStateAbbr: "Chest Springs, PA",
  },
  {
    zip: "16625",
    ST: "PA",
    cityWithStateAbbr: "Claysburg, PA",
  },
  {
    zip: "16627",
    ST: "PA",
    cityWithStateAbbr: "Coalport, PA",
  },
  {
    zip: "16629",
    ST: "PA",
    cityWithStateAbbr: "Coupon, PA",
  },
  {
    zip: "16630",
    ST: "PA",
    cityWithStateAbbr: "Cresson, PA",
  },
  {
    zip: "16631",
    ST: "PA",
    cityWithStateAbbr: "Curryville, PA",
  },
  {
    zip: "16633",
    ST: "PA",
    cityWithStateAbbr: "Defiance, PA",
  },
  {
    zip: "16634",
    ST: "PA",
    cityWithStateAbbr: "Dudley, PA",
  },
  {
    zip: "16635",
    ST: "PA",
    cityWithStateAbbr: "Duncansville, PA",
  },
  {
    zip: "16636",
    ST: "PA",
    cityWithStateAbbr: "Dysart, PA",
  },
  {
    zip: "16637",
    ST: "PA",
    cityWithStateAbbr: "East Freedom, PA",
  },
  {
    zip: "16638",
    ST: "PA",
    cityWithStateAbbr: "Entriken, PA",
  },
  {
    zip: "16639",
    ST: "PA",
    cityWithStateAbbr: "Fallentimber, PA",
  },
  {
    zip: "16640",
    ST: "PA",
    cityWithStateAbbr: "Flinton, PA",
  },
  {
    zip: "16641",
    ST: "PA",
    cityWithStateAbbr: "Gallitzin, PA",
  },
  {
    zip: "16644",
    ST: "PA",
    cityWithStateAbbr: "Glasgow, PA",
  },
  {
    zip: "16645",
    ST: "PA",
    cityWithStateAbbr: "Glen Hope, PA",
  },
  {
    zip: "16646",
    ST: "PA",
    cityWithStateAbbr: "Hastings, PA",
  },
  {
    zip: "16647",
    ST: "PA",
    cityWithStateAbbr: "Hesston, PA",
  },
  {
    zip: "16648",
    ST: "PA",
    cityWithStateAbbr: "Hollidaysburg, PA",
  },
  {
    zip: "16650",
    ST: "PA",
    cityWithStateAbbr: "Hopewell, PA",
  },
  {
    zip: "16651",
    ST: "PA",
    cityWithStateAbbr: "Houtzdale, PA",
  },
  {
    zip: "16652",
    ST: "PA",
    cityWithStateAbbr: "Huntingdon, PA",
  },
  {
    zip: "16654",
    ST: "PA",
    cityWithStateAbbr: "Huntingdon, PA",
  },
  {
    zip: "16655",
    ST: "PA",
    cityWithStateAbbr: "Imler, PA",
  },
  {
    zip: "16656",
    ST: "PA",
    cityWithStateAbbr: "Irvona, PA",
  },
  {
    zip: "16657",
    ST: "PA",
    cityWithStateAbbr: "James Creek, PA",
  },
  {
    zip: "16659",
    ST: "PA",
    cityWithStateAbbr: "Loysburg, PA",
  },
  {
    zip: "16660",
    ST: "PA",
    cityWithStateAbbr: "Mc Connellstown, PA",
  },
  {
    zip: "16661",
    ST: "PA",
    cityWithStateAbbr: "Madera, PA",
  },
  {
    zip: "16662",
    ST: "PA",
    cityWithStateAbbr: "Martinsburg, PA",
  },
  {
    zip: "16663",
    ST: "PA",
    cityWithStateAbbr: "Morann, PA",
  },
  {
    zip: "16664",
    ST: "PA",
    cityWithStateAbbr: "New Enterprise, PA",
  },
  {
    zip: "16665",
    ST: "PA",
    cityWithStateAbbr: "Newry, PA",
  },
  {
    zip: "16666",
    ST: "PA",
    cityWithStateAbbr: "Osceola Mills, PA",
  },
  {
    zip: "16667",
    ST: "PA",
    cityWithStateAbbr: "Osterburg, PA",
  },
  {
    zip: "16668",
    ST: "PA",
    cityWithStateAbbr: "Patton, PA",
  },
  {
    zip: "16669",
    ST: "PA",
    cityWithStateAbbr: "Petersburg, PA",
  },
  {
    zip: "16670",
    ST: "PA",
    cityWithStateAbbr: "Queen, PA",
  },
  {
    zip: "16671",
    ST: "PA",
    cityWithStateAbbr: "Ramey, PA",
  },
  {
    zip: "16672",
    ST: "PA",
    cityWithStateAbbr: "Riddlesburg, PA",
  },
  {
    zip: "16673",
    ST: "PA",
    cityWithStateAbbr: "Roaring Spring, PA",
  },
  {
    zip: "16674",
    ST: "PA",
    cityWithStateAbbr: "Robertsdale, PA",
  },
  {
    zip: "16675",
    ST: "PA",
    cityWithStateAbbr: "Saint Boniface, PA",
  },
  {
    zip: "16677",
    ST: "PA",
    cityWithStateAbbr: "Sandy Ridge, PA",
  },
  {
    zip: "16678",
    ST: "PA",
    cityWithStateAbbr: "Saxton, PA",
  },
  {
    zip: "16679",
    ST: "PA",
    cityWithStateAbbr: "Six Mile Run, PA",
  },
  {
    zip: "16680",
    ST: "PA",
    cityWithStateAbbr: "Smithmill, PA",
  },
  {
    zip: "16681",
    ST: "PA",
    cityWithStateAbbr: "Smokerun, PA",
  },
  {
    zip: "16682",
    ST: "PA",
    cityWithStateAbbr: "Sproul, PA",
  },
  {
    zip: "16683",
    ST: "PA",
    cityWithStateAbbr: "Spruce Creek, PA",
  },
  {
    zip: "16684",
    ST: "PA",
    cityWithStateAbbr: "Tipton, PA",
  },
  {
    zip: "16685",
    ST: "PA",
    cityWithStateAbbr: "Todd, PA",
  },
  {
    zip: "16686",
    ST: "PA",
    cityWithStateAbbr: "Tyrone, PA",
  },
  {
    zip: "16689",
    ST: "PA",
    cityWithStateAbbr: "Waterfall, PA",
  },
  {
    zip: "16691",
    ST: "PA",
    cityWithStateAbbr: "Wells Tannery, PA",
  },
  {
    zip: "16692",
    ST: "PA",
    cityWithStateAbbr: "Westover, PA",
  },
  {
    zip: "16693",
    ST: "PA",
    cityWithStateAbbr: "Williamsburg, PA",
  },
  {
    zip: "16694",
    ST: "PA",
    cityWithStateAbbr: "Wood, PA",
  },
  {
    zip: "16695",
    ST: "PA",
    cityWithStateAbbr: "Woodbury, PA",
  },
  {
    zip: "16698",
    ST: "PA",
    cityWithStateAbbr: "Houtzdale, PA",
  },
  {
    zip: "16699",
    ST: "PA",
    cityWithStateAbbr: "Cresson, PA",
  },
  {
    zip: "16701",
    ST: "PA",
    cityWithStateAbbr: "Bradford, PA",
  },
  {
    zip: "16720",
    ST: "PA",
    cityWithStateAbbr: "Austin, PA",
  },
  {
    zip: "16724",
    ST: "PA",
    cityWithStateAbbr: "Crosby, PA",
  },
  {
    zip: "16725",
    ST: "PA",
    cityWithStateAbbr: "Custer City, PA",
  },
  {
    zip: "16726",
    ST: "PA",
    cityWithStateAbbr: "Cyclone, PA",
  },
  {
    zip: "16727",
    ST: "PA",
    cityWithStateAbbr: "Derrick City, PA",
  },
  {
    zip: "16728",
    ST: "PA",
    cityWithStateAbbr: "De Young, PA",
  },
  {
    zip: "16729",
    ST: "PA",
    cityWithStateAbbr: "Duke Center, PA",
  },
  {
    zip: "16730",
    ST: "PA",
    cityWithStateAbbr: "East Smethport, PA",
  },
  {
    zip: "16731",
    ST: "PA",
    cityWithStateAbbr: "Eldred, PA",
  },
  {
    zip: "16732",
    ST: "PA",
    cityWithStateAbbr: "Gifford, PA",
  },
  {
    zip: "16733",
    ST: "PA",
    cityWithStateAbbr: "Hazel Hurst, PA",
  },
  {
    zip: "16734",
    ST: "PA",
    cityWithStateAbbr: "James City, PA",
  },
  {
    zip: "16735",
    ST: "PA",
    cityWithStateAbbr: "Kane, PA",
  },
  {
    zip: "16738",
    ST: "PA",
    cityWithStateAbbr: "Lewis Run, PA",
  },
  {
    zip: "16740",
    ST: "PA",
    cityWithStateAbbr: "Mount Jewett, PA",
  },
  {
    zip: "16743",
    ST: "PA",
    cityWithStateAbbr: "Port Allegany, PA",
  },
  {
    zip: "16744",
    ST: "PA",
    cityWithStateAbbr: "Rew, PA",
  },
  {
    zip: "16745",
    ST: "PA",
    cityWithStateAbbr: "Rixford, PA",
  },
  {
    zip: "16746",
    ST: "PA",
    cityWithStateAbbr: "Roulette, PA",
  },
  {
    zip: "16748",
    ST: "PA",
    cityWithStateAbbr: "Shinglehouse, PA",
  },
  {
    zip: "16749",
    ST: "PA",
    cityWithStateAbbr: "Smethport, PA",
  },
  {
    zip: "16750",
    ST: "PA",
    cityWithStateAbbr: "Turtlepoint, PA",
  },
  {
    zip: "16801",
    ST: "PA",
    cityWithStateAbbr: "State College, PA",
  },
  {
    zip: "16802",
    ST: "PA",
    cityWithStateAbbr: "University Park, PA",
  },
  {
    zip: "16803",
    ST: "PA",
    cityWithStateAbbr: "State College, PA",
  },
  {
    zip: "16804",
    ST: "PA",
    cityWithStateAbbr: "State College, PA",
  },
  {
    zip: "16805",
    ST: "PA",
    cityWithStateAbbr: "State College, PA",
  },
  {
    zip: "16820",
    ST: "PA",
    cityWithStateAbbr: "Aaronsburg, PA",
  },
  {
    zip: "16821",
    ST: "PA",
    cityWithStateAbbr: "Allport, PA",
  },
  {
    zip: "16822",
    ST: "PA",
    cityWithStateAbbr: "Beech Creek, PA",
  },
  {
    zip: "16823",
    ST: "PA",
    cityWithStateAbbr: "Bellefonte, PA",
  },
  {
    zip: "16825",
    ST: "PA",
    cityWithStateAbbr: "Bigler, PA",
  },
  {
    zip: "16826",
    ST: "PA",
    cityWithStateAbbr: "Blanchard, PA",
  },
  {
    zip: "16827",
    ST: "PA",
    cityWithStateAbbr: "Boalsburg, PA",
  },
  {
    zip: "16828",
    ST: "PA",
    cityWithStateAbbr: "Centre Hall, PA",
  },
  {
    zip: "16829",
    ST: "PA",
    cityWithStateAbbr: "Clarence, PA",
  },
  {
    zip: "16830",
    ST: "PA",
    cityWithStateAbbr: "Clearfield, PA",
  },
  {
    zip: "16832",
    ST: "PA",
    cityWithStateAbbr: "Coburn, PA",
  },
  {
    zip: "16833",
    ST: "PA",
    cityWithStateAbbr: "Curwensville, PA",
  },
  {
    zip: "16834",
    ST: "PA",
    cityWithStateAbbr: "Drifting, PA",
  },
  {
    zip: "16835",
    ST: "PA",
    cityWithStateAbbr: "Fleming, PA",
  },
  {
    zip: "16836",
    ST: "PA",
    cityWithStateAbbr: "Frenchville, PA",
  },
  {
    zip: "16837",
    ST: "PA",
    cityWithStateAbbr: "Glen Richey, PA",
  },
  {
    zip: "16838",
    ST: "PA",
    cityWithStateAbbr: "Grampian, PA",
  },
  {
    zip: "16839",
    ST: "PA",
    cityWithStateAbbr: "Grassflat, PA",
  },
  {
    zip: "16840",
    ST: "PA",
    cityWithStateAbbr: "Hawk Run, PA",
  },
  {
    zip: "16841",
    ST: "PA",
    cityWithStateAbbr: "Howard, PA",
  },
  {
    zip: "16843",
    ST: "PA",
    cityWithStateAbbr: "Hyde, PA",
  },
  {
    zip: "16844",
    ST: "PA",
    cityWithStateAbbr: "Julian, PA",
  },
  {
    zip: "16845",
    ST: "PA",
    cityWithStateAbbr: "Karthaus, PA",
  },
  {
    zip: "16847",
    ST: "PA",
    cityWithStateAbbr: "Kylertown, PA",
  },
  {
    zip: "16848",
    ST: "PA",
    cityWithStateAbbr: "Lamar, PA",
  },
  {
    zip: "16849",
    ST: "PA",
    cityWithStateAbbr: "Lanse, PA",
  },
  {
    zip: "16850",
    ST: "PA",
    cityWithStateAbbr: "Lecontes Mills, PA",
  },
  {
    zip: "16851",
    ST: "PA",
    cityWithStateAbbr: "Lemont, PA",
  },
  {
    zip: "16852",
    ST: "PA",
    cityWithStateAbbr: "Madisonburg, PA",
  },
  {
    zip: "16853",
    ST: "PA",
    cityWithStateAbbr: "Milesburg, PA",
  },
  {
    zip: "16854",
    ST: "PA",
    cityWithStateAbbr: "Millheim, PA",
  },
  {
    zip: "16855",
    ST: "PA",
    cityWithStateAbbr: "Mineral Springs, PA",
  },
  {
    zip: "16856",
    ST: "PA",
    cityWithStateAbbr: "Mingoville, PA",
  },
  {
    zip: "16858",
    ST: "PA",
    cityWithStateAbbr: "Morrisdale, PA",
  },
  {
    zip: "16859",
    ST: "PA",
    cityWithStateAbbr: "Moshannon, PA",
  },
  {
    zip: "16860",
    ST: "PA",
    cityWithStateAbbr: "Munson, PA",
  },
  {
    zip: "16861",
    ST: "PA",
    cityWithStateAbbr: "New Millport, PA",
  },
  {
    zip: "16863",
    ST: "PA",
    cityWithStateAbbr: "Olanta, PA",
  },
  {
    zip: "16864",
    ST: "PA",
    cityWithStateAbbr: "Orviston, PA",
  },
  {
    zip: "16865",
    ST: "PA",
    cityWithStateAbbr: "Pennsylvania Furnace, PA",
  },
  {
    zip: "16866",
    ST: "PA",
    cityWithStateAbbr: "Philipsburg, PA",
  },
  {
    zip: "16868",
    ST: "PA",
    cityWithStateAbbr: "Pine Grove Mills, PA",
  },
  {
    zip: "16870",
    ST: "PA",
    cityWithStateAbbr: "Port Matilda, PA",
  },
  {
    zip: "16871",
    ST: "PA",
    cityWithStateAbbr: "Pottersdale, PA",
  },
  {
    zip: "16872",
    ST: "PA",
    cityWithStateAbbr: "Rebersburg, PA",
  },
  {
    zip: "16873",
    ST: "PA",
    cityWithStateAbbr: "Shawville, PA",
  },
  {
    zip: "16874",
    ST: "PA",
    cityWithStateAbbr: "Snow Shoe, PA",
  },
  {
    zip: "16875",
    ST: "PA",
    cityWithStateAbbr: "Spring Mills, PA",
  },
  {
    zip: "16876",
    ST: "PA",
    cityWithStateAbbr: "Wallaceton, PA",
  },
  {
    zip: "16877",
    ST: "PA",
    cityWithStateAbbr: "Warriors Mark, PA",
  },
  {
    zip: "16878",
    ST: "PA",
    cityWithStateAbbr: "West Decatur, PA",
  },
  {
    zip: "16879",
    ST: "PA",
    cityWithStateAbbr: "Winburne, PA",
  },
  {
    zip: "16881",
    ST: "PA",
    cityWithStateAbbr: "Woodland, PA",
  },
  {
    zip: "16882",
    ST: "PA",
    cityWithStateAbbr: "Woodward, PA",
  },
  {
    zip: "16901",
    ST: "PA",
    cityWithStateAbbr: "Wellsboro, PA",
  },
  {
    zip: "16910",
    ST: "PA",
    cityWithStateAbbr: "Alba, PA",
  },
  {
    zip: "16911",
    ST: "PA",
    cityWithStateAbbr: "Arnot, PA",
  },
  {
    zip: "16912",
    ST: "PA",
    cityWithStateAbbr: "Blossburg, PA",
  },
  {
    zip: "16914",
    ST: "PA",
    cityWithStateAbbr: "Columbia Cross Roads, PA",
  },
  {
    zip: "16915",
    ST: "PA",
    cityWithStateAbbr: "Coudersport, PA",
  },
  {
    zip: "16917",
    ST: "PA",
    cityWithStateAbbr: "Covington, PA",
  },
  {
    zip: "16920",
    ST: "PA",
    cityWithStateAbbr: "Elkland, PA",
  },
  {
    zip: "16921",
    ST: "PA",
    cityWithStateAbbr: "Gaines, PA",
  },
  {
    zip: "16922",
    ST: "PA",
    cityWithStateAbbr: "Galeton, PA",
  },
  {
    zip: "16923",
    ST: "PA",
    cityWithStateAbbr: "Genesee, PA",
  },
  {
    zip: "16925",
    ST: "PA",
    cityWithStateAbbr: "Gillett, PA",
  },
  {
    zip: "16926",
    ST: "PA",
    cityWithStateAbbr: "Granville Summit, PA",
  },
  {
    zip: "16927",
    ST: "PA",
    cityWithStateAbbr: "Harrison Valley, PA",
  },
  {
    zip: "16928",
    ST: "PA",
    cityWithStateAbbr: "Knoxville, PA",
  },
  {
    zip: "16929",
    ST: "PA",
    cityWithStateAbbr: "Lawrenceville, PA",
  },
  {
    zip: "16930",
    ST: "PA",
    cityWithStateAbbr: "Liberty, PA",
  },
  {
    zip: "16932",
    ST: "PA",
    cityWithStateAbbr: "Mainesburg, PA",
  },
  {
    zip: "16933",
    ST: "PA",
    cityWithStateAbbr: "Mansfield, PA",
  },
  {
    zip: "16935",
    ST: "PA",
    cityWithStateAbbr: "Middlebury Center, PA",
  },
  {
    zip: "16936",
    ST: "PA",
    cityWithStateAbbr: "Millerton, PA",
  },
  {
    zip: "16937",
    ST: "PA",
    cityWithStateAbbr: "Mills, PA",
  },
  {
    zip: "16938",
    ST: "PA",
    cityWithStateAbbr: "Morris, PA",
  },
  {
    zip: "16939",
    ST: "PA",
    cityWithStateAbbr: "Morris Run, PA",
  },
  {
    zip: "16940",
    ST: "PA",
    cityWithStateAbbr: "Nelson, PA",
  },
  {
    zip: "16941",
    ST: "PA",
    cityWithStateAbbr: "Genesee, PA",
  },
  {
    zip: "16942",
    ST: "PA",
    cityWithStateAbbr: "Osceola, PA",
  },
  {
    zip: "16943",
    ST: "PA",
    cityWithStateAbbr: "Sabinsville, PA",
  },
  {
    zip: "16945",
    ST: "PA",
    cityWithStateAbbr: "Sylvania, PA",
  },
  {
    zip: "16946",
    ST: "PA",
    cityWithStateAbbr: "Tioga, PA",
  },
  {
    zip: "16947",
    ST: "PA",
    cityWithStateAbbr: "Troy, PA",
  },
  {
    zip: "16948",
    ST: "PA",
    cityWithStateAbbr: "Ulysses, PA",
  },
  {
    zip: "16950",
    ST: "PA",
    cityWithStateAbbr: "Westfield, PA",
  },
  {
    zip: "17001",
    ST: "PA",
    cityWithStateAbbr: "Camp Hill, PA",
  },
  {
    zip: "17002",
    ST: "PA",
    cityWithStateAbbr: "Allensville, PA",
  },
  {
    zip: "17003",
    ST: "PA",
    cityWithStateAbbr: "Annville, PA",
  },
  {
    zip: "17004",
    ST: "PA",
    cityWithStateAbbr: "Belleville, PA",
  },
  {
    zip: "17005",
    ST: "PA",
    cityWithStateAbbr: "Berrysburg, PA",
  },
  {
    zip: "17006",
    ST: "PA",
    cityWithStateAbbr: "Blain, PA",
  },
  {
    zip: "17007",
    ST: "PA",
    cityWithStateAbbr: "Boiling Springs, PA",
  },
  {
    zip: "17009",
    ST: "PA",
    cityWithStateAbbr: "Burnham, PA",
  },
  {
    zip: "17010",
    ST: "PA",
    cityWithStateAbbr: "Campbelltown, PA",
  },
  {
    zip: "17011",
    ST: "PA",
    cityWithStateAbbr: "Camp Hill, PA",
  },
  {
    zip: "17012",
    ST: "PA",
    cityWithStateAbbr: "Camp Hill, PA",
  },
  {
    zip: "17013",
    ST: "PA",
    cityWithStateAbbr: "Carlisle, PA",
  },
  {
    zip: "17014",
    ST: "PA",
    cityWithStateAbbr: "Cocolamus, PA",
  },
  {
    zip: "17015",
    ST: "PA",
    cityWithStateAbbr: "Carlisle, PA",
  },
  {
    zip: "17016",
    ST: "PA",
    cityWithStateAbbr: "Cornwall, PA",
  },
  {
    zip: "17017",
    ST: "PA",
    cityWithStateAbbr: "Dalmatia, PA",
  },
  {
    zip: "17018",
    ST: "PA",
    cityWithStateAbbr: "Dauphin, PA",
  },
  {
    zip: "17019",
    ST: "PA",
    cityWithStateAbbr: "Dillsburg, PA",
  },
  {
    zip: "17020",
    ST: "PA",
    cityWithStateAbbr: "Duncannon, PA",
  },
  {
    zip: "17021",
    ST: "PA",
    cityWithStateAbbr: "East Waterford, PA",
  },
  {
    zip: "17022",
    ST: "PA",
    cityWithStateAbbr: "Elizabethtown, PA",
  },
  {
    zip: "17023",
    ST: "PA",
    cityWithStateAbbr: "Elizabethville, PA",
  },
  {
    zip: "17024",
    ST: "PA",
    cityWithStateAbbr: "Elliottsburg, PA",
  },
  {
    zip: "17025",
    ST: "PA",
    cityWithStateAbbr: "Enola, PA",
  },
  {
    zip: "17026",
    ST: "PA",
    cityWithStateAbbr: "Fredericksburg, PA",
  },
  {
    zip: "17027",
    ST: "PA",
    cityWithStateAbbr: "Grantham, PA",
  },
  {
    zip: "17028",
    ST: "PA",
    cityWithStateAbbr: "Grantville, PA",
  },
  {
    zip: "17029",
    ST: "PA",
    cityWithStateAbbr: "Granville, PA",
  },
  {
    zip: "17030",
    ST: "PA",
    cityWithStateAbbr: "Gratz, PA",
  },
  {
    zip: "17032",
    ST: "PA",
    cityWithStateAbbr: "Halifax, PA",
  },
  {
    zip: "17033",
    ST: "PA",
    cityWithStateAbbr: "Hershey, PA",
  },
  {
    zip: "17034",
    ST: "PA",
    cityWithStateAbbr: "Highspire, PA",
  },
  {
    zip: "17035",
    ST: "PA",
    cityWithStateAbbr: "Honey Grove, PA",
  },
  {
    zip: "17036",
    ST: "PA",
    cityWithStateAbbr: "Hummelstown, PA",
  },
  {
    zip: "17037",
    ST: "PA",
    cityWithStateAbbr: "Ickesburg, PA",
  },
  {
    zip: "17038",
    ST: "PA",
    cityWithStateAbbr: "Jonestown, PA",
  },
  {
    zip: "17039",
    ST: "PA",
    cityWithStateAbbr: "Kleinfeltersville, PA",
  },
  {
    zip: "17040",
    ST: "PA",
    cityWithStateAbbr: "Landisburg, PA",
  },
  {
    zip: "17041",
    ST: "PA",
    cityWithStateAbbr: "Lawn, PA",
  },
  {
    zip: "17042",
    ST: "PA",
    cityWithStateAbbr: "Lebanon, PA",
  },
  {
    zip: "17043",
    ST: "PA",
    cityWithStateAbbr: "Lemoyne, PA",
  },
  {
    zip: "17044",
    ST: "PA",
    cityWithStateAbbr: "Lewistown, PA",
  },
  {
    zip: "17045",
    ST: "PA",
    cityWithStateAbbr: "Liverpool, PA",
  },
  {
    zip: "17046",
    ST: "PA",
    cityWithStateAbbr: "Lebanon, PA",
  },
  {
    zip: "17047",
    ST: "PA",
    cityWithStateAbbr: "Loysville, PA",
  },
  {
    zip: "17048",
    ST: "PA",
    cityWithStateAbbr: "Lykens, PA",
  },
  {
    zip: "17049",
    ST: "PA",
    cityWithStateAbbr: "Mc Alisterville, PA",
  },
  {
    zip: "17050",
    ST: "PA",
    cityWithStateAbbr: "Mechanicsburg, PA",
  },
  {
    zip: "17051",
    ST: "PA",
    cityWithStateAbbr: "Mc Veytown, PA",
  },
  {
    zip: "17052",
    ST: "PA",
    cityWithStateAbbr: "Mapleton Depot, PA",
  },
  {
    zip: "17053",
    ST: "PA",
    cityWithStateAbbr: "Marysville, PA",
  },
  {
    zip: "17054",
    ST: "PA",
    cityWithStateAbbr: "Mattawana, PA",
  },
  {
    zip: "17055",
    ST: "PA",
    cityWithStateAbbr: "Mechanicsburg, PA",
  },
  {
    zip: "17056",
    ST: "PA",
    cityWithStateAbbr: "Mexico, PA",
  },
  {
    zip: "17057",
    ST: "PA",
    cityWithStateAbbr: "Middletown, PA",
  },
  {
    zip: "17058",
    ST: "PA",
    cityWithStateAbbr: "Mifflin, PA",
  },
  {
    zip: "17059",
    ST: "PA",
    cityWithStateAbbr: "Mifflintown, PA",
  },
  {
    zip: "17060",
    ST: "PA",
    cityWithStateAbbr: "Mill Creek, PA",
  },
  {
    zip: "17061",
    ST: "PA",
    cityWithStateAbbr: "Millersburg, PA",
  },
  {
    zip: "17062",
    ST: "PA",
    cityWithStateAbbr: "Millerstown, PA",
  },
  {
    zip: "17063",
    ST: "PA",
    cityWithStateAbbr: "Milroy, PA",
  },
  {
    zip: "17064",
    ST: "PA",
    cityWithStateAbbr: "Mount Gretna, PA",
  },
  {
    zip: "17065",
    ST: "PA",
    cityWithStateAbbr: "Mount Holly Springs, PA",
  },
  {
    zip: "17066",
    ST: "PA",
    cityWithStateAbbr: "Mount Union, PA",
  },
  {
    zip: "17067",
    ST: "PA",
    cityWithStateAbbr: "Myerstown, PA",
  },
  {
    zip: "17068",
    ST: "PA",
    cityWithStateAbbr: "New Bloomfield, PA",
  },
  {
    zip: "17069",
    ST: "PA",
    cityWithStateAbbr: "New Buffalo, PA",
  },
  {
    zip: "17070",
    ST: "PA",
    cityWithStateAbbr: "New Cumberland, PA",
  },
  {
    zip: "17071",
    ST: "PA",
    cityWithStateAbbr: "New Germantown, PA",
  },
  {
    zip: "17072",
    ST: "PA",
    cityWithStateAbbr: "New Kingstown, PA",
  },
  {
    zip: "17073",
    ST: "PA",
    cityWithStateAbbr: "Newmanstown, PA",
  },
  {
    zip: "17074",
    ST: "PA",
    cityWithStateAbbr: "Newport, PA",
  },
  {
    zip: "17075",
    ST: "PA",
    cityWithStateAbbr: "Newton Hamilton, PA",
  },
  {
    zip: "17076",
    ST: "PA",
    cityWithStateAbbr: "Oakland Mills, PA",
  },
  {
    zip: "17077",
    ST: "PA",
    cityWithStateAbbr: "Ono, PA",
  },
  {
    zip: "17078",
    ST: "PA",
    cityWithStateAbbr: "Palmyra, PA",
  },
  {
    zip: "17080",
    ST: "PA",
    cityWithStateAbbr: "Pillow, PA",
  },
  {
    zip: "17081",
    ST: "PA",
    cityWithStateAbbr: "Plainfield, PA",
  },
  {
    zip: "17082",
    ST: "PA",
    cityWithStateAbbr: "Port Royal, PA",
  },
  {
    zip: "17083",
    ST: "PA",
    cityWithStateAbbr: "Quentin, PA",
  },
  {
    zip: "17084",
    ST: "PA",
    cityWithStateAbbr: "Reedsville, PA",
  },
  {
    zip: "17085",
    ST: "PA",
    cityWithStateAbbr: "Rexmont, PA",
  },
  {
    zip: "17086",
    ST: "PA",
    cityWithStateAbbr: "Richfield, PA",
  },
  {
    zip: "17087",
    ST: "PA",
    cityWithStateAbbr: "Richland, PA",
  },
  {
    zip: "17088",
    ST: "PA",
    cityWithStateAbbr: "Schaefferstown, PA",
  },
  {
    zip: "17089",
    ST: "PA",
    cityWithStateAbbr: "Camp Hill, PA",
  },
  {
    zip: "17090",
    ST: "PA",
    cityWithStateAbbr: "Shermans Dale, PA",
  },
  {
    zip: "17093",
    ST: "PA",
    cityWithStateAbbr: "Summerdale, PA",
  },
  {
    zip: "17094",
    ST: "PA",
    cityWithStateAbbr: "Thompsontown, PA",
  },
  {
    zip: "17097",
    ST: "PA",
    cityWithStateAbbr: "Wiconisco, PA",
  },
  {
    zip: "17098",
    ST: "PA",
    cityWithStateAbbr: "Williamstown, PA",
  },
  {
    zip: "17099",
    ST: "PA",
    cityWithStateAbbr: "Yeagertown, PA",
  },
  {
    zip: "17101",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17102",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17103",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17104",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17105",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17106",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17107",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17108",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17109",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17110",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17111",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17112",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17113",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17120",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17121",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17122",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17123",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17124",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17125",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17126",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17127",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17128",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17129",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17130",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17140",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17177",
    ST: "PA",
    cityWithStateAbbr: "Harrisburg, PA",
  },
  {
    zip: "17201",
    ST: "PA",
    cityWithStateAbbr: "Chambersburg, PA",
  },
  {
    zip: "17202",
    ST: "PA",
    cityWithStateAbbr: "Chambersburg, PA",
  },
  {
    zip: "17210",
    ST: "PA",
    cityWithStateAbbr: "Amberson, PA",
  },
  {
    zip: "17211",
    ST: "PA",
    cityWithStateAbbr: "Artemas, PA",
  },
  {
    zip: "17212",
    ST: "PA",
    cityWithStateAbbr: "Big Cove Tannery, PA",
  },
  {
    zip: "17213",
    ST: "PA",
    cityWithStateAbbr: "Blairs Mills, PA",
  },
  {
    zip: "17214",
    ST: "PA",
    cityWithStateAbbr: "Blue Ridge Summit, PA",
  },
  {
    zip: "17215",
    ST: "PA",
    cityWithStateAbbr: "Burnt Cabins, PA",
  },
  {
    zip: "17217",
    ST: "PA",
    cityWithStateAbbr: "Concord, PA",
  },
  {
    zip: "17219",
    ST: "PA",
    cityWithStateAbbr: "Doylesburg, PA",
  },
  {
    zip: "17220",
    ST: "PA",
    cityWithStateAbbr: "Dry Run, PA",
  },
  {
    zip: "17221",
    ST: "PA",
    cityWithStateAbbr: "Fannettsburg, PA",
  },
  {
    zip: "17222",
    ST: "PA",
    cityWithStateAbbr: "Fayetteville, PA",
  },
  {
    zip: "17223",
    ST: "PA",
    cityWithStateAbbr: "Fort Littleton, PA",
  },
  {
    zip: "17224",
    ST: "PA",
    cityWithStateAbbr: "Fort Loudon, PA",
  },
  {
    zip: "17225",
    ST: "PA",
    cityWithStateAbbr: "Greencastle, PA",
  },
  {
    zip: "17228",
    ST: "PA",
    cityWithStateAbbr: "Harrisonville, PA",
  },
  {
    zip: "17229",
    ST: "PA",
    cityWithStateAbbr: "Hustontown, PA",
  },
  {
    zip: "17231",
    ST: "PA",
    cityWithStateAbbr: "Lemasters, PA",
  },
  {
    zip: "17232",
    ST: "PA",
    cityWithStateAbbr: "Lurgan, PA",
  },
  {
    zip: "17233",
    ST: "PA",
    cityWithStateAbbr: "Mc Connellsburg, PA",
  },
  {
    zip: "17235",
    ST: "PA",
    cityWithStateAbbr: "Marion, PA",
  },
  {
    zip: "17236",
    ST: "PA",
    cityWithStateAbbr: "Mercersburg, PA",
  },
  {
    zip: "17237",
    ST: "PA",
    cityWithStateAbbr: "Mont Alto, PA",
  },
  {
    zip: "17238",
    ST: "PA",
    cityWithStateAbbr: "Needmore, PA",
  },
  {
    zip: "17239",
    ST: "PA",
    cityWithStateAbbr: "Neelyton, PA",
  },
  {
    zip: "17240",
    ST: "PA",
    cityWithStateAbbr: "Newburg, PA",
  },
  {
    zip: "17241",
    ST: "PA",
    cityWithStateAbbr: "Newville, PA",
  },
  {
    zip: "17243",
    ST: "PA",
    cityWithStateAbbr: "Orbisonia, PA",
  },
  {
    zip: "17244",
    ST: "PA",
    cityWithStateAbbr: "Orrstown, PA",
  },
  {
    zip: "17246",
    ST: "PA",
    cityWithStateAbbr: "Pleasant Hall, PA",
  },
  {
    zip: "17247",
    ST: "PA",
    cityWithStateAbbr: "Quincy, PA",
  },
  {
    zip: "17249",
    ST: "PA",
    cityWithStateAbbr: "Rockhill Furnace, PA",
  },
  {
    zip: "17250",
    ST: "PA",
    cityWithStateAbbr: "Rouzerville, PA",
  },
  {
    zip: "17251",
    ST: "PA",
    cityWithStateAbbr: "Roxbury, PA",
  },
  {
    zip: "17252",
    ST: "PA",
    cityWithStateAbbr: "Saint Thomas, PA",
  },
  {
    zip: "17253",
    ST: "PA",
    cityWithStateAbbr: "Saltillo, PA",
  },
  {
    zip: "17254",
    ST: "PA",
    cityWithStateAbbr: "Scotland, PA",
  },
  {
    zip: "17255",
    ST: "PA",
    cityWithStateAbbr: "Shade Gap, PA",
  },
  {
    zip: "17256",
    ST: "PA",
    cityWithStateAbbr: "Shady Grove, PA",
  },
  {
    zip: "17257",
    ST: "PA",
    cityWithStateAbbr: "Shippensburg, PA",
  },
  {
    zip: "17260",
    ST: "PA",
    cityWithStateAbbr: "Shirleysburg, PA",
  },
  {
    zip: "17261",
    ST: "PA",
    cityWithStateAbbr: "South Mountain, PA",
  },
  {
    zip: "17262",
    ST: "PA",
    cityWithStateAbbr: "Spring Run, PA",
  },
  {
    zip: "17263",
    ST: "PA",
    cityWithStateAbbr: "State Line, PA",
  },
  {
    zip: "17264",
    ST: "PA",
    cityWithStateAbbr: "Three Springs, PA",
  },
  {
    zip: "17265",
    ST: "PA",
    cityWithStateAbbr: "Upperstrasburg, PA",
  },
  {
    zip: "17266",
    ST: "PA",
    cityWithStateAbbr: "Walnut Bottom, PA",
  },
  {
    zip: "17267",
    ST: "PA",
    cityWithStateAbbr: "Warfordsburg, PA",
  },
  {
    zip: "17268",
    ST: "PA",
    cityWithStateAbbr: "Waynesboro, PA",
  },
  {
    zip: "17271",
    ST: "PA",
    cityWithStateAbbr: "Willow Hill, PA",
  },
  {
    zip: "17272",
    ST: "PA",
    cityWithStateAbbr: "Zullinger, PA",
  },
  {
    zip: "17301",
    ST: "PA",
    cityWithStateAbbr: "Abbottstown, PA",
  },
  {
    zip: "17302",
    ST: "PA",
    cityWithStateAbbr: "Airville, PA",
  },
  {
    zip: "17303",
    ST: "PA",
    cityWithStateAbbr: "Arendtsville, PA",
  },
  {
    zip: "17304",
    ST: "PA",
    cityWithStateAbbr: "Aspers, PA",
  },
  {
    zip: "17306",
    ST: "PA",
    cityWithStateAbbr: "Bendersville, PA",
  },
  {
    zip: "17307",
    ST: "PA",
    cityWithStateAbbr: "Biglerville, PA",
  },
  {
    zip: "17309",
    ST: "PA",
    cityWithStateAbbr: "Brogue, PA",
  },
  {
    zip: "17310",
    ST: "PA",
    cityWithStateAbbr: "Cashtown, PA",
  },
  {
    zip: "17311",
    ST: "PA",
    cityWithStateAbbr: "Codorus, PA",
  },
  {
    zip: "17312",
    ST: "PA",
    cityWithStateAbbr: "Craley, PA",
  },
  {
    zip: "17313",
    ST: "PA",
    cityWithStateAbbr: "Dallastown, PA",
  },
  {
    zip: "17314",
    ST: "PA",
    cityWithStateAbbr: "Delta, PA",
  },
  {
    zip: "17315",
    ST: "PA",
    cityWithStateAbbr: "Dover, PA",
  },
  {
    zip: "17316",
    ST: "PA",
    cityWithStateAbbr: "East Berlin, PA",
  },
  {
    zip: "17317",
    ST: "PA",
    cityWithStateAbbr: "East Prospect, PA",
  },
  {
    zip: "17318",
    ST: "PA",
    cityWithStateAbbr: "Emigsville, PA",
  },
  {
    zip: "17319",
    ST: "PA",
    cityWithStateAbbr: "Etters, PA",
  },
  {
    zip: "17320",
    ST: "PA",
    cityWithStateAbbr: "Fairfield, PA",
  },
  {
    zip: "17321",
    ST: "PA",
    cityWithStateAbbr: "Fawn Grove, PA",
  },
  {
    zip: "17322",
    ST: "PA",
    cityWithStateAbbr: "Felton, PA",
  },
  {
    zip: "17323",
    ST: "PA",
    cityWithStateAbbr: "Franklintown, PA",
  },
  {
    zip: "17324",
    ST: "PA",
    cityWithStateAbbr: "Gardners, PA",
  },
  {
    zip: "17325",
    ST: "PA",
    cityWithStateAbbr: "Gettysburg, PA",
  },
  {
    zip: "17327",
    ST: "PA",
    cityWithStateAbbr: "Glen Rock, PA",
  },
  {
    zip: "17329",
    ST: "PA",
    cityWithStateAbbr: "Glenville, PA",
  },
  {
    zip: "17331",
    ST: "PA",
    cityWithStateAbbr: "Hanover, PA",
  },
  {
    zip: "17332",
    ST: "PA",
    cityWithStateAbbr: "Hanover, PA",
  },
  {
    zip: "17333",
    ST: "PA",
    cityWithStateAbbr: "Hanover, PA",
  },
  {
    zip: "17334",
    ST: "PA",
    cityWithStateAbbr: "Hanover, PA",
  },
  {
    zip: "17337",
    ST: "PA",
    cityWithStateAbbr: "Idaville, PA",
  },
  {
    zip: "17339",
    ST: "PA",
    cityWithStateAbbr: "Lewisberry, PA",
  },
  {
    zip: "17340",
    ST: "PA",
    cityWithStateAbbr: "Littlestown, PA",
  },
  {
    zip: "17342",
    ST: "PA",
    cityWithStateAbbr: "Loganville, PA",
  },
  {
    zip: "17343",
    ST: "PA",
    cityWithStateAbbr: "Mc Knightstown, PA",
  },
  {
    zip: "17344",
    ST: "PA",
    cityWithStateAbbr: "Mc Sherrystown, PA",
  },
  {
    zip: "17345",
    ST: "PA",
    cityWithStateAbbr: "Manchester, PA",
  },
  {
    zip: "17347",
    ST: "PA",
    cityWithStateAbbr: "Mount Wolf, PA",
  },
  {
    zip: "17349",
    ST: "PA",
    cityWithStateAbbr: "New Freedom, PA",
  },
  {
    zip: "17350",
    ST: "PA",
    cityWithStateAbbr: "New Oxford, PA",
  },
  {
    zip: "17352",
    ST: "PA",
    cityWithStateAbbr: "New Park, PA",
  },
  {
    zip: "17353",
    ST: "PA",
    cityWithStateAbbr: "Orrtanna, PA",
  },
  {
    zip: "17354",
    ST: "PA",
    cityWithStateAbbr: "Porters Sideling, PA",
  },
  {
    zip: "17355",
    ST: "PA",
    cityWithStateAbbr: "Railroad, PA",
  },
  {
    zip: "17356",
    ST: "PA",
    cityWithStateAbbr: "Red Lion, PA",
  },
  {
    zip: "17358",
    ST: "PA",
    cityWithStateAbbr: "Rossville, PA",
  },
  {
    zip: "17360",
    ST: "PA",
    cityWithStateAbbr: "Seven Valleys, PA",
  },
  {
    zip: "17361",
    ST: "PA",
    cityWithStateAbbr: "Shrewsbury, PA",
  },
  {
    zip: "17362",
    ST: "PA",
    cityWithStateAbbr: "Spring Grove, PA",
  },
  {
    zip: "17363",
    ST: "PA",
    cityWithStateAbbr: "Stewartstown, PA",
  },
  {
    zip: "17364",
    ST: "PA",
    cityWithStateAbbr: "Thomasville, PA",
  },
  {
    zip: "17365",
    ST: "PA",
    cityWithStateAbbr: "Wellsville, PA",
  },
  {
    zip: "17366",
    ST: "PA",
    cityWithStateAbbr: "Windsor, PA",
  },
  {
    zip: "17368",
    ST: "PA",
    cityWithStateAbbr: "Wrightsville, PA",
  },
  {
    zip: "17370",
    ST: "PA",
    cityWithStateAbbr: "York Haven, PA",
  },
  {
    zip: "17371",
    ST: "PA",
    cityWithStateAbbr: "York New Salem, PA",
  },
  {
    zip: "17372",
    ST: "PA",
    cityWithStateAbbr: "York Springs, PA",
  },
  {
    zip: "17375",
    ST: "PA",
    cityWithStateAbbr: "Peach Glen, PA",
  },
  {
    zip: "17401",
    ST: "PA",
    cityWithStateAbbr: "York, PA",
  },
  {
    zip: "17402",
    ST: "PA",
    cityWithStateAbbr: "York, PA",
  },
  {
    zip: "17403",
    ST: "PA",
    cityWithStateAbbr: "York, PA",
  },
  {
    zip: "17404",
    ST: "PA",
    cityWithStateAbbr: "York, PA",
  },
  {
    zip: "17405",
    ST: "PA",
    cityWithStateAbbr: "York, PA",
  },
  {
    zip: "17406",
    ST: "PA",
    cityWithStateAbbr: "York, PA",
  },
  {
    zip: "17407",
    ST: "PA",
    cityWithStateAbbr: "York, PA",
  },
  {
    zip: "17408",
    ST: "PA",
    cityWithStateAbbr: "York, PA",
  },
  {
    zip: "17415",
    ST: "PA",
    cityWithStateAbbr: "York, PA",
  },
  {
    zip: "17501",
    ST: "PA",
    cityWithStateAbbr: "Akron, PA",
  },
  {
    zip: "17502",
    ST: "PA",
    cityWithStateAbbr: "Bainbridge, PA",
  },
  {
    zip: "17503",
    ST: "PA",
    cityWithStateAbbr: "Bart, PA",
  },
  {
    zip: "17504",
    ST: "PA",
    cityWithStateAbbr: "Bausman, PA",
  },
  {
    zip: "17505",
    ST: "PA",
    cityWithStateAbbr: "Bird In Hand, PA",
  },
  {
    zip: "17506",
    ST: "PA",
    cityWithStateAbbr: "Blue Ball, PA",
  },
  {
    zip: "17507",
    ST: "PA",
    cityWithStateAbbr: "Bowmansville, PA",
  },
  {
    zip: "17508",
    ST: "PA",
    cityWithStateAbbr: "Brownstown, PA",
  },
  {
    zip: "17509",
    ST: "PA",
    cityWithStateAbbr: "Christiana, PA",
  },
  {
    zip: "17512",
    ST: "PA",
    cityWithStateAbbr: "Columbia, PA",
  },
  {
    zip: "17516",
    ST: "PA",
    cityWithStateAbbr: "Conestoga, PA",
  },
  {
    zip: "17517",
    ST: "PA",
    cityWithStateAbbr: "Denver, PA",
  },
  {
    zip: "17518",
    ST: "PA",
    cityWithStateAbbr: "Drumore, PA",
  },
  {
    zip: "17519",
    ST: "PA",
    cityWithStateAbbr: "East Earl, PA",
  },
  {
    zip: "17520",
    ST: "PA",
    cityWithStateAbbr: "East Petersburg, PA",
  },
  {
    zip: "17521",
    ST: "PA",
    cityWithStateAbbr: "Elm, PA",
  },
  {
    zip: "17522",
    ST: "PA",
    cityWithStateAbbr: "Ephrata, PA",
  },
  {
    zip: "17527",
    ST: "PA",
    cityWithStateAbbr: "Gap, PA",
  },
  {
    zip: "17528",
    ST: "PA",
    cityWithStateAbbr: "Goodville, PA",
  },
  {
    zip: "17529",
    ST: "PA",
    cityWithStateAbbr: "Gordonville, PA",
  },
  {
    zip: "17532",
    ST: "PA",
    cityWithStateAbbr: "Holtwood, PA",
  },
  {
    zip: "17533",
    ST: "PA",
    cityWithStateAbbr: "Hopeland, PA",
  },
  {
    zip: "17534",
    ST: "PA",
    cityWithStateAbbr: "Intercourse, PA",
  },
  {
    zip: "17535",
    ST: "PA",
    cityWithStateAbbr: "Kinzers, PA",
  },
  {
    zip: "17536",
    ST: "PA",
    cityWithStateAbbr: "Kirkwood, PA",
  },
  {
    zip: "17537",
    ST: "PA",
    cityWithStateAbbr: "Lampeter, PA",
  },
  {
    zip: "17538",
    ST: "PA",
    cityWithStateAbbr: "Landisville, PA",
  },
  {
    zip: "17540",
    ST: "PA",
    cityWithStateAbbr: "Leola, PA",
  },
  {
    zip: "17543",
    ST: "PA",
    cityWithStateAbbr: "Lititz, PA",
  },
  {
    zip: "17545",
    ST: "PA",
    cityWithStateAbbr: "Manheim, PA",
  },
  {
    zip: "17547",
    ST: "PA",
    cityWithStateAbbr: "Marietta, PA",
  },
  {
    zip: "17549",
    ST: "PA",
    cityWithStateAbbr: "Martindale, PA",
  },
  {
    zip: "17550",
    ST: "PA",
    cityWithStateAbbr: "Maytown, PA",
  },
  {
    zip: "17551",
    ST: "PA",
    cityWithStateAbbr: "Millersville, PA",
  },
  {
    zip: "17552",
    ST: "PA",
    cityWithStateAbbr: "Mount Joy, PA",
  },
  {
    zip: "17554",
    ST: "PA",
    cityWithStateAbbr: "Mountville, PA",
  },
  {
    zip: "17555",
    ST: "PA",
    cityWithStateAbbr: "Narvon, PA",
  },
  {
    zip: "17557",
    ST: "PA",
    cityWithStateAbbr: "New Holland, PA",
  },
  {
    zip: "17560",
    ST: "PA",
    cityWithStateAbbr: "New Providence, PA",
  },
  {
    zip: "17562",
    ST: "PA",
    cityWithStateAbbr: "Paradise, PA",
  },
  {
    zip: "17563",
    ST: "PA",
    cityWithStateAbbr: "Peach Bottom, PA",
  },
  {
    zip: "17564",
    ST: "PA",
    cityWithStateAbbr: "Penryn, PA",
  },
  {
    zip: "17565",
    ST: "PA",
    cityWithStateAbbr: "Pequea, PA",
  },
  {
    zip: "17566",
    ST: "PA",
    cityWithStateAbbr: "Quarryville, PA",
  },
  {
    zip: "17567",
    ST: "PA",
    cityWithStateAbbr: "Reamstown, PA",
  },
  {
    zip: "17568",
    ST: "PA",
    cityWithStateAbbr: "Refton, PA",
  },
  {
    zip: "17569",
    ST: "PA",
    cityWithStateAbbr: "Reinholds, PA",
  },
  {
    zip: "17570",
    ST: "PA",
    cityWithStateAbbr: "Rheems, PA",
  },
  {
    zip: "17572",
    ST: "PA",
    cityWithStateAbbr: "Ronks, PA",
  },
  {
    zip: "17573",
    ST: "PA",
    cityWithStateAbbr: "Lancaster, PA",
  },
  {
    zip: "17575",
    ST: "PA",
    cityWithStateAbbr: "Silver Spring, PA",
  },
  {
    zip: "17576",
    ST: "PA",
    cityWithStateAbbr: "Smoketown, PA",
  },
  {
    zip: "17578",
    ST: "PA",
    cityWithStateAbbr: "Stevens, PA",
  },
  {
    zip: "17579",
    ST: "PA",
    cityWithStateAbbr: "Strasburg, PA",
  },
  {
    zip: "17580",
    ST: "PA",
    cityWithStateAbbr: "Talmage, PA",
  },
  {
    zip: "17581",
    ST: "PA",
    cityWithStateAbbr: "Terre Hill, PA",
  },
  {
    zip: "17582",
    ST: "PA",
    cityWithStateAbbr: "Washington Boro, PA",
  },
  {
    zip: "17583",
    ST: "PA",
    cityWithStateAbbr: "West Willow, PA",
  },
  {
    zip: "17584",
    ST: "PA",
    cityWithStateAbbr: "Willow Street, PA",
  },
  {
    zip: "17585",
    ST: "PA",
    cityWithStateAbbr: "Witmer, PA",
  },
  {
    zip: "17601",
    ST: "PA",
    cityWithStateAbbr: "Lancaster, PA",
  },
  {
    zip: "17602",
    ST: "PA",
    cityWithStateAbbr: "Lancaster, PA",
  },
  {
    zip: "17603",
    ST: "PA",
    cityWithStateAbbr: "Lancaster, PA",
  },
  {
    zip: "17604",
    ST: "PA",
    cityWithStateAbbr: "Lancaster, PA",
  },
  {
    zip: "17605",
    ST: "PA",
    cityWithStateAbbr: "Lancaster, PA",
  },
  {
    zip: "17606",
    ST: "PA",
    cityWithStateAbbr: "Lancaster, PA",
  },
  {
    zip: "17607",
    ST: "PA",
    cityWithStateAbbr: "Lancaster, PA",
  },
  {
    zip: "17608",
    ST: "PA",
    cityWithStateAbbr: "Lancaster, PA",
  },
  {
    zip: "17611",
    ST: "PA",
    cityWithStateAbbr: "Lancaster, PA",
  },
  {
    zip: "17622",
    ST: "PA",
    cityWithStateAbbr: "Lancaster, PA",
  },
  {
    zip: "17701",
    ST: "PA",
    cityWithStateAbbr: "Williamsport, PA",
  },
  {
    zip: "17702",
    ST: "PA",
    cityWithStateAbbr: "Williamsport, PA",
  },
  {
    zip: "17703",
    ST: "PA",
    cityWithStateAbbr: "Williamsport, PA",
  },
  {
    zip: "17705",
    ST: "PA",
    cityWithStateAbbr: "Williamsport, PA",
  },
  {
    zip: "17720",
    ST: "PA",
    cityWithStateAbbr: "Antes Fort, PA",
  },
  {
    zip: "17721",
    ST: "PA",
    cityWithStateAbbr: "Avis, PA",
  },
  {
    zip: "17723",
    ST: "PA",
    cityWithStateAbbr: "Cammal, PA",
  },
  {
    zip: "17724",
    ST: "PA",
    cityWithStateAbbr: "Canton, PA",
  },
  {
    zip: "17726",
    ST: "PA",
    cityWithStateAbbr: "Castanea, PA",
  },
  {
    zip: "17727",
    ST: "PA",
    cityWithStateAbbr: "Cedar Run, PA",
  },
  {
    zip: "17728",
    ST: "PA",
    cityWithStateAbbr: "Cogan Station, PA",
  },
  {
    zip: "17729",
    ST: "PA",
    cityWithStateAbbr: "Cross Fork, PA",
  },
  {
    zip: "17730",
    ST: "PA",
    cityWithStateAbbr: "Dewart, PA",
  },
  {
    zip: "17731",
    ST: "PA",
    cityWithStateAbbr: "Eagles Mere, PA",
  },
  {
    zip: "17735",
    ST: "PA",
    cityWithStateAbbr: "Grover, PA",
  },
  {
    zip: "17737",
    ST: "PA",
    cityWithStateAbbr: "Hughesville, PA",
  },
  {
    zip: "17738",
    ST: "PA",
    cityWithStateAbbr: "Renovo, PA",
  },
  {
    zip: "17739",
    ST: "PA",
    cityWithStateAbbr: "Jersey Mills, PA",
  },
  {
    zip: "17740",
    ST: "PA",
    cityWithStateAbbr: "Jersey Shore, PA",
  },
  {
    zip: "17742",
    ST: "PA",
    cityWithStateAbbr: "Lairdsville, PA",
  },
  {
    zip: "17744",
    ST: "PA",
    cityWithStateAbbr: "Linden, PA",
  },
  {
    zip: "17745",
    ST: "PA",
    cityWithStateAbbr: "Lock Haven, PA",
  },
  {
    zip: "17747",
    ST: "PA",
    cityWithStateAbbr: "Loganton, PA",
  },
  {
    zip: "17748",
    ST: "PA",
    cityWithStateAbbr: "Mc Elhattan, PA",
  },
  {
    zip: "17749",
    ST: "PA",
    cityWithStateAbbr: "Mc Ewensville, PA",
  },
  {
    zip: "17750",
    ST: "PA",
    cityWithStateAbbr: "Mackeyville, PA",
  },
  {
    zip: "17751",
    ST: "PA",
    cityWithStateAbbr: "Mill Hall, PA",
  },
  {
    zip: "17752",
    ST: "PA",
    cityWithStateAbbr: "Montgomery, PA",
  },
  {
    zip: "17754",
    ST: "PA",
    cityWithStateAbbr: "Montoursville, PA",
  },
  {
    zip: "17756",
    ST: "PA",
    cityWithStateAbbr: "Muncy, PA",
  },
  {
    zip: "17758",
    ST: "PA",
    cityWithStateAbbr: "Muncy Valley, PA",
  },
  {
    zip: "17760",
    ST: "PA",
    cityWithStateAbbr: "North Bend, PA",
  },
  {
    zip: "17762",
    ST: "PA",
    cityWithStateAbbr: "Picture Rocks, PA",
  },
  {
    zip: "17763",
    ST: "PA",
    cityWithStateAbbr: "Ralston, PA",
  },
  {
    zip: "17764",
    ST: "PA",
    cityWithStateAbbr: "Renovo, PA",
  },
  {
    zip: "17765",
    ST: "PA",
    cityWithStateAbbr: "Roaring Branch, PA",
  },
  {
    zip: "17767",
    ST: "PA",
    cityWithStateAbbr: "Salona, PA",
  },
  {
    zip: "17768",
    ST: "PA",
    cityWithStateAbbr: "Shunk, PA",
  },
  {
    zip: "17769",
    ST: "PA",
    cityWithStateAbbr: "Slate Run, PA",
  },
  {
    zip: "17771",
    ST: "PA",
    cityWithStateAbbr: "Trout Run, PA",
  },
  {
    zip: "17772",
    ST: "PA",
    cityWithStateAbbr: "Turbotville, PA",
  },
  {
    zip: "17774",
    ST: "PA",
    cityWithStateAbbr: "Unityville, PA",
  },
  {
    zip: "17776",
    ST: "PA",
    cityWithStateAbbr: "Waterville, PA",
  },
  {
    zip: "17777",
    ST: "PA",
    cityWithStateAbbr: "Watsontown, PA",
  },
  {
    zip: "17778",
    ST: "PA",
    cityWithStateAbbr: "Westport, PA",
  },
  {
    zip: "17779",
    ST: "PA",
    cityWithStateAbbr: "Woolrich, PA",
  },
  {
    zip: "17801",
    ST: "PA",
    cityWithStateAbbr: "Sunbury, PA",
  },
  {
    zip: "17810",
    ST: "PA",
    cityWithStateAbbr: "Allenwood, PA",
  },
  {
    zip: "17812",
    ST: "PA",
    cityWithStateAbbr: "Beaver Springs, PA",
  },
  {
    zip: "17813",
    ST: "PA",
    cityWithStateAbbr: "Beavertown, PA",
  },
  {
    zip: "17814",
    ST: "PA",
    cityWithStateAbbr: "Benton, PA",
  },
  {
    zip: "17815",
    ST: "PA",
    cityWithStateAbbr: "Bloomsburg, PA",
  },
  {
    zip: "17820",
    ST: "PA",
    cityWithStateAbbr: "Catawissa, PA",
  },
  {
    zip: "17821",
    ST: "PA",
    cityWithStateAbbr: "Danville, PA",
  },
  {
    zip: "17822",
    ST: "PA",
    cityWithStateAbbr: "Danville, PA",
  },
  {
    zip: "17823",
    ST: "PA",
    cityWithStateAbbr: "Dornsife, PA",
  },
  {
    zip: "17824",
    ST: "PA",
    cityWithStateAbbr: "Elysburg, PA",
  },
  {
    zip: "17827",
    ST: "PA",
    cityWithStateAbbr: "Freeburg, PA",
  },
  {
    zip: "17829",
    ST: "PA",
    cityWithStateAbbr: "Hartleton, PA",
  },
  {
    zip: "17830",
    ST: "PA",
    cityWithStateAbbr: "Herndon, PA",
  },
  {
    zip: "17831",
    ST: "PA",
    cityWithStateAbbr: "Hummels Wharf, PA",
  },
  {
    zip: "17832",
    ST: "PA",
    cityWithStateAbbr: "Marion Heights, PA",
  },
  {
    zip: "17833",
    ST: "PA",
    cityWithStateAbbr: "Kreamer, PA",
  },
  {
    zip: "17834",
    ST: "PA",
    cityWithStateAbbr: "Kulpmont, PA",
  },
  {
    zip: "17835",
    ST: "PA",
    cityWithStateAbbr: "Laurelton, PA",
  },
  {
    zip: "17836",
    ST: "PA",
    cityWithStateAbbr: "Leck Kill, PA",
  },
  {
    zip: "17837",
    ST: "PA",
    cityWithStateAbbr: "Lewisburg, PA",
  },
  {
    zip: "17839",
    ST: "PA",
    cityWithStateAbbr: "Lightstreet, PA",
  },
  {
    zip: "17840",
    ST: "PA",
    cityWithStateAbbr: "Locust Gap, PA",
  },
  {
    zip: "17841",
    ST: "PA",
    cityWithStateAbbr: "Mc Clure, PA",
  },
  {
    zip: "17842",
    ST: "PA",
    cityWithStateAbbr: "Middleburg, PA",
  },
  {
    zip: "17843",
    ST: "PA",
    cityWithStateAbbr: "Beaver Springs, PA",
  },
  {
    zip: "17844",
    ST: "PA",
    cityWithStateAbbr: "Mifflinburg, PA",
  },
  {
    zip: "17845",
    ST: "PA",
    cityWithStateAbbr: "Millmont, PA",
  },
  {
    zip: "17846",
    ST: "PA",
    cityWithStateAbbr: "Millville, PA",
  },
  {
    zip: "17847",
    ST: "PA",
    cityWithStateAbbr: "Milton, PA",
  },
  {
    zip: "17850",
    ST: "PA",
    cityWithStateAbbr: "Montandon, PA",
  },
  {
    zip: "17851",
    ST: "PA",
    cityWithStateAbbr: "Mount Carmel, PA",
  },
  {
    zip: "17853",
    ST: "PA",
    cityWithStateAbbr: "Mount Pleasant Mills, PA",
  },
  {
    zip: "17855",
    ST: "PA",
    cityWithStateAbbr: "New Berlin, PA",
  },
  {
    zip: "17856",
    ST: "PA",
    cityWithStateAbbr: "New Columbia, PA",
  },
  {
    zip: "17857",
    ST: "PA",
    cityWithStateAbbr: "Northumberland, PA",
  },
  {
    zip: "17858",
    ST: "PA",
    cityWithStateAbbr: "Numidia, PA",
  },
  {
    zip: "17859",
    ST: "PA",
    cityWithStateAbbr: "Orangeville, PA",
  },
  {
    zip: "17860",
    ST: "PA",
    cityWithStateAbbr: "Paxinos, PA",
  },
  {
    zip: "17861",
    ST: "PA",
    cityWithStateAbbr: "Paxtonville, PA",
  },
  {
    zip: "17862",
    ST: "PA",
    cityWithStateAbbr: "Penns Creek, PA",
  },
  {
    zip: "17864",
    ST: "PA",
    cityWithStateAbbr: "Port Trevorton, PA",
  },
  {
    zip: "17865",
    ST: "PA",
    cityWithStateAbbr: "Potts Grove, PA",
  },
  {
    zip: "17866",
    ST: "PA",
    cityWithStateAbbr: "Coal Township, PA",
  },
  {
    zip: "17867",
    ST: "PA",
    cityWithStateAbbr: "Rebuck, PA",
  },
  {
    zip: "17868",
    ST: "PA",
    cityWithStateAbbr: "Riverside, PA",
  },
  {
    zip: "17870",
    ST: "PA",
    cityWithStateAbbr: "Selinsgrove, PA",
  },
  {
    zip: "17872",
    ST: "PA",
    cityWithStateAbbr: "Shamokin, PA",
  },
  {
    zip: "17876",
    ST: "PA",
    cityWithStateAbbr: "Shamokin Dam, PA",
  },
  {
    zip: "17877",
    ST: "PA",
    cityWithStateAbbr: "Snydertown, PA",
  },
  {
    zip: "17878",
    ST: "PA",
    cityWithStateAbbr: "Stillwater, PA",
  },
  {
    zip: "17880",
    ST: "PA",
    cityWithStateAbbr: "Swengel, PA",
  },
  {
    zip: "17881",
    ST: "PA",
    cityWithStateAbbr: "Trevorton, PA",
  },
  {
    zip: "17882",
    ST: "PA",
    cityWithStateAbbr: "Troxelville, PA",
  },
  {
    zip: "17883",
    ST: "PA",
    cityWithStateAbbr: "Vicksburg, PA",
  },
  {
    zip: "17884",
    ST: "PA",
    cityWithStateAbbr: "Washingtonville, PA",
  },
  {
    zip: "17885",
    ST: "PA",
    cityWithStateAbbr: "Weikert, PA",
  },
  {
    zip: "17886",
    ST: "PA",
    cityWithStateAbbr: "West Milton, PA",
  },
  {
    zip: "17887",
    ST: "PA",
    cityWithStateAbbr: "White Deer, PA",
  },
  {
    zip: "17888",
    ST: "PA",
    cityWithStateAbbr: "Wilburton, PA",
  },
  {
    zip: "17889",
    ST: "PA",
    cityWithStateAbbr: "Winfield, PA",
  },
  {
    zip: "17901",
    ST: "PA",
    cityWithStateAbbr: "Pottsville, PA",
  },
  {
    zip: "17920",
    ST: "PA",
    cityWithStateAbbr: "Aristes, PA",
  },
  {
    zip: "17921",
    ST: "PA",
    cityWithStateAbbr: "Ashland, PA",
  },
  {
    zip: "17922",
    ST: "PA",
    cityWithStateAbbr: "Auburn, PA",
  },
  {
    zip: "17923",
    ST: "PA",
    cityWithStateAbbr: "Branchdale, PA",
  },
  {
    zip: "17925",
    ST: "PA",
    cityWithStateAbbr: "Brockton, PA",
  },
  {
    zip: "17929",
    ST: "PA",
    cityWithStateAbbr: "Cressona, PA",
  },
  {
    zip: "17930",
    ST: "PA",
    cityWithStateAbbr: "Cumbola, PA",
  },
  {
    zip: "17931",
    ST: "PA",
    cityWithStateAbbr: "Frackville, PA",
  },
  {
    zip: "17932",
    ST: "PA",
    cityWithStateAbbr: "Frackville, PA",
  },
  {
    zip: "17933",
    ST: "PA",
    cityWithStateAbbr: "Friedensburg, PA",
  },
  {
    zip: "17934",
    ST: "PA",
    cityWithStateAbbr: "Gilberton, PA",
  },
  {
    zip: "17935",
    ST: "PA",
    cityWithStateAbbr: "Girardville, PA",
  },
  {
    zip: "17936",
    ST: "PA",
    cityWithStateAbbr: "Gordon, PA",
  },
  {
    zip: "17938",
    ST: "PA",
    cityWithStateAbbr: "Hegins, PA",
  },
  {
    zip: "17941",
    ST: "PA",
    cityWithStateAbbr: "Klingerstown, PA",
  },
  {
    zip: "17942",
    ST: "PA",
    cityWithStateAbbr: "Auburn, PA",
  },
  {
    zip: "17943",
    ST: "PA",
    cityWithStateAbbr: "Lavelle, PA",
  },
  {
    zip: "17944",
    ST: "PA",
    cityWithStateAbbr: "Llewellyn, PA",
  },
  {
    zip: "17945",
    ST: "PA",
    cityWithStateAbbr: "Locustdale, PA",
  },
  {
    zip: "17946",
    ST: "PA",
    cityWithStateAbbr: "Lost Creek, PA",
  },
  {
    zip: "17948",
    ST: "PA",
    cityWithStateAbbr: "Mahanoy City, PA",
  },
  {
    zip: "17949",
    ST: "PA",
    cityWithStateAbbr: "Mahanoy Plane, PA",
  },
  {
    zip: "17951",
    ST: "PA",
    cityWithStateAbbr: "Mar Lin, PA",
  },
  {
    zip: "17952",
    ST: "PA",
    cityWithStateAbbr: "Mary D, PA",
  },
  {
    zip: "17953",
    ST: "PA",
    cityWithStateAbbr: "Middleport, PA",
  },
  {
    zip: "17954",
    ST: "PA",
    cityWithStateAbbr: "Minersville, PA",
  },
  {
    zip: "17957",
    ST: "PA",
    cityWithStateAbbr: "Muir, PA",
  },
  {
    zip: "17959",
    ST: "PA",
    cityWithStateAbbr: "New Philadelphia, PA",
  },
  {
    zip: "17960",
    ST: "PA",
    cityWithStateAbbr: "New Ringgold, PA",
  },
  {
    zip: "17961",
    ST: "PA",
    cityWithStateAbbr: "Orwigsburg, PA",
  },
  {
    zip: "17963",
    ST: "PA",
    cityWithStateAbbr: "Pine Grove, PA",
  },
  {
    zip: "17964",
    ST: "PA",
    cityWithStateAbbr: "Pitman, PA",
  },
  {
    zip: "17965",
    ST: "PA",
    cityWithStateAbbr: "Port Carbon, PA",
  },
  {
    zip: "17966",
    ST: "PA",
    cityWithStateAbbr: "Ravine, PA",
  },
  {
    zip: "17967",
    ST: "PA",
    cityWithStateAbbr: "Ringtown, PA",
  },
  {
    zip: "17968",
    ST: "PA",
    cityWithStateAbbr: "Sacramento, PA",
  },
  {
    zip: "17970",
    ST: "PA",
    cityWithStateAbbr: "Saint Clair, PA",
  },
  {
    zip: "17972",
    ST: "PA",
    cityWithStateAbbr: "Schuylkill Haven, PA",
  },
  {
    zip: "17974",
    ST: "PA",
    cityWithStateAbbr: "Seltzer, PA",
  },
  {
    zip: "17976",
    ST: "PA",
    cityWithStateAbbr: "Shenandoah, PA",
  },
  {
    zip: "17978",
    ST: "PA",
    cityWithStateAbbr: "Spring Glen, PA",
  },
  {
    zip: "17979",
    ST: "PA",
    cityWithStateAbbr: "Summit Station, PA",
  },
  {
    zip: "17980",
    ST: "PA",
    cityWithStateAbbr: "Tower City, PA",
  },
  {
    zip: "17981",
    ST: "PA",
    cityWithStateAbbr: "Tremont, PA",
  },
  {
    zip: "17982",
    ST: "PA",
    cityWithStateAbbr: "Tuscarora, PA",
  },
  {
    zip: "17983",
    ST: "PA",
    cityWithStateAbbr: "Valley View, PA",
  },
  {
    zip: "17985",
    ST: "PA",
    cityWithStateAbbr: "Zion Grove, PA",
  },
  {
    zip: "18001",
    ST: "PA",
    cityWithStateAbbr: "Lehigh Valley, PA",
  },
  {
    zip: "18002",
    ST: "PA",
    cityWithStateAbbr: "Lehigh Valley, PA",
  },
  {
    zip: "18003",
    ST: "PA",
    cityWithStateAbbr: "Lehigh Valley, PA",
  },
  {
    zip: "18010",
    ST: "PA",
    cityWithStateAbbr: "Ackermanville, PA",
  },
  {
    zip: "18011",
    ST: "PA",
    cityWithStateAbbr: "Alburtis, PA",
  },
  {
    zip: "18012",
    ST: "PA",
    cityWithStateAbbr: "Aquashicola, PA",
  },
  {
    zip: "18013",
    ST: "PA",
    cityWithStateAbbr: "Bangor, PA",
  },
  {
    zip: "18014",
    ST: "PA",
    cityWithStateAbbr: "Bath, PA",
  },
  {
    zip: "18015",
    ST: "PA",
    cityWithStateAbbr: "Bethlehem, PA",
  },
  {
    zip: "18016",
    ST: "PA",
    cityWithStateAbbr: "Bethlehem, PA",
  },
  {
    zip: "18017",
    ST: "PA",
    cityWithStateAbbr: "Bethlehem, PA",
  },
  {
    zip: "18018",
    ST: "PA",
    cityWithStateAbbr: "Bethlehem, PA",
  },
  {
    zip: "18020",
    ST: "PA",
    cityWithStateAbbr: "Bethlehem, PA",
  },
  {
    zip: "18025",
    ST: "PA",
    cityWithStateAbbr: "Bethlehem, PA",
  },
  {
    zip: "18030",
    ST: "PA",
    cityWithStateAbbr: "Bowmanstown, PA",
  },
  {
    zip: "18031",
    ST: "PA",
    cityWithStateAbbr: "Breinigsville, PA",
  },
  {
    zip: "18032",
    ST: "PA",
    cityWithStateAbbr: "Catasauqua, PA",
  },
  {
    zip: "18034",
    ST: "PA",
    cityWithStateAbbr: "Center Valley, PA",
  },
  {
    zip: "18035",
    ST: "PA",
    cityWithStateAbbr: "Cherryville, PA",
  },
  {
    zip: "18036",
    ST: "PA",
    cityWithStateAbbr: "Coopersburg, PA",
  },
  {
    zip: "18037",
    ST: "PA",
    cityWithStateAbbr: "Coplay, PA",
  },
  {
    zip: "18038",
    ST: "PA",
    cityWithStateAbbr: "Danielsville, PA",
  },
  {
    zip: "18039",
    ST: "PA",
    cityWithStateAbbr: "Durham, PA",
  },
  {
    zip: "18040",
    ST: "PA",
    cityWithStateAbbr: "Easton, PA",
  },
  {
    zip: "18041",
    ST: "PA",
    cityWithStateAbbr: "East Greenville, PA",
  },
  {
    zip: "18042",
    ST: "PA",
    cityWithStateAbbr: "Easton, PA",
  },
  {
    zip: "18043",
    ST: "PA",
    cityWithStateAbbr: "Easton, PA",
  },
  {
    zip: "18044",
    ST: "PA",
    cityWithStateAbbr: "Easton, PA",
  },
  {
    zip: "18045",
    ST: "PA",
    cityWithStateAbbr: "Easton, PA",
  },
  {
    zip: "18046",
    ST: "PA",
    cityWithStateAbbr: "East Texas, PA",
  },
  {
    zip: "18049",
    ST: "PA",
    cityWithStateAbbr: "Emmaus, PA",
  },
  {
    zip: "18050",
    ST: "PA",
    cityWithStateAbbr: "Flicksville, PA",
  },
  {
    zip: "18051",
    ST: "PA",
    cityWithStateAbbr: "Fogelsville, PA",
  },
  {
    zip: "18052",
    ST: "PA",
    cityWithStateAbbr: "Whitehall, PA",
  },
  {
    zip: "18053",
    ST: "PA",
    cityWithStateAbbr: "Germansville, PA",
  },
  {
    zip: "18054",
    ST: "PA",
    cityWithStateAbbr: "Green Lane, PA",
  },
  {
    zip: "18055",
    ST: "PA",
    cityWithStateAbbr: "Hellertown, PA",
  },
  {
    zip: "18056",
    ST: "PA",
    cityWithStateAbbr: "Hereford, PA",
  },
  {
    zip: "18058",
    ST: "PA",
    cityWithStateAbbr: "Kunkletown, PA",
  },
  {
    zip: "18059",
    ST: "PA",
    cityWithStateAbbr: "Laurys Station, PA",
  },
  {
    zip: "18060",
    ST: "PA",
    cityWithStateAbbr: "Limeport, PA",
  },
  {
    zip: "18062",
    ST: "PA",
    cityWithStateAbbr: "Macungie, PA",
  },
  {
    zip: "18063",
    ST: "PA",
    cityWithStateAbbr: "Martins Creek, PA",
  },
  {
    zip: "18064",
    ST: "PA",
    cityWithStateAbbr: "Nazareth, PA",
  },
  {
    zip: "18065",
    ST: "PA",
    cityWithStateAbbr: "Neffs, PA",
  },
  {
    zip: "18066",
    ST: "PA",
    cityWithStateAbbr: "New Tripoli, PA",
  },
  {
    zip: "18067",
    ST: "PA",
    cityWithStateAbbr: "Northampton, PA",
  },
  {
    zip: "18068",
    ST: "PA",
    cityWithStateAbbr: "Old Zionsville, PA",
  },
  {
    zip: "18069",
    ST: "PA",
    cityWithStateAbbr: "Orefield, PA",
  },
  {
    zip: "18070",
    ST: "PA",
    cityWithStateAbbr: "Palm, PA",
  },
  {
    zip: "18071",
    ST: "PA",
    cityWithStateAbbr: "Palmerton, PA",
  },
  {
    zip: "18072",
    ST: "PA",
    cityWithStateAbbr: "Pen Argyl, PA",
  },
  {
    zip: "18073",
    ST: "PA",
    cityWithStateAbbr: "Pennsburg, PA",
  },
  {
    zip: "18074",
    ST: "PA",
    cityWithStateAbbr: "Perkiomenville, PA",
  },
  {
    zip: "18076",
    ST: "PA",
    cityWithStateAbbr: "Red Hill, PA",
  },
  {
    zip: "18077",
    ST: "PA",
    cityWithStateAbbr: "Riegelsville, PA",
  },
  {
    zip: "18078",
    ST: "PA",
    cityWithStateAbbr: "Schnecksville, PA",
  },
  {
    zip: "18079",
    ST: "PA",
    cityWithStateAbbr: "Slatedale, PA",
  },
  {
    zip: "18080",
    ST: "PA",
    cityWithStateAbbr: "Slatington, PA",
  },
  {
    zip: "18081",
    ST: "PA",
    cityWithStateAbbr: "Springtown, PA",
  },
  {
    zip: "18083",
    ST: "PA",
    cityWithStateAbbr: "Stockertown, PA",
  },
  {
    zip: "18084",
    ST: "PA",
    cityWithStateAbbr: "Sumneytown, PA",
  },
  {
    zip: "18085",
    ST: "PA",
    cityWithStateAbbr: "Tatamy, PA",
  },
  {
    zip: "18086",
    ST: "PA",
    cityWithStateAbbr: "Treichlers, PA",
  },
  {
    zip: "18087",
    ST: "PA",
    cityWithStateAbbr: "Trexlertown, PA",
  },
  {
    zip: "18088",
    ST: "PA",
    cityWithStateAbbr: "Walnutport, PA",
  },
  {
    zip: "18091",
    ST: "PA",
    cityWithStateAbbr: "Wind Gap, PA",
  },
  {
    zip: "18092",
    ST: "PA",
    cityWithStateAbbr: "Zionsville, PA",
  },
  {
    zip: "18098",
    ST: "PA",
    cityWithStateAbbr: "Emmaus, PA",
  },
  {
    zip: "18099",
    ST: "PA",
    cityWithStateAbbr: "Emmaus, PA",
  },
  {
    zip: "18101",
    ST: "PA",
    cityWithStateAbbr: "Allentown, PA",
  },
  {
    zip: "18102",
    ST: "PA",
    cityWithStateAbbr: "Allentown, PA",
  },
  {
    zip: "18103",
    ST: "PA",
    cityWithStateAbbr: "Allentown, PA",
  },
  {
    zip: "18104",
    ST: "PA",
    cityWithStateAbbr: "Allentown, PA",
  },
  {
    zip: "18105",
    ST: "PA",
    cityWithStateAbbr: "Allentown, PA",
  },
  {
    zip: "18106",
    ST: "PA",
    cityWithStateAbbr: "Allentown, PA",
  },
  {
    zip: "18109",
    ST: "PA",
    cityWithStateAbbr: "Allentown, PA",
  },
  {
    zip: "18195",
    ST: "PA",
    cityWithStateAbbr: "Allentown, PA",
  },
  {
    zip: "18201",
    ST: "PA",
    cityWithStateAbbr: "Hazleton, PA",
  },
  {
    zip: "18202",
    ST: "PA",
    cityWithStateAbbr: "Hazleton, PA",
  },
  {
    zip: "18210",
    ST: "PA",
    cityWithStateAbbr: "Albrightsville, PA",
  },
  {
    zip: "18211",
    ST: "PA",
    cityWithStateAbbr: "Andreas, PA",
  },
  {
    zip: "18212",
    ST: "PA",
    cityWithStateAbbr: "Ashfield, PA",
  },
  {
    zip: "18214",
    ST: "PA",
    cityWithStateAbbr: "Barnesville, PA",
  },
  {
    zip: "18216",
    ST: "PA",
    cityWithStateAbbr: "Beaver Meadows, PA",
  },
  {
    zip: "18218",
    ST: "PA",
    cityWithStateAbbr: "Coaldale, PA",
  },
  {
    zip: "18219",
    ST: "PA",
    cityWithStateAbbr: "Conyngham, PA",
  },
  {
    zip: "18220",
    ST: "PA",
    cityWithStateAbbr: "Delano, PA",
  },
  {
    zip: "18221",
    ST: "PA",
    cityWithStateAbbr: "Drifton, PA",
  },
  {
    zip: "18222",
    ST: "PA",
    cityWithStateAbbr: "Drums, PA",
  },
  {
    zip: "18223",
    ST: "PA",
    cityWithStateAbbr: "Ebervale, PA",
  },
  {
    zip: "18224",
    ST: "PA",
    cityWithStateAbbr: "Freeland, PA",
  },
  {
    zip: "18225",
    ST: "PA",
    cityWithStateAbbr: "Harleigh, PA",
  },
  {
    zip: "18229",
    ST: "PA",
    cityWithStateAbbr: "Jim Thorpe, PA",
  },
  {
    zip: "18230",
    ST: "PA",
    cityWithStateAbbr: "Junedale, PA",
  },
  {
    zip: "18231",
    ST: "PA",
    cityWithStateAbbr: "Kelayres, PA",
  },
  {
    zip: "18232",
    ST: "PA",
    cityWithStateAbbr: "Lansford, PA",
  },
  {
    zip: "18234",
    ST: "PA",
    cityWithStateAbbr: "Lattimer Mines, PA",
  },
  {
    zip: "18235",
    ST: "PA",
    cityWithStateAbbr: "Lehighton, PA",
  },
  {
    zip: "18237",
    ST: "PA",
    cityWithStateAbbr: "Mcadoo, PA",
  },
  {
    zip: "18239",
    ST: "PA",
    cityWithStateAbbr: "Milnesville, PA",
  },
  {
    zip: "18240",
    ST: "PA",
    cityWithStateAbbr: "Nesquehoning, PA",
  },
  {
    zip: "18241",
    ST: "PA",
    cityWithStateAbbr: "Nuremberg, PA",
  },
  {
    zip: "18242",
    ST: "PA",
    cityWithStateAbbr: "Oneida, PA",
  },
  {
    zip: "18244",
    ST: "PA",
    cityWithStateAbbr: "Parryville, PA",
  },
  {
    zip: "18245",
    ST: "PA",
    cityWithStateAbbr: "Quakake, PA",
  },
  {
    zip: "18246",
    ST: "PA",
    cityWithStateAbbr: "Rock Glen, PA",
  },
  {
    zip: "18247",
    ST: "PA",
    cityWithStateAbbr: "Saint Johns, PA",
  },
  {
    zip: "18248",
    ST: "PA",
    cityWithStateAbbr: "Sheppton, PA",
  },
  {
    zip: "18249",
    ST: "PA",
    cityWithStateAbbr: "Sugarloaf, PA",
  },
  {
    zip: "18250",
    ST: "PA",
    cityWithStateAbbr: "Summit Hill, PA",
  },
  {
    zip: "18251",
    ST: "PA",
    cityWithStateAbbr: "Sybertsville, PA",
  },
  {
    zip: "18252",
    ST: "PA",
    cityWithStateAbbr: "Tamaqua, PA",
  },
  {
    zip: "18254",
    ST: "PA",
    cityWithStateAbbr: "Tresckow, PA",
  },
  {
    zip: "18255",
    ST: "PA",
    cityWithStateAbbr: "Weatherly, PA",
  },
  {
    zip: "18256",
    ST: "PA",
    cityWithStateAbbr: "Weston, PA",
  },
  {
    zip: "18301",
    ST: "PA",
    cityWithStateAbbr: "East Stroudsburg, PA",
  },
  {
    zip: "18302",
    ST: "PA",
    cityWithStateAbbr: "East Stroudsburg, PA",
  },
  {
    zip: "18320",
    ST: "PA",
    cityWithStateAbbr: "Analomink, PA",
  },
  {
    zip: "18321",
    ST: "PA",
    cityWithStateAbbr: "Bartonsville, PA",
  },
  {
    zip: "18322",
    ST: "PA",
    cityWithStateAbbr: "Brodheadsville, PA",
  },
  {
    zip: "18323",
    ST: "PA",
    cityWithStateAbbr: "Buck Hill Falls, PA",
  },
  {
    zip: "18324",
    ST: "PA",
    cityWithStateAbbr: "Bushkill, PA",
  },
  {
    zip: "18325",
    ST: "PA",
    cityWithStateAbbr: "Canadensis, PA",
  },
  {
    zip: "18326",
    ST: "PA",
    cityWithStateAbbr: "Cresco, PA",
  },
  {
    zip: "18327",
    ST: "PA",
    cityWithStateAbbr: "Delaware Water Gap, PA",
  },
  {
    zip: "18328",
    ST: "PA",
    cityWithStateAbbr: "Dingmans Ferry, PA",
  },
  {
    zip: "18330",
    ST: "PA",
    cityWithStateAbbr: "Effort, PA",
  },
  {
    zip: "18331",
    ST: "PA",
    cityWithStateAbbr: "Gilbert, PA",
  },
  {
    zip: "18332",
    ST: "PA",
    cityWithStateAbbr: "Henryville, PA",
  },
  {
    zip: "18333",
    ST: "PA",
    cityWithStateAbbr: "Kresgeville, PA",
  },
  {
    zip: "18334",
    ST: "PA",
    cityWithStateAbbr: "Long Pond, PA",
  },
  {
    zip: "18335",
    ST: "PA",
    cityWithStateAbbr: "Marshalls Creek, PA",
  },
  {
    zip: "18336",
    ST: "PA",
    cityWithStateAbbr: "Matamoras, PA",
  },
  {
    zip: "18337",
    ST: "PA",
    cityWithStateAbbr: "Milford, PA",
  },
  {
    zip: "18340",
    ST: "PA",
    cityWithStateAbbr: "Millrift, PA",
  },
  {
    zip: "18341",
    ST: "PA",
    cityWithStateAbbr: "Minisink Hills, PA",
  },
  {
    zip: "18342",
    ST: "PA",
    cityWithStateAbbr: "Mountainhome, PA",
  },
  {
    zip: "18343",
    ST: "PA",
    cityWithStateAbbr: "Mount Bethel, PA",
  },
  {
    zip: "18344",
    ST: "PA",
    cityWithStateAbbr: "Mount Pocono, PA",
  },
  {
    zip: "18346",
    ST: "PA",
    cityWithStateAbbr: "Pocono Summit, PA",
  },
  {
    zip: "18347",
    ST: "PA",
    cityWithStateAbbr: "Pocono Lake, PA",
  },
  {
    zip: "18348",
    ST: "PA",
    cityWithStateAbbr: "Pocono Lake Preserve, PA",
  },
  {
    zip: "18349",
    ST: "PA",
    cityWithStateAbbr: "Pocono Manor, PA",
  },
  {
    zip: "18350",
    ST: "PA",
    cityWithStateAbbr: "Pocono Pines, PA",
  },
  {
    zip: "18351",
    ST: "PA",
    cityWithStateAbbr: "Portland, PA",
  },
  {
    zip: "18352",
    ST: "PA",
    cityWithStateAbbr: "Reeders, PA",
  },
  {
    zip: "18353",
    ST: "PA",
    cityWithStateAbbr: "Saylorsburg, PA",
  },
  {
    zip: "18354",
    ST: "PA",
    cityWithStateAbbr: "Sciota, PA",
  },
  {
    zip: "18355",
    ST: "PA",
    cityWithStateAbbr: "Scotrun, PA",
  },
  {
    zip: "18356",
    ST: "PA",
    cityWithStateAbbr: "Shawnee On Delaware, PA",
  },
  {
    zip: "18357",
    ST: "PA",
    cityWithStateAbbr: "Skytop, PA",
  },
  {
    zip: "18360",
    ST: "PA",
    cityWithStateAbbr: "Stroudsburg, PA",
  },
  {
    zip: "18370",
    ST: "PA",
    cityWithStateAbbr: "Swiftwater, PA",
  },
  {
    zip: "18371",
    ST: "PA",
    cityWithStateAbbr: "Tamiment, PA",
  },
  {
    zip: "18372",
    ST: "PA",
    cityWithStateAbbr: "Tannersville, PA",
  },
  {
    zip: "18373",
    ST: "PA",
    cityWithStateAbbr: "Unity House, PA",
  },
  {
    zip: "18403",
    ST: "PA",
    cityWithStateAbbr: "Archbald, PA",
  },
  {
    zip: "18405",
    ST: "PA",
    cityWithStateAbbr: "Beach Lake, PA",
  },
  {
    zip: "18407",
    ST: "PA",
    cityWithStateAbbr: "Carbondale, PA",
  },
  {
    zip: "18410",
    ST: "PA",
    cityWithStateAbbr: "Chinchilla, PA",
  },
  {
    zip: "18411",
    ST: "PA",
    cityWithStateAbbr: "Clarks Summit, PA",
  },
  {
    zip: "18413",
    ST: "PA",
    cityWithStateAbbr: "Clifford, PA",
  },
  {
    zip: "18414",
    ST: "PA",
    cityWithStateAbbr: "Dalton, PA",
  },
  {
    zip: "18415",
    ST: "PA",
    cityWithStateAbbr: "Damascus, PA",
  },
  {
    zip: "18416",
    ST: "PA",
    cityWithStateAbbr: "Elmhurst, PA",
  },
  {
    zip: "18417",
    ST: "PA",
    cityWithStateAbbr: "Equinunk, PA",
  },
  {
    zip: "18419",
    ST: "PA",
    cityWithStateAbbr: "Factoryville, PA",
  },
  {
    zip: "18420",
    ST: "PA",
    cityWithStateAbbr: "Fleetville, PA",
  },
  {
    zip: "18421",
    ST: "PA",
    cityWithStateAbbr: "Forest City, PA",
  },
  {
    zip: "18424",
    ST: "PA",
    cityWithStateAbbr: "Gouldsboro, PA",
  },
  {
    zip: "18425",
    ST: "PA",
    cityWithStateAbbr: "Greeley, PA",
  },
  {
    zip: "18426",
    ST: "PA",
    cityWithStateAbbr: "Greentown, PA",
  },
  {
    zip: "18427",
    ST: "PA",
    cityWithStateAbbr: "Hamlin, PA",
  },
  {
    zip: "18428",
    ST: "PA",
    cityWithStateAbbr: "Hawley, PA",
  },
  {
    zip: "18430",
    ST: "PA",
    cityWithStateAbbr: "Herrick Center, PA",
  },
  {
    zip: "18431",
    ST: "PA",
    cityWithStateAbbr: "Honesdale, PA",
  },
  {
    zip: "18433",
    ST: "PA",
    cityWithStateAbbr: "Jermyn, PA",
  },
  {
    zip: "18434",
    ST: "PA",
    cityWithStateAbbr: "Jessup, PA",
  },
  {
    zip: "18435",
    ST: "PA",
    cityWithStateAbbr: "Lackawaxen, PA",
  },
  {
    zip: "18436",
    ST: "PA",
    cityWithStateAbbr: "Lake Ariel, PA",
  },
  {
    zip: "18437",
    ST: "PA",
    cityWithStateAbbr: "Lake Como, PA",
  },
  {
    zip: "18438",
    ST: "PA",
    cityWithStateAbbr: "Lakeville, PA",
  },
  {
    zip: "18439",
    ST: "PA",
    cityWithStateAbbr: "Lakewood, PA",
  },
  {
    zip: "18440",
    ST: "PA",
    cityWithStateAbbr: "La Plume, PA",
  },
  {
    zip: "18441",
    ST: "PA",
    cityWithStateAbbr: "Lenoxville, PA",
  },
  {
    zip: "18443",
    ST: "PA",
    cityWithStateAbbr: "Milanville, PA",
  },
  {
    zip: "18444",
    ST: "PA",
    cityWithStateAbbr: "Moscow, PA",
  },
  {
    zip: "18445",
    ST: "PA",
    cityWithStateAbbr: "Newfoundland, PA",
  },
  {
    zip: "18446",
    ST: "PA",
    cityWithStateAbbr: "Nicholson, PA",
  },
  {
    zip: "18447",
    ST: "PA",
    cityWithStateAbbr: "Olyphant, PA",
  },
  {
    zip: "18448",
    ST: "PA",
    cityWithStateAbbr: "Olyphant, PA",
  },
  {
    zip: "18449",
    ST: "PA",
    cityWithStateAbbr: "Orson, PA",
  },
  {
    zip: "18451",
    ST: "PA",
    cityWithStateAbbr: "Paupack, PA",
  },
  {
    zip: "18452",
    ST: "PA",
    cityWithStateAbbr: "Peckville, PA",
  },
  {
    zip: "18453",
    ST: "PA",
    cityWithStateAbbr: "Pleasant Mount, PA",
  },
  {
    zip: "18454",
    ST: "PA",
    cityWithStateAbbr: "Poyntelle, PA",
  },
  {
    zip: "18455",
    ST: "PA",
    cityWithStateAbbr: "Preston Park, PA",
  },
  {
    zip: "18456",
    ST: "PA",
    cityWithStateAbbr: "Prompton, PA",
  },
  {
    zip: "18457",
    ST: "PA",
    cityWithStateAbbr: "Rowland, PA",
  },
  {
    zip: "18458",
    ST: "PA",
    cityWithStateAbbr: "Shohola, PA",
  },
  {
    zip: "18459",
    ST: "PA",
    cityWithStateAbbr: "South Canaan, PA",
  },
  {
    zip: "18460",
    ST: "PA",
    cityWithStateAbbr: "South Sterling, PA",
  },
  {
    zip: "18461",
    ST: "PA",
    cityWithStateAbbr: "Starlight, PA",
  },
  {
    zip: "18462",
    ST: "PA",
    cityWithStateAbbr: "Starrucca, PA",
  },
  {
    zip: "18463",
    ST: "PA",
    cityWithStateAbbr: "Sterling, PA",
  },
  {
    zip: "18464",
    ST: "PA",
    cityWithStateAbbr: "Tafton, PA",
  },
  {
    zip: "18465",
    ST: "PA",
    cityWithStateAbbr: "Thompson, PA",
  },
  {
    zip: "18466",
    ST: "PA",
    cityWithStateAbbr: "Tobyhanna, PA",
  },
  {
    zip: "18469",
    ST: "PA",
    cityWithStateAbbr: "Tyler Hill, PA",
  },
  {
    zip: "18470",
    ST: "PA",
    cityWithStateAbbr: "Union Dale, PA",
  },
  {
    zip: "18471",
    ST: "PA",
    cityWithStateAbbr: "Waverly, PA",
  },
  {
    zip: "18472",
    ST: "PA",
    cityWithStateAbbr: "Waymart, PA",
  },
  {
    zip: "18473",
    ST: "PA",
    cityWithStateAbbr: "White Mills, PA",
  },
  {
    zip: "18501",
    ST: "PA",
    cityWithStateAbbr: "Scranton, PA",
  },
  {
    zip: "18502",
    ST: "PA",
    cityWithStateAbbr: "Scranton, PA",
  },
  {
    zip: "18503",
    ST: "PA",
    cityWithStateAbbr: "Scranton, PA",
  },
  {
    zip: "18504",
    ST: "PA",
    cityWithStateAbbr: "Scranton, PA",
  },
  {
    zip: "18505",
    ST: "PA",
    cityWithStateAbbr: "Scranton, PA",
  },
  {
    zip: "18507",
    ST: "PA",
    cityWithStateAbbr: "Moosic, PA",
  },
  {
    zip: "18508",
    ST: "PA",
    cityWithStateAbbr: "Scranton, PA",
  },
  {
    zip: "18509",
    ST: "PA",
    cityWithStateAbbr: "Scranton, PA",
  },
  {
    zip: "18510",
    ST: "PA",
    cityWithStateAbbr: "Scranton, PA",
  },
  {
    zip: "18512",
    ST: "PA",
    cityWithStateAbbr: "Scranton, PA",
  },
  {
    zip: "18515",
    ST: "PA",
    cityWithStateAbbr: "Scranton, PA",
  },
  {
    zip: "18517",
    ST: "PA",
    cityWithStateAbbr: "Taylor, PA",
  },
  {
    zip: "18518",
    ST: "PA",
    cityWithStateAbbr: "Old Forge, PA",
  },
  {
    zip: "18519",
    ST: "PA",
    cityWithStateAbbr: "Scranton, PA",
  },
  {
    zip: "18540",
    ST: "PA",
    cityWithStateAbbr: "Scranton, PA",
  },
  {
    zip: "18577",
    ST: "PA",
    cityWithStateAbbr: "Scranton, PA",
  },
  {
    zip: "18601",
    ST: "PA",
    cityWithStateAbbr: "Beach Haven, PA",
  },
  {
    zip: "18602",
    ST: "PA",
    cityWithStateAbbr: "Bear Creek, PA",
  },
  {
    zip: "18603",
    ST: "PA",
    cityWithStateAbbr: "Berwick, PA",
  },
  {
    zip: "18610",
    ST: "PA",
    cityWithStateAbbr: "Blakeslee, PA",
  },
  {
    zip: "18611",
    ST: "PA",
    cityWithStateAbbr: "Cambra, PA",
  },
  {
    zip: "18612",
    ST: "PA",
    cityWithStateAbbr: "Dallas, PA",
  },
  {
    zip: "18614",
    ST: "PA",
    cityWithStateAbbr: "Dushore, PA",
  },
  {
    zip: "18615",
    ST: "PA",
    cityWithStateAbbr: "Falls, PA",
  },
  {
    zip: "18616",
    ST: "PA",
    cityWithStateAbbr: "Forksville, PA",
  },
  {
    zip: "18617",
    ST: "PA",
    cityWithStateAbbr: "Glen Lyon, PA",
  },
  {
    zip: "18618",
    ST: "PA",
    cityWithStateAbbr: "Harveys Lake, PA",
  },
  {
    zip: "18619",
    ST: "PA",
    cityWithStateAbbr: "Hillsgrove, PA",
  },
  {
    zip: "18621",
    ST: "PA",
    cityWithStateAbbr: "Hunlock Creek, PA",
  },
  {
    zip: "18622",
    ST: "PA",
    cityWithStateAbbr: "Huntington Mills, PA",
  },
  {
    zip: "18623",
    ST: "PA",
    cityWithStateAbbr: "Laceyville, PA",
  },
  {
    zip: "18624",
    ST: "PA",
    cityWithStateAbbr: "Lake Harmony, PA",
  },
  {
    zip: "18625",
    ST: "PA",
    cityWithStateAbbr: "Lake Winola, PA",
  },
  {
    zip: "18626",
    ST: "PA",
    cityWithStateAbbr: "Laporte, PA",
  },
  {
    zip: "18627",
    ST: "PA",
    cityWithStateAbbr: "Lehman, PA",
  },
  {
    zip: "18628",
    ST: "PA",
    cityWithStateAbbr: "Lopez, PA",
  },
  {
    zip: "18629",
    ST: "PA",
    cityWithStateAbbr: "Mehoopany, PA",
  },
  {
    zip: "18630",
    ST: "PA",
    cityWithStateAbbr: "Meshoppen, PA",
  },
  {
    zip: "18631",
    ST: "PA",
    cityWithStateAbbr: "Mifflinville, PA",
  },
  {
    zip: "18632",
    ST: "PA",
    cityWithStateAbbr: "Mildred, PA",
  },
  {
    zip: "18634",
    ST: "PA",
    cityWithStateAbbr: "Nanticoke, PA",
  },
  {
    zip: "18635",
    ST: "PA",
    cityWithStateAbbr: "Nescopeck, PA",
  },
  {
    zip: "18636",
    ST: "PA",
    cityWithStateAbbr: "Noxen, PA",
  },
  {
    zip: "18640",
    ST: "PA",
    cityWithStateAbbr: "Pittston, PA",
  },
  {
    zip: "18641",
    ST: "PA",
    cityWithStateAbbr: "Pittston, PA",
  },
  {
    zip: "18642",
    ST: "PA",
    cityWithStateAbbr: "Duryea, PA",
  },
  {
    zip: "18643",
    ST: "PA",
    cityWithStateAbbr: "Pittston, PA",
  },
  {
    zip: "18644",
    ST: "PA",
    cityWithStateAbbr: "Wyoming, PA",
  },
  {
    zip: "18651",
    ST: "PA",
    cityWithStateAbbr: "Plymouth, PA",
  },
  {
    zip: "18653",
    ST: "PA",
    cityWithStateAbbr: "Ransom, PA",
  },
  {
    zip: "18654",
    ST: "PA",
    cityWithStateAbbr: "Shawanese, PA",
  },
  {
    zip: "18655",
    ST: "PA",
    cityWithStateAbbr: "Shickshinny, PA",
  },
  {
    zip: "18656",
    ST: "PA",
    cityWithStateAbbr: "Sweet Valley, PA",
  },
  {
    zip: "18657",
    ST: "PA",
    cityWithStateAbbr: "Tunkhannock, PA",
  },
  {
    zip: "18660",
    ST: "PA",
    cityWithStateAbbr: "Wapwallopen, PA",
  },
  {
    zip: "18661",
    ST: "PA",
    cityWithStateAbbr: "White Haven, PA",
  },
  {
    zip: "18690",
    ST: "PA",
    cityWithStateAbbr: "Dallas, PA",
  },
  {
    zip: "18701",
    ST: "PA",
    cityWithStateAbbr: "Wilkes Barre, PA",
  },
  {
    zip: "18702",
    ST: "PA",
    cityWithStateAbbr: "Wilkes Barre, PA",
  },
  {
    zip: "18703",
    ST: "PA",
    cityWithStateAbbr: "Wilkes Barre, PA",
  },
  {
    zip: "18704",
    ST: "PA",
    cityWithStateAbbr: "Kingston, PA",
  },
  {
    zip: "18705",
    ST: "PA",
    cityWithStateAbbr: "Wilkes Barre, PA",
  },
  {
    zip: "18706",
    ST: "PA",
    cityWithStateAbbr: "Wilkes Barre, PA",
  },
  {
    zip: "18707",
    ST: "PA",
    cityWithStateAbbr: "Mountain Top, PA",
  },
  {
    zip: "18708",
    ST: "PA",
    cityWithStateAbbr: "Shavertown, PA",
  },
  {
    zip: "18709",
    ST: "PA",
    cityWithStateAbbr: "Luzerne, PA",
  },
  {
    zip: "18710",
    ST: "PA",
    cityWithStateAbbr: "Wilkes Barre, PA",
  },
  {
    zip: "18711",
    ST: "PA",
    cityWithStateAbbr: "Wilkes Barre, PA",
  },
  {
    zip: "18762",
    ST: "PA",
    cityWithStateAbbr: "Wilkes Barre, PA",
  },
  {
    zip: "18764",
    ST: "PA",
    cityWithStateAbbr: "Wilkes Barre, PA",
  },
  {
    zip: "18765",
    ST: "PA",
    cityWithStateAbbr: "Wilkes Barre, PA",
  },
  {
    zip: "18766",
    ST: "PA",
    cityWithStateAbbr: "Wilkes Barre, PA",
  },
  {
    zip: "18767",
    ST: "PA",
    cityWithStateAbbr: "Wilkes Barre, PA",
  },
  {
    zip: "18769",
    ST: "PA",
    cityWithStateAbbr: "Wilkes Barre, PA",
  },
  {
    zip: "18773",
    ST: "PA",
    cityWithStateAbbr: "Wilkes Barre, PA",
  },
  {
    zip: "18801",
    ST: "PA",
    cityWithStateAbbr: "Montrose, PA",
  },
  {
    zip: "18810",
    ST: "PA",
    cityWithStateAbbr: "Athens, PA",
  },
  {
    zip: "18812",
    ST: "PA",
    cityWithStateAbbr: "Brackney, PA",
  },
  {
    zip: "18813",
    ST: "PA",
    cityWithStateAbbr: "Brooklyn, PA",
  },
  {
    zip: "18814",
    ST: "PA",
    cityWithStateAbbr: "Burlington, PA",
  },
  {
    zip: "18815",
    ST: "PA",
    cityWithStateAbbr: "Camptown, PA",
  },
  {
    zip: "18816",
    ST: "PA",
    cityWithStateAbbr: "Dimock, PA",
  },
  {
    zip: "18817",
    ST: "PA",
    cityWithStateAbbr: "East Smithfield, PA",
  },
  {
    zip: "18818",
    ST: "PA",
    cityWithStateAbbr: "Friendsville, PA",
  },
  {
    zip: "18820",
    ST: "PA",
    cityWithStateAbbr: "Gibson, PA",
  },
  {
    zip: "18821",
    ST: "PA",
    cityWithStateAbbr: "Great Bend, PA",
  },
  {
    zip: "18822",
    ST: "PA",
    cityWithStateAbbr: "Hallstead, PA",
  },
  {
    zip: "18823",
    ST: "PA",
    cityWithStateAbbr: "Harford, PA",
  },
  {
    zip: "18824",
    ST: "PA",
    cityWithStateAbbr: "Hop Bottom, PA",
  },
  {
    zip: "18825",
    ST: "PA",
    cityWithStateAbbr: "Jackson, PA",
  },
  {
    zip: "18826",
    ST: "PA",
    cityWithStateAbbr: "Kingsley, PA",
  },
  {
    zip: "18827",
    ST: "PA",
    cityWithStateAbbr: "Lanesboro, PA",
  },
  {
    zip: "18828",
    ST: "PA",
    cityWithStateAbbr: "Lawton, PA",
  },
  {
    zip: "18829",
    ST: "PA",
    cityWithStateAbbr: "Le Raysville, PA",
  },
  {
    zip: "18830",
    ST: "PA",
    cityWithStateAbbr: "Little Meadows, PA",
  },
  {
    zip: "18831",
    ST: "PA",
    cityWithStateAbbr: "Milan, PA",
  },
  {
    zip: "18832",
    ST: "PA",
    cityWithStateAbbr: "Monroeton, PA",
  },
  {
    zip: "18833",
    ST: "PA",
    cityWithStateAbbr: "New Albany, PA",
  },
  {
    zip: "18834",
    ST: "PA",
    cityWithStateAbbr: "New Milford, PA",
  },
  {
    zip: "18837",
    ST: "PA",
    cityWithStateAbbr: "Rome, PA",
  },
  {
    zip: "18839",
    ST: "PA",
    cityWithStateAbbr: "Rushville, PA",
  },
  {
    zip: "18840",
    ST: "PA",
    cityWithStateAbbr: "Sayre, PA",
  },
  {
    zip: "18842",
    ST: "PA",
    cityWithStateAbbr: "South Gibson, PA",
  },
  {
    zip: "18843",
    ST: "PA",
    cityWithStateAbbr: "South Montrose, PA",
  },
  {
    zip: "18844",
    ST: "PA",
    cityWithStateAbbr: "Springville, PA",
  },
  {
    zip: "18845",
    ST: "PA",
    cityWithStateAbbr: "Stevensville, PA",
  },
  {
    zip: "18846",
    ST: "PA",
    cityWithStateAbbr: "Sugar Run, PA",
  },
  {
    zip: "18847",
    ST: "PA",
    cityWithStateAbbr: "Susquehanna, PA",
  },
  {
    zip: "18848",
    ST: "PA",
    cityWithStateAbbr: "Towanda, PA",
  },
  {
    zip: "18850",
    ST: "PA",
    cityWithStateAbbr: "Ulster, PA",
  },
  {
    zip: "18851",
    ST: "PA",
    cityWithStateAbbr: "Warren Center, PA",
  },
  {
    zip: "18853",
    ST: "PA",
    cityWithStateAbbr: "Wyalusing, PA",
  },
  {
    zip: "18854",
    ST: "PA",
    cityWithStateAbbr: "Wysox, PA",
  },
  {
    zip: "18901",
    ST: "PA",
    cityWithStateAbbr: "Doylestown, PA",
  },
  {
    zip: "18902",
    ST: "PA",
    cityWithStateAbbr: "Doylestown, PA",
  },
  {
    zip: "18910",
    ST: "PA",
    cityWithStateAbbr: "Bedminster, PA",
  },
  {
    zip: "18911",
    ST: "PA",
    cityWithStateAbbr: "Blooming Glen, PA",
  },
  {
    zip: "18912",
    ST: "PA",
    cityWithStateAbbr: "Buckingham, PA",
  },
  {
    zip: "18913",
    ST: "PA",
    cityWithStateAbbr: "Carversville, PA",
  },
  {
    zip: "18914",
    ST: "PA",
    cityWithStateAbbr: "Chalfont, PA",
  },
  {
    zip: "18915",
    ST: "PA",
    cityWithStateAbbr: "Colmar, PA",
  },
  {
    zip: "18916",
    ST: "PA",
    cityWithStateAbbr: "Danboro, PA",
  },
  {
    zip: "18917",
    ST: "PA",
    cityWithStateAbbr: "Dublin, PA",
  },
  {
    zip: "18918",
    ST: "PA",
    cityWithStateAbbr: "Earlington, PA",
  },
  {
    zip: "18920",
    ST: "PA",
    cityWithStateAbbr: "Erwinna, PA",
  },
  {
    zip: "18921",
    ST: "PA",
    cityWithStateAbbr: "Ferndale, PA",
  },
  {
    zip: "18922",
    ST: "PA",
    cityWithStateAbbr: "Forest Grove, PA",
  },
  {
    zip: "18923",
    ST: "PA",
    cityWithStateAbbr: "Fountainville, PA",
  },
  {
    zip: "18924",
    ST: "PA",
    cityWithStateAbbr: "Franconia, PA",
  },
  {
    zip: "18925",
    ST: "PA",
    cityWithStateAbbr: "Furlong, PA",
  },
  {
    zip: "18926",
    ST: "PA",
    cityWithStateAbbr: "Gardenville, PA",
  },
  {
    zip: "18927",
    ST: "PA",
    cityWithStateAbbr: "Hilltown, PA",
  },
  {
    zip: "18928",
    ST: "PA",
    cityWithStateAbbr: "Holicong, PA",
  },
  {
    zip: "18929",
    ST: "PA",
    cityWithStateAbbr: "Jamison, PA",
  },
  {
    zip: "18930",
    ST: "PA",
    cityWithStateAbbr: "Kintnersville, PA",
  },
  {
    zip: "18931",
    ST: "PA",
    cityWithStateAbbr: "Lahaska, PA",
  },
  {
    zip: "18932",
    ST: "PA",
    cityWithStateAbbr: "Line Lexington, PA",
  },
  {
    zip: "18933",
    ST: "PA",
    cityWithStateAbbr: "Lumberville, PA",
  },
  {
    zip: "18934",
    ST: "PA",
    cityWithStateAbbr: "Mechanicsville, PA",
  },
  {
    zip: "18935",
    ST: "PA",
    cityWithStateAbbr: "Milford Square, PA",
  },
  {
    zip: "18936",
    ST: "PA",
    cityWithStateAbbr: "Montgomeryville, PA",
  },
  {
    zip: "18938",
    ST: "PA",
    cityWithStateAbbr: "New Hope, PA",
  },
  {
    zip: "18940",
    ST: "PA",
    cityWithStateAbbr: "Newtown, PA",
  },
  {
    zip: "18942",
    ST: "PA",
    cityWithStateAbbr: "Ottsville, PA",
  },
  {
    zip: "18943",
    ST: "PA",
    cityWithStateAbbr: "Penns Park, PA",
  },
  {
    zip: "18944",
    ST: "PA",
    cityWithStateAbbr: "Perkasie, PA",
  },
  {
    zip: "18946",
    ST: "PA",
    cityWithStateAbbr: "Pineville, PA",
  },
  {
    zip: "18947",
    ST: "PA",
    cityWithStateAbbr: "Pipersville, PA",
  },
  {
    zip: "18949",
    ST: "PA",
    cityWithStateAbbr: "Plumsteadville, PA",
  },
  {
    zip: "18950",
    ST: "PA",
    cityWithStateAbbr: "Point Pleasant, PA",
  },
  {
    zip: "18951",
    ST: "PA",
    cityWithStateAbbr: "Quakertown, PA",
  },
  {
    zip: "18953",
    ST: "PA",
    cityWithStateAbbr: "Revere, PA",
  },
  {
    zip: "18954",
    ST: "PA",
    cityWithStateAbbr: "Richboro, PA",
  },
  {
    zip: "18955",
    ST: "PA",
    cityWithStateAbbr: "Richlandtown, PA",
  },
  {
    zip: "18956",
    ST: "PA",
    cityWithStateAbbr: "Rushland, PA",
  },
  {
    zip: "18957",
    ST: "PA",
    cityWithStateAbbr: "Salford, PA",
  },
  {
    zip: "18958",
    ST: "PA",
    cityWithStateAbbr: "Salfordville, PA",
  },
  {
    zip: "18960",
    ST: "PA",
    cityWithStateAbbr: "Sellersville, PA",
  },
  {
    zip: "18962",
    ST: "PA",
    cityWithStateAbbr: "Silverdale, PA",
  },
  {
    zip: "18963",
    ST: "PA",
    cityWithStateAbbr: "Solebury, PA",
  },
  {
    zip: "18964",
    ST: "PA",
    cityWithStateAbbr: "Souderton, PA",
  },
  {
    zip: "18966",
    ST: "PA",
    cityWithStateAbbr: "Southampton, PA",
  },
  {
    zip: "18968",
    ST: "PA",
    cityWithStateAbbr: "Spinnerstown, PA",
  },
  {
    zip: "18969",
    ST: "PA",
    cityWithStateAbbr: "Telford, PA",
  },
  {
    zip: "18970",
    ST: "PA",
    cityWithStateAbbr: "Trumbauersville, PA",
  },
  {
    zip: "18971",
    ST: "PA",
    cityWithStateAbbr: "Tylersport, PA",
  },
  {
    zip: "18972",
    ST: "PA",
    cityWithStateAbbr: "Upper Black Eddy, PA",
  },
  {
    zip: "18974",
    ST: "PA",
    cityWithStateAbbr: "Warminster, PA",
  },
  {
    zip: "18976",
    ST: "PA",
    cityWithStateAbbr: "Warrington, PA",
  },
  {
    zip: "18977",
    ST: "PA",
    cityWithStateAbbr: "Washington Crossing, PA",
  },
  {
    zip: "18979",
    ST: "PA",
    cityWithStateAbbr: "Woxall, PA",
  },
  {
    zip: "18980",
    ST: "PA",
    cityWithStateAbbr: "Wycombe, PA",
  },
  {
    zip: "18981",
    ST: "PA",
    cityWithStateAbbr: "Zionhill, PA",
  },
  {
    zip: "18991",
    ST: "PA",
    cityWithStateAbbr: "Warminster, PA",
  },
  {
    zip: "19001",
    ST: "PA",
    cityWithStateAbbr: "Abington, PA",
  },
  {
    zip: "19002",
    ST: "PA",
    cityWithStateAbbr: "Ambler, PA",
  },
  {
    zip: "19003",
    ST: "PA",
    cityWithStateAbbr: "Ardmore, PA",
  },
  {
    zip: "19004",
    ST: "PA",
    cityWithStateAbbr: "Bala Cynwyd, PA",
  },
  {
    zip: "19006",
    ST: "PA",
    cityWithStateAbbr: "Huntingdon Valley, PA",
  },
  {
    zip: "19007",
    ST: "PA",
    cityWithStateAbbr: "Bristol, PA",
  },
  {
    zip: "19008",
    ST: "PA",
    cityWithStateAbbr: "Broomall, PA",
  },
  {
    zip: "19009",
    ST: "PA",
    cityWithStateAbbr: "Bryn Athyn, PA",
  },
  {
    zip: "19010",
    ST: "PA",
    cityWithStateAbbr: "Bryn Mawr, PA",
  },
  {
    zip: "19012",
    ST: "PA",
    cityWithStateAbbr: "Cheltenham, PA",
  },
  {
    zip: "19013",
    ST: "PA",
    cityWithStateAbbr: "Chester, PA",
  },
  {
    zip: "19014",
    ST: "PA",
    cityWithStateAbbr: "Aston, PA",
  },
  {
    zip: "19015",
    ST: "PA",
    cityWithStateAbbr: "Brookhaven, PA",
  },
  {
    zip: "19016",
    ST: "PA",
    cityWithStateAbbr: "Chester, PA",
  },
  {
    zip: "19017",
    ST: "PA",
    cityWithStateAbbr: "Chester Heights, PA",
  },
  {
    zip: "19018",
    ST: "PA",
    cityWithStateAbbr: "Clifton Heights, PA",
  },
  {
    zip: "19019",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19020",
    ST: "PA",
    cityWithStateAbbr: "Bensalem, PA",
  },
  {
    zip: "19021",
    ST: "PA",
    cityWithStateAbbr: "Croydon, PA",
  },
  {
    zip: "19022",
    ST: "PA",
    cityWithStateAbbr: "Crum Lynne, PA",
  },
  {
    zip: "19023",
    ST: "PA",
    cityWithStateAbbr: "Darby, PA",
  },
  {
    zip: "19025",
    ST: "PA",
    cityWithStateAbbr: "Dresher, PA",
  },
  {
    zip: "19026",
    ST: "PA",
    cityWithStateAbbr: "Drexel Hill, PA",
  },
  {
    zip: "19027",
    ST: "PA",
    cityWithStateAbbr: "Elkins Park, PA",
  },
  {
    zip: "19028",
    ST: "PA",
    cityWithStateAbbr: "Edgemont, PA",
  },
  {
    zip: "19029",
    ST: "PA",
    cityWithStateAbbr: "Essington, PA",
  },
  {
    zip: "19030",
    ST: "PA",
    cityWithStateAbbr: "Fairless Hills, PA",
  },
  {
    zip: "19031",
    ST: "PA",
    cityWithStateAbbr: "Flourtown, PA",
  },
  {
    zip: "19032",
    ST: "PA",
    cityWithStateAbbr: "Folcroft, PA",
  },
  {
    zip: "19033",
    ST: "PA",
    cityWithStateAbbr: "Folsom, PA",
  },
  {
    zip: "19034",
    ST: "PA",
    cityWithStateAbbr: "Fort Washington, PA",
  },
  {
    zip: "19035",
    ST: "PA",
    cityWithStateAbbr: "Gladwyne, PA",
  },
  {
    zip: "19036",
    ST: "PA",
    cityWithStateAbbr: "Glenolden, PA",
  },
  {
    zip: "19037",
    ST: "PA",
    cityWithStateAbbr: "Glen Riddle Lima, PA",
  },
  {
    zip: "19038",
    ST: "PA",
    cityWithStateAbbr: "Glenside, PA",
  },
  {
    zip: "19039",
    ST: "PA",
    cityWithStateAbbr: "Gradyville, PA",
  },
  {
    zip: "19040",
    ST: "PA",
    cityWithStateAbbr: "Hatboro, PA",
  },
  {
    zip: "19041",
    ST: "PA",
    cityWithStateAbbr: "Haverford, PA",
  },
  {
    zip: "19043",
    ST: "PA",
    cityWithStateAbbr: "Holmes, PA",
  },
  {
    zip: "19044",
    ST: "PA",
    cityWithStateAbbr: "Horsham, PA",
  },
  {
    zip: "19046",
    ST: "PA",
    cityWithStateAbbr: "Jenkintown, PA",
  },
  {
    zip: "19047",
    ST: "PA",
    cityWithStateAbbr: "Langhorne, PA",
  },
  {
    zip: "19048",
    ST: "PA",
    cityWithStateAbbr: "Fort Washington, PA",
  },
  {
    zip: "19049",
    ST: "PA",
    cityWithStateAbbr: "Fort Washington, PA",
  },
  {
    zip: "19050",
    ST: "PA",
    cityWithStateAbbr: "Lansdowne, PA",
  },
  {
    zip: "19052",
    ST: "PA",
    cityWithStateAbbr: "Lenni, PA",
  },
  {
    zip: "19053",
    ST: "PA",
    cityWithStateAbbr: "Feasterville Trevose, PA",
  },
  {
    zip: "19054",
    ST: "PA",
    cityWithStateAbbr: "Levittown, PA",
  },
  {
    zip: "19055",
    ST: "PA",
    cityWithStateAbbr: "Levittown, PA",
  },
  {
    zip: "19056",
    ST: "PA",
    cityWithStateAbbr: "Levittown, PA",
  },
  {
    zip: "19057",
    ST: "PA",
    cityWithStateAbbr: "Levittown, PA",
  },
  {
    zip: "19058",
    ST: "PA",
    cityWithStateAbbr: "Levittown, PA",
  },
  {
    zip: "19060",
    ST: "PA",
    cityWithStateAbbr: "Garnet Valley, PA",
  },
  {
    zip: "19061",
    ST: "PA",
    cityWithStateAbbr: "Marcus Hook, PA",
  },
  {
    zip: "19063",
    ST: "PA",
    cityWithStateAbbr: "Media, PA",
  },
  {
    zip: "19064",
    ST: "PA",
    cityWithStateAbbr: "Springfield, PA",
  },
  {
    zip: "19065",
    ST: "PA",
    cityWithStateAbbr: "Media, PA",
  },
  {
    zip: "19066",
    ST: "PA",
    cityWithStateAbbr: "Merion Station, PA",
  },
  {
    zip: "19067",
    ST: "PA",
    cityWithStateAbbr: "Morrisville, PA",
  },
  {
    zip: "19070",
    ST: "PA",
    cityWithStateAbbr: "Morton, PA",
  },
  {
    zip: "19072",
    ST: "PA",
    cityWithStateAbbr: "Narberth, PA",
  },
  {
    zip: "19073",
    ST: "PA",
    cityWithStateAbbr: "Newtown Square, PA",
  },
  {
    zip: "19074",
    ST: "PA",
    cityWithStateAbbr: "Norwood, PA",
  },
  {
    zip: "19075",
    ST: "PA",
    cityWithStateAbbr: "Oreland, PA",
  },
  {
    zip: "19076",
    ST: "PA",
    cityWithStateAbbr: "Prospect Park, PA",
  },
  {
    zip: "19078",
    ST: "PA",
    cityWithStateAbbr: "Ridley Park, PA",
  },
  {
    zip: "19079",
    ST: "PA",
    cityWithStateAbbr: "Sharon Hill, PA",
  },
  {
    zip: "19080",
    ST: "PA",
    cityWithStateAbbr: "Wayne, PA",
  },
  {
    zip: "19081",
    ST: "PA",
    cityWithStateAbbr: "Swarthmore, PA",
  },
  {
    zip: "19082",
    ST: "PA",
    cityWithStateAbbr: "Upper Darby, PA",
  },
  {
    zip: "19083",
    ST: "PA",
    cityWithStateAbbr: "Havertown, PA",
  },
  {
    zip: "19085",
    ST: "PA",
    cityWithStateAbbr: "Villanova, PA",
  },
  {
    zip: "19086",
    ST: "PA",
    cityWithStateAbbr: "Wallingford, PA",
  },
  {
    zip: "19087",
    ST: "PA",
    cityWithStateAbbr: "Wayne, PA",
  },
  {
    zip: "19088",
    ST: "PA",
    cityWithStateAbbr: "Wayne, PA",
  },
  {
    zip: "19089",
    ST: "PA",
    cityWithStateAbbr: "Wayne, PA",
  },
  {
    zip: "19090",
    ST: "PA",
    cityWithStateAbbr: "Willow Grove, PA",
  },
  {
    zip: "19091",
    ST: "PA",
    cityWithStateAbbr: "Media, PA",
  },
  {
    zip: "19092",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19093",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19094",
    ST: "PA",
    cityWithStateAbbr: "Woodlyn, PA",
  },
  {
    zip: "19095",
    ST: "PA",
    cityWithStateAbbr: "Wyncote, PA",
  },
  {
    zip: "19096",
    ST: "PA",
    cityWithStateAbbr: "Wynnewood, PA",
  },
  {
    zip: "19098",
    ST: "PA",
    cityWithStateAbbr: "Holmes, PA",
  },
  {
    zip: "19099",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19101",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19102",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19103",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19104",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19105",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19106",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19107",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19108",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19109",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19110",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19111",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19112",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19113",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19114",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19115",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19116",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19118",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19119",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19120",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19121",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19122",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19123",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19124",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19125",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19126",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19127",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19128",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19129",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19130",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19131",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19132",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19133",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19134",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19135",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19136",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19137",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19138",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19139",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19140",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19141",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19142",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19143",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19144",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19145",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19146",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19147",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19148",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19149",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19150",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19151",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19152",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19153",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19154",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19155",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19160",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19161",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19162",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19170",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19171",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19172",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19173",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19175",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19176",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19177",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19178",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19181",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19182",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19183",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19184",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19185",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19187",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19188",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19190",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19191",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19192",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19193",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19194",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19195",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19196",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19197",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19244",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19255",
    ST: "PA",
    cityWithStateAbbr: "Philadelphia, PA",
  },
  {
    zip: "19301",
    ST: "PA",
    cityWithStateAbbr: "Paoli, PA",
  },
  {
    zip: "19310",
    ST: "PA",
    cityWithStateAbbr: "Atglen, PA",
  },
  {
    zip: "19311",
    ST: "PA",
    cityWithStateAbbr: "Avondale, PA",
  },
  {
    zip: "19312",
    ST: "PA",
    cityWithStateAbbr: "Berwyn, PA",
  },
  {
    zip: "19316",
    ST: "PA",
    cityWithStateAbbr: "Brandamore, PA",
  },
  {
    zip: "19317",
    ST: "PA",
    cityWithStateAbbr: "Chadds Ford, PA",
  },
  {
    zip: "19318",
    ST: "PA",
    cityWithStateAbbr: "Chatham, PA",
  },
  {
    zip: "19319",
    ST: "PA",
    cityWithStateAbbr: "Cheyney, PA",
  },
  {
    zip: "19320",
    ST: "PA",
    cityWithStateAbbr: "Coatesville, PA",
  },
  {
    zip: "19330",
    ST: "PA",
    cityWithStateAbbr: "Cochranville, PA",
  },
  {
    zip: "19331",
    ST: "PA",
    cityWithStateAbbr: "Concordville, PA",
  },
  {
    zip: "19333",
    ST: "PA",
    cityWithStateAbbr: "Devon, PA",
  },
  {
    zip: "19335",
    ST: "PA",
    cityWithStateAbbr: "Downingtown, PA",
  },
  {
    zip: "19339",
    ST: "PA",
    cityWithStateAbbr: "Concordville, PA",
  },
  {
    zip: "19340",
    ST: "PA",
    cityWithStateAbbr: "Concordville, PA",
  },
  {
    zip: "19341",
    ST: "PA",
    cityWithStateAbbr: "Exton, PA",
  },
  {
    zip: "19342",
    ST: "PA",
    cityWithStateAbbr: "Glen Mills, PA",
  },
  {
    zip: "19343",
    ST: "PA",
    cityWithStateAbbr: "Glenmoore, PA",
  },
  {
    zip: "19344",
    ST: "PA",
    cityWithStateAbbr: "Honey Brook, PA",
  },
  {
    zip: "19345",
    ST: "PA",
    cityWithStateAbbr: "Immaculata, PA",
  },
  {
    zip: "19346",
    ST: "PA",
    cityWithStateAbbr: "Kelton, PA",
  },
  {
    zip: "19347",
    ST: "PA",
    cityWithStateAbbr: "Kemblesville, PA",
  },
  {
    zip: "19348",
    ST: "PA",
    cityWithStateAbbr: "Kennett Square, PA",
  },
  {
    zip: "19350",
    ST: "PA",
    cityWithStateAbbr: "Landenberg, PA",
  },
  {
    zip: "19351",
    ST: "PA",
    cityWithStateAbbr: "Lewisville, PA",
  },
  {
    zip: "19352",
    ST: "PA",
    cityWithStateAbbr: "Lincoln University, PA",
  },
  {
    zip: "19353",
    ST: "PA",
    cityWithStateAbbr: "Lionville, PA",
  },
  {
    zip: "19354",
    ST: "PA",
    cityWithStateAbbr: "Lyndell, PA",
  },
  {
    zip: "19355",
    ST: "PA",
    cityWithStateAbbr: "Malvern, PA",
  },
  {
    zip: "19357",
    ST: "PA",
    cityWithStateAbbr: "Mendenhall, PA",
  },
  {
    zip: "19358",
    ST: "PA",
    cityWithStateAbbr: "Modena, PA",
  },
  {
    zip: "19360",
    ST: "PA",
    cityWithStateAbbr: "New London, PA",
  },
  {
    zip: "19362",
    ST: "PA",
    cityWithStateAbbr: "Nottingham, PA",
  },
  {
    zip: "19363",
    ST: "PA",
    cityWithStateAbbr: "Oxford, PA",
  },
  {
    zip: "19365",
    ST: "PA",
    cityWithStateAbbr: "Parkesburg, PA",
  },
  {
    zip: "19366",
    ST: "PA",
    cityWithStateAbbr: "Pocopson, PA",
  },
  {
    zip: "19367",
    ST: "PA",
    cityWithStateAbbr: "Pomeroy, PA",
  },
  {
    zip: "19369",
    ST: "PA",
    cityWithStateAbbr: "Sadsburyville, PA",
  },
  {
    zip: "19371",
    ST: "PA",
    cityWithStateAbbr: "Suplee, PA",
  },
  {
    zip: "19372",
    ST: "PA",
    cityWithStateAbbr: "Thorndale, PA",
  },
  {
    zip: "19373",
    ST: "PA",
    cityWithStateAbbr: "Thornton, PA",
  },
  {
    zip: "19374",
    ST: "PA",
    cityWithStateAbbr: "Toughkenamon, PA",
  },
  {
    zip: "19375",
    ST: "PA",
    cityWithStateAbbr: "Unionville, PA",
  },
  {
    zip: "19376",
    ST: "PA",
    cityWithStateAbbr: "Wagontown, PA",
  },
  {
    zip: "19380",
    ST: "PA",
    cityWithStateAbbr: "West Chester, PA",
  },
  {
    zip: "19381",
    ST: "PA",
    cityWithStateAbbr: "West Chester, PA",
  },
  {
    zip: "19382",
    ST: "PA",
    cityWithStateAbbr: "West Chester, PA",
  },
  {
    zip: "19383",
    ST: "PA",
    cityWithStateAbbr: "West Chester, PA",
  },
  {
    zip: "19388",
    ST: "PA",
    cityWithStateAbbr: "West Chester, PA",
  },
  {
    zip: "19390",
    ST: "PA",
    cityWithStateAbbr: "West Grove, PA",
  },
  {
    zip: "19395",
    ST: "PA",
    cityWithStateAbbr: "Westtown, PA",
  },
  {
    zip: "19397",
    ST: "PA",
    cityWithStateAbbr: "Southeastern, PA",
  },
  {
    zip: "19398",
    ST: "PA",
    cityWithStateAbbr: "Southeastern, PA",
  },
  {
    zip: "19399",
    ST: "PA",
    cityWithStateAbbr: "Southeastern, PA",
  },
  {
    zip: "19401",
    ST: "PA",
    cityWithStateAbbr: "Norristown, PA",
  },
  {
    zip: "19403",
    ST: "PA",
    cityWithStateAbbr: "Norristown, PA",
  },
  {
    zip: "19404",
    ST: "PA",
    cityWithStateAbbr: "Norristown, PA",
  },
  {
    zip: "19405",
    ST: "PA",
    cityWithStateAbbr: "Bridgeport, PA",
  },
  {
    zip: "19406",
    ST: "PA",
    cityWithStateAbbr: "King Of Prussia, PA",
  },
  {
    zip: "19407",
    ST: "PA",
    cityWithStateAbbr: "Audubon, PA",
  },
  {
    zip: "19408",
    ST: "PA",
    cityWithStateAbbr: "Eagleville, PA",
  },
  {
    zip: "19409",
    ST: "PA",
    cityWithStateAbbr: "Fairview Village, PA",
  },
  {
    zip: "19415",
    ST: "PA",
    cityWithStateAbbr: "Eagleville, PA",
  },
  {
    zip: "19420",
    ST: "PA",
    cityWithStateAbbr: "Arcola, PA",
  },
  {
    zip: "19421",
    ST: "PA",
    cityWithStateAbbr: "Birchrunville, PA",
  },
  {
    zip: "19422",
    ST: "PA",
    cityWithStateAbbr: "Blue Bell, PA",
  },
  {
    zip: "19423",
    ST: "PA",
    cityWithStateAbbr: "Cedars, PA",
  },
  {
    zip: "19424",
    ST: "PA",
    cityWithStateAbbr: "Blue Bell, PA",
  },
  {
    zip: "19425",
    ST: "PA",
    cityWithStateAbbr: "Chester Springs, PA",
  },
  {
    zip: "19426",
    ST: "PA",
    cityWithStateAbbr: "Collegeville, PA",
  },
  {
    zip: "19428",
    ST: "PA",
    cityWithStateAbbr: "Conshohocken, PA",
  },
  {
    zip: "19429",
    ST: "PA",
    cityWithStateAbbr: "Conshohocken, PA",
  },
  {
    zip: "19430",
    ST: "PA",
    cityWithStateAbbr: "Creamery, PA",
  },
  {
    zip: "19432",
    ST: "PA",
    cityWithStateAbbr: "Devault, PA",
  },
  {
    zip: "19435",
    ST: "PA",
    cityWithStateAbbr: "Frederick, PA",
  },
  {
    zip: "19436",
    ST: "PA",
    cityWithStateAbbr: "Gwynedd, PA",
  },
  {
    zip: "19437",
    ST: "PA",
    cityWithStateAbbr: "Gwynedd Valley, PA",
  },
  {
    zip: "19438",
    ST: "PA",
    cityWithStateAbbr: "Harleysville, PA",
  },
  {
    zip: "19440",
    ST: "PA",
    cityWithStateAbbr: "Hatfield, PA",
  },
  {
    zip: "19441",
    ST: "PA",
    cityWithStateAbbr: "Harleysville, PA",
  },
  {
    zip: "19442",
    ST: "PA",
    cityWithStateAbbr: "Kimberton, PA",
  },
  {
    zip: "19443",
    ST: "PA",
    cityWithStateAbbr: "Kulpsville, PA",
  },
  {
    zip: "19444",
    ST: "PA",
    cityWithStateAbbr: "Lafayette Hill, PA",
  },
  {
    zip: "19446",
    ST: "PA",
    cityWithStateAbbr: "Lansdale, PA",
  },
  {
    zip: "19450",
    ST: "PA",
    cityWithStateAbbr: "Lederach, PA",
  },
  {
    zip: "19451",
    ST: "PA",
    cityWithStateAbbr: "Mainland, PA",
  },
  {
    zip: "19453",
    ST: "PA",
    cityWithStateAbbr: "Mont Clare, PA",
  },
  {
    zip: "19454",
    ST: "PA",
    cityWithStateAbbr: "North Wales, PA",
  },
  {
    zip: "19455",
    ST: "PA",
    cityWithStateAbbr: "North Wales, PA",
  },
  {
    zip: "19456",
    ST: "PA",
    cityWithStateAbbr: "Oaks, PA",
  },
  {
    zip: "19457",
    ST: "PA",
    cityWithStateAbbr: "Parker Ford, PA",
  },
  {
    zip: "19460",
    ST: "PA",
    cityWithStateAbbr: "Phoenixville, PA",
  },
  {
    zip: "19462",
    ST: "PA",
    cityWithStateAbbr: "Plymouth Meeting, PA",
  },
  {
    zip: "19464",
    ST: "PA",
    cityWithStateAbbr: "Pottstown, PA",
  },
  {
    zip: "19465",
    ST: "PA",
    cityWithStateAbbr: "Pottstown, PA",
  },
  {
    zip: "19468",
    ST: "PA",
    cityWithStateAbbr: "Royersford, PA",
  },
  {
    zip: "19470",
    ST: "PA",
    cityWithStateAbbr: "Saint Peters, PA",
  },
  {
    zip: "19472",
    ST: "PA",
    cityWithStateAbbr: "Sassamansville, PA",
  },
  {
    zip: "19473",
    ST: "PA",
    cityWithStateAbbr: "Schwenksville, PA",
  },
  {
    zip: "19474",
    ST: "PA",
    cityWithStateAbbr: "Skippack, PA",
  },
  {
    zip: "19475",
    ST: "PA",
    cityWithStateAbbr: "Spring City, PA",
  },
  {
    zip: "19477",
    ST: "PA",
    cityWithStateAbbr: "Spring House, PA",
  },
  {
    zip: "19478",
    ST: "PA",
    cityWithStateAbbr: "Spring Mount, PA",
  },
  {
    zip: "19480",
    ST: "PA",
    cityWithStateAbbr: "Uwchland, PA",
  },
  {
    zip: "19481",
    ST: "PA",
    cityWithStateAbbr: "Valley Forge, PA",
  },
  {
    zip: "19482",
    ST: "PA",
    cityWithStateAbbr: "Valley Forge, PA",
  },
  {
    zip: "19484",
    ST: "PA",
    cityWithStateAbbr: "Valley Forge, PA",
  },
  {
    zip: "19485",
    ST: "PA",
    cityWithStateAbbr: "Valley Forge, PA",
  },
  {
    zip: "19486",
    ST: "PA",
    cityWithStateAbbr: "West Point, PA",
  },
  {
    zip: "19490",
    ST: "PA",
    cityWithStateAbbr: "Worcester, PA",
  },
  {
    zip: "19492",
    ST: "PA",
    cityWithStateAbbr: "Zieglerville, PA",
  },
  {
    zip: "19493",
    ST: "PA",
    cityWithStateAbbr: "Valley Forge, PA",
  },
  {
    zip: "19494",
    ST: "PA",
    cityWithStateAbbr: "Valley Forge, PA",
  },
  {
    zip: "19495",
    ST: "PA",
    cityWithStateAbbr: "Valley Forge, PA",
  },
  {
    zip: "19496",
    ST: "PA",
    cityWithStateAbbr: "Valley Forge, PA",
  },
  {
    zip: "19501",
    ST: "PA",
    cityWithStateAbbr: "Adamstown, PA",
  },
  {
    zip: "19503",
    ST: "PA",
    cityWithStateAbbr: "Bally, PA",
  },
  {
    zip: "19504",
    ST: "PA",
    cityWithStateAbbr: "Barto, PA",
  },
  {
    zip: "19505",
    ST: "PA",
    cityWithStateAbbr: "Bechtelsville, PA",
  },
  {
    zip: "19506",
    ST: "PA",
    cityWithStateAbbr: "Bernville, PA",
  },
  {
    zip: "19507",
    ST: "PA",
    cityWithStateAbbr: "Bethel, PA",
  },
  {
    zip: "19508",
    ST: "PA",
    cityWithStateAbbr: "Birdsboro, PA",
  },
  {
    zip: "19510",
    ST: "PA",
    cityWithStateAbbr: "Blandon, PA",
  },
  {
    zip: "19511",
    ST: "PA",
    cityWithStateAbbr: "Bowers, PA",
  },
  {
    zip: "19512",
    ST: "PA",
    cityWithStateAbbr: "Boyertown, PA",
  },
  {
    zip: "19516",
    ST: "PA",
    cityWithStateAbbr: "Centerport, PA",
  },
  {
    zip: "19518",
    ST: "PA",
    cityWithStateAbbr: "Douglassville, PA",
  },
  {
    zip: "19519",
    ST: "PA",
    cityWithStateAbbr: "Earlville, PA",
  },
  {
    zip: "19520",
    ST: "PA",
    cityWithStateAbbr: "Elverson, PA",
  },
  {
    zip: "19522",
    ST: "PA",
    cityWithStateAbbr: "Fleetwood, PA",
  },
  {
    zip: "19523",
    ST: "PA",
    cityWithStateAbbr: "Geigertown, PA",
  },
  {
    zip: "19525",
    ST: "PA",
    cityWithStateAbbr: "Gilbertsville, PA",
  },
  {
    zip: "19526",
    ST: "PA",
    cityWithStateAbbr: "Hamburg, PA",
  },
  {
    zip: "19529",
    ST: "PA",
    cityWithStateAbbr: "Kempton, PA",
  },
  {
    zip: "19530",
    ST: "PA",
    cityWithStateAbbr: "Kutztown, PA",
  },
  {
    zip: "19533",
    ST: "PA",
    cityWithStateAbbr: "Leesport, PA",
  },
  {
    zip: "19534",
    ST: "PA",
    cityWithStateAbbr: "Lenhartsville, PA",
  },
  {
    zip: "19535",
    ST: "PA",
    cityWithStateAbbr: "Limekiln, PA",
  },
  {
    zip: "19536",
    ST: "PA",
    cityWithStateAbbr: "Lyon Station, PA",
  },
  {
    zip: "19538",
    ST: "PA",
    cityWithStateAbbr: "Maxatawny, PA",
  },
  {
    zip: "19539",
    ST: "PA",
    cityWithStateAbbr: "Mertztown, PA",
  },
  {
    zip: "19540",
    ST: "PA",
    cityWithStateAbbr: "Mohnton, PA",
  },
  {
    zip: "19541",
    ST: "PA",
    cityWithStateAbbr: "Mohrsville, PA",
  },
  {
    zip: "19542",
    ST: "PA",
    cityWithStateAbbr: "Monocacy Station, PA",
  },
  {
    zip: "19543",
    ST: "PA",
    cityWithStateAbbr: "Morgantown, PA",
  },
  {
    zip: "19544",
    ST: "PA",
    cityWithStateAbbr: "Mount Aetna, PA",
  },
  {
    zip: "19545",
    ST: "PA",
    cityWithStateAbbr: "New Berlinville, PA",
  },
  {
    zip: "19547",
    ST: "PA",
    cityWithStateAbbr: "Oley, PA",
  },
  {
    zip: "19548",
    ST: "PA",
    cityWithStateAbbr: "Pine Forge, PA",
  },
  {
    zip: "19549",
    ST: "PA",
    cityWithStateAbbr: "Port Clinton, PA",
  },
  {
    zip: "19550",
    ST: "PA",
    cityWithStateAbbr: "Rehrersburg, PA",
  },
  {
    zip: "19551",
    ST: "PA",
    cityWithStateAbbr: "Robesonia, PA",
  },
  {
    zip: "19554",
    ST: "PA",
    cityWithStateAbbr: "Shartlesville, PA",
  },
  {
    zip: "19555",
    ST: "PA",
    cityWithStateAbbr: "Shoemakersville, PA",
  },
  {
    zip: "19559",
    ST: "PA",
    cityWithStateAbbr: "Strausstown, PA",
  },
  {
    zip: "19560",
    ST: "PA",
    cityWithStateAbbr: "Temple, PA",
  },
  {
    zip: "19562",
    ST: "PA",
    cityWithStateAbbr: "Topton, PA",
  },
  {
    zip: "19564",
    ST: "PA",
    cityWithStateAbbr: "Virginville, PA",
  },
  {
    zip: "19565",
    ST: "PA",
    cityWithStateAbbr: "Wernersville, PA",
  },
  {
    zip: "19567",
    ST: "PA",
    cityWithStateAbbr: "Womelsdorf, PA",
  },
  {
    zip: "19601",
    ST: "PA",
    cityWithStateAbbr: "Reading, PA",
  },
  {
    zip: "19602",
    ST: "PA",
    cityWithStateAbbr: "Reading, PA",
  },
  {
    zip: "19603",
    ST: "PA",
    cityWithStateAbbr: "Reading, PA",
  },
  {
    zip: "19604",
    ST: "PA",
    cityWithStateAbbr: "Reading, PA",
  },
  {
    zip: "19605",
    ST: "PA",
    cityWithStateAbbr: "Reading, PA",
  },
  {
    zip: "19606",
    ST: "PA",
    cityWithStateAbbr: "Reading, PA",
  },
  {
    zip: "19607",
    ST: "PA",
    cityWithStateAbbr: "Reading, PA",
  },
  {
    zip: "19608",
    ST: "PA",
    cityWithStateAbbr: "Reading, PA",
  },
  {
    zip: "19609",
    ST: "PA",
    cityWithStateAbbr: "Reading, PA",
  },
  {
    zip: "19610",
    ST: "PA",
    cityWithStateAbbr: "Reading, PA",
  },
  {
    zip: "19611",
    ST: "PA",
    cityWithStateAbbr: "Reading, PA",
  },
  {
    zip: "19612",
    ST: "PA",
    cityWithStateAbbr: "Reading, PA",
  },
  {
    zip: "19701",
    ST: "DE",
    cityWithStateAbbr: "Bear, DE",
  },
  {
    zip: "19702",
    ST: "DE",
    cityWithStateAbbr: "Newark, DE",
  },
  {
    zip: "19703",
    ST: "DE",
    cityWithStateAbbr: "Claymont, DE",
  },
  {
    zip: "19706",
    ST: "DE",
    cityWithStateAbbr: "Delaware City, DE",
  },
  {
    zip: "19707",
    ST: "DE",
    cityWithStateAbbr: "Hockessin, DE",
  },
  {
    zip: "19708",
    ST: "DE",
    cityWithStateAbbr: "Kirkwood, DE",
  },
  {
    zip: "19709",
    ST: "DE",
    cityWithStateAbbr: "Middletown, DE",
  },
  {
    zip: "19710",
    ST: "DE",
    cityWithStateAbbr: "Montchanin, DE",
  },
  {
    zip: "19711",
    ST: "DE",
    cityWithStateAbbr: "Newark, DE",
  },
  {
    zip: "19712",
    ST: "DE",
    cityWithStateAbbr: "Newark, DE",
  },
  {
    zip: "19713",
    ST: "DE",
    cityWithStateAbbr: "Newark, DE",
  },
  {
    zip: "19714",
    ST: "DE",
    cityWithStateAbbr: "Newark, DE",
  },
  {
    zip: "19715",
    ST: "DE",
    cityWithStateAbbr: "Newark, DE",
  },
  {
    zip: "19716",
    ST: "DE",
    cityWithStateAbbr: "Newark, DE",
  },
  {
    zip: "19717",
    ST: "DE",
    cityWithStateAbbr: "Newark, DE",
  },
  {
    zip: "19718",
    ST: "DE",
    cityWithStateAbbr: "Newark, DE",
  },
  {
    zip: "19720",
    ST: "DE",
    cityWithStateAbbr: "New Castle, DE",
  },
  {
    zip: "19721",
    ST: "DE",
    cityWithStateAbbr: "New Castle, DE",
  },
  {
    zip: "19725",
    ST: "DE",
    cityWithStateAbbr: "Newark, DE",
  },
  {
    zip: "19726",
    ST: "DE",
    cityWithStateAbbr: "New Castle, DE",
  },
  {
    zip: "19730",
    ST: "DE",
    cityWithStateAbbr: "Odessa, DE",
  },
  {
    zip: "19731",
    ST: "DE",
    cityWithStateAbbr: "Port Penn, DE",
  },
  {
    zip: "19732",
    ST: "DE",
    cityWithStateAbbr: "Rockland, DE",
  },
  {
    zip: "19733",
    ST: "DE",
    cityWithStateAbbr: "Saint Georges, DE",
  },
  {
    zip: "19734",
    ST: "DE",
    cityWithStateAbbr: "Townsend, DE",
  },
  {
    zip: "19735",
    ST: "DE",
    cityWithStateAbbr: "Winterthur, DE",
  },
  {
    zip: "19736",
    ST: "DE",
    cityWithStateAbbr: "Yorklyn, DE",
  },
  {
    zip: "19801",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19802",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19803",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19804",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19805",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19806",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19807",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19808",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19809",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19810",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19850",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19880",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19884",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19885",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19886",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19890",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19891",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19892",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19893",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19894",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19895",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19896",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19897",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19898",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19899",
    ST: "DE",
    cityWithStateAbbr: "Wilmington, DE",
  },
  {
    zip: "19901",
    ST: "DE",
    cityWithStateAbbr: "Dover, DE",
  },
  {
    zip: "19902",
    ST: "DE",
    cityWithStateAbbr: "Dover Afb, DE",
  },
  {
    zip: "19903",
    ST: "DE",
    cityWithStateAbbr: "Dover, DE",
  },
  {
    zip: "19904",
    ST: "DE",
    cityWithStateAbbr: "Dover, DE",
  },
  {
    zip: "19905",
    ST: "DE",
    cityWithStateAbbr: "Dover, DE",
  },
  {
    zip: "19906",
    ST: "DE",
    cityWithStateAbbr: "Dover, DE",
  },
  {
    zip: "19930",
    ST: "DE",
    cityWithStateAbbr: "Bethany Beach, DE",
  },
  {
    zip: "19931",
    ST: "DE",
    cityWithStateAbbr: "Bethel, DE",
  },
  {
    zip: "19933",
    ST: "DE",
    cityWithStateAbbr: "Bridgeville, DE",
  },
  {
    zip: "19934",
    ST: "DE",
    cityWithStateAbbr: "Camden Wyoming, DE",
  },
  {
    zip: "19936",
    ST: "DE",
    cityWithStateAbbr: "Cheswold, DE",
  },
  {
    zip: "19938",
    ST: "DE",
    cityWithStateAbbr: "Clayton, DE",
  },
  {
    zip: "19939",
    ST: "DE",
    cityWithStateAbbr: "Dagsboro, DE",
  },
  {
    zip: "19940",
    ST: "DE",
    cityWithStateAbbr: "Delmar, DE",
  },
  {
    zip: "19941",
    ST: "DE",
    cityWithStateAbbr: "Ellendale, DE",
  },
  {
    zip: "19943",
    ST: "DE",
    cityWithStateAbbr: "Felton, DE",
  },
  {
    zip: "19944",
    ST: "DE",
    cityWithStateAbbr: "Fenwick Island, DE",
  },
  {
    zip: "19945",
    ST: "DE",
    cityWithStateAbbr: "Frankford, DE",
  },
  {
    zip: "19946",
    ST: "DE",
    cityWithStateAbbr: "Frederica, DE",
  },
  {
    zip: "19947",
    ST: "DE",
    cityWithStateAbbr: "Georgetown, DE",
  },
  {
    zip: "19950",
    ST: "DE",
    cityWithStateAbbr: "Greenwood, DE",
  },
  {
    zip: "19951",
    ST: "DE",
    cityWithStateAbbr: "Harbeson, DE",
  },
  {
    zip: "19952",
    ST: "DE",
    cityWithStateAbbr: "Harrington, DE",
  },
  {
    zip: "19953",
    ST: "DE",
    cityWithStateAbbr: "Hartly, DE",
  },
  {
    zip: "19954",
    ST: "DE",
    cityWithStateAbbr: "Houston, DE",
  },
  {
    zip: "19955",
    ST: "DE",
    cityWithStateAbbr: "Kenton, DE",
  },
  {
    zip: "19956",
    ST: "DE",
    cityWithStateAbbr: "Laurel, DE",
  },
  {
    zip: "19958",
    ST: "DE",
    cityWithStateAbbr: "Lewes, DE",
  },
  {
    zip: "19960",
    ST: "DE",
    cityWithStateAbbr: "Lincoln, DE",
  },
  {
    zip: "19961",
    ST: "DE",
    cityWithStateAbbr: "Little Creek, DE",
  },
  {
    zip: "19962",
    ST: "DE",
    cityWithStateAbbr: "Magnolia, DE",
  },
  {
    zip: "19963",
    ST: "DE",
    cityWithStateAbbr: "Milford, DE",
  },
  {
    zip: "19964",
    ST: "DE",
    cityWithStateAbbr: "Marydel, DE",
  },
  {
    zip: "19966",
    ST: "DE",
    cityWithStateAbbr: "Millsboro, DE",
  },
  {
    zip: "19967",
    ST: "DE",
    cityWithStateAbbr: "Millville, DE",
  },
  {
    zip: "19968",
    ST: "DE",
    cityWithStateAbbr: "Milton, DE",
  },
  {
    zip: "19969",
    ST: "DE",
    cityWithStateAbbr: "Nassau, DE",
  },
  {
    zip: "19970",
    ST: "DE",
    cityWithStateAbbr: "Ocean View, DE",
  },
  {
    zip: "19971",
    ST: "DE",
    cityWithStateAbbr: "Rehoboth Beach, DE",
  },
  {
    zip: "19973",
    ST: "DE",
    cityWithStateAbbr: "Seaford, DE",
  },
  {
    zip: "19975",
    ST: "DE",
    cityWithStateAbbr: "Selbyville, DE",
  },
  {
    zip: "19977",
    ST: "DE",
    cityWithStateAbbr: "Smyrna, DE",
  },
  {
    zip: "19979",
    ST: "DE",
    cityWithStateAbbr: "Viola, DE",
  },
  {
    zip: "19980",
    ST: "DE",
    cityWithStateAbbr: "Woodside, DE",
  },
  {
    zip: "20001",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20002",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20003",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20004",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20005",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20006",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20007",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20008",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20009",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20010",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20011",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20012",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20013",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20015",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20016",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20017",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20018",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20019",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20020",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20022",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20023",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20024",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20026",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20027",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20029",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20030",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20032",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20033",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20035",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20036",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20037",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20038",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20039",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20040",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20041",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20042",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20043",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20044",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20045",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20046",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20047",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20049",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20050",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20051",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20052",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20053",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20055",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20056",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20057",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20058",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20059",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20060",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20061",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20062",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20063",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20064",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20065",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20066",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20067",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20068",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20069",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20070",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20071",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20073",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20074",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20075",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20076",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20077",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20078",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20080",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20081",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20082",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20088",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20090",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20091",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20098",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20101",
    ST: "VA",
    cityWithStateAbbr: "Dulles, VA",
  },
  {
    zip: "20102",
    ST: "VA",
    cityWithStateAbbr: "Dulles, VA",
  },
  {
    zip: "20103",
    ST: "VA",
    cityWithStateAbbr: "Dulles, VA",
  },
  {
    zip: "20104",
    ST: "VA",
    cityWithStateAbbr: "Dulles, VA",
  },
  {
    zip: "20105",
    ST: "VA",
    cityWithStateAbbr: "Aldie, VA",
  },
  {
    zip: "20106",
    ST: "VA",
    cityWithStateAbbr: "Amissville, VA",
  },
  {
    zip: "20108",
    ST: "VA",
    cityWithStateAbbr: "Manassas, VA",
  },
  {
    zip: "20109",
    ST: "VA",
    cityWithStateAbbr: "Manassas, VA",
  },
  {
    zip: "20110",
    ST: "VA",
    cityWithStateAbbr: "Manassas, VA",
  },
  {
    zip: "20111",
    ST: "VA",
    cityWithStateAbbr: "Manassas, VA",
  },
  {
    zip: "20112",
    ST: "VA",
    cityWithStateAbbr: "Manassas, VA",
  },
  {
    zip: "20113",
    ST: "VA",
    cityWithStateAbbr: "Manassas, VA",
  },
  {
    zip: "20115",
    ST: "VA",
    cityWithStateAbbr: "Marshall, VA",
  },
  {
    zip: "20116",
    ST: "VA",
    cityWithStateAbbr: "Marshall, VA",
  },
  {
    zip: "20117",
    ST: "VA",
    cityWithStateAbbr: "Middleburg, VA",
  },
  {
    zip: "20118",
    ST: "VA",
    cityWithStateAbbr: "Middleburg, VA",
  },
  {
    zip: "20119",
    ST: "VA",
    cityWithStateAbbr: "Catlett, VA",
  },
  {
    zip: "20120",
    ST: "VA",
    cityWithStateAbbr: "Centreville, VA",
  },
  {
    zip: "20121",
    ST: "VA",
    cityWithStateAbbr: "Centreville, VA",
  },
  {
    zip: "20122",
    ST: "VA",
    cityWithStateAbbr: "Centreville, VA",
  },
  {
    zip: "20124",
    ST: "VA",
    cityWithStateAbbr: "Clifton, VA",
  },
  {
    zip: "20128",
    ST: "VA",
    cityWithStateAbbr: "Orlean, VA",
  },
  {
    zip: "20129",
    ST: "VA",
    cityWithStateAbbr: "Paeonian Springs, VA",
  },
  {
    zip: "20130",
    ST: "VA",
    cityWithStateAbbr: "Paris, VA",
  },
  {
    zip: "20131",
    ST: "VA",
    cityWithStateAbbr: "Philomont, VA",
  },
  {
    zip: "20132",
    ST: "VA",
    cityWithStateAbbr: "Purcellville, VA",
  },
  {
    zip: "20134",
    ST: "VA",
    cityWithStateAbbr: "Purcellville, VA",
  },
  {
    zip: "20135",
    ST: "VA",
    cityWithStateAbbr: "Bluemont, VA",
  },
  {
    zip: "20136",
    ST: "VA",
    cityWithStateAbbr: "Bristow, VA",
  },
  {
    zip: "20137",
    ST: "VA",
    cityWithStateAbbr: "Broad Run, VA",
  },
  {
    zip: "20138",
    ST: "VA",
    cityWithStateAbbr: "Calverton, VA",
  },
  {
    zip: "20139",
    ST: "VA",
    cityWithStateAbbr: "Casanova, VA",
  },
  {
    zip: "20140",
    ST: "VA",
    cityWithStateAbbr: "Rectortown, VA",
  },
  {
    zip: "20141",
    ST: "VA",
    cityWithStateAbbr: "Round Hill, VA",
  },
  {
    zip: "20142",
    ST: "VA",
    cityWithStateAbbr: "Round Hill, VA",
  },
  {
    zip: "20143",
    ST: "VA",
    cityWithStateAbbr: "Catharpin, VA",
  },
  {
    zip: "20144",
    ST: "VA",
    cityWithStateAbbr: "Delaplane, VA",
  },
  {
    zip: "20146",
    ST: "VA",
    cityWithStateAbbr: "Ashburn, VA",
  },
  {
    zip: "20147",
    ST: "VA",
    cityWithStateAbbr: "Ashburn, VA",
  },
  {
    zip: "20148",
    ST: "VA",
    cityWithStateAbbr: "Ashburn, VA",
  },
  {
    zip: "20149",
    ST: "VA",
    cityWithStateAbbr: "Ashburn, VA",
  },
  {
    zip: "20151",
    ST: "VA",
    cityWithStateAbbr: "Chantilly, VA",
  },
  {
    zip: "20152",
    ST: "VA",
    cityWithStateAbbr: "Chantilly, VA",
  },
  {
    zip: "20153",
    ST: "VA",
    cityWithStateAbbr: "Chantilly, VA",
  },
  {
    zip: "20155",
    ST: "VA",
    cityWithStateAbbr: "Gainesville, VA",
  },
  {
    zip: "20156",
    ST: "VA",
    cityWithStateAbbr: "Gainesville, VA",
  },
  {
    zip: "20158",
    ST: "VA",
    cityWithStateAbbr: "Hamilton, VA",
  },
  {
    zip: "20159",
    ST: "VA",
    cityWithStateAbbr: "Hamilton, VA",
  },
  {
    zip: "20160",
    ST: "VA",
    cityWithStateAbbr: "Lincoln, VA",
  },
  {
    zip: "20163",
    ST: "VA",
    cityWithStateAbbr: "Sterling, VA",
  },
  {
    zip: "20164",
    ST: "VA",
    cityWithStateAbbr: "Sterling, VA",
  },
  {
    zip: "20165",
    ST: "VA",
    cityWithStateAbbr: "Sterling, VA",
  },
  {
    zip: "20166",
    ST: "VA",
    cityWithStateAbbr: "Sterling, VA",
  },
  {
    zip: "20167",
    ST: "VA",
    cityWithStateAbbr: "Sterling, VA",
  },
  {
    zip: "20168",
    ST: "VA",
    cityWithStateAbbr: "Haymarket, VA",
  },
  {
    zip: "20169",
    ST: "VA",
    cityWithStateAbbr: "Haymarket, VA",
  },
  {
    zip: "20170",
    ST: "VA",
    cityWithStateAbbr: "Herndon, VA",
  },
  {
    zip: "20171",
    ST: "VA",
    cityWithStateAbbr: "Herndon, VA",
  },
  {
    zip: "20172",
    ST: "VA",
    cityWithStateAbbr: "Herndon, VA",
  },
  {
    zip: "20175",
    ST: "VA",
    cityWithStateAbbr: "Leesburg, VA",
  },
  {
    zip: "20176",
    ST: "VA",
    cityWithStateAbbr: "Leesburg, VA",
  },
  {
    zip: "20177",
    ST: "VA",
    cityWithStateAbbr: "Leesburg, VA",
  },
  {
    zip: "20178",
    ST: "VA",
    cityWithStateAbbr: "Leesburg, VA",
  },
  {
    zip: "20180",
    ST: "VA",
    cityWithStateAbbr: "Lovettsville, VA",
  },
  {
    zip: "20181",
    ST: "VA",
    cityWithStateAbbr: "Nokesville, VA",
  },
  {
    zip: "20182",
    ST: "VA",
    cityWithStateAbbr: "Nokesville, VA",
  },
  {
    zip: "20184",
    ST: "VA",
    cityWithStateAbbr: "Upperville, VA",
  },
  {
    zip: "20185",
    ST: "VA",
    cityWithStateAbbr: "Upperville, VA",
  },
  {
    zip: "20186",
    ST: "VA",
    cityWithStateAbbr: "Warrenton, VA",
  },
  {
    zip: "20187",
    ST: "VA",
    cityWithStateAbbr: "Warrenton, VA",
  },
  {
    zip: "20188",
    ST: "VA",
    cityWithStateAbbr: "Warrenton, VA",
  },
  {
    zip: "20189",
    ST: "DC",
    cityWithStateAbbr: "Dulles, DC",
  },
  {
    zip: "20190",
    ST: "VA",
    cityWithStateAbbr: "Reston, VA",
  },
  {
    zip: "20191",
    ST: "VA",
    cityWithStateAbbr: "Reston, VA",
  },
  {
    zip: "20192",
    ST: "VA",
    cityWithStateAbbr: "Herndon, VA",
  },
  {
    zip: "20194",
    ST: "VA",
    cityWithStateAbbr: "Reston, VA",
  },
  {
    zip: "20195",
    ST: "VA",
    cityWithStateAbbr: "Reston, VA",
  },
  {
    zip: "20196",
    ST: "VA",
    cityWithStateAbbr: "Reston, VA",
  },
  {
    zip: "20197",
    ST: "VA",
    cityWithStateAbbr: "Waterford, VA",
  },
  {
    zip: "20198",
    ST: "VA",
    cityWithStateAbbr: "The Plains, VA",
  },
  {
    zip: "20201",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20202",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20203",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20204",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20206",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20207",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20208",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20210",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20211",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20212",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20213",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20214",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20215",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20216",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20217",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20218",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20219",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20220",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20221",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20222",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20223",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20224",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20226",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20227",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20228",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20229",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20230",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20232",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20233",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20235",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20237",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20238",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20239",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20240",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20241",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20242",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20244",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20245",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20250",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20251",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20254",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20260",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20261",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20262",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20265",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20266",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20268",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20270",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20277",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20289",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20299",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20301",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20303",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20306",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20307",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20310",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20314",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20317",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20318",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20319",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20330",
    ST: "VA",
    cityWithStateAbbr: "Washington, VA",
  },
  {
    zip: "20340",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20350",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20355",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20370",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20372",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20373",
    ST: "DC",
    cityWithStateAbbr: "Naval Anacost Annex, DC",
  },
  {
    zip: "20374",
    ST: "DC",
    cityWithStateAbbr: "Washington Navy Yard, DC",
  },
  {
    zip: "20375",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20376",
    ST: "DC",
    cityWithStateAbbr: "Washington Navy Yard, DC",
  },
  {
    zip: "20380",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20388",
    ST: "DC",
    cityWithStateAbbr: "Washington Navy Yard, DC",
  },
  {
    zip: "20389",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20390",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20391",
    ST: "DC",
    cityWithStateAbbr: "Washington Navy Yard, DC",
  },
  {
    zip: "20392",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20393",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20394",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20395",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20398",
    ST: "DC",
    cityWithStateAbbr: "Washington Navy Yard, DC",
  },
  {
    zip: "20401",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20402",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20403",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20404",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20405",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20406",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20407",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20408",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20409",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20410",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20411",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20412",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20413",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20414",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20415",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20416",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20418",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20419",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20420",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20421",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20422",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20423",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20424",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20425",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20426",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20427",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20428",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20429",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20431",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20433",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20434",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20435",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20436",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20437",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20439",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20440",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20441",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20442",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20444",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20447",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20451",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20453",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20456",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20460",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20463",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20469",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20470",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20472",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20500",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20501",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20502",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20503",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20504",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20505",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20506",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20507",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20508",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20509",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20510",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20511",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20515",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20520",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20521",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20522",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20523",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20524",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20525",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20526",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20527",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20528",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20529",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20530",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20531",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20532",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20533",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20534",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20535",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20536",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20537",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20538",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20539",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20540",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20541",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20542",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20543",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20544",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20546",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20547",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20548",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20549",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20551",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20552",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20553",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20554",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20555",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20557",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20559",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20560",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20565",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20566",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20570",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20571",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20572",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20573",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20575",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20576",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20577",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20578",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20579",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20580",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20581",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20585",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20586",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20590",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20591",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20593",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20594",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20597",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20598",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20599",
    ST: "DC",
    cityWithStateAbbr: "Washington, DC",
  },
  {
    zip: "20601",
    ST: "MD",
    cityWithStateAbbr: "Waldorf, MD",
  },
  {
    zip: "20602",
    ST: "MD",
    cityWithStateAbbr: "Waldorf, MD",
  },
  {
    zip: "20603",
    ST: "MD",
    cityWithStateAbbr: "Waldorf, MD",
  },
  {
    zip: "20604",
    ST: "MD",
    cityWithStateAbbr: "Waldorf, MD",
  },
  {
    zip: "20606",
    ST: "MD",
    cityWithStateAbbr: "Abell, MD",
  },
  {
    zip: "20607",
    ST: "MD",
    cityWithStateAbbr: "Accokeek, MD",
  },
  {
    zip: "20608",
    ST: "MD",
    cityWithStateAbbr: "Aquasco, MD",
  },
  {
    zip: "20609",
    ST: "MD",
    cityWithStateAbbr: "Avenue, MD",
  },
  {
    zip: "20610",
    ST: "MD",
    cityWithStateAbbr: "Barstow, MD",
  },
  {
    zip: "20611",
    ST: "MD",
    cityWithStateAbbr: "Bel Alton, MD",
  },
  {
    zip: "20612",
    ST: "MD",
    cityWithStateAbbr: "Benedict, MD",
  },
  {
    zip: "20613",
    ST: "MD",
    cityWithStateAbbr: "Brandywine, MD",
  },
  {
    zip: "20615",
    ST: "MD",
    cityWithStateAbbr: "Broomes Island, MD",
  },
  {
    zip: "20616",
    ST: "MD",
    cityWithStateAbbr: "Bryans Road, MD",
  },
  {
    zip: "20617",
    ST: "MD",
    cityWithStateAbbr: "Bryantown, MD",
  },
  {
    zip: "20618",
    ST: "MD",
    cityWithStateAbbr: "Bushwood, MD",
  },
  {
    zip: "20619",
    ST: "MD",
    cityWithStateAbbr: "California, MD",
  },
  {
    zip: "20620",
    ST: "MD",
    cityWithStateAbbr: "Callaway, MD",
  },
  {
    zip: "20621",
    ST: "MD",
    cityWithStateAbbr: "Chaptico, MD",
  },
  {
    zip: "20622",
    ST: "MD",
    cityWithStateAbbr: "Charlotte Hall, MD",
  },
  {
    zip: "20623",
    ST: "MD",
    cityWithStateAbbr: "Cheltenham, MD",
  },
  {
    zip: "20624",
    ST: "MD",
    cityWithStateAbbr: "Clements, MD",
  },
  {
    zip: "20625",
    ST: "MD",
    cityWithStateAbbr: "Cobb Island, MD",
  },
  {
    zip: "20626",
    ST: "MD",
    cityWithStateAbbr: "Coltons Point, MD",
  },
  {
    zip: "20627",
    ST: "MD",
    cityWithStateAbbr: "Compton, MD",
  },
  {
    zip: "20628",
    ST: "MD",
    cityWithStateAbbr: "Dameron, MD",
  },
  {
    zip: "20629",
    ST: "MD",
    cityWithStateAbbr: "Dowell, MD",
  },
  {
    zip: "20630",
    ST: "MD",
    cityWithStateAbbr: "Drayden, MD",
  },
  {
    zip: "20632",
    ST: "MD",
    cityWithStateAbbr: "Faulkner, MD",
  },
  {
    zip: "20634",
    ST: "MD",
    cityWithStateAbbr: "Great Mills, MD",
  },
  {
    zip: "20635",
    ST: "MD",
    cityWithStateAbbr: "Helen, MD",
  },
  {
    zip: "20636",
    ST: "MD",
    cityWithStateAbbr: "Hollywood, MD",
  },
  {
    zip: "20637",
    ST: "MD",
    cityWithStateAbbr: "Hughesville, MD",
  },
  {
    zip: "20639",
    ST: "MD",
    cityWithStateAbbr: "Huntingtown, MD",
  },
  {
    zip: "20640",
    ST: "MD",
    cityWithStateAbbr: "Indian Head, MD",
  },
  {
    zip: "20643",
    ST: "MD",
    cityWithStateAbbr: "Ironsides, MD",
  },
  {
    zip: "20645",
    ST: "MD",
    cityWithStateAbbr: "Issue, MD",
  },
  {
    zip: "20646",
    ST: "MD",
    cityWithStateAbbr: "La Plata, MD",
  },
  {
    zip: "20650",
    ST: "MD",
    cityWithStateAbbr: "Leonardtown, MD",
  },
  {
    zip: "20653",
    ST: "MD",
    cityWithStateAbbr: "Lexington Park, MD",
  },
  {
    zip: "20656",
    ST: "MD",
    cityWithStateAbbr: "Loveville, MD",
  },
  {
    zip: "20657",
    ST: "MD",
    cityWithStateAbbr: "Lusby, MD",
  },
  {
    zip: "20658",
    ST: "MD",
    cityWithStateAbbr: "Marbury, MD",
  },
  {
    zip: "20659",
    ST: "MD",
    cityWithStateAbbr: "Mechanicsville, MD",
  },
  {
    zip: "20660",
    ST: "MD",
    cityWithStateAbbr: "Morganza, MD",
  },
  {
    zip: "20661",
    ST: "MD",
    cityWithStateAbbr: "Mount Victoria, MD",
  },
  {
    zip: "20662",
    ST: "MD",
    cityWithStateAbbr: "Nanjemoy, MD",
  },
  {
    zip: "20664",
    ST: "MD",
    cityWithStateAbbr: "Newburg, MD",
  },
  {
    zip: "20667",
    ST: "MD",
    cityWithStateAbbr: "Park Hall, MD",
  },
  {
    zip: "20670",
    ST: "MD",
    cityWithStateAbbr: "Patuxent River, MD",
  },
  {
    zip: "20674",
    ST: "MD",
    cityWithStateAbbr: "Piney Point, MD",
  },
  {
    zip: "20675",
    ST: "MD",
    cityWithStateAbbr: "Pomfret, MD",
  },
  {
    zip: "20676",
    ST: "MD",
    cityWithStateAbbr: "Port Republic, MD",
  },
  {
    zip: "20677",
    ST: "MD",
    cityWithStateAbbr: "Port Tobacco, MD",
  },
  {
    zip: "20678",
    ST: "MD",
    cityWithStateAbbr: "Prince Frederick, MD",
  },
  {
    zip: "20680",
    ST: "MD",
    cityWithStateAbbr: "Ridge, MD",
  },
  {
    zip: "20682",
    ST: "MD",
    cityWithStateAbbr: "Rock Point, MD",
  },
  {
    zip: "20684",
    ST: "MD",
    cityWithStateAbbr: "Saint Inigoes, MD",
  },
  {
    zip: "20685",
    ST: "MD",
    cityWithStateAbbr: "Saint Leonard, MD",
  },
  {
    zip: "20686",
    ST: "MD",
    cityWithStateAbbr: "Saint Marys City, MD",
  },
  {
    zip: "20687",
    ST: "MD",
    cityWithStateAbbr: "Scotland, MD",
  },
  {
    zip: "20688",
    ST: "MD",
    cityWithStateAbbr: "Solomons, MD",
  },
  {
    zip: "20689",
    ST: "MD",
    cityWithStateAbbr: "Sunderland, MD",
  },
  {
    zip: "20690",
    ST: "MD",
    cityWithStateAbbr: "Tall Timbers, MD",
  },
  {
    zip: "20692",
    ST: "MD",
    cityWithStateAbbr: "Valley Lee, MD",
  },
  {
    zip: "20693",
    ST: "MD",
    cityWithStateAbbr: "Welcome, MD",
  },
  {
    zip: "20695",
    ST: "MD",
    cityWithStateAbbr: "White Plains, MD",
  },
  {
    zip: "20701",
    ST: "MD",
    cityWithStateAbbr: "Annapolis Junction, MD",
  },
  {
    zip: "20703",
    ST: "MD",
    cityWithStateAbbr: "Lanham, MD",
  },
  {
    zip: "20704",
    ST: "MD",
    cityWithStateAbbr: "Beltsville, MD",
  },
  {
    zip: "20705",
    ST: "MD",
    cityWithStateAbbr: "Beltsville, MD",
  },
  {
    zip: "20706",
    ST: "MD",
    cityWithStateAbbr: "Lanham, MD",
  },
  {
    zip: "20707",
    ST: "MD",
    cityWithStateAbbr: "Laurel, MD",
  },
  {
    zip: "20708",
    ST: "MD",
    cityWithStateAbbr: "Laurel, MD",
  },
  {
    zip: "20709",
    ST: "MD",
    cityWithStateAbbr: "Laurel, MD",
  },
  {
    zip: "20710",
    ST: "MD",
    cityWithStateAbbr: "Bladensburg, MD",
  },
  {
    zip: "20711",
    ST: "MD",
    cityWithStateAbbr: "Lothian, MD",
  },
  {
    zip: "20712",
    ST: "MD",
    cityWithStateAbbr: "Mount Rainier, MD",
  },
  {
    zip: "20714",
    ST: "MD",
    cityWithStateAbbr: "North Beach, MD",
  },
  {
    zip: "20715",
    ST: "MD",
    cityWithStateAbbr: "Bowie, MD",
  },
  {
    zip: "20716",
    ST: "MD",
    cityWithStateAbbr: "Bowie, MD",
  },
  {
    zip: "20717",
    ST: "MD",
    cityWithStateAbbr: "Bowie, MD",
  },
  {
    zip: "20718",
    ST: "MD",
    cityWithStateAbbr: "Bowie, MD",
  },
  {
    zip: "20719",
    ST: "MD",
    cityWithStateAbbr: "Bowie, MD",
  },
  {
    zip: "20720",
    ST: "MD",
    cityWithStateAbbr: "Bowie, MD",
  },
  {
    zip: "20721",
    ST: "MD",
    cityWithStateAbbr: "Bowie, MD",
  },
  {
    zip: "20722",
    ST: "MD",
    cityWithStateAbbr: "Brentwood, MD",
  },
  {
    zip: "20723",
    ST: "MD",
    cityWithStateAbbr: "Laurel, MD",
  },
  {
    zip: "20724",
    ST: "MD",
    cityWithStateAbbr: "Laurel, MD",
  },
  {
    zip: "20725",
    ST: "MD",
    cityWithStateAbbr: "Laurel, MD",
  },
  {
    zip: "20726",
    ST: "MD",
    cityWithStateAbbr: "Laurel, MD",
  },
  {
    zip: "20731",
    ST: "MD",
    cityWithStateAbbr: "Capitol Heights, MD",
  },
  {
    zip: "20732",
    ST: "MD",
    cityWithStateAbbr: "Chesapeake Beach, MD",
  },
  {
    zip: "20733",
    ST: "MD",
    cityWithStateAbbr: "Churchton, MD",
  },
  {
    zip: "20735",
    ST: "MD",
    cityWithStateAbbr: "Clinton, MD",
  },
  {
    zip: "20736",
    ST: "MD",
    cityWithStateAbbr: "Owings, MD",
  },
  {
    zip: "20737",
    ST: "MD",
    cityWithStateAbbr: "Riverdale, MD",
  },
  {
    zip: "20738",
    ST: "MD",
    cityWithStateAbbr: "Riverdale, MD",
  },
  {
    zip: "20740",
    ST: "MD",
    cityWithStateAbbr: "College Park, MD",
  },
  {
    zip: "20741",
    ST: "MD",
    cityWithStateAbbr: "College Park, MD",
  },
  {
    zip: "20742",
    ST: "MD",
    cityWithStateAbbr: "College Park, MD",
  },
  {
    zip: "20743",
    ST: "MD",
    cityWithStateAbbr: "Capitol Heights, MD",
  },
  {
    zip: "20744",
    ST: "MD",
    cityWithStateAbbr: "Fort Washington, MD",
  },
  {
    zip: "20745",
    ST: "MD",
    cityWithStateAbbr: "Oxon Hill, MD",
  },
  {
    zip: "20746",
    ST: "MD",
    cityWithStateAbbr: "Suitland, MD",
  },
  {
    zip: "20747",
    ST: "MD",
    cityWithStateAbbr: "District Heights, MD",
  },
  {
    zip: "20748",
    ST: "MD",
    cityWithStateAbbr: "Temple Hills, MD",
  },
  {
    zip: "20749",
    ST: "MD",
    cityWithStateAbbr: "Fort Washington, MD",
  },
  {
    zip: "20750",
    ST: "MD",
    cityWithStateAbbr: "Oxon Hill, MD",
  },
  {
    zip: "20751",
    ST: "MD",
    cityWithStateAbbr: "Deale, MD",
  },
  {
    zip: "20752",
    ST: "MD",
    cityWithStateAbbr: "Suitland, MD",
  },
  {
    zip: "20753",
    ST: "MD",
    cityWithStateAbbr: "District Heights, MD",
  },
  {
    zip: "20754",
    ST: "MD",
    cityWithStateAbbr: "Dunkirk, MD",
  },
  {
    zip: "20755",
    ST: "MD",
    cityWithStateAbbr: "Fort George G Meade, MD",
  },
  {
    zip: "20757",
    ST: "MD",
    cityWithStateAbbr: "Temple Hills, MD",
  },
  {
    zip: "20758",
    ST: "MD",
    cityWithStateAbbr: "Friendship, MD",
  },
  {
    zip: "20759",
    ST: "MD",
    cityWithStateAbbr: "Fulton, MD",
  },
  {
    zip: "20762",
    ST: "MD",
    cityWithStateAbbr: "Andrews Air Force Base, MD",
  },
  {
    zip: "20763",
    ST: "MD",
    cityWithStateAbbr: "Savage, MD",
  },
  {
    zip: "20764",
    ST: "MD",
    cityWithStateAbbr: "Shady Side, MD",
  },
  {
    zip: "20765",
    ST: "MD",
    cityWithStateAbbr: "Galesville, MD",
  },
  {
    zip: "20768",
    ST: "MD",
    cityWithStateAbbr: "Greenbelt, MD",
  },
  {
    zip: "20769",
    ST: "MD",
    cityWithStateAbbr: "Glenn Dale, MD",
  },
  {
    zip: "20770",
    ST: "MD",
    cityWithStateAbbr: "Greenbelt, MD",
  },
  {
    zip: "20771",
    ST: "MD",
    cityWithStateAbbr: "Greenbelt, MD",
  },
  {
    zip: "20772",
    ST: "MD",
    cityWithStateAbbr: "Upper Marlboro, MD",
  },
  {
    zip: "20773",
    ST: "MD",
    cityWithStateAbbr: "Upper Marlboro, MD",
  },
  {
    zip: "20774",
    ST: "MD",
    cityWithStateAbbr: "Upper Marlboro, MD",
  },
  {
    zip: "20775",
    ST: "MD",
    cityWithStateAbbr: "Upper Marlboro, MD",
  },
  {
    zip: "20776",
    ST: "MD",
    cityWithStateAbbr: "Harwood, MD",
  },
  {
    zip: "20777",
    ST: "MD",
    cityWithStateAbbr: "Highland, MD",
  },
  {
    zip: "20778",
    ST: "MD",
    cityWithStateAbbr: "West River, MD",
  },
  {
    zip: "20779",
    ST: "MD",
    cityWithStateAbbr: "Tracys Landing, MD",
  },
  {
    zip: "20781",
    ST: "MD",
    cityWithStateAbbr: "Hyattsville, MD",
  },
  {
    zip: "20782",
    ST: "MD",
    cityWithStateAbbr: "Hyattsville, MD",
  },
  {
    zip: "20783",
    ST: "MD",
    cityWithStateAbbr: "Hyattsville, MD",
  },
  {
    zip: "20784",
    ST: "MD",
    cityWithStateAbbr: "Hyattsville, MD",
  },
  {
    zip: "20785",
    ST: "MD",
    cityWithStateAbbr: "Hyattsville, MD",
  },
  {
    zip: "20787",
    ST: "MD",
    cityWithStateAbbr: "Hyattsville, MD",
  },
  {
    zip: "20788",
    ST: "MD",
    cityWithStateAbbr: "Hyattsville, MD",
  },
  {
    zip: "20790",
    ST: "MD",
    cityWithStateAbbr: "Capitol Heights, MD",
  },
  {
    zip: "20791",
    ST: "MD",
    cityWithStateAbbr: "Capitol Heights, MD",
  },
  {
    zip: "20792",
    ST: "MD",
    cityWithStateAbbr: "Upper Marlboro, MD",
  },
  {
    zip: "20794",
    ST: "MD",
    cityWithStateAbbr: "Jessup, MD",
  },
  {
    zip: "20797",
    ST: "MD",
    cityWithStateAbbr: "Southern Md Facility, MD",
  },
  {
    zip: "20799",
    ST: "MD",
    cityWithStateAbbr: "Capitol Heights, MD",
  },
  {
    zip: "20810",
    ST: "MD",
    cityWithStateAbbr: "Bethesda, MD",
  },
  {
    zip: "20811",
    ST: "MD",
    cityWithStateAbbr: "Bethesda, MD",
  },
  {
    zip: "20812",
    ST: "MD",
    cityWithStateAbbr: "Glen Echo, MD",
  },
  {
    zip: "20813",
    ST: "MD",
    cityWithStateAbbr: "Bethesda, MD",
  },
  {
    zip: "20814",
    ST: "MD",
    cityWithStateAbbr: "Bethesda, MD",
  },
  {
    zip: "20815",
    ST: "MD",
    cityWithStateAbbr: "Chevy Chase, MD",
  },
  {
    zip: "20816",
    ST: "MD",
    cityWithStateAbbr: "Bethesda, MD",
  },
  {
    zip: "20817",
    ST: "MD",
    cityWithStateAbbr: "Bethesda, MD",
  },
  {
    zip: "20818",
    ST: "MD",
    cityWithStateAbbr: "Cabin John, MD",
  },
  {
    zip: "20824",
    ST: "MD",
    cityWithStateAbbr: "Bethesda, MD",
  },
  {
    zip: "20825",
    ST: "MD",
    cityWithStateAbbr: "Chevy Chase, MD",
  },
  {
    zip: "20827",
    ST: "MD",
    cityWithStateAbbr: "Bethesda, MD",
  },
  {
    zip: "20830",
    ST: "MD",
    cityWithStateAbbr: "Olney, MD",
  },
  {
    zip: "20832",
    ST: "MD",
    cityWithStateAbbr: "Olney, MD",
  },
  {
    zip: "20833",
    ST: "MD",
    cityWithStateAbbr: "Brookeville, MD",
  },
  {
    zip: "20837",
    ST: "MD",
    cityWithStateAbbr: "Poolesville, MD",
  },
  {
    zip: "20838",
    ST: "MD",
    cityWithStateAbbr: "Barnesville, MD",
  },
  {
    zip: "20839",
    ST: "MD",
    cityWithStateAbbr: "Beallsville, MD",
  },
  {
    zip: "20841",
    ST: "MD",
    cityWithStateAbbr: "Boyds, MD",
  },
  {
    zip: "20842",
    ST: "MD",
    cityWithStateAbbr: "Dickerson, MD",
  },
  {
    zip: "20847",
    ST: "MD",
    cityWithStateAbbr: "Rockville, MD",
  },
  {
    zip: "20848",
    ST: "MD",
    cityWithStateAbbr: "Rockville, MD",
  },
  {
    zip: "20849",
    ST: "MD",
    cityWithStateAbbr: "Rockville, MD",
  },
  {
    zip: "20850",
    ST: "MD",
    cityWithStateAbbr: "Rockville, MD",
  },
  {
    zip: "20851",
    ST: "MD",
    cityWithStateAbbr: "Rockville, MD",
  },
  {
    zip: "20852",
    ST: "MD",
    cityWithStateAbbr: "Rockville, MD",
  },
  {
    zip: "20853",
    ST: "MD",
    cityWithStateAbbr: "Rockville, MD",
  },
  {
    zip: "20854",
    ST: "MD",
    cityWithStateAbbr: "Potomac, MD",
  },
  {
    zip: "20855",
    ST: "MD",
    cityWithStateAbbr: "Derwood, MD",
  },
  {
    zip: "20857",
    ST: "MD",
    cityWithStateAbbr: "Rockville, MD",
  },
  {
    zip: "20859",
    ST: "MD",
    cityWithStateAbbr: "Potomac, MD",
  },
  {
    zip: "20860",
    ST: "MD",
    cityWithStateAbbr: "Sandy Spring, MD",
  },
  {
    zip: "20861",
    ST: "MD",
    cityWithStateAbbr: "Ashton, MD",
  },
  {
    zip: "20862",
    ST: "MD",
    cityWithStateAbbr: "Brinklow, MD",
  },
  {
    zip: "20866",
    ST: "MD",
    cityWithStateAbbr: "Burtonsville, MD",
  },
  {
    zip: "20868",
    ST: "MD",
    cityWithStateAbbr: "Spencerville, MD",
  },
  {
    zip: "20871",
    ST: "MD",
    cityWithStateAbbr: "Clarksburg, MD",
  },
  {
    zip: "20872",
    ST: "MD",
    cityWithStateAbbr: "Damascus, MD",
  },
  {
    zip: "20874",
    ST: "MD",
    cityWithStateAbbr: "Germantown, MD",
  },
  {
    zip: "20875",
    ST: "MD",
    cityWithStateAbbr: "Germantown, MD",
  },
  {
    zip: "20876",
    ST: "MD",
    cityWithStateAbbr: "Germantown, MD",
  },
  {
    zip: "20877",
    ST: "MD",
    cityWithStateAbbr: "Gaithersburg, MD",
  },
  {
    zip: "20878",
    ST: "MD",
    cityWithStateAbbr: "Gaithersburg, MD",
  },
  {
    zip: "20879",
    ST: "MD",
    cityWithStateAbbr: "Gaithersburg, MD",
  },
  {
    zip: "20880",
    ST: "MD",
    cityWithStateAbbr: "Washington Grove, MD",
  },
  {
    zip: "20882",
    ST: "MD",
    cityWithStateAbbr: "Gaithersburg, MD",
  },
  {
    zip: "20883",
    ST: "MD",
    cityWithStateAbbr: "Gaithersburg, MD",
  },
  {
    zip: "20884",
    ST: "MD",
    cityWithStateAbbr: "Gaithersburg, MD",
  },
  {
    zip: "20885",
    ST: "MD",
    cityWithStateAbbr: "Gaithersburg, MD",
  },
  {
    zip: "20886",
    ST: "MD",
    cityWithStateAbbr: "Montgomery Village, MD",
  },
  {
    zip: "20889",
    ST: "MD",
    cityWithStateAbbr: "Bethesda, MD",
  },
  {
    zip: "20891",
    ST: "MD",
    cityWithStateAbbr: "Kensington, MD",
  },
  {
    zip: "20892",
    ST: "MD",
    cityWithStateAbbr: "Bethesda, MD",
  },
  {
    zip: "20894",
    ST: "MD",
    cityWithStateAbbr: "Bethesda, MD",
  },
  {
    zip: "20895",
    ST: "MD",
    cityWithStateAbbr: "Kensington, MD",
  },
  {
    zip: "20896",
    ST: "MD",
    cityWithStateAbbr: "Garrett Park, MD",
  },
  {
    zip: "20898",
    ST: "MD",
    cityWithStateAbbr: "Gaithersburg, MD",
  },
  {
    zip: "20899",
    ST: "MD",
    cityWithStateAbbr: "Gaithersburg, MD",
  },
  {
    zip: "20901",
    ST: "MD",
    cityWithStateAbbr: "Silver Spring, MD",
  },
  {
    zip: "20902",
    ST: "MD",
    cityWithStateAbbr: "Silver Spring, MD",
  },
  {
    zip: "20903",
    ST: "MD",
    cityWithStateAbbr: "Silver Spring, MD",
  },
  {
    zip: "20904",
    ST: "MD",
    cityWithStateAbbr: "Silver Spring, MD",
  },
  {
    zip: "20905",
    ST: "MD",
    cityWithStateAbbr: "Silver Spring, MD",
  },
  {
    zip: "20906",
    ST: "MD",
    cityWithStateAbbr: "Silver Spring, MD",
  },
  {
    zip: "20907",
    ST: "MD",
    cityWithStateAbbr: "Silver Spring, MD",
  },
  {
    zip: "20908",
    ST: "MD",
    cityWithStateAbbr: "Silver Spring, MD",
  },
  {
    zip: "20910",
    ST: "MD",
    cityWithStateAbbr: "Silver Spring, MD",
  },
  {
    zip: "20911",
    ST: "MD",
    cityWithStateAbbr: "Silver Spring, MD",
  },
  {
    zip: "20912",
    ST: "MD",
    cityWithStateAbbr: "Takoma Park, MD",
  },
  {
    zip: "20913",
    ST: "MD",
    cityWithStateAbbr: "Takoma Park, MD",
  },
  {
    zip: "20914",
    ST: "MD",
    cityWithStateAbbr: "Silver Spring, MD",
  },
  {
    zip: "20915",
    ST: "MD",
    cityWithStateAbbr: "Silver Spring, MD",
  },
  {
    zip: "20916",
    ST: "MD",
    cityWithStateAbbr: "Silver Spring, MD",
  },
  {
    zip: "20918",
    ST: "MD",
    cityWithStateAbbr: "Silver Spring, MD",
  },
  {
    zip: "20993",
    ST: "MD",
    cityWithStateAbbr: "Silver Spring, MD",
  },
  {
    zip: "20997",
    ST: "MD",
    cityWithStateAbbr: "Silver Spring, MD",
  },
  {
    zip: "21001",
    ST: "MD",
    cityWithStateAbbr: "Aberdeen, MD",
  },
  {
    zip: "21005",
    ST: "MD",
    cityWithStateAbbr: "Aberdeen Proving Ground, MD",
  },
  {
    zip: "21009",
    ST: "MD",
    cityWithStateAbbr: "Abingdon, MD",
  },
  {
    zip: "21010",
    ST: "MD",
    cityWithStateAbbr: "Gunpowder, MD",
  },
  {
    zip: "21012",
    ST: "MD",
    cityWithStateAbbr: "Arnold, MD",
  },
  {
    zip: "21013",
    ST: "MD",
    cityWithStateAbbr: "Baldwin, MD",
  },
  {
    zip: "21014",
    ST: "MD",
    cityWithStateAbbr: "Bel Air, MD",
  },
  {
    zip: "21015",
    ST: "MD",
    cityWithStateAbbr: "Bel Air, MD",
  },
  {
    zip: "21017",
    ST: "MD",
    cityWithStateAbbr: "Belcamp, MD",
  },
  {
    zip: "21018",
    ST: "MD",
    cityWithStateAbbr: "Benson, MD",
  },
  {
    zip: "21020",
    ST: "MD",
    cityWithStateAbbr: "Boring, MD",
  },
  {
    zip: "21022",
    ST: "MD",
    cityWithStateAbbr: "Brooklandville, MD",
  },
  {
    zip: "21023",
    ST: "MD",
    cityWithStateAbbr: "Butler, MD",
  },
  {
    zip: "21027",
    ST: "MD",
    cityWithStateAbbr: "Chase, MD",
  },
  {
    zip: "21028",
    ST: "MD",
    cityWithStateAbbr: "Churchville, MD",
  },
  {
    zip: "21029",
    ST: "MD",
    cityWithStateAbbr: "Clarksville, MD",
  },
  {
    zip: "21030",
    ST: "MD",
    cityWithStateAbbr: "Cockeysville, MD",
  },
  {
    zip: "21031",
    ST: "MD",
    cityWithStateAbbr: "Hunt Valley, MD",
  },
  {
    zip: "21032",
    ST: "MD",
    cityWithStateAbbr: "Crownsville, MD",
  },
  {
    zip: "21034",
    ST: "MD",
    cityWithStateAbbr: "Darlington, MD",
  },
  {
    zip: "21035",
    ST: "MD",
    cityWithStateAbbr: "Davidsonville, MD",
  },
  {
    zip: "21036",
    ST: "MD",
    cityWithStateAbbr: "Dayton, MD",
  },
  {
    zip: "21037",
    ST: "MD",
    cityWithStateAbbr: "Edgewater, MD",
  },
  {
    zip: "21040",
    ST: "MD",
    cityWithStateAbbr: "Edgewood, MD",
  },
  {
    zip: "21041",
    ST: "MD",
    cityWithStateAbbr: "Ellicott City, MD",
  },
  {
    zip: "21042",
    ST: "MD",
    cityWithStateAbbr: "Ellicott City, MD",
  },
  {
    zip: "21043",
    ST: "MD",
    cityWithStateAbbr: "Ellicott City, MD",
  },
  {
    zip: "21044",
    ST: "MD",
    cityWithStateAbbr: "Columbia, MD",
  },
  {
    zip: "21045",
    ST: "MD",
    cityWithStateAbbr: "Columbia, MD",
  },
  {
    zip: "21046",
    ST: "MD",
    cityWithStateAbbr: "Columbia, MD",
  },
  {
    zip: "21047",
    ST: "MD",
    cityWithStateAbbr: "Fallston, MD",
  },
  {
    zip: "21048",
    ST: "MD",
    cityWithStateAbbr: "Finksburg, MD",
  },
  {
    zip: "21050",
    ST: "MD",
    cityWithStateAbbr: "Forest Hill, MD",
  },
  {
    zip: "21051",
    ST: "MD",
    cityWithStateAbbr: "Fork, MD",
  },
  {
    zip: "21052",
    ST: "MD",
    cityWithStateAbbr: "Fort Howard, MD",
  },
  {
    zip: "21053",
    ST: "MD",
    cityWithStateAbbr: "Freeland, MD",
  },
  {
    zip: "21054",
    ST: "MD",
    cityWithStateAbbr: "Gambrills, MD",
  },
  {
    zip: "21056",
    ST: "MD",
    cityWithStateAbbr: "Gibson Island, MD",
  },
  {
    zip: "21057",
    ST: "MD",
    cityWithStateAbbr: "Glen Arm, MD",
  },
  {
    zip: "21060",
    ST: "MD",
    cityWithStateAbbr: "Glen Burnie, MD",
  },
  {
    zip: "21061",
    ST: "MD",
    cityWithStateAbbr: "Glen Burnie, MD",
  },
  {
    zip: "21062",
    ST: "MD",
    cityWithStateAbbr: "Glen Burnie, MD",
  },
  {
    zip: "21065",
    ST: "MD",
    cityWithStateAbbr: "Hunt Valley, MD",
  },
  {
    zip: "21071",
    ST: "MD",
    cityWithStateAbbr: "Glyndon, MD",
  },
  {
    zip: "21074",
    ST: "MD",
    cityWithStateAbbr: "Hampstead, MD",
  },
  {
    zip: "21075",
    ST: "MD",
    cityWithStateAbbr: "Elkridge, MD",
  },
  {
    zip: "21076",
    ST: "MD",
    cityWithStateAbbr: "Hanover, MD",
  },
  {
    zip: "21077",
    ST: "MD",
    cityWithStateAbbr: "Harmans, MD",
  },
  {
    zip: "21078",
    ST: "MD",
    cityWithStateAbbr: "Havre De Grace, MD",
  },
  {
    zip: "21082",
    ST: "MD",
    cityWithStateAbbr: "Hydes, MD",
  },
  {
    zip: "21084",
    ST: "MD",
    cityWithStateAbbr: "Jarrettsville, MD",
  },
  {
    zip: "21085",
    ST: "MD",
    cityWithStateAbbr: "Joppa, MD",
  },
  {
    zip: "21087",
    ST: "MD",
    cityWithStateAbbr: "Kingsville, MD",
  },
  {
    zip: "21088",
    ST: "MD",
    cityWithStateAbbr: "Lineboro, MD",
  },
  {
    zip: "21090",
    ST: "MD",
    cityWithStateAbbr: "Linthicum Heights, MD",
  },
  {
    zip: "21092",
    ST: "MD",
    cityWithStateAbbr: "Long Green, MD",
  },
  {
    zip: "21093",
    ST: "MD",
    cityWithStateAbbr: "Lutherville Timonium, MD",
  },
  {
    zip: "21094",
    ST: "MD",
    cityWithStateAbbr: "Lutherville Timonium, MD",
  },
  {
    zip: "21102",
    ST: "MD",
    cityWithStateAbbr: "Manchester, MD",
  },
  {
    zip: "21104",
    ST: "MD",
    cityWithStateAbbr: "Marriottsville, MD",
  },
  {
    zip: "21105",
    ST: "MD",
    cityWithStateAbbr: "Maryland Line, MD",
  },
  {
    zip: "21106",
    ST: "MD",
    cityWithStateAbbr: "Mayo, MD",
  },
  {
    zip: "21108",
    ST: "MD",
    cityWithStateAbbr: "Millersville, MD",
  },
  {
    zip: "21111",
    ST: "MD",
    cityWithStateAbbr: "Monkton, MD",
  },
  {
    zip: "21113",
    ST: "MD",
    cityWithStateAbbr: "Odenton, MD",
  },
  {
    zip: "21114",
    ST: "MD",
    cityWithStateAbbr: "Crofton, MD",
  },
  {
    zip: "21117",
    ST: "MD",
    cityWithStateAbbr: "Owings Mills, MD",
  },
  {
    zip: "21120",
    ST: "MD",
    cityWithStateAbbr: "Parkton, MD",
  },
  {
    zip: "21122",
    ST: "MD",
    cityWithStateAbbr: "Pasadena, MD",
  },
  {
    zip: "21123",
    ST: "MD",
    cityWithStateAbbr: "Pasadena, MD",
  },
  {
    zip: "21128",
    ST: "MD",
    cityWithStateAbbr: "Perry Hall, MD",
  },
  {
    zip: "21130",
    ST: "MD",
    cityWithStateAbbr: "Perryman, MD",
  },
  {
    zip: "21131",
    ST: "MD",
    cityWithStateAbbr: "Phoenix, MD",
  },
  {
    zip: "21132",
    ST: "MD",
    cityWithStateAbbr: "Pylesville, MD",
  },
  {
    zip: "21133",
    ST: "MD",
    cityWithStateAbbr: "Randallstown, MD",
  },
  {
    zip: "21136",
    ST: "MD",
    cityWithStateAbbr: "Reisterstown, MD",
  },
  {
    zip: "21139",
    ST: "MD",
    cityWithStateAbbr: "Riderwood, MD",
  },
  {
    zip: "21140",
    ST: "MD",
    cityWithStateAbbr: "Riva, MD",
  },
  {
    zip: "21144",
    ST: "MD",
    cityWithStateAbbr: "Severn, MD",
  },
  {
    zip: "21146",
    ST: "MD",
    cityWithStateAbbr: "Severna Park, MD",
  },
  {
    zip: "21150",
    ST: "MD",
    cityWithStateAbbr: "Simpsonville, MD",
  },
  {
    zip: "21152",
    ST: "MD",
    cityWithStateAbbr: "Sparks Glencoe, MD",
  },
  {
    zip: "21153",
    ST: "MD",
    cityWithStateAbbr: "Stevenson, MD",
  },
  {
    zip: "21154",
    ST: "MD",
    cityWithStateAbbr: "Street, MD",
  },
  {
    zip: "21155",
    ST: "MD",
    cityWithStateAbbr: "Upperco, MD",
  },
  {
    zip: "21156",
    ST: "MD",
    cityWithStateAbbr: "Upper Falls, MD",
  },
  {
    zip: "21157",
    ST: "MD",
    cityWithStateAbbr: "Westminster, MD",
  },
  {
    zip: "21158",
    ST: "MD",
    cityWithStateAbbr: "Westminster, MD",
  },
  {
    zip: "21160",
    ST: "MD",
    cityWithStateAbbr: "Whiteford, MD",
  },
  {
    zip: "21161",
    ST: "MD",
    cityWithStateAbbr: "White Hall, MD",
  },
  {
    zip: "21162",
    ST: "MD",
    cityWithStateAbbr: "White Marsh, MD",
  },
  {
    zip: "21163",
    ST: "MD",
    cityWithStateAbbr: "Woodstock, MD",
  },
  {
    zip: "21201",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21202",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21203",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21204",
    ST: "MD",
    cityWithStateAbbr: "Towson, MD",
  },
  {
    zip: "21205",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21206",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21207",
    ST: "MD",
    cityWithStateAbbr: "Gwynn Oak, MD",
  },
  {
    zip: "21208",
    ST: "MD",
    cityWithStateAbbr: "Pikesville, MD",
  },
  {
    zip: "21209",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21210",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21211",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21212",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21213",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21214",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21215",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21216",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21217",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21218",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21219",
    ST: "MD",
    cityWithStateAbbr: "Sparrows Point, MD",
  },
  {
    zip: "21220",
    ST: "MD",
    cityWithStateAbbr: "Middle River, MD",
  },
  {
    zip: "21221",
    ST: "MD",
    cityWithStateAbbr: "Essex, MD",
  },
  {
    zip: "21222",
    ST: "MD",
    cityWithStateAbbr: "Dundalk, MD",
  },
  {
    zip: "21223",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21224",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21225",
    ST: "MD",
    cityWithStateAbbr: "Brooklyn, MD",
  },
  {
    zip: "21226",
    ST: "MD",
    cityWithStateAbbr: "Curtis Bay, MD",
  },
  {
    zip: "21227",
    ST: "MD",
    cityWithStateAbbr: "Halethorpe, MD",
  },
  {
    zip: "21228",
    ST: "MD",
    cityWithStateAbbr: "Catonsville, MD",
  },
  {
    zip: "21229",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21230",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21231",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21233",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21234",
    ST: "MD",
    cityWithStateAbbr: "Parkville, MD",
  },
  {
    zip: "21235",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21236",
    ST: "MD",
    cityWithStateAbbr: "Nottingham, MD",
  },
  {
    zip: "21237",
    ST: "MD",
    cityWithStateAbbr: "Rosedale, MD",
  },
  {
    zip: "21239",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21240",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21241",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21244",
    ST: "MD",
    cityWithStateAbbr: "Windsor Mill, MD",
  },
  {
    zip: "21250",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21251",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21252",
    ST: "MD",
    cityWithStateAbbr: "Towson, MD",
  },
  {
    zip: "21263",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21264",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21265",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21270",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21273",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21274",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21275",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21278",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21279",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21280",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21281",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21282",
    ST: "MD",
    cityWithStateAbbr: "Pikesville, MD",
  },
  {
    zip: "21283",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21284",
    ST: "MD",
    cityWithStateAbbr: "Towson, MD",
  },
  {
    zip: "21285",
    ST: "MD",
    cityWithStateAbbr: "Towson, MD",
  },
  {
    zip: "21286",
    ST: "MD",
    cityWithStateAbbr: "Towson, MD",
  },
  {
    zip: "21287",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21288",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21289",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21290",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21297",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21298",
    ST: "MD",
    cityWithStateAbbr: "Baltimore, MD",
  },
  {
    zip: "21401",
    ST: "MD",
    cityWithStateAbbr: "Annapolis, MD",
  },
  {
    zip: "21402",
    ST: "MD",
    cityWithStateAbbr: "Annapolis, MD",
  },
  {
    zip: "21403",
    ST: "MD",
    cityWithStateAbbr: "Annapolis, MD",
  },
  {
    zip: "21404",
    ST: "MD",
    cityWithStateAbbr: "Annapolis, MD",
  },
  {
    zip: "21405",
    ST: "MD",
    cityWithStateAbbr: "Annapolis, MD",
  },
  {
    zip: "21409",
    ST: "MD",
    cityWithStateAbbr: "Annapolis, MD",
  },
  {
    zip: "21411",
    ST: "MD",
    cityWithStateAbbr: "Annapolis, MD",
  },
  {
    zip: "21412",
    ST: "MD",
    cityWithStateAbbr: "Annapolis, MD",
  },
  {
    zip: "21501",
    ST: "MD",
    cityWithStateAbbr: "Cumberland, MD",
  },
  {
    zip: "21502",
    ST: "MD",
    cityWithStateAbbr: "Cumberland, MD",
  },
  {
    zip: "21503",
    ST: "MD",
    cityWithStateAbbr: "Cumberland, MD",
  },
  {
    zip: "21504",
    ST: "MD",
    cityWithStateAbbr: "Cumberland, MD",
  },
  {
    zip: "21505",
    ST: "MD",
    cityWithStateAbbr: "Cumberland, MD",
  },
  {
    zip: "21520",
    ST: "MD",
    cityWithStateAbbr: "Accident, MD",
  },
  {
    zip: "21521",
    ST: "MD",
    cityWithStateAbbr: "Barton, MD",
  },
  {
    zip: "21522",
    ST: "MD",
    cityWithStateAbbr: "Bittinger, MD",
  },
  {
    zip: "21523",
    ST: "MD",
    cityWithStateAbbr: "Bloomington, MD",
  },
  {
    zip: "21524",
    ST: "MD",
    cityWithStateAbbr: "Corriganville, MD",
  },
  {
    zip: "21528",
    ST: "MD",
    cityWithStateAbbr: "Eckhart Mines, MD",
  },
  {
    zip: "21529",
    ST: "MD",
    cityWithStateAbbr: "Ellerslie, MD",
  },
  {
    zip: "21530",
    ST: "MD",
    cityWithStateAbbr: "Flintstone, MD",
  },
  {
    zip: "21531",
    ST: "MD",
    cityWithStateAbbr: "Friendsville, MD",
  },
  {
    zip: "21532",
    ST: "MD",
    cityWithStateAbbr: "Frostburg, MD",
  },
  {
    zip: "21536",
    ST: "MD",
    cityWithStateAbbr: "Grantsville, MD",
  },
  {
    zip: "21538",
    ST: "MD",
    cityWithStateAbbr: "Kitzmiller, MD",
  },
  {
    zip: "21539",
    ST: "MD",
    cityWithStateAbbr: "Lonaconing, MD",
  },
  {
    zip: "21540",
    ST: "MD",
    cityWithStateAbbr: "Luke, MD",
  },
  {
    zip: "21541",
    ST: "MD",
    cityWithStateAbbr: "Mc Henry, MD",
  },
  {
    zip: "21542",
    ST: "MD",
    cityWithStateAbbr: "Midland, MD",
  },
  {
    zip: "21543",
    ST: "MD",
    cityWithStateAbbr: "Midlothian, MD",
  },
  {
    zip: "21545",
    ST: "MD",
    cityWithStateAbbr: "Mount Savage, MD",
  },
  {
    zip: "21550",
    ST: "MD",
    cityWithStateAbbr: "Oakland, MD",
  },
  {
    zip: "21555",
    ST: "MD",
    cityWithStateAbbr: "Oldtown, MD",
  },
  {
    zip: "21556",
    ST: "MD",
    cityWithStateAbbr: "Pinto, MD",
  },
  {
    zip: "21557",
    ST: "MD",
    cityWithStateAbbr: "Rawlings, MD",
  },
  {
    zip: "21560",
    ST: "MD",
    cityWithStateAbbr: "Spring Gap, MD",
  },
  {
    zip: "21561",
    ST: "MD",
    cityWithStateAbbr: "Swanton, MD",
  },
  {
    zip: "21562",
    ST: "MD",
    cityWithStateAbbr: "Westernport, MD",
  },
  {
    zip: "21601",
    ST: "MD",
    cityWithStateAbbr: "Easton, MD",
  },
  {
    zip: "21607",
    ST: "MD",
    cityWithStateAbbr: "Barclay, MD",
  },
  {
    zip: "21609",
    ST: "MD",
    cityWithStateAbbr: "Bethlehem, MD",
  },
  {
    zip: "21610",
    ST: "MD",
    cityWithStateAbbr: "Betterton, MD",
  },
  {
    zip: "21612",
    ST: "MD",
    cityWithStateAbbr: "Bozman, MD",
  },
  {
    zip: "21613",
    ST: "MD",
    cityWithStateAbbr: "Cambridge, MD",
  },
  {
    zip: "21617",
    ST: "MD",
    cityWithStateAbbr: "Centreville, MD",
  },
  {
    zip: "21619",
    ST: "MD",
    cityWithStateAbbr: "Chester, MD",
  },
  {
    zip: "21620",
    ST: "MD",
    cityWithStateAbbr: "Chestertown, MD",
  },
  {
    zip: "21622",
    ST: "MD",
    cityWithStateAbbr: "Church Creek, MD",
  },
  {
    zip: "21623",
    ST: "MD",
    cityWithStateAbbr: "Church Hill, MD",
  },
  {
    zip: "21624",
    ST: "MD",
    cityWithStateAbbr: "Claiborne, MD",
  },
  {
    zip: "21625",
    ST: "MD",
    cityWithStateAbbr: "Cordova, MD",
  },
  {
    zip: "21626",
    ST: "MD",
    cityWithStateAbbr: "Crapo, MD",
  },
  {
    zip: "21627",
    ST: "MD",
    cityWithStateAbbr: "Crocheron, MD",
  },
  {
    zip: "21628",
    ST: "MD",
    cityWithStateAbbr: "Crumpton, MD",
  },
  {
    zip: "21629",
    ST: "MD",
    cityWithStateAbbr: "Denton, MD",
  },
  {
    zip: "21631",
    ST: "MD",
    cityWithStateAbbr: "East New Market, MD",
  },
  {
    zip: "21632",
    ST: "MD",
    cityWithStateAbbr: "Federalsburg, MD",
  },
  {
    zip: "21634",
    ST: "MD",
    cityWithStateAbbr: "Fishing Creek, MD",
  },
  {
    zip: "21635",
    ST: "MD",
    cityWithStateAbbr: "Galena, MD",
  },
  {
    zip: "21636",
    ST: "MD",
    cityWithStateAbbr: "Goldsboro, MD",
  },
  {
    zip: "21638",
    ST: "MD",
    cityWithStateAbbr: "Grasonville, MD",
  },
  {
    zip: "21639",
    ST: "MD",
    cityWithStateAbbr: "Greensboro, MD",
  },
  {
    zip: "21640",
    ST: "MD",
    cityWithStateAbbr: "Henderson, MD",
  },
  {
    zip: "21641",
    ST: "MD",
    cityWithStateAbbr: "Hillsboro, MD",
  },
  {
    zip: "21643",
    ST: "MD",
    cityWithStateAbbr: "Hurlock, MD",
  },
  {
    zip: "21644",
    ST: "MD",
    cityWithStateAbbr: "Ingleside, MD",
  },
  {
    zip: "21645",
    ST: "MD",
    cityWithStateAbbr: "Kennedyville, MD",
  },
  {
    zip: "21647",
    ST: "MD",
    cityWithStateAbbr: "Mcdaniel, MD",
  },
  {
    zip: "21648",
    ST: "MD",
    cityWithStateAbbr: "Madison, MD",
  },
  {
    zip: "21649",
    ST: "MD",
    cityWithStateAbbr: "Marydel, MD",
  },
  {
    zip: "21650",
    ST: "MD",
    cityWithStateAbbr: "Massey, MD",
  },
  {
    zip: "21651",
    ST: "MD",
    cityWithStateAbbr: "Millington, MD",
  },
  {
    zip: "21652",
    ST: "MD",
    cityWithStateAbbr: "Neavitt, MD",
  },
  {
    zip: "21653",
    ST: "MD",
    cityWithStateAbbr: "Newcomb, MD",
  },
  {
    zip: "21654",
    ST: "MD",
    cityWithStateAbbr: "Oxford, MD",
  },
  {
    zip: "21655",
    ST: "MD",
    cityWithStateAbbr: "Preston, MD",
  },
  {
    zip: "21656",
    ST: "MD",
    cityWithStateAbbr: "Price, MD",
  },
  {
    zip: "21657",
    ST: "MD",
    cityWithStateAbbr: "Queen Anne, MD",
  },
  {
    zip: "21658",
    ST: "MD",
    cityWithStateAbbr: "Queenstown, MD",
  },
  {
    zip: "21659",
    ST: "MD",
    cityWithStateAbbr: "Rhodesdale, MD",
  },
  {
    zip: "21660",
    ST: "MD",
    cityWithStateAbbr: "Ridgely, MD",
  },
  {
    zip: "21661",
    ST: "MD",
    cityWithStateAbbr: "Rock Hall, MD",
  },
  {
    zip: "21662",
    ST: "MD",
    cityWithStateAbbr: "Royal Oak, MD",
  },
  {
    zip: "21663",
    ST: "MD",
    cityWithStateAbbr: "Saint Michaels, MD",
  },
  {
    zip: "21664",
    ST: "MD",
    cityWithStateAbbr: "Secretary, MD",
  },
  {
    zip: "21665",
    ST: "MD",
    cityWithStateAbbr: "Sherwood, MD",
  },
  {
    zip: "21666",
    ST: "MD",
    cityWithStateAbbr: "Stevensville, MD",
  },
  {
    zip: "21667",
    ST: "MD",
    cityWithStateAbbr: "Still Pond, MD",
  },
  {
    zip: "21668",
    ST: "MD",
    cityWithStateAbbr: "Sudlersville, MD",
  },
  {
    zip: "21669",
    ST: "MD",
    cityWithStateAbbr: "Taylors Island, MD",
  },
  {
    zip: "21670",
    ST: "MD",
    cityWithStateAbbr: "Templeville, MD",
  },
  {
    zip: "21671",
    ST: "MD",
    cityWithStateAbbr: "Tilghman, MD",
  },
  {
    zip: "21672",
    ST: "MD",
    cityWithStateAbbr: "Toddville, MD",
  },
  {
    zip: "21673",
    ST: "MD",
    cityWithStateAbbr: "Trappe, MD",
  },
  {
    zip: "21675",
    ST: "MD",
    cityWithStateAbbr: "Wingate, MD",
  },
  {
    zip: "21676",
    ST: "MD",
    cityWithStateAbbr: "Wittman, MD",
  },
  {
    zip: "21677",
    ST: "MD",
    cityWithStateAbbr: "Woolford, MD",
  },
  {
    zip: "21678",
    ST: "MD",
    cityWithStateAbbr: "Worton, MD",
  },
  {
    zip: "21679",
    ST: "MD",
    cityWithStateAbbr: "Wye Mills, MD",
  },
  {
    zip: "21690",
    ST: "MD",
    cityWithStateAbbr: "Chestertown, MD",
  },
  {
    zip: "21701",
    ST: "MD",
    cityWithStateAbbr: "Frederick, MD",
  },
  {
    zip: "21702",
    ST: "MD",
    cityWithStateAbbr: "Frederick, MD",
  },
  {
    zip: "21703",
    ST: "MD",
    cityWithStateAbbr: "Frederick, MD",
  },
  {
    zip: "21704",
    ST: "MD",
    cityWithStateAbbr: "Frederick, MD",
  },
  {
    zip: "21705",
    ST: "MD",
    cityWithStateAbbr: "Frederick, MD",
  },
  {
    zip: "21709",
    ST: "MD",
    cityWithStateAbbr: "Frederick, MD",
  },
  {
    zip: "21710",
    ST: "MD",
    cityWithStateAbbr: "Adamstown, MD",
  },
  {
    zip: "21711",
    ST: "MD",
    cityWithStateAbbr: "Big Pool, MD",
  },
  {
    zip: "21713",
    ST: "MD",
    cityWithStateAbbr: "Boonsboro, MD",
  },
  {
    zip: "21714",
    ST: "MD",
    cityWithStateAbbr: "Braddock Heights, MD",
  },
  {
    zip: "21715",
    ST: "MD",
    cityWithStateAbbr: "Brownsville, MD",
  },
  {
    zip: "21716",
    ST: "MD",
    cityWithStateAbbr: "Brunswick, MD",
  },
  {
    zip: "21717",
    ST: "MD",
    cityWithStateAbbr: "Buckeystown, MD",
  },
  {
    zip: "21718",
    ST: "MD",
    cityWithStateAbbr: "Burkittsville, MD",
  },
  {
    zip: "21719",
    ST: "MD",
    cityWithStateAbbr: "Cascade, MD",
  },
  {
    zip: "21720",
    ST: "MD",
    cityWithStateAbbr: "Cavetown, MD",
  },
  {
    zip: "21721",
    ST: "MD",
    cityWithStateAbbr: "Chewsville, MD",
  },
  {
    zip: "21722",
    ST: "MD",
    cityWithStateAbbr: "Clear Spring, MD",
  },
  {
    zip: "21723",
    ST: "MD",
    cityWithStateAbbr: "Cooksville, MD",
  },
  {
    zip: "21727",
    ST: "MD",
    cityWithStateAbbr: "Emmitsburg, MD",
  },
  {
    zip: "21733",
    ST: "MD",
    cityWithStateAbbr: "Fairplay, MD",
  },
  {
    zip: "21734",
    ST: "MD",
    cityWithStateAbbr: "Funkstown, MD",
  },
  {
    zip: "21737",
    ST: "MD",
    cityWithStateAbbr: "Glenelg, MD",
  },
  {
    zip: "21738",
    ST: "MD",
    cityWithStateAbbr: "Glenwood, MD",
  },
  {
    zip: "21740",
    ST: "MD",
    cityWithStateAbbr: "Hagerstown, MD",
  },
  {
    zip: "21741",
    ST: "MD",
    cityWithStateAbbr: "Hagerstown, MD",
  },
  {
    zip: "21742",
    ST: "MD",
    cityWithStateAbbr: "Hagerstown, MD",
  },
  {
    zip: "21746",
    ST: "MD",
    cityWithStateAbbr: "Hagerstown, MD",
  },
  {
    zip: "21747",
    ST: "MD",
    cityWithStateAbbr: "Hagerstown, MD",
  },
  {
    zip: "21748",
    ST: "MD",
    cityWithStateAbbr: "Hagerstown, MD",
  },
  {
    zip: "21749",
    ST: "MD",
    cityWithStateAbbr: "Hagerstown, MD",
  },
  {
    zip: "21750",
    ST: "MD",
    cityWithStateAbbr: "Hancock, MD",
  },
  {
    zip: "21754",
    ST: "MD",
    cityWithStateAbbr: "Ijamsville, MD",
  },
  {
    zip: "21755",
    ST: "MD",
    cityWithStateAbbr: "Jefferson, MD",
  },
  {
    zip: "21756",
    ST: "MD",
    cityWithStateAbbr: "Keedysville, MD",
  },
  {
    zip: "21757",
    ST: "MD",
    cityWithStateAbbr: "Keymar, MD",
  },
  {
    zip: "21758",
    ST: "MD",
    cityWithStateAbbr: "Knoxville, MD",
  },
  {
    zip: "21759",
    ST: "MD",
    cityWithStateAbbr: "Ladiesburg, MD",
  },
  {
    zip: "21762",
    ST: "MD",
    cityWithStateAbbr: "Libertytown, MD",
  },
  {
    zip: "21765",
    ST: "MD",
    cityWithStateAbbr: "Lisbon, MD",
  },
  {
    zip: "21766",
    ST: "MD",
    cityWithStateAbbr: "Little Orleans, MD",
  },
  {
    zip: "21767",
    ST: "MD",
    cityWithStateAbbr: "Maugansville, MD",
  },
  {
    zip: "21769",
    ST: "MD",
    cityWithStateAbbr: "Middletown, MD",
  },
  {
    zip: "21770",
    ST: "MD",
    cityWithStateAbbr: "Monrovia, MD",
  },
  {
    zip: "21771",
    ST: "MD",
    cityWithStateAbbr: "Mount Airy, MD",
  },
  {
    zip: "21773",
    ST: "MD",
    cityWithStateAbbr: "Myersville, MD",
  },
  {
    zip: "21774",
    ST: "MD",
    cityWithStateAbbr: "New Market, MD",
  },
  {
    zip: "21775",
    ST: "MD",
    cityWithStateAbbr: "New Midway, MD",
  },
  {
    zip: "21776",
    ST: "MD",
    cityWithStateAbbr: "New Windsor, MD",
  },
  {
    zip: "21777",
    ST: "MD",
    cityWithStateAbbr: "Point Of Rocks, MD",
  },
  {
    zip: "21778",
    ST: "MD",
    cityWithStateAbbr: "Rocky Ridge, MD",
  },
  {
    zip: "21779",
    ST: "MD",
    cityWithStateAbbr: "Rohrersville, MD",
  },
  {
    zip: "21780",
    ST: "MD",
    cityWithStateAbbr: "Sabillasville, MD",
  },
  {
    zip: "21781",
    ST: "MD",
    cityWithStateAbbr: "Saint James, MD",
  },
  {
    zip: "21782",
    ST: "MD",
    cityWithStateAbbr: "Sharpsburg, MD",
  },
  {
    zip: "21783",
    ST: "MD",
    cityWithStateAbbr: "Smithsburg, MD",
  },
  {
    zip: "21784",
    ST: "MD",
    cityWithStateAbbr: "Sykesville, MD",
  },
  {
    zip: "21787",
    ST: "MD",
    cityWithStateAbbr: "Taneytown, MD",
  },
  {
    zip: "21788",
    ST: "MD",
    cityWithStateAbbr: "Thurmont, MD",
  },
  {
    zip: "21790",
    ST: "MD",
    cityWithStateAbbr: "Tuscarora, MD",
  },
  {
    zip: "21791",
    ST: "MD",
    cityWithStateAbbr: "Union Bridge, MD",
  },
  {
    zip: "21792",
    ST: "MD",
    cityWithStateAbbr: "Unionville, MD",
  },
  {
    zip: "21793",
    ST: "MD",
    cityWithStateAbbr: "Walkersville, MD",
  },
  {
    zip: "21794",
    ST: "MD",
    cityWithStateAbbr: "West Friendship, MD",
  },
  {
    zip: "21795",
    ST: "MD",
    cityWithStateAbbr: "Williamsport, MD",
  },
  {
    zip: "21797",
    ST: "MD",
    cityWithStateAbbr: "Woodbine, MD",
  },
  {
    zip: "21798",
    ST: "MD",
    cityWithStateAbbr: "Woodsboro, MD",
  },
  {
    zip: "21801",
    ST: "MD",
    cityWithStateAbbr: "Salisbury, MD",
  },
  {
    zip: "21802",
    ST: "MD",
    cityWithStateAbbr: "Salisbury, MD",
  },
  {
    zip: "21803",
    ST: "MD",
    cityWithStateAbbr: "Salisbury, MD",
  },
  {
    zip: "21804",
    ST: "MD",
    cityWithStateAbbr: "Salisbury, MD",
  },
  {
    zip: "21810",
    ST: "MD",
    cityWithStateAbbr: "Allen, MD",
  },
  {
    zip: "21811",
    ST: "MD",
    cityWithStateAbbr: "Berlin, MD",
  },
  {
    zip: "21813",
    ST: "MD",
    cityWithStateAbbr: "Bishopville, MD",
  },
  {
    zip: "21814",
    ST: "MD",
    cityWithStateAbbr: "Bivalve, MD",
  },
  {
    zip: "21817",
    ST: "MD",
    cityWithStateAbbr: "Crisfield, MD",
  },
  {
    zip: "21821",
    ST: "MD",
    cityWithStateAbbr: "Deal Island, MD",
  },
  {
    zip: "21822",
    ST: "MD",
    cityWithStateAbbr: "Eden, MD",
  },
  {
    zip: "21824",
    ST: "MD",
    cityWithStateAbbr: "Ewell, MD",
  },
  {
    zip: "21826",
    ST: "MD",
    cityWithStateAbbr: "Fruitland, MD",
  },
  {
    zip: "21829",
    ST: "MD",
    cityWithStateAbbr: "Girdletree, MD",
  },
  {
    zip: "21830",
    ST: "MD",
    cityWithStateAbbr: "Hebron, MD",
  },
  {
    zip: "21835",
    ST: "MD",
    cityWithStateAbbr: "Linkwood, MD",
  },
  {
    zip: "21836",
    ST: "MD",
    cityWithStateAbbr: "Manokin, MD",
  },
  {
    zip: "21837",
    ST: "MD",
    cityWithStateAbbr: "Mardela Springs, MD",
  },
  {
    zip: "21838",
    ST: "MD",
    cityWithStateAbbr: "Marion Station, MD",
  },
  {
    zip: "21840",
    ST: "MD",
    cityWithStateAbbr: "Nanticoke, MD",
  },
  {
    zip: "21841",
    ST: "MD",
    cityWithStateAbbr: "Newark, MD",
  },
  {
    zip: "21842",
    ST: "MD",
    cityWithStateAbbr: "Ocean City, MD",
  },
  {
    zip: "21843",
    ST: "MD",
    cityWithStateAbbr: "Ocean City, MD",
  },
  {
    zip: "21849",
    ST: "MD",
    cityWithStateAbbr: "Parsonsburg, MD",
  },
  {
    zip: "21850",
    ST: "MD",
    cityWithStateAbbr: "Pittsville, MD",
  },
  {
    zip: "21851",
    ST: "MD",
    cityWithStateAbbr: "Pocomoke City, MD",
  },
  {
    zip: "21852",
    ST: "MD",
    cityWithStateAbbr: "Powellville, MD",
  },
  {
    zip: "21853",
    ST: "MD",
    cityWithStateAbbr: "Princess Anne, MD",
  },
  {
    zip: "21856",
    ST: "MD",
    cityWithStateAbbr: "Quantico, MD",
  },
  {
    zip: "21857",
    ST: "MD",
    cityWithStateAbbr: "Rehobeth, MD",
  },
  {
    zip: "21861",
    ST: "MD",
    cityWithStateAbbr: "Sharptown, MD",
  },
  {
    zip: "21862",
    ST: "MD",
    cityWithStateAbbr: "Showell, MD",
  },
  {
    zip: "21863",
    ST: "MD",
    cityWithStateAbbr: "Snow Hill, MD",
  },
  {
    zip: "21864",
    ST: "MD",
    cityWithStateAbbr: "Stockton, MD",
  },
  {
    zip: "21865",
    ST: "MD",
    cityWithStateAbbr: "Tyaskin, MD",
  },
  {
    zip: "21866",
    ST: "MD",
    cityWithStateAbbr: "Tylerton, MD",
  },
  {
    zip: "21867",
    ST: "MD",
    cityWithStateAbbr: "Upper Fairmount, MD",
  },
  {
    zip: "21869",
    ST: "MD",
    cityWithStateAbbr: "Vienna, MD",
  },
  {
    zip: "21871",
    ST: "MD",
    cityWithStateAbbr: "Westover, MD",
  },
  {
    zip: "21872",
    ST: "MD",
    cityWithStateAbbr: "Whaleyville, MD",
  },
  {
    zip: "21874",
    ST: "MD",
    cityWithStateAbbr: "Willards, MD",
  },
  {
    zip: "21875",
    ST: "MD",
    cityWithStateAbbr: "Delmar, MD",
  },
  {
    zip: "21890",
    ST: "MD",
    cityWithStateAbbr: "Westover, MD",
  },
  {
    zip: "21901",
    ST: "MD",
    cityWithStateAbbr: "North East, MD",
  },
  {
    zip: "21902",
    ST: "MD",
    cityWithStateAbbr: "Perry Point, MD",
  },
  {
    zip: "21903",
    ST: "MD",
    cityWithStateAbbr: "Perryville, MD",
  },
  {
    zip: "21904",
    ST: "MD",
    cityWithStateAbbr: "Port Deposit, MD",
  },
  {
    zip: "21911",
    ST: "MD",
    cityWithStateAbbr: "Rising Sun, MD",
  },
  {
    zip: "21912",
    ST: "MD",
    cityWithStateAbbr: "Warwick, MD",
  },
  {
    zip: "21913",
    ST: "MD",
    cityWithStateAbbr: "Cecilton, MD",
  },
  {
    zip: "21914",
    ST: "MD",
    cityWithStateAbbr: "Charlestown, MD",
  },
  {
    zip: "21915",
    ST: "MD",
    cityWithStateAbbr: "Chesapeake City, MD",
  },
  {
    zip: "21916",
    ST: "MD",
    cityWithStateAbbr: "Childs, MD",
  },
  {
    zip: "21917",
    ST: "MD",
    cityWithStateAbbr: "Colora, MD",
  },
  {
    zip: "21918",
    ST: "MD",
    cityWithStateAbbr: "Conowingo, MD",
  },
  {
    zip: "21919",
    ST: "MD",
    cityWithStateAbbr: "Earleville, MD",
  },
  {
    zip: "21920",
    ST: "MD",
    cityWithStateAbbr: "Elk Mills, MD",
  },
  {
    zip: "21921",
    ST: "MD",
    cityWithStateAbbr: "Elkton, MD",
  },
  {
    zip: "21922",
    ST: "MD",
    cityWithStateAbbr: "Elkton, MD",
  },
  {
    zip: "21930",
    ST: "MD",
    cityWithStateAbbr: "Georgetown, MD",
  },
  {
    zip: "22003",
    ST: "VA",
    cityWithStateAbbr: "Annandale, VA",
  },
  {
    zip: "22009",
    ST: "VA",
    cityWithStateAbbr: "Burke, VA",
  },
  {
    zip: "22015",
    ST: "VA",
    cityWithStateAbbr: "Burke, VA",
  },
  {
    zip: "22025",
    ST: "VA",
    cityWithStateAbbr: "Dumfries, VA",
  },
  {
    zip: "22026",
    ST: "VA",
    cityWithStateAbbr: "Dumfries, VA",
  },
  {
    zip: "22027",
    ST: "VA",
    cityWithStateAbbr: "Dunn Loring, VA",
  },
  {
    zip: "22030",
    ST: "VA",
    cityWithStateAbbr: "Fairfax, VA",
  },
  {
    zip: "22031",
    ST: "VA",
    cityWithStateAbbr: "Fairfax, VA",
  },
  {
    zip: "22032",
    ST: "VA",
    cityWithStateAbbr: "Fairfax, VA",
  },
  {
    zip: "22033",
    ST: "VA",
    cityWithStateAbbr: "Fairfax, VA",
  },
  {
    zip: "22034",
    ST: "VA",
    cityWithStateAbbr: "Fairfax, VA",
  },
  {
    zip: "22035",
    ST: "VA",
    cityWithStateAbbr: "Fairfax, VA",
  },
  {
    zip: "22036",
    ST: "VA",
    cityWithStateAbbr: "Fairfax, VA",
  },
  {
    zip: "22037",
    ST: "VA",
    cityWithStateAbbr: "Fairfax, VA",
  },
  {
    zip: "22038",
    ST: "VA",
    cityWithStateAbbr: "Fairfax, VA",
  },
  {
    zip: "22039",
    ST: "VA",
    cityWithStateAbbr: "Fairfax Station, VA",
  },
  {
    zip: "22040",
    ST: "VA",
    cityWithStateAbbr: "Falls Church, VA",
  },
  {
    zip: "22041",
    ST: "VA",
    cityWithStateAbbr: "Falls Church, VA",
  },
  {
    zip: "22042",
    ST: "VA",
    cityWithStateAbbr: "Falls Church, VA",
  },
  {
    zip: "22043",
    ST: "VA",
    cityWithStateAbbr: "Falls Church, VA",
  },
  {
    zip: "22044",
    ST: "VA",
    cityWithStateAbbr: "Falls Church, VA",
  },
  {
    zip: "22046",
    ST: "VA",
    cityWithStateAbbr: "Falls Church, VA",
  },
  {
    zip: "22060",
    ST: "VA",
    cityWithStateAbbr: "Fort Belvoir, VA",
  },
  {
    zip: "22066",
    ST: "VA",
    cityWithStateAbbr: "Great Falls, VA",
  },
  {
    zip: "22067",
    ST: "VA",
    cityWithStateAbbr: "Greenway, VA",
  },
  {
    zip: "22079",
    ST: "VA",
    cityWithStateAbbr: "Lorton, VA",
  },
  {
    zip: "22081",
    ST: "VA",
    cityWithStateAbbr: "Merrifield, VA",
  },
  {
    zip: "22082",
    ST: "VA",
    cityWithStateAbbr: "Merrifield, VA",
  },
  {
    zip: "22101",
    ST: "VA",
    cityWithStateAbbr: "Mc Lean, VA",
  },
  {
    zip: "22102",
    ST: "VA",
    cityWithStateAbbr: "Mc Lean, VA",
  },
  {
    zip: "22103",
    ST: "VA",
    cityWithStateAbbr: "West Mclean, VA",
  },
  {
    zip: "22106",
    ST: "VA",
    cityWithStateAbbr: "Mc Lean, VA",
  },
  {
    zip: "22107",
    ST: "VA",
    cityWithStateAbbr: "Mc Lean, VA",
  },
  {
    zip: "22108",
    ST: "VA",
    cityWithStateAbbr: "Mc Lean, VA",
  },
  {
    zip: "22109",
    ST: "VA",
    cityWithStateAbbr: "Mc Lean, VA",
  },
  {
    zip: "22116",
    ST: "VA",
    cityWithStateAbbr: "Merrifield, VA",
  },
  {
    zip: "22117",
    ST: "VA",
    cityWithStateAbbr: "Middleburg, VA",
  },
  {
    zip: "22118",
    ST: "VA",
    cityWithStateAbbr: "Merrifield, VA",
  },
  {
    zip: "22119",
    ST: "VA",
    cityWithStateAbbr: "Merrifield, VA",
  },
  {
    zip: "22121",
    ST: "VA",
    cityWithStateAbbr: "Mount Vernon, VA",
  },
  {
    zip: "22122",
    ST: "VA",
    cityWithStateAbbr: "Newington, VA",
  },
  {
    zip: "22124",
    ST: "VA",
    cityWithStateAbbr: "Oakton, VA",
  },
  {
    zip: "22125",
    ST: "VA",
    cityWithStateAbbr: "Occoquan, VA",
  },
  {
    zip: "22134",
    ST: "VA",
    cityWithStateAbbr: "Quantico, VA",
  },
  {
    zip: "22135",
    ST: "VA",
    cityWithStateAbbr: "Quantico, VA",
  },
  {
    zip: "22150",
    ST: "VA",
    cityWithStateAbbr: "Springfield, VA",
  },
  {
    zip: "22151",
    ST: "VA",
    cityWithStateAbbr: "Springfield, VA",
  },
  {
    zip: "22152",
    ST: "VA",
    cityWithStateAbbr: "Springfield, VA",
  },
  {
    zip: "22153",
    ST: "VA",
    cityWithStateAbbr: "Springfield, VA",
  },
  {
    zip: "22156",
    ST: "VA",
    cityWithStateAbbr: "Springfield, VA",
  },
  {
    zip: "22158",
    ST: "VA",
    cityWithStateAbbr: "Springfield, VA",
  },
  {
    zip: "22159",
    ST: "VA",
    cityWithStateAbbr: "Springfield, VA",
  },
  {
    zip: "22160",
    ST: "VA",
    cityWithStateAbbr: "Springfield, VA",
  },
  {
    zip: "22161",
    ST: "VA",
    cityWithStateAbbr: "Springfield, VA",
  },
  {
    zip: "22172",
    ST: "VA",
    cityWithStateAbbr: "Triangle, VA",
  },
  {
    zip: "22180",
    ST: "VA",
    cityWithStateAbbr: "Vienna, VA",
  },
  {
    zip: "22181",
    ST: "VA",
    cityWithStateAbbr: "Vienna, VA",
  },
  {
    zip: "22182",
    ST: "VA",
    cityWithStateAbbr: "Vienna, VA",
  },
  {
    zip: "22183",
    ST: "VA",
    cityWithStateAbbr: "Vienna, VA",
  },
  {
    zip: "22185",
    ST: "VA",
    cityWithStateAbbr: "Vienna, VA",
  },
  {
    zip: "22191",
    ST: "VA",
    cityWithStateAbbr: "Woodbridge, VA",
  },
  {
    zip: "22192",
    ST: "VA",
    cityWithStateAbbr: "Woodbridge, VA",
  },
  {
    zip: "22193",
    ST: "VA",
    cityWithStateAbbr: "Woodbridge, VA",
  },
  {
    zip: "22194",
    ST: "VA",
    cityWithStateAbbr: "Woodbridge, VA",
  },
  {
    zip: "22195",
    ST: "VA",
    cityWithStateAbbr: "Woodbridge, VA",
  },
  {
    zip: "22199",
    ST: "VA",
    cityWithStateAbbr: "Lorton, VA",
  },
  {
    zip: "22201",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22202",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22203",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22204",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22205",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22206",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22207",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22209",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22210",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22211",
    ST: "VA",
    cityWithStateAbbr: "Fort Myer, VA",
  },
  {
    zip: "22212",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22213",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22214",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22215",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22216",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22217",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22219",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22222",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22225",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22226",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22227",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22230",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22240",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22242",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22243",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22244",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22245",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22246",
    ST: "VA",
    cityWithStateAbbr: "Arlington, VA",
  },
  {
    zip: "22301",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22302",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22303",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22304",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22305",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22306",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22307",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22308",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22309",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22310",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22311",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22312",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22313",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22314",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22315",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22320",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22331",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22332",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22333",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22334",
    ST: "VA",
    cityWithStateAbbr: "Alexandria, VA",
  },
  {
    zip: "22401",
    ST: "VA",
    cityWithStateAbbr: "Fredericksburg, VA",
  },
  {
    zip: "22402",
    ST: "VA",
    cityWithStateAbbr: "Fredericksburg, VA",
  },
  {
    zip: "22403",
    ST: "VA",
    cityWithStateAbbr: "Fredericksburg, VA",
  },
  {
    zip: "22404",
    ST: "VA",
    cityWithStateAbbr: "Fredericksburg, VA",
  },
  {
    zip: "22405",
    ST: "VA",
    cityWithStateAbbr: "Fredericksburg, VA",
  },
  {
    zip: "22406",
    ST: "VA",
    cityWithStateAbbr: "Fredericksburg, VA",
  },
  {
    zip: "22407",
    ST: "VA",
    cityWithStateAbbr: "Fredericksburg, VA",
  },
  {
    zip: "22408",
    ST: "VA",
    cityWithStateAbbr: "Fredericksburg, VA",
  },
  {
    zip: "22412",
    ST: "VA",
    cityWithStateAbbr: "Fredericksburg, VA",
  },
  {
    zip: "22427",
    ST: "VA",
    cityWithStateAbbr: "Bowling Green, VA",
  },
  {
    zip: "22428",
    ST: "VA",
    cityWithStateAbbr: "Bowling Green, VA",
  },
  {
    zip: "22430",
    ST: "VA",
    cityWithStateAbbr: "Brooke, VA",
  },
  {
    zip: "22432",
    ST: "VA",
    cityWithStateAbbr: "Burgess, VA",
  },
  {
    zip: "22433",
    ST: "VA",
    cityWithStateAbbr: "Burr Hill, VA",
  },
  {
    zip: "22435",
    ST: "VA",
    cityWithStateAbbr: "Callao, VA",
  },
  {
    zip: "22436",
    ST: "VA",
    cityWithStateAbbr: "Caret, VA",
  },
  {
    zip: "22437",
    ST: "VA",
    cityWithStateAbbr: "Center Cross, VA",
  },
  {
    zip: "22438",
    ST: "VA",
    cityWithStateAbbr: "Champlain, VA",
  },
  {
    zip: "22442",
    ST: "VA",
    cityWithStateAbbr: "Coles Point, VA",
  },
  {
    zip: "22443",
    ST: "VA",
    cityWithStateAbbr: "Colonial Beach, VA",
  },
  {
    zip: "22446",
    ST: "VA",
    cityWithStateAbbr: "Corbin, VA",
  },
  {
    zip: "22448",
    ST: "VA",
    cityWithStateAbbr: "Dahlgren, VA",
  },
  {
    zip: "22451",
    ST: "VA",
    cityWithStateAbbr: "Dogue, VA",
  },
  {
    zip: "22454",
    ST: "VA",
    cityWithStateAbbr: "Dunnsville, VA",
  },
  {
    zip: "22456",
    ST: "VA",
    cityWithStateAbbr: "Edwardsville, VA",
  },
  {
    zip: "22460",
    ST: "VA",
    cityWithStateAbbr: "Farnham, VA",
  },
  {
    zip: "22463",
    ST: "VA",
    cityWithStateAbbr: "Garrisonville, VA",
  },
  {
    zip: "22469",
    ST: "VA",
    cityWithStateAbbr: "Hague, VA",
  },
  {
    zip: "22471",
    ST: "VA",
    cityWithStateAbbr: "Hartwood, VA",
  },
  {
    zip: "22472",
    ST: "VA",
    cityWithStateAbbr: "Haynesville, VA",
  },
  {
    zip: "22473",
    ST: "VA",
    cityWithStateAbbr: "Heathsville, VA",
  },
  {
    zip: "22476",
    ST: "VA",
    cityWithStateAbbr: "Hustle, VA",
  },
  {
    zip: "22480",
    ST: "VA",
    cityWithStateAbbr: "Irvington, VA",
  },
  {
    zip: "22481",
    ST: "VA",
    cityWithStateAbbr: "Jersey, VA",
  },
  {
    zip: "22482",
    ST: "VA",
    cityWithStateAbbr: "Kilmarnock, VA",
  },
  {
    zip: "22485",
    ST: "VA",
    cityWithStateAbbr: "King George, VA",
  },
  {
    zip: "22488",
    ST: "VA",
    cityWithStateAbbr: "Kinsale, VA",
  },
  {
    zip: "22501",
    ST: "VA",
    cityWithStateAbbr: "Ladysmith, VA",
  },
  {
    zip: "22503",
    ST: "VA",
    cityWithStateAbbr: "Lancaster, VA",
  },
  {
    zip: "22504",
    ST: "VA",
    cityWithStateAbbr: "Laneview, VA",
  },
  {
    zip: "22507",
    ST: "VA",
    cityWithStateAbbr: "Lively, VA",
  },
  {
    zip: "22508",
    ST: "VA",
    cityWithStateAbbr: "Locust Grove, VA",
  },
  {
    zip: "22509",
    ST: "VA",
    cityWithStateAbbr: "Loretto, VA",
  },
  {
    zip: "22511",
    ST: "VA",
    cityWithStateAbbr: "Lottsburg, VA",
  },
  {
    zip: "22513",
    ST: "VA",
    cityWithStateAbbr: "Merry Point, VA",
  },
  {
    zip: "22514",
    ST: "VA",
    cityWithStateAbbr: "Milford, VA",
  },
  {
    zip: "22517",
    ST: "VA",
    cityWithStateAbbr: "Mollusk, VA",
  },
  {
    zip: "22520",
    ST: "VA",
    cityWithStateAbbr: "Montross, VA",
  },
  {
    zip: "22523",
    ST: "VA",
    cityWithStateAbbr: "Morattico, VA",
  },
  {
    zip: "22524",
    ST: "VA",
    cityWithStateAbbr: "Mount Holly, VA",
  },
  {
    zip: "22526",
    ST: "VA",
    cityWithStateAbbr: "Ninde, VA",
  },
  {
    zip: "22528",
    ST: "VA",
    cityWithStateAbbr: "Nuttsville, VA",
  },
  {
    zip: "22529",
    ST: "VA",
    cityWithStateAbbr: "Oldhams, VA",
  },
  {
    zip: "22530",
    ST: "VA",
    cityWithStateAbbr: "Ophelia, VA",
  },
  {
    zip: "22534",
    ST: "VA",
    cityWithStateAbbr: "Partlow, VA",
  },
  {
    zip: "22535",
    ST: "VA",
    cityWithStateAbbr: "Port Royal, VA",
  },
  {
    zip: "22538",
    ST: "VA",
    cityWithStateAbbr: "Rappahannock Academy, VA",
  },
  {
    zip: "22539",
    ST: "VA",
    cityWithStateAbbr: "Reedville, VA",
  },
  {
    zip: "22542",
    ST: "VA",
    cityWithStateAbbr: "Rhoadesville, VA",
  },
  {
    zip: "22544",
    ST: "VA",
    cityWithStateAbbr: "Rollins Fork, VA",
  },
  {
    zip: "22545",
    ST: "VA",
    cityWithStateAbbr: "Ruby, VA",
  },
  {
    zip: "22546",
    ST: "VA",
    cityWithStateAbbr: "Ruther Glen, VA",
  },
  {
    zip: "22547",
    ST: "VA",
    cityWithStateAbbr: "Sealston, VA",
  },
  {
    zip: "22548",
    ST: "VA",
    cityWithStateAbbr: "Sharps, VA",
  },
  {
    zip: "22551",
    ST: "VA",
    cityWithStateAbbr: "Spotsylvania, VA",
  },
  {
    zip: "22552",
    ST: "VA",
    cityWithStateAbbr: "Sparta, VA",
  },
  {
    zip: "22553",
    ST: "VA",
    cityWithStateAbbr: "Spotsylvania, VA",
  },
  {
    zip: "22554",
    ST: "VA",
    cityWithStateAbbr: "Stafford, VA",
  },
  {
    zip: "22555",
    ST: "VA",
    cityWithStateAbbr: "Stafford, VA",
  },
  {
    zip: "22556",
    ST: "VA",
    cityWithStateAbbr: "Stafford, VA",
  },
  {
    zip: "22558",
    ST: "VA",
    cityWithStateAbbr: "Stratford, VA",
  },
  {
    zip: "22560",
    ST: "VA",
    cityWithStateAbbr: "Tappahannock, VA",
  },
  {
    zip: "22565",
    ST: "VA",
    cityWithStateAbbr: "Thornburg, VA",
  },
  {
    zip: "22567",
    ST: "VA",
    cityWithStateAbbr: "Unionville, VA",
  },
  {
    zip: "22570",
    ST: "VA",
    cityWithStateAbbr: "Village, VA",
  },
  {
    zip: "22572",
    ST: "VA",
    cityWithStateAbbr: "Warsaw, VA",
  },
  {
    zip: "22576",
    ST: "VA",
    cityWithStateAbbr: "Weems, VA",
  },
  {
    zip: "22577",
    ST: "VA",
    cityWithStateAbbr: "Sandy Point, VA",
  },
  {
    zip: "22578",
    ST: "VA",
    cityWithStateAbbr: "White Stone, VA",
  },
  {
    zip: "22579",
    ST: "VA",
    cityWithStateAbbr: "Wicomico Church, VA",
  },
  {
    zip: "22580",
    ST: "VA",
    cityWithStateAbbr: "Woodford, VA",
  },
  {
    zip: "22581",
    ST: "VA",
    cityWithStateAbbr: "Zacata, VA",
  },
  {
    zip: "22601",
    ST: "VA",
    cityWithStateAbbr: "Winchester, VA",
  },
  {
    zip: "22602",
    ST: "VA",
    cityWithStateAbbr: "Winchester, VA",
  },
  {
    zip: "22603",
    ST: "VA",
    cityWithStateAbbr: "Winchester, VA",
  },
  {
    zip: "22604",
    ST: "VA",
    cityWithStateAbbr: "Winchester, VA",
  },
  {
    zip: "22610",
    ST: "VA",
    cityWithStateAbbr: "Bentonville, VA",
  },
  {
    zip: "22611",
    ST: "VA",
    cityWithStateAbbr: "Berryville, VA",
  },
  {
    zip: "22620",
    ST: "VA",
    cityWithStateAbbr: "Boyce, VA",
  },
  {
    zip: "22622",
    ST: "VA",
    cityWithStateAbbr: "Brucetown, VA",
  },
  {
    zip: "22623",
    ST: "VA",
    cityWithStateAbbr: "Chester Gap, VA",
  },
  {
    zip: "22624",
    ST: "VA",
    cityWithStateAbbr: "Clear Brook, VA",
  },
  {
    zip: "22625",
    ST: "VA",
    cityWithStateAbbr: "Cross Junction, VA",
  },
  {
    zip: "22626",
    ST: "VA",
    cityWithStateAbbr: "Fishers Hill, VA",
  },
  {
    zip: "22627",
    ST: "VA",
    cityWithStateAbbr: "Flint Hill, VA",
  },
  {
    zip: "22630",
    ST: "VA",
    cityWithStateAbbr: "Front Royal, VA",
  },
  {
    zip: "22637",
    ST: "VA",
    cityWithStateAbbr: "Gore, VA",
  },
  {
    zip: "22639",
    ST: "VA",
    cityWithStateAbbr: "Hume, VA",
  },
  {
    zip: "22640",
    ST: "VA",
    cityWithStateAbbr: "Huntly, VA",
  },
  {
    zip: "22641",
    ST: "VA",
    cityWithStateAbbr: "Strasburg, VA",
  },
  {
    zip: "22642",
    ST: "VA",
    cityWithStateAbbr: "Linden, VA",
  },
  {
    zip: "22643",
    ST: "VA",
    cityWithStateAbbr: "Markham, VA",
  },
  {
    zip: "22644",
    ST: "VA",
    cityWithStateAbbr: "Maurertown, VA",
  },
  {
    zip: "22645",
    ST: "VA",
    cityWithStateAbbr: "Middletown, VA",
  },
  {
    zip: "22646",
    ST: "VA",
    cityWithStateAbbr: "Millwood, VA",
  },
  {
    zip: "22649",
    ST: "VA",
    cityWithStateAbbr: "Middletown, VA",
  },
  {
    zip: "22650",
    ST: "VA",
    cityWithStateAbbr: "Rileyville, VA",
  },
  {
    zip: "22652",
    ST: "VA",
    cityWithStateAbbr: "Fort Valley, VA",
  },
  {
    zip: "22654",
    ST: "VA",
    cityWithStateAbbr: "Star Tannery, VA",
  },
  {
    zip: "22655",
    ST: "VA",
    cityWithStateAbbr: "Stephens City, VA",
  },
  {
    zip: "22656",
    ST: "VA",
    cityWithStateAbbr: "Stephenson, VA",
  },
  {
    zip: "22657",
    ST: "VA",
    cityWithStateAbbr: "Strasburg, VA",
  },
  {
    zip: "22660",
    ST: "VA",
    cityWithStateAbbr: "Toms Brook, VA",
  },
  {
    zip: "22663",
    ST: "VA",
    cityWithStateAbbr: "White Post, VA",
  },
  {
    zip: "22664",
    ST: "VA",
    cityWithStateAbbr: "Woodstock, VA",
  },
  {
    zip: "22701",
    ST: "VA",
    cityWithStateAbbr: "Culpeper, VA",
  },
  {
    zip: "22709",
    ST: "VA",
    cityWithStateAbbr: "Aroda, VA",
  },
  {
    zip: "22711",
    ST: "VA",
    cityWithStateAbbr: "Banco, VA",
  },
  {
    zip: "22712",
    ST: "VA",
    cityWithStateAbbr: "Bealeton, VA",
  },
  {
    zip: "22713",
    ST: "VA",
    cityWithStateAbbr: "Boston, VA",
  },
  {
    zip: "22714",
    ST: "VA",
    cityWithStateAbbr: "Brandy Station, VA",
  },
  {
    zip: "22715",
    ST: "VA",
    cityWithStateAbbr: "Brightwood, VA",
  },
  {
    zip: "22716",
    ST: "VA",
    cityWithStateAbbr: "Castleton, VA",
  },
  {
    zip: "22718",
    ST: "VA",
    cityWithStateAbbr: "Elkwood, VA",
  },
  {
    zip: "22719",
    ST: "VA",
    cityWithStateAbbr: "Etlan, VA",
  },
  {
    zip: "22720",
    ST: "VA",
    cityWithStateAbbr: "Goldvein, VA",
  },
  {
    zip: "22722",
    ST: "VA",
    cityWithStateAbbr: "Haywood, VA",
  },
  {
    zip: "22723",
    ST: "VA",
    cityWithStateAbbr: "Hood, VA",
  },
  {
    zip: "22724",
    ST: "VA",
    cityWithStateAbbr: "Jeffersonton, VA",
  },
  {
    zip: "22725",
    ST: "VA",
    cityWithStateAbbr: "Leon, VA",
  },
  {
    zip: "22726",
    ST: "VA",
    cityWithStateAbbr: "Lignum, VA",
  },
  {
    zip: "22727",
    ST: "VA",
    cityWithStateAbbr: "Madison, VA",
  },
  {
    zip: "22728",
    ST: "VA",
    cityWithStateAbbr: "Midland, VA",
  },
  {
    zip: "22729",
    ST: "VA",
    cityWithStateAbbr: "Mitchells, VA",
  },
  {
    zip: "22730",
    ST: "VA",
    cityWithStateAbbr: "Oakpark, VA",
  },
  {
    zip: "22731",
    ST: "VA",
    cityWithStateAbbr: "Pratts, VA",
  },
  {
    zip: "22732",
    ST: "VA",
    cityWithStateAbbr: "Radiant, VA",
  },
  {
    zip: "22733",
    ST: "VA",
    cityWithStateAbbr: "Rapidan, VA",
  },
  {
    zip: "22734",
    ST: "VA",
    cityWithStateAbbr: "Remington, VA",
  },
  {
    zip: "22735",
    ST: "VA",
    cityWithStateAbbr: "Reva, VA",
  },
  {
    zip: "22736",
    ST: "VA",
    cityWithStateAbbr: "Richardsville, VA",
  },
  {
    zip: "22737",
    ST: "VA",
    cityWithStateAbbr: "Rixeyville, VA",
  },
  {
    zip: "22738",
    ST: "VA",
    cityWithStateAbbr: "Rochelle, VA",
  },
  {
    zip: "22739",
    ST: "VA",
    cityWithStateAbbr: "Somerville, VA",
  },
  {
    zip: "22740",
    ST: "VA",
    cityWithStateAbbr: "Sperryville, VA",
  },
  {
    zip: "22741",
    ST: "VA",
    cityWithStateAbbr: "Stevensburg, VA",
  },
  {
    zip: "22742",
    ST: "VA",
    cityWithStateAbbr: "Sumerduck, VA",
  },
  {
    zip: "22743",
    ST: "VA",
    cityWithStateAbbr: "Syria, VA",
  },
  {
    zip: "22746",
    ST: "VA",
    cityWithStateAbbr: "Viewtown, VA",
  },
  {
    zip: "22747",
    ST: "VA",
    cityWithStateAbbr: "Washington, VA",
  },
  {
    zip: "22748",
    ST: "VA",
    cityWithStateAbbr: "Wolftown, VA",
  },
  {
    zip: "22749",
    ST: "VA",
    cityWithStateAbbr: "Woodville, VA",
  },
  {
    zip: "22801",
    ST: "VA",
    cityWithStateAbbr: "Harrisonburg, VA",
  },
  {
    zip: "22802",
    ST: "VA",
    cityWithStateAbbr: "Harrisonburg, VA",
  },
  {
    zip: "22803",
    ST: "VA",
    cityWithStateAbbr: "Harrisonburg, VA",
  },
  {
    zip: "22807",
    ST: "VA",
    cityWithStateAbbr: "Harrisonburg, VA",
  },
  {
    zip: "22810",
    ST: "VA",
    cityWithStateAbbr: "Basye, VA",
  },
  {
    zip: "22811",
    ST: "VA",
    cityWithStateAbbr: "Bergton, VA",
  },
  {
    zip: "22812",
    ST: "VA",
    cityWithStateAbbr: "Bridgewater, VA",
  },
  {
    zip: "22815",
    ST: "VA",
    cityWithStateAbbr: "Broadway, VA",
  },
  {
    zip: "22820",
    ST: "VA",
    cityWithStateAbbr: "Criders, VA",
  },
  {
    zip: "22821",
    ST: "VA",
    cityWithStateAbbr: "Dayton, VA",
  },
  {
    zip: "22824",
    ST: "VA",
    cityWithStateAbbr: "Edinburg, VA",
  },
  {
    zip: "22827",
    ST: "VA",
    cityWithStateAbbr: "Elkton, VA",
  },
  {
    zip: "22830",
    ST: "VA",
    cityWithStateAbbr: "Fulks Run, VA",
  },
  {
    zip: "22831",
    ST: "VA",
    cityWithStateAbbr: "Hinton, VA",
  },
  {
    zip: "22832",
    ST: "VA",
    cityWithStateAbbr: "Keezletown, VA",
  },
  {
    zip: "22833",
    ST: "VA",
    cityWithStateAbbr: "Lacey Spring, VA",
  },
  {
    zip: "22834",
    ST: "VA",
    cityWithStateAbbr: "Linville, VA",
  },
  {
    zip: "22835",
    ST: "VA",
    cityWithStateAbbr: "Luray, VA",
  },
  {
    zip: "22840",
    ST: "VA",
    cityWithStateAbbr: "Mc Gaheysville, VA",
  },
  {
    zip: "22841",
    ST: "VA",
    cityWithStateAbbr: "Mount Crawford, VA",
  },
  {
    zip: "22842",
    ST: "VA",
    cityWithStateAbbr: "Mount Jackson, VA",
  },
  {
    zip: "22843",
    ST: "VA",
    cityWithStateAbbr: "Mount Solon, VA",
  },
  {
    zip: "22844",
    ST: "VA",
    cityWithStateAbbr: "New Market, VA",
  },
  {
    zip: "22845",
    ST: "VA",
    cityWithStateAbbr: "Orkney Springs, VA",
  },
  {
    zip: "22846",
    ST: "VA",
    cityWithStateAbbr: "Penn Laird, VA",
  },
  {
    zip: "22847",
    ST: "VA",
    cityWithStateAbbr: "Quicksburg, VA",
  },
  {
    zip: "22848",
    ST: "VA",
    cityWithStateAbbr: "Pleasant Valley, VA",
  },
  {
    zip: "22849",
    ST: "VA",
    cityWithStateAbbr: "Shenandoah, VA",
  },
  {
    zip: "22850",
    ST: "VA",
    cityWithStateAbbr: "Singers Glen, VA",
  },
  {
    zip: "22851",
    ST: "VA",
    cityWithStateAbbr: "Stanley, VA",
  },
  {
    zip: "22853",
    ST: "VA",
    cityWithStateAbbr: "Timberville, VA",
  },
  {
    zip: "22901",
    ST: "VA",
    cityWithStateAbbr: "Charlottesville, VA",
  },
  {
    zip: "22902",
    ST: "VA",
    cityWithStateAbbr: "Charlottesville, VA",
  },
  {
    zip: "22903",
    ST: "VA",
    cityWithStateAbbr: "Charlottesville, VA",
  },
  {
    zip: "22904",
    ST: "VA",
    cityWithStateAbbr: "Charlottesville, VA",
  },
  {
    zip: "22905",
    ST: "VA",
    cityWithStateAbbr: "Charlottesville, VA",
  },
  {
    zip: "22906",
    ST: "VA",
    cityWithStateAbbr: "Charlottesville, VA",
  },
  {
    zip: "22907",
    ST: "VA",
    cityWithStateAbbr: "Charlottesville, VA",
  },
  {
    zip: "22908",
    ST: "VA",
    cityWithStateAbbr: "Charlottesville, VA",
  },
  {
    zip: "22909",
    ST: "VA",
    cityWithStateAbbr: "Charlottesville, VA",
  },
  {
    zip: "22910",
    ST: "VA",
    cityWithStateAbbr: "Charlottesville, VA",
  },
  {
    zip: "22911",
    ST: "VA",
    cityWithStateAbbr: "Charlottesville, VA",
  },
  {
    zip: "22920",
    ST: "VA",
    cityWithStateAbbr: "Afton, VA",
  },
  {
    zip: "22922",
    ST: "VA",
    cityWithStateAbbr: "Arrington, VA",
  },
  {
    zip: "22923",
    ST: "VA",
    cityWithStateAbbr: "Barboursville, VA",
  },
  {
    zip: "22924",
    ST: "VA",
    cityWithStateAbbr: "Batesville, VA",
  },
  {
    zip: "22931",
    ST: "VA",
    cityWithStateAbbr: "Covesville, VA",
  },
  {
    zip: "22932",
    ST: "VA",
    cityWithStateAbbr: "Crozet, VA",
  },
  {
    zip: "22935",
    ST: "VA",
    cityWithStateAbbr: "Dyke, VA",
  },
  {
    zip: "22936",
    ST: "VA",
    cityWithStateAbbr: "Earlysville, VA",
  },
  {
    zip: "22937",
    ST: "VA",
    cityWithStateAbbr: "Esmont, VA",
  },
  {
    zip: "22938",
    ST: "VA",
    cityWithStateAbbr: "Faber, VA",
  },
  {
    zip: "22939",
    ST: "VA",
    cityWithStateAbbr: "Fishersville, VA",
  },
  {
    zip: "22940",
    ST: "VA",
    cityWithStateAbbr: "Free Union, VA",
  },
  {
    zip: "22942",
    ST: "VA",
    cityWithStateAbbr: "Gordonsville, VA",
  },
  {
    zip: "22943",
    ST: "VA",
    cityWithStateAbbr: "Greenwood, VA",
  },
  {
    zip: "22945",
    ST: "VA",
    cityWithStateAbbr: "Ivy, VA",
  },
  {
    zip: "22946",
    ST: "VA",
    cityWithStateAbbr: "Keene, VA",
  },
  {
    zip: "22947",
    ST: "VA",
    cityWithStateAbbr: "Keswick, VA",
  },
  {
    zip: "22948",
    ST: "VA",
    cityWithStateAbbr: "Locust Dale, VA",
  },
  {
    zip: "22949",
    ST: "VA",
    cityWithStateAbbr: "Lovingston, VA",
  },
  {
    zip: "22952",
    ST: "VA",
    cityWithStateAbbr: "Lyndhurst, VA",
  },
  {
    zip: "22957",
    ST: "VA",
    cityWithStateAbbr: "Montpelier Station, VA",
  },
  {
    zip: "22958",
    ST: "VA",
    cityWithStateAbbr: "Nellysford, VA",
  },
  {
    zip: "22959",
    ST: "VA",
    cityWithStateAbbr: "North Garden, VA",
  },
  {
    zip: "22960",
    ST: "VA",
    cityWithStateAbbr: "Orange, VA",
  },
  {
    zip: "22963",
    ST: "VA",
    cityWithStateAbbr: "Palmyra, VA",
  },
  {
    zip: "22964",
    ST: "VA",
    cityWithStateAbbr: "Piney River, VA",
  },
  {
    zip: "22965",
    ST: "VA",
    cityWithStateAbbr: "Quinque, VA",
  },
  {
    zip: "22967",
    ST: "VA",
    cityWithStateAbbr: "Roseland, VA",
  },
  {
    zip: "22968",
    ST: "VA",
    cityWithStateAbbr: "Ruckersville, VA",
  },
  {
    zip: "22969",
    ST: "VA",
    cityWithStateAbbr: "Schuyler, VA",
  },
  {
    zip: "22971",
    ST: "VA",
    cityWithStateAbbr: "Shipman, VA",
  },
  {
    zip: "22972",
    ST: "VA",
    cityWithStateAbbr: "Somerset, VA",
  },
  {
    zip: "22973",
    ST: "VA",
    cityWithStateAbbr: "Stanardsville, VA",
  },
  {
    zip: "22974",
    ST: "VA",
    cityWithStateAbbr: "Troy, VA",
  },
  {
    zip: "22976",
    ST: "VA",
    cityWithStateAbbr: "Tyro, VA",
  },
  {
    zip: "22980",
    ST: "VA",
    cityWithStateAbbr: "Waynesboro, VA",
  },
  {
    zip: "22987",
    ST: "VA",
    cityWithStateAbbr: "White Hall, VA",
  },
  {
    zip: "22989",
    ST: "VA",
    cityWithStateAbbr: "Woodberry Forest, VA",
  },
  {
    zip: "23001",
    ST: "VA",
    cityWithStateAbbr: "Achilles, VA",
  },
  {
    zip: "23002",
    ST: "VA",
    cityWithStateAbbr: "Amelia Court House, VA",
  },
  {
    zip: "23003",
    ST: "VA",
    cityWithStateAbbr: "Ark, VA",
  },
  {
    zip: "23004",
    ST: "VA",
    cityWithStateAbbr: "Arvonia, VA",
  },
  {
    zip: "23005",
    ST: "VA",
    cityWithStateAbbr: "Ashland, VA",
  },
  {
    zip: "23009",
    ST: "VA",
    cityWithStateAbbr: "Aylett, VA",
  },
  {
    zip: "23011",
    ST: "VA",
    cityWithStateAbbr: "Barhamsville, VA",
  },
  {
    zip: "23014",
    ST: "VA",
    cityWithStateAbbr: "Beaumont, VA",
  },
  {
    zip: "23015",
    ST: "VA",
    cityWithStateAbbr: "Beaverdam, VA",
  },
  {
    zip: "23018",
    ST: "VA",
    cityWithStateAbbr: "Bena, VA",
  },
  {
    zip: "23021",
    ST: "VA",
    cityWithStateAbbr: "Bohannon, VA",
  },
  {
    zip: "23022",
    ST: "VA",
    cityWithStateAbbr: "Bremo Bluff, VA",
  },
  {
    zip: "23023",
    ST: "VA",
    cityWithStateAbbr: "Bruington, VA",
  },
  {
    zip: "23024",
    ST: "VA",
    cityWithStateAbbr: "Bumpass, VA",
  },
  {
    zip: "23025",
    ST: "VA",
    cityWithStateAbbr: "Cardinal, VA",
  },
  {
    zip: "23027",
    ST: "VA",
    cityWithStateAbbr: "Cartersville, VA",
  },
  {
    zip: "23030",
    ST: "VA",
    cityWithStateAbbr: "Charles City, VA",
  },
  {
    zip: "23031",
    ST: "VA",
    cityWithStateAbbr: "Christchurch, VA",
  },
  {
    zip: "23032",
    ST: "VA",
    cityWithStateAbbr: "Church View, VA",
  },
  {
    zip: "23035",
    ST: "VA",
    cityWithStateAbbr: "Cobbs Creek, VA",
  },
  {
    zip: "23038",
    ST: "VA",
    cityWithStateAbbr: "Columbia, VA",
  },
  {
    zip: "23039",
    ST: "VA",
    cityWithStateAbbr: "Crozier, VA",
  },
  {
    zip: "23040",
    ST: "VA",
    cityWithStateAbbr: "Cumberland, VA",
  },
  {
    zip: "23043",
    ST: "VA",
    cityWithStateAbbr: "Deltaville, VA",
  },
  {
    zip: "23045",
    ST: "VA",
    cityWithStateAbbr: "Diggs, VA",
  },
  {
    zip: "23047",
    ST: "VA",
    cityWithStateAbbr: "Doswell, VA",
  },
  {
    zip: "23050",
    ST: "VA",
    cityWithStateAbbr: "Dutton, VA",
  },
  {
    zip: "23055",
    ST: "VA",
    cityWithStateAbbr: "Fork Union, VA",
  },
  {
    zip: "23056",
    ST: "VA",
    cityWithStateAbbr: "Foster, VA",
  },
  {
    zip: "23058",
    ST: "VA",
    cityWithStateAbbr: "Glen Allen, VA",
  },
  {
    zip: "23059",
    ST: "VA",
    cityWithStateAbbr: "Glen Allen, VA",
  },
  {
    zip: "23060",
    ST: "VA",
    cityWithStateAbbr: "Glen Allen, VA",
  },
  {
    zip: "23061",
    ST: "VA",
    cityWithStateAbbr: "Gloucester, VA",
  },
  {
    zip: "23062",
    ST: "VA",
    cityWithStateAbbr: "Gloucester Point, VA",
  },
  {
    zip: "23063",
    ST: "VA",
    cityWithStateAbbr: "Goochland, VA",
  },
  {
    zip: "23064",
    ST: "VA",
    cityWithStateAbbr: "Grimstead, VA",
  },
  {
    zip: "23065",
    ST: "VA",
    cityWithStateAbbr: "Gum Spring, VA",
  },
  {
    zip: "23066",
    ST: "VA",
    cityWithStateAbbr: "Gwynn, VA",
  },
  {
    zip: "23067",
    ST: "VA",
    cityWithStateAbbr: "Hadensville, VA",
  },
  {
    zip: "23068",
    ST: "VA",
    cityWithStateAbbr: "Hallieford, VA",
  },
  {
    zip: "23069",
    ST: "VA",
    cityWithStateAbbr: "Hanover, VA",
  },
  {
    zip: "23070",
    ST: "VA",
    cityWithStateAbbr: "Hardyville, VA",
  },
  {
    zip: "23071",
    ST: "VA",
    cityWithStateAbbr: "Hartfield, VA",
  },
  {
    zip: "23072",
    ST: "VA",
    cityWithStateAbbr: "Hayes, VA",
  },
  {
    zip: "23075",
    ST: "VA",
    cityWithStateAbbr: "Henrico, VA",
  },
  {
    zip: "23076",
    ST: "VA",
    cityWithStateAbbr: "Hudgins, VA",
  },
  {
    zip: "23079",
    ST: "VA",
    cityWithStateAbbr: "Jamaica, VA",
  },
  {
    zip: "23081",
    ST: "VA",
    cityWithStateAbbr: "Jamestown, VA",
  },
  {
    zip: "23083",
    ST: "VA",
    cityWithStateAbbr: "Jetersville, VA",
  },
  {
    zip: "23084",
    ST: "VA",
    cityWithStateAbbr: "Kents Store, VA",
  },
  {
    zip: "23085",
    ST: "VA",
    cityWithStateAbbr: "King And Queen Court Hou, VA",
  },
  {
    zip: "23086",
    ST: "VA",
    cityWithStateAbbr: "King William, VA",
  },
  {
    zip: "23089",
    ST: "VA",
    cityWithStateAbbr: "Lanexa, VA",
  },
  {
    zip: "23090",
    ST: "VA",
    cityWithStateAbbr: "Lightfoot, VA",
  },
  {
    zip: "23091",
    ST: "VA",
    cityWithStateAbbr: "Little Plymouth, VA",
  },
  {
    zip: "23092",
    ST: "VA",
    cityWithStateAbbr: "Locust Hill, VA",
  },
  {
    zip: "23093",
    ST: "VA",
    cityWithStateAbbr: "Louisa, VA",
  },
  {
    zip: "23102",
    ST: "VA",
    cityWithStateAbbr: "Maidens, VA",
  },
  {
    zip: "23103",
    ST: "VA",
    cityWithStateAbbr: "Manakin Sabot, VA",
  },
  {
    zip: "23105",
    ST: "VA",
    cityWithStateAbbr: "Mannboro, VA",
  },
  {
    zip: "23106",
    ST: "VA",
    cityWithStateAbbr: "Manquin, VA",
  },
  {
    zip: "23107",
    ST: "VA",
    cityWithStateAbbr: "Maryus, VA",
  },
  {
    zip: "23108",
    ST: "VA",
    cityWithStateAbbr: "Mascot, VA",
  },
  {
    zip: "23109",
    ST: "VA",
    cityWithStateAbbr: "Mathews, VA",
  },
  {
    zip: "23110",
    ST: "VA",
    cityWithStateAbbr: "Mattaponi, VA",
  },
  {
    zip: "23111",
    ST: "VA",
    cityWithStateAbbr: "Mechanicsville, VA",
  },
  {
    zip: "23112",
    ST: "VA",
    cityWithStateAbbr: "Midlothian, VA",
  },
  {
    zip: "23113",
    ST: "VA",
    cityWithStateAbbr: "Midlothian, VA",
  },
  {
    zip: "23114",
    ST: "VA",
    cityWithStateAbbr: "Midlothian, VA",
  },
  {
    zip: "23115",
    ST: "VA",
    cityWithStateAbbr: "Millers Tavern, VA",
  },
  {
    zip: "23116",
    ST: "VA",
    cityWithStateAbbr: "Mechanicsville, VA",
  },
  {
    zip: "23117",
    ST: "VA",
    cityWithStateAbbr: "Mineral, VA",
  },
  {
    zip: "23119",
    ST: "VA",
    cityWithStateAbbr: "Moon, VA",
  },
  {
    zip: "23120",
    ST: "VA",
    cityWithStateAbbr: "Moseley, VA",
  },
  {
    zip: "23123",
    ST: "VA",
    cityWithStateAbbr: "New Canton, VA",
  },
  {
    zip: "23124",
    ST: "VA",
    cityWithStateAbbr: "New Kent, VA",
  },
  {
    zip: "23125",
    ST: "VA",
    cityWithStateAbbr: "New Point, VA",
  },
  {
    zip: "23126",
    ST: "VA",
    cityWithStateAbbr: "Newtown, VA",
  },
  {
    zip: "23127",
    ST: "VA",
    cityWithStateAbbr: "Norge, VA",
  },
  {
    zip: "23128",
    ST: "VA",
    cityWithStateAbbr: "North, VA",
  },
  {
    zip: "23129",
    ST: "VA",
    cityWithStateAbbr: "Oilville, VA",
  },
  {
    zip: "23130",
    ST: "VA",
    cityWithStateAbbr: "Onemo, VA",
  },
  {
    zip: "23131",
    ST: "VA",
    cityWithStateAbbr: "Ordinary, VA",
  },
  {
    zip: "23138",
    ST: "VA",
    cityWithStateAbbr: "Port Haywood, VA",
  },
  {
    zip: "23139",
    ST: "VA",
    cityWithStateAbbr: "Powhatan, VA",
  },
  {
    zip: "23140",
    ST: "VA",
    cityWithStateAbbr: "Providence Forge, VA",
  },
  {
    zip: "23141",
    ST: "VA",
    cityWithStateAbbr: "Quinton, VA",
  },
  {
    zip: "23146",
    ST: "VA",
    cityWithStateAbbr: "Rockville, VA",
  },
  {
    zip: "23147",
    ST: "VA",
    cityWithStateAbbr: "Ruthville, VA",
  },
  {
    zip: "23148",
    ST: "VA",
    cityWithStateAbbr: "Saint Stephens Church, VA",
  },
  {
    zip: "23149",
    ST: "VA",
    cityWithStateAbbr: "Saluda, VA",
  },
  {
    zip: "23150",
    ST: "VA",
    cityWithStateAbbr: "Sandston, VA",
  },
  {
    zip: "23153",
    ST: "VA",
    cityWithStateAbbr: "Sandy Hook, VA",
  },
  {
    zip: "23154",
    ST: "VA",
    cityWithStateAbbr: "Schley, VA",
  },
  {
    zip: "23155",
    ST: "VA",
    cityWithStateAbbr: "Severn, VA",
  },
  {
    zip: "23156",
    ST: "VA",
    cityWithStateAbbr: "Shacklefords, VA",
  },
  {
    zip: "23160",
    ST: "VA",
    cityWithStateAbbr: "State Farm, VA",
  },
  {
    zip: "23161",
    ST: "VA",
    cityWithStateAbbr: "Stevensville, VA",
  },
  {
    zip: "23162",
    ST: "VA",
    cityWithStateAbbr: "Studley, VA",
  },
  {
    zip: "23163",
    ST: "VA",
    cityWithStateAbbr: "Susan, VA",
  },
  {
    zip: "23168",
    ST: "VA",
    cityWithStateAbbr: "Toano, VA",
  },
  {
    zip: "23169",
    ST: "VA",
    cityWithStateAbbr: "Topping, VA",
  },
  {
    zip: "23170",
    ST: "VA",
    cityWithStateAbbr: "Trevilians, VA",
  },
  {
    zip: "23173",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23175",
    ST: "VA",
    cityWithStateAbbr: "Urbanna, VA",
  },
  {
    zip: "23176",
    ST: "VA",
    cityWithStateAbbr: "Wake, VA",
  },
  {
    zip: "23177",
    ST: "VA",
    cityWithStateAbbr: "Walkerton, VA",
  },
  {
    zip: "23178",
    ST: "VA",
    cityWithStateAbbr: "Ware Neck, VA",
  },
  {
    zip: "23180",
    ST: "VA",
    cityWithStateAbbr: "Water View, VA",
  },
  {
    zip: "23181",
    ST: "VA",
    cityWithStateAbbr: "West Point, VA",
  },
  {
    zip: "23183",
    ST: "VA",
    cityWithStateAbbr: "White Marsh, VA",
  },
  {
    zip: "23184",
    ST: "VA",
    cityWithStateAbbr: "Wicomico, VA",
  },
  {
    zip: "23185",
    ST: "VA",
    cityWithStateAbbr: "Williamsburg, VA",
  },
  {
    zip: "23186",
    ST: "VA",
    cityWithStateAbbr: "Williamsburg, VA",
  },
  {
    zip: "23187",
    ST: "VA",
    cityWithStateAbbr: "Williamsburg, VA",
  },
  {
    zip: "23188",
    ST: "VA",
    cityWithStateAbbr: "Williamsburg, VA",
  },
  {
    zip: "23190",
    ST: "VA",
    cityWithStateAbbr: "Woods Cross Roads, VA",
  },
  {
    zip: "23192",
    ST: "VA",
    cityWithStateAbbr: "Montpelier, VA",
  },
  {
    zip: "23218",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23219",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23220",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23221",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23222",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23223",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23224",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23225",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23226",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23227",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23228",
    ST: "VA",
    cityWithStateAbbr: "Henrico, VA",
  },
  {
    zip: "23229",
    ST: "VA",
    cityWithStateAbbr: "Henrico, VA",
  },
  {
    zip: "23230",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23231",
    ST: "VA",
    cityWithStateAbbr: "Henrico, VA",
  },
  {
    zip: "23232",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23233",
    ST: "VA",
    cityWithStateAbbr: "Henrico, VA",
  },
  {
    zip: "23234",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23235",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23236",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23237",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23238",
    ST: "VA",
    cityWithStateAbbr: "Henrico, VA",
  },
  {
    zip: "23241",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23242",
    ST: "VA",
    cityWithStateAbbr: "Henrico, VA",
  },
  {
    zip: "23249",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23250",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23255",
    ST: "VA",
    cityWithStateAbbr: "Henrico, VA",
  },
  {
    zip: "23260",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23261",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23269",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23273",
    ST: "VA",
    cityWithStateAbbr: "Henrico, VA",
  },
  {
    zip: "23274",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23276",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23278",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23279",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23282",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23284",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23285",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23286",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23288",
    ST: "VA",
    cityWithStateAbbr: "Henrico, VA",
  },
  {
    zip: "23289",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23290",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23291",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23292",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23293",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23294",
    ST: "VA",
    cityWithStateAbbr: "Henrico, VA",
  },
  {
    zip: "23295",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23297",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23298",
    ST: "VA",
    cityWithStateAbbr: "Richmond, VA",
  },
  {
    zip: "23301",
    ST: "VA",
    cityWithStateAbbr: "Accomac, VA",
  },
  {
    zip: "23302",
    ST: "VA",
    cityWithStateAbbr: "Assawoman, VA",
  },
  {
    zip: "23303",
    ST: "VA",
    cityWithStateAbbr: "Atlantic, VA",
  },
  {
    zip: "23304",
    ST: "VA",
    cityWithStateAbbr: "Battery Park, VA",
  },
  {
    zip: "23306",
    ST: "VA",
    cityWithStateAbbr: "Belle Haven, VA",
  },
  {
    zip: "23307",
    ST: "VA",
    cityWithStateAbbr: "Birdsnest, VA",
  },
  {
    zip: "23308",
    ST: "VA",
    cityWithStateAbbr: "Bloxom, VA",
  },
  {
    zip: "23310",
    ST: "VA",
    cityWithStateAbbr: "Cape Charles, VA",
  },
  {
    zip: "23313",
    ST: "VA",
    cityWithStateAbbr: "Capeville, VA",
  },
  {
    zip: "23314",
    ST: "VA",
    cityWithStateAbbr: "Carrollton, VA",
  },
  {
    zip: "23315",
    ST: "VA",
    cityWithStateAbbr: "Carrsville, VA",
  },
  {
    zip: "23316",
    ST: "VA",
    cityWithStateAbbr: "Cheriton, VA",
  },
  {
    zip: "23320",
    ST: "VA",
    cityWithStateAbbr: "Chesapeake, VA",
  },
  {
    zip: "23321",
    ST: "VA",
    cityWithStateAbbr: "Chesapeake, VA",
  },
  {
    zip: "23322",
    ST: "VA",
    cityWithStateAbbr: "Chesapeake, VA",
  },
  {
    zip: "23323",
    ST: "VA",
    cityWithStateAbbr: "Chesapeake, VA",
  },
  {
    zip: "23324",
    ST: "VA",
    cityWithStateAbbr: "Chesapeake, VA",
  },
  {
    zip: "23325",
    ST: "VA",
    cityWithStateAbbr: "Chesapeake, VA",
  },
  {
    zip: "23326",
    ST: "VA",
    cityWithStateAbbr: "Chesapeake, VA",
  },
  {
    zip: "23327",
    ST: "VA",
    cityWithStateAbbr: "Chesapeake, VA",
  },
  {
    zip: "23328",
    ST: "VA",
    cityWithStateAbbr: "Chesapeake, VA",
  },
  {
    zip: "23336",
    ST: "VA",
    cityWithStateAbbr: "Chincoteague Island, VA",
  },
  {
    zip: "23337",
    ST: "VA",
    cityWithStateAbbr: "Wallops Island, VA",
  },
  {
    zip: "23341",
    ST: "VA",
    cityWithStateAbbr: "Craddockville, VA",
  },
  {
    zip: "23345",
    ST: "VA",
    cityWithStateAbbr: "Davis Wharf, VA",
  },
  {
    zip: "23347",
    ST: "VA",
    cityWithStateAbbr: "Eastville, VA",
  },
  {
    zip: "23350",
    ST: "VA",
    cityWithStateAbbr: "Exmore, VA",
  },
  {
    zip: "23354",
    ST: "VA",
    cityWithStateAbbr: "Franktown, VA",
  },
  {
    zip: "23356",
    ST: "VA",
    cityWithStateAbbr: "Greenbackville, VA",
  },
  {
    zip: "23357",
    ST: "VA",
    cityWithStateAbbr: "Greenbush, VA",
  },
  {
    zip: "23358",
    ST: "VA",
    cityWithStateAbbr: "Hacksneck, VA",
  },
  {
    zip: "23359",
    ST: "VA",
    cityWithStateAbbr: "Hallwood, VA",
  },
  {
    zip: "23389",
    ST: "VA",
    cityWithStateAbbr: "Harborton, VA",
  },
  {
    zip: "23395",
    ST: "VA",
    cityWithStateAbbr: "Horntown, VA",
  },
  {
    zip: "23396",
    ST: "VA",
    cityWithStateAbbr: "Oak Hall, VA",
  },
  {
    zip: "23397",
    ST: "VA",
    cityWithStateAbbr: "Isle Of Wight, VA",
  },
  {
    zip: "23398",
    ST: "VA",
    cityWithStateAbbr: "Jamesville, VA",
  },
  {
    zip: "23399",
    ST: "VA",
    cityWithStateAbbr: "Jenkins Bridge, VA",
  },
  {
    zip: "23401",
    ST: "VA",
    cityWithStateAbbr: "Keller, VA",
  },
  {
    zip: "23404",
    ST: "VA",
    cityWithStateAbbr: "Locustville, VA",
  },
  {
    zip: "23405",
    ST: "VA",
    cityWithStateAbbr: "Machipongo, VA",
  },
  {
    zip: "23407",
    ST: "VA",
    cityWithStateAbbr: "Mappsville, VA",
  },
  {
    zip: "23408",
    ST: "VA",
    cityWithStateAbbr: "Marionville, VA",
  },
  {
    zip: "23409",
    ST: "VA",
    cityWithStateAbbr: "Mears, VA",
  },
  {
    zip: "23410",
    ST: "VA",
    cityWithStateAbbr: "Melfa, VA",
  },
  {
    zip: "23412",
    ST: "VA",
    cityWithStateAbbr: "Modest Town, VA",
  },
  {
    zip: "23413",
    ST: "VA",
    cityWithStateAbbr: "Nassawadox, VA",
  },
  {
    zip: "23414",
    ST: "VA",
    cityWithStateAbbr: "Nelsonia, VA",
  },
  {
    zip: "23415",
    ST: "VA",
    cityWithStateAbbr: "New Church, VA",
  },
  {
    zip: "23416",
    ST: "VA",
    cityWithStateAbbr: "Oak Hall, VA",
  },
  {
    zip: "23417",
    ST: "VA",
    cityWithStateAbbr: "Onancock, VA",
  },
  {
    zip: "23418",
    ST: "VA",
    cityWithStateAbbr: "Onley, VA",
  },
  {
    zip: "23419",
    ST: "VA",
    cityWithStateAbbr: "Oyster, VA",
  },
  {
    zip: "23420",
    ST: "VA",
    cityWithStateAbbr: "Painter, VA",
  },
  {
    zip: "23421",
    ST: "VA",
    cityWithStateAbbr: "Parksley, VA",
  },
  {
    zip: "23422",
    ST: "VA",
    cityWithStateAbbr: "Pungoteague, VA",
  },
  {
    zip: "23423",
    ST: "VA",
    cityWithStateAbbr: "Quinby, VA",
  },
  {
    zip: "23424",
    ST: "VA",
    cityWithStateAbbr: "Rescue, VA",
  },
  {
    zip: "23426",
    ST: "VA",
    cityWithStateAbbr: "Sanford, VA",
  },
  {
    zip: "23427",
    ST: "VA",
    cityWithStateAbbr: "Saxis, VA",
  },
  {
    zip: "23429",
    ST: "VA",
    cityWithStateAbbr: "Seaview, VA",
  },
  {
    zip: "23430",
    ST: "VA",
    cityWithStateAbbr: "Smithfield, VA",
  },
  {
    zip: "23431",
    ST: "VA",
    cityWithStateAbbr: "Smithfield, VA",
  },
  {
    zip: "23432",
    ST: "VA",
    cityWithStateAbbr: "Suffolk, VA",
  },
  {
    zip: "23433",
    ST: "VA",
    cityWithStateAbbr: "Suffolk, VA",
  },
  {
    zip: "23434",
    ST: "VA",
    cityWithStateAbbr: "Suffolk, VA",
  },
  {
    zip: "23435",
    ST: "VA",
    cityWithStateAbbr: "Suffolk, VA",
  },
  {
    zip: "23436",
    ST: "VA",
    cityWithStateAbbr: "Suffolk, VA",
  },
  {
    zip: "23437",
    ST: "VA",
    cityWithStateAbbr: "Suffolk, VA",
  },
  {
    zip: "23438",
    ST: "VA",
    cityWithStateAbbr: "Suffolk, VA",
  },
  {
    zip: "23439",
    ST: "VA",
    cityWithStateAbbr: "Suffolk, VA",
  },
  {
    zip: "23440",
    ST: "VA",
    cityWithStateAbbr: "Tangier, VA",
  },
  {
    zip: "23441",
    ST: "VA",
    cityWithStateAbbr: "Tasley, VA",
  },
  {
    zip: "23442",
    ST: "VA",
    cityWithStateAbbr: "Temperanceville, VA",
  },
  {
    zip: "23443",
    ST: "VA",
    cityWithStateAbbr: "Townsend, VA",
  },
  {
    zip: "23450",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23451",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23452",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23453",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23454",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23455",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23456",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23457",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23458",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23459",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23460",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23461",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23462",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23463",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23464",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23465",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23466",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23467",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23471",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23479",
    ST: "VA",
    cityWithStateAbbr: "Virginia Beach, VA",
  },
  {
    zip: "23480",
    ST: "VA",
    cityWithStateAbbr: "Wachapreague, VA",
  },
  {
    zip: "23482",
    ST: "VA",
    cityWithStateAbbr: "Wardtown, VA",
  },
  {
    zip: "23483",
    ST: "VA",
    cityWithStateAbbr: "Wattsville, VA",
  },
  {
    zip: "23486",
    ST: "VA",
    cityWithStateAbbr: "Willis Wharf, VA",
  },
  {
    zip: "23487",
    ST: "VA",
    cityWithStateAbbr: "Windsor, VA",
  },
  {
    zip: "23488",
    ST: "VA",
    cityWithStateAbbr: "Withams, VA",
  },
  {
    zip: "23501",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23502",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23503",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23504",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23505",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23506",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23507",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23508",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23509",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23510",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23511",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23512",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23513",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23514",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23515",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23517",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23518",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23519",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23520",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23521",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23523",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23529",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23541",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23551",
    ST: "VA",
    cityWithStateAbbr: "Norfolk, VA",
  },
  {
    zip: "23601",
    ST: "VA",
    cityWithStateAbbr: "Newport News, VA",
  },
  {
    zip: "23602",
    ST: "VA",
    cityWithStateAbbr: "Newport News, VA",
  },
  {
    zip: "23603",
    ST: "VA",
    cityWithStateAbbr: "Newport News, VA",
  },
  {
    zip: "23604",
    ST: "VA",
    cityWithStateAbbr: "Fort Eustis, VA",
  },
  {
    zip: "23605",
    ST: "VA",
    cityWithStateAbbr: "Newport News, VA",
  },
  {
    zip: "23606",
    ST: "VA",
    cityWithStateAbbr: "Newport News, VA",
  },
  {
    zip: "23607",
    ST: "VA",
    cityWithStateAbbr: "Newport News, VA",
  },
  {
    zip: "23608",
    ST: "VA",
    cityWithStateAbbr: "Newport News, VA",
  },
  {
    zip: "23609",
    ST: "VA",
    cityWithStateAbbr: "Newport News, VA",
  },
  {
    zip: "23612",
    ST: "VA",
    cityWithStateAbbr: "Newport News, VA",
  },
  {
    zip: "23628",
    ST: "VA",
    cityWithStateAbbr: "Newport News, VA",
  },
  {
    zip: "23630",
    ST: "VA",
    cityWithStateAbbr: "Hampton, VA",
  },
  {
    zip: "23651",
    ST: "VA",
    cityWithStateAbbr: "Fort Monroe, VA",
  },
  {
    zip: "23661",
    ST: "VA",
    cityWithStateAbbr: "Hampton, VA",
  },
  {
    zip: "23662",
    ST: "VA",
    cityWithStateAbbr: "Poquoson, VA",
  },
  {
    zip: "23663",
    ST: "VA",
    cityWithStateAbbr: "Hampton, VA",
  },
  {
    zip: "23664",
    ST: "VA",
    cityWithStateAbbr: "Hampton, VA",
  },
  {
    zip: "23665",
    ST: "VA",
    cityWithStateAbbr: "Hampton, VA",
  },
  {
    zip: "23666",
    ST: "VA",
    cityWithStateAbbr: "Hampton, VA",
  },
  {
    zip: "23667",
    ST: "VA",
    cityWithStateAbbr: "Hampton, VA",
  },
  {
    zip: "23668",
    ST: "VA",
    cityWithStateAbbr: "Hampton, VA",
  },
  {
    zip: "23669",
    ST: "VA",
    cityWithStateAbbr: "Hampton, VA",
  },
  {
    zip: "23670",
    ST: "VA",
    cityWithStateAbbr: "Hampton, VA",
  },
  {
    zip: "23681",
    ST: "VA",
    cityWithStateAbbr: "Hampton, VA",
  },
  {
    zip: "23690",
    ST: "VA",
    cityWithStateAbbr: "Yorktown, VA",
  },
  {
    zip: "23691",
    ST: "VA",
    cityWithStateAbbr: "Yorktown, VA",
  },
  {
    zip: "23692",
    ST: "VA",
    cityWithStateAbbr: "Yorktown, VA",
  },
  {
    zip: "23693",
    ST: "VA",
    cityWithStateAbbr: "Yorktown, VA",
  },
  {
    zip: "23694",
    ST: "VA",
    cityWithStateAbbr: "Lackey, VA",
  },
  {
    zip: "23696",
    ST: "VA",
    cityWithStateAbbr: "Seaford, VA",
  },
  {
    zip: "23701",
    ST: "VA",
    cityWithStateAbbr: "Portsmouth, VA",
  },
  {
    zip: "23702",
    ST: "VA",
    cityWithStateAbbr: "Portsmouth, VA",
  },
  {
    zip: "23703",
    ST: "VA",
    cityWithStateAbbr: "Portsmouth, VA",
  },
  {
    zip: "23704",
    ST: "VA",
    cityWithStateAbbr: "Portsmouth, VA",
  },
  {
    zip: "23705",
    ST: "VA",
    cityWithStateAbbr: "Portsmouth, VA",
  },
  {
    zip: "23707",
    ST: "VA",
    cityWithStateAbbr: "Portsmouth, VA",
  },
  {
    zip: "23708",
    ST: "VA",
    cityWithStateAbbr: "Portsmouth, VA",
  },
  {
    zip: "23709",
    ST: "VA",
    cityWithStateAbbr: "Portsmouth, VA",
  },
  {
    zip: "23801",
    ST: "VA",
    cityWithStateAbbr: "Fort Lee, VA",
  },
  {
    zip: "23803",
    ST: "VA",
    cityWithStateAbbr: "Petersburg, VA",
  },
  {
    zip: "23804",
    ST: "VA",
    cityWithStateAbbr: "Petersburg, VA",
  },
  {
    zip: "23805",
    ST: "VA",
    cityWithStateAbbr: "Petersburg, VA",
  },
  {
    zip: "23806",
    ST: "VA",
    cityWithStateAbbr: "Virginia State Universit, VA",
  },
  {
    zip: "23821",
    ST: "VA",
    cityWithStateAbbr: "Alberta, VA",
  },
  {
    zip: "23822",
    ST: "VA",
    cityWithStateAbbr: "Ammon, VA",
  },
  {
    zip: "23824",
    ST: "VA",
    cityWithStateAbbr: "Blackstone, VA",
  },
  {
    zip: "23827",
    ST: "VA",
    cityWithStateAbbr: "Boykins, VA",
  },
  {
    zip: "23828",
    ST: "VA",
    cityWithStateAbbr: "Branchville, VA",
  },
  {
    zip: "23829",
    ST: "VA",
    cityWithStateAbbr: "Capron, VA",
  },
  {
    zip: "23830",
    ST: "VA",
    cityWithStateAbbr: "Carson, VA",
  },
  {
    zip: "23831",
    ST: "VA",
    cityWithStateAbbr: "Chester, VA",
  },
  {
    zip: "23832",
    ST: "VA",
    cityWithStateAbbr: "Chesterfield, VA",
  },
  {
    zip: "23833",
    ST: "VA",
    cityWithStateAbbr: "Church Road, VA",
  },
  {
    zip: "23834",
    ST: "VA",
    cityWithStateAbbr: "Colonial Heights, VA",
  },
  {
    zip: "23836",
    ST: "VA",
    cityWithStateAbbr: "Chester, VA",
  },
  {
    zip: "23837",
    ST: "VA",
    cityWithStateAbbr: "Courtland, VA",
  },
  {
    zip: "23838",
    ST: "VA",
    cityWithStateAbbr: "Chesterfield, VA",
  },
  {
    zip: "23839",
    ST: "VA",
    cityWithStateAbbr: "Dendron, VA",
  },
  {
    zip: "23840",
    ST: "VA",
    cityWithStateAbbr: "Dewitt, VA",
  },
  {
    zip: "23841",
    ST: "VA",
    cityWithStateAbbr: "Dinwiddie, VA",
  },
  {
    zip: "23842",
    ST: "VA",
    cityWithStateAbbr: "Disputanta, VA",
  },
  {
    zip: "23843",
    ST: "VA",
    cityWithStateAbbr: "Dolphin, VA",
  },
  {
    zip: "23844",
    ST: "VA",
    cityWithStateAbbr: "Drewryville, VA",
  },
  {
    zip: "23845",
    ST: "VA",
    cityWithStateAbbr: "Ebony, VA",
  },
  {
    zip: "23846",
    ST: "VA",
    cityWithStateAbbr: "Elberon, VA",
  },
  {
    zip: "23847",
    ST: "VA",
    cityWithStateAbbr: "Emporia, VA",
  },
  {
    zip: "23850",
    ST: "VA",
    cityWithStateAbbr: "Ford, VA",
  },
  {
    zip: "23851",
    ST: "VA",
    cityWithStateAbbr: "Franklin, VA",
  },
  {
    zip: "23856",
    ST: "VA",
    cityWithStateAbbr: "Freeman, VA",
  },
  {
    zip: "23857",
    ST: "VA",
    cityWithStateAbbr: "Gasburg, VA",
  },
  {
    zip: "23860",
    ST: "VA",
    cityWithStateAbbr: "Hopewell, VA",
  },
  {
    zip: "23866",
    ST: "VA",
    cityWithStateAbbr: "Ivor, VA",
  },
  {
    zip: "23867",
    ST: "VA",
    cityWithStateAbbr: "Jarratt, VA",
  },
  {
    zip: "23868",
    ST: "VA",
    cityWithStateAbbr: "Lawrenceville, VA",
  },
  {
    zip: "23870",
    ST: "VA",
    cityWithStateAbbr: "Jarratt, VA",
  },
  {
    zip: "23872",
    ST: "VA",
    cityWithStateAbbr: "Mc Kenney, VA",
  },
  {
    zip: "23873",
    ST: "VA",
    cityWithStateAbbr: "Meredithville, VA",
  },
  {
    zip: "23874",
    ST: "VA",
    cityWithStateAbbr: "Newsoms, VA",
  },
  {
    zip: "23875",
    ST: "VA",
    cityWithStateAbbr: "Prince George, VA",
  },
  {
    zip: "23876",
    ST: "VA",
    cityWithStateAbbr: "Rawlings, VA",
  },
  {
    zip: "23878",
    ST: "VA",
    cityWithStateAbbr: "Sedley, VA",
  },
  {
    zip: "23879",
    ST: "VA",
    cityWithStateAbbr: "Skippers, VA",
  },
  {
    zip: "23881",
    ST: "VA",
    cityWithStateAbbr: "Spring Grove, VA",
  },
  {
    zip: "23882",
    ST: "VA",
    cityWithStateAbbr: "Stony Creek, VA",
  },
  {
    zip: "23883",
    ST: "VA",
    cityWithStateAbbr: "Surry, VA",
  },
  {
    zip: "23884",
    ST: "VA",
    cityWithStateAbbr: "Sussex, VA",
  },
  {
    zip: "23885",
    ST: "VA",
    cityWithStateAbbr: "Sutherland, VA",
  },
  {
    zip: "23887",
    ST: "VA",
    cityWithStateAbbr: "Valentines, VA",
  },
  {
    zip: "23888",
    ST: "VA",
    cityWithStateAbbr: "Wakefield, VA",
  },
  {
    zip: "23889",
    ST: "VA",
    cityWithStateAbbr: "Warfield, VA",
  },
  {
    zip: "23890",
    ST: "VA",
    cityWithStateAbbr: "Waverly, VA",
  },
  {
    zip: "23891",
    ST: "VA",
    cityWithStateAbbr: "Waverly, VA",
  },
  {
    zip: "23893",
    ST: "VA",
    cityWithStateAbbr: "White Plains, VA",
  },
  {
    zip: "23894",
    ST: "VA",
    cityWithStateAbbr: "Wilsons, VA",
  },
  {
    zip: "23897",
    ST: "VA",
    cityWithStateAbbr: "Yale, VA",
  },
  {
    zip: "23898",
    ST: "VA",
    cityWithStateAbbr: "Zuni, VA",
  },
  {
    zip: "23899",
    ST: "VA",
    cityWithStateAbbr: "Claremont, VA",
  },
  {
    zip: "23901",
    ST: "VA",
    cityWithStateAbbr: "Farmville, VA",
  },
  {
    zip: "23909",
    ST: "VA",
    cityWithStateAbbr: "Farmville, VA",
  },
  {
    zip: "23915",
    ST: "VA",
    cityWithStateAbbr: "Baskerville, VA",
  },
  {
    zip: "23917",
    ST: "VA",
    cityWithStateAbbr: "Boydton, VA",
  },
  {
    zip: "23919",
    ST: "VA",
    cityWithStateAbbr: "Bracey, VA",
  },
  {
    zip: "23920",
    ST: "VA",
    cityWithStateAbbr: "Brodnax, VA",
  },
  {
    zip: "23921",
    ST: "VA",
    cityWithStateAbbr: "Buckingham, VA",
  },
  {
    zip: "23922",
    ST: "VA",
    cityWithStateAbbr: "Burkeville, VA",
  },
  {
    zip: "23923",
    ST: "VA",
    cityWithStateAbbr: "Charlotte Court House, VA",
  },
  {
    zip: "23924",
    ST: "VA",
    cityWithStateAbbr: "Chase City, VA",
  },
  {
    zip: "23927",
    ST: "VA",
    cityWithStateAbbr: "Clarksville, VA",
  },
  {
    zip: "23930",
    ST: "VA",
    cityWithStateAbbr: "Crewe, VA",
  },
  {
    zip: "23934",
    ST: "VA",
    cityWithStateAbbr: "Cullen, VA",
  },
  {
    zip: "23936",
    ST: "VA",
    cityWithStateAbbr: "Dillwyn, VA",
  },
  {
    zip: "23937",
    ST: "VA",
    cityWithStateAbbr: "Drakes Branch, VA",
  },
  {
    zip: "23938",
    ST: "VA",
    cityWithStateAbbr: "Dundas, VA",
  },
  {
    zip: "23939",
    ST: "VA",
    cityWithStateAbbr: "Evergreen, VA",
  },
  {
    zip: "23941",
    ST: "VA",
    cityWithStateAbbr: "Fort Mitchell, VA",
  },
  {
    zip: "23942",
    ST: "VA",
    cityWithStateAbbr: "Green Bay, VA",
  },
  {
    zip: "23943",
    ST: "VA",
    cityWithStateAbbr: "Hampden Sydney, VA",
  },
  {
    zip: "23944",
    ST: "VA",
    cityWithStateAbbr: "Kenbridge, VA",
  },
  {
    zip: "23947",
    ST: "VA",
    cityWithStateAbbr: "Keysville, VA",
  },
  {
    zip: "23950",
    ST: "VA",
    cityWithStateAbbr: "La Crosse, VA",
  },
  {
    zip: "23952",
    ST: "VA",
    cityWithStateAbbr: "Lunenburg, VA",
  },
  {
    zip: "23954",
    ST: "VA",
    cityWithStateAbbr: "Meherrin, VA",
  },
  {
    zip: "23955",
    ST: "VA",
    cityWithStateAbbr: "Nottoway, VA",
  },
  {
    zip: "23958",
    ST: "VA",
    cityWithStateAbbr: "Pamplin, VA",
  },
  {
    zip: "23959",
    ST: "VA",
    cityWithStateAbbr: "Phenix, VA",
  },
  {
    zip: "23960",
    ST: "VA",
    cityWithStateAbbr: "Prospect, VA",
  },
  {
    zip: "23962",
    ST: "VA",
    cityWithStateAbbr: "Randolph, VA",
  },
  {
    zip: "23963",
    ST: "VA",
    cityWithStateAbbr: "Red House, VA",
  },
  {
    zip: "23964",
    ST: "VA",
    cityWithStateAbbr: "Red Oak, VA",
  },
  {
    zip: "23966",
    ST: "VA",
    cityWithStateAbbr: "Rice, VA",
  },
  {
    zip: "23967",
    ST: "VA",
    cityWithStateAbbr: "Saxe, VA",
  },
  {
    zip: "23968",
    ST: "VA",
    cityWithStateAbbr: "Skipwith, VA",
  },
  {
    zip: "23970",
    ST: "VA",
    cityWithStateAbbr: "South Hill, VA",
  },
  {
    zip: "23974",
    ST: "VA",
    cityWithStateAbbr: "Victoria, VA",
  },
  {
    zip: "23976",
    ST: "VA",
    cityWithStateAbbr: "Wylliesburg, VA",
  },
  {
    zip: "24001",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24002",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24003",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24004",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24005",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24006",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24007",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24008",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24009",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24010",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24011",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24012",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24013",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24014",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24015",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24016",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24017",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24018",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24019",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24020",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24022",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24023",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24024",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24025",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24026",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24027",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24028",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24029",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24030",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24031",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24032",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24033",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24034",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24035",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24036",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24037",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24038",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24040",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24042",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24043",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24050",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24053",
    ST: "VA",
    cityWithStateAbbr: "Ararat, VA",
  },
  {
    zip: "24054",
    ST: "VA",
    cityWithStateAbbr: "Axton, VA",
  },
  {
    zip: "24055",
    ST: "VA",
    cityWithStateAbbr: "Bassett, VA",
  },
  {
    zip: "24058",
    ST: "VA",
    cityWithStateAbbr: "Belspring, VA",
  },
  {
    zip: "24059",
    ST: "VA",
    cityWithStateAbbr: "Bent Mountain, VA",
  },
  {
    zip: "24060",
    ST: "VA",
    cityWithStateAbbr: "Blacksburg, VA",
  },
  {
    zip: "24061",
    ST: "VA",
    cityWithStateAbbr: "Blacksburg, VA",
  },
  {
    zip: "24062",
    ST: "VA",
    cityWithStateAbbr: "Blacksburg, VA",
  },
  {
    zip: "24063",
    ST: "VA",
    cityWithStateAbbr: "Blacksburg, VA",
  },
  {
    zip: "24064",
    ST: "VA",
    cityWithStateAbbr: "Blue Ridge, VA",
  },
  {
    zip: "24065",
    ST: "VA",
    cityWithStateAbbr: "Boones Mill, VA",
  },
  {
    zip: "24066",
    ST: "VA",
    cityWithStateAbbr: "Buchanan, VA",
  },
  {
    zip: "24067",
    ST: "VA",
    cityWithStateAbbr: "Callaway, VA",
  },
  {
    zip: "24068",
    ST: "VA",
    cityWithStateAbbr: "Christiansburg, VA",
  },
  {
    zip: "24069",
    ST: "VA",
    cityWithStateAbbr: "Cascade, VA",
  },
  {
    zip: "24070",
    ST: "VA",
    cityWithStateAbbr: "Catawba, VA",
  },
  {
    zip: "24072",
    ST: "VA",
    cityWithStateAbbr: "Check, VA",
  },
  {
    zip: "24073",
    ST: "VA",
    cityWithStateAbbr: "Christiansburg, VA",
  },
  {
    zip: "24076",
    ST: "VA",
    cityWithStateAbbr: "Claudville, VA",
  },
  {
    zip: "24077",
    ST: "VA",
    cityWithStateAbbr: "Cloverdale, VA",
  },
  {
    zip: "24078",
    ST: "VA",
    cityWithStateAbbr: "Collinsville, VA",
  },
  {
    zip: "24079",
    ST: "VA",
    cityWithStateAbbr: "Copper Hill, VA",
  },
  {
    zip: "24082",
    ST: "VA",
    cityWithStateAbbr: "Critz, VA",
  },
  {
    zip: "24083",
    ST: "VA",
    cityWithStateAbbr: "Daleville, VA",
  },
  {
    zip: "24084",
    ST: "VA",
    cityWithStateAbbr: "Dublin, VA",
  },
  {
    zip: "24085",
    ST: "VA",
    cityWithStateAbbr: "Eagle Rock, VA",
  },
  {
    zip: "24086",
    ST: "VA",
    cityWithStateAbbr: "Eggleston, VA",
  },
  {
    zip: "24087",
    ST: "VA",
    cityWithStateAbbr: "Elliston, VA",
  },
  {
    zip: "24088",
    ST: "VA",
    cityWithStateAbbr: "Ferrum, VA",
  },
  {
    zip: "24089",
    ST: "VA",
    cityWithStateAbbr: "Fieldale, VA",
  },
  {
    zip: "24090",
    ST: "VA",
    cityWithStateAbbr: "Fincastle, VA",
  },
  {
    zip: "24091",
    ST: "VA",
    cityWithStateAbbr: "Floyd, VA",
  },
  {
    zip: "24092",
    ST: "VA",
    cityWithStateAbbr: "Glade Hill, VA",
  },
  {
    zip: "24093",
    ST: "VA",
    cityWithStateAbbr: "Glen Lyn, VA",
  },
  {
    zip: "24095",
    ST: "VA",
    cityWithStateAbbr: "Goodview, VA",
  },
  {
    zip: "24101",
    ST: "VA",
    cityWithStateAbbr: "Hardy, VA",
  },
  {
    zip: "24102",
    ST: "VA",
    cityWithStateAbbr: "Henry, VA",
  },
  {
    zip: "24104",
    ST: "VA",
    cityWithStateAbbr: "Huddleston, VA",
  },
  {
    zip: "24105",
    ST: "VA",
    cityWithStateAbbr: "Indian Valley, VA",
  },
  {
    zip: "24111",
    ST: "VA",
    cityWithStateAbbr: "Mc Coy, VA",
  },
  {
    zip: "24112",
    ST: "VA",
    cityWithStateAbbr: "Martinsville, VA",
  },
  {
    zip: "24113",
    ST: "VA",
    cityWithStateAbbr: "Martinsville, VA",
  },
  {
    zip: "24114",
    ST: "VA",
    cityWithStateAbbr: "Martinsville, VA",
  },
  {
    zip: "24115",
    ST: "VA",
    cityWithStateAbbr: "Martinsville, VA",
  },
  {
    zip: "24120",
    ST: "VA",
    cityWithStateAbbr: "Meadows Of Dan, VA",
  },
  {
    zip: "24121",
    ST: "VA",
    cityWithStateAbbr: "Moneta, VA",
  },
  {
    zip: "24122",
    ST: "VA",
    cityWithStateAbbr: "Montvale, VA",
  },
  {
    zip: "24124",
    ST: "VA",
    cityWithStateAbbr: "Narrows, VA",
  },
  {
    zip: "24126",
    ST: "VA",
    cityWithStateAbbr: "Newbern, VA",
  },
  {
    zip: "24127",
    ST: "VA",
    cityWithStateAbbr: "New Castle, VA",
  },
  {
    zip: "24128",
    ST: "VA",
    cityWithStateAbbr: "Newport, VA",
  },
  {
    zip: "24129",
    ST: "VA",
    cityWithStateAbbr: "New River, VA",
  },
  {
    zip: "24130",
    ST: "VA",
    cityWithStateAbbr: "Oriskany, VA",
  },
  {
    zip: "24131",
    ST: "VA",
    cityWithStateAbbr: "Paint Bank, VA",
  },
  {
    zip: "24132",
    ST: "VA",
    cityWithStateAbbr: "Parrott, VA",
  },
  {
    zip: "24133",
    ST: "VA",
    cityWithStateAbbr: "Patrick Springs, VA",
  },
  {
    zip: "24134",
    ST: "VA",
    cityWithStateAbbr: "Pearisburg, VA",
  },
  {
    zip: "24136",
    ST: "VA",
    cityWithStateAbbr: "Pembroke, VA",
  },
  {
    zip: "24137",
    ST: "VA",
    cityWithStateAbbr: "Penhook, VA",
  },
  {
    zip: "24138",
    ST: "VA",
    cityWithStateAbbr: "Pilot, VA",
  },
  {
    zip: "24139",
    ST: "VA",
    cityWithStateAbbr: "Pittsville, VA",
  },
  {
    zip: "24141",
    ST: "VA",
    cityWithStateAbbr: "Radford, VA",
  },
  {
    zip: "24142",
    ST: "VA",
    cityWithStateAbbr: "Radford, VA",
  },
  {
    zip: "24143",
    ST: "VA",
    cityWithStateAbbr: "Radford, VA",
  },
  {
    zip: "24146",
    ST: "VA",
    cityWithStateAbbr: "Redwood, VA",
  },
  {
    zip: "24147",
    ST: "VA",
    cityWithStateAbbr: "Rich Creek, VA",
  },
  {
    zip: "24148",
    ST: "VA",
    cityWithStateAbbr: "Ridgeway, VA",
  },
  {
    zip: "24149",
    ST: "VA",
    cityWithStateAbbr: "Riner, VA",
  },
  {
    zip: "24150",
    ST: "VA",
    cityWithStateAbbr: "Ripplemead, VA",
  },
  {
    zip: "24151",
    ST: "VA",
    cityWithStateAbbr: "Rocky Mount, VA",
  },
  {
    zip: "24153",
    ST: "VA",
    cityWithStateAbbr: "Salem, VA",
  },
  {
    zip: "24155",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24157",
    ST: "VA",
    cityWithStateAbbr: "Roanoke, VA",
  },
  {
    zip: "24161",
    ST: "VA",
    cityWithStateAbbr: "Sandy Level, VA",
  },
  {
    zip: "24162",
    ST: "VA",
    cityWithStateAbbr: "Shawsville, VA",
  },
  {
    zip: "24165",
    ST: "VA",
    cityWithStateAbbr: "Spencer, VA",
  },
  {
    zip: "24167",
    ST: "VA",
    cityWithStateAbbr: "Staffordsville, VA",
  },
  {
    zip: "24168",
    ST: "VA",
    cityWithStateAbbr: "Stanleytown, VA",
  },
  {
    zip: "24171",
    ST: "VA",
    cityWithStateAbbr: "Stuart, VA",
  },
  {
    zip: "24174",
    ST: "VA",
    cityWithStateAbbr: "Thaxton, VA",
  },
  {
    zip: "24175",
    ST: "VA",
    cityWithStateAbbr: "Troutville, VA",
  },
  {
    zip: "24176",
    ST: "VA",
    cityWithStateAbbr: "Union Hall, VA",
  },
  {
    zip: "24177",
    ST: "VA",
    cityWithStateAbbr: "Vesta, VA",
  },
  {
    zip: "24178",
    ST: "VA",
    cityWithStateAbbr: "Villamont, VA",
  },
  {
    zip: "24179",
    ST: "VA",
    cityWithStateAbbr: "Vinton, VA",
  },
  {
    zip: "24184",
    ST: "VA",
    cityWithStateAbbr: "Wirtz, VA",
  },
  {
    zip: "24185",
    ST: "VA",
    cityWithStateAbbr: "Woolwine, VA",
  },
  {
    zip: "24201",
    ST: "VA",
    cityWithStateAbbr: "Bristol, VA",
  },
  {
    zip: "24202",
    ST: "VA",
    cityWithStateAbbr: "Bristol, VA",
  },
  {
    zip: "24203",
    ST: "VA",
    cityWithStateAbbr: "Bristol, VA",
  },
  {
    zip: "24209",
    ST: "VA",
    cityWithStateAbbr: "Bristol, VA",
  },
  {
    zip: "24210",
    ST: "VA",
    cityWithStateAbbr: "Abingdon, VA",
  },
  {
    zip: "24211",
    ST: "VA",
    cityWithStateAbbr: "Abingdon, VA",
  },
  {
    zip: "24212",
    ST: "VA",
    cityWithStateAbbr: "Abingdon, VA",
  },
  {
    zip: "24215",
    ST: "VA",
    cityWithStateAbbr: "Andover, VA",
  },
  {
    zip: "24216",
    ST: "VA",
    cityWithStateAbbr: "Appalachia, VA",
  },
  {
    zip: "24217",
    ST: "VA",
    cityWithStateAbbr: "Bee, VA",
  },
  {
    zip: "24218",
    ST: "VA",
    cityWithStateAbbr: "Ben Hur, VA",
  },
  {
    zip: "24219",
    ST: "VA",
    cityWithStateAbbr: "Big Stone Gap, VA",
  },
  {
    zip: "24220",
    ST: "VA",
    cityWithStateAbbr: "Birchleaf, VA",
  },
  {
    zip: "24221",
    ST: "VA",
    cityWithStateAbbr: "Blackwater, VA",
  },
  {
    zip: "24224",
    ST: "VA",
    cityWithStateAbbr: "Castlewood, VA",
  },
  {
    zip: "24225",
    ST: "VA",
    cityWithStateAbbr: "Cleveland, VA",
  },
  {
    zip: "24226",
    ST: "VA",
    cityWithStateAbbr: "Clinchco, VA",
  },
  {
    zip: "24228",
    ST: "VA",
    cityWithStateAbbr: "Clintwood, VA",
  },
  {
    zip: "24230",
    ST: "VA",
    cityWithStateAbbr: "Coeburn, VA",
  },
  {
    zip: "24236",
    ST: "VA",
    cityWithStateAbbr: "Damascus, VA",
  },
  {
    zip: "24237",
    ST: "VA",
    cityWithStateAbbr: "Dante, VA",
  },
  {
    zip: "24239",
    ST: "VA",
    cityWithStateAbbr: "Davenport, VA",
  },
  {
    zip: "24243",
    ST: "VA",
    cityWithStateAbbr: "Dryden, VA",
  },
  {
    zip: "24244",
    ST: "VA",
    cityWithStateAbbr: "Duffield, VA",
  },
  {
    zip: "24245",
    ST: "VA",
    cityWithStateAbbr: "Dungannon, VA",
  },
  {
    zip: "24246",
    ST: "VA",
    cityWithStateAbbr: "East Stone Gap, VA",
  },
  {
    zip: "24248",
    ST: "VA",
    cityWithStateAbbr: "Ewing, VA",
  },
  {
    zip: "24250",
    ST: "VA",
    cityWithStateAbbr: "Fort Blackmore, VA",
  },
  {
    zip: "24251",
    ST: "VA",
    cityWithStateAbbr: "Gate City, VA",
  },
  {
    zip: "24256",
    ST: "VA",
    cityWithStateAbbr: "Haysi, VA",
  },
  {
    zip: "24258",
    ST: "VA",
    cityWithStateAbbr: "Hiltons, VA",
  },
  {
    zip: "24260",
    ST: "VA",
    cityWithStateAbbr: "Honaker, VA",
  },
  {
    zip: "24263",
    ST: "VA",
    cityWithStateAbbr: "Jonesville, VA",
  },
  {
    zip: "24265",
    ST: "VA",
    cityWithStateAbbr: "Keokee, VA",
  },
  {
    zip: "24266",
    ST: "VA",
    cityWithStateAbbr: "Lebanon, VA",
  },
  {
    zip: "24269",
    ST: "VA",
    cityWithStateAbbr: "Mc Clure, VA",
  },
  {
    zip: "24270",
    ST: "VA",
    cityWithStateAbbr: "Mendota, VA",
  },
  {
    zip: "24271",
    ST: "VA",
    cityWithStateAbbr: "Nickelsville, VA",
  },
  {
    zip: "24272",
    ST: "VA",
    cityWithStateAbbr: "Nora, VA",
  },
  {
    zip: "24273",
    ST: "VA",
    cityWithStateAbbr: "Norton, VA",
  },
  {
    zip: "24277",
    ST: "VA",
    cityWithStateAbbr: "Pennington Gap, VA",
  },
  {
    zip: "24279",
    ST: "VA",
    cityWithStateAbbr: "Pound, VA",
  },
  {
    zip: "24280",
    ST: "VA",
    cityWithStateAbbr: "Rosedale, VA",
  },
  {
    zip: "24281",
    ST: "VA",
    cityWithStateAbbr: "Rose Hill, VA",
  },
  {
    zip: "24282",
    ST: "VA",
    cityWithStateAbbr: "Saint Charles, VA",
  },
  {
    zip: "24283",
    ST: "VA",
    cityWithStateAbbr: "Saint Paul, VA",
  },
  {
    zip: "24290",
    ST: "VA",
    cityWithStateAbbr: "Weber City, VA",
  },
  {
    zip: "24292",
    ST: "VA",
    cityWithStateAbbr: "Whitetop, VA",
  },
  {
    zip: "24293",
    ST: "VA",
    cityWithStateAbbr: "Wise, VA",
  },
  {
    zip: "24301",
    ST: "VA",
    cityWithStateAbbr: "Pulaski, VA",
  },
  {
    zip: "24311",
    ST: "VA",
    cityWithStateAbbr: "Atkins, VA",
  },
  {
    zip: "24312",
    ST: "VA",
    cityWithStateAbbr: "Austinville, VA",
  },
  {
    zip: "24313",
    ST: "VA",
    cityWithStateAbbr: "Barren Springs, VA",
  },
  {
    zip: "24314",
    ST: "VA",
    cityWithStateAbbr: "Bastian, VA",
  },
  {
    zip: "24315",
    ST: "VA",
    cityWithStateAbbr: "Bland, VA",
  },
  {
    zip: "24316",
    ST: "VA",
    cityWithStateAbbr: "Broadford, VA",
  },
  {
    zip: "24317",
    ST: "VA",
    cityWithStateAbbr: "Cana, VA",
  },
  {
    zip: "24318",
    ST: "VA",
    cityWithStateAbbr: "Ceres, VA",
  },
  {
    zip: "24319",
    ST: "VA",
    cityWithStateAbbr: "Chilhowie, VA",
  },
  {
    zip: "24322",
    ST: "VA",
    cityWithStateAbbr: "Cripple Creek, VA",
  },
  {
    zip: "24323",
    ST: "VA",
    cityWithStateAbbr: "Crockett, VA",
  },
  {
    zip: "24324",
    ST: "VA",
    cityWithStateAbbr: "Draper, VA",
  },
  {
    zip: "24325",
    ST: "VA",
    cityWithStateAbbr: "Dugspur, VA",
  },
  {
    zip: "24326",
    ST: "VA",
    cityWithStateAbbr: "Elk Creek, VA",
  },
  {
    zip: "24327",
    ST: "VA",
    cityWithStateAbbr: "Emory, VA",
  },
  {
    zip: "24328",
    ST: "VA",
    cityWithStateAbbr: "Fancy Gap, VA",
  },
  {
    zip: "24330",
    ST: "VA",
    cityWithStateAbbr: "Fries, VA",
  },
  {
    zip: "24333",
    ST: "VA",
    cityWithStateAbbr: "Galax, VA",
  },
  {
    zip: "24340",
    ST: "VA",
    cityWithStateAbbr: "Glade Spring, VA",
  },
  {
    zip: "24343",
    ST: "VA",
    cityWithStateAbbr: "Hillsville, VA",
  },
  {
    zip: "24347",
    ST: "VA",
    cityWithStateAbbr: "Hiwassee, VA",
  },
  {
    zip: "24348",
    ST: "VA",
    cityWithStateAbbr: "Independence, VA",
  },
  {
    zip: "24350",
    ST: "VA",
    cityWithStateAbbr: "Ivanhoe, VA",
  },
  {
    zip: "24351",
    ST: "VA",
    cityWithStateAbbr: "Lambsburg, VA",
  },
  {
    zip: "24352",
    ST: "VA",
    cityWithStateAbbr: "Laurel Fork, VA",
  },
  {
    zip: "24354",
    ST: "VA",
    cityWithStateAbbr: "Marion, VA",
  },
  {
    zip: "24360",
    ST: "VA",
    cityWithStateAbbr: "Max Meadows, VA",
  },
  {
    zip: "24361",
    ST: "VA",
    cityWithStateAbbr: "Meadowview, VA",
  },
  {
    zip: "24363",
    ST: "VA",
    cityWithStateAbbr: "Mouth Of Wilson, VA",
  },
  {
    zip: "24366",
    ST: "VA",
    cityWithStateAbbr: "Rocky Gap, VA",
  },
  {
    zip: "24368",
    ST: "VA",
    cityWithStateAbbr: "Rural Retreat, VA",
  },
  {
    zip: "24370",
    ST: "VA",
    cityWithStateAbbr: "Saltville, VA",
  },
  {
    zip: "24374",
    ST: "VA",
    cityWithStateAbbr: "Speedwell, VA",
  },
  {
    zip: "24375",
    ST: "VA",
    cityWithStateAbbr: "Sugar Grove, VA",
  },
  {
    zip: "24377",
    ST: "VA",
    cityWithStateAbbr: "Tannersville, VA",
  },
  {
    zip: "24378",
    ST: "VA",
    cityWithStateAbbr: "Troutdale, VA",
  },
  {
    zip: "24380",
    ST: "VA",
    cityWithStateAbbr: "Willis, VA",
  },
  {
    zip: "24381",
    ST: "VA",
    cityWithStateAbbr: "Woodlawn, VA",
  },
  {
    zip: "24382",
    ST: "VA",
    cityWithStateAbbr: "Wytheville, VA",
  },
  {
    zip: "24401",
    ST: "VA",
    cityWithStateAbbr: "Staunton, VA",
  },
  {
    zip: "24402",
    ST: "VA",
    cityWithStateAbbr: "Staunton, VA",
  },
  {
    zip: "24411",
    ST: "VA",
    cityWithStateAbbr: "Augusta Springs, VA",
  },
  {
    zip: "24412",
    ST: "VA",
    cityWithStateAbbr: "Bacova, VA",
  },
  {
    zip: "24413",
    ST: "VA",
    cityWithStateAbbr: "Blue Grass, VA",
  },
  {
    zip: "24415",
    ST: "VA",
    cityWithStateAbbr: "Brownsburg, VA",
  },
  {
    zip: "24416",
    ST: "VA",
    cityWithStateAbbr: "Buena Vista, VA",
  },
  {
    zip: "24421",
    ST: "VA",
    cityWithStateAbbr: "Churchville, VA",
  },
  {
    zip: "24422",
    ST: "VA",
    cityWithStateAbbr: "Clifton Forge, VA",
  },
  {
    zip: "24426",
    ST: "VA",
    cityWithStateAbbr: "Covington, VA",
  },
  {
    zip: "24430",
    ST: "VA",
    cityWithStateAbbr: "Craigsville, VA",
  },
  {
    zip: "24431",
    ST: "VA",
    cityWithStateAbbr: "Crimora, VA",
  },
  {
    zip: "24432",
    ST: "VA",
    cityWithStateAbbr: "Deerfield, VA",
  },
  {
    zip: "24433",
    ST: "VA",
    cityWithStateAbbr: "Doe Hill, VA",
  },
  {
    zip: "24435",
    ST: "VA",
    cityWithStateAbbr: "Fairfield, VA",
  },
  {
    zip: "24437",
    ST: "VA",
    cityWithStateAbbr: "Fort Defiance, VA",
  },
  {
    zip: "24438",
    ST: "VA",
    cityWithStateAbbr: "Glen Wilton, VA",
  },
  {
    zip: "24439",
    ST: "VA",
    cityWithStateAbbr: "Goshen, VA",
  },
  {
    zip: "24440",
    ST: "VA",
    cityWithStateAbbr: "Greenville, VA",
  },
  {
    zip: "24441",
    ST: "VA",
    cityWithStateAbbr: "Grottoes, VA",
  },
  {
    zip: "24442",
    ST: "VA",
    cityWithStateAbbr: "Head Waters, VA",
  },
  {
    zip: "24445",
    ST: "VA",
    cityWithStateAbbr: "Hot Springs, VA",
  },
  {
    zip: "24448",
    ST: "VA",
    cityWithStateAbbr: "Iron Gate, VA",
  },
  {
    zip: "24450",
    ST: "VA",
    cityWithStateAbbr: "Lexington, VA",
  },
  {
    zip: "24457",
    ST: "VA",
    cityWithStateAbbr: "Low Moor, VA",
  },
  {
    zip: "24458",
    ST: "VA",
    cityWithStateAbbr: "Mc Dowell, VA",
  },
  {
    zip: "24459",
    ST: "VA",
    cityWithStateAbbr: "Middlebrook, VA",
  },
  {
    zip: "24460",
    ST: "VA",
    cityWithStateAbbr: "Millboro, VA",
  },
  {
    zip: "24463",
    ST: "VA",
    cityWithStateAbbr: "Mint Spring, VA",
  },
  {
    zip: "24464",
    ST: "VA",
    cityWithStateAbbr: "Montebello, VA",
  },
  {
    zip: "24465",
    ST: "VA",
    cityWithStateAbbr: "Monterey, VA",
  },
  {
    zip: "24467",
    ST: "VA",
    cityWithStateAbbr: "Mount Sidney, VA",
  },
  {
    zip: "24468",
    ST: "VA",
    cityWithStateAbbr: "Mustoe, VA",
  },
  {
    zip: "24469",
    ST: "VA",
    cityWithStateAbbr: "New Hope, VA",
  },
  {
    zip: "24471",
    ST: "VA",
    cityWithStateAbbr: "Port Republic, VA",
  },
  {
    zip: "24472",
    ST: "VA",
    cityWithStateAbbr: "Raphine, VA",
  },
  {
    zip: "24473",
    ST: "VA",
    cityWithStateAbbr: "Rockbridge Baths, VA",
  },
  {
    zip: "24474",
    ST: "VA",
    cityWithStateAbbr: "Selma, VA",
  },
  {
    zip: "24476",
    ST: "VA",
    cityWithStateAbbr: "Steeles Tavern, VA",
  },
  {
    zip: "24477",
    ST: "VA",
    cityWithStateAbbr: "Stuarts Draft, VA",
  },
  {
    zip: "24479",
    ST: "VA",
    cityWithStateAbbr: "Swoope, VA",
  },
  {
    zip: "24482",
    ST: "VA",
    cityWithStateAbbr: "Verona, VA",
  },
  {
    zip: "24483",
    ST: "VA",
    cityWithStateAbbr: "Vesuvius, VA",
  },
  {
    zip: "24484",
    ST: "VA",
    cityWithStateAbbr: "Warm Springs, VA",
  },
  {
    zip: "24485",
    ST: "VA",
    cityWithStateAbbr: "West Augusta, VA",
  },
  {
    zip: "24486",
    ST: "VA",
    cityWithStateAbbr: "Weyers Cave, VA",
  },
  {
    zip: "24487",
    ST: "VA",
    cityWithStateAbbr: "Williamsville, VA",
  },
  {
    zip: "24501",
    ST: "VA",
    cityWithStateAbbr: "Lynchburg, VA",
  },
  {
    zip: "24502",
    ST: "VA",
    cityWithStateAbbr: "Lynchburg, VA",
  },
  {
    zip: "24503",
    ST: "VA",
    cityWithStateAbbr: "Lynchburg, VA",
  },
  {
    zip: "24504",
    ST: "VA",
    cityWithStateAbbr: "Lynchburg, VA",
  },
  {
    zip: "24505",
    ST: "VA",
    cityWithStateAbbr: "Lynchburg, VA",
  },
  {
    zip: "24506",
    ST: "VA",
    cityWithStateAbbr: "Lynchburg, VA",
  },
  {
    zip: "24513",
    ST: "VA",
    cityWithStateAbbr: "Lynchburg, VA",
  },
  {
    zip: "24514",
    ST: "VA",
    cityWithStateAbbr: "Lynchburg, VA",
  },
  {
    zip: "24515",
    ST: "VA",
    cityWithStateAbbr: "Lynchburg, VA",
  },
  {
    zip: "24517",
    ST: "VA",
    cityWithStateAbbr: "Altavista, VA",
  },
  {
    zip: "24520",
    ST: "VA",
    cityWithStateAbbr: "Alton, VA",
  },
  {
    zip: "24521",
    ST: "VA",
    cityWithStateAbbr: "Amherst, VA",
  },
  {
    zip: "24522",
    ST: "VA",
    cityWithStateAbbr: "Appomattox, VA",
  },
  {
    zip: "24523",
    ST: "VA",
    cityWithStateAbbr: "Bedford, VA",
  },
  {
    zip: "24526",
    ST: "VA",
    cityWithStateAbbr: "Big Island, VA",
  },
  {
    zip: "24527",
    ST: "VA",
    cityWithStateAbbr: "Blairs, VA",
  },
  {
    zip: "24528",
    ST: "VA",
    cityWithStateAbbr: "Brookneal, VA",
  },
  {
    zip: "24529",
    ST: "VA",
    cityWithStateAbbr: "Buffalo Junction, VA",
  },
  {
    zip: "24530",
    ST: "VA",
    cityWithStateAbbr: "Callands, VA",
  },
  {
    zip: "24531",
    ST: "VA",
    cityWithStateAbbr: "Chatham, VA",
  },
  {
    zip: "24533",
    ST: "VA",
    cityWithStateAbbr: "Clifford, VA",
  },
  {
    zip: "24534",
    ST: "VA",
    cityWithStateAbbr: "Clover, VA",
  },
  {
    zip: "24535",
    ST: "VA",
    cityWithStateAbbr: "Cluster Springs, VA",
  },
  {
    zip: "24536",
    ST: "VA",
    cityWithStateAbbr: "Coleman Falls, VA",
  },
  {
    zip: "24538",
    ST: "VA",
    cityWithStateAbbr: "Concord, VA",
  },
  {
    zip: "24539",
    ST: "VA",
    cityWithStateAbbr: "Crystal Hill, VA",
  },
  {
    zip: "24540",
    ST: "VA",
    cityWithStateAbbr: "Danville, VA",
  },
  {
    zip: "24541",
    ST: "VA",
    cityWithStateAbbr: "Danville, VA",
  },
  {
    zip: "24543",
    ST: "VA",
    cityWithStateAbbr: "Danville, VA",
  },
  {
    zip: "24549",
    ST: "VA",
    cityWithStateAbbr: "Dry Fork, VA",
  },
  {
    zip: "24550",
    ST: "VA",
    cityWithStateAbbr: "Evington, VA",
  },
  {
    zip: "24551",
    ST: "VA",
    cityWithStateAbbr: "Forest, VA",
  },
  {
    zip: "24553",
    ST: "VA",
    cityWithStateAbbr: "Gladstone, VA",
  },
  {
    zip: "24554",
    ST: "VA",
    cityWithStateAbbr: "Gladys, VA",
  },
  {
    zip: "24555",
    ST: "VA",
    cityWithStateAbbr: "Glasgow, VA",
  },
  {
    zip: "24556",
    ST: "VA",
    cityWithStateAbbr: "Goode, VA",
  },
  {
    zip: "24557",
    ST: "VA",
    cityWithStateAbbr: "Gretna, VA",
  },
  {
    zip: "24558",
    ST: "VA",
    cityWithStateAbbr: "Halifax, VA",
  },
  {
    zip: "24562",
    ST: "VA",
    cityWithStateAbbr: "Howardsville, VA",
  },
  {
    zip: "24563",
    ST: "VA",
    cityWithStateAbbr: "Hurt, VA",
  },
  {
    zip: "24565",
    ST: "VA",
    cityWithStateAbbr: "Java, VA",
  },
  {
    zip: "24566",
    ST: "VA",
    cityWithStateAbbr: "Keeling, VA",
  },
  {
    zip: "24569",
    ST: "VA",
    cityWithStateAbbr: "Long Island, VA",
  },
  {
    zip: "24570",
    ST: "VA",
    cityWithStateAbbr: "Lowry, VA",
  },
  {
    zip: "24571",
    ST: "VA",
    cityWithStateAbbr: "Lynch Station, VA",
  },
  {
    zip: "24572",
    ST: "VA",
    cityWithStateAbbr: "Madison Heights, VA",
  },
  {
    zip: "24574",
    ST: "VA",
    cityWithStateAbbr: "Monroe, VA",
  },
  {
    zip: "24576",
    ST: "VA",
    cityWithStateAbbr: "Naruna, VA",
  },
  {
    zip: "24577",
    ST: "VA",
    cityWithStateAbbr: "Nathalie, VA",
  },
  {
    zip: "24578",
    ST: "VA",
    cityWithStateAbbr: "Natural Bridge, VA",
  },
  {
    zip: "24579",
    ST: "VA",
    cityWithStateAbbr: "Natural Bridge Station, VA",
  },
  {
    zip: "24580",
    ST: "VA",
    cityWithStateAbbr: "Nelson, VA",
  },
  {
    zip: "24581",
    ST: "VA",
    cityWithStateAbbr: "Norwood, VA",
  },
  {
    zip: "24586",
    ST: "VA",
    cityWithStateAbbr: "Ringgold, VA",
  },
  {
    zip: "24588",
    ST: "VA",
    cityWithStateAbbr: "Rustburg, VA",
  },
  {
    zip: "24589",
    ST: "VA",
    cityWithStateAbbr: "Scottsburg, VA",
  },
  {
    zip: "24590",
    ST: "VA",
    cityWithStateAbbr: "Scottsville, VA",
  },
  {
    zip: "24592",
    ST: "VA",
    cityWithStateAbbr: "South Boston, VA",
  },
  {
    zip: "24593",
    ST: "VA",
    cityWithStateAbbr: "Spout Spring, VA",
  },
  {
    zip: "24594",
    ST: "VA",
    cityWithStateAbbr: "Sutherlin, VA",
  },
  {
    zip: "24595",
    ST: "VA",
    cityWithStateAbbr: "Sweet Briar, VA",
  },
  {
    zip: "24597",
    ST: "VA",
    cityWithStateAbbr: "Vernon Hill, VA",
  },
  {
    zip: "24598",
    ST: "VA",
    cityWithStateAbbr: "Virgilina, VA",
  },
  {
    zip: "24599",
    ST: "VA",
    cityWithStateAbbr: "Wingina, VA",
  },
  {
    zip: "24601",
    ST: "VA",
    cityWithStateAbbr: "Amonate, VA",
  },
  {
    zip: "24602",
    ST: "VA",
    cityWithStateAbbr: "Bandy, VA",
  },
  {
    zip: "24603",
    ST: "VA",
    cityWithStateAbbr: "Big Rock, VA",
  },
  {
    zip: "24604",
    ST: "WV",
    cityWithStateAbbr: "Bishop, WV",
  },
  {
    zip: "24605",
    ST: "VA",
    cityWithStateAbbr: "Bluefield, VA",
  },
  {
    zip: "24606",
    ST: "VA",
    cityWithStateAbbr: "Boissevain, VA",
  },
  {
    zip: "24607",
    ST: "VA",
    cityWithStateAbbr: "Breaks, VA",
  },
  {
    zip: "24608",
    ST: "VA",
    cityWithStateAbbr: "Burkes Garden, VA",
  },
  {
    zip: "24609",
    ST: "VA",
    cityWithStateAbbr: "Cedar Bluff, VA",
  },
  {
    zip: "24612",
    ST: "VA",
    cityWithStateAbbr: "Doran, VA",
  },
  {
    zip: "24613",
    ST: "VA",
    cityWithStateAbbr: "Falls Mills, VA",
  },
  {
    zip: "24614",
    ST: "VA",
    cityWithStateAbbr: "Grundy, VA",
  },
  {
    zip: "24619",
    ST: "VA",
    cityWithStateAbbr: "Horsepen, VA",
  },
  {
    zip: "24620",
    ST: "VA",
    cityWithStateAbbr: "Hurley, VA",
  },
  {
    zip: "24622",
    ST: "VA",
    cityWithStateAbbr: "Jewell Ridge, VA",
  },
  {
    zip: "24624",
    ST: "VA",
    cityWithStateAbbr: "Keen Mountain, VA",
  },
  {
    zip: "24627",
    ST: "VA",
    cityWithStateAbbr: "Mavisdale, VA",
  },
  {
    zip: "24628",
    ST: "VA",
    cityWithStateAbbr: "Maxie, VA",
  },
  {
    zip: "24630",
    ST: "VA",
    cityWithStateAbbr: "North Tazewell, VA",
  },
  {
    zip: "24631",
    ST: "VA",
    cityWithStateAbbr: "Oakwood, VA",
  },
  {
    zip: "24634",
    ST: "VA",
    cityWithStateAbbr: "Pilgrims Knob, VA",
  },
  {
    zip: "24635",
    ST: "VA",
    cityWithStateAbbr: "Pocahontas, VA",
  },
  {
    zip: "24637",
    ST: "VA",
    cityWithStateAbbr: "Pounding Mill, VA",
  },
  {
    zip: "24639",
    ST: "VA",
    cityWithStateAbbr: "Raven, VA",
  },
  {
    zip: "24640",
    ST: "VA",
    cityWithStateAbbr: "Red Ash, VA",
  },
  {
    zip: "24641",
    ST: "VA",
    cityWithStateAbbr: "Richlands, VA",
  },
  {
    zip: "24646",
    ST: "VA",
    cityWithStateAbbr: "Rowe, VA",
  },
  {
    zip: "24647",
    ST: "VA",
    cityWithStateAbbr: "Shortt Gap, VA",
  },
  {
    zip: "24649",
    ST: "VA",
    cityWithStateAbbr: "Swords Creek, VA",
  },
  {
    zip: "24651",
    ST: "VA",
    cityWithStateAbbr: "Tazewell, VA",
  },
  {
    zip: "24656",
    ST: "VA",
    cityWithStateAbbr: "Vansant, VA",
  },
  {
    zip: "24657",
    ST: "VA",
    cityWithStateAbbr: "Whitewood, VA",
  },
  {
    zip: "24658",
    ST: "VA",
    cityWithStateAbbr: "Wolford, VA",
  },
  {
    zip: "24701",
    ST: "WV",
    cityWithStateAbbr: "Bluefield, WV",
  },
  {
    zip: "24712",
    ST: "WV",
    cityWithStateAbbr: "Athens, WV",
  },
  {
    zip: "24714",
    ST: "WV",
    cityWithStateAbbr: "Beeson, WV",
  },
  {
    zip: "24715",
    ST: "WV",
    cityWithStateAbbr: "Bramwell, WV",
  },
  {
    zip: "24716",
    ST: "WV",
    cityWithStateAbbr: "Bud, WV",
  },
  {
    zip: "24719",
    ST: "WV",
    cityWithStateAbbr: "Covel, WV",
  },
  {
    zip: "24724",
    ST: "WV",
    cityWithStateAbbr: "Freeman, WV",
  },
  {
    zip: "24726",
    ST: "WV",
    cityWithStateAbbr: "Herndon, WV",
  },
  {
    zip: "24729",
    ST: "WV",
    cityWithStateAbbr: "Hiawatha, WV",
  },
  {
    zip: "24731",
    ST: "WV",
    cityWithStateAbbr: "Kegley, WV",
  },
  {
    zip: "24732",
    ST: "WV",
    cityWithStateAbbr: "Kellysville, WV",
  },
  {
    zip: "24733",
    ST: "WV",
    cityWithStateAbbr: "Lashmeet, WV",
  },
  {
    zip: "24736",
    ST: "WV",
    cityWithStateAbbr: "Matoaka, WV",
  },
  {
    zip: "24737",
    ST: "WV",
    cityWithStateAbbr: "Montcalm, WV",
  },
  {
    zip: "24738",
    ST: "WV",
    cityWithStateAbbr: "Nemours, WV",
  },
  {
    zip: "24739",
    ST: "WV",
    cityWithStateAbbr: "Princeton, WV",
  },
  {
    zip: "24740",
    ST: "WV",
    cityWithStateAbbr: "Princeton, WV",
  },
  {
    zip: "24747",
    ST: "WV",
    cityWithStateAbbr: "Rock, WV",
  },
  {
    zip: "24751",
    ST: "WV",
    cityWithStateAbbr: "Wolfe, WV",
  },
  {
    zip: "24801",
    ST: "WV",
    cityWithStateAbbr: "Welch, WV",
  },
  {
    zip: "24808",
    ST: "WV",
    cityWithStateAbbr: "Anawalt, WV",
  },
  {
    zip: "24811",
    ST: "WV",
    cityWithStateAbbr: "Avondale, WV",
  },
  {
    zip: "24813",
    ST: "WV",
    cityWithStateAbbr: "Bartley, WV",
  },
  {
    zip: "24815",
    ST: "WV",
    cityWithStateAbbr: "Berwind, WV",
  },
  {
    zip: "24816",
    ST: "WV",
    cityWithStateAbbr: "Big Sandy, WV",
  },
  {
    zip: "24817",
    ST: "WV",
    cityWithStateAbbr: "Bradshaw, WV",
  },
  {
    zip: "24818",
    ST: "WV",
    cityWithStateAbbr: "Brenton, WV",
  },
  {
    zip: "24822",
    ST: "WV",
    cityWithStateAbbr: "Clear Fork, WV",
  },
  {
    zip: "24823",
    ST: "WV",
    cityWithStateAbbr: "Coal Mountain, WV",
  },
  {
    zip: "24824",
    ST: "WV",
    cityWithStateAbbr: "Coalwood, WV",
  },
  {
    zip: "24826",
    ST: "WV",
    cityWithStateAbbr: "Cucumber, WV",
  },
  {
    zip: "24827",
    ST: "WV",
    cityWithStateAbbr: "Cyclone, WV",
  },
  {
    zip: "24828",
    ST: "WV",
    cityWithStateAbbr: "Davy, WV",
  },
  {
    zip: "24829",
    ST: "WV",
    cityWithStateAbbr: "Eckman, WV",
  },
  {
    zip: "24830",
    ST: "WV",
    cityWithStateAbbr: "Elbert, WV",
  },
  {
    zip: "24831",
    ST: "WV",
    cityWithStateAbbr: "Elkhorn, WV",
  },
  {
    zip: "24834",
    ST: "WV",
    cityWithStateAbbr: "Fanrock, WV",
  },
  {
    zip: "24836",
    ST: "WV",
    cityWithStateAbbr: "Gary, WV",
  },
  {
    zip: "24839",
    ST: "WV",
    cityWithStateAbbr: "Hanover, WV",
  },
  {
    zip: "24842",
    ST: "WV",
    cityWithStateAbbr: "Welch, WV",
  },
  {
    zip: "24843",
    ST: "WV",
    cityWithStateAbbr: "Hensley, WV",
  },
  {
    zip: "24844",
    ST: "WV",
    cityWithStateAbbr: "Iaeger, WV",
  },
  {
    zip: "24845",
    ST: "WV",
    cityWithStateAbbr: "Ikes Fork, WV",
  },
  {
    zip: "24846",
    ST: "WV",
    cityWithStateAbbr: "Isaban, WV",
  },
  {
    zip: "24847",
    ST: "WV",
    cityWithStateAbbr: "Itmann, WV",
  },
  {
    zip: "24848",
    ST: "WV",
    cityWithStateAbbr: "Jenkinjones, WV",
  },
  {
    zip: "24849",
    ST: "WV",
    cityWithStateAbbr: "Jesse, WV",
  },
  {
    zip: "24850",
    ST: "WV",
    cityWithStateAbbr: "Jolo, WV",
  },
  {
    zip: "24851",
    ST: "WV",
    cityWithStateAbbr: "Justice, WV",
  },
  {
    zip: "24852",
    ST: "WV",
    cityWithStateAbbr: "Keystone, WV",
  },
  {
    zip: "24853",
    ST: "WV",
    cityWithStateAbbr: "Kimball, WV",
  },
  {
    zip: "24854",
    ST: "WV",
    cityWithStateAbbr: "Kopperston, WV",
  },
  {
    zip: "24855",
    ST: "WV",
    cityWithStateAbbr: "Kyle, WV",
  },
  {
    zip: "24857",
    ST: "WV",
    cityWithStateAbbr: "Lynco, WV",
  },
  {
    zip: "24859",
    ST: "WV",
    cityWithStateAbbr: "Marianna, WV",
  },
  {
    zip: "24860",
    ST: "WV",
    cityWithStateAbbr: "Matheny, WV",
  },
  {
    zip: "24861",
    ST: "WV",
    cityWithStateAbbr: "Maybeury, WV",
  },
  {
    zip: "24862",
    ST: "WV",
    cityWithStateAbbr: "Mohawk, WV",
  },
  {
    zip: "24866",
    ST: "WV",
    cityWithStateAbbr: "Newhall, WV",
  },
  {
    zip: "24867",
    ST: "WV",
    cityWithStateAbbr: "New Richmond, WV",
  },
  {
    zip: "24868",
    ST: "WV",
    cityWithStateAbbr: "Northfork, WV",
  },
  {
    zip: "24869",
    ST: "WV",
    cityWithStateAbbr: "North Spring, WV",
  },
  {
    zip: "24870",
    ST: "WV",
    cityWithStateAbbr: "Oceana, WV",
  },
  {
    zip: "24871",
    ST: "WV",
    cityWithStateAbbr: "Pageton, WV",
  },
  {
    zip: "24872",
    ST: "WV",
    cityWithStateAbbr: "Panther, WV",
  },
  {
    zip: "24873",
    ST: "WV",
    cityWithStateAbbr: "Paynesville, WV",
  },
  {
    zip: "24874",
    ST: "WV",
    cityWithStateAbbr: "Pineville, WV",
  },
  {
    zip: "24878",
    ST: "WV",
    cityWithStateAbbr: "Premier, WV",
  },
  {
    zip: "24879",
    ST: "WV",
    cityWithStateAbbr: "Raysal, WV",
  },
  {
    zip: "24880",
    ST: "WV",
    cityWithStateAbbr: "Rock View, WV",
  },
  {
    zip: "24881",
    ST: "WV",
    cityWithStateAbbr: "Roderfield, WV",
  },
  {
    zip: "24882",
    ST: "WV",
    cityWithStateAbbr: "Simon, WV",
  },
  {
    zip: "24884",
    ST: "WV",
    cityWithStateAbbr: "Squire, WV",
  },
  {
    zip: "24887",
    ST: "WV",
    cityWithStateAbbr: "Switchback, WV",
  },
  {
    zip: "24888",
    ST: "WV",
    cityWithStateAbbr: "Thorpe, WV",
  },
  {
    zip: "24892",
    ST: "WV",
    cityWithStateAbbr: "War, WV",
  },
  {
    zip: "24894",
    ST: "WV",
    cityWithStateAbbr: "Warriormine, WV",
  },
  {
    zip: "24895",
    ST: "WV",
    cityWithStateAbbr: "Wilcoe, WV",
  },
  {
    zip: "24898",
    ST: "WV",
    cityWithStateAbbr: "Wyoming, WV",
  },
  {
    zip: "24899",
    ST: "WV",
    cityWithStateAbbr: "Yukon, WV",
  },
  {
    zip: "24901",
    ST: "WV",
    cityWithStateAbbr: "Lewisburg, WV",
  },
  {
    zip: "24902",
    ST: "WV",
    cityWithStateAbbr: "Fairlea, WV",
  },
  {
    zip: "24910",
    ST: "WV",
    cityWithStateAbbr: "Alderson, WV",
  },
  {
    zip: "24915",
    ST: "WV",
    cityWithStateAbbr: "Arbovale, WV",
  },
  {
    zip: "24916",
    ST: "WV",
    cityWithStateAbbr: "Asbury, WV",
  },
  {
    zip: "24917",
    ST: "WV",
    cityWithStateAbbr: "Auto, WV",
  },
  {
    zip: "24918",
    ST: "WV",
    cityWithStateAbbr: "Ballard, WV",
  },
  {
    zip: "24920",
    ST: "WV",
    cityWithStateAbbr: "Bartow, WV",
  },
  {
    zip: "24924",
    ST: "WV",
    cityWithStateAbbr: "Buckeye, WV",
  },
  {
    zip: "24925",
    ST: "WV",
    cityWithStateAbbr: "Caldwell, WV",
  },
  {
    zip: "24927",
    ST: "WV",
    cityWithStateAbbr: "Cass, WV",
  },
  {
    zip: "24931",
    ST: "WV",
    cityWithStateAbbr: "Crawley, WV",
  },
  {
    zip: "24934",
    ST: "WV",
    cityWithStateAbbr: "Dunmore, WV",
  },
  {
    zip: "24935",
    ST: "WV",
    cityWithStateAbbr: "Forest Hill, WV",
  },
  {
    zip: "24938",
    ST: "WV",
    cityWithStateAbbr: "Frankford, WV",
  },
  {
    zip: "24941",
    ST: "WV",
    cityWithStateAbbr: "Gap Mills, WV",
  },
  {
    zip: "24943",
    ST: "WV",
    cityWithStateAbbr: "Grassy Meadows, WV",
  },
  {
    zip: "24944",
    ST: "WV",
    cityWithStateAbbr: "Green Bank, WV",
  },
  {
    zip: "24945",
    ST: "WV",
    cityWithStateAbbr: "Greenville, WV",
  },
  {
    zip: "24946",
    ST: "WV",
    cityWithStateAbbr: "Hillsboro, WV",
  },
  {
    zip: "24951",
    ST: "WV",
    cityWithStateAbbr: "Lindside, WV",
  },
  {
    zip: "24954",
    ST: "WV",
    cityWithStateAbbr: "Marlinton, WV",
  },
  {
    zip: "24957",
    ST: "WV",
    cityWithStateAbbr: "Maxwelton, WV",
  },
  {
    zip: "24962",
    ST: "WV",
    cityWithStateAbbr: "Pence Springs, WV",
  },
  {
    zip: "24963",
    ST: "WV",
    cityWithStateAbbr: "Peterstown, WV",
  },
  {
    zip: "24966",
    ST: "WV",
    cityWithStateAbbr: "Renick, WV",
  },
  {
    zip: "24970",
    ST: "WV",
    cityWithStateAbbr: "Ronceverte, WV",
  },
  {
    zip: "24974",
    ST: "WV",
    cityWithStateAbbr: "Secondcreek, WV",
  },
  {
    zip: "24976",
    ST: "WV",
    cityWithStateAbbr: "Sinks Grove, WV",
  },
  {
    zip: "24977",
    ST: "WV",
    cityWithStateAbbr: "Smoot, WV",
  },
  {
    zip: "24981",
    ST: "WV",
    cityWithStateAbbr: "Talcott, WV",
  },
  {
    zip: "24983",
    ST: "WV",
    cityWithStateAbbr: "Union, WV",
  },
  {
    zip: "24984",
    ST: "WV",
    cityWithStateAbbr: "Waiteville, WV",
  },
  {
    zip: "24985",
    ST: "WV",
    cityWithStateAbbr: "Wayside, WV",
  },
  {
    zip: "24986",
    ST: "WV",
    cityWithStateAbbr: "White Sulphur Springs, WV",
  },
  {
    zip: "24991",
    ST: "WV",
    cityWithStateAbbr: "Williamsburg, WV",
  },
  {
    zip: "24993",
    ST: "WV",
    cityWithStateAbbr: "Wolfcreek, WV",
  },
  {
    zip: "25002",
    ST: "WV",
    cityWithStateAbbr: "Alloy, WV",
  },
  {
    zip: "25003",
    ST: "WV",
    cityWithStateAbbr: "Alum Creek, WV",
  },
  {
    zip: "25005",
    ST: "WV",
    cityWithStateAbbr: "Amma, WV",
  },
  {
    zip: "25007",
    ST: "WV",
    cityWithStateAbbr: "Arnett, WV",
  },
  {
    zip: "25008",
    ST: "WV",
    cityWithStateAbbr: "Artie, WV",
  },
  {
    zip: "25009",
    ST: "WV",
    cityWithStateAbbr: "Ashford, WV",
  },
  {
    zip: "25011",
    ST: "WV",
    cityWithStateAbbr: "Bancroft, WV",
  },
  {
    zip: "25015",
    ST: "WV",
    cityWithStateAbbr: "Belle, WV",
  },
  {
    zip: "25019",
    ST: "WV",
    cityWithStateAbbr: "Bickmore, WV",
  },
  {
    zip: "25021",
    ST: "WV",
    cityWithStateAbbr: "Bim, WV",
  },
  {
    zip: "25022",
    ST: "WV",
    cityWithStateAbbr: "Blair, WV",
  },
  {
    zip: "25024",
    ST: "WV",
    cityWithStateAbbr: "Bloomingrose, WV",
  },
  {
    zip: "25025",
    ST: "WV",
    cityWithStateAbbr: "Blount, WV",
  },
  {
    zip: "25026",
    ST: "WV",
    cityWithStateAbbr: "Blue Creek, WV",
  },
  {
    zip: "25028",
    ST: "WV",
    cityWithStateAbbr: "Bob White, WV",
  },
  {
    zip: "25030",
    ST: "WV",
    cityWithStateAbbr: "Bomont, WV",
  },
  {
    zip: "25031",
    ST: "WV",
    cityWithStateAbbr: "Boomer, WV",
  },
  {
    zip: "25033",
    ST: "WV",
    cityWithStateAbbr: "Buffalo, WV",
  },
  {
    zip: "25035",
    ST: "WV",
    cityWithStateAbbr: "Cabin Creek, WV",
  },
  {
    zip: "25036",
    ST: "WV",
    cityWithStateAbbr: "Cannelton, WV",
  },
  {
    zip: "25039",
    ST: "WV",
    cityWithStateAbbr: "Cedar Grove, WV",
  },
  {
    zip: "25040",
    ST: "WV",
    cityWithStateAbbr: "Charlton Heights, WV",
  },
  {
    zip: "25043",
    ST: "WV",
    cityWithStateAbbr: "Clay, WV",
  },
  {
    zip: "25044",
    ST: "WV",
    cityWithStateAbbr: "Clear Creek, WV",
  },
  {
    zip: "25045",
    ST: "WV",
    cityWithStateAbbr: "Clendenin, WV",
  },
  {
    zip: "25047",
    ST: "WV",
    cityWithStateAbbr: "Clothier, WV",
  },
  {
    zip: "25048",
    ST: "WV",
    cityWithStateAbbr: "Colcord, WV",
  },
  {
    zip: "25049",
    ST: "WV",
    cityWithStateAbbr: "Comfort, WV",
  },
  {
    zip: "25051",
    ST: "WV",
    cityWithStateAbbr: "Costa, WV",
  },
  {
    zip: "25053",
    ST: "WV",
    cityWithStateAbbr: "Danville, WV",
  },
  {
    zip: "25054",
    ST: "WV",
    cityWithStateAbbr: "Dawes, WV",
  },
  {
    zip: "25057",
    ST: "WV",
    cityWithStateAbbr: "Deep Water, WV",
  },
  {
    zip: "25059",
    ST: "WV",
    cityWithStateAbbr: "Dixie, WV",
  },
  {
    zip: "25060",
    ST: "WV",
    cityWithStateAbbr: "Dorothy, WV",
  },
  {
    zip: "25061",
    ST: "WV",
    cityWithStateAbbr: "Drybranch, WV",
  },
  {
    zip: "25062",
    ST: "WV",
    cityWithStateAbbr: "Dry Creek, WV",
  },
  {
    zip: "25063",
    ST: "WV",
    cityWithStateAbbr: "Duck, WV",
  },
  {
    zip: "25064",
    ST: "WV",
    cityWithStateAbbr: "Dunbar, WV",
  },
  {
    zip: "25067",
    ST: "WV",
    cityWithStateAbbr: "East Bank, WV",
  },
  {
    zip: "25070",
    ST: "WV",
    cityWithStateAbbr: "Eleanor, WV",
  },
  {
    zip: "25071",
    ST: "WV",
    cityWithStateAbbr: "Elkview, WV",
  },
  {
    zip: "25075",
    ST: "WV",
    cityWithStateAbbr: "Eskdale, WV",
  },
  {
    zip: "25076",
    ST: "WV",
    cityWithStateAbbr: "Ethel, WV",
  },
  {
    zip: "25079",
    ST: "WV",
    cityWithStateAbbr: "Falling Rock, WV",
  },
  {
    zip: "25081",
    ST: "WV",
    cityWithStateAbbr: "Foster, WV",
  },
  {
    zip: "25082",
    ST: "WV",
    cityWithStateAbbr: "Fraziers Bottom, WV",
  },
  {
    zip: "25083",
    ST: "WV",
    cityWithStateAbbr: "Gallagher, WV",
  },
  {
    zip: "25085",
    ST: "WV",
    cityWithStateAbbr: "Gauley Bridge, WV",
  },
  {
    zip: "25086",
    ST: "WV",
    cityWithStateAbbr: "Glasgow, WV",
  },
  {
    zip: "25088",
    ST: "WV",
    cityWithStateAbbr: "Glen, WV",
  },
  {
    zip: "25090",
    ST: "WV",
    cityWithStateAbbr: "Glen Ferris, WV",
  },
  {
    zip: "25093",
    ST: "WV",
    cityWithStateAbbr: "Gordon, WV",
  },
  {
    zip: "25102",
    ST: "WV",
    cityWithStateAbbr: "Handley, WV",
  },
  {
    zip: "25103",
    ST: "WV",
    cityWithStateAbbr: "Hansford, WV",
  },
  {
    zip: "25106",
    ST: "WV",
    cityWithStateAbbr: "Henderson, WV",
  },
  {
    zip: "25107",
    ST: "WV",
    cityWithStateAbbr: "Hernshaw, WV",
  },
  {
    zip: "25108",
    ST: "WV",
    cityWithStateAbbr: "Hewett, WV",
  },
  {
    zip: "25109",
    ST: "WV",
    cityWithStateAbbr: "Hometown, WV",
  },
  {
    zip: "25110",
    ST: "WV",
    cityWithStateAbbr: "Hugheston, WV",
  },
  {
    zip: "25111",
    ST: "WV",
    cityWithStateAbbr: "Indore, WV",
  },
  {
    zip: "25112",
    ST: "WV",
    cityWithStateAbbr: "Institute, WV",
  },
  {
    zip: "25113",
    ST: "WV",
    cityWithStateAbbr: "Ivydale, WV",
  },
  {
    zip: "25114",
    ST: "WV",
    cityWithStateAbbr: "Jeffrey, WV",
  },
  {
    zip: "25115",
    ST: "WV",
    cityWithStateAbbr: "Kanawha Falls, WV",
  },
  {
    zip: "25118",
    ST: "WV",
    cityWithStateAbbr: "Kimberly, WV",
  },
  {
    zip: "25119",
    ST: "WV",
    cityWithStateAbbr: "Kincaid, WV",
  },
  {
    zip: "25121",
    ST: "WV",
    cityWithStateAbbr: "Lake, WV",
  },
  {
    zip: "25123",
    ST: "WV",
    cityWithStateAbbr: "Leon, WV",
  },
  {
    zip: "25124",
    ST: "WV",
    cityWithStateAbbr: "Liberty, WV",
  },
  {
    zip: "25125",
    ST: "WV",
    cityWithStateAbbr: "Lizemores, WV",
  },
  {
    zip: "25126",
    ST: "WV",
    cityWithStateAbbr: "London, WV",
  },
  {
    zip: "25130",
    ST: "WV",
    cityWithStateAbbr: "Madison, WV",
  },
  {
    zip: "25132",
    ST: "WV",
    cityWithStateAbbr: "Mammoth, WV",
  },
  {
    zip: "25133",
    ST: "WV",
    cityWithStateAbbr: "Maysel, WV",
  },
  {
    zip: "25134",
    ST: "WV",
    cityWithStateAbbr: "Miami, WV",
  },
  {
    zip: "25136",
    ST: "WV",
    cityWithStateAbbr: "Montgomery, WV",
  },
  {
    zip: "25139",
    ST: "WV",
    cityWithStateAbbr: "Mount Carbon, WV",
  },
  {
    zip: "25140",
    ST: "WV",
    cityWithStateAbbr: "Naoma, WV",
  },
  {
    zip: "25141",
    ST: "WV",
    cityWithStateAbbr: "Nebo, WV",
  },
  {
    zip: "25142",
    ST: "WV",
    cityWithStateAbbr: "Nellis, WV",
  },
  {
    zip: "25143",
    ST: "WV",
    cityWithStateAbbr: "Nitro, WV",
  },
  {
    zip: "25148",
    ST: "WV",
    cityWithStateAbbr: "Orgas, WV",
  },
  {
    zip: "25149",
    ST: "WV",
    cityWithStateAbbr: "Ottawa, WV",
  },
  {
    zip: "25152",
    ST: "WV",
    cityWithStateAbbr: "Page, WV",
  },
  {
    zip: "25154",
    ST: "WV",
    cityWithStateAbbr: "Peytona, WV",
  },
  {
    zip: "25156",
    ST: "WV",
    cityWithStateAbbr: "Pinch, WV",
  },
  {
    zip: "25159",
    ST: "WV",
    cityWithStateAbbr: "Poca, WV",
  },
  {
    zip: "25160",
    ST: "WV",
    cityWithStateAbbr: "Pond Gap, WV",
  },
  {
    zip: "25161",
    ST: "WV",
    cityWithStateAbbr: "Powellton, WV",
  },
  {
    zip: "25162",
    ST: "WV",
    cityWithStateAbbr: "Pratt, WV",
  },
  {
    zip: "25164",
    ST: "WV",
    cityWithStateAbbr: "Procious, WV",
  },
  {
    zip: "25165",
    ST: "WV",
    cityWithStateAbbr: "Racine, WV",
  },
  {
    zip: "25168",
    ST: "WV",
    cityWithStateAbbr: "Red House, WV",
  },
  {
    zip: "25169",
    ST: "WV",
    cityWithStateAbbr: "Ridgeview, WV",
  },
  {
    zip: "25173",
    ST: "WV",
    cityWithStateAbbr: "Robson, WV",
  },
  {
    zip: "25174",
    ST: "WV",
    cityWithStateAbbr: "Rock Creek, WV",
  },
  {
    zip: "25177",
    ST: "WV",
    cityWithStateAbbr: "Saint Albans, WV",
  },
  {
    zip: "25180",
    ST: "WV",
    cityWithStateAbbr: "Saxon, WV",
  },
  {
    zip: "25181",
    ST: "WV",
    cityWithStateAbbr: "Seth, WV",
  },
  {
    zip: "25183",
    ST: "WV",
    cityWithStateAbbr: "Sharples, WV",
  },
  {
    zip: "25185",
    ST: "WV",
    cityWithStateAbbr: "Mount Olive, WV",
  },
  {
    zip: "25186",
    ST: "WV",
    cityWithStateAbbr: "Smithers, WV",
  },
  {
    zip: "25187",
    ST: "WV",
    cityWithStateAbbr: "Southside, WV",
  },
  {
    zip: "25193",
    ST: "WV",
    cityWithStateAbbr: "Sylvester, WV",
  },
  {
    zip: "25201",
    ST: "WV",
    cityWithStateAbbr: "Tad, WV",
  },
  {
    zip: "25202",
    ST: "WV",
    cityWithStateAbbr: "Tornado, WV",
  },
  {
    zip: "25203",
    ST: "WV",
    cityWithStateAbbr: "Turtle Creek, WV",
  },
  {
    zip: "25204",
    ST: "WV",
    cityWithStateAbbr: "Twilight, WV",
  },
  {
    zip: "25205",
    ST: "WV",
    cityWithStateAbbr: "Uneeda, WV",
  },
  {
    zip: "25206",
    ST: "WV",
    cityWithStateAbbr: "Van, WV",
  },
  {
    zip: "25208",
    ST: "WV",
    cityWithStateAbbr: "Wharton, WV",
  },
  {
    zip: "25209",
    ST: "WV",
    cityWithStateAbbr: "Whitesville, WV",
  },
  {
    zip: "25211",
    ST: "WV",
    cityWithStateAbbr: "Widen, WV",
  },
  {
    zip: "25213",
    ST: "WV",
    cityWithStateAbbr: "Winfield, WV",
  },
  {
    zip: "25214",
    ST: "WV",
    cityWithStateAbbr: "Winifrede, WV",
  },
  {
    zip: "25231",
    ST: "WV",
    cityWithStateAbbr: "Advent, WV",
  },
  {
    zip: "25234",
    ST: "WV",
    cityWithStateAbbr: "Arnoldsburg, WV",
  },
  {
    zip: "25235",
    ST: "WV",
    cityWithStateAbbr: "Chloe, WV",
  },
  {
    zip: "25239",
    ST: "WV",
    cityWithStateAbbr: "Cottageville, WV",
  },
  {
    zip: "25241",
    ST: "WV",
    cityWithStateAbbr: "Evans, WV",
  },
  {
    zip: "25243",
    ST: "WV",
    cityWithStateAbbr: "Gandeeville, WV",
  },
  {
    zip: "25244",
    ST: "WV",
    cityWithStateAbbr: "Gay, WV",
  },
  {
    zip: "25245",
    ST: "WV",
    cityWithStateAbbr: "Given, WV",
  },
  {
    zip: "25247",
    ST: "WV",
    cityWithStateAbbr: "Hartford, WV",
  },
  {
    zip: "25248",
    ST: "WV",
    cityWithStateAbbr: "Kenna, WV",
  },
  {
    zip: "25251",
    ST: "WV",
    cityWithStateAbbr: "Left Hand, WV",
  },
  {
    zip: "25252",
    ST: "WV",
    cityWithStateAbbr: "Le Roy, WV",
  },
  {
    zip: "25253",
    ST: "WV",
    cityWithStateAbbr: "Letart, WV",
  },
  {
    zip: "25259",
    ST: "WV",
    cityWithStateAbbr: "Looneyville, WV",
  },
  {
    zip: "25260",
    ST: "WV",
    cityWithStateAbbr: "Mason, WV",
  },
  {
    zip: "25261",
    ST: "WV",
    cityWithStateAbbr: "Millstone, WV",
  },
  {
    zip: "25262",
    ST: "WV",
    cityWithStateAbbr: "Millwood, WV",
  },
  {
    zip: "25264",
    ST: "WV",
    cityWithStateAbbr: "Mount Alto, WV",
  },
  {
    zip: "25265",
    ST: "WV",
    cityWithStateAbbr: "New Haven, WV",
  },
  {
    zip: "25266",
    ST: "WV",
    cityWithStateAbbr: "Newton, WV",
  },
  {
    zip: "25267",
    ST: "WV",
    cityWithStateAbbr: "Normantown, WV",
  },
  {
    zip: "25268",
    ST: "WV",
    cityWithStateAbbr: "Orma, WV",
  },
  {
    zip: "25270",
    ST: "WV",
    cityWithStateAbbr: "Reedy, WV",
  },
  {
    zip: "25271",
    ST: "WV",
    cityWithStateAbbr: "Ripley, WV",
  },
  {
    zip: "25275",
    ST: "WV",
    cityWithStateAbbr: "Sandyville, WV",
  },
  {
    zip: "25276",
    ST: "WV",
    cityWithStateAbbr: "Spencer, WV",
  },
  {
    zip: "25285",
    ST: "WV",
    cityWithStateAbbr: "Wallback, WV",
  },
  {
    zip: "25286",
    ST: "WV",
    cityWithStateAbbr: "Walton, WV",
  },
  {
    zip: "25287",
    ST: "WV",
    cityWithStateAbbr: "West Columbia, WV",
  },
  {
    zip: "25301",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25302",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25303",
    ST: "WV",
    cityWithStateAbbr: "South Charleston, WV",
  },
  {
    zip: "25304",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25305",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25306",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25309",
    ST: "WV",
    cityWithStateAbbr: "South Charleston, WV",
  },
  {
    zip: "25311",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25312",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25313",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25314",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25315",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25317",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25320",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25321",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25322",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25323",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25324",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25325",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25326",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25327",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25328",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25329",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25330",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25331",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25332",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25333",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25334",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25335",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25336",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25337",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25338",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25339",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25350",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25356",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25357",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25358",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25360",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25361",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25362",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25364",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25365",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25375",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25387",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25389",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25392",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25396",
    ST: "WV",
    cityWithStateAbbr: "Charleston, WV",
  },
  {
    zip: "25401",
    ST: "WV",
    cityWithStateAbbr: "Martinsburg, WV",
  },
  {
    zip: "25402",
    ST: "WV",
    cityWithStateAbbr: "Martinsburg, WV",
  },
  {
    zip: "25403",
    ST: "WV",
    cityWithStateAbbr: "Martinsburg, WV",
  },
  {
    zip: "25404",
    ST: "WV",
    cityWithStateAbbr: "Martinsburg, WV",
  },
  {
    zip: "25405",
    ST: "WV",
    cityWithStateAbbr: "Martinsburg, WV",
  },
  {
    zip: "25410",
    ST: "WV",
    cityWithStateAbbr: "Bakerton, WV",
  },
  {
    zip: "25411",
    ST: "WV",
    cityWithStateAbbr: "Berkeley Springs, WV",
  },
  {
    zip: "25413",
    ST: "WV",
    cityWithStateAbbr: "Bunker Hill, WV",
  },
  {
    zip: "25414",
    ST: "WV",
    cityWithStateAbbr: "Charles Town, WV",
  },
  {
    zip: "25419",
    ST: "WV",
    cityWithStateAbbr: "Falling Waters, WV",
  },
  {
    zip: "25420",
    ST: "WV",
    cityWithStateAbbr: "Gerrardstown, WV",
  },
  {
    zip: "25421",
    ST: "WV",
    cityWithStateAbbr: "Glengary, WV",
  },
  {
    zip: "25422",
    ST: "WV",
    cityWithStateAbbr: "Great Cacapon, WV",
  },
  {
    zip: "25423",
    ST: "WV",
    cityWithStateAbbr: "Halltown, WV",
  },
  {
    zip: "25425",
    ST: "WV",
    cityWithStateAbbr: "Harpers Ferry, WV",
  },
  {
    zip: "25427",
    ST: "WV",
    cityWithStateAbbr: "Hedgesville, WV",
  },
  {
    zip: "25428",
    ST: "WV",
    cityWithStateAbbr: "Inwood, WV",
  },
  {
    zip: "25430",
    ST: "WV",
    cityWithStateAbbr: "Kearneysville, WV",
  },
  {
    zip: "25431",
    ST: "WV",
    cityWithStateAbbr: "Levels, WV",
  },
  {
    zip: "25432",
    ST: "WV",
    cityWithStateAbbr: "Millville, WV",
  },
  {
    zip: "25434",
    ST: "WV",
    cityWithStateAbbr: "Paw Paw, WV",
  },
  {
    zip: "25437",
    ST: "WV",
    cityWithStateAbbr: "Points, WV",
  },
  {
    zip: "25438",
    ST: "WV",
    cityWithStateAbbr: "Ranson, WV",
  },
  {
    zip: "25440",
    ST: "WV",
    cityWithStateAbbr: "Ridgeway, WV",
  },
  {
    zip: "25441",
    ST: "WV",
    cityWithStateAbbr: "Rippon, WV",
  },
  {
    zip: "25442",
    ST: "WV",
    cityWithStateAbbr: "Shenandoah Junction, WV",
  },
  {
    zip: "25443",
    ST: "WV",
    cityWithStateAbbr: "Shepherdstown, WV",
  },
  {
    zip: "25444",
    ST: "WV",
    cityWithStateAbbr: "Slanesville, WV",
  },
  {
    zip: "25446",
    ST: "WV",
    cityWithStateAbbr: "Summit Point, WV",
  },
  {
    zip: "25501",
    ST: "WV",
    cityWithStateAbbr: "Alkol, WV",
  },
  {
    zip: "25502",
    ST: "WV",
    cityWithStateAbbr: "Apple Grove, WV",
  },
  {
    zip: "25503",
    ST: "WV",
    cityWithStateAbbr: "Ashton, WV",
  },
  {
    zip: "25504",
    ST: "WV",
    cityWithStateAbbr: "Barboursville, WV",
  },
  {
    zip: "25505",
    ST: "WV",
    cityWithStateAbbr: "Big Creek, WV",
  },
  {
    zip: "25506",
    ST: "WV",
    cityWithStateAbbr: "Branchland, WV",
  },
  {
    zip: "25507",
    ST: "WV",
    cityWithStateAbbr: "Ceredo, WV",
  },
  {
    zip: "25508",
    ST: "WV",
    cityWithStateAbbr: "Chapmanville, WV",
  },
  {
    zip: "25510",
    ST: "WV",
    cityWithStateAbbr: "Culloden, WV",
  },
  {
    zip: "25511",
    ST: "WV",
    cityWithStateAbbr: "Dunlow, WV",
  },
  {
    zip: "25512",
    ST: "WV",
    cityWithStateAbbr: "East Lynn, WV",
  },
  {
    zip: "25514",
    ST: "WV",
    cityWithStateAbbr: "Fort Gay, WV",
  },
  {
    zip: "25515",
    ST: "WV",
    cityWithStateAbbr: "Gallipolis Ferry, WV",
  },
  {
    zip: "25517",
    ST: "WV",
    cityWithStateAbbr: "Genoa, WV",
  },
  {
    zip: "25520",
    ST: "WV",
    cityWithStateAbbr: "Glenwood, WV",
  },
  {
    zip: "25521",
    ST: "WV",
    cityWithStateAbbr: "Griffithsville, WV",
  },
  {
    zip: "25523",
    ST: "WV",
    cityWithStateAbbr: "Hamlin, WV",
  },
  {
    zip: "25524",
    ST: "WV",
    cityWithStateAbbr: "Harts, WV",
  },
  {
    zip: "25526",
    ST: "WV",
    cityWithStateAbbr: "Hurricane, WV",
  },
  {
    zip: "25529",
    ST: "WV",
    cityWithStateAbbr: "Julian, WV",
  },
  {
    zip: "25530",
    ST: "WV",
    cityWithStateAbbr: "Kenova, WV",
  },
  {
    zip: "25534",
    ST: "WV",
    cityWithStateAbbr: "Kiahsville, WV",
  },
  {
    zip: "25535",
    ST: "WV",
    cityWithStateAbbr: "Lavalette, WV",
  },
  {
    zip: "25537",
    ST: "WV",
    cityWithStateAbbr: "Lesage, WV",
  },
  {
    zip: "25540",
    ST: "WV",
    cityWithStateAbbr: "Midkiff, WV",
  },
  {
    zip: "25541",
    ST: "WV",
    cityWithStateAbbr: "Milton, WV",
  },
  {
    zip: "25544",
    ST: "WV",
    cityWithStateAbbr: "Myra, WV",
  },
  {
    zip: "25545",
    ST: "WV",
    cityWithStateAbbr: "Ona, WV",
  },
  {
    zip: "25547",
    ST: "WV",
    cityWithStateAbbr: "Pecks Mill, WV",
  },
  {
    zip: "25550",
    ST: "WV",
    cityWithStateAbbr: "Point Pleasant, WV",
  },
  {
    zip: "25555",
    ST: "WV",
    cityWithStateAbbr: "Prichard, WV",
  },
  {
    zip: "25557",
    ST: "WV",
    cityWithStateAbbr: "Ranger, WV",
  },
  {
    zip: "25559",
    ST: "WV",
    cityWithStateAbbr: "Salt Rock, WV",
  },
  {
    zip: "25560",
    ST: "WV",
    cityWithStateAbbr: "Scott Depot, WV",
  },
  {
    zip: "25562",
    ST: "WV",
    cityWithStateAbbr: "Shoals, WV",
  },
  {
    zip: "25564",
    ST: "WV",
    cityWithStateAbbr: "Sod, WV",
  },
  {
    zip: "25565",
    ST: "WV",
    cityWithStateAbbr: "Spurlockville, WV",
  },
  {
    zip: "25567",
    ST: "WV",
    cityWithStateAbbr: "Sumerco, WV",
  },
  {
    zip: "25569",
    ST: "WV",
    cityWithStateAbbr: "Teays, WV",
  },
  {
    zip: "25570",
    ST: "WV",
    cityWithStateAbbr: "Wayne, WV",
  },
  {
    zip: "25571",
    ST: "WV",
    cityWithStateAbbr: "West Hamlin, WV",
  },
  {
    zip: "25572",
    ST: "WV",
    cityWithStateAbbr: "Woodville, WV",
  },
  {
    zip: "25573",
    ST: "WV",
    cityWithStateAbbr: "Yawkey, WV",
  },
  {
    zip: "25601",
    ST: "WV",
    cityWithStateAbbr: "Logan, WV",
  },
  {
    zip: "25606",
    ST: "WV",
    cityWithStateAbbr: "Accoville, WV",
  },
  {
    zip: "25607",
    ST: "WV",
    cityWithStateAbbr: "Amherstdale, WV",
  },
  {
    zip: "25608",
    ST: "WV",
    cityWithStateAbbr: "Baisden, WV",
  },
  {
    zip: "25611",
    ST: "WV",
    cityWithStateAbbr: "Bruno, WV",
  },
  {
    zip: "25612",
    ST: "WV",
    cityWithStateAbbr: "Chauncey, WV",
  },
  {
    zip: "25614",
    ST: "WV",
    cityWithStateAbbr: "Cora, WV",
  },
  {
    zip: "25617",
    ST: "WV",
    cityWithStateAbbr: "Davin, WV",
  },
  {
    zip: "25621",
    ST: "WV",
    cityWithStateAbbr: "Gilbert, WV",
  },
  {
    zip: "25624",
    ST: "WV",
    cityWithStateAbbr: "Henlawson, WV",
  },
  {
    zip: "25625",
    ST: "WV",
    cityWithStateAbbr: "Holden, WV",
  },
  {
    zip: "25628",
    ST: "WV",
    cityWithStateAbbr: "Kistler, WV",
  },
  {
    zip: "25630",
    ST: "WV",
    cityWithStateAbbr: "Lorado, WV",
  },
  {
    zip: "25632",
    ST: "WV",
    cityWithStateAbbr: "Lyburn, WV",
  },
  {
    zip: "25634",
    ST: "WV",
    cityWithStateAbbr: "Mallory, WV",
  },
  {
    zip: "25635",
    ST: "WV",
    cityWithStateAbbr: "Man, WV",
  },
  {
    zip: "25637",
    ST: "WV",
    cityWithStateAbbr: "Mount Gay, WV",
  },
  {
    zip: "25638",
    ST: "WV",
    cityWithStateAbbr: "Omar, WV",
  },
  {
    zip: "25639",
    ST: "WV",
    cityWithStateAbbr: "Peach Creek, WV",
  },
  {
    zip: "25644",
    ST: "WV",
    cityWithStateAbbr: "Sarah Ann, WV",
  },
  {
    zip: "25646",
    ST: "WV",
    cityWithStateAbbr: "Stollings, WV",
  },
  {
    zip: "25647",
    ST: "WV",
    cityWithStateAbbr: "Switzer, WV",
  },
  {
    zip: "25649",
    ST: "WV",
    cityWithStateAbbr: "Verdunville, WV",
  },
  {
    zip: "25650",
    ST: "WV",
    cityWithStateAbbr: "Verner, WV",
  },
  {
    zip: "25651",
    ST: "WV",
    cityWithStateAbbr: "Wharncliffe, WV",
  },
  {
    zip: "25652",
    ST: "WV",
    cityWithStateAbbr: "Whitman, WV",
  },
  {
    zip: "25653",
    ST: "WV",
    cityWithStateAbbr: "Wilkinson, WV",
  },
  {
    zip: "25654",
    ST: "WV",
    cityWithStateAbbr: "Yolyn, WV",
  },
  {
    zip: "25661",
    ST: "WV",
    cityWithStateAbbr: "Williamson, WV",
  },
  {
    zip: "25665",
    ST: "KY",
    cityWithStateAbbr: "Borderland, KY",
  },
  {
    zip: "25666",
    ST: "WV",
    cityWithStateAbbr: "Breeden, WV",
  },
  {
    zip: "25667",
    ST: "WV",
    cityWithStateAbbr: "Chattaroy, WV",
  },
  {
    zip: "25669",
    ST: "WV",
    cityWithStateAbbr: "Crum, WV",
  },
  {
    zip: "25670",
    ST: "WV",
    cityWithStateAbbr: "Delbarton, WV",
  },
  {
    zip: "25671",
    ST: "WV",
    cityWithStateAbbr: "Dingess, WV",
  },
  {
    zip: "25672",
    ST: "WV",
    cityWithStateAbbr: "Edgarton, WV",
  },
  {
    zip: "25674",
    ST: "WV",
    cityWithStateAbbr: "Kermit, WV",
  },
  {
    zip: "25676",
    ST: "WV",
    cityWithStateAbbr: "Lenore, WV",
  },
  {
    zip: "25678",
    ST: "WV",
    cityWithStateAbbr: "Matewan, WV",
  },
  {
    zip: "25685",
    ST: "WV",
    cityWithStateAbbr: "Naugatuck, WV",
  },
  {
    zip: "25686",
    ST: "WV",
    cityWithStateAbbr: "Newtown, WV",
  },
  {
    zip: "25688",
    ST: "WV",
    cityWithStateAbbr: "North Matewan, WV",
  },
  {
    zip: "25690",
    ST: "WV",
    cityWithStateAbbr: "Ragland, WV",
  },
  {
    zip: "25691",
    ST: "WV",
    cityWithStateAbbr: "Rawl, WV",
  },
  {
    zip: "25692",
    ST: "WV",
    cityWithStateAbbr: "Red Jacket, WV",
  },
  {
    zip: "25696",
    ST: "WV",
    cityWithStateAbbr: "Varney, WV",
  },
  {
    zip: "25699",
    ST: "WV",
    cityWithStateAbbr: "Wilsondale, WV",
  },
  {
    zip: "25701",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25702",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25703",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25704",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25705",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25706",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25707",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25708",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25709",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25710",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25711",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25712",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25713",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25714",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25715",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25716",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25717",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25718",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25719",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25720",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25721",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25722",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25723",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25724",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25725",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25726",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25727",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25728",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25729",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25755",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25770",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25771",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25772",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25773",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25774",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25775",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25776",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25777",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25778",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25779",
    ST: "WV",
    cityWithStateAbbr: "Huntington, WV",
  },
  {
    zip: "25801",
    ST: "WV",
    cityWithStateAbbr: "Beckley, WV",
  },
  {
    zip: "25802",
    ST: "WV",
    cityWithStateAbbr: "Beckley, WV",
  },
  {
    zip: "25810",
    ST: "WV",
    cityWithStateAbbr: "Allen Junction, WV",
  },
  {
    zip: "25811",
    ST: "WV",
    cityWithStateAbbr: "Amigo, WV",
  },
  {
    zip: "25812",
    ST: "WV",
    cityWithStateAbbr: "Ansted, WV",
  },
  {
    zip: "25813",
    ST: "WV",
    cityWithStateAbbr: "Beaver, WV",
  },
  {
    zip: "25817",
    ST: "WV",
    cityWithStateAbbr: "Bolt, WV",
  },
  {
    zip: "25818",
    ST: "WV",
    cityWithStateAbbr: "Bradley, WV",
  },
  {
    zip: "25820",
    ST: "WV",
    cityWithStateAbbr: "Camp Creek, WV",
  },
  {
    zip: "25823",
    ST: "WV",
    cityWithStateAbbr: "Coal City, WV",
  },
  {
    zip: "25825",
    ST: "WV",
    cityWithStateAbbr: "Cool Ridge, WV",
  },
  {
    zip: "25826",
    ST: "WV",
    cityWithStateAbbr: "Corinne, WV",
  },
  {
    zip: "25827",
    ST: "WV",
    cityWithStateAbbr: "Crab Orchard, WV",
  },
  {
    zip: "25831",
    ST: "WV",
    cityWithStateAbbr: "Danese, WV",
  },
  {
    zip: "25832",
    ST: "WV",
    cityWithStateAbbr: "Daniels, WV",
  },
  {
    zip: "25833",
    ST: "WV",
    cityWithStateAbbr: "Dothan, WV",
  },
  {
    zip: "25836",
    ST: "WV",
    cityWithStateAbbr: "Eccles, WV",
  },
  {
    zip: "25837",
    ST: "WV",
    cityWithStateAbbr: "Edmond, WV",
  },
  {
    zip: "25839",
    ST: "WV",
    cityWithStateAbbr: "Fairdale, WV",
  },
  {
    zip: "25840",
    ST: "WV",
    cityWithStateAbbr: "Fayetteville, WV",
  },
  {
    zip: "25841",
    ST: "WV",
    cityWithStateAbbr: "Flat Top, WV",
  },
  {
    zip: "25843",
    ST: "WV",
    cityWithStateAbbr: "Ghent, WV",
  },
  {
    zip: "25844",
    ST: "WV",
    cityWithStateAbbr: "Glen Daniel, WV",
  },
  {
    zip: "25845",
    ST: "WV",
    cityWithStateAbbr: "Glen Fork, WV",
  },
  {
    zip: "25846",
    ST: "WV",
    cityWithStateAbbr: "Glen Jean, WV",
  },
  {
    zip: "25848",
    ST: "WV",
    cityWithStateAbbr: "Glen Rogers, WV",
  },
  {
    zip: "25849",
    ST: "WV",
    cityWithStateAbbr: "Glen White, WV",
  },
  {
    zip: "25851",
    ST: "WV",
    cityWithStateAbbr: "Harper, WV",
  },
  {
    zip: "25853",
    ST: "WV",
    cityWithStateAbbr: "Helen, WV",
  },
  {
    zip: "25854",
    ST: "WV",
    cityWithStateAbbr: "Hico, WV",
  },
  {
    zip: "25855",
    ST: "WV",
    cityWithStateAbbr: "Hilltop, WV",
  },
  {
    zip: "25857",
    ST: "WV",
    cityWithStateAbbr: "Josephine, WV",
  },
  {
    zip: "25860",
    ST: "WV",
    cityWithStateAbbr: "Lanark, WV",
  },
  {
    zip: "25862",
    ST: "WV",
    cityWithStateAbbr: "Lansing, WV",
  },
  {
    zip: "25864",
    ST: "WV",
    cityWithStateAbbr: "Layland, WV",
  },
  {
    zip: "25865",
    ST: "WV",
    cityWithStateAbbr: "Lester, WV",
  },
  {
    zip: "25866",
    ST: "WV",
    cityWithStateAbbr: "Lochgelly, WV",
  },
  {
    zip: "25868",
    ST: "WV",
    cityWithStateAbbr: "Lookout, WV",
  },
  {
    zip: "25870",
    ST: "WV",
    cityWithStateAbbr: "Maben, WV",
  },
  {
    zip: "25871",
    ST: "WV",
    cityWithStateAbbr: "Mabscott, WV",
  },
  {
    zip: "25873",
    ST: "WV",
    cityWithStateAbbr: "Mac Arthur, WV",
  },
  {
    zip: "25875",
    ST: "WV",
    cityWithStateAbbr: "Mc Graws, WV",
  },
  {
    zip: "25876",
    ST: "WV",
    cityWithStateAbbr: "Saulsville, WV",
  },
  {
    zip: "25878",
    ST: "WV",
    cityWithStateAbbr: "Midway, WV",
  },
  {
    zip: "25879",
    ST: "WV",
    cityWithStateAbbr: "Minden, WV",
  },
  {
    zip: "25880",
    ST: "WV",
    cityWithStateAbbr: "Mount Hope, WV",
  },
  {
    zip: "25882",
    ST: "WV",
    cityWithStateAbbr: "Mullens, WV",
  },
  {
    zip: "25901",
    ST: "WV",
    cityWithStateAbbr: "Oak Hill, WV",
  },
  {
    zip: "25902",
    ST: "WV",
    cityWithStateAbbr: "Odd, WV",
  },
  {
    zip: "25904",
    ST: "WV",
    cityWithStateAbbr: "Pax, WV",
  },
  {
    zip: "25906",
    ST: "WV",
    cityWithStateAbbr: "Piney View, WV",
  },
  {
    zip: "25907",
    ST: "WV",
    cityWithStateAbbr: "Prince, WV",
  },
  {
    zip: "25908",
    ST: "WV",
    cityWithStateAbbr: "Princewick, WV",
  },
  {
    zip: "25909",
    ST: "WV",
    cityWithStateAbbr: "Prosperity, WV",
  },
  {
    zip: "25911",
    ST: "WV",
    cityWithStateAbbr: "Raleigh, WV",
  },
  {
    zip: "25913",
    ST: "WV",
    cityWithStateAbbr: "Ravencliff, WV",
  },
  {
    zip: "25915",
    ST: "WV",
    cityWithStateAbbr: "Rhodell, WV",
  },
  {
    zip: "25916",
    ST: "WV",
    cityWithStateAbbr: "Sabine, WV",
  },
  {
    zip: "25917",
    ST: "WV",
    cityWithStateAbbr: "Scarbro, WV",
  },
  {
    zip: "25918",
    ST: "WV",
    cityWithStateAbbr: "Shady Spring, WV",
  },
  {
    zip: "25919",
    ST: "WV",
    cityWithStateAbbr: "Skelton, WV",
  },
  {
    zip: "25920",
    ST: "WV",
    cityWithStateAbbr: "Slab Fork, WV",
  },
  {
    zip: "25921",
    ST: "WV",
    cityWithStateAbbr: "Sophia, WV",
  },
  {
    zip: "25922",
    ST: "WV",
    cityWithStateAbbr: "Spanishburg, WV",
  },
  {
    zip: "25927",
    ST: "WV",
    cityWithStateAbbr: "Stanaford, WV",
  },
  {
    zip: "25928",
    ST: "WV",
    cityWithStateAbbr: "Stephenson, WV",
  },
  {
    zip: "25932",
    ST: "WV",
    cityWithStateAbbr: "Surveyor, WV",
  },
  {
    zip: "25936",
    ST: "WV",
    cityWithStateAbbr: "Thurmond, WV",
  },
  {
    zip: "25938",
    ST: "WV",
    cityWithStateAbbr: "Victor, WV",
  },
  {
    zip: "25942",
    ST: "WV",
    cityWithStateAbbr: "Winona, WV",
  },
  {
    zip: "25943",
    ST: "WV",
    cityWithStateAbbr: "Wyco, WV",
  },
  {
    zip: "25951",
    ST: "WV",
    cityWithStateAbbr: "Hinton, WV",
  },
  {
    zip: "25958",
    ST: "WV",
    cityWithStateAbbr: "Charmco, WV",
  },
  {
    zip: "25962",
    ST: "WV",
    cityWithStateAbbr: "Rainelle, WV",
  },
  {
    zip: "25966",
    ST: "WV",
    cityWithStateAbbr: "Green Sulphur Springs, WV",
  },
  {
    zip: "25969",
    ST: "WV",
    cityWithStateAbbr: "Jumping Branch, WV",
  },
  {
    zip: "25971",
    ST: "WV",
    cityWithStateAbbr: "Lerona, WV",
  },
  {
    zip: "25972",
    ST: "WV",
    cityWithStateAbbr: "Leslie, WV",
  },
  {
    zip: "25976",
    ST: "WV",
    cityWithStateAbbr: "Meadow Bridge, WV",
  },
  {
    zip: "25977",
    ST: "WV",
    cityWithStateAbbr: "Meadow Creek, WV",
  },
  {
    zip: "25978",
    ST: "WV",
    cityWithStateAbbr: "Nimitz, WV",
  },
  {
    zip: "25979",
    ST: "WV",
    cityWithStateAbbr: "Pipestem, WV",
  },
  {
    zip: "25981",
    ST: "WV",
    cityWithStateAbbr: "Quinwood, WV",
  },
  {
    zip: "25984",
    ST: "WV",
    cityWithStateAbbr: "Rupert, WV",
  },
  {
    zip: "25985",
    ST: "WV",
    cityWithStateAbbr: "Sandstone, WV",
  },
  {
    zip: "25986",
    ST: "WV",
    cityWithStateAbbr: "Spring Dale, WV",
  },
  {
    zip: "25989",
    ST: "WV",
    cityWithStateAbbr: "White Oak, WV",
  },
  {
    zip: "26003",
    ST: "WV",
    cityWithStateAbbr: "Wheeling, WV",
  },
  {
    zip: "26030",
    ST: "WV",
    cityWithStateAbbr: "Beech Bottom, WV",
  },
  {
    zip: "26031",
    ST: "WV",
    cityWithStateAbbr: "Benwood, WV",
  },
  {
    zip: "26032",
    ST: "WV",
    cityWithStateAbbr: "Bethany, WV",
  },
  {
    zip: "26033",
    ST: "WV",
    cityWithStateAbbr: "Cameron, WV",
  },
  {
    zip: "26034",
    ST: "WV",
    cityWithStateAbbr: "Chester, WV",
  },
  {
    zip: "26035",
    ST: "WV",
    cityWithStateAbbr: "Colliers, WV",
  },
  {
    zip: "26036",
    ST: "WV",
    cityWithStateAbbr: "Dallas, WV",
  },
  {
    zip: "26037",
    ST: "WV",
    cityWithStateAbbr: "Follansbee, WV",
  },
  {
    zip: "26038",
    ST: "WV",
    cityWithStateAbbr: "Glen Dale, WV",
  },
  {
    zip: "26039",
    ST: "WV",
    cityWithStateAbbr: "Glen Easton, WV",
  },
  {
    zip: "26040",
    ST: "WV",
    cityWithStateAbbr: "Mcmechen, WV",
  },
  {
    zip: "26041",
    ST: "WV",
    cityWithStateAbbr: "Moundsville, WV",
  },
  {
    zip: "26047",
    ST: "WV",
    cityWithStateAbbr: "New Cumberland, WV",
  },
  {
    zip: "26050",
    ST: "WV",
    cityWithStateAbbr: "Newell, WV",
  },
  {
    zip: "26055",
    ST: "WV",
    cityWithStateAbbr: "Proctor, WV",
  },
  {
    zip: "26056",
    ST: "WV",
    cityWithStateAbbr: "New Manchester, WV",
  },
  {
    zip: "26058",
    ST: "WV",
    cityWithStateAbbr: "Short Creek, WV",
  },
  {
    zip: "26059",
    ST: "WV",
    cityWithStateAbbr: "Triadelphia, WV",
  },
  {
    zip: "26060",
    ST: "WV",
    cityWithStateAbbr: "Valley Grove, WV",
  },
  {
    zip: "26062",
    ST: "WV",
    cityWithStateAbbr: "Weirton, WV",
  },
  {
    zip: "26070",
    ST: "WV",
    cityWithStateAbbr: "Wellsburg, WV",
  },
  {
    zip: "26074",
    ST: "WV",
    cityWithStateAbbr: "West Liberty, WV",
  },
  {
    zip: "26075",
    ST: "WV",
    cityWithStateAbbr: "Windsor Heights, WV",
  },
  {
    zip: "26101",
    ST: "WV",
    cityWithStateAbbr: "Parkersburg, WV",
  },
  {
    zip: "26102",
    ST: "WV",
    cityWithStateAbbr: "Parkersburg, WV",
  },
  {
    zip: "26103",
    ST: "WV",
    cityWithStateAbbr: "Parkersburg, WV",
  },
  {
    zip: "26104",
    ST: "WV",
    cityWithStateAbbr: "Parkersburg, WV",
  },
  {
    zip: "26105",
    ST: "WV",
    cityWithStateAbbr: "Vienna, WV",
  },
  {
    zip: "26106",
    ST: "WV",
    cityWithStateAbbr: "Parkersburg, WV",
  },
  {
    zip: "26120",
    ST: "WV",
    cityWithStateAbbr: "Mineral Wells, WV",
  },
  {
    zip: "26121",
    ST: "WV",
    cityWithStateAbbr: "Mineral Wells, WV",
  },
  {
    zip: "26133",
    ST: "WV",
    cityWithStateAbbr: "Belleville, WV",
  },
  {
    zip: "26134",
    ST: "WV",
    cityWithStateAbbr: "Belmont, WV",
  },
  {
    zip: "26136",
    ST: "WV",
    cityWithStateAbbr: "Big Bend, WV",
  },
  {
    zip: "26137",
    ST: "WV",
    cityWithStateAbbr: "Big Springs, WV",
  },
  {
    zip: "26138",
    ST: "WV",
    cityWithStateAbbr: "Brohard, WV",
  },
  {
    zip: "26141",
    ST: "WV",
    cityWithStateAbbr: "Creston, WV",
  },
  {
    zip: "26142",
    ST: "WV",
    cityWithStateAbbr: "Davisville, WV",
  },
  {
    zip: "26143",
    ST: "WV",
    cityWithStateAbbr: "Elizabeth, WV",
  },
  {
    zip: "26146",
    ST: "WV",
    cityWithStateAbbr: "Friendly, WV",
  },
  {
    zip: "26147",
    ST: "WV",
    cityWithStateAbbr: "Grantsville, WV",
  },
  {
    zip: "26148",
    ST: "WV",
    cityWithStateAbbr: "Macfarlan, WV",
  },
  {
    zip: "26149",
    ST: "WV",
    cityWithStateAbbr: "Middlebourne, WV",
  },
  {
    zip: "26150",
    ST: "WV",
    cityWithStateAbbr: "Mineral Wells, WV",
  },
  {
    zip: "26151",
    ST: "WV",
    cityWithStateAbbr: "Mount Zion, WV",
  },
  {
    zip: "26152",
    ST: "WV",
    cityWithStateAbbr: "Munday, WV",
  },
  {
    zip: "26155",
    ST: "WV",
    cityWithStateAbbr: "New Martinsville, WV",
  },
  {
    zip: "26159",
    ST: "WV",
    cityWithStateAbbr: "Paden City, WV",
  },
  {
    zip: "26160",
    ST: "WV",
    cityWithStateAbbr: "Palestine, WV",
  },
  {
    zip: "26161",
    ST: "WV",
    cityWithStateAbbr: "Petroleum, WV",
  },
  {
    zip: "26162",
    ST: "WV",
    cityWithStateAbbr: "Porters Falls, WV",
  },
  {
    zip: "26164",
    ST: "WV",
    cityWithStateAbbr: "Ravenswood, WV",
  },
  {
    zip: "26167",
    ST: "WV",
    cityWithStateAbbr: "Reader, WV",
  },
  {
    zip: "26169",
    ST: "WV",
    cityWithStateAbbr: "Rockport, WV",
  },
  {
    zip: "26170",
    ST: "WV",
    cityWithStateAbbr: "Saint Marys, WV",
  },
  {
    zip: "26175",
    ST: "WV",
    cityWithStateAbbr: "Sistersville, WV",
  },
  {
    zip: "26178",
    ST: "WV",
    cityWithStateAbbr: "Smithville, WV",
  },
  {
    zip: "26180",
    ST: "WV",
    cityWithStateAbbr: "Walker, WV",
  },
  {
    zip: "26181",
    ST: "WV",
    cityWithStateAbbr: "Washington, WV",
  },
  {
    zip: "26184",
    ST: "WV",
    cityWithStateAbbr: "Waverly, WV",
  },
  {
    zip: "26186",
    ST: "WV",
    cityWithStateAbbr: "Wileyville, WV",
  },
  {
    zip: "26187",
    ST: "WV",
    cityWithStateAbbr: "Williamstown, WV",
  },
  {
    zip: "26201",
    ST: "WV",
    cityWithStateAbbr: "Buckhannon, WV",
  },
  {
    zip: "26202",
    ST: "WV",
    cityWithStateAbbr: "Fenwick, WV",
  },
  {
    zip: "26203",
    ST: "WV",
    cityWithStateAbbr: "Erbacon, WV",
  },
  {
    zip: "26205",
    ST: "WV",
    cityWithStateAbbr: "Craigsville, WV",
  },
  {
    zip: "26206",
    ST: "WV",
    cityWithStateAbbr: "Cowen, WV",
  },
  {
    zip: "26208",
    ST: "WV",
    cityWithStateAbbr: "Camden On Gauley, WV",
  },
  {
    zip: "26209",
    ST: "WV",
    cityWithStateAbbr: "Snowshoe, WV",
  },
  {
    zip: "26210",
    ST: "WV",
    cityWithStateAbbr: "Adrian, WV",
  },
  {
    zip: "26215",
    ST: "WV",
    cityWithStateAbbr: "Cleveland, WV",
  },
  {
    zip: "26217",
    ST: "WV",
    cityWithStateAbbr: "Diana, WV",
  },
  {
    zip: "26218",
    ST: "WV",
    cityWithStateAbbr: "French Creek, WV",
  },
  {
    zip: "26219",
    ST: "WV",
    cityWithStateAbbr: "Frenchton, WV",
  },
  {
    zip: "26222",
    ST: "WV",
    cityWithStateAbbr: "Hacker Valley, WV",
  },
  {
    zip: "26224",
    ST: "WV",
    cityWithStateAbbr: "Helvetia, WV",
  },
  {
    zip: "26228",
    ST: "WV",
    cityWithStateAbbr: "Kanawha Head, WV",
  },
  {
    zip: "26229",
    ST: "WV",
    cityWithStateAbbr: "Lorentz, WV",
  },
  {
    zip: "26230",
    ST: "WV",
    cityWithStateAbbr: "Pickens, WV",
  },
  {
    zip: "26234",
    ST: "WV",
    cityWithStateAbbr: "Rock Cave, WV",
  },
  {
    zip: "26236",
    ST: "WV",
    cityWithStateAbbr: "Selbyville, WV",
  },
  {
    zip: "26237",
    ST: "WV",
    cityWithStateAbbr: "Tallmansville, WV",
  },
  {
    zip: "26238",
    ST: "WV",
    cityWithStateAbbr: "Volga, WV",
  },
  {
    zip: "26241",
    ST: "WV",
    cityWithStateAbbr: "Elkins, WV",
  },
  {
    zip: "26250",
    ST: "WV",
    cityWithStateAbbr: "Belington, WV",
  },
  {
    zip: "26253",
    ST: "WV",
    cityWithStateAbbr: "Beverly, WV",
  },
  {
    zip: "26254",
    ST: "WV",
    cityWithStateAbbr: "Bowden, WV",
  },
  {
    zip: "26257",
    ST: "WV",
    cityWithStateAbbr: "Coalton, WV",
  },
  {
    zip: "26259",
    ST: "WV",
    cityWithStateAbbr: "Dailey, WV",
  },
  {
    zip: "26260",
    ST: "WV",
    cityWithStateAbbr: "Davis, WV",
  },
  {
    zip: "26261",
    ST: "WV",
    cityWithStateAbbr: "Richwood, WV",
  },
  {
    zip: "26263",
    ST: "WV",
    cityWithStateAbbr: "Dryfork, WV",
  },
  {
    zip: "26264",
    ST: "WV",
    cityWithStateAbbr: "Durbin, WV",
  },
  {
    zip: "26266",
    ST: "WV",
    cityWithStateAbbr: "Upperglade, WV",
  },
  {
    zip: "26267",
    ST: "WV",
    cityWithStateAbbr: "Ellamore, WV",
  },
  {
    zip: "26268",
    ST: "WV",
    cityWithStateAbbr: "Glady, WV",
  },
  {
    zip: "26269",
    ST: "WV",
    cityWithStateAbbr: "Hambleton, WV",
  },
  {
    zip: "26270",
    ST: "WV",
    cityWithStateAbbr: "Harman, WV",
  },
  {
    zip: "26271",
    ST: "WV",
    cityWithStateAbbr: "Hendricks, WV",
  },
  {
    zip: "26273",
    ST: "WV",
    cityWithStateAbbr: "Huttonsville, WV",
  },
  {
    zip: "26275",
    ST: "WV",
    cityWithStateAbbr: "Junior, WV",
  },
  {
    zip: "26276",
    ST: "WV",
    cityWithStateAbbr: "Kerens, WV",
  },
  {
    zip: "26278",
    ST: "WV",
    cityWithStateAbbr: "Mabie, WV",
  },
  {
    zip: "26280",
    ST: "WV",
    cityWithStateAbbr: "Mill Creek, WV",
  },
  {
    zip: "26282",
    ST: "WV",
    cityWithStateAbbr: "Monterville, WV",
  },
  {
    zip: "26283",
    ST: "WV",
    cityWithStateAbbr: "Montrose, WV",
  },
  {
    zip: "26285",
    ST: "WV",
    cityWithStateAbbr: "Norton, WV",
  },
  {
    zip: "26287",
    ST: "WV",
    cityWithStateAbbr: "Parsons, WV",
  },
  {
    zip: "26288",
    ST: "WV",
    cityWithStateAbbr: "Webster Springs, WV",
  },
  {
    zip: "26289",
    ST: "WV",
    cityWithStateAbbr: "Red Creek, WV",
  },
  {
    zip: "26291",
    ST: "WV",
    cityWithStateAbbr: "Slatyfork, WV",
  },
  {
    zip: "26292",
    ST: "WV",
    cityWithStateAbbr: "Thomas, WV",
  },
  {
    zip: "26293",
    ST: "WV",
    cityWithStateAbbr: "Valley Bend, WV",
  },
  {
    zip: "26294",
    ST: "WV",
    cityWithStateAbbr: "Valley Head, WV",
  },
  {
    zip: "26296",
    ST: "WV",
    cityWithStateAbbr: "Whitmer, WV",
  },
  {
    zip: "26298",
    ST: "WV",
    cityWithStateAbbr: "Bergoo, WV",
  },
  {
    zip: "26301",
    ST: "WV",
    cityWithStateAbbr: "Clarksburg, WV",
  },
  {
    zip: "26302",
    ST: "WV",
    cityWithStateAbbr: "Clarksburg, WV",
  },
  {
    zip: "26306",
    ST: "WV",
    cityWithStateAbbr: "Clarksburg, WV",
  },
  {
    zip: "26320",
    ST: "WV",
    cityWithStateAbbr: "Alma, WV",
  },
  {
    zip: "26321",
    ST: "WV",
    cityWithStateAbbr: "Alum Bridge, WV",
  },
  {
    zip: "26323",
    ST: "WV",
    cityWithStateAbbr: "Anmoore, WV",
  },
  {
    zip: "26325",
    ST: "WV",
    cityWithStateAbbr: "Auburn, WV",
  },
  {
    zip: "26327",
    ST: "WV",
    cityWithStateAbbr: "Berea, WV",
  },
  {
    zip: "26330",
    ST: "WV",
    cityWithStateAbbr: "Bridgeport, WV",
  },
  {
    zip: "26334",
    ST: "WV",
    cityWithStateAbbr: "Brownton, WV",
  },
  {
    zip: "26335",
    ST: "WV",
    cityWithStateAbbr: "Burnsville, WV",
  },
  {
    zip: "26337",
    ST: "WV",
    cityWithStateAbbr: "Cairo, WV",
  },
  {
    zip: "26338",
    ST: "WV",
    cityWithStateAbbr: "Camden, WV",
  },
  {
    zip: "26339",
    ST: "WV",
    cityWithStateAbbr: "Center Point, WV",
  },
  {
    zip: "26342",
    ST: "WV",
    cityWithStateAbbr: "Coxs Mills, WV",
  },
  {
    zip: "26343",
    ST: "WV",
    cityWithStateAbbr: "Crawford, WV",
  },
  {
    zip: "26346",
    ST: "WV",
    cityWithStateAbbr: "Ellenboro, WV",
  },
  {
    zip: "26347",
    ST: "WV",
    cityWithStateAbbr: "Flemington, WV",
  },
  {
    zip: "26348",
    ST: "WV",
    cityWithStateAbbr: "Folsom, WV",
  },
  {
    zip: "26349",
    ST: "WV",
    cityWithStateAbbr: "Galloway, WV",
  },
  {
    zip: "26351",
    ST: "WV",
    cityWithStateAbbr: "Glenville, WV",
  },
  {
    zip: "26354",
    ST: "WV",
    cityWithStateAbbr: "Grafton, WV",
  },
  {
    zip: "26361",
    ST: "WV",
    cityWithStateAbbr: "Gypsy, WV",
  },
  {
    zip: "26362",
    ST: "WV",
    cityWithStateAbbr: "Harrisville, WV",
  },
  {
    zip: "26366",
    ST: "WV",
    cityWithStateAbbr: "Haywood, WV",
  },
  {
    zip: "26369",
    ST: "WV",
    cityWithStateAbbr: "Hepzibah, WV",
  },
  {
    zip: "26372",
    ST: "WV",
    cityWithStateAbbr: "Horner, WV",
  },
  {
    zip: "26374",
    ST: "WV",
    cityWithStateAbbr: "Independence, WV",
  },
  {
    zip: "26376",
    ST: "WV",
    cityWithStateAbbr: "Ireland, WV",
  },
  {
    zip: "26377",
    ST: "WV",
    cityWithStateAbbr: "Jacksonburg, WV",
  },
  {
    zip: "26378",
    ST: "WV",
    cityWithStateAbbr: "Jane Lew, WV",
  },
  {
    zip: "26384",
    ST: "WV",
    cityWithStateAbbr: "Linn, WV",
  },
  {
    zip: "26385",
    ST: "WV",
    cityWithStateAbbr: "Lost Creek, WV",
  },
  {
    zip: "26386",
    ST: "WV",
    cityWithStateAbbr: "Lumberport, WV",
  },
  {
    zip: "26404",
    ST: "WV",
    cityWithStateAbbr: "Meadowbrook, WV",
  },
  {
    zip: "26405",
    ST: "WV",
    cityWithStateAbbr: "Moatsville, WV",
  },
  {
    zip: "26408",
    ST: "WV",
    cityWithStateAbbr: "Mount Clare, WV",
  },
  {
    zip: "26410",
    ST: "WV",
    cityWithStateAbbr: "Newburg, WV",
  },
  {
    zip: "26411",
    ST: "WV",
    cityWithStateAbbr: "New Milton, WV",
  },
  {
    zip: "26412",
    ST: "WV",
    cityWithStateAbbr: "Orlando, WV",
  },
  {
    zip: "26415",
    ST: "WV",
    cityWithStateAbbr: "Pennsboro, WV",
  },
  {
    zip: "26416",
    ST: "WV",
    cityWithStateAbbr: "Philippi, WV",
  },
  {
    zip: "26419",
    ST: "WV",
    cityWithStateAbbr: "Pine Grove, WV",
  },
  {
    zip: "26421",
    ST: "WV",
    cityWithStateAbbr: "Pullman, WV",
  },
  {
    zip: "26422",
    ST: "WV",
    cityWithStateAbbr: "Reynoldsville, WV",
  },
  {
    zip: "26424",
    ST: "WV",
    cityWithStateAbbr: "Rosemont, WV",
  },
  {
    zip: "26425",
    ST: "WV",
    cityWithStateAbbr: "Rowlesburg, WV",
  },
  {
    zip: "26426",
    ST: "WV",
    cityWithStateAbbr: "Salem, WV",
  },
  {
    zip: "26430",
    ST: "WV",
    cityWithStateAbbr: "Sand Fork, WV",
  },
  {
    zip: "26431",
    ST: "WV",
    cityWithStateAbbr: "Shinnston, WV",
  },
  {
    zip: "26434",
    ST: "WV",
    cityWithStateAbbr: "Shirley, WV",
  },
  {
    zip: "26435",
    ST: "WV",
    cityWithStateAbbr: "Simpson, WV",
  },
  {
    zip: "26436",
    ST: "WV",
    cityWithStateAbbr: "Smithburg, WV",
  },
  {
    zip: "26437",
    ST: "WV",
    cityWithStateAbbr: "Smithfield, WV",
  },
  {
    zip: "26438",
    ST: "WV",
    cityWithStateAbbr: "Spelter, WV",
  },
  {
    zip: "26440",
    ST: "WV",
    cityWithStateAbbr: "Thornton, WV",
  },
  {
    zip: "26443",
    ST: "WV",
    cityWithStateAbbr: "Troy, WV",
  },
  {
    zip: "26444",
    ST: "WV",
    cityWithStateAbbr: "Tunnelton, WV",
  },
  {
    zip: "26447",
    ST: "WV",
    cityWithStateAbbr: "Walkersville, WV",
  },
  {
    zip: "26448",
    ST: "WV",
    cityWithStateAbbr: "Wallace, WV",
  },
  {
    zip: "26451",
    ST: "WV",
    cityWithStateAbbr: "West Milford, WV",
  },
  {
    zip: "26452",
    ST: "WV",
    cityWithStateAbbr: "Weston, WV",
  },
  {
    zip: "26456",
    ST: "WV",
    cityWithStateAbbr: "West Union, WV",
  },
  {
    zip: "26463",
    ST: "WV",
    cityWithStateAbbr: "Wyatt, WV",
  },
  {
    zip: "26501",
    ST: "WV",
    cityWithStateAbbr: "Morgantown, WV",
  },
  {
    zip: "26502",
    ST: "WV",
    cityWithStateAbbr: "Morgantown, WV",
  },
  {
    zip: "26504",
    ST: "WV",
    cityWithStateAbbr: "Morgantown, WV",
  },
  {
    zip: "26505",
    ST: "WV",
    cityWithStateAbbr: "Morgantown, WV",
  },
  {
    zip: "26506",
    ST: "WV",
    cityWithStateAbbr: "Morgantown, WV",
  },
  {
    zip: "26507",
    ST: "WV",
    cityWithStateAbbr: "Morgantown, WV",
  },
  {
    zip: "26508",
    ST: "WV",
    cityWithStateAbbr: "Morgantown, WV",
  },
  {
    zip: "26519",
    ST: "WV",
    cityWithStateAbbr: "Albright, WV",
  },
  {
    zip: "26520",
    ST: "WV",
    cityWithStateAbbr: "Arthurdale, WV",
  },
  {
    zip: "26521",
    ST: "WV",
    cityWithStateAbbr: "Blacksville, WV",
  },
  {
    zip: "26524",
    ST: "WV",
    cityWithStateAbbr: "Bretz, WV",
  },
  {
    zip: "26525",
    ST: "WV",
    cityWithStateAbbr: "Bruceton Mills, WV",
  },
  {
    zip: "26527",
    ST: "WV",
    cityWithStateAbbr: "Cassville, WV",
  },
  {
    zip: "26531",
    ST: "WV",
    cityWithStateAbbr: "Dellslow, WV",
  },
  {
    zip: "26534",
    ST: "WV",
    cityWithStateAbbr: "Granville, WV",
  },
  {
    zip: "26537",
    ST: "WV",
    cityWithStateAbbr: "Kingwood, WV",
  },
  {
    zip: "26541",
    ST: "WV",
    cityWithStateAbbr: "Maidsville, WV",
  },
  {
    zip: "26542",
    ST: "WV",
    cityWithStateAbbr: "Masontown, WV",
  },
  {
    zip: "26543",
    ST: "WV",
    cityWithStateAbbr: "Osage, WV",
  },
  {
    zip: "26544",
    ST: "WV",
    cityWithStateAbbr: "Pentress, WV",
  },
  {
    zip: "26546",
    ST: "WV",
    cityWithStateAbbr: "Pursglove, WV",
  },
  {
    zip: "26547",
    ST: "WV",
    cityWithStateAbbr: "Reedsville, WV",
  },
  {
    zip: "26554",
    ST: "WV",
    cityWithStateAbbr: "Fairmont, WV",
  },
  {
    zip: "26555",
    ST: "WV",
    cityWithStateAbbr: "Fairmont, WV",
  },
  {
    zip: "26559",
    ST: "WV",
    cityWithStateAbbr: "Barrackville, WV",
  },
  {
    zip: "26560",
    ST: "WV",
    cityWithStateAbbr: "Baxter, WV",
  },
  {
    zip: "26561",
    ST: "WV",
    cityWithStateAbbr: "Big Run, WV",
  },
  {
    zip: "26562",
    ST: "WV",
    cityWithStateAbbr: "Burton, WV",
  },
  {
    zip: "26563",
    ST: "WV",
    cityWithStateAbbr: "Carolina, WV",
  },
  {
    zip: "26566",
    ST: "WV",
    cityWithStateAbbr: "Colfax, WV",
  },
  {
    zip: "26568",
    ST: "WV",
    cityWithStateAbbr: "Enterprise, WV",
  },
  {
    zip: "26570",
    ST: "WV",
    cityWithStateAbbr: "Fairview, WV",
  },
  {
    zip: "26571",
    ST: "WV",
    cityWithStateAbbr: "Farmington, WV",
  },
  {
    zip: "26572",
    ST: "WV",
    cityWithStateAbbr: "Four States, WV",
  },
  {
    zip: "26574",
    ST: "WV",
    cityWithStateAbbr: "Grant Town, WV",
  },
  {
    zip: "26575",
    ST: "WV",
    cityWithStateAbbr: "Hundred, WV",
  },
  {
    zip: "26576",
    ST: "WV",
    cityWithStateAbbr: "Idamay, WV",
  },
  {
    zip: "26578",
    ST: "WV",
    cityWithStateAbbr: "Kingmont, WV",
  },
  {
    zip: "26581",
    ST: "WV",
    cityWithStateAbbr: "Littleton, WV",
  },
  {
    zip: "26582",
    ST: "WV",
    cityWithStateAbbr: "Mannington, WV",
  },
  {
    zip: "26585",
    ST: "WV",
    cityWithStateAbbr: "Metz, WV",
  },
  {
    zip: "26586",
    ST: "WV",
    cityWithStateAbbr: "Montana Mines, WV",
  },
  {
    zip: "26587",
    ST: "WV",
    cityWithStateAbbr: "Rachel, WV",
  },
  {
    zip: "26588",
    ST: "WV",
    cityWithStateAbbr: "Rivesville, WV",
  },
  {
    zip: "26590",
    ST: "WV",
    cityWithStateAbbr: "Wana, WV",
  },
  {
    zip: "26591",
    ST: "WV",
    cityWithStateAbbr: "Worthington, WV",
  },
  {
    zip: "26601",
    ST: "WV",
    cityWithStateAbbr: "Sutton, WV",
  },
  {
    zip: "26610",
    ST: "WV",
    cityWithStateAbbr: "Birch River, WV",
  },
  {
    zip: "26611",
    ST: "WV",
    cityWithStateAbbr: "Cedarville, WV",
  },
  {
    zip: "26615",
    ST: "WV",
    cityWithStateAbbr: "Copen, WV",
  },
  {
    zip: "26617",
    ST: "WV",
    cityWithStateAbbr: "Dille, WV",
  },
  {
    zip: "26619",
    ST: "WV",
    cityWithStateAbbr: "Exchange, WV",
  },
  {
    zip: "26621",
    ST: "WV",
    cityWithStateAbbr: "Flatwoods, WV",
  },
  {
    zip: "26623",
    ST: "WV",
    cityWithStateAbbr: "Frametown, WV",
  },
  {
    zip: "26624",
    ST: "WV",
    cityWithStateAbbr: "Gassaway, WV",
  },
  {
    zip: "26627",
    ST: "WV",
    cityWithStateAbbr: "Heaters, WV",
  },
  {
    zip: "26629",
    ST: "WV",
    cityWithStateAbbr: "Little Birch, WV",
  },
  {
    zip: "26631",
    ST: "WV",
    cityWithStateAbbr: "Napier, WV",
  },
  {
    zip: "26636",
    ST: "WV",
    cityWithStateAbbr: "Rosedale, WV",
  },
  {
    zip: "26638",
    ST: "WV",
    cityWithStateAbbr: "Shock, WV",
  },
  {
    zip: "26651",
    ST: "WV",
    cityWithStateAbbr: "Summersville, WV",
  },
  {
    zip: "26656",
    ST: "WV",
    cityWithStateAbbr: "Belva, WV",
  },
  {
    zip: "26660",
    ST: "WV",
    cityWithStateAbbr: "Calvin, WV",
  },
  {
    zip: "26662",
    ST: "WV",
    cityWithStateAbbr: "Canvas, WV",
  },
  {
    zip: "26667",
    ST: "WV",
    cityWithStateAbbr: "Drennen, WV",
  },
  {
    zip: "26671",
    ST: "WV",
    cityWithStateAbbr: "Gilboa, WV",
  },
  {
    zip: "26675",
    ST: "WV",
    cityWithStateAbbr: "Keslers Cross Lanes, WV",
  },
  {
    zip: "26676",
    ST: "WV",
    cityWithStateAbbr: "Leivasy, WV",
  },
  {
    zip: "26678",
    ST: "WV",
    cityWithStateAbbr: "Mount Lookout, WV",
  },
  {
    zip: "26679",
    ST: "WV",
    cityWithStateAbbr: "Mount Nebo, WV",
  },
  {
    zip: "26680",
    ST: "WV",
    cityWithStateAbbr: "Nallen, WV",
  },
  {
    zip: "26681",
    ST: "WV",
    cityWithStateAbbr: "Nettie, WV",
  },
  {
    zip: "26684",
    ST: "WV",
    cityWithStateAbbr: "Pool, WV",
  },
  {
    zip: "26690",
    ST: "WV",
    cityWithStateAbbr: "Swiss, WV",
  },
  {
    zip: "26691",
    ST: "WV",
    cityWithStateAbbr: "Tioga, WV",
  },
  {
    zip: "26704",
    ST: "WV",
    cityWithStateAbbr: "Augusta, WV",
  },
  {
    zip: "26705",
    ST: "WV",
    cityWithStateAbbr: "Aurora, WV",
  },
  {
    zip: "26707",
    ST: "WV",
    cityWithStateAbbr: "Bayard, WV",
  },
  {
    zip: "26710",
    ST: "WV",
    cityWithStateAbbr: "Burlington, WV",
  },
  {
    zip: "26711",
    ST: "WV",
    cityWithStateAbbr: "Capon Bridge, WV",
  },
  {
    zip: "26714",
    ST: "WV",
    cityWithStateAbbr: "Delray, WV",
  },
  {
    zip: "26716",
    ST: "WV",
    cityWithStateAbbr: "Eglon, WV",
  },
  {
    zip: "26717",
    ST: "WV",
    cityWithStateAbbr: "Elk Garden, WV",
  },
  {
    zip: "26719",
    ST: "WV",
    cityWithStateAbbr: "Fort Ashby, WV",
  },
  {
    zip: "26720",
    ST: "WV",
    cityWithStateAbbr: "Gormania, WV",
  },
  {
    zip: "26722",
    ST: "WV",
    cityWithStateAbbr: "Green Spring, WV",
  },
  {
    zip: "26726",
    ST: "WV",
    cityWithStateAbbr: "Keyser, WV",
  },
  {
    zip: "26731",
    ST: "WV",
    cityWithStateAbbr: "Lahmansville, WV",
  },
  {
    zip: "26739",
    ST: "WV",
    cityWithStateAbbr: "Mount Storm, WV",
  },
  {
    zip: "26743",
    ST: "WV",
    cityWithStateAbbr: "New Creek, WV",
  },
  {
    zip: "26750",
    ST: "WV",
    cityWithStateAbbr: "Piedmont, WV",
  },
  {
    zip: "26753",
    ST: "WV",
    cityWithStateAbbr: "Ridgeley, WV",
  },
  {
    zip: "26755",
    ST: "WV",
    cityWithStateAbbr: "Rio, WV",
  },
  {
    zip: "26757",
    ST: "WV",
    cityWithStateAbbr: "Romney, WV",
  },
  {
    zip: "26761",
    ST: "WV",
    cityWithStateAbbr: "Shanks, WV",
  },
  {
    zip: "26763",
    ST: "WV",
    cityWithStateAbbr: "Springfield, WV",
  },
  {
    zip: "26764",
    ST: "WV",
    cityWithStateAbbr: "Terra Alta, WV",
  },
  {
    zip: "26767",
    ST: "WV",
    cityWithStateAbbr: "Wiley Ford, WV",
  },
  {
    zip: "26801",
    ST: "WV",
    cityWithStateAbbr: "Baker, WV",
  },
  {
    zip: "26802",
    ST: "WV",
    cityWithStateAbbr: "Brandywine, WV",
  },
  {
    zip: "26804",
    ST: "WV",
    cityWithStateAbbr: "Circleville, WV",
  },
  {
    zip: "26807",
    ST: "WV",
    cityWithStateAbbr: "Franklin, WV",
  },
  {
    zip: "26808",
    ST: "WV",
    cityWithStateAbbr: "High View, WV",
  },
  {
    zip: "26810",
    ST: "WV",
    cityWithStateAbbr: "Lost City, WV",
  },
  {
    zip: "26812",
    ST: "WV",
    cityWithStateAbbr: "Mathias, WV",
  },
  {
    zip: "26814",
    ST: "WV",
    cityWithStateAbbr: "Riverton, WV",
  },
  {
    zip: "26815",
    ST: "WV",
    cityWithStateAbbr: "Sugar Grove, WV",
  },
  {
    zip: "26817",
    ST: "WV",
    cityWithStateAbbr: "Bloomery, WV",
  },
  {
    zip: "26818",
    ST: "WV",
    cityWithStateAbbr: "Fisher, WV",
  },
  {
    zip: "26823",
    ST: "WV",
    cityWithStateAbbr: "Capon Springs, WV",
  },
  {
    zip: "26833",
    ST: "WV",
    cityWithStateAbbr: "Maysville, WV",
  },
  {
    zip: "26836",
    ST: "WV",
    cityWithStateAbbr: "Moorefield, WV",
  },
  {
    zip: "26838",
    ST: "WV",
    cityWithStateAbbr: "Milam, WV",
  },
  {
    zip: "26845",
    ST: "WV",
    cityWithStateAbbr: "Old Fields, WV",
  },
  {
    zip: "26847",
    ST: "WV",
    cityWithStateAbbr: "Petersburg, WV",
  },
  {
    zip: "26851",
    ST: "WV",
    cityWithStateAbbr: "Wardensville, WV",
  },
  {
    zip: "26852",
    ST: "WV",
    cityWithStateAbbr: "Purgitsville, WV",
  },
  {
    zip: "26855",
    ST: "WV",
    cityWithStateAbbr: "Cabins, WV",
  },
  {
    zip: "26865",
    ST: "WV",
    cityWithStateAbbr: "Yellow Spring, WV",
  },
  {
    zip: "26866",
    ST: "WV",
    cityWithStateAbbr: "Upper Tract, WV",
  },
  {
    zip: "26884",
    ST: "WV",
    cityWithStateAbbr: "Seneca Rocks, WV",
  },
  {
    zip: "26886",
    ST: "WV",
    cityWithStateAbbr: "Onego, WV",
  },
  {
    zip: "27006",
    ST: "NC",
    cityWithStateAbbr: "Advance, NC",
  },
  {
    zip: "27007",
    ST: "NC",
    cityWithStateAbbr: "Ararat, NC",
  },
  {
    zip: "27009",
    ST: "NC",
    cityWithStateAbbr: "Belews Creek, NC",
  },
  {
    zip: "27010",
    ST: "NC",
    cityWithStateAbbr: "Bethania, NC",
  },
  {
    zip: "27011",
    ST: "NC",
    cityWithStateAbbr: "Boonville, NC",
  },
  {
    zip: "27012",
    ST: "NC",
    cityWithStateAbbr: "Clemmons, NC",
  },
  {
    zip: "27013",
    ST: "NC",
    cityWithStateAbbr: "Cleveland, NC",
  },
  {
    zip: "27014",
    ST: "NC",
    cityWithStateAbbr: "Cooleemee, NC",
  },
  {
    zip: "27016",
    ST: "NC",
    cityWithStateAbbr: "Danbury, NC",
  },
  {
    zip: "27017",
    ST: "NC",
    cityWithStateAbbr: "Dobson, NC",
  },
  {
    zip: "27018",
    ST: "NC",
    cityWithStateAbbr: "East Bend, NC",
  },
  {
    zip: "27019",
    ST: "NC",
    cityWithStateAbbr: "Germanton, NC",
  },
  {
    zip: "27020",
    ST: "NC",
    cityWithStateAbbr: "Hamptonville, NC",
  },
  {
    zip: "27021",
    ST: "NC",
    cityWithStateAbbr: "King, NC",
  },
  {
    zip: "27022",
    ST: "NC",
    cityWithStateAbbr: "Lawsonville, NC",
  },
  {
    zip: "27023",
    ST: "NC",
    cityWithStateAbbr: "Lewisville, NC",
  },
  {
    zip: "27024",
    ST: "NC",
    cityWithStateAbbr: "Lowgap, NC",
  },
  {
    zip: "27025",
    ST: "NC",
    cityWithStateAbbr: "Madison, NC",
  },
  {
    zip: "27027",
    ST: "NC",
    cityWithStateAbbr: "Mayodan, NC",
  },
  {
    zip: "27028",
    ST: "NC",
    cityWithStateAbbr: "Mocksville, NC",
  },
  {
    zip: "27030",
    ST: "NC",
    cityWithStateAbbr: "Mount Airy, NC",
  },
  {
    zip: "27031",
    ST: "NC",
    cityWithStateAbbr: "Mount Airy, NC",
  },
  {
    zip: "27040",
    ST: "NC",
    cityWithStateAbbr: "Pfafftown, NC",
  },
  {
    zip: "27041",
    ST: "NC",
    cityWithStateAbbr: "Pilot Mountain, NC",
  },
  {
    zip: "27042",
    ST: "NC",
    cityWithStateAbbr: "Pine Hall, NC",
  },
  {
    zip: "27043",
    ST: "NC",
    cityWithStateAbbr: "Pinnacle, NC",
  },
  {
    zip: "27045",
    ST: "NC",
    cityWithStateAbbr: "Rural Hall, NC",
  },
  {
    zip: "27046",
    ST: "NC",
    cityWithStateAbbr: "Sandy Ridge, NC",
  },
  {
    zip: "27047",
    ST: "NC",
    cityWithStateAbbr: "Siloam, NC",
  },
  {
    zip: "27048",
    ST: "NC",
    cityWithStateAbbr: "Stoneville, NC",
  },
  {
    zip: "27049",
    ST: "NC",
    cityWithStateAbbr: "Toast, NC",
  },
  {
    zip: "27050",
    ST: "NC",
    cityWithStateAbbr: "Tobaccoville, NC",
  },
  {
    zip: "27051",
    ST: "NC",
    cityWithStateAbbr: "Walkertown, NC",
  },
  {
    zip: "27052",
    ST: "NC",
    cityWithStateAbbr: "Walnut Cove, NC",
  },
  {
    zip: "27053",
    ST: "NC",
    cityWithStateAbbr: "Westfield, NC",
  },
  {
    zip: "27054",
    ST: "NC",
    cityWithStateAbbr: "Woodleaf, NC",
  },
  {
    zip: "27055",
    ST: "NC",
    cityWithStateAbbr: "Yadkinville, NC",
  },
  {
    zip: "27094",
    ST: "NC",
    cityWithStateAbbr: "Rural Hall, NC",
  },
  {
    zip: "27098",
    ST: "NC",
    cityWithStateAbbr: "Rural Hall, NC",
  },
  {
    zip: "27099",
    ST: "NC",
    cityWithStateAbbr: "Rural Hall, NC",
  },
  {
    zip: "27101",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27102",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27103",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27104",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27105",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27106",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27107",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27108",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27109",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27110",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27111",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27113",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27114",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27115",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27116",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27117",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27120",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27127",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27130",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27150",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27152",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27155",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27157",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27199",
    ST: "NC",
    cityWithStateAbbr: "Winston Salem, NC",
  },
  {
    zip: "27201",
    ST: "NC",
    cityWithStateAbbr: "Alamance, NC",
  },
  {
    zip: "27202",
    ST: "NC",
    cityWithStateAbbr: "Altamahaw, NC",
  },
  {
    zip: "27203",
    ST: "NC",
    cityWithStateAbbr: "Asheboro, NC",
  },
  {
    zip: "27204",
    ST: "NC",
    cityWithStateAbbr: "Asheboro, NC",
  },
  {
    zip: "27205",
    ST: "NC",
    cityWithStateAbbr: "Asheboro, NC",
  },
  {
    zip: "27207",
    ST: "NC",
    cityWithStateAbbr: "Bear Creek, NC",
  },
  {
    zip: "27208",
    ST: "NC",
    cityWithStateAbbr: "Bennett, NC",
  },
  {
    zip: "27209",
    ST: "NC",
    cityWithStateAbbr: "Biscoe, NC",
  },
  {
    zip: "27212",
    ST: "NC",
    cityWithStateAbbr: "Blanch, NC",
  },
  {
    zip: "27213",
    ST: "NC",
    cityWithStateAbbr: "Bonlee, NC",
  },
  {
    zip: "27214",
    ST: "NC",
    cityWithStateAbbr: "Browns Summit, NC",
  },
  {
    zip: "27215",
    ST: "NC",
    cityWithStateAbbr: "Burlington, NC",
  },
  {
    zip: "27216",
    ST: "NC",
    cityWithStateAbbr: "Burlington, NC",
  },
  {
    zip: "27217",
    ST: "NC",
    cityWithStateAbbr: "Burlington, NC",
  },
  {
    zip: "27228",
    ST: "NC",
    cityWithStateAbbr: "Bynum, NC",
  },
  {
    zip: "27229",
    ST: "NC",
    cityWithStateAbbr: "Candor, NC",
  },
  {
    zip: "27230",
    ST: "NC",
    cityWithStateAbbr: "Cedar Falls, NC",
  },
  {
    zip: "27231",
    ST: "NC",
    cityWithStateAbbr: "Cedar Grove, NC",
  },
  {
    zip: "27233",
    ST: "NC",
    cityWithStateAbbr: "Climax, NC",
  },
  {
    zip: "27235",
    ST: "NC",
    cityWithStateAbbr: "Colfax, NC",
  },
  {
    zip: "27237",
    ST: "NC",
    cityWithStateAbbr: "Cumnock, NC",
  },
  {
    zip: "27239",
    ST: "NC",
    cityWithStateAbbr: "Denton, NC",
  },
  {
    zip: "27242",
    ST: "NC",
    cityWithStateAbbr: "Eagle Springs, NC",
  },
  {
    zip: "27243",
    ST: "NC",
    cityWithStateAbbr: "Efland, NC",
  },
  {
    zip: "27244",
    ST: "NC",
    cityWithStateAbbr: "Elon, NC",
  },
  {
    zip: "27247",
    ST: "NC",
    cityWithStateAbbr: "Ether, NC",
  },
  {
    zip: "27248",
    ST: "NC",
    cityWithStateAbbr: "Franklinville, NC",
  },
  {
    zip: "27249",
    ST: "NC",
    cityWithStateAbbr: "Gibsonville, NC",
  },
  {
    zip: "27252",
    ST: "NC",
    cityWithStateAbbr: "Goldston, NC",
  },
  {
    zip: "27253",
    ST: "NC",
    cityWithStateAbbr: "Graham, NC",
  },
  {
    zip: "27256",
    ST: "NC",
    cityWithStateAbbr: "Gulf, NC",
  },
  {
    zip: "27258",
    ST: "NC",
    cityWithStateAbbr: "Haw River, NC",
  },
  {
    zip: "27259",
    ST: "NC",
    cityWithStateAbbr: "Highfalls, NC",
  },
  {
    zip: "27260",
    ST: "NC",
    cityWithStateAbbr: "High Point, NC",
  },
  {
    zip: "27261",
    ST: "NC",
    cityWithStateAbbr: "High Point, NC",
  },
  {
    zip: "27262",
    ST: "NC",
    cityWithStateAbbr: "High Point, NC",
  },
  {
    zip: "27263",
    ST: "NC",
    cityWithStateAbbr: "High Point, NC",
  },
  {
    zip: "27264",
    ST: "NC",
    cityWithStateAbbr: "High Point, NC",
  },
  {
    zip: "27265",
    ST: "NC",
    cityWithStateAbbr: "High Point, NC",
  },
  {
    zip: "27278",
    ST: "NC",
    cityWithStateAbbr: "Hillsborough, NC",
  },
  {
    zip: "27281",
    ST: "NC",
    cityWithStateAbbr: "Jackson Springs, NC",
  },
  {
    zip: "27282",
    ST: "NC",
    cityWithStateAbbr: "Jamestown, NC",
  },
  {
    zip: "27283",
    ST: "NC",
    cityWithStateAbbr: "Julian, NC",
  },
  {
    zip: "27284",
    ST: "NC",
    cityWithStateAbbr: "Kernersville, NC",
  },
  {
    zip: "27285",
    ST: "NC",
    cityWithStateAbbr: "Kernersville, NC",
  },
  {
    zip: "27288",
    ST: "NC",
    cityWithStateAbbr: "Eden, NC",
  },
  {
    zip: "27289",
    ST: "NC",
    cityWithStateAbbr: "Eden, NC",
  },
  {
    zip: "27291",
    ST: "NC",
    cityWithStateAbbr: "Leasburg, NC",
  },
  {
    zip: "27292",
    ST: "NC",
    cityWithStateAbbr: "Lexington, NC",
  },
  {
    zip: "27293",
    ST: "NC",
    cityWithStateAbbr: "Lexington, NC",
  },
  {
    zip: "27294",
    ST: "NC",
    cityWithStateAbbr: "Lexington, NC",
  },
  {
    zip: "27295",
    ST: "NC",
    cityWithStateAbbr: "Lexington, NC",
  },
  {
    zip: "27298",
    ST: "NC",
    cityWithStateAbbr: "Liberty, NC",
  },
  {
    zip: "27299",
    ST: "NC",
    cityWithStateAbbr: "Linwood, NC",
  },
  {
    zip: "27301",
    ST: "NC",
    cityWithStateAbbr: "Mc Leansville, NC",
  },
  {
    zip: "27302",
    ST: "NC",
    cityWithStateAbbr: "Mebane, NC",
  },
  {
    zip: "27305",
    ST: "NC",
    cityWithStateAbbr: "Milton, NC",
  },
  {
    zip: "27306",
    ST: "NC",
    cityWithStateAbbr: "Mount Gilead, NC",
  },
  {
    zip: "27310",
    ST: "NC",
    cityWithStateAbbr: "Oak Ridge, NC",
  },
  {
    zip: "27311",
    ST: "NC",
    cityWithStateAbbr: "Pelham, NC",
  },
  {
    zip: "27312",
    ST: "NC",
    cityWithStateAbbr: "Pittsboro, NC",
  },
  {
    zip: "27313",
    ST: "NC",
    cityWithStateAbbr: "Pleasant Garden, NC",
  },
  {
    zip: "27314",
    ST: "NC",
    cityWithStateAbbr: "Prospect Hill, NC",
  },
  {
    zip: "27315",
    ST: "NC",
    cityWithStateAbbr: "Providence, NC",
  },
  {
    zip: "27316",
    ST: "NC",
    cityWithStateAbbr: "Ramseur, NC",
  },
  {
    zip: "27317",
    ST: "NC",
    cityWithStateAbbr: "Randleman, NC",
  },
  {
    zip: "27320",
    ST: "NC",
    cityWithStateAbbr: "Reidsville, NC",
  },
  {
    zip: "27323",
    ST: "NC",
    cityWithStateAbbr: "Reidsville, NC",
  },
  {
    zip: "27325",
    ST: "NC",
    cityWithStateAbbr: "Robbins, NC",
  },
  {
    zip: "27326",
    ST: "NC",
    cityWithStateAbbr: "Ruffin, NC",
  },
  {
    zip: "27330",
    ST: "NC",
    cityWithStateAbbr: "Sanford, NC",
  },
  {
    zip: "27331",
    ST: "NC",
    cityWithStateAbbr: "Sanford, NC",
  },
  {
    zip: "27332",
    ST: "NC",
    cityWithStateAbbr: "Sanford, NC",
  },
  {
    zip: "27340",
    ST: "NC",
    cityWithStateAbbr: "Saxapahaw, NC",
  },
  {
    zip: "27341",
    ST: "NC",
    cityWithStateAbbr: "Seagrove, NC",
  },
  {
    zip: "27342",
    ST: "NC",
    cityWithStateAbbr: "Sedalia, NC",
  },
  {
    zip: "27343",
    ST: "NC",
    cityWithStateAbbr: "Semora, NC",
  },
  {
    zip: "27344",
    ST: "NC",
    cityWithStateAbbr: "Siler City, NC",
  },
  {
    zip: "27349",
    ST: "NC",
    cityWithStateAbbr: "Snow Camp, NC",
  },
  {
    zip: "27350",
    ST: "NC",
    cityWithStateAbbr: "Sophia, NC",
  },
  {
    zip: "27351",
    ST: "NC",
    cityWithStateAbbr: "Southmont, NC",
  },
  {
    zip: "27355",
    ST: "NC",
    cityWithStateAbbr: "Staley, NC",
  },
  {
    zip: "27356",
    ST: "NC",
    cityWithStateAbbr: "Star, NC",
  },
  {
    zip: "27357",
    ST: "NC",
    cityWithStateAbbr: "Stokesdale, NC",
  },
  {
    zip: "27358",
    ST: "NC",
    cityWithStateAbbr: "Summerfield, NC",
  },
  {
    zip: "27359",
    ST: "NC",
    cityWithStateAbbr: "Swepsonville, NC",
  },
  {
    zip: "27360",
    ST: "NC",
    cityWithStateAbbr: "Thomasville, NC",
  },
  {
    zip: "27361",
    ST: "NC",
    cityWithStateAbbr: "Thomasville, NC",
  },
  {
    zip: "27370",
    ST: "NC",
    cityWithStateAbbr: "Trinity, NC",
  },
  {
    zip: "27371",
    ST: "NC",
    cityWithStateAbbr: "Troy, NC",
  },
  {
    zip: "27373",
    ST: "NC",
    cityWithStateAbbr: "Wallburg, NC",
  },
  {
    zip: "27374",
    ST: "NC",
    cityWithStateAbbr: "Welcome, NC",
  },
  {
    zip: "27375",
    ST: "NC",
    cityWithStateAbbr: "Wentworth, NC",
  },
  {
    zip: "27376",
    ST: "NC",
    cityWithStateAbbr: "West End, NC",
  },
  {
    zip: "27377",
    ST: "NC",
    cityWithStateAbbr: "Whitsett, NC",
  },
  {
    zip: "27379",
    ST: "NC",
    cityWithStateAbbr: "Yanceyville, NC",
  },
  {
    zip: "27401",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27402",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27403",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27404",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27405",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27406",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27407",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27408",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27409",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27410",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27411",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27412",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27413",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27415",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27416",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27417",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27419",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27420",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27425",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27427",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27429",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27435",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27438",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27455",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27495",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27497",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27498",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27499",
    ST: "NC",
    cityWithStateAbbr: "Greensboro, NC",
  },
  {
    zip: "27501",
    ST: "NC",
    cityWithStateAbbr: "Angier, NC",
  },
  {
    zip: "27502",
    ST: "NC",
    cityWithStateAbbr: "Apex, NC",
  },
  {
    zip: "27503",
    ST: "NC",
    cityWithStateAbbr: "Bahama, NC",
  },
  {
    zip: "27504",
    ST: "NC",
    cityWithStateAbbr: "Benson, NC",
  },
  {
    zip: "27505",
    ST: "NC",
    cityWithStateAbbr: "Broadway, NC",
  },
  {
    zip: "27506",
    ST: "NC",
    cityWithStateAbbr: "Buies Creek, NC",
  },
  {
    zip: "27507",
    ST: "NC",
    cityWithStateAbbr: "Bullock, NC",
  },
  {
    zip: "27508",
    ST: "NC",
    cityWithStateAbbr: "Bunn, NC",
  },
  {
    zip: "27509",
    ST: "NC",
    cityWithStateAbbr: "Butner, NC",
  },
  {
    zip: "27510",
    ST: "NC",
    cityWithStateAbbr: "Carrboro, NC",
  },
  {
    zip: "27511",
    ST: "NC",
    cityWithStateAbbr: "Cary, NC",
  },
  {
    zip: "27512",
    ST: "NC",
    cityWithStateAbbr: "Cary, NC",
  },
  {
    zip: "27513",
    ST: "NC",
    cityWithStateAbbr: "Cary, NC",
  },
  {
    zip: "27514",
    ST: "NC",
    cityWithStateAbbr: "Chapel Hill, NC",
  },
  {
    zip: "27515",
    ST: "NC",
    cityWithStateAbbr: "Chapel Hill, NC",
  },
  {
    zip: "27516",
    ST: "NC",
    cityWithStateAbbr: "Chapel Hill, NC",
  },
  {
    zip: "27517",
    ST: "NC",
    cityWithStateAbbr: "Chapel Hill, NC",
  },
  {
    zip: "27518",
    ST: "NC",
    cityWithStateAbbr: "Cary, NC",
  },
  {
    zip: "27519",
    ST: "NC",
    cityWithStateAbbr: "Cary, NC",
  },
  {
    zip: "27520",
    ST: "NC",
    cityWithStateAbbr: "Clayton, NC",
  },
  {
    zip: "27521",
    ST: "NC",
    cityWithStateAbbr: "Coats, NC",
  },
  {
    zip: "27522",
    ST: "NC",
    cityWithStateAbbr: "Creedmoor, NC",
  },
  {
    zip: "27523",
    ST: "NC",
    cityWithStateAbbr: "Apex, NC",
  },
  {
    zip: "27524",
    ST: "NC",
    cityWithStateAbbr: "Four Oaks, NC",
  },
  {
    zip: "27525",
    ST: "NC",
    cityWithStateAbbr: "Franklinton, NC",
  },
  {
    zip: "27526",
    ST: "NC",
    cityWithStateAbbr: "Fuquay Varina, NC",
  },
  {
    zip: "27527",
    ST: "NC",
    cityWithStateAbbr: "Clayton, NC",
  },
  {
    zip: "27528",
    ST: "NC",
    cityWithStateAbbr: "Clayton, NC",
  },
  {
    zip: "27529",
    ST: "NC",
    cityWithStateAbbr: "Garner, NC",
  },
  {
    zip: "27530",
    ST: "NC",
    cityWithStateAbbr: "Goldsboro, NC",
  },
  {
    zip: "27531",
    ST: "NC",
    cityWithStateAbbr: "Goldsboro, NC",
  },
  {
    zip: "27532",
    ST: "NC",
    cityWithStateAbbr: "Goldsboro, NC",
  },
  {
    zip: "27533",
    ST: "NC",
    cityWithStateAbbr: "Goldsboro, NC",
  },
  {
    zip: "27534",
    ST: "NC",
    cityWithStateAbbr: "Goldsboro, NC",
  },
  {
    zip: "27536",
    ST: "NC",
    cityWithStateAbbr: "Henderson, NC",
  },
  {
    zip: "27537",
    ST: "NC",
    cityWithStateAbbr: "Henderson, NC",
  },
  {
    zip: "27539",
    ST: "NC",
    cityWithStateAbbr: "Apex, NC",
  },
  {
    zip: "27540",
    ST: "NC",
    cityWithStateAbbr: "Holly Springs, NC",
  },
  {
    zip: "27541",
    ST: "NC",
    cityWithStateAbbr: "Hurdle Mills, NC",
  },
  {
    zip: "27542",
    ST: "NC",
    cityWithStateAbbr: "Kenly, NC",
  },
  {
    zip: "27543",
    ST: "NC",
    cityWithStateAbbr: "Kipling, NC",
  },
  {
    zip: "27544",
    ST: "NC",
    cityWithStateAbbr: "Kittrell, NC",
  },
  {
    zip: "27545",
    ST: "NC",
    cityWithStateAbbr: "Knightdale, NC",
  },
  {
    zip: "27546",
    ST: "NC",
    cityWithStateAbbr: "Lillington, NC",
  },
  {
    zip: "27549",
    ST: "NC",
    cityWithStateAbbr: "Louisburg, NC",
  },
  {
    zip: "27551",
    ST: "NC",
    cityWithStateAbbr: "Macon, NC",
  },
  {
    zip: "27552",
    ST: "NC",
    cityWithStateAbbr: "Mamers, NC",
  },
  {
    zip: "27553",
    ST: "NC",
    cityWithStateAbbr: "Manson, NC",
  },
  {
    zip: "27555",
    ST: "NC",
    cityWithStateAbbr: "Micro, NC",
  },
  {
    zip: "27556",
    ST: "NC",
    cityWithStateAbbr: "Middleburg, NC",
  },
  {
    zip: "27557",
    ST: "NC",
    cityWithStateAbbr: "Middlesex, NC",
  },
  {
    zip: "27559",
    ST: "NC",
    cityWithStateAbbr: "Moncure, NC",
  },
  {
    zip: "27560",
    ST: "NC",
    cityWithStateAbbr: "Morrisville, NC",
  },
  {
    zip: "27562",
    ST: "NC",
    cityWithStateAbbr: "New Hill, NC",
  },
  {
    zip: "27563",
    ST: "NC",
    cityWithStateAbbr: "Norlina, NC",
  },
  {
    zip: "27564",
    ST: "NC",
    cityWithStateAbbr: "Creedmoor, NC",
  },
  {
    zip: "27565",
    ST: "NC",
    cityWithStateAbbr: "Oxford, NC",
  },
  {
    zip: "27568",
    ST: "NC",
    cityWithStateAbbr: "Pine Level, NC",
  },
  {
    zip: "27569",
    ST: "NC",
    cityWithStateAbbr: "Princeton, NC",
  },
  {
    zip: "27570",
    ST: "NC",
    cityWithStateAbbr: "Ridgeway, NC",
  },
  {
    zip: "27571",
    ST: "NC",
    cityWithStateAbbr: "Rolesville, NC",
  },
  {
    zip: "27572",
    ST: "NC",
    cityWithStateAbbr: "Rougemont, NC",
  },
  {
    zip: "27573",
    ST: "NC",
    cityWithStateAbbr: "Roxboro, NC",
  },
  {
    zip: "27574",
    ST: "NC",
    cityWithStateAbbr: "Roxboro, NC",
  },
  {
    zip: "27576",
    ST: "NC",
    cityWithStateAbbr: "Selma, NC",
  },
  {
    zip: "27577",
    ST: "NC",
    cityWithStateAbbr: "Smithfield, NC",
  },
  {
    zip: "27581",
    ST: "NC",
    cityWithStateAbbr: "Stem, NC",
  },
  {
    zip: "27582",
    ST: "NC",
    cityWithStateAbbr: "Stovall, NC",
  },
  {
    zip: "27583",
    ST: "NC",
    cityWithStateAbbr: "Timberlake, NC",
  },
  {
    zip: "27584",
    ST: "NC",
    cityWithStateAbbr: "Townsville, NC",
  },
  {
    zip: "27586",
    ST: "NC",
    cityWithStateAbbr: "Vaughan, NC",
  },
  {
    zip: "27587",
    ST: "NC",
    cityWithStateAbbr: "Wake Forest, NC",
  },
  {
    zip: "27588",
    ST: "NC",
    cityWithStateAbbr: "Wake Forest, NC",
  },
  {
    zip: "27589",
    ST: "NC",
    cityWithStateAbbr: "Warrenton, NC",
  },
  {
    zip: "27591",
    ST: "NC",
    cityWithStateAbbr: "Wendell, NC",
  },
  {
    zip: "27592",
    ST: "NC",
    cityWithStateAbbr: "Willow Spring, NC",
  },
  {
    zip: "27593",
    ST: "NC",
    cityWithStateAbbr: "Wilsons Mills, NC",
  },
  {
    zip: "27594",
    ST: "NC",
    cityWithStateAbbr: "Wise, NC",
  },
  {
    zip: "27596",
    ST: "NC",
    cityWithStateAbbr: "Youngsville, NC",
  },
  {
    zip: "27597",
    ST: "NC",
    cityWithStateAbbr: "Zebulon, NC",
  },
  {
    zip: "27599",
    ST: "NC",
    cityWithStateAbbr: "Chapel Hill, NC",
  },
  {
    zip: "27601",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27602",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27603",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27604",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27605",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27606",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27607",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27608",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27609",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27610",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27611",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27612",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27613",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27614",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27615",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27616",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27617",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27619",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27620",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27621",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27622",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27623",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27624",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27625",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27626",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27627",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27628",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27629",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27634",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27635",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27636",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27640",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27650",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27656",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27658",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27661",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27668",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27675",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27676",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27690",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27695",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27697",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27698",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27699",
    ST: "NC",
    cityWithStateAbbr: "Raleigh, NC",
  },
  {
    zip: "27701",
    ST: "NC",
    cityWithStateAbbr: "Durham, NC",
  },
  {
    zip: "27702",
    ST: "NC",
    cityWithStateAbbr: "Durham, NC",
  },
  {
    zip: "27703",
    ST: "NC",
    cityWithStateAbbr: "Durham, NC",
  },
  {
    zip: "27704",
    ST: "NC",
    cityWithStateAbbr: "Durham, NC",
  },
  {
    zip: "27705",
    ST: "NC",
    cityWithStateAbbr: "Durham, NC",
  },
  {
    zip: "27706",
    ST: "NC",
    cityWithStateAbbr: "Durham, NC",
  },
  {
    zip: "27707",
    ST: "NC",
    cityWithStateAbbr: "Durham, NC",
  },
  {
    zip: "27708",
    ST: "NC",
    cityWithStateAbbr: "Durham, NC",
  },
  {
    zip: "27709",
    ST: "NC",
    cityWithStateAbbr: "Durham, NC",
  },
  {
    zip: "27710",
    ST: "NC",
    cityWithStateAbbr: "Durham, NC",
  },
  {
    zip: "27711",
    ST: "NC",
    cityWithStateAbbr: "Durham, NC",
  },
  {
    zip: "27712",
    ST: "NC",
    cityWithStateAbbr: "Durham, NC",
  },
  {
    zip: "27713",
    ST: "NC",
    cityWithStateAbbr: "Durham, NC",
  },
  {
    zip: "27715",
    ST: "NC",
    cityWithStateAbbr: "Durham, NC",
  },
  {
    zip: "27717",
    ST: "NC",
    cityWithStateAbbr: "Durham, NC",
  },
  {
    zip: "27722",
    ST: "NC",
    cityWithStateAbbr: "Durham, NC",
  },
  {
    zip: "27801",
    ST: "NC",
    cityWithStateAbbr: "Rocky Mount, NC",
  },
  {
    zip: "27802",
    ST: "NC",
    cityWithStateAbbr: "Rocky Mount, NC",
  },
  {
    zip: "27803",
    ST: "NC",
    cityWithStateAbbr: "Rocky Mount, NC",
  },
  {
    zip: "27804",
    ST: "NC",
    cityWithStateAbbr: "Rocky Mount, NC",
  },
  {
    zip: "27805",
    ST: "NC",
    cityWithStateAbbr: "Aulander, NC",
  },
  {
    zip: "27806",
    ST: "NC",
    cityWithStateAbbr: "Aurora, NC",
  },
  {
    zip: "27807",
    ST: "NC",
    cityWithStateAbbr: "Bailey, NC",
  },
  {
    zip: "27808",
    ST: "NC",
    cityWithStateAbbr: "Bath, NC",
  },
  {
    zip: "27809",
    ST: "NC",
    cityWithStateAbbr: "Battleboro, NC",
  },
  {
    zip: "27810",
    ST: "NC",
    cityWithStateAbbr: "Belhaven, NC",
  },
  {
    zip: "27811",
    ST: "NC",
    cityWithStateAbbr: "Bellarthur, NC",
  },
  {
    zip: "27812",
    ST: "NC",
    cityWithStateAbbr: "Bethel, NC",
  },
  {
    zip: "27813",
    ST: "NC",
    cityWithStateAbbr: "Black Creek, NC",
  },
  {
    zip: "27814",
    ST: "NC",
    cityWithStateAbbr: "Blounts Creek, NC",
  },
  {
    zip: "27815",
    ST: "NC",
    cityWithStateAbbr: "Rocky Mount, NC",
  },
  {
    zip: "27816",
    ST: "NC",
    cityWithStateAbbr: "Castalia, NC",
  },
  {
    zip: "27817",
    ST: "NC",
    cityWithStateAbbr: "Chocowinity, NC",
  },
  {
    zip: "27818",
    ST: "NC",
    cityWithStateAbbr: "Como, NC",
  },
  {
    zip: "27819",
    ST: "NC",
    cityWithStateAbbr: "Conetoe, NC",
  },
  {
    zip: "27820",
    ST: "NC",
    cityWithStateAbbr: "Conway, NC",
  },
  {
    zip: "27821",
    ST: "NC",
    cityWithStateAbbr: "Edward, NC",
  },
  {
    zip: "27822",
    ST: "NC",
    cityWithStateAbbr: "Elm City, NC",
  },
  {
    zip: "27823",
    ST: "NC",
    cityWithStateAbbr: "Enfield, NC",
  },
  {
    zip: "27824",
    ST: "NC",
    cityWithStateAbbr: "Engelhard, NC",
  },
  {
    zip: "27825",
    ST: "NC",
    cityWithStateAbbr: "Everetts, NC",
  },
  {
    zip: "27826",
    ST: "NC",
    cityWithStateAbbr: "Fairfield, NC",
  },
  {
    zip: "27827",
    ST: "NC",
    cityWithStateAbbr: "Falkland, NC",
  },
  {
    zip: "27828",
    ST: "NC",
    cityWithStateAbbr: "Farmville, NC",
  },
  {
    zip: "27829",
    ST: "NC",
    cityWithStateAbbr: "Fountain, NC",
  },
  {
    zip: "27830",
    ST: "NC",
    cityWithStateAbbr: "Fremont, NC",
  },
  {
    zip: "27831",
    ST: "NC",
    cityWithStateAbbr: "Garysburg, NC",
  },
  {
    zip: "27832",
    ST: "NC",
    cityWithStateAbbr: "Gaston, NC",
  },
  {
    zip: "27833",
    ST: "NC",
    cityWithStateAbbr: "Greenville, NC",
  },
  {
    zip: "27834",
    ST: "NC",
    cityWithStateAbbr: "Greenville, NC",
  },
  {
    zip: "27835",
    ST: "NC",
    cityWithStateAbbr: "Greenville, NC",
  },
  {
    zip: "27836",
    ST: "NC",
    cityWithStateAbbr: "Greenville, NC",
  },
  {
    zip: "27837",
    ST: "NC",
    cityWithStateAbbr: "Grimesland, NC",
  },
  {
    zip: "27838",
    ST: "NC",
    cityWithStateAbbr: "Gumberry, NC",
  },
  {
    zip: "27839",
    ST: "NC",
    cityWithStateAbbr: "Halifax, NC",
  },
  {
    zip: "27840",
    ST: "NC",
    cityWithStateAbbr: "Hamilton, NC",
  },
  {
    zip: "27841",
    ST: "NC",
    cityWithStateAbbr: "Hassell, NC",
  },
  {
    zip: "27842",
    ST: "NC",
    cityWithStateAbbr: "Henrico, NC",
  },
  {
    zip: "27843",
    ST: "NC",
    cityWithStateAbbr: "Hobgood, NC",
  },
  {
    zip: "27844",
    ST: "NC",
    cityWithStateAbbr: "Hollister, NC",
  },
  {
    zip: "27845",
    ST: "NC",
    cityWithStateAbbr: "Jackson, NC",
  },
  {
    zip: "27846",
    ST: "NC",
    cityWithStateAbbr: "Jamesville, NC",
  },
  {
    zip: "27847",
    ST: "NC",
    cityWithStateAbbr: "Kelford, NC",
  },
  {
    zip: "27849",
    ST: "NC",
    cityWithStateAbbr: "Lewiston Woodville, NC",
  },
  {
    zip: "27850",
    ST: "NC",
    cityWithStateAbbr: "Littleton, NC",
  },
  {
    zip: "27851",
    ST: "NC",
    cityWithStateAbbr: "Lucama, NC",
  },
  {
    zip: "27852",
    ST: "NC",
    cityWithStateAbbr: "Macclesfield, NC",
  },
  {
    zip: "27853",
    ST: "NC",
    cityWithStateAbbr: "Margarettsville, NC",
  },
  {
    zip: "27855",
    ST: "NC",
    cityWithStateAbbr: "Murfreesboro, NC",
  },
  {
    zip: "27856",
    ST: "NC",
    cityWithStateAbbr: "Nashville, NC",
  },
  {
    zip: "27857",
    ST: "NC",
    cityWithStateAbbr: "Oak City, NC",
  },
  {
    zip: "27858",
    ST: "NC",
    cityWithStateAbbr: "Greenville, NC",
  },
  {
    zip: "27860",
    ST: "NC",
    cityWithStateAbbr: "Pantego, NC",
  },
  {
    zip: "27861",
    ST: "NC",
    cityWithStateAbbr: "Parmele, NC",
  },
  {
    zip: "27862",
    ST: "NC",
    cityWithStateAbbr: "Pendleton, NC",
  },
  {
    zip: "27863",
    ST: "NC",
    cityWithStateAbbr: "Pikeville, NC",
  },
  {
    zip: "27864",
    ST: "NC",
    cityWithStateAbbr: "Pinetops, NC",
  },
  {
    zip: "27865",
    ST: "NC",
    cityWithStateAbbr: "Pinetown, NC",
  },
  {
    zip: "27866",
    ST: "NC",
    cityWithStateAbbr: "Pleasant Hill, NC",
  },
  {
    zip: "27867",
    ST: "NC",
    cityWithStateAbbr: "Potecasi, NC",
  },
  {
    zip: "27868",
    ST: "NC",
    cityWithStateAbbr: "Red Oak, NC",
  },
  {
    zip: "27869",
    ST: "NC",
    cityWithStateAbbr: "Rich Square, NC",
  },
  {
    zip: "27870",
    ST: "NC",
    cityWithStateAbbr: "Roanoke Rapids, NC",
  },
  {
    zip: "27871",
    ST: "NC",
    cityWithStateAbbr: "Robersonville, NC",
  },
  {
    zip: "27872",
    ST: "NC",
    cityWithStateAbbr: "Roxobel, NC",
  },
  {
    zip: "27873",
    ST: "NC",
    cityWithStateAbbr: "Saratoga, NC",
  },
  {
    zip: "27874",
    ST: "NC",
    cityWithStateAbbr: "Scotland Neck, NC",
  },
  {
    zip: "27875",
    ST: "NC",
    cityWithStateAbbr: "Scranton, NC",
  },
  {
    zip: "27876",
    ST: "NC",
    cityWithStateAbbr: "Seaboard, NC",
  },
  {
    zip: "27877",
    ST: "NC",
    cityWithStateAbbr: "Severn, NC",
  },
  {
    zip: "27878",
    ST: "NC",
    cityWithStateAbbr: "Sharpsburg, NC",
  },
  {
    zip: "27879",
    ST: "NC",
    cityWithStateAbbr: "Simpson, NC",
  },
  {
    zip: "27880",
    ST: "NC",
    cityWithStateAbbr: "Sims, NC",
  },
  {
    zip: "27881",
    ST: "NC",
    cityWithStateAbbr: "Speed, NC",
  },
  {
    zip: "27882",
    ST: "NC",
    cityWithStateAbbr: "Spring Hope, NC",
  },
  {
    zip: "27883",
    ST: "NC",
    cityWithStateAbbr: "Stantonsburg, NC",
  },
  {
    zip: "27884",
    ST: "NC",
    cityWithStateAbbr: "Stokes, NC",
  },
  {
    zip: "27885",
    ST: "NC",
    cityWithStateAbbr: "Swanquarter, NC",
  },
  {
    zip: "27886",
    ST: "NC",
    cityWithStateAbbr: "Tarboro, NC",
  },
  {
    zip: "27887",
    ST: "NC",
    cityWithStateAbbr: "Tillery, NC",
  },
  {
    zip: "27888",
    ST: "NC",
    cityWithStateAbbr: "Walstonburg, NC",
  },
  {
    zip: "27889",
    ST: "NC",
    cityWithStateAbbr: "Washington, NC",
  },
  {
    zip: "27890",
    ST: "NC",
    cityWithStateAbbr: "Weldon, NC",
  },
  {
    zip: "27891",
    ST: "NC",
    cityWithStateAbbr: "Whitakers, NC",
  },
  {
    zip: "27892",
    ST: "NC",
    cityWithStateAbbr: "Williamston, NC",
  },
  {
    zip: "27893",
    ST: "NC",
    cityWithStateAbbr: "Wilson, NC",
  },
  {
    zip: "27894",
    ST: "NC",
    cityWithStateAbbr: "Wilson, NC",
  },
  {
    zip: "27895",
    ST: "NC",
    cityWithStateAbbr: "Wilson, NC",
  },
  {
    zip: "27896",
    ST: "NC",
    cityWithStateAbbr: "Wilson, NC",
  },
  {
    zip: "27897",
    ST: "NC",
    cityWithStateAbbr: "Woodland, NC",
  },
  {
    zip: "27906",
    ST: "NC",
    cityWithStateAbbr: "Elizabeth City, NC",
  },
  {
    zip: "27907",
    ST: "NC",
    cityWithStateAbbr: "Elizabeth City, NC",
  },
  {
    zip: "27909",
    ST: "NC",
    cityWithStateAbbr: "Elizabeth City, NC",
  },
  {
    zip: "27910",
    ST: "NC",
    cityWithStateAbbr: "Ahoskie, NC",
  },
  {
    zip: "27915",
    ST: "NC",
    cityWithStateAbbr: "Avon, NC",
  },
  {
    zip: "27916",
    ST: "NC",
    cityWithStateAbbr: "Aydlett, NC",
  },
  {
    zip: "27917",
    ST: "NC",
    cityWithStateAbbr: "Barco, NC",
  },
  {
    zip: "27919",
    ST: "NC",
    cityWithStateAbbr: "Belvidere, NC",
  },
  {
    zip: "27920",
    ST: "NC",
    cityWithStateAbbr: "Buxton, NC",
  },
  {
    zip: "27921",
    ST: "NC",
    cityWithStateAbbr: "Camden, NC",
  },
  {
    zip: "27922",
    ST: "NC",
    cityWithStateAbbr: "Cofield, NC",
  },
  {
    zip: "27923",
    ST: "NC",
    cityWithStateAbbr: "Coinjock, NC",
  },
  {
    zip: "27924",
    ST: "NC",
    cityWithStateAbbr: "Colerain, NC",
  },
  {
    zip: "27925",
    ST: "NC",
    cityWithStateAbbr: "Columbia, NC",
  },
  {
    zip: "27926",
    ST: "NC",
    cityWithStateAbbr: "Corapeake, NC",
  },
  {
    zip: "27927",
    ST: "NC",
    cityWithStateAbbr: "Corolla, NC",
  },
  {
    zip: "27928",
    ST: "NC",
    cityWithStateAbbr: "Creswell, NC",
  },
  {
    zip: "27929",
    ST: "NC",
    cityWithStateAbbr: "Currituck, NC",
  },
  {
    zip: "27930",
    ST: "NC",
    cityWithStateAbbr: "Hertford, NC",
  },
  {
    zip: "27932",
    ST: "NC",
    cityWithStateAbbr: "Edenton, NC",
  },
  {
    zip: "27935",
    ST: "NC",
    cityWithStateAbbr: "Eure, NC",
  },
  {
    zip: "27936",
    ST: "NC",
    cityWithStateAbbr: "Frisco, NC",
  },
  {
    zip: "27937",
    ST: "NC",
    cityWithStateAbbr: "Gates, NC",
  },
  {
    zip: "27938",
    ST: "NC",
    cityWithStateAbbr: "Gatesville, NC",
  },
  {
    zip: "27939",
    ST: "NC",
    cityWithStateAbbr: "Grandy, NC",
  },
  {
    zip: "27941",
    ST: "NC",
    cityWithStateAbbr: "Harbinger, NC",
  },
  {
    zip: "27942",
    ST: "NC",
    cityWithStateAbbr: "Harrellsville, NC",
  },
  {
    zip: "27943",
    ST: "NC",
    cityWithStateAbbr: "Hatteras, NC",
  },
  {
    zip: "27944",
    ST: "NC",
    cityWithStateAbbr: "Hertford, NC",
  },
  {
    zip: "27946",
    ST: "NC",
    cityWithStateAbbr: "Hobbsville, NC",
  },
  {
    zip: "27947",
    ST: "NC",
    cityWithStateAbbr: "Jarvisburg, NC",
  },
  {
    zip: "27948",
    ST: "NC",
    cityWithStateAbbr: "Kill Devil Hills, NC",
  },
  {
    zip: "27949",
    ST: "NC",
    cityWithStateAbbr: "Kitty Hawk, NC",
  },
  {
    zip: "27950",
    ST: "NC",
    cityWithStateAbbr: "Knotts Island, NC",
  },
  {
    zip: "27953",
    ST: "NC",
    cityWithStateAbbr: "Manns Harbor, NC",
  },
  {
    zip: "27954",
    ST: "NC",
    cityWithStateAbbr: "Manteo, NC",
  },
  {
    zip: "27956",
    ST: "NC",
    cityWithStateAbbr: "Maple, NC",
  },
  {
    zip: "27957",
    ST: "NC",
    cityWithStateAbbr: "Merry Hill, NC",
  },
  {
    zip: "27958",
    ST: "NC",
    cityWithStateAbbr: "Moyock, NC",
  },
  {
    zip: "27959",
    ST: "NC",
    cityWithStateAbbr: "Nags Head, NC",
  },
  {
    zip: "27960",
    ST: "NC",
    cityWithStateAbbr: "Ocracoke, NC",
  },
  {
    zip: "27962",
    ST: "NC",
    cityWithStateAbbr: "Plymouth, NC",
  },
  {
    zip: "27964",
    ST: "NC",
    cityWithStateAbbr: "Point Harbor, NC",
  },
  {
    zip: "27965",
    ST: "NC",
    cityWithStateAbbr: "Poplar Branch, NC",
  },
  {
    zip: "27966",
    ST: "NC",
    cityWithStateAbbr: "Powells Point, NC",
  },
  {
    zip: "27967",
    ST: "NC",
    cityWithStateAbbr: "Powellsville, NC",
  },
  {
    zip: "27968",
    ST: "NC",
    cityWithStateAbbr: "Rodanthe, NC",
  },
  {
    zip: "27969",
    ST: "NC",
    cityWithStateAbbr: "Roduco, NC",
  },
  {
    zip: "27970",
    ST: "NC",
    cityWithStateAbbr: "Roper, NC",
  },
  {
    zip: "27972",
    ST: "NC",
    cityWithStateAbbr: "Salvo, NC",
  },
  {
    zip: "27973",
    ST: "NC",
    cityWithStateAbbr: "Shawboro, NC",
  },
  {
    zip: "27974",
    ST: "NC",
    cityWithStateAbbr: "Shiloh, NC",
  },
  {
    zip: "27976",
    ST: "NC",
    cityWithStateAbbr: "South Mills, NC",
  },
  {
    zip: "27978",
    ST: "NC",
    cityWithStateAbbr: "Stumpy Point, NC",
  },
  {
    zip: "27979",
    ST: "NC",
    cityWithStateAbbr: "Sunbury, NC",
  },
  {
    zip: "27980",
    ST: "NC",
    cityWithStateAbbr: "Tyner, NC",
  },
  {
    zip: "27981",
    ST: "NC",
    cityWithStateAbbr: "Wanchese, NC",
  },
  {
    zip: "27982",
    ST: "NC",
    cityWithStateAbbr: "Waves, NC",
  },
  {
    zip: "27983",
    ST: "NC",
    cityWithStateAbbr: "Windsor, NC",
  },
  {
    zip: "27985",
    ST: "NC",
    cityWithStateAbbr: "Winfall, NC",
  },
  {
    zip: "27986",
    ST: "NC",
    cityWithStateAbbr: "Winton, NC",
  },
  {
    zip: "28001",
    ST: "NC",
    cityWithStateAbbr: "Albemarle, NC",
  },
  {
    zip: "28002",
    ST: "NC",
    cityWithStateAbbr: "Albemarle, NC",
  },
  {
    zip: "28006",
    ST: "NC",
    cityWithStateAbbr: "Alexis, NC",
  },
  {
    zip: "28007",
    ST: "NC",
    cityWithStateAbbr: "Ansonville, NC",
  },
  {
    zip: "28009",
    ST: "NC",
    cityWithStateAbbr: "Badin, NC",
  },
  {
    zip: "28010",
    ST: "NC",
    cityWithStateAbbr: "Barium Springs, NC",
  },
  {
    zip: "28012",
    ST: "NC",
    cityWithStateAbbr: "Belmont, NC",
  },
  {
    zip: "28016",
    ST: "NC",
    cityWithStateAbbr: "Bessemer City, NC",
  },
  {
    zip: "28017",
    ST: "NC",
    cityWithStateAbbr: "Boiling Springs, NC",
  },
  {
    zip: "28018",
    ST: "NC",
    cityWithStateAbbr: "Bostic, NC",
  },
  {
    zip: "28019",
    ST: "NC",
    cityWithStateAbbr: "Caroleen, NC",
  },
  {
    zip: "28020",
    ST: "NC",
    cityWithStateAbbr: "Casar, NC",
  },
  {
    zip: "28021",
    ST: "NC",
    cityWithStateAbbr: "Cherryville, NC",
  },
  {
    zip: "28023",
    ST: "NC",
    cityWithStateAbbr: "China Grove, NC",
  },
  {
    zip: "28024",
    ST: "NC",
    cityWithStateAbbr: "Cliffside, NC",
  },
  {
    zip: "28025",
    ST: "NC",
    cityWithStateAbbr: "Concord, NC",
  },
  {
    zip: "28026",
    ST: "NC",
    cityWithStateAbbr: "Concord, NC",
  },
  {
    zip: "28027",
    ST: "NC",
    cityWithStateAbbr: "Concord, NC",
  },
  {
    zip: "28031",
    ST: "NC",
    cityWithStateAbbr: "Cornelius, NC",
  },
  {
    zip: "28032",
    ST: "NC",
    cityWithStateAbbr: "Cramerton, NC",
  },
  {
    zip: "28033",
    ST: "NC",
    cityWithStateAbbr: "Crouse, NC",
  },
  {
    zip: "28034",
    ST: "NC",
    cityWithStateAbbr: "Dallas, NC",
  },
  {
    zip: "28035",
    ST: "NC",
    cityWithStateAbbr: "Davidson, NC",
  },
  {
    zip: "28036",
    ST: "NC",
    cityWithStateAbbr: "Davidson, NC",
  },
  {
    zip: "28037",
    ST: "NC",
    cityWithStateAbbr: "Denver, NC",
  },
  {
    zip: "28038",
    ST: "NC",
    cityWithStateAbbr: "Earl, NC",
  },
  {
    zip: "28039",
    ST: "NC",
    cityWithStateAbbr: "East Spencer, NC",
  },
  {
    zip: "28040",
    ST: "NC",
    cityWithStateAbbr: "Ellenboro, NC",
  },
  {
    zip: "28041",
    ST: "NC",
    cityWithStateAbbr: "Faith, NC",
  },
  {
    zip: "28042",
    ST: "NC",
    cityWithStateAbbr: "Fallston, NC",
  },
  {
    zip: "28043",
    ST: "NC",
    cityWithStateAbbr: "Forest City, NC",
  },
  {
    zip: "28052",
    ST: "NC",
    cityWithStateAbbr: "Gastonia, NC",
  },
  {
    zip: "28053",
    ST: "NC",
    cityWithStateAbbr: "Gastonia, NC",
  },
  {
    zip: "28054",
    ST: "NC",
    cityWithStateAbbr: "Gastonia, NC",
  },
  {
    zip: "28055",
    ST: "NC",
    cityWithStateAbbr: "Gastonia, NC",
  },
  {
    zip: "28056",
    ST: "NC",
    cityWithStateAbbr: "Gastonia, NC",
  },
  {
    zip: "28070",
    ST: "NC",
    cityWithStateAbbr: "Huntersville, NC",
  },
  {
    zip: "28071",
    ST: "NC",
    cityWithStateAbbr: "Gold Hill, NC",
  },
  {
    zip: "28072",
    ST: "NC",
    cityWithStateAbbr: "Granite Quarry, NC",
  },
  {
    zip: "28073",
    ST: "NC",
    cityWithStateAbbr: "Grover, NC",
  },
  {
    zip: "28074",
    ST: "NC",
    cityWithStateAbbr: "Harris, NC",
  },
  {
    zip: "28075",
    ST: "NC",
    cityWithStateAbbr: "Harrisburg, NC",
  },
  {
    zip: "28076",
    ST: "NC",
    cityWithStateAbbr: "Henrietta, NC",
  },
  {
    zip: "28077",
    ST: "NC",
    cityWithStateAbbr: "High Shoals, NC",
  },
  {
    zip: "28078",
    ST: "NC",
    cityWithStateAbbr: "Huntersville, NC",
  },
  {
    zip: "28079",
    ST: "NC",
    cityWithStateAbbr: "Indian Trail, NC",
  },
  {
    zip: "28080",
    ST: "NC",
    cityWithStateAbbr: "Iron Station, NC",
  },
  {
    zip: "28081",
    ST: "NC",
    cityWithStateAbbr: "Kannapolis, NC",
  },
  {
    zip: "28082",
    ST: "NC",
    cityWithStateAbbr: "Kannapolis, NC",
  },
  {
    zip: "28083",
    ST: "NC",
    cityWithStateAbbr: "Kannapolis, NC",
  },
  {
    zip: "28086",
    ST: "NC",
    cityWithStateAbbr: "Kings Mountain, NC",
  },
  {
    zip: "28088",
    ST: "NC",
    cityWithStateAbbr: "Landis, NC",
  },
  {
    zip: "28089",
    ST: "NC",
    cityWithStateAbbr: "Lattimore, NC",
  },
  {
    zip: "28090",
    ST: "NC",
    cityWithStateAbbr: "Lawndale, NC",
  },
  {
    zip: "28091",
    ST: "NC",
    cityWithStateAbbr: "Lilesville, NC",
  },
  {
    zip: "28092",
    ST: "NC",
    cityWithStateAbbr: "Lincolnton, NC",
  },
  {
    zip: "28093",
    ST: "NC",
    cityWithStateAbbr: "Lincolnton, NC",
  },
  {
    zip: "28097",
    ST: "NC",
    cityWithStateAbbr: "Locust, NC",
  },
  {
    zip: "28098",
    ST: "NC",
    cityWithStateAbbr: "Lowell, NC",
  },
  {
    zip: "28101",
    ST: "NC",
    cityWithStateAbbr: "Mc Adenville, NC",
  },
  {
    zip: "28102",
    ST: "NC",
    cityWithStateAbbr: "Mc Farlan, NC",
  },
  {
    zip: "28103",
    ST: "NC",
    cityWithStateAbbr: "Marshville, NC",
  },
  {
    zip: "28104",
    ST: "NC",
    cityWithStateAbbr: "Matthews, NC",
  },
  {
    zip: "28105",
    ST: "NC",
    cityWithStateAbbr: "Matthews, NC",
  },
  {
    zip: "28106",
    ST: "NC",
    cityWithStateAbbr: "Matthews, NC",
  },
  {
    zip: "28107",
    ST: "NC",
    cityWithStateAbbr: "Midland, NC",
  },
  {
    zip: "28108",
    ST: "NC",
    cityWithStateAbbr: "Mineral Springs, NC",
  },
  {
    zip: "28109",
    ST: "NC",
    cityWithStateAbbr: "Misenheimer, NC",
  },
  {
    zip: "28110",
    ST: "NC",
    cityWithStateAbbr: "Monroe, NC",
  },
  {
    zip: "28111",
    ST: "NC",
    cityWithStateAbbr: "Monroe, NC",
  },
  {
    zip: "28112",
    ST: "NC",
    cityWithStateAbbr: "Monroe, NC",
  },
  {
    zip: "28114",
    ST: "NC",
    cityWithStateAbbr: "Mooresboro, NC",
  },
  {
    zip: "28115",
    ST: "NC",
    cityWithStateAbbr: "Mooresville, NC",
  },
  {
    zip: "28117",
    ST: "NC",
    cityWithStateAbbr: "Mooresville, NC",
  },
  {
    zip: "28119",
    ST: "NC",
    cityWithStateAbbr: "Morven, NC",
  },
  {
    zip: "28120",
    ST: "NC",
    cityWithStateAbbr: "Mount Holly, NC",
  },
  {
    zip: "28123",
    ST: "NC",
    cityWithStateAbbr: "Mount Mourne, NC",
  },
  {
    zip: "28124",
    ST: "NC",
    cityWithStateAbbr: "Mount Pleasant, NC",
  },
  {
    zip: "28125",
    ST: "NC",
    cityWithStateAbbr: "Mount Ulla, NC",
  },
  {
    zip: "28126",
    ST: "NC",
    cityWithStateAbbr: "Newell, NC",
  },
  {
    zip: "28127",
    ST: "NC",
    cityWithStateAbbr: "New London, NC",
  },
  {
    zip: "28128",
    ST: "NC",
    cityWithStateAbbr: "Norwood, NC",
  },
  {
    zip: "28129",
    ST: "NC",
    cityWithStateAbbr: "Oakboro, NC",
  },
  {
    zip: "28130",
    ST: "NC",
    cityWithStateAbbr: "Paw Creek, NC",
  },
  {
    zip: "28133",
    ST: "NC",
    cityWithStateAbbr: "Peachland, NC",
  },
  {
    zip: "28134",
    ST: "NC",
    cityWithStateAbbr: "Pineville, NC",
  },
  {
    zip: "28135",
    ST: "NC",
    cityWithStateAbbr: "Polkton, NC",
  },
  {
    zip: "28136",
    ST: "NC",
    cityWithStateAbbr: "Polkville, NC",
  },
  {
    zip: "28137",
    ST: "NC",
    cityWithStateAbbr: "Richfield, NC",
  },
  {
    zip: "28138",
    ST: "NC",
    cityWithStateAbbr: "Rockwell, NC",
  },
  {
    zip: "28139",
    ST: "NC",
    cityWithStateAbbr: "Rutherfordton, NC",
  },
  {
    zip: "28144",
    ST: "NC",
    cityWithStateAbbr: "Salisbury, NC",
  },
  {
    zip: "28145",
    ST: "NC",
    cityWithStateAbbr: "Salisbury, NC",
  },
  {
    zip: "28146",
    ST: "NC",
    cityWithStateAbbr: "Salisbury, NC",
  },
  {
    zip: "28147",
    ST: "NC",
    cityWithStateAbbr: "Salisbury, NC",
  },
  {
    zip: "28150",
    ST: "NC",
    cityWithStateAbbr: "Shelby, NC",
  },
  {
    zip: "28151",
    ST: "NC",
    cityWithStateAbbr: "Shelby, NC",
  },
  {
    zip: "28152",
    ST: "NC",
    cityWithStateAbbr: "Shelby, NC",
  },
  {
    zip: "28159",
    ST: "NC",
    cityWithStateAbbr: "Spencer, NC",
  },
  {
    zip: "28160",
    ST: "NC",
    cityWithStateAbbr: "Spindale, NC",
  },
  {
    zip: "28163",
    ST: "NC",
    cityWithStateAbbr: "Stanfield, NC",
  },
  {
    zip: "28164",
    ST: "NC",
    cityWithStateAbbr: "Stanley, NC",
  },
  {
    zip: "28166",
    ST: "NC",
    cityWithStateAbbr: "Troutman, NC",
  },
  {
    zip: "28167",
    ST: "NC",
    cityWithStateAbbr: "Union Mills, NC",
  },
  {
    zip: "28168",
    ST: "NC",
    cityWithStateAbbr: "Vale, NC",
  },
  {
    zip: "28169",
    ST: "NC",
    cityWithStateAbbr: "Waco, NC",
  },
  {
    zip: "28170",
    ST: "NC",
    cityWithStateAbbr: "Wadesboro, NC",
  },
  {
    zip: "28173",
    ST: "NC",
    cityWithStateAbbr: "Waxhaw, NC",
  },
  {
    zip: "28174",
    ST: "NC",
    cityWithStateAbbr: "Wingate, NC",
  },
  {
    zip: "28201",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28202",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28203",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28204",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28205",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28206",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28207",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28208",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28209",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28210",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28211",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28212",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28213",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28214",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28215",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28216",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28217",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28218",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28219",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28220",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28221",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28222",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28223",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28224",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28226",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28227",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28228",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28229",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28230",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28231",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28232",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28233",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28234",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28235",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28236",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28237",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28241",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28242",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28243",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28244",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28246",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28247",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28250",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28253",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28254",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28255",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28256",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28258",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28260",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28262",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28263",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28265",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28266",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28269",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28270",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28271",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28272",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28273",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28274",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28275",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28277",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28278",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28280",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28281",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28282",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28284",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28285",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28287",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28288",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28289",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28290",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28296",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28297",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28299",
    ST: "NC",
    cityWithStateAbbr: "Charlotte, NC",
  },
  {
    zip: "28301",
    ST: "NC",
    cityWithStateAbbr: "Fayetteville, NC",
  },
  {
    zip: "28302",
    ST: "NC",
    cityWithStateAbbr: "Fayetteville, NC",
  },
  {
    zip: "28303",
    ST: "NC",
    cityWithStateAbbr: "Fayetteville, NC",
  },
  {
    zip: "28304",
    ST: "NC",
    cityWithStateAbbr: "Fayetteville, NC",
  },
  {
    zip: "28305",
    ST: "NC",
    cityWithStateAbbr: "Fayetteville, NC",
  },
  {
    zip: "28306",
    ST: "NC",
    cityWithStateAbbr: "Fayetteville, NC",
  },
  {
    zip: "28307",
    ST: "NC",
    cityWithStateAbbr: "Fort Bragg, NC",
  },
  {
    zip: "28308",
    ST: "NC",
    cityWithStateAbbr: "Pope Army Airfield, NC",
  },
  {
    zip: "28309",
    ST: "NC",
    cityWithStateAbbr: "Fayetteville, NC",
  },
  {
    zip: "28310",
    ST: "NC",
    cityWithStateAbbr: "Fort Bragg, NC",
  },
  {
    zip: "28311",
    ST: "NC",
    cityWithStateAbbr: "Fayetteville, NC",
  },
  {
    zip: "28312",
    ST: "NC",
    cityWithStateAbbr: "Fayetteville, NC",
  },
  {
    zip: "28314",
    ST: "NC",
    cityWithStateAbbr: "Fayetteville, NC",
  },
  {
    zip: "28315",
    ST: "NC",
    cityWithStateAbbr: "Aberdeen, NC",
  },
  {
    zip: "28318",
    ST: "NC",
    cityWithStateAbbr: "Autryville, NC",
  },
  {
    zip: "28319",
    ST: "NC",
    cityWithStateAbbr: "Barnesville, NC",
  },
  {
    zip: "28320",
    ST: "NC",
    cityWithStateAbbr: "Bladenboro, NC",
  },
  {
    zip: "28323",
    ST: "NC",
    cityWithStateAbbr: "Bunnlevel, NC",
  },
  {
    zip: "28325",
    ST: "NC",
    cityWithStateAbbr: "Calypso, NC",
  },
  {
    zip: "28326",
    ST: "NC",
    cityWithStateAbbr: "Cameron, NC",
  },
  {
    zip: "28327",
    ST: "NC",
    cityWithStateAbbr: "Carthage, NC",
  },
  {
    zip: "28328",
    ST: "NC",
    cityWithStateAbbr: "Clinton, NC",
  },
  {
    zip: "28329",
    ST: "NC",
    cityWithStateAbbr: "Clinton, NC",
  },
  {
    zip: "28330",
    ST: "NC",
    cityWithStateAbbr: "Cordova, NC",
  },
  {
    zip: "28331",
    ST: "NC",
    cityWithStateAbbr: "Cumberland, NC",
  },
  {
    zip: "28332",
    ST: "NC",
    cityWithStateAbbr: "Dublin, NC",
  },
  {
    zip: "28333",
    ST: "NC",
    cityWithStateAbbr: "Dudley, NC",
  },
  {
    zip: "28334",
    ST: "NC",
    cityWithStateAbbr: "Dunn, NC",
  },
  {
    zip: "28335",
    ST: "NC",
    cityWithStateAbbr: "Dunn, NC",
  },
  {
    zip: "28337",
    ST: "NC",
    cityWithStateAbbr: "Elizabethtown, NC",
  },
  {
    zip: "28338",
    ST: "NC",
    cityWithStateAbbr: "Ellerbe, NC",
  },
  {
    zip: "28339",
    ST: "NC",
    cityWithStateAbbr: "Erwin, NC",
  },
  {
    zip: "28340",
    ST: "NC",
    cityWithStateAbbr: "Fairmont, NC",
  },
  {
    zip: "28341",
    ST: "NC",
    cityWithStateAbbr: "Faison, NC",
  },
  {
    zip: "28342",
    ST: "NC",
    cityWithStateAbbr: "Falcon, NC",
  },
  {
    zip: "28343",
    ST: "NC",
    cityWithStateAbbr: "Gibson, NC",
  },
  {
    zip: "28344",
    ST: "NC",
    cityWithStateAbbr: "Godwin, NC",
  },
  {
    zip: "28345",
    ST: "NC",
    cityWithStateAbbr: "Hamlet, NC",
  },
  {
    zip: "28347",
    ST: "NC",
    cityWithStateAbbr: "Hoffman, NC",
  },
  {
    zip: "28348",
    ST: "NC",
    cityWithStateAbbr: "Hope Mills, NC",
  },
  {
    zip: "28349",
    ST: "NC",
    cityWithStateAbbr: "Kenansville, NC",
  },
  {
    zip: "28350",
    ST: "NC",
    cityWithStateAbbr: "Lakeview, NC",
  },
  {
    zip: "28351",
    ST: "NC",
    cityWithStateAbbr: "Laurel Hill, NC",
  },
  {
    zip: "28352",
    ST: "NC",
    cityWithStateAbbr: "Laurinburg, NC",
  },
  {
    zip: "28353",
    ST: "NC",
    cityWithStateAbbr: "Laurinburg, NC",
  },
  {
    zip: "28355",
    ST: "NC",
    cityWithStateAbbr: "Lemon Springs, NC",
  },
  {
    zip: "28356",
    ST: "NC",
    cityWithStateAbbr: "Linden, NC",
  },
  {
    zip: "28357",
    ST: "NC",
    cityWithStateAbbr: "Lumber Bridge, NC",
  },
  {
    zip: "28358",
    ST: "NC",
    cityWithStateAbbr: "Lumberton, NC",
  },
  {
    zip: "28359",
    ST: "NC",
    cityWithStateAbbr: "Lumberton, NC",
  },
  {
    zip: "28360",
    ST: "NC",
    cityWithStateAbbr: "Lumberton, NC",
  },
  {
    zip: "28362",
    ST: "NC",
    cityWithStateAbbr: "Marietta, NC",
  },
  {
    zip: "28363",
    ST: "NC",
    cityWithStateAbbr: "Marston, NC",
  },
  {
    zip: "28364",
    ST: "NC",
    cityWithStateAbbr: "Maxton, NC",
  },
  {
    zip: "28365",
    ST: "NC",
    cityWithStateAbbr: "Mount Olive, NC",
  },
  {
    zip: "28366",
    ST: "NC",
    cityWithStateAbbr: "Newton Grove, NC",
  },
  {
    zip: "28367",
    ST: "NC",
    cityWithStateAbbr: "Norman, NC",
  },
  {
    zip: "28368",
    ST: "NC",
    cityWithStateAbbr: "Olivia, NC",
  },
  {
    zip: "28369",
    ST: "NC",
    cityWithStateAbbr: "Orrum, NC",
  },
  {
    zip: "28370",
    ST: "NC",
    cityWithStateAbbr: "Pinehurst, NC",
  },
  {
    zip: "28371",
    ST: "NC",
    cityWithStateAbbr: "Parkton, NC",
  },
  {
    zip: "28372",
    ST: "NC",
    cityWithStateAbbr: "Pembroke, NC",
  },
  {
    zip: "28373",
    ST: "NC",
    cityWithStateAbbr: "Pinebluff, NC",
  },
  {
    zip: "28374",
    ST: "NC",
    cityWithStateAbbr: "Pinehurst, NC",
  },
  {
    zip: "28375",
    ST: "NC",
    cityWithStateAbbr: "Proctorville, NC",
  },
  {
    zip: "28376",
    ST: "NC",
    cityWithStateAbbr: "Raeford, NC",
  },
  {
    zip: "28377",
    ST: "NC",
    cityWithStateAbbr: "Red Springs, NC",
  },
  {
    zip: "28378",
    ST: "NC",
    cityWithStateAbbr: "Rex, NC",
  },
  {
    zip: "28379",
    ST: "NC",
    cityWithStateAbbr: "Rockingham, NC",
  },
  {
    zip: "28380",
    ST: "NC",
    cityWithStateAbbr: "Rockingham, NC",
  },
  {
    zip: "28382",
    ST: "NC",
    cityWithStateAbbr: "Roseboro, NC",
  },
  {
    zip: "28383",
    ST: "NC",
    cityWithStateAbbr: "Rowland, NC",
  },
  {
    zip: "28384",
    ST: "NC",
    cityWithStateAbbr: "Saint Pauls, NC",
  },
  {
    zip: "28385",
    ST: "NC",
    cityWithStateAbbr: "Salemburg, NC",
  },
  {
    zip: "28386",
    ST: "NC",
    cityWithStateAbbr: "Shannon, NC",
  },
  {
    zip: "28387",
    ST: "NC",
    cityWithStateAbbr: "Southern Pines, NC",
  },
  {
    zip: "28388",
    ST: "NC",
    cityWithStateAbbr: "Southern Pines, NC",
  },
  {
    zip: "28390",
    ST: "NC",
    cityWithStateAbbr: "Spring Lake, NC",
  },
  {
    zip: "28391",
    ST: "NC",
    cityWithStateAbbr: "Stedman, NC",
  },
  {
    zip: "28392",
    ST: "NC",
    cityWithStateAbbr: "Tar Heel, NC",
  },
  {
    zip: "28393",
    ST: "NC",
    cityWithStateAbbr: "Turkey, NC",
  },
  {
    zip: "28394",
    ST: "NC",
    cityWithStateAbbr: "Vass, NC",
  },
  {
    zip: "28395",
    ST: "NC",
    cityWithStateAbbr: "Wade, NC",
  },
  {
    zip: "28396",
    ST: "NC",
    cityWithStateAbbr: "Wagram, NC",
  },
  {
    zip: "28398",
    ST: "NC",
    cityWithStateAbbr: "Warsaw, NC",
  },
  {
    zip: "28399",
    ST: "NC",
    cityWithStateAbbr: "White Oak, NC",
  },
  {
    zip: "28401",
    ST: "NC",
    cityWithStateAbbr: "Wilmington, NC",
  },
  {
    zip: "28402",
    ST: "NC",
    cityWithStateAbbr: "Wilmington, NC",
  },
  {
    zip: "28403",
    ST: "NC",
    cityWithStateAbbr: "Wilmington, NC",
  },
  {
    zip: "28404",
    ST: "NC",
    cityWithStateAbbr: "Wilmington, NC",
  },
  {
    zip: "28405",
    ST: "NC",
    cityWithStateAbbr: "Wilmington, NC",
  },
  {
    zip: "28406",
    ST: "NC",
    cityWithStateAbbr: "Wilmington, NC",
  },
  {
    zip: "28407",
    ST: "NC",
    cityWithStateAbbr: "Wilmington, NC",
  },
  {
    zip: "28408",
    ST: "NC",
    cityWithStateAbbr: "Wilmington, NC",
  },
  {
    zip: "28409",
    ST: "NC",
    cityWithStateAbbr: "Wilmington, NC",
  },
  {
    zip: "28410",
    ST: "NC",
    cityWithStateAbbr: "Wilmington, NC",
  },
  {
    zip: "28411",
    ST: "NC",
    cityWithStateAbbr: "Wilmington, NC",
  },
  {
    zip: "28412",
    ST: "NC",
    cityWithStateAbbr: "Wilmington, NC",
  },
  {
    zip: "28420",
    ST: "NC",
    cityWithStateAbbr: "Ash, NC",
  },
  {
    zip: "28421",
    ST: "NC",
    cityWithStateAbbr: "Atkinson, NC",
  },
  {
    zip: "28422",
    ST: "NC",
    cityWithStateAbbr: "Bolivia, NC",
  },
  {
    zip: "28423",
    ST: "NC",
    cityWithStateAbbr: "Bolton, NC",
  },
  {
    zip: "28424",
    ST: "NC",
    cityWithStateAbbr: "Brunswick, NC",
  },
  {
    zip: "28425",
    ST: "NC",
    cityWithStateAbbr: "Burgaw, NC",
  },
  {
    zip: "28428",
    ST: "NC",
    cityWithStateAbbr: "Carolina Beach, NC",
  },
  {
    zip: "28429",
    ST: "NC",
    cityWithStateAbbr: "Castle Hayne, NC",
  },
  {
    zip: "28430",
    ST: "NC",
    cityWithStateAbbr: "Cerro Gordo, NC",
  },
  {
    zip: "28431",
    ST: "NC",
    cityWithStateAbbr: "Chadbourn, NC",
  },
  {
    zip: "28432",
    ST: "NC",
    cityWithStateAbbr: "Clarendon, NC",
  },
  {
    zip: "28433",
    ST: "NC",
    cityWithStateAbbr: "Clarkton, NC",
  },
  {
    zip: "28434",
    ST: "NC",
    cityWithStateAbbr: "Council, NC",
  },
  {
    zip: "28435",
    ST: "NC",
    cityWithStateAbbr: "Currie, NC",
  },
  {
    zip: "28436",
    ST: "NC",
    cityWithStateAbbr: "Delco, NC",
  },
  {
    zip: "28438",
    ST: "NC",
    cityWithStateAbbr: "Evergreen, NC",
  },
  {
    zip: "28439",
    ST: "NC",
    cityWithStateAbbr: "Fair Bluff, NC",
  },
  {
    zip: "28441",
    ST: "NC",
    cityWithStateAbbr: "Garland, NC",
  },
  {
    zip: "28442",
    ST: "NC",
    cityWithStateAbbr: "Hallsboro, NC",
  },
  {
    zip: "28443",
    ST: "NC",
    cityWithStateAbbr: "Hampstead, NC",
  },
  {
    zip: "28444",
    ST: "NC",
    cityWithStateAbbr: "Harrells, NC",
  },
  {
    zip: "28445",
    ST: "NC",
    cityWithStateAbbr: "Holly Ridge, NC",
  },
  {
    zip: "28447",
    ST: "NC",
    cityWithStateAbbr: "Ivanhoe, NC",
  },
  {
    zip: "28448",
    ST: "NC",
    cityWithStateAbbr: "Kelly, NC",
  },
  {
    zip: "28449",
    ST: "NC",
    cityWithStateAbbr: "Kure Beach, NC",
  },
  {
    zip: "28450",
    ST: "NC",
    cityWithStateAbbr: "Lake Waccamaw, NC",
  },
  {
    zip: "28451",
    ST: "NC",
    cityWithStateAbbr: "Leland, NC",
  },
  {
    zip: "28452",
    ST: "NC",
    cityWithStateAbbr: "Longwood, NC",
  },
  {
    zip: "28453",
    ST: "NC",
    cityWithStateAbbr: "Magnolia, NC",
  },
  {
    zip: "28454",
    ST: "NC",
    cityWithStateAbbr: "Maple Hill, NC",
  },
  {
    zip: "28455",
    ST: "NC",
    cityWithStateAbbr: "Nakina, NC",
  },
  {
    zip: "28456",
    ST: "NC",
    cityWithStateAbbr: "Riegelwood, NC",
  },
  {
    zip: "28457",
    ST: "NC",
    cityWithStateAbbr: "Rocky Point, NC",
  },
  {
    zip: "28458",
    ST: "NC",
    cityWithStateAbbr: "Rose Hill, NC",
  },
  {
    zip: "28459",
    ST: "NC",
    cityWithStateAbbr: "Shallotte, NC",
  },
  {
    zip: "28460",
    ST: "NC",
    cityWithStateAbbr: "Sneads Ferry, NC",
  },
  {
    zip: "28461",
    ST: "NC",
    cityWithStateAbbr: "Southport, NC",
  },
  {
    zip: "28462",
    ST: "NC",
    cityWithStateAbbr: "Supply, NC",
  },
  {
    zip: "28463",
    ST: "NC",
    cityWithStateAbbr: "Tabor City, NC",
  },
  {
    zip: "28464",
    ST: "NC",
    cityWithStateAbbr: "Teachey, NC",
  },
  {
    zip: "28465",
    ST: "NC",
    cityWithStateAbbr: "Oak Island, NC",
  },
  {
    zip: "28466",
    ST: "NC",
    cityWithStateAbbr: "Wallace, NC",
  },
  {
    zip: "28467",
    ST: "NC",
    cityWithStateAbbr: "Calabash, NC",
  },
  {
    zip: "28468",
    ST: "NC",
    cityWithStateAbbr: "Sunset Beach, NC",
  },
  {
    zip: "28469",
    ST: "NC",
    cityWithStateAbbr: "Ocean Isle Beach, NC",
  },
  {
    zip: "28470",
    ST: "NC",
    cityWithStateAbbr: "Shallotte, NC",
  },
  {
    zip: "28472",
    ST: "NC",
    cityWithStateAbbr: "Whiteville, NC",
  },
  {
    zip: "28478",
    ST: "NC",
    cityWithStateAbbr: "Willard, NC",
  },
  {
    zip: "28479",
    ST: "NC",
    cityWithStateAbbr: "Winnabow, NC",
  },
  {
    zip: "28480",
    ST: "NC",
    cityWithStateAbbr: "Wrightsville Beach, NC",
  },
  {
    zip: "28501",
    ST: "NC",
    cityWithStateAbbr: "Kinston, NC",
  },
  {
    zip: "28502",
    ST: "NC",
    cityWithStateAbbr: "Kinston, NC",
  },
  {
    zip: "28503",
    ST: "NC",
    cityWithStateAbbr: "Kinston, NC",
  },
  {
    zip: "28504",
    ST: "NC",
    cityWithStateAbbr: "Kinston, NC",
  },
  {
    zip: "28508",
    ST: "NC",
    cityWithStateAbbr: "Albertson, NC",
  },
  {
    zip: "28509",
    ST: "NC",
    cityWithStateAbbr: "Alliance, NC",
  },
  {
    zip: "28510",
    ST: "NC",
    cityWithStateAbbr: "Arapahoe, NC",
  },
  {
    zip: "28511",
    ST: "NC",
    cityWithStateAbbr: "Atlantic, NC",
  },
  {
    zip: "28512",
    ST: "NC",
    cityWithStateAbbr: "Atlantic Beach, NC",
  },
  {
    zip: "28513",
    ST: "NC",
    cityWithStateAbbr: "Ayden, NC",
  },
  {
    zip: "28515",
    ST: "NC",
    cityWithStateAbbr: "Bayboro, NC",
  },
  {
    zip: "28516",
    ST: "NC",
    cityWithStateAbbr: "Beaufort, NC",
  },
  {
    zip: "28518",
    ST: "NC",
    cityWithStateAbbr: "Beulaville, NC",
  },
  {
    zip: "28519",
    ST: "NC",
    cityWithStateAbbr: "Bridgeton, NC",
  },
  {
    zip: "28520",
    ST: "NC",
    cityWithStateAbbr: "Cedar Island, NC",
  },
  {
    zip: "28521",
    ST: "NC",
    cityWithStateAbbr: "Chinquapin, NC",
  },
  {
    zip: "28522",
    ST: "NC",
    cityWithStateAbbr: "Comfort, NC",
  },
  {
    zip: "28523",
    ST: "NC",
    cityWithStateAbbr: "Cove City, NC",
  },
  {
    zip: "28524",
    ST: "NC",
    cityWithStateAbbr: "Davis, NC",
  },
  {
    zip: "28525",
    ST: "NC",
    cityWithStateAbbr: "Deep Run, NC",
  },
  {
    zip: "28526",
    ST: "NC",
    cityWithStateAbbr: "Dover, NC",
  },
  {
    zip: "28527",
    ST: "NC",
    cityWithStateAbbr: "Ernul, NC",
  },
  {
    zip: "28528",
    ST: "NC",
    cityWithStateAbbr: "Gloucester, NC",
  },
  {
    zip: "28529",
    ST: "NC",
    cityWithStateAbbr: "Grantsboro, NC",
  },
  {
    zip: "28530",
    ST: "NC",
    cityWithStateAbbr: "Grifton, NC",
  },
  {
    zip: "28531",
    ST: "NC",
    cityWithStateAbbr: "Harkers Island, NC",
  },
  {
    zip: "28532",
    ST: "NC",
    cityWithStateAbbr: "Havelock, NC",
  },
  {
    zip: "28533",
    ST: "NC",
    cityWithStateAbbr: "Cherry Point, NC",
  },
  {
    zip: "28537",
    ST: "NC",
    cityWithStateAbbr: "Hobucken, NC",
  },
  {
    zip: "28538",
    ST: "NC",
    cityWithStateAbbr: "Hookerton, NC",
  },
  {
    zip: "28539",
    ST: "NC",
    cityWithStateAbbr: "Hubert, NC",
  },
  {
    zip: "28540",
    ST: "NC",
    cityWithStateAbbr: "Jacksonville, NC",
  },
  {
    zip: "28541",
    ST: "NC",
    cityWithStateAbbr: "Jacksonville, NC",
  },
  {
    zip: "28542",
    ST: "NC",
    cityWithStateAbbr: "Camp Lejeune, NC",
  },
  {
    zip: "28543",
    ST: "NC",
    cityWithStateAbbr: "Tarawa Terrace, NC",
  },
  {
    zip: "28544",
    ST: "NC",
    cityWithStateAbbr: "Midway Park, NC",
  },
  {
    zip: "28545",
    ST: "NC",
    cityWithStateAbbr: "Mccutcheon Field, NC",
  },
  {
    zip: "28546",
    ST: "NC",
    cityWithStateAbbr: "Jacksonville, NC",
  },
  {
    zip: "28547",
    ST: "NC",
    cityWithStateAbbr: "Camp Lejeune, NC",
  },
  {
    zip: "28551",
    ST: "NC",
    cityWithStateAbbr: "La Grange, NC",
  },
  {
    zip: "28552",
    ST: "NC",
    cityWithStateAbbr: "Lowland, NC",
  },
  {
    zip: "28553",
    ST: "NC",
    cityWithStateAbbr: "Marshallberg, NC",
  },
  {
    zip: "28554",
    ST: "NC",
    cityWithStateAbbr: "Maury, NC",
  },
  {
    zip: "28555",
    ST: "NC",
    cityWithStateAbbr: "Maysville, NC",
  },
  {
    zip: "28556",
    ST: "NC",
    cityWithStateAbbr: "Merritt, NC",
  },
  {
    zip: "28557",
    ST: "NC",
    cityWithStateAbbr: "Morehead City, NC",
  },
  {
    zip: "28560",
    ST: "NC",
    cityWithStateAbbr: "New Bern, NC",
  },
  {
    zip: "28561",
    ST: "NC",
    cityWithStateAbbr: "New Bern, NC",
  },
  {
    zip: "28562",
    ST: "NC",
    cityWithStateAbbr: "New Bern, NC",
  },
  {
    zip: "28563",
    ST: "NC",
    cityWithStateAbbr: "New Bern, NC",
  },
  {
    zip: "28564",
    ST: "NC",
    cityWithStateAbbr: "New Bern, NC",
  },
  {
    zip: "28570",
    ST: "NC",
    cityWithStateAbbr: "Newport, NC",
  },
  {
    zip: "28571",
    ST: "NC",
    cityWithStateAbbr: "Oriental, NC",
  },
  {
    zip: "28572",
    ST: "NC",
    cityWithStateAbbr: "Pink Hill, NC",
  },
  {
    zip: "28573",
    ST: "NC",
    cityWithStateAbbr: "Pollocksville, NC",
  },
  {
    zip: "28574",
    ST: "NC",
    cityWithStateAbbr: "Richlands, NC",
  },
  {
    zip: "28575",
    ST: "NC",
    cityWithStateAbbr: "Salter Path, NC",
  },
  {
    zip: "28577",
    ST: "NC",
    cityWithStateAbbr: "Sealevel, NC",
  },
  {
    zip: "28578",
    ST: "NC",
    cityWithStateAbbr: "Seven Springs, NC",
  },
  {
    zip: "28579",
    ST: "NC",
    cityWithStateAbbr: "Smyrna, NC",
  },
  {
    zip: "28580",
    ST: "NC",
    cityWithStateAbbr: "Snow Hill, NC",
  },
  {
    zip: "28581",
    ST: "NC",
    cityWithStateAbbr: "Stacy, NC",
  },
  {
    zip: "28582",
    ST: "NC",
    cityWithStateAbbr: "Stella, NC",
  },
  {
    zip: "28583",
    ST: "NC",
    cityWithStateAbbr: "Stonewall, NC",
  },
  {
    zip: "28584",
    ST: "NC",
    cityWithStateAbbr: "Swansboro, NC",
  },
  {
    zip: "28585",
    ST: "NC",
    cityWithStateAbbr: "Trenton, NC",
  },
  {
    zip: "28586",
    ST: "NC",
    cityWithStateAbbr: "Vanceboro, NC",
  },
  {
    zip: "28587",
    ST: "NC",
    cityWithStateAbbr: "Vandemere, NC",
  },
  {
    zip: "28589",
    ST: "NC",
    cityWithStateAbbr: "Williston, NC",
  },
  {
    zip: "28590",
    ST: "NC",
    cityWithStateAbbr: "Winterville, NC",
  },
  {
    zip: "28594",
    ST: "NC",
    cityWithStateAbbr: "Emerald Isle, NC",
  },
  {
    zip: "28601",
    ST: "NC",
    cityWithStateAbbr: "Hickory, NC",
  },
  {
    zip: "28602",
    ST: "NC",
    cityWithStateAbbr: "Hickory, NC",
  },
  {
    zip: "28603",
    ST: "NC",
    cityWithStateAbbr: "Hickory, NC",
  },
  {
    zip: "28604",
    ST: "NC",
    cityWithStateAbbr: "Banner Elk, NC",
  },
  {
    zip: "28605",
    ST: "NC",
    cityWithStateAbbr: "Blowing Rock, NC",
  },
  {
    zip: "28606",
    ST: "NC",
    cityWithStateAbbr: "Boomer, NC",
  },
  {
    zip: "28607",
    ST: "NC",
    cityWithStateAbbr: "Boone, NC",
  },
  {
    zip: "28608",
    ST: "NC",
    cityWithStateAbbr: "Boone, NC",
  },
  {
    zip: "28609",
    ST: "NC",
    cityWithStateAbbr: "Catawba, NC",
  },
  {
    zip: "28610",
    ST: "NC",
    cityWithStateAbbr: "Claremont, NC",
  },
  {
    zip: "28611",
    ST: "NC",
    cityWithStateAbbr: "Collettsville, NC",
  },
  {
    zip: "28612",
    ST: "NC",
    cityWithStateAbbr: "Connelly Springs, NC",
  },
  {
    zip: "28613",
    ST: "NC",
    cityWithStateAbbr: "Conover, NC",
  },
  {
    zip: "28615",
    ST: "NC",
    cityWithStateAbbr: "Creston, NC",
  },
  {
    zip: "28616",
    ST: "NC",
    cityWithStateAbbr: "Crossnore, NC",
  },
  {
    zip: "28617",
    ST: "NC",
    cityWithStateAbbr: "Crumpler, NC",
  },
  {
    zip: "28618",
    ST: "NC",
    cityWithStateAbbr: "Deep Gap, NC",
  },
  {
    zip: "28619",
    ST: "NC",
    cityWithStateAbbr: "Drexel, NC",
  },
  {
    zip: "28621",
    ST: "NC",
    cityWithStateAbbr: "Elkin, NC",
  },
  {
    zip: "28622",
    ST: "NC",
    cityWithStateAbbr: "Elk Park, NC",
  },
  {
    zip: "28623",
    ST: "NC",
    cityWithStateAbbr: "Ennice, NC",
  },
  {
    zip: "28624",
    ST: "NC",
    cityWithStateAbbr: "Ferguson, NC",
  },
  {
    zip: "28625",
    ST: "NC",
    cityWithStateAbbr: "Statesville, NC",
  },
  {
    zip: "28626",
    ST: "NC",
    cityWithStateAbbr: "Fleetwood, NC",
  },
  {
    zip: "28627",
    ST: "NC",
    cityWithStateAbbr: "Glade Valley, NC",
  },
  {
    zip: "28628",
    ST: "NC",
    cityWithStateAbbr: "Glen Alpine, NC",
  },
  {
    zip: "28629",
    ST: "NC",
    cityWithStateAbbr: "Glendale Springs, NC",
  },
  {
    zip: "28630",
    ST: "NC",
    cityWithStateAbbr: "Granite Falls, NC",
  },
  {
    zip: "28631",
    ST: "NC",
    cityWithStateAbbr: "Grassy Creek, NC",
  },
  {
    zip: "28633",
    ST: "NC",
    cityWithStateAbbr: "Lenoir, NC",
  },
  {
    zip: "28634",
    ST: "NC",
    cityWithStateAbbr: "Harmony, NC",
  },
  {
    zip: "28635",
    ST: "NC",
    cityWithStateAbbr: "Hays, NC",
  },
  {
    zip: "28636",
    ST: "NC",
    cityWithStateAbbr: "Hiddenite, NC",
  },
  {
    zip: "28637",
    ST: "NC",
    cityWithStateAbbr: "Hildebran, NC",
  },
  {
    zip: "28638",
    ST: "NC",
    cityWithStateAbbr: "Hudson, NC",
  },
  {
    zip: "28640",
    ST: "NC",
    cityWithStateAbbr: "Jefferson, NC",
  },
  {
    zip: "28641",
    ST: "NC",
    cityWithStateAbbr: "Jonas Ridge, NC",
  },
  {
    zip: "28642",
    ST: "NC",
    cityWithStateAbbr: "Jonesville, NC",
  },
  {
    zip: "28643",
    ST: "NC",
    cityWithStateAbbr: "Lansing, NC",
  },
  {
    zip: "28644",
    ST: "NC",
    cityWithStateAbbr: "Laurel Springs, NC",
  },
  {
    zip: "28645",
    ST: "NC",
    cityWithStateAbbr: "Lenoir, NC",
  },
  {
    zip: "28646",
    ST: "NC",
    cityWithStateAbbr: "Linville, NC",
  },
  {
    zip: "28647",
    ST: "NC",
    cityWithStateAbbr: "Linville Falls, NC",
  },
  {
    zip: "28649",
    ST: "NC",
    cityWithStateAbbr: "Mc Grady, NC",
  },
  {
    zip: "28650",
    ST: "NC",
    cityWithStateAbbr: "Maiden, NC",
  },
  {
    zip: "28651",
    ST: "NC",
    cityWithStateAbbr: "Millers Creek, NC",
  },
  {
    zip: "28652",
    ST: "NC",
    cityWithStateAbbr: "Minneapolis, NC",
  },
  {
    zip: "28653",
    ST: "NC",
    cityWithStateAbbr: "Montezuma, NC",
  },
  {
    zip: "28654",
    ST: "NC",
    cityWithStateAbbr: "Moravian Falls, NC",
  },
  {
    zip: "28655",
    ST: "NC",
    cityWithStateAbbr: "Morganton, NC",
  },
  {
    zip: "28656",
    ST: "NC",
    cityWithStateAbbr: "North Wilkesboro, NC",
  },
  {
    zip: "28657",
    ST: "NC",
    cityWithStateAbbr: "Newland, NC",
  },
  {
    zip: "28658",
    ST: "NC",
    cityWithStateAbbr: "Newton, NC",
  },
  {
    zip: "28659",
    ST: "NC",
    cityWithStateAbbr: "North Wilkesboro, NC",
  },
  {
    zip: "28660",
    ST: "NC",
    cityWithStateAbbr: "Olin, NC",
  },
  {
    zip: "28661",
    ST: "NC",
    cityWithStateAbbr: "Patterson, NC",
  },
  {
    zip: "28662",
    ST: "NC",
    cityWithStateAbbr: "Pineola, NC",
  },
  {
    zip: "28663",
    ST: "NC",
    cityWithStateAbbr: "Piney Creek, NC",
  },
  {
    zip: "28664",
    ST: "NC",
    cityWithStateAbbr: "Plumtree, NC",
  },
  {
    zip: "28665",
    ST: "NC",
    cityWithStateAbbr: "Purlear, NC",
  },
  {
    zip: "28666",
    ST: "NC",
    cityWithStateAbbr: "Icard, NC",
  },
  {
    zip: "28667",
    ST: "NC",
    cityWithStateAbbr: "Rhodhiss, NC",
  },
  {
    zip: "28668",
    ST: "NC",
    cityWithStateAbbr: "Roaring Gap, NC",
  },
  {
    zip: "28669",
    ST: "NC",
    cityWithStateAbbr: "Roaring River, NC",
  },
  {
    zip: "28670",
    ST: "NC",
    cityWithStateAbbr: "Ronda, NC",
  },
  {
    zip: "28671",
    ST: "NC",
    cityWithStateAbbr: "Rutherford College, NC",
  },
  {
    zip: "28672",
    ST: "NC",
    cityWithStateAbbr: "Scottville, NC",
  },
  {
    zip: "28673",
    ST: "NC",
    cityWithStateAbbr: "Sherrills Ford, NC",
  },
  {
    zip: "28675",
    ST: "NC",
    cityWithStateAbbr: "Sparta, NC",
  },
  {
    zip: "28676",
    ST: "NC",
    cityWithStateAbbr: "State Road, NC",
  },
  {
    zip: "28677",
    ST: "NC",
    cityWithStateAbbr: "Statesville, NC",
  },
  {
    zip: "28678",
    ST: "NC",
    cityWithStateAbbr: "Stony Point, NC",
  },
  {
    zip: "28679",
    ST: "NC",
    cityWithStateAbbr: "Sugar Grove, NC",
  },
  {
    zip: "28680",
    ST: "NC",
    cityWithStateAbbr: "Morganton, NC",
  },
  {
    zip: "28681",
    ST: "NC",
    cityWithStateAbbr: "Taylorsville, NC",
  },
  {
    zip: "28682",
    ST: "NC",
    cityWithStateAbbr: "Terrell, NC",
  },
  {
    zip: "28683",
    ST: "NC",
    cityWithStateAbbr: "Thurmond, NC",
  },
  {
    zip: "28684",
    ST: "NC",
    cityWithStateAbbr: "Todd, NC",
  },
  {
    zip: "28685",
    ST: "NC",
    cityWithStateAbbr: "Traphill, NC",
  },
  {
    zip: "28687",
    ST: "NC",
    cityWithStateAbbr: "Statesville, NC",
  },
  {
    zip: "28688",
    ST: "NC",
    cityWithStateAbbr: "Turnersburg, NC",
  },
  {
    zip: "28689",
    ST: "NC",
    cityWithStateAbbr: "Union Grove, NC",
  },
  {
    zip: "28690",
    ST: "NC",
    cityWithStateAbbr: "Valdese, NC",
  },
  {
    zip: "28691",
    ST: "NC",
    cityWithStateAbbr: "Valle Crucis, NC",
  },
  {
    zip: "28692",
    ST: "NC",
    cityWithStateAbbr: "Vilas, NC",
  },
  {
    zip: "28693",
    ST: "NC",
    cityWithStateAbbr: "Warrensville, NC",
  },
  {
    zip: "28694",
    ST: "NC",
    cityWithStateAbbr: "West Jefferson, NC",
  },
  {
    zip: "28697",
    ST: "NC",
    cityWithStateAbbr: "Wilkesboro, NC",
  },
  {
    zip: "28698",
    ST: "NC",
    cityWithStateAbbr: "Zionville, NC",
  },
  {
    zip: "28699",
    ST: "NC",
    cityWithStateAbbr: "Scotts, NC",
  },
  {
    zip: "28701",
    ST: "NC",
    cityWithStateAbbr: "Alexander, NC",
  },
  {
    zip: "28702",
    ST: "NC",
    cityWithStateAbbr: "Almond, NC",
  },
  {
    zip: "28704",
    ST: "NC",
    cityWithStateAbbr: "Arden, NC",
  },
  {
    zip: "28705",
    ST: "NC",
    cityWithStateAbbr: "Bakersville, NC",
  },
  {
    zip: "28707",
    ST: "NC",
    cityWithStateAbbr: "Balsam, NC",
  },
  {
    zip: "28708",
    ST: "NC",
    cityWithStateAbbr: "Balsam Grove, NC",
  },
  {
    zip: "28709",
    ST: "NC",
    cityWithStateAbbr: "Barnardsville, NC",
  },
  {
    zip: "28710",
    ST: "NC",
    cityWithStateAbbr: "Bat Cave, NC",
  },
  {
    zip: "28711",
    ST: "NC",
    cityWithStateAbbr: "Black Mountain, NC",
  },
  {
    zip: "28712",
    ST: "NC",
    cityWithStateAbbr: "Brevard, NC",
  },
  {
    zip: "28713",
    ST: "NC",
    cityWithStateAbbr: "Bryson City, NC",
  },
  {
    zip: "28714",
    ST: "NC",
    cityWithStateAbbr: "Burnsville, NC",
  },
  {
    zip: "28715",
    ST: "NC",
    cityWithStateAbbr: "Candler, NC",
  },
  {
    zip: "28716",
    ST: "NC",
    cityWithStateAbbr: "Canton, NC",
  },
  {
    zip: "28717",
    ST: "NC",
    cityWithStateAbbr: "Cashiers, NC",
  },
  {
    zip: "28718",
    ST: "NC",
    cityWithStateAbbr: "Cedar Mountain, NC",
  },
  {
    zip: "28719",
    ST: "NC",
    cityWithStateAbbr: "Cherokee, NC",
  },
  {
    zip: "28720",
    ST: "NC",
    cityWithStateAbbr: "Chimney Rock, NC",
  },
  {
    zip: "28721",
    ST: "NC",
    cityWithStateAbbr: "Clyde, NC",
  },
  {
    zip: "28722",
    ST: "NC",
    cityWithStateAbbr: "Columbus, NC",
  },
  {
    zip: "28723",
    ST: "NC",
    cityWithStateAbbr: "Cullowhee, NC",
  },
  {
    zip: "28724",
    ST: "NC",
    cityWithStateAbbr: "Dana, NC",
  },
  {
    zip: "28725",
    ST: "NC",
    cityWithStateAbbr: "Dillsboro, NC",
  },
  {
    zip: "28726",
    ST: "NC",
    cityWithStateAbbr: "East Flat Rock, NC",
  },
  {
    zip: "28727",
    ST: "NC",
    cityWithStateAbbr: "Edneyville, NC",
  },
  {
    zip: "28728",
    ST: "NC",
    cityWithStateAbbr: "Enka, NC",
  },
  {
    zip: "28729",
    ST: "NC",
    cityWithStateAbbr: "Etowah, NC",
  },
  {
    zip: "28730",
    ST: "NC",
    cityWithStateAbbr: "Fairview, NC",
  },
  {
    zip: "28731",
    ST: "NC",
    cityWithStateAbbr: "Flat Rock, NC",
  },
  {
    zip: "28732",
    ST: "NC",
    cityWithStateAbbr: "Fletcher, NC",
  },
  {
    zip: "28733",
    ST: "NC",
    cityWithStateAbbr: "Fontana Dam, NC",
  },
  {
    zip: "28734",
    ST: "NC",
    cityWithStateAbbr: "Franklin, NC",
  },
  {
    zip: "28735",
    ST: "NC",
    cityWithStateAbbr: "Gerton, NC",
  },
  {
    zip: "28736",
    ST: "NC",
    cityWithStateAbbr: "Glenville, NC",
  },
  {
    zip: "28737",
    ST: "NC",
    cityWithStateAbbr: "Glenwood, NC",
  },
  {
    zip: "28738",
    ST: "NC",
    cityWithStateAbbr: "Hazelwood, NC",
  },
  {
    zip: "28739",
    ST: "NC",
    cityWithStateAbbr: "Hendersonville, NC",
  },
  {
    zip: "28740",
    ST: "NC",
    cityWithStateAbbr: "Green Mountain, NC",
  },
  {
    zip: "28741",
    ST: "NC",
    cityWithStateAbbr: "Highlands, NC",
  },
  {
    zip: "28742",
    ST: "NC",
    cityWithStateAbbr: "Horse Shoe, NC",
  },
  {
    zip: "28743",
    ST: "NC",
    cityWithStateAbbr: "Hot Springs, NC",
  },
  {
    zip: "28744",
    ST: "NC",
    cityWithStateAbbr: "Franklin, NC",
  },
  {
    zip: "28745",
    ST: "NC",
    cityWithStateAbbr: "Lake Junaluska, NC",
  },
  {
    zip: "28746",
    ST: "NC",
    cityWithStateAbbr: "Lake Lure, NC",
  },
  {
    zip: "28747",
    ST: "NC",
    cityWithStateAbbr: "Lake Toxaway, NC",
  },
  {
    zip: "28748",
    ST: "NC",
    cityWithStateAbbr: "Leicester, NC",
  },
  {
    zip: "28749",
    ST: "NC",
    cityWithStateAbbr: "Little Switzerland, NC",
  },
  {
    zip: "28750",
    ST: "NC",
    cityWithStateAbbr: "Lynn, NC",
  },
  {
    zip: "28751",
    ST: "NC",
    cityWithStateAbbr: "Maggie Valley, NC",
  },
  {
    zip: "28752",
    ST: "NC",
    cityWithStateAbbr: "Marion, NC",
  },
  {
    zip: "28753",
    ST: "NC",
    cityWithStateAbbr: "Marshall, NC",
  },
  {
    zip: "28754",
    ST: "NC",
    cityWithStateAbbr: "Mars Hill, NC",
  },
  {
    zip: "28755",
    ST: "NC",
    cityWithStateAbbr: "Micaville, NC",
  },
  {
    zip: "28756",
    ST: "NC",
    cityWithStateAbbr: "Mill Spring, NC",
  },
  {
    zip: "28757",
    ST: "NC",
    cityWithStateAbbr: "Montreat, NC",
  },
  {
    zip: "28758",
    ST: "NC",
    cityWithStateAbbr: "Mountain Home, NC",
  },
  {
    zip: "28759",
    ST: "NC",
    cityWithStateAbbr: "Mills River, NC",
  },
  {
    zip: "28760",
    ST: "NC",
    cityWithStateAbbr: "Naples, NC",
  },
  {
    zip: "28761",
    ST: "NC",
    cityWithStateAbbr: "Nebo, NC",
  },
  {
    zip: "28762",
    ST: "NC",
    cityWithStateAbbr: "Old Fort, NC",
  },
  {
    zip: "28763",
    ST: "NC",
    cityWithStateAbbr: "Otto, NC",
  },
  {
    zip: "28765",
    ST: "NC",
    cityWithStateAbbr: "Penland, NC",
  },
  {
    zip: "28766",
    ST: "NC",
    cityWithStateAbbr: "Penrose, NC",
  },
  {
    zip: "28768",
    ST: "NC",
    cityWithStateAbbr: "Pisgah Forest, NC",
  },
  {
    zip: "28770",
    ST: "NC",
    cityWithStateAbbr: "Ridgecrest, NC",
  },
  {
    zip: "28771",
    ST: "NC",
    cityWithStateAbbr: "Robbinsville, NC",
  },
  {
    zip: "28772",
    ST: "NC",
    cityWithStateAbbr: "Rosman, NC",
  },
  {
    zip: "28773",
    ST: "NC",
    cityWithStateAbbr: "Saluda, NC",
  },
  {
    zip: "28774",
    ST: "NC",
    cityWithStateAbbr: "Sapphire, NC",
  },
  {
    zip: "28775",
    ST: "NC",
    cityWithStateAbbr: "Scaly Mountain, NC",
  },
  {
    zip: "28776",
    ST: "NC",
    cityWithStateAbbr: "Skyland, NC",
  },
  {
    zip: "28777",
    ST: "NC",
    cityWithStateAbbr: "Spruce Pine, NC",
  },
  {
    zip: "28778",
    ST: "NC",
    cityWithStateAbbr: "Swannanoa, NC",
  },
  {
    zip: "28779",
    ST: "NC",
    cityWithStateAbbr: "Sylva, NC",
  },
  {
    zip: "28781",
    ST: "NC",
    cityWithStateAbbr: "Topton, NC",
  },
  {
    zip: "28782",
    ST: "NC",
    cityWithStateAbbr: "Tryon, NC",
  },
  {
    zip: "28783",
    ST: "NC",
    cityWithStateAbbr: "Tuckasegee, NC",
  },
  {
    zip: "28784",
    ST: "NC",
    cityWithStateAbbr: "Tuxedo, NC",
  },
  {
    zip: "28785",
    ST: "NC",
    cityWithStateAbbr: "Waynesville, NC",
  },
  {
    zip: "28786",
    ST: "NC",
    cityWithStateAbbr: "Waynesville, NC",
  },
  {
    zip: "28787",
    ST: "NC",
    cityWithStateAbbr: "Weaverville, NC",
  },
  {
    zip: "28788",
    ST: "NC",
    cityWithStateAbbr: "Webster, NC",
  },
  {
    zip: "28789",
    ST: "NC",
    cityWithStateAbbr: "Whittier, NC",
  },
  {
    zip: "28790",
    ST: "NC",
    cityWithStateAbbr: "Zirconia, NC",
  },
  {
    zip: "28791",
    ST: "NC",
    cityWithStateAbbr: "Hendersonville, NC",
  },
  {
    zip: "28792",
    ST: "NC",
    cityWithStateAbbr: "Hendersonville, NC",
  },
  {
    zip: "28793",
    ST: "NC",
    cityWithStateAbbr: "Hendersonville, NC",
  },
  {
    zip: "28801",
    ST: "NC",
    cityWithStateAbbr: "Asheville, NC",
  },
  {
    zip: "28802",
    ST: "NC",
    cityWithStateAbbr: "Asheville, NC",
  },
  {
    zip: "28803",
    ST: "NC",
    cityWithStateAbbr: "Asheville, NC",
  },
  {
    zip: "28804",
    ST: "NC",
    cityWithStateAbbr: "Asheville, NC",
  },
  {
    zip: "28805",
    ST: "NC",
    cityWithStateAbbr: "Asheville, NC",
  },
  {
    zip: "28806",
    ST: "NC",
    cityWithStateAbbr: "Asheville, NC",
  },
  {
    zip: "28810",
    ST: "NC",
    cityWithStateAbbr: "Asheville, NC",
  },
  {
    zip: "28813",
    ST: "NC",
    cityWithStateAbbr: "Asheville, NC",
  },
  {
    zip: "28814",
    ST: "NC",
    cityWithStateAbbr: "Asheville, NC",
  },
  {
    zip: "28815",
    ST: "NC",
    cityWithStateAbbr: "Asheville, NC",
  },
  {
    zip: "28816",
    ST: "NC",
    cityWithStateAbbr: "Asheville, NC",
  },
  {
    zip: "28901",
    ST: "NC",
    cityWithStateAbbr: "Andrews, NC",
  },
  {
    zip: "28902",
    ST: "NC",
    cityWithStateAbbr: "Brasstown, NC",
  },
  {
    zip: "28903",
    ST: "NC",
    cityWithStateAbbr: "Culberson, NC",
  },
  {
    zip: "28904",
    ST: "NC",
    cityWithStateAbbr: "Hayesville, NC",
  },
  {
    zip: "28905",
    ST: "NC",
    cityWithStateAbbr: "Marble, NC",
  },
  {
    zip: "28906",
    ST: "NC",
    cityWithStateAbbr: "Murphy, NC",
  },
  {
    zip: "28909",
    ST: "NC",
    cityWithStateAbbr: "Warne, NC",
  },
  {
    zip: "29001",
    ST: "SC",
    cityWithStateAbbr: "Alcolu, SC",
  },
  {
    zip: "29002",
    ST: "SC",
    cityWithStateAbbr: "Ballentine, SC",
  },
  {
    zip: "29003",
    ST: "SC",
    cityWithStateAbbr: "Bamberg, SC",
  },
  {
    zip: "29006",
    ST: "SC",
    cityWithStateAbbr: "Batesburg, SC",
  },
  {
    zip: "29009",
    ST: "SC",
    cityWithStateAbbr: "Bethune, SC",
  },
  {
    zip: "29010",
    ST: "SC",
    cityWithStateAbbr: "Bishopville, SC",
  },
  {
    zip: "29014",
    ST: "SC",
    cityWithStateAbbr: "Blackstock, SC",
  },
  {
    zip: "29015",
    ST: "SC",
    cityWithStateAbbr: "Blair, SC",
  },
  {
    zip: "29016",
    ST: "SC",
    cityWithStateAbbr: "Blythewood, SC",
  },
  {
    zip: "29018",
    ST: "SC",
    cityWithStateAbbr: "Bowman, SC",
  },
  {
    zip: "29020",
    ST: "SC",
    cityWithStateAbbr: "Camden, SC",
  },
  {
    zip: "29021",
    ST: "SC",
    cityWithStateAbbr: "Camden, SC",
  },
  {
    zip: "29030",
    ST: "SC",
    cityWithStateAbbr: "Cameron, SC",
  },
  {
    zip: "29031",
    ST: "SC",
    cityWithStateAbbr: "Carlisle, SC",
  },
  {
    zip: "29032",
    ST: "SC",
    cityWithStateAbbr: "Cassatt, SC",
  },
  {
    zip: "29033",
    ST: "SC",
    cityWithStateAbbr: "Cayce, SC",
  },
  {
    zip: "29036",
    ST: "SC",
    cityWithStateAbbr: "Chapin, SC",
  },
  {
    zip: "29037",
    ST: "SC",
    cityWithStateAbbr: "Chappells, SC",
  },
  {
    zip: "29038",
    ST: "SC",
    cityWithStateAbbr: "Cope, SC",
  },
  {
    zip: "29039",
    ST: "SC",
    cityWithStateAbbr: "Cordova, SC",
  },
  {
    zip: "29040",
    ST: "SC",
    cityWithStateAbbr: "Dalzell, SC",
  },
  {
    zip: "29041",
    ST: "SC",
    cityWithStateAbbr: "Davis Station, SC",
  },
  {
    zip: "29042",
    ST: "SC",
    cityWithStateAbbr: "Denmark, SC",
  },
  {
    zip: "29044",
    ST: "SC",
    cityWithStateAbbr: "Eastover, SC",
  },
  {
    zip: "29045",
    ST: "SC",
    cityWithStateAbbr: "Elgin, SC",
  },
  {
    zip: "29046",
    ST: "SC",
    cityWithStateAbbr: "Elliott, SC",
  },
  {
    zip: "29047",
    ST: "SC",
    cityWithStateAbbr: "Elloree, SC",
  },
  {
    zip: "29048",
    ST: "SC",
    cityWithStateAbbr: "Eutawville, SC",
  },
  {
    zip: "29051",
    ST: "SC",
    cityWithStateAbbr: "Gable, SC",
  },
  {
    zip: "29052",
    ST: "SC",
    cityWithStateAbbr: "Gadsden, SC",
  },
  {
    zip: "29053",
    ST: "SC",
    cityWithStateAbbr: "Gaston, SC",
  },
  {
    zip: "29054",
    ST: "SC",
    cityWithStateAbbr: "Gilbert, SC",
  },
  {
    zip: "29055",
    ST: "SC",
    cityWithStateAbbr: "Great Falls, SC",
  },
  {
    zip: "29056",
    ST: "SC",
    cityWithStateAbbr: "Greeleyville, SC",
  },
  {
    zip: "29058",
    ST: "SC",
    cityWithStateAbbr: "Heath Springs, SC",
  },
  {
    zip: "29059",
    ST: "SC",
    cityWithStateAbbr: "Holly Hill, SC",
  },
  {
    zip: "29061",
    ST: "SC",
    cityWithStateAbbr: "Hopkins, SC",
  },
  {
    zip: "29062",
    ST: "SC",
    cityWithStateAbbr: "Horatio, SC",
  },
  {
    zip: "29063",
    ST: "SC",
    cityWithStateAbbr: "Irmo, SC",
  },
  {
    zip: "29065",
    ST: "SC",
    cityWithStateAbbr: "Jenkinsville, SC",
  },
  {
    zip: "29067",
    ST: "SC",
    cityWithStateAbbr: "Kershaw, SC",
  },
  {
    zip: "29069",
    ST: "SC",
    cityWithStateAbbr: "Lamar, SC",
  },
  {
    zip: "29070",
    ST: "SC",
    cityWithStateAbbr: "Leesville, SC",
  },
  {
    zip: "29071",
    ST: "SC",
    cityWithStateAbbr: "Lexington, SC",
  },
  {
    zip: "29072",
    ST: "SC",
    cityWithStateAbbr: "Lexington, SC",
  },
  {
    zip: "29073",
    ST: "SC",
    cityWithStateAbbr: "Lexington, SC",
  },
  {
    zip: "29074",
    ST: "SC",
    cityWithStateAbbr: "Liberty Hill, SC",
  },
  {
    zip: "29075",
    ST: "SC",
    cityWithStateAbbr: "Little Mountain, SC",
  },
  {
    zip: "29078",
    ST: "SC",
    cityWithStateAbbr: "Lugoff, SC",
  },
  {
    zip: "29079",
    ST: "SC",
    cityWithStateAbbr: "Lydia, SC",
  },
  {
    zip: "29080",
    ST: "SC",
    cityWithStateAbbr: "Lynchburg, SC",
  },
  {
    zip: "29081",
    ST: "SC",
    cityWithStateAbbr: "Ehrhardt, SC",
  },
  {
    zip: "29082",
    ST: "SC",
    cityWithStateAbbr: "Lodge, SC",
  },
  {
    zip: "29101",
    ST: "SC",
    cityWithStateAbbr: "Mc Bee, SC",
  },
  {
    zip: "29102",
    ST: "SC",
    cityWithStateAbbr: "Manning, SC",
  },
  {
    zip: "29104",
    ST: "SC",
    cityWithStateAbbr: "Mayesville, SC",
  },
  {
    zip: "29105",
    ST: "SC",
    cityWithStateAbbr: "Monetta, SC",
  },
  {
    zip: "29107",
    ST: "SC",
    cityWithStateAbbr: "Neeses, SC",
  },
  {
    zip: "29108",
    ST: "SC",
    cityWithStateAbbr: "Newberry, SC",
  },
  {
    zip: "29111",
    ST: "SC",
    cityWithStateAbbr: "New Zion, SC",
  },
  {
    zip: "29112",
    ST: "SC",
    cityWithStateAbbr: "North, SC",
  },
  {
    zip: "29113",
    ST: "SC",
    cityWithStateAbbr: "Norway, SC",
  },
  {
    zip: "29114",
    ST: "SC",
    cityWithStateAbbr: "Olanta, SC",
  },
  {
    zip: "29115",
    ST: "SC",
    cityWithStateAbbr: "Orangeburg, SC",
  },
  {
    zip: "29116",
    ST: "SC",
    cityWithStateAbbr: "Orangeburg, SC",
  },
  {
    zip: "29117",
    ST: "SC",
    cityWithStateAbbr: "Orangeburg, SC",
  },
  {
    zip: "29118",
    ST: "SC",
    cityWithStateAbbr: "Orangeburg, SC",
  },
  {
    zip: "29122",
    ST: "SC",
    cityWithStateAbbr: "Peak, SC",
  },
  {
    zip: "29123",
    ST: "SC",
    cityWithStateAbbr: "Pelion, SC",
  },
  {
    zip: "29125",
    ST: "SC",
    cityWithStateAbbr: "Pinewood, SC",
  },
  {
    zip: "29126",
    ST: "SC",
    cityWithStateAbbr: "Pomaria, SC",
  },
  {
    zip: "29127",
    ST: "SC",
    cityWithStateAbbr: "Prosperity, SC",
  },
  {
    zip: "29128",
    ST: "SC",
    cityWithStateAbbr: "Rembert, SC",
  },
  {
    zip: "29129",
    ST: "SC",
    cityWithStateAbbr: "Ridge Spring, SC",
  },
  {
    zip: "29130",
    ST: "SC",
    cityWithStateAbbr: "Ridgeway, SC",
  },
  {
    zip: "29132",
    ST: "SC",
    cityWithStateAbbr: "Rion, SC",
  },
  {
    zip: "29133",
    ST: "SC",
    cityWithStateAbbr: "Rowesville, SC",
  },
  {
    zip: "29135",
    ST: "SC",
    cityWithStateAbbr: "Saint Matthews, SC",
  },
  {
    zip: "29137",
    ST: "SC",
    cityWithStateAbbr: "Salley, SC",
  },
  {
    zip: "29138",
    ST: "SC",
    cityWithStateAbbr: "Saluda, SC",
  },
  {
    zip: "29142",
    ST: "SC",
    cityWithStateAbbr: "Santee, SC",
  },
  {
    zip: "29143",
    ST: "SC",
    cityWithStateAbbr: "Sardinia, SC",
  },
  {
    zip: "29145",
    ST: "SC",
    cityWithStateAbbr: "Silverstreet, SC",
  },
  {
    zip: "29146",
    ST: "SC",
    cityWithStateAbbr: "Springfield, SC",
  },
  {
    zip: "29147",
    ST: "SC",
    cityWithStateAbbr: "State Park, SC",
  },
  {
    zip: "29148",
    ST: "SC",
    cityWithStateAbbr: "Summerton, SC",
  },
  {
    zip: "29150",
    ST: "SC",
    cityWithStateAbbr: "Sumter, SC",
  },
  {
    zip: "29151",
    ST: "SC",
    cityWithStateAbbr: "Sumter, SC",
  },
  {
    zip: "29152",
    ST: "SC",
    cityWithStateAbbr: "Shaw Afb, SC",
  },
  {
    zip: "29153",
    ST: "SC",
    cityWithStateAbbr: "Sumter, SC",
  },
  {
    zip: "29154",
    ST: "SC",
    cityWithStateAbbr: "Sumter, SC",
  },
  {
    zip: "29160",
    ST: "SC",
    cityWithStateAbbr: "Swansea, SC",
  },
  {
    zip: "29161",
    ST: "SC",
    cityWithStateAbbr: "Timmonsville, SC",
  },
  {
    zip: "29162",
    ST: "SC",
    cityWithStateAbbr: "Turbeville, SC",
  },
  {
    zip: "29163",
    ST: "SC",
    cityWithStateAbbr: "Vance, SC",
  },
  {
    zip: "29164",
    ST: "SC",
    cityWithStateAbbr: "Wagener, SC",
  },
  {
    zip: "29166",
    ST: "SC",
    cityWithStateAbbr: "Ward, SC",
  },
  {
    zip: "29168",
    ST: "SC",
    cityWithStateAbbr: "Wedgefield, SC",
  },
  {
    zip: "29169",
    ST: "SC",
    cityWithStateAbbr: "West Columbia, SC",
  },
  {
    zip: "29170",
    ST: "SC",
    cityWithStateAbbr: "West Columbia, SC",
  },
  {
    zip: "29171",
    ST: "SC",
    cityWithStateAbbr: "West Columbia, SC",
  },
  {
    zip: "29172",
    ST: "SC",
    cityWithStateAbbr: "West Columbia, SC",
  },
  {
    zip: "29175",
    ST: "SC",
    cityWithStateAbbr: "Westville, SC",
  },
  {
    zip: "29177",
    ST: "SC",
    cityWithStateAbbr: "White Rock, SC",
  },
  {
    zip: "29178",
    ST: "SC",
    cityWithStateAbbr: "Whitmire, SC",
  },
  {
    zip: "29180",
    ST: "SC",
    cityWithStateAbbr: "Winnsboro, SC",
  },
  {
    zip: "29201",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29202",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29203",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29204",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29205",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29206",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29207",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29208",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29209",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29210",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29211",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29212",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29214",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29215",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29216",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29217",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29218",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29219",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29220",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29221",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29222",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29223",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29224",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29225",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29226",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29227",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29228",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29229",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29230",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29240",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29250",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29260",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29290",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29292",
    ST: "SC",
    cityWithStateAbbr: "Columbia, SC",
  },
  {
    zip: "29301",
    ST: "SC",
    cityWithStateAbbr: "Spartanburg, SC",
  },
  {
    zip: "29302",
    ST: "SC",
    cityWithStateAbbr: "Spartanburg, SC",
  },
  {
    zip: "29303",
    ST: "SC",
    cityWithStateAbbr: "Spartanburg, SC",
  },
  {
    zip: "29304",
    ST: "SC",
    cityWithStateAbbr: "Spartanburg, SC",
  },
  {
    zip: "29305",
    ST: "SC",
    cityWithStateAbbr: "Spartanburg, SC",
  },
  {
    zip: "29306",
    ST: "SC",
    cityWithStateAbbr: "Spartanburg, SC",
  },
  {
    zip: "29307",
    ST: "SC",
    cityWithStateAbbr: "Spartanburg, SC",
  },
  {
    zip: "29316",
    ST: "SC",
    cityWithStateAbbr: "Boiling Springs, SC",
  },
  {
    zip: "29318",
    ST: "SC",
    cityWithStateAbbr: "Boiling Springs, SC",
  },
  {
    zip: "29319",
    ST: "SC",
    cityWithStateAbbr: "Spartanburg, SC",
  },
  {
    zip: "29320",
    ST: "SC",
    cityWithStateAbbr: "Arcadia, SC",
  },
  {
    zip: "29321",
    ST: "SC",
    cityWithStateAbbr: "Buffalo, SC",
  },
  {
    zip: "29322",
    ST: "SC",
    cityWithStateAbbr: "Campobello, SC",
  },
  {
    zip: "29323",
    ST: "SC",
    cityWithStateAbbr: "Chesnee, SC",
  },
  {
    zip: "29324",
    ST: "SC",
    cityWithStateAbbr: "Clifton, SC",
  },
  {
    zip: "29325",
    ST: "SC",
    cityWithStateAbbr: "Clinton, SC",
  },
  {
    zip: "29329",
    ST: "SC",
    cityWithStateAbbr: "Converse, SC",
  },
  {
    zip: "29330",
    ST: "SC",
    cityWithStateAbbr: "Cowpens, SC",
  },
  {
    zip: "29331",
    ST: "SC",
    cityWithStateAbbr: "Cross Anchor, SC",
  },
  {
    zip: "29332",
    ST: "SC",
    cityWithStateAbbr: "Cross Hill, SC",
  },
  {
    zip: "29333",
    ST: "SC",
    cityWithStateAbbr: "Drayton, SC",
  },
  {
    zip: "29334",
    ST: "SC",
    cityWithStateAbbr: "Duncan, SC",
  },
  {
    zip: "29335",
    ST: "SC",
    cityWithStateAbbr: "Enoree, SC",
  },
  {
    zip: "29336",
    ST: "SC",
    cityWithStateAbbr: "Fairforest, SC",
  },
  {
    zip: "29338",
    ST: "SC",
    cityWithStateAbbr: "Fingerville, SC",
  },
  {
    zip: "29340",
    ST: "SC",
    cityWithStateAbbr: "Gaffney, SC",
  },
  {
    zip: "29341",
    ST: "SC",
    cityWithStateAbbr: "Gaffney, SC",
  },
  {
    zip: "29342",
    ST: "SC",
    cityWithStateAbbr: "Gaffney, SC",
  },
  {
    zip: "29346",
    ST: "SC",
    cityWithStateAbbr: "Glendale, SC",
  },
  {
    zip: "29348",
    ST: "SC",
    cityWithStateAbbr: "Gramling, SC",
  },
  {
    zip: "29349",
    ST: "SC",
    cityWithStateAbbr: "Inman, SC",
  },
  {
    zip: "29351",
    ST: "SC",
    cityWithStateAbbr: "Joanna, SC",
  },
  {
    zip: "29353",
    ST: "SC",
    cityWithStateAbbr: "Jonesville, SC",
  },
  {
    zip: "29355",
    ST: "SC",
    cityWithStateAbbr: "Kinards, SC",
  },
  {
    zip: "29356",
    ST: "SC",
    cityWithStateAbbr: "Landrum, SC",
  },
  {
    zip: "29360",
    ST: "SC",
    cityWithStateAbbr: "Laurens, SC",
  },
  {
    zip: "29364",
    ST: "SC",
    cityWithStateAbbr: "Lockhart, SC",
  },
  {
    zip: "29365",
    ST: "SC",
    cityWithStateAbbr: "Lyman, SC",
  },
  {
    zip: "29368",
    ST: "SC",
    cityWithStateAbbr: "Mayo, SC",
  },
  {
    zip: "29369",
    ST: "SC",
    cityWithStateAbbr: "Moore, SC",
  },
  {
    zip: "29370",
    ST: "SC",
    cityWithStateAbbr: "Mountville, SC",
  },
  {
    zip: "29372",
    ST: "SC",
    cityWithStateAbbr: "Pacolet, SC",
  },
  {
    zip: "29373",
    ST: "SC",
    cityWithStateAbbr: "Pacolet Mills, SC",
  },
  {
    zip: "29374",
    ST: "SC",
    cityWithStateAbbr: "Pauline, SC",
  },
  {
    zip: "29375",
    ST: "SC",
    cityWithStateAbbr: "Reidville, SC",
  },
  {
    zip: "29376",
    ST: "SC",
    cityWithStateAbbr: "Roebuck, SC",
  },
  {
    zip: "29377",
    ST: "SC",
    cityWithStateAbbr: "Startex, SC",
  },
  {
    zip: "29378",
    ST: "SC",
    cityWithStateAbbr: "Una, SC",
  },
  {
    zip: "29379",
    ST: "SC",
    cityWithStateAbbr: "Union, SC",
  },
  {
    zip: "29384",
    ST: "SC",
    cityWithStateAbbr: "Waterloo, SC",
  },
  {
    zip: "29385",
    ST: "SC",
    cityWithStateAbbr: "Wellford, SC",
  },
  {
    zip: "29386",
    ST: "SC",
    cityWithStateAbbr: "White Stone, SC",
  },
  {
    zip: "29388",
    ST: "SC",
    cityWithStateAbbr: "Woodruff, SC",
  },
  {
    zip: "29395",
    ST: "SC",
    cityWithStateAbbr: "Jonesville, SC",
  },
  {
    zip: "29401",
    ST: "SC",
    cityWithStateAbbr: "Charleston, SC",
  },
  {
    zip: "29402",
    ST: "SC",
    cityWithStateAbbr: "Charleston, SC",
  },
  {
    zip: "29403",
    ST: "SC",
    cityWithStateAbbr: "Charleston, SC",
  },
  {
    zip: "29404",
    ST: "SC",
    cityWithStateAbbr: "Charleston Afb, SC",
  },
  {
    zip: "29405",
    ST: "SC",
    cityWithStateAbbr: "North Charleston, SC",
  },
  {
    zip: "29406",
    ST: "SC",
    cityWithStateAbbr: "Charleston, SC",
  },
  {
    zip: "29407",
    ST: "SC",
    cityWithStateAbbr: "Charleston, SC",
  },
  {
    zip: "29409",
    ST: "SC",
    cityWithStateAbbr: "Charleston, SC",
  },
  {
    zip: "29410",
    ST: "SC",
    cityWithStateAbbr: "Hanahan, SC",
  },
  {
    zip: "29412",
    ST: "SC",
    cityWithStateAbbr: "Charleston, SC",
  },
  {
    zip: "29413",
    ST: "SC",
    cityWithStateAbbr: "Charleston, SC",
  },
  {
    zip: "29414",
    ST: "SC",
    cityWithStateAbbr: "Charleston, SC",
  },
  {
    zip: "29415",
    ST: "SC",
    cityWithStateAbbr: "North Charleston, SC",
  },
  {
    zip: "29416",
    ST: "SC",
    cityWithStateAbbr: "Charleston, SC",
  },
  {
    zip: "29417",
    ST: "SC",
    cityWithStateAbbr: "Charleston, SC",
  },
  {
    zip: "29418",
    ST: "SC",
    cityWithStateAbbr: "North Charleston, SC",
  },
  {
    zip: "29419",
    ST: "SC",
    cityWithStateAbbr: "North Charleston, SC",
  },
  {
    zip: "29420",
    ST: "SC",
    cityWithStateAbbr: "North Charleston, SC",
  },
  {
    zip: "29422",
    ST: "SC",
    cityWithStateAbbr: "Charleston, SC",
  },
  {
    zip: "29423",
    ST: "SC",
    cityWithStateAbbr: "Charleston, SC",
  },
  {
    zip: "29424",
    ST: "SC",
    cityWithStateAbbr: "Charleston, SC",
  },
  {
    zip: "29425",
    ST: "SC",
    cityWithStateAbbr: "Charleston, SC",
  },
  {
    zip: "29426",
    ST: "SC",
    cityWithStateAbbr: "Adams Run, SC",
  },
  {
    zip: "29429",
    ST: "SC",
    cityWithStateAbbr: "Awendaw, SC",
  },
  {
    zip: "29430",
    ST: "SC",
    cityWithStateAbbr: "Bethera, SC",
  },
  {
    zip: "29431",
    ST: "SC",
    cityWithStateAbbr: "Bonneau, SC",
  },
  {
    zip: "29432",
    ST: "SC",
    cityWithStateAbbr: "Branchville, SC",
  },
  {
    zip: "29433",
    ST: "SC",
    cityWithStateAbbr: "Canadys, SC",
  },
  {
    zip: "29434",
    ST: "SC",
    cityWithStateAbbr: "Cordesville, SC",
  },
  {
    zip: "29435",
    ST: "SC",
    cityWithStateAbbr: "Cottageville, SC",
  },
  {
    zip: "29436",
    ST: "SC",
    cityWithStateAbbr: "Cross, SC",
  },
  {
    zip: "29437",
    ST: "SC",
    cityWithStateAbbr: "Dorchester, SC",
  },
  {
    zip: "29438",
    ST: "SC",
    cityWithStateAbbr: "Edisto Island, SC",
  },
  {
    zip: "29439",
    ST: "SC",
    cityWithStateAbbr: "Folly Beach, SC",
  },
  {
    zip: "29440",
    ST: "SC",
    cityWithStateAbbr: "Georgetown, SC",
  },
  {
    zip: "29442",
    ST: "SC",
    cityWithStateAbbr: "Georgetown, SC",
  },
  {
    zip: "29445",
    ST: "SC",
    cityWithStateAbbr: "Goose Creek, SC",
  },
  {
    zip: "29446",
    ST: "SC",
    cityWithStateAbbr: "Green Pond, SC",
  },
  {
    zip: "29447",
    ST: "SC",
    cityWithStateAbbr: "Grover, SC",
  },
  {
    zip: "29448",
    ST: "SC",
    cityWithStateAbbr: "Harleyville, SC",
  },
  {
    zip: "29449",
    ST: "SC",
    cityWithStateAbbr: "Hollywood, SC",
  },
  {
    zip: "29450",
    ST: "SC",
    cityWithStateAbbr: "Huger, SC",
  },
  {
    zip: "29451",
    ST: "SC",
    cityWithStateAbbr: "Isle Of Palms, SC",
  },
  {
    zip: "29452",
    ST: "SC",
    cityWithStateAbbr: "Jacksonboro, SC",
  },
  {
    zip: "29453",
    ST: "SC",
    cityWithStateAbbr: "Jamestown, SC",
  },
  {
    zip: "29455",
    ST: "SC",
    cityWithStateAbbr: "Johns Island, SC",
  },
  {
    zip: "29456",
    ST: "SC",
    cityWithStateAbbr: "Ladson, SC",
  },
  {
    zip: "29457",
    ST: "SC",
    cityWithStateAbbr: "Johns Island, SC",
  },
  {
    zip: "29458",
    ST: "SC",
    cityWithStateAbbr: "Mc Clellanville, SC",
  },
  {
    zip: "29461",
    ST: "SC",
    cityWithStateAbbr: "Moncks Corner, SC",
  },
  {
    zip: "29464",
    ST: "SC",
    cityWithStateAbbr: "Mount Pleasant, SC",
  },
  {
    zip: "29465",
    ST: "SC",
    cityWithStateAbbr: "Mount Pleasant, SC",
  },
  {
    zip: "29466",
    ST: "SC",
    cityWithStateAbbr: "Mount Pleasant, SC",
  },
  {
    zip: "29468",
    ST: "SC",
    cityWithStateAbbr: "Pineville, SC",
  },
  {
    zip: "29469",
    ST: "SC",
    cityWithStateAbbr: "Pinopolis, SC",
  },
  {
    zip: "29470",
    ST: "SC",
    cityWithStateAbbr: "Ravenel, SC",
  },
  {
    zip: "29471",
    ST: "SC",
    cityWithStateAbbr: "Reevesville, SC",
  },
  {
    zip: "29472",
    ST: "SC",
    cityWithStateAbbr: "Ridgeville, SC",
  },
  {
    zip: "29474",
    ST: "SC",
    cityWithStateAbbr: "Round O, SC",
  },
  {
    zip: "29475",
    ST: "SC",
    cityWithStateAbbr: "Ruffin, SC",
  },
  {
    zip: "29476",
    ST: "SC",
    cityWithStateAbbr: "Russellville, SC",
  },
  {
    zip: "29477",
    ST: "SC",
    cityWithStateAbbr: "Saint George, SC",
  },
  {
    zip: "29479",
    ST: "SC",
    cityWithStateAbbr: "Saint Stephen, SC",
  },
  {
    zip: "29481",
    ST: "SC",
    cityWithStateAbbr: "Smoaks, SC",
  },
  {
    zip: "29482",
    ST: "SC",
    cityWithStateAbbr: "Sullivans Island, SC",
  },
  {
    zip: "29483",
    ST: "SC",
    cityWithStateAbbr: "Summerville, SC",
  },
  {
    zip: "29484",
    ST: "SC",
    cityWithStateAbbr: "Summerville, SC",
  },
  {
    zip: "29485",
    ST: "SC",
    cityWithStateAbbr: "Summerville, SC",
  },
  {
    zip: "29486",
    ST: "SC",
    cityWithStateAbbr: "Summerville, SC",
  },
  {
    zip: "29487",
    ST: "SC",
    cityWithStateAbbr: "Wadmalaw Island, SC",
  },
  {
    zip: "29488",
    ST: "SC",
    cityWithStateAbbr: "Walterboro, SC",
  },
  {
    zip: "29492",
    ST: "SC",
    cityWithStateAbbr: "Charleston, SC",
  },
  {
    zip: "29493",
    ST: "SC",
    cityWithStateAbbr: "Williams, SC",
  },
  {
    zip: "29501",
    ST: "SC",
    cityWithStateAbbr: "Florence, SC",
  },
  {
    zip: "29502",
    ST: "SC",
    cityWithStateAbbr: "Florence, SC",
  },
  {
    zip: "29503",
    ST: "SC",
    cityWithStateAbbr: "Florence, SC",
  },
  {
    zip: "29504",
    ST: "SC",
    cityWithStateAbbr: "Florence, SC",
  },
  {
    zip: "29505",
    ST: "SC",
    cityWithStateAbbr: "Florence, SC",
  },
  {
    zip: "29506",
    ST: "SC",
    cityWithStateAbbr: "Florence, SC",
  },
  {
    zip: "29510",
    ST: "SC",
    cityWithStateAbbr: "Andrews, SC",
  },
  {
    zip: "29511",
    ST: "SC",
    cityWithStateAbbr: "Aynor, SC",
  },
  {
    zip: "29512",
    ST: "SC",
    cityWithStateAbbr: "Bennettsville, SC",
  },
  {
    zip: "29516",
    ST: "SC",
    cityWithStateAbbr: "Blenheim, SC",
  },
  {
    zip: "29518",
    ST: "SC",
    cityWithStateAbbr: "Cades, SC",
  },
  {
    zip: "29519",
    ST: "SC",
    cityWithStateAbbr: "Centenary, SC",
  },
  {
    zip: "29520",
    ST: "SC",
    cityWithStateAbbr: "Cheraw, SC",
  },
  {
    zip: "29525",
    ST: "SC",
    cityWithStateAbbr: "Clio, SC",
  },
  {
    zip: "29526",
    ST: "SC",
    cityWithStateAbbr: "Conway, SC",
  },
  {
    zip: "29527",
    ST: "SC",
    cityWithStateAbbr: "Conway, SC",
  },
  {
    zip: "29528",
    ST: "SC",
    cityWithStateAbbr: "Conway, SC",
  },
  {
    zip: "29530",
    ST: "SC",
    cityWithStateAbbr: "Coward, SC",
  },
  {
    zip: "29532",
    ST: "SC",
    cityWithStateAbbr: "Darlington, SC",
  },
  {
    zip: "29536",
    ST: "SC",
    cityWithStateAbbr: "Dillon, SC",
  },
  {
    zip: "29540",
    ST: "SC",
    cityWithStateAbbr: "Darlington, SC",
  },
  {
    zip: "29541",
    ST: "SC",
    cityWithStateAbbr: "Effingham, SC",
  },
  {
    zip: "29543",
    ST: "SC",
    cityWithStateAbbr: "Fork, SC",
  },
  {
    zip: "29544",
    ST: "SC",
    cityWithStateAbbr: "Galivants Ferry, SC",
  },
  {
    zip: "29545",
    ST: "SC",
    cityWithStateAbbr: "Green Sea, SC",
  },
  {
    zip: "29546",
    ST: "SC",
    cityWithStateAbbr: "Gresham, SC",
  },
  {
    zip: "29547",
    ST: "SC",
    cityWithStateAbbr: "Hamer, SC",
  },
  {
    zip: "29550",
    ST: "SC",
    cityWithStateAbbr: "Hartsville, SC",
  },
  {
    zip: "29551",
    ST: "SC",
    cityWithStateAbbr: "Hartsville, SC",
  },
  {
    zip: "29554",
    ST: "SC",
    cityWithStateAbbr: "Hemingway, SC",
  },
  {
    zip: "29555",
    ST: "SC",
    cityWithStateAbbr: "Johnsonville, SC",
  },
  {
    zip: "29556",
    ST: "SC",
    cityWithStateAbbr: "Kingstree, SC",
  },
  {
    zip: "29560",
    ST: "SC",
    cityWithStateAbbr: "Lake City, SC",
  },
  {
    zip: "29563",
    ST: "SC",
    cityWithStateAbbr: "Lake View, SC",
  },
  {
    zip: "29564",
    ST: "SC",
    cityWithStateAbbr: "Lane, SC",
  },
  {
    zip: "29565",
    ST: "SC",
    cityWithStateAbbr: "Latta, SC",
  },
  {
    zip: "29566",
    ST: "SC",
    cityWithStateAbbr: "Little River, SC",
  },
  {
    zip: "29567",
    ST: "SC",
    cityWithStateAbbr: "Little Rock, SC",
  },
  {
    zip: "29568",
    ST: "SC",
    cityWithStateAbbr: "Longs, SC",
  },
  {
    zip: "29569",
    ST: "SC",
    cityWithStateAbbr: "Loris, SC",
  },
  {
    zip: "29570",
    ST: "SC",
    cityWithStateAbbr: "Mc Coll, SC",
  },
  {
    zip: "29571",
    ST: "SC",
    cityWithStateAbbr: "Marion, SC",
  },
  {
    zip: "29572",
    ST: "SC",
    cityWithStateAbbr: "Myrtle Beach, SC",
  },
  {
    zip: "29573",
    ST: "SC",
    cityWithStateAbbr: "Minturn, SC",
  },
  {
    zip: "29574",
    ST: "SC",
    cityWithStateAbbr: "Mullins, SC",
  },
  {
    zip: "29575",
    ST: "SC",
    cityWithStateAbbr: "Myrtle Beach, SC",
  },
  {
    zip: "29576",
    ST: "SC",
    cityWithStateAbbr: "Murrells Inlet, SC",
  },
  {
    zip: "29577",
    ST: "SC",
    cityWithStateAbbr: "Myrtle Beach, SC",
  },
  {
    zip: "29578",
    ST: "SC",
    cityWithStateAbbr: "Myrtle Beach, SC",
  },
  {
    zip: "29579",
    ST: "SC",
    cityWithStateAbbr: "Myrtle Beach, SC",
  },
  {
    zip: "29580",
    ST: "SC",
    cityWithStateAbbr: "Nesmith, SC",
  },
  {
    zip: "29581",
    ST: "SC",
    cityWithStateAbbr: "Nichols, SC",
  },
  {
    zip: "29582",
    ST: "SC",
    cityWithStateAbbr: "North Myrtle Beach, SC",
  },
  {
    zip: "29583",
    ST: "SC",
    cityWithStateAbbr: "Pamplico, SC",
  },
  {
    zip: "29584",
    ST: "SC",
    cityWithStateAbbr: "Patrick, SC",
  },
  {
    zip: "29585",
    ST: "SC",
    cityWithStateAbbr: "Pawleys Island, SC",
  },
  {
    zip: "29587",
    ST: "SC",
    cityWithStateAbbr: "Myrtle Beach, SC",
  },
  {
    zip: "29588",
    ST: "SC",
    cityWithStateAbbr: "Myrtle Beach, SC",
  },
  {
    zip: "29589",
    ST: "SC",
    cityWithStateAbbr: "Rains, SC",
  },
  {
    zip: "29590",
    ST: "SC",
    cityWithStateAbbr: "Salters, SC",
  },
  {
    zip: "29591",
    ST: "SC",
    cityWithStateAbbr: "Scranton, SC",
  },
  {
    zip: "29592",
    ST: "SC",
    cityWithStateAbbr: "Sellers, SC",
  },
  {
    zip: "29593",
    ST: "SC",
    cityWithStateAbbr: "Society Hill, SC",
  },
  {
    zip: "29594",
    ST: "SC",
    cityWithStateAbbr: "Tatum, SC",
  },
  {
    zip: "29596",
    ST: "SC",
    cityWithStateAbbr: "Wallace, SC",
  },
  {
    zip: "29597",
    ST: "SC",
    cityWithStateAbbr: "North Myrtle Beach, SC",
  },
  {
    zip: "29598",
    ST: "SC",
    cityWithStateAbbr: "North Myrtle Beach, SC",
  },
  {
    zip: "29601",
    ST: "SC",
    cityWithStateAbbr: "Greenville, SC",
  },
  {
    zip: "29602",
    ST: "SC",
    cityWithStateAbbr: "Greenville, SC",
  },
  {
    zip: "29603",
    ST: "SC",
    cityWithStateAbbr: "Greenville, SC",
  },
  {
    zip: "29604",
    ST: "SC",
    cityWithStateAbbr: "Greenville, SC",
  },
  {
    zip: "29605",
    ST: "SC",
    cityWithStateAbbr: "Greenville, SC",
  },
  {
    zip: "29606",
    ST: "SC",
    cityWithStateAbbr: "Greenville, SC",
  },
  {
    zip: "29607",
    ST: "SC",
    cityWithStateAbbr: "Greenville, SC",
  },
  {
    zip: "29608",
    ST: "SC",
    cityWithStateAbbr: "Greenville, SC",
  },
  {
    zip: "29609",
    ST: "SC",
    cityWithStateAbbr: "Greenville, SC",
  },
  {
    zip: "29610",
    ST: "SC",
    cityWithStateAbbr: "Greenville, SC",
  },
  {
    zip: "29611",
    ST: "SC",
    cityWithStateAbbr: "Greenville, SC",
  },
  {
    zip: "29612",
    ST: "SC",
    cityWithStateAbbr: "Greenville, SC",
  },
  {
    zip: "29613",
    ST: "SC",
    cityWithStateAbbr: "Greenville, SC",
  },
  {
    zip: "29614",
    ST: "SC",
    cityWithStateAbbr: "Greenville, SC",
  },
  {
    zip: "29615",
    ST: "SC",
    cityWithStateAbbr: "Greenville, SC",
  },
  {
    zip: "29616",
    ST: "SC",
    cityWithStateAbbr: "Greenville, SC",
  },
  {
    zip: "29617",
    ST: "SC",
    cityWithStateAbbr: "Greenville, SC",
  },
  {
    zip: "29620",
    ST: "SC",
    cityWithStateAbbr: "Abbeville, SC",
  },
  {
    zip: "29621",
    ST: "SC",
    cityWithStateAbbr: "Anderson, SC",
  },
  {
    zip: "29622",
    ST: "SC",
    cityWithStateAbbr: "Anderson, SC",
  },
  {
    zip: "29623",
    ST: "SC",
    cityWithStateAbbr: "Anderson, SC",
  },
  {
    zip: "29624",
    ST: "SC",
    cityWithStateAbbr: "Anderson, SC",
  },
  {
    zip: "29625",
    ST: "SC",
    cityWithStateAbbr: "Anderson, SC",
  },
  {
    zip: "29626",
    ST: "SC",
    cityWithStateAbbr: "Anderson, SC",
  },
  {
    zip: "29627",
    ST: "SC",
    cityWithStateAbbr: "Belton, SC",
  },
  {
    zip: "29628",
    ST: "SC",
    cityWithStateAbbr: "Calhoun Falls, SC",
  },
  {
    zip: "29630",
    ST: "SC",
    cityWithStateAbbr: "Central, SC",
  },
  {
    zip: "29631",
    ST: "SC",
    cityWithStateAbbr: "Clemson, SC",
  },
  {
    zip: "29632",
    ST: "SC",
    cityWithStateAbbr: "Clemson, SC",
  },
  {
    zip: "29633",
    ST: "SC",
    cityWithStateAbbr: "Clemson, SC",
  },
  {
    zip: "29634",
    ST: "SC",
    cityWithStateAbbr: "Clemson, SC",
  },
  {
    zip: "29635",
    ST: "SC",
    cityWithStateAbbr: "Cleveland, SC",
  },
  {
    zip: "29636",
    ST: "SC",
    cityWithStateAbbr: "Conestee, SC",
  },
  {
    zip: "29638",
    ST: "SC",
    cityWithStateAbbr: "Donalds, SC",
  },
  {
    zip: "29639",
    ST: "SC",
    cityWithStateAbbr: "Due West, SC",
  },
  {
    zip: "29640",
    ST: "SC",
    cityWithStateAbbr: "Easley, SC",
  },
  {
    zip: "29641",
    ST: "SC",
    cityWithStateAbbr: "Easley, SC",
  },
  {
    zip: "29642",
    ST: "SC",
    cityWithStateAbbr: "Easley, SC",
  },
  {
    zip: "29643",
    ST: "SC",
    cityWithStateAbbr: "Fair Play, SC",
  },
  {
    zip: "29644",
    ST: "SC",
    cityWithStateAbbr: "Fountain Inn, SC",
  },
  {
    zip: "29645",
    ST: "SC",
    cityWithStateAbbr: "Gray Court, SC",
  },
  {
    zip: "29646",
    ST: "SC",
    cityWithStateAbbr: "Greenwood, SC",
  },
  {
    zip: "29647",
    ST: "SC",
    cityWithStateAbbr: "Greenwood, SC",
  },
  {
    zip: "29648",
    ST: "SC",
    cityWithStateAbbr: "Greenwood, SC",
  },
  {
    zip: "29649",
    ST: "SC",
    cityWithStateAbbr: "Greenwood, SC",
  },
  {
    zip: "29650",
    ST: "SC",
    cityWithStateAbbr: "Greer, SC",
  },
  {
    zip: "29651",
    ST: "SC",
    cityWithStateAbbr: "Greer, SC",
  },
  {
    zip: "29652",
    ST: "SC",
    cityWithStateAbbr: "Greer, SC",
  },
  {
    zip: "29653",
    ST: "SC",
    cityWithStateAbbr: "Hodges, SC",
  },
  {
    zip: "29654",
    ST: "SC",
    cityWithStateAbbr: "Honea Path, SC",
  },
  {
    zip: "29655",
    ST: "SC",
    cityWithStateAbbr: "Iva, SC",
  },
  {
    zip: "29656",
    ST: "SC",
    cityWithStateAbbr: "La France, SC",
  },
  {
    zip: "29657",
    ST: "SC",
    cityWithStateAbbr: "Liberty, SC",
  },
  {
    zip: "29658",
    ST: "SC",
    cityWithStateAbbr: "Long Creek, SC",
  },
  {
    zip: "29659",
    ST: "SC",
    cityWithStateAbbr: "Lowndesville, SC",
  },
  {
    zip: "29661",
    ST: "SC",
    cityWithStateAbbr: "Marietta, SC",
  },
  {
    zip: "29662",
    ST: "SC",
    cityWithStateAbbr: "Mauldin, SC",
  },
  {
    zip: "29664",
    ST: "SC",
    cityWithStateAbbr: "Mountain Rest, SC",
  },
  {
    zip: "29665",
    ST: "SC",
    cityWithStateAbbr: "Newry, SC",
  },
  {
    zip: "29666",
    ST: "SC",
    cityWithStateAbbr: "Ninety Six, SC",
  },
  {
    zip: "29667",
    ST: "SC",
    cityWithStateAbbr: "Norris, SC",
  },
  {
    zip: "29669",
    ST: "SC",
    cityWithStateAbbr: "Pelzer, SC",
  },
  {
    zip: "29670",
    ST: "SC",
    cityWithStateAbbr: "Pendleton, SC",
  },
  {
    zip: "29671",
    ST: "SC",
    cityWithStateAbbr: "Pickens, SC",
  },
  {
    zip: "29672",
    ST: "SC",
    cityWithStateAbbr: "Seneca, SC",
  },
  {
    zip: "29673",
    ST: "SC",
    cityWithStateAbbr: "Piedmont, SC",
  },
  {
    zip: "29675",
    ST: "SC",
    cityWithStateAbbr: "Richland, SC",
  },
  {
    zip: "29676",
    ST: "SC",
    cityWithStateAbbr: "Salem, SC",
  },
  {
    zip: "29677",
    ST: "SC",
    cityWithStateAbbr: "Sandy Springs, SC",
  },
  {
    zip: "29678",
    ST: "SC",
    cityWithStateAbbr: "Seneca, SC",
  },
  {
    zip: "29679",
    ST: "SC",
    cityWithStateAbbr: "Seneca, SC",
  },
  {
    zip: "29680",
    ST: "SC",
    cityWithStateAbbr: "Simpsonville, SC",
  },
  {
    zip: "29681",
    ST: "SC",
    cityWithStateAbbr: "Simpsonville, SC",
  },
  {
    zip: "29682",
    ST: "SC",
    cityWithStateAbbr: "Six Mile, SC",
  },
  {
    zip: "29683",
    ST: "SC",
    cityWithStateAbbr: "Slater, SC",
  },
  {
    zip: "29684",
    ST: "SC",
    cityWithStateAbbr: "Starr, SC",
  },
  {
    zip: "29685",
    ST: "SC",
    cityWithStateAbbr: "Sunset, SC",
  },
  {
    zip: "29686",
    ST: "SC",
    cityWithStateAbbr: "Tamassee, SC",
  },
  {
    zip: "29687",
    ST: "SC",
    cityWithStateAbbr: "Taylors, SC",
  },
  {
    zip: "29688",
    ST: "SC",
    cityWithStateAbbr: "Tigerville, SC",
  },
  {
    zip: "29689",
    ST: "SC",
    cityWithStateAbbr: "Townville, SC",
  },
  {
    zip: "29690",
    ST: "SC",
    cityWithStateAbbr: "Travelers Rest, SC",
  },
  {
    zip: "29691",
    ST: "SC",
    cityWithStateAbbr: "Walhalla, SC",
  },
  {
    zip: "29692",
    ST: "SC",
    cityWithStateAbbr: "Ware Shoals, SC",
  },
  {
    zip: "29693",
    ST: "SC",
    cityWithStateAbbr: "Westminster, SC",
  },
  {
    zip: "29695",
    ST: "SC",
    cityWithStateAbbr: "Hodges, SC",
  },
  {
    zip: "29696",
    ST: "SC",
    cityWithStateAbbr: "West Union, SC",
  },
  {
    zip: "29697",
    ST: "SC",
    cityWithStateAbbr: "Williamston, SC",
  },
  {
    zip: "29702",
    ST: "SC",
    cityWithStateAbbr: "Blacksburg, SC",
  },
  {
    zip: "29703",
    ST: "SC",
    cityWithStateAbbr: "Bowling Green, SC",
  },
  {
    zip: "29704",
    ST: "SC",
    cityWithStateAbbr: "Catawba, SC",
  },
  {
    zip: "29706",
    ST: "SC",
    cityWithStateAbbr: "Chester, SC",
  },
  {
    zip: "29707",
    ST: "SC",
    cityWithStateAbbr: "Fort Mill, SC",
  },
  {
    zip: "29708",
    ST: "SC",
    cityWithStateAbbr: "Fort Mill, SC",
  },
  {
    zip: "29709",
    ST: "SC",
    cityWithStateAbbr: "Chesterfield, SC",
  },
  {
    zip: "29710",
    ST: "SC",
    cityWithStateAbbr: "Clover, SC",
  },
  {
    zip: "29712",
    ST: "SC",
    cityWithStateAbbr: "Edgemoor, SC",
  },
  {
    zip: "29714",
    ST: "SC",
    cityWithStateAbbr: "Fort Lawn, SC",
  },
  {
    zip: "29715",
    ST: "SC",
    cityWithStateAbbr: "Fort Mill, SC",
  },
  {
    zip: "29716",
    ST: "SC",
    cityWithStateAbbr: "Fort Mill, SC",
  },
  {
    zip: "29717",
    ST: "SC",
    cityWithStateAbbr: "Hickory Grove, SC",
  },
  {
    zip: "29718",
    ST: "SC",
    cityWithStateAbbr: "Jefferson, SC",
  },
  {
    zip: "29720",
    ST: "SC",
    cityWithStateAbbr: "Lancaster, SC",
  },
  {
    zip: "29721",
    ST: "SC",
    cityWithStateAbbr: "Lancaster, SC",
  },
  {
    zip: "29722",
    ST: "SC",
    cityWithStateAbbr: "Lancaster, SC",
  },
  {
    zip: "29724",
    ST: "SC",
    cityWithStateAbbr: "Lando, SC",
  },
  {
    zip: "29726",
    ST: "SC",
    cityWithStateAbbr: "Mc Connells, SC",
  },
  {
    zip: "29727",
    ST: "SC",
    cityWithStateAbbr: "Mount Croghan, SC",
  },
  {
    zip: "29728",
    ST: "SC",
    cityWithStateAbbr: "Pageland, SC",
  },
  {
    zip: "29729",
    ST: "SC",
    cityWithStateAbbr: "Richburg, SC",
  },
  {
    zip: "29730",
    ST: "SC",
    cityWithStateAbbr: "Rock Hill, SC",
  },
  {
    zip: "29731",
    ST: "SC",
    cityWithStateAbbr: "Rock Hill, SC",
  },
  {
    zip: "29732",
    ST: "SC",
    cityWithStateAbbr: "Rock Hill, SC",
  },
  {
    zip: "29733",
    ST: "SC",
    cityWithStateAbbr: "Rock Hill, SC",
  },
  {
    zip: "29734",
    ST: "SC",
    cityWithStateAbbr: "Rock Hill, SC",
  },
  {
    zip: "29741",
    ST: "SC",
    cityWithStateAbbr: "Ruby, SC",
  },
  {
    zip: "29742",
    ST: "SC",
    cityWithStateAbbr: "Sharon, SC",
  },
  {
    zip: "29743",
    ST: "SC",
    cityWithStateAbbr: "Smyrna, SC",
  },
  {
    zip: "29744",
    ST: "SC",
    cityWithStateAbbr: "Van Wyck, SC",
  },
  {
    zip: "29745",
    ST: "SC",
    cityWithStateAbbr: "York, SC",
  },
  {
    zip: "29801",
    ST: "SC",
    cityWithStateAbbr: "Aiken, SC",
  },
  {
    zip: "29802",
    ST: "SC",
    cityWithStateAbbr: "Aiken, SC",
  },
  {
    zip: "29803",
    ST: "SC",
    cityWithStateAbbr: "Aiken, SC",
  },
  {
    zip: "29804",
    ST: "SC",
    cityWithStateAbbr: "Aiken, SC",
  },
  {
    zip: "29805",
    ST: "SC",
    cityWithStateAbbr: "Aiken, SC",
  },
  {
    zip: "29808",
    ST: "SC",
    cityWithStateAbbr: "Aiken, SC",
  },
  {
    zip: "29809",
    ST: "SC",
    cityWithStateAbbr: "New Ellenton, SC",
  },
  {
    zip: "29810",
    ST: "SC",
    cityWithStateAbbr: "Allendale, SC",
  },
  {
    zip: "29812",
    ST: "SC",
    cityWithStateAbbr: "Barnwell, SC",
  },
  {
    zip: "29813",
    ST: "SC",
    cityWithStateAbbr: "Hilda, SC",
  },
  {
    zip: "29816",
    ST: "SC",
    cityWithStateAbbr: "Bath, SC",
  },
  {
    zip: "29817",
    ST: "SC",
    cityWithStateAbbr: "Blackville, SC",
  },
  {
    zip: "29819",
    ST: "SC",
    cityWithStateAbbr: "Bradley, SC",
  },
  {
    zip: "29821",
    ST: "SC",
    cityWithStateAbbr: "Clarks Hill, SC",
  },
  {
    zip: "29822",
    ST: "SC",
    cityWithStateAbbr: "Clearwater, SC",
  },
  {
    zip: "29824",
    ST: "SC",
    cityWithStateAbbr: "Edgefield, SC",
  },
  {
    zip: "29826",
    ST: "SC",
    cityWithStateAbbr: "Elko, SC",
  },
  {
    zip: "29827",
    ST: "SC",
    cityWithStateAbbr: "Fairfax, SC",
  },
  {
    zip: "29828",
    ST: "SC",
    cityWithStateAbbr: "Gloverville, SC",
  },
  {
    zip: "29829",
    ST: "SC",
    cityWithStateAbbr: "Graniteville, SC",
  },
  {
    zip: "29831",
    ST: "SC",
    cityWithStateAbbr: "Jackson, SC",
  },
  {
    zip: "29832",
    ST: "SC",
    cityWithStateAbbr: "Johnston, SC",
  },
  {
    zip: "29834",
    ST: "SC",
    cityWithStateAbbr: "Langley, SC",
  },
  {
    zip: "29835",
    ST: "SC",
    cityWithStateAbbr: "Mc Cormick, SC",
  },
  {
    zip: "29836",
    ST: "SC",
    cityWithStateAbbr: "Martin, SC",
  },
  {
    zip: "29838",
    ST: "SC",
    cityWithStateAbbr: "Modoc, SC",
  },
  {
    zip: "29839",
    ST: "SC",
    cityWithStateAbbr: "Montmorenci, SC",
  },
  {
    zip: "29840",
    ST: "SC",
    cityWithStateAbbr: "Mount Carmel, SC",
  },
  {
    zip: "29841",
    ST: "SC",
    cityWithStateAbbr: "North Augusta, SC",
  },
  {
    zip: "29842",
    ST: "SC",
    cityWithStateAbbr: "Beech Island, SC",
  },
  {
    zip: "29843",
    ST: "SC",
    cityWithStateAbbr: "Olar, SC",
  },
  {
    zip: "29844",
    ST: "SC",
    cityWithStateAbbr: "Parksville, SC",
  },
  {
    zip: "29845",
    ST: "SC",
    cityWithStateAbbr: "Plum Branch, SC",
  },
  {
    zip: "29846",
    ST: "SC",
    cityWithStateAbbr: "Sycamore, SC",
  },
  {
    zip: "29847",
    ST: "SC",
    cityWithStateAbbr: "Trenton, SC",
  },
  {
    zip: "29848",
    ST: "SC",
    cityWithStateAbbr: "Troy, SC",
  },
  {
    zip: "29849",
    ST: "SC",
    cityWithStateAbbr: "Ulmer, SC",
  },
  {
    zip: "29850",
    ST: "SC",
    cityWithStateAbbr: "Vaucluse, SC",
  },
  {
    zip: "29851",
    ST: "SC",
    cityWithStateAbbr: "Warrenville, SC",
  },
  {
    zip: "29853",
    ST: "SC",
    cityWithStateAbbr: "Williston, SC",
  },
  {
    zip: "29856",
    ST: "SC",
    cityWithStateAbbr: "Windsor, SC",
  },
  {
    zip: "29860",
    ST: "SC",
    cityWithStateAbbr: "North Augusta, SC",
  },
  {
    zip: "29861",
    ST: "SC",
    cityWithStateAbbr: "North Augusta, SC",
  },
  {
    zip: "29899",
    ST: "SC",
    cityWithStateAbbr: "Mc Cormick, SC",
  },
  {
    zip: "29901",
    ST: "SC",
    cityWithStateAbbr: "Beaufort, SC",
  },
  {
    zip: "29902",
    ST: "SC",
    cityWithStateAbbr: "Beaufort, SC",
  },
  {
    zip: "29903",
    ST: "SC",
    cityWithStateAbbr: "Beaufort, SC",
  },
  {
    zip: "29904",
    ST: "SC",
    cityWithStateAbbr: "Beaufort, SC",
  },
  {
    zip: "29905",
    ST: "SC",
    cityWithStateAbbr: "Parris Island, SC",
  },
  {
    zip: "29906",
    ST: "SC",
    cityWithStateAbbr: "Beaufort, SC",
  },
  {
    zip: "29907",
    ST: "SC",
    cityWithStateAbbr: "Beaufort, SC",
  },
  {
    zip: "29909",
    ST: "SC",
    cityWithStateAbbr: "Okatie, SC",
  },
  {
    zip: "29910",
    ST: "SC",
    cityWithStateAbbr: "Bluffton, SC",
  },
  {
    zip: "29911",
    ST: "SC",
    cityWithStateAbbr: "Brunson, SC",
  },
  {
    zip: "29912",
    ST: "SC",
    cityWithStateAbbr: "Coosawhatchie, SC",
  },
  {
    zip: "29913",
    ST: "SC",
    cityWithStateAbbr: "Crocketville, SC",
  },
  {
    zip: "29914",
    ST: "SC",
    cityWithStateAbbr: "Dale, SC",
  },
  {
    zip: "29915",
    ST: "SC",
    cityWithStateAbbr: "Daufuskie Island, SC",
  },
  {
    zip: "29916",
    ST: "SC",
    cityWithStateAbbr: "Early Branch, SC",
  },
  {
    zip: "29918",
    ST: "SC",
    cityWithStateAbbr: "Estill, SC",
  },
  {
    zip: "29920",
    ST: "SC",
    cityWithStateAbbr: "Saint Helena Island, SC",
  },
  {
    zip: "29921",
    ST: "SC",
    cityWithStateAbbr: "Furman, SC",
  },
  {
    zip: "29922",
    ST: "SC",
    cityWithStateAbbr: "Garnett, SC",
  },
  {
    zip: "29923",
    ST: "SC",
    cityWithStateAbbr: "Gifford, SC",
  },
  {
    zip: "29924",
    ST: "SC",
    cityWithStateAbbr: "Hampton, SC",
  },
  {
    zip: "29925",
    ST: "SC",
    cityWithStateAbbr: "Hilton Head Island, SC",
  },
  {
    zip: "29926",
    ST: "SC",
    cityWithStateAbbr: "Hilton Head Island, SC",
  },
  {
    zip: "29927",
    ST: "SC",
    cityWithStateAbbr: "Hardeeville, SC",
  },
  {
    zip: "29928",
    ST: "SC",
    cityWithStateAbbr: "Hilton Head Island, SC",
  },
  {
    zip: "29929",
    ST: "SC",
    cityWithStateAbbr: "Islandton, SC",
  },
  {
    zip: "29931",
    ST: "SC",
    cityWithStateAbbr: "Lobeco, SC",
  },
  {
    zip: "29932",
    ST: "SC",
    cityWithStateAbbr: "Luray, SC",
  },
  {
    zip: "29933",
    ST: "SC",
    cityWithStateAbbr: "Miley, SC",
  },
  {
    zip: "29934",
    ST: "SC",
    cityWithStateAbbr: "Pineland, SC",
  },
  {
    zip: "29935",
    ST: "SC",
    cityWithStateAbbr: "Port Royal, SC",
  },
  {
    zip: "29936",
    ST: "SC",
    cityWithStateAbbr: "Ridgeland, SC",
  },
  {
    zip: "29938",
    ST: "SC",
    cityWithStateAbbr: "Hilton Head Island, SC",
  },
  {
    zip: "29939",
    ST: "SC",
    cityWithStateAbbr: "Scotia, SC",
  },
  {
    zip: "29940",
    ST: "SC",
    cityWithStateAbbr: "Seabrook, SC",
  },
  {
    zip: "29941",
    ST: "SC",
    cityWithStateAbbr: "Sheldon, SC",
  },
  {
    zip: "29943",
    ST: "SC",
    cityWithStateAbbr: "Tillman, SC",
  },
  {
    zip: "29944",
    ST: "SC",
    cityWithStateAbbr: "Varnville, SC",
  },
  {
    zip: "29945",
    ST: "SC",
    cityWithStateAbbr: "Yemassee, SC",
  },
  {
    zip: "30002",
    ST: "GA",
    cityWithStateAbbr: "Avondale Estates, GA",
  },
  {
    zip: "30003",
    ST: "GA",
    cityWithStateAbbr: "Norcross, GA",
  },
  {
    zip: "30004",
    ST: "GA",
    cityWithStateAbbr: "Alpharetta, GA",
  },
  {
    zip: "30005",
    ST: "GA",
    cityWithStateAbbr: "Alpharetta, GA",
  },
  {
    zip: "30006",
    ST: "GA",
    cityWithStateAbbr: "Marietta, GA",
  },
  {
    zip: "30007",
    ST: "GA",
    cityWithStateAbbr: "Marietta, GA",
  },
  {
    zip: "30008",
    ST: "GA",
    cityWithStateAbbr: "Marietta, GA",
  },
  {
    zip: "30009",
    ST: "GA",
    cityWithStateAbbr: "Alpharetta, GA",
  },
  {
    zip: "30010",
    ST: "GA",
    cityWithStateAbbr: "Norcross, GA",
  },
  {
    zip: "30011",
    ST: "GA",
    cityWithStateAbbr: "Auburn, GA",
  },
  {
    zip: "30012",
    ST: "GA",
    cityWithStateAbbr: "Conyers, GA",
  },
  {
    zip: "30013",
    ST: "GA",
    cityWithStateAbbr: "Conyers, GA",
  },
  {
    zip: "30014",
    ST: "GA",
    cityWithStateAbbr: "Covington, GA",
  },
  {
    zip: "30015",
    ST: "GA",
    cityWithStateAbbr: "Covington, GA",
  },
  {
    zip: "30016",
    ST: "GA",
    cityWithStateAbbr: "Covington, GA",
  },
  {
    zip: "30017",
    ST: "GA",
    cityWithStateAbbr: "Grayson, GA",
  },
  {
    zip: "30018",
    ST: "GA",
    cityWithStateAbbr: "Jersey, GA",
  },
  {
    zip: "30019",
    ST: "GA",
    cityWithStateAbbr: "Dacula, GA",
  },
  {
    zip: "30021",
    ST: "GA",
    cityWithStateAbbr: "Clarkston, GA",
  },
  {
    zip: "30022",
    ST: "GA",
    cityWithStateAbbr: "Alpharetta, GA",
  },
  {
    zip: "30023",
    ST: "GA",
    cityWithStateAbbr: "Alpharetta, GA",
  },
  {
    zip: "30024",
    ST: "GA",
    cityWithStateAbbr: "Suwanee, GA",
  },
  {
    zip: "30025",
    ST: "GA",
    cityWithStateAbbr: "Social Circle, GA",
  },
  {
    zip: "30026",
    ST: "GA",
    cityWithStateAbbr: "North Metro, GA",
  },
  {
    zip: "30028",
    ST: "GA",
    cityWithStateAbbr: "Cumming, GA",
  },
  {
    zip: "30029",
    ST: "GA",
    cityWithStateAbbr: "North Metro, GA",
  },
  {
    zip: "30030",
    ST: "GA",
    cityWithStateAbbr: "Decatur, GA",
  },
  {
    zip: "30031",
    ST: "GA",
    cityWithStateAbbr: "Decatur, GA",
  },
  {
    zip: "30032",
    ST: "GA",
    cityWithStateAbbr: "Decatur, GA",
  },
  {
    zip: "30033",
    ST: "GA",
    cityWithStateAbbr: "Decatur, GA",
  },
  {
    zip: "30034",
    ST: "GA",
    cityWithStateAbbr: "Decatur, GA",
  },
  {
    zip: "30035",
    ST: "GA",
    cityWithStateAbbr: "Decatur, GA",
  },
  {
    zip: "30036",
    ST: "GA",
    cityWithStateAbbr: "Decatur, GA",
  },
  {
    zip: "30037",
    ST: "GA",
    cityWithStateAbbr: "Decatur, GA",
  },
  {
    zip: "30038",
    ST: "GA",
    cityWithStateAbbr: "Lithonia, GA",
  },
  {
    zip: "30039",
    ST: "GA",
    cityWithStateAbbr: "Snellville, GA",
  },
  {
    zip: "30040",
    ST: "GA",
    cityWithStateAbbr: "Cumming, GA",
  },
  {
    zip: "30041",
    ST: "GA",
    cityWithStateAbbr: "Cumming, GA",
  },
  {
    zip: "30042",
    ST: "GA",
    cityWithStateAbbr: "Lawrenceville, GA",
  },
  {
    zip: "30043",
    ST: "GA",
    cityWithStateAbbr: "Lawrenceville, GA",
  },
  {
    zip: "30044",
    ST: "GA",
    cityWithStateAbbr: "Lawrenceville, GA",
  },
  {
    zip: "30045",
    ST: "GA",
    cityWithStateAbbr: "Lawrenceville, GA",
  },
  {
    zip: "30046",
    ST: "GA",
    cityWithStateAbbr: "Lawrenceville, GA",
  },
  {
    zip: "30047",
    ST: "GA",
    cityWithStateAbbr: "Lilburn, GA",
  },
  {
    zip: "30048",
    ST: "GA",
    cityWithStateAbbr: "Lilburn, GA",
  },
  {
    zip: "30049",
    ST: "GA",
    cityWithStateAbbr: "Lawrenceville, GA",
  },
  {
    zip: "30052",
    ST: "GA",
    cityWithStateAbbr: "Loganville, GA",
  },
  {
    zip: "30054",
    ST: "GA",
    cityWithStateAbbr: "Oxford, GA",
  },
  {
    zip: "30055",
    ST: "GA",
    cityWithStateAbbr: "Mansfield, GA",
  },
  {
    zip: "30056",
    ST: "GA",
    cityWithStateAbbr: "Newborn, GA",
  },
  {
    zip: "30058",
    ST: "GA",
    cityWithStateAbbr: "Lithonia, GA",
  },
  {
    zip: "30060",
    ST: "GA",
    cityWithStateAbbr: "Marietta, GA",
  },
  {
    zip: "30061",
    ST: "GA",
    cityWithStateAbbr: "Marietta, GA",
  },
  {
    zip: "30062",
    ST: "GA",
    cityWithStateAbbr: "Marietta, GA",
  },
  {
    zip: "30063",
    ST: "GA",
    cityWithStateAbbr: "Marietta, GA",
  },
  {
    zip: "30064",
    ST: "GA",
    cityWithStateAbbr: "Marietta, GA",
  },
  {
    zip: "30065",
    ST: "GA",
    cityWithStateAbbr: "Marietta, GA",
  },
  {
    zip: "30066",
    ST: "GA",
    cityWithStateAbbr: "Marietta, GA",
  },
  {
    zip: "30067",
    ST: "GA",
    cityWithStateAbbr: "Marietta, GA",
  },
  {
    zip: "30068",
    ST: "GA",
    cityWithStateAbbr: "Marietta, GA",
  },
  {
    zip: "30069",
    ST: "GA",
    cityWithStateAbbr: "Marietta, GA",
  },
  {
    zip: "30070",
    ST: "GA",
    cityWithStateAbbr: "Porterdale, GA",
  },
  {
    zip: "30071",
    ST: "GA",
    cityWithStateAbbr: "Norcross, GA",
  },
  {
    zip: "30072",
    ST: "GA",
    cityWithStateAbbr: "Pine Lake, GA",
  },
  {
    zip: "30074",
    ST: "GA",
    cityWithStateAbbr: "Redan, GA",
  },
  {
    zip: "30075",
    ST: "GA",
    cityWithStateAbbr: "Roswell, GA",
  },
  {
    zip: "30076",
    ST: "GA",
    cityWithStateAbbr: "Roswell, GA",
  },
  {
    zip: "30077",
    ST: "GA",
    cityWithStateAbbr: "Roswell, GA",
  },
  {
    zip: "30078",
    ST: "GA",
    cityWithStateAbbr: "Snellville, GA",
  },
  {
    zip: "30079",
    ST: "GA",
    cityWithStateAbbr: "Scottdale, GA",
  },
  {
    zip: "30080",
    ST: "GA",
    cityWithStateAbbr: "Smyrna, GA",
  },
  {
    zip: "30081",
    ST: "GA",
    cityWithStateAbbr: "Smyrna, GA",
  },
  {
    zip: "30082",
    ST: "GA",
    cityWithStateAbbr: "Smyrna, GA",
  },
  {
    zip: "30083",
    ST: "GA",
    cityWithStateAbbr: "Stone Mountain, GA",
  },
  {
    zip: "30084",
    ST: "GA",
    cityWithStateAbbr: "Tucker, GA",
  },
  {
    zip: "30085",
    ST: "GA",
    cityWithStateAbbr: "Tucker, GA",
  },
  {
    zip: "30086",
    ST: "GA",
    cityWithStateAbbr: "Stone Mountain, GA",
  },
  {
    zip: "30087",
    ST: "GA",
    cityWithStateAbbr: "Stone Mountain, GA",
  },
  {
    zip: "30088",
    ST: "GA",
    cityWithStateAbbr: "Stone Mountain, GA",
  },
  {
    zip: "30090",
    ST: "GA",
    cityWithStateAbbr: "Marietta, GA",
  },
  {
    zip: "30091",
    ST: "GA",
    cityWithStateAbbr: "Norcross, GA",
  },
  {
    zip: "30092",
    ST: "GA",
    cityWithStateAbbr: "Peachtree Corners, GA",
  },
  {
    zip: "30093",
    ST: "GA",
    cityWithStateAbbr: "Norcross, GA",
  },
  {
    zip: "30094",
    ST: "GA",
    cityWithStateAbbr: "Conyers, GA",
  },
  {
    zip: "30095",
    ST: "GA",
    cityWithStateAbbr: "Duluth, GA",
  },
  {
    zip: "30096",
    ST: "GA",
    cityWithStateAbbr: "Duluth, GA",
  },
  {
    zip: "30097",
    ST: "GA",
    cityWithStateAbbr: "Duluth, GA",
  },
  {
    zip: "30098",
    ST: "GA",
    cityWithStateAbbr: "Duluth, GA",
  },
  {
    zip: "30099",
    ST: "GA",
    cityWithStateAbbr: "Duluth, GA",
  },
  {
    zip: "30101",
    ST: "GA",
    cityWithStateAbbr: "Acworth, GA",
  },
  {
    zip: "30102",
    ST: "GA",
    cityWithStateAbbr: "Acworth, GA",
  },
  {
    zip: "30103",
    ST: "GA",
    cityWithStateAbbr: "Adairsville, GA",
  },
  {
    zip: "30104",
    ST: "GA",
    cityWithStateAbbr: "Aragon, GA",
  },
  {
    zip: "30105",
    ST: "GA",
    cityWithStateAbbr: "Armuchee, GA",
  },
  {
    zip: "30106",
    ST: "GA",
    cityWithStateAbbr: "Austell, GA",
  },
  {
    zip: "30107",
    ST: "GA",
    cityWithStateAbbr: "Ball Ground, GA",
  },
  {
    zip: "30108",
    ST: "GA",
    cityWithStateAbbr: "Bowdon, GA",
  },
  {
    zip: "30109",
    ST: "GA",
    cityWithStateAbbr: "Bowdon Junction, GA",
  },
  {
    zip: "30110",
    ST: "GA",
    cityWithStateAbbr: "Bremen, GA",
  },
  {
    zip: "30111",
    ST: "GA",
    cityWithStateAbbr: "Clarkdale, GA",
  },
  {
    zip: "30112",
    ST: "GA",
    cityWithStateAbbr: "Carrollton, GA",
  },
  {
    zip: "30113",
    ST: "GA",
    cityWithStateAbbr: "Buchanan, GA",
  },
  {
    zip: "30114",
    ST: "GA",
    cityWithStateAbbr: "Canton, GA",
  },
  {
    zip: "30115",
    ST: "GA",
    cityWithStateAbbr: "Canton, GA",
  },
  {
    zip: "30116",
    ST: "GA",
    cityWithStateAbbr: "Carrollton, GA",
  },
  {
    zip: "30117",
    ST: "GA",
    cityWithStateAbbr: "Carrollton, GA",
  },
  {
    zip: "30118",
    ST: "GA",
    cityWithStateAbbr: "Carrollton, GA",
  },
  {
    zip: "30119",
    ST: "GA",
    cityWithStateAbbr: "Carrollton, GA",
  },
  {
    zip: "30120",
    ST: "GA",
    cityWithStateAbbr: "Cartersville, GA",
  },
  {
    zip: "30121",
    ST: "GA",
    cityWithStateAbbr: "Cartersville, GA",
  },
  {
    zip: "30122",
    ST: "GA",
    cityWithStateAbbr: "Lithia Springs, GA",
  },
  {
    zip: "30123",
    ST: "GA",
    cityWithStateAbbr: "Cassville, GA",
  },
  {
    zip: "30124",
    ST: "GA",
    cityWithStateAbbr: "Cave Spring, GA",
  },
  {
    zip: "30125",
    ST: "GA",
    cityWithStateAbbr: "Cedartown, GA",
  },
  {
    zip: "30126",
    ST: "GA",
    cityWithStateAbbr: "Mableton, GA",
  },
  {
    zip: "30127",
    ST: "GA",
    cityWithStateAbbr: "Powder Springs, GA",
  },
  {
    zip: "30129",
    ST: "GA",
    cityWithStateAbbr: "Coosa, GA",
  },
  {
    zip: "30132",
    ST: "GA",
    cityWithStateAbbr: "Dallas, GA",
  },
  {
    zip: "30133",
    ST: "GA",
    cityWithStateAbbr: "Douglasville, GA",
  },
  {
    zip: "30134",
    ST: "GA",
    cityWithStateAbbr: "Douglasville, GA",
  },
  {
    zip: "30135",
    ST: "GA",
    cityWithStateAbbr: "Douglasville, GA",
  },
  {
    zip: "30137",
    ST: "GA",
    cityWithStateAbbr: "Emerson, GA",
  },
  {
    zip: "30138",
    ST: "GA",
    cityWithStateAbbr: "Esom Hill, GA",
  },
  {
    zip: "30139",
    ST: "GA",
    cityWithStateAbbr: "Fairmount, GA",
  },
  {
    zip: "30140",
    ST: "GA",
    cityWithStateAbbr: "Felton, GA",
  },
  {
    zip: "30141",
    ST: "GA",
    cityWithStateAbbr: "Hiram, GA",
  },
  {
    zip: "30142",
    ST: "GA",
    cityWithStateAbbr: "Holly Springs, GA",
  },
  {
    zip: "30143",
    ST: "GA",
    cityWithStateAbbr: "Jasper, GA",
  },
  {
    zip: "30144",
    ST: "GA",
    cityWithStateAbbr: "Kennesaw, GA",
  },
  {
    zip: "30145",
    ST: "GA",
    cityWithStateAbbr: "Kingston, GA",
  },
  {
    zip: "30146",
    ST: "GA",
    cityWithStateAbbr: "Lebanon, GA",
  },
  {
    zip: "30147",
    ST: "GA",
    cityWithStateAbbr: "Lindale, GA",
  },
  {
    zip: "30148",
    ST: "GA",
    cityWithStateAbbr: "Marble Hill, GA",
  },
  {
    zip: "30149",
    ST: "GA",
    cityWithStateAbbr: "Mount Berry, GA",
  },
  {
    zip: "30150",
    ST: "GA",
    cityWithStateAbbr: "Mount Zion, GA",
  },
  {
    zip: "30151",
    ST: "GA",
    cityWithStateAbbr: "Nelson, GA",
  },
  {
    zip: "30152",
    ST: "GA",
    cityWithStateAbbr: "Kennesaw, GA",
  },
  {
    zip: "30153",
    ST: "GA",
    cityWithStateAbbr: "Rockmart, GA",
  },
  {
    zip: "30154",
    ST: "GA",
    cityWithStateAbbr: "Douglasville, GA",
  },
  {
    zip: "30156",
    ST: "GA",
    cityWithStateAbbr: "Kennesaw, GA",
  },
  {
    zip: "30157",
    ST: "GA",
    cityWithStateAbbr: "Dallas, GA",
  },
  {
    zip: "30160",
    ST: "GA",
    cityWithStateAbbr: "Kennesaw, GA",
  },
  {
    zip: "30161",
    ST: "GA",
    cityWithStateAbbr: "Rome, GA",
  },
  {
    zip: "30162",
    ST: "GA",
    cityWithStateAbbr: "Rome, GA",
  },
  {
    zip: "30163",
    ST: "GA",
    cityWithStateAbbr: "Rome, GA",
  },
  {
    zip: "30164",
    ST: "GA",
    cityWithStateAbbr: "Rome, GA",
  },
  {
    zip: "30165",
    ST: "GA",
    cityWithStateAbbr: "Rome, GA",
  },
  {
    zip: "30168",
    ST: "GA",
    cityWithStateAbbr: "Austell, GA",
  },
  {
    zip: "30169",
    ST: "GA",
    cityWithStateAbbr: "Canton, GA",
  },
  {
    zip: "30170",
    ST: "GA",
    cityWithStateAbbr: "Roopville, GA",
  },
  {
    zip: "30171",
    ST: "GA",
    cityWithStateAbbr: "Rydal, GA",
  },
  {
    zip: "30172",
    ST: "GA",
    cityWithStateAbbr: "Shannon, GA",
  },
  {
    zip: "30173",
    ST: "GA",
    cityWithStateAbbr: "Silver Creek, GA",
  },
  {
    zip: "30175",
    ST: "GA",
    cityWithStateAbbr: "Talking Rock, GA",
  },
  {
    zip: "30176",
    ST: "GA",
    cityWithStateAbbr: "Tallapoosa, GA",
  },
  {
    zip: "30177",
    ST: "GA",
    cityWithStateAbbr: "Tate, GA",
  },
  {
    zip: "30178",
    ST: "GA",
    cityWithStateAbbr: "Taylorsville, GA",
  },
  {
    zip: "30179",
    ST: "GA",
    cityWithStateAbbr: "Temple, GA",
  },
  {
    zip: "30180",
    ST: "GA",
    cityWithStateAbbr: "Villa Rica, GA",
  },
  {
    zip: "30182",
    ST: "GA",
    cityWithStateAbbr: "Waco, GA",
  },
  {
    zip: "30183",
    ST: "GA",
    cityWithStateAbbr: "Waleska, GA",
  },
  {
    zip: "30184",
    ST: "GA",
    cityWithStateAbbr: "White, GA",
  },
  {
    zip: "30185",
    ST: "GA",
    cityWithStateAbbr: "Whitesburg, GA",
  },
  {
    zip: "30187",
    ST: "GA",
    cityWithStateAbbr: "Winston, GA",
  },
  {
    zip: "30188",
    ST: "GA",
    cityWithStateAbbr: "Woodstock, GA",
  },
  {
    zip: "30189",
    ST: "GA",
    cityWithStateAbbr: "Woodstock, GA",
  },
  {
    zip: "30204",
    ST: "GA",
    cityWithStateAbbr: "Barnesville, GA",
  },
  {
    zip: "30205",
    ST: "GA",
    cityWithStateAbbr: "Brooks, GA",
  },
  {
    zip: "30206",
    ST: "GA",
    cityWithStateAbbr: "Concord, GA",
  },
  {
    zip: "30212",
    ST: "GA",
    cityWithStateAbbr: "Experiment, GA",
  },
  {
    zip: "30213",
    ST: "GA",
    cityWithStateAbbr: "Fairburn, GA",
  },
  {
    zip: "30214",
    ST: "GA",
    cityWithStateAbbr: "Fayetteville, GA",
  },
  {
    zip: "30215",
    ST: "GA",
    cityWithStateAbbr: "Fayetteville, GA",
  },
  {
    zip: "30216",
    ST: "GA",
    cityWithStateAbbr: "Flovilla, GA",
  },
  {
    zip: "30217",
    ST: "GA",
    cityWithStateAbbr: "Franklin, GA",
  },
  {
    zip: "30218",
    ST: "GA",
    cityWithStateAbbr: "Gay, GA",
  },
  {
    zip: "30219",
    ST: "GA",
    cityWithStateAbbr: "Glenn, GA",
  },
  {
    zip: "30220",
    ST: "GA",
    cityWithStateAbbr: "Grantville, GA",
  },
  {
    zip: "30222",
    ST: "GA",
    cityWithStateAbbr: "Greenville, GA",
  },
  {
    zip: "30223",
    ST: "GA",
    cityWithStateAbbr: "Griffin, GA",
  },
  {
    zip: "30224",
    ST: "GA",
    cityWithStateAbbr: "Griffin, GA",
  },
  {
    zip: "30228",
    ST: "GA",
    cityWithStateAbbr: "Hampton, GA",
  },
  {
    zip: "30229",
    ST: "GA",
    cityWithStateAbbr: "Haralson, GA",
  },
  {
    zip: "30230",
    ST: "GA",
    cityWithStateAbbr: "Hogansville, GA",
  },
  {
    zip: "30233",
    ST: "GA",
    cityWithStateAbbr: "Jackson, GA",
  },
  {
    zip: "30234",
    ST: "GA",
    cityWithStateAbbr: "Jenkinsburg, GA",
  },
  {
    zip: "30236",
    ST: "GA",
    cityWithStateAbbr: "Jonesboro, GA",
  },
  {
    zip: "30237",
    ST: "GA",
    cityWithStateAbbr: "Jonesboro, GA",
  },
  {
    zip: "30238",
    ST: "GA",
    cityWithStateAbbr: "Jonesboro, GA",
  },
  {
    zip: "30240",
    ST: "GA",
    cityWithStateAbbr: "Lagrange, GA",
  },
  {
    zip: "30241",
    ST: "GA",
    cityWithStateAbbr: "Lagrange, GA",
  },
  {
    zip: "30248",
    ST: "GA",
    cityWithStateAbbr: "Locust Grove, GA",
  },
  {
    zip: "30250",
    ST: "GA",
    cityWithStateAbbr: "Lovejoy, GA",
  },
  {
    zip: "30251",
    ST: "GA",
    cityWithStateAbbr: "Luthersville, GA",
  },
  {
    zip: "30252",
    ST: "GA",
    cityWithStateAbbr: "Mcdonough, GA",
  },
  {
    zip: "30253",
    ST: "GA",
    cityWithStateAbbr: "Mcdonough, GA",
  },
  {
    zip: "30256",
    ST: "GA",
    cityWithStateAbbr: "Meansville, GA",
  },
  {
    zip: "30257",
    ST: "GA",
    cityWithStateAbbr: "Milner, GA",
  },
  {
    zip: "30258",
    ST: "GA",
    cityWithStateAbbr: "Molena, GA",
  },
  {
    zip: "30259",
    ST: "GA",
    cityWithStateAbbr: "Moreland, GA",
  },
  {
    zip: "30260",
    ST: "GA",
    cityWithStateAbbr: "Morrow, GA",
  },
  {
    zip: "30261",
    ST: "GA",
    cityWithStateAbbr: "Lagrange, GA",
  },
  {
    zip: "30263",
    ST: "GA",
    cityWithStateAbbr: "Newnan, GA",
  },
  {
    zip: "30264",
    ST: "GA",
    cityWithStateAbbr: "Newnan, GA",
  },
  {
    zip: "30265",
    ST: "GA",
    cityWithStateAbbr: "Newnan, GA",
  },
  {
    zip: "30266",
    ST: "GA",
    cityWithStateAbbr: "Orchard Hill, GA",
  },
  {
    zip: "30268",
    ST: "GA",
    cityWithStateAbbr: "Palmetto, GA",
  },
  {
    zip: "30269",
    ST: "GA",
    cityWithStateAbbr: "Peachtree City, GA",
  },
  {
    zip: "30270",
    ST: "GA",
    cityWithStateAbbr: "Peachtree City, GA",
  },
  {
    zip: "30271",
    ST: "GA",
    cityWithStateAbbr: "Newnan, GA",
  },
  {
    zip: "30272",
    ST: "GA",
    cityWithStateAbbr: "Red Oak, GA",
  },
  {
    zip: "30273",
    ST: "GA",
    cityWithStateAbbr: "Rex, GA",
  },
  {
    zip: "30274",
    ST: "GA",
    cityWithStateAbbr: "Riverdale, GA",
  },
  {
    zip: "30275",
    ST: "GA",
    cityWithStateAbbr: "Sargent, GA",
  },
  {
    zip: "30276",
    ST: "GA",
    cityWithStateAbbr: "Senoia, GA",
  },
  {
    zip: "30277",
    ST: "GA",
    cityWithStateAbbr: "Sharpsburg, GA",
  },
  {
    zip: "30281",
    ST: "GA",
    cityWithStateAbbr: "Stockbridge, GA",
  },
  {
    zip: "30284",
    ST: "GA",
    cityWithStateAbbr: "Sunny Side, GA",
  },
  {
    zip: "30285",
    ST: "GA",
    cityWithStateAbbr: "The Rock, GA",
  },
  {
    zip: "30286",
    ST: "GA",
    cityWithStateAbbr: "Thomaston, GA",
  },
  {
    zip: "30287",
    ST: "GA",
    cityWithStateAbbr: "Morrow, GA",
  },
  {
    zip: "30288",
    ST: "GA",
    cityWithStateAbbr: "Conley, GA",
  },
  {
    zip: "30289",
    ST: "GA",
    cityWithStateAbbr: "Turin, GA",
  },
  {
    zip: "30290",
    ST: "GA",
    cityWithStateAbbr: "Tyrone, GA",
  },
  {
    zip: "30291",
    ST: "GA",
    cityWithStateAbbr: "Union City, GA",
  },
  {
    zip: "30292",
    ST: "GA",
    cityWithStateAbbr: "Williamson, GA",
  },
  {
    zip: "30293",
    ST: "GA",
    cityWithStateAbbr: "Woodbury, GA",
  },
  {
    zip: "30294",
    ST: "GA",
    cityWithStateAbbr: "Ellenwood, GA",
  },
  {
    zip: "30295",
    ST: "GA",
    cityWithStateAbbr: "Zebulon, GA",
  },
  {
    zip: "30296",
    ST: "GA",
    cityWithStateAbbr: "Riverdale, GA",
  },
  {
    zip: "30297",
    ST: "GA",
    cityWithStateAbbr: "Forest Park, GA",
  },
  {
    zip: "30298",
    ST: "GA",
    cityWithStateAbbr: "Forest Park, GA",
  },
  {
    zip: "30301",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30302",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30303",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30304",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30305",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30306",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30307",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30308",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30309",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30310",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30311",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30312",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30313",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30314",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30315",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30316",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30317",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30318",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30319",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30320",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30321",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30322",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30324",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30325",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30326",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30327",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30328",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30329",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30330",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30331",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30332",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30333",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30334",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30336",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30337",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30338",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30339",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30340",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30341",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30342",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30343",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30344",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30345",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30346",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30348",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30349",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30350",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30353",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30354",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30355",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30356",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30357",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30358",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30359",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30360",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30361",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30362",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30363",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30364",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30366",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30368",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30369",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30370",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30371",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30374",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30375",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30376",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30377",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30378",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30379",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30380",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30384",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30385",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30388",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30390",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30392",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30394",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30396",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30398",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "30401",
    ST: "GA",
    cityWithStateAbbr: "Swainsboro, GA",
  },
  {
    zip: "30410",
    ST: "GA",
    cityWithStateAbbr: "Ailey, GA",
  },
  {
    zip: "30411",
    ST: "GA",
    cityWithStateAbbr: "Alamo, GA",
  },
  {
    zip: "30412",
    ST: "GA",
    cityWithStateAbbr: "Alston, GA",
  },
  {
    zip: "30413",
    ST: "GA",
    cityWithStateAbbr: "Bartow, GA",
  },
  {
    zip: "30414",
    ST: "GA",
    cityWithStateAbbr: "Bellville, GA",
  },
  {
    zip: "30415",
    ST: "GA",
    cityWithStateAbbr: "Brooklet, GA",
  },
  {
    zip: "30417",
    ST: "GA",
    cityWithStateAbbr: "Claxton, GA",
  },
  {
    zip: "30420",
    ST: "GA",
    cityWithStateAbbr: "Cobbtown, GA",
  },
  {
    zip: "30421",
    ST: "GA",
    cityWithStateAbbr: "Collins, GA",
  },
  {
    zip: "30423",
    ST: "GA",
    cityWithStateAbbr: "Daisy, GA",
  },
  {
    zip: "30424",
    ST: "GA",
    cityWithStateAbbr: "Dover, GA",
  },
  {
    zip: "30425",
    ST: "GA",
    cityWithStateAbbr: "Garfield, GA",
  },
  {
    zip: "30426",
    ST: "GA",
    cityWithStateAbbr: "Girard, GA",
  },
  {
    zip: "30427",
    ST: "GA",
    cityWithStateAbbr: "Glennville, GA",
  },
  {
    zip: "30428",
    ST: "GA",
    cityWithStateAbbr: "Glenwood, GA",
  },
  {
    zip: "30429",
    ST: "GA",
    cityWithStateAbbr: "Hagan, GA",
  },
  {
    zip: "30434",
    ST: "GA",
    cityWithStateAbbr: "Louisville, GA",
  },
  {
    zip: "30436",
    ST: "GA",
    cityWithStateAbbr: "Lyons, GA",
  },
  {
    zip: "30438",
    ST: "GA",
    cityWithStateAbbr: "Manassas, GA",
  },
  {
    zip: "30439",
    ST: "GA",
    cityWithStateAbbr: "Metter, GA",
  },
  {
    zip: "30441",
    ST: "GA",
    cityWithStateAbbr: "Midville, GA",
  },
  {
    zip: "30442",
    ST: "GA",
    cityWithStateAbbr: "Millen, GA",
  },
  {
    zip: "30445",
    ST: "GA",
    cityWithStateAbbr: "Mount Vernon, GA",
  },
  {
    zip: "30446",
    ST: "GA",
    cityWithStateAbbr: "Newington, GA",
  },
  {
    zip: "30447",
    ST: "GA",
    cityWithStateAbbr: "Norristown, GA",
  },
  {
    zip: "30448",
    ST: "GA",
    cityWithStateAbbr: "Nunez, GA",
  },
  {
    zip: "30449",
    ST: "GA",
    cityWithStateAbbr: "Oliver, GA",
  },
  {
    zip: "30450",
    ST: "GA",
    cityWithStateAbbr: "Portal, GA",
  },
  {
    zip: "30451",
    ST: "GA",
    cityWithStateAbbr: "Pulaski, GA",
  },
  {
    zip: "30452",
    ST: "GA",
    cityWithStateAbbr: "Register, GA",
  },
  {
    zip: "30453",
    ST: "GA",
    cityWithStateAbbr: "Reidsville, GA",
  },
  {
    zip: "30454",
    ST: "GA",
    cityWithStateAbbr: "Rockledge, GA",
  },
  {
    zip: "30455",
    ST: "GA",
    cityWithStateAbbr: "Rocky Ford, GA",
  },
  {
    zip: "30456",
    ST: "GA",
    cityWithStateAbbr: "Sardis, GA",
  },
  {
    zip: "30457",
    ST: "GA",
    cityWithStateAbbr: "Soperton, GA",
  },
  {
    zip: "30458",
    ST: "GA",
    cityWithStateAbbr: "Statesboro, GA",
  },
  {
    zip: "30459",
    ST: "GA",
    cityWithStateAbbr: "Statesboro, GA",
  },
  {
    zip: "30460",
    ST: "GA",
    cityWithStateAbbr: "Statesboro, GA",
  },
  {
    zip: "30461",
    ST: "GA",
    cityWithStateAbbr: "Statesboro, GA",
  },
  {
    zip: "30464",
    ST: "GA",
    cityWithStateAbbr: "Stillmore, GA",
  },
  {
    zip: "30467",
    ST: "GA",
    cityWithStateAbbr: "Sylvania, GA",
  },
  {
    zip: "30470",
    ST: "GA",
    cityWithStateAbbr: "Tarrytown, GA",
  },
  {
    zip: "30471",
    ST: "GA",
    cityWithStateAbbr: "Twin City, GA",
  },
  {
    zip: "30473",
    ST: "GA",
    cityWithStateAbbr: "Uvalda, GA",
  },
  {
    zip: "30474",
    ST: "GA",
    cityWithStateAbbr: "Vidalia, GA",
  },
  {
    zip: "30475",
    ST: "GA",
    cityWithStateAbbr: "Vidalia, GA",
  },
  {
    zip: "30477",
    ST: "GA",
    cityWithStateAbbr: "Wadley, GA",
  },
  {
    zip: "30499",
    ST: "GA",
    cityWithStateAbbr: "Reidsville, GA",
  },
  {
    zip: "30501",
    ST: "GA",
    cityWithStateAbbr: "Gainesville, GA",
  },
  {
    zip: "30502",
    ST: "GA",
    cityWithStateAbbr: "Chestnut Mountain, GA",
  },
  {
    zip: "30503",
    ST: "GA",
    cityWithStateAbbr: "Gainesville, GA",
  },
  {
    zip: "30504",
    ST: "GA",
    cityWithStateAbbr: "Gainesville, GA",
  },
  {
    zip: "30506",
    ST: "GA",
    cityWithStateAbbr: "Gainesville, GA",
  },
  {
    zip: "30507",
    ST: "GA",
    cityWithStateAbbr: "Gainesville, GA",
  },
  {
    zip: "30510",
    ST: "GA",
    cityWithStateAbbr: "Alto, GA",
  },
  {
    zip: "30511",
    ST: "GA",
    cityWithStateAbbr: "Baldwin, GA",
  },
  {
    zip: "30512",
    ST: "GA",
    cityWithStateAbbr: "Blairsville, GA",
  },
  {
    zip: "30513",
    ST: "GA",
    cityWithStateAbbr: "Blue Ridge, GA",
  },
  {
    zip: "30514",
    ST: "GA",
    cityWithStateAbbr: "Blairsville, GA",
  },
  {
    zip: "30515",
    ST: "GA",
    cityWithStateAbbr: "Buford, GA",
  },
  {
    zip: "30516",
    ST: "GA",
    cityWithStateAbbr: "Bowersville, GA",
  },
  {
    zip: "30517",
    ST: "GA",
    cityWithStateAbbr: "Braselton, GA",
  },
  {
    zip: "30518",
    ST: "GA",
    cityWithStateAbbr: "Buford, GA",
  },
  {
    zip: "30519",
    ST: "GA",
    cityWithStateAbbr: "Buford, GA",
  },
  {
    zip: "30520",
    ST: "GA",
    cityWithStateAbbr: "Canon, GA",
  },
  {
    zip: "30521",
    ST: "GA",
    cityWithStateAbbr: "Carnesville, GA",
  },
  {
    zip: "30522",
    ST: "GA",
    cityWithStateAbbr: "Cherry Log, GA",
  },
  {
    zip: "30523",
    ST: "GA",
    cityWithStateAbbr: "Clarkesville, GA",
  },
  {
    zip: "30525",
    ST: "GA",
    cityWithStateAbbr: "Clayton, GA",
  },
  {
    zip: "30527",
    ST: "GA",
    cityWithStateAbbr: "Clermont, GA",
  },
  {
    zip: "30528",
    ST: "GA",
    cityWithStateAbbr: "Cleveland, GA",
  },
  {
    zip: "30529",
    ST: "GA",
    cityWithStateAbbr: "Commerce, GA",
  },
  {
    zip: "30530",
    ST: "GA",
    cityWithStateAbbr: "Commerce, GA",
  },
  {
    zip: "30531",
    ST: "GA",
    cityWithStateAbbr: "Cornelia, GA",
  },
  {
    zip: "30533",
    ST: "GA",
    cityWithStateAbbr: "Dahlonega, GA",
  },
  {
    zip: "30534",
    ST: "GA",
    cityWithStateAbbr: "Dawsonville, GA",
  },
  {
    zip: "30535",
    ST: "GA",
    cityWithStateAbbr: "Demorest, GA",
  },
  {
    zip: "30536",
    ST: "GA",
    cityWithStateAbbr: "Ellijay, GA",
  },
  {
    zip: "30537",
    ST: "GA",
    cityWithStateAbbr: "Dillard, GA",
  },
  {
    zip: "30538",
    ST: "GA",
    cityWithStateAbbr: "Eastanollee, GA",
  },
  {
    zip: "30539",
    ST: "GA",
    cityWithStateAbbr: "East Ellijay, GA",
  },
  {
    zip: "30540",
    ST: "GA",
    cityWithStateAbbr: "Ellijay, GA",
  },
  {
    zip: "30541",
    ST: "GA",
    cityWithStateAbbr: "Epworth, GA",
  },
  {
    zip: "30542",
    ST: "GA",
    cityWithStateAbbr: "Flowery Branch, GA",
  },
  {
    zip: "30543",
    ST: "GA",
    cityWithStateAbbr: "Gillsville, GA",
  },
  {
    zip: "30544",
    ST: "GA",
    cityWithStateAbbr: "Demorest, GA",
  },
  {
    zip: "30545",
    ST: "GA",
    cityWithStateAbbr: "Helen, GA",
  },
  {
    zip: "30546",
    ST: "GA",
    cityWithStateAbbr: "Hiawassee, GA",
  },
  {
    zip: "30547",
    ST: "GA",
    cityWithStateAbbr: "Homer, GA",
  },
  {
    zip: "30548",
    ST: "GA",
    cityWithStateAbbr: "Hoschton, GA",
  },
  {
    zip: "30549",
    ST: "GA",
    cityWithStateAbbr: "Jefferson, GA",
  },
  {
    zip: "30552",
    ST: "GA",
    cityWithStateAbbr: "Lakemont, GA",
  },
  {
    zip: "30553",
    ST: "GA",
    cityWithStateAbbr: "Lavonia, GA",
  },
  {
    zip: "30554",
    ST: "GA",
    cityWithStateAbbr: "Lula, GA",
  },
  {
    zip: "30555",
    ST: "GA",
    cityWithStateAbbr: "Mc Caysville, GA",
  },
  {
    zip: "30557",
    ST: "GA",
    cityWithStateAbbr: "Martin, GA",
  },
  {
    zip: "30558",
    ST: "GA",
    cityWithStateAbbr: "Maysville, GA",
  },
  {
    zip: "30559",
    ST: "GA",
    cityWithStateAbbr: "Mineral Bluff, GA",
  },
  {
    zip: "30560",
    ST: "GA",
    cityWithStateAbbr: "Morganton, GA",
  },
  {
    zip: "30562",
    ST: "GA",
    cityWithStateAbbr: "Mountain City, GA",
  },
  {
    zip: "30563",
    ST: "GA",
    cityWithStateAbbr: "Mount Airy, GA",
  },
  {
    zip: "30564",
    ST: "GA",
    cityWithStateAbbr: "Murrayville, GA",
  },
  {
    zip: "30565",
    ST: "GA",
    cityWithStateAbbr: "Nicholson, GA",
  },
  {
    zip: "30566",
    ST: "GA",
    cityWithStateAbbr: "Oakwood, GA",
  },
  {
    zip: "30567",
    ST: "GA",
    cityWithStateAbbr: "Pendergrass, GA",
  },
  {
    zip: "30568",
    ST: "GA",
    cityWithStateAbbr: "Rabun Gap, GA",
  },
  {
    zip: "30571",
    ST: "GA",
    cityWithStateAbbr: "Sautee Nacoochee, GA",
  },
  {
    zip: "30572",
    ST: "GA",
    cityWithStateAbbr: "Suches, GA",
  },
  {
    zip: "30573",
    ST: "GA",
    cityWithStateAbbr: "Tallulah Falls, GA",
  },
  {
    zip: "30575",
    ST: "GA",
    cityWithStateAbbr: "Talmo, GA",
  },
  {
    zip: "30576",
    ST: "GA",
    cityWithStateAbbr: "Tiger, GA",
  },
  {
    zip: "30577",
    ST: "GA",
    cityWithStateAbbr: "Toccoa, GA",
  },
  {
    zip: "30580",
    ST: "GA",
    cityWithStateAbbr: "Turnerville, GA",
  },
  {
    zip: "30581",
    ST: "GA",
    cityWithStateAbbr: "Wiley, GA",
  },
  {
    zip: "30582",
    ST: "GA",
    cityWithStateAbbr: "Young Harris, GA",
  },
  {
    zip: "30597",
    ST: "GA",
    cityWithStateAbbr: "Dahlonega, GA",
  },
  {
    zip: "30598",
    ST: "GA",
    cityWithStateAbbr: "Toccoa Falls, GA",
  },
  {
    zip: "30599",
    ST: "GA",
    cityWithStateAbbr: "Commerce, GA",
  },
  {
    zip: "30601",
    ST: "GA",
    cityWithStateAbbr: "Athens, GA",
  },
  {
    zip: "30602",
    ST: "GA",
    cityWithStateAbbr: "Athens, GA",
  },
  {
    zip: "30603",
    ST: "GA",
    cityWithStateAbbr: "Athens, GA",
  },
  {
    zip: "30604",
    ST: "GA",
    cityWithStateAbbr: "Athens, GA",
  },
  {
    zip: "30605",
    ST: "GA",
    cityWithStateAbbr: "Athens, GA",
  },
  {
    zip: "30606",
    ST: "GA",
    cityWithStateAbbr: "Athens, GA",
  },
  {
    zip: "30607",
    ST: "GA",
    cityWithStateAbbr: "Athens, GA",
  },
  {
    zip: "30608",
    ST: "GA",
    cityWithStateAbbr: "Athens, GA",
  },
  {
    zip: "30609",
    ST: "GA",
    cityWithStateAbbr: "Athens, GA",
  },
  {
    zip: "30612",
    ST: "GA",
    cityWithStateAbbr: "Athens, GA",
  },
  {
    zip: "30619",
    ST: "GA",
    cityWithStateAbbr: "Arnoldsville, GA",
  },
  {
    zip: "30620",
    ST: "GA",
    cityWithStateAbbr: "Bethlehem, GA",
  },
  {
    zip: "30621",
    ST: "GA",
    cityWithStateAbbr: "Bishop, GA",
  },
  {
    zip: "30622",
    ST: "GA",
    cityWithStateAbbr: "Bogart, GA",
  },
  {
    zip: "30623",
    ST: "GA",
    cityWithStateAbbr: "Bostwick, GA",
  },
  {
    zip: "30624",
    ST: "GA",
    cityWithStateAbbr: "Bowman, GA",
  },
  {
    zip: "30625",
    ST: "GA",
    cityWithStateAbbr: "Buckhead, GA",
  },
  {
    zip: "30627",
    ST: "GA",
    cityWithStateAbbr: "Carlton, GA",
  },
  {
    zip: "30628",
    ST: "GA",
    cityWithStateAbbr: "Colbert, GA",
  },
  {
    zip: "30629",
    ST: "GA",
    cityWithStateAbbr: "Comer, GA",
  },
  {
    zip: "30630",
    ST: "GA",
    cityWithStateAbbr: "Crawford, GA",
  },
  {
    zip: "30631",
    ST: "GA",
    cityWithStateAbbr: "Crawfordville, GA",
  },
  {
    zip: "30633",
    ST: "GA",
    cityWithStateAbbr: "Danielsville, GA",
  },
  {
    zip: "30634",
    ST: "GA",
    cityWithStateAbbr: "Dewy Rose, GA",
  },
  {
    zip: "30635",
    ST: "GA",
    cityWithStateAbbr: "Elberton, GA",
  },
  {
    zip: "30638",
    ST: "GA",
    cityWithStateAbbr: "Farmington, GA",
  },
  {
    zip: "30639",
    ST: "GA",
    cityWithStateAbbr: "Franklin Springs, GA",
  },
  {
    zip: "30641",
    ST: "GA",
    cityWithStateAbbr: "Good Hope, GA",
  },
  {
    zip: "30642",
    ST: "GA",
    cityWithStateAbbr: "Greensboro, GA",
  },
  {
    zip: "30643",
    ST: "GA",
    cityWithStateAbbr: "Hartwell, GA",
  },
  {
    zip: "30645",
    ST: "GA",
    cityWithStateAbbr: "High Shoals, GA",
  },
  {
    zip: "30646",
    ST: "GA",
    cityWithStateAbbr: "Hull, GA",
  },
  {
    zip: "30647",
    ST: "GA",
    cityWithStateAbbr: "Ila, GA",
  },
  {
    zip: "30648",
    ST: "GA",
    cityWithStateAbbr: "Lexington, GA",
  },
  {
    zip: "30650",
    ST: "GA",
    cityWithStateAbbr: "Madison, GA",
  },
  {
    zip: "30655",
    ST: "GA",
    cityWithStateAbbr: "Monroe, GA",
  },
  {
    zip: "30656",
    ST: "GA",
    cityWithStateAbbr: "Monroe, GA",
  },
  {
    zip: "30660",
    ST: "GA",
    cityWithStateAbbr: "Rayle, GA",
  },
  {
    zip: "30662",
    ST: "GA",
    cityWithStateAbbr: "Royston, GA",
  },
  {
    zip: "30663",
    ST: "GA",
    cityWithStateAbbr: "Rutledge, GA",
  },
  {
    zip: "30664",
    ST: "GA",
    cityWithStateAbbr: "Sharon, GA",
  },
  {
    zip: "30665",
    ST: "GA",
    cityWithStateAbbr: "Siloam, GA",
  },
  {
    zip: "30666",
    ST: "GA",
    cityWithStateAbbr: "Statham, GA",
  },
  {
    zip: "30667",
    ST: "GA",
    cityWithStateAbbr: "Stephens, GA",
  },
  {
    zip: "30668",
    ST: "GA",
    cityWithStateAbbr: "Tignall, GA",
  },
  {
    zip: "30669",
    ST: "GA",
    cityWithStateAbbr: "Union Point, GA",
  },
  {
    zip: "30671",
    ST: "GA",
    cityWithStateAbbr: "Maxeys, GA",
  },
  {
    zip: "30673",
    ST: "GA",
    cityWithStateAbbr: "Washington, GA",
  },
  {
    zip: "30677",
    ST: "GA",
    cityWithStateAbbr: "Watkinsville, GA",
  },
  {
    zip: "30678",
    ST: "GA",
    cityWithStateAbbr: "White Plains, GA",
  },
  {
    zip: "30680",
    ST: "GA",
    cityWithStateAbbr: "Winder, GA",
  },
  {
    zip: "30683",
    ST: "GA",
    cityWithStateAbbr: "Winterville, GA",
  },
  {
    zip: "30701",
    ST: "GA",
    cityWithStateAbbr: "Calhoun, GA",
  },
  {
    zip: "30703",
    ST: "GA",
    cityWithStateAbbr: "Calhoun, GA",
  },
  {
    zip: "30705",
    ST: "GA",
    cityWithStateAbbr: "Chatsworth, GA",
  },
  {
    zip: "30707",
    ST: "GA",
    cityWithStateAbbr: "Chickamauga, GA",
  },
  {
    zip: "30708",
    ST: "GA",
    cityWithStateAbbr: "Cisco, GA",
  },
  {
    zip: "30710",
    ST: "GA",
    cityWithStateAbbr: "Cohutta, GA",
  },
  {
    zip: "30711",
    ST: "GA",
    cityWithStateAbbr: "Crandall, GA",
  },
  {
    zip: "30719",
    ST: "GA",
    cityWithStateAbbr: "Dalton, GA",
  },
  {
    zip: "30720",
    ST: "GA",
    cityWithStateAbbr: "Dalton, GA",
  },
  {
    zip: "30721",
    ST: "GA",
    cityWithStateAbbr: "Dalton, GA",
  },
  {
    zip: "30722",
    ST: "GA",
    cityWithStateAbbr: "Dalton, GA",
  },
  {
    zip: "30724",
    ST: "GA",
    cityWithStateAbbr: "Eton, GA",
  },
  {
    zip: "30725",
    ST: "GA",
    cityWithStateAbbr: "Flintstone, GA",
  },
  {
    zip: "30726",
    ST: "GA",
    cityWithStateAbbr: "Graysville, GA",
  },
  {
    zip: "30728",
    ST: "GA",
    cityWithStateAbbr: "La Fayette, GA",
  },
  {
    zip: "30730",
    ST: "GA",
    cityWithStateAbbr: "Lyerly, GA",
  },
  {
    zip: "30731",
    ST: "GA",
    cityWithStateAbbr: "Menlo, GA",
  },
  {
    zip: "30732",
    ST: "GA",
    cityWithStateAbbr: "Oakman, GA",
  },
  {
    zip: "30733",
    ST: "GA",
    cityWithStateAbbr: "Plainville, GA",
  },
  {
    zip: "30734",
    ST: "GA",
    cityWithStateAbbr: "Ranger, GA",
  },
  {
    zip: "30735",
    ST: "GA",
    cityWithStateAbbr: "Resaca, GA",
  },
  {
    zip: "30736",
    ST: "GA",
    cityWithStateAbbr: "Ringgold, GA",
  },
  {
    zip: "30738",
    ST: "GA",
    cityWithStateAbbr: "Rising Fawn, GA",
  },
  {
    zip: "30739",
    ST: "GA",
    cityWithStateAbbr: "Rock Spring, GA",
  },
  {
    zip: "30740",
    ST: "GA",
    cityWithStateAbbr: "Rocky Face, GA",
  },
  {
    zip: "30741",
    ST: "GA",
    cityWithStateAbbr: "Rossville, GA",
  },
  {
    zip: "30742",
    ST: "GA",
    cityWithStateAbbr: "Fort Oglethorpe, GA",
  },
  {
    zip: "30746",
    ST: "GA",
    cityWithStateAbbr: "Sugar Valley, GA",
  },
  {
    zip: "30747",
    ST: "GA",
    cityWithStateAbbr: "Summerville, GA",
  },
  {
    zip: "30750",
    ST: "GA",
    cityWithStateAbbr: "Lookout Mountain, GA",
  },
  {
    zip: "30751",
    ST: "GA",
    cityWithStateAbbr: "Tennga, GA",
  },
  {
    zip: "30752",
    ST: "GA",
    cityWithStateAbbr: "Trenton, GA",
  },
  {
    zip: "30753",
    ST: "GA",
    cityWithStateAbbr: "Trion, GA",
  },
  {
    zip: "30755",
    ST: "GA",
    cityWithStateAbbr: "Tunnel Hill, GA",
  },
  {
    zip: "30756",
    ST: "GA",
    cityWithStateAbbr: "Varnell, GA",
  },
  {
    zip: "30757",
    ST: "GA",
    cityWithStateAbbr: "Wildwood, GA",
  },
  {
    zip: "30802",
    ST: "GA",
    cityWithStateAbbr: "Appling, GA",
  },
  {
    zip: "30803",
    ST: "GA",
    cityWithStateAbbr: "Avera, GA",
  },
  {
    zip: "30805",
    ST: "GA",
    cityWithStateAbbr: "Blythe, GA",
  },
  {
    zip: "30806",
    ST: "GA",
    cityWithStateAbbr: "Boneville, GA",
  },
  {
    zip: "30807",
    ST: "GA",
    cityWithStateAbbr: "Camak, GA",
  },
  {
    zip: "30808",
    ST: "GA",
    cityWithStateAbbr: "Dearing, GA",
  },
  {
    zip: "30809",
    ST: "GA",
    cityWithStateAbbr: "Evans, GA",
  },
  {
    zip: "30810",
    ST: "GA",
    cityWithStateAbbr: "Gibson, GA",
  },
  {
    zip: "30811",
    ST: "GA",
    cityWithStateAbbr: "Gough, GA",
  },
  {
    zip: "30812",
    ST: "GA",
    cityWithStateAbbr: "Gracewood, GA",
  },
  {
    zip: "30813",
    ST: "GA",
    cityWithStateAbbr: "Grovetown, GA",
  },
  {
    zip: "30814",
    ST: "GA",
    cityWithStateAbbr: "Harlem, GA",
  },
  {
    zip: "30815",
    ST: "GA",
    cityWithStateAbbr: "Hephzibah, GA",
  },
  {
    zip: "30816",
    ST: "GA",
    cityWithStateAbbr: "Keysville, GA",
  },
  {
    zip: "30817",
    ST: "GA",
    cityWithStateAbbr: "Lincolnton, GA",
  },
  {
    zip: "30818",
    ST: "GA",
    cityWithStateAbbr: "Matthews, GA",
  },
  {
    zip: "30819",
    ST: "GA",
    cityWithStateAbbr: "Mesena, GA",
  },
  {
    zip: "30820",
    ST: "GA",
    cityWithStateAbbr: "Mitchell, GA",
  },
  {
    zip: "30821",
    ST: "GA",
    cityWithStateAbbr: "Norwood, GA",
  },
  {
    zip: "30822",
    ST: "GA",
    cityWithStateAbbr: "Perkins, GA",
  },
  {
    zip: "30823",
    ST: "GA",
    cityWithStateAbbr: "Stapleton, GA",
  },
  {
    zip: "30824",
    ST: "GA",
    cityWithStateAbbr: "Thomson, GA",
  },
  {
    zip: "30828",
    ST: "GA",
    cityWithStateAbbr: "Warrenton, GA",
  },
  {
    zip: "30830",
    ST: "GA",
    cityWithStateAbbr: "Waynesboro, GA",
  },
  {
    zip: "30833",
    ST: "GA",
    cityWithStateAbbr: "Wrens, GA",
  },
  {
    zip: "30901",
    ST: "GA",
    cityWithStateAbbr: "Augusta, GA",
  },
  {
    zip: "30903",
    ST: "GA",
    cityWithStateAbbr: "Augusta, GA",
  },
  {
    zip: "30904",
    ST: "GA",
    cityWithStateAbbr: "Augusta, GA",
  },
  {
    zip: "30905",
    ST: "GA",
    cityWithStateAbbr: "Augusta, GA",
  },
  {
    zip: "30906",
    ST: "GA",
    cityWithStateAbbr: "Augusta, GA",
  },
  {
    zip: "30907",
    ST: "GA",
    cityWithStateAbbr: "Augusta, GA",
  },
  {
    zip: "30909",
    ST: "GA",
    cityWithStateAbbr: "Augusta, GA",
  },
  {
    zip: "30912",
    ST: "GA",
    cityWithStateAbbr: "Augusta, GA",
  },
  {
    zip: "30913",
    ST: "GA",
    cityWithStateAbbr: "Augusta, GA",
  },
  {
    zip: "30914",
    ST: "GA",
    cityWithStateAbbr: "Augusta, GA",
  },
  {
    zip: "30916",
    ST: "GA",
    cityWithStateAbbr: "Augusta, GA",
  },
  {
    zip: "30917",
    ST: "GA",
    cityWithStateAbbr: "Augusta, GA",
  },
  {
    zip: "30919",
    ST: "GA",
    cityWithStateAbbr: "Augusta, GA",
  },
  {
    zip: "30999",
    ST: "GA",
    cityWithStateAbbr: "Augusta, GA",
  },
  {
    zip: "31001",
    ST: "GA",
    cityWithStateAbbr: "Abbeville, GA",
  },
  {
    zip: "31002",
    ST: "GA",
    cityWithStateAbbr: "Adrian, GA",
  },
  {
    zip: "31003",
    ST: "GA",
    cityWithStateAbbr: "Allentown, GA",
  },
  {
    zip: "31004",
    ST: "GA",
    cityWithStateAbbr: "Bolingbroke, GA",
  },
  {
    zip: "31005",
    ST: "GA",
    cityWithStateAbbr: "Bonaire, GA",
  },
  {
    zip: "31006",
    ST: "GA",
    cityWithStateAbbr: "Butler, GA",
  },
  {
    zip: "31007",
    ST: "GA",
    cityWithStateAbbr: "Byromville, GA",
  },
  {
    zip: "31008",
    ST: "GA",
    cityWithStateAbbr: "Byron, GA",
  },
  {
    zip: "31009",
    ST: "GA",
    cityWithStateAbbr: "Cadwell, GA",
  },
  {
    zip: "31010",
    ST: "GA",
    cityWithStateAbbr: "Cordele, GA",
  },
  {
    zip: "31011",
    ST: "GA",
    cityWithStateAbbr: "Chauncey, GA",
  },
  {
    zip: "31012",
    ST: "GA",
    cityWithStateAbbr: "Chester, GA",
  },
  {
    zip: "31013",
    ST: "GA",
    cityWithStateAbbr: "Clinchfield, GA",
  },
  {
    zip: "31014",
    ST: "GA",
    cityWithStateAbbr: "Cochran, GA",
  },
  {
    zip: "31015",
    ST: "GA",
    cityWithStateAbbr: "Cordele, GA",
  },
  {
    zip: "31016",
    ST: "GA",
    cityWithStateAbbr: "Culloden, GA",
  },
  {
    zip: "31017",
    ST: "GA",
    cityWithStateAbbr: "Danville, GA",
  },
  {
    zip: "31018",
    ST: "GA",
    cityWithStateAbbr: "Davisboro, GA",
  },
  {
    zip: "31019",
    ST: "GA",
    cityWithStateAbbr: "Dexter, GA",
  },
  {
    zip: "31020",
    ST: "GA",
    cityWithStateAbbr: "Dry Branch, GA",
  },
  {
    zip: "31021",
    ST: "GA",
    cityWithStateAbbr: "Dublin, GA",
  },
  {
    zip: "31022",
    ST: "GA",
    cityWithStateAbbr: "Dudley, GA",
  },
  {
    zip: "31023",
    ST: "GA",
    cityWithStateAbbr: "Eastman, GA",
  },
  {
    zip: "31024",
    ST: "GA",
    cityWithStateAbbr: "Eatonton, GA",
  },
  {
    zip: "31025",
    ST: "GA",
    cityWithStateAbbr: "Elko, GA",
  },
  {
    zip: "31026",
    ST: "GA",
    cityWithStateAbbr: "Eatonton, GA",
  },
  {
    zip: "31027",
    ST: "GA",
    cityWithStateAbbr: "East Dublin, GA",
  },
  {
    zip: "31028",
    ST: "GA",
    cityWithStateAbbr: "Centerville, GA",
  },
  {
    zip: "31029",
    ST: "GA",
    cityWithStateAbbr: "Forsyth, GA",
  },
  {
    zip: "31030",
    ST: "GA",
    cityWithStateAbbr: "Fort Valley, GA",
  },
  {
    zip: "31031",
    ST: "GA",
    cityWithStateAbbr: "Gordon, GA",
  },
  {
    zip: "31032",
    ST: "GA",
    cityWithStateAbbr: "Gray, GA",
  },
  {
    zip: "31033",
    ST: "GA",
    cityWithStateAbbr: "Haddock, GA",
  },
  {
    zip: "31034",
    ST: "GA",
    cityWithStateAbbr: "Hardwick, GA",
  },
  {
    zip: "31035",
    ST: "GA",
    cityWithStateAbbr: "Harrison, GA",
  },
  {
    zip: "31036",
    ST: "GA",
    cityWithStateAbbr: "Hawkinsville, GA",
  },
  {
    zip: "31037",
    ST: "GA",
    cityWithStateAbbr: "Helena, GA",
  },
  {
    zip: "31038",
    ST: "GA",
    cityWithStateAbbr: "Hillsboro, GA",
  },
  {
    zip: "31039",
    ST: "GA",
    cityWithStateAbbr: "Howard, GA",
  },
  {
    zip: "31040",
    ST: "GA",
    cityWithStateAbbr: "Dublin, GA",
  },
  {
    zip: "31041",
    ST: "GA",
    cityWithStateAbbr: "Ideal, GA",
  },
  {
    zip: "31042",
    ST: "GA",
    cityWithStateAbbr: "Irwinton, GA",
  },
  {
    zip: "31044",
    ST: "GA",
    cityWithStateAbbr: "Jeffersonville, GA",
  },
  {
    zip: "31045",
    ST: "GA",
    cityWithStateAbbr: "Jewell, GA",
  },
  {
    zip: "31046",
    ST: "GA",
    cityWithStateAbbr: "Juliette, GA",
  },
  {
    zip: "31047",
    ST: "GA",
    cityWithStateAbbr: "Kathleen, GA",
  },
  {
    zip: "31049",
    ST: "GA",
    cityWithStateAbbr: "Kite, GA",
  },
  {
    zip: "31050",
    ST: "GA",
    cityWithStateAbbr: "Knoxville, GA",
  },
  {
    zip: "31051",
    ST: "GA",
    cityWithStateAbbr: "Lilly, GA",
  },
  {
    zip: "31052",
    ST: "GA",
    cityWithStateAbbr: "Lizella, GA",
  },
  {
    zip: "31054",
    ST: "GA",
    cityWithStateAbbr: "Mc Intyre, GA",
  },
  {
    zip: "31055",
    ST: "GA",
    cityWithStateAbbr: "Mc Rae, GA",
  },
  {
    zip: "31057",
    ST: "GA",
    cityWithStateAbbr: "Marshallville, GA",
  },
  {
    zip: "31058",
    ST: "GA",
    cityWithStateAbbr: "Mauk, GA",
  },
  {
    zip: "31059",
    ST: "GA",
    cityWithStateAbbr: "Milledgeville, GA",
  },
  {
    zip: "31060",
    ST: "GA",
    cityWithStateAbbr: "Milan, GA",
  },
  {
    zip: "31061",
    ST: "GA",
    cityWithStateAbbr: "Milledgeville, GA",
  },
  {
    zip: "31062",
    ST: "GA",
    cityWithStateAbbr: "Milledgeville, GA",
  },
  {
    zip: "31063",
    ST: "GA",
    cityWithStateAbbr: "Montezuma, GA",
  },
  {
    zip: "31064",
    ST: "GA",
    cityWithStateAbbr: "Monticello, GA",
  },
  {
    zip: "31065",
    ST: "GA",
    cityWithStateAbbr: "Montrose, GA",
  },
  {
    zip: "31066",
    ST: "GA",
    cityWithStateAbbr: "Musella, GA",
  },
  {
    zip: "31067",
    ST: "GA",
    cityWithStateAbbr: "Oconee, GA",
  },
  {
    zip: "31068",
    ST: "GA",
    cityWithStateAbbr: "Oglethorpe, GA",
  },
  {
    zip: "31069",
    ST: "GA",
    cityWithStateAbbr: "Perry, GA",
  },
  {
    zip: "31070",
    ST: "GA",
    cityWithStateAbbr: "Pinehurst, GA",
  },
  {
    zip: "31071",
    ST: "GA",
    cityWithStateAbbr: "Pineview, GA",
  },
  {
    zip: "31072",
    ST: "GA",
    cityWithStateAbbr: "Pitts, GA",
  },
  {
    zip: "31075",
    ST: "GA",
    cityWithStateAbbr: "Rentz, GA",
  },
  {
    zip: "31076",
    ST: "GA",
    cityWithStateAbbr: "Reynolds, GA",
  },
  {
    zip: "31077",
    ST: "GA",
    cityWithStateAbbr: "Rhine, GA",
  },
  {
    zip: "31078",
    ST: "GA",
    cityWithStateAbbr: "Roberta, GA",
  },
  {
    zip: "31079",
    ST: "GA",
    cityWithStateAbbr: "Rochelle, GA",
  },
  {
    zip: "31081",
    ST: "GA",
    cityWithStateAbbr: "Rupert, GA",
  },
  {
    zip: "31082",
    ST: "GA",
    cityWithStateAbbr: "Sandersville, GA",
  },
  {
    zip: "31083",
    ST: "GA",
    cityWithStateAbbr: "Scotland, GA",
  },
  {
    zip: "31084",
    ST: "GA",
    cityWithStateAbbr: "Seville, GA",
  },
  {
    zip: "31085",
    ST: "GA",
    cityWithStateAbbr: "Shady Dale, GA",
  },
  {
    zip: "31086",
    ST: "GA",
    cityWithStateAbbr: "Smarr, GA",
  },
  {
    zip: "31087",
    ST: "GA",
    cityWithStateAbbr: "Sparta, GA",
  },
  {
    zip: "31088",
    ST: "GA",
    cityWithStateAbbr: "Warner Robins, GA",
  },
  {
    zip: "31089",
    ST: "GA",
    cityWithStateAbbr: "Tennille, GA",
  },
  {
    zip: "31090",
    ST: "GA",
    cityWithStateAbbr: "Toomsboro, GA",
  },
  {
    zip: "31091",
    ST: "GA",
    cityWithStateAbbr: "Unadilla, GA",
  },
  {
    zip: "31092",
    ST: "GA",
    cityWithStateAbbr: "Vienna, GA",
  },
  {
    zip: "31093",
    ST: "GA",
    cityWithStateAbbr: "Warner Robins, GA",
  },
  {
    zip: "31094",
    ST: "GA",
    cityWithStateAbbr: "Warthen, GA",
  },
  {
    zip: "31095",
    ST: "GA",
    cityWithStateAbbr: "Warner Robins, GA",
  },
  {
    zip: "31096",
    ST: "GA",
    cityWithStateAbbr: "Wrightsville, GA",
  },
  {
    zip: "31097",
    ST: "GA",
    cityWithStateAbbr: "Yatesville, GA",
  },
  {
    zip: "31098",
    ST: "GA",
    cityWithStateAbbr: "Warner Robins, GA",
  },
  {
    zip: "31099",
    ST: "GA",
    cityWithStateAbbr: "Warner Robins, GA",
  },
  {
    zip: "31106",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "31107",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "31119",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "31126",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "31131",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "31136",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "31139",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "31141",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "31145",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "31146",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "31150",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "31156",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "31192",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "31193",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "31195",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "31196",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "31201",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31202",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31203",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31204",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31205",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31206",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31207",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31208",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31209",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31210",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31211",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31212",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31213",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31216",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31217",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31220",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31221",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31294",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31295",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31296",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31297",
    ST: "GA",
    cityWithStateAbbr: "Macon, GA",
  },
  {
    zip: "31301",
    ST: "GA",
    cityWithStateAbbr: "Allenhurst, GA",
  },
  {
    zip: "31302",
    ST: "GA",
    cityWithStateAbbr: "Bloomingdale, GA",
  },
  {
    zip: "31303",
    ST: "GA",
    cityWithStateAbbr: "Clyo, GA",
  },
  {
    zip: "31304",
    ST: "GA",
    cityWithStateAbbr: "Crescent, GA",
  },
  {
    zip: "31305",
    ST: "GA",
    cityWithStateAbbr: "Darien, GA",
  },
  {
    zip: "31307",
    ST: "GA",
    cityWithStateAbbr: "Eden, GA",
  },
  {
    zip: "31308",
    ST: "GA",
    cityWithStateAbbr: "Ellabell, GA",
  },
  {
    zip: "31309",
    ST: "GA",
    cityWithStateAbbr: "Fleming, GA",
  },
  {
    zip: "31310",
    ST: "GA",
    cityWithStateAbbr: "Hinesville, GA",
  },
  {
    zip: "31312",
    ST: "GA",
    cityWithStateAbbr: "Guyton, GA",
  },
  {
    zip: "31313",
    ST: "GA",
    cityWithStateAbbr: "Hinesville, GA",
  },
  {
    zip: "31314",
    ST: "GA",
    cityWithStateAbbr: "Fort Stewart, GA",
  },
  {
    zip: "31315",
    ST: "GA",
    cityWithStateAbbr: "Fort Stewart, GA",
  },
  {
    zip: "31316",
    ST: "GA",
    cityWithStateAbbr: "Ludowici, GA",
  },
  {
    zip: "31318",
    ST: "GA",
    cityWithStateAbbr: "Meldrim, GA",
  },
  {
    zip: "31319",
    ST: "GA",
    cityWithStateAbbr: "Meridian, GA",
  },
  {
    zip: "31320",
    ST: "GA",
    cityWithStateAbbr: "Midway, GA",
  },
  {
    zip: "31321",
    ST: "GA",
    cityWithStateAbbr: "Pembroke, GA",
  },
  {
    zip: "31322",
    ST: "GA",
    cityWithStateAbbr: "Pooler, GA",
  },
  {
    zip: "31323",
    ST: "GA",
    cityWithStateAbbr: "Riceboro, GA",
  },
  {
    zip: "31324",
    ST: "GA",
    cityWithStateAbbr: "Richmond Hill, GA",
  },
  {
    zip: "31326",
    ST: "GA",
    cityWithStateAbbr: "Rincon, GA",
  },
  {
    zip: "31327",
    ST: "GA",
    cityWithStateAbbr: "Sapelo Island, GA",
  },
  {
    zip: "31328",
    ST: "GA",
    cityWithStateAbbr: "Tybee Island, GA",
  },
  {
    zip: "31329",
    ST: "GA",
    cityWithStateAbbr: "Springfield, GA",
  },
  {
    zip: "31331",
    ST: "GA",
    cityWithStateAbbr: "Townsend, GA",
  },
  {
    zip: "31333",
    ST: "GA",
    cityWithStateAbbr: "Walthourville, GA",
  },
  {
    zip: "31401",
    ST: "GA",
    cityWithStateAbbr: "Savannah, GA",
  },
  {
    zip: "31402",
    ST: "GA",
    cityWithStateAbbr: "Savannah, GA",
  },
  {
    zip: "31403",
    ST: "GA",
    cityWithStateAbbr: "Savannah, GA",
  },
  {
    zip: "31404",
    ST: "GA",
    cityWithStateAbbr: "Savannah, GA",
  },
  {
    zip: "31405",
    ST: "GA",
    cityWithStateAbbr: "Savannah, GA",
  },
  {
    zip: "31406",
    ST: "GA",
    cityWithStateAbbr: "Savannah, GA",
  },
  {
    zip: "31407",
    ST: "GA",
    cityWithStateAbbr: "Port Wentworth, GA",
  },
  {
    zip: "31408",
    ST: "GA",
    cityWithStateAbbr: "Savannah, GA",
  },
  {
    zip: "31409",
    ST: "GA",
    cityWithStateAbbr: "Savannah, GA",
  },
  {
    zip: "31410",
    ST: "GA",
    cityWithStateAbbr: "Savannah, GA",
  },
  {
    zip: "31411",
    ST: "GA",
    cityWithStateAbbr: "Savannah, GA",
  },
  {
    zip: "31412",
    ST: "GA",
    cityWithStateAbbr: "Savannah, GA",
  },
  {
    zip: "31414",
    ST: "GA",
    cityWithStateAbbr: "Savannah, GA",
  },
  {
    zip: "31415",
    ST: "GA",
    cityWithStateAbbr: "Savannah, GA",
  },
  {
    zip: "31416",
    ST: "GA",
    cityWithStateAbbr: "Savannah, GA",
  },
  {
    zip: "31418",
    ST: "GA",
    cityWithStateAbbr: "Savannah, GA",
  },
  {
    zip: "31419",
    ST: "GA",
    cityWithStateAbbr: "Savannah, GA",
  },
  {
    zip: "31420",
    ST: "GA",
    cityWithStateAbbr: "Savannah, GA",
  },
  {
    zip: "31421",
    ST: "GA",
    cityWithStateAbbr: "Savannah, GA",
  },
  {
    zip: "31501",
    ST: "GA",
    cityWithStateAbbr: "Waycross, GA",
  },
  {
    zip: "31502",
    ST: "GA",
    cityWithStateAbbr: "Waycross, GA",
  },
  {
    zip: "31503",
    ST: "GA",
    cityWithStateAbbr: "Waycross, GA",
  },
  {
    zip: "31510",
    ST: "GA",
    cityWithStateAbbr: "Alma, GA",
  },
  {
    zip: "31512",
    ST: "GA",
    cityWithStateAbbr: "Ambrose, GA",
  },
  {
    zip: "31513",
    ST: "GA",
    cityWithStateAbbr: "Baxley, GA",
  },
  {
    zip: "31515",
    ST: "GA",
    cityWithStateAbbr: "Baxley, GA",
  },
  {
    zip: "31516",
    ST: "GA",
    cityWithStateAbbr: "Blackshear, GA",
  },
  {
    zip: "31518",
    ST: "GA",
    cityWithStateAbbr: "Bristol, GA",
  },
  {
    zip: "31519",
    ST: "GA",
    cityWithStateAbbr: "Broxton, GA",
  },
  {
    zip: "31520",
    ST: "GA",
    cityWithStateAbbr: "Brunswick, GA",
  },
  {
    zip: "31521",
    ST: "GA",
    cityWithStateAbbr: "Brunswick, GA",
  },
  {
    zip: "31522",
    ST: "GA",
    cityWithStateAbbr: "Saint Simons Island, GA",
  },
  {
    zip: "31523",
    ST: "GA",
    cityWithStateAbbr: "Brunswick, GA",
  },
  {
    zip: "31524",
    ST: "GA",
    cityWithStateAbbr: "Brunswick, GA",
  },
  {
    zip: "31525",
    ST: "GA",
    cityWithStateAbbr: "Brunswick, GA",
  },
  {
    zip: "31527",
    ST: "GA",
    cityWithStateAbbr: "Jekyll Island, GA",
  },
  {
    zip: "31532",
    ST: "GA",
    cityWithStateAbbr: "Denton, GA",
  },
  {
    zip: "31533",
    ST: "GA",
    cityWithStateAbbr: "Douglas, GA",
  },
  {
    zip: "31534",
    ST: "GA",
    cityWithStateAbbr: "Douglas, GA",
  },
  {
    zip: "31535",
    ST: "GA",
    cityWithStateAbbr: "Douglas, GA",
  },
  {
    zip: "31537",
    ST: "GA",
    cityWithStateAbbr: "Folkston, GA",
  },
  {
    zip: "31539",
    ST: "GA",
    cityWithStateAbbr: "Hazlehurst, GA",
  },
  {
    zip: "31542",
    ST: "GA",
    cityWithStateAbbr: "Hoboken, GA",
  },
  {
    zip: "31543",
    ST: "GA",
    cityWithStateAbbr: "Hortense, GA",
  },
  {
    zip: "31544",
    ST: "GA",
    cityWithStateAbbr: "Jacksonville, GA",
  },
  {
    zip: "31545",
    ST: "GA",
    cityWithStateAbbr: "Jesup, GA",
  },
  {
    zip: "31546",
    ST: "GA",
    cityWithStateAbbr: "Jesup, GA",
  },
  {
    zip: "31547",
    ST: "GA",
    cityWithStateAbbr: "Kings Bay, GA",
  },
  {
    zip: "31548",
    ST: "GA",
    cityWithStateAbbr: "Kingsland, GA",
  },
  {
    zip: "31549",
    ST: "GA",
    cityWithStateAbbr: "Lumber City, GA",
  },
  {
    zip: "31550",
    ST: "GA",
    cityWithStateAbbr: "Manor, GA",
  },
  {
    zip: "31551",
    ST: "GA",
    cityWithStateAbbr: "Mershon, GA",
  },
  {
    zip: "31552",
    ST: "GA",
    cityWithStateAbbr: "Millwood, GA",
  },
  {
    zip: "31553",
    ST: "GA",
    cityWithStateAbbr: "Nahunta, GA",
  },
  {
    zip: "31554",
    ST: "GA",
    cityWithStateAbbr: "Nicholls, GA",
  },
  {
    zip: "31555",
    ST: "GA",
    cityWithStateAbbr: "Odum, GA",
  },
  {
    zip: "31556",
    ST: "GA",
    cityWithStateAbbr: "Offerman, GA",
  },
  {
    zip: "31557",
    ST: "GA",
    cityWithStateAbbr: "Patterson, GA",
  },
  {
    zip: "31558",
    ST: "GA",
    cityWithStateAbbr: "Saint Marys, GA",
  },
  {
    zip: "31560",
    ST: "GA",
    cityWithStateAbbr: "Screven, GA",
  },
  {
    zip: "31561",
    ST: "GA",
    cityWithStateAbbr: "Sea Island, GA",
  },
  {
    zip: "31562",
    ST: "GA",
    cityWithStateAbbr: "Saint George, GA",
  },
  {
    zip: "31563",
    ST: "GA",
    cityWithStateAbbr: "Surrency, GA",
  },
  {
    zip: "31564",
    ST: "GA",
    cityWithStateAbbr: "Waresboro, GA",
  },
  {
    zip: "31565",
    ST: "GA",
    cityWithStateAbbr: "Waverly, GA",
  },
  {
    zip: "31566",
    ST: "GA",
    cityWithStateAbbr: "Waynesville, GA",
  },
  {
    zip: "31567",
    ST: "GA",
    cityWithStateAbbr: "West Green, GA",
  },
  {
    zip: "31568",
    ST: "GA",
    cityWithStateAbbr: "White Oak, GA",
  },
  {
    zip: "31569",
    ST: "GA",
    cityWithStateAbbr: "Woodbine, GA",
  },
  {
    zip: "31598",
    ST: "GA",
    cityWithStateAbbr: "Jesup, GA",
  },
  {
    zip: "31599",
    ST: "GA",
    cityWithStateAbbr: "Jesup, GA",
  },
  {
    zip: "31601",
    ST: "GA",
    cityWithStateAbbr: "Valdosta, GA",
  },
  {
    zip: "31602",
    ST: "GA",
    cityWithStateAbbr: "Valdosta, GA",
  },
  {
    zip: "31603",
    ST: "GA",
    cityWithStateAbbr: "Valdosta, GA",
  },
  {
    zip: "31604",
    ST: "GA",
    cityWithStateAbbr: "Valdosta, GA",
  },
  {
    zip: "31605",
    ST: "GA",
    cityWithStateAbbr: "Valdosta, GA",
  },
  {
    zip: "31606",
    ST: "GA",
    cityWithStateAbbr: "Valdosta, GA",
  },
  {
    zip: "31620",
    ST: "GA",
    cityWithStateAbbr: "Adel, GA",
  },
  {
    zip: "31622",
    ST: "GA",
    cityWithStateAbbr: "Alapaha, GA",
  },
  {
    zip: "31623",
    ST: "GA",
    cityWithStateAbbr: "Argyle, GA",
  },
  {
    zip: "31624",
    ST: "GA",
    cityWithStateAbbr: "Axson, GA",
  },
  {
    zip: "31625",
    ST: "GA",
    cityWithStateAbbr: "Barney, GA",
  },
  {
    zip: "31626",
    ST: "GA",
    cityWithStateAbbr: "Boston, GA",
  },
  {
    zip: "31627",
    ST: "GA",
    cityWithStateAbbr: "Cecil, GA",
  },
  {
    zip: "31629",
    ST: "GA",
    cityWithStateAbbr: "Dixie, GA",
  },
  {
    zip: "31630",
    ST: "GA",
    cityWithStateAbbr: "Du Pont, GA",
  },
  {
    zip: "31631",
    ST: "GA",
    cityWithStateAbbr: "Fargo, GA",
  },
  {
    zip: "31632",
    ST: "GA",
    cityWithStateAbbr: "Hahira, GA",
  },
  {
    zip: "31634",
    ST: "GA",
    cityWithStateAbbr: "Homerville, GA",
  },
  {
    zip: "31635",
    ST: "GA",
    cityWithStateAbbr: "Lakeland, GA",
  },
  {
    zip: "31636",
    ST: "GA",
    cityWithStateAbbr: "Lake Park, GA",
  },
  {
    zip: "31637",
    ST: "GA",
    cityWithStateAbbr: "Lenox, GA",
  },
  {
    zip: "31638",
    ST: "GA",
    cityWithStateAbbr: "Morven, GA",
  },
  {
    zip: "31639",
    ST: "GA",
    cityWithStateAbbr: "Nashville, GA",
  },
  {
    zip: "31641",
    ST: "GA",
    cityWithStateAbbr: "Naylor, GA",
  },
  {
    zip: "31642",
    ST: "GA",
    cityWithStateAbbr: "Pearson, GA",
  },
  {
    zip: "31643",
    ST: "GA",
    cityWithStateAbbr: "Quitman, GA",
  },
  {
    zip: "31645",
    ST: "GA",
    cityWithStateAbbr: "Ray City, GA",
  },
  {
    zip: "31647",
    ST: "GA",
    cityWithStateAbbr: "Sparks, GA",
  },
  {
    zip: "31648",
    ST: "GA",
    cityWithStateAbbr: "Statenville, GA",
  },
  {
    zip: "31649",
    ST: "GA",
    cityWithStateAbbr: "Stockton, GA",
  },
  {
    zip: "31650",
    ST: "GA",
    cityWithStateAbbr: "Willacoochee, GA",
  },
  {
    zip: "31698",
    ST: "GA",
    cityWithStateAbbr: "Valdosta, GA",
  },
  {
    zip: "31699",
    ST: "GA",
    cityWithStateAbbr: "Moody Afb, GA",
  },
  {
    zip: "31701",
    ST: "GA",
    cityWithStateAbbr: "Albany, GA",
  },
  {
    zip: "31702",
    ST: "GA",
    cityWithStateAbbr: "Albany, GA",
  },
  {
    zip: "31703",
    ST: "GA",
    cityWithStateAbbr: "Albany, GA",
  },
  {
    zip: "31704",
    ST: "GA",
    cityWithStateAbbr: "Albany, GA",
  },
  {
    zip: "31705",
    ST: "GA",
    cityWithStateAbbr: "Albany, GA",
  },
  {
    zip: "31706",
    ST: "GA",
    cityWithStateAbbr: "Albany, GA",
  },
  {
    zip: "31707",
    ST: "GA",
    cityWithStateAbbr: "Albany, GA",
  },
  {
    zip: "31708",
    ST: "GA",
    cityWithStateAbbr: "Albany, GA",
  },
  {
    zip: "31709",
    ST: "GA",
    cityWithStateAbbr: "Americus, GA",
  },
  {
    zip: "31711",
    ST: "GA",
    cityWithStateAbbr: "Andersonville, GA",
  },
  {
    zip: "31712",
    ST: "GA",
    cityWithStateAbbr: "Arabi, GA",
  },
  {
    zip: "31714",
    ST: "GA",
    cityWithStateAbbr: "Ashburn, GA",
  },
  {
    zip: "31716",
    ST: "GA",
    cityWithStateAbbr: "Baconton, GA",
  },
  {
    zip: "31719",
    ST: "GA",
    cityWithStateAbbr: "Americus, GA",
  },
  {
    zip: "31720",
    ST: "GA",
    cityWithStateAbbr: "Barwick, GA",
  },
  {
    zip: "31721",
    ST: "GA",
    cityWithStateAbbr: "Albany, GA",
  },
  {
    zip: "31722",
    ST: "GA",
    cityWithStateAbbr: "Berlin, GA",
  },
  {
    zip: "31727",
    ST: "GA",
    cityWithStateAbbr: "Brookfield, GA",
  },
  {
    zip: "31730",
    ST: "GA",
    cityWithStateAbbr: "Camilla, GA",
  },
  {
    zip: "31733",
    ST: "GA",
    cityWithStateAbbr: "Chula, GA",
  },
  {
    zip: "31735",
    ST: "GA",
    cityWithStateAbbr: "Cobb, GA",
  },
  {
    zip: "31738",
    ST: "GA",
    cityWithStateAbbr: "Coolidge, GA",
  },
  {
    zip: "31739",
    ST: "GA",
    cityWithStateAbbr: "Cotton, GA",
  },
  {
    zip: "31742",
    ST: "GA",
    cityWithStateAbbr: "Dawson, GA",
  },
  {
    zip: "31743",
    ST: "GA",
    cityWithStateAbbr: "De Soto, GA",
  },
  {
    zip: "31744",
    ST: "GA",
    cityWithStateAbbr: "Doerun, GA",
  },
  {
    zip: "31747",
    ST: "GA",
    cityWithStateAbbr: "Ellenton, GA",
  },
  {
    zip: "31749",
    ST: "GA",
    cityWithStateAbbr: "Enigma, GA",
  },
  {
    zip: "31750",
    ST: "GA",
    cityWithStateAbbr: "Fitzgerald, GA",
  },
  {
    zip: "31753",
    ST: "GA",
    cityWithStateAbbr: "Funston, GA",
  },
  {
    zip: "31756",
    ST: "GA",
    cityWithStateAbbr: "Hartsfield, GA",
  },
  {
    zip: "31757",
    ST: "GA",
    cityWithStateAbbr: "Thomasville, GA",
  },
  {
    zip: "31758",
    ST: "GA",
    cityWithStateAbbr: "Thomasville, GA",
  },
  {
    zip: "31760",
    ST: "GA",
    cityWithStateAbbr: "Irwinville, GA",
  },
  {
    zip: "31763",
    ST: "GA",
    cityWithStateAbbr: "Leesburg, GA",
  },
  {
    zip: "31764",
    ST: "GA",
    cityWithStateAbbr: "Leslie, GA",
  },
  {
    zip: "31765",
    ST: "GA",
    cityWithStateAbbr: "Meigs, GA",
  },
  {
    zip: "31768",
    ST: "GA",
    cityWithStateAbbr: "Moultrie, GA",
  },
  {
    zip: "31769",
    ST: "GA",
    cityWithStateAbbr: "Mystic, GA",
  },
  {
    zip: "31771",
    ST: "GA",
    cityWithStateAbbr: "Norman Park, GA",
  },
  {
    zip: "31772",
    ST: "GA",
    cityWithStateAbbr: "Oakfield, GA",
  },
  {
    zip: "31773",
    ST: "GA",
    cityWithStateAbbr: "Ochlocknee, GA",
  },
  {
    zip: "31774",
    ST: "GA",
    cityWithStateAbbr: "Ocilla, GA",
  },
  {
    zip: "31775",
    ST: "GA",
    cityWithStateAbbr: "Omega, GA",
  },
  {
    zip: "31776",
    ST: "GA",
    cityWithStateAbbr: "Moultrie, GA",
  },
  {
    zip: "31777",
    ST: "GA",
    cityWithStateAbbr: "Parrott, GA",
  },
  {
    zip: "31778",
    ST: "GA",
    cityWithStateAbbr: "Pavo, GA",
  },
  {
    zip: "31779",
    ST: "GA",
    cityWithStateAbbr: "Pelham, GA",
  },
  {
    zip: "31780",
    ST: "GA",
    cityWithStateAbbr: "Plains, GA",
  },
  {
    zip: "31781",
    ST: "GA",
    cityWithStateAbbr: "Poulan, GA",
  },
  {
    zip: "31782",
    ST: "GA",
    cityWithStateAbbr: "Putney, GA",
  },
  {
    zip: "31783",
    ST: "GA",
    cityWithStateAbbr: "Rebecca, GA",
  },
  {
    zip: "31784",
    ST: "GA",
    cityWithStateAbbr: "Sale City, GA",
  },
  {
    zip: "31785",
    ST: "GA",
    cityWithStateAbbr: "Sasser, GA",
  },
  {
    zip: "31786",
    ST: "GA",
    cityWithStateAbbr: "Shellman, GA",
  },
  {
    zip: "31787",
    ST: "GA",
    cityWithStateAbbr: "Smithville, GA",
  },
  {
    zip: "31788",
    ST: "GA",
    cityWithStateAbbr: "Moultrie, GA",
  },
  {
    zip: "31789",
    ST: "GA",
    cityWithStateAbbr: "Sumner, GA",
  },
  {
    zip: "31790",
    ST: "GA",
    cityWithStateAbbr: "Sycamore, GA",
  },
  {
    zip: "31791",
    ST: "GA",
    cityWithStateAbbr: "Sylvester, GA",
  },
  {
    zip: "31792",
    ST: "GA",
    cityWithStateAbbr: "Thomasville, GA",
  },
  {
    zip: "31793",
    ST: "GA",
    cityWithStateAbbr: "Tifton, GA",
  },
  {
    zip: "31794",
    ST: "GA",
    cityWithStateAbbr: "Tifton, GA",
  },
  {
    zip: "31795",
    ST: "GA",
    cityWithStateAbbr: "Ty Ty, GA",
  },
  {
    zip: "31796",
    ST: "GA",
    cityWithStateAbbr: "Warwick, GA",
  },
  {
    zip: "31798",
    ST: "GA",
    cityWithStateAbbr: "Wray, GA",
  },
  {
    zip: "31799",
    ST: "GA",
    cityWithStateAbbr: "Thomasville, GA",
  },
  {
    zip: "31801",
    ST: "GA",
    cityWithStateAbbr: "Box Springs, GA",
  },
  {
    zip: "31803",
    ST: "GA",
    cityWithStateAbbr: "Buena Vista, GA",
  },
  {
    zip: "31804",
    ST: "GA",
    cityWithStateAbbr: "Cataula, GA",
  },
  {
    zip: "31805",
    ST: "GA",
    cityWithStateAbbr: "Cusseta, GA",
  },
  {
    zip: "31806",
    ST: "GA",
    cityWithStateAbbr: "Ellaville, GA",
  },
  {
    zip: "31807",
    ST: "GA",
    cityWithStateAbbr: "Ellerslie, GA",
  },
  {
    zip: "31808",
    ST: "GA",
    cityWithStateAbbr: "Fortson, GA",
  },
  {
    zip: "31810",
    ST: "GA",
    cityWithStateAbbr: "Geneva, GA",
  },
  {
    zip: "31811",
    ST: "GA",
    cityWithStateAbbr: "Hamilton, GA",
  },
  {
    zip: "31812",
    ST: "GA",
    cityWithStateAbbr: "Junction City, GA",
  },
  {
    zip: "31814",
    ST: "GA",
    cityWithStateAbbr: "Louvale, GA",
  },
  {
    zip: "31815",
    ST: "GA",
    cityWithStateAbbr: "Lumpkin, GA",
  },
  {
    zip: "31816",
    ST: "GA",
    cityWithStateAbbr: "Manchester, GA",
  },
  {
    zip: "31820",
    ST: "GA",
    cityWithStateAbbr: "Midland, GA",
  },
  {
    zip: "31821",
    ST: "GA",
    cityWithStateAbbr: "Omaha, GA",
  },
  {
    zip: "31822",
    ST: "GA",
    cityWithStateAbbr: "Pine Mountain, GA",
  },
  {
    zip: "31823",
    ST: "GA",
    cityWithStateAbbr: "Pine Mountain Valley, GA",
  },
  {
    zip: "31824",
    ST: "GA",
    cityWithStateAbbr: "Preston, GA",
  },
  {
    zip: "31825",
    ST: "GA",
    cityWithStateAbbr: "Richland, GA",
  },
  {
    zip: "31826",
    ST: "GA",
    cityWithStateAbbr: "Shiloh, GA",
  },
  {
    zip: "31827",
    ST: "GA",
    cityWithStateAbbr: "Talbotton, GA",
  },
  {
    zip: "31829",
    ST: "GA",
    cityWithStateAbbr: "Upatoi, GA",
  },
  {
    zip: "31830",
    ST: "GA",
    cityWithStateAbbr: "Warm Springs, GA",
  },
  {
    zip: "31831",
    ST: "GA",
    cityWithStateAbbr: "Waverly Hall, GA",
  },
  {
    zip: "31832",
    ST: "GA",
    cityWithStateAbbr: "Weston, GA",
  },
  {
    zip: "31833",
    ST: "GA",
    cityWithStateAbbr: "West Point, GA",
  },
  {
    zip: "31836",
    ST: "GA",
    cityWithStateAbbr: "Woodland, GA",
  },
  {
    zip: "31901",
    ST: "GA",
    cityWithStateAbbr: "Columbus, GA",
  },
  {
    zip: "31902",
    ST: "GA",
    cityWithStateAbbr: "Columbus, GA",
  },
  {
    zip: "31903",
    ST: "GA",
    cityWithStateAbbr: "Columbus, GA",
  },
  {
    zip: "31904",
    ST: "GA",
    cityWithStateAbbr: "Columbus, GA",
  },
  {
    zip: "31905",
    ST: "GA",
    cityWithStateAbbr: "Fort Benning, GA",
  },
  {
    zip: "31906",
    ST: "GA",
    cityWithStateAbbr: "Columbus, GA",
  },
  {
    zip: "31907",
    ST: "GA",
    cityWithStateAbbr: "Columbus, GA",
  },
  {
    zip: "31908",
    ST: "GA",
    cityWithStateAbbr: "Columbus, GA",
  },
  {
    zip: "31909",
    ST: "GA",
    cityWithStateAbbr: "Columbus, GA",
  },
  {
    zip: "31914",
    ST: "GA",
    cityWithStateAbbr: "Columbus, GA",
  },
  {
    zip: "31917",
    ST: "GA",
    cityWithStateAbbr: "Columbus, GA",
  },
  {
    zip: "31993",
    ST: "GA",
    cityWithStateAbbr: "Columbus, GA",
  },
  {
    zip: "31995",
    ST: "GA",
    cityWithStateAbbr: "Fort Benning, GA",
  },
  {
    zip: "31997",
    ST: "GA",
    cityWithStateAbbr: "Columbus, GA",
  },
  {
    zip: "31998",
    ST: "GA",
    cityWithStateAbbr: "Columbus, GA",
  },
  {
    zip: "31999",
    ST: "GA",
    cityWithStateAbbr: "Columbus, GA",
  },
  {
    zip: "32003",
    ST: "FL",
    cityWithStateAbbr: "Fleming Island, FL",
  },
  {
    zip: "32004",
    ST: "FL",
    cityWithStateAbbr: "Ponte Vedra Beach, FL",
  },
  {
    zip: "32006",
    ST: "FL",
    cityWithStateAbbr: "Fleming Island, FL",
  },
  {
    zip: "32007",
    ST: "FL",
    cityWithStateAbbr: "Bostwick, FL",
  },
  {
    zip: "32008",
    ST: "FL",
    cityWithStateAbbr: "Branford, FL",
  },
  {
    zip: "32009",
    ST: "FL",
    cityWithStateAbbr: "Bryceville, FL",
  },
  {
    zip: "32011",
    ST: "FL",
    cityWithStateAbbr: "Callahan, FL",
  },
  {
    zip: "32013",
    ST: "FL",
    cityWithStateAbbr: "Day, FL",
  },
  {
    zip: "32024",
    ST: "FL",
    cityWithStateAbbr: "Lake City, FL",
  },
  {
    zip: "32025",
    ST: "FL",
    cityWithStateAbbr: "Lake City, FL",
  },
  {
    zip: "32026",
    ST: "FL",
    cityWithStateAbbr: "Raiford, FL",
  },
  {
    zip: "32030",
    ST: "FL",
    cityWithStateAbbr: "Doctors Inlet, FL",
  },
  {
    zip: "32033",
    ST: "FL",
    cityWithStateAbbr: "Elkton, FL",
  },
  {
    zip: "32034",
    ST: "FL",
    cityWithStateAbbr: "Fernandina Beach, FL",
  },
  {
    zip: "32035",
    ST: "FL",
    cityWithStateAbbr: "Fernandina Beach, FL",
  },
  {
    zip: "32038",
    ST: "FL",
    cityWithStateAbbr: "Fort White, FL",
  },
  {
    zip: "32040",
    ST: "FL",
    cityWithStateAbbr: "Glen Saint Mary, FL",
  },
  {
    zip: "32041",
    ST: "FL",
    cityWithStateAbbr: "Yulee, FL",
  },
  {
    zip: "32042",
    ST: "FL",
    cityWithStateAbbr: "Graham, FL",
  },
  {
    zip: "32043",
    ST: "FL",
    cityWithStateAbbr: "Green Cove Springs, FL",
  },
  {
    zip: "32044",
    ST: "FL",
    cityWithStateAbbr: "Hampton, FL",
  },
  {
    zip: "32046",
    ST: "FL",
    cityWithStateAbbr: "Hilliard, FL",
  },
  {
    zip: "32050",
    ST: "FL",
    cityWithStateAbbr: "Middleburg, FL",
  },
  {
    zip: "32052",
    ST: "FL",
    cityWithStateAbbr: "Jasper, FL",
  },
  {
    zip: "32053",
    ST: "FL",
    cityWithStateAbbr: "Jennings, FL",
  },
  {
    zip: "32054",
    ST: "FL",
    cityWithStateAbbr: "Lake Butler, FL",
  },
  {
    zip: "32055",
    ST: "FL",
    cityWithStateAbbr: "Lake City, FL",
  },
  {
    zip: "32056",
    ST: "FL",
    cityWithStateAbbr: "Lake City, FL",
  },
  {
    zip: "32058",
    ST: "FL",
    cityWithStateAbbr: "Lawtey, FL",
  },
  {
    zip: "32059",
    ST: "FL",
    cityWithStateAbbr: "Lee, FL",
  },
  {
    zip: "32060",
    ST: "FL",
    cityWithStateAbbr: "Live Oak, FL",
  },
  {
    zip: "32061",
    ST: "FL",
    cityWithStateAbbr: "Lulu, FL",
  },
  {
    zip: "32062",
    ST: "FL",
    cityWithStateAbbr: "Mc Alpin, FL",
  },
  {
    zip: "32063",
    ST: "FL",
    cityWithStateAbbr: "Macclenny, FL",
  },
  {
    zip: "32064",
    ST: "FL",
    cityWithStateAbbr: "Live Oak, FL",
  },
  {
    zip: "32065",
    ST: "FL",
    cityWithStateAbbr: "Orange Park, FL",
  },
  {
    zip: "32066",
    ST: "FL",
    cityWithStateAbbr: "Mayo, FL",
  },
  {
    zip: "32067",
    ST: "FL",
    cityWithStateAbbr: "Orange Park, FL",
  },
  {
    zip: "32068",
    ST: "FL",
    cityWithStateAbbr: "Middleburg, FL",
  },
  {
    zip: "32071",
    ST: "FL",
    cityWithStateAbbr: "O Brien, FL",
  },
  {
    zip: "32072",
    ST: "FL",
    cityWithStateAbbr: "Olustee, FL",
  },
  {
    zip: "32073",
    ST: "FL",
    cityWithStateAbbr: "Orange Park, FL",
  },
  {
    zip: "32079",
    ST: "FL",
    cityWithStateAbbr: "Penney Farms, FL",
  },
  {
    zip: "32080",
    ST: "FL",
    cityWithStateAbbr: "Saint Augustine, FL",
  },
  {
    zip: "32081",
    ST: "FL",
    cityWithStateAbbr: "Ponte Vedra, FL",
  },
  {
    zip: "32082",
    ST: "FL",
    cityWithStateAbbr: "Ponte Vedra Beach, FL",
  },
  {
    zip: "32083",
    ST: "FL",
    cityWithStateAbbr: "Raiford, FL",
  },
  {
    zip: "32084",
    ST: "FL",
    cityWithStateAbbr: "Saint Augustine, FL",
  },
  {
    zip: "32085",
    ST: "FL",
    cityWithStateAbbr: "Saint Augustine, FL",
  },
  {
    zip: "32086",
    ST: "FL",
    cityWithStateAbbr: "Saint Augustine, FL",
  },
  {
    zip: "32087",
    ST: "FL",
    cityWithStateAbbr: "Sanderson, FL",
  },
  {
    zip: "32091",
    ST: "FL",
    cityWithStateAbbr: "Starke, FL",
  },
  {
    zip: "32092",
    ST: "FL",
    cityWithStateAbbr: "Saint Augustine, FL",
  },
  {
    zip: "32094",
    ST: "FL",
    cityWithStateAbbr: "Wellborn, FL",
  },
  {
    zip: "32095",
    ST: "FL",
    cityWithStateAbbr: "Saint Augustine, FL",
  },
  {
    zip: "32096",
    ST: "FL",
    cityWithStateAbbr: "White Springs, FL",
  },
  {
    zip: "32097",
    ST: "FL",
    cityWithStateAbbr: "Yulee, FL",
  },
  {
    zip: "32099",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32102",
    ST: "FL",
    cityWithStateAbbr: "Astor, FL",
  },
  {
    zip: "32105",
    ST: "FL",
    cityWithStateAbbr: "Barberville, FL",
  },
  {
    zip: "32110",
    ST: "FL",
    cityWithStateAbbr: "Bunnell, FL",
  },
  {
    zip: "32111",
    ST: "FL",
    cityWithStateAbbr: "Candler, FL",
  },
  {
    zip: "32112",
    ST: "FL",
    cityWithStateAbbr: "Crescent City, FL",
  },
  {
    zip: "32113",
    ST: "FL",
    cityWithStateAbbr: "Citra, FL",
  },
  {
    zip: "32114",
    ST: "FL",
    cityWithStateAbbr: "Daytona Beach, FL",
  },
  {
    zip: "32115",
    ST: "FL",
    cityWithStateAbbr: "Daytona Beach, FL",
  },
  {
    zip: "32116",
    ST: "FL",
    cityWithStateAbbr: "Daytona Beach, FL",
  },
  {
    zip: "32117",
    ST: "FL",
    cityWithStateAbbr: "Daytona Beach, FL",
  },
  {
    zip: "32118",
    ST: "FL",
    cityWithStateAbbr: "Daytona Beach, FL",
  },
  {
    zip: "32119",
    ST: "FL",
    cityWithStateAbbr: "Daytona Beach, FL",
  },
  {
    zip: "32120",
    ST: "FL",
    cityWithStateAbbr: "Daytona Beach, FL",
  },
  {
    zip: "32121",
    ST: "FL",
    cityWithStateAbbr: "Daytona Beach, FL",
  },
  {
    zip: "32122",
    ST: "FL",
    cityWithStateAbbr: "Daytona Beach, FL",
  },
  {
    zip: "32123",
    ST: "FL",
    cityWithStateAbbr: "Port Orange, FL",
  },
  {
    zip: "32124",
    ST: "FL",
    cityWithStateAbbr: "Daytona Beach, FL",
  },
  {
    zip: "32125",
    ST: "FL",
    cityWithStateAbbr: "Daytona Beach, FL",
  },
  {
    zip: "32126",
    ST: "FL",
    cityWithStateAbbr: "Daytona Beach, FL",
  },
  {
    zip: "32127",
    ST: "FL",
    cityWithStateAbbr: "Port Orange, FL",
  },
  {
    zip: "32128",
    ST: "FL",
    cityWithStateAbbr: "Port Orange, FL",
  },
  {
    zip: "32129",
    ST: "FL",
    cityWithStateAbbr: "Port Orange, FL",
  },
  {
    zip: "32130",
    ST: "FL",
    cityWithStateAbbr: "De Leon Springs, FL",
  },
  {
    zip: "32131",
    ST: "FL",
    cityWithStateAbbr: "East Palatka, FL",
  },
  {
    zip: "32132",
    ST: "FL",
    cityWithStateAbbr: "Edgewater, FL",
  },
  {
    zip: "32133",
    ST: "FL",
    cityWithStateAbbr: "Eastlake Weir, FL",
  },
  {
    zip: "32134",
    ST: "FL",
    cityWithStateAbbr: "Fort Mc Coy, FL",
  },
  {
    zip: "32135",
    ST: "FL",
    cityWithStateAbbr: "Palm Coast, FL",
  },
  {
    zip: "32136",
    ST: "FL",
    cityWithStateAbbr: "Flagler Beach, FL",
  },
  {
    zip: "32137",
    ST: "FL",
    cityWithStateAbbr: "Palm Coast, FL",
  },
  {
    zip: "32138",
    ST: "FL",
    cityWithStateAbbr: "Grandin, FL",
  },
  {
    zip: "32139",
    ST: "FL",
    cityWithStateAbbr: "Georgetown, FL",
  },
  {
    zip: "32140",
    ST: "FL",
    cityWithStateAbbr: "Florahome, FL",
  },
  {
    zip: "32141",
    ST: "FL",
    cityWithStateAbbr: "Edgewater, FL",
  },
  {
    zip: "32142",
    ST: "FL",
    cityWithStateAbbr: "Palm Coast, FL",
  },
  {
    zip: "32143",
    ST: "FL",
    cityWithStateAbbr: "Flagler Beach, FL",
  },
  {
    zip: "32145",
    ST: "FL",
    cityWithStateAbbr: "Hastings, FL",
  },
  {
    zip: "32147",
    ST: "FL",
    cityWithStateAbbr: "Hollister, FL",
  },
  {
    zip: "32148",
    ST: "FL",
    cityWithStateAbbr: "Interlachen, FL",
  },
  {
    zip: "32149",
    ST: "FL",
    cityWithStateAbbr: "Interlachen, FL",
  },
  {
    zip: "32157",
    ST: "FL",
    cityWithStateAbbr: "Lake Como, FL",
  },
  {
    zip: "32158",
    ST: "FL",
    cityWithStateAbbr: "Lady Lake, FL",
  },
  {
    zip: "32159",
    ST: "FL",
    cityWithStateAbbr: "Lady Lake, FL",
  },
  {
    zip: "32160",
    ST: "FL",
    cityWithStateAbbr: "Lake Geneva, FL",
  },
  {
    zip: "32162",
    ST: "FL",
    cityWithStateAbbr: "The Villages, FL",
  },
  {
    zip: "32163",
    ST: "FL",
    cityWithStateAbbr: "The Villages, FL",
  },
  {
    zip: "32164",
    ST: "FL",
    cityWithStateAbbr: "Palm Coast, FL",
  },
  {
    zip: "32168",
    ST: "FL",
    cityWithStateAbbr: "New Smyrna Beach, FL",
  },
  {
    zip: "32169",
    ST: "FL",
    cityWithStateAbbr: "New Smyrna Beach, FL",
  },
  {
    zip: "32170",
    ST: "FL",
    cityWithStateAbbr: "New Smyrna Beach, FL",
  },
  {
    zip: "32173",
    ST: "FL",
    cityWithStateAbbr: "Ormond Beach, FL",
  },
  {
    zip: "32174",
    ST: "FL",
    cityWithStateAbbr: "Ormond Beach, FL",
  },
  {
    zip: "32175",
    ST: "FL",
    cityWithStateAbbr: "Ormond Beach, FL",
  },
  {
    zip: "32176",
    ST: "FL",
    cityWithStateAbbr: "Ormond Beach, FL",
  },
  {
    zip: "32177",
    ST: "FL",
    cityWithStateAbbr: "Palatka, FL",
  },
  {
    zip: "32178",
    ST: "FL",
    cityWithStateAbbr: "Palatka, FL",
  },
  {
    zip: "32179",
    ST: "FL",
    cityWithStateAbbr: "Ocklawaha, FL",
  },
  {
    zip: "32180",
    ST: "FL",
    cityWithStateAbbr: "Pierson, FL",
  },
  {
    zip: "32181",
    ST: "FL",
    cityWithStateAbbr: "Pomona Park, FL",
  },
  {
    zip: "32182",
    ST: "FL",
    cityWithStateAbbr: "Orange Springs, FL",
  },
  {
    zip: "32183",
    ST: "FL",
    cityWithStateAbbr: "Ocklawaha, FL",
  },
  {
    zip: "32185",
    ST: "FL",
    cityWithStateAbbr: "Putnam Hall, FL",
  },
  {
    zip: "32187",
    ST: "FL",
    cityWithStateAbbr: "San Mateo, FL",
  },
  {
    zip: "32189",
    ST: "FL",
    cityWithStateAbbr: "Satsuma, FL",
  },
  {
    zip: "32190",
    ST: "FL",
    cityWithStateAbbr: "Seville, FL",
  },
  {
    zip: "32192",
    ST: "FL",
    cityWithStateAbbr: "Sparr, FL",
  },
  {
    zip: "32193",
    ST: "FL",
    cityWithStateAbbr: "Welaka, FL",
  },
  {
    zip: "32195",
    ST: "FL",
    cityWithStateAbbr: "Weirsdale, FL",
  },
  {
    zip: "32198",
    ST: "FL",
    cityWithStateAbbr: "Daytona Beach, FL",
  },
  {
    zip: "32201",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32202",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32203",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32204",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32205",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32206",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32207",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32208",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32209",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32210",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32211",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32212",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32214",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32215",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32216",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32217",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32218",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32219",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32220",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32221",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32222",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32223",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32224",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32225",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32226",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32227",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32228",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32229",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32230",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32231",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32232",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32233",
    ST: "FL",
    cityWithStateAbbr: "Atlantic Beach, FL",
  },
  {
    zip: "32234",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32235",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32236",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32237",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32238",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32239",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32240",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville Beach, FL",
  },
  {
    zip: "32241",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32244",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32245",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32246",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32247",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32250",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville Beach, FL",
  },
  {
    zip: "32254",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32255",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32256",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32257",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32258",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32259",
    ST: "FL",
    cityWithStateAbbr: "Saint Johns, FL",
  },
  {
    zip: "32260",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32266",
    ST: "FL",
    cityWithStateAbbr: "Neptune Beach, FL",
  },
  {
    zip: "32277",
    ST: "FL",
    cityWithStateAbbr: "Jacksonville, FL",
  },
  {
    zip: "32301",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32302",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32303",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32304",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32305",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32306",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32307",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32308",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32309",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32310",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32311",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32312",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32313",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32314",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32315",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32316",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32317",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32318",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32320",
    ST: "FL",
    cityWithStateAbbr: "Apalachicola, FL",
  },
  {
    zip: "32321",
    ST: "FL",
    cityWithStateAbbr: "Bristol, FL",
  },
  {
    zip: "32322",
    ST: "FL",
    cityWithStateAbbr: "Carrabelle, FL",
  },
  {
    zip: "32323",
    ST: "FL",
    cityWithStateAbbr: "Lanark Village, FL",
  },
  {
    zip: "32324",
    ST: "FL",
    cityWithStateAbbr: "Chattahoochee, FL",
  },
  {
    zip: "32326",
    ST: "FL",
    cityWithStateAbbr: "Crawfordville, FL",
  },
  {
    zip: "32327",
    ST: "FL",
    cityWithStateAbbr: "Crawfordville, FL",
  },
  {
    zip: "32328",
    ST: "FL",
    cityWithStateAbbr: "Eastpoint, FL",
  },
  {
    zip: "32329",
    ST: "FL",
    cityWithStateAbbr: "Apalachicola, FL",
  },
  {
    zip: "32330",
    ST: "FL",
    cityWithStateAbbr: "Greensboro, FL",
  },
  {
    zip: "32331",
    ST: "FL",
    cityWithStateAbbr: "Greenville, FL",
  },
  {
    zip: "32332",
    ST: "FL",
    cityWithStateAbbr: "Gretna, FL",
  },
  {
    zip: "32333",
    ST: "FL",
    cityWithStateAbbr: "Havana, FL",
  },
  {
    zip: "32334",
    ST: "FL",
    cityWithStateAbbr: "Hosford, FL",
  },
  {
    zip: "32335",
    ST: "FL",
    cityWithStateAbbr: "Sumatra, FL",
  },
  {
    zip: "32336",
    ST: "FL",
    cityWithStateAbbr: "Lamont, FL",
  },
  {
    zip: "32337",
    ST: "FL",
    cityWithStateAbbr: "Lloyd, FL",
  },
  {
    zip: "32340",
    ST: "FL",
    cityWithStateAbbr: "Madison, FL",
  },
  {
    zip: "32341",
    ST: "FL",
    cityWithStateAbbr: "Madison, FL",
  },
  {
    zip: "32343",
    ST: "FL",
    cityWithStateAbbr: "Midway, FL",
  },
  {
    zip: "32344",
    ST: "FL",
    cityWithStateAbbr: "Monticello, FL",
  },
  {
    zip: "32345",
    ST: "FL",
    cityWithStateAbbr: "Monticello, FL",
  },
  {
    zip: "32346",
    ST: "FL",
    cityWithStateAbbr: "Panacea, FL",
  },
  {
    zip: "32347",
    ST: "FL",
    cityWithStateAbbr: "Perry, FL",
  },
  {
    zip: "32348",
    ST: "FL",
    cityWithStateAbbr: "Perry, FL",
  },
  {
    zip: "32350",
    ST: "FL",
    cityWithStateAbbr: "Pinetta, FL",
  },
  {
    zip: "32351",
    ST: "FL",
    cityWithStateAbbr: "Quincy, FL",
  },
  {
    zip: "32352",
    ST: "FL",
    cityWithStateAbbr: "Quincy, FL",
  },
  {
    zip: "32353",
    ST: "FL",
    cityWithStateAbbr: "Quincy, FL",
  },
  {
    zip: "32355",
    ST: "FL",
    cityWithStateAbbr: "Saint Marks, FL",
  },
  {
    zip: "32356",
    ST: "FL",
    cityWithStateAbbr: "Salem, FL",
  },
  {
    zip: "32357",
    ST: "FL",
    cityWithStateAbbr: "Shady Grove, FL",
  },
  {
    zip: "32358",
    ST: "FL",
    cityWithStateAbbr: "Sopchoppy, FL",
  },
  {
    zip: "32359",
    ST: "FL",
    cityWithStateAbbr: "Steinhatchee, FL",
  },
  {
    zip: "32360",
    ST: "FL",
    cityWithStateAbbr: "Telogia, FL",
  },
  {
    zip: "32361",
    ST: "FL",
    cityWithStateAbbr: "Wacissa, FL",
  },
  {
    zip: "32362",
    ST: "FL",
    cityWithStateAbbr: "Woodville, FL",
  },
  {
    zip: "32395",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32399",
    ST: "FL",
    cityWithStateAbbr: "Tallahassee, FL",
  },
  {
    zip: "32401",
    ST: "FL",
    cityWithStateAbbr: "Panama City, FL",
  },
  {
    zip: "32402",
    ST: "FL",
    cityWithStateAbbr: "Panama City, FL",
  },
  {
    zip: "32403",
    ST: "FL",
    cityWithStateAbbr: "Panama City, FL",
  },
  {
    zip: "32404",
    ST: "FL",
    cityWithStateAbbr: "Panama City, FL",
  },
  {
    zip: "32405",
    ST: "FL",
    cityWithStateAbbr: "Panama City, FL",
  },
  {
    zip: "32406",
    ST: "FL",
    cityWithStateAbbr: "Panama City, FL",
  },
  {
    zip: "32407",
    ST: "FL",
    cityWithStateAbbr: "Panama City Beach, FL",
  },
  {
    zip: "32408",
    ST: "FL",
    cityWithStateAbbr: "Panama City, FL",
  },
  {
    zip: "32409",
    ST: "FL",
    cityWithStateAbbr: "Panama City, FL",
  },
  {
    zip: "32410",
    ST: "FL",
    cityWithStateAbbr: "Mexico Beach, FL",
  },
  {
    zip: "32411",
    ST: "FL",
    cityWithStateAbbr: "Panama City, FL",
  },
  {
    zip: "32412",
    ST: "FL",
    cityWithStateAbbr: "Panama City, FL",
  },
  {
    zip: "32413",
    ST: "FL",
    cityWithStateAbbr: "Panama City Beach, FL",
  },
  {
    zip: "32417",
    ST: "FL",
    cityWithStateAbbr: "Panama City, FL",
  },
  {
    zip: "32420",
    ST: "FL",
    cityWithStateAbbr: "Alford, FL",
  },
  {
    zip: "32421",
    ST: "FL",
    cityWithStateAbbr: "Altha, FL",
  },
  {
    zip: "32422",
    ST: "FL",
    cityWithStateAbbr: "Argyle, FL",
  },
  {
    zip: "32423",
    ST: "FL",
    cityWithStateAbbr: "Bascom, FL",
  },
  {
    zip: "32424",
    ST: "FL",
    cityWithStateAbbr: "Blountstown, FL",
  },
  {
    zip: "32425",
    ST: "FL",
    cityWithStateAbbr: "Bonifay, FL",
  },
  {
    zip: "32426",
    ST: "FL",
    cityWithStateAbbr: "Campbellton, FL",
  },
  {
    zip: "32427",
    ST: "FL",
    cityWithStateAbbr: "Caryville, FL",
  },
  {
    zip: "32428",
    ST: "FL",
    cityWithStateAbbr: "Chipley, FL",
  },
  {
    zip: "32430",
    ST: "FL",
    cityWithStateAbbr: "Clarksville, FL",
  },
  {
    zip: "32431",
    ST: "FL",
    cityWithStateAbbr: "Cottondale, FL",
  },
  {
    zip: "32432",
    ST: "FL",
    cityWithStateAbbr: "Cypress, FL",
  },
  {
    zip: "32433",
    ST: "FL",
    cityWithStateAbbr: "Defuniak Springs, FL",
  },
  {
    zip: "32434",
    ST: "FL",
    cityWithStateAbbr: "Mossy Head, FL",
  },
  {
    zip: "32435",
    ST: "FL",
    cityWithStateAbbr: "Defuniak Springs, FL",
  },
  {
    zip: "32437",
    ST: "FL",
    cityWithStateAbbr: "Ebro, FL",
  },
  {
    zip: "32438",
    ST: "FL",
    cityWithStateAbbr: "Fountain, FL",
  },
  {
    zip: "32439",
    ST: "FL",
    cityWithStateAbbr: "Freeport, FL",
  },
  {
    zip: "32440",
    ST: "FL",
    cityWithStateAbbr: "Graceville, FL",
  },
  {
    zip: "32442",
    ST: "FL",
    cityWithStateAbbr: "Grand Ridge, FL",
  },
  {
    zip: "32443",
    ST: "FL",
    cityWithStateAbbr: "Greenwood, FL",
  },
  {
    zip: "32444",
    ST: "FL",
    cityWithStateAbbr: "Lynn Haven, FL",
  },
  {
    zip: "32445",
    ST: "FL",
    cityWithStateAbbr: "Malone, FL",
  },
  {
    zip: "32446",
    ST: "FL",
    cityWithStateAbbr: "Marianna, FL",
  },
  {
    zip: "32447",
    ST: "FL",
    cityWithStateAbbr: "Marianna, FL",
  },
  {
    zip: "32448",
    ST: "FL",
    cityWithStateAbbr: "Marianna, FL",
  },
  {
    zip: "32449",
    ST: "FL",
    cityWithStateAbbr: "Wewahitchka, FL",
  },
  {
    zip: "32452",
    ST: "FL",
    cityWithStateAbbr: "Noma, FL",
  },
  {
    zip: "32455",
    ST: "FL",
    cityWithStateAbbr: "Ponce De Leon, FL",
  },
  {
    zip: "32456",
    ST: "FL",
    cityWithStateAbbr: "Port Saint Joe, FL",
  },
  {
    zip: "32457",
    ST: "FL",
    cityWithStateAbbr: "Port Saint Joe, FL",
  },
  {
    zip: "32459",
    ST: "FL",
    cityWithStateAbbr: "Santa Rosa Beach, FL",
  },
  {
    zip: "32460",
    ST: "FL",
    cityWithStateAbbr: "Sneads, FL",
  },
  {
    zip: "32461",
    ST: "FL",
    cityWithStateAbbr: "Rosemary Beach, FL",
  },
  {
    zip: "32462",
    ST: "FL",
    cityWithStateAbbr: "Vernon, FL",
  },
  {
    zip: "32463",
    ST: "FL",
    cityWithStateAbbr: "Wausau, FL",
  },
  {
    zip: "32464",
    ST: "FL",
    cityWithStateAbbr: "Westville, FL",
  },
  {
    zip: "32465",
    ST: "FL",
    cityWithStateAbbr: "Wewahitchka, FL",
  },
  {
    zip: "32466",
    ST: "FL",
    cityWithStateAbbr: "Youngstown, FL",
  },
  {
    zip: "32501",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32502",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32503",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32504",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32505",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32506",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32507",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32508",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32509",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32511",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32512",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32513",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32514",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32516",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32520",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32521",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32522",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32523",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32524",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32526",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32530",
    ST: "FL",
    cityWithStateAbbr: "Bagdad, FL",
  },
  {
    zip: "32531",
    ST: "FL",
    cityWithStateAbbr: "Baker, FL",
  },
  {
    zip: "32533",
    ST: "FL",
    cityWithStateAbbr: "Cantonment, FL",
  },
  {
    zip: "32534",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32535",
    ST: "FL",
    cityWithStateAbbr: "Century, FL",
  },
  {
    zip: "32536",
    ST: "FL",
    cityWithStateAbbr: "Crestview, FL",
  },
  {
    zip: "32537",
    ST: "FL",
    cityWithStateAbbr: "Milligan, FL",
  },
  {
    zip: "32538",
    ST: "FL",
    cityWithStateAbbr: "Paxton, FL",
  },
  {
    zip: "32539",
    ST: "FL",
    cityWithStateAbbr: "Crestview, FL",
  },
  {
    zip: "32540",
    ST: "FL",
    cityWithStateAbbr: "Destin, FL",
  },
  {
    zip: "32541",
    ST: "FL",
    cityWithStateAbbr: "Destin, FL",
  },
  {
    zip: "32542",
    ST: "FL",
    cityWithStateAbbr: "Eglin Afb, FL",
  },
  {
    zip: "32544",
    ST: "FL",
    cityWithStateAbbr: "Hurlburt Field, FL",
  },
  {
    zip: "32547",
    ST: "FL",
    cityWithStateAbbr: "Fort Walton Beach, FL",
  },
  {
    zip: "32548",
    ST: "FL",
    cityWithStateAbbr: "Fort Walton Beach, FL",
  },
  {
    zip: "32549",
    ST: "FL",
    cityWithStateAbbr: "Fort Walton Beach, FL",
  },
  {
    zip: "32550",
    ST: "FL",
    cityWithStateAbbr: "Miramar Beach, FL",
  },
  {
    zip: "32559",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32560",
    ST: "FL",
    cityWithStateAbbr: "Gonzalez, FL",
  },
  {
    zip: "32561",
    ST: "FL",
    cityWithStateAbbr: "Gulf Breeze, FL",
  },
  {
    zip: "32562",
    ST: "FL",
    cityWithStateAbbr: "Gulf Breeze, FL",
  },
  {
    zip: "32563",
    ST: "FL",
    cityWithStateAbbr: "Gulf Breeze, FL",
  },
  {
    zip: "32564",
    ST: "FL",
    cityWithStateAbbr: "Holt, FL",
  },
  {
    zip: "32565",
    ST: "FL",
    cityWithStateAbbr: "Jay, FL",
  },
  {
    zip: "32566",
    ST: "FL",
    cityWithStateAbbr: "Navarre, FL",
  },
  {
    zip: "32567",
    ST: "FL",
    cityWithStateAbbr: "Laurel Hill, FL",
  },
  {
    zip: "32568",
    ST: "FL",
    cityWithStateAbbr: "Mc David, FL",
  },
  {
    zip: "32569",
    ST: "FL",
    cityWithStateAbbr: "Mary Esther, FL",
  },
  {
    zip: "32570",
    ST: "FL",
    cityWithStateAbbr: "Milton, FL",
  },
  {
    zip: "32571",
    ST: "FL",
    cityWithStateAbbr: "Milton, FL",
  },
  {
    zip: "32572",
    ST: "FL",
    cityWithStateAbbr: "Milton, FL",
  },
  {
    zip: "32577",
    ST: "FL",
    cityWithStateAbbr: "Molino, FL",
  },
  {
    zip: "32578",
    ST: "FL",
    cityWithStateAbbr: "Niceville, FL",
  },
  {
    zip: "32579",
    ST: "FL",
    cityWithStateAbbr: "Shalimar, FL",
  },
  {
    zip: "32580",
    ST: "FL",
    cityWithStateAbbr: "Valparaiso, FL",
  },
  {
    zip: "32583",
    ST: "FL",
    cityWithStateAbbr: "Milton, FL",
  },
  {
    zip: "32588",
    ST: "FL",
    cityWithStateAbbr: "Niceville, FL",
  },
  {
    zip: "32590",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32591",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32592",
    ST: "FL",
    cityWithStateAbbr: "Pensacola, FL",
  },
  {
    zip: "32601",
    ST: "FL",
    cityWithStateAbbr: "Gainesville, FL",
  },
  {
    zip: "32602",
    ST: "FL",
    cityWithStateAbbr: "Gainesville, FL",
  },
  {
    zip: "32603",
    ST: "FL",
    cityWithStateAbbr: "Gainesville, FL",
  },
  {
    zip: "32604",
    ST: "FL",
    cityWithStateAbbr: "Gainesville, FL",
  },
  {
    zip: "32605",
    ST: "FL",
    cityWithStateAbbr: "Gainesville, FL",
  },
  {
    zip: "32606",
    ST: "FL",
    cityWithStateAbbr: "Gainesville, FL",
  },
  {
    zip: "32607",
    ST: "FL",
    cityWithStateAbbr: "Gainesville, FL",
  },
  {
    zip: "32608",
    ST: "FL",
    cityWithStateAbbr: "Gainesville, FL",
  },
  {
    zip: "32609",
    ST: "FL",
    cityWithStateAbbr: "Gainesville, FL",
  },
  {
    zip: "32610",
    ST: "FL",
    cityWithStateAbbr: "Gainesville, FL",
  },
  {
    zip: "32611",
    ST: "FL",
    cityWithStateAbbr: "Gainesville, FL",
  },
  {
    zip: "32612",
    ST: "FL",
    cityWithStateAbbr: "Gainesville, FL",
  },
  {
    zip: "32613",
    ST: "FL",
    cityWithStateAbbr: "Gainesville, FL",
  },
  {
    zip: "32614",
    ST: "FL",
    cityWithStateAbbr: "Gainesville, FL",
  },
  {
    zip: "32615",
    ST: "FL",
    cityWithStateAbbr: "Alachua, FL",
  },
  {
    zip: "32616",
    ST: "FL",
    cityWithStateAbbr: "Alachua, FL",
  },
  {
    zip: "32617",
    ST: "FL",
    cityWithStateAbbr: "Anthony, FL",
  },
  {
    zip: "32618",
    ST: "FL",
    cityWithStateAbbr: "Archer, FL",
  },
  {
    zip: "32619",
    ST: "FL",
    cityWithStateAbbr: "Bell, FL",
  },
  {
    zip: "32621",
    ST: "FL",
    cityWithStateAbbr: "Bronson, FL",
  },
  {
    zip: "32622",
    ST: "FL",
    cityWithStateAbbr: "Brooker, FL",
  },
  {
    zip: "32625",
    ST: "FL",
    cityWithStateAbbr: "Cedar Key, FL",
  },
  {
    zip: "32626",
    ST: "FL",
    cityWithStateAbbr: "Chiefland, FL",
  },
  {
    zip: "32627",
    ST: "FL",
    cityWithStateAbbr: "Gainesville, FL",
  },
  {
    zip: "32628",
    ST: "FL",
    cityWithStateAbbr: "Cross City, FL",
  },
  {
    zip: "32631",
    ST: "FL",
    cityWithStateAbbr: "Earleton, FL",
  },
  {
    zip: "32633",
    ST: "FL",
    cityWithStateAbbr: "Evinston, FL",
  },
  {
    zip: "32634",
    ST: "FL",
    cityWithStateAbbr: "Fairfield, FL",
  },
  {
    zip: "32635",
    ST: "FL",
    cityWithStateAbbr: "Gainesville, FL",
  },
  {
    zip: "32639",
    ST: "FL",
    cityWithStateAbbr: "Gulf Hammock, FL",
  },
  {
    zip: "32640",
    ST: "FL",
    cityWithStateAbbr: "Hawthorne, FL",
  },
  {
    zip: "32641",
    ST: "FL",
    cityWithStateAbbr: "Gainesville, FL",
  },
  {
    zip: "32643",
    ST: "FL",
    cityWithStateAbbr: "High Springs, FL",
  },
  {
    zip: "32644",
    ST: "FL",
    cityWithStateAbbr: "Chiefland, FL",
  },
  {
    zip: "32648",
    ST: "FL",
    cityWithStateAbbr: "Horseshoe Beach, FL",
  },
  {
    zip: "32653",
    ST: "FL",
    cityWithStateAbbr: "Gainesville, FL",
  },
  {
    zip: "32654",
    ST: "FL",
    cityWithStateAbbr: "Island Grove, FL",
  },
  {
    zip: "32655",
    ST: "FL",
    cityWithStateAbbr: "High Springs, FL",
  },
  {
    zip: "32656",
    ST: "FL",
    cityWithStateAbbr: "Keystone Heights, FL",
  },
  {
    zip: "32658",
    ST: "FL",
    cityWithStateAbbr: "La Crosse, FL",
  },
  {
    zip: "32662",
    ST: "FL",
    cityWithStateAbbr: "Lochloosa, FL",
  },
  {
    zip: "32663",
    ST: "FL",
    cityWithStateAbbr: "Lowell, FL",
  },
  {
    zip: "32664",
    ST: "FL",
    cityWithStateAbbr: "Mc Intosh, FL",
  },
  {
    zip: "32666",
    ST: "FL",
    cityWithStateAbbr: "Melrose, FL",
  },
  {
    zip: "32667",
    ST: "FL",
    cityWithStateAbbr: "Micanopy, FL",
  },
  {
    zip: "32668",
    ST: "FL",
    cityWithStateAbbr: "Morriston, FL",
  },
  {
    zip: "32669",
    ST: "FL",
    cityWithStateAbbr: "Newberry, FL",
  },
  {
    zip: "32680",
    ST: "FL",
    cityWithStateAbbr: "Old Town, FL",
  },
  {
    zip: "32681",
    ST: "FL",
    cityWithStateAbbr: "Orange Lake, FL",
  },
  {
    zip: "32683",
    ST: "FL",
    cityWithStateAbbr: "Otter Creek, FL",
  },
  {
    zip: "32686",
    ST: "FL",
    cityWithStateAbbr: "Reddick, FL",
  },
  {
    zip: "32692",
    ST: "FL",
    cityWithStateAbbr: "Suwannee, FL",
  },
  {
    zip: "32693",
    ST: "FL",
    cityWithStateAbbr: "Trenton, FL",
  },
  {
    zip: "32694",
    ST: "FL",
    cityWithStateAbbr: "Waldo, FL",
  },
  {
    zip: "32696",
    ST: "FL",
    cityWithStateAbbr: "Williston, FL",
  },
  {
    zip: "32697",
    ST: "FL",
    cityWithStateAbbr: "Worthington Springs, FL",
  },
  {
    zip: "32701",
    ST: "FL",
    cityWithStateAbbr: "Altamonte Springs, FL",
  },
  {
    zip: "32702",
    ST: "FL",
    cityWithStateAbbr: "Altoona, FL",
  },
  {
    zip: "32703",
    ST: "FL",
    cityWithStateAbbr: "Apopka, FL",
  },
  {
    zip: "32704",
    ST: "FL",
    cityWithStateAbbr: "Apopka, FL",
  },
  {
    zip: "32706",
    ST: "FL",
    cityWithStateAbbr: "Cassadaga, FL",
  },
  {
    zip: "32707",
    ST: "FL",
    cityWithStateAbbr: "Casselberry, FL",
  },
  {
    zip: "32708",
    ST: "FL",
    cityWithStateAbbr: "Winter Springs, FL",
  },
  {
    zip: "32709",
    ST: "FL",
    cityWithStateAbbr: "Christmas, FL",
  },
  {
    zip: "32710",
    ST: "FL",
    cityWithStateAbbr: "Clarcona, FL",
  },
  {
    zip: "32712",
    ST: "FL",
    cityWithStateAbbr: "Apopka, FL",
  },
  {
    zip: "32713",
    ST: "FL",
    cityWithStateAbbr: "Debary, FL",
  },
  {
    zip: "32714",
    ST: "FL",
    cityWithStateAbbr: "Altamonte Springs, FL",
  },
  {
    zip: "32715",
    ST: "FL",
    cityWithStateAbbr: "Altamonte Springs, FL",
  },
  {
    zip: "32716",
    ST: "FL",
    cityWithStateAbbr: "Altamonte Springs, FL",
  },
  {
    zip: "32718",
    ST: "FL",
    cityWithStateAbbr: "Casselberry, FL",
  },
  {
    zip: "32719",
    ST: "FL",
    cityWithStateAbbr: "Winter Springs, FL",
  },
  {
    zip: "32720",
    ST: "FL",
    cityWithStateAbbr: "Deland, FL",
  },
  {
    zip: "32721",
    ST: "FL",
    cityWithStateAbbr: "Deland, FL",
  },
  {
    zip: "32722",
    ST: "FL",
    cityWithStateAbbr: "Glenwood, FL",
  },
  {
    zip: "32723",
    ST: "FL",
    cityWithStateAbbr: "Deland, FL",
  },
  {
    zip: "32724",
    ST: "FL",
    cityWithStateAbbr: "Deland, FL",
  },
  {
    zip: "32725",
    ST: "FL",
    cityWithStateAbbr: "Deltona, FL",
  },
  {
    zip: "32726",
    ST: "FL",
    cityWithStateAbbr: "Eustis, FL",
  },
  {
    zip: "32727",
    ST: "FL",
    cityWithStateAbbr: "Eustis, FL",
  },
  {
    zip: "32728",
    ST: "FL",
    cityWithStateAbbr: "Deltona, FL",
  },
  {
    zip: "32730",
    ST: "FL",
    cityWithStateAbbr: "Casselberry, FL",
  },
  {
    zip: "32732",
    ST: "FL",
    cityWithStateAbbr: "Geneva, FL",
  },
  {
    zip: "32733",
    ST: "FL",
    cityWithStateAbbr: "Goldenrod, FL",
  },
  {
    zip: "32735",
    ST: "FL",
    cityWithStateAbbr: "Grand Island, FL",
  },
  {
    zip: "32736",
    ST: "FL",
    cityWithStateAbbr: "Eustis, FL",
  },
  {
    zip: "32738",
    ST: "FL",
    cityWithStateAbbr: "Deltona, FL",
  },
  {
    zip: "32739",
    ST: "FL",
    cityWithStateAbbr: "Deltona, FL",
  },
  {
    zip: "32744",
    ST: "FL",
    cityWithStateAbbr: "Lake Helen, FL",
  },
  {
    zip: "32745",
    ST: "FL",
    cityWithStateAbbr: "Mid Florida, FL",
  },
  {
    zip: "32746",
    ST: "FL",
    cityWithStateAbbr: "Lake Mary, FL",
  },
  {
    zip: "32747",
    ST: "FL",
    cityWithStateAbbr: "Lake Monroe, FL",
  },
  {
    zip: "32750",
    ST: "FL",
    cityWithStateAbbr: "Longwood, FL",
  },
  {
    zip: "32751",
    ST: "FL",
    cityWithStateAbbr: "Maitland, FL",
  },
  {
    zip: "32752",
    ST: "FL",
    cityWithStateAbbr: "Longwood, FL",
  },
  {
    zip: "32753",
    ST: "FL",
    cityWithStateAbbr: "Debary, FL",
  },
  {
    zip: "32754",
    ST: "FL",
    cityWithStateAbbr: "Mims, FL",
  },
  {
    zip: "32756",
    ST: "FL",
    cityWithStateAbbr: "Mount Dora, FL",
  },
  {
    zip: "32757",
    ST: "FL",
    cityWithStateAbbr: "Mount Dora, FL",
  },
  {
    zip: "32759",
    ST: "FL",
    cityWithStateAbbr: "Oak Hill, FL",
  },
  {
    zip: "32762",
    ST: "FL",
    cityWithStateAbbr: "Oviedo, FL",
  },
  {
    zip: "32763",
    ST: "FL",
    cityWithStateAbbr: "Orange City, FL",
  },
  {
    zip: "32764",
    ST: "FL",
    cityWithStateAbbr: "Osteen, FL",
  },
  {
    zip: "32765",
    ST: "FL",
    cityWithStateAbbr: "Oviedo, FL",
  },
  {
    zip: "32766",
    ST: "FL",
    cityWithStateAbbr: "Oviedo, FL",
  },
  {
    zip: "32767",
    ST: "FL",
    cityWithStateAbbr: "Paisley, FL",
  },
  {
    zip: "32768",
    ST: "FL",
    cityWithStateAbbr: "Plymouth, FL",
  },
  {
    zip: "32771",
    ST: "FL",
    cityWithStateAbbr: "Sanford, FL",
  },
  {
    zip: "32772",
    ST: "FL",
    cityWithStateAbbr: "Sanford, FL",
  },
  {
    zip: "32773",
    ST: "FL",
    cityWithStateAbbr: "Sanford, FL",
  },
  {
    zip: "32774",
    ST: "FL",
    cityWithStateAbbr: "Orange City, FL",
  },
  {
    zip: "32775",
    ST: "FL",
    cityWithStateAbbr: "Scottsmoor, FL",
  },
  {
    zip: "32776",
    ST: "FL",
    cityWithStateAbbr: "Sorrento, FL",
  },
  {
    zip: "32777",
    ST: "FL",
    cityWithStateAbbr: "Tangerine, FL",
  },
  {
    zip: "32778",
    ST: "FL",
    cityWithStateAbbr: "Tavares, FL",
  },
  {
    zip: "32779",
    ST: "FL",
    cityWithStateAbbr: "Longwood, FL",
  },
  {
    zip: "32780",
    ST: "FL",
    cityWithStateAbbr: "Titusville, FL",
  },
  {
    zip: "32781",
    ST: "FL",
    cityWithStateAbbr: "Titusville, FL",
  },
  {
    zip: "32783",
    ST: "FL",
    cityWithStateAbbr: "Titusville, FL",
  },
  {
    zip: "32784",
    ST: "FL",
    cityWithStateAbbr: "Umatilla, FL",
  },
  {
    zip: "32789",
    ST: "FL",
    cityWithStateAbbr: "Winter Park, FL",
  },
  {
    zip: "32790",
    ST: "FL",
    cityWithStateAbbr: "Winter Park, FL",
  },
  {
    zip: "32791",
    ST: "FL",
    cityWithStateAbbr: "Longwood, FL",
  },
  {
    zip: "32792",
    ST: "FL",
    cityWithStateAbbr: "Winter Park, FL",
  },
  {
    zip: "32793",
    ST: "FL",
    cityWithStateAbbr: "Winter Park, FL",
  },
  {
    zip: "32794",
    ST: "FL",
    cityWithStateAbbr: "Maitland, FL",
  },
  {
    zip: "32795",
    ST: "FL",
    cityWithStateAbbr: "Lake Mary, FL",
  },
  {
    zip: "32796",
    ST: "FL",
    cityWithStateAbbr: "Titusville, FL",
  },
  {
    zip: "32798",
    ST: "FL",
    cityWithStateAbbr: "Zellwood, FL",
  },
  {
    zip: "32799",
    ST: "FL",
    cityWithStateAbbr: "Mid Florida, FL",
  },
  {
    zip: "32801",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32802",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32803",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32804",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32805",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32806",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32807",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32808",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32809",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32810",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32811",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32812",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32814",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32815",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32816",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32817",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32818",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32819",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32820",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32821",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32822",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32824",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32825",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32826",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32827",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32828",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32829",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32830",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32831",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32832",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32833",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32834",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32835",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32836",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32837",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32839",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32853",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32854",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32855",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32856",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32857",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32858",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32859",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32860",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32861",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32862",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32867",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32868",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32869",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32872",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32877",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32878",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32885",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32886",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32887",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32891",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32896",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32897",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32899",
    ST: "FL",
    cityWithStateAbbr: "Orlando, FL",
  },
  {
    zip: "32901",
    ST: "FL",
    cityWithStateAbbr: "Melbourne, FL",
  },
  {
    zip: "32902",
    ST: "FL",
    cityWithStateAbbr: "Melbourne, FL",
  },
  {
    zip: "32903",
    ST: "FL",
    cityWithStateAbbr: "Indialantic, FL",
  },
  {
    zip: "32904",
    ST: "FL",
    cityWithStateAbbr: "Melbourne, FL",
  },
  {
    zip: "32905",
    ST: "FL",
    cityWithStateAbbr: "Palm Bay, FL",
  },
  {
    zip: "32906",
    ST: "FL",
    cityWithStateAbbr: "Palm Bay, FL",
  },
  {
    zip: "32907",
    ST: "FL",
    cityWithStateAbbr: "Palm Bay, FL",
  },
  {
    zip: "32908",
    ST: "FL",
    cityWithStateAbbr: "Palm Bay, FL",
  },
  {
    zip: "32909",
    ST: "FL",
    cityWithStateAbbr: "Palm Bay, FL",
  },
  {
    zip: "32910",
    ST: "FL",
    cityWithStateAbbr: "Palm Bay, FL",
  },
  {
    zip: "32911",
    ST: "FL",
    cityWithStateAbbr: "Palm Bay, FL",
  },
  {
    zip: "32912",
    ST: "FL",
    cityWithStateAbbr: "Melbourne, FL",
  },
  {
    zip: "32919",
    ST: "FL",
    cityWithStateAbbr: "Melbourne, FL",
  },
  {
    zip: "32920",
    ST: "FL",
    cityWithStateAbbr: "Cape Canaveral, FL",
  },
  {
    zip: "32922",
    ST: "FL",
    cityWithStateAbbr: "Cocoa, FL",
  },
  {
    zip: "32923",
    ST: "FL",
    cityWithStateAbbr: "Cocoa, FL",
  },
  {
    zip: "32924",
    ST: "FL",
    cityWithStateAbbr: "Cocoa, FL",
  },
  {
    zip: "32925",
    ST: "FL",
    cityWithStateAbbr: "Patrick Afb, FL",
  },
  {
    zip: "32926",
    ST: "FL",
    cityWithStateAbbr: "Cocoa, FL",
  },
  {
    zip: "32927",
    ST: "FL",
    cityWithStateAbbr: "Cocoa, FL",
  },
  {
    zip: "32931",
    ST: "FL",
    cityWithStateAbbr: "Cocoa Beach, FL",
  },
  {
    zip: "32932",
    ST: "FL",
    cityWithStateAbbr: "Cocoa Beach, FL",
  },
  {
    zip: "32934",
    ST: "FL",
    cityWithStateAbbr: "Melbourne, FL",
  },
  {
    zip: "32935",
    ST: "FL",
    cityWithStateAbbr: "Melbourne, FL",
  },
  {
    zip: "32936",
    ST: "FL",
    cityWithStateAbbr: "Melbourne, FL",
  },
  {
    zip: "32937",
    ST: "FL",
    cityWithStateAbbr: "Satellite Beach, FL",
  },
  {
    zip: "32940",
    ST: "FL",
    cityWithStateAbbr: "Melbourne, FL",
  },
  {
    zip: "32941",
    ST: "FL",
    cityWithStateAbbr: "Melbourne, FL",
  },
  {
    zip: "32948",
    ST: "FL",
    cityWithStateAbbr: "Fellsmere, FL",
  },
  {
    zip: "32949",
    ST: "FL",
    cityWithStateAbbr: "Grant, FL",
  },
  {
    zip: "32950",
    ST: "FL",
    cityWithStateAbbr: "Malabar, FL",
  },
  {
    zip: "32951",
    ST: "FL",
    cityWithStateAbbr: "Melbourne Beach, FL",
  },
  {
    zip: "32952",
    ST: "FL",
    cityWithStateAbbr: "Merritt Island, FL",
  },
  {
    zip: "32953",
    ST: "FL",
    cityWithStateAbbr: "Merritt Island, FL",
  },
  {
    zip: "32954",
    ST: "FL",
    cityWithStateAbbr: "Merritt Island, FL",
  },
  {
    zip: "32955",
    ST: "FL",
    cityWithStateAbbr: "Rockledge, FL",
  },
  {
    zip: "32956",
    ST: "FL",
    cityWithStateAbbr: "Rockledge, FL",
  },
  {
    zip: "32957",
    ST: "FL",
    cityWithStateAbbr: "Roseland, FL",
  },
  {
    zip: "32958",
    ST: "FL",
    cityWithStateAbbr: "Sebastian, FL",
  },
  {
    zip: "32959",
    ST: "FL",
    cityWithStateAbbr: "Sharpes, FL",
  },
  {
    zip: "32960",
    ST: "FL",
    cityWithStateAbbr: "Vero Beach, FL",
  },
  {
    zip: "32961",
    ST: "FL",
    cityWithStateAbbr: "Vero Beach, FL",
  },
  {
    zip: "32962",
    ST: "FL",
    cityWithStateAbbr: "Vero Beach, FL",
  },
  {
    zip: "32963",
    ST: "FL",
    cityWithStateAbbr: "Vero Beach, FL",
  },
  {
    zip: "32964",
    ST: "FL",
    cityWithStateAbbr: "Vero Beach, FL",
  },
  {
    zip: "32965",
    ST: "FL",
    cityWithStateAbbr: "Vero Beach, FL",
  },
  {
    zip: "32966",
    ST: "FL",
    cityWithStateAbbr: "Vero Beach, FL",
  },
  {
    zip: "32967",
    ST: "FL",
    cityWithStateAbbr: "Vero Beach, FL",
  },
  {
    zip: "32968",
    ST: "FL",
    cityWithStateAbbr: "Vero Beach, FL",
  },
  {
    zip: "32969",
    ST: "FL",
    cityWithStateAbbr: "Vero Beach, FL",
  },
  {
    zip: "32970",
    ST: "FL",
    cityWithStateAbbr: "Wabasso, FL",
  },
  {
    zip: "32971",
    ST: "FL",
    cityWithStateAbbr: "Winter Beach, FL",
  },
  {
    zip: "32976",
    ST: "FL",
    cityWithStateAbbr: "Sebastian, FL",
  },
  {
    zip: "32978",
    ST: "FL",
    cityWithStateAbbr: "Sebastian, FL",
  },
  {
    zip: "33001",
    ST: "FL",
    cityWithStateAbbr: "Long Key, FL",
  },
  {
    zip: "33002",
    ST: "FL",
    cityWithStateAbbr: "Hialeah, FL",
  },
  {
    zip: "33004",
    ST: "FL",
    cityWithStateAbbr: "Dania, FL",
  },
  {
    zip: "33008",
    ST: "FL",
    cityWithStateAbbr: "Hallandale, FL",
  },
  {
    zip: "33009",
    ST: "FL",
    cityWithStateAbbr: "Hallandale, FL",
  },
  {
    zip: "33010",
    ST: "FL",
    cityWithStateAbbr: "Hialeah, FL",
  },
  {
    zip: "33011",
    ST: "FL",
    cityWithStateAbbr: "Hialeah, FL",
  },
  {
    zip: "33012",
    ST: "FL",
    cityWithStateAbbr: "Hialeah, FL",
  },
  {
    zip: "33013",
    ST: "FL",
    cityWithStateAbbr: "Hialeah, FL",
  },
  {
    zip: "33014",
    ST: "FL",
    cityWithStateAbbr: "Hialeah, FL",
  },
  {
    zip: "33015",
    ST: "FL",
    cityWithStateAbbr: "Hialeah, FL",
  },
  {
    zip: "33016",
    ST: "FL",
    cityWithStateAbbr: "Hialeah, FL",
  },
  {
    zip: "33017",
    ST: "FL",
    cityWithStateAbbr: "Hialeah, FL",
  },
  {
    zip: "33018",
    ST: "FL",
    cityWithStateAbbr: "Hialeah, FL",
  },
  {
    zip: "33019",
    ST: "FL",
    cityWithStateAbbr: "Hollywood, FL",
  },
  {
    zip: "33020",
    ST: "FL",
    cityWithStateAbbr: "Hollywood, FL",
  },
  {
    zip: "33021",
    ST: "FL",
    cityWithStateAbbr: "Hollywood, FL",
  },
  {
    zip: "33022",
    ST: "FL",
    cityWithStateAbbr: "Hollywood, FL",
  },
  {
    zip: "33023",
    ST: "FL",
    cityWithStateAbbr: "Hollywood, FL",
  },
  {
    zip: "33024",
    ST: "FL",
    cityWithStateAbbr: "Hollywood, FL",
  },
  {
    zip: "33025",
    ST: "FL",
    cityWithStateAbbr: "Hollywood, FL",
  },
  {
    zip: "33026",
    ST: "FL",
    cityWithStateAbbr: "Hollywood, FL",
  },
  {
    zip: "33027",
    ST: "FL",
    cityWithStateAbbr: "Hollywood, FL",
  },
  {
    zip: "33028",
    ST: "FL",
    cityWithStateAbbr: "Pembroke Pines, FL",
  },
  {
    zip: "33029",
    ST: "FL",
    cityWithStateAbbr: "Hollywood, FL",
  },
  {
    zip: "33030",
    ST: "FL",
    cityWithStateAbbr: "Homestead, FL",
  },
  {
    zip: "33031",
    ST: "FL",
    cityWithStateAbbr: "Homestead, FL",
  },
  {
    zip: "33032",
    ST: "FL",
    cityWithStateAbbr: "Homestead, FL",
  },
  {
    zip: "33033",
    ST: "FL",
    cityWithStateAbbr: "Homestead, FL",
  },
  {
    zip: "33034",
    ST: "FL",
    cityWithStateAbbr: "Homestead, FL",
  },
  {
    zip: "33035",
    ST: "FL",
    cityWithStateAbbr: "Homestead, FL",
  },
  {
    zip: "33036",
    ST: "FL",
    cityWithStateAbbr: "Islamorada, FL",
  },
  {
    zip: "33037",
    ST: "FL",
    cityWithStateAbbr: "Key Largo, FL",
  },
  {
    zip: "33039",
    ST: "FL",
    cityWithStateAbbr: "Homestead, FL",
  },
  {
    zip: "33040",
    ST: "FL",
    cityWithStateAbbr: "Key West, FL",
  },
  {
    zip: "33041",
    ST: "FL",
    cityWithStateAbbr: "Key West, FL",
  },
  {
    zip: "33042",
    ST: "FL",
    cityWithStateAbbr: "Summerland Key, FL",
  },
  {
    zip: "33043",
    ST: "FL",
    cityWithStateAbbr: "Big Pine Key, FL",
  },
  {
    zip: "33045",
    ST: "FL",
    cityWithStateAbbr: "Key West, FL",
  },
  {
    zip: "33050",
    ST: "FL",
    cityWithStateAbbr: "Marathon, FL",
  },
  {
    zip: "33051",
    ST: "FL",
    cityWithStateAbbr: "Key Colony Beach, FL",
  },
  {
    zip: "33052",
    ST: "FL",
    cityWithStateAbbr: "Marathon Shores, FL",
  },
  {
    zip: "33054",
    ST: "FL",
    cityWithStateAbbr: "Opa Locka, FL",
  },
  {
    zip: "33055",
    ST: "FL",
    cityWithStateAbbr: "Opa Locka, FL",
  },
  {
    zip: "33056",
    ST: "FL",
    cityWithStateAbbr: "Miami Gardens, FL",
  },
  {
    zip: "33060",
    ST: "FL",
    cityWithStateAbbr: "Pompano Beach, FL",
  },
  {
    zip: "33061",
    ST: "FL",
    cityWithStateAbbr: "Pompano Beach, FL",
  },
  {
    zip: "33062",
    ST: "FL",
    cityWithStateAbbr: "Pompano Beach, FL",
  },
  {
    zip: "33063",
    ST: "FL",
    cityWithStateAbbr: "Pompano Beach, FL",
  },
  {
    zip: "33064",
    ST: "FL",
    cityWithStateAbbr: "Pompano Beach, FL",
  },
  {
    zip: "33065",
    ST: "FL",
    cityWithStateAbbr: "Pompano Beach, FL",
  },
  {
    zip: "33066",
    ST: "FL",
    cityWithStateAbbr: "Pompano Beach, FL",
  },
  {
    zip: "33067",
    ST: "FL",
    cityWithStateAbbr: "Pompano Beach, FL",
  },
  {
    zip: "33068",
    ST: "FL",
    cityWithStateAbbr: "Pompano Beach, FL",
  },
  {
    zip: "33069",
    ST: "FL",
    cityWithStateAbbr: "Pompano Beach, FL",
  },
  {
    zip: "33070",
    ST: "FL",
    cityWithStateAbbr: "Tavernier, FL",
  },
  {
    zip: "33071",
    ST: "FL",
    cityWithStateAbbr: "Pompano Beach, FL",
  },
  {
    zip: "33072",
    ST: "FL",
    cityWithStateAbbr: "Pompano Beach, FL",
  },
  {
    zip: "33073",
    ST: "FL",
    cityWithStateAbbr: "Pompano Beach, FL",
  },
  {
    zip: "33074",
    ST: "FL",
    cityWithStateAbbr: "Pompano Beach, FL",
  },
  {
    zip: "33075",
    ST: "FL",
    cityWithStateAbbr: "Coral Springs, FL",
  },
  {
    zip: "33076",
    ST: "FL",
    cityWithStateAbbr: "Pompano Beach, FL",
  },
  {
    zip: "33077",
    ST: "FL",
    cityWithStateAbbr: "Pompano Beach, FL",
  },
  {
    zip: "33081",
    ST: "FL",
    cityWithStateAbbr: "Hollywood, FL",
  },
  {
    zip: "33082",
    ST: "FL",
    cityWithStateAbbr: "Pembroke Pines, FL",
  },
  {
    zip: "33083",
    ST: "FL",
    cityWithStateAbbr: "Hollywood, FL",
  },
  {
    zip: "33084",
    ST: "FL",
    cityWithStateAbbr: "Hollywood, FL",
  },
  {
    zip: "33090",
    ST: "FL",
    cityWithStateAbbr: "Homestead, FL",
  },
  {
    zip: "33092",
    ST: "FL",
    cityWithStateAbbr: "Homestead, FL",
  },
  {
    zip: "33093",
    ST: "FL",
    cityWithStateAbbr: "Margate, FL",
  },
  {
    zip: "33097",
    ST: "FL",
    cityWithStateAbbr: "Coconut Creek, FL",
  },
  {
    zip: "33101",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33102",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33109",
    ST: "FL",
    cityWithStateAbbr: "Miami Beach, FL",
  },
  {
    zip: "33111",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33112",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33114",
    ST: "FL",
    cityWithStateAbbr: "Coral Gables, FL",
  },
  {
    zip: "33116",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33119",
    ST: "FL",
    cityWithStateAbbr: "Miami Beach, FL",
  },
  {
    zip: "33122",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33124",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33125",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33126",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33127",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33128",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33129",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33130",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33131",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33132",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33133",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33134",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33135",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33136",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33137",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33138",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33139",
    ST: "FL",
    cityWithStateAbbr: "Miami Beach, FL",
  },
  {
    zip: "33140",
    ST: "FL",
    cityWithStateAbbr: "Miami Beach, FL",
  },
  {
    zip: "33141",
    ST: "FL",
    cityWithStateAbbr: "Miami Beach, FL",
  },
  {
    zip: "33142",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33143",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33144",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33145",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33146",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33147",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33149",
    ST: "FL",
    cityWithStateAbbr: "Key Biscayne, FL",
  },
  {
    zip: "33150",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33151",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33152",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33153",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33154",
    ST: "FL",
    cityWithStateAbbr: "Miami Beach, FL",
  },
  {
    zip: "33155",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33156",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33157",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33158",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33159",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33160",
    ST: "FL",
    cityWithStateAbbr: "North Miami Beach, FL",
  },
  {
    zip: "33161",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33162",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33163",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33164",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33165",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33166",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33167",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33168",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33169",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33170",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33172",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33173",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33174",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33175",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33176",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33177",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33178",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33179",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33180",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33181",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33182",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33183",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33184",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33185",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33186",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33187",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33188",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33189",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33190",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33191",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33193",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33194",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33196",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33197",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33199",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33222",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33231",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33233",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33234",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33238",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33239",
    ST: "FL",
    cityWithStateAbbr: "Miami Beach, FL",
  },
  {
    zip: "33242",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33243",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33245",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33247",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33255",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33256",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33257",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33261",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33265",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33266",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33269",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33280",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33283",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33296",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33299",
    ST: "FL",
    cityWithStateAbbr: "Miami, FL",
  },
  {
    zip: "33301",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33302",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33303",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33304",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33305",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33306",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33307",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33308",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33309",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33310",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33311",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33312",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33313",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33314",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33315",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33316",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33317",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33318",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33319",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33320",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33321",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33322",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33323",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33324",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33325",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33326",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33327",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33328",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33329",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33330",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33331",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33332",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33334",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33335",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33336",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33337",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33338",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33339",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33340",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33345",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33346",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33348",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33349",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33351",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33355",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33359",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33388",
    ST: "FL",
    cityWithStateAbbr: "Plantation, FL",
  },
  {
    zip: "33394",
    ST: "FL",
    cityWithStateAbbr: "Fort Lauderdale, FL",
  },
  {
    zip: "33401",
    ST: "FL",
    cityWithStateAbbr: "West Palm Beach, FL",
  },
  {
    zip: "33402",
    ST: "FL",
    cityWithStateAbbr: "West Palm Beach, FL",
  },
  {
    zip: "33403",
    ST: "FL",
    cityWithStateAbbr: "West Palm Beach, FL",
  },
  {
    zip: "33404",
    ST: "FL",
    cityWithStateAbbr: "West Palm Beach, FL",
  },
  {
    zip: "33405",
    ST: "FL",
    cityWithStateAbbr: "West Palm Beach, FL",
  },
  {
    zip: "33406",
    ST: "FL",
    cityWithStateAbbr: "West Palm Beach, FL",
  },
  {
    zip: "33407",
    ST: "FL",
    cityWithStateAbbr: "West Palm Beach, FL",
  },
  {
    zip: "33408",
    ST: "FL",
    cityWithStateAbbr: "North Palm Beach, FL",
  },
  {
    zip: "33409",
    ST: "FL",
    cityWithStateAbbr: "West Palm Beach, FL",
  },
  {
    zip: "33410",
    ST: "FL",
    cityWithStateAbbr: "Palm Beach Gardens, FL",
  },
  {
    zip: "33411",
    ST: "FL",
    cityWithStateAbbr: "West Palm Beach, FL",
  },
  {
    zip: "33412",
    ST: "FL",
    cityWithStateAbbr: "West Palm Beach, FL",
  },
  {
    zip: "33413",
    ST: "FL",
    cityWithStateAbbr: "West Palm Beach, FL",
  },
  {
    zip: "33414",
    ST: "FL",
    cityWithStateAbbr: "Wellington, FL",
  },
  {
    zip: "33415",
    ST: "FL",
    cityWithStateAbbr: "West Palm Beach, FL",
  },
  {
    zip: "33416",
    ST: "FL",
    cityWithStateAbbr: "West Palm Beach, FL",
  },
  {
    zip: "33417",
    ST: "FL",
    cityWithStateAbbr: "West Palm Beach, FL",
  },
  {
    zip: "33418",
    ST: "FL",
    cityWithStateAbbr: "Palm Beach Gardens, FL",
  },
  {
    zip: "33419",
    ST: "FL",
    cityWithStateAbbr: "West Palm Beach, FL",
  },
  {
    zip: "33420",
    ST: "FL",
    cityWithStateAbbr: "West Palm Beach, FL",
  },
  {
    zip: "33421",
    ST: "FL",
    cityWithStateAbbr: "Royal Palm Beach, FL",
  },
  {
    zip: "33422",
    ST: "FL",
    cityWithStateAbbr: "West Palm Beach, FL",
  },
  {
    zip: "33424",
    ST: "FL",
    cityWithStateAbbr: "Boynton Beach, FL",
  },
  {
    zip: "33425",
    ST: "FL",
    cityWithStateAbbr: "Boynton Beach, FL",
  },
  {
    zip: "33426",
    ST: "FL",
    cityWithStateAbbr: "Boynton Beach, FL",
  },
  {
    zip: "33427",
    ST: "FL",
    cityWithStateAbbr: "Boca Raton, FL",
  },
  {
    zip: "33428",
    ST: "FL",
    cityWithStateAbbr: "Boca Raton, FL",
  },
  {
    zip: "33429",
    ST: "FL",
    cityWithStateAbbr: "Boca Raton, FL",
  },
  {
    zip: "33430",
    ST: "FL",
    cityWithStateAbbr: "Belle Glade, FL",
  },
  {
    zip: "33431",
    ST: "FL",
    cityWithStateAbbr: "Boca Raton, FL",
  },
  {
    zip: "33432",
    ST: "FL",
    cityWithStateAbbr: "Boca Raton, FL",
  },
  {
    zip: "33433",
    ST: "FL",
    cityWithStateAbbr: "Boca Raton, FL",
  },
  {
    zip: "33434",
    ST: "FL",
    cityWithStateAbbr: "Boca Raton, FL",
  },
  {
    zip: "33435",
    ST: "FL",
    cityWithStateAbbr: "Boynton Beach, FL",
  },
  {
    zip: "33436",
    ST: "FL",
    cityWithStateAbbr: "Boynton Beach, FL",
  },
  {
    zip: "33437",
    ST: "FL",
    cityWithStateAbbr: "Boynton Beach, FL",
  },
  {
    zip: "33438",
    ST: "FL",
    cityWithStateAbbr: "Canal Point, FL",
  },
  {
    zip: "33440",
    ST: "FL",
    cityWithStateAbbr: "Clewiston, FL",
  },
  {
    zip: "33441",
    ST: "FL",
    cityWithStateAbbr: "Deerfield Beach, FL",
  },
  {
    zip: "33442",
    ST: "FL",
    cityWithStateAbbr: "Deerfield Beach, FL",
  },
  {
    zip: "33443",
    ST: "FL",
    cityWithStateAbbr: "Deerfield Beach, FL",
  },
  {
    zip: "33444",
    ST: "FL",
    cityWithStateAbbr: "Delray Beach, FL",
  },
  {
    zip: "33445",
    ST: "FL",
    cityWithStateAbbr: "Delray Beach, FL",
  },
  {
    zip: "33446",
    ST: "FL",
    cityWithStateAbbr: "Delray Beach, FL",
  },
  {
    zip: "33448",
    ST: "FL",
    cityWithStateAbbr: "Delray Beach, FL",
  },
  {
    zip: "33449",
    ST: "FL",
    cityWithStateAbbr: "Lake Worth, FL",
  },
  {
    zip: "33454",
    ST: "FL",
    cityWithStateAbbr: "Greenacres, FL",
  },
  {
    zip: "33455",
    ST: "FL",
    cityWithStateAbbr: "Hobe Sound, FL",
  },
  {
    zip: "33458",
    ST: "FL",
    cityWithStateAbbr: "Jupiter, FL",
  },
  {
    zip: "33459",
    ST: "FL",
    cityWithStateAbbr: "Lake Harbor, FL",
  },
  {
    zip: "33460",
    ST: "FL",
    cityWithStateAbbr: "Lake Worth, FL",
  },
  {
    zip: "33461",
    ST: "FL",
    cityWithStateAbbr: "Lake Worth, FL",
  },
  {
    zip: "33462",
    ST: "FL",
    cityWithStateAbbr: "Lake Worth, FL",
  },
  {
    zip: "33463",
    ST: "FL",
    cityWithStateAbbr: "Lake Worth, FL",
  },
  {
    zip: "33464",
    ST: "FL",
    cityWithStateAbbr: "Boca Raton, FL",
  },
  {
    zip: "33465",
    ST: "FL",
    cityWithStateAbbr: "Lake Worth, FL",
  },
  {
    zip: "33466",
    ST: "FL",
    cityWithStateAbbr: "Lake Worth, FL",
  },
  {
    zip: "33467",
    ST: "FL",
    cityWithStateAbbr: "Lake Worth, FL",
  },
  {
    zip: "33468",
    ST: "FL",
    cityWithStateAbbr: "Jupiter, FL",
  },
  {
    zip: "33469",
    ST: "FL",
    cityWithStateAbbr: "Jupiter, FL",
  },
  {
    zip: "33470",
    ST: "FL",
    cityWithStateAbbr: "Loxahatchee, FL",
  },
  {
    zip: "33471",
    ST: "FL",
    cityWithStateAbbr: "Moore Haven, FL",
  },
  {
    zip: "33472",
    ST: "FL",
    cityWithStateAbbr: "Boynton Beach, FL",
  },
  {
    zip: "33473",
    ST: "FL",
    cityWithStateAbbr: "Boynton Beach, FL",
  },
  {
    zip: "33474",
    ST: "FL",
    cityWithStateAbbr: "Boynton Beach, FL",
  },
  {
    zip: "33475",
    ST: "FL",
    cityWithStateAbbr: "Hobe Sound, FL",
  },
  {
    zip: "33476",
    ST: "FL",
    cityWithStateAbbr: "Pahokee, FL",
  },
  {
    zip: "33477",
    ST: "FL",
    cityWithStateAbbr: "Jupiter, FL",
  },
  {
    zip: "33478",
    ST: "FL",
    cityWithStateAbbr: "Jupiter, FL",
  },
  {
    zip: "33480",
    ST: "FL",
    cityWithStateAbbr: "Palm Beach, FL",
  },
  {
    zip: "33481",
    ST: "FL",
    cityWithStateAbbr: "Boca Raton, FL",
  },
  {
    zip: "33482",
    ST: "FL",
    cityWithStateAbbr: "Delray Beach, FL",
  },
  {
    zip: "33483",
    ST: "FL",
    cityWithStateAbbr: "Delray Beach, FL",
  },
  {
    zip: "33484",
    ST: "FL",
    cityWithStateAbbr: "Delray Beach, FL",
  },
  {
    zip: "33486",
    ST: "FL",
    cityWithStateAbbr: "Boca Raton, FL",
  },
  {
    zip: "33487",
    ST: "FL",
    cityWithStateAbbr: "Boca Raton, FL",
  },
  {
    zip: "33488",
    ST: "FL",
    cityWithStateAbbr: "Boca Raton, FL",
  },
  {
    zip: "33493",
    ST: "FL",
    cityWithStateAbbr: "South Bay, FL",
  },
  {
    zip: "33496",
    ST: "FL",
    cityWithStateAbbr: "Boca Raton, FL",
  },
  {
    zip: "33497",
    ST: "FL",
    cityWithStateAbbr: "Boca Raton, FL",
  },
  {
    zip: "33498",
    ST: "FL",
    cityWithStateAbbr: "Boca Raton, FL",
  },
  {
    zip: "33499",
    ST: "FL",
    cityWithStateAbbr: "Boca Raton, FL",
  },
  {
    zip: "33503",
    ST: "FL",
    cityWithStateAbbr: "Balm, FL",
  },
  {
    zip: "33508",
    ST: "FL",
    cityWithStateAbbr: "Brandon, FL",
  },
  {
    zip: "33509",
    ST: "FL",
    cityWithStateAbbr: "Brandon, FL",
  },
  {
    zip: "33510",
    ST: "FL",
    cityWithStateAbbr: "Brandon, FL",
  },
  {
    zip: "33511",
    ST: "FL",
    cityWithStateAbbr: "Brandon, FL",
  },
  {
    zip: "33513",
    ST: "FL",
    cityWithStateAbbr: "Bushnell, FL",
  },
  {
    zip: "33514",
    ST: "FL",
    cityWithStateAbbr: "Center Hill, FL",
  },
  {
    zip: "33521",
    ST: "FL",
    cityWithStateAbbr: "Coleman, FL",
  },
  {
    zip: "33523",
    ST: "FL",
    cityWithStateAbbr: "Dade City, FL",
  },
  {
    zip: "33524",
    ST: "FL",
    cityWithStateAbbr: "Crystal Springs, FL",
  },
  {
    zip: "33525",
    ST: "FL",
    cityWithStateAbbr: "Dade City, FL",
  },
  {
    zip: "33526",
    ST: "FL",
    cityWithStateAbbr: "Dade City, FL",
  },
  {
    zip: "33527",
    ST: "FL",
    cityWithStateAbbr: "Dover, FL",
  },
  {
    zip: "33530",
    ST: "FL",
    cityWithStateAbbr: "Durant, FL",
  },
  {
    zip: "33534",
    ST: "FL",
    cityWithStateAbbr: "Gibsonton, FL",
  },
  {
    zip: "33537",
    ST: "FL",
    cityWithStateAbbr: "Lacoochee, FL",
  },
  {
    zip: "33538",
    ST: "FL",
    cityWithStateAbbr: "Lake Panasoffkee, FL",
  },
  {
    zip: "33539",
    ST: "FL",
    cityWithStateAbbr: "Zephyrhills, FL",
  },
  {
    zip: "33540",
    ST: "FL",
    cityWithStateAbbr: "Zephyrhills, FL",
  },
  {
    zip: "33541",
    ST: "FL",
    cityWithStateAbbr: "Zephyrhills, FL",
  },
  {
    zip: "33542",
    ST: "FL",
    cityWithStateAbbr: "Zephyrhills, FL",
  },
  {
    zip: "33543",
    ST: "FL",
    cityWithStateAbbr: "Wesley Chapel, FL",
  },
  {
    zip: "33544",
    ST: "FL",
    cityWithStateAbbr: "Wesley Chapel, FL",
  },
  {
    zip: "33545",
    ST: "FL",
    cityWithStateAbbr: "Wesley Chapel, FL",
  },
  {
    zip: "33547",
    ST: "FL",
    cityWithStateAbbr: "Lithia, FL",
  },
  {
    zip: "33548",
    ST: "FL",
    cityWithStateAbbr: "Lutz, FL",
  },
  {
    zip: "33549",
    ST: "FL",
    cityWithStateAbbr: "Lutz, FL",
  },
  {
    zip: "33550",
    ST: "FL",
    cityWithStateAbbr: "Mango, FL",
  },
  {
    zip: "33556",
    ST: "FL",
    cityWithStateAbbr: "Odessa, FL",
  },
  {
    zip: "33558",
    ST: "FL",
    cityWithStateAbbr: "Lutz, FL",
  },
  {
    zip: "33559",
    ST: "FL",
    cityWithStateAbbr: "Lutz, FL",
  },
  {
    zip: "33563",
    ST: "FL",
    cityWithStateAbbr: "Plant City, FL",
  },
  {
    zip: "33564",
    ST: "FL",
    cityWithStateAbbr: "Plant City, FL",
  },
  {
    zip: "33565",
    ST: "FL",
    cityWithStateAbbr: "Plant City, FL",
  },
  {
    zip: "33566",
    ST: "FL",
    cityWithStateAbbr: "Plant City, FL",
  },
  {
    zip: "33567",
    ST: "FL",
    cityWithStateAbbr: "Plant City, FL",
  },
  {
    zip: "33568",
    ST: "FL",
    cityWithStateAbbr: "Riverview, FL",
  },
  {
    zip: "33569",
    ST: "FL",
    cityWithStateAbbr: "Riverview, FL",
  },
  {
    zip: "33570",
    ST: "FL",
    cityWithStateAbbr: "Ruskin, FL",
  },
  {
    zip: "33571",
    ST: "FL",
    cityWithStateAbbr: "Sun City Center, FL",
  },
  {
    zip: "33572",
    ST: "FL",
    cityWithStateAbbr: "Apollo Beach, FL",
  },
  {
    zip: "33573",
    ST: "FL",
    cityWithStateAbbr: "Sun City Center, FL",
  },
  {
    zip: "33574",
    ST: "FL",
    cityWithStateAbbr: "Saint Leo, FL",
  },
  {
    zip: "33575",
    ST: "FL",
    cityWithStateAbbr: "Ruskin, FL",
  },
  {
    zip: "33576",
    ST: "FL",
    cityWithStateAbbr: "San Antonio, FL",
  },
  {
    zip: "33578",
    ST: "FL",
    cityWithStateAbbr: "Riverview, FL",
  },
  {
    zip: "33579",
    ST: "FL",
    cityWithStateAbbr: "Riverview, FL",
  },
  {
    zip: "33583",
    ST: "FL",
    cityWithStateAbbr: "Seffner, FL",
  },
  {
    zip: "33584",
    ST: "FL",
    cityWithStateAbbr: "Seffner, FL",
  },
  {
    zip: "33585",
    ST: "FL",
    cityWithStateAbbr: "Sumterville, FL",
  },
  {
    zip: "33586",
    ST: "FL",
    cityWithStateAbbr: "Sun City, FL",
  },
  {
    zip: "33587",
    ST: "FL",
    cityWithStateAbbr: "Sydney, FL",
  },
  {
    zip: "33592",
    ST: "FL",
    cityWithStateAbbr: "Thonotosassa, FL",
  },
  {
    zip: "33593",
    ST: "FL",
    cityWithStateAbbr: "Trilby, FL",
  },
  {
    zip: "33594",
    ST: "FL",
    cityWithStateAbbr: "Valrico, FL",
  },
  {
    zip: "33595",
    ST: "FL",
    cityWithStateAbbr: "Valrico, FL",
  },
  {
    zip: "33596",
    ST: "FL",
    cityWithStateAbbr: "Valrico, FL",
  },
  {
    zip: "33597",
    ST: "FL",
    cityWithStateAbbr: "Webster, FL",
  },
  {
    zip: "33598",
    ST: "FL",
    cityWithStateAbbr: "Wimauma, FL",
  },
  {
    zip: "33601",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33602",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33603",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33604",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33605",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33606",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33607",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33608",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33609",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33610",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33611",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33612",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33613",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33614",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33615",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33616",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33617",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33618",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33619",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33620",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33621",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33622",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33623",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33624",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33625",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33626",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33629",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33630",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33631",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33633",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33634",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33635",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33637",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33646",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33647",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33650",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33655",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33660",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33661",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33662",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33663",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33664",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33672",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33673",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33674",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33675",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33677",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33679",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33680",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33681",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33682",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33684",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33685",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33686",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33687",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33688",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33689",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33694",
    ST: "FL",
    cityWithStateAbbr: "Tampa, FL",
  },
  {
    zip: "33701",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33702",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33703",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33704",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33705",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33706",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33707",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33708",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33709",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33710",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33711",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33712",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33713",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33714",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33715",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33716",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33729",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33730",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33731",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33732",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33733",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33734",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33736",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33737",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33738",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33740",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33741",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33742",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33743",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33744",
    ST: "FL",
    cityWithStateAbbr: "Bay Pines, FL",
  },
  {
    zip: "33747",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33755",
    ST: "FL",
    cityWithStateAbbr: "Clearwater, FL",
  },
  {
    zip: "33756",
    ST: "FL",
    cityWithStateAbbr: "Clearwater, FL",
  },
  {
    zip: "33757",
    ST: "FL",
    cityWithStateAbbr: "Clearwater, FL",
  },
  {
    zip: "33758",
    ST: "FL",
    cityWithStateAbbr: "Clearwater, FL",
  },
  {
    zip: "33759",
    ST: "FL",
    cityWithStateAbbr: "Clearwater, FL",
  },
  {
    zip: "33760",
    ST: "FL",
    cityWithStateAbbr: "Clearwater, FL",
  },
  {
    zip: "33761",
    ST: "FL",
    cityWithStateAbbr: "Clearwater, FL",
  },
  {
    zip: "33762",
    ST: "FL",
    cityWithStateAbbr: "Clearwater, FL",
  },
  {
    zip: "33763",
    ST: "FL",
    cityWithStateAbbr: "Clearwater, FL",
  },
  {
    zip: "33764",
    ST: "FL",
    cityWithStateAbbr: "Clearwater, FL",
  },
  {
    zip: "33765",
    ST: "FL",
    cityWithStateAbbr: "Clearwater, FL",
  },
  {
    zip: "33766",
    ST: "FL",
    cityWithStateAbbr: "Clearwater, FL",
  },
  {
    zip: "33767",
    ST: "FL",
    cityWithStateAbbr: "Clearwater Beach, FL",
  },
  {
    zip: "33769",
    ST: "FL",
    cityWithStateAbbr: "Clearwater, FL",
  },
  {
    zip: "33770",
    ST: "FL",
    cityWithStateAbbr: "Largo, FL",
  },
  {
    zip: "33771",
    ST: "FL",
    cityWithStateAbbr: "Largo, FL",
  },
  {
    zip: "33772",
    ST: "FL",
    cityWithStateAbbr: "Seminole, FL",
  },
  {
    zip: "33773",
    ST: "FL",
    cityWithStateAbbr: "Largo, FL",
  },
  {
    zip: "33774",
    ST: "FL",
    cityWithStateAbbr: "Largo, FL",
  },
  {
    zip: "33775",
    ST: "FL",
    cityWithStateAbbr: "Seminole, FL",
  },
  {
    zip: "33776",
    ST: "FL",
    cityWithStateAbbr: "Seminole, FL",
  },
  {
    zip: "33777",
    ST: "FL",
    cityWithStateAbbr: "Seminole, FL",
  },
  {
    zip: "33778",
    ST: "FL",
    cityWithStateAbbr: "Largo, FL",
  },
  {
    zip: "33779",
    ST: "FL",
    cityWithStateAbbr: "Largo, FL",
  },
  {
    zip: "33780",
    ST: "FL",
    cityWithStateAbbr: "Pinellas Park, FL",
  },
  {
    zip: "33781",
    ST: "FL",
    cityWithStateAbbr: "Pinellas Park, FL",
  },
  {
    zip: "33782",
    ST: "FL",
    cityWithStateAbbr: "Pinellas Park, FL",
  },
  {
    zip: "33784",
    ST: "FL",
    cityWithStateAbbr: "Saint Petersburg, FL",
  },
  {
    zip: "33785",
    ST: "FL",
    cityWithStateAbbr: "Indian Rocks Beach, FL",
  },
  {
    zip: "33786",
    ST: "FL",
    cityWithStateAbbr: "Belleair Beach, FL",
  },
  {
    zip: "33801",
    ST: "FL",
    cityWithStateAbbr: "Lakeland, FL",
  },
  {
    zip: "33802",
    ST: "FL",
    cityWithStateAbbr: "Lakeland, FL",
  },
  {
    zip: "33803",
    ST: "FL",
    cityWithStateAbbr: "Lakeland, FL",
  },
  {
    zip: "33804",
    ST: "FL",
    cityWithStateAbbr: "Lakeland, FL",
  },
  {
    zip: "33805",
    ST: "FL",
    cityWithStateAbbr: "Lakeland, FL",
  },
  {
    zip: "33806",
    ST: "FL",
    cityWithStateAbbr: "Lakeland, FL",
  },
  {
    zip: "33807",
    ST: "FL",
    cityWithStateAbbr: "Lakeland, FL",
  },
  {
    zip: "33809",
    ST: "FL",
    cityWithStateAbbr: "Lakeland, FL",
  },
  {
    zip: "33810",
    ST: "FL",
    cityWithStateAbbr: "Lakeland, FL",
  },
  {
    zip: "33811",
    ST: "FL",
    cityWithStateAbbr: "Lakeland, FL",
  },
  {
    zip: "33812",
    ST: "FL",
    cityWithStateAbbr: "Lakeland, FL",
  },
  {
    zip: "33813",
    ST: "FL",
    cityWithStateAbbr: "Lakeland, FL",
  },
  {
    zip: "33815",
    ST: "FL",
    cityWithStateAbbr: "Lakeland, FL",
  },
  {
    zip: "33820",
    ST: "FL",
    cityWithStateAbbr: "Alturas, FL",
  },
  {
    zip: "33823",
    ST: "FL",
    cityWithStateAbbr: "Auburndale, FL",
  },
  {
    zip: "33825",
    ST: "FL",
    cityWithStateAbbr: "Avon Park, FL",
  },
  {
    zip: "33826",
    ST: "FL",
    cityWithStateAbbr: "Avon Park, FL",
  },
  {
    zip: "33827",
    ST: "FL",
    cityWithStateAbbr: "Babson Park, FL",
  },
  {
    zip: "33830",
    ST: "FL",
    cityWithStateAbbr: "Bartow, FL",
  },
  {
    zip: "33831",
    ST: "FL",
    cityWithStateAbbr: "Bartow, FL",
  },
  {
    zip: "33834",
    ST: "FL",
    cityWithStateAbbr: "Bowling Green, FL",
  },
  {
    zip: "33835",
    ST: "FL",
    cityWithStateAbbr: "Bradley, FL",
  },
  {
    zip: "33836",
    ST: "FL",
    cityWithStateAbbr: "Davenport, FL",
  },
  {
    zip: "33837",
    ST: "FL",
    cityWithStateAbbr: "Davenport, FL",
  },
  {
    zip: "33838",
    ST: "FL",
    cityWithStateAbbr: "Dundee, FL",
  },
  {
    zip: "33839",
    ST: "FL",
    cityWithStateAbbr: "Eagle Lake, FL",
  },
  {
    zip: "33840",
    ST: "FL",
    cityWithStateAbbr: "Eaton Park, FL",
  },
  {
    zip: "33841",
    ST: "FL",
    cityWithStateAbbr: "Fort Meade, FL",
  },
  {
    zip: "33843",
    ST: "FL",
    cityWithStateAbbr: "Frostproof, FL",
  },
  {
    zip: "33844",
    ST: "FL",
    cityWithStateAbbr: "Haines City, FL",
  },
  {
    zip: "33845",
    ST: "FL",
    cityWithStateAbbr: "Haines City, FL",
  },
  {
    zip: "33846",
    ST: "FL",
    cityWithStateAbbr: "Highland City, FL",
  },
  {
    zip: "33847",
    ST: "FL",
    cityWithStateAbbr: "Homeland, FL",
  },
  {
    zip: "33848",
    ST: "FL",
    cityWithStateAbbr: "Intercession City, FL",
  },
  {
    zip: "33849",
    ST: "FL",
    cityWithStateAbbr: "Kathleen, FL",
  },
  {
    zip: "33850",
    ST: "FL",
    cityWithStateAbbr: "Lake Alfred, FL",
  },
  {
    zip: "33851",
    ST: "FL",
    cityWithStateAbbr: "Lake Hamilton, FL",
  },
  {
    zip: "33852",
    ST: "FL",
    cityWithStateAbbr: "Lake Placid, FL",
  },
  {
    zip: "33853",
    ST: "FL",
    cityWithStateAbbr: "Lake Wales, FL",
  },
  {
    zip: "33854",
    ST: "FL",
    cityWithStateAbbr: "Lakeshore, FL",
  },
  {
    zip: "33855",
    ST: "FL",
    cityWithStateAbbr: "Indian Lake Estates, FL",
  },
  {
    zip: "33856",
    ST: "FL",
    cityWithStateAbbr: "Nalcrest, FL",
  },
  {
    zip: "33857",
    ST: "FL",
    cityWithStateAbbr: "Lorida, FL",
  },
  {
    zip: "33858",
    ST: "FL",
    cityWithStateAbbr: "Loughman, FL",
  },
  {
    zip: "33859",
    ST: "FL",
    cityWithStateAbbr: "Lake Wales, FL",
  },
  {
    zip: "33860",
    ST: "FL",
    cityWithStateAbbr: "Mulberry, FL",
  },
  {
    zip: "33862",
    ST: "FL",
    cityWithStateAbbr: "Lake Placid, FL",
  },
  {
    zip: "33863",
    ST: "FL",
    cityWithStateAbbr: "Nichols, FL",
  },
  {
    zip: "33865",
    ST: "FL",
    cityWithStateAbbr: "Ona, FL",
  },
  {
    zip: "33867",
    ST: "FL",
    cityWithStateAbbr: "River Ranch, FL",
  },
  {
    zip: "33868",
    ST: "FL",
    cityWithStateAbbr: "Polk City, FL",
  },
  {
    zip: "33870",
    ST: "FL",
    cityWithStateAbbr: "Sebring, FL",
  },
  {
    zip: "33871",
    ST: "FL",
    cityWithStateAbbr: "Sebring, FL",
  },
  {
    zip: "33872",
    ST: "FL",
    cityWithStateAbbr: "Sebring, FL",
  },
  {
    zip: "33873",
    ST: "FL",
    cityWithStateAbbr: "Wauchula, FL",
  },
  {
    zip: "33875",
    ST: "FL",
    cityWithStateAbbr: "Sebring, FL",
  },
  {
    zip: "33876",
    ST: "FL",
    cityWithStateAbbr: "Sebring, FL",
  },
  {
    zip: "33877",
    ST: "FL",
    cityWithStateAbbr: "Waverly, FL",
  },
  {
    zip: "33880",
    ST: "FL",
    cityWithStateAbbr: "Winter Haven, FL",
  },
  {
    zip: "33881",
    ST: "FL",
    cityWithStateAbbr: "Winter Haven, FL",
  },
  {
    zip: "33882",
    ST: "FL",
    cityWithStateAbbr: "Winter Haven, FL",
  },
  {
    zip: "33883",
    ST: "FL",
    cityWithStateAbbr: "Winter Haven, FL",
  },
  {
    zip: "33884",
    ST: "FL",
    cityWithStateAbbr: "Winter Haven, FL",
  },
  {
    zip: "33885",
    ST: "FL",
    cityWithStateAbbr: "Winter Haven, FL",
  },
  {
    zip: "33888",
    ST: "FL",
    cityWithStateAbbr: "Winter Haven, FL",
  },
  {
    zip: "33890",
    ST: "FL",
    cityWithStateAbbr: "Zolfo Springs, FL",
  },
  {
    zip: "33896",
    ST: "FL",
    cityWithStateAbbr: "Davenport, FL",
  },
  {
    zip: "33897",
    ST: "FL",
    cityWithStateAbbr: "Davenport, FL",
  },
  {
    zip: "33898",
    ST: "FL",
    cityWithStateAbbr: "Lake Wales, FL",
  },
  {
    zip: "33901",
    ST: "FL",
    cityWithStateAbbr: "Fort Myers, FL",
  },
  {
    zip: "33902",
    ST: "FL",
    cityWithStateAbbr: "Fort Myers, FL",
  },
  {
    zip: "33903",
    ST: "FL",
    cityWithStateAbbr: "North Fort Myers, FL",
  },
  {
    zip: "33904",
    ST: "FL",
    cityWithStateAbbr: "Cape Coral, FL",
  },
  {
    zip: "33905",
    ST: "FL",
    cityWithStateAbbr: "Fort Myers, FL",
  },
  {
    zip: "33906",
    ST: "FL",
    cityWithStateAbbr: "Fort Myers, FL",
  },
  {
    zip: "33907",
    ST: "FL",
    cityWithStateAbbr: "Fort Myers, FL",
  },
  {
    zip: "33908",
    ST: "FL",
    cityWithStateAbbr: "Fort Myers, FL",
  },
  {
    zip: "33909",
    ST: "FL",
    cityWithStateAbbr: "Cape Coral, FL",
  },
  {
    zip: "33910",
    ST: "FL",
    cityWithStateAbbr: "Cape Coral, FL",
  },
  {
    zip: "33911",
    ST: "FL",
    cityWithStateAbbr: "Fort Myers, FL",
  },
  {
    zip: "33912",
    ST: "FL",
    cityWithStateAbbr: "Fort Myers, FL",
  },
  {
    zip: "33913",
    ST: "FL",
    cityWithStateAbbr: "Fort Myers, FL",
  },
  {
    zip: "33914",
    ST: "FL",
    cityWithStateAbbr: "Cape Coral, FL",
  },
  {
    zip: "33915",
    ST: "FL",
    cityWithStateAbbr: "Cape Coral, FL",
  },
  {
    zip: "33916",
    ST: "FL",
    cityWithStateAbbr: "Fort Myers, FL",
  },
  {
    zip: "33917",
    ST: "FL",
    cityWithStateAbbr: "North Fort Myers, FL",
  },
  {
    zip: "33918",
    ST: "FL",
    cityWithStateAbbr: "North Fort Myers, FL",
  },
  {
    zip: "33919",
    ST: "FL",
    cityWithStateAbbr: "Fort Myers, FL",
  },
  {
    zip: "33920",
    ST: "FL",
    cityWithStateAbbr: "Alva, FL",
  },
  {
    zip: "33921",
    ST: "FL",
    cityWithStateAbbr: "Boca Grande, FL",
  },
  {
    zip: "33922",
    ST: "FL",
    cityWithStateAbbr: "Bokeelia, FL",
  },
  {
    zip: "33924",
    ST: "FL",
    cityWithStateAbbr: "Captiva, FL",
  },
  {
    zip: "33927",
    ST: "FL",
    cityWithStateAbbr: "El Jobean, FL",
  },
  {
    zip: "33928",
    ST: "FL",
    cityWithStateAbbr: "Estero, FL",
  },
  {
    zip: "33929",
    ST: "FL",
    cityWithStateAbbr: "Estero, FL",
  },
  {
    zip: "33930",
    ST: "FL",
    cityWithStateAbbr: "Felda, FL",
  },
  {
    zip: "33931",
    ST: "FL",
    cityWithStateAbbr: "Fort Myers Beach, FL",
  },
  {
    zip: "33932",
    ST: "FL",
    cityWithStateAbbr: "Fort Myers Beach, FL",
  },
  {
    zip: "33935",
    ST: "FL",
    cityWithStateAbbr: "Labelle, FL",
  },
  {
    zip: "33936",
    ST: "FL",
    cityWithStateAbbr: "Lehigh Acres, FL",
  },
  {
    zip: "33938",
    ST: "FL",
    cityWithStateAbbr: "Murdock, FL",
  },
  {
    zip: "33944",
    ST: "FL",
    cityWithStateAbbr: "Palmdale, FL",
  },
  {
    zip: "33945",
    ST: "FL",
    cityWithStateAbbr: "Pineland, FL",
  },
  {
    zip: "33946",
    ST: "FL",
    cityWithStateAbbr: "Placida, FL",
  },
  {
    zip: "33947",
    ST: "FL",
    cityWithStateAbbr: "Rotonda West, FL",
  },
  {
    zip: "33948",
    ST: "FL",
    cityWithStateAbbr: "Port Charlotte, FL",
  },
  {
    zip: "33949",
    ST: "FL",
    cityWithStateAbbr: "Port Charlotte, FL",
  },
  {
    zip: "33950",
    ST: "FL",
    cityWithStateAbbr: "Punta Gorda, FL",
  },
  {
    zip: "33951",
    ST: "FL",
    cityWithStateAbbr: "Punta Gorda, FL",
  },
  {
    zip: "33952",
    ST: "FL",
    cityWithStateAbbr: "Port Charlotte, FL",
  },
  {
    zip: "33953",
    ST: "FL",
    cityWithStateAbbr: "Port Charlotte, FL",
  },
  {
    zip: "33954",
    ST: "FL",
    cityWithStateAbbr: "Port Charlotte, FL",
  },
  {
    zip: "33955",
    ST: "FL",
    cityWithStateAbbr: "Punta Gorda, FL",
  },
  {
    zip: "33956",
    ST: "FL",
    cityWithStateAbbr: "Saint James City, FL",
  },
  {
    zip: "33957",
    ST: "FL",
    cityWithStateAbbr: "Sanibel, FL",
  },
  {
    zip: "33960",
    ST: "FL",
    cityWithStateAbbr: "Venus, FL",
  },
  {
    zip: "33965",
    ST: "FL",
    cityWithStateAbbr: "Fort Myers, FL",
  },
  {
    zip: "33966",
    ST: "FL",
    cityWithStateAbbr: "Fort Myers, FL",
  },
  {
    zip: "33967",
    ST: "FL",
    cityWithStateAbbr: "Fort Myers, FL",
  },
  {
    zip: "33970",
    ST: "FL",
    cityWithStateAbbr: "Lehigh Acres, FL",
  },
  {
    zip: "33971",
    ST: "FL",
    cityWithStateAbbr: "Lehigh Acres, FL",
  },
  {
    zip: "33972",
    ST: "FL",
    cityWithStateAbbr: "Lehigh Acres, FL",
  },
  {
    zip: "33973",
    ST: "FL",
    cityWithStateAbbr: "Lehigh Acres, FL",
  },
  {
    zip: "33974",
    ST: "FL",
    cityWithStateAbbr: "Lehigh Acres, FL",
  },
  {
    zip: "33975",
    ST: "FL",
    cityWithStateAbbr: "Labelle, FL",
  },
  {
    zip: "33976",
    ST: "FL",
    cityWithStateAbbr: "Lehigh Acres, FL",
  },
  {
    zip: "33980",
    ST: "FL",
    cityWithStateAbbr: "Punta Gorda, FL",
  },
  {
    zip: "33981",
    ST: "FL",
    cityWithStateAbbr: "Port Charlotte, FL",
  },
  {
    zip: "33982",
    ST: "FL",
    cityWithStateAbbr: "Punta Gorda, FL",
  },
  {
    zip: "33983",
    ST: "FL",
    cityWithStateAbbr: "Punta Gorda, FL",
  },
  {
    zip: "33990",
    ST: "FL",
    cityWithStateAbbr: "Cape Coral, FL",
  },
  {
    zip: "33991",
    ST: "FL",
    cityWithStateAbbr: "Cape Coral, FL",
  },
  {
    zip: "33993",
    ST: "FL",
    cityWithStateAbbr: "Cape Coral, FL",
  },
  {
    zip: "33994",
    ST: "FL",
    cityWithStateAbbr: "Fort Myers, FL",
  },
  {
    zip: "34101",
    ST: "FL",
    cityWithStateAbbr: "Naples, FL",
  },
  {
    zip: "34102",
    ST: "FL",
    cityWithStateAbbr: "Naples, FL",
  },
  {
    zip: "34103",
    ST: "FL",
    cityWithStateAbbr: "Naples, FL",
  },
  {
    zip: "34104",
    ST: "FL",
    cityWithStateAbbr: "Naples, FL",
  },
  {
    zip: "34105",
    ST: "FL",
    cityWithStateAbbr: "Naples, FL",
  },
  {
    zip: "34106",
    ST: "FL",
    cityWithStateAbbr: "Naples, FL",
  },
  {
    zip: "34107",
    ST: "FL",
    cityWithStateAbbr: "Naples, FL",
  },
  {
    zip: "34108",
    ST: "FL",
    cityWithStateAbbr: "Naples, FL",
  },
  {
    zip: "34109",
    ST: "FL",
    cityWithStateAbbr: "Naples, FL",
  },
  {
    zip: "34110",
    ST: "FL",
    cityWithStateAbbr: "Naples, FL",
  },
  {
    zip: "34112",
    ST: "FL",
    cityWithStateAbbr: "Naples, FL",
  },
  {
    zip: "34113",
    ST: "FL",
    cityWithStateAbbr: "Naples, FL",
  },
  {
    zip: "34114",
    ST: "FL",
    cityWithStateAbbr: "Naples, FL",
  },
  {
    zip: "34116",
    ST: "FL",
    cityWithStateAbbr: "Naples, FL",
  },
  {
    zip: "34117",
    ST: "FL",
    cityWithStateAbbr: "Naples, FL",
  },
  {
    zip: "34119",
    ST: "FL",
    cityWithStateAbbr: "Naples, FL",
  },
  {
    zip: "34120",
    ST: "FL",
    cityWithStateAbbr: "Naples, FL",
  },
  {
    zip: "34133",
    ST: "FL",
    cityWithStateAbbr: "Bonita Springs, FL",
  },
  {
    zip: "34134",
    ST: "FL",
    cityWithStateAbbr: "Bonita Springs, FL",
  },
  {
    zip: "34135",
    ST: "FL",
    cityWithStateAbbr: "Bonita Springs, FL",
  },
  {
    zip: "34136",
    ST: "FL",
    cityWithStateAbbr: "Bonita Springs, FL",
  },
  {
    zip: "34137",
    ST: "FL",
    cityWithStateAbbr: "Copeland, FL",
  },
  {
    zip: "34138",
    ST: "FL",
    cityWithStateAbbr: "Chokoloskee, FL",
  },
  {
    zip: "34139",
    ST: "FL",
    cityWithStateAbbr: "Everglades City, FL",
  },
  {
    zip: "34140",
    ST: "FL",
    cityWithStateAbbr: "Goodland, FL",
  },
  {
    zip: "34141",
    ST: "FL",
    cityWithStateAbbr: "Ochopee, FL",
  },
  {
    zip: "34142",
    ST: "FL",
    cityWithStateAbbr: "Immokalee, FL",
  },
  {
    zip: "34143",
    ST: "FL",
    cityWithStateAbbr: "Immokalee, FL",
  },
  {
    zip: "34145",
    ST: "FL",
    cityWithStateAbbr: "Marco Island, FL",
  },
  {
    zip: "34146",
    ST: "FL",
    cityWithStateAbbr: "Marco Island, FL",
  },
  {
    zip: "34201",
    ST: "FL",
    cityWithStateAbbr: "Bradenton, FL",
  },
  {
    zip: "34202",
    ST: "FL",
    cityWithStateAbbr: "Bradenton, FL",
  },
  {
    zip: "34203",
    ST: "FL",
    cityWithStateAbbr: "Bradenton, FL",
  },
  {
    zip: "34204",
    ST: "FL",
    cityWithStateAbbr: "Bradenton, FL",
  },
  {
    zip: "34205",
    ST: "FL",
    cityWithStateAbbr: "Bradenton, FL",
  },
  {
    zip: "34206",
    ST: "FL",
    cityWithStateAbbr: "Bradenton, FL",
  },
  {
    zip: "34207",
    ST: "FL",
    cityWithStateAbbr: "Bradenton, FL",
  },
  {
    zip: "34208",
    ST: "FL",
    cityWithStateAbbr: "Bradenton, FL",
  },
  {
    zip: "34209",
    ST: "FL",
    cityWithStateAbbr: "Bradenton, FL",
  },
  {
    zip: "34210",
    ST: "FL",
    cityWithStateAbbr: "Bradenton, FL",
  },
  {
    zip: "34211",
    ST: "FL",
    cityWithStateAbbr: "Bradenton, FL",
  },
  {
    zip: "34212",
    ST: "FL",
    cityWithStateAbbr: "Bradenton, FL",
  },
  {
    zip: "34215",
    ST: "FL",
    cityWithStateAbbr: "Cortez, FL",
  },
  {
    zip: "34216",
    ST: "FL",
    cityWithStateAbbr: "Anna Maria, FL",
  },
  {
    zip: "34217",
    ST: "FL",
    cityWithStateAbbr: "Bradenton Beach, FL",
  },
  {
    zip: "34218",
    ST: "FL",
    cityWithStateAbbr: "Holmes Beach, FL",
  },
  {
    zip: "34219",
    ST: "FL",
    cityWithStateAbbr: "Parrish, FL",
  },
  {
    zip: "34220",
    ST: "FL",
    cityWithStateAbbr: "Palmetto, FL",
  },
  {
    zip: "34221",
    ST: "FL",
    cityWithStateAbbr: "Palmetto, FL",
  },
  {
    zip: "34222",
    ST: "FL",
    cityWithStateAbbr: "Ellenton, FL",
  },
  {
    zip: "34223",
    ST: "FL",
    cityWithStateAbbr: "Englewood, FL",
  },
  {
    zip: "34224",
    ST: "FL",
    cityWithStateAbbr: "Englewood, FL",
  },
  {
    zip: "34228",
    ST: "FL",
    cityWithStateAbbr: "Longboat Key, FL",
  },
  {
    zip: "34229",
    ST: "FL",
    cityWithStateAbbr: "Osprey, FL",
  },
  {
    zip: "34230",
    ST: "FL",
    cityWithStateAbbr: "Sarasota, FL",
  },
  {
    zip: "34231",
    ST: "FL",
    cityWithStateAbbr: "Sarasota, FL",
  },
  {
    zip: "34232",
    ST: "FL",
    cityWithStateAbbr: "Sarasota, FL",
  },
  {
    zip: "34233",
    ST: "FL",
    cityWithStateAbbr: "Sarasota, FL",
  },
  {
    zip: "34234",
    ST: "FL",
    cityWithStateAbbr: "Sarasota, FL",
  },
  {
    zip: "34235",
    ST: "FL",
    cityWithStateAbbr: "Sarasota, FL",
  },
  {
    zip: "34236",
    ST: "FL",
    cityWithStateAbbr: "Sarasota, FL",
  },
  {
    zip: "34237",
    ST: "FL",
    cityWithStateAbbr: "Sarasota, FL",
  },
  {
    zip: "34238",
    ST: "FL",
    cityWithStateAbbr: "Sarasota, FL",
  },
  {
    zip: "34239",
    ST: "FL",
    cityWithStateAbbr: "Sarasota, FL",
  },
  {
    zip: "34240",
    ST: "FL",
    cityWithStateAbbr: "Sarasota, FL",
  },
  {
    zip: "34241",
    ST: "FL",
    cityWithStateAbbr: "Sarasota, FL",
  },
  {
    zip: "34242",
    ST: "FL",
    cityWithStateAbbr: "Sarasota, FL",
  },
  {
    zip: "34243",
    ST: "FL",
    cityWithStateAbbr: "Sarasota, FL",
  },
  {
    zip: "34250",
    ST: "FL",
    cityWithStateAbbr: "Terra Ceia, FL",
  },
  {
    zip: "34251",
    ST: "FL",
    cityWithStateAbbr: "Myakka City, FL",
  },
  {
    zip: "34260",
    ST: "FL",
    cityWithStateAbbr: "Sarasota, FL",
  },
  {
    zip: "34264",
    ST: "FL",
    cityWithStateAbbr: "Oneco, FL",
  },
  {
    zip: "34265",
    ST: "FL",
    cityWithStateAbbr: "Arcadia, FL",
  },
  {
    zip: "34266",
    ST: "FL",
    cityWithStateAbbr: "Arcadia, FL",
  },
  {
    zip: "34267",
    ST: "FL",
    cityWithStateAbbr: "Fort Ogden, FL",
  },
  {
    zip: "34268",
    ST: "FL",
    cityWithStateAbbr: "Nocatee, FL",
  },
  {
    zip: "34269",
    ST: "FL",
    cityWithStateAbbr: "Arcadia, FL",
  },
  {
    zip: "34270",
    ST: "FL",
    cityWithStateAbbr: "Tallevast, FL",
  },
  {
    zip: "34272",
    ST: "FL",
    cityWithStateAbbr: "Laurel, FL",
  },
  {
    zip: "34274",
    ST: "FL",
    cityWithStateAbbr: "Nokomis, FL",
  },
  {
    zip: "34275",
    ST: "FL",
    cityWithStateAbbr: "Nokomis, FL",
  },
  {
    zip: "34276",
    ST: "FL",
    cityWithStateAbbr: "Sarasota, FL",
  },
  {
    zip: "34277",
    ST: "FL",
    cityWithStateAbbr: "Sarasota, FL",
  },
  {
    zip: "34278",
    ST: "FL",
    cityWithStateAbbr: "Sarasota, FL",
  },
  {
    zip: "34280",
    ST: "FL",
    cityWithStateAbbr: "Bradenton, FL",
  },
  {
    zip: "34281",
    ST: "FL",
    cityWithStateAbbr: "Bradenton, FL",
  },
  {
    zip: "34282",
    ST: "FL",
    cityWithStateAbbr: "Bradenton, FL",
  },
  {
    zip: "34284",
    ST: "FL",
    cityWithStateAbbr: "Venice, FL",
  },
  {
    zip: "34285",
    ST: "FL",
    cityWithStateAbbr: "Venice, FL",
  },
  {
    zip: "34286",
    ST: "FL",
    cityWithStateAbbr: "North Port, FL",
  },
  {
    zip: "34287",
    ST: "FL",
    cityWithStateAbbr: "North Port, FL",
  },
  {
    zip: "34288",
    ST: "FL",
    cityWithStateAbbr: "North Port, FL",
  },
  {
    zip: "34289",
    ST: "FL",
    cityWithStateAbbr: "North Port, FL",
  },
  {
    zip: "34290",
    ST: "FL",
    cityWithStateAbbr: "North Port, FL",
  },
  {
    zip: "34291",
    ST: "FL",
    cityWithStateAbbr: "North Port, FL",
  },
  {
    zip: "34292",
    ST: "FL",
    cityWithStateAbbr: "Venice, FL",
  },
  {
    zip: "34293",
    ST: "FL",
    cityWithStateAbbr: "Venice, FL",
  },
  {
    zip: "34295",
    ST: "FL",
    cityWithStateAbbr: "Englewood, FL",
  },
  {
    zip: "34420",
    ST: "FL",
    cityWithStateAbbr: "Belleview, FL",
  },
  {
    zip: "34421",
    ST: "FL",
    cityWithStateAbbr: "Belleview, FL",
  },
  {
    zip: "34423",
    ST: "FL",
    cityWithStateAbbr: "Crystal River, FL",
  },
  {
    zip: "34428",
    ST: "FL",
    cityWithStateAbbr: "Crystal River, FL",
  },
  {
    zip: "34429",
    ST: "FL",
    cityWithStateAbbr: "Crystal River, FL",
  },
  {
    zip: "34430",
    ST: "FL",
    cityWithStateAbbr: "Dunnellon, FL",
  },
  {
    zip: "34431",
    ST: "FL",
    cityWithStateAbbr: "Dunnellon, FL",
  },
  {
    zip: "34432",
    ST: "FL",
    cityWithStateAbbr: "Dunnellon, FL",
  },
  {
    zip: "34433",
    ST: "FL",
    cityWithStateAbbr: "Dunnellon, FL",
  },
  {
    zip: "34434",
    ST: "FL",
    cityWithStateAbbr: "Dunnellon, FL",
  },
  {
    zip: "34436",
    ST: "FL",
    cityWithStateAbbr: "Floral City, FL",
  },
  {
    zip: "34442",
    ST: "FL",
    cityWithStateAbbr: "Hernando, FL",
  },
  {
    zip: "34445",
    ST: "FL",
    cityWithStateAbbr: "Holder, FL",
  },
  {
    zip: "34446",
    ST: "FL",
    cityWithStateAbbr: "Homosassa, FL",
  },
  {
    zip: "34447",
    ST: "FL",
    cityWithStateAbbr: "Homosassa Springs, FL",
  },
  {
    zip: "34448",
    ST: "FL",
    cityWithStateAbbr: "Homosassa, FL",
  },
  {
    zip: "34449",
    ST: "FL",
    cityWithStateAbbr: "Inglis, FL",
  },
  {
    zip: "34450",
    ST: "FL",
    cityWithStateAbbr: "Inverness, FL",
  },
  {
    zip: "34451",
    ST: "FL",
    cityWithStateAbbr: "Inverness, FL",
  },
  {
    zip: "34452",
    ST: "FL",
    cityWithStateAbbr: "Inverness, FL",
  },
  {
    zip: "34453",
    ST: "FL",
    cityWithStateAbbr: "Inverness, FL",
  },
  {
    zip: "34460",
    ST: "FL",
    cityWithStateAbbr: "Lecanto, FL",
  },
  {
    zip: "34461",
    ST: "FL",
    cityWithStateAbbr: "Lecanto, FL",
  },
  {
    zip: "34464",
    ST: "FL",
    cityWithStateAbbr: "Beverly Hills, FL",
  },
  {
    zip: "34465",
    ST: "FL",
    cityWithStateAbbr: "Beverly Hills, FL",
  },
  {
    zip: "34470",
    ST: "FL",
    cityWithStateAbbr: "Ocala, FL",
  },
  {
    zip: "34471",
    ST: "FL",
    cityWithStateAbbr: "Ocala, FL",
  },
  {
    zip: "34472",
    ST: "FL",
    cityWithStateAbbr: "Ocala, FL",
  },
  {
    zip: "34473",
    ST: "FL",
    cityWithStateAbbr: "Ocala, FL",
  },
  {
    zip: "34474",
    ST: "FL",
    cityWithStateAbbr: "Ocala, FL",
  },
  {
    zip: "34475",
    ST: "FL",
    cityWithStateAbbr: "Ocala, FL",
  },
  {
    zip: "34476",
    ST: "FL",
    cityWithStateAbbr: "Ocala, FL",
  },
  {
    zip: "34477",
    ST: "FL",
    cityWithStateAbbr: "Ocala, FL",
  },
  {
    zip: "34478",
    ST: "FL",
    cityWithStateAbbr: "Ocala, FL",
  },
  {
    zip: "34479",
    ST: "FL",
    cityWithStateAbbr: "Ocala, FL",
  },
  {
    zip: "34480",
    ST: "FL",
    cityWithStateAbbr: "Ocala, FL",
  },
  {
    zip: "34481",
    ST: "FL",
    cityWithStateAbbr: "Ocala, FL",
  },
  {
    zip: "34482",
    ST: "FL",
    cityWithStateAbbr: "Ocala, FL",
  },
  {
    zip: "34483",
    ST: "FL",
    cityWithStateAbbr: "Ocala, FL",
  },
  {
    zip: "34484",
    ST: "FL",
    cityWithStateAbbr: "Oxford, FL",
  },
  {
    zip: "34487",
    ST: "FL",
    cityWithStateAbbr: "Homosassa, FL",
  },
  {
    zip: "34488",
    ST: "FL",
    cityWithStateAbbr: "Silver Springs, FL",
  },
  {
    zip: "34489",
    ST: "FL",
    cityWithStateAbbr: "Silver Springs, FL",
  },
  {
    zip: "34491",
    ST: "FL",
    cityWithStateAbbr: "Summerfield, FL",
  },
  {
    zip: "34492",
    ST: "FL",
    cityWithStateAbbr: "Summerfield, FL",
  },
  {
    zip: "34498",
    ST: "FL",
    cityWithStateAbbr: "Yankeetown, FL",
  },
  {
    zip: "34601",
    ST: "FL",
    cityWithStateAbbr: "Brooksville, FL",
  },
  {
    zip: "34602",
    ST: "FL",
    cityWithStateAbbr: "Brooksville, FL",
  },
  {
    zip: "34603",
    ST: "FL",
    cityWithStateAbbr: "Brooksville, FL",
  },
  {
    zip: "34604",
    ST: "FL",
    cityWithStateAbbr: "Brooksville, FL",
  },
  {
    zip: "34605",
    ST: "FL",
    cityWithStateAbbr: "Brooksville, FL",
  },
  {
    zip: "34606",
    ST: "FL",
    cityWithStateAbbr: "Spring Hill, FL",
  },
  {
    zip: "34607",
    ST: "FL",
    cityWithStateAbbr: "Spring Hill, FL",
  },
  {
    zip: "34608",
    ST: "FL",
    cityWithStateAbbr: "Spring Hill, FL",
  },
  {
    zip: "34609",
    ST: "FL",
    cityWithStateAbbr: "Spring Hill, FL",
  },
  {
    zip: "34610",
    ST: "FL",
    cityWithStateAbbr: "Spring Hill, FL",
  },
  {
    zip: "34611",
    ST: "FL",
    cityWithStateAbbr: "Spring Hill, FL",
  },
  {
    zip: "34613",
    ST: "FL",
    cityWithStateAbbr: "Brooksville, FL",
  },
  {
    zip: "34614",
    ST: "FL",
    cityWithStateAbbr: "Brooksville, FL",
  },
  {
    zip: "34636",
    ST: "FL",
    cityWithStateAbbr: "Istachatta, FL",
  },
  {
    zip: "34637",
    ST: "FL",
    cityWithStateAbbr: "Land O Lakes, FL",
  },
  {
    zip: "34638",
    ST: "FL",
    cityWithStateAbbr: "Land O Lakes, FL",
  },
  {
    zip: "34639",
    ST: "FL",
    cityWithStateAbbr: "Land O Lakes, FL",
  },
  {
    zip: "34652",
    ST: "FL",
    cityWithStateAbbr: "New Port Richey, FL",
  },
  {
    zip: "34653",
    ST: "FL",
    cityWithStateAbbr: "New Port Richey, FL",
  },
  {
    zip: "34654",
    ST: "FL",
    cityWithStateAbbr: "New Port Richey, FL",
  },
  {
    zip: "34655",
    ST: "FL",
    cityWithStateAbbr: "New Port Richey, FL",
  },
  {
    zip: "34656",
    ST: "FL",
    cityWithStateAbbr: "New Port Richey, FL",
  },
  {
    zip: "34660",
    ST: "FL",
    cityWithStateAbbr: "Ozona, FL",
  },
  {
    zip: "34661",
    ST: "FL",
    cityWithStateAbbr: "Nobleton, FL",
  },
  {
    zip: "34667",
    ST: "FL",
    cityWithStateAbbr: "Hudson, FL",
  },
  {
    zip: "34668",
    ST: "FL",
    cityWithStateAbbr: "Port Richey, FL",
  },
  {
    zip: "34669",
    ST: "FL",
    cityWithStateAbbr: "Hudson, FL",
  },
  {
    zip: "34673",
    ST: "FL",
    cityWithStateAbbr: "Port Richey, FL",
  },
  {
    zip: "34674",
    ST: "FL",
    cityWithStateAbbr: "Hudson, FL",
  },
  {
    zip: "34677",
    ST: "FL",
    cityWithStateAbbr: "Oldsmar, FL",
  },
  {
    zip: "34679",
    ST: "FL",
    cityWithStateAbbr: "Aripeka, FL",
  },
  {
    zip: "34680",
    ST: "FL",
    cityWithStateAbbr: "Elfers, FL",
  },
  {
    zip: "34681",
    ST: "FL",
    cityWithStateAbbr: "Crystal Beach, FL",
  },
  {
    zip: "34682",
    ST: "FL",
    cityWithStateAbbr: "Palm Harbor, FL",
  },
  {
    zip: "34683",
    ST: "FL",
    cityWithStateAbbr: "Palm Harbor, FL",
  },
  {
    zip: "34684",
    ST: "FL",
    cityWithStateAbbr: "Palm Harbor, FL",
  },
  {
    zip: "34685",
    ST: "FL",
    cityWithStateAbbr: "Palm Harbor, FL",
  },
  {
    zip: "34688",
    ST: "FL",
    cityWithStateAbbr: "Tarpon Springs, FL",
  },
  {
    zip: "34689",
    ST: "FL",
    cityWithStateAbbr: "Tarpon Springs, FL",
  },
  {
    zip: "34690",
    ST: "FL",
    cityWithStateAbbr: "Holiday, FL",
  },
  {
    zip: "34691",
    ST: "FL",
    cityWithStateAbbr: "Holiday, FL",
  },
  {
    zip: "34692",
    ST: "FL",
    cityWithStateAbbr: "Holiday, FL",
  },
  {
    zip: "34695",
    ST: "FL",
    cityWithStateAbbr: "Safety Harbor, FL",
  },
  {
    zip: "34697",
    ST: "FL",
    cityWithStateAbbr: "Dunedin, FL",
  },
  {
    zip: "34698",
    ST: "FL",
    cityWithStateAbbr: "Dunedin, FL",
  },
  {
    zip: "34705",
    ST: "FL",
    cityWithStateAbbr: "Astatula, FL",
  },
  {
    zip: "34711",
    ST: "FL",
    cityWithStateAbbr: "Clermont, FL",
  },
  {
    zip: "34712",
    ST: "FL",
    cityWithStateAbbr: "Clermont, FL",
  },
  {
    zip: "34713",
    ST: "FL",
    cityWithStateAbbr: "Clermont, FL",
  },
  {
    zip: "34714",
    ST: "FL",
    cityWithStateAbbr: "Clermont, FL",
  },
  {
    zip: "34715",
    ST: "FL",
    cityWithStateAbbr: "Clermont, FL",
  },
  {
    zip: "34729",
    ST: "FL",
    cityWithStateAbbr: "Ferndale, FL",
  },
  {
    zip: "34731",
    ST: "FL",
    cityWithStateAbbr: "Fruitland Park, FL",
  },
  {
    zip: "34734",
    ST: "FL",
    cityWithStateAbbr: "Gotha, FL",
  },
  {
    zip: "34736",
    ST: "FL",
    cityWithStateAbbr: "Groveland, FL",
  },
  {
    zip: "34737",
    ST: "FL",
    cityWithStateAbbr: "Howey In The Hills, FL",
  },
  {
    zip: "34739",
    ST: "FL",
    cityWithStateAbbr: "Kenansville, FL",
  },
  {
    zip: "34740",
    ST: "FL",
    cityWithStateAbbr: "Killarney, FL",
  },
  {
    zip: "34741",
    ST: "FL",
    cityWithStateAbbr: "Kissimmee, FL",
  },
  {
    zip: "34742",
    ST: "FL",
    cityWithStateAbbr: "Kissimmee, FL",
  },
  {
    zip: "34743",
    ST: "FL",
    cityWithStateAbbr: "Kissimmee, FL",
  },
  {
    zip: "34744",
    ST: "FL",
    cityWithStateAbbr: "Kissimmee, FL",
  },
  {
    zip: "34745",
    ST: "FL",
    cityWithStateAbbr: "Kissimmee, FL",
  },
  {
    zip: "34746",
    ST: "FL",
    cityWithStateAbbr: "Kissimmee, FL",
  },
  {
    zip: "34747",
    ST: "FL",
    cityWithStateAbbr: "Kissimmee, FL",
  },
  {
    zip: "34748",
    ST: "FL",
    cityWithStateAbbr: "Leesburg, FL",
  },
  {
    zip: "34749",
    ST: "FL",
    cityWithStateAbbr: "Leesburg, FL",
  },
  {
    zip: "34753",
    ST: "FL",
    cityWithStateAbbr: "Mascotte, FL",
  },
  {
    zip: "34755",
    ST: "FL",
    cityWithStateAbbr: "Minneola, FL",
  },
  {
    zip: "34756",
    ST: "FL",
    cityWithStateAbbr: "Montverde, FL",
  },
  {
    zip: "34758",
    ST: "FL",
    cityWithStateAbbr: "Kissimmee, FL",
  },
  {
    zip: "34759",
    ST: "FL",
    cityWithStateAbbr: "Kissimmee, FL",
  },
  {
    zip: "34760",
    ST: "FL",
    cityWithStateAbbr: "Oakland, FL",
  },
  {
    zip: "34761",
    ST: "FL",
    cityWithStateAbbr: "Ocoee, FL",
  },
  {
    zip: "34762",
    ST: "FL",
    cityWithStateAbbr: "Okahumpka, FL",
  },
  {
    zip: "34769",
    ST: "FL",
    cityWithStateAbbr: "Saint Cloud, FL",
  },
  {
    zip: "34770",
    ST: "FL",
    cityWithStateAbbr: "Saint Cloud, FL",
  },
  {
    zip: "34771",
    ST: "FL",
    cityWithStateAbbr: "Saint Cloud, FL",
  },
  {
    zip: "34772",
    ST: "FL",
    cityWithStateAbbr: "Saint Cloud, FL",
  },
  {
    zip: "34773",
    ST: "FL",
    cityWithStateAbbr: "Saint Cloud, FL",
  },
  {
    zip: "34777",
    ST: "FL",
    cityWithStateAbbr: "Winter Garden, FL",
  },
  {
    zip: "34778",
    ST: "FL",
    cityWithStateAbbr: "Winter Garden, FL",
  },
  {
    zip: "34785",
    ST: "FL",
    cityWithStateAbbr: "Wildwood, FL",
  },
  {
    zip: "34786",
    ST: "FL",
    cityWithStateAbbr: "Windermere, FL",
  },
  {
    zip: "34787",
    ST: "FL",
    cityWithStateAbbr: "Winter Garden, FL",
  },
  {
    zip: "34788",
    ST: "FL",
    cityWithStateAbbr: "Leesburg, FL",
  },
  {
    zip: "34789",
    ST: "FL",
    cityWithStateAbbr: "Leesburg, FL",
  },
  {
    zip: "34797",
    ST: "FL",
    cityWithStateAbbr: "Yalaha, FL",
  },
  {
    zip: "34945",
    ST: "FL",
    cityWithStateAbbr: "Fort Pierce, FL",
  },
  {
    zip: "34946",
    ST: "FL",
    cityWithStateAbbr: "Fort Pierce, FL",
  },
  {
    zip: "34947",
    ST: "FL",
    cityWithStateAbbr: "Fort Pierce, FL",
  },
  {
    zip: "34948",
    ST: "FL",
    cityWithStateAbbr: "Fort Pierce, FL",
  },
  {
    zip: "34949",
    ST: "FL",
    cityWithStateAbbr: "Fort Pierce, FL",
  },
  {
    zip: "34950",
    ST: "FL",
    cityWithStateAbbr: "Fort Pierce, FL",
  },
  {
    zip: "34951",
    ST: "FL",
    cityWithStateAbbr: "Fort Pierce, FL",
  },
  {
    zip: "34952",
    ST: "FL",
    cityWithStateAbbr: "Port Saint Lucie, FL",
  },
  {
    zip: "34953",
    ST: "FL",
    cityWithStateAbbr: "Port Saint Lucie, FL",
  },
  {
    zip: "34954",
    ST: "FL",
    cityWithStateAbbr: "Fort Pierce, FL",
  },
  {
    zip: "34956",
    ST: "FL",
    cityWithStateAbbr: "Indiantown, FL",
  },
  {
    zip: "34957",
    ST: "FL",
    cityWithStateAbbr: "Jensen Beach, FL",
  },
  {
    zip: "34958",
    ST: "FL",
    cityWithStateAbbr: "Jensen Beach, FL",
  },
  {
    zip: "34972",
    ST: "FL",
    cityWithStateAbbr: "Okeechobee, FL",
  },
  {
    zip: "34973",
    ST: "FL",
    cityWithStateAbbr: "Okeechobee, FL",
  },
  {
    zip: "34974",
    ST: "FL",
    cityWithStateAbbr: "Okeechobee, FL",
  },
  {
    zip: "34979",
    ST: "FL",
    cityWithStateAbbr: "Fort Pierce, FL",
  },
  {
    zip: "34981",
    ST: "FL",
    cityWithStateAbbr: "Fort Pierce, FL",
  },
  {
    zip: "34982",
    ST: "FL",
    cityWithStateAbbr: "Fort Pierce, FL",
  },
  {
    zip: "34983",
    ST: "FL",
    cityWithStateAbbr: "Port Saint Lucie, FL",
  },
  {
    zip: "34984",
    ST: "FL",
    cityWithStateAbbr: "Port Saint Lucie, FL",
  },
  {
    zip: "34985",
    ST: "FL",
    cityWithStateAbbr: "Port Saint Lucie, FL",
  },
  {
    zip: "34986",
    ST: "FL",
    cityWithStateAbbr: "Port Saint Lucie, FL",
  },
  {
    zip: "34987",
    ST: "FL",
    cityWithStateAbbr: "Port Saint Lucie, FL",
  },
  {
    zip: "34988",
    ST: "FL",
    cityWithStateAbbr: "Port Saint Lucie, FL",
  },
  {
    zip: "34990",
    ST: "FL",
    cityWithStateAbbr: "Palm City, FL",
  },
  {
    zip: "34991",
    ST: "FL",
    cityWithStateAbbr: "Palm City, FL",
  },
  {
    zip: "34992",
    ST: "FL",
    cityWithStateAbbr: "Port Salerno, FL",
  },
  {
    zip: "34994",
    ST: "FL",
    cityWithStateAbbr: "Stuart, FL",
  },
  {
    zip: "34995",
    ST: "FL",
    cityWithStateAbbr: "Stuart, FL",
  },
  {
    zip: "34996",
    ST: "FL",
    cityWithStateAbbr: "Stuart, FL",
  },
  {
    zip: "34997",
    ST: "FL",
    cityWithStateAbbr: "Stuart, FL",
  },
  {
    zip: "35004",
    ST: "AL",
    cityWithStateAbbr: "Moody, AL",
  },
  {
    zip: "35005",
    ST: "AL",
    cityWithStateAbbr: "Adamsville, AL",
  },
  {
    zip: "35006",
    ST: "AL",
    cityWithStateAbbr: "Adger, AL",
  },
  {
    zip: "35007",
    ST: "AL",
    cityWithStateAbbr: "Alabaster, AL",
  },
  {
    zip: "35010",
    ST: "AL",
    cityWithStateAbbr: "Alexander City, AL",
  },
  {
    zip: "35011",
    ST: "AL",
    cityWithStateAbbr: "Alexander City, AL",
  },
  {
    zip: "35013",
    ST: "AL",
    cityWithStateAbbr: "Allgood, AL",
  },
  {
    zip: "35014",
    ST: "AL",
    cityWithStateAbbr: "Alpine, AL",
  },
  {
    zip: "35015",
    ST: "AL",
    cityWithStateAbbr: "Alton, AL",
  },
  {
    zip: "35016",
    ST: "AL",
    cityWithStateAbbr: "Arab, AL",
  },
  {
    zip: "35019",
    ST: "AL",
    cityWithStateAbbr: "Baileyton, AL",
  },
  {
    zip: "35020",
    ST: "AL",
    cityWithStateAbbr: "Bessemer, AL",
  },
  {
    zip: "35021",
    ST: "AL",
    cityWithStateAbbr: "Bessemer, AL",
  },
  {
    zip: "35022",
    ST: "AL",
    cityWithStateAbbr: "Bessemer, AL",
  },
  {
    zip: "35023",
    ST: "AL",
    cityWithStateAbbr: "Bessemer, AL",
  },
  {
    zip: "35031",
    ST: "AL",
    cityWithStateAbbr: "Blountsville, AL",
  },
  {
    zip: "35032",
    ST: "AL",
    cityWithStateAbbr: "Bon Air, AL",
  },
  {
    zip: "35033",
    ST: "AL",
    cityWithStateAbbr: "Bremen, AL",
  },
  {
    zip: "35034",
    ST: "AL",
    cityWithStateAbbr: "Brent, AL",
  },
  {
    zip: "35035",
    ST: "AL",
    cityWithStateAbbr: "Brierfield, AL",
  },
  {
    zip: "35036",
    ST: "AL",
    cityWithStateAbbr: "Brookside, AL",
  },
  {
    zip: "35038",
    ST: "AL",
    cityWithStateAbbr: "Burnwell, AL",
  },
  {
    zip: "35040",
    ST: "AL",
    cityWithStateAbbr: "Calera, AL",
  },
  {
    zip: "35041",
    ST: "AL",
    cityWithStateAbbr: "Cardiff, AL",
  },
  {
    zip: "35042",
    ST: "AL",
    cityWithStateAbbr: "Centreville, AL",
  },
  {
    zip: "35043",
    ST: "AL",
    cityWithStateAbbr: "Chelsea, AL",
  },
  {
    zip: "35044",
    ST: "AL",
    cityWithStateAbbr: "Childersburg, AL",
  },
  {
    zip: "35045",
    ST: "AL",
    cityWithStateAbbr: "Clanton, AL",
  },
  {
    zip: "35046",
    ST: "AL",
    cityWithStateAbbr: "Clanton, AL",
  },
  {
    zip: "35048",
    ST: "AL",
    cityWithStateAbbr: "Clay, AL",
  },
  {
    zip: "35049",
    ST: "AL",
    cityWithStateAbbr: "Cleveland, AL",
  },
  {
    zip: "35051",
    ST: "AL",
    cityWithStateAbbr: "Columbiana, AL",
  },
  {
    zip: "35052",
    ST: "AL",
    cityWithStateAbbr: "Cook Springs, AL",
  },
  {
    zip: "35053",
    ST: "AL",
    cityWithStateAbbr: "Crane Hill, AL",
  },
  {
    zip: "35054",
    ST: "AL",
    cityWithStateAbbr: "Cropwell, AL",
  },
  {
    zip: "35055",
    ST: "AL",
    cityWithStateAbbr: "Cullman, AL",
  },
  {
    zip: "35056",
    ST: "AL",
    cityWithStateAbbr: "Cullman, AL",
  },
  {
    zip: "35057",
    ST: "AL",
    cityWithStateAbbr: "Cullman, AL",
  },
  {
    zip: "35058",
    ST: "AL",
    cityWithStateAbbr: "Cullman, AL",
  },
  {
    zip: "35060",
    ST: "AL",
    cityWithStateAbbr: "Docena, AL",
  },
  {
    zip: "35061",
    ST: "AL",
    cityWithStateAbbr: "Dolomite, AL",
  },
  {
    zip: "35062",
    ST: "AL",
    cityWithStateAbbr: "Dora, AL",
  },
  {
    zip: "35063",
    ST: "AL",
    cityWithStateAbbr: "Empire, AL",
  },
  {
    zip: "35064",
    ST: "AL",
    cityWithStateAbbr: "Fairfield, AL",
  },
  {
    zip: "35068",
    ST: "AL",
    cityWithStateAbbr: "Fultondale, AL",
  },
  {
    zip: "35070",
    ST: "AL",
    cityWithStateAbbr: "Garden City, AL",
  },
  {
    zip: "35071",
    ST: "AL",
    cityWithStateAbbr: "Gardendale, AL",
  },
  {
    zip: "35072",
    ST: "AL",
    cityWithStateAbbr: "Goodwater, AL",
  },
  {
    zip: "35073",
    ST: "AL",
    cityWithStateAbbr: "Graysville, AL",
  },
  {
    zip: "35074",
    ST: "AL",
    cityWithStateAbbr: "Green Pond, AL",
  },
  {
    zip: "35077",
    ST: "AL",
    cityWithStateAbbr: "Hanceville, AL",
  },
  {
    zip: "35078",
    ST: "AL",
    cityWithStateAbbr: "Harpersville, AL",
  },
  {
    zip: "35079",
    ST: "AL",
    cityWithStateAbbr: "Hayden, AL",
  },
  {
    zip: "35080",
    ST: "AL",
    cityWithStateAbbr: "Helena, AL",
  },
  {
    zip: "35082",
    ST: "AL",
    cityWithStateAbbr: "Hollins, AL",
  },
  {
    zip: "35083",
    ST: "AL",
    cityWithStateAbbr: "Holly Pond, AL",
  },
  {
    zip: "35085",
    ST: "AL",
    cityWithStateAbbr: "Jemison, AL",
  },
  {
    zip: "35087",
    ST: "AL",
    cityWithStateAbbr: "Joppa, AL",
  },
  {
    zip: "35089",
    ST: "AL",
    cityWithStateAbbr: "Kellyton, AL",
  },
  {
    zip: "35091",
    ST: "AL",
    cityWithStateAbbr: "Kimberly, AL",
  },
  {
    zip: "35094",
    ST: "AL",
    cityWithStateAbbr: "Leeds, AL",
  },
  {
    zip: "35096",
    ST: "AL",
    cityWithStateAbbr: "Lincoln, AL",
  },
  {
    zip: "35097",
    ST: "AL",
    cityWithStateAbbr: "Locust Fork, AL",
  },
  {
    zip: "35098",
    ST: "AL",
    cityWithStateAbbr: "Logan, AL",
  },
  {
    zip: "35111",
    ST: "AL",
    cityWithStateAbbr: "Mc Calla, AL",
  },
  {
    zip: "35112",
    ST: "AL",
    cityWithStateAbbr: "Margaret, AL",
  },
  {
    zip: "35114",
    ST: "AL",
    cityWithStateAbbr: "Maylene, AL",
  },
  {
    zip: "35115",
    ST: "AL",
    cityWithStateAbbr: "Montevallo, AL",
  },
  {
    zip: "35116",
    ST: "AL",
    cityWithStateAbbr: "Morris, AL",
  },
  {
    zip: "35117",
    ST: "AL",
    cityWithStateAbbr: "Mount Olive, AL",
  },
  {
    zip: "35118",
    ST: "AL",
    cityWithStateAbbr: "Mulga, AL",
  },
  {
    zip: "35119",
    ST: "AL",
    cityWithStateAbbr: "New Castle, AL",
  },
  {
    zip: "35120",
    ST: "AL",
    cityWithStateAbbr: "Odenville, AL",
  },
  {
    zip: "35121",
    ST: "AL",
    cityWithStateAbbr: "Oneonta, AL",
  },
  {
    zip: "35123",
    ST: "AL",
    cityWithStateAbbr: "Palmerdale, AL",
  },
  {
    zip: "35124",
    ST: "AL",
    cityWithStateAbbr: "Pelham, AL",
  },
  {
    zip: "35125",
    ST: "AL",
    cityWithStateAbbr: "Pell City, AL",
  },
  {
    zip: "35126",
    ST: "AL",
    cityWithStateAbbr: "Pinson, AL",
  },
  {
    zip: "35127",
    ST: "AL",
    cityWithStateAbbr: "Pleasant Grove, AL",
  },
  {
    zip: "35128",
    ST: "AL",
    cityWithStateAbbr: "Pell City, AL",
  },
  {
    zip: "35130",
    ST: "AL",
    cityWithStateAbbr: "Quinton, AL",
  },
  {
    zip: "35131",
    ST: "AL",
    cityWithStateAbbr: "Ragland, AL",
  },
  {
    zip: "35133",
    ST: "AL",
    cityWithStateAbbr: "Remlap, AL",
  },
  {
    zip: "35135",
    ST: "AL",
    cityWithStateAbbr: "Riverside, AL",
  },
  {
    zip: "35136",
    ST: "AL",
    cityWithStateAbbr: "Rockford, AL",
  },
  {
    zip: "35137",
    ST: "AL",
    cityWithStateAbbr: "Saginaw, AL",
  },
  {
    zip: "35139",
    ST: "AL",
    cityWithStateAbbr: "Sayre, AL",
  },
  {
    zip: "35142",
    ST: "AL",
    cityWithStateAbbr: "Shannon, AL",
  },
  {
    zip: "35143",
    ST: "AL",
    cityWithStateAbbr: "Shelby, AL",
  },
  {
    zip: "35144",
    ST: "AL",
    cityWithStateAbbr: "Siluria, AL",
  },
  {
    zip: "35146",
    ST: "AL",
    cityWithStateAbbr: "Springville, AL",
  },
  {
    zip: "35147",
    ST: "AL",
    cityWithStateAbbr: "Sterrett, AL",
  },
  {
    zip: "35148",
    ST: "AL",
    cityWithStateAbbr: "Sumiton, AL",
  },
  {
    zip: "35149",
    ST: "AL",
    cityWithStateAbbr: "Sycamore, AL",
  },
  {
    zip: "35150",
    ST: "AL",
    cityWithStateAbbr: "Sylacauga, AL",
  },
  {
    zip: "35151",
    ST: "AL",
    cityWithStateAbbr: "Sylacauga, AL",
  },
  {
    zip: "35160",
    ST: "AL",
    cityWithStateAbbr: "Talladega, AL",
  },
  {
    zip: "35161",
    ST: "AL",
    cityWithStateAbbr: "Talladega, AL",
  },
  {
    zip: "35171",
    ST: "AL",
    cityWithStateAbbr: "Thorsby, AL",
  },
  {
    zip: "35172",
    ST: "AL",
    cityWithStateAbbr: "Trafford, AL",
  },
  {
    zip: "35173",
    ST: "AL",
    cityWithStateAbbr: "Trussville, AL",
  },
  {
    zip: "35175",
    ST: "AL",
    cityWithStateAbbr: "Union Grove, AL",
  },
  {
    zip: "35176",
    ST: "AL",
    cityWithStateAbbr: "Vandiver, AL",
  },
  {
    zip: "35178",
    ST: "AL",
    cityWithStateAbbr: "Vincent, AL",
  },
  {
    zip: "35179",
    ST: "AL",
    cityWithStateAbbr: "Vinemont, AL",
  },
  {
    zip: "35180",
    ST: "AL",
    cityWithStateAbbr: "Warrior, AL",
  },
  {
    zip: "35181",
    ST: "AL",
    cityWithStateAbbr: "Watson, AL",
  },
  {
    zip: "35182",
    ST: "AL",
    cityWithStateAbbr: "Wattsville, AL",
  },
  {
    zip: "35183",
    ST: "AL",
    cityWithStateAbbr: "Weogufka, AL",
  },
  {
    zip: "35184",
    ST: "AL",
    cityWithStateAbbr: "West Blocton, AL",
  },
  {
    zip: "35185",
    ST: "AL",
    cityWithStateAbbr: "Westover, AL",
  },
  {
    zip: "35186",
    ST: "AL",
    cityWithStateAbbr: "Wilsonville, AL",
  },
  {
    zip: "35187",
    ST: "AL",
    cityWithStateAbbr: "Wilton, AL",
  },
  {
    zip: "35188",
    ST: "AL",
    cityWithStateAbbr: "Woodstock, AL",
  },
  {
    zip: "35201",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35202",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35203",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35204",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35205",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35206",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35207",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35208",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35209",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35210",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35211",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35212",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35213",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35214",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35215",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35216",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35217",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35218",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35219",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35220",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35221",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35222",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35223",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35224",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35226",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35228",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35229",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35231",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35232",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35233",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35234",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35235",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35236",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35237",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35238",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35242",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35243",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35244",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35246",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35249",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35253",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35254",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35255",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35259",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35260",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35261",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35266",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35282",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35283",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35285",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35287",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35288",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35290",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35291",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35292",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35293",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35294",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35295",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35296",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35297",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35298",
    ST: "AL",
    cityWithStateAbbr: "Birmingham, AL",
  },
  {
    zip: "35401",
    ST: "AL",
    cityWithStateAbbr: "Tuscaloosa, AL",
  },
  {
    zip: "35402",
    ST: "AL",
    cityWithStateAbbr: "Tuscaloosa, AL",
  },
  {
    zip: "35403",
    ST: "AL",
    cityWithStateAbbr: "Tuscaloosa, AL",
  },
  {
    zip: "35404",
    ST: "AL",
    cityWithStateAbbr: "Tuscaloosa, AL",
  },
  {
    zip: "35405",
    ST: "AL",
    cityWithStateAbbr: "Tuscaloosa, AL",
  },
  {
    zip: "35406",
    ST: "AL",
    cityWithStateAbbr: "Tuscaloosa, AL",
  },
  {
    zip: "35407",
    ST: "AL",
    cityWithStateAbbr: "Tuscaloosa, AL",
  },
  {
    zip: "35440",
    ST: "AL",
    cityWithStateAbbr: "Abernant, AL",
  },
  {
    zip: "35441",
    ST: "AL",
    cityWithStateAbbr: "Akron, AL",
  },
  {
    zip: "35442",
    ST: "AL",
    cityWithStateAbbr: "Aliceville, AL",
  },
  {
    zip: "35443",
    ST: "AL",
    cityWithStateAbbr: "Boligee, AL",
  },
  {
    zip: "35444",
    ST: "AL",
    cityWithStateAbbr: "Brookwood, AL",
  },
  {
    zip: "35446",
    ST: "AL",
    cityWithStateAbbr: "Buhl, AL",
  },
  {
    zip: "35447",
    ST: "AL",
    cityWithStateAbbr: "Carrollton, AL",
  },
  {
    zip: "35448",
    ST: "AL",
    cityWithStateAbbr: "Clinton, AL",
  },
  {
    zip: "35449",
    ST: "AL",
    cityWithStateAbbr: "Coaling, AL",
  },
  {
    zip: "35452",
    ST: "AL",
    cityWithStateAbbr: "Coker, AL",
  },
  {
    zip: "35453",
    ST: "AL",
    cityWithStateAbbr: "Cottondale, AL",
  },
  {
    zip: "35456",
    ST: "AL",
    cityWithStateAbbr: "Duncanville, AL",
  },
  {
    zip: "35457",
    ST: "AL",
    cityWithStateAbbr: "Echola, AL",
  },
  {
    zip: "35458",
    ST: "AL",
    cityWithStateAbbr: "Elrod, AL",
  },
  {
    zip: "35459",
    ST: "AL",
    cityWithStateAbbr: "Emelle, AL",
  },
  {
    zip: "35460",
    ST: "AL",
    cityWithStateAbbr: "Epes, AL",
  },
  {
    zip: "35461",
    ST: "AL",
    cityWithStateAbbr: "Ethelsville, AL",
  },
  {
    zip: "35462",
    ST: "AL",
    cityWithStateAbbr: "Eutaw, AL",
  },
  {
    zip: "35463",
    ST: "AL",
    cityWithStateAbbr: "Fosters, AL",
  },
  {
    zip: "35464",
    ST: "AL",
    cityWithStateAbbr: "Gainesville, AL",
  },
  {
    zip: "35466",
    ST: "AL",
    cityWithStateAbbr: "Gordo, AL",
  },
  {
    zip: "35468",
    ST: "AL",
    cityWithStateAbbr: "Kellerman, AL",
  },
  {
    zip: "35469",
    ST: "AL",
    cityWithStateAbbr: "Knoxville, AL",
  },
  {
    zip: "35470",
    ST: "AL",
    cityWithStateAbbr: "Livingston, AL",
  },
  {
    zip: "35471",
    ST: "AL",
    cityWithStateAbbr: "Mc Shan, AL",
  },
  {
    zip: "35473",
    ST: "AL",
    cityWithStateAbbr: "Northport, AL",
  },
  {
    zip: "35474",
    ST: "AL",
    cityWithStateAbbr: "Moundville, AL",
  },
  {
    zip: "35475",
    ST: "AL",
    cityWithStateAbbr: "Northport, AL",
  },
  {
    zip: "35476",
    ST: "AL",
    cityWithStateAbbr: "Northport, AL",
  },
  {
    zip: "35477",
    ST: "AL",
    cityWithStateAbbr: "Panola, AL",
  },
  {
    zip: "35478",
    ST: "AL",
    cityWithStateAbbr: "Peterson, AL",
  },
  {
    zip: "35480",
    ST: "AL",
    cityWithStateAbbr: "Ralph, AL",
  },
  {
    zip: "35481",
    ST: "AL",
    cityWithStateAbbr: "Reform, AL",
  },
  {
    zip: "35482",
    ST: "AL",
    cityWithStateAbbr: "Samantha, AL",
  },
  {
    zip: "35485",
    ST: "AL",
    cityWithStateAbbr: "Tuscaloosa, AL",
  },
  {
    zip: "35486",
    ST: "AL",
    cityWithStateAbbr: "Tuscaloosa, AL",
  },
  {
    zip: "35487",
    ST: "AL",
    cityWithStateAbbr: "Tuscaloosa, AL",
  },
  {
    zip: "35490",
    ST: "AL",
    cityWithStateAbbr: "Vance, AL",
  },
  {
    zip: "35491",
    ST: "AL",
    cityWithStateAbbr: "West Greene, AL",
  },
  {
    zip: "35501",
    ST: "AL",
    cityWithStateAbbr: "Jasper, AL",
  },
  {
    zip: "35502",
    ST: "AL",
    cityWithStateAbbr: "Jasper, AL",
  },
  {
    zip: "35503",
    ST: "AL",
    cityWithStateAbbr: "Jasper, AL",
  },
  {
    zip: "35504",
    ST: "AL",
    cityWithStateAbbr: "Jasper, AL",
  },
  {
    zip: "35540",
    ST: "AL",
    cityWithStateAbbr: "Addison, AL",
  },
  {
    zip: "35541",
    ST: "AL",
    cityWithStateAbbr: "Arley, AL",
  },
  {
    zip: "35542",
    ST: "AL",
    cityWithStateAbbr: "Bankston, AL",
  },
  {
    zip: "35543",
    ST: "AL",
    cityWithStateAbbr: "Bear Creek, AL",
  },
  {
    zip: "35544",
    ST: "AL",
    cityWithStateAbbr: "Beaverton, AL",
  },
  {
    zip: "35545",
    ST: "AL",
    cityWithStateAbbr: "Belk, AL",
  },
  {
    zip: "35546",
    ST: "AL",
    cityWithStateAbbr: "Berry, AL",
  },
  {
    zip: "35548",
    ST: "AL",
    cityWithStateAbbr: "Brilliant, AL",
  },
  {
    zip: "35549",
    ST: "AL",
    cityWithStateAbbr: "Carbon Hill, AL",
  },
  {
    zip: "35550",
    ST: "AL",
    cityWithStateAbbr: "Cordova, AL",
  },
  {
    zip: "35551",
    ST: "AL",
    cityWithStateAbbr: "Delmar, AL",
  },
  {
    zip: "35552",
    ST: "AL",
    cityWithStateAbbr: "Detroit, AL",
  },
  {
    zip: "35553",
    ST: "AL",
    cityWithStateAbbr: "Double Springs, AL",
  },
  {
    zip: "35554",
    ST: "AL",
    cityWithStateAbbr: "Eldridge, AL",
  },
  {
    zip: "35555",
    ST: "AL",
    cityWithStateAbbr: "Fayette, AL",
  },
  {
    zip: "35559",
    ST: "AL",
    cityWithStateAbbr: "Glen Allen, AL",
  },
  {
    zip: "35560",
    ST: "AL",
    cityWithStateAbbr: "Goodsprings, AL",
  },
  {
    zip: "35563",
    ST: "AL",
    cityWithStateAbbr: "Guin, AL",
  },
  {
    zip: "35564",
    ST: "AL",
    cityWithStateAbbr: "Hackleburg, AL",
  },
  {
    zip: "35565",
    ST: "AL",
    cityWithStateAbbr: "Haleyville, AL",
  },
  {
    zip: "35570",
    ST: "AL",
    cityWithStateAbbr: "Hamilton, AL",
  },
  {
    zip: "35571",
    ST: "AL",
    cityWithStateAbbr: "Hodges, AL",
  },
  {
    zip: "35572",
    ST: "AL",
    cityWithStateAbbr: "Houston, AL",
  },
  {
    zip: "35573",
    ST: "AL",
    cityWithStateAbbr: "Kansas, AL",
  },
  {
    zip: "35574",
    ST: "AL",
    cityWithStateAbbr: "Kennedy, AL",
  },
  {
    zip: "35575",
    ST: "AL",
    cityWithStateAbbr: "Lynn, AL",
  },
  {
    zip: "35576",
    ST: "AL",
    cityWithStateAbbr: "Millport, AL",
  },
  {
    zip: "35577",
    ST: "AL",
    cityWithStateAbbr: "Natural Bridge, AL",
  },
  {
    zip: "35578",
    ST: "AL",
    cityWithStateAbbr: "Nauvoo, AL",
  },
  {
    zip: "35579",
    ST: "AL",
    cityWithStateAbbr: "Oakman, AL",
  },
  {
    zip: "35580",
    ST: "AL",
    cityWithStateAbbr: "Parrish, AL",
  },
  {
    zip: "35581",
    ST: "AL",
    cityWithStateAbbr: "Phil Campbell, AL",
  },
  {
    zip: "35582",
    ST: "AL",
    cityWithStateAbbr: "Red Bay, AL",
  },
  {
    zip: "35584",
    ST: "AL",
    cityWithStateAbbr: "Sipsey, AL",
  },
  {
    zip: "35585",
    ST: "AL",
    cityWithStateAbbr: "Spruce Pine, AL",
  },
  {
    zip: "35586",
    ST: "AL",
    cityWithStateAbbr: "Sulligent, AL",
  },
  {
    zip: "35587",
    ST: "AL",
    cityWithStateAbbr: "Townley, AL",
  },
  {
    zip: "35592",
    ST: "AL",
    cityWithStateAbbr: "Vernon, AL",
  },
  {
    zip: "35593",
    ST: "AL",
    cityWithStateAbbr: "Vina, AL",
  },
  {
    zip: "35594",
    ST: "AL",
    cityWithStateAbbr: "Winfield, AL",
  },
  {
    zip: "35601",
    ST: "AL",
    cityWithStateAbbr: "Decatur, AL",
  },
  {
    zip: "35602",
    ST: "AL",
    cityWithStateAbbr: "Decatur, AL",
  },
  {
    zip: "35603",
    ST: "AL",
    cityWithStateAbbr: "Decatur, AL",
  },
  {
    zip: "35609",
    ST: "AL",
    cityWithStateAbbr: "Decatur, AL",
  },
  {
    zip: "35610",
    ST: "AL",
    cityWithStateAbbr: "Anderson, AL",
  },
  {
    zip: "35611",
    ST: "AL",
    cityWithStateAbbr: "Athens, AL",
  },
  {
    zip: "35612",
    ST: "AL",
    cityWithStateAbbr: "Athens, AL",
  },
  {
    zip: "35613",
    ST: "AL",
    cityWithStateAbbr: "Athens, AL",
  },
  {
    zip: "35614",
    ST: "AL",
    cityWithStateAbbr: "Athens, AL",
  },
  {
    zip: "35615",
    ST: "AL",
    cityWithStateAbbr: "Belle Mina, AL",
  },
  {
    zip: "35616",
    ST: "AL",
    cityWithStateAbbr: "Cherokee, AL",
  },
  {
    zip: "35617",
    ST: "AL",
    cityWithStateAbbr: "Cloverdale, AL",
  },
  {
    zip: "35618",
    ST: "AL",
    cityWithStateAbbr: "Courtland, AL",
  },
  {
    zip: "35619",
    ST: "AL",
    cityWithStateAbbr: "Danville, AL",
  },
  {
    zip: "35620",
    ST: "AL",
    cityWithStateAbbr: "Elkmont, AL",
  },
  {
    zip: "35621",
    ST: "AL",
    cityWithStateAbbr: "Eva, AL",
  },
  {
    zip: "35622",
    ST: "AL",
    cityWithStateAbbr: "Falkville, AL",
  },
  {
    zip: "35630",
    ST: "AL",
    cityWithStateAbbr: "Florence, AL",
  },
  {
    zip: "35631",
    ST: "AL",
    cityWithStateAbbr: "Florence, AL",
  },
  {
    zip: "35632",
    ST: "AL",
    cityWithStateAbbr: "Florence, AL",
  },
  {
    zip: "35633",
    ST: "AL",
    cityWithStateAbbr: "Florence, AL",
  },
  {
    zip: "35634",
    ST: "AL",
    cityWithStateAbbr: "Florence, AL",
  },
  {
    zip: "35640",
    ST: "AL",
    cityWithStateAbbr: "Hartselle, AL",
  },
  {
    zip: "35643",
    ST: "AL",
    cityWithStateAbbr: "Hillsboro, AL",
  },
  {
    zip: "35645",
    ST: "AL",
    cityWithStateAbbr: "Killen, AL",
  },
  {
    zip: "35646",
    ST: "AL",
    cityWithStateAbbr: "Leighton, AL",
  },
  {
    zip: "35647",
    ST: "AL",
    cityWithStateAbbr: "Lester, AL",
  },
  {
    zip: "35648",
    ST: "AL",
    cityWithStateAbbr: "Lexington, AL",
  },
  {
    zip: "35649",
    ST: "AL",
    cityWithStateAbbr: "Mooresville, AL",
  },
  {
    zip: "35650",
    ST: "AL",
    cityWithStateAbbr: "Moulton, AL",
  },
  {
    zip: "35651",
    ST: "AL",
    cityWithStateAbbr: "Mount Hope, AL",
  },
  {
    zip: "35652",
    ST: "AL",
    cityWithStateAbbr: "Rogersville, AL",
  },
  {
    zip: "35653",
    ST: "AL",
    cityWithStateAbbr: "Russellville, AL",
  },
  {
    zip: "35654",
    ST: "AL",
    cityWithStateAbbr: "Russellville, AL",
  },
  {
    zip: "35660",
    ST: "AL",
    cityWithStateAbbr: "Sheffield, AL",
  },
  {
    zip: "35661",
    ST: "AL",
    cityWithStateAbbr: "Muscle Shoals, AL",
  },
  {
    zip: "35662",
    ST: "AL",
    cityWithStateAbbr: "Muscle Shoals, AL",
  },
  {
    zip: "35670",
    ST: "AL",
    cityWithStateAbbr: "Somerville, AL",
  },
  {
    zip: "35671",
    ST: "AL",
    cityWithStateAbbr: "Tanner, AL",
  },
  {
    zip: "35672",
    ST: "AL",
    cityWithStateAbbr: "Town Creek, AL",
  },
  {
    zip: "35673",
    ST: "AL",
    cityWithStateAbbr: "Trinity, AL",
  },
  {
    zip: "35674",
    ST: "AL",
    cityWithStateAbbr: "Tuscumbia, AL",
  },
  {
    zip: "35677",
    ST: "AL",
    cityWithStateAbbr: "Waterloo, AL",
  },
  {
    zip: "35699",
    ST: "AL",
    cityWithStateAbbr: "Decatur, AL",
  },
  {
    zip: "35739",
    ST: "AL",
    cityWithStateAbbr: "Ardmore, AL",
  },
  {
    zip: "35740",
    ST: "AL",
    cityWithStateAbbr: "Bridgeport, AL",
  },
  {
    zip: "35741",
    ST: "AL",
    cityWithStateAbbr: "Brownsboro, AL",
  },
  {
    zip: "35742",
    ST: "AL",
    cityWithStateAbbr: "Capshaw, AL",
  },
  {
    zip: "35744",
    ST: "AL",
    cityWithStateAbbr: "Dutton, AL",
  },
  {
    zip: "35745",
    ST: "AL",
    cityWithStateAbbr: "Estillfork, AL",
  },
  {
    zip: "35746",
    ST: "AL",
    cityWithStateAbbr: "Fackler, AL",
  },
  {
    zip: "35747",
    ST: "AL",
    cityWithStateAbbr: "Grant, AL",
  },
  {
    zip: "35748",
    ST: "AL",
    cityWithStateAbbr: "Gurley, AL",
  },
  {
    zip: "35749",
    ST: "AL",
    cityWithStateAbbr: "Harvest, AL",
  },
  {
    zip: "35750",
    ST: "AL",
    cityWithStateAbbr: "Hazel Green, AL",
  },
  {
    zip: "35751",
    ST: "AL",
    cityWithStateAbbr: "Hollytree, AL",
  },
  {
    zip: "35752",
    ST: "AL",
    cityWithStateAbbr: "Hollywood, AL",
  },
  {
    zip: "35754",
    ST: "AL",
    cityWithStateAbbr: "Laceys Spring, AL",
  },
  {
    zip: "35755",
    ST: "AL",
    cityWithStateAbbr: "Langston, AL",
  },
  {
    zip: "35756",
    ST: "AL",
    cityWithStateAbbr: "Madison, AL",
  },
  {
    zip: "35757",
    ST: "AL",
    cityWithStateAbbr: "Madison, AL",
  },
  {
    zip: "35758",
    ST: "AL",
    cityWithStateAbbr: "Madison, AL",
  },
  {
    zip: "35759",
    ST: "AL",
    cityWithStateAbbr: "Meridianville, AL",
  },
  {
    zip: "35760",
    ST: "AL",
    cityWithStateAbbr: "New Hope, AL",
  },
  {
    zip: "35761",
    ST: "AL",
    cityWithStateAbbr: "New Market, AL",
  },
  {
    zip: "35762",
    ST: "AL",
    cityWithStateAbbr: "Normal, AL",
  },
  {
    zip: "35763",
    ST: "AL",
    cityWithStateAbbr: "Owens Cross Roads, AL",
  },
  {
    zip: "35764",
    ST: "AL",
    cityWithStateAbbr: "Paint Rock, AL",
  },
  {
    zip: "35765",
    ST: "AL",
    cityWithStateAbbr: "Pisgah, AL",
  },
  {
    zip: "35766",
    ST: "AL",
    cityWithStateAbbr: "Princeton, AL",
  },
  {
    zip: "35767",
    ST: "AL",
    cityWithStateAbbr: "Ryland, AL",
  },
  {
    zip: "35768",
    ST: "AL",
    cityWithStateAbbr: "Scottsboro, AL",
  },
  {
    zip: "35769",
    ST: "AL",
    cityWithStateAbbr: "Scottsboro, AL",
  },
  {
    zip: "35771",
    ST: "AL",
    cityWithStateAbbr: "Section, AL",
  },
  {
    zip: "35772",
    ST: "AL",
    cityWithStateAbbr: "Stevenson, AL",
  },
  {
    zip: "35773",
    ST: "AL",
    cityWithStateAbbr: "Toney, AL",
  },
  {
    zip: "35774",
    ST: "AL",
    cityWithStateAbbr: "Trenton, AL",
  },
  {
    zip: "35775",
    ST: "AL",
    cityWithStateAbbr: "Valhermoso Springs, AL",
  },
  {
    zip: "35776",
    ST: "AL",
    cityWithStateAbbr: "Woodville, AL",
  },
  {
    zip: "35801",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35802",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35803",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35804",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35805",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35806",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35807",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35808",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35809",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35810",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35811",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35812",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35813",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35814",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35815",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35816",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35824",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35893",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35894",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35895",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35896",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35897",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35898",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35899",
    ST: "AL",
    cityWithStateAbbr: "Huntsville, AL",
  },
  {
    zip: "35901",
    ST: "AL",
    cityWithStateAbbr: "Gadsden, AL",
  },
  {
    zip: "35902",
    ST: "AL",
    cityWithStateAbbr: "Gadsden, AL",
  },
  {
    zip: "35903",
    ST: "AL",
    cityWithStateAbbr: "Gadsden, AL",
  },
  {
    zip: "35904",
    ST: "AL",
    cityWithStateAbbr: "Gadsden, AL",
  },
  {
    zip: "35905",
    ST: "AL",
    cityWithStateAbbr: "Gadsden, AL",
  },
  {
    zip: "35906",
    ST: "AL",
    cityWithStateAbbr: "Rainbow City, AL",
  },
  {
    zip: "35907",
    ST: "AL",
    cityWithStateAbbr: "Gadsden, AL",
  },
  {
    zip: "35950",
    ST: "AL",
    cityWithStateAbbr: "Albertville, AL",
  },
  {
    zip: "35951",
    ST: "AL",
    cityWithStateAbbr: "Albertville, AL",
  },
  {
    zip: "35952",
    ST: "AL",
    cityWithStateAbbr: "Altoona, AL",
  },
  {
    zip: "35953",
    ST: "AL",
    cityWithStateAbbr: "Ashville, AL",
  },
  {
    zip: "35954",
    ST: "AL",
    cityWithStateAbbr: "Attalla, AL",
  },
  {
    zip: "35956",
    ST: "AL",
    cityWithStateAbbr: "Boaz, AL",
  },
  {
    zip: "35957",
    ST: "AL",
    cityWithStateAbbr: "Boaz, AL",
  },
  {
    zip: "35958",
    ST: "AL",
    cityWithStateAbbr: "Bryant, AL",
  },
  {
    zip: "35959",
    ST: "AL",
    cityWithStateAbbr: "Cedar Bluff, AL",
  },
  {
    zip: "35960",
    ST: "AL",
    cityWithStateAbbr: "Centre, AL",
  },
  {
    zip: "35961",
    ST: "AL",
    cityWithStateAbbr: "Collinsville, AL",
  },
  {
    zip: "35962",
    ST: "AL",
    cityWithStateAbbr: "Crossville, AL",
  },
  {
    zip: "35963",
    ST: "AL",
    cityWithStateAbbr: "Dawson, AL",
  },
  {
    zip: "35964",
    ST: "AL",
    cityWithStateAbbr: "Douglas, AL",
  },
  {
    zip: "35966",
    ST: "AL",
    cityWithStateAbbr: "Flat Rock, AL",
  },
  {
    zip: "35967",
    ST: "AL",
    cityWithStateAbbr: "Fort Payne, AL",
  },
  {
    zip: "35968",
    ST: "AL",
    cityWithStateAbbr: "Fort Payne, AL",
  },
  {
    zip: "35971",
    ST: "AL",
    cityWithStateAbbr: "Fyffe, AL",
  },
  {
    zip: "35972",
    ST: "AL",
    cityWithStateAbbr: "Gallant, AL",
  },
  {
    zip: "35973",
    ST: "AL",
    cityWithStateAbbr: "Gaylesville, AL",
  },
  {
    zip: "35974",
    ST: "AL",
    cityWithStateAbbr: "Geraldine, AL",
  },
  {
    zip: "35975",
    ST: "AL",
    cityWithStateAbbr: "Groveoak, AL",
  },
  {
    zip: "35976",
    ST: "AL",
    cityWithStateAbbr: "Guntersville, AL",
  },
  {
    zip: "35978",
    ST: "AL",
    cityWithStateAbbr: "Henagar, AL",
  },
  {
    zip: "35979",
    ST: "AL",
    cityWithStateAbbr: "Higdon, AL",
  },
  {
    zip: "35980",
    ST: "AL",
    cityWithStateAbbr: "Horton, AL",
  },
  {
    zip: "35981",
    ST: "AL",
    cityWithStateAbbr: "Ider, AL",
  },
  {
    zip: "35983",
    ST: "AL",
    cityWithStateAbbr: "Leesburg, AL",
  },
  {
    zip: "35984",
    ST: "AL",
    cityWithStateAbbr: "Mentone, AL",
  },
  {
    zip: "35986",
    ST: "AL",
    cityWithStateAbbr: "Rainsville, AL",
  },
  {
    zip: "35987",
    ST: "AL",
    cityWithStateAbbr: "Steele, AL",
  },
  {
    zip: "35988",
    ST: "AL",
    cityWithStateAbbr: "Sylvania, AL",
  },
  {
    zip: "35989",
    ST: "AL",
    cityWithStateAbbr: "Valley Head, AL",
  },
  {
    zip: "35990",
    ST: "AL",
    cityWithStateAbbr: "Walnut Grove, AL",
  },
  {
    zip: "36003",
    ST: "AL",
    cityWithStateAbbr: "Autaugaville, AL",
  },
  {
    zip: "36005",
    ST: "AL",
    cityWithStateAbbr: "Banks, AL",
  },
  {
    zip: "36006",
    ST: "AL",
    cityWithStateAbbr: "Billingsley, AL",
  },
  {
    zip: "36008",
    ST: "AL",
    cityWithStateAbbr: "Booth, AL",
  },
  {
    zip: "36009",
    ST: "AL",
    cityWithStateAbbr: "Brantley, AL",
  },
  {
    zip: "36010",
    ST: "AL",
    cityWithStateAbbr: "Brundidge, AL",
  },
  {
    zip: "36013",
    ST: "AL",
    cityWithStateAbbr: "Cecil, AL",
  },
  {
    zip: "36015",
    ST: "AL",
    cityWithStateAbbr: "Chapman, AL",
  },
  {
    zip: "36016",
    ST: "AL",
    cityWithStateAbbr: "Clayton, AL",
  },
  {
    zip: "36017",
    ST: "AL",
    cityWithStateAbbr: "Clio, AL",
  },
  {
    zip: "36020",
    ST: "AL",
    cityWithStateAbbr: "Coosada, AL",
  },
  {
    zip: "36022",
    ST: "AL",
    cityWithStateAbbr: "Deatsville, AL",
  },
  {
    zip: "36023",
    ST: "AL",
    cityWithStateAbbr: "East Tallassee, AL",
  },
  {
    zip: "36024",
    ST: "AL",
    cityWithStateAbbr: "Eclectic, AL",
  },
  {
    zip: "36025",
    ST: "AL",
    cityWithStateAbbr: "Elmore, AL",
  },
  {
    zip: "36026",
    ST: "AL",
    cityWithStateAbbr: "Equality, AL",
  },
  {
    zip: "36027",
    ST: "AL",
    cityWithStateAbbr: "Eufaula, AL",
  },
  {
    zip: "36028",
    ST: "AL",
    cityWithStateAbbr: "Dozier, AL",
  },
  {
    zip: "36029",
    ST: "AL",
    cityWithStateAbbr: "Fitzpatrick, AL",
  },
  {
    zip: "36030",
    ST: "AL",
    cityWithStateAbbr: "Forest Home, AL",
  },
  {
    zip: "36031",
    ST: "AL",
    cityWithStateAbbr: "Fort Davis, AL",
  },
  {
    zip: "36032",
    ST: "AL",
    cityWithStateAbbr: "Fort Deposit, AL",
  },
  {
    zip: "36033",
    ST: "AL",
    cityWithStateAbbr: "Georgiana, AL",
  },
  {
    zip: "36034",
    ST: "AL",
    cityWithStateAbbr: "Glenwood, AL",
  },
  {
    zip: "36035",
    ST: "AL",
    cityWithStateAbbr: "Goshen, AL",
  },
  {
    zip: "36036",
    ST: "AL",
    cityWithStateAbbr: "Grady, AL",
  },
  {
    zip: "36037",
    ST: "AL",
    cityWithStateAbbr: "Greenville, AL",
  },
  {
    zip: "36038",
    ST: "AL",
    cityWithStateAbbr: "Gantt, AL",
  },
  {
    zip: "36039",
    ST: "AL",
    cityWithStateAbbr: "Hardaway, AL",
  },
  {
    zip: "36040",
    ST: "AL",
    cityWithStateAbbr: "Hayneville, AL",
  },
  {
    zip: "36041",
    ST: "AL",
    cityWithStateAbbr: "Highland Home, AL",
  },
  {
    zip: "36042",
    ST: "AL",
    cityWithStateAbbr: "Honoraville, AL",
  },
  {
    zip: "36043",
    ST: "AL",
    cityWithStateAbbr: "Hope Hull, AL",
  },
  {
    zip: "36045",
    ST: "AL",
    cityWithStateAbbr: "Kent, AL",
  },
  {
    zip: "36046",
    ST: "AL",
    cityWithStateAbbr: "Lapine, AL",
  },
  {
    zip: "36047",
    ST: "AL",
    cityWithStateAbbr: "Letohatchee, AL",
  },
  {
    zip: "36048",
    ST: "AL",
    cityWithStateAbbr: "Louisville, AL",
  },
  {
    zip: "36049",
    ST: "AL",
    cityWithStateAbbr: "Luverne, AL",
  },
  {
    zip: "36051",
    ST: "AL",
    cityWithStateAbbr: "Marbury, AL",
  },
  {
    zip: "36052",
    ST: "AL",
    cityWithStateAbbr: "Mathews, AL",
  },
  {
    zip: "36053",
    ST: "AL",
    cityWithStateAbbr: "Midway, AL",
  },
  {
    zip: "36054",
    ST: "AL",
    cityWithStateAbbr: "Millbrook, AL",
  },
  {
    zip: "36057",
    ST: "AL",
    cityWithStateAbbr: "Mount Meigs, AL",
  },
  {
    zip: "36061",
    ST: "AL",
    cityWithStateAbbr: "Perote, AL",
  },
  {
    zip: "36062",
    ST: "AL",
    cityWithStateAbbr: "Petrey, AL",
  },
  {
    zip: "36064",
    ST: "AL",
    cityWithStateAbbr: "Pike Road, AL",
  },
  {
    zip: "36065",
    ST: "AL",
    cityWithStateAbbr: "Pine Level, AL",
  },
  {
    zip: "36066",
    ST: "AL",
    cityWithStateAbbr: "Prattville, AL",
  },
  {
    zip: "36067",
    ST: "AL",
    cityWithStateAbbr: "Prattville, AL",
  },
  {
    zip: "36068",
    ST: "AL",
    cityWithStateAbbr: "Prattville, AL",
  },
  {
    zip: "36069",
    ST: "AL",
    cityWithStateAbbr: "Ramer, AL",
  },
  {
    zip: "36071",
    ST: "AL",
    cityWithStateAbbr: "Rutledge, AL",
  },
  {
    zip: "36072",
    ST: "AL",
    cityWithStateAbbr: "Eufaula, AL",
  },
  {
    zip: "36075",
    ST: "AL",
    cityWithStateAbbr: "Shorter, AL",
  },
  {
    zip: "36078",
    ST: "AL",
    cityWithStateAbbr: "Tallassee, AL",
  },
  {
    zip: "36079",
    ST: "AL",
    cityWithStateAbbr: "Troy, AL",
  },
  {
    zip: "36080",
    ST: "AL",
    cityWithStateAbbr: "Titus, AL",
  },
  {
    zip: "36081",
    ST: "AL",
    cityWithStateAbbr: "Troy, AL",
  },
  {
    zip: "36082",
    ST: "AL",
    cityWithStateAbbr: "Troy, AL",
  },
  {
    zip: "36083",
    ST: "AL",
    cityWithStateAbbr: "Tuskegee, AL",
  },
  {
    zip: "36087",
    ST: "AL",
    cityWithStateAbbr: "Tuskegee Institute, AL",
  },
  {
    zip: "36088",
    ST: "AL",
    cityWithStateAbbr: "Tuskegee Institute, AL",
  },
  {
    zip: "36089",
    ST: "AL",
    cityWithStateAbbr: "Union Springs, AL",
  },
  {
    zip: "36091",
    ST: "AL",
    cityWithStateAbbr: "Verbena, AL",
  },
  {
    zip: "36092",
    ST: "AL",
    cityWithStateAbbr: "Wetumpka, AL",
  },
  {
    zip: "36093",
    ST: "AL",
    cityWithStateAbbr: "Wetumpka, AL",
  },
  {
    zip: "36101",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36102",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36103",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36104",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36105",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36106",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36107",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36108",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36109",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36110",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36111",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36112",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36113",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36114",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36115",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36116",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36117",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36118",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36119",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36120",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36121",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36123",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36124",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36125",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36130",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36131",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36132",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36133",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36134",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36135",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36140",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36141",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36142",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36177",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36191",
    ST: "AL",
    cityWithStateAbbr: "Montgomery, AL",
  },
  {
    zip: "36201",
    ST: "AL",
    cityWithStateAbbr: "Anniston, AL",
  },
  {
    zip: "36202",
    ST: "AL",
    cityWithStateAbbr: "Anniston, AL",
  },
  {
    zip: "36203",
    ST: "AL",
    cityWithStateAbbr: "Oxford, AL",
  },
  {
    zip: "36204",
    ST: "AL",
    cityWithStateAbbr: "Anniston, AL",
  },
  {
    zip: "36205",
    ST: "AL",
    cityWithStateAbbr: "Anniston, AL",
  },
  {
    zip: "36206",
    ST: "AL",
    cityWithStateAbbr: "Anniston, AL",
  },
  {
    zip: "36207",
    ST: "AL",
    cityWithStateAbbr: "Anniston, AL",
  },
  {
    zip: "36250",
    ST: "AL",
    cityWithStateAbbr: "Alexandria, AL",
  },
  {
    zip: "36251",
    ST: "AL",
    cityWithStateAbbr: "Ashland, AL",
  },
  {
    zip: "36253",
    ST: "AL",
    cityWithStateAbbr: "Bynum, AL",
  },
  {
    zip: "36254",
    ST: "AL",
    cityWithStateAbbr: "Choccolocco, AL",
  },
  {
    zip: "36255",
    ST: "AL",
    cityWithStateAbbr: "Cragford, AL",
  },
  {
    zip: "36256",
    ST: "AL",
    cityWithStateAbbr: "Daviston, AL",
  },
  {
    zip: "36257",
    ST: "AL",
    cityWithStateAbbr: "De Armanville, AL",
  },
  {
    zip: "36258",
    ST: "AL",
    cityWithStateAbbr: "Delta, AL",
  },
  {
    zip: "36260",
    ST: "AL",
    cityWithStateAbbr: "Eastaboga, AL",
  },
  {
    zip: "36261",
    ST: "AL",
    cityWithStateAbbr: "Edwardsville, AL",
  },
  {
    zip: "36262",
    ST: "AL",
    cityWithStateAbbr: "Fruithurst, AL",
  },
  {
    zip: "36263",
    ST: "AL",
    cityWithStateAbbr: "Graham, AL",
  },
  {
    zip: "36264",
    ST: "AL",
    cityWithStateAbbr: "Heflin, AL",
  },
  {
    zip: "36265",
    ST: "AL",
    cityWithStateAbbr: "Jacksonville, AL",
  },
  {
    zip: "36266",
    ST: "AL",
    cityWithStateAbbr: "Lineville, AL",
  },
  {
    zip: "36267",
    ST: "AL",
    cityWithStateAbbr: "Millerville, AL",
  },
  {
    zip: "36268",
    ST: "AL",
    cityWithStateAbbr: "Munford, AL",
  },
  {
    zip: "36269",
    ST: "AL",
    cityWithStateAbbr: "Muscadine, AL",
  },
  {
    zip: "36271",
    ST: "AL",
    cityWithStateAbbr: "Ohatchee, AL",
  },
  {
    zip: "36272",
    ST: "AL",
    cityWithStateAbbr: "Piedmont, AL",
  },
  {
    zip: "36273",
    ST: "AL",
    cityWithStateAbbr: "Ranburne, AL",
  },
  {
    zip: "36274",
    ST: "AL",
    cityWithStateAbbr: "Roanoke, AL",
  },
  {
    zip: "36275",
    ST: "AL",
    cityWithStateAbbr: "Spring Garden, AL",
  },
  {
    zip: "36276",
    ST: "AL",
    cityWithStateAbbr: "Wadley, AL",
  },
  {
    zip: "36277",
    ST: "AL",
    cityWithStateAbbr: "Weaver, AL",
  },
  {
    zip: "36278",
    ST: "AL",
    cityWithStateAbbr: "Wedowee, AL",
  },
  {
    zip: "36279",
    ST: "AL",
    cityWithStateAbbr: "Wellington, AL",
  },
  {
    zip: "36280",
    ST: "AL",
    cityWithStateAbbr: "Woodland, AL",
  },
  {
    zip: "36301",
    ST: "AL",
    cityWithStateAbbr: "Dothan, AL",
  },
  {
    zip: "36302",
    ST: "AL",
    cityWithStateAbbr: "Dothan, AL",
  },
  {
    zip: "36303",
    ST: "AL",
    cityWithStateAbbr: "Dothan, AL",
  },
  {
    zip: "36304",
    ST: "AL",
    cityWithStateAbbr: "Dothan, AL",
  },
  {
    zip: "36305",
    ST: "AL",
    cityWithStateAbbr: "Dothan, AL",
  },
  {
    zip: "36310",
    ST: "AL",
    cityWithStateAbbr: "Abbeville, AL",
  },
  {
    zip: "36311",
    ST: "AL",
    cityWithStateAbbr: "Ariton, AL",
  },
  {
    zip: "36312",
    ST: "AL",
    cityWithStateAbbr: "Ashford, AL",
  },
  {
    zip: "36313",
    ST: "AL",
    cityWithStateAbbr: "Bellwood, AL",
  },
  {
    zip: "36314",
    ST: "AL",
    cityWithStateAbbr: "Black, AL",
  },
  {
    zip: "36316",
    ST: "AL",
    cityWithStateAbbr: "Chancellor, AL",
  },
  {
    zip: "36317",
    ST: "AL",
    cityWithStateAbbr: "Clopton, AL",
  },
  {
    zip: "36318",
    ST: "AL",
    cityWithStateAbbr: "Coffee Springs, AL",
  },
  {
    zip: "36319",
    ST: "AL",
    cityWithStateAbbr: "Columbia, AL",
  },
  {
    zip: "36320",
    ST: "AL",
    cityWithStateAbbr: "Cottonwood, AL",
  },
  {
    zip: "36321",
    ST: "AL",
    cityWithStateAbbr: "Cowarts, AL",
  },
  {
    zip: "36322",
    ST: "AL",
    cityWithStateAbbr: "Daleville, AL",
  },
  {
    zip: "36323",
    ST: "AL",
    cityWithStateAbbr: "Elba, AL",
  },
  {
    zip: "36330",
    ST: "AL",
    cityWithStateAbbr: "Enterprise, AL",
  },
  {
    zip: "36331",
    ST: "AL",
    cityWithStateAbbr: "Enterprise, AL",
  },
  {
    zip: "36340",
    ST: "AL",
    cityWithStateAbbr: "Geneva, AL",
  },
  {
    zip: "36343",
    ST: "AL",
    cityWithStateAbbr: "Gordon, AL",
  },
  {
    zip: "36344",
    ST: "AL",
    cityWithStateAbbr: "Hartford, AL",
  },
  {
    zip: "36345",
    ST: "AL",
    cityWithStateAbbr: "Headland, AL",
  },
  {
    zip: "36346",
    ST: "AL",
    cityWithStateAbbr: "Jack, AL",
  },
  {
    zip: "36349",
    ST: "AL",
    cityWithStateAbbr: "Malvern, AL",
  },
  {
    zip: "36350",
    ST: "AL",
    cityWithStateAbbr: "Midland City, AL",
  },
  {
    zip: "36351",
    ST: "AL",
    cityWithStateAbbr: "New Brockton, AL",
  },
  {
    zip: "36352",
    ST: "AL",
    cityWithStateAbbr: "Newton, AL",
  },
  {
    zip: "36353",
    ST: "AL",
    cityWithStateAbbr: "Newville, AL",
  },
  {
    zip: "36360",
    ST: "AL",
    cityWithStateAbbr: "Ozark, AL",
  },
  {
    zip: "36361",
    ST: "AL",
    cityWithStateAbbr: "Ozark, AL",
  },
  {
    zip: "36362",
    ST: "AL",
    cityWithStateAbbr: "Fort Rucker, AL",
  },
  {
    zip: "36370",
    ST: "AL",
    cityWithStateAbbr: "Pansey, AL",
  },
  {
    zip: "36371",
    ST: "AL",
    cityWithStateAbbr: "Pinckard, AL",
  },
  {
    zip: "36373",
    ST: "AL",
    cityWithStateAbbr: "Shorterville, AL",
  },
  {
    zip: "36374",
    ST: "AL",
    cityWithStateAbbr: "Skipperville, AL",
  },
  {
    zip: "36375",
    ST: "AL",
    cityWithStateAbbr: "Slocomb, AL",
  },
  {
    zip: "36376",
    ST: "AL",
    cityWithStateAbbr: "Webb, AL",
  },
  {
    zip: "36401",
    ST: "AL",
    cityWithStateAbbr: "Evergreen, AL",
  },
  {
    zip: "36420",
    ST: "AL",
    cityWithStateAbbr: "Andalusia, AL",
  },
  {
    zip: "36421",
    ST: "AL",
    cityWithStateAbbr: "Andalusia, AL",
  },
  {
    zip: "36425",
    ST: "AL",
    cityWithStateAbbr: "Beatrice, AL",
  },
  {
    zip: "36426",
    ST: "AL",
    cityWithStateAbbr: "Brewton, AL",
  },
  {
    zip: "36427",
    ST: "AL",
    cityWithStateAbbr: "Brewton, AL",
  },
  {
    zip: "36429",
    ST: "AL",
    cityWithStateAbbr: "Brooklyn, AL",
  },
  {
    zip: "36432",
    ST: "AL",
    cityWithStateAbbr: "Castleberry, AL",
  },
  {
    zip: "36435",
    ST: "AL",
    cityWithStateAbbr: "Coy, AL",
  },
  {
    zip: "36436",
    ST: "AL",
    cityWithStateAbbr: "Dickinson, AL",
  },
  {
    zip: "36439",
    ST: "AL",
    cityWithStateAbbr: "Excel, AL",
  },
  {
    zip: "36441",
    ST: "AL",
    cityWithStateAbbr: "Flomaton, AL",
  },
  {
    zip: "36442",
    ST: "AL",
    cityWithStateAbbr: "Florala, AL",
  },
  {
    zip: "36444",
    ST: "AL",
    cityWithStateAbbr: "Franklin, AL",
  },
  {
    zip: "36445",
    ST: "AL",
    cityWithStateAbbr: "Frisco City, AL",
  },
  {
    zip: "36446",
    ST: "AL",
    cityWithStateAbbr: "Fulton, AL",
  },
  {
    zip: "36449",
    ST: "AL",
    cityWithStateAbbr: "Uriah, AL",
  },
  {
    zip: "36451",
    ST: "AL",
    cityWithStateAbbr: "Grove Hill, AL",
  },
  {
    zip: "36453",
    ST: "AL",
    cityWithStateAbbr: "Kinston, AL",
  },
  {
    zip: "36454",
    ST: "AL",
    cityWithStateAbbr: "Lenox, AL",
  },
  {
    zip: "36455",
    ST: "AL",
    cityWithStateAbbr: "Lockhart, AL",
  },
  {
    zip: "36456",
    ST: "AL",
    cityWithStateAbbr: "Mc Kenzie, AL",
  },
  {
    zip: "36457",
    ST: "AL",
    cityWithStateAbbr: "Megargel, AL",
  },
  {
    zip: "36458",
    ST: "AL",
    cityWithStateAbbr: "Mexia, AL",
  },
  {
    zip: "36460",
    ST: "AL",
    cityWithStateAbbr: "Monroeville, AL",
  },
  {
    zip: "36461",
    ST: "AL",
    cityWithStateAbbr: "Monroeville, AL",
  },
  {
    zip: "36462",
    ST: "AL",
    cityWithStateAbbr: "Monroeville, AL",
  },
  {
    zip: "36467",
    ST: "AL",
    cityWithStateAbbr: "Opp, AL",
  },
  {
    zip: "36470",
    ST: "AL",
    cityWithStateAbbr: "Perdue Hill, AL",
  },
  {
    zip: "36471",
    ST: "AL",
    cityWithStateAbbr: "Peterman, AL",
  },
  {
    zip: "36473",
    ST: "AL",
    cityWithStateAbbr: "Range, AL",
  },
  {
    zip: "36474",
    ST: "AL",
    cityWithStateAbbr: "Red Level, AL",
  },
  {
    zip: "36475",
    ST: "AL",
    cityWithStateAbbr: "Repton, AL",
  },
  {
    zip: "36476",
    ST: "AL",
    cityWithStateAbbr: "River Falls, AL",
  },
  {
    zip: "36477",
    ST: "AL",
    cityWithStateAbbr: "Samson, AL",
  },
  {
    zip: "36480",
    ST: "AL",
    cityWithStateAbbr: "Uriah, AL",
  },
  {
    zip: "36481",
    ST: "AL",
    cityWithStateAbbr: "Vredenburgh, AL",
  },
  {
    zip: "36482",
    ST: "AL",
    cityWithStateAbbr: "Whatley, AL",
  },
  {
    zip: "36483",
    ST: "AL",
    cityWithStateAbbr: "Wing, AL",
  },
  {
    zip: "36501",
    ST: "AL",
    cityWithStateAbbr: "Alma, AL",
  },
  {
    zip: "36502",
    ST: "AL",
    cityWithStateAbbr: "Atmore, AL",
  },
  {
    zip: "36503",
    ST: "AL",
    cityWithStateAbbr: "Atmore, AL",
  },
  {
    zip: "36504",
    ST: "AL",
    cityWithStateAbbr: "Atmore, AL",
  },
  {
    zip: "36505",
    ST: "AL",
    cityWithStateAbbr: "Axis, AL",
  },
  {
    zip: "36507",
    ST: "AL",
    cityWithStateAbbr: "Bay Minette, AL",
  },
  {
    zip: "36509",
    ST: "AL",
    cityWithStateAbbr: "Bayou La Batre, AL",
  },
  {
    zip: "36511",
    ST: "AL",
    cityWithStateAbbr: "Bon Secour, AL",
  },
  {
    zip: "36512",
    ST: "AL",
    cityWithStateAbbr: "Bucks, AL",
  },
  {
    zip: "36513",
    ST: "AL",
    cityWithStateAbbr: "Calvert, AL",
  },
  {
    zip: "36515",
    ST: "AL",
    cityWithStateAbbr: "Carlton, AL",
  },
  {
    zip: "36518",
    ST: "AL",
    cityWithStateAbbr: "Chatom, AL",
  },
  {
    zip: "36521",
    ST: "AL",
    cityWithStateAbbr: "Chunchula, AL",
  },
  {
    zip: "36522",
    ST: "AL",
    cityWithStateAbbr: "Citronelle, AL",
  },
  {
    zip: "36523",
    ST: "AL",
    cityWithStateAbbr: "Coden, AL",
  },
  {
    zip: "36524",
    ST: "AL",
    cityWithStateAbbr: "Coffeeville, AL",
  },
  {
    zip: "36525",
    ST: "AL",
    cityWithStateAbbr: "Creola, AL",
  },
  {
    zip: "36526",
    ST: "AL",
    cityWithStateAbbr: "Daphne, AL",
  },
  {
    zip: "36527",
    ST: "AL",
    cityWithStateAbbr: "Spanish Fort, AL",
  },
  {
    zip: "36528",
    ST: "AL",
    cityWithStateAbbr: "Dauphin Island, AL",
  },
  {
    zip: "36529",
    ST: "AL",
    cityWithStateAbbr: "Deer Park, AL",
  },
  {
    zip: "36530",
    ST: "AL",
    cityWithStateAbbr: "Elberta, AL",
  },
  {
    zip: "36532",
    ST: "AL",
    cityWithStateAbbr: "Fairhope, AL",
  },
  {
    zip: "36533",
    ST: "AL",
    cityWithStateAbbr: "Fairhope, AL",
  },
  {
    zip: "36535",
    ST: "AL",
    cityWithStateAbbr: "Foley, AL",
  },
  {
    zip: "36536",
    ST: "AL",
    cityWithStateAbbr: "Foley, AL",
  },
  {
    zip: "36538",
    ST: "AL",
    cityWithStateAbbr: "Frankville, AL",
  },
  {
    zip: "36539",
    ST: "AL",
    cityWithStateAbbr: "Fruitdale, AL",
  },
  {
    zip: "36540",
    ST: "AL",
    cityWithStateAbbr: "Gainestown, AL",
  },
  {
    zip: "36541",
    ST: "AL",
    cityWithStateAbbr: "Grand Bay, AL",
  },
  {
    zip: "36542",
    ST: "AL",
    cityWithStateAbbr: "Gulf Shores, AL",
  },
  {
    zip: "36543",
    ST: "AL",
    cityWithStateAbbr: "Huxford, AL",
  },
  {
    zip: "36544",
    ST: "AL",
    cityWithStateAbbr: "Irvington, AL",
  },
  {
    zip: "36545",
    ST: "AL",
    cityWithStateAbbr: "Jackson, AL",
  },
  {
    zip: "36547",
    ST: "AL",
    cityWithStateAbbr: "Gulf Shores, AL",
  },
  {
    zip: "36548",
    ST: "AL",
    cityWithStateAbbr: "Leroy, AL",
  },
  {
    zip: "36549",
    ST: "AL",
    cityWithStateAbbr: "Lillian, AL",
  },
  {
    zip: "36550",
    ST: "AL",
    cityWithStateAbbr: "Little River, AL",
  },
  {
    zip: "36551",
    ST: "AL",
    cityWithStateAbbr: "Loxley, AL",
  },
  {
    zip: "36553",
    ST: "AL",
    cityWithStateAbbr: "Mc Intosh, AL",
  },
  {
    zip: "36555",
    ST: "AL",
    cityWithStateAbbr: "Magnolia Springs, AL",
  },
  {
    zip: "36556",
    ST: "AL",
    cityWithStateAbbr: "Malcolm, AL",
  },
  {
    zip: "36558",
    ST: "AL",
    cityWithStateAbbr: "Millry, AL",
  },
  {
    zip: "36559",
    ST: "AL",
    cityWithStateAbbr: "Montrose, AL",
  },
  {
    zip: "36560",
    ST: "AL",
    cityWithStateAbbr: "Mount Vernon, AL",
  },
  {
    zip: "36561",
    ST: "AL",
    cityWithStateAbbr: "Orange Beach, AL",
  },
  {
    zip: "36562",
    ST: "AL",
    cityWithStateAbbr: "Perdido, AL",
  },
  {
    zip: "36564",
    ST: "AL",
    cityWithStateAbbr: "Point Clear, AL",
  },
  {
    zip: "36567",
    ST: "AL",
    cityWithStateAbbr: "Robertsdale, AL",
  },
  {
    zip: "36568",
    ST: "AL",
    cityWithStateAbbr: "Saint Elmo, AL",
  },
  {
    zip: "36569",
    ST: "AL",
    cityWithStateAbbr: "Saint Stephens, AL",
  },
  {
    zip: "36571",
    ST: "AL",
    cityWithStateAbbr: "Saraland, AL",
  },
  {
    zip: "36572",
    ST: "AL",
    cityWithStateAbbr: "Satsuma, AL",
  },
  {
    zip: "36574",
    ST: "AL",
    cityWithStateAbbr: "Seminole, AL",
  },
  {
    zip: "36575",
    ST: "AL",
    cityWithStateAbbr: "Semmes, AL",
  },
  {
    zip: "36576",
    ST: "AL",
    cityWithStateAbbr: "Silverhill, AL",
  },
  {
    zip: "36577",
    ST: "AL",
    cityWithStateAbbr: "Spanish Fort, AL",
  },
  {
    zip: "36578",
    ST: "AL",
    cityWithStateAbbr: "Stapleton, AL",
  },
  {
    zip: "36579",
    ST: "AL",
    cityWithStateAbbr: "Stockton, AL",
  },
  {
    zip: "36580",
    ST: "AL",
    cityWithStateAbbr: "Summerdale, AL",
  },
  {
    zip: "36581",
    ST: "AL",
    cityWithStateAbbr: "Sunflower, AL",
  },
  {
    zip: "36582",
    ST: "AL",
    cityWithStateAbbr: "Theodore, AL",
  },
  {
    zip: "36583",
    ST: "AL",
    cityWithStateAbbr: "Tibbie, AL",
  },
  {
    zip: "36584",
    ST: "AL",
    cityWithStateAbbr: "Vinegar Bend, AL",
  },
  {
    zip: "36585",
    ST: "AL",
    cityWithStateAbbr: "Wagarville, AL",
  },
  {
    zip: "36587",
    ST: "AL",
    cityWithStateAbbr: "Wilmer, AL",
  },
  {
    zip: "36590",
    ST: "AL",
    cityWithStateAbbr: "Theodore, AL",
  },
  {
    zip: "36601",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36602",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36603",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36604",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36605",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36606",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36607",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36608",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36609",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36610",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36611",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36612",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36613",
    ST: "AL",
    cityWithStateAbbr: "Eight Mile, AL",
  },
  {
    zip: "36615",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36616",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36617",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36618",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36619",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36625",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36628",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36630",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36633",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36640",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36641",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36644",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36652",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36660",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36663",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36670",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36671",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36675",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36685",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36688",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36689",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36691",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36693",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36695",
    ST: "AL",
    cityWithStateAbbr: "Mobile, AL",
  },
  {
    zip: "36701",
    ST: "AL",
    cityWithStateAbbr: "Selma, AL",
  },
  {
    zip: "36702",
    ST: "AL",
    cityWithStateAbbr: "Selma, AL",
  },
  {
    zip: "36703",
    ST: "AL",
    cityWithStateAbbr: "Selma, AL",
  },
  {
    zip: "36720",
    ST: "AL",
    cityWithStateAbbr: "Alberta, AL",
  },
  {
    zip: "36721",
    ST: "AL",
    cityWithStateAbbr: "Annemanie, AL",
  },
  {
    zip: "36722",
    ST: "AL",
    cityWithStateAbbr: "Arlington, AL",
  },
  {
    zip: "36723",
    ST: "AL",
    cityWithStateAbbr: "Boykin, AL",
  },
  {
    zip: "36726",
    ST: "AL",
    cityWithStateAbbr: "Camden, AL",
  },
  {
    zip: "36727",
    ST: "AL",
    cityWithStateAbbr: "Campbell, AL",
  },
  {
    zip: "36728",
    ST: "AL",
    cityWithStateAbbr: "Catherine, AL",
  },
  {
    zip: "36732",
    ST: "AL",
    cityWithStateAbbr: "Demopolis, AL",
  },
  {
    zip: "36736",
    ST: "AL",
    cityWithStateAbbr: "Dixons Mills, AL",
  },
  {
    zip: "36738",
    ST: "AL",
    cityWithStateAbbr: "Faunsdale, AL",
  },
  {
    zip: "36740",
    ST: "AL",
    cityWithStateAbbr: "Forkland, AL",
  },
  {
    zip: "36741",
    ST: "AL",
    cityWithStateAbbr: "Furman, AL",
  },
  {
    zip: "36742",
    ST: "AL",
    cityWithStateAbbr: "Gallion, AL",
  },
  {
    zip: "36744",
    ST: "AL",
    cityWithStateAbbr: "Greensboro, AL",
  },
  {
    zip: "36745",
    ST: "AL",
    cityWithStateAbbr: "Jefferson, AL",
  },
  {
    zip: "36748",
    ST: "AL",
    cityWithStateAbbr: "Linden, AL",
  },
  {
    zip: "36749",
    ST: "AL",
    cityWithStateAbbr: "Jones, AL",
  },
  {
    zip: "36750",
    ST: "AL",
    cityWithStateAbbr: "Maplesville, AL",
  },
  {
    zip: "36751",
    ST: "AL",
    cityWithStateAbbr: "Lower Peach Tree, AL",
  },
  {
    zip: "36752",
    ST: "AL",
    cityWithStateAbbr: "Lowndesboro, AL",
  },
  {
    zip: "36753",
    ST: "AL",
    cityWithStateAbbr: "Mc Williams, AL",
  },
  {
    zip: "36754",
    ST: "AL",
    cityWithStateAbbr: "Magnolia, AL",
  },
  {
    zip: "36756",
    ST: "AL",
    cityWithStateAbbr: "Marion, AL",
  },
  {
    zip: "36758",
    ST: "AL",
    cityWithStateAbbr: "Plantersville, AL",
  },
  {
    zip: "36759",
    ST: "AL",
    cityWithStateAbbr: "Marion Junction, AL",
  },
  {
    zip: "36761",
    ST: "AL",
    cityWithStateAbbr: "Minter, AL",
  },
  {
    zip: "36762",
    ST: "AL",
    cityWithStateAbbr: "Thomasville, AL",
  },
  {
    zip: "36763",
    ST: "AL",
    cityWithStateAbbr: "Myrtlewood, AL",
  },
  {
    zip: "36764",
    ST: "AL",
    cityWithStateAbbr: "Nanafalia, AL",
  },
  {
    zip: "36765",
    ST: "AL",
    cityWithStateAbbr: "Newbern, AL",
  },
  {
    zip: "36766",
    ST: "AL",
    cityWithStateAbbr: "Oak Hill, AL",
  },
  {
    zip: "36767",
    ST: "AL",
    cityWithStateAbbr: "Orrville, AL",
  },
  {
    zip: "36768",
    ST: "AL",
    cityWithStateAbbr: "Pine Apple, AL",
  },
  {
    zip: "36769",
    ST: "AL",
    cityWithStateAbbr: "Pine Hill, AL",
  },
  {
    zip: "36773",
    ST: "AL",
    cityWithStateAbbr: "Safford, AL",
  },
  {
    zip: "36775",
    ST: "AL",
    cityWithStateAbbr: "Sardis, AL",
  },
  {
    zip: "36776",
    ST: "AL",
    cityWithStateAbbr: "Sawyerville, AL",
  },
  {
    zip: "36782",
    ST: "AL",
    cityWithStateAbbr: "Sweet Water, AL",
  },
  {
    zip: "36783",
    ST: "AL",
    cityWithStateAbbr: "Thomaston, AL",
  },
  {
    zip: "36784",
    ST: "AL",
    cityWithStateAbbr: "Thomasville, AL",
  },
  {
    zip: "36785",
    ST: "AL",
    cityWithStateAbbr: "Tyler, AL",
  },
  {
    zip: "36786",
    ST: "AL",
    cityWithStateAbbr: "Uniontown, AL",
  },
  {
    zip: "36790",
    ST: "AL",
    cityWithStateAbbr: "Stanton, AL",
  },
  {
    zip: "36792",
    ST: "AL",
    cityWithStateAbbr: "Randolph, AL",
  },
  {
    zip: "36793",
    ST: "AL",
    cityWithStateAbbr: "Lawley, AL",
  },
  {
    zip: "36801",
    ST: "AL",
    cityWithStateAbbr: "Opelika, AL",
  },
  {
    zip: "36802",
    ST: "AL",
    cityWithStateAbbr: "Opelika, AL",
  },
  {
    zip: "36803",
    ST: "AL",
    cityWithStateAbbr: "Opelika, AL",
  },
  {
    zip: "36804",
    ST: "AL",
    cityWithStateAbbr: "Opelika, AL",
  },
  {
    zip: "36830",
    ST: "AL",
    cityWithStateAbbr: "Auburn, AL",
  },
  {
    zip: "36831",
    ST: "AL",
    cityWithStateAbbr: "Auburn, AL",
  },
  {
    zip: "36832",
    ST: "AL",
    cityWithStateAbbr: "Auburn, AL",
  },
  {
    zip: "36849",
    ST: "AL",
    cityWithStateAbbr: "Auburn University, AL",
  },
  {
    zip: "36850",
    ST: "AL",
    cityWithStateAbbr: "Camp Hill, AL",
  },
  {
    zip: "36851",
    ST: "AL",
    cityWithStateAbbr: "Cottonton, AL",
  },
  {
    zip: "36852",
    ST: "AL",
    cityWithStateAbbr: "Cusseta, AL",
  },
  {
    zip: "36853",
    ST: "AL",
    cityWithStateAbbr: "Dadeville, AL",
  },
  {
    zip: "36854",
    ST: "AL",
    cityWithStateAbbr: "Valley, AL",
  },
  {
    zip: "36855",
    ST: "AL",
    cityWithStateAbbr: "Five Points, AL",
  },
  {
    zip: "36856",
    ST: "AL",
    cityWithStateAbbr: "Fort Mitchell, AL",
  },
  {
    zip: "36858",
    ST: "AL",
    cityWithStateAbbr: "Hatchechubbee, AL",
  },
  {
    zip: "36859",
    ST: "AL",
    cityWithStateAbbr: "Holy Trinity, AL",
  },
  {
    zip: "36860",
    ST: "AL",
    cityWithStateAbbr: "Hurtsboro, AL",
  },
  {
    zip: "36861",
    ST: "AL",
    cityWithStateAbbr: "Jacksons Gap, AL",
  },
  {
    zip: "36862",
    ST: "AL",
    cityWithStateAbbr: "Lafayette, AL",
  },
  {
    zip: "36863",
    ST: "AL",
    cityWithStateAbbr: "Lanett, AL",
  },
  {
    zip: "36865",
    ST: "AL",
    cityWithStateAbbr: "Loachapoka, AL",
  },
  {
    zip: "36866",
    ST: "AL",
    cityWithStateAbbr: "Notasulga, AL",
  },
  {
    zip: "36867",
    ST: "AL",
    cityWithStateAbbr: "Phenix City, AL",
  },
  {
    zip: "36868",
    ST: "AL",
    cityWithStateAbbr: "Phenix City, AL",
  },
  {
    zip: "36869",
    ST: "AL",
    cityWithStateAbbr: "Phenix City, AL",
  },
  {
    zip: "36870",
    ST: "AL",
    cityWithStateAbbr: "Phenix City, AL",
  },
  {
    zip: "36871",
    ST: "AL",
    cityWithStateAbbr: "Pittsview, AL",
  },
  {
    zip: "36872",
    ST: "AL",
    cityWithStateAbbr: "Valley, AL",
  },
  {
    zip: "36874",
    ST: "AL",
    cityWithStateAbbr: "Salem, AL",
  },
  {
    zip: "36875",
    ST: "AL",
    cityWithStateAbbr: "Seale, AL",
  },
  {
    zip: "36877",
    ST: "AL",
    cityWithStateAbbr: "Smiths Station, AL",
  },
  {
    zip: "36879",
    ST: "AL",
    cityWithStateAbbr: "Waverly, AL",
  },
  {
    zip: "36901",
    ST: "AL",
    cityWithStateAbbr: "Bellamy, AL",
  },
  {
    zip: "36904",
    ST: "AL",
    cityWithStateAbbr: "Butler, AL",
  },
  {
    zip: "36907",
    ST: "AL",
    cityWithStateAbbr: "Cuba, AL",
  },
  {
    zip: "36908",
    ST: "AL",
    cityWithStateAbbr: "Gilbertown, AL",
  },
  {
    zip: "36910",
    ST: "AL",
    cityWithStateAbbr: "Jachin, AL",
  },
  {
    zip: "36912",
    ST: "AL",
    cityWithStateAbbr: "Lisman, AL",
  },
  {
    zip: "36913",
    ST: "AL",
    cityWithStateAbbr: "Melvin, AL",
  },
  {
    zip: "36915",
    ST: "AL",
    cityWithStateAbbr: "Needham, AL",
  },
  {
    zip: "36916",
    ST: "AL",
    cityWithStateAbbr: "Pennington, AL",
  },
  {
    zip: "36919",
    ST: "AL",
    cityWithStateAbbr: "Silas, AL",
  },
  {
    zip: "36921",
    ST: "AL",
    cityWithStateAbbr: "Toxey, AL",
  },
  {
    zip: "36922",
    ST: "AL",
    cityWithStateAbbr: "Ward, AL",
  },
  {
    zip: "36925",
    ST: "AL",
    cityWithStateAbbr: "York, AL",
  },
  {
    zip: "37010",
    ST: "TN",
    cityWithStateAbbr: "Adams, TN",
  },
  {
    zip: "37011",
    ST: "TN",
    cityWithStateAbbr: "Antioch, TN",
  },
  {
    zip: "37012",
    ST: "TN",
    cityWithStateAbbr: "Alexandria, TN",
  },
  {
    zip: "37013",
    ST: "TN",
    cityWithStateAbbr: "Antioch, TN",
  },
  {
    zip: "37014",
    ST: "TN",
    cityWithStateAbbr: "Arrington, TN",
  },
  {
    zip: "37015",
    ST: "TN",
    cityWithStateAbbr: "Ashland City, TN",
  },
  {
    zip: "37016",
    ST: "TN",
    cityWithStateAbbr: "Auburntown, TN",
  },
  {
    zip: "37018",
    ST: "TN",
    cityWithStateAbbr: "Beechgrove, TN",
  },
  {
    zip: "37019",
    ST: "TN",
    cityWithStateAbbr: "Belfast, TN",
  },
  {
    zip: "37020",
    ST: "TN",
    cityWithStateAbbr: "Bell Buckle, TN",
  },
  {
    zip: "37022",
    ST: "TN",
    cityWithStateAbbr: "Bethpage, TN",
  },
  {
    zip: "37023",
    ST: "TN",
    cityWithStateAbbr: "Big Rock, TN",
  },
  {
    zip: "37024",
    ST: "TN",
    cityWithStateAbbr: "Brentwood, TN",
  },
  {
    zip: "37025",
    ST: "TN",
    cityWithStateAbbr: "Bon Aqua, TN",
  },
  {
    zip: "37026",
    ST: "TN",
    cityWithStateAbbr: "Bradyville, TN",
  },
  {
    zip: "37027",
    ST: "TN",
    cityWithStateAbbr: "Brentwood, TN",
  },
  {
    zip: "37028",
    ST: "TN",
    cityWithStateAbbr: "Bumpus Mills, TN",
  },
  {
    zip: "37029",
    ST: "TN",
    cityWithStateAbbr: "Burns, TN",
  },
  {
    zip: "37030",
    ST: "TN",
    cityWithStateAbbr: "Carthage, TN",
  },
  {
    zip: "37031",
    ST: "TN",
    cityWithStateAbbr: "Castalian Springs, TN",
  },
  {
    zip: "37032",
    ST: "TN",
    cityWithStateAbbr: "Cedar Hill, TN",
  },
  {
    zip: "37033",
    ST: "TN",
    cityWithStateAbbr: "Centerville, TN",
  },
  {
    zip: "37034",
    ST: "TN",
    cityWithStateAbbr: "Chapel Hill, TN",
  },
  {
    zip: "37035",
    ST: "TN",
    cityWithStateAbbr: "Chapmansboro, TN",
  },
  {
    zip: "37036",
    ST: "TN",
    cityWithStateAbbr: "Charlotte, TN",
  },
  {
    zip: "37037",
    ST: "TN",
    cityWithStateAbbr: "Christiana, TN",
  },
  {
    zip: "37040",
    ST: "TN",
    cityWithStateAbbr: "Clarksville, TN",
  },
  {
    zip: "37041",
    ST: "TN",
    cityWithStateAbbr: "Clarksville, TN",
  },
  {
    zip: "37042",
    ST: "TN",
    cityWithStateAbbr: "Clarksville, TN",
  },
  {
    zip: "37043",
    ST: "TN",
    cityWithStateAbbr: "Clarksville, TN",
  },
  {
    zip: "37044",
    ST: "TN",
    cityWithStateAbbr: "Clarksville, TN",
  },
  {
    zip: "37046",
    ST: "TN",
    cityWithStateAbbr: "College Grove, TN",
  },
  {
    zip: "37047",
    ST: "TN",
    cityWithStateAbbr: "Cornersville, TN",
  },
  {
    zip: "37048",
    ST: "TN",
    cityWithStateAbbr: "Cottontown, TN",
  },
  {
    zip: "37049",
    ST: "TN",
    cityWithStateAbbr: "Cross Plains, TN",
  },
  {
    zip: "37050",
    ST: "TN",
    cityWithStateAbbr: "Cumberland City, TN",
  },
  {
    zip: "37051",
    ST: "TN",
    cityWithStateAbbr: "Cumberland Furnace, TN",
  },
  {
    zip: "37052",
    ST: "TN",
    cityWithStateAbbr: "Cunningham, TN",
  },
  {
    zip: "37055",
    ST: "TN",
    cityWithStateAbbr: "Dickson, TN",
  },
  {
    zip: "37056",
    ST: "TN",
    cityWithStateAbbr: "Dickson, TN",
  },
  {
    zip: "37057",
    ST: "TN",
    cityWithStateAbbr: "Dixon Springs, TN",
  },
  {
    zip: "37058",
    ST: "TN",
    cityWithStateAbbr: "Dover, TN",
  },
  {
    zip: "37059",
    ST: "TN",
    cityWithStateAbbr: "Dowelltown, TN",
  },
  {
    zip: "37060",
    ST: "TN",
    cityWithStateAbbr: "Eagleville, TN",
  },
  {
    zip: "37061",
    ST: "TN",
    cityWithStateAbbr: "Erin, TN",
  },
  {
    zip: "37062",
    ST: "TN",
    cityWithStateAbbr: "Fairview, TN",
  },
  {
    zip: "37063",
    ST: "TN",
    cityWithStateAbbr: "Fosterville, TN",
  },
  {
    zip: "37064",
    ST: "TN",
    cityWithStateAbbr: "Franklin, TN",
  },
  {
    zip: "37065",
    ST: "TN",
    cityWithStateAbbr: "Franklin, TN",
  },
  {
    zip: "37066",
    ST: "TN",
    cityWithStateAbbr: "Gallatin, TN",
  },
  {
    zip: "37067",
    ST: "TN",
    cityWithStateAbbr: "Franklin, TN",
  },
  {
    zip: "37068",
    ST: "TN",
    cityWithStateAbbr: "Franklin, TN",
  },
  {
    zip: "37069",
    ST: "TN",
    cityWithStateAbbr: "Franklin, TN",
  },
  {
    zip: "37070",
    ST: "TN",
    cityWithStateAbbr: "Goodlettsville, TN",
  },
  {
    zip: "37071",
    ST: "TN",
    cityWithStateAbbr: "Gladeville, TN",
  },
  {
    zip: "37072",
    ST: "TN",
    cityWithStateAbbr: "Goodlettsville, TN",
  },
  {
    zip: "37073",
    ST: "TN",
    cityWithStateAbbr: "Greenbrier, TN",
  },
  {
    zip: "37074",
    ST: "TN",
    cityWithStateAbbr: "Hartsville, TN",
  },
  {
    zip: "37075",
    ST: "TN",
    cityWithStateAbbr: "Hendersonville, TN",
  },
  {
    zip: "37076",
    ST: "TN",
    cityWithStateAbbr: "Hermitage, TN",
  },
  {
    zip: "37077",
    ST: "TN",
    cityWithStateAbbr: "Hendersonville, TN",
  },
  {
    zip: "37078",
    ST: "TN",
    cityWithStateAbbr: "Hurricane Mills, TN",
  },
  {
    zip: "37079",
    ST: "TN",
    cityWithStateAbbr: "Indian Mound, TN",
  },
  {
    zip: "37080",
    ST: "TN",
    cityWithStateAbbr: "Joelton, TN",
  },
  {
    zip: "37082",
    ST: "TN",
    cityWithStateAbbr: "Kingston Springs, TN",
  },
  {
    zip: "37083",
    ST: "TN",
    cityWithStateAbbr: "Lafayette, TN",
  },
  {
    zip: "37085",
    ST: "TN",
    cityWithStateAbbr: "Lascassas, TN",
  },
  {
    zip: "37086",
    ST: "TN",
    cityWithStateAbbr: "La Vergne, TN",
  },
  {
    zip: "37087",
    ST: "TN",
    cityWithStateAbbr: "Lebanon, TN",
  },
  {
    zip: "37088",
    ST: "TN",
    cityWithStateAbbr: "Lebanon, TN",
  },
  {
    zip: "37089",
    ST: "TN",
    cityWithStateAbbr: "La Vergne, TN",
  },
  {
    zip: "37090",
    ST: "TN",
    cityWithStateAbbr: "Lebanon, TN",
  },
  {
    zip: "37091",
    ST: "TN",
    cityWithStateAbbr: "Lewisburg, TN",
  },
  {
    zip: "37095",
    ST: "TN",
    cityWithStateAbbr: "Liberty, TN",
  },
  {
    zip: "37096",
    ST: "TN",
    cityWithStateAbbr: "Linden, TN",
  },
  {
    zip: "37097",
    ST: "TN",
    cityWithStateAbbr: "Lobelville, TN",
  },
  {
    zip: "37098",
    ST: "TN",
    cityWithStateAbbr: "Lyles, TN",
  },
  {
    zip: "37101",
    ST: "TN",
    cityWithStateAbbr: "Mc Ewen, TN",
  },
  {
    zip: "37110",
    ST: "TN",
    cityWithStateAbbr: "Mcminnville, TN",
  },
  {
    zip: "37111",
    ST: "TN",
    cityWithStateAbbr: "Mcminnville, TN",
  },
  {
    zip: "37115",
    ST: "TN",
    cityWithStateAbbr: "Madison, TN",
  },
  {
    zip: "37116",
    ST: "TN",
    cityWithStateAbbr: "Madison, TN",
  },
  {
    zip: "37118",
    ST: "TN",
    cityWithStateAbbr: "Milton, TN",
  },
  {
    zip: "37119",
    ST: "TN",
    cityWithStateAbbr: "Mitchellville, TN",
  },
  {
    zip: "37121",
    ST: "TN",
    cityWithStateAbbr: "Mount Juliet, TN",
  },
  {
    zip: "37122",
    ST: "TN",
    cityWithStateAbbr: "Mount Juliet, TN",
  },
  {
    zip: "37127",
    ST: "TN",
    cityWithStateAbbr: "Murfreesboro, TN",
  },
  {
    zip: "37128",
    ST: "TN",
    cityWithStateAbbr: "Murfreesboro, TN",
  },
  {
    zip: "37129",
    ST: "TN",
    cityWithStateAbbr: "Murfreesboro, TN",
  },
  {
    zip: "37130",
    ST: "TN",
    cityWithStateAbbr: "Murfreesboro, TN",
  },
  {
    zip: "37131",
    ST: "TN",
    cityWithStateAbbr: "Murfreesboro, TN",
  },
  {
    zip: "37132",
    ST: "TN",
    cityWithStateAbbr: "Murfreesboro, TN",
  },
  {
    zip: "37133",
    ST: "TN",
    cityWithStateAbbr: "Murfreesboro, TN",
  },
  {
    zip: "37134",
    ST: "TN",
    cityWithStateAbbr: "New Johnsonville, TN",
  },
  {
    zip: "37135",
    ST: "TN",
    cityWithStateAbbr: "Nolensville, TN",
  },
  {
    zip: "37136",
    ST: "TN",
    cityWithStateAbbr: "Norene, TN",
  },
  {
    zip: "37137",
    ST: "TN",
    cityWithStateAbbr: "Nunnelly, TN",
  },
  {
    zip: "37138",
    ST: "TN",
    cityWithStateAbbr: "Old Hickory, TN",
  },
  {
    zip: "37140",
    ST: "TN",
    cityWithStateAbbr: "Only, TN",
  },
  {
    zip: "37141",
    ST: "TN",
    cityWithStateAbbr: "Orlinda, TN",
  },
  {
    zip: "37142",
    ST: "TN",
    cityWithStateAbbr: "Palmyra, TN",
  },
  {
    zip: "37143",
    ST: "TN",
    cityWithStateAbbr: "Pegram, TN",
  },
  {
    zip: "37144",
    ST: "TN",
    cityWithStateAbbr: "Petersburg, TN",
  },
  {
    zip: "37145",
    ST: "TN",
    cityWithStateAbbr: "Pleasant Shade, TN",
  },
  {
    zip: "37146",
    ST: "TN",
    cityWithStateAbbr: "Pleasant View, TN",
  },
  {
    zip: "37148",
    ST: "TN",
    cityWithStateAbbr: "Portland, TN",
  },
  {
    zip: "37149",
    ST: "TN",
    cityWithStateAbbr: "Readyville, TN",
  },
  {
    zip: "37150",
    ST: "TN",
    cityWithStateAbbr: "Red Boiling Springs, TN",
  },
  {
    zip: "37151",
    ST: "TN",
    cityWithStateAbbr: "Riddleton, TN",
  },
  {
    zip: "37152",
    ST: "TN",
    cityWithStateAbbr: "Ridgetop, TN",
  },
  {
    zip: "37153",
    ST: "TN",
    cityWithStateAbbr: "Rockvale, TN",
  },
  {
    zip: "37160",
    ST: "TN",
    cityWithStateAbbr: "Shelbyville, TN",
  },
  {
    zip: "37161",
    ST: "TN",
    cityWithStateAbbr: "Shelbyville, TN",
  },
  {
    zip: "37162",
    ST: "TN",
    cityWithStateAbbr: "Shelbyville, TN",
  },
  {
    zip: "37165",
    ST: "TN",
    cityWithStateAbbr: "Slayden, TN",
  },
  {
    zip: "37166",
    ST: "TN",
    cityWithStateAbbr: "Smithville, TN",
  },
  {
    zip: "37167",
    ST: "TN",
    cityWithStateAbbr: "Smyrna, TN",
  },
  {
    zip: "37171",
    ST: "TN",
    cityWithStateAbbr: "Southside, TN",
  },
  {
    zip: "37172",
    ST: "TN",
    cityWithStateAbbr: "Springfield, TN",
  },
  {
    zip: "37174",
    ST: "TN",
    cityWithStateAbbr: "Spring Hill, TN",
  },
  {
    zip: "37175",
    ST: "TN",
    cityWithStateAbbr: "Stewart, TN",
  },
  {
    zip: "37178",
    ST: "TN",
    cityWithStateAbbr: "Tennessee Ridge, TN",
  },
  {
    zip: "37179",
    ST: "TN",
    cityWithStateAbbr: "Thompsons Station, TN",
  },
  {
    zip: "37180",
    ST: "TN",
    cityWithStateAbbr: "Unionville, TN",
  },
  {
    zip: "37181",
    ST: "TN",
    cityWithStateAbbr: "Vanleer, TN",
  },
  {
    zip: "37183",
    ST: "TN",
    cityWithStateAbbr: "Wartrace, TN",
  },
  {
    zip: "37184",
    ST: "TN",
    cityWithStateAbbr: "Watertown, TN",
  },
  {
    zip: "37185",
    ST: "TN",
    cityWithStateAbbr: "Waverly, TN",
  },
  {
    zip: "37186",
    ST: "TN",
    cityWithStateAbbr: "Westmoreland, TN",
  },
  {
    zip: "37187",
    ST: "TN",
    cityWithStateAbbr: "White Bluff, TN",
  },
  {
    zip: "37188",
    ST: "TN",
    cityWithStateAbbr: "White House, TN",
  },
  {
    zip: "37189",
    ST: "TN",
    cityWithStateAbbr: "Whites Creek, TN",
  },
  {
    zip: "37190",
    ST: "TN",
    cityWithStateAbbr: "Woodbury, TN",
  },
  {
    zip: "37191",
    ST: "TN",
    cityWithStateAbbr: "Woodlawn, TN",
  },
  {
    zip: "37201",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37202",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37203",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37204",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37205",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37206",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37207",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37208",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37209",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37210",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37211",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37212",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37213",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37214",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37215",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37216",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37217",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37218",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37219",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37220",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37221",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37222",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37224",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37227",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37228",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37229",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37230",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37232",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37234",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37235",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37236",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37238",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37240",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37241",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37242",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37243",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37244",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37246",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37250",
    ST: "TN",
    cityWithStateAbbr: "Nashville, TN",
  },
  {
    zip: "37301",
    ST: "TN",
    cityWithStateAbbr: "Altamont, TN",
  },
  {
    zip: "37302",
    ST: "TN",
    cityWithStateAbbr: "Apison, TN",
  },
  {
    zip: "37303",
    ST: "TN",
    cityWithStateAbbr: "Athens, TN",
  },
  {
    zip: "37304",
    ST: "TN",
    cityWithStateAbbr: "Bakewell, TN",
  },
  {
    zip: "37305",
    ST: "TN",
    cityWithStateAbbr: "Beersheba Springs, TN",
  },
  {
    zip: "37306",
    ST: "TN",
    cityWithStateAbbr: "Belvidere, TN",
  },
  {
    zip: "37307",
    ST: "TN",
    cityWithStateAbbr: "Benton, TN",
  },
  {
    zip: "37308",
    ST: "TN",
    cityWithStateAbbr: "Birchwood, TN",
  },
  {
    zip: "37309",
    ST: "TN",
    cityWithStateAbbr: "Calhoun, TN",
  },
  {
    zip: "37310",
    ST: "TN",
    cityWithStateAbbr: "Charleston, TN",
  },
  {
    zip: "37311",
    ST: "TN",
    cityWithStateAbbr: "Cleveland, TN",
  },
  {
    zip: "37312",
    ST: "TN",
    cityWithStateAbbr: "Cleveland, TN",
  },
  {
    zip: "37313",
    ST: "TN",
    cityWithStateAbbr: "Coalmont, TN",
  },
  {
    zip: "37314",
    ST: "TN",
    cityWithStateAbbr: "Coker Creek, TN",
  },
  {
    zip: "37315",
    ST: "TN",
    cityWithStateAbbr: "Collegedale, TN",
  },
  {
    zip: "37316",
    ST: "TN",
    cityWithStateAbbr: "Conasauga, TN",
  },
  {
    zip: "37317",
    ST: "TN",
    cityWithStateAbbr: "Copperhill, TN",
  },
  {
    zip: "37318",
    ST: "TN",
    cityWithStateAbbr: "Cowan, TN",
  },
  {
    zip: "37320",
    ST: "TN",
    cityWithStateAbbr: "Cleveland, TN",
  },
  {
    zip: "37321",
    ST: "TN",
    cityWithStateAbbr: "Dayton, TN",
  },
  {
    zip: "37322",
    ST: "TN",
    cityWithStateAbbr: "Decatur, TN",
  },
  {
    zip: "37323",
    ST: "TN",
    cityWithStateAbbr: "Cleveland, TN",
  },
  {
    zip: "37324",
    ST: "TN",
    cityWithStateAbbr: "Decherd, TN",
  },
  {
    zip: "37325",
    ST: "TN",
    cityWithStateAbbr: "Delano, TN",
  },
  {
    zip: "37326",
    ST: "TN",
    cityWithStateAbbr: "Ducktown, TN",
  },
  {
    zip: "37327",
    ST: "TN",
    cityWithStateAbbr: "Dunlap, TN",
  },
  {
    zip: "37328",
    ST: "TN",
    cityWithStateAbbr: "Elora, TN",
  },
  {
    zip: "37329",
    ST: "TN",
    cityWithStateAbbr: "Englewood, TN",
  },
  {
    zip: "37330",
    ST: "TN",
    cityWithStateAbbr: "Estill Springs, TN",
  },
  {
    zip: "37331",
    ST: "TN",
    cityWithStateAbbr: "Etowah, TN",
  },
  {
    zip: "37332",
    ST: "TN",
    cityWithStateAbbr: "Evensville, TN",
  },
  {
    zip: "37333",
    ST: "TN",
    cityWithStateAbbr: "Farner, TN",
  },
  {
    zip: "37334",
    ST: "TN",
    cityWithStateAbbr: "Fayetteville, TN",
  },
  {
    zip: "37335",
    ST: "TN",
    cityWithStateAbbr: "Flintville, TN",
  },
  {
    zip: "37336",
    ST: "TN",
    cityWithStateAbbr: "Georgetown, TN",
  },
  {
    zip: "37337",
    ST: "TN",
    cityWithStateAbbr: "Grandview, TN",
  },
  {
    zip: "37338",
    ST: "TN",
    cityWithStateAbbr: "Graysville, TN",
  },
  {
    zip: "37339",
    ST: "TN",
    cityWithStateAbbr: "Gruetli Laager, TN",
  },
  {
    zip: "37340",
    ST: "TN",
    cityWithStateAbbr: "Guild, TN",
  },
  {
    zip: "37341",
    ST: "TN",
    cityWithStateAbbr: "Harrison, TN",
  },
  {
    zip: "37342",
    ST: "TN",
    cityWithStateAbbr: "Hillsboro, TN",
  },
  {
    zip: "37343",
    ST: "TN",
    cityWithStateAbbr: "Hixson, TN",
  },
  {
    zip: "37345",
    ST: "TN",
    cityWithStateAbbr: "Huntland, TN",
  },
  {
    zip: "37347",
    ST: "TN",
    cityWithStateAbbr: "Jasper, TN",
  },
  {
    zip: "37348",
    ST: "TN",
    cityWithStateAbbr: "Kelso, TN",
  },
  {
    zip: "37349",
    ST: "TN",
    cityWithStateAbbr: "Manchester, TN",
  },
  {
    zip: "37350",
    ST: "TN",
    cityWithStateAbbr: "Lookout Mountain, TN",
  },
  {
    zip: "37351",
    ST: "TN",
    cityWithStateAbbr: "Lupton City, TN",
  },
  {
    zip: "37352",
    ST: "TN",
    cityWithStateAbbr: "Lynchburg, TN",
  },
  {
    zip: "37353",
    ST: "TN",
    cityWithStateAbbr: "Mc Donald, TN",
  },
  {
    zip: "37354",
    ST: "TN",
    cityWithStateAbbr: "Madisonville, TN",
  },
  {
    zip: "37355",
    ST: "TN",
    cityWithStateAbbr: "Manchester, TN",
  },
  {
    zip: "37356",
    ST: "TN",
    cityWithStateAbbr: "Monteagle, TN",
  },
  {
    zip: "37357",
    ST: "TN",
    cityWithStateAbbr: "Morrison, TN",
  },
  {
    zip: "37359",
    ST: "TN",
    cityWithStateAbbr: "Mulberry, TN",
  },
  {
    zip: "37360",
    ST: "TN",
    cityWithStateAbbr: "Normandy, TN",
  },
  {
    zip: "37361",
    ST: "TN",
    cityWithStateAbbr: "Ocoee, TN",
  },
  {
    zip: "37362",
    ST: "TN",
    cityWithStateAbbr: "Old Fort, TN",
  },
  {
    zip: "37363",
    ST: "TN",
    cityWithStateAbbr: "Ooltewah, TN",
  },
  {
    zip: "37364",
    ST: "TN",
    cityWithStateAbbr: "Cleveland, TN",
  },
  {
    zip: "37365",
    ST: "TN",
    cityWithStateAbbr: "Palmer, TN",
  },
  {
    zip: "37366",
    ST: "TN",
    cityWithStateAbbr: "Pelham, TN",
  },
  {
    zip: "37367",
    ST: "TN",
    cityWithStateAbbr: "Pikeville, TN",
  },
  {
    zip: "37369",
    ST: "TN",
    cityWithStateAbbr: "Reliance, TN",
  },
  {
    zip: "37370",
    ST: "TN",
    cityWithStateAbbr: "Riceville, TN",
  },
  {
    zip: "37371",
    ST: "TN",
    cityWithStateAbbr: "Athens, TN",
  },
  {
    zip: "37373",
    ST: "TN",
    cityWithStateAbbr: "Sale Creek, TN",
  },
  {
    zip: "37374",
    ST: "TN",
    cityWithStateAbbr: "Sequatchie, TN",
  },
  {
    zip: "37375",
    ST: "TN",
    cityWithStateAbbr: "Sewanee, TN",
  },
  {
    zip: "37376",
    ST: "TN",
    cityWithStateAbbr: "Sherwood, TN",
  },
  {
    zip: "37377",
    ST: "TN",
    cityWithStateAbbr: "Signal Mountain, TN",
  },
  {
    zip: "37378",
    ST: "TN",
    cityWithStateAbbr: "Smartt, TN",
  },
  {
    zip: "37379",
    ST: "TN",
    cityWithStateAbbr: "Soddy Daisy, TN",
  },
  {
    zip: "37380",
    ST: "TN",
    cityWithStateAbbr: "South Pittsburg, TN",
  },
  {
    zip: "37381",
    ST: "TN",
    cityWithStateAbbr: "Spring City, TN",
  },
  {
    zip: "37382",
    ST: "TN",
    cityWithStateAbbr: "Summitville, TN",
  },
  {
    zip: "37383",
    ST: "TN",
    cityWithStateAbbr: "Sewanee, TN",
  },
  {
    zip: "37384",
    ST: "TN",
    cityWithStateAbbr: "Soddy Daisy, TN",
  },
  {
    zip: "37385",
    ST: "TN",
    cityWithStateAbbr: "Tellico Plains, TN",
  },
  {
    zip: "37387",
    ST: "TN",
    cityWithStateAbbr: "Tracy City, TN",
  },
  {
    zip: "37388",
    ST: "TN",
    cityWithStateAbbr: "Tullahoma, TN",
  },
  {
    zip: "37389",
    ST: "TN",
    cityWithStateAbbr: "Arnold Afb, TN",
  },
  {
    zip: "37391",
    ST: "TN",
    cityWithStateAbbr: "Turtletown, TN",
  },
  {
    zip: "37394",
    ST: "TN",
    cityWithStateAbbr: "Viola, TN",
  },
  {
    zip: "37396",
    ST: "TN",
    cityWithStateAbbr: "Whiteside, TN",
  },
  {
    zip: "37397",
    ST: "TN",
    cityWithStateAbbr: "Whitwell, TN",
  },
  {
    zip: "37398",
    ST: "TN",
    cityWithStateAbbr: "Winchester, TN",
  },
  {
    zip: "37401",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37402",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37403",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37404",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37405",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37406",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37407",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37408",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37409",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37410",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37411",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37412",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37414",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37415",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37416",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37419",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37421",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37422",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37424",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37450",
    ST: "TN",
    cityWithStateAbbr: "Chattanooga, TN",
  },
  {
    zip: "37501",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "37544",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "37601",
    ST: "TN",
    cityWithStateAbbr: "Johnson City, TN",
  },
  {
    zip: "37602",
    ST: "TN",
    cityWithStateAbbr: "Johnson City, TN",
  },
  {
    zip: "37604",
    ST: "TN",
    cityWithStateAbbr: "Johnson City, TN",
  },
  {
    zip: "37605",
    ST: "TN",
    cityWithStateAbbr: "Johnson City, TN",
  },
  {
    zip: "37614",
    ST: "TN",
    cityWithStateAbbr: "Johnson City, TN",
  },
  {
    zip: "37615",
    ST: "TN",
    cityWithStateAbbr: "Johnson City, TN",
  },
  {
    zip: "37616",
    ST: "TN",
    cityWithStateAbbr: "Afton, TN",
  },
  {
    zip: "37617",
    ST: "TN",
    cityWithStateAbbr: "Blountville, TN",
  },
  {
    zip: "37618",
    ST: "TN",
    cityWithStateAbbr: "Bluff City, TN",
  },
  {
    zip: "37620",
    ST: "TN",
    cityWithStateAbbr: "Bristol, TN",
  },
  {
    zip: "37621",
    ST: "TN",
    cityWithStateAbbr: "Bristol, TN",
  },
  {
    zip: "37625",
    ST: "VA",
    cityWithStateAbbr: "Bristol, VA",
  },
  {
    zip: "37640",
    ST: "TN",
    cityWithStateAbbr: "Butler, TN",
  },
  {
    zip: "37641",
    ST: "TN",
    cityWithStateAbbr: "Chuckey, TN",
  },
  {
    zip: "37642",
    ST: "TN",
    cityWithStateAbbr: "Church Hill, TN",
  },
  {
    zip: "37643",
    ST: "TN",
    cityWithStateAbbr: "Elizabethton, TN",
  },
  {
    zip: "37644",
    ST: "TN",
    cityWithStateAbbr: "Elizabethton, TN",
  },
  {
    zip: "37645",
    ST: "TN",
    cityWithStateAbbr: "Mount Carmel, TN",
  },
  {
    zip: "37650",
    ST: "TN",
    cityWithStateAbbr: "Erwin, TN",
  },
  {
    zip: "37656",
    ST: "TN",
    cityWithStateAbbr: "Fall Branch, TN",
  },
  {
    zip: "37657",
    ST: "TN",
    cityWithStateAbbr: "Flag Pond, TN",
  },
  {
    zip: "37658",
    ST: "TN",
    cityWithStateAbbr: "Hampton, TN",
  },
  {
    zip: "37659",
    ST: "TN",
    cityWithStateAbbr: "Jonesborough, TN",
  },
  {
    zip: "37660",
    ST: "TN",
    cityWithStateAbbr: "Kingsport, TN",
  },
  {
    zip: "37662",
    ST: "TN",
    cityWithStateAbbr: "Kingsport, TN",
  },
  {
    zip: "37663",
    ST: "TN",
    cityWithStateAbbr: "Kingsport, TN",
  },
  {
    zip: "37664",
    ST: "TN",
    cityWithStateAbbr: "Kingsport, TN",
  },
  {
    zip: "37665",
    ST: "TN",
    cityWithStateAbbr: "Kingsport, TN",
  },
  {
    zip: "37669",
    ST: "TN",
    cityWithStateAbbr: "Kingsport, TN",
  },
  {
    zip: "37680",
    ST: "TN",
    cityWithStateAbbr: "Laurel Bloomery, TN",
  },
  {
    zip: "37681",
    ST: "TN",
    cityWithStateAbbr: "Limestone, TN",
  },
  {
    zip: "37682",
    ST: "TN",
    cityWithStateAbbr: "Milligan College, TN",
  },
  {
    zip: "37683",
    ST: "TN",
    cityWithStateAbbr: "Mountain City, TN",
  },
  {
    zip: "37684",
    ST: "TN",
    cityWithStateAbbr: "Mountain Home, TN",
  },
  {
    zip: "37686",
    ST: "TN",
    cityWithStateAbbr: "Piney Flats, TN",
  },
  {
    zip: "37687",
    ST: "TN",
    cityWithStateAbbr: "Roan Mountain, TN",
  },
  {
    zip: "37688",
    ST: "TN",
    cityWithStateAbbr: "Shady Valley, TN",
  },
  {
    zip: "37690",
    ST: "TN",
    cityWithStateAbbr: "Telford, TN",
  },
  {
    zip: "37691",
    ST: "TN",
    cityWithStateAbbr: "Trade, TN",
  },
  {
    zip: "37692",
    ST: "TN",
    cityWithStateAbbr: "Unicoi, TN",
  },
  {
    zip: "37694",
    ST: "TN",
    cityWithStateAbbr: "Watauga, TN",
  },
  {
    zip: "37699",
    ST: "TN",
    cityWithStateAbbr: "Piney Flats, TN",
  },
  {
    zip: "37701",
    ST: "TN",
    cityWithStateAbbr: "Alcoa, TN",
  },
  {
    zip: "37705",
    ST: "TN",
    cityWithStateAbbr: "Andersonville, TN",
  },
  {
    zip: "37707",
    ST: "TN",
    cityWithStateAbbr: "Arthur, TN",
  },
  {
    zip: "37708",
    ST: "TN",
    cityWithStateAbbr: "Bean Station, TN",
  },
  {
    zip: "37709",
    ST: "TN",
    cityWithStateAbbr: "Blaine, TN",
  },
  {
    zip: "37710",
    ST: "TN",
    cityWithStateAbbr: "Briceville, TN",
  },
  {
    zip: "37711",
    ST: "TN",
    cityWithStateAbbr: "Bulls Gap, TN",
  },
  {
    zip: "37713",
    ST: "TN",
    cityWithStateAbbr: "Bybee, TN",
  },
  {
    zip: "37714",
    ST: "TN",
    cityWithStateAbbr: "Caryville, TN",
  },
  {
    zip: "37715",
    ST: "TN",
    cityWithStateAbbr: "Clairfield, TN",
  },
  {
    zip: "37716",
    ST: "TN",
    cityWithStateAbbr: "Clinton, TN",
  },
  {
    zip: "37717",
    ST: "TN",
    cityWithStateAbbr: "Clinton, TN",
  },
  {
    zip: "37719",
    ST: "TN",
    cityWithStateAbbr: "Coalfield, TN",
  },
  {
    zip: "37721",
    ST: "TN",
    cityWithStateAbbr: "Corryton, TN",
  },
  {
    zip: "37722",
    ST: "TN",
    cityWithStateAbbr: "Cosby, TN",
  },
  {
    zip: "37723",
    ST: "TN",
    cityWithStateAbbr: "Crab Orchard, TN",
  },
  {
    zip: "37724",
    ST: "TN",
    cityWithStateAbbr: "Cumberland Gap, TN",
  },
  {
    zip: "37725",
    ST: "TN",
    cityWithStateAbbr: "Dandridge, TN",
  },
  {
    zip: "37726",
    ST: "TN",
    cityWithStateAbbr: "Deer Lodge, TN",
  },
  {
    zip: "37727",
    ST: "TN",
    cityWithStateAbbr: "Del Rio, TN",
  },
  {
    zip: "37729",
    ST: "TN",
    cityWithStateAbbr: "Duff, TN",
  },
  {
    zip: "37730",
    ST: "TN",
    cityWithStateAbbr: "Eagan, TN",
  },
  {
    zip: "37731",
    ST: "TN",
    cityWithStateAbbr: "Eidson, TN",
  },
  {
    zip: "37732",
    ST: "TN",
    cityWithStateAbbr: "Elgin, TN",
  },
  {
    zip: "37733",
    ST: "TN",
    cityWithStateAbbr: "Rugby, TN",
  },
  {
    zip: "37737",
    ST: "TN",
    cityWithStateAbbr: "Friendsville, TN",
  },
  {
    zip: "37738",
    ST: "TN",
    cityWithStateAbbr: "Gatlinburg, TN",
  },
  {
    zip: "37742",
    ST: "TN",
    cityWithStateAbbr: "Greenback, TN",
  },
  {
    zip: "37743",
    ST: "TN",
    cityWithStateAbbr: "Greeneville, TN",
  },
  {
    zip: "37744",
    ST: "TN",
    cityWithStateAbbr: "Greeneville, TN",
  },
  {
    zip: "37745",
    ST: "TN",
    cityWithStateAbbr: "Greeneville, TN",
  },
  {
    zip: "37748",
    ST: "TN",
    cityWithStateAbbr: "Harriman, TN",
  },
  {
    zip: "37752",
    ST: "TN",
    cityWithStateAbbr: "Harrogate, TN",
  },
  {
    zip: "37753",
    ST: "TN",
    cityWithStateAbbr: "Hartford, TN",
  },
  {
    zip: "37754",
    ST: "TN",
    cityWithStateAbbr: "Heiskell, TN",
  },
  {
    zip: "37755",
    ST: "TN",
    cityWithStateAbbr: "Helenwood, TN",
  },
  {
    zip: "37756",
    ST: "TN",
    cityWithStateAbbr: "Huntsville, TN",
  },
  {
    zip: "37757",
    ST: "TN",
    cityWithStateAbbr: "Jacksboro, TN",
  },
  {
    zip: "37760",
    ST: "TN",
    cityWithStateAbbr: "Jefferson City, TN",
  },
  {
    zip: "37762",
    ST: "TN",
    cityWithStateAbbr: "Jellico, TN",
  },
  {
    zip: "37763",
    ST: "TN",
    cityWithStateAbbr: "Kingston, TN",
  },
  {
    zip: "37764",
    ST: "TN",
    cityWithStateAbbr: "Kodak, TN",
  },
  {
    zip: "37765",
    ST: "TN",
    cityWithStateAbbr: "Kyles Ford, TN",
  },
  {
    zip: "37766",
    ST: "TN",
    cityWithStateAbbr: "La Follette, TN",
  },
  {
    zip: "37769",
    ST: "TN",
    cityWithStateAbbr: "Lake City, TN",
  },
  {
    zip: "37770",
    ST: "TN",
    cityWithStateAbbr: "Lancing, TN",
  },
  {
    zip: "37771",
    ST: "TN",
    cityWithStateAbbr: "Lenoir City, TN",
  },
  {
    zip: "37772",
    ST: "TN",
    cityWithStateAbbr: "Lenoir City, TN",
  },
  {
    zip: "37773",
    ST: "TN",
    cityWithStateAbbr: "Lone Mountain, TN",
  },
  {
    zip: "37774",
    ST: "TN",
    cityWithStateAbbr: "Loudon, TN",
  },
  {
    zip: "37777",
    ST: "TN",
    cityWithStateAbbr: "Louisville, TN",
  },
  {
    zip: "37778",
    ST: "TN",
    cityWithStateAbbr: "Lowland, TN",
  },
  {
    zip: "37779",
    ST: "TN",
    cityWithStateAbbr: "Luttrell, TN",
  },
  {
    zip: "37801",
    ST: "TN",
    cityWithStateAbbr: "Maryville, TN",
  },
  {
    zip: "37802",
    ST: "TN",
    cityWithStateAbbr: "Maryville, TN",
  },
  {
    zip: "37803",
    ST: "TN",
    cityWithStateAbbr: "Maryville, TN",
  },
  {
    zip: "37804",
    ST: "TN",
    cityWithStateAbbr: "Maryville, TN",
  },
  {
    zip: "37806",
    ST: "TN",
    cityWithStateAbbr: "Mascot, TN",
  },
  {
    zip: "37807",
    ST: "TN",
    cityWithStateAbbr: "Maynardville, TN",
  },
  {
    zip: "37809",
    ST: "TN",
    cityWithStateAbbr: "Midway, TN",
  },
  {
    zip: "37810",
    ST: "TN",
    cityWithStateAbbr: "Mohawk, TN",
  },
  {
    zip: "37811",
    ST: "TN",
    cityWithStateAbbr: "Mooresburg, TN",
  },
  {
    zip: "37813",
    ST: "TN",
    cityWithStateAbbr: "Morristown, TN",
  },
  {
    zip: "37814",
    ST: "TN",
    cityWithStateAbbr: "Morristown, TN",
  },
  {
    zip: "37815",
    ST: "TN",
    cityWithStateAbbr: "Morristown, TN",
  },
  {
    zip: "37816",
    ST: "TN",
    cityWithStateAbbr: "Morristown, TN",
  },
  {
    zip: "37818",
    ST: "TN",
    cityWithStateAbbr: "Mosheim, TN",
  },
  {
    zip: "37819",
    ST: "TN",
    cityWithStateAbbr: "Newcomb, TN",
  },
  {
    zip: "37820",
    ST: "TN",
    cityWithStateAbbr: "New Market, TN",
  },
  {
    zip: "37821",
    ST: "TN",
    cityWithStateAbbr: "Newport, TN",
  },
  {
    zip: "37822",
    ST: "TN",
    cityWithStateAbbr: "Newport, TN",
  },
  {
    zip: "37824",
    ST: "TN",
    cityWithStateAbbr: "New Tazewell, TN",
  },
  {
    zip: "37825",
    ST: "TN",
    cityWithStateAbbr: "New Tazewell, TN",
  },
  {
    zip: "37826",
    ST: "TN",
    cityWithStateAbbr: "Niota, TN",
  },
  {
    zip: "37828",
    ST: "TN",
    cityWithStateAbbr: "Norris, TN",
  },
  {
    zip: "37829",
    ST: "TN",
    cityWithStateAbbr: "Oakdale, TN",
  },
  {
    zip: "37830",
    ST: "TN",
    cityWithStateAbbr: "Oak Ridge, TN",
  },
  {
    zip: "37831",
    ST: "TN",
    cityWithStateAbbr: "Oak Ridge, TN",
  },
  {
    zip: "37840",
    ST: "TN",
    cityWithStateAbbr: "Oliver Springs, TN",
  },
  {
    zip: "37841",
    ST: "TN",
    cityWithStateAbbr: "Oneida, TN",
  },
  {
    zip: "37843",
    ST: "TN",
    cityWithStateAbbr: "Parrottsville, TN",
  },
  {
    zip: "37845",
    ST: "TN",
    cityWithStateAbbr: "Petros, TN",
  },
  {
    zip: "37846",
    ST: "TN",
    cityWithStateAbbr: "Philadelphia, TN",
  },
  {
    zip: "37847",
    ST: "TN",
    cityWithStateAbbr: "Pioneer, TN",
  },
  {
    zip: "37848",
    ST: "TN",
    cityWithStateAbbr: "Powder Springs, TN",
  },
  {
    zip: "37849",
    ST: "TN",
    cityWithStateAbbr: "Powell, TN",
  },
  {
    zip: "37851",
    ST: "KY",
    cityWithStateAbbr: "Pruden, KY",
  },
  {
    zip: "37852",
    ST: "TN",
    cityWithStateAbbr: "Robbins, TN",
  },
  {
    zip: "37853",
    ST: "TN",
    cityWithStateAbbr: "Rockford, TN",
  },
  {
    zip: "37854",
    ST: "TN",
    cityWithStateAbbr: "Rockwood, TN",
  },
  {
    zip: "37857",
    ST: "TN",
    cityWithStateAbbr: "Rogersville, TN",
  },
  {
    zip: "37860",
    ST: "TN",
    cityWithStateAbbr: "Russellville, TN",
  },
  {
    zip: "37861",
    ST: "TN",
    cityWithStateAbbr: "Rutledge, TN",
  },
  {
    zip: "37862",
    ST: "TN",
    cityWithStateAbbr: "Sevierville, TN",
  },
  {
    zip: "37863",
    ST: "TN",
    cityWithStateAbbr: "Pigeon Forge, TN",
  },
  {
    zip: "37864",
    ST: "TN",
    cityWithStateAbbr: "Sevierville, TN",
  },
  {
    zip: "37865",
    ST: "TN",
    cityWithStateAbbr: "Seymour, TN",
  },
  {
    zip: "37866",
    ST: "TN",
    cityWithStateAbbr: "Sharps Chapel, TN",
  },
  {
    zip: "37867",
    ST: "TN",
    cityWithStateAbbr: "Shawanee, TN",
  },
  {
    zip: "37868",
    ST: "TN",
    cityWithStateAbbr: "Pigeon Forge, TN",
  },
  {
    zip: "37869",
    ST: "TN",
    cityWithStateAbbr: "Sneedville, TN",
  },
  {
    zip: "37870",
    ST: "TN",
    cityWithStateAbbr: "Speedwell, TN",
  },
  {
    zip: "37871",
    ST: "TN",
    cityWithStateAbbr: "Strawberry Plains, TN",
  },
  {
    zip: "37872",
    ST: "TN",
    cityWithStateAbbr: "Sunbright, TN",
  },
  {
    zip: "37873",
    ST: "TN",
    cityWithStateAbbr: "Surgoinsville, TN",
  },
  {
    zip: "37874",
    ST: "TN",
    cityWithStateAbbr: "Sweetwater, TN",
  },
  {
    zip: "37876",
    ST: "TN",
    cityWithStateAbbr: "Sevierville, TN",
  },
  {
    zip: "37877",
    ST: "TN",
    cityWithStateAbbr: "Talbott, TN",
  },
  {
    zip: "37878",
    ST: "TN",
    cityWithStateAbbr: "Tallassee, TN",
  },
  {
    zip: "37879",
    ST: "TN",
    cityWithStateAbbr: "Tazewell, TN",
  },
  {
    zip: "37880",
    ST: "TN",
    cityWithStateAbbr: "Ten Mile, TN",
  },
  {
    zip: "37881",
    ST: "TN",
    cityWithStateAbbr: "Thorn Hill, TN",
  },
  {
    zip: "37882",
    ST: "TN",
    cityWithStateAbbr: "Townsend, TN",
  },
  {
    zip: "37885",
    ST: "TN",
    cityWithStateAbbr: "Vonore, TN",
  },
  {
    zip: "37886",
    ST: "TN",
    cityWithStateAbbr: "Walland, TN",
  },
  {
    zip: "37887",
    ST: "TN",
    cityWithStateAbbr: "Wartburg, TN",
  },
  {
    zip: "37888",
    ST: "TN",
    cityWithStateAbbr: "Washburn, TN",
  },
  {
    zip: "37890",
    ST: "TN",
    cityWithStateAbbr: "White Pine, TN",
  },
  {
    zip: "37891",
    ST: "TN",
    cityWithStateAbbr: "Whitesburg, TN",
  },
  {
    zip: "37892",
    ST: "TN",
    cityWithStateAbbr: "Winfield, TN",
  },
  {
    zip: "37901",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37902",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37909",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37912",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37914",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37915",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37916",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37917",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37918",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37919",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37920",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37921",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37922",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37923",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37924",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37927",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37928",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37929",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37930",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37931",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37932",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37933",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37934",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37938",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37939",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37940",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37950",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37995",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37996",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37997",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "37998",
    ST: "TN",
    cityWithStateAbbr: "Knoxville, TN",
  },
  {
    zip: "38001",
    ST: "TN",
    cityWithStateAbbr: "Alamo, TN",
  },
  {
    zip: "38002",
    ST: "TN",
    cityWithStateAbbr: "Arlington, TN",
  },
  {
    zip: "38004",
    ST: "TN",
    cityWithStateAbbr: "Atoka, TN",
  },
  {
    zip: "38006",
    ST: "TN",
    cityWithStateAbbr: "Bells, TN",
  },
  {
    zip: "38007",
    ST: "TN",
    cityWithStateAbbr: "Bogota, TN",
  },
  {
    zip: "38008",
    ST: "TN",
    cityWithStateAbbr: "Bolivar, TN",
  },
  {
    zip: "38010",
    ST: "TN",
    cityWithStateAbbr: "Braden, TN",
  },
  {
    zip: "38011",
    ST: "TN",
    cityWithStateAbbr: "Brighton, TN",
  },
  {
    zip: "38012",
    ST: "TN",
    cityWithStateAbbr: "Brownsville, TN",
  },
  {
    zip: "38014",
    ST: "TN",
    cityWithStateAbbr: "Brunswick, TN",
  },
  {
    zip: "38015",
    ST: "TN",
    cityWithStateAbbr: "Burlison, TN",
  },
  {
    zip: "38016",
    ST: "TN",
    cityWithStateAbbr: "Cordova, TN",
  },
  {
    zip: "38017",
    ST: "TN",
    cityWithStateAbbr: "Collierville, TN",
  },
  {
    zip: "38018",
    ST: "TN",
    cityWithStateAbbr: "Cordova, TN",
  },
  {
    zip: "38019",
    ST: "TN",
    cityWithStateAbbr: "Covington, TN",
  },
  {
    zip: "38021",
    ST: "TN",
    cityWithStateAbbr: "Crockett Mills, TN",
  },
  {
    zip: "38023",
    ST: "TN",
    cityWithStateAbbr: "Drummonds, TN",
  },
  {
    zip: "38024",
    ST: "TN",
    cityWithStateAbbr: "Dyersburg, TN",
  },
  {
    zip: "38025",
    ST: "TN",
    cityWithStateAbbr: "Dyersburg, TN",
  },
  {
    zip: "38027",
    ST: "TN",
    cityWithStateAbbr: "Collierville, TN",
  },
  {
    zip: "38028",
    ST: "TN",
    cityWithStateAbbr: "Eads, TN",
  },
  {
    zip: "38029",
    ST: "TN",
    cityWithStateAbbr: "Ellendale, TN",
  },
  {
    zip: "38030",
    ST: "TN",
    cityWithStateAbbr: "Finley, TN",
  },
  {
    zip: "38034",
    ST: "TN",
    cityWithStateAbbr: "Friendship, TN",
  },
  {
    zip: "38036",
    ST: "TN",
    cityWithStateAbbr: "Gallaway, TN",
  },
  {
    zip: "38037",
    ST: "TN",
    cityWithStateAbbr: "Gates, TN",
  },
  {
    zip: "38039",
    ST: "TN",
    cityWithStateAbbr: "Grand Junction, TN",
  },
  {
    zip: "38040",
    ST: "TN",
    cityWithStateAbbr: "Halls, TN",
  },
  {
    zip: "38041",
    ST: "TN",
    cityWithStateAbbr: "Henning, TN",
  },
  {
    zip: "38042",
    ST: "TN",
    cityWithStateAbbr: "Hickory Valley, TN",
  },
  {
    zip: "38044",
    ST: "TN",
    cityWithStateAbbr: "Hornsby, TN",
  },
  {
    zip: "38045",
    ST: "TN",
    cityWithStateAbbr: "Laconia, TN",
  },
  {
    zip: "38046",
    ST: "TN",
    cityWithStateAbbr: "La Grange, TN",
  },
  {
    zip: "38047",
    ST: "TN",
    cityWithStateAbbr: "Lenox, TN",
  },
  {
    zip: "38048",
    ST: "TN",
    cityWithStateAbbr: "Macon, TN",
  },
  {
    zip: "38049",
    ST: "TN",
    cityWithStateAbbr: "Mason, TN",
  },
  {
    zip: "38050",
    ST: "TN",
    cityWithStateAbbr: "Maury City, TN",
  },
  {
    zip: "38052",
    ST: "TN",
    cityWithStateAbbr: "Middleton, TN",
  },
  {
    zip: "38053",
    ST: "TN",
    cityWithStateAbbr: "Millington, TN",
  },
  {
    zip: "38054",
    ST: "TN",
    cityWithStateAbbr: "Millington, TN",
  },
  {
    zip: "38055",
    ST: "TN",
    cityWithStateAbbr: "Millington, TN",
  },
  {
    zip: "38057",
    ST: "TN",
    cityWithStateAbbr: "Moscow, TN",
  },
  {
    zip: "38058",
    ST: "TN",
    cityWithStateAbbr: "Munford, TN",
  },
  {
    zip: "38059",
    ST: "TN",
    cityWithStateAbbr: "Newbern, TN",
  },
  {
    zip: "38060",
    ST: "TN",
    cityWithStateAbbr: "Oakland, TN",
  },
  {
    zip: "38061",
    ST: "TN",
    cityWithStateAbbr: "Pocahontas, TN",
  },
  {
    zip: "38063",
    ST: "TN",
    cityWithStateAbbr: "Ripley, TN",
  },
  {
    zip: "38066",
    ST: "TN",
    cityWithStateAbbr: "Rossville, TN",
  },
  {
    zip: "38067",
    ST: "TN",
    cityWithStateAbbr: "Saulsbury, TN",
  },
  {
    zip: "38068",
    ST: "TN",
    cityWithStateAbbr: "Somerville, TN",
  },
  {
    zip: "38069",
    ST: "TN",
    cityWithStateAbbr: "Stanton, TN",
  },
  {
    zip: "38070",
    ST: "TN",
    cityWithStateAbbr: "Tigrett, TN",
  },
  {
    zip: "38071",
    ST: "TN",
    cityWithStateAbbr: "Tipton, TN",
  },
  {
    zip: "38075",
    ST: "TN",
    cityWithStateAbbr: "Whiteville, TN",
  },
  {
    zip: "38076",
    ST: "TN",
    cityWithStateAbbr: "Williston, TN",
  },
  {
    zip: "38077",
    ST: "TN",
    cityWithStateAbbr: "Wynnburg, TN",
  },
  {
    zip: "38079",
    ST: "TN",
    cityWithStateAbbr: "Tiptonville, TN",
  },
  {
    zip: "38080",
    ST: "TN",
    cityWithStateAbbr: "Ridgely, TN",
  },
  {
    zip: "38083",
    ST: "TN",
    cityWithStateAbbr: "Millington, TN",
  },
  {
    zip: "38088",
    ST: "TN",
    cityWithStateAbbr: "Cordova, TN",
  },
  {
    zip: "38101",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38103",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38104",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38105",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38106",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38107",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38108",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38109",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38111",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38112",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38113",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38114",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38115",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38116",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38117",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38118",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38119",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38120",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38122",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38124",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38125",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38126",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38127",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38128",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38130",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38131",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38132",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38133",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38134",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38135",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38136",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38137",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38138",
    ST: "TN",
    cityWithStateAbbr: "Germantown, TN",
  },
  {
    zip: "38139",
    ST: "TN",
    cityWithStateAbbr: "Germantown, TN",
  },
  {
    zip: "38141",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38145",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38147",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38148",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38150",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38151",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38152",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38157",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38159",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38161",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38163",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38166",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38167",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38168",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38173",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38174",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38175",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38177",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38181",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38182",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38183",
    ST: "TN",
    cityWithStateAbbr: "Germantown, TN",
  },
  {
    zip: "38184",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38186",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38187",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38188",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38190",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38193",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38194",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38197",
    ST: "TN",
    cityWithStateAbbr: "Memphis, TN",
  },
  {
    zip: "38201",
    ST: "TN",
    cityWithStateAbbr: "Mc Kenzie, TN",
  },
  {
    zip: "38220",
    ST: "TN",
    cityWithStateAbbr: "Atwood, TN",
  },
  {
    zip: "38221",
    ST: "TN",
    cityWithStateAbbr: "Big Sandy, TN",
  },
  {
    zip: "38222",
    ST: "TN",
    cityWithStateAbbr: "Buchanan, TN",
  },
  {
    zip: "38223",
    ST: "TN",
    cityWithStateAbbr: "Como, TN",
  },
  {
    zip: "38224",
    ST: "TN",
    cityWithStateAbbr: "Cottage Grove, TN",
  },
  {
    zip: "38225",
    ST: "TN",
    cityWithStateAbbr: "Dresden, TN",
  },
  {
    zip: "38226",
    ST: "TN",
    cityWithStateAbbr: "Dukedom, TN",
  },
  {
    zip: "38229",
    ST: "TN",
    cityWithStateAbbr: "Gleason, TN",
  },
  {
    zip: "38230",
    ST: "TN",
    cityWithStateAbbr: "Greenfield, TN",
  },
  {
    zip: "38231",
    ST: "TN",
    cityWithStateAbbr: "Henry, TN",
  },
  {
    zip: "38232",
    ST: "TN",
    cityWithStateAbbr: "Hornbeak, TN",
  },
  {
    zip: "38233",
    ST: "TN",
    cityWithStateAbbr: "Kenton, TN",
  },
  {
    zip: "38235",
    ST: "TN",
    cityWithStateAbbr: "Mc Lemoresville, TN",
  },
  {
    zip: "38236",
    ST: "TN",
    cityWithStateAbbr: "Mansfield, TN",
  },
  {
    zip: "38237",
    ST: "TN",
    cityWithStateAbbr: "Martin, TN",
  },
  {
    zip: "38238",
    ST: "TN",
    cityWithStateAbbr: "Martin, TN",
  },
  {
    zip: "38240",
    ST: "TN",
    cityWithStateAbbr: "Obion, TN",
  },
  {
    zip: "38241",
    ST: "TN",
    cityWithStateAbbr: "Palmersville, TN",
  },
  {
    zip: "38242",
    ST: "TN",
    cityWithStateAbbr: "Paris, TN",
  },
  {
    zip: "38251",
    ST: "TN",
    cityWithStateAbbr: "Puryear, TN",
  },
  {
    zip: "38253",
    ST: "TN",
    cityWithStateAbbr: "Rives, TN",
  },
  {
    zip: "38254",
    ST: "TN",
    cityWithStateAbbr: "Samburg, TN",
  },
  {
    zip: "38255",
    ST: "TN",
    cityWithStateAbbr: "Sharon, TN",
  },
  {
    zip: "38256",
    ST: "TN",
    cityWithStateAbbr: "Springville, TN",
  },
  {
    zip: "38257",
    ST: "TN",
    cityWithStateAbbr: "South Fulton, TN",
  },
  {
    zip: "38258",
    ST: "TN",
    cityWithStateAbbr: "Trezevant, TN",
  },
  {
    zip: "38259",
    ST: "TN",
    cityWithStateAbbr: "Trimble, TN",
  },
  {
    zip: "38260",
    ST: "TN",
    cityWithStateAbbr: "Troy, TN",
  },
  {
    zip: "38261",
    ST: "TN",
    cityWithStateAbbr: "Union City, TN",
  },
  {
    zip: "38271",
    ST: "TN",
    cityWithStateAbbr: "Woodland Mills, TN",
  },
  {
    zip: "38281",
    ST: "TN",
    cityWithStateAbbr: "Union City, TN",
  },
  {
    zip: "38301",
    ST: "TN",
    cityWithStateAbbr: "Jackson, TN",
  },
  {
    zip: "38302",
    ST: "TN",
    cityWithStateAbbr: "Jackson, TN",
  },
  {
    zip: "38303",
    ST: "TN",
    cityWithStateAbbr: "Jackson, TN",
  },
  {
    zip: "38305",
    ST: "TN",
    cityWithStateAbbr: "Jackson, TN",
  },
  {
    zip: "38308",
    ST: "TN",
    cityWithStateAbbr: "Jackson, TN",
  },
  {
    zip: "38310",
    ST: "TN",
    cityWithStateAbbr: "Adamsville, TN",
  },
  {
    zip: "38311",
    ST: "TN",
    cityWithStateAbbr: "Bath Springs, TN",
  },
  {
    zip: "38313",
    ST: "TN",
    cityWithStateAbbr: "Beech Bluff, TN",
  },
  {
    zip: "38314",
    ST: "TN",
    cityWithStateAbbr: "Jackson, TN",
  },
  {
    zip: "38315",
    ST: "TN",
    cityWithStateAbbr: "Bethel Springs, TN",
  },
  {
    zip: "38316",
    ST: "TN",
    cityWithStateAbbr: "Bradford, TN",
  },
  {
    zip: "38317",
    ST: "TN",
    cityWithStateAbbr: "Bruceton, TN",
  },
  {
    zip: "38318",
    ST: "TN",
    cityWithStateAbbr: "Buena Vista, TN",
  },
  {
    zip: "38320",
    ST: "TN",
    cityWithStateAbbr: "Camden, TN",
  },
  {
    zip: "38321",
    ST: "TN",
    cityWithStateAbbr: "Cedar Grove, TN",
  },
  {
    zip: "38324",
    ST: "TN",
    cityWithStateAbbr: "Clarksburg, TN",
  },
  {
    zip: "38326",
    ST: "TN",
    cityWithStateAbbr: "Counce, TN",
  },
  {
    zip: "38327",
    ST: "TN",
    cityWithStateAbbr: "Crump, TN",
  },
  {
    zip: "38328",
    ST: "TN",
    cityWithStateAbbr: "Darden, TN",
  },
  {
    zip: "38329",
    ST: "TN",
    cityWithStateAbbr: "Decaturville, TN",
  },
  {
    zip: "38330",
    ST: "TN",
    cityWithStateAbbr: "Dyer, TN",
  },
  {
    zip: "38331",
    ST: "TN",
    cityWithStateAbbr: "Eaton, TN",
  },
  {
    zip: "38332",
    ST: "TN",
    cityWithStateAbbr: "Enville, TN",
  },
  {
    zip: "38333",
    ST: "TN",
    cityWithStateAbbr: "Eva, TN",
  },
  {
    zip: "38334",
    ST: "TN",
    cityWithStateAbbr: "Finger, TN",
  },
  {
    zip: "38336",
    ST: "TN",
    cityWithStateAbbr: "Fruitvale, TN",
  },
  {
    zip: "38337",
    ST: "TN",
    cityWithStateAbbr: "Gadsden, TN",
  },
  {
    zip: "38338",
    ST: "TN",
    cityWithStateAbbr: "Gibson, TN",
  },
  {
    zip: "38339",
    ST: "TN",
    cityWithStateAbbr: "Guys, TN",
  },
  {
    zip: "38340",
    ST: "TN",
    cityWithStateAbbr: "Henderson, TN",
  },
  {
    zip: "38341",
    ST: "TN",
    cityWithStateAbbr: "Holladay, TN",
  },
  {
    zip: "38342",
    ST: "TN",
    cityWithStateAbbr: "Hollow Rock, TN",
  },
  {
    zip: "38343",
    ST: "TN",
    cityWithStateAbbr: "Humboldt, TN",
  },
  {
    zip: "38344",
    ST: "TN",
    cityWithStateAbbr: "Huntingdon, TN",
  },
  {
    zip: "38345",
    ST: "TN",
    cityWithStateAbbr: "Huron, TN",
  },
  {
    zip: "38346",
    ST: "TN",
    cityWithStateAbbr: "Idlewild, TN",
  },
  {
    zip: "38347",
    ST: "TN",
    cityWithStateAbbr: "Jacks Creek, TN",
  },
  {
    zip: "38348",
    ST: "TN",
    cityWithStateAbbr: "Lavinia, TN",
  },
  {
    zip: "38351",
    ST: "TN",
    cityWithStateAbbr: "Lexington, TN",
  },
  {
    zip: "38352",
    ST: "TN",
    cityWithStateAbbr: "Luray, TN",
  },
  {
    zip: "38355",
    ST: "TN",
    cityWithStateAbbr: "Medina, TN",
  },
  {
    zip: "38356",
    ST: "TN",
    cityWithStateAbbr: "Medon, TN",
  },
  {
    zip: "38357",
    ST: "TN",
    cityWithStateAbbr: "Michie, TN",
  },
  {
    zip: "38358",
    ST: "TN",
    cityWithStateAbbr: "Milan, TN",
  },
  {
    zip: "38359",
    ST: "TN",
    cityWithStateAbbr: "Milledgeville, TN",
  },
  {
    zip: "38361",
    ST: "TN",
    cityWithStateAbbr: "Morris Chapel, TN",
  },
  {
    zip: "38362",
    ST: "TN",
    cityWithStateAbbr: "Oakfield, TN",
  },
  {
    zip: "38363",
    ST: "TN",
    cityWithStateAbbr: "Parsons, TN",
  },
  {
    zip: "38365",
    ST: "TN",
    cityWithStateAbbr: "Pickwick Dam, TN",
  },
  {
    zip: "38366",
    ST: "TN",
    cityWithStateAbbr: "Pinson, TN",
  },
  {
    zip: "38367",
    ST: "TN",
    cityWithStateAbbr: "Ramer, TN",
  },
  {
    zip: "38368",
    ST: "TN",
    cityWithStateAbbr: "Reagan, TN",
  },
  {
    zip: "38369",
    ST: "TN",
    cityWithStateAbbr: "Rutherford, TN",
  },
  {
    zip: "38370",
    ST: "TN",
    cityWithStateAbbr: "Saltillo, TN",
  },
  {
    zip: "38371",
    ST: "TN",
    cityWithStateAbbr: "Sardis, TN",
  },
  {
    zip: "38372",
    ST: "TN",
    cityWithStateAbbr: "Savannah, TN",
  },
  {
    zip: "38374",
    ST: "TN",
    cityWithStateAbbr: "Scotts Hill, TN",
  },
  {
    zip: "38375",
    ST: "TN",
    cityWithStateAbbr: "Selmer, TN",
  },
  {
    zip: "38376",
    ST: "TN",
    cityWithStateAbbr: "Shiloh, TN",
  },
  {
    zip: "38377",
    ST: "TN",
    cityWithStateAbbr: "Silerton, TN",
  },
  {
    zip: "38378",
    ST: "TN",
    cityWithStateAbbr: "Spring Creek, TN",
  },
  {
    zip: "38379",
    ST: "TN",
    cityWithStateAbbr: "Stantonville, TN",
  },
  {
    zip: "38380",
    ST: "TN",
    cityWithStateAbbr: "Sugar Tree, TN",
  },
  {
    zip: "38381",
    ST: "TN",
    cityWithStateAbbr: "Toone, TN",
  },
  {
    zip: "38382",
    ST: "TN",
    cityWithStateAbbr: "Trenton, TN",
  },
  {
    zip: "38387",
    ST: "TN",
    cityWithStateAbbr: "Westport, TN",
  },
  {
    zip: "38388",
    ST: "TN",
    cityWithStateAbbr: "Wildersville, TN",
  },
  {
    zip: "38389",
    ST: "TN",
    cityWithStateAbbr: "Yorkville, TN",
  },
  {
    zip: "38390",
    ST: "TN",
    cityWithStateAbbr: "Yuma, TN",
  },
  {
    zip: "38391",
    ST: "TN",
    cityWithStateAbbr: "Denmark, TN",
  },
  {
    zip: "38392",
    ST: "TN",
    cityWithStateAbbr: "Mercer, TN",
  },
  {
    zip: "38393",
    ST: "TN",
    cityWithStateAbbr: "Chewalla, TN",
  },
  {
    zip: "38401",
    ST: "TN",
    cityWithStateAbbr: "Columbia, TN",
  },
  {
    zip: "38402",
    ST: "TN",
    cityWithStateAbbr: "Columbia, TN",
  },
  {
    zip: "38425",
    ST: "TN",
    cityWithStateAbbr: "Clifton, TN",
  },
  {
    zip: "38449",
    ST: "TN",
    cityWithStateAbbr: "Ardmore, TN",
  },
  {
    zip: "38450",
    ST: "TN",
    cityWithStateAbbr: "Collinwood, TN",
  },
  {
    zip: "38451",
    ST: "TN",
    cityWithStateAbbr: "Culleoka, TN",
  },
  {
    zip: "38452",
    ST: "TN",
    cityWithStateAbbr: "Cypress Inn, TN",
  },
  {
    zip: "38453",
    ST: "TN",
    cityWithStateAbbr: "Dellrose, TN",
  },
  {
    zip: "38454",
    ST: "TN",
    cityWithStateAbbr: "Duck River, TN",
  },
  {
    zip: "38455",
    ST: "TN",
    cityWithStateAbbr: "Elkton, TN",
  },
  {
    zip: "38456",
    ST: "TN",
    cityWithStateAbbr: "Ethridge, TN",
  },
  {
    zip: "38457",
    ST: "TN",
    cityWithStateAbbr: "Five Points, TN",
  },
  {
    zip: "38459",
    ST: "TN",
    cityWithStateAbbr: "Frankewing, TN",
  },
  {
    zip: "38460",
    ST: "TN",
    cityWithStateAbbr: "Goodspring, TN",
  },
  {
    zip: "38461",
    ST: "TN",
    cityWithStateAbbr: "Hampshire, TN",
  },
  {
    zip: "38462",
    ST: "TN",
    cityWithStateAbbr: "Hohenwald, TN",
  },
  {
    zip: "38463",
    ST: "TN",
    cityWithStateAbbr: "Iron City, TN",
  },
  {
    zip: "38464",
    ST: "TN",
    cityWithStateAbbr: "Lawrenceburg, TN",
  },
  {
    zip: "38468",
    ST: "TN",
    cityWithStateAbbr: "Leoma, TN",
  },
  {
    zip: "38469",
    ST: "TN",
    cityWithStateAbbr: "Loretto, TN",
  },
  {
    zip: "38471",
    ST: "TN",
    cityWithStateAbbr: "Lutts, TN",
  },
  {
    zip: "38472",
    ST: "TN",
    cityWithStateAbbr: "Lynnville, TN",
  },
  {
    zip: "38473",
    ST: "TN",
    cityWithStateAbbr: "Minor Hill, TN",
  },
  {
    zip: "38474",
    ST: "TN",
    cityWithStateAbbr: "Mount Pleasant, TN",
  },
  {
    zip: "38475",
    ST: "TN",
    cityWithStateAbbr: "Olivehill, TN",
  },
  {
    zip: "38476",
    ST: "TN",
    cityWithStateAbbr: "Primm Springs, TN",
  },
  {
    zip: "38477",
    ST: "TN",
    cityWithStateAbbr: "Prospect, TN",
  },
  {
    zip: "38478",
    ST: "TN",
    cityWithStateAbbr: "Pulaski, TN",
  },
  {
    zip: "38481",
    ST: "TN",
    cityWithStateAbbr: "Saint Joseph, TN",
  },
  {
    zip: "38482",
    ST: "TN",
    cityWithStateAbbr: "Santa Fe, TN",
  },
  {
    zip: "38483",
    ST: "TN",
    cityWithStateAbbr: "Summertown, TN",
  },
  {
    zip: "38485",
    ST: "TN",
    cityWithStateAbbr: "Waynesboro, TN",
  },
  {
    zip: "38486",
    ST: "TN",
    cityWithStateAbbr: "Westpoint, TN",
  },
  {
    zip: "38487",
    ST: "TN",
    cityWithStateAbbr: "Williamsport, TN",
  },
  {
    zip: "38488",
    ST: "TN",
    cityWithStateAbbr: "Taft, TN",
  },
  {
    zip: "38501",
    ST: "TN",
    cityWithStateAbbr: "Cookeville, TN",
  },
  {
    zip: "38502",
    ST: "TN",
    cityWithStateAbbr: "Cookeville, TN",
  },
  {
    zip: "38503",
    ST: "TN",
    cityWithStateAbbr: "Cookeville, TN",
  },
  {
    zip: "38504",
    ST: "TN",
    cityWithStateAbbr: "Allardt, TN",
  },
  {
    zip: "38505",
    ST: "TN",
    cityWithStateAbbr: "Cookeville, TN",
  },
  {
    zip: "38506",
    ST: "TN",
    cityWithStateAbbr: "Cookeville, TN",
  },
  {
    zip: "38541",
    ST: "TN",
    cityWithStateAbbr: "Allons, TN",
  },
  {
    zip: "38542",
    ST: "TN",
    cityWithStateAbbr: "Allred, TN",
  },
  {
    zip: "38543",
    ST: "TN",
    cityWithStateAbbr: "Alpine, TN",
  },
  {
    zip: "38544",
    ST: "TN",
    cityWithStateAbbr: "Baxter, TN",
  },
  {
    zip: "38545",
    ST: "TN",
    cityWithStateAbbr: "Bloomington Springs, TN",
  },
  {
    zip: "38547",
    ST: "TN",
    cityWithStateAbbr: "Brush Creek, TN",
  },
  {
    zip: "38548",
    ST: "TN",
    cityWithStateAbbr: "Buffalo Valley, TN",
  },
  {
    zip: "38549",
    ST: "TN",
    cityWithStateAbbr: "Byrdstown, TN",
  },
  {
    zip: "38550",
    ST: "TN",
    cityWithStateAbbr: "Campaign, TN",
  },
  {
    zip: "38551",
    ST: "TN",
    cityWithStateAbbr: "Celina, TN",
  },
  {
    zip: "38552",
    ST: "TN",
    cityWithStateAbbr: "Chestnut Mound, TN",
  },
  {
    zip: "38553",
    ST: "TN",
    cityWithStateAbbr: "Clarkrange, TN",
  },
  {
    zip: "38554",
    ST: "TN",
    cityWithStateAbbr: "Crawford, TN",
  },
  {
    zip: "38555",
    ST: "TN",
    cityWithStateAbbr: "Crossville, TN",
  },
  {
    zip: "38556",
    ST: "TN",
    cityWithStateAbbr: "Jamestown, TN",
  },
  {
    zip: "38557",
    ST: "TN",
    cityWithStateAbbr: "Crossville, TN",
  },
  {
    zip: "38558",
    ST: "TN",
    cityWithStateAbbr: "Crossville, TN",
  },
  {
    zip: "38559",
    ST: "TN",
    cityWithStateAbbr: "Doyle, TN",
  },
  {
    zip: "38560",
    ST: "TN",
    cityWithStateAbbr: "Elmwood, TN",
  },
  {
    zip: "38562",
    ST: "TN",
    cityWithStateAbbr: "Gainesboro, TN",
  },
  {
    zip: "38563",
    ST: "TN",
    cityWithStateAbbr: "Gordonsville, TN",
  },
  {
    zip: "38564",
    ST: "TN",
    cityWithStateAbbr: "Granville, TN",
  },
  {
    zip: "38565",
    ST: "TN",
    cityWithStateAbbr: "Grimsley, TN",
  },
  {
    zip: "38567",
    ST: "TN",
    cityWithStateAbbr: "Hickman, TN",
  },
  {
    zip: "38568",
    ST: "TN",
    cityWithStateAbbr: "Hilham, TN",
  },
  {
    zip: "38569",
    ST: "TN",
    cityWithStateAbbr: "Lancaster, TN",
  },
  {
    zip: "38570",
    ST: "TN",
    cityWithStateAbbr: "Livingston, TN",
  },
  {
    zip: "38571",
    ST: "TN",
    cityWithStateAbbr: "Crossville, TN",
  },
  {
    zip: "38572",
    ST: "TN",
    cityWithStateAbbr: "Crossville, TN",
  },
  {
    zip: "38573",
    ST: "TN",
    cityWithStateAbbr: "Monroe, TN",
  },
  {
    zip: "38574",
    ST: "TN",
    cityWithStateAbbr: "Monterey, TN",
  },
  {
    zip: "38575",
    ST: "TN",
    cityWithStateAbbr: "Moss, TN",
  },
  {
    zip: "38577",
    ST: "TN",
    cityWithStateAbbr: "Pall Mall, TN",
  },
  {
    zip: "38578",
    ST: "TN",
    cityWithStateAbbr: "Pleasant Hill, TN",
  },
  {
    zip: "38579",
    ST: "TN",
    cityWithStateAbbr: "Quebeck, TN",
  },
  {
    zip: "38580",
    ST: "TN",
    cityWithStateAbbr: "Rickman, TN",
  },
  {
    zip: "38581",
    ST: "TN",
    cityWithStateAbbr: "Rock Island, TN",
  },
  {
    zip: "38582",
    ST: "TN",
    cityWithStateAbbr: "Silver Point, TN",
  },
  {
    zip: "38583",
    ST: "TN",
    cityWithStateAbbr: "Sparta, TN",
  },
  {
    zip: "38585",
    ST: "TN",
    cityWithStateAbbr: "Spencer, TN",
  },
  {
    zip: "38587",
    ST: "TN",
    cityWithStateAbbr: "Walling, TN",
  },
  {
    zip: "38588",
    ST: "TN",
    cityWithStateAbbr: "Whitleyville, TN",
  },
  {
    zip: "38589",
    ST: "TN",
    cityWithStateAbbr: "Wilder, TN",
  },
  {
    zip: "38601",
    ST: "MS",
    cityWithStateAbbr: "Abbeville, MS",
  },
  {
    zip: "38602",
    ST: "MS",
    cityWithStateAbbr: "Arkabutla, MS",
  },
  {
    zip: "38603",
    ST: "MS",
    cityWithStateAbbr: "Ashland, MS",
  },
  {
    zip: "38606",
    ST: "MS",
    cityWithStateAbbr: "Batesville, MS",
  },
  {
    zip: "38609",
    ST: "MS",
    cityWithStateAbbr: "Marks, MS",
  },
  {
    zip: "38610",
    ST: "MS",
    cityWithStateAbbr: "Blue Mountain, MS",
  },
  {
    zip: "38611",
    ST: "MS",
    cityWithStateAbbr: "Byhalia, MS",
  },
  {
    zip: "38614",
    ST: "MS",
    cityWithStateAbbr: "Clarksdale, MS",
  },
  {
    zip: "38617",
    ST: "MS",
    cityWithStateAbbr: "Coahoma, MS",
  },
  {
    zip: "38618",
    ST: "MS",
    cityWithStateAbbr: "Coldwater, MS",
  },
  {
    zip: "38619",
    ST: "MS",
    cityWithStateAbbr: "Como, MS",
  },
  {
    zip: "38620",
    ST: "MS",
    cityWithStateAbbr: "Courtland, MS",
  },
  {
    zip: "38621",
    ST: "MS",
    cityWithStateAbbr: "Crenshaw, MS",
  },
  {
    zip: "38622",
    ST: "MS",
    cityWithStateAbbr: "Crowder, MS",
  },
  {
    zip: "38623",
    ST: "MS",
    cityWithStateAbbr: "Darling, MS",
  },
  {
    zip: "38625",
    ST: "MS",
    cityWithStateAbbr: "Dumas, MS",
  },
  {
    zip: "38626",
    ST: "MS",
    cityWithStateAbbr: "Dundee, MS",
  },
  {
    zip: "38627",
    ST: "MS",
    cityWithStateAbbr: "Etta, MS",
  },
  {
    zip: "38628",
    ST: "MS",
    cityWithStateAbbr: "Sledge, MS",
  },
  {
    zip: "38629",
    ST: "MS",
    cityWithStateAbbr: "Falkner, MS",
  },
  {
    zip: "38630",
    ST: "MS",
    cityWithStateAbbr: "Farrell, MS",
  },
  {
    zip: "38631",
    ST: "MS",
    cityWithStateAbbr: "Friars Point, MS",
  },
  {
    zip: "38632",
    ST: "MS",
    cityWithStateAbbr: "Hernando, MS",
  },
  {
    zip: "38633",
    ST: "MS",
    cityWithStateAbbr: "Hickory Flat, MS",
  },
  {
    zip: "38634",
    ST: "MS",
    cityWithStateAbbr: "Holly Springs, MS",
  },
  {
    zip: "38635",
    ST: "MS",
    cityWithStateAbbr: "Holly Springs, MS",
  },
  {
    zip: "38637",
    ST: "MS",
    cityWithStateAbbr: "Horn Lake, MS",
  },
  {
    zip: "38638",
    ST: "MS",
    cityWithStateAbbr: "Independence, MS",
  },
  {
    zip: "38639",
    ST: "MS",
    cityWithStateAbbr: "Jonestown, MS",
  },
  {
    zip: "38641",
    ST: "MS",
    cityWithStateAbbr: "Lake Cormorant, MS",
  },
  {
    zip: "38642",
    ST: "MS",
    cityWithStateAbbr: "Lamar, MS",
  },
  {
    zip: "38643",
    ST: "MS",
    cityWithStateAbbr: "Lambert, MS",
  },
  {
    zip: "38644",
    ST: "MS",
    cityWithStateAbbr: "Lula, MS",
  },
  {
    zip: "38645",
    ST: "MS",
    cityWithStateAbbr: "Lyon, MS",
  },
  {
    zip: "38646",
    ST: "MS",
    cityWithStateAbbr: "Marks, MS",
  },
  {
    zip: "38647",
    ST: "MS",
    cityWithStateAbbr: "Michigan City, MS",
  },
  {
    zip: "38649",
    ST: "MS",
    cityWithStateAbbr: "Mount Pleasant, MS",
  },
  {
    zip: "38650",
    ST: "MS",
    cityWithStateAbbr: "Myrtle, MS",
  },
  {
    zip: "38651",
    ST: "MS",
    cityWithStateAbbr: "Nesbit, MS",
  },
  {
    zip: "38652",
    ST: "MS",
    cityWithStateAbbr: "New Albany, MS",
  },
  {
    zip: "38654",
    ST: "MS",
    cityWithStateAbbr: "Olive Branch, MS",
  },
  {
    zip: "38655",
    ST: "MS",
    cityWithStateAbbr: "Oxford, MS",
  },
  {
    zip: "38658",
    ST: "MS",
    cityWithStateAbbr: "Pope, MS",
  },
  {
    zip: "38659",
    ST: "MS",
    cityWithStateAbbr: "Potts Camp, MS",
  },
  {
    zip: "38661",
    ST: "MS",
    cityWithStateAbbr: "Red Banks, MS",
  },
  {
    zip: "38663",
    ST: "MS",
    cityWithStateAbbr: "Ripley, MS",
  },
  {
    zip: "38664",
    ST: "MS",
    cityWithStateAbbr: "Robinsonville, MS",
  },
  {
    zip: "38665",
    ST: "MS",
    cityWithStateAbbr: "Sarah, MS",
  },
  {
    zip: "38666",
    ST: "MS",
    cityWithStateAbbr: "Sardis, MS",
  },
  {
    zip: "38668",
    ST: "MS",
    cityWithStateAbbr: "Senatobia, MS",
  },
  {
    zip: "38669",
    ST: "MS",
    cityWithStateAbbr: "Sherard, MS",
  },
  {
    zip: "38670",
    ST: "MS",
    cityWithStateAbbr: "Sledge, MS",
  },
  {
    zip: "38671",
    ST: "MS",
    cityWithStateAbbr: "Southaven, MS",
  },
  {
    zip: "38672",
    ST: "MS",
    cityWithStateAbbr: "Southaven, MS",
  },
  {
    zip: "38673",
    ST: "MS",
    cityWithStateAbbr: "Taylor, MS",
  },
  {
    zip: "38674",
    ST: "MS",
    cityWithStateAbbr: "Tiplersville, MS",
  },
  {
    zip: "38675",
    ST: "MS",
    cityWithStateAbbr: "Oxford, MS",
  },
  {
    zip: "38676",
    ST: "MS",
    cityWithStateAbbr: "Tunica, MS",
  },
  {
    zip: "38677",
    ST: "MS",
    cityWithStateAbbr: "University, MS",
  },
  {
    zip: "38679",
    ST: "MS",
    cityWithStateAbbr: "Victoria, MS",
  },
  {
    zip: "38680",
    ST: "MS",
    cityWithStateAbbr: "Walls, MS",
  },
  {
    zip: "38683",
    ST: "MS",
    cityWithStateAbbr: "Walnut, MS",
  },
  {
    zip: "38685",
    ST: "MS",
    cityWithStateAbbr: "Waterford, MS",
  },
  {
    zip: "38686",
    ST: "MS",
    cityWithStateAbbr: "Walls, MS",
  },
  {
    zip: "38701",
    ST: "MS",
    cityWithStateAbbr: "Greenville, MS",
  },
  {
    zip: "38702",
    ST: "MS",
    cityWithStateAbbr: "Greenville, MS",
  },
  {
    zip: "38703",
    ST: "MS",
    cityWithStateAbbr: "Greenville, MS",
  },
  {
    zip: "38704",
    ST: "MS",
    cityWithStateAbbr: "Greenville, MS",
  },
  {
    zip: "38720",
    ST: "MS",
    cityWithStateAbbr: "Alligator, MS",
  },
  {
    zip: "38721",
    ST: "MS",
    cityWithStateAbbr: "Anguilla, MS",
  },
  {
    zip: "38722",
    ST: "MS",
    cityWithStateAbbr: "Arcola, MS",
  },
  {
    zip: "38723",
    ST: "MS",
    cityWithStateAbbr: "Avon, MS",
  },
  {
    zip: "38725",
    ST: "MS",
    cityWithStateAbbr: "Benoit, MS",
  },
  {
    zip: "38726",
    ST: "MS",
    cityWithStateAbbr: "Beulah, MS",
  },
  {
    zip: "38730",
    ST: "MS",
    cityWithStateAbbr: "Boyle, MS",
  },
  {
    zip: "38731",
    ST: "MS",
    cityWithStateAbbr: "Chatham, MS",
  },
  {
    zip: "38732",
    ST: "MS",
    cityWithStateAbbr: "Cleveland, MS",
  },
  {
    zip: "38733",
    ST: "MS",
    cityWithStateAbbr: "Cleveland, MS",
  },
  {
    zip: "38736",
    ST: "MS",
    cityWithStateAbbr: "Doddsville, MS",
  },
  {
    zip: "38737",
    ST: "MS",
    cityWithStateAbbr: "Drew, MS",
  },
  {
    zip: "38738",
    ST: "MS",
    cityWithStateAbbr: "Parchman, MS",
  },
  {
    zip: "38739",
    ST: "MS",
    cityWithStateAbbr: "Dublin, MS",
  },
  {
    zip: "38740",
    ST: "MS",
    cityWithStateAbbr: "Duncan, MS",
  },
  {
    zip: "38744",
    ST: "MS",
    cityWithStateAbbr: "Glen Allan, MS",
  },
  {
    zip: "38745",
    ST: "MS",
    cityWithStateAbbr: "Grace, MS",
  },
  {
    zip: "38746",
    ST: "MS",
    cityWithStateAbbr: "Gunnison, MS",
  },
  {
    zip: "38748",
    ST: "MS",
    cityWithStateAbbr: "Hollandale, MS",
  },
  {
    zip: "38749",
    ST: "MS",
    cityWithStateAbbr: "Indianola, MS",
  },
  {
    zip: "38751",
    ST: "MS",
    cityWithStateAbbr: "Indianola, MS",
  },
  {
    zip: "38753",
    ST: "MS",
    cityWithStateAbbr: "Inverness, MS",
  },
  {
    zip: "38754",
    ST: "MS",
    cityWithStateAbbr: "Isola, MS",
  },
  {
    zip: "38756",
    ST: "MS",
    cityWithStateAbbr: "Leland, MS",
  },
  {
    zip: "38759",
    ST: "MS",
    cityWithStateAbbr: "Merigold, MS",
  },
  {
    zip: "38760",
    ST: "MS",
    cityWithStateAbbr: "Metcalfe, MS",
  },
  {
    zip: "38761",
    ST: "MS",
    cityWithStateAbbr: "Moorhead, MS",
  },
  {
    zip: "38762",
    ST: "MS",
    cityWithStateAbbr: "Mound Bayou, MS",
  },
  {
    zip: "38764",
    ST: "MS",
    cityWithStateAbbr: "Pace, MS",
  },
  {
    zip: "38765",
    ST: "MS",
    cityWithStateAbbr: "Panther Burn, MS",
  },
  {
    zip: "38767",
    ST: "MS",
    cityWithStateAbbr: "Rena Lara, MS",
  },
  {
    zip: "38768",
    ST: "MS",
    cityWithStateAbbr: "Rome, MS",
  },
  {
    zip: "38769",
    ST: "MS",
    cityWithStateAbbr: "Rosedale, MS",
  },
  {
    zip: "38771",
    ST: "MS",
    cityWithStateAbbr: "Ruleville, MS",
  },
  {
    zip: "38772",
    ST: "MS",
    cityWithStateAbbr: "Scott, MS",
  },
  {
    zip: "38773",
    ST: "MS",
    cityWithStateAbbr: "Shaw, MS",
  },
  {
    zip: "38774",
    ST: "MS",
    cityWithStateAbbr: "Shelby, MS",
  },
  {
    zip: "38776",
    ST: "MS",
    cityWithStateAbbr: "Stoneville, MS",
  },
  {
    zip: "38778",
    ST: "MS",
    cityWithStateAbbr: "Sunflower, MS",
  },
  {
    zip: "38780",
    ST: "MS",
    cityWithStateAbbr: "Wayside, MS",
  },
  {
    zip: "38781",
    ST: "MS",
    cityWithStateAbbr: "Winstonville, MS",
  },
  {
    zip: "38782",
    ST: "MS",
    cityWithStateAbbr: "Winterville, MS",
  },
  {
    zip: "38801",
    ST: "MS",
    cityWithStateAbbr: "Tupelo, MS",
  },
  {
    zip: "38802",
    ST: "MS",
    cityWithStateAbbr: "Tupelo, MS",
  },
  {
    zip: "38803",
    ST: "MS",
    cityWithStateAbbr: "Tupelo, MS",
  },
  {
    zip: "38804",
    ST: "MS",
    cityWithStateAbbr: "Tupelo, MS",
  },
  {
    zip: "38820",
    ST: "MS",
    cityWithStateAbbr: "Algoma, MS",
  },
  {
    zip: "38821",
    ST: "MS",
    cityWithStateAbbr: "Amory, MS",
  },
  {
    zip: "38824",
    ST: "MS",
    cityWithStateAbbr: "Baldwyn, MS",
  },
  {
    zip: "38825",
    ST: "MS",
    cityWithStateAbbr: "Becker, MS",
  },
  {
    zip: "38826",
    ST: "MS",
    cityWithStateAbbr: "Belden, MS",
  },
  {
    zip: "38827",
    ST: "MS",
    cityWithStateAbbr: "Belmont, MS",
  },
  {
    zip: "38828",
    ST: "MS",
    cityWithStateAbbr: "Blue Springs, MS",
  },
  {
    zip: "38829",
    ST: "MS",
    cityWithStateAbbr: "Booneville, MS",
  },
  {
    zip: "38833",
    ST: "MS",
    cityWithStateAbbr: "Burnsville, MS",
  },
  {
    zip: "38834",
    ST: "MS",
    cityWithStateAbbr: "Corinth, MS",
  },
  {
    zip: "38835",
    ST: "MS",
    cityWithStateAbbr: "Corinth, MS",
  },
  {
    zip: "38838",
    ST: "MS",
    cityWithStateAbbr: "Dennis, MS",
  },
  {
    zip: "38839",
    ST: "MS",
    cityWithStateAbbr: "Derma, MS",
  },
  {
    zip: "38841",
    ST: "MS",
    cityWithStateAbbr: "Ecru, MS",
  },
  {
    zip: "38843",
    ST: "MS",
    cityWithStateAbbr: "Fulton, MS",
  },
  {
    zip: "38844",
    ST: "MS",
    cityWithStateAbbr: "Gattman, MS",
  },
  {
    zip: "38846",
    ST: "MS",
    cityWithStateAbbr: "Glen, MS",
  },
  {
    zip: "38847",
    ST: "MS",
    cityWithStateAbbr: "Golden, MS",
  },
  {
    zip: "38848",
    ST: "MS",
    cityWithStateAbbr: "Greenwood Springs, MS",
  },
  {
    zip: "38849",
    ST: "MS",
    cityWithStateAbbr: "Guntown, MS",
  },
  {
    zip: "38850",
    ST: "MS",
    cityWithStateAbbr: "Houlka, MS",
  },
  {
    zip: "38851",
    ST: "MS",
    cityWithStateAbbr: "Houston, MS",
  },
  {
    zip: "38852",
    ST: "MS",
    cityWithStateAbbr: "Iuka, MS",
  },
  {
    zip: "38855",
    ST: "MS",
    cityWithStateAbbr: "Mantachie, MS",
  },
  {
    zip: "38856",
    ST: "MS",
    cityWithStateAbbr: "Marietta, MS",
  },
  {
    zip: "38857",
    ST: "MS",
    cityWithStateAbbr: "Mooreville, MS",
  },
  {
    zip: "38858",
    ST: "MS",
    cityWithStateAbbr: "Nettleton, MS",
  },
  {
    zip: "38859",
    ST: "MS",
    cityWithStateAbbr: "New Site, MS",
  },
  {
    zip: "38860",
    ST: "MS",
    cityWithStateAbbr: "Okolona, MS",
  },
  {
    zip: "38862",
    ST: "MS",
    cityWithStateAbbr: "Plantersville, MS",
  },
  {
    zip: "38863",
    ST: "MS",
    cityWithStateAbbr: "Pontotoc, MS",
  },
  {
    zip: "38864",
    ST: "MS",
    cityWithStateAbbr: "Randolph, MS",
  },
  {
    zip: "38865",
    ST: "MS",
    cityWithStateAbbr: "Rienzi, MS",
  },
  {
    zip: "38866",
    ST: "MS",
    cityWithStateAbbr: "Saltillo, MS",
  },
  {
    zip: "38868",
    ST: "MS",
    cityWithStateAbbr: "Shannon, MS",
  },
  {
    zip: "38869",
    ST: "MS",
    cityWithStateAbbr: "Sherman, MS",
  },
  {
    zip: "38870",
    ST: "MS",
    cityWithStateAbbr: "Smithville, MS",
  },
  {
    zip: "38871",
    ST: "MS",
    cityWithStateAbbr: "Thaxton, MS",
  },
  {
    zip: "38873",
    ST: "MS",
    cityWithStateAbbr: "Tishomingo, MS",
  },
  {
    zip: "38874",
    ST: "MS",
    cityWithStateAbbr: "Toccopola, MS",
  },
  {
    zip: "38875",
    ST: "MS",
    cityWithStateAbbr: "Trebloc, MS",
  },
  {
    zip: "38876",
    ST: "MS",
    cityWithStateAbbr: "Tremont, MS",
  },
  {
    zip: "38877",
    ST: "MS",
    cityWithStateAbbr: "Van Vleet, MS",
  },
  {
    zip: "38878",
    ST: "MS",
    cityWithStateAbbr: "Vardaman, MS",
  },
  {
    zip: "38879",
    ST: "MS",
    cityWithStateAbbr: "Verona, MS",
  },
  {
    zip: "38880",
    ST: "MS",
    cityWithStateAbbr: "Wheeler, MS",
  },
  {
    zip: "38901",
    ST: "MS",
    cityWithStateAbbr: "Grenada, MS",
  },
  {
    zip: "38902",
    ST: "MS",
    cityWithStateAbbr: "Grenada, MS",
  },
  {
    zip: "38913",
    ST: "MS",
    cityWithStateAbbr: "Banner, MS",
  },
  {
    zip: "38914",
    ST: "MS",
    cityWithStateAbbr: "Big Creek, MS",
  },
  {
    zip: "38915",
    ST: "MS",
    cityWithStateAbbr: "Bruce, MS",
  },
  {
    zip: "38916",
    ST: "MS",
    cityWithStateAbbr: "Calhoun City, MS",
  },
  {
    zip: "38917",
    ST: "MS",
    cityWithStateAbbr: "Carrollton, MS",
  },
  {
    zip: "38920",
    ST: "MS",
    cityWithStateAbbr: "Cascilla, MS",
  },
  {
    zip: "38921",
    ST: "MS",
    cityWithStateAbbr: "Charleston, MS",
  },
  {
    zip: "38922",
    ST: "MS",
    cityWithStateAbbr: "Coffeeville, MS",
  },
  {
    zip: "38923",
    ST: "MS",
    cityWithStateAbbr: "Coila, MS",
  },
  {
    zip: "38924",
    ST: "MS",
    cityWithStateAbbr: "Cruger, MS",
  },
  {
    zip: "38925",
    ST: "MS",
    cityWithStateAbbr: "Duck Hill, MS",
  },
  {
    zip: "38926",
    ST: "MS",
    cityWithStateAbbr: "Elliott, MS",
  },
  {
    zip: "38927",
    ST: "MS",
    cityWithStateAbbr: "Enid, MS",
  },
  {
    zip: "38928",
    ST: "MS",
    cityWithStateAbbr: "Glendora, MS",
  },
  {
    zip: "38929",
    ST: "MS",
    cityWithStateAbbr: "Gore Springs, MS",
  },
  {
    zip: "38930",
    ST: "MS",
    cityWithStateAbbr: "Greenwood, MS",
  },
  {
    zip: "38935",
    ST: "MS",
    cityWithStateAbbr: "Greenwood, MS",
  },
  {
    zip: "38940",
    ST: "MS",
    cityWithStateAbbr: "Holcomb, MS",
  },
  {
    zip: "38941",
    ST: "MS",
    cityWithStateAbbr: "Itta Bena, MS",
  },
  {
    zip: "38943",
    ST: "MS",
    cityWithStateAbbr: "Mc Carley, MS",
  },
  {
    zip: "38944",
    ST: "MS",
    cityWithStateAbbr: "Minter City, MS",
  },
  {
    zip: "38945",
    ST: "MS",
    cityWithStateAbbr: "Greenwood, MS",
  },
  {
    zip: "38946",
    ST: "MS",
    cityWithStateAbbr: "Morgan City, MS",
  },
  {
    zip: "38947",
    ST: "MS",
    cityWithStateAbbr: "North Carrollton, MS",
  },
  {
    zip: "38948",
    ST: "MS",
    cityWithStateAbbr: "Oakland, MS",
  },
  {
    zip: "38949",
    ST: "MS",
    cityWithStateAbbr: "Paris, MS",
  },
  {
    zip: "38950",
    ST: "MS",
    cityWithStateAbbr: "Philipp, MS",
  },
  {
    zip: "38951",
    ST: "MS",
    cityWithStateAbbr: "Pittsboro, MS",
  },
  {
    zip: "38952",
    ST: "MS",
    cityWithStateAbbr: "Schlater, MS",
  },
  {
    zip: "38953",
    ST: "MS",
    cityWithStateAbbr: "Scobey, MS",
  },
  {
    zip: "38954",
    ST: "MS",
    cityWithStateAbbr: "Sidon, MS",
  },
  {
    zip: "38955",
    ST: "MS",
    cityWithStateAbbr: "Slate Spring, MS",
  },
  {
    zip: "38957",
    ST: "MS",
    cityWithStateAbbr: "Sumner, MS",
  },
  {
    zip: "38958",
    ST: "MS",
    cityWithStateAbbr: "Swan Lake, MS",
  },
  {
    zip: "38959",
    ST: "MS",
    cityWithStateAbbr: "Swiftown, MS",
  },
  {
    zip: "38960",
    ST: "MS",
    cityWithStateAbbr: "Tie Plant, MS",
  },
  {
    zip: "38961",
    ST: "MS",
    cityWithStateAbbr: "Tillatoba, MS",
  },
  {
    zip: "38962",
    ST: "MS",
    cityWithStateAbbr: "Tippo, MS",
  },
  {
    zip: "38963",
    ST: "MS",
    cityWithStateAbbr: "Tutwiler, MS",
  },
  {
    zip: "38964",
    ST: "MS",
    cityWithStateAbbr: "Vance, MS",
  },
  {
    zip: "38965",
    ST: "MS",
    cityWithStateAbbr: "Water Valley, MS",
  },
  {
    zip: "38966",
    ST: "MS",
    cityWithStateAbbr: "Webb, MS",
  },
  {
    zip: "38967",
    ST: "MS",
    cityWithStateAbbr: "Winona, MS",
  },
  {
    zip: "39038",
    ST: "MS",
    cityWithStateAbbr: "Belzoni, MS",
  },
  {
    zip: "39039",
    ST: "MS",
    cityWithStateAbbr: "Benton, MS",
  },
  {
    zip: "39040",
    ST: "MS",
    cityWithStateAbbr: "Bentonia, MS",
  },
  {
    zip: "39041",
    ST: "MS",
    cityWithStateAbbr: "Bolton, MS",
  },
  {
    zip: "39042",
    ST: "MS",
    cityWithStateAbbr: "Brandon, MS",
  },
  {
    zip: "39043",
    ST: "MS",
    cityWithStateAbbr: "Brandon, MS",
  },
  {
    zip: "39044",
    ST: "MS",
    cityWithStateAbbr: "Braxton, MS",
  },
  {
    zip: "39045",
    ST: "MS",
    cityWithStateAbbr: "Camden, MS",
  },
  {
    zip: "39046",
    ST: "MS",
    cityWithStateAbbr: "Canton, MS",
  },
  {
    zip: "39047",
    ST: "MS",
    cityWithStateAbbr: "Brandon, MS",
  },
  {
    zip: "39051",
    ST: "MS",
    cityWithStateAbbr: "Carthage, MS",
  },
  {
    zip: "39054",
    ST: "MS",
    cityWithStateAbbr: "Cary, MS",
  },
  {
    zip: "39056",
    ST: "MS",
    cityWithStateAbbr: "Clinton, MS",
  },
  {
    zip: "39057",
    ST: "MS",
    cityWithStateAbbr: "Conehatta, MS",
  },
  {
    zip: "39058",
    ST: "MS",
    cityWithStateAbbr: "Clinton, MS",
  },
  {
    zip: "39059",
    ST: "MS",
    cityWithStateAbbr: "Crystal Springs, MS",
  },
  {
    zip: "39060",
    ST: "MS",
    cityWithStateAbbr: "Clinton, MS",
  },
  {
    zip: "39061",
    ST: "MS",
    cityWithStateAbbr: "Delta City, MS",
  },
  {
    zip: "39062",
    ST: "MS",
    cityWithStateAbbr: "D Lo, MS",
  },
  {
    zip: "39063",
    ST: "MS",
    cityWithStateAbbr: "Durant, MS",
  },
  {
    zip: "39066",
    ST: "MS",
    cityWithStateAbbr: "Edwards, MS",
  },
  {
    zip: "39067",
    ST: "MS",
    cityWithStateAbbr: "Ethel, MS",
  },
  {
    zip: "39069",
    ST: "MS",
    cityWithStateAbbr: "Fayette, MS",
  },
  {
    zip: "39071",
    ST: "MS",
    cityWithStateAbbr: "Flora, MS",
  },
  {
    zip: "39072",
    ST: "MS",
    cityWithStateAbbr: "Flora, MS",
  },
  {
    zip: "39073",
    ST: "MS",
    cityWithStateAbbr: "Florence, MS",
  },
  {
    zip: "39074",
    ST: "MS",
    cityWithStateAbbr: "Forest, MS",
  },
  {
    zip: "39077",
    ST: "MS",
    cityWithStateAbbr: "Gallman, MS",
  },
  {
    zip: "39078",
    ST: "MS",
    cityWithStateAbbr: "Georgetown, MS",
  },
  {
    zip: "39079",
    ST: "MS",
    cityWithStateAbbr: "Goodman, MS",
  },
  {
    zip: "39080",
    ST: "MS",
    cityWithStateAbbr: "Harperville, MS",
  },
  {
    zip: "39081",
    ST: "MS",
    cityWithStateAbbr: "Fayette, MS",
  },
  {
    zip: "39082",
    ST: "MS",
    cityWithStateAbbr: "Harrisville, MS",
  },
  {
    zip: "39083",
    ST: "MS",
    cityWithStateAbbr: "Hazlehurst, MS",
  },
  {
    zip: "39086",
    ST: "MS",
    cityWithStateAbbr: "Hermanville, MS",
  },
  {
    zip: "39087",
    ST: "MS",
    cityWithStateAbbr: "Hillsboro, MS",
  },
  {
    zip: "39088",
    ST: "MS",
    cityWithStateAbbr: "Holly Bluff, MS",
  },
  {
    zip: "39090",
    ST: "MS",
    cityWithStateAbbr: "Kosciusko, MS",
  },
  {
    zip: "39092",
    ST: "MS",
    cityWithStateAbbr: "Lake, MS",
  },
  {
    zip: "39094",
    ST: "MS",
    cityWithStateAbbr: "Lena, MS",
  },
  {
    zip: "39095",
    ST: "MS",
    cityWithStateAbbr: "Lexington, MS",
  },
  {
    zip: "39096",
    ST: "MS",
    cityWithStateAbbr: "Lorman, MS",
  },
  {
    zip: "39097",
    ST: "MS",
    cityWithStateAbbr: "Louise, MS",
  },
  {
    zip: "39098",
    ST: "MS",
    cityWithStateAbbr: "Ludlow, MS",
  },
  {
    zip: "39107",
    ST: "MS",
    cityWithStateAbbr: "Mc Adams, MS",
  },
  {
    zip: "39108",
    ST: "MS",
    cityWithStateAbbr: "Mc Cool, MS",
  },
  {
    zip: "39109",
    ST: "MS",
    cityWithStateAbbr: "Madden, MS",
  },
  {
    zip: "39110",
    ST: "MS",
    cityWithStateAbbr: "Madison, MS",
  },
  {
    zip: "39111",
    ST: "MS",
    cityWithStateAbbr: "Magee, MS",
  },
  {
    zip: "39113",
    ST: "MS",
    cityWithStateAbbr: "Mayersville, MS",
  },
  {
    zip: "39114",
    ST: "MS",
    cityWithStateAbbr: "Mendenhall, MS",
  },
  {
    zip: "39115",
    ST: "MS",
    cityWithStateAbbr: "Midnight, MS",
  },
  {
    zip: "39116",
    ST: "MS",
    cityWithStateAbbr: "Mize, MS",
  },
  {
    zip: "39117",
    ST: "MS",
    cityWithStateAbbr: "Morton, MS",
  },
  {
    zip: "39119",
    ST: "MS",
    cityWithStateAbbr: "Mount Olive, MS",
  },
  {
    zip: "39120",
    ST: "MS",
    cityWithStateAbbr: "Natchez, MS",
  },
  {
    zip: "39121",
    ST: "MS",
    cityWithStateAbbr: "Natchez, MS",
  },
  {
    zip: "39122",
    ST: "MS",
    cityWithStateAbbr: "Natchez, MS",
  },
  {
    zip: "39130",
    ST: "MS",
    cityWithStateAbbr: "Madison, MS",
  },
  {
    zip: "39140",
    ST: "MS",
    cityWithStateAbbr: "Newhebron, MS",
  },
  {
    zip: "39144",
    ST: "MS",
    cityWithStateAbbr: "Pattison, MS",
  },
  {
    zip: "39145",
    ST: "MS",
    cityWithStateAbbr: "Pelahatchie, MS",
  },
  {
    zip: "39146",
    ST: "MS",
    cityWithStateAbbr: "Pickens, MS",
  },
  {
    zip: "39148",
    ST: "MS",
    cityWithStateAbbr: "Piney Woods, MS",
  },
  {
    zip: "39149",
    ST: "MS",
    cityWithStateAbbr: "Pinola, MS",
  },
  {
    zip: "39150",
    ST: "MS",
    cityWithStateAbbr: "Port Gibson, MS",
  },
  {
    zip: "39151",
    ST: "MS",
    cityWithStateAbbr: "Puckett, MS",
  },
  {
    zip: "39152",
    ST: "MS",
    cityWithStateAbbr: "Pulaski, MS",
  },
  {
    zip: "39153",
    ST: "MS",
    cityWithStateAbbr: "Raleigh, MS",
  },
  {
    zip: "39154",
    ST: "MS",
    cityWithStateAbbr: "Raymond, MS",
  },
  {
    zip: "39156",
    ST: "MS",
    cityWithStateAbbr: "Redwood, MS",
  },
  {
    zip: "39157",
    ST: "MS",
    cityWithStateAbbr: "Ridgeland, MS",
  },
  {
    zip: "39158",
    ST: "MS",
    cityWithStateAbbr: "Ridgeland, MS",
  },
  {
    zip: "39159",
    ST: "MS",
    cityWithStateAbbr: "Rolling Fork, MS",
  },
  {
    zip: "39160",
    ST: "MS",
    cityWithStateAbbr: "Sallis, MS",
  },
  {
    zip: "39161",
    ST: "MS",
    cityWithStateAbbr: "Sandhill, MS",
  },
  {
    zip: "39162",
    ST: "MS",
    cityWithStateAbbr: "Satartia, MS",
  },
  {
    zip: "39163",
    ST: "MS",
    cityWithStateAbbr: "Sharon, MS",
  },
  {
    zip: "39165",
    ST: "MS",
    cityWithStateAbbr: "Sibley, MS",
  },
  {
    zip: "39166",
    ST: "MS",
    cityWithStateAbbr: "Silver City, MS",
  },
  {
    zip: "39167",
    ST: "MS",
    cityWithStateAbbr: "Star, MS",
  },
  {
    zip: "39168",
    ST: "MS",
    cityWithStateAbbr: "Taylorsville, MS",
  },
  {
    zip: "39169",
    ST: "MS",
    cityWithStateAbbr: "Tchula, MS",
  },
  {
    zip: "39170",
    ST: "MS",
    cityWithStateAbbr: "Terry, MS",
  },
  {
    zip: "39171",
    ST: "MS",
    cityWithStateAbbr: "Thomastown, MS",
  },
  {
    zip: "39173",
    ST: "MS",
    cityWithStateAbbr: "Tinsley, MS",
  },
  {
    zip: "39174",
    ST: "MS",
    cityWithStateAbbr: "Tougaloo, MS",
  },
  {
    zip: "39175",
    ST: "MS",
    cityWithStateAbbr: "Utica, MS",
  },
  {
    zip: "39176",
    ST: "MS",
    cityWithStateAbbr: "Vaiden, MS",
  },
  {
    zip: "39177",
    ST: "MS",
    cityWithStateAbbr: "Valley Park, MS",
  },
  {
    zip: "39179",
    ST: "MS",
    cityWithStateAbbr: "Vaughan, MS",
  },
  {
    zip: "39180",
    ST: "MS",
    cityWithStateAbbr: "Vicksburg, MS",
  },
  {
    zip: "39181",
    ST: "MS",
    cityWithStateAbbr: "Vicksburg, MS",
  },
  {
    zip: "39182",
    ST: "MS",
    cityWithStateAbbr: "Vicksburg, MS",
  },
  {
    zip: "39183",
    ST: "MS",
    cityWithStateAbbr: "Vicksburg, MS",
  },
  {
    zip: "39189",
    ST: "MS",
    cityWithStateAbbr: "Walnut Grove, MS",
  },
  {
    zip: "39190",
    ST: "MS",
    cityWithStateAbbr: "Washington, MS",
  },
  {
    zip: "39191",
    ST: "MS",
    cityWithStateAbbr: "Wesson, MS",
  },
  {
    zip: "39192",
    ST: "MS",
    cityWithStateAbbr: "West, MS",
  },
  {
    zip: "39193",
    ST: "MS",
    cityWithStateAbbr: "Whitfield, MS",
  },
  {
    zip: "39194",
    ST: "MS",
    cityWithStateAbbr: "Yazoo City, MS",
  },
  {
    zip: "39201",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39202",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39203",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39204",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39205",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39206",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39207",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39208",
    ST: "MS",
    cityWithStateAbbr: "Pearl, MS",
  },
  {
    zip: "39209",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39210",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39211",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39212",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39213",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39215",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39216",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39217",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39218",
    ST: "MS",
    cityWithStateAbbr: "Richland, MS",
  },
  {
    zip: "39225",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39232",
    ST: "MS",
    cityWithStateAbbr: "Flowood, MS",
  },
  {
    zip: "39236",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39269",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39271",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39272",
    ST: "MS",
    cityWithStateAbbr: "Byram, MS",
  },
  {
    zip: "39282",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39283",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39284",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39286",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39288",
    ST: "MS",
    cityWithStateAbbr: "Pearl, MS",
  },
  {
    zip: "39289",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39296",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39298",
    ST: "MS",
    cityWithStateAbbr: "Jackson, MS",
  },
  {
    zip: "39301",
    ST: "MS",
    cityWithStateAbbr: "Meridian, MS",
  },
  {
    zip: "39302",
    ST: "MS",
    cityWithStateAbbr: "Meridian, MS",
  },
  {
    zip: "39303",
    ST: "MS",
    cityWithStateAbbr: "Meridian, MS",
  },
  {
    zip: "39304",
    ST: "MS",
    cityWithStateAbbr: "Meridian, MS",
  },
  {
    zip: "39305",
    ST: "MS",
    cityWithStateAbbr: "Meridian, MS",
  },
  {
    zip: "39307",
    ST: "MS",
    cityWithStateAbbr: "Meridian, MS",
  },
  {
    zip: "39309",
    ST: "MS",
    cityWithStateAbbr: "Meridian, MS",
  },
  {
    zip: "39320",
    ST: "MS",
    cityWithStateAbbr: "Bailey, MS",
  },
  {
    zip: "39322",
    ST: "MS",
    cityWithStateAbbr: "Buckatunna, MS",
  },
  {
    zip: "39323",
    ST: "MS",
    cityWithStateAbbr: "Chunky, MS",
  },
  {
    zip: "39324",
    ST: "MS",
    cityWithStateAbbr: "Clara, MS",
  },
  {
    zip: "39325",
    ST: "MS",
    cityWithStateAbbr: "Collinsville, MS",
  },
  {
    zip: "39326",
    ST: "MS",
    cityWithStateAbbr: "Daleville, MS",
  },
  {
    zip: "39327",
    ST: "MS",
    cityWithStateAbbr: "Decatur, MS",
  },
  {
    zip: "39328",
    ST: "MS",
    cityWithStateAbbr: "De Kalb, MS",
  },
  {
    zip: "39330",
    ST: "MS",
    cityWithStateAbbr: "Enterprise, MS",
  },
  {
    zip: "39332",
    ST: "MS",
    cityWithStateAbbr: "Hickory, MS",
  },
  {
    zip: "39335",
    ST: "MS",
    cityWithStateAbbr: "Lauderdale, MS",
  },
  {
    zip: "39336",
    ST: "MS",
    cityWithStateAbbr: "Lawrence, MS",
  },
  {
    zip: "39337",
    ST: "MS",
    cityWithStateAbbr: "Little Rock, MS",
  },
  {
    zip: "39338",
    ST: "MS",
    cityWithStateAbbr: "Louin, MS",
  },
  {
    zip: "39339",
    ST: "MS",
    cityWithStateAbbr: "Louisville, MS",
  },
  {
    zip: "39341",
    ST: "MS",
    cityWithStateAbbr: "Macon, MS",
  },
  {
    zip: "39342",
    ST: "MS",
    cityWithStateAbbr: "Marion, MS",
  },
  {
    zip: "39345",
    ST: "MS",
    cityWithStateAbbr: "Newton, MS",
  },
  {
    zip: "39346",
    ST: "MS",
    cityWithStateAbbr: "Noxapater, MS",
  },
  {
    zip: "39347",
    ST: "MS",
    cityWithStateAbbr: "Pachuta, MS",
  },
  {
    zip: "39348",
    ST: "MS",
    cityWithStateAbbr: "Paulding, MS",
  },
  {
    zip: "39350",
    ST: "MS",
    cityWithStateAbbr: "Philadelphia, MS",
  },
  {
    zip: "39352",
    ST: "MS",
    cityWithStateAbbr: "Porterville, MS",
  },
  {
    zip: "39354",
    ST: "MS",
    cityWithStateAbbr: "Preston, MS",
  },
  {
    zip: "39355",
    ST: "MS",
    cityWithStateAbbr: "Quitman, MS",
  },
  {
    zip: "39356",
    ST: "MS",
    cityWithStateAbbr: "Rose Hill, MS",
  },
  {
    zip: "39358",
    ST: "MS",
    cityWithStateAbbr: "Scooba, MS",
  },
  {
    zip: "39359",
    ST: "MS",
    cityWithStateAbbr: "Sebastopol, MS",
  },
  {
    zip: "39360",
    ST: "MS",
    cityWithStateAbbr: "Shubuta, MS",
  },
  {
    zip: "39361",
    ST: "MS",
    cityWithStateAbbr: "Shuqualak, MS",
  },
  {
    zip: "39362",
    ST: "MS",
    cityWithStateAbbr: "State Line, MS",
  },
  {
    zip: "39363",
    ST: "MS",
    cityWithStateAbbr: "Stonewall, MS",
  },
  {
    zip: "39364",
    ST: "MS",
    cityWithStateAbbr: "Toomsuba, MS",
  },
  {
    zip: "39365",
    ST: "MS",
    cityWithStateAbbr: "Union, MS",
  },
  {
    zip: "39366",
    ST: "MS",
    cityWithStateAbbr: "Vossburg, MS",
  },
  {
    zip: "39367",
    ST: "MS",
    cityWithStateAbbr: "Waynesboro, MS",
  },
  {
    zip: "39401",
    ST: "MS",
    cityWithStateAbbr: "Hattiesburg, MS",
  },
  {
    zip: "39402",
    ST: "MS",
    cityWithStateAbbr: "Hattiesburg, MS",
  },
  {
    zip: "39403",
    ST: "MS",
    cityWithStateAbbr: "Hattiesburg, MS",
  },
  {
    zip: "39404",
    ST: "MS",
    cityWithStateAbbr: "Hattiesburg, MS",
  },
  {
    zip: "39406",
    ST: "MS",
    cityWithStateAbbr: "Hattiesburg, MS",
  },
  {
    zip: "39407",
    ST: "MS",
    cityWithStateAbbr: "Hattiesburg, MS",
  },
  {
    zip: "39421",
    ST: "MS",
    cityWithStateAbbr: "Bassfield, MS",
  },
  {
    zip: "39422",
    ST: "MS",
    cityWithStateAbbr: "Bay Springs, MS",
  },
  {
    zip: "39423",
    ST: "MS",
    cityWithStateAbbr: "Beaumont, MS",
  },
  {
    zip: "39425",
    ST: "MS",
    cityWithStateAbbr: "Brooklyn, MS",
  },
  {
    zip: "39426",
    ST: "MS",
    cityWithStateAbbr: "Carriere, MS",
  },
  {
    zip: "39427",
    ST: "MS",
    cityWithStateAbbr: "Carson, MS",
  },
  {
    zip: "39428",
    ST: "MS",
    cityWithStateAbbr: "Collins, MS",
  },
  {
    zip: "39429",
    ST: "MS",
    cityWithStateAbbr: "Columbia, MS",
  },
  {
    zip: "39436",
    ST: "MS",
    cityWithStateAbbr: "Eastabuchie, MS",
  },
  {
    zip: "39437",
    ST: "MS",
    cityWithStateAbbr: "Ellisville, MS",
  },
  {
    zip: "39439",
    ST: "MS",
    cityWithStateAbbr: "Heidelberg, MS",
  },
  {
    zip: "39440",
    ST: "MS",
    cityWithStateAbbr: "Laurel, MS",
  },
  {
    zip: "39441",
    ST: "MS",
    cityWithStateAbbr: "Laurel, MS",
  },
  {
    zip: "39442",
    ST: "MS",
    cityWithStateAbbr: "Laurel, MS",
  },
  {
    zip: "39443",
    ST: "MS",
    cityWithStateAbbr: "Laurel, MS",
  },
  {
    zip: "39451",
    ST: "MS",
    cityWithStateAbbr: "Leakesville, MS",
  },
  {
    zip: "39452",
    ST: "MS",
    cityWithStateAbbr: "Lucedale, MS",
  },
  {
    zip: "39455",
    ST: "MS",
    cityWithStateAbbr: "Lumberton, MS",
  },
  {
    zip: "39456",
    ST: "MS",
    cityWithStateAbbr: "Mc Lain, MS",
  },
  {
    zip: "39457",
    ST: "MS",
    cityWithStateAbbr: "Mc Neill, MS",
  },
  {
    zip: "39459",
    ST: "MS",
    cityWithStateAbbr: "Moselle, MS",
  },
  {
    zip: "39460",
    ST: "MS",
    cityWithStateAbbr: "Moss, MS",
  },
  {
    zip: "39461",
    ST: "MS",
    cityWithStateAbbr: "Neely, MS",
  },
  {
    zip: "39462",
    ST: "MS",
    cityWithStateAbbr: "New Augusta, MS",
  },
  {
    zip: "39463",
    ST: "MS",
    cityWithStateAbbr: "Nicholson, MS",
  },
  {
    zip: "39464",
    ST: "MS",
    cityWithStateAbbr: "Ovett, MS",
  },
  {
    zip: "39465",
    ST: "MS",
    cityWithStateAbbr: "Petal, MS",
  },
  {
    zip: "39466",
    ST: "MS",
    cityWithStateAbbr: "Picayune, MS",
  },
  {
    zip: "39470",
    ST: "MS",
    cityWithStateAbbr: "Poplarville, MS",
  },
  {
    zip: "39474",
    ST: "MS",
    cityWithStateAbbr: "Prentiss, MS",
  },
  {
    zip: "39475",
    ST: "MS",
    cityWithStateAbbr: "Purvis, MS",
  },
  {
    zip: "39476",
    ST: "MS",
    cityWithStateAbbr: "Richton, MS",
  },
  {
    zip: "39477",
    ST: "MS",
    cityWithStateAbbr: "Sandersville, MS",
  },
  {
    zip: "39478",
    ST: "MS",
    cityWithStateAbbr: "Sandy Hook, MS",
  },
  {
    zip: "39479",
    ST: "MS",
    cityWithStateAbbr: "Seminary, MS",
  },
  {
    zip: "39480",
    ST: "MS",
    cityWithStateAbbr: "Soso, MS",
  },
  {
    zip: "39481",
    ST: "MS",
    cityWithStateAbbr: "Stringer, MS",
  },
  {
    zip: "39482",
    ST: "MS",
    cityWithStateAbbr: "Sumrall, MS",
  },
  {
    zip: "39483",
    ST: "MS",
    cityWithStateAbbr: "Foxworth, MS",
  },
  {
    zip: "39501",
    ST: "MS",
    cityWithStateAbbr: "Gulfport, MS",
  },
  {
    zip: "39502",
    ST: "MS",
    cityWithStateAbbr: "Gulfport, MS",
  },
  {
    zip: "39503",
    ST: "MS",
    cityWithStateAbbr: "Gulfport, MS",
  },
  {
    zip: "39505",
    ST: "MS",
    cityWithStateAbbr: "Gulfport, MS",
  },
  {
    zip: "39506",
    ST: "MS",
    cityWithStateAbbr: "Gulfport, MS",
  },
  {
    zip: "39507",
    ST: "MS",
    cityWithStateAbbr: "Gulfport, MS",
  },
  {
    zip: "39520",
    ST: "MS",
    cityWithStateAbbr: "Bay Saint Louis, MS",
  },
  {
    zip: "39521",
    ST: "MS",
    cityWithStateAbbr: "Bay Saint Louis, MS",
  },
  {
    zip: "39522",
    ST: "MS",
    cityWithStateAbbr: "Stennis Space Center, MS",
  },
  {
    zip: "39525",
    ST: "MS",
    cityWithStateAbbr: "Diamondhead, MS",
  },
  {
    zip: "39529",
    ST: "MS",
    cityWithStateAbbr: "Stennis Space Center, MS",
  },
  {
    zip: "39530",
    ST: "MS",
    cityWithStateAbbr: "Biloxi, MS",
  },
  {
    zip: "39531",
    ST: "MS",
    cityWithStateAbbr: "Biloxi, MS",
  },
  {
    zip: "39532",
    ST: "MS",
    cityWithStateAbbr: "Biloxi, MS",
  },
  {
    zip: "39533",
    ST: "MS",
    cityWithStateAbbr: "Biloxi, MS",
  },
  {
    zip: "39534",
    ST: "MS",
    cityWithStateAbbr: "Biloxi, MS",
  },
  {
    zip: "39535",
    ST: "MS",
    cityWithStateAbbr: "Biloxi, MS",
  },
  {
    zip: "39540",
    ST: "MS",
    cityWithStateAbbr: "Diberville, MS",
  },
  {
    zip: "39552",
    ST: "MS",
    cityWithStateAbbr: "Escatawpa, MS",
  },
  {
    zip: "39553",
    ST: "MS",
    cityWithStateAbbr: "Gautier, MS",
  },
  {
    zip: "39555",
    ST: "MS",
    cityWithStateAbbr: "Hurley, MS",
  },
  {
    zip: "39556",
    ST: "MS",
    cityWithStateAbbr: "Kiln, MS",
  },
  {
    zip: "39558",
    ST: "MS",
    cityWithStateAbbr: "Lakeshore, MS",
  },
  {
    zip: "39560",
    ST: "MS",
    cityWithStateAbbr: "Long Beach, MS",
  },
  {
    zip: "39561",
    ST: "MS",
    cityWithStateAbbr: "Mc Henry, MS",
  },
  {
    zip: "39562",
    ST: "MS",
    cityWithStateAbbr: "Moss Point, MS",
  },
  {
    zip: "39563",
    ST: "MS",
    cityWithStateAbbr: "Moss Point, MS",
  },
  {
    zip: "39564",
    ST: "MS",
    cityWithStateAbbr: "Ocean Springs, MS",
  },
  {
    zip: "39565",
    ST: "MS",
    cityWithStateAbbr: "Vancleave, MS",
  },
  {
    zip: "39566",
    ST: "MS",
    cityWithStateAbbr: "Ocean Springs, MS",
  },
  {
    zip: "39567",
    ST: "MS",
    cityWithStateAbbr: "Pascagoula, MS",
  },
  {
    zip: "39568",
    ST: "MS",
    cityWithStateAbbr: "Pascagoula, MS",
  },
  {
    zip: "39569",
    ST: "MS",
    cityWithStateAbbr: "Pascagoula, MS",
  },
  {
    zip: "39571",
    ST: "MS",
    cityWithStateAbbr: "Pass Christian, MS",
  },
  {
    zip: "39572",
    ST: "MS",
    cityWithStateAbbr: "Pearlington, MS",
  },
  {
    zip: "39573",
    ST: "MS",
    cityWithStateAbbr: "Perkinston, MS",
  },
  {
    zip: "39574",
    ST: "MS",
    cityWithStateAbbr: "Saucier, MS",
  },
  {
    zip: "39576",
    ST: "MS",
    cityWithStateAbbr: "Waveland, MS",
  },
  {
    zip: "39577",
    ST: "MS",
    cityWithStateAbbr: "Wiggins, MS",
  },
  {
    zip: "39581",
    ST: "MS",
    cityWithStateAbbr: "Pascagoula, MS",
  },
  {
    zip: "39595",
    ST: "MS",
    cityWithStateAbbr: "Pascagoula, MS",
  },
  {
    zip: "39601",
    ST: "MS",
    cityWithStateAbbr: "Brookhaven, MS",
  },
  {
    zip: "39602",
    ST: "MS",
    cityWithStateAbbr: "Brookhaven, MS",
  },
  {
    zip: "39603",
    ST: "MS",
    cityWithStateAbbr: "Brookhaven, MS",
  },
  {
    zip: "39629",
    ST: "MS",
    cityWithStateAbbr: "Bogue Chitto, MS",
  },
  {
    zip: "39630",
    ST: "MS",
    cityWithStateAbbr: "Bude, MS",
  },
  {
    zip: "39631",
    ST: "MS",
    cityWithStateAbbr: "Centreville, MS",
  },
  {
    zip: "39632",
    ST: "MS",
    cityWithStateAbbr: "Chatawa, MS",
  },
  {
    zip: "39633",
    ST: "MS",
    cityWithStateAbbr: "Crosby, MS",
  },
  {
    zip: "39635",
    ST: "MS",
    cityWithStateAbbr: "Fernwood, MS",
  },
  {
    zip: "39638",
    ST: "MS",
    cityWithStateAbbr: "Gloster, MS",
  },
  {
    zip: "39641",
    ST: "MS",
    cityWithStateAbbr: "Jayess, MS",
  },
  {
    zip: "39643",
    ST: "MS",
    cityWithStateAbbr: "Kokomo, MS",
  },
  {
    zip: "39645",
    ST: "MS",
    cityWithStateAbbr: "Liberty, MS",
  },
  {
    zip: "39647",
    ST: "MS",
    cityWithStateAbbr: "Mc Call Creek, MS",
  },
  {
    zip: "39648",
    ST: "MS",
    cityWithStateAbbr: "Mccomb, MS",
  },
  {
    zip: "39649",
    ST: "MS",
    cityWithStateAbbr: "Mccomb, MS",
  },
  {
    zip: "39652",
    ST: "MS",
    cityWithStateAbbr: "Magnolia, MS",
  },
  {
    zip: "39653",
    ST: "MS",
    cityWithStateAbbr: "Meadville, MS",
  },
  {
    zip: "39654",
    ST: "MS",
    cityWithStateAbbr: "Monticello, MS",
  },
  {
    zip: "39656",
    ST: "MS",
    cityWithStateAbbr: "Oak Vale, MS",
  },
  {
    zip: "39657",
    ST: "MS",
    cityWithStateAbbr: "Osyka, MS",
  },
  {
    zip: "39661",
    ST: "MS",
    cityWithStateAbbr: "Roxie, MS",
  },
  {
    zip: "39662",
    ST: "MS",
    cityWithStateAbbr: "Ruth, MS",
  },
  {
    zip: "39663",
    ST: "MS",
    cityWithStateAbbr: "Silver Creek, MS",
  },
  {
    zip: "39664",
    ST: "MS",
    cityWithStateAbbr: "Smithdale, MS",
  },
  {
    zip: "39665",
    ST: "MS",
    cityWithStateAbbr: "Sontag, MS",
  },
  {
    zip: "39666",
    ST: "MS",
    cityWithStateAbbr: "Summit, MS",
  },
  {
    zip: "39667",
    ST: "MS",
    cityWithStateAbbr: "Tylertown, MS",
  },
  {
    zip: "39668",
    ST: "MS",
    cityWithStateAbbr: "Union Church, MS",
  },
  {
    zip: "39669",
    ST: "MS",
    cityWithStateAbbr: "Woodville, MS",
  },
  {
    zip: "39701",
    ST: "MS",
    cityWithStateAbbr: "Columbus, MS",
  },
  {
    zip: "39702",
    ST: "MS",
    cityWithStateAbbr: "Columbus, MS",
  },
  {
    zip: "39703",
    ST: "MS",
    cityWithStateAbbr: "Columbus, MS",
  },
  {
    zip: "39704",
    ST: "MS",
    cityWithStateAbbr: "Columbus, MS",
  },
  {
    zip: "39705",
    ST: "MS",
    cityWithStateAbbr: "Columbus, MS",
  },
  {
    zip: "39710",
    ST: "MS",
    cityWithStateAbbr: "Columbus, MS",
  },
  {
    zip: "39730",
    ST: "MS",
    cityWithStateAbbr: "Aberdeen, MS",
  },
  {
    zip: "39735",
    ST: "MS",
    cityWithStateAbbr: "Ackerman, MS",
  },
  {
    zip: "39736",
    ST: "MS",
    cityWithStateAbbr: "Artesia, MS",
  },
  {
    zip: "39737",
    ST: "MS",
    cityWithStateAbbr: "Bellefontaine, MS",
  },
  {
    zip: "39739",
    ST: "MS",
    cityWithStateAbbr: "Brooksville, MS",
  },
  {
    zip: "39740",
    ST: "MS",
    cityWithStateAbbr: "Caledonia, MS",
  },
  {
    zip: "39741",
    ST: "MS",
    cityWithStateAbbr: "Cedarbluff, MS",
  },
  {
    zip: "39743",
    ST: "MS",
    cityWithStateAbbr: "Crawford, MS",
  },
  {
    zip: "39744",
    ST: "MS",
    cityWithStateAbbr: "Eupora, MS",
  },
  {
    zip: "39745",
    ST: "MS",
    cityWithStateAbbr: "French Camp, MS",
  },
  {
    zip: "39746",
    ST: "MS",
    cityWithStateAbbr: "Hamilton, MS",
  },
  {
    zip: "39747",
    ST: "MS",
    cityWithStateAbbr: "Kilmichael, MS",
  },
  {
    zip: "39750",
    ST: "MS",
    cityWithStateAbbr: "Maben, MS",
  },
  {
    zip: "39751",
    ST: "MS",
    cityWithStateAbbr: "Mantee, MS",
  },
  {
    zip: "39752",
    ST: "MS",
    cityWithStateAbbr: "Mathiston, MS",
  },
  {
    zip: "39753",
    ST: "MS",
    cityWithStateAbbr: "Mayhew, MS",
  },
  {
    zip: "39754",
    ST: "MS",
    cityWithStateAbbr: "Montpelier, MS",
  },
  {
    zip: "39755",
    ST: "MS",
    cityWithStateAbbr: "Pheba, MS",
  },
  {
    zip: "39756",
    ST: "MS",
    cityWithStateAbbr: "Prairie, MS",
  },
  {
    zip: "39759",
    ST: "MS",
    cityWithStateAbbr: "Starkville, MS",
  },
  {
    zip: "39760",
    ST: "MS",
    cityWithStateAbbr: "Starkville, MS",
  },
  {
    zip: "39762",
    ST: "MS",
    cityWithStateAbbr: "Mississippi State, MS",
  },
  {
    zip: "39766",
    ST: "MS",
    cityWithStateAbbr: "Steens, MS",
  },
  {
    zip: "39767",
    ST: "MS",
    cityWithStateAbbr: "Stewart, MS",
  },
  {
    zip: "39769",
    ST: "MS",
    cityWithStateAbbr: "Sturgis, MS",
  },
  {
    zip: "39771",
    ST: "MS",
    cityWithStateAbbr: "Walthall, MS",
  },
  {
    zip: "39772",
    ST: "MS",
    cityWithStateAbbr: "Weir, MS",
  },
  {
    zip: "39773",
    ST: "MS",
    cityWithStateAbbr: "West Point, MS",
  },
  {
    zip: "39776",
    ST: "MS",
    cityWithStateAbbr: "Woodland, MS",
  },
  {
    zip: "39813",
    ST: "GA",
    cityWithStateAbbr: "Arlington, GA",
  },
  {
    zip: "39815",
    ST: "GA",
    cityWithStateAbbr: "Attapulgus, GA",
  },
  {
    zip: "39817",
    ST: "GA",
    cityWithStateAbbr: "Bainbridge, GA",
  },
  {
    zip: "39818",
    ST: "GA",
    cityWithStateAbbr: "Bainbridge, GA",
  },
  {
    zip: "39819",
    ST: "GA",
    cityWithStateAbbr: "Bainbridge, GA",
  },
  {
    zip: "39823",
    ST: "GA",
    cityWithStateAbbr: "Blakely, GA",
  },
  {
    zip: "39824",
    ST: "GA",
    cityWithStateAbbr: "Bluffton, GA",
  },
  {
    zip: "39825",
    ST: "GA",
    cityWithStateAbbr: "Brinson, GA",
  },
  {
    zip: "39826",
    ST: "GA",
    cityWithStateAbbr: "Bronwood, GA",
  },
  {
    zip: "39827",
    ST: "GA",
    cityWithStateAbbr: "Cairo, GA",
  },
  {
    zip: "39828",
    ST: "GA",
    cityWithStateAbbr: "Cairo, GA",
  },
  {
    zip: "39829",
    ST: "GA",
    cityWithStateAbbr: "Calvary, GA",
  },
  {
    zip: "39832",
    ST: "GA",
    cityWithStateAbbr: "Cedar Springs, GA",
  },
  {
    zip: "39834",
    ST: "GA",
    cityWithStateAbbr: "Climax, GA",
  },
  {
    zip: "39836",
    ST: "GA",
    cityWithStateAbbr: "Coleman, GA",
  },
  {
    zip: "39837",
    ST: "GA",
    cityWithStateAbbr: "Colquitt, GA",
  },
  {
    zip: "39840",
    ST: "GA",
    cityWithStateAbbr: "Cuthbert, GA",
  },
  {
    zip: "39841",
    ST: "GA",
    cityWithStateAbbr: "Damascus, GA",
  },
  {
    zip: "39842",
    ST: "GA",
    cityWithStateAbbr: "Dawson, GA",
  },
  {
    zip: "39845",
    ST: "GA",
    cityWithStateAbbr: "Donalsonville, GA",
  },
  {
    zip: "39846",
    ST: "GA",
    cityWithStateAbbr: "Edison, GA",
  },
  {
    zip: "39851",
    ST: "GA",
    cityWithStateAbbr: "Fort Gaines, GA",
  },
  {
    zip: "39852",
    ST: "GA",
    cityWithStateAbbr: "Fowlstown, GA",
  },
  {
    zip: "39854",
    ST: "GA",
    cityWithStateAbbr: "Georgetown, GA",
  },
  {
    zip: "39859",
    ST: "GA",
    cityWithStateAbbr: "Iron City, GA",
  },
  {
    zip: "39861",
    ST: "GA",
    cityWithStateAbbr: "Jakin, GA",
  },
  {
    zip: "39862",
    ST: "GA",
    cityWithStateAbbr: "Leary, GA",
  },
  {
    zip: "39866",
    ST: "GA",
    cityWithStateAbbr: "Morgan, GA",
  },
  {
    zip: "39867",
    ST: "GA",
    cityWithStateAbbr: "Morris, GA",
  },
  {
    zip: "39870",
    ST: "GA",
    cityWithStateAbbr: "Newton, GA",
  },
  {
    zip: "39877",
    ST: "GA",
    cityWithStateAbbr: "Parrott, GA",
  },
  {
    zip: "39885",
    ST: "GA",
    cityWithStateAbbr: "Sasser, GA",
  },
  {
    zip: "39886",
    ST: "GA",
    cityWithStateAbbr: "Shellman, GA",
  },
  {
    zip: "39897",
    ST: "GA",
    cityWithStateAbbr: "Whigham, GA",
  },
  {
    zip: "39901",
    ST: "GA",
    cityWithStateAbbr: "Atlanta, GA",
  },
  {
    zip: "40003",
    ST: "KY",
    cityWithStateAbbr: "Bagdad, KY",
  },
  {
    zip: "40004",
    ST: "KY",
    cityWithStateAbbr: "Bardstown, KY",
  },
  {
    zip: "40006",
    ST: "KY",
    cityWithStateAbbr: "Bedford, KY",
  },
  {
    zip: "40007",
    ST: "KY",
    cityWithStateAbbr: "Bethlehem, KY",
  },
  {
    zip: "40008",
    ST: "KY",
    cityWithStateAbbr: "Bloomfield, KY",
  },
  {
    zip: "40009",
    ST: "KY",
    cityWithStateAbbr: "Bradfordsville, KY",
  },
  {
    zip: "40010",
    ST: "KY",
    cityWithStateAbbr: "Buckner, KY",
  },
  {
    zip: "40011",
    ST: "KY",
    cityWithStateAbbr: "Campbellsburg, KY",
  },
  {
    zip: "40012",
    ST: "KY",
    cityWithStateAbbr: "Chaplin, KY",
  },
  {
    zip: "40013",
    ST: "KY",
    cityWithStateAbbr: "Coxs Creek, KY",
  },
  {
    zip: "40014",
    ST: "KY",
    cityWithStateAbbr: "Crestwood, KY",
  },
  {
    zip: "40018",
    ST: "KY",
    cityWithStateAbbr: "Eastwood, KY",
  },
  {
    zip: "40019",
    ST: "KY",
    cityWithStateAbbr: "Eminence, KY",
  },
  {
    zip: "40020",
    ST: "KY",
    cityWithStateAbbr: "Fairfield, KY",
  },
  {
    zip: "40022",
    ST: "KY",
    cityWithStateAbbr: "Finchville, KY",
  },
  {
    zip: "40023",
    ST: "KY",
    cityWithStateAbbr: "Fisherville, KY",
  },
  {
    zip: "40025",
    ST: "KY",
    cityWithStateAbbr: "Glenview, KY",
  },
  {
    zip: "40026",
    ST: "KY",
    cityWithStateAbbr: "Goshen, KY",
  },
  {
    zip: "40027",
    ST: "KY",
    cityWithStateAbbr: "Harrods Creek, KY",
  },
  {
    zip: "40031",
    ST: "KY",
    cityWithStateAbbr: "La Grange, KY",
  },
  {
    zip: "40032",
    ST: "KY",
    cityWithStateAbbr: "La Grange, KY",
  },
  {
    zip: "40033",
    ST: "KY",
    cityWithStateAbbr: "Lebanon, KY",
  },
  {
    zip: "40036",
    ST: "KY",
    cityWithStateAbbr: "Lockport, KY",
  },
  {
    zip: "40037",
    ST: "KY",
    cityWithStateAbbr: "Loretto, KY",
  },
  {
    zip: "40040",
    ST: "KY",
    cityWithStateAbbr: "Mackville, KY",
  },
  {
    zip: "40041",
    ST: "KY",
    cityWithStateAbbr: "Masonic Home, KY",
  },
  {
    zip: "40045",
    ST: "KY",
    cityWithStateAbbr: "Milton, KY",
  },
  {
    zip: "40046",
    ST: "KY",
    cityWithStateAbbr: "Mount Eden, KY",
  },
  {
    zip: "40047",
    ST: "KY",
    cityWithStateAbbr: "Mount Washington, KY",
  },
  {
    zip: "40048",
    ST: "KY",
    cityWithStateAbbr: "Nazareth, KY",
  },
  {
    zip: "40049",
    ST: "KY",
    cityWithStateAbbr: "Nerinx, KY",
  },
  {
    zip: "40050",
    ST: "KY",
    cityWithStateAbbr: "New Castle, KY",
  },
  {
    zip: "40051",
    ST: "KY",
    cityWithStateAbbr: "New Haven, KY",
  },
  {
    zip: "40052",
    ST: "KY",
    cityWithStateAbbr: "New Hope, KY",
  },
  {
    zip: "40055",
    ST: "KY",
    cityWithStateAbbr: "Pendleton, KY",
  },
  {
    zip: "40056",
    ST: "KY",
    cityWithStateAbbr: "Pewee Valley, KY",
  },
  {
    zip: "40057",
    ST: "KY",
    cityWithStateAbbr: "Pleasureville, KY",
  },
  {
    zip: "40058",
    ST: "KY",
    cityWithStateAbbr: "Port Royal, KY",
  },
  {
    zip: "40059",
    ST: "KY",
    cityWithStateAbbr: "Prospect, KY",
  },
  {
    zip: "40060",
    ST: "KY",
    cityWithStateAbbr: "Raywick, KY",
  },
  {
    zip: "40061",
    ST: "KY",
    cityWithStateAbbr: "Saint Catharine, KY",
  },
  {
    zip: "40062",
    ST: "KY",
    cityWithStateAbbr: "Saint Francis, KY",
  },
  {
    zip: "40063",
    ST: "KY",
    cityWithStateAbbr: "Saint Mary, KY",
  },
  {
    zip: "40065",
    ST: "KY",
    cityWithStateAbbr: "Shelbyville, KY",
  },
  {
    zip: "40066",
    ST: "KY",
    cityWithStateAbbr: "Shelbyville, KY",
  },
  {
    zip: "40067",
    ST: "KY",
    cityWithStateAbbr: "Simpsonville, KY",
  },
  {
    zip: "40068",
    ST: "KY",
    cityWithStateAbbr: "Smithfield, KY",
  },
  {
    zip: "40069",
    ST: "KY",
    cityWithStateAbbr: "Springfield, KY",
  },
  {
    zip: "40070",
    ST: "KY",
    cityWithStateAbbr: "Sulphur, KY",
  },
  {
    zip: "40071",
    ST: "KY",
    cityWithStateAbbr: "Taylorsville, KY",
  },
  {
    zip: "40075",
    ST: "KY",
    cityWithStateAbbr: "Turners Station, KY",
  },
  {
    zip: "40076",
    ST: "KY",
    cityWithStateAbbr: "Waddy, KY",
  },
  {
    zip: "40077",
    ST: "KY",
    cityWithStateAbbr: "Westport, KY",
  },
  {
    zip: "40078",
    ST: "KY",
    cityWithStateAbbr: "Willisburg, KY",
  },
  {
    zip: "40104",
    ST: "KY",
    cityWithStateAbbr: "Battletown, KY",
  },
  {
    zip: "40107",
    ST: "KY",
    cityWithStateAbbr: "Boston, KY",
  },
  {
    zip: "40108",
    ST: "KY",
    cityWithStateAbbr: "Brandenburg, KY",
  },
  {
    zip: "40109",
    ST: "KY",
    cityWithStateAbbr: "Brooks, KY",
  },
  {
    zip: "40110",
    ST: "KY",
    cityWithStateAbbr: "Clermont, KY",
  },
  {
    zip: "40111",
    ST: "KY",
    cityWithStateAbbr: "Cloverport, KY",
  },
  {
    zip: "40115",
    ST: "KY",
    cityWithStateAbbr: "Custer, KY",
  },
  {
    zip: "40117",
    ST: "KY",
    cityWithStateAbbr: "Ekron, KY",
  },
  {
    zip: "40118",
    ST: "KY",
    cityWithStateAbbr: "Fairdale, KY",
  },
  {
    zip: "40119",
    ST: "KY",
    cityWithStateAbbr: "Falls Of Rough, KY",
  },
  {
    zip: "40121",
    ST: "KY",
    cityWithStateAbbr: "Fort Knox, KY",
  },
  {
    zip: "40129",
    ST: "KY",
    cityWithStateAbbr: "Hillview, KY",
  },
  {
    zip: "40140",
    ST: "KY",
    cityWithStateAbbr: "Garfield, KY",
  },
  {
    zip: "40142",
    ST: "KY",
    cityWithStateAbbr: "Guston, KY",
  },
  {
    zip: "40143",
    ST: "KY",
    cityWithStateAbbr: "Hardinsburg, KY",
  },
  {
    zip: "40144",
    ST: "KY",
    cityWithStateAbbr: "Harned, KY",
  },
  {
    zip: "40145",
    ST: "KY",
    cityWithStateAbbr: "Hudson, KY",
  },
  {
    zip: "40146",
    ST: "KY",
    cityWithStateAbbr: "Irvington, KY",
  },
  {
    zip: "40150",
    ST: "KY",
    cityWithStateAbbr: "Lebanon Junction, KY",
  },
  {
    zip: "40152",
    ST: "KY",
    cityWithStateAbbr: "Mc Daniels, KY",
  },
  {
    zip: "40153",
    ST: "KY",
    cityWithStateAbbr: "Mc Quady, KY",
  },
  {
    zip: "40155",
    ST: "KY",
    cityWithStateAbbr: "Muldraugh, KY",
  },
  {
    zip: "40157",
    ST: "KY",
    cityWithStateAbbr: "Payneville, KY",
  },
  {
    zip: "40159",
    ST: "KY",
    cityWithStateAbbr: "Radcliff, KY",
  },
  {
    zip: "40160",
    ST: "KY",
    cityWithStateAbbr: "Radcliff, KY",
  },
  {
    zip: "40161",
    ST: "KY",
    cityWithStateAbbr: "Rhodelia, KY",
  },
  {
    zip: "40162",
    ST: "KY",
    cityWithStateAbbr: "Rineyville, KY",
  },
  {
    zip: "40165",
    ST: "KY",
    cityWithStateAbbr: "Shepherdsville, KY",
  },
  {
    zip: "40170",
    ST: "KY",
    cityWithStateAbbr: "Stephensport, KY",
  },
  {
    zip: "40171",
    ST: "KY",
    cityWithStateAbbr: "Union Star, KY",
  },
  {
    zip: "40175",
    ST: "KY",
    cityWithStateAbbr: "Vine Grove, KY",
  },
  {
    zip: "40176",
    ST: "KY",
    cityWithStateAbbr: "Webster, KY",
  },
  {
    zip: "40177",
    ST: "KY",
    cityWithStateAbbr: "West Point, KY",
  },
  {
    zip: "40178",
    ST: "KY",
    cityWithStateAbbr: "Westview, KY",
  },
  {
    zip: "40201",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40202",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40203",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40204",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40205",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40206",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40207",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40208",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40209",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40210",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40211",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40212",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40213",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40214",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40215",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40216",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40217",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40218",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40219",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40220",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40221",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40222",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40223",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40224",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40225",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40228",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40229",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40231",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40232",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40233",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40241",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40242",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40243",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40245",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40250",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40251",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40252",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40253",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40255",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40256",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40257",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40258",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40259",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40261",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40266",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40268",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40269",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40270",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40272",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40280",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40281",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40282",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40283",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40285",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40287",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40289",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40290",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40291",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40292",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40293",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40294",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40295",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40296",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40297",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40298",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40299",
    ST: "KY",
    cityWithStateAbbr: "Louisville, KY",
  },
  {
    zip: "40310",
    ST: "KY",
    cityWithStateAbbr: "Burgin, KY",
  },
  {
    zip: "40311",
    ST: "KY",
    cityWithStateAbbr: "Carlisle, KY",
  },
  {
    zip: "40312",
    ST: "KY",
    cityWithStateAbbr: "Clay City, KY",
  },
  {
    zip: "40313",
    ST: "KY",
    cityWithStateAbbr: "Clearfield, KY",
  },
  {
    zip: "40316",
    ST: "KY",
    cityWithStateAbbr: "Denniston, KY",
  },
  {
    zip: "40317",
    ST: "KY",
    cityWithStateAbbr: "Elliottville, KY",
  },
  {
    zip: "40319",
    ST: "KY",
    cityWithStateAbbr: "Farmers, KY",
  },
  {
    zip: "40322",
    ST: "KY",
    cityWithStateAbbr: "Frenchburg, KY",
  },
  {
    zip: "40324",
    ST: "KY",
    cityWithStateAbbr: "Georgetown, KY",
  },
  {
    zip: "40328",
    ST: "KY",
    cityWithStateAbbr: "Gravel Switch, KY",
  },
  {
    zip: "40330",
    ST: "KY",
    cityWithStateAbbr: "Harrodsburg, KY",
  },
  {
    zip: "40334",
    ST: "KY",
    cityWithStateAbbr: "Hope, KY",
  },
  {
    zip: "40336",
    ST: "KY",
    cityWithStateAbbr: "Irvine, KY",
  },
  {
    zip: "40337",
    ST: "KY",
    cityWithStateAbbr: "Jeffersonville, KY",
  },
  {
    zip: "40339",
    ST: "KY",
    cityWithStateAbbr: "Keene, KY",
  },
  {
    zip: "40340",
    ST: "KY",
    cityWithStateAbbr: "Nicholasville, KY",
  },
  {
    zip: "40342",
    ST: "KY",
    cityWithStateAbbr: "Lawrenceburg, KY",
  },
  {
    zip: "40346",
    ST: "KY",
    cityWithStateAbbr: "Means, KY",
  },
  {
    zip: "40347",
    ST: "KY",
    cityWithStateAbbr: "Midway, KY",
  },
  {
    zip: "40348",
    ST: "KY",
    cityWithStateAbbr: "Millersburg, KY",
  },
  {
    zip: "40350",
    ST: "KY",
    cityWithStateAbbr: "Moorefield, KY",
  },
  {
    zip: "40351",
    ST: "KY",
    cityWithStateAbbr: "Morehead, KY",
  },
  {
    zip: "40353",
    ST: "KY",
    cityWithStateAbbr: "Mount Sterling, KY",
  },
  {
    zip: "40355",
    ST: "KY",
    cityWithStateAbbr: "New Liberty, KY",
  },
  {
    zip: "40356",
    ST: "KY",
    cityWithStateAbbr: "Nicholasville, KY",
  },
  {
    zip: "40357",
    ST: "KY",
    cityWithStateAbbr: "North Middletown, KY",
  },
  {
    zip: "40358",
    ST: "KY",
    cityWithStateAbbr: "Olympia, KY",
  },
  {
    zip: "40359",
    ST: "KY",
    cityWithStateAbbr: "Owenton, KY",
  },
  {
    zip: "40360",
    ST: "KY",
    cityWithStateAbbr: "Owingsville, KY",
  },
  {
    zip: "40361",
    ST: "KY",
    cityWithStateAbbr: "Paris, KY",
  },
  {
    zip: "40362",
    ST: "KY",
    cityWithStateAbbr: "Paris, KY",
  },
  {
    zip: "40363",
    ST: "KY",
    cityWithStateAbbr: "Perry Park, KY",
  },
  {
    zip: "40366",
    ST: "KY",
    cityWithStateAbbr: "Preston, KY",
  },
  {
    zip: "40370",
    ST: "KY",
    cityWithStateAbbr: "Sadieville, KY",
  },
  {
    zip: "40371",
    ST: "KY",
    cityWithStateAbbr: "Salt Lick, KY",
  },
  {
    zip: "40372",
    ST: "KY",
    cityWithStateAbbr: "Salvisa, KY",
  },
  {
    zip: "40374",
    ST: "KY",
    cityWithStateAbbr: "Sharpsburg, KY",
  },
  {
    zip: "40376",
    ST: "KY",
    cityWithStateAbbr: "Slade, KY",
  },
  {
    zip: "40379",
    ST: "KY",
    cityWithStateAbbr: "Stamping Ground, KY",
  },
  {
    zip: "40380",
    ST: "KY",
    cityWithStateAbbr: "Stanton, KY",
  },
  {
    zip: "40383",
    ST: "KY",
    cityWithStateAbbr: "Versailles, KY",
  },
  {
    zip: "40384",
    ST: "KY",
    cityWithStateAbbr: "Versailles, KY",
  },
  {
    zip: "40385",
    ST: "KY",
    cityWithStateAbbr: "Waco, KY",
  },
  {
    zip: "40387",
    ST: "KY",
    cityWithStateAbbr: "Wellington, KY",
  },
  {
    zip: "40390",
    ST: "KY",
    cityWithStateAbbr: "Wilmore, KY",
  },
  {
    zip: "40391",
    ST: "KY",
    cityWithStateAbbr: "Winchester, KY",
  },
  {
    zip: "40392",
    ST: "KY",
    cityWithStateAbbr: "Winchester, KY",
  },
  {
    zip: "40402",
    ST: "KY",
    cityWithStateAbbr: "Annville, KY",
  },
  {
    zip: "40403",
    ST: "KY",
    cityWithStateAbbr: "Berea, KY",
  },
  {
    zip: "40404",
    ST: "KY",
    cityWithStateAbbr: "Berea, KY",
  },
  {
    zip: "40405",
    ST: "KY",
    cityWithStateAbbr: "Bighill, KY",
  },
  {
    zip: "40409",
    ST: "KY",
    cityWithStateAbbr: "Brodhead, KY",
  },
  {
    zip: "40410",
    ST: "KY",
    cityWithStateAbbr: "Bryantsville, KY",
  },
  {
    zip: "40419",
    ST: "KY",
    cityWithStateAbbr: "Crab Orchard, KY",
  },
  {
    zip: "40422",
    ST: "KY",
    cityWithStateAbbr: "Danville, KY",
  },
  {
    zip: "40423",
    ST: "KY",
    cityWithStateAbbr: "Danville, KY",
  },
  {
    zip: "40434",
    ST: "KY",
    cityWithStateAbbr: "Gray Hawk, KY",
  },
  {
    zip: "40437",
    ST: "KY",
    cityWithStateAbbr: "Hustonville, KY",
  },
  {
    zip: "40440",
    ST: "KY",
    cityWithStateAbbr: "Junction City, KY",
  },
  {
    zip: "40442",
    ST: "KY",
    cityWithStateAbbr: "Kings Mountain, KY",
  },
  {
    zip: "40444",
    ST: "KY",
    cityWithStateAbbr: "Lancaster, KY",
  },
  {
    zip: "40445",
    ST: "KY",
    cityWithStateAbbr: "Livingston, KY",
  },
  {
    zip: "40446",
    ST: "KY",
    cityWithStateAbbr: "Lancaster, KY",
  },
  {
    zip: "40447",
    ST: "KY",
    cityWithStateAbbr: "Mc Kee, KY",
  },
  {
    zip: "40448",
    ST: "KY",
    cityWithStateAbbr: "Mc Kinney, KY",
  },
  {
    zip: "40452",
    ST: "KY",
    cityWithStateAbbr: "Mitchellsburg, KY",
  },
  {
    zip: "40456",
    ST: "KY",
    cityWithStateAbbr: "Mount Vernon, KY",
  },
  {
    zip: "40460",
    ST: "KY",
    cityWithStateAbbr: "Orlando, KY",
  },
  {
    zip: "40461",
    ST: "KY",
    cityWithStateAbbr: "Paint Lick, KY",
  },
  {
    zip: "40464",
    ST: "KY",
    cityWithStateAbbr: "Parksville, KY",
  },
  {
    zip: "40468",
    ST: "KY",
    cityWithStateAbbr: "Perryville, KY",
  },
  {
    zip: "40472",
    ST: "KY",
    cityWithStateAbbr: "Ravenna, KY",
  },
  {
    zip: "40473",
    ST: "KY",
    cityWithStateAbbr: "Renfro Valley, KY",
  },
  {
    zip: "40475",
    ST: "KY",
    cityWithStateAbbr: "Richmond, KY",
  },
  {
    zip: "40476",
    ST: "KY",
    cityWithStateAbbr: "Richmond, KY",
  },
  {
    zip: "40481",
    ST: "KY",
    cityWithStateAbbr: "Sandgap, KY",
  },
  {
    zip: "40484",
    ST: "KY",
    cityWithStateAbbr: "Stanford, KY",
  },
  {
    zip: "40486",
    ST: "KY",
    cityWithStateAbbr: "Tyner, KY",
  },
  {
    zip: "40488",
    ST: "KY",
    cityWithStateAbbr: "Waneta, KY",
  },
  {
    zip: "40489",
    ST: "KY",
    cityWithStateAbbr: "Waynesburg, KY",
  },
  {
    zip: "40492",
    ST: "KY",
    cityWithStateAbbr: "Wildie, KY",
  },
  {
    zip: "40502",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40503",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40504",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40505",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40506",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40507",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40508",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40509",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40510",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40511",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40512",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40513",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40514",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40515",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40516",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40517",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40522",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40523",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40524",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40526",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40533",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40536",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40544",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40546",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40550",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40555",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40574",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40575",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40576",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40577",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40578",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40579",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40580",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40581",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40582",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40583",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40588",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40591",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40598",
    ST: "KY",
    cityWithStateAbbr: "Lexington, KY",
  },
  {
    zip: "40601",
    ST: "KY",
    cityWithStateAbbr: "Frankfort, KY",
  },
  {
    zip: "40602",
    ST: "KY",
    cityWithStateAbbr: "Frankfort, KY",
  },
  {
    zip: "40603",
    ST: "KY",
    cityWithStateAbbr: "Frankfort, KY",
  },
  {
    zip: "40604",
    ST: "KY",
    cityWithStateAbbr: "Frankfort, KY",
  },
  {
    zip: "40618",
    ST: "KY",
    cityWithStateAbbr: "Frankfort, KY",
  },
  {
    zip: "40619",
    ST: "KY",
    cityWithStateAbbr: "Frankfort, KY",
  },
  {
    zip: "40620",
    ST: "KY",
    cityWithStateAbbr: "Frankfort, KY",
  },
  {
    zip: "40621",
    ST: "KY",
    cityWithStateAbbr: "Frankfort, KY",
  },
  {
    zip: "40622",
    ST: "KY",
    cityWithStateAbbr: "Frankfort, KY",
  },
  {
    zip: "40701",
    ST: "KY",
    cityWithStateAbbr: "Corbin, KY",
  },
  {
    zip: "40702",
    ST: "KY",
    cityWithStateAbbr: "Corbin, KY",
  },
  {
    zip: "40724",
    ST: "KY",
    cityWithStateAbbr: "Bush, KY",
  },
  {
    zip: "40729",
    ST: "KY",
    cityWithStateAbbr: "East Bernstadt, KY",
  },
  {
    zip: "40730",
    ST: "KY",
    cityWithStateAbbr: "Emlyn, KY",
  },
  {
    zip: "40734",
    ST: "KY",
    cityWithStateAbbr: "Gray, KY",
  },
  {
    zip: "40737",
    ST: "KY",
    cityWithStateAbbr: "Keavy, KY",
  },
  {
    zip: "40740",
    ST: "KY",
    cityWithStateAbbr: "Lily, KY",
  },
  {
    zip: "40741",
    ST: "KY",
    cityWithStateAbbr: "London, KY",
  },
  {
    zip: "40742",
    ST: "KY",
    cityWithStateAbbr: "London, KY",
  },
  {
    zip: "40743",
    ST: "KY",
    cityWithStateAbbr: "London, KY",
  },
  {
    zip: "40744",
    ST: "KY",
    cityWithStateAbbr: "London, KY",
  },
  {
    zip: "40745",
    ST: "KY",
    cityWithStateAbbr: "London, KY",
  },
  {
    zip: "40755",
    ST: "KY",
    cityWithStateAbbr: "Pittsburg, KY",
  },
  {
    zip: "40759",
    ST: "KY",
    cityWithStateAbbr: "Rockholds, KY",
  },
  {
    zip: "40763",
    ST: "KY",
    cityWithStateAbbr: "Siler, KY",
  },
  {
    zip: "40769",
    ST: "KY",
    cityWithStateAbbr: "Williamsburg, KY",
  },
  {
    zip: "40771",
    ST: "KY",
    cityWithStateAbbr: "Woodbine, KY",
  },
  {
    zip: "40801",
    ST: "KY",
    cityWithStateAbbr: "Ages Brookside, KY",
  },
  {
    zip: "40803",
    ST: "KY",
    cityWithStateAbbr: "Asher, KY",
  },
  {
    zip: "40806",
    ST: "KY",
    cityWithStateAbbr: "Baxter, KY",
  },
  {
    zip: "40807",
    ST: "KY",
    cityWithStateAbbr: "Benham, KY",
  },
  {
    zip: "40808",
    ST: "KY",
    cityWithStateAbbr: "Big Laurel, KY",
  },
  {
    zip: "40810",
    ST: "KY",
    cityWithStateAbbr: "Bledsoe, KY",
  },
  {
    zip: "40813",
    ST: "KY",
    cityWithStateAbbr: "Calvin, KY",
  },
  {
    zip: "40815",
    ST: "KY",
    cityWithStateAbbr: "Cawood, KY",
  },
  {
    zip: "40816",
    ST: "KY",
    cityWithStateAbbr: "Chappell, KY",
  },
  {
    zip: "40818",
    ST: "KY",
    cityWithStateAbbr: "Coalgood, KY",
  },
  {
    zip: "40819",
    ST: "KY",
    cityWithStateAbbr: "Coldiron, KY",
  },
  {
    zip: "40820",
    ST: "KY",
    cityWithStateAbbr: "Cranks, KY",
  },
  {
    zip: "40823",
    ST: "KY",
    cityWithStateAbbr: "Cumberland, KY",
  },
  {
    zip: "40824",
    ST: "KY",
    cityWithStateAbbr: "Dayhoit, KY",
  },
  {
    zip: "40826",
    ST: "KY",
    cityWithStateAbbr: "Eolia, KY",
  },
  {
    zip: "40827",
    ST: "KY",
    cityWithStateAbbr: "Essie, KY",
  },
  {
    zip: "40828",
    ST: "KY",
    cityWithStateAbbr: "Evarts, KY",
  },
  {
    zip: "40829",
    ST: "KY",
    cityWithStateAbbr: "Grays Knob, KY",
  },
  {
    zip: "40830",
    ST: "KY",
    cityWithStateAbbr: "Gulston, KY",
  },
  {
    zip: "40831",
    ST: "KY",
    cityWithStateAbbr: "Harlan, KY",
  },
  {
    zip: "40840",
    ST: "KY",
    cityWithStateAbbr: "Helton, KY",
  },
  {
    zip: "40843",
    ST: "KY",
    cityWithStateAbbr: "Holmes Mill, KY",
  },
  {
    zip: "40844",
    ST: "KY",
    cityWithStateAbbr: "Hoskinston, KY",
  },
  {
    zip: "40845",
    ST: "KY",
    cityWithStateAbbr: "Hulen, KY",
  },
  {
    zip: "40847",
    ST: "KY",
    cityWithStateAbbr: "Kenvir, KY",
  },
  {
    zip: "40849",
    ST: "KY",
    cityWithStateAbbr: "Lejunior, KY",
  },
  {
    zip: "40854",
    ST: "KY",
    cityWithStateAbbr: "Loyall, KY",
  },
  {
    zip: "40855",
    ST: "KY",
    cityWithStateAbbr: "Lynch, KY",
  },
  {
    zip: "40856",
    ST: "KY",
    cityWithStateAbbr: "Miracle, KY",
  },
  {
    zip: "40858",
    ST: "KY",
    cityWithStateAbbr: "Mozelle, KY",
  },
  {
    zip: "40862",
    ST: "KY",
    cityWithStateAbbr: "Partridge, KY",
  },
  {
    zip: "40863",
    ST: "KY",
    cityWithStateAbbr: "Pathfork, KY",
  },
  {
    zip: "40865",
    ST: "KY",
    cityWithStateAbbr: "Putney, KY",
  },
  {
    zip: "40868",
    ST: "KY",
    cityWithStateAbbr: "Stinnett, KY",
  },
  {
    zip: "40870",
    ST: "KY",
    cityWithStateAbbr: "Totz, KY",
  },
  {
    zip: "40873",
    ST: "KY",
    cityWithStateAbbr: "Wallins Creek, KY",
  },
  {
    zip: "40874",
    ST: "KY",
    cityWithStateAbbr: "Warbranch, KY",
  },
  {
    zip: "40902",
    ST: "KY",
    cityWithStateAbbr: "Arjay, KY",
  },
  {
    zip: "40903",
    ST: "KY",
    cityWithStateAbbr: "Artemus, KY",
  },
  {
    zip: "40906",
    ST: "KY",
    cityWithStateAbbr: "Barbourville, KY",
  },
  {
    zip: "40913",
    ST: "KY",
    cityWithStateAbbr: "Beverly, KY",
  },
  {
    zip: "40914",
    ST: "KY",
    cityWithStateAbbr: "Big Creek, KY",
  },
  {
    zip: "40915",
    ST: "KY",
    cityWithStateAbbr: "Bimble, KY",
  },
  {
    zip: "40921",
    ST: "KY",
    cityWithStateAbbr: "Bryants Store, KY",
  },
  {
    zip: "40923",
    ST: "KY",
    cityWithStateAbbr: "Cannon, KY",
  },
  {
    zip: "40927",
    ST: "KY",
    cityWithStateAbbr: "Closplint, KY",
  },
  {
    zip: "40930",
    ST: "KY",
    cityWithStateAbbr: "Dewitt, KY",
  },
  {
    zip: "40932",
    ST: "KY",
    cityWithStateAbbr: "Fall Rock, KY",
  },
  {
    zip: "40935",
    ST: "KY",
    cityWithStateAbbr: "Flat Lick, KY",
  },
  {
    zip: "40939",
    ST: "KY",
    cityWithStateAbbr: "Fourmile, KY",
  },
  {
    zip: "40940",
    ST: "KY",
    cityWithStateAbbr: "Frakes, KY",
  },
  {
    zip: "40941",
    ST: "KY",
    cityWithStateAbbr: "Garrard, KY",
  },
  {
    zip: "40943",
    ST: "KY",
    cityWithStateAbbr: "Girdler, KY",
  },
  {
    zip: "40944",
    ST: "KY",
    cityWithStateAbbr: "Goose Rock, KY",
  },
  {
    zip: "40946",
    ST: "KY",
    cityWithStateAbbr: "Green Road, KY",
  },
  {
    zip: "40949",
    ST: "KY",
    cityWithStateAbbr: "Heidrick, KY",
  },
  {
    zip: "40951",
    ST: "KY",
    cityWithStateAbbr: "Hima, KY",
  },
  {
    zip: "40953",
    ST: "KY",
    cityWithStateAbbr: "Hinkle, KY",
  },
  {
    zip: "40955",
    ST: "KY",
    cityWithStateAbbr: "Ingram, KY",
  },
  {
    zip: "40958",
    ST: "KY",
    cityWithStateAbbr: "Kettle Island, KY",
  },
  {
    zip: "40962",
    ST: "KY",
    cityWithStateAbbr: "Manchester, KY",
  },
  {
    zip: "40964",
    ST: "KY",
    cityWithStateAbbr: "Mary Alice, KY",
  },
  {
    zip: "40965",
    ST: "KY",
    cityWithStateAbbr: "Middlesboro, KY",
  },
  {
    zip: "40972",
    ST: "KY",
    cityWithStateAbbr: "Oneida, KY",
  },
  {
    zip: "40977",
    ST: "KY",
    cityWithStateAbbr: "Pineville, KY",
  },
  {
    zip: "40979",
    ST: "KY",
    cityWithStateAbbr: "Roark, KY",
  },
  {
    zip: "40981",
    ST: "KY",
    cityWithStateAbbr: "Saul, KY",
  },
  {
    zip: "40982",
    ST: "KY",
    cityWithStateAbbr: "Scalf, KY",
  },
  {
    zip: "40983",
    ST: "KY",
    cityWithStateAbbr: "Sextons Creek, KY",
  },
  {
    zip: "40988",
    ST: "KY",
    cityWithStateAbbr: "Stoney Fork, KY",
  },
  {
    zip: "40995",
    ST: "KY",
    cityWithStateAbbr: "Trosper, KY",
  },
  {
    zip: "40997",
    ST: "KY",
    cityWithStateAbbr: "Walker, KY",
  },
  {
    zip: "40999",
    ST: "KY",
    cityWithStateAbbr: "Woollum, KY",
  },
  {
    zip: "41001",
    ST: "KY",
    cityWithStateAbbr: "Alexandria, KY",
  },
  {
    zip: "41002",
    ST: "KY",
    cityWithStateAbbr: "Augusta, KY",
  },
  {
    zip: "41003",
    ST: "KY",
    cityWithStateAbbr: "Berry, KY",
  },
  {
    zip: "41004",
    ST: "KY",
    cityWithStateAbbr: "Brooksville, KY",
  },
  {
    zip: "41005",
    ST: "KY",
    cityWithStateAbbr: "Burlington, KY",
  },
  {
    zip: "41006",
    ST: "KY",
    cityWithStateAbbr: "Butler, KY",
  },
  {
    zip: "41007",
    ST: "KY",
    cityWithStateAbbr: "California, KY",
  },
  {
    zip: "41008",
    ST: "KY",
    cityWithStateAbbr: "Carrollton, KY",
  },
  {
    zip: "41010",
    ST: "KY",
    cityWithStateAbbr: "Corinth, KY",
  },
  {
    zip: "41011",
    ST: "KY",
    cityWithStateAbbr: "Covington, KY",
  },
  {
    zip: "41012",
    ST: "KY",
    cityWithStateAbbr: "Covington, KY",
  },
  {
    zip: "41014",
    ST: "KY",
    cityWithStateAbbr: "Covington, KY",
  },
  {
    zip: "41015",
    ST: "KY",
    cityWithStateAbbr: "Latonia, KY",
  },
  {
    zip: "41016",
    ST: "KY",
    cityWithStateAbbr: "Covington, KY",
  },
  {
    zip: "41017",
    ST: "KY",
    cityWithStateAbbr: "Ft Mitchell, KY",
  },
  {
    zip: "41018",
    ST: "KY",
    cityWithStateAbbr: "Erlanger, KY",
  },
  {
    zip: "41019",
    ST: "KY",
    cityWithStateAbbr: "Covington, KY",
  },
  {
    zip: "41022",
    ST: "KY",
    cityWithStateAbbr: "Florence, KY",
  },
  {
    zip: "41030",
    ST: "KY",
    cityWithStateAbbr: "Crittenden, KY",
  },
  {
    zip: "41031",
    ST: "KY",
    cityWithStateAbbr: "Cynthiana, KY",
  },
  {
    zip: "41033",
    ST: "KY",
    cityWithStateAbbr: "De Mossville, KY",
  },
  {
    zip: "41034",
    ST: "KY",
    cityWithStateAbbr: "Dover, KY",
  },
  {
    zip: "41035",
    ST: "KY",
    cityWithStateAbbr: "Dry Ridge, KY",
  },
  {
    zip: "41037",
    ST: "KY",
    cityWithStateAbbr: "Elizaville, KY",
  },
  {
    zip: "41039",
    ST: "KY",
    cityWithStateAbbr: "Ewing, KY",
  },
  {
    zip: "41040",
    ST: "KY",
    cityWithStateAbbr: "Falmouth, KY",
  },
  {
    zip: "41041",
    ST: "KY",
    cityWithStateAbbr: "Flemingsburg, KY",
  },
  {
    zip: "41042",
    ST: "KY",
    cityWithStateAbbr: "Florence, KY",
  },
  {
    zip: "41043",
    ST: "KY",
    cityWithStateAbbr: "Foster, KY",
  },
  {
    zip: "41044",
    ST: "KY",
    cityWithStateAbbr: "Germantown, KY",
  },
  {
    zip: "41045",
    ST: "KY",
    cityWithStateAbbr: "Ghent, KY",
  },
  {
    zip: "41046",
    ST: "KY",
    cityWithStateAbbr: "Glencoe, KY",
  },
  {
    zip: "41048",
    ST: "KY",
    cityWithStateAbbr: "Hebron, KY",
  },
  {
    zip: "41049",
    ST: "KY",
    cityWithStateAbbr: "Hillsboro, KY",
  },
  {
    zip: "41051",
    ST: "KY",
    cityWithStateAbbr: "Independence, KY",
  },
  {
    zip: "41052",
    ST: "KY",
    cityWithStateAbbr: "Jonesville, KY",
  },
  {
    zip: "41053",
    ST: "KY",
    cityWithStateAbbr: "Kenton, KY",
  },
  {
    zip: "41054",
    ST: "KY",
    cityWithStateAbbr: "Mason, KY",
  },
  {
    zip: "41055",
    ST: "KY",
    cityWithStateAbbr: "Mayslick, KY",
  },
  {
    zip: "41056",
    ST: "KY",
    cityWithStateAbbr: "Maysville, KY",
  },
  {
    zip: "41059",
    ST: "KY",
    cityWithStateAbbr: "Melbourne, KY",
  },
  {
    zip: "41061",
    ST: "KY",
    cityWithStateAbbr: "Milford, KY",
  },
  {
    zip: "41062",
    ST: "KY",
    cityWithStateAbbr: "Minerva, KY",
  },
  {
    zip: "41063",
    ST: "KY",
    cityWithStateAbbr: "Morning View, KY",
  },
  {
    zip: "41064",
    ST: "KY",
    cityWithStateAbbr: "Mount Olivet, KY",
  },
  {
    zip: "41065",
    ST: "KY",
    cityWithStateAbbr: "Muses Mills, KY",
  },
  {
    zip: "41071",
    ST: "KY",
    cityWithStateAbbr: "Newport, KY",
  },
  {
    zip: "41072",
    ST: "KY",
    cityWithStateAbbr: "Newport, KY",
  },
  {
    zip: "41073",
    ST: "KY",
    cityWithStateAbbr: "Bellevue, KY",
  },
  {
    zip: "41074",
    ST: "KY",
    cityWithStateAbbr: "Dayton, KY",
  },
  {
    zip: "41075",
    ST: "KY",
    cityWithStateAbbr: "Fort Thomas, KY",
  },
  {
    zip: "41076",
    ST: "KY",
    cityWithStateAbbr: "Newport, KY",
  },
  {
    zip: "41080",
    ST: "KY",
    cityWithStateAbbr: "Petersburg, KY",
  },
  {
    zip: "41081",
    ST: "KY",
    cityWithStateAbbr: "Plummers Landing, KY",
  },
  {
    zip: "41083",
    ST: "KY",
    cityWithStateAbbr: "Sanders, KY",
  },
  {
    zip: "41085",
    ST: "KY",
    cityWithStateAbbr: "Silver Grove, KY",
  },
  {
    zip: "41086",
    ST: "KY",
    cityWithStateAbbr: "Sparta, KY",
  },
  {
    zip: "41091",
    ST: "KY",
    cityWithStateAbbr: "Union, KY",
  },
  {
    zip: "41092",
    ST: "KY",
    cityWithStateAbbr: "Verona, KY",
  },
  {
    zip: "41093",
    ST: "KY",
    cityWithStateAbbr: "Wallingford, KY",
  },
  {
    zip: "41094",
    ST: "KY",
    cityWithStateAbbr: "Walton, KY",
  },
  {
    zip: "41095",
    ST: "KY",
    cityWithStateAbbr: "Warsaw, KY",
  },
  {
    zip: "41096",
    ST: "KY",
    cityWithStateAbbr: "Washington, KY",
  },
  {
    zip: "41097",
    ST: "KY",
    cityWithStateAbbr: "Williamstown, KY",
  },
  {
    zip: "41098",
    ST: "KY",
    cityWithStateAbbr: "Worthville, KY",
  },
  {
    zip: "41099",
    ST: "KY",
    cityWithStateAbbr: "Newport, KY",
  },
  {
    zip: "41101",
    ST: "KY",
    cityWithStateAbbr: "Ashland, KY",
  },
  {
    zip: "41102",
    ST: "KY",
    cityWithStateAbbr: "Ashland, KY",
  },
  {
    zip: "41105",
    ST: "KY",
    cityWithStateAbbr: "Ashland, KY",
  },
  {
    zip: "41114",
    ST: "KY",
    cityWithStateAbbr: "Ashland, KY",
  },
  {
    zip: "41121",
    ST: "KY",
    cityWithStateAbbr: "Argillite, KY",
  },
  {
    zip: "41124",
    ST: "KY",
    cityWithStateAbbr: "Blaine, KY",
  },
  {
    zip: "41128",
    ST: "KY",
    cityWithStateAbbr: "Carter, KY",
  },
  {
    zip: "41129",
    ST: "KY",
    cityWithStateAbbr: "Catlettsburg, KY",
  },
  {
    zip: "41132",
    ST: "KY",
    cityWithStateAbbr: "Denton, KY",
  },
  {
    zip: "41135",
    ST: "KY",
    cityWithStateAbbr: "Emerson, KY",
  },
  {
    zip: "41139",
    ST: "KY",
    cityWithStateAbbr: "Flatwoods, KY",
  },
  {
    zip: "41141",
    ST: "KY",
    cityWithStateAbbr: "Garrison, KY",
  },
  {
    zip: "41142",
    ST: "KY",
    cityWithStateAbbr: "Grahn, KY",
  },
  {
    zip: "41143",
    ST: "KY",
    cityWithStateAbbr: "Grayson, KY",
  },
  {
    zip: "41144",
    ST: "KY",
    cityWithStateAbbr: "Greenup, KY",
  },
  {
    zip: "41146",
    ST: "KY",
    cityWithStateAbbr: "Hitchins, KY",
  },
  {
    zip: "41149",
    ST: "KY",
    cityWithStateAbbr: "Isonville, KY",
  },
  {
    zip: "41159",
    ST: "KY",
    cityWithStateAbbr: "Martha, KY",
  },
  {
    zip: "41160",
    ST: "KY",
    cityWithStateAbbr: "Mazie, KY",
  },
  {
    zip: "41164",
    ST: "KY",
    cityWithStateAbbr: "Olive Hill, KY",
  },
  {
    zip: "41166",
    ST: "KY",
    cityWithStateAbbr: "Quincy, KY",
  },
  {
    zip: "41168",
    ST: "KY",
    cityWithStateAbbr: "Rush, KY",
  },
  {
    zip: "41169",
    ST: "KY",
    cityWithStateAbbr: "Russell, KY",
  },
  {
    zip: "41171",
    ST: "KY",
    cityWithStateAbbr: "Sandy Hook, KY",
  },
  {
    zip: "41173",
    ST: "KY",
    cityWithStateAbbr: "Soldier, KY",
  },
  {
    zip: "41174",
    ST: "KY",
    cityWithStateAbbr: "South Portsmouth, KY",
  },
  {
    zip: "41175",
    ST: "KY",
    cityWithStateAbbr: "South Shore, KY",
  },
  {
    zip: "41179",
    ST: "KY",
    cityWithStateAbbr: "Vanceburg, KY",
  },
  {
    zip: "41180",
    ST: "KY",
    cityWithStateAbbr: "Webbville, KY",
  },
  {
    zip: "41181",
    ST: "KY",
    cityWithStateAbbr: "Willard, KY",
  },
  {
    zip: "41183",
    ST: "KY",
    cityWithStateAbbr: "Worthington, KY",
  },
  {
    zip: "41189",
    ST: "KY",
    cityWithStateAbbr: "Tollesboro, KY",
  },
  {
    zip: "41201",
    ST: "KY",
    cityWithStateAbbr: "Adams, KY",
  },
  {
    zip: "41203",
    ST: "KY",
    cityWithStateAbbr: "Beauty, KY",
  },
  {
    zip: "41204",
    ST: "KY",
    cityWithStateAbbr: "Boons Camp, KY",
  },
  {
    zip: "41214",
    ST: "KY",
    cityWithStateAbbr: "Debord, KY",
  },
  {
    zip: "41216",
    ST: "KY",
    cityWithStateAbbr: "East Point, KY",
  },
  {
    zip: "41219",
    ST: "KY",
    cityWithStateAbbr: "Flatgap, KY",
  },
  {
    zip: "41222",
    ST: "KY",
    cityWithStateAbbr: "Hagerhill, KY",
  },
  {
    zip: "41224",
    ST: "KY",
    cityWithStateAbbr: "Inez, KY",
  },
  {
    zip: "41226",
    ST: "KY",
    cityWithStateAbbr: "Keaton, KY",
  },
  {
    zip: "41230",
    ST: "KY",
    cityWithStateAbbr: "Louisa, KY",
  },
  {
    zip: "41231",
    ST: "KY",
    cityWithStateAbbr: "Lovely, KY",
  },
  {
    zip: "41232",
    ST: "KY",
    cityWithStateAbbr: "Lowmansville, KY",
  },
  {
    zip: "41234",
    ST: "KY",
    cityWithStateAbbr: "Meally, KY",
  },
  {
    zip: "41238",
    ST: "KY",
    cityWithStateAbbr: "Oil Springs, KY",
  },
  {
    zip: "41240",
    ST: "KY",
    cityWithStateAbbr: "Paintsville, KY",
  },
  {
    zip: "41250",
    ST: "KY",
    cityWithStateAbbr: "Pilgrim, KY",
  },
  {
    zip: "41254",
    ST: "KY",
    cityWithStateAbbr: "River, KY",
  },
  {
    zip: "41255",
    ST: "KY",
    cityWithStateAbbr: "Sitka, KY",
  },
  {
    zip: "41256",
    ST: "KY",
    cityWithStateAbbr: "Staffordsville, KY",
  },
  {
    zip: "41257",
    ST: "KY",
    cityWithStateAbbr: "Stambaugh, KY",
  },
  {
    zip: "41260",
    ST: "KY",
    cityWithStateAbbr: "Thelma, KY",
  },
  {
    zip: "41262",
    ST: "KY",
    cityWithStateAbbr: "Tomahawk, KY",
  },
  {
    zip: "41263",
    ST: "KY",
    cityWithStateAbbr: "Tutor Key, KY",
  },
  {
    zip: "41264",
    ST: "KY",
    cityWithStateAbbr: "Ulysses, KY",
  },
  {
    zip: "41265",
    ST: "KY",
    cityWithStateAbbr: "Van Lear, KY",
  },
  {
    zip: "41267",
    ST: "KY",
    cityWithStateAbbr: "Warfield, KY",
  },
  {
    zip: "41268",
    ST: "KY",
    cityWithStateAbbr: "West Van Lear, KY",
  },
  {
    zip: "41271",
    ST: "KY",
    cityWithStateAbbr: "Williamsport, KY",
  },
  {
    zip: "41274",
    ST: "KY",
    cityWithStateAbbr: "Wittensville, KY",
  },
  {
    zip: "41301",
    ST: "KY",
    cityWithStateAbbr: "Campton, KY",
  },
  {
    zip: "41307",
    ST: "KY",
    cityWithStateAbbr: "Athol, KY",
  },
  {
    zip: "41310",
    ST: "KY",
    cityWithStateAbbr: "Bays, KY",
  },
  {
    zip: "41311",
    ST: "KY",
    cityWithStateAbbr: "Beattyville, KY",
  },
  {
    zip: "41313",
    ST: "KY",
    cityWithStateAbbr: "Campton, KY",
  },
  {
    zip: "41314",
    ST: "KY",
    cityWithStateAbbr: "Booneville, KY",
  },
  {
    zip: "41317",
    ST: "KY",
    cityWithStateAbbr: "Clayhole, KY",
  },
  {
    zip: "41332",
    ST: "KY",
    cityWithStateAbbr: "Hazel Green, KY",
  },
  {
    zip: "41333",
    ST: "KY",
    cityWithStateAbbr: "Heidelberg, KY",
  },
  {
    zip: "41338",
    ST: "KY",
    cityWithStateAbbr: "Island City, KY",
  },
  {
    zip: "41339",
    ST: "KY",
    cityWithStateAbbr: "Jackson, KY",
  },
  {
    zip: "41347",
    ST: "KY",
    cityWithStateAbbr: "Lone, KY",
  },
  {
    zip: "41348",
    ST: "KY",
    cityWithStateAbbr: "Lost Creek, KY",
  },
  {
    zip: "41351",
    ST: "KY",
    cityWithStateAbbr: "Mistletoe, KY",
  },
  {
    zip: "41352",
    ST: "KY",
    cityWithStateAbbr: "Mize, KY",
  },
  {
    zip: "41360",
    ST: "KY",
    cityWithStateAbbr: "Pine Ridge, KY",
  },
  {
    zip: "41362",
    ST: "KY",
    cityWithStateAbbr: "Primrose, KY",
  },
  {
    zip: "41364",
    ST: "KY",
    cityWithStateAbbr: "Ricetown, KY",
  },
  {
    zip: "41365",
    ST: "KY",
    cityWithStateAbbr: "Rogers, KY",
  },
  {
    zip: "41366",
    ST: "KY",
    cityWithStateAbbr: "Rousseau, KY",
  },
  {
    zip: "41367",
    ST: "KY",
    cityWithStateAbbr: "Rowdy, KY",
  },
  {
    zip: "41368",
    ST: "KY",
    cityWithStateAbbr: "Saint Helens, KY",
  },
  {
    zip: "41385",
    ST: "KY",
    cityWithStateAbbr: "Vancleve, KY",
  },
  {
    zip: "41386",
    ST: "KY",
    cityWithStateAbbr: "Vincent, KY",
  },
  {
    zip: "41390",
    ST: "KY",
    cityWithStateAbbr: "Whick, KY",
  },
  {
    zip: "41397",
    ST: "KY",
    cityWithStateAbbr: "Zoe, KY",
  },
  {
    zip: "41408",
    ST: "KY",
    cityWithStateAbbr: "Cannel City, KY",
  },
  {
    zip: "41413",
    ST: "KY",
    cityWithStateAbbr: "Crockett, KY",
  },
  {
    zip: "41421",
    ST: "KY",
    cityWithStateAbbr: "Elkfork, KY",
  },
  {
    zip: "41425",
    ST: "KY",
    cityWithStateAbbr: "Ezel, KY",
  },
  {
    zip: "41426",
    ST: "KY",
    cityWithStateAbbr: "Falcon, KY",
  },
  {
    zip: "41451",
    ST: "KY",
    cityWithStateAbbr: "Malone, KY",
  },
  {
    zip: "41459",
    ST: "KY",
    cityWithStateAbbr: "Ophir, KY",
  },
  {
    zip: "41464",
    ST: "KY",
    cityWithStateAbbr: "Royalton, KY",
  },
  {
    zip: "41465",
    ST: "KY",
    cityWithStateAbbr: "Salyersville, KY",
  },
  {
    zip: "41472",
    ST: "KY",
    cityWithStateAbbr: "West Liberty, KY",
  },
  {
    zip: "41477",
    ST: "KY",
    cityWithStateAbbr: "Wrigley, KY",
  },
  {
    zip: "41501",
    ST: "KY",
    cityWithStateAbbr: "Pikeville, KY",
  },
  {
    zip: "41502",
    ST: "KY",
    cityWithStateAbbr: "Pikeville, KY",
  },
  {
    zip: "41503",
    ST: "KY",
    cityWithStateAbbr: "South Williamson, KY",
  },
  {
    zip: "41512",
    ST: "KY",
    cityWithStateAbbr: "Ashcamp, KY",
  },
  {
    zip: "41513",
    ST: "KY",
    cityWithStateAbbr: "Belcher, KY",
  },
  {
    zip: "41514",
    ST: "KY",
    cityWithStateAbbr: "Belfry, KY",
  },
  {
    zip: "41517",
    ST: "KY",
    cityWithStateAbbr: "Burdine, KY",
  },
  {
    zip: "41519",
    ST: "KY",
    cityWithStateAbbr: "Canada, KY",
  },
  {
    zip: "41520",
    ST: "KY",
    cityWithStateAbbr: "Dorton, KY",
  },
  {
    zip: "41522",
    ST: "KY",
    cityWithStateAbbr: "Elkhorn City, KY",
  },
  {
    zip: "41524",
    ST: "KY",
    cityWithStateAbbr: "Fedscreek, KY",
  },
  {
    zip: "41526",
    ST: "KY",
    cityWithStateAbbr: "Fords Branch, KY",
  },
  {
    zip: "41527",
    ST: "KY",
    cityWithStateAbbr: "Forest Hills, KY",
  },
  {
    zip: "41528",
    ST: "KY",
    cityWithStateAbbr: "Freeburn, KY",
  },
  {
    zip: "41531",
    ST: "KY",
    cityWithStateAbbr: "Hardy, KY",
  },
  {
    zip: "41534",
    ST: "KY",
    cityWithStateAbbr: "Hellier, KY",
  },
  {
    zip: "41535",
    ST: "KY",
    cityWithStateAbbr: "Huddy, KY",
  },
  {
    zip: "41537",
    ST: "KY",
    cityWithStateAbbr: "Jenkins, KY",
  },
  {
    zip: "41538",
    ST: "KY",
    cityWithStateAbbr: "Jonancy, KY",
  },
  {
    zip: "41539",
    ST: "KY",
    cityWithStateAbbr: "Kimper, KY",
  },
  {
    zip: "41540",
    ST: "KY",
    cityWithStateAbbr: "Lick Creek, KY",
  },
  {
    zip: "41542",
    ST: "KY",
    cityWithStateAbbr: "Lookout, KY",
  },
  {
    zip: "41543",
    ST: "KY",
    cityWithStateAbbr: "Mc Andrews, KY",
  },
  {
    zip: "41544",
    ST: "KY",
    cityWithStateAbbr: "Mc Carr, KY",
  },
  {
    zip: "41547",
    ST: "KY",
    cityWithStateAbbr: "Majestic, KY",
  },
  {
    zip: "41548",
    ST: "KY",
    cityWithStateAbbr: "Mouthcard, KY",
  },
  {
    zip: "41549",
    ST: "KY",
    cityWithStateAbbr: "Myra, KY",
  },
  {
    zip: "41553",
    ST: "KY",
    cityWithStateAbbr: "Phelps, KY",
  },
  {
    zip: "41554",
    ST: "KY",
    cityWithStateAbbr: "Phyllis, KY",
  },
  {
    zip: "41555",
    ST: "KY",
    cityWithStateAbbr: "Pinsonfork, KY",
  },
  {
    zip: "41557",
    ST: "KY",
    cityWithStateAbbr: "Raccoon, KY",
  },
  {
    zip: "41558",
    ST: "KY",
    cityWithStateAbbr: "Ransom, KY",
  },
  {
    zip: "41559",
    ST: "KY",
    cityWithStateAbbr: "Regina, KY",
  },
  {
    zip: "41560",
    ST: "KY",
    cityWithStateAbbr: "Robinson Creek, KY",
  },
  {
    zip: "41561",
    ST: "KY",
    cityWithStateAbbr: "Rockhouse, KY",
  },
  {
    zip: "41562",
    ST: "KY",
    cityWithStateAbbr: "Shelbiana, KY",
  },
  {
    zip: "41563",
    ST: "KY",
    cityWithStateAbbr: "Shelby Gap, KY",
  },
  {
    zip: "41564",
    ST: "KY",
    cityWithStateAbbr: "Sidney, KY",
  },
  {
    zip: "41566",
    ST: "KY",
    cityWithStateAbbr: "Steele, KY",
  },
  {
    zip: "41567",
    ST: "KY",
    cityWithStateAbbr: "Stone, KY",
  },
  {
    zip: "41568",
    ST: "KY",
    cityWithStateAbbr: "Stopover, KY",
  },
  {
    zip: "41571",
    ST: "KY",
    cityWithStateAbbr: "Varney, KY",
  },
  {
    zip: "41572",
    ST: "KY",
    cityWithStateAbbr: "Virgie, KY",
  },
  {
    zip: "41601",
    ST: "KY",
    cityWithStateAbbr: "Allen, KY",
  },
  {
    zip: "41602",
    ST: "KY",
    cityWithStateAbbr: "Auxier, KY",
  },
  {
    zip: "41603",
    ST: "KY",
    cityWithStateAbbr: "Banner, KY",
  },
  {
    zip: "41604",
    ST: "KY",
    cityWithStateAbbr: "Beaver, KY",
  },
  {
    zip: "41605",
    ST: "KY",
    cityWithStateAbbr: "Betsy Layne, KY",
  },
  {
    zip: "41606",
    ST: "KY",
    cityWithStateAbbr: "Bevinsville, KY",
  },
  {
    zip: "41607",
    ST: "KY",
    cityWithStateAbbr: "Blue River, KY",
  },
  {
    zip: "41612",
    ST: "KY",
    cityWithStateAbbr: "Bypro, KY",
  },
  {
    zip: "41615",
    ST: "KY",
    cityWithStateAbbr: "Dana, KY",
  },
  {
    zip: "41616",
    ST: "KY",
    cityWithStateAbbr: "David, KY",
  },
  {
    zip: "41619",
    ST: "KY",
    cityWithStateAbbr: "Drift, KY",
  },
  {
    zip: "41621",
    ST: "KY",
    cityWithStateAbbr: "Dwale, KY",
  },
  {
    zip: "41622",
    ST: "KY",
    cityWithStateAbbr: "Eastern, KY",
  },
  {
    zip: "41630",
    ST: "KY",
    cityWithStateAbbr: "Garrett, KY",
  },
  {
    zip: "41631",
    ST: "KY",
    cityWithStateAbbr: "Grethel, KY",
  },
  {
    zip: "41632",
    ST: "KY",
    cityWithStateAbbr: "Gunlock, KY",
  },
  {
    zip: "41635",
    ST: "KY",
    cityWithStateAbbr: "Harold, KY",
  },
  {
    zip: "41636",
    ST: "KY",
    cityWithStateAbbr: "Hi Hat, KY",
  },
  {
    zip: "41640",
    ST: "KY",
    cityWithStateAbbr: "Hueysville, KY",
  },
  {
    zip: "41642",
    ST: "KY",
    cityWithStateAbbr: "Ivel, KY",
  },
  {
    zip: "41643",
    ST: "KY",
    cityWithStateAbbr: "Lackey, KY",
  },
  {
    zip: "41645",
    ST: "KY",
    cityWithStateAbbr: "Langley, KY",
  },
  {
    zip: "41647",
    ST: "KY",
    cityWithStateAbbr: "Mc Dowell, KY",
  },
  {
    zip: "41649",
    ST: "KY",
    cityWithStateAbbr: "Martin, KY",
  },
  {
    zip: "41650",
    ST: "KY",
    cityWithStateAbbr: "Melvin, KY",
  },
  {
    zip: "41651",
    ST: "KY",
    cityWithStateAbbr: "Minnie, KY",
  },
  {
    zip: "41653",
    ST: "KY",
    cityWithStateAbbr: "Prestonsburg, KY",
  },
  {
    zip: "41655",
    ST: "KY",
    cityWithStateAbbr: "Printer, KY",
  },
  {
    zip: "41659",
    ST: "KY",
    cityWithStateAbbr: "Stanville, KY",
  },
  {
    zip: "41660",
    ST: "KY",
    cityWithStateAbbr: "Teaberry, KY",
  },
  {
    zip: "41663",
    ST: "KY",
    cityWithStateAbbr: "Tram, KY",
  },
  {
    zip: "41666",
    ST: "KY",
    cityWithStateAbbr: "Wayland, KY",
  },
  {
    zip: "41667",
    ST: "KY",
    cityWithStateAbbr: "Weeksbury, KY",
  },
  {
    zip: "41669",
    ST: "KY",
    cityWithStateAbbr: "Wheelwright, KY",
  },
  {
    zip: "41701",
    ST: "KY",
    cityWithStateAbbr: "Hazard, KY",
  },
  {
    zip: "41702",
    ST: "KY",
    cityWithStateAbbr: "Hazard, KY",
  },
  {
    zip: "41712",
    ST: "KY",
    cityWithStateAbbr: "Ary, KY",
  },
  {
    zip: "41713",
    ST: "KY",
    cityWithStateAbbr: "Avawam, KY",
  },
  {
    zip: "41714",
    ST: "KY",
    cityWithStateAbbr: "Bear Branch, KY",
  },
  {
    zip: "41719",
    ST: "KY",
    cityWithStateAbbr: "Bonnyman, KY",
  },
  {
    zip: "41721",
    ST: "KY",
    cityWithStateAbbr: "Buckhorn, KY",
  },
  {
    zip: "41722",
    ST: "KY",
    cityWithStateAbbr: "Bulan, KY",
  },
  {
    zip: "41723",
    ST: "KY",
    cityWithStateAbbr: "Busy, KY",
  },
  {
    zip: "41725",
    ST: "KY",
    cityWithStateAbbr: "Carrie, KY",
  },
  {
    zip: "41727",
    ST: "KY",
    cityWithStateAbbr: "Chavies, KY",
  },
  {
    zip: "41729",
    ST: "KY",
    cityWithStateAbbr: "Combs, KY",
  },
  {
    zip: "41731",
    ST: "KY",
    cityWithStateAbbr: "Cornettsville, KY",
  },
  {
    zip: "41735",
    ST: "KY",
    cityWithStateAbbr: "Delphia, KY",
  },
  {
    zip: "41736",
    ST: "KY",
    cityWithStateAbbr: "Dice, KY",
  },
  {
    zip: "41739",
    ST: "KY",
    cityWithStateAbbr: "Dwarf, KY",
  },
  {
    zip: "41740",
    ST: "KY",
    cityWithStateAbbr: "Emmalena, KY",
  },
  {
    zip: "41743",
    ST: "KY",
    cityWithStateAbbr: "Fisty, KY",
  },
  {
    zip: "41745",
    ST: "KY",
    cityWithStateAbbr: "Gays Creek, KY",
  },
  {
    zip: "41746",
    ST: "KY",
    cityWithStateAbbr: "Happy, KY",
  },
  {
    zip: "41747",
    ST: "KY",
    cityWithStateAbbr: "Hardburly, KY",
  },
  {
    zip: "41749",
    ST: "KY",
    cityWithStateAbbr: "Hyden, KY",
  },
  {
    zip: "41751",
    ST: "KY",
    cityWithStateAbbr: "Jeff, KY",
  },
  {
    zip: "41754",
    ST: "KY",
    cityWithStateAbbr: "Krypton, KY",
  },
  {
    zip: "41759",
    ST: "KY",
    cityWithStateAbbr: "Sassafras, KY",
  },
  {
    zip: "41760",
    ST: "KY",
    cityWithStateAbbr: "Scuddy, KY",
  },
  {
    zip: "41762",
    ST: "KY",
    cityWithStateAbbr: "Sizerock, KY",
  },
  {
    zip: "41763",
    ST: "KY",
    cityWithStateAbbr: "Slemp, KY",
  },
  {
    zip: "41764",
    ST: "KY",
    cityWithStateAbbr: "Smilax, KY",
  },
  {
    zip: "41766",
    ST: "KY",
    cityWithStateAbbr: "Thousandsticks, KY",
  },
  {
    zip: "41772",
    ST: "KY",
    cityWithStateAbbr: "Vest, KY",
  },
  {
    zip: "41773",
    ST: "KY",
    cityWithStateAbbr: "Vicco, KY",
  },
  {
    zip: "41774",
    ST: "KY",
    cityWithStateAbbr: "Viper, KY",
  },
  {
    zip: "41775",
    ST: "KY",
    cityWithStateAbbr: "Wendover, KY",
  },
  {
    zip: "41776",
    ST: "KY",
    cityWithStateAbbr: "Wooton, KY",
  },
  {
    zip: "41777",
    ST: "KY",
    cityWithStateAbbr: "Yeaddiss, KY",
  },
  {
    zip: "41778",
    ST: "KY",
    cityWithStateAbbr: "Yerkes, KY",
  },
  {
    zip: "41804",
    ST: "KY",
    cityWithStateAbbr: "Blackey, KY",
  },
  {
    zip: "41810",
    ST: "KY",
    cityWithStateAbbr: "Cromona, KY",
  },
  {
    zip: "41812",
    ST: "KY",
    cityWithStateAbbr: "Deane, KY",
  },
  {
    zip: "41815",
    ST: "KY",
    cityWithStateAbbr: "Ermine, KY",
  },
  {
    zip: "41817",
    ST: "KY",
    cityWithStateAbbr: "Garner, KY",
  },
  {
    zip: "41819",
    ST: "KY",
    cityWithStateAbbr: "Gordon, KY",
  },
  {
    zip: "41821",
    ST: "KY",
    cityWithStateAbbr: "Hallie, KY",
  },
  {
    zip: "41822",
    ST: "KY",
    cityWithStateAbbr: "Hindman, KY",
  },
  {
    zip: "41824",
    ST: "KY",
    cityWithStateAbbr: "Isom, KY",
  },
  {
    zip: "41825",
    ST: "KY",
    cityWithStateAbbr: "Jackhorn, KY",
  },
  {
    zip: "41826",
    ST: "KY",
    cityWithStateAbbr: "Jeremiah, KY",
  },
  {
    zip: "41828",
    ST: "KY",
    cityWithStateAbbr: "Kite, KY",
  },
  {
    zip: "41831",
    ST: "KY",
    cityWithStateAbbr: "Leburn, KY",
  },
  {
    zip: "41832",
    ST: "KY",
    cityWithStateAbbr: "Letcher, KY",
  },
  {
    zip: "41833",
    ST: "KY",
    cityWithStateAbbr: "Linefork, KY",
  },
  {
    zip: "41834",
    ST: "KY",
    cityWithStateAbbr: "Littcarr, KY",
  },
  {
    zip: "41835",
    ST: "KY",
    cityWithStateAbbr: "Mc Roberts, KY",
  },
  {
    zip: "41836",
    ST: "KY",
    cityWithStateAbbr: "Mallie, KY",
  },
  {
    zip: "41837",
    ST: "KY",
    cityWithStateAbbr: "Mayking, KY",
  },
  {
    zip: "41838",
    ST: "KY",
    cityWithStateAbbr: "Millstone, KY",
  },
  {
    zip: "41839",
    ST: "KY",
    cityWithStateAbbr: "Mousie, KY",
  },
  {
    zip: "41840",
    ST: "KY",
    cityWithStateAbbr: "Neon, KY",
  },
  {
    zip: "41843",
    ST: "KY",
    cityWithStateAbbr: "Pine Top, KY",
  },
  {
    zip: "41844",
    ST: "KY",
    cityWithStateAbbr: "Pippa Passes, KY",
  },
  {
    zip: "41845",
    ST: "KY",
    cityWithStateAbbr: "Premium, KY",
  },
  {
    zip: "41847",
    ST: "KY",
    cityWithStateAbbr: "Redfox, KY",
  },
  {
    zip: "41848",
    ST: "KY",
    cityWithStateAbbr: "Roxana, KY",
  },
  {
    zip: "41849",
    ST: "KY",
    cityWithStateAbbr: "Seco, KY",
  },
  {
    zip: "41855",
    ST: "KY",
    cityWithStateAbbr: "Thornton, KY",
  },
  {
    zip: "41858",
    ST: "KY",
    cityWithStateAbbr: "Whitesburg, KY",
  },
  {
    zip: "41859",
    ST: "KY",
    cityWithStateAbbr: "Dema, KY",
  },
  {
    zip: "41861",
    ST: "KY",
    cityWithStateAbbr: "Raven, KY",
  },
  {
    zip: "41862",
    ST: "KY",
    cityWithStateAbbr: "Topmost, KY",
  },
  {
    zip: "42001",
    ST: "KY",
    cityWithStateAbbr: "Paducah, KY",
  },
  {
    zip: "42002",
    ST: "KY",
    cityWithStateAbbr: "Paducah, KY",
  },
  {
    zip: "42003",
    ST: "KY",
    cityWithStateAbbr: "Paducah, KY",
  },
  {
    zip: "42020",
    ST: "KY",
    cityWithStateAbbr: "Almo, KY",
  },
  {
    zip: "42021",
    ST: "KY",
    cityWithStateAbbr: "Arlington, KY",
  },
  {
    zip: "42022",
    ST: "KY",
    cityWithStateAbbr: "Bandana, KY",
  },
  {
    zip: "42023",
    ST: "KY",
    cityWithStateAbbr: "Bardwell, KY",
  },
  {
    zip: "42024",
    ST: "KY",
    cityWithStateAbbr: "Barlow, KY",
  },
  {
    zip: "42025",
    ST: "KY",
    cityWithStateAbbr: "Benton, KY",
  },
  {
    zip: "42027",
    ST: "KY",
    cityWithStateAbbr: "Boaz, KY",
  },
  {
    zip: "42028",
    ST: "KY",
    cityWithStateAbbr: "Burna, KY",
  },
  {
    zip: "42029",
    ST: "KY",
    cityWithStateAbbr: "Calvert City, KY",
  },
  {
    zip: "42031",
    ST: "KY",
    cityWithStateAbbr: "Clinton, KY",
  },
  {
    zip: "42032",
    ST: "KY",
    cityWithStateAbbr: "Columbus, KY",
  },
  {
    zip: "42033",
    ST: "KY",
    cityWithStateAbbr: "Crayne, KY",
  },
  {
    zip: "42035",
    ST: "KY",
    cityWithStateAbbr: "Cunningham, KY",
  },
  {
    zip: "42036",
    ST: "KY",
    cityWithStateAbbr: "Dexter, KY",
  },
  {
    zip: "42037",
    ST: "KY",
    cityWithStateAbbr: "Dycusburg, KY",
  },
  {
    zip: "42038",
    ST: "KY",
    cityWithStateAbbr: "Eddyville, KY",
  },
  {
    zip: "42039",
    ST: "KY",
    cityWithStateAbbr: "Fancy Farm, KY",
  },
  {
    zip: "42040",
    ST: "KY",
    cityWithStateAbbr: "Farmington, KY",
  },
  {
    zip: "42041",
    ST: "KY",
    cityWithStateAbbr: "Fulton, KY",
  },
  {
    zip: "42044",
    ST: "KY",
    cityWithStateAbbr: "Gilbertsville, KY",
  },
  {
    zip: "42045",
    ST: "KY",
    cityWithStateAbbr: "Grand Rivers, KY",
  },
  {
    zip: "42047",
    ST: "KY",
    cityWithStateAbbr: "Hampton, KY",
  },
  {
    zip: "42048",
    ST: "KY",
    cityWithStateAbbr: "Hardin, KY",
  },
  {
    zip: "42049",
    ST: "KY",
    cityWithStateAbbr: "Hazel, KY",
  },
  {
    zip: "42050",
    ST: "KY",
    cityWithStateAbbr: "Hickman, KY",
  },
  {
    zip: "42051",
    ST: "KY",
    cityWithStateAbbr: "Hickory, KY",
  },
  {
    zip: "42053",
    ST: "KY",
    cityWithStateAbbr: "Kevil, KY",
  },
  {
    zip: "42054",
    ST: "KY",
    cityWithStateAbbr: "Kirksey, KY",
  },
  {
    zip: "42055",
    ST: "KY",
    cityWithStateAbbr: "Kuttawa, KY",
  },
  {
    zip: "42056",
    ST: "KY",
    cityWithStateAbbr: "La Center, KY",
  },
  {
    zip: "42058",
    ST: "KY",
    cityWithStateAbbr: "Ledbetter, KY",
  },
  {
    zip: "42060",
    ST: "KY",
    cityWithStateAbbr: "Lovelaceville, KY",
  },
  {
    zip: "42061",
    ST: "KY",
    cityWithStateAbbr: "Lowes, KY",
  },
  {
    zip: "42063",
    ST: "KY",
    cityWithStateAbbr: "Lynnville, KY",
  },
  {
    zip: "42064",
    ST: "KY",
    cityWithStateAbbr: "Marion, KY",
  },
  {
    zip: "42066",
    ST: "KY",
    cityWithStateAbbr: "Mayfield, KY",
  },
  {
    zip: "42069",
    ST: "KY",
    cityWithStateAbbr: "Melber, KY",
  },
  {
    zip: "42070",
    ST: "KY",
    cityWithStateAbbr: "Milburn, KY",
  },
  {
    zip: "42071",
    ST: "KY",
    cityWithStateAbbr: "Murray, KY",
  },
  {
    zip: "42076",
    ST: "KY",
    cityWithStateAbbr: "New Concord, KY",
  },
  {
    zip: "42078",
    ST: "KY",
    cityWithStateAbbr: "Salem, KY",
  },
  {
    zip: "42079",
    ST: "KY",
    cityWithStateAbbr: "Sedalia, KY",
  },
  {
    zip: "42081",
    ST: "KY",
    cityWithStateAbbr: "Smithland, KY",
  },
  {
    zip: "42082",
    ST: "KY",
    cityWithStateAbbr: "Symsonia, KY",
  },
  {
    zip: "42083",
    ST: "KY",
    cityWithStateAbbr: "Tiline, KY",
  },
  {
    zip: "42084",
    ST: "KY",
    cityWithStateAbbr: "Tolu, KY",
  },
  {
    zip: "42085",
    ST: "KY",
    cityWithStateAbbr: "Water Valley, KY",
  },
  {
    zip: "42086",
    ST: "KY",
    cityWithStateAbbr: "West Paducah, KY",
  },
  {
    zip: "42087",
    ST: "KY",
    cityWithStateAbbr: "Wickliffe, KY",
  },
  {
    zip: "42088",
    ST: "KY",
    cityWithStateAbbr: "Wingo, KY",
  },
  {
    zip: "42101",
    ST: "KY",
    cityWithStateAbbr: "Bowling Green, KY",
  },
  {
    zip: "42102",
    ST: "KY",
    cityWithStateAbbr: "Bowling Green, KY",
  },
  {
    zip: "42103",
    ST: "KY",
    cityWithStateAbbr: "Bowling Green, KY",
  },
  {
    zip: "42104",
    ST: "KY",
    cityWithStateAbbr: "Bowling Green, KY",
  },
  {
    zip: "42120",
    ST: "KY",
    cityWithStateAbbr: "Adolphus, KY",
  },
  {
    zip: "42122",
    ST: "KY",
    cityWithStateAbbr: "Alvaton, KY",
  },
  {
    zip: "42123",
    ST: "KY",
    cityWithStateAbbr: "Austin, KY",
  },
  {
    zip: "42124",
    ST: "KY",
    cityWithStateAbbr: "Beaumont, KY",
  },
  {
    zip: "42127",
    ST: "KY",
    cityWithStateAbbr: "Cave City, KY",
  },
  {
    zip: "42128",
    ST: "KY",
    cityWithStateAbbr: "Drake, KY",
  },
  {
    zip: "42129",
    ST: "KY",
    cityWithStateAbbr: "Edmonton, KY",
  },
  {
    zip: "42130",
    ST: "KY",
    cityWithStateAbbr: "Eighty Eight, KY",
  },
  {
    zip: "42131",
    ST: "KY",
    cityWithStateAbbr: "Etoile, KY",
  },
  {
    zip: "42133",
    ST: "KY",
    cityWithStateAbbr: "Fountain Run, KY",
  },
  {
    zip: "42134",
    ST: "KY",
    cityWithStateAbbr: "Franklin, KY",
  },
  {
    zip: "42135",
    ST: "KY",
    cityWithStateAbbr: "Franklin, KY",
  },
  {
    zip: "42140",
    ST: "KY",
    cityWithStateAbbr: "Gamaliel, KY",
  },
  {
    zip: "42141",
    ST: "KY",
    cityWithStateAbbr: "Glasgow, KY",
  },
  {
    zip: "42142",
    ST: "KY",
    cityWithStateAbbr: "Glasgow, KY",
  },
  {
    zip: "42151",
    ST: "KY",
    cityWithStateAbbr: "Hestand, KY",
  },
  {
    zip: "42152",
    ST: "KY",
    cityWithStateAbbr: "Hiseville, KY",
  },
  {
    zip: "42153",
    ST: "KY",
    cityWithStateAbbr: "Holland, KY",
  },
  {
    zip: "42154",
    ST: "KY",
    cityWithStateAbbr: "Knob Lick, KY",
  },
  {
    zip: "42156",
    ST: "KY",
    cityWithStateAbbr: "Lucas, KY",
  },
  {
    zip: "42157",
    ST: "KY",
    cityWithStateAbbr: "Mount Hermon, KY",
  },
  {
    zip: "42159",
    ST: "KY",
    cityWithStateAbbr: "Oakland, KY",
  },
  {
    zip: "42160",
    ST: "KY",
    cityWithStateAbbr: "Park City, KY",
  },
  {
    zip: "42163",
    ST: "KY",
    cityWithStateAbbr: "Rocky Hill, KY",
  },
  {
    zip: "42164",
    ST: "KY",
    cityWithStateAbbr: "Scottsville, KY",
  },
  {
    zip: "42166",
    ST: "KY",
    cityWithStateAbbr: "Summer Shade, KY",
  },
  {
    zip: "42167",
    ST: "KY",
    cityWithStateAbbr: "Tompkinsville, KY",
  },
  {
    zip: "42170",
    ST: "KY",
    cityWithStateAbbr: "Woodburn, KY",
  },
  {
    zip: "42171",
    ST: "KY",
    cityWithStateAbbr: "Smiths Grove, KY",
  },
  {
    zip: "42201",
    ST: "KY",
    cityWithStateAbbr: "Aberdeen, KY",
  },
  {
    zip: "42202",
    ST: "KY",
    cityWithStateAbbr: "Adairville, KY",
  },
  {
    zip: "42204",
    ST: "KY",
    cityWithStateAbbr: "Allensville, KY",
  },
  {
    zip: "42206",
    ST: "KY",
    cityWithStateAbbr: "Auburn, KY",
  },
  {
    zip: "42207",
    ST: "KY",
    cityWithStateAbbr: "Bee Spring, KY",
  },
  {
    zip: "42210",
    ST: "KY",
    cityWithStateAbbr: "Brownsville, KY",
  },
  {
    zip: "42211",
    ST: "KY",
    cityWithStateAbbr: "Cadiz, KY",
  },
  {
    zip: "42214",
    ST: "KY",
    cityWithStateAbbr: "Center, KY",
  },
  {
    zip: "42215",
    ST: "KY",
    cityWithStateAbbr: "Cerulean, KY",
  },
  {
    zip: "42216",
    ST: "KY",
    cityWithStateAbbr: "Clifty, KY",
  },
  {
    zip: "42217",
    ST: "KY",
    cityWithStateAbbr: "Crofton, KY",
  },
  {
    zip: "42219",
    ST: "KY",
    cityWithStateAbbr: "Dunbar, KY",
  },
  {
    zip: "42220",
    ST: "KY",
    cityWithStateAbbr: "Elkton, KY",
  },
  {
    zip: "42221",
    ST: "KY",
    cityWithStateAbbr: "Fairview, KY",
  },
  {
    zip: "42223",
    ST: "TN",
    cityWithStateAbbr: "Fort Campbell, TN",
  },
  {
    zip: "42232",
    ST: "KY",
    cityWithStateAbbr: "Gracey, KY",
  },
  {
    zip: "42234",
    ST: "KY",
    cityWithStateAbbr: "Guthrie, KY",
  },
  {
    zip: "42236",
    ST: "KY",
    cityWithStateAbbr: "Herndon, KY",
  },
  {
    zip: "42240",
    ST: "KY",
    cityWithStateAbbr: "Hopkinsville, KY",
  },
  {
    zip: "42241",
    ST: "KY",
    cityWithStateAbbr: "Hopkinsville, KY",
  },
  {
    zip: "42252",
    ST: "KY",
    cityWithStateAbbr: "Jetson, KY",
  },
  {
    zip: "42254",
    ST: "KY",
    cityWithStateAbbr: "La Fayette, KY",
  },
  {
    zip: "42256",
    ST: "KY",
    cityWithStateAbbr: "Lewisburg, KY",
  },
  {
    zip: "42259",
    ST: "KY",
    cityWithStateAbbr: "Mammoth Cave, KY",
  },
  {
    zip: "42261",
    ST: "KY",
    cityWithStateAbbr: "Morgantown, KY",
  },
  {
    zip: "42262",
    ST: "KY",
    cityWithStateAbbr: "Oak Grove, KY",
  },
  {
    zip: "42265",
    ST: "KY",
    cityWithStateAbbr: "Olmstead, KY",
  },
  {
    zip: "42266",
    ST: "KY",
    cityWithStateAbbr: "Pembroke, KY",
  },
  {
    zip: "42273",
    ST: "KY",
    cityWithStateAbbr: "Rochester, KY",
  },
  {
    zip: "42274",
    ST: "KY",
    cityWithStateAbbr: "Rockfield, KY",
  },
  {
    zip: "42275",
    ST: "KY",
    cityWithStateAbbr: "Roundhill, KY",
  },
  {
    zip: "42276",
    ST: "KY",
    cityWithStateAbbr: "Russellville, KY",
  },
  {
    zip: "42280",
    ST: "KY",
    cityWithStateAbbr: "Sharon Grove, KY",
  },
  {
    zip: "42285",
    ST: "KY",
    cityWithStateAbbr: "Sweeden, KY",
  },
  {
    zip: "42286",
    ST: "KY",
    cityWithStateAbbr: "Trenton, KY",
  },
  {
    zip: "42288",
    ST: "KY",
    cityWithStateAbbr: "Woodbury, KY",
  },
  {
    zip: "42301",
    ST: "KY",
    cityWithStateAbbr: "Owensboro, KY",
  },
  {
    zip: "42302",
    ST: "KY",
    cityWithStateAbbr: "Owensboro, KY",
  },
  {
    zip: "42303",
    ST: "KY",
    cityWithStateAbbr: "Owensboro, KY",
  },
  {
    zip: "42304",
    ST: "KY",
    cityWithStateAbbr: "Owensboro, KY",
  },
  {
    zip: "42320",
    ST: "KY",
    cityWithStateAbbr: "Beaver Dam, KY",
  },
  {
    zip: "42321",
    ST: "KY",
    cityWithStateAbbr: "Beech Creek, KY",
  },
  {
    zip: "42322",
    ST: "KY",
    cityWithStateAbbr: "Beech Grove, KY",
  },
  {
    zip: "42323",
    ST: "KY",
    cityWithStateAbbr: "Beechmont, KY",
  },
  {
    zip: "42324",
    ST: "KY",
    cityWithStateAbbr: "Belton, KY",
  },
  {
    zip: "42325",
    ST: "KY",
    cityWithStateAbbr: "Bremen, KY",
  },
  {
    zip: "42326",
    ST: "KY",
    cityWithStateAbbr: "Browder, KY",
  },
  {
    zip: "42327",
    ST: "KY",
    cityWithStateAbbr: "Calhoun, KY",
  },
  {
    zip: "42328",
    ST: "KY",
    cityWithStateAbbr: "Centertown, KY",
  },
  {
    zip: "42330",
    ST: "KY",
    cityWithStateAbbr: "Central City, KY",
  },
  {
    zip: "42332",
    ST: "KY",
    cityWithStateAbbr: "Cleaton, KY",
  },
  {
    zip: "42333",
    ST: "KY",
    cityWithStateAbbr: "Cromwell, KY",
  },
  {
    zip: "42334",
    ST: "KY",
    cityWithStateAbbr: "Curdsville, KY",
  },
  {
    zip: "42337",
    ST: "KY",
    cityWithStateAbbr: "Drakesboro, KY",
  },
  {
    zip: "42338",
    ST: "KY",
    cityWithStateAbbr: "Dundee, KY",
  },
  {
    zip: "42339",
    ST: "KY",
    cityWithStateAbbr: "Dunmor, KY",
  },
  {
    zip: "42343",
    ST: "KY",
    cityWithStateAbbr: "Fordsville, KY",
  },
  {
    zip: "42344",
    ST: "KY",
    cityWithStateAbbr: "Graham, KY",
  },
  {
    zip: "42345",
    ST: "KY",
    cityWithStateAbbr: "Greenville, KY",
  },
  {
    zip: "42347",
    ST: "KY",
    cityWithStateAbbr: "Hartford, KY",
  },
  {
    zip: "42348",
    ST: "KY",
    cityWithStateAbbr: "Hawesville, KY",
  },
  {
    zip: "42349",
    ST: "KY",
    cityWithStateAbbr: "Horse Branch, KY",
  },
  {
    zip: "42350",
    ST: "KY",
    cityWithStateAbbr: "Island, KY",
  },
  {
    zip: "42351",
    ST: "KY",
    cityWithStateAbbr: "Lewisport, KY",
  },
  {
    zip: "42352",
    ST: "KY",
    cityWithStateAbbr: "Livermore, KY",
  },
  {
    zip: "42354",
    ST: "KY",
    cityWithStateAbbr: "Mc Henry, KY",
  },
  {
    zip: "42355",
    ST: "KY",
    cityWithStateAbbr: "Maceo, KY",
  },
  {
    zip: "42356",
    ST: "KY",
    cityWithStateAbbr: "Maple Mount, KY",
  },
  {
    zip: "42361",
    ST: "KY",
    cityWithStateAbbr: "Olaton, KY",
  },
  {
    zip: "42364",
    ST: "KY",
    cityWithStateAbbr: "Hawesville, KY",
  },
  {
    zip: "42366",
    ST: "KY",
    cityWithStateAbbr: "Philpot, KY",
  },
  {
    zip: "42367",
    ST: "KY",
    cityWithStateAbbr: "Powderly, KY",
  },
  {
    zip: "42368",
    ST: "KY",
    cityWithStateAbbr: "Reynolds Station, KY",
  },
  {
    zip: "42369",
    ST: "KY",
    cityWithStateAbbr: "Rockport, KY",
  },
  {
    zip: "42370",
    ST: "KY",
    cityWithStateAbbr: "Rosine, KY",
  },
  {
    zip: "42371",
    ST: "KY",
    cityWithStateAbbr: "Rumsey, KY",
  },
  {
    zip: "42372",
    ST: "KY",
    cityWithStateAbbr: "Sacramento, KY",
  },
  {
    zip: "42374",
    ST: "KY",
    cityWithStateAbbr: "South Carrollton, KY",
  },
  {
    zip: "42375",
    ST: "KY",
    cityWithStateAbbr: "Owensboro, KY",
  },
  {
    zip: "42376",
    ST: "KY",
    cityWithStateAbbr: "Utica, KY",
  },
  {
    zip: "42377",
    ST: "KY",
    cityWithStateAbbr: "West Louisville, KY",
  },
  {
    zip: "42378",
    ST: "KY",
    cityWithStateAbbr: "Whitesville, KY",
  },
  {
    zip: "42402",
    ST: "KY",
    cityWithStateAbbr: "Baskett, KY",
  },
  {
    zip: "42404",
    ST: "KY",
    cityWithStateAbbr: "Clay, KY",
  },
  {
    zip: "42406",
    ST: "KY",
    cityWithStateAbbr: "Corydon, KY",
  },
  {
    zip: "42408",
    ST: "KY",
    cityWithStateAbbr: "Dawson Springs, KY",
  },
  {
    zip: "42409",
    ST: "KY",
    cityWithStateAbbr: "Dixon, KY",
  },
  {
    zip: "42410",
    ST: "KY",
    cityWithStateAbbr: "Earlington, KY",
  },
  {
    zip: "42411",
    ST: "KY",
    cityWithStateAbbr: "Fredonia, KY",
  },
  {
    zip: "42413",
    ST: "KY",
    cityWithStateAbbr: "Hanson, KY",
  },
  {
    zip: "42419",
    ST: "KY",
    cityWithStateAbbr: "Henderson, KY",
  },
  {
    zip: "42420",
    ST: "KY",
    cityWithStateAbbr: "Henderson, KY",
  },
  {
    zip: "42431",
    ST: "KY",
    cityWithStateAbbr: "Madisonville, KY",
  },
  {
    zip: "42436",
    ST: "KY",
    cityWithStateAbbr: "Manitou, KY",
  },
  {
    zip: "42437",
    ST: "KY",
    cityWithStateAbbr: "Morganfield, KY",
  },
  {
    zip: "42440",
    ST: "KY",
    cityWithStateAbbr: "Mortons Gap, KY",
  },
  {
    zip: "42441",
    ST: "KY",
    cityWithStateAbbr: "Nebo, KY",
  },
  {
    zip: "42442",
    ST: "KY",
    cityWithStateAbbr: "Nortonville, KY",
  },
  {
    zip: "42444",
    ST: "KY",
    cityWithStateAbbr: "Poole, KY",
  },
  {
    zip: "42445",
    ST: "KY",
    cityWithStateAbbr: "Princeton, KY",
  },
  {
    zip: "42450",
    ST: "KY",
    cityWithStateAbbr: "Providence, KY",
  },
  {
    zip: "42451",
    ST: "KY",
    cityWithStateAbbr: "Reed, KY",
  },
  {
    zip: "42452",
    ST: "KY",
    cityWithStateAbbr: "Robards, KY",
  },
  {
    zip: "42453",
    ST: "KY",
    cityWithStateAbbr: "Saint Charles, KY",
  },
  {
    zip: "42455",
    ST: "KY",
    cityWithStateAbbr: "Sebree, KY",
  },
  {
    zip: "42456",
    ST: "KY",
    cityWithStateAbbr: "Slaughters, KY",
  },
  {
    zip: "42457",
    ST: "KY",
    cityWithStateAbbr: "Smith Mills, KY",
  },
  {
    zip: "42458",
    ST: "KY",
    cityWithStateAbbr: "Spottsville, KY",
  },
  {
    zip: "42459",
    ST: "KY",
    cityWithStateAbbr: "Sturgis, KY",
  },
  {
    zip: "42460",
    ST: "KY",
    cityWithStateAbbr: "Sullivan, KY",
  },
  {
    zip: "42461",
    ST: "KY",
    cityWithStateAbbr: "Uniontown, KY",
  },
  {
    zip: "42462",
    ST: "KY",
    cityWithStateAbbr: "Waverly, KY",
  },
  {
    zip: "42463",
    ST: "KY",
    cityWithStateAbbr: "Wheatcroft, KY",
  },
  {
    zip: "42464",
    ST: "KY",
    cityWithStateAbbr: "White Plains, KY",
  },
  {
    zip: "42501",
    ST: "KY",
    cityWithStateAbbr: "Somerset, KY",
  },
  {
    zip: "42502",
    ST: "KY",
    cityWithStateAbbr: "Somerset, KY",
  },
  {
    zip: "42503",
    ST: "KY",
    cityWithStateAbbr: "Somerset, KY",
  },
  {
    zip: "42516",
    ST: "KY",
    cityWithStateAbbr: "Bethelridge, KY",
  },
  {
    zip: "42518",
    ST: "KY",
    cityWithStateAbbr: "Bronston, KY",
  },
  {
    zip: "42519",
    ST: "KY",
    cityWithStateAbbr: "Burnside, KY",
  },
  {
    zip: "42528",
    ST: "KY",
    cityWithStateAbbr: "Dunnville, KY",
  },
  {
    zip: "42533",
    ST: "KY",
    cityWithStateAbbr: "Ferguson, KY",
  },
  {
    zip: "42539",
    ST: "KY",
    cityWithStateAbbr: "Liberty, KY",
  },
  {
    zip: "42541",
    ST: "KY",
    cityWithStateAbbr: "Middleburg, KY",
  },
  {
    zip: "42544",
    ST: "KY",
    cityWithStateAbbr: "Nancy, KY",
  },
  {
    zip: "42553",
    ST: "KY",
    cityWithStateAbbr: "Science Hill, KY",
  },
  {
    zip: "42558",
    ST: "KY",
    cityWithStateAbbr: "Tateville, KY",
  },
  {
    zip: "42564",
    ST: "KY",
    cityWithStateAbbr: "West Somerset, KY",
  },
  {
    zip: "42565",
    ST: "KY",
    cityWithStateAbbr: "Windsor, KY",
  },
  {
    zip: "42566",
    ST: "KY",
    cityWithStateAbbr: "Yosemite, KY",
  },
  {
    zip: "42567",
    ST: "KY",
    cityWithStateAbbr: "Eubank, KY",
  },
  {
    zip: "42602",
    ST: "KY",
    cityWithStateAbbr: "Albany, KY",
  },
  {
    zip: "42603",
    ST: "KY",
    cityWithStateAbbr: "Alpha, KY",
  },
  {
    zip: "42629",
    ST: "KY",
    cityWithStateAbbr: "Jamestown, KY",
  },
  {
    zip: "42631",
    ST: "KY",
    cityWithStateAbbr: "Marshes Siding, KY",
  },
  {
    zip: "42633",
    ST: "KY",
    cityWithStateAbbr: "Monticello, KY",
  },
  {
    zip: "42634",
    ST: "KY",
    cityWithStateAbbr: "Parkers Lake, KY",
  },
  {
    zip: "42635",
    ST: "KY",
    cityWithStateAbbr: "Pine Knot, KY",
  },
  {
    zip: "42638",
    ST: "KY",
    cityWithStateAbbr: "Revelo, KY",
  },
  {
    zip: "42642",
    ST: "KY",
    cityWithStateAbbr: "Russell Springs, KY",
  },
  {
    zip: "42647",
    ST: "KY",
    cityWithStateAbbr: "Stearns, KY",
  },
  {
    zip: "42649",
    ST: "KY",
    cityWithStateAbbr: "Strunk, KY",
  },
  {
    zip: "42653",
    ST: "KY",
    cityWithStateAbbr: "Whitley City, KY",
  },
  {
    zip: "42701",
    ST: "KY",
    cityWithStateAbbr: "Elizabethtown, KY",
  },
  {
    zip: "42702",
    ST: "KY",
    cityWithStateAbbr: "Elizabethtown, KY",
  },
  {
    zip: "42712",
    ST: "KY",
    cityWithStateAbbr: "Big Clifty, KY",
  },
  {
    zip: "42713",
    ST: "KY",
    cityWithStateAbbr: "Bonnieville, KY",
  },
  {
    zip: "42715",
    ST: "KY",
    cityWithStateAbbr: "Breeding, KY",
  },
  {
    zip: "42716",
    ST: "KY",
    cityWithStateAbbr: "Buffalo, KY",
  },
  {
    zip: "42717",
    ST: "KY",
    cityWithStateAbbr: "Burkesville, KY",
  },
  {
    zip: "42718",
    ST: "KY",
    cityWithStateAbbr: "Campbellsville, KY",
  },
  {
    zip: "42719",
    ST: "KY",
    cityWithStateAbbr: "Campbellsville, KY",
  },
  {
    zip: "42720",
    ST: "KY",
    cityWithStateAbbr: "Cane Valley, KY",
  },
  {
    zip: "42721",
    ST: "KY",
    cityWithStateAbbr: "Caneyville, KY",
  },
  {
    zip: "42722",
    ST: "KY",
    cityWithStateAbbr: "Canmer, KY",
  },
  {
    zip: "42724",
    ST: "KY",
    cityWithStateAbbr: "Cecilia, KY",
  },
  {
    zip: "42726",
    ST: "KY",
    cityWithStateAbbr: "Clarkson, KY",
  },
  {
    zip: "42728",
    ST: "KY",
    cityWithStateAbbr: "Columbia, KY",
  },
  {
    zip: "42729",
    ST: "KY",
    cityWithStateAbbr: "Cub Run, KY",
  },
  {
    zip: "42731",
    ST: "KY",
    cityWithStateAbbr: "Dubre, KY",
  },
  {
    zip: "42732",
    ST: "KY",
    cityWithStateAbbr: "Eastview, KY",
  },
  {
    zip: "42733",
    ST: "KY",
    cityWithStateAbbr: "Elk Horn, KY",
  },
  {
    zip: "42740",
    ST: "KY",
    cityWithStateAbbr: "Glendale, KY",
  },
  {
    zip: "42741",
    ST: "KY",
    cityWithStateAbbr: "Glens Fork, KY",
  },
  {
    zip: "42742",
    ST: "KY",
    cityWithStateAbbr: "Gradyville, KY",
  },
  {
    zip: "42743",
    ST: "KY",
    cityWithStateAbbr: "Greensburg, KY",
  },
  {
    zip: "42746",
    ST: "KY",
    cityWithStateAbbr: "Hardyville, KY",
  },
  {
    zip: "42748",
    ST: "KY",
    cityWithStateAbbr: "Hodgenville, KY",
  },
  {
    zip: "42749",
    ST: "KY",
    cityWithStateAbbr: "Horse Cave, KY",
  },
  {
    zip: "42753",
    ST: "KY",
    cityWithStateAbbr: "Knifley, KY",
  },
  {
    zip: "42754",
    ST: "KY",
    cityWithStateAbbr: "Leitchfield, KY",
  },
  {
    zip: "42755",
    ST: "KY",
    cityWithStateAbbr: "Leitchfield, KY",
  },
  {
    zip: "42757",
    ST: "KY",
    cityWithStateAbbr: "Magnolia, KY",
  },
  {
    zip: "42758",
    ST: "KY",
    cityWithStateAbbr: "Mannsville, KY",
  },
  {
    zip: "42759",
    ST: "KY",
    cityWithStateAbbr: "Marrowbone, KY",
  },
  {
    zip: "42762",
    ST: "KY",
    cityWithStateAbbr: "Millwood, KY",
  },
  {
    zip: "42764",
    ST: "KY",
    cityWithStateAbbr: "Mount Sherman, KY",
  },
  {
    zip: "42765",
    ST: "KY",
    cityWithStateAbbr: "Munfordville, KY",
  },
  {
    zip: "42776",
    ST: "KY",
    cityWithStateAbbr: "Sonora, KY",
  },
  {
    zip: "42782",
    ST: "KY",
    cityWithStateAbbr: "Summersville, KY",
  },
  {
    zip: "42784",
    ST: "KY",
    cityWithStateAbbr: "Upton, KY",
  },
  {
    zip: "42788",
    ST: "KY",
    cityWithStateAbbr: "White Mills, KY",
  },
  {
    zip: "43001",
    ST: "OH",
    cityWithStateAbbr: "Alexandria, OH",
  },
  {
    zip: "43002",
    ST: "OH",
    cityWithStateAbbr: "Amlin, OH",
  },
  {
    zip: "43003",
    ST: "OH",
    cityWithStateAbbr: "Ashley, OH",
  },
  {
    zip: "43004",
    ST: "OH",
    cityWithStateAbbr: "Blacklick, OH",
  },
  {
    zip: "43005",
    ST: "OH",
    cityWithStateAbbr: "Bladensburg, OH",
  },
  {
    zip: "43006",
    ST: "OH",
    cityWithStateAbbr: "Brinkhaven, OH",
  },
  {
    zip: "43007",
    ST: "OH",
    cityWithStateAbbr: "Broadway, OH",
  },
  {
    zip: "43008",
    ST: "OH",
    cityWithStateAbbr: "Buckeye Lake, OH",
  },
  {
    zip: "43009",
    ST: "OH",
    cityWithStateAbbr: "Cable, OH",
  },
  {
    zip: "43010",
    ST: "OH",
    cityWithStateAbbr: "Catawba, OH",
  },
  {
    zip: "43011",
    ST: "OH",
    cityWithStateAbbr: "Centerburg, OH",
  },
  {
    zip: "43013",
    ST: "OH",
    cityWithStateAbbr: "Croton, OH",
  },
  {
    zip: "43014",
    ST: "OH",
    cityWithStateAbbr: "Danville, OH",
  },
  {
    zip: "43015",
    ST: "OH",
    cityWithStateAbbr: "Delaware, OH",
  },
  {
    zip: "43016",
    ST: "OH",
    cityWithStateAbbr: "Dublin, OH",
  },
  {
    zip: "43017",
    ST: "OH",
    cityWithStateAbbr: "Dublin, OH",
  },
  {
    zip: "43018",
    ST: "OH",
    cityWithStateAbbr: "Etna, OH",
  },
  {
    zip: "43019",
    ST: "OH",
    cityWithStateAbbr: "Fredericktown, OH",
  },
  {
    zip: "43021",
    ST: "OH",
    cityWithStateAbbr: "Galena, OH",
  },
  {
    zip: "43022",
    ST: "OH",
    cityWithStateAbbr: "Gambier, OH",
  },
  {
    zip: "43023",
    ST: "OH",
    cityWithStateAbbr: "Granville, OH",
  },
  {
    zip: "43025",
    ST: "OH",
    cityWithStateAbbr: "Hebron, OH",
  },
  {
    zip: "43026",
    ST: "OH",
    cityWithStateAbbr: "Hilliard, OH",
  },
  {
    zip: "43027",
    ST: "OH",
    cityWithStateAbbr: "Homer, OH",
  },
  {
    zip: "43028",
    ST: "OH",
    cityWithStateAbbr: "Howard, OH",
  },
  {
    zip: "43029",
    ST: "OH",
    cityWithStateAbbr: "Irwin, OH",
  },
  {
    zip: "43030",
    ST: "OH",
    cityWithStateAbbr: "Jacksontown, OH",
  },
  {
    zip: "43031",
    ST: "OH",
    cityWithStateAbbr: "Johnstown, OH",
  },
  {
    zip: "43032",
    ST: "OH",
    cityWithStateAbbr: "Kilbourne, OH",
  },
  {
    zip: "43033",
    ST: "OH",
    cityWithStateAbbr: "Kirkersville, OH",
  },
  {
    zip: "43035",
    ST: "OH",
    cityWithStateAbbr: "Lewis Center, OH",
  },
  {
    zip: "43036",
    ST: "OH",
    cityWithStateAbbr: "Magnetic Springs, OH",
  },
  {
    zip: "43037",
    ST: "OH",
    cityWithStateAbbr: "Martinsburg, OH",
  },
  {
    zip: "43040",
    ST: "OH",
    cityWithStateAbbr: "Marysville, OH",
  },
  {
    zip: "43041",
    ST: "OH",
    cityWithStateAbbr: "Marysville, OH",
  },
  {
    zip: "43044",
    ST: "OH",
    cityWithStateAbbr: "Mechanicsburg, OH",
  },
  {
    zip: "43045",
    ST: "OH",
    cityWithStateAbbr: "Milford Center, OH",
  },
  {
    zip: "43046",
    ST: "OH",
    cityWithStateAbbr: "Millersport, OH",
  },
  {
    zip: "43047",
    ST: "OH",
    cityWithStateAbbr: "Mingo, OH",
  },
  {
    zip: "43048",
    ST: "OH",
    cityWithStateAbbr: "Mount Liberty, OH",
  },
  {
    zip: "43050",
    ST: "OH",
    cityWithStateAbbr: "Mount Vernon, OH",
  },
  {
    zip: "43054",
    ST: "OH",
    cityWithStateAbbr: "New Albany, OH",
  },
  {
    zip: "43055",
    ST: "OH",
    cityWithStateAbbr: "Newark, OH",
  },
  {
    zip: "43056",
    ST: "OH",
    cityWithStateAbbr: "Heath, OH",
  },
  {
    zip: "43058",
    ST: "OH",
    cityWithStateAbbr: "Newark, OH",
  },
  {
    zip: "43060",
    ST: "OH",
    cityWithStateAbbr: "North Lewisburg, OH",
  },
  {
    zip: "43061",
    ST: "OH",
    cityWithStateAbbr: "Ostrander, OH",
  },
  {
    zip: "43062",
    ST: "OH",
    cityWithStateAbbr: "Pataskala, OH",
  },
  {
    zip: "43064",
    ST: "OH",
    cityWithStateAbbr: "Plain City, OH",
  },
  {
    zip: "43065",
    ST: "OH",
    cityWithStateAbbr: "Powell, OH",
  },
  {
    zip: "43066",
    ST: "OH",
    cityWithStateAbbr: "Radnor, OH",
  },
  {
    zip: "43067",
    ST: "OH",
    cityWithStateAbbr: "Raymond, OH",
  },
  {
    zip: "43068",
    ST: "OH",
    cityWithStateAbbr: "Reynoldsburg, OH",
  },
  {
    zip: "43069",
    ST: "OH",
    cityWithStateAbbr: "Reynoldsburg, OH",
  },
  {
    zip: "43070",
    ST: "OH",
    cityWithStateAbbr: "Rosewood, OH",
  },
  {
    zip: "43071",
    ST: "OH",
    cityWithStateAbbr: "Saint Louisville, OH",
  },
  {
    zip: "43072",
    ST: "OH",
    cityWithStateAbbr: "Saint Paris, OH",
  },
  {
    zip: "43073",
    ST: "OH",
    cityWithStateAbbr: "Summit Station, OH",
  },
  {
    zip: "43074",
    ST: "OH",
    cityWithStateAbbr: "Sunbury, OH",
  },
  {
    zip: "43076",
    ST: "OH",
    cityWithStateAbbr: "Thornville, OH",
  },
  {
    zip: "43077",
    ST: "OH",
    cityWithStateAbbr: "Unionville Center, OH",
  },
  {
    zip: "43078",
    ST: "OH",
    cityWithStateAbbr: "Urbana, OH",
  },
  {
    zip: "43080",
    ST: "OH",
    cityWithStateAbbr: "Utica, OH",
  },
  {
    zip: "43081",
    ST: "OH",
    cityWithStateAbbr: "Westerville, OH",
  },
  {
    zip: "43082",
    ST: "OH",
    cityWithStateAbbr: "Westerville, OH",
  },
  {
    zip: "43083",
    ST: "OH",
    cityWithStateAbbr: "Westville, OH",
  },
  {
    zip: "43084",
    ST: "OH",
    cityWithStateAbbr: "Woodstock, OH",
  },
  {
    zip: "43085",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43086",
    ST: "OH",
    cityWithStateAbbr: "Westerville, OH",
  },
  {
    zip: "43093",
    ST: "OH",
    cityWithStateAbbr: "Newark, OH",
  },
  {
    zip: "43101",
    ST: "OH",
    cityWithStateAbbr: "Adelphi, OH",
  },
  {
    zip: "43102",
    ST: "OH",
    cityWithStateAbbr: "Amanda, OH",
  },
  {
    zip: "43103",
    ST: "OH",
    cityWithStateAbbr: "Ashville, OH",
  },
  {
    zip: "43105",
    ST: "OH",
    cityWithStateAbbr: "Baltimore, OH",
  },
  {
    zip: "43106",
    ST: "OH",
    cityWithStateAbbr: "Bloomingburg, OH",
  },
  {
    zip: "43107",
    ST: "OH",
    cityWithStateAbbr: "Bremen, OH",
  },
  {
    zip: "43109",
    ST: "OH",
    cityWithStateAbbr: "Brice, OH",
  },
  {
    zip: "43110",
    ST: "OH",
    cityWithStateAbbr: "Canal Winchester, OH",
  },
  {
    zip: "43111",
    ST: "OH",
    cityWithStateAbbr: "Carbon Hill, OH",
  },
  {
    zip: "43112",
    ST: "OH",
    cityWithStateAbbr: "Carroll, OH",
  },
  {
    zip: "43113",
    ST: "OH",
    cityWithStateAbbr: "Circleville, OH",
  },
  {
    zip: "43115",
    ST: "OH",
    cityWithStateAbbr: "Clarksburg, OH",
  },
  {
    zip: "43116",
    ST: "OH",
    cityWithStateAbbr: "Commercial Point, OH",
  },
  {
    zip: "43117",
    ST: "OH",
    cityWithStateAbbr: "Derby, OH",
  },
  {
    zip: "43119",
    ST: "OH",
    cityWithStateAbbr: "Galloway, OH",
  },
  {
    zip: "43123",
    ST: "OH",
    cityWithStateAbbr: "Grove City, OH",
  },
  {
    zip: "43125",
    ST: "OH",
    cityWithStateAbbr: "Groveport, OH",
  },
  {
    zip: "43126",
    ST: "OH",
    cityWithStateAbbr: "Harrisburg, OH",
  },
  {
    zip: "43127",
    ST: "OH",
    cityWithStateAbbr: "Haydenville, OH",
  },
  {
    zip: "43128",
    ST: "OH",
    cityWithStateAbbr: "Jeffersonville, OH",
  },
  {
    zip: "43130",
    ST: "OH",
    cityWithStateAbbr: "Lancaster, OH",
  },
  {
    zip: "43135",
    ST: "OH",
    cityWithStateAbbr: "Laurelville, OH",
  },
  {
    zip: "43136",
    ST: "OH",
    cityWithStateAbbr: "Lithopolis, OH",
  },
  {
    zip: "43137",
    ST: "OH",
    cityWithStateAbbr: "Lockbourne, OH",
  },
  {
    zip: "43138",
    ST: "OH",
    cityWithStateAbbr: "Logan, OH",
  },
  {
    zip: "43140",
    ST: "OH",
    cityWithStateAbbr: "London, OH",
  },
  {
    zip: "43142",
    ST: "OH",
    cityWithStateAbbr: "Milledgeville, OH",
  },
  {
    zip: "43143",
    ST: "OH",
    cityWithStateAbbr: "Mount Sterling, OH",
  },
  {
    zip: "43144",
    ST: "OH",
    cityWithStateAbbr: "Murray City, OH",
  },
  {
    zip: "43145",
    ST: "OH",
    cityWithStateAbbr: "New Holland, OH",
  },
  {
    zip: "43146",
    ST: "OH",
    cityWithStateAbbr: "Orient, OH",
  },
  {
    zip: "43147",
    ST: "OH",
    cityWithStateAbbr: "Pickerington, OH",
  },
  {
    zip: "43148",
    ST: "OH",
    cityWithStateAbbr: "Pleasantville, OH",
  },
  {
    zip: "43149",
    ST: "OH",
    cityWithStateAbbr: "Rockbridge, OH",
  },
  {
    zip: "43150",
    ST: "OH",
    cityWithStateAbbr: "Rushville, OH",
  },
  {
    zip: "43151",
    ST: "OH",
    cityWithStateAbbr: "Sedalia, OH",
  },
  {
    zip: "43152",
    ST: "OH",
    cityWithStateAbbr: "South Bloomingville, OH",
  },
  {
    zip: "43153",
    ST: "OH",
    cityWithStateAbbr: "South Solon, OH",
  },
  {
    zip: "43154",
    ST: "OH",
    cityWithStateAbbr: "Stoutsville, OH",
  },
  {
    zip: "43155",
    ST: "OH",
    cityWithStateAbbr: "Sugar Grove, OH",
  },
  {
    zip: "43156",
    ST: "OH",
    cityWithStateAbbr: "Tarlton, OH",
  },
  {
    zip: "43157",
    ST: "OH",
    cityWithStateAbbr: "Thurston, OH",
  },
  {
    zip: "43158",
    ST: "OH",
    cityWithStateAbbr: "Union Furnace, OH",
  },
  {
    zip: "43160",
    ST: "OH",
    cityWithStateAbbr: "Washington Court House, OH",
  },
  {
    zip: "43162",
    ST: "OH",
    cityWithStateAbbr: "West Jefferson, OH",
  },
  {
    zip: "43163",
    ST: "OH",
    cityWithStateAbbr: "Lancaster, OH",
  },
  {
    zip: "43164",
    ST: "OH",
    cityWithStateAbbr: "Williamsport, OH",
  },
  {
    zip: "43194",
    ST: "OH",
    cityWithStateAbbr: "Lockbourne, OH",
  },
  {
    zip: "43195",
    ST: "OH",
    cityWithStateAbbr: "Groveport, OH",
  },
  {
    zip: "43199",
    ST: "OH",
    cityWithStateAbbr: "Groveport, OH",
  },
  {
    zip: "43201",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43202",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43203",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43204",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43205",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43206",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43207",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43209",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43210",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43211",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43212",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43213",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43214",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43215",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43216",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43217",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43218",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43219",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43220",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43221",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43222",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43223",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43224",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43226",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43227",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43228",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43229",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43230",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43231",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43232",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43234",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43235",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43236",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43240",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43251",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43260",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43266",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43268",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43270",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43271",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43272",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43279",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43287",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43291",
    ST: "OH",
    cityWithStateAbbr: "Columbus, OH",
  },
  {
    zip: "43301",
    ST: "OH",
    cityWithStateAbbr: "Marion, OH",
  },
  {
    zip: "43302",
    ST: "OH",
    cityWithStateAbbr: "Marion, OH",
  },
  {
    zip: "43306",
    ST: "OH",
    cityWithStateAbbr: "Marion, OH",
  },
  {
    zip: "43310",
    ST: "OH",
    cityWithStateAbbr: "Belle Center, OH",
  },
  {
    zip: "43311",
    ST: "OH",
    cityWithStateAbbr: "Bellefontaine, OH",
  },
  {
    zip: "43314",
    ST: "OH",
    cityWithStateAbbr: "Caledonia, OH",
  },
  {
    zip: "43315",
    ST: "OH",
    cityWithStateAbbr: "Cardington, OH",
  },
  {
    zip: "43316",
    ST: "OH",
    cityWithStateAbbr: "Carey, OH",
  },
  {
    zip: "43317",
    ST: "OH",
    cityWithStateAbbr: "Chesterville, OH",
  },
  {
    zip: "43318",
    ST: "OH",
    cityWithStateAbbr: "De Graff, OH",
  },
  {
    zip: "43319",
    ST: "OH",
    cityWithStateAbbr: "East Liberty, OH",
  },
  {
    zip: "43320",
    ST: "OH",
    cityWithStateAbbr: "Edison, OH",
  },
  {
    zip: "43321",
    ST: "OH",
    cityWithStateAbbr: "Fulton, OH",
  },
  {
    zip: "43322",
    ST: "OH",
    cityWithStateAbbr: "Green Camp, OH",
  },
  {
    zip: "43323",
    ST: "OH",
    cityWithStateAbbr: "Harpster, OH",
  },
  {
    zip: "43324",
    ST: "OH",
    cityWithStateAbbr: "Huntsville, OH",
  },
  {
    zip: "43325",
    ST: "OH",
    cityWithStateAbbr: "Iberia, OH",
  },
  {
    zip: "43326",
    ST: "OH",
    cityWithStateAbbr: "Kenton, OH",
  },
  {
    zip: "43330",
    ST: "OH",
    cityWithStateAbbr: "Kirby, OH",
  },
  {
    zip: "43331",
    ST: "OH",
    cityWithStateAbbr: "Lakeview, OH",
  },
  {
    zip: "43332",
    ST: "OH",
    cityWithStateAbbr: "La Rue, OH",
  },
  {
    zip: "43333",
    ST: "OH",
    cityWithStateAbbr: "Lewistown, OH",
  },
  {
    zip: "43334",
    ST: "OH",
    cityWithStateAbbr: "Marengo, OH",
  },
  {
    zip: "43335",
    ST: "OH",
    cityWithStateAbbr: "Martel, OH",
  },
  {
    zip: "43336",
    ST: "OH",
    cityWithStateAbbr: "Middleburg, OH",
  },
  {
    zip: "43337",
    ST: "OH",
    cityWithStateAbbr: "Morral, OH",
  },
  {
    zip: "43338",
    ST: "OH",
    cityWithStateAbbr: "Mount Gilead, OH",
  },
  {
    zip: "43340",
    ST: "OH",
    cityWithStateAbbr: "Mount Victory, OH",
  },
  {
    zip: "43341",
    ST: "OH",
    cityWithStateAbbr: "New Bloomington, OH",
  },
  {
    zip: "43342",
    ST: "OH",
    cityWithStateAbbr: "Prospect, OH",
  },
  {
    zip: "43343",
    ST: "OH",
    cityWithStateAbbr: "Quincy, OH",
  },
  {
    zip: "43344",
    ST: "OH",
    cityWithStateAbbr: "Richwood, OH",
  },
  {
    zip: "43345",
    ST: "OH",
    cityWithStateAbbr: "Ridgeway, OH",
  },
  {
    zip: "43346",
    ST: "OH",
    cityWithStateAbbr: "Roundhead, OH",
  },
  {
    zip: "43347",
    ST: "OH",
    cityWithStateAbbr: "Rushsylvania, OH",
  },
  {
    zip: "43348",
    ST: "OH",
    cityWithStateAbbr: "Russells Point, OH",
  },
  {
    zip: "43349",
    ST: "OH",
    cityWithStateAbbr: "Shauck, OH",
  },
  {
    zip: "43350",
    ST: "OH",
    cityWithStateAbbr: "Sparta, OH",
  },
  {
    zip: "43351",
    ST: "OH",
    cityWithStateAbbr: "Upper Sandusky, OH",
  },
  {
    zip: "43356",
    ST: "OH",
    cityWithStateAbbr: "Waldo, OH",
  },
  {
    zip: "43357",
    ST: "OH",
    cityWithStateAbbr: "West Liberty, OH",
  },
  {
    zip: "43358",
    ST: "OH",
    cityWithStateAbbr: "West Mansfield, OH",
  },
  {
    zip: "43359",
    ST: "OH",
    cityWithStateAbbr: "Wharton, OH",
  },
  {
    zip: "43360",
    ST: "OH",
    cityWithStateAbbr: "Zanesfield, OH",
  },
  {
    zip: "43402",
    ST: "OH",
    cityWithStateAbbr: "Bowling Green, OH",
  },
  {
    zip: "43403",
    ST: "OH",
    cityWithStateAbbr: "Bowling Green, OH",
  },
  {
    zip: "43406",
    ST: "OH",
    cityWithStateAbbr: "Bradner, OH",
  },
  {
    zip: "43407",
    ST: "OH",
    cityWithStateAbbr: "Burgoon, OH",
  },
  {
    zip: "43408",
    ST: "OH",
    cityWithStateAbbr: "Clay Center, OH",
  },
  {
    zip: "43410",
    ST: "OH",
    cityWithStateAbbr: "Clyde, OH",
  },
  {
    zip: "43412",
    ST: "OH",
    cityWithStateAbbr: "Curtice, OH",
  },
  {
    zip: "43413",
    ST: "OH",
    cityWithStateAbbr: "Cygnet, OH",
  },
  {
    zip: "43414",
    ST: "OH",
    cityWithStateAbbr: "Dunbridge, OH",
  },
  {
    zip: "43416",
    ST: "OH",
    cityWithStateAbbr: "Elmore, OH",
  },
  {
    zip: "43420",
    ST: "OH",
    cityWithStateAbbr: "Fremont, OH",
  },
  {
    zip: "43430",
    ST: "OH",
    cityWithStateAbbr: "Genoa, OH",
  },
  {
    zip: "43431",
    ST: "OH",
    cityWithStateAbbr: "Gibsonburg, OH",
  },
  {
    zip: "43432",
    ST: "OH",
    cityWithStateAbbr: "Graytown, OH",
  },
  {
    zip: "43433",
    ST: "OH",
    cityWithStateAbbr: "Gypsum, OH",
  },
  {
    zip: "43434",
    ST: "OH",
    cityWithStateAbbr: "Harbor View, OH",
  },
  {
    zip: "43435",
    ST: "OH",
    cityWithStateAbbr: "Helena, OH",
  },
  {
    zip: "43436",
    ST: "OH",
    cityWithStateAbbr: "Isle Saint George, OH",
  },
  {
    zip: "43437",
    ST: "OH",
    cityWithStateAbbr: "Jerry City, OH",
  },
  {
    zip: "43438",
    ST: "OH",
    cityWithStateAbbr: "Kelleys Island, OH",
  },
  {
    zip: "43439",
    ST: "OH",
    cityWithStateAbbr: "Lacarne, OH",
  },
  {
    zip: "43440",
    ST: "OH",
    cityWithStateAbbr: "Lakeside Marblehead, OH",
  },
  {
    zip: "43441",
    ST: "OH",
    cityWithStateAbbr: "Lemoyne, OH",
  },
  {
    zip: "43442",
    ST: "OH",
    cityWithStateAbbr: "Lindsey, OH",
  },
  {
    zip: "43443",
    ST: "OH",
    cityWithStateAbbr: "Luckey, OH",
  },
  {
    zip: "43445",
    ST: "OH",
    cityWithStateAbbr: "Martin, OH",
  },
  {
    zip: "43446",
    ST: "OH",
    cityWithStateAbbr: "Middle Bass, OH",
  },
  {
    zip: "43447",
    ST: "OH",
    cityWithStateAbbr: "Millbury, OH",
  },
  {
    zip: "43449",
    ST: "OH",
    cityWithStateAbbr: "Oak Harbor, OH",
  },
  {
    zip: "43450",
    ST: "OH",
    cityWithStateAbbr: "Pemberville, OH",
  },
  {
    zip: "43451",
    ST: "OH",
    cityWithStateAbbr: "Portage, OH",
  },
  {
    zip: "43452",
    ST: "OH",
    cityWithStateAbbr: "Port Clinton, OH",
  },
  {
    zip: "43456",
    ST: "OH",
    cityWithStateAbbr: "Put In Bay, OH",
  },
  {
    zip: "43457",
    ST: "OH",
    cityWithStateAbbr: "Risingsun, OH",
  },
  {
    zip: "43458",
    ST: "OH",
    cityWithStateAbbr: "Rocky Ridge, OH",
  },
  {
    zip: "43460",
    ST: "OH",
    cityWithStateAbbr: "Rossford, OH",
  },
  {
    zip: "43462",
    ST: "OH",
    cityWithStateAbbr: "Rudolph, OH",
  },
  {
    zip: "43463",
    ST: "OH",
    cityWithStateAbbr: "Stony Ridge, OH",
  },
  {
    zip: "43464",
    ST: "OH",
    cityWithStateAbbr: "Vickery, OH",
  },
  {
    zip: "43465",
    ST: "OH",
    cityWithStateAbbr: "Walbridge, OH",
  },
  {
    zip: "43466",
    ST: "OH",
    cityWithStateAbbr: "Wayne, OH",
  },
  {
    zip: "43467",
    ST: "OH",
    cityWithStateAbbr: "West Millgrove, OH",
  },
  {
    zip: "43468",
    ST: "OH",
    cityWithStateAbbr: "Williston, OH",
  },
  {
    zip: "43469",
    ST: "OH",
    cityWithStateAbbr: "Woodville, OH",
  },
  {
    zip: "43501",
    ST: "OH",
    cityWithStateAbbr: "Alvordton, OH",
  },
  {
    zip: "43502",
    ST: "OH",
    cityWithStateAbbr: "Archbold, OH",
  },
  {
    zip: "43504",
    ST: "OH",
    cityWithStateAbbr: "Berkey, OH",
  },
  {
    zip: "43505",
    ST: "OH",
    cityWithStateAbbr: "Blakeslee, OH",
  },
  {
    zip: "43506",
    ST: "OH",
    cityWithStateAbbr: "Bryan, OH",
  },
  {
    zip: "43510",
    ST: "OH",
    cityWithStateAbbr: "Colton, OH",
  },
  {
    zip: "43511",
    ST: "OH",
    cityWithStateAbbr: "Custar, OH",
  },
  {
    zip: "43512",
    ST: "OH",
    cityWithStateAbbr: "Defiance, OH",
  },
  {
    zip: "43515",
    ST: "OH",
    cityWithStateAbbr: "Delta, OH",
  },
  {
    zip: "43516",
    ST: "OH",
    cityWithStateAbbr: "Deshler, OH",
  },
  {
    zip: "43517",
    ST: "OH",
    cityWithStateAbbr: "Edgerton, OH",
  },
  {
    zip: "43518",
    ST: "OH",
    cityWithStateAbbr: "Edon, OH",
  },
  {
    zip: "43519",
    ST: "OH",
    cityWithStateAbbr: "Evansport, OH",
  },
  {
    zip: "43520",
    ST: "OH",
    cityWithStateAbbr: "Farmer, OH",
  },
  {
    zip: "43521",
    ST: "OH",
    cityWithStateAbbr: "Fayette, OH",
  },
  {
    zip: "43522",
    ST: "OH",
    cityWithStateAbbr: "Grand Rapids, OH",
  },
  {
    zip: "43523",
    ST: "OH",
    cityWithStateAbbr: "Grelton, OH",
  },
  {
    zip: "43524",
    ST: "OH",
    cityWithStateAbbr: "Hamler, OH",
  },
  {
    zip: "43525",
    ST: "OH",
    cityWithStateAbbr: "Haskins, OH",
  },
  {
    zip: "43526",
    ST: "OH",
    cityWithStateAbbr: "Hicksville, OH",
  },
  {
    zip: "43527",
    ST: "OH",
    cityWithStateAbbr: "Holgate, OH",
  },
  {
    zip: "43528",
    ST: "OH",
    cityWithStateAbbr: "Holland, OH",
  },
  {
    zip: "43529",
    ST: "OH",
    cityWithStateAbbr: "Hoytville, OH",
  },
  {
    zip: "43530",
    ST: "OH",
    cityWithStateAbbr: "Jewell, OH",
  },
  {
    zip: "43531",
    ST: "OH",
    cityWithStateAbbr: "Kunkle, OH",
  },
  {
    zip: "43532",
    ST: "OH",
    cityWithStateAbbr: "Liberty Center, OH",
  },
  {
    zip: "43533",
    ST: "OH",
    cityWithStateAbbr: "Lyons, OH",
  },
  {
    zip: "43534",
    ST: "OH",
    cityWithStateAbbr: "Mc Clure, OH",
  },
  {
    zip: "43535",
    ST: "OH",
    cityWithStateAbbr: "Malinta, OH",
  },
  {
    zip: "43536",
    ST: "OH",
    cityWithStateAbbr: "Mark Center, OH",
  },
  {
    zip: "43537",
    ST: "OH",
    cityWithStateAbbr: "Maumee, OH",
  },
  {
    zip: "43540",
    ST: "OH",
    cityWithStateAbbr: "Metamora, OH",
  },
  {
    zip: "43541",
    ST: "OH",
    cityWithStateAbbr: "Milton Center, OH",
  },
  {
    zip: "43542",
    ST: "OH",
    cityWithStateAbbr: "Monclova, OH",
  },
  {
    zip: "43543",
    ST: "OH",
    cityWithStateAbbr: "Montpelier, OH",
  },
  {
    zip: "43545",
    ST: "OH",
    cityWithStateAbbr: "Napoleon, OH",
  },
  {
    zip: "43547",
    ST: "OH",
    cityWithStateAbbr: "Neapolis, OH",
  },
  {
    zip: "43548",
    ST: "OH",
    cityWithStateAbbr: "New Bavaria, OH",
  },
  {
    zip: "43549",
    ST: "OH",
    cityWithStateAbbr: "Ney, OH",
  },
  {
    zip: "43550",
    ST: "OH",
    cityWithStateAbbr: "Okolona, OH",
  },
  {
    zip: "43551",
    ST: "OH",
    cityWithStateAbbr: "Perrysburg, OH",
  },
  {
    zip: "43552",
    ST: "OH",
    cityWithStateAbbr: "Perrysburg, OH",
  },
  {
    zip: "43553",
    ST: "OH",
    cityWithStateAbbr: "Pettisville, OH",
  },
  {
    zip: "43554",
    ST: "OH",
    cityWithStateAbbr: "Pioneer, OH",
  },
  {
    zip: "43555",
    ST: "OH",
    cityWithStateAbbr: "Ridgeville Corners, OH",
  },
  {
    zip: "43556",
    ST: "OH",
    cityWithStateAbbr: "Sherwood, OH",
  },
  {
    zip: "43557",
    ST: "OH",
    cityWithStateAbbr: "Stryker, OH",
  },
  {
    zip: "43558",
    ST: "OH",
    cityWithStateAbbr: "Swanton, OH",
  },
  {
    zip: "43560",
    ST: "OH",
    cityWithStateAbbr: "Sylvania, OH",
  },
  {
    zip: "43565",
    ST: "OH",
    cityWithStateAbbr: "Tontogany, OH",
  },
  {
    zip: "43566",
    ST: "OH",
    cityWithStateAbbr: "Waterville, OH",
  },
  {
    zip: "43567",
    ST: "OH",
    cityWithStateAbbr: "Wauseon, OH",
  },
  {
    zip: "43569",
    ST: "OH",
    cityWithStateAbbr: "Weston, OH",
  },
  {
    zip: "43570",
    ST: "OH",
    cityWithStateAbbr: "West Unity, OH",
  },
  {
    zip: "43571",
    ST: "OH",
    cityWithStateAbbr: "Whitehouse, OH",
  },
  {
    zip: "43601",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43603",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43604",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43605",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43606",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43607",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43608",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43609",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43610",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43611",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43612",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43613",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43614",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43615",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43616",
    ST: "OH",
    cityWithStateAbbr: "Oregon, OH",
  },
  {
    zip: "43617",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43619",
    ST: "OH",
    cityWithStateAbbr: "Northwood, OH",
  },
  {
    zip: "43620",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43623",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43635",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43652",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43654",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43656",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43657",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43659",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43660",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43661",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43666",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43667",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43681",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43682",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43697",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43699",
    ST: "OH",
    cityWithStateAbbr: "Toledo, OH",
  },
  {
    zip: "43701",
    ST: "OH",
    cityWithStateAbbr: "Zanesville, OH",
  },
  {
    zip: "43702",
    ST: "OH",
    cityWithStateAbbr: "Zanesville, OH",
  },
  {
    zip: "43711",
    ST: "OH",
    cityWithStateAbbr: "Ava, OH",
  },
  {
    zip: "43713",
    ST: "OH",
    cityWithStateAbbr: "Barnesville, OH",
  },
  {
    zip: "43716",
    ST: "OH",
    cityWithStateAbbr: "Beallsville, OH",
  },
  {
    zip: "43717",
    ST: "OH",
    cityWithStateAbbr: "Belle Valley, OH",
  },
  {
    zip: "43718",
    ST: "OH",
    cityWithStateAbbr: "Belmont, OH",
  },
  {
    zip: "43719",
    ST: "OH",
    cityWithStateAbbr: "Bethesda, OH",
  },
  {
    zip: "43720",
    ST: "OH",
    cityWithStateAbbr: "Blue Rock, OH",
  },
  {
    zip: "43721",
    ST: "OH",
    cityWithStateAbbr: "Brownsville, OH",
  },
  {
    zip: "43722",
    ST: "OH",
    cityWithStateAbbr: "Buffalo, OH",
  },
  {
    zip: "43723",
    ST: "OH",
    cityWithStateAbbr: "Byesville, OH",
  },
  {
    zip: "43724",
    ST: "OH",
    cityWithStateAbbr: "Caldwell, OH",
  },
  {
    zip: "43725",
    ST: "OH",
    cityWithStateAbbr: "Cambridge, OH",
  },
  {
    zip: "43727",
    ST: "OH",
    cityWithStateAbbr: "Chandlersville, OH",
  },
  {
    zip: "43728",
    ST: "OH",
    cityWithStateAbbr: "Chesterhill, OH",
  },
  {
    zip: "43730",
    ST: "OH",
    cityWithStateAbbr: "Corning, OH",
  },
  {
    zip: "43731",
    ST: "OH",
    cityWithStateAbbr: "Crooksville, OH",
  },
  {
    zip: "43732",
    ST: "OH",
    cityWithStateAbbr: "Cumberland, OH",
  },
  {
    zip: "43733",
    ST: "OH",
    cityWithStateAbbr: "Derwent, OH",
  },
  {
    zip: "43734",
    ST: "OH",
    cityWithStateAbbr: "Duncan Falls, OH",
  },
  {
    zip: "43735",
    ST: "OH",
    cityWithStateAbbr: "East Fultonham, OH",
  },
  {
    zip: "43736",
    ST: "OH",
    cityWithStateAbbr: "Fairview, OH",
  },
  {
    zip: "43738",
    ST: "OH",
    cityWithStateAbbr: "Fultonham, OH",
  },
  {
    zip: "43739",
    ST: "OH",
    cityWithStateAbbr: "Glenford, OH",
  },
  {
    zip: "43740",
    ST: "OH",
    cityWithStateAbbr: "Gratiot, OH",
  },
  {
    zip: "43746",
    ST: "OH",
    cityWithStateAbbr: "Hopewell, OH",
  },
  {
    zip: "43747",
    ST: "OH",
    cityWithStateAbbr: "Jerusalem, OH",
  },
  {
    zip: "43748",
    ST: "OH",
    cityWithStateAbbr: "Junction City, OH",
  },
  {
    zip: "43749",
    ST: "OH",
    cityWithStateAbbr: "Kimbolton, OH",
  },
  {
    zip: "43750",
    ST: "OH",
    cityWithStateAbbr: "Kipling, OH",
  },
  {
    zip: "43752",
    ST: "OH",
    cityWithStateAbbr: "Laings, OH",
  },
  {
    zip: "43754",
    ST: "OH",
    cityWithStateAbbr: "Lewisville, OH",
  },
  {
    zip: "43755",
    ST: "OH",
    cityWithStateAbbr: "Lore City, OH",
  },
  {
    zip: "43756",
    ST: "OH",
    cityWithStateAbbr: "Mcconnelsville, OH",
  },
  {
    zip: "43757",
    ST: "OH",
    cityWithStateAbbr: "Malaga, OH",
  },
  {
    zip: "43758",
    ST: "OH",
    cityWithStateAbbr: "Malta, OH",
  },
  {
    zip: "43759",
    ST: "OH",
    cityWithStateAbbr: "Morristown, OH",
  },
  {
    zip: "43760",
    ST: "OH",
    cityWithStateAbbr: "Mount Perry, OH",
  },
  {
    zip: "43761",
    ST: "OH",
    cityWithStateAbbr: "Moxahala, OH",
  },
  {
    zip: "43762",
    ST: "OH",
    cityWithStateAbbr: "New Concord, OH",
  },
  {
    zip: "43764",
    ST: "OH",
    cityWithStateAbbr: "New Lexington, OH",
  },
  {
    zip: "43766",
    ST: "OH",
    cityWithStateAbbr: "New Straitsville, OH",
  },
  {
    zip: "43767",
    ST: "OH",
    cityWithStateAbbr: "Norwich, OH",
  },
  {
    zip: "43768",
    ST: "OH",
    cityWithStateAbbr: "Old Washington, OH",
  },
  {
    zip: "43771",
    ST: "OH",
    cityWithStateAbbr: "Philo, OH",
  },
  {
    zip: "43772",
    ST: "OH",
    cityWithStateAbbr: "Pleasant City, OH",
  },
  {
    zip: "43773",
    ST: "OH",
    cityWithStateAbbr: "Quaker City, OH",
  },
  {
    zip: "43777",
    ST: "OH",
    cityWithStateAbbr: "Roseville, OH",
  },
  {
    zip: "43778",
    ST: "OH",
    cityWithStateAbbr: "Salesville, OH",
  },
  {
    zip: "43779",
    ST: "OH",
    cityWithStateAbbr: "Sarahsville, OH",
  },
  {
    zip: "43780",
    ST: "OH",
    cityWithStateAbbr: "Senecaville, OH",
  },
  {
    zip: "43782",
    ST: "OH",
    cityWithStateAbbr: "Shawnee, OH",
  },
  {
    zip: "43783",
    ST: "OH",
    cityWithStateAbbr: "Somerset, OH",
  },
  {
    zip: "43786",
    ST: "OH",
    cityWithStateAbbr: "Stafford, OH",
  },
  {
    zip: "43787",
    ST: "OH",
    cityWithStateAbbr: "Stockport, OH",
  },
  {
    zip: "43788",
    ST: "OH",
    cityWithStateAbbr: "Summerfield, OH",
  },
  {
    zip: "43791",
    ST: "OH",
    cityWithStateAbbr: "White Cottage, OH",
  },
  {
    zip: "43793",
    ST: "OH",
    cityWithStateAbbr: "Woodsfield, OH",
  },
  {
    zip: "43802",
    ST: "OH",
    cityWithStateAbbr: "Adamsville, OH",
  },
  {
    zip: "43803",
    ST: "OH",
    cityWithStateAbbr: "Bakersville, OH",
  },
  {
    zip: "43804",
    ST: "OH",
    cityWithStateAbbr: "Baltic, OH",
  },
  {
    zip: "43805",
    ST: "OH",
    cityWithStateAbbr: "Blissfield, OH",
  },
  {
    zip: "43811",
    ST: "OH",
    cityWithStateAbbr: "Conesville, OH",
  },
  {
    zip: "43812",
    ST: "OH",
    cityWithStateAbbr: "Coshocton, OH",
  },
  {
    zip: "43821",
    ST: "OH",
    cityWithStateAbbr: "Dresden, OH",
  },
  {
    zip: "43822",
    ST: "OH",
    cityWithStateAbbr: "Frazeysburg, OH",
  },
  {
    zip: "43824",
    ST: "OH",
    cityWithStateAbbr: "Fresno, OH",
  },
  {
    zip: "43828",
    ST: "OH",
    cityWithStateAbbr: "Keene, OH",
  },
  {
    zip: "43830",
    ST: "OH",
    cityWithStateAbbr: "Nashport, OH",
  },
  {
    zip: "43832",
    ST: "OH",
    cityWithStateAbbr: "Newcomerstown, OH",
  },
  {
    zip: "43836",
    ST: "OH",
    cityWithStateAbbr: "Plainfield, OH",
  },
  {
    zip: "43837",
    ST: "OH",
    cityWithStateAbbr: "Port Washington, OH",
  },
  {
    zip: "43840",
    ST: "OH",
    cityWithStateAbbr: "Stone Creek, OH",
  },
  {
    zip: "43842",
    ST: "OH",
    cityWithStateAbbr: "Trinway, OH",
  },
  {
    zip: "43843",
    ST: "OH",
    cityWithStateAbbr: "Walhonding, OH",
  },
  {
    zip: "43844",
    ST: "OH",
    cityWithStateAbbr: "Warsaw, OH",
  },
  {
    zip: "43845",
    ST: "OH",
    cityWithStateAbbr: "West Lafayette, OH",
  },
  {
    zip: "43901",
    ST: "OH",
    cityWithStateAbbr: "Adena, OH",
  },
  {
    zip: "43902",
    ST: "OH",
    cityWithStateAbbr: "Alledonia, OH",
  },
  {
    zip: "43903",
    ST: "OH",
    cityWithStateAbbr: "Amsterdam, OH",
  },
  {
    zip: "43905",
    ST: "OH",
    cityWithStateAbbr: "Barton, OH",
  },
  {
    zip: "43906",
    ST: "OH",
    cityWithStateAbbr: "Bellaire, OH",
  },
  {
    zip: "43907",
    ST: "OH",
    cityWithStateAbbr: "Cadiz, OH",
  },
  {
    zip: "43908",
    ST: "OH",
    cityWithStateAbbr: "Bergholz, OH",
  },
  {
    zip: "43909",
    ST: "OH",
    cityWithStateAbbr: "Blaine, OH",
  },
  {
    zip: "43910",
    ST: "OH",
    cityWithStateAbbr: "Bloomingdale, OH",
  },
  {
    zip: "43912",
    ST: "OH",
    cityWithStateAbbr: "Bridgeport, OH",
  },
  {
    zip: "43913",
    ST: "OH",
    cityWithStateAbbr: "Brilliant, OH",
  },
  {
    zip: "43914",
    ST: "OH",
    cityWithStateAbbr: "Cameron, OH",
  },
  {
    zip: "43915",
    ST: "OH",
    cityWithStateAbbr: "Clarington, OH",
  },
  {
    zip: "43916",
    ST: "OH",
    cityWithStateAbbr: "Colerain, OH",
  },
  {
    zip: "43917",
    ST: "OH",
    cityWithStateAbbr: "Dillonvale, OH",
  },
  {
    zip: "43920",
    ST: "OH",
    cityWithStateAbbr: "East Liverpool, OH",
  },
  {
    zip: "43925",
    ST: "OH",
    cityWithStateAbbr: "East Springfield, OH",
  },
  {
    zip: "43926",
    ST: "OH",
    cityWithStateAbbr: "Empire, OH",
  },
  {
    zip: "43927",
    ST: "OH",
    cityWithStateAbbr: "Fairpoint, OH",
  },
  {
    zip: "43928",
    ST: "OH",
    cityWithStateAbbr: "Glencoe, OH",
  },
  {
    zip: "43930",
    ST: "OH",
    cityWithStateAbbr: "Hammondsville, OH",
  },
  {
    zip: "43931",
    ST: "OH",
    cityWithStateAbbr: "Hannibal, OH",
  },
  {
    zip: "43932",
    ST: "OH",
    cityWithStateAbbr: "Irondale, OH",
  },
  {
    zip: "43933",
    ST: "OH",
    cityWithStateAbbr: "Jacobsburg, OH",
  },
  {
    zip: "43934",
    ST: "OH",
    cityWithStateAbbr: "Lansing, OH",
  },
  {
    zip: "43935",
    ST: "OH",
    cityWithStateAbbr: "Martins Ferry, OH",
  },
  {
    zip: "43937",
    ST: "OH",
    cityWithStateAbbr: "Maynard, OH",
  },
  {
    zip: "43938",
    ST: "OH",
    cityWithStateAbbr: "Mingo Junction, OH",
  },
  {
    zip: "43939",
    ST: "OH",
    cityWithStateAbbr: "Mount Pleasant, OH",
  },
  {
    zip: "43940",
    ST: "OH",
    cityWithStateAbbr: "Neffs, OH",
  },
  {
    zip: "43941",
    ST: "OH",
    cityWithStateAbbr: "Piney Fork, OH",
  },
  {
    zip: "43942",
    ST: "OH",
    cityWithStateAbbr: "Powhatan Point, OH",
  },
  {
    zip: "43943",
    ST: "OH",
    cityWithStateAbbr: "Rayland, OH",
  },
  {
    zip: "43944",
    ST: "OH",
    cityWithStateAbbr: "Richmond, OH",
  },
  {
    zip: "43945",
    ST: "OH",
    cityWithStateAbbr: "Salineville, OH",
  },
  {
    zip: "43946",
    ST: "OH",
    cityWithStateAbbr: "Sardis, OH",
  },
  {
    zip: "43947",
    ST: "OH",
    cityWithStateAbbr: "Shadyside, OH",
  },
  {
    zip: "43948",
    ST: "OH",
    cityWithStateAbbr: "Smithfield, OH",
  },
  {
    zip: "43950",
    ST: "OH",
    cityWithStateAbbr: "Saint Clairsville, OH",
  },
  {
    zip: "43951",
    ST: "OH",
    cityWithStateAbbr: "Lafferty, OH",
  },
  {
    zip: "43952",
    ST: "OH",
    cityWithStateAbbr: "Steubenville, OH",
  },
  {
    zip: "43953",
    ST: "OH",
    cityWithStateAbbr: "Steubenville, OH",
  },
  {
    zip: "43961",
    ST: "OH",
    cityWithStateAbbr: "Stratton, OH",
  },
  {
    zip: "43962",
    ST: "OH",
    cityWithStateAbbr: "Summitville, OH",
  },
  {
    zip: "43963",
    ST: "OH",
    cityWithStateAbbr: "Tiltonsville, OH",
  },
  {
    zip: "43964",
    ST: "OH",
    cityWithStateAbbr: "Toronto, OH",
  },
  {
    zip: "43967",
    ST: "OH",
    cityWithStateAbbr: "Warnock, OH",
  },
  {
    zip: "43968",
    ST: "OH",
    cityWithStateAbbr: "Wellsville, OH",
  },
  {
    zip: "43970",
    ST: "OH",
    cityWithStateAbbr: "Wolf Run, OH",
  },
  {
    zip: "43971",
    ST: "OH",
    cityWithStateAbbr: "Yorkville, OH",
  },
  {
    zip: "43972",
    ST: "OH",
    cityWithStateAbbr: "Bannock, OH",
  },
  {
    zip: "43973",
    ST: "OH",
    cityWithStateAbbr: "Freeport, OH",
  },
  {
    zip: "43974",
    ST: "OH",
    cityWithStateAbbr: "Harrisville, OH",
  },
  {
    zip: "43976",
    ST: "OH",
    cityWithStateAbbr: "Hopedale, OH",
  },
  {
    zip: "43977",
    ST: "OH",
    cityWithStateAbbr: "Flushing, OH",
  },
  {
    zip: "43981",
    ST: "OH",
    cityWithStateAbbr: "New Athens, OH",
  },
  {
    zip: "43983",
    ST: "OH",
    cityWithStateAbbr: "Piedmont, OH",
  },
  {
    zip: "43984",
    ST: "OH",
    cityWithStateAbbr: "New Rumley, OH",
  },
  {
    zip: "43985",
    ST: "OH",
    cityWithStateAbbr: "Holloway, OH",
  },
  {
    zip: "43986",
    ST: "OH",
    cityWithStateAbbr: "Jewett, OH",
  },
  {
    zip: "43988",
    ST: "OH",
    cityWithStateAbbr: "Scio, OH",
  },
  {
    zip: "44001",
    ST: "OH",
    cityWithStateAbbr: "Amherst, OH",
  },
  {
    zip: "44003",
    ST: "OH",
    cityWithStateAbbr: "Andover, OH",
  },
  {
    zip: "44004",
    ST: "OH",
    cityWithStateAbbr: "Ashtabula, OH",
  },
  {
    zip: "44005",
    ST: "OH",
    cityWithStateAbbr: "Ashtabula, OH",
  },
  {
    zip: "44010",
    ST: "OH",
    cityWithStateAbbr: "Austinburg, OH",
  },
  {
    zip: "44011",
    ST: "OH",
    cityWithStateAbbr: "Avon, OH",
  },
  {
    zip: "44012",
    ST: "OH",
    cityWithStateAbbr: "Avon Lake, OH",
  },
  {
    zip: "44017",
    ST: "OH",
    cityWithStateAbbr: "Berea, OH",
  },
  {
    zip: "44021",
    ST: "OH",
    cityWithStateAbbr: "Burton, OH",
  },
  {
    zip: "44022",
    ST: "OH",
    cityWithStateAbbr: "Chagrin Falls, OH",
  },
  {
    zip: "44023",
    ST: "OH",
    cityWithStateAbbr: "Chagrin Falls, OH",
  },
  {
    zip: "44024",
    ST: "OH",
    cityWithStateAbbr: "Chardon, OH",
  },
  {
    zip: "44026",
    ST: "OH",
    cityWithStateAbbr: "Chesterland, OH",
  },
  {
    zip: "44028",
    ST: "OH",
    cityWithStateAbbr: "Columbia Station, OH",
  },
  {
    zip: "44030",
    ST: "OH",
    cityWithStateAbbr: "Conneaut, OH",
  },
  {
    zip: "44032",
    ST: "OH",
    cityWithStateAbbr: "Dorset, OH",
  },
  {
    zip: "44033",
    ST: "OH",
    cityWithStateAbbr: "East Claridon, OH",
  },
  {
    zip: "44035",
    ST: "OH",
    cityWithStateAbbr: "Elyria, OH",
  },
  {
    zip: "44036",
    ST: "OH",
    cityWithStateAbbr: "Elyria, OH",
  },
  {
    zip: "44039",
    ST: "OH",
    cityWithStateAbbr: "North Ridgeville, OH",
  },
  {
    zip: "44040",
    ST: "OH",
    cityWithStateAbbr: "Gates Mills, OH",
  },
  {
    zip: "44041",
    ST: "OH",
    cityWithStateAbbr: "Geneva, OH",
  },
  {
    zip: "44044",
    ST: "OH",
    cityWithStateAbbr: "Grafton, OH",
  },
  {
    zip: "44045",
    ST: "OH",
    cityWithStateAbbr: "Grand River, OH",
  },
  {
    zip: "44046",
    ST: "OH",
    cityWithStateAbbr: "Huntsburg, OH",
  },
  {
    zip: "44047",
    ST: "OH",
    cityWithStateAbbr: "Jefferson, OH",
  },
  {
    zip: "44048",
    ST: "OH",
    cityWithStateAbbr: "Kingsville, OH",
  },
  {
    zip: "44049",
    ST: "OH",
    cityWithStateAbbr: "Kipton, OH",
  },
  {
    zip: "44050",
    ST: "OH",
    cityWithStateAbbr: "Lagrange, OH",
  },
  {
    zip: "44052",
    ST: "OH",
    cityWithStateAbbr: "Lorain, OH",
  },
  {
    zip: "44053",
    ST: "OH",
    cityWithStateAbbr: "Lorain, OH",
  },
  {
    zip: "44054",
    ST: "OH",
    cityWithStateAbbr: "Sheffield Lake, OH",
  },
  {
    zip: "44055",
    ST: "OH",
    cityWithStateAbbr: "Lorain, OH",
  },
  {
    zip: "44056",
    ST: "OH",
    cityWithStateAbbr: "Macedonia, OH",
  },
  {
    zip: "44057",
    ST: "OH",
    cityWithStateAbbr: "Madison, OH",
  },
  {
    zip: "44060",
    ST: "OH",
    cityWithStateAbbr: "Mentor, OH",
  },
  {
    zip: "44061",
    ST: "OH",
    cityWithStateAbbr: "Mentor, OH",
  },
  {
    zip: "44062",
    ST: "OH",
    cityWithStateAbbr: "Middlefield, OH",
  },
  {
    zip: "44064",
    ST: "OH",
    cityWithStateAbbr: "Montville, OH",
  },
  {
    zip: "44065",
    ST: "OH",
    cityWithStateAbbr: "Newbury, OH",
  },
  {
    zip: "44067",
    ST: "OH",
    cityWithStateAbbr: "Northfield, OH",
  },
  {
    zip: "44068",
    ST: "OH",
    cityWithStateAbbr: "North Kingsville, OH",
  },
  {
    zip: "44070",
    ST: "OH",
    cityWithStateAbbr: "North Olmsted, OH",
  },
  {
    zip: "44072",
    ST: "OH",
    cityWithStateAbbr: "Novelty, OH",
  },
  {
    zip: "44073",
    ST: "OH",
    cityWithStateAbbr: "Novelty, OH",
  },
  {
    zip: "44074",
    ST: "OH",
    cityWithStateAbbr: "Oberlin, OH",
  },
  {
    zip: "44076",
    ST: "OH",
    cityWithStateAbbr: "Orwell, OH",
  },
  {
    zip: "44077",
    ST: "OH",
    cityWithStateAbbr: "Painesville, OH",
  },
  {
    zip: "44080",
    ST: "OH",
    cityWithStateAbbr: "Parkman, OH",
  },
  {
    zip: "44081",
    ST: "OH",
    cityWithStateAbbr: "Perry, OH",
  },
  {
    zip: "44082",
    ST: "OH",
    cityWithStateAbbr: "Pierpont, OH",
  },
  {
    zip: "44084",
    ST: "OH",
    cityWithStateAbbr: "Rock Creek, OH",
  },
  {
    zip: "44085",
    ST: "OH",
    cityWithStateAbbr: "Rome, OH",
  },
  {
    zip: "44086",
    ST: "OH",
    cityWithStateAbbr: "Thompson, OH",
  },
  {
    zip: "44087",
    ST: "OH",
    cityWithStateAbbr: "Twinsburg, OH",
  },
  {
    zip: "44088",
    ST: "OH",
    cityWithStateAbbr: "Unionville, OH",
  },
  {
    zip: "44089",
    ST: "OH",
    cityWithStateAbbr: "Vermilion, OH",
  },
  {
    zip: "44090",
    ST: "OH",
    cityWithStateAbbr: "Wellington, OH",
  },
  {
    zip: "44092",
    ST: "OH",
    cityWithStateAbbr: "Wickliffe, OH",
  },
  {
    zip: "44093",
    ST: "OH",
    cityWithStateAbbr: "Williamsfield, OH",
  },
  {
    zip: "44094",
    ST: "OH",
    cityWithStateAbbr: "Willoughby, OH",
  },
  {
    zip: "44095",
    ST: "OH",
    cityWithStateAbbr: "Eastlake, OH",
  },
  {
    zip: "44096",
    ST: "OH",
    cityWithStateAbbr: "Willoughby, OH",
  },
  {
    zip: "44097",
    ST: "OH",
    cityWithStateAbbr: "Eastlake, OH",
  },
  {
    zip: "44099",
    ST: "OH",
    cityWithStateAbbr: "Windsor, OH",
  },
  {
    zip: "44101",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44102",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44103",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44104",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44105",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44106",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44107",
    ST: "OH",
    cityWithStateAbbr: "Lakewood, OH",
  },
  {
    zip: "44108",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44109",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44110",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44111",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44112",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44113",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44114",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44115",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44116",
    ST: "OH",
    cityWithStateAbbr: "Rocky River, OH",
  },
  {
    zip: "44117",
    ST: "OH",
    cityWithStateAbbr: "Euclid, OH",
  },
  {
    zip: "44118",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44119",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44120",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44121",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44122",
    ST: "OH",
    cityWithStateAbbr: "Beachwood, OH",
  },
  {
    zip: "44123",
    ST: "OH",
    cityWithStateAbbr: "Euclid, OH",
  },
  {
    zip: "44124",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44125",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44126",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44127",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44128",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44129",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44130",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44131",
    ST: "OH",
    cityWithStateAbbr: "Independence, OH",
  },
  {
    zip: "44132",
    ST: "OH",
    cityWithStateAbbr: "Euclid, OH",
  },
  {
    zip: "44133",
    ST: "OH",
    cityWithStateAbbr: "North Royalton, OH",
  },
  {
    zip: "44134",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44135",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44136",
    ST: "OH",
    cityWithStateAbbr: "Strongsville, OH",
  },
  {
    zip: "44137",
    ST: "OH",
    cityWithStateAbbr: "Maple Heights, OH",
  },
  {
    zip: "44138",
    ST: "OH",
    cityWithStateAbbr: "Olmsted Falls, OH",
  },
  {
    zip: "44139",
    ST: "OH",
    cityWithStateAbbr: "Solon, OH",
  },
  {
    zip: "44140",
    ST: "OH",
    cityWithStateAbbr: "Bay Village, OH",
  },
  {
    zip: "44141",
    ST: "OH",
    cityWithStateAbbr: "Brecksville, OH",
  },
  {
    zip: "44142",
    ST: "OH",
    cityWithStateAbbr: "Brookpark, OH",
  },
  {
    zip: "44143",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44144",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44145",
    ST: "OH",
    cityWithStateAbbr: "Westlake, OH",
  },
  {
    zip: "44146",
    ST: "OH",
    cityWithStateAbbr: "Bedford, OH",
  },
  {
    zip: "44147",
    ST: "OH",
    cityWithStateAbbr: "Broadview Heights, OH",
  },
  {
    zip: "44149",
    ST: "OH",
    cityWithStateAbbr: "Strongsville, OH",
  },
  {
    zip: "44181",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44188",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44190",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44191",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44192",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44193",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44194",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44195",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44198",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44199",
    ST: "OH",
    cityWithStateAbbr: "Cleveland, OH",
  },
  {
    zip: "44201",
    ST: "OH",
    cityWithStateAbbr: "Atwater, OH",
  },
  {
    zip: "44202",
    ST: "OH",
    cityWithStateAbbr: "Aurora, OH",
  },
  {
    zip: "44203",
    ST: "OH",
    cityWithStateAbbr: "Barberton, OH",
  },
  {
    zip: "44210",
    ST: "OH",
    cityWithStateAbbr: "Bath, OH",
  },
  {
    zip: "44211",
    ST: "OH",
    cityWithStateAbbr: "Brady Lake, OH",
  },
  {
    zip: "44212",
    ST: "OH",
    cityWithStateAbbr: "Brunswick, OH",
  },
  {
    zip: "44214",
    ST: "OH",
    cityWithStateAbbr: "Burbank, OH",
  },
  {
    zip: "44215",
    ST: "OH",
    cityWithStateAbbr: "Chippewa Lake, OH",
  },
  {
    zip: "44216",
    ST: "OH",
    cityWithStateAbbr: "Clinton, OH",
  },
  {
    zip: "44217",
    ST: "OH",
    cityWithStateAbbr: "Creston, OH",
  },
  {
    zip: "44221",
    ST: "OH",
    cityWithStateAbbr: "Cuyahoga Falls, OH",
  },
  {
    zip: "44222",
    ST: "OH",
    cityWithStateAbbr: "Cuyahoga Falls, OH",
  },
  {
    zip: "44223",
    ST: "OH",
    cityWithStateAbbr: "Cuyahoga Falls, OH",
  },
  {
    zip: "44224",
    ST: "OH",
    cityWithStateAbbr: "Stow, OH",
  },
  {
    zip: "44230",
    ST: "OH",
    cityWithStateAbbr: "Doylestown, OH",
  },
  {
    zip: "44231",
    ST: "OH",
    cityWithStateAbbr: "Garrettsville, OH",
  },
  {
    zip: "44232",
    ST: "OH",
    cityWithStateAbbr: "Green, OH",
  },
  {
    zip: "44233",
    ST: "OH",
    cityWithStateAbbr: "Hinckley, OH",
  },
  {
    zip: "44234",
    ST: "OH",
    cityWithStateAbbr: "Hiram, OH",
  },
  {
    zip: "44235",
    ST: "OH",
    cityWithStateAbbr: "Homerville, OH",
  },
  {
    zip: "44236",
    ST: "OH",
    cityWithStateAbbr: "Hudson, OH",
  },
  {
    zip: "44237",
    ST: "OH",
    cityWithStateAbbr: "Hudson, OH",
  },
  {
    zip: "44240",
    ST: "OH",
    cityWithStateAbbr: "Kent, OH",
  },
  {
    zip: "44241",
    ST: "OH",
    cityWithStateAbbr: "Streetsboro, OH",
  },
  {
    zip: "44242",
    ST: "OH",
    cityWithStateAbbr: "Kent, OH",
  },
  {
    zip: "44243",
    ST: "OH",
    cityWithStateAbbr: "Kent, OH",
  },
  {
    zip: "44250",
    ST: "OH",
    cityWithStateAbbr: "Lakemore, OH",
  },
  {
    zip: "44251",
    ST: "OH",
    cityWithStateAbbr: "Westfield Center, OH",
  },
  {
    zip: "44253",
    ST: "OH",
    cityWithStateAbbr: "Litchfield, OH",
  },
  {
    zip: "44254",
    ST: "OH",
    cityWithStateAbbr: "Lodi, OH",
  },
  {
    zip: "44255",
    ST: "OH",
    cityWithStateAbbr: "Mantua, OH",
  },
  {
    zip: "44256",
    ST: "OH",
    cityWithStateAbbr: "Medina, OH",
  },
  {
    zip: "44258",
    ST: "OH",
    cityWithStateAbbr: "Medina, OH",
  },
  {
    zip: "44260",
    ST: "OH",
    cityWithStateAbbr: "Mogadore, OH",
  },
  {
    zip: "44262",
    ST: "OH",
    cityWithStateAbbr: "Munroe Falls, OH",
  },
  {
    zip: "44264",
    ST: "OH",
    cityWithStateAbbr: "Peninsula, OH",
  },
  {
    zip: "44265",
    ST: "OH",
    cityWithStateAbbr: "Randolph, OH",
  },
  {
    zip: "44266",
    ST: "OH",
    cityWithStateAbbr: "Ravenna, OH",
  },
  {
    zip: "44270",
    ST: "OH",
    cityWithStateAbbr: "Rittman, OH",
  },
  {
    zip: "44272",
    ST: "OH",
    cityWithStateAbbr: "Rootstown, OH",
  },
  {
    zip: "44273",
    ST: "OH",
    cityWithStateAbbr: "Seville, OH",
  },
  {
    zip: "44274",
    ST: "OH",
    cityWithStateAbbr: "Sharon Center, OH",
  },
  {
    zip: "44275",
    ST: "OH",
    cityWithStateAbbr: "Spencer, OH",
  },
  {
    zip: "44276",
    ST: "OH",
    cityWithStateAbbr: "Sterling, OH",
  },
  {
    zip: "44278",
    ST: "OH",
    cityWithStateAbbr: "Tallmadge, OH",
  },
  {
    zip: "44280",
    ST: "OH",
    cityWithStateAbbr: "Valley City, OH",
  },
  {
    zip: "44281",
    ST: "OH",
    cityWithStateAbbr: "Wadsworth, OH",
  },
  {
    zip: "44282",
    ST: "OH",
    cityWithStateAbbr: "Wadsworth, OH",
  },
  {
    zip: "44285",
    ST: "OH",
    cityWithStateAbbr: "Wayland, OH",
  },
  {
    zip: "44286",
    ST: "OH",
    cityWithStateAbbr: "Richfield, OH",
  },
  {
    zip: "44287",
    ST: "OH",
    cityWithStateAbbr: "West Salem, OH",
  },
  {
    zip: "44288",
    ST: "OH",
    cityWithStateAbbr: "Windham, OH",
  },
  {
    zip: "44301",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44302",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44303",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44304",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44305",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44306",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44307",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44308",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44309",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44310",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44311",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44312",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44313",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44314",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44315",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44316",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44317",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44319",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44320",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44321",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44325",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44326",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44328",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44333",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44334",
    ST: "OH",
    cityWithStateAbbr: "Fairlawn, OH",
  },
  {
    zip: "44372",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44396",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44398",
    ST: "OH",
    cityWithStateAbbr: "Akron, OH",
  },
  {
    zip: "44401",
    ST: "OH",
    cityWithStateAbbr: "Berlin Center, OH",
  },
  {
    zip: "44402",
    ST: "OH",
    cityWithStateAbbr: "Bristolville, OH",
  },
  {
    zip: "44403",
    ST: "OH",
    cityWithStateAbbr: "Brookfield, OH",
  },
  {
    zip: "44404",
    ST: "OH",
    cityWithStateAbbr: "Burghill, OH",
  },
  {
    zip: "44405",
    ST: "OH",
    cityWithStateAbbr: "Campbell, OH",
  },
  {
    zip: "44406",
    ST: "OH",
    cityWithStateAbbr: "Canfield, OH",
  },
  {
    zip: "44408",
    ST: "OH",
    cityWithStateAbbr: "Columbiana, OH",
  },
  {
    zip: "44410",
    ST: "OH",
    cityWithStateAbbr: "Cortland, OH",
  },
  {
    zip: "44411",
    ST: "OH",
    cityWithStateAbbr: "Deerfield, OH",
  },
  {
    zip: "44412",
    ST: "OH",
    cityWithStateAbbr: "Diamond, OH",
  },
  {
    zip: "44413",
    ST: "OH",
    cityWithStateAbbr: "East Palestine, OH",
  },
  {
    zip: "44415",
    ST: "OH",
    cityWithStateAbbr: "Elkton, OH",
  },
  {
    zip: "44416",
    ST: "OH",
    cityWithStateAbbr: "Ellsworth, OH",
  },
  {
    zip: "44417",
    ST: "OH",
    cityWithStateAbbr: "Farmdale, OH",
  },
  {
    zip: "44418",
    ST: "OH",
    cityWithStateAbbr: "Fowler, OH",
  },
  {
    zip: "44420",
    ST: "OH",
    cityWithStateAbbr: "Girard, OH",
  },
  {
    zip: "44422",
    ST: "OH",
    cityWithStateAbbr: "Greenford, OH",
  },
  {
    zip: "44423",
    ST: "OH",
    cityWithStateAbbr: "Hanoverton, OH",
  },
  {
    zip: "44424",
    ST: "OH",
    cityWithStateAbbr: "Hartford, OH",
  },
  {
    zip: "44425",
    ST: "OH",
    cityWithStateAbbr: "Hubbard, OH",
  },
  {
    zip: "44427",
    ST: "OH",
    cityWithStateAbbr: "Kensington, OH",
  },
  {
    zip: "44428",
    ST: "OH",
    cityWithStateAbbr: "Kinsman, OH",
  },
  {
    zip: "44429",
    ST: "OH",
    cityWithStateAbbr: "Lake Milton, OH",
  },
  {
    zip: "44430",
    ST: "OH",
    cityWithStateAbbr: "Leavittsburg, OH",
  },
  {
    zip: "44431",
    ST: "OH",
    cityWithStateAbbr: "Leetonia, OH",
  },
  {
    zip: "44432",
    ST: "OH",
    cityWithStateAbbr: "Lisbon, OH",
  },
  {
    zip: "44436",
    ST: "OH",
    cityWithStateAbbr: "Lowellville, OH",
  },
  {
    zip: "44437",
    ST: "OH",
    cityWithStateAbbr: "Mc Donald, OH",
  },
  {
    zip: "44438",
    ST: "OH",
    cityWithStateAbbr: "Masury, OH",
  },
  {
    zip: "44439",
    ST: "OH",
    cityWithStateAbbr: "Mesopotamia, OH",
  },
  {
    zip: "44440",
    ST: "OH",
    cityWithStateAbbr: "Mineral Ridge, OH",
  },
  {
    zip: "44441",
    ST: "OH",
    cityWithStateAbbr: "Negley, OH",
  },
  {
    zip: "44442",
    ST: "OH",
    cityWithStateAbbr: "New Middletown, OH",
  },
  {
    zip: "44443",
    ST: "OH",
    cityWithStateAbbr: "New Springfield, OH",
  },
  {
    zip: "44444",
    ST: "OH",
    cityWithStateAbbr: "Newton Falls, OH",
  },
  {
    zip: "44445",
    ST: "OH",
    cityWithStateAbbr: "New Waterford, OH",
  },
  {
    zip: "44446",
    ST: "OH",
    cityWithStateAbbr: "Niles, OH",
  },
  {
    zip: "44449",
    ST: "OH",
    cityWithStateAbbr: "North Benton, OH",
  },
  {
    zip: "44450",
    ST: "OH",
    cityWithStateAbbr: "North Bloomfield, OH",
  },
  {
    zip: "44451",
    ST: "OH",
    cityWithStateAbbr: "North Jackson, OH",
  },
  {
    zip: "44452",
    ST: "OH",
    cityWithStateAbbr: "North Lima, OH",
  },
  {
    zip: "44453",
    ST: "OH",
    cityWithStateAbbr: "Orangeville, OH",
  },
  {
    zip: "44454",
    ST: "OH",
    cityWithStateAbbr: "Petersburg, OH",
  },
  {
    zip: "44455",
    ST: "OH",
    cityWithStateAbbr: "Rogers, OH",
  },
  {
    zip: "44460",
    ST: "OH",
    cityWithStateAbbr: "Salem, OH",
  },
  {
    zip: "44470",
    ST: "OH",
    cityWithStateAbbr: "Southington, OH",
  },
  {
    zip: "44471",
    ST: "OH",
    cityWithStateAbbr: "Struthers, OH",
  },
  {
    zip: "44473",
    ST: "OH",
    cityWithStateAbbr: "Vienna, OH",
  },
  {
    zip: "44481",
    ST: "OH",
    cityWithStateAbbr: "Warren, OH",
  },
  {
    zip: "44482",
    ST: "OH",
    cityWithStateAbbr: "Warren, OH",
  },
  {
    zip: "44483",
    ST: "OH",
    cityWithStateAbbr: "Warren, OH",
  },
  {
    zip: "44484",
    ST: "OH",
    cityWithStateAbbr: "Warren, OH",
  },
  {
    zip: "44485",
    ST: "OH",
    cityWithStateAbbr: "Warren, OH",
  },
  {
    zip: "44486",
    ST: "OH",
    cityWithStateAbbr: "Warren, OH",
  },
  {
    zip: "44490",
    ST: "OH",
    cityWithStateAbbr: "Washingtonville, OH",
  },
  {
    zip: "44491",
    ST: "OH",
    cityWithStateAbbr: "West Farmington, OH",
  },
  {
    zip: "44492",
    ST: "OH",
    cityWithStateAbbr: "West Point, OH",
  },
  {
    zip: "44493",
    ST: "OH",
    cityWithStateAbbr: "Winona, OH",
  },
  {
    zip: "44501",
    ST: "OH",
    cityWithStateAbbr: "Youngstown, OH",
  },
  {
    zip: "44502",
    ST: "OH",
    cityWithStateAbbr: "Youngstown, OH",
  },
  {
    zip: "44503",
    ST: "OH",
    cityWithStateAbbr: "Youngstown, OH",
  },
  {
    zip: "44504",
    ST: "OH",
    cityWithStateAbbr: "Youngstown, OH",
  },
  {
    zip: "44505",
    ST: "OH",
    cityWithStateAbbr: "Youngstown, OH",
  },
  {
    zip: "44506",
    ST: "OH",
    cityWithStateAbbr: "Youngstown, OH",
  },
  {
    zip: "44507",
    ST: "OH",
    cityWithStateAbbr: "Youngstown, OH",
  },
  {
    zip: "44509",
    ST: "OH",
    cityWithStateAbbr: "Youngstown, OH",
  },
  {
    zip: "44510",
    ST: "OH",
    cityWithStateAbbr: "Youngstown, OH",
  },
  {
    zip: "44511",
    ST: "OH",
    cityWithStateAbbr: "Youngstown, OH",
  },
  {
    zip: "44512",
    ST: "OH",
    cityWithStateAbbr: "Youngstown, OH",
  },
  {
    zip: "44513",
    ST: "OH",
    cityWithStateAbbr: "Youngstown, OH",
  },
  {
    zip: "44514",
    ST: "OH",
    cityWithStateAbbr: "Youngstown, OH",
  },
  {
    zip: "44515",
    ST: "OH",
    cityWithStateAbbr: "Youngstown, OH",
  },
  {
    zip: "44555",
    ST: "OH",
    cityWithStateAbbr: "Youngstown, OH",
  },
  {
    zip: "44601",
    ST: "OH",
    cityWithStateAbbr: "Alliance, OH",
  },
  {
    zip: "44606",
    ST: "OH",
    cityWithStateAbbr: "Apple Creek, OH",
  },
  {
    zip: "44607",
    ST: "OH",
    cityWithStateAbbr: "Augusta, OH",
  },
  {
    zip: "44608",
    ST: "OH",
    cityWithStateAbbr: "Beach City, OH",
  },
  {
    zip: "44609",
    ST: "OH",
    cityWithStateAbbr: "Beloit, OH",
  },
  {
    zip: "44610",
    ST: "OH",
    cityWithStateAbbr: "Berlin, OH",
  },
  {
    zip: "44611",
    ST: "OH",
    cityWithStateAbbr: "Big Prairie, OH",
  },
  {
    zip: "44612",
    ST: "OH",
    cityWithStateAbbr: "Bolivar, OH",
  },
  {
    zip: "44613",
    ST: "OH",
    cityWithStateAbbr: "Brewster, OH",
  },
  {
    zip: "44614",
    ST: "OH",
    cityWithStateAbbr: "Canal Fulton, OH",
  },
  {
    zip: "44615",
    ST: "OH",
    cityWithStateAbbr: "Carrollton, OH",
  },
  {
    zip: "44617",
    ST: "OH",
    cityWithStateAbbr: "Charm, OH",
  },
  {
    zip: "44618",
    ST: "OH",
    cityWithStateAbbr: "Dalton, OH",
  },
  {
    zip: "44619",
    ST: "OH",
    cityWithStateAbbr: "Damascus, OH",
  },
  {
    zip: "44620",
    ST: "OH",
    cityWithStateAbbr: "Dellroy, OH",
  },
  {
    zip: "44621",
    ST: "OH",
    cityWithStateAbbr: "Dennison, OH",
  },
  {
    zip: "44622",
    ST: "OH",
    cityWithStateAbbr: "Dover, OH",
  },
  {
    zip: "44624",
    ST: "OH",
    cityWithStateAbbr: "Dundee, OH",
  },
  {
    zip: "44625",
    ST: "OH",
    cityWithStateAbbr: "East Rochester, OH",
  },
  {
    zip: "44626",
    ST: "OH",
    cityWithStateAbbr: "East Sparta, OH",
  },
  {
    zip: "44627",
    ST: "OH",
    cityWithStateAbbr: "Fredericksburg, OH",
  },
  {
    zip: "44628",
    ST: "OH",
    cityWithStateAbbr: "Glenmont, OH",
  },
  {
    zip: "44629",
    ST: "OH",
    cityWithStateAbbr: "Gnadenhutten, OH",
  },
  {
    zip: "44630",
    ST: "OH",
    cityWithStateAbbr: "Greentown, OH",
  },
  {
    zip: "44632",
    ST: "OH",
    cityWithStateAbbr: "Hartville, OH",
  },
  {
    zip: "44633",
    ST: "OH",
    cityWithStateAbbr: "Holmesville, OH",
  },
  {
    zip: "44634",
    ST: "OH",
    cityWithStateAbbr: "Homeworth, OH",
  },
  {
    zip: "44636",
    ST: "OH",
    cityWithStateAbbr: "Kidron, OH",
  },
  {
    zip: "44637",
    ST: "OH",
    cityWithStateAbbr: "Killbuck, OH",
  },
  {
    zip: "44638",
    ST: "OH",
    cityWithStateAbbr: "Lakeville, OH",
  },
  {
    zip: "44639",
    ST: "OH",
    cityWithStateAbbr: "Leesville, OH",
  },
  {
    zip: "44640",
    ST: "OH",
    cityWithStateAbbr: "Limaville, OH",
  },
  {
    zip: "44641",
    ST: "OH",
    cityWithStateAbbr: "Louisville, OH",
  },
  {
    zip: "44643",
    ST: "OH",
    cityWithStateAbbr: "Magnolia, OH",
  },
  {
    zip: "44644",
    ST: "OH",
    cityWithStateAbbr: "Malvern, OH",
  },
  {
    zip: "44645",
    ST: "OH",
    cityWithStateAbbr: "Marshallville, OH",
  },
  {
    zip: "44646",
    ST: "OH",
    cityWithStateAbbr: "Massillon, OH",
  },
  {
    zip: "44647",
    ST: "OH",
    cityWithStateAbbr: "Massillon, OH",
  },
  {
    zip: "44648",
    ST: "OH",
    cityWithStateAbbr: "Massillon, OH",
  },
  {
    zip: "44650",
    ST: "OH",
    cityWithStateAbbr: "Maximo, OH",
  },
  {
    zip: "44651",
    ST: "OH",
    cityWithStateAbbr: "Mechanicstown, OH",
  },
  {
    zip: "44652",
    ST: "OH",
    cityWithStateAbbr: "Middlebranch, OH",
  },
  {
    zip: "44653",
    ST: "OH",
    cityWithStateAbbr: "Midvale, OH",
  },
  {
    zip: "44654",
    ST: "OH",
    cityWithStateAbbr: "Millersburg, OH",
  },
  {
    zip: "44656",
    ST: "OH",
    cityWithStateAbbr: "Mineral City, OH",
  },
  {
    zip: "44657",
    ST: "OH",
    cityWithStateAbbr: "Minerva, OH",
  },
  {
    zip: "44659",
    ST: "OH",
    cityWithStateAbbr: "Mount Eaton, OH",
  },
  {
    zip: "44660",
    ST: "OH",
    cityWithStateAbbr: "Mount Hope, OH",
  },
  {
    zip: "44661",
    ST: "OH",
    cityWithStateAbbr: "Nashville, OH",
  },
  {
    zip: "44662",
    ST: "OH",
    cityWithStateAbbr: "Navarre, OH",
  },
  {
    zip: "44663",
    ST: "OH",
    cityWithStateAbbr: "New Philadelphia, OH",
  },
  {
    zip: "44665",
    ST: "OH",
    cityWithStateAbbr: "North Georgetown, OH",
  },
  {
    zip: "44666",
    ST: "OH",
    cityWithStateAbbr: "North Lawrence, OH",
  },
  {
    zip: "44667",
    ST: "OH",
    cityWithStateAbbr: "Orrville, OH",
  },
  {
    zip: "44669",
    ST: "OH",
    cityWithStateAbbr: "Paris, OH",
  },
  {
    zip: "44670",
    ST: "OH",
    cityWithStateAbbr: "Robertsville, OH",
  },
  {
    zip: "44671",
    ST: "OH",
    cityWithStateAbbr: "Sandyville, OH",
  },
  {
    zip: "44672",
    ST: "OH",
    cityWithStateAbbr: "Sebring, OH",
  },
  {
    zip: "44675",
    ST: "OH",
    cityWithStateAbbr: "Sherrodsville, OH",
  },
  {
    zip: "44676",
    ST: "OH",
    cityWithStateAbbr: "Shreve, OH",
  },
  {
    zip: "44677",
    ST: "OH",
    cityWithStateAbbr: "Smithville, OH",
  },
  {
    zip: "44678",
    ST: "OH",
    cityWithStateAbbr: "Somerdale, OH",
  },
  {
    zip: "44679",
    ST: "OH",
    cityWithStateAbbr: "Stillwater, OH",
  },
  {
    zip: "44680",
    ST: "OH",
    cityWithStateAbbr: "Strasburg, OH",
  },
  {
    zip: "44681",
    ST: "OH",
    cityWithStateAbbr: "Sugarcreek, OH",
  },
  {
    zip: "44682",
    ST: "OH",
    cityWithStateAbbr: "Tuscarawas, OH",
  },
  {
    zip: "44683",
    ST: "OH",
    cityWithStateAbbr: "Uhrichsville, OH",
  },
  {
    zip: "44685",
    ST: "OH",
    cityWithStateAbbr: "Uniontown, OH",
  },
  {
    zip: "44687",
    ST: "OH",
    cityWithStateAbbr: "Walnut Creek, OH",
  },
  {
    zip: "44688",
    ST: "OH",
    cityWithStateAbbr: "Waynesburg, OH",
  },
  {
    zip: "44689",
    ST: "OH",
    cityWithStateAbbr: "Wilmot, OH",
  },
  {
    zip: "44690",
    ST: "OH",
    cityWithStateAbbr: "Winesburg, OH",
  },
  {
    zip: "44691",
    ST: "OH",
    cityWithStateAbbr: "Wooster, OH",
  },
  {
    zip: "44693",
    ST: "OH",
    cityWithStateAbbr: "Deersville, OH",
  },
  {
    zip: "44695",
    ST: "OH",
    cityWithStateAbbr: "Bowerston, OH",
  },
  {
    zip: "44697",
    ST: "OH",
    cityWithStateAbbr: "Zoar, OH",
  },
  {
    zip: "44699",
    ST: "OH",
    cityWithStateAbbr: "Tippecanoe, OH",
  },
  {
    zip: "44701",
    ST: "OH",
    cityWithStateAbbr: "Canton, OH",
  },
  {
    zip: "44702",
    ST: "OH",
    cityWithStateAbbr: "Canton, OH",
  },
  {
    zip: "44703",
    ST: "OH",
    cityWithStateAbbr: "Canton, OH",
  },
  {
    zip: "44704",
    ST: "OH",
    cityWithStateAbbr: "Canton, OH",
  },
  {
    zip: "44705",
    ST: "OH",
    cityWithStateAbbr: "Canton, OH",
  },
  {
    zip: "44706",
    ST: "OH",
    cityWithStateAbbr: "Canton, OH",
  },
  {
    zip: "44707",
    ST: "OH",
    cityWithStateAbbr: "Canton, OH",
  },
  {
    zip: "44708",
    ST: "OH",
    cityWithStateAbbr: "Canton, OH",
  },
  {
    zip: "44709",
    ST: "OH",
    cityWithStateAbbr: "Canton, OH",
  },
  {
    zip: "44710",
    ST: "OH",
    cityWithStateAbbr: "Canton, OH",
  },
  {
    zip: "44711",
    ST: "OH",
    cityWithStateAbbr: "Canton, OH",
  },
  {
    zip: "44714",
    ST: "OH",
    cityWithStateAbbr: "Canton, OH",
  },
  {
    zip: "44718",
    ST: "OH",
    cityWithStateAbbr: "Canton, OH",
  },
  {
    zip: "44720",
    ST: "OH",
    cityWithStateAbbr: "North Canton, OH",
  },
  {
    zip: "44721",
    ST: "OH",
    cityWithStateAbbr: "Canton, OH",
  },
  {
    zip: "44730",
    ST: "OH",
    cityWithStateAbbr: "East Canton, OH",
  },
  {
    zip: "44735",
    ST: "OH",
    cityWithStateAbbr: "Canton, OH",
  },
  {
    zip: "44750",
    ST: "OH",
    cityWithStateAbbr: "Canton, OH",
  },
  {
    zip: "44767",
    ST: "OH",
    cityWithStateAbbr: "Canton, OH",
  },
  {
    zip: "44799",
    ST: "OH",
    cityWithStateAbbr: "Canton, OH",
  },
  {
    zip: "44802",
    ST: "OH",
    cityWithStateAbbr: "Alvada, OH",
  },
  {
    zip: "44804",
    ST: "OH",
    cityWithStateAbbr: "Arcadia, OH",
  },
  {
    zip: "44805",
    ST: "OH",
    cityWithStateAbbr: "Ashland, OH",
  },
  {
    zip: "44807",
    ST: "OH",
    cityWithStateAbbr: "Attica, OH",
  },
  {
    zip: "44809",
    ST: "OH",
    cityWithStateAbbr: "Bascom, OH",
  },
  {
    zip: "44811",
    ST: "OH",
    cityWithStateAbbr: "Bellevue, OH",
  },
  {
    zip: "44813",
    ST: "OH",
    cityWithStateAbbr: "Bellville, OH",
  },
  {
    zip: "44814",
    ST: "OH",
    cityWithStateAbbr: "Berlin Heights, OH",
  },
  {
    zip: "44815",
    ST: "OH",
    cityWithStateAbbr: "Bettsville, OH",
  },
  {
    zip: "44816",
    ST: "OH",
    cityWithStateAbbr: "Birmingham, OH",
  },
  {
    zip: "44817",
    ST: "OH",
    cityWithStateAbbr: "Bloomdale, OH",
  },
  {
    zip: "44818",
    ST: "OH",
    cityWithStateAbbr: "Bloomville, OH",
  },
  {
    zip: "44820",
    ST: "OH",
    cityWithStateAbbr: "Bucyrus, OH",
  },
  {
    zip: "44822",
    ST: "OH",
    cityWithStateAbbr: "Butler, OH",
  },
  {
    zip: "44824",
    ST: "OH",
    cityWithStateAbbr: "Castalia, OH",
  },
  {
    zip: "44825",
    ST: "OH",
    cityWithStateAbbr: "Chatfield, OH",
  },
  {
    zip: "44826",
    ST: "OH",
    cityWithStateAbbr: "Collins, OH",
  },
  {
    zip: "44827",
    ST: "OH",
    cityWithStateAbbr: "Crestline, OH",
  },
  {
    zip: "44828",
    ST: "OH",
    cityWithStateAbbr: "Flat Rock, OH",
  },
  {
    zip: "44830",
    ST: "OH",
    cityWithStateAbbr: "Fostoria, OH",
  },
  {
    zip: "44833",
    ST: "OH",
    cityWithStateAbbr: "Galion, OH",
  },
  {
    zip: "44836",
    ST: "OH",
    cityWithStateAbbr: "Green Springs, OH",
  },
  {
    zip: "44837",
    ST: "OH",
    cityWithStateAbbr: "Greenwich, OH",
  },
  {
    zip: "44838",
    ST: "OH",
    cityWithStateAbbr: "Hayesville, OH",
  },
  {
    zip: "44839",
    ST: "OH",
    cityWithStateAbbr: "Huron, OH",
  },
  {
    zip: "44840",
    ST: "OH",
    cityWithStateAbbr: "Jeromesville, OH",
  },
  {
    zip: "44841",
    ST: "OH",
    cityWithStateAbbr: "Kansas, OH",
  },
  {
    zip: "44842",
    ST: "OH",
    cityWithStateAbbr: "Loudonville, OH",
  },
  {
    zip: "44843",
    ST: "OH",
    cityWithStateAbbr: "Lucas, OH",
  },
  {
    zip: "44844",
    ST: "OH",
    cityWithStateAbbr: "Mc Cutchenville, OH",
  },
  {
    zip: "44845",
    ST: "OH",
    cityWithStateAbbr: "Melmore, OH",
  },
  {
    zip: "44846",
    ST: "OH",
    cityWithStateAbbr: "Milan, OH",
  },
  {
    zip: "44847",
    ST: "OH",
    cityWithStateAbbr: "Monroeville, OH",
  },
  {
    zip: "44848",
    ST: "OH",
    cityWithStateAbbr: "Nankin, OH",
  },
  {
    zip: "44849",
    ST: "OH",
    cityWithStateAbbr: "Nevada, OH",
  },
  {
    zip: "44850",
    ST: "OH",
    cityWithStateAbbr: "New Haven, OH",
  },
  {
    zip: "44851",
    ST: "OH",
    cityWithStateAbbr: "New London, OH",
  },
  {
    zip: "44853",
    ST: "OH",
    cityWithStateAbbr: "New Riegel, OH",
  },
  {
    zip: "44854",
    ST: "OH",
    cityWithStateAbbr: "New Washington, OH",
  },
  {
    zip: "44855",
    ST: "OH",
    cityWithStateAbbr: "North Fairfield, OH",
  },
  {
    zip: "44856",
    ST: "OH",
    cityWithStateAbbr: "North Robinson, OH",
  },
  {
    zip: "44857",
    ST: "OH",
    cityWithStateAbbr: "Norwalk, OH",
  },
  {
    zip: "44859",
    ST: "OH",
    cityWithStateAbbr: "Nova, OH",
  },
  {
    zip: "44860",
    ST: "OH",
    cityWithStateAbbr: "Oceola, OH",
  },
  {
    zip: "44861",
    ST: "OH",
    cityWithStateAbbr: "Old Fort, OH",
  },
  {
    zip: "44862",
    ST: "OH",
    cityWithStateAbbr: "Ontario, OH",
  },
  {
    zip: "44864",
    ST: "OH",
    cityWithStateAbbr: "Perrysville, OH",
  },
  {
    zip: "44865",
    ST: "OH",
    cityWithStateAbbr: "Plymouth, OH",
  },
  {
    zip: "44866",
    ST: "OH",
    cityWithStateAbbr: "Polk, OH",
  },
  {
    zip: "44867",
    ST: "OH",
    cityWithStateAbbr: "Republic, OH",
  },
  {
    zip: "44870",
    ST: "OH",
    cityWithStateAbbr: "Sandusky, OH",
  },
  {
    zip: "44871",
    ST: "OH",
    cityWithStateAbbr: "Sandusky, OH",
  },
  {
    zip: "44874",
    ST: "OH",
    cityWithStateAbbr: "Savannah, OH",
  },
  {
    zip: "44875",
    ST: "OH",
    cityWithStateAbbr: "Shelby, OH",
  },
  {
    zip: "44878",
    ST: "OH",
    cityWithStateAbbr: "Shiloh, OH",
  },
  {
    zip: "44880",
    ST: "OH",
    cityWithStateAbbr: "Sullivan, OH",
  },
  {
    zip: "44881",
    ST: "OH",
    cityWithStateAbbr: "Sulphur Springs, OH",
  },
  {
    zip: "44882",
    ST: "OH",
    cityWithStateAbbr: "Sycamore, OH",
  },
  {
    zip: "44883",
    ST: "OH",
    cityWithStateAbbr: "Tiffin, OH",
  },
  {
    zip: "44887",
    ST: "OH",
    cityWithStateAbbr: "Tiro, OH",
  },
  {
    zip: "44888",
    ST: "OH",
    cityWithStateAbbr: "Willard, OH",
  },
  {
    zip: "44889",
    ST: "OH",
    cityWithStateAbbr: "Wakeman, OH",
  },
  {
    zip: "44890",
    ST: "OH",
    cityWithStateAbbr: "Willard, OH",
  },
  {
    zip: "44901",
    ST: "OH",
    cityWithStateAbbr: "Mansfield, OH",
  },
  {
    zip: "44902",
    ST: "OH",
    cityWithStateAbbr: "Mansfield, OH",
  },
  {
    zip: "44903",
    ST: "OH",
    cityWithStateAbbr: "Mansfield, OH",
  },
  {
    zip: "44904",
    ST: "OH",
    cityWithStateAbbr: "Mansfield, OH",
  },
  {
    zip: "44905",
    ST: "OH",
    cityWithStateAbbr: "Mansfield, OH",
  },
  {
    zip: "44906",
    ST: "OH",
    cityWithStateAbbr: "Mansfield, OH",
  },
  {
    zip: "44907",
    ST: "OH",
    cityWithStateAbbr: "Mansfield, OH",
  },
  {
    zip: "45001",
    ST: "OH",
    cityWithStateAbbr: "Addyston, OH",
  },
  {
    zip: "45002",
    ST: "OH",
    cityWithStateAbbr: "Cleves, OH",
  },
  {
    zip: "45003",
    ST: "OH",
    cityWithStateAbbr: "College Corner, OH",
  },
  {
    zip: "45004",
    ST: "OH",
    cityWithStateAbbr: "Collinsville, OH",
  },
  {
    zip: "45005",
    ST: "OH",
    cityWithStateAbbr: "Franklin, OH",
  },
  {
    zip: "45011",
    ST: "OH",
    cityWithStateAbbr: "Hamilton, OH",
  },
  {
    zip: "45012",
    ST: "OH",
    cityWithStateAbbr: "Hamilton, OH",
  },
  {
    zip: "45013",
    ST: "OH",
    cityWithStateAbbr: "Hamilton, OH",
  },
  {
    zip: "45014",
    ST: "OH",
    cityWithStateAbbr: "Fairfield, OH",
  },
  {
    zip: "45015",
    ST: "OH",
    cityWithStateAbbr: "Hamilton, OH",
  },
  {
    zip: "45018",
    ST: "OH",
    cityWithStateAbbr: "Fairfield, OH",
  },
  {
    zip: "45025",
    ST: "OH",
    cityWithStateAbbr: "Hamilton, OH",
  },
  {
    zip: "45026",
    ST: "OH",
    cityWithStateAbbr: "Hamilton, OH",
  },
  {
    zip: "45030",
    ST: "OH",
    cityWithStateAbbr: "Harrison, OH",
  },
  {
    zip: "45032",
    ST: "OH",
    cityWithStateAbbr: "Harveysburg, OH",
  },
  {
    zip: "45033",
    ST: "OH",
    cityWithStateAbbr: "Hooven, OH",
  },
  {
    zip: "45034",
    ST: "OH",
    cityWithStateAbbr: "Kings Mills, OH",
  },
  {
    zip: "45036",
    ST: "OH",
    cityWithStateAbbr: "Lebanon, OH",
  },
  {
    zip: "45039",
    ST: "OH",
    cityWithStateAbbr: "Maineville, OH",
  },
  {
    zip: "45040",
    ST: "OH",
    cityWithStateAbbr: "Mason, OH",
  },
  {
    zip: "45041",
    ST: "OH",
    cityWithStateAbbr: "Miamitown, OH",
  },
  {
    zip: "45042",
    ST: "OH",
    cityWithStateAbbr: "Middletown, OH",
  },
  {
    zip: "45043",
    ST: "OH",
    cityWithStateAbbr: "Middletown, OH",
  },
  {
    zip: "45044",
    ST: "OH",
    cityWithStateAbbr: "Middletown, OH",
  },
  {
    zip: "45050",
    ST: "OH",
    cityWithStateAbbr: "Monroe, OH",
  },
  {
    zip: "45051",
    ST: "OH",
    cityWithStateAbbr: "Mount Saint Joseph, OH",
  },
  {
    zip: "45052",
    ST: "OH",
    cityWithStateAbbr: "North Bend, OH",
  },
  {
    zip: "45053",
    ST: "OH",
    cityWithStateAbbr: "Okeana, OH",
  },
  {
    zip: "45054",
    ST: "OH",
    cityWithStateAbbr: "Oregonia, OH",
  },
  {
    zip: "45055",
    ST: "OH",
    cityWithStateAbbr: "Overpeck, OH",
  },
  {
    zip: "45056",
    ST: "OH",
    cityWithStateAbbr: "Oxford, OH",
  },
  {
    zip: "45061",
    ST: "OH",
    cityWithStateAbbr: "Ross, OH",
  },
  {
    zip: "45062",
    ST: "OH",
    cityWithStateAbbr: "Seven Mile, OH",
  },
  {
    zip: "45063",
    ST: "OH",
    cityWithStateAbbr: "Shandon, OH",
  },
  {
    zip: "45064",
    ST: "OH",
    cityWithStateAbbr: "Somerville, OH",
  },
  {
    zip: "45065",
    ST: "OH",
    cityWithStateAbbr: "South Lebanon, OH",
  },
  {
    zip: "45066",
    ST: "OH",
    cityWithStateAbbr: "Springboro, OH",
  },
  {
    zip: "45067",
    ST: "OH",
    cityWithStateAbbr: "Trenton, OH",
  },
  {
    zip: "45068",
    ST: "OH",
    cityWithStateAbbr: "Waynesville, OH",
  },
  {
    zip: "45069",
    ST: "OH",
    cityWithStateAbbr: "West Chester, OH",
  },
  {
    zip: "45070",
    ST: "OH",
    cityWithStateAbbr: "West Elkton, OH",
  },
  {
    zip: "45071",
    ST: "OH",
    cityWithStateAbbr: "West Chester, OH",
  },
  {
    zip: "45101",
    ST: "OH",
    cityWithStateAbbr: "Aberdeen, OH",
  },
  {
    zip: "45102",
    ST: "OH",
    cityWithStateAbbr: "Amelia, OH",
  },
  {
    zip: "45103",
    ST: "OH",
    cityWithStateAbbr: "Batavia, OH",
  },
  {
    zip: "45105",
    ST: "OH",
    cityWithStateAbbr: "Bentonville, OH",
  },
  {
    zip: "45106",
    ST: "OH",
    cityWithStateAbbr: "Bethel, OH",
  },
  {
    zip: "45107",
    ST: "OH",
    cityWithStateAbbr: "Blanchester, OH",
  },
  {
    zip: "45110",
    ST: "OH",
    cityWithStateAbbr: "Buford, OH",
  },
  {
    zip: "45111",
    ST: "OH",
    cityWithStateAbbr: "Camp Dennison, OH",
  },
  {
    zip: "45112",
    ST: "OH",
    cityWithStateAbbr: "Chilo, OH",
  },
  {
    zip: "45113",
    ST: "OH",
    cityWithStateAbbr: "Clarksville, OH",
  },
  {
    zip: "45114",
    ST: "OH",
    cityWithStateAbbr: "Cuba, OH",
  },
  {
    zip: "45115",
    ST: "OH",
    cityWithStateAbbr: "Decatur, OH",
  },
  {
    zip: "45118",
    ST: "OH",
    cityWithStateAbbr: "Fayetteville, OH",
  },
  {
    zip: "45119",
    ST: "OH",
    cityWithStateAbbr: "Feesburg, OH",
  },
  {
    zip: "45120",
    ST: "OH",
    cityWithStateAbbr: "Felicity, OH",
  },
  {
    zip: "45121",
    ST: "OH",
    cityWithStateAbbr: "Georgetown, OH",
  },
  {
    zip: "45122",
    ST: "OH",
    cityWithStateAbbr: "Goshen, OH",
  },
  {
    zip: "45123",
    ST: "OH",
    cityWithStateAbbr: "Greenfield, OH",
  },
  {
    zip: "45130",
    ST: "OH",
    cityWithStateAbbr: "Hamersville, OH",
  },
  {
    zip: "45131",
    ST: "OH",
    cityWithStateAbbr: "Higginsport, OH",
  },
  {
    zip: "45132",
    ST: "OH",
    cityWithStateAbbr: "Highland, OH",
  },
  {
    zip: "45133",
    ST: "OH",
    cityWithStateAbbr: "Hillsboro, OH",
  },
  {
    zip: "45135",
    ST: "OH",
    cityWithStateAbbr: "Leesburg, OH",
  },
  {
    zip: "45138",
    ST: "OH",
    cityWithStateAbbr: "Lees Creek, OH",
  },
  {
    zip: "45140",
    ST: "OH",
    cityWithStateAbbr: "Loveland, OH",
  },
  {
    zip: "45142",
    ST: "OH",
    cityWithStateAbbr: "Lynchburg, OH",
  },
  {
    zip: "45144",
    ST: "OH",
    cityWithStateAbbr: "Manchester, OH",
  },
  {
    zip: "45145",
    ST: "OH",
    cityWithStateAbbr: "Marathon, OH",
  },
  {
    zip: "45146",
    ST: "OH",
    cityWithStateAbbr: "Martinsville, OH",
  },
  {
    zip: "45147",
    ST: "OH",
    cityWithStateAbbr: "Miamiville, OH",
  },
  {
    zip: "45148",
    ST: "OH",
    cityWithStateAbbr: "Midland, OH",
  },
  {
    zip: "45150",
    ST: "OH",
    cityWithStateAbbr: "Milford, OH",
  },
  {
    zip: "45152",
    ST: "OH",
    cityWithStateAbbr: "Morrow, OH",
  },
  {
    zip: "45153",
    ST: "OH",
    cityWithStateAbbr: "Moscow, OH",
  },
  {
    zip: "45154",
    ST: "OH",
    cityWithStateAbbr: "Mount Orab, OH",
  },
  {
    zip: "45155",
    ST: "OH",
    cityWithStateAbbr: "Mowrystown, OH",
  },
  {
    zip: "45156",
    ST: "OH",
    cityWithStateAbbr: "Neville, OH",
  },
  {
    zip: "45157",
    ST: "OH",
    cityWithStateAbbr: "New Richmond, OH",
  },
  {
    zip: "45158",
    ST: "OH",
    cityWithStateAbbr: "Newtonsville, OH",
  },
  {
    zip: "45159",
    ST: "OH",
    cityWithStateAbbr: "New Vienna, OH",
  },
  {
    zip: "45160",
    ST: "OH",
    cityWithStateAbbr: "Owensville, OH",
  },
  {
    zip: "45162",
    ST: "OH",
    cityWithStateAbbr: "Pleasant Plain, OH",
  },
  {
    zip: "45164",
    ST: "OH",
    cityWithStateAbbr: "Port William, OH",
  },
  {
    zip: "45166",
    ST: "OH",
    cityWithStateAbbr: "Reesville, OH",
  },
  {
    zip: "45167",
    ST: "OH",
    cityWithStateAbbr: "Ripley, OH",
  },
  {
    zip: "45168",
    ST: "OH",
    cityWithStateAbbr: "Russellville, OH",
  },
  {
    zip: "45169",
    ST: "OH",
    cityWithStateAbbr: "Sabina, OH",
  },
  {
    zip: "45171",
    ST: "OH",
    cityWithStateAbbr: "Sardinia, OH",
  },
  {
    zip: "45172",
    ST: "OH",
    cityWithStateAbbr: "Sinking Spring, OH",
  },
  {
    zip: "45174",
    ST: "OH",
    cityWithStateAbbr: "Terrace Park, OH",
  },
  {
    zip: "45176",
    ST: "OH",
    cityWithStateAbbr: "Williamsburg, OH",
  },
  {
    zip: "45177",
    ST: "OH",
    cityWithStateAbbr: "Wilmington, OH",
  },
  {
    zip: "45201",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45202",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45203",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45204",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45205",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45206",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45207",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45208",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45209",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45211",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45212",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45213",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45214",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45215",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45216",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45217",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45218",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45219",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45220",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45221",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45222",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45223",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45224",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45225",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45226",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45227",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45229",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45230",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45231",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45232",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45233",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45234",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45235",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45236",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45237",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45238",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45239",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45240",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45241",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45242",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45243",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45244",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45245",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45246",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45247",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45248",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45249",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45250",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45251",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45252",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45253",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45254",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45255",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45258",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45262",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45263",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45264",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45267",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45268",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45269",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45270",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45271",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45273",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45274",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45275",
    ST: "KY",
    cityWithStateAbbr: "Cincinnati, KY",
  },
  {
    zip: "45277",
    ST: "KY",
    cityWithStateAbbr: "Cincinnati, KY",
  },
  {
    zip: "45280",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45296",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45298",
    ST: "KY",
    cityWithStateAbbr: "Cincinnati, KY",
  },
  {
    zip: "45299",
    ST: "OH",
    cityWithStateAbbr: "Cincinnati, OH",
  },
  {
    zip: "45301",
    ST: "OH",
    cityWithStateAbbr: "Alpha, OH",
  },
  {
    zip: "45302",
    ST: "OH",
    cityWithStateAbbr: "Anna, OH",
  },
  {
    zip: "45303",
    ST: "OH",
    cityWithStateAbbr: "Ansonia, OH",
  },
  {
    zip: "45304",
    ST: "OH",
    cityWithStateAbbr: "Arcanum, OH",
  },
  {
    zip: "45305",
    ST: "OH",
    cityWithStateAbbr: "Bellbrook, OH",
  },
  {
    zip: "45306",
    ST: "OH",
    cityWithStateAbbr: "Botkins, OH",
  },
  {
    zip: "45307",
    ST: "OH",
    cityWithStateAbbr: "Bowersville, OH",
  },
  {
    zip: "45308",
    ST: "OH",
    cityWithStateAbbr: "Bradford, OH",
  },
  {
    zip: "45309",
    ST: "OH",
    cityWithStateAbbr: "Brookville, OH",
  },
  {
    zip: "45310",
    ST: "OH",
    cityWithStateAbbr: "Burkettsville, OH",
  },
  {
    zip: "45311",
    ST: "OH",
    cityWithStateAbbr: "Camden, OH",
  },
  {
    zip: "45312",
    ST: "OH",
    cityWithStateAbbr: "Casstown, OH",
  },
  {
    zip: "45314",
    ST: "OH",
    cityWithStateAbbr: "Cedarville, OH",
  },
  {
    zip: "45315",
    ST: "OH",
    cityWithStateAbbr: "Clayton, OH",
  },
  {
    zip: "45316",
    ST: "OH",
    cityWithStateAbbr: "Clifton, OH",
  },
  {
    zip: "45317",
    ST: "OH",
    cityWithStateAbbr: "Conover, OH",
  },
  {
    zip: "45318",
    ST: "OH",
    cityWithStateAbbr: "Covington, OH",
  },
  {
    zip: "45319",
    ST: "OH",
    cityWithStateAbbr: "Donnelsville, OH",
  },
  {
    zip: "45320",
    ST: "OH",
    cityWithStateAbbr: "Eaton, OH",
  },
  {
    zip: "45321",
    ST: "OH",
    cityWithStateAbbr: "Eldorado, OH",
  },
  {
    zip: "45322",
    ST: "OH",
    cityWithStateAbbr: "Englewood, OH",
  },
  {
    zip: "45323",
    ST: "OH",
    cityWithStateAbbr: "Enon, OH",
  },
  {
    zip: "45324",
    ST: "OH",
    cityWithStateAbbr: "Fairborn, OH",
  },
  {
    zip: "45325",
    ST: "OH",
    cityWithStateAbbr: "Farmersville, OH",
  },
  {
    zip: "45326",
    ST: "OH",
    cityWithStateAbbr: "Fletcher, OH",
  },
  {
    zip: "45327",
    ST: "OH",
    cityWithStateAbbr: "Germantown, OH",
  },
  {
    zip: "45328",
    ST: "OH",
    cityWithStateAbbr: "Gettysburg, OH",
  },
  {
    zip: "45330",
    ST: "OH",
    cityWithStateAbbr: "Gratis, OH",
  },
  {
    zip: "45331",
    ST: "OH",
    cityWithStateAbbr: "Greenville, OH",
  },
  {
    zip: "45332",
    ST: "OH",
    cityWithStateAbbr: "Hollansburg, OH",
  },
  {
    zip: "45333",
    ST: "OH",
    cityWithStateAbbr: "Houston, OH",
  },
  {
    zip: "45334",
    ST: "OH",
    cityWithStateAbbr: "Jackson Center, OH",
  },
  {
    zip: "45335",
    ST: "OH",
    cityWithStateAbbr: "Jamestown, OH",
  },
  {
    zip: "45336",
    ST: "OH",
    cityWithStateAbbr: "Kettlersville, OH",
  },
  {
    zip: "45337",
    ST: "OH",
    cityWithStateAbbr: "Laura, OH",
  },
  {
    zip: "45338",
    ST: "OH",
    cityWithStateAbbr: "Lewisburg, OH",
  },
  {
    zip: "45339",
    ST: "OH",
    cityWithStateAbbr: "Ludlow Falls, OH",
  },
  {
    zip: "45340",
    ST: "OH",
    cityWithStateAbbr: "Maplewood, OH",
  },
  {
    zip: "45341",
    ST: "OH",
    cityWithStateAbbr: "Medway, OH",
  },
  {
    zip: "45342",
    ST: "OH",
    cityWithStateAbbr: "Miamisburg, OH",
  },
  {
    zip: "45343",
    ST: "OH",
    cityWithStateAbbr: "Miamisburg, OH",
  },
  {
    zip: "45344",
    ST: "OH",
    cityWithStateAbbr: "New Carlisle, OH",
  },
  {
    zip: "45345",
    ST: "OH",
    cityWithStateAbbr: "New Lebanon, OH",
  },
  {
    zip: "45346",
    ST: "OH",
    cityWithStateAbbr: "New Madison, OH",
  },
  {
    zip: "45347",
    ST: "OH",
    cityWithStateAbbr: "New Paris, OH",
  },
  {
    zip: "45348",
    ST: "OH",
    cityWithStateAbbr: "New Weston, OH",
  },
  {
    zip: "45349",
    ST: "OH",
    cityWithStateAbbr: "North Hampton, OH",
  },
  {
    zip: "45350",
    ST: "OH",
    cityWithStateAbbr: "North Star, OH",
  },
  {
    zip: "45351",
    ST: "OH",
    cityWithStateAbbr: "Osgood, OH",
  },
  {
    zip: "45352",
    ST: "OH",
    cityWithStateAbbr: "Palestine, OH",
  },
  {
    zip: "45353",
    ST: "OH",
    cityWithStateAbbr: "Pemberton, OH",
  },
  {
    zip: "45354",
    ST: "OH",
    cityWithStateAbbr: "Phillipsburg, OH",
  },
  {
    zip: "45356",
    ST: "OH",
    cityWithStateAbbr: "Piqua, OH",
  },
  {
    zip: "45358",
    ST: "OH",
    cityWithStateAbbr: "Pitsburg, OH",
  },
  {
    zip: "45359",
    ST: "OH",
    cityWithStateAbbr: "Pleasant Hill, OH",
  },
  {
    zip: "45360",
    ST: "OH",
    cityWithStateAbbr: "Port Jefferson, OH",
  },
  {
    zip: "45361",
    ST: "OH",
    cityWithStateAbbr: "Potsdam, OH",
  },
  {
    zip: "45362",
    ST: "OH",
    cityWithStateAbbr: "Rossburg, OH",
  },
  {
    zip: "45363",
    ST: "OH",
    cityWithStateAbbr: "Russia, OH",
  },
  {
    zip: "45365",
    ST: "OH",
    cityWithStateAbbr: "Sidney, OH",
  },
  {
    zip: "45367",
    ST: "OH",
    cityWithStateAbbr: "Sidney, OH",
  },
  {
    zip: "45368",
    ST: "OH",
    cityWithStateAbbr: "South Charleston, OH",
  },
  {
    zip: "45369",
    ST: "OH",
    cityWithStateAbbr: "South Vienna, OH",
  },
  {
    zip: "45370",
    ST: "OH",
    cityWithStateAbbr: "Spring Valley, OH",
  },
  {
    zip: "45371",
    ST: "OH",
    cityWithStateAbbr: "Tipp City, OH",
  },
  {
    zip: "45372",
    ST: "OH",
    cityWithStateAbbr: "Tremont City, OH",
  },
  {
    zip: "45373",
    ST: "OH",
    cityWithStateAbbr: "Troy, OH",
  },
  {
    zip: "45374",
    ST: "OH",
    cityWithStateAbbr: "Troy, OH",
  },
  {
    zip: "45377",
    ST: "OH",
    cityWithStateAbbr: "Vandalia, OH",
  },
  {
    zip: "45378",
    ST: "OH",
    cityWithStateAbbr: "Verona, OH",
  },
  {
    zip: "45380",
    ST: "OH",
    cityWithStateAbbr: "Versailles, OH",
  },
  {
    zip: "45381",
    ST: "OH",
    cityWithStateAbbr: "West Alexandria, OH",
  },
  {
    zip: "45382",
    ST: "OH",
    cityWithStateAbbr: "West Manchester, OH",
  },
  {
    zip: "45383",
    ST: "OH",
    cityWithStateAbbr: "West Milton, OH",
  },
  {
    zip: "45384",
    ST: "OH",
    cityWithStateAbbr: "Wilberforce, OH",
  },
  {
    zip: "45385",
    ST: "OH",
    cityWithStateAbbr: "Xenia, OH",
  },
  {
    zip: "45387",
    ST: "OH",
    cityWithStateAbbr: "Yellow Springs, OH",
  },
  {
    zip: "45388",
    ST: "OH",
    cityWithStateAbbr: "Yorkshire, OH",
  },
  {
    zip: "45389",
    ST: "OH",
    cityWithStateAbbr: "Christiansburg, OH",
  },
  {
    zip: "45390",
    ST: "OH",
    cityWithStateAbbr: "Union City, OH",
  },
  {
    zip: "45401",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45402",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45403",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45404",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45405",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45406",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45408",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45409",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45410",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45412",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45413",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45414",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45415",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45416",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45417",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45418",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45419",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45420",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45422",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45423",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45424",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45426",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45427",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45428",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45429",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45430",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45431",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45432",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45433",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45434",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45435",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45437",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45439",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45440",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45441",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45448",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45449",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45454",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45458",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45459",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45469",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45470",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45475",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45479",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45481",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45482",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45490",
    ST: "OH",
    cityWithStateAbbr: "Dayton, OH",
  },
  {
    zip: "45501",
    ST: "OH",
    cityWithStateAbbr: "Springfield, OH",
  },
  {
    zip: "45502",
    ST: "OH",
    cityWithStateAbbr: "Springfield, OH",
  },
  {
    zip: "45503",
    ST: "OH",
    cityWithStateAbbr: "Springfield, OH",
  },
  {
    zip: "45504",
    ST: "OH",
    cityWithStateAbbr: "Springfield, OH",
  },
  {
    zip: "45505",
    ST: "OH",
    cityWithStateAbbr: "Springfield, OH",
  },
  {
    zip: "45506",
    ST: "OH",
    cityWithStateAbbr: "Springfield, OH",
  },
  {
    zip: "45601",
    ST: "OH",
    cityWithStateAbbr: "Chillicothe, OH",
  },
  {
    zip: "45612",
    ST: "OH",
    cityWithStateAbbr: "Bainbridge, OH",
  },
  {
    zip: "45613",
    ST: "OH",
    cityWithStateAbbr: "Beaver, OH",
  },
  {
    zip: "45614",
    ST: "OH",
    cityWithStateAbbr: "Bidwell, OH",
  },
  {
    zip: "45616",
    ST: "OH",
    cityWithStateAbbr: "Blue Creek, OH",
  },
  {
    zip: "45617",
    ST: "OH",
    cityWithStateAbbr: "Bourneville, OH",
  },
  {
    zip: "45618",
    ST: "OH",
    cityWithStateAbbr: "Cherry Fork, OH",
  },
  {
    zip: "45619",
    ST: "OH",
    cityWithStateAbbr: "Chesapeake, OH",
  },
  {
    zip: "45620",
    ST: "OH",
    cityWithStateAbbr: "Cheshire, OH",
  },
  {
    zip: "45621",
    ST: "OH",
    cityWithStateAbbr: "Coalton, OH",
  },
  {
    zip: "45622",
    ST: "OH",
    cityWithStateAbbr: "Creola, OH",
  },
  {
    zip: "45623",
    ST: "OH",
    cityWithStateAbbr: "Crown City, OH",
  },
  {
    zip: "45624",
    ST: "OH",
    cityWithStateAbbr: "Cynthiana, OH",
  },
  {
    zip: "45628",
    ST: "OH",
    cityWithStateAbbr: "Frankfort, OH",
  },
  {
    zip: "45629",
    ST: "OH",
    cityWithStateAbbr: "Franklin Furnace, OH",
  },
  {
    zip: "45630",
    ST: "OH",
    cityWithStateAbbr: "Friendship, OH",
  },
  {
    zip: "45631",
    ST: "OH",
    cityWithStateAbbr: "Gallipolis, OH",
  },
  {
    zip: "45633",
    ST: "OH",
    cityWithStateAbbr: "Hallsville, OH",
  },
  {
    zip: "45634",
    ST: "OH",
    cityWithStateAbbr: "Hamden, OH",
  },
  {
    zip: "45636",
    ST: "OH",
    cityWithStateAbbr: "Haverhill, OH",
  },
  {
    zip: "45638",
    ST: "OH",
    cityWithStateAbbr: "Ironton, OH",
  },
  {
    zip: "45640",
    ST: "OH",
    cityWithStateAbbr: "Jackson, OH",
  },
  {
    zip: "45642",
    ST: "OH",
    cityWithStateAbbr: "Jasper, OH",
  },
  {
    zip: "45643",
    ST: "OH",
    cityWithStateAbbr: "Kerr, OH",
  },
  {
    zip: "45644",
    ST: "OH",
    cityWithStateAbbr: "Kingston, OH",
  },
  {
    zip: "45645",
    ST: "OH",
    cityWithStateAbbr: "Kitts Hill, OH",
  },
  {
    zip: "45646",
    ST: "OH",
    cityWithStateAbbr: "Latham, OH",
  },
  {
    zip: "45647",
    ST: "OH",
    cityWithStateAbbr: "Londonderry, OH",
  },
  {
    zip: "45648",
    ST: "OH",
    cityWithStateAbbr: "Lucasville, OH",
  },
  {
    zip: "45650",
    ST: "OH",
    cityWithStateAbbr: "Lynx, OH",
  },
  {
    zip: "45651",
    ST: "OH",
    cityWithStateAbbr: "Mc Arthur, OH",
  },
  {
    zip: "45652",
    ST: "OH",
    cityWithStateAbbr: "Mc Dermott, OH",
  },
  {
    zip: "45653",
    ST: "OH",
    cityWithStateAbbr: "Minford, OH",
  },
  {
    zip: "45654",
    ST: "OH",
    cityWithStateAbbr: "New Plymouth, OH",
  },
  {
    zip: "45656",
    ST: "OH",
    cityWithStateAbbr: "Oak Hill, OH",
  },
  {
    zip: "45657",
    ST: "OH",
    cityWithStateAbbr: "Otway, OH",
  },
  {
    zip: "45658",
    ST: "OH",
    cityWithStateAbbr: "Patriot, OH",
  },
  {
    zip: "45659",
    ST: "OH",
    cityWithStateAbbr: "Pedro, OH",
  },
  {
    zip: "45660",
    ST: "OH",
    cityWithStateAbbr: "Peebles, OH",
  },
  {
    zip: "45661",
    ST: "OH",
    cityWithStateAbbr: "Piketon, OH",
  },
  {
    zip: "45662",
    ST: "OH",
    cityWithStateAbbr: "Portsmouth, OH",
  },
  {
    zip: "45663",
    ST: "OH",
    cityWithStateAbbr: "West Portsmouth, OH",
  },
  {
    zip: "45669",
    ST: "OH",
    cityWithStateAbbr: "Proctorville, OH",
  },
  {
    zip: "45671",
    ST: "OH",
    cityWithStateAbbr: "Rarden, OH",
  },
  {
    zip: "45672",
    ST: "OH",
    cityWithStateAbbr: "Ray, OH",
  },
  {
    zip: "45673",
    ST: "OH",
    cityWithStateAbbr: "Richmond Dale, OH",
  },
  {
    zip: "45674",
    ST: "OH",
    cityWithStateAbbr: "Rio Grande, OH",
  },
  {
    zip: "45675",
    ST: "OH",
    cityWithStateAbbr: "Rock Camp, OH",
  },
  {
    zip: "45677",
    ST: "OH",
    cityWithStateAbbr: "Scioto Furnace, OH",
  },
  {
    zip: "45678",
    ST: "OH",
    cityWithStateAbbr: "Scottown, OH",
  },
  {
    zip: "45679",
    ST: "OH",
    cityWithStateAbbr: "Seaman, OH",
  },
  {
    zip: "45680",
    ST: "OH",
    cityWithStateAbbr: "South Point, OH",
  },
  {
    zip: "45681",
    ST: "OH",
    cityWithStateAbbr: "South Salem, OH",
  },
  {
    zip: "45682",
    ST: "OH",
    cityWithStateAbbr: "South Webster, OH",
  },
  {
    zip: "45683",
    ST: "OH",
    cityWithStateAbbr: "Stockdale, OH",
  },
  {
    zip: "45684",
    ST: "OH",
    cityWithStateAbbr: "Stout, OH",
  },
  {
    zip: "45685",
    ST: "OH",
    cityWithStateAbbr: "Thurman, OH",
  },
  {
    zip: "45686",
    ST: "OH",
    cityWithStateAbbr: "Vinton, OH",
  },
  {
    zip: "45687",
    ST: "OH",
    cityWithStateAbbr: "Wakefield, OH",
  },
  {
    zip: "45688",
    ST: "OH",
    cityWithStateAbbr: "Waterloo, OH",
  },
  {
    zip: "45690",
    ST: "OH",
    cityWithStateAbbr: "Waverly, OH",
  },
  {
    zip: "45692",
    ST: "OH",
    cityWithStateAbbr: "Wellston, OH",
  },
  {
    zip: "45693",
    ST: "OH",
    cityWithStateAbbr: "West Union, OH",
  },
  {
    zip: "45694",
    ST: "OH",
    cityWithStateAbbr: "Wheelersburg, OH",
  },
  {
    zip: "45695",
    ST: "OH",
    cityWithStateAbbr: "Wilkesville, OH",
  },
  {
    zip: "45696",
    ST: "OH",
    cityWithStateAbbr: "Willow Wood, OH",
  },
  {
    zip: "45697",
    ST: "OH",
    cityWithStateAbbr: "Winchester, OH",
  },
  {
    zip: "45698",
    ST: "OH",
    cityWithStateAbbr: "Zaleski, OH",
  },
  {
    zip: "45699",
    ST: "OH",
    cityWithStateAbbr: "Lucasville, OH",
  },
  {
    zip: "45701",
    ST: "OH",
    cityWithStateAbbr: "Athens, OH",
  },
  {
    zip: "45710",
    ST: "OH",
    cityWithStateAbbr: "Albany, OH",
  },
  {
    zip: "45711",
    ST: "OH",
    cityWithStateAbbr: "Amesville, OH",
  },
  {
    zip: "45712",
    ST: "OH",
    cityWithStateAbbr: "Barlow, OH",
  },
  {
    zip: "45713",
    ST: "OH",
    cityWithStateAbbr: "Bartlett, OH",
  },
  {
    zip: "45714",
    ST: "OH",
    cityWithStateAbbr: "Belpre, OH",
  },
  {
    zip: "45715",
    ST: "OH",
    cityWithStateAbbr: "Beverly, OH",
  },
  {
    zip: "45716",
    ST: "OH",
    cityWithStateAbbr: "Buchtel, OH",
  },
  {
    zip: "45719",
    ST: "OH",
    cityWithStateAbbr: "Chauncey, OH",
  },
  {
    zip: "45720",
    ST: "OH",
    cityWithStateAbbr: "Chester, OH",
  },
  {
    zip: "45721",
    ST: "OH",
    cityWithStateAbbr: "Coal Run, OH",
  },
  {
    zip: "45723",
    ST: "OH",
    cityWithStateAbbr: "Coolville, OH",
  },
  {
    zip: "45724",
    ST: "OH",
    cityWithStateAbbr: "Cutler, OH",
  },
  {
    zip: "45727",
    ST: "OH",
    cityWithStateAbbr: "Dexter City, OH",
  },
  {
    zip: "45729",
    ST: "OH",
    cityWithStateAbbr: "Fleming, OH",
  },
  {
    zip: "45732",
    ST: "OH",
    cityWithStateAbbr: "Glouster, OH",
  },
  {
    zip: "45734",
    ST: "OH",
    cityWithStateAbbr: "Graysville, OH",
  },
  {
    zip: "45735",
    ST: "OH",
    cityWithStateAbbr: "Guysville, OH",
  },
  {
    zip: "45739",
    ST: "OH",
    cityWithStateAbbr: "Hockingport, OH",
  },
  {
    zip: "45740",
    ST: "OH",
    cityWithStateAbbr: "Jacksonville, OH",
  },
  {
    zip: "45741",
    ST: "OH",
    cityWithStateAbbr: "Langsville, OH",
  },
  {
    zip: "45742",
    ST: "OH",
    cityWithStateAbbr: "Little Hocking, OH",
  },
  {
    zip: "45743",
    ST: "OH",
    cityWithStateAbbr: "Long Bottom, OH",
  },
  {
    zip: "45744",
    ST: "OH",
    cityWithStateAbbr: "Lowell, OH",
  },
  {
    zip: "45745",
    ST: "OH",
    cityWithStateAbbr: "Lower Salem, OH",
  },
  {
    zip: "45746",
    ST: "OH",
    cityWithStateAbbr: "Macksburg, OH",
  },
  {
    zip: "45750",
    ST: "OH",
    cityWithStateAbbr: "Marietta, OH",
  },
  {
    zip: "45760",
    ST: "OH",
    cityWithStateAbbr: "Middleport, OH",
  },
  {
    zip: "45761",
    ST: "OH",
    cityWithStateAbbr: "Millfield, OH",
  },
  {
    zip: "45764",
    ST: "OH",
    cityWithStateAbbr: "Nelsonville, OH",
  },
  {
    zip: "45766",
    ST: "OH",
    cityWithStateAbbr: "New Marshfield, OH",
  },
  {
    zip: "45767",
    ST: "OH",
    cityWithStateAbbr: "New Matamoras, OH",
  },
  {
    zip: "45768",
    ST: "OH",
    cityWithStateAbbr: "Newport, OH",
  },
  {
    zip: "45769",
    ST: "OH",
    cityWithStateAbbr: "Pomeroy, OH",
  },
  {
    zip: "45770",
    ST: "OH",
    cityWithStateAbbr: "Portland, OH",
  },
  {
    zip: "45771",
    ST: "OH",
    cityWithStateAbbr: "Racine, OH",
  },
  {
    zip: "45772",
    ST: "OH",
    cityWithStateAbbr: "Reedsville, OH",
  },
  {
    zip: "45773",
    ST: "OH",
    cityWithStateAbbr: "Reno, OH",
  },
  {
    zip: "45775",
    ST: "OH",
    cityWithStateAbbr: "Rutland, OH",
  },
  {
    zip: "45776",
    ST: "OH",
    cityWithStateAbbr: "Shade, OH",
  },
  {
    zip: "45777",
    ST: "OH",
    cityWithStateAbbr: "Sharpsburg, OH",
  },
  {
    zip: "45778",
    ST: "OH",
    cityWithStateAbbr: "Stewart, OH",
  },
  {
    zip: "45779",
    ST: "OH",
    cityWithStateAbbr: "Syracuse, OH",
  },
  {
    zip: "45780",
    ST: "OH",
    cityWithStateAbbr: "The Plains, OH",
  },
  {
    zip: "45782",
    ST: "OH",
    cityWithStateAbbr: "Trimble, OH",
  },
  {
    zip: "45783",
    ST: "OH",
    cityWithStateAbbr: "Tuppers Plains, OH",
  },
  {
    zip: "45784",
    ST: "OH",
    cityWithStateAbbr: "Vincent, OH",
  },
  {
    zip: "45786",
    ST: "OH",
    cityWithStateAbbr: "Waterford, OH",
  },
  {
    zip: "45787",
    ST: "OH",
    cityWithStateAbbr: "Watertown, OH",
  },
  {
    zip: "45788",
    ST: "OH",
    cityWithStateAbbr: "Whipple, OH",
  },
  {
    zip: "45789",
    ST: "OH",
    cityWithStateAbbr: "Wingett Run, OH",
  },
  {
    zip: "45801",
    ST: "OH",
    cityWithStateAbbr: "Lima, OH",
  },
  {
    zip: "45802",
    ST: "OH",
    cityWithStateAbbr: "Lima, OH",
  },
  {
    zip: "45804",
    ST: "OH",
    cityWithStateAbbr: "Lima, OH",
  },
  {
    zip: "45805",
    ST: "OH",
    cityWithStateAbbr: "Lima, OH",
  },
  {
    zip: "45806",
    ST: "OH",
    cityWithStateAbbr: "Lima, OH",
  },
  {
    zip: "45807",
    ST: "OH",
    cityWithStateAbbr: "Lima, OH",
  },
  {
    zip: "45808",
    ST: "OH",
    cityWithStateAbbr: "Beaverdam, OH",
  },
  {
    zip: "45809",
    ST: "OH",
    cityWithStateAbbr: "Gomer, OH",
  },
  {
    zip: "45810",
    ST: "OH",
    cityWithStateAbbr: "Ada, OH",
  },
  {
    zip: "45812",
    ST: "OH",
    cityWithStateAbbr: "Alger, OH",
  },
  {
    zip: "45813",
    ST: "OH",
    cityWithStateAbbr: "Antwerp, OH",
  },
  {
    zip: "45814",
    ST: "OH",
    cityWithStateAbbr: "Arlington, OH",
  },
  {
    zip: "45815",
    ST: "OH",
    cityWithStateAbbr: "Belmore, OH",
  },
  {
    zip: "45816",
    ST: "OH",
    cityWithStateAbbr: "Benton Ridge, OH",
  },
  {
    zip: "45817",
    ST: "OH",
    cityWithStateAbbr: "Bluffton, OH",
  },
  {
    zip: "45819",
    ST: "OH",
    cityWithStateAbbr: "Buckland, OH",
  },
  {
    zip: "45820",
    ST: "OH",
    cityWithStateAbbr: "Cairo, OH",
  },
  {
    zip: "45821",
    ST: "OH",
    cityWithStateAbbr: "Cecil, OH",
  },
  {
    zip: "45822",
    ST: "OH",
    cityWithStateAbbr: "Celina, OH",
  },
  {
    zip: "45826",
    ST: "OH",
    cityWithStateAbbr: "Chickasaw, OH",
  },
  {
    zip: "45827",
    ST: "OH",
    cityWithStateAbbr: "Cloverdale, OH",
  },
  {
    zip: "45828",
    ST: "OH",
    cityWithStateAbbr: "Coldwater, OH",
  },
  {
    zip: "45830",
    ST: "OH",
    cityWithStateAbbr: "Columbus Grove, OH",
  },
  {
    zip: "45831",
    ST: "OH",
    cityWithStateAbbr: "Continental, OH",
  },
  {
    zip: "45832",
    ST: "OH",
    cityWithStateAbbr: "Convoy, OH",
  },
  {
    zip: "45833",
    ST: "OH",
    cityWithStateAbbr: "Delphos, OH",
  },
  {
    zip: "45835",
    ST: "OH",
    cityWithStateAbbr: "Dola, OH",
  },
  {
    zip: "45836",
    ST: "OH",
    cityWithStateAbbr: "Dunkirk, OH",
  },
  {
    zip: "45837",
    ST: "OH",
    cityWithStateAbbr: "Dupont, OH",
  },
  {
    zip: "45838",
    ST: "OH",
    cityWithStateAbbr: "Elgin, OH",
  },
  {
    zip: "45839",
    ST: "OH",
    cityWithStateAbbr: "Findlay, OH",
  },
  {
    zip: "45840",
    ST: "OH",
    cityWithStateAbbr: "Findlay, OH",
  },
  {
    zip: "45841",
    ST: "OH",
    cityWithStateAbbr: "Jenera, OH",
  },
  {
    zip: "45843",
    ST: "OH",
    cityWithStateAbbr: "Forest, OH",
  },
  {
    zip: "45844",
    ST: "OH",
    cityWithStateAbbr: "Fort Jennings, OH",
  },
  {
    zip: "45845",
    ST: "OH",
    cityWithStateAbbr: "Fort Loramie, OH",
  },
  {
    zip: "45846",
    ST: "OH",
    cityWithStateAbbr: "Fort Recovery, OH",
  },
  {
    zip: "45848",
    ST: "OH",
    cityWithStateAbbr: "Glandorf, OH",
  },
  {
    zip: "45849",
    ST: "OH",
    cityWithStateAbbr: "Grover Hill, OH",
  },
  {
    zip: "45850",
    ST: "OH",
    cityWithStateAbbr: "Harrod, OH",
  },
  {
    zip: "45851",
    ST: "OH",
    cityWithStateAbbr: "Haviland, OH",
  },
  {
    zip: "45853",
    ST: "OH",
    cityWithStateAbbr: "Kalida, OH",
  },
  {
    zip: "45854",
    ST: "OH",
    cityWithStateAbbr: "Lafayette, OH",
  },
  {
    zip: "45855",
    ST: "OH",
    cityWithStateAbbr: "Latty, OH",
  },
  {
    zip: "45856",
    ST: "OH",
    cityWithStateAbbr: "Leipsic, OH",
  },
  {
    zip: "45858",
    ST: "OH",
    cityWithStateAbbr: "Mc Comb, OH",
  },
  {
    zip: "45859",
    ST: "OH",
    cityWithStateAbbr: "Mc Guffey, OH",
  },
  {
    zip: "45860",
    ST: "OH",
    cityWithStateAbbr: "Maria Stein, OH",
  },
  {
    zip: "45861",
    ST: "OH",
    cityWithStateAbbr: "Melrose, OH",
  },
  {
    zip: "45862",
    ST: "OH",
    cityWithStateAbbr: "Mendon, OH",
  },
  {
    zip: "45863",
    ST: "OH",
    cityWithStateAbbr: "Middle Point, OH",
  },
  {
    zip: "45864",
    ST: "OH",
    cityWithStateAbbr: "Miller City, OH",
  },
  {
    zip: "45865",
    ST: "OH",
    cityWithStateAbbr: "Minster, OH",
  },
  {
    zip: "45866",
    ST: "OH",
    cityWithStateAbbr: "Montezuma, OH",
  },
  {
    zip: "45867",
    ST: "OH",
    cityWithStateAbbr: "Mount Blanchard, OH",
  },
  {
    zip: "45868",
    ST: "OH",
    cityWithStateAbbr: "Mount Cory, OH",
  },
  {
    zip: "45869",
    ST: "OH",
    cityWithStateAbbr: "New Bremen, OH",
  },
  {
    zip: "45870",
    ST: "OH",
    cityWithStateAbbr: "New Hampshire, OH",
  },
  {
    zip: "45871",
    ST: "OH",
    cityWithStateAbbr: "New Knoxville, OH",
  },
  {
    zip: "45872",
    ST: "OH",
    cityWithStateAbbr: "North Baltimore, OH",
  },
  {
    zip: "45873",
    ST: "OH",
    cityWithStateAbbr: "Oakwood, OH",
  },
  {
    zip: "45874",
    ST: "OH",
    cityWithStateAbbr: "Ohio City, OH",
  },
  {
    zip: "45875",
    ST: "OH",
    cityWithStateAbbr: "Ottawa, OH",
  },
  {
    zip: "45876",
    ST: "OH",
    cityWithStateAbbr: "Ottoville, OH",
  },
  {
    zip: "45877",
    ST: "OH",
    cityWithStateAbbr: "Pandora, OH",
  },
  {
    zip: "45879",
    ST: "OH",
    cityWithStateAbbr: "Paulding, OH",
  },
  {
    zip: "45880",
    ST: "OH",
    cityWithStateAbbr: "Payne, OH",
  },
  {
    zip: "45881",
    ST: "OH",
    cityWithStateAbbr: "Rawson, OH",
  },
  {
    zip: "45882",
    ST: "OH",
    cityWithStateAbbr: "Rockford, OH",
  },
  {
    zip: "45883",
    ST: "OH",
    cityWithStateAbbr: "Saint Henry, OH",
  },
  {
    zip: "45884",
    ST: "OH",
    cityWithStateAbbr: "Saint Johns, OH",
  },
  {
    zip: "45885",
    ST: "OH",
    cityWithStateAbbr: "Saint Marys, OH",
  },
  {
    zip: "45886",
    ST: "OH",
    cityWithStateAbbr: "Scott, OH",
  },
  {
    zip: "45887",
    ST: "OH",
    cityWithStateAbbr: "Spencerville, OH",
  },
  {
    zip: "45888",
    ST: "OH",
    cityWithStateAbbr: "Uniopolis, OH",
  },
  {
    zip: "45889",
    ST: "OH",
    cityWithStateAbbr: "Van Buren, OH",
  },
  {
    zip: "45890",
    ST: "OH",
    cityWithStateAbbr: "Vanlue, OH",
  },
  {
    zip: "45891",
    ST: "OH",
    cityWithStateAbbr: "Van Wert, OH",
  },
  {
    zip: "45893",
    ST: "OH",
    cityWithStateAbbr: "Vaughnsville, OH",
  },
  {
    zip: "45894",
    ST: "OH",
    cityWithStateAbbr: "Venedocia, OH",
  },
  {
    zip: "45895",
    ST: "OH",
    cityWithStateAbbr: "Wapakoneta, OH",
  },
  {
    zip: "45896",
    ST: "OH",
    cityWithStateAbbr: "Waynesfield, OH",
  },
  {
    zip: "45897",
    ST: "OH",
    cityWithStateAbbr: "Williamstown, OH",
  },
  {
    zip: "45898",
    ST: "OH",
    cityWithStateAbbr: "Willshire, OH",
  },
  {
    zip: "45899",
    ST: "OH",
    cityWithStateAbbr: "Wren, OH",
  },
  {
    zip: "45999",
    ST: "KY",
    cityWithStateAbbr: "Cincinnati, KY",
  },
  {
    zip: "46001",
    ST: "IN",
    cityWithStateAbbr: "Alexandria, IN",
  },
  {
    zip: "46011",
    ST: "IN",
    cityWithStateAbbr: "Anderson, IN",
  },
  {
    zip: "46012",
    ST: "IN",
    cityWithStateAbbr: "Anderson, IN",
  },
  {
    zip: "46013",
    ST: "IN",
    cityWithStateAbbr: "Anderson, IN",
  },
  {
    zip: "46014",
    ST: "IN",
    cityWithStateAbbr: "Anderson, IN",
  },
  {
    zip: "46015",
    ST: "IN",
    cityWithStateAbbr: "Anderson, IN",
  },
  {
    zip: "46016",
    ST: "IN",
    cityWithStateAbbr: "Anderson, IN",
  },
  {
    zip: "46017",
    ST: "IN",
    cityWithStateAbbr: "Anderson, IN",
  },
  {
    zip: "46018",
    ST: "IN",
    cityWithStateAbbr: "Anderson, IN",
  },
  {
    zip: "46030",
    ST: "IN",
    cityWithStateAbbr: "Arcadia, IN",
  },
  {
    zip: "46031",
    ST: "IN",
    cityWithStateAbbr: "Atlanta, IN",
  },
  {
    zip: "46032",
    ST: "IN",
    cityWithStateAbbr: "Carmel, IN",
  },
  {
    zip: "46033",
    ST: "IN",
    cityWithStateAbbr: "Carmel, IN",
  },
  {
    zip: "46034",
    ST: "IN",
    cityWithStateAbbr: "Cicero, IN",
  },
  {
    zip: "46035",
    ST: "IN",
    cityWithStateAbbr: "Colfax, IN",
  },
  {
    zip: "46036",
    ST: "IN",
    cityWithStateAbbr: "Elwood, IN",
  },
  {
    zip: "46037",
    ST: "IN",
    cityWithStateAbbr: "Fishers, IN",
  },
  {
    zip: "46038",
    ST: "IN",
    cityWithStateAbbr: "Fishers, IN",
  },
  {
    zip: "46039",
    ST: "IN",
    cityWithStateAbbr: "Forest, IN",
  },
  {
    zip: "46040",
    ST: "IN",
    cityWithStateAbbr: "Fortville, IN",
  },
  {
    zip: "46041",
    ST: "IN",
    cityWithStateAbbr: "Frankfort, IN",
  },
  {
    zip: "46044",
    ST: "IN",
    cityWithStateAbbr: "Frankton, IN",
  },
  {
    zip: "46045",
    ST: "IN",
    cityWithStateAbbr: "Goldsmith, IN",
  },
  {
    zip: "46047",
    ST: "IN",
    cityWithStateAbbr: "Hobbs, IN",
  },
  {
    zip: "46048",
    ST: "IN",
    cityWithStateAbbr: "Ingalls, IN",
  },
  {
    zip: "46049",
    ST: "IN",
    cityWithStateAbbr: "Kempton, IN",
  },
  {
    zip: "46050",
    ST: "IN",
    cityWithStateAbbr: "Kirklin, IN",
  },
  {
    zip: "46051",
    ST: "IN",
    cityWithStateAbbr: "Lapel, IN",
  },
  {
    zip: "46052",
    ST: "IN",
    cityWithStateAbbr: "Lebanon, IN",
  },
  {
    zip: "46055",
    ST: "IN",
    cityWithStateAbbr: "Mccordsville, IN",
  },
  {
    zip: "46056",
    ST: "IN",
    cityWithStateAbbr: "Markleville, IN",
  },
  {
    zip: "46057",
    ST: "IN",
    cityWithStateAbbr: "Michigantown, IN",
  },
  {
    zip: "46058",
    ST: "IN",
    cityWithStateAbbr: "Mulberry, IN",
  },
  {
    zip: "46060",
    ST: "IN",
    cityWithStateAbbr: "Noblesville, IN",
  },
  {
    zip: "46061",
    ST: "IN",
    cityWithStateAbbr: "Noblesville, IN",
  },
  {
    zip: "46062",
    ST: "IN",
    cityWithStateAbbr: "Noblesville, IN",
  },
  {
    zip: "46063",
    ST: "IN",
    cityWithStateAbbr: "Orestes, IN",
  },
  {
    zip: "46064",
    ST: "IN",
    cityWithStateAbbr: "Pendleton, IN",
  },
  {
    zip: "46065",
    ST: "IN",
    cityWithStateAbbr: "Rossville, IN",
  },
  {
    zip: "46067",
    ST: "IN",
    cityWithStateAbbr: "Sedalia, IN",
  },
  {
    zip: "46068",
    ST: "IN",
    cityWithStateAbbr: "Sharpsville, IN",
  },
  {
    zip: "46069",
    ST: "IN",
    cityWithStateAbbr: "Sheridan, IN",
  },
  {
    zip: "46070",
    ST: "IN",
    cityWithStateAbbr: "Summitville, IN",
  },
  {
    zip: "46071",
    ST: "IN",
    cityWithStateAbbr: "Thorntown, IN",
  },
  {
    zip: "46072",
    ST: "IN",
    cityWithStateAbbr: "Tipton, IN",
  },
  {
    zip: "46074",
    ST: "IN",
    cityWithStateAbbr: "Westfield, IN",
  },
  {
    zip: "46075",
    ST: "IN",
    cityWithStateAbbr: "Whitestown, IN",
  },
  {
    zip: "46076",
    ST: "IN",
    cityWithStateAbbr: "Windfall, IN",
  },
  {
    zip: "46077",
    ST: "IN",
    cityWithStateAbbr: "Zionsville, IN",
  },
  {
    zip: "46082",
    ST: "IN",
    cityWithStateAbbr: "Carmel, IN",
  },
  {
    zip: "46085",
    ST: "IN",
    cityWithStateAbbr: "Fishers, IN",
  },
  {
    zip: "46102",
    ST: "IN",
    cityWithStateAbbr: "Advance, IN",
  },
  {
    zip: "46103",
    ST: "IN",
    cityWithStateAbbr: "Amo, IN",
  },
  {
    zip: "46104",
    ST: "IN",
    cityWithStateAbbr: "Arlington, IN",
  },
  {
    zip: "46105",
    ST: "IN",
    cityWithStateAbbr: "Bainbridge, IN",
  },
  {
    zip: "46106",
    ST: "IN",
    cityWithStateAbbr: "Bargersville, IN",
  },
  {
    zip: "46107",
    ST: "IN",
    cityWithStateAbbr: "Beech Grove, IN",
  },
  {
    zip: "46110",
    ST: "IN",
    cityWithStateAbbr: "Boggstown, IN",
  },
  {
    zip: "46111",
    ST: "IN",
    cityWithStateAbbr: "Brooklyn, IN",
  },
  {
    zip: "46112",
    ST: "IN",
    cityWithStateAbbr: "Brownsburg, IN",
  },
  {
    zip: "46113",
    ST: "IN",
    cityWithStateAbbr: "Camby, IN",
  },
  {
    zip: "46115",
    ST: "IN",
    cityWithStateAbbr: "Carthage, IN",
  },
  {
    zip: "46117",
    ST: "IN",
    cityWithStateAbbr: "Charlottesville, IN",
  },
  {
    zip: "46118",
    ST: "IN",
    cityWithStateAbbr: "Clayton, IN",
  },
  {
    zip: "46120",
    ST: "IN",
    cityWithStateAbbr: "Cloverdale, IN",
  },
  {
    zip: "46121",
    ST: "IN",
    cityWithStateAbbr: "Coatesville, IN",
  },
  {
    zip: "46122",
    ST: "IN",
    cityWithStateAbbr: "Danville, IN",
  },
  {
    zip: "46123",
    ST: "IN",
    cityWithStateAbbr: "Avon, IN",
  },
  {
    zip: "46124",
    ST: "IN",
    cityWithStateAbbr: "Edinburgh, IN",
  },
  {
    zip: "46125",
    ST: "IN",
    cityWithStateAbbr: "Eminence, IN",
  },
  {
    zip: "46126",
    ST: "IN",
    cityWithStateAbbr: "Fairland, IN",
  },
  {
    zip: "46127",
    ST: "IN",
    cityWithStateAbbr: "Falmouth, IN",
  },
  {
    zip: "46128",
    ST: "IN",
    cityWithStateAbbr: "Fillmore, IN",
  },
  {
    zip: "46129",
    ST: "IN",
    cityWithStateAbbr: "Finly, IN",
  },
  {
    zip: "46130",
    ST: "IN",
    cityWithStateAbbr: "Fountaintown, IN",
  },
  {
    zip: "46131",
    ST: "IN",
    cityWithStateAbbr: "Franklin, IN",
  },
  {
    zip: "46133",
    ST: "IN",
    cityWithStateAbbr: "Glenwood, IN",
  },
  {
    zip: "46135",
    ST: "IN",
    cityWithStateAbbr: "Greencastle, IN",
  },
  {
    zip: "46140",
    ST: "IN",
    cityWithStateAbbr: "Greenfield, IN",
  },
  {
    zip: "46142",
    ST: "IN",
    cityWithStateAbbr: "Greenwood, IN",
  },
  {
    zip: "46143",
    ST: "IN",
    cityWithStateAbbr: "Greenwood, IN",
  },
  {
    zip: "46144",
    ST: "IN",
    cityWithStateAbbr: "Gwynneville, IN",
  },
  {
    zip: "46146",
    ST: "IN",
    cityWithStateAbbr: "Homer, IN",
  },
  {
    zip: "46147",
    ST: "IN",
    cityWithStateAbbr: "Jamestown, IN",
  },
  {
    zip: "46148",
    ST: "IN",
    cityWithStateAbbr: "Knightstown, IN",
  },
  {
    zip: "46149",
    ST: "IN",
    cityWithStateAbbr: "Lizton, IN",
  },
  {
    zip: "46150",
    ST: "IN",
    cityWithStateAbbr: "Manilla, IN",
  },
  {
    zip: "46151",
    ST: "IN",
    cityWithStateAbbr: "Martinsville, IN",
  },
  {
    zip: "46154",
    ST: "IN",
    cityWithStateAbbr: "Maxwell, IN",
  },
  {
    zip: "46155",
    ST: "IN",
    cityWithStateAbbr: "Mays, IN",
  },
  {
    zip: "46156",
    ST: "IN",
    cityWithStateAbbr: "Milroy, IN",
  },
  {
    zip: "46157",
    ST: "IN",
    cityWithStateAbbr: "Monrovia, IN",
  },
  {
    zip: "46158",
    ST: "IN",
    cityWithStateAbbr: "Mooresville, IN",
  },
  {
    zip: "46160",
    ST: "IN",
    cityWithStateAbbr: "Morgantown, IN",
  },
  {
    zip: "46161",
    ST: "IN",
    cityWithStateAbbr: "Morristown, IN",
  },
  {
    zip: "46162",
    ST: "IN",
    cityWithStateAbbr: "Needham, IN",
  },
  {
    zip: "46163",
    ST: "IN",
    cityWithStateAbbr: "New Palestine, IN",
  },
  {
    zip: "46164",
    ST: "IN",
    cityWithStateAbbr: "Nineveh, IN",
  },
  {
    zip: "46165",
    ST: "IN",
    cityWithStateAbbr: "North Salem, IN",
  },
  {
    zip: "46166",
    ST: "IN",
    cityWithStateAbbr: "Paragon, IN",
  },
  {
    zip: "46167",
    ST: "IN",
    cityWithStateAbbr: "Pittsboro, IN",
  },
  {
    zip: "46168",
    ST: "IN",
    cityWithStateAbbr: "Plainfield, IN",
  },
  {
    zip: "46170",
    ST: "IN",
    cityWithStateAbbr: "Putnamville, IN",
  },
  {
    zip: "46171",
    ST: "IN",
    cityWithStateAbbr: "Reelsville, IN",
  },
  {
    zip: "46172",
    ST: "IN",
    cityWithStateAbbr: "Roachdale, IN",
  },
  {
    zip: "46173",
    ST: "IN",
    cityWithStateAbbr: "Rushville, IN",
  },
  {
    zip: "46175",
    ST: "IN",
    cityWithStateAbbr: "Russellville, IN",
  },
  {
    zip: "46176",
    ST: "IN",
    cityWithStateAbbr: "Shelbyville, IN",
  },
  {
    zip: "46180",
    ST: "IN",
    cityWithStateAbbr: "Stilesville, IN",
  },
  {
    zip: "46181",
    ST: "IN",
    cityWithStateAbbr: "Trafalgar, IN",
  },
  {
    zip: "46182",
    ST: "IN",
    cityWithStateAbbr: "Waldron, IN",
  },
  {
    zip: "46183",
    ST: "IN",
    cityWithStateAbbr: "West Newton, IN",
  },
  {
    zip: "46184",
    ST: "IN",
    cityWithStateAbbr: "Whiteland, IN",
  },
  {
    zip: "46186",
    ST: "IN",
    cityWithStateAbbr: "Wilkinson, IN",
  },
  {
    zip: "46201",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46202",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46203",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46204",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46205",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46206",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46207",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46208",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46209",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46211",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46214",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46216",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46217",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46218",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46219",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46220",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46221",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46222",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46223",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46224",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46225",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46226",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46227",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46228",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46229",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46230",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46231",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46234",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46235",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46236",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46237",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46239",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46240",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46241",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46242",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46244",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46247",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46249",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46250",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46251",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46253",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46254",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46255",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46256",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46259",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46260",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46262",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46266",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46268",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46274",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46275",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46277",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46278",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46280",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46282",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46283",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46285",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46290",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46291",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46295",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46296",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46298",
    ST: "IN",
    cityWithStateAbbr: "Indianapolis, IN",
  },
  {
    zip: "46301",
    ST: "IN",
    cityWithStateAbbr: "Beverly Shores, IN",
  },
  {
    zip: "46302",
    ST: "IN",
    cityWithStateAbbr: "Boone Grove, IN",
  },
  {
    zip: "46303",
    ST: "IN",
    cityWithStateAbbr: "Cedar Lake, IN",
  },
  {
    zip: "46304",
    ST: "IN",
    cityWithStateAbbr: "Chesterton, IN",
  },
  {
    zip: "46307",
    ST: "IN",
    cityWithStateAbbr: "Crown Point, IN",
  },
  {
    zip: "46308",
    ST: "IN",
    cityWithStateAbbr: "Crown Point, IN",
  },
  {
    zip: "46310",
    ST: "IN",
    cityWithStateAbbr: "Demotte, IN",
  },
  {
    zip: "46311",
    ST: "IN",
    cityWithStateAbbr: "Dyer, IN",
  },
  {
    zip: "46312",
    ST: "IN",
    cityWithStateAbbr: "East Chicago, IN",
  },
  {
    zip: "46319",
    ST: "IN",
    cityWithStateAbbr: "Griffith, IN",
  },
  {
    zip: "46320",
    ST: "IN",
    cityWithStateAbbr: "Hammond, IN",
  },
  {
    zip: "46321",
    ST: "IN",
    cityWithStateAbbr: "Munster, IN",
  },
  {
    zip: "46322",
    ST: "IN",
    cityWithStateAbbr: "Highland, IN",
  },
  {
    zip: "46323",
    ST: "IN",
    cityWithStateAbbr: "Hammond, IN",
  },
  {
    zip: "46324",
    ST: "IN",
    cityWithStateAbbr: "Hammond, IN",
  },
  {
    zip: "46325",
    ST: "IN",
    cityWithStateAbbr: "Hammond, IN",
  },
  {
    zip: "46327",
    ST: "IN",
    cityWithStateAbbr: "Hammond, IN",
  },
  {
    zip: "46340",
    ST: "IN",
    cityWithStateAbbr: "Hanna, IN",
  },
  {
    zip: "46341",
    ST: "IN",
    cityWithStateAbbr: "Hebron, IN",
  },
  {
    zip: "46342",
    ST: "IN",
    cityWithStateAbbr: "Hobart, IN",
  },
  {
    zip: "46345",
    ST: "IN",
    cityWithStateAbbr: "Kingsbury, IN",
  },
  {
    zip: "46346",
    ST: "IN",
    cityWithStateAbbr: "Kingsford Heights, IN",
  },
  {
    zip: "46347",
    ST: "IN",
    cityWithStateAbbr: "Kouts, IN",
  },
  {
    zip: "46348",
    ST: "IN",
    cityWithStateAbbr: "La Crosse, IN",
  },
  {
    zip: "46349",
    ST: "IN",
    cityWithStateAbbr: "Lake Village, IN",
  },
  {
    zip: "46350",
    ST: "IN",
    cityWithStateAbbr: "La Porte, IN",
  },
  {
    zip: "46352",
    ST: "IN",
    cityWithStateAbbr: "La Porte, IN",
  },
  {
    zip: "46355",
    ST: "IN",
    cityWithStateAbbr: "Leroy, IN",
  },
  {
    zip: "46356",
    ST: "IN",
    cityWithStateAbbr: "Lowell, IN",
  },
  {
    zip: "46360",
    ST: "IN",
    cityWithStateAbbr: "Michigan City, IN",
  },
  {
    zip: "46361",
    ST: "IN",
    cityWithStateAbbr: "Michigan City, IN",
  },
  {
    zip: "46365",
    ST: "IN",
    cityWithStateAbbr: "Mill Creek, IN",
  },
  {
    zip: "46366",
    ST: "IN",
    cityWithStateAbbr: "North Judson, IN",
  },
  {
    zip: "46368",
    ST: "IN",
    cityWithStateAbbr: "Portage, IN",
  },
  {
    zip: "46371",
    ST: "IN",
    cityWithStateAbbr: "Rolling Prairie, IN",
  },
  {
    zip: "46372",
    ST: "IN",
    cityWithStateAbbr: "Roselawn, IN",
  },
  {
    zip: "46373",
    ST: "IN",
    cityWithStateAbbr: "Saint John, IN",
  },
  {
    zip: "46374",
    ST: "IN",
    cityWithStateAbbr: "San Pierre, IN",
  },
  {
    zip: "46375",
    ST: "IN",
    cityWithStateAbbr: "Schererville, IN",
  },
  {
    zip: "46376",
    ST: "IN",
    cityWithStateAbbr: "Schneider, IN",
  },
  {
    zip: "46377",
    ST: "IN",
    cityWithStateAbbr: "Shelby, IN",
  },
  {
    zip: "46379",
    ST: "IN",
    cityWithStateAbbr: "Sumava Resorts, IN",
  },
  {
    zip: "46380",
    ST: "IN",
    cityWithStateAbbr: "Tefft, IN",
  },
  {
    zip: "46381",
    ST: "IN",
    cityWithStateAbbr: "Thayer, IN",
  },
  {
    zip: "46382",
    ST: "IN",
    cityWithStateAbbr: "Union Mills, IN",
  },
  {
    zip: "46383",
    ST: "IN",
    cityWithStateAbbr: "Valparaiso, IN",
  },
  {
    zip: "46384",
    ST: "IN",
    cityWithStateAbbr: "Valparaiso, IN",
  },
  {
    zip: "46385",
    ST: "IN",
    cityWithStateAbbr: "Valparaiso, IN",
  },
  {
    zip: "46390",
    ST: "IN",
    cityWithStateAbbr: "Wanatah, IN",
  },
  {
    zip: "46391",
    ST: "IN",
    cityWithStateAbbr: "Westville, IN",
  },
  {
    zip: "46392",
    ST: "IN",
    cityWithStateAbbr: "Wheatfield, IN",
  },
  {
    zip: "46393",
    ST: "IN",
    cityWithStateAbbr: "Wheeler, IN",
  },
  {
    zip: "46394",
    ST: "IN",
    cityWithStateAbbr: "Whiting, IN",
  },
  {
    zip: "46401",
    ST: "IN",
    cityWithStateAbbr: "Gary, IN",
  },
  {
    zip: "46402",
    ST: "IN",
    cityWithStateAbbr: "Gary, IN",
  },
  {
    zip: "46403",
    ST: "IN",
    cityWithStateAbbr: "Gary, IN",
  },
  {
    zip: "46404",
    ST: "IN",
    cityWithStateAbbr: "Gary, IN",
  },
  {
    zip: "46405",
    ST: "IN",
    cityWithStateAbbr: "Lake Station, IN",
  },
  {
    zip: "46406",
    ST: "IN",
    cityWithStateAbbr: "Gary, IN",
  },
  {
    zip: "46407",
    ST: "IN",
    cityWithStateAbbr: "Gary, IN",
  },
  {
    zip: "46408",
    ST: "IN",
    cityWithStateAbbr: "Gary, IN",
  },
  {
    zip: "46409",
    ST: "IN",
    cityWithStateAbbr: "Gary, IN",
  },
  {
    zip: "46410",
    ST: "IN",
    cityWithStateAbbr: "Merrillville, IN",
  },
  {
    zip: "46411",
    ST: "IN",
    cityWithStateAbbr: "Merrillville, IN",
  },
  {
    zip: "46501",
    ST: "IN",
    cityWithStateAbbr: "Argos, IN",
  },
  {
    zip: "46502",
    ST: "IN",
    cityWithStateAbbr: "Atwood, IN",
  },
  {
    zip: "46504",
    ST: "IN",
    cityWithStateAbbr: "Bourbon, IN",
  },
  {
    zip: "46506",
    ST: "IN",
    cityWithStateAbbr: "Bremen, IN",
  },
  {
    zip: "46507",
    ST: "IN",
    cityWithStateAbbr: "Bristol, IN",
  },
  {
    zip: "46508",
    ST: "IN",
    cityWithStateAbbr: "Burket, IN",
  },
  {
    zip: "46510",
    ST: "IN",
    cityWithStateAbbr: "Claypool, IN",
  },
  {
    zip: "46511",
    ST: "IN",
    cityWithStateAbbr: "Culver, IN",
  },
  {
    zip: "46513",
    ST: "IN",
    cityWithStateAbbr: "Donaldson, IN",
  },
  {
    zip: "46514",
    ST: "IN",
    cityWithStateAbbr: "Elkhart, IN",
  },
  {
    zip: "46515",
    ST: "IN",
    cityWithStateAbbr: "Elkhart, IN",
  },
  {
    zip: "46516",
    ST: "IN",
    cityWithStateAbbr: "Elkhart, IN",
  },
  {
    zip: "46517",
    ST: "IN",
    cityWithStateAbbr: "Elkhart, IN",
  },
  {
    zip: "46524",
    ST: "IN",
    cityWithStateAbbr: "Etna Green, IN",
  },
  {
    zip: "46526",
    ST: "IN",
    cityWithStateAbbr: "Goshen, IN",
  },
  {
    zip: "46527",
    ST: "IN",
    cityWithStateAbbr: "Goshen, IN",
  },
  {
    zip: "46528",
    ST: "IN",
    cityWithStateAbbr: "Goshen, IN",
  },
  {
    zip: "46530",
    ST: "IN",
    cityWithStateAbbr: "Granger, IN",
  },
  {
    zip: "46531",
    ST: "IN",
    cityWithStateAbbr: "Grovertown, IN",
  },
  {
    zip: "46532",
    ST: "IN",
    cityWithStateAbbr: "Hamlet, IN",
  },
  {
    zip: "46534",
    ST: "IN",
    cityWithStateAbbr: "Knox, IN",
  },
  {
    zip: "46536",
    ST: "IN",
    cityWithStateAbbr: "Lakeville, IN",
  },
  {
    zip: "46537",
    ST: "IN",
    cityWithStateAbbr: "Lapaz, IN",
  },
  {
    zip: "46538",
    ST: "IN",
    cityWithStateAbbr: "Leesburg, IN",
  },
  {
    zip: "46539",
    ST: "IN",
    cityWithStateAbbr: "Mentone, IN",
  },
  {
    zip: "46540",
    ST: "IN",
    cityWithStateAbbr: "Middlebury, IN",
  },
  {
    zip: "46542",
    ST: "IN",
    cityWithStateAbbr: "Milford, IN",
  },
  {
    zip: "46543",
    ST: "IN",
    cityWithStateAbbr: "Millersburg, IN",
  },
  {
    zip: "46544",
    ST: "IN",
    cityWithStateAbbr: "Mishawaka, IN",
  },
  {
    zip: "46545",
    ST: "IN",
    cityWithStateAbbr: "Mishawaka, IN",
  },
  {
    zip: "46546",
    ST: "IN",
    cityWithStateAbbr: "Mishawaka, IN",
  },
  {
    zip: "46550",
    ST: "IN",
    cityWithStateAbbr: "Nappanee, IN",
  },
  {
    zip: "46552",
    ST: "IN",
    cityWithStateAbbr: "New Carlisle, IN",
  },
  {
    zip: "46553",
    ST: "IN",
    cityWithStateAbbr: "New Paris, IN",
  },
  {
    zip: "46554",
    ST: "IN",
    cityWithStateAbbr: "North Liberty, IN",
  },
  {
    zip: "46555",
    ST: "IN",
    cityWithStateAbbr: "North Webster, IN",
  },
  {
    zip: "46556",
    ST: "IN",
    cityWithStateAbbr: "Notre Dame, IN",
  },
  {
    zip: "46561",
    ST: "IN",
    cityWithStateAbbr: "Osceola, IN",
  },
  {
    zip: "46562",
    ST: "IN",
    cityWithStateAbbr: "Pierceton, IN",
  },
  {
    zip: "46563",
    ST: "IN",
    cityWithStateAbbr: "Plymouth, IN",
  },
  {
    zip: "46565",
    ST: "IN",
    cityWithStateAbbr: "Shipshewana, IN",
  },
  {
    zip: "46567",
    ST: "IN",
    cityWithStateAbbr: "Syracuse, IN",
  },
  {
    zip: "46570",
    ST: "IN",
    cityWithStateAbbr: "Tippecanoe, IN",
  },
  {
    zip: "46571",
    ST: "IN",
    cityWithStateAbbr: "Topeka, IN",
  },
  {
    zip: "46572",
    ST: "IN",
    cityWithStateAbbr: "Tyner, IN",
  },
  {
    zip: "46573",
    ST: "IN",
    cityWithStateAbbr: "Wakarusa, IN",
  },
  {
    zip: "46574",
    ST: "IN",
    cityWithStateAbbr: "Walkerton, IN",
  },
  {
    zip: "46580",
    ST: "IN",
    cityWithStateAbbr: "Warsaw, IN",
  },
  {
    zip: "46581",
    ST: "IN",
    cityWithStateAbbr: "Warsaw, IN",
  },
  {
    zip: "46582",
    ST: "IN",
    cityWithStateAbbr: "Warsaw, IN",
  },
  {
    zip: "46590",
    ST: "IN",
    cityWithStateAbbr: "Winona Lake, IN",
  },
  {
    zip: "46595",
    ST: "IN",
    cityWithStateAbbr: "Wyatt, IN",
  },
  {
    zip: "46601",
    ST: "IN",
    cityWithStateAbbr: "South Bend, IN",
  },
  {
    zip: "46613",
    ST: "IN",
    cityWithStateAbbr: "South Bend, IN",
  },
  {
    zip: "46614",
    ST: "IN",
    cityWithStateAbbr: "South Bend, IN",
  },
  {
    zip: "46615",
    ST: "IN",
    cityWithStateAbbr: "South Bend, IN",
  },
  {
    zip: "46616",
    ST: "IN",
    cityWithStateAbbr: "South Bend, IN",
  },
  {
    zip: "46617",
    ST: "IN",
    cityWithStateAbbr: "South Bend, IN",
  },
  {
    zip: "46619",
    ST: "IN",
    cityWithStateAbbr: "South Bend, IN",
  },
  {
    zip: "46624",
    ST: "IN",
    cityWithStateAbbr: "South Bend, IN",
  },
  {
    zip: "46626",
    ST: "IN",
    cityWithStateAbbr: "South Bend, IN",
  },
  {
    zip: "46628",
    ST: "IN",
    cityWithStateAbbr: "South Bend, IN",
  },
  {
    zip: "46634",
    ST: "IN",
    cityWithStateAbbr: "South Bend, IN",
  },
  {
    zip: "46635",
    ST: "IN",
    cityWithStateAbbr: "South Bend, IN",
  },
  {
    zip: "46637",
    ST: "IN",
    cityWithStateAbbr: "South Bend, IN",
  },
  {
    zip: "46660",
    ST: "IN",
    cityWithStateAbbr: "South Bend, IN",
  },
  {
    zip: "46680",
    ST: "IN",
    cityWithStateAbbr: "South Bend, IN",
  },
  {
    zip: "46699",
    ST: "IN",
    cityWithStateAbbr: "South Bend, IN",
  },
  {
    zip: "46701",
    ST: "IN",
    cityWithStateAbbr: "Albion, IN",
  },
  {
    zip: "46702",
    ST: "IN",
    cityWithStateAbbr: "Andrews, IN",
  },
  {
    zip: "46703",
    ST: "IN",
    cityWithStateAbbr: "Angola, IN",
  },
  {
    zip: "46704",
    ST: "IN",
    cityWithStateAbbr: "Arcola, IN",
  },
  {
    zip: "46705",
    ST: "IN",
    cityWithStateAbbr: "Ashley, IN",
  },
  {
    zip: "46706",
    ST: "IN",
    cityWithStateAbbr: "Auburn, IN",
  },
  {
    zip: "46710",
    ST: "IN",
    cityWithStateAbbr: "Avilla, IN",
  },
  {
    zip: "46711",
    ST: "IN",
    cityWithStateAbbr: "Berne, IN",
  },
  {
    zip: "46713",
    ST: "IN",
    cityWithStateAbbr: "Bippus, IN",
  },
  {
    zip: "46714",
    ST: "IN",
    cityWithStateAbbr: "Bluffton, IN",
  },
  {
    zip: "46721",
    ST: "IN",
    cityWithStateAbbr: "Butler, IN",
  },
  {
    zip: "46723",
    ST: "IN",
    cityWithStateAbbr: "Churubusco, IN",
  },
  {
    zip: "46725",
    ST: "IN",
    cityWithStateAbbr: "Columbia City, IN",
  },
  {
    zip: "46730",
    ST: "IN",
    cityWithStateAbbr: "Corunna, IN",
  },
  {
    zip: "46731",
    ST: "IN",
    cityWithStateAbbr: "Craigville, IN",
  },
  {
    zip: "46732",
    ST: "IN",
    cityWithStateAbbr: "Cromwell, IN",
  },
  {
    zip: "46733",
    ST: "IN",
    cityWithStateAbbr: "Decatur, IN",
  },
  {
    zip: "46737",
    ST: "IN",
    cityWithStateAbbr: "Fremont, IN",
  },
  {
    zip: "46738",
    ST: "IN",
    cityWithStateAbbr: "Garrett, IN",
  },
  {
    zip: "46740",
    ST: "IN",
    cityWithStateAbbr: "Geneva, IN",
  },
  {
    zip: "46741",
    ST: "IN",
    cityWithStateAbbr: "Grabill, IN",
  },
  {
    zip: "46742",
    ST: "IN",
    cityWithStateAbbr: "Hamilton, IN",
  },
  {
    zip: "46743",
    ST: "IN",
    cityWithStateAbbr: "Harlan, IN",
  },
  {
    zip: "46745",
    ST: "IN",
    cityWithStateAbbr: "Hoagland, IN",
  },
  {
    zip: "46746",
    ST: "IN",
    cityWithStateAbbr: "Howe, IN",
  },
  {
    zip: "46747",
    ST: "IN",
    cityWithStateAbbr: "Hudson, IN",
  },
  {
    zip: "46748",
    ST: "IN",
    cityWithStateAbbr: "Huntertown, IN",
  },
  {
    zip: "46750",
    ST: "IN",
    cityWithStateAbbr: "Huntington, IN",
  },
  {
    zip: "46755",
    ST: "IN",
    cityWithStateAbbr: "Kendallville, IN",
  },
  {
    zip: "46759",
    ST: "IN",
    cityWithStateAbbr: "Keystone, IN",
  },
  {
    zip: "46760",
    ST: "IN",
    cityWithStateAbbr: "Kimmell, IN",
  },
  {
    zip: "46761",
    ST: "IN",
    cityWithStateAbbr: "Lagrange, IN",
  },
  {
    zip: "46763",
    ST: "IN",
    cityWithStateAbbr: "Laotto, IN",
  },
  {
    zip: "46764",
    ST: "IN",
    cityWithStateAbbr: "Larwill, IN",
  },
  {
    zip: "46765",
    ST: "IN",
    cityWithStateAbbr: "Leo, IN",
  },
  {
    zip: "46766",
    ST: "IN",
    cityWithStateAbbr: "Liberty Center, IN",
  },
  {
    zip: "46767",
    ST: "IN",
    cityWithStateAbbr: "Ligonier, IN",
  },
  {
    zip: "46769",
    ST: "IN",
    cityWithStateAbbr: "Linn Grove, IN",
  },
  {
    zip: "46770",
    ST: "IN",
    cityWithStateAbbr: "Markle, IN",
  },
  {
    zip: "46771",
    ST: "IN",
    cityWithStateAbbr: "Mongo, IN",
  },
  {
    zip: "46772",
    ST: "IN",
    cityWithStateAbbr: "Monroe, IN",
  },
  {
    zip: "46773",
    ST: "IN",
    cityWithStateAbbr: "Monroeville, IN",
  },
  {
    zip: "46774",
    ST: "IN",
    cityWithStateAbbr: "New Haven, IN",
  },
  {
    zip: "46776",
    ST: "IN",
    cityWithStateAbbr: "Orland, IN",
  },
  {
    zip: "46777",
    ST: "IN",
    cityWithStateAbbr: "Ossian, IN",
  },
  {
    zip: "46778",
    ST: "IN",
    cityWithStateAbbr: "Petroleum, IN",
  },
  {
    zip: "46779",
    ST: "IN",
    cityWithStateAbbr: "Pleasant Lake, IN",
  },
  {
    zip: "46780",
    ST: "IN",
    cityWithStateAbbr: "Pleasant Mills, IN",
  },
  {
    zip: "46781",
    ST: "IN",
    cityWithStateAbbr: "Poneto, IN",
  },
  {
    zip: "46782",
    ST: "IN",
    cityWithStateAbbr: "Preble, IN",
  },
  {
    zip: "46783",
    ST: "IN",
    cityWithStateAbbr: "Roanoke, IN",
  },
  {
    zip: "46784",
    ST: "IN",
    cityWithStateAbbr: "Rome City, IN",
  },
  {
    zip: "46785",
    ST: "IN",
    cityWithStateAbbr: "Saint Joe, IN",
  },
  {
    zip: "46786",
    ST: "IN",
    cityWithStateAbbr: "South Milford, IN",
  },
  {
    zip: "46787",
    ST: "IN",
    cityWithStateAbbr: "South Whitley, IN",
  },
  {
    zip: "46788",
    ST: "IN",
    cityWithStateAbbr: "Spencerville, IN",
  },
  {
    zip: "46789",
    ST: "IN",
    cityWithStateAbbr: "Stroh, IN",
  },
  {
    zip: "46791",
    ST: "IN",
    cityWithStateAbbr: "Uniondale, IN",
  },
  {
    zip: "46792",
    ST: "IN",
    cityWithStateAbbr: "Warren, IN",
  },
  {
    zip: "46793",
    ST: "IN",
    cityWithStateAbbr: "Waterloo, IN",
  },
  {
    zip: "46794",
    ST: "IN",
    cityWithStateAbbr: "Wawaka, IN",
  },
  {
    zip: "46795",
    ST: "IN",
    cityWithStateAbbr: "Wolcottville, IN",
  },
  {
    zip: "46796",
    ST: "IN",
    cityWithStateAbbr: "Wolflake, IN",
  },
  {
    zip: "46797",
    ST: "IN",
    cityWithStateAbbr: "Woodburn, IN",
  },
  {
    zip: "46798",
    ST: "IN",
    cityWithStateAbbr: "Yoder, IN",
  },
  {
    zip: "46799",
    ST: "IN",
    cityWithStateAbbr: "Zanesville, IN",
  },
  {
    zip: "46801",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46802",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46803",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46804",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46805",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46806",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46807",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46808",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46809",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46814",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46815",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46816",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46818",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46819",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46825",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46835",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46845",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46850",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46851",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46852",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46853",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46854",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46855",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46856",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46857",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46858",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46859",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46860",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46861",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46862",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46863",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46864",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46865",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46866",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46867",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46868",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46869",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46885",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46895",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46896",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46897",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46898",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46899",
    ST: "IN",
    cityWithStateAbbr: "Fort Wayne, IN",
  },
  {
    zip: "46901",
    ST: "IN",
    cityWithStateAbbr: "Kokomo, IN",
  },
  {
    zip: "46902",
    ST: "IN",
    cityWithStateAbbr: "Kokomo, IN",
  },
  {
    zip: "46903",
    ST: "IN",
    cityWithStateAbbr: "Kokomo, IN",
  },
  {
    zip: "46904",
    ST: "IN",
    cityWithStateAbbr: "Kokomo, IN",
  },
  {
    zip: "46910",
    ST: "IN",
    cityWithStateAbbr: "Akron, IN",
  },
  {
    zip: "46911",
    ST: "IN",
    cityWithStateAbbr: "Amboy, IN",
  },
  {
    zip: "46912",
    ST: "IN",
    cityWithStateAbbr: "Athens, IN",
  },
  {
    zip: "46913",
    ST: "IN",
    cityWithStateAbbr: "Bringhurst, IN",
  },
  {
    zip: "46914",
    ST: "IN",
    cityWithStateAbbr: "Bunker Hill, IN",
  },
  {
    zip: "46915",
    ST: "IN",
    cityWithStateAbbr: "Burlington, IN",
  },
  {
    zip: "46916",
    ST: "IN",
    cityWithStateAbbr: "Burrows, IN",
  },
  {
    zip: "46917",
    ST: "IN",
    cityWithStateAbbr: "Camden, IN",
  },
  {
    zip: "46919",
    ST: "IN",
    cityWithStateAbbr: "Converse, IN",
  },
  {
    zip: "46920",
    ST: "IN",
    cityWithStateAbbr: "Cutler, IN",
  },
  {
    zip: "46921",
    ST: "IN",
    cityWithStateAbbr: "Deedsville, IN",
  },
  {
    zip: "46922",
    ST: "IN",
    cityWithStateAbbr: "Delong, IN",
  },
  {
    zip: "46923",
    ST: "IN",
    cityWithStateAbbr: "Delphi, IN",
  },
  {
    zip: "46926",
    ST: "IN",
    cityWithStateAbbr: "Denver, IN",
  },
  {
    zip: "46928",
    ST: "IN",
    cityWithStateAbbr: "Fairmount, IN",
  },
  {
    zip: "46929",
    ST: "IN",
    cityWithStateAbbr: "Flora, IN",
  },
  {
    zip: "46930",
    ST: "IN",
    cityWithStateAbbr: "Fowlerton, IN",
  },
  {
    zip: "46931",
    ST: "IN",
    cityWithStateAbbr: "Fulton, IN",
  },
  {
    zip: "46932",
    ST: "IN",
    cityWithStateAbbr: "Galveston, IN",
  },
  {
    zip: "46933",
    ST: "IN",
    cityWithStateAbbr: "Gas City, IN",
  },
  {
    zip: "46936",
    ST: "IN",
    cityWithStateAbbr: "Greentown, IN",
  },
  {
    zip: "46937",
    ST: "IN",
    cityWithStateAbbr: "Hemlock, IN",
  },
  {
    zip: "46938",
    ST: "IN",
    cityWithStateAbbr: "Jonesboro, IN",
  },
  {
    zip: "46939",
    ST: "IN",
    cityWithStateAbbr: "Kewanna, IN",
  },
  {
    zip: "46940",
    ST: "IN",
    cityWithStateAbbr: "La Fontaine, IN",
  },
  {
    zip: "46941",
    ST: "IN",
    cityWithStateAbbr: "Lagro, IN",
  },
  {
    zip: "46942",
    ST: "IN",
    cityWithStateAbbr: "Lake Cicott, IN",
  },
  {
    zip: "46943",
    ST: "IN",
    cityWithStateAbbr: "Laketon, IN",
  },
  {
    zip: "46945",
    ST: "IN",
    cityWithStateAbbr: "Leiters Ford, IN",
  },
  {
    zip: "46946",
    ST: "IN",
    cityWithStateAbbr: "Liberty Mills, IN",
  },
  {
    zip: "46947",
    ST: "IN",
    cityWithStateAbbr: "Logansport, IN",
  },
  {
    zip: "46950",
    ST: "IN",
    cityWithStateAbbr: "Lucerne, IN",
  },
  {
    zip: "46951",
    ST: "IN",
    cityWithStateAbbr: "Macy, IN",
  },
  {
    zip: "46952",
    ST: "IN",
    cityWithStateAbbr: "Marion, IN",
  },
  {
    zip: "46953",
    ST: "IN",
    cityWithStateAbbr: "Marion, IN",
  },
  {
    zip: "46957",
    ST: "IN",
    cityWithStateAbbr: "Matthews, IN",
  },
  {
    zip: "46958",
    ST: "IN",
    cityWithStateAbbr: "Mexico, IN",
  },
  {
    zip: "46959",
    ST: "IN",
    cityWithStateAbbr: "Miami, IN",
  },
  {
    zip: "46960",
    ST: "IN",
    cityWithStateAbbr: "Monterey, IN",
  },
  {
    zip: "46961",
    ST: "IN",
    cityWithStateAbbr: "New Waverly, IN",
  },
  {
    zip: "46962",
    ST: "IN",
    cityWithStateAbbr: "North Manchester, IN",
  },
  {
    zip: "46965",
    ST: "IN",
    cityWithStateAbbr: "Oakford, IN",
  },
  {
    zip: "46967",
    ST: "IN",
    cityWithStateAbbr: "Onward, IN",
  },
  {
    zip: "46968",
    ST: "IN",
    cityWithStateAbbr: "Ora, IN",
  },
  {
    zip: "46970",
    ST: "IN",
    cityWithStateAbbr: "Peru, IN",
  },
  {
    zip: "46971",
    ST: "IN",
    cityWithStateAbbr: "Grissom Arb, IN",
  },
  {
    zip: "46974",
    ST: "IN",
    cityWithStateAbbr: "Roann, IN",
  },
  {
    zip: "46975",
    ST: "IN",
    cityWithStateAbbr: "Rochester, IN",
  },
  {
    zip: "46977",
    ST: "IN",
    cityWithStateAbbr: "Rockfield, IN",
  },
  {
    zip: "46978",
    ST: "IN",
    cityWithStateAbbr: "Royal Center, IN",
  },
  {
    zip: "46979",
    ST: "IN",
    cityWithStateAbbr: "Russiaville, IN",
  },
  {
    zip: "46980",
    ST: "IN",
    cityWithStateAbbr: "Servia, IN",
  },
  {
    zip: "46982",
    ST: "IN",
    cityWithStateAbbr: "Silver Lake, IN",
  },
  {
    zip: "46984",
    ST: "IN",
    cityWithStateAbbr: "Somerset, IN",
  },
  {
    zip: "46985",
    ST: "IN",
    cityWithStateAbbr: "Star City, IN",
  },
  {
    zip: "46986",
    ST: "IN",
    cityWithStateAbbr: "Swayzee, IN",
  },
  {
    zip: "46987",
    ST: "IN",
    cityWithStateAbbr: "Sweetser, IN",
  },
  {
    zip: "46988",
    ST: "IN",
    cityWithStateAbbr: "Twelve Mile, IN",
  },
  {
    zip: "46989",
    ST: "IN",
    cityWithStateAbbr: "Upland, IN",
  },
  {
    zip: "46990",
    ST: "IN",
    cityWithStateAbbr: "Urbana, IN",
  },
  {
    zip: "46991",
    ST: "IN",
    cityWithStateAbbr: "Van Buren, IN",
  },
  {
    zip: "46992",
    ST: "IN",
    cityWithStateAbbr: "Wabash, IN",
  },
  {
    zip: "46994",
    ST: "IN",
    cityWithStateAbbr: "Walton, IN",
  },
  {
    zip: "46995",
    ST: "IN",
    cityWithStateAbbr: "West Middleton, IN",
  },
  {
    zip: "46996",
    ST: "IN",
    cityWithStateAbbr: "Winamac, IN",
  },
  {
    zip: "46998",
    ST: "IN",
    cityWithStateAbbr: "Young America, IN",
  },
  {
    zip: "47001",
    ST: "IN",
    cityWithStateAbbr: "Aurora, IN",
  },
  {
    zip: "47003",
    ST: "IN",
    cityWithStateAbbr: "West College Corner, IN",
  },
  {
    zip: "47006",
    ST: "IN",
    cityWithStateAbbr: "Batesville, IN",
  },
  {
    zip: "47010",
    ST: "IN",
    cityWithStateAbbr: "Bath, IN",
  },
  {
    zip: "47011",
    ST: "IN",
    cityWithStateAbbr: "Bennington, IN",
  },
  {
    zip: "47012",
    ST: "IN",
    cityWithStateAbbr: "Brookville, IN",
  },
  {
    zip: "47016",
    ST: "IN",
    cityWithStateAbbr: "Cedar Grove, IN",
  },
  {
    zip: "47017",
    ST: "IN",
    cityWithStateAbbr: "Cross Plains, IN",
  },
  {
    zip: "47018",
    ST: "IN",
    cityWithStateAbbr: "Dillsboro, IN",
  },
  {
    zip: "47019",
    ST: "IN",
    cityWithStateAbbr: "East Enterprise, IN",
  },
  {
    zip: "47020",
    ST: "IN",
    cityWithStateAbbr: "Florence, IN",
  },
  {
    zip: "47021",
    ST: "IN",
    cityWithStateAbbr: "Friendship, IN",
  },
  {
    zip: "47022",
    ST: "IN",
    cityWithStateAbbr: "Guilford, IN",
  },
  {
    zip: "47023",
    ST: "IN",
    cityWithStateAbbr: "Holton, IN",
  },
  {
    zip: "47024",
    ST: "IN",
    cityWithStateAbbr: "Laurel, IN",
  },
  {
    zip: "47025",
    ST: "IN",
    cityWithStateAbbr: "Lawrenceburg, IN",
  },
  {
    zip: "47030",
    ST: "IN",
    cityWithStateAbbr: "Metamora, IN",
  },
  {
    zip: "47031",
    ST: "IN",
    cityWithStateAbbr: "Milan, IN",
  },
  {
    zip: "47032",
    ST: "IN",
    cityWithStateAbbr: "Moores Hill, IN",
  },
  {
    zip: "47033",
    ST: "IN",
    cityWithStateAbbr: "Morris, IN",
  },
  {
    zip: "47034",
    ST: "IN",
    cityWithStateAbbr: "Napoleon, IN",
  },
  {
    zip: "47035",
    ST: "IN",
    cityWithStateAbbr: "New Trenton, IN",
  },
  {
    zip: "47036",
    ST: "IN",
    cityWithStateAbbr: "Oldenburg, IN",
  },
  {
    zip: "47037",
    ST: "IN",
    cityWithStateAbbr: "Osgood, IN",
  },
  {
    zip: "47038",
    ST: "IN",
    cityWithStateAbbr: "Patriot, IN",
  },
  {
    zip: "47039",
    ST: "IN",
    cityWithStateAbbr: "Pierceville, IN",
  },
  {
    zip: "47040",
    ST: "IN",
    cityWithStateAbbr: "Rising Sun, IN",
  },
  {
    zip: "47041",
    ST: "IN",
    cityWithStateAbbr: "Sunman, IN",
  },
  {
    zip: "47042",
    ST: "IN",
    cityWithStateAbbr: "Versailles, IN",
  },
  {
    zip: "47043",
    ST: "IN",
    cityWithStateAbbr: "Vevay, IN",
  },
  {
    zip: "47060",
    ST: "IN",
    cityWithStateAbbr: "West Harrison, IN",
  },
  {
    zip: "47102",
    ST: "IN",
    cityWithStateAbbr: "Austin, IN",
  },
  {
    zip: "47104",
    ST: "IN",
    cityWithStateAbbr: "Bethlehem, IN",
  },
  {
    zip: "47106",
    ST: "IN",
    cityWithStateAbbr: "Borden, IN",
  },
  {
    zip: "47107",
    ST: "IN",
    cityWithStateAbbr: "Bradford, IN",
  },
  {
    zip: "47108",
    ST: "IN",
    cityWithStateAbbr: "Campbellsburg, IN",
  },
  {
    zip: "47110",
    ST: "IN",
    cityWithStateAbbr: "Central, IN",
  },
  {
    zip: "47111",
    ST: "IN",
    cityWithStateAbbr: "Charlestown, IN",
  },
  {
    zip: "47112",
    ST: "IN",
    cityWithStateAbbr: "Corydon, IN",
  },
  {
    zip: "47114",
    ST: "IN",
    cityWithStateAbbr: "Crandall, IN",
  },
  {
    zip: "47115",
    ST: "IN",
    cityWithStateAbbr: "Depauw, IN",
  },
  {
    zip: "47116",
    ST: "IN",
    cityWithStateAbbr: "Eckerty, IN",
  },
  {
    zip: "47117",
    ST: "IN",
    cityWithStateAbbr: "Elizabeth, IN",
  },
  {
    zip: "47118",
    ST: "IN",
    cityWithStateAbbr: "English, IN",
  },
  {
    zip: "47119",
    ST: "IN",
    cityWithStateAbbr: "Floyds Knobs, IN",
  },
  {
    zip: "47120",
    ST: "IN",
    cityWithStateAbbr: "Fredericksburg, IN",
  },
  {
    zip: "47122",
    ST: "IN",
    cityWithStateAbbr: "Georgetown, IN",
  },
  {
    zip: "47123",
    ST: "IN",
    cityWithStateAbbr: "Grantsburg, IN",
  },
  {
    zip: "47124",
    ST: "IN",
    cityWithStateAbbr: "Greenville, IN",
  },
  {
    zip: "47125",
    ST: "IN",
    cityWithStateAbbr: "Hardinsburg, IN",
  },
  {
    zip: "47126",
    ST: "IN",
    cityWithStateAbbr: "Henryville, IN",
  },
  {
    zip: "47129",
    ST: "IN",
    cityWithStateAbbr: "Clarksville, IN",
  },
  {
    zip: "47130",
    ST: "IN",
    cityWithStateAbbr: "Jeffersonville, IN",
  },
  {
    zip: "47131",
    ST: "IN",
    cityWithStateAbbr: "Jeffersonville, IN",
  },
  {
    zip: "47132",
    ST: "IN",
    cityWithStateAbbr: "Jeffersonville, IN",
  },
  {
    zip: "47133",
    ST: "IN",
    cityWithStateAbbr: "Jeffersonville, IN",
  },
  {
    zip: "47134",
    ST: "IN",
    cityWithStateAbbr: "Jeffersonville, IN",
  },
  {
    zip: "47135",
    ST: "IN",
    cityWithStateAbbr: "Laconia, IN",
  },
  {
    zip: "47136",
    ST: "IN",
    cityWithStateAbbr: "Lanesville, IN",
  },
  {
    zip: "47137",
    ST: "IN",
    cityWithStateAbbr: "Leavenworth, IN",
  },
  {
    zip: "47138",
    ST: "IN",
    cityWithStateAbbr: "Lexington, IN",
  },
  {
    zip: "47139",
    ST: "IN",
    cityWithStateAbbr: "Scottsburg, IN",
  },
  {
    zip: "47140",
    ST: "IN",
    cityWithStateAbbr: "Marengo, IN",
  },
  {
    zip: "47141",
    ST: "IN",
    cityWithStateAbbr: "Marysville, IN",
  },
  {
    zip: "47142",
    ST: "IN",
    cityWithStateAbbr: "Mauckport, IN",
  },
  {
    zip: "47143",
    ST: "IN",
    cityWithStateAbbr: "Memphis, IN",
  },
  {
    zip: "47144",
    ST: "IN",
    cityWithStateAbbr: "Jeffersonville, IN",
  },
  {
    zip: "47145",
    ST: "IN",
    cityWithStateAbbr: "Milltown, IN",
  },
  {
    zip: "47146",
    ST: "IN",
    cityWithStateAbbr: "Mount Saint Francis, IN",
  },
  {
    zip: "47147",
    ST: "IN",
    cityWithStateAbbr: "Nabb, IN",
  },
  {
    zip: "47150",
    ST: "IN",
    cityWithStateAbbr: "New Albany, IN",
  },
  {
    zip: "47151",
    ST: "IN",
    cityWithStateAbbr: "New Albany, IN",
  },
  {
    zip: "47160",
    ST: "IN",
    cityWithStateAbbr: "New Middletown, IN",
  },
  {
    zip: "47161",
    ST: "IN",
    cityWithStateAbbr: "New Salisbury, IN",
  },
  {
    zip: "47162",
    ST: "IN",
    cityWithStateAbbr: "New Washington, IN",
  },
  {
    zip: "47163",
    ST: "IN",
    cityWithStateAbbr: "Otisco, IN",
  },
  {
    zip: "47164",
    ST: "IN",
    cityWithStateAbbr: "Palmyra, IN",
  },
  {
    zip: "47165",
    ST: "IN",
    cityWithStateAbbr: "Pekin, IN",
  },
  {
    zip: "47166",
    ST: "IN",
    cityWithStateAbbr: "Ramsey, IN",
  },
  {
    zip: "47167",
    ST: "IN",
    cityWithStateAbbr: "Salem, IN",
  },
  {
    zip: "47170",
    ST: "IN",
    cityWithStateAbbr: "Scottsburg, IN",
  },
  {
    zip: "47172",
    ST: "IN",
    cityWithStateAbbr: "Sellersburg, IN",
  },
  {
    zip: "47174",
    ST: "IN",
    cityWithStateAbbr: "Sulphur, IN",
  },
  {
    zip: "47175",
    ST: "IN",
    cityWithStateAbbr: "Taswell, IN",
  },
  {
    zip: "47177",
    ST: "IN",
    cityWithStateAbbr: "Underwood, IN",
  },
  {
    zip: "47190",
    ST: "IN",
    cityWithStateAbbr: "Jeffersonville, IN",
  },
  {
    zip: "47199",
    ST: "IN",
    cityWithStateAbbr: "Jeffersonville, IN",
  },
  {
    zip: "47201",
    ST: "IN",
    cityWithStateAbbr: "Columbus, IN",
  },
  {
    zip: "47202",
    ST: "IN",
    cityWithStateAbbr: "Columbus, IN",
  },
  {
    zip: "47203",
    ST: "IN",
    cityWithStateAbbr: "Columbus, IN",
  },
  {
    zip: "47220",
    ST: "IN",
    cityWithStateAbbr: "Brownstown, IN",
  },
  {
    zip: "47223",
    ST: "IN",
    cityWithStateAbbr: "Butlerville, IN",
  },
  {
    zip: "47224",
    ST: "IN",
    cityWithStateAbbr: "Canaan, IN",
  },
  {
    zip: "47225",
    ST: "IN",
    cityWithStateAbbr: "Clarksburg, IN",
  },
  {
    zip: "47226",
    ST: "IN",
    cityWithStateAbbr: "Clifford, IN",
  },
  {
    zip: "47227",
    ST: "IN",
    cityWithStateAbbr: "Commiskey, IN",
  },
  {
    zip: "47228",
    ST: "IN",
    cityWithStateAbbr: "Cortland, IN",
  },
  {
    zip: "47229",
    ST: "IN",
    cityWithStateAbbr: "Crothersville, IN",
  },
  {
    zip: "47230",
    ST: "IN",
    cityWithStateAbbr: "Deputy, IN",
  },
  {
    zip: "47231",
    ST: "IN",
    cityWithStateAbbr: "Dupont, IN",
  },
  {
    zip: "47232",
    ST: "IN",
    cityWithStateAbbr: "Elizabethtown, IN",
  },
  {
    zip: "47234",
    ST: "IN",
    cityWithStateAbbr: "Flat Rock, IN",
  },
  {
    zip: "47235",
    ST: "IN",
    cityWithStateAbbr: "Freetown, IN",
  },
  {
    zip: "47236",
    ST: "IN",
    cityWithStateAbbr: "Grammer, IN",
  },
  {
    zip: "47240",
    ST: "IN",
    cityWithStateAbbr: "Greensburg, IN",
  },
  {
    zip: "47243",
    ST: "IN",
    cityWithStateAbbr: "Hanover, IN",
  },
  {
    zip: "47244",
    ST: "IN",
    cityWithStateAbbr: "Hartsville, IN",
  },
  {
    zip: "47245",
    ST: "IN",
    cityWithStateAbbr: "Hayden, IN",
  },
  {
    zip: "47246",
    ST: "IN",
    cityWithStateAbbr: "Hope, IN",
  },
  {
    zip: "47247",
    ST: "IN",
    cityWithStateAbbr: "Jonesville, IN",
  },
  {
    zip: "47249",
    ST: "IN",
    cityWithStateAbbr: "Kurtz, IN",
  },
  {
    zip: "47250",
    ST: "IN",
    cityWithStateAbbr: "Madison, IN",
  },
  {
    zip: "47260",
    ST: "IN",
    cityWithStateAbbr: "Medora, IN",
  },
  {
    zip: "47261",
    ST: "IN",
    cityWithStateAbbr: "Millhousen, IN",
  },
  {
    zip: "47263",
    ST: "IN",
    cityWithStateAbbr: "New Point, IN",
  },
  {
    zip: "47264",
    ST: "IN",
    cityWithStateAbbr: "Norman, IN",
  },
  {
    zip: "47265",
    ST: "IN",
    cityWithStateAbbr: "North Vernon, IN",
  },
  {
    zip: "47270",
    ST: "IN",
    cityWithStateAbbr: "Paris Crossing, IN",
  },
  {
    zip: "47272",
    ST: "IN",
    cityWithStateAbbr: "Saint Paul, IN",
  },
  {
    zip: "47273",
    ST: "IN",
    cityWithStateAbbr: "Scipio, IN",
  },
  {
    zip: "47274",
    ST: "IN",
    cityWithStateAbbr: "Seymour, IN",
  },
  {
    zip: "47280",
    ST: "IN",
    cityWithStateAbbr: "Taylorsville, IN",
  },
  {
    zip: "47281",
    ST: "IN",
    cityWithStateAbbr: "Vallonia, IN",
  },
  {
    zip: "47282",
    ST: "IN",
    cityWithStateAbbr: "Vernon, IN",
  },
  {
    zip: "47283",
    ST: "IN",
    cityWithStateAbbr: "Westport, IN",
  },
  {
    zip: "47302",
    ST: "IN",
    cityWithStateAbbr: "Muncie, IN",
  },
  {
    zip: "47303",
    ST: "IN",
    cityWithStateAbbr: "Muncie, IN",
  },
  {
    zip: "47304",
    ST: "IN",
    cityWithStateAbbr: "Muncie, IN",
  },
  {
    zip: "47305",
    ST: "IN",
    cityWithStateAbbr: "Muncie, IN",
  },
  {
    zip: "47306",
    ST: "IN",
    cityWithStateAbbr: "Muncie, IN",
  },
  {
    zip: "47307",
    ST: "IN",
    cityWithStateAbbr: "Muncie, IN",
  },
  {
    zip: "47308",
    ST: "IN",
    cityWithStateAbbr: "Muncie, IN",
  },
  {
    zip: "47320",
    ST: "IN",
    cityWithStateAbbr: "Albany, IN",
  },
  {
    zip: "47322",
    ST: "IN",
    cityWithStateAbbr: "Bentonville, IN",
  },
  {
    zip: "47324",
    ST: "IN",
    cityWithStateAbbr: "Boston, IN",
  },
  {
    zip: "47325",
    ST: "IN",
    cityWithStateAbbr: "Brownsville, IN",
  },
  {
    zip: "47326",
    ST: "IN",
    cityWithStateAbbr: "Bryant, IN",
  },
  {
    zip: "47327",
    ST: "IN",
    cityWithStateAbbr: "Cambridge City, IN",
  },
  {
    zip: "47330",
    ST: "IN",
    cityWithStateAbbr: "Centerville, IN",
  },
  {
    zip: "47331",
    ST: "IN",
    cityWithStateAbbr: "Connersville, IN",
  },
  {
    zip: "47334",
    ST: "IN",
    cityWithStateAbbr: "Daleville, IN",
  },
  {
    zip: "47335",
    ST: "IN",
    cityWithStateAbbr: "Dublin, IN",
  },
  {
    zip: "47336",
    ST: "IN",
    cityWithStateAbbr: "Dunkirk, IN",
  },
  {
    zip: "47337",
    ST: "IN",
    cityWithStateAbbr: "Dunreith, IN",
  },
  {
    zip: "47338",
    ST: "IN",
    cityWithStateAbbr: "Eaton, IN",
  },
  {
    zip: "47339",
    ST: "IN",
    cityWithStateAbbr: "Economy, IN",
  },
  {
    zip: "47340",
    ST: "IN",
    cityWithStateAbbr: "Farmland, IN",
  },
  {
    zip: "47341",
    ST: "IN",
    cityWithStateAbbr: "Fountain City, IN",
  },
  {
    zip: "47342",
    ST: "IN",
    cityWithStateAbbr: "Gaston, IN",
  },
  {
    zip: "47344",
    ST: "IN",
    cityWithStateAbbr: "Greensboro, IN",
  },
  {
    zip: "47345",
    ST: "IN",
    cityWithStateAbbr: "Greens Fork, IN",
  },
  {
    zip: "47346",
    ST: "IN",
    cityWithStateAbbr: "Hagerstown, IN",
  },
  {
    zip: "47348",
    ST: "IN",
    cityWithStateAbbr: "Hartford City, IN",
  },
  {
    zip: "47351",
    ST: "IN",
    cityWithStateAbbr: "Kennard, IN",
  },
  {
    zip: "47352",
    ST: "IN",
    cityWithStateAbbr: "Lewisville, IN",
  },
  {
    zip: "47353",
    ST: "IN",
    cityWithStateAbbr: "Liberty, IN",
  },
  {
    zip: "47354",
    ST: "IN",
    cityWithStateAbbr: "Losantville, IN",
  },
  {
    zip: "47355",
    ST: "IN",
    cityWithStateAbbr: "Lynn, IN",
  },
  {
    zip: "47356",
    ST: "IN",
    cityWithStateAbbr: "Middletown, IN",
  },
  {
    zip: "47357",
    ST: "IN",
    cityWithStateAbbr: "Milton, IN",
  },
  {
    zip: "47358",
    ST: "IN",
    cityWithStateAbbr: "Modoc, IN",
  },
  {
    zip: "47359",
    ST: "IN",
    cityWithStateAbbr: "Montpelier, IN",
  },
  {
    zip: "47360",
    ST: "IN",
    cityWithStateAbbr: "Mooreland, IN",
  },
  {
    zip: "47361",
    ST: "IN",
    cityWithStateAbbr: "Mount Summit, IN",
  },
  {
    zip: "47362",
    ST: "IN",
    cityWithStateAbbr: "New Castle, IN",
  },
  {
    zip: "47366",
    ST: "IN",
    cityWithStateAbbr: "New Lisbon, IN",
  },
  {
    zip: "47367",
    ST: "IN",
    cityWithStateAbbr: "Oakville, IN",
  },
  {
    zip: "47368",
    ST: "IN",
    cityWithStateAbbr: "Parker City, IN",
  },
  {
    zip: "47369",
    ST: "IN",
    cityWithStateAbbr: "Pennville, IN",
  },
  {
    zip: "47370",
    ST: "IN",
    cityWithStateAbbr: "Pershing, IN",
  },
  {
    zip: "47371",
    ST: "IN",
    cityWithStateAbbr: "Portland, IN",
  },
  {
    zip: "47373",
    ST: "IN",
    cityWithStateAbbr: "Redkey, IN",
  },
  {
    zip: "47374",
    ST: "IN",
    cityWithStateAbbr: "Richmond, IN",
  },
  {
    zip: "47375",
    ST: "IN",
    cityWithStateAbbr: "Richmond, IN",
  },
  {
    zip: "47380",
    ST: "IN",
    cityWithStateAbbr: "Ridgeville, IN",
  },
  {
    zip: "47381",
    ST: "IN",
    cityWithStateAbbr: "Salamonia, IN",
  },
  {
    zip: "47382",
    ST: "IN",
    cityWithStateAbbr: "Saratoga, IN",
  },
  {
    zip: "47383",
    ST: "IN",
    cityWithStateAbbr: "Selma, IN",
  },
  {
    zip: "47384",
    ST: "IN",
    cityWithStateAbbr: "Shirley, IN",
  },
  {
    zip: "47385",
    ST: "IN",
    cityWithStateAbbr: "Spiceland, IN",
  },
  {
    zip: "47386",
    ST: "IN",
    cityWithStateAbbr: "Springport, IN",
  },
  {
    zip: "47387",
    ST: "IN",
    cityWithStateAbbr: "Straughn, IN",
  },
  {
    zip: "47388",
    ST: "IN",
    cityWithStateAbbr: "Sulphur Springs, IN",
  },
  {
    zip: "47390",
    ST: "IN",
    cityWithStateAbbr: "Union City, IN",
  },
  {
    zip: "47392",
    ST: "IN",
    cityWithStateAbbr: "Webster, IN",
  },
  {
    zip: "47393",
    ST: "IN",
    cityWithStateAbbr: "Williamsburg, IN",
  },
  {
    zip: "47394",
    ST: "IN",
    cityWithStateAbbr: "Winchester, IN",
  },
  {
    zip: "47396",
    ST: "IN",
    cityWithStateAbbr: "Yorktown, IN",
  },
  {
    zip: "47401",
    ST: "IN",
    cityWithStateAbbr: "Bloomington, IN",
  },
  {
    zip: "47402",
    ST: "IN",
    cityWithStateAbbr: "Bloomington, IN",
  },
  {
    zip: "47403",
    ST: "IN",
    cityWithStateAbbr: "Bloomington, IN",
  },
  {
    zip: "47404",
    ST: "IN",
    cityWithStateAbbr: "Bloomington, IN",
  },
  {
    zip: "47405",
    ST: "IN",
    cityWithStateAbbr: "Bloomington, IN",
  },
  {
    zip: "47406",
    ST: "IN",
    cityWithStateAbbr: "Bloomington, IN",
  },
  {
    zip: "47407",
    ST: "IN",
    cityWithStateAbbr: "Bloomington, IN",
  },
  {
    zip: "47408",
    ST: "IN",
    cityWithStateAbbr: "Bloomington, IN",
  },
  {
    zip: "47420",
    ST: "IN",
    cityWithStateAbbr: "Avoca, IN",
  },
  {
    zip: "47421",
    ST: "IN",
    cityWithStateAbbr: "Bedford, IN",
  },
  {
    zip: "47424",
    ST: "IN",
    cityWithStateAbbr: "Bloomfield, IN",
  },
  {
    zip: "47426",
    ST: "IN",
    cityWithStateAbbr: "Clear Creek, IN",
  },
  {
    zip: "47427",
    ST: "IN",
    cityWithStateAbbr: "Coal City, IN",
  },
  {
    zip: "47429",
    ST: "IN",
    cityWithStateAbbr: "Ellettsville, IN",
  },
  {
    zip: "47431",
    ST: "IN",
    cityWithStateAbbr: "Freedom, IN",
  },
  {
    zip: "47432",
    ST: "IN",
    cityWithStateAbbr: "French Lick, IN",
  },
  {
    zip: "47433",
    ST: "IN",
    cityWithStateAbbr: "Gosport, IN",
  },
  {
    zip: "47434",
    ST: "IN",
    cityWithStateAbbr: "Harrodsburg, IN",
  },
  {
    zip: "47435",
    ST: "IN",
    cityWithStateAbbr: "Helmsburg, IN",
  },
  {
    zip: "47436",
    ST: "IN",
    cityWithStateAbbr: "Heltonville, IN",
  },
  {
    zip: "47437",
    ST: "IN",
    cityWithStateAbbr: "Huron, IN",
  },
  {
    zip: "47438",
    ST: "IN",
    cityWithStateAbbr: "Jasonville, IN",
  },
  {
    zip: "47439",
    ST: "IN",
    cityWithStateAbbr: "Koleen, IN",
  },
  {
    zip: "47441",
    ST: "IN",
    cityWithStateAbbr: "Linton, IN",
  },
  {
    zip: "47443",
    ST: "IN",
    cityWithStateAbbr: "Lyons, IN",
  },
  {
    zip: "47445",
    ST: "IN",
    cityWithStateAbbr: "Midland, IN",
  },
  {
    zip: "47446",
    ST: "IN",
    cityWithStateAbbr: "Mitchell, IN",
  },
  {
    zip: "47448",
    ST: "IN",
    cityWithStateAbbr: "Nashville, IN",
  },
  {
    zip: "47449",
    ST: "IN",
    cityWithStateAbbr: "Newberry, IN",
  },
  {
    zip: "47451",
    ST: "IN",
    cityWithStateAbbr: "Oolitic, IN",
  },
  {
    zip: "47452",
    ST: "IN",
    cityWithStateAbbr: "Orleans, IN",
  },
  {
    zip: "47453",
    ST: "IN",
    cityWithStateAbbr: "Owensburg, IN",
  },
  {
    zip: "47454",
    ST: "IN",
    cityWithStateAbbr: "Paoli, IN",
  },
  {
    zip: "47455",
    ST: "IN",
    cityWithStateAbbr: "Patricksburg, IN",
  },
  {
    zip: "47456",
    ST: "IN",
    cityWithStateAbbr: "Quincy, IN",
  },
  {
    zip: "47457",
    ST: "IN",
    cityWithStateAbbr: "Scotland, IN",
  },
  {
    zip: "47458",
    ST: "IN",
    cityWithStateAbbr: "Smithville, IN",
  },
  {
    zip: "47459",
    ST: "IN",
    cityWithStateAbbr: "Solsberry, IN",
  },
  {
    zip: "47460",
    ST: "IN",
    cityWithStateAbbr: "Spencer, IN",
  },
  {
    zip: "47462",
    ST: "IN",
    cityWithStateAbbr: "Springville, IN",
  },
  {
    zip: "47463",
    ST: "IN",
    cityWithStateAbbr: "Stanford, IN",
  },
  {
    zip: "47464",
    ST: "IN",
    cityWithStateAbbr: "Stinesville, IN",
  },
  {
    zip: "47465",
    ST: "IN",
    cityWithStateAbbr: "Switz City, IN",
  },
  {
    zip: "47467",
    ST: "IN",
    cityWithStateAbbr: "Tunnelton, IN",
  },
  {
    zip: "47468",
    ST: "IN",
    cityWithStateAbbr: "Unionville, IN",
  },
  {
    zip: "47469",
    ST: "IN",
    cityWithStateAbbr: "West Baden Springs, IN",
  },
  {
    zip: "47470",
    ST: "IN",
    cityWithStateAbbr: "Williams, IN",
  },
  {
    zip: "47471",
    ST: "IN",
    cityWithStateAbbr: "Worthington, IN",
  },
  {
    zip: "47501",
    ST: "IN",
    cityWithStateAbbr: "Washington, IN",
  },
  {
    zip: "47512",
    ST: "IN",
    cityWithStateAbbr: "Bicknell, IN",
  },
  {
    zip: "47513",
    ST: "IN",
    cityWithStateAbbr: "Birdseye, IN",
  },
  {
    zip: "47514",
    ST: "IN",
    cityWithStateAbbr: "Branchville, IN",
  },
  {
    zip: "47515",
    ST: "IN",
    cityWithStateAbbr: "Bristow, IN",
  },
  {
    zip: "47516",
    ST: "IN",
    cityWithStateAbbr: "Bruceville, IN",
  },
  {
    zip: "47519",
    ST: "IN",
    cityWithStateAbbr: "Cannelburg, IN",
  },
  {
    zip: "47520",
    ST: "IN",
    cityWithStateAbbr: "Cannelton, IN",
  },
  {
    zip: "47521",
    ST: "IN",
    cityWithStateAbbr: "Celestine, IN",
  },
  {
    zip: "47522",
    ST: "IN",
    cityWithStateAbbr: "Crane, IN",
  },
  {
    zip: "47523",
    ST: "IN",
    cityWithStateAbbr: "Dale, IN",
  },
  {
    zip: "47524",
    ST: "IN",
    cityWithStateAbbr: "Decker, IN",
  },
  {
    zip: "47525",
    ST: "IN",
    cityWithStateAbbr: "Derby, IN",
  },
  {
    zip: "47527",
    ST: "IN",
    cityWithStateAbbr: "Dubois, IN",
  },
  {
    zip: "47528",
    ST: "IN",
    cityWithStateAbbr: "Edwardsport, IN",
  },
  {
    zip: "47529",
    ST: "IN",
    cityWithStateAbbr: "Elnora, IN",
  },
  {
    zip: "47531",
    ST: "IN",
    cityWithStateAbbr: "Evanston, IN",
  },
  {
    zip: "47532",
    ST: "IN",
    cityWithStateAbbr: "Ferdinand, IN",
  },
  {
    zip: "47535",
    ST: "IN",
    cityWithStateAbbr: "Freelandville, IN",
  },
  {
    zip: "47536",
    ST: "IN",
    cityWithStateAbbr: "Fulda, IN",
  },
  {
    zip: "47537",
    ST: "IN",
    cityWithStateAbbr: "Gentryville, IN",
  },
  {
    zip: "47541",
    ST: "IN",
    cityWithStateAbbr: "Holland, IN",
  },
  {
    zip: "47542",
    ST: "IN",
    cityWithStateAbbr: "Huntingburg, IN",
  },
  {
    zip: "47545",
    ST: "IN",
    cityWithStateAbbr: "Ireland, IN",
  },
  {
    zip: "47546",
    ST: "IN",
    cityWithStateAbbr: "Jasper, IN",
  },
  {
    zip: "47547",
    ST: "IN",
    cityWithStateAbbr: "Jasper, IN",
  },
  {
    zip: "47549",
    ST: "IN",
    cityWithStateAbbr: "Jasper, IN",
  },
  {
    zip: "47550",
    ST: "IN",
    cityWithStateAbbr: "Lamar, IN",
  },
  {
    zip: "47551",
    ST: "IN",
    cityWithStateAbbr: "Leopold, IN",
  },
  {
    zip: "47552",
    ST: "IN",
    cityWithStateAbbr: "Lincoln City, IN",
  },
  {
    zip: "47553",
    ST: "IN",
    cityWithStateAbbr: "Loogootee, IN",
  },
  {
    zip: "47556",
    ST: "IN",
    cityWithStateAbbr: "Mariah Hill, IN",
  },
  {
    zip: "47557",
    ST: "IN",
    cityWithStateAbbr: "Monroe City, IN",
  },
  {
    zip: "47558",
    ST: "IN",
    cityWithStateAbbr: "Montgomery, IN",
  },
  {
    zip: "47561",
    ST: "IN",
    cityWithStateAbbr: "Oaktown, IN",
  },
  {
    zip: "47562",
    ST: "IN",
    cityWithStateAbbr: "Odon, IN",
  },
  {
    zip: "47564",
    ST: "IN",
    cityWithStateAbbr: "Otwell, IN",
  },
  {
    zip: "47567",
    ST: "IN",
    cityWithStateAbbr: "Petersburg, IN",
  },
  {
    zip: "47568",
    ST: "IN",
    cityWithStateAbbr: "Plainville, IN",
  },
  {
    zip: "47573",
    ST: "IN",
    cityWithStateAbbr: "Ragsdale, IN",
  },
  {
    zip: "47574",
    ST: "IN",
    cityWithStateAbbr: "Rome, IN",
  },
  {
    zip: "47575",
    ST: "IN",
    cityWithStateAbbr: "Saint Anthony, IN",
  },
  {
    zip: "47576",
    ST: "IN",
    cityWithStateAbbr: "Saint Croix, IN",
  },
  {
    zip: "47577",
    ST: "IN",
    cityWithStateAbbr: "Saint Meinrad, IN",
  },
  {
    zip: "47578",
    ST: "IN",
    cityWithStateAbbr: "Sandborn, IN",
  },
  {
    zip: "47579",
    ST: "IN",
    cityWithStateAbbr: "Santa Claus, IN",
  },
  {
    zip: "47580",
    ST: "IN",
    cityWithStateAbbr: "Schnellville, IN",
  },
  {
    zip: "47581",
    ST: "IN",
    cityWithStateAbbr: "Shoals, IN",
  },
  {
    zip: "47584",
    ST: "IN",
    cityWithStateAbbr: "Spurgeon, IN",
  },
  {
    zip: "47585",
    ST: "IN",
    cityWithStateAbbr: "Stendal, IN",
  },
  {
    zip: "47586",
    ST: "IN",
    cityWithStateAbbr: "Tell City, IN",
  },
  {
    zip: "47588",
    ST: "IN",
    cityWithStateAbbr: "Troy, IN",
  },
  {
    zip: "47590",
    ST: "IN",
    cityWithStateAbbr: "Velpen, IN",
  },
  {
    zip: "47591",
    ST: "IN",
    cityWithStateAbbr: "Vincennes, IN",
  },
  {
    zip: "47596",
    ST: "IN",
    cityWithStateAbbr: "Westphalia, IN",
  },
  {
    zip: "47597",
    ST: "IN",
    cityWithStateAbbr: "Wheatland, IN",
  },
  {
    zip: "47598",
    ST: "IN",
    cityWithStateAbbr: "Winslow, IN",
  },
  {
    zip: "47601",
    ST: "IN",
    cityWithStateAbbr: "Boonville, IN",
  },
  {
    zip: "47610",
    ST: "IN",
    cityWithStateAbbr: "Chandler, IN",
  },
  {
    zip: "47611",
    ST: "IN",
    cityWithStateAbbr: "Chrisney, IN",
  },
  {
    zip: "47612",
    ST: "IN",
    cityWithStateAbbr: "Cynthiana, IN",
  },
  {
    zip: "47613",
    ST: "IN",
    cityWithStateAbbr: "Elberfeld, IN",
  },
  {
    zip: "47614",
    ST: "IN",
    cityWithStateAbbr: "Boonville, IN",
  },
  {
    zip: "47615",
    ST: "IN",
    cityWithStateAbbr: "Grandview, IN",
  },
  {
    zip: "47616",
    ST: "IN",
    cityWithStateAbbr: "Griffin, IN",
  },
  {
    zip: "47617",
    ST: "IN",
    cityWithStateAbbr: "Hatfield, IN",
  },
  {
    zip: "47618",
    ST: "IN",
    cityWithStateAbbr: "Inglefield, IN",
  },
  {
    zip: "47619",
    ST: "IN",
    cityWithStateAbbr: "Lynnville, IN",
  },
  {
    zip: "47620",
    ST: "IN",
    cityWithStateAbbr: "Mount Vernon, IN",
  },
  {
    zip: "47629",
    ST: "KY",
    cityWithStateAbbr: "Newburgh, KY",
  },
  {
    zip: "47630",
    ST: "IN",
    cityWithStateAbbr: "Newburgh, IN",
  },
  {
    zip: "47631",
    ST: "IN",
    cityWithStateAbbr: "New Harmony, IN",
  },
  {
    zip: "47633",
    ST: "IN",
    cityWithStateAbbr: "Poseyville, IN",
  },
  {
    zip: "47634",
    ST: "IN",
    cityWithStateAbbr: "Richland, IN",
  },
  {
    zip: "47635",
    ST: "IN",
    cityWithStateAbbr: "Rockport, IN",
  },
  {
    zip: "47637",
    ST: "IN",
    cityWithStateAbbr: "Tennyson, IN",
  },
  {
    zip: "47638",
    ST: "IN",
    cityWithStateAbbr: "Wadesville, IN",
  },
  {
    zip: "47639",
    ST: "IN",
    cityWithStateAbbr: "Haubstadt, IN",
  },
  {
    zip: "47640",
    ST: "IN",
    cityWithStateAbbr: "Hazleton, IN",
  },
  {
    zip: "47647",
    ST: "IN",
    cityWithStateAbbr: "Buckskin, IN",
  },
  {
    zip: "47648",
    ST: "IN",
    cityWithStateAbbr: "Fort Branch, IN",
  },
  {
    zip: "47649",
    ST: "IN",
    cityWithStateAbbr: "Francisco, IN",
  },
  {
    zip: "47654",
    ST: "IN",
    cityWithStateAbbr: "Mackey, IN",
  },
  {
    zip: "47660",
    ST: "IN",
    cityWithStateAbbr: "Oakland City, IN",
  },
  {
    zip: "47665",
    ST: "IN",
    cityWithStateAbbr: "Owensville, IN",
  },
  {
    zip: "47666",
    ST: "IN",
    cityWithStateAbbr: "Patoka, IN",
  },
  {
    zip: "47670",
    ST: "IN",
    cityWithStateAbbr: "Princeton, IN",
  },
  {
    zip: "47683",
    ST: "IN",
    cityWithStateAbbr: "Somerville, IN",
  },
  {
    zip: "47701",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47702",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47703",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47704",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47705",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47706",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47708",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47710",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47711",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47712",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47713",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47714",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47715",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47716",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47719",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47720",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47721",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47722",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47724",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47725",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47728",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47730",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47731",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47732",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47733",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47734",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47735",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47736",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47737",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47740",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47747",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47750",
    ST: "IN",
    cityWithStateAbbr: "Evansville, IN",
  },
  {
    zip: "47801",
    ST: "IN",
    cityWithStateAbbr: "Terre Haute, IN",
  },
  {
    zip: "47802",
    ST: "IN",
    cityWithStateAbbr: "Terre Haute, IN",
  },
  {
    zip: "47803",
    ST: "IN",
    cityWithStateAbbr: "Terre Haute, IN",
  },
  {
    zip: "47804",
    ST: "IN",
    cityWithStateAbbr: "Terre Haute, IN",
  },
  {
    zip: "47805",
    ST: "IN",
    cityWithStateAbbr: "Terre Haute, IN",
  },
  {
    zip: "47807",
    ST: "IN",
    cityWithStateAbbr: "Terre Haute, IN",
  },
  {
    zip: "47808",
    ST: "IN",
    cityWithStateAbbr: "Terre Haute, IN",
  },
  {
    zip: "47809",
    ST: "IN",
    cityWithStateAbbr: "Terre Haute, IN",
  },
  {
    zip: "47811",
    ST: "IN",
    cityWithStateAbbr: "Terre Haute, IN",
  },
  {
    zip: "47812",
    ST: "IN",
    cityWithStateAbbr: "Terre Haute, IN",
  },
  {
    zip: "47830",
    ST: "IN",
    cityWithStateAbbr: "Bellmore, IN",
  },
  {
    zip: "47831",
    ST: "IN",
    cityWithStateAbbr: "Blanford, IN",
  },
  {
    zip: "47832",
    ST: "IN",
    cityWithStateAbbr: "Bloomingdale, IN",
  },
  {
    zip: "47833",
    ST: "IN",
    cityWithStateAbbr: "Bowling Green, IN",
  },
  {
    zip: "47834",
    ST: "IN",
    cityWithStateAbbr: "Brazil, IN",
  },
  {
    zip: "47836",
    ST: "IN",
    cityWithStateAbbr: "Bridgeton, IN",
  },
  {
    zip: "47837",
    ST: "IN",
    cityWithStateAbbr: "Carbon, IN",
  },
  {
    zip: "47838",
    ST: "IN",
    cityWithStateAbbr: "Carlisle, IN",
  },
  {
    zip: "47840",
    ST: "IN",
    cityWithStateAbbr: "Centerpoint, IN",
  },
  {
    zip: "47841",
    ST: "IN",
    cityWithStateAbbr: "Clay City, IN",
  },
  {
    zip: "47842",
    ST: "IN",
    cityWithStateAbbr: "Clinton, IN",
  },
  {
    zip: "47845",
    ST: "IN",
    cityWithStateAbbr: "Coalmont, IN",
  },
  {
    zip: "47846",
    ST: "IN",
    cityWithStateAbbr: "Cory, IN",
  },
  {
    zip: "47847",
    ST: "IN",
    cityWithStateAbbr: "Dana, IN",
  },
  {
    zip: "47848",
    ST: "IN",
    cityWithStateAbbr: "Dugger, IN",
  },
  {
    zip: "47849",
    ST: "IN",
    cityWithStateAbbr: "Fairbanks, IN",
  },
  {
    zip: "47850",
    ST: "IN",
    cityWithStateAbbr: "Farmersburg, IN",
  },
  {
    zip: "47851",
    ST: "IN",
    cityWithStateAbbr: "Fontanet, IN",
  },
  {
    zip: "47852",
    ST: "IN",
    cityWithStateAbbr: "Graysville, IN",
  },
  {
    zip: "47853",
    ST: "IN",
    cityWithStateAbbr: "Harmony, IN",
  },
  {
    zip: "47854",
    ST: "IN",
    cityWithStateAbbr: "Hillsdale, IN",
  },
  {
    zip: "47855",
    ST: "IN",
    cityWithStateAbbr: "Hymera, IN",
  },
  {
    zip: "47857",
    ST: "IN",
    cityWithStateAbbr: "Knightsville, IN",
  },
  {
    zip: "47858",
    ST: "IN",
    cityWithStateAbbr: "Lewis, IN",
  },
  {
    zip: "47859",
    ST: "IN",
    cityWithStateAbbr: "Marshall, IN",
  },
  {
    zip: "47860",
    ST: "IN",
    cityWithStateAbbr: "Mecca, IN",
  },
  {
    zip: "47861",
    ST: "IN",
    cityWithStateAbbr: "Merom, IN",
  },
  {
    zip: "47862",
    ST: "IN",
    cityWithStateAbbr: "Montezuma, IN",
  },
  {
    zip: "47863",
    ST: "IN",
    cityWithStateAbbr: "New Goshen, IN",
  },
  {
    zip: "47865",
    ST: "IN",
    cityWithStateAbbr: "Paxton, IN",
  },
  {
    zip: "47866",
    ST: "IN",
    cityWithStateAbbr: "Pimento, IN",
  },
  {
    zip: "47868",
    ST: "IN",
    cityWithStateAbbr: "Poland, IN",
  },
  {
    zip: "47869",
    ST: "IN",
    cityWithStateAbbr: "Prairie Creek, IN",
  },
  {
    zip: "47870",
    ST: "IN",
    cityWithStateAbbr: "Prairieton, IN",
  },
  {
    zip: "47871",
    ST: "IN",
    cityWithStateAbbr: "Riley, IN",
  },
  {
    zip: "47872",
    ST: "IN",
    cityWithStateAbbr: "Rockville, IN",
  },
  {
    zip: "47874",
    ST: "IN",
    cityWithStateAbbr: "Rosedale, IN",
  },
  {
    zip: "47875",
    ST: "IN",
    cityWithStateAbbr: "Saint Bernice, IN",
  },
  {
    zip: "47876",
    ST: "IN",
    cityWithStateAbbr: "Saint Mary Of The Woods, IN",
  },
  {
    zip: "47878",
    ST: "IN",
    cityWithStateAbbr: "Seelyville, IN",
  },
  {
    zip: "47879",
    ST: "IN",
    cityWithStateAbbr: "Shelburn, IN",
  },
  {
    zip: "47880",
    ST: "IN",
    cityWithStateAbbr: "Shepardsville, IN",
  },
  {
    zip: "47881",
    ST: "IN",
    cityWithStateAbbr: "Staunton, IN",
  },
  {
    zip: "47882",
    ST: "IN",
    cityWithStateAbbr: "Sullivan, IN",
  },
  {
    zip: "47884",
    ST: "IN",
    cityWithStateAbbr: "Universal, IN",
  },
  {
    zip: "47885",
    ST: "IN",
    cityWithStateAbbr: "West Terre Haute, IN",
  },
  {
    zip: "47901",
    ST: "IN",
    cityWithStateAbbr: "Lafayette, IN",
  },
  {
    zip: "47902",
    ST: "IN",
    cityWithStateAbbr: "Lafayette, IN",
  },
  {
    zip: "47903",
    ST: "IN",
    cityWithStateAbbr: "Lafayette, IN",
  },
  {
    zip: "47904",
    ST: "IN",
    cityWithStateAbbr: "Lafayette, IN",
  },
  {
    zip: "47905",
    ST: "IN",
    cityWithStateAbbr: "Lafayette, IN",
  },
  {
    zip: "47906",
    ST: "IN",
    cityWithStateAbbr: "West Lafayette, IN",
  },
  {
    zip: "47907",
    ST: "IN",
    cityWithStateAbbr: "West Lafayette, IN",
  },
  {
    zip: "47909",
    ST: "IN",
    cityWithStateAbbr: "Lafayette, IN",
  },
  {
    zip: "47916",
    ST: "IN",
    cityWithStateAbbr: "Alamo, IN",
  },
  {
    zip: "47917",
    ST: "IN",
    cityWithStateAbbr: "Ambia, IN",
  },
  {
    zip: "47918",
    ST: "IN",
    cityWithStateAbbr: "Attica, IN",
  },
  {
    zip: "47920",
    ST: "IN",
    cityWithStateAbbr: "Battle Ground, IN",
  },
  {
    zip: "47921",
    ST: "IN",
    cityWithStateAbbr: "Boswell, IN",
  },
  {
    zip: "47922",
    ST: "IN",
    cityWithStateAbbr: "Brook, IN",
  },
  {
    zip: "47923",
    ST: "IN",
    cityWithStateAbbr: "Brookston, IN",
  },
  {
    zip: "47924",
    ST: "IN",
    cityWithStateAbbr: "Buck Creek, IN",
  },
  {
    zip: "47925",
    ST: "IN",
    cityWithStateAbbr: "Buffalo, IN",
  },
  {
    zip: "47926",
    ST: "IN",
    cityWithStateAbbr: "Burnettsville, IN",
  },
  {
    zip: "47928",
    ST: "IN",
    cityWithStateAbbr: "Cayuga, IN",
  },
  {
    zip: "47929",
    ST: "IN",
    cityWithStateAbbr: "Chalmers, IN",
  },
  {
    zip: "47930",
    ST: "IN",
    cityWithStateAbbr: "Clarks Hill, IN",
  },
  {
    zip: "47932",
    ST: "IN",
    cityWithStateAbbr: "Covington, IN",
  },
  {
    zip: "47933",
    ST: "IN",
    cityWithStateAbbr: "Crawfordsville, IN",
  },
  {
    zip: "47934",
    ST: "IN",
    cityWithStateAbbr: "Crawfordsville, IN",
  },
  {
    zip: "47935",
    ST: "IN",
    cityWithStateAbbr: "Crawfordsville, IN",
  },
  {
    zip: "47936",
    ST: "IN",
    cityWithStateAbbr: "Crawfordsville, IN",
  },
  {
    zip: "47937",
    ST: "IN",
    cityWithStateAbbr: "Crawfordsville, IN",
  },
  {
    zip: "47938",
    ST: "IN",
    cityWithStateAbbr: "Crawfordsville, IN",
  },
  {
    zip: "47939",
    ST: "IN",
    cityWithStateAbbr: "Crawfordsville, IN",
  },
  {
    zip: "47940",
    ST: "IN",
    cityWithStateAbbr: "Darlington, IN",
  },
  {
    zip: "47941",
    ST: "IN",
    cityWithStateAbbr: "Dayton, IN",
  },
  {
    zip: "47942",
    ST: "IN",
    cityWithStateAbbr: "Earl Park, IN",
  },
  {
    zip: "47943",
    ST: "IN",
    cityWithStateAbbr: "Fair Oaks, IN",
  },
  {
    zip: "47944",
    ST: "IN",
    cityWithStateAbbr: "Fowler, IN",
  },
  {
    zip: "47946",
    ST: "IN",
    cityWithStateAbbr: "Francesville, IN",
  },
  {
    zip: "47948",
    ST: "IN",
    cityWithStateAbbr: "Goodland, IN",
  },
  {
    zip: "47949",
    ST: "IN",
    cityWithStateAbbr: "Hillsboro, IN",
  },
  {
    zip: "47950",
    ST: "IN",
    cityWithStateAbbr: "Idaville, IN",
  },
  {
    zip: "47951",
    ST: "IN",
    cityWithStateAbbr: "Kentland, IN",
  },
  {
    zip: "47952",
    ST: "IN",
    cityWithStateAbbr: "Kingman, IN",
  },
  {
    zip: "47954",
    ST: "IN",
    cityWithStateAbbr: "Ladoga, IN",
  },
  {
    zip: "47955",
    ST: "IN",
    cityWithStateAbbr: "Linden, IN",
  },
  {
    zip: "47957",
    ST: "IN",
    cityWithStateAbbr: "Medaryville, IN",
  },
  {
    zip: "47958",
    ST: "IN",
    cityWithStateAbbr: "Mellott, IN",
  },
  {
    zip: "47959",
    ST: "IN",
    cityWithStateAbbr: "Monon, IN",
  },
  {
    zip: "47960",
    ST: "IN",
    cityWithStateAbbr: "Monticello, IN",
  },
  {
    zip: "47962",
    ST: "IN",
    cityWithStateAbbr: "Montmorenci, IN",
  },
  {
    zip: "47963",
    ST: "IN",
    cityWithStateAbbr: "Morocco, IN",
  },
  {
    zip: "47964",
    ST: "IN",
    cityWithStateAbbr: "Mount Ayr, IN",
  },
  {
    zip: "47965",
    ST: "IN",
    cityWithStateAbbr: "New Market, IN",
  },
  {
    zip: "47966",
    ST: "IN",
    cityWithStateAbbr: "Newport, IN",
  },
  {
    zip: "47967",
    ST: "IN",
    cityWithStateAbbr: "New Richmond, IN",
  },
  {
    zip: "47968",
    ST: "IN",
    cityWithStateAbbr: "New Ross, IN",
  },
  {
    zip: "47969",
    ST: "IN",
    cityWithStateAbbr: "Newtown, IN",
  },
  {
    zip: "47970",
    ST: "IN",
    cityWithStateAbbr: "Otterbein, IN",
  },
  {
    zip: "47971",
    ST: "IN",
    cityWithStateAbbr: "Oxford, IN",
  },
  {
    zip: "47974",
    ST: "IN",
    cityWithStateAbbr: "Perrysville, IN",
  },
  {
    zip: "47975",
    ST: "IN",
    cityWithStateAbbr: "Pine Village, IN",
  },
  {
    zip: "47977",
    ST: "IN",
    cityWithStateAbbr: "Remington, IN",
  },
  {
    zip: "47978",
    ST: "IN",
    cityWithStateAbbr: "Rensselaer, IN",
  },
  {
    zip: "47980",
    ST: "IN",
    cityWithStateAbbr: "Reynolds, IN",
  },
  {
    zip: "47981",
    ST: "IN",
    cityWithStateAbbr: "Romney, IN",
  },
  {
    zip: "47982",
    ST: "IN",
    cityWithStateAbbr: "State Line, IN",
  },
  {
    zip: "47983",
    ST: "IN",
    cityWithStateAbbr: "Stockwell, IN",
  },
  {
    zip: "47984",
    ST: "IN",
    cityWithStateAbbr: "Talbot, IN",
  },
  {
    zip: "47986",
    ST: "IN",
    cityWithStateAbbr: "Templeton, IN",
  },
  {
    zip: "47987",
    ST: "IN",
    cityWithStateAbbr: "Veedersburg, IN",
  },
  {
    zip: "47988",
    ST: "IN",
    cityWithStateAbbr: "Wallace, IN",
  },
  {
    zip: "47989",
    ST: "IN",
    cityWithStateAbbr: "Waveland, IN",
  },
  {
    zip: "47990",
    ST: "IN",
    cityWithStateAbbr: "Waynetown, IN",
  },
  {
    zip: "47991",
    ST: "IN",
    cityWithStateAbbr: "West Lebanon, IN",
  },
  {
    zip: "47992",
    ST: "IN",
    cityWithStateAbbr: "Westpoint, IN",
  },
  {
    zip: "47993",
    ST: "IN",
    cityWithStateAbbr: "Williamsport, IN",
  },
  {
    zip: "47994",
    ST: "IN",
    cityWithStateAbbr: "Wingate, IN",
  },
  {
    zip: "47995",
    ST: "IN",
    cityWithStateAbbr: "Wolcott, IN",
  },
  {
    zip: "47996",
    ST: "IN",
    cityWithStateAbbr: "West Lafayette, IN",
  },
  {
    zip: "47997",
    ST: "IN",
    cityWithStateAbbr: "Yeoman, IN",
  },
  {
    zip: "48001",
    ST: "MI",
    cityWithStateAbbr: "Algonac, MI",
  },
  {
    zip: "48002",
    ST: "MI",
    cityWithStateAbbr: "Allenton, MI",
  },
  {
    zip: "48003",
    ST: "MI",
    cityWithStateAbbr: "Almont, MI",
  },
  {
    zip: "48004",
    ST: "MI",
    cityWithStateAbbr: "Anchorville, MI",
  },
  {
    zip: "48005",
    ST: "MI",
    cityWithStateAbbr: "Armada, MI",
  },
  {
    zip: "48006",
    ST: "MI",
    cityWithStateAbbr: "Avoca, MI",
  },
  {
    zip: "48007",
    ST: "MI",
    cityWithStateAbbr: "Troy, MI",
  },
  {
    zip: "48009",
    ST: "MI",
    cityWithStateAbbr: "Birmingham, MI",
  },
  {
    zip: "48012",
    ST: "MI",
    cityWithStateAbbr: "Birmingham, MI",
  },
  {
    zip: "48014",
    ST: "MI",
    cityWithStateAbbr: "Capac, MI",
  },
  {
    zip: "48015",
    ST: "MI",
    cityWithStateAbbr: "Center Line, MI",
  },
  {
    zip: "48017",
    ST: "MI",
    cityWithStateAbbr: "Clawson, MI",
  },
  {
    zip: "48021",
    ST: "MI",
    cityWithStateAbbr: "Eastpointe, MI",
  },
  {
    zip: "48022",
    ST: "MI",
    cityWithStateAbbr: "Emmett, MI",
  },
  {
    zip: "48023",
    ST: "MI",
    cityWithStateAbbr: "Fair Haven, MI",
  },
  {
    zip: "48025",
    ST: "MI",
    cityWithStateAbbr: "Franklin, MI",
  },
  {
    zip: "48026",
    ST: "MI",
    cityWithStateAbbr: "Fraser, MI",
  },
  {
    zip: "48027",
    ST: "MI",
    cityWithStateAbbr: "Goodells, MI",
  },
  {
    zip: "48028",
    ST: "MI",
    cityWithStateAbbr: "Harsens Island, MI",
  },
  {
    zip: "48030",
    ST: "MI",
    cityWithStateAbbr: "Hazel Park, MI",
  },
  {
    zip: "48032",
    ST: "MI",
    cityWithStateAbbr: "Jeddo, MI",
  },
  {
    zip: "48033",
    ST: "MI",
    cityWithStateAbbr: "Southfield, MI",
  },
  {
    zip: "48034",
    ST: "MI",
    cityWithStateAbbr: "Southfield, MI",
  },
  {
    zip: "48035",
    ST: "MI",
    cityWithStateAbbr: "Clinton Township, MI",
  },
  {
    zip: "48036",
    ST: "MI",
    cityWithStateAbbr: "Clinton Township, MI",
  },
  {
    zip: "48037",
    ST: "MI",
    cityWithStateAbbr: "Southfield, MI",
  },
  {
    zip: "48038",
    ST: "MI",
    cityWithStateAbbr: "Clinton Township, MI",
  },
  {
    zip: "48039",
    ST: "MI",
    cityWithStateAbbr: "Marine City, MI",
  },
  {
    zip: "48040",
    ST: "MI",
    cityWithStateAbbr: "Marysville, MI",
  },
  {
    zip: "48041",
    ST: "MI",
    cityWithStateAbbr: "Memphis, MI",
  },
  {
    zip: "48042",
    ST: "MI",
    cityWithStateAbbr: "Macomb, MI",
  },
  {
    zip: "48043",
    ST: "MI",
    cityWithStateAbbr: "Mount Clemens, MI",
  },
  {
    zip: "48044",
    ST: "MI",
    cityWithStateAbbr: "Macomb, MI",
  },
  {
    zip: "48045",
    ST: "MI",
    cityWithStateAbbr: "Harrison Township, MI",
  },
  {
    zip: "48046",
    ST: "MI",
    cityWithStateAbbr: "Mount Clemens, MI",
  },
  {
    zip: "48047",
    ST: "MI",
    cityWithStateAbbr: "New Baltimore, MI",
  },
  {
    zip: "48048",
    ST: "MI",
    cityWithStateAbbr: "New Haven, MI",
  },
  {
    zip: "48049",
    ST: "MI",
    cityWithStateAbbr: "North Street, MI",
  },
  {
    zip: "48050",
    ST: "MI",
    cityWithStateAbbr: "New Haven, MI",
  },
  {
    zip: "48051",
    ST: "MI",
    cityWithStateAbbr: "New Baltimore, MI",
  },
  {
    zip: "48054",
    ST: "MI",
    cityWithStateAbbr: "East China, MI",
  },
  {
    zip: "48059",
    ST: "MI",
    cityWithStateAbbr: "Fort Gratiot, MI",
  },
  {
    zip: "48060",
    ST: "MI",
    cityWithStateAbbr: "Port Huron, MI",
  },
  {
    zip: "48061",
    ST: "MI",
    cityWithStateAbbr: "Port Huron, MI",
  },
  {
    zip: "48062",
    ST: "MI",
    cityWithStateAbbr: "Richmond, MI",
  },
  {
    zip: "48063",
    ST: "MI",
    cityWithStateAbbr: "Columbus, MI",
  },
  {
    zip: "48064",
    ST: "MI",
    cityWithStateAbbr: "Casco, MI",
  },
  {
    zip: "48065",
    ST: "MI",
    cityWithStateAbbr: "Romeo, MI",
  },
  {
    zip: "48066",
    ST: "MI",
    cityWithStateAbbr: "Roseville, MI",
  },
  {
    zip: "48067",
    ST: "MI",
    cityWithStateAbbr: "Royal Oak, MI",
  },
  {
    zip: "48068",
    ST: "MI",
    cityWithStateAbbr: "Royal Oak, MI",
  },
  {
    zip: "48069",
    ST: "MI",
    cityWithStateAbbr: "Pleasant Ridge, MI",
  },
  {
    zip: "48070",
    ST: "MI",
    cityWithStateAbbr: "Huntington Woods, MI",
  },
  {
    zip: "48071",
    ST: "MI",
    cityWithStateAbbr: "Madison Heights, MI",
  },
  {
    zip: "48072",
    ST: "MI",
    cityWithStateAbbr: "Berkley, MI",
  },
  {
    zip: "48073",
    ST: "MI",
    cityWithStateAbbr: "Royal Oak, MI",
  },
  {
    zip: "48074",
    ST: "MI",
    cityWithStateAbbr: "Smiths Creek, MI",
  },
  {
    zip: "48075",
    ST: "MI",
    cityWithStateAbbr: "Southfield, MI",
  },
  {
    zip: "48076",
    ST: "MI",
    cityWithStateAbbr: "Southfield, MI",
  },
  {
    zip: "48079",
    ST: "MI",
    cityWithStateAbbr: "Saint Clair, MI",
  },
  {
    zip: "48080",
    ST: "MI",
    cityWithStateAbbr: "Saint Clair Shores, MI",
  },
  {
    zip: "48081",
    ST: "MI",
    cityWithStateAbbr: "Saint Clair Shores, MI",
  },
  {
    zip: "48082",
    ST: "MI",
    cityWithStateAbbr: "Saint Clair Shores, MI",
  },
  {
    zip: "48083",
    ST: "MI",
    cityWithStateAbbr: "Troy, MI",
  },
  {
    zip: "48084",
    ST: "MI",
    cityWithStateAbbr: "Troy, MI",
  },
  {
    zip: "48085",
    ST: "MI",
    cityWithStateAbbr: "Troy, MI",
  },
  {
    zip: "48086",
    ST: "MI",
    cityWithStateAbbr: "Southfield, MI",
  },
  {
    zip: "48088",
    ST: "MI",
    cityWithStateAbbr: "Warren, MI",
  },
  {
    zip: "48089",
    ST: "MI",
    cityWithStateAbbr: "Warren, MI",
  },
  {
    zip: "48090",
    ST: "MI",
    cityWithStateAbbr: "Warren, MI",
  },
  {
    zip: "48091",
    ST: "MI",
    cityWithStateAbbr: "Warren, MI",
  },
  {
    zip: "48092",
    ST: "MI",
    cityWithStateAbbr: "Warren, MI",
  },
  {
    zip: "48093",
    ST: "MI",
    cityWithStateAbbr: "Warren, MI",
  },
  {
    zip: "48094",
    ST: "MI",
    cityWithStateAbbr: "Washington, MI",
  },
  {
    zip: "48095",
    ST: "MI",
    cityWithStateAbbr: "Washington, MI",
  },
  {
    zip: "48096",
    ST: "MI",
    cityWithStateAbbr: "Ray, MI",
  },
  {
    zip: "48097",
    ST: "MI",
    cityWithStateAbbr: "Yale, MI",
  },
  {
    zip: "48098",
    ST: "MI",
    cityWithStateAbbr: "Troy, MI",
  },
  {
    zip: "48099",
    ST: "MI",
    cityWithStateAbbr: "Troy, MI",
  },
  {
    zip: "48101",
    ST: "MI",
    cityWithStateAbbr: "Allen Park, MI",
  },
  {
    zip: "48103",
    ST: "MI",
    cityWithStateAbbr: "Ann Arbor, MI",
  },
  {
    zip: "48104",
    ST: "MI",
    cityWithStateAbbr: "Ann Arbor, MI",
  },
  {
    zip: "48105",
    ST: "MI",
    cityWithStateAbbr: "Ann Arbor, MI",
  },
  {
    zip: "48106",
    ST: "MI",
    cityWithStateAbbr: "Ann Arbor, MI",
  },
  {
    zip: "48107",
    ST: "MI",
    cityWithStateAbbr: "Ann Arbor, MI",
  },
  {
    zip: "48108",
    ST: "MI",
    cityWithStateAbbr: "Ann Arbor, MI",
  },
  {
    zip: "48109",
    ST: "MI",
    cityWithStateAbbr: "Ann Arbor, MI",
  },
  {
    zip: "48110",
    ST: "MI",
    cityWithStateAbbr: "Azalia, MI",
  },
  {
    zip: "48111",
    ST: "MI",
    cityWithStateAbbr: "Belleville, MI",
  },
  {
    zip: "48112",
    ST: "MI",
    cityWithStateAbbr: "Belleville, MI",
  },
  {
    zip: "48113",
    ST: "MI",
    cityWithStateAbbr: "Ann Arbor, MI",
  },
  {
    zip: "48114",
    ST: "MI",
    cityWithStateAbbr: "Brighton, MI",
  },
  {
    zip: "48115",
    ST: "MI",
    cityWithStateAbbr: "Bridgewater, MI",
  },
  {
    zip: "48116",
    ST: "MI",
    cityWithStateAbbr: "Brighton, MI",
  },
  {
    zip: "48117",
    ST: "MI",
    cityWithStateAbbr: "Carleton, MI",
  },
  {
    zip: "48118",
    ST: "MI",
    cityWithStateAbbr: "Chelsea, MI",
  },
  {
    zip: "48120",
    ST: "MI",
    cityWithStateAbbr: "Dearborn, MI",
  },
  {
    zip: "48121",
    ST: "MI",
    cityWithStateAbbr: "Dearborn, MI",
  },
  {
    zip: "48122",
    ST: "MI",
    cityWithStateAbbr: "Melvindale, MI",
  },
  {
    zip: "48123",
    ST: "MI",
    cityWithStateAbbr: "Dearborn, MI",
  },
  {
    zip: "48124",
    ST: "MI",
    cityWithStateAbbr: "Dearborn, MI",
  },
  {
    zip: "48125",
    ST: "MI",
    cityWithStateAbbr: "Dearborn Heights, MI",
  },
  {
    zip: "48126",
    ST: "MI",
    cityWithStateAbbr: "Dearborn, MI",
  },
  {
    zip: "48127",
    ST: "MI",
    cityWithStateAbbr: "Dearborn Heights, MI",
  },
  {
    zip: "48128",
    ST: "MI",
    cityWithStateAbbr: "Dearborn, MI",
  },
  {
    zip: "48130",
    ST: "MI",
    cityWithStateAbbr: "Dexter, MI",
  },
  {
    zip: "48131",
    ST: "MI",
    cityWithStateAbbr: "Dundee, MI",
  },
  {
    zip: "48133",
    ST: "MI",
    cityWithStateAbbr: "Erie, MI",
  },
  {
    zip: "48134",
    ST: "MI",
    cityWithStateAbbr: "Flat Rock, MI",
  },
  {
    zip: "48135",
    ST: "MI",
    cityWithStateAbbr: "Garden City, MI",
  },
  {
    zip: "48136",
    ST: "MI",
    cityWithStateAbbr: "Garden City, MI",
  },
  {
    zip: "48137",
    ST: "MI",
    cityWithStateAbbr: "Gregory, MI",
  },
  {
    zip: "48138",
    ST: "MI",
    cityWithStateAbbr: "Grosse Ile, MI",
  },
  {
    zip: "48139",
    ST: "MI",
    cityWithStateAbbr: "Hamburg, MI",
  },
  {
    zip: "48140",
    ST: "MI",
    cityWithStateAbbr: "Ida, MI",
  },
  {
    zip: "48141",
    ST: "MI",
    cityWithStateAbbr: "Inkster, MI",
  },
  {
    zip: "48143",
    ST: "MI",
    cityWithStateAbbr: "Lakeland, MI",
  },
  {
    zip: "48144",
    ST: "MI",
    cityWithStateAbbr: "Lambertville, MI",
  },
  {
    zip: "48145",
    ST: "MI",
    cityWithStateAbbr: "La Salle, MI",
  },
  {
    zip: "48146",
    ST: "MI",
    cityWithStateAbbr: "Lincoln Park, MI",
  },
  {
    zip: "48150",
    ST: "MI",
    cityWithStateAbbr: "Livonia, MI",
  },
  {
    zip: "48151",
    ST: "MI",
    cityWithStateAbbr: "Livonia, MI",
  },
  {
    zip: "48152",
    ST: "MI",
    cityWithStateAbbr: "Livonia, MI",
  },
  {
    zip: "48153",
    ST: "MI",
    cityWithStateAbbr: "Livonia, MI",
  },
  {
    zip: "48154",
    ST: "MI",
    cityWithStateAbbr: "Livonia, MI",
  },
  {
    zip: "48157",
    ST: "MI",
    cityWithStateAbbr: "Luna Pier, MI",
  },
  {
    zip: "48158",
    ST: "MI",
    cityWithStateAbbr: "Manchester, MI",
  },
  {
    zip: "48159",
    ST: "MI",
    cityWithStateAbbr: "Maybee, MI",
  },
  {
    zip: "48160",
    ST: "MI",
    cityWithStateAbbr: "Milan, MI",
  },
  {
    zip: "48161",
    ST: "MI",
    cityWithStateAbbr: "Monroe, MI",
  },
  {
    zip: "48162",
    ST: "MI",
    cityWithStateAbbr: "Monroe, MI",
  },
  {
    zip: "48164",
    ST: "MI",
    cityWithStateAbbr: "New Boston, MI",
  },
  {
    zip: "48165",
    ST: "MI",
    cityWithStateAbbr: "New Hudson, MI",
  },
  {
    zip: "48166",
    ST: "MI",
    cityWithStateAbbr: "Newport, MI",
  },
  {
    zip: "48167",
    ST: "MI",
    cityWithStateAbbr: "Northville, MI",
  },
  {
    zip: "48168",
    ST: "MI",
    cityWithStateAbbr: "Northville, MI",
  },
  {
    zip: "48169",
    ST: "MI",
    cityWithStateAbbr: "Pinckney, MI",
  },
  {
    zip: "48170",
    ST: "MI",
    cityWithStateAbbr: "Plymouth, MI",
  },
  {
    zip: "48173",
    ST: "MI",
    cityWithStateAbbr: "Rockwood, MI",
  },
  {
    zip: "48174",
    ST: "MI",
    cityWithStateAbbr: "Romulus, MI",
  },
  {
    zip: "48175",
    ST: "MI",
    cityWithStateAbbr: "Salem, MI",
  },
  {
    zip: "48176",
    ST: "MI",
    cityWithStateAbbr: "Saline, MI",
  },
  {
    zip: "48177",
    ST: "MI",
    cityWithStateAbbr: "Samaria, MI",
  },
  {
    zip: "48178",
    ST: "MI",
    cityWithStateAbbr: "South Lyon, MI",
  },
  {
    zip: "48179",
    ST: "MI",
    cityWithStateAbbr: "South Rockwood, MI",
  },
  {
    zip: "48180",
    ST: "MI",
    cityWithStateAbbr: "Taylor, MI",
  },
  {
    zip: "48182",
    ST: "MI",
    cityWithStateAbbr: "Temperance, MI",
  },
  {
    zip: "48183",
    ST: "MI",
    cityWithStateAbbr: "Trenton, MI",
  },
  {
    zip: "48184",
    ST: "MI",
    cityWithStateAbbr: "Wayne, MI",
  },
  {
    zip: "48185",
    ST: "MI",
    cityWithStateAbbr: "Westland, MI",
  },
  {
    zip: "48186",
    ST: "MI",
    cityWithStateAbbr: "Westland, MI",
  },
  {
    zip: "48187",
    ST: "MI",
    cityWithStateAbbr: "Canton, MI",
  },
  {
    zip: "48188",
    ST: "MI",
    cityWithStateAbbr: "Canton, MI",
  },
  {
    zip: "48189",
    ST: "MI",
    cityWithStateAbbr: "Whitmore Lake, MI",
  },
  {
    zip: "48190",
    ST: "MI",
    cityWithStateAbbr: "Whittaker, MI",
  },
  {
    zip: "48191",
    ST: "MI",
    cityWithStateAbbr: "Willis, MI",
  },
  {
    zip: "48192",
    ST: "MI",
    cityWithStateAbbr: "Wyandotte, MI",
  },
  {
    zip: "48193",
    ST: "MI",
    cityWithStateAbbr: "Riverview, MI",
  },
  {
    zip: "48195",
    ST: "MI",
    cityWithStateAbbr: "Southgate, MI",
  },
  {
    zip: "48197",
    ST: "MI",
    cityWithStateAbbr: "Ypsilanti, MI",
  },
  {
    zip: "48198",
    ST: "MI",
    cityWithStateAbbr: "Ypsilanti, MI",
  },
  {
    zip: "48201",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48202",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48203",
    ST: "MI",
    cityWithStateAbbr: "Highland Park, MI",
  },
  {
    zip: "48204",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48205",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48206",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48207",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48208",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48209",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48210",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48211",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48212",
    ST: "MI",
    cityWithStateAbbr: "Hamtramck, MI",
  },
  {
    zip: "48213",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48214",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48215",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48216",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48217",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48218",
    ST: "MI",
    cityWithStateAbbr: "River Rouge, MI",
  },
  {
    zip: "48219",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48220",
    ST: "MI",
    cityWithStateAbbr: "Ferndale, MI",
  },
  {
    zip: "48221",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48222",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48223",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48224",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48225",
    ST: "MI",
    cityWithStateAbbr: "Harper Woods, MI",
  },
  {
    zip: "48226",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48227",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48228",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48229",
    ST: "MI",
    cityWithStateAbbr: "Ecorse, MI",
  },
  {
    zip: "48230",
    ST: "MI",
    cityWithStateAbbr: "Grosse Pointe, MI",
  },
  {
    zip: "48231",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48232",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48233",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48234",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48235",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48236",
    ST: "MI",
    cityWithStateAbbr: "Grosse Pointe, MI",
  },
  {
    zip: "48237",
    ST: "MI",
    cityWithStateAbbr: "Oak Park, MI",
  },
  {
    zip: "48238",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48239",
    ST: "MI",
    cityWithStateAbbr: "Redford, MI",
  },
  {
    zip: "48240",
    ST: "MI",
    cityWithStateAbbr: "Redford, MI",
  },
  {
    zip: "48242",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48243",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48244",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48255",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48260",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48264",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48265",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48266",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48267",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48268",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48269",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48272",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48275",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48277",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48278",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48279",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48288",
    ST: "MI",
    cityWithStateAbbr: "Detroit, MI",
  },
  {
    zip: "48301",
    ST: "MI",
    cityWithStateAbbr: "Bloomfield Hills, MI",
  },
  {
    zip: "48302",
    ST: "MI",
    cityWithStateAbbr: "Bloomfield Hills, MI",
  },
  {
    zip: "48303",
    ST: "MI",
    cityWithStateAbbr: "Bloomfield Hills, MI",
  },
  {
    zip: "48304",
    ST: "MI",
    cityWithStateAbbr: "Bloomfield Hills, MI",
  },
  {
    zip: "48306",
    ST: "MI",
    cityWithStateAbbr: "Rochester, MI",
  },
  {
    zip: "48307",
    ST: "MI",
    cityWithStateAbbr: "Rochester, MI",
  },
  {
    zip: "48308",
    ST: "MI",
    cityWithStateAbbr: "Rochester, MI",
  },
  {
    zip: "48309",
    ST: "MI",
    cityWithStateAbbr: "Rochester, MI",
  },
  {
    zip: "48310",
    ST: "MI",
    cityWithStateAbbr: "Sterling Heights, MI",
  },
  {
    zip: "48311",
    ST: "MI",
    cityWithStateAbbr: "Sterling Heights, MI",
  },
  {
    zip: "48312",
    ST: "MI",
    cityWithStateAbbr: "Sterling Heights, MI",
  },
  {
    zip: "48313",
    ST: "MI",
    cityWithStateAbbr: "Sterling Heights, MI",
  },
  {
    zip: "48314",
    ST: "MI",
    cityWithStateAbbr: "Sterling Heights, MI",
  },
  {
    zip: "48315",
    ST: "MI",
    cityWithStateAbbr: "Utica, MI",
  },
  {
    zip: "48316",
    ST: "MI",
    cityWithStateAbbr: "Utica, MI",
  },
  {
    zip: "48317",
    ST: "MI",
    cityWithStateAbbr: "Utica, MI",
  },
  {
    zip: "48318",
    ST: "MI",
    cityWithStateAbbr: "Utica, MI",
  },
  {
    zip: "48320",
    ST: "MI",
    cityWithStateAbbr: "Keego Harbor, MI",
  },
  {
    zip: "48321",
    ST: "MI",
    cityWithStateAbbr: "Auburn Hills, MI",
  },
  {
    zip: "48322",
    ST: "MI",
    cityWithStateAbbr: "West Bloomfield, MI",
  },
  {
    zip: "48323",
    ST: "MI",
    cityWithStateAbbr: "West Bloomfield, MI",
  },
  {
    zip: "48324",
    ST: "MI",
    cityWithStateAbbr: "West Bloomfield, MI",
  },
  {
    zip: "48325",
    ST: "MI",
    cityWithStateAbbr: "West Bloomfield, MI",
  },
  {
    zip: "48326",
    ST: "MI",
    cityWithStateAbbr: "Auburn Hills, MI",
  },
  {
    zip: "48327",
    ST: "MI",
    cityWithStateAbbr: "Waterford, MI",
  },
  {
    zip: "48328",
    ST: "MI",
    cityWithStateAbbr: "Waterford, MI",
  },
  {
    zip: "48329",
    ST: "MI",
    cityWithStateAbbr: "Waterford, MI",
  },
  {
    zip: "48330",
    ST: "MI",
    cityWithStateAbbr: "Drayton Plains, MI",
  },
  {
    zip: "48331",
    ST: "MI",
    cityWithStateAbbr: "Farmington, MI",
  },
  {
    zip: "48332",
    ST: "MI",
    cityWithStateAbbr: "Farmington, MI",
  },
  {
    zip: "48333",
    ST: "MI",
    cityWithStateAbbr: "Farmington, MI",
  },
  {
    zip: "48334",
    ST: "MI",
    cityWithStateAbbr: "Farmington, MI",
  },
  {
    zip: "48335",
    ST: "MI",
    cityWithStateAbbr: "Farmington, MI",
  },
  {
    zip: "48336",
    ST: "MI",
    cityWithStateAbbr: "Farmington, MI",
  },
  {
    zip: "48340",
    ST: "MI",
    cityWithStateAbbr: "Pontiac, MI",
  },
  {
    zip: "48341",
    ST: "MI",
    cityWithStateAbbr: "Pontiac, MI",
  },
  {
    zip: "48342",
    ST: "MI",
    cityWithStateAbbr: "Pontiac, MI",
  },
  {
    zip: "48343",
    ST: "MI",
    cityWithStateAbbr: "Pontiac, MI",
  },
  {
    zip: "48346",
    ST: "MI",
    cityWithStateAbbr: "Clarkston, MI",
  },
  {
    zip: "48347",
    ST: "MI",
    cityWithStateAbbr: "Clarkston, MI",
  },
  {
    zip: "48348",
    ST: "MI",
    cityWithStateAbbr: "Clarkston, MI",
  },
  {
    zip: "48350",
    ST: "MI",
    cityWithStateAbbr: "Davisburg, MI",
  },
  {
    zip: "48353",
    ST: "MI",
    cityWithStateAbbr: "Hartland, MI",
  },
  {
    zip: "48356",
    ST: "MI",
    cityWithStateAbbr: "Highland, MI",
  },
  {
    zip: "48357",
    ST: "MI",
    cityWithStateAbbr: "Highland, MI",
  },
  {
    zip: "48359",
    ST: "MI",
    cityWithStateAbbr: "Lake Orion, MI",
  },
  {
    zip: "48360",
    ST: "MI",
    cityWithStateAbbr: "Lake Orion, MI",
  },
  {
    zip: "48361",
    ST: "MI",
    cityWithStateAbbr: "Lake Orion, MI",
  },
  {
    zip: "48362",
    ST: "MI",
    cityWithStateAbbr: "Lake Orion, MI",
  },
  {
    zip: "48363",
    ST: "MI",
    cityWithStateAbbr: "Oakland, MI",
  },
  {
    zip: "48366",
    ST: "MI",
    cityWithStateAbbr: "Lakeville, MI",
  },
  {
    zip: "48367",
    ST: "MI",
    cityWithStateAbbr: "Leonard, MI",
  },
  {
    zip: "48370",
    ST: "MI",
    cityWithStateAbbr: "Oxford, MI",
  },
  {
    zip: "48371",
    ST: "MI",
    cityWithStateAbbr: "Oxford, MI",
  },
  {
    zip: "48374",
    ST: "MI",
    cityWithStateAbbr: "Novi, MI",
  },
  {
    zip: "48375",
    ST: "MI",
    cityWithStateAbbr: "Novi, MI",
  },
  {
    zip: "48376",
    ST: "MI",
    cityWithStateAbbr: "Novi, MI",
  },
  {
    zip: "48377",
    ST: "MI",
    cityWithStateAbbr: "Novi, MI",
  },
  {
    zip: "48380",
    ST: "MI",
    cityWithStateAbbr: "Milford, MI",
  },
  {
    zip: "48381",
    ST: "MI",
    cityWithStateAbbr: "Milford, MI",
  },
  {
    zip: "48382",
    ST: "MI",
    cityWithStateAbbr: "Commerce Township, MI",
  },
  {
    zip: "48383",
    ST: "MI",
    cityWithStateAbbr: "White Lake, MI",
  },
  {
    zip: "48386",
    ST: "MI",
    cityWithStateAbbr: "White Lake, MI",
  },
  {
    zip: "48387",
    ST: "MI",
    cityWithStateAbbr: "Union Lake, MI",
  },
  {
    zip: "48390",
    ST: "MI",
    cityWithStateAbbr: "Walled Lake, MI",
  },
  {
    zip: "48391",
    ST: "MI",
    cityWithStateAbbr: "Walled Lake, MI",
  },
  {
    zip: "48393",
    ST: "MI",
    cityWithStateAbbr: "Wixom, MI",
  },
  {
    zip: "48397",
    ST: "MI",
    cityWithStateAbbr: "Warren, MI",
  },
  {
    zip: "48401",
    ST: "MI",
    cityWithStateAbbr: "Applegate, MI",
  },
  {
    zip: "48410",
    ST: "MI",
    cityWithStateAbbr: "Argyle, MI",
  },
  {
    zip: "48411",
    ST: "MI",
    cityWithStateAbbr: "Atlas, MI",
  },
  {
    zip: "48412",
    ST: "MI",
    cityWithStateAbbr: "Attica, MI",
  },
  {
    zip: "48413",
    ST: "MI",
    cityWithStateAbbr: "Bad Axe, MI",
  },
  {
    zip: "48414",
    ST: "MI",
    cityWithStateAbbr: "Bancroft, MI",
  },
  {
    zip: "48415",
    ST: "MI",
    cityWithStateAbbr: "Birch Run, MI",
  },
  {
    zip: "48416",
    ST: "MI",
    cityWithStateAbbr: "Brown City, MI",
  },
  {
    zip: "48417",
    ST: "MI",
    cityWithStateAbbr: "Burt, MI",
  },
  {
    zip: "48418",
    ST: "MI",
    cityWithStateAbbr: "Byron, MI",
  },
  {
    zip: "48419",
    ST: "MI",
    cityWithStateAbbr: "Carsonville, MI",
  },
  {
    zip: "48420",
    ST: "MI",
    cityWithStateAbbr: "Clio, MI",
  },
  {
    zip: "48421",
    ST: "MI",
    cityWithStateAbbr: "Columbiaville, MI",
  },
  {
    zip: "48422",
    ST: "MI",
    cityWithStateAbbr: "Croswell, MI",
  },
  {
    zip: "48423",
    ST: "MI",
    cityWithStateAbbr: "Davison, MI",
  },
  {
    zip: "48426",
    ST: "MI",
    cityWithStateAbbr: "Decker, MI",
  },
  {
    zip: "48427",
    ST: "MI",
    cityWithStateAbbr: "Deckerville, MI",
  },
  {
    zip: "48428",
    ST: "MI",
    cityWithStateAbbr: "Dryden, MI",
  },
  {
    zip: "48429",
    ST: "MI",
    cityWithStateAbbr: "Durand, MI",
  },
  {
    zip: "48430",
    ST: "MI",
    cityWithStateAbbr: "Fenton, MI",
  },
  {
    zip: "48432",
    ST: "MI",
    cityWithStateAbbr: "Filion, MI",
  },
  {
    zip: "48433",
    ST: "MI",
    cityWithStateAbbr: "Flushing, MI",
  },
  {
    zip: "48434",
    ST: "MI",
    cityWithStateAbbr: "Forestville, MI",
  },
  {
    zip: "48435",
    ST: "MI",
    cityWithStateAbbr: "Fostoria, MI",
  },
  {
    zip: "48436",
    ST: "MI",
    cityWithStateAbbr: "Gaines, MI",
  },
  {
    zip: "48437",
    ST: "MI",
    cityWithStateAbbr: "Genesee, MI",
  },
  {
    zip: "48438",
    ST: "MI",
    cityWithStateAbbr: "Goodrich, MI",
  },
  {
    zip: "48439",
    ST: "MI",
    cityWithStateAbbr: "Grand Blanc, MI",
  },
  {
    zip: "48440",
    ST: "MI",
    cityWithStateAbbr: "Hadley, MI",
  },
  {
    zip: "48441",
    ST: "MI",
    cityWithStateAbbr: "Harbor Beach, MI",
  },
  {
    zip: "48442",
    ST: "MI",
    cityWithStateAbbr: "Holly, MI",
  },
  {
    zip: "48444",
    ST: "MI",
    cityWithStateAbbr: "Imlay City, MI",
  },
  {
    zip: "48445",
    ST: "MI",
    cityWithStateAbbr: "Kinde, MI",
  },
  {
    zip: "48446",
    ST: "MI",
    cityWithStateAbbr: "Lapeer, MI",
  },
  {
    zip: "48449",
    ST: "MI",
    cityWithStateAbbr: "Lennon, MI",
  },
  {
    zip: "48450",
    ST: "MI",
    cityWithStateAbbr: "Lexington, MI",
  },
  {
    zip: "48451",
    ST: "MI",
    cityWithStateAbbr: "Linden, MI",
  },
  {
    zip: "48453",
    ST: "MI",
    cityWithStateAbbr: "Marlette, MI",
  },
  {
    zip: "48454",
    ST: "MI",
    cityWithStateAbbr: "Melvin, MI",
  },
  {
    zip: "48455",
    ST: "MI",
    cityWithStateAbbr: "Metamora, MI",
  },
  {
    zip: "48456",
    ST: "MI",
    cityWithStateAbbr: "Minden City, MI",
  },
  {
    zip: "48457",
    ST: "MI",
    cityWithStateAbbr: "Montrose, MI",
  },
  {
    zip: "48458",
    ST: "MI",
    cityWithStateAbbr: "Mount Morris, MI",
  },
  {
    zip: "48460",
    ST: "MI",
    cityWithStateAbbr: "New Lothrop, MI",
  },
  {
    zip: "48461",
    ST: "MI",
    cityWithStateAbbr: "North Branch, MI",
  },
  {
    zip: "48462",
    ST: "MI",
    cityWithStateAbbr: "Ortonville, MI",
  },
  {
    zip: "48463",
    ST: "MI",
    cityWithStateAbbr: "Otisville, MI",
  },
  {
    zip: "48464",
    ST: "MI",
    cityWithStateAbbr: "Otter Lake, MI",
  },
  {
    zip: "48465",
    ST: "MI",
    cityWithStateAbbr: "Palms, MI",
  },
  {
    zip: "48466",
    ST: "MI",
    cityWithStateAbbr: "Peck, MI",
  },
  {
    zip: "48467",
    ST: "MI",
    cityWithStateAbbr: "Port Austin, MI",
  },
  {
    zip: "48468",
    ST: "MI",
    cityWithStateAbbr: "Port Hope, MI",
  },
  {
    zip: "48469",
    ST: "MI",
    cityWithStateAbbr: "Port Sanilac, MI",
  },
  {
    zip: "48470",
    ST: "MI",
    cityWithStateAbbr: "Ruth, MI",
  },
  {
    zip: "48471",
    ST: "MI",
    cityWithStateAbbr: "Sandusky, MI",
  },
  {
    zip: "48472",
    ST: "MI",
    cityWithStateAbbr: "Snover, MI",
  },
  {
    zip: "48473",
    ST: "MI",
    cityWithStateAbbr: "Swartz Creek, MI",
  },
  {
    zip: "48475",
    ST: "MI",
    cityWithStateAbbr: "Ubly, MI",
  },
  {
    zip: "48476",
    ST: "MI",
    cityWithStateAbbr: "Vernon, MI",
  },
  {
    zip: "48480",
    ST: "MI",
    cityWithStateAbbr: "Grand Blanc, MI",
  },
  {
    zip: "48501",
    ST: "MI",
    cityWithStateAbbr: "Flint, MI",
  },
  {
    zip: "48502",
    ST: "MI",
    cityWithStateAbbr: "Flint, MI",
  },
  {
    zip: "48503",
    ST: "MI",
    cityWithStateAbbr: "Flint, MI",
  },
  {
    zip: "48504",
    ST: "MI",
    cityWithStateAbbr: "Flint, MI",
  },
  {
    zip: "48505",
    ST: "MI",
    cityWithStateAbbr: "Flint, MI",
  },
  {
    zip: "48506",
    ST: "MI",
    cityWithStateAbbr: "Flint, MI",
  },
  {
    zip: "48507",
    ST: "MI",
    cityWithStateAbbr: "Flint, MI",
  },
  {
    zip: "48509",
    ST: "MI",
    cityWithStateAbbr: "Burton, MI",
  },
  {
    zip: "48519",
    ST: "MI",
    cityWithStateAbbr: "Burton, MI",
  },
  {
    zip: "48529",
    ST: "MI",
    cityWithStateAbbr: "Burton, MI",
  },
  {
    zip: "48531",
    ST: "MI",
    cityWithStateAbbr: "Flint, MI",
  },
  {
    zip: "48532",
    ST: "MI",
    cityWithStateAbbr: "Flint, MI",
  },
  {
    zip: "48550",
    ST: "MI",
    cityWithStateAbbr: "Flint, MI",
  },
  {
    zip: "48551",
    ST: "MI",
    cityWithStateAbbr: "Flint, MI",
  },
  {
    zip: "48552",
    ST: "MI",
    cityWithStateAbbr: "Flint, MI",
  },
  {
    zip: "48553",
    ST: "MI",
    cityWithStateAbbr: "Flint, MI",
  },
  {
    zip: "48554",
    ST: "MI",
    cityWithStateAbbr: "Flint, MI",
  },
  {
    zip: "48555",
    ST: "MI",
    cityWithStateAbbr: "Flint, MI",
  },
  {
    zip: "48556",
    ST: "MI",
    cityWithStateAbbr: "Flint, MI",
  },
  {
    zip: "48557",
    ST: "MI",
    cityWithStateAbbr: "Flint, MI",
  },
  {
    zip: "48601",
    ST: "MI",
    cityWithStateAbbr: "Saginaw, MI",
  },
  {
    zip: "48602",
    ST: "MI",
    cityWithStateAbbr: "Saginaw, MI",
  },
  {
    zip: "48603",
    ST: "MI",
    cityWithStateAbbr: "Saginaw, MI",
  },
  {
    zip: "48604",
    ST: "MI",
    cityWithStateAbbr: "Saginaw, MI",
  },
  {
    zip: "48605",
    ST: "MI",
    cityWithStateAbbr: "Saginaw, MI",
  },
  {
    zip: "48606",
    ST: "MI",
    cityWithStateAbbr: "Saginaw, MI",
  },
  {
    zip: "48607",
    ST: "MI",
    cityWithStateAbbr: "Saginaw, MI",
  },
  {
    zip: "48608",
    ST: "MI",
    cityWithStateAbbr: "Saginaw, MI",
  },
  {
    zip: "48609",
    ST: "MI",
    cityWithStateAbbr: "Saginaw, MI",
  },
  {
    zip: "48610",
    ST: "MI",
    cityWithStateAbbr: "Alger, MI",
  },
  {
    zip: "48611",
    ST: "MI",
    cityWithStateAbbr: "Auburn, MI",
  },
  {
    zip: "48612",
    ST: "MI",
    cityWithStateAbbr: "Beaverton, MI",
  },
  {
    zip: "48613",
    ST: "MI",
    cityWithStateAbbr: "Bentley, MI",
  },
  {
    zip: "48614",
    ST: "MI",
    cityWithStateAbbr: "Brant, MI",
  },
  {
    zip: "48615",
    ST: "MI",
    cityWithStateAbbr: "Breckenridge, MI",
  },
  {
    zip: "48616",
    ST: "MI",
    cityWithStateAbbr: "Chesaning, MI",
  },
  {
    zip: "48617",
    ST: "MI",
    cityWithStateAbbr: "Clare, MI",
  },
  {
    zip: "48618",
    ST: "MI",
    cityWithStateAbbr: "Coleman, MI",
  },
  {
    zip: "48619",
    ST: "MI",
    cityWithStateAbbr: "Comins, MI",
  },
  {
    zip: "48620",
    ST: "MI",
    cityWithStateAbbr: "Edenville, MI",
  },
  {
    zip: "48621",
    ST: "MI",
    cityWithStateAbbr: "Fairview, MI",
  },
  {
    zip: "48622",
    ST: "MI",
    cityWithStateAbbr: "Farwell, MI",
  },
  {
    zip: "48623",
    ST: "MI",
    cityWithStateAbbr: "Freeland, MI",
  },
  {
    zip: "48624",
    ST: "MI",
    cityWithStateAbbr: "Gladwin, MI",
  },
  {
    zip: "48625",
    ST: "MI",
    cityWithStateAbbr: "Harrison, MI",
  },
  {
    zip: "48626",
    ST: "MI",
    cityWithStateAbbr: "Hemlock, MI",
  },
  {
    zip: "48627",
    ST: "MI",
    cityWithStateAbbr: "Higgins Lake, MI",
  },
  {
    zip: "48628",
    ST: "MI",
    cityWithStateAbbr: "Hope, MI",
  },
  {
    zip: "48629",
    ST: "MI",
    cityWithStateAbbr: "Houghton Lake, MI",
  },
  {
    zip: "48630",
    ST: "MI",
    cityWithStateAbbr: "Houghton Lake Heights, MI",
  },
  {
    zip: "48631",
    ST: "MI",
    cityWithStateAbbr: "Kawkawlin, MI",
  },
  {
    zip: "48632",
    ST: "MI",
    cityWithStateAbbr: "Lake, MI",
  },
  {
    zip: "48633",
    ST: "MI",
    cityWithStateAbbr: "Lake George, MI",
  },
  {
    zip: "48634",
    ST: "MI",
    cityWithStateAbbr: "Linwood, MI",
  },
  {
    zip: "48635",
    ST: "MI",
    cityWithStateAbbr: "Lupton, MI",
  },
  {
    zip: "48636",
    ST: "MI",
    cityWithStateAbbr: "Luzerne, MI",
  },
  {
    zip: "48637",
    ST: "MI",
    cityWithStateAbbr: "Merrill, MI",
  },
  {
    zip: "48638",
    ST: "MI",
    cityWithStateAbbr: "Saginaw, MI",
  },
  {
    zip: "48640",
    ST: "MI",
    cityWithStateAbbr: "Midland, MI",
  },
  {
    zip: "48641",
    ST: "MI",
    cityWithStateAbbr: "Midland, MI",
  },
  {
    zip: "48642",
    ST: "MI",
    cityWithStateAbbr: "Midland, MI",
  },
  {
    zip: "48647",
    ST: "MI",
    cityWithStateAbbr: "Mio, MI",
  },
  {
    zip: "48649",
    ST: "MI",
    cityWithStateAbbr: "Oakley, MI",
  },
  {
    zip: "48650",
    ST: "MI",
    cityWithStateAbbr: "Pinconning, MI",
  },
  {
    zip: "48651",
    ST: "MI",
    cityWithStateAbbr: "Prudenville, MI",
  },
  {
    zip: "48652",
    ST: "MI",
    cityWithStateAbbr: "Rhodes, MI",
  },
  {
    zip: "48653",
    ST: "MI",
    cityWithStateAbbr: "Roscommon, MI",
  },
  {
    zip: "48654",
    ST: "MI",
    cityWithStateAbbr: "Rose City, MI",
  },
  {
    zip: "48655",
    ST: "MI",
    cityWithStateAbbr: "Saint Charles, MI",
  },
  {
    zip: "48656",
    ST: "MI",
    cityWithStateAbbr: "Saint Helen, MI",
  },
  {
    zip: "48657",
    ST: "MI",
    cityWithStateAbbr: "Sanford, MI",
  },
  {
    zip: "48658",
    ST: "MI",
    cityWithStateAbbr: "Standish, MI",
  },
  {
    zip: "48659",
    ST: "MI",
    cityWithStateAbbr: "Sterling, MI",
  },
  {
    zip: "48661",
    ST: "MI",
    cityWithStateAbbr: "West Branch, MI",
  },
  {
    zip: "48662",
    ST: "MI",
    cityWithStateAbbr: "Wheeler, MI",
  },
  {
    zip: "48663",
    ST: "MI",
    cityWithStateAbbr: "Saginaw, MI",
  },
  {
    zip: "48667",
    ST: "MI",
    cityWithStateAbbr: "Midland, MI",
  },
  {
    zip: "48670",
    ST: "MI",
    cityWithStateAbbr: "Midland, MI",
  },
  {
    zip: "48674",
    ST: "MI",
    cityWithStateAbbr: "Midland, MI",
  },
  {
    zip: "48686",
    ST: "MI",
    cityWithStateAbbr: "Midland, MI",
  },
  {
    zip: "48701",
    ST: "MI",
    cityWithStateAbbr: "Akron, MI",
  },
  {
    zip: "48703",
    ST: "MI",
    cityWithStateAbbr: "Au Gres, MI",
  },
  {
    zip: "48705",
    ST: "MI",
    cityWithStateAbbr: "Barton City, MI",
  },
  {
    zip: "48706",
    ST: "MI",
    cityWithStateAbbr: "Bay City, MI",
  },
  {
    zip: "48707",
    ST: "MI",
    cityWithStateAbbr: "Bay City, MI",
  },
  {
    zip: "48708",
    ST: "MI",
    cityWithStateAbbr: "Bay City, MI",
  },
  {
    zip: "48710",
    ST: "MI",
    cityWithStateAbbr: "University Center, MI",
  },
  {
    zip: "48720",
    ST: "MI",
    cityWithStateAbbr: "Bay Port, MI",
  },
  {
    zip: "48721",
    ST: "MI",
    cityWithStateAbbr: "Black River, MI",
  },
  {
    zip: "48722",
    ST: "MI",
    cityWithStateAbbr: "Bridgeport, MI",
  },
  {
    zip: "48723",
    ST: "MI",
    cityWithStateAbbr: "Caro, MI",
  },
  {
    zip: "48724",
    ST: "MI",
    cityWithStateAbbr: "Carrollton, MI",
  },
  {
    zip: "48725",
    ST: "MI",
    cityWithStateAbbr: "Caseville, MI",
  },
  {
    zip: "48726",
    ST: "MI",
    cityWithStateAbbr: "Cass City, MI",
  },
  {
    zip: "48727",
    ST: "MI",
    cityWithStateAbbr: "Clifford, MI",
  },
  {
    zip: "48728",
    ST: "MI",
    cityWithStateAbbr: "Curran, MI",
  },
  {
    zip: "48729",
    ST: "MI",
    cityWithStateAbbr: "Deford, MI",
  },
  {
    zip: "48730",
    ST: "MI",
    cityWithStateAbbr: "East Tawas, MI",
  },
  {
    zip: "48731",
    ST: "MI",
    cityWithStateAbbr: "Elkton, MI",
  },
  {
    zip: "48732",
    ST: "MI",
    cityWithStateAbbr: "Essexville, MI",
  },
  {
    zip: "48733",
    ST: "MI",
    cityWithStateAbbr: "Fairgrove, MI",
  },
  {
    zip: "48734",
    ST: "MI",
    cityWithStateAbbr: "Frankenmuth, MI",
  },
  {
    zip: "48735",
    ST: "MI",
    cityWithStateAbbr: "Gagetown, MI",
  },
  {
    zip: "48736",
    ST: "MI",
    cityWithStateAbbr: "Reese, MI",
  },
  {
    zip: "48737",
    ST: "MI",
    cityWithStateAbbr: "Glennie, MI",
  },
  {
    zip: "48738",
    ST: "MI",
    cityWithStateAbbr: "Greenbush, MI",
  },
  {
    zip: "48739",
    ST: "MI",
    cityWithStateAbbr: "Hale, MI",
  },
  {
    zip: "48740",
    ST: "MI",
    cityWithStateAbbr: "Harrisville, MI",
  },
  {
    zip: "48741",
    ST: "MI",
    cityWithStateAbbr: "Kingston, MI",
  },
  {
    zip: "48742",
    ST: "MI",
    cityWithStateAbbr: "Lincoln, MI",
  },
  {
    zip: "48743",
    ST: "MI",
    cityWithStateAbbr: "Long Lake, MI",
  },
  {
    zip: "48744",
    ST: "MI",
    cityWithStateAbbr: "Mayville, MI",
  },
  {
    zip: "48745",
    ST: "MI",
    cityWithStateAbbr: "Mikado, MI",
  },
  {
    zip: "48746",
    ST: "MI",
    cityWithStateAbbr: "Millington, MI",
  },
  {
    zip: "48747",
    ST: "MI",
    cityWithStateAbbr: "Munger, MI",
  },
  {
    zip: "48748",
    ST: "MI",
    cityWithStateAbbr: "National City, MI",
  },
  {
    zip: "48749",
    ST: "MI",
    cityWithStateAbbr: "Omer, MI",
  },
  {
    zip: "48750",
    ST: "MI",
    cityWithStateAbbr: "Oscoda, MI",
  },
  {
    zip: "48754",
    ST: "MI",
    cityWithStateAbbr: "Owendale, MI",
  },
  {
    zip: "48755",
    ST: "MI",
    cityWithStateAbbr: "Pigeon, MI",
  },
  {
    zip: "48756",
    ST: "MI",
    cityWithStateAbbr: "Prescott, MI",
  },
  {
    zip: "48757",
    ST: "MI",
    cityWithStateAbbr: "Reese, MI",
  },
  {
    zip: "48758",
    ST: "MI",
    cityWithStateAbbr: "Richville, MI",
  },
  {
    zip: "48759",
    ST: "MI",
    cityWithStateAbbr: "Sebewaing, MI",
  },
  {
    zip: "48760",
    ST: "MI",
    cityWithStateAbbr: "Silverwood, MI",
  },
  {
    zip: "48761",
    ST: "MI",
    cityWithStateAbbr: "South Branch, MI",
  },
  {
    zip: "48762",
    ST: "MI",
    cityWithStateAbbr: "Spruce, MI",
  },
  {
    zip: "48763",
    ST: "MI",
    cityWithStateAbbr: "Tawas City, MI",
  },
  {
    zip: "48764",
    ST: "MI",
    cityWithStateAbbr: "Tawas City, MI",
  },
  {
    zip: "48765",
    ST: "MI",
    cityWithStateAbbr: "Turner, MI",
  },
  {
    zip: "48766",
    ST: "MI",
    cityWithStateAbbr: "Twining, MI",
  },
  {
    zip: "48767",
    ST: "MI",
    cityWithStateAbbr: "Unionville, MI",
  },
  {
    zip: "48768",
    ST: "MI",
    cityWithStateAbbr: "Vassar, MI",
  },
  {
    zip: "48769",
    ST: "MI",
    cityWithStateAbbr: "Vassar, MI",
  },
  {
    zip: "48770",
    ST: "MI",
    cityWithStateAbbr: "Whittemore, MI",
  },
  {
    zip: "48787",
    ST: "MI",
    cityWithStateAbbr: "Frankenmuth, MI",
  },
  {
    zip: "48801",
    ST: "MI",
    cityWithStateAbbr: "Alma, MI",
  },
  {
    zip: "48804",
    ST: "MI",
    cityWithStateAbbr: "Mount Pleasant, MI",
  },
  {
    zip: "48805",
    ST: "MI",
    cityWithStateAbbr: "Okemos, MI",
  },
  {
    zip: "48806",
    ST: "MI",
    cityWithStateAbbr: "Ashley, MI",
  },
  {
    zip: "48807",
    ST: "MI",
    cityWithStateAbbr: "Bannister, MI",
  },
  {
    zip: "48808",
    ST: "MI",
    cityWithStateAbbr: "Bath, MI",
  },
  {
    zip: "48809",
    ST: "MI",
    cityWithStateAbbr: "Belding, MI",
  },
  {
    zip: "48811",
    ST: "MI",
    cityWithStateAbbr: "Carson City, MI",
  },
  {
    zip: "48812",
    ST: "MI",
    cityWithStateAbbr: "Cedar Lake, MI",
  },
  {
    zip: "48813",
    ST: "MI",
    cityWithStateAbbr: "Charlotte, MI",
  },
  {
    zip: "48815",
    ST: "MI",
    cityWithStateAbbr: "Clarksville, MI",
  },
  {
    zip: "48816",
    ST: "MI",
    cityWithStateAbbr: "Cohoctah, MI",
  },
  {
    zip: "48817",
    ST: "MI",
    cityWithStateAbbr: "Corunna, MI",
  },
  {
    zip: "48818",
    ST: "MI",
    cityWithStateAbbr: "Crystal, MI",
  },
  {
    zip: "48819",
    ST: "MI",
    cityWithStateAbbr: "Dansville, MI",
  },
  {
    zip: "48820",
    ST: "MI",
    cityWithStateAbbr: "Dewitt, MI",
  },
  {
    zip: "48821",
    ST: "MI",
    cityWithStateAbbr: "Dimondale, MI",
  },
  {
    zip: "48822",
    ST: "MI",
    cityWithStateAbbr: "Eagle, MI",
  },
  {
    zip: "48823",
    ST: "MI",
    cityWithStateAbbr: "East Lansing, MI",
  },
  {
    zip: "48824",
    ST: "MI",
    cityWithStateAbbr: "East Lansing, MI",
  },
  {
    zip: "48825",
    ST: "MI",
    cityWithStateAbbr: "East Lansing, MI",
  },
  {
    zip: "48826",
    ST: "MI",
    cityWithStateAbbr: "East Lansing, MI",
  },
  {
    zip: "48827",
    ST: "MI",
    cityWithStateAbbr: "Eaton Rapids, MI",
  },
  {
    zip: "48829",
    ST: "MI",
    cityWithStateAbbr: "Edmore, MI",
  },
  {
    zip: "48830",
    ST: "MI",
    cityWithStateAbbr: "Elm Hall, MI",
  },
  {
    zip: "48831",
    ST: "MI",
    cityWithStateAbbr: "Elsie, MI",
  },
  {
    zip: "48832",
    ST: "MI",
    cityWithStateAbbr: "Elwell, MI",
  },
  {
    zip: "48833",
    ST: "MI",
    cityWithStateAbbr: "Eureka, MI",
  },
  {
    zip: "48834",
    ST: "MI",
    cityWithStateAbbr: "Fenwick, MI",
  },
  {
    zip: "48835",
    ST: "MI",
    cityWithStateAbbr: "Fowler, MI",
  },
  {
    zip: "48836",
    ST: "MI",
    cityWithStateAbbr: "Fowlerville, MI",
  },
  {
    zip: "48837",
    ST: "MI",
    cityWithStateAbbr: "Grand Ledge, MI",
  },
  {
    zip: "48838",
    ST: "MI",
    cityWithStateAbbr: "Greenville, MI",
  },
  {
    zip: "48840",
    ST: "MI",
    cityWithStateAbbr: "Haslett, MI",
  },
  {
    zip: "48841",
    ST: "MI",
    cityWithStateAbbr: "Henderson, MI",
  },
  {
    zip: "48842",
    ST: "MI",
    cityWithStateAbbr: "Holt, MI",
  },
  {
    zip: "48843",
    ST: "MI",
    cityWithStateAbbr: "Howell, MI",
  },
  {
    zip: "48844",
    ST: "MI",
    cityWithStateAbbr: "Howell, MI",
  },
  {
    zip: "48845",
    ST: "MI",
    cityWithStateAbbr: "Hubbardston, MI",
  },
  {
    zip: "48846",
    ST: "MI",
    cityWithStateAbbr: "Ionia, MI",
  },
  {
    zip: "48847",
    ST: "MI",
    cityWithStateAbbr: "Ithaca, MI",
  },
  {
    zip: "48848",
    ST: "MI",
    cityWithStateAbbr: "Laingsburg, MI",
  },
  {
    zip: "48849",
    ST: "MI",
    cityWithStateAbbr: "Lake Odessa, MI",
  },
  {
    zip: "48850",
    ST: "MI",
    cityWithStateAbbr: "Lakeview, MI",
  },
  {
    zip: "48851",
    ST: "MI",
    cityWithStateAbbr: "Lyons, MI",
  },
  {
    zip: "48852",
    ST: "MI",
    cityWithStateAbbr: "Mcbrides, MI",
  },
  {
    zip: "48853",
    ST: "MI",
    cityWithStateAbbr: "Maple Rapids, MI",
  },
  {
    zip: "48854",
    ST: "MI",
    cityWithStateAbbr: "Mason, MI",
  },
  {
    zip: "48855",
    ST: "MI",
    cityWithStateAbbr: "Howell, MI",
  },
  {
    zip: "48856",
    ST: "MI",
    cityWithStateAbbr: "Middleton, MI",
  },
  {
    zip: "48857",
    ST: "MI",
    cityWithStateAbbr: "Morrice, MI",
  },
  {
    zip: "48858",
    ST: "MI",
    cityWithStateAbbr: "Mount Pleasant, MI",
  },
  {
    zip: "48859",
    ST: "MI",
    cityWithStateAbbr: "Mount Pleasant, MI",
  },
  {
    zip: "48860",
    ST: "MI",
    cityWithStateAbbr: "Muir, MI",
  },
  {
    zip: "48861",
    ST: "MI",
    cityWithStateAbbr: "Mulliken, MI",
  },
  {
    zip: "48862",
    ST: "MI",
    cityWithStateAbbr: "North Star, MI",
  },
  {
    zip: "48863",
    ST: "MI",
    cityWithStateAbbr: "Howell, MI",
  },
  {
    zip: "48864",
    ST: "MI",
    cityWithStateAbbr: "Okemos, MI",
  },
  {
    zip: "48865",
    ST: "MI",
    cityWithStateAbbr: "Orleans, MI",
  },
  {
    zip: "48866",
    ST: "MI",
    cityWithStateAbbr: "Ovid, MI",
  },
  {
    zip: "48867",
    ST: "MI",
    cityWithStateAbbr: "Owosso, MI",
  },
  {
    zip: "48870",
    ST: "MI",
    cityWithStateAbbr: "Palo, MI",
  },
  {
    zip: "48871",
    ST: "MI",
    cityWithStateAbbr: "Perrinton, MI",
  },
  {
    zip: "48872",
    ST: "MI",
    cityWithStateAbbr: "Perry, MI",
  },
  {
    zip: "48873",
    ST: "MI",
    cityWithStateAbbr: "Pewamo, MI",
  },
  {
    zip: "48874",
    ST: "MI",
    cityWithStateAbbr: "Pompeii, MI",
  },
  {
    zip: "48875",
    ST: "MI",
    cityWithStateAbbr: "Portland, MI",
  },
  {
    zip: "48876",
    ST: "MI",
    cityWithStateAbbr: "Potterville, MI",
  },
  {
    zip: "48877",
    ST: "MI",
    cityWithStateAbbr: "Riverdale, MI",
  },
  {
    zip: "48878",
    ST: "MI",
    cityWithStateAbbr: "Rosebush, MI",
  },
  {
    zip: "48879",
    ST: "MI",
    cityWithStateAbbr: "Saint Johns, MI",
  },
  {
    zip: "48880",
    ST: "MI",
    cityWithStateAbbr: "Saint Louis, MI",
  },
  {
    zip: "48881",
    ST: "MI",
    cityWithStateAbbr: "Saranac, MI",
  },
  {
    zip: "48882",
    ST: "MI",
    cityWithStateAbbr: "Shaftsburg, MI",
  },
  {
    zip: "48883",
    ST: "MI",
    cityWithStateAbbr: "Shepherd, MI",
  },
  {
    zip: "48884",
    ST: "MI",
    cityWithStateAbbr: "Sheridan, MI",
  },
  {
    zip: "48885",
    ST: "MI",
    cityWithStateAbbr: "Sidney, MI",
  },
  {
    zip: "48886",
    ST: "MI",
    cityWithStateAbbr: "Six Lakes, MI",
  },
  {
    zip: "48887",
    ST: "MI",
    cityWithStateAbbr: "Smyrna, MI",
  },
  {
    zip: "48888",
    ST: "MI",
    cityWithStateAbbr: "Stanton, MI",
  },
  {
    zip: "48889",
    ST: "MI",
    cityWithStateAbbr: "Sumner, MI",
  },
  {
    zip: "48890",
    ST: "MI",
    cityWithStateAbbr: "Sunfield, MI",
  },
  {
    zip: "48891",
    ST: "MI",
    cityWithStateAbbr: "Vestaburg, MI",
  },
  {
    zip: "48892",
    ST: "MI",
    cityWithStateAbbr: "Webberville, MI",
  },
  {
    zip: "48893",
    ST: "MI",
    cityWithStateAbbr: "Weidman, MI",
  },
  {
    zip: "48894",
    ST: "MI",
    cityWithStateAbbr: "Westphalia, MI",
  },
  {
    zip: "48895",
    ST: "MI",
    cityWithStateAbbr: "Williamston, MI",
  },
  {
    zip: "48896",
    ST: "MI",
    cityWithStateAbbr: "Winn, MI",
  },
  {
    zip: "48897",
    ST: "MI",
    cityWithStateAbbr: "Woodland, MI",
  },
  {
    zip: "48901",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48906",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48908",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48909",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48910",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48911",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48912",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48913",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48915",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48916",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48917",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48918",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48919",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48921",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48922",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48924",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48929",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48930",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48933",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48937",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48950",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48951",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48956",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "48980",
    ST: "MI",
    cityWithStateAbbr: "Lansing, MI",
  },
  {
    zip: "49001",
    ST: "MI",
    cityWithStateAbbr: "Kalamazoo, MI",
  },
  {
    zip: "49002",
    ST: "MI",
    cityWithStateAbbr: "Portage, MI",
  },
  {
    zip: "49003",
    ST: "MI",
    cityWithStateAbbr: "Kalamazoo, MI",
  },
  {
    zip: "49004",
    ST: "MI",
    cityWithStateAbbr: "Kalamazoo, MI",
  },
  {
    zip: "49005",
    ST: "MI",
    cityWithStateAbbr: "Kalamazoo, MI",
  },
  {
    zip: "49006",
    ST: "MI",
    cityWithStateAbbr: "Kalamazoo, MI",
  },
  {
    zip: "49007",
    ST: "MI",
    cityWithStateAbbr: "Kalamazoo, MI",
  },
  {
    zip: "49008",
    ST: "MI",
    cityWithStateAbbr: "Kalamazoo, MI",
  },
  {
    zip: "49009",
    ST: "MI",
    cityWithStateAbbr: "Kalamazoo, MI",
  },
  {
    zip: "49010",
    ST: "MI",
    cityWithStateAbbr: "Allegan, MI",
  },
  {
    zip: "49011",
    ST: "MI",
    cityWithStateAbbr: "Athens, MI",
  },
  {
    zip: "49012",
    ST: "MI",
    cityWithStateAbbr: "Augusta, MI",
  },
  {
    zip: "49013",
    ST: "MI",
    cityWithStateAbbr: "Bangor, MI",
  },
  {
    zip: "49014",
    ST: "MI",
    cityWithStateAbbr: "Battle Creek, MI",
  },
  {
    zip: "49015",
    ST: "MI",
    cityWithStateAbbr: "Battle Creek, MI",
  },
  {
    zip: "49016",
    ST: "MI",
    cityWithStateAbbr: "Battle Creek, MI",
  },
  {
    zip: "49017",
    ST: "MI",
    cityWithStateAbbr: "Battle Creek, MI",
  },
  {
    zip: "49018",
    ST: "MI",
    cityWithStateAbbr: "Battle Creek, MI",
  },
  {
    zip: "49019",
    ST: "MI",
    cityWithStateAbbr: "Kalamazoo, MI",
  },
  {
    zip: "49020",
    ST: "MI",
    cityWithStateAbbr: "Bedford, MI",
  },
  {
    zip: "49021",
    ST: "MI",
    cityWithStateAbbr: "Bellevue, MI",
  },
  {
    zip: "49022",
    ST: "MI",
    cityWithStateAbbr: "Benton Harbor, MI",
  },
  {
    zip: "49023",
    ST: "MI",
    cityWithStateAbbr: "Benton Harbor, MI",
  },
  {
    zip: "49024",
    ST: "MI",
    cityWithStateAbbr: "Portage, MI",
  },
  {
    zip: "49026",
    ST: "MI",
    cityWithStateAbbr: "Bloomingdale, MI",
  },
  {
    zip: "49027",
    ST: "MI",
    cityWithStateAbbr: "Breedsville, MI",
  },
  {
    zip: "49028",
    ST: "MI",
    cityWithStateAbbr: "Bronson, MI",
  },
  {
    zip: "49029",
    ST: "MI",
    cityWithStateAbbr: "Burlington, MI",
  },
  {
    zip: "49030",
    ST: "MI",
    cityWithStateAbbr: "Burr Oak, MI",
  },
  {
    zip: "49031",
    ST: "MI",
    cityWithStateAbbr: "Cassopolis, MI",
  },
  {
    zip: "49032",
    ST: "MI",
    cityWithStateAbbr: "Centreville, MI",
  },
  {
    zip: "49033",
    ST: "MI",
    cityWithStateAbbr: "Ceresco, MI",
  },
  {
    zip: "49034",
    ST: "MI",
    cityWithStateAbbr: "Climax, MI",
  },
  {
    zip: "49035",
    ST: "MI",
    cityWithStateAbbr: "Cloverdale, MI",
  },
  {
    zip: "49036",
    ST: "MI",
    cityWithStateAbbr: "Coldwater, MI",
  },
  {
    zip: "49037",
    ST: "MI",
    cityWithStateAbbr: "Battle Creek, MI",
  },
  {
    zip: "49038",
    ST: "MI",
    cityWithStateAbbr: "Coloma, MI",
  },
  {
    zip: "49039",
    ST: "MI",
    cityWithStateAbbr: "Hagar Shores, MI",
  },
  {
    zip: "49040",
    ST: "MI",
    cityWithStateAbbr: "Colon, MI",
  },
  {
    zip: "49041",
    ST: "MI",
    cityWithStateAbbr: "Comstock, MI",
  },
  {
    zip: "49042",
    ST: "MI",
    cityWithStateAbbr: "Constantine, MI",
  },
  {
    zip: "49043",
    ST: "MI",
    cityWithStateAbbr: "Covert, MI",
  },
  {
    zip: "49045",
    ST: "MI",
    cityWithStateAbbr: "Decatur, MI",
  },
  {
    zip: "49046",
    ST: "MI",
    cityWithStateAbbr: "Delton, MI",
  },
  {
    zip: "49047",
    ST: "MI",
    cityWithStateAbbr: "Dowagiac, MI",
  },
  {
    zip: "49048",
    ST: "MI",
    cityWithStateAbbr: "Kalamazoo, MI",
  },
  {
    zip: "49050",
    ST: "MI",
    cityWithStateAbbr: "Dowling, MI",
  },
  {
    zip: "49051",
    ST: "MI",
    cityWithStateAbbr: "East Leroy, MI",
  },
  {
    zip: "49052",
    ST: "MI",
    cityWithStateAbbr: "Fulton, MI",
  },
  {
    zip: "49053",
    ST: "MI",
    cityWithStateAbbr: "Galesburg, MI",
  },
  {
    zip: "49055",
    ST: "MI",
    cityWithStateAbbr: "Gobles, MI",
  },
  {
    zip: "49056",
    ST: "MI",
    cityWithStateAbbr: "Grand Junction, MI",
  },
  {
    zip: "49057",
    ST: "MI",
    cityWithStateAbbr: "Hartford, MI",
  },
  {
    zip: "49058",
    ST: "MI",
    cityWithStateAbbr: "Hastings, MI",
  },
  {
    zip: "49060",
    ST: "MI",
    cityWithStateAbbr: "Hickory Corners, MI",
  },
  {
    zip: "49061",
    ST: "MI",
    cityWithStateAbbr: "Jones, MI",
  },
  {
    zip: "49062",
    ST: "MI",
    cityWithStateAbbr: "Kendall, MI",
  },
  {
    zip: "49063",
    ST: "MI",
    cityWithStateAbbr: "Lacota, MI",
  },
  {
    zip: "49064",
    ST: "MI",
    cityWithStateAbbr: "Lawrence, MI",
  },
  {
    zip: "49065",
    ST: "MI",
    cityWithStateAbbr: "Lawton, MI",
  },
  {
    zip: "49066",
    ST: "MI",
    cityWithStateAbbr: "Leonidas, MI",
  },
  {
    zip: "49067",
    ST: "MI",
    cityWithStateAbbr: "Marcellus, MI",
  },
  {
    zip: "49068",
    ST: "MI",
    cityWithStateAbbr: "Marshall, MI",
  },
  {
    zip: "49070",
    ST: "MI",
    cityWithStateAbbr: "Martin, MI",
  },
  {
    zip: "49071",
    ST: "MI",
    cityWithStateAbbr: "Mattawan, MI",
  },
  {
    zip: "49072",
    ST: "MI",
    cityWithStateAbbr: "Mendon, MI",
  },
  {
    zip: "49073",
    ST: "MI",
    cityWithStateAbbr: "Nashville, MI",
  },
  {
    zip: "49074",
    ST: "MI",
    cityWithStateAbbr: "Nazareth, MI",
  },
  {
    zip: "49075",
    ST: "MI",
    cityWithStateAbbr: "Nottawa, MI",
  },
  {
    zip: "49076",
    ST: "MI",
    cityWithStateAbbr: "Olivet, MI",
  },
  {
    zip: "49077",
    ST: "MI",
    cityWithStateAbbr: "Oshtemo, MI",
  },
  {
    zip: "49078",
    ST: "MI",
    cityWithStateAbbr: "Otsego, MI",
  },
  {
    zip: "49079",
    ST: "MI",
    cityWithStateAbbr: "Paw Paw, MI",
  },
  {
    zip: "49080",
    ST: "MI",
    cityWithStateAbbr: "Plainwell, MI",
  },
  {
    zip: "49081",
    ST: "MI",
    cityWithStateAbbr: "Portage, MI",
  },
  {
    zip: "49082",
    ST: "MI",
    cityWithStateAbbr: "Quincy, MI",
  },
  {
    zip: "49083",
    ST: "MI",
    cityWithStateAbbr: "Richland, MI",
  },
  {
    zip: "49084",
    ST: "MI",
    cityWithStateAbbr: "Riverside, MI",
  },
  {
    zip: "49085",
    ST: "MI",
    cityWithStateAbbr: "Saint Joseph, MI",
  },
  {
    zip: "49087",
    ST: "MI",
    cityWithStateAbbr: "Schoolcraft, MI",
  },
  {
    zip: "49088",
    ST: "MI",
    cityWithStateAbbr: "Scotts, MI",
  },
  {
    zip: "49089",
    ST: "MI",
    cityWithStateAbbr: "Sherwood, MI",
  },
  {
    zip: "49090",
    ST: "MI",
    cityWithStateAbbr: "South Haven, MI",
  },
  {
    zip: "49091",
    ST: "MI",
    cityWithStateAbbr: "Sturgis, MI",
  },
  {
    zip: "49092",
    ST: "MI",
    cityWithStateAbbr: "Tekonsha, MI",
  },
  {
    zip: "49093",
    ST: "MI",
    cityWithStateAbbr: "Three Rivers, MI",
  },
  {
    zip: "49094",
    ST: "MI",
    cityWithStateAbbr: "Union City, MI",
  },
  {
    zip: "49095",
    ST: "MI",
    cityWithStateAbbr: "Vandalia, MI",
  },
  {
    zip: "49096",
    ST: "MI",
    cityWithStateAbbr: "Vermontville, MI",
  },
  {
    zip: "49097",
    ST: "MI",
    cityWithStateAbbr: "Vicksburg, MI",
  },
  {
    zip: "49098",
    ST: "MI",
    cityWithStateAbbr: "Watervliet, MI",
  },
  {
    zip: "49099",
    ST: "MI",
    cityWithStateAbbr: "White Pigeon, MI",
  },
  {
    zip: "49101",
    ST: "MI",
    cityWithStateAbbr: "Baroda, MI",
  },
  {
    zip: "49102",
    ST: "MI",
    cityWithStateAbbr: "Berrien Center, MI",
  },
  {
    zip: "49103",
    ST: "MI",
    cityWithStateAbbr: "Berrien Springs, MI",
  },
  {
    zip: "49104",
    ST: "MI",
    cityWithStateAbbr: "Berrien Springs, MI",
  },
  {
    zip: "49106",
    ST: "MI",
    cityWithStateAbbr: "Bridgman, MI",
  },
  {
    zip: "49107",
    ST: "MI",
    cityWithStateAbbr: "Buchanan, MI",
  },
  {
    zip: "49111",
    ST: "MI",
    cityWithStateAbbr: "Eau Claire, MI",
  },
  {
    zip: "49112",
    ST: "MI",
    cityWithStateAbbr: "Edwardsburg, MI",
  },
  {
    zip: "49113",
    ST: "MI",
    cityWithStateAbbr: "Galien, MI",
  },
  {
    zip: "49115",
    ST: "MI",
    cityWithStateAbbr: "Harbert, MI",
  },
  {
    zip: "49116",
    ST: "MI",
    cityWithStateAbbr: "Lakeside, MI",
  },
  {
    zip: "49117",
    ST: "MI",
    cityWithStateAbbr: "New Buffalo, MI",
  },
  {
    zip: "49119",
    ST: "MI",
    cityWithStateAbbr: "New Troy, MI",
  },
  {
    zip: "49120",
    ST: "MI",
    cityWithStateAbbr: "Niles, MI",
  },
  {
    zip: "49125",
    ST: "MI",
    cityWithStateAbbr: "Sawyer, MI",
  },
  {
    zip: "49126",
    ST: "MI",
    cityWithStateAbbr: "Sodus, MI",
  },
  {
    zip: "49127",
    ST: "MI",
    cityWithStateAbbr: "Stevensville, MI",
  },
  {
    zip: "49128",
    ST: "MI",
    cityWithStateAbbr: "Three Oaks, MI",
  },
  {
    zip: "49129",
    ST: "MI",
    cityWithStateAbbr: "Union Pier, MI",
  },
  {
    zip: "49130",
    ST: "MI",
    cityWithStateAbbr: "Union, MI",
  },
  {
    zip: "49201",
    ST: "MI",
    cityWithStateAbbr: "Jackson, MI",
  },
  {
    zip: "49202",
    ST: "MI",
    cityWithStateAbbr: "Jackson, MI",
  },
  {
    zip: "49203",
    ST: "MI",
    cityWithStateAbbr: "Jackson, MI",
  },
  {
    zip: "49204",
    ST: "MI",
    cityWithStateAbbr: "Jackson, MI",
  },
  {
    zip: "49220",
    ST: "MI",
    cityWithStateAbbr: "Addison, MI",
  },
  {
    zip: "49221",
    ST: "MI",
    cityWithStateAbbr: "Adrian, MI",
  },
  {
    zip: "49224",
    ST: "MI",
    cityWithStateAbbr: "Albion, MI",
  },
  {
    zip: "49227",
    ST: "MI",
    cityWithStateAbbr: "Allen, MI",
  },
  {
    zip: "49228",
    ST: "MI",
    cityWithStateAbbr: "Blissfield, MI",
  },
  {
    zip: "49229",
    ST: "MI",
    cityWithStateAbbr: "Britton, MI",
  },
  {
    zip: "49230",
    ST: "MI",
    cityWithStateAbbr: "Brooklyn, MI",
  },
  {
    zip: "49232",
    ST: "MI",
    cityWithStateAbbr: "Camden, MI",
  },
  {
    zip: "49233",
    ST: "MI",
    cityWithStateAbbr: "Cement City, MI",
  },
  {
    zip: "49234",
    ST: "MI",
    cityWithStateAbbr: "Clarklake, MI",
  },
  {
    zip: "49235",
    ST: "MI",
    cityWithStateAbbr: "Clayton, MI",
  },
  {
    zip: "49236",
    ST: "MI",
    cityWithStateAbbr: "Clinton, MI",
  },
  {
    zip: "49237",
    ST: "MI",
    cityWithStateAbbr: "Concord, MI",
  },
  {
    zip: "49238",
    ST: "MI",
    cityWithStateAbbr: "Deerfield, MI",
  },
  {
    zip: "49239",
    ST: "MI",
    cityWithStateAbbr: "Frontier, MI",
  },
  {
    zip: "49240",
    ST: "MI",
    cityWithStateAbbr: "Grass Lake, MI",
  },
  {
    zip: "49241",
    ST: "MI",
    cityWithStateAbbr: "Hanover, MI",
  },
  {
    zip: "49242",
    ST: "MI",
    cityWithStateAbbr: "Hillsdale, MI",
  },
  {
    zip: "49245",
    ST: "MI",
    cityWithStateAbbr: "Homer, MI",
  },
  {
    zip: "49246",
    ST: "MI",
    cityWithStateAbbr: "Horton, MI",
  },
  {
    zip: "49247",
    ST: "MI",
    cityWithStateAbbr: "Hudson, MI",
  },
  {
    zip: "49248",
    ST: "MI",
    cityWithStateAbbr: "Jasper, MI",
  },
  {
    zip: "49249",
    ST: "MI",
    cityWithStateAbbr: "Jerome, MI",
  },
  {
    zip: "49250",
    ST: "MI",
    cityWithStateAbbr: "Jonesville, MI",
  },
  {
    zip: "49251",
    ST: "MI",
    cityWithStateAbbr: "Leslie, MI",
  },
  {
    zip: "49252",
    ST: "MI",
    cityWithStateAbbr: "Litchfield, MI",
  },
  {
    zip: "49253",
    ST: "MI",
    cityWithStateAbbr: "Manitou Beach, MI",
  },
  {
    zip: "49254",
    ST: "MI",
    cityWithStateAbbr: "Michigan Center, MI",
  },
  {
    zip: "49255",
    ST: "MI",
    cityWithStateAbbr: "Montgomery, MI",
  },
  {
    zip: "49256",
    ST: "MI",
    cityWithStateAbbr: "Morenci, MI",
  },
  {
    zip: "49257",
    ST: "MI",
    cityWithStateAbbr: "Moscow, MI",
  },
  {
    zip: "49258",
    ST: "MI",
    cityWithStateAbbr: "Mosherville, MI",
  },
  {
    zip: "49259",
    ST: "MI",
    cityWithStateAbbr: "Munith, MI",
  },
  {
    zip: "49261",
    ST: "MI",
    cityWithStateAbbr: "Napoleon, MI",
  },
  {
    zip: "49262",
    ST: "MI",
    cityWithStateAbbr: "North Adams, MI",
  },
  {
    zip: "49263",
    ST: "MI",
    cityWithStateAbbr: "Norvell, MI",
  },
  {
    zip: "49264",
    ST: "MI",
    cityWithStateAbbr: "Onondaga, MI",
  },
  {
    zip: "49265",
    ST: "MI",
    cityWithStateAbbr: "Onsted, MI",
  },
  {
    zip: "49266",
    ST: "MI",
    cityWithStateAbbr: "Osseo, MI",
  },
  {
    zip: "49267",
    ST: "MI",
    cityWithStateAbbr: "Ottawa Lake, MI",
  },
  {
    zip: "49268",
    ST: "MI",
    cityWithStateAbbr: "Palmyra, MI",
  },
  {
    zip: "49269",
    ST: "MI",
    cityWithStateAbbr: "Parma, MI",
  },
  {
    zip: "49270",
    ST: "MI",
    cityWithStateAbbr: "Petersburg, MI",
  },
  {
    zip: "49271",
    ST: "MI",
    cityWithStateAbbr: "Pittsford, MI",
  },
  {
    zip: "49272",
    ST: "MI",
    cityWithStateAbbr: "Pleasant Lake, MI",
  },
  {
    zip: "49274",
    ST: "MI",
    cityWithStateAbbr: "Reading, MI",
  },
  {
    zip: "49276",
    ST: "MI",
    cityWithStateAbbr: "Riga, MI",
  },
  {
    zip: "49277",
    ST: "MI",
    cityWithStateAbbr: "Rives Junction, MI",
  },
  {
    zip: "49279",
    ST: "MI",
    cityWithStateAbbr: "Sand Creek, MI",
  },
  {
    zip: "49281",
    ST: "MI",
    cityWithStateAbbr: "Somerset, MI",
  },
  {
    zip: "49282",
    ST: "MI",
    cityWithStateAbbr: "Somerset Center, MI",
  },
  {
    zip: "49283",
    ST: "MI",
    cityWithStateAbbr: "Spring Arbor, MI",
  },
  {
    zip: "49284",
    ST: "MI",
    cityWithStateAbbr: "Springport, MI",
  },
  {
    zip: "49285",
    ST: "MI",
    cityWithStateAbbr: "Stockbridge, MI",
  },
  {
    zip: "49286",
    ST: "MI",
    cityWithStateAbbr: "Tecumseh, MI",
  },
  {
    zip: "49287",
    ST: "MI",
    cityWithStateAbbr: "Tipton, MI",
  },
  {
    zip: "49288",
    ST: "MI",
    cityWithStateAbbr: "Waldron, MI",
  },
  {
    zip: "49289",
    ST: "MI",
    cityWithStateAbbr: "Weston, MI",
  },
  {
    zip: "49301",
    ST: "MI",
    cityWithStateAbbr: "Ada, MI",
  },
  {
    zip: "49302",
    ST: "MI",
    cityWithStateAbbr: "Alto, MI",
  },
  {
    zip: "49303",
    ST: "MI",
    cityWithStateAbbr: "Bailey, MI",
  },
  {
    zip: "49304",
    ST: "MI",
    cityWithStateAbbr: "Baldwin, MI",
  },
  {
    zip: "49305",
    ST: "MI",
    cityWithStateAbbr: "Barryton, MI",
  },
  {
    zip: "49306",
    ST: "MI",
    cityWithStateAbbr: "Belmont, MI",
  },
  {
    zip: "49307",
    ST: "MI",
    cityWithStateAbbr: "Big Rapids, MI",
  },
  {
    zip: "49309",
    ST: "MI",
    cityWithStateAbbr: "Bitely, MI",
  },
  {
    zip: "49310",
    ST: "MI",
    cityWithStateAbbr: "Blanchard, MI",
  },
  {
    zip: "49311",
    ST: "MI",
    cityWithStateAbbr: "Bradley, MI",
  },
  {
    zip: "49312",
    ST: "MI",
    cityWithStateAbbr: "Brohman, MI",
  },
  {
    zip: "49314",
    ST: "MI",
    cityWithStateAbbr: "Burnips, MI",
  },
  {
    zip: "49315",
    ST: "MI",
    cityWithStateAbbr: "Byron Center, MI",
  },
  {
    zip: "49316",
    ST: "MI",
    cityWithStateAbbr: "Caledonia, MI",
  },
  {
    zip: "49317",
    ST: "MI",
    cityWithStateAbbr: "Cannonsburg, MI",
  },
  {
    zip: "49318",
    ST: "MI",
    cityWithStateAbbr: "Casnovia, MI",
  },
  {
    zip: "49319",
    ST: "MI",
    cityWithStateAbbr: "Cedar Springs, MI",
  },
  {
    zip: "49320",
    ST: "MI",
    cityWithStateAbbr: "Chippewa Lake, MI",
  },
  {
    zip: "49321",
    ST: "MI",
    cityWithStateAbbr: "Comstock Park, MI",
  },
  {
    zip: "49322",
    ST: "MI",
    cityWithStateAbbr: "Coral, MI",
  },
  {
    zip: "49323",
    ST: "MI",
    cityWithStateAbbr: "Dorr, MI",
  },
  {
    zip: "49325",
    ST: "MI",
    cityWithStateAbbr: "Freeport, MI",
  },
  {
    zip: "49326",
    ST: "MI",
    cityWithStateAbbr: "Gowen, MI",
  },
  {
    zip: "49327",
    ST: "MI",
    cityWithStateAbbr: "Grant, MI",
  },
  {
    zip: "49328",
    ST: "MI",
    cityWithStateAbbr: "Hopkins, MI",
  },
  {
    zip: "49329",
    ST: "MI",
    cityWithStateAbbr: "Howard City, MI",
  },
  {
    zip: "49330",
    ST: "MI",
    cityWithStateAbbr: "Kent City, MI",
  },
  {
    zip: "49331",
    ST: "MI",
    cityWithStateAbbr: "Lowell, MI",
  },
  {
    zip: "49332",
    ST: "MI",
    cityWithStateAbbr: "Mecosta, MI",
  },
  {
    zip: "49333",
    ST: "MI",
    cityWithStateAbbr: "Middleville, MI",
  },
  {
    zip: "49335",
    ST: "MI",
    cityWithStateAbbr: "Moline, MI",
  },
  {
    zip: "49336",
    ST: "MI",
    cityWithStateAbbr: "Morley, MI",
  },
  {
    zip: "49337",
    ST: "MI",
    cityWithStateAbbr: "Newaygo, MI",
  },
  {
    zip: "49338",
    ST: "MI",
    cityWithStateAbbr: "Paris, MI",
  },
  {
    zip: "49339",
    ST: "MI",
    cityWithStateAbbr: "Pierson, MI",
  },
  {
    zip: "49340",
    ST: "MI",
    cityWithStateAbbr: "Remus, MI",
  },
  {
    zip: "49341",
    ST: "MI",
    cityWithStateAbbr: "Rockford, MI",
  },
  {
    zip: "49342",
    ST: "MI",
    cityWithStateAbbr: "Rodney, MI",
  },
  {
    zip: "49343",
    ST: "MI",
    cityWithStateAbbr: "Sand Lake, MI",
  },
  {
    zip: "49344",
    ST: "MI",
    cityWithStateAbbr: "Shelbyville, MI",
  },
  {
    zip: "49345",
    ST: "MI",
    cityWithStateAbbr: "Sparta, MI",
  },
  {
    zip: "49346",
    ST: "MI",
    cityWithStateAbbr: "Stanwood, MI",
  },
  {
    zip: "49347",
    ST: "MI",
    cityWithStateAbbr: "Trufant, MI",
  },
  {
    zip: "49348",
    ST: "MI",
    cityWithStateAbbr: "Wayland, MI",
  },
  {
    zip: "49349",
    ST: "MI",
    cityWithStateAbbr: "White Cloud, MI",
  },
  {
    zip: "49351",
    ST: "MI",
    cityWithStateAbbr: "Rockford, MI",
  },
  {
    zip: "49355",
    ST: "MI",
    cityWithStateAbbr: "Ada, MI",
  },
  {
    zip: "49356",
    ST: "MI",
    cityWithStateAbbr: "Ada, MI",
  },
  {
    zip: "49357",
    ST: "MI",
    cityWithStateAbbr: "Ada, MI",
  },
  {
    zip: "49401",
    ST: "MI",
    cityWithStateAbbr: "Allendale, MI",
  },
  {
    zip: "49402",
    ST: "MI",
    cityWithStateAbbr: "Branch, MI",
  },
  {
    zip: "49403",
    ST: "MI",
    cityWithStateAbbr: "Conklin, MI",
  },
  {
    zip: "49404",
    ST: "MI",
    cityWithStateAbbr: "Coopersville, MI",
  },
  {
    zip: "49405",
    ST: "MI",
    cityWithStateAbbr: "Custer, MI",
  },
  {
    zip: "49406",
    ST: "MI",
    cityWithStateAbbr: "Douglas, MI",
  },
  {
    zip: "49408",
    ST: "MI",
    cityWithStateAbbr: "Fennville, MI",
  },
  {
    zip: "49409",
    ST: "MI",
    cityWithStateAbbr: "Ferrysburg, MI",
  },
  {
    zip: "49410",
    ST: "MI",
    cityWithStateAbbr: "Fountain, MI",
  },
  {
    zip: "49411",
    ST: "MI",
    cityWithStateAbbr: "Free Soil, MI",
  },
  {
    zip: "49412",
    ST: "MI",
    cityWithStateAbbr: "Fremont, MI",
  },
  {
    zip: "49413",
    ST: "MI",
    cityWithStateAbbr: "Fremont, MI",
  },
  {
    zip: "49415",
    ST: "MI",
    cityWithStateAbbr: "Fruitport, MI",
  },
  {
    zip: "49416",
    ST: "MI",
    cityWithStateAbbr: "Glenn, MI",
  },
  {
    zip: "49417",
    ST: "MI",
    cityWithStateAbbr: "Grand Haven, MI",
  },
  {
    zip: "49418",
    ST: "MI",
    cityWithStateAbbr: "Grandville, MI",
  },
  {
    zip: "49419",
    ST: "MI",
    cityWithStateAbbr: "Hamilton, MI",
  },
  {
    zip: "49420",
    ST: "MI",
    cityWithStateAbbr: "Hart, MI",
  },
  {
    zip: "49421",
    ST: "MI",
    cityWithStateAbbr: "Hesperia, MI",
  },
  {
    zip: "49422",
    ST: "MI",
    cityWithStateAbbr: "Holland, MI",
  },
  {
    zip: "49423",
    ST: "MI",
    cityWithStateAbbr: "Holland, MI",
  },
  {
    zip: "49424",
    ST: "MI",
    cityWithStateAbbr: "Holland, MI",
  },
  {
    zip: "49425",
    ST: "MI",
    cityWithStateAbbr: "Holton, MI",
  },
  {
    zip: "49426",
    ST: "MI",
    cityWithStateAbbr: "Hudsonville, MI",
  },
  {
    zip: "49427",
    ST: "MI",
    cityWithStateAbbr: "Jamestown, MI",
  },
  {
    zip: "49428",
    ST: "MI",
    cityWithStateAbbr: "Jenison, MI",
  },
  {
    zip: "49429",
    ST: "MI",
    cityWithStateAbbr: "Jenison, MI",
  },
  {
    zip: "49430",
    ST: "MI",
    cityWithStateAbbr: "Lamont, MI",
  },
  {
    zip: "49431",
    ST: "MI",
    cityWithStateAbbr: "Ludington, MI",
  },
  {
    zip: "49434",
    ST: "MI",
    cityWithStateAbbr: "Macatawa, MI",
  },
  {
    zip: "49435",
    ST: "MI",
    cityWithStateAbbr: "Marne, MI",
  },
  {
    zip: "49436",
    ST: "MI",
    cityWithStateAbbr: "Mears, MI",
  },
  {
    zip: "49437",
    ST: "MI",
    cityWithStateAbbr: "Montague, MI",
  },
  {
    zip: "49440",
    ST: "MI",
    cityWithStateAbbr: "Muskegon, MI",
  },
  {
    zip: "49441",
    ST: "MI",
    cityWithStateAbbr: "Muskegon, MI",
  },
  {
    zip: "49442",
    ST: "MI",
    cityWithStateAbbr: "Muskegon, MI",
  },
  {
    zip: "49443",
    ST: "MI",
    cityWithStateAbbr: "Muskegon, MI",
  },
  {
    zip: "49444",
    ST: "MI",
    cityWithStateAbbr: "Muskegon, MI",
  },
  {
    zip: "49445",
    ST: "MI",
    cityWithStateAbbr: "Muskegon, MI",
  },
  {
    zip: "49446",
    ST: "MI",
    cityWithStateAbbr: "New Era, MI",
  },
  {
    zip: "49448",
    ST: "MI",
    cityWithStateAbbr: "Nunica, MI",
  },
  {
    zip: "49449",
    ST: "MI",
    cityWithStateAbbr: "Pentwater, MI",
  },
  {
    zip: "49450",
    ST: "MI",
    cityWithStateAbbr: "Pullman, MI",
  },
  {
    zip: "49451",
    ST: "MI",
    cityWithStateAbbr: "Ravenna, MI",
  },
  {
    zip: "49452",
    ST: "MI",
    cityWithStateAbbr: "Rothbury, MI",
  },
  {
    zip: "49453",
    ST: "MI",
    cityWithStateAbbr: "Saugatuck, MI",
  },
  {
    zip: "49454",
    ST: "MI",
    cityWithStateAbbr: "Scottville, MI",
  },
  {
    zip: "49455",
    ST: "MI",
    cityWithStateAbbr: "Shelby, MI",
  },
  {
    zip: "49456",
    ST: "MI",
    cityWithStateAbbr: "Spring Lake, MI",
  },
  {
    zip: "49457",
    ST: "MI",
    cityWithStateAbbr: "Twin Lake, MI",
  },
  {
    zip: "49458",
    ST: "MI",
    cityWithStateAbbr: "Walhalla, MI",
  },
  {
    zip: "49459",
    ST: "MI",
    cityWithStateAbbr: "Walkerville, MI",
  },
  {
    zip: "49460",
    ST: "MI",
    cityWithStateAbbr: "West Olive, MI",
  },
  {
    zip: "49461",
    ST: "MI",
    cityWithStateAbbr: "Whitehall, MI",
  },
  {
    zip: "49463",
    ST: "MI",
    cityWithStateAbbr: "Sylvan Beach, MI",
  },
  {
    zip: "49464",
    ST: "MI",
    cityWithStateAbbr: "Zeeland, MI",
  },
  {
    zip: "49468",
    ST: "MI",
    cityWithStateAbbr: "Grandville, MI",
  },
  {
    zip: "49501",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49502",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49503",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49504",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49505",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49506",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49507",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49508",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49509",
    ST: "MI",
    cityWithStateAbbr: "Wyoming, MI",
  },
  {
    zip: "49510",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49512",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49514",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49515",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49516",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49518",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49519",
    ST: "MI",
    cityWithStateAbbr: "Wyoming, MI",
  },
  {
    zip: "49523",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49525",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49528",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49530",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49534",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49544",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49546",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49548",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49555",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49560",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49588",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49599",
    ST: "MI",
    cityWithStateAbbr: "Grand Rapids, MI",
  },
  {
    zip: "49601",
    ST: "MI",
    cityWithStateAbbr: "Cadillac, MI",
  },
  {
    zip: "49610",
    ST: "MI",
    cityWithStateAbbr: "Acme, MI",
  },
  {
    zip: "49611",
    ST: "MI",
    cityWithStateAbbr: "Alba, MI",
  },
  {
    zip: "49612",
    ST: "MI",
    cityWithStateAbbr: "Alden, MI",
  },
  {
    zip: "49613",
    ST: "MI",
    cityWithStateAbbr: "Arcadia, MI",
  },
  {
    zip: "49614",
    ST: "MI",
    cityWithStateAbbr: "Bear Lake, MI",
  },
  {
    zip: "49615",
    ST: "MI",
    cityWithStateAbbr: "Bellaire, MI",
  },
  {
    zip: "49616",
    ST: "MI",
    cityWithStateAbbr: "Benzonia, MI",
  },
  {
    zip: "49617",
    ST: "MI",
    cityWithStateAbbr: "Beulah, MI",
  },
  {
    zip: "49618",
    ST: "MI",
    cityWithStateAbbr: "Boon, MI",
  },
  {
    zip: "49619",
    ST: "MI",
    cityWithStateAbbr: "Brethren, MI",
  },
  {
    zip: "49620",
    ST: "MI",
    cityWithStateAbbr: "Buckley, MI",
  },
  {
    zip: "49621",
    ST: "MI",
    cityWithStateAbbr: "Cedar, MI",
  },
  {
    zip: "49622",
    ST: "MI",
    cityWithStateAbbr: "Central Lake, MI",
  },
  {
    zip: "49623",
    ST: "MI",
    cityWithStateAbbr: "Chase, MI",
  },
  {
    zip: "49625",
    ST: "MI",
    cityWithStateAbbr: "Copemish, MI",
  },
  {
    zip: "49626",
    ST: "MI",
    cityWithStateAbbr: "Eastlake, MI",
  },
  {
    zip: "49627",
    ST: "MI",
    cityWithStateAbbr: "Eastport, MI",
  },
  {
    zip: "49628",
    ST: "MI",
    cityWithStateAbbr: "Elberta, MI",
  },
  {
    zip: "49629",
    ST: "MI",
    cityWithStateAbbr: "Elk Rapids, MI",
  },
  {
    zip: "49630",
    ST: "MI",
    cityWithStateAbbr: "Empire, MI",
  },
  {
    zip: "49631",
    ST: "MI",
    cityWithStateAbbr: "Evart, MI",
  },
  {
    zip: "49632",
    ST: "MI",
    cityWithStateAbbr: "Falmouth, MI",
  },
  {
    zip: "49633",
    ST: "MI",
    cityWithStateAbbr: "Fife Lake, MI",
  },
  {
    zip: "49634",
    ST: "MI",
    cityWithStateAbbr: "Filer City, MI",
  },
  {
    zip: "49635",
    ST: "MI",
    cityWithStateAbbr: "Frankfort, MI",
  },
  {
    zip: "49636",
    ST: "MI",
    cityWithStateAbbr: "Glen Arbor, MI",
  },
  {
    zip: "49637",
    ST: "MI",
    cityWithStateAbbr: "Grawn, MI",
  },
  {
    zip: "49638",
    ST: "MI",
    cityWithStateAbbr: "Harrietta, MI",
  },
  {
    zip: "49639",
    ST: "MI",
    cityWithStateAbbr: "Hersey, MI",
  },
  {
    zip: "49640",
    ST: "MI",
    cityWithStateAbbr: "Honor, MI",
  },
  {
    zip: "49642",
    ST: "MI",
    cityWithStateAbbr: "Idlewild, MI",
  },
  {
    zip: "49643",
    ST: "MI",
    cityWithStateAbbr: "Interlochen, MI",
  },
  {
    zip: "49644",
    ST: "MI",
    cityWithStateAbbr: "Irons, MI",
  },
  {
    zip: "49645",
    ST: "MI",
    cityWithStateAbbr: "Kaleva, MI",
  },
  {
    zip: "49646",
    ST: "MI",
    cityWithStateAbbr: "Kalkaska, MI",
  },
  {
    zip: "49648",
    ST: "MI",
    cityWithStateAbbr: "Kewadin, MI",
  },
  {
    zip: "49649",
    ST: "MI",
    cityWithStateAbbr: "Kingsley, MI",
  },
  {
    zip: "49650",
    ST: "MI",
    cityWithStateAbbr: "Lake Ann, MI",
  },
  {
    zip: "49651",
    ST: "MI",
    cityWithStateAbbr: "Lake City, MI",
  },
  {
    zip: "49653",
    ST: "MI",
    cityWithStateAbbr: "Lake Leelanau, MI",
  },
  {
    zip: "49654",
    ST: "MI",
    cityWithStateAbbr: "Leland, MI",
  },
  {
    zip: "49655",
    ST: "MI",
    cityWithStateAbbr: "Leroy, MI",
  },
  {
    zip: "49656",
    ST: "MI",
    cityWithStateAbbr: "Luther, MI",
  },
  {
    zip: "49657",
    ST: "MI",
    cityWithStateAbbr: "Mc Bain, MI",
  },
  {
    zip: "49659",
    ST: "MI",
    cityWithStateAbbr: "Mancelona, MI",
  },
  {
    zip: "49660",
    ST: "MI",
    cityWithStateAbbr: "Manistee, MI",
  },
  {
    zip: "49663",
    ST: "MI",
    cityWithStateAbbr: "Manton, MI",
  },
  {
    zip: "49664",
    ST: "MI",
    cityWithStateAbbr: "Maple City, MI",
  },
  {
    zip: "49665",
    ST: "MI",
    cityWithStateAbbr: "Marion, MI",
  },
  {
    zip: "49666",
    ST: "MI",
    cityWithStateAbbr: "Mayfield, MI",
  },
  {
    zip: "49667",
    ST: "MI",
    cityWithStateAbbr: "Merritt, MI",
  },
  {
    zip: "49668",
    ST: "MI",
    cityWithStateAbbr: "Mesick, MI",
  },
  {
    zip: "49670",
    ST: "MI",
    cityWithStateAbbr: "Northport, MI",
  },
  {
    zip: "49673",
    ST: "MI",
    cityWithStateAbbr: "Old Mission, MI",
  },
  {
    zip: "49674",
    ST: "MI",
    cityWithStateAbbr: "Omena, MI",
  },
  {
    zip: "49675",
    ST: "MI",
    cityWithStateAbbr: "Onekama, MI",
  },
  {
    zip: "49676",
    ST: "MI",
    cityWithStateAbbr: "Rapid City, MI",
  },
  {
    zip: "49677",
    ST: "MI",
    cityWithStateAbbr: "Reed City, MI",
  },
  {
    zip: "49679",
    ST: "MI",
    cityWithStateAbbr: "Sears, MI",
  },
  {
    zip: "49680",
    ST: "MI",
    cityWithStateAbbr: "South Boardman, MI",
  },
  {
    zip: "49682",
    ST: "MI",
    cityWithStateAbbr: "Suttons Bay, MI",
  },
  {
    zip: "49683",
    ST: "MI",
    cityWithStateAbbr: "Thompsonville, MI",
  },
  {
    zip: "49684",
    ST: "MI",
    cityWithStateAbbr: "Traverse City, MI",
  },
  {
    zip: "49685",
    ST: "MI",
    cityWithStateAbbr: "Traverse City, MI",
  },
  {
    zip: "49686",
    ST: "MI",
    cityWithStateAbbr: "Traverse City, MI",
  },
  {
    zip: "49688",
    ST: "MI",
    cityWithStateAbbr: "Tustin, MI",
  },
  {
    zip: "49689",
    ST: "MI",
    cityWithStateAbbr: "Wellston, MI",
  },
  {
    zip: "49690",
    ST: "MI",
    cityWithStateAbbr: "Williamsburg, MI",
  },
  {
    zip: "49696",
    ST: "MI",
    cityWithStateAbbr: "Traverse City, MI",
  },
  {
    zip: "49701",
    ST: "MI",
    cityWithStateAbbr: "Mackinaw City, MI",
  },
  {
    zip: "49705",
    ST: "MI",
    cityWithStateAbbr: "Afton, MI",
  },
  {
    zip: "49706",
    ST: "MI",
    cityWithStateAbbr: "Alanson, MI",
  },
  {
    zip: "49707",
    ST: "MI",
    cityWithStateAbbr: "Alpena, MI",
  },
  {
    zip: "49709",
    ST: "MI",
    cityWithStateAbbr: "Atlanta, MI",
  },
  {
    zip: "49710",
    ST: "MI",
    cityWithStateAbbr: "Barbeau, MI",
  },
  {
    zip: "49711",
    ST: "MI",
    cityWithStateAbbr: "Bay Shore, MI",
  },
  {
    zip: "49712",
    ST: "MI",
    cityWithStateAbbr: "Boyne City, MI",
  },
  {
    zip: "49713",
    ST: "MI",
    cityWithStateAbbr: "Boyne Falls, MI",
  },
  {
    zip: "49715",
    ST: "MI",
    cityWithStateAbbr: "Brimley, MI",
  },
  {
    zip: "49716",
    ST: "MI",
    cityWithStateAbbr: "Brutus, MI",
  },
  {
    zip: "49717",
    ST: "MI",
    cityWithStateAbbr: "Burt Lake, MI",
  },
  {
    zip: "49718",
    ST: "MI",
    cityWithStateAbbr: "Carp Lake, MI",
  },
  {
    zip: "49719",
    ST: "MI",
    cityWithStateAbbr: "Cedarville, MI",
  },
  {
    zip: "49720",
    ST: "MI",
    cityWithStateAbbr: "Charlevoix, MI",
  },
  {
    zip: "49721",
    ST: "MI",
    cityWithStateAbbr: "Cheboygan, MI",
  },
  {
    zip: "49722",
    ST: "MI",
    cityWithStateAbbr: "Conway, MI",
  },
  {
    zip: "49723",
    ST: "MI",
    cityWithStateAbbr: "Cross Village, MI",
  },
  {
    zip: "49724",
    ST: "MI",
    cityWithStateAbbr: "Dafter, MI",
  },
  {
    zip: "49725",
    ST: "MI",
    cityWithStateAbbr: "De Tour Village, MI",
  },
  {
    zip: "49726",
    ST: "MI",
    cityWithStateAbbr: "Drummond Island, MI",
  },
  {
    zip: "49727",
    ST: "MI",
    cityWithStateAbbr: "East Jordan, MI",
  },
  {
    zip: "49728",
    ST: "MI",
    cityWithStateAbbr: "Eckerman, MI",
  },
  {
    zip: "49729",
    ST: "MI",
    cityWithStateAbbr: "Ellsworth, MI",
  },
  {
    zip: "49730",
    ST: "MI",
    cityWithStateAbbr: "Elmira, MI",
  },
  {
    zip: "49733",
    ST: "MI",
    cityWithStateAbbr: "Frederic, MI",
  },
  {
    zip: "49734",
    ST: "MI",
    cityWithStateAbbr: "Gaylord, MI",
  },
  {
    zip: "49735",
    ST: "MI",
    cityWithStateAbbr: "Gaylord, MI",
  },
  {
    zip: "49736",
    ST: "MI",
    cityWithStateAbbr: "Goetzville, MI",
  },
  {
    zip: "49737",
    ST: "MI",
    cityWithStateAbbr: "Good Hart, MI",
  },
  {
    zip: "49738",
    ST: "MI",
    cityWithStateAbbr: "Grayling, MI",
  },
  {
    zip: "49739",
    ST: "MI",
    cityWithStateAbbr: "Grayling, MI",
  },
  {
    zip: "49740",
    ST: "MI",
    cityWithStateAbbr: "Harbor Springs, MI",
  },
  {
    zip: "49743",
    ST: "MI",
    cityWithStateAbbr: "Hawks, MI",
  },
  {
    zip: "49744",
    ST: "MI",
    cityWithStateAbbr: "Herron, MI",
  },
  {
    zip: "49745",
    ST: "MI",
    cityWithStateAbbr: "Hessel, MI",
  },
  {
    zip: "49746",
    ST: "MI",
    cityWithStateAbbr: "Hillman, MI",
  },
  {
    zip: "49747",
    ST: "MI",
    cityWithStateAbbr: "Hubbard Lake, MI",
  },
  {
    zip: "49748",
    ST: "MI",
    cityWithStateAbbr: "Hulbert, MI",
  },
  {
    zip: "49749",
    ST: "MI",
    cityWithStateAbbr: "Indian River, MI",
  },
  {
    zip: "49751",
    ST: "MI",
    cityWithStateAbbr: "Johannesburg, MI",
  },
  {
    zip: "49752",
    ST: "MI",
    cityWithStateAbbr: "Kinross, MI",
  },
  {
    zip: "49753",
    ST: "MI",
    cityWithStateAbbr: "Lachine, MI",
  },
  {
    zip: "49755",
    ST: "MI",
    cityWithStateAbbr: "Levering, MI",
  },
  {
    zip: "49756",
    ST: "MI",
    cityWithStateAbbr: "Lewiston, MI",
  },
  {
    zip: "49757",
    ST: "MI",
    cityWithStateAbbr: "Mackinac Island, MI",
  },
  {
    zip: "49759",
    ST: "MI",
    cityWithStateAbbr: "Millersburg, MI",
  },
  {
    zip: "49760",
    ST: "MI",
    cityWithStateAbbr: "Moran, MI",
  },
  {
    zip: "49761",
    ST: "MI",
    cityWithStateAbbr: "Mullett Lake, MI",
  },
  {
    zip: "49762",
    ST: "MI",
    cityWithStateAbbr: "Naubinway, MI",
  },
  {
    zip: "49764",
    ST: "MI",
    cityWithStateAbbr: "Oden, MI",
  },
  {
    zip: "49765",
    ST: "MI",
    cityWithStateAbbr: "Onaway, MI",
  },
  {
    zip: "49766",
    ST: "MI",
    cityWithStateAbbr: "Ossineke, MI",
  },
  {
    zip: "49768",
    ST: "MI",
    cityWithStateAbbr: "Paradise, MI",
  },
  {
    zip: "49769",
    ST: "MI",
    cityWithStateAbbr: "Pellston, MI",
  },
  {
    zip: "49770",
    ST: "MI",
    cityWithStateAbbr: "Petoskey, MI",
  },
  {
    zip: "49774",
    ST: "MI",
    cityWithStateAbbr: "Pickford, MI",
  },
  {
    zip: "49775",
    ST: "MI",
    cityWithStateAbbr: "Pointe Aux Pins, MI",
  },
  {
    zip: "49776",
    ST: "MI",
    cityWithStateAbbr: "Posen, MI",
  },
  {
    zip: "49777",
    ST: "MI",
    cityWithStateAbbr: "Presque Isle, MI",
  },
  {
    zip: "49779",
    ST: "MI",
    cityWithStateAbbr: "Rogers City, MI",
  },
  {
    zip: "49780",
    ST: "MI",
    cityWithStateAbbr: "Rudyard, MI",
  },
  {
    zip: "49781",
    ST: "MI",
    cityWithStateAbbr: "Saint Ignace, MI",
  },
  {
    zip: "49782",
    ST: "MI",
    cityWithStateAbbr: "Beaver Island, MI",
  },
  {
    zip: "49783",
    ST: "MI",
    cityWithStateAbbr: "Sault Sainte Marie, MI",
  },
  {
    zip: "49784",
    ST: "MI",
    cityWithStateAbbr: "Kincheloe, MI",
  },
  {
    zip: "49785",
    ST: "MI",
    cityWithStateAbbr: "Kincheloe, MI",
  },
  {
    zip: "49786",
    ST: "MI",
    cityWithStateAbbr: "Kincheloe, MI",
  },
  {
    zip: "49788",
    ST: "MI",
    cityWithStateAbbr: "Kincheloe, MI",
  },
  {
    zip: "49791",
    ST: "MI",
    cityWithStateAbbr: "Topinabee, MI",
  },
  {
    zip: "49792",
    ST: "MI",
    cityWithStateAbbr: "Tower, MI",
  },
  {
    zip: "49793",
    ST: "MI",
    cityWithStateAbbr: "Trout Lake, MI",
  },
  {
    zip: "49795",
    ST: "MI",
    cityWithStateAbbr: "Vanderbilt, MI",
  },
  {
    zip: "49796",
    ST: "MI",
    cityWithStateAbbr: "Walloon Lake, MI",
  },
  {
    zip: "49797",
    ST: "MI",
    cityWithStateAbbr: "Waters, MI",
  },
  {
    zip: "49799",
    ST: "MI",
    cityWithStateAbbr: "Wolverine, MI",
  },
  {
    zip: "49801",
    ST: "MI",
    cityWithStateAbbr: "Iron Mountain, MI",
  },
  {
    zip: "49802",
    ST: "MI",
    cityWithStateAbbr: "Kingsford, MI",
  },
  {
    zip: "49805",
    ST: "MI",
    cityWithStateAbbr: "Allouez, MI",
  },
  {
    zip: "49806",
    ST: "MI",
    cityWithStateAbbr: "Au Train, MI",
  },
  {
    zip: "49807",
    ST: "MI",
    cityWithStateAbbr: "Bark River, MI",
  },
  {
    zip: "49808",
    ST: "MI",
    cityWithStateAbbr: "Big Bay, MI",
  },
  {
    zip: "49812",
    ST: "MI",
    cityWithStateAbbr: "Carney, MI",
  },
  {
    zip: "49814",
    ST: "MI",
    cityWithStateAbbr: "Champion, MI",
  },
  {
    zip: "49815",
    ST: "MI",
    cityWithStateAbbr: "Channing, MI",
  },
  {
    zip: "49816",
    ST: "MI",
    cityWithStateAbbr: "Chatham, MI",
  },
  {
    zip: "49817",
    ST: "MI",
    cityWithStateAbbr: "Cooks, MI",
  },
  {
    zip: "49818",
    ST: "MI",
    cityWithStateAbbr: "Cornell, MI",
  },
  {
    zip: "49819",
    ST: "MI",
    cityWithStateAbbr: "Arnold, MI",
  },
  {
    zip: "49820",
    ST: "MI",
    cityWithStateAbbr: "Curtis, MI",
  },
  {
    zip: "49821",
    ST: "MI",
    cityWithStateAbbr: "Daggett, MI",
  },
  {
    zip: "49822",
    ST: "MI",
    cityWithStateAbbr: "Deerton, MI",
  },
  {
    zip: "49825",
    ST: "MI",
    cityWithStateAbbr: "Eben Junction, MI",
  },
  {
    zip: "49826",
    ST: "MI",
    cityWithStateAbbr: "Rumely, MI",
  },
  {
    zip: "49827",
    ST: "MI",
    cityWithStateAbbr: "Engadine, MI",
  },
  {
    zip: "49829",
    ST: "MI",
    cityWithStateAbbr: "Escanaba, MI",
  },
  {
    zip: "49831",
    ST: "MI",
    cityWithStateAbbr: "Felch, MI",
  },
  {
    zip: "49833",
    ST: "MI",
    cityWithStateAbbr: "Little Lake, MI",
  },
  {
    zip: "49834",
    ST: "MI",
    cityWithStateAbbr: "Foster City, MI",
  },
  {
    zip: "49835",
    ST: "MI",
    cityWithStateAbbr: "Garden, MI",
  },
  {
    zip: "49836",
    ST: "MI",
    cityWithStateAbbr: "Germfask, MI",
  },
  {
    zip: "49837",
    ST: "MI",
    cityWithStateAbbr: "Gladstone, MI",
  },
  {
    zip: "49838",
    ST: "MI",
    cityWithStateAbbr: "Gould City, MI",
  },
  {
    zip: "49839",
    ST: "MI",
    cityWithStateAbbr: "Grand Marais, MI",
  },
  {
    zip: "49840",
    ST: "MI",
    cityWithStateAbbr: "Gulliver, MI",
  },
  {
    zip: "49841",
    ST: "MI",
    cityWithStateAbbr: "Gwinn, MI",
  },
  {
    zip: "49845",
    ST: "MI",
    cityWithStateAbbr: "Harris, MI",
  },
  {
    zip: "49847",
    ST: "MI",
    cityWithStateAbbr: "Hermansville, MI",
  },
  {
    zip: "49848",
    ST: "MI",
    cityWithStateAbbr: "Ingalls, MI",
  },
  {
    zip: "49849",
    ST: "MI",
    cityWithStateAbbr: "Ishpeming, MI",
  },
  {
    zip: "49852",
    ST: "MI",
    cityWithStateAbbr: "Loretto, MI",
  },
  {
    zip: "49853",
    ST: "MI",
    cityWithStateAbbr: "Mc Millan, MI",
  },
  {
    zip: "49854",
    ST: "MI",
    cityWithStateAbbr: "Manistique, MI",
  },
  {
    zip: "49855",
    ST: "MI",
    cityWithStateAbbr: "Marquette, MI",
  },
  {
    zip: "49858",
    ST: "MI",
    cityWithStateAbbr: "Menominee, MI",
  },
  {
    zip: "49861",
    ST: "MI",
    cityWithStateAbbr: "Michigamme, MI",
  },
  {
    zip: "49862",
    ST: "MI",
    cityWithStateAbbr: "Munising, MI",
  },
  {
    zip: "49863",
    ST: "MI",
    cityWithStateAbbr: "Nadeau, MI",
  },
  {
    zip: "49864",
    ST: "MI",
    cityWithStateAbbr: "Nahma, MI",
  },
  {
    zip: "49865",
    ST: "MI",
    cityWithStateAbbr: "National Mine, MI",
  },
  {
    zip: "49866",
    ST: "MI",
    cityWithStateAbbr: "Negaunee, MI",
  },
  {
    zip: "49868",
    ST: "MI",
    cityWithStateAbbr: "Newberry, MI",
  },
  {
    zip: "49870",
    ST: "MI",
    cityWithStateAbbr: "Norway, MI",
  },
  {
    zip: "49871",
    ST: "MI",
    cityWithStateAbbr: "Palmer, MI",
  },
  {
    zip: "49872",
    ST: "MI",
    cityWithStateAbbr: "Perkins, MI",
  },
  {
    zip: "49873",
    ST: "MI",
    cityWithStateAbbr: "Perronville, MI",
  },
  {
    zip: "49874",
    ST: "MI",
    cityWithStateAbbr: "Powers, MI",
  },
  {
    zip: "49876",
    ST: "MI",
    cityWithStateAbbr: "Quinnesec, MI",
  },
  {
    zip: "49877",
    ST: "MI",
    cityWithStateAbbr: "Ralph, MI",
  },
  {
    zip: "49878",
    ST: "MI",
    cityWithStateAbbr: "Rapid River, MI",
  },
  {
    zip: "49879",
    ST: "MI",
    cityWithStateAbbr: "Republic, MI",
  },
  {
    zip: "49880",
    ST: "MI",
    cityWithStateAbbr: "Rock, MI",
  },
  {
    zip: "49881",
    ST: "MI",
    cityWithStateAbbr: "Sagola, MI",
  },
  {
    zip: "49883",
    ST: "MI",
    cityWithStateAbbr: "Seney, MI",
  },
  {
    zip: "49884",
    ST: "MI",
    cityWithStateAbbr: "Shingleton, MI",
  },
  {
    zip: "49885",
    ST: "MI",
    cityWithStateAbbr: "Skandia, MI",
  },
  {
    zip: "49886",
    ST: "MI",
    cityWithStateAbbr: "Spalding, MI",
  },
  {
    zip: "49887",
    ST: "MI",
    cityWithStateAbbr: "Stephenson, MI",
  },
  {
    zip: "49891",
    ST: "MI",
    cityWithStateAbbr: "Trenary, MI",
  },
  {
    zip: "49892",
    ST: "MI",
    cityWithStateAbbr: "Vulcan, MI",
  },
  {
    zip: "49893",
    ST: "MI",
    cityWithStateAbbr: "Wallace, MI",
  },
  {
    zip: "49894",
    ST: "MI",
    cityWithStateAbbr: "Wells, MI",
  },
  {
    zip: "49895",
    ST: "MI",
    cityWithStateAbbr: "Wetmore, MI",
  },
  {
    zip: "49896",
    ST: "MI",
    cityWithStateAbbr: "Wilson, MI",
  },
  {
    zip: "49901",
    ST: "MI",
    cityWithStateAbbr: "Ahmeek, MI",
  },
  {
    zip: "49902",
    ST: "MI",
    cityWithStateAbbr: "Alpha, MI",
  },
  {
    zip: "49903",
    ST: "MI",
    cityWithStateAbbr: "Amasa, MI",
  },
  {
    zip: "49905",
    ST: "MI",
    cityWithStateAbbr: "Atlantic Mine, MI",
  },
  {
    zip: "49908",
    ST: "MI",
    cityWithStateAbbr: "Baraga, MI",
  },
  {
    zip: "49910",
    ST: "MI",
    cityWithStateAbbr: "Bergland, MI",
  },
  {
    zip: "49911",
    ST: "MI",
    cityWithStateAbbr: "Bessemer, MI",
  },
  {
    zip: "49912",
    ST: "MI",
    cityWithStateAbbr: "Bruce Crossing, MI",
  },
  {
    zip: "49913",
    ST: "MI",
    cityWithStateAbbr: "Calumet, MI",
  },
  {
    zip: "49915",
    ST: "MI",
    cityWithStateAbbr: "Caspian, MI",
  },
  {
    zip: "49916",
    ST: "MI",
    cityWithStateAbbr: "Chassell, MI",
  },
  {
    zip: "49917",
    ST: "MI",
    cityWithStateAbbr: "Copper City, MI",
  },
  {
    zip: "49918",
    ST: "MI",
    cityWithStateAbbr: "Copper Harbor, MI",
  },
  {
    zip: "49919",
    ST: "MI",
    cityWithStateAbbr: "Covington, MI",
  },
  {
    zip: "49920",
    ST: "MI",
    cityWithStateAbbr: "Crystal Falls, MI",
  },
  {
    zip: "49921",
    ST: "MI",
    cityWithStateAbbr: "Dodgeville, MI",
  },
  {
    zip: "49922",
    ST: "MI",
    cityWithStateAbbr: "Dollar Bay, MI",
  },
  {
    zip: "49925",
    ST: "MI",
    cityWithStateAbbr: "Ewen, MI",
  },
  {
    zip: "49927",
    ST: "MI",
    cityWithStateAbbr: "Gaastra, MI",
  },
  {
    zip: "49929",
    ST: "MI",
    cityWithStateAbbr: "Greenland, MI",
  },
  {
    zip: "49930",
    ST: "MI",
    cityWithStateAbbr: "Hancock, MI",
  },
  {
    zip: "49931",
    ST: "MI",
    cityWithStateAbbr: "Houghton, MI",
  },
  {
    zip: "49934",
    ST: "MI",
    cityWithStateAbbr: "Hubbell, MI",
  },
  {
    zip: "49935",
    ST: "MI",
    cityWithStateAbbr: "Iron River, MI",
  },
  {
    zip: "49938",
    ST: "MI",
    cityWithStateAbbr: "Ironwood, MI",
  },
  {
    zip: "49942",
    ST: "MI",
    cityWithStateAbbr: "Kearsarge, MI",
  },
  {
    zip: "49945",
    ST: "MI",
    cityWithStateAbbr: "Lake Linden, MI",
  },
  {
    zip: "49946",
    ST: "MI",
    cityWithStateAbbr: "Lanse, MI",
  },
  {
    zip: "49947",
    ST: "MI",
    cityWithStateAbbr: "Marenisco, MI",
  },
  {
    zip: "49948",
    ST: "MI",
    cityWithStateAbbr: "Mass City, MI",
  },
  {
    zip: "49950",
    ST: "MI",
    cityWithStateAbbr: "Mohawk, MI",
  },
  {
    zip: "49952",
    ST: "MI",
    cityWithStateAbbr: "Nisula, MI",
  },
  {
    zip: "49953",
    ST: "MI",
    cityWithStateAbbr: "Ontonagon, MI",
  },
  {
    zip: "49955",
    ST: "MI",
    cityWithStateAbbr: "Painesdale, MI",
  },
  {
    zip: "49958",
    ST: "MI",
    cityWithStateAbbr: "Pelkie, MI",
  },
  {
    zip: "49959",
    ST: "MI",
    cityWithStateAbbr: "Ramsay, MI",
  },
  {
    zip: "49960",
    ST: "MI",
    cityWithStateAbbr: "Rockland, MI",
  },
  {
    zip: "49961",
    ST: "MI",
    cityWithStateAbbr: "Sidnaw, MI",
  },
  {
    zip: "49962",
    ST: "MI",
    cityWithStateAbbr: "Skanee, MI",
  },
  {
    zip: "49963",
    ST: "MI",
    cityWithStateAbbr: "South Range, MI",
  },
  {
    zip: "49964",
    ST: "MI",
    cityWithStateAbbr: "Stambaugh, MI",
  },
  {
    zip: "49965",
    ST: "MI",
    cityWithStateAbbr: "Toivola, MI",
  },
  {
    zip: "49967",
    ST: "MI",
    cityWithStateAbbr: "Trout Creek, MI",
  },
  {
    zip: "49968",
    ST: "MI",
    cityWithStateAbbr: "Wakefield, MI",
  },
  {
    zip: "49969",
    ST: "MI",
    cityWithStateAbbr: "Watersmeet, MI",
  },
  {
    zip: "49970",
    ST: "MI",
    cityWithStateAbbr: "Watton, MI",
  },
  {
    zip: "49971",
    ST: "MI",
    cityWithStateAbbr: "White Pine, MI",
  },
  {
    zip: "50001",
    ST: "IA",
    cityWithStateAbbr: "Ackworth, IA",
  },
  {
    zip: "50002",
    ST: "IA",
    cityWithStateAbbr: "Adair, IA",
  },
  {
    zip: "50003",
    ST: "IA",
    cityWithStateAbbr: "Adel, IA",
  },
  {
    zip: "50005",
    ST: "IA",
    cityWithStateAbbr: "Albion, IA",
  },
  {
    zip: "50006",
    ST: "IA",
    cityWithStateAbbr: "Alden, IA",
  },
  {
    zip: "50007",
    ST: "IA",
    cityWithStateAbbr: "Alleman, IA",
  },
  {
    zip: "50008",
    ST: "IA",
    cityWithStateAbbr: "Allerton, IA",
  },
  {
    zip: "50009",
    ST: "IA",
    cityWithStateAbbr: "Altoona, IA",
  },
  {
    zip: "50010",
    ST: "IA",
    cityWithStateAbbr: "Ames, IA",
  },
  {
    zip: "50011",
    ST: "IA",
    cityWithStateAbbr: "Ames, IA",
  },
  {
    zip: "50012",
    ST: "IA",
    cityWithStateAbbr: "Ames, IA",
  },
  {
    zip: "50013",
    ST: "IA",
    cityWithStateAbbr: "Ames, IA",
  },
  {
    zip: "50014",
    ST: "IA",
    cityWithStateAbbr: "Ames, IA",
  },
  {
    zip: "50020",
    ST: "IA",
    cityWithStateAbbr: "Anita, IA",
  },
  {
    zip: "50021",
    ST: "IA",
    cityWithStateAbbr: "Ankeny, IA",
  },
  {
    zip: "50022",
    ST: "IA",
    cityWithStateAbbr: "Atlantic, IA",
  },
  {
    zip: "50023",
    ST: "IA",
    cityWithStateAbbr: "Ankeny, IA",
  },
  {
    zip: "50025",
    ST: "IA",
    cityWithStateAbbr: "Audubon, IA",
  },
  {
    zip: "50026",
    ST: "IA",
    cityWithStateAbbr: "Bagley, IA",
  },
  {
    zip: "50027",
    ST: "IA",
    cityWithStateAbbr: "Barnes City, IA",
  },
  {
    zip: "50028",
    ST: "IA",
    cityWithStateAbbr: "Baxter, IA",
  },
  {
    zip: "50029",
    ST: "IA",
    cityWithStateAbbr: "Bayard, IA",
  },
  {
    zip: "50031",
    ST: "IA",
    cityWithStateAbbr: "Beaver, IA",
  },
  {
    zip: "50032",
    ST: "IA",
    cityWithStateAbbr: "Berwick, IA",
  },
  {
    zip: "50033",
    ST: "IA",
    cityWithStateAbbr: "Bevington, IA",
  },
  {
    zip: "50034",
    ST: "IA",
    cityWithStateAbbr: "Blairsburg, IA",
  },
  {
    zip: "50035",
    ST: "IA",
    cityWithStateAbbr: "Bondurant, IA",
  },
  {
    zip: "50036",
    ST: "IA",
    cityWithStateAbbr: "Boone, IA",
  },
  {
    zip: "50037",
    ST: "IA",
    cityWithStateAbbr: "Boone, IA",
  },
  {
    zip: "50038",
    ST: "IA",
    cityWithStateAbbr: "Booneville, IA",
  },
  {
    zip: "50039",
    ST: "IA",
    cityWithStateAbbr: "Bouton, IA",
  },
  {
    zip: "50040",
    ST: "IA",
    cityWithStateAbbr: "Boxholm, IA",
  },
  {
    zip: "50041",
    ST: "IA",
    cityWithStateAbbr: "Bradford, IA",
  },
  {
    zip: "50042",
    ST: "IA",
    cityWithStateAbbr: "Brayton, IA",
  },
  {
    zip: "50043",
    ST: "IA",
    cityWithStateAbbr: "Buckeye, IA",
  },
  {
    zip: "50044",
    ST: "IA",
    cityWithStateAbbr: "Bussey, IA",
  },
  {
    zip: "50046",
    ST: "IA",
    cityWithStateAbbr: "Cambridge, IA",
  },
  {
    zip: "50047",
    ST: "IA",
    cityWithStateAbbr: "Carlisle, IA",
  },
  {
    zip: "50048",
    ST: "IA",
    cityWithStateAbbr: "Casey, IA",
  },
  {
    zip: "50049",
    ST: "IA",
    cityWithStateAbbr: "Chariton, IA",
  },
  {
    zip: "50050",
    ST: "IA",
    cityWithStateAbbr: "Churdan, IA",
  },
  {
    zip: "50051",
    ST: "IA",
    cityWithStateAbbr: "Clemons, IA",
  },
  {
    zip: "50052",
    ST: "IA",
    cityWithStateAbbr: "Clio, IA",
  },
  {
    zip: "50054",
    ST: "IA",
    cityWithStateAbbr: "Colfax, IA",
  },
  {
    zip: "50055",
    ST: "IA",
    cityWithStateAbbr: "Collins, IA",
  },
  {
    zip: "50056",
    ST: "IA",
    cityWithStateAbbr: "Colo, IA",
  },
  {
    zip: "50057",
    ST: "IA",
    cityWithStateAbbr: "Columbia, IA",
  },
  {
    zip: "50058",
    ST: "IA",
    cityWithStateAbbr: "Coon Rapids, IA",
  },
  {
    zip: "50059",
    ST: "IA",
    cityWithStateAbbr: "Cooper, IA",
  },
  {
    zip: "50060",
    ST: "IA",
    cityWithStateAbbr: "Corydon, IA",
  },
  {
    zip: "50061",
    ST: "IA",
    cityWithStateAbbr: "Cumming, IA",
  },
  {
    zip: "50062",
    ST: "IA",
    cityWithStateAbbr: "Melcher Dallas, IA",
  },
  {
    zip: "50063",
    ST: "IA",
    cityWithStateAbbr: "Dallas Center, IA",
  },
  {
    zip: "50064",
    ST: "IA",
    cityWithStateAbbr: "Dana, IA",
  },
  {
    zip: "50065",
    ST: "IA",
    cityWithStateAbbr: "Davis City, IA",
  },
  {
    zip: "50066",
    ST: "IA",
    cityWithStateAbbr: "Dawson, IA",
  },
  {
    zip: "50067",
    ST: "IA",
    cityWithStateAbbr: "Decatur, IA",
  },
  {
    zip: "50068",
    ST: "IA",
    cityWithStateAbbr: "Derby, IA",
  },
  {
    zip: "50069",
    ST: "IA",
    cityWithStateAbbr: "De Soto, IA",
  },
  {
    zip: "50070",
    ST: "IA",
    cityWithStateAbbr: "Dexter, IA",
  },
  {
    zip: "50071",
    ST: "IA",
    cityWithStateAbbr: "Dows, IA",
  },
  {
    zip: "50072",
    ST: "IA",
    cityWithStateAbbr: "Earlham, IA",
  },
  {
    zip: "50073",
    ST: "IA",
    cityWithStateAbbr: "Elkhart, IA",
  },
  {
    zip: "50074",
    ST: "IA",
    cityWithStateAbbr: "Ellston, IA",
  },
  {
    zip: "50075",
    ST: "IA",
    cityWithStateAbbr: "Ellsworth, IA",
  },
  {
    zip: "50076",
    ST: "IA",
    cityWithStateAbbr: "Exira, IA",
  },
  {
    zip: "50078",
    ST: "IA",
    cityWithStateAbbr: "Ferguson, IA",
  },
  {
    zip: "50101",
    ST: "IA",
    cityWithStateAbbr: "Galt, IA",
  },
  {
    zip: "50102",
    ST: "IA",
    cityWithStateAbbr: "Garden City, IA",
  },
  {
    zip: "50103",
    ST: "IA",
    cityWithStateAbbr: "Garden Grove, IA",
  },
  {
    zip: "50104",
    ST: "IA",
    cityWithStateAbbr: "Gibson, IA",
  },
  {
    zip: "50105",
    ST: "IA",
    cityWithStateAbbr: "Gilbert, IA",
  },
  {
    zip: "50106",
    ST: "IA",
    cityWithStateAbbr: "Gilman, IA",
  },
  {
    zip: "50107",
    ST: "IA",
    cityWithStateAbbr: "Grand Junction, IA",
  },
  {
    zip: "50108",
    ST: "IA",
    cityWithStateAbbr: "Grand River, IA",
  },
  {
    zip: "50109",
    ST: "IA",
    cityWithStateAbbr: "Granger, IA",
  },
  {
    zip: "50110",
    ST: "IA",
    cityWithStateAbbr: "Gray, IA",
  },
  {
    zip: "50111",
    ST: "IA",
    cityWithStateAbbr: "Grimes, IA",
  },
  {
    zip: "50112",
    ST: "IA",
    cityWithStateAbbr: "Grinnell, IA",
  },
  {
    zip: "50115",
    ST: "IA",
    cityWithStateAbbr: "Guthrie Center, IA",
  },
  {
    zip: "50116",
    ST: "IA",
    cityWithStateAbbr: "Hamilton, IA",
  },
  {
    zip: "50117",
    ST: "IA",
    cityWithStateAbbr: "Hamlin, IA",
  },
  {
    zip: "50118",
    ST: "IA",
    cityWithStateAbbr: "Hartford, IA",
  },
  {
    zip: "50119",
    ST: "IA",
    cityWithStateAbbr: "Harvey, IA",
  },
  {
    zip: "50120",
    ST: "IA",
    cityWithStateAbbr: "Haverhill, IA",
  },
  {
    zip: "50122",
    ST: "IA",
    cityWithStateAbbr: "Hubbard, IA",
  },
  {
    zip: "50123",
    ST: "IA",
    cityWithStateAbbr: "Humeston, IA",
  },
  {
    zip: "50124",
    ST: "IA",
    cityWithStateAbbr: "Huxley, IA",
  },
  {
    zip: "50125",
    ST: "IA",
    cityWithStateAbbr: "Indianola, IA",
  },
  {
    zip: "50126",
    ST: "IA",
    cityWithStateAbbr: "Iowa Falls, IA",
  },
  {
    zip: "50127",
    ST: "IA",
    cityWithStateAbbr: "Ira, IA",
  },
  {
    zip: "50128",
    ST: "IA",
    cityWithStateAbbr: "Jamaica, IA",
  },
  {
    zip: "50129",
    ST: "IA",
    cityWithStateAbbr: "Jefferson, IA",
  },
  {
    zip: "50130",
    ST: "IA",
    cityWithStateAbbr: "Jewell, IA",
  },
  {
    zip: "50131",
    ST: "IA",
    cityWithStateAbbr: "Johnston, IA",
  },
  {
    zip: "50132",
    ST: "IA",
    cityWithStateAbbr: "Kamrar, IA",
  },
  {
    zip: "50133",
    ST: "IA",
    cityWithStateAbbr: "Kellerton, IA",
  },
  {
    zip: "50134",
    ST: "IA",
    cityWithStateAbbr: "Kelley, IA",
  },
  {
    zip: "50135",
    ST: "IA",
    cityWithStateAbbr: "Kellogg, IA",
  },
  {
    zip: "50136",
    ST: "IA",
    cityWithStateAbbr: "Keswick, IA",
  },
  {
    zip: "50137",
    ST: "IA",
    cityWithStateAbbr: "Killduff, IA",
  },
  {
    zip: "50138",
    ST: "IA",
    cityWithStateAbbr: "Knoxville, IA",
  },
  {
    zip: "50139",
    ST: "IA",
    cityWithStateAbbr: "Lacona, IA",
  },
  {
    zip: "50140",
    ST: "IA",
    cityWithStateAbbr: "Lamoni, IA",
  },
  {
    zip: "50141",
    ST: "IA",
    cityWithStateAbbr: "Laurel, IA",
  },
  {
    zip: "50142",
    ST: "IA",
    cityWithStateAbbr: "Le Grand, IA",
  },
  {
    zip: "50143",
    ST: "IA",
    cityWithStateAbbr: "Leighton, IA",
  },
  {
    zip: "50144",
    ST: "IA",
    cityWithStateAbbr: "Leon, IA",
  },
  {
    zip: "50145",
    ST: "IA",
    cityWithStateAbbr: "Liberty Center, IA",
  },
  {
    zip: "50146",
    ST: "IA",
    cityWithStateAbbr: "Linden, IA",
  },
  {
    zip: "50147",
    ST: "IA",
    cityWithStateAbbr: "Lineville, IA",
  },
  {
    zip: "50148",
    ST: "IA",
    cityWithStateAbbr: "Liscomb, IA",
  },
  {
    zip: "50149",
    ST: "IA",
    cityWithStateAbbr: "Lorimor, IA",
  },
  {
    zip: "50150",
    ST: "IA",
    cityWithStateAbbr: "Lovilia, IA",
  },
  {
    zip: "50151",
    ST: "IA",
    cityWithStateAbbr: "Lucas, IA",
  },
  {
    zip: "50152",
    ST: "IA",
    cityWithStateAbbr: "Luther, IA",
  },
  {
    zip: "50153",
    ST: "IA",
    cityWithStateAbbr: "Lynnville, IA",
  },
  {
    zip: "50154",
    ST: "IA",
    cityWithStateAbbr: "Mc Callsburg, IA",
  },
  {
    zip: "50155",
    ST: "IA",
    cityWithStateAbbr: "Macksburg, IA",
  },
  {
    zip: "50156",
    ST: "IA",
    cityWithStateAbbr: "Madrid, IA",
  },
  {
    zip: "50157",
    ST: "IA",
    cityWithStateAbbr: "Malcom, IA",
  },
  {
    zip: "50158",
    ST: "IA",
    cityWithStateAbbr: "Marshalltown, IA",
  },
  {
    zip: "50160",
    ST: "IA",
    cityWithStateAbbr: "Martensdale, IA",
  },
  {
    zip: "50161",
    ST: "IA",
    cityWithStateAbbr: "Maxwell, IA",
  },
  {
    zip: "50162",
    ST: "IA",
    cityWithStateAbbr: "Melbourne, IA",
  },
  {
    zip: "50163",
    ST: "IA",
    cityWithStateAbbr: "Melcher Dallas, IA",
  },
  {
    zip: "50164",
    ST: "IA",
    cityWithStateAbbr: "Menlo, IA",
  },
  {
    zip: "50165",
    ST: "IA",
    cityWithStateAbbr: "Millerton, IA",
  },
  {
    zip: "50166",
    ST: "IA",
    cityWithStateAbbr: "Milo, IA",
  },
  {
    zip: "50167",
    ST: "IA",
    cityWithStateAbbr: "Minburn, IA",
  },
  {
    zip: "50168",
    ST: "IA",
    cityWithStateAbbr: "Mingo, IA",
  },
  {
    zip: "50169",
    ST: "IA",
    cityWithStateAbbr: "Mitchellville, IA",
  },
  {
    zip: "50170",
    ST: "IA",
    cityWithStateAbbr: "Monroe, IA",
  },
  {
    zip: "50171",
    ST: "IA",
    cityWithStateAbbr: "Montezuma, IA",
  },
  {
    zip: "50173",
    ST: "IA",
    cityWithStateAbbr: "Montour, IA",
  },
  {
    zip: "50174",
    ST: "IA",
    cityWithStateAbbr: "Murray, IA",
  },
  {
    zip: "50201",
    ST: "IA",
    cityWithStateAbbr: "Nevada, IA",
  },
  {
    zip: "50206",
    ST: "IA",
    cityWithStateAbbr: "New Providence, IA",
  },
  {
    zip: "50207",
    ST: "IA",
    cityWithStateAbbr: "New Sharon, IA",
  },
  {
    zip: "50208",
    ST: "IA",
    cityWithStateAbbr: "Newton, IA",
  },
  {
    zip: "50210",
    ST: "IA",
    cityWithStateAbbr: "New Virginia, IA",
  },
  {
    zip: "50211",
    ST: "IA",
    cityWithStateAbbr: "Norwalk, IA",
  },
  {
    zip: "50212",
    ST: "IA",
    cityWithStateAbbr: "Ogden, IA",
  },
  {
    zip: "50213",
    ST: "IA",
    cityWithStateAbbr: "Osceola, IA",
  },
  {
    zip: "50214",
    ST: "IA",
    cityWithStateAbbr: "Otley, IA",
  },
  {
    zip: "50216",
    ST: "IA",
    cityWithStateAbbr: "Panora, IA",
  },
  {
    zip: "50217",
    ST: "IA",
    cityWithStateAbbr: "Paton, IA",
  },
  {
    zip: "50218",
    ST: "IA",
    cityWithStateAbbr: "Patterson, IA",
  },
  {
    zip: "50219",
    ST: "IA",
    cityWithStateAbbr: "Pella, IA",
  },
  {
    zip: "50220",
    ST: "IA",
    cityWithStateAbbr: "Perry, IA",
  },
  {
    zip: "50222",
    ST: "IA",
    cityWithStateAbbr: "Peru, IA",
  },
  {
    zip: "50223",
    ST: "IA",
    cityWithStateAbbr: "Pilot Mound, IA",
  },
  {
    zip: "50225",
    ST: "IA",
    cityWithStateAbbr: "Pleasantville, IA",
  },
  {
    zip: "50226",
    ST: "IA",
    cityWithStateAbbr: "Polk City, IA",
  },
  {
    zip: "50227",
    ST: "IA",
    cityWithStateAbbr: "Popejoy, IA",
  },
  {
    zip: "50228",
    ST: "IA",
    cityWithStateAbbr: "Prairie City, IA",
  },
  {
    zip: "50229",
    ST: "IA",
    cityWithStateAbbr: "Prole, IA",
  },
  {
    zip: "50230",
    ST: "IA",
    cityWithStateAbbr: "Radcliffe, IA",
  },
  {
    zip: "50231",
    ST: "IA",
    cityWithStateAbbr: "Randall, IA",
  },
  {
    zip: "50232",
    ST: "IA",
    cityWithStateAbbr: "Reasnor, IA",
  },
  {
    zip: "50233",
    ST: "IA",
    cityWithStateAbbr: "Redfield, IA",
  },
  {
    zip: "50234",
    ST: "IA",
    cityWithStateAbbr: "Rhodes, IA",
  },
  {
    zip: "50235",
    ST: "IA",
    cityWithStateAbbr: "Rippey, IA",
  },
  {
    zip: "50236",
    ST: "IA",
    cityWithStateAbbr: "Roland, IA",
  },
  {
    zip: "50237",
    ST: "IA",
    cityWithStateAbbr: "Runnells, IA",
  },
  {
    zip: "50238",
    ST: "IA",
    cityWithStateAbbr: "Russell, IA",
  },
  {
    zip: "50239",
    ST: "IA",
    cityWithStateAbbr: "Saint Anthony, IA",
  },
  {
    zip: "50240",
    ST: "IA",
    cityWithStateAbbr: "Saint Charles, IA",
  },
  {
    zip: "50241",
    ST: "IA",
    cityWithStateAbbr: "Saint Marys, IA",
  },
  {
    zip: "50242",
    ST: "IA",
    cityWithStateAbbr: "Searsboro, IA",
  },
  {
    zip: "50243",
    ST: "IA",
    cityWithStateAbbr: "Sheldahl, IA",
  },
  {
    zip: "50244",
    ST: "IA",
    cityWithStateAbbr: "Slater, IA",
  },
  {
    zip: "50246",
    ST: "IA",
    cityWithStateAbbr: "Stanhope, IA",
  },
  {
    zip: "50247",
    ST: "IA",
    cityWithStateAbbr: "State Center, IA",
  },
  {
    zip: "50248",
    ST: "IA",
    cityWithStateAbbr: "Story City, IA",
  },
  {
    zip: "50249",
    ST: "IA",
    cityWithStateAbbr: "Stratford, IA",
  },
  {
    zip: "50250",
    ST: "IA",
    cityWithStateAbbr: "Stuart, IA",
  },
  {
    zip: "50251",
    ST: "IA",
    cityWithStateAbbr: "Sully, IA",
  },
  {
    zip: "50252",
    ST: "IA",
    cityWithStateAbbr: "Swan, IA",
  },
  {
    zip: "50254",
    ST: "IA",
    cityWithStateAbbr: "Thayer, IA",
  },
  {
    zip: "50255",
    ST: "IA",
    cityWithStateAbbr: "Thornburg, IA",
  },
  {
    zip: "50256",
    ST: "IA",
    cityWithStateAbbr: "Tracy, IA",
  },
  {
    zip: "50257",
    ST: "IA",
    cityWithStateAbbr: "Truro, IA",
  },
  {
    zip: "50258",
    ST: "IA",
    cityWithStateAbbr: "Union, IA",
  },
  {
    zip: "50259",
    ST: "IA",
    cityWithStateAbbr: "Gifford, IA",
  },
  {
    zip: "50261",
    ST: "IA",
    cityWithStateAbbr: "Van Meter, IA",
  },
  {
    zip: "50262",
    ST: "IA",
    cityWithStateAbbr: "Van Wert, IA",
  },
  {
    zip: "50263",
    ST: "IA",
    cityWithStateAbbr: "Waukee, IA",
  },
  {
    zip: "50264",
    ST: "IA",
    cityWithStateAbbr: "Weldon, IA",
  },
  {
    zip: "50265",
    ST: "IA",
    cityWithStateAbbr: "West Des Moines, IA",
  },
  {
    zip: "50266",
    ST: "IA",
    cityWithStateAbbr: "West Des Moines, IA",
  },
  {
    zip: "50268",
    ST: "IA",
    cityWithStateAbbr: "What Cheer, IA",
  },
  {
    zip: "50269",
    ST: "IA",
    cityWithStateAbbr: "Whitten, IA",
  },
  {
    zip: "50271",
    ST: "IA",
    cityWithStateAbbr: "Williams, IA",
  },
  {
    zip: "50272",
    ST: "IA",
    cityWithStateAbbr: "Williamson, IA",
  },
  {
    zip: "50273",
    ST: "IA",
    cityWithStateAbbr: "Winterset, IA",
  },
  {
    zip: "50274",
    ST: "IA",
    cityWithStateAbbr: "Wiota, IA",
  },
  {
    zip: "50275",
    ST: "IA",
    cityWithStateAbbr: "Woodburn, IA",
  },
  {
    zip: "50276",
    ST: "IA",
    cityWithStateAbbr: "Woodward, IA",
  },
  {
    zip: "50277",
    ST: "IA",
    cityWithStateAbbr: "Yale, IA",
  },
  {
    zip: "50278",
    ST: "IA",
    cityWithStateAbbr: "Zearing, IA",
  },
  {
    zip: "50301",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50302",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50303",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50304",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50305",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50306",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50307",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50308",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50309",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50310",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50311",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50312",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50313",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50314",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50315",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50316",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50317",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50318",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50319",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50320",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50321",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50322",
    ST: "IA",
    cityWithStateAbbr: "Urbandale, IA",
  },
  {
    zip: "50323",
    ST: "IA",
    cityWithStateAbbr: "Urbandale, IA",
  },
  {
    zip: "50324",
    ST: "IA",
    cityWithStateAbbr: "Windsor Heights, IA",
  },
  {
    zip: "50325",
    ST: "IA",
    cityWithStateAbbr: "Clive, IA",
  },
  {
    zip: "50327",
    ST: "IA",
    cityWithStateAbbr: "Pleasant Hill, IA",
  },
  {
    zip: "50328",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50329",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50330",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50331",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50332",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50333",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50334",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50335",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50336",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50339",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50340",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50359",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50360",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50361",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50362",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50363",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50364",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50367",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50368",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50369",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50380",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50381",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50391",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50392",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50393",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50394",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50395",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50396",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50398",
    ST: "IA",
    cityWithStateAbbr: "Urbandale, IA",
  },
  {
    zip: "50401",
    ST: "IA",
    cityWithStateAbbr: "Mason City, IA",
  },
  {
    zip: "50402",
    ST: "IA",
    cityWithStateAbbr: "Mason City, IA",
  },
  {
    zip: "50420",
    ST: "IA",
    cityWithStateAbbr: "Alexander, IA",
  },
  {
    zip: "50421",
    ST: "IA",
    cityWithStateAbbr: "Belmond, IA",
  },
  {
    zip: "50423",
    ST: "IA",
    cityWithStateAbbr: "Britt, IA",
  },
  {
    zip: "50424",
    ST: "IA",
    cityWithStateAbbr: "Buffalo Center, IA",
  },
  {
    zip: "50426",
    ST: "IA",
    cityWithStateAbbr: "Carpenter, IA",
  },
  {
    zip: "50427",
    ST: "IA",
    cityWithStateAbbr: "Chapin, IA",
  },
  {
    zip: "50428",
    ST: "IA",
    cityWithStateAbbr: "Clear Lake, IA",
  },
  {
    zip: "50430",
    ST: "IA",
    cityWithStateAbbr: "Corwith, IA",
  },
  {
    zip: "50431",
    ST: "IA",
    cityWithStateAbbr: "Coulter, IA",
  },
  {
    zip: "50432",
    ST: "IA",
    cityWithStateAbbr: "Crystal Lake, IA",
  },
  {
    zip: "50433",
    ST: "IA",
    cityWithStateAbbr: "Dougherty, IA",
  },
  {
    zip: "50434",
    ST: "IA",
    cityWithStateAbbr: "Fertile, IA",
  },
  {
    zip: "50435",
    ST: "IA",
    cityWithStateAbbr: "Floyd, IA",
  },
  {
    zip: "50436",
    ST: "IA",
    cityWithStateAbbr: "Forest City, IA",
  },
  {
    zip: "50438",
    ST: "IA",
    cityWithStateAbbr: "Garner, IA",
  },
  {
    zip: "50439",
    ST: "IA",
    cityWithStateAbbr: "Goodell, IA",
  },
  {
    zip: "50440",
    ST: "IA",
    cityWithStateAbbr: "Grafton, IA",
  },
  {
    zip: "50441",
    ST: "IA",
    cityWithStateAbbr: "Hampton, IA",
  },
  {
    zip: "50444",
    ST: "IA",
    cityWithStateAbbr: "Hanlontown, IA",
  },
  {
    zip: "50446",
    ST: "IA",
    cityWithStateAbbr: "Joice, IA",
  },
  {
    zip: "50447",
    ST: "IA",
    cityWithStateAbbr: "Kanawha, IA",
  },
  {
    zip: "50448",
    ST: "IA",
    cityWithStateAbbr: "Kensett, IA",
  },
  {
    zip: "50449",
    ST: "IA",
    cityWithStateAbbr: "Klemme, IA",
  },
  {
    zip: "50450",
    ST: "IA",
    cityWithStateAbbr: "Lake Mills, IA",
  },
  {
    zip: "50451",
    ST: "IA",
    cityWithStateAbbr: "Lakota, IA",
  },
  {
    zip: "50452",
    ST: "IA",
    cityWithStateAbbr: "Latimer, IA",
  },
  {
    zip: "50453",
    ST: "IA",
    cityWithStateAbbr: "Leland, IA",
  },
  {
    zip: "50454",
    ST: "IA",
    cityWithStateAbbr: "Little Cedar, IA",
  },
  {
    zip: "50455",
    ST: "IA",
    cityWithStateAbbr: "Mc Intire, IA",
  },
  {
    zip: "50456",
    ST: "IA",
    cityWithStateAbbr: "Manly, IA",
  },
  {
    zip: "50457",
    ST: "IA",
    cityWithStateAbbr: "Meservey, IA",
  },
  {
    zip: "50458",
    ST: "IA",
    cityWithStateAbbr: "Nora Springs, IA",
  },
  {
    zip: "50459",
    ST: "IA",
    cityWithStateAbbr: "Northwood, IA",
  },
  {
    zip: "50460",
    ST: "IA",
    cityWithStateAbbr: "Orchard, IA",
  },
  {
    zip: "50461",
    ST: "IA",
    cityWithStateAbbr: "Osage, IA",
  },
  {
    zip: "50464",
    ST: "IA",
    cityWithStateAbbr: "Plymouth, IA",
  },
  {
    zip: "50465",
    ST: "IA",
    cityWithStateAbbr: "Rake, IA",
  },
  {
    zip: "50466",
    ST: "IA",
    cityWithStateAbbr: "Riceville, IA",
  },
  {
    zip: "50467",
    ST: "IA",
    cityWithStateAbbr: "Rock Falls, IA",
  },
  {
    zip: "50468",
    ST: "IA",
    cityWithStateAbbr: "Rockford, IA",
  },
  {
    zip: "50469",
    ST: "IA",
    cityWithStateAbbr: "Rockwell, IA",
  },
  {
    zip: "50470",
    ST: "IA",
    cityWithStateAbbr: "Rowan, IA",
  },
  {
    zip: "50471",
    ST: "IA",
    cityWithStateAbbr: "Rudd, IA",
  },
  {
    zip: "50472",
    ST: "IA",
    cityWithStateAbbr: "Saint Ansgar, IA",
  },
  {
    zip: "50473",
    ST: "IA",
    cityWithStateAbbr: "Scarville, IA",
  },
  {
    zip: "50475",
    ST: "IA",
    cityWithStateAbbr: "Sheffield, IA",
  },
  {
    zip: "50476",
    ST: "IA",
    cityWithStateAbbr: "Stacyville, IA",
  },
  {
    zip: "50477",
    ST: "IA",
    cityWithStateAbbr: "Swaledale, IA",
  },
  {
    zip: "50478",
    ST: "IA",
    cityWithStateAbbr: "Thompson, IA",
  },
  {
    zip: "50479",
    ST: "IA",
    cityWithStateAbbr: "Thornton, IA",
  },
  {
    zip: "50480",
    ST: "IA",
    cityWithStateAbbr: "Titonka, IA",
  },
  {
    zip: "50481",
    ST: "IA",
    cityWithStateAbbr: "Toeterville, IA",
  },
  {
    zip: "50482",
    ST: "IA",
    cityWithStateAbbr: "Ventura, IA",
  },
  {
    zip: "50483",
    ST: "IA",
    cityWithStateAbbr: "Wesley, IA",
  },
  {
    zip: "50484",
    ST: "IA",
    cityWithStateAbbr: "Woden, IA",
  },
  {
    zip: "50501",
    ST: "IA",
    cityWithStateAbbr: "Fort Dodge, IA",
  },
  {
    zip: "50510",
    ST: "IA",
    cityWithStateAbbr: "Albert City, IA",
  },
  {
    zip: "50511",
    ST: "IA",
    cityWithStateAbbr: "Algona, IA",
  },
  {
    zip: "50514",
    ST: "IA",
    cityWithStateAbbr: "Armstrong, IA",
  },
  {
    zip: "50515",
    ST: "IA",
    cityWithStateAbbr: "Ayrshire, IA",
  },
  {
    zip: "50516",
    ST: "IA",
    cityWithStateAbbr: "Badger, IA",
  },
  {
    zip: "50517",
    ST: "IA",
    cityWithStateAbbr: "Bancroft, IA",
  },
  {
    zip: "50518",
    ST: "IA",
    cityWithStateAbbr: "Barnum, IA",
  },
  {
    zip: "50519",
    ST: "IA",
    cityWithStateAbbr: "Bode, IA",
  },
  {
    zip: "50520",
    ST: "IA",
    cityWithStateAbbr: "Bradgate, IA",
  },
  {
    zip: "50521",
    ST: "IA",
    cityWithStateAbbr: "Burnside, IA",
  },
  {
    zip: "50522",
    ST: "IA",
    cityWithStateAbbr: "Burt, IA",
  },
  {
    zip: "50523",
    ST: "IA",
    cityWithStateAbbr: "Callender, IA",
  },
  {
    zip: "50524",
    ST: "IA",
    cityWithStateAbbr: "Clare, IA",
  },
  {
    zip: "50525",
    ST: "IA",
    cityWithStateAbbr: "Clarion, IA",
  },
  {
    zip: "50526",
    ST: "IA",
    cityWithStateAbbr: "Clarion, IA",
  },
  {
    zip: "50527",
    ST: "IA",
    cityWithStateAbbr: "Curlew, IA",
  },
  {
    zip: "50528",
    ST: "IA",
    cityWithStateAbbr: "Cylinder, IA",
  },
  {
    zip: "50529",
    ST: "IA",
    cityWithStateAbbr: "Dakota City, IA",
  },
  {
    zip: "50530",
    ST: "IA",
    cityWithStateAbbr: "Dayton, IA",
  },
  {
    zip: "50531",
    ST: "IA",
    cityWithStateAbbr: "Dolliver, IA",
  },
  {
    zip: "50532",
    ST: "IA",
    cityWithStateAbbr: "Duncombe, IA",
  },
  {
    zip: "50533",
    ST: "IA",
    cityWithStateAbbr: "Eagle Grove, IA",
  },
  {
    zip: "50535",
    ST: "IA",
    cityWithStateAbbr: "Early, IA",
  },
  {
    zip: "50536",
    ST: "IA",
    cityWithStateAbbr: "Emmetsburg, IA",
  },
  {
    zip: "50538",
    ST: "IA",
    cityWithStateAbbr: "Farnhamville, IA",
  },
  {
    zip: "50539",
    ST: "IA",
    cityWithStateAbbr: "Fenton, IA",
  },
  {
    zip: "50540",
    ST: "IA",
    cityWithStateAbbr: "Fonda, IA",
  },
  {
    zip: "50541",
    ST: "IA",
    cityWithStateAbbr: "Gilmore City, IA",
  },
  {
    zip: "50542",
    ST: "IA",
    cityWithStateAbbr: "Goldfield, IA",
  },
  {
    zip: "50543",
    ST: "IA",
    cityWithStateAbbr: "Gowrie, IA",
  },
  {
    zip: "50544",
    ST: "IA",
    cityWithStateAbbr: "Harcourt, IA",
  },
  {
    zip: "50545",
    ST: "IA",
    cityWithStateAbbr: "Hardy, IA",
  },
  {
    zip: "50546",
    ST: "IA",
    cityWithStateAbbr: "Havelock, IA",
  },
  {
    zip: "50548",
    ST: "IA",
    cityWithStateAbbr: "Humboldt, IA",
  },
  {
    zip: "50551",
    ST: "IA",
    cityWithStateAbbr: "Jolley, IA",
  },
  {
    zip: "50552",
    ST: "IA",
    cityWithStateAbbr: "Knierim, IA",
  },
  {
    zip: "50554",
    ST: "IA",
    cityWithStateAbbr: "Laurens, IA",
  },
  {
    zip: "50556",
    ST: "IA",
    cityWithStateAbbr: "Ledyard, IA",
  },
  {
    zip: "50557",
    ST: "IA",
    cityWithStateAbbr: "Lehigh, IA",
  },
  {
    zip: "50558",
    ST: "IA",
    cityWithStateAbbr: "Livermore, IA",
  },
  {
    zip: "50559",
    ST: "IA",
    cityWithStateAbbr: "Lone Rock, IA",
  },
  {
    zip: "50560",
    ST: "IA",
    cityWithStateAbbr: "Lu Verne, IA",
  },
  {
    zip: "50561",
    ST: "IA",
    cityWithStateAbbr: "Lytton, IA",
  },
  {
    zip: "50562",
    ST: "IA",
    cityWithStateAbbr: "Mallard, IA",
  },
  {
    zip: "50563",
    ST: "IA",
    cityWithStateAbbr: "Manson, IA",
  },
  {
    zip: "50565",
    ST: "IA",
    cityWithStateAbbr: "Marathon, IA",
  },
  {
    zip: "50566",
    ST: "IA",
    cityWithStateAbbr: "Moorland, IA",
  },
  {
    zip: "50567",
    ST: "IA",
    cityWithStateAbbr: "Nemaha, IA",
  },
  {
    zip: "50568",
    ST: "IA",
    cityWithStateAbbr: "Newell, IA",
  },
  {
    zip: "50569",
    ST: "IA",
    cityWithStateAbbr: "Otho, IA",
  },
  {
    zip: "50570",
    ST: "IA",
    cityWithStateAbbr: "Ottosen, IA",
  },
  {
    zip: "50571",
    ST: "IA",
    cityWithStateAbbr: "Palmer, IA",
  },
  {
    zip: "50573",
    ST: "IA",
    cityWithStateAbbr: "Plover, IA",
  },
  {
    zip: "50574",
    ST: "IA",
    cityWithStateAbbr: "Pocahontas, IA",
  },
  {
    zip: "50575",
    ST: "IA",
    cityWithStateAbbr: "Pomeroy, IA",
  },
  {
    zip: "50576",
    ST: "IA",
    cityWithStateAbbr: "Rembrandt, IA",
  },
  {
    zip: "50577",
    ST: "IA",
    cityWithStateAbbr: "Renwick, IA",
  },
  {
    zip: "50578",
    ST: "IA",
    cityWithStateAbbr: "Ringsted, IA",
  },
  {
    zip: "50579",
    ST: "IA",
    cityWithStateAbbr: "Rockwell City, IA",
  },
  {
    zip: "50581",
    ST: "IA",
    cityWithStateAbbr: "Rolfe, IA",
  },
  {
    zip: "50582",
    ST: "IA",
    cityWithStateAbbr: "Rutland, IA",
  },
  {
    zip: "50583",
    ST: "IA",
    cityWithStateAbbr: "Sac City, IA",
  },
  {
    zip: "50585",
    ST: "IA",
    cityWithStateAbbr: "Sioux Rapids, IA",
  },
  {
    zip: "50586",
    ST: "IA",
    cityWithStateAbbr: "Somers, IA",
  },
  {
    zip: "50588",
    ST: "IA",
    cityWithStateAbbr: "Storm Lake, IA",
  },
  {
    zip: "50590",
    ST: "IA",
    cityWithStateAbbr: "Swea City, IA",
  },
  {
    zip: "50591",
    ST: "IA",
    cityWithStateAbbr: "Thor, IA",
  },
  {
    zip: "50592",
    ST: "IA",
    cityWithStateAbbr: "Truesdale, IA",
  },
  {
    zip: "50593",
    ST: "IA",
    cityWithStateAbbr: "Varina, IA",
  },
  {
    zip: "50594",
    ST: "IA",
    cityWithStateAbbr: "Vincent, IA",
  },
  {
    zip: "50595",
    ST: "IA",
    cityWithStateAbbr: "Webster City, IA",
  },
  {
    zip: "50597",
    ST: "IA",
    cityWithStateAbbr: "West Bend, IA",
  },
  {
    zip: "50598",
    ST: "IA",
    cityWithStateAbbr: "Whittemore, IA",
  },
  {
    zip: "50599",
    ST: "IA",
    cityWithStateAbbr: "Woolstock, IA",
  },
  {
    zip: "50601",
    ST: "IA",
    cityWithStateAbbr: "Ackley, IA",
  },
  {
    zip: "50602",
    ST: "IA",
    cityWithStateAbbr: "Allison, IA",
  },
  {
    zip: "50603",
    ST: "IA",
    cityWithStateAbbr: "Alta Vista, IA",
  },
  {
    zip: "50604",
    ST: "IA",
    cityWithStateAbbr: "Aplington, IA",
  },
  {
    zip: "50605",
    ST: "IA",
    cityWithStateAbbr: "Aredale, IA",
  },
  {
    zip: "50606",
    ST: "IA",
    cityWithStateAbbr: "Arlington, IA",
  },
  {
    zip: "50607",
    ST: "IA",
    cityWithStateAbbr: "Aurora, IA",
  },
  {
    zip: "50608",
    ST: "IA",
    cityWithStateAbbr: "Austinville, IA",
  },
  {
    zip: "50609",
    ST: "IA",
    cityWithStateAbbr: "Beaman, IA",
  },
  {
    zip: "50611",
    ST: "IA",
    cityWithStateAbbr: "Bristow, IA",
  },
  {
    zip: "50612",
    ST: "IA",
    cityWithStateAbbr: "Buckingham, IA",
  },
  {
    zip: "50613",
    ST: "IA",
    cityWithStateAbbr: "Cedar Falls, IA",
  },
  {
    zip: "50614",
    ST: "IA",
    cityWithStateAbbr: "Cedar Falls, IA",
  },
  {
    zip: "50616",
    ST: "IA",
    cityWithStateAbbr: "Charles City, IA",
  },
  {
    zip: "50619",
    ST: "IA",
    cityWithStateAbbr: "Clarksville, IA",
  },
  {
    zip: "50620",
    ST: "IA",
    cityWithStateAbbr: "Colwell, IA",
  },
  {
    zip: "50621",
    ST: "IA",
    cityWithStateAbbr: "Conrad, IA",
  },
  {
    zip: "50622",
    ST: "IA",
    cityWithStateAbbr: "Denver, IA",
  },
  {
    zip: "50623",
    ST: "IA",
    cityWithStateAbbr: "Dewar, IA",
  },
  {
    zip: "50624",
    ST: "IA",
    cityWithStateAbbr: "Dike, IA",
  },
  {
    zip: "50625",
    ST: "IA",
    cityWithStateAbbr: "Dumont, IA",
  },
  {
    zip: "50626",
    ST: "IA",
    cityWithStateAbbr: "Dunkerton, IA",
  },
  {
    zip: "50627",
    ST: "IA",
    cityWithStateAbbr: "Eldora, IA",
  },
  {
    zip: "50628",
    ST: "IA",
    cityWithStateAbbr: "Elma, IA",
  },
  {
    zip: "50629",
    ST: "IA",
    cityWithStateAbbr: "Fairbank, IA",
  },
  {
    zip: "50630",
    ST: "IA",
    cityWithStateAbbr: "Fredericksburg, IA",
  },
  {
    zip: "50631",
    ST: "IA",
    cityWithStateAbbr: "Frederika, IA",
  },
  {
    zip: "50632",
    ST: "IA",
    cityWithStateAbbr: "Garwin, IA",
  },
  {
    zip: "50633",
    ST: "IA",
    cityWithStateAbbr: "Geneva, IA",
  },
  {
    zip: "50634",
    ST: "IA",
    cityWithStateAbbr: "Gilbertville, IA",
  },
  {
    zip: "50635",
    ST: "IA",
    cityWithStateAbbr: "Gladbrook, IA",
  },
  {
    zip: "50636",
    ST: "IA",
    cityWithStateAbbr: "Greene, IA",
  },
  {
    zip: "50638",
    ST: "IA",
    cityWithStateAbbr: "Grundy Center, IA",
  },
  {
    zip: "50641",
    ST: "IA",
    cityWithStateAbbr: "Hazleton, IA",
  },
  {
    zip: "50642",
    ST: "IA",
    cityWithStateAbbr: "Holland, IA",
  },
  {
    zip: "50643",
    ST: "IA",
    cityWithStateAbbr: "Hudson, IA",
  },
  {
    zip: "50644",
    ST: "IA",
    cityWithStateAbbr: "Independence, IA",
  },
  {
    zip: "50645",
    ST: "IA",
    cityWithStateAbbr: "Ionia, IA",
  },
  {
    zip: "50647",
    ST: "IA",
    cityWithStateAbbr: "Janesville, IA",
  },
  {
    zip: "50648",
    ST: "IA",
    cityWithStateAbbr: "Jesup, IA",
  },
  {
    zip: "50649",
    ST: "IA",
    cityWithStateAbbr: "Kesley, IA",
  },
  {
    zip: "50650",
    ST: "IA",
    cityWithStateAbbr: "Lamont, IA",
  },
  {
    zip: "50651",
    ST: "IA",
    cityWithStateAbbr: "La Porte City, IA",
  },
  {
    zip: "50652",
    ST: "IA",
    cityWithStateAbbr: "Lincoln, IA",
  },
  {
    zip: "50653",
    ST: "IA",
    cityWithStateAbbr: "Marble Rock, IA",
  },
  {
    zip: "50654",
    ST: "IA",
    cityWithStateAbbr: "Masonville, IA",
  },
  {
    zip: "50655",
    ST: "IA",
    cityWithStateAbbr: "Maynard, IA",
  },
  {
    zip: "50657",
    ST: "IA",
    cityWithStateAbbr: "Morrison, IA",
  },
  {
    zip: "50658",
    ST: "IA",
    cityWithStateAbbr: "Nashua, IA",
  },
  {
    zip: "50659",
    ST: "IA",
    cityWithStateAbbr: "New Hampton, IA",
  },
  {
    zip: "50660",
    ST: "IA",
    cityWithStateAbbr: "New Hartford, IA",
  },
  {
    zip: "50661",
    ST: "IA",
    cityWithStateAbbr: "North Washington, IA",
  },
  {
    zip: "50662",
    ST: "IA",
    cityWithStateAbbr: "Oelwein, IA",
  },
  {
    zip: "50664",
    ST: "IA",
    cityWithStateAbbr: "Oran, IA",
  },
  {
    zip: "50665",
    ST: "IA",
    cityWithStateAbbr: "Parkersburg, IA",
  },
  {
    zip: "50666",
    ST: "IA",
    cityWithStateAbbr: "Plainfield, IA",
  },
  {
    zip: "50667",
    ST: "IA",
    cityWithStateAbbr: "Raymond, IA",
  },
  {
    zip: "50668",
    ST: "IA",
    cityWithStateAbbr: "Readlyn, IA",
  },
  {
    zip: "50669",
    ST: "IA",
    cityWithStateAbbr: "Reinbeck, IA",
  },
  {
    zip: "50670",
    ST: "IA",
    cityWithStateAbbr: "Shell Rock, IA",
  },
  {
    zip: "50671",
    ST: "IA",
    cityWithStateAbbr: "Stanley, IA",
  },
  {
    zip: "50672",
    ST: "IA",
    cityWithStateAbbr: "Steamboat Rock, IA",
  },
  {
    zip: "50673",
    ST: "IA",
    cityWithStateAbbr: "Stout, IA",
  },
  {
    zip: "50674",
    ST: "IA",
    cityWithStateAbbr: "Sumner, IA",
  },
  {
    zip: "50675",
    ST: "IA",
    cityWithStateAbbr: "Traer, IA",
  },
  {
    zip: "50676",
    ST: "IA",
    cityWithStateAbbr: "Tripoli, IA",
  },
  {
    zip: "50677",
    ST: "IA",
    cityWithStateAbbr: "Waverly, IA",
  },
  {
    zip: "50680",
    ST: "IA",
    cityWithStateAbbr: "Wellsburg, IA",
  },
  {
    zip: "50681",
    ST: "IA",
    cityWithStateAbbr: "Westgate, IA",
  },
  {
    zip: "50682",
    ST: "IA",
    cityWithStateAbbr: "Winthrop, IA",
  },
  {
    zip: "50701",
    ST: "IA",
    cityWithStateAbbr: "Waterloo, IA",
  },
  {
    zip: "50702",
    ST: "IA",
    cityWithStateAbbr: "Waterloo, IA",
  },
  {
    zip: "50703",
    ST: "IA",
    cityWithStateAbbr: "Waterloo, IA",
  },
  {
    zip: "50704",
    ST: "IA",
    cityWithStateAbbr: "Waterloo, IA",
  },
  {
    zip: "50707",
    ST: "IA",
    cityWithStateAbbr: "Evansdale, IA",
  },
  {
    zip: "50801",
    ST: "IA",
    cityWithStateAbbr: "Creston, IA",
  },
  {
    zip: "50830",
    ST: "IA",
    cityWithStateAbbr: "Afton, IA",
  },
  {
    zip: "50831",
    ST: "IA",
    cityWithStateAbbr: "Arispe, IA",
  },
  {
    zip: "50833",
    ST: "IA",
    cityWithStateAbbr: "Bedford, IA",
  },
  {
    zip: "50835",
    ST: "IA",
    cityWithStateAbbr: "Benton, IA",
  },
  {
    zip: "50836",
    ST: "IA",
    cityWithStateAbbr: "Blockton, IA",
  },
  {
    zip: "50837",
    ST: "IA",
    cityWithStateAbbr: "Bridgewater, IA",
  },
  {
    zip: "50839",
    ST: "IA",
    cityWithStateAbbr: "Carbon, IA",
  },
  {
    zip: "50840",
    ST: "IA",
    cityWithStateAbbr: "Clearfield, IA",
  },
  {
    zip: "50841",
    ST: "IA",
    cityWithStateAbbr: "Corning, IA",
  },
  {
    zip: "50842",
    ST: "IA",
    cityWithStateAbbr: "Cromwell, IA",
  },
  {
    zip: "50843",
    ST: "IA",
    cityWithStateAbbr: "Cumberland, IA",
  },
  {
    zip: "50845",
    ST: "IA",
    cityWithStateAbbr: "Diagonal, IA",
  },
  {
    zip: "50846",
    ST: "IA",
    cityWithStateAbbr: "Fontanelle, IA",
  },
  {
    zip: "50847",
    ST: "IA",
    cityWithStateAbbr: "Grant, IA",
  },
  {
    zip: "50848",
    ST: "IA",
    cityWithStateAbbr: "Gravity, IA",
  },
  {
    zip: "50849",
    ST: "IA",
    cityWithStateAbbr: "Greenfield, IA",
  },
  {
    zip: "50851",
    ST: "IA",
    cityWithStateAbbr: "Lenox, IA",
  },
  {
    zip: "50853",
    ST: "IA",
    cityWithStateAbbr: "Massena, IA",
  },
  {
    zip: "50854",
    ST: "IA",
    cityWithStateAbbr: "Mount Ayr, IA",
  },
  {
    zip: "50857",
    ST: "IA",
    cityWithStateAbbr: "Nodaway, IA",
  },
  {
    zip: "50858",
    ST: "IA",
    cityWithStateAbbr: "Orient, IA",
  },
  {
    zip: "50859",
    ST: "IA",
    cityWithStateAbbr: "Prescott, IA",
  },
  {
    zip: "50860",
    ST: "IA",
    cityWithStateAbbr: "Redding, IA",
  },
  {
    zip: "50861",
    ST: "IA",
    cityWithStateAbbr: "Shannon City, IA",
  },
  {
    zip: "50862",
    ST: "IA",
    cityWithStateAbbr: "Sharpsburg, IA",
  },
  {
    zip: "50863",
    ST: "IA",
    cityWithStateAbbr: "Tingley, IA",
  },
  {
    zip: "50864",
    ST: "IA",
    cityWithStateAbbr: "Villisca, IA",
  },
  {
    zip: "50936",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50940",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50947",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50950",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50980",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "50981",
    ST: "IA",
    cityWithStateAbbr: "Des Moines, IA",
  },
  {
    zip: "51001",
    ST: "IA",
    cityWithStateAbbr: "Akron, IA",
  },
  {
    zip: "51002",
    ST: "IA",
    cityWithStateAbbr: "Alta, IA",
  },
  {
    zip: "51003",
    ST: "IA",
    cityWithStateAbbr: "Alton, IA",
  },
  {
    zip: "51004",
    ST: "IA",
    cityWithStateAbbr: "Anthon, IA",
  },
  {
    zip: "51005",
    ST: "IA",
    cityWithStateAbbr: "Aurelia, IA",
  },
  {
    zip: "51006",
    ST: "IA",
    cityWithStateAbbr: "Battle Creek, IA",
  },
  {
    zip: "51007",
    ST: "IA",
    cityWithStateAbbr: "Bronson, IA",
  },
  {
    zip: "51008",
    ST: "IA",
    cityWithStateAbbr: "Brunsville, IA",
  },
  {
    zip: "51009",
    ST: "IA",
    cityWithStateAbbr: "Calumet, IA",
  },
  {
    zip: "51010",
    ST: "IA",
    cityWithStateAbbr: "Castana, IA",
  },
  {
    zip: "51011",
    ST: "IA",
    cityWithStateAbbr: "Chatsworth, IA",
  },
  {
    zip: "51012",
    ST: "IA",
    cityWithStateAbbr: "Cherokee, IA",
  },
  {
    zip: "51014",
    ST: "IA",
    cityWithStateAbbr: "Cleghorn, IA",
  },
  {
    zip: "51015",
    ST: "IA",
    cityWithStateAbbr: "Climbing Hill, IA",
  },
  {
    zip: "51016",
    ST: "IA",
    cityWithStateAbbr: "Correctionville, IA",
  },
  {
    zip: "51018",
    ST: "IA",
    cityWithStateAbbr: "Cushing, IA",
  },
  {
    zip: "51019",
    ST: "IA",
    cityWithStateAbbr: "Danbury, IA",
  },
  {
    zip: "51020",
    ST: "IA",
    cityWithStateAbbr: "Galva, IA",
  },
  {
    zip: "51022",
    ST: "IA",
    cityWithStateAbbr: "Granville, IA",
  },
  {
    zip: "51023",
    ST: "IA",
    cityWithStateAbbr: "Hawarden, IA",
  },
  {
    zip: "51024",
    ST: "IA",
    cityWithStateAbbr: "Hinton, IA",
  },
  {
    zip: "51025",
    ST: "IA",
    cityWithStateAbbr: "Holstein, IA",
  },
  {
    zip: "51026",
    ST: "IA",
    cityWithStateAbbr: "Hornick, IA",
  },
  {
    zip: "51027",
    ST: "IA",
    cityWithStateAbbr: "Ireton, IA",
  },
  {
    zip: "51028",
    ST: "IA",
    cityWithStateAbbr: "Kingsley, IA",
  },
  {
    zip: "51029",
    ST: "IA",
    cityWithStateAbbr: "Larrabee, IA",
  },
  {
    zip: "51030",
    ST: "IA",
    cityWithStateAbbr: "Lawton, IA",
  },
  {
    zip: "51031",
    ST: "IA",
    cityWithStateAbbr: "Le Mars, IA",
  },
  {
    zip: "51033",
    ST: "IA",
    cityWithStateAbbr: "Linn Grove, IA",
  },
  {
    zip: "51034",
    ST: "IA",
    cityWithStateAbbr: "Mapleton, IA",
  },
  {
    zip: "51035",
    ST: "IA",
    cityWithStateAbbr: "Marcus, IA",
  },
  {
    zip: "51036",
    ST: "IA",
    cityWithStateAbbr: "Maurice, IA",
  },
  {
    zip: "51037",
    ST: "IA",
    cityWithStateAbbr: "Meriden, IA",
  },
  {
    zip: "51038",
    ST: "IA",
    cityWithStateAbbr: "Merrill, IA",
  },
  {
    zip: "51039",
    ST: "IA",
    cityWithStateAbbr: "Moville, IA",
  },
  {
    zip: "51040",
    ST: "IA",
    cityWithStateAbbr: "Onawa, IA",
  },
  {
    zip: "51041",
    ST: "IA",
    cityWithStateAbbr: "Orange City, IA",
  },
  {
    zip: "51044",
    ST: "IA",
    cityWithStateAbbr: "Oto, IA",
  },
  {
    zip: "51045",
    ST: "IA",
    cityWithStateAbbr: "Oyens, IA",
  },
  {
    zip: "51046",
    ST: "IA",
    cityWithStateAbbr: "Paullina, IA",
  },
  {
    zip: "51047",
    ST: "IA",
    cityWithStateAbbr: "Peterson, IA",
  },
  {
    zip: "51048",
    ST: "IA",
    cityWithStateAbbr: "Pierson, IA",
  },
  {
    zip: "51049",
    ST: "IA",
    cityWithStateAbbr: "Quimby, IA",
  },
  {
    zip: "51050",
    ST: "IA",
    cityWithStateAbbr: "Remsen, IA",
  },
  {
    zip: "51051",
    ST: "IA",
    cityWithStateAbbr: "Rodney, IA",
  },
  {
    zip: "51052",
    ST: "IA",
    cityWithStateAbbr: "Salix, IA",
  },
  {
    zip: "51053",
    ST: "IA",
    cityWithStateAbbr: "Schaller, IA",
  },
  {
    zip: "51054",
    ST: "IA",
    cityWithStateAbbr: "Sergeant Bluff, IA",
  },
  {
    zip: "51055",
    ST: "IA",
    cityWithStateAbbr: "Sloan, IA",
  },
  {
    zip: "51056",
    ST: "IA",
    cityWithStateAbbr: "Smithland, IA",
  },
  {
    zip: "51058",
    ST: "IA",
    cityWithStateAbbr: "Sutherland, IA",
  },
  {
    zip: "51060",
    ST: "IA",
    cityWithStateAbbr: "Ute, IA",
  },
  {
    zip: "51061",
    ST: "IA",
    cityWithStateAbbr: "Washta, IA",
  },
  {
    zip: "51062",
    ST: "IA",
    cityWithStateAbbr: "Westfield, IA",
  },
  {
    zip: "51063",
    ST: "IA",
    cityWithStateAbbr: "Whiting, IA",
  },
  {
    zip: "51101",
    ST: "IA",
    cityWithStateAbbr: "Sioux City, IA",
  },
  {
    zip: "51102",
    ST: "IA",
    cityWithStateAbbr: "Sioux City, IA",
  },
  {
    zip: "51103",
    ST: "IA",
    cityWithStateAbbr: "Sioux City, IA",
  },
  {
    zip: "51104",
    ST: "IA",
    cityWithStateAbbr: "Sioux City, IA",
  },
  {
    zip: "51105",
    ST: "IA",
    cityWithStateAbbr: "Sioux City, IA",
  },
  {
    zip: "51106",
    ST: "IA",
    cityWithStateAbbr: "Sioux City, IA",
  },
  {
    zip: "51108",
    ST: "IA",
    cityWithStateAbbr: "Sioux City, IA",
  },
  {
    zip: "51109",
    ST: "IA",
    cityWithStateAbbr: "Sioux City, IA",
  },
  {
    zip: "51111",
    ST: "IA",
    cityWithStateAbbr: "Sioux City, IA",
  },
  {
    zip: "51201",
    ST: "IA",
    cityWithStateAbbr: "Sheldon, IA",
  },
  {
    zip: "51230",
    ST: "IA",
    cityWithStateAbbr: "Alvord, IA",
  },
  {
    zip: "51231",
    ST: "IA",
    cityWithStateAbbr: "Archer, IA",
  },
  {
    zip: "51232",
    ST: "IA",
    cityWithStateAbbr: "Ashton, IA",
  },
  {
    zip: "51234",
    ST: "IA",
    cityWithStateAbbr: "Boyden, IA",
  },
  {
    zip: "51235",
    ST: "IA",
    cityWithStateAbbr: "Doon, IA",
  },
  {
    zip: "51237",
    ST: "IA",
    cityWithStateAbbr: "George, IA",
  },
  {
    zip: "51238",
    ST: "IA",
    cityWithStateAbbr: "Hospers, IA",
  },
  {
    zip: "51239",
    ST: "IA",
    cityWithStateAbbr: "Hull, IA",
  },
  {
    zip: "51240",
    ST: "IA",
    cityWithStateAbbr: "Inwood, IA",
  },
  {
    zip: "51241",
    ST: "IA",
    cityWithStateAbbr: "Larchwood, IA",
  },
  {
    zip: "51242",
    ST: "IA",
    cityWithStateAbbr: "Lester, IA",
  },
  {
    zip: "51243",
    ST: "IA",
    cityWithStateAbbr: "Little Rock, IA",
  },
  {
    zip: "51244",
    ST: "IA",
    cityWithStateAbbr: "Matlock, IA",
  },
  {
    zip: "51245",
    ST: "IA",
    cityWithStateAbbr: "Primghar, IA",
  },
  {
    zip: "51246",
    ST: "IA",
    cityWithStateAbbr: "Rock Rapids, IA",
  },
  {
    zip: "51247",
    ST: "IA",
    cityWithStateAbbr: "Rock Valley, IA",
  },
  {
    zip: "51248",
    ST: "IA",
    cityWithStateAbbr: "Sanborn, IA",
  },
  {
    zip: "51249",
    ST: "IA",
    cityWithStateAbbr: "Sibley, IA",
  },
  {
    zip: "51250",
    ST: "IA",
    cityWithStateAbbr: "Sioux Center, IA",
  },
  {
    zip: "51301",
    ST: "IA",
    cityWithStateAbbr: "Spencer, IA",
  },
  {
    zip: "51331",
    ST: "IA",
    cityWithStateAbbr: "Arnolds Park, IA",
  },
  {
    zip: "51333",
    ST: "IA",
    cityWithStateAbbr: "Dickens, IA",
  },
  {
    zip: "51334",
    ST: "IA",
    cityWithStateAbbr: "Estherville, IA",
  },
  {
    zip: "51338",
    ST: "IA",
    cityWithStateAbbr: "Everly, IA",
  },
  {
    zip: "51340",
    ST: "IA",
    cityWithStateAbbr: "Fostoria, IA",
  },
  {
    zip: "51341",
    ST: "IA",
    cityWithStateAbbr: "Gillett Grove, IA",
  },
  {
    zip: "51342",
    ST: "IA",
    cityWithStateAbbr: "Graettinger, IA",
  },
  {
    zip: "51343",
    ST: "IA",
    cityWithStateAbbr: "Greenville, IA",
  },
  {
    zip: "51345",
    ST: "IA",
    cityWithStateAbbr: "Harris, IA",
  },
  {
    zip: "51346",
    ST: "IA",
    cityWithStateAbbr: "Hartley, IA",
  },
  {
    zip: "51347",
    ST: "IA",
    cityWithStateAbbr: "Lake Park, IA",
  },
  {
    zip: "51350",
    ST: "IA",
    cityWithStateAbbr: "Melvin, IA",
  },
  {
    zip: "51351",
    ST: "IA",
    cityWithStateAbbr: "Milford, IA",
  },
  {
    zip: "51354",
    ST: "IA",
    cityWithStateAbbr: "Ocheyedan, IA",
  },
  {
    zip: "51355",
    ST: "IA",
    cityWithStateAbbr: "Okoboji, IA",
  },
  {
    zip: "51357",
    ST: "IA",
    cityWithStateAbbr: "Royal, IA",
  },
  {
    zip: "51358",
    ST: "IA",
    cityWithStateAbbr: "Ruthven, IA",
  },
  {
    zip: "51360",
    ST: "IA",
    cityWithStateAbbr: "Spirit Lake, IA",
  },
  {
    zip: "51363",
    ST: "IA",
    cityWithStateAbbr: "Superior, IA",
  },
  {
    zip: "51364",
    ST: "IA",
    cityWithStateAbbr: "Terril, IA",
  },
  {
    zip: "51365",
    ST: "IA",
    cityWithStateAbbr: "Wallingford, IA",
  },
  {
    zip: "51366",
    ST: "IA",
    cityWithStateAbbr: "Webb, IA",
  },
  {
    zip: "51401",
    ST: "IA",
    cityWithStateAbbr: "Carroll, IA",
  },
  {
    zip: "51430",
    ST: "IA",
    cityWithStateAbbr: "Arcadia, IA",
  },
  {
    zip: "51431",
    ST: "IA",
    cityWithStateAbbr: "Arthur, IA",
  },
  {
    zip: "51432",
    ST: "IA",
    cityWithStateAbbr: "Aspinwall, IA",
  },
  {
    zip: "51433",
    ST: "IA",
    cityWithStateAbbr: "Auburn, IA",
  },
  {
    zip: "51436",
    ST: "IA",
    cityWithStateAbbr: "Breda, IA",
  },
  {
    zip: "51439",
    ST: "IA",
    cityWithStateAbbr: "Charter Oak, IA",
  },
  {
    zip: "51440",
    ST: "IA",
    cityWithStateAbbr: "Dedham, IA",
  },
  {
    zip: "51441",
    ST: "IA",
    cityWithStateAbbr: "Deloit, IA",
  },
  {
    zip: "51442",
    ST: "IA",
    cityWithStateAbbr: "Denison, IA",
  },
  {
    zip: "51443",
    ST: "IA",
    cityWithStateAbbr: "Glidden, IA",
  },
  {
    zip: "51444",
    ST: "IA",
    cityWithStateAbbr: "Halbur, IA",
  },
  {
    zip: "51445",
    ST: "IA",
    cityWithStateAbbr: "Ida Grove, IA",
  },
  {
    zip: "51446",
    ST: "IA",
    cityWithStateAbbr: "Irwin, IA",
  },
  {
    zip: "51447",
    ST: "IA",
    cityWithStateAbbr: "Kirkman, IA",
  },
  {
    zip: "51448",
    ST: "IA",
    cityWithStateAbbr: "Kiron, IA",
  },
  {
    zip: "51449",
    ST: "IA",
    cityWithStateAbbr: "Lake City, IA",
  },
  {
    zip: "51450",
    ST: "IA",
    cityWithStateAbbr: "Lake View, IA",
  },
  {
    zip: "51451",
    ST: "IA",
    cityWithStateAbbr: "Lanesboro, IA",
  },
  {
    zip: "51452",
    ST: "IA",
    cityWithStateAbbr: "Lidderdale, IA",
  },
  {
    zip: "51453",
    ST: "IA",
    cityWithStateAbbr: "Lohrville, IA",
  },
  {
    zip: "51454",
    ST: "IA",
    cityWithStateAbbr: "Manilla, IA",
  },
  {
    zip: "51455",
    ST: "IA",
    cityWithStateAbbr: "Manning, IA",
  },
  {
    zip: "51458",
    ST: "IA",
    cityWithStateAbbr: "Odebolt, IA",
  },
  {
    zip: "51459",
    ST: "IA",
    cityWithStateAbbr: "Ralston, IA",
  },
  {
    zip: "51460",
    ST: "IA",
    cityWithStateAbbr: "Ricketts, IA",
  },
  {
    zip: "51461",
    ST: "IA",
    cityWithStateAbbr: "Schleswig, IA",
  },
  {
    zip: "51462",
    ST: "IA",
    cityWithStateAbbr: "Scranton, IA",
  },
  {
    zip: "51463",
    ST: "IA",
    cityWithStateAbbr: "Templeton, IA",
  },
  {
    zip: "51465",
    ST: "IA",
    cityWithStateAbbr: "Vail, IA",
  },
  {
    zip: "51466",
    ST: "IA",
    cityWithStateAbbr: "Wall Lake, IA",
  },
  {
    zip: "51467",
    ST: "IA",
    cityWithStateAbbr: "Westside, IA",
  },
  {
    zip: "51501",
    ST: "IA",
    cityWithStateAbbr: "Council Bluffs, IA",
  },
  {
    zip: "51502",
    ST: "IA",
    cityWithStateAbbr: "Council Bluffs, IA",
  },
  {
    zip: "51503",
    ST: "IA",
    cityWithStateAbbr: "Council Bluffs, IA",
  },
  {
    zip: "51510",
    ST: "IA",
    cityWithStateAbbr: "Carter Lake, IA",
  },
  {
    zip: "51520",
    ST: "IA",
    cityWithStateAbbr: "Arion, IA",
  },
  {
    zip: "51521",
    ST: "IA",
    cityWithStateAbbr: "Avoca, IA",
  },
  {
    zip: "51523",
    ST: "IA",
    cityWithStateAbbr: "Blencoe, IA",
  },
  {
    zip: "51525",
    ST: "IA",
    cityWithStateAbbr: "Carson, IA",
  },
  {
    zip: "51526",
    ST: "IA",
    cityWithStateAbbr: "Crescent, IA",
  },
  {
    zip: "51527",
    ST: "IA",
    cityWithStateAbbr: "Defiance, IA",
  },
  {
    zip: "51528",
    ST: "IA",
    cityWithStateAbbr: "Dow City, IA",
  },
  {
    zip: "51529",
    ST: "IA",
    cityWithStateAbbr: "Dunlap, IA",
  },
  {
    zip: "51530",
    ST: "IA",
    cityWithStateAbbr: "Earling, IA",
  },
  {
    zip: "51531",
    ST: "IA",
    cityWithStateAbbr: "Elk Horn, IA",
  },
  {
    zip: "51532",
    ST: "IA",
    cityWithStateAbbr: "Elliott, IA",
  },
  {
    zip: "51533",
    ST: "IA",
    cityWithStateAbbr: "Emerson, IA",
  },
  {
    zip: "51534",
    ST: "IA",
    cityWithStateAbbr: "Glenwood, IA",
  },
  {
    zip: "51535",
    ST: "IA",
    cityWithStateAbbr: "Griswold, IA",
  },
  {
    zip: "51536",
    ST: "IA",
    cityWithStateAbbr: "Hancock, IA",
  },
  {
    zip: "51537",
    ST: "IA",
    cityWithStateAbbr: "Harlan, IA",
  },
  {
    zip: "51540",
    ST: "IA",
    cityWithStateAbbr: "Hastings, IA",
  },
  {
    zip: "51541",
    ST: "IA",
    cityWithStateAbbr: "Henderson, IA",
  },
  {
    zip: "51542",
    ST: "IA",
    cityWithStateAbbr: "Honey Creek, IA",
  },
  {
    zip: "51543",
    ST: "IA",
    cityWithStateAbbr: "Kimballton, IA",
  },
  {
    zip: "51544",
    ST: "IA",
    cityWithStateAbbr: "Lewis, IA",
  },
  {
    zip: "51545",
    ST: "IA",
    cityWithStateAbbr: "Little Sioux, IA",
  },
  {
    zip: "51546",
    ST: "IA",
    cityWithStateAbbr: "Logan, IA",
  },
  {
    zip: "51548",
    ST: "IA",
    cityWithStateAbbr: "Mc Clelland, IA",
  },
  {
    zip: "51549",
    ST: "IA",
    cityWithStateAbbr: "Macedonia, IA",
  },
  {
    zip: "51550",
    ST: "IA",
    cityWithStateAbbr: "Magnolia, IA",
  },
  {
    zip: "51551",
    ST: "IA",
    cityWithStateAbbr: "Malvern, IA",
  },
  {
    zip: "51552",
    ST: "IA",
    cityWithStateAbbr: "Marne, IA",
  },
  {
    zip: "51553",
    ST: "IA",
    cityWithStateAbbr: "Minden, IA",
  },
  {
    zip: "51554",
    ST: "IA",
    cityWithStateAbbr: "Mineola, IA",
  },
  {
    zip: "51555",
    ST: "IA",
    cityWithStateAbbr: "Missouri Valley, IA",
  },
  {
    zip: "51556",
    ST: "IA",
    cityWithStateAbbr: "Modale, IA",
  },
  {
    zip: "51557",
    ST: "IA",
    cityWithStateAbbr: "Mondamin, IA",
  },
  {
    zip: "51558",
    ST: "IA",
    cityWithStateAbbr: "Moorhead, IA",
  },
  {
    zip: "51559",
    ST: "IA",
    cityWithStateAbbr: "Neola, IA",
  },
  {
    zip: "51560",
    ST: "IA",
    cityWithStateAbbr: "Oakland, IA",
  },
  {
    zip: "51561",
    ST: "IA",
    cityWithStateAbbr: "Pacific Junction, IA",
  },
  {
    zip: "51562",
    ST: "IA",
    cityWithStateAbbr: "Panama, IA",
  },
  {
    zip: "51563",
    ST: "IA",
    cityWithStateAbbr: "Persia, IA",
  },
  {
    zip: "51564",
    ST: "IA",
    cityWithStateAbbr: "Pisgah, IA",
  },
  {
    zip: "51565",
    ST: "IA",
    cityWithStateAbbr: "Portsmouth, IA",
  },
  {
    zip: "51566",
    ST: "IA",
    cityWithStateAbbr: "Red Oak, IA",
  },
  {
    zip: "51570",
    ST: "IA",
    cityWithStateAbbr: "Shelby, IA",
  },
  {
    zip: "51571",
    ST: "IA",
    cityWithStateAbbr: "Silver City, IA",
  },
  {
    zip: "51572",
    ST: "IA",
    cityWithStateAbbr: "Soldier, IA",
  },
  {
    zip: "51573",
    ST: "IA",
    cityWithStateAbbr: "Stanton, IA",
  },
  {
    zip: "51575",
    ST: "IA",
    cityWithStateAbbr: "Treynor, IA",
  },
  {
    zip: "51576",
    ST: "IA",
    cityWithStateAbbr: "Underwood, IA",
  },
  {
    zip: "51577",
    ST: "IA",
    cityWithStateAbbr: "Walnut, IA",
  },
  {
    zip: "51578",
    ST: "IA",
    cityWithStateAbbr: "Westphalia, IA",
  },
  {
    zip: "51579",
    ST: "IA",
    cityWithStateAbbr: "Woodbine, IA",
  },
  {
    zip: "51591",
    ST: "IA",
    cityWithStateAbbr: "Red Oak, IA",
  },
  {
    zip: "51593",
    ST: "IA",
    cityWithStateAbbr: "Harlan, IA",
  },
  {
    zip: "51601",
    ST: "IA",
    cityWithStateAbbr: "Shenandoah, IA",
  },
  {
    zip: "51602",
    ST: "IA",
    cityWithStateAbbr: "Shenandoah, IA",
  },
  {
    zip: "51603",
    ST: "IA",
    cityWithStateAbbr: "Shenandoah, IA",
  },
  {
    zip: "51630",
    ST: "IA",
    cityWithStateAbbr: "Blanchard, IA",
  },
  {
    zip: "51631",
    ST: "IA",
    cityWithStateAbbr: "Braddyville, IA",
  },
  {
    zip: "51632",
    ST: "IA",
    cityWithStateAbbr: "Clarinda, IA",
  },
  {
    zip: "51636",
    ST: "IA",
    cityWithStateAbbr: "Coin, IA",
  },
  {
    zip: "51637",
    ST: "IA",
    cityWithStateAbbr: "College Springs, IA",
  },
  {
    zip: "51638",
    ST: "IA",
    cityWithStateAbbr: "Essex, IA",
  },
  {
    zip: "51639",
    ST: "IA",
    cityWithStateAbbr: "Farragut, IA",
  },
  {
    zip: "51640",
    ST: "IA",
    cityWithStateAbbr: "Hamburg, IA",
  },
  {
    zip: "51645",
    ST: "IA",
    cityWithStateAbbr: "Imogene, IA",
  },
  {
    zip: "51646",
    ST: "IA",
    cityWithStateAbbr: "New Market, IA",
  },
  {
    zip: "51647",
    ST: "IA",
    cityWithStateAbbr: "Northboro, IA",
  },
  {
    zip: "51648",
    ST: "IA",
    cityWithStateAbbr: "Percival, IA",
  },
  {
    zip: "51649",
    ST: "IA",
    cityWithStateAbbr: "Randolph, IA",
  },
  {
    zip: "51650",
    ST: "IA",
    cityWithStateAbbr: "Riverton, IA",
  },
  {
    zip: "51651",
    ST: "IA",
    cityWithStateAbbr: "Shambaugh, IA",
  },
  {
    zip: "51652",
    ST: "IA",
    cityWithStateAbbr: "Sidney, IA",
  },
  {
    zip: "51653",
    ST: "IA",
    cityWithStateAbbr: "Tabor, IA",
  },
  {
    zip: "51654",
    ST: "IA",
    cityWithStateAbbr: "Thurman, IA",
  },
  {
    zip: "51656",
    ST: "IA",
    cityWithStateAbbr: "Yorktown, IA",
  },
  {
    zip: "52001",
    ST: "IA",
    cityWithStateAbbr: "Dubuque, IA",
  },
  {
    zip: "52002",
    ST: "IA",
    cityWithStateAbbr: "Dubuque, IA",
  },
  {
    zip: "52003",
    ST: "IA",
    cityWithStateAbbr: "Dubuque, IA",
  },
  {
    zip: "52004",
    ST: "IA",
    cityWithStateAbbr: "Dubuque, IA",
  },
  {
    zip: "52030",
    ST: "IA",
    cityWithStateAbbr: "Andrew, IA",
  },
  {
    zip: "52031",
    ST: "IA",
    cityWithStateAbbr: "Bellevue, IA",
  },
  {
    zip: "52032",
    ST: "IA",
    cityWithStateAbbr: "Bernard, IA",
  },
  {
    zip: "52033",
    ST: "IA",
    cityWithStateAbbr: "Cascade, IA",
  },
  {
    zip: "52035",
    ST: "IA",
    cityWithStateAbbr: "Colesburg, IA",
  },
  {
    zip: "52036",
    ST: "IA",
    cityWithStateAbbr: "Delaware, IA",
  },
  {
    zip: "52037",
    ST: "IA",
    cityWithStateAbbr: "Delmar, IA",
  },
  {
    zip: "52038",
    ST: "IA",
    cityWithStateAbbr: "Dundee, IA",
  },
  {
    zip: "52039",
    ST: "IA",
    cityWithStateAbbr: "Durango, IA",
  },
  {
    zip: "52040",
    ST: "IA",
    cityWithStateAbbr: "Dyersville, IA",
  },
  {
    zip: "52041",
    ST: "IA",
    cityWithStateAbbr: "Earlville, IA",
  },
  {
    zip: "52042",
    ST: "IA",
    cityWithStateAbbr: "Edgewood, IA",
  },
  {
    zip: "52043",
    ST: "IA",
    cityWithStateAbbr: "Elkader, IA",
  },
  {
    zip: "52044",
    ST: "IA",
    cityWithStateAbbr: "Elkport, IA",
  },
  {
    zip: "52045",
    ST: "IA",
    cityWithStateAbbr: "Epworth, IA",
  },
  {
    zip: "52046",
    ST: "IA",
    cityWithStateAbbr: "Farley, IA",
  },
  {
    zip: "52047",
    ST: "IA",
    cityWithStateAbbr: "Farmersburg, IA",
  },
  {
    zip: "52048",
    ST: "IA",
    cityWithStateAbbr: "Garber, IA",
  },
  {
    zip: "52049",
    ST: "IA",
    cityWithStateAbbr: "Garnavillo, IA",
  },
  {
    zip: "52050",
    ST: "IA",
    cityWithStateAbbr: "Greeley, IA",
  },
  {
    zip: "52052",
    ST: "IA",
    cityWithStateAbbr: "Guttenberg, IA",
  },
  {
    zip: "52053",
    ST: "IA",
    cityWithStateAbbr: "Holy Cross, IA",
  },
  {
    zip: "52054",
    ST: "IA",
    cityWithStateAbbr: "La Motte, IA",
  },
  {
    zip: "52056",
    ST: "IA",
    cityWithStateAbbr: "Luxemburg, IA",
  },
  {
    zip: "52057",
    ST: "IA",
    cityWithStateAbbr: "Manchester, IA",
  },
  {
    zip: "52060",
    ST: "IA",
    cityWithStateAbbr: "Maquoketa, IA",
  },
  {
    zip: "52064",
    ST: "IA",
    cityWithStateAbbr: "Miles, IA",
  },
  {
    zip: "52065",
    ST: "IA",
    cityWithStateAbbr: "New Vienna, IA",
  },
  {
    zip: "52066",
    ST: "IA",
    cityWithStateAbbr: "North Buena Vista, IA",
  },
  {
    zip: "52068",
    ST: "IA",
    cityWithStateAbbr: "Peosta, IA",
  },
  {
    zip: "52069",
    ST: "IA",
    cityWithStateAbbr: "Preston, IA",
  },
  {
    zip: "52070",
    ST: "IA",
    cityWithStateAbbr: "Sabula, IA",
  },
  {
    zip: "52071",
    ST: "IA",
    cityWithStateAbbr: "Saint Donatus, IA",
  },
  {
    zip: "52072",
    ST: "IA",
    cityWithStateAbbr: "Saint Olaf, IA",
  },
  {
    zip: "52073",
    ST: "IA",
    cityWithStateAbbr: "Sherrill, IA",
  },
  {
    zip: "52074",
    ST: "IA",
    cityWithStateAbbr: "Spragueville, IA",
  },
  {
    zip: "52075",
    ST: "IA",
    cityWithStateAbbr: "Springbrook, IA",
  },
  {
    zip: "52076",
    ST: "IA",
    cityWithStateAbbr: "Strawberry Point, IA",
  },
  {
    zip: "52077",
    ST: "IA",
    cityWithStateAbbr: "Volga, IA",
  },
  {
    zip: "52078",
    ST: "IA",
    cityWithStateAbbr: "Worthington, IA",
  },
  {
    zip: "52079",
    ST: "IA",
    cityWithStateAbbr: "Zwingle, IA",
  },
  {
    zip: "52099",
    ST: "IA",
    cityWithStateAbbr: "Dubuque, IA",
  },
  {
    zip: "52101",
    ST: "IA",
    cityWithStateAbbr: "Decorah, IA",
  },
  {
    zip: "52132",
    ST: "IA",
    cityWithStateAbbr: "Calmar, IA",
  },
  {
    zip: "52133",
    ST: "IA",
    cityWithStateAbbr: "Castalia, IA",
  },
  {
    zip: "52134",
    ST: "IA",
    cityWithStateAbbr: "Chester, IA",
  },
  {
    zip: "52135",
    ST: "IA",
    cityWithStateAbbr: "Clermont, IA",
  },
  {
    zip: "52136",
    ST: "IA",
    cityWithStateAbbr: "Cresco, IA",
  },
  {
    zip: "52140",
    ST: "IA",
    cityWithStateAbbr: "Dorchester, IA",
  },
  {
    zip: "52141",
    ST: "IA",
    cityWithStateAbbr: "Elgin, IA",
  },
  {
    zip: "52142",
    ST: "IA",
    cityWithStateAbbr: "Fayette, IA",
  },
  {
    zip: "52144",
    ST: "IA",
    cityWithStateAbbr: "Fort Atkinson, IA",
  },
  {
    zip: "52146",
    ST: "IA",
    cityWithStateAbbr: "Harpers Ferry, IA",
  },
  {
    zip: "52147",
    ST: "IA",
    cityWithStateAbbr: "Hawkeye, IA",
  },
  {
    zip: "52149",
    ST: "IA",
    cityWithStateAbbr: "Highlandville, IA",
  },
  {
    zip: "52151",
    ST: "IA",
    cityWithStateAbbr: "Lansing, IA",
  },
  {
    zip: "52154",
    ST: "IA",
    cityWithStateAbbr: "Lawler, IA",
  },
  {
    zip: "52155",
    ST: "IA",
    cityWithStateAbbr: "Lime Springs, IA",
  },
  {
    zip: "52156",
    ST: "IA",
    cityWithStateAbbr: "Luana, IA",
  },
  {
    zip: "52157",
    ST: "IA",
    cityWithStateAbbr: "Mc Gregor, IA",
  },
  {
    zip: "52158",
    ST: "IA",
    cityWithStateAbbr: "Marquette, IA",
  },
  {
    zip: "52159",
    ST: "IA",
    cityWithStateAbbr: "Monona, IA",
  },
  {
    zip: "52160",
    ST: "IA",
    cityWithStateAbbr: "New Albin, IA",
  },
  {
    zip: "52161",
    ST: "IA",
    cityWithStateAbbr: "Ossian, IA",
  },
  {
    zip: "52162",
    ST: "IA",
    cityWithStateAbbr: "Postville, IA",
  },
  {
    zip: "52163",
    ST: "IA",
    cityWithStateAbbr: "Protivin, IA",
  },
  {
    zip: "52164",
    ST: "IA",
    cityWithStateAbbr: "Randalia, IA",
  },
  {
    zip: "52165",
    ST: "IA",
    cityWithStateAbbr: "Ridgeway, IA",
  },
  {
    zip: "52166",
    ST: "IA",
    cityWithStateAbbr: "Saint Lucas, IA",
  },
  {
    zip: "52168",
    ST: "IA",
    cityWithStateAbbr: "Spillville, IA",
  },
  {
    zip: "52169",
    ST: "IA",
    cityWithStateAbbr: "Wadena, IA",
  },
  {
    zip: "52170",
    ST: "IA",
    cityWithStateAbbr: "Waterville, IA",
  },
  {
    zip: "52171",
    ST: "IA",
    cityWithStateAbbr: "Waucoma, IA",
  },
  {
    zip: "52172",
    ST: "IA",
    cityWithStateAbbr: "Waukon, IA",
  },
  {
    zip: "52175",
    ST: "IA",
    cityWithStateAbbr: "West Union, IA",
  },
  {
    zip: "52201",
    ST: "IA",
    cityWithStateAbbr: "Ainsworth, IA",
  },
  {
    zip: "52202",
    ST: "IA",
    cityWithStateAbbr: "Alburnett, IA",
  },
  {
    zip: "52203",
    ST: "IA",
    cityWithStateAbbr: "Amana, IA",
  },
  {
    zip: "52204",
    ST: "IA",
    cityWithStateAbbr: "Amana, IA",
  },
  {
    zip: "52205",
    ST: "IA",
    cityWithStateAbbr: "Anamosa, IA",
  },
  {
    zip: "52206",
    ST: "IA",
    cityWithStateAbbr: "Atkins, IA",
  },
  {
    zip: "52207",
    ST: "IA",
    cityWithStateAbbr: "Baldwin, IA",
  },
  {
    zip: "52208",
    ST: "IA",
    cityWithStateAbbr: "Belle Plaine, IA",
  },
  {
    zip: "52209",
    ST: "IA",
    cityWithStateAbbr: "Blairstown, IA",
  },
  {
    zip: "52210",
    ST: "IA",
    cityWithStateAbbr: "Brandon, IA",
  },
  {
    zip: "52211",
    ST: "IA",
    cityWithStateAbbr: "Brooklyn, IA",
  },
  {
    zip: "52212",
    ST: "IA",
    cityWithStateAbbr: "Center Junction, IA",
  },
  {
    zip: "52213",
    ST: "IA",
    cityWithStateAbbr: "Center Point, IA",
  },
  {
    zip: "52214",
    ST: "IA",
    cityWithStateAbbr: "Central City, IA",
  },
  {
    zip: "52215",
    ST: "IA",
    cityWithStateAbbr: "Chelsea, IA",
  },
  {
    zip: "52216",
    ST: "IA",
    cityWithStateAbbr: "Clarence, IA",
  },
  {
    zip: "52217",
    ST: "IA",
    cityWithStateAbbr: "Clutier, IA",
  },
  {
    zip: "52218",
    ST: "IA",
    cityWithStateAbbr: "Coggon, IA",
  },
  {
    zip: "52219",
    ST: "IA",
    cityWithStateAbbr: "Prairieburg, IA",
  },
  {
    zip: "52220",
    ST: "IA",
    cityWithStateAbbr: "Conroy, IA",
  },
  {
    zip: "52221",
    ST: "IA",
    cityWithStateAbbr: "Guernsey, IA",
  },
  {
    zip: "52222",
    ST: "IA",
    cityWithStateAbbr: "Deep River, IA",
  },
  {
    zip: "52223",
    ST: "IA",
    cityWithStateAbbr: "Delhi, IA",
  },
  {
    zip: "52224",
    ST: "IA",
    cityWithStateAbbr: "Dysart, IA",
  },
  {
    zip: "52225",
    ST: "IA",
    cityWithStateAbbr: "Elberon, IA",
  },
  {
    zip: "52227",
    ST: "IA",
    cityWithStateAbbr: "Ely, IA",
  },
  {
    zip: "52228",
    ST: "IA",
    cityWithStateAbbr: "Fairfax, IA",
  },
  {
    zip: "52229",
    ST: "IA",
    cityWithStateAbbr: "Garrison, IA",
  },
  {
    zip: "52231",
    ST: "IA",
    cityWithStateAbbr: "Harper, IA",
  },
  {
    zip: "52232",
    ST: "IA",
    cityWithStateAbbr: "Hartwick, IA",
  },
  {
    zip: "52233",
    ST: "IA",
    cityWithStateAbbr: "Hiawatha, IA",
  },
  {
    zip: "52235",
    ST: "IA",
    cityWithStateAbbr: "Hills, IA",
  },
  {
    zip: "52236",
    ST: "IA",
    cityWithStateAbbr: "Homestead, IA",
  },
  {
    zip: "52237",
    ST: "IA",
    cityWithStateAbbr: "Hopkinton, IA",
  },
  {
    zip: "52240",
    ST: "IA",
    cityWithStateAbbr: "Iowa City, IA",
  },
  {
    zip: "52241",
    ST: "IA",
    cityWithStateAbbr: "Coralville, IA",
  },
  {
    zip: "52242",
    ST: "IA",
    cityWithStateAbbr: "Iowa City, IA",
  },
  {
    zip: "52243",
    ST: "IA",
    cityWithStateAbbr: "Iowa City, IA",
  },
  {
    zip: "52244",
    ST: "IA",
    cityWithStateAbbr: "Iowa City, IA",
  },
  {
    zip: "52245",
    ST: "IA",
    cityWithStateAbbr: "Iowa City, IA",
  },
  {
    zip: "52246",
    ST: "IA",
    cityWithStateAbbr: "Iowa City, IA",
  },
  {
    zip: "52247",
    ST: "IA",
    cityWithStateAbbr: "Kalona, IA",
  },
  {
    zip: "52248",
    ST: "IA",
    cityWithStateAbbr: "Keota, IA",
  },
  {
    zip: "52249",
    ST: "IA",
    cityWithStateAbbr: "Keystone, IA",
  },
  {
    zip: "52251",
    ST: "IA",
    cityWithStateAbbr: "Ladora, IA",
  },
  {
    zip: "52252",
    ST: "IA",
    cityWithStateAbbr: "Langworthy, IA",
  },
  {
    zip: "52253",
    ST: "IA",
    cityWithStateAbbr: "Lisbon, IA",
  },
  {
    zip: "52254",
    ST: "IA",
    cityWithStateAbbr: "Lost Nation, IA",
  },
  {
    zip: "52255",
    ST: "IA",
    cityWithStateAbbr: "Lowden, IA",
  },
  {
    zip: "52257",
    ST: "IA",
    cityWithStateAbbr: "Luzerne, IA",
  },
  {
    zip: "52301",
    ST: "IA",
    cityWithStateAbbr: "Marengo, IA",
  },
  {
    zip: "52302",
    ST: "IA",
    cityWithStateAbbr: "Marion, IA",
  },
  {
    zip: "52305",
    ST: "IA",
    cityWithStateAbbr: "Martelle, IA",
  },
  {
    zip: "52306",
    ST: "IA",
    cityWithStateAbbr: "Mechanicsville, IA",
  },
  {
    zip: "52307",
    ST: "IA",
    cityWithStateAbbr: "Middle Amana, IA",
  },
  {
    zip: "52308",
    ST: "IA",
    cityWithStateAbbr: "Millersburg, IA",
  },
  {
    zip: "52309",
    ST: "IA",
    cityWithStateAbbr: "Monmouth, IA",
  },
  {
    zip: "52310",
    ST: "IA",
    cityWithStateAbbr: "Monticello, IA",
  },
  {
    zip: "52312",
    ST: "IA",
    cityWithStateAbbr: "Morley, IA",
  },
  {
    zip: "52313",
    ST: "IA",
    cityWithStateAbbr: "Mount Auburn, IA",
  },
  {
    zip: "52314",
    ST: "IA",
    cityWithStateAbbr: "Mount Vernon, IA",
  },
  {
    zip: "52315",
    ST: "IA",
    cityWithStateAbbr: "Newhall, IA",
  },
  {
    zip: "52316",
    ST: "IA",
    cityWithStateAbbr: "North English, IA",
  },
  {
    zip: "52317",
    ST: "IA",
    cityWithStateAbbr: "North Liberty, IA",
  },
  {
    zip: "52318",
    ST: "IA",
    cityWithStateAbbr: "Norway, IA",
  },
  {
    zip: "52320",
    ST: "IA",
    cityWithStateAbbr: "Olin, IA",
  },
  {
    zip: "52321",
    ST: "IA",
    cityWithStateAbbr: "Onslow, IA",
  },
  {
    zip: "52322",
    ST: "IA",
    cityWithStateAbbr: "Oxford, IA",
  },
  {
    zip: "52323",
    ST: "IA",
    cityWithStateAbbr: "Oxford Junction, IA",
  },
  {
    zip: "52324",
    ST: "IA",
    cityWithStateAbbr: "Palo, IA",
  },
  {
    zip: "52325",
    ST: "IA",
    cityWithStateAbbr: "Parnell, IA",
  },
  {
    zip: "52326",
    ST: "IA",
    cityWithStateAbbr: "Quasqueton, IA",
  },
  {
    zip: "52327",
    ST: "IA",
    cityWithStateAbbr: "Riverside, IA",
  },
  {
    zip: "52328",
    ST: "IA",
    cityWithStateAbbr: "Robins, IA",
  },
  {
    zip: "52329",
    ST: "IA",
    cityWithStateAbbr: "Rowley, IA",
  },
  {
    zip: "52330",
    ST: "IA",
    cityWithStateAbbr: "Ryan, IA",
  },
  {
    zip: "52332",
    ST: "IA",
    cityWithStateAbbr: "Shellsburg, IA",
  },
  {
    zip: "52333",
    ST: "IA",
    cityWithStateAbbr: "Solon, IA",
  },
  {
    zip: "52334",
    ST: "IA",
    cityWithStateAbbr: "South Amana, IA",
  },
  {
    zip: "52335",
    ST: "IA",
    cityWithStateAbbr: "South English, IA",
  },
  {
    zip: "52336",
    ST: "IA",
    cityWithStateAbbr: "Springville, IA",
  },
  {
    zip: "52337",
    ST: "IA",
    cityWithStateAbbr: "Stanwood, IA",
  },
  {
    zip: "52338",
    ST: "IA",
    cityWithStateAbbr: "Swisher, IA",
  },
  {
    zip: "52339",
    ST: "IA",
    cityWithStateAbbr: "Tama, IA",
  },
  {
    zip: "52340",
    ST: "IA",
    cityWithStateAbbr: "Tiffin, IA",
  },
  {
    zip: "52341",
    ST: "IA",
    cityWithStateAbbr: "Toddville, IA",
  },
  {
    zip: "52342",
    ST: "IA",
    cityWithStateAbbr: "Toledo, IA",
  },
  {
    zip: "52344",
    ST: "IA",
    cityWithStateAbbr: "Troy Mills, IA",
  },
  {
    zip: "52345",
    ST: "IA",
    cityWithStateAbbr: "Urbana, IA",
  },
  {
    zip: "52346",
    ST: "IA",
    cityWithStateAbbr: "Van Horne, IA",
  },
  {
    zip: "52347",
    ST: "IA",
    cityWithStateAbbr: "Victor, IA",
  },
  {
    zip: "52348",
    ST: "IA",
    cityWithStateAbbr: "Vining, IA",
  },
  {
    zip: "52349",
    ST: "IA",
    cityWithStateAbbr: "Vinton, IA",
  },
  {
    zip: "52351",
    ST: "IA",
    cityWithStateAbbr: "Walford, IA",
  },
  {
    zip: "52352",
    ST: "IA",
    cityWithStateAbbr: "Walker, IA",
  },
  {
    zip: "52353",
    ST: "IA",
    cityWithStateAbbr: "Washington, IA",
  },
  {
    zip: "52354",
    ST: "IA",
    cityWithStateAbbr: "Watkins, IA",
  },
  {
    zip: "52355",
    ST: "IA",
    cityWithStateAbbr: "Webster, IA",
  },
  {
    zip: "52356",
    ST: "IA",
    cityWithStateAbbr: "Wellman, IA",
  },
  {
    zip: "52358",
    ST: "IA",
    cityWithStateAbbr: "West Branch, IA",
  },
  {
    zip: "52359",
    ST: "IA",
    cityWithStateAbbr: "West Chester, IA",
  },
  {
    zip: "52361",
    ST: "IA",
    cityWithStateAbbr: "Williamsburg, IA",
  },
  {
    zip: "52362",
    ST: "IA",
    cityWithStateAbbr: "Wyoming, IA",
  },
  {
    zip: "52401",
    ST: "IA",
    cityWithStateAbbr: "Cedar Rapids, IA",
  },
  {
    zip: "52402",
    ST: "IA",
    cityWithStateAbbr: "Cedar Rapids, IA",
  },
  {
    zip: "52403",
    ST: "IA",
    cityWithStateAbbr: "Cedar Rapids, IA",
  },
  {
    zip: "52404",
    ST: "IA",
    cityWithStateAbbr: "Cedar Rapids, IA",
  },
  {
    zip: "52405",
    ST: "IA",
    cityWithStateAbbr: "Cedar Rapids, IA",
  },
  {
    zip: "52406",
    ST: "IA",
    cityWithStateAbbr: "Cedar Rapids, IA",
  },
  {
    zip: "52407",
    ST: "IA",
    cityWithStateAbbr: "Cedar Rapids, IA",
  },
  {
    zip: "52408",
    ST: "IA",
    cityWithStateAbbr: "Cedar Rapids, IA",
  },
  {
    zip: "52409",
    ST: "IA",
    cityWithStateAbbr: "Cedar Rapids, IA",
  },
  {
    zip: "52410",
    ST: "IA",
    cityWithStateAbbr: "Cedar Rapids, IA",
  },
  {
    zip: "52411",
    ST: "IA",
    cityWithStateAbbr: "Cedar Rapids, IA",
  },
  {
    zip: "52497",
    ST: "IA",
    cityWithStateAbbr: "Cedar Rapids, IA",
  },
  {
    zip: "52498",
    ST: "IA",
    cityWithStateAbbr: "Cedar Rapids, IA",
  },
  {
    zip: "52499",
    ST: "IA",
    cityWithStateAbbr: "Cedar Rapids, IA",
  },
  {
    zip: "52501",
    ST: "IA",
    cityWithStateAbbr: "Ottumwa, IA",
  },
  {
    zip: "52530",
    ST: "IA",
    cityWithStateAbbr: "Agency, IA",
  },
  {
    zip: "52531",
    ST: "IA",
    cityWithStateAbbr: "Albia, IA",
  },
  {
    zip: "52533",
    ST: "IA",
    cityWithStateAbbr: "Batavia, IA",
  },
  {
    zip: "52534",
    ST: "IA",
    cityWithStateAbbr: "Beacon, IA",
  },
  {
    zip: "52535",
    ST: "IA",
    cityWithStateAbbr: "Birmingham, IA",
  },
  {
    zip: "52536",
    ST: "IA",
    cityWithStateAbbr: "Blakesburg, IA",
  },
  {
    zip: "52537",
    ST: "IA",
    cityWithStateAbbr: "Bloomfield, IA",
  },
  {
    zip: "52540",
    ST: "IA",
    cityWithStateAbbr: "Brighton, IA",
  },
  {
    zip: "52542",
    ST: "IA",
    cityWithStateAbbr: "Cantril, IA",
  },
  {
    zip: "52543",
    ST: "IA",
    cityWithStateAbbr: "Cedar, IA",
  },
  {
    zip: "52544",
    ST: "IA",
    cityWithStateAbbr: "Centerville, IA",
  },
  {
    zip: "52548",
    ST: "IA",
    cityWithStateAbbr: "Chillicothe, IA",
  },
  {
    zip: "52549",
    ST: "IA",
    cityWithStateAbbr: "Cincinnati, IA",
  },
  {
    zip: "52550",
    ST: "IA",
    cityWithStateAbbr: "Delta, IA",
  },
  {
    zip: "52551",
    ST: "IA",
    cityWithStateAbbr: "Douds, IA",
  },
  {
    zip: "52552",
    ST: "IA",
    cityWithStateAbbr: "Drakesville, IA",
  },
  {
    zip: "52553",
    ST: "IA",
    cityWithStateAbbr: "Eddyville, IA",
  },
  {
    zip: "52554",
    ST: "IA",
    cityWithStateAbbr: "Eldon, IA",
  },
  {
    zip: "52555",
    ST: "IA",
    cityWithStateAbbr: "Exline, IA",
  },
  {
    zip: "52556",
    ST: "IA",
    cityWithStateAbbr: "Fairfield, IA",
  },
  {
    zip: "52557",
    ST: "IA",
    cityWithStateAbbr: "Fairfield, IA",
  },
  {
    zip: "52560",
    ST: "IA",
    cityWithStateAbbr: "Floris, IA",
  },
  {
    zip: "52561",
    ST: "IA",
    cityWithStateAbbr: "Fremont, IA",
  },
  {
    zip: "52562",
    ST: "IA",
    cityWithStateAbbr: "Hayesville, IA",
  },
  {
    zip: "52563",
    ST: "IA",
    cityWithStateAbbr: "Hedrick, IA",
  },
  {
    zip: "52565",
    ST: "IA",
    cityWithStateAbbr: "Keosauqua, IA",
  },
  {
    zip: "52566",
    ST: "IA",
    cityWithStateAbbr: "Kirkville, IA",
  },
  {
    zip: "52567",
    ST: "IA",
    cityWithStateAbbr: "Libertyville, IA",
  },
  {
    zip: "52568",
    ST: "IA",
    cityWithStateAbbr: "Martinsburg, IA",
  },
  {
    zip: "52569",
    ST: "IA",
    cityWithStateAbbr: "Melrose, IA",
  },
  {
    zip: "52570",
    ST: "IA",
    cityWithStateAbbr: "Milton, IA",
  },
  {
    zip: "52571",
    ST: "IA",
    cityWithStateAbbr: "Moravia, IA",
  },
  {
    zip: "52572",
    ST: "IA",
    cityWithStateAbbr: "Moulton, IA",
  },
  {
    zip: "52573",
    ST: "IA",
    cityWithStateAbbr: "Mount Sterling, IA",
  },
  {
    zip: "52574",
    ST: "IA",
    cityWithStateAbbr: "Mystic, IA",
  },
  {
    zip: "52576",
    ST: "IA",
    cityWithStateAbbr: "Ollie, IA",
  },
  {
    zip: "52577",
    ST: "IA",
    cityWithStateAbbr: "Oskaloosa, IA",
  },
  {
    zip: "52580",
    ST: "IA",
    cityWithStateAbbr: "Packwood, IA",
  },
  {
    zip: "52581",
    ST: "IA",
    cityWithStateAbbr: "Plano, IA",
  },
  {
    zip: "52583",
    ST: "IA",
    cityWithStateAbbr: "Promise City, IA",
  },
  {
    zip: "52584",
    ST: "IA",
    cityWithStateAbbr: "Pulaski, IA",
  },
  {
    zip: "52585",
    ST: "IA",
    cityWithStateAbbr: "Richland, IA",
  },
  {
    zip: "52586",
    ST: "IA",
    cityWithStateAbbr: "Rose Hill, IA",
  },
  {
    zip: "52588",
    ST: "IA",
    cityWithStateAbbr: "Selma, IA",
  },
  {
    zip: "52590",
    ST: "IA",
    cityWithStateAbbr: "Seymour, IA",
  },
  {
    zip: "52591",
    ST: "IA",
    cityWithStateAbbr: "Sigourney, IA",
  },
  {
    zip: "52593",
    ST: "IA",
    cityWithStateAbbr: "Udell, IA",
  },
  {
    zip: "52594",
    ST: "IA",
    cityWithStateAbbr: "Unionville, IA",
  },
  {
    zip: "52595",
    ST: "IA",
    cityWithStateAbbr: "University Park, IA",
  },
  {
    zip: "52601",
    ST: "IA",
    cityWithStateAbbr: "Burlington, IA",
  },
  {
    zip: "52619",
    ST: "IA",
    cityWithStateAbbr: "Argyle, IA",
  },
  {
    zip: "52620",
    ST: "IA",
    cityWithStateAbbr: "Bonaparte, IA",
  },
  {
    zip: "52621",
    ST: "IA",
    cityWithStateAbbr: "Crawfordsville, IA",
  },
  {
    zip: "52623",
    ST: "IA",
    cityWithStateAbbr: "Danville, IA",
  },
  {
    zip: "52624",
    ST: "IA",
    cityWithStateAbbr: "Denmark, IA",
  },
  {
    zip: "52625",
    ST: "IA",
    cityWithStateAbbr: "Donnellson, IA",
  },
  {
    zip: "52626",
    ST: "IA",
    cityWithStateAbbr: "Farmington, IA",
  },
  {
    zip: "52627",
    ST: "IA",
    cityWithStateAbbr: "Fort Madison, IA",
  },
  {
    zip: "52630",
    ST: "IA",
    cityWithStateAbbr: "Hillsboro, IA",
  },
  {
    zip: "52631",
    ST: "IA",
    cityWithStateAbbr: "Houghton, IA",
  },
  {
    zip: "52632",
    ST: "IA",
    cityWithStateAbbr: "Keokuk, IA",
  },
  {
    zip: "52635",
    ST: "IA",
    cityWithStateAbbr: "Lockridge, IA",
  },
  {
    zip: "52637",
    ST: "IA",
    cityWithStateAbbr: "Mediapolis, IA",
  },
  {
    zip: "52638",
    ST: "IA",
    cityWithStateAbbr: "Middletown, IA",
  },
  {
    zip: "52639",
    ST: "IA",
    cityWithStateAbbr: "Montrose, IA",
  },
  {
    zip: "52640",
    ST: "IA",
    cityWithStateAbbr: "Morning Sun, IA",
  },
  {
    zip: "52641",
    ST: "IA",
    cityWithStateAbbr: "Mount Pleasant, IA",
  },
  {
    zip: "52642",
    ST: "IA",
    cityWithStateAbbr: "Rome, IA",
  },
  {
    zip: "52644",
    ST: "IA",
    cityWithStateAbbr: "Mount Union, IA",
  },
  {
    zip: "52645",
    ST: "IA",
    cityWithStateAbbr: "New London, IA",
  },
  {
    zip: "52646",
    ST: "IA",
    cityWithStateAbbr: "Oakville, IA",
  },
  {
    zip: "52647",
    ST: "IA",
    cityWithStateAbbr: "Olds, IA",
  },
  {
    zip: "52648",
    ST: "IA",
    cityWithStateAbbr: "Pilot Grove, IA",
  },
  {
    zip: "52649",
    ST: "IA",
    cityWithStateAbbr: "Salem, IA",
  },
  {
    zip: "52650",
    ST: "IA",
    cityWithStateAbbr: "Sperry, IA",
  },
  {
    zip: "52651",
    ST: "IA",
    cityWithStateAbbr: "Stockport, IA",
  },
  {
    zip: "52652",
    ST: "IA",
    cityWithStateAbbr: "Swedesburg, IA",
  },
  {
    zip: "52653",
    ST: "IA",
    cityWithStateAbbr: "Wapello, IA",
  },
  {
    zip: "52654",
    ST: "IA",
    cityWithStateAbbr: "Wayland, IA",
  },
  {
    zip: "52655",
    ST: "IA",
    cityWithStateAbbr: "West Burlington, IA",
  },
  {
    zip: "52656",
    ST: "IA",
    cityWithStateAbbr: "West Point, IA",
  },
  {
    zip: "52657",
    ST: "IA",
    cityWithStateAbbr: "Saint Paul, IA",
  },
  {
    zip: "52658",
    ST: "IA",
    cityWithStateAbbr: "Wever, IA",
  },
  {
    zip: "52659",
    ST: "IA",
    cityWithStateAbbr: "Winfield, IA",
  },
  {
    zip: "52660",
    ST: "IA",
    cityWithStateAbbr: "Yarmouth, IA",
  },
  {
    zip: "52701",
    ST: "IA",
    cityWithStateAbbr: "Andover, IA",
  },
  {
    zip: "52720",
    ST: "IA",
    cityWithStateAbbr: "Atalissa, IA",
  },
  {
    zip: "52721",
    ST: "IA",
    cityWithStateAbbr: "Bennett, IA",
  },
  {
    zip: "52722",
    ST: "IA",
    cityWithStateAbbr: "Bettendorf, IA",
  },
  {
    zip: "52726",
    ST: "IA",
    cityWithStateAbbr: "Blue Grass, IA",
  },
  {
    zip: "52727",
    ST: "IA",
    cityWithStateAbbr: "Bryant, IA",
  },
  {
    zip: "52728",
    ST: "IA",
    cityWithStateAbbr: "Buffalo, IA",
  },
  {
    zip: "52729",
    ST: "IA",
    cityWithStateAbbr: "Calamus, IA",
  },
  {
    zip: "52730",
    ST: "IA",
    cityWithStateAbbr: "Camanche, IA",
  },
  {
    zip: "52731",
    ST: "IA",
    cityWithStateAbbr: "Charlotte, IA",
  },
  {
    zip: "52732",
    ST: "IA",
    cityWithStateAbbr: "Clinton, IA",
  },
  {
    zip: "52733",
    ST: "IA",
    cityWithStateAbbr: "Clinton, IA",
  },
  {
    zip: "52734",
    ST: "IA",
    cityWithStateAbbr: "Clinton, IA",
  },
  {
    zip: "52736",
    ST: "IA",
    cityWithStateAbbr: "Clinton, IA",
  },
  {
    zip: "52737",
    ST: "IA",
    cityWithStateAbbr: "Columbus City, IA",
  },
  {
    zip: "52738",
    ST: "IA",
    cityWithStateAbbr: "Columbus Junction, IA",
  },
  {
    zip: "52739",
    ST: "IA",
    cityWithStateAbbr: "Conesville, IA",
  },
  {
    zip: "52742",
    ST: "IA",
    cityWithStateAbbr: "De Witt, IA",
  },
  {
    zip: "52745",
    ST: "IA",
    cityWithStateAbbr: "Dixon, IA",
  },
  {
    zip: "52746",
    ST: "IA",
    cityWithStateAbbr: "Donahue, IA",
  },
  {
    zip: "52747",
    ST: "IA",
    cityWithStateAbbr: "Durant, IA",
  },
  {
    zip: "52748",
    ST: "IA",
    cityWithStateAbbr: "Eldridge, IA",
  },
  {
    zip: "52749",
    ST: "IA",
    cityWithStateAbbr: "Fruitland, IA",
  },
  {
    zip: "52750",
    ST: "IA",
    cityWithStateAbbr: "Goose Lake, IA",
  },
  {
    zip: "52751",
    ST: "IA",
    cityWithStateAbbr: "Grand Mound, IA",
  },
  {
    zip: "52752",
    ST: "IA",
    cityWithStateAbbr: "Grandview, IA",
  },
  {
    zip: "52753",
    ST: "IA",
    cityWithStateAbbr: "Le Claire, IA",
  },
  {
    zip: "52754",
    ST: "IA",
    cityWithStateAbbr: "Letts, IA",
  },
  {
    zip: "52755",
    ST: "IA",
    cityWithStateAbbr: "Lone Tree, IA",
  },
  {
    zip: "52756",
    ST: "IA",
    cityWithStateAbbr: "Long Grove, IA",
  },
  {
    zip: "52757",
    ST: "IA",
    cityWithStateAbbr: "Low Moor, IA",
  },
  {
    zip: "52758",
    ST: "IA",
    cityWithStateAbbr: "Mc Causland, IA",
  },
  {
    zip: "52759",
    ST: "IA",
    cityWithStateAbbr: "Montpelier, IA",
  },
  {
    zip: "52760",
    ST: "IA",
    cityWithStateAbbr: "Moscow, IA",
  },
  {
    zip: "52761",
    ST: "IA",
    cityWithStateAbbr: "Muscatine, IA",
  },
  {
    zip: "52765",
    ST: "IA",
    cityWithStateAbbr: "New Liberty, IA",
  },
  {
    zip: "52766",
    ST: "IA",
    cityWithStateAbbr: "Nichols, IA",
  },
  {
    zip: "52767",
    ST: "IA",
    cityWithStateAbbr: "Pleasant Valley, IA",
  },
  {
    zip: "52768",
    ST: "IA",
    cityWithStateAbbr: "Princeton, IA",
  },
  {
    zip: "52769",
    ST: "IA",
    cityWithStateAbbr: "Stockton, IA",
  },
  {
    zip: "52771",
    ST: "IA",
    cityWithStateAbbr: "Teeds Grove, IA",
  },
  {
    zip: "52772",
    ST: "IA",
    cityWithStateAbbr: "Tipton, IA",
  },
  {
    zip: "52773",
    ST: "IA",
    cityWithStateAbbr: "Walcott, IA",
  },
  {
    zip: "52774",
    ST: "IA",
    cityWithStateAbbr: "Welton, IA",
  },
  {
    zip: "52776",
    ST: "IA",
    cityWithStateAbbr: "West Liberty, IA",
  },
  {
    zip: "52777",
    ST: "IA",
    cityWithStateAbbr: "Wheatland, IA",
  },
  {
    zip: "52778",
    ST: "IA",
    cityWithStateAbbr: "Wilton, IA",
  },
  {
    zip: "52801",
    ST: "IA",
    cityWithStateAbbr: "Davenport, IA",
  },
  {
    zip: "52802",
    ST: "IA",
    cityWithStateAbbr: "Davenport, IA",
  },
  {
    zip: "52803",
    ST: "IA",
    cityWithStateAbbr: "Davenport, IA",
  },
  {
    zip: "52804",
    ST: "IA",
    cityWithStateAbbr: "Davenport, IA",
  },
  {
    zip: "52805",
    ST: "IA",
    cityWithStateAbbr: "Davenport, IA",
  },
  {
    zip: "52806",
    ST: "IA",
    cityWithStateAbbr: "Davenport, IA",
  },
  {
    zip: "52807",
    ST: "IA",
    cityWithStateAbbr: "Davenport, IA",
  },
  {
    zip: "52808",
    ST: "IA",
    cityWithStateAbbr: "Davenport, IA",
  },
  {
    zip: "52809",
    ST: "IA",
    cityWithStateAbbr: "Davenport, IA",
  },
  {
    zip: "53001",
    ST: "WI",
    cityWithStateAbbr: "Adell, WI",
  },
  {
    zip: "53002",
    ST: "WI",
    cityWithStateAbbr: "Allenton, WI",
  },
  {
    zip: "53003",
    ST: "WI",
    cityWithStateAbbr: "Ashippun, WI",
  },
  {
    zip: "53004",
    ST: "WI",
    cityWithStateAbbr: "Belgium, WI",
  },
  {
    zip: "53005",
    ST: "WI",
    cityWithStateAbbr: "Brookfield, WI",
  },
  {
    zip: "53006",
    ST: "WI",
    cityWithStateAbbr: "Brownsville, WI",
  },
  {
    zip: "53007",
    ST: "WI",
    cityWithStateAbbr: "Butler, WI",
  },
  {
    zip: "53008",
    ST: "WI",
    cityWithStateAbbr: "Brookfield, WI",
  },
  {
    zip: "53010",
    ST: "WI",
    cityWithStateAbbr: "Campbellsport, WI",
  },
  {
    zip: "53011",
    ST: "WI",
    cityWithStateAbbr: "Cascade, WI",
  },
  {
    zip: "53012",
    ST: "WI",
    cityWithStateAbbr: "Cedarburg, WI",
  },
  {
    zip: "53013",
    ST: "WI",
    cityWithStateAbbr: "Cedar Grove, WI",
  },
  {
    zip: "53014",
    ST: "WI",
    cityWithStateAbbr: "Chilton, WI",
  },
  {
    zip: "53015",
    ST: "WI",
    cityWithStateAbbr: "Cleveland, WI",
  },
  {
    zip: "53016",
    ST: "WI",
    cityWithStateAbbr: "Clyman, WI",
  },
  {
    zip: "53017",
    ST: "WI",
    cityWithStateAbbr: "Colgate, WI",
  },
  {
    zip: "53018",
    ST: "WI",
    cityWithStateAbbr: "Delafield, WI",
  },
  {
    zip: "53019",
    ST: "WI",
    cityWithStateAbbr: "Eden, WI",
  },
  {
    zip: "53020",
    ST: "WI",
    cityWithStateAbbr: "Elkhart Lake, WI",
  },
  {
    zip: "53021",
    ST: "WI",
    cityWithStateAbbr: "Fredonia, WI",
  },
  {
    zip: "53022",
    ST: "WI",
    cityWithStateAbbr: "Germantown, WI",
  },
  {
    zip: "53023",
    ST: "WI",
    cityWithStateAbbr: "Glenbeulah, WI",
  },
  {
    zip: "53024",
    ST: "WI",
    cityWithStateAbbr: "Grafton, WI",
  },
  {
    zip: "53026",
    ST: "WI",
    cityWithStateAbbr: "Greenbush, WI",
  },
  {
    zip: "53027",
    ST: "WI",
    cityWithStateAbbr: "Hartford, WI",
  },
  {
    zip: "53029",
    ST: "WI",
    cityWithStateAbbr: "Hartland, WI",
  },
  {
    zip: "53031",
    ST: "WI",
    cityWithStateAbbr: "Hingham, WI",
  },
  {
    zip: "53032",
    ST: "WI",
    cityWithStateAbbr: "Horicon, WI",
  },
  {
    zip: "53033",
    ST: "WI",
    cityWithStateAbbr: "Hubertus, WI",
  },
  {
    zip: "53034",
    ST: "WI",
    cityWithStateAbbr: "Hustisford, WI",
  },
  {
    zip: "53035",
    ST: "WI",
    cityWithStateAbbr: "Iron Ridge, WI",
  },
  {
    zip: "53036",
    ST: "WI",
    cityWithStateAbbr: "Ixonia, WI",
  },
  {
    zip: "53037",
    ST: "WI",
    cityWithStateAbbr: "Jackson, WI",
  },
  {
    zip: "53038",
    ST: "WI",
    cityWithStateAbbr: "Johnson Creek, WI",
  },
  {
    zip: "53039",
    ST: "WI",
    cityWithStateAbbr: "Juneau, WI",
  },
  {
    zip: "53040",
    ST: "WI",
    cityWithStateAbbr: "Kewaskum, WI",
  },
  {
    zip: "53042",
    ST: "WI",
    cityWithStateAbbr: "Kiel, WI",
  },
  {
    zip: "53044",
    ST: "WI",
    cityWithStateAbbr: "Kohler, WI",
  },
  {
    zip: "53045",
    ST: "WI",
    cityWithStateAbbr: "Brookfield, WI",
  },
  {
    zip: "53046",
    ST: "WI",
    cityWithStateAbbr: "Lannon, WI",
  },
  {
    zip: "53047",
    ST: "WI",
    cityWithStateAbbr: "Lebanon, WI",
  },
  {
    zip: "53048",
    ST: "WI",
    cityWithStateAbbr: "Lomira, WI",
  },
  {
    zip: "53049",
    ST: "WI",
    cityWithStateAbbr: "Malone, WI",
  },
  {
    zip: "53050",
    ST: "WI",
    cityWithStateAbbr: "Mayville, WI",
  },
  {
    zip: "53051",
    ST: "WI",
    cityWithStateAbbr: "Menomonee Falls, WI",
  },
  {
    zip: "53052",
    ST: "WI",
    cityWithStateAbbr: "Menomonee Falls, WI",
  },
  {
    zip: "53056",
    ST: "WI",
    cityWithStateAbbr: "Merton, WI",
  },
  {
    zip: "53057",
    ST: "WI",
    cityWithStateAbbr: "Mount Calvary, WI",
  },
  {
    zip: "53058",
    ST: "WI",
    cityWithStateAbbr: "Nashotah, WI",
  },
  {
    zip: "53059",
    ST: "WI",
    cityWithStateAbbr: "Neosho, WI",
  },
  {
    zip: "53060",
    ST: "WI",
    cityWithStateAbbr: "Newburg, WI",
  },
  {
    zip: "53061",
    ST: "WI",
    cityWithStateAbbr: "New Holstein, WI",
  },
  {
    zip: "53062",
    ST: "WI",
    cityWithStateAbbr: "New Holstein, WI",
  },
  {
    zip: "53063",
    ST: "WI",
    cityWithStateAbbr: "Newton, WI",
  },
  {
    zip: "53064",
    ST: "WI",
    cityWithStateAbbr: "North Lake, WI",
  },
  {
    zip: "53065",
    ST: "WI",
    cityWithStateAbbr: "Oakfield, WI",
  },
  {
    zip: "53066",
    ST: "WI",
    cityWithStateAbbr: "Oconomowoc, WI",
  },
  {
    zip: "53069",
    ST: "WI",
    cityWithStateAbbr: "Okauchee, WI",
  },
  {
    zip: "53070",
    ST: "WI",
    cityWithStateAbbr: "Oostburg, WI",
  },
  {
    zip: "53072",
    ST: "WI",
    cityWithStateAbbr: "Pewaukee, WI",
  },
  {
    zip: "53073",
    ST: "WI",
    cityWithStateAbbr: "Plymouth, WI",
  },
  {
    zip: "53074",
    ST: "WI",
    cityWithStateAbbr: "Port Washington, WI",
  },
  {
    zip: "53075",
    ST: "WI",
    cityWithStateAbbr: "Random Lake, WI",
  },
  {
    zip: "53076",
    ST: "WI",
    cityWithStateAbbr: "Richfield, WI",
  },
  {
    zip: "53078",
    ST: "WI",
    cityWithStateAbbr: "Rubicon, WI",
  },
  {
    zip: "53079",
    ST: "WI",
    cityWithStateAbbr: "Saint Cloud, WI",
  },
  {
    zip: "53080",
    ST: "WI",
    cityWithStateAbbr: "Saukville, WI",
  },
  {
    zip: "53081",
    ST: "WI",
    cityWithStateAbbr: "Sheboygan, WI",
  },
  {
    zip: "53082",
    ST: "WI",
    cityWithStateAbbr: "Sheboygan, WI",
  },
  {
    zip: "53083",
    ST: "WI",
    cityWithStateAbbr: "Sheboygan, WI",
  },
  {
    zip: "53085",
    ST: "WI",
    cityWithStateAbbr: "Sheboygan Falls, WI",
  },
  {
    zip: "53086",
    ST: "WI",
    cityWithStateAbbr: "Slinger, WI",
  },
  {
    zip: "53088",
    ST: "WI",
    cityWithStateAbbr: "Stockbridge, WI",
  },
  {
    zip: "53089",
    ST: "WI",
    cityWithStateAbbr: "Sussex, WI",
  },
  {
    zip: "53090",
    ST: "WI",
    cityWithStateAbbr: "West Bend, WI",
  },
  {
    zip: "53091",
    ST: "WI",
    cityWithStateAbbr: "Theresa, WI",
  },
  {
    zip: "53092",
    ST: "WI",
    cityWithStateAbbr: "Mequon, WI",
  },
  {
    zip: "53093",
    ST: "WI",
    cityWithStateAbbr: "Waldo, WI",
  },
  {
    zip: "53094",
    ST: "WI",
    cityWithStateAbbr: "Watertown, WI",
  },
  {
    zip: "53095",
    ST: "WI",
    cityWithStateAbbr: "West Bend, WI",
  },
  {
    zip: "53097",
    ST: "WI",
    cityWithStateAbbr: "Mequon, WI",
  },
  {
    zip: "53098",
    ST: "WI",
    cityWithStateAbbr: "Watertown, WI",
  },
  {
    zip: "53099",
    ST: "WI",
    cityWithStateAbbr: "Woodland, WI",
  },
  {
    zip: "53101",
    ST: "WI",
    cityWithStateAbbr: "Bassett, WI",
  },
  {
    zip: "53102",
    ST: "WI",
    cityWithStateAbbr: "Benet Lake, WI",
  },
  {
    zip: "53103",
    ST: "WI",
    cityWithStateAbbr: "Big Bend, WI",
  },
  {
    zip: "53104",
    ST: "WI",
    cityWithStateAbbr: "Bristol, WI",
  },
  {
    zip: "53105",
    ST: "WI",
    cityWithStateAbbr: "Burlington, WI",
  },
  {
    zip: "53108",
    ST: "WI",
    cityWithStateAbbr: "Caledonia, WI",
  },
  {
    zip: "53109",
    ST: "WI",
    cityWithStateAbbr: "Camp Lake, WI",
  },
  {
    zip: "53110",
    ST: "WI",
    cityWithStateAbbr: "Cudahy, WI",
  },
  {
    zip: "53114",
    ST: "WI",
    cityWithStateAbbr: "Darien, WI",
  },
  {
    zip: "53115",
    ST: "WI",
    cityWithStateAbbr: "Delavan, WI",
  },
  {
    zip: "53118",
    ST: "WI",
    cityWithStateAbbr: "Dousman, WI",
  },
  {
    zip: "53119",
    ST: "WI",
    cityWithStateAbbr: "Eagle, WI",
  },
  {
    zip: "53120",
    ST: "WI",
    cityWithStateAbbr: "East Troy, WI",
  },
  {
    zip: "53121",
    ST: "WI",
    cityWithStateAbbr: "Elkhorn, WI",
  },
  {
    zip: "53122",
    ST: "WI",
    cityWithStateAbbr: "Elm Grove, WI",
  },
  {
    zip: "53125",
    ST: "WI",
    cityWithStateAbbr: "Fontana, WI",
  },
  {
    zip: "53126",
    ST: "WI",
    cityWithStateAbbr: "Franksville, WI",
  },
  {
    zip: "53127",
    ST: "WI",
    cityWithStateAbbr: "Genesee Depot, WI",
  },
  {
    zip: "53128",
    ST: "WI",
    cityWithStateAbbr: "Genoa City, WI",
  },
  {
    zip: "53129",
    ST: "WI",
    cityWithStateAbbr: "Greendale, WI",
  },
  {
    zip: "53130",
    ST: "WI",
    cityWithStateAbbr: "Hales Corners, WI",
  },
  {
    zip: "53132",
    ST: "WI",
    cityWithStateAbbr: "Franklin, WI",
  },
  {
    zip: "53137",
    ST: "WI",
    cityWithStateAbbr: "Helenville, WI",
  },
  {
    zip: "53138",
    ST: "WI",
    cityWithStateAbbr: "Honey Creek, WI",
  },
  {
    zip: "53139",
    ST: "WI",
    cityWithStateAbbr: "Kansasville, WI",
  },
  {
    zip: "53140",
    ST: "WI",
    cityWithStateAbbr: "Kenosha, WI",
  },
  {
    zip: "53141",
    ST: "WI",
    cityWithStateAbbr: "Kenosha, WI",
  },
  {
    zip: "53142",
    ST: "WI",
    cityWithStateAbbr: "Kenosha, WI",
  },
  {
    zip: "53143",
    ST: "WI",
    cityWithStateAbbr: "Kenosha, WI",
  },
  {
    zip: "53144",
    ST: "WI",
    cityWithStateAbbr: "Kenosha, WI",
  },
  {
    zip: "53146",
    ST: "WI",
    cityWithStateAbbr: "New Berlin, WI",
  },
  {
    zip: "53147",
    ST: "WI",
    cityWithStateAbbr: "Lake Geneva, WI",
  },
  {
    zip: "53148",
    ST: "WI",
    cityWithStateAbbr: "Lyons, WI",
  },
  {
    zip: "53149",
    ST: "WI",
    cityWithStateAbbr: "Mukwonago, WI",
  },
  {
    zip: "53150",
    ST: "WI",
    cityWithStateAbbr: "Muskego, WI",
  },
  {
    zip: "53151",
    ST: "WI",
    cityWithStateAbbr: "New Berlin, WI",
  },
  {
    zip: "53152",
    ST: "WI",
    cityWithStateAbbr: "New Munster, WI",
  },
  {
    zip: "53153",
    ST: "WI",
    cityWithStateAbbr: "North Prairie, WI",
  },
  {
    zip: "53154",
    ST: "WI",
    cityWithStateAbbr: "Oak Creek, WI",
  },
  {
    zip: "53156",
    ST: "WI",
    cityWithStateAbbr: "Palmyra, WI",
  },
  {
    zip: "53157",
    ST: "WI",
    cityWithStateAbbr: "Pell Lake, WI",
  },
  {
    zip: "53158",
    ST: "WI",
    cityWithStateAbbr: "Pleasant Prairie, WI",
  },
  {
    zip: "53159",
    ST: "WI",
    cityWithStateAbbr: "Powers Lake, WI",
  },
  {
    zip: "53167",
    ST: "WI",
    cityWithStateAbbr: "Rochester, WI",
  },
  {
    zip: "53168",
    ST: "WI",
    cityWithStateAbbr: "Salem, WI",
  },
  {
    zip: "53170",
    ST: "WI",
    cityWithStateAbbr: "Silver Lake, WI",
  },
  {
    zip: "53171",
    ST: "WI",
    cityWithStateAbbr: "Somers, WI",
  },
  {
    zip: "53172",
    ST: "WI",
    cityWithStateAbbr: "South Milwaukee, WI",
  },
  {
    zip: "53176",
    ST: "WI",
    cityWithStateAbbr: "Springfield, WI",
  },
  {
    zip: "53177",
    ST: "WI",
    cityWithStateAbbr: "Sturtevant, WI",
  },
  {
    zip: "53178",
    ST: "WI",
    cityWithStateAbbr: "Sullivan, WI",
  },
  {
    zip: "53179",
    ST: "WI",
    cityWithStateAbbr: "Trevor, WI",
  },
  {
    zip: "53181",
    ST: "WI",
    cityWithStateAbbr: "Twin Lakes, WI",
  },
  {
    zip: "53182",
    ST: "WI",
    cityWithStateAbbr: "Union Grove, WI",
  },
  {
    zip: "53183",
    ST: "WI",
    cityWithStateAbbr: "Wales, WI",
  },
  {
    zip: "53184",
    ST: "WI",
    cityWithStateAbbr: "Walworth, WI",
  },
  {
    zip: "53185",
    ST: "WI",
    cityWithStateAbbr: "Waterford, WI",
  },
  {
    zip: "53186",
    ST: "WI",
    cityWithStateAbbr: "Waukesha, WI",
  },
  {
    zip: "53187",
    ST: "WI",
    cityWithStateAbbr: "Waukesha, WI",
  },
  {
    zip: "53188",
    ST: "WI",
    cityWithStateAbbr: "Waukesha, WI",
  },
  {
    zip: "53189",
    ST: "WI",
    cityWithStateAbbr: "Waukesha, WI",
  },
  {
    zip: "53190",
    ST: "WI",
    cityWithStateAbbr: "Whitewater, WI",
  },
  {
    zip: "53191",
    ST: "WI",
    cityWithStateAbbr: "Williams Bay, WI",
  },
  {
    zip: "53192",
    ST: "WI",
    cityWithStateAbbr: "Wilmot, WI",
  },
  {
    zip: "53194",
    ST: "WI",
    cityWithStateAbbr: "Woodworth, WI",
  },
  {
    zip: "53195",
    ST: "WI",
    cityWithStateAbbr: "Zenda, WI",
  },
  {
    zip: "53201",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53202",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53203",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53204",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53205",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53206",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53207",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53208",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53209",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53210",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53211",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53212",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53213",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53214",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53215",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53216",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53217",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53218",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53219",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53220",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53221",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53222",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53223",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53224",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53225",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53226",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53227",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53228",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53233",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53234",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53235",
    ST: "WI",
    cityWithStateAbbr: "Saint Francis, WI",
  },
  {
    zip: "53237",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53259",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53263",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53267",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53268",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53274",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53278",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53288",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53290",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53293",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53295",
    ST: "WI",
    cityWithStateAbbr: "Milwaukee, WI",
  },
  {
    zip: "53401",
    ST: "WI",
    cityWithStateAbbr: "Racine, WI",
  },
  {
    zip: "53402",
    ST: "WI",
    cityWithStateAbbr: "Racine, WI",
  },
  {
    zip: "53403",
    ST: "WI",
    cityWithStateAbbr: "Racine, WI",
  },
  {
    zip: "53404",
    ST: "WI",
    cityWithStateAbbr: "Racine, WI",
  },
  {
    zip: "53405",
    ST: "WI",
    cityWithStateAbbr: "Racine, WI",
  },
  {
    zip: "53406",
    ST: "WI",
    cityWithStateAbbr: "Racine, WI",
  },
  {
    zip: "53407",
    ST: "WI",
    cityWithStateAbbr: "Racine, WI",
  },
  {
    zip: "53408",
    ST: "WI",
    cityWithStateAbbr: "Racine, WI",
  },
  {
    zip: "53501",
    ST: "WI",
    cityWithStateAbbr: "Afton, WI",
  },
  {
    zip: "53502",
    ST: "WI",
    cityWithStateAbbr: "Albany, WI",
  },
  {
    zip: "53503",
    ST: "WI",
    cityWithStateAbbr: "Arena, WI",
  },
  {
    zip: "53504",
    ST: "WI",
    cityWithStateAbbr: "Argyle, WI",
  },
  {
    zip: "53505",
    ST: "WI",
    cityWithStateAbbr: "Avalon, WI",
  },
  {
    zip: "53506",
    ST: "WI",
    cityWithStateAbbr: "Avoca, WI",
  },
  {
    zip: "53507",
    ST: "WI",
    cityWithStateAbbr: "Barneveld, WI",
  },
  {
    zip: "53508",
    ST: "WI",
    cityWithStateAbbr: "Belleville, WI",
  },
  {
    zip: "53510",
    ST: "WI",
    cityWithStateAbbr: "Belmont, WI",
  },
  {
    zip: "53511",
    ST: "WI",
    cityWithStateAbbr: "Beloit, WI",
  },
  {
    zip: "53512",
    ST: "WI",
    cityWithStateAbbr: "Beloit, WI",
  },
  {
    zip: "53515",
    ST: "WI",
    cityWithStateAbbr: "Black Earth, WI",
  },
  {
    zip: "53516",
    ST: "WI",
    cityWithStateAbbr: "Blanchardville, WI",
  },
  {
    zip: "53517",
    ST: "WI",
    cityWithStateAbbr: "Blue Mounds, WI",
  },
  {
    zip: "53518",
    ST: "WI",
    cityWithStateAbbr: "Blue River, WI",
  },
  {
    zip: "53520",
    ST: "WI",
    cityWithStateAbbr: "Brodhead, WI",
  },
  {
    zip: "53521",
    ST: "WI",
    cityWithStateAbbr: "Brooklyn, WI",
  },
  {
    zip: "53522",
    ST: "WI",
    cityWithStateAbbr: "Browntown, WI",
  },
  {
    zip: "53523",
    ST: "WI",
    cityWithStateAbbr: "Cambridge, WI",
  },
  {
    zip: "53525",
    ST: "WI",
    cityWithStateAbbr: "Clinton, WI",
  },
  {
    zip: "53526",
    ST: "WI",
    cityWithStateAbbr: "Cobb, WI",
  },
  {
    zip: "53527",
    ST: "WI",
    cityWithStateAbbr: "Cottage Grove, WI",
  },
  {
    zip: "53528",
    ST: "WI",
    cityWithStateAbbr: "Cross Plains, WI",
  },
  {
    zip: "53529",
    ST: "WI",
    cityWithStateAbbr: "Dane, WI",
  },
  {
    zip: "53530",
    ST: "WI",
    cityWithStateAbbr: "Darlington, WI",
  },
  {
    zip: "53531",
    ST: "WI",
    cityWithStateAbbr: "Deerfield, WI",
  },
  {
    zip: "53532",
    ST: "WI",
    cityWithStateAbbr: "De Forest, WI",
  },
  {
    zip: "53533",
    ST: "WI",
    cityWithStateAbbr: "Dodgeville, WI",
  },
  {
    zip: "53534",
    ST: "WI",
    cityWithStateAbbr: "Edgerton, WI",
  },
  {
    zip: "53535",
    ST: "WI",
    cityWithStateAbbr: "Edmund, WI",
  },
  {
    zip: "53536",
    ST: "WI",
    cityWithStateAbbr: "Evansville, WI",
  },
  {
    zip: "53537",
    ST: "WI",
    cityWithStateAbbr: "Footville, WI",
  },
  {
    zip: "53538",
    ST: "WI",
    cityWithStateAbbr: "Fort Atkinson, WI",
  },
  {
    zip: "53540",
    ST: "WI",
    cityWithStateAbbr: "Gotham, WI",
  },
  {
    zip: "53541",
    ST: "WI",
    cityWithStateAbbr: "Gratiot, WI",
  },
  {
    zip: "53542",
    ST: "WI",
    cityWithStateAbbr: "Hanover, WI",
  },
  {
    zip: "53543",
    ST: "WI",
    cityWithStateAbbr: "Highland, WI",
  },
  {
    zip: "53544",
    ST: "WI",
    cityWithStateAbbr: "Hollandale, WI",
  },
  {
    zip: "53545",
    ST: "WI",
    cityWithStateAbbr: "Janesville, WI",
  },
  {
    zip: "53546",
    ST: "WI",
    cityWithStateAbbr: "Janesville, WI",
  },
  {
    zip: "53547",
    ST: "WI",
    cityWithStateAbbr: "Janesville, WI",
  },
  {
    zip: "53548",
    ST: "WI",
    cityWithStateAbbr: "Janesville, WI",
  },
  {
    zip: "53549",
    ST: "WI",
    cityWithStateAbbr: "Jefferson, WI",
  },
  {
    zip: "53550",
    ST: "WI",
    cityWithStateAbbr: "Juda, WI",
  },
  {
    zip: "53551",
    ST: "WI",
    cityWithStateAbbr: "Lake Mills, WI",
  },
  {
    zip: "53553",
    ST: "WI",
    cityWithStateAbbr: "Linden, WI",
  },
  {
    zip: "53554",
    ST: "WI",
    cityWithStateAbbr: "Livingston, WI",
  },
  {
    zip: "53555",
    ST: "WI",
    cityWithStateAbbr: "Lodi, WI",
  },
  {
    zip: "53556",
    ST: "WI",
    cityWithStateAbbr: "Lone Rock, WI",
  },
  {
    zip: "53557",
    ST: "WI",
    cityWithStateAbbr: "Lowell, WI",
  },
  {
    zip: "53558",
    ST: "WI",
    cityWithStateAbbr: "Mc Farland, WI",
  },
  {
    zip: "53559",
    ST: "WI",
    cityWithStateAbbr: "Marshall, WI",
  },
  {
    zip: "53560",
    ST: "WI",
    cityWithStateAbbr: "Mazomanie, WI",
  },
  {
    zip: "53561",
    ST: "WI",
    cityWithStateAbbr: "Merrimac, WI",
  },
  {
    zip: "53562",
    ST: "WI",
    cityWithStateAbbr: "Middleton, WI",
  },
  {
    zip: "53563",
    ST: "WI",
    cityWithStateAbbr: "Milton, WI",
  },
  {
    zip: "53565",
    ST: "WI",
    cityWithStateAbbr: "Mineral Point, WI",
  },
  {
    zip: "53566",
    ST: "WI",
    cityWithStateAbbr: "Monroe, WI",
  },
  {
    zip: "53569",
    ST: "WI",
    cityWithStateAbbr: "Montfort, WI",
  },
  {
    zip: "53570",
    ST: "WI",
    cityWithStateAbbr: "Monticello, WI",
  },
  {
    zip: "53571",
    ST: "WI",
    cityWithStateAbbr: "Morrisonville, WI",
  },
  {
    zip: "53572",
    ST: "WI",
    cityWithStateAbbr: "Mount Horeb, WI",
  },
  {
    zip: "53573",
    ST: "WI",
    cityWithStateAbbr: "Muscoda, WI",
  },
  {
    zip: "53574",
    ST: "WI",
    cityWithStateAbbr: "New Glarus, WI",
  },
  {
    zip: "53575",
    ST: "WI",
    cityWithStateAbbr: "Oregon, WI",
  },
  {
    zip: "53576",
    ST: "WI",
    cityWithStateAbbr: "Orfordville, WI",
  },
  {
    zip: "53577",
    ST: "WI",
    cityWithStateAbbr: "Plain, WI",
  },
  {
    zip: "53578",
    ST: "WI",
    cityWithStateAbbr: "Prairie Du Sac, WI",
  },
  {
    zip: "53579",
    ST: "WI",
    cityWithStateAbbr: "Reeseville, WI",
  },
  {
    zip: "53580",
    ST: "WI",
    cityWithStateAbbr: "Rewey, WI",
  },
  {
    zip: "53581",
    ST: "WI",
    cityWithStateAbbr: "Richland Center, WI",
  },
  {
    zip: "53582",
    ST: "WI",
    cityWithStateAbbr: "Ridgeway, WI",
  },
  {
    zip: "53583",
    ST: "WI",
    cityWithStateAbbr: "Sauk City, WI",
  },
  {
    zip: "53584",
    ST: "WI",
    cityWithStateAbbr: "Sextonville, WI",
  },
  {
    zip: "53585",
    ST: "WI",
    cityWithStateAbbr: "Sharon, WI",
  },
  {
    zip: "53586",
    ST: "WI",
    cityWithStateAbbr: "Shullsburg, WI",
  },
  {
    zip: "53587",
    ST: "WI",
    cityWithStateAbbr: "South Wayne, WI",
  },
  {
    zip: "53588",
    ST: "WI",
    cityWithStateAbbr: "Spring Green, WI",
  },
  {
    zip: "53589",
    ST: "WI",
    cityWithStateAbbr: "Stoughton, WI",
  },
  {
    zip: "53590",
    ST: "WI",
    cityWithStateAbbr: "Sun Prairie, WI",
  },
  {
    zip: "53593",
    ST: "WI",
    cityWithStateAbbr: "Verona, WI",
  },
  {
    zip: "53594",
    ST: "WI",
    cityWithStateAbbr: "Waterloo, WI",
  },
  {
    zip: "53595",
    ST: "WI",
    cityWithStateAbbr: "Dodgeville, WI",
  },
  {
    zip: "53596",
    ST: "WI",
    cityWithStateAbbr: "Sun Prairie, WI",
  },
  {
    zip: "53597",
    ST: "WI",
    cityWithStateAbbr: "Waunakee, WI",
  },
  {
    zip: "53598",
    ST: "WI",
    cityWithStateAbbr: "Windsor, WI",
  },
  {
    zip: "53599",
    ST: "WI",
    cityWithStateAbbr: "Woodford, WI",
  },
  {
    zip: "53701",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53702",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53703",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53704",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53705",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53706",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53707",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53708",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53711",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53713",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53714",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53715",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53716",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53717",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53718",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53719",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53725",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53726",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53744",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53774",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53777",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53778",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53779",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53782",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53783",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53784",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53785",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53786",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53788",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53789",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53790",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53791",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53792",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53793",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53794",
    ST: "WI",
    cityWithStateAbbr: "Madison, WI",
  },
  {
    zip: "53801",
    ST: "WI",
    cityWithStateAbbr: "Bagley, WI",
  },
  {
    zip: "53802",
    ST: "WI",
    cityWithStateAbbr: "Beetown, WI",
  },
  {
    zip: "53803",
    ST: "WI",
    cityWithStateAbbr: "Benton, WI",
  },
  {
    zip: "53804",
    ST: "WI",
    cityWithStateAbbr: "Bloomington, WI",
  },
  {
    zip: "53805",
    ST: "WI",
    cityWithStateAbbr: "Boscobel, WI",
  },
  {
    zip: "53806",
    ST: "WI",
    cityWithStateAbbr: "Cassville, WI",
  },
  {
    zip: "53807",
    ST: "WI",
    cityWithStateAbbr: "Cuba City, WI",
  },
  {
    zip: "53808",
    ST: "WI",
    cityWithStateAbbr: "Dickeyville, WI",
  },
  {
    zip: "53809",
    ST: "WI",
    cityWithStateAbbr: "Fennimore, WI",
  },
  {
    zip: "53810",
    ST: "WI",
    cityWithStateAbbr: "Glen Haven, WI",
  },
  {
    zip: "53811",
    ST: "WI",
    cityWithStateAbbr: "Hazel Green, WI",
  },
  {
    zip: "53812",
    ST: "WI",
    cityWithStateAbbr: "Kieler, WI",
  },
  {
    zip: "53813",
    ST: "WI",
    cityWithStateAbbr: "Lancaster, WI",
  },
  {
    zip: "53816",
    ST: "WI",
    cityWithStateAbbr: "Mount Hope, WI",
  },
  {
    zip: "53817",
    ST: "WI",
    cityWithStateAbbr: "Patch Grove, WI",
  },
  {
    zip: "53818",
    ST: "WI",
    cityWithStateAbbr: "Platteville, WI",
  },
  {
    zip: "53820",
    ST: "WI",
    cityWithStateAbbr: "Potosi, WI",
  },
  {
    zip: "53821",
    ST: "WI",
    cityWithStateAbbr: "Prairie Du Chien, WI",
  },
  {
    zip: "53824",
    ST: "WI",
    cityWithStateAbbr: "Sinsinawa, WI",
  },
  {
    zip: "53825",
    ST: "WI",
    cityWithStateAbbr: "Stitzer, WI",
  },
  {
    zip: "53826",
    ST: "WI",
    cityWithStateAbbr: "Wauzeka, WI",
  },
  {
    zip: "53827",
    ST: "WI",
    cityWithStateAbbr: "Woodman, WI",
  },
  {
    zip: "53901",
    ST: "WI",
    cityWithStateAbbr: "Portage, WI",
  },
  {
    zip: "53910",
    ST: "WI",
    cityWithStateAbbr: "Adams, WI",
  },
  {
    zip: "53911",
    ST: "WI",
    cityWithStateAbbr: "Arlington, WI",
  },
  {
    zip: "53913",
    ST: "WI",
    cityWithStateAbbr: "Baraboo, WI",
  },
  {
    zip: "53916",
    ST: "WI",
    cityWithStateAbbr: "Beaver Dam, WI",
  },
  {
    zip: "53919",
    ST: "WI",
    cityWithStateAbbr: "Brandon, WI",
  },
  {
    zip: "53920",
    ST: "WI",
    cityWithStateAbbr: "Briggsville, WI",
  },
  {
    zip: "53922",
    ST: "WI",
    cityWithStateAbbr: "Burnett, WI",
  },
  {
    zip: "53923",
    ST: "WI",
    cityWithStateAbbr: "Cambria, WI",
  },
  {
    zip: "53924",
    ST: "WI",
    cityWithStateAbbr: "Cazenovia, WI",
  },
  {
    zip: "53925",
    ST: "WI",
    cityWithStateAbbr: "Columbus, WI",
  },
  {
    zip: "53926",
    ST: "WI",
    cityWithStateAbbr: "Dalton, WI",
  },
  {
    zip: "53927",
    ST: "WI",
    cityWithStateAbbr: "Dellwood, WI",
  },
  {
    zip: "53928",
    ST: "WI",
    cityWithStateAbbr: "Doylestown, WI",
  },
  {
    zip: "53929",
    ST: "WI",
    cityWithStateAbbr: "Elroy, WI",
  },
  {
    zip: "53930",
    ST: "WI",
    cityWithStateAbbr: "Endeavor, WI",
  },
  {
    zip: "53931",
    ST: "WI",
    cityWithStateAbbr: "Fairwater, WI",
  },
  {
    zip: "53932",
    ST: "WI",
    cityWithStateAbbr: "Fall River, WI",
  },
  {
    zip: "53933",
    ST: "WI",
    cityWithStateAbbr: "Fox Lake, WI",
  },
  {
    zip: "53934",
    ST: "WI",
    cityWithStateAbbr: "Friendship, WI",
  },
  {
    zip: "53935",
    ST: "WI",
    cityWithStateAbbr: "Friesland, WI",
  },
  {
    zip: "53936",
    ST: "WI",
    cityWithStateAbbr: "Grand Marsh, WI",
  },
  {
    zip: "53937",
    ST: "WI",
    cityWithStateAbbr: "Hillpoint, WI",
  },
  {
    zip: "53939",
    ST: "WI",
    cityWithStateAbbr: "Kingston, WI",
  },
  {
    zip: "53940",
    ST: "WI",
    cityWithStateAbbr: "Lake Delton, WI",
  },
  {
    zip: "53941",
    ST: "WI",
    cityWithStateAbbr: "La Valle, WI",
  },
  {
    zip: "53942",
    ST: "WI",
    cityWithStateAbbr: "Lime Ridge, WI",
  },
  {
    zip: "53943",
    ST: "WI",
    cityWithStateAbbr: "Loganville, WI",
  },
  {
    zip: "53944",
    ST: "WI",
    cityWithStateAbbr: "Lyndon Station, WI",
  },
  {
    zip: "53946",
    ST: "WI",
    cityWithStateAbbr: "Markesan, WI",
  },
  {
    zip: "53947",
    ST: "WI",
    cityWithStateAbbr: "Marquette, WI",
  },
  {
    zip: "53948",
    ST: "WI",
    cityWithStateAbbr: "Mauston, WI",
  },
  {
    zip: "53949",
    ST: "WI",
    cityWithStateAbbr: "Montello, WI",
  },
  {
    zip: "53950",
    ST: "WI",
    cityWithStateAbbr: "New Lisbon, WI",
  },
  {
    zip: "53951",
    ST: "WI",
    cityWithStateAbbr: "North Freedom, WI",
  },
  {
    zip: "53952",
    ST: "WI",
    cityWithStateAbbr: "Oxford, WI",
  },
  {
    zip: "53953",
    ST: "WI",
    cityWithStateAbbr: "Packwaukee, WI",
  },
  {
    zip: "53954",
    ST: "WI",
    cityWithStateAbbr: "Pardeeville, WI",
  },
  {
    zip: "53955",
    ST: "WI",
    cityWithStateAbbr: "Poynette, WI",
  },
  {
    zip: "53956",
    ST: "WI",
    cityWithStateAbbr: "Randolph, WI",
  },
  {
    zip: "53957",
    ST: "WI",
    cityWithStateAbbr: "Randolph, WI",
  },
  {
    zip: "53958",
    ST: "WI",
    cityWithStateAbbr: "Reedsburg, WI",
  },
  {
    zip: "53959",
    ST: "WI",
    cityWithStateAbbr: "Reedsburg, WI",
  },
  {
    zip: "53960",
    ST: "WI",
    cityWithStateAbbr: "Rio, WI",
  },
  {
    zip: "53961",
    ST: "WI",
    cityWithStateAbbr: "Rock Springs, WI",
  },
  {
    zip: "53962",
    ST: "WI",
    cityWithStateAbbr: "Union Center, WI",
  },
  {
    zip: "53963",
    ST: "WI",
    cityWithStateAbbr: "Waupun, WI",
  },
  {
    zip: "53964",
    ST: "WI",
    cityWithStateAbbr: "Westfield, WI",
  },
  {
    zip: "53965",
    ST: "WI",
    cityWithStateAbbr: "Wisconsin Dells, WI",
  },
  {
    zip: "53968",
    ST: "WI",
    cityWithStateAbbr: "Wonewoc, WI",
  },
  {
    zip: "53969",
    ST: "WI",
    cityWithStateAbbr: "Wyocena, WI",
  },
  {
    zip: "54001",
    ST: "WI",
    cityWithStateAbbr: "Amery, WI",
  },
  {
    zip: "54002",
    ST: "WI",
    cityWithStateAbbr: "Baldwin, WI",
  },
  {
    zip: "54003",
    ST: "WI",
    cityWithStateAbbr: "Beldenville, WI",
  },
  {
    zip: "54004",
    ST: "WI",
    cityWithStateAbbr: "Clayton, WI",
  },
  {
    zip: "54005",
    ST: "WI",
    cityWithStateAbbr: "Clear Lake, WI",
  },
  {
    zip: "54006",
    ST: "WI",
    cityWithStateAbbr: "Cushing, WI",
  },
  {
    zip: "54007",
    ST: "WI",
    cityWithStateAbbr: "Deer Park, WI",
  },
  {
    zip: "54009",
    ST: "WI",
    cityWithStateAbbr: "Dresser, WI",
  },
  {
    zip: "54010",
    ST: "WI",
    cityWithStateAbbr: "East Ellsworth, WI",
  },
  {
    zip: "54011",
    ST: "WI",
    cityWithStateAbbr: "Ellsworth, WI",
  },
  {
    zip: "54013",
    ST: "WI",
    cityWithStateAbbr: "Glenwood City, WI",
  },
  {
    zip: "54014",
    ST: "WI",
    cityWithStateAbbr: "Hager City, WI",
  },
  {
    zip: "54015",
    ST: "WI",
    cityWithStateAbbr: "Hammond, WI",
  },
  {
    zip: "54016",
    ST: "WI",
    cityWithStateAbbr: "Hudson, WI",
  },
  {
    zip: "54017",
    ST: "WI",
    cityWithStateAbbr: "New Richmond, WI",
  },
  {
    zip: "54020",
    ST: "WI",
    cityWithStateAbbr: "Osceola, WI",
  },
  {
    zip: "54021",
    ST: "WI",
    cityWithStateAbbr: "Prescott, WI",
  },
  {
    zip: "54022",
    ST: "WI",
    cityWithStateAbbr: "River Falls, WI",
  },
  {
    zip: "54023",
    ST: "WI",
    cityWithStateAbbr: "Roberts, WI",
  },
  {
    zip: "54024",
    ST: "WI",
    cityWithStateAbbr: "Saint Croix Falls, WI",
  },
  {
    zip: "54025",
    ST: "WI",
    cityWithStateAbbr: "Somerset, WI",
  },
  {
    zip: "54026",
    ST: "WI",
    cityWithStateAbbr: "Star Prairie, WI",
  },
  {
    zip: "54027",
    ST: "WI",
    cityWithStateAbbr: "Wilson, WI",
  },
  {
    zip: "54028",
    ST: "WI",
    cityWithStateAbbr: "Woodville, WI",
  },
  {
    zip: "54082",
    ST: "WI",
    cityWithStateAbbr: "Houlton, WI",
  },
  {
    zip: "54101",
    ST: "WI",
    cityWithStateAbbr: "Abrams, WI",
  },
  {
    zip: "54102",
    ST: "WI",
    cityWithStateAbbr: "Amberg, WI",
  },
  {
    zip: "54103",
    ST: "WI",
    cityWithStateAbbr: "Armstrong Creek, WI",
  },
  {
    zip: "54104",
    ST: "WI",
    cityWithStateAbbr: "Athelstane, WI",
  },
  {
    zip: "54106",
    ST: "WI",
    cityWithStateAbbr: "Black Creek, WI",
  },
  {
    zip: "54107",
    ST: "WI",
    cityWithStateAbbr: "Bonduel, WI",
  },
  {
    zip: "54110",
    ST: "WI",
    cityWithStateAbbr: "Brillion, WI",
  },
  {
    zip: "54111",
    ST: "WI",
    cityWithStateAbbr: "Cecil, WI",
  },
  {
    zip: "54112",
    ST: "WI",
    cityWithStateAbbr: "Coleman, WI",
  },
  {
    zip: "54113",
    ST: "WI",
    cityWithStateAbbr: "Combined Locks, WI",
  },
  {
    zip: "54114",
    ST: "WI",
    cityWithStateAbbr: "Crivitz, WI",
  },
  {
    zip: "54115",
    ST: "WI",
    cityWithStateAbbr: "De Pere, WI",
  },
  {
    zip: "54119",
    ST: "WI",
    cityWithStateAbbr: "Dunbar, WI",
  },
  {
    zip: "54120",
    ST: "WI",
    cityWithStateAbbr: "Fence, WI",
  },
  {
    zip: "54121",
    ST: "WI",
    cityWithStateAbbr: "Florence, WI",
  },
  {
    zip: "54123",
    ST: "WI",
    cityWithStateAbbr: "Forest Junction, WI",
  },
  {
    zip: "54124",
    ST: "WI",
    cityWithStateAbbr: "Gillett, WI",
  },
  {
    zip: "54125",
    ST: "WI",
    cityWithStateAbbr: "Goodman, WI",
  },
  {
    zip: "54126",
    ST: "WI",
    cityWithStateAbbr: "Greenleaf, WI",
  },
  {
    zip: "54127",
    ST: "WI",
    cityWithStateAbbr: "Green Valley, WI",
  },
  {
    zip: "54128",
    ST: "WI",
    cityWithStateAbbr: "Gresham, WI",
  },
  {
    zip: "54129",
    ST: "WI",
    cityWithStateAbbr: "Hilbert, WI",
  },
  {
    zip: "54130",
    ST: "WI",
    cityWithStateAbbr: "Kaukauna, WI",
  },
  {
    zip: "54131",
    ST: "WI",
    cityWithStateAbbr: "Freedom, WI",
  },
  {
    zip: "54135",
    ST: "WI",
    cityWithStateAbbr: "Keshena, WI",
  },
  {
    zip: "54136",
    ST: "WI",
    cityWithStateAbbr: "Kimberly, WI",
  },
  {
    zip: "54137",
    ST: "WI",
    cityWithStateAbbr: "Krakow, WI",
  },
  {
    zip: "54138",
    ST: "WI",
    cityWithStateAbbr: "Lakewood, WI",
  },
  {
    zip: "54139",
    ST: "WI",
    cityWithStateAbbr: "Lena, WI",
  },
  {
    zip: "54140",
    ST: "WI",
    cityWithStateAbbr: "Little Chute, WI",
  },
  {
    zip: "54141",
    ST: "WI",
    cityWithStateAbbr: "Little Suamico, WI",
  },
  {
    zip: "54143",
    ST: "WI",
    cityWithStateAbbr: "Marinette, WI",
  },
  {
    zip: "54149",
    ST: "WI",
    cityWithStateAbbr: "Mountain, WI",
  },
  {
    zip: "54150",
    ST: "WI",
    cityWithStateAbbr: "Neopit, WI",
  },
  {
    zip: "54151",
    ST: "WI",
    cityWithStateAbbr: "Niagara, WI",
  },
  {
    zip: "54152",
    ST: "WI",
    cityWithStateAbbr: "Nichols, WI",
  },
  {
    zip: "54153",
    ST: "WI",
    cityWithStateAbbr: "Oconto, WI",
  },
  {
    zip: "54154",
    ST: "WI",
    cityWithStateAbbr: "Oconto Falls, WI",
  },
  {
    zip: "54155",
    ST: "WI",
    cityWithStateAbbr: "Oneida, WI",
  },
  {
    zip: "54156",
    ST: "WI",
    cityWithStateAbbr: "Pembine, WI",
  },
  {
    zip: "54157",
    ST: "WI",
    cityWithStateAbbr: "Peshtigo, WI",
  },
  {
    zip: "54159",
    ST: "WI",
    cityWithStateAbbr: "Porterfield, WI",
  },
  {
    zip: "54160",
    ST: "WI",
    cityWithStateAbbr: "Potter, WI",
  },
  {
    zip: "54161",
    ST: "WI",
    cityWithStateAbbr: "Pound, WI",
  },
  {
    zip: "54162",
    ST: "WI",
    cityWithStateAbbr: "Pulaski, WI",
  },
  {
    zip: "54165",
    ST: "WI",
    cityWithStateAbbr: "Seymour, WI",
  },
  {
    zip: "54166",
    ST: "WI",
    cityWithStateAbbr: "Shawano, WI",
  },
  {
    zip: "54169",
    ST: "WI",
    cityWithStateAbbr: "Sherwood, WI",
  },
  {
    zip: "54170",
    ST: "WI",
    cityWithStateAbbr: "Shiocton, WI",
  },
  {
    zip: "54171",
    ST: "WI",
    cityWithStateAbbr: "Sobieski, WI",
  },
  {
    zip: "54173",
    ST: "WI",
    cityWithStateAbbr: "Suamico, WI",
  },
  {
    zip: "54174",
    ST: "WI",
    cityWithStateAbbr: "Suring, WI",
  },
  {
    zip: "54175",
    ST: "WI",
    cityWithStateAbbr: "Townsend, WI",
  },
  {
    zip: "54177",
    ST: "WI",
    cityWithStateAbbr: "Wausaukee, WI",
  },
  {
    zip: "54180",
    ST: "WI",
    cityWithStateAbbr: "Wrightstown, WI",
  },
  {
    zip: "54182",
    ST: "WI",
    cityWithStateAbbr: "Zachow, WI",
  },
  {
    zip: "54201",
    ST: "WI",
    cityWithStateAbbr: "Algoma, WI",
  },
  {
    zip: "54202",
    ST: "WI",
    cityWithStateAbbr: "Baileys Harbor, WI",
  },
  {
    zip: "54204",
    ST: "WI",
    cityWithStateAbbr: "Brussels, WI",
  },
  {
    zip: "54205",
    ST: "WI",
    cityWithStateAbbr: "Casco, WI",
  },
  {
    zip: "54207",
    ST: "WI",
    cityWithStateAbbr: "Collins, WI",
  },
  {
    zip: "54208",
    ST: "WI",
    cityWithStateAbbr: "Denmark, WI",
  },
  {
    zip: "54209",
    ST: "WI",
    cityWithStateAbbr: "Egg Harbor, WI",
  },
  {
    zip: "54210",
    ST: "WI",
    cityWithStateAbbr: "Ellison Bay, WI",
  },
  {
    zip: "54211",
    ST: "WI",
    cityWithStateAbbr: "Ephraim, WI",
  },
  {
    zip: "54212",
    ST: "WI",
    cityWithStateAbbr: "Fish Creek, WI",
  },
  {
    zip: "54213",
    ST: "WI",
    cityWithStateAbbr: "Forestville, WI",
  },
  {
    zip: "54214",
    ST: "WI",
    cityWithStateAbbr: "Francis Creek, WI",
  },
  {
    zip: "54215",
    ST: "WI",
    cityWithStateAbbr: "Kellnersville, WI",
  },
  {
    zip: "54216",
    ST: "WI",
    cityWithStateAbbr: "Kewaunee, WI",
  },
  {
    zip: "54217",
    ST: "WI",
    cityWithStateAbbr: "Luxemburg, WI",
  },
  {
    zip: "54220",
    ST: "WI",
    cityWithStateAbbr: "Manitowoc, WI",
  },
  {
    zip: "54221",
    ST: "WI",
    cityWithStateAbbr: "Manitowoc, WI",
  },
  {
    zip: "54226",
    ST: "WI",
    cityWithStateAbbr: "Maplewood, WI",
  },
  {
    zip: "54227",
    ST: "WI",
    cityWithStateAbbr: "Maribel, WI",
  },
  {
    zip: "54228",
    ST: "WI",
    cityWithStateAbbr: "Mishicot, WI",
  },
  {
    zip: "54229",
    ST: "WI",
    cityWithStateAbbr: "New Franken, WI",
  },
  {
    zip: "54230",
    ST: "WI",
    cityWithStateAbbr: "Reedsville, WI",
  },
  {
    zip: "54232",
    ST: "WI",
    cityWithStateAbbr: "Saint Nazianz, WI",
  },
  {
    zip: "54234",
    ST: "WI",
    cityWithStateAbbr: "Sister Bay, WI",
  },
  {
    zip: "54235",
    ST: "WI",
    cityWithStateAbbr: "Sturgeon Bay, WI",
  },
  {
    zip: "54240",
    ST: "WI",
    cityWithStateAbbr: "Tisch Mills, WI",
  },
  {
    zip: "54241",
    ST: "WI",
    cityWithStateAbbr: "Two Rivers, WI",
  },
  {
    zip: "54245",
    ST: "WI",
    cityWithStateAbbr: "Valders, WI",
  },
  {
    zip: "54246",
    ST: "WI",
    cityWithStateAbbr: "Washington Island, WI",
  },
  {
    zip: "54247",
    ST: "WI",
    cityWithStateAbbr: "Whitelaw, WI",
  },
  {
    zip: "54301",
    ST: "WI",
    cityWithStateAbbr: "Green Bay, WI",
  },
  {
    zip: "54302",
    ST: "WI",
    cityWithStateAbbr: "Green Bay, WI",
  },
  {
    zip: "54303",
    ST: "WI",
    cityWithStateAbbr: "Green Bay, WI",
  },
  {
    zip: "54304",
    ST: "WI",
    cityWithStateAbbr: "Green Bay, WI",
  },
  {
    zip: "54305",
    ST: "WI",
    cityWithStateAbbr: "Green Bay, WI",
  },
  {
    zip: "54306",
    ST: "WI",
    cityWithStateAbbr: "Green Bay, WI",
  },
  {
    zip: "54307",
    ST: "WI",
    cityWithStateAbbr: "Green Bay, WI",
  },
  {
    zip: "54308",
    ST: "WI",
    cityWithStateAbbr: "Green Bay, WI",
  },
  {
    zip: "54311",
    ST: "WI",
    cityWithStateAbbr: "Green Bay, WI",
  },
  {
    zip: "54313",
    ST: "WI",
    cityWithStateAbbr: "Green Bay, WI",
  },
  {
    zip: "54324",
    ST: "WI",
    cityWithStateAbbr: "Green Bay, WI",
  },
  {
    zip: "54344",
    ST: "WI",
    cityWithStateAbbr: "Green Bay, WI",
  },
  {
    zip: "54401",
    ST: "WI",
    cityWithStateAbbr: "Wausau, WI",
  },
  {
    zip: "54402",
    ST: "WI",
    cityWithStateAbbr: "Wausau, WI",
  },
  {
    zip: "54403",
    ST: "WI",
    cityWithStateAbbr: "Wausau, WI",
  },
  {
    zip: "54404",
    ST: "WI",
    cityWithStateAbbr: "Marshfield, WI",
  },
  {
    zip: "54405",
    ST: "WI",
    cityWithStateAbbr: "Abbotsford, WI",
  },
  {
    zip: "54406",
    ST: "WI",
    cityWithStateAbbr: "Amherst, WI",
  },
  {
    zip: "54407",
    ST: "WI",
    cityWithStateAbbr: "Amherst Junction, WI",
  },
  {
    zip: "54408",
    ST: "WI",
    cityWithStateAbbr: "Aniwa, WI",
  },
  {
    zip: "54409",
    ST: "WI",
    cityWithStateAbbr: "Antigo, WI",
  },
  {
    zip: "54410",
    ST: "WI",
    cityWithStateAbbr: "Arpin, WI",
  },
  {
    zip: "54411",
    ST: "WI",
    cityWithStateAbbr: "Athens, WI",
  },
  {
    zip: "54412",
    ST: "WI",
    cityWithStateAbbr: "Auburndale, WI",
  },
  {
    zip: "54413",
    ST: "WI",
    cityWithStateAbbr: "Babcock, WI",
  },
  {
    zip: "54414",
    ST: "WI",
    cityWithStateAbbr: "Birnamwood, WI",
  },
  {
    zip: "54415",
    ST: "WI",
    cityWithStateAbbr: "Blenker, WI",
  },
  {
    zip: "54416",
    ST: "WI",
    cityWithStateAbbr: "Bowler, WI",
  },
  {
    zip: "54417",
    ST: "WI",
    cityWithStateAbbr: "Brokaw, WI",
  },
  {
    zip: "54418",
    ST: "WI",
    cityWithStateAbbr: "Bryant, WI",
  },
  {
    zip: "54420",
    ST: "WI",
    cityWithStateAbbr: "Chili, WI",
  },
  {
    zip: "54421",
    ST: "WI",
    cityWithStateAbbr: "Colby, WI",
  },
  {
    zip: "54422",
    ST: "WI",
    cityWithStateAbbr: "Curtiss, WI",
  },
  {
    zip: "54423",
    ST: "WI",
    cityWithStateAbbr: "Custer, WI",
  },
  {
    zip: "54424",
    ST: "WI",
    cityWithStateAbbr: "Deerbrook, WI",
  },
  {
    zip: "54425",
    ST: "WI",
    cityWithStateAbbr: "Dorchester, WI",
  },
  {
    zip: "54426",
    ST: "WI",
    cityWithStateAbbr: "Edgar, WI",
  },
  {
    zip: "54427",
    ST: "WI",
    cityWithStateAbbr: "Eland, WI",
  },
  {
    zip: "54428",
    ST: "WI",
    cityWithStateAbbr: "Elcho, WI",
  },
  {
    zip: "54429",
    ST: "WI",
    cityWithStateAbbr: "Elderon, WI",
  },
  {
    zip: "54430",
    ST: "WI",
    cityWithStateAbbr: "Elton, WI",
  },
  {
    zip: "54432",
    ST: "WI",
    cityWithStateAbbr: "Galloway, WI",
  },
  {
    zip: "54433",
    ST: "WI",
    cityWithStateAbbr: "Gilman, WI",
  },
  {
    zip: "54434",
    ST: "WI",
    cityWithStateAbbr: "Jump River, WI",
  },
  {
    zip: "54435",
    ST: "WI",
    cityWithStateAbbr: "Gleason, WI",
  },
  {
    zip: "54436",
    ST: "WI",
    cityWithStateAbbr: "Granton, WI",
  },
  {
    zip: "54437",
    ST: "WI",
    cityWithStateAbbr: "Greenwood, WI",
  },
  {
    zip: "54439",
    ST: "WI",
    cityWithStateAbbr: "Hannibal, WI",
  },
  {
    zip: "54440",
    ST: "WI",
    cityWithStateAbbr: "Hatley, WI",
  },
  {
    zip: "54441",
    ST: "WI",
    cityWithStateAbbr: "Hewitt, WI",
  },
  {
    zip: "54442",
    ST: "WI",
    cityWithStateAbbr: "Irma, WI",
  },
  {
    zip: "54443",
    ST: "WI",
    cityWithStateAbbr: "Junction City, WI",
  },
  {
    zip: "54446",
    ST: "WI",
    cityWithStateAbbr: "Loyal, WI",
  },
  {
    zip: "54447",
    ST: "WI",
    cityWithStateAbbr: "Lublin, WI",
  },
  {
    zip: "54448",
    ST: "WI",
    cityWithStateAbbr: "Marathon, WI",
  },
  {
    zip: "54449",
    ST: "WI",
    cityWithStateAbbr: "Marshfield, WI",
  },
  {
    zip: "54450",
    ST: "WI",
    cityWithStateAbbr: "Mattoon, WI",
  },
  {
    zip: "54451",
    ST: "WI",
    cityWithStateAbbr: "Medford, WI",
  },
  {
    zip: "54452",
    ST: "WI",
    cityWithStateAbbr: "Merrill, WI",
  },
  {
    zip: "54454",
    ST: "WI",
    cityWithStateAbbr: "Milladore, WI",
  },
  {
    zip: "54455",
    ST: "WI",
    cityWithStateAbbr: "Mosinee, WI",
  },
  {
    zip: "54456",
    ST: "WI",
    cityWithStateAbbr: "Neillsville, WI",
  },
  {
    zip: "54457",
    ST: "WI",
    cityWithStateAbbr: "Nekoosa, WI",
  },
  {
    zip: "54458",
    ST: "WI",
    cityWithStateAbbr: "Nelsonville, WI",
  },
  {
    zip: "54459",
    ST: "WI",
    cityWithStateAbbr: "Ogema, WI",
  },
  {
    zip: "54460",
    ST: "WI",
    cityWithStateAbbr: "Owen, WI",
  },
  {
    zip: "54462",
    ST: "WI",
    cityWithStateAbbr: "Pearson, WI",
  },
  {
    zip: "54463",
    ST: "WI",
    cityWithStateAbbr: "Pelican Lake, WI",
  },
  {
    zip: "54464",
    ST: "WI",
    cityWithStateAbbr: "Phlox, WI",
  },
  {
    zip: "54465",
    ST: "WI",
    cityWithStateAbbr: "Pickerel, WI",
  },
  {
    zip: "54466",
    ST: "WI",
    cityWithStateAbbr: "Pittsville, WI",
  },
  {
    zip: "54467",
    ST: "WI",
    cityWithStateAbbr: "Plover, WI",
  },
  {
    zip: "54469",
    ST: "WI",
    cityWithStateAbbr: "Port Edwards, WI",
  },
  {
    zip: "54470",
    ST: "WI",
    cityWithStateAbbr: "Rib Lake, WI",
  },
  {
    zip: "54471",
    ST: "WI",
    cityWithStateAbbr: "Ringle, WI",
  },
  {
    zip: "54472",
    ST: "WI",
    cityWithStateAbbr: "Marshfield, WI",
  },
  {
    zip: "54473",
    ST: "WI",
    cityWithStateAbbr: "Rosholt, WI",
  },
  {
    zip: "54474",
    ST: "WI",
    cityWithStateAbbr: "Rothschild, WI",
  },
  {
    zip: "54475",
    ST: "WI",
    cityWithStateAbbr: "Rudolph, WI",
  },
  {
    zip: "54476",
    ST: "WI",
    cityWithStateAbbr: "Schofield, WI",
  },
  {
    zip: "54479",
    ST: "WI",
    cityWithStateAbbr: "Spencer, WI",
  },
  {
    zip: "54480",
    ST: "WI",
    cityWithStateAbbr: "Stetsonville, WI",
  },
  {
    zip: "54481",
    ST: "WI",
    cityWithStateAbbr: "Stevens Point, WI",
  },
  {
    zip: "54482",
    ST: "WI",
    cityWithStateAbbr: "Stevens Point, WI",
  },
  {
    zip: "54484",
    ST: "WI",
    cityWithStateAbbr: "Stratford, WI",
  },
  {
    zip: "54485",
    ST: "WI",
    cityWithStateAbbr: "Summit Lake, WI",
  },
  {
    zip: "54486",
    ST: "WI",
    cityWithStateAbbr: "Tigerton, WI",
  },
  {
    zip: "54487",
    ST: "WI",
    cityWithStateAbbr: "Tomahawk, WI",
  },
  {
    zip: "54488",
    ST: "WI",
    cityWithStateAbbr: "Unity, WI",
  },
  {
    zip: "54489",
    ST: "WI",
    cityWithStateAbbr: "Vesper, WI",
  },
  {
    zip: "54490",
    ST: "WI",
    cityWithStateAbbr: "Westboro, WI",
  },
  {
    zip: "54491",
    ST: "WI",
    cityWithStateAbbr: "White Lake, WI",
  },
  {
    zip: "54492",
    ST: "WI",
    cityWithStateAbbr: "Stevens Point, WI",
  },
  {
    zip: "54493",
    ST: "WI",
    cityWithStateAbbr: "Willard, WI",
  },
  {
    zip: "54494",
    ST: "WI",
    cityWithStateAbbr: "Wisconsin Rapids, WI",
  },
  {
    zip: "54495",
    ST: "WI",
    cityWithStateAbbr: "Wisconsin Rapids, WI",
  },
  {
    zip: "54498",
    ST: "WI",
    cityWithStateAbbr: "Withee, WI",
  },
  {
    zip: "54499",
    ST: "WI",
    cityWithStateAbbr: "Wittenberg, WI",
  },
  {
    zip: "54501",
    ST: "WI",
    cityWithStateAbbr: "Rhinelander, WI",
  },
  {
    zip: "54511",
    ST: "WI",
    cityWithStateAbbr: "Argonne, WI",
  },
  {
    zip: "54512",
    ST: "WI",
    cityWithStateAbbr: "Boulder Junction, WI",
  },
  {
    zip: "54513",
    ST: "WI",
    cityWithStateAbbr: "Brantwood, WI",
  },
  {
    zip: "54514",
    ST: "WI",
    cityWithStateAbbr: "Butternut, WI",
  },
  {
    zip: "54515",
    ST: "WI",
    cityWithStateAbbr: "Catawba, WI",
  },
  {
    zip: "54517",
    ST: "WI",
    cityWithStateAbbr: "Clam Lake, WI",
  },
  {
    zip: "54519",
    ST: "WI",
    cityWithStateAbbr: "Conover, WI",
  },
  {
    zip: "54520",
    ST: "WI",
    cityWithStateAbbr: "Crandon, WI",
  },
  {
    zip: "54521",
    ST: "WI",
    cityWithStateAbbr: "Eagle River, WI",
  },
  {
    zip: "54524",
    ST: "WI",
    cityWithStateAbbr: "Fifield, WI",
  },
  {
    zip: "54525",
    ST: "WI",
    cityWithStateAbbr: "Gile, WI",
  },
  {
    zip: "54526",
    ST: "WI",
    cityWithStateAbbr: "Glen Flora, WI",
  },
  {
    zip: "54527",
    ST: "WI",
    cityWithStateAbbr: "Glidden, WI",
  },
  {
    zip: "54529",
    ST: "WI",
    cityWithStateAbbr: "Harshaw, WI",
  },
  {
    zip: "54530",
    ST: "WI",
    cityWithStateAbbr: "Hawkins, WI",
  },
  {
    zip: "54531",
    ST: "WI",
    cityWithStateAbbr: "Hazelhurst, WI",
  },
  {
    zip: "54532",
    ST: "WI",
    cityWithStateAbbr: "Heafford Junction, WI",
  },
  {
    zip: "54534",
    ST: "WI",
    cityWithStateAbbr: "Hurley, WI",
  },
  {
    zip: "54536",
    ST: "WI",
    cityWithStateAbbr: "Iron Belt, WI",
  },
  {
    zip: "54537",
    ST: "WI",
    cityWithStateAbbr: "Kennan, WI",
  },
  {
    zip: "54538",
    ST: "WI",
    cityWithStateAbbr: "Lac Du Flambeau, WI",
  },
  {
    zip: "54539",
    ST: "WI",
    cityWithStateAbbr: "Lake Tomahawk, WI",
  },
  {
    zip: "54540",
    ST: "WI",
    cityWithStateAbbr: "Land O Lakes, WI",
  },
  {
    zip: "54541",
    ST: "WI",
    cityWithStateAbbr: "Laona, WI",
  },
  {
    zip: "54542",
    ST: "WI",
    cityWithStateAbbr: "Long Lake, WI",
  },
  {
    zip: "54543",
    ST: "WI",
    cityWithStateAbbr: "Mc Naughton, WI",
  },
  {
    zip: "54545",
    ST: "WI",
    cityWithStateAbbr: "Manitowish Waters, WI",
  },
  {
    zip: "54546",
    ST: "WI",
    cityWithStateAbbr: "Mellen, WI",
  },
  {
    zip: "54547",
    ST: "WI",
    cityWithStateAbbr: "Mercer, WI",
  },
  {
    zip: "54548",
    ST: "WI",
    cityWithStateAbbr: "Minocqua, WI",
  },
  {
    zip: "54550",
    ST: "WI",
    cityWithStateAbbr: "Montreal, WI",
  },
  {
    zip: "54552",
    ST: "WI",
    cityWithStateAbbr: "Park Falls, WI",
  },
  {
    zip: "54554",
    ST: "WI",
    cityWithStateAbbr: "Phelps, WI",
  },
  {
    zip: "54555",
    ST: "WI",
    cityWithStateAbbr: "Phillips, WI",
  },
  {
    zip: "54556",
    ST: "WI",
    cityWithStateAbbr: "Prentice, WI",
  },
  {
    zip: "54557",
    ST: "WI",
    cityWithStateAbbr: "Presque Isle, WI",
  },
  {
    zip: "54558",
    ST: "WI",
    cityWithStateAbbr: "Saint Germain, WI",
  },
  {
    zip: "54559",
    ST: "WI",
    cityWithStateAbbr: "Saxon, WI",
  },
  {
    zip: "54560",
    ST: "WI",
    cityWithStateAbbr: "Sayner, WI",
  },
  {
    zip: "54561",
    ST: "WI",
    cityWithStateAbbr: "Star Lake, WI",
  },
  {
    zip: "54562",
    ST: "WI",
    cityWithStateAbbr: "Three Lakes, WI",
  },
  {
    zip: "54563",
    ST: "WI",
    cityWithStateAbbr: "Tony, WI",
  },
  {
    zip: "54564",
    ST: "WI",
    cityWithStateAbbr: "Tripoli, WI",
  },
  {
    zip: "54565",
    ST: "WI",
    cityWithStateAbbr: "Upson, WI",
  },
  {
    zip: "54566",
    ST: "WI",
    cityWithStateAbbr: "Wabeno, WI",
  },
  {
    zip: "54568",
    ST: "WI",
    cityWithStateAbbr: "Woodruff, WI",
  },
  {
    zip: "54601",
    ST: "WI",
    cityWithStateAbbr: "La Crosse, WI",
  },
  {
    zip: "54602",
    ST: "WI",
    cityWithStateAbbr: "La Crosse, WI",
  },
  {
    zip: "54603",
    ST: "WI",
    cityWithStateAbbr: "La Crosse, WI",
  },
  {
    zip: "54610",
    ST: "WI",
    cityWithStateAbbr: "Alma, WI",
  },
  {
    zip: "54611",
    ST: "WI",
    cityWithStateAbbr: "Alma Center, WI",
  },
  {
    zip: "54612",
    ST: "WI",
    cityWithStateAbbr: "Arcadia, WI",
  },
  {
    zip: "54613",
    ST: "WI",
    cityWithStateAbbr: "Arkdale, WI",
  },
  {
    zip: "54614",
    ST: "WI",
    cityWithStateAbbr: "Bangor, WI",
  },
  {
    zip: "54615",
    ST: "WI",
    cityWithStateAbbr: "Black River Falls, WI",
  },
  {
    zip: "54616",
    ST: "WI",
    cityWithStateAbbr: "Blair, WI",
  },
  {
    zip: "54618",
    ST: "WI",
    cityWithStateAbbr: "Camp Douglas, WI",
  },
  {
    zip: "54619",
    ST: "WI",
    cityWithStateAbbr: "Cashton, WI",
  },
  {
    zip: "54620",
    ST: "WI",
    cityWithStateAbbr: "Cataract, WI",
  },
  {
    zip: "54621",
    ST: "WI",
    cityWithStateAbbr: "Chaseburg, WI",
  },
  {
    zip: "54622",
    ST: "WI",
    cityWithStateAbbr: "Cochrane, WI",
  },
  {
    zip: "54623",
    ST: "WI",
    cityWithStateAbbr: "Coon Valley, WI",
  },
  {
    zip: "54624",
    ST: "WI",
    cityWithStateAbbr: "De Soto, WI",
  },
  {
    zip: "54625",
    ST: "WI",
    cityWithStateAbbr: "Dodge, WI",
  },
  {
    zip: "54626",
    ST: "WI",
    cityWithStateAbbr: "Eastman, WI",
  },
  {
    zip: "54627",
    ST: "WI",
    cityWithStateAbbr: "Ettrick, WI",
  },
  {
    zip: "54628",
    ST: "WI",
    cityWithStateAbbr: "Ferryville, WI",
  },
  {
    zip: "54629",
    ST: "WI",
    cityWithStateAbbr: "Fountain City, WI",
  },
  {
    zip: "54630",
    ST: "WI",
    cityWithStateAbbr: "Galesville, WI",
  },
  {
    zip: "54631",
    ST: "WI",
    cityWithStateAbbr: "Gays Mills, WI",
  },
  {
    zip: "54632",
    ST: "WI",
    cityWithStateAbbr: "Genoa, WI",
  },
  {
    zip: "54634",
    ST: "WI",
    cityWithStateAbbr: "Hillsboro, WI",
  },
  {
    zip: "54635",
    ST: "WI",
    cityWithStateAbbr: "Hixton, WI",
  },
  {
    zip: "54636",
    ST: "WI",
    cityWithStateAbbr: "Holmen, WI",
  },
  {
    zip: "54637",
    ST: "WI",
    cityWithStateAbbr: "Hustler, WI",
  },
  {
    zip: "54638",
    ST: "WI",
    cityWithStateAbbr: "Kendall, WI",
  },
  {
    zip: "54639",
    ST: "WI",
    cityWithStateAbbr: "La Farge, WI",
  },
  {
    zip: "54640",
    ST: "IA",
    cityWithStateAbbr: "Lynxville, IA",
  },
  {
    zip: "54641",
    ST: "WI",
    cityWithStateAbbr: "Mather, WI",
  },
  {
    zip: "54642",
    ST: "WI",
    cityWithStateAbbr: "Melrose, WI",
  },
  {
    zip: "54643",
    ST: "WI",
    cityWithStateAbbr: "Millston, WI",
  },
  {
    zip: "54644",
    ST: "WI",
    cityWithStateAbbr: "Mindoro, WI",
  },
  {
    zip: "54645",
    ST: "WI",
    cityWithStateAbbr: "Mount Sterling, WI",
  },
  {
    zip: "54646",
    ST: "WI",
    cityWithStateAbbr: "Necedah, WI",
  },
  {
    zip: "54648",
    ST: "WI",
    cityWithStateAbbr: "Norwalk, WI",
  },
  {
    zip: "54649",
    ST: "WI",
    cityWithStateAbbr: "Oakdale, WI",
  },
  {
    zip: "54650",
    ST: "WI",
    cityWithStateAbbr: "Onalaska, WI",
  },
  {
    zip: "54651",
    ST: "WI",
    cityWithStateAbbr: "Ontario, WI",
  },
  {
    zip: "54652",
    ST: "WI",
    cityWithStateAbbr: "Readstown, WI",
  },
  {
    zip: "54653",
    ST: "WI",
    cityWithStateAbbr: "Rockland, WI",
  },
  {
    zip: "54654",
    ST: "WI",
    cityWithStateAbbr: "Seneca, WI",
  },
  {
    zip: "54655",
    ST: "WI",
    cityWithStateAbbr: "Soldiers Grove, WI",
  },
  {
    zip: "54656",
    ST: "WI",
    cityWithStateAbbr: "Sparta, WI",
  },
  {
    zip: "54657",
    ST: "WI",
    cityWithStateAbbr: "Steuben, WI",
  },
  {
    zip: "54658",
    ST: "WI",
    cityWithStateAbbr: "Stoddard, WI",
  },
  {
    zip: "54659",
    ST: "WI",
    cityWithStateAbbr: "Taylor, WI",
  },
  {
    zip: "54660",
    ST: "WI",
    cityWithStateAbbr: "Tomah, WI",
  },
  {
    zip: "54661",
    ST: "WI",
    cityWithStateAbbr: "Trempealeau, WI",
  },
  {
    zip: "54662",
    ST: "WI",
    cityWithStateAbbr: "Tunnel City, WI",
  },
  {
    zip: "54664",
    ST: "WI",
    cityWithStateAbbr: "Viola, WI",
  },
  {
    zip: "54665",
    ST: "WI",
    cityWithStateAbbr: "Viroqua, WI",
  },
  {
    zip: "54666",
    ST: "WI",
    cityWithStateAbbr: "Warrens, WI",
  },
  {
    zip: "54667",
    ST: "WI",
    cityWithStateAbbr: "Westby, WI",
  },
  {
    zip: "54669",
    ST: "WI",
    cityWithStateAbbr: "West Salem, WI",
  },
  {
    zip: "54670",
    ST: "WI",
    cityWithStateAbbr: "Wilton, WI",
  },
  {
    zip: "54701",
    ST: "WI",
    cityWithStateAbbr: "Eau Claire, WI",
  },
  {
    zip: "54702",
    ST: "WI",
    cityWithStateAbbr: "Eau Claire, WI",
  },
  {
    zip: "54703",
    ST: "WI",
    cityWithStateAbbr: "Eau Claire, WI",
  },
  {
    zip: "54720",
    ST: "WI",
    cityWithStateAbbr: "Altoona, WI",
  },
  {
    zip: "54721",
    ST: "WI",
    cityWithStateAbbr: "Arkansaw, WI",
  },
  {
    zip: "54722",
    ST: "WI",
    cityWithStateAbbr: "Augusta, WI",
  },
  {
    zip: "54723",
    ST: "WI",
    cityWithStateAbbr: "Bay City, WI",
  },
  {
    zip: "54724",
    ST: "WI",
    cityWithStateAbbr: "Bloomer, WI",
  },
  {
    zip: "54725",
    ST: "WI",
    cityWithStateAbbr: "Boyceville, WI",
  },
  {
    zip: "54726",
    ST: "WI",
    cityWithStateAbbr: "Boyd, WI",
  },
  {
    zip: "54727",
    ST: "WI",
    cityWithStateAbbr: "Cadott, WI",
  },
  {
    zip: "54728",
    ST: "WI",
    cityWithStateAbbr: "Chetek, WI",
  },
  {
    zip: "54729",
    ST: "WI",
    cityWithStateAbbr: "Chippewa Falls, WI",
  },
  {
    zip: "54730",
    ST: "WI",
    cityWithStateAbbr: "Colfax, WI",
  },
  {
    zip: "54731",
    ST: "WI",
    cityWithStateAbbr: "Conrath, WI",
  },
  {
    zip: "54732",
    ST: "WI",
    cityWithStateAbbr: "Cornell, WI",
  },
  {
    zip: "54733",
    ST: "WI",
    cityWithStateAbbr: "Dallas, WI",
  },
  {
    zip: "54734",
    ST: "WI",
    cityWithStateAbbr: "Downing, WI",
  },
  {
    zip: "54735",
    ST: "WI",
    cityWithStateAbbr: "Downsville, WI",
  },
  {
    zip: "54736",
    ST: "WI",
    cityWithStateAbbr: "Durand, WI",
  },
  {
    zip: "54737",
    ST: "WI",
    cityWithStateAbbr: "Eau Galle, WI",
  },
  {
    zip: "54738",
    ST: "WI",
    cityWithStateAbbr: "Eleva, WI",
  },
  {
    zip: "54739",
    ST: "WI",
    cityWithStateAbbr: "Elk Mound, WI",
  },
  {
    zip: "54740",
    ST: "WI",
    cityWithStateAbbr: "Elmwood, WI",
  },
  {
    zip: "54741",
    ST: "WI",
    cityWithStateAbbr: "Fairchild, WI",
  },
  {
    zip: "54742",
    ST: "WI",
    cityWithStateAbbr: "Fall Creek, WI",
  },
  {
    zip: "54743",
    ST: "WI",
    cityWithStateAbbr: "Gilmanton, WI",
  },
  {
    zip: "54745",
    ST: "WI",
    cityWithStateAbbr: "Holcombe, WI",
  },
  {
    zip: "54746",
    ST: "WI",
    cityWithStateAbbr: "Humbird, WI",
  },
  {
    zip: "54747",
    ST: "WI",
    cityWithStateAbbr: "Independence, WI",
  },
  {
    zip: "54748",
    ST: "WI",
    cityWithStateAbbr: "Jim Falls, WI",
  },
  {
    zip: "54749",
    ST: "WI",
    cityWithStateAbbr: "Knapp, WI",
  },
  {
    zip: "54750",
    ST: "WI",
    cityWithStateAbbr: "Maiden Rock, WI",
  },
  {
    zip: "54751",
    ST: "WI",
    cityWithStateAbbr: "Menomonie, WI",
  },
  {
    zip: "54754",
    ST: "WI",
    cityWithStateAbbr: "Merrillan, WI",
  },
  {
    zip: "54755",
    ST: "WI",
    cityWithStateAbbr: "Mondovi, WI",
  },
  {
    zip: "54756",
    ST: "WI",
    cityWithStateAbbr: "Nelson, WI",
  },
  {
    zip: "54757",
    ST: "WI",
    cityWithStateAbbr: "New Auburn, WI",
  },
  {
    zip: "54758",
    ST: "WI",
    cityWithStateAbbr: "Osseo, WI",
  },
  {
    zip: "54759",
    ST: "WI",
    cityWithStateAbbr: "Pepin, WI",
  },
  {
    zip: "54760",
    ST: "WI",
    cityWithStateAbbr: "Pigeon Falls, WI",
  },
  {
    zip: "54761",
    ST: "WI",
    cityWithStateAbbr: "Plum City, WI",
  },
  {
    zip: "54762",
    ST: "WI",
    cityWithStateAbbr: "Prairie Farm, WI",
  },
  {
    zip: "54763",
    ST: "WI",
    cityWithStateAbbr: "Ridgeland, WI",
  },
  {
    zip: "54764",
    ST: "WI",
    cityWithStateAbbr: "Rock Falls, WI",
  },
  {
    zip: "54765",
    ST: "WI",
    cityWithStateAbbr: "Sand Creek, WI",
  },
  {
    zip: "54766",
    ST: "WI",
    cityWithStateAbbr: "Sheldon, WI",
  },
  {
    zip: "54767",
    ST: "WI",
    cityWithStateAbbr: "Spring Valley, WI",
  },
  {
    zip: "54768",
    ST: "WI",
    cityWithStateAbbr: "Stanley, WI",
  },
  {
    zip: "54769",
    ST: "WI",
    cityWithStateAbbr: "Stockholm, WI",
  },
  {
    zip: "54770",
    ST: "WI",
    cityWithStateAbbr: "Strum, WI",
  },
  {
    zip: "54771",
    ST: "WI",
    cityWithStateAbbr: "Thorp, WI",
  },
  {
    zip: "54772",
    ST: "WI",
    cityWithStateAbbr: "Wheeler, WI",
  },
  {
    zip: "54773",
    ST: "WI",
    cityWithStateAbbr: "Whitehall, WI",
  },
  {
    zip: "54774",
    ST: "WI",
    cityWithStateAbbr: "Chippewa Falls, WI",
  },
  {
    zip: "54801",
    ST: "WI",
    cityWithStateAbbr: "Spooner, WI",
  },
  {
    zip: "54805",
    ST: "WI",
    cityWithStateAbbr: "Almena, WI",
  },
  {
    zip: "54806",
    ST: "WI",
    cityWithStateAbbr: "Ashland, WI",
  },
  {
    zip: "54810",
    ST: "WI",
    cityWithStateAbbr: "Balsam Lake, WI",
  },
  {
    zip: "54812",
    ST: "WI",
    cityWithStateAbbr: "Barron, WI",
  },
  {
    zip: "54813",
    ST: "WI",
    cityWithStateAbbr: "Barronett, WI",
  },
  {
    zip: "54814",
    ST: "WI",
    cityWithStateAbbr: "Bayfield, WI",
  },
  {
    zip: "54816",
    ST: "WI",
    cityWithStateAbbr: "Benoit, WI",
  },
  {
    zip: "54817",
    ST: "WI",
    cityWithStateAbbr: "Birchwood, WI",
  },
  {
    zip: "54818",
    ST: "WI",
    cityWithStateAbbr: "Brill, WI",
  },
  {
    zip: "54819",
    ST: "WI",
    cityWithStateAbbr: "Bruce, WI",
  },
  {
    zip: "54820",
    ST: "WI",
    cityWithStateAbbr: "Brule, WI",
  },
  {
    zip: "54821",
    ST: "WI",
    cityWithStateAbbr: "Cable, WI",
  },
  {
    zip: "54822",
    ST: "WI",
    cityWithStateAbbr: "Cameron, WI",
  },
  {
    zip: "54824",
    ST: "WI",
    cityWithStateAbbr: "Centuria, WI",
  },
  {
    zip: "54826",
    ST: "WI",
    cityWithStateAbbr: "Comstock, WI",
  },
  {
    zip: "54827",
    ST: "WI",
    cityWithStateAbbr: "Cornucopia, WI",
  },
  {
    zip: "54828",
    ST: "WI",
    cityWithStateAbbr: "Couderay, WI",
  },
  {
    zip: "54829",
    ST: "WI",
    cityWithStateAbbr: "Cumberland, WI",
  },
  {
    zip: "54830",
    ST: "WI",
    cityWithStateAbbr: "Danbury, WI",
  },
  {
    zip: "54832",
    ST: "WI",
    cityWithStateAbbr: "Drummond, WI",
  },
  {
    zip: "54834",
    ST: "WI",
    cityWithStateAbbr: "Edgewater, WI",
  },
  {
    zip: "54835",
    ST: "WI",
    cityWithStateAbbr: "Exeland, WI",
  },
  {
    zip: "54836",
    ST: "WI",
    cityWithStateAbbr: "Foxboro, WI",
  },
  {
    zip: "54837",
    ST: "WI",
    cityWithStateAbbr: "Frederic, WI",
  },
  {
    zip: "54838",
    ST: "WI",
    cityWithStateAbbr: "Gordon, WI",
  },
  {
    zip: "54839",
    ST: "WI",
    cityWithStateAbbr: "Grand View, WI",
  },
  {
    zip: "54840",
    ST: "WI",
    cityWithStateAbbr: "Grantsburg, WI",
  },
  {
    zip: "54841",
    ST: "WI",
    cityWithStateAbbr: "Haugen, WI",
  },
  {
    zip: "54842",
    ST: "WI",
    cityWithStateAbbr: "Hawthorne, WI",
  },
  {
    zip: "54843",
    ST: "WI",
    cityWithStateAbbr: "Hayward, WI",
  },
  {
    zip: "54844",
    ST: "WI",
    cityWithStateAbbr: "Herbster, WI",
  },
  {
    zip: "54845",
    ST: "WI",
    cityWithStateAbbr: "Hertel, WI",
  },
  {
    zip: "54846",
    ST: "WI",
    cityWithStateAbbr: "High Bridge, WI",
  },
  {
    zip: "54847",
    ST: "WI",
    cityWithStateAbbr: "Iron River, WI",
  },
  {
    zip: "54848",
    ST: "WI",
    cityWithStateAbbr: "Ladysmith, WI",
  },
  {
    zip: "54849",
    ST: "WI",
    cityWithStateAbbr: "Lake Nebagamon, WI",
  },
  {
    zip: "54850",
    ST: "WI",
    cityWithStateAbbr: "La Pointe, WI",
  },
  {
    zip: "54853",
    ST: "WI",
    cityWithStateAbbr: "Luck, WI",
  },
  {
    zip: "54854",
    ST: "WI",
    cityWithStateAbbr: "Maple, WI",
  },
  {
    zip: "54855",
    ST: "WI",
    cityWithStateAbbr: "Marengo, WI",
  },
  {
    zip: "54856",
    ST: "WI",
    cityWithStateAbbr: "Mason, WI",
  },
  {
    zip: "54857",
    ST: "WI",
    cityWithStateAbbr: "Mikana, WI",
  },
  {
    zip: "54858",
    ST: "WI",
    cityWithStateAbbr: "Milltown, WI",
  },
  {
    zip: "54859",
    ST: "WI",
    cityWithStateAbbr: "Minong, WI",
  },
  {
    zip: "54861",
    ST: "WI",
    cityWithStateAbbr: "Odanah, WI",
  },
  {
    zip: "54862",
    ST: "WI",
    cityWithStateAbbr: "Ojibwa, WI",
  },
  {
    zip: "54864",
    ST: "WI",
    cityWithStateAbbr: "Poplar, WI",
  },
  {
    zip: "54865",
    ST: "WI",
    cityWithStateAbbr: "Port Wing, WI",
  },
  {
    zip: "54867",
    ST: "WI",
    cityWithStateAbbr: "Radisson, WI",
  },
  {
    zip: "54868",
    ST: "WI",
    cityWithStateAbbr: "Rice Lake, WI",
  },
  {
    zip: "54870",
    ST: "WI",
    cityWithStateAbbr: "Sarona, WI",
  },
  {
    zip: "54871",
    ST: "WI",
    cityWithStateAbbr: "Shell Lake, WI",
  },
  {
    zip: "54872",
    ST: "WI",
    cityWithStateAbbr: "Siren, WI",
  },
  {
    zip: "54873",
    ST: "WI",
    cityWithStateAbbr: "Solon Springs, WI",
  },
  {
    zip: "54874",
    ST: "WI",
    cityWithStateAbbr: "South Range, WI",
  },
  {
    zip: "54875",
    ST: "WI",
    cityWithStateAbbr: "Springbrook, WI",
  },
  {
    zip: "54876",
    ST: "WI",
    cityWithStateAbbr: "Stone Lake, WI",
  },
  {
    zip: "54880",
    ST: "WI",
    cityWithStateAbbr: "Superior, WI",
  },
  {
    zip: "54888",
    ST: "WI",
    cityWithStateAbbr: "Trego, WI",
  },
  {
    zip: "54889",
    ST: "WI",
    cityWithStateAbbr: "Turtle Lake, WI",
  },
  {
    zip: "54890",
    ST: "WI",
    cityWithStateAbbr: "Wascott, WI",
  },
  {
    zip: "54891",
    ST: "WI",
    cityWithStateAbbr: "Washburn, WI",
  },
  {
    zip: "54893",
    ST: "WI",
    cityWithStateAbbr: "Webster, WI",
  },
  {
    zip: "54895",
    ST: "WI",
    cityWithStateAbbr: "Weyerhaeuser, WI",
  },
  {
    zip: "54896",
    ST: "WI",
    cityWithStateAbbr: "Winter, WI",
  },
  {
    zip: "54901",
    ST: "WI",
    cityWithStateAbbr: "Oshkosh, WI",
  },
  {
    zip: "54902",
    ST: "WI",
    cityWithStateAbbr: "Oshkosh, WI",
  },
  {
    zip: "54903",
    ST: "WI",
    cityWithStateAbbr: "Oshkosh, WI",
  },
  {
    zip: "54904",
    ST: "WI",
    cityWithStateAbbr: "Oshkosh, WI",
  },
  {
    zip: "54906",
    ST: "WI",
    cityWithStateAbbr: "Oshkosh, WI",
  },
  {
    zip: "54909",
    ST: "WI",
    cityWithStateAbbr: "Almond, WI",
  },
  {
    zip: "54911",
    ST: "WI",
    cityWithStateAbbr: "Appleton, WI",
  },
  {
    zip: "54912",
    ST: "WI",
    cityWithStateAbbr: "Appleton, WI",
  },
  {
    zip: "54913",
    ST: "WI",
    cityWithStateAbbr: "Appleton, WI",
  },
  {
    zip: "54914",
    ST: "WI",
    cityWithStateAbbr: "Appleton, WI",
  },
  {
    zip: "54915",
    ST: "WI",
    cityWithStateAbbr: "Appleton, WI",
  },
  {
    zip: "54919",
    ST: "WI",
    cityWithStateAbbr: "Appleton, WI",
  },
  {
    zip: "54921",
    ST: "WI",
    cityWithStateAbbr: "Bancroft, WI",
  },
  {
    zip: "54922",
    ST: "WI",
    cityWithStateAbbr: "Bear Creek, WI",
  },
  {
    zip: "54923",
    ST: "WI",
    cityWithStateAbbr: "Berlin, WI",
  },
  {
    zip: "54926",
    ST: "WI",
    cityWithStateAbbr: "Big Falls, WI",
  },
  {
    zip: "54927",
    ST: "WI",
    cityWithStateAbbr: "Butte Des Morts, WI",
  },
  {
    zip: "54928",
    ST: "WI",
    cityWithStateAbbr: "Caroline, WI",
  },
  {
    zip: "54929",
    ST: "WI",
    cityWithStateAbbr: "Clintonville, WI",
  },
  {
    zip: "54930",
    ST: "WI",
    cityWithStateAbbr: "Coloma, WI",
  },
  {
    zip: "54931",
    ST: "WI",
    cityWithStateAbbr: "Dale, WI",
  },
  {
    zip: "54932",
    ST: "WI",
    cityWithStateAbbr: "Eldorado, WI",
  },
  {
    zip: "54933",
    ST: "WI",
    cityWithStateAbbr: "Embarrass, WI",
  },
  {
    zip: "54934",
    ST: "WI",
    cityWithStateAbbr: "Eureka, WI",
  },
  {
    zip: "54935",
    ST: "WI",
    cityWithStateAbbr: "Fond Du Lac, WI",
  },
  {
    zip: "54936",
    ST: "WI",
    cityWithStateAbbr: "Fond Du Lac, WI",
  },
  {
    zip: "54937",
    ST: "WI",
    cityWithStateAbbr: "Fond Du Lac, WI",
  },
  {
    zip: "54940",
    ST: "WI",
    cityWithStateAbbr: "Fremont, WI",
  },
  {
    zip: "54941",
    ST: "WI",
    cityWithStateAbbr: "Green Lake, WI",
  },
  {
    zip: "54942",
    ST: "WI",
    cityWithStateAbbr: "Greenville, WI",
  },
  {
    zip: "54943",
    ST: "WI",
    cityWithStateAbbr: "Hancock, WI",
  },
  {
    zip: "54944",
    ST: "WI",
    cityWithStateAbbr: "Hortonville, WI",
  },
  {
    zip: "54945",
    ST: "WI",
    cityWithStateAbbr: "Iola, WI",
  },
  {
    zip: "54946",
    ST: "WI",
    cityWithStateAbbr: "King, WI",
  },
  {
    zip: "54947",
    ST: "WI",
    cityWithStateAbbr: "Larsen, WI",
  },
  {
    zip: "54948",
    ST: "WI",
    cityWithStateAbbr: "Leopolis, WI",
  },
  {
    zip: "54949",
    ST: "WI",
    cityWithStateAbbr: "Manawa, WI",
  },
  {
    zip: "54950",
    ST: "WI",
    cityWithStateAbbr: "Marion, WI",
  },
  {
    zip: "54952",
    ST: "WI",
    cityWithStateAbbr: "Menasha, WI",
  },
  {
    zip: "54956",
    ST: "WI",
    cityWithStateAbbr: "Neenah, WI",
  },
  {
    zip: "54957",
    ST: "WI",
    cityWithStateAbbr: "Neenah, WI",
  },
  {
    zip: "54960",
    ST: "WI",
    cityWithStateAbbr: "Neshkoro, WI",
  },
  {
    zip: "54961",
    ST: "WI",
    cityWithStateAbbr: "New London, WI",
  },
  {
    zip: "54962",
    ST: "WI",
    cityWithStateAbbr: "Ogdensburg, WI",
  },
  {
    zip: "54963",
    ST: "WI",
    cityWithStateAbbr: "Omro, WI",
  },
  {
    zip: "54964",
    ST: "WI",
    cityWithStateAbbr: "Pickett, WI",
  },
  {
    zip: "54965",
    ST: "WI",
    cityWithStateAbbr: "Pine River, WI",
  },
  {
    zip: "54966",
    ST: "WI",
    cityWithStateAbbr: "Plainfield, WI",
  },
  {
    zip: "54967",
    ST: "WI",
    cityWithStateAbbr: "Poy Sippi, WI",
  },
  {
    zip: "54968",
    ST: "WI",
    cityWithStateAbbr: "Princeton, WI",
  },
  {
    zip: "54969",
    ST: "WI",
    cityWithStateAbbr: "Readfield, WI",
  },
  {
    zip: "54970",
    ST: "WI",
    cityWithStateAbbr: "Redgranite, WI",
  },
  {
    zip: "54971",
    ST: "WI",
    cityWithStateAbbr: "Ripon, WI",
  },
  {
    zip: "54974",
    ST: "WI",
    cityWithStateAbbr: "Rosendale, WI",
  },
  {
    zip: "54976",
    ST: "WI",
    cityWithStateAbbr: "Saxeville, WI",
  },
  {
    zip: "54977",
    ST: "WI",
    cityWithStateAbbr: "Scandinavia, WI",
  },
  {
    zip: "54978",
    ST: "WI",
    cityWithStateAbbr: "Tilleda, WI",
  },
  {
    zip: "54979",
    ST: "WI",
    cityWithStateAbbr: "Van Dyne, WI",
  },
  {
    zip: "54980",
    ST: "WI",
    cityWithStateAbbr: "Waukau, WI",
  },
  {
    zip: "54981",
    ST: "WI",
    cityWithStateAbbr: "Waupaca, WI",
  },
  {
    zip: "54982",
    ST: "WI",
    cityWithStateAbbr: "Wautoma, WI",
  },
  {
    zip: "54983",
    ST: "WI",
    cityWithStateAbbr: "Weyauwega, WI",
  },
  {
    zip: "54984",
    ST: "WI",
    cityWithStateAbbr: "Wild Rose, WI",
  },
  {
    zip: "54985",
    ST: "WI",
    cityWithStateAbbr: "Winnebago, WI",
  },
  {
    zip: "54986",
    ST: "WI",
    cityWithStateAbbr: "Winneconne, WI",
  },
  {
    zip: "54990",
    ST: "WI",
    cityWithStateAbbr: "Iola, WI",
  },
  {
    zip: "55001",
    ST: "MN",
    cityWithStateAbbr: "Afton, MN",
  },
  {
    zip: "55002",
    ST: "MN",
    cityWithStateAbbr: "Almelund, MN",
  },
  {
    zip: "55003",
    ST: "MN",
    cityWithStateAbbr: "Bayport, MN",
  },
  {
    zip: "55005",
    ST: "MN",
    cityWithStateAbbr: "Bethel, MN",
  },
  {
    zip: "55006",
    ST: "MN",
    cityWithStateAbbr: "Braham, MN",
  },
  {
    zip: "55007",
    ST: "MN",
    cityWithStateAbbr: "Brook Park, MN",
  },
  {
    zip: "55008",
    ST: "MN",
    cityWithStateAbbr: "Cambridge, MN",
  },
  {
    zip: "55009",
    ST: "MN",
    cityWithStateAbbr: "Cannon Falls, MN",
  },
  {
    zip: "55010",
    ST: "MN",
    cityWithStateAbbr: "Castle Rock, MN",
  },
  {
    zip: "55011",
    ST: "MN",
    cityWithStateAbbr: "Cedar, MN",
  },
  {
    zip: "55012",
    ST: "MN",
    cityWithStateAbbr: "Center City, MN",
  },
  {
    zip: "55013",
    ST: "MN",
    cityWithStateAbbr: "Chisago City, MN",
  },
  {
    zip: "55014",
    ST: "MN",
    cityWithStateAbbr: "Circle Pines, MN",
  },
  {
    zip: "55016",
    ST: "MN",
    cityWithStateAbbr: "Cottage Grove, MN",
  },
  {
    zip: "55017",
    ST: "MN",
    cityWithStateAbbr: "Dalbo, MN",
  },
  {
    zip: "55018",
    ST: "MN",
    cityWithStateAbbr: "Dennison, MN",
  },
  {
    zip: "55019",
    ST: "MN",
    cityWithStateAbbr: "Dundas, MN",
  },
  {
    zip: "55020",
    ST: "MN",
    cityWithStateAbbr: "Elko New Market, MN",
  },
  {
    zip: "55021",
    ST: "MN",
    cityWithStateAbbr: "Faribault, MN",
  },
  {
    zip: "55024",
    ST: "MN",
    cityWithStateAbbr: "Farmington, MN",
  },
  {
    zip: "55025",
    ST: "MN",
    cityWithStateAbbr: "Forest Lake, MN",
  },
  {
    zip: "55026",
    ST: "MN",
    cityWithStateAbbr: "Frontenac, MN",
  },
  {
    zip: "55027",
    ST: "MN",
    cityWithStateAbbr: "Goodhue, MN",
  },
  {
    zip: "55029",
    ST: "MN",
    cityWithStateAbbr: "Grandy, MN",
  },
  {
    zip: "55030",
    ST: "MN",
    cityWithStateAbbr: "Grasston, MN",
  },
  {
    zip: "55031",
    ST: "MN",
    cityWithStateAbbr: "Hampton, MN",
  },
  {
    zip: "55032",
    ST: "MN",
    cityWithStateAbbr: "Harris, MN",
  },
  {
    zip: "55033",
    ST: "MN",
    cityWithStateAbbr: "Hastings, MN",
  },
  {
    zip: "55036",
    ST: "MN",
    cityWithStateAbbr: "Henriette, MN",
  },
  {
    zip: "55037",
    ST: "MN",
    cityWithStateAbbr: "Hinckley, MN",
  },
  {
    zip: "55038",
    ST: "MN",
    cityWithStateAbbr: "Hugo, MN",
  },
  {
    zip: "55040",
    ST: "MN",
    cityWithStateAbbr: "Isanti, MN",
  },
  {
    zip: "55041",
    ST: "MN",
    cityWithStateAbbr: "Lake City, MN",
  },
  {
    zip: "55042",
    ST: "MN",
    cityWithStateAbbr: "Lake Elmo, MN",
  },
  {
    zip: "55043",
    ST: "MN",
    cityWithStateAbbr: "Lakeland, MN",
  },
  {
    zip: "55044",
    ST: "MN",
    cityWithStateAbbr: "Lakeville, MN",
  },
  {
    zip: "55045",
    ST: "MN",
    cityWithStateAbbr: "Lindstrom, MN",
  },
  {
    zip: "55046",
    ST: "MN",
    cityWithStateAbbr: "Lonsdale, MN",
  },
  {
    zip: "55047",
    ST: "MN",
    cityWithStateAbbr: "Marine On Saint Croix, MN",
  },
  {
    zip: "55049",
    ST: "MN",
    cityWithStateAbbr: "Medford, MN",
  },
  {
    zip: "55051",
    ST: "MN",
    cityWithStateAbbr: "Mora, MN",
  },
  {
    zip: "55052",
    ST: "MN",
    cityWithStateAbbr: "Morristown, MN",
  },
  {
    zip: "55053",
    ST: "MN",
    cityWithStateAbbr: "Nerstrand, MN",
  },
  {
    zip: "55054",
    ST: "MN",
    cityWithStateAbbr: "Elko New Market, MN",
  },
  {
    zip: "55055",
    ST: "MN",
    cityWithStateAbbr: "Newport, MN",
  },
  {
    zip: "55056",
    ST: "MN",
    cityWithStateAbbr: "North Branch, MN",
  },
  {
    zip: "55057",
    ST: "MN",
    cityWithStateAbbr: "Northfield, MN",
  },
  {
    zip: "55060",
    ST: "MN",
    cityWithStateAbbr: "Owatonna, MN",
  },
  {
    zip: "55063",
    ST: "MN",
    cityWithStateAbbr: "Pine City, MN",
  },
  {
    zip: "55065",
    ST: "MN",
    cityWithStateAbbr: "Randolph, MN",
  },
  {
    zip: "55066",
    ST: "MN",
    cityWithStateAbbr: "Red Wing, MN",
  },
  {
    zip: "55067",
    ST: "MN",
    cityWithStateAbbr: "Rock Creek, MN",
  },
  {
    zip: "55068",
    ST: "MN",
    cityWithStateAbbr: "Rosemount, MN",
  },
  {
    zip: "55069",
    ST: "MN",
    cityWithStateAbbr: "Rush City, MN",
  },
  {
    zip: "55070",
    ST: "MN",
    cityWithStateAbbr: "Saint Francis, MN",
  },
  {
    zip: "55071",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul Park, MN",
  },
  {
    zip: "55072",
    ST: "MN",
    cityWithStateAbbr: "Sandstone, MN",
  },
  {
    zip: "55073",
    ST: "MN",
    cityWithStateAbbr: "Scandia, MN",
  },
  {
    zip: "55074",
    ST: "MN",
    cityWithStateAbbr: "Shafer, MN",
  },
  {
    zip: "55075",
    ST: "MN",
    cityWithStateAbbr: "South Saint Paul, MN",
  },
  {
    zip: "55076",
    ST: "MN",
    cityWithStateAbbr: "Inver Grove Heights, MN",
  },
  {
    zip: "55077",
    ST: "MN",
    cityWithStateAbbr: "Inver Grove Heights, MN",
  },
  {
    zip: "55078",
    ST: "MN",
    cityWithStateAbbr: "Stacy, MN",
  },
  {
    zip: "55079",
    ST: "MN",
    cityWithStateAbbr: "Stacy, MN",
  },
  {
    zip: "55080",
    ST: "MN",
    cityWithStateAbbr: "Stanchfield, MN",
  },
  {
    zip: "55082",
    ST: "MN",
    cityWithStateAbbr: "Stillwater, MN",
  },
  {
    zip: "55083",
    ST: "MN",
    cityWithStateAbbr: "Stillwater, MN",
  },
  {
    zip: "55084",
    ST: "MN",
    cityWithStateAbbr: "Taylors Falls, MN",
  },
  {
    zip: "55085",
    ST: "MN",
    cityWithStateAbbr: "Vermillion, MN",
  },
  {
    zip: "55087",
    ST: "MN",
    cityWithStateAbbr: "Warsaw, MN",
  },
  {
    zip: "55088",
    ST: "MN",
    cityWithStateAbbr: "Webster, MN",
  },
  {
    zip: "55089",
    ST: "MN",
    cityWithStateAbbr: "Welch, MN",
  },
  {
    zip: "55090",
    ST: "MN",
    cityWithStateAbbr: "Willernie, MN",
  },
  {
    zip: "55092",
    ST: "MN",
    cityWithStateAbbr: "Wyoming, MN",
  },
  {
    zip: "55101",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55102",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55103",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55104",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55105",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55106",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55107",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55108",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55109",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55110",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55111",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55112",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55113",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55114",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55115",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55116",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55117",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55118",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55119",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55120",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55121",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55122",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55123",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55124",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55125",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55126",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55127",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55128",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55129",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55130",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55133",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55144",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55146",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55150",
    ST: "MN",
    cityWithStateAbbr: "Mendota, MN",
  },
  {
    zip: "55155",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55164",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55165",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55166",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55168",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55170",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55171",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55172",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55175",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55187",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55188",
    ST: "MN",
    cityWithStateAbbr: "Saint Paul, MN",
  },
  {
    zip: "55301",
    ST: "MN",
    cityWithStateAbbr: "Albertville, MN",
  },
  {
    zip: "55302",
    ST: "MN",
    cityWithStateAbbr: "Annandale, MN",
  },
  {
    zip: "55303",
    ST: "MN",
    cityWithStateAbbr: "Anoka, MN",
  },
  {
    zip: "55304",
    ST: "MN",
    cityWithStateAbbr: "Andover, MN",
  },
  {
    zip: "55305",
    ST: "MN",
    cityWithStateAbbr: "Hopkins, MN",
  },
  {
    zip: "55306",
    ST: "MN",
    cityWithStateAbbr: "Burnsville, MN",
  },
  {
    zip: "55307",
    ST: "MN",
    cityWithStateAbbr: "Arlington, MN",
  },
  {
    zip: "55308",
    ST: "MN",
    cityWithStateAbbr: "Becker, MN",
  },
  {
    zip: "55309",
    ST: "MN",
    cityWithStateAbbr: "Big Lake, MN",
  },
  {
    zip: "55310",
    ST: "MN",
    cityWithStateAbbr: "Bird Island, MN",
  },
  {
    zip: "55311",
    ST: "MN",
    cityWithStateAbbr: "Osseo, MN",
  },
  {
    zip: "55312",
    ST: "MN",
    cityWithStateAbbr: "Brownton, MN",
  },
  {
    zip: "55313",
    ST: "MN",
    cityWithStateAbbr: "Buffalo, MN",
  },
  {
    zip: "55314",
    ST: "MN",
    cityWithStateAbbr: "Buffalo Lake, MN",
  },
  {
    zip: "55315",
    ST: "MN",
    cityWithStateAbbr: "Carver, MN",
  },
  {
    zip: "55316",
    ST: "MN",
    cityWithStateAbbr: "Champlin, MN",
  },
  {
    zip: "55317",
    ST: "MN",
    cityWithStateAbbr: "Chanhassen, MN",
  },
  {
    zip: "55318",
    ST: "MN",
    cityWithStateAbbr: "Chaska, MN",
  },
  {
    zip: "55319",
    ST: "MN",
    cityWithStateAbbr: "Clear Lake, MN",
  },
  {
    zip: "55320",
    ST: "MN",
    cityWithStateAbbr: "Clearwater, MN",
  },
  {
    zip: "55321",
    ST: "MN",
    cityWithStateAbbr: "Cokato, MN",
  },
  {
    zip: "55322",
    ST: "MN",
    cityWithStateAbbr: "Cologne, MN",
  },
  {
    zip: "55323",
    ST: "MN",
    cityWithStateAbbr: "Crystal Bay, MN",
  },
  {
    zip: "55324",
    ST: "MN",
    cityWithStateAbbr: "Darwin, MN",
  },
  {
    zip: "55325",
    ST: "MN",
    cityWithStateAbbr: "Dassel, MN",
  },
  {
    zip: "55327",
    ST: "MN",
    cityWithStateAbbr: "Dayton, MN",
  },
  {
    zip: "55328",
    ST: "MN",
    cityWithStateAbbr: "Delano, MN",
  },
  {
    zip: "55329",
    ST: "MN",
    cityWithStateAbbr: "Eden Valley, MN",
  },
  {
    zip: "55330",
    ST: "MN",
    cityWithStateAbbr: "Elk River, MN",
  },
  {
    zip: "55331",
    ST: "MN",
    cityWithStateAbbr: "Excelsior, MN",
  },
  {
    zip: "55332",
    ST: "MN",
    cityWithStateAbbr: "Fairfax, MN",
  },
  {
    zip: "55333",
    ST: "MN",
    cityWithStateAbbr: "Franklin, MN",
  },
  {
    zip: "55334",
    ST: "MN",
    cityWithStateAbbr: "Gaylord, MN",
  },
  {
    zip: "55335",
    ST: "MN",
    cityWithStateAbbr: "Gibbon, MN",
  },
  {
    zip: "55336",
    ST: "MN",
    cityWithStateAbbr: "Glencoe, MN",
  },
  {
    zip: "55337",
    ST: "MN",
    cityWithStateAbbr: "Burnsville, MN",
  },
  {
    zip: "55338",
    ST: "MN",
    cityWithStateAbbr: "Green Isle, MN",
  },
  {
    zip: "55339",
    ST: "MN",
    cityWithStateAbbr: "Hamburg, MN",
  },
  {
    zip: "55340",
    ST: "MN",
    cityWithStateAbbr: "Hamel, MN",
  },
  {
    zip: "55341",
    ST: "MN",
    cityWithStateAbbr: "Hanover, MN",
  },
  {
    zip: "55342",
    ST: "MN",
    cityWithStateAbbr: "Hector, MN",
  },
  {
    zip: "55343",
    ST: "MN",
    cityWithStateAbbr: "Hopkins, MN",
  },
  {
    zip: "55344",
    ST: "MN",
    cityWithStateAbbr: "Eden Prairie, MN",
  },
  {
    zip: "55345",
    ST: "MN",
    cityWithStateAbbr: "Minnetonka, MN",
  },
  {
    zip: "55346",
    ST: "MN",
    cityWithStateAbbr: "Eden Prairie, MN",
  },
  {
    zip: "55347",
    ST: "MN",
    cityWithStateAbbr: "Eden Prairie, MN",
  },
  {
    zip: "55348",
    ST: "MN",
    cityWithStateAbbr: "Maple Plain, MN",
  },
  {
    zip: "55349",
    ST: "MN",
    cityWithStateAbbr: "Howard Lake, MN",
  },
  {
    zip: "55350",
    ST: "MN",
    cityWithStateAbbr: "Hutchinson, MN",
  },
  {
    zip: "55352",
    ST: "MN",
    cityWithStateAbbr: "Jordan, MN",
  },
  {
    zip: "55353",
    ST: "MN",
    cityWithStateAbbr: "Kimball, MN",
  },
  {
    zip: "55354",
    ST: "MN",
    cityWithStateAbbr: "Lester Prairie, MN",
  },
  {
    zip: "55355",
    ST: "MN",
    cityWithStateAbbr: "Litchfield, MN",
  },
  {
    zip: "55356",
    ST: "MN",
    cityWithStateAbbr: "Long Lake, MN",
  },
  {
    zip: "55357",
    ST: "MN",
    cityWithStateAbbr: "Loretto, MN",
  },
  {
    zip: "55358",
    ST: "MN",
    cityWithStateAbbr: "Maple Lake, MN",
  },
  {
    zip: "55359",
    ST: "MN",
    cityWithStateAbbr: "Maple Plain, MN",
  },
  {
    zip: "55360",
    ST: "MN",
    cityWithStateAbbr: "Mayer, MN",
  },
  {
    zip: "55361",
    ST: "MN",
    cityWithStateAbbr: "Minnetonka Beach, MN",
  },
  {
    zip: "55362",
    ST: "MN",
    cityWithStateAbbr: "Monticello, MN",
  },
  {
    zip: "55363",
    ST: "MN",
    cityWithStateAbbr: "Montrose, MN",
  },
  {
    zip: "55364",
    ST: "MN",
    cityWithStateAbbr: "Mound, MN",
  },
  {
    zip: "55365",
    ST: "MN",
    cityWithStateAbbr: "Monticello, MN",
  },
  {
    zip: "55366",
    ST: "MN",
    cityWithStateAbbr: "New Auburn, MN",
  },
  {
    zip: "55367",
    ST: "MN",
    cityWithStateAbbr: "New Germany, MN",
  },
  {
    zip: "55368",
    ST: "MN",
    cityWithStateAbbr: "Norwood Young America, MN",
  },
  {
    zip: "55369",
    ST: "MN",
    cityWithStateAbbr: "Osseo, MN",
  },
  {
    zip: "55370",
    ST: "MN",
    cityWithStateAbbr: "Plato, MN",
  },
  {
    zip: "55371",
    ST: "MN",
    cityWithStateAbbr: "Princeton, MN",
  },
  {
    zip: "55372",
    ST: "MN",
    cityWithStateAbbr: "Prior Lake, MN",
  },
  {
    zip: "55373",
    ST: "MN",
    cityWithStateAbbr: "Rockford, MN",
  },
  {
    zip: "55374",
    ST: "MN",
    cityWithStateAbbr: "Rogers, MN",
  },
  {
    zip: "55375",
    ST: "MN",
    cityWithStateAbbr: "Saint Bonifacius, MN",
  },
  {
    zip: "55376",
    ST: "MN",
    cityWithStateAbbr: "Saint Michael, MN",
  },
  {
    zip: "55377",
    ST: "MN",
    cityWithStateAbbr: "Santiago, MN",
  },
  {
    zip: "55378",
    ST: "MN",
    cityWithStateAbbr: "Savage, MN",
  },
  {
    zip: "55379",
    ST: "MN",
    cityWithStateAbbr: "Shakopee, MN",
  },
  {
    zip: "55380",
    ST: "MN",
    cityWithStateAbbr: "Silver Creek, MN",
  },
  {
    zip: "55381",
    ST: "MN",
    cityWithStateAbbr: "Silver Lake, MN",
  },
  {
    zip: "55382",
    ST: "MN",
    cityWithStateAbbr: "South Haven, MN",
  },
  {
    zip: "55383",
    ST: "MN",
    cityWithStateAbbr: "Norwood, MN",
  },
  {
    zip: "55384",
    ST: "MN",
    cityWithStateAbbr: "Spring Park, MN",
  },
  {
    zip: "55385",
    ST: "MN",
    cityWithStateAbbr: "Stewart, MN",
  },
  {
    zip: "55386",
    ST: "MN",
    cityWithStateAbbr: "Victoria, MN",
  },
  {
    zip: "55387",
    ST: "MN",
    cityWithStateAbbr: "Waconia, MN",
  },
  {
    zip: "55388",
    ST: "MN",
    cityWithStateAbbr: "Watertown, MN",
  },
  {
    zip: "55389",
    ST: "MN",
    cityWithStateAbbr: "Watkins, MN",
  },
  {
    zip: "55390",
    ST: "MN",
    cityWithStateAbbr: "Waverly, MN",
  },
  {
    zip: "55391",
    ST: "MN",
    cityWithStateAbbr: "Wayzata, MN",
  },
  {
    zip: "55392",
    ST: "MN",
    cityWithStateAbbr: "Navarre, MN",
  },
  {
    zip: "55393",
    ST: "MN",
    cityWithStateAbbr: "Maple Plain, MN",
  },
  {
    zip: "55394",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55395",
    ST: "MN",
    cityWithStateAbbr: "Winsted, MN",
  },
  {
    zip: "55396",
    ST: "MN",
    cityWithStateAbbr: "Winthrop, MN",
  },
  {
    zip: "55397",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55398",
    ST: "MN",
    cityWithStateAbbr: "Zimmerman, MN",
  },
  {
    zip: "55399",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55401",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55402",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55403",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55404",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55405",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55406",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55407",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55408",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55409",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55410",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55411",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55412",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55413",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55414",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55415",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55416",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55417",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55418",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55419",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55420",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55421",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55422",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55423",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55424",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55425",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55426",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55427",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55428",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55429",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55430",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55431",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55432",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55433",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55434",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55435",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55436",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55437",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55438",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55439",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55440",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55441",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55442",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55443",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55444",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55445",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55446",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55447",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55448",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55449",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55450",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55454",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55455",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55458",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55459",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55460",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55467",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55470",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55472",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55473",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55474",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55479",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55480",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55483",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55484",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55485",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55486",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55487",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55488",
    ST: "MN",
    cityWithStateAbbr: "Minneapolis, MN",
  },
  {
    zip: "55550",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55551",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55552",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55553",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55554",
    ST: "MN",
    cityWithStateAbbr: "Norwood, MN",
  },
  {
    zip: "55555",
    ST: "MN",
    cityWithStateAbbr: "Norwood Young America, MN",
  },
  {
    zip: "55556",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55557",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55558",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55559",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55560",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55561",
    ST: "MN",
    cityWithStateAbbr: "Monticello, MN",
  },
  {
    zip: "55562",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55563",
    ST: "MN",
    cityWithStateAbbr: "Monticello, MN",
  },
  {
    zip: "55564",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55565",
    ST: "MN",
    cityWithStateAbbr: "Monticello, MN",
  },
  {
    zip: "55566",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55567",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55568",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55569",
    ST: "MN",
    cityWithStateAbbr: "Osseo, MN",
  },
  {
    zip: "55570",
    ST: "MN",
    cityWithStateAbbr: "Maple Plain, MN",
  },
  {
    zip: "55571",
    ST: "MN",
    cityWithStateAbbr: "Maple Plain, MN",
  },
  {
    zip: "55572",
    ST: "MN",
    cityWithStateAbbr: "Rockford, MN",
  },
  {
    zip: "55573",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55574",
    ST: "MN",
    cityWithStateAbbr: "Maple Plain, MN",
  },
  {
    zip: "55575",
    ST: "MN",
    cityWithStateAbbr: "Howard Lake, MN",
  },
  {
    zip: "55576",
    ST: "MN",
    cityWithStateAbbr: "Maple Plain, MN",
  },
  {
    zip: "55577",
    ST: "MN",
    cityWithStateAbbr: "Rockford, MN",
  },
  {
    zip: "55578",
    ST: "MN",
    cityWithStateAbbr: "Maple Plain, MN",
  },
  {
    zip: "55579",
    ST: "MN",
    cityWithStateAbbr: "Maple Plain, MN",
  },
  {
    zip: "55580",
    ST: "MN",
    cityWithStateAbbr: "Monticello, MN",
  },
  {
    zip: "55581",
    ST: "MN",
    cityWithStateAbbr: "Monticello, MN",
  },
  {
    zip: "55582",
    ST: "MN",
    cityWithStateAbbr: "Monticello, MN",
  },
  {
    zip: "55583",
    ST: "MN",
    cityWithStateAbbr: "Norwood, MN",
  },
  {
    zip: "55584",
    ST: "MN",
    cityWithStateAbbr: "Monticello, MN",
  },
  {
    zip: "55585",
    ST: "MN",
    cityWithStateAbbr: "Monticello, MN",
  },
  {
    zip: "55586",
    ST: "MN",
    cityWithStateAbbr: "Monticello, MN",
  },
  {
    zip: "55587",
    ST: "MN",
    cityWithStateAbbr: "Monticello, MN",
  },
  {
    zip: "55588",
    ST: "MN",
    cityWithStateAbbr: "Monticello, MN",
  },
  {
    zip: "55589",
    ST: "MN",
    cityWithStateAbbr: "Monticello, MN",
  },
  {
    zip: "55590",
    ST: "MN",
    cityWithStateAbbr: "Monticello, MN",
  },
  {
    zip: "55591",
    ST: "MN",
    cityWithStateAbbr: "Monticello, MN",
  },
  {
    zip: "55592",
    ST: "MN",
    cityWithStateAbbr: "Maple Plain, MN",
  },
  {
    zip: "55593",
    ST: "MN",
    cityWithStateAbbr: "Maple Plain, MN",
  },
  {
    zip: "55594",
    ST: "MN",
    cityWithStateAbbr: "Young America, MN",
  },
  {
    zip: "55595",
    ST: "MN",
    cityWithStateAbbr: "Loretto, MN",
  },
  {
    zip: "55596",
    ST: "MN",
    cityWithStateAbbr: "Loretto, MN",
  },
  {
    zip: "55597",
    ST: "MN",
    cityWithStateAbbr: "Loretto, MN",
  },
  {
    zip: "55598",
    ST: "MN",
    cityWithStateAbbr: "Loretto, MN",
  },
  {
    zip: "55599",
    ST: "MN",
    cityWithStateAbbr: "Loretto, MN",
  },
  {
    zip: "55601",
    ST: "MN",
    cityWithStateAbbr: "Beaver Bay, MN",
  },
  {
    zip: "55602",
    ST: "MN",
    cityWithStateAbbr: "Brimson, MN",
  },
  {
    zip: "55603",
    ST: "MN",
    cityWithStateAbbr: "Finland, MN",
  },
  {
    zip: "55604",
    ST: "MN",
    cityWithStateAbbr: "Grand Marais, MN",
  },
  {
    zip: "55605",
    ST: "MN",
    cityWithStateAbbr: "Grand Portage, MN",
  },
  {
    zip: "55606",
    ST: "MN",
    cityWithStateAbbr: "Hovland, MN",
  },
  {
    zip: "55607",
    ST: "MN",
    cityWithStateAbbr: "Isabella, MN",
  },
  {
    zip: "55609",
    ST: "MN",
    cityWithStateAbbr: "Knife River, MN",
  },
  {
    zip: "55612",
    ST: "MN",
    cityWithStateAbbr: "Lutsen, MN",
  },
  {
    zip: "55613",
    ST: "MN",
    cityWithStateAbbr: "Schroeder, MN",
  },
  {
    zip: "55614",
    ST: "MN",
    cityWithStateAbbr: "Silver Bay, MN",
  },
  {
    zip: "55615",
    ST: "MN",
    cityWithStateAbbr: "Tofte, MN",
  },
  {
    zip: "55616",
    ST: "MN",
    cityWithStateAbbr: "Two Harbors, MN",
  },
  {
    zip: "55701",
    ST: "MN",
    cityWithStateAbbr: "Adolph, MN",
  },
  {
    zip: "55702",
    ST: "MN",
    cityWithStateAbbr: "Alborn, MN",
  },
  {
    zip: "55703",
    ST: "MN",
    cityWithStateAbbr: "Angora, MN",
  },
  {
    zip: "55704",
    ST: "MN",
    cityWithStateAbbr: "Askov, MN",
  },
  {
    zip: "55705",
    ST: "MN",
    cityWithStateAbbr: "Aurora, MN",
  },
  {
    zip: "55706",
    ST: "MN",
    cityWithStateAbbr: "Babbitt, MN",
  },
  {
    zip: "55707",
    ST: "MN",
    cityWithStateAbbr: "Barnum, MN",
  },
  {
    zip: "55708",
    ST: "MN",
    cityWithStateAbbr: "Biwabik, MN",
  },
  {
    zip: "55709",
    ST: "MN",
    cityWithStateAbbr: "Bovey, MN",
  },
  {
    zip: "55710",
    ST: "MN",
    cityWithStateAbbr: "Britt, MN",
  },
  {
    zip: "55711",
    ST: "MN",
    cityWithStateAbbr: "Brookston, MN",
  },
  {
    zip: "55712",
    ST: "MN",
    cityWithStateAbbr: "Bruno, MN",
  },
  {
    zip: "55713",
    ST: "MN",
    cityWithStateAbbr: "Buhl, MN",
  },
  {
    zip: "55716",
    ST: "MN",
    cityWithStateAbbr: "Calumet, MN",
  },
  {
    zip: "55717",
    ST: "MN",
    cityWithStateAbbr: "Canyon, MN",
  },
  {
    zip: "55718",
    ST: "MN",
    cityWithStateAbbr: "Carlton, MN",
  },
  {
    zip: "55719",
    ST: "MN",
    cityWithStateAbbr: "Chisholm, MN",
  },
  {
    zip: "55720",
    ST: "MN",
    cityWithStateAbbr: "Cloquet, MN",
  },
  {
    zip: "55721",
    ST: "MN",
    cityWithStateAbbr: "Cohasset, MN",
  },
  {
    zip: "55722",
    ST: "MN",
    cityWithStateAbbr: "Coleraine, MN",
  },
  {
    zip: "55723",
    ST: "MN",
    cityWithStateAbbr: "Cook, MN",
  },
  {
    zip: "55724",
    ST: "MN",
    cityWithStateAbbr: "Cotton, MN",
  },
  {
    zip: "55725",
    ST: "MN",
    cityWithStateAbbr: "Crane Lake, MN",
  },
  {
    zip: "55726",
    ST: "MN",
    cityWithStateAbbr: "Cromwell, MN",
  },
  {
    zip: "55730",
    ST: "MN",
    cityWithStateAbbr: "Grand Rapids, MN",
  },
  {
    zip: "55731",
    ST: "MN",
    cityWithStateAbbr: "Ely, MN",
  },
  {
    zip: "55732",
    ST: "MN",
    cityWithStateAbbr: "Embarrass, MN",
  },
  {
    zip: "55733",
    ST: "MN",
    cityWithStateAbbr: "Esko, MN",
  },
  {
    zip: "55734",
    ST: "MN",
    cityWithStateAbbr: "Eveleth, MN",
  },
  {
    zip: "55735",
    ST: "MN",
    cityWithStateAbbr: "Finlayson, MN",
  },
  {
    zip: "55736",
    ST: "MN",
    cityWithStateAbbr: "Floodwood, MN",
  },
  {
    zip: "55738",
    ST: "MN",
    cityWithStateAbbr: "Forbes, MN",
  },
  {
    zip: "55741",
    ST: "MN",
    cityWithStateAbbr: "Gilbert, MN",
  },
  {
    zip: "55742",
    ST: "MN",
    cityWithStateAbbr: "Goodland, MN",
  },
  {
    zip: "55744",
    ST: "MN",
    cityWithStateAbbr: "Grand Rapids, MN",
  },
  {
    zip: "55745",
    ST: "MN",
    cityWithStateAbbr: "Grand Rapids, MN",
  },
  {
    zip: "55746",
    ST: "MN",
    cityWithStateAbbr: "Hibbing, MN",
  },
  {
    zip: "55747",
    ST: "MN",
    cityWithStateAbbr: "Hibbing, MN",
  },
  {
    zip: "55748",
    ST: "MN",
    cityWithStateAbbr: "Hill City, MN",
  },
  {
    zip: "55749",
    ST: "MN",
    cityWithStateAbbr: "Holyoke, MN",
  },
  {
    zip: "55750",
    ST: "MN",
    cityWithStateAbbr: "Hoyt Lakes, MN",
  },
  {
    zip: "55751",
    ST: "MN",
    cityWithStateAbbr: "Iron, MN",
  },
  {
    zip: "55752",
    ST: "MN",
    cityWithStateAbbr: "Jacobson, MN",
  },
  {
    zip: "55753",
    ST: "MN",
    cityWithStateAbbr: "Keewatin, MN",
  },
  {
    zip: "55756",
    ST: "MN",
    cityWithStateAbbr: "Kerrick, MN",
  },
  {
    zip: "55757",
    ST: "MN",
    cityWithStateAbbr: "Kettle River, MN",
  },
  {
    zip: "55758",
    ST: "MN",
    cityWithStateAbbr: "Kinney, MN",
  },
  {
    zip: "55760",
    ST: "MN",
    cityWithStateAbbr: "Mcgregor, MN",
  },
  {
    zip: "55763",
    ST: "MN",
    cityWithStateAbbr: "Makinen, MN",
  },
  {
    zip: "55764",
    ST: "MN",
    cityWithStateAbbr: "Marble, MN",
  },
  {
    zip: "55765",
    ST: "MN",
    cityWithStateAbbr: "Meadowlands, MN",
  },
  {
    zip: "55766",
    ST: "MN",
    cityWithStateAbbr: "Melrude, MN",
  },
  {
    zip: "55767",
    ST: "MN",
    cityWithStateAbbr: "Moose Lake, MN",
  },
  {
    zip: "55768",
    ST: "MN",
    cityWithStateAbbr: "Mountain Iron, MN",
  },
  {
    zip: "55769",
    ST: "MN",
    cityWithStateAbbr: "Nashwauk, MN",
  },
  {
    zip: "55771",
    ST: "MN",
    cityWithStateAbbr: "Orr, MN",
  },
  {
    zip: "55772",
    ST: "MN",
    cityWithStateAbbr: "Nett Lake, MN",
  },
  {
    zip: "55775",
    ST: "MN",
    cityWithStateAbbr: "Pengilly, MN",
  },
  {
    zip: "55777",
    ST: "MN",
    cityWithStateAbbr: "Virginia, MN",
  },
  {
    zip: "55779",
    ST: "MN",
    cityWithStateAbbr: "Saginaw, MN",
  },
  {
    zip: "55780",
    ST: "MN",
    cityWithStateAbbr: "Sawyer, MN",
  },
  {
    zip: "55781",
    ST: "MN",
    cityWithStateAbbr: "Side Lake, MN",
  },
  {
    zip: "55782",
    ST: "MN",
    cityWithStateAbbr: "Soudan, MN",
  },
  {
    zip: "55783",
    ST: "MN",
    cityWithStateAbbr: "Sturgeon Lake, MN",
  },
  {
    zip: "55784",
    ST: "MN",
    cityWithStateAbbr: "Swan River, MN",
  },
  {
    zip: "55785",
    ST: "MN",
    cityWithStateAbbr: "Swatara, MN",
  },
  {
    zip: "55786",
    ST: "MN",
    cityWithStateAbbr: "Taconite, MN",
  },
  {
    zip: "55787",
    ST: "MN",
    cityWithStateAbbr: "Tamarack, MN",
  },
  {
    zip: "55790",
    ST: "MN",
    cityWithStateAbbr: "Tower, MN",
  },
  {
    zip: "55791",
    ST: "MN",
    cityWithStateAbbr: "Twig, MN",
  },
  {
    zip: "55792",
    ST: "MN",
    cityWithStateAbbr: "Virginia, MN",
  },
  {
    zip: "55793",
    ST: "MN",
    cityWithStateAbbr: "Warba, MN",
  },
  {
    zip: "55795",
    ST: "MN",
    cityWithStateAbbr: "Willow River, MN",
  },
  {
    zip: "55796",
    ST: "MN",
    cityWithStateAbbr: "Winton, MN",
  },
  {
    zip: "55797",
    ST: "MN",
    cityWithStateAbbr: "Wrenshall, MN",
  },
  {
    zip: "55798",
    ST: "MN",
    cityWithStateAbbr: "Wright, MN",
  },
  {
    zip: "55801",
    ST: "MN",
    cityWithStateAbbr: "Duluth, MN",
  },
  {
    zip: "55802",
    ST: "MN",
    cityWithStateAbbr: "Duluth, MN",
  },
  {
    zip: "55803",
    ST: "MN",
    cityWithStateAbbr: "Duluth, MN",
  },
  {
    zip: "55804",
    ST: "MN",
    cityWithStateAbbr: "Duluth, MN",
  },
  {
    zip: "55805",
    ST: "MN",
    cityWithStateAbbr: "Duluth, MN",
  },
  {
    zip: "55806",
    ST: "MN",
    cityWithStateAbbr: "Duluth, MN",
  },
  {
    zip: "55807",
    ST: "MN",
    cityWithStateAbbr: "Duluth, MN",
  },
  {
    zip: "55808",
    ST: "MN",
    cityWithStateAbbr: "Duluth, MN",
  },
  {
    zip: "55810",
    ST: "MN",
    cityWithStateAbbr: "Duluth, MN",
  },
  {
    zip: "55811",
    ST: "MN",
    cityWithStateAbbr: "Duluth, MN",
  },
  {
    zip: "55812",
    ST: "MN",
    cityWithStateAbbr: "Duluth, MN",
  },
  {
    zip: "55814",
    ST: "MN",
    cityWithStateAbbr: "Duluth, MN",
  },
  {
    zip: "55815",
    ST: "MN",
    cityWithStateAbbr: "Duluth, MN",
  },
  {
    zip: "55816",
    ST: "MN",
    cityWithStateAbbr: "Duluth, MN",
  },
  {
    zip: "55901",
    ST: "MN",
    cityWithStateAbbr: "Rochester, MN",
  },
  {
    zip: "55902",
    ST: "MN",
    cityWithStateAbbr: "Rochester, MN",
  },
  {
    zip: "55903",
    ST: "MN",
    cityWithStateAbbr: "Rochester, MN",
  },
  {
    zip: "55904",
    ST: "MN",
    cityWithStateAbbr: "Rochester, MN",
  },
  {
    zip: "55905",
    ST: "MN",
    cityWithStateAbbr: "Rochester, MN",
  },
  {
    zip: "55906",
    ST: "MN",
    cityWithStateAbbr: "Rochester, MN",
  },
  {
    zip: "55909",
    ST: "MN",
    cityWithStateAbbr: "Adams, MN",
  },
  {
    zip: "55910",
    ST: "MN",
    cityWithStateAbbr: "Altura, MN",
  },
  {
    zip: "55912",
    ST: "MN",
    cityWithStateAbbr: "Austin, MN",
  },
  {
    zip: "55917",
    ST: "MN",
    cityWithStateAbbr: "Blooming Prairie, MN",
  },
  {
    zip: "55918",
    ST: "MN",
    cityWithStateAbbr: "Brownsdale, MN",
  },
  {
    zip: "55919",
    ST: "MN",
    cityWithStateAbbr: "Brownsville, MN",
  },
  {
    zip: "55920",
    ST: "MN",
    cityWithStateAbbr: "Byron, MN",
  },
  {
    zip: "55921",
    ST: "MN",
    cityWithStateAbbr: "Caledonia, MN",
  },
  {
    zip: "55922",
    ST: "MN",
    cityWithStateAbbr: "Canton, MN",
  },
  {
    zip: "55923",
    ST: "MN",
    cityWithStateAbbr: "Chatfield, MN",
  },
  {
    zip: "55924",
    ST: "MN",
    cityWithStateAbbr: "Claremont, MN",
  },
  {
    zip: "55925",
    ST: "MN",
    cityWithStateAbbr: "Dakota, MN",
  },
  {
    zip: "55926",
    ST: "MN",
    cityWithStateAbbr: "Dexter, MN",
  },
  {
    zip: "55927",
    ST: "MN",
    cityWithStateAbbr: "Dodge Center, MN",
  },
  {
    zip: "55929",
    ST: "MN",
    cityWithStateAbbr: "Dover, MN",
  },
  {
    zip: "55931",
    ST: "MN",
    cityWithStateAbbr: "Eitzen, MN",
  },
  {
    zip: "55932",
    ST: "MN",
    cityWithStateAbbr: "Elgin, MN",
  },
  {
    zip: "55933",
    ST: "MN",
    cityWithStateAbbr: "Elkton, MN",
  },
  {
    zip: "55934",
    ST: "MN",
    cityWithStateAbbr: "Eyota, MN",
  },
  {
    zip: "55935",
    ST: "MN",
    cityWithStateAbbr: "Fountain, MN",
  },
  {
    zip: "55936",
    ST: "MN",
    cityWithStateAbbr: "Grand Meadow, MN",
  },
  {
    zip: "55939",
    ST: "MN",
    cityWithStateAbbr: "Harmony, MN",
  },
  {
    zip: "55940",
    ST: "MN",
    cityWithStateAbbr: "Hayfield, MN",
  },
  {
    zip: "55941",
    ST: "MN",
    cityWithStateAbbr: "Hokah, MN",
  },
  {
    zip: "55942",
    ST: "MN",
    cityWithStateAbbr: "Homer, MN",
  },
  {
    zip: "55943",
    ST: "MN",
    cityWithStateAbbr: "Houston, MN",
  },
  {
    zip: "55944",
    ST: "MN",
    cityWithStateAbbr: "Kasson, MN",
  },
  {
    zip: "55945",
    ST: "MN",
    cityWithStateAbbr: "Kellogg, MN",
  },
  {
    zip: "55946",
    ST: "MN",
    cityWithStateAbbr: "Kenyon, MN",
  },
  {
    zip: "55947",
    ST: "MN",
    cityWithStateAbbr: "La Crescent, MN",
  },
  {
    zip: "55949",
    ST: "MN",
    cityWithStateAbbr: "Lanesboro, MN",
  },
  {
    zip: "55950",
    ST: "MN",
    cityWithStateAbbr: "Lansing, MN",
  },
  {
    zip: "55951",
    ST: "MN",
    cityWithStateAbbr: "Le Roy, MN",
  },
  {
    zip: "55952",
    ST: "MN",
    cityWithStateAbbr: "Lewiston, MN",
  },
  {
    zip: "55953",
    ST: "MN",
    cityWithStateAbbr: "Lyle, MN",
  },
  {
    zip: "55954",
    ST: "MN",
    cityWithStateAbbr: "Mabel, MN",
  },
  {
    zip: "55955",
    ST: "MN",
    cityWithStateAbbr: "Mantorville, MN",
  },
  {
    zip: "55956",
    ST: "MN",
    cityWithStateAbbr: "Mazeppa, MN",
  },
  {
    zip: "55957",
    ST: "MN",
    cityWithStateAbbr: "Millville, MN",
  },
  {
    zip: "55959",
    ST: "MN",
    cityWithStateAbbr: "Minnesota City, MN",
  },
  {
    zip: "55960",
    ST: "MN",
    cityWithStateAbbr: "Oronoco, MN",
  },
  {
    zip: "55961",
    ST: "MN",
    cityWithStateAbbr: "Ostrander, MN",
  },
  {
    zip: "55962",
    ST: "MN",
    cityWithStateAbbr: "Peterson, MN",
  },
  {
    zip: "55963",
    ST: "MN",
    cityWithStateAbbr: "Pine Island, MN",
  },
  {
    zip: "55964",
    ST: "MN",
    cityWithStateAbbr: "Plainview, MN",
  },
  {
    zip: "55965",
    ST: "MN",
    cityWithStateAbbr: "Preston, MN",
  },
  {
    zip: "55967",
    ST: "MN",
    cityWithStateAbbr: "Racine, MN",
  },
  {
    zip: "55968",
    ST: "MN",
    cityWithStateAbbr: "Reads Landing, MN",
  },
  {
    zip: "55969",
    ST: "MN",
    cityWithStateAbbr: "Rollingstone, MN",
  },
  {
    zip: "55970",
    ST: "MN",
    cityWithStateAbbr: "Rose Creek, MN",
  },
  {
    zip: "55971",
    ST: "MN",
    cityWithStateAbbr: "Rushford, MN",
  },
  {
    zip: "55972",
    ST: "MN",
    cityWithStateAbbr: "Saint Charles, MN",
  },
  {
    zip: "55973",
    ST: "MN",
    cityWithStateAbbr: "Sargeant, MN",
  },
  {
    zip: "55974",
    ST: "MN",
    cityWithStateAbbr: "Spring Grove, MN",
  },
  {
    zip: "55975",
    ST: "MN",
    cityWithStateAbbr: "Spring Valley, MN",
  },
  {
    zip: "55976",
    ST: "MN",
    cityWithStateAbbr: "Stewartville, MN",
  },
  {
    zip: "55977",
    ST: "MN",
    cityWithStateAbbr: "Taopi, MN",
  },
  {
    zip: "55979",
    ST: "MN",
    cityWithStateAbbr: "Utica, MN",
  },
  {
    zip: "55981",
    ST: "MN",
    cityWithStateAbbr: "Wabasha, MN",
  },
  {
    zip: "55982",
    ST: "MN",
    cityWithStateAbbr: "Waltham, MN",
  },
  {
    zip: "55983",
    ST: "MN",
    cityWithStateAbbr: "Wanamingo, MN",
  },
  {
    zip: "55985",
    ST: "MN",
    cityWithStateAbbr: "West Concord, MN",
  },
  {
    zip: "55987",
    ST: "MN",
    cityWithStateAbbr: "Winona, MN",
  },
  {
    zip: "55988",
    ST: "MN",
    cityWithStateAbbr: "Stockton, MN",
  },
  {
    zip: "55990",
    ST: "MN",
    cityWithStateAbbr: "Wykoff, MN",
  },
  {
    zip: "55991",
    ST: "MN",
    cityWithStateAbbr: "Zumbro Falls, MN",
  },
  {
    zip: "55992",
    ST: "MN",
    cityWithStateAbbr: "Zumbrota, MN",
  },
  {
    zip: "56001",
    ST: "MN",
    cityWithStateAbbr: "Mankato, MN",
  },
  {
    zip: "56002",
    ST: "MN",
    cityWithStateAbbr: "Mankato, MN",
  },
  {
    zip: "56003",
    ST: "MN",
    cityWithStateAbbr: "Mankato, MN",
  },
  {
    zip: "56006",
    ST: "MN",
    cityWithStateAbbr: "Mankato, MN",
  },
  {
    zip: "56007",
    ST: "MN",
    cityWithStateAbbr: "Albert Lea, MN",
  },
  {
    zip: "56009",
    ST: "MN",
    cityWithStateAbbr: "Alden, MN",
  },
  {
    zip: "56010",
    ST: "MN",
    cityWithStateAbbr: "Amboy, MN",
  },
  {
    zip: "56011",
    ST: "MN",
    cityWithStateAbbr: "Belle Plaine, MN",
  },
  {
    zip: "56013",
    ST: "MN",
    cityWithStateAbbr: "Blue Earth, MN",
  },
  {
    zip: "56014",
    ST: "MN",
    cityWithStateAbbr: "Bricelyn, MN",
  },
  {
    zip: "56016",
    ST: "MN",
    cityWithStateAbbr: "Clarks Grove, MN",
  },
  {
    zip: "56017",
    ST: "MN",
    cityWithStateAbbr: "Cleveland, MN",
  },
  {
    zip: "56019",
    ST: "MN",
    cityWithStateAbbr: "Comfrey, MN",
  },
  {
    zip: "56020",
    ST: "MN",
    cityWithStateAbbr: "Conger, MN",
  },
  {
    zip: "56021",
    ST: "MN",
    cityWithStateAbbr: "Courtland, MN",
  },
  {
    zip: "56022",
    ST: "MN",
    cityWithStateAbbr: "Darfur, MN",
  },
  {
    zip: "56023",
    ST: "MN",
    cityWithStateAbbr: "Delavan, MN",
  },
  {
    zip: "56024",
    ST: "MN",
    cityWithStateAbbr: "Eagle Lake, MN",
  },
  {
    zip: "56025",
    ST: "MN",
    cityWithStateAbbr: "Easton, MN",
  },
  {
    zip: "56026",
    ST: "MN",
    cityWithStateAbbr: "Ellendale, MN",
  },
  {
    zip: "56027",
    ST: "MN",
    cityWithStateAbbr: "Elmore, MN",
  },
  {
    zip: "56028",
    ST: "MN",
    cityWithStateAbbr: "Elysian, MN",
  },
  {
    zip: "56029",
    ST: "MN",
    cityWithStateAbbr: "Emmons, MN",
  },
  {
    zip: "56030",
    ST: "MN",
    cityWithStateAbbr: "Essig, MN",
  },
  {
    zip: "56031",
    ST: "MN",
    cityWithStateAbbr: "Fairmont, MN",
  },
  {
    zip: "56032",
    ST: "MN",
    cityWithStateAbbr: "Freeborn, MN",
  },
  {
    zip: "56033",
    ST: "MN",
    cityWithStateAbbr: "Frost, MN",
  },
  {
    zip: "56034",
    ST: "MN",
    cityWithStateAbbr: "Garden City, MN",
  },
  {
    zip: "56035",
    ST: "MN",
    cityWithStateAbbr: "Geneva, MN",
  },
  {
    zip: "56036",
    ST: "MN",
    cityWithStateAbbr: "Glenville, MN",
  },
  {
    zip: "56037",
    ST: "MN",
    cityWithStateAbbr: "Good Thunder, MN",
  },
  {
    zip: "56039",
    ST: "MN",
    cityWithStateAbbr: "Granada, MN",
  },
  {
    zip: "56041",
    ST: "MN",
    cityWithStateAbbr: "Hanska, MN",
  },
  {
    zip: "56042",
    ST: "MN",
    cityWithStateAbbr: "Hartland, MN",
  },
  {
    zip: "56043",
    ST: "MN",
    cityWithStateAbbr: "Hayward, MN",
  },
  {
    zip: "56044",
    ST: "MN",
    cityWithStateAbbr: "Henderson, MN",
  },
  {
    zip: "56045",
    ST: "MN",
    cityWithStateAbbr: "Hollandale, MN",
  },
  {
    zip: "56046",
    ST: "MN",
    cityWithStateAbbr: "Hope, MN",
  },
  {
    zip: "56047",
    ST: "MN",
    cityWithStateAbbr: "Huntley, MN",
  },
  {
    zip: "56048",
    ST: "MN",
    cityWithStateAbbr: "Janesville, MN",
  },
  {
    zip: "56050",
    ST: "MN",
    cityWithStateAbbr: "Kasota, MN",
  },
  {
    zip: "56051",
    ST: "MN",
    cityWithStateAbbr: "Kiester, MN",
  },
  {
    zip: "56052",
    ST: "MN",
    cityWithStateAbbr: "Kilkenny, MN",
  },
  {
    zip: "56054",
    ST: "MN",
    cityWithStateAbbr: "Lafayette, MN",
  },
  {
    zip: "56055",
    ST: "MN",
    cityWithStateAbbr: "Lake Crystal, MN",
  },
  {
    zip: "56056",
    ST: "MN",
    cityWithStateAbbr: "La Salle, MN",
  },
  {
    zip: "56057",
    ST: "MN",
    cityWithStateAbbr: "Le Center, MN",
  },
  {
    zip: "56058",
    ST: "MN",
    cityWithStateAbbr: "Le Sueur, MN",
  },
  {
    zip: "56060",
    ST: "MN",
    cityWithStateAbbr: "Lewisville, MN",
  },
  {
    zip: "56062",
    ST: "MN",
    cityWithStateAbbr: "Madelia, MN",
  },
  {
    zip: "56063",
    ST: "MN",
    cityWithStateAbbr: "Madison Lake, MN",
  },
  {
    zip: "56065",
    ST: "MN",
    cityWithStateAbbr: "Mapleton, MN",
  },
  {
    zip: "56068",
    ST: "MN",
    cityWithStateAbbr: "Minnesota Lake, MN",
  },
  {
    zip: "56069",
    ST: "MN",
    cityWithStateAbbr: "Montgomery, MN",
  },
  {
    zip: "56071",
    ST: "MN",
    cityWithStateAbbr: "New Prague, MN",
  },
  {
    zip: "56072",
    ST: "MN",
    cityWithStateAbbr: "New Richland, MN",
  },
  {
    zip: "56073",
    ST: "MN",
    cityWithStateAbbr: "New Ulm, MN",
  },
  {
    zip: "56074",
    ST: "MN",
    cityWithStateAbbr: "Nicollet, MN",
  },
  {
    zip: "56075",
    ST: "MN",
    cityWithStateAbbr: "Northrop, MN",
  },
  {
    zip: "56078",
    ST: "MN",
    cityWithStateAbbr: "Pemberton, MN",
  },
  {
    zip: "56080",
    ST: "MN",
    cityWithStateAbbr: "Saint Clair, MN",
  },
  {
    zip: "56081",
    ST: "MN",
    cityWithStateAbbr: "Saint James, MN",
  },
  {
    zip: "56082",
    ST: "MN",
    cityWithStateAbbr: "Saint Peter, MN",
  },
  {
    zip: "56083",
    ST: "MN",
    cityWithStateAbbr: "Sanborn, MN",
  },
  {
    zip: "56084",
    ST: "MN",
    cityWithStateAbbr: "Searles, MN",
  },
  {
    zip: "56085",
    ST: "MN",
    cityWithStateAbbr: "Sleepy Eye, MN",
  },
  {
    zip: "56087",
    ST: "MN",
    cityWithStateAbbr: "Springfield, MN",
  },
  {
    zip: "56088",
    ST: "MN",
    cityWithStateAbbr: "Truman, MN",
  },
  {
    zip: "56089",
    ST: "MN",
    cityWithStateAbbr: "Twin Lakes, MN",
  },
  {
    zip: "56090",
    ST: "MN",
    cityWithStateAbbr: "Vernon Center, MN",
  },
  {
    zip: "56091",
    ST: "MN",
    cityWithStateAbbr: "Waldorf, MN",
  },
  {
    zip: "56093",
    ST: "MN",
    cityWithStateAbbr: "Waseca, MN",
  },
  {
    zip: "56096",
    ST: "MN",
    cityWithStateAbbr: "Waterville, MN",
  },
  {
    zip: "56097",
    ST: "MN",
    cityWithStateAbbr: "Wells, MN",
  },
  {
    zip: "56098",
    ST: "MN",
    cityWithStateAbbr: "Winnebago, MN",
  },
  {
    zip: "56101",
    ST: "MN",
    cityWithStateAbbr: "Windom, MN",
  },
  {
    zip: "56110",
    ST: "MN",
    cityWithStateAbbr: "Adrian, MN",
  },
  {
    zip: "56111",
    ST: "MN",
    cityWithStateAbbr: "Alpha, MN",
  },
  {
    zip: "56113",
    ST: "MN",
    cityWithStateAbbr: "Arco, MN",
  },
  {
    zip: "56114",
    ST: "MN",
    cityWithStateAbbr: "Avoca, MN",
  },
  {
    zip: "56115",
    ST: "MN",
    cityWithStateAbbr: "Balaton, MN",
  },
  {
    zip: "56116",
    ST: "MN",
    cityWithStateAbbr: "Beaver Creek, MN",
  },
  {
    zip: "56117",
    ST: "MN",
    cityWithStateAbbr: "Bigelow, MN",
  },
  {
    zip: "56118",
    ST: "MN",
    cityWithStateAbbr: "Bingham Lake, MN",
  },
  {
    zip: "56119",
    ST: "MN",
    cityWithStateAbbr: "Brewster, MN",
  },
  {
    zip: "56120",
    ST: "MN",
    cityWithStateAbbr: "Butterfield, MN",
  },
  {
    zip: "56121",
    ST: "MN",
    cityWithStateAbbr: "Ceylon, MN",
  },
  {
    zip: "56122",
    ST: "MN",
    cityWithStateAbbr: "Chandler, MN",
  },
  {
    zip: "56123",
    ST: "MN",
    cityWithStateAbbr: "Currie, MN",
  },
  {
    zip: "56125",
    ST: "MN",
    cityWithStateAbbr: "Dovray, MN",
  },
  {
    zip: "56127",
    ST: "MN",
    cityWithStateAbbr: "Dunnell, MN",
  },
  {
    zip: "56128",
    ST: "MN",
    cityWithStateAbbr: "Edgerton, MN",
  },
  {
    zip: "56129",
    ST: "MN",
    cityWithStateAbbr: "Ellsworth, MN",
  },
  {
    zip: "56131",
    ST: "MN",
    cityWithStateAbbr: "Fulda, MN",
  },
  {
    zip: "56132",
    ST: "MN",
    cityWithStateAbbr: "Garvin, MN",
  },
  {
    zip: "56134",
    ST: "MN",
    cityWithStateAbbr: "Hardwick, MN",
  },
  {
    zip: "56136",
    ST: "MN",
    cityWithStateAbbr: "Hendricks, MN",
  },
  {
    zip: "56137",
    ST: "MN",
    cityWithStateAbbr: "Heron Lake, MN",
  },
  {
    zip: "56138",
    ST: "MN",
    cityWithStateAbbr: "Hills, MN",
  },
  {
    zip: "56139",
    ST: "MN",
    cityWithStateAbbr: "Holland, MN",
  },
  {
    zip: "56140",
    ST: "MN",
    cityWithStateAbbr: "Ihlen, MN",
  },
  {
    zip: "56141",
    ST: "MN",
    cityWithStateAbbr: "Iona, MN",
  },
  {
    zip: "56142",
    ST: "MN",
    cityWithStateAbbr: "Ivanhoe, MN",
  },
  {
    zip: "56143",
    ST: "MN",
    cityWithStateAbbr: "Jackson, MN",
  },
  {
    zip: "56144",
    ST: "MN",
    cityWithStateAbbr: "Jasper, MN",
  },
  {
    zip: "56145",
    ST: "MN",
    cityWithStateAbbr: "Jeffers, MN",
  },
  {
    zip: "56146",
    ST: "MN",
    cityWithStateAbbr: "Kanaranzi, MN",
  },
  {
    zip: "56147",
    ST: "MN",
    cityWithStateAbbr: "Kenneth, MN",
  },
  {
    zip: "56149",
    ST: "MN",
    cityWithStateAbbr: "Lake Benton, MN",
  },
  {
    zip: "56150",
    ST: "MN",
    cityWithStateAbbr: "Lakefield, MN",
  },
  {
    zip: "56151",
    ST: "MN",
    cityWithStateAbbr: "Lake Wilson, MN",
  },
  {
    zip: "56152",
    ST: "MN",
    cityWithStateAbbr: "Lamberton, MN",
  },
  {
    zip: "56153",
    ST: "MN",
    cityWithStateAbbr: "Leota, MN",
  },
  {
    zip: "56155",
    ST: "MN",
    cityWithStateAbbr: "Lismore, MN",
  },
  {
    zip: "56156",
    ST: "MN",
    cityWithStateAbbr: "Luverne, MN",
  },
  {
    zip: "56157",
    ST: "MN",
    cityWithStateAbbr: "Lynd, MN",
  },
  {
    zip: "56158",
    ST: "MN",
    cityWithStateAbbr: "Magnolia, MN",
  },
  {
    zip: "56159",
    ST: "MN",
    cityWithStateAbbr: "Mountain Lake, MN",
  },
  {
    zip: "56160",
    ST: "MN",
    cityWithStateAbbr: "Odin, MN",
  },
  {
    zip: "56161",
    ST: "MN",
    cityWithStateAbbr: "Okabena, MN",
  },
  {
    zip: "56162",
    ST: "MN",
    cityWithStateAbbr: "Ormsby, MN",
  },
  {
    zip: "56164",
    ST: "MN",
    cityWithStateAbbr: "Pipestone, MN",
  },
  {
    zip: "56165",
    ST: "MN",
    cityWithStateAbbr: "Reading, MN",
  },
  {
    zip: "56166",
    ST: "MN",
    cityWithStateAbbr: "Revere, MN",
  },
  {
    zip: "56167",
    ST: "MN",
    cityWithStateAbbr: "Round Lake, MN",
  },
  {
    zip: "56168",
    ST: "MN",
    cityWithStateAbbr: "Rushmore, MN",
  },
  {
    zip: "56169",
    ST: "MN",
    cityWithStateAbbr: "Russell, MN",
  },
  {
    zip: "56170",
    ST: "MN",
    cityWithStateAbbr: "Ruthton, MN",
  },
  {
    zip: "56171",
    ST: "MN",
    cityWithStateAbbr: "Sherburn, MN",
  },
  {
    zip: "56172",
    ST: "MN",
    cityWithStateAbbr: "Slayton, MN",
  },
  {
    zip: "56173",
    ST: "MN",
    cityWithStateAbbr: "Steen, MN",
  },
  {
    zip: "56174",
    ST: "MN",
    cityWithStateAbbr: "Storden, MN",
  },
  {
    zip: "56175",
    ST: "MN",
    cityWithStateAbbr: "Tracy, MN",
  },
  {
    zip: "56176",
    ST: "MN",
    cityWithStateAbbr: "Trimont, MN",
  },
  {
    zip: "56177",
    ST: "MN",
    cityWithStateAbbr: "Trosky, MN",
  },
  {
    zip: "56178",
    ST: "MN",
    cityWithStateAbbr: "Tyler, MN",
  },
  {
    zip: "56180",
    ST: "MN",
    cityWithStateAbbr: "Walnut Grove, MN",
  },
  {
    zip: "56181",
    ST: "MN",
    cityWithStateAbbr: "Welcome, MN",
  },
  {
    zip: "56183",
    ST: "MN",
    cityWithStateAbbr: "Westbrook, MN",
  },
  {
    zip: "56185",
    ST: "MN",
    cityWithStateAbbr: "Wilmont, MN",
  },
  {
    zip: "56186",
    ST: "MN",
    cityWithStateAbbr: "Woodstock, MN",
  },
  {
    zip: "56187",
    ST: "MN",
    cityWithStateAbbr: "Worthington, MN",
  },
  {
    zip: "56201",
    ST: "MN",
    cityWithStateAbbr: "Willmar, MN",
  },
  {
    zip: "56207",
    ST: "MN",
    cityWithStateAbbr: "Alberta, MN",
  },
  {
    zip: "56208",
    ST: "MN",
    cityWithStateAbbr: "Appleton, MN",
  },
  {
    zip: "56209",
    ST: "MN",
    cityWithStateAbbr: "Atwater, MN",
  },
  {
    zip: "56210",
    ST: "MN",
    cityWithStateAbbr: "Barry, MN",
  },
  {
    zip: "56211",
    ST: "MN",
    cityWithStateAbbr: "Beardsley, MN",
  },
  {
    zip: "56212",
    ST: "MN",
    cityWithStateAbbr: "Bellingham, MN",
  },
  {
    zip: "56214",
    ST: "MN",
    cityWithStateAbbr: "Belview, MN",
  },
  {
    zip: "56215",
    ST: "MN",
    cityWithStateAbbr: "Benson, MN",
  },
  {
    zip: "56216",
    ST: "MN",
    cityWithStateAbbr: "Blomkest, MN",
  },
  {
    zip: "56218",
    ST: "MN",
    cityWithStateAbbr: "Boyd, MN",
  },
  {
    zip: "56219",
    ST: "MN",
    cityWithStateAbbr: "Browns Valley, MN",
  },
  {
    zip: "56220",
    ST: "MN",
    cityWithStateAbbr: "Canby, MN",
  },
  {
    zip: "56221",
    ST: "MN",
    cityWithStateAbbr: "Chokio, MN",
  },
  {
    zip: "56222",
    ST: "MN",
    cityWithStateAbbr: "Clara City, MN",
  },
  {
    zip: "56223",
    ST: "MN",
    cityWithStateAbbr: "Clarkfield, MN",
  },
  {
    zip: "56224",
    ST: "MN",
    cityWithStateAbbr: "Clements, MN",
  },
  {
    zip: "56225",
    ST: "MN",
    cityWithStateAbbr: "Clinton, MN",
  },
  {
    zip: "56226",
    ST: "MN",
    cityWithStateAbbr: "Clontarf, MN",
  },
  {
    zip: "56227",
    ST: "MN",
    cityWithStateAbbr: "Correll, MN",
  },
  {
    zip: "56228",
    ST: "MN",
    cityWithStateAbbr: "Cosmos, MN",
  },
  {
    zip: "56229",
    ST: "MN",
    cityWithStateAbbr: "Cottonwood, MN",
  },
  {
    zip: "56230",
    ST: "MN",
    cityWithStateAbbr: "Danube, MN",
  },
  {
    zip: "56231",
    ST: "MN",
    cityWithStateAbbr: "Danvers, MN",
  },
  {
    zip: "56232",
    ST: "MN",
    cityWithStateAbbr: "Dawson, MN",
  },
  {
    zip: "56235",
    ST: "MN",
    cityWithStateAbbr: "Donnelly, MN",
  },
  {
    zip: "56236",
    ST: "MN",
    cityWithStateAbbr: "Dumont, MN",
  },
  {
    zip: "56237",
    ST: "MN",
    cityWithStateAbbr: "Echo, MN",
  },
  {
    zip: "56239",
    ST: "MN",
    cityWithStateAbbr: "Ghent, MN",
  },
  {
    zip: "56240",
    ST: "MN",
    cityWithStateAbbr: "Graceville, MN",
  },
  {
    zip: "56241",
    ST: "MN",
    cityWithStateAbbr: "Granite Falls, MN",
  },
  {
    zip: "56243",
    ST: "MN",
    cityWithStateAbbr: "Grove City, MN",
  },
  {
    zip: "56244",
    ST: "MN",
    cityWithStateAbbr: "Hancock, MN",
  },
  {
    zip: "56245",
    ST: "MN",
    cityWithStateAbbr: "Hanley Falls, MN",
  },
  {
    zip: "56248",
    ST: "MN",
    cityWithStateAbbr: "Herman, MN",
  },
  {
    zip: "56249",
    ST: "MN",
    cityWithStateAbbr: "Holloway, MN",
  },
  {
    zip: "56251",
    ST: "MN",
    cityWithStateAbbr: "Kandiyohi, MN",
  },
  {
    zip: "56252",
    ST: "MN",
    cityWithStateAbbr: "Kerkhoven, MN",
  },
  {
    zip: "56253",
    ST: "MN",
    cityWithStateAbbr: "Lake Lillian, MN",
  },
  {
    zip: "56255",
    ST: "MN",
    cityWithStateAbbr: "Lucan, MN",
  },
  {
    zip: "56256",
    ST: "MN",
    cityWithStateAbbr: "Madison, MN",
  },
  {
    zip: "56257",
    ST: "MN",
    cityWithStateAbbr: "Marietta, MN",
  },
  {
    zip: "56258",
    ST: "MN",
    cityWithStateAbbr: "Marshall, MN",
  },
  {
    zip: "56260",
    ST: "MN",
    cityWithStateAbbr: "Maynard, MN",
  },
  {
    zip: "56262",
    ST: "MN",
    cityWithStateAbbr: "Milan, MN",
  },
  {
    zip: "56263",
    ST: "MN",
    cityWithStateAbbr: "Milroy, MN",
  },
  {
    zip: "56264",
    ST: "MN",
    cityWithStateAbbr: "Minneota, MN",
  },
  {
    zip: "56265",
    ST: "MN",
    cityWithStateAbbr: "Montevideo, MN",
  },
  {
    zip: "56266",
    ST: "MN",
    cityWithStateAbbr: "Morgan, MN",
  },
  {
    zip: "56267",
    ST: "MN",
    cityWithStateAbbr: "Morris, MN",
  },
  {
    zip: "56270",
    ST: "MN",
    cityWithStateAbbr: "Morton, MN",
  },
  {
    zip: "56271",
    ST: "MN",
    cityWithStateAbbr: "Murdock, MN",
  },
  {
    zip: "56273",
    ST: "MN",
    cityWithStateAbbr: "New London, MN",
  },
  {
    zip: "56274",
    ST: "MN",
    cityWithStateAbbr: "Norcross, MN",
  },
  {
    zip: "56276",
    ST: "MN",
    cityWithStateAbbr: "Odessa, MN",
  },
  {
    zip: "56277",
    ST: "MN",
    cityWithStateAbbr: "Olivia, MN",
  },
  {
    zip: "56278",
    ST: "MN",
    cityWithStateAbbr: "Ortonville, MN",
  },
  {
    zip: "56279",
    ST: "MN",
    cityWithStateAbbr: "Pennock, MN",
  },
  {
    zip: "56280",
    ST: "MN",
    cityWithStateAbbr: "Porter, MN",
  },
  {
    zip: "56281",
    ST: "MN",
    cityWithStateAbbr: "Prinsburg, MN",
  },
  {
    zip: "56282",
    ST: "MN",
    cityWithStateAbbr: "Raymond, MN",
  },
  {
    zip: "56283",
    ST: "MN",
    cityWithStateAbbr: "Redwood Falls, MN",
  },
  {
    zip: "56284",
    ST: "MN",
    cityWithStateAbbr: "Renville, MN",
  },
  {
    zip: "56285",
    ST: "MN",
    cityWithStateAbbr: "Sacred Heart, MN",
  },
  {
    zip: "56287",
    ST: "MN",
    cityWithStateAbbr: "Seaforth, MN",
  },
  {
    zip: "56288",
    ST: "MN",
    cityWithStateAbbr: "Spicer, MN",
  },
  {
    zip: "56289",
    ST: "MN",
    cityWithStateAbbr: "Sunburg, MN",
  },
  {
    zip: "56291",
    ST: "MN",
    cityWithStateAbbr: "Taunton, MN",
  },
  {
    zip: "56292",
    ST: "MN",
    cityWithStateAbbr: "Vesta, MN",
  },
  {
    zip: "56293",
    ST: "MN",
    cityWithStateAbbr: "Wabasso, MN",
  },
  {
    zip: "56294",
    ST: "MN",
    cityWithStateAbbr: "Wanda, MN",
  },
  {
    zip: "56295",
    ST: "MN",
    cityWithStateAbbr: "Watson, MN",
  },
  {
    zip: "56296",
    ST: "MN",
    cityWithStateAbbr: "Wheaton, MN",
  },
  {
    zip: "56297",
    ST: "MN",
    cityWithStateAbbr: "Wood Lake, MN",
  },
  {
    zip: "56301",
    ST: "MN",
    cityWithStateAbbr: "Saint Cloud, MN",
  },
  {
    zip: "56302",
    ST: "MN",
    cityWithStateAbbr: "Saint Cloud, MN",
  },
  {
    zip: "56303",
    ST: "MN",
    cityWithStateAbbr: "Saint Cloud, MN",
  },
  {
    zip: "56304",
    ST: "MN",
    cityWithStateAbbr: "Saint Cloud, MN",
  },
  {
    zip: "56307",
    ST: "MN",
    cityWithStateAbbr: "Albany, MN",
  },
  {
    zip: "56308",
    ST: "MN",
    cityWithStateAbbr: "Alexandria, MN",
  },
  {
    zip: "56309",
    ST: "MN",
    cityWithStateAbbr: "Ashby, MN",
  },
  {
    zip: "56310",
    ST: "MN",
    cityWithStateAbbr: "Avon, MN",
  },
  {
    zip: "56311",
    ST: "MN",
    cityWithStateAbbr: "Barrett, MN",
  },
  {
    zip: "56312",
    ST: "MN",
    cityWithStateAbbr: "Belgrade, MN",
  },
  {
    zip: "56313",
    ST: "MN",
    cityWithStateAbbr: "Bock, MN",
  },
  {
    zip: "56314",
    ST: "MN",
    cityWithStateAbbr: "Bowlus, MN",
  },
  {
    zip: "56315",
    ST: "MN",
    cityWithStateAbbr: "Brandon, MN",
  },
  {
    zip: "56316",
    ST: "MN",
    cityWithStateAbbr: "Brooten, MN",
  },
  {
    zip: "56317",
    ST: "MN",
    cityWithStateAbbr: "Buckman, MN",
  },
  {
    zip: "56318",
    ST: "MN",
    cityWithStateAbbr: "Burtrum, MN",
  },
  {
    zip: "56319",
    ST: "MN",
    cityWithStateAbbr: "Carlos, MN",
  },
  {
    zip: "56320",
    ST: "MN",
    cityWithStateAbbr: "Cold Spring, MN",
  },
  {
    zip: "56321",
    ST: "MN",
    cityWithStateAbbr: "Collegeville, MN",
  },
  {
    zip: "56323",
    ST: "MN",
    cityWithStateAbbr: "Cyrus, MN",
  },
  {
    zip: "56324",
    ST: "MN",
    cityWithStateAbbr: "Dalton, MN",
  },
  {
    zip: "56325",
    ST: "MN",
    cityWithStateAbbr: "Elrosa, MN",
  },
  {
    zip: "56326",
    ST: "MN",
    cityWithStateAbbr: "Evansville, MN",
  },
  {
    zip: "56327",
    ST: "MN",
    cityWithStateAbbr: "Farwell, MN",
  },
  {
    zip: "56328",
    ST: "MN",
    cityWithStateAbbr: "Flensburg, MN",
  },
  {
    zip: "56329",
    ST: "MN",
    cityWithStateAbbr: "Foley, MN",
  },
  {
    zip: "56330",
    ST: "MN",
    cityWithStateAbbr: "Foreston, MN",
  },
  {
    zip: "56331",
    ST: "MN",
    cityWithStateAbbr: "Freeport, MN",
  },
  {
    zip: "56332",
    ST: "MN",
    cityWithStateAbbr: "Garfield, MN",
  },
  {
    zip: "56333",
    ST: "MN",
    cityWithStateAbbr: "Gilman, MN",
  },
  {
    zip: "56334",
    ST: "MN",
    cityWithStateAbbr: "Glenwood, MN",
  },
  {
    zip: "56335",
    ST: "MN",
    cityWithStateAbbr: "Greenwald, MN",
  },
  {
    zip: "56336",
    ST: "MN",
    cityWithStateAbbr: "Grey Eagle, MN",
  },
  {
    zip: "56338",
    ST: "MN",
    cityWithStateAbbr: "Hillman, MN",
  },
  {
    zip: "56339",
    ST: "MN",
    cityWithStateAbbr: "Hoffman, MN",
  },
  {
    zip: "56340",
    ST: "MN",
    cityWithStateAbbr: "Holdingford, MN",
  },
  {
    zip: "56341",
    ST: "MN",
    cityWithStateAbbr: "Holmes City, MN",
  },
  {
    zip: "56342",
    ST: "MN",
    cityWithStateAbbr: "Isle, MN",
  },
  {
    zip: "56343",
    ST: "MN",
    cityWithStateAbbr: "Kensington, MN",
  },
  {
    zip: "56344",
    ST: "MN",
    cityWithStateAbbr: "Lastrup, MN",
  },
  {
    zip: "56345",
    ST: "MN",
    cityWithStateAbbr: "Little Falls, MN",
  },
  {
    zip: "56347",
    ST: "MN",
    cityWithStateAbbr: "Long Prairie, MN",
  },
  {
    zip: "56349",
    ST: "MN",
    cityWithStateAbbr: "Lowry, MN",
  },
  {
    zip: "56350",
    ST: "MN",
    cityWithStateAbbr: "Mc Grath, MN",
  },
  {
    zip: "56352",
    ST: "MN",
    cityWithStateAbbr: "Melrose, MN",
  },
  {
    zip: "56353",
    ST: "MN",
    cityWithStateAbbr: "Milaca, MN",
  },
  {
    zip: "56354",
    ST: "MN",
    cityWithStateAbbr: "Miltona, MN",
  },
  {
    zip: "56355",
    ST: "MN",
    cityWithStateAbbr: "Nelson, MN",
  },
  {
    zip: "56356",
    ST: "MN",
    cityWithStateAbbr: "New Munich, MN",
  },
  {
    zip: "56357",
    ST: "MN",
    cityWithStateAbbr: "Oak Park, MN",
  },
  {
    zip: "56358",
    ST: "MN",
    cityWithStateAbbr: "Ogilvie, MN",
  },
  {
    zip: "56359",
    ST: "MN",
    cityWithStateAbbr: "Onamia, MN",
  },
  {
    zip: "56360",
    ST: "MN",
    cityWithStateAbbr: "Osakis, MN",
  },
  {
    zip: "56361",
    ST: "MN",
    cityWithStateAbbr: "Parkers Prairie, MN",
  },
  {
    zip: "56362",
    ST: "MN",
    cityWithStateAbbr: "Paynesville, MN",
  },
  {
    zip: "56363",
    ST: "MN",
    cityWithStateAbbr: "Pease, MN",
  },
  {
    zip: "56364",
    ST: "MN",
    cityWithStateAbbr: "Pierz, MN",
  },
  {
    zip: "56367",
    ST: "MN",
    cityWithStateAbbr: "Rice, MN",
  },
  {
    zip: "56368",
    ST: "MN",
    cityWithStateAbbr: "Richmond, MN",
  },
  {
    zip: "56369",
    ST: "MN",
    cityWithStateAbbr: "Rockville, MN",
  },
  {
    zip: "56371",
    ST: "MN",
    cityWithStateAbbr: "Roscoe, MN",
  },
  {
    zip: "56372",
    ST: "MN",
    cityWithStateAbbr: "Saint Cloud, MN",
  },
  {
    zip: "56373",
    ST: "MN",
    cityWithStateAbbr: "Royalton, MN",
  },
  {
    zip: "56374",
    ST: "MN",
    cityWithStateAbbr: "Saint Joseph, MN",
  },
  {
    zip: "56375",
    ST: "MN",
    cityWithStateAbbr: "Saint Stephen, MN",
  },
  {
    zip: "56376",
    ST: "MN",
    cityWithStateAbbr: "Saint Martin, MN",
  },
  {
    zip: "56377",
    ST: "MN",
    cityWithStateAbbr: "Sartell, MN",
  },
  {
    zip: "56378",
    ST: "MN",
    cityWithStateAbbr: "Sauk Centre, MN",
  },
  {
    zip: "56379",
    ST: "MN",
    cityWithStateAbbr: "Sauk Rapids, MN",
  },
  {
    zip: "56381",
    ST: "MN",
    cityWithStateAbbr: "Starbuck, MN",
  },
  {
    zip: "56382",
    ST: "MN",
    cityWithStateAbbr: "Swanville, MN",
  },
  {
    zip: "56384",
    ST: "MN",
    cityWithStateAbbr: "Upsala, MN",
  },
  {
    zip: "56385",
    ST: "MN",
    cityWithStateAbbr: "Villard, MN",
  },
  {
    zip: "56386",
    ST: "MN",
    cityWithStateAbbr: "Wahkon, MN",
  },
  {
    zip: "56387",
    ST: "MN",
    cityWithStateAbbr: "Waite Park, MN",
  },
  {
    zip: "56388",
    ST: "MN",
    cityWithStateAbbr: "Waite Park, MN",
  },
  {
    zip: "56389",
    ST: "MN",
    cityWithStateAbbr: "West Union, MN",
  },
  {
    zip: "56393",
    ST: "MN",
    cityWithStateAbbr: "Saint Cloud, MN",
  },
  {
    zip: "56395",
    ST: "MN",
    cityWithStateAbbr: "Saint Cloud, MN",
  },
  {
    zip: "56396",
    ST: "MN",
    cityWithStateAbbr: "Saint Cloud, MN",
  },
  {
    zip: "56397",
    ST: "MN",
    cityWithStateAbbr: "Saint Cloud, MN",
  },
  {
    zip: "56398",
    ST: "MN",
    cityWithStateAbbr: "Saint Cloud, MN",
  },
  {
    zip: "56399",
    ST: "MN",
    cityWithStateAbbr: "Saint Cloud, MN",
  },
  {
    zip: "56401",
    ST: "MN",
    cityWithStateAbbr: "Brainerd, MN",
  },
  {
    zip: "56425",
    ST: "MN",
    cityWithStateAbbr: "Baxter, MN",
  },
  {
    zip: "56430",
    ST: "MN",
    cityWithStateAbbr: "Ah Gwah Ching, MN",
  },
  {
    zip: "56431",
    ST: "MN",
    cityWithStateAbbr: "Aitkin, MN",
  },
  {
    zip: "56433",
    ST: "MN",
    cityWithStateAbbr: "Akeley, MN",
  },
  {
    zip: "56434",
    ST: "MN",
    cityWithStateAbbr: "Aldrich, MN",
  },
  {
    zip: "56435",
    ST: "MN",
    cityWithStateAbbr: "Backus, MN",
  },
  {
    zip: "56436",
    ST: "MN",
    cityWithStateAbbr: "Benedict, MN",
  },
  {
    zip: "56437",
    ST: "MN",
    cityWithStateAbbr: "Bertha, MN",
  },
  {
    zip: "56438",
    ST: "MN",
    cityWithStateAbbr: "Browerville, MN",
  },
  {
    zip: "56440",
    ST: "MN",
    cityWithStateAbbr: "Clarissa, MN",
  },
  {
    zip: "56441",
    ST: "MN",
    cityWithStateAbbr: "Crosby, MN",
  },
  {
    zip: "56442",
    ST: "MN",
    cityWithStateAbbr: "Crosslake, MN",
  },
  {
    zip: "56443",
    ST: "MN",
    cityWithStateAbbr: "Cushing, MN",
  },
  {
    zip: "56444",
    ST: "MN",
    cityWithStateAbbr: "Deerwood, MN",
  },
  {
    zip: "56446",
    ST: "MN",
    cityWithStateAbbr: "Eagle Bend, MN",
  },
  {
    zip: "56447",
    ST: "MN",
    cityWithStateAbbr: "Emily, MN",
  },
  {
    zip: "56448",
    ST: "MN",
    cityWithStateAbbr: "Fifty Lakes, MN",
  },
  {
    zip: "56449",
    ST: "MN",
    cityWithStateAbbr: "Fort Ripley, MN",
  },
  {
    zip: "56450",
    ST: "MN",
    cityWithStateAbbr: "Garrison, MN",
  },
  {
    zip: "56452",
    ST: "MN",
    cityWithStateAbbr: "Hackensack, MN",
  },
  {
    zip: "56453",
    ST: "MN",
    cityWithStateAbbr: "Hewitt, MN",
  },
  {
    zip: "56455",
    ST: "MN",
    cityWithStateAbbr: "Ironton, MN",
  },
  {
    zip: "56456",
    ST: "MN",
    cityWithStateAbbr: "Jenkins, MN",
  },
  {
    zip: "56458",
    ST: "MN",
    cityWithStateAbbr: "Lake George, MN",
  },
  {
    zip: "56459",
    ST: "MN",
    cityWithStateAbbr: "Lake Hubert, MN",
  },
  {
    zip: "56461",
    ST: "MN",
    cityWithStateAbbr: "Laporte, MN",
  },
  {
    zip: "56464",
    ST: "MN",
    cityWithStateAbbr: "Menahga, MN",
  },
  {
    zip: "56465",
    ST: "MN",
    cityWithStateAbbr: "Merrifield, MN",
  },
  {
    zip: "56466",
    ST: "MN",
    cityWithStateAbbr: "Motley, MN",
  },
  {
    zip: "56467",
    ST: "MN",
    cityWithStateAbbr: "Nevis, MN",
  },
  {
    zip: "56468",
    ST: "MN",
    cityWithStateAbbr: "Nisswa, MN",
  },
  {
    zip: "56469",
    ST: "MN",
    cityWithStateAbbr: "Palisade, MN",
  },
  {
    zip: "56470",
    ST: "MN",
    cityWithStateAbbr: "Park Rapids, MN",
  },
  {
    zip: "56472",
    ST: "MN",
    cityWithStateAbbr: "Pequot Lakes, MN",
  },
  {
    zip: "56473",
    ST: "MN",
    cityWithStateAbbr: "Pillager, MN",
  },
  {
    zip: "56474",
    ST: "MN",
    cityWithStateAbbr: "Pine River, MN",
  },
  {
    zip: "56475",
    ST: "MN",
    cityWithStateAbbr: "Randall, MN",
  },
  {
    zip: "56477",
    ST: "MN",
    cityWithStateAbbr: "Sebeka, MN",
  },
  {
    zip: "56478",
    ST: "MN",
    cityWithStateAbbr: "Nimrod, MN",
  },
  {
    zip: "56479",
    ST: "MN",
    cityWithStateAbbr: "Staples, MN",
  },
  {
    zip: "56481",
    ST: "MN",
    cityWithStateAbbr: "Verndale, MN",
  },
  {
    zip: "56482",
    ST: "MN",
    cityWithStateAbbr: "Wadena, MN",
  },
  {
    zip: "56484",
    ST: "MN",
    cityWithStateAbbr: "Walker, MN",
  },
  {
    zip: "56501",
    ST: "MN",
    cityWithStateAbbr: "Detroit Lakes, MN",
  },
  {
    zip: "56502",
    ST: "MN",
    cityWithStateAbbr: "Detroit Lakes, MN",
  },
  {
    zip: "56510",
    ST: "MN",
    cityWithStateAbbr: "Ada, MN",
  },
  {
    zip: "56511",
    ST: "MN",
    cityWithStateAbbr: "Audubon, MN",
  },
  {
    zip: "56514",
    ST: "MN",
    cityWithStateAbbr: "Barnesville, MN",
  },
  {
    zip: "56515",
    ST: "MN",
    cityWithStateAbbr: "Battle Lake, MN",
  },
  {
    zip: "56516",
    ST: "MN",
    cityWithStateAbbr: "Bejou, MN",
  },
  {
    zip: "56517",
    ST: "MN",
    cityWithStateAbbr: "Beltrami, MN",
  },
  {
    zip: "56518",
    ST: "MN",
    cityWithStateAbbr: "Bluffton, MN",
  },
  {
    zip: "56519",
    ST: "MN",
    cityWithStateAbbr: "Borup, MN",
  },
  {
    zip: "56520",
    ST: "MN",
    cityWithStateAbbr: "Breckenridge, MN",
  },
  {
    zip: "56521",
    ST: "MN",
    cityWithStateAbbr: "Callaway, MN",
  },
  {
    zip: "56522",
    ST: "MN",
    cityWithStateAbbr: "Campbell, MN",
  },
  {
    zip: "56523",
    ST: "MN",
    cityWithStateAbbr: "Climax, MN",
  },
  {
    zip: "56524",
    ST: "MN",
    cityWithStateAbbr: "Clitherall, MN",
  },
  {
    zip: "56525",
    ST: "MN",
    cityWithStateAbbr: "Comstock, MN",
  },
  {
    zip: "56527",
    ST: "MN",
    cityWithStateAbbr: "Deer Creek, MN",
  },
  {
    zip: "56528",
    ST: "MN",
    cityWithStateAbbr: "Dent, MN",
  },
  {
    zip: "56529",
    ST: "MN",
    cityWithStateAbbr: "Dilworth, MN",
  },
  {
    zip: "56531",
    ST: "MN",
    cityWithStateAbbr: "Elbow Lake, MN",
  },
  {
    zip: "56533",
    ST: "MN",
    cityWithStateAbbr: "Elizabeth, MN",
  },
  {
    zip: "56534",
    ST: "MN",
    cityWithStateAbbr: "Erhard, MN",
  },
  {
    zip: "56535",
    ST: "MN",
    cityWithStateAbbr: "Erskine, MN",
  },
  {
    zip: "56536",
    ST: "MN",
    cityWithStateAbbr: "Felton, MN",
  },
  {
    zip: "56537",
    ST: "MN",
    cityWithStateAbbr: "Fergus Falls, MN",
  },
  {
    zip: "56538",
    ST: "MN",
    cityWithStateAbbr: "Fergus Falls, MN",
  },
  {
    zip: "56540",
    ST: "MN",
    cityWithStateAbbr: "Fertile, MN",
  },
  {
    zip: "56541",
    ST: "MN",
    cityWithStateAbbr: "Flom, MN",
  },
  {
    zip: "56542",
    ST: "MN",
    cityWithStateAbbr: "Fosston, MN",
  },
  {
    zip: "56543",
    ST: "MN",
    cityWithStateAbbr: "Foxhome, MN",
  },
  {
    zip: "56544",
    ST: "MN",
    cityWithStateAbbr: "Frazee, MN",
  },
  {
    zip: "56545",
    ST: "MN",
    cityWithStateAbbr: "Gary, MN",
  },
  {
    zip: "56546",
    ST: "MN",
    cityWithStateAbbr: "Georgetown, MN",
  },
  {
    zip: "56547",
    ST: "MN",
    cityWithStateAbbr: "Glyndon, MN",
  },
  {
    zip: "56548",
    ST: "MN",
    cityWithStateAbbr: "Halstad, MN",
  },
  {
    zip: "56549",
    ST: "MN",
    cityWithStateAbbr: "Hawley, MN",
  },
  {
    zip: "56550",
    ST: "MN",
    cityWithStateAbbr: "Hendrum, MN",
  },
  {
    zip: "56551",
    ST: "MN",
    cityWithStateAbbr: "Henning, MN",
  },
  {
    zip: "56552",
    ST: "MN",
    cityWithStateAbbr: "Hitterdal, MN",
  },
  {
    zip: "56553",
    ST: "MN",
    cityWithStateAbbr: "Kent, MN",
  },
  {
    zip: "56554",
    ST: "MN",
    cityWithStateAbbr: "Lake Park, MN",
  },
  {
    zip: "56556",
    ST: "MN",
    cityWithStateAbbr: "Mcintosh, MN",
  },
  {
    zip: "56557",
    ST: "MN",
    cityWithStateAbbr: "Mahnomen, MN",
  },
  {
    zip: "56560",
    ST: "MN",
    cityWithStateAbbr: "Moorhead, MN",
  },
  {
    zip: "56561",
    ST: "MN",
    cityWithStateAbbr: "Moorhead, MN",
  },
  {
    zip: "56562",
    ST: "MN",
    cityWithStateAbbr: "Moorhead, MN",
  },
  {
    zip: "56563",
    ST: "MN",
    cityWithStateAbbr: "Moorhead, MN",
  },
  {
    zip: "56565",
    ST: "MN",
    cityWithStateAbbr: "Nashua, MN",
  },
  {
    zip: "56566",
    ST: "MN",
    cityWithStateAbbr: "Naytahwaush, MN",
  },
  {
    zip: "56567",
    ST: "MN",
    cityWithStateAbbr: "New York Mills, MN",
  },
  {
    zip: "56568",
    ST: "MN",
    cityWithStateAbbr: "Nielsville, MN",
  },
  {
    zip: "56569",
    ST: "MN",
    cityWithStateAbbr: "Ogema, MN",
  },
  {
    zip: "56570",
    ST: "MN",
    cityWithStateAbbr: "Osage, MN",
  },
  {
    zip: "56571",
    ST: "MN",
    cityWithStateAbbr: "Ottertail, MN",
  },
  {
    zip: "56572",
    ST: "MN",
    cityWithStateAbbr: "Pelican Rapids, MN",
  },
  {
    zip: "56573",
    ST: "MN",
    cityWithStateAbbr: "Perham, MN",
  },
  {
    zip: "56574",
    ST: "MN",
    cityWithStateAbbr: "Perley, MN",
  },
  {
    zip: "56575",
    ST: "MN",
    cityWithStateAbbr: "Ponsford, MN",
  },
  {
    zip: "56576",
    ST: "MN",
    cityWithStateAbbr: "Richville, MN",
  },
  {
    zip: "56577",
    ST: "MN",
    cityWithStateAbbr: "Richwood, MN",
  },
  {
    zip: "56578",
    ST: "MN",
    cityWithStateAbbr: "Rochert, MN",
  },
  {
    zip: "56579",
    ST: "MN",
    cityWithStateAbbr: "Rothsay, MN",
  },
  {
    zip: "56580",
    ST: "MN",
    cityWithStateAbbr: "Sabin, MN",
  },
  {
    zip: "56581",
    ST: "MN",
    cityWithStateAbbr: "Shelly, MN",
  },
  {
    zip: "56583",
    ST: "MN",
    cityWithStateAbbr: "Tintah, MN",
  },
  {
    zip: "56584",
    ST: "MN",
    cityWithStateAbbr: "Twin Valley, MN",
  },
  {
    zip: "56585",
    ST: "MN",
    cityWithStateAbbr: "Ulen, MN",
  },
  {
    zip: "56586",
    ST: "MN",
    cityWithStateAbbr: "Underwood, MN",
  },
  {
    zip: "56587",
    ST: "MN",
    cityWithStateAbbr: "Vergas, MN",
  },
  {
    zip: "56588",
    ST: "MN",
    cityWithStateAbbr: "Vining, MN",
  },
  {
    zip: "56589",
    ST: "MN",
    cityWithStateAbbr: "Waubun, MN",
  },
  {
    zip: "56590",
    ST: "MN",
    cityWithStateAbbr: "Wendell, MN",
  },
  {
    zip: "56591",
    ST: "MN",
    cityWithStateAbbr: "White Earth, MN",
  },
  {
    zip: "56592",
    ST: "MN",
    cityWithStateAbbr: "Winger, MN",
  },
  {
    zip: "56593",
    ST: "MN",
    cityWithStateAbbr: "Wolf Lake, MN",
  },
  {
    zip: "56594",
    ST: "MN",
    cityWithStateAbbr: "Wolverton, MN",
  },
  {
    zip: "56601",
    ST: "MN",
    cityWithStateAbbr: "Bemidji, MN",
  },
  {
    zip: "56619",
    ST: "MN",
    cityWithStateAbbr: "Bemidji, MN",
  },
  {
    zip: "56621",
    ST: "MN",
    cityWithStateAbbr: "Bagley, MN",
  },
  {
    zip: "56623",
    ST: "MN",
    cityWithStateAbbr: "Baudette, MN",
  },
  {
    zip: "56626",
    ST: "MN",
    cityWithStateAbbr: "Bena, MN",
  },
  {
    zip: "56627",
    ST: "MN",
    cityWithStateAbbr: "Big Falls, MN",
  },
  {
    zip: "56628",
    ST: "MN",
    cityWithStateAbbr: "Bigfork, MN",
  },
  {
    zip: "56629",
    ST: "MN",
    cityWithStateAbbr: "Birchdale, MN",
  },
  {
    zip: "56630",
    ST: "MN",
    cityWithStateAbbr: "Blackduck, MN",
  },
  {
    zip: "56631",
    ST: "MN",
    cityWithStateAbbr: "Bowstring, MN",
  },
  {
    zip: "56633",
    ST: "MN",
    cityWithStateAbbr: "Cass Lake, MN",
  },
  {
    zip: "56634",
    ST: "MN",
    cityWithStateAbbr: "Clearbrook, MN",
  },
  {
    zip: "56636",
    ST: "MN",
    cityWithStateAbbr: "Deer River, MN",
  },
  {
    zip: "56637",
    ST: "MN",
    cityWithStateAbbr: "Talmoon, MN",
  },
  {
    zip: "56639",
    ST: "MN",
    cityWithStateAbbr: "Effie, MN",
  },
  {
    zip: "56641",
    ST: "MN",
    cityWithStateAbbr: "Federal Dam, MN",
  },
  {
    zip: "56644",
    ST: "MN",
    cityWithStateAbbr: "Gonvick, MN",
  },
  {
    zip: "56646",
    ST: "MN",
    cityWithStateAbbr: "Gully, MN",
  },
  {
    zip: "56647",
    ST: "MN",
    cityWithStateAbbr: "Hines, MN",
  },
  {
    zip: "56649",
    ST: "MN",
    cityWithStateAbbr: "International Falls, MN",
  },
  {
    zip: "56650",
    ST: "MN",
    cityWithStateAbbr: "Kelliher, MN",
  },
  {
    zip: "56651",
    ST: "MN",
    cityWithStateAbbr: "Lengby, MN",
  },
  {
    zip: "56652",
    ST: "MN",
    cityWithStateAbbr: "Leonard, MN",
  },
  {
    zip: "56653",
    ST: "MN",
    cityWithStateAbbr: "Littlefork, MN",
  },
  {
    zip: "56654",
    ST: "MN",
    cityWithStateAbbr: "Loman, MN",
  },
  {
    zip: "56655",
    ST: "MN",
    cityWithStateAbbr: "Longville, MN",
  },
  {
    zip: "56657",
    ST: "MN",
    cityWithStateAbbr: "Marcell, MN",
  },
  {
    zip: "56658",
    ST: "MN",
    cityWithStateAbbr: "Margie, MN",
  },
  {
    zip: "56659",
    ST: "MN",
    cityWithStateAbbr: "Max, MN",
  },
  {
    zip: "56660",
    ST: "MN",
    cityWithStateAbbr: "Mizpah, MN",
  },
  {
    zip: "56661",
    ST: "MN",
    cityWithStateAbbr: "Northome, MN",
  },
  {
    zip: "56662",
    ST: "MN",
    cityWithStateAbbr: "Outing, MN",
  },
  {
    zip: "56663",
    ST: "MN",
    cityWithStateAbbr: "Pennington, MN",
  },
  {
    zip: "56666",
    ST: "MN",
    cityWithStateAbbr: "Ponemah, MN",
  },
  {
    zip: "56667",
    ST: "MN",
    cityWithStateAbbr: "Puposky, MN",
  },
  {
    zip: "56668",
    ST: "MN",
    cityWithStateAbbr: "Ranier, MN",
  },
  {
    zip: "56669",
    ST: "MN",
    cityWithStateAbbr: "Kabetogama, MN",
  },
  {
    zip: "56670",
    ST: "MN",
    cityWithStateAbbr: "Redby, MN",
  },
  {
    zip: "56671",
    ST: "MN",
    cityWithStateAbbr: "Redlake, MN",
  },
  {
    zip: "56672",
    ST: "MN",
    cityWithStateAbbr: "Remer, MN",
  },
  {
    zip: "56673",
    ST: "MN",
    cityWithStateAbbr: "Roosevelt, MN",
  },
  {
    zip: "56676",
    ST: "MN",
    cityWithStateAbbr: "Shevlin, MN",
  },
  {
    zip: "56678",
    ST: "MN",
    cityWithStateAbbr: "Solway, MN",
  },
  {
    zip: "56679",
    ST: "MN",
    cityWithStateAbbr: "South International Fall, MN",
  },
  {
    zip: "56680",
    ST: "MN",
    cityWithStateAbbr: "Spring Lake, MN",
  },
  {
    zip: "56681",
    ST: "MN",
    cityWithStateAbbr: "Squaw Lake, MN",
  },
  {
    zip: "56682",
    ST: "MN",
    cityWithStateAbbr: "Swift, MN",
  },
  {
    zip: "56683",
    ST: "MN",
    cityWithStateAbbr: "Tenstrike, MN",
  },
  {
    zip: "56684",
    ST: "MN",
    cityWithStateAbbr: "Trail, MN",
  },
  {
    zip: "56685",
    ST: "MN",
    cityWithStateAbbr: "Waskish, MN",
  },
  {
    zip: "56686",
    ST: "MN",
    cityWithStateAbbr: "Williams, MN",
  },
  {
    zip: "56687",
    ST: "MN",
    cityWithStateAbbr: "Wilton, MN",
  },
  {
    zip: "56688",
    ST: "MN",
    cityWithStateAbbr: "Wirt, MN",
  },
  {
    zip: "56701",
    ST: "MN",
    cityWithStateAbbr: "Thief River Falls, MN",
  },
  {
    zip: "56710",
    ST: "MN",
    cityWithStateAbbr: "Alvarado, MN",
  },
  {
    zip: "56711",
    ST: "MN",
    cityWithStateAbbr: "Angle Inlet, MN",
  },
  {
    zip: "56713",
    ST: "MN",
    cityWithStateAbbr: "Argyle, MN",
  },
  {
    zip: "56714",
    ST: "MN",
    cityWithStateAbbr: "Badger, MN",
  },
  {
    zip: "56715",
    ST: "MN",
    cityWithStateAbbr: "Brooks, MN",
  },
  {
    zip: "56716",
    ST: "MN",
    cityWithStateAbbr: "Crookston, MN",
  },
  {
    zip: "56720",
    ST: "MN",
    cityWithStateAbbr: "Donaldson, MN",
  },
  {
    zip: "56721",
    ST: "MN",
    cityWithStateAbbr: "East Grand Forks, MN",
  },
  {
    zip: "56722",
    ST: "MN",
    cityWithStateAbbr: "Euclid, MN",
  },
  {
    zip: "56723",
    ST: "MN",
    cityWithStateAbbr: "Fisher, MN",
  },
  {
    zip: "56724",
    ST: "MN",
    cityWithStateAbbr: "Gatzke, MN",
  },
  {
    zip: "56725",
    ST: "MN",
    cityWithStateAbbr: "Goodridge, MN",
  },
  {
    zip: "56726",
    ST: "MN",
    cityWithStateAbbr: "Greenbush, MN",
  },
  {
    zip: "56727",
    ST: "MN",
    cityWithStateAbbr: "Grygla, MN",
  },
  {
    zip: "56728",
    ST: "MN",
    cityWithStateAbbr: "Hallock, MN",
  },
  {
    zip: "56729",
    ST: "MN",
    cityWithStateAbbr: "Halma, MN",
  },
  {
    zip: "56731",
    ST: "MN",
    cityWithStateAbbr: "Humboldt, MN",
  },
  {
    zip: "56732",
    ST: "MN",
    cityWithStateAbbr: "Karlstad, MN",
  },
  {
    zip: "56733",
    ST: "MN",
    cityWithStateAbbr: "Kennedy, MN",
  },
  {
    zip: "56734",
    ST: "MN",
    cityWithStateAbbr: "Lake Bronson, MN",
  },
  {
    zip: "56735",
    ST: "MN",
    cityWithStateAbbr: "Lancaster, MN",
  },
  {
    zip: "56736",
    ST: "MN",
    cityWithStateAbbr: "Mentor, MN",
  },
  {
    zip: "56737",
    ST: "MN",
    cityWithStateAbbr: "Middle River, MN",
  },
  {
    zip: "56738",
    ST: "MN",
    cityWithStateAbbr: "Newfolden, MN",
  },
  {
    zip: "56740",
    ST: "MN",
    cityWithStateAbbr: "Noyes, MN",
  },
  {
    zip: "56741",
    ST: "MN",
    cityWithStateAbbr: "Oak Island, MN",
  },
  {
    zip: "56742",
    ST: "MN",
    cityWithStateAbbr: "Oklee, MN",
  },
  {
    zip: "56744",
    ST: "MN",
    cityWithStateAbbr: "Oslo, MN",
  },
  {
    zip: "56748",
    ST: "MN",
    cityWithStateAbbr: "Plummer, MN",
  },
  {
    zip: "56750",
    ST: "MN",
    cityWithStateAbbr: "Red Lake Falls, MN",
  },
  {
    zip: "56751",
    ST: "MN",
    cityWithStateAbbr: "Roseau, MN",
  },
  {
    zip: "56754",
    ST: "MN",
    cityWithStateAbbr: "Saint Hilaire, MN",
  },
  {
    zip: "56755",
    ST: "MN",
    cityWithStateAbbr: "Saint Vincent, MN",
  },
  {
    zip: "56756",
    ST: "MN",
    cityWithStateAbbr: "Salol, MN",
  },
  {
    zip: "56757",
    ST: "MN",
    cityWithStateAbbr: "Stephen, MN",
  },
  {
    zip: "56758",
    ST: "MN",
    cityWithStateAbbr: "Strandquist, MN",
  },
  {
    zip: "56759",
    ST: "MN",
    cityWithStateAbbr: "Strathcona, MN",
  },
  {
    zip: "56760",
    ST: "MN",
    cityWithStateAbbr: "Viking, MN",
  },
  {
    zip: "56761",
    ST: "MN",
    cityWithStateAbbr: "Wannaska, MN",
  },
  {
    zip: "56762",
    ST: "MN",
    cityWithStateAbbr: "Warren, MN",
  },
  {
    zip: "56763",
    ST: "MN",
    cityWithStateAbbr: "Warroad, MN",
  },
  {
    zip: "56901",
    ST: "DC",
    cityWithStateAbbr: "Parcel Return Service, DC",
  },
  {
    zip: "56915",
    ST: "DC",
    cityWithStateAbbr: "Parcel Return Service, DC",
  },
  {
    zip: "56920",
    ST: "DC",
    cityWithStateAbbr: "Parcel Return Service, DC",
  },
  {
    zip: "56933",
    ST: "DC",
    cityWithStateAbbr: "Parcel Return Service, DC",
  },
  {
    zip: "57001",
    ST: "SD",
    cityWithStateAbbr: "Alcester, SD",
  },
  {
    zip: "57002",
    ST: "SD",
    cityWithStateAbbr: "Aurora, SD",
  },
  {
    zip: "57003",
    ST: "SD",
    cityWithStateAbbr: "Baltic, SD",
  },
  {
    zip: "57004",
    ST: "SD",
    cityWithStateAbbr: "Beresford, SD",
  },
  {
    zip: "57005",
    ST: "SD",
    cityWithStateAbbr: "Brandon, SD",
  },
  {
    zip: "57006",
    ST: "SD",
    cityWithStateAbbr: "Brookings, SD",
  },
  {
    zip: "57007",
    ST: "SD",
    cityWithStateAbbr: "Brookings, SD",
  },
  {
    zip: "57010",
    ST: "SD",
    cityWithStateAbbr: "Burbank, SD",
  },
  {
    zip: "57012",
    ST: "SD",
    cityWithStateAbbr: "Canistota, SD",
  },
  {
    zip: "57013",
    ST: "SD",
    cityWithStateAbbr: "Canton, SD",
  },
  {
    zip: "57014",
    ST: "SD",
    cityWithStateAbbr: "Centerville, SD",
  },
  {
    zip: "57015",
    ST: "SD",
    cityWithStateAbbr: "Chancellor, SD",
  },
  {
    zip: "57016",
    ST: "SD",
    cityWithStateAbbr: "Chester, SD",
  },
  {
    zip: "57017",
    ST: "SD",
    cityWithStateAbbr: "Colman, SD",
  },
  {
    zip: "57018",
    ST: "SD",
    cityWithStateAbbr: "Colton, SD",
  },
  {
    zip: "57020",
    ST: "SD",
    cityWithStateAbbr: "Crooks, SD",
  },
  {
    zip: "57021",
    ST: "SD",
    cityWithStateAbbr: "Davis, SD",
  },
  {
    zip: "57022",
    ST: "SD",
    cityWithStateAbbr: "Dell Rapids, SD",
  },
  {
    zip: "57024",
    ST: "SD",
    cityWithStateAbbr: "Egan, SD",
  },
  {
    zip: "57025",
    ST: "SD",
    cityWithStateAbbr: "Elk Point, SD",
  },
  {
    zip: "57026",
    ST: "SD",
    cityWithStateAbbr: "Elkton, SD",
  },
  {
    zip: "57027",
    ST: "SD",
    cityWithStateAbbr: "Fairview, SD",
  },
  {
    zip: "57028",
    ST: "SD",
    cityWithStateAbbr: "Flandreau, SD",
  },
  {
    zip: "57029",
    ST: "SD",
    cityWithStateAbbr: "Freeman, SD",
  },
  {
    zip: "57030",
    ST: "SD",
    cityWithStateAbbr: "Garretson, SD",
  },
  {
    zip: "57031",
    ST: "SD",
    cityWithStateAbbr: "Gayville, SD",
  },
  {
    zip: "57032",
    ST: "SD",
    cityWithStateAbbr: "Harrisburg, SD",
  },
  {
    zip: "57033",
    ST: "SD",
    cityWithStateAbbr: "Hartford, SD",
  },
  {
    zip: "57034",
    ST: "SD",
    cityWithStateAbbr: "Hudson, SD",
  },
  {
    zip: "57035",
    ST: "SD",
    cityWithStateAbbr: "Humboldt, SD",
  },
  {
    zip: "57036",
    ST: "SD",
    cityWithStateAbbr: "Hurley, SD",
  },
  {
    zip: "57037",
    ST: "SD",
    cityWithStateAbbr: "Irene, SD",
  },
  {
    zip: "57038",
    ST: "SD",
    cityWithStateAbbr: "Jefferson, SD",
  },
  {
    zip: "57039",
    ST: "SD",
    cityWithStateAbbr: "Lennox, SD",
  },
  {
    zip: "57040",
    ST: "SD",
    cityWithStateAbbr: "Lesterville, SD",
  },
  {
    zip: "57041",
    ST: "SD",
    cityWithStateAbbr: "Lyons, SD",
  },
  {
    zip: "57042",
    ST: "SD",
    cityWithStateAbbr: "Madison, SD",
  },
  {
    zip: "57043",
    ST: "SD",
    cityWithStateAbbr: "Marion, SD",
  },
  {
    zip: "57045",
    ST: "SD",
    cityWithStateAbbr: "Menno, SD",
  },
  {
    zip: "57046",
    ST: "SD",
    cityWithStateAbbr: "Mission Hill, SD",
  },
  {
    zip: "57047",
    ST: "SD",
    cityWithStateAbbr: "Monroe, SD",
  },
  {
    zip: "57048",
    ST: "SD",
    cityWithStateAbbr: "Montrose, SD",
  },
  {
    zip: "57049",
    ST: "SD",
    cityWithStateAbbr: "North Sioux City, SD",
  },
  {
    zip: "57050",
    ST: "SD",
    cityWithStateAbbr: "Nunda, SD",
  },
  {
    zip: "57051",
    ST: "SD",
    cityWithStateAbbr: "Oldham, SD",
  },
  {
    zip: "57052",
    ST: "SD",
    cityWithStateAbbr: "Olivet, SD",
  },
  {
    zip: "57053",
    ST: "SD",
    cityWithStateAbbr: "Parker, SD",
  },
  {
    zip: "57054",
    ST: "SD",
    cityWithStateAbbr: "Ramona, SD",
  },
  {
    zip: "57055",
    ST: "SD",
    cityWithStateAbbr: "Renner, SD",
  },
  {
    zip: "57057",
    ST: "SD",
    cityWithStateAbbr: "Rutland, SD",
  },
  {
    zip: "57058",
    ST: "SD",
    cityWithStateAbbr: "Salem, SD",
  },
  {
    zip: "57059",
    ST: "SD",
    cityWithStateAbbr: "Scotland, SD",
  },
  {
    zip: "57061",
    ST: "SD",
    cityWithStateAbbr: "Sinai, SD",
  },
  {
    zip: "57062",
    ST: "SD",
    cityWithStateAbbr: "Springfield, SD",
  },
  {
    zip: "57063",
    ST: "SD",
    cityWithStateAbbr: "Tabor, SD",
  },
  {
    zip: "57064",
    ST: "SD",
    cityWithStateAbbr: "Tea, SD",
  },
  {
    zip: "57065",
    ST: "SD",
    cityWithStateAbbr: "Trent, SD",
  },
  {
    zip: "57066",
    ST: "SD",
    cityWithStateAbbr: "Tyndall, SD",
  },
  {
    zip: "57067",
    ST: "SD",
    cityWithStateAbbr: "Utica, SD",
  },
  {
    zip: "57068",
    ST: "SD",
    cityWithStateAbbr: "Valley Springs, SD",
  },
  {
    zip: "57069",
    ST: "SD",
    cityWithStateAbbr: "Vermillion, SD",
  },
  {
    zip: "57070",
    ST: "SD",
    cityWithStateAbbr: "Viborg, SD",
  },
  {
    zip: "57071",
    ST: "SD",
    cityWithStateAbbr: "Volga, SD",
  },
  {
    zip: "57072",
    ST: "SD",
    cityWithStateAbbr: "Volin, SD",
  },
  {
    zip: "57073",
    ST: "SD",
    cityWithStateAbbr: "Wakonda, SD",
  },
  {
    zip: "57075",
    ST: "SD",
    cityWithStateAbbr: "Wentworth, SD",
  },
  {
    zip: "57076",
    ST: "SD",
    cityWithStateAbbr: "Winfred, SD",
  },
  {
    zip: "57077",
    ST: "SD",
    cityWithStateAbbr: "Worthing, SD",
  },
  {
    zip: "57078",
    ST: "SD",
    cityWithStateAbbr: "Yankton, SD",
  },
  {
    zip: "57101",
    ST: "SD",
    cityWithStateAbbr: "Sioux Falls, SD",
  },
  {
    zip: "57103",
    ST: "SD",
    cityWithStateAbbr: "Sioux Falls, SD",
  },
  {
    zip: "57104",
    ST: "SD",
    cityWithStateAbbr: "Sioux Falls, SD",
  },
  {
    zip: "57105",
    ST: "SD",
    cityWithStateAbbr: "Sioux Falls, SD",
  },
  {
    zip: "57106",
    ST: "SD",
    cityWithStateAbbr: "Sioux Falls, SD",
  },
  {
    zip: "57107",
    ST: "SD",
    cityWithStateAbbr: "Sioux Falls, SD",
  },
  {
    zip: "57108",
    ST: "SD",
    cityWithStateAbbr: "Sioux Falls, SD",
  },
  {
    zip: "57109",
    ST: "SD",
    cityWithStateAbbr: "Sioux Falls, SD",
  },
  {
    zip: "57110",
    ST: "SD",
    cityWithStateAbbr: "Sioux Falls, SD",
  },
  {
    zip: "57117",
    ST: "SD",
    cityWithStateAbbr: "Sioux Falls, SD",
  },
  {
    zip: "57118",
    ST: "SD",
    cityWithStateAbbr: "Sioux Falls, SD",
  },
  {
    zip: "57186",
    ST: "SD",
    cityWithStateAbbr: "Sioux Falls, SD",
  },
  {
    zip: "57193",
    ST: "SD",
    cityWithStateAbbr: "Sioux Falls, SD",
  },
  {
    zip: "57197",
    ST: "SD",
    cityWithStateAbbr: "Sioux Falls, SD",
  },
  {
    zip: "57198",
    ST: "SD",
    cityWithStateAbbr: "Sioux Falls, SD",
  },
  {
    zip: "57201",
    ST: "SD",
    cityWithStateAbbr: "Watertown, SD",
  },
  {
    zip: "57212",
    ST: "SD",
    cityWithStateAbbr: "Arlington, SD",
  },
  {
    zip: "57213",
    ST: "SD",
    cityWithStateAbbr: "Astoria, SD",
  },
  {
    zip: "57214",
    ST: "SD",
    cityWithStateAbbr: "Badger, SD",
  },
  {
    zip: "57216",
    ST: "SD",
    cityWithStateAbbr: "Big Stone City, SD",
  },
  {
    zip: "57217",
    ST: "SD",
    cityWithStateAbbr: "Bradley, SD",
  },
  {
    zip: "57218",
    ST: "SD",
    cityWithStateAbbr: "Brandt, SD",
  },
  {
    zip: "57219",
    ST: "SD",
    cityWithStateAbbr: "Bristol, SD",
  },
  {
    zip: "57220",
    ST: "SD",
    cityWithStateAbbr: "Bruce, SD",
  },
  {
    zip: "57221",
    ST: "SD",
    cityWithStateAbbr: "Bryant, SD",
  },
  {
    zip: "57223",
    ST: "SD",
    cityWithStateAbbr: "Castlewood, SD",
  },
  {
    zip: "57224",
    ST: "SD",
    cityWithStateAbbr: "Claire City, SD",
  },
  {
    zip: "57225",
    ST: "SD",
    cityWithStateAbbr: "Clark, SD",
  },
  {
    zip: "57226",
    ST: "SD",
    cityWithStateAbbr: "Clear Lake, SD",
  },
  {
    zip: "57227",
    ST: "SD",
    cityWithStateAbbr: "Corona, SD",
  },
  {
    zip: "57231",
    ST: "SD",
    cityWithStateAbbr: "De Smet, SD",
  },
  {
    zip: "57232",
    ST: "SD",
    cityWithStateAbbr: "Eden, SD",
  },
  {
    zip: "57233",
    ST: "SD",
    cityWithStateAbbr: "Erwin, SD",
  },
  {
    zip: "57234",
    ST: "SD",
    cityWithStateAbbr: "Estelline, SD",
  },
  {
    zip: "57235",
    ST: "SD",
    cityWithStateAbbr: "Florence, SD",
  },
  {
    zip: "57236",
    ST: "SD",
    cityWithStateAbbr: "Garden City, SD",
  },
  {
    zip: "57237",
    ST: "SD",
    cityWithStateAbbr: "Gary, SD",
  },
  {
    zip: "57238",
    ST: "SD",
    cityWithStateAbbr: "Goodwin, SD",
  },
  {
    zip: "57239",
    ST: "SD",
    cityWithStateAbbr: "Grenville, SD",
  },
  {
    zip: "57241",
    ST: "SD",
    cityWithStateAbbr: "Hayti, SD",
  },
  {
    zip: "57242",
    ST: "SD",
    cityWithStateAbbr: "Hazel, SD",
  },
  {
    zip: "57243",
    ST: "SD",
    cityWithStateAbbr: "Henry, SD",
  },
  {
    zip: "57245",
    ST: "SD",
    cityWithStateAbbr: "Kranzburg, SD",
  },
  {
    zip: "57246",
    ST: "SD",
    cityWithStateAbbr: "Labolt, SD",
  },
  {
    zip: "57247",
    ST: "SD",
    cityWithStateAbbr: "Lake City, SD",
  },
  {
    zip: "57248",
    ST: "SD",
    cityWithStateAbbr: "Lake Norden, SD",
  },
  {
    zip: "57249",
    ST: "SD",
    cityWithStateAbbr: "Lake Preston, SD",
  },
  {
    zip: "57251",
    ST: "SD",
    cityWithStateAbbr: "Marvin, SD",
  },
  {
    zip: "57252",
    ST: "SD",
    cityWithStateAbbr: "Milbank, SD",
  },
  {
    zip: "57253",
    ST: "SD",
    cityWithStateAbbr: "Milbank, SD",
  },
  {
    zip: "57255",
    ST: "SD",
    cityWithStateAbbr: "New Effington, SD",
  },
  {
    zip: "57256",
    ST: "SD",
    cityWithStateAbbr: "Ortley, SD",
  },
  {
    zip: "57257",
    ST: "SD",
    cityWithStateAbbr: "Peever, SD",
  },
  {
    zip: "57258",
    ST: "SD",
    cityWithStateAbbr: "Raymond, SD",
  },
  {
    zip: "57259",
    ST: "SD",
    cityWithStateAbbr: "Revillo, SD",
  },
  {
    zip: "57260",
    ST: "SD",
    cityWithStateAbbr: "Rosholt, SD",
  },
  {
    zip: "57261",
    ST: "SD",
    cityWithStateAbbr: "Roslyn, SD",
  },
  {
    zip: "57262",
    ST: "SD",
    cityWithStateAbbr: "Sisseton, SD",
  },
  {
    zip: "57263",
    ST: "SD",
    cityWithStateAbbr: "South Shore, SD",
  },
  {
    zip: "57264",
    ST: "SD",
    cityWithStateAbbr: "Stockholm, SD",
  },
  {
    zip: "57265",
    ST: "SD",
    cityWithStateAbbr: "Strandburg, SD",
  },
  {
    zip: "57266",
    ST: "SD",
    cityWithStateAbbr: "Summit, SD",
  },
  {
    zip: "57268",
    ST: "SD",
    cityWithStateAbbr: "Toronto, SD",
  },
  {
    zip: "57269",
    ST: "SD",
    cityWithStateAbbr: "Twin Brooks, SD",
  },
  {
    zip: "57270",
    ST: "SD",
    cityWithStateAbbr: "Veblen, SD",
  },
  {
    zip: "57271",
    ST: "SD",
    cityWithStateAbbr: "Vienna, SD",
  },
  {
    zip: "57272",
    ST: "SD",
    cityWithStateAbbr: "Wallace, SD",
  },
  {
    zip: "57273",
    ST: "SD",
    cityWithStateAbbr: "Waubay, SD",
  },
  {
    zip: "57274",
    ST: "SD",
    cityWithStateAbbr: "Webster, SD",
  },
  {
    zip: "57276",
    ST: "SD",
    cityWithStateAbbr: "White, SD",
  },
  {
    zip: "57278",
    ST: "SD",
    cityWithStateAbbr: "Willow Lake, SD",
  },
  {
    zip: "57279",
    ST: "SD",
    cityWithStateAbbr: "Wilmot, SD",
  },
  {
    zip: "57301",
    ST: "SD",
    cityWithStateAbbr: "Mitchell, SD",
  },
  {
    zip: "57311",
    ST: "SD",
    cityWithStateAbbr: "Alexandria, SD",
  },
  {
    zip: "57312",
    ST: "SD",
    cityWithStateAbbr: "Alpena, SD",
  },
  {
    zip: "57313",
    ST: "SD",
    cityWithStateAbbr: "Armour, SD",
  },
  {
    zip: "57314",
    ST: "SD",
    cityWithStateAbbr: "Artesian, SD",
  },
  {
    zip: "57315",
    ST: "SD",
    cityWithStateAbbr: "Avon, SD",
  },
  {
    zip: "57317",
    ST: "SD",
    cityWithStateAbbr: "Bonesteel, SD",
  },
  {
    zip: "57319",
    ST: "SD",
    cityWithStateAbbr: "Bridgewater, SD",
  },
  {
    zip: "57321",
    ST: "SD",
    cityWithStateAbbr: "Canova, SD",
  },
  {
    zip: "57322",
    ST: "SD",
    cityWithStateAbbr: "Carpenter, SD",
  },
  {
    zip: "57323",
    ST: "SD",
    cityWithStateAbbr: "Carthage, SD",
  },
  {
    zip: "57324",
    ST: "SD",
    cityWithStateAbbr: "Cavour, SD",
  },
  {
    zip: "57325",
    ST: "SD",
    cityWithStateAbbr: "Chamberlain, SD",
  },
  {
    zip: "57326",
    ST: "SD",
    cityWithStateAbbr: "Chamberlain, SD",
  },
  {
    zip: "57328",
    ST: "SD",
    cityWithStateAbbr: "Corsica, SD",
  },
  {
    zip: "57329",
    ST: "SD",
    cityWithStateAbbr: "Dante, SD",
  },
  {
    zip: "57330",
    ST: "SD",
    cityWithStateAbbr: "Delmont, SD",
  },
  {
    zip: "57331",
    ST: "SD",
    cityWithStateAbbr: "Dimock, SD",
  },
  {
    zip: "57332",
    ST: "SD",
    cityWithStateAbbr: "Emery, SD",
  },
  {
    zip: "57334",
    ST: "SD",
    cityWithStateAbbr: "Ethan, SD",
  },
  {
    zip: "57335",
    ST: "SD",
    cityWithStateAbbr: "Fairfax, SD",
  },
  {
    zip: "57337",
    ST: "SD",
    cityWithStateAbbr: "Fedora, SD",
  },
  {
    zip: "57339",
    ST: "SD",
    cityWithStateAbbr: "Fort Thompson, SD",
  },
  {
    zip: "57340",
    ST: "SD",
    cityWithStateAbbr: "Fulton, SD",
  },
  {
    zip: "57341",
    ST: "SD",
    cityWithStateAbbr: "Gann Valley, SD",
  },
  {
    zip: "57342",
    ST: "SD",
    cityWithStateAbbr: "Geddes, SD",
  },
  {
    zip: "57344",
    ST: "SD",
    cityWithStateAbbr: "Harrison, SD",
  },
  {
    zip: "57345",
    ST: "SD",
    cityWithStateAbbr: "Highmore, SD",
  },
  {
    zip: "57346",
    ST: "SD",
    cityWithStateAbbr: "Stephan, SD",
  },
  {
    zip: "57348",
    ST: "SD",
    cityWithStateAbbr: "Hitchcock, SD",
  },
  {
    zip: "57349",
    ST: "SD",
    cityWithStateAbbr: "Howard, SD",
  },
  {
    zip: "57350",
    ST: "SD",
    cityWithStateAbbr: "Huron, SD",
  },
  {
    zip: "57353",
    ST: "SD",
    cityWithStateAbbr: "Iroquois, SD",
  },
  {
    zip: "57354",
    ST: "SD",
    cityWithStateAbbr: "Kaylor, SD",
  },
  {
    zip: "57355",
    ST: "SD",
    cityWithStateAbbr: "Kimball, SD",
  },
  {
    zip: "57356",
    ST: "SD",
    cityWithStateAbbr: "Lake Andes, SD",
  },
  {
    zip: "57358",
    ST: "SD",
    cityWithStateAbbr: "Lane, SD",
  },
  {
    zip: "57359",
    ST: "SD",
    cityWithStateAbbr: "Letcher, SD",
  },
  {
    zip: "57361",
    ST: "SD",
    cityWithStateAbbr: "Marty, SD",
  },
  {
    zip: "57362",
    ST: "SD",
    cityWithStateAbbr: "Miller, SD",
  },
  {
    zip: "57363",
    ST: "SD",
    cityWithStateAbbr: "Mount Vernon, SD",
  },
  {
    zip: "57364",
    ST: "SD",
    cityWithStateAbbr: "New Holland, SD",
  },
  {
    zip: "57365",
    ST: "SD",
    cityWithStateAbbr: "Oacoma, SD",
  },
  {
    zip: "57366",
    ST: "SD",
    cityWithStateAbbr: "Parkston, SD",
  },
  {
    zip: "57367",
    ST: "SD",
    cityWithStateAbbr: "Pickstown, SD",
  },
  {
    zip: "57368",
    ST: "SD",
    cityWithStateAbbr: "Plankinton, SD",
  },
  {
    zip: "57369",
    ST: "SD",
    cityWithStateAbbr: "Platte, SD",
  },
  {
    zip: "57370",
    ST: "SD",
    cityWithStateAbbr: "Pukwana, SD",
  },
  {
    zip: "57371",
    ST: "SD",
    cityWithStateAbbr: "Ree Heights, SD",
  },
  {
    zip: "57373",
    ST: "SD",
    cityWithStateAbbr: "Saint Lawrence, SD",
  },
  {
    zip: "57374",
    ST: "SD",
    cityWithStateAbbr: "Spencer, SD",
  },
  {
    zip: "57375",
    ST: "SD",
    cityWithStateAbbr: "Stickney, SD",
  },
  {
    zip: "57376",
    ST: "SD",
    cityWithStateAbbr: "Tripp, SD",
  },
  {
    zip: "57379",
    ST: "SD",
    cityWithStateAbbr: "Virgil, SD",
  },
  {
    zip: "57380",
    ST: "SD",
    cityWithStateAbbr: "Wagner, SD",
  },
  {
    zip: "57381",
    ST: "SD",
    cityWithStateAbbr: "Wessington, SD",
  },
  {
    zip: "57382",
    ST: "SD",
    cityWithStateAbbr: "Wessington Springs, SD",
  },
  {
    zip: "57383",
    ST: "SD",
    cityWithStateAbbr: "White Lake, SD",
  },
  {
    zip: "57384",
    ST: "SD",
    cityWithStateAbbr: "Wolsey, SD",
  },
  {
    zip: "57385",
    ST: "SD",
    cityWithStateAbbr: "Woonsocket, SD",
  },
  {
    zip: "57386",
    ST: "SD",
    cityWithStateAbbr: "Yale, SD",
  },
  {
    zip: "57399",
    ST: "SD",
    cityWithStateAbbr: "Huron, SD",
  },
  {
    zip: "57401",
    ST: "SD",
    cityWithStateAbbr: "Aberdeen, SD",
  },
  {
    zip: "57402",
    ST: "SD",
    cityWithStateAbbr: "Aberdeen, SD",
  },
  {
    zip: "57420",
    ST: "SD",
    cityWithStateAbbr: "Akaska, SD",
  },
  {
    zip: "57421",
    ST: "SD",
    cityWithStateAbbr: "Amherst, SD",
  },
  {
    zip: "57422",
    ST: "SD",
    cityWithStateAbbr: "Andover, SD",
  },
  {
    zip: "57424",
    ST: "SD",
    cityWithStateAbbr: "Ashton, SD",
  },
  {
    zip: "57426",
    ST: "SD",
    cityWithStateAbbr: "Barnard, SD",
  },
  {
    zip: "57427",
    ST: "SD",
    cityWithStateAbbr: "Bath, SD",
  },
  {
    zip: "57428",
    ST: "SD",
    cityWithStateAbbr: "Bowdle, SD",
  },
  {
    zip: "57429",
    ST: "SD",
    cityWithStateAbbr: "Brentford, SD",
  },
  {
    zip: "57430",
    ST: "SD",
    cityWithStateAbbr: "Britton, SD",
  },
  {
    zip: "57432",
    ST: "SD",
    cityWithStateAbbr: "Claremont, SD",
  },
  {
    zip: "57433",
    ST: "SD",
    cityWithStateAbbr: "Columbia, SD",
  },
  {
    zip: "57434",
    ST: "SD",
    cityWithStateAbbr: "Conde, SD",
  },
  {
    zip: "57435",
    ST: "SD",
    cityWithStateAbbr: "Cresbard, SD",
  },
  {
    zip: "57436",
    ST: "SD",
    cityWithStateAbbr: "Doland, SD",
  },
  {
    zip: "57437",
    ST: "SD",
    cityWithStateAbbr: "Eureka, SD",
  },
  {
    zip: "57438",
    ST: "SD",
    cityWithStateAbbr: "Faulkton, SD",
  },
  {
    zip: "57439",
    ST: "SD",
    cityWithStateAbbr: "Ferney, SD",
  },
  {
    zip: "57440",
    ST: "SD",
    cityWithStateAbbr: "Frankfort, SD",
  },
  {
    zip: "57441",
    ST: "SD",
    cityWithStateAbbr: "Frederick, SD",
  },
  {
    zip: "57442",
    ST: "SD",
    cityWithStateAbbr: "Gettysburg, SD",
  },
  {
    zip: "57445",
    ST: "SD",
    cityWithStateAbbr: "Groton, SD",
  },
  {
    zip: "57446",
    ST: "SD",
    cityWithStateAbbr: "Hecla, SD",
  },
  {
    zip: "57448",
    ST: "SD",
    cityWithStateAbbr: "Hosmer, SD",
  },
  {
    zip: "57449",
    ST: "SD",
    cityWithStateAbbr: "Houghton, SD",
  },
  {
    zip: "57450",
    ST: "SD",
    cityWithStateAbbr: "Hoven, SD",
  },
  {
    zip: "57451",
    ST: "SD",
    cityWithStateAbbr: "Ipswich, SD",
  },
  {
    zip: "57452",
    ST: "SD",
    cityWithStateAbbr: "Java, SD",
  },
  {
    zip: "57454",
    ST: "SD",
    cityWithStateAbbr: "Langford, SD",
  },
  {
    zip: "57455",
    ST: "SD",
    cityWithStateAbbr: "Lebanon, SD",
  },
  {
    zip: "57456",
    ST: "SD",
    cityWithStateAbbr: "Leola, SD",
  },
  {
    zip: "57457",
    ST: "SD",
    cityWithStateAbbr: "Long Lake, SD",
  },
  {
    zip: "57460",
    ST: "SD",
    cityWithStateAbbr: "Mansfield, SD",
  },
  {
    zip: "57461",
    ST: "SD",
    cityWithStateAbbr: "Mellette, SD",
  },
  {
    zip: "57465",
    ST: "SD",
    cityWithStateAbbr: "Northville, SD",
  },
  {
    zip: "57466",
    ST: "SD",
    cityWithStateAbbr: "Onaka, SD",
  },
  {
    zip: "57467",
    ST: "SD",
    cityWithStateAbbr: "Orient, SD",
  },
  {
    zip: "57468",
    ST: "SD",
    cityWithStateAbbr: "Pierpont, SD",
  },
  {
    zip: "57469",
    ST: "SD",
    cityWithStateAbbr: "Redfield, SD",
  },
  {
    zip: "57470",
    ST: "SD",
    cityWithStateAbbr: "Rockham, SD",
  },
  {
    zip: "57471",
    ST: "SD",
    cityWithStateAbbr: "Roscoe, SD",
  },
  {
    zip: "57472",
    ST: "SD",
    cityWithStateAbbr: "Selby, SD",
  },
  {
    zip: "57473",
    ST: "SD",
    cityWithStateAbbr: "Seneca, SD",
  },
  {
    zip: "57474",
    ST: "SD",
    cityWithStateAbbr: "Stratford, SD",
  },
  {
    zip: "57475",
    ST: "SD",
    cityWithStateAbbr: "Tolstoy, SD",
  },
  {
    zip: "57476",
    ST: "SD",
    cityWithStateAbbr: "Tulare, SD",
  },
  {
    zip: "57477",
    ST: "SD",
    cityWithStateAbbr: "Turton, SD",
  },
  {
    zip: "57479",
    ST: "SD",
    cityWithStateAbbr: "Warner, SD",
  },
  {
    zip: "57481",
    ST: "SD",
    cityWithStateAbbr: "Westport, SD",
  },
  {
    zip: "57501",
    ST: "SD",
    cityWithStateAbbr: "Pierre, SD",
  },
  {
    zip: "57520",
    ST: "SD",
    cityWithStateAbbr: "Agar, SD",
  },
  {
    zip: "57521",
    ST: "SD",
    cityWithStateAbbr: "Belvidere, SD",
  },
  {
    zip: "57522",
    ST: "SD",
    cityWithStateAbbr: "Blunt, SD",
  },
  {
    zip: "57523",
    ST: "SD",
    cityWithStateAbbr: "Burke, SD",
  },
  {
    zip: "57528",
    ST: "SD",
    cityWithStateAbbr: "Colome, SD",
  },
  {
    zip: "57529",
    ST: "SD",
    cityWithStateAbbr: "Dallas, SD",
  },
  {
    zip: "57531",
    ST: "SD",
    cityWithStateAbbr: "Draper, SD",
  },
  {
    zip: "57532",
    ST: "SD",
    cityWithStateAbbr: "Fort Pierre, SD",
  },
  {
    zip: "57533",
    ST: "SD",
    cityWithStateAbbr: "Gregory, SD",
  },
  {
    zip: "57534",
    ST: "SD",
    cityWithStateAbbr: "Hamill, SD",
  },
  {
    zip: "57536",
    ST: "SD",
    cityWithStateAbbr: "Harrold, SD",
  },
  {
    zip: "57537",
    ST: "SD",
    cityWithStateAbbr: "Hayes, SD",
  },
  {
    zip: "57538",
    ST: "SD",
    cityWithStateAbbr: "Herrick, SD",
  },
  {
    zip: "57540",
    ST: "SD",
    cityWithStateAbbr: "Holabird, SD",
  },
  {
    zip: "57541",
    ST: "SD",
    cityWithStateAbbr: "Ideal, SD",
  },
  {
    zip: "57543",
    ST: "SD",
    cityWithStateAbbr: "Kadoka, SD",
  },
  {
    zip: "57544",
    ST: "SD",
    cityWithStateAbbr: "Kennebec, SD",
  },
  {
    zip: "57547",
    ST: "SD",
    cityWithStateAbbr: "Long Valley, SD",
  },
  {
    zip: "57548",
    ST: "SD",
    cityWithStateAbbr: "Lower Brule, SD",
  },
  {
    zip: "57551",
    ST: "SD",
    cityWithStateAbbr: "Martin, SD",
  },
  {
    zip: "57552",
    ST: "SD",
    cityWithStateAbbr: "Midland, SD",
  },
  {
    zip: "57553",
    ST: "SD",
    cityWithStateAbbr: "Milesville, SD",
  },
  {
    zip: "57555",
    ST: "SD",
    cityWithStateAbbr: "Mission, SD",
  },
  {
    zip: "57559",
    ST: "SD",
    cityWithStateAbbr: "Murdo, SD",
  },
  {
    zip: "57560",
    ST: "SD",
    cityWithStateAbbr: "Norris, SD",
  },
  {
    zip: "57562",
    ST: "SD",
    cityWithStateAbbr: "Okaton, SD",
  },
  {
    zip: "57563",
    ST: "SD",
    cityWithStateAbbr: "Okreek, SD",
  },
  {
    zip: "57564",
    ST: "SD",
    cityWithStateAbbr: "Onida, SD",
  },
  {
    zip: "57566",
    ST: "SD",
    cityWithStateAbbr: "Parmelee, SD",
  },
  {
    zip: "57567",
    ST: "SD",
    cityWithStateAbbr: "Philip, SD",
  },
  {
    zip: "57568",
    ST: "SD",
    cityWithStateAbbr: "Presho, SD",
  },
  {
    zip: "57569",
    ST: "SD",
    cityWithStateAbbr: "Reliance, SD",
  },
  {
    zip: "57570",
    ST: "SD",
    cityWithStateAbbr: "Rosebud, SD",
  },
  {
    zip: "57571",
    ST: "SD",
    cityWithStateAbbr: "Saint Charles, SD",
  },
  {
    zip: "57572",
    ST: "SD",
    cityWithStateAbbr: "Saint Francis, SD",
  },
  {
    zip: "57574",
    ST: "SD",
    cityWithStateAbbr: "Tuthill, SD",
  },
  {
    zip: "57576",
    ST: "SD",
    cityWithStateAbbr: "Vivian, SD",
  },
  {
    zip: "57577",
    ST: "SD",
    cityWithStateAbbr: "Wanblee, SD",
  },
  {
    zip: "57579",
    ST: "SD",
    cityWithStateAbbr: "White River, SD",
  },
  {
    zip: "57580",
    ST: "SD",
    cityWithStateAbbr: "Winner, SD",
  },
  {
    zip: "57584",
    ST: "SD",
    cityWithStateAbbr: "Witten, SD",
  },
  {
    zip: "57585",
    ST: "SD",
    cityWithStateAbbr: "Wood, SD",
  },
  {
    zip: "57601",
    ST: "SD",
    cityWithStateAbbr: "Mobridge, SD",
  },
  {
    zip: "57620",
    ST: "SD",
    cityWithStateAbbr: "Bison, SD",
  },
  {
    zip: "57621",
    ST: "SD",
    cityWithStateAbbr: "Bullhead, SD",
  },
  {
    zip: "57622",
    ST: "SD",
    cityWithStateAbbr: "Cherry Creek, SD",
  },
  {
    zip: "57623",
    ST: "SD",
    cityWithStateAbbr: "Dupree, SD",
  },
  {
    zip: "57625",
    ST: "SD",
    cityWithStateAbbr: "Eagle Butte, SD",
  },
  {
    zip: "57626",
    ST: "SD",
    cityWithStateAbbr: "Faith, SD",
  },
  {
    zip: "57630",
    ST: "SD",
    cityWithStateAbbr: "Glencross, SD",
  },
  {
    zip: "57631",
    ST: "SD",
    cityWithStateAbbr: "Glenham, SD",
  },
  {
    zip: "57632",
    ST: "SD",
    cityWithStateAbbr: "Herreid, SD",
  },
  {
    zip: "57633",
    ST: "SD",
    cityWithStateAbbr: "Isabel, SD",
  },
  {
    zip: "57634",
    ST: "SD",
    cityWithStateAbbr: "Keldron, SD",
  },
  {
    zip: "57636",
    ST: "SD",
    cityWithStateAbbr: "Lantry, SD",
  },
  {
    zip: "57638",
    ST: "SD",
    cityWithStateAbbr: "Lemmon, SD",
  },
  {
    zip: "57639",
    ST: "SD",
    cityWithStateAbbr: "Little Eagle, SD",
  },
  {
    zip: "57640",
    ST: "SD",
    cityWithStateAbbr: "Lodgepole, SD",
  },
  {
    zip: "57641",
    ST: "SD",
    cityWithStateAbbr: "Mc Intosh, SD",
  },
  {
    zip: "57642",
    ST: "SD",
    cityWithStateAbbr: "Mc Laughlin, SD",
  },
  {
    zip: "57644",
    ST: "SD",
    cityWithStateAbbr: "Meadow, SD",
  },
  {
    zip: "57645",
    ST: "ND",
    cityWithStateAbbr: "Morristown, ND",
  },
  {
    zip: "57646",
    ST: "SD",
    cityWithStateAbbr: "Mound City, SD",
  },
  {
    zip: "57648",
    ST: "SD",
    cityWithStateAbbr: "Pollock, SD",
  },
  {
    zip: "57649",
    ST: "SD",
    cityWithStateAbbr: "Prairie City, SD",
  },
  {
    zip: "57650",
    ST: "SD",
    cityWithStateAbbr: "Ralph, SD",
  },
  {
    zip: "57651",
    ST: "SD",
    cityWithStateAbbr: "Reva, SD",
  },
  {
    zip: "57652",
    ST: "SD",
    cityWithStateAbbr: "Ridgeview, SD",
  },
  {
    zip: "57656",
    ST: "SD",
    cityWithStateAbbr: "Timber Lake, SD",
  },
  {
    zip: "57657",
    ST: "SD",
    cityWithStateAbbr: "Trail City, SD",
  },
  {
    zip: "57658",
    ST: "SD",
    cityWithStateAbbr: "Wakpala, SD",
  },
  {
    zip: "57659",
    ST: "SD",
    cityWithStateAbbr: "Walker, SD",
  },
  {
    zip: "57660",
    ST: "SD",
    cityWithStateAbbr: "Watauga, SD",
  },
  {
    zip: "57661",
    ST: "SD",
    cityWithStateAbbr: "Whitehorse, SD",
  },
  {
    zip: "57701",
    ST: "SD",
    cityWithStateAbbr: "Rapid City, SD",
  },
  {
    zip: "57702",
    ST: "SD",
    cityWithStateAbbr: "Rapid City, SD",
  },
  {
    zip: "57703",
    ST: "SD",
    cityWithStateAbbr: "Rapid City, SD",
  },
  {
    zip: "57706",
    ST: "SD",
    cityWithStateAbbr: "Ellsworth Afb, SD",
  },
  {
    zip: "57709",
    ST: "SD",
    cityWithStateAbbr: "Rapid City, SD",
  },
  {
    zip: "57714",
    ST: "SD",
    cityWithStateAbbr: "Allen, SD",
  },
  {
    zip: "57716",
    ST: "SD",
    cityWithStateAbbr: "Batesland, SD",
  },
  {
    zip: "57717",
    ST: "SD",
    cityWithStateAbbr: "Belle Fourche, SD",
  },
  {
    zip: "57718",
    ST: "SD",
    cityWithStateAbbr: "Black Hawk, SD",
  },
  {
    zip: "57719",
    ST: "SD",
    cityWithStateAbbr: "Box Elder, SD",
  },
  {
    zip: "57720",
    ST: "SD",
    cityWithStateAbbr: "Buffalo, SD",
  },
  {
    zip: "57722",
    ST: "SD",
    cityWithStateAbbr: "Buffalo Gap, SD",
  },
  {
    zip: "57724",
    ST: "MT",
    cityWithStateAbbr: "Camp Crook, MT",
  },
  {
    zip: "57725",
    ST: "SD",
    cityWithStateAbbr: "Caputa, SD",
  },
  {
    zip: "57730",
    ST: "SD",
    cityWithStateAbbr: "Custer, SD",
  },
  {
    zip: "57732",
    ST: "SD",
    cityWithStateAbbr: "Deadwood, SD",
  },
  {
    zip: "57735",
    ST: "SD",
    cityWithStateAbbr: "Edgemont, SD",
  },
  {
    zip: "57737",
    ST: "SD",
    cityWithStateAbbr: "Enning, SD",
  },
  {
    zip: "57738",
    ST: "SD",
    cityWithStateAbbr: "Fairburn, SD",
  },
  {
    zip: "57741",
    ST: "SD",
    cityWithStateAbbr: "Fort Meade, SD",
  },
  {
    zip: "57744",
    ST: "SD",
    cityWithStateAbbr: "Hermosa, SD",
  },
  {
    zip: "57745",
    ST: "SD",
    cityWithStateAbbr: "Hill City, SD",
  },
  {
    zip: "57747",
    ST: "SD",
    cityWithStateAbbr: "Hot Springs, SD",
  },
  {
    zip: "57748",
    ST: "SD",
    cityWithStateAbbr: "Howes, SD",
  },
  {
    zip: "57750",
    ST: "SD",
    cityWithStateAbbr: "Interior, SD",
  },
  {
    zip: "57751",
    ST: "SD",
    cityWithStateAbbr: "Keystone, SD",
  },
  {
    zip: "57752",
    ST: "SD",
    cityWithStateAbbr: "Kyle, SD",
  },
  {
    zip: "57754",
    ST: "SD",
    cityWithStateAbbr: "Lead, SD",
  },
  {
    zip: "57755",
    ST: "SD",
    cityWithStateAbbr: "Ludlow, SD",
  },
  {
    zip: "57756",
    ST: "SD",
    cityWithStateAbbr: "Manderson, SD",
  },
  {
    zip: "57758",
    ST: "SD",
    cityWithStateAbbr: "Mud Butte, SD",
  },
  {
    zip: "57759",
    ST: "SD",
    cityWithStateAbbr: "Nemo, SD",
  },
  {
    zip: "57760",
    ST: "SD",
    cityWithStateAbbr: "Newell, SD",
  },
  {
    zip: "57761",
    ST: "SD",
    cityWithStateAbbr: "New Underwood, SD",
  },
  {
    zip: "57762",
    ST: "SD",
    cityWithStateAbbr: "Nisland, SD",
  },
  {
    zip: "57763",
    ST: "SD",
    cityWithStateAbbr: "Oelrichs, SD",
  },
  {
    zip: "57764",
    ST: "SD",
    cityWithStateAbbr: "Oglala, SD",
  },
  {
    zip: "57766",
    ST: "SD",
    cityWithStateAbbr: "Oral, SD",
  },
  {
    zip: "57767",
    ST: "SD",
    cityWithStateAbbr: "Owanka, SD",
  },
  {
    zip: "57769",
    ST: "SD",
    cityWithStateAbbr: "Piedmont, SD",
  },
  {
    zip: "57770",
    ST: "SD",
    cityWithStateAbbr: "Pine Ridge, SD",
  },
  {
    zip: "57772",
    ST: "SD",
    cityWithStateAbbr: "Porcupine, SD",
  },
  {
    zip: "57773",
    ST: "SD",
    cityWithStateAbbr: "Pringle, SD",
  },
  {
    zip: "57775",
    ST: "SD",
    cityWithStateAbbr: "Quinn, SD",
  },
  {
    zip: "57776",
    ST: "SD",
    cityWithStateAbbr: "Redig, SD",
  },
  {
    zip: "57779",
    ST: "SD",
    cityWithStateAbbr: "Saint Onge, SD",
  },
  {
    zip: "57780",
    ST: "SD",
    cityWithStateAbbr: "Scenic, SD",
  },
  {
    zip: "57782",
    ST: "SD",
    cityWithStateAbbr: "Smithwick, SD",
  },
  {
    zip: "57783",
    ST: "SD",
    cityWithStateAbbr: "Spearfish, SD",
  },
  {
    zip: "57785",
    ST: "SD",
    cityWithStateAbbr: "Sturgis, SD",
  },
  {
    zip: "57787",
    ST: "SD",
    cityWithStateAbbr: "Union Center, SD",
  },
  {
    zip: "57788",
    ST: "SD",
    cityWithStateAbbr: "Vale, SD",
  },
  {
    zip: "57790",
    ST: "SD",
    cityWithStateAbbr: "Wall, SD",
  },
  {
    zip: "57791",
    ST: "SD",
    cityWithStateAbbr: "Wasta, SD",
  },
  {
    zip: "57792",
    ST: "SD",
    cityWithStateAbbr: "White Owl, SD",
  },
  {
    zip: "57793",
    ST: "SD",
    cityWithStateAbbr: "Whitewood, SD",
  },
  {
    zip: "57794",
    ST: "SD",
    cityWithStateAbbr: "Wounded Knee, SD",
  },
  {
    zip: "57799",
    ST: "SD",
    cityWithStateAbbr: "Spearfish, SD",
  },
  {
    zip: "58001",
    ST: "ND",
    cityWithStateAbbr: "Abercrombie, ND",
  },
  {
    zip: "58002",
    ST: "ND",
    cityWithStateAbbr: "Absaraka, ND",
  },
  {
    zip: "58004",
    ST: "ND",
    cityWithStateAbbr: "Amenia, ND",
  },
  {
    zip: "58005",
    ST: "ND",
    cityWithStateAbbr: "Argusville, ND",
  },
  {
    zip: "58006",
    ST: "ND",
    cityWithStateAbbr: "Arthur, ND",
  },
  {
    zip: "58007",
    ST: "ND",
    cityWithStateAbbr: "Ayr, ND",
  },
  {
    zip: "58008",
    ST: "ND",
    cityWithStateAbbr: "Barney, ND",
  },
  {
    zip: "58009",
    ST: "ND",
    cityWithStateAbbr: "Blanchard, ND",
  },
  {
    zip: "58011",
    ST: "ND",
    cityWithStateAbbr: "Buffalo, ND",
  },
  {
    zip: "58012",
    ST: "ND",
    cityWithStateAbbr: "Casselton, ND",
  },
  {
    zip: "58013",
    ST: "ND",
    cityWithStateAbbr: "Cayuga, ND",
  },
  {
    zip: "58015",
    ST: "ND",
    cityWithStateAbbr: "Christine, ND",
  },
  {
    zip: "58016",
    ST: "ND",
    cityWithStateAbbr: "Clifford, ND",
  },
  {
    zip: "58017",
    ST: "ND",
    cityWithStateAbbr: "Cogswell, ND",
  },
  {
    zip: "58018",
    ST: "ND",
    cityWithStateAbbr: "Colfax, ND",
  },
  {
    zip: "58021",
    ST: "ND",
    cityWithStateAbbr: "Davenport, ND",
  },
  {
    zip: "58027",
    ST: "ND",
    cityWithStateAbbr: "Enderlin, ND",
  },
  {
    zip: "58029",
    ST: "ND",
    cityWithStateAbbr: "Erie, ND",
  },
  {
    zip: "58030",
    ST: "ND",
    cityWithStateAbbr: "Fairmount, ND",
  },
  {
    zip: "58031",
    ST: "ND",
    cityWithStateAbbr: "Fingal, ND",
  },
  {
    zip: "58032",
    ST: "ND",
    cityWithStateAbbr: "Forman, ND",
  },
  {
    zip: "58033",
    ST: "ND",
    cityWithStateAbbr: "Fort Ransom, ND",
  },
  {
    zip: "58035",
    ST: "ND",
    cityWithStateAbbr: "Galesburg, ND",
  },
  {
    zip: "58036",
    ST: "ND",
    cityWithStateAbbr: "Gardner, ND",
  },
  {
    zip: "58038",
    ST: "ND",
    cityWithStateAbbr: "Grandin, ND",
  },
  {
    zip: "58040",
    ST: "ND",
    cityWithStateAbbr: "Gwinner, ND",
  },
  {
    zip: "58041",
    ST: "ND",
    cityWithStateAbbr: "Hankinson, ND",
  },
  {
    zip: "58042",
    ST: "ND",
    cityWithStateAbbr: "Harwood, ND",
  },
  {
    zip: "58043",
    ST: "ND",
    cityWithStateAbbr: "Havana, ND",
  },
  {
    zip: "58045",
    ST: "ND",
    cityWithStateAbbr: "Hillsboro, ND",
  },
  {
    zip: "58046",
    ST: "ND",
    cityWithStateAbbr: "Hope, ND",
  },
  {
    zip: "58047",
    ST: "ND",
    cityWithStateAbbr: "Horace, ND",
  },
  {
    zip: "58048",
    ST: "ND",
    cityWithStateAbbr: "Hunter, ND",
  },
  {
    zip: "58049",
    ST: "ND",
    cityWithStateAbbr: "Kathryn, ND",
  },
  {
    zip: "58051",
    ST: "ND",
    cityWithStateAbbr: "Kindred, ND",
  },
  {
    zip: "58052",
    ST: "ND",
    cityWithStateAbbr: "Leonard, ND",
  },
  {
    zip: "58053",
    ST: "ND",
    cityWithStateAbbr: "Lidgerwood, ND",
  },
  {
    zip: "58054",
    ST: "ND",
    cityWithStateAbbr: "Lisbon, ND",
  },
  {
    zip: "58056",
    ST: "ND",
    cityWithStateAbbr: "Luverne, ND",
  },
  {
    zip: "58057",
    ST: "ND",
    cityWithStateAbbr: "Mcleod, ND",
  },
  {
    zip: "58058",
    ST: "ND",
    cityWithStateAbbr: "Mantador, ND",
  },
  {
    zip: "58059",
    ST: "ND",
    cityWithStateAbbr: "Mapleton, ND",
  },
  {
    zip: "58060",
    ST: "ND",
    cityWithStateAbbr: "Milnor, ND",
  },
  {
    zip: "58061",
    ST: "ND",
    cityWithStateAbbr: "Mooreton, ND",
  },
  {
    zip: "58062",
    ST: "ND",
    cityWithStateAbbr: "Nome, ND",
  },
  {
    zip: "58063",
    ST: "ND",
    cityWithStateAbbr: "Oriska, ND",
  },
  {
    zip: "58064",
    ST: "ND",
    cityWithStateAbbr: "Page, ND",
  },
  {
    zip: "58065",
    ST: "ND",
    cityWithStateAbbr: "Pillsbury, ND",
  },
  {
    zip: "58067",
    ST: "ND",
    cityWithStateAbbr: "Rutland, ND",
  },
  {
    zip: "58068",
    ST: "ND",
    cityWithStateAbbr: "Sheldon, ND",
  },
  {
    zip: "58069",
    ST: "ND",
    cityWithStateAbbr: "Stirum, ND",
  },
  {
    zip: "58071",
    ST: "ND",
    cityWithStateAbbr: "Tower City, ND",
  },
  {
    zip: "58072",
    ST: "ND",
    cityWithStateAbbr: "Valley City, ND",
  },
  {
    zip: "58074",
    ST: "ND",
    cityWithStateAbbr: "Wahpeton, ND",
  },
  {
    zip: "58075",
    ST: "ND",
    cityWithStateAbbr: "Wahpeton, ND",
  },
  {
    zip: "58076",
    ST: "ND",
    cityWithStateAbbr: "Wahpeton, ND",
  },
  {
    zip: "58077",
    ST: "ND",
    cityWithStateAbbr: "Walcott, ND",
  },
  {
    zip: "58078",
    ST: "ND",
    cityWithStateAbbr: "West Fargo, ND",
  },
  {
    zip: "58079",
    ST: "ND",
    cityWithStateAbbr: "Wheatland, ND",
  },
  {
    zip: "58081",
    ST: "ND",
    cityWithStateAbbr: "Wyndmere, ND",
  },
  {
    zip: "58102",
    ST: "ND",
    cityWithStateAbbr: "Fargo, ND",
  },
  {
    zip: "58103",
    ST: "ND",
    cityWithStateAbbr: "Fargo, ND",
  },
  {
    zip: "58104",
    ST: "ND",
    cityWithStateAbbr: "Fargo, ND",
  },
  {
    zip: "58105",
    ST: "ND",
    cityWithStateAbbr: "Fargo, ND",
  },
  {
    zip: "58106",
    ST: "ND",
    cityWithStateAbbr: "Fargo, ND",
  },
  {
    zip: "58107",
    ST: "ND",
    cityWithStateAbbr: "Fargo, ND",
  },
  {
    zip: "58108",
    ST: "ND",
    cityWithStateAbbr: "Fargo, ND",
  },
  {
    zip: "58109",
    ST: "ND",
    cityWithStateAbbr: "Fargo, ND",
  },
  {
    zip: "58121",
    ST: "ND",
    cityWithStateAbbr: "Fargo, ND",
  },
  {
    zip: "58122",
    ST: "ND",
    cityWithStateAbbr: "Fargo, ND",
  },
  {
    zip: "58124",
    ST: "ND",
    cityWithStateAbbr: "Fargo, ND",
  },
  {
    zip: "58125",
    ST: "ND",
    cityWithStateAbbr: "Fargo, ND",
  },
  {
    zip: "58126",
    ST: "ND",
    cityWithStateAbbr: "Fargo, ND",
  },
  {
    zip: "58201",
    ST: "ND",
    cityWithStateAbbr: "Grand Forks, ND",
  },
  {
    zip: "58202",
    ST: "ND",
    cityWithStateAbbr: "Grand Forks, ND",
  },
  {
    zip: "58203",
    ST: "ND",
    cityWithStateAbbr: "Grand Forks, ND",
  },
  {
    zip: "58204",
    ST: "ND",
    cityWithStateAbbr: "Grand Forks Afb, ND",
  },
  {
    zip: "58205",
    ST: "ND",
    cityWithStateAbbr: "Grand Forks Afb, ND",
  },
  {
    zip: "58206",
    ST: "MN",
    cityWithStateAbbr: "Grand Forks, MN",
  },
  {
    zip: "58207",
    ST: "MN",
    cityWithStateAbbr: "Grand Forks, MN",
  },
  {
    zip: "58208",
    ST: "ND",
    cityWithStateAbbr: "Grand Forks, ND",
  },
  {
    zip: "58210",
    ST: "ND",
    cityWithStateAbbr: "Adams, ND",
  },
  {
    zip: "58212",
    ST: "ND",
    cityWithStateAbbr: "Aneta, ND",
  },
  {
    zip: "58214",
    ST: "ND",
    cityWithStateAbbr: "Arvilla, ND",
  },
  {
    zip: "58216",
    ST: "ND",
    cityWithStateAbbr: "Bathgate, ND",
  },
  {
    zip: "58218",
    ST: "ND",
    cityWithStateAbbr: "Buxton, ND",
  },
  {
    zip: "58219",
    ST: "ND",
    cityWithStateAbbr: "Caledonia, ND",
  },
  {
    zip: "58220",
    ST: "ND",
    cityWithStateAbbr: "Cavalier, ND",
  },
  {
    zip: "58222",
    ST: "ND",
    cityWithStateAbbr: "Crystal, ND",
  },
  {
    zip: "58223",
    ST: "ND",
    cityWithStateAbbr: "Cummings, ND",
  },
  {
    zip: "58224",
    ST: "ND",
    cityWithStateAbbr: "Dahlen, ND",
  },
  {
    zip: "58225",
    ST: "ND",
    cityWithStateAbbr: "Drayton, ND",
  },
  {
    zip: "58227",
    ST: "ND",
    cityWithStateAbbr: "Edinburg, ND",
  },
  {
    zip: "58228",
    ST: "ND",
    cityWithStateAbbr: "Emerado, ND",
  },
  {
    zip: "58229",
    ST: "ND",
    cityWithStateAbbr: "Fairdale, ND",
  },
  {
    zip: "58230",
    ST: "ND",
    cityWithStateAbbr: "Finley, ND",
  },
  {
    zip: "58231",
    ST: "ND",
    cityWithStateAbbr: "Fordville, ND",
  },
  {
    zip: "58233",
    ST: "ND",
    cityWithStateAbbr: "Forest River, ND",
  },
  {
    zip: "58235",
    ST: "ND",
    cityWithStateAbbr: "Gilby, ND",
  },
  {
    zip: "58236",
    ST: "ND",
    cityWithStateAbbr: "Glasston, ND",
  },
  {
    zip: "58237",
    ST: "ND",
    cityWithStateAbbr: "Grafton, ND",
  },
  {
    zip: "58238",
    ST: "ND",
    cityWithStateAbbr: "Hamilton, ND",
  },
  {
    zip: "58239",
    ST: "ND",
    cityWithStateAbbr: "Hannah, ND",
  },
  {
    zip: "58240",
    ST: "ND",
    cityWithStateAbbr: "Hatton, ND",
  },
  {
    zip: "58241",
    ST: "ND",
    cityWithStateAbbr: "Hensel, ND",
  },
  {
    zip: "58243",
    ST: "ND",
    cityWithStateAbbr: "Hoople, ND",
  },
  {
    zip: "58244",
    ST: "ND",
    cityWithStateAbbr: "Inkster, ND",
  },
  {
    zip: "58249",
    ST: "ND",
    cityWithStateAbbr: "Langdon, ND",
  },
  {
    zip: "58250",
    ST: "ND",
    cityWithStateAbbr: "Lankin, ND",
  },
  {
    zip: "58251",
    ST: "ND",
    cityWithStateAbbr: "Larimore, ND",
  },
  {
    zip: "58254",
    ST: "ND",
    cityWithStateAbbr: "Mcville, ND",
  },
  {
    zip: "58255",
    ST: "ND",
    cityWithStateAbbr: "Maida, ND",
  },
  {
    zip: "58256",
    ST: "ND",
    cityWithStateAbbr: "Manvel, ND",
  },
  {
    zip: "58257",
    ST: "ND",
    cityWithStateAbbr: "Mayville, ND",
  },
  {
    zip: "58258",
    ST: "ND",
    cityWithStateAbbr: "Mekinock, ND",
  },
  {
    zip: "58259",
    ST: "ND",
    cityWithStateAbbr: "Michigan, ND",
  },
  {
    zip: "58260",
    ST: "ND",
    cityWithStateAbbr: "Milton, ND",
  },
  {
    zip: "58261",
    ST: "ND",
    cityWithStateAbbr: "Minto, ND",
  },
  {
    zip: "58262",
    ST: "ND",
    cityWithStateAbbr: "Mountain, ND",
  },
  {
    zip: "58265",
    ST: "ND",
    cityWithStateAbbr: "Neche, ND",
  },
  {
    zip: "58266",
    ST: "ND",
    cityWithStateAbbr: "Niagara, ND",
  },
  {
    zip: "58267",
    ST: "ND",
    cityWithStateAbbr: "Northwood, ND",
  },
  {
    zip: "58269",
    ST: "ND",
    cityWithStateAbbr: "Osnabrock, ND",
  },
  {
    zip: "58270",
    ST: "ND",
    cityWithStateAbbr: "Park River, ND",
  },
  {
    zip: "58271",
    ST: "ND",
    cityWithStateAbbr: "Pembina, ND",
  },
  {
    zip: "58272",
    ST: "ND",
    cityWithStateAbbr: "Petersburg, ND",
  },
  {
    zip: "58273",
    ST: "ND",
    cityWithStateAbbr: "Pisek, ND",
  },
  {
    zip: "58274",
    ST: "ND",
    cityWithStateAbbr: "Portland, ND",
  },
  {
    zip: "58275",
    ST: "ND",
    cityWithStateAbbr: "Reynolds, ND",
  },
  {
    zip: "58276",
    ST: "ND",
    cityWithStateAbbr: "Saint Thomas, ND",
  },
  {
    zip: "58277",
    ST: "ND",
    cityWithStateAbbr: "Sharon, ND",
  },
  {
    zip: "58278",
    ST: "ND",
    cityWithStateAbbr: "Thompson, ND",
  },
  {
    zip: "58281",
    ST: "ND",
    cityWithStateAbbr: "Wales, ND",
  },
  {
    zip: "58282",
    ST: "ND",
    cityWithStateAbbr: "Walhalla, ND",
  },
  {
    zip: "58301",
    ST: "ND",
    cityWithStateAbbr: "Devils Lake, ND",
  },
  {
    zip: "58310",
    ST: "ND",
    cityWithStateAbbr: "Agate, ND",
  },
  {
    zip: "58311",
    ST: "ND",
    cityWithStateAbbr: "Alsen, ND",
  },
  {
    zip: "58313",
    ST: "ND",
    cityWithStateAbbr: "Balta, ND",
  },
  {
    zip: "58316",
    ST: "ND",
    cityWithStateAbbr: "Belcourt, ND",
  },
  {
    zip: "58317",
    ST: "ND",
    cityWithStateAbbr: "Bisbee, ND",
  },
  {
    zip: "58318",
    ST: "ND",
    cityWithStateAbbr: "Bottineau, ND",
  },
  {
    zip: "58321",
    ST: "ND",
    cityWithStateAbbr: "Brocket, ND",
  },
  {
    zip: "58323",
    ST: "ND",
    cityWithStateAbbr: "Calvin, ND",
  },
  {
    zip: "58324",
    ST: "ND",
    cityWithStateAbbr: "Cando, ND",
  },
  {
    zip: "58325",
    ST: "ND",
    cityWithStateAbbr: "Churchs Ferry, ND",
  },
  {
    zip: "58327",
    ST: "ND",
    cityWithStateAbbr: "Crary, ND",
  },
  {
    zip: "58329",
    ST: "ND",
    cityWithStateAbbr: "Dunseith, ND",
  },
  {
    zip: "58330",
    ST: "ND",
    cityWithStateAbbr: "Edmore, ND",
  },
  {
    zip: "58331",
    ST: "ND",
    cityWithStateAbbr: "Egeland, ND",
  },
  {
    zip: "58332",
    ST: "ND",
    cityWithStateAbbr: "Esmond, ND",
  },
  {
    zip: "58335",
    ST: "ND",
    cityWithStateAbbr: "Fort Totten, ND",
  },
  {
    zip: "58338",
    ST: "ND",
    cityWithStateAbbr: "Hampden, ND",
  },
  {
    zip: "58339",
    ST: "ND",
    cityWithStateAbbr: "Hansboro, ND",
  },
  {
    zip: "58341",
    ST: "ND",
    cityWithStateAbbr: "Harvey, ND",
  },
  {
    zip: "58343",
    ST: "ND",
    cityWithStateAbbr: "Knox, ND",
  },
  {
    zip: "58344",
    ST: "ND",
    cityWithStateAbbr: "Lakota, ND",
  },
  {
    zip: "58345",
    ST: "ND",
    cityWithStateAbbr: "Lawton, ND",
  },
  {
    zip: "58346",
    ST: "ND",
    cityWithStateAbbr: "Leeds, ND",
  },
  {
    zip: "58348",
    ST: "ND",
    cityWithStateAbbr: "Maddock, ND",
  },
  {
    zip: "58351",
    ST: "ND",
    cityWithStateAbbr: "Minnewaukan, ND",
  },
  {
    zip: "58352",
    ST: "ND",
    cityWithStateAbbr: "Munich, ND",
  },
  {
    zip: "58353",
    ST: "ND",
    cityWithStateAbbr: "Mylo, ND",
  },
  {
    zip: "58355",
    ST: "ND",
    cityWithStateAbbr: "Nekoma, ND",
  },
  {
    zip: "58356",
    ST: "ND",
    cityWithStateAbbr: "New Rockford, ND",
  },
  {
    zip: "58357",
    ST: "ND",
    cityWithStateAbbr: "Oberon, ND",
  },
  {
    zip: "58361",
    ST: "ND",
    cityWithStateAbbr: "Pekin, ND",
  },
  {
    zip: "58362",
    ST: "ND",
    cityWithStateAbbr: "Penn, ND",
  },
  {
    zip: "58363",
    ST: "ND",
    cityWithStateAbbr: "Perth, ND",
  },
  {
    zip: "58365",
    ST: "ND",
    cityWithStateAbbr: "Rocklake, ND",
  },
  {
    zip: "58366",
    ST: "ND",
    cityWithStateAbbr: "Rolette, ND",
  },
  {
    zip: "58367",
    ST: "ND",
    cityWithStateAbbr: "Rolla, ND",
  },
  {
    zip: "58368",
    ST: "ND",
    cityWithStateAbbr: "Rugby, ND",
  },
  {
    zip: "58369",
    ST: "ND",
    cityWithStateAbbr: "Saint John, ND",
  },
  {
    zip: "58370",
    ST: "ND",
    cityWithStateAbbr: "Saint Michael, ND",
  },
  {
    zip: "58372",
    ST: "ND",
    cityWithStateAbbr: "Sarles, ND",
  },
  {
    zip: "58374",
    ST: "ND",
    cityWithStateAbbr: "Sheyenne, ND",
  },
  {
    zip: "58377",
    ST: "ND",
    cityWithStateAbbr: "Starkweather, ND",
  },
  {
    zip: "58379",
    ST: "ND",
    cityWithStateAbbr: "Tokio, ND",
  },
  {
    zip: "58380",
    ST: "ND",
    cityWithStateAbbr: "Tolna, ND",
  },
  {
    zip: "58381",
    ST: "ND",
    cityWithStateAbbr: "Warwick, ND",
  },
  {
    zip: "58382",
    ST: "ND",
    cityWithStateAbbr: "Webster, ND",
  },
  {
    zip: "58384",
    ST: "ND",
    cityWithStateAbbr: "Willow City, ND",
  },
  {
    zip: "58385",
    ST: "ND",
    cityWithStateAbbr: "Wolford, ND",
  },
  {
    zip: "58386",
    ST: "ND",
    cityWithStateAbbr: "York, ND",
  },
  {
    zip: "58401",
    ST: "ND",
    cityWithStateAbbr: "Jamestown, ND",
  },
  {
    zip: "58402",
    ST: "ND",
    cityWithStateAbbr: "Jamestown, ND",
  },
  {
    zip: "58405",
    ST: "ND",
    cityWithStateAbbr: "Jamestown, ND",
  },
  {
    zip: "58413",
    ST: "ND",
    cityWithStateAbbr: "Ashley, ND",
  },
  {
    zip: "58415",
    ST: "ND",
    cityWithStateAbbr: "Berlin, ND",
  },
  {
    zip: "58416",
    ST: "ND",
    cityWithStateAbbr: "Binford, ND",
  },
  {
    zip: "58418",
    ST: "ND",
    cityWithStateAbbr: "Bowdon, ND",
  },
  {
    zip: "58420",
    ST: "ND",
    cityWithStateAbbr: "Buchanan, ND",
  },
  {
    zip: "58421",
    ST: "ND",
    cityWithStateAbbr: "Carrington, ND",
  },
  {
    zip: "58422",
    ST: "ND",
    cityWithStateAbbr: "Cathay, ND",
  },
  {
    zip: "58423",
    ST: "ND",
    cityWithStateAbbr: "Chaseley, ND",
  },
  {
    zip: "58424",
    ST: "ND",
    cityWithStateAbbr: "Cleveland, ND",
  },
  {
    zip: "58425",
    ST: "ND",
    cityWithStateAbbr: "Cooperstown, ND",
  },
  {
    zip: "58426",
    ST: "ND",
    cityWithStateAbbr: "Courtenay, ND",
  },
  {
    zip: "58428",
    ST: "ND",
    cityWithStateAbbr: "Dawson, ND",
  },
  {
    zip: "58429",
    ST: "ND",
    cityWithStateAbbr: "Dazey, ND",
  },
  {
    zip: "58430",
    ST: "ND",
    cityWithStateAbbr: "Denhoff, ND",
  },
  {
    zip: "58431",
    ST: "ND",
    cityWithStateAbbr: "Dickey, ND",
  },
  {
    zip: "58433",
    ST: "ND",
    cityWithStateAbbr: "Edgeley, ND",
  },
  {
    zip: "58436",
    ST: "ND",
    cityWithStateAbbr: "Ellendale, ND",
  },
  {
    zip: "58438",
    ST: "ND",
    cityWithStateAbbr: "Fessenden, ND",
  },
  {
    zip: "58439",
    ST: "ND",
    cityWithStateAbbr: "Forbes, ND",
  },
  {
    zip: "58440",
    ST: "ND",
    cityWithStateAbbr: "Fredonia, ND",
  },
  {
    zip: "58441",
    ST: "ND",
    cityWithStateAbbr: "Fullerton, ND",
  },
  {
    zip: "58442",
    ST: "ND",
    cityWithStateAbbr: "Gackle, ND",
  },
  {
    zip: "58443",
    ST: "ND",
    cityWithStateAbbr: "Glenfield, ND",
  },
  {
    zip: "58444",
    ST: "ND",
    cityWithStateAbbr: "Goodrich, ND",
  },
  {
    zip: "58445",
    ST: "ND",
    cityWithStateAbbr: "Grace City, ND",
  },
  {
    zip: "58448",
    ST: "ND",
    cityWithStateAbbr: "Hannaford, ND",
  },
  {
    zip: "58451",
    ST: "ND",
    cityWithStateAbbr: "Hurdsfield, ND",
  },
  {
    zip: "58452",
    ST: "ND",
    cityWithStateAbbr: "Jessie, ND",
  },
  {
    zip: "58454",
    ST: "ND",
    cityWithStateAbbr: "Jud, ND",
  },
  {
    zip: "58455",
    ST: "ND",
    cityWithStateAbbr: "Kensal, ND",
  },
  {
    zip: "58456",
    ST: "ND",
    cityWithStateAbbr: "Kulm, ND",
  },
  {
    zip: "58458",
    ST: "ND",
    cityWithStateAbbr: "Lamoure, ND",
  },
  {
    zip: "58460",
    ST: "ND",
    cityWithStateAbbr: "Lehr, ND",
  },
  {
    zip: "58461",
    ST: "ND",
    cityWithStateAbbr: "Litchville, ND",
  },
  {
    zip: "58463",
    ST: "ND",
    cityWithStateAbbr: "Mcclusky, ND",
  },
  {
    zip: "58464",
    ST: "ND",
    cityWithStateAbbr: "Mchenry, ND",
  },
  {
    zip: "58466",
    ST: "ND",
    cityWithStateAbbr: "Marion, ND",
  },
  {
    zip: "58467",
    ST: "ND",
    cityWithStateAbbr: "Medina, ND",
  },
  {
    zip: "58472",
    ST: "ND",
    cityWithStateAbbr: "Montpelier, ND",
  },
  {
    zip: "58474",
    ST: "ND",
    cityWithStateAbbr: "Oakes, ND",
  },
  {
    zip: "58475",
    ST: "ND",
    cityWithStateAbbr: "Pettibone, ND",
  },
  {
    zip: "58476",
    ST: "ND",
    cityWithStateAbbr: "Pingree, ND",
  },
  {
    zip: "58477",
    ST: "ND",
    cityWithStateAbbr: "Regan, ND",
  },
  {
    zip: "58478",
    ST: "ND",
    cityWithStateAbbr: "Robinson, ND",
  },
  {
    zip: "58479",
    ST: "ND",
    cityWithStateAbbr: "Rogers, ND",
  },
  {
    zip: "58480",
    ST: "ND",
    cityWithStateAbbr: "Sanborn, ND",
  },
  {
    zip: "58481",
    ST: "ND",
    cityWithStateAbbr: "Spiritwood, ND",
  },
  {
    zip: "58482",
    ST: "ND",
    cityWithStateAbbr: "Steele, ND",
  },
  {
    zip: "58483",
    ST: "ND",
    cityWithStateAbbr: "Streeter, ND",
  },
  {
    zip: "58484",
    ST: "ND",
    cityWithStateAbbr: "Sutton, ND",
  },
  {
    zip: "58486",
    ST: "ND",
    cityWithStateAbbr: "Sykeston, ND",
  },
  {
    zip: "58487",
    ST: "ND",
    cityWithStateAbbr: "Tappen, ND",
  },
  {
    zip: "58488",
    ST: "ND",
    cityWithStateAbbr: "Tuttle, ND",
  },
  {
    zip: "58490",
    ST: "ND",
    cityWithStateAbbr: "Verona, ND",
  },
  {
    zip: "58492",
    ST: "ND",
    cityWithStateAbbr: "Wimbledon, ND",
  },
  {
    zip: "58494",
    ST: "ND",
    cityWithStateAbbr: "Wing, ND",
  },
  {
    zip: "58495",
    ST: "ND",
    cityWithStateAbbr: "Wishek, ND",
  },
  {
    zip: "58496",
    ST: "ND",
    cityWithStateAbbr: "Woodworth, ND",
  },
  {
    zip: "58497",
    ST: "ND",
    cityWithStateAbbr: "Ypsilanti, ND",
  },
  {
    zip: "58501",
    ST: "ND",
    cityWithStateAbbr: "Bismarck, ND",
  },
  {
    zip: "58502",
    ST: "ND",
    cityWithStateAbbr: "Bismarck, ND",
  },
  {
    zip: "58503",
    ST: "ND",
    cityWithStateAbbr: "Bismarck, ND",
  },
  {
    zip: "58504",
    ST: "ND",
    cityWithStateAbbr: "Bismarck, ND",
  },
  {
    zip: "58505",
    ST: "ND",
    cityWithStateAbbr: "Bismarck, ND",
  },
  {
    zip: "58506",
    ST: "ND",
    cityWithStateAbbr: "Bismarck, ND",
  },
  {
    zip: "58507",
    ST: "ND",
    cityWithStateAbbr: "Bismarck, ND",
  },
  {
    zip: "58520",
    ST: "ND",
    cityWithStateAbbr: "Almont, ND",
  },
  {
    zip: "58521",
    ST: "ND",
    cityWithStateAbbr: "Baldwin, ND",
  },
  {
    zip: "58523",
    ST: "ND",
    cityWithStateAbbr: "Beulah, ND",
  },
  {
    zip: "58524",
    ST: "ND",
    cityWithStateAbbr: "Braddock, ND",
  },
  {
    zip: "58528",
    ST: "ND",
    cityWithStateAbbr: "Cannon Ball, ND",
  },
  {
    zip: "58529",
    ST: "ND",
    cityWithStateAbbr: "Carson, ND",
  },
  {
    zip: "58530",
    ST: "ND",
    cityWithStateAbbr: "Center, ND",
  },
  {
    zip: "58531",
    ST: "ND",
    cityWithStateAbbr: "Coleharbor, ND",
  },
  {
    zip: "58532",
    ST: "ND",
    cityWithStateAbbr: "Driscoll, ND",
  },
  {
    zip: "58533",
    ST: "ND",
    cityWithStateAbbr: "Elgin, ND",
  },
  {
    zip: "58535",
    ST: "ND",
    cityWithStateAbbr: "Flasher, ND",
  },
  {
    zip: "58538",
    ST: "ND",
    cityWithStateAbbr: "Fort Yates, ND",
  },
  {
    zip: "58540",
    ST: "ND",
    cityWithStateAbbr: "Garrison, ND",
  },
  {
    zip: "58541",
    ST: "ND",
    cityWithStateAbbr: "Golden Valley, ND",
  },
  {
    zip: "58542",
    ST: "ND",
    cityWithStateAbbr: "Hague, ND",
  },
  {
    zip: "58544",
    ST: "ND",
    cityWithStateAbbr: "Hazelton, ND",
  },
  {
    zip: "58545",
    ST: "ND",
    cityWithStateAbbr: "Hazen, ND",
  },
  {
    zip: "58549",
    ST: "ND",
    cityWithStateAbbr: "Kintyre, ND",
  },
  {
    zip: "58552",
    ST: "ND",
    cityWithStateAbbr: "Linton, ND",
  },
  {
    zip: "58554",
    ST: "ND",
    cityWithStateAbbr: "Mandan, ND",
  },
  {
    zip: "58558",
    ST: "ND",
    cityWithStateAbbr: "Menoken, ND",
  },
  {
    zip: "58559",
    ST: "ND",
    cityWithStateAbbr: "Mercer, ND",
  },
  {
    zip: "58560",
    ST: "ND",
    cityWithStateAbbr: "Moffit, ND",
  },
  {
    zip: "58561",
    ST: "ND",
    cityWithStateAbbr: "Napoleon, ND",
  },
  {
    zip: "58562",
    ST: "ND",
    cityWithStateAbbr: "New Leipzig, ND",
  },
  {
    zip: "58563",
    ST: "ND",
    cityWithStateAbbr: "New Salem, ND",
  },
  {
    zip: "58564",
    ST: "ND",
    cityWithStateAbbr: "Raleigh, ND",
  },
  {
    zip: "58565",
    ST: "ND",
    cityWithStateAbbr: "Riverdale, ND",
  },
  {
    zip: "58566",
    ST: "ND",
    cityWithStateAbbr: "Saint Anthony, ND",
  },
  {
    zip: "58568",
    ST: "ND",
    cityWithStateAbbr: "Selfridge, ND",
  },
  {
    zip: "58569",
    ST: "ND",
    cityWithStateAbbr: "Shields, ND",
  },
  {
    zip: "58570",
    ST: "ND",
    cityWithStateAbbr: "Solen, ND",
  },
  {
    zip: "58571",
    ST: "ND",
    cityWithStateAbbr: "Stanton, ND",
  },
  {
    zip: "58572",
    ST: "ND",
    cityWithStateAbbr: "Sterling, ND",
  },
  {
    zip: "58573",
    ST: "ND",
    cityWithStateAbbr: "Strasburg, ND",
  },
  {
    zip: "58575",
    ST: "ND",
    cityWithStateAbbr: "Turtle Lake, ND",
  },
  {
    zip: "58576",
    ST: "ND",
    cityWithStateAbbr: "Underwood, ND",
  },
  {
    zip: "58577",
    ST: "ND",
    cityWithStateAbbr: "Washburn, ND",
  },
  {
    zip: "58579",
    ST: "ND",
    cityWithStateAbbr: "Wilton, ND",
  },
  {
    zip: "58580",
    ST: "ND",
    cityWithStateAbbr: "Zap, ND",
  },
  {
    zip: "58581",
    ST: "ND",
    cityWithStateAbbr: "Zeeland, ND",
  },
  {
    zip: "58601",
    ST: "ND",
    cityWithStateAbbr: "Dickinson, ND",
  },
  {
    zip: "58602",
    ST: "ND",
    cityWithStateAbbr: "Dickinson, ND",
  },
  {
    zip: "58620",
    ST: "ND",
    cityWithStateAbbr: "Amidon, ND",
  },
  {
    zip: "58621",
    ST: "ND",
    cityWithStateAbbr: "Beach, ND",
  },
  {
    zip: "58622",
    ST: "ND",
    cityWithStateAbbr: "Belfield, ND",
  },
  {
    zip: "58623",
    ST: "ND",
    cityWithStateAbbr: "Bowman, ND",
  },
  {
    zip: "58625",
    ST: "ND",
    cityWithStateAbbr: "Dodge, ND",
  },
  {
    zip: "58626",
    ST: "ND",
    cityWithStateAbbr: "Dunn Center, ND",
  },
  {
    zip: "58627",
    ST: "ND",
    cityWithStateAbbr: "Fairfield, ND",
  },
  {
    zip: "58630",
    ST: "ND",
    cityWithStateAbbr: "Gladstone, ND",
  },
  {
    zip: "58631",
    ST: "ND",
    cityWithStateAbbr: "Glen Ullin, ND",
  },
  {
    zip: "58632",
    ST: "ND",
    cityWithStateAbbr: "Golva, ND",
  },
  {
    zip: "58634",
    ST: "ND",
    cityWithStateAbbr: "Grassy Butte, ND",
  },
  {
    zip: "58636",
    ST: "ND",
    cityWithStateAbbr: "Halliday, ND",
  },
  {
    zip: "58638",
    ST: "ND",
    cityWithStateAbbr: "Hebron, ND",
  },
  {
    zip: "58639",
    ST: "ND",
    cityWithStateAbbr: "Hettinger, ND",
  },
  {
    zip: "58640",
    ST: "ND",
    cityWithStateAbbr: "Killdeer, ND",
  },
  {
    zip: "58641",
    ST: "ND",
    cityWithStateAbbr: "Lefor, ND",
  },
  {
    zip: "58642",
    ST: "ND",
    cityWithStateAbbr: "Manning, ND",
  },
  {
    zip: "58643",
    ST: "ND",
    cityWithStateAbbr: "Marmarth, ND",
  },
  {
    zip: "58644",
    ST: "ND",
    cityWithStateAbbr: "Marshall, ND",
  },
  {
    zip: "58645",
    ST: "ND",
    cityWithStateAbbr: "Medora, ND",
  },
  {
    zip: "58646",
    ST: "ND",
    cityWithStateAbbr: "Mott, ND",
  },
  {
    zip: "58647",
    ST: "ND",
    cityWithStateAbbr: "New England, ND",
  },
  {
    zip: "58649",
    ST: "ND",
    cityWithStateAbbr: "Reeder, ND",
  },
  {
    zip: "58650",
    ST: "ND",
    cityWithStateAbbr: "Regent, ND",
  },
  {
    zip: "58651",
    ST: "ND",
    cityWithStateAbbr: "Rhame, ND",
  },
  {
    zip: "58652",
    ST: "ND",
    cityWithStateAbbr: "Richardton, ND",
  },
  {
    zip: "58653",
    ST: "ND",
    cityWithStateAbbr: "Scranton, ND",
  },
  {
    zip: "58654",
    ST: "ND",
    cityWithStateAbbr: "Sentinel Butte, ND",
  },
  {
    zip: "58655",
    ST: "ND",
    cityWithStateAbbr: "South Heart, ND",
  },
  {
    zip: "58656",
    ST: "ND",
    cityWithStateAbbr: "Taylor, ND",
  },
  {
    zip: "58701",
    ST: "ND",
    cityWithStateAbbr: "Minot, ND",
  },
  {
    zip: "58702",
    ST: "ND",
    cityWithStateAbbr: "Minot, ND",
  },
  {
    zip: "58703",
    ST: "ND",
    cityWithStateAbbr: "Minot, ND",
  },
  {
    zip: "58704",
    ST: "ND",
    cityWithStateAbbr: "Minot Afb, ND",
  },
  {
    zip: "58705",
    ST: "ND",
    cityWithStateAbbr: "Minot Afb, ND",
  },
  {
    zip: "58707",
    ST: "ND",
    cityWithStateAbbr: "Minot, ND",
  },
  {
    zip: "58710",
    ST: "ND",
    cityWithStateAbbr: "Anamoose, ND",
  },
  {
    zip: "58711",
    ST: "ND",
    cityWithStateAbbr: "Antler, ND",
  },
  {
    zip: "58712",
    ST: "ND",
    cityWithStateAbbr: "Balfour, ND",
  },
  {
    zip: "58713",
    ST: "ND",
    cityWithStateAbbr: "Bantry, ND",
  },
  {
    zip: "58716",
    ST: "ND",
    cityWithStateAbbr: "Benedict, ND",
  },
  {
    zip: "58718",
    ST: "ND",
    cityWithStateAbbr: "Berthold, ND",
  },
  {
    zip: "58721",
    ST: "ND",
    cityWithStateAbbr: "Bowbells, ND",
  },
  {
    zip: "58722",
    ST: "ND",
    cityWithStateAbbr: "Burlington, ND",
  },
  {
    zip: "58723",
    ST: "ND",
    cityWithStateAbbr: "Butte, ND",
  },
  {
    zip: "58725",
    ST: "ND",
    cityWithStateAbbr: "Carpio, ND",
  },
  {
    zip: "58727",
    ST: "ND",
    cityWithStateAbbr: "Columbus, ND",
  },
  {
    zip: "58730",
    ST: "ND",
    cityWithStateAbbr: "Crosby, ND",
  },
  {
    zip: "58731",
    ST: "ND",
    cityWithStateAbbr: "Deering, ND",
  },
  {
    zip: "58733",
    ST: "ND",
    cityWithStateAbbr: "Des Lacs, ND",
  },
  {
    zip: "58734",
    ST: "ND",
    cityWithStateAbbr: "Donnybrook, ND",
  },
  {
    zip: "58735",
    ST: "ND",
    cityWithStateAbbr: "Douglas, ND",
  },
  {
    zip: "58736",
    ST: "ND",
    cityWithStateAbbr: "Drake, ND",
  },
  {
    zip: "58737",
    ST: "ND",
    cityWithStateAbbr: "Flaxton, ND",
  },
  {
    zip: "58740",
    ST: "ND",
    cityWithStateAbbr: "Glenburn, ND",
  },
  {
    zip: "58741",
    ST: "ND",
    cityWithStateAbbr: "Granville, ND",
  },
  {
    zip: "58744",
    ST: "ND",
    cityWithStateAbbr: "Karlsruhe, ND",
  },
  {
    zip: "58746",
    ST: "ND",
    cityWithStateAbbr: "Kenmare, ND",
  },
  {
    zip: "58748",
    ST: "ND",
    cityWithStateAbbr: "Kramer, ND",
  },
  {
    zip: "58750",
    ST: "ND",
    cityWithStateAbbr: "Lansford, ND",
  },
  {
    zip: "58752",
    ST: "ND",
    cityWithStateAbbr: "Lignite, ND",
  },
  {
    zip: "58755",
    ST: "ND",
    cityWithStateAbbr: "Mcgregor, ND",
  },
  {
    zip: "58756",
    ST: "ND",
    cityWithStateAbbr: "Makoti, ND",
  },
  {
    zip: "58757",
    ST: "ND",
    cityWithStateAbbr: "Mandaree, ND",
  },
  {
    zip: "58758",
    ST: "ND",
    cityWithStateAbbr: "Martin, ND",
  },
  {
    zip: "58759",
    ST: "ND",
    cityWithStateAbbr: "Max, ND",
  },
  {
    zip: "58760",
    ST: "ND",
    cityWithStateAbbr: "Maxbass, ND",
  },
  {
    zip: "58761",
    ST: "ND",
    cityWithStateAbbr: "Mohall, ND",
  },
  {
    zip: "58762",
    ST: "ND",
    cityWithStateAbbr: "Newburg, ND",
  },
  {
    zip: "58763",
    ST: "ND",
    cityWithStateAbbr: "New Town, ND",
  },
  {
    zip: "58765",
    ST: "ND",
    cityWithStateAbbr: "Noonan, ND",
  },
  {
    zip: "58768",
    ST: "ND",
    cityWithStateAbbr: "Norwich, ND",
  },
  {
    zip: "58769",
    ST: "ND",
    cityWithStateAbbr: "Palermo, ND",
  },
  {
    zip: "58770",
    ST: "ND",
    cityWithStateAbbr: "Parshall, ND",
  },
  {
    zip: "58771",
    ST: "ND",
    cityWithStateAbbr: "Plaza, ND",
  },
  {
    zip: "58772",
    ST: "ND",
    cityWithStateAbbr: "Portal, ND",
  },
  {
    zip: "58773",
    ST: "ND",
    cityWithStateAbbr: "Powers Lake, ND",
  },
  {
    zip: "58775",
    ST: "ND",
    cityWithStateAbbr: "Roseglen, ND",
  },
  {
    zip: "58776",
    ST: "ND",
    cityWithStateAbbr: "Ross, ND",
  },
  {
    zip: "58778",
    ST: "ND",
    cityWithStateAbbr: "Ruso, ND",
  },
  {
    zip: "58779",
    ST: "ND",
    cityWithStateAbbr: "Ryder, ND",
  },
  {
    zip: "58781",
    ST: "ND",
    cityWithStateAbbr: "Sawyer, ND",
  },
  {
    zip: "58782",
    ST: "ND",
    cityWithStateAbbr: "Sherwood, ND",
  },
  {
    zip: "58783",
    ST: "ND",
    cityWithStateAbbr: "Souris, ND",
  },
  {
    zip: "58784",
    ST: "ND",
    cityWithStateAbbr: "Stanley, ND",
  },
  {
    zip: "58785",
    ST: "ND",
    cityWithStateAbbr: "Surrey, ND",
  },
  {
    zip: "58787",
    ST: "ND",
    cityWithStateAbbr: "Tolley, ND",
  },
  {
    zip: "58788",
    ST: "ND",
    cityWithStateAbbr: "Towner, ND",
  },
  {
    zip: "58789",
    ST: "ND",
    cityWithStateAbbr: "Upham, ND",
  },
  {
    zip: "58790",
    ST: "ND",
    cityWithStateAbbr: "Velva, ND",
  },
  {
    zip: "58792",
    ST: "ND",
    cityWithStateAbbr: "Voltaire, ND",
  },
  {
    zip: "58793",
    ST: "ND",
    cityWithStateAbbr: "Westhope, ND",
  },
  {
    zip: "58794",
    ST: "ND",
    cityWithStateAbbr: "White Earth, ND",
  },
  {
    zip: "58795",
    ST: "ND",
    cityWithStateAbbr: "Wildrose, ND",
  },
  {
    zip: "58801",
    ST: "ND",
    cityWithStateAbbr: "Williston, ND",
  },
  {
    zip: "58802",
    ST: "ND",
    cityWithStateAbbr: "Williston, ND",
  },
  {
    zip: "58830",
    ST: "ND",
    cityWithStateAbbr: "Alamo, ND",
  },
  {
    zip: "58831",
    ST: "ND",
    cityWithStateAbbr: "Alexander, ND",
  },
  {
    zip: "58833",
    ST: "ND",
    cityWithStateAbbr: "Ambrose, ND",
  },
  {
    zip: "58835",
    ST: "ND",
    cityWithStateAbbr: "Arnegard, ND",
  },
  {
    zip: "58838",
    ST: "ND",
    cityWithStateAbbr: "Cartwright, ND",
  },
  {
    zip: "58843",
    ST: "ND",
    cityWithStateAbbr: "Epping, ND",
  },
  {
    zip: "58844",
    ST: "ND",
    cityWithStateAbbr: "Fortuna, ND",
  },
  {
    zip: "58845",
    ST: "ND",
    cityWithStateAbbr: "Grenora, ND",
  },
  {
    zip: "58847",
    ST: "ND",
    cityWithStateAbbr: "Keene, ND",
  },
  {
    zip: "58849",
    ST: "ND",
    cityWithStateAbbr: "Ray, ND",
  },
  {
    zip: "58852",
    ST: "ND",
    cityWithStateAbbr: "Tioga, ND",
  },
  {
    zip: "58853",
    ST: "ND",
    cityWithStateAbbr: "Trenton, ND",
  },
  {
    zip: "58854",
    ST: "ND",
    cityWithStateAbbr: "Watford City, ND",
  },
  {
    zip: "58856",
    ST: "ND",
    cityWithStateAbbr: "Zahl, ND",
  },
  {
    zip: "59001",
    ST: "MT",
    cityWithStateAbbr: "Absarokee, MT",
  },
  {
    zip: "59002",
    ST: "MT",
    cityWithStateAbbr: "Acton, MT",
  },
  {
    zip: "59003",
    ST: "MT",
    cityWithStateAbbr: "Ashland, MT",
  },
  {
    zip: "59004",
    ST: "MT",
    cityWithStateAbbr: "Ashland, MT",
  },
  {
    zip: "59006",
    ST: "MT",
    cityWithStateAbbr: "Ballantine, MT",
  },
  {
    zip: "59007",
    ST: "MT",
    cityWithStateAbbr: "Bearcreek, MT",
  },
  {
    zip: "59008",
    ST: "MT",
    cityWithStateAbbr: "Belfry, MT",
  },
  {
    zip: "59010",
    ST: "MT",
    cityWithStateAbbr: "Bighorn, MT",
  },
  {
    zip: "59011",
    ST: "MT",
    cityWithStateAbbr: "Big Timber, MT",
  },
  {
    zip: "59012",
    ST: "MT",
    cityWithStateAbbr: "Birney, MT",
  },
  {
    zip: "59013",
    ST: "MT",
    cityWithStateAbbr: "Boyd, MT",
  },
  {
    zip: "59014",
    ST: "MT",
    cityWithStateAbbr: "Bridger, MT",
  },
  {
    zip: "59015",
    ST: "MT",
    cityWithStateAbbr: "Broadview, MT",
  },
  {
    zip: "59016",
    ST: "MT",
    cityWithStateAbbr: "Busby, MT",
  },
  {
    zip: "59018",
    ST: "MT",
    cityWithStateAbbr: "Clyde Park, MT",
  },
  {
    zip: "59019",
    ST: "MT",
    cityWithStateAbbr: "Columbus, MT",
  },
  {
    zip: "59020",
    ST: "MT",
    cityWithStateAbbr: "Cooke City, MT",
  },
  {
    zip: "59022",
    ST: "MT",
    cityWithStateAbbr: "Crow Agency, MT",
  },
  {
    zip: "59024",
    ST: "MT",
    cityWithStateAbbr: "Custer, MT",
  },
  {
    zip: "59025",
    ST: "MT",
    cityWithStateAbbr: "Decker, MT",
  },
  {
    zip: "59026",
    ST: "MT",
    cityWithStateAbbr: "Edgar, MT",
  },
  {
    zip: "59027",
    ST: "MT",
    cityWithStateAbbr: "Emigrant, MT",
  },
  {
    zip: "59028",
    ST: "MT",
    cityWithStateAbbr: "Fishtail, MT",
  },
  {
    zip: "59029",
    ST: "MT",
    cityWithStateAbbr: "Fromberg, MT",
  },
  {
    zip: "59030",
    ST: "MT",
    cityWithStateAbbr: "Gardiner, MT",
  },
  {
    zip: "59031",
    ST: "MT",
    cityWithStateAbbr: "Garryowen, MT",
  },
  {
    zip: "59032",
    ST: "MT",
    cityWithStateAbbr: "Grass Range, MT",
  },
  {
    zip: "59033",
    ST: "MT",
    cityWithStateAbbr: "Greycliff, MT",
  },
  {
    zip: "59034",
    ST: "MT",
    cityWithStateAbbr: "Hardin, MT",
  },
  {
    zip: "59035",
    ST: "MT",
    cityWithStateAbbr: "Fort Smith, MT",
  },
  {
    zip: "59036",
    ST: "MT",
    cityWithStateAbbr: "Harlowton, MT",
  },
  {
    zip: "59037",
    ST: "MT",
    cityWithStateAbbr: "Huntley, MT",
  },
  {
    zip: "59038",
    ST: "MT",
    cityWithStateAbbr: "Hysham, MT",
  },
  {
    zip: "59039",
    ST: "MT",
    cityWithStateAbbr: "Ingomar, MT",
  },
  {
    zip: "59041",
    ST: "MT",
    cityWithStateAbbr: "Joliet, MT",
  },
  {
    zip: "59043",
    ST: "MT",
    cityWithStateAbbr: "Lame Deer, MT",
  },
  {
    zip: "59044",
    ST: "MT",
    cityWithStateAbbr: "Laurel, MT",
  },
  {
    zip: "59046",
    ST: "MT",
    cityWithStateAbbr: "Lavina, MT",
  },
  {
    zip: "59047",
    ST: "MT",
    cityWithStateAbbr: "Livingston, MT",
  },
  {
    zip: "59050",
    ST: "MT",
    cityWithStateAbbr: "Lodge Grass, MT",
  },
  {
    zip: "59052",
    ST: "MT",
    cityWithStateAbbr: "Mc Leod, MT",
  },
  {
    zip: "59053",
    ST: "MT",
    cityWithStateAbbr: "Martinsdale, MT",
  },
  {
    zip: "59054",
    ST: "MT",
    cityWithStateAbbr: "Melstone, MT",
  },
  {
    zip: "59055",
    ST: "MT",
    cityWithStateAbbr: "Melville, MT",
  },
  {
    zip: "59057",
    ST: "MT",
    cityWithStateAbbr: "Molt, MT",
  },
  {
    zip: "59058",
    ST: "MT",
    cityWithStateAbbr: "Mosby, MT",
  },
  {
    zip: "59059",
    ST: "MT",
    cityWithStateAbbr: "Musselshell, MT",
  },
  {
    zip: "59061",
    ST: "MT",
    cityWithStateAbbr: "Nye, MT",
  },
  {
    zip: "59062",
    ST: "MT",
    cityWithStateAbbr: "Otter, MT",
  },
  {
    zip: "59063",
    ST: "MT",
    cityWithStateAbbr: "Park City, MT",
  },
  {
    zip: "59064",
    ST: "MT",
    cityWithStateAbbr: "Pompeys Pillar, MT",
  },
  {
    zip: "59065",
    ST: "MT",
    cityWithStateAbbr: "Pray, MT",
  },
  {
    zip: "59066",
    ST: "MT",
    cityWithStateAbbr: "Pryor, MT",
  },
  {
    zip: "59067",
    ST: "MT",
    cityWithStateAbbr: "Rapelje, MT",
  },
  {
    zip: "59068",
    ST: "MT",
    cityWithStateAbbr: "Red Lodge, MT",
  },
  {
    zip: "59069",
    ST: "MT",
    cityWithStateAbbr: "Reed Point, MT",
  },
  {
    zip: "59070",
    ST: "MT",
    cityWithStateAbbr: "Roberts, MT",
  },
  {
    zip: "59071",
    ST: "MT",
    cityWithStateAbbr: "Roscoe, MT",
  },
  {
    zip: "59072",
    ST: "MT",
    cityWithStateAbbr: "Roundup, MT",
  },
  {
    zip: "59073",
    ST: "MT",
    cityWithStateAbbr: "Roundup, MT",
  },
  {
    zip: "59074",
    ST: "MT",
    cityWithStateAbbr: "Ryegate, MT",
  },
  {
    zip: "59075",
    ST: "MT",
    cityWithStateAbbr: "Saint Xavier, MT",
  },
  {
    zip: "59076",
    ST: "MT",
    cityWithStateAbbr: "Sanders, MT",
  },
  {
    zip: "59077",
    ST: "MT",
    cityWithStateAbbr: "Sand Springs, MT",
  },
  {
    zip: "59078",
    ST: "MT",
    cityWithStateAbbr: "Shawmut, MT",
  },
  {
    zip: "59079",
    ST: "MT",
    cityWithStateAbbr: "Shepherd, MT",
  },
  {
    zip: "59081",
    ST: "MT",
    cityWithStateAbbr: "Silver Gate, MT",
  },
  {
    zip: "59082",
    ST: "MT",
    cityWithStateAbbr: "Springdale, MT",
  },
  {
    zip: "59083",
    ST: "MT",
    cityWithStateAbbr: "Sumatra, MT",
  },
  {
    zip: "59084",
    ST: "MT",
    cityWithStateAbbr: "Teigen, MT",
  },
  {
    zip: "59085",
    ST: "MT",
    cityWithStateAbbr: "Two Dot, MT",
  },
  {
    zip: "59086",
    ST: "MT",
    cityWithStateAbbr: "Wilsall, MT",
  },
  {
    zip: "59087",
    ST: "MT",
    cityWithStateAbbr: "Winnett, MT",
  },
  {
    zip: "59088",
    ST: "MT",
    cityWithStateAbbr: "Worden, MT",
  },
  {
    zip: "59089",
    ST: "MT",
    cityWithStateAbbr: "Wyola, MT",
  },
  {
    zip: "59101",
    ST: "MT",
    cityWithStateAbbr: "Billings, MT",
  },
  {
    zip: "59102",
    ST: "MT",
    cityWithStateAbbr: "Billings, MT",
  },
  {
    zip: "59103",
    ST: "MT",
    cityWithStateAbbr: "Billings, MT",
  },
  {
    zip: "59104",
    ST: "MT",
    cityWithStateAbbr: "Billings, MT",
  },
  {
    zip: "59105",
    ST: "MT",
    cityWithStateAbbr: "Billings, MT",
  },
  {
    zip: "59106",
    ST: "MT",
    cityWithStateAbbr: "Billings, MT",
  },
  {
    zip: "59107",
    ST: "MT",
    cityWithStateAbbr: "Billings, MT",
  },
  {
    zip: "59108",
    ST: "MT",
    cityWithStateAbbr: "Billings, MT",
  },
  {
    zip: "59111",
    ST: "MT",
    cityWithStateAbbr: "Billings, MT",
  },
  {
    zip: "59114",
    ST: "MT",
    cityWithStateAbbr: "Billings, MT",
  },
  {
    zip: "59115",
    ST: "MT",
    cityWithStateAbbr: "Billings, MT",
  },
  {
    zip: "59116",
    ST: "MT",
    cityWithStateAbbr: "Billings, MT",
  },
  {
    zip: "59117",
    ST: "MT",
    cityWithStateAbbr: "Billings, MT",
  },
  {
    zip: "59201",
    ST: "MT",
    cityWithStateAbbr: "Wolf Point, MT",
  },
  {
    zip: "59211",
    ST: "MT",
    cityWithStateAbbr: "Antelope, MT",
  },
  {
    zip: "59212",
    ST: "MT",
    cityWithStateAbbr: "Bainville, MT",
  },
  {
    zip: "59213",
    ST: "MT",
    cityWithStateAbbr: "Brockton, MT",
  },
  {
    zip: "59214",
    ST: "MT",
    cityWithStateAbbr: "Brockway, MT",
  },
  {
    zip: "59215",
    ST: "MT",
    cityWithStateAbbr: "Circle, MT",
  },
  {
    zip: "59217",
    ST: "MT",
    cityWithStateAbbr: "Crane, MT",
  },
  {
    zip: "59218",
    ST: "MT",
    cityWithStateAbbr: "Culbertson, MT",
  },
  {
    zip: "59219",
    ST: "MT",
    cityWithStateAbbr: "Dagmar, MT",
  },
  {
    zip: "59221",
    ST: "MT",
    cityWithStateAbbr: "Fairview, MT",
  },
  {
    zip: "59222",
    ST: "MT",
    cityWithStateAbbr: "Flaxville, MT",
  },
  {
    zip: "59223",
    ST: "MT",
    cityWithStateAbbr: "Fort Peck, MT",
  },
  {
    zip: "59225",
    ST: "MT",
    cityWithStateAbbr: "Frazer, MT",
  },
  {
    zip: "59226",
    ST: "MT",
    cityWithStateAbbr: "Froid, MT",
  },
  {
    zip: "59230",
    ST: "MT",
    cityWithStateAbbr: "Glasgow, MT",
  },
  {
    zip: "59231",
    ST: "MT",
    cityWithStateAbbr: "Saint Marie, MT",
  },
  {
    zip: "59240",
    ST: "MT",
    cityWithStateAbbr: "Glentana, MT",
  },
  {
    zip: "59241",
    ST: "MT",
    cityWithStateAbbr: "Hinsdale, MT",
  },
  {
    zip: "59242",
    ST: "MT",
    cityWithStateAbbr: "Homestead, MT",
  },
  {
    zip: "59243",
    ST: "MT",
    cityWithStateAbbr: "Lambert, MT",
  },
  {
    zip: "59244",
    ST: "MT",
    cityWithStateAbbr: "Larslan, MT",
  },
  {
    zip: "59247",
    ST: "MT",
    cityWithStateAbbr: "Medicine Lake, MT",
  },
  {
    zip: "59248",
    ST: "MT",
    cityWithStateAbbr: "Nashua, MT",
  },
  {
    zip: "59250",
    ST: "MT",
    cityWithStateAbbr: "Opheim, MT",
  },
  {
    zip: "59252",
    ST: "MT",
    cityWithStateAbbr: "Outlook, MT",
  },
  {
    zip: "59253",
    ST: "MT",
    cityWithStateAbbr: "Peerless, MT",
  },
  {
    zip: "59254",
    ST: "MT",
    cityWithStateAbbr: "Plentywood, MT",
  },
  {
    zip: "59255",
    ST: "MT",
    cityWithStateAbbr: "Poplar, MT",
  },
  {
    zip: "59256",
    ST: "MT",
    cityWithStateAbbr: "Raymond, MT",
  },
  {
    zip: "59257",
    ST: "MT",
    cityWithStateAbbr: "Redstone, MT",
  },
  {
    zip: "59258",
    ST: "MT",
    cityWithStateAbbr: "Reserve, MT",
  },
  {
    zip: "59259",
    ST: "MT",
    cityWithStateAbbr: "Richey, MT",
  },
  {
    zip: "59260",
    ST: "MT",
    cityWithStateAbbr: "Richland, MT",
  },
  {
    zip: "59261",
    ST: "MT",
    cityWithStateAbbr: "Saco, MT",
  },
  {
    zip: "59262",
    ST: "MT",
    cityWithStateAbbr: "Savage, MT",
  },
  {
    zip: "59263",
    ST: "MT",
    cityWithStateAbbr: "Scobey, MT",
  },
  {
    zip: "59270",
    ST: "MT",
    cityWithStateAbbr: "Sidney, MT",
  },
  {
    zip: "59273",
    ST: "MT",
    cityWithStateAbbr: "Vandalia, MT",
  },
  {
    zip: "59274",
    ST: "MT",
    cityWithStateAbbr: "Vida, MT",
  },
  {
    zip: "59275",
    ST: "MT",
    cityWithStateAbbr: "Westby, MT",
  },
  {
    zip: "59276",
    ST: "MT",
    cityWithStateAbbr: "Whitetail, MT",
  },
  {
    zip: "59301",
    ST: "MT",
    cityWithStateAbbr: "Miles City, MT",
  },
  {
    zip: "59311",
    ST: "MT",
    cityWithStateAbbr: "Alzada, MT",
  },
  {
    zip: "59312",
    ST: "MT",
    cityWithStateAbbr: "Angela, MT",
  },
  {
    zip: "59313",
    ST: "MT",
    cityWithStateAbbr: "Baker, MT",
  },
  {
    zip: "59314",
    ST: "MT",
    cityWithStateAbbr: "Biddle, MT",
  },
  {
    zip: "59315",
    ST: "MT",
    cityWithStateAbbr: "Bloomfield, MT",
  },
  {
    zip: "59316",
    ST: "MT",
    cityWithStateAbbr: "Boyes, MT",
  },
  {
    zip: "59317",
    ST: "MT",
    cityWithStateAbbr: "Broadus, MT",
  },
  {
    zip: "59318",
    ST: "MT",
    cityWithStateAbbr: "Brusett, MT",
  },
  {
    zip: "59319",
    ST: "MT",
    cityWithStateAbbr: "Capitol, MT",
  },
  {
    zip: "59322",
    ST: "MT",
    cityWithStateAbbr: "Cohagen, MT",
  },
  {
    zip: "59323",
    ST: "MT",
    cityWithStateAbbr: "Colstrip, MT",
  },
  {
    zip: "59324",
    ST: "MT",
    cityWithStateAbbr: "Ekalaka, MT",
  },
  {
    zip: "59326",
    ST: "MT",
    cityWithStateAbbr: "Fallon, MT",
  },
  {
    zip: "59327",
    ST: "MT",
    cityWithStateAbbr: "Forsyth, MT",
  },
  {
    zip: "59330",
    ST: "MT",
    cityWithStateAbbr: "Glendive, MT",
  },
  {
    zip: "59332",
    ST: "MT",
    cityWithStateAbbr: "Hammond, MT",
  },
  {
    zip: "59333",
    ST: "MT",
    cityWithStateAbbr: "Hathaway, MT",
  },
  {
    zip: "59336",
    ST: "MT",
    cityWithStateAbbr: "Ismay, MT",
  },
  {
    zip: "59337",
    ST: "MT",
    cityWithStateAbbr: "Jordan, MT",
  },
  {
    zip: "59338",
    ST: "MT",
    cityWithStateAbbr: "Kinsey, MT",
  },
  {
    zip: "59339",
    ST: "MT",
    cityWithStateAbbr: "Lindsay, MT",
  },
  {
    zip: "59341",
    ST: "MT",
    cityWithStateAbbr: "Mildred, MT",
  },
  {
    zip: "59343",
    ST: "MT",
    cityWithStateAbbr: "Olive, MT",
  },
  {
    zip: "59344",
    ST: "MT",
    cityWithStateAbbr: "Plevna, MT",
  },
  {
    zip: "59345",
    ST: "MT",
    cityWithStateAbbr: "Powderville, MT",
  },
  {
    zip: "59347",
    ST: "MT",
    cityWithStateAbbr: "Rosebud, MT",
  },
  {
    zip: "59349",
    ST: "MT",
    cityWithStateAbbr: "Terry, MT",
  },
  {
    zip: "59351",
    ST: "MT",
    cityWithStateAbbr: "Volborg, MT",
  },
  {
    zip: "59353",
    ST: "MT",
    cityWithStateAbbr: "Wibaux, MT",
  },
  {
    zip: "59354",
    ST: "MT",
    cityWithStateAbbr: "Willard, MT",
  },
  {
    zip: "59401",
    ST: "MT",
    cityWithStateAbbr: "Great Falls, MT",
  },
  {
    zip: "59402",
    ST: "MT",
    cityWithStateAbbr: "Malmstrom Afb, MT",
  },
  {
    zip: "59403",
    ST: "MT",
    cityWithStateAbbr: "Great Falls, MT",
  },
  {
    zip: "59404",
    ST: "MT",
    cityWithStateAbbr: "Great Falls, MT",
  },
  {
    zip: "59405",
    ST: "MT",
    cityWithStateAbbr: "Great Falls, MT",
  },
  {
    zip: "59406",
    ST: "MT",
    cityWithStateAbbr: "Great Falls, MT",
  },
  {
    zip: "59410",
    ST: "MT",
    cityWithStateAbbr: "Augusta, MT",
  },
  {
    zip: "59411",
    ST: "MT",
    cityWithStateAbbr: "Babb, MT",
  },
  {
    zip: "59412",
    ST: "MT",
    cityWithStateAbbr: "Belt, MT",
  },
  {
    zip: "59414",
    ST: "MT",
    cityWithStateAbbr: "Black Eagle, MT",
  },
  {
    zip: "59416",
    ST: "MT",
    cityWithStateAbbr: "Brady, MT",
  },
  {
    zip: "59417",
    ST: "MT",
    cityWithStateAbbr: "Browning, MT",
  },
  {
    zip: "59418",
    ST: "MT",
    cityWithStateAbbr: "Buffalo, MT",
  },
  {
    zip: "59419",
    ST: "MT",
    cityWithStateAbbr: "Bynum, MT",
  },
  {
    zip: "59420",
    ST: "MT",
    cityWithStateAbbr: "Carter, MT",
  },
  {
    zip: "59421",
    ST: "MT",
    cityWithStateAbbr: "Cascade, MT",
  },
  {
    zip: "59422",
    ST: "MT",
    cityWithStateAbbr: "Choteau, MT",
  },
  {
    zip: "59424",
    ST: "MT",
    cityWithStateAbbr: "Coffee Creek, MT",
  },
  {
    zip: "59425",
    ST: "MT",
    cityWithStateAbbr: "Conrad, MT",
  },
  {
    zip: "59427",
    ST: "MT",
    cityWithStateAbbr: "Cut Bank, MT",
  },
  {
    zip: "59430",
    ST: "MT",
    cityWithStateAbbr: "Denton, MT",
  },
  {
    zip: "59432",
    ST: "MT",
    cityWithStateAbbr: "Dupuyer, MT",
  },
  {
    zip: "59433",
    ST: "MT",
    cityWithStateAbbr: "Dutton, MT",
  },
  {
    zip: "59434",
    ST: "MT",
    cityWithStateAbbr: "East Glacier Park, MT",
  },
  {
    zip: "59435",
    ST: "MT",
    cityWithStateAbbr: "Ethridge, MT",
  },
  {
    zip: "59436",
    ST: "MT",
    cityWithStateAbbr: "Fairfield, MT",
  },
  {
    zip: "59440",
    ST: "MT",
    cityWithStateAbbr: "Floweree, MT",
  },
  {
    zip: "59441",
    ST: "MT",
    cityWithStateAbbr: "Forest Grove, MT",
  },
  {
    zip: "59442",
    ST: "MT",
    cityWithStateAbbr: "Fort Benton, MT",
  },
  {
    zip: "59443",
    ST: "MT",
    cityWithStateAbbr: "Fort Shaw, MT",
  },
  {
    zip: "59444",
    ST: "MT",
    cityWithStateAbbr: "Galata, MT",
  },
  {
    zip: "59446",
    ST: "MT",
    cityWithStateAbbr: "Geraldine, MT",
  },
  {
    zip: "59447",
    ST: "MT",
    cityWithStateAbbr: "Geyser, MT",
  },
  {
    zip: "59448",
    ST: "MT",
    cityWithStateAbbr: "Heart Butte, MT",
  },
  {
    zip: "59450",
    ST: "MT",
    cityWithStateAbbr: "Highwood, MT",
  },
  {
    zip: "59451",
    ST: "MT",
    cityWithStateAbbr: "Hilger, MT",
  },
  {
    zip: "59452",
    ST: "MT",
    cityWithStateAbbr: "Hobson, MT",
  },
  {
    zip: "59453",
    ST: "MT",
    cityWithStateAbbr: "Judith Gap, MT",
  },
  {
    zip: "59454",
    ST: "MT",
    cityWithStateAbbr: "Kevin, MT",
  },
  {
    zip: "59456",
    ST: "MT",
    cityWithStateAbbr: "Ledger, MT",
  },
  {
    zip: "59457",
    ST: "MT",
    cityWithStateAbbr: "Lewistown, MT",
  },
  {
    zip: "59460",
    ST: "MT",
    cityWithStateAbbr: "Loma, MT",
  },
  {
    zip: "59461",
    ST: "MT",
    cityWithStateAbbr: "Lothair, MT",
  },
  {
    zip: "59462",
    ST: "MT",
    cityWithStateAbbr: "Moccasin, MT",
  },
  {
    zip: "59463",
    ST: "MT",
    cityWithStateAbbr: "Monarch, MT",
  },
  {
    zip: "59464",
    ST: "MT",
    cityWithStateAbbr: "Moore, MT",
  },
  {
    zip: "59465",
    ST: "MT",
    cityWithStateAbbr: "Neihart, MT",
  },
  {
    zip: "59466",
    ST: "MT",
    cityWithStateAbbr: "Oilmont, MT",
  },
  {
    zip: "59467",
    ST: "MT",
    cityWithStateAbbr: "Pendroy, MT",
  },
  {
    zip: "59468",
    ST: "MT",
    cityWithStateAbbr: "Power, MT",
  },
  {
    zip: "59469",
    ST: "MT",
    cityWithStateAbbr: "Raynesford, MT",
  },
  {
    zip: "59471",
    ST: "MT",
    cityWithStateAbbr: "Roy, MT",
  },
  {
    zip: "59472",
    ST: "MT",
    cityWithStateAbbr: "Sand Coulee, MT",
  },
  {
    zip: "59474",
    ST: "MT",
    cityWithStateAbbr: "Shelby, MT",
  },
  {
    zip: "59477",
    ST: "MT",
    cityWithStateAbbr: "Simms, MT",
  },
  {
    zip: "59479",
    ST: "MT",
    cityWithStateAbbr: "Stanford, MT",
  },
  {
    zip: "59480",
    ST: "MT",
    cityWithStateAbbr: "Stockett, MT",
  },
  {
    zip: "59482",
    ST: "MT",
    cityWithStateAbbr: "Sunburst, MT",
  },
  {
    zip: "59483",
    ST: "MT",
    cityWithStateAbbr: "Sun River, MT",
  },
  {
    zip: "59484",
    ST: "MT",
    cityWithStateAbbr: "Sweet Grass, MT",
  },
  {
    zip: "59485",
    ST: "MT",
    cityWithStateAbbr: "Ulm, MT",
  },
  {
    zip: "59486",
    ST: "MT",
    cityWithStateAbbr: "Valier, MT",
  },
  {
    zip: "59487",
    ST: "MT",
    cityWithStateAbbr: "Vaughn, MT",
  },
  {
    zip: "59489",
    ST: "MT",
    cityWithStateAbbr: "Winifred, MT",
  },
  {
    zip: "59501",
    ST: "MT",
    cityWithStateAbbr: "Havre, MT",
  },
  {
    zip: "59520",
    ST: "MT",
    cityWithStateAbbr: "Big Sandy, MT",
  },
  {
    zip: "59521",
    ST: "MT",
    cityWithStateAbbr: "Box Elder, MT",
  },
  {
    zip: "59522",
    ST: "MT",
    cityWithStateAbbr: "Chester, MT",
  },
  {
    zip: "59523",
    ST: "MT",
    cityWithStateAbbr: "Chinook, MT",
  },
  {
    zip: "59524",
    ST: "MT",
    cityWithStateAbbr: "Dodson, MT",
  },
  {
    zip: "59525",
    ST: "MT",
    cityWithStateAbbr: "Gildford, MT",
  },
  {
    zip: "59526",
    ST: "MT",
    cityWithStateAbbr: "Harlem, MT",
  },
  {
    zip: "59527",
    ST: "MT",
    cityWithStateAbbr: "Hays, MT",
  },
  {
    zip: "59528",
    ST: "MT",
    cityWithStateAbbr: "Hingham, MT",
  },
  {
    zip: "59529",
    ST: "MT",
    cityWithStateAbbr: "Hogeland, MT",
  },
  {
    zip: "59530",
    ST: "MT",
    cityWithStateAbbr: "Inverness, MT",
  },
  {
    zip: "59531",
    ST: "MT",
    cityWithStateAbbr: "Joplin, MT",
  },
  {
    zip: "59532",
    ST: "MT",
    cityWithStateAbbr: "Kremlin, MT",
  },
  {
    zip: "59535",
    ST: "MT",
    cityWithStateAbbr: "Lloyd, MT",
  },
  {
    zip: "59537",
    ST: "MT",
    cityWithStateAbbr: "Loring, MT",
  },
  {
    zip: "59538",
    ST: "MT",
    cityWithStateAbbr: "Malta, MT",
  },
  {
    zip: "59540",
    ST: "MT",
    cityWithStateAbbr: "Rudyard, MT",
  },
  {
    zip: "59542",
    ST: "MT",
    cityWithStateAbbr: "Turner, MT",
  },
  {
    zip: "59544",
    ST: "MT",
    cityWithStateAbbr: "Whitewater, MT",
  },
  {
    zip: "59545",
    ST: "MT",
    cityWithStateAbbr: "Whitlash, MT",
  },
  {
    zip: "59546",
    ST: "MT",
    cityWithStateAbbr: "Zortman, MT",
  },
  {
    zip: "59547",
    ST: "MT",
    cityWithStateAbbr: "Zurich, MT",
  },
  {
    zip: "59601",
    ST: "MT",
    cityWithStateAbbr: "Helena, MT",
  },
  {
    zip: "59602",
    ST: "MT",
    cityWithStateAbbr: "Helena, MT",
  },
  {
    zip: "59604",
    ST: "MT",
    cityWithStateAbbr: "Helena, MT",
  },
  {
    zip: "59620",
    ST: "MT",
    cityWithStateAbbr: "Helena, MT",
  },
  {
    zip: "59623",
    ST: "MT",
    cityWithStateAbbr: "Helena, MT",
  },
  {
    zip: "59624",
    ST: "MT",
    cityWithStateAbbr: "Helena, MT",
  },
  {
    zip: "59625",
    ST: "MT",
    cityWithStateAbbr: "Helena, MT",
  },
  {
    zip: "59626",
    ST: "MT",
    cityWithStateAbbr: "Helena, MT",
  },
  {
    zip: "59631",
    ST: "MT",
    cityWithStateAbbr: "Basin, MT",
  },
  {
    zip: "59632",
    ST: "MT",
    cityWithStateAbbr: "Boulder, MT",
  },
  {
    zip: "59633",
    ST: "MT",
    cityWithStateAbbr: "Canyon Creek, MT",
  },
  {
    zip: "59634",
    ST: "MT",
    cityWithStateAbbr: "Clancy, MT",
  },
  {
    zip: "59635",
    ST: "MT",
    cityWithStateAbbr: "East Helena, MT",
  },
  {
    zip: "59636",
    ST: "MT",
    cityWithStateAbbr: "Fort Harrison, MT",
  },
  {
    zip: "59638",
    ST: "MT",
    cityWithStateAbbr: "Jefferson City, MT",
  },
  {
    zip: "59639",
    ST: "MT",
    cityWithStateAbbr: "Lincoln, MT",
  },
  {
    zip: "59640",
    ST: "MT",
    cityWithStateAbbr: "Marysville, MT",
  },
  {
    zip: "59641",
    ST: "MT",
    cityWithStateAbbr: "Radersburg, MT",
  },
  {
    zip: "59642",
    ST: "MT",
    cityWithStateAbbr: "Ringling, MT",
  },
  {
    zip: "59643",
    ST: "MT",
    cityWithStateAbbr: "Toston, MT",
  },
  {
    zip: "59644",
    ST: "MT",
    cityWithStateAbbr: "Townsend, MT",
  },
  {
    zip: "59645",
    ST: "MT",
    cityWithStateAbbr: "White Sulphur Springs, MT",
  },
  {
    zip: "59647",
    ST: "MT",
    cityWithStateAbbr: "Winston, MT",
  },
  {
    zip: "59648",
    ST: "MT",
    cityWithStateAbbr: "Wolf Creek, MT",
  },
  {
    zip: "59701",
    ST: "MT",
    cityWithStateAbbr: "Butte, MT",
  },
  {
    zip: "59702",
    ST: "MT",
    cityWithStateAbbr: "Butte, MT",
  },
  {
    zip: "59703",
    ST: "MT",
    cityWithStateAbbr: "Butte, MT",
  },
  {
    zip: "59707",
    ST: "MT",
    cityWithStateAbbr: "Butte, MT",
  },
  {
    zip: "59710",
    ST: "MT",
    cityWithStateAbbr: "Alder, MT",
  },
  {
    zip: "59711",
    ST: "MT",
    cityWithStateAbbr: "Anaconda, MT",
  },
  {
    zip: "59713",
    ST: "MT",
    cityWithStateAbbr: "Avon, MT",
  },
  {
    zip: "59714",
    ST: "MT",
    cityWithStateAbbr: "Belgrade, MT",
  },
  {
    zip: "59715",
    ST: "MT",
    cityWithStateAbbr: "Bozeman, MT",
  },
  {
    zip: "59716",
    ST: "MT",
    cityWithStateAbbr: "Big Sky, MT",
  },
  {
    zip: "59717",
    ST: "MT",
    cityWithStateAbbr: "Bozeman, MT",
  },
  {
    zip: "59718",
    ST: "MT",
    cityWithStateAbbr: "Bozeman, MT",
  },
  {
    zip: "59719",
    ST: "MT",
    cityWithStateAbbr: "Bozeman, MT",
  },
  {
    zip: "59720",
    ST: "MT",
    cityWithStateAbbr: "Cameron, MT",
  },
  {
    zip: "59721",
    ST: "MT",
    cityWithStateAbbr: "Cardwell, MT",
  },
  {
    zip: "59722",
    ST: "MT",
    cityWithStateAbbr: "Deer Lodge, MT",
  },
  {
    zip: "59724",
    ST: "MT",
    cityWithStateAbbr: "Dell, MT",
  },
  {
    zip: "59725",
    ST: "MT",
    cityWithStateAbbr: "Dillon, MT",
  },
  {
    zip: "59727",
    ST: "MT",
    cityWithStateAbbr: "Divide, MT",
  },
  {
    zip: "59728",
    ST: "MT",
    cityWithStateAbbr: "Elliston, MT",
  },
  {
    zip: "59729",
    ST: "MT",
    cityWithStateAbbr: "Ennis, MT",
  },
  {
    zip: "59730",
    ST: "MT",
    cityWithStateAbbr: "Gallatin Gateway, MT",
  },
  {
    zip: "59731",
    ST: "MT",
    cityWithStateAbbr: "Garrison, MT",
  },
  {
    zip: "59732",
    ST: "MT",
    cityWithStateAbbr: "Glen, MT",
  },
  {
    zip: "59733",
    ST: "MT",
    cityWithStateAbbr: "Gold Creek, MT",
  },
  {
    zip: "59735",
    ST: "MT",
    cityWithStateAbbr: "Harrison, MT",
  },
  {
    zip: "59736",
    ST: "MT",
    cityWithStateAbbr: "Jackson, MT",
  },
  {
    zip: "59739",
    ST: "MT",
    cityWithStateAbbr: "Lima, MT",
  },
  {
    zip: "59740",
    ST: "MT",
    cityWithStateAbbr: "Mc Allister, MT",
  },
  {
    zip: "59741",
    ST: "MT",
    cityWithStateAbbr: "Manhattan, MT",
  },
  {
    zip: "59743",
    ST: "MT",
    cityWithStateAbbr: "Melrose, MT",
  },
  {
    zip: "59745",
    ST: "MT",
    cityWithStateAbbr: "Norris, MT",
  },
  {
    zip: "59746",
    ST: "MT",
    cityWithStateAbbr: "Polaris, MT",
  },
  {
    zip: "59747",
    ST: "MT",
    cityWithStateAbbr: "Pony, MT",
  },
  {
    zip: "59748",
    ST: "MT",
    cityWithStateAbbr: "Ramsay, MT",
  },
  {
    zip: "59749",
    ST: "MT",
    cityWithStateAbbr: "Sheridan, MT",
  },
  {
    zip: "59750",
    ST: "MT",
    cityWithStateAbbr: "Butte, MT",
  },
  {
    zip: "59751",
    ST: "MT",
    cityWithStateAbbr: "Silver Star, MT",
  },
  {
    zip: "59752",
    ST: "MT",
    cityWithStateAbbr: "Three Forks, MT",
  },
  {
    zip: "59754",
    ST: "MT",
    cityWithStateAbbr: "Twin Bridges, MT",
  },
  {
    zip: "59755",
    ST: "MT",
    cityWithStateAbbr: "Virginia City, MT",
  },
  {
    zip: "59756",
    ST: "MT",
    cityWithStateAbbr: "Warm Springs, MT",
  },
  {
    zip: "59758",
    ST: "MT",
    cityWithStateAbbr: "West Yellowstone, MT",
  },
  {
    zip: "59759",
    ST: "MT",
    cityWithStateAbbr: "Whitehall, MT",
  },
  {
    zip: "59760",
    ST: "MT",
    cityWithStateAbbr: "Willow Creek, MT",
  },
  {
    zip: "59761",
    ST: "MT",
    cityWithStateAbbr: "Wisdom, MT",
  },
  {
    zip: "59762",
    ST: "MT",
    cityWithStateAbbr: "Wise River, MT",
  },
  {
    zip: "59771",
    ST: "MT",
    cityWithStateAbbr: "Bozeman, MT",
  },
  {
    zip: "59772",
    ST: "MT",
    cityWithStateAbbr: "Bozeman, MT",
  },
  {
    zip: "59801",
    ST: "MT",
    cityWithStateAbbr: "Missoula, MT",
  },
  {
    zip: "59802",
    ST: "MT",
    cityWithStateAbbr: "Missoula, MT",
  },
  {
    zip: "59803",
    ST: "MT",
    cityWithStateAbbr: "Missoula, MT",
  },
  {
    zip: "59804",
    ST: "MT",
    cityWithStateAbbr: "Missoula, MT",
  },
  {
    zip: "59806",
    ST: "MT",
    cityWithStateAbbr: "Missoula, MT",
  },
  {
    zip: "59807",
    ST: "MT",
    cityWithStateAbbr: "Missoula, MT",
  },
  {
    zip: "59808",
    ST: "MT",
    cityWithStateAbbr: "Missoula, MT",
  },
  {
    zip: "59812",
    ST: "MT",
    cityWithStateAbbr: "Missoula, MT",
  },
  {
    zip: "59820",
    ST: "MT",
    cityWithStateAbbr: "Alberton, MT",
  },
  {
    zip: "59821",
    ST: "MT",
    cityWithStateAbbr: "Arlee, MT",
  },
  {
    zip: "59823",
    ST: "MT",
    cityWithStateAbbr: "Bonner, MT",
  },
  {
    zip: "59824",
    ST: "MT",
    cityWithStateAbbr: "Charlo, MT",
  },
  {
    zip: "59825",
    ST: "MT",
    cityWithStateAbbr: "Clinton, MT",
  },
  {
    zip: "59826",
    ST: "MT",
    cityWithStateAbbr: "Condon, MT",
  },
  {
    zip: "59827",
    ST: "MT",
    cityWithStateAbbr: "Conner, MT",
  },
  {
    zip: "59828",
    ST: "MT",
    cityWithStateAbbr: "Corvallis, MT",
  },
  {
    zip: "59829",
    ST: "MT",
    cityWithStateAbbr: "Darby, MT",
  },
  {
    zip: "59830",
    ST: "MT",
    cityWithStateAbbr: "De Borgia, MT",
  },
  {
    zip: "59831",
    ST: "MT",
    cityWithStateAbbr: "Dixon, MT",
  },
  {
    zip: "59832",
    ST: "MT",
    cityWithStateAbbr: "Drummond, MT",
  },
  {
    zip: "59833",
    ST: "MT",
    cityWithStateAbbr: "Florence, MT",
  },
  {
    zip: "59834",
    ST: "MT",
    cityWithStateAbbr: "Frenchtown, MT",
  },
  {
    zip: "59835",
    ST: "MT",
    cityWithStateAbbr: "Grantsdale, MT",
  },
  {
    zip: "59837",
    ST: "MT",
    cityWithStateAbbr: "Hall, MT",
  },
  {
    zip: "59840",
    ST: "MT",
    cityWithStateAbbr: "Hamilton, MT",
  },
  {
    zip: "59841",
    ST: "MT",
    cityWithStateAbbr: "Pinesdale, MT",
  },
  {
    zip: "59842",
    ST: "MT",
    cityWithStateAbbr: "Haugan, MT",
  },
  {
    zip: "59843",
    ST: "MT",
    cityWithStateAbbr: "Helmville, MT",
  },
  {
    zip: "59844",
    ST: "MT",
    cityWithStateAbbr: "Heron, MT",
  },
  {
    zip: "59845",
    ST: "MT",
    cityWithStateAbbr: "Hot Springs, MT",
  },
  {
    zip: "59846",
    ST: "MT",
    cityWithStateAbbr: "Huson, MT",
  },
  {
    zip: "59847",
    ST: "MT",
    cityWithStateAbbr: "Lolo, MT",
  },
  {
    zip: "59848",
    ST: "MT",
    cityWithStateAbbr: "Lonepine, MT",
  },
  {
    zip: "59851",
    ST: "MT",
    cityWithStateAbbr: "Milltown, MT",
  },
  {
    zip: "59853",
    ST: "MT",
    cityWithStateAbbr: "Noxon, MT",
  },
  {
    zip: "59854",
    ST: "MT",
    cityWithStateAbbr: "Ovando, MT",
  },
  {
    zip: "59855",
    ST: "MT",
    cityWithStateAbbr: "Pablo, MT",
  },
  {
    zip: "59856",
    ST: "MT",
    cityWithStateAbbr: "Paradise, MT",
  },
  {
    zip: "59858",
    ST: "MT",
    cityWithStateAbbr: "Philipsburg, MT",
  },
  {
    zip: "59859",
    ST: "MT",
    cityWithStateAbbr: "Plains, MT",
  },
  {
    zip: "59860",
    ST: "MT",
    cityWithStateAbbr: "Polson, MT",
  },
  {
    zip: "59863",
    ST: "MT",
    cityWithStateAbbr: "Ravalli, MT",
  },
  {
    zip: "59864",
    ST: "MT",
    cityWithStateAbbr: "Ronan, MT",
  },
  {
    zip: "59865",
    ST: "MT",
    cityWithStateAbbr: "Saint Ignatius, MT",
  },
  {
    zip: "59866",
    ST: "MT",
    cityWithStateAbbr: "Saint Regis, MT",
  },
  {
    zip: "59867",
    ST: "MT",
    cityWithStateAbbr: "Saltese, MT",
  },
  {
    zip: "59868",
    ST: "MT",
    cityWithStateAbbr: "Seeley Lake, MT",
  },
  {
    zip: "59870",
    ST: "MT",
    cityWithStateAbbr: "Stevensville, MT",
  },
  {
    zip: "59871",
    ST: "MT",
    cityWithStateAbbr: "Sula, MT",
  },
  {
    zip: "59872",
    ST: "MT",
    cityWithStateAbbr: "Superior, MT",
  },
  {
    zip: "59873",
    ST: "MT",
    cityWithStateAbbr: "Thompson Falls, MT",
  },
  {
    zip: "59874",
    ST: "MT",
    cityWithStateAbbr: "Trout Creek, MT",
  },
  {
    zip: "59875",
    ST: "MT",
    cityWithStateAbbr: "Victor, MT",
  },
  {
    zip: "59901",
    ST: "MT",
    cityWithStateAbbr: "Kalispell, MT",
  },
  {
    zip: "59903",
    ST: "MT",
    cityWithStateAbbr: "Kalispell, MT",
  },
  {
    zip: "59904",
    ST: "MT",
    cityWithStateAbbr: "Kalispell, MT",
  },
  {
    zip: "59910",
    ST: "MT",
    cityWithStateAbbr: "Big Arm, MT",
  },
  {
    zip: "59911",
    ST: "MT",
    cityWithStateAbbr: "Bigfork, MT",
  },
  {
    zip: "59912",
    ST: "MT",
    cityWithStateAbbr: "Columbia Falls, MT",
  },
  {
    zip: "59913",
    ST: "MT",
    cityWithStateAbbr: "Coram, MT",
  },
  {
    zip: "59914",
    ST: "MT",
    cityWithStateAbbr: "Dayton, MT",
  },
  {
    zip: "59915",
    ST: "MT",
    cityWithStateAbbr: "Elmo, MT",
  },
  {
    zip: "59916",
    ST: "MT",
    cityWithStateAbbr: "Essex, MT",
  },
  {
    zip: "59917",
    ST: "MT",
    cityWithStateAbbr: "Eureka, MT",
  },
  {
    zip: "59918",
    ST: "MT",
    cityWithStateAbbr: "Fortine, MT",
  },
  {
    zip: "59919",
    ST: "MT",
    cityWithStateAbbr: "Hungry Horse, MT",
  },
  {
    zip: "59920",
    ST: "MT",
    cityWithStateAbbr: "Kila, MT",
  },
  {
    zip: "59921",
    ST: "MT",
    cityWithStateAbbr: "Lake Mc Donald, MT",
  },
  {
    zip: "59922",
    ST: "MT",
    cityWithStateAbbr: "Lakeside, MT",
  },
  {
    zip: "59923",
    ST: "MT",
    cityWithStateAbbr: "Libby, MT",
  },
  {
    zip: "59925",
    ST: "MT",
    cityWithStateAbbr: "Marion, MT",
  },
  {
    zip: "59926",
    ST: "MT",
    cityWithStateAbbr: "Martin City, MT",
  },
  {
    zip: "59927",
    ST: "MT",
    cityWithStateAbbr: "Olney, MT",
  },
  {
    zip: "59928",
    ST: "MT",
    cityWithStateAbbr: "Polebridge, MT",
  },
  {
    zip: "59929",
    ST: "MT",
    cityWithStateAbbr: "Proctor, MT",
  },
  {
    zip: "59930",
    ST: "MT",
    cityWithStateAbbr: "Rexford, MT",
  },
  {
    zip: "59931",
    ST: "MT",
    cityWithStateAbbr: "Rollins, MT",
  },
  {
    zip: "59932",
    ST: "MT",
    cityWithStateAbbr: "Somers, MT",
  },
  {
    zip: "59933",
    ST: "MT",
    cityWithStateAbbr: "Stryker, MT",
  },
  {
    zip: "59934",
    ST: "MT",
    cityWithStateAbbr: "Trego, MT",
  },
  {
    zip: "59935",
    ST: "MT",
    cityWithStateAbbr: "Troy, MT",
  },
  {
    zip: "59936",
    ST: "MT",
    cityWithStateAbbr: "West Glacier, MT",
  },
  {
    zip: "59937",
    ST: "MT",
    cityWithStateAbbr: "Whitefish, MT",
  },
  {
    zip: "60001",
    ST: "IL",
    cityWithStateAbbr: "Alden, IL",
  },
  {
    zip: "60002",
    ST: "IL",
    cityWithStateAbbr: "Antioch, IL",
  },
  {
    zip: "60004",
    ST: "IL",
    cityWithStateAbbr: "Arlington Heights, IL",
  },
  {
    zip: "60005",
    ST: "IL",
    cityWithStateAbbr: "Arlington Heights, IL",
  },
  {
    zip: "60006",
    ST: "IL",
    cityWithStateAbbr: "Arlington Heights, IL",
  },
  {
    zip: "60007",
    ST: "IL",
    cityWithStateAbbr: "Elk Grove Village, IL",
  },
  {
    zip: "60008",
    ST: "IL",
    cityWithStateAbbr: "Rolling Meadows, IL",
  },
  {
    zip: "60009",
    ST: "IL",
    cityWithStateAbbr: "Elk Grove Village, IL",
  },
  {
    zip: "60010",
    ST: "IL",
    cityWithStateAbbr: "Barrington, IL",
  },
  {
    zip: "60011",
    ST: "IL",
    cityWithStateAbbr: "Barrington, IL",
  },
  {
    zip: "60012",
    ST: "IL",
    cityWithStateAbbr: "Crystal Lake, IL",
  },
  {
    zip: "60013",
    ST: "IL",
    cityWithStateAbbr: "Cary, IL",
  },
  {
    zip: "60014",
    ST: "IL",
    cityWithStateAbbr: "Crystal Lake, IL",
  },
  {
    zip: "60015",
    ST: "IL",
    cityWithStateAbbr: "Deerfield, IL",
  },
  {
    zip: "60016",
    ST: "IL",
    cityWithStateAbbr: "Des Plaines, IL",
  },
  {
    zip: "60017",
    ST: "IL",
    cityWithStateAbbr: "Des Plaines, IL",
  },
  {
    zip: "60018",
    ST: "IL",
    cityWithStateAbbr: "Des Plaines, IL",
  },
  {
    zip: "60019",
    ST: "IL",
    cityWithStateAbbr: "Des Plaines, IL",
  },
  {
    zip: "60020",
    ST: "IL",
    cityWithStateAbbr: "Fox Lake, IL",
  },
  {
    zip: "60021",
    ST: "IL",
    cityWithStateAbbr: "Fox River Grove, IL",
  },
  {
    zip: "60022",
    ST: "IL",
    cityWithStateAbbr: "Glencoe, IL",
  },
  {
    zip: "60025",
    ST: "IL",
    cityWithStateAbbr: "Glenview, IL",
  },
  {
    zip: "60026",
    ST: "IL",
    cityWithStateAbbr: "Glenview, IL",
  },
  {
    zip: "60029",
    ST: "IL",
    cityWithStateAbbr: "Golf, IL",
  },
  {
    zip: "60030",
    ST: "IL",
    cityWithStateAbbr: "Grayslake, IL",
  },
  {
    zip: "60031",
    ST: "IL",
    cityWithStateAbbr: "Gurnee, IL",
  },
  {
    zip: "60033",
    ST: "IL",
    cityWithStateAbbr: "Harvard, IL",
  },
  {
    zip: "60034",
    ST: "IL",
    cityWithStateAbbr: "Hebron, IL",
  },
  {
    zip: "60035",
    ST: "IL",
    cityWithStateAbbr: "Highland Park, IL",
  },
  {
    zip: "60037",
    ST: "IL",
    cityWithStateAbbr: "Fort Sheridan, IL",
  },
  {
    zip: "60038",
    ST: "IL",
    cityWithStateAbbr: "Palatine, IL",
  },
  {
    zip: "60039",
    ST: "IL",
    cityWithStateAbbr: "Crystal Lake, IL",
  },
  {
    zip: "60040",
    ST: "IL",
    cityWithStateAbbr: "Highwood, IL",
  },
  {
    zip: "60041",
    ST: "IL",
    cityWithStateAbbr: "Ingleside, IL",
  },
  {
    zip: "60042",
    ST: "IL",
    cityWithStateAbbr: "Island Lake, IL",
  },
  {
    zip: "60043",
    ST: "IL",
    cityWithStateAbbr: "Kenilworth, IL",
  },
  {
    zip: "60044",
    ST: "IL",
    cityWithStateAbbr: "Lake Bluff, IL",
  },
  {
    zip: "60045",
    ST: "IL",
    cityWithStateAbbr: "Lake Forest, IL",
  },
  {
    zip: "60046",
    ST: "IL",
    cityWithStateAbbr: "Lake Villa, IL",
  },
  {
    zip: "60047",
    ST: "IL",
    cityWithStateAbbr: "Lake Zurich, IL",
  },
  {
    zip: "60048",
    ST: "IL",
    cityWithStateAbbr: "Libertyville, IL",
  },
  {
    zip: "60050",
    ST: "IL",
    cityWithStateAbbr: "Mchenry, IL",
  },
  {
    zip: "60051",
    ST: "IL",
    cityWithStateAbbr: "Mchenry, IL",
  },
  {
    zip: "60053",
    ST: "IL",
    cityWithStateAbbr: "Morton Grove, IL",
  },
  {
    zip: "60055",
    ST: "IL",
    cityWithStateAbbr: "Palatine, IL",
  },
  {
    zip: "60056",
    ST: "IL",
    cityWithStateAbbr: "Mount Prospect, IL",
  },
  {
    zip: "60060",
    ST: "IL",
    cityWithStateAbbr: "Mundelein, IL",
  },
  {
    zip: "60061",
    ST: "IL",
    cityWithStateAbbr: "Vernon Hills, IL",
  },
  {
    zip: "60062",
    ST: "IL",
    cityWithStateAbbr: "Northbrook, IL",
  },
  {
    zip: "60064",
    ST: "IL",
    cityWithStateAbbr: "North Chicago, IL",
  },
  {
    zip: "60065",
    ST: "IL",
    cityWithStateAbbr: "Northbrook, IL",
  },
  {
    zip: "60067",
    ST: "IL",
    cityWithStateAbbr: "Palatine, IL",
  },
  {
    zip: "60068",
    ST: "IL",
    cityWithStateAbbr: "Park Ridge, IL",
  },
  {
    zip: "60069",
    ST: "IL",
    cityWithStateAbbr: "Lincolnshire, IL",
  },
  {
    zip: "60070",
    ST: "IL",
    cityWithStateAbbr: "Prospect Heights, IL",
  },
  {
    zip: "60071",
    ST: "IL",
    cityWithStateAbbr: "Richmond, IL",
  },
  {
    zip: "60072",
    ST: "IL",
    cityWithStateAbbr: "Ringwood, IL",
  },
  {
    zip: "60073",
    ST: "IL",
    cityWithStateAbbr: "Round Lake, IL",
  },
  {
    zip: "60074",
    ST: "IL",
    cityWithStateAbbr: "Palatine, IL",
  },
  {
    zip: "60075",
    ST: "IL",
    cityWithStateAbbr: "Russell, IL",
  },
  {
    zip: "60076",
    ST: "IL",
    cityWithStateAbbr: "Skokie, IL",
  },
  {
    zip: "60077",
    ST: "IL",
    cityWithStateAbbr: "Skokie, IL",
  },
  {
    zip: "60078",
    ST: "IL",
    cityWithStateAbbr: "Palatine, IL",
  },
  {
    zip: "60079",
    ST: "IL",
    cityWithStateAbbr: "Waukegan, IL",
  },
  {
    zip: "60081",
    ST: "IL",
    cityWithStateAbbr: "Spring Grove, IL",
  },
  {
    zip: "60082",
    ST: "IL",
    cityWithStateAbbr: "Techny, IL",
  },
  {
    zip: "60083",
    ST: "IL",
    cityWithStateAbbr: "Wadsworth, IL",
  },
  {
    zip: "60084",
    ST: "IL",
    cityWithStateAbbr: "Wauconda, IL",
  },
  {
    zip: "60085",
    ST: "IL",
    cityWithStateAbbr: "Waukegan, IL",
  },
  {
    zip: "60086",
    ST: "IL",
    cityWithStateAbbr: "North Chicago, IL",
  },
  {
    zip: "60087",
    ST: "IL",
    cityWithStateAbbr: "Waukegan, IL",
  },
  {
    zip: "60088",
    ST: "IL",
    cityWithStateAbbr: "Great Lakes, IL",
  },
  {
    zip: "60089",
    ST: "IL",
    cityWithStateAbbr: "Buffalo Grove, IL",
  },
  {
    zip: "60090",
    ST: "IL",
    cityWithStateAbbr: "Wheeling, IL",
  },
  {
    zip: "60091",
    ST: "IL",
    cityWithStateAbbr: "Wilmette, IL",
  },
  {
    zip: "60093",
    ST: "IL",
    cityWithStateAbbr: "Winnetka, IL",
  },
  {
    zip: "60094",
    ST: "IL",
    cityWithStateAbbr: "Palatine, IL",
  },
  {
    zip: "60095",
    ST: "IL",
    cityWithStateAbbr: "Palatine, IL",
  },
  {
    zip: "60096",
    ST: "IL",
    cityWithStateAbbr: "Winthrop Harbor, IL",
  },
  {
    zip: "60097",
    ST: "IL",
    cityWithStateAbbr: "Wonder Lake, IL",
  },
  {
    zip: "60098",
    ST: "IL",
    cityWithStateAbbr: "Woodstock, IL",
  },
  {
    zip: "60099",
    ST: "IL",
    cityWithStateAbbr: "Zion, IL",
  },
  {
    zip: "60101",
    ST: "IL",
    cityWithStateAbbr: "Addison, IL",
  },
  {
    zip: "60102",
    ST: "IL",
    cityWithStateAbbr: "Algonquin, IL",
  },
  {
    zip: "60103",
    ST: "IL",
    cityWithStateAbbr: "Bartlett, IL",
  },
  {
    zip: "60104",
    ST: "IL",
    cityWithStateAbbr: "Bellwood, IL",
  },
  {
    zip: "60105",
    ST: "IL",
    cityWithStateAbbr: "Bensenville, IL",
  },
  {
    zip: "60106",
    ST: "IL",
    cityWithStateAbbr: "Bensenville, IL",
  },
  {
    zip: "60107",
    ST: "IL",
    cityWithStateAbbr: "Streamwood, IL",
  },
  {
    zip: "60108",
    ST: "IL",
    cityWithStateAbbr: "Bloomingdale, IL",
  },
  {
    zip: "60109",
    ST: "IL",
    cityWithStateAbbr: "Burlington, IL",
  },
  {
    zip: "60110",
    ST: "IL",
    cityWithStateAbbr: "Carpentersville, IL",
  },
  {
    zip: "60111",
    ST: "IL",
    cityWithStateAbbr: "Clare, IL",
  },
  {
    zip: "60112",
    ST: "IL",
    cityWithStateAbbr: "Cortland, IL",
  },
  {
    zip: "60113",
    ST: "IL",
    cityWithStateAbbr: "Creston, IL",
  },
  {
    zip: "60115",
    ST: "IL",
    cityWithStateAbbr: "Dekalb, IL",
  },
  {
    zip: "60116",
    ST: "IL",
    cityWithStateAbbr: "Carol Stream, IL",
  },
  {
    zip: "60117",
    ST: "IL",
    cityWithStateAbbr: "Bloomingdale, IL",
  },
  {
    zip: "60118",
    ST: "IL",
    cityWithStateAbbr: "Dundee, IL",
  },
  {
    zip: "60119",
    ST: "IL",
    cityWithStateAbbr: "Elburn, IL",
  },
  {
    zip: "60120",
    ST: "IL",
    cityWithStateAbbr: "Elgin, IL",
  },
  {
    zip: "60121",
    ST: "IL",
    cityWithStateAbbr: "Elgin, IL",
  },
  {
    zip: "60122",
    ST: "IL",
    cityWithStateAbbr: "Carol Stream, IL",
  },
  {
    zip: "60123",
    ST: "IL",
    cityWithStateAbbr: "Elgin, IL",
  },
  {
    zip: "60124",
    ST: "IL",
    cityWithStateAbbr: "Elgin, IL",
  },
  {
    zip: "60126",
    ST: "IL",
    cityWithStateAbbr: "Elmhurst, IL",
  },
  {
    zip: "60128",
    ST: "IL",
    cityWithStateAbbr: "Carol Stream, IL",
  },
  {
    zip: "60129",
    ST: "IL",
    cityWithStateAbbr: "Esmond, IL",
  },
  {
    zip: "60130",
    ST: "IL",
    cityWithStateAbbr: "Forest Park, IL",
  },
  {
    zip: "60131",
    ST: "IL",
    cityWithStateAbbr: "Franklin Park, IL",
  },
  {
    zip: "60132",
    ST: "IL",
    cityWithStateAbbr: "Carol Stream, IL",
  },
  {
    zip: "60133",
    ST: "IL",
    cityWithStateAbbr: "Hanover Park, IL",
  },
  {
    zip: "60134",
    ST: "IL",
    cityWithStateAbbr: "Geneva, IL",
  },
  {
    zip: "60135",
    ST: "IL",
    cityWithStateAbbr: "Genoa, IL",
  },
  {
    zip: "60136",
    ST: "IL",
    cityWithStateAbbr: "Gilberts, IL",
  },
  {
    zip: "60137",
    ST: "IL",
    cityWithStateAbbr: "Glen Ellyn, IL",
  },
  {
    zip: "60138",
    ST: "IL",
    cityWithStateAbbr: "Glen Ellyn, IL",
  },
  {
    zip: "60139",
    ST: "IL",
    cityWithStateAbbr: "Glendale Heights, IL",
  },
  {
    zip: "60140",
    ST: "IL",
    cityWithStateAbbr: "Hampshire, IL",
  },
  {
    zip: "60141",
    ST: "IL",
    cityWithStateAbbr: "Hines, IL",
  },
  {
    zip: "60142",
    ST: "IL",
    cityWithStateAbbr: "Huntley, IL",
  },
  {
    zip: "60143",
    ST: "IL",
    cityWithStateAbbr: "Itasca, IL",
  },
  {
    zip: "60144",
    ST: "IL",
    cityWithStateAbbr: "Kaneville, IL",
  },
  {
    zip: "60145",
    ST: "IL",
    cityWithStateAbbr: "Kingston, IL",
  },
  {
    zip: "60146",
    ST: "IL",
    cityWithStateAbbr: "Kirkland, IL",
  },
  {
    zip: "60147",
    ST: "IL",
    cityWithStateAbbr: "Lafox, IL",
  },
  {
    zip: "60148",
    ST: "IL",
    cityWithStateAbbr: "Lombard, IL",
  },
  {
    zip: "60150",
    ST: "IL",
    cityWithStateAbbr: "Malta, IL",
  },
  {
    zip: "60151",
    ST: "IL",
    cityWithStateAbbr: "Maple Park, IL",
  },
  {
    zip: "60152",
    ST: "IL",
    cityWithStateAbbr: "Marengo, IL",
  },
  {
    zip: "60153",
    ST: "IL",
    cityWithStateAbbr: "Maywood, IL",
  },
  {
    zip: "60154",
    ST: "IL",
    cityWithStateAbbr: "Westchester, IL",
  },
  {
    zip: "60155",
    ST: "IL",
    cityWithStateAbbr: "Broadview, IL",
  },
  {
    zip: "60156",
    ST: "IL",
    cityWithStateAbbr: "Lake In The Hills, IL",
  },
  {
    zip: "60157",
    ST: "IL",
    cityWithStateAbbr: "Medinah, IL",
  },
  {
    zip: "60159",
    ST: "IL",
    cityWithStateAbbr: "Schaumburg, IL",
  },
  {
    zip: "60160",
    ST: "IL",
    cityWithStateAbbr: "Melrose Park, IL",
  },
  {
    zip: "60161",
    ST: "IL",
    cityWithStateAbbr: "Melrose Park, IL",
  },
  {
    zip: "60162",
    ST: "IL",
    cityWithStateAbbr: "Hillside, IL",
  },
  {
    zip: "60163",
    ST: "IL",
    cityWithStateAbbr: "Berkeley, IL",
  },
  {
    zip: "60164",
    ST: "IL",
    cityWithStateAbbr: "Melrose Park, IL",
  },
  {
    zip: "60165",
    ST: "IL",
    cityWithStateAbbr: "Stone Park, IL",
  },
  {
    zip: "60168",
    ST: "IL",
    cityWithStateAbbr: "Schaumburg, IL",
  },
  {
    zip: "60169",
    ST: "IL",
    cityWithStateAbbr: "Hoffman Estates, IL",
  },
  {
    zip: "60170",
    ST: "IL",
    cityWithStateAbbr: "Elgin, IL",
  },
  {
    zip: "60171",
    ST: "IL",
    cityWithStateAbbr: "River Grove, IL",
  },
  {
    zip: "60172",
    ST: "IL",
    cityWithStateAbbr: "Roselle, IL",
  },
  {
    zip: "60173",
    ST: "IL",
    cityWithStateAbbr: "Schaumburg, IL",
  },
  {
    zip: "60174",
    ST: "IL",
    cityWithStateAbbr: "Saint Charles, IL",
  },
  {
    zip: "60175",
    ST: "IL",
    cityWithStateAbbr: "Saint Charles, IL",
  },
  {
    zip: "60176",
    ST: "IL",
    cityWithStateAbbr: "Schiller Park, IL",
  },
  {
    zip: "60177",
    ST: "IL",
    cityWithStateAbbr: "South Elgin, IL",
  },
  {
    zip: "60178",
    ST: "IL",
    cityWithStateAbbr: "Sycamore, IL",
  },
  {
    zip: "60179",
    ST: "IL",
    cityWithStateAbbr: "Hoffman Estates, IL",
  },
  {
    zip: "60180",
    ST: "IL",
    cityWithStateAbbr: "Union, IL",
  },
  {
    zip: "60181",
    ST: "IL",
    cityWithStateAbbr: "Villa Park, IL",
  },
  {
    zip: "60183",
    ST: "IL",
    cityWithStateAbbr: "Wasco, IL",
  },
  {
    zip: "60184",
    ST: "IL",
    cityWithStateAbbr: "Wayne, IL",
  },
  {
    zip: "60185",
    ST: "IL",
    cityWithStateAbbr: "West Chicago, IL",
  },
  {
    zip: "60186",
    ST: "IL",
    cityWithStateAbbr: "West Chicago, IL",
  },
  {
    zip: "60187",
    ST: "IL",
    cityWithStateAbbr: "Wheaton, IL",
  },
  {
    zip: "60188",
    ST: "IL",
    cityWithStateAbbr: "Carol Stream, IL",
  },
  {
    zip: "60189",
    ST: "IL",
    cityWithStateAbbr: "Wheaton, IL",
  },
  {
    zip: "60190",
    ST: "IL",
    cityWithStateAbbr: "Winfield, IL",
  },
  {
    zip: "60191",
    ST: "IL",
    cityWithStateAbbr: "Wood Dale, IL",
  },
  {
    zip: "60192",
    ST: "IL",
    cityWithStateAbbr: "Hoffman Estates, IL",
  },
  {
    zip: "60193",
    ST: "IL",
    cityWithStateAbbr: "Schaumburg, IL",
  },
  {
    zip: "60194",
    ST: "IL",
    cityWithStateAbbr: "Schaumburg, IL",
  },
  {
    zip: "60195",
    ST: "IL",
    cityWithStateAbbr: "Schaumburg, IL",
  },
  {
    zip: "60196",
    ST: "IL",
    cityWithStateAbbr: "Schaumburg, IL",
  },
  {
    zip: "60197",
    ST: "IL",
    cityWithStateAbbr: "Carol Stream, IL",
  },
  {
    zip: "60199",
    ST: "IL",
    cityWithStateAbbr: "Carol Stream, IL",
  },
  {
    zip: "60201",
    ST: "IL",
    cityWithStateAbbr: "Evanston, IL",
  },
  {
    zip: "60202",
    ST: "IL",
    cityWithStateAbbr: "Evanston, IL",
  },
  {
    zip: "60203",
    ST: "IL",
    cityWithStateAbbr: "Evanston, IL",
  },
  {
    zip: "60204",
    ST: "IL",
    cityWithStateAbbr: "Evanston, IL",
  },
  {
    zip: "60208",
    ST: "IL",
    cityWithStateAbbr: "Evanston, IL",
  },
  {
    zip: "60209",
    ST: "IL",
    cityWithStateAbbr: "Evanston, IL",
  },
  {
    zip: "60290",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60301",
    ST: "IL",
    cityWithStateAbbr: "Oak Park, IL",
  },
  {
    zip: "60302",
    ST: "IL",
    cityWithStateAbbr: "Oak Park, IL",
  },
  {
    zip: "60303",
    ST: "IL",
    cityWithStateAbbr: "Oak Park, IL",
  },
  {
    zip: "60304",
    ST: "IL",
    cityWithStateAbbr: "Oak Park, IL",
  },
  {
    zip: "60305",
    ST: "IL",
    cityWithStateAbbr: "River Forest, IL",
  },
  {
    zip: "60399",
    ST: "IL",
    cityWithStateAbbr: "Wood Dale, IL",
  },
  {
    zip: "60401",
    ST: "IL",
    cityWithStateAbbr: "Beecher, IL",
  },
  {
    zip: "60402",
    ST: "IL",
    cityWithStateAbbr: "Berwyn, IL",
  },
  {
    zip: "60403",
    ST: "IL",
    cityWithStateAbbr: "Crest Hill, IL",
  },
  {
    zip: "60404",
    ST: "IL",
    cityWithStateAbbr: "Shorewood, IL",
  },
  {
    zip: "60406",
    ST: "IL",
    cityWithStateAbbr: "Blue Island, IL",
  },
  {
    zip: "60407",
    ST: "IL",
    cityWithStateAbbr: "Braceville, IL",
  },
  {
    zip: "60408",
    ST: "IL",
    cityWithStateAbbr: "Braidwood, IL",
  },
  {
    zip: "60409",
    ST: "IL",
    cityWithStateAbbr: "Calumet City, IL",
  },
  {
    zip: "60410",
    ST: "IL",
    cityWithStateAbbr: "Channahon, IL",
  },
  {
    zip: "60411",
    ST: "IL",
    cityWithStateAbbr: "Chicago Heights, IL",
  },
  {
    zip: "60412",
    ST: "IL",
    cityWithStateAbbr: "Chicago Heights, IL",
  },
  {
    zip: "60415",
    ST: "IL",
    cityWithStateAbbr: "Chicago Ridge, IL",
  },
  {
    zip: "60416",
    ST: "IL",
    cityWithStateAbbr: "Coal City, IL",
  },
  {
    zip: "60417",
    ST: "IL",
    cityWithStateAbbr: "Crete, IL",
  },
  {
    zip: "60419",
    ST: "IL",
    cityWithStateAbbr: "Dolton, IL",
  },
  {
    zip: "60420",
    ST: "IL",
    cityWithStateAbbr: "Dwight, IL",
  },
  {
    zip: "60421",
    ST: "IL",
    cityWithStateAbbr: "Elwood, IL",
  },
  {
    zip: "60422",
    ST: "IL",
    cityWithStateAbbr: "Flossmoor, IL",
  },
  {
    zip: "60423",
    ST: "IL",
    cityWithStateAbbr: "Frankfort, IL",
  },
  {
    zip: "60424",
    ST: "IL",
    cityWithStateAbbr: "Gardner, IL",
  },
  {
    zip: "60425",
    ST: "IL",
    cityWithStateAbbr: "Glenwood, IL",
  },
  {
    zip: "60426",
    ST: "IL",
    cityWithStateAbbr: "Harvey, IL",
  },
  {
    zip: "60428",
    ST: "IL",
    cityWithStateAbbr: "Markham, IL",
  },
  {
    zip: "60429",
    ST: "IL",
    cityWithStateAbbr: "Hazel Crest, IL",
  },
  {
    zip: "60430",
    ST: "IL",
    cityWithStateAbbr: "Homewood, IL",
  },
  {
    zip: "60431",
    ST: "IL",
    cityWithStateAbbr: "Joliet, IL",
  },
  {
    zip: "60432",
    ST: "IL",
    cityWithStateAbbr: "Joliet, IL",
  },
  {
    zip: "60433",
    ST: "IL",
    cityWithStateAbbr: "Joliet, IL",
  },
  {
    zip: "60434",
    ST: "IL",
    cityWithStateAbbr: "Joliet, IL",
  },
  {
    zip: "60435",
    ST: "IL",
    cityWithStateAbbr: "Joliet, IL",
  },
  {
    zip: "60436",
    ST: "IL",
    cityWithStateAbbr: "Joliet, IL",
  },
  {
    zip: "60437",
    ST: "IL",
    cityWithStateAbbr: "Kinsman, IL",
  },
  {
    zip: "60438",
    ST: "IL",
    cityWithStateAbbr: "Lansing, IL",
  },
  {
    zip: "60439",
    ST: "IL",
    cityWithStateAbbr: "Lemont, IL",
  },
  {
    zip: "60440",
    ST: "IL",
    cityWithStateAbbr: "Bolingbrook, IL",
  },
  {
    zip: "60441",
    ST: "IL",
    cityWithStateAbbr: "Lockport, IL",
  },
  {
    zip: "60442",
    ST: "IL",
    cityWithStateAbbr: "Manhattan, IL",
  },
  {
    zip: "60443",
    ST: "IL",
    cityWithStateAbbr: "Matteson, IL",
  },
  {
    zip: "60444",
    ST: "IL",
    cityWithStateAbbr: "Mazon, IL",
  },
  {
    zip: "60445",
    ST: "IL",
    cityWithStateAbbr: "Midlothian, IL",
  },
  {
    zip: "60446",
    ST: "IL",
    cityWithStateAbbr: "Romeoville, IL",
  },
  {
    zip: "60447",
    ST: "IL",
    cityWithStateAbbr: "Minooka, IL",
  },
  {
    zip: "60448",
    ST: "IL",
    cityWithStateAbbr: "Mokena, IL",
  },
  {
    zip: "60449",
    ST: "IL",
    cityWithStateAbbr: "Monee, IL",
  },
  {
    zip: "60450",
    ST: "IL",
    cityWithStateAbbr: "Morris, IL",
  },
  {
    zip: "60451",
    ST: "IL",
    cityWithStateAbbr: "New Lenox, IL",
  },
  {
    zip: "60452",
    ST: "IL",
    cityWithStateAbbr: "Oak Forest, IL",
  },
  {
    zip: "60453",
    ST: "IL",
    cityWithStateAbbr: "Oak Lawn, IL",
  },
  {
    zip: "60454",
    ST: "IL",
    cityWithStateAbbr: "Oak Lawn, IL",
  },
  {
    zip: "60455",
    ST: "IL",
    cityWithStateAbbr: "Bridgeview, IL",
  },
  {
    zip: "60456",
    ST: "IL",
    cityWithStateAbbr: "Hometown, IL",
  },
  {
    zip: "60457",
    ST: "IL",
    cityWithStateAbbr: "Hickory Hills, IL",
  },
  {
    zip: "60458",
    ST: "IL",
    cityWithStateAbbr: "Justice, IL",
  },
  {
    zip: "60459",
    ST: "IL",
    cityWithStateAbbr: "Burbank, IL",
  },
  {
    zip: "60460",
    ST: "IL",
    cityWithStateAbbr: "Odell, IL",
  },
  {
    zip: "60461",
    ST: "IL",
    cityWithStateAbbr: "Olympia Fields, IL",
  },
  {
    zip: "60462",
    ST: "IL",
    cityWithStateAbbr: "Orland Park, IL",
  },
  {
    zip: "60463",
    ST: "IL",
    cityWithStateAbbr: "Palos Heights, IL",
  },
  {
    zip: "60464",
    ST: "IL",
    cityWithStateAbbr: "Palos Park, IL",
  },
  {
    zip: "60465",
    ST: "IL",
    cityWithStateAbbr: "Palos Hills, IL",
  },
  {
    zip: "60466",
    ST: "IL",
    cityWithStateAbbr: "Park Forest, IL",
  },
  {
    zip: "60467",
    ST: "IL",
    cityWithStateAbbr: "Orland Park, IL",
  },
  {
    zip: "60468",
    ST: "IL",
    cityWithStateAbbr: "Peotone, IL",
  },
  {
    zip: "60469",
    ST: "IL",
    cityWithStateAbbr: "Posen, IL",
  },
  {
    zip: "60470",
    ST: "IL",
    cityWithStateAbbr: "Ransom, IL",
  },
  {
    zip: "60471",
    ST: "IL",
    cityWithStateAbbr: "Richton Park, IL",
  },
  {
    zip: "60472",
    ST: "IL",
    cityWithStateAbbr: "Robbins, IL",
  },
  {
    zip: "60473",
    ST: "IL",
    cityWithStateAbbr: "South Holland, IL",
  },
  {
    zip: "60474",
    ST: "IL",
    cityWithStateAbbr: "South Wilmington, IL",
  },
  {
    zip: "60475",
    ST: "IL",
    cityWithStateAbbr: "Steger, IL",
  },
  {
    zip: "60476",
    ST: "IL",
    cityWithStateAbbr: "Thornton, IL",
  },
  {
    zip: "60477",
    ST: "IL",
    cityWithStateAbbr: "Tinley Park, IL",
  },
  {
    zip: "60478",
    ST: "IL",
    cityWithStateAbbr: "Country Club Hills, IL",
  },
  {
    zip: "60479",
    ST: "IL",
    cityWithStateAbbr: "Verona, IL",
  },
  {
    zip: "60480",
    ST: "IL",
    cityWithStateAbbr: "Willow Springs, IL",
  },
  {
    zip: "60481",
    ST: "IL",
    cityWithStateAbbr: "Wilmington, IL",
  },
  {
    zip: "60482",
    ST: "IL",
    cityWithStateAbbr: "Worth, IL",
  },
  {
    zip: "60484",
    ST: "IL",
    cityWithStateAbbr: "University Park, IL",
  },
  {
    zip: "60487",
    ST: "IL",
    cityWithStateAbbr: "Tinley Park, IL",
  },
  {
    zip: "60490",
    ST: "IL",
    cityWithStateAbbr: "Bolingbrook, IL",
  },
  {
    zip: "60491",
    ST: "IL",
    cityWithStateAbbr: "Homer Glen, IL",
  },
  {
    zip: "60499",
    ST: "IL",
    cityWithStateAbbr: "Bedford Park, IL",
  },
  {
    zip: "60501",
    ST: "IL",
    cityWithStateAbbr: "Summit Argo, IL",
  },
  {
    zip: "60502",
    ST: "IL",
    cityWithStateAbbr: "Aurora, IL",
  },
  {
    zip: "60503",
    ST: "IL",
    cityWithStateAbbr: "Aurora, IL",
  },
  {
    zip: "60504",
    ST: "IL",
    cityWithStateAbbr: "Aurora, IL",
  },
  {
    zip: "60505",
    ST: "IL",
    cityWithStateAbbr: "Aurora, IL",
  },
  {
    zip: "60506",
    ST: "IL",
    cityWithStateAbbr: "Aurora, IL",
  },
  {
    zip: "60507",
    ST: "IL",
    cityWithStateAbbr: "Aurora, IL",
  },
  {
    zip: "60510",
    ST: "IL",
    cityWithStateAbbr: "Batavia, IL",
  },
  {
    zip: "60511",
    ST: "IL",
    cityWithStateAbbr: "Big Rock, IL",
  },
  {
    zip: "60512",
    ST: "IL",
    cityWithStateAbbr: "Bristol, IL",
  },
  {
    zip: "60513",
    ST: "IL",
    cityWithStateAbbr: "Brookfield, IL",
  },
  {
    zip: "60514",
    ST: "IL",
    cityWithStateAbbr: "Clarendon Hills, IL",
  },
  {
    zip: "60515",
    ST: "IL",
    cityWithStateAbbr: "Downers Grove, IL",
  },
  {
    zip: "60516",
    ST: "IL",
    cityWithStateAbbr: "Downers Grove, IL",
  },
  {
    zip: "60517",
    ST: "IL",
    cityWithStateAbbr: "Woodridge, IL",
  },
  {
    zip: "60518",
    ST: "IL",
    cityWithStateAbbr: "Earlville, IL",
  },
  {
    zip: "60519",
    ST: "IL",
    cityWithStateAbbr: "Eola, IL",
  },
  {
    zip: "60520",
    ST: "IL",
    cityWithStateAbbr: "Hinckley, IL",
  },
  {
    zip: "60521",
    ST: "IL",
    cityWithStateAbbr: "Hinsdale, IL",
  },
  {
    zip: "60522",
    ST: "IL",
    cityWithStateAbbr: "Hinsdale, IL",
  },
  {
    zip: "60523",
    ST: "IL",
    cityWithStateAbbr: "Oak Brook, IL",
  },
  {
    zip: "60525",
    ST: "IL",
    cityWithStateAbbr: "La Grange, IL",
  },
  {
    zip: "60526",
    ST: "IL",
    cityWithStateAbbr: "La Grange Park, IL",
  },
  {
    zip: "60527",
    ST: "IL",
    cityWithStateAbbr: "Willowbrook, IL",
  },
  {
    zip: "60530",
    ST: "IL",
    cityWithStateAbbr: "Lee, IL",
  },
  {
    zip: "60531",
    ST: "IL",
    cityWithStateAbbr: "Leland, IL",
  },
  {
    zip: "60532",
    ST: "IL",
    cityWithStateAbbr: "Lisle, IL",
  },
  {
    zip: "60534",
    ST: "IL",
    cityWithStateAbbr: "Lyons, IL",
  },
  {
    zip: "60536",
    ST: "IL",
    cityWithStateAbbr: "Millbrook, IL",
  },
  {
    zip: "60537",
    ST: "IL",
    cityWithStateAbbr: "Millington, IL",
  },
  {
    zip: "60538",
    ST: "IL",
    cityWithStateAbbr: "Montgomery, IL",
  },
  {
    zip: "60539",
    ST: "IL",
    cityWithStateAbbr: "Mooseheart, IL",
  },
  {
    zip: "60540",
    ST: "IL",
    cityWithStateAbbr: "Naperville, IL",
  },
  {
    zip: "60541",
    ST: "IL",
    cityWithStateAbbr: "Newark, IL",
  },
  {
    zip: "60542",
    ST: "IL",
    cityWithStateAbbr: "North Aurora, IL",
  },
  {
    zip: "60543",
    ST: "IL",
    cityWithStateAbbr: "Oswego, IL",
  },
  {
    zip: "60544",
    ST: "IL",
    cityWithStateAbbr: "Plainfield, IL",
  },
  {
    zip: "60545",
    ST: "IL",
    cityWithStateAbbr: "Plano, IL",
  },
  {
    zip: "60546",
    ST: "IL",
    cityWithStateAbbr: "Riverside, IL",
  },
  {
    zip: "60548",
    ST: "IL",
    cityWithStateAbbr: "Sandwich, IL",
  },
  {
    zip: "60549",
    ST: "IL",
    cityWithStateAbbr: "Serena, IL",
  },
  {
    zip: "60550",
    ST: "IL",
    cityWithStateAbbr: "Shabbona, IL",
  },
  {
    zip: "60551",
    ST: "IL",
    cityWithStateAbbr: "Sheridan, IL",
  },
  {
    zip: "60552",
    ST: "IL",
    cityWithStateAbbr: "Somonauk, IL",
  },
  {
    zip: "60553",
    ST: "IL",
    cityWithStateAbbr: "Steward, IL",
  },
  {
    zip: "60554",
    ST: "IL",
    cityWithStateAbbr: "Sugar Grove, IL",
  },
  {
    zip: "60555",
    ST: "IL",
    cityWithStateAbbr: "Warrenville, IL",
  },
  {
    zip: "60556",
    ST: "IL",
    cityWithStateAbbr: "Waterman, IL",
  },
  {
    zip: "60557",
    ST: "IL",
    cityWithStateAbbr: "Wedron, IL",
  },
  {
    zip: "60558",
    ST: "IL",
    cityWithStateAbbr: "Western Springs, IL",
  },
  {
    zip: "60559",
    ST: "IL",
    cityWithStateAbbr: "Westmont, IL",
  },
  {
    zip: "60560",
    ST: "IL",
    cityWithStateAbbr: "Yorkville, IL",
  },
  {
    zip: "60561",
    ST: "IL",
    cityWithStateAbbr: "Darien, IL",
  },
  {
    zip: "60563",
    ST: "IL",
    cityWithStateAbbr: "Naperville, IL",
  },
  {
    zip: "60564",
    ST: "IL",
    cityWithStateAbbr: "Naperville, IL",
  },
  {
    zip: "60565",
    ST: "IL",
    cityWithStateAbbr: "Naperville, IL",
  },
  {
    zip: "60566",
    ST: "IL",
    cityWithStateAbbr: "Naperville, IL",
  },
  {
    zip: "60567",
    ST: "IL",
    cityWithStateAbbr: "Naperville, IL",
  },
  {
    zip: "60568",
    ST: "IL",
    cityWithStateAbbr: "Aurora, IL",
  },
  {
    zip: "60572",
    ST: "IL",
    cityWithStateAbbr: "Aurora, IL",
  },
  {
    zip: "60585",
    ST: "IL",
    cityWithStateAbbr: "Plainfield, IL",
  },
  {
    zip: "60586",
    ST: "IL",
    cityWithStateAbbr: "Plainfield, IL",
  },
  {
    zip: "60598",
    ST: "IL",
    cityWithStateAbbr: "Aurora, IL",
  },
  {
    zip: "60599",
    ST: "IL",
    cityWithStateAbbr: "Fox Valley, IL",
  },
  {
    zip: "60601",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60602",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60603",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60604",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60605",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60606",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60607",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60608",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60609",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60610",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60611",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60612",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60613",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60614",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60615",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60616",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60617",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60618",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60619",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60620",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60621",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60622",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60623",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60624",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60625",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60626",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60628",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60629",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60630",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60631",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60632",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60633",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60634",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60636",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60637",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60638",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60639",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60640",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60641",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60642",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60643",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60644",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60645",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60646",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60647",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60649",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60651",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60652",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60653",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60654",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60655",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60656",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60657",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60659",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60660",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60661",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60664",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60666",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60668",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60669",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60670",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60673",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60674",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60675",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60677",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60678",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60680",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60681",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60682",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60684",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60685",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60686",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60687",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60688",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60689",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60690",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60691",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60693",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60694",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60695",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60696",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60697",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60699",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60701",
    ST: "IL",
    cityWithStateAbbr: "Chicago, IL",
  },
  {
    zip: "60706",
    ST: "IL",
    cityWithStateAbbr: "Harwood Heights, IL",
  },
  {
    zip: "60707",
    ST: "IL",
    cityWithStateAbbr: "Elmwood Park, IL",
  },
  {
    zip: "60712",
    ST: "IL",
    cityWithStateAbbr: "Lincolnwood, IL",
  },
  {
    zip: "60714",
    ST: "IL",
    cityWithStateAbbr: "Niles, IL",
  },
  {
    zip: "60803",
    ST: "IL",
    cityWithStateAbbr: "Alsip, IL",
  },
  {
    zip: "60804",
    ST: "IL",
    cityWithStateAbbr: "Cicero, IL",
  },
  {
    zip: "60805",
    ST: "IL",
    cityWithStateAbbr: "Evergreen Park, IL",
  },
  {
    zip: "60827",
    ST: "IL",
    cityWithStateAbbr: "Riverdale, IL",
  },
  {
    zip: "60901",
    ST: "IL",
    cityWithStateAbbr: "Kankakee, IL",
  },
  {
    zip: "60910",
    ST: "IL",
    cityWithStateAbbr: "Aroma Park, IL",
  },
  {
    zip: "60911",
    ST: "IL",
    cityWithStateAbbr: "Ashkum, IL",
  },
  {
    zip: "60912",
    ST: "IL",
    cityWithStateAbbr: "Beaverville, IL",
  },
  {
    zip: "60913",
    ST: "IL",
    cityWithStateAbbr: "Bonfield, IL",
  },
  {
    zip: "60914",
    ST: "IL",
    cityWithStateAbbr: "Bourbonnais, IL",
  },
  {
    zip: "60915",
    ST: "IL",
    cityWithStateAbbr: "Bradley, IL",
  },
  {
    zip: "60917",
    ST: "IL",
    cityWithStateAbbr: "Buckingham, IL",
  },
  {
    zip: "60918",
    ST: "IL",
    cityWithStateAbbr: "Buckley, IL",
  },
  {
    zip: "60919",
    ST: "IL",
    cityWithStateAbbr: "Cabery, IL",
  },
  {
    zip: "60920",
    ST: "IL",
    cityWithStateAbbr: "Campus, IL",
  },
  {
    zip: "60921",
    ST: "IL",
    cityWithStateAbbr: "Chatsworth, IL",
  },
  {
    zip: "60922",
    ST: "IL",
    cityWithStateAbbr: "Chebanse, IL",
  },
  {
    zip: "60924",
    ST: "IL",
    cityWithStateAbbr: "Cissna Park, IL",
  },
  {
    zip: "60926",
    ST: "IL",
    cityWithStateAbbr: "Claytonville, IL",
  },
  {
    zip: "60927",
    ST: "IL",
    cityWithStateAbbr: "Clifton, IL",
  },
  {
    zip: "60928",
    ST: "IL",
    cityWithStateAbbr: "Crescent City, IL",
  },
  {
    zip: "60929",
    ST: "IL",
    cityWithStateAbbr: "Cullom, IL",
  },
  {
    zip: "60930",
    ST: "IL",
    cityWithStateAbbr: "Danforth, IL",
  },
  {
    zip: "60931",
    ST: "IL",
    cityWithStateAbbr: "Donovan, IL",
  },
  {
    zip: "60932",
    ST: "IL",
    cityWithStateAbbr: "East Lynn, IL",
  },
  {
    zip: "60933",
    ST: "IL",
    cityWithStateAbbr: "Elliott, IL",
  },
  {
    zip: "60934",
    ST: "IL",
    cityWithStateAbbr: "Emington, IL",
  },
  {
    zip: "60935",
    ST: "IL",
    cityWithStateAbbr: "Essex, IL",
  },
  {
    zip: "60936",
    ST: "IL",
    cityWithStateAbbr: "Gibson City, IL",
  },
  {
    zip: "60938",
    ST: "IL",
    cityWithStateAbbr: "Gilman, IL",
  },
  {
    zip: "60939",
    ST: "IL",
    cityWithStateAbbr: "Goodwine, IL",
  },
  {
    zip: "60940",
    ST: "IL",
    cityWithStateAbbr: "Grant Park, IL",
  },
  {
    zip: "60941",
    ST: "IL",
    cityWithStateAbbr: "Herscher, IL",
  },
  {
    zip: "60942",
    ST: "IL",
    cityWithStateAbbr: "Hoopeston, IL",
  },
  {
    zip: "60944",
    ST: "IL",
    cityWithStateAbbr: "Hopkins Park, IL",
  },
  {
    zip: "60945",
    ST: "IL",
    cityWithStateAbbr: "Iroquois, IL",
  },
  {
    zip: "60946",
    ST: "IL",
    cityWithStateAbbr: "Kempton, IL",
  },
  {
    zip: "60948",
    ST: "IL",
    cityWithStateAbbr: "Loda, IL",
  },
  {
    zip: "60949",
    ST: "IL",
    cityWithStateAbbr: "Ludlow, IL",
  },
  {
    zip: "60950",
    ST: "IL",
    cityWithStateAbbr: "Manteno, IL",
  },
  {
    zip: "60951",
    ST: "IL",
    cityWithStateAbbr: "Martinton, IL",
  },
  {
    zip: "60952",
    ST: "IL",
    cityWithStateAbbr: "Melvin, IL",
  },
  {
    zip: "60953",
    ST: "IL",
    cityWithStateAbbr: "Milford, IL",
  },
  {
    zip: "60954",
    ST: "IL",
    cityWithStateAbbr: "Momence, IL",
  },
  {
    zip: "60955",
    ST: "IL",
    cityWithStateAbbr: "Onarga, IL",
  },
  {
    zip: "60956",
    ST: "IL",
    cityWithStateAbbr: "Papineau, IL",
  },
  {
    zip: "60957",
    ST: "IL",
    cityWithStateAbbr: "Paxton, IL",
  },
  {
    zip: "60958",
    ST: "IL",
    cityWithStateAbbr: "Pembroke Township, IL",
  },
  {
    zip: "60959",
    ST: "IL",
    cityWithStateAbbr: "Piper City, IL",
  },
  {
    zip: "60960",
    ST: "IL",
    cityWithStateAbbr: "Rankin, IL",
  },
  {
    zip: "60961",
    ST: "IL",
    cityWithStateAbbr: "Reddick, IL",
  },
  {
    zip: "60962",
    ST: "IL",
    cityWithStateAbbr: "Roberts, IL",
  },
  {
    zip: "60963",
    ST: "IL",
    cityWithStateAbbr: "Rossville, IL",
  },
  {
    zip: "60964",
    ST: "IL",
    cityWithStateAbbr: "Saint Anne, IL",
  },
  {
    zip: "60966",
    ST: "IL",
    cityWithStateAbbr: "Sheldon, IL",
  },
  {
    zip: "60967",
    ST: "IL",
    cityWithStateAbbr: "Stockland, IL",
  },
  {
    zip: "60968",
    ST: "IL",
    cityWithStateAbbr: "Thawville, IL",
  },
  {
    zip: "60969",
    ST: "IL",
    cityWithStateAbbr: "Union Hill, IL",
  },
  {
    zip: "60970",
    ST: "IL",
    cityWithStateAbbr: "Watseka, IL",
  },
  {
    zip: "60973",
    ST: "IL",
    cityWithStateAbbr: "Wellington, IL",
  },
  {
    zip: "60974",
    ST: "IL",
    cityWithStateAbbr: "Woodland, IL",
  },
  {
    zip: "61001",
    ST: "IL",
    cityWithStateAbbr: "Apple River, IL",
  },
  {
    zip: "61006",
    ST: "IL",
    cityWithStateAbbr: "Ashton, IL",
  },
  {
    zip: "61007",
    ST: "IL",
    cityWithStateAbbr: "Baileyville, IL",
  },
  {
    zip: "61008",
    ST: "IL",
    cityWithStateAbbr: "Belvidere, IL",
  },
  {
    zip: "61010",
    ST: "IL",
    cityWithStateAbbr: "Byron, IL",
  },
  {
    zip: "61011",
    ST: "IL",
    cityWithStateAbbr: "Caledonia, IL",
  },
  {
    zip: "61012",
    ST: "IL",
    cityWithStateAbbr: "Capron, IL",
  },
  {
    zip: "61013",
    ST: "IL",
    cityWithStateAbbr: "Cedarville, IL",
  },
  {
    zip: "61014",
    ST: "IL",
    cityWithStateAbbr: "Chadwick, IL",
  },
  {
    zip: "61015",
    ST: "IL",
    cityWithStateAbbr: "Chana, IL",
  },
  {
    zip: "61016",
    ST: "IL",
    cityWithStateAbbr: "Cherry Valley, IL",
  },
  {
    zip: "61018",
    ST: "IL",
    cityWithStateAbbr: "Dakota, IL",
  },
  {
    zip: "61019",
    ST: "IL",
    cityWithStateAbbr: "Davis, IL",
  },
  {
    zip: "61020",
    ST: "IL",
    cityWithStateAbbr: "Davis Junction, IL",
  },
  {
    zip: "61021",
    ST: "IL",
    cityWithStateAbbr: "Dixon, IL",
  },
  {
    zip: "61024",
    ST: "IL",
    cityWithStateAbbr: "Durand, IL",
  },
  {
    zip: "61025",
    ST: "IL",
    cityWithStateAbbr: "East Dubuque, IL",
  },
  {
    zip: "61027",
    ST: "IL",
    cityWithStateAbbr: "Eleroy, IL",
  },
  {
    zip: "61028",
    ST: "IL",
    cityWithStateAbbr: "Elizabeth, IL",
  },
  {
    zip: "61030",
    ST: "IL",
    cityWithStateAbbr: "Forreston, IL",
  },
  {
    zip: "61031",
    ST: "IL",
    cityWithStateAbbr: "Franklin Grove, IL",
  },
  {
    zip: "61032",
    ST: "IL",
    cityWithStateAbbr: "Freeport, IL",
  },
  {
    zip: "61036",
    ST: "IL",
    cityWithStateAbbr: "Galena, IL",
  },
  {
    zip: "61037",
    ST: "IL",
    cityWithStateAbbr: "Galt, IL",
  },
  {
    zip: "61038",
    ST: "IL",
    cityWithStateAbbr: "Garden Prairie, IL",
  },
  {
    zip: "61039",
    ST: "IL",
    cityWithStateAbbr: "German Valley, IL",
  },
  {
    zip: "61041",
    ST: "IL",
    cityWithStateAbbr: "Hanover, IL",
  },
  {
    zip: "61042",
    ST: "IL",
    cityWithStateAbbr: "Harmon, IL",
  },
  {
    zip: "61043",
    ST: "IL",
    cityWithStateAbbr: "Holcomb, IL",
  },
  {
    zip: "61044",
    ST: "IL",
    cityWithStateAbbr: "Kent, IL",
  },
  {
    zip: "61046",
    ST: "IL",
    cityWithStateAbbr: "Lanark, IL",
  },
  {
    zip: "61047",
    ST: "IL",
    cityWithStateAbbr: "Leaf River, IL",
  },
  {
    zip: "61048",
    ST: "IL",
    cityWithStateAbbr: "Lena, IL",
  },
  {
    zip: "61049",
    ST: "IL",
    cityWithStateAbbr: "Lindenwood, IL",
  },
  {
    zip: "61050",
    ST: "IL",
    cityWithStateAbbr: "Mc Connell, IL",
  },
  {
    zip: "61051",
    ST: "IL",
    cityWithStateAbbr: "Milledgeville, IL",
  },
  {
    zip: "61052",
    ST: "IL",
    cityWithStateAbbr: "Monroe Center, IL",
  },
  {
    zip: "61053",
    ST: "IL",
    cityWithStateAbbr: "Mount Carroll, IL",
  },
  {
    zip: "61054",
    ST: "IL",
    cityWithStateAbbr: "Mount Morris, IL",
  },
  {
    zip: "61057",
    ST: "IL",
    cityWithStateAbbr: "Nachusa, IL",
  },
  {
    zip: "61059",
    ST: "IL",
    cityWithStateAbbr: "Nora, IL",
  },
  {
    zip: "61060",
    ST: "IL",
    cityWithStateAbbr: "Orangeville, IL",
  },
  {
    zip: "61061",
    ST: "IL",
    cityWithStateAbbr: "Oregon, IL",
  },
  {
    zip: "61062",
    ST: "IL",
    cityWithStateAbbr: "Pearl City, IL",
  },
  {
    zip: "61063",
    ST: "IL",
    cityWithStateAbbr: "Pecatonica, IL",
  },
  {
    zip: "61064",
    ST: "IL",
    cityWithStateAbbr: "Polo, IL",
  },
  {
    zip: "61065",
    ST: "IL",
    cityWithStateAbbr: "Poplar Grove, IL",
  },
  {
    zip: "61067",
    ST: "IL",
    cityWithStateAbbr: "Ridott, IL",
  },
  {
    zip: "61068",
    ST: "IL",
    cityWithStateAbbr: "Rochelle, IL",
  },
  {
    zip: "61070",
    ST: "IL",
    cityWithStateAbbr: "Rock City, IL",
  },
  {
    zip: "61071",
    ST: "IL",
    cityWithStateAbbr: "Rock Falls, IL",
  },
  {
    zip: "61072",
    ST: "IL",
    cityWithStateAbbr: "Rockton, IL",
  },
  {
    zip: "61073",
    ST: "IL",
    cityWithStateAbbr: "Roscoe, IL",
  },
  {
    zip: "61074",
    ST: "IL",
    cityWithStateAbbr: "Savanna, IL",
  },
  {
    zip: "61075",
    ST: "IL",
    cityWithStateAbbr: "Scales Mound, IL",
  },
  {
    zip: "61077",
    ST: "IL",
    cityWithStateAbbr: "Seward, IL",
  },
  {
    zip: "61078",
    ST: "IL",
    cityWithStateAbbr: "Shannon, IL",
  },
  {
    zip: "61079",
    ST: "IL",
    cityWithStateAbbr: "Shirland, IL",
  },
  {
    zip: "61080",
    ST: "IL",
    cityWithStateAbbr: "South Beloit, IL",
  },
  {
    zip: "61081",
    ST: "IL",
    cityWithStateAbbr: "Sterling, IL",
  },
  {
    zip: "61084",
    ST: "IL",
    cityWithStateAbbr: "Stillman Valley, IL",
  },
  {
    zip: "61085",
    ST: "IL",
    cityWithStateAbbr: "Stockton, IL",
  },
  {
    zip: "61087",
    ST: "IL",
    cityWithStateAbbr: "Warren, IL",
  },
  {
    zip: "61088",
    ST: "IL",
    cityWithStateAbbr: "Winnebago, IL",
  },
  {
    zip: "61089",
    ST: "IL",
    cityWithStateAbbr: "Winslow, IL",
  },
  {
    zip: "61091",
    ST: "IL",
    cityWithStateAbbr: "Woosung, IL",
  },
  {
    zip: "61101",
    ST: "IL",
    cityWithStateAbbr: "Rockford, IL",
  },
  {
    zip: "61102",
    ST: "IL",
    cityWithStateAbbr: "Rockford, IL",
  },
  {
    zip: "61103",
    ST: "IL",
    cityWithStateAbbr: "Rockford, IL",
  },
  {
    zip: "61104",
    ST: "IL",
    cityWithStateAbbr: "Rockford, IL",
  },
  {
    zip: "61105",
    ST: "IL",
    cityWithStateAbbr: "Rockford, IL",
  },
  {
    zip: "61106",
    ST: "IL",
    cityWithStateAbbr: "Rockford, IL",
  },
  {
    zip: "61107",
    ST: "IL",
    cityWithStateAbbr: "Rockford, IL",
  },
  {
    zip: "61108",
    ST: "IL",
    cityWithStateAbbr: "Rockford, IL",
  },
  {
    zip: "61109",
    ST: "IL",
    cityWithStateAbbr: "Rockford, IL",
  },
  {
    zip: "61110",
    ST: "IL",
    cityWithStateAbbr: "Rockford, IL",
  },
  {
    zip: "61111",
    ST: "IL",
    cityWithStateAbbr: "Loves Park, IL",
  },
  {
    zip: "61112",
    ST: "IL",
    cityWithStateAbbr: "Rockford, IL",
  },
  {
    zip: "61114",
    ST: "IL",
    cityWithStateAbbr: "Rockford, IL",
  },
  {
    zip: "61115",
    ST: "IL",
    cityWithStateAbbr: "Machesney Park, IL",
  },
  {
    zip: "61125",
    ST: "IL",
    cityWithStateAbbr: "Rockford, IL",
  },
  {
    zip: "61126",
    ST: "IL",
    cityWithStateAbbr: "Rockford, IL",
  },
  {
    zip: "61130",
    ST: "IL",
    cityWithStateAbbr: "Loves Park, IL",
  },
  {
    zip: "61131",
    ST: "IL",
    cityWithStateAbbr: "Loves Park, IL",
  },
  {
    zip: "61132",
    ST: "IL",
    cityWithStateAbbr: "Loves Park, IL",
  },
  {
    zip: "61201",
    ST: "IL",
    cityWithStateAbbr: "Rock Island, IL",
  },
  {
    zip: "61204",
    ST: "IL",
    cityWithStateAbbr: "Rock Island, IL",
  },
  {
    zip: "61230",
    ST: "IL",
    cityWithStateAbbr: "Albany, IL",
  },
  {
    zip: "61231",
    ST: "IL",
    cityWithStateAbbr: "Aledo, IL",
  },
  {
    zip: "61232",
    ST: "IL",
    cityWithStateAbbr: "Andalusia, IL",
  },
  {
    zip: "61233",
    ST: "IL",
    cityWithStateAbbr: "Andover, IL",
  },
  {
    zip: "61234",
    ST: "IL",
    cityWithStateAbbr: "Annawan, IL",
  },
  {
    zip: "61235",
    ST: "IL",
    cityWithStateAbbr: "Atkinson, IL",
  },
  {
    zip: "61236",
    ST: "IL",
    cityWithStateAbbr: "Barstow, IL",
  },
  {
    zip: "61237",
    ST: "IL",
    cityWithStateAbbr: "Buffalo Prairie, IL",
  },
  {
    zip: "61238",
    ST: "IL",
    cityWithStateAbbr: "Cambridge, IL",
  },
  {
    zip: "61239",
    ST: "IL",
    cityWithStateAbbr: "Carbon Cliff, IL",
  },
  {
    zip: "61240",
    ST: "IL",
    cityWithStateAbbr: "Coal Valley, IL",
  },
  {
    zip: "61241",
    ST: "IL",
    cityWithStateAbbr: "Colona, IL",
  },
  {
    zip: "61242",
    ST: "IL",
    cityWithStateAbbr: "Cordova, IL",
  },
  {
    zip: "61243",
    ST: "IL",
    cityWithStateAbbr: "Deer Grove, IL",
  },
  {
    zip: "61244",
    ST: "IL",
    cityWithStateAbbr: "East Moline, IL",
  },
  {
    zip: "61250",
    ST: "IL",
    cityWithStateAbbr: "Erie, IL",
  },
  {
    zip: "61251",
    ST: "IL",
    cityWithStateAbbr: "Fenton, IL",
  },
  {
    zip: "61252",
    ST: "IL",
    cityWithStateAbbr: "Fulton, IL",
  },
  {
    zip: "61254",
    ST: "IL",
    cityWithStateAbbr: "Geneseo, IL",
  },
  {
    zip: "61256",
    ST: "IL",
    cityWithStateAbbr: "Hampton, IL",
  },
  {
    zip: "61257",
    ST: "IL",
    cityWithStateAbbr: "Hillsdale, IL",
  },
  {
    zip: "61258",
    ST: "IL",
    cityWithStateAbbr: "Hooppole, IL",
  },
  {
    zip: "61259",
    ST: "IL",
    cityWithStateAbbr: "Illinois City, IL",
  },
  {
    zip: "61260",
    ST: "IL",
    cityWithStateAbbr: "Joy, IL",
  },
  {
    zip: "61261",
    ST: "IL",
    cityWithStateAbbr: "Lyndon, IL",
  },
  {
    zip: "61262",
    ST: "IL",
    cityWithStateAbbr: "Lynn Center, IL",
  },
  {
    zip: "61263",
    ST: "IL",
    cityWithStateAbbr: "Matherville, IL",
  },
  {
    zip: "61264",
    ST: "IL",
    cityWithStateAbbr: "Milan, IL",
  },
  {
    zip: "61265",
    ST: "IL",
    cityWithStateAbbr: "Moline, IL",
  },
  {
    zip: "61266",
    ST: "IL",
    cityWithStateAbbr: "Moline, IL",
  },
  {
    zip: "61270",
    ST: "IL",
    cityWithStateAbbr: "Morrison, IL",
  },
  {
    zip: "61272",
    ST: "IL",
    cityWithStateAbbr: "New Boston, IL",
  },
  {
    zip: "61273",
    ST: "IL",
    cityWithStateAbbr: "Orion, IL",
  },
  {
    zip: "61274",
    ST: "IL",
    cityWithStateAbbr: "Osco, IL",
  },
  {
    zip: "61275",
    ST: "IL",
    cityWithStateAbbr: "Port Byron, IL",
  },
  {
    zip: "61276",
    ST: "IL",
    cityWithStateAbbr: "Preemption, IL",
  },
  {
    zip: "61277",
    ST: "IL",
    cityWithStateAbbr: "Prophetstown, IL",
  },
  {
    zip: "61278",
    ST: "IL",
    cityWithStateAbbr: "Rapids City, IL",
  },
  {
    zip: "61279",
    ST: "IL",
    cityWithStateAbbr: "Reynolds, IL",
  },
  {
    zip: "61281",
    ST: "IL",
    cityWithStateAbbr: "Sherrard, IL",
  },
  {
    zip: "61282",
    ST: "IL",
    cityWithStateAbbr: "Silvis, IL",
  },
  {
    zip: "61283",
    ST: "IL",
    cityWithStateAbbr: "Tampico, IL",
  },
  {
    zip: "61284",
    ST: "IL",
    cityWithStateAbbr: "Taylor Ridge, IL",
  },
  {
    zip: "61285",
    ST: "IL",
    cityWithStateAbbr: "Thomson, IL",
  },
  {
    zip: "61299",
    ST: "IL",
    cityWithStateAbbr: "Rock Island, IL",
  },
  {
    zip: "61301",
    ST: "IL",
    cityWithStateAbbr: "La Salle, IL",
  },
  {
    zip: "61310",
    ST: "IL",
    cityWithStateAbbr: "Amboy, IL",
  },
  {
    zip: "61311",
    ST: "IL",
    cityWithStateAbbr: "Streator, IL",
  },
  {
    zip: "61312",
    ST: "IL",
    cityWithStateAbbr: "Arlington, IL",
  },
  {
    zip: "61313",
    ST: "IL",
    cityWithStateAbbr: "Blackstone, IL",
  },
  {
    zip: "61314",
    ST: "IL",
    cityWithStateAbbr: "Buda, IL",
  },
  {
    zip: "61315",
    ST: "IL",
    cityWithStateAbbr: "Bureau, IL",
  },
  {
    zip: "61316",
    ST: "IL",
    cityWithStateAbbr: "Cedar Point, IL",
  },
  {
    zip: "61317",
    ST: "IL",
    cityWithStateAbbr: "Cherry, IL",
  },
  {
    zip: "61318",
    ST: "IL",
    cityWithStateAbbr: "Compton, IL",
  },
  {
    zip: "61319",
    ST: "IL",
    cityWithStateAbbr: "Cornell, IL",
  },
  {
    zip: "61320",
    ST: "IL",
    cityWithStateAbbr: "Dalzell, IL",
  },
  {
    zip: "61321",
    ST: "IL",
    cityWithStateAbbr: "Dana, IL",
  },
  {
    zip: "61322",
    ST: "IL",
    cityWithStateAbbr: "Depue, IL",
  },
  {
    zip: "61323",
    ST: "IL",
    cityWithStateAbbr: "Dover, IL",
  },
  {
    zip: "61324",
    ST: "IL",
    cityWithStateAbbr: "Eldena, IL",
  },
  {
    zip: "61325",
    ST: "IL",
    cityWithStateAbbr: "Grand Ridge, IL",
  },
  {
    zip: "61326",
    ST: "IL",
    cityWithStateAbbr: "Granville, IL",
  },
  {
    zip: "61327",
    ST: "IL",
    cityWithStateAbbr: "Hennepin, IL",
  },
  {
    zip: "61328",
    ST: "IL",
    cityWithStateAbbr: "Kasbeer, IL",
  },
  {
    zip: "61329",
    ST: "IL",
    cityWithStateAbbr: "Ladd, IL",
  },
  {
    zip: "61330",
    ST: "IL",
    cityWithStateAbbr: "La Moille, IL",
  },
  {
    zip: "61331",
    ST: "IL",
    cityWithStateAbbr: "Lee Center, IL",
  },
  {
    zip: "61332",
    ST: "IL",
    cityWithStateAbbr: "Leonore, IL",
  },
  {
    zip: "61333",
    ST: "IL",
    cityWithStateAbbr: "Long Point, IL",
  },
  {
    zip: "61334",
    ST: "IL",
    cityWithStateAbbr: "Lostant, IL",
  },
  {
    zip: "61335",
    ST: "IL",
    cityWithStateAbbr: "Mc Nabb, IL",
  },
  {
    zip: "61336",
    ST: "IL",
    cityWithStateAbbr: "Magnolia, IL",
  },
  {
    zip: "61337",
    ST: "IL",
    cityWithStateAbbr: "Malden, IL",
  },
  {
    zip: "61338",
    ST: "IL",
    cityWithStateAbbr: "Manlius, IL",
  },
  {
    zip: "61340",
    ST: "IL",
    cityWithStateAbbr: "Mark, IL",
  },
  {
    zip: "61341",
    ST: "IL",
    cityWithStateAbbr: "Marseilles, IL",
  },
  {
    zip: "61342",
    ST: "IL",
    cityWithStateAbbr: "Mendota, IL",
  },
  {
    zip: "61344",
    ST: "IL",
    cityWithStateAbbr: "Mineral, IL",
  },
  {
    zip: "61345",
    ST: "IL",
    cityWithStateAbbr: "Neponset, IL",
  },
  {
    zip: "61346",
    ST: "IL",
    cityWithStateAbbr: "New Bedford, IL",
  },
  {
    zip: "61348",
    ST: "IL",
    cityWithStateAbbr: "Oglesby, IL",
  },
  {
    zip: "61349",
    ST: "IL",
    cityWithStateAbbr: "Ohio, IL",
  },
  {
    zip: "61350",
    ST: "IL",
    cityWithStateAbbr: "Ottawa, IL",
  },
  {
    zip: "61353",
    ST: "IL",
    cityWithStateAbbr: "Paw Paw, IL",
  },
  {
    zip: "61354",
    ST: "IL",
    cityWithStateAbbr: "Peru, IL",
  },
  {
    zip: "61356",
    ST: "IL",
    cityWithStateAbbr: "Princeton, IL",
  },
  {
    zip: "61358",
    ST: "IL",
    cityWithStateAbbr: "Rutland, IL",
  },
  {
    zip: "61359",
    ST: "IL",
    cityWithStateAbbr: "Seatonville, IL",
  },
  {
    zip: "61360",
    ST: "IL",
    cityWithStateAbbr: "Seneca, IL",
  },
  {
    zip: "61361",
    ST: "IL",
    cityWithStateAbbr: "Sheffield, IL",
  },
  {
    zip: "61362",
    ST: "IL",
    cityWithStateAbbr: "Spring Valley, IL",
  },
  {
    zip: "61363",
    ST: "IL",
    cityWithStateAbbr: "Standard, IL",
  },
  {
    zip: "61364",
    ST: "IL",
    cityWithStateAbbr: "Streator, IL",
  },
  {
    zip: "61367",
    ST: "IL",
    cityWithStateAbbr: "Sublette, IL",
  },
  {
    zip: "61368",
    ST: "IL",
    cityWithStateAbbr: "Tiskilwa, IL",
  },
  {
    zip: "61369",
    ST: "IL",
    cityWithStateAbbr: "Toluca, IL",
  },
  {
    zip: "61370",
    ST: "IL",
    cityWithStateAbbr: "Tonica, IL",
  },
  {
    zip: "61371",
    ST: "IL",
    cityWithStateAbbr: "Triumph, IL",
  },
  {
    zip: "61372",
    ST: "IL",
    cityWithStateAbbr: "Troy Grove, IL",
  },
  {
    zip: "61373",
    ST: "IL",
    cityWithStateAbbr: "Utica, IL",
  },
  {
    zip: "61374",
    ST: "IL",
    cityWithStateAbbr: "Van Orin, IL",
  },
  {
    zip: "61375",
    ST: "IL",
    cityWithStateAbbr: "Varna, IL",
  },
  {
    zip: "61376",
    ST: "IL",
    cityWithStateAbbr: "Walnut, IL",
  },
  {
    zip: "61377",
    ST: "IL",
    cityWithStateAbbr: "Wenona, IL",
  },
  {
    zip: "61378",
    ST: "IL",
    cityWithStateAbbr: "West Brooklyn, IL",
  },
  {
    zip: "61379",
    ST: "IL",
    cityWithStateAbbr: "Wyanet, IL",
  },
  {
    zip: "61401",
    ST: "IL",
    cityWithStateAbbr: "Galesburg, IL",
  },
  {
    zip: "61402",
    ST: "IL",
    cityWithStateAbbr: "Galesburg, IL",
  },
  {
    zip: "61410",
    ST: "IL",
    cityWithStateAbbr: "Abingdon, IL",
  },
  {
    zip: "61411",
    ST: "IL",
    cityWithStateAbbr: "Adair, IL",
  },
  {
    zip: "61412",
    ST: "IL",
    cityWithStateAbbr: "Alexis, IL",
  },
  {
    zip: "61413",
    ST: "IL",
    cityWithStateAbbr: "Alpha, IL",
  },
  {
    zip: "61414",
    ST: "IL",
    cityWithStateAbbr: "Altona, IL",
  },
  {
    zip: "61415",
    ST: "IL",
    cityWithStateAbbr: "Avon, IL",
  },
  {
    zip: "61416",
    ST: "IL",
    cityWithStateAbbr: "Bardolph, IL",
  },
  {
    zip: "61417",
    ST: "IL",
    cityWithStateAbbr: "Berwick, IL",
  },
  {
    zip: "61418",
    ST: "IL",
    cityWithStateAbbr: "Biggsville, IL",
  },
  {
    zip: "61419",
    ST: "IL",
    cityWithStateAbbr: "Bishop Hill, IL",
  },
  {
    zip: "61420",
    ST: "IL",
    cityWithStateAbbr: "Blandinsville, IL",
  },
  {
    zip: "61421",
    ST: "IL",
    cityWithStateAbbr: "Bradford, IL",
  },
  {
    zip: "61422",
    ST: "IL",
    cityWithStateAbbr: "Bushnell, IL",
  },
  {
    zip: "61423",
    ST: "IL",
    cityWithStateAbbr: "Cameron, IL",
  },
  {
    zip: "61424",
    ST: "IL",
    cityWithStateAbbr: "Camp Grove, IL",
  },
  {
    zip: "61425",
    ST: "IL",
    cityWithStateAbbr: "Carman, IL",
  },
  {
    zip: "61426",
    ST: "IL",
    cityWithStateAbbr: "Castleton, IL",
  },
  {
    zip: "61427",
    ST: "IL",
    cityWithStateAbbr: "Cuba, IL",
  },
  {
    zip: "61428",
    ST: "IL",
    cityWithStateAbbr: "Dahinda, IL",
  },
  {
    zip: "61430",
    ST: "IL",
    cityWithStateAbbr: "East Galesburg, IL",
  },
  {
    zip: "61431",
    ST: "IL",
    cityWithStateAbbr: "Ellisville, IL",
  },
  {
    zip: "61432",
    ST: "IL",
    cityWithStateAbbr: "Fairview, IL",
  },
  {
    zip: "61433",
    ST: "IL",
    cityWithStateAbbr: "Fiatt, IL",
  },
  {
    zip: "61434",
    ST: "IL",
    cityWithStateAbbr: "Galva, IL",
  },
  {
    zip: "61435",
    ST: "IL",
    cityWithStateAbbr: "Gerlaw, IL",
  },
  {
    zip: "61436",
    ST: "IL",
    cityWithStateAbbr: "Gilson, IL",
  },
  {
    zip: "61437",
    ST: "IL",
    cityWithStateAbbr: "Gladstone, IL",
  },
  {
    zip: "61438",
    ST: "IL",
    cityWithStateAbbr: "Good Hope, IL",
  },
  {
    zip: "61439",
    ST: "IL",
    cityWithStateAbbr: "Henderson, IL",
  },
  {
    zip: "61440",
    ST: "IL",
    cityWithStateAbbr: "Industry, IL",
  },
  {
    zip: "61441",
    ST: "IL",
    cityWithStateAbbr: "Ipava, IL",
  },
  {
    zip: "61442",
    ST: "IL",
    cityWithStateAbbr: "Keithsburg, IL",
  },
  {
    zip: "61443",
    ST: "IL",
    cityWithStateAbbr: "Kewanee, IL",
  },
  {
    zip: "61447",
    ST: "IL",
    cityWithStateAbbr: "Kirkwood, IL",
  },
  {
    zip: "61448",
    ST: "IL",
    cityWithStateAbbr: "Knoxville, IL",
  },
  {
    zip: "61449",
    ST: "IL",
    cityWithStateAbbr: "La Fayette, IL",
  },
  {
    zip: "61450",
    ST: "IL",
    cityWithStateAbbr: "La Harpe, IL",
  },
  {
    zip: "61451",
    ST: "IL",
    cityWithStateAbbr: "Laura, IL",
  },
  {
    zip: "61452",
    ST: "IL",
    cityWithStateAbbr: "Littleton, IL",
  },
  {
    zip: "61453",
    ST: "IL",
    cityWithStateAbbr: "Little York, IL",
  },
  {
    zip: "61454",
    ST: "IL",
    cityWithStateAbbr: "Lomax, IL",
  },
  {
    zip: "61455",
    ST: "IL",
    cityWithStateAbbr: "Macomb, IL",
  },
  {
    zip: "61458",
    ST: "IL",
    cityWithStateAbbr: "Maquon, IL",
  },
  {
    zip: "61459",
    ST: "IL",
    cityWithStateAbbr: "Marietta, IL",
  },
  {
    zip: "61460",
    ST: "IL",
    cityWithStateAbbr: "Media, IL",
  },
  {
    zip: "61462",
    ST: "IL",
    cityWithStateAbbr: "Monmouth, IL",
  },
  {
    zip: "61465",
    ST: "IL",
    cityWithStateAbbr: "New Windsor, IL",
  },
  {
    zip: "61466",
    ST: "IL",
    cityWithStateAbbr: "North Henderson, IL",
  },
  {
    zip: "61467",
    ST: "IL",
    cityWithStateAbbr: "Oneida, IL",
  },
  {
    zip: "61468",
    ST: "IL",
    cityWithStateAbbr: "Ophiem, IL",
  },
  {
    zip: "61469",
    ST: "IL",
    cityWithStateAbbr: "Oquawka, IL",
  },
  {
    zip: "61470",
    ST: "IL",
    cityWithStateAbbr: "Prairie City, IL",
  },
  {
    zip: "61471",
    ST: "IL",
    cityWithStateAbbr: "Raritan, IL",
  },
  {
    zip: "61472",
    ST: "IL",
    cityWithStateAbbr: "Rio, IL",
  },
  {
    zip: "61473",
    ST: "IL",
    cityWithStateAbbr: "Roseville, IL",
  },
  {
    zip: "61474",
    ST: "IL",
    cityWithStateAbbr: "Saint Augustine, IL",
  },
  {
    zip: "61475",
    ST: "IL",
    cityWithStateAbbr: "Sciota, IL",
  },
  {
    zip: "61476",
    ST: "IL",
    cityWithStateAbbr: "Seaton, IL",
  },
  {
    zip: "61477",
    ST: "IL",
    cityWithStateAbbr: "Smithfield, IL",
  },
  {
    zip: "61478",
    ST: "IL",
    cityWithStateAbbr: "Smithshire, IL",
  },
  {
    zip: "61479",
    ST: "IL",
    cityWithStateAbbr: "Speer, IL",
  },
  {
    zip: "61480",
    ST: "IL",
    cityWithStateAbbr: "Stronghurst, IL",
  },
  {
    zip: "61482",
    ST: "IL",
    cityWithStateAbbr: "Table Grove, IL",
  },
  {
    zip: "61483",
    ST: "IL",
    cityWithStateAbbr: "Toulon, IL",
  },
  {
    zip: "61484",
    ST: "IL",
    cityWithStateAbbr: "Vermont, IL",
  },
  {
    zip: "61485",
    ST: "IL",
    cityWithStateAbbr: "Victoria, IL",
  },
  {
    zip: "61486",
    ST: "IL",
    cityWithStateAbbr: "Viola, IL",
  },
  {
    zip: "61488",
    ST: "IL",
    cityWithStateAbbr: "Wataga, IL",
  },
  {
    zip: "61489",
    ST: "IL",
    cityWithStateAbbr: "Williamsfield, IL",
  },
  {
    zip: "61490",
    ST: "IL",
    cityWithStateAbbr: "Woodhull, IL",
  },
  {
    zip: "61491",
    ST: "IL",
    cityWithStateAbbr: "Wyoming, IL",
  },
  {
    zip: "61501",
    ST: "IL",
    cityWithStateAbbr: "Astoria, IL",
  },
  {
    zip: "61516",
    ST: "IL",
    cityWithStateAbbr: "Benson, IL",
  },
  {
    zip: "61517",
    ST: "IL",
    cityWithStateAbbr: "Brimfield, IL",
  },
  {
    zip: "61519",
    ST: "IL",
    cityWithStateAbbr: "Bryant, IL",
  },
  {
    zip: "61520",
    ST: "IL",
    cityWithStateAbbr: "Canton, IL",
  },
  {
    zip: "61523",
    ST: "IL",
    cityWithStateAbbr: "Chillicothe, IL",
  },
  {
    zip: "61524",
    ST: "IL",
    cityWithStateAbbr: "Dunfermline, IL",
  },
  {
    zip: "61525",
    ST: "IL",
    cityWithStateAbbr: "Dunlap, IL",
  },
  {
    zip: "61526",
    ST: "IL",
    cityWithStateAbbr: "Edelstein, IL",
  },
  {
    zip: "61528",
    ST: "IL",
    cityWithStateAbbr: "Edwards, IL",
  },
  {
    zip: "61529",
    ST: "IL",
    cityWithStateAbbr: "Elmwood, IL",
  },
  {
    zip: "61530",
    ST: "IL",
    cityWithStateAbbr: "Eureka, IL",
  },
  {
    zip: "61531",
    ST: "IL",
    cityWithStateAbbr: "Farmington, IL",
  },
  {
    zip: "61532",
    ST: "IL",
    cityWithStateAbbr: "Forest City, IL",
  },
  {
    zip: "61533",
    ST: "IL",
    cityWithStateAbbr: "Glasford, IL",
  },
  {
    zip: "61534",
    ST: "IL",
    cityWithStateAbbr: "Green Valley, IL",
  },
  {
    zip: "61535",
    ST: "IL",
    cityWithStateAbbr: "Groveland, IL",
  },
  {
    zip: "61536",
    ST: "IL",
    cityWithStateAbbr: "Hanna City, IL",
  },
  {
    zip: "61537",
    ST: "IL",
    cityWithStateAbbr: "Henry, IL",
  },
  {
    zip: "61539",
    ST: "IL",
    cityWithStateAbbr: "Kingston Mines, IL",
  },
  {
    zip: "61540",
    ST: "IL",
    cityWithStateAbbr: "Lacon, IL",
  },
  {
    zip: "61541",
    ST: "IL",
    cityWithStateAbbr: "La Rose, IL",
  },
  {
    zip: "61542",
    ST: "IL",
    cityWithStateAbbr: "Lewistown, IL",
  },
  {
    zip: "61543",
    ST: "IL",
    cityWithStateAbbr: "Liverpool, IL",
  },
  {
    zip: "61544",
    ST: "IL",
    cityWithStateAbbr: "London Mills, IL",
  },
  {
    zip: "61545",
    ST: "IL",
    cityWithStateAbbr: "Lowpoint, IL",
  },
  {
    zip: "61546",
    ST: "IL",
    cityWithStateAbbr: "Manito, IL",
  },
  {
    zip: "61547",
    ST: "IL",
    cityWithStateAbbr: "Mapleton, IL",
  },
  {
    zip: "61548",
    ST: "IL",
    cityWithStateAbbr: "Metamora, IL",
  },
  {
    zip: "61550",
    ST: "IL",
    cityWithStateAbbr: "Morton, IL",
  },
  {
    zip: "61552",
    ST: "IL",
    cityWithStateAbbr: "Mossville, IL",
  },
  {
    zip: "61553",
    ST: "IL",
    cityWithStateAbbr: "Norris, IL",
  },
  {
    zip: "61554",
    ST: "IL",
    cityWithStateAbbr: "Pekin, IL",
  },
  {
    zip: "61555",
    ST: "IL",
    cityWithStateAbbr: "Pekin, IL",
  },
  {
    zip: "61558",
    ST: "IL",
    cityWithStateAbbr: "Pekin, IL",
  },
  {
    zip: "61559",
    ST: "IL",
    cityWithStateAbbr: "Princeville, IL",
  },
  {
    zip: "61560",
    ST: "IL",
    cityWithStateAbbr: "Putnam, IL",
  },
  {
    zip: "61561",
    ST: "IL",
    cityWithStateAbbr: "Roanoke, IL",
  },
  {
    zip: "61562",
    ST: "IL",
    cityWithStateAbbr: "Rome, IL",
  },
  {
    zip: "61563",
    ST: "IL",
    cityWithStateAbbr: "Saint David, IL",
  },
  {
    zip: "61564",
    ST: "IL",
    cityWithStateAbbr: "South Pekin, IL",
  },
  {
    zip: "61565",
    ST: "IL",
    cityWithStateAbbr: "Sparland, IL",
  },
  {
    zip: "61567",
    ST: "IL",
    cityWithStateAbbr: "Topeka, IL",
  },
  {
    zip: "61568",
    ST: "IL",
    cityWithStateAbbr: "Tremont, IL",
  },
  {
    zip: "61569",
    ST: "IL",
    cityWithStateAbbr: "Trivoli, IL",
  },
  {
    zip: "61570",
    ST: "IL",
    cityWithStateAbbr: "Washburn, IL",
  },
  {
    zip: "61571",
    ST: "IL",
    cityWithStateAbbr: "Washington, IL",
  },
  {
    zip: "61572",
    ST: "IL",
    cityWithStateAbbr: "Yates City, IL",
  },
  {
    zip: "61601",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61602",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61603",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61604",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61605",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61606",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61607",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61610",
    ST: "IL",
    cityWithStateAbbr: "Creve Coeur, IL",
  },
  {
    zip: "61611",
    ST: "IL",
    cityWithStateAbbr: "East Peoria, IL",
  },
  {
    zip: "61612",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61613",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61614",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61615",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61616",
    ST: "IL",
    cityWithStateAbbr: "Peoria Heights, IL",
  },
  {
    zip: "61625",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61629",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61630",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61633",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61634",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61635",
    ST: "IL",
    cityWithStateAbbr: "East Peoria, IL",
  },
  {
    zip: "61636",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61637",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61638",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61639",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61641",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61643",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61650",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61651",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61652",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61653",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61654",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61655",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61656",
    ST: "IL",
    cityWithStateAbbr: "Peoria, IL",
  },
  {
    zip: "61701",
    ST: "IL",
    cityWithStateAbbr: "Bloomington, IL",
  },
  {
    zip: "61702",
    ST: "IL",
    cityWithStateAbbr: "Bloomington, IL",
  },
  {
    zip: "61704",
    ST: "IL",
    cityWithStateAbbr: "Bloomington, IL",
  },
  {
    zip: "61705",
    ST: "IL",
    cityWithStateAbbr: "Bloomington, IL",
  },
  {
    zip: "61709",
    ST: "IL",
    cityWithStateAbbr: "Bloomington, IL",
  },
  {
    zip: "61710",
    ST: "IL",
    cityWithStateAbbr: "Bloomington, IL",
  },
  {
    zip: "61720",
    ST: "IL",
    cityWithStateAbbr: "Anchor, IL",
  },
  {
    zip: "61721",
    ST: "IL",
    cityWithStateAbbr: "Armington, IL",
  },
  {
    zip: "61722",
    ST: "IL",
    cityWithStateAbbr: "Arrowsmith, IL",
  },
  {
    zip: "61723",
    ST: "IL",
    cityWithStateAbbr: "Atlanta, IL",
  },
  {
    zip: "61724",
    ST: "IL",
    cityWithStateAbbr: "Bellflower, IL",
  },
  {
    zip: "61725",
    ST: "IL",
    cityWithStateAbbr: "Carlock, IL",
  },
  {
    zip: "61726",
    ST: "IL",
    cityWithStateAbbr: "Chenoa, IL",
  },
  {
    zip: "61727",
    ST: "IL",
    cityWithStateAbbr: "Clinton, IL",
  },
  {
    zip: "61728",
    ST: "IL",
    cityWithStateAbbr: "Colfax, IL",
  },
  {
    zip: "61729",
    ST: "IL",
    cityWithStateAbbr: "Congerville, IL",
  },
  {
    zip: "61730",
    ST: "IL",
    cityWithStateAbbr: "Cooksville, IL",
  },
  {
    zip: "61731",
    ST: "IL",
    cityWithStateAbbr: "Cropsey, IL",
  },
  {
    zip: "61732",
    ST: "IL",
    cityWithStateAbbr: "Danvers, IL",
  },
  {
    zip: "61733",
    ST: "IL",
    cityWithStateAbbr: "Deer Creek, IL",
  },
  {
    zip: "61734",
    ST: "IL",
    cityWithStateAbbr: "Delavan, IL",
  },
  {
    zip: "61735",
    ST: "IL",
    cityWithStateAbbr: "Dewitt, IL",
  },
  {
    zip: "61736",
    ST: "IL",
    cityWithStateAbbr: "Downs, IL",
  },
  {
    zip: "61737",
    ST: "IL",
    cityWithStateAbbr: "Ellsworth, IL",
  },
  {
    zip: "61738",
    ST: "IL",
    cityWithStateAbbr: "El Paso, IL",
  },
  {
    zip: "61739",
    ST: "IL",
    cityWithStateAbbr: "Fairbury, IL",
  },
  {
    zip: "61740",
    ST: "IL",
    cityWithStateAbbr: "Flanagan, IL",
  },
  {
    zip: "61741",
    ST: "IL",
    cityWithStateAbbr: "Forrest, IL",
  },
  {
    zip: "61742",
    ST: "IL",
    cityWithStateAbbr: "Goodfield, IL",
  },
  {
    zip: "61743",
    ST: "IL",
    cityWithStateAbbr: "Graymont, IL",
  },
  {
    zip: "61744",
    ST: "IL",
    cityWithStateAbbr: "Gridley, IL",
  },
  {
    zip: "61745",
    ST: "IL",
    cityWithStateAbbr: "Heyworth, IL",
  },
  {
    zip: "61747",
    ST: "IL",
    cityWithStateAbbr: "Hopedale, IL",
  },
  {
    zip: "61748",
    ST: "IL",
    cityWithStateAbbr: "Hudson, IL",
  },
  {
    zip: "61749",
    ST: "IL",
    cityWithStateAbbr: "Kenney, IL",
  },
  {
    zip: "61750",
    ST: "IL",
    cityWithStateAbbr: "Lane, IL",
  },
  {
    zip: "61751",
    ST: "IL",
    cityWithStateAbbr: "Lawndale, IL",
  },
  {
    zip: "61752",
    ST: "IL",
    cityWithStateAbbr: "Le Roy, IL",
  },
  {
    zip: "61753",
    ST: "IL",
    cityWithStateAbbr: "Lexington, IL",
  },
  {
    zip: "61754",
    ST: "IL",
    cityWithStateAbbr: "Mc Lean, IL",
  },
  {
    zip: "61755",
    ST: "IL",
    cityWithStateAbbr: "Mackinaw, IL",
  },
  {
    zip: "61756",
    ST: "IL",
    cityWithStateAbbr: "Maroa, IL",
  },
  {
    zip: "61758",
    ST: "IL",
    cityWithStateAbbr: "Merna, IL",
  },
  {
    zip: "61759",
    ST: "IL",
    cityWithStateAbbr: "Minier, IL",
  },
  {
    zip: "61760",
    ST: "IL",
    cityWithStateAbbr: "Minonk, IL",
  },
  {
    zip: "61761",
    ST: "IL",
    cityWithStateAbbr: "Normal, IL",
  },
  {
    zip: "61764",
    ST: "IL",
    cityWithStateAbbr: "Pontiac, IL",
  },
  {
    zip: "61769",
    ST: "IL",
    cityWithStateAbbr: "Saunemin, IL",
  },
  {
    zip: "61770",
    ST: "IL",
    cityWithStateAbbr: "Saybrook, IL",
  },
  {
    zip: "61771",
    ST: "IL",
    cityWithStateAbbr: "Secor, IL",
  },
  {
    zip: "61772",
    ST: "IL",
    cityWithStateAbbr: "Shirley, IL",
  },
  {
    zip: "61773",
    ST: "IL",
    cityWithStateAbbr: "Sibley, IL",
  },
  {
    zip: "61774",
    ST: "IL",
    cityWithStateAbbr: "Stanford, IL",
  },
  {
    zip: "61775",
    ST: "IL",
    cityWithStateAbbr: "Strawn, IL",
  },
  {
    zip: "61776",
    ST: "IL",
    cityWithStateAbbr: "Towanda, IL",
  },
  {
    zip: "61777",
    ST: "IL",
    cityWithStateAbbr: "Wapella, IL",
  },
  {
    zip: "61778",
    ST: "IL",
    cityWithStateAbbr: "Waynesville, IL",
  },
  {
    zip: "61790",
    ST: "IL",
    cityWithStateAbbr: "Normal, IL",
  },
  {
    zip: "61791",
    ST: "IL",
    cityWithStateAbbr: "Bloomington, IL",
  },
  {
    zip: "61799",
    ST: "IL",
    cityWithStateAbbr: "Bloomington, IL",
  },
  {
    zip: "61801",
    ST: "IL",
    cityWithStateAbbr: "Urbana, IL",
  },
  {
    zip: "61802",
    ST: "IL",
    cityWithStateAbbr: "Urbana, IL",
  },
  {
    zip: "61803",
    ST: "IL",
    cityWithStateAbbr: "Urbana, IL",
  },
  {
    zip: "61810",
    ST: "IL",
    cityWithStateAbbr: "Allerton, IL",
  },
  {
    zip: "61811",
    ST: "IL",
    cityWithStateAbbr: "Alvin, IL",
  },
  {
    zip: "61812",
    ST: "IL",
    cityWithStateAbbr: "Armstrong, IL",
  },
  {
    zip: "61813",
    ST: "IL",
    cityWithStateAbbr: "Bement, IL",
  },
  {
    zip: "61814",
    ST: "IL",
    cityWithStateAbbr: "Bismarck, IL",
  },
  {
    zip: "61815",
    ST: "IL",
    cityWithStateAbbr: "Bondville, IL",
  },
  {
    zip: "61816",
    ST: "IL",
    cityWithStateAbbr: "Broadlands, IL",
  },
  {
    zip: "61817",
    ST: "IL",
    cityWithStateAbbr: "Catlin, IL",
  },
  {
    zip: "61818",
    ST: "IL",
    cityWithStateAbbr: "Cerro Gordo, IL",
  },
  {
    zip: "61820",
    ST: "IL",
    cityWithStateAbbr: "Champaign, IL",
  },
  {
    zip: "61821",
    ST: "IL",
    cityWithStateAbbr: "Champaign, IL",
  },
  {
    zip: "61822",
    ST: "IL",
    cityWithStateAbbr: "Champaign, IL",
  },
  {
    zip: "61824",
    ST: "IL",
    cityWithStateAbbr: "Champaign, IL",
  },
  {
    zip: "61825",
    ST: "IL",
    cityWithStateAbbr: "Champaign, IL",
  },
  {
    zip: "61826",
    ST: "IL",
    cityWithStateAbbr: "Champaign, IL",
  },
  {
    zip: "61830",
    ST: "IL",
    cityWithStateAbbr: "Cisco, IL",
  },
  {
    zip: "61831",
    ST: "IL",
    cityWithStateAbbr: "Collison, IL",
  },
  {
    zip: "61832",
    ST: "IL",
    cityWithStateAbbr: "Danville, IL",
  },
  {
    zip: "61833",
    ST: "IL",
    cityWithStateAbbr: "Tilton, IL",
  },
  {
    zip: "61834",
    ST: "IL",
    cityWithStateAbbr: "Danville, IL",
  },
  {
    zip: "61839",
    ST: "IL",
    cityWithStateAbbr: "De Land, IL",
  },
  {
    zip: "61840",
    ST: "IL",
    cityWithStateAbbr: "Dewey, IL",
  },
  {
    zip: "61841",
    ST: "IL",
    cityWithStateAbbr: "Fairmount, IL",
  },
  {
    zip: "61842",
    ST: "IL",
    cityWithStateAbbr: "Farmer City, IL",
  },
  {
    zip: "61843",
    ST: "IL",
    cityWithStateAbbr: "Fisher, IL",
  },
  {
    zip: "61844",
    ST: "IL",
    cityWithStateAbbr: "Fithian, IL",
  },
  {
    zip: "61845",
    ST: "IL",
    cityWithStateAbbr: "Foosland, IL",
  },
  {
    zip: "61846",
    ST: "IL",
    cityWithStateAbbr: "Georgetown, IL",
  },
  {
    zip: "61847",
    ST: "IL",
    cityWithStateAbbr: "Gifford, IL",
  },
  {
    zip: "61848",
    ST: "IL",
    cityWithStateAbbr: "Henning, IL",
  },
  {
    zip: "61849",
    ST: "IL",
    cityWithStateAbbr: "Homer, IL",
  },
  {
    zip: "61850",
    ST: "IL",
    cityWithStateAbbr: "Indianola, IL",
  },
  {
    zip: "61851",
    ST: "IL",
    cityWithStateAbbr: "Ivesdale, IL",
  },
  {
    zip: "61852",
    ST: "IL",
    cityWithStateAbbr: "Longview, IL",
  },
  {
    zip: "61853",
    ST: "IL",
    cityWithStateAbbr: "Mahomet, IL",
  },
  {
    zip: "61854",
    ST: "IL",
    cityWithStateAbbr: "Mansfield, IL",
  },
  {
    zip: "61855",
    ST: "IL",
    cityWithStateAbbr: "Milmine, IL",
  },
  {
    zip: "61856",
    ST: "IL",
    cityWithStateAbbr: "Monticello, IL",
  },
  {
    zip: "61857",
    ST: "IL",
    cityWithStateAbbr: "Muncie, IL",
  },
  {
    zip: "61858",
    ST: "IL",
    cityWithStateAbbr: "Oakwood, IL",
  },
  {
    zip: "61859",
    ST: "IL",
    cityWithStateAbbr: "Ogden, IL",
  },
  {
    zip: "61862",
    ST: "IL",
    cityWithStateAbbr: "Penfield, IL",
  },
  {
    zip: "61863",
    ST: "IL",
    cityWithStateAbbr: "Pesotum, IL",
  },
  {
    zip: "61864",
    ST: "IL",
    cityWithStateAbbr: "Philo, IL",
  },
  {
    zip: "61865",
    ST: "IL",
    cityWithStateAbbr: "Potomac, IL",
  },
  {
    zip: "61866",
    ST: "IL",
    cityWithStateAbbr: "Rantoul, IL",
  },
  {
    zip: "61870",
    ST: "IL",
    cityWithStateAbbr: "Ridge Farm, IL",
  },
  {
    zip: "61871",
    ST: "IL",
    cityWithStateAbbr: "Royal, IL",
  },
  {
    zip: "61872",
    ST: "IL",
    cityWithStateAbbr: "Sadorus, IL",
  },
  {
    zip: "61873",
    ST: "IL",
    cityWithStateAbbr: "Saint Joseph, IL",
  },
  {
    zip: "61874",
    ST: "IL",
    cityWithStateAbbr: "Savoy, IL",
  },
  {
    zip: "61875",
    ST: "IL",
    cityWithStateAbbr: "Seymour, IL",
  },
  {
    zip: "61876",
    ST: "IL",
    cityWithStateAbbr: "Sidell, IL",
  },
  {
    zip: "61877",
    ST: "IL",
    cityWithStateAbbr: "Sidney, IL",
  },
  {
    zip: "61878",
    ST: "IL",
    cityWithStateAbbr: "Thomasboro, IL",
  },
  {
    zip: "61880",
    ST: "IL",
    cityWithStateAbbr: "Tolono, IL",
  },
  {
    zip: "61882",
    ST: "IL",
    cityWithStateAbbr: "Weldon, IL",
  },
  {
    zip: "61883",
    ST: "IL",
    cityWithStateAbbr: "Westville, IL",
  },
  {
    zip: "61884",
    ST: "IL",
    cityWithStateAbbr: "White Heath, IL",
  },
  {
    zip: "61910",
    ST: "IL",
    cityWithStateAbbr: "Arcola, IL",
  },
  {
    zip: "61911",
    ST: "IL",
    cityWithStateAbbr: "Arthur, IL",
  },
  {
    zip: "61912",
    ST: "IL",
    cityWithStateAbbr: "Ashmore, IL",
  },
  {
    zip: "61913",
    ST: "IL",
    cityWithStateAbbr: "Atwood, IL",
  },
  {
    zip: "61914",
    ST: "IL",
    cityWithStateAbbr: "Bethany, IL",
  },
  {
    zip: "61917",
    ST: "IL",
    cityWithStateAbbr: "Brocton, IL",
  },
  {
    zip: "61919",
    ST: "IL",
    cityWithStateAbbr: "Camargo, IL",
  },
  {
    zip: "61920",
    ST: "IL",
    cityWithStateAbbr: "Charleston, IL",
  },
  {
    zip: "61924",
    ST: "IL",
    cityWithStateAbbr: "Chrisman, IL",
  },
  {
    zip: "61925",
    ST: "IL",
    cityWithStateAbbr: "Dalton City, IL",
  },
  {
    zip: "61928",
    ST: "IL",
    cityWithStateAbbr: "Gays, IL",
  },
  {
    zip: "61929",
    ST: "IL",
    cityWithStateAbbr: "Hammond, IL",
  },
  {
    zip: "61930",
    ST: "IL",
    cityWithStateAbbr: "Hindsboro, IL",
  },
  {
    zip: "61931",
    ST: "IL",
    cityWithStateAbbr: "Humboldt, IL",
  },
  {
    zip: "61932",
    ST: "IL",
    cityWithStateAbbr: "Hume, IL",
  },
  {
    zip: "61933",
    ST: "IL",
    cityWithStateAbbr: "Kansas, IL",
  },
  {
    zip: "61936",
    ST: "IL",
    cityWithStateAbbr: "La Place, IL",
  },
  {
    zip: "61937",
    ST: "IL",
    cityWithStateAbbr: "Lovington, IL",
  },
  {
    zip: "61938",
    ST: "IL",
    cityWithStateAbbr: "Mattoon, IL",
  },
  {
    zip: "61940",
    ST: "IL",
    cityWithStateAbbr: "Metcalf, IL",
  },
  {
    zip: "61941",
    ST: "IL",
    cityWithStateAbbr: "Murdock, IL",
  },
  {
    zip: "61942",
    ST: "IL",
    cityWithStateAbbr: "Newman, IL",
  },
  {
    zip: "61943",
    ST: "IL",
    cityWithStateAbbr: "Oakland, IL",
  },
  {
    zip: "61944",
    ST: "IL",
    cityWithStateAbbr: "Paris, IL",
  },
  {
    zip: "61949",
    ST: "IL",
    cityWithStateAbbr: "Redmon, IL",
  },
  {
    zip: "61951",
    ST: "IL",
    cityWithStateAbbr: "Sullivan, IL",
  },
  {
    zip: "61953",
    ST: "IL",
    cityWithStateAbbr: "Tuscola, IL",
  },
  {
    zip: "61955",
    ST: "IL",
    cityWithStateAbbr: "Vermilion, IL",
  },
  {
    zip: "61956",
    ST: "IL",
    cityWithStateAbbr: "Villa Grove, IL",
  },
  {
    zip: "61957",
    ST: "IL",
    cityWithStateAbbr: "Windsor, IL",
  },
  {
    zip: "62001",
    ST: "IL",
    cityWithStateAbbr: "Alhambra, IL",
  },
  {
    zip: "62002",
    ST: "IL",
    cityWithStateAbbr: "Alton, IL",
  },
  {
    zip: "62006",
    ST: "IL",
    cityWithStateAbbr: "Batchtown, IL",
  },
  {
    zip: "62009",
    ST: "IL",
    cityWithStateAbbr: "Benld, IL",
  },
  {
    zip: "62010",
    ST: "IL",
    cityWithStateAbbr: "Bethalto, IL",
  },
  {
    zip: "62011",
    ST: "IL",
    cityWithStateAbbr: "Bingham, IL",
  },
  {
    zip: "62012",
    ST: "IL",
    cityWithStateAbbr: "Brighton, IL",
  },
  {
    zip: "62013",
    ST: "IL",
    cityWithStateAbbr: "Brussels, IL",
  },
  {
    zip: "62014",
    ST: "IL",
    cityWithStateAbbr: "Bunker Hill, IL",
  },
  {
    zip: "62015",
    ST: "IL",
    cityWithStateAbbr: "Butler, IL",
  },
  {
    zip: "62016",
    ST: "IL",
    cityWithStateAbbr: "Carrollton, IL",
  },
  {
    zip: "62017",
    ST: "IL",
    cityWithStateAbbr: "Coffeen, IL",
  },
  {
    zip: "62018",
    ST: "IL",
    cityWithStateAbbr: "Cottage Hills, IL",
  },
  {
    zip: "62019",
    ST: "IL",
    cityWithStateAbbr: "Donnellson, IL",
  },
  {
    zip: "62021",
    ST: "IL",
    cityWithStateAbbr: "Dorsey, IL",
  },
  {
    zip: "62022",
    ST: "IL",
    cityWithStateAbbr: "Dow, IL",
  },
  {
    zip: "62023",
    ST: "IL",
    cityWithStateAbbr: "Eagarville, IL",
  },
  {
    zip: "62024",
    ST: "IL",
    cityWithStateAbbr: "East Alton, IL",
  },
  {
    zip: "62025",
    ST: "IL",
    cityWithStateAbbr: "Edwardsville, IL",
  },
  {
    zip: "62026",
    ST: "IL",
    cityWithStateAbbr: "Edwardsville, IL",
  },
  {
    zip: "62027",
    ST: "IL",
    cityWithStateAbbr: "Eldred, IL",
  },
  {
    zip: "62028",
    ST: "IL",
    cityWithStateAbbr: "Elsah, IL",
  },
  {
    zip: "62030",
    ST: "IL",
    cityWithStateAbbr: "Fidelity, IL",
  },
  {
    zip: "62031",
    ST: "IL",
    cityWithStateAbbr: "Fieldon, IL",
  },
  {
    zip: "62032",
    ST: "IL",
    cityWithStateAbbr: "Fillmore, IL",
  },
  {
    zip: "62033",
    ST: "IL",
    cityWithStateAbbr: "Gillespie, IL",
  },
  {
    zip: "62034",
    ST: "IL",
    cityWithStateAbbr: "Glen Carbon, IL",
  },
  {
    zip: "62035",
    ST: "IL",
    cityWithStateAbbr: "Godfrey, IL",
  },
  {
    zip: "62036",
    ST: "IL",
    cityWithStateAbbr: "Golden Eagle, IL",
  },
  {
    zip: "62037",
    ST: "IL",
    cityWithStateAbbr: "Grafton, IL",
  },
  {
    zip: "62040",
    ST: "IL",
    cityWithStateAbbr: "Granite City, IL",
  },
  {
    zip: "62044",
    ST: "IL",
    cityWithStateAbbr: "Greenfield, IL",
  },
  {
    zip: "62045",
    ST: "IL",
    cityWithStateAbbr: "Hamburg, IL",
  },
  {
    zip: "62046",
    ST: "IL",
    cityWithStateAbbr: "Hamel, IL",
  },
  {
    zip: "62047",
    ST: "IL",
    cityWithStateAbbr: "Hardin, IL",
  },
  {
    zip: "62048",
    ST: "IL",
    cityWithStateAbbr: "Hartford, IL",
  },
  {
    zip: "62049",
    ST: "IL",
    cityWithStateAbbr: "Hillsboro, IL",
  },
  {
    zip: "62050",
    ST: "IL",
    cityWithStateAbbr: "Hillview, IL",
  },
  {
    zip: "62051",
    ST: "IL",
    cityWithStateAbbr: "Irving, IL",
  },
  {
    zip: "62052",
    ST: "IL",
    cityWithStateAbbr: "Jerseyville, IL",
  },
  {
    zip: "62053",
    ST: "IL",
    cityWithStateAbbr: "Kampsville, IL",
  },
  {
    zip: "62054",
    ST: "IL",
    cityWithStateAbbr: "Kane, IL",
  },
  {
    zip: "62056",
    ST: "IL",
    cityWithStateAbbr: "Litchfield, IL",
  },
  {
    zip: "62058",
    ST: "IL",
    cityWithStateAbbr: "Livingston, IL",
  },
  {
    zip: "62059",
    ST: "IL",
    cityWithStateAbbr: "Lovejoy, IL",
  },
  {
    zip: "62060",
    ST: "IL",
    cityWithStateAbbr: "Madison, IL",
  },
  {
    zip: "62061",
    ST: "IL",
    cityWithStateAbbr: "Marine, IL",
  },
  {
    zip: "62062",
    ST: "IL",
    cityWithStateAbbr: "Maryville, IL",
  },
  {
    zip: "62063",
    ST: "IL",
    cityWithStateAbbr: "Medora, IL",
  },
  {
    zip: "62065",
    ST: "IL",
    cityWithStateAbbr: "Michael, IL",
  },
  {
    zip: "62067",
    ST: "IL",
    cityWithStateAbbr: "Moro, IL",
  },
  {
    zip: "62069",
    ST: "IL",
    cityWithStateAbbr: "Mount Olive, IL",
  },
  {
    zip: "62070",
    ST: "IL",
    cityWithStateAbbr: "Mozier, IL",
  },
  {
    zip: "62071",
    ST: "IL",
    cityWithStateAbbr: "National Stock Yards, IL",
  },
  {
    zip: "62074",
    ST: "IL",
    cityWithStateAbbr: "New Douglas, IL",
  },
  {
    zip: "62075",
    ST: "IL",
    cityWithStateAbbr: "Nokomis, IL",
  },
  {
    zip: "62076",
    ST: "IL",
    cityWithStateAbbr: "Ohlman, IL",
  },
  {
    zip: "62077",
    ST: "IL",
    cityWithStateAbbr: "Panama, IL",
  },
  {
    zip: "62078",
    ST: "IL",
    cityWithStateAbbr: "Patterson, IL",
  },
  {
    zip: "62079",
    ST: "IL",
    cityWithStateAbbr: "Piasa, IL",
  },
  {
    zip: "62080",
    ST: "IL",
    cityWithStateAbbr: "Ramsey, IL",
  },
  {
    zip: "62081",
    ST: "IL",
    cityWithStateAbbr: "Rockbridge, IL",
  },
  {
    zip: "62082",
    ST: "IL",
    cityWithStateAbbr: "Roodhouse, IL",
  },
  {
    zip: "62083",
    ST: "IL",
    cityWithStateAbbr: "Rosamond, IL",
  },
  {
    zip: "62084",
    ST: "IL",
    cityWithStateAbbr: "Roxana, IL",
  },
  {
    zip: "62085",
    ST: "IL",
    cityWithStateAbbr: "Sawyerville, IL",
  },
  {
    zip: "62086",
    ST: "IL",
    cityWithStateAbbr: "Sorento, IL",
  },
  {
    zip: "62087",
    ST: "IL",
    cityWithStateAbbr: "South Roxana, IL",
  },
  {
    zip: "62088",
    ST: "IL",
    cityWithStateAbbr: "Staunton, IL",
  },
  {
    zip: "62089",
    ST: "IL",
    cityWithStateAbbr: "Taylor Springs, IL",
  },
  {
    zip: "62090",
    ST: "IL",
    cityWithStateAbbr: "Venice, IL",
  },
  {
    zip: "62091",
    ST: "IL",
    cityWithStateAbbr: "Walshville, IL",
  },
  {
    zip: "62092",
    ST: "IL",
    cityWithStateAbbr: "White Hall, IL",
  },
  {
    zip: "62093",
    ST: "IL",
    cityWithStateAbbr: "Wilsonville, IL",
  },
  {
    zip: "62094",
    ST: "IL",
    cityWithStateAbbr: "Witt, IL",
  },
  {
    zip: "62095",
    ST: "IL",
    cityWithStateAbbr: "Wood River, IL",
  },
  {
    zip: "62097",
    ST: "IL",
    cityWithStateAbbr: "Worden, IL",
  },
  {
    zip: "62098",
    ST: "IL",
    cityWithStateAbbr: "Wrights, IL",
  },
  {
    zip: "62201",
    ST: "IL",
    cityWithStateAbbr: "East Saint Louis, IL",
  },
  {
    zip: "62202",
    ST: "IL",
    cityWithStateAbbr: "East Saint Louis, IL",
  },
  {
    zip: "62203",
    ST: "IL",
    cityWithStateAbbr: "East Saint Louis, IL",
  },
  {
    zip: "62204",
    ST: "IL",
    cityWithStateAbbr: "East Saint Louis, IL",
  },
  {
    zip: "62205",
    ST: "IL",
    cityWithStateAbbr: "East Saint Louis, IL",
  },
  {
    zip: "62206",
    ST: "IL",
    cityWithStateAbbr: "East Saint Louis, IL",
  },
  {
    zip: "62207",
    ST: "IL",
    cityWithStateAbbr: "East Saint Louis, IL",
  },
  {
    zip: "62208",
    ST: "IL",
    cityWithStateAbbr: "Fairview Heights, IL",
  },
  {
    zip: "62214",
    ST: "IL",
    cityWithStateAbbr: "Addieville, IL",
  },
  {
    zip: "62215",
    ST: "IL",
    cityWithStateAbbr: "Albers, IL",
  },
  {
    zip: "62216",
    ST: "IL",
    cityWithStateAbbr: "Aviston, IL",
  },
  {
    zip: "62217",
    ST: "IL",
    cityWithStateAbbr: "Baldwin, IL",
  },
  {
    zip: "62218",
    ST: "IL",
    cityWithStateAbbr: "Bartelso, IL",
  },
  {
    zip: "62219",
    ST: "IL",
    cityWithStateAbbr: "Beckemeyer, IL",
  },
  {
    zip: "62220",
    ST: "IL",
    cityWithStateAbbr: "Belleville, IL",
  },
  {
    zip: "62221",
    ST: "IL",
    cityWithStateAbbr: "Belleville, IL",
  },
  {
    zip: "62222",
    ST: "IL",
    cityWithStateAbbr: "Belleville, IL",
  },
  {
    zip: "62223",
    ST: "IL",
    cityWithStateAbbr: "Belleville, IL",
  },
  {
    zip: "62225",
    ST: "IL",
    cityWithStateAbbr: "Scott Air Force Base, IL",
  },
  {
    zip: "62226",
    ST: "IL",
    cityWithStateAbbr: "Belleville, IL",
  },
  {
    zip: "62230",
    ST: "IL",
    cityWithStateAbbr: "Breese, IL",
  },
  {
    zip: "62231",
    ST: "IL",
    cityWithStateAbbr: "Carlyle, IL",
  },
  {
    zip: "62232",
    ST: "IL",
    cityWithStateAbbr: "Caseyville, IL",
  },
  {
    zip: "62233",
    ST: "IL",
    cityWithStateAbbr: "Chester, IL",
  },
  {
    zip: "62234",
    ST: "IL",
    cityWithStateAbbr: "Collinsville, IL",
  },
  {
    zip: "62236",
    ST: "IL",
    cityWithStateAbbr: "Columbia, IL",
  },
  {
    zip: "62237",
    ST: "IL",
    cityWithStateAbbr: "Coulterville, IL",
  },
  {
    zip: "62238",
    ST: "IL",
    cityWithStateAbbr: "Cutler, IL",
  },
  {
    zip: "62239",
    ST: "IL",
    cityWithStateAbbr: "Dupo, IL",
  },
  {
    zip: "62240",
    ST: "IL",
    cityWithStateAbbr: "East Carondelet, IL",
  },
  {
    zip: "62241",
    ST: "IL",
    cityWithStateAbbr: "Ellis Grove, IL",
  },
  {
    zip: "62242",
    ST: "IL",
    cityWithStateAbbr: "Evansville, IL",
  },
  {
    zip: "62243",
    ST: "IL",
    cityWithStateAbbr: "Freeburg, IL",
  },
  {
    zip: "62244",
    ST: "IL",
    cityWithStateAbbr: "Fults, IL",
  },
  {
    zip: "62245",
    ST: "IL",
    cityWithStateAbbr: "Germantown, IL",
  },
  {
    zip: "62246",
    ST: "IL",
    cityWithStateAbbr: "Greenville, IL",
  },
  {
    zip: "62247",
    ST: "IL",
    cityWithStateAbbr: "Hagarstown, IL",
  },
  {
    zip: "62248",
    ST: "IL",
    cityWithStateAbbr: "Hecker, IL",
  },
  {
    zip: "62249",
    ST: "IL",
    cityWithStateAbbr: "Highland, IL",
  },
  {
    zip: "62250",
    ST: "IL",
    cityWithStateAbbr: "Hoffman, IL",
  },
  {
    zip: "62252",
    ST: "IL",
    cityWithStateAbbr: "Huey, IL",
  },
  {
    zip: "62253",
    ST: "IL",
    cityWithStateAbbr: "Keyesport, IL",
  },
  {
    zip: "62254",
    ST: "IL",
    cityWithStateAbbr: "Lebanon, IL",
  },
  {
    zip: "62255",
    ST: "IL",
    cityWithStateAbbr: "Lenzburg, IL",
  },
  {
    zip: "62256",
    ST: "IL",
    cityWithStateAbbr: "Maeystown, IL",
  },
  {
    zip: "62257",
    ST: "IL",
    cityWithStateAbbr: "Marissa, IL",
  },
  {
    zip: "62258",
    ST: "IL",
    cityWithStateAbbr: "Mascoutah, IL",
  },
  {
    zip: "62259",
    ST: "IL",
    cityWithStateAbbr: "Menard, IL",
  },
  {
    zip: "62260",
    ST: "IL",
    cityWithStateAbbr: "Millstadt, IL",
  },
  {
    zip: "62261",
    ST: "IL",
    cityWithStateAbbr: "Modoc, IL",
  },
  {
    zip: "62262",
    ST: "IL",
    cityWithStateAbbr: "Mulberry Grove, IL",
  },
  {
    zip: "62263",
    ST: "IL",
    cityWithStateAbbr: "Nashville, IL",
  },
  {
    zip: "62264",
    ST: "IL",
    cityWithStateAbbr: "New Athens, IL",
  },
  {
    zip: "62265",
    ST: "IL",
    cityWithStateAbbr: "New Baden, IL",
  },
  {
    zip: "62266",
    ST: "IL",
    cityWithStateAbbr: "New Memphis, IL",
  },
  {
    zip: "62268",
    ST: "IL",
    cityWithStateAbbr: "Oakdale, IL",
  },
  {
    zip: "62269",
    ST: "IL",
    cityWithStateAbbr: "O Fallon, IL",
  },
  {
    zip: "62271",
    ST: "IL",
    cityWithStateAbbr: "Okawville, IL",
  },
  {
    zip: "62272",
    ST: "IL",
    cityWithStateAbbr: "Percy, IL",
  },
  {
    zip: "62273",
    ST: "IL",
    cityWithStateAbbr: "Pierron, IL",
  },
  {
    zip: "62274",
    ST: "IL",
    cityWithStateAbbr: "Pinckneyville, IL",
  },
  {
    zip: "62275",
    ST: "IL",
    cityWithStateAbbr: "Pocahontas, IL",
  },
  {
    zip: "62277",
    ST: "IL",
    cityWithStateAbbr: "Prairie Du Rocher, IL",
  },
  {
    zip: "62278",
    ST: "IL",
    cityWithStateAbbr: "Red Bud, IL",
  },
  {
    zip: "62279",
    ST: "IL",
    cityWithStateAbbr: "Renault, IL",
  },
  {
    zip: "62280",
    ST: "IL",
    cityWithStateAbbr: "Rockwood, IL",
  },
  {
    zip: "62281",
    ST: "IL",
    cityWithStateAbbr: "Saint Jacob, IL",
  },
  {
    zip: "62282",
    ST: "IL",
    cityWithStateAbbr: "Saint Libory, IL",
  },
  {
    zip: "62284",
    ST: "IL",
    cityWithStateAbbr: "Smithboro, IL",
  },
  {
    zip: "62285",
    ST: "IL",
    cityWithStateAbbr: "Smithton, IL",
  },
  {
    zip: "62286",
    ST: "IL",
    cityWithStateAbbr: "Sparta, IL",
  },
  {
    zip: "62288",
    ST: "IL",
    cityWithStateAbbr: "Steeleville, IL",
  },
  {
    zip: "62289",
    ST: "IL",
    cityWithStateAbbr: "Summerfield, IL",
  },
  {
    zip: "62292",
    ST: "IL",
    cityWithStateAbbr: "Tilden, IL",
  },
  {
    zip: "62293",
    ST: "IL",
    cityWithStateAbbr: "Trenton, IL",
  },
  {
    zip: "62294",
    ST: "IL",
    cityWithStateAbbr: "Troy, IL",
  },
  {
    zip: "62295",
    ST: "IL",
    cityWithStateAbbr: "Valmeyer, IL",
  },
  {
    zip: "62297",
    ST: "IL",
    cityWithStateAbbr: "Walsh, IL",
  },
  {
    zip: "62298",
    ST: "IL",
    cityWithStateAbbr: "Waterloo, IL",
  },
  {
    zip: "62301",
    ST: "IL",
    cityWithStateAbbr: "Quincy, IL",
  },
  {
    zip: "62305",
    ST: "IL",
    cityWithStateAbbr: "Quincy, IL",
  },
  {
    zip: "62306",
    ST: "IL",
    cityWithStateAbbr: "Quincy, IL",
  },
  {
    zip: "62311",
    ST: "IL",
    cityWithStateAbbr: "Augusta, IL",
  },
  {
    zip: "62312",
    ST: "IL",
    cityWithStateAbbr: "Barry, IL",
  },
  {
    zip: "62313",
    ST: "IL",
    cityWithStateAbbr: "Basco, IL",
  },
  {
    zip: "62314",
    ST: "IL",
    cityWithStateAbbr: "Baylis, IL",
  },
  {
    zip: "62316",
    ST: "IL",
    cityWithStateAbbr: "Bowen, IL",
  },
  {
    zip: "62319",
    ST: "IL",
    cityWithStateAbbr: "Camden, IL",
  },
  {
    zip: "62320",
    ST: "IL",
    cityWithStateAbbr: "Camp Point, IL",
  },
  {
    zip: "62321",
    ST: "IL",
    cityWithStateAbbr: "Carthage, IL",
  },
  {
    zip: "62323",
    ST: "IL",
    cityWithStateAbbr: "Chambersburg, IL",
  },
  {
    zip: "62324",
    ST: "IL",
    cityWithStateAbbr: "Clayton, IL",
  },
  {
    zip: "62325",
    ST: "IL",
    cityWithStateAbbr: "Coatsburg, IL",
  },
  {
    zip: "62326",
    ST: "IL",
    cityWithStateAbbr: "Colchester, IL",
  },
  {
    zip: "62329",
    ST: "IL",
    cityWithStateAbbr: "Colusa, IL",
  },
  {
    zip: "62330",
    ST: "IL",
    cityWithStateAbbr: "Dallas City, IL",
  },
  {
    zip: "62334",
    ST: "IL",
    cityWithStateAbbr: "Elvaston, IL",
  },
  {
    zip: "62336",
    ST: "IL",
    cityWithStateAbbr: "Ferris, IL",
  },
  {
    zip: "62338",
    ST: "IL",
    cityWithStateAbbr: "Fowler, IL",
  },
  {
    zip: "62339",
    ST: "IL",
    cityWithStateAbbr: "Golden, IL",
  },
  {
    zip: "62340",
    ST: "IL",
    cityWithStateAbbr: "Griggsville, IL",
  },
  {
    zip: "62341",
    ST: "IL",
    cityWithStateAbbr: "Hamilton, IL",
  },
  {
    zip: "62343",
    ST: "IL",
    cityWithStateAbbr: "Hull, IL",
  },
  {
    zip: "62344",
    ST: "IL",
    cityWithStateAbbr: "Huntsville, IL",
  },
  {
    zip: "62345",
    ST: "IL",
    cityWithStateAbbr: "Kinderhook, IL",
  },
  {
    zip: "62346",
    ST: "IL",
    cityWithStateAbbr: "La Prairie, IL",
  },
  {
    zip: "62347",
    ST: "IL",
    cityWithStateAbbr: "Liberty, IL",
  },
  {
    zip: "62348",
    ST: "IL",
    cityWithStateAbbr: "Lima, IL",
  },
  {
    zip: "62349",
    ST: "IL",
    cityWithStateAbbr: "Loraine, IL",
  },
  {
    zip: "62351",
    ST: "IL",
    cityWithStateAbbr: "Mendon, IL",
  },
  {
    zip: "62352",
    ST: "IL",
    cityWithStateAbbr: "Milton, IL",
  },
  {
    zip: "62353",
    ST: "IL",
    cityWithStateAbbr: "Mount Sterling, IL",
  },
  {
    zip: "62354",
    ST: "IL",
    cityWithStateAbbr: "Nauvoo, IL",
  },
  {
    zip: "62355",
    ST: "IL",
    cityWithStateAbbr: "Nebo, IL",
  },
  {
    zip: "62356",
    ST: "IL",
    cityWithStateAbbr: "New Canton, IL",
  },
  {
    zip: "62357",
    ST: "IL",
    cityWithStateAbbr: "New Salem, IL",
  },
  {
    zip: "62358",
    ST: "IL",
    cityWithStateAbbr: "Niota, IL",
  },
  {
    zip: "62359",
    ST: "IL",
    cityWithStateAbbr: "Paloma, IL",
  },
  {
    zip: "62360",
    ST: "IL",
    cityWithStateAbbr: "Payson, IL",
  },
  {
    zip: "62361",
    ST: "IL",
    cityWithStateAbbr: "Pearl, IL",
  },
  {
    zip: "62362",
    ST: "IL",
    cityWithStateAbbr: "Perry, IL",
  },
  {
    zip: "62363",
    ST: "IL",
    cityWithStateAbbr: "Pittsfield, IL",
  },
  {
    zip: "62365",
    ST: "IL",
    cityWithStateAbbr: "Plainville, IL",
  },
  {
    zip: "62366",
    ST: "IL",
    cityWithStateAbbr: "Pleasant Hill, IL",
  },
  {
    zip: "62367",
    ST: "IL",
    cityWithStateAbbr: "Plymouth, IL",
  },
  {
    zip: "62370",
    ST: "IL",
    cityWithStateAbbr: "Rockport, IL",
  },
  {
    zip: "62373",
    ST: "IL",
    cityWithStateAbbr: "Sutter, IL",
  },
  {
    zip: "62374",
    ST: "IL",
    cityWithStateAbbr: "Tennessee, IL",
  },
  {
    zip: "62375",
    ST: "IL",
    cityWithStateAbbr: "Timewell, IL",
  },
  {
    zip: "62376",
    ST: "IL",
    cityWithStateAbbr: "Ursa, IL",
  },
  {
    zip: "62378",
    ST: "IL",
    cityWithStateAbbr: "Versailles, IL",
  },
  {
    zip: "62379",
    ST: "IL",
    cityWithStateAbbr: "Warsaw, IL",
  },
  {
    zip: "62380",
    ST: "IL",
    cityWithStateAbbr: "West Point, IL",
  },
  {
    zip: "62401",
    ST: "IL",
    cityWithStateAbbr: "Effingham, IL",
  },
  {
    zip: "62410",
    ST: "IL",
    cityWithStateAbbr: "Allendale, IL",
  },
  {
    zip: "62411",
    ST: "IL",
    cityWithStateAbbr: "Altamont, IL",
  },
  {
    zip: "62413",
    ST: "IL",
    cityWithStateAbbr: "Annapolis, IL",
  },
  {
    zip: "62414",
    ST: "IL",
    cityWithStateAbbr: "Beecher City, IL",
  },
  {
    zip: "62417",
    ST: "IL",
    cityWithStateAbbr: "Bridgeport, IL",
  },
  {
    zip: "62418",
    ST: "IL",
    cityWithStateAbbr: "Brownstown, IL",
  },
  {
    zip: "62419",
    ST: "IL",
    cityWithStateAbbr: "Calhoun, IL",
  },
  {
    zip: "62420",
    ST: "IL",
    cityWithStateAbbr: "Casey, IL",
  },
  {
    zip: "62421",
    ST: "IL",
    cityWithStateAbbr: "Claremont, IL",
  },
  {
    zip: "62422",
    ST: "IL",
    cityWithStateAbbr: "Cowden, IL",
  },
  {
    zip: "62423",
    ST: "IL",
    cityWithStateAbbr: "Dennison, IL",
  },
  {
    zip: "62424",
    ST: "IL",
    cityWithStateAbbr: "Dieterich, IL",
  },
  {
    zip: "62425",
    ST: "IL",
    cityWithStateAbbr: "Dundas, IL",
  },
  {
    zip: "62426",
    ST: "IL",
    cityWithStateAbbr: "Edgewood, IL",
  },
  {
    zip: "62427",
    ST: "IL",
    cityWithStateAbbr: "Flat Rock, IL",
  },
  {
    zip: "62428",
    ST: "IL",
    cityWithStateAbbr: "Greenup, IL",
  },
  {
    zip: "62431",
    ST: "IL",
    cityWithStateAbbr: "Herrick, IL",
  },
  {
    zip: "62432",
    ST: "IL",
    cityWithStateAbbr: "Hidalgo, IL",
  },
  {
    zip: "62433",
    ST: "IL",
    cityWithStateAbbr: "Hutsonville, IL",
  },
  {
    zip: "62434",
    ST: "IL",
    cityWithStateAbbr: "Ingraham, IL",
  },
  {
    zip: "62435",
    ST: "IL",
    cityWithStateAbbr: "Janesville, IL",
  },
  {
    zip: "62436",
    ST: "IL",
    cityWithStateAbbr: "Jewett, IL",
  },
  {
    zip: "62438",
    ST: "IL",
    cityWithStateAbbr: "Lakewood, IL",
  },
  {
    zip: "62439",
    ST: "IL",
    cityWithStateAbbr: "Lawrenceville, IL",
  },
  {
    zip: "62440",
    ST: "IL",
    cityWithStateAbbr: "Lerna, IL",
  },
  {
    zip: "62441",
    ST: "IL",
    cityWithStateAbbr: "Marshall, IL",
  },
  {
    zip: "62442",
    ST: "IL",
    cityWithStateAbbr: "Martinsville, IL",
  },
  {
    zip: "62443",
    ST: "IL",
    cityWithStateAbbr: "Mason, IL",
  },
  {
    zip: "62444",
    ST: "IL",
    cityWithStateAbbr: "Mode, IL",
  },
  {
    zip: "62445",
    ST: "IL",
    cityWithStateAbbr: "Montrose, IL",
  },
  {
    zip: "62446",
    ST: "IL",
    cityWithStateAbbr: "Mount Erie, IL",
  },
  {
    zip: "62447",
    ST: "IL",
    cityWithStateAbbr: "Neoga, IL",
  },
  {
    zip: "62448",
    ST: "IL",
    cityWithStateAbbr: "Newton, IL",
  },
  {
    zip: "62449",
    ST: "IL",
    cityWithStateAbbr: "Oblong, IL",
  },
  {
    zip: "62450",
    ST: "IL",
    cityWithStateAbbr: "Olney, IL",
  },
  {
    zip: "62451",
    ST: "IL",
    cityWithStateAbbr: "Palestine, IL",
  },
  {
    zip: "62452",
    ST: "IL",
    cityWithStateAbbr: "Parkersburg, IL",
  },
  {
    zip: "62454",
    ST: "IL",
    cityWithStateAbbr: "Robinson, IL",
  },
  {
    zip: "62458",
    ST: "IL",
    cityWithStateAbbr: "Saint Elmo, IL",
  },
  {
    zip: "62459",
    ST: "IL",
    cityWithStateAbbr: "Sainte Marie, IL",
  },
  {
    zip: "62460",
    ST: "IL",
    cityWithStateAbbr: "Saint Francisville, IL",
  },
  {
    zip: "62461",
    ST: "IL",
    cityWithStateAbbr: "Shumway, IL",
  },
  {
    zip: "62462",
    ST: "IL",
    cityWithStateAbbr: "Sigel, IL",
  },
  {
    zip: "62463",
    ST: "IL",
    cityWithStateAbbr: "Stewardson, IL",
  },
  {
    zip: "62464",
    ST: "IL",
    cityWithStateAbbr: "Stoy, IL",
  },
  {
    zip: "62465",
    ST: "IL",
    cityWithStateAbbr: "Strasburg, IL",
  },
  {
    zip: "62466",
    ST: "IL",
    cityWithStateAbbr: "Sumner, IL",
  },
  {
    zip: "62467",
    ST: "IL",
    cityWithStateAbbr: "Teutopolis, IL",
  },
  {
    zip: "62468",
    ST: "IL",
    cityWithStateAbbr: "Toledo, IL",
  },
  {
    zip: "62469",
    ST: "IL",
    cityWithStateAbbr: "Trilla, IL",
  },
  {
    zip: "62471",
    ST: "IL",
    cityWithStateAbbr: "Vandalia, IL",
  },
  {
    zip: "62473",
    ST: "IL",
    cityWithStateAbbr: "Watson, IL",
  },
  {
    zip: "62474",
    ST: "IL",
    cityWithStateAbbr: "Westfield, IL",
  },
  {
    zip: "62475",
    ST: "IL",
    cityWithStateAbbr: "West Liberty, IL",
  },
  {
    zip: "62476",
    ST: "IL",
    cityWithStateAbbr: "West Salem, IL",
  },
  {
    zip: "62477",
    ST: "IL",
    cityWithStateAbbr: "West Union, IL",
  },
  {
    zip: "62478",
    ST: "IL",
    cityWithStateAbbr: "West York, IL",
  },
  {
    zip: "62479",
    ST: "IL",
    cityWithStateAbbr: "Wheeler, IL",
  },
  {
    zip: "62480",
    ST: "IL",
    cityWithStateAbbr: "Willow Hill, IL",
  },
  {
    zip: "62481",
    ST: "IL",
    cityWithStateAbbr: "Yale, IL",
  },
  {
    zip: "62501",
    ST: "IL",
    cityWithStateAbbr: "Argenta, IL",
  },
  {
    zip: "62510",
    ST: "IL",
    cityWithStateAbbr: "Assumption, IL",
  },
  {
    zip: "62512",
    ST: "IL",
    cityWithStateAbbr: "Beason, IL",
  },
  {
    zip: "62513",
    ST: "IL",
    cityWithStateAbbr: "Blue Mound, IL",
  },
  {
    zip: "62514",
    ST: "IL",
    cityWithStateAbbr: "Boody, IL",
  },
  {
    zip: "62515",
    ST: "IL",
    cityWithStateAbbr: "Buffalo, IL",
  },
  {
    zip: "62517",
    ST: "IL",
    cityWithStateAbbr: "Bulpitt, IL",
  },
  {
    zip: "62518",
    ST: "IL",
    cityWithStateAbbr: "Chestnut, IL",
  },
  {
    zip: "62519",
    ST: "IL",
    cityWithStateAbbr: "Cornland, IL",
  },
  {
    zip: "62520",
    ST: "IL",
    cityWithStateAbbr: "Dawson, IL",
  },
  {
    zip: "62521",
    ST: "IL",
    cityWithStateAbbr: "Decatur, IL",
  },
  {
    zip: "62522",
    ST: "IL",
    cityWithStateAbbr: "Decatur, IL",
  },
  {
    zip: "62523",
    ST: "IL",
    cityWithStateAbbr: "Decatur, IL",
  },
  {
    zip: "62524",
    ST: "IL",
    cityWithStateAbbr: "Decatur, IL",
  },
  {
    zip: "62525",
    ST: "IL",
    cityWithStateAbbr: "Decatur, IL",
  },
  {
    zip: "62526",
    ST: "IL",
    cityWithStateAbbr: "Decatur, IL",
  },
  {
    zip: "62530",
    ST: "IL",
    cityWithStateAbbr: "Divernon, IL",
  },
  {
    zip: "62531",
    ST: "IL",
    cityWithStateAbbr: "Edinburg, IL",
  },
  {
    zip: "62532",
    ST: "IL",
    cityWithStateAbbr: "Elwin, IL",
  },
  {
    zip: "62533",
    ST: "IL",
    cityWithStateAbbr: "Farmersville, IL",
  },
  {
    zip: "62534",
    ST: "IL",
    cityWithStateAbbr: "Findlay, IL",
  },
  {
    zip: "62535",
    ST: "IL",
    cityWithStateAbbr: "Forsyth, IL",
  },
  {
    zip: "62536",
    ST: "IL",
    cityWithStateAbbr: "Glenarm, IL",
  },
  {
    zip: "62537",
    ST: "IL",
    cityWithStateAbbr: "Harristown, IL",
  },
  {
    zip: "62538",
    ST: "IL",
    cityWithStateAbbr: "Harvel, IL",
  },
  {
    zip: "62539",
    ST: "IL",
    cityWithStateAbbr: "Illiopolis, IL",
  },
  {
    zip: "62540",
    ST: "IL",
    cityWithStateAbbr: "Kincaid, IL",
  },
  {
    zip: "62541",
    ST: "IL",
    cityWithStateAbbr: "Lake Fork, IL",
  },
  {
    zip: "62543",
    ST: "IL",
    cityWithStateAbbr: "Latham, IL",
  },
  {
    zip: "62544",
    ST: "IL",
    cityWithStateAbbr: "Macon, IL",
  },
  {
    zip: "62545",
    ST: "IL",
    cityWithStateAbbr: "Mechanicsburg, IL",
  },
  {
    zip: "62546",
    ST: "IL",
    cityWithStateAbbr: "Morrisonville, IL",
  },
  {
    zip: "62547",
    ST: "IL",
    cityWithStateAbbr: "Mount Auburn, IL",
  },
  {
    zip: "62548",
    ST: "IL",
    cityWithStateAbbr: "Mount Pulaski, IL",
  },
  {
    zip: "62549",
    ST: "IL",
    cityWithStateAbbr: "Mt Zion, IL",
  },
  {
    zip: "62550",
    ST: "IL",
    cityWithStateAbbr: "Moweaqua, IL",
  },
  {
    zip: "62551",
    ST: "IL",
    cityWithStateAbbr: "Niantic, IL",
  },
  {
    zip: "62553",
    ST: "IL",
    cityWithStateAbbr: "Oconee, IL",
  },
  {
    zip: "62554",
    ST: "IL",
    cityWithStateAbbr: "Oreana, IL",
  },
  {
    zip: "62555",
    ST: "IL",
    cityWithStateAbbr: "Owaneco, IL",
  },
  {
    zip: "62556",
    ST: "IL",
    cityWithStateAbbr: "Palmer, IL",
  },
  {
    zip: "62557",
    ST: "IL",
    cityWithStateAbbr: "Pana, IL",
  },
  {
    zip: "62558",
    ST: "IL",
    cityWithStateAbbr: "Pawnee, IL",
  },
  {
    zip: "62560",
    ST: "IL",
    cityWithStateAbbr: "Raymond, IL",
  },
  {
    zip: "62561",
    ST: "IL",
    cityWithStateAbbr: "Riverton, IL",
  },
  {
    zip: "62563",
    ST: "IL",
    cityWithStateAbbr: "Rochester, IL",
  },
  {
    zip: "62565",
    ST: "IL",
    cityWithStateAbbr: "Shelbyville, IL",
  },
  {
    zip: "62567",
    ST: "IL",
    cityWithStateAbbr: "Stonington, IL",
  },
  {
    zip: "62568",
    ST: "IL",
    cityWithStateAbbr: "Taylorville, IL",
  },
  {
    zip: "62570",
    ST: "IL",
    cityWithStateAbbr: "Tovey, IL",
  },
  {
    zip: "62571",
    ST: "IL",
    cityWithStateAbbr: "Tower Hill, IL",
  },
  {
    zip: "62572",
    ST: "IL",
    cityWithStateAbbr: "Waggoner, IL",
  },
  {
    zip: "62573",
    ST: "IL",
    cityWithStateAbbr: "Warrensburg, IL",
  },
  {
    zip: "62601",
    ST: "IL",
    cityWithStateAbbr: "Alexander, IL",
  },
  {
    zip: "62610",
    ST: "IL",
    cityWithStateAbbr: "Alsey, IL",
  },
  {
    zip: "62611",
    ST: "IL",
    cityWithStateAbbr: "Arenzville, IL",
  },
  {
    zip: "62612",
    ST: "IL",
    cityWithStateAbbr: "Ashland, IL",
  },
  {
    zip: "62613",
    ST: "IL",
    cityWithStateAbbr: "Athens, IL",
  },
  {
    zip: "62615",
    ST: "IL",
    cityWithStateAbbr: "Auburn, IL",
  },
  {
    zip: "62617",
    ST: "IL",
    cityWithStateAbbr: "Bath, IL",
  },
  {
    zip: "62618",
    ST: "IL",
    cityWithStateAbbr: "Beardstown, IL",
  },
  {
    zip: "62621",
    ST: "IL",
    cityWithStateAbbr: "Bluffs, IL",
  },
  {
    zip: "62622",
    ST: "IL",
    cityWithStateAbbr: "Bluff Springs, IL",
  },
  {
    zip: "62624",
    ST: "IL",
    cityWithStateAbbr: "Browning, IL",
  },
  {
    zip: "62625",
    ST: "IL",
    cityWithStateAbbr: "Cantrall, IL",
  },
  {
    zip: "62626",
    ST: "IL",
    cityWithStateAbbr: "Carlinville, IL",
  },
  {
    zip: "62627",
    ST: "IL",
    cityWithStateAbbr: "Chandlerville, IL",
  },
  {
    zip: "62628",
    ST: "IL",
    cityWithStateAbbr: "Chapin, IL",
  },
  {
    zip: "62629",
    ST: "IL",
    cityWithStateAbbr: "Chatham, IL",
  },
  {
    zip: "62630",
    ST: "IL",
    cityWithStateAbbr: "Chesterfield, IL",
  },
  {
    zip: "62631",
    ST: "IL",
    cityWithStateAbbr: "Concord, IL",
  },
  {
    zip: "62633",
    ST: "IL",
    cityWithStateAbbr: "Easton, IL",
  },
  {
    zip: "62634",
    ST: "IL",
    cityWithStateAbbr: "Elkhart, IL",
  },
  {
    zip: "62635",
    ST: "IL",
    cityWithStateAbbr: "Emden, IL",
  },
  {
    zip: "62638",
    ST: "IL",
    cityWithStateAbbr: "Franklin, IL",
  },
  {
    zip: "62639",
    ST: "IL",
    cityWithStateAbbr: "Frederick, IL",
  },
  {
    zip: "62640",
    ST: "IL",
    cityWithStateAbbr: "Girard, IL",
  },
  {
    zip: "62642",
    ST: "IL",
    cityWithStateAbbr: "Greenview, IL",
  },
  {
    zip: "62643",
    ST: "IL",
    cityWithStateAbbr: "Hartsburg, IL",
  },
  {
    zip: "62644",
    ST: "IL",
    cityWithStateAbbr: "Havana, IL",
  },
  {
    zip: "62649",
    ST: "IL",
    cityWithStateAbbr: "Hettick, IL",
  },
  {
    zip: "62650",
    ST: "IL",
    cityWithStateAbbr: "Jacksonville, IL",
  },
  {
    zip: "62651",
    ST: "IL",
    cityWithStateAbbr: "Jacksonville, IL",
  },
  {
    zip: "62655",
    ST: "IL",
    cityWithStateAbbr: "Kilbourne, IL",
  },
  {
    zip: "62656",
    ST: "IL",
    cityWithStateAbbr: "Lincoln, IL",
  },
  {
    zip: "62659",
    ST: "IL",
    cityWithStateAbbr: "Lincolns New Salem, IL",
  },
  {
    zip: "62660",
    ST: "IL",
    cityWithStateAbbr: "Literberry, IL",
  },
  {
    zip: "62661",
    ST: "IL",
    cityWithStateAbbr: "Loami, IL",
  },
  {
    zip: "62662",
    ST: "IL",
    cityWithStateAbbr: "Lowder, IL",
  },
  {
    zip: "62663",
    ST: "IL",
    cityWithStateAbbr: "Manchester, IL",
  },
  {
    zip: "62664",
    ST: "IL",
    cityWithStateAbbr: "Mason City, IL",
  },
  {
    zip: "62665",
    ST: "IL",
    cityWithStateAbbr: "Meredosia, IL",
  },
  {
    zip: "62666",
    ST: "IL",
    cityWithStateAbbr: "Middletown, IL",
  },
  {
    zip: "62667",
    ST: "IL",
    cityWithStateAbbr: "Modesto, IL",
  },
  {
    zip: "62668",
    ST: "IL",
    cityWithStateAbbr: "Murrayville, IL",
  },
  {
    zip: "62670",
    ST: "IL",
    cityWithStateAbbr: "New Berlin, IL",
  },
  {
    zip: "62671",
    ST: "IL",
    cityWithStateAbbr: "New Holland, IL",
  },
  {
    zip: "62672",
    ST: "IL",
    cityWithStateAbbr: "Nilwood, IL",
  },
  {
    zip: "62673",
    ST: "IL",
    cityWithStateAbbr: "Oakford, IL",
  },
  {
    zip: "62674",
    ST: "IL",
    cityWithStateAbbr: "Palmyra, IL",
  },
  {
    zip: "62675",
    ST: "IL",
    cityWithStateAbbr: "Petersburg, IL",
  },
  {
    zip: "62677",
    ST: "IL",
    cityWithStateAbbr: "Pleasant Plains, IL",
  },
  {
    zip: "62681",
    ST: "IL",
    cityWithStateAbbr: "Rushville, IL",
  },
  {
    zip: "62682",
    ST: "IL",
    cityWithStateAbbr: "San Jose, IL",
  },
  {
    zip: "62683",
    ST: "IL",
    cityWithStateAbbr: "Scottville, IL",
  },
  {
    zip: "62684",
    ST: "IL",
    cityWithStateAbbr: "Sherman, IL",
  },
  {
    zip: "62685",
    ST: "IL",
    cityWithStateAbbr: "Shipman, IL",
  },
  {
    zip: "62688",
    ST: "IL",
    cityWithStateAbbr: "Tallula, IL",
  },
  {
    zip: "62689",
    ST: "IL",
    cityWithStateAbbr: "Thayer, IL",
  },
  {
    zip: "62690",
    ST: "IL",
    cityWithStateAbbr: "Virden, IL",
  },
  {
    zip: "62691",
    ST: "IL",
    cityWithStateAbbr: "Virginia, IL",
  },
  {
    zip: "62692",
    ST: "IL",
    cityWithStateAbbr: "Waverly, IL",
  },
  {
    zip: "62693",
    ST: "IL",
    cityWithStateAbbr: "Williamsville, IL",
  },
  {
    zip: "62694",
    ST: "IL",
    cityWithStateAbbr: "Winchester, IL",
  },
  {
    zip: "62695",
    ST: "IL",
    cityWithStateAbbr: "Woodson, IL",
  },
  {
    zip: "62701",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62702",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62703",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62704",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62705",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62706",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62707",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62708",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62711",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62712",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62715",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62716",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62719",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62721",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62722",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62723",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62726",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62736",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62739",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62756",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62757",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62761",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62762",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62763",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62764",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62765",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62766",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62767",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62769",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62776",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62777",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62781",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62786",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62791",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62794",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62796",
    ST: "IL",
    cityWithStateAbbr: "Springfield, IL",
  },
  {
    zip: "62801",
    ST: "IL",
    cityWithStateAbbr: "Centralia, IL",
  },
  {
    zip: "62803",
    ST: "IL",
    cityWithStateAbbr: "Hoyleton, IL",
  },
  {
    zip: "62805",
    ST: "IL",
    cityWithStateAbbr: "Thompsonville, IL",
  },
  {
    zip: "62806",
    ST: "IL",
    cityWithStateAbbr: "Albion, IL",
  },
  {
    zip: "62807",
    ST: "IL",
    cityWithStateAbbr: "Alma, IL",
  },
  {
    zip: "62808",
    ST: "IL",
    cityWithStateAbbr: "Ashley, IL",
  },
  {
    zip: "62809",
    ST: "IL",
    cityWithStateAbbr: "Barnhill, IL",
  },
  {
    zip: "62810",
    ST: "IL",
    cityWithStateAbbr: "Belle Rive, IL",
  },
  {
    zip: "62811",
    ST: "IL",
    cityWithStateAbbr: "Bellmont, IL",
  },
  {
    zip: "62812",
    ST: "IL",
    cityWithStateAbbr: "Benton, IL",
  },
  {
    zip: "62814",
    ST: "IL",
    cityWithStateAbbr: "Bluford, IL",
  },
  {
    zip: "62815",
    ST: "IL",
    cityWithStateAbbr: "Bone Gap, IL",
  },
  {
    zip: "62816",
    ST: "IL",
    cityWithStateAbbr: "Bonnie, IL",
  },
  {
    zip: "62817",
    ST: "IL",
    cityWithStateAbbr: "Broughton, IL",
  },
  {
    zip: "62818",
    ST: "IL",
    cityWithStateAbbr: "Browns, IL",
  },
  {
    zip: "62819",
    ST: "IL",
    cityWithStateAbbr: "Buckner, IL",
  },
  {
    zip: "62820",
    ST: "IL",
    cityWithStateAbbr: "Burnt Prairie, IL",
  },
  {
    zip: "62821",
    ST: "IL",
    cityWithStateAbbr: "Carmi, IL",
  },
  {
    zip: "62822",
    ST: "IL",
    cityWithStateAbbr: "Christopher, IL",
  },
  {
    zip: "62823",
    ST: "IL",
    cityWithStateAbbr: "Cisne, IL",
  },
  {
    zip: "62824",
    ST: "IL",
    cityWithStateAbbr: "Clay City, IL",
  },
  {
    zip: "62825",
    ST: "IL",
    cityWithStateAbbr: "Coello, IL",
  },
  {
    zip: "62827",
    ST: "IL",
    cityWithStateAbbr: "Crossville, IL",
  },
  {
    zip: "62828",
    ST: "IL",
    cityWithStateAbbr: "Dahlgren, IL",
  },
  {
    zip: "62829",
    ST: "IL",
    cityWithStateAbbr: "Dale, IL",
  },
  {
    zip: "62830",
    ST: "IL",
    cityWithStateAbbr: "Dix, IL",
  },
  {
    zip: "62831",
    ST: "IL",
    cityWithStateAbbr: "Du Bois, IL",
  },
  {
    zip: "62832",
    ST: "IL",
    cityWithStateAbbr: "Du Quoin, IL",
  },
  {
    zip: "62833",
    ST: "IL",
    cityWithStateAbbr: "Ellery, IL",
  },
  {
    zip: "62834",
    ST: "IL",
    cityWithStateAbbr: "Emma, IL",
  },
  {
    zip: "62835",
    ST: "IL",
    cityWithStateAbbr: "Enfield, IL",
  },
  {
    zip: "62836",
    ST: "IL",
    cityWithStateAbbr: "Ewing, IL",
  },
  {
    zip: "62837",
    ST: "IL",
    cityWithStateAbbr: "Fairfield, IL",
  },
  {
    zip: "62838",
    ST: "IL",
    cityWithStateAbbr: "Farina, IL",
  },
  {
    zip: "62839",
    ST: "IL",
    cityWithStateAbbr: "Flora, IL",
  },
  {
    zip: "62840",
    ST: "IL",
    cityWithStateAbbr: "Frankfort Heights, IL",
  },
  {
    zip: "62841",
    ST: "IL",
    cityWithStateAbbr: "Freeman Spur, IL",
  },
  {
    zip: "62842",
    ST: "IL",
    cityWithStateAbbr: "Geff, IL",
  },
  {
    zip: "62843",
    ST: "IL",
    cityWithStateAbbr: "Golden Gate, IL",
  },
  {
    zip: "62844",
    ST: "IL",
    cityWithStateAbbr: "Grayville, IL",
  },
  {
    zip: "62846",
    ST: "IL",
    cityWithStateAbbr: "Ina, IL",
  },
  {
    zip: "62848",
    ST: "IL",
    cityWithStateAbbr: "Irvington, IL",
  },
  {
    zip: "62849",
    ST: "IL",
    cityWithStateAbbr: "Iuka, IL",
  },
  {
    zip: "62850",
    ST: "IL",
    cityWithStateAbbr: "Johnsonville, IL",
  },
  {
    zip: "62851",
    ST: "IL",
    cityWithStateAbbr: "Keenes, IL",
  },
  {
    zip: "62852",
    ST: "IL",
    cityWithStateAbbr: "Keensburg, IL",
  },
  {
    zip: "62853",
    ST: "IL",
    cityWithStateAbbr: "Kell, IL",
  },
  {
    zip: "62854",
    ST: "IL",
    cityWithStateAbbr: "Kinmundy, IL",
  },
  {
    zip: "62855",
    ST: "IL",
    cityWithStateAbbr: "Lancaster, IL",
  },
  {
    zip: "62856",
    ST: "IL",
    cityWithStateAbbr: "Logan, IL",
  },
  {
    zip: "62857",
    ST: "IL",
    cityWithStateAbbr: "Saint Peter, IL",
  },
  {
    zip: "62858",
    ST: "IL",
    cityWithStateAbbr: "Louisville, IL",
  },
  {
    zip: "62859",
    ST: "IL",
    cityWithStateAbbr: "Mc Leansboro, IL",
  },
  {
    zip: "62860",
    ST: "IL",
    cityWithStateAbbr: "Macedonia, IL",
  },
  {
    zip: "62861",
    ST: "IL",
    cityWithStateAbbr: "Maunie, IL",
  },
  {
    zip: "62862",
    ST: "IL",
    cityWithStateAbbr: "Mill Shoals, IL",
  },
  {
    zip: "62863",
    ST: "IL",
    cityWithStateAbbr: "Mount Carmel, IL",
  },
  {
    zip: "62864",
    ST: "IL",
    cityWithStateAbbr: "Mount Vernon, IL",
  },
  {
    zip: "62865",
    ST: "IL",
    cityWithStateAbbr: "Mulkeytown, IL",
  },
  {
    zip: "62866",
    ST: "IL",
    cityWithStateAbbr: "Nason, IL",
  },
  {
    zip: "62867",
    ST: "IL",
    cityWithStateAbbr: "New Haven, IL",
  },
  {
    zip: "62868",
    ST: "IL",
    cityWithStateAbbr: "Noble, IL",
  },
  {
    zip: "62869",
    ST: "IL",
    cityWithStateAbbr: "Norris City, IL",
  },
  {
    zip: "62870",
    ST: "IL",
    cityWithStateAbbr: "Odin, IL",
  },
  {
    zip: "62871",
    ST: "IL",
    cityWithStateAbbr: "Omaha, IL",
  },
  {
    zip: "62872",
    ST: "IL",
    cityWithStateAbbr: "Opdyke, IL",
  },
  {
    zip: "62874",
    ST: "IL",
    cityWithStateAbbr: "Orient, IL",
  },
  {
    zip: "62875",
    ST: "IL",
    cityWithStateAbbr: "Patoka, IL",
  },
  {
    zip: "62876",
    ST: "IL",
    cityWithStateAbbr: "Radom, IL",
  },
  {
    zip: "62877",
    ST: "IL",
    cityWithStateAbbr: "Richview, IL",
  },
  {
    zip: "62878",
    ST: "IL",
    cityWithStateAbbr: "Rinard, IL",
  },
  {
    zip: "62879",
    ST: "IL",
    cityWithStateAbbr: "Sailor Springs, IL",
  },
  {
    zip: "62880",
    ST: "IL",
    cityWithStateAbbr: "Saint Peter, IL",
  },
  {
    zip: "62881",
    ST: "IL",
    cityWithStateAbbr: "Salem, IL",
  },
  {
    zip: "62882",
    ST: "IL",
    cityWithStateAbbr: "Sandoval, IL",
  },
  {
    zip: "62883",
    ST: "IL",
    cityWithStateAbbr: "Scheller, IL",
  },
  {
    zip: "62884",
    ST: "IL",
    cityWithStateAbbr: "Sesser, IL",
  },
  {
    zip: "62885",
    ST: "IL",
    cityWithStateAbbr: "Shobonier, IL",
  },
  {
    zip: "62886",
    ST: "IL",
    cityWithStateAbbr: "Sims, IL",
  },
  {
    zip: "62887",
    ST: "IL",
    cityWithStateAbbr: "Springerton, IL",
  },
  {
    zip: "62888",
    ST: "IL",
    cityWithStateAbbr: "Tamaroa, IL",
  },
  {
    zip: "62889",
    ST: "IL",
    cityWithStateAbbr: "Texico, IL",
  },
  {
    zip: "62890",
    ST: "IL",
    cityWithStateAbbr: "Thompsonville, IL",
  },
  {
    zip: "62891",
    ST: "IL",
    cityWithStateAbbr: "Valier, IL",
  },
  {
    zip: "62892",
    ST: "IL",
    cityWithStateAbbr: "Vernon, IL",
  },
  {
    zip: "62893",
    ST: "IL",
    cityWithStateAbbr: "Walnut Hill, IL",
  },
  {
    zip: "62894",
    ST: "IL",
    cityWithStateAbbr: "Waltonville, IL",
  },
  {
    zip: "62895",
    ST: "IL",
    cityWithStateAbbr: "Wayne City, IL",
  },
  {
    zip: "62896",
    ST: "IL",
    cityWithStateAbbr: "West Frankfort, IL",
  },
  {
    zip: "62897",
    ST: "IL",
    cityWithStateAbbr: "Whittington, IL",
  },
  {
    zip: "62898",
    ST: "IL",
    cityWithStateAbbr: "Woodlawn, IL",
  },
  {
    zip: "62899",
    ST: "IL",
    cityWithStateAbbr: "Xenia, IL",
  },
  {
    zip: "62901",
    ST: "IL",
    cityWithStateAbbr: "Carbondale, IL",
  },
  {
    zip: "62902",
    ST: "IL",
    cityWithStateAbbr: "Carbondale, IL",
  },
  {
    zip: "62903",
    ST: "IL",
    cityWithStateAbbr: "Carbondale, IL",
  },
  {
    zip: "62905",
    ST: "IL",
    cityWithStateAbbr: "Alto Pass, IL",
  },
  {
    zip: "62906",
    ST: "IL",
    cityWithStateAbbr: "Anna, IL",
  },
  {
    zip: "62907",
    ST: "IL",
    cityWithStateAbbr: "Ava, IL",
  },
  {
    zip: "62908",
    ST: "IL",
    cityWithStateAbbr: "Belknap, IL",
  },
  {
    zip: "62909",
    ST: "IL",
    cityWithStateAbbr: "Boles, IL",
  },
  {
    zip: "62910",
    ST: "IL",
    cityWithStateAbbr: "Brookport, IL",
  },
  {
    zip: "62912",
    ST: "IL",
    cityWithStateAbbr: "Buncombe, IL",
  },
  {
    zip: "62914",
    ST: "IL",
    cityWithStateAbbr: "Cairo, IL",
  },
  {
    zip: "62915",
    ST: "IL",
    cityWithStateAbbr: "Cambria, IL",
  },
  {
    zip: "62916",
    ST: "IL",
    cityWithStateAbbr: "Campbell Hill, IL",
  },
  {
    zip: "62917",
    ST: "IL",
    cityWithStateAbbr: "Carrier Mills, IL",
  },
  {
    zip: "62918",
    ST: "IL",
    cityWithStateAbbr: "Carterville, IL",
  },
  {
    zip: "62919",
    ST: "IL",
    cityWithStateAbbr: "Cave In Rock, IL",
  },
  {
    zip: "62920",
    ST: "IL",
    cityWithStateAbbr: "Cobden, IL",
  },
  {
    zip: "62921",
    ST: "IL",
    cityWithStateAbbr: "Colp, IL",
  },
  {
    zip: "62922",
    ST: "IL",
    cityWithStateAbbr: "Creal Springs, IL",
  },
  {
    zip: "62923",
    ST: "IL",
    cityWithStateAbbr: "Cypress, IL",
  },
  {
    zip: "62924",
    ST: "IL",
    cityWithStateAbbr: "De Soto, IL",
  },
  {
    zip: "62926",
    ST: "IL",
    cityWithStateAbbr: "Dongola, IL",
  },
  {
    zip: "62927",
    ST: "IL",
    cityWithStateAbbr: "Dowell, IL",
  },
  {
    zip: "62928",
    ST: "IL",
    cityWithStateAbbr: "Eddyville, IL",
  },
  {
    zip: "62930",
    ST: "IL",
    cityWithStateAbbr: "Eldorado, IL",
  },
  {
    zip: "62931",
    ST: "IL",
    cityWithStateAbbr: "Elizabethtown, IL",
  },
  {
    zip: "62932",
    ST: "IL",
    cityWithStateAbbr: "Elkville, IL",
  },
  {
    zip: "62933",
    ST: "IL",
    cityWithStateAbbr: "Energy, IL",
  },
  {
    zip: "62934",
    ST: "IL",
    cityWithStateAbbr: "Equality, IL",
  },
  {
    zip: "62935",
    ST: "IL",
    cityWithStateAbbr: "Galatia, IL",
  },
  {
    zip: "62938",
    ST: "IL",
    cityWithStateAbbr: "Golconda, IL",
  },
  {
    zip: "62939",
    ST: "IL",
    cityWithStateAbbr: "Goreville, IL",
  },
  {
    zip: "62940",
    ST: "IL",
    cityWithStateAbbr: "Gorham, IL",
  },
  {
    zip: "62941",
    ST: "IL",
    cityWithStateAbbr: "Grand Chain, IL",
  },
  {
    zip: "62942",
    ST: "IL",
    cityWithStateAbbr: "Grand Tower, IL",
  },
  {
    zip: "62943",
    ST: "IL",
    cityWithStateAbbr: "Grantsburg, IL",
  },
  {
    zip: "62946",
    ST: "IL",
    cityWithStateAbbr: "Harrisburg, IL",
  },
  {
    zip: "62947",
    ST: "IL",
    cityWithStateAbbr: "Herod, IL",
  },
  {
    zip: "62948",
    ST: "IL",
    cityWithStateAbbr: "Herrin, IL",
  },
  {
    zip: "62949",
    ST: "IL",
    cityWithStateAbbr: "Hurst, IL",
  },
  {
    zip: "62950",
    ST: "IL",
    cityWithStateAbbr: "Jacob, IL",
  },
  {
    zip: "62951",
    ST: "IL",
    cityWithStateAbbr: "Johnston City, IL",
  },
  {
    zip: "62952",
    ST: "IL",
    cityWithStateAbbr: "Jonesboro, IL",
  },
  {
    zip: "62953",
    ST: "IL",
    cityWithStateAbbr: "Joppa, IL",
  },
  {
    zip: "62954",
    ST: "IL",
    cityWithStateAbbr: "Junction, IL",
  },
  {
    zip: "62955",
    ST: "IL",
    cityWithStateAbbr: "Karbers Ridge, IL",
  },
  {
    zip: "62956",
    ST: "IL",
    cityWithStateAbbr: "Karnak, IL",
  },
  {
    zip: "62957",
    ST: "IL",
    cityWithStateAbbr: "Mc Clure, IL",
  },
  {
    zip: "62958",
    ST: "IL",
    cityWithStateAbbr: "Makanda, IL",
  },
  {
    zip: "62959",
    ST: "IL",
    cityWithStateAbbr: "Marion, IL",
  },
  {
    zip: "62960",
    ST: "IL",
    cityWithStateAbbr: "Metropolis, IL",
  },
  {
    zip: "62961",
    ST: "IL",
    cityWithStateAbbr: "Millcreek, IL",
  },
  {
    zip: "62962",
    ST: "IL",
    cityWithStateAbbr: "Miller City, IL",
  },
  {
    zip: "62963",
    ST: "IL",
    cityWithStateAbbr: "Mound City, IL",
  },
  {
    zip: "62964",
    ST: "IL",
    cityWithStateAbbr: "Mounds, IL",
  },
  {
    zip: "62965",
    ST: "IL",
    cityWithStateAbbr: "Muddy, IL",
  },
  {
    zip: "62966",
    ST: "IL",
    cityWithStateAbbr: "Murphysboro, IL",
  },
  {
    zip: "62967",
    ST: "IL",
    cityWithStateAbbr: "New Burnside, IL",
  },
  {
    zip: "62969",
    ST: "IL",
    cityWithStateAbbr: "Olive Branch, IL",
  },
  {
    zip: "62970",
    ST: "IL",
    cityWithStateAbbr: "Olmsted, IL",
  },
  {
    zip: "62971",
    ST: "IL",
    cityWithStateAbbr: "Oraville, IL",
  },
  {
    zip: "62972",
    ST: "IL",
    cityWithStateAbbr: "Ozark, IL",
  },
  {
    zip: "62973",
    ST: "IL",
    cityWithStateAbbr: "Perks, IL",
  },
  {
    zip: "62974",
    ST: "IL",
    cityWithStateAbbr: "Pittsburg, IL",
  },
  {
    zip: "62975",
    ST: "IL",
    cityWithStateAbbr: "Pomona, IL",
  },
  {
    zip: "62976",
    ST: "IL",
    cityWithStateAbbr: "Pulaski, IL",
  },
  {
    zip: "62977",
    ST: "IL",
    cityWithStateAbbr: "Raleigh, IL",
  },
  {
    zip: "62979",
    ST: "IL",
    cityWithStateAbbr: "Ridgway, IL",
  },
  {
    zip: "62982",
    ST: "IL",
    cityWithStateAbbr: "Rosiclare, IL",
  },
  {
    zip: "62983",
    ST: "IL",
    cityWithStateAbbr: "Royalton, IL",
  },
  {
    zip: "62984",
    ST: "IL",
    cityWithStateAbbr: "Shawneetown, IL",
  },
  {
    zip: "62985",
    ST: "IL",
    cityWithStateAbbr: "Simpson, IL",
  },
  {
    zip: "62987",
    ST: "IL",
    cityWithStateAbbr: "Stonefort, IL",
  },
  {
    zip: "62988",
    ST: "IL",
    cityWithStateAbbr: "Tamms, IL",
  },
  {
    zip: "62990",
    ST: "IL",
    cityWithStateAbbr: "Thebes, IL",
  },
  {
    zip: "62992",
    ST: "IL",
    cityWithStateAbbr: "Ullin, IL",
  },
  {
    zip: "62993",
    ST: "IL",
    cityWithStateAbbr: "Unity, IL",
  },
  {
    zip: "62994",
    ST: "IL",
    cityWithStateAbbr: "Vergennes, IL",
  },
  {
    zip: "62995",
    ST: "IL",
    cityWithStateAbbr: "Vienna, IL",
  },
  {
    zip: "62996",
    ST: "IL",
    cityWithStateAbbr: "Villa Ridge, IL",
  },
  {
    zip: "62997",
    ST: "IL",
    cityWithStateAbbr: "Willisville, IL",
  },
  {
    zip: "62998",
    ST: "IL",
    cityWithStateAbbr: "Wolf Lake, IL",
  },
  {
    zip: "62999",
    ST: "IL",
    cityWithStateAbbr: "Zeigler, IL",
  },
  {
    zip: "63001",
    ST: "MO",
    cityWithStateAbbr: "Pacific, MO",
  },
  {
    zip: "63005",
    ST: "MO",
    cityWithStateAbbr: "Chesterfield, MO",
  },
  {
    zip: "63006",
    ST: "MO",
    cityWithStateAbbr: "Chesterfield, MO",
  },
  {
    zip: "63010",
    ST: "MO",
    cityWithStateAbbr: "Arnold, MO",
  },
  {
    zip: "63011",
    ST: "MO",
    cityWithStateAbbr: "Ballwin, MO",
  },
  {
    zip: "63012",
    ST: "MO",
    cityWithStateAbbr: "Barnhart, MO",
  },
  {
    zip: "63013",
    ST: "MO",
    cityWithStateAbbr: "Beaufort, MO",
  },
  {
    zip: "63014",
    ST: "MO",
    cityWithStateAbbr: "Berger, MO",
  },
  {
    zip: "63015",
    ST: "MO",
    cityWithStateAbbr: "Catawissa, MO",
  },
  {
    zip: "63016",
    ST: "MO",
    cityWithStateAbbr: "Cedar Hill, MO",
  },
  {
    zip: "63017",
    ST: "MO",
    cityWithStateAbbr: "Chesterfield, MO",
  },
  {
    zip: "63019",
    ST: "MO",
    cityWithStateAbbr: "Crystal City, MO",
  },
  {
    zip: "63020",
    ST: "MO",
    cityWithStateAbbr: "De Soto, MO",
  },
  {
    zip: "63021",
    ST: "MO",
    cityWithStateAbbr: "Ballwin, MO",
  },
  {
    zip: "63022",
    ST: "MO",
    cityWithStateAbbr: "Ballwin, MO",
  },
  {
    zip: "63023",
    ST: "MO",
    cityWithStateAbbr: "Dittmer, MO",
  },
  {
    zip: "63024",
    ST: "MO",
    cityWithStateAbbr: "Ballwin, MO",
  },
  {
    zip: "63025",
    ST: "MO",
    cityWithStateAbbr: "Eureka, MO",
  },
  {
    zip: "63026",
    ST: "MO",
    cityWithStateAbbr: "Fenton, MO",
  },
  {
    zip: "63028",
    ST: "MO",
    cityWithStateAbbr: "Festus, MO",
  },
  {
    zip: "63030",
    ST: "MO",
    cityWithStateAbbr: "Fletcher, MO",
  },
  {
    zip: "63031",
    ST: "MO",
    cityWithStateAbbr: "Florissant, MO",
  },
  {
    zip: "63032",
    ST: "MO",
    cityWithStateAbbr: "Florissant, MO",
  },
  {
    zip: "63033",
    ST: "MO",
    cityWithStateAbbr: "Florissant, MO",
  },
  {
    zip: "63034",
    ST: "MO",
    cityWithStateAbbr: "Florissant, MO",
  },
  {
    zip: "63036",
    ST: "MO",
    cityWithStateAbbr: "French Village, MO",
  },
  {
    zip: "63037",
    ST: "MO",
    cityWithStateAbbr: "Gerald, MO",
  },
  {
    zip: "63038",
    ST: "MO",
    cityWithStateAbbr: "Glencoe, MO",
  },
  {
    zip: "63039",
    ST: "MO",
    cityWithStateAbbr: "Gray Summit, MO",
  },
  {
    zip: "63040",
    ST: "MO",
    cityWithStateAbbr: "Grover, MO",
  },
  {
    zip: "63041",
    ST: "MO",
    cityWithStateAbbr: "Grubville, MO",
  },
  {
    zip: "63042",
    ST: "MO",
    cityWithStateAbbr: "Hazelwood, MO",
  },
  {
    zip: "63043",
    ST: "MO",
    cityWithStateAbbr: "Maryland Heights, MO",
  },
  {
    zip: "63044",
    ST: "MO",
    cityWithStateAbbr: "Bridgeton, MO",
  },
  {
    zip: "63045",
    ST: "MO",
    cityWithStateAbbr: "Earth City, MO",
  },
  {
    zip: "63047",
    ST: "MO",
    cityWithStateAbbr: "Hematite, MO",
  },
  {
    zip: "63048",
    ST: "MO",
    cityWithStateAbbr: "Herculaneum, MO",
  },
  {
    zip: "63049",
    ST: "MO",
    cityWithStateAbbr: "High Ridge, MO",
  },
  {
    zip: "63050",
    ST: "MO",
    cityWithStateAbbr: "Hillsboro, MO",
  },
  {
    zip: "63051",
    ST: "MO",
    cityWithStateAbbr: "House Springs, MO",
  },
  {
    zip: "63052",
    ST: "MO",
    cityWithStateAbbr: "Imperial, MO",
  },
  {
    zip: "63053",
    ST: "MO",
    cityWithStateAbbr: "Kimmswick, MO",
  },
  {
    zip: "63055",
    ST: "MO",
    cityWithStateAbbr: "Labadie, MO",
  },
  {
    zip: "63056",
    ST: "MO",
    cityWithStateAbbr: "Leslie, MO",
  },
  {
    zip: "63057",
    ST: "MO",
    cityWithStateAbbr: "Liguori, MO",
  },
  {
    zip: "63060",
    ST: "MO",
    cityWithStateAbbr: "Lonedell, MO",
  },
  {
    zip: "63061",
    ST: "MO",
    cityWithStateAbbr: "Luebbering, MO",
  },
  {
    zip: "63065",
    ST: "MO",
    cityWithStateAbbr: "Mapaville, MO",
  },
  {
    zip: "63066",
    ST: "MO",
    cityWithStateAbbr: "Morse Mill, MO",
  },
  {
    zip: "63068",
    ST: "MO",
    cityWithStateAbbr: "New Haven, MO",
  },
  {
    zip: "63069",
    ST: "MO",
    cityWithStateAbbr: "Pacific, MO",
  },
  {
    zip: "63070",
    ST: "MO",
    cityWithStateAbbr: "Pevely, MO",
  },
  {
    zip: "63071",
    ST: "MO",
    cityWithStateAbbr: "Richwoods, MO",
  },
  {
    zip: "63072",
    ST: "MO",
    cityWithStateAbbr: "Robertsville, MO",
  },
  {
    zip: "63073",
    ST: "MO",
    cityWithStateAbbr: "Saint Albans, MO",
  },
  {
    zip: "63074",
    ST: "MO",
    cityWithStateAbbr: "Saint Ann, MO",
  },
  {
    zip: "63077",
    ST: "MO",
    cityWithStateAbbr: "Saint Clair, MO",
  },
  {
    zip: "63079",
    ST: "MO",
    cityWithStateAbbr: "Stanton, MO",
  },
  {
    zip: "63080",
    ST: "MO",
    cityWithStateAbbr: "Sullivan, MO",
  },
  {
    zip: "63084",
    ST: "MO",
    cityWithStateAbbr: "Union, MO",
  },
  {
    zip: "63087",
    ST: "MO",
    cityWithStateAbbr: "Valles Mines, MO",
  },
  {
    zip: "63088",
    ST: "MO",
    cityWithStateAbbr: "Valley Park, MO",
  },
  {
    zip: "63089",
    ST: "MO",
    cityWithStateAbbr: "Villa Ridge, MO",
  },
  {
    zip: "63090",
    ST: "MO",
    cityWithStateAbbr: "Washington, MO",
  },
  {
    zip: "63091",
    ST: "MO",
    cityWithStateAbbr: "Rosebud, MO",
  },
  {
    zip: "63099",
    ST: "MO",
    cityWithStateAbbr: "Fenton, MO",
  },
  {
    zip: "63101",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63102",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63103",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63104",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63105",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63106",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63107",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63108",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63109",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63110",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63111",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63112",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63113",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63114",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63115",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63116",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63117",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63118",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63119",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63120",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63121",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63122",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63123",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63124",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63125",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63126",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63127",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63128",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63129",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63130",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63131",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63132",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63133",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63134",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63135",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63136",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63137",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63138",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63139",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63140",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63141",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63143",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63144",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63145",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63146",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63147",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63150",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63151",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63155",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63156",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63157",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63158",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63160",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63163",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63164",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63166",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63167",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63169",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63171",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63177",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63178",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63179",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63180",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63182",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63188",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63195",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63197",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63199",
    ST: "MO",
    cityWithStateAbbr: "Saint Louis, MO",
  },
  {
    zip: "63301",
    ST: "MO",
    cityWithStateAbbr: "Saint Charles, MO",
  },
  {
    zip: "63302",
    ST: "MO",
    cityWithStateAbbr: "Saint Charles, MO",
  },
  {
    zip: "63303",
    ST: "MO",
    cityWithStateAbbr: "Saint Charles, MO",
  },
  {
    zip: "63304",
    ST: "MO",
    cityWithStateAbbr: "Saint Charles, MO",
  },
  {
    zip: "63330",
    ST: "MO",
    cityWithStateAbbr: "Annada, MO",
  },
  {
    zip: "63332",
    ST: "MO",
    cityWithStateAbbr: "Augusta, MO",
  },
  {
    zip: "63333",
    ST: "MO",
    cityWithStateAbbr: "Bellflower, MO",
  },
  {
    zip: "63334",
    ST: "MO",
    cityWithStateAbbr: "Bowling Green, MO",
  },
  {
    zip: "63336",
    ST: "MO",
    cityWithStateAbbr: "Clarksville, MO",
  },
  {
    zip: "63338",
    ST: "MO",
    cityWithStateAbbr: "Cottleville, MO",
  },
  {
    zip: "63339",
    ST: "MO",
    cityWithStateAbbr: "Curryville, MO",
  },
  {
    zip: "63341",
    ST: "MO",
    cityWithStateAbbr: "Defiance, MO",
  },
  {
    zip: "63342",
    ST: "MO",
    cityWithStateAbbr: "Dutzow, MO",
  },
  {
    zip: "63343",
    ST: "MO",
    cityWithStateAbbr: "Elsberry, MO",
  },
  {
    zip: "63344",
    ST: "MO",
    cityWithStateAbbr: "Eolia, MO",
  },
  {
    zip: "63345",
    ST: "MO",
    cityWithStateAbbr: "Farber, MO",
  },
  {
    zip: "63346",
    ST: "MO",
    cityWithStateAbbr: "Flinthill, MO",
  },
  {
    zip: "63347",
    ST: "MO",
    cityWithStateAbbr: "Foley, MO",
  },
  {
    zip: "63348",
    ST: "MO",
    cityWithStateAbbr: "Foristell, MO",
  },
  {
    zip: "63349",
    ST: "MO",
    cityWithStateAbbr: "Hawk Point, MO",
  },
  {
    zip: "63350",
    ST: "MO",
    cityWithStateAbbr: "High Hill, MO",
  },
  {
    zip: "63351",
    ST: "MO",
    cityWithStateAbbr: "Jonesburg, MO",
  },
  {
    zip: "63352",
    ST: "MO",
    cityWithStateAbbr: "Laddonia, MO",
  },
  {
    zip: "63353",
    ST: "MO",
    cityWithStateAbbr: "Louisiana, MO",
  },
  {
    zip: "63357",
    ST: "MO",
    cityWithStateAbbr: "Marthasville, MO",
  },
  {
    zip: "63359",
    ST: "MO",
    cityWithStateAbbr: "Middletown, MO",
  },
  {
    zip: "63361",
    ST: "MO",
    cityWithStateAbbr: "Montgomery City, MO",
  },
  {
    zip: "63362",
    ST: "MO",
    cityWithStateAbbr: "Moscow Mills, MO",
  },
  {
    zip: "63363",
    ST: "MO",
    cityWithStateAbbr: "New Florence, MO",
  },
  {
    zip: "63365",
    ST: "MO",
    cityWithStateAbbr: "New Melle, MO",
  },
  {
    zip: "63366",
    ST: "MO",
    cityWithStateAbbr: "O Fallon, MO",
  },
  {
    zip: "63367",
    ST: "MO",
    cityWithStateAbbr: "Lake Saint Louis, MO",
  },
  {
    zip: "63368",
    ST: "MO",
    cityWithStateAbbr: "O Fallon, MO",
  },
  {
    zip: "63369",
    ST: "MO",
    cityWithStateAbbr: "Old Monroe, MO",
  },
  {
    zip: "63370",
    ST: "MO",
    cityWithStateAbbr: "Olney, MO",
  },
  {
    zip: "63373",
    ST: "MO",
    cityWithStateAbbr: "Portage Des Sioux, MO",
  },
  {
    zip: "63376",
    ST: "MO",
    cityWithStateAbbr: "Saint Peters, MO",
  },
  {
    zip: "63377",
    ST: "MO",
    cityWithStateAbbr: "Silex, MO",
  },
  {
    zip: "63378",
    ST: "MO",
    cityWithStateAbbr: "Treloar, MO",
  },
  {
    zip: "63379",
    ST: "MO",
    cityWithStateAbbr: "Troy, MO",
  },
  {
    zip: "63380",
    ST: "MO",
    cityWithStateAbbr: "Truesdale, MO",
  },
  {
    zip: "63381",
    ST: "MO",
    cityWithStateAbbr: "Truxton, MO",
  },
  {
    zip: "63382",
    ST: "MO",
    cityWithStateAbbr: "Vandalia, MO",
  },
  {
    zip: "63383",
    ST: "MO",
    cityWithStateAbbr: "Warrenton, MO",
  },
  {
    zip: "63384",
    ST: "MO",
    cityWithStateAbbr: "Wellsville, MO",
  },
  {
    zip: "63385",
    ST: "MO",
    cityWithStateAbbr: "Wentzville, MO",
  },
  {
    zip: "63386",
    ST: "MO",
    cityWithStateAbbr: "West Alton, MO",
  },
  {
    zip: "63387",
    ST: "MO",
    cityWithStateAbbr: "Whiteside, MO",
  },
  {
    zip: "63388",
    ST: "MO",
    cityWithStateAbbr: "Williamsburg, MO",
  },
  {
    zip: "63389",
    ST: "MO",
    cityWithStateAbbr: "Winfield, MO",
  },
  {
    zip: "63390",
    ST: "MO",
    cityWithStateAbbr: "Wright City, MO",
  },
  {
    zip: "63401",
    ST: "MO",
    cityWithStateAbbr: "Hannibal, MO",
  },
  {
    zip: "63430",
    ST: "MO",
    cityWithStateAbbr: "Alexandria, MO",
  },
  {
    zip: "63431",
    ST: "MO",
    cityWithStateAbbr: "Anabel, MO",
  },
  {
    zip: "63432",
    ST: "MO",
    cityWithStateAbbr: "Arbela, MO",
  },
  {
    zip: "63433",
    ST: "MO",
    cityWithStateAbbr: "Ashburn, MO",
  },
  {
    zip: "63434",
    ST: "MO",
    cityWithStateAbbr: "Bethel, MO",
  },
  {
    zip: "63435",
    ST: "MO",
    cityWithStateAbbr: "Canton, MO",
  },
  {
    zip: "63436",
    ST: "MO",
    cityWithStateAbbr: "Center, MO",
  },
  {
    zip: "63437",
    ST: "MO",
    cityWithStateAbbr: "Clarence, MO",
  },
  {
    zip: "63438",
    ST: "MO",
    cityWithStateAbbr: "Durham, MO",
  },
  {
    zip: "63439",
    ST: "MO",
    cityWithStateAbbr: "Emden, MO",
  },
  {
    zip: "63440",
    ST: "MO",
    cityWithStateAbbr: "Ewing, MO",
  },
  {
    zip: "63441",
    ST: "MO",
    cityWithStateAbbr: "Frankford, MO",
  },
  {
    zip: "63442",
    ST: "MO",
    cityWithStateAbbr: "Granger, MO",
  },
  {
    zip: "63443",
    ST: "MO",
    cityWithStateAbbr: "Hunnewell, MO",
  },
  {
    zip: "63445",
    ST: "MO",
    cityWithStateAbbr: "Kahoka, MO",
  },
  {
    zip: "63446",
    ST: "MO",
    cityWithStateAbbr: "Knox City, MO",
  },
  {
    zip: "63447",
    ST: "MO",
    cityWithStateAbbr: "La Belle, MO",
  },
  {
    zip: "63448",
    ST: "MO",
    cityWithStateAbbr: "La Grange, MO",
  },
  {
    zip: "63450",
    ST: "MO",
    cityWithStateAbbr: "Lentner, MO",
  },
  {
    zip: "63451",
    ST: "MO",
    cityWithStateAbbr: "Leonard, MO",
  },
  {
    zip: "63452",
    ST: "MO",
    cityWithStateAbbr: "Lewistown, MO",
  },
  {
    zip: "63453",
    ST: "MO",
    cityWithStateAbbr: "Luray, MO",
  },
  {
    zip: "63454",
    ST: "MO",
    cityWithStateAbbr: "Maywood, MO",
  },
  {
    zip: "63456",
    ST: "MO",
    cityWithStateAbbr: "Monroe City, MO",
  },
  {
    zip: "63457",
    ST: "MO",
    cityWithStateAbbr: "Monticello, MO",
  },
  {
    zip: "63458",
    ST: "MO",
    cityWithStateAbbr: "Newark, MO",
  },
  {
    zip: "63459",
    ST: "MO",
    cityWithStateAbbr: "New London, MO",
  },
  {
    zip: "63460",
    ST: "MO",
    cityWithStateAbbr: "Novelty, MO",
  },
  {
    zip: "63461",
    ST: "MO",
    cityWithStateAbbr: "Palmyra, MO",
  },
  {
    zip: "63462",
    ST: "MO",
    cityWithStateAbbr: "Perry, MO",
  },
  {
    zip: "63463",
    ST: "MO",
    cityWithStateAbbr: "Philadelphia, MO",
  },
  {
    zip: "63464",
    ST: "MO",
    cityWithStateAbbr: "Plevna, MO",
  },
  {
    zip: "63465",
    ST: "MO",
    cityWithStateAbbr: "Revere, MO",
  },
  {
    zip: "63466",
    ST: "MO",
    cityWithStateAbbr: "Saint Patrick, MO",
  },
  {
    zip: "63467",
    ST: "MO",
    cityWithStateAbbr: "Saverton, MO",
  },
  {
    zip: "63468",
    ST: "MO",
    cityWithStateAbbr: "Shelbina, MO",
  },
  {
    zip: "63469",
    ST: "MO",
    cityWithStateAbbr: "Shelbyville, MO",
  },
  {
    zip: "63471",
    ST: "MO",
    cityWithStateAbbr: "Taylor, MO",
  },
  {
    zip: "63472",
    ST: "MO",
    cityWithStateAbbr: "Wayland, MO",
  },
  {
    zip: "63473",
    ST: "MO",
    cityWithStateAbbr: "Williamstown, MO",
  },
  {
    zip: "63474",
    ST: "MO",
    cityWithStateAbbr: "Wyaconda, MO",
  },
  {
    zip: "63501",
    ST: "MO",
    cityWithStateAbbr: "Kirksville, MO",
  },
  {
    zip: "63530",
    ST: "MO",
    cityWithStateAbbr: "Atlanta, MO",
  },
  {
    zip: "63531",
    ST: "MO",
    cityWithStateAbbr: "Baring, MO",
  },
  {
    zip: "63532",
    ST: "MO",
    cityWithStateAbbr: "Bevier, MO",
  },
  {
    zip: "63533",
    ST: "MO",
    cityWithStateAbbr: "Brashear, MO",
  },
  {
    zip: "63534",
    ST: "MO",
    cityWithStateAbbr: "Callao, MO",
  },
  {
    zip: "63535",
    ST: "MO",
    cityWithStateAbbr: "Coatsville, MO",
  },
  {
    zip: "63536",
    ST: "MO",
    cityWithStateAbbr: "Downing, MO",
  },
  {
    zip: "63537",
    ST: "MO",
    cityWithStateAbbr: "Edina, MO",
  },
  {
    zip: "63538",
    ST: "MO",
    cityWithStateAbbr: "Elmer, MO",
  },
  {
    zip: "63539",
    ST: "MO",
    cityWithStateAbbr: "Ethel, MO",
  },
  {
    zip: "63540",
    ST: "MO",
    cityWithStateAbbr: "Gibbs, MO",
  },
  {
    zip: "63541",
    ST: "MO",
    cityWithStateAbbr: "Glenwood, MO",
  },
  {
    zip: "63543",
    ST: "MO",
    cityWithStateAbbr: "Gorin, MO",
  },
  {
    zip: "63544",
    ST: "MO",
    cityWithStateAbbr: "Green Castle, MO",
  },
  {
    zip: "63545",
    ST: "MO",
    cityWithStateAbbr: "Green City, MO",
  },
  {
    zip: "63546",
    ST: "MO",
    cityWithStateAbbr: "Greentop, MO",
  },
  {
    zip: "63547",
    ST: "MO",
    cityWithStateAbbr: "Hurdland, MO",
  },
  {
    zip: "63548",
    ST: "MO",
    cityWithStateAbbr: "Lancaster, MO",
  },
  {
    zip: "63549",
    ST: "MO",
    cityWithStateAbbr: "La Plata, MO",
  },
  {
    zip: "63551",
    ST: "MO",
    cityWithStateAbbr: "Livonia, MO",
  },
  {
    zip: "63552",
    ST: "MO",
    cityWithStateAbbr: "Macon, MO",
  },
  {
    zip: "63555",
    ST: "MO",
    cityWithStateAbbr: "Memphis, MO",
  },
  {
    zip: "63556",
    ST: "MO",
    cityWithStateAbbr: "Milan, MO",
  },
  {
    zip: "63557",
    ST: "MO",
    cityWithStateAbbr: "New Boston, MO",
  },
  {
    zip: "63558",
    ST: "MO",
    cityWithStateAbbr: "New Cambria, MO",
  },
  {
    zip: "63559",
    ST: "MO",
    cityWithStateAbbr: "Novinger, MO",
  },
  {
    zip: "63560",
    ST: "MO",
    cityWithStateAbbr: "Pollock, MO",
  },
  {
    zip: "63561",
    ST: "MO",
    cityWithStateAbbr: "Queen City, MO",
  },
  {
    zip: "63563",
    ST: "MO",
    cityWithStateAbbr: "Rutledge, MO",
  },
  {
    zip: "63565",
    ST: "MO",
    cityWithStateAbbr: "Unionville, MO",
  },
  {
    zip: "63566",
    ST: "MO",
    cityWithStateAbbr: "Winigan, MO",
  },
  {
    zip: "63567",
    ST: "MO",
    cityWithStateAbbr: "Worthington, MO",
  },
  {
    zip: "63601",
    ST: "MO",
    cityWithStateAbbr: "Park Hills, MO",
  },
  {
    zip: "63620",
    ST: "MO",
    cityWithStateAbbr: "Annapolis, MO",
  },
  {
    zip: "63621",
    ST: "MO",
    cityWithStateAbbr: "Arcadia, MO",
  },
  {
    zip: "63622",
    ST: "MO",
    cityWithStateAbbr: "Belgrade, MO",
  },
  {
    zip: "63623",
    ST: "MO",
    cityWithStateAbbr: "Belleview, MO",
  },
  {
    zip: "63624",
    ST: "MO",
    cityWithStateAbbr: "Bismarck, MO",
  },
  {
    zip: "63625",
    ST: "MO",
    cityWithStateAbbr: "Black, MO",
  },
  {
    zip: "63626",
    ST: "MO",
    cityWithStateAbbr: "Blackwell, MO",
  },
  {
    zip: "63627",
    ST: "MO",
    cityWithStateAbbr: "Bloomsdale, MO",
  },
  {
    zip: "63628",
    ST: "MO",
    cityWithStateAbbr: "Bonne Terre, MO",
  },
  {
    zip: "63629",
    ST: "MO",
    cityWithStateAbbr: "Bunker, MO",
  },
  {
    zip: "63630",
    ST: "MO",
    cityWithStateAbbr: "Cadet, MO",
  },
  {
    zip: "63631",
    ST: "MO",
    cityWithStateAbbr: "Caledonia, MO",
  },
  {
    zip: "63632",
    ST: "MO",
    cityWithStateAbbr: "Cascade, MO",
  },
  {
    zip: "63633",
    ST: "MO",
    cityWithStateAbbr: "Centerville, MO",
  },
  {
    zip: "63636",
    ST: "MO",
    cityWithStateAbbr: "Des Arc, MO",
  },
  {
    zip: "63637",
    ST: "MO",
    cityWithStateAbbr: "Doe Run, MO",
  },
  {
    zip: "63638",
    ST: "MO",
    cityWithStateAbbr: "Ellington, MO",
  },
  {
    zip: "63640",
    ST: "MO",
    cityWithStateAbbr: "Farmington, MO",
  },
  {
    zip: "63645",
    ST: "MO",
    cityWithStateAbbr: "Fredericktown, MO",
  },
  {
    zip: "63648",
    ST: "MO",
    cityWithStateAbbr: "Irondale, MO",
  },
  {
    zip: "63650",
    ST: "MO",
    cityWithStateAbbr: "Ironton, MO",
  },
  {
    zip: "63651",
    ST: "MO",
    cityWithStateAbbr: "Knob Lick, MO",
  },
  {
    zip: "63653",
    ST: "MO",
    cityWithStateAbbr: "Leadwood, MO",
  },
  {
    zip: "63654",
    ST: "MO",
    cityWithStateAbbr: "Lesterville, MO",
  },
  {
    zip: "63655",
    ST: "MO",
    cityWithStateAbbr: "Marquand, MO",
  },
  {
    zip: "63656",
    ST: "MO",
    cityWithStateAbbr: "Middle Brook, MO",
  },
  {
    zip: "63660",
    ST: "MO",
    cityWithStateAbbr: "Mineral Point, MO",
  },
  {
    zip: "63662",
    ST: "MO",
    cityWithStateAbbr: "Patton, MO",
  },
  {
    zip: "63663",
    ST: "MO",
    cityWithStateAbbr: "Pilot Knob, MO",
  },
  {
    zip: "63664",
    ST: "MO",
    cityWithStateAbbr: "Potosi, MO",
  },
  {
    zip: "63665",
    ST: "MO",
    cityWithStateAbbr: "Redford, MO",
  },
  {
    zip: "63666",
    ST: "MO",
    cityWithStateAbbr: "Reynolds, MO",
  },
  {
    zip: "63670",
    ST: "MO",
    cityWithStateAbbr: "Sainte Genevieve, MO",
  },
  {
    zip: "63673",
    ST: "MO",
    cityWithStateAbbr: "Saint Mary, MO",
  },
  {
    zip: "63674",
    ST: "MO",
    cityWithStateAbbr: "Tiff, MO",
  },
  {
    zip: "63675",
    ST: "MO",
    cityWithStateAbbr: "Vulcan, MO",
  },
  {
    zip: "63701",
    ST: "MO",
    cityWithStateAbbr: "Cape Girardeau, MO",
  },
  {
    zip: "63702",
    ST: "MO",
    cityWithStateAbbr: "Cape Girardeau, MO",
  },
  {
    zip: "63703",
    ST: "MO",
    cityWithStateAbbr: "Cape Girardeau, MO",
  },
  {
    zip: "63730",
    ST: "MO",
    cityWithStateAbbr: "Advance, MO",
  },
  {
    zip: "63732",
    ST: "MO",
    cityWithStateAbbr: "Altenburg, MO",
  },
  {
    zip: "63735",
    ST: "MO",
    cityWithStateAbbr: "Bell City, MO",
  },
  {
    zip: "63736",
    ST: "MO",
    cityWithStateAbbr: "Benton, MO",
  },
  {
    zip: "63737",
    ST: "MO",
    cityWithStateAbbr: "Brazeau, MO",
  },
  {
    zip: "63738",
    ST: "MO",
    cityWithStateAbbr: "Brownwood, MO",
  },
  {
    zip: "63739",
    ST: "MO",
    cityWithStateAbbr: "Burfordville, MO",
  },
  {
    zip: "63740",
    ST: "MO",
    cityWithStateAbbr: "Chaffee, MO",
  },
  {
    zip: "63742",
    ST: "MO",
    cityWithStateAbbr: "Commerce, MO",
  },
  {
    zip: "63743",
    ST: "MO",
    cityWithStateAbbr: "Daisy, MO",
  },
  {
    zip: "63744",
    ST: "MO",
    cityWithStateAbbr: "Delta, MO",
  },
  {
    zip: "63745",
    ST: "MO",
    cityWithStateAbbr: "Dutchtown, MO",
  },
  {
    zip: "63746",
    ST: "MO",
    cityWithStateAbbr: "Farrar, MO",
  },
  {
    zip: "63747",
    ST: "MO",
    cityWithStateAbbr: "Friedheim, MO",
  },
  {
    zip: "63748",
    ST: "MO",
    cityWithStateAbbr: "Frohna, MO",
  },
  {
    zip: "63750",
    ST: "MO",
    cityWithStateAbbr: "Gipsy, MO",
  },
  {
    zip: "63751",
    ST: "MO",
    cityWithStateAbbr: "Glenallen, MO",
  },
  {
    zip: "63752",
    ST: "MO",
    cityWithStateAbbr: "Gordonville, MO",
  },
  {
    zip: "63755",
    ST: "MO",
    cityWithStateAbbr: "Jackson, MO",
  },
  {
    zip: "63758",
    ST: "MO",
    cityWithStateAbbr: "Kelso, MO",
  },
  {
    zip: "63760",
    ST: "MO",
    cityWithStateAbbr: "Leopold, MO",
  },
  {
    zip: "63763",
    ST: "MO",
    cityWithStateAbbr: "Mc Gee, MO",
  },
  {
    zip: "63764",
    ST: "MO",
    cityWithStateAbbr: "Marble Hill, MO",
  },
  {
    zip: "63766",
    ST: "MO",
    cityWithStateAbbr: "Millersville, MO",
  },
  {
    zip: "63767",
    ST: "MO",
    cityWithStateAbbr: "Morley, MO",
  },
  {
    zip: "63769",
    ST: "MO",
    cityWithStateAbbr: "Oak Ridge, MO",
  },
  {
    zip: "63770",
    ST: "MO",
    cityWithStateAbbr: "Old Appleton, MO",
  },
  {
    zip: "63771",
    ST: "MO",
    cityWithStateAbbr: "Oran, MO",
  },
  {
    zip: "63774",
    ST: "MO",
    cityWithStateAbbr: "Perkins, MO",
  },
  {
    zip: "63775",
    ST: "MO",
    cityWithStateAbbr: "Perryville, MO",
  },
  {
    zip: "63776",
    ST: "MO",
    cityWithStateAbbr: "Mc Bride, MO",
  },
  {
    zip: "63779",
    ST: "MO",
    cityWithStateAbbr: "Pocahontas, MO",
  },
  {
    zip: "63780",
    ST: "MO",
    cityWithStateAbbr: "Scott City, MO",
  },
  {
    zip: "63781",
    ST: "MO",
    cityWithStateAbbr: "Sedgewickville, MO",
  },
  {
    zip: "63782",
    ST: "MO",
    cityWithStateAbbr: "Sturdivant, MO",
  },
  {
    zip: "63783",
    ST: "MO",
    cityWithStateAbbr: "Uniontown, MO",
  },
  {
    zip: "63784",
    ST: "MO",
    cityWithStateAbbr: "Vanduser, MO",
  },
  {
    zip: "63785",
    ST: "MO",
    cityWithStateAbbr: "Whitewater, MO",
  },
  {
    zip: "63787",
    ST: "MO",
    cityWithStateAbbr: "Zalma, MO",
  },
  {
    zip: "63801",
    ST: "MO",
    cityWithStateAbbr: "Sikeston, MO",
  },
  {
    zip: "63820",
    ST: "MO",
    cityWithStateAbbr: "Anniston, MO",
  },
  {
    zip: "63821",
    ST: "MO",
    cityWithStateAbbr: "Arbyrd, MO",
  },
  {
    zip: "63822",
    ST: "MO",
    cityWithStateAbbr: "Bernie, MO",
  },
  {
    zip: "63823",
    ST: "MO",
    cityWithStateAbbr: "Bertrand, MO",
  },
  {
    zip: "63824",
    ST: "MO",
    cityWithStateAbbr: "Blodgett, MO",
  },
  {
    zip: "63825",
    ST: "MO",
    cityWithStateAbbr: "Bloomfield, MO",
  },
  {
    zip: "63826",
    ST: "MO",
    cityWithStateAbbr: "Braggadocio, MO",
  },
  {
    zip: "63827",
    ST: "MO",
    cityWithStateAbbr: "Bragg City, MO",
  },
  {
    zip: "63828",
    ST: "MO",
    cityWithStateAbbr: "Canalou, MO",
  },
  {
    zip: "63829",
    ST: "MO",
    cityWithStateAbbr: "Cardwell, MO",
  },
  {
    zip: "63830",
    ST: "MO",
    cityWithStateAbbr: "Caruthersville, MO",
  },
  {
    zip: "63833",
    ST: "MO",
    cityWithStateAbbr: "Catron, MO",
  },
  {
    zip: "63834",
    ST: "MO",
    cityWithStateAbbr: "Charleston, MO",
  },
  {
    zip: "63837",
    ST: "MO",
    cityWithStateAbbr: "Clarkton, MO",
  },
  {
    zip: "63839",
    ST: "MO",
    cityWithStateAbbr: "Cooter, MO",
  },
  {
    zip: "63840",
    ST: "MO",
    cityWithStateAbbr: "Deering, MO",
  },
  {
    zip: "63841",
    ST: "MO",
    cityWithStateAbbr: "Dexter, MO",
  },
  {
    zip: "63845",
    ST: "MO",
    cityWithStateAbbr: "East Prairie, MO",
  },
  {
    zip: "63846",
    ST: "MO",
    cityWithStateAbbr: "Essex, MO",
  },
  {
    zip: "63847",
    ST: "MO",
    cityWithStateAbbr: "Gibson, MO",
  },
  {
    zip: "63848",
    ST: "MO",
    cityWithStateAbbr: "Gideon, MO",
  },
  {
    zip: "63849",
    ST: "MO",
    cityWithStateAbbr: "Gobler, MO",
  },
  {
    zip: "63850",
    ST: "MO",
    cityWithStateAbbr: "Grayridge, MO",
  },
  {
    zip: "63851",
    ST: "MO",
    cityWithStateAbbr: "Hayti, MO",
  },
  {
    zip: "63852",
    ST: "MO",
    cityWithStateAbbr: "Holcomb, MO",
  },
  {
    zip: "63853",
    ST: "MO",
    cityWithStateAbbr: "Holland, MO",
  },
  {
    zip: "63855",
    ST: "MO",
    cityWithStateAbbr: "Hornersville, MO",
  },
  {
    zip: "63857",
    ST: "MO",
    cityWithStateAbbr: "Kennett, MO",
  },
  {
    zip: "63860",
    ST: "MO",
    cityWithStateAbbr: "Kewanee, MO",
  },
  {
    zip: "63862",
    ST: "MO",
    cityWithStateAbbr: "Lilbourn, MO",
  },
  {
    zip: "63863",
    ST: "MO",
    cityWithStateAbbr: "Malden, MO",
  },
  {
    zip: "63866",
    ST: "MO",
    cityWithStateAbbr: "Marston, MO",
  },
  {
    zip: "63867",
    ST: "MO",
    cityWithStateAbbr: "Matthews, MO",
  },
  {
    zip: "63868",
    ST: "MO",
    cityWithStateAbbr: "Morehouse, MO",
  },
  {
    zip: "63869",
    ST: "MO",
    cityWithStateAbbr: "New Madrid, MO",
  },
  {
    zip: "63870",
    ST: "MO",
    cityWithStateAbbr: "Parma, MO",
  },
  {
    zip: "63873",
    ST: "MO",
    cityWithStateAbbr: "Portageville, MO",
  },
  {
    zip: "63874",
    ST: "MO",
    cityWithStateAbbr: "Risco, MO",
  },
  {
    zip: "63875",
    ST: "MO",
    cityWithStateAbbr: "Rives, MO",
  },
  {
    zip: "63876",
    ST: "MO",
    cityWithStateAbbr: "Senath, MO",
  },
  {
    zip: "63877",
    ST: "MO",
    cityWithStateAbbr: "Steele, MO",
  },
  {
    zip: "63878",
    ST: "MO",
    cityWithStateAbbr: "Tallapoosa, MO",
  },
  {
    zip: "63879",
    ST: "MO",
    cityWithStateAbbr: "Wardell, MO",
  },
  {
    zip: "63880",
    ST: "MO",
    cityWithStateAbbr: "Whiteoak, MO",
  },
  {
    zip: "63881",
    ST: "MO",
    cityWithStateAbbr: "Wolf Island, MO",
  },
  {
    zip: "63882",
    ST: "MO",
    cityWithStateAbbr: "Wyatt, MO",
  },
  {
    zip: "63901",
    ST: "MO",
    cityWithStateAbbr: "Poplar Bluff, MO",
  },
  {
    zip: "63902",
    ST: "MO",
    cityWithStateAbbr: "Poplar Bluff, MO",
  },
  {
    zip: "63931",
    ST: "MO",
    cityWithStateAbbr: "Briar, MO",
  },
  {
    zip: "63932",
    ST: "MO",
    cityWithStateAbbr: "Broseley, MO",
  },
  {
    zip: "63933",
    ST: "MO",
    cityWithStateAbbr: "Campbell, MO",
  },
  {
    zip: "63934",
    ST: "MO",
    cityWithStateAbbr: "Clubb, MO",
  },
  {
    zip: "63935",
    ST: "MO",
    cityWithStateAbbr: "Doniphan, MO",
  },
  {
    zip: "63936",
    ST: "MO",
    cityWithStateAbbr: "Dudley, MO",
  },
  {
    zip: "63937",
    ST: "MO",
    cityWithStateAbbr: "Ellsinore, MO",
  },
  {
    zip: "63938",
    ST: "MO",
    cityWithStateAbbr: "Fagus, MO",
  },
  {
    zip: "63939",
    ST: "MO",
    cityWithStateAbbr: "Fairdealing, MO",
  },
  {
    zip: "63940",
    ST: "MO",
    cityWithStateAbbr: "Fisk, MO",
  },
  {
    zip: "63941",
    ST: "MO",
    cityWithStateAbbr: "Fremont, MO",
  },
  {
    zip: "63942",
    ST: "MO",
    cityWithStateAbbr: "Gatewood, MO",
  },
  {
    zip: "63943",
    ST: "MO",
    cityWithStateAbbr: "Grandin, MO",
  },
  {
    zip: "63944",
    ST: "MO",
    cityWithStateAbbr: "Greenville, MO",
  },
  {
    zip: "63945",
    ST: "MO",
    cityWithStateAbbr: "Harviell, MO",
  },
  {
    zip: "63950",
    ST: "MO",
    cityWithStateAbbr: "Lodi, MO",
  },
  {
    zip: "63951",
    ST: "MO",
    cityWithStateAbbr: "Lowndes, MO",
  },
  {
    zip: "63952",
    ST: "MO",
    cityWithStateAbbr: "Mill Spring, MO",
  },
  {
    zip: "63953",
    ST: "MO",
    cityWithStateAbbr: "Naylor, MO",
  },
  {
    zip: "63954",
    ST: "MO",
    cityWithStateAbbr: "Neelyville, MO",
  },
  {
    zip: "63955",
    ST: "MO",
    cityWithStateAbbr: "Oxly, MO",
  },
  {
    zip: "63956",
    ST: "MO",
    cityWithStateAbbr: "Patterson, MO",
  },
  {
    zip: "63957",
    ST: "MO",
    cityWithStateAbbr: "Piedmont, MO",
  },
  {
    zip: "63960",
    ST: "MO",
    cityWithStateAbbr: "Puxico, MO",
  },
  {
    zip: "63961",
    ST: "MO",
    cityWithStateAbbr: "Qulin, MO",
  },
  {
    zip: "63962",
    ST: "MO",
    cityWithStateAbbr: "Rombauer, MO",
  },
  {
    zip: "63963",
    ST: "MO",
    cityWithStateAbbr: "Shook, MO",
  },
  {
    zip: "63964",
    ST: "MO",
    cityWithStateAbbr: "Silva, MO",
  },
  {
    zip: "63965",
    ST: "MO",
    cityWithStateAbbr: "Van Buren, MO",
  },
  {
    zip: "63966",
    ST: "MO",
    cityWithStateAbbr: "Wappapello, MO",
  },
  {
    zip: "63967",
    ST: "MO",
    cityWithStateAbbr: "Williamsville, MO",
  },
  {
    zip: "64001",
    ST: "MO",
    cityWithStateAbbr: "Alma, MO",
  },
  {
    zip: "64011",
    ST: "MO",
    cityWithStateAbbr: "Bates City, MO",
  },
  {
    zip: "64012",
    ST: "MO",
    cityWithStateAbbr: "Belton, MO",
  },
  {
    zip: "64013",
    ST: "MO",
    cityWithStateAbbr: "Blue Springs, MO",
  },
  {
    zip: "64014",
    ST: "MO",
    cityWithStateAbbr: "Blue Springs, MO",
  },
  {
    zip: "64015",
    ST: "MO",
    cityWithStateAbbr: "Blue Springs, MO",
  },
  {
    zip: "64016",
    ST: "MO",
    cityWithStateAbbr: "Buckner, MO",
  },
  {
    zip: "64017",
    ST: "MO",
    cityWithStateAbbr: "Camden, MO",
  },
  {
    zip: "64018",
    ST: "MO",
    cityWithStateAbbr: "Camden Point, MO",
  },
  {
    zip: "64019",
    ST: "MO",
    cityWithStateAbbr: "Centerview, MO",
  },
  {
    zip: "64020",
    ST: "MO",
    cityWithStateAbbr: "Concordia, MO",
  },
  {
    zip: "64021",
    ST: "MO",
    cityWithStateAbbr: "Corder, MO",
  },
  {
    zip: "64022",
    ST: "MO",
    cityWithStateAbbr: "Dover, MO",
  },
  {
    zip: "64024",
    ST: "MO",
    cityWithStateAbbr: "Excelsior Springs, MO",
  },
  {
    zip: "64028",
    ST: "MO",
    cityWithStateAbbr: "Farley, MO",
  },
  {
    zip: "64029",
    ST: "MO",
    cityWithStateAbbr: "Grain Valley, MO",
  },
  {
    zip: "64030",
    ST: "MO",
    cityWithStateAbbr: "Grandview, MO",
  },
  {
    zip: "64034",
    ST: "MO",
    cityWithStateAbbr: "Greenwood, MO",
  },
  {
    zip: "64035",
    ST: "MO",
    cityWithStateAbbr: "Hardin, MO",
  },
  {
    zip: "64036",
    ST: "MO",
    cityWithStateAbbr: "Henrietta, MO",
  },
  {
    zip: "64037",
    ST: "MO",
    cityWithStateAbbr: "Higginsville, MO",
  },
  {
    zip: "64040",
    ST: "MO",
    cityWithStateAbbr: "Holden, MO",
  },
  {
    zip: "64048",
    ST: "MO",
    cityWithStateAbbr: "Holt, MO",
  },
  {
    zip: "64050",
    ST: "MO",
    cityWithStateAbbr: "Independence, MO",
  },
  {
    zip: "64051",
    ST: "MO",
    cityWithStateAbbr: "Independence, MO",
  },
  {
    zip: "64052",
    ST: "MO",
    cityWithStateAbbr: "Independence, MO",
  },
  {
    zip: "64053",
    ST: "MO",
    cityWithStateAbbr: "Independence, MO",
  },
  {
    zip: "64054",
    ST: "MO",
    cityWithStateAbbr: "Independence, MO",
  },
  {
    zip: "64055",
    ST: "MO",
    cityWithStateAbbr: "Independence, MO",
  },
  {
    zip: "64056",
    ST: "MO",
    cityWithStateAbbr: "Independence, MO",
  },
  {
    zip: "64057",
    ST: "MO",
    cityWithStateAbbr: "Independence, MO",
  },
  {
    zip: "64058",
    ST: "MO",
    cityWithStateAbbr: "Independence, MO",
  },
  {
    zip: "64060",
    ST: "MO",
    cityWithStateAbbr: "Kearney, MO",
  },
  {
    zip: "64061",
    ST: "MO",
    cityWithStateAbbr: "Kingsville, MO",
  },
  {
    zip: "64062",
    ST: "MO",
    cityWithStateAbbr: "Lawson, MO",
  },
  {
    zip: "64063",
    ST: "MO",
    cityWithStateAbbr: "Lees Summit, MO",
  },
  {
    zip: "64064",
    ST: "MO",
    cityWithStateAbbr: "Lees Summit, MO",
  },
  {
    zip: "64065",
    ST: "MO",
    cityWithStateAbbr: "Lees Summit, MO",
  },
  {
    zip: "64066",
    ST: "MO",
    cityWithStateAbbr: "Levasy, MO",
  },
  {
    zip: "64067",
    ST: "MO",
    cityWithStateAbbr: "Lexington, MO",
  },
  {
    zip: "64068",
    ST: "MO",
    cityWithStateAbbr: "Liberty, MO",
  },
  {
    zip: "64069",
    ST: "MO",
    cityWithStateAbbr: "Liberty, MO",
  },
  {
    zip: "64070",
    ST: "MO",
    cityWithStateAbbr: "Lone Jack, MO",
  },
  {
    zip: "64071",
    ST: "MO",
    cityWithStateAbbr: "Mayview, MO",
  },
  {
    zip: "64072",
    ST: "MO",
    cityWithStateAbbr: "Missouri City, MO",
  },
  {
    zip: "64073",
    ST: "MO",
    cityWithStateAbbr: "Mosby, MO",
  },
  {
    zip: "64074",
    ST: "MO",
    cityWithStateAbbr: "Napoleon, MO",
  },
  {
    zip: "64075",
    ST: "MO",
    cityWithStateAbbr: "Oak Grove, MO",
  },
  {
    zip: "64076",
    ST: "MO",
    cityWithStateAbbr: "Odessa, MO",
  },
  {
    zip: "64077",
    ST: "MO",
    cityWithStateAbbr: "Orrick, MO",
  },
  {
    zip: "64078",
    ST: "MO",
    cityWithStateAbbr: "Peculiar, MO",
  },
  {
    zip: "64079",
    ST: "MO",
    cityWithStateAbbr: "Platte City, MO",
  },
  {
    zip: "64080",
    ST: "MO",
    cityWithStateAbbr: "Pleasant Hill, MO",
  },
  {
    zip: "64081",
    ST: "MO",
    cityWithStateAbbr: "Lees Summit, MO",
  },
  {
    zip: "64082",
    ST: "MO",
    cityWithStateAbbr: "Lees Summit, MO",
  },
  {
    zip: "64083",
    ST: "MO",
    cityWithStateAbbr: "Raymore, MO",
  },
  {
    zip: "64084",
    ST: "MO",
    cityWithStateAbbr: "Rayville, MO",
  },
  {
    zip: "64085",
    ST: "MO",
    cityWithStateAbbr: "Richmond, MO",
  },
  {
    zip: "64086",
    ST: "MO",
    cityWithStateAbbr: "Lees Summit, MO",
  },
  {
    zip: "64088",
    ST: "MO",
    cityWithStateAbbr: "Sibley, MO",
  },
  {
    zip: "64089",
    ST: "MO",
    cityWithStateAbbr: "Smithville, MO",
  },
  {
    zip: "64090",
    ST: "MO",
    cityWithStateAbbr: "Strasburg, MO",
  },
  {
    zip: "64092",
    ST: "MO",
    cityWithStateAbbr: "Waldron, MO",
  },
  {
    zip: "64093",
    ST: "MO",
    cityWithStateAbbr: "Warrensburg, MO",
  },
  {
    zip: "64096",
    ST: "MO",
    cityWithStateAbbr: "Waverly, MO",
  },
  {
    zip: "64097",
    ST: "MO",
    cityWithStateAbbr: "Wellington, MO",
  },
  {
    zip: "64098",
    ST: "MO",
    cityWithStateAbbr: "Weston, MO",
  },
  {
    zip: "64101",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64102",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64105",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64106",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64108",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64109",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64110",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64111",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64112",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64113",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64114",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64116",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64117",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64118",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64119",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64120",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64121",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64123",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64124",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64125",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64126",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64127",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64128",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64129",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64130",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64131",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64132",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64133",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64134",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64136",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64137",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64138",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64139",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64141",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64144",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64145",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64146",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64147",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64148",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64149",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64150",
    ST: "MO",
    cityWithStateAbbr: "Riverside, MO",
  },
  {
    zip: "64151",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64152",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64153",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64154",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64155",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64156",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64157",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64158",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64161",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64163",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64164",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64165",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64166",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64167",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64168",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64170",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64171",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64179",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64180",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64184",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64187",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64188",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64190",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64191",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64192",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64195",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64196",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64197",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64198",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64199",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "64401",
    ST: "MO",
    cityWithStateAbbr: "Agency, MO",
  },
  {
    zip: "64402",
    ST: "MO",
    cityWithStateAbbr: "Albany, MO",
  },
  {
    zip: "64420",
    ST: "MO",
    cityWithStateAbbr: "Allendale, MO",
  },
  {
    zip: "64421",
    ST: "MO",
    cityWithStateAbbr: "Amazonia, MO",
  },
  {
    zip: "64422",
    ST: "MO",
    cityWithStateAbbr: "Amity, MO",
  },
  {
    zip: "64423",
    ST: "MO",
    cityWithStateAbbr: "Barnard, MO",
  },
  {
    zip: "64424",
    ST: "MO",
    cityWithStateAbbr: "Bethany, MO",
  },
  {
    zip: "64426",
    ST: "MO",
    cityWithStateAbbr: "Blythedale, MO",
  },
  {
    zip: "64427",
    ST: "MO",
    cityWithStateAbbr: "Bolckow, MO",
  },
  {
    zip: "64428",
    ST: "MO",
    cityWithStateAbbr: "Burlington Junction, MO",
  },
  {
    zip: "64429",
    ST: "MO",
    cityWithStateAbbr: "Cameron, MO",
  },
  {
    zip: "64430",
    ST: "MO",
    cityWithStateAbbr: "Clarksdale, MO",
  },
  {
    zip: "64431",
    ST: "MO",
    cityWithStateAbbr: "Clearmont, MO",
  },
  {
    zip: "64432",
    ST: "MO",
    cityWithStateAbbr: "Clyde, MO",
  },
  {
    zip: "64433",
    ST: "MO",
    cityWithStateAbbr: "Conception, MO",
  },
  {
    zip: "64434",
    ST: "MO",
    cityWithStateAbbr: "Conception Junction, MO",
  },
  {
    zip: "64436",
    ST: "MO",
    cityWithStateAbbr: "Cosby, MO",
  },
  {
    zip: "64437",
    ST: "MO",
    cityWithStateAbbr: "Craig, MO",
  },
  {
    zip: "64438",
    ST: "MO",
    cityWithStateAbbr: "Darlington, MO",
  },
  {
    zip: "64439",
    ST: "MO",
    cityWithStateAbbr: "Dearborn, MO",
  },
  {
    zip: "64440",
    ST: "MO",
    cityWithStateAbbr: "De Kalb, MO",
  },
  {
    zip: "64441",
    ST: "MO",
    cityWithStateAbbr: "Denver, MO",
  },
  {
    zip: "64442",
    ST: "MO",
    cityWithStateAbbr: "Eagleville, MO",
  },
  {
    zip: "64443",
    ST: "MO",
    cityWithStateAbbr: "Easton, MO",
  },
  {
    zip: "64444",
    ST: "MO",
    cityWithStateAbbr: "Edgerton, MO",
  },
  {
    zip: "64445",
    ST: "MO",
    cityWithStateAbbr: "Elmo, MO",
  },
  {
    zip: "64446",
    ST: "MO",
    cityWithStateAbbr: "Fairfax, MO",
  },
  {
    zip: "64448",
    ST: "MO",
    cityWithStateAbbr: "Faucett, MO",
  },
  {
    zip: "64449",
    ST: "MO",
    cityWithStateAbbr: "Fillmore, MO",
  },
  {
    zip: "64451",
    ST: "MO",
    cityWithStateAbbr: "Forest City, MO",
  },
  {
    zip: "64453",
    ST: "MO",
    cityWithStateAbbr: "Gentry, MO",
  },
  {
    zip: "64454",
    ST: "MO",
    cityWithStateAbbr: "Gower, MO",
  },
  {
    zip: "64455",
    ST: "MO",
    cityWithStateAbbr: "Graham, MO",
  },
  {
    zip: "64456",
    ST: "MO",
    cityWithStateAbbr: "Grant City, MO",
  },
  {
    zip: "64457",
    ST: "MO",
    cityWithStateAbbr: "Guilford, MO",
  },
  {
    zip: "64458",
    ST: "MO",
    cityWithStateAbbr: "Hatfield, MO",
  },
  {
    zip: "64459",
    ST: "MO",
    cityWithStateAbbr: "Helena, MO",
  },
  {
    zip: "64461",
    ST: "MO",
    cityWithStateAbbr: "Hopkins, MO",
  },
  {
    zip: "64463",
    ST: "MO",
    cityWithStateAbbr: "King City, MO",
  },
  {
    zip: "64465",
    ST: "MO",
    cityWithStateAbbr: "Lathrop, MO",
  },
  {
    zip: "64466",
    ST: "MO",
    cityWithStateAbbr: "Maitland, MO",
  },
  {
    zip: "64467",
    ST: "MO",
    cityWithStateAbbr: "Martinsville, MO",
  },
  {
    zip: "64468",
    ST: "MO",
    cityWithStateAbbr: "Maryville, MO",
  },
  {
    zip: "64469",
    ST: "MO",
    cityWithStateAbbr: "Maysville, MO",
  },
  {
    zip: "64470",
    ST: "MO",
    cityWithStateAbbr: "Mound City, MO",
  },
  {
    zip: "64471",
    ST: "MO",
    cityWithStateAbbr: "New Hampton, MO",
  },
  {
    zip: "64473",
    ST: "MO",
    cityWithStateAbbr: "Oregon, MO",
  },
  {
    zip: "64474",
    ST: "MO",
    cityWithStateAbbr: "Osborn, MO",
  },
  {
    zip: "64475",
    ST: "MO",
    cityWithStateAbbr: "Parnell, MO",
  },
  {
    zip: "64476",
    ST: "MO",
    cityWithStateAbbr: "Pickering, MO",
  },
  {
    zip: "64477",
    ST: "MO",
    cityWithStateAbbr: "Plattsburg, MO",
  },
  {
    zip: "64479",
    ST: "MO",
    cityWithStateAbbr: "Ravenwood, MO",
  },
  {
    zip: "64480",
    ST: "MO",
    cityWithStateAbbr: "Rea, MO",
  },
  {
    zip: "64481",
    ST: "MO",
    cityWithStateAbbr: "Ridgeway, MO",
  },
  {
    zip: "64482",
    ST: "MO",
    cityWithStateAbbr: "Rock Port, MO",
  },
  {
    zip: "64483",
    ST: "MO",
    cityWithStateAbbr: "Rosendale, MO",
  },
  {
    zip: "64484",
    ST: "MO",
    cityWithStateAbbr: "Rushville, MO",
  },
  {
    zip: "64485",
    ST: "MO",
    cityWithStateAbbr: "Savannah, MO",
  },
  {
    zip: "64486",
    ST: "MO",
    cityWithStateAbbr: "Sheridan, MO",
  },
  {
    zip: "64487",
    ST: "MO",
    cityWithStateAbbr: "Skidmore, MO",
  },
  {
    zip: "64489",
    ST: "MO",
    cityWithStateAbbr: "Stanberry, MO",
  },
  {
    zip: "64490",
    ST: "MO",
    cityWithStateAbbr: "Stewartsville, MO",
  },
  {
    zip: "64491",
    ST: "MO",
    cityWithStateAbbr: "Tarkio, MO",
  },
  {
    zip: "64492",
    ST: "MO",
    cityWithStateAbbr: "Trimble, MO",
  },
  {
    zip: "64493",
    ST: "MO",
    cityWithStateAbbr: "Turney, MO",
  },
  {
    zip: "64494",
    ST: "MO",
    cityWithStateAbbr: "Union Star, MO",
  },
  {
    zip: "64496",
    ST: "MO",
    cityWithStateAbbr: "Watson, MO",
  },
  {
    zip: "64497",
    ST: "MO",
    cityWithStateAbbr: "Weatherby, MO",
  },
  {
    zip: "64498",
    ST: "MO",
    cityWithStateAbbr: "Westboro, MO",
  },
  {
    zip: "64499",
    ST: "MO",
    cityWithStateAbbr: "Worth, MO",
  },
  {
    zip: "64501",
    ST: "MO",
    cityWithStateAbbr: "Saint Joseph, MO",
  },
  {
    zip: "64502",
    ST: "MO",
    cityWithStateAbbr: "Saint Joseph, MO",
  },
  {
    zip: "64503",
    ST: "MO",
    cityWithStateAbbr: "Saint Joseph, MO",
  },
  {
    zip: "64504",
    ST: "MO",
    cityWithStateAbbr: "Saint Joseph, MO",
  },
  {
    zip: "64505",
    ST: "MO",
    cityWithStateAbbr: "Saint Joseph, MO",
  },
  {
    zip: "64506",
    ST: "MO",
    cityWithStateAbbr: "Saint Joseph, MO",
  },
  {
    zip: "64507",
    ST: "MO",
    cityWithStateAbbr: "Saint Joseph, MO",
  },
  {
    zip: "64508",
    ST: "MO",
    cityWithStateAbbr: "Saint Joseph, MO",
  },
  {
    zip: "64601",
    ST: "MO",
    cityWithStateAbbr: "Chillicothe, MO",
  },
  {
    zip: "64620",
    ST: "MO",
    cityWithStateAbbr: "Altamont, MO",
  },
  {
    zip: "64622",
    ST: "MO",
    cityWithStateAbbr: "Bogard, MO",
  },
  {
    zip: "64623",
    ST: "MO",
    cityWithStateAbbr: "Bosworth, MO",
  },
  {
    zip: "64624",
    ST: "MO",
    cityWithStateAbbr: "Braymer, MO",
  },
  {
    zip: "64625",
    ST: "MO",
    cityWithStateAbbr: "Breckenridge, MO",
  },
  {
    zip: "64628",
    ST: "MO",
    cityWithStateAbbr: "Brookfield, MO",
  },
  {
    zip: "64630",
    ST: "MO",
    cityWithStateAbbr: "Browning, MO",
  },
  {
    zip: "64631",
    ST: "MO",
    cityWithStateAbbr: "Bucklin, MO",
  },
  {
    zip: "64632",
    ST: "MO",
    cityWithStateAbbr: "Cainsville, MO",
  },
  {
    zip: "64633",
    ST: "MO",
    cityWithStateAbbr: "Carrollton, MO",
  },
  {
    zip: "64635",
    ST: "MO",
    cityWithStateAbbr: "Chula, MO",
  },
  {
    zip: "64636",
    ST: "MO",
    cityWithStateAbbr: "Coffey, MO",
  },
  {
    zip: "64637",
    ST: "MO",
    cityWithStateAbbr: "Cowgill, MO",
  },
  {
    zip: "64638",
    ST: "MO",
    cityWithStateAbbr: "Dawn, MO",
  },
  {
    zip: "64639",
    ST: "MO",
    cityWithStateAbbr: "De Witt, MO",
  },
  {
    zip: "64640",
    ST: "MO",
    cityWithStateAbbr: "Gallatin, MO",
  },
  {
    zip: "64641",
    ST: "MO",
    cityWithStateAbbr: "Galt, MO",
  },
  {
    zip: "64642",
    ST: "MO",
    cityWithStateAbbr: "Gilman City, MO",
  },
  {
    zip: "64643",
    ST: "MO",
    cityWithStateAbbr: "Hale, MO",
  },
  {
    zip: "64644",
    ST: "MO",
    cityWithStateAbbr: "Hamilton, MO",
  },
  {
    zip: "64645",
    ST: "MO",
    cityWithStateAbbr: "Harris, MO",
  },
  {
    zip: "64646",
    ST: "MO",
    cityWithStateAbbr: "Humphreys, MO",
  },
  {
    zip: "64647",
    ST: "MO",
    cityWithStateAbbr: "Jameson, MO",
  },
  {
    zip: "64648",
    ST: "MO",
    cityWithStateAbbr: "Jamesport, MO",
  },
  {
    zip: "64649",
    ST: "MO",
    cityWithStateAbbr: "Kidder, MO",
  },
  {
    zip: "64650",
    ST: "MO",
    cityWithStateAbbr: "Kingston, MO",
  },
  {
    zip: "64651",
    ST: "MO",
    cityWithStateAbbr: "Laclede, MO",
  },
  {
    zip: "64652",
    ST: "MO",
    cityWithStateAbbr: "Laredo, MO",
  },
  {
    zip: "64653",
    ST: "MO",
    cityWithStateAbbr: "Linneus, MO",
  },
  {
    zip: "64654",
    ST: "MO",
    cityWithStateAbbr: "Lock Springs, MO",
  },
  {
    zip: "64655",
    ST: "MO",
    cityWithStateAbbr: "Lucerne, MO",
  },
  {
    zip: "64656",
    ST: "MO",
    cityWithStateAbbr: "Ludlow, MO",
  },
  {
    zip: "64657",
    ST: "MO",
    cityWithStateAbbr: "Mc Fall, MO",
  },
  {
    zip: "64658",
    ST: "MO",
    cityWithStateAbbr: "Marceline, MO",
  },
  {
    zip: "64659",
    ST: "MO",
    cityWithStateAbbr: "Meadville, MO",
  },
  {
    zip: "64660",
    ST: "MO",
    cityWithStateAbbr: "Mendon, MO",
  },
  {
    zip: "64661",
    ST: "MO",
    cityWithStateAbbr: "Mercer, MO",
  },
  {
    zip: "64664",
    ST: "MO",
    cityWithStateAbbr: "Mooresville, MO",
  },
  {
    zip: "64667",
    ST: "MO",
    cityWithStateAbbr: "Newtown, MO",
  },
  {
    zip: "64668",
    ST: "MO",
    cityWithStateAbbr: "Norborne, MO",
  },
  {
    zip: "64670",
    ST: "MO",
    cityWithStateAbbr: "Pattonsburg, MO",
  },
  {
    zip: "64671",
    ST: "MO",
    cityWithStateAbbr: "Polo, MO",
  },
  {
    zip: "64672",
    ST: "MO",
    cityWithStateAbbr: "Powersville, MO",
  },
  {
    zip: "64673",
    ST: "MO",
    cityWithStateAbbr: "Princeton, MO",
  },
  {
    zip: "64674",
    ST: "MO",
    cityWithStateAbbr: "Purdin, MO",
  },
  {
    zip: "64676",
    ST: "MO",
    cityWithStateAbbr: "Rothville, MO",
  },
  {
    zip: "64679",
    ST: "MO",
    cityWithStateAbbr: "Spickard, MO",
  },
  {
    zip: "64680",
    ST: "MO",
    cityWithStateAbbr: "Stet, MO",
  },
  {
    zip: "64681",
    ST: "MO",
    cityWithStateAbbr: "Sumner, MO",
  },
  {
    zip: "64682",
    ST: "MO",
    cityWithStateAbbr: "Tina, MO",
  },
  {
    zip: "64683",
    ST: "MO",
    cityWithStateAbbr: "Trenton, MO",
  },
  {
    zip: "64686",
    ST: "MO",
    cityWithStateAbbr: "Utica, MO",
  },
  {
    zip: "64688",
    ST: "MO",
    cityWithStateAbbr: "Wheeling, MO",
  },
  {
    zip: "64689",
    ST: "MO",
    cityWithStateAbbr: "Winston, MO",
  },
  {
    zip: "64701",
    ST: "MO",
    cityWithStateAbbr: "Harrisonville, MO",
  },
  {
    zip: "64720",
    ST: "MO",
    cityWithStateAbbr: "Adrian, MO",
  },
  {
    zip: "64722",
    ST: "MO",
    cityWithStateAbbr: "Amoret, MO",
  },
  {
    zip: "64723",
    ST: "MO",
    cityWithStateAbbr: "Amsterdam, MO",
  },
  {
    zip: "64724",
    ST: "MO",
    cityWithStateAbbr: "Appleton City, MO",
  },
  {
    zip: "64725",
    ST: "MO",
    cityWithStateAbbr: "Archie, MO",
  },
  {
    zip: "64726",
    ST: "MO",
    cityWithStateAbbr: "Blairstown, MO",
  },
  {
    zip: "64728",
    ST: "MO",
    cityWithStateAbbr: "Bronaugh, MO",
  },
  {
    zip: "64730",
    ST: "MO",
    cityWithStateAbbr: "Butler, MO",
  },
  {
    zip: "64733",
    ST: "MO",
    cityWithStateAbbr: "Chilhowee, MO",
  },
  {
    zip: "64734",
    ST: "MO",
    cityWithStateAbbr: "Cleveland, MO",
  },
  {
    zip: "64735",
    ST: "MO",
    cityWithStateAbbr: "Clinton, MO",
  },
  {
    zip: "64738",
    ST: "MO",
    cityWithStateAbbr: "Collins, MO",
  },
  {
    zip: "64739",
    ST: "MO",
    cityWithStateAbbr: "Creighton, MO",
  },
  {
    zip: "64740",
    ST: "MO",
    cityWithStateAbbr: "Deepwater, MO",
  },
  {
    zip: "64741",
    ST: "MO",
    cityWithStateAbbr: "Deerfield, MO",
  },
  {
    zip: "64742",
    ST: "MO",
    cityWithStateAbbr: "Drexel, MO",
  },
  {
    zip: "64743",
    ST: "MO",
    cityWithStateAbbr: "East Lynne, MO",
  },
  {
    zip: "64744",
    ST: "MO",
    cityWithStateAbbr: "El Dorado Springs, MO",
  },
  {
    zip: "64745",
    ST: "MO",
    cityWithStateAbbr: "Foster, MO",
  },
  {
    zip: "64746",
    ST: "MO",
    cityWithStateAbbr: "Freeman, MO",
  },
  {
    zip: "64747",
    ST: "MO",
    cityWithStateAbbr: "Garden City, MO",
  },
  {
    zip: "64748",
    ST: "MO",
    cityWithStateAbbr: "Golden City, MO",
  },
  {
    zip: "64750",
    ST: "MO",
    cityWithStateAbbr: "Harwood, MO",
  },
  {
    zip: "64752",
    ST: "MO",
    cityWithStateAbbr: "Hume, MO",
  },
  {
    zip: "64755",
    ST: "MO",
    cityWithStateAbbr: "Jasper, MO",
  },
  {
    zip: "64756",
    ST: "MO",
    cityWithStateAbbr: "Jerico Springs, MO",
  },
  {
    zip: "64759",
    ST: "MO",
    cityWithStateAbbr: "Lamar, MO",
  },
  {
    zip: "64761",
    ST: "MO",
    cityWithStateAbbr: "Leeton, MO",
  },
  {
    zip: "64762",
    ST: "MO",
    cityWithStateAbbr: "Liberal, MO",
  },
  {
    zip: "64763",
    ST: "MO",
    cityWithStateAbbr: "Lowry City, MO",
  },
  {
    zip: "64765",
    ST: "MO",
    cityWithStateAbbr: "Metz, MO",
  },
  {
    zip: "64766",
    ST: "MO",
    cityWithStateAbbr: "Milford, MO",
  },
  {
    zip: "64767",
    ST: "MO",
    cityWithStateAbbr: "Milo, MO",
  },
  {
    zip: "64769",
    ST: "MO",
    cityWithStateAbbr: "Mindenmines, MO",
  },
  {
    zip: "64770",
    ST: "MO",
    cityWithStateAbbr: "Montrose, MO",
  },
  {
    zip: "64771",
    ST: "MO",
    cityWithStateAbbr: "Moundville, MO",
  },
  {
    zip: "64772",
    ST: "MO",
    cityWithStateAbbr: "Nevada, MO",
  },
  {
    zip: "64776",
    ST: "MO",
    cityWithStateAbbr: "Osceola, MO",
  },
  {
    zip: "64778",
    ST: "MO",
    cityWithStateAbbr: "Richards, MO",
  },
  {
    zip: "64779",
    ST: "MO",
    cityWithStateAbbr: "Rich Hill, MO",
  },
  {
    zip: "64780",
    ST: "MO",
    cityWithStateAbbr: "Rockville, MO",
  },
  {
    zip: "64781",
    ST: "MO",
    cityWithStateAbbr: "Roscoe, MO",
  },
  {
    zip: "64783",
    ST: "MO",
    cityWithStateAbbr: "Schell City, MO",
  },
  {
    zip: "64784",
    ST: "MO",
    cityWithStateAbbr: "Sheldon, MO",
  },
  {
    zip: "64788",
    ST: "MO",
    cityWithStateAbbr: "Urich, MO",
  },
  {
    zip: "64790",
    ST: "MO",
    cityWithStateAbbr: "Walker, MO",
  },
  {
    zip: "64801",
    ST: "MO",
    cityWithStateAbbr: "Joplin, MO",
  },
  {
    zip: "64802",
    ST: "MO",
    cityWithStateAbbr: "Joplin, MO",
  },
  {
    zip: "64803",
    ST: "MO",
    cityWithStateAbbr: "Joplin, MO",
  },
  {
    zip: "64804",
    ST: "MO",
    cityWithStateAbbr: "Joplin, MO",
  },
  {
    zip: "64830",
    ST: "MO",
    cityWithStateAbbr: "Alba, MO",
  },
  {
    zip: "64831",
    ST: "MO",
    cityWithStateAbbr: "Anderson, MO",
  },
  {
    zip: "64832",
    ST: "MO",
    cityWithStateAbbr: "Asbury, MO",
  },
  {
    zip: "64833",
    ST: "MO",
    cityWithStateAbbr: "Avilla, MO",
  },
  {
    zip: "64834",
    ST: "MO",
    cityWithStateAbbr: "Carl Junction, MO",
  },
  {
    zip: "64835",
    ST: "MO",
    cityWithStateAbbr: "Carterville, MO",
  },
  {
    zip: "64836",
    ST: "MO",
    cityWithStateAbbr: "Carthage, MO",
  },
  {
    zip: "64840",
    ST: "MO",
    cityWithStateAbbr: "Diamond, MO",
  },
  {
    zip: "64841",
    ST: "MO",
    cityWithStateAbbr: "Duenweg, MO",
  },
  {
    zip: "64842",
    ST: "MO",
    cityWithStateAbbr: "Fairview, MO",
  },
  {
    zip: "64843",
    ST: "MO",
    cityWithStateAbbr: "Goodman, MO",
  },
  {
    zip: "64844",
    ST: "MO",
    cityWithStateAbbr: "Granby, MO",
  },
  {
    zip: "64847",
    ST: "MO",
    cityWithStateAbbr: "Lanagan, MO",
  },
  {
    zip: "64848",
    ST: "MO",
    cityWithStateAbbr: "La Russell, MO",
  },
  {
    zip: "64849",
    ST: "MO",
    cityWithStateAbbr: "Neck City, MO",
  },
  {
    zip: "64850",
    ST: "MO",
    cityWithStateAbbr: "Neosho, MO",
  },
  {
    zip: "64853",
    ST: "MO",
    cityWithStateAbbr: "Newtonia, MO",
  },
  {
    zip: "64854",
    ST: "MO",
    cityWithStateAbbr: "Noel, MO",
  },
  {
    zip: "64855",
    ST: "MO",
    cityWithStateAbbr: "Oronogo, MO",
  },
  {
    zip: "64856",
    ST: "MO",
    cityWithStateAbbr: "Pineville, MO",
  },
  {
    zip: "64857",
    ST: "MO",
    cityWithStateAbbr: "Purcell, MO",
  },
  {
    zip: "64858",
    ST: "MO",
    cityWithStateAbbr: "Racine, MO",
  },
  {
    zip: "64859",
    ST: "MO",
    cityWithStateAbbr: "Reeds, MO",
  },
  {
    zip: "64861",
    ST: "MO",
    cityWithStateAbbr: "Rocky Comfort, MO",
  },
  {
    zip: "64862",
    ST: "MO",
    cityWithStateAbbr: "Sarcoxie, MO",
  },
  {
    zip: "64863",
    ST: "MO",
    cityWithStateAbbr: "South West City, MO",
  },
  {
    zip: "64864",
    ST: "MO",
    cityWithStateAbbr: "Saginaw, MO",
  },
  {
    zip: "64865",
    ST: "MO",
    cityWithStateAbbr: "Seneca, MO",
  },
  {
    zip: "64866",
    ST: "MO",
    cityWithStateAbbr: "Stark City, MO",
  },
  {
    zip: "64867",
    ST: "MO",
    cityWithStateAbbr: "Stella, MO",
  },
  {
    zip: "64868",
    ST: "MO",
    cityWithStateAbbr: "Tiff City, MO",
  },
  {
    zip: "64869",
    ST: "MO",
    cityWithStateAbbr: "Waco, MO",
  },
  {
    zip: "64870",
    ST: "MO",
    cityWithStateAbbr: "Webb City, MO",
  },
  {
    zip: "64873",
    ST: "MO",
    cityWithStateAbbr: "Wentworth, MO",
  },
  {
    zip: "64874",
    ST: "MO",
    cityWithStateAbbr: "Wheaton, MO",
  },
  {
    zip: "64999",
    ST: "MO",
    cityWithStateAbbr: "Kansas City, MO",
  },
  {
    zip: "65001",
    ST: "MO",
    cityWithStateAbbr: "Argyle, MO",
  },
  {
    zip: "65010",
    ST: "MO",
    cityWithStateAbbr: "Ashland, MO",
  },
  {
    zip: "65011",
    ST: "MO",
    cityWithStateAbbr: "Barnett, MO",
  },
  {
    zip: "65013",
    ST: "MO",
    cityWithStateAbbr: "Belle, MO",
  },
  {
    zip: "65014",
    ST: "MO",
    cityWithStateAbbr: "Bland, MO",
  },
  {
    zip: "65016",
    ST: "MO",
    cityWithStateAbbr: "Bonnots Mill, MO",
  },
  {
    zip: "65017",
    ST: "MO",
    cityWithStateAbbr: "Brumley, MO",
  },
  {
    zip: "65018",
    ST: "MO",
    cityWithStateAbbr: "California, MO",
  },
  {
    zip: "65020",
    ST: "MO",
    cityWithStateAbbr: "Camdenton, MO",
  },
  {
    zip: "65023",
    ST: "MO",
    cityWithStateAbbr: "Centertown, MO",
  },
  {
    zip: "65024",
    ST: "MO",
    cityWithStateAbbr: "Chamois, MO",
  },
  {
    zip: "65025",
    ST: "MO",
    cityWithStateAbbr: "Clarksburg, MO",
  },
  {
    zip: "65026",
    ST: "MO",
    cityWithStateAbbr: "Eldon, MO",
  },
  {
    zip: "65032",
    ST: "MO",
    cityWithStateAbbr: "Eugene, MO",
  },
  {
    zip: "65034",
    ST: "MO",
    cityWithStateAbbr: "Fortuna, MO",
  },
  {
    zip: "65035",
    ST: "MO",
    cityWithStateAbbr: "Freeburg, MO",
  },
  {
    zip: "65036",
    ST: "MO",
    cityWithStateAbbr: "Gasconade, MO",
  },
  {
    zip: "65037",
    ST: "MO",
    cityWithStateAbbr: "Gravois Mills, MO",
  },
  {
    zip: "65038",
    ST: "MO",
    cityWithStateAbbr: "Laurie, MO",
  },
  {
    zip: "65039",
    ST: "MO",
    cityWithStateAbbr: "Hartsburg, MO",
  },
  {
    zip: "65040",
    ST: "MO",
    cityWithStateAbbr: "Henley, MO",
  },
  {
    zip: "65041",
    ST: "MO",
    cityWithStateAbbr: "Hermann, MO",
  },
  {
    zip: "65042",
    ST: "MO",
    cityWithStateAbbr: "High Point, MO",
  },
  {
    zip: "65043",
    ST: "MO",
    cityWithStateAbbr: "Holts Summit, MO",
  },
  {
    zip: "65046",
    ST: "MO",
    cityWithStateAbbr: "Jamestown, MO",
  },
  {
    zip: "65047",
    ST: "MO",
    cityWithStateAbbr: "Kaiser, MO",
  },
  {
    zip: "65048",
    ST: "MO",
    cityWithStateAbbr: "Koeltztown, MO",
  },
  {
    zip: "65049",
    ST: "MO",
    cityWithStateAbbr: "Lake Ozark, MO",
  },
  {
    zip: "65050",
    ST: "MO",
    cityWithStateAbbr: "Latham, MO",
  },
  {
    zip: "65051",
    ST: "MO",
    cityWithStateAbbr: "Linn, MO",
  },
  {
    zip: "65052",
    ST: "MO",
    cityWithStateAbbr: "Linn Creek, MO",
  },
  {
    zip: "65053",
    ST: "MO",
    cityWithStateAbbr: "Lohman, MO",
  },
  {
    zip: "65054",
    ST: "MO",
    cityWithStateAbbr: "Loose Creek, MO",
  },
  {
    zip: "65055",
    ST: "MO",
    cityWithStateAbbr: "Mc Girk, MO",
  },
  {
    zip: "65058",
    ST: "MO",
    cityWithStateAbbr: "Meta, MO",
  },
  {
    zip: "65059",
    ST: "MO",
    cityWithStateAbbr: "Mokane, MO",
  },
  {
    zip: "65061",
    ST: "MO",
    cityWithStateAbbr: "Morrison, MO",
  },
  {
    zip: "65062",
    ST: "MO",
    cityWithStateAbbr: "Mount Sterling, MO",
  },
  {
    zip: "65063",
    ST: "MO",
    cityWithStateAbbr: "New Bloomfield, MO",
  },
  {
    zip: "65064",
    ST: "MO",
    cityWithStateAbbr: "Olean, MO",
  },
  {
    zip: "65065",
    ST: "MO",
    cityWithStateAbbr: "Osage Beach, MO",
  },
  {
    zip: "65066",
    ST: "MO",
    cityWithStateAbbr: "Owensville, MO",
  },
  {
    zip: "65067",
    ST: "MO",
    cityWithStateAbbr: "Portland, MO",
  },
  {
    zip: "65068",
    ST: "MO",
    cityWithStateAbbr: "Prairie Home, MO",
  },
  {
    zip: "65069",
    ST: "MO",
    cityWithStateAbbr: "Rhineland, MO",
  },
  {
    zip: "65072",
    ST: "MO",
    cityWithStateAbbr: "Rocky Mount, MO",
  },
  {
    zip: "65074",
    ST: "MO",
    cityWithStateAbbr: "Russellville, MO",
  },
  {
    zip: "65075",
    ST: "MO",
    cityWithStateAbbr: "Saint Elizabeth, MO",
  },
  {
    zip: "65076",
    ST: "MO",
    cityWithStateAbbr: "Saint Thomas, MO",
  },
  {
    zip: "65077",
    ST: "MO",
    cityWithStateAbbr: "Steedman, MO",
  },
  {
    zip: "65078",
    ST: "MO",
    cityWithStateAbbr: "Stover, MO",
  },
  {
    zip: "65079",
    ST: "MO",
    cityWithStateAbbr: "Sunrise Beach, MO",
  },
  {
    zip: "65080",
    ST: "MO",
    cityWithStateAbbr: "Tebbetts, MO",
  },
  {
    zip: "65081",
    ST: "MO",
    cityWithStateAbbr: "Tipton, MO",
  },
  {
    zip: "65082",
    ST: "MO",
    cityWithStateAbbr: "Tuscumbia, MO",
  },
  {
    zip: "65083",
    ST: "MO",
    cityWithStateAbbr: "Ulman, MO",
  },
  {
    zip: "65084",
    ST: "MO",
    cityWithStateAbbr: "Versailles, MO",
  },
  {
    zip: "65085",
    ST: "MO",
    cityWithStateAbbr: "Westphalia, MO",
  },
  {
    zip: "65101",
    ST: "MO",
    cityWithStateAbbr: "Jefferson City, MO",
  },
  {
    zip: "65102",
    ST: "MO",
    cityWithStateAbbr: "Jefferson City, MO",
  },
  {
    zip: "65103",
    ST: "MO",
    cityWithStateAbbr: "Jefferson City, MO",
  },
  {
    zip: "65104",
    ST: "MO",
    cityWithStateAbbr: "Jefferson City, MO",
  },
  {
    zip: "65105",
    ST: "MO",
    cityWithStateAbbr: "Jefferson City, MO",
  },
  {
    zip: "65106",
    ST: "MO",
    cityWithStateAbbr: "Jefferson City, MO",
  },
  {
    zip: "65107",
    ST: "MO",
    cityWithStateAbbr: "Jefferson City, MO",
  },
  {
    zip: "65108",
    ST: "MO",
    cityWithStateAbbr: "Jefferson City, MO",
  },
  {
    zip: "65109",
    ST: "MO",
    cityWithStateAbbr: "Jefferson City, MO",
  },
  {
    zip: "65110",
    ST: "MO",
    cityWithStateAbbr: "Jefferson City, MO",
  },
  {
    zip: "65111",
    ST: "MO",
    cityWithStateAbbr: "Jefferson City, MO",
  },
  {
    zip: "65201",
    ST: "MO",
    cityWithStateAbbr: "Columbia, MO",
  },
  {
    zip: "65202",
    ST: "MO",
    cityWithStateAbbr: "Columbia, MO",
  },
  {
    zip: "65203",
    ST: "MO",
    cityWithStateAbbr: "Columbia, MO",
  },
  {
    zip: "65205",
    ST: "MO",
    cityWithStateAbbr: "Columbia, MO",
  },
  {
    zip: "65211",
    ST: "MO",
    cityWithStateAbbr: "Columbia, MO",
  },
  {
    zip: "65212",
    ST: "MO",
    cityWithStateAbbr: "Columbia, MO",
  },
  {
    zip: "65215",
    ST: "MO",
    cityWithStateAbbr: "Columbia, MO",
  },
  {
    zip: "65216",
    ST: "MO",
    cityWithStateAbbr: "Columbia, MO",
  },
  {
    zip: "65217",
    ST: "MO",
    cityWithStateAbbr: "Columbia, MO",
  },
  {
    zip: "65218",
    ST: "MO",
    cityWithStateAbbr: "Columbia, MO",
  },
  {
    zip: "65230",
    ST: "MO",
    cityWithStateAbbr: "Armstrong, MO",
  },
  {
    zip: "65231",
    ST: "MO",
    cityWithStateAbbr: "Auxvasse, MO",
  },
  {
    zip: "65232",
    ST: "MO",
    cityWithStateAbbr: "Benton City, MO",
  },
  {
    zip: "65233",
    ST: "MO",
    cityWithStateAbbr: "Boonville, MO",
  },
  {
    zip: "65236",
    ST: "MO",
    cityWithStateAbbr: "Brunswick, MO",
  },
  {
    zip: "65237",
    ST: "MO",
    cityWithStateAbbr: "Bunceton, MO",
  },
  {
    zip: "65239",
    ST: "MO",
    cityWithStateAbbr: "Cairo, MO",
  },
  {
    zip: "65240",
    ST: "MO",
    cityWithStateAbbr: "Centralia, MO",
  },
  {
    zip: "65243",
    ST: "MO",
    cityWithStateAbbr: "Clark, MO",
  },
  {
    zip: "65244",
    ST: "MO",
    cityWithStateAbbr: "Clifton Hill, MO",
  },
  {
    zip: "65246",
    ST: "MO",
    cityWithStateAbbr: "Dalton, MO",
  },
  {
    zip: "65247",
    ST: "MO",
    cityWithStateAbbr: "Excello, MO",
  },
  {
    zip: "65248",
    ST: "MO",
    cityWithStateAbbr: "Fayette, MO",
  },
  {
    zip: "65250",
    ST: "MO",
    cityWithStateAbbr: "Franklin, MO",
  },
  {
    zip: "65251",
    ST: "MO",
    cityWithStateAbbr: "Fulton, MO",
  },
  {
    zip: "65254",
    ST: "MO",
    cityWithStateAbbr: "Glasgow, MO",
  },
  {
    zip: "65255",
    ST: "MO",
    cityWithStateAbbr: "Hallsville, MO",
  },
  {
    zip: "65256",
    ST: "MO",
    cityWithStateAbbr: "Harrisburg, MO",
  },
  {
    zip: "65257",
    ST: "MO",
    cityWithStateAbbr: "Higbee, MO",
  },
  {
    zip: "65258",
    ST: "MO",
    cityWithStateAbbr: "Holliday, MO",
  },
  {
    zip: "65259",
    ST: "MO",
    cityWithStateAbbr: "Huntsville, MO",
  },
  {
    zip: "65260",
    ST: "MO",
    cityWithStateAbbr: "Jacksonville, MO",
  },
  {
    zip: "65261",
    ST: "MO",
    cityWithStateAbbr: "Keytesville, MO",
  },
  {
    zip: "65262",
    ST: "MO",
    cityWithStateAbbr: "Kingdom City, MO",
  },
  {
    zip: "65263",
    ST: "MO",
    cityWithStateAbbr: "Madison, MO",
  },
  {
    zip: "65264",
    ST: "MO",
    cityWithStateAbbr: "Martinsburg, MO",
  },
  {
    zip: "65265",
    ST: "MO",
    cityWithStateAbbr: "Mexico, MO",
  },
  {
    zip: "65270",
    ST: "MO",
    cityWithStateAbbr: "Moberly, MO",
  },
  {
    zip: "65274",
    ST: "MO",
    cityWithStateAbbr: "New Franklin, MO",
  },
  {
    zip: "65275",
    ST: "MO",
    cityWithStateAbbr: "Paris, MO",
  },
  {
    zip: "65276",
    ST: "MO",
    cityWithStateAbbr: "Pilot Grove, MO",
  },
  {
    zip: "65278",
    ST: "MO",
    cityWithStateAbbr: "Renick, MO",
  },
  {
    zip: "65279",
    ST: "MO",
    cityWithStateAbbr: "Rocheport, MO",
  },
  {
    zip: "65280",
    ST: "MO",
    cityWithStateAbbr: "Rush Hill, MO",
  },
  {
    zip: "65281",
    ST: "MO",
    cityWithStateAbbr: "Salisbury, MO",
  },
  {
    zip: "65282",
    ST: "MO",
    cityWithStateAbbr: "Santa Fe, MO",
  },
  {
    zip: "65283",
    ST: "MO",
    cityWithStateAbbr: "Stoutsville, MO",
  },
  {
    zip: "65284",
    ST: "MO",
    cityWithStateAbbr: "Sturgeon, MO",
  },
  {
    zip: "65285",
    ST: "MO",
    cityWithStateAbbr: "Thompson, MO",
  },
  {
    zip: "65286",
    ST: "MO",
    cityWithStateAbbr: "Triplett, MO",
  },
  {
    zip: "65287",
    ST: "MO",
    cityWithStateAbbr: "Wooldridge, MO",
  },
  {
    zip: "65299",
    ST: "MO",
    cityWithStateAbbr: "Columbia, MO",
  },
  {
    zip: "65301",
    ST: "MO",
    cityWithStateAbbr: "Sedalia, MO",
  },
  {
    zip: "65302",
    ST: "MO",
    cityWithStateAbbr: "Sedalia, MO",
  },
  {
    zip: "65305",
    ST: "MO",
    cityWithStateAbbr: "Whiteman Air Force Base, MO",
  },
  {
    zip: "65320",
    ST: "MO",
    cityWithStateAbbr: "Arrow Rock, MO",
  },
  {
    zip: "65321",
    ST: "MO",
    cityWithStateAbbr: "Blackburn, MO",
  },
  {
    zip: "65322",
    ST: "MO",
    cityWithStateAbbr: "Blackwater, MO",
  },
  {
    zip: "65323",
    ST: "MO",
    cityWithStateAbbr: "Calhoun, MO",
  },
  {
    zip: "65324",
    ST: "MO",
    cityWithStateAbbr: "Climax Springs, MO",
  },
  {
    zip: "65325",
    ST: "MO",
    cityWithStateAbbr: "Cole Camp, MO",
  },
  {
    zip: "65326",
    ST: "MO",
    cityWithStateAbbr: "Edwards, MO",
  },
  {
    zip: "65327",
    ST: "MO",
    cityWithStateAbbr: "Emma, MO",
  },
  {
    zip: "65329",
    ST: "MO",
    cityWithStateAbbr: "Florence, MO",
  },
  {
    zip: "65330",
    ST: "MO",
    cityWithStateAbbr: "Gilliam, MO",
  },
  {
    zip: "65332",
    ST: "MO",
    cityWithStateAbbr: "Green Ridge, MO",
  },
  {
    zip: "65333",
    ST: "MO",
    cityWithStateAbbr: "Houstonia, MO",
  },
  {
    zip: "65334",
    ST: "MO",
    cityWithStateAbbr: "Hughesville, MO",
  },
  {
    zip: "65335",
    ST: "MO",
    cityWithStateAbbr: "Ionia, MO",
  },
  {
    zip: "65336",
    ST: "MO",
    cityWithStateAbbr: "Knob Noster, MO",
  },
  {
    zip: "65337",
    ST: "MO",
    cityWithStateAbbr: "La Monte, MO",
  },
  {
    zip: "65338",
    ST: "MO",
    cityWithStateAbbr: "Lincoln, MO",
  },
  {
    zip: "65339",
    ST: "MO",
    cityWithStateAbbr: "Malta Bend, MO",
  },
  {
    zip: "65340",
    ST: "MO",
    cityWithStateAbbr: "Marshall, MO",
  },
  {
    zip: "65344",
    ST: "MO",
    cityWithStateAbbr: "Miami, MO",
  },
  {
    zip: "65345",
    ST: "MO",
    cityWithStateAbbr: "Mora, MO",
  },
  {
    zip: "65347",
    ST: "MO",
    cityWithStateAbbr: "Nelson, MO",
  },
  {
    zip: "65348",
    ST: "MO",
    cityWithStateAbbr: "Otterville, MO",
  },
  {
    zip: "65349",
    ST: "MO",
    cityWithStateAbbr: "Slater, MO",
  },
  {
    zip: "65350",
    ST: "MO",
    cityWithStateAbbr: "Smithton, MO",
  },
  {
    zip: "65351",
    ST: "MO",
    cityWithStateAbbr: "Sweet Springs, MO",
  },
  {
    zip: "65354",
    ST: "MO",
    cityWithStateAbbr: "Syracuse, MO",
  },
  {
    zip: "65355",
    ST: "MO",
    cityWithStateAbbr: "Warsaw, MO",
  },
  {
    zip: "65360",
    ST: "MO",
    cityWithStateAbbr: "Windsor, MO",
  },
  {
    zip: "65401",
    ST: "MO",
    cityWithStateAbbr: "Rolla, MO",
  },
  {
    zip: "65402",
    ST: "MO",
    cityWithStateAbbr: "Rolla, MO",
  },
  {
    zip: "65409",
    ST: "MO",
    cityWithStateAbbr: "Rolla, MO",
  },
  {
    zip: "65436",
    ST: "MO",
    cityWithStateAbbr: "Beulah, MO",
  },
  {
    zip: "65438",
    ST: "MO",
    cityWithStateAbbr: "Birch Tree, MO",
  },
  {
    zip: "65439",
    ST: "MO",
    cityWithStateAbbr: "Bixby, MO",
  },
  {
    zip: "65440",
    ST: "MO",
    cityWithStateAbbr: "Boss, MO",
  },
  {
    zip: "65441",
    ST: "MO",
    cityWithStateAbbr: "Bourbon, MO",
  },
  {
    zip: "65443",
    ST: "MO",
    cityWithStateAbbr: "Brinktown, MO",
  },
  {
    zip: "65444",
    ST: "MO",
    cityWithStateAbbr: "Bucyrus, MO",
  },
  {
    zip: "65446",
    ST: "MO",
    cityWithStateAbbr: "Cherryville, MO",
  },
  {
    zip: "65449",
    ST: "MO",
    cityWithStateAbbr: "Cook Sta, MO",
  },
  {
    zip: "65452",
    ST: "MO",
    cityWithStateAbbr: "Crocker, MO",
  },
  {
    zip: "65453",
    ST: "MO",
    cityWithStateAbbr: "Cuba, MO",
  },
  {
    zip: "65456",
    ST: "MO",
    cityWithStateAbbr: "Davisville, MO",
  },
  {
    zip: "65457",
    ST: "MO",
    cityWithStateAbbr: "Devils Elbow, MO",
  },
  {
    zip: "65459",
    ST: "MO",
    cityWithStateAbbr: "Dixon, MO",
  },
  {
    zip: "65461",
    ST: "MO",
    cityWithStateAbbr: "Duke, MO",
  },
  {
    zip: "65462",
    ST: "MO",
    cityWithStateAbbr: "Edgar Springs, MO",
  },
  {
    zip: "65463",
    ST: "MO",
    cityWithStateAbbr: "Eldridge, MO",
  },
  {
    zip: "65464",
    ST: "MO",
    cityWithStateAbbr: "Elk Creek, MO",
  },
  {
    zip: "65466",
    ST: "MO",
    cityWithStateAbbr: "Eminence, MO",
  },
  {
    zip: "65468",
    ST: "MO",
    cityWithStateAbbr: "Eunice, MO",
  },
  {
    zip: "65470",
    ST: "MO",
    cityWithStateAbbr: "Falcon, MO",
  },
  {
    zip: "65473",
    ST: "MO",
    cityWithStateAbbr: "Fort Leonard Wood, MO",
  },
  {
    zip: "65479",
    ST: "MO",
    cityWithStateAbbr: "Hartshorn, MO",
  },
  {
    zip: "65483",
    ST: "MO",
    cityWithStateAbbr: "Houston, MO",
  },
  {
    zip: "65484",
    ST: "MO",
    cityWithStateAbbr: "Huggins, MO",
  },
  {
    zip: "65486",
    ST: "MO",
    cityWithStateAbbr: "Iberia, MO",
  },
  {
    zip: "65501",
    ST: "MO",
    cityWithStateAbbr: "Jadwin, MO",
  },
  {
    zip: "65529",
    ST: "MO",
    cityWithStateAbbr: "Jerome, MO",
  },
  {
    zip: "65532",
    ST: "MO",
    cityWithStateAbbr: "Lake Spring, MO",
  },
  {
    zip: "65534",
    ST: "MO",
    cityWithStateAbbr: "Laquey, MO",
  },
  {
    zip: "65535",
    ST: "MO",
    cityWithStateAbbr: "Leasburg, MO",
  },
  {
    zip: "65536",
    ST: "MO",
    cityWithStateAbbr: "Lebanon, MO",
  },
  {
    zip: "65541",
    ST: "MO",
    cityWithStateAbbr: "Lenox, MO",
  },
  {
    zip: "65542",
    ST: "MO",
    cityWithStateAbbr: "Licking, MO",
  },
  {
    zip: "65543",
    ST: "MO",
    cityWithStateAbbr: "Lynchburg, MO",
  },
  {
    zip: "65546",
    ST: "MO",
    cityWithStateAbbr: "Montier, MO",
  },
  {
    zip: "65548",
    ST: "MO",
    cityWithStateAbbr: "Mountain View, MO",
  },
  {
    zip: "65550",
    ST: "MO",
    cityWithStateAbbr: "Newburg, MO",
  },
  {
    zip: "65552",
    ST: "MO",
    cityWithStateAbbr: "Plato, MO",
  },
  {
    zip: "65555",
    ST: "MO",
    cityWithStateAbbr: "Raymondville, MO",
  },
  {
    zip: "65556",
    ST: "MO",
    cityWithStateAbbr: "Richland, MO",
  },
  {
    zip: "65557",
    ST: "MO",
    cityWithStateAbbr: "Roby, MO",
  },
  {
    zip: "65559",
    ST: "MO",
    cityWithStateAbbr: "Saint James, MO",
  },
  {
    zip: "65560",
    ST: "MO",
    cityWithStateAbbr: "Salem, MO",
  },
  {
    zip: "65564",
    ST: "MO",
    cityWithStateAbbr: "Solo, MO",
  },
  {
    zip: "65565",
    ST: "MO",
    cityWithStateAbbr: "Steelville, MO",
  },
  {
    zip: "65566",
    ST: "MO",
    cityWithStateAbbr: "Viburnum, MO",
  },
  {
    zip: "65567",
    ST: "MO",
    cityWithStateAbbr: "Stoutland, MO",
  },
  {
    zip: "65570",
    ST: "MO",
    cityWithStateAbbr: "Success, MO",
  },
  {
    zip: "65571",
    ST: "MO",
    cityWithStateAbbr: "Summersville, MO",
  },
  {
    zip: "65580",
    ST: "MO",
    cityWithStateAbbr: "Vichy, MO",
  },
  {
    zip: "65582",
    ST: "MO",
    cityWithStateAbbr: "Vienna, MO",
  },
  {
    zip: "65583",
    ST: "MO",
    cityWithStateAbbr: "Waynesville, MO",
  },
  {
    zip: "65584",
    ST: "MO",
    cityWithStateAbbr: "Saint Robert, MO",
  },
  {
    zip: "65586",
    ST: "MO",
    cityWithStateAbbr: "Wesco, MO",
  },
  {
    zip: "65588",
    ST: "MO",
    cityWithStateAbbr: "Winona, MO",
  },
  {
    zip: "65589",
    ST: "MO",
    cityWithStateAbbr: "Yukon, MO",
  },
  {
    zip: "65590",
    ST: "MO",
    cityWithStateAbbr: "Long Lane, MO",
  },
  {
    zip: "65591",
    ST: "MO",
    cityWithStateAbbr: "Montreal, MO",
  },
  {
    zip: "65601",
    ST: "MO",
    cityWithStateAbbr: "Aldrich, MO",
  },
  {
    zip: "65603",
    ST: "MO",
    cityWithStateAbbr: "Arcola, MO",
  },
  {
    zip: "65604",
    ST: "MO",
    cityWithStateAbbr: "Ash Grove, MO",
  },
  {
    zip: "65605",
    ST: "MO",
    cityWithStateAbbr: "Aurora, MO",
  },
  {
    zip: "65606",
    ST: "MO",
    cityWithStateAbbr: "Alton, MO",
  },
  {
    zip: "65607",
    ST: "MO",
    cityWithStateAbbr: "Caplinger Mills, MO",
  },
  {
    zip: "65608",
    ST: "MO",
    cityWithStateAbbr: "Ava, MO",
  },
  {
    zip: "65609",
    ST: "MO",
    cityWithStateAbbr: "Bakersfield, MO",
  },
  {
    zip: "65610",
    ST: "MO",
    cityWithStateAbbr: "Billings, MO",
  },
  {
    zip: "65611",
    ST: "MO",
    cityWithStateAbbr: "Blue Eye, MO",
  },
  {
    zip: "65612",
    ST: "MO",
    cityWithStateAbbr: "Bois D Arc, MO",
  },
  {
    zip: "65613",
    ST: "MO",
    cityWithStateAbbr: "Bolivar, MO",
  },
  {
    zip: "65614",
    ST: "MO",
    cityWithStateAbbr: "Bradleyville, MO",
  },
  {
    zip: "65615",
    ST: "MO",
    cityWithStateAbbr: "Branson, MO",
  },
  {
    zip: "65616",
    ST: "MO",
    cityWithStateAbbr: "Branson, MO",
  },
  {
    zip: "65617",
    ST: "MO",
    cityWithStateAbbr: "Brighton, MO",
  },
  {
    zip: "65618",
    ST: "MO",
    cityWithStateAbbr: "Brixey, MO",
  },
  {
    zip: "65619",
    ST: "MO",
    cityWithStateAbbr: "Brookline, MO",
  },
  {
    zip: "65620",
    ST: "MO",
    cityWithStateAbbr: "Bruner, MO",
  },
  {
    zip: "65622",
    ST: "MO",
    cityWithStateAbbr: "Buffalo, MO",
  },
  {
    zip: "65623",
    ST: "MO",
    cityWithStateAbbr: "Butterfield, MO",
  },
  {
    zip: "65624",
    ST: "MO",
    cityWithStateAbbr: "Cape Fair, MO",
  },
  {
    zip: "65625",
    ST: "MO",
    cityWithStateAbbr: "Cassville, MO",
  },
  {
    zip: "65626",
    ST: "MO",
    cityWithStateAbbr: "Caulfield, MO",
  },
  {
    zip: "65627",
    ST: "MO",
    cityWithStateAbbr: "Cedarcreek, MO",
  },
  {
    zip: "65629",
    ST: "MO",
    cityWithStateAbbr: "Chadwick, MO",
  },
  {
    zip: "65630",
    ST: "MO",
    cityWithStateAbbr: "Chestnutridge, MO",
  },
  {
    zip: "65631",
    ST: "MO",
    cityWithStateAbbr: "Clever, MO",
  },
  {
    zip: "65632",
    ST: "MO",
    cityWithStateAbbr: "Conway, MO",
  },
  {
    zip: "65633",
    ST: "MO",
    cityWithStateAbbr: "Crane, MO",
  },
  {
    zip: "65634",
    ST: "MO",
    cityWithStateAbbr: "Cross Timbers, MO",
  },
  {
    zip: "65635",
    ST: "MO",
    cityWithStateAbbr: "Dadeville, MO",
  },
  {
    zip: "65636",
    ST: "MO",
    cityWithStateAbbr: "Diggins, MO",
  },
  {
    zip: "65637",
    ST: "MO",
    cityWithStateAbbr: "Dora, MO",
  },
  {
    zip: "65638",
    ST: "MO",
    cityWithStateAbbr: "Drury, MO",
  },
  {
    zip: "65640",
    ST: "MO",
    cityWithStateAbbr: "Dunnegan, MO",
  },
  {
    zip: "65641",
    ST: "MO",
    cityWithStateAbbr: "Eagle Rock, MO",
  },
  {
    zip: "65644",
    ST: "MO",
    cityWithStateAbbr: "Elkland, MO",
  },
  {
    zip: "65645",
    ST: "MO",
    cityWithStateAbbr: "Morrisville, MO",
  },
  {
    zip: "65646",
    ST: "MO",
    cityWithStateAbbr: "Everton, MO",
  },
  {
    zip: "65647",
    ST: "MO",
    cityWithStateAbbr: "Exeter, MO",
  },
  {
    zip: "65648",
    ST: "MO",
    cityWithStateAbbr: "Fair Grove, MO",
  },
  {
    zip: "65649",
    ST: "MO",
    cityWithStateAbbr: "Fair Play, MO",
  },
  {
    zip: "65650",
    ST: "MO",
    cityWithStateAbbr: "Flemington, MO",
  },
  {
    zip: "65652",
    ST: "MO",
    cityWithStateAbbr: "Fordland, MO",
  },
  {
    zip: "65653",
    ST: "MO",
    cityWithStateAbbr: "Forsyth, MO",
  },
  {
    zip: "65654",
    ST: "MO",
    cityWithStateAbbr: "Freistatt, MO",
  },
  {
    zip: "65655",
    ST: "MO",
    cityWithStateAbbr: "Gainesville, MO",
  },
  {
    zip: "65656",
    ST: "MO",
    cityWithStateAbbr: "Galena, MO",
  },
  {
    zip: "65657",
    ST: "MO",
    cityWithStateAbbr: "Garrison, MO",
  },
  {
    zip: "65658",
    ST: "MO",
    cityWithStateAbbr: "Golden, MO",
  },
  {
    zip: "65660",
    ST: "MO",
    cityWithStateAbbr: "Graff, MO",
  },
  {
    zip: "65661",
    ST: "MO",
    cityWithStateAbbr: "Greenfield, MO",
  },
  {
    zip: "65662",
    ST: "MO",
    cityWithStateAbbr: "Grovespring, MO",
  },
  {
    zip: "65663",
    ST: "MO",
    cityWithStateAbbr: "Half Way, MO",
  },
  {
    zip: "65664",
    ST: "MO",
    cityWithStateAbbr: "Halltown, MO",
  },
  {
    zip: "65666",
    ST: "MO",
    cityWithStateAbbr: "Hardenville, MO",
  },
  {
    zip: "65667",
    ST: "MO",
    cityWithStateAbbr: "Hartville, MO",
  },
  {
    zip: "65668",
    ST: "MO",
    cityWithStateAbbr: "Hermitage, MO",
  },
  {
    zip: "65669",
    ST: "MO",
    cityWithStateAbbr: "Highlandville, MO",
  },
  {
    zip: "65672",
    ST: "MO",
    cityWithStateAbbr: "Hollister, MO",
  },
  {
    zip: "65673",
    ST: "MO",
    cityWithStateAbbr: "Hollister, MO",
  },
  {
    zip: "65674",
    ST: "MO",
    cityWithStateAbbr: "Humansville, MO",
  },
  {
    zip: "65675",
    ST: "MO",
    cityWithStateAbbr: "Hurley, MO",
  },
  {
    zip: "65676",
    ST: "MO",
    cityWithStateAbbr: "Isabella, MO",
  },
  {
    zip: "65679",
    ST: "MO",
    cityWithStateAbbr: "Kirbyville, MO",
  },
  {
    zip: "65680",
    ST: "MO",
    cityWithStateAbbr: "Kissee Mills, MO",
  },
  {
    zip: "65681",
    ST: "MO",
    cityWithStateAbbr: "Lampe, MO",
  },
  {
    zip: "65682",
    ST: "MO",
    cityWithStateAbbr: "Lockwood, MO",
  },
  {
    zip: "65685",
    ST: "MO",
    cityWithStateAbbr: "Louisburg, MO",
  },
  {
    zip: "65686",
    ST: "MO",
    cityWithStateAbbr: "Kimberling City, MO",
  },
  {
    zip: "65688",
    ST: "MO",
    cityWithStateAbbr: "Brandsville, MO",
  },
  {
    zip: "65689",
    ST: "MO",
    cityWithStateAbbr: "Cabool, MO",
  },
  {
    zip: "65690",
    ST: "MO",
    cityWithStateAbbr: "Couch, MO",
  },
  {
    zip: "65692",
    ST: "MO",
    cityWithStateAbbr: "Koshkonong, MO",
  },
  {
    zip: "65701",
    ST: "MO",
    cityWithStateAbbr: "Mc Clurg, MO",
  },
  {
    zip: "65702",
    ST: "MO",
    cityWithStateAbbr: "Macomb, MO",
  },
  {
    zip: "65704",
    ST: "MO",
    cityWithStateAbbr: "Mansfield, MO",
  },
  {
    zip: "65705",
    ST: "MO",
    cityWithStateAbbr: "Marionville, MO",
  },
  {
    zip: "65706",
    ST: "MO",
    cityWithStateAbbr: "Marshfield, MO",
  },
  {
    zip: "65707",
    ST: "MO",
    cityWithStateAbbr: "Miller, MO",
  },
  {
    zip: "65708",
    ST: "MO",
    cityWithStateAbbr: "Monett, MO",
  },
  {
    zip: "65710",
    ST: "MO",
    cityWithStateAbbr: "Morrisville, MO",
  },
  {
    zip: "65711",
    ST: "MO",
    cityWithStateAbbr: "Mountain Grove, MO",
  },
  {
    zip: "65712",
    ST: "MO",
    cityWithStateAbbr: "Mount Vernon, MO",
  },
  {
    zip: "65713",
    ST: "MO",
    cityWithStateAbbr: "Niangua, MO",
  },
  {
    zip: "65714",
    ST: "MO",
    cityWithStateAbbr: "Nixa, MO",
  },
  {
    zip: "65715",
    ST: "MO",
    cityWithStateAbbr: "Noble, MO",
  },
  {
    zip: "65717",
    ST: "MO",
    cityWithStateAbbr: "Norwood, MO",
  },
  {
    zip: "65720",
    ST: "MO",
    cityWithStateAbbr: "Oldfield, MO",
  },
  {
    zip: "65721",
    ST: "MO",
    cityWithStateAbbr: "Ozark, MO",
  },
  {
    zip: "65722",
    ST: "MO",
    cityWithStateAbbr: "Phillipsburg, MO",
  },
  {
    zip: "65723",
    ST: "MO",
    cityWithStateAbbr: "Pierce City, MO",
  },
  {
    zip: "65724",
    ST: "MO",
    cityWithStateAbbr: "Pittsburg, MO",
  },
  {
    zip: "65725",
    ST: "MO",
    cityWithStateAbbr: "Pleasant Hope, MO",
  },
  {
    zip: "65726",
    ST: "MO",
    cityWithStateAbbr: "Point Lookout, MO",
  },
  {
    zip: "65727",
    ST: "MO",
    cityWithStateAbbr: "Polk, MO",
  },
  {
    zip: "65728",
    ST: "MO",
    cityWithStateAbbr: "Ponce De Leon, MO",
  },
  {
    zip: "65729",
    ST: "MO",
    cityWithStateAbbr: "Pontiac, MO",
  },
  {
    zip: "65730",
    ST: "MO",
    cityWithStateAbbr: "Powell, MO",
  },
  {
    zip: "65731",
    ST: "MO",
    cityWithStateAbbr: "Powersite, MO",
  },
  {
    zip: "65732",
    ST: "MO",
    cityWithStateAbbr: "Preston, MO",
  },
  {
    zip: "65733",
    ST: "MO",
    cityWithStateAbbr: "Protem, MO",
  },
  {
    zip: "65734",
    ST: "MO",
    cityWithStateAbbr: "Purdy, MO",
  },
  {
    zip: "65735",
    ST: "MO",
    cityWithStateAbbr: "Quincy, MO",
  },
  {
    zip: "65737",
    ST: "MO",
    cityWithStateAbbr: "Reeds Spring, MO",
  },
  {
    zip: "65738",
    ST: "MO",
    cityWithStateAbbr: "Republic, MO",
  },
  {
    zip: "65739",
    ST: "MO",
    cityWithStateAbbr: "Ridgedale, MO",
  },
  {
    zip: "65740",
    ST: "MO",
    cityWithStateAbbr: "Rockaway Beach, MO",
  },
  {
    zip: "65741",
    ST: "MO",
    cityWithStateAbbr: "Rockbridge, MO",
  },
  {
    zip: "65742",
    ST: "MO",
    cityWithStateAbbr: "Rogersville, MO",
  },
  {
    zip: "65744",
    ST: "MO",
    cityWithStateAbbr: "Rueter, MO",
  },
  {
    zip: "65745",
    ST: "MO",
    cityWithStateAbbr: "Seligman, MO",
  },
  {
    zip: "65746",
    ST: "MO",
    cityWithStateAbbr: "Seymour, MO",
  },
  {
    zip: "65747",
    ST: "MO",
    cityWithStateAbbr: "Shell Knob, MO",
  },
  {
    zip: "65752",
    ST: "MO",
    cityWithStateAbbr: "South Greenfield, MO",
  },
  {
    zip: "65753",
    ST: "MO",
    cityWithStateAbbr: "Sparta, MO",
  },
  {
    zip: "65754",
    ST: "MO",
    cityWithStateAbbr: "Spokane, MO",
  },
  {
    zip: "65755",
    ST: "MO",
    cityWithStateAbbr: "Squires, MO",
  },
  {
    zip: "65756",
    ST: "MO",
    cityWithStateAbbr: "Stotts City, MO",
  },
  {
    zip: "65757",
    ST: "MO",
    cityWithStateAbbr: "Strafford, MO",
  },
  {
    zip: "65759",
    ST: "MO",
    cityWithStateAbbr: "Taneyville, MO",
  },
  {
    zip: "65760",
    ST: "MO",
    cityWithStateAbbr: "Tecumseh, MO",
  },
  {
    zip: "65761",
    ST: "MO",
    cityWithStateAbbr: "Theodosia, MO",
  },
  {
    zip: "65762",
    ST: "MO",
    cityWithStateAbbr: "Thornfield, MO",
  },
  {
    zip: "65764",
    ST: "MO",
    cityWithStateAbbr: "Tunas, MO",
  },
  {
    zip: "65765",
    ST: "MO",
    cityWithStateAbbr: "Turners, MO",
  },
  {
    zip: "65766",
    ST: "MO",
    cityWithStateAbbr: "Udall, MO",
  },
  {
    zip: "65767",
    ST: "MO",
    cityWithStateAbbr: "Urbana, MO",
  },
  {
    zip: "65768",
    ST: "MO",
    cityWithStateAbbr: "Vanzant, MO",
  },
  {
    zip: "65769",
    ST: "MO",
    cityWithStateAbbr: "Verona, MO",
  },
  {
    zip: "65770",
    ST: "MO",
    cityWithStateAbbr: "Walnut Grove, MO",
  },
  {
    zip: "65771",
    ST: "MO",
    cityWithStateAbbr: "Walnut Shade, MO",
  },
  {
    zip: "65772",
    ST: "MO",
    cityWithStateAbbr: "Washburn, MO",
  },
  {
    zip: "65773",
    ST: "MO",
    cityWithStateAbbr: "Wasola, MO",
  },
  {
    zip: "65774",
    ST: "MO",
    cityWithStateAbbr: "Weaubleau, MO",
  },
  {
    zip: "65775",
    ST: "MO",
    cityWithStateAbbr: "West Plains, MO",
  },
  {
    zip: "65776",
    ST: "MO",
    cityWithStateAbbr: "South Fork, MO",
  },
  {
    zip: "65777",
    ST: "MO",
    cityWithStateAbbr: "Moody, MO",
  },
  {
    zip: "65778",
    ST: "MO",
    cityWithStateAbbr: "Myrtle, MO",
  },
  {
    zip: "65779",
    ST: "MO",
    cityWithStateAbbr: "Wheatland, MO",
  },
  {
    zip: "65781",
    ST: "MO",
    cityWithStateAbbr: "Willard, MO",
  },
  {
    zip: "65783",
    ST: "MO",
    cityWithStateAbbr: "Windyville, MO",
  },
  {
    zip: "65784",
    ST: "MO",
    cityWithStateAbbr: "Zanoni, MO",
  },
  {
    zip: "65785",
    ST: "MO",
    cityWithStateAbbr: "Stockton, MO",
  },
  {
    zip: "65786",
    ST: "MO",
    cityWithStateAbbr: "Macks Creek, MO",
  },
  {
    zip: "65787",
    ST: "MO",
    cityWithStateAbbr: "Roach, MO",
  },
  {
    zip: "65788",
    ST: "MO",
    cityWithStateAbbr: "Peace Valley, MO",
  },
  {
    zip: "65789",
    ST: "MO",
    cityWithStateAbbr: "Pomona, MO",
  },
  {
    zip: "65790",
    ST: "MO",
    cityWithStateAbbr: "Pottersville, MO",
  },
  {
    zip: "65791",
    ST: "MO",
    cityWithStateAbbr: "Thayer, MO",
  },
  {
    zip: "65793",
    ST: "MO",
    cityWithStateAbbr: "Willow Springs, MO",
  },
  {
    zip: "65801",
    ST: "MO",
    cityWithStateAbbr: "Springfield, MO",
  },
  {
    zip: "65802",
    ST: "MO",
    cityWithStateAbbr: "Springfield, MO",
  },
  {
    zip: "65803",
    ST: "MO",
    cityWithStateAbbr: "Springfield, MO",
  },
  {
    zip: "65804",
    ST: "MO",
    cityWithStateAbbr: "Springfield, MO",
  },
  {
    zip: "65805",
    ST: "MO",
    cityWithStateAbbr: "Springfield, MO",
  },
  {
    zip: "65806",
    ST: "MO",
    cityWithStateAbbr: "Springfield, MO",
  },
  {
    zip: "65807",
    ST: "MO",
    cityWithStateAbbr: "Springfield, MO",
  },
  {
    zip: "65808",
    ST: "MO",
    cityWithStateAbbr: "Springfield, MO",
  },
  {
    zip: "65809",
    ST: "MO",
    cityWithStateAbbr: "Springfield, MO",
  },
  {
    zip: "65810",
    ST: "MO",
    cityWithStateAbbr: "Springfield, MO",
  },
  {
    zip: "65814",
    ST: "MO",
    cityWithStateAbbr: "Springfield, MO",
  },
  {
    zip: "65817",
    ST: "MO",
    cityWithStateAbbr: "Springfield, MO",
  },
  {
    zip: "65890",
    ST: "MO",
    cityWithStateAbbr: "Springfield, MO",
  },
  {
    zip: "65897",
    ST: "MO",
    cityWithStateAbbr: "Springfield, MO",
  },
  {
    zip: "65898",
    ST: "MO",
    cityWithStateAbbr: "Springfield, MO",
  },
  {
    zip: "65899",
    ST: "MO",
    cityWithStateAbbr: "Springfield, MO",
  },
  {
    zip: "66002",
    ST: "KS",
    cityWithStateAbbr: "Atchison, KS",
  },
  {
    zip: "66006",
    ST: "KS",
    cityWithStateAbbr: "Baldwin City, KS",
  },
  {
    zip: "66007",
    ST: "KS",
    cityWithStateAbbr: "Basehor, KS",
  },
  {
    zip: "66008",
    ST: "KS",
    cityWithStateAbbr: "Bendena, KS",
  },
  {
    zip: "66010",
    ST: "KS",
    cityWithStateAbbr: "Blue Mound, KS",
  },
  {
    zip: "66012",
    ST: "KS",
    cityWithStateAbbr: "Bonner Springs, KS",
  },
  {
    zip: "66013",
    ST: "KS",
    cityWithStateAbbr: "Bucyrus, KS",
  },
  {
    zip: "66014",
    ST: "KS",
    cityWithStateAbbr: "Centerville, KS",
  },
  {
    zip: "66015",
    ST: "KS",
    cityWithStateAbbr: "Colony, KS",
  },
  {
    zip: "66016",
    ST: "KS",
    cityWithStateAbbr: "Cummings, KS",
  },
  {
    zip: "66017",
    ST: "KS",
    cityWithStateAbbr: "Denton, KS",
  },
  {
    zip: "66018",
    ST: "KS",
    cityWithStateAbbr: "De Soto, KS",
  },
  {
    zip: "66019",
    ST: "KS",
    cityWithStateAbbr: "Clearview City, KS",
  },
  {
    zip: "66020",
    ST: "KS",
    cityWithStateAbbr: "Easton, KS",
  },
  {
    zip: "66021",
    ST: "KS",
    cityWithStateAbbr: "Edgerton, KS",
  },
  {
    zip: "66023",
    ST: "KS",
    cityWithStateAbbr: "Effingham, KS",
  },
  {
    zip: "66024",
    ST: "KS",
    cityWithStateAbbr: "Elwood, KS",
  },
  {
    zip: "66025",
    ST: "KS",
    cityWithStateAbbr: "Eudora, KS",
  },
  {
    zip: "66026",
    ST: "KS",
    cityWithStateAbbr: "Fontana, KS",
  },
  {
    zip: "66027",
    ST: "KS",
    cityWithStateAbbr: "Fort Leavenworth, KS",
  },
  {
    zip: "66030",
    ST: "KS",
    cityWithStateAbbr: "Gardner, KS",
  },
  {
    zip: "66031",
    ST: "KS",
    cityWithStateAbbr: "New Century, KS",
  },
  {
    zip: "66032",
    ST: "KS",
    cityWithStateAbbr: "Garnett, KS",
  },
  {
    zip: "66033",
    ST: "KS",
    cityWithStateAbbr: "Greeley, KS",
  },
  {
    zip: "66035",
    ST: "KS",
    cityWithStateAbbr: "Highland, KS",
  },
  {
    zip: "66036",
    ST: "KS",
    cityWithStateAbbr: "Hillsdale, KS",
  },
  {
    zip: "66039",
    ST: "KS",
    cityWithStateAbbr: "Kincaid, KS",
  },
  {
    zip: "66040",
    ST: "KS",
    cityWithStateAbbr: "Lacygne, KS",
  },
  {
    zip: "66041",
    ST: "KS",
    cityWithStateAbbr: "Lancaster, KS",
  },
  {
    zip: "66042",
    ST: "KS",
    cityWithStateAbbr: "Lane, KS",
  },
  {
    zip: "66043",
    ST: "KS",
    cityWithStateAbbr: "Lansing, KS",
  },
  {
    zip: "66044",
    ST: "KS",
    cityWithStateAbbr: "Lawrence, KS",
  },
  {
    zip: "66045",
    ST: "KS",
    cityWithStateAbbr: "Lawrence, KS",
  },
  {
    zip: "66046",
    ST: "KS",
    cityWithStateAbbr: "Lawrence, KS",
  },
  {
    zip: "66047",
    ST: "KS",
    cityWithStateAbbr: "Lawrence, KS",
  },
  {
    zip: "66048",
    ST: "KS",
    cityWithStateAbbr: "Leavenworth, KS",
  },
  {
    zip: "66049",
    ST: "KS",
    cityWithStateAbbr: "Lawrence, KS",
  },
  {
    zip: "66050",
    ST: "KS",
    cityWithStateAbbr: "Lecompton, KS",
  },
  {
    zip: "66051",
    ST: "KS",
    cityWithStateAbbr: "Olathe, KS",
  },
  {
    zip: "66052",
    ST: "KS",
    cityWithStateAbbr: "Linwood, KS",
  },
  {
    zip: "66053",
    ST: "KS",
    cityWithStateAbbr: "Louisburg, KS",
  },
  {
    zip: "66054",
    ST: "KS",
    cityWithStateAbbr: "Mc Louth, KS",
  },
  {
    zip: "66056",
    ST: "KS",
    cityWithStateAbbr: "Mound City, KS",
  },
  {
    zip: "66058",
    ST: "KS",
    cityWithStateAbbr: "Muscotah, KS",
  },
  {
    zip: "66060",
    ST: "KS",
    cityWithStateAbbr: "Nortonville, KS",
  },
  {
    zip: "66061",
    ST: "KS",
    cityWithStateAbbr: "Olathe, KS",
  },
  {
    zip: "66062",
    ST: "KS",
    cityWithStateAbbr: "Olathe, KS",
  },
  {
    zip: "66063",
    ST: "KS",
    cityWithStateAbbr: "Olathe, KS",
  },
  {
    zip: "66064",
    ST: "KS",
    cityWithStateAbbr: "Osawatomie, KS",
  },
  {
    zip: "66066",
    ST: "KS",
    cityWithStateAbbr: "Oskaloosa, KS",
  },
  {
    zip: "66067",
    ST: "KS",
    cityWithStateAbbr: "Ottawa, KS",
  },
  {
    zip: "66070",
    ST: "KS",
    cityWithStateAbbr: "Ozawkie, KS",
  },
  {
    zip: "66071",
    ST: "KS",
    cityWithStateAbbr: "Paola, KS",
  },
  {
    zip: "66072",
    ST: "KS",
    cityWithStateAbbr: "Parker, KS",
  },
  {
    zip: "66073",
    ST: "KS",
    cityWithStateAbbr: "Perry, KS",
  },
  {
    zip: "66075",
    ST: "KS",
    cityWithStateAbbr: "Pleasanton, KS",
  },
  {
    zip: "66076",
    ST: "KS",
    cityWithStateAbbr: "Pomona, KS",
  },
  {
    zip: "66078",
    ST: "KS",
    cityWithStateAbbr: "Princeton, KS",
  },
  {
    zip: "66079",
    ST: "KS",
    cityWithStateAbbr: "Rantoul, KS",
  },
  {
    zip: "66080",
    ST: "KS",
    cityWithStateAbbr: "Richmond, KS",
  },
  {
    zip: "66083",
    ST: "KS",
    cityWithStateAbbr: "Spring Hill, KS",
  },
  {
    zip: "66085",
    ST: "KS",
    cityWithStateAbbr: "Stilwell, KS",
  },
  {
    zip: "66086",
    ST: "KS",
    cityWithStateAbbr: "Tonganoxie, KS",
  },
  {
    zip: "66087",
    ST: "KS",
    cityWithStateAbbr: "Troy, KS",
  },
  {
    zip: "66088",
    ST: "KS",
    cityWithStateAbbr: "Valley Falls, KS",
  },
  {
    zip: "66090",
    ST: "KS",
    cityWithStateAbbr: "Wathena, KS",
  },
  {
    zip: "66091",
    ST: "KS",
    cityWithStateAbbr: "Welda, KS",
  },
  {
    zip: "66092",
    ST: "KS",
    cityWithStateAbbr: "Wellsville, KS",
  },
  {
    zip: "66093",
    ST: "KS",
    cityWithStateAbbr: "Westphalia, KS",
  },
  {
    zip: "66094",
    ST: "KS",
    cityWithStateAbbr: "White Cloud, KS",
  },
  {
    zip: "66095",
    ST: "KS",
    cityWithStateAbbr: "Williamsburg, KS",
  },
  {
    zip: "66097",
    ST: "KS",
    cityWithStateAbbr: "Winchester, KS",
  },
  {
    zip: "66101",
    ST: "KS",
    cityWithStateAbbr: "Kansas City, KS",
  },
  {
    zip: "66102",
    ST: "KS",
    cityWithStateAbbr: "Kansas City, KS",
  },
  {
    zip: "66103",
    ST: "KS",
    cityWithStateAbbr: "Kansas City, KS",
  },
  {
    zip: "66104",
    ST: "KS",
    cityWithStateAbbr: "Kansas City, KS",
  },
  {
    zip: "66105",
    ST: "KS",
    cityWithStateAbbr: "Kansas City, KS",
  },
  {
    zip: "66106",
    ST: "KS",
    cityWithStateAbbr: "Kansas City, KS",
  },
  {
    zip: "66109",
    ST: "KS",
    cityWithStateAbbr: "Kansas City, KS",
  },
  {
    zip: "66110",
    ST: "KS",
    cityWithStateAbbr: "Kansas City, KS",
  },
  {
    zip: "66111",
    ST: "KS",
    cityWithStateAbbr: "Kansas City, KS",
  },
  {
    zip: "66112",
    ST: "KS",
    cityWithStateAbbr: "Kansas City, KS",
  },
  {
    zip: "66113",
    ST: "KS",
    cityWithStateAbbr: "Edwardsville, KS",
  },
  {
    zip: "66115",
    ST: "KS",
    cityWithStateAbbr: "Kansas City, KS",
  },
  {
    zip: "66117",
    ST: "KS",
    cityWithStateAbbr: "Kansas City, KS",
  },
  {
    zip: "66118",
    ST: "KS",
    cityWithStateAbbr: "Kansas City, KS",
  },
  {
    zip: "66119",
    ST: "KS",
    cityWithStateAbbr: "Kansas City, KS",
  },
  {
    zip: "66160",
    ST: "KS",
    cityWithStateAbbr: "Kansas City, KS",
  },
  {
    zip: "66201",
    ST: "KS",
    cityWithStateAbbr: "Mission, KS",
  },
  {
    zip: "66202",
    ST: "KS",
    cityWithStateAbbr: "Mission, KS",
  },
  {
    zip: "66203",
    ST: "KS",
    cityWithStateAbbr: "Shawnee, KS",
  },
  {
    zip: "66204",
    ST: "KS",
    cityWithStateAbbr: "Overland Park, KS",
  },
  {
    zip: "66205",
    ST: "KS",
    cityWithStateAbbr: "Mission, KS",
  },
  {
    zip: "66206",
    ST: "KS",
    cityWithStateAbbr: "Leawood, KS",
  },
  {
    zip: "66207",
    ST: "KS",
    cityWithStateAbbr: "Overland Park, KS",
  },
  {
    zip: "66208",
    ST: "KS",
    cityWithStateAbbr: "Prairie Village, KS",
  },
  {
    zip: "66209",
    ST: "KS",
    cityWithStateAbbr: "Leawood, KS",
  },
  {
    zip: "66210",
    ST: "KS",
    cityWithStateAbbr: "Overland Park, KS",
  },
  {
    zip: "66211",
    ST: "KS",
    cityWithStateAbbr: "Leawood, KS",
  },
  {
    zip: "66212",
    ST: "KS",
    cityWithStateAbbr: "Overland Park, KS",
  },
  {
    zip: "66213",
    ST: "KS",
    cityWithStateAbbr: "Overland Park, KS",
  },
  {
    zip: "66214",
    ST: "KS",
    cityWithStateAbbr: "Overland Park, KS",
  },
  {
    zip: "66215",
    ST: "KS",
    cityWithStateAbbr: "Lenexa, KS",
  },
  {
    zip: "66216",
    ST: "KS",
    cityWithStateAbbr: "Shawnee, KS",
  },
  {
    zip: "66217",
    ST: "KS",
    cityWithStateAbbr: "Shawnee, KS",
  },
  {
    zip: "66218",
    ST: "KS",
    cityWithStateAbbr: "Shawnee, KS",
  },
  {
    zip: "66219",
    ST: "KS",
    cityWithStateAbbr: "Lenexa, KS",
  },
  {
    zip: "66220",
    ST: "KS",
    cityWithStateAbbr: "Lenexa, KS",
  },
  {
    zip: "66221",
    ST: "KS",
    cityWithStateAbbr: "Overland Park, KS",
  },
  {
    zip: "66222",
    ST: "KS",
    cityWithStateAbbr: "Mission, KS",
  },
  {
    zip: "66223",
    ST: "KS",
    cityWithStateAbbr: "Overland Park, KS",
  },
  {
    zip: "66224",
    ST: "KS",
    cityWithStateAbbr: "Overland Park, KS",
  },
  {
    zip: "66225",
    ST: "KS",
    cityWithStateAbbr: "Overland Park, KS",
  },
  {
    zip: "66226",
    ST: "KS",
    cityWithStateAbbr: "Shawnee, KS",
  },
  {
    zip: "66227",
    ST: "KS",
    cityWithStateAbbr: "Lenexa, KS",
  },
  {
    zip: "66250",
    ST: "KS",
    cityWithStateAbbr: "Lenexa, KS",
  },
  {
    zip: "66251",
    ST: "KS",
    cityWithStateAbbr: "Overland Park, KS",
  },
  {
    zip: "66276",
    ST: "KS",
    cityWithStateAbbr: "Lenexa, KS",
  },
  {
    zip: "66282",
    ST: "KS",
    cityWithStateAbbr: "Overland Park, KS",
  },
  {
    zip: "66283",
    ST: "KS",
    cityWithStateAbbr: "Overland Park, KS",
  },
  {
    zip: "66285",
    ST: "KS",
    cityWithStateAbbr: "Lenexa, KS",
  },
  {
    zip: "66286",
    ST: "KS",
    cityWithStateAbbr: "Shawnee, KS",
  },
  {
    zip: "66401",
    ST: "KS",
    cityWithStateAbbr: "Alma, KS",
  },
  {
    zip: "66402",
    ST: "KS",
    cityWithStateAbbr: "Auburn, KS",
  },
  {
    zip: "66403",
    ST: "KS",
    cityWithStateAbbr: "Axtell, KS",
  },
  {
    zip: "66404",
    ST: "KS",
    cityWithStateAbbr: "Baileyville, KS",
  },
  {
    zip: "66406",
    ST: "KS",
    cityWithStateAbbr: "Beattie, KS",
  },
  {
    zip: "66407",
    ST: "KS",
    cityWithStateAbbr: "Belvue, KS",
  },
  {
    zip: "66408",
    ST: "KS",
    cityWithStateAbbr: "Bern, KS",
  },
  {
    zip: "66409",
    ST: "KS",
    cityWithStateAbbr: "Berryton, KS",
  },
  {
    zip: "66411",
    ST: "KS",
    cityWithStateAbbr: "Blue Rapids, KS",
  },
  {
    zip: "66412",
    ST: "KS",
    cityWithStateAbbr: "Bremen, KS",
  },
  {
    zip: "66413",
    ST: "KS",
    cityWithStateAbbr: "Burlingame, KS",
  },
  {
    zip: "66414",
    ST: "KS",
    cityWithStateAbbr: "Carbondale, KS",
  },
  {
    zip: "66415",
    ST: "KS",
    cityWithStateAbbr: "Centralia, KS",
  },
  {
    zip: "66416",
    ST: "KS",
    cityWithStateAbbr: "Circleville, KS",
  },
  {
    zip: "66417",
    ST: "KS",
    cityWithStateAbbr: "Corning, KS",
  },
  {
    zip: "66418",
    ST: "KS",
    cityWithStateAbbr: "Delia, KS",
  },
  {
    zip: "66419",
    ST: "KS",
    cityWithStateAbbr: "Denison, KS",
  },
  {
    zip: "66420",
    ST: "KS",
    cityWithStateAbbr: "Dover, KS",
  },
  {
    zip: "66422",
    ST: "KS",
    cityWithStateAbbr: "Emmett, KS",
  },
  {
    zip: "66423",
    ST: "KS",
    cityWithStateAbbr: "Eskridge, KS",
  },
  {
    zip: "66424",
    ST: "KS",
    cityWithStateAbbr: "Everest, KS",
  },
  {
    zip: "66425",
    ST: "KS",
    cityWithStateAbbr: "Fairview, KS",
  },
  {
    zip: "66426",
    ST: "KS",
    cityWithStateAbbr: "Fostoria, KS",
  },
  {
    zip: "66427",
    ST: "KS",
    cityWithStateAbbr: "Frankfort, KS",
  },
  {
    zip: "66428",
    ST: "KS",
    cityWithStateAbbr: "Goff, KS",
  },
  {
    zip: "66429",
    ST: "KS",
    cityWithStateAbbr: "Grantville, KS",
  },
  {
    zip: "66431",
    ST: "KS",
    cityWithStateAbbr: "Harveyville, KS",
  },
  {
    zip: "66432",
    ST: "KS",
    cityWithStateAbbr: "Havensville, KS",
  },
  {
    zip: "66434",
    ST: "KS",
    cityWithStateAbbr: "Hiawatha, KS",
  },
  {
    zip: "66436",
    ST: "KS",
    cityWithStateAbbr: "Holton, KS",
  },
  {
    zip: "66438",
    ST: "KS",
    cityWithStateAbbr: "Home, KS",
  },
  {
    zip: "66439",
    ST: "KS",
    cityWithStateAbbr: "Horton, KS",
  },
  {
    zip: "66440",
    ST: "KS",
    cityWithStateAbbr: "Hoyt, KS",
  },
  {
    zip: "66441",
    ST: "KS",
    cityWithStateAbbr: "Junction City, KS",
  },
  {
    zip: "66442",
    ST: "KS",
    cityWithStateAbbr: "Fort Riley, KS",
  },
  {
    zip: "66449",
    ST: "KS",
    cityWithStateAbbr: "Leonardville, KS",
  },
  {
    zip: "66451",
    ST: "KS",
    cityWithStateAbbr: "Lyndon, KS",
  },
  {
    zip: "66501",
    ST: "KS",
    cityWithStateAbbr: "Mc Farland, KS",
  },
  {
    zip: "66502",
    ST: "KS",
    cityWithStateAbbr: "Manhattan, KS",
  },
  {
    zip: "66503",
    ST: "KS",
    cityWithStateAbbr: "Manhattan, KS",
  },
  {
    zip: "66505",
    ST: "KS",
    cityWithStateAbbr: "Manhattan, KS",
  },
  {
    zip: "66506",
    ST: "KS",
    cityWithStateAbbr: "Manhattan, KS",
  },
  {
    zip: "66507",
    ST: "KS",
    cityWithStateAbbr: "Maple Hill, KS",
  },
  {
    zip: "66508",
    ST: "KS",
    cityWithStateAbbr: "Marysville, KS",
  },
  {
    zip: "66509",
    ST: "KS",
    cityWithStateAbbr: "Mayetta, KS",
  },
  {
    zip: "66510",
    ST: "KS",
    cityWithStateAbbr: "Melvern, KS",
  },
  {
    zip: "66512",
    ST: "KS",
    cityWithStateAbbr: "Meriden, KS",
  },
  {
    zip: "66514",
    ST: "KS",
    cityWithStateAbbr: "Milford, KS",
  },
  {
    zip: "66515",
    ST: "KS",
    cityWithStateAbbr: "Morrill, KS",
  },
  {
    zip: "66516",
    ST: "KS",
    cityWithStateAbbr: "Netawaka, KS",
  },
  {
    zip: "66517",
    ST: "KS",
    cityWithStateAbbr: "Ogden, KS",
  },
  {
    zip: "66518",
    ST: "KS",
    cityWithStateAbbr: "Oketo, KS",
  },
  {
    zip: "66520",
    ST: "KS",
    cityWithStateAbbr: "Olsburg, KS",
  },
  {
    zip: "66521",
    ST: "KS",
    cityWithStateAbbr: "Onaga, KS",
  },
  {
    zip: "66522",
    ST: "KS",
    cityWithStateAbbr: "Oneida, KS",
  },
  {
    zip: "66523",
    ST: "KS",
    cityWithStateAbbr: "Osage City, KS",
  },
  {
    zip: "66524",
    ST: "KS",
    cityWithStateAbbr: "Overbrook, KS",
  },
  {
    zip: "66526",
    ST: "KS",
    cityWithStateAbbr: "Paxico, KS",
  },
  {
    zip: "66527",
    ST: "KS",
    cityWithStateAbbr: "Powhattan, KS",
  },
  {
    zip: "66528",
    ST: "KS",
    cityWithStateAbbr: "Quenemo, KS",
  },
  {
    zip: "66531",
    ST: "KS",
    cityWithStateAbbr: "Riley, KS",
  },
  {
    zip: "66532",
    ST: "KS",
    cityWithStateAbbr: "Robinson, KS",
  },
  {
    zip: "66533",
    ST: "KS",
    cityWithStateAbbr: "Rossville, KS",
  },
  {
    zip: "66534",
    ST: "KS",
    cityWithStateAbbr: "Sabetha, KS",
  },
  {
    zip: "66535",
    ST: "KS",
    cityWithStateAbbr: "Saint George, KS",
  },
  {
    zip: "66536",
    ST: "KS",
    cityWithStateAbbr: "Saint Marys, KS",
  },
  {
    zip: "66537",
    ST: "KS",
    cityWithStateAbbr: "Scranton, KS",
  },
  {
    zip: "66538",
    ST: "KS",
    cityWithStateAbbr: "Seneca, KS",
  },
  {
    zip: "66539",
    ST: "KS",
    cityWithStateAbbr: "Silver Lake, KS",
  },
  {
    zip: "66540",
    ST: "KS",
    cityWithStateAbbr: "Soldier, KS",
  },
  {
    zip: "66541",
    ST: "KS",
    cityWithStateAbbr: "Summerfield, KS",
  },
  {
    zip: "66542",
    ST: "KS",
    cityWithStateAbbr: "Tecumseh, KS",
  },
  {
    zip: "66543",
    ST: "KS",
    cityWithStateAbbr: "Vassar, KS",
  },
  {
    zip: "66544",
    ST: "KS",
    cityWithStateAbbr: "Vermillion, KS",
  },
  {
    zip: "66546",
    ST: "KS",
    cityWithStateAbbr: "Wakarusa, KS",
  },
  {
    zip: "66547",
    ST: "KS",
    cityWithStateAbbr: "Wamego, KS",
  },
  {
    zip: "66548",
    ST: "KS",
    cityWithStateAbbr: "Waterville, KS",
  },
  {
    zip: "66549",
    ST: "KS",
    cityWithStateAbbr: "Westmoreland, KS",
  },
  {
    zip: "66550",
    ST: "KS",
    cityWithStateAbbr: "Wetmore, KS",
  },
  {
    zip: "66552",
    ST: "KS",
    cityWithStateAbbr: "Whiting, KS",
  },
  {
    zip: "66554",
    ST: "KS",
    cityWithStateAbbr: "Randolph, KS",
  },
  {
    zip: "66601",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66603",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66604",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66605",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66606",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66607",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66608",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66609",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66610",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66611",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66612",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66614",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66615",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66616",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66617",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66618",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66619",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66620",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66621",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66622",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66624",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66625",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66626",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66628",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66629",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66636",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66647",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66667",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66675",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66683",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66699",
    ST: "KS",
    cityWithStateAbbr: "Topeka, KS",
  },
  {
    zip: "66701",
    ST: "KS",
    cityWithStateAbbr: "Fort Scott, KS",
  },
  {
    zip: "66710",
    ST: "KS",
    cityWithStateAbbr: "Altoona, KS",
  },
  {
    zip: "66711",
    ST: "KS",
    cityWithStateAbbr: "Arcadia, KS",
  },
  {
    zip: "66712",
    ST: "KS",
    cityWithStateAbbr: "Arma, KS",
  },
  {
    zip: "66713",
    ST: "KS",
    cityWithStateAbbr: "Baxter Springs, KS",
  },
  {
    zip: "66714",
    ST: "KS",
    cityWithStateAbbr: "Benedict, KS",
  },
  {
    zip: "66716",
    ST: "KS",
    cityWithStateAbbr: "Bronson, KS",
  },
  {
    zip: "66717",
    ST: "KS",
    cityWithStateAbbr: "Buffalo, KS",
  },
  {
    zip: "66720",
    ST: "KS",
    cityWithStateAbbr: "Chanute, KS",
  },
  {
    zip: "66724",
    ST: "KS",
    cityWithStateAbbr: "Cherokee, KS",
  },
  {
    zip: "66725",
    ST: "KS",
    cityWithStateAbbr: "Columbus, KS",
  },
  {
    zip: "66728",
    ST: "KS",
    cityWithStateAbbr: "Crestline, KS",
  },
  {
    zip: "66732",
    ST: "KS",
    cityWithStateAbbr: "Elsmore, KS",
  },
  {
    zip: "66733",
    ST: "KS",
    cityWithStateAbbr: "Erie, KS",
  },
  {
    zip: "66734",
    ST: "KS",
    cityWithStateAbbr: "Farlington, KS",
  },
  {
    zip: "66735",
    ST: "KS",
    cityWithStateAbbr: "Franklin, KS",
  },
  {
    zip: "66736",
    ST: "KS",
    cityWithStateAbbr: "Fredonia, KS",
  },
  {
    zip: "66738",
    ST: "KS",
    cityWithStateAbbr: "Fulton, KS",
  },
  {
    zip: "66739",
    ST: "KS",
    cityWithStateAbbr: "Galena, KS",
  },
  {
    zip: "66740",
    ST: "KS",
    cityWithStateAbbr: "Galesburg, KS",
  },
  {
    zip: "66741",
    ST: "KS",
    cityWithStateAbbr: "Garland, KS",
  },
  {
    zip: "66742",
    ST: "KS",
    cityWithStateAbbr: "Gas, KS",
  },
  {
    zip: "66743",
    ST: "KS",
    cityWithStateAbbr: "Girard, KS",
  },
  {
    zip: "66746",
    ST: "KS",
    cityWithStateAbbr: "Hepler, KS",
  },
  {
    zip: "66748",
    ST: "KS",
    cityWithStateAbbr: "Humboldt, KS",
  },
  {
    zip: "66749",
    ST: "KS",
    cityWithStateAbbr: "Iola, KS",
  },
  {
    zip: "66751",
    ST: "KS",
    cityWithStateAbbr: "La Harpe, KS",
  },
  {
    zip: "66753",
    ST: "KS",
    cityWithStateAbbr: "Mc Cune, KS",
  },
  {
    zip: "66754",
    ST: "KS",
    cityWithStateAbbr: "Mapleton, KS",
  },
  {
    zip: "66755",
    ST: "KS",
    cityWithStateAbbr: "Moran, KS",
  },
  {
    zip: "66756",
    ST: "KS",
    cityWithStateAbbr: "Mulberry, KS",
  },
  {
    zip: "66757",
    ST: "KS",
    cityWithStateAbbr: "Neodesha, KS",
  },
  {
    zip: "66758",
    ST: "KS",
    cityWithStateAbbr: "Neosho Falls, KS",
  },
  {
    zip: "66759",
    ST: "KS",
    cityWithStateAbbr: "New Albany, KS",
  },
  {
    zip: "66760",
    ST: "KS",
    cityWithStateAbbr: "Opolis, KS",
  },
  {
    zip: "66761",
    ST: "KS",
    cityWithStateAbbr: "Piqua, KS",
  },
  {
    zip: "66762",
    ST: "KS",
    cityWithStateAbbr: "Pittsburg, KS",
  },
  {
    zip: "66763",
    ST: "KS",
    cityWithStateAbbr: "Frontenac, KS",
  },
  {
    zip: "66767",
    ST: "KS",
    cityWithStateAbbr: "Prescott, KS",
  },
  {
    zip: "66769",
    ST: "KS",
    cityWithStateAbbr: "Redfield, KS",
  },
  {
    zip: "66770",
    ST: "KS",
    cityWithStateAbbr: "Riverton, KS",
  },
  {
    zip: "66771",
    ST: "KS",
    cityWithStateAbbr: "Saint Paul, KS",
  },
  {
    zip: "66772",
    ST: "KS",
    cityWithStateAbbr: "Savonburg, KS",
  },
  {
    zip: "66773",
    ST: "KS",
    cityWithStateAbbr: "Scammon, KS",
  },
  {
    zip: "66775",
    ST: "KS",
    cityWithStateAbbr: "Stark, KS",
  },
  {
    zip: "66776",
    ST: "KS",
    cityWithStateAbbr: "Thayer, KS",
  },
  {
    zip: "66777",
    ST: "KS",
    cityWithStateAbbr: "Toronto, KS",
  },
  {
    zip: "66778",
    ST: "KS",
    cityWithStateAbbr: "Treece, KS",
  },
  {
    zip: "66779",
    ST: "KS",
    cityWithStateAbbr: "Uniontown, KS",
  },
  {
    zip: "66780",
    ST: "KS",
    cityWithStateAbbr: "Walnut, KS",
  },
  {
    zip: "66781",
    ST: "KS",
    cityWithStateAbbr: "Weir, KS",
  },
  {
    zip: "66782",
    ST: "KS",
    cityWithStateAbbr: "West Mineral, KS",
  },
  {
    zip: "66783",
    ST: "KS",
    cityWithStateAbbr: "Yates Center, KS",
  },
  {
    zip: "66801",
    ST: "KS",
    cityWithStateAbbr: "Emporia, KS",
  },
  {
    zip: "66830",
    ST: "KS",
    cityWithStateAbbr: "Admire, KS",
  },
  {
    zip: "66833",
    ST: "KS",
    cityWithStateAbbr: "Allen, KS",
  },
  {
    zip: "66834",
    ST: "KS",
    cityWithStateAbbr: "Alta Vista, KS",
  },
  {
    zip: "66835",
    ST: "KS",
    cityWithStateAbbr: "Americus, KS",
  },
  {
    zip: "66838",
    ST: "KS",
    cityWithStateAbbr: "Burdick, KS",
  },
  {
    zip: "66839",
    ST: "KS",
    cityWithStateAbbr: "Burlington, KS",
  },
  {
    zip: "66840",
    ST: "KS",
    cityWithStateAbbr: "Burns, KS",
  },
  {
    zip: "66842",
    ST: "KS",
    cityWithStateAbbr: "Cassoday, KS",
  },
  {
    zip: "66843",
    ST: "KS",
    cityWithStateAbbr: "Cedar Point, KS",
  },
  {
    zip: "66845",
    ST: "KS",
    cityWithStateAbbr: "Cottonwood Falls, KS",
  },
  {
    zip: "66846",
    ST: "KS",
    cityWithStateAbbr: "Council Grove, KS",
  },
  {
    zip: "66849",
    ST: "KS",
    cityWithStateAbbr: "Dwight, KS",
  },
  {
    zip: "66850",
    ST: "KS",
    cityWithStateAbbr: "Elmdale, KS",
  },
  {
    zip: "66851",
    ST: "KS",
    cityWithStateAbbr: "Florence, KS",
  },
  {
    zip: "66852",
    ST: "KS",
    cityWithStateAbbr: "Gridley, KS",
  },
  {
    zip: "66853",
    ST: "KS",
    cityWithStateAbbr: "Hamilton, KS",
  },
  {
    zip: "66854",
    ST: "KS",
    cityWithStateAbbr: "Hartford, KS",
  },
  {
    zip: "66855",
    ST: "KS",
    cityWithStateAbbr: "Lamont, KS",
  },
  {
    zip: "66856",
    ST: "KS",
    cityWithStateAbbr: "Lebo, KS",
  },
  {
    zip: "66857",
    ST: "KS",
    cityWithStateAbbr: "Le Roy, KS",
  },
  {
    zip: "66858",
    ST: "KS",
    cityWithStateAbbr: "Lincolnville, KS",
  },
  {
    zip: "66859",
    ST: "KS",
    cityWithStateAbbr: "Lost Springs, KS",
  },
  {
    zip: "66860",
    ST: "KS",
    cityWithStateAbbr: "Madison, KS",
  },
  {
    zip: "66861",
    ST: "KS",
    cityWithStateAbbr: "Marion, KS",
  },
  {
    zip: "66862",
    ST: "KS",
    cityWithStateAbbr: "Matfield Green, KS",
  },
  {
    zip: "66863",
    ST: "KS",
    cityWithStateAbbr: "Neal, KS",
  },
  {
    zip: "66864",
    ST: "KS",
    cityWithStateAbbr: "Neosho Rapids, KS",
  },
  {
    zip: "66865",
    ST: "KS",
    cityWithStateAbbr: "Olpe, KS",
  },
  {
    zip: "66866",
    ST: "KS",
    cityWithStateAbbr: "Peabody, KS",
  },
  {
    zip: "66868",
    ST: "KS",
    cityWithStateAbbr: "Reading, KS",
  },
  {
    zip: "66869",
    ST: "KS",
    cityWithStateAbbr: "Strong City, KS",
  },
  {
    zip: "66870",
    ST: "KS",
    cityWithStateAbbr: "Virgil, KS",
  },
  {
    zip: "66871",
    ST: "KS",
    cityWithStateAbbr: "Waverly, KS",
  },
  {
    zip: "66872",
    ST: "KS",
    cityWithStateAbbr: "White City, KS",
  },
  {
    zip: "66873",
    ST: "KS",
    cityWithStateAbbr: "Wilsey, KS",
  },
  {
    zip: "66901",
    ST: "KS",
    cityWithStateAbbr: "Concordia, KS",
  },
  {
    zip: "66930",
    ST: "KS",
    cityWithStateAbbr: "Agenda, KS",
  },
  {
    zip: "66932",
    ST: "KS",
    cityWithStateAbbr: "Athol, KS",
  },
  {
    zip: "66933",
    ST: "KS",
    cityWithStateAbbr: "Barnes, KS",
  },
  {
    zip: "66935",
    ST: "KS",
    cityWithStateAbbr: "Belleville, KS",
  },
  {
    zip: "66936",
    ST: "KS",
    cityWithStateAbbr: "Burr Oak, KS",
  },
  {
    zip: "66937",
    ST: "KS",
    cityWithStateAbbr: "Clifton, KS",
  },
  {
    zip: "66938",
    ST: "KS",
    cityWithStateAbbr: "Clyde, KS",
  },
  {
    zip: "66939",
    ST: "KS",
    cityWithStateAbbr: "Courtland, KS",
  },
  {
    zip: "66940",
    ST: "KS",
    cityWithStateAbbr: "Cuba, KS",
  },
  {
    zip: "66941",
    ST: "KS",
    cityWithStateAbbr: "Esbon, KS",
  },
  {
    zip: "66942",
    ST: "KS",
    cityWithStateAbbr: "Formoso, KS",
  },
  {
    zip: "66943",
    ST: "KS",
    cityWithStateAbbr: "Greenleaf, KS",
  },
  {
    zip: "66944",
    ST: "KS",
    cityWithStateAbbr: "Haddam, KS",
  },
  {
    zip: "66945",
    ST: "KS",
    cityWithStateAbbr: "Hanover, KS",
  },
  {
    zip: "66946",
    ST: "KS",
    cityWithStateAbbr: "Hollenberg, KS",
  },
  {
    zip: "66948",
    ST: "KS",
    cityWithStateAbbr: "Jamestown, KS",
  },
  {
    zip: "66949",
    ST: "KS",
    cityWithStateAbbr: "Jewell, KS",
  },
  {
    zip: "66951",
    ST: "KS",
    cityWithStateAbbr: "Kensington, KS",
  },
  {
    zip: "66952",
    ST: "KS",
    cityWithStateAbbr: "Lebanon, KS",
  },
  {
    zip: "66953",
    ST: "KS",
    cityWithStateAbbr: "Linn, KS",
  },
  {
    zip: "66955",
    ST: "KS",
    cityWithStateAbbr: "Mahaska, KS",
  },
  {
    zip: "66956",
    ST: "KS",
    cityWithStateAbbr: "Mankato, KS",
  },
  {
    zip: "66958",
    ST: "KS",
    cityWithStateAbbr: "Morrowville, KS",
  },
  {
    zip: "66959",
    ST: "KS",
    cityWithStateAbbr: "Munden, KS",
  },
  {
    zip: "66960",
    ST: "KS",
    cityWithStateAbbr: "Narka, KS",
  },
  {
    zip: "66961",
    ST: "KS",
    cityWithStateAbbr: "Norway, KS",
  },
  {
    zip: "66962",
    ST: "KS",
    cityWithStateAbbr: "Palmer, KS",
  },
  {
    zip: "66963",
    ST: "KS",
    cityWithStateAbbr: "Randall, KS",
  },
  {
    zip: "66964",
    ST: "KS",
    cityWithStateAbbr: "Republic, KS",
  },
  {
    zip: "66966",
    ST: "KS",
    cityWithStateAbbr: "Scandia, KS",
  },
  {
    zip: "66967",
    ST: "KS",
    cityWithStateAbbr: "Smith Center, KS",
  },
  {
    zip: "66968",
    ST: "KS",
    cityWithStateAbbr: "Washington, KS",
  },
  {
    zip: "66970",
    ST: "KS",
    cityWithStateAbbr: "Webber, KS",
  },
  {
    zip: "67001",
    ST: "KS",
    cityWithStateAbbr: "Andale, KS",
  },
  {
    zip: "67002",
    ST: "KS",
    cityWithStateAbbr: "Andover, KS",
  },
  {
    zip: "67003",
    ST: "KS",
    cityWithStateAbbr: "Anthony, KS",
  },
  {
    zip: "67004",
    ST: "KS",
    cityWithStateAbbr: "Argonia, KS",
  },
  {
    zip: "67005",
    ST: "KS",
    cityWithStateAbbr: "Arkansas City, KS",
  },
  {
    zip: "67008",
    ST: "KS",
    cityWithStateAbbr: "Atlanta, KS",
  },
  {
    zip: "67009",
    ST: "KS",
    cityWithStateAbbr: "Attica, KS",
  },
  {
    zip: "67010",
    ST: "KS",
    cityWithStateAbbr: "Augusta, KS",
  },
  {
    zip: "67012",
    ST: "KS",
    cityWithStateAbbr: "Beaumont, KS",
  },
  {
    zip: "67013",
    ST: "KS",
    cityWithStateAbbr: "Belle Plaine, KS",
  },
  {
    zip: "67016",
    ST: "KS",
    cityWithStateAbbr: "Bentley, KS",
  },
  {
    zip: "67017",
    ST: "KS",
    cityWithStateAbbr: "Benton, KS",
  },
  {
    zip: "67018",
    ST: "KS",
    cityWithStateAbbr: "Bluff City, KS",
  },
  {
    zip: "67019",
    ST: "KS",
    cityWithStateAbbr: "Burden, KS",
  },
  {
    zip: "67020",
    ST: "KS",
    cityWithStateAbbr: "Burrton, KS",
  },
  {
    zip: "67021",
    ST: "KS",
    cityWithStateAbbr: "Byers, KS",
  },
  {
    zip: "67022",
    ST: "KS",
    cityWithStateAbbr: "Caldwell, KS",
  },
  {
    zip: "67023",
    ST: "KS",
    cityWithStateAbbr: "Cambridge, KS",
  },
  {
    zip: "67024",
    ST: "KS",
    cityWithStateAbbr: "Cedar Vale, KS",
  },
  {
    zip: "67025",
    ST: "KS",
    cityWithStateAbbr: "Cheney, KS",
  },
  {
    zip: "67026",
    ST: "KS",
    cityWithStateAbbr: "Clearwater, KS",
  },
  {
    zip: "67028",
    ST: "KS",
    cityWithStateAbbr: "Coats, KS",
  },
  {
    zip: "67029",
    ST: "KS",
    cityWithStateAbbr: "Coldwater, KS",
  },
  {
    zip: "67030",
    ST: "KS",
    cityWithStateAbbr: "Colwich, KS",
  },
  {
    zip: "67031",
    ST: "KS",
    cityWithStateAbbr: "Conway Springs, KS",
  },
  {
    zip: "67035",
    ST: "KS",
    cityWithStateAbbr: "Cunningham, KS",
  },
  {
    zip: "67036",
    ST: "KS",
    cityWithStateAbbr: "Danville, KS",
  },
  {
    zip: "67037",
    ST: "KS",
    cityWithStateAbbr: "Derby, KS",
  },
  {
    zip: "67038",
    ST: "KS",
    cityWithStateAbbr: "Dexter, KS",
  },
  {
    zip: "67039",
    ST: "KS",
    cityWithStateAbbr: "Douglass, KS",
  },
  {
    zip: "67041",
    ST: "KS",
    cityWithStateAbbr: "Elbing, KS",
  },
  {
    zip: "67042",
    ST: "KS",
    cityWithStateAbbr: "El Dorado, KS",
  },
  {
    zip: "67045",
    ST: "KS",
    cityWithStateAbbr: "Eureka, KS",
  },
  {
    zip: "67047",
    ST: "KS",
    cityWithStateAbbr: "Fall River, KS",
  },
  {
    zip: "67049",
    ST: "KS",
    cityWithStateAbbr: "Freeport, KS",
  },
  {
    zip: "67050",
    ST: "KS",
    cityWithStateAbbr: "Garden Plain, KS",
  },
  {
    zip: "67051",
    ST: "KS",
    cityWithStateAbbr: "Geuda Springs, KS",
  },
  {
    zip: "67052",
    ST: "KS",
    cityWithStateAbbr: "Goddard, KS",
  },
  {
    zip: "67053",
    ST: "KS",
    cityWithStateAbbr: "Goessel, KS",
  },
  {
    zip: "67054",
    ST: "KS",
    cityWithStateAbbr: "Greensburg, KS",
  },
  {
    zip: "67055",
    ST: "KS",
    cityWithStateAbbr: "Greenwich, KS",
  },
  {
    zip: "67056",
    ST: "KS",
    cityWithStateAbbr: "Halstead, KS",
  },
  {
    zip: "67057",
    ST: "KS",
    cityWithStateAbbr: "Hardtner, KS",
  },
  {
    zip: "67058",
    ST: "KS",
    cityWithStateAbbr: "Harper, KS",
  },
  {
    zip: "67059",
    ST: "KS",
    cityWithStateAbbr: "Haviland, KS",
  },
  {
    zip: "67060",
    ST: "KS",
    cityWithStateAbbr: "Haysville, KS",
  },
  {
    zip: "67061",
    ST: "KS",
    cityWithStateAbbr: "Hazelton, KS",
  },
  {
    zip: "67062",
    ST: "KS",
    cityWithStateAbbr: "Hesston, KS",
  },
  {
    zip: "67063",
    ST: "KS",
    cityWithStateAbbr: "Hillsboro, KS",
  },
  {
    zip: "67065",
    ST: "KS",
    cityWithStateAbbr: "Isabel, KS",
  },
  {
    zip: "67066",
    ST: "KS",
    cityWithStateAbbr: "Iuka, KS",
  },
  {
    zip: "67067",
    ST: "KS",
    cityWithStateAbbr: "Kechi, KS",
  },
  {
    zip: "67068",
    ST: "KS",
    cityWithStateAbbr: "Kingman, KS",
  },
  {
    zip: "67070",
    ST: "KS",
    cityWithStateAbbr: "Kiowa, KS",
  },
  {
    zip: "67071",
    ST: "KS",
    cityWithStateAbbr: "Lake City, KS",
  },
  {
    zip: "67072",
    ST: "KS",
    cityWithStateAbbr: "Latham, KS",
  },
  {
    zip: "67073",
    ST: "KS",
    cityWithStateAbbr: "Lehigh, KS",
  },
  {
    zip: "67074",
    ST: "KS",
    cityWithStateAbbr: "Leon, KS",
  },
  {
    zip: "67101",
    ST: "KS",
    cityWithStateAbbr: "Maize, KS",
  },
  {
    zip: "67102",
    ST: "KS",
    cityWithStateAbbr: "Maple City, KS",
  },
  {
    zip: "67103",
    ST: "KS",
    cityWithStateAbbr: "Mayfield, KS",
  },
  {
    zip: "67104",
    ST: "KS",
    cityWithStateAbbr: "Medicine Lodge, KS",
  },
  {
    zip: "67105",
    ST: "KS",
    cityWithStateAbbr: "Milan, KS",
  },
  {
    zip: "67106",
    ST: "KS",
    cityWithStateAbbr: "Milton, KS",
  },
  {
    zip: "67107",
    ST: "KS",
    cityWithStateAbbr: "Moundridge, KS",
  },
  {
    zip: "67108",
    ST: "KS",
    cityWithStateAbbr: "Mount Hope, KS",
  },
  {
    zip: "67109",
    ST: "KS",
    cityWithStateAbbr: "Mullinville, KS",
  },
  {
    zip: "67110",
    ST: "KS",
    cityWithStateAbbr: "Mulvane, KS",
  },
  {
    zip: "67111",
    ST: "KS",
    cityWithStateAbbr: "Murdock, KS",
  },
  {
    zip: "67112",
    ST: "KS",
    cityWithStateAbbr: "Nashville, KS",
  },
  {
    zip: "67114",
    ST: "KS",
    cityWithStateAbbr: "Newton, KS",
  },
  {
    zip: "67117",
    ST: "KS",
    cityWithStateAbbr: "North Newton, KS",
  },
  {
    zip: "67118",
    ST: "KS",
    cityWithStateAbbr: "Norwich, KS",
  },
  {
    zip: "67119",
    ST: "KS",
    cityWithStateAbbr: "Oxford, KS",
  },
  {
    zip: "67120",
    ST: "KS",
    cityWithStateAbbr: "Peck, KS",
  },
  {
    zip: "67122",
    ST: "KS",
    cityWithStateAbbr: "Piedmont, KS",
  },
  {
    zip: "67123",
    ST: "KS",
    cityWithStateAbbr: "Potwin, KS",
  },
  {
    zip: "67124",
    ST: "KS",
    cityWithStateAbbr: "Pratt, KS",
  },
  {
    zip: "67127",
    ST: "KS",
    cityWithStateAbbr: "Protection, KS",
  },
  {
    zip: "67131",
    ST: "KS",
    cityWithStateAbbr: "Rock, KS",
  },
  {
    zip: "67132",
    ST: "KS",
    cityWithStateAbbr: "Rosalia, KS",
  },
  {
    zip: "67133",
    ST: "KS",
    cityWithStateAbbr: "Rose Hill, KS",
  },
  {
    zip: "67134",
    ST: "KS",
    cityWithStateAbbr: "Sawyer, KS",
  },
  {
    zip: "67135",
    ST: "KS",
    cityWithStateAbbr: "Sedgwick, KS",
  },
  {
    zip: "67137",
    ST: "KS",
    cityWithStateAbbr: "Severy, KS",
  },
  {
    zip: "67138",
    ST: "KS",
    cityWithStateAbbr: "Sharon, KS",
  },
  {
    zip: "67140",
    ST: "KS",
    cityWithStateAbbr: "South Haven, KS",
  },
  {
    zip: "67142",
    ST: "KS",
    cityWithStateAbbr: "Spivey, KS",
  },
  {
    zip: "67143",
    ST: "KS",
    cityWithStateAbbr: "Sun City, KS",
  },
  {
    zip: "67144",
    ST: "KS",
    cityWithStateAbbr: "Towanda, KS",
  },
  {
    zip: "67146",
    ST: "KS",
    cityWithStateAbbr: "Udall, KS",
  },
  {
    zip: "67147",
    ST: "KS",
    cityWithStateAbbr: "Valley Center, KS",
  },
  {
    zip: "67149",
    ST: "KS",
    cityWithStateAbbr: "Viola, KS",
  },
  {
    zip: "67150",
    ST: "KS",
    cityWithStateAbbr: "Waldron, KS",
  },
  {
    zip: "67151",
    ST: "KS",
    cityWithStateAbbr: "Walton, KS",
  },
  {
    zip: "67152",
    ST: "KS",
    cityWithStateAbbr: "Wellington, KS",
  },
  {
    zip: "67154",
    ST: "KS",
    cityWithStateAbbr: "Whitewater, KS",
  },
  {
    zip: "67155",
    ST: "KS",
    cityWithStateAbbr: "Wilmore, KS",
  },
  {
    zip: "67156",
    ST: "KS",
    cityWithStateAbbr: "Winfield, KS",
  },
  {
    zip: "67159",
    ST: "KS",
    cityWithStateAbbr: "Zenda, KS",
  },
  {
    zip: "67201",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67202",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67203",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67204",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67205",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67206",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67207",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67208",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67209",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67210",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67211",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67212",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67213",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67214",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67215",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67216",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67217",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67218",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67219",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67220",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67221",
    ST: "KS",
    cityWithStateAbbr: "Mcconnell Afb, KS",
  },
  {
    zip: "67223",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67226",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67227",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67228",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67230",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67232",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67235",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67260",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67275",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67276",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67277",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67278",
    ST: "KS",
    cityWithStateAbbr: "Wichita, KS",
  },
  {
    zip: "67301",
    ST: "KS",
    cityWithStateAbbr: "Independence, KS",
  },
  {
    zip: "67330",
    ST: "KS",
    cityWithStateAbbr: "Altamont, KS",
  },
  {
    zip: "67332",
    ST: "KS",
    cityWithStateAbbr: "Bartlett, KS",
  },
  {
    zip: "67333",
    ST: "KS",
    cityWithStateAbbr: "Caney, KS",
  },
  {
    zip: "67334",
    ST: "KS",
    cityWithStateAbbr: "Chautauqua, KS",
  },
  {
    zip: "67335",
    ST: "KS",
    cityWithStateAbbr: "Cherryvale, KS",
  },
  {
    zip: "67336",
    ST: "KS",
    cityWithStateAbbr: "Chetopa, KS",
  },
  {
    zip: "67337",
    ST: "KS",
    cityWithStateAbbr: "Coffeyville, KS",
  },
  {
    zip: "67340",
    ST: "KS",
    cityWithStateAbbr: "Dearing, KS",
  },
  {
    zip: "67341",
    ST: "KS",
    cityWithStateAbbr: "Dennis, KS",
  },
  {
    zip: "67342",
    ST: "KS",
    cityWithStateAbbr: "Edna, KS",
  },
  {
    zip: "67344",
    ST: "KS",
    cityWithStateAbbr: "Elk City, KS",
  },
  {
    zip: "67345",
    ST: "KS",
    cityWithStateAbbr: "Elk Falls, KS",
  },
  {
    zip: "67346",
    ST: "KS",
    cityWithStateAbbr: "Grenola, KS",
  },
  {
    zip: "67347",
    ST: "KS",
    cityWithStateAbbr: "Havana, KS",
  },
  {
    zip: "67349",
    ST: "KS",
    cityWithStateAbbr: "Howard, KS",
  },
  {
    zip: "67351",
    ST: "KS",
    cityWithStateAbbr: "Liberty, KS",
  },
  {
    zip: "67352",
    ST: "KS",
    cityWithStateAbbr: "Longton, KS",
  },
  {
    zip: "67353",
    ST: "KS",
    cityWithStateAbbr: "Moline, KS",
  },
  {
    zip: "67354",
    ST: "KS",
    cityWithStateAbbr: "Mound Valley, KS",
  },
  {
    zip: "67355",
    ST: "KS",
    cityWithStateAbbr: "Niotaze, KS",
  },
  {
    zip: "67356",
    ST: "KS",
    cityWithStateAbbr: "Oswego, KS",
  },
  {
    zip: "67357",
    ST: "KS",
    cityWithStateAbbr: "Parsons, KS",
  },
  {
    zip: "67360",
    ST: "KS",
    cityWithStateAbbr: "Peru, KS",
  },
  {
    zip: "67361",
    ST: "KS",
    cityWithStateAbbr: "Sedan, KS",
  },
  {
    zip: "67363",
    ST: "KS",
    cityWithStateAbbr: "Sycamore, KS",
  },
  {
    zip: "67364",
    ST: "KS",
    cityWithStateAbbr: "Tyro, KS",
  },
  {
    zip: "67401",
    ST: "KS",
    cityWithStateAbbr: "Salina, KS",
  },
  {
    zip: "67402",
    ST: "KS",
    cityWithStateAbbr: "Salina, KS",
  },
  {
    zip: "67410",
    ST: "KS",
    cityWithStateAbbr: "Abilene, KS",
  },
  {
    zip: "67416",
    ST: "KS",
    cityWithStateAbbr: "Assaria, KS",
  },
  {
    zip: "67417",
    ST: "KS",
    cityWithStateAbbr: "Aurora, KS",
  },
  {
    zip: "67418",
    ST: "KS",
    cityWithStateAbbr: "Barnard, KS",
  },
  {
    zip: "67420",
    ST: "KS",
    cityWithStateAbbr: "Beloit, KS",
  },
  {
    zip: "67422",
    ST: "KS",
    cityWithStateAbbr: "Bennington, KS",
  },
  {
    zip: "67423",
    ST: "KS",
    cityWithStateAbbr: "Beverly, KS",
  },
  {
    zip: "67425",
    ST: "KS",
    cityWithStateAbbr: "Brookville, KS",
  },
  {
    zip: "67427",
    ST: "KS",
    cityWithStateAbbr: "Bushton, KS",
  },
  {
    zip: "67428",
    ST: "KS",
    cityWithStateAbbr: "Canton, KS",
  },
  {
    zip: "67430",
    ST: "KS",
    cityWithStateAbbr: "Cawker City, KS",
  },
  {
    zip: "67431",
    ST: "KS",
    cityWithStateAbbr: "Chapman, KS",
  },
  {
    zip: "67432",
    ST: "KS",
    cityWithStateAbbr: "Clay Center, KS",
  },
  {
    zip: "67436",
    ST: "KS",
    cityWithStateAbbr: "Delphos, KS",
  },
  {
    zip: "67437",
    ST: "KS",
    cityWithStateAbbr: "Downs, KS",
  },
  {
    zip: "67438",
    ST: "KS",
    cityWithStateAbbr: "Durham, KS",
  },
  {
    zip: "67439",
    ST: "KS",
    cityWithStateAbbr: "Ellsworth, KS",
  },
  {
    zip: "67441",
    ST: "KS",
    cityWithStateAbbr: "Enterprise, KS",
  },
  {
    zip: "67442",
    ST: "KS",
    cityWithStateAbbr: "Falun, KS",
  },
  {
    zip: "67443",
    ST: "KS",
    cityWithStateAbbr: "Galva, KS",
  },
  {
    zip: "67444",
    ST: "KS",
    cityWithStateAbbr: "Geneseo, KS",
  },
  {
    zip: "67445",
    ST: "KS",
    cityWithStateAbbr: "Glasco, KS",
  },
  {
    zip: "67446",
    ST: "KS",
    cityWithStateAbbr: "Glen Elder, KS",
  },
  {
    zip: "67447",
    ST: "KS",
    cityWithStateAbbr: "Green, KS",
  },
  {
    zip: "67448",
    ST: "KS",
    cityWithStateAbbr: "Gypsum, KS",
  },
  {
    zip: "67449",
    ST: "KS",
    cityWithStateAbbr: "Herington, KS",
  },
  {
    zip: "67450",
    ST: "KS",
    cityWithStateAbbr: "Holyrood, KS",
  },
  {
    zip: "67451",
    ST: "KS",
    cityWithStateAbbr: "Hope, KS",
  },
  {
    zip: "67452",
    ST: "KS",
    cityWithStateAbbr: "Hunter, KS",
  },
  {
    zip: "67454",
    ST: "KS",
    cityWithStateAbbr: "Kanopolis, KS",
  },
  {
    zip: "67455",
    ST: "KS",
    cityWithStateAbbr: "Lincoln, KS",
  },
  {
    zip: "67456",
    ST: "KS",
    cityWithStateAbbr: "Lindsborg, KS",
  },
  {
    zip: "67457",
    ST: "KS",
    cityWithStateAbbr: "Little River, KS",
  },
  {
    zip: "67458",
    ST: "KS",
    cityWithStateAbbr: "Longford, KS",
  },
  {
    zip: "67459",
    ST: "KS",
    cityWithStateAbbr: "Lorraine, KS",
  },
  {
    zip: "67460",
    ST: "KS",
    cityWithStateAbbr: "Mcpherson, KS",
  },
  {
    zip: "67464",
    ST: "KS",
    cityWithStateAbbr: "Marquette, KS",
  },
  {
    zip: "67466",
    ST: "KS",
    cityWithStateAbbr: "Miltonvale, KS",
  },
  {
    zip: "67467",
    ST: "KS",
    cityWithStateAbbr: "Minneapolis, KS",
  },
  {
    zip: "67468",
    ST: "KS",
    cityWithStateAbbr: "Morganville, KS",
  },
  {
    zip: "67470",
    ST: "KS",
    cityWithStateAbbr: "New Cambria, KS",
  },
  {
    zip: "67473",
    ST: "KS",
    cityWithStateAbbr: "Osborne, KS",
  },
  {
    zip: "67474",
    ST: "KS",
    cityWithStateAbbr: "Portis, KS",
  },
  {
    zip: "67475",
    ST: "KS",
    cityWithStateAbbr: "Ramona, KS",
  },
  {
    zip: "67476",
    ST: "KS",
    cityWithStateAbbr: "Roxbury, KS",
  },
  {
    zip: "67478",
    ST: "KS",
    cityWithStateAbbr: "Simpson, KS",
  },
  {
    zip: "67480",
    ST: "KS",
    cityWithStateAbbr: "Solomon, KS",
  },
  {
    zip: "67481",
    ST: "KS",
    cityWithStateAbbr: "Sylvan Grove, KS",
  },
  {
    zip: "67482",
    ST: "KS",
    cityWithStateAbbr: "Talmage, KS",
  },
  {
    zip: "67483",
    ST: "KS",
    cityWithStateAbbr: "Tampa, KS",
  },
  {
    zip: "67484",
    ST: "KS",
    cityWithStateAbbr: "Tescott, KS",
  },
  {
    zip: "67485",
    ST: "KS",
    cityWithStateAbbr: "Tipton, KS",
  },
  {
    zip: "67487",
    ST: "KS",
    cityWithStateAbbr: "Wakefield, KS",
  },
  {
    zip: "67490",
    ST: "KS",
    cityWithStateAbbr: "Wilson, KS",
  },
  {
    zip: "67491",
    ST: "KS",
    cityWithStateAbbr: "Windom, KS",
  },
  {
    zip: "67492",
    ST: "KS",
    cityWithStateAbbr: "Woodbine, KS",
  },
  {
    zip: "67501",
    ST: "KS",
    cityWithStateAbbr: "Hutchinson, KS",
  },
  {
    zip: "67502",
    ST: "KS",
    cityWithStateAbbr: "Hutchinson, KS",
  },
  {
    zip: "67504",
    ST: "KS",
    cityWithStateAbbr: "Hutchinson, KS",
  },
  {
    zip: "67505",
    ST: "KS",
    cityWithStateAbbr: "South Hutchinson, KS",
  },
  {
    zip: "67510",
    ST: "KS",
    cityWithStateAbbr: "Abbyville, KS",
  },
  {
    zip: "67511",
    ST: "KS",
    cityWithStateAbbr: "Albert, KS",
  },
  {
    zip: "67512",
    ST: "KS",
    cityWithStateAbbr: "Alden, KS",
  },
  {
    zip: "67513",
    ST: "KS",
    cityWithStateAbbr: "Alexander, KS",
  },
  {
    zip: "67514",
    ST: "KS",
    cityWithStateAbbr: "Arlington, KS",
  },
  {
    zip: "67515",
    ST: "KS",
    cityWithStateAbbr: "Arnold, KS",
  },
  {
    zip: "67516",
    ST: "KS",
    cityWithStateAbbr: "Bazine, KS",
  },
  {
    zip: "67518",
    ST: "KS",
    cityWithStateAbbr: "Beeler, KS",
  },
  {
    zip: "67519",
    ST: "KS",
    cityWithStateAbbr: "Belpre, KS",
  },
  {
    zip: "67520",
    ST: "KS",
    cityWithStateAbbr: "Bison, KS",
  },
  {
    zip: "67521",
    ST: "KS",
    cityWithStateAbbr: "Brownell, KS",
  },
  {
    zip: "67522",
    ST: "KS",
    cityWithStateAbbr: "Buhler, KS",
  },
  {
    zip: "67523",
    ST: "KS",
    cityWithStateAbbr: "Burdett, KS",
  },
  {
    zip: "67524",
    ST: "KS",
    cityWithStateAbbr: "Chase, KS",
  },
  {
    zip: "67525",
    ST: "KS",
    cityWithStateAbbr: "Claflin, KS",
  },
  {
    zip: "67526",
    ST: "KS",
    cityWithStateAbbr: "Ellinwood, KS",
  },
  {
    zip: "67529",
    ST: "KS",
    cityWithStateAbbr: "Garfield, KS",
  },
  {
    zip: "67530",
    ST: "KS",
    cityWithStateAbbr: "Great Bend, KS",
  },
  {
    zip: "67543",
    ST: "KS",
    cityWithStateAbbr: "Haven, KS",
  },
  {
    zip: "67544",
    ST: "KS",
    cityWithStateAbbr: "Hoisington, KS",
  },
  {
    zip: "67545",
    ST: "KS",
    cityWithStateAbbr: "Hudson, KS",
  },
  {
    zip: "67546",
    ST: "KS",
    cityWithStateAbbr: "Inman, KS",
  },
  {
    zip: "67547",
    ST: "KS",
    cityWithStateAbbr: "Kinsley, KS",
  },
  {
    zip: "67548",
    ST: "KS",
    cityWithStateAbbr: "La Crosse, KS",
  },
  {
    zip: "67550",
    ST: "KS",
    cityWithStateAbbr: "Larned, KS",
  },
  {
    zip: "67552",
    ST: "KS",
    cityWithStateAbbr: "Lewis, KS",
  },
  {
    zip: "67553",
    ST: "KS",
    cityWithStateAbbr: "Liebenthal, KS",
  },
  {
    zip: "67554",
    ST: "KS",
    cityWithStateAbbr: "Lyons, KS",
  },
  {
    zip: "67556",
    ST: "KS",
    cityWithStateAbbr: "Mc Cracken, KS",
  },
  {
    zip: "67557",
    ST: "KS",
    cityWithStateAbbr: "Macksville, KS",
  },
  {
    zip: "67559",
    ST: "KS",
    cityWithStateAbbr: "Nekoma, KS",
  },
  {
    zip: "67560",
    ST: "KS",
    cityWithStateAbbr: "Ness City, KS",
  },
  {
    zip: "67561",
    ST: "KS",
    cityWithStateAbbr: "Nickerson, KS",
  },
  {
    zip: "67563",
    ST: "KS",
    cityWithStateAbbr: "Offerle, KS",
  },
  {
    zip: "67564",
    ST: "KS",
    cityWithStateAbbr: "Olmitz, KS",
  },
  {
    zip: "67565",
    ST: "KS",
    cityWithStateAbbr: "Otis, KS",
  },
  {
    zip: "67566",
    ST: "KS",
    cityWithStateAbbr: "Partridge, KS",
  },
  {
    zip: "67567",
    ST: "KS",
    cityWithStateAbbr: "Pawnee Rock, KS",
  },
  {
    zip: "67568",
    ST: "KS",
    cityWithStateAbbr: "Plevna, KS",
  },
  {
    zip: "67570",
    ST: "KS",
    cityWithStateAbbr: "Pretty Prairie, KS",
  },
  {
    zip: "67572",
    ST: "KS",
    cityWithStateAbbr: "Ransom, KS",
  },
  {
    zip: "67573",
    ST: "KS",
    cityWithStateAbbr: "Raymond, KS",
  },
  {
    zip: "67574",
    ST: "KS",
    cityWithStateAbbr: "Rozel, KS",
  },
  {
    zip: "67575",
    ST: "KS",
    cityWithStateAbbr: "Rush Center, KS",
  },
  {
    zip: "67576",
    ST: "KS",
    cityWithStateAbbr: "Saint John, KS",
  },
  {
    zip: "67578",
    ST: "KS",
    cityWithStateAbbr: "Stafford, KS",
  },
  {
    zip: "67579",
    ST: "KS",
    cityWithStateAbbr: "Sterling, KS",
  },
  {
    zip: "67581",
    ST: "KS",
    cityWithStateAbbr: "Sylvia, KS",
  },
  {
    zip: "67583",
    ST: "KS",
    cityWithStateAbbr: "Turon, KS",
  },
  {
    zip: "67584",
    ST: "KS",
    cityWithStateAbbr: "Utica, KS",
  },
  {
    zip: "67585",
    ST: "KS",
    cityWithStateAbbr: "Yoder, KS",
  },
  {
    zip: "67601",
    ST: "KS",
    cityWithStateAbbr: "Hays, KS",
  },
  {
    zip: "67621",
    ST: "KS",
    cityWithStateAbbr: "Agra, KS",
  },
  {
    zip: "67622",
    ST: "KS",
    cityWithStateAbbr: "Almena, KS",
  },
  {
    zip: "67623",
    ST: "KS",
    cityWithStateAbbr: "Alton, KS",
  },
  {
    zip: "67625",
    ST: "KS",
    cityWithStateAbbr: "Bogue, KS",
  },
  {
    zip: "67626",
    ST: "KS",
    cityWithStateAbbr: "Bunker Hill, KS",
  },
  {
    zip: "67627",
    ST: "KS",
    cityWithStateAbbr: "Catharine, KS",
  },
  {
    zip: "67628",
    ST: "KS",
    cityWithStateAbbr: "Cedar, KS",
  },
  {
    zip: "67629",
    ST: "KS",
    cityWithStateAbbr: "Clayton, KS",
  },
  {
    zip: "67631",
    ST: "KS",
    cityWithStateAbbr: "Collyer, KS",
  },
  {
    zip: "67632",
    ST: "KS",
    cityWithStateAbbr: "Damar, KS",
  },
  {
    zip: "67634",
    ST: "KS",
    cityWithStateAbbr: "Dorrance, KS",
  },
  {
    zip: "67635",
    ST: "KS",
    cityWithStateAbbr: "Dresden, KS",
  },
  {
    zip: "67637",
    ST: "KS",
    cityWithStateAbbr: "Ellis, KS",
  },
  {
    zip: "67638",
    ST: "KS",
    cityWithStateAbbr: "Gaylord, KS",
  },
  {
    zip: "67639",
    ST: "KS",
    cityWithStateAbbr: "Glade, KS",
  },
  {
    zip: "67640",
    ST: "KS",
    cityWithStateAbbr: "Gorham, KS",
  },
  {
    zip: "67642",
    ST: "KS",
    cityWithStateAbbr: "Hill City, KS",
  },
  {
    zip: "67643",
    ST: "KS",
    cityWithStateAbbr: "Jennings, KS",
  },
  {
    zip: "67644",
    ST: "KS",
    cityWithStateAbbr: "Kirwin, KS",
  },
  {
    zip: "67645",
    ST: "KS",
    cityWithStateAbbr: "Lenora, KS",
  },
  {
    zip: "67646",
    ST: "KS",
    cityWithStateAbbr: "Logan, KS",
  },
  {
    zip: "67647",
    ST: "KS",
    cityWithStateAbbr: "Long Island, KS",
  },
  {
    zip: "67648",
    ST: "KS",
    cityWithStateAbbr: "Lucas, KS",
  },
  {
    zip: "67649",
    ST: "KS",
    cityWithStateAbbr: "Luray, KS",
  },
  {
    zip: "67650",
    ST: "KS",
    cityWithStateAbbr: "Morland, KS",
  },
  {
    zip: "67651",
    ST: "KS",
    cityWithStateAbbr: "Natoma, KS",
  },
  {
    zip: "67653",
    ST: "KS",
    cityWithStateAbbr: "Norcatur, KS",
  },
  {
    zip: "67654",
    ST: "KS",
    cityWithStateAbbr: "Norton, KS",
  },
  {
    zip: "67656",
    ST: "KS",
    cityWithStateAbbr: "Ogallah, KS",
  },
  {
    zip: "67657",
    ST: "KS",
    cityWithStateAbbr: "Palco, KS",
  },
  {
    zip: "67658",
    ST: "KS",
    cityWithStateAbbr: "Paradise, KS",
  },
  {
    zip: "67659",
    ST: "KS",
    cityWithStateAbbr: "Penokee, KS",
  },
  {
    zip: "67660",
    ST: "KS",
    cityWithStateAbbr: "Pfeifer, KS",
  },
  {
    zip: "67661",
    ST: "KS",
    cityWithStateAbbr: "Phillipsburg, KS",
  },
  {
    zip: "67663",
    ST: "KS",
    cityWithStateAbbr: "Plainville, KS",
  },
  {
    zip: "67664",
    ST: "KS",
    cityWithStateAbbr: "Prairie View, KS",
  },
  {
    zip: "67665",
    ST: "KS",
    cityWithStateAbbr: "Russell, KS",
  },
  {
    zip: "67667",
    ST: "KS",
    cityWithStateAbbr: "Schoenchen, KS",
  },
  {
    zip: "67669",
    ST: "KS",
    cityWithStateAbbr: "Stockton, KS",
  },
  {
    zip: "67671",
    ST: "KS",
    cityWithStateAbbr: "Victoria, KS",
  },
  {
    zip: "67672",
    ST: "KS",
    cityWithStateAbbr: "Wakeeney, KS",
  },
  {
    zip: "67673",
    ST: "KS",
    cityWithStateAbbr: "Waldo, KS",
  },
  {
    zip: "67674",
    ST: "KS",
    cityWithStateAbbr: "Walker, KS",
  },
  {
    zip: "67675",
    ST: "KS",
    cityWithStateAbbr: "Woodston, KS",
  },
  {
    zip: "67701",
    ST: "KS",
    cityWithStateAbbr: "Colby, KS",
  },
  {
    zip: "67730",
    ST: "KS",
    cityWithStateAbbr: "Atwood, KS",
  },
  {
    zip: "67731",
    ST: "KS",
    cityWithStateAbbr: "Bird City, KS",
  },
  {
    zip: "67732",
    ST: "KS",
    cityWithStateAbbr: "Brewster, KS",
  },
  {
    zip: "67733",
    ST: "KS",
    cityWithStateAbbr: "Edson, KS",
  },
  {
    zip: "67734",
    ST: "KS",
    cityWithStateAbbr: "Gem, KS",
  },
  {
    zip: "67735",
    ST: "KS",
    cityWithStateAbbr: "Goodland, KS",
  },
  {
    zip: "67736",
    ST: "KS",
    cityWithStateAbbr: "Gove, KS",
  },
  {
    zip: "67737",
    ST: "KS",
    cityWithStateAbbr: "Grainfield, KS",
  },
  {
    zip: "67738",
    ST: "KS",
    cityWithStateAbbr: "Grinnell, KS",
  },
  {
    zip: "67739",
    ST: "KS",
    cityWithStateAbbr: "Herndon, KS",
  },
  {
    zip: "67740",
    ST: "KS",
    cityWithStateAbbr: "Hoxie, KS",
  },
  {
    zip: "67741",
    ST: "KS",
    cityWithStateAbbr: "Kanorado, KS",
  },
  {
    zip: "67743",
    ST: "KS",
    cityWithStateAbbr: "Levant, KS",
  },
  {
    zip: "67744",
    ST: "KS",
    cityWithStateAbbr: "Ludell, KS",
  },
  {
    zip: "67745",
    ST: "KS",
    cityWithStateAbbr: "Mc Donald, KS",
  },
  {
    zip: "67747",
    ST: "KS",
    cityWithStateAbbr: "Monument, KS",
  },
  {
    zip: "67748",
    ST: "KS",
    cityWithStateAbbr: "Oakley, KS",
  },
  {
    zip: "67749",
    ST: "KS",
    cityWithStateAbbr: "Oberlin, KS",
  },
  {
    zip: "67751",
    ST: "KS",
    cityWithStateAbbr: "Park, KS",
  },
  {
    zip: "67752",
    ST: "KS",
    cityWithStateAbbr: "Quinter, KS",
  },
  {
    zip: "67753",
    ST: "KS",
    cityWithStateAbbr: "Rexford, KS",
  },
  {
    zip: "67756",
    ST: "KS",
    cityWithStateAbbr: "Saint Francis, KS",
  },
  {
    zip: "67757",
    ST: "KS",
    cityWithStateAbbr: "Selden, KS",
  },
  {
    zip: "67758",
    ST: "KS",
    cityWithStateAbbr: "Sharon Springs, KS",
  },
  {
    zip: "67761",
    ST: "KS",
    cityWithStateAbbr: "Wallace, KS",
  },
  {
    zip: "67762",
    ST: "KS",
    cityWithStateAbbr: "Weskan, KS",
  },
  {
    zip: "67764",
    ST: "KS",
    cityWithStateAbbr: "Winona, KS",
  },
  {
    zip: "67801",
    ST: "KS",
    cityWithStateAbbr: "Dodge City, KS",
  },
  {
    zip: "67831",
    ST: "KS",
    cityWithStateAbbr: "Ashland, KS",
  },
  {
    zip: "67834",
    ST: "KS",
    cityWithStateAbbr: "Bucklin, KS",
  },
  {
    zip: "67835",
    ST: "KS",
    cityWithStateAbbr: "Cimarron, KS",
  },
  {
    zip: "67836",
    ST: "KS",
    cityWithStateAbbr: "Coolidge, KS",
  },
  {
    zip: "67837",
    ST: "KS",
    cityWithStateAbbr: "Copeland, KS",
  },
  {
    zip: "67838",
    ST: "KS",
    cityWithStateAbbr: "Deerfield, KS",
  },
  {
    zip: "67839",
    ST: "KS",
    cityWithStateAbbr: "Dighton, KS",
  },
  {
    zip: "67840",
    ST: "KS",
    cityWithStateAbbr: "Englewood, KS",
  },
  {
    zip: "67841",
    ST: "KS",
    cityWithStateAbbr: "Ensign, KS",
  },
  {
    zip: "67842",
    ST: "KS",
    cityWithStateAbbr: "Ford, KS",
  },
  {
    zip: "67843",
    ST: "KS",
    cityWithStateAbbr: "Fort Dodge, KS",
  },
  {
    zip: "67844",
    ST: "KS",
    cityWithStateAbbr: "Fowler, KS",
  },
  {
    zip: "67846",
    ST: "KS",
    cityWithStateAbbr: "Garden City, KS",
  },
  {
    zip: "67849",
    ST: "KS",
    cityWithStateAbbr: "Hanston, KS",
  },
  {
    zip: "67850",
    ST: "KS",
    cityWithStateAbbr: "Healy, KS",
  },
  {
    zip: "67851",
    ST: "KS",
    cityWithStateAbbr: "Holcomb, KS",
  },
  {
    zip: "67853",
    ST: "KS",
    cityWithStateAbbr: "Ingalls, KS",
  },
  {
    zip: "67854",
    ST: "KS",
    cityWithStateAbbr: "Jetmore, KS",
  },
  {
    zip: "67855",
    ST: "KS",
    cityWithStateAbbr: "Johnson, KS",
  },
  {
    zip: "67857",
    ST: "KS",
    cityWithStateAbbr: "Kendall, KS",
  },
  {
    zip: "67859",
    ST: "KS",
    cityWithStateAbbr: "Kismet, KS",
  },
  {
    zip: "67860",
    ST: "KS",
    cityWithStateAbbr: "Lakin, KS",
  },
  {
    zip: "67861",
    ST: "KS",
    cityWithStateAbbr: "Leoti, KS",
  },
  {
    zip: "67862",
    ST: "KS",
    cityWithStateAbbr: "Manter, KS",
  },
  {
    zip: "67863",
    ST: "KS",
    cityWithStateAbbr: "Marienthal, KS",
  },
  {
    zip: "67864",
    ST: "KS",
    cityWithStateAbbr: "Meade, KS",
  },
  {
    zip: "67865",
    ST: "KS",
    cityWithStateAbbr: "Minneola, KS",
  },
  {
    zip: "67867",
    ST: "KS",
    cityWithStateAbbr: "Montezuma, KS",
  },
  {
    zip: "67868",
    ST: "KS",
    cityWithStateAbbr: "Pierceville, KS",
  },
  {
    zip: "67869",
    ST: "KS",
    cityWithStateAbbr: "Plains, KS",
  },
  {
    zip: "67870",
    ST: "KS",
    cityWithStateAbbr: "Satanta, KS",
  },
  {
    zip: "67871",
    ST: "KS",
    cityWithStateAbbr: "Scott City, KS",
  },
  {
    zip: "67876",
    ST: "KS",
    cityWithStateAbbr: "Spearville, KS",
  },
  {
    zip: "67877",
    ST: "KS",
    cityWithStateAbbr: "Sublette, KS",
  },
  {
    zip: "67878",
    ST: "KS",
    cityWithStateAbbr: "Syracuse, KS",
  },
  {
    zip: "67879",
    ST: "KS",
    cityWithStateAbbr: "Tribune, KS",
  },
  {
    zip: "67880",
    ST: "KS",
    cityWithStateAbbr: "Ulysses, KS",
  },
  {
    zip: "67882",
    ST: "KS",
    cityWithStateAbbr: "Wright, KS",
  },
  {
    zip: "67901",
    ST: "KS",
    cityWithStateAbbr: "Liberal, KS",
  },
  {
    zip: "67905",
    ST: "KS",
    cityWithStateAbbr: "Liberal, KS",
  },
  {
    zip: "67950",
    ST: "KS",
    cityWithStateAbbr: "Elkhart, KS",
  },
  {
    zip: "67951",
    ST: "KS",
    cityWithStateAbbr: "Hugoton, KS",
  },
  {
    zip: "67952",
    ST: "KS",
    cityWithStateAbbr: "Moscow, KS",
  },
  {
    zip: "67953",
    ST: "KS",
    cityWithStateAbbr: "Richfield, KS",
  },
  {
    zip: "67954",
    ST: "KS",
    cityWithStateAbbr: "Rolla, KS",
  },
  {
    zip: "68001",
    ST: "NE",
    cityWithStateAbbr: "Abie, NE",
  },
  {
    zip: "68002",
    ST: "NE",
    cityWithStateAbbr: "Arlington, NE",
  },
  {
    zip: "68003",
    ST: "NE",
    cityWithStateAbbr: "Ashland, NE",
  },
  {
    zip: "68004",
    ST: "NE",
    cityWithStateAbbr: "Bancroft, NE",
  },
  {
    zip: "68005",
    ST: "NE",
    cityWithStateAbbr: "Bellevue, NE",
  },
  {
    zip: "68007",
    ST: "NE",
    cityWithStateAbbr: "Bennington, NE",
  },
  {
    zip: "68008",
    ST: "NE",
    cityWithStateAbbr: "Blair, NE",
  },
  {
    zip: "68009",
    ST: "NE",
    cityWithStateAbbr: "Blair, NE",
  },
  {
    zip: "68010",
    ST: "NE",
    cityWithStateAbbr: "Boys Town, NE",
  },
  {
    zip: "68014",
    ST: "NE",
    cityWithStateAbbr: "Bruno, NE",
  },
  {
    zip: "68015",
    ST: "NE",
    cityWithStateAbbr: "Cedar Bluffs, NE",
  },
  {
    zip: "68016",
    ST: "NE",
    cityWithStateAbbr: "Cedar Creek, NE",
  },
  {
    zip: "68017",
    ST: "NE",
    cityWithStateAbbr: "Ceresco, NE",
  },
  {
    zip: "68018",
    ST: "NE",
    cityWithStateAbbr: "Colon, NE",
  },
  {
    zip: "68019",
    ST: "NE",
    cityWithStateAbbr: "Craig, NE",
  },
  {
    zip: "68020",
    ST: "NE",
    cityWithStateAbbr: "Decatur, NE",
  },
  {
    zip: "68022",
    ST: "NE",
    cityWithStateAbbr: "Elkhorn, NE",
  },
  {
    zip: "68023",
    ST: "NE",
    cityWithStateAbbr: "Fort Calhoun, NE",
  },
  {
    zip: "68025",
    ST: "NE",
    cityWithStateAbbr: "Fremont, NE",
  },
  {
    zip: "68026",
    ST: "NE",
    cityWithStateAbbr: "Fremont, NE",
  },
  {
    zip: "68028",
    ST: "NE",
    cityWithStateAbbr: "Gretna, NE",
  },
  {
    zip: "68029",
    ST: "NE",
    cityWithStateAbbr: "Herman, NE",
  },
  {
    zip: "68030",
    ST: "NE",
    cityWithStateAbbr: "Homer, NE",
  },
  {
    zip: "68031",
    ST: "NE",
    cityWithStateAbbr: "Hooper, NE",
  },
  {
    zip: "68033",
    ST: "NE",
    cityWithStateAbbr: "Ithaca, NE",
  },
  {
    zip: "68034",
    ST: "NE",
    cityWithStateAbbr: "Kennard, NE",
  },
  {
    zip: "68036",
    ST: "NE",
    cityWithStateAbbr: "Linwood, NE",
  },
  {
    zip: "68037",
    ST: "NE",
    cityWithStateAbbr: "Louisville, NE",
  },
  {
    zip: "68038",
    ST: "NE",
    cityWithStateAbbr: "Lyons, NE",
  },
  {
    zip: "68039",
    ST: "NE",
    cityWithStateAbbr: "Macy, NE",
  },
  {
    zip: "68040",
    ST: "NE",
    cityWithStateAbbr: "Malmo, NE",
  },
  {
    zip: "68041",
    ST: "NE",
    cityWithStateAbbr: "Mead, NE",
  },
  {
    zip: "68042",
    ST: "NE",
    cityWithStateAbbr: "Memphis, NE",
  },
  {
    zip: "68044",
    ST: "NE",
    cityWithStateAbbr: "Nickerson, NE",
  },
  {
    zip: "68045",
    ST: "NE",
    cityWithStateAbbr: "Oakland, NE",
  },
  {
    zip: "68046",
    ST: "NE",
    cityWithStateAbbr: "Papillion, NE",
  },
  {
    zip: "68047",
    ST: "NE",
    cityWithStateAbbr: "Pender, NE",
  },
  {
    zip: "68048",
    ST: "NE",
    cityWithStateAbbr: "Plattsmouth, NE",
  },
  {
    zip: "68050",
    ST: "NE",
    cityWithStateAbbr: "Prague, NE",
  },
  {
    zip: "68055",
    ST: "NE",
    cityWithStateAbbr: "Rosalie, NE",
  },
  {
    zip: "68056",
    ST: "NE",
    cityWithStateAbbr: "St Columbans, NE",
  },
  {
    zip: "68057",
    ST: "NE",
    cityWithStateAbbr: "Scribner, NE",
  },
  {
    zip: "68058",
    ST: "NE",
    cityWithStateAbbr: "South Bend, NE",
  },
  {
    zip: "68059",
    ST: "NE",
    cityWithStateAbbr: "Springfield, NE",
  },
  {
    zip: "68061",
    ST: "NE",
    cityWithStateAbbr: "Tekamah, NE",
  },
  {
    zip: "68062",
    ST: "NE",
    cityWithStateAbbr: "Thurston, NE",
  },
  {
    zip: "68063",
    ST: "NE",
    cityWithStateAbbr: "Uehling, NE",
  },
  {
    zip: "68064",
    ST: "NE",
    cityWithStateAbbr: "Valley, NE",
  },
  {
    zip: "68065",
    ST: "NE",
    cityWithStateAbbr: "Valparaiso, NE",
  },
  {
    zip: "68066",
    ST: "NE",
    cityWithStateAbbr: "Wahoo, NE",
  },
  {
    zip: "68067",
    ST: "NE",
    cityWithStateAbbr: "Walthill, NE",
  },
  {
    zip: "68068",
    ST: "NE",
    cityWithStateAbbr: "Washington, NE",
  },
  {
    zip: "68069",
    ST: "NE",
    cityWithStateAbbr: "Waterloo, NE",
  },
  {
    zip: "68070",
    ST: "NE",
    cityWithStateAbbr: "Weston, NE",
  },
  {
    zip: "68071",
    ST: "NE",
    cityWithStateAbbr: "Winnebago, NE",
  },
  {
    zip: "68072",
    ST: "NE",
    cityWithStateAbbr: "Winslow, NE",
  },
  {
    zip: "68073",
    ST: "NE",
    cityWithStateAbbr: "Yutan, NE",
  },
  {
    zip: "68101",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68102",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68103",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68104",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68105",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68106",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68107",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68108",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68109",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68110",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68111",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68112",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68113",
    ST: "NE",
    cityWithStateAbbr: "Offutt Afb, NE",
  },
  {
    zip: "68114",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68116",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68117",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68118",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68119",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68120",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68122",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68123",
    ST: "NE",
    cityWithStateAbbr: "Bellevue, NE",
  },
  {
    zip: "68124",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68127",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68128",
    ST: "NE",
    cityWithStateAbbr: "La Vista, NE",
  },
  {
    zip: "68130",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68131",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68132",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68133",
    ST: "NE",
    cityWithStateAbbr: "Papillion, NE",
  },
  {
    zip: "68134",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68135",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68136",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68137",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68138",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68139",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68142",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68144",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68145",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68147",
    ST: "NE",
    cityWithStateAbbr: "Bellevue, NE",
  },
  {
    zip: "68152",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68154",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68155",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68157",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68164",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68172",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68175",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68176",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68178",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68179",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68180",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68182",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68183",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68197",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68198",
    ST: "NE",
    cityWithStateAbbr: "Omaha, NE",
  },
  {
    zip: "68301",
    ST: "NE",
    cityWithStateAbbr: "Adams, NE",
  },
  {
    zip: "68303",
    ST: "NE",
    cityWithStateAbbr: "Alexandria, NE",
  },
  {
    zip: "68304",
    ST: "NE",
    cityWithStateAbbr: "Alvo, NE",
  },
  {
    zip: "68305",
    ST: "NE",
    cityWithStateAbbr: "Auburn, NE",
  },
  {
    zip: "68307",
    ST: "NE",
    cityWithStateAbbr: "Avoca, NE",
  },
  {
    zip: "68309",
    ST: "NE",
    cityWithStateAbbr: "Barneston, NE",
  },
  {
    zip: "68310",
    ST: "NE",
    cityWithStateAbbr: "Beatrice, NE",
  },
  {
    zip: "68313",
    ST: "NE",
    cityWithStateAbbr: "Beaver Crossing, NE",
  },
  {
    zip: "68314",
    ST: "NE",
    cityWithStateAbbr: "Bee, NE",
  },
  {
    zip: "68315",
    ST: "NE",
    cityWithStateAbbr: "Belvidere, NE",
  },
  {
    zip: "68316",
    ST: "NE",
    cityWithStateAbbr: "Benedict, NE",
  },
  {
    zip: "68317",
    ST: "NE",
    cityWithStateAbbr: "Bennet, NE",
  },
  {
    zip: "68318",
    ST: "NE",
    cityWithStateAbbr: "Blue Springs, NE",
  },
  {
    zip: "68319",
    ST: "NE",
    cityWithStateAbbr: "Bradshaw, NE",
  },
  {
    zip: "68320",
    ST: "NE",
    cityWithStateAbbr: "Brock, NE",
  },
  {
    zip: "68321",
    ST: "NE",
    cityWithStateAbbr: "Brownville, NE",
  },
  {
    zip: "68322",
    ST: "NE",
    cityWithStateAbbr: "Bruning, NE",
  },
  {
    zip: "68323",
    ST: "NE",
    cityWithStateAbbr: "Burchard, NE",
  },
  {
    zip: "68324",
    ST: "NE",
    cityWithStateAbbr: "Burr, NE",
  },
  {
    zip: "68325",
    ST: "NE",
    cityWithStateAbbr: "Byron, NE",
  },
  {
    zip: "68326",
    ST: "NE",
    cityWithStateAbbr: "Carleton, NE",
  },
  {
    zip: "68327",
    ST: "NE",
    cityWithStateAbbr: "Chester, NE",
  },
  {
    zip: "68328",
    ST: "NE",
    cityWithStateAbbr: "Clatonia, NE",
  },
  {
    zip: "68329",
    ST: "NE",
    cityWithStateAbbr: "Cook, NE",
  },
  {
    zip: "68330",
    ST: "NE",
    cityWithStateAbbr: "Cordova, NE",
  },
  {
    zip: "68331",
    ST: "NE",
    cityWithStateAbbr: "Cortland, NE",
  },
  {
    zip: "68332",
    ST: "NE",
    cityWithStateAbbr: "Crab Orchard, NE",
  },
  {
    zip: "68333",
    ST: "NE",
    cityWithStateAbbr: "Crete, NE",
  },
  {
    zip: "68335",
    ST: "NE",
    cityWithStateAbbr: "Davenport, NE",
  },
  {
    zip: "68336",
    ST: "NE",
    cityWithStateAbbr: "Davey, NE",
  },
  {
    zip: "68337",
    ST: "NE",
    cityWithStateAbbr: "Dawson, NE",
  },
  {
    zip: "68338",
    ST: "NE",
    cityWithStateAbbr: "Daykin, NE",
  },
  {
    zip: "68339",
    ST: "NE",
    cityWithStateAbbr: "Denton, NE",
  },
  {
    zip: "68340",
    ST: "NE",
    cityWithStateAbbr: "Deshler, NE",
  },
  {
    zip: "68341",
    ST: "NE",
    cityWithStateAbbr: "De Witt, NE",
  },
  {
    zip: "68342",
    ST: "NE",
    cityWithStateAbbr: "Diller, NE",
  },
  {
    zip: "68343",
    ST: "NE",
    cityWithStateAbbr: "Dorchester, NE",
  },
  {
    zip: "68344",
    ST: "NE",
    cityWithStateAbbr: "Douglas, NE",
  },
  {
    zip: "68345",
    ST: "NE",
    cityWithStateAbbr: "Du Bois, NE",
  },
  {
    zip: "68346",
    ST: "NE",
    cityWithStateAbbr: "Dunbar, NE",
  },
  {
    zip: "68347",
    ST: "NE",
    cityWithStateAbbr: "Eagle, NE",
  },
  {
    zip: "68348",
    ST: "NE",
    cityWithStateAbbr: "Elk Creek, NE",
  },
  {
    zip: "68349",
    ST: "NE",
    cityWithStateAbbr: "Elmwood, NE",
  },
  {
    zip: "68350",
    ST: "NE",
    cityWithStateAbbr: "Endicott, NE",
  },
  {
    zip: "68351",
    ST: "NE",
    cityWithStateAbbr: "Exeter, NE",
  },
  {
    zip: "68352",
    ST: "NE",
    cityWithStateAbbr: "Fairbury, NE",
  },
  {
    zip: "68354",
    ST: "NE",
    cityWithStateAbbr: "Fairmont, NE",
  },
  {
    zip: "68355",
    ST: "NE",
    cityWithStateAbbr: "Falls City, NE",
  },
  {
    zip: "68357",
    ST: "NE",
    cityWithStateAbbr: "Filley, NE",
  },
  {
    zip: "68358",
    ST: "NE",
    cityWithStateAbbr: "Firth, NE",
  },
  {
    zip: "68359",
    ST: "NE",
    cityWithStateAbbr: "Friend, NE",
  },
  {
    zip: "68360",
    ST: "NE",
    cityWithStateAbbr: "Garland, NE",
  },
  {
    zip: "68361",
    ST: "NE",
    cityWithStateAbbr: "Geneva, NE",
  },
  {
    zip: "68362",
    ST: "NE",
    cityWithStateAbbr: "Gilead, NE",
  },
  {
    zip: "68364",
    ST: "NE",
    cityWithStateAbbr: "Goehner, NE",
  },
  {
    zip: "68365",
    ST: "NE",
    cityWithStateAbbr: "Grafton, NE",
  },
  {
    zip: "68366",
    ST: "NE",
    cityWithStateAbbr: "Greenwood, NE",
  },
  {
    zip: "68367",
    ST: "NE",
    cityWithStateAbbr: "Gresham, NE",
  },
  {
    zip: "68368",
    ST: "NE",
    cityWithStateAbbr: "Hallam, NE",
  },
  {
    zip: "68370",
    ST: "NE",
    cityWithStateAbbr: "Hebron, NE",
  },
  {
    zip: "68371",
    ST: "NE",
    cityWithStateAbbr: "Henderson, NE",
  },
  {
    zip: "68372",
    ST: "NE",
    cityWithStateAbbr: "Hickman, NE",
  },
  {
    zip: "68375",
    ST: "NE",
    cityWithStateAbbr: "Hubbell, NE",
  },
  {
    zip: "68376",
    ST: "NE",
    cityWithStateAbbr: "Humboldt, NE",
  },
  {
    zip: "68377",
    ST: "NE",
    cityWithStateAbbr: "Jansen, NE",
  },
  {
    zip: "68378",
    ST: "NE",
    cityWithStateAbbr: "Johnson, NE",
  },
  {
    zip: "68379",
    ST: "NE",
    cityWithStateAbbr: "Julian, NE",
  },
  {
    zip: "68380",
    ST: "NE",
    cityWithStateAbbr: "Lewiston, NE",
  },
  {
    zip: "68381",
    ST: "NE",
    cityWithStateAbbr: "Liberty, NE",
  },
  {
    zip: "68382",
    ST: "NE",
    cityWithStateAbbr: "Lorton, NE",
  },
  {
    zip: "68401",
    ST: "NE",
    cityWithStateAbbr: "Mc Cool Junction, NE",
  },
  {
    zip: "68402",
    ST: "NE",
    cityWithStateAbbr: "Malcolm, NE",
  },
  {
    zip: "68403",
    ST: "NE",
    cityWithStateAbbr: "Manley, NE",
  },
  {
    zip: "68404",
    ST: "NE",
    cityWithStateAbbr: "Martell, NE",
  },
  {
    zip: "68405",
    ST: "NE",
    cityWithStateAbbr: "Milford, NE",
  },
  {
    zip: "68406",
    ST: "NE",
    cityWithStateAbbr: "Milligan, NE",
  },
  {
    zip: "68407",
    ST: "NE",
    cityWithStateAbbr: "Murdock, NE",
  },
  {
    zip: "68409",
    ST: "NE",
    cityWithStateAbbr: "Murray, NE",
  },
  {
    zip: "68410",
    ST: "NE",
    cityWithStateAbbr: "Nebraska City, NE",
  },
  {
    zip: "68413",
    ST: "NE",
    cityWithStateAbbr: "Nehawka, NE",
  },
  {
    zip: "68414",
    ST: "NE",
    cityWithStateAbbr: "Nemaha, NE",
  },
  {
    zip: "68415",
    ST: "NE",
    cityWithStateAbbr: "Odell, NE",
  },
  {
    zip: "68416",
    ST: "NE",
    cityWithStateAbbr: "Ohiowa, NE",
  },
  {
    zip: "68417",
    ST: "NE",
    cityWithStateAbbr: "Otoe, NE",
  },
  {
    zip: "68418",
    ST: "NE",
    cityWithStateAbbr: "Palmyra, NE",
  },
  {
    zip: "68419",
    ST: "NE",
    cityWithStateAbbr: "Panama, NE",
  },
  {
    zip: "68420",
    ST: "NE",
    cityWithStateAbbr: "Pawnee City, NE",
  },
  {
    zip: "68421",
    ST: "NE",
    cityWithStateAbbr: "Peru, NE",
  },
  {
    zip: "68422",
    ST: "NE",
    cityWithStateAbbr: "Pickrell, NE",
  },
  {
    zip: "68423",
    ST: "NE",
    cityWithStateAbbr: "Pleasant Dale, NE",
  },
  {
    zip: "68424",
    ST: "NE",
    cityWithStateAbbr: "Plymouth, NE",
  },
  {
    zip: "68428",
    ST: "NE",
    cityWithStateAbbr: "Raymond, NE",
  },
  {
    zip: "68429",
    ST: "NE",
    cityWithStateAbbr: "Reynolds, NE",
  },
  {
    zip: "68430",
    ST: "NE",
    cityWithStateAbbr: "Roca, NE",
  },
  {
    zip: "68431",
    ST: "NE",
    cityWithStateAbbr: "Rulo, NE",
  },
  {
    zip: "68433",
    ST: "NE",
    cityWithStateAbbr: "Salem, NE",
  },
  {
    zip: "68434",
    ST: "NE",
    cityWithStateAbbr: "Seward, NE",
  },
  {
    zip: "68436",
    ST: "NE",
    cityWithStateAbbr: "Shickley, NE",
  },
  {
    zip: "68437",
    ST: "NE",
    cityWithStateAbbr: "Shubert, NE",
  },
  {
    zip: "68438",
    ST: "NE",
    cityWithStateAbbr: "Sprague, NE",
  },
  {
    zip: "68439",
    ST: "NE",
    cityWithStateAbbr: "Staplehurst, NE",
  },
  {
    zip: "68440",
    ST: "NE",
    cityWithStateAbbr: "Steele City, NE",
  },
  {
    zip: "68441",
    ST: "NE",
    cityWithStateAbbr: "Steinauer, NE",
  },
  {
    zip: "68442",
    ST: "NE",
    cityWithStateAbbr: "Stella, NE",
  },
  {
    zip: "68443",
    ST: "NE",
    cityWithStateAbbr: "Sterling, NE",
  },
  {
    zip: "68444",
    ST: "NE",
    cityWithStateAbbr: "Strang, NE",
  },
  {
    zip: "68445",
    ST: "NE",
    cityWithStateAbbr: "Swanton, NE",
  },
  {
    zip: "68446",
    ST: "NE",
    cityWithStateAbbr: "Syracuse, NE",
  },
  {
    zip: "68447",
    ST: "NE",
    cityWithStateAbbr: "Table Rock, NE",
  },
  {
    zip: "68448",
    ST: "NE",
    cityWithStateAbbr: "Talmage, NE",
  },
  {
    zip: "68450",
    ST: "NE",
    cityWithStateAbbr: "Tecumseh, NE",
  },
  {
    zip: "68452",
    ST: "NE",
    cityWithStateAbbr: "Ong, NE",
  },
  {
    zip: "68453",
    ST: "NE",
    cityWithStateAbbr: "Tobias, NE",
  },
  {
    zip: "68454",
    ST: "NE",
    cityWithStateAbbr: "Unadilla, NE",
  },
  {
    zip: "68455",
    ST: "NE",
    cityWithStateAbbr: "Union, NE",
  },
  {
    zip: "68456",
    ST: "NE",
    cityWithStateAbbr: "Utica, NE",
  },
  {
    zip: "68457",
    ST: "NE",
    cityWithStateAbbr: "Verdon, NE",
  },
  {
    zip: "68458",
    ST: "NE",
    cityWithStateAbbr: "Virginia, NE",
  },
  {
    zip: "68460",
    ST: "NE",
    cityWithStateAbbr: "Waco, NE",
  },
  {
    zip: "68461",
    ST: "NE",
    cityWithStateAbbr: "Walton, NE",
  },
  {
    zip: "68462",
    ST: "NE",
    cityWithStateAbbr: "Waverly, NE",
  },
  {
    zip: "68463",
    ST: "NE",
    cityWithStateAbbr: "Weeping Water, NE",
  },
  {
    zip: "68464",
    ST: "NE",
    cityWithStateAbbr: "Western, NE",
  },
  {
    zip: "68465",
    ST: "NE",
    cityWithStateAbbr: "Wilber, NE",
  },
  {
    zip: "68466",
    ST: "NE",
    cityWithStateAbbr: "Wymore, NE",
  },
  {
    zip: "68467",
    ST: "NE",
    cityWithStateAbbr: "York, NE",
  },
  {
    zip: "68501",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68502",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68503",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68504",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68505",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68506",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68507",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68508",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68509",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68510",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68512",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68514",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68516",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68517",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68520",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68521",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68522",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68523",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68524",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68526",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68527",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68528",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68529",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68531",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68532",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68542",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68544",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68583",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68588",
    ST: "NE",
    cityWithStateAbbr: "Lincoln, NE",
  },
  {
    zip: "68601",
    ST: "NE",
    cityWithStateAbbr: "Columbus, NE",
  },
  {
    zip: "68602",
    ST: "NE",
    cityWithStateAbbr: "Columbus, NE",
  },
  {
    zip: "68620",
    ST: "NE",
    cityWithStateAbbr: "Albion, NE",
  },
  {
    zip: "68621",
    ST: "NE",
    cityWithStateAbbr: "Ames, NE",
  },
  {
    zip: "68622",
    ST: "NE",
    cityWithStateAbbr: "Bartlett, NE",
  },
  {
    zip: "68623",
    ST: "NE",
    cityWithStateAbbr: "Belgrade, NE",
  },
  {
    zip: "68624",
    ST: "NE",
    cityWithStateAbbr: "Bellwood, NE",
  },
  {
    zip: "68626",
    ST: "NE",
    cityWithStateAbbr: "Brainard, NE",
  },
  {
    zip: "68627",
    ST: "NE",
    cityWithStateAbbr: "Cedar Rapids, NE",
  },
  {
    zip: "68628",
    ST: "NE",
    cityWithStateAbbr: "Clarks, NE",
  },
  {
    zip: "68629",
    ST: "NE",
    cityWithStateAbbr: "Clarkson, NE",
  },
  {
    zip: "68631",
    ST: "NE",
    cityWithStateAbbr: "Creston, NE",
  },
  {
    zip: "68632",
    ST: "NE",
    cityWithStateAbbr: "David City, NE",
  },
  {
    zip: "68633",
    ST: "NE",
    cityWithStateAbbr: "Dodge, NE",
  },
  {
    zip: "68634",
    ST: "NE",
    cityWithStateAbbr: "Duncan, NE",
  },
  {
    zip: "68635",
    ST: "NE",
    cityWithStateAbbr: "Dwight, NE",
  },
  {
    zip: "68636",
    ST: "NE",
    cityWithStateAbbr: "Elgin, NE",
  },
  {
    zip: "68637",
    ST: "NE",
    cityWithStateAbbr: "Ericson, NE",
  },
  {
    zip: "68638",
    ST: "NE",
    cityWithStateAbbr: "Fullerton, NE",
  },
  {
    zip: "68640",
    ST: "NE",
    cityWithStateAbbr: "Genoa, NE",
  },
  {
    zip: "68641",
    ST: "NE",
    cityWithStateAbbr: "Howells, NE",
  },
  {
    zip: "68642",
    ST: "NE",
    cityWithStateAbbr: "Humphrey, NE",
  },
  {
    zip: "68643",
    ST: "NE",
    cityWithStateAbbr: "Leigh, NE",
  },
  {
    zip: "68644",
    ST: "NE",
    cityWithStateAbbr: "Lindsay, NE",
  },
  {
    zip: "68647",
    ST: "NE",
    cityWithStateAbbr: "Monroe, NE",
  },
  {
    zip: "68648",
    ST: "NE",
    cityWithStateAbbr: "Morse Bluff, NE",
  },
  {
    zip: "68649",
    ST: "NE",
    cityWithStateAbbr: "North Bend, NE",
  },
  {
    zip: "68651",
    ST: "NE",
    cityWithStateAbbr: "Osceola, NE",
  },
  {
    zip: "68652",
    ST: "NE",
    cityWithStateAbbr: "Petersburg, NE",
  },
  {
    zip: "68653",
    ST: "NE",
    cityWithStateAbbr: "Platte Center, NE",
  },
  {
    zip: "68654",
    ST: "NE",
    cityWithStateAbbr: "Polk, NE",
  },
  {
    zip: "68655",
    ST: "NE",
    cityWithStateAbbr: "Primrose, NE",
  },
  {
    zip: "68658",
    ST: "NE",
    cityWithStateAbbr: "Rising City, NE",
  },
  {
    zip: "68659",
    ST: "NE",
    cityWithStateAbbr: "Rogers, NE",
  },
  {
    zip: "68660",
    ST: "NE",
    cityWithStateAbbr: "Saint Edward, NE",
  },
  {
    zip: "68661",
    ST: "NE",
    cityWithStateAbbr: "Schuyler, NE",
  },
  {
    zip: "68662",
    ST: "NE",
    cityWithStateAbbr: "Shelby, NE",
  },
  {
    zip: "68663",
    ST: "NE",
    cityWithStateAbbr: "Silver Creek, NE",
  },
  {
    zip: "68664",
    ST: "NE",
    cityWithStateAbbr: "Snyder, NE",
  },
  {
    zip: "68665",
    ST: "NE",
    cityWithStateAbbr: "Spalding, NE",
  },
  {
    zip: "68666",
    ST: "NE",
    cityWithStateAbbr: "Stromsburg, NE",
  },
  {
    zip: "68667",
    ST: "NE",
    cityWithStateAbbr: "Surprise, NE",
  },
  {
    zip: "68669",
    ST: "NE",
    cityWithStateAbbr: "Ulysses, NE",
  },
  {
    zip: "68701",
    ST: "NE",
    cityWithStateAbbr: "Norfolk, NE",
  },
  {
    zip: "68702",
    ST: "NE",
    cityWithStateAbbr: "Norfolk, NE",
  },
  {
    zip: "68710",
    ST: "NE",
    cityWithStateAbbr: "Allen, NE",
  },
  {
    zip: "68711",
    ST: "NE",
    cityWithStateAbbr: "Amelia, NE",
  },
  {
    zip: "68713",
    ST: "NE",
    cityWithStateAbbr: "Atkinson, NE",
  },
  {
    zip: "68714",
    ST: "NE",
    cityWithStateAbbr: "Bassett, NE",
  },
  {
    zip: "68715",
    ST: "NE",
    cityWithStateAbbr: "Battle Creek, NE",
  },
  {
    zip: "68716",
    ST: "NE",
    cityWithStateAbbr: "Beemer, NE",
  },
  {
    zip: "68717",
    ST: "NE",
    cityWithStateAbbr: "Belden, NE",
  },
  {
    zip: "68718",
    ST: "NE",
    cityWithStateAbbr: "Bloomfield, NE",
  },
  {
    zip: "68719",
    ST: "NE",
    cityWithStateAbbr: "Bristow, NE",
  },
  {
    zip: "68720",
    ST: "NE",
    cityWithStateAbbr: "Brunswick, NE",
  },
  {
    zip: "68722",
    ST: "NE",
    cityWithStateAbbr: "Butte, NE",
  },
  {
    zip: "68723",
    ST: "NE",
    cityWithStateAbbr: "Carroll, NE",
  },
  {
    zip: "68724",
    ST: "NE",
    cityWithStateAbbr: "Center, NE",
  },
  {
    zip: "68725",
    ST: "NE",
    cityWithStateAbbr: "Chambers, NE",
  },
  {
    zip: "68726",
    ST: "NE",
    cityWithStateAbbr: "Clearwater, NE",
  },
  {
    zip: "68727",
    ST: "NE",
    cityWithStateAbbr: "Coleridge, NE",
  },
  {
    zip: "68728",
    ST: "NE",
    cityWithStateAbbr: "Concord, NE",
  },
  {
    zip: "68729",
    ST: "NE",
    cityWithStateAbbr: "Creighton, NE",
  },
  {
    zip: "68730",
    ST: "NE",
    cityWithStateAbbr: "Crofton, NE",
  },
  {
    zip: "68731",
    ST: "NE",
    cityWithStateAbbr: "Dakota City, NE",
  },
  {
    zip: "68732",
    ST: "NE",
    cityWithStateAbbr: "Dixon, NE",
  },
  {
    zip: "68733",
    ST: "NE",
    cityWithStateAbbr: "Emerson, NE",
  },
  {
    zip: "68734",
    ST: "NE",
    cityWithStateAbbr: "Emmet, NE",
  },
  {
    zip: "68735",
    ST: "NE",
    cityWithStateAbbr: "Ewing, NE",
  },
  {
    zip: "68736",
    ST: "NE",
    cityWithStateAbbr: "Fordyce, NE",
  },
  {
    zip: "68738",
    ST: "NE",
    cityWithStateAbbr: "Hadar, NE",
  },
  {
    zip: "68739",
    ST: "NE",
    cityWithStateAbbr: "Hartington, NE",
  },
  {
    zip: "68740",
    ST: "NE",
    cityWithStateAbbr: "Hoskins, NE",
  },
  {
    zip: "68741",
    ST: "NE",
    cityWithStateAbbr: "Hubbard, NE",
  },
  {
    zip: "68742",
    ST: "NE",
    cityWithStateAbbr: "Inman, NE",
  },
  {
    zip: "68743",
    ST: "NE",
    cityWithStateAbbr: "Jackson, NE",
  },
  {
    zip: "68745",
    ST: "NE",
    cityWithStateAbbr: "Laurel, NE",
  },
  {
    zip: "68746",
    ST: "NE",
    cityWithStateAbbr: "Lynch, NE",
  },
  {
    zip: "68747",
    ST: "NE",
    cityWithStateAbbr: "Mclean, NE",
  },
  {
    zip: "68748",
    ST: "NE",
    cityWithStateAbbr: "Madison, NE",
  },
  {
    zip: "68749",
    ST: "NE",
    cityWithStateAbbr: "Magnet, NE",
  },
  {
    zip: "68751",
    ST: "NE",
    cityWithStateAbbr: "Maskell, NE",
  },
  {
    zip: "68752",
    ST: "NE",
    cityWithStateAbbr: "Meadow Grove, NE",
  },
  {
    zip: "68753",
    ST: "NE",
    cityWithStateAbbr: "Mills, NE",
  },
  {
    zip: "68755",
    ST: "NE",
    cityWithStateAbbr: "Naper, NE",
  },
  {
    zip: "68756",
    ST: "NE",
    cityWithStateAbbr: "Neligh, NE",
  },
  {
    zip: "68757",
    ST: "NE",
    cityWithStateAbbr: "Newcastle, NE",
  },
  {
    zip: "68758",
    ST: "NE",
    cityWithStateAbbr: "Newman Grove, NE",
  },
  {
    zip: "68759",
    ST: "NE",
    cityWithStateAbbr: "Newport, NE",
  },
  {
    zip: "68760",
    ST: "NE",
    cityWithStateAbbr: "Niobrara, NE",
  },
  {
    zip: "68761",
    ST: "NE",
    cityWithStateAbbr: "Oakdale, NE",
  },
  {
    zip: "68763",
    ST: "NE",
    cityWithStateAbbr: "Oneill, NE",
  },
  {
    zip: "68764",
    ST: "NE",
    cityWithStateAbbr: "Orchard, NE",
  },
  {
    zip: "68765",
    ST: "NE",
    cityWithStateAbbr: "Osmond, NE",
  },
  {
    zip: "68766",
    ST: "NE",
    cityWithStateAbbr: "Page, NE",
  },
  {
    zip: "68767",
    ST: "NE",
    cityWithStateAbbr: "Pierce, NE",
  },
  {
    zip: "68768",
    ST: "NE",
    cityWithStateAbbr: "Pilger, NE",
  },
  {
    zip: "68769",
    ST: "NE",
    cityWithStateAbbr: "Plainview, NE",
  },
  {
    zip: "68770",
    ST: "NE",
    cityWithStateAbbr: "Ponca, NE",
  },
  {
    zip: "68771",
    ST: "NE",
    cityWithStateAbbr: "Randolph, NE",
  },
  {
    zip: "68773",
    ST: "NE",
    cityWithStateAbbr: "Royal, NE",
  },
  {
    zip: "68774",
    ST: "NE",
    cityWithStateAbbr: "Saint Helena, NE",
  },
  {
    zip: "68776",
    ST: "NE",
    cityWithStateAbbr: "South Sioux City, NE",
  },
  {
    zip: "68777",
    ST: "NE",
    cityWithStateAbbr: "Spencer, NE",
  },
  {
    zip: "68778",
    ST: "NE",
    cityWithStateAbbr: "Springview, NE",
  },
  {
    zip: "68779",
    ST: "NE",
    cityWithStateAbbr: "Stanton, NE",
  },
  {
    zip: "68780",
    ST: "NE",
    cityWithStateAbbr: "Stuart, NE",
  },
  {
    zip: "68781",
    ST: "NE",
    cityWithStateAbbr: "Tilden, NE",
  },
  {
    zip: "68783",
    ST: "NE",
    cityWithStateAbbr: "Verdigre, NE",
  },
  {
    zip: "68784",
    ST: "NE",
    cityWithStateAbbr: "Wakefield, NE",
  },
  {
    zip: "68785",
    ST: "NE",
    cityWithStateAbbr: "Waterbury, NE",
  },
  {
    zip: "68786",
    ST: "NE",
    cityWithStateAbbr: "Wausa, NE",
  },
  {
    zip: "68787",
    ST: "NE",
    cityWithStateAbbr: "Wayne, NE",
  },
  {
    zip: "68788",
    ST: "NE",
    cityWithStateAbbr: "West Point, NE",
  },
  {
    zip: "68789",
    ST: "NE",
    cityWithStateAbbr: "Winnetoon, NE",
  },
  {
    zip: "68790",
    ST: "NE",
    cityWithStateAbbr: "Winside, NE",
  },
  {
    zip: "68791",
    ST: "NE",
    cityWithStateAbbr: "Wisner, NE",
  },
  {
    zip: "68792",
    ST: "NE",
    cityWithStateAbbr: "Wynot, NE",
  },
  {
    zip: "68801",
    ST: "NE",
    cityWithStateAbbr: "Grand Island, NE",
  },
  {
    zip: "68802",
    ST: "NE",
    cityWithStateAbbr: "Grand Island, NE",
  },
  {
    zip: "68803",
    ST: "NE",
    cityWithStateAbbr: "Grand Island, NE",
  },
  {
    zip: "68810",
    ST: "NE",
    cityWithStateAbbr: "Alda, NE",
  },
  {
    zip: "68812",
    ST: "NE",
    cityWithStateAbbr: "Amherst, NE",
  },
  {
    zip: "68813",
    ST: "NE",
    cityWithStateAbbr: "Anselmo, NE",
  },
  {
    zip: "68814",
    ST: "NE",
    cityWithStateAbbr: "Ansley, NE",
  },
  {
    zip: "68815",
    ST: "NE",
    cityWithStateAbbr: "Arcadia, NE",
  },
  {
    zip: "68816",
    ST: "NE",
    cityWithStateAbbr: "Archer, NE",
  },
  {
    zip: "68817",
    ST: "NE",
    cityWithStateAbbr: "Ashton, NE",
  },
  {
    zip: "68818",
    ST: "NE",
    cityWithStateAbbr: "Aurora, NE",
  },
  {
    zip: "68820",
    ST: "NE",
    cityWithStateAbbr: "Boelus, NE",
  },
  {
    zip: "68821",
    ST: "NE",
    cityWithStateAbbr: "Brewster, NE",
  },
  {
    zip: "68822",
    ST: "NE",
    cityWithStateAbbr: "Broken Bow, NE",
  },
  {
    zip: "68823",
    ST: "NE",
    cityWithStateAbbr: "Burwell, NE",
  },
  {
    zip: "68824",
    ST: "NE",
    cityWithStateAbbr: "Cairo, NE",
  },
  {
    zip: "68825",
    ST: "NE",
    cityWithStateAbbr: "Callaway, NE",
  },
  {
    zip: "68826",
    ST: "NE",
    cityWithStateAbbr: "Central City, NE",
  },
  {
    zip: "68827",
    ST: "NE",
    cityWithStateAbbr: "Chapman, NE",
  },
  {
    zip: "68828",
    ST: "NE",
    cityWithStateAbbr: "Comstock, NE",
  },
  {
    zip: "68831",
    ST: "NE",
    cityWithStateAbbr: "Dannebrog, NE",
  },
  {
    zip: "68832",
    ST: "NE",
    cityWithStateAbbr: "Doniphan, NE",
  },
  {
    zip: "68833",
    ST: "NE",
    cityWithStateAbbr: "Dunning, NE",
  },
  {
    zip: "68834",
    ST: "NE",
    cityWithStateAbbr: "Eddyville, NE",
  },
  {
    zip: "68835",
    ST: "NE",
    cityWithStateAbbr: "Elba, NE",
  },
  {
    zip: "68836",
    ST: "NE",
    cityWithStateAbbr: "Elm Creek, NE",
  },
  {
    zip: "68837",
    ST: "NE",
    cityWithStateAbbr: "Elyria, NE",
  },
  {
    zip: "68838",
    ST: "NE",
    cityWithStateAbbr: "Farwell, NE",
  },
  {
    zip: "68840",
    ST: "NE",
    cityWithStateAbbr: "Gibbon, NE",
  },
  {
    zip: "68841",
    ST: "NE",
    cityWithStateAbbr: "Giltner, NE",
  },
  {
    zip: "68842",
    ST: "NE",
    cityWithStateAbbr: "Greeley, NE",
  },
  {
    zip: "68843",
    ST: "NE",
    cityWithStateAbbr: "Hampton, NE",
  },
  {
    zip: "68844",
    ST: "NE",
    cityWithStateAbbr: "Hazard, NE",
  },
  {
    zip: "68845",
    ST: "NE",
    cityWithStateAbbr: "Kearney, NE",
  },
  {
    zip: "68846",
    ST: "NE",
    cityWithStateAbbr: "Hordville, NE",
  },
  {
    zip: "68847",
    ST: "NE",
    cityWithStateAbbr: "Kearney, NE",
  },
  {
    zip: "68848",
    ST: "NE",
    cityWithStateAbbr: "Kearney, NE",
  },
  {
    zip: "68849",
    ST: "NE",
    cityWithStateAbbr: "Kearney, NE",
  },
  {
    zip: "68850",
    ST: "NE",
    cityWithStateAbbr: "Lexington, NE",
  },
  {
    zip: "68852",
    ST: "NE",
    cityWithStateAbbr: "Litchfield, NE",
  },
  {
    zip: "68853",
    ST: "NE",
    cityWithStateAbbr: "Loup City, NE",
  },
  {
    zip: "68854",
    ST: "NE",
    cityWithStateAbbr: "Marquette, NE",
  },
  {
    zip: "68855",
    ST: "NE",
    cityWithStateAbbr: "Mason City, NE",
  },
  {
    zip: "68856",
    ST: "NE",
    cityWithStateAbbr: "Merna, NE",
  },
  {
    zip: "68858",
    ST: "NE",
    cityWithStateAbbr: "Miller, NE",
  },
  {
    zip: "68859",
    ST: "NE",
    cityWithStateAbbr: "North Loup, NE",
  },
  {
    zip: "68860",
    ST: "NE",
    cityWithStateAbbr: "Oconto, NE",
  },
  {
    zip: "68861",
    ST: "NE",
    cityWithStateAbbr: "Odessa, NE",
  },
  {
    zip: "68862",
    ST: "NE",
    cityWithStateAbbr: "Ord, NE",
  },
  {
    zip: "68863",
    ST: "NE",
    cityWithStateAbbr: "Overton, NE",
  },
  {
    zip: "68864",
    ST: "NE",
    cityWithStateAbbr: "Palmer, NE",
  },
  {
    zip: "68865",
    ST: "NE",
    cityWithStateAbbr: "Phillips, NE",
  },
  {
    zip: "68866",
    ST: "NE",
    cityWithStateAbbr: "Pleasanton, NE",
  },
  {
    zip: "68869",
    ST: "NE",
    cityWithStateAbbr: "Ravenna, NE",
  },
  {
    zip: "68870",
    ST: "NE",
    cityWithStateAbbr: "Riverdale, NE",
  },
  {
    zip: "68871",
    ST: "NE",
    cityWithStateAbbr: "Rockville, NE",
  },
  {
    zip: "68872",
    ST: "NE",
    cityWithStateAbbr: "Saint Libory, NE",
  },
  {
    zip: "68873",
    ST: "NE",
    cityWithStateAbbr: "Saint Paul, NE",
  },
  {
    zip: "68874",
    ST: "NE",
    cityWithStateAbbr: "Sargent, NE",
  },
  {
    zip: "68875",
    ST: "NE",
    cityWithStateAbbr: "Scotia, NE",
  },
  {
    zip: "68876",
    ST: "NE",
    cityWithStateAbbr: "Shelton, NE",
  },
  {
    zip: "68878",
    ST: "NE",
    cityWithStateAbbr: "Sumner, NE",
  },
  {
    zip: "68879",
    ST: "NE",
    cityWithStateAbbr: "Taylor, NE",
  },
  {
    zip: "68881",
    ST: "NE",
    cityWithStateAbbr: "Westerville, NE",
  },
  {
    zip: "68882",
    ST: "NE",
    cityWithStateAbbr: "Wolbach, NE",
  },
  {
    zip: "68883",
    ST: "NE",
    cityWithStateAbbr: "Wood River, NE",
  },
  {
    zip: "68901",
    ST: "NE",
    cityWithStateAbbr: "Hastings, NE",
  },
  {
    zip: "68902",
    ST: "NE",
    cityWithStateAbbr: "Hastings, NE",
  },
  {
    zip: "68920",
    ST: "NE",
    cityWithStateAbbr: "Alma, NE",
  },
  {
    zip: "68922",
    ST: "NE",
    cityWithStateAbbr: "Arapahoe, NE",
  },
  {
    zip: "68923",
    ST: "NE",
    cityWithStateAbbr: "Atlanta, NE",
  },
  {
    zip: "68924",
    ST: "NE",
    cityWithStateAbbr: "Axtell, NE",
  },
  {
    zip: "68925",
    ST: "NE",
    cityWithStateAbbr: "Ayr, NE",
  },
  {
    zip: "68926",
    ST: "NE",
    cityWithStateAbbr: "Beaver City, NE",
  },
  {
    zip: "68927",
    ST: "NE",
    cityWithStateAbbr: "Bertrand, NE",
  },
  {
    zip: "68928",
    ST: "NE",
    cityWithStateAbbr: "Bladen, NE",
  },
  {
    zip: "68929",
    ST: "NE",
    cityWithStateAbbr: "Bloomington, NE",
  },
  {
    zip: "68930",
    ST: "NE",
    cityWithStateAbbr: "Blue Hill, NE",
  },
  {
    zip: "68932",
    ST: "NE",
    cityWithStateAbbr: "Campbell, NE",
  },
  {
    zip: "68933",
    ST: "NE",
    cityWithStateAbbr: "Clay Center, NE",
  },
  {
    zip: "68934",
    ST: "NE",
    cityWithStateAbbr: "Deweese, NE",
  },
  {
    zip: "68935",
    ST: "NE",
    cityWithStateAbbr: "Edgar, NE",
  },
  {
    zip: "68936",
    ST: "NE",
    cityWithStateAbbr: "Edison, NE",
  },
  {
    zip: "68937",
    ST: "NE",
    cityWithStateAbbr: "Elwood, NE",
  },
  {
    zip: "68938",
    ST: "NE",
    cityWithStateAbbr: "Fairfield, NE",
  },
  {
    zip: "68939",
    ST: "NE",
    cityWithStateAbbr: "Franklin, NE",
  },
  {
    zip: "68940",
    ST: "NE",
    cityWithStateAbbr: "Funk, NE",
  },
  {
    zip: "68941",
    ST: "NE",
    cityWithStateAbbr: "Glenvil, NE",
  },
  {
    zip: "68942",
    ST: "NE",
    cityWithStateAbbr: "Guide Rock, NE",
  },
  {
    zip: "68943",
    ST: "NE",
    cityWithStateAbbr: "Hardy, NE",
  },
  {
    zip: "68944",
    ST: "NE",
    cityWithStateAbbr: "Harvard, NE",
  },
  {
    zip: "68945",
    ST: "NE",
    cityWithStateAbbr: "Heartwell, NE",
  },
  {
    zip: "68946",
    ST: "NE",
    cityWithStateAbbr: "Hendley, NE",
  },
  {
    zip: "68947",
    ST: "NE",
    cityWithStateAbbr: "Hildreth, NE",
  },
  {
    zip: "68948",
    ST: "NE",
    cityWithStateAbbr: "Holbrook, NE",
  },
  {
    zip: "68949",
    ST: "NE",
    cityWithStateAbbr: "Holdrege, NE",
  },
  {
    zip: "68950",
    ST: "NE",
    cityWithStateAbbr: "Holstein, NE",
  },
  {
    zip: "68952",
    ST: "NE",
    cityWithStateAbbr: "Inavale, NE",
  },
  {
    zip: "68954",
    ST: "NE",
    cityWithStateAbbr: "Inland, NE",
  },
  {
    zip: "68955",
    ST: "NE",
    cityWithStateAbbr: "Juniata, NE",
  },
  {
    zip: "68956",
    ST: "NE",
    cityWithStateAbbr: "Kenesaw, NE",
  },
  {
    zip: "68957",
    ST: "NE",
    cityWithStateAbbr: "Lawrence, NE",
  },
  {
    zip: "68958",
    ST: "NE",
    cityWithStateAbbr: "Loomis, NE",
  },
  {
    zip: "68959",
    ST: "NE",
    cityWithStateAbbr: "Minden, NE",
  },
  {
    zip: "68960",
    ST: "NE",
    cityWithStateAbbr: "Naponee, NE",
  },
  {
    zip: "68961",
    ST: "NE",
    cityWithStateAbbr: "Nelson, NE",
  },
  {
    zip: "68964",
    ST: "NE",
    cityWithStateAbbr: "Oak, NE",
  },
  {
    zip: "68966",
    ST: "NE",
    cityWithStateAbbr: "Orleans, NE",
  },
  {
    zip: "68967",
    ST: "NE",
    cityWithStateAbbr: "Oxford, NE",
  },
  {
    zip: "68969",
    ST: "NE",
    cityWithStateAbbr: "Ragan, NE",
  },
  {
    zip: "68970",
    ST: "NE",
    cityWithStateAbbr: "Red Cloud, NE",
  },
  {
    zip: "68971",
    ST: "NE",
    cityWithStateAbbr: "Republican City, NE",
  },
  {
    zip: "68972",
    ST: "NE",
    cityWithStateAbbr: "Riverton, NE",
  },
  {
    zip: "68973",
    ST: "NE",
    cityWithStateAbbr: "Roseland, NE",
  },
  {
    zip: "68974",
    ST: "NE",
    cityWithStateAbbr: "Ruskin, NE",
  },
  {
    zip: "68975",
    ST: "NE",
    cityWithStateAbbr: "Saronville, NE",
  },
  {
    zip: "68976",
    ST: "NE",
    cityWithStateAbbr: "Smithfield, NE",
  },
  {
    zip: "68977",
    ST: "NE",
    cityWithStateAbbr: "Stamford, NE",
  },
  {
    zip: "68978",
    ST: "NE",
    cityWithStateAbbr: "Superior, NE",
  },
  {
    zip: "68979",
    ST: "NE",
    cityWithStateAbbr: "Sutton, NE",
  },
  {
    zip: "68980",
    ST: "NE",
    cityWithStateAbbr: "Trumbull, NE",
  },
  {
    zip: "68981",
    ST: "NE",
    cityWithStateAbbr: "Upland, NE",
  },
  {
    zip: "68982",
    ST: "NE",
    cityWithStateAbbr: "Wilcox, NE",
  },
  {
    zip: "69001",
    ST: "NE",
    cityWithStateAbbr: "Mc Cook, NE",
  },
  {
    zip: "69020",
    ST: "NE",
    cityWithStateAbbr: "Bartley, NE",
  },
  {
    zip: "69021",
    ST: "NE",
    cityWithStateAbbr: "Benkelman, NE",
  },
  {
    zip: "69022",
    ST: "NE",
    cityWithStateAbbr: "Cambridge, NE",
  },
  {
    zip: "69023",
    ST: "NE",
    cityWithStateAbbr: "Champion, NE",
  },
  {
    zip: "69024",
    ST: "NE",
    cityWithStateAbbr: "Culbertson, NE",
  },
  {
    zip: "69025",
    ST: "NE",
    cityWithStateAbbr: "Curtis, NE",
  },
  {
    zip: "69026",
    ST: "NE",
    cityWithStateAbbr: "Danbury, NE",
  },
  {
    zip: "69027",
    ST: "NE",
    cityWithStateAbbr: "Enders, NE",
  },
  {
    zip: "69028",
    ST: "NE",
    cityWithStateAbbr: "Eustis, NE",
  },
  {
    zip: "69029",
    ST: "NE",
    cityWithStateAbbr: "Farnam, NE",
  },
  {
    zip: "69030",
    ST: "NE",
    cityWithStateAbbr: "Haigler, NE",
  },
  {
    zip: "69032",
    ST: "NE",
    cityWithStateAbbr: "Hayes Center, NE",
  },
  {
    zip: "69033",
    ST: "NE",
    cityWithStateAbbr: "Imperial, NE",
  },
  {
    zip: "69034",
    ST: "NE",
    cityWithStateAbbr: "Indianola, NE",
  },
  {
    zip: "69036",
    ST: "NE",
    cityWithStateAbbr: "Lebanon, NE",
  },
  {
    zip: "69037",
    ST: "NE",
    cityWithStateAbbr: "Max, NE",
  },
  {
    zip: "69038",
    ST: "NE",
    cityWithStateAbbr: "Maywood, NE",
  },
  {
    zip: "69039",
    ST: "NE",
    cityWithStateAbbr: "Moorefield, NE",
  },
  {
    zip: "69040",
    ST: "NE",
    cityWithStateAbbr: "Palisade, NE",
  },
  {
    zip: "69041",
    ST: "NE",
    cityWithStateAbbr: "Parks, NE",
  },
  {
    zip: "69042",
    ST: "NE",
    cityWithStateAbbr: "Stockville, NE",
  },
  {
    zip: "69043",
    ST: "NE",
    cityWithStateAbbr: "Stratton, NE",
  },
  {
    zip: "69044",
    ST: "NE",
    cityWithStateAbbr: "Trenton, NE",
  },
  {
    zip: "69045",
    ST: "NE",
    cityWithStateAbbr: "Wauneta, NE",
  },
  {
    zip: "69046",
    ST: "NE",
    cityWithStateAbbr: "Wilsonville, NE",
  },
  {
    zip: "69101",
    ST: "NE",
    cityWithStateAbbr: "North Platte, NE",
  },
  {
    zip: "69103",
    ST: "NE",
    cityWithStateAbbr: "North Platte, NE",
  },
  {
    zip: "69120",
    ST: "NE",
    cityWithStateAbbr: "Arnold, NE",
  },
  {
    zip: "69121",
    ST: "NE",
    cityWithStateAbbr: "Arthur, NE",
  },
  {
    zip: "69122",
    ST: "NE",
    cityWithStateAbbr: "Big Springs, NE",
  },
  {
    zip: "69123",
    ST: "NE",
    cityWithStateAbbr: "Brady, NE",
  },
  {
    zip: "69125",
    ST: "NE",
    cityWithStateAbbr: "Broadwater, NE",
  },
  {
    zip: "69127",
    ST: "NE",
    cityWithStateAbbr: "Brule, NE",
  },
  {
    zip: "69128",
    ST: "NE",
    cityWithStateAbbr: "Bushnell, NE",
  },
  {
    zip: "69129",
    ST: "NE",
    cityWithStateAbbr: "Chappell, NE",
  },
  {
    zip: "69130",
    ST: "NE",
    cityWithStateAbbr: "Cozad, NE",
  },
  {
    zip: "69131",
    ST: "NE",
    cityWithStateAbbr: "Dalton, NE",
  },
  {
    zip: "69132",
    ST: "NE",
    cityWithStateAbbr: "Dickens, NE",
  },
  {
    zip: "69133",
    ST: "NE",
    cityWithStateAbbr: "Dix, NE",
  },
  {
    zip: "69134",
    ST: "NE",
    cityWithStateAbbr: "Elsie, NE",
  },
  {
    zip: "69135",
    ST: "NE",
    cityWithStateAbbr: "Elsmere, NE",
  },
  {
    zip: "69138",
    ST: "NE",
    cityWithStateAbbr: "Gothenburg, NE",
  },
  {
    zip: "69140",
    ST: "NE",
    cityWithStateAbbr: "Grant, NE",
  },
  {
    zip: "69141",
    ST: "NE",
    cityWithStateAbbr: "Gurley, NE",
  },
  {
    zip: "69142",
    ST: "NE",
    cityWithStateAbbr: "Halsey, NE",
  },
  {
    zip: "69143",
    ST: "NE",
    cityWithStateAbbr: "Hershey, NE",
  },
  {
    zip: "69144",
    ST: "NE",
    cityWithStateAbbr: "Keystone, NE",
  },
  {
    zip: "69145",
    ST: "NE",
    cityWithStateAbbr: "Kimball, NE",
  },
  {
    zip: "69146",
    ST: "NE",
    cityWithStateAbbr: "Lemoyne, NE",
  },
  {
    zip: "69147",
    ST: "NE",
    cityWithStateAbbr: "Lewellen, NE",
  },
  {
    zip: "69148",
    ST: "NE",
    cityWithStateAbbr: "Lisco, NE",
  },
  {
    zip: "69149",
    ST: "NE",
    cityWithStateAbbr: "Lodgepole, NE",
  },
  {
    zip: "69150",
    ST: "NE",
    cityWithStateAbbr: "Madrid, NE",
  },
  {
    zip: "69151",
    ST: "NE",
    cityWithStateAbbr: "Maxwell, NE",
  },
  {
    zip: "69152",
    ST: "NE",
    cityWithStateAbbr: "Mullen, NE",
  },
  {
    zip: "69153",
    ST: "NE",
    cityWithStateAbbr: "Ogallala, NE",
  },
  {
    zip: "69154",
    ST: "NE",
    cityWithStateAbbr: "Oshkosh, NE",
  },
  {
    zip: "69155",
    ST: "NE",
    cityWithStateAbbr: "Paxton, NE",
  },
  {
    zip: "69156",
    ST: "NE",
    cityWithStateAbbr: "Potter, NE",
  },
  {
    zip: "69157",
    ST: "NE",
    cityWithStateAbbr: "Purdum, NE",
  },
  {
    zip: "69160",
    ST: "NE",
    cityWithStateAbbr: "Sidney, NE",
  },
  {
    zip: "69161",
    ST: "NE",
    cityWithStateAbbr: "Seneca, NE",
  },
  {
    zip: "69162",
    ST: "NE",
    cityWithStateAbbr: "Sidney, NE",
  },
  {
    zip: "69163",
    ST: "NE",
    cityWithStateAbbr: "Stapleton, NE",
  },
  {
    zip: "69165",
    ST: "NE",
    cityWithStateAbbr: "Sutherland, NE",
  },
  {
    zip: "69166",
    ST: "NE",
    cityWithStateAbbr: "Thedford, NE",
  },
  {
    zip: "69167",
    ST: "NE",
    cityWithStateAbbr: "Tryon, NE",
  },
  {
    zip: "69168",
    ST: "NE",
    cityWithStateAbbr: "Venango, NE",
  },
  {
    zip: "69169",
    ST: "NE",
    cityWithStateAbbr: "Wallace, NE",
  },
  {
    zip: "69170",
    ST: "NE",
    cityWithStateAbbr: "Wellfleet, NE",
  },
  {
    zip: "69171",
    ST: "NE",
    cityWithStateAbbr: "Willow Island, NE",
  },
  {
    zip: "69190",
    ST: "NE",
    cityWithStateAbbr: "Oshkosh, NE",
  },
  {
    zip: "69201",
    ST: "NE",
    cityWithStateAbbr: "Valentine, NE",
  },
  {
    zip: "69210",
    ST: "NE",
    cityWithStateAbbr: "Ainsworth, NE",
  },
  {
    zip: "69211",
    ST: "NE",
    cityWithStateAbbr: "Cody, NE",
  },
  {
    zip: "69212",
    ST: "NE",
    cityWithStateAbbr: "Crookston, NE",
  },
  {
    zip: "69214",
    ST: "NE",
    cityWithStateAbbr: "Johnstown, NE",
  },
  {
    zip: "69216",
    ST: "NE",
    cityWithStateAbbr: "Kilgore, NE",
  },
  {
    zip: "69217",
    ST: "NE",
    cityWithStateAbbr: "Long Pine, NE",
  },
  {
    zip: "69218",
    ST: "NE",
    cityWithStateAbbr: "Merriman, NE",
  },
  {
    zip: "69219",
    ST: "NE",
    cityWithStateAbbr: "Nenzel, NE",
  },
  {
    zip: "69220",
    ST: "NE",
    cityWithStateAbbr: "Sparks, NE",
  },
  {
    zip: "69221",
    ST: "NE",
    cityWithStateAbbr: "Wood Lake, NE",
  },
  {
    zip: "69301",
    ST: "NE",
    cityWithStateAbbr: "Alliance, NE",
  },
  {
    zip: "69331",
    ST: "NE",
    cityWithStateAbbr: "Angora, NE",
  },
  {
    zip: "69333",
    ST: "NE",
    cityWithStateAbbr: "Ashby, NE",
  },
  {
    zip: "69334",
    ST: "NE",
    cityWithStateAbbr: "Bayard, NE",
  },
  {
    zip: "69335",
    ST: "NE",
    cityWithStateAbbr: "Bingham, NE",
  },
  {
    zip: "69336",
    ST: "NE",
    cityWithStateAbbr: "Bridgeport, NE",
  },
  {
    zip: "69337",
    ST: "NE",
    cityWithStateAbbr: "Chadron, NE",
  },
  {
    zip: "69339",
    ST: "NE",
    cityWithStateAbbr: "Crawford, NE",
  },
  {
    zip: "69340",
    ST: "NE",
    cityWithStateAbbr: "Ellsworth, NE",
  },
  {
    zip: "69341",
    ST: "NE",
    cityWithStateAbbr: "Gering, NE",
  },
  {
    zip: "69343",
    ST: "NE",
    cityWithStateAbbr: "Gordon, NE",
  },
  {
    zip: "69345",
    ST: "NE",
    cityWithStateAbbr: "Harrisburg, NE",
  },
  {
    zip: "69346",
    ST: "NE",
    cityWithStateAbbr: "Harrison, NE",
  },
  {
    zip: "69347",
    ST: "NE",
    cityWithStateAbbr: "Hay Springs, NE",
  },
  {
    zip: "69348",
    ST: "NE",
    cityWithStateAbbr: "Hemingford, NE",
  },
  {
    zip: "69350",
    ST: "NE",
    cityWithStateAbbr: "Hyannis, NE",
  },
  {
    zip: "69351",
    ST: "NE",
    cityWithStateAbbr: "Lakeside, NE",
  },
  {
    zip: "69352",
    ST: "NE",
    cityWithStateAbbr: "Lyman, NE",
  },
  {
    zip: "69353",
    ST: "NE",
    cityWithStateAbbr: "Mcgrew, NE",
  },
  {
    zip: "69354",
    ST: "NE",
    cityWithStateAbbr: "Marsland, NE",
  },
  {
    zip: "69355",
    ST: "NE",
    cityWithStateAbbr: "Melbeta, NE",
  },
  {
    zip: "69356",
    ST: "NE",
    cityWithStateAbbr: "Minatare, NE",
  },
  {
    zip: "69357",
    ST: "NE",
    cityWithStateAbbr: "Mitchell, NE",
  },
  {
    zip: "69358",
    ST: "NE",
    cityWithStateAbbr: "Morrill, NE",
  },
  {
    zip: "69360",
    ST: "NE",
    cityWithStateAbbr: "Rushville, NE",
  },
  {
    zip: "69361",
    ST: "NE",
    cityWithStateAbbr: "Scottsbluff, NE",
  },
  {
    zip: "69363",
    ST: "NE",
    cityWithStateAbbr: "Scottsbluff, NE",
  },
  {
    zip: "69365",
    ST: "SD",
    cityWithStateAbbr: "Whiteclay, SD",
  },
  {
    zip: "69366",
    ST: "NE",
    cityWithStateAbbr: "Whitman, NE",
  },
  {
    zip: "69367",
    ST: "NE",
    cityWithStateAbbr: "Whitney, NE",
  },
  {
    zip: "70001",
    ST: "LA",
    cityWithStateAbbr: "Metairie, LA",
  },
  {
    zip: "70002",
    ST: "LA",
    cityWithStateAbbr: "Metairie, LA",
  },
  {
    zip: "70003",
    ST: "LA",
    cityWithStateAbbr: "Metairie, LA",
  },
  {
    zip: "70004",
    ST: "LA",
    cityWithStateAbbr: "Metairie, LA",
  },
  {
    zip: "70005",
    ST: "LA",
    cityWithStateAbbr: "Metairie, LA",
  },
  {
    zip: "70006",
    ST: "LA",
    cityWithStateAbbr: "Metairie, LA",
  },
  {
    zip: "70009",
    ST: "LA",
    cityWithStateAbbr: "Metairie, LA",
  },
  {
    zip: "70010",
    ST: "LA",
    cityWithStateAbbr: "Metairie, LA",
  },
  {
    zip: "70011",
    ST: "LA",
    cityWithStateAbbr: "Metairie, LA",
  },
  {
    zip: "70030",
    ST: "LA",
    cityWithStateAbbr: "Des Allemands, LA",
  },
  {
    zip: "70031",
    ST: "LA",
    cityWithStateAbbr: "Ama, LA",
  },
  {
    zip: "70032",
    ST: "LA",
    cityWithStateAbbr: "Arabi, LA",
  },
  {
    zip: "70033",
    ST: "LA",
    cityWithStateAbbr: "Metairie, LA",
  },
  {
    zip: "70036",
    ST: "LA",
    cityWithStateAbbr: "Barataria, LA",
  },
  {
    zip: "70037",
    ST: "LA",
    cityWithStateAbbr: "Belle Chasse, LA",
  },
  {
    zip: "70038",
    ST: "LA",
    cityWithStateAbbr: "Boothville, LA",
  },
  {
    zip: "70039",
    ST: "LA",
    cityWithStateAbbr: "Boutte, LA",
  },
  {
    zip: "70040",
    ST: "LA",
    cityWithStateAbbr: "Braithwaite, LA",
  },
  {
    zip: "70041",
    ST: "LA",
    cityWithStateAbbr: "Buras, LA",
  },
  {
    zip: "70043",
    ST: "LA",
    cityWithStateAbbr: "Chalmette, LA",
  },
  {
    zip: "70044",
    ST: "LA",
    cityWithStateAbbr: "Chalmette, LA",
  },
  {
    zip: "70047",
    ST: "LA",
    cityWithStateAbbr: "Destrehan, LA",
  },
  {
    zip: "70049",
    ST: "LA",
    cityWithStateAbbr: "Edgard, LA",
  },
  {
    zip: "70050",
    ST: "LA",
    cityWithStateAbbr: "Empire, LA",
  },
  {
    zip: "70051",
    ST: "LA",
    cityWithStateAbbr: "Garyville, LA",
  },
  {
    zip: "70052",
    ST: "LA",
    cityWithStateAbbr: "Gramercy, LA",
  },
  {
    zip: "70053",
    ST: "LA",
    cityWithStateAbbr: "Gretna, LA",
  },
  {
    zip: "70054",
    ST: "LA",
    cityWithStateAbbr: "Gretna, LA",
  },
  {
    zip: "70055",
    ST: "LA",
    cityWithStateAbbr: "Metairie, LA",
  },
  {
    zip: "70056",
    ST: "LA",
    cityWithStateAbbr: "Gretna, LA",
  },
  {
    zip: "70057",
    ST: "LA",
    cityWithStateAbbr: "Hahnville, LA",
  },
  {
    zip: "70058",
    ST: "LA",
    cityWithStateAbbr: "Harvey, LA",
  },
  {
    zip: "70059",
    ST: "LA",
    cityWithStateAbbr: "Harvey, LA",
  },
  {
    zip: "70060",
    ST: "LA",
    cityWithStateAbbr: "Metairie, LA",
  },
  {
    zip: "70062",
    ST: "LA",
    cityWithStateAbbr: "Kenner, LA",
  },
  {
    zip: "70063",
    ST: "LA",
    cityWithStateAbbr: "Kenner, LA",
  },
  {
    zip: "70064",
    ST: "LA",
    cityWithStateAbbr: "Kenner, LA",
  },
  {
    zip: "70065",
    ST: "LA",
    cityWithStateAbbr: "Kenner, LA",
  },
  {
    zip: "70067",
    ST: "LA",
    cityWithStateAbbr: "Lafitte, LA",
  },
  {
    zip: "70068",
    ST: "LA",
    cityWithStateAbbr: "La Place, LA",
  },
  {
    zip: "70069",
    ST: "LA",
    cityWithStateAbbr: "La Place, LA",
  },
  {
    zip: "70070",
    ST: "LA",
    cityWithStateAbbr: "Luling, LA",
  },
  {
    zip: "70071",
    ST: "LA",
    cityWithStateAbbr: "Lutcher, LA",
  },
  {
    zip: "70072",
    ST: "LA",
    cityWithStateAbbr: "Marrero, LA",
  },
  {
    zip: "70073",
    ST: "LA",
    cityWithStateAbbr: "Marrero, LA",
  },
  {
    zip: "70075",
    ST: "LA",
    cityWithStateAbbr: "Meraux, LA",
  },
  {
    zip: "70076",
    ST: "LA",
    cityWithStateAbbr: "Mount Airy, LA",
  },
  {
    zip: "70078",
    ST: "LA",
    cityWithStateAbbr: "New Sarpy, LA",
  },
  {
    zip: "70079",
    ST: "LA",
    cityWithStateAbbr: "Norco, LA",
  },
  {
    zip: "70080",
    ST: "LA",
    cityWithStateAbbr: "Paradis, LA",
  },
  {
    zip: "70081",
    ST: "LA",
    cityWithStateAbbr: "Pilottown, LA",
  },
  {
    zip: "70082",
    ST: "LA",
    cityWithStateAbbr: "Pointe A La Hache, LA",
  },
  {
    zip: "70083",
    ST: "LA",
    cityWithStateAbbr: "Port Sulphur, LA",
  },
  {
    zip: "70084",
    ST: "LA",
    cityWithStateAbbr: "Reserve, LA",
  },
  {
    zip: "70085",
    ST: "LA",
    cityWithStateAbbr: "Saint Bernard, LA",
  },
  {
    zip: "70086",
    ST: "LA",
    cityWithStateAbbr: "Saint James, LA",
  },
  {
    zip: "70087",
    ST: "LA",
    cityWithStateAbbr: "Saint Rose, LA",
  },
  {
    zip: "70090",
    ST: "LA",
    cityWithStateAbbr: "Vacherie, LA",
  },
  {
    zip: "70091",
    ST: "LA",
    cityWithStateAbbr: "Venice, LA",
  },
  {
    zip: "70092",
    ST: "LA",
    cityWithStateAbbr: "Violet, LA",
  },
  {
    zip: "70093",
    ST: "LA",
    cityWithStateAbbr: "Belle Chasse, LA",
  },
  {
    zip: "70094",
    ST: "LA",
    cityWithStateAbbr: "Westwego, LA",
  },
  {
    zip: "70096",
    ST: "LA",
    cityWithStateAbbr: "Westwego, LA",
  },
  {
    zip: "70097",
    ST: "LA",
    cityWithStateAbbr: "Kenner, LA",
  },
  {
    zip: "70112",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70113",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70114",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70115",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70116",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70117",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70118",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70119",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70121",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70122",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70123",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70124",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70125",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70126",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70127",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70128",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70129",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70130",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70131",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70139",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70140",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70141",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70142",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70143",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70145",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70146",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70148",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70150",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70151",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70152",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70153",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70154",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70156",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70157",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70158",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70159",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70160",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70161",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70162",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70163",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70164",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70165",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70166",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70167",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70170",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70172",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70174",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70175",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70176",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70177",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70178",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70179",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70181",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70182",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70183",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70184",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70185",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70186",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70187",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70189",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70190",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70195",
    ST: "LA",
    cityWithStateAbbr: "New Orleans, LA",
  },
  {
    zip: "70301",
    ST: "LA",
    cityWithStateAbbr: "Thibodaux, LA",
  },
  {
    zip: "70302",
    ST: "LA",
    cityWithStateAbbr: "Thibodaux, LA",
  },
  {
    zip: "70310",
    ST: "LA",
    cityWithStateAbbr: "Thibodaux, LA",
  },
  {
    zip: "70339",
    ST: "LA",
    cityWithStateAbbr: "Pierre Part, LA",
  },
  {
    zip: "70340",
    ST: "LA",
    cityWithStateAbbr: "Amelia, LA",
  },
  {
    zip: "70341",
    ST: "LA",
    cityWithStateAbbr: "Belle Rose, LA",
  },
  {
    zip: "70342",
    ST: "LA",
    cityWithStateAbbr: "Berwick, LA",
  },
  {
    zip: "70343",
    ST: "LA",
    cityWithStateAbbr: "Bourg, LA",
  },
  {
    zip: "70344",
    ST: "LA",
    cityWithStateAbbr: "Chauvin, LA",
  },
  {
    zip: "70345",
    ST: "LA",
    cityWithStateAbbr: "Cut Off, LA",
  },
  {
    zip: "70346",
    ST: "LA",
    cityWithStateAbbr: "Donaldsonville, LA",
  },
  {
    zip: "70352",
    ST: "LA",
    cityWithStateAbbr: "Donner, LA",
  },
  {
    zip: "70353",
    ST: "LA",
    cityWithStateAbbr: "Dulac, LA",
  },
  {
    zip: "70354",
    ST: "LA",
    cityWithStateAbbr: "Galliano, LA",
  },
  {
    zip: "70355",
    ST: "LA",
    cityWithStateAbbr: "Gheens, LA",
  },
  {
    zip: "70356",
    ST: "LA",
    cityWithStateAbbr: "Gibson, LA",
  },
  {
    zip: "70357",
    ST: "LA",
    cityWithStateAbbr: "Golden Meadow, LA",
  },
  {
    zip: "70358",
    ST: "LA",
    cityWithStateAbbr: "Grand Isle, LA",
  },
  {
    zip: "70359",
    ST: "LA",
    cityWithStateAbbr: "Gray, LA",
  },
  {
    zip: "70360",
    ST: "LA",
    cityWithStateAbbr: "Houma, LA",
  },
  {
    zip: "70361",
    ST: "LA",
    cityWithStateAbbr: "Houma, LA",
  },
  {
    zip: "70363",
    ST: "LA",
    cityWithStateAbbr: "Houma, LA",
  },
  {
    zip: "70364",
    ST: "LA",
    cityWithStateAbbr: "Houma, LA",
  },
  {
    zip: "70371",
    ST: "LA",
    cityWithStateAbbr: "Kraemer, LA",
  },
  {
    zip: "70372",
    ST: "LA",
    cityWithStateAbbr: "Labadieville, LA",
  },
  {
    zip: "70373",
    ST: "LA",
    cityWithStateAbbr: "Larose, LA",
  },
  {
    zip: "70374",
    ST: "LA",
    cityWithStateAbbr: "Lockport, LA",
  },
  {
    zip: "70375",
    ST: "LA",
    cityWithStateAbbr: "Mathews, LA",
  },
  {
    zip: "70377",
    ST: "LA",
    cityWithStateAbbr: "Montegut, LA",
  },
  {
    zip: "70380",
    ST: "LA",
    cityWithStateAbbr: "Morgan City, LA",
  },
  {
    zip: "70381",
    ST: "LA",
    cityWithStateAbbr: "Morgan City, LA",
  },
  {
    zip: "70390",
    ST: "LA",
    cityWithStateAbbr: "Napoleonville, LA",
  },
  {
    zip: "70391",
    ST: "LA",
    cityWithStateAbbr: "Paincourtville, LA",
  },
  {
    zip: "70392",
    ST: "LA",
    cityWithStateAbbr: "Patterson, LA",
  },
  {
    zip: "70393",
    ST: "LA",
    cityWithStateAbbr: "Plattenville, LA",
  },
  {
    zip: "70394",
    ST: "LA",
    cityWithStateAbbr: "Raceland, LA",
  },
  {
    zip: "70395",
    ST: "LA",
    cityWithStateAbbr: "Schriever, LA",
  },
  {
    zip: "70397",
    ST: "LA",
    cityWithStateAbbr: "Theriot, LA",
  },
  {
    zip: "70401",
    ST: "LA",
    cityWithStateAbbr: "Hammond, LA",
  },
  {
    zip: "70402",
    ST: "LA",
    cityWithStateAbbr: "Hammond, LA",
  },
  {
    zip: "70403",
    ST: "LA",
    cityWithStateAbbr: "Hammond, LA",
  },
  {
    zip: "70404",
    ST: "LA",
    cityWithStateAbbr: "Hammond, LA",
  },
  {
    zip: "70420",
    ST: "LA",
    cityWithStateAbbr: "Abita Springs, LA",
  },
  {
    zip: "70421",
    ST: "LA",
    cityWithStateAbbr: "Akers, LA",
  },
  {
    zip: "70422",
    ST: "LA",
    cityWithStateAbbr: "Amite, LA",
  },
  {
    zip: "70426",
    ST: "LA",
    cityWithStateAbbr: "Angie, LA",
  },
  {
    zip: "70427",
    ST: "LA",
    cityWithStateAbbr: "Bogalusa, LA",
  },
  {
    zip: "70429",
    ST: "LA",
    cityWithStateAbbr: "Bogalusa, LA",
  },
  {
    zip: "70431",
    ST: "LA",
    cityWithStateAbbr: "Bush, LA",
  },
  {
    zip: "70433",
    ST: "LA",
    cityWithStateAbbr: "Covington, LA",
  },
  {
    zip: "70434",
    ST: "LA",
    cityWithStateAbbr: "Covington, LA",
  },
  {
    zip: "70435",
    ST: "LA",
    cityWithStateAbbr: "Covington, LA",
  },
  {
    zip: "70436",
    ST: "LA",
    cityWithStateAbbr: "Fluker, LA",
  },
  {
    zip: "70437",
    ST: "LA",
    cityWithStateAbbr: "Folsom, LA",
  },
  {
    zip: "70438",
    ST: "LA",
    cityWithStateAbbr: "Franklinton, LA",
  },
  {
    zip: "70441",
    ST: "LA",
    cityWithStateAbbr: "Greensburg, LA",
  },
  {
    zip: "70442",
    ST: "LA",
    cityWithStateAbbr: "Husser, LA",
  },
  {
    zip: "70443",
    ST: "LA",
    cityWithStateAbbr: "Independence, LA",
  },
  {
    zip: "70444",
    ST: "LA",
    cityWithStateAbbr: "Kentwood, LA",
  },
  {
    zip: "70445",
    ST: "LA",
    cityWithStateAbbr: "Lacombe, LA",
  },
  {
    zip: "70446",
    ST: "LA",
    cityWithStateAbbr: "Loranger, LA",
  },
  {
    zip: "70447",
    ST: "LA",
    cityWithStateAbbr: "Madisonville, LA",
  },
  {
    zip: "70448",
    ST: "LA",
    cityWithStateAbbr: "Mandeville, LA",
  },
  {
    zip: "70449",
    ST: "LA",
    cityWithStateAbbr: "Maurepas, LA",
  },
  {
    zip: "70450",
    ST: "LA",
    cityWithStateAbbr: "Mount Hermon, LA",
  },
  {
    zip: "70451",
    ST: "LA",
    cityWithStateAbbr: "Natalbany, LA",
  },
  {
    zip: "70452",
    ST: "LA",
    cityWithStateAbbr: "Pearl River, LA",
  },
  {
    zip: "70453",
    ST: "LA",
    cityWithStateAbbr: "Pine Grove, LA",
  },
  {
    zip: "70454",
    ST: "LA",
    cityWithStateAbbr: "Ponchatoula, LA",
  },
  {
    zip: "70455",
    ST: "LA",
    cityWithStateAbbr: "Robert, LA",
  },
  {
    zip: "70456",
    ST: "LA",
    cityWithStateAbbr: "Roseland, LA",
  },
  {
    zip: "70457",
    ST: "LA",
    cityWithStateAbbr: "Saint Benedict, LA",
  },
  {
    zip: "70458",
    ST: "LA",
    cityWithStateAbbr: "Slidell, LA",
  },
  {
    zip: "70459",
    ST: "LA",
    cityWithStateAbbr: "Slidell, LA",
  },
  {
    zip: "70460",
    ST: "LA",
    cityWithStateAbbr: "Slidell, LA",
  },
  {
    zip: "70461",
    ST: "LA",
    cityWithStateAbbr: "Slidell, LA",
  },
  {
    zip: "70462",
    ST: "LA",
    cityWithStateAbbr: "Springfield, LA",
  },
  {
    zip: "70463",
    ST: "LA",
    cityWithStateAbbr: "Sun, LA",
  },
  {
    zip: "70464",
    ST: "LA",
    cityWithStateAbbr: "Talisheek, LA",
  },
  {
    zip: "70465",
    ST: "LA",
    cityWithStateAbbr: "Tangipahoa, LA",
  },
  {
    zip: "70466",
    ST: "LA",
    cityWithStateAbbr: "Tickfaw, LA",
  },
  {
    zip: "70467",
    ST: "LA",
    cityWithStateAbbr: "Varnado, LA",
  },
  {
    zip: "70469",
    ST: "LA",
    cityWithStateAbbr: "Slidell, LA",
  },
  {
    zip: "70470",
    ST: "LA",
    cityWithStateAbbr: "Mandeville, LA",
  },
  {
    zip: "70471",
    ST: "LA",
    cityWithStateAbbr: "Mandeville, LA",
  },
  {
    zip: "70501",
    ST: "LA",
    cityWithStateAbbr: "Lafayette, LA",
  },
  {
    zip: "70502",
    ST: "LA",
    cityWithStateAbbr: "Lafayette, LA",
  },
  {
    zip: "70503",
    ST: "LA",
    cityWithStateAbbr: "Lafayette, LA",
  },
  {
    zip: "70504",
    ST: "LA",
    cityWithStateAbbr: "Lafayette, LA",
  },
  {
    zip: "70505",
    ST: "LA",
    cityWithStateAbbr: "Lafayette, LA",
  },
  {
    zip: "70506",
    ST: "LA",
    cityWithStateAbbr: "Lafayette, LA",
  },
  {
    zip: "70507",
    ST: "LA",
    cityWithStateAbbr: "Lafayette, LA",
  },
  {
    zip: "70508",
    ST: "LA",
    cityWithStateAbbr: "Lafayette, LA",
  },
  {
    zip: "70509",
    ST: "LA",
    cityWithStateAbbr: "Lafayette, LA",
  },
  {
    zip: "70510",
    ST: "LA",
    cityWithStateAbbr: "Abbeville, LA",
  },
  {
    zip: "70511",
    ST: "LA",
    cityWithStateAbbr: "Abbeville, LA",
  },
  {
    zip: "70512",
    ST: "LA",
    cityWithStateAbbr: "Arnaudville, LA",
  },
  {
    zip: "70513",
    ST: "LA",
    cityWithStateAbbr: "Avery Island, LA",
  },
  {
    zip: "70514",
    ST: "LA",
    cityWithStateAbbr: "Baldwin, LA",
  },
  {
    zip: "70515",
    ST: "LA",
    cityWithStateAbbr: "Basile, LA",
  },
  {
    zip: "70516",
    ST: "LA",
    cityWithStateAbbr: "Branch, LA",
  },
  {
    zip: "70517",
    ST: "LA",
    cityWithStateAbbr: "Breaux Bridge, LA",
  },
  {
    zip: "70518",
    ST: "LA",
    cityWithStateAbbr: "Broussard, LA",
  },
  {
    zip: "70519",
    ST: "LA",
    cityWithStateAbbr: "Cade, LA",
  },
  {
    zip: "70520",
    ST: "LA",
    cityWithStateAbbr: "Carencro, LA",
  },
  {
    zip: "70521",
    ST: "LA",
    cityWithStateAbbr: "Cecilia, LA",
  },
  {
    zip: "70522",
    ST: "LA",
    cityWithStateAbbr: "Centerville, LA",
  },
  {
    zip: "70523",
    ST: "LA",
    cityWithStateAbbr: "Charenton, LA",
  },
  {
    zip: "70524",
    ST: "LA",
    cityWithStateAbbr: "Chataignier, LA",
  },
  {
    zip: "70525",
    ST: "LA",
    cityWithStateAbbr: "Church Point, LA",
  },
  {
    zip: "70526",
    ST: "LA",
    cityWithStateAbbr: "Crowley, LA",
  },
  {
    zip: "70527",
    ST: "LA",
    cityWithStateAbbr: "Crowley, LA",
  },
  {
    zip: "70528",
    ST: "LA",
    cityWithStateAbbr: "Delcambre, LA",
  },
  {
    zip: "70529",
    ST: "LA",
    cityWithStateAbbr: "Duson, LA",
  },
  {
    zip: "70531",
    ST: "LA",
    cityWithStateAbbr: "Egan, LA",
  },
  {
    zip: "70532",
    ST: "LA",
    cityWithStateAbbr: "Elton, LA",
  },
  {
    zip: "70533",
    ST: "LA",
    cityWithStateAbbr: "Erath, LA",
  },
  {
    zip: "70534",
    ST: "LA",
    cityWithStateAbbr: "Estherwood, LA",
  },
  {
    zip: "70535",
    ST: "LA",
    cityWithStateAbbr: "Eunice, LA",
  },
  {
    zip: "70537",
    ST: "LA",
    cityWithStateAbbr: "Evangeline, LA",
  },
  {
    zip: "70538",
    ST: "LA",
    cityWithStateAbbr: "Franklin, LA",
  },
  {
    zip: "70540",
    ST: "LA",
    cityWithStateAbbr: "Garden City, LA",
  },
  {
    zip: "70541",
    ST: "LA",
    cityWithStateAbbr: "Grand Coteau, LA",
  },
  {
    zip: "70542",
    ST: "LA",
    cityWithStateAbbr: "Gueydan, LA",
  },
  {
    zip: "70543",
    ST: "LA",
    cityWithStateAbbr: "Iota, LA",
  },
  {
    zip: "70544",
    ST: "LA",
    cityWithStateAbbr: "Jeanerette, LA",
  },
  {
    zip: "70546",
    ST: "LA",
    cityWithStateAbbr: "Jennings, LA",
  },
  {
    zip: "70548",
    ST: "LA",
    cityWithStateAbbr: "Kaplan, LA",
  },
  {
    zip: "70549",
    ST: "LA",
    cityWithStateAbbr: "Lake Arthur, LA",
  },
  {
    zip: "70550",
    ST: "LA",
    cityWithStateAbbr: "Lawtell, LA",
  },
  {
    zip: "70551",
    ST: "LA",
    cityWithStateAbbr: "Leonville, LA",
  },
  {
    zip: "70552",
    ST: "LA",
    cityWithStateAbbr: "Loreauville, LA",
  },
  {
    zip: "70554",
    ST: "LA",
    cityWithStateAbbr: "Mamou, LA",
  },
  {
    zip: "70555",
    ST: "LA",
    cityWithStateAbbr: "Maurice, LA",
  },
  {
    zip: "70556",
    ST: "LA",
    cityWithStateAbbr: "Mermentau, LA",
  },
  {
    zip: "70558",
    ST: "LA",
    cityWithStateAbbr: "Milton, LA",
  },
  {
    zip: "70559",
    ST: "LA",
    cityWithStateAbbr: "Morse, LA",
  },
  {
    zip: "70560",
    ST: "LA",
    cityWithStateAbbr: "New Iberia, LA",
  },
  {
    zip: "70562",
    ST: "LA",
    cityWithStateAbbr: "New Iberia, LA",
  },
  {
    zip: "70563",
    ST: "LA",
    cityWithStateAbbr: "New Iberia, LA",
  },
  {
    zip: "70569",
    ST: "LA",
    cityWithStateAbbr: "Lydia, LA",
  },
  {
    zip: "70570",
    ST: "LA",
    cityWithStateAbbr: "Opelousas, LA",
  },
  {
    zip: "70571",
    ST: "LA",
    cityWithStateAbbr: "Opelousas, LA",
  },
  {
    zip: "70575",
    ST: "LA",
    cityWithStateAbbr: "Perry, LA",
  },
  {
    zip: "70576",
    ST: "LA",
    cityWithStateAbbr: "Pine Prairie, LA",
  },
  {
    zip: "70577",
    ST: "LA",
    cityWithStateAbbr: "Port Barre, LA",
  },
  {
    zip: "70578",
    ST: "LA",
    cityWithStateAbbr: "Rayne, LA",
  },
  {
    zip: "70580",
    ST: "LA",
    cityWithStateAbbr: "Reddell, LA",
  },
  {
    zip: "70581",
    ST: "LA",
    cityWithStateAbbr: "Roanoke, LA",
  },
  {
    zip: "70582",
    ST: "LA",
    cityWithStateAbbr: "Saint Martinville, LA",
  },
  {
    zip: "70583",
    ST: "LA",
    cityWithStateAbbr: "Scott, LA",
  },
  {
    zip: "70584",
    ST: "LA",
    cityWithStateAbbr: "Sunset, LA",
  },
  {
    zip: "70585",
    ST: "LA",
    cityWithStateAbbr: "Turkey Creek, LA",
  },
  {
    zip: "70586",
    ST: "LA",
    cityWithStateAbbr: "Ville Platte, LA",
  },
  {
    zip: "70589",
    ST: "LA",
    cityWithStateAbbr: "Washington, LA",
  },
  {
    zip: "70591",
    ST: "LA",
    cityWithStateAbbr: "Welsh, LA",
  },
  {
    zip: "70592",
    ST: "LA",
    cityWithStateAbbr: "Youngsville, LA",
  },
  {
    zip: "70593",
    ST: "LA",
    cityWithStateAbbr: "Lafayette, LA",
  },
  {
    zip: "70596",
    ST: "LA",
    cityWithStateAbbr: "Lafayette, LA",
  },
  {
    zip: "70598",
    ST: "LA",
    cityWithStateAbbr: "Lafayette, LA",
  },
  {
    zip: "70601",
    ST: "LA",
    cityWithStateAbbr: "Lake Charles, LA",
  },
  {
    zip: "70602",
    ST: "LA",
    cityWithStateAbbr: "Lake Charles, LA",
  },
  {
    zip: "70605",
    ST: "LA",
    cityWithStateAbbr: "Lake Charles, LA",
  },
  {
    zip: "70606",
    ST: "LA",
    cityWithStateAbbr: "Lake Charles, LA",
  },
  {
    zip: "70607",
    ST: "LA",
    cityWithStateAbbr: "Lake Charles, LA",
  },
  {
    zip: "70609",
    ST: "LA",
    cityWithStateAbbr: "Lake Charles, LA",
  },
  {
    zip: "70611",
    ST: "LA",
    cityWithStateAbbr: "Lake Charles, LA",
  },
  {
    zip: "70612",
    ST: "LA",
    cityWithStateAbbr: "Lake Charles, LA",
  },
  {
    zip: "70615",
    ST: "LA",
    cityWithStateAbbr: "Lake Charles, LA",
  },
  {
    zip: "70616",
    ST: "LA",
    cityWithStateAbbr: "Lake Charles, LA",
  },
  {
    zip: "70629",
    ST: "LA",
    cityWithStateAbbr: "Lake Charles, LA",
  },
  {
    zip: "70630",
    ST: "LA",
    cityWithStateAbbr: "Bell City, LA",
  },
  {
    zip: "70631",
    ST: "LA",
    cityWithStateAbbr: "Cameron, LA",
  },
  {
    zip: "70632",
    ST: "LA",
    cityWithStateAbbr: "Creole, LA",
  },
  {
    zip: "70633",
    ST: "LA",
    cityWithStateAbbr: "Dequincy, LA",
  },
  {
    zip: "70634",
    ST: "LA",
    cityWithStateAbbr: "Deridder, LA",
  },
  {
    zip: "70637",
    ST: "LA",
    cityWithStateAbbr: "Dry Creek, LA",
  },
  {
    zip: "70638",
    ST: "LA",
    cityWithStateAbbr: "Elizabeth, LA",
  },
  {
    zip: "70639",
    ST: "LA",
    cityWithStateAbbr: "Evans, LA",
  },
  {
    zip: "70640",
    ST: "LA",
    cityWithStateAbbr: "Fenton, LA",
  },
  {
    zip: "70643",
    ST: "LA",
    cityWithStateAbbr: "Grand Chenier, LA",
  },
  {
    zip: "70644",
    ST: "LA",
    cityWithStateAbbr: "Grant, LA",
  },
  {
    zip: "70645",
    ST: "LA",
    cityWithStateAbbr: "Hackberry, LA",
  },
  {
    zip: "70646",
    ST: "LA",
    cityWithStateAbbr: "Hayes, LA",
  },
  {
    zip: "70647",
    ST: "LA",
    cityWithStateAbbr: "Iowa, LA",
  },
  {
    zip: "70648",
    ST: "LA",
    cityWithStateAbbr: "Kinder, LA",
  },
  {
    zip: "70650",
    ST: "LA",
    cityWithStateAbbr: "Lacassine, LA",
  },
  {
    zip: "70651",
    ST: "LA",
    cityWithStateAbbr: "Leblanc, LA",
  },
  {
    zip: "70652",
    ST: "LA",
    cityWithStateAbbr: "Longville, LA",
  },
  {
    zip: "70653",
    ST: "LA",
    cityWithStateAbbr: "Merryville, LA",
  },
  {
    zip: "70654",
    ST: "LA",
    cityWithStateAbbr: "Mittie, LA",
  },
  {
    zip: "70655",
    ST: "LA",
    cityWithStateAbbr: "Oberlin, LA",
  },
  {
    zip: "70656",
    ST: "LA",
    cityWithStateAbbr: "Pitkin, LA",
  },
  {
    zip: "70657",
    ST: "LA",
    cityWithStateAbbr: "Ragley, LA",
  },
  {
    zip: "70658",
    ST: "LA",
    cityWithStateAbbr: "Reeves, LA",
  },
  {
    zip: "70659",
    ST: "LA",
    cityWithStateAbbr: "Rosepine, LA",
  },
  {
    zip: "70660",
    ST: "LA",
    cityWithStateAbbr: "Singer, LA",
  },
  {
    zip: "70661",
    ST: "LA",
    cityWithStateAbbr: "Starks, LA",
  },
  {
    zip: "70662",
    ST: "LA",
    cityWithStateAbbr: "Sugartown, LA",
  },
  {
    zip: "70663",
    ST: "LA",
    cityWithStateAbbr: "Sulphur, LA",
  },
  {
    zip: "70664",
    ST: "LA",
    cityWithStateAbbr: "Sulphur, LA",
  },
  {
    zip: "70665",
    ST: "LA",
    cityWithStateAbbr: "Sulphur, LA",
  },
  {
    zip: "70668",
    ST: "LA",
    cityWithStateAbbr: "Vinton, LA",
  },
  {
    zip: "70669",
    ST: "LA",
    cityWithStateAbbr: "Westlake, LA",
  },
  {
    zip: "70704",
    ST: "LA",
    cityWithStateAbbr: "Baker, LA",
  },
  {
    zip: "70706",
    ST: "LA",
    cityWithStateAbbr: "Denham Springs, LA",
  },
  {
    zip: "70707",
    ST: "LA",
    cityWithStateAbbr: "Gonzales, LA",
  },
  {
    zip: "70710",
    ST: "LA",
    cityWithStateAbbr: "Addis, LA",
  },
  {
    zip: "70711",
    ST: "LA",
    cityWithStateAbbr: "Albany, LA",
  },
  {
    zip: "70712",
    ST: "LA",
    cityWithStateAbbr: "Angola, LA",
  },
  {
    zip: "70714",
    ST: "LA",
    cityWithStateAbbr: "Baker, LA",
  },
  {
    zip: "70715",
    ST: "LA",
    cityWithStateAbbr: "Batchelor, LA",
  },
  {
    zip: "70718",
    ST: "LA",
    cityWithStateAbbr: "Brittany, LA",
  },
  {
    zip: "70719",
    ST: "LA",
    cityWithStateAbbr: "Brusly, LA",
  },
  {
    zip: "70721",
    ST: "LA",
    cityWithStateAbbr: "Carville, LA",
  },
  {
    zip: "70722",
    ST: "LA",
    cityWithStateAbbr: "Clinton, LA",
  },
  {
    zip: "70723",
    ST: "LA",
    cityWithStateAbbr: "Convent, LA",
  },
  {
    zip: "70725",
    ST: "LA",
    cityWithStateAbbr: "Darrow, LA",
  },
  {
    zip: "70726",
    ST: "LA",
    cityWithStateAbbr: "Denham Springs, LA",
  },
  {
    zip: "70727",
    ST: "LA",
    cityWithStateAbbr: "Denham Springs, LA",
  },
  {
    zip: "70728",
    ST: "LA",
    cityWithStateAbbr: "Duplessis, LA",
  },
  {
    zip: "70729",
    ST: "LA",
    cityWithStateAbbr: "Erwinville, LA",
  },
  {
    zip: "70730",
    ST: "LA",
    cityWithStateAbbr: "Ethel, LA",
  },
  {
    zip: "70732",
    ST: "LA",
    cityWithStateAbbr: "Fordoche, LA",
  },
  {
    zip: "70733",
    ST: "LA",
    cityWithStateAbbr: "French Settlement, LA",
  },
  {
    zip: "70734",
    ST: "LA",
    cityWithStateAbbr: "Geismar, LA",
  },
  {
    zip: "70736",
    ST: "LA",
    cityWithStateAbbr: "Glynn, LA",
  },
  {
    zip: "70737",
    ST: "LA",
    cityWithStateAbbr: "Gonzales, LA",
  },
  {
    zip: "70738",
    ST: "LA",
    cityWithStateAbbr: "Burnside, LA",
  },
  {
    zip: "70739",
    ST: "LA",
    cityWithStateAbbr: "Greenwell Springs, LA",
  },
  {
    zip: "70740",
    ST: "LA",
    cityWithStateAbbr: "Grosse Tete, LA",
  },
  {
    zip: "70743",
    ST: "LA",
    cityWithStateAbbr: "Hester, LA",
  },
  {
    zip: "70744",
    ST: "LA",
    cityWithStateAbbr: "Holden, LA",
  },
  {
    zip: "70747",
    ST: "LA",
    cityWithStateAbbr: "Innis, LA",
  },
  {
    zip: "70748",
    ST: "LA",
    cityWithStateAbbr: "Jackson, LA",
  },
  {
    zip: "70749",
    ST: "LA",
    cityWithStateAbbr: "Jarreau, LA",
  },
  {
    zip: "70750",
    ST: "LA",
    cityWithStateAbbr: "Krotz Springs, LA",
  },
  {
    zip: "70752",
    ST: "LA",
    cityWithStateAbbr: "Lakeland, LA",
  },
  {
    zip: "70753",
    ST: "LA",
    cityWithStateAbbr: "Lettsworth, LA",
  },
  {
    zip: "70754",
    ST: "LA",
    cityWithStateAbbr: "Livingston, LA",
  },
  {
    zip: "70755",
    ST: "LA",
    cityWithStateAbbr: "Livonia, LA",
  },
  {
    zip: "70756",
    ST: "LA",
    cityWithStateAbbr: "Lottie, LA",
  },
  {
    zip: "70757",
    ST: "LA",
    cityWithStateAbbr: "Maringouin, LA",
  },
  {
    zip: "70759",
    ST: "LA",
    cityWithStateAbbr: "Morganza, LA",
  },
  {
    zip: "70760",
    ST: "LA",
    cityWithStateAbbr: "New Roads, LA",
  },
  {
    zip: "70761",
    ST: "LA",
    cityWithStateAbbr: "Norwood, LA",
  },
  {
    zip: "70762",
    ST: "LA",
    cityWithStateAbbr: "Oscar, LA",
  },
  {
    zip: "70763",
    ST: "LA",
    cityWithStateAbbr: "Paulina, LA",
  },
  {
    zip: "70764",
    ST: "LA",
    cityWithStateAbbr: "Plaquemine, LA",
  },
  {
    zip: "70765",
    ST: "LA",
    cityWithStateAbbr: "Plaquemine, LA",
  },
  {
    zip: "70767",
    ST: "LA",
    cityWithStateAbbr: "Port Allen, LA",
  },
  {
    zip: "70769",
    ST: "LA",
    cityWithStateAbbr: "Prairieville, LA",
  },
  {
    zip: "70770",
    ST: "LA",
    cityWithStateAbbr: "Pride, LA",
  },
  {
    zip: "70772",
    ST: "LA",
    cityWithStateAbbr: "Rosedale, LA",
  },
  {
    zip: "70773",
    ST: "LA",
    cityWithStateAbbr: "Rougon, LA",
  },
  {
    zip: "70774",
    ST: "LA",
    cityWithStateAbbr: "Saint Amant, LA",
  },
  {
    zip: "70775",
    ST: "LA",
    cityWithStateAbbr: "Saint Francisville, LA",
  },
  {
    zip: "70776",
    ST: "LA",
    cityWithStateAbbr: "Saint Gabriel, LA",
  },
  {
    zip: "70777",
    ST: "LA",
    cityWithStateAbbr: "Slaughter, LA",
  },
  {
    zip: "70778",
    ST: "LA",
    cityWithStateAbbr: "Sorrento, LA",
  },
  {
    zip: "70780",
    ST: "LA",
    cityWithStateAbbr: "Sunshine, LA",
  },
  {
    zip: "70782",
    ST: "LA",
    cityWithStateAbbr: "Tunica, LA",
  },
  {
    zip: "70783",
    ST: "LA",
    cityWithStateAbbr: "Ventress, LA",
  },
  {
    zip: "70784",
    ST: "LA",
    cityWithStateAbbr: "Wakefield, LA",
  },
  {
    zip: "70785",
    ST: "LA",
    cityWithStateAbbr: "Walker, LA",
  },
  {
    zip: "70786",
    ST: "LA",
    cityWithStateAbbr: "Watson, LA",
  },
  {
    zip: "70787",
    ST: "LA",
    cityWithStateAbbr: "Weyanoke, LA",
  },
  {
    zip: "70788",
    ST: "LA",
    cityWithStateAbbr: "White Castle, LA",
  },
  {
    zip: "70789",
    ST: "LA",
    cityWithStateAbbr: "Wilson, LA",
  },
  {
    zip: "70791",
    ST: "LA",
    cityWithStateAbbr: "Zachary, LA",
  },
  {
    zip: "70792",
    ST: "LA",
    cityWithStateAbbr: "Uncle Sam, LA",
  },
  {
    zip: "70801",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70802",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70803",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70804",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70805",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70806",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70807",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70808",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70809",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70810",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70811",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70812",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70813",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70814",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70815",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70816",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70817",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70818",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70819",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70820",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70821",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70822",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70823",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70825",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70826",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70827",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70831",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70833",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70835",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70836",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70837",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70873",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70874",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70879",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70884",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70891",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70892",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70893",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70894",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70895",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70896",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "70898",
    ST: "LA",
    cityWithStateAbbr: "Baton Rouge, LA",
  },
  {
    zip: "71001",
    ST: "LA",
    cityWithStateAbbr: "Arcadia, LA",
  },
  {
    zip: "71002",
    ST: "LA",
    cityWithStateAbbr: "Ashland, LA",
  },
  {
    zip: "71003",
    ST: "LA",
    cityWithStateAbbr: "Athens, LA",
  },
  {
    zip: "71004",
    ST: "LA",
    cityWithStateAbbr: "Belcher, LA",
  },
  {
    zip: "71006",
    ST: "LA",
    cityWithStateAbbr: "Benton, LA",
  },
  {
    zip: "71007",
    ST: "LA",
    cityWithStateAbbr: "Bethany, LA",
  },
  {
    zip: "71008",
    ST: "LA",
    cityWithStateAbbr: "Bienville, LA",
  },
  {
    zip: "71009",
    ST: "LA",
    cityWithStateAbbr: "Blanchard, LA",
  },
  {
    zip: "71016",
    ST: "LA",
    cityWithStateAbbr: "Castor, LA",
  },
  {
    zip: "71018",
    ST: "LA",
    cityWithStateAbbr: "Cotton Valley, LA",
  },
  {
    zip: "71019",
    ST: "LA",
    cityWithStateAbbr: "Coushatta, LA",
  },
  {
    zip: "71021",
    ST: "LA",
    cityWithStateAbbr: "Cullen, LA",
  },
  {
    zip: "71023",
    ST: "LA",
    cityWithStateAbbr: "Doyline, LA",
  },
  {
    zip: "71024",
    ST: "LA",
    cityWithStateAbbr: "Dubberly, LA",
  },
  {
    zip: "71027",
    ST: "LA",
    cityWithStateAbbr: "Frierson, LA",
  },
  {
    zip: "71028",
    ST: "LA",
    cityWithStateAbbr: "Gibsland, LA",
  },
  {
    zip: "71029",
    ST: "LA",
    cityWithStateAbbr: "Gilliam, LA",
  },
  {
    zip: "71030",
    ST: "LA",
    cityWithStateAbbr: "Gloster, LA",
  },
  {
    zip: "71031",
    ST: "LA",
    cityWithStateAbbr: "Goldonna, LA",
  },
  {
    zip: "71032",
    ST: "LA",
    cityWithStateAbbr: "Grand Cane, LA",
  },
  {
    zip: "71033",
    ST: "LA",
    cityWithStateAbbr: "Greenwood, LA",
  },
  {
    zip: "71034",
    ST: "LA",
    cityWithStateAbbr: "Hall Summit, LA",
  },
  {
    zip: "71037",
    ST: "LA",
    cityWithStateAbbr: "Haughton, LA",
  },
  {
    zip: "71038",
    ST: "LA",
    cityWithStateAbbr: "Haynesville, LA",
  },
  {
    zip: "71039",
    ST: "LA",
    cityWithStateAbbr: "Heflin, LA",
  },
  {
    zip: "71040",
    ST: "LA",
    cityWithStateAbbr: "Homer, LA",
  },
  {
    zip: "71043",
    ST: "LA",
    cityWithStateAbbr: "Hosston, LA",
  },
  {
    zip: "71044",
    ST: "LA",
    cityWithStateAbbr: "Ida, LA",
  },
  {
    zip: "71045",
    ST: "LA",
    cityWithStateAbbr: "Jamestown, LA",
  },
  {
    zip: "71046",
    ST: "LA",
    cityWithStateAbbr: "Keatchie, LA",
  },
  {
    zip: "71047",
    ST: "LA",
    cityWithStateAbbr: "Keithville, LA",
  },
  {
    zip: "71048",
    ST: "LA",
    cityWithStateAbbr: "Lisbon, LA",
  },
  {
    zip: "71049",
    ST: "LA",
    cityWithStateAbbr: "Logansport, LA",
  },
  {
    zip: "71050",
    ST: "LA",
    cityWithStateAbbr: "Longstreet, LA",
  },
  {
    zip: "71051",
    ST: "LA",
    cityWithStateAbbr: "Elm Grove, LA",
  },
  {
    zip: "71052",
    ST: "LA",
    cityWithStateAbbr: "Mansfield, LA",
  },
  {
    zip: "71055",
    ST: "LA",
    cityWithStateAbbr: "Minden, LA",
  },
  {
    zip: "71058",
    ST: "LA",
    cityWithStateAbbr: "Minden, LA",
  },
  {
    zip: "71060",
    ST: "LA",
    cityWithStateAbbr: "Mooringsport, LA",
  },
  {
    zip: "71061",
    ST: "LA",
    cityWithStateAbbr: "Oil City, LA",
  },
  {
    zip: "71063",
    ST: "LA",
    cityWithStateAbbr: "Pelican, LA",
  },
  {
    zip: "71064",
    ST: "LA",
    cityWithStateAbbr: "Plain Dealing, LA",
  },
  {
    zip: "71065",
    ST: "LA",
    cityWithStateAbbr: "Pleasant Hill, LA",
  },
  {
    zip: "71066",
    ST: "LA",
    cityWithStateAbbr: "Powhatan, LA",
  },
  {
    zip: "71067",
    ST: "LA",
    cityWithStateAbbr: "Princeton, LA",
  },
  {
    zip: "71068",
    ST: "LA",
    cityWithStateAbbr: "Ringgold, LA",
  },
  {
    zip: "71069",
    ST: "LA",
    cityWithStateAbbr: "Rodessa, LA",
  },
  {
    zip: "71070",
    ST: "LA",
    cityWithStateAbbr: "Saline, LA",
  },
  {
    zip: "71071",
    ST: "LA",
    cityWithStateAbbr: "Sarepta, LA",
  },
  {
    zip: "71072",
    ST: "LA",
    cityWithStateAbbr: "Shongaloo, LA",
  },
  {
    zip: "71073",
    ST: "LA",
    cityWithStateAbbr: "Sibley, LA",
  },
  {
    zip: "71075",
    ST: "LA",
    cityWithStateAbbr: "Springhill, LA",
  },
  {
    zip: "71078",
    ST: "LA",
    cityWithStateAbbr: "Stonewall, LA",
  },
  {
    zip: "71079",
    ST: "LA",
    cityWithStateAbbr: "Summerfield, LA",
  },
  {
    zip: "71080",
    ST: "LA",
    cityWithStateAbbr: "Taylor, LA",
  },
  {
    zip: "71082",
    ST: "LA",
    cityWithStateAbbr: "Vivian, LA",
  },
  {
    zip: "71101",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71102",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71103",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71104",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71105",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71106",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71107",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71108",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71109",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71110",
    ST: "LA",
    cityWithStateAbbr: "Barksdale Afb, LA",
  },
  {
    zip: "71111",
    ST: "LA",
    cityWithStateAbbr: "Bossier City, LA",
  },
  {
    zip: "71112",
    ST: "LA",
    cityWithStateAbbr: "Bossier City, LA",
  },
  {
    zip: "71113",
    ST: "LA",
    cityWithStateAbbr: "Bossier City, LA",
  },
  {
    zip: "71115",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71118",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71119",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71120",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71129",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71130",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71133",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71134",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71135",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71136",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71137",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71138",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71148",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71149",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71150",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71151",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71152",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71153",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71154",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71156",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71161",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71162",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71163",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71164",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71165",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71166",
    ST: "LA",
    cityWithStateAbbr: "Shreveport, LA",
  },
  {
    zip: "71171",
    ST: "LA",
    cityWithStateAbbr: "Bossier City, LA",
  },
  {
    zip: "71172",
    ST: "LA",
    cityWithStateAbbr: "Bossier City, LA",
  },
  {
    zip: "71201",
    ST: "LA",
    cityWithStateAbbr: "Monroe, LA",
  },
  {
    zip: "71202",
    ST: "LA",
    cityWithStateAbbr: "Monroe, LA",
  },
  {
    zip: "71203",
    ST: "LA",
    cityWithStateAbbr: "Monroe, LA",
  },
  {
    zip: "71207",
    ST: "LA",
    cityWithStateAbbr: "Monroe, LA",
  },
  {
    zip: "71209",
    ST: "LA",
    cityWithStateAbbr: "Monroe, LA",
  },
  {
    zip: "71210",
    ST: "LA",
    cityWithStateAbbr: "Monroe, LA",
  },
  {
    zip: "71211",
    ST: "LA",
    cityWithStateAbbr: "Monroe, LA",
  },
  {
    zip: "71212",
    ST: "LA",
    cityWithStateAbbr: "Monroe, LA",
  },
  {
    zip: "71213",
    ST: "LA",
    cityWithStateAbbr: "Monroe, LA",
  },
  {
    zip: "71217",
    ST: "LA",
    cityWithStateAbbr: "Monroe, LA",
  },
  {
    zip: "71218",
    ST: "LA",
    cityWithStateAbbr: "Archibald, LA",
  },
  {
    zip: "71219",
    ST: "LA",
    cityWithStateAbbr: "Baskin, LA",
  },
  {
    zip: "71220",
    ST: "LA",
    cityWithStateAbbr: "Bastrop, LA",
  },
  {
    zip: "71221",
    ST: "LA",
    cityWithStateAbbr: "Bastrop, LA",
  },
  {
    zip: "71222",
    ST: "LA",
    cityWithStateAbbr: "Bernice, LA",
  },
  {
    zip: "71223",
    ST: "LA",
    cityWithStateAbbr: "Bonita, LA",
  },
  {
    zip: "71225",
    ST: "LA",
    cityWithStateAbbr: "Calhoun, LA",
  },
  {
    zip: "71226",
    ST: "LA",
    cityWithStateAbbr: "Chatham, LA",
  },
  {
    zip: "71227",
    ST: "LA",
    cityWithStateAbbr: "Choudrant, LA",
  },
  {
    zip: "71229",
    ST: "LA",
    cityWithStateAbbr: "Collinston, LA",
  },
  {
    zip: "71230",
    ST: "LA",
    cityWithStateAbbr: "Crowville, LA",
  },
  {
    zip: "71232",
    ST: "LA",
    cityWithStateAbbr: "Delhi, LA",
  },
  {
    zip: "71233",
    ST: "LA",
    cityWithStateAbbr: "Delta, LA",
  },
  {
    zip: "71234",
    ST: "LA",
    cityWithStateAbbr: "Downsville, LA",
  },
  {
    zip: "71235",
    ST: "LA",
    cityWithStateAbbr: "Dubach, LA",
  },
  {
    zip: "71237",
    ST: "LA",
    cityWithStateAbbr: "Epps, LA",
  },
  {
    zip: "71238",
    ST: "LA",
    cityWithStateAbbr: "Eros, LA",
  },
  {
    zip: "71240",
    ST: "LA",
    cityWithStateAbbr: "Fairbanks, LA",
  },
  {
    zip: "71241",
    ST: "LA",
    cityWithStateAbbr: "Farmerville, LA",
  },
  {
    zip: "71242",
    ST: "LA",
    cityWithStateAbbr: "Forest, LA",
  },
  {
    zip: "71243",
    ST: "LA",
    cityWithStateAbbr: "Fort Necessity, LA",
  },
  {
    zip: "71245",
    ST: "LA",
    cityWithStateAbbr: "Grambling, LA",
  },
  {
    zip: "71247",
    ST: "LA",
    cityWithStateAbbr: "Hodge, LA",
  },
  {
    zip: "71249",
    ST: "LA",
    cityWithStateAbbr: "Jigger, LA",
  },
  {
    zip: "71250",
    ST: "LA",
    cityWithStateAbbr: "Jones, LA",
  },
  {
    zip: "71251",
    ST: "LA",
    cityWithStateAbbr: "Jonesboro, LA",
  },
  {
    zip: "71253",
    ST: "LA",
    cityWithStateAbbr: "Kilbourne, LA",
  },
  {
    zip: "71254",
    ST: "LA",
    cityWithStateAbbr: "Lake Providence, LA",
  },
  {
    zip: "71256",
    ST: "LA",
    cityWithStateAbbr: "Lillie, LA",
  },
  {
    zip: "71259",
    ST: "LA",
    cityWithStateAbbr: "Mangham, LA",
  },
  {
    zip: "71260",
    ST: "LA",
    cityWithStateAbbr: "Marion, LA",
  },
  {
    zip: "71261",
    ST: "LA",
    cityWithStateAbbr: "Mer Rouge, LA",
  },
  {
    zip: "71263",
    ST: "LA",
    cityWithStateAbbr: "Oak Grove, LA",
  },
  {
    zip: "71264",
    ST: "LA",
    cityWithStateAbbr: "Oak Ridge, LA",
  },
  {
    zip: "71266",
    ST: "LA",
    cityWithStateAbbr: "Pioneer, LA",
  },
  {
    zip: "71268",
    ST: "LA",
    cityWithStateAbbr: "Quitman, LA",
  },
  {
    zip: "71269",
    ST: "LA",
    cityWithStateAbbr: "Rayville, LA",
  },
  {
    zip: "71270",
    ST: "LA",
    cityWithStateAbbr: "Ruston, LA",
  },
  {
    zip: "71272",
    ST: "LA",
    cityWithStateAbbr: "Ruston, LA",
  },
  {
    zip: "71273",
    ST: "LA",
    cityWithStateAbbr: "Ruston, LA",
  },
  {
    zip: "71275",
    ST: "LA",
    cityWithStateAbbr: "Simsboro, LA",
  },
  {
    zip: "71276",
    ST: "LA",
    cityWithStateAbbr: "Sondheimer, LA",
  },
  {
    zip: "71277",
    ST: "LA",
    cityWithStateAbbr: "Spearsville, LA",
  },
  {
    zip: "71279",
    ST: "LA",
    cityWithStateAbbr: "Start, LA",
  },
  {
    zip: "71280",
    ST: "LA",
    cityWithStateAbbr: "Sterlington, LA",
  },
  {
    zip: "71281",
    ST: "LA",
    cityWithStateAbbr: "Swartz, LA",
  },
  {
    zip: "71282",
    ST: "LA",
    cityWithStateAbbr: "Tallulah, LA",
  },
  {
    zip: "71284",
    ST: "LA",
    cityWithStateAbbr: "Tallulah, LA",
  },
  {
    zip: "71286",
    ST: "LA",
    cityWithStateAbbr: "Transylvania, LA",
  },
  {
    zip: "71291",
    ST: "LA",
    cityWithStateAbbr: "West Monroe, LA",
  },
  {
    zip: "71292",
    ST: "LA",
    cityWithStateAbbr: "West Monroe, LA",
  },
  {
    zip: "71294",
    ST: "LA",
    cityWithStateAbbr: "West Monroe, LA",
  },
  {
    zip: "71295",
    ST: "LA",
    cityWithStateAbbr: "Winnsboro, LA",
  },
  {
    zip: "71301",
    ST: "LA",
    cityWithStateAbbr: "Alexandria, LA",
  },
  {
    zip: "71302",
    ST: "LA",
    cityWithStateAbbr: "Alexandria, LA",
  },
  {
    zip: "71303",
    ST: "LA",
    cityWithStateAbbr: "Alexandria, LA",
  },
  {
    zip: "71306",
    ST: "LA",
    cityWithStateAbbr: "Alexandria, LA",
  },
  {
    zip: "71307",
    ST: "LA",
    cityWithStateAbbr: "Alexandria, LA",
  },
  {
    zip: "71309",
    ST: "LA",
    cityWithStateAbbr: "Alexandria, LA",
  },
  {
    zip: "71315",
    ST: "LA",
    cityWithStateAbbr: "Alexandria, LA",
  },
  {
    zip: "71316",
    ST: "LA",
    cityWithStateAbbr: "Acme, LA",
  },
  {
    zip: "71320",
    ST: "LA",
    cityWithStateAbbr: "Bordelonville, LA",
  },
  {
    zip: "71322",
    ST: "LA",
    cityWithStateAbbr: "Bunkie, LA",
  },
  {
    zip: "71323",
    ST: "LA",
    cityWithStateAbbr: "Center Point, LA",
  },
  {
    zip: "71324",
    ST: "LA",
    cityWithStateAbbr: "Chase, LA",
  },
  {
    zip: "71325",
    ST: "LA",
    cityWithStateAbbr: "Cheneyville, LA",
  },
  {
    zip: "71326",
    ST: "LA",
    cityWithStateAbbr: "Clayton, LA",
  },
  {
    zip: "71327",
    ST: "LA",
    cityWithStateAbbr: "Cottonport, LA",
  },
  {
    zip: "71328",
    ST: "LA",
    cityWithStateAbbr: "Deville, LA",
  },
  {
    zip: "71329",
    ST: "LA",
    cityWithStateAbbr: "Dupont, LA",
  },
  {
    zip: "71330",
    ST: "LA",
    cityWithStateAbbr: "Echo, LA",
  },
  {
    zip: "71331",
    ST: "LA",
    cityWithStateAbbr: "Effie, LA",
  },
  {
    zip: "71333",
    ST: "LA",
    cityWithStateAbbr: "Evergreen, LA",
  },
  {
    zip: "71334",
    ST: "LA",
    cityWithStateAbbr: "Ferriday, LA",
  },
  {
    zip: "71336",
    ST: "LA",
    cityWithStateAbbr: "Gilbert, LA",
  },
  {
    zip: "71339",
    ST: "LA",
    cityWithStateAbbr: "Hamburg, LA",
  },
  {
    zip: "71340",
    ST: "LA",
    cityWithStateAbbr: "Harrisonburg, LA",
  },
  {
    zip: "71341",
    ST: "LA",
    cityWithStateAbbr: "Hessmer, LA",
  },
  {
    zip: "71342",
    ST: "LA",
    cityWithStateAbbr: "Jena, LA",
  },
  {
    zip: "71343",
    ST: "LA",
    cityWithStateAbbr: "Jonesville, LA",
  },
  {
    zip: "71345",
    ST: "LA",
    cityWithStateAbbr: "Lebeau, LA",
  },
  {
    zip: "71346",
    ST: "LA",
    cityWithStateAbbr: "Lecompte, LA",
  },
  {
    zip: "71348",
    ST: "LA",
    cityWithStateAbbr: "Libuse, LA",
  },
  {
    zip: "71350",
    ST: "LA",
    cityWithStateAbbr: "Mansura, LA",
  },
  {
    zip: "71351",
    ST: "LA",
    cityWithStateAbbr: "Marksville, LA",
  },
  {
    zip: "71353",
    ST: "LA",
    cityWithStateAbbr: "Melville, LA",
  },
  {
    zip: "71354",
    ST: "LA",
    cityWithStateAbbr: "Monterey, LA",
  },
  {
    zip: "71355",
    ST: "LA",
    cityWithStateAbbr: "Moreauville, LA",
  },
  {
    zip: "71356",
    ST: "LA",
    cityWithStateAbbr: "Morrow, LA",
  },
  {
    zip: "71357",
    ST: "LA",
    cityWithStateAbbr: "Newellton, LA",
  },
  {
    zip: "71358",
    ST: "LA",
    cityWithStateAbbr: "Palmetto, LA",
  },
  {
    zip: "71359",
    ST: "LA",
    cityWithStateAbbr: "Pineville, LA",
  },
  {
    zip: "71360",
    ST: "LA",
    cityWithStateAbbr: "Pineville, LA",
  },
  {
    zip: "71361",
    ST: "LA",
    cityWithStateAbbr: "Pineville, LA",
  },
  {
    zip: "71362",
    ST: "LA",
    cityWithStateAbbr: "Plaucheville, LA",
  },
  {
    zip: "71363",
    ST: "LA",
    cityWithStateAbbr: "Rhinehart, LA",
  },
  {
    zip: "71365",
    ST: "LA",
    cityWithStateAbbr: "Ruby, LA",
  },
  {
    zip: "71366",
    ST: "LA",
    cityWithStateAbbr: "Saint Joseph, LA",
  },
  {
    zip: "71367",
    ST: "LA",
    cityWithStateAbbr: "Saint Landry, LA",
  },
  {
    zip: "71368",
    ST: "LA",
    cityWithStateAbbr: "Sicily Island, LA",
  },
  {
    zip: "71369",
    ST: "LA",
    cityWithStateAbbr: "Simmesport, LA",
  },
  {
    zip: "71371",
    ST: "LA",
    cityWithStateAbbr: "Trout, LA",
  },
  {
    zip: "71373",
    ST: "LA",
    cityWithStateAbbr: "Vidalia, LA",
  },
  {
    zip: "71375",
    ST: "LA",
    cityWithStateAbbr: "Waterproof, LA",
  },
  {
    zip: "71377",
    ST: "LA",
    cityWithStateAbbr: "Wildsville, LA",
  },
  {
    zip: "71378",
    ST: "LA",
    cityWithStateAbbr: "Wisner, LA",
  },
  {
    zip: "71401",
    ST: "LA",
    cityWithStateAbbr: "Aimwell, LA",
  },
  {
    zip: "71403",
    ST: "LA",
    cityWithStateAbbr: "Anacoco, LA",
  },
  {
    zip: "71404",
    ST: "LA",
    cityWithStateAbbr: "Atlanta, LA",
  },
  {
    zip: "71405",
    ST: "LA",
    cityWithStateAbbr: "Ball, LA",
  },
  {
    zip: "71406",
    ST: "LA",
    cityWithStateAbbr: "Belmont, LA",
  },
  {
    zip: "71407",
    ST: "LA",
    cityWithStateAbbr: "Bentley, LA",
  },
  {
    zip: "71409",
    ST: "LA",
    cityWithStateAbbr: "Boyce, LA",
  },
  {
    zip: "71410",
    ST: "LA",
    cityWithStateAbbr: "Calvin, LA",
  },
  {
    zip: "71411",
    ST: "LA",
    cityWithStateAbbr: "Campti, LA",
  },
  {
    zip: "71414",
    ST: "LA",
    cityWithStateAbbr: "Clarence, LA",
  },
  {
    zip: "71415",
    ST: "LA",
    cityWithStateAbbr: "Clarks, LA",
  },
  {
    zip: "71416",
    ST: "LA",
    cityWithStateAbbr: "Cloutierville, LA",
  },
  {
    zip: "71417",
    ST: "LA",
    cityWithStateAbbr: "Colfax, LA",
  },
  {
    zip: "71418",
    ST: "LA",
    cityWithStateAbbr: "Columbia, LA",
  },
  {
    zip: "71419",
    ST: "LA",
    cityWithStateAbbr: "Converse, LA",
  },
  {
    zip: "71422",
    ST: "LA",
    cityWithStateAbbr: "Dodson, LA",
  },
  {
    zip: "71423",
    ST: "LA",
    cityWithStateAbbr: "Dry Prong, LA",
  },
  {
    zip: "71424",
    ST: "LA",
    cityWithStateAbbr: "Elmer, LA",
  },
  {
    zip: "71425",
    ST: "LA",
    cityWithStateAbbr: "Enterprise, LA",
  },
  {
    zip: "71426",
    ST: "LA",
    cityWithStateAbbr: "Fisher, LA",
  },
  {
    zip: "71427",
    ST: "LA",
    cityWithStateAbbr: "Flatwoods, LA",
  },
  {
    zip: "71428",
    ST: "LA",
    cityWithStateAbbr: "Flora, LA",
  },
  {
    zip: "71429",
    ST: "LA",
    cityWithStateAbbr: "Florien, LA",
  },
  {
    zip: "71430",
    ST: "LA",
    cityWithStateAbbr: "Forest Hill, LA",
  },
  {
    zip: "71431",
    ST: "LA",
    cityWithStateAbbr: "Gardner, LA",
  },
  {
    zip: "71432",
    ST: "LA",
    cityWithStateAbbr: "Georgetown, LA",
  },
  {
    zip: "71433",
    ST: "LA",
    cityWithStateAbbr: "Glenmora, LA",
  },
  {
    zip: "71434",
    ST: "LA",
    cityWithStateAbbr: "Gorum, LA",
  },
  {
    zip: "71435",
    ST: "LA",
    cityWithStateAbbr: "Grayson, LA",
  },
  {
    zip: "71438",
    ST: "LA",
    cityWithStateAbbr: "Hineston, LA",
  },
  {
    zip: "71439",
    ST: "LA",
    cityWithStateAbbr: "Hornbeck, LA",
  },
  {
    zip: "71440",
    ST: "LA",
    cityWithStateAbbr: "Joyce, LA",
  },
  {
    zip: "71441",
    ST: "LA",
    cityWithStateAbbr: "Kelly, LA",
  },
  {
    zip: "71443",
    ST: "LA",
    cityWithStateAbbr: "Kurthwood, LA",
  },
  {
    zip: "71446",
    ST: "LA",
    cityWithStateAbbr: "Leesville, LA",
  },
  {
    zip: "71447",
    ST: "LA",
    cityWithStateAbbr: "Lena, LA",
  },
  {
    zip: "71448",
    ST: "LA",
    cityWithStateAbbr: "Longleaf, LA",
  },
  {
    zip: "71449",
    ST: "LA",
    cityWithStateAbbr: "Many, LA",
  },
  {
    zip: "71450",
    ST: "LA",
    cityWithStateAbbr: "Marthaville, LA",
  },
  {
    zip: "71452",
    ST: "LA",
    cityWithStateAbbr: "Melrose, LA",
  },
  {
    zip: "71454",
    ST: "LA",
    cityWithStateAbbr: "Montgomery, LA",
  },
  {
    zip: "71455",
    ST: "LA",
    cityWithStateAbbr: "Mora, LA",
  },
  {
    zip: "71456",
    ST: "LA",
    cityWithStateAbbr: "Natchez, LA",
  },
  {
    zip: "71457",
    ST: "LA",
    cityWithStateAbbr: "Natchitoches, LA",
  },
  {
    zip: "71458",
    ST: "LA",
    cityWithStateAbbr: "Natchitoches, LA",
  },
  {
    zip: "71459",
    ST: "LA",
    cityWithStateAbbr: "Fort Polk, LA",
  },
  {
    zip: "71460",
    ST: "LA",
    cityWithStateAbbr: "Negreet, LA",
  },
  {
    zip: "71461",
    ST: "LA",
    cityWithStateAbbr: "New Llano, LA",
  },
  {
    zip: "71462",
    ST: "LA",
    cityWithStateAbbr: "Noble, LA",
  },
  {
    zip: "71463",
    ST: "LA",
    cityWithStateAbbr: "Oakdale, LA",
  },
  {
    zip: "71465",
    ST: "LA",
    cityWithStateAbbr: "Olla, LA",
  },
  {
    zip: "71466",
    ST: "LA",
    cityWithStateAbbr: "Otis, LA",
  },
  {
    zip: "71467",
    ST: "LA",
    cityWithStateAbbr: "Pollock, LA",
  },
  {
    zip: "71468",
    ST: "LA",
    cityWithStateAbbr: "Provencal, LA",
  },
  {
    zip: "71469",
    ST: "LA",
    cityWithStateAbbr: "Robeline, LA",
  },
  {
    zip: "71471",
    ST: "LA",
    cityWithStateAbbr: "Saint Maurice, LA",
  },
  {
    zip: "71472",
    ST: "LA",
    cityWithStateAbbr: "Sieper, LA",
  },
  {
    zip: "71473",
    ST: "LA",
    cityWithStateAbbr: "Sikes, LA",
  },
  {
    zip: "71474",
    ST: "LA",
    cityWithStateAbbr: "Simpson, LA",
  },
  {
    zip: "71475",
    ST: "LA",
    cityWithStateAbbr: "Slagle, LA",
  },
  {
    zip: "71477",
    ST: "LA",
    cityWithStateAbbr: "Tioga, LA",
  },
  {
    zip: "71479",
    ST: "LA",
    cityWithStateAbbr: "Tullos, LA",
  },
  {
    zip: "71480",
    ST: "LA",
    cityWithStateAbbr: "Urania, LA",
  },
  {
    zip: "71483",
    ST: "LA",
    cityWithStateAbbr: "Winnfield, LA",
  },
  {
    zip: "71485",
    ST: "LA",
    cityWithStateAbbr: "Woodworth, LA",
  },
  {
    zip: "71486",
    ST: "LA",
    cityWithStateAbbr: "Zwolle, LA",
  },
  {
    zip: "71496",
    ST: "LA",
    cityWithStateAbbr: "Leesville, LA",
  },
  {
    zip: "71497",
    ST: "LA",
    cityWithStateAbbr: "Natchitoches, LA",
  },
  {
    zip: "71601",
    ST: "AR",
    cityWithStateAbbr: "Pine Bluff, AR",
  },
  {
    zip: "71602",
    ST: "AR",
    cityWithStateAbbr: "White Hall, AR",
  },
  {
    zip: "71603",
    ST: "AR",
    cityWithStateAbbr: "Pine Bluff, AR",
  },
  {
    zip: "71611",
    ST: "AR",
    cityWithStateAbbr: "Pine Bluff, AR",
  },
  {
    zip: "71612",
    ST: "AR",
    cityWithStateAbbr: "White Hall, AR",
  },
  {
    zip: "71613",
    ST: "AR",
    cityWithStateAbbr: "Pine Bluff, AR",
  },
  {
    zip: "71630",
    ST: "AR",
    cityWithStateAbbr: "Arkansas City, AR",
  },
  {
    zip: "71631",
    ST: "AR",
    cityWithStateAbbr: "Banks, AR",
  },
  {
    zip: "71635",
    ST: "AR",
    cityWithStateAbbr: "Crossett, AR",
  },
  {
    zip: "71638",
    ST: "AR",
    cityWithStateAbbr: "Dermott, AR",
  },
  {
    zip: "71639",
    ST: "AR",
    cityWithStateAbbr: "Dumas, AR",
  },
  {
    zip: "71640",
    ST: "AR",
    cityWithStateAbbr: "Eudora, AR",
  },
  {
    zip: "71642",
    ST: "AR",
    cityWithStateAbbr: "Fountain Hill, AR",
  },
  {
    zip: "71643",
    ST: "AR",
    cityWithStateAbbr: "Gould, AR",
  },
  {
    zip: "71644",
    ST: "AR",
    cityWithStateAbbr: "Grady, AR",
  },
  {
    zip: "71646",
    ST: "AR",
    cityWithStateAbbr: "Hamburg, AR",
  },
  {
    zip: "71647",
    ST: "AR",
    cityWithStateAbbr: "Hermitage, AR",
  },
  {
    zip: "71651",
    ST: "AR",
    cityWithStateAbbr: "Jersey, AR",
  },
  {
    zip: "71652",
    ST: "AR",
    cityWithStateAbbr: "Kingsland, AR",
  },
  {
    zip: "71653",
    ST: "AR",
    cityWithStateAbbr: "Lake Village, AR",
  },
  {
    zip: "71654",
    ST: "AR",
    cityWithStateAbbr: "Mc Gehee, AR",
  },
  {
    zip: "71655",
    ST: "AR",
    cityWithStateAbbr: "Monticello, AR",
  },
  {
    zip: "71656",
    ST: "AR",
    cityWithStateAbbr: "Monticello, AR",
  },
  {
    zip: "71657",
    ST: "AR",
    cityWithStateAbbr: "Monticello, AR",
  },
  {
    zip: "71658",
    ST: "AR",
    cityWithStateAbbr: "Montrose, AR",
  },
  {
    zip: "71659",
    ST: "AR",
    cityWithStateAbbr: "Moscow, AR",
  },
  {
    zip: "71660",
    ST: "AR",
    cityWithStateAbbr: "New Edinburg, AR",
  },
  {
    zip: "71661",
    ST: "AR",
    cityWithStateAbbr: "Parkdale, AR",
  },
  {
    zip: "71662",
    ST: "AR",
    cityWithStateAbbr: "Pickens, AR",
  },
  {
    zip: "71663",
    ST: "AR",
    cityWithStateAbbr: "Portland, AR",
  },
  {
    zip: "71665",
    ST: "AR",
    cityWithStateAbbr: "Rison, AR",
  },
  {
    zip: "71666",
    ST: "AR",
    cityWithStateAbbr: "Rohwer, AR",
  },
  {
    zip: "71667",
    ST: "AR",
    cityWithStateAbbr: "Star City, AR",
  },
  {
    zip: "71670",
    ST: "AR",
    cityWithStateAbbr: "Tillar, AR",
  },
  {
    zip: "71671",
    ST: "AR",
    cityWithStateAbbr: "Warren, AR",
  },
  {
    zip: "71674",
    ST: "AR",
    cityWithStateAbbr: "Watson, AR",
  },
  {
    zip: "71675",
    ST: "AR",
    cityWithStateAbbr: "Wilmar, AR",
  },
  {
    zip: "71676",
    ST: "AR",
    cityWithStateAbbr: "Wilmot, AR",
  },
  {
    zip: "71677",
    ST: "AR",
    cityWithStateAbbr: "Winchester, AR",
  },
  {
    zip: "71678",
    ST: "AR",
    cityWithStateAbbr: "Yorktown, AR",
  },
  {
    zip: "71701",
    ST: "AR",
    cityWithStateAbbr: "Camden, AR",
  },
  {
    zip: "71711",
    ST: "AR",
    cityWithStateAbbr: "Camden, AR",
  },
  {
    zip: "71720",
    ST: "AR",
    cityWithStateAbbr: "Bearden, AR",
  },
  {
    zip: "71721",
    ST: "AR",
    cityWithStateAbbr: "Beirne, AR",
  },
  {
    zip: "71722",
    ST: "AR",
    cityWithStateAbbr: "Bluff City, AR",
  },
  {
    zip: "71724",
    ST: "AR",
    cityWithStateAbbr: "Calion, AR",
  },
  {
    zip: "71725",
    ST: "AR",
    cityWithStateAbbr: "Carthage, AR",
  },
  {
    zip: "71726",
    ST: "AR",
    cityWithStateAbbr: "Chidester, AR",
  },
  {
    zip: "71728",
    ST: "AR",
    cityWithStateAbbr: "Curtis, AR",
  },
  {
    zip: "71730",
    ST: "AR",
    cityWithStateAbbr: "El Dorado, AR",
  },
  {
    zip: "71731",
    ST: "AR",
    cityWithStateAbbr: "El Dorado, AR",
  },
  {
    zip: "71740",
    ST: "AR",
    cityWithStateAbbr: "Emerson, AR",
  },
  {
    zip: "71742",
    ST: "AR",
    cityWithStateAbbr: "Fordyce, AR",
  },
  {
    zip: "71743",
    ST: "AR",
    cityWithStateAbbr: "Gurdon, AR",
  },
  {
    zip: "71744",
    ST: "AR",
    cityWithStateAbbr: "Hampton, AR",
  },
  {
    zip: "71745",
    ST: "AR",
    cityWithStateAbbr: "Harrell, AR",
  },
  {
    zip: "71747",
    ST: "AR",
    cityWithStateAbbr: "Huttig, AR",
  },
  {
    zip: "71748",
    ST: "AR",
    cityWithStateAbbr: "Ivan, AR",
  },
  {
    zip: "71749",
    ST: "AR",
    cityWithStateAbbr: "Junction City, AR",
  },
  {
    zip: "71750",
    ST: "AR",
    cityWithStateAbbr: "Lawson, AR",
  },
  {
    zip: "71751",
    ST: "AR",
    cityWithStateAbbr: "Louann, AR",
  },
  {
    zip: "71752",
    ST: "AR",
    cityWithStateAbbr: "Mc Neil, AR",
  },
  {
    zip: "71753",
    ST: "AR",
    cityWithStateAbbr: "Magnolia, AR",
  },
  {
    zip: "71754",
    ST: "AR",
    cityWithStateAbbr: "Magnolia, AR",
  },
  {
    zip: "71758",
    ST: "AR",
    cityWithStateAbbr: "Mount Holly, AR",
  },
  {
    zip: "71759",
    ST: "AR",
    cityWithStateAbbr: "Norphlet, AR",
  },
  {
    zip: "71762",
    ST: "AR",
    cityWithStateAbbr: "Smackover, AR",
  },
  {
    zip: "71763",
    ST: "AR",
    cityWithStateAbbr: "Sparkman, AR",
  },
  {
    zip: "71764",
    ST: "AR",
    cityWithStateAbbr: "Stephens, AR",
  },
  {
    zip: "71765",
    ST: "AR",
    cityWithStateAbbr: "Strong, AR",
  },
  {
    zip: "71766",
    ST: "AR",
    cityWithStateAbbr: "Thornton, AR",
  },
  {
    zip: "71770",
    ST: "AR",
    cityWithStateAbbr: "Waldo, AR",
  },
  {
    zip: "71772",
    ST: "AR",
    cityWithStateAbbr: "Whelen Springs, AR",
  },
  {
    zip: "71801",
    ST: "AR",
    cityWithStateAbbr: "Hope, AR",
  },
  {
    zip: "71802",
    ST: "AR",
    cityWithStateAbbr: "Hope, AR",
  },
  {
    zip: "71820",
    ST: "AR",
    cityWithStateAbbr: "Alleene, AR",
  },
  {
    zip: "71822",
    ST: "AR",
    cityWithStateAbbr: "Ashdown, AR",
  },
  {
    zip: "71823",
    ST: "AR",
    cityWithStateAbbr: "Ben Lomond, AR",
  },
  {
    zip: "71825",
    ST: "AR",
    cityWithStateAbbr: "Blevins, AR",
  },
  {
    zip: "71826",
    ST: "AR",
    cityWithStateAbbr: "Bradley, AR",
  },
  {
    zip: "71827",
    ST: "AR",
    cityWithStateAbbr: "Buckner, AR",
  },
  {
    zip: "71828",
    ST: "AR",
    cityWithStateAbbr: "Cale, AR",
  },
  {
    zip: "71831",
    ST: "AR",
    cityWithStateAbbr: "Columbus, AR",
  },
  {
    zip: "71832",
    ST: "AR",
    cityWithStateAbbr: "De Queen, AR",
  },
  {
    zip: "71833",
    ST: "AR",
    cityWithStateAbbr: "Dierks, AR",
  },
  {
    zip: "71834",
    ST: "AR",
    cityWithStateAbbr: "Doddridge, AR",
  },
  {
    zip: "71835",
    ST: "AR",
    cityWithStateAbbr: "Emmet, AR",
  },
  {
    zip: "71836",
    ST: "AR",
    cityWithStateAbbr: "Foreman, AR",
  },
  {
    zip: "71837",
    ST: "AR",
    cityWithStateAbbr: "Fouke, AR",
  },
  {
    zip: "71838",
    ST: "AR",
    cityWithStateAbbr: "Fulton, AR",
  },
  {
    zip: "71839",
    ST: "AR",
    cityWithStateAbbr: "Garland City, AR",
  },
  {
    zip: "71840",
    ST: "AR",
    cityWithStateAbbr: "Genoa, AR",
  },
  {
    zip: "71841",
    ST: "AR",
    cityWithStateAbbr: "Gillham, AR",
  },
  {
    zip: "71842",
    ST: "AR",
    cityWithStateAbbr: "Horatio, AR",
  },
  {
    zip: "71845",
    ST: "AR",
    cityWithStateAbbr: "Lewisville, AR",
  },
  {
    zip: "71846",
    ST: "AR",
    cityWithStateAbbr: "Lockesburg, AR",
  },
  {
    zip: "71847",
    ST: "AR",
    cityWithStateAbbr: "Mc Caskill, AR",
  },
  {
    zip: "71851",
    ST: "AR",
    cityWithStateAbbr: "Mineral Springs, AR",
  },
  {
    zip: "71852",
    ST: "AR",
    cityWithStateAbbr: "Nashville, AR",
  },
  {
    zip: "71853",
    ST: "AR",
    cityWithStateAbbr: "Ogden, AR",
  },
  {
    zip: "71854",
    ST: "AR",
    cityWithStateAbbr: "Texarkana, AR",
  },
  {
    zip: "71855",
    ST: "AR",
    cityWithStateAbbr: "Ozan, AR",
  },
  {
    zip: "71857",
    ST: "AR",
    cityWithStateAbbr: "Prescott, AR",
  },
  {
    zip: "71858",
    ST: "AR",
    cityWithStateAbbr: "Rosston, AR",
  },
  {
    zip: "71859",
    ST: "AR",
    cityWithStateAbbr: "Saratoga, AR",
  },
  {
    zip: "71860",
    ST: "AR",
    cityWithStateAbbr: "Stamps, AR",
  },
  {
    zip: "71861",
    ST: "AR",
    cityWithStateAbbr: "Taylor, AR",
  },
  {
    zip: "71862",
    ST: "AR",
    cityWithStateAbbr: "Washington, AR",
  },
  {
    zip: "71864",
    ST: "AR",
    cityWithStateAbbr: "Willisville, AR",
  },
  {
    zip: "71865",
    ST: "AR",
    cityWithStateAbbr: "Wilton, AR",
  },
  {
    zip: "71866",
    ST: "AR",
    cityWithStateAbbr: "Winthrop, AR",
  },
  {
    zip: "71901",
    ST: "AR",
    cityWithStateAbbr: "Hot Springs National Par, AR",
  },
  {
    zip: "71902",
    ST: "AR",
    cityWithStateAbbr: "Hot Springs National Par, AR",
  },
  {
    zip: "71903",
    ST: "AR",
    cityWithStateAbbr: "Hot Springs National Par, AR",
  },
  {
    zip: "71909",
    ST: "AR",
    cityWithStateAbbr: "Hot Springs Village, AR",
  },
  {
    zip: "71910",
    ST: "AR",
    cityWithStateAbbr: "Hot Springs Village, AR",
  },
  {
    zip: "71913",
    ST: "AR",
    cityWithStateAbbr: "Hot Springs National Par, AR",
  },
  {
    zip: "71914",
    ST: "AR",
    cityWithStateAbbr: "Hot Springs National Par, AR",
  },
  {
    zip: "71920",
    ST: "AR",
    cityWithStateAbbr: "Alpine, AR",
  },
  {
    zip: "71921",
    ST: "AR",
    cityWithStateAbbr: "Amity, AR",
  },
  {
    zip: "71922",
    ST: "AR",
    cityWithStateAbbr: "Antoine, AR",
  },
  {
    zip: "71923",
    ST: "AR",
    cityWithStateAbbr: "Arkadelphia, AR",
  },
  {
    zip: "71929",
    ST: "AR",
    cityWithStateAbbr: "Bismarck, AR",
  },
  {
    zip: "71932",
    ST: "AR",
    cityWithStateAbbr: "Board Camp, AR",
  },
  {
    zip: "71933",
    ST: "AR",
    cityWithStateAbbr: "Bonnerdale, AR",
  },
  {
    zip: "71935",
    ST: "AR",
    cityWithStateAbbr: "Caddo Gap, AR",
  },
  {
    zip: "71937",
    ST: "AR",
    cityWithStateAbbr: "Cove, AR",
  },
  {
    zip: "71940",
    ST: "AR",
    cityWithStateAbbr: "Delight, AR",
  },
  {
    zip: "71941",
    ST: "AR",
    cityWithStateAbbr: "Donaldson, AR",
  },
  {
    zip: "71942",
    ST: "AR",
    cityWithStateAbbr: "Friendship, AR",
  },
  {
    zip: "71943",
    ST: "AR",
    cityWithStateAbbr: "Glenwood, AR",
  },
  {
    zip: "71944",
    ST: "AR",
    cityWithStateAbbr: "Grannis, AR",
  },
  {
    zip: "71945",
    ST: "AR",
    cityWithStateAbbr: "Hatfield, AR",
  },
  {
    zip: "71949",
    ST: "AR",
    cityWithStateAbbr: "Jessieville, AR",
  },
  {
    zip: "71950",
    ST: "AR",
    cityWithStateAbbr: "Kirby, AR",
  },
  {
    zip: "71952",
    ST: "AR",
    cityWithStateAbbr: "Langley, AR",
  },
  {
    zip: "71953",
    ST: "AR",
    cityWithStateAbbr: "Mena, AR",
  },
  {
    zip: "71956",
    ST: "AR",
    cityWithStateAbbr: "Mountain Pine, AR",
  },
  {
    zip: "71957",
    ST: "AR",
    cityWithStateAbbr: "Mount Ida, AR",
  },
  {
    zip: "71958",
    ST: "AR",
    cityWithStateAbbr: "Murfreesboro, AR",
  },
  {
    zip: "71959",
    ST: "AR",
    cityWithStateAbbr: "Newhope, AR",
  },
  {
    zip: "71960",
    ST: "AR",
    cityWithStateAbbr: "Norman, AR",
  },
  {
    zip: "71961",
    ST: "AR",
    cityWithStateAbbr: "Oden, AR",
  },
  {
    zip: "71962",
    ST: "AR",
    cityWithStateAbbr: "Okolona, AR",
  },
  {
    zip: "71964",
    ST: "AR",
    cityWithStateAbbr: "Pearcy, AR",
  },
  {
    zip: "71965",
    ST: "AR",
    cityWithStateAbbr: "Pencil Bluff, AR",
  },
  {
    zip: "71966",
    ST: "AR",
    cityWithStateAbbr: "Oden, AR",
  },
  {
    zip: "71968",
    ST: "AR",
    cityWithStateAbbr: "Royal, AR",
  },
  {
    zip: "71969",
    ST: "AR",
    cityWithStateAbbr: "Sims, AR",
  },
  {
    zip: "71970",
    ST: "AR",
    cityWithStateAbbr: "Story, AR",
  },
  {
    zip: "71971",
    ST: "AR",
    cityWithStateAbbr: "Umpire, AR",
  },
  {
    zip: "71972",
    ST: "AR",
    cityWithStateAbbr: "Vandervoort, AR",
  },
  {
    zip: "71973",
    ST: "AR",
    cityWithStateAbbr: "Wickes, AR",
  },
  {
    zip: "71998",
    ST: "AR",
    cityWithStateAbbr: "Arkadelphia, AR",
  },
  {
    zip: "71999",
    ST: "AR",
    cityWithStateAbbr: "Arkadelphia, AR",
  },
  {
    zip: "72001",
    ST: "AR",
    cityWithStateAbbr: "Adona, AR",
  },
  {
    zip: "72002",
    ST: "AR",
    cityWithStateAbbr: "Alexander, AR",
  },
  {
    zip: "72003",
    ST: "AR",
    cityWithStateAbbr: "Almyra, AR",
  },
  {
    zip: "72004",
    ST: "AR",
    cityWithStateAbbr: "Altheimer, AR",
  },
  {
    zip: "72005",
    ST: "AR",
    cityWithStateAbbr: "Amagon, AR",
  },
  {
    zip: "72006",
    ST: "AR",
    cityWithStateAbbr: "Augusta, AR",
  },
  {
    zip: "72007",
    ST: "AR",
    cityWithStateAbbr: "Austin, AR",
  },
  {
    zip: "72010",
    ST: "AR",
    cityWithStateAbbr: "Bald Knob, AR",
  },
  {
    zip: "72011",
    ST: "AR",
    cityWithStateAbbr: "Bauxite, AR",
  },
  {
    zip: "72012",
    ST: "AR",
    cityWithStateAbbr: "Beebe, AR",
  },
  {
    zip: "72013",
    ST: "AR",
    cityWithStateAbbr: "Bee Branch, AR",
  },
  {
    zip: "72014",
    ST: "AR",
    cityWithStateAbbr: "Beedeville, AR",
  },
  {
    zip: "72015",
    ST: "AR",
    cityWithStateAbbr: "Benton, AR",
  },
  {
    zip: "72016",
    ST: "AR",
    cityWithStateAbbr: "Bigelow, AR",
  },
  {
    zip: "72017",
    ST: "AR",
    cityWithStateAbbr: "Biscoe, AR",
  },
  {
    zip: "72018",
    ST: "AR",
    cityWithStateAbbr: "Benton, AR",
  },
  {
    zip: "72019",
    ST: "AR",
    cityWithStateAbbr: "Benton, AR",
  },
  {
    zip: "72020",
    ST: "AR",
    cityWithStateAbbr: "Bradford, AR",
  },
  {
    zip: "72021",
    ST: "AR",
    cityWithStateAbbr: "Brinkley, AR",
  },
  {
    zip: "72022",
    ST: "AR",
    cityWithStateAbbr: "Bryant, AR",
  },
  {
    zip: "72023",
    ST: "AR",
    cityWithStateAbbr: "Cabot, AR",
  },
  {
    zip: "72024",
    ST: "AR",
    cityWithStateAbbr: "Carlisle, AR",
  },
  {
    zip: "72025",
    ST: "AR",
    cityWithStateAbbr: "Casa, AR",
  },
  {
    zip: "72026",
    ST: "AR",
    cityWithStateAbbr: "Casscoe, AR",
  },
  {
    zip: "72027",
    ST: "AR",
    cityWithStateAbbr: "Center Ridge, AR",
  },
  {
    zip: "72028",
    ST: "AR",
    cityWithStateAbbr: "Choctaw, AR",
  },
  {
    zip: "72029",
    ST: "AR",
    cityWithStateAbbr: "Clarendon, AR",
  },
  {
    zip: "72030",
    ST: "AR",
    cityWithStateAbbr: "Cleveland, AR",
  },
  {
    zip: "72031",
    ST: "AR",
    cityWithStateAbbr: "Clinton, AR",
  },
  {
    zip: "72032",
    ST: "AR",
    cityWithStateAbbr: "Conway, AR",
  },
  {
    zip: "72033",
    ST: "AR",
    cityWithStateAbbr: "Conway, AR",
  },
  {
    zip: "72034",
    ST: "AR",
    cityWithStateAbbr: "Conway, AR",
  },
  {
    zip: "72035",
    ST: "AR",
    cityWithStateAbbr: "Conway, AR",
  },
  {
    zip: "72036",
    ST: "AR",
    cityWithStateAbbr: "Cotton Plant, AR",
  },
  {
    zip: "72037",
    ST: "AR",
    cityWithStateAbbr: "Coy, AR",
  },
  {
    zip: "72038",
    ST: "AR",
    cityWithStateAbbr: "Crocketts Bluff, AR",
  },
  {
    zip: "72039",
    ST: "AR",
    cityWithStateAbbr: "Damascus, AR",
  },
  {
    zip: "72040",
    ST: "AR",
    cityWithStateAbbr: "Des Arc, AR",
  },
  {
    zip: "72041",
    ST: "AR",
    cityWithStateAbbr: "De Valls Bluff, AR",
  },
  {
    zip: "72042",
    ST: "AR",
    cityWithStateAbbr: "De Witt, AR",
  },
  {
    zip: "72043",
    ST: "AR",
    cityWithStateAbbr: "Diaz, AR",
  },
  {
    zip: "72044",
    ST: "AR",
    cityWithStateAbbr: "Edgemont, AR",
  },
  {
    zip: "72045",
    ST: "AR",
    cityWithStateAbbr: "El Paso, AR",
  },
  {
    zip: "72046",
    ST: "AR",
    cityWithStateAbbr: "England, AR",
  },
  {
    zip: "72047",
    ST: "AR",
    cityWithStateAbbr: "Enola, AR",
  },
  {
    zip: "72048",
    ST: "AR",
    cityWithStateAbbr: "Ethel, AR",
  },
  {
    zip: "72051",
    ST: "AR",
    cityWithStateAbbr: "Fox, AR",
  },
  {
    zip: "72052",
    ST: "AR",
    cityWithStateAbbr: "Garner, AR",
  },
  {
    zip: "72053",
    ST: "AR",
    cityWithStateAbbr: "College Station, AR",
  },
  {
    zip: "72055",
    ST: "AR",
    cityWithStateAbbr: "Gillett, AR",
  },
  {
    zip: "72057",
    ST: "AR",
    cityWithStateAbbr: "Grapevine, AR",
  },
  {
    zip: "72058",
    ST: "AR",
    cityWithStateAbbr: "Greenbrier, AR",
  },
  {
    zip: "72059",
    ST: "AR",
    cityWithStateAbbr: "Gregory, AR",
  },
  {
    zip: "72060",
    ST: "AR",
    cityWithStateAbbr: "Griffithville, AR",
  },
  {
    zip: "72061",
    ST: "AR",
    cityWithStateAbbr: "Guy, AR",
  },
  {
    zip: "72063",
    ST: "AR",
    cityWithStateAbbr: "Hattieville, AR",
  },
  {
    zip: "72064",
    ST: "AR",
    cityWithStateAbbr: "Hazen, AR",
  },
  {
    zip: "72065",
    ST: "AR",
    cityWithStateAbbr: "Hensley, AR",
  },
  {
    zip: "72066",
    ST: "AR",
    cityWithStateAbbr: "Hickory Plains, AR",
  },
  {
    zip: "72067",
    ST: "AR",
    cityWithStateAbbr: "Higden, AR",
  },
  {
    zip: "72068",
    ST: "AR",
    cityWithStateAbbr: "Higginson, AR",
  },
  {
    zip: "72069",
    ST: "AR",
    cityWithStateAbbr: "Holly Grove, AR",
  },
  {
    zip: "72070",
    ST: "AR",
    cityWithStateAbbr: "Houston, AR",
  },
  {
    zip: "72072",
    ST: "AR",
    cityWithStateAbbr: "Humnoke, AR",
  },
  {
    zip: "72073",
    ST: "AR",
    cityWithStateAbbr: "Humphrey, AR",
  },
  {
    zip: "72074",
    ST: "AR",
    cityWithStateAbbr: "Hunter, AR",
  },
  {
    zip: "72075",
    ST: "AR",
    cityWithStateAbbr: "Jacksonport, AR",
  },
  {
    zip: "72076",
    ST: "AR",
    cityWithStateAbbr: "Jacksonville, AR",
  },
  {
    zip: "72078",
    ST: "AR",
    cityWithStateAbbr: "Jacksonville, AR",
  },
  {
    zip: "72079",
    ST: "AR",
    cityWithStateAbbr: "Jefferson, AR",
  },
  {
    zip: "72080",
    ST: "AR",
    cityWithStateAbbr: "Jerusalem, AR",
  },
  {
    zip: "72081",
    ST: "AR",
    cityWithStateAbbr: "Judsonia, AR",
  },
  {
    zip: "72082",
    ST: "AR",
    cityWithStateAbbr: "Kensett, AR",
  },
  {
    zip: "72083",
    ST: "AR",
    cityWithStateAbbr: "Keo, AR",
  },
  {
    zip: "72084",
    ST: "AR",
    cityWithStateAbbr: "Leola, AR",
  },
  {
    zip: "72085",
    ST: "AR",
    cityWithStateAbbr: "Letona, AR",
  },
  {
    zip: "72086",
    ST: "AR",
    cityWithStateAbbr: "Lonoke, AR",
  },
  {
    zip: "72087",
    ST: "AR",
    cityWithStateAbbr: "Lonsdale, AR",
  },
  {
    zip: "72088",
    ST: "AR",
    cityWithStateAbbr: "Fairfield Bay, AR",
  },
  {
    zip: "72089",
    ST: "AR",
    cityWithStateAbbr: "Bryant, AR",
  },
  {
    zip: "72099",
    ST: "AR",
    cityWithStateAbbr: "Little Rock Air Force Ba, AR",
  },
  {
    zip: "72101",
    ST: "AR",
    cityWithStateAbbr: "Mc Crory, AR",
  },
  {
    zip: "72102",
    ST: "AR",
    cityWithStateAbbr: "Mc Rae, AR",
  },
  {
    zip: "72103",
    ST: "AR",
    cityWithStateAbbr: "Mabelvale, AR",
  },
  {
    zip: "72104",
    ST: "AR",
    cityWithStateAbbr: "Malvern, AR",
  },
  {
    zip: "72105",
    ST: "AR",
    cityWithStateAbbr: "Jones Mill, AR",
  },
  {
    zip: "72106",
    ST: "AR",
    cityWithStateAbbr: "Mayflower, AR",
  },
  {
    zip: "72107",
    ST: "AR",
    cityWithStateAbbr: "Menifee, AR",
  },
  {
    zip: "72108",
    ST: "AR",
    cityWithStateAbbr: "Monroe, AR",
  },
  {
    zip: "72110",
    ST: "AR",
    cityWithStateAbbr: "Morrilton, AR",
  },
  {
    zip: "72111",
    ST: "AR",
    cityWithStateAbbr: "Mount Vernon, AR",
  },
  {
    zip: "72112",
    ST: "AR",
    cityWithStateAbbr: "Newport, AR",
  },
  {
    zip: "72113",
    ST: "AR",
    cityWithStateAbbr: "Maumelle, AR",
  },
  {
    zip: "72114",
    ST: "AR",
    cityWithStateAbbr: "North Little Rock, AR",
  },
  {
    zip: "72115",
    ST: "AR",
    cityWithStateAbbr: "North Little Rock, AR",
  },
  {
    zip: "72116",
    ST: "AR",
    cityWithStateAbbr: "North Little Rock, AR",
  },
  {
    zip: "72117",
    ST: "AR",
    cityWithStateAbbr: "North Little Rock, AR",
  },
  {
    zip: "72118",
    ST: "AR",
    cityWithStateAbbr: "North Little Rock, AR",
  },
  {
    zip: "72119",
    ST: "AR",
    cityWithStateAbbr: "North Little Rock, AR",
  },
  {
    zip: "72120",
    ST: "AR",
    cityWithStateAbbr: "Sherwood, AR",
  },
  {
    zip: "72121",
    ST: "AR",
    cityWithStateAbbr: "Pangburn, AR",
  },
  {
    zip: "72122",
    ST: "AR",
    cityWithStateAbbr: "Paron, AR",
  },
  {
    zip: "72123",
    ST: "AR",
    cityWithStateAbbr: "Patterson, AR",
  },
  {
    zip: "72124",
    ST: "AR",
    cityWithStateAbbr: "North Little Rock, AR",
  },
  {
    zip: "72125",
    ST: "AR",
    cityWithStateAbbr: "Perry, AR",
  },
  {
    zip: "72126",
    ST: "AR",
    cityWithStateAbbr: "Perryville, AR",
  },
  {
    zip: "72127",
    ST: "AR",
    cityWithStateAbbr: "Plumerville, AR",
  },
  {
    zip: "72128",
    ST: "AR",
    cityWithStateAbbr: "Poyen, AR",
  },
  {
    zip: "72129",
    ST: "AR",
    cityWithStateAbbr: "Prattsville, AR",
  },
  {
    zip: "72130",
    ST: "AR",
    cityWithStateAbbr: "Prim, AR",
  },
  {
    zip: "72131",
    ST: "AR",
    cityWithStateAbbr: "Quitman, AR",
  },
  {
    zip: "72132",
    ST: "AR",
    cityWithStateAbbr: "Redfield, AR",
  },
  {
    zip: "72133",
    ST: "AR",
    cityWithStateAbbr: "Reydell, AR",
  },
  {
    zip: "72134",
    ST: "AR",
    cityWithStateAbbr: "Roe, AR",
  },
  {
    zip: "72135",
    ST: "AR",
    cityWithStateAbbr: "Roland, AR",
  },
  {
    zip: "72136",
    ST: "AR",
    cityWithStateAbbr: "Romance, AR",
  },
  {
    zip: "72137",
    ST: "AR",
    cityWithStateAbbr: "Rose Bud, AR",
  },
  {
    zip: "72139",
    ST: "AR",
    cityWithStateAbbr: "Russell, AR",
  },
  {
    zip: "72140",
    ST: "AR",
    cityWithStateAbbr: "Saint Charles, AR",
  },
  {
    zip: "72141",
    ST: "AR",
    cityWithStateAbbr: "Scotland, AR",
  },
  {
    zip: "72142",
    ST: "AR",
    cityWithStateAbbr: "Scott, AR",
  },
  {
    zip: "72143",
    ST: "AR",
    cityWithStateAbbr: "Searcy, AR",
  },
  {
    zip: "72145",
    ST: "AR",
    cityWithStateAbbr: "Searcy, AR",
  },
  {
    zip: "72149",
    ST: "AR",
    cityWithStateAbbr: "Searcy, AR",
  },
  {
    zip: "72150",
    ST: "AR",
    cityWithStateAbbr: "Sheridan, AR",
  },
  {
    zip: "72152",
    ST: "AR",
    cityWithStateAbbr: "Sherrill, AR",
  },
  {
    zip: "72153",
    ST: "AR",
    cityWithStateAbbr: "Shirley, AR",
  },
  {
    zip: "72156",
    ST: "AR",
    cityWithStateAbbr: "Solgohachia, AR",
  },
  {
    zip: "72157",
    ST: "AR",
    cityWithStateAbbr: "Springfield, AR",
  },
  {
    zip: "72160",
    ST: "AR",
    cityWithStateAbbr: "Stuttgart, AR",
  },
  {
    zip: "72164",
    ST: "AR",
    cityWithStateAbbr: "Sweet Home, AR",
  },
  {
    zip: "72165",
    ST: "AR",
    cityWithStateAbbr: "Thida, AR",
  },
  {
    zip: "72166",
    ST: "AR",
    cityWithStateAbbr: "Tichnor, AR",
  },
  {
    zip: "72167",
    ST: "AR",
    cityWithStateAbbr: "Traskwood, AR",
  },
  {
    zip: "72168",
    ST: "AR",
    cityWithStateAbbr: "Tucker, AR",
  },
  {
    zip: "72169",
    ST: "AR",
    cityWithStateAbbr: "Tupelo, AR",
  },
  {
    zip: "72170",
    ST: "AR",
    cityWithStateAbbr: "Ulm, AR",
  },
  {
    zip: "72173",
    ST: "AR",
    cityWithStateAbbr: "Vilonia, AR",
  },
  {
    zip: "72175",
    ST: "AR",
    cityWithStateAbbr: "Wabbaseka, AR",
  },
  {
    zip: "72176",
    ST: "AR",
    cityWithStateAbbr: "Ward, AR",
  },
  {
    zip: "72178",
    ST: "AR",
    cityWithStateAbbr: "West Point, AR",
  },
  {
    zip: "72179",
    ST: "AR",
    cityWithStateAbbr: "Wilburn, AR",
  },
  {
    zip: "72180",
    ST: "AR",
    cityWithStateAbbr: "Woodson, AR",
  },
  {
    zip: "72181",
    ST: "AR",
    cityWithStateAbbr: "Wooster, AR",
  },
  {
    zip: "72182",
    ST: "AR",
    cityWithStateAbbr: "Wright, AR",
  },
  {
    zip: "72183",
    ST: "AR",
    cityWithStateAbbr: "Wrightsville, AR",
  },
  {
    zip: "72190",
    ST: "AR",
    cityWithStateAbbr: "North Little Rock, AR",
  },
  {
    zip: "72199",
    ST: "AR",
    cityWithStateAbbr: "North Little Rock, AR",
  },
  {
    zip: "72201",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72202",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72203",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72204",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72205",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72206",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72207",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72209",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72210",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72211",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72212",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72214",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72215",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72216",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72217",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72219",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72221",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72222",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72223",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72225",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72227",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72231",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72260",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72295",
    ST: "AR",
    cityWithStateAbbr: "Little Rock, AR",
  },
  {
    zip: "72301",
    ST: "AR",
    cityWithStateAbbr: "West Memphis, AR",
  },
  {
    zip: "72303",
    ST: "AR",
    cityWithStateAbbr: "West Memphis, AR",
  },
  {
    zip: "72310",
    ST: "AR",
    cityWithStateAbbr: "Armorel, AR",
  },
  {
    zip: "72311",
    ST: "AR",
    cityWithStateAbbr: "Aubrey, AR",
  },
  {
    zip: "72312",
    ST: "AR",
    cityWithStateAbbr: "Barton, AR",
  },
  {
    zip: "72313",
    ST: "AR",
    cityWithStateAbbr: "Bassett, AR",
  },
  {
    zip: "72315",
    ST: "AR",
    cityWithStateAbbr: "Blytheville, AR",
  },
  {
    zip: "72316",
    ST: "AR",
    cityWithStateAbbr: "Blytheville, AR",
  },
  {
    zip: "72319",
    ST: "AR",
    cityWithStateAbbr: "Gosnell, AR",
  },
  {
    zip: "72320",
    ST: "AR",
    cityWithStateAbbr: "Brickeys, AR",
  },
  {
    zip: "72321",
    ST: "AR",
    cityWithStateAbbr: "Burdette, AR",
  },
  {
    zip: "72322",
    ST: "AR",
    cityWithStateAbbr: "Caldwell, AR",
  },
  {
    zip: "72324",
    ST: "AR",
    cityWithStateAbbr: "Cherry Valley, AR",
  },
  {
    zip: "72325",
    ST: "AR",
    cityWithStateAbbr: "Clarkedale, AR",
  },
  {
    zip: "72326",
    ST: "AR",
    cityWithStateAbbr: "Colt, AR",
  },
  {
    zip: "72327",
    ST: "AR",
    cityWithStateAbbr: "Crawfordsville, AR",
  },
  {
    zip: "72328",
    ST: "AR",
    cityWithStateAbbr: "Crumrod, AR",
  },
  {
    zip: "72329",
    ST: "AR",
    cityWithStateAbbr: "Driver, AR",
  },
  {
    zip: "72330",
    ST: "AR",
    cityWithStateAbbr: "Dyess, AR",
  },
  {
    zip: "72331",
    ST: "AR",
    cityWithStateAbbr: "Earle, AR",
  },
  {
    zip: "72332",
    ST: "AR",
    cityWithStateAbbr: "Edmondson, AR",
  },
  {
    zip: "72333",
    ST: "AR",
    cityWithStateAbbr: "Elaine, AR",
  },
  {
    zip: "72335",
    ST: "AR",
    cityWithStateAbbr: "Forrest City, AR",
  },
  {
    zip: "72336",
    ST: "AR",
    cityWithStateAbbr: "Forrest City, AR",
  },
  {
    zip: "72338",
    ST: "TN",
    cityWithStateAbbr: "Frenchmans Bayou, TN",
  },
  {
    zip: "72339",
    ST: "AR",
    cityWithStateAbbr: "Gilmore, AR",
  },
  {
    zip: "72340",
    ST: "AR",
    cityWithStateAbbr: "Goodwin, AR",
  },
  {
    zip: "72341",
    ST: "AR",
    cityWithStateAbbr: "Haynes, AR",
  },
  {
    zip: "72342",
    ST: "AR",
    cityWithStateAbbr: "Helena, AR",
  },
  {
    zip: "72346",
    ST: "AR",
    cityWithStateAbbr: "Heth, AR",
  },
  {
    zip: "72347",
    ST: "AR",
    cityWithStateAbbr: "Hickory Ridge, AR",
  },
  {
    zip: "72348",
    ST: "AR",
    cityWithStateAbbr: "Hughes, AR",
  },
  {
    zip: "72350",
    ST: "AR",
    cityWithStateAbbr: "Joiner, AR",
  },
  {
    zip: "72351",
    ST: "AR",
    cityWithStateAbbr: "Keiser, AR",
  },
  {
    zip: "72352",
    ST: "AR",
    cityWithStateAbbr: "La Grange, AR",
  },
  {
    zip: "72353",
    ST: "AR",
    cityWithStateAbbr: "Lambrook, AR",
  },
  {
    zip: "72354",
    ST: "AR",
    cityWithStateAbbr: "Lepanto, AR",
  },
  {
    zip: "72355",
    ST: "AR",
    cityWithStateAbbr: "Lexa, AR",
  },
  {
    zip: "72358",
    ST: "AR",
    cityWithStateAbbr: "Luxora, AR",
  },
  {
    zip: "72359",
    ST: "AR",
    cityWithStateAbbr: "Madison, AR",
  },
  {
    zip: "72360",
    ST: "AR",
    cityWithStateAbbr: "Marianna, AR",
  },
  {
    zip: "72364",
    ST: "AR",
    cityWithStateAbbr: "Marion, AR",
  },
  {
    zip: "72365",
    ST: "AR",
    cityWithStateAbbr: "Marked Tree, AR",
  },
  {
    zip: "72366",
    ST: "AR",
    cityWithStateAbbr: "Marvell, AR",
  },
  {
    zip: "72367",
    ST: "AR",
    cityWithStateAbbr: "Mellwood, AR",
  },
  {
    zip: "72368",
    ST: "AR",
    cityWithStateAbbr: "Moro, AR",
  },
  {
    zip: "72369",
    ST: "AR",
    cityWithStateAbbr: "Oneida, AR",
  },
  {
    zip: "72370",
    ST: "AR",
    cityWithStateAbbr: "Osceola, AR",
  },
  {
    zip: "72372",
    ST: "AR",
    cityWithStateAbbr: "Palestine, AR",
  },
  {
    zip: "72373",
    ST: "AR",
    cityWithStateAbbr: "Parkin, AR",
  },
  {
    zip: "72374",
    ST: "AR",
    cityWithStateAbbr: "Poplar Grove, AR",
  },
  {
    zip: "72376",
    ST: "AR",
    cityWithStateAbbr: "Proctor, AR",
  },
  {
    zip: "72377",
    ST: "AR",
    cityWithStateAbbr: "Rivervale, AR",
  },
  {
    zip: "72379",
    ST: "AR",
    cityWithStateAbbr: "Snow Lake, AR",
  },
  {
    zip: "72383",
    ST: "AR",
    cityWithStateAbbr: "Turner, AR",
  },
  {
    zip: "72384",
    ST: "AR",
    cityWithStateAbbr: "Turrell, AR",
  },
  {
    zip: "72386",
    ST: "AR",
    cityWithStateAbbr: "Tyronza, AR",
  },
  {
    zip: "72387",
    ST: "AR",
    cityWithStateAbbr: "Vanndale, AR",
  },
  {
    zip: "72389",
    ST: "AR",
    cityWithStateAbbr: "Wabash, AR",
  },
  {
    zip: "72390",
    ST: "AR",
    cityWithStateAbbr: "West Helena, AR",
  },
  {
    zip: "72391",
    ST: "AR",
    cityWithStateAbbr: "West Ridge, AR",
  },
  {
    zip: "72392",
    ST: "AR",
    cityWithStateAbbr: "Wheatley, AR",
  },
  {
    zip: "72394",
    ST: "AR",
    cityWithStateAbbr: "Widener, AR",
  },
  {
    zip: "72395",
    ST: "AR",
    cityWithStateAbbr: "Wilson, AR",
  },
  {
    zip: "72396",
    ST: "AR",
    cityWithStateAbbr: "Wynne, AR",
  },
  {
    zip: "72401",
    ST: "AR",
    cityWithStateAbbr: "Jonesboro, AR",
  },
  {
    zip: "72402",
    ST: "AR",
    cityWithStateAbbr: "Jonesboro, AR",
  },
  {
    zip: "72403",
    ST: "AR",
    cityWithStateAbbr: "Jonesboro, AR",
  },
  {
    zip: "72404",
    ST: "AR",
    cityWithStateAbbr: "Jonesboro, AR",
  },
  {
    zip: "72410",
    ST: "AR",
    cityWithStateAbbr: "Alicia, AR",
  },
  {
    zip: "72411",
    ST: "AR",
    cityWithStateAbbr: "Bay, AR",
  },
  {
    zip: "72412",
    ST: "AR",
    cityWithStateAbbr: "Beech Grove, AR",
  },
  {
    zip: "72413",
    ST: "AR",
    cityWithStateAbbr: "Biggers, AR",
  },
  {
    zip: "72414",
    ST: "AR",
    cityWithStateAbbr: "Black Oak, AR",
  },
  {
    zip: "72415",
    ST: "AR",
    cityWithStateAbbr: "Black Rock, AR",
  },
  {
    zip: "72416",
    ST: "AR",
    cityWithStateAbbr: "Bono, AR",
  },
  {
    zip: "72417",
    ST: "AR",
    cityWithStateAbbr: "Brookland, AR",
  },
  {
    zip: "72419",
    ST: "AR",
    cityWithStateAbbr: "Caraway, AR",
  },
  {
    zip: "72421",
    ST: "AR",
    cityWithStateAbbr: "Cash, AR",
  },
  {
    zip: "72422",
    ST: "AR",
    cityWithStateAbbr: "Corning, AR",
  },
  {
    zip: "72424",
    ST: "AR",
    cityWithStateAbbr: "Datto, AR",
  },
  {
    zip: "72425",
    ST: "AR",
    cityWithStateAbbr: "Delaplaine, AR",
  },
  {
    zip: "72426",
    ST: "AR",
    cityWithStateAbbr: "Dell, AR",
  },
  {
    zip: "72427",
    ST: "AR",
    cityWithStateAbbr: "Egypt, AR",
  },
  {
    zip: "72428",
    ST: "AR",
    cityWithStateAbbr: "Etowah, AR",
  },
  {
    zip: "72429",
    ST: "AR",
    cityWithStateAbbr: "Fisher, AR",
  },
  {
    zip: "72430",
    ST: "AR",
    cityWithStateAbbr: "Greenway, AR",
  },
  {
    zip: "72431",
    ST: "AR",
    cityWithStateAbbr: "Grubbs, AR",
  },
  {
    zip: "72432",
    ST: "AR",
    cityWithStateAbbr: "Harrisburg, AR",
  },
  {
    zip: "72433",
    ST: "AR",
    cityWithStateAbbr: "Hoxie, AR",
  },
  {
    zip: "72434",
    ST: "AR",
    cityWithStateAbbr: "Imboden, AR",
  },
  {
    zip: "72435",
    ST: "AR",
    cityWithStateAbbr: "Knobel, AR",
  },
  {
    zip: "72436",
    ST: "AR",
    cityWithStateAbbr: "Lafe, AR",
  },
  {
    zip: "72437",
    ST: "AR",
    cityWithStateAbbr: "Lake City, AR",
  },
  {
    zip: "72438",
    ST: "AR",
    cityWithStateAbbr: "Leachville, AR",
  },
  {
    zip: "72439",
    ST: "AR",
    cityWithStateAbbr: "Bono, AR",
  },
  {
    zip: "72440",
    ST: "AR",
    cityWithStateAbbr: "Lynn, AR",
  },
  {
    zip: "72441",
    ST: "AR",
    cityWithStateAbbr: "Mc Dougal, AR",
  },
  {
    zip: "72442",
    ST: "AR",
    cityWithStateAbbr: "Manila, AR",
  },
  {
    zip: "72443",
    ST: "AR",
    cityWithStateAbbr: "Marmaduke, AR",
  },
  {
    zip: "72444",
    ST: "AR",
    cityWithStateAbbr: "Maynard, AR",
  },
  {
    zip: "72445",
    ST: "AR",
    cityWithStateAbbr: "Minturn, AR",
  },
  {
    zip: "72447",
    ST: "AR",
    cityWithStateAbbr: "Monette, AR",
  },
  {
    zip: "72449",
    ST: "AR",
    cityWithStateAbbr: "O Kean, AR",
  },
  {
    zip: "72450",
    ST: "AR",
    cityWithStateAbbr: "Paragould, AR",
  },
  {
    zip: "72451",
    ST: "AR",
    cityWithStateAbbr: "Paragould, AR",
  },
  {
    zip: "72453",
    ST: "AR",
    cityWithStateAbbr: "Peach Orchard, AR",
  },
  {
    zip: "72454",
    ST: "AR",
    cityWithStateAbbr: "Piggott, AR",
  },
  {
    zip: "72455",
    ST: "AR",
    cityWithStateAbbr: "Pocahontas, AR",
  },
  {
    zip: "72456",
    ST: "AR",
    cityWithStateAbbr: "Pollard, AR",
  },
  {
    zip: "72457",
    ST: "AR",
    cityWithStateAbbr: "Portia, AR",
  },
  {
    zip: "72458",
    ST: "AR",
    cityWithStateAbbr: "Powhatan, AR",
  },
  {
    zip: "72459",
    ST: "AR",
    cityWithStateAbbr: "Ravenden, AR",
  },
  {
    zip: "72460",
    ST: "AR",
    cityWithStateAbbr: "Ravenden Springs, AR",
  },
  {
    zip: "72461",
    ST: "AR",
    cityWithStateAbbr: "Rector, AR",
  },
  {
    zip: "72462",
    ST: "AR",
    cityWithStateAbbr: "Reyno, AR",
  },
  {
    zip: "72464",
    ST: "AR",
    cityWithStateAbbr: "Saint Francis, AR",
  },
  {
    zip: "72465",
    ST: "AR",
    cityWithStateAbbr: "Sedgwick, AR",
  },
  {
    zip: "72466",
    ST: "AR",
    cityWithStateAbbr: "Smithville, AR",
  },
  {
    zip: "72467",
    ST: "AR",
    cityWithStateAbbr: "State University, AR",
  },
  {
    zip: "72469",
    ST: "AR",
    cityWithStateAbbr: "Strawberry, AR",
  },
  {
    zip: "72470",
    ST: "AR",
    cityWithStateAbbr: "Success, AR",
  },
  {
    zip: "72471",
    ST: "AR",
    cityWithStateAbbr: "Swifton, AR",
  },
  {
    zip: "72472",
    ST: "AR",
    cityWithStateAbbr: "Trumann, AR",
  },
  {
    zip: "72473",
    ST: "AR",
    cityWithStateAbbr: "Tuckerman, AR",
  },
  {
    zip: "72474",
    ST: "AR",
    cityWithStateAbbr: "Walcott, AR",
  },
  {
    zip: "72475",
    ST: "AR",
    cityWithStateAbbr: "Waldenburg, AR",
  },
  {
    zip: "72476",
    ST: "AR",
    cityWithStateAbbr: "Walnut Ridge, AR",
  },
  {
    zip: "72478",
    ST: "AR",
    cityWithStateAbbr: "Warm Springs, AR",
  },
  {
    zip: "72479",
    ST: "AR",
    cityWithStateAbbr: "Weiner, AR",
  },
  {
    zip: "72482",
    ST: "AR",
    cityWithStateAbbr: "Williford, AR",
  },
  {
    zip: "72501",
    ST: "AR",
    cityWithStateAbbr: "Batesville, AR",
  },
  {
    zip: "72503",
    ST: "AR",
    cityWithStateAbbr: "Batesville, AR",
  },
  {
    zip: "72512",
    ST: "AR",
    cityWithStateAbbr: "Horseshoe Bend, AR",
  },
  {
    zip: "72513",
    ST: "AR",
    cityWithStateAbbr: "Ash Flat, AR",
  },
  {
    zip: "72515",
    ST: "AR",
    cityWithStateAbbr: "Bexar, AR",
  },
  {
    zip: "72517",
    ST: "AR",
    cityWithStateAbbr: "Brockwell, AR",
  },
  {
    zip: "72519",
    ST: "AR",
    cityWithStateAbbr: "Calico Rock, AR",
  },
  {
    zip: "72520",
    ST: "AR",
    cityWithStateAbbr: "Camp, AR",
  },
  {
    zip: "72521",
    ST: "AR",
    cityWithStateAbbr: "Cave City, AR",
  },
  {
    zip: "72522",
    ST: "AR",
    cityWithStateAbbr: "Charlotte, AR",
  },
  {
    zip: "72523",
    ST: "AR",
    cityWithStateAbbr: "Concord, AR",
  },
  {
    zip: "72524",
    ST: "AR",
    cityWithStateAbbr: "Cord, AR",
  },
  {
    zip: "72525",
    ST: "AR",
    cityWithStateAbbr: "Cherokee Village, AR",
  },
  {
    zip: "72526",
    ST: "AR",
    cityWithStateAbbr: "Cushman, AR",
  },
  {
    zip: "72527",
    ST: "AR",
    cityWithStateAbbr: "Desha, AR",
  },
  {
    zip: "72528",
    ST: "AR",
    cityWithStateAbbr: "Dolph, AR",
  },
  {
    zip: "72529",
    ST: "AR",
    cityWithStateAbbr: "Cherokee Village, AR",
  },
  {
    zip: "72530",
    ST: "AR",
    cityWithStateAbbr: "Drasco, AR",
  },
  {
    zip: "72531",
    ST: "AR",
    cityWithStateAbbr: "Elizabeth, AR",
  },
  {
    zip: "72532",
    ST: "AR",
    cityWithStateAbbr: "Evening Shade, AR",
  },
  {
    zip: "72533",
    ST: "AR",
    cityWithStateAbbr: "Fifty Six, AR",
  },
  {
    zip: "72534",
    ST: "AR",
    cityWithStateAbbr: "Floral, AR",
  },
  {
    zip: "72536",
    ST: "AR",
    cityWithStateAbbr: "Franklin, AR",
  },
  {
    zip: "72537",
    ST: "AR",
    cityWithStateAbbr: "Gamaliel, AR",
  },
  {
    zip: "72538",
    ST: "AR",
    cityWithStateAbbr: "Gepp, AR",
  },
  {
    zip: "72539",
    ST: "AR",
    cityWithStateAbbr: "Glencoe, AR",
  },
  {
    zip: "72540",
    ST: "AR",
    cityWithStateAbbr: "Guion, AR",
  },
  {
    zip: "72542",
    ST: "AR",
    cityWithStateAbbr: "Hardy, AR",
  },
  {
    zip: "72543",
    ST: "AR",
    cityWithStateAbbr: "Heber Springs, AR",
  },
  {
    zip: "72544",
    ST: "AR",
    cityWithStateAbbr: "Henderson, AR",
  },
  {
    zip: "72545",
    ST: "AR",
    cityWithStateAbbr: "Heber Springs, AR",
  },
  {
    zip: "72546",
    ST: "AR",
    cityWithStateAbbr: "Ida, AR",
  },
  {
    zip: "72550",
    ST: "AR",
    cityWithStateAbbr: "Locust Grove, AR",
  },
  {
    zip: "72553",
    ST: "AR",
    cityWithStateAbbr: "Magness, AR",
  },
  {
    zip: "72554",
    ST: "AR",
    cityWithStateAbbr: "Mammoth Spring, AR",
  },
  {
    zip: "72555",
    ST: "AR",
    cityWithStateAbbr: "Marcella, AR",
  },
  {
    zip: "72556",
    ST: "AR",
    cityWithStateAbbr: "Melbourne, AR",
  },
  {
    zip: "72560",
    ST: "AR",
    cityWithStateAbbr: "Mountain View, AR",
  },
  {
    zip: "72561",
    ST: "AR",
    cityWithStateAbbr: "Mount Pleasant, AR",
  },
  {
    zip: "72562",
    ST: "AR",
    cityWithStateAbbr: "Newark, AR",
  },
  {
    zip: "72564",
    ST: "AR",
    cityWithStateAbbr: "Oil Trough, AR",
  },
  {
    zip: "72565",
    ST: "AR",
    cityWithStateAbbr: "Oxford, AR",
  },
  {
    zip: "72566",
    ST: "AR",
    cityWithStateAbbr: "Pineville, AR",
  },
  {
    zip: "72567",
    ST: "AR",
    cityWithStateAbbr: "Pleasant Grove, AR",
  },
  {
    zip: "72568",
    ST: "AR",
    cityWithStateAbbr: "Pleasant Plains, AR",
  },
  {
    zip: "72569",
    ST: "AR",
    cityWithStateAbbr: "Poughkeepsie, AR",
  },
  {
    zip: "72571",
    ST: "AR",
    cityWithStateAbbr: "Rosie, AR",
  },
  {
    zip: "72572",
    ST: "AR",
    cityWithStateAbbr: "Saffell, AR",
  },
  {
    zip: "72573",
    ST: "AR",
    cityWithStateAbbr: "Sage, AR",
  },
  {
    zip: "72575",
    ST: "AR",
    cityWithStateAbbr: "Salado, AR",
  },
  {
    zip: "72576",
    ST: "AR",
    cityWithStateAbbr: "Salem, AR",
  },
  {
    zip: "72577",
    ST: "AR",
    cityWithStateAbbr: "Sidney, AR",
  },
  {
    zip: "72578",
    ST: "AR",
    cityWithStateAbbr: "Sturkie, AR",
  },
  {
    zip: "72579",
    ST: "AR",
    cityWithStateAbbr: "Sulphur Rock, AR",
  },
  {
    zip: "72581",
    ST: "AR",
    cityWithStateAbbr: "Tumbling Shoals, AR",
  },
  {
    zip: "72583",
    ST: "AR",
    cityWithStateAbbr: "Viola, AR",
  },
  {
    zip: "72584",
    ST: "AR",
    cityWithStateAbbr: "Violet Hill, AR",
  },
  {
    zip: "72585",
    ST: "AR",
    cityWithStateAbbr: "Wideman, AR",
  },
  {
    zip: "72587",
    ST: "AR",
    cityWithStateAbbr: "Wiseman, AR",
  },
  {
    zip: "72601",
    ST: "AR",
    cityWithStateAbbr: "Harrison, AR",
  },
  {
    zip: "72602",
    ST: "AR",
    cityWithStateAbbr: "Harrison, AR",
  },
  {
    zip: "72611",
    ST: "AR",
    cityWithStateAbbr: "Alpena, AR",
  },
  {
    zip: "72613",
    ST: "AR",
    cityWithStateAbbr: "Beaver, AR",
  },
  {
    zip: "72615",
    ST: "AR",
    cityWithStateAbbr: "Bergman, AR",
  },
  {
    zip: "72616",
    ST: "AR",
    cityWithStateAbbr: "Berryville, AR",
  },
  {
    zip: "72617",
    ST: "AR",
    cityWithStateAbbr: "Big Flat, AR",
  },
  {
    zip: "72619",
    ST: "AR",
    cityWithStateAbbr: "Bull Shoals, AR",
  },
  {
    zip: "72623",
    ST: "AR",
    cityWithStateAbbr: "Clarkridge, AR",
  },
  {
    zip: "72624",
    ST: "AR",
    cityWithStateAbbr: "Compton, AR",
  },
  {
    zip: "72626",
    ST: "AR",
    cityWithStateAbbr: "Cotter, AR",
  },
  {
    zip: "72628",
    ST: "AR",
    cityWithStateAbbr: "Deer, AR",
  },
  {
    zip: "72629",
    ST: "AR",
    cityWithStateAbbr: "Dennard, AR",
  },
  {
    zip: "72630",
    ST: "AR",
    cityWithStateAbbr: "Diamond City, AR",
  },
  {
    zip: "72631",
    ST: "AR",
    cityWithStateAbbr: "Eureka Springs, AR",
  },
  {
    zip: "72632",
    ST: "AR",
    cityWithStateAbbr: "Eureka Springs, AR",
  },
  {
    zip: "72633",
    ST: "AR",
    cityWithStateAbbr: "Everton, AR",
  },
  {
    zip: "72634",
    ST: "AR",
    cityWithStateAbbr: "Flippin, AR",
  },
  {
    zip: "72635",
    ST: "AR",
    cityWithStateAbbr: "Gassville, AR",
  },
  {
    zip: "72636",
    ST: "AR",
    cityWithStateAbbr: "Gilbert, AR",
  },
  {
    zip: "72638",
    ST: "AR",
    cityWithStateAbbr: "Green Forest, AR",
  },
  {
    zip: "72639",
    ST: "AR",
    cityWithStateAbbr: "Harriet, AR",
  },
  {
    zip: "72640",
    ST: "AR",
    cityWithStateAbbr: "Hasty, AR",
  },
  {
    zip: "72641",
    ST: "AR",
    cityWithStateAbbr: "Jasper, AR",
  },
  {
    zip: "72642",
    ST: "AR",
    cityWithStateAbbr: "Lakeview, AR",
  },
  {
    zip: "72644",
    ST: "AR",
    cityWithStateAbbr: "Lead Hill, AR",
  },
  {
    zip: "72645",
    ST: "AR",
    cityWithStateAbbr: "Leslie, AR",
  },
  {
    zip: "72648",
    ST: "AR",
    cityWithStateAbbr: "Marble Falls, AR",
  },
  {
    zip: "72650",
    ST: "AR",
    cityWithStateAbbr: "Marshall, AR",
  },
  {
    zip: "72651",
    ST: "AR",
    cityWithStateAbbr: "Midway, AR",
  },
  {
    zip: "72653",
    ST: "AR",
    cityWithStateAbbr: "Mountain Home, AR",
  },
  {
    zip: "72654",
    ST: "AR",
    cityWithStateAbbr: "Mountain Home, AR",
  },
  {
    zip: "72655",
    ST: "AR",
    cityWithStateAbbr: "Mount Judea, AR",
  },
  {
    zip: "72657",
    ST: "AR",
    cityWithStateAbbr: "Timbo, AR",
  },
  {
    zip: "72658",
    ST: "AR",
    cityWithStateAbbr: "Norfork, AR",
  },
  {
    zip: "72659",
    ST: "AR",
    cityWithStateAbbr: "Norfork, AR",
  },
  {
    zip: "72660",
    ST: "AR",
    cityWithStateAbbr: "Oak Grove, AR",
  },
  {
    zip: "72661",
    ST: "AR",
    cityWithStateAbbr: "Oakland, AR",
  },
  {
    zip: "72662",
    ST: "AR",
    cityWithStateAbbr: "Omaha, AR",
  },
  {
    zip: "72663",
    ST: "AR",
    cityWithStateAbbr: "Onia, AR",
  },
  {
    zip: "72666",
    ST: "AR",
    cityWithStateAbbr: "Parthenon, AR",
  },
  {
    zip: "72668",
    ST: "AR",
    cityWithStateAbbr: "Peel, AR",
  },
  {
    zip: "72669",
    ST: "AR",
    cityWithStateAbbr: "Pindall, AR",
  },
  {
    zip: "72670",
    ST: "AR",
    cityWithStateAbbr: "Ponca, AR",
  },
  {
    zip: "72672",
    ST: "AR",
    cityWithStateAbbr: "Pyatt, AR",
  },
  {
    zip: "72675",
    ST: "AR",
    cityWithStateAbbr: "Saint Joe, AR",
  },
  {
    zip: "72677",
    ST: "AR",
    cityWithStateAbbr: "Summit, AR",
  },
  {
    zip: "72679",
    ST: "AR",
    cityWithStateAbbr: "Tilly, AR",
  },
  {
    zip: "72680",
    ST: "AR",
    cityWithStateAbbr: "Timbo, AR",
  },
  {
    zip: "72682",
    ST: "AR",
    cityWithStateAbbr: "Valley Springs, AR",
  },
  {
    zip: "72683",
    ST: "AR",
    cityWithStateAbbr: "Vendor, AR",
  },
  {
    zip: "72685",
    ST: "AR",
    cityWithStateAbbr: "Western Grove, AR",
  },
  {
    zip: "72686",
    ST: "AR",
    cityWithStateAbbr: "Witts Springs, AR",
  },
  {
    zip: "72687",
    ST: "AR",
    cityWithStateAbbr: "Yellville, AR",
  },
  {
    zip: "72701",
    ST: "AR",
    cityWithStateAbbr: "Fayetteville, AR",
  },
  {
    zip: "72702",
    ST: "AR",
    cityWithStateAbbr: "Fayetteville, AR",
  },
  {
    zip: "72703",
    ST: "AR",
    cityWithStateAbbr: "Fayetteville, AR",
  },
  {
    zip: "72704",
    ST: "AR",
    cityWithStateAbbr: "Fayetteville, AR",
  },
  {
    zip: "72711",
    ST: "AR",
    cityWithStateAbbr: "Avoca, AR",
  },
  {
    zip: "72712",
    ST: "AR",
    cityWithStateAbbr: "Bentonville, AR",
  },
  {
    zip: "72713",
    ST: "AR",
    cityWithStateAbbr: "Bentonville, AR",
  },
  {
    zip: "72714",
    ST: "AR",
    cityWithStateAbbr: "Bella Vista, AR",
  },
  {
    zip: "72715",
    ST: "AR",
    cityWithStateAbbr: "Bella Vista, AR",
  },
  {
    zip: "72716",
    ST: "AR",
    cityWithStateAbbr: "Bentonville, AR",
  },
  {
    zip: "72717",
    ST: "AR",
    cityWithStateAbbr: "Canehill, AR",
  },
  {
    zip: "72718",
    ST: "AR",
    cityWithStateAbbr: "Cave Springs, AR",
  },
  {
    zip: "72719",
    ST: "AR",
    cityWithStateAbbr: "Centerton, AR",
  },
  {
    zip: "72721",
    ST: "AR",
    cityWithStateAbbr: "Combs, AR",
  },
  {
    zip: "72722",
    ST: "AR",
    cityWithStateAbbr: "Decatur, AR",
  },
  {
    zip: "72727",
    ST: "AR",
    cityWithStateAbbr: "Elkins, AR",
  },
  {
    zip: "72728",
    ST: "AR",
    cityWithStateAbbr: "Elm Springs, AR",
  },
  {
    zip: "72729",
    ST: "AR",
    cityWithStateAbbr: "Evansville, AR",
  },
  {
    zip: "72730",
    ST: "AR",
    cityWithStateAbbr: "Farmington, AR",
  },
  {
    zip: "72732",
    ST: "AR",
    cityWithStateAbbr: "Garfield, AR",
  },
  {
    zip: "72733",
    ST: "AR",
    cityWithStateAbbr: "Gateway, AR",
  },
  {
    zip: "72734",
    ST: "AR",
    cityWithStateAbbr: "Gentry, AR",
  },
  {
    zip: "72735",
    ST: "AR",
    cityWithStateAbbr: "Goshen, AR",
  },
  {
    zip: "72736",
    ST: "AR",
    cityWithStateAbbr: "Gravette, AR",
  },
  {
    zip: "72737",
    ST: "AR",
    cityWithStateAbbr: "Greenland, AR",
  },
  {
    zip: "72738",
    ST: "AR",
    cityWithStateAbbr: "Hindsville, AR",
  },
  {
    zip: "72739",
    ST: "AR",
    cityWithStateAbbr: "Hiwasse, AR",
  },
  {
    zip: "72740",
    ST: "AR",
    cityWithStateAbbr: "Huntsville, AR",
  },
  {
    zip: "72741",
    ST: "AR",
    cityWithStateAbbr: "Johnson, AR",
  },
  {
    zip: "72742",
    ST: "AR",
    cityWithStateAbbr: "Kingston, AR",
  },
  {
    zip: "72744",
    ST: "AR",
    cityWithStateAbbr: "Lincoln, AR",
  },
  {
    zip: "72745",
    ST: "AR",
    cityWithStateAbbr: "Lowell, AR",
  },
  {
    zip: "72747",
    ST: "AR",
    cityWithStateAbbr: "Maysville, AR",
  },
  {
    zip: "72749",
    ST: "AR",
    cityWithStateAbbr: "Morrow, AR",
  },
  {
    zip: "72751",
    ST: "AR",
    cityWithStateAbbr: "Pea Ridge, AR",
  },
  {
    zip: "72752",
    ST: "AR",
    cityWithStateAbbr: "Pettigrew, AR",
  },
  {
    zip: "72753",
    ST: "AR",
    cityWithStateAbbr: "Prairie Grove, AR",
  },
  {
    zip: "72756",
    ST: "AR",
    cityWithStateAbbr: "Rogers, AR",
  },
  {
    zip: "72757",
    ST: "AR",
    cityWithStateAbbr: "Rogers, AR",
  },
  {
    zip: "72758",
    ST: "AR",
    cityWithStateAbbr: "Rogers, AR",
  },
  {
    zip: "72760",
    ST: "AR",
    cityWithStateAbbr: "Saint Paul, AR",
  },
  {
    zip: "72761",
    ST: "AR",
    cityWithStateAbbr: "Siloam Springs, AR",
  },
  {
    zip: "72762",
    ST: "AR",
    cityWithStateAbbr: "Springdale, AR",
  },
  {
    zip: "72764",
    ST: "AR",
    cityWithStateAbbr: "Springdale, AR",
  },
  {
    zip: "72765",
    ST: "AR",
    cityWithStateAbbr: "Springdale, AR",
  },
  {
    zip: "72766",
    ST: "AR",
    cityWithStateAbbr: "Springdale, AR",
  },
  {
    zip: "72768",
    ST: "AR",
    cityWithStateAbbr: "Sulphur Springs, AR",
  },
  {
    zip: "72769",
    ST: "AR",
    cityWithStateAbbr: "Summers, AR",
  },
  {
    zip: "72770",
    ST: "AR",
    cityWithStateAbbr: "Tontitown, AR",
  },
  {
    zip: "72773",
    ST: "AR",
    cityWithStateAbbr: "Wesley, AR",
  },
  {
    zip: "72774",
    ST: "AR",
    cityWithStateAbbr: "West Fork, AR",
  },
  {
    zip: "72776",
    ST: "AR",
    cityWithStateAbbr: "Witter, AR",
  },
  {
    zip: "72801",
    ST: "AR",
    cityWithStateAbbr: "Russellville, AR",
  },
  {
    zip: "72802",
    ST: "AR",
    cityWithStateAbbr: "Russellville, AR",
  },
  {
    zip: "72811",
    ST: "AR",
    cityWithStateAbbr: "Russellville, AR",
  },
  {
    zip: "72812",
    ST: "AR",
    cityWithStateAbbr: "Russellville, AR",
  },
  {
    zip: "72820",
    ST: "AR",
    cityWithStateAbbr: "Alix, AR",
  },
  {
    zip: "72821",
    ST: "AR",
    cityWithStateAbbr: "Altus, AR",
  },
  {
    zip: "72823",
    ST: "AR",
    cityWithStateAbbr: "Atkins, AR",
  },
  {
    zip: "72824",
    ST: "AR",
    cityWithStateAbbr: "Belleville, AR",
  },
  {
    zip: "72826",
    ST: "AR",
    cityWithStateAbbr: "Blue Mountain, AR",
  },
  {
    zip: "72827",
    ST: "AR",
    cityWithStateAbbr: "Bluffton, AR",
  },
  {
    zip: "72828",
    ST: "AR",
    cityWithStateAbbr: "Briggsville, AR",
  },
  {
    zip: "72829",
    ST: "AR",
    cityWithStateAbbr: "Centerville, AR",
  },
  {
    zip: "72830",
    ST: "AR",
    cityWithStateAbbr: "Clarksville, AR",
  },
  {
    zip: "72832",
    ST: "AR",
    cityWithStateAbbr: "Coal Hill, AR",
  },
  {
    zip: "72833",
    ST: "AR",
    cityWithStateAbbr: "Danville, AR",
  },
  {
    zip: "72834",
    ST: "AR",
    cityWithStateAbbr: "Dardanelle, AR",
  },
  {
    zip: "72835",
    ST: "AR",
    cityWithStateAbbr: "Delaware, AR",
  },
  {
    zip: "72837",
    ST: "AR",
    cityWithStateAbbr: "Dover, AR",
  },
  {
    zip: "72838",
    ST: "AR",
    cityWithStateAbbr: "Gravelly, AR",
  },
  {
    zip: "72839",
    ST: "AR",
    cityWithStateAbbr: "Hagarville, AR",
  },
  {
    zip: "72840",
    ST: "AR",
    cityWithStateAbbr: "Hartman, AR",
  },
  {
    zip: "72841",
    ST: "AR",
    cityWithStateAbbr: "Harvey, AR",
  },
  {
    zip: "72842",
    ST: "AR",
    cityWithStateAbbr: "Havana, AR",
  },
  {
    zip: "72843",
    ST: "AR",
    cityWithStateAbbr: "Hector, AR",
  },
  {
    zip: "72845",
    ST: "AR",
    cityWithStateAbbr: "Knoxville, AR",
  },
  {
    zip: "72846",
    ST: "AR",
    cityWithStateAbbr: "Lamar, AR",
  },
  {
    zip: "72847",
    ST: "AR",
    cityWithStateAbbr: "London, AR",
  },
  {
    zip: "72851",
    ST: "AR",
    cityWithStateAbbr: "New Blaine, AR",
  },
  {
    zip: "72852",
    ST: "AR",
    cityWithStateAbbr: "Oark, AR",
  },
  {
    zip: "72853",
    ST: "AR",
    cityWithStateAbbr: "Ola, AR",
  },
  {
    zip: "72854",
    ST: "AR",
    cityWithStateAbbr: "Ozone, AR",
  },
  {
    zip: "72855",
    ST: "AR",
    cityWithStateAbbr: "Paris, AR",
  },
  {
    zip: "72856",
    ST: "AR",
    cityWithStateAbbr: "Pelsor, AR",
  },
  {
    zip: "72857",
    ST: "AR",
    cityWithStateAbbr: "Plainview, AR",
  },
  {
    zip: "72858",
    ST: "AR",
    cityWithStateAbbr: "Pottsville, AR",
  },
  {
    zip: "72860",
    ST: "AR",
    cityWithStateAbbr: "Rover, AR",
  },
  {
    zip: "72863",
    ST: "AR",
    cityWithStateAbbr: "Scranton, AR",
  },
  {
    zip: "72865",
    ST: "AR",
    cityWithStateAbbr: "Subiaco, AR",
  },
  {
    zip: "72901",
    ST: "AR",
    cityWithStateAbbr: "Fort Smith, AR",
  },
  {
    zip: "72902",
    ST: "AR",
    cityWithStateAbbr: "Fort Smith, AR",
  },
  {
    zip: "72903",
    ST: "AR",
    cityWithStateAbbr: "Fort Smith, AR",
  },
  {
    zip: "72904",
    ST: "AR",
    cityWithStateAbbr: "Fort Smith, AR",
  },
  {
    zip: "72905",
    ST: "AR",
    cityWithStateAbbr: "Fort Smith, AR",
  },
  {
    zip: "72906",
    ST: "AR",
    cityWithStateAbbr: "Fort Smith, AR",
  },
  {
    zip: "72908",
    ST: "AR",
    cityWithStateAbbr: "Fort Smith, AR",
  },
  {
    zip: "72913",
    ST: "AR",
    cityWithStateAbbr: "Fort Smith, AR",
  },
  {
    zip: "72914",
    ST: "AR",
    cityWithStateAbbr: "Fort Smith, AR",
  },
  {
    zip: "72916",
    ST: "AR",
    cityWithStateAbbr: "Fort Smith, AR",
  },
  {
    zip: "72917",
    ST: "AR",
    cityWithStateAbbr: "Fort Smith, AR",
  },
  {
    zip: "72918",
    ST: "AR",
    cityWithStateAbbr: "Fort Smith, AR",
  },
  {
    zip: "72919",
    ST: "AR",
    cityWithStateAbbr: "Fort Smith, AR",
  },
  {
    zip: "72921",
    ST: "AR",
    cityWithStateAbbr: "Alma, AR",
  },
  {
    zip: "72923",
    ST: "AR",
    cityWithStateAbbr: "Barling, AR",
  },
  {
    zip: "72926",
    ST: "AR",
    cityWithStateAbbr: "Boles, AR",
  },
  {
    zip: "72927",
    ST: "AR",
    cityWithStateAbbr: "Booneville, AR",
  },
  {
    zip: "72928",
    ST: "AR",
    cityWithStateAbbr: "Branch, AR",
  },
  {
    zip: "72930",
    ST: "AR",
    cityWithStateAbbr: "Cecil, AR",
  },
  {
    zip: "72932",
    ST: "AR",
    cityWithStateAbbr: "Cedarville, AR",
  },
  {
    zip: "72933",
    ST: "AR",
    cityWithStateAbbr: "Charleston, AR",
  },
  {
    zip: "72934",
    ST: "AR",
    cityWithStateAbbr: "Chester, AR",
  },
  {
    zip: "72935",
    ST: "AR",
    cityWithStateAbbr: "Dyer, AR",
  },
  {
    zip: "72936",
    ST: "AR",
    cityWithStateAbbr: "Greenwood, AR",
  },
  {
    zip: "72937",
    ST: "AR",
    cityWithStateAbbr: "Hackett, AR",
  },
  {
    zip: "72938",
    ST: "AR",
    cityWithStateAbbr: "Hartford, AR",
  },
  {
    zip: "72940",
    ST: "AR",
    cityWithStateAbbr: "Huntington, AR",
  },
  {
    zip: "72941",
    ST: "AR",
    cityWithStateAbbr: "Lavaca, AR",
  },
  {
    zip: "72943",
    ST: "AR",
    cityWithStateAbbr: "Magazine, AR",
  },
  {
    zip: "72944",
    ST: "AR",
    cityWithStateAbbr: "Mansfield, AR",
  },
  {
    zip: "72945",
    ST: "AR",
    cityWithStateAbbr: "Midland, AR",
  },
  {
    zip: "72946",
    ST: "AR",
    cityWithStateAbbr: "Mountainburg, AR",
  },
  {
    zip: "72947",
    ST: "AR",
    cityWithStateAbbr: "Mulberry, AR",
  },
  {
    zip: "72948",
    ST: "AR",
    cityWithStateAbbr: "Natural Dam, AR",
  },
  {
    zip: "72949",
    ST: "AR",
    cityWithStateAbbr: "Ozark, AR",
  },
  {
    zip: "72950",
    ST: "AR",
    cityWithStateAbbr: "Parks, AR",
  },
  {
    zip: "72951",
    ST: "AR",
    cityWithStateAbbr: "Ratcliff, AR",
  },
  {
    zip: "72952",
    ST: "AR",
    cityWithStateAbbr: "Rudy, AR",
  },
  {
    zip: "72955",
    ST: "AR",
    cityWithStateAbbr: "Uniontown, AR",
  },
  {
    zip: "72956",
    ST: "AR",
    cityWithStateAbbr: "Van Buren, AR",
  },
  {
    zip: "72957",
    ST: "AR",
    cityWithStateAbbr: "Van Buren, AR",
  },
  {
    zip: "72958",
    ST: "AR",
    cityWithStateAbbr: "Waldron, AR",
  },
  {
    zip: "72959",
    ST: "AR",
    cityWithStateAbbr: "Winslow, AR",
  },
  {
    zip: "73001",
    ST: "OK",
    cityWithStateAbbr: "Albert, OK",
  },
  {
    zip: "73002",
    ST: "OK",
    cityWithStateAbbr: "Alex, OK",
  },
  {
    zip: "73003",
    ST: "OK",
    cityWithStateAbbr: "Edmond, OK",
  },
  {
    zip: "73004",
    ST: "OK",
    cityWithStateAbbr: "Amber, OK",
  },
  {
    zip: "73005",
    ST: "OK",
    cityWithStateAbbr: "Anadarko, OK",
  },
  {
    zip: "73006",
    ST: "OK",
    cityWithStateAbbr: "Apache, OK",
  },
  {
    zip: "73007",
    ST: "OK",
    cityWithStateAbbr: "Arcadia, OK",
  },
  {
    zip: "73008",
    ST: "OK",
    cityWithStateAbbr: "Bethany, OK",
  },
  {
    zip: "73009",
    ST: "OK",
    cityWithStateAbbr: "Binger, OK",
  },
  {
    zip: "73010",
    ST: "OK",
    cityWithStateAbbr: "Blanchard, OK",
  },
  {
    zip: "73011",
    ST: "OK",
    cityWithStateAbbr: "Bradley, OK",
  },
  {
    zip: "73012",
    ST: "OK",
    cityWithStateAbbr: "Edmond, OK",
  },
  {
    zip: "73013",
    ST: "OK",
    cityWithStateAbbr: "Edmond, OK",
  },
  {
    zip: "73014",
    ST: "OK",
    cityWithStateAbbr: "Calumet, OK",
  },
  {
    zip: "73015",
    ST: "OK",
    cityWithStateAbbr: "Carnegie, OK",
  },
  {
    zip: "73016",
    ST: "OK",
    cityWithStateAbbr: "Cashion, OK",
  },
  {
    zip: "73017",
    ST: "OK",
    cityWithStateAbbr: "Cement, OK",
  },
  {
    zip: "73018",
    ST: "OK",
    cityWithStateAbbr: "Chickasha, OK",
  },
  {
    zip: "73019",
    ST: "OK",
    cityWithStateAbbr: "Norman, OK",
  },
  {
    zip: "73020",
    ST: "OK",
    cityWithStateAbbr: "Choctaw, OK",
  },
  {
    zip: "73021",
    ST: "OK",
    cityWithStateAbbr: "Colony, OK",
  },
  {
    zip: "73022",
    ST: "OK",
    cityWithStateAbbr: "Concho, OK",
  },
  {
    zip: "73023",
    ST: "OK",
    cityWithStateAbbr: "Chickasha, OK",
  },
  {
    zip: "73024",
    ST: "OK",
    cityWithStateAbbr: "Corn, OK",
  },
  {
    zip: "73025",
    ST: "OK",
    cityWithStateAbbr: "Edmond, OK",
  },
  {
    zip: "73026",
    ST: "OK",
    cityWithStateAbbr: "Norman, OK",
  },
  {
    zip: "73027",
    ST: "OK",
    cityWithStateAbbr: "Coyle, OK",
  },
  {
    zip: "73028",
    ST: "OK",
    cityWithStateAbbr: "Crescent, OK",
  },
  {
    zip: "73029",
    ST: "OK",
    cityWithStateAbbr: "Cyril, OK",
  },
  {
    zip: "73030",
    ST: "OK",
    cityWithStateAbbr: "Davis, OK",
  },
  {
    zip: "73031",
    ST: "OK",
    cityWithStateAbbr: "Dibble, OK",
  },
  {
    zip: "73032",
    ST: "OK",
    cityWithStateAbbr: "Dougherty, OK",
  },
  {
    zip: "73033",
    ST: "OK",
    cityWithStateAbbr: "Eakly, OK",
  },
  {
    zip: "73034",
    ST: "OK",
    cityWithStateAbbr: "Edmond, OK",
  },
  {
    zip: "73036",
    ST: "OK",
    cityWithStateAbbr: "El Reno, OK",
  },
  {
    zip: "73038",
    ST: "OK",
    cityWithStateAbbr: "Fort Cobb, OK",
  },
  {
    zip: "73039",
    ST: "OK",
    cityWithStateAbbr: "Davis, OK",
  },
  {
    zip: "73040",
    ST: "OK",
    cityWithStateAbbr: "Geary, OK",
  },
  {
    zip: "73041",
    ST: "OK",
    cityWithStateAbbr: "Gotebo, OK",
  },
  {
    zip: "73042",
    ST: "OK",
    cityWithStateAbbr: "Gracemont, OK",
  },
  {
    zip: "73043",
    ST: "OK",
    cityWithStateAbbr: "Greenfield, OK",
  },
  {
    zip: "73044",
    ST: "OK",
    cityWithStateAbbr: "Guthrie, OK",
  },
  {
    zip: "73045",
    ST: "OK",
    cityWithStateAbbr: "Harrah, OK",
  },
  {
    zip: "73047",
    ST: "OK",
    cityWithStateAbbr: "Hinton, OK",
  },
  {
    zip: "73048",
    ST: "OK",
    cityWithStateAbbr: "Hydro, OK",
  },
  {
    zip: "73049",
    ST: "OK",
    cityWithStateAbbr: "Jones, OK",
  },
  {
    zip: "73050",
    ST: "OK",
    cityWithStateAbbr: "Langston, OK",
  },
  {
    zip: "73051",
    ST: "OK",
    cityWithStateAbbr: "Lexington, OK",
  },
  {
    zip: "73052",
    ST: "OK",
    cityWithStateAbbr: "Lindsay, OK",
  },
  {
    zip: "73053",
    ST: "OK",
    cityWithStateAbbr: "Lookeba, OK",
  },
  {
    zip: "73054",
    ST: "OK",
    cityWithStateAbbr: "Luther, OK",
  },
  {
    zip: "73055",
    ST: "OK",
    cityWithStateAbbr: "Marlow, OK",
  },
  {
    zip: "73056",
    ST: "OK",
    cityWithStateAbbr: "Marshall, OK",
  },
  {
    zip: "73057",
    ST: "OK",
    cityWithStateAbbr: "Maysville, OK",
  },
  {
    zip: "73058",
    ST: "OK",
    cityWithStateAbbr: "Meridian, OK",
  },
  {
    zip: "73059",
    ST: "OK",
    cityWithStateAbbr: "Minco, OK",
  },
  {
    zip: "73061",
    ST: "OK",
    cityWithStateAbbr: "Morrison, OK",
  },
  {
    zip: "73062",
    ST: "OK",
    cityWithStateAbbr: "Mountain View, OK",
  },
  {
    zip: "73063",
    ST: "OK",
    cityWithStateAbbr: "Mulhall, OK",
  },
  {
    zip: "73064",
    ST: "OK",
    cityWithStateAbbr: "Mustang, OK",
  },
  {
    zip: "73065",
    ST: "OK",
    cityWithStateAbbr: "Newcastle, OK",
  },
  {
    zip: "73066",
    ST: "OK",
    cityWithStateAbbr: "Nicoma Park, OK",
  },
  {
    zip: "73067",
    ST: "OK",
    cityWithStateAbbr: "Ninnekah, OK",
  },
  {
    zip: "73068",
    ST: "OK",
    cityWithStateAbbr: "Noble, OK",
  },
  {
    zip: "73069",
    ST: "OK",
    cityWithStateAbbr: "Norman, OK",
  },
  {
    zip: "73070",
    ST: "OK",
    cityWithStateAbbr: "Norman, OK",
  },
  {
    zip: "73071",
    ST: "OK",
    cityWithStateAbbr: "Norman, OK",
  },
  {
    zip: "73072",
    ST: "OK",
    cityWithStateAbbr: "Norman, OK",
  },
  {
    zip: "73073",
    ST: "OK",
    cityWithStateAbbr: "Orlando, OK",
  },
  {
    zip: "73074",
    ST: "OK",
    cityWithStateAbbr: "Paoli, OK",
  },
  {
    zip: "73075",
    ST: "OK",
    cityWithStateAbbr: "Pauls Valley, OK",
  },
  {
    zip: "73077",
    ST: "OK",
    cityWithStateAbbr: "Perry, OK",
  },
  {
    zip: "73078",
    ST: "OK",
    cityWithStateAbbr: "Piedmont, OK",
  },
  {
    zip: "73079",
    ST: "OK",
    cityWithStateAbbr: "Pocasset, OK",
  },
  {
    zip: "73080",
    ST: "OK",
    cityWithStateAbbr: "Purcell, OK",
  },
  {
    zip: "73082",
    ST: "OK",
    cityWithStateAbbr: "Rush Springs, OK",
  },
  {
    zip: "73083",
    ST: "OK",
    cityWithStateAbbr: "Edmond, OK",
  },
  {
    zip: "73084",
    ST: "OK",
    cityWithStateAbbr: "Spencer, OK",
  },
  {
    zip: "73085",
    ST: "OK",
    cityWithStateAbbr: "Yukon, OK",
  },
  {
    zip: "73086",
    ST: "OK",
    cityWithStateAbbr: "Sulphur, OK",
  },
  {
    zip: "73089",
    ST: "OK",
    cityWithStateAbbr: "Tuttle, OK",
  },
  {
    zip: "73090",
    ST: "OK",
    cityWithStateAbbr: "Union City, OK",
  },
  {
    zip: "73092",
    ST: "OK",
    cityWithStateAbbr: "Verden, OK",
  },
  {
    zip: "73093",
    ST: "OK",
    cityWithStateAbbr: "Washington, OK",
  },
  {
    zip: "73095",
    ST: "OK",
    cityWithStateAbbr: "Wayne, OK",
  },
  {
    zip: "73096",
    ST: "OK",
    cityWithStateAbbr: "Weatherford, OK",
  },
  {
    zip: "73097",
    ST: "OK",
    cityWithStateAbbr: "Wheatland, OK",
  },
  {
    zip: "73098",
    ST: "OK",
    cityWithStateAbbr: "Wynnewood, OK",
  },
  {
    zip: "73099",
    ST: "OK",
    cityWithStateAbbr: "Yukon, OK",
  },
  {
    zip: "73101",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73102",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73103",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73104",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73105",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73106",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73107",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73108",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73109",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73110",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73111",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73112",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73113",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73114",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73115",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73116",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73117",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73118",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73119",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73120",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73121",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73122",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73123",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73124",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73125",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73126",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73127",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73128",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73129",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73130",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73131",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73132",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73134",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73135",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73136",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73137",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73139",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73140",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73141",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73142",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73143",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73144",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73145",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73146",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73147",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73148",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73149",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73150",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73151",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73152",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73153",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73154",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73155",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73156",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73157",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73159",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73160",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73162",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73163",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73164",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73165",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73167",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73169",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73170",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73172",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73173",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73178",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73179",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73184",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73185",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73189",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73190",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73194",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73195",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73196",
    ST: "OK",
    cityWithStateAbbr: "Oklahoma City, OK",
  },
  {
    zip: "73301",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "73344",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "73401",
    ST: "OK",
    cityWithStateAbbr: "Ardmore, OK",
  },
  {
    zip: "73402",
    ST: "OK",
    cityWithStateAbbr: "Ardmore, OK",
  },
  {
    zip: "73403",
    ST: "OK",
    cityWithStateAbbr: "Ardmore, OK",
  },
  {
    zip: "73425",
    ST: "OK",
    cityWithStateAbbr: "Countyline, OK",
  },
  {
    zip: "73430",
    ST: "OK",
    cityWithStateAbbr: "Burneyville, OK",
  },
  {
    zip: "73432",
    ST: "OK",
    cityWithStateAbbr: "Coleman, OK",
  },
  {
    zip: "73433",
    ST: "OK",
    cityWithStateAbbr: "Elmore City, OK",
  },
  {
    zip: "73434",
    ST: "OK",
    cityWithStateAbbr: "Foster, OK",
  },
  {
    zip: "73435",
    ST: "OK",
    cityWithStateAbbr: "Fox, OK",
  },
  {
    zip: "73436",
    ST: "OK",
    cityWithStateAbbr: "Gene Autry, OK",
  },
  {
    zip: "73437",
    ST: "OK",
    cityWithStateAbbr: "Graham, OK",
  },
  {
    zip: "73438",
    ST: "OK",
    cityWithStateAbbr: "Healdton, OK",
  },
  {
    zip: "73439",
    ST: "OK",
    cityWithStateAbbr: "Kingston, OK",
  },
  {
    zip: "73440",
    ST: "OK",
    cityWithStateAbbr: "Lebanon, OK",
  },
  {
    zip: "73441",
    ST: "OK",
    cityWithStateAbbr: "Leon, OK",
  },
  {
    zip: "73442",
    ST: "OK",
    cityWithStateAbbr: "Loco, OK",
  },
  {
    zip: "73443",
    ST: "OK",
    cityWithStateAbbr: "Lone Grove, OK",
  },
  {
    zip: "73444",
    ST: "OK",
    cityWithStateAbbr: "Hennepin, OK",
  },
  {
    zip: "73446",
    ST: "OK",
    cityWithStateAbbr: "Madill, OK",
  },
  {
    zip: "73447",
    ST: "OK",
    cityWithStateAbbr: "Mannsville, OK",
  },
  {
    zip: "73448",
    ST: "OK",
    cityWithStateAbbr: "Marietta, OK",
  },
  {
    zip: "73449",
    ST: "OK",
    cityWithStateAbbr: "Mead, OK",
  },
  {
    zip: "73450",
    ST: "OK",
    cityWithStateAbbr: "Milburn, OK",
  },
  {
    zip: "73453",
    ST: "OK",
    cityWithStateAbbr: "Overbrook, OK",
  },
  {
    zip: "73455",
    ST: "OK",
    cityWithStateAbbr: "Ravia, OK",
  },
  {
    zip: "73456",
    ST: "OK",
    cityWithStateAbbr: "Ringling, OK",
  },
  {
    zip: "73458",
    ST: "OK",
    cityWithStateAbbr: "Springer, OK",
  },
  {
    zip: "73459",
    ST: "OK",
    cityWithStateAbbr: "Thackerville, OK",
  },
  {
    zip: "73460",
    ST: "OK",
    cityWithStateAbbr: "Tishomingo, OK",
  },
  {
    zip: "73461",
    ST: "OK",
    cityWithStateAbbr: "Wapanucka, OK",
  },
  {
    zip: "73463",
    ST: "OK",
    cityWithStateAbbr: "Wilson, OK",
  },
  {
    zip: "73481",
    ST: "OK",
    cityWithStateAbbr: "Ratliff City, OK",
  },
  {
    zip: "73487",
    ST: "OK",
    cityWithStateAbbr: "Tatums, OK",
  },
  {
    zip: "73488",
    ST: "OK",
    cityWithStateAbbr: "Tussy, OK",
  },
  {
    zip: "73491",
    ST: "OK",
    cityWithStateAbbr: "Velma, OK",
  },
  {
    zip: "73501",
    ST: "OK",
    cityWithStateAbbr: "Lawton, OK",
  },
  {
    zip: "73502",
    ST: "OK",
    cityWithStateAbbr: "Lawton, OK",
  },
  {
    zip: "73503",
    ST: "OK",
    cityWithStateAbbr: "Fort Sill, OK",
  },
  {
    zip: "73505",
    ST: "OK",
    cityWithStateAbbr: "Lawton, OK",
  },
  {
    zip: "73506",
    ST: "OK",
    cityWithStateAbbr: "Lawton, OK",
  },
  {
    zip: "73507",
    ST: "OK",
    cityWithStateAbbr: "Lawton, OK",
  },
  {
    zip: "73520",
    ST: "OK",
    cityWithStateAbbr: "Addington, OK",
  },
  {
    zip: "73521",
    ST: "OK",
    cityWithStateAbbr: "Altus, OK",
  },
  {
    zip: "73522",
    ST: "OK",
    cityWithStateAbbr: "Altus, OK",
  },
  {
    zip: "73523",
    ST: "OK",
    cityWithStateAbbr: "Altus Afb, OK",
  },
  {
    zip: "73526",
    ST: "OK",
    cityWithStateAbbr: "Blair, OK",
  },
  {
    zip: "73527",
    ST: "OK",
    cityWithStateAbbr: "Cache, OK",
  },
  {
    zip: "73528",
    ST: "OK",
    cityWithStateAbbr: "Chattanooga, OK",
  },
  {
    zip: "73529",
    ST: "OK",
    cityWithStateAbbr: "Comanche, OK",
  },
  {
    zip: "73530",
    ST: "OK",
    cityWithStateAbbr: "Davidson, OK",
  },
  {
    zip: "73531",
    ST: "OK",
    cityWithStateAbbr: "Devol, OK",
  },
  {
    zip: "73532",
    ST: "OK",
    cityWithStateAbbr: "Duke, OK",
  },
  {
    zip: "73533",
    ST: "OK",
    cityWithStateAbbr: "Duncan, OK",
  },
  {
    zip: "73534",
    ST: "OK",
    cityWithStateAbbr: "Duncan, OK",
  },
  {
    zip: "73536",
    ST: "OK",
    cityWithStateAbbr: "Duncan, OK",
  },
  {
    zip: "73537",
    ST: "OK",
    cityWithStateAbbr: "Eldorado, OK",
  },
  {
    zip: "73538",
    ST: "OK",
    cityWithStateAbbr: "Elgin, OK",
  },
  {
    zip: "73539",
    ST: "OK",
    cityWithStateAbbr: "Elmer, OK",
  },
  {
    zip: "73540",
    ST: "OK",
    cityWithStateAbbr: "Faxon, OK",
  },
  {
    zip: "73541",
    ST: "OK",
    cityWithStateAbbr: "Fletcher, OK",
  },
  {
    zip: "73542",
    ST: "OK",
    cityWithStateAbbr: "Frederick, OK",
  },
  {
    zip: "73543",
    ST: "OK",
    cityWithStateAbbr: "Geronimo, OK",
  },
  {
    zip: "73544",
    ST: "OK",
    cityWithStateAbbr: "Gould, OK",
  },
  {
    zip: "73546",
    ST: "OK",
    cityWithStateAbbr: "Grandfield, OK",
  },
  {
    zip: "73547",
    ST: "OK",
    cityWithStateAbbr: "Granite, OK",
  },
  {
    zip: "73548",
    ST: "OK",
    cityWithStateAbbr: "Hastings, OK",
  },
  {
    zip: "73549",
    ST: "OK",
    cityWithStateAbbr: "Headrick, OK",
  },
  {
    zip: "73550",
    ST: "OK",
    cityWithStateAbbr: "Hollis, OK",
  },
  {
    zip: "73551",
    ST: "OK",
    cityWithStateAbbr: "Hollister, OK",
  },
  {
    zip: "73552",
    ST: "OK",
    cityWithStateAbbr: "Indiahoma, OK",
  },
  {
    zip: "73553",
    ST: "OK",
    cityWithStateAbbr: "Loveland, OK",
  },
  {
    zip: "73554",
    ST: "OK",
    cityWithStateAbbr: "Mangum, OK",
  },
  {
    zip: "73555",
    ST: "OK",
    cityWithStateAbbr: "Manitou, OK",
  },
  {
    zip: "73556",
    ST: "OK",
    cityWithStateAbbr: "Martha, OK",
  },
  {
    zip: "73557",
    ST: "OK",
    cityWithStateAbbr: "Medicine Park, OK",
  },
  {
    zip: "73559",
    ST: "OK",
    cityWithStateAbbr: "Mountain Park, OK",
  },
  {
    zip: "73560",
    ST: "OK",
    cityWithStateAbbr: "Olustee, OK",
  },
  {
    zip: "73561",
    ST: "OK",
    cityWithStateAbbr: "Oscar, OK",
  },
  {
    zip: "73562",
    ST: "OK",
    cityWithStateAbbr: "Randlett, OK",
  },
  {
    zip: "73564",
    ST: "OK",
    cityWithStateAbbr: "Roosevelt, OK",
  },
  {
    zip: "73565",
    ST: "OK",
    cityWithStateAbbr: "Ryan, OK",
  },
  {
    zip: "73566",
    ST: "OK",
    cityWithStateAbbr: "Snyder, OK",
  },
  {
    zip: "73567",
    ST: "OK",
    cityWithStateAbbr: "Sterling, OK",
  },
  {
    zip: "73568",
    ST: "OK",
    cityWithStateAbbr: "Temple, OK",
  },
  {
    zip: "73569",
    ST: "OK",
    cityWithStateAbbr: "Terral, OK",
  },
  {
    zip: "73570",
    ST: "OK",
    cityWithStateAbbr: "Tipton, OK",
  },
  {
    zip: "73571",
    ST: "OK",
    cityWithStateAbbr: "Vinson, OK",
  },
  {
    zip: "73572",
    ST: "OK",
    cityWithStateAbbr: "Walters, OK",
  },
  {
    zip: "73573",
    ST: "OK",
    cityWithStateAbbr: "Waurika, OK",
  },
  {
    zip: "73601",
    ST: "OK",
    cityWithStateAbbr: "Clinton, OK",
  },
  {
    zip: "73620",
    ST: "OK",
    cityWithStateAbbr: "Arapaho, OK",
  },
  {
    zip: "73622",
    ST: "OK",
    cityWithStateAbbr: "Bessie, OK",
  },
  {
    zip: "73624",
    ST: "OK",
    cityWithStateAbbr: "Burns Flat, OK",
  },
  {
    zip: "73625",
    ST: "OK",
    cityWithStateAbbr: "Butler, OK",
  },
  {
    zip: "73626",
    ST: "OK",
    cityWithStateAbbr: "Canute, OK",
  },
  {
    zip: "73627",
    ST: "OK",
    cityWithStateAbbr: "Carter, OK",
  },
  {
    zip: "73628",
    ST: "OK",
    cityWithStateAbbr: "Cheyenne, OK",
  },
  {
    zip: "73632",
    ST: "OK",
    cityWithStateAbbr: "Cordell, OK",
  },
  {
    zip: "73638",
    ST: "OK",
    cityWithStateAbbr: "Crawford, OK",
  },
  {
    zip: "73639",
    ST: "OK",
    cityWithStateAbbr: "Custer City, OK",
  },
  {
    zip: "73641",
    ST: "OK",
    cityWithStateAbbr: "Dill City, OK",
  },
  {
    zip: "73642",
    ST: "OK",
    cityWithStateAbbr: "Durham, OK",
  },
  {
    zip: "73644",
    ST: "OK",
    cityWithStateAbbr: "Elk City, OK",
  },
  {
    zip: "73645",
    ST: "OK",
    cityWithStateAbbr: "Erick, OK",
  },
  {
    zip: "73646",
    ST: "OK",
    cityWithStateAbbr: "Fay, OK",
  },
  {
    zip: "73647",
    ST: "OK",
    cityWithStateAbbr: "Foss, OK",
  },
  {
    zip: "73648",
    ST: "OK",
    cityWithStateAbbr: "Elk City, OK",
  },
  {
    zip: "73650",
    ST: "OK",
    cityWithStateAbbr: "Hammon, OK",
  },
  {
    zip: "73651",
    ST: "OK",
    cityWithStateAbbr: "Hobart, OK",
  },
  {
    zip: "73654",
    ST: "OK",
    cityWithStateAbbr: "Leedey, OK",
  },
  {
    zip: "73655",
    ST: "OK",
    cityWithStateAbbr: "Lone Wolf, OK",
  },
  {
    zip: "73658",
    ST: "OK",
    cityWithStateAbbr: "Oakwood, OK",
  },
  {
    zip: "73659",
    ST: "OK",
    cityWithStateAbbr: "Putnam, OK",
  },
  {
    zip: "73660",
    ST: "OK",
    cityWithStateAbbr: "Reydon, OK",
  },
  {
    zip: "73661",
    ST: "OK",
    cityWithStateAbbr: "Rocky, OK",
  },
  {
    zip: "73662",
    ST: "OK",
    cityWithStateAbbr: "Sayre, OK",
  },
  {
    zip: "73663",
    ST: "OK",
    cityWithStateAbbr: "Seiling, OK",
  },
  {
    zip: "73664",
    ST: "OK",
    cityWithStateAbbr: "Sentinel, OK",
  },
  {
    zip: "73666",
    ST: "OK",
    cityWithStateAbbr: "Sweetwater, OK",
  },
  {
    zip: "73667",
    ST: "OK",
    cityWithStateAbbr: "Taloga, OK",
  },
  {
    zip: "73668",
    ST: "OK",
    cityWithStateAbbr: "Texola, OK",
  },
  {
    zip: "73669",
    ST: "OK",
    cityWithStateAbbr: "Thomas, OK",
  },
  {
    zip: "73673",
    ST: "OK",
    cityWithStateAbbr: "Willow, OK",
  },
  {
    zip: "73701",
    ST: "OK",
    cityWithStateAbbr: "Enid, OK",
  },
  {
    zip: "73702",
    ST: "OK",
    cityWithStateAbbr: "Enid, OK",
  },
  {
    zip: "73703",
    ST: "OK",
    cityWithStateAbbr: "Enid, OK",
  },
  {
    zip: "73705",
    ST: "OK",
    cityWithStateAbbr: "Enid, OK",
  },
  {
    zip: "73706",
    ST: "OK",
    cityWithStateAbbr: "Enid, OK",
  },
  {
    zip: "73716",
    ST: "OK",
    cityWithStateAbbr: "Aline, OK",
  },
  {
    zip: "73717",
    ST: "OK",
    cityWithStateAbbr: "Alva, OK",
  },
  {
    zip: "73718",
    ST: "OK",
    cityWithStateAbbr: "Ames, OK",
  },
  {
    zip: "73719",
    ST: "OK",
    cityWithStateAbbr: "Amorita, OK",
  },
  {
    zip: "73720",
    ST: "OK",
    cityWithStateAbbr: "Bison, OK",
  },
  {
    zip: "73722",
    ST: "OK",
    cityWithStateAbbr: "Burlington, OK",
  },
  {
    zip: "73724",
    ST: "OK",
    cityWithStateAbbr: "Canton, OK",
  },
  {
    zip: "73726",
    ST: "OK",
    cityWithStateAbbr: "Carmen, OK",
  },
  {
    zip: "73727",
    ST: "OK",
    cityWithStateAbbr: "Carrier, OK",
  },
  {
    zip: "73728",
    ST: "OK",
    cityWithStateAbbr: "Cherokee, OK",
  },
  {
    zip: "73729",
    ST: "OK",
    cityWithStateAbbr: "Cleo Springs, OK",
  },
  {
    zip: "73730",
    ST: "OK",
    cityWithStateAbbr: "Covington, OK",
  },
  {
    zip: "73731",
    ST: "OK",
    cityWithStateAbbr: "Dacoma, OK",
  },
  {
    zip: "73733",
    ST: "OK",
    cityWithStateAbbr: "Douglas, OK",
  },
  {
    zip: "73734",
    ST: "OK",
    cityWithStateAbbr: "Dover, OK",
  },
  {
    zip: "73735",
    ST: "OK",
    cityWithStateAbbr: "Drummond, OK",
  },
  {
    zip: "73736",
    ST: "OK",
    cityWithStateAbbr: "Fairmont, OK",
  },
  {
    zip: "73737",
    ST: "OK",
    cityWithStateAbbr: "Fairview, OK",
  },
  {
    zip: "73738",
    ST: "OK",
    cityWithStateAbbr: "Garber, OK",
  },
  {
    zip: "73739",
    ST: "OK",
    cityWithStateAbbr: "Goltry, OK",
  },
  {
    zip: "73741",
    ST: "OK",
    cityWithStateAbbr: "Helena, OK",
  },
  {
    zip: "73742",
    ST: "OK",
    cityWithStateAbbr: "Hennessey, OK",
  },
  {
    zip: "73743",
    ST: "OK",
    cityWithStateAbbr: "Hillsdale, OK",
  },
  {
    zip: "73744",
    ST: "OK",
    cityWithStateAbbr: "Hitchcock, OK",
  },
  {
    zip: "73746",
    ST: "OK",
    cityWithStateAbbr: "Hopeton, OK",
  },
  {
    zip: "73747",
    ST: "OK",
    cityWithStateAbbr: "Isabella, OK",
  },
  {
    zip: "73749",
    ST: "OK",
    cityWithStateAbbr: "Jet, OK",
  },
  {
    zip: "73750",
    ST: "OK",
    cityWithStateAbbr: "Kingfisher, OK",
  },
  {
    zip: "73753",
    ST: "OK",
    cityWithStateAbbr: "Kremlin, OK",
  },
  {
    zip: "73754",
    ST: "OK",
    cityWithStateAbbr: "Lahoma, OK",
  },
  {
    zip: "73755",
    ST: "OK",
    cityWithStateAbbr: "Longdale, OK",
  },
  {
    zip: "73756",
    ST: "OK",
    cityWithStateAbbr: "Loyal, OK",
  },
  {
    zip: "73757",
    ST: "OK",
    cityWithStateAbbr: "Lucien, OK",
  },
  {
    zip: "73758",
    ST: "OK",
    cityWithStateAbbr: "Manchester, OK",
  },
  {
    zip: "73759",
    ST: "OK",
    cityWithStateAbbr: "Medford, OK",
  },
  {
    zip: "73760",
    ST: "OK",
    cityWithStateAbbr: "Meno, OK",
  },
  {
    zip: "73761",
    ST: "OK",
    cityWithStateAbbr: "Nash, OK",
  },
  {
    zip: "73762",
    ST: "OK",
    cityWithStateAbbr: "Okarche, OK",
  },
  {
    zip: "73763",
    ST: "OK",
    cityWithStateAbbr: "Okeene, OK",
  },
  {
    zip: "73764",
    ST: "OK",
    cityWithStateAbbr: "Omega, OK",
  },
  {
    zip: "73766",
    ST: "OK",
    cityWithStateAbbr: "Pond Creek, OK",
  },
  {
    zip: "73768",
    ST: "OK",
    cityWithStateAbbr: "Ringwood, OK",
  },
  {
    zip: "73770",
    ST: "OK",
    cityWithStateAbbr: "Southard, OK",
  },
  {
    zip: "73771",
    ST: "OK",
    cityWithStateAbbr: "Wakita, OK",
  },
  {
    zip: "73772",
    ST: "OK",
    cityWithStateAbbr: "Watonga, OK",
  },
  {
    zip: "73773",
    ST: "OK",
    cityWithStateAbbr: "Waukomis, OK",
  },
  {
    zip: "73801",
    ST: "OK",
    cityWithStateAbbr: "Woodward, OK",
  },
  {
    zip: "73802",
    ST: "OK",
    cityWithStateAbbr: "Woodward, OK",
  },
  {
    zip: "73832",
    ST: "OK",
    cityWithStateAbbr: "Arnett, OK",
  },
  {
    zip: "73834",
    ST: "OK",
    cityWithStateAbbr: "Buffalo, OK",
  },
  {
    zip: "73835",
    ST: "OK",
    cityWithStateAbbr: "Camargo, OK",
  },
  {
    zip: "73838",
    ST: "OK",
    cityWithStateAbbr: "Chester, OK",
  },
  {
    zip: "73840",
    ST: "OK",
    cityWithStateAbbr: "Fargo, OK",
  },
  {
    zip: "73841",
    ST: "OK",
    cityWithStateAbbr: "Fort Supply, OK",
  },
  {
    zip: "73842",
    ST: "OK",
    cityWithStateAbbr: "Freedom, OK",
  },
  {
    zip: "73843",
    ST: "OK",
    cityWithStateAbbr: "Gage, OK",
  },
  {
    zip: "73844",
    ST: "OK",
    cityWithStateAbbr: "Gate, OK",
  },
  {
    zip: "73848",
    ST: "OK",
    cityWithStateAbbr: "Laverne, OK",
  },
  {
    zip: "73851",
    ST: "OK",
    cityWithStateAbbr: "May, OK",
  },
  {
    zip: "73852",
    ST: "OK",
    cityWithStateAbbr: "Mooreland, OK",
  },
  {
    zip: "73853",
    ST: "OK",
    cityWithStateAbbr: "Mutual, OK",
  },
  {
    zip: "73855",
    ST: "OK",
    cityWithStateAbbr: "Rosston, OK",
  },
  {
    zip: "73857",
    ST: "OK",
    cityWithStateAbbr: "Sharon, OK",
  },
  {
    zip: "73858",
    ST: "OK",
    cityWithStateAbbr: "Shattuck, OK",
  },
  {
    zip: "73859",
    ST: "OK",
    cityWithStateAbbr: "Vici, OK",
  },
  {
    zip: "73860",
    ST: "OK",
    cityWithStateAbbr: "Waynoka, OK",
  },
  {
    zip: "73901",
    ST: "OK",
    cityWithStateAbbr: "Adams, OK",
  },
  {
    zip: "73931",
    ST: "OK",
    cityWithStateAbbr: "Balko, OK",
  },
  {
    zip: "73932",
    ST: "OK",
    cityWithStateAbbr: "Beaver, OK",
  },
  {
    zip: "73933",
    ST: "OK",
    cityWithStateAbbr: "Boise City, OK",
  },
  {
    zip: "73937",
    ST: "OK",
    cityWithStateAbbr: "Felt, OK",
  },
  {
    zip: "73938",
    ST: "OK",
    cityWithStateAbbr: "Forgan, OK",
  },
  {
    zip: "73939",
    ST: "OK",
    cityWithStateAbbr: "Goodwell, OK",
  },
  {
    zip: "73942",
    ST: "OK",
    cityWithStateAbbr: "Guymon, OK",
  },
  {
    zip: "73944",
    ST: "OK",
    cityWithStateAbbr: "Hardesty, OK",
  },
  {
    zip: "73945",
    ST: "OK",
    cityWithStateAbbr: "Hooker, OK",
  },
  {
    zip: "73946",
    ST: "OK",
    cityWithStateAbbr: "Kenton, OK",
  },
  {
    zip: "73947",
    ST: "OK",
    cityWithStateAbbr: "Keyes, OK",
  },
  {
    zip: "73949",
    ST: "OK",
    cityWithStateAbbr: "Texhoma, OK",
  },
  {
    zip: "73950",
    ST: "OK",
    cityWithStateAbbr: "Turpin, OK",
  },
  {
    zip: "73951",
    ST: "OK",
    cityWithStateAbbr: "Tyrone, OK",
  },
  {
    zip: "73960",
    ST: "OK",
    cityWithStateAbbr: "Texhoma, OK",
  },
  {
    zip: "74001",
    ST: "OK",
    cityWithStateAbbr: "Avant, OK",
  },
  {
    zip: "74002",
    ST: "OK",
    cityWithStateAbbr: "Barnsdall, OK",
  },
  {
    zip: "74003",
    ST: "OK",
    cityWithStateAbbr: "Bartlesville, OK",
  },
  {
    zip: "74004",
    ST: "OK",
    cityWithStateAbbr: "Bartlesville, OK",
  },
  {
    zip: "74005",
    ST: "OK",
    cityWithStateAbbr: "Bartlesville, OK",
  },
  {
    zip: "74006",
    ST: "OK",
    cityWithStateAbbr: "Bartlesville, OK",
  },
  {
    zip: "74008",
    ST: "OK",
    cityWithStateAbbr: "Bixby, OK",
  },
  {
    zip: "74010",
    ST: "OK",
    cityWithStateAbbr: "Bristow, OK",
  },
  {
    zip: "74011",
    ST: "OK",
    cityWithStateAbbr: "Broken Arrow, OK",
  },
  {
    zip: "74012",
    ST: "OK",
    cityWithStateAbbr: "Broken Arrow, OK",
  },
  {
    zip: "74013",
    ST: "OK",
    cityWithStateAbbr: "Broken Arrow, OK",
  },
  {
    zip: "74014",
    ST: "OK",
    cityWithStateAbbr: "Broken Arrow, OK",
  },
  {
    zip: "74015",
    ST: "OK",
    cityWithStateAbbr: "Catoosa, OK",
  },
  {
    zip: "74016",
    ST: "OK",
    cityWithStateAbbr: "Chelsea, OK",
  },
  {
    zip: "74017",
    ST: "OK",
    cityWithStateAbbr: "Claremore, OK",
  },
  {
    zip: "74018",
    ST: "OK",
    cityWithStateAbbr: "Claremore, OK",
  },
  {
    zip: "74019",
    ST: "OK",
    cityWithStateAbbr: "Claremore, OK",
  },
  {
    zip: "74020",
    ST: "OK",
    cityWithStateAbbr: "Cleveland, OK",
  },
  {
    zip: "74021",
    ST: "OK",
    cityWithStateAbbr: "Collinsville, OK",
  },
  {
    zip: "74022",
    ST: "OK",
    cityWithStateAbbr: "Copan, OK",
  },
  {
    zip: "74023",
    ST: "OK",
    cityWithStateAbbr: "Cushing, OK",
  },
  {
    zip: "74026",
    ST: "OK",
    cityWithStateAbbr: "Davenport, OK",
  },
  {
    zip: "74027",
    ST: "OK",
    cityWithStateAbbr: "Delaware, OK",
  },
  {
    zip: "74028",
    ST: "OK",
    cityWithStateAbbr: "Depew, OK",
  },
  {
    zip: "74029",
    ST: "OK",
    cityWithStateAbbr: "Dewey, OK",
  },
  {
    zip: "74030",
    ST: "OK",
    cityWithStateAbbr: "Drumright, OK",
  },
  {
    zip: "74031",
    ST: "OK",
    cityWithStateAbbr: "Foyil, OK",
  },
  {
    zip: "74032",
    ST: "OK",
    cityWithStateAbbr: "Glencoe, OK",
  },
  {
    zip: "74033",
    ST: "OK",
    cityWithStateAbbr: "Glenpool, OK",
  },
  {
    zip: "74034",
    ST: "OK",
    cityWithStateAbbr: "Hallett, OK",
  },
  {
    zip: "74035",
    ST: "OK",
    cityWithStateAbbr: "Hominy, OK",
  },
  {
    zip: "74036",
    ST: "OK",
    cityWithStateAbbr: "Inola, OK",
  },
  {
    zip: "74037",
    ST: "OK",
    cityWithStateAbbr: "Jenks, OK",
  },
  {
    zip: "74038",
    ST: "OK",
    cityWithStateAbbr: "Jennings, OK",
  },
  {
    zip: "74039",
    ST: "OK",
    cityWithStateAbbr: "Kellyville, OK",
  },
  {
    zip: "74041",
    ST: "OK",
    cityWithStateAbbr: "Kiefer, OK",
  },
  {
    zip: "74042",
    ST: "OK",
    cityWithStateAbbr: "Lenapah, OK",
  },
  {
    zip: "74043",
    ST: "OK",
    cityWithStateAbbr: "Leonard, OK",
  },
  {
    zip: "74044",
    ST: "OK",
    cityWithStateAbbr: "Mannford, OK",
  },
  {
    zip: "74045",
    ST: "OK",
    cityWithStateAbbr: "Maramec, OK",
  },
  {
    zip: "74046",
    ST: "OK",
    cityWithStateAbbr: "Milfay, OK",
  },
  {
    zip: "74047",
    ST: "OK",
    cityWithStateAbbr: "Mounds, OK",
  },
  {
    zip: "74048",
    ST: "OK",
    cityWithStateAbbr: "Nowata, OK",
  },
  {
    zip: "74050",
    ST: "OK",
    cityWithStateAbbr: "Oakhurst, OK",
  },
  {
    zip: "74051",
    ST: "OK",
    cityWithStateAbbr: "Ochelata, OK",
  },
  {
    zip: "74052",
    ST: "OK",
    cityWithStateAbbr: "Oilton, OK",
  },
  {
    zip: "74053",
    ST: "OK",
    cityWithStateAbbr: "Oologah, OK",
  },
  {
    zip: "74054",
    ST: "OK",
    cityWithStateAbbr: "Osage, OK",
  },
  {
    zip: "74055",
    ST: "OK",
    cityWithStateAbbr: "Owasso, OK",
  },
  {
    zip: "74056",
    ST: "OK",
    cityWithStateAbbr: "Pawhuska, OK",
  },
  {
    zip: "74058",
    ST: "OK",
    cityWithStateAbbr: "Pawnee, OK",
  },
  {
    zip: "74059",
    ST: "OK",
    cityWithStateAbbr: "Perkins, OK",
  },
  {
    zip: "74060",
    ST: "OK",
    cityWithStateAbbr: "Prue, OK",
  },
  {
    zip: "74061",
    ST: "OK",
    cityWithStateAbbr: "Ramona, OK",
  },
  {
    zip: "74062",
    ST: "OK",
    cityWithStateAbbr: "Ripley, OK",
  },
  {
    zip: "74063",
    ST: "OK",
    cityWithStateAbbr: "Sand Springs, OK",
  },
  {
    zip: "74066",
    ST: "OK",
    cityWithStateAbbr: "Sapulpa, OK",
  },
  {
    zip: "74067",
    ST: "OK",
    cityWithStateAbbr: "Sapulpa, OK",
  },
  {
    zip: "74068",
    ST: "OK",
    cityWithStateAbbr: "Shamrock, OK",
  },
  {
    zip: "74070",
    ST: "OK",
    cityWithStateAbbr: "Skiatook, OK",
  },
  {
    zip: "74071",
    ST: "OK",
    cityWithStateAbbr: "Slick, OK",
  },
  {
    zip: "74072",
    ST: "OK",
    cityWithStateAbbr: "S Coffeyville, OK",
  },
  {
    zip: "74073",
    ST: "OK",
    cityWithStateAbbr: "Sperry, OK",
  },
  {
    zip: "74074",
    ST: "OK",
    cityWithStateAbbr: "Stillwater, OK",
  },
  {
    zip: "74075",
    ST: "OK",
    cityWithStateAbbr: "Stillwater, OK",
  },
  {
    zip: "74076",
    ST: "OK",
    cityWithStateAbbr: "Stillwater, OK",
  },
  {
    zip: "74077",
    ST: "OK",
    cityWithStateAbbr: "Stillwater, OK",
  },
  {
    zip: "74078",
    ST: "OK",
    cityWithStateAbbr: "Stillwater, OK",
  },
  {
    zip: "74079",
    ST: "OK",
    cityWithStateAbbr: "Stroud, OK",
  },
  {
    zip: "74080",
    ST: "OK",
    cityWithStateAbbr: "Talala, OK",
  },
  {
    zip: "74081",
    ST: "OK",
    cityWithStateAbbr: "Terlton, OK",
  },
  {
    zip: "74082",
    ST: "OK",
    cityWithStateAbbr: "Vera, OK",
  },
  {
    zip: "74083",
    ST: "OK",
    cityWithStateAbbr: "Wann, OK",
  },
  {
    zip: "74084",
    ST: "OK",
    cityWithStateAbbr: "Wynona, OK",
  },
  {
    zip: "74085",
    ST: "OK",
    cityWithStateAbbr: "Yale, OK",
  },
  {
    zip: "74101",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74102",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74103",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74104",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74105",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74106",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74107",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74108",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74110",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74112",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74114",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74115",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74116",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74117",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74119",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74120",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74121",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74126",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74127",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74128",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74129",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74130",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74131",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74132",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74133",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74134",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74135",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74136",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74137",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74141",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74145",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74146",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74147",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74148",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74149",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74150",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74152",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74153",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74155",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74156",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74157",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74158",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74159",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74169",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74170",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74171",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74172",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74182",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74186",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74187",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74192",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74193",
    ST: "OK",
    cityWithStateAbbr: "Tulsa, OK",
  },
  {
    zip: "74301",
    ST: "OK",
    cityWithStateAbbr: "Vinita, OK",
  },
  {
    zip: "74330",
    ST: "OK",
    cityWithStateAbbr: "Adair, OK",
  },
  {
    zip: "74331",
    ST: "OK",
    cityWithStateAbbr: "Afton, OK",
  },
  {
    zip: "74332",
    ST: "OK",
    cityWithStateAbbr: "Big Cabin, OK",
  },
  {
    zip: "74333",
    ST: "OK",
    cityWithStateAbbr: "Bluejacket, OK",
  },
  {
    zip: "74335",
    ST: "OK",
    cityWithStateAbbr: "Cardin, OK",
  },
  {
    zip: "74337",
    ST: "OK",
    cityWithStateAbbr: "Chouteau, OK",
  },
  {
    zip: "74338",
    ST: "OK",
    cityWithStateAbbr: "Colcord, OK",
  },
  {
    zip: "74339",
    ST: "OK",
    cityWithStateAbbr: "Commerce, OK",
  },
  {
    zip: "74340",
    ST: "OK",
    cityWithStateAbbr: "Disney, OK",
  },
  {
    zip: "74342",
    ST: "OK",
    cityWithStateAbbr: "Eucha, OK",
  },
  {
    zip: "74343",
    ST: "OK",
    cityWithStateAbbr: "Fairland, OK",
  },
  {
    zip: "74344",
    ST: "OK",
    cityWithStateAbbr: "Grove, OK",
  },
  {
    zip: "74345",
    ST: "OK",
    cityWithStateAbbr: "Grove, OK",
  },
  {
    zip: "74346",
    ST: "OK",
    cityWithStateAbbr: "Jay, OK",
  },
  {
    zip: "74347",
    ST: "OK",
    cityWithStateAbbr: "Kansas, OK",
  },
  {
    zip: "74349",
    ST: "OK",
    cityWithStateAbbr: "Ketchum, OK",
  },
  {
    zip: "74350",
    ST: "OK",
    cityWithStateAbbr: "Langley, OK",
  },
  {
    zip: "74352",
    ST: "OK",
    cityWithStateAbbr: "Locust Grove, OK",
  },
  {
    zip: "74354",
    ST: "OK",
    cityWithStateAbbr: "Miami, OK",
  },
  {
    zip: "74355",
    ST: "OK",
    cityWithStateAbbr: "Miami, OK",
  },
  {
    zip: "74358",
    ST: "OK",
    cityWithStateAbbr: "North Miami, OK",
  },
  {
    zip: "74359",
    ST: "OK",
    cityWithStateAbbr: "Oaks, OK",
  },
  {
    zip: "74360",
    ST: "OK",
    cityWithStateAbbr: "Picher, OK",
  },
  {
    zip: "74361",
    ST: "OK",
    cityWithStateAbbr: "Pryor, OK",
  },
  {
    zip: "74362",
    ST: "OK",
    cityWithStateAbbr: "Pryor, OK",
  },
  {
    zip: "74363",
    ST: "OK",
    cityWithStateAbbr: "Quapaw, OK",
  },
  {
    zip: "74364",
    ST: "OK",
    cityWithStateAbbr: "Rose, OK",
  },
  {
    zip: "74365",
    ST: "OK",
    cityWithStateAbbr: "Salina, OK",
  },
  {
    zip: "74366",
    ST: "OK",
    cityWithStateAbbr: "Spavinaw, OK",
  },
  {
    zip: "74367",
    ST: "OK",
    cityWithStateAbbr: "Strang, OK",
  },
  {
    zip: "74368",
    ST: "OK",
    cityWithStateAbbr: "Twin Oaks, OK",
  },
  {
    zip: "74369",
    ST: "OK",
    cityWithStateAbbr: "Welch, OK",
  },
  {
    zip: "74370",
    ST: "OK",
    cityWithStateAbbr: "Wyandotte, OK",
  },
  {
    zip: "74401",
    ST: "OK",
    cityWithStateAbbr: "Muskogee, OK",
  },
  {
    zip: "74402",
    ST: "OK",
    cityWithStateAbbr: "Muskogee, OK",
  },
  {
    zip: "74403",
    ST: "OK",
    cityWithStateAbbr: "Muskogee, OK",
  },
  {
    zip: "74421",
    ST: "OK",
    cityWithStateAbbr: "Beggs, OK",
  },
  {
    zip: "74422",
    ST: "OK",
    cityWithStateAbbr: "Boynton, OK",
  },
  {
    zip: "74423",
    ST: "OK",
    cityWithStateAbbr: "Braggs, OK",
  },
  {
    zip: "74425",
    ST: "OK",
    cityWithStateAbbr: "Canadian, OK",
  },
  {
    zip: "74426",
    ST: "OK",
    cityWithStateAbbr: "Checotah, OK",
  },
  {
    zip: "74427",
    ST: "OK",
    cityWithStateAbbr: "Cookson, OK",
  },
  {
    zip: "74428",
    ST: "OK",
    cityWithStateAbbr: "Council Hill, OK",
  },
  {
    zip: "74429",
    ST: "OK",
    cityWithStateAbbr: "Coweta, OK",
  },
  {
    zip: "74430",
    ST: "OK",
    cityWithStateAbbr: "Crowder, OK",
  },
  {
    zip: "74431",
    ST: "OK",
    cityWithStateAbbr: "Dewar, OK",
  },
  {
    zip: "74432",
    ST: "OK",
    cityWithStateAbbr: "Eufaula, OK",
  },
  {
    zip: "74434",
    ST: "OK",
    cityWithStateAbbr: "Fort Gibson, OK",
  },
  {
    zip: "74435",
    ST: "OK",
    cityWithStateAbbr: "Gore, OK",
  },
  {
    zip: "74436",
    ST: "OK",
    cityWithStateAbbr: "Haskell, OK",
  },
  {
    zip: "74437",
    ST: "OK",
    cityWithStateAbbr: "Henryetta, OK",
  },
  {
    zip: "74438",
    ST: "OK",
    cityWithStateAbbr: "Hitchita, OK",
  },
  {
    zip: "74439",
    ST: "OK",
    cityWithStateAbbr: "Braggs, OK",
  },
  {
    zip: "74440",
    ST: "OK",
    cityWithStateAbbr: "Hoyt, OK",
  },
  {
    zip: "74441",
    ST: "OK",
    cityWithStateAbbr: "Hulbert, OK",
  },
  {
    zip: "74442",
    ST: "OK",
    cityWithStateAbbr: "Indianola, OK",
  },
  {
    zip: "74444",
    ST: "OK",
    cityWithStateAbbr: "Moodys, OK",
  },
  {
    zip: "74445",
    ST: "OK",
    cityWithStateAbbr: "Morris, OK",
  },
  {
    zip: "74446",
    ST: "OK",
    cityWithStateAbbr: "Okay, OK",
  },
  {
    zip: "74447",
    ST: "OK",
    cityWithStateAbbr: "Okmulgee, OK",
  },
  {
    zip: "74450",
    ST: "OK",
    cityWithStateAbbr: "Oktaha, OK",
  },
  {
    zip: "74451",
    ST: "OK",
    cityWithStateAbbr: "Park Hill, OK",
  },
  {
    zip: "74452",
    ST: "OK",
    cityWithStateAbbr: "Peggs, OK",
  },
  {
    zip: "74454",
    ST: "OK",
    cityWithStateAbbr: "Porter, OK",
  },
  {
    zip: "74455",
    ST: "OK",
    cityWithStateAbbr: "Porum, OK",
  },
  {
    zip: "74456",
    ST: "OK",
    cityWithStateAbbr: "Preston, OK",
  },
  {
    zip: "74457",
    ST: "OK",
    cityWithStateAbbr: "Proctor, OK",
  },
  {
    zip: "74458",
    ST: "OK",
    cityWithStateAbbr: "Redbird, OK",
  },
  {
    zip: "74459",
    ST: "OK",
    cityWithStateAbbr: "Rentiesville, OK",
  },
  {
    zip: "74460",
    ST: "OK",
    cityWithStateAbbr: "Schulter, OK",
  },
  {
    zip: "74461",
    ST: "OK",
    cityWithStateAbbr: "Stidham, OK",
  },
  {
    zip: "74462",
    ST: "OK",
    cityWithStateAbbr: "Stigler, OK",
  },
  {
    zip: "74463",
    ST: "OK",
    cityWithStateAbbr: "Taft, OK",
  },
  {
    zip: "74464",
    ST: "OK",
    cityWithStateAbbr: "Tahlequah, OK",
  },
  {
    zip: "74465",
    ST: "OK",
    cityWithStateAbbr: "Tahlequah, OK",
  },
  {
    zip: "74467",
    ST: "OK",
    cityWithStateAbbr: "Wagoner, OK",
  },
  {
    zip: "74468",
    ST: "OK",
    cityWithStateAbbr: "Wainwright, OK",
  },
  {
    zip: "74469",
    ST: "OK",
    cityWithStateAbbr: "Warner, OK",
  },
  {
    zip: "74470",
    ST: "OK",
    cityWithStateAbbr: "Webbers Falls, OK",
  },
  {
    zip: "74471",
    ST: "OK",
    cityWithStateAbbr: "Welling, OK",
  },
  {
    zip: "74472",
    ST: "OK",
    cityWithStateAbbr: "Whitefield, OK",
  },
  {
    zip: "74477",
    ST: "OK",
    cityWithStateAbbr: "Wagoner, OK",
  },
  {
    zip: "74501",
    ST: "OK",
    cityWithStateAbbr: "Mcalester, OK",
  },
  {
    zip: "74502",
    ST: "OK",
    cityWithStateAbbr: "Mcalester, OK",
  },
  {
    zip: "74521",
    ST: "OK",
    cityWithStateAbbr: "Albion, OK",
  },
  {
    zip: "74522",
    ST: "OK",
    cityWithStateAbbr: "Alderson, OK",
  },
  {
    zip: "74523",
    ST: "OK",
    cityWithStateAbbr: "Antlers, OK",
  },
  {
    zip: "74525",
    ST: "OK",
    cityWithStateAbbr: "Atoka, OK",
  },
  {
    zip: "74528",
    ST: "OK",
    cityWithStateAbbr: "Blanco, OK",
  },
  {
    zip: "74529",
    ST: "OK",
    cityWithStateAbbr: "Blocker, OK",
  },
  {
    zip: "74530",
    ST: "OK",
    cityWithStateAbbr: "Bromide, OK",
  },
  {
    zip: "74531",
    ST: "OK",
    cityWithStateAbbr: "Calvin, OK",
  },
  {
    zip: "74533",
    ST: "OK",
    cityWithStateAbbr: "Caney, OK",
  },
  {
    zip: "74534",
    ST: "OK",
    cityWithStateAbbr: "Centrahoma, OK",
  },
  {
    zip: "74535",
    ST: "OK",
    cityWithStateAbbr: "Clarita, OK",
  },
  {
    zip: "74536",
    ST: "OK",
    cityWithStateAbbr: "Clayton, OK",
  },
  {
    zip: "74538",
    ST: "OK",
    cityWithStateAbbr: "Coalgate, OK",
  },
  {
    zip: "74540",
    ST: "OK",
    cityWithStateAbbr: "Daisy, OK",
  },
  {
    zip: "74543",
    ST: "OK",
    cityWithStateAbbr: "Finley, OK",
  },
  {
    zip: "74545",
    ST: "OK",
    cityWithStateAbbr: "Gowen, OK",
  },
  {
    zip: "74546",
    ST: "OK",
    cityWithStateAbbr: "Haileyville, OK",
  },
  {
    zip: "74547",
    ST: "OK",
    cityWithStateAbbr: "Hartshorne, OK",
  },
  {
    zip: "74549",
    ST: "OK",
    cityWithStateAbbr: "Honobia, OK",
  },
  {
    zip: "74552",
    ST: "OK",
    cityWithStateAbbr: "Kinta, OK",
  },
  {
    zip: "74553",
    ST: "OK",
    cityWithStateAbbr: "Kiowa, OK",
  },
  {
    zip: "74554",
    ST: "OK",
    cityWithStateAbbr: "Krebs, OK",
  },
  {
    zip: "74555",
    ST: "OK",
    cityWithStateAbbr: "Lane, OK",
  },
  {
    zip: "74556",
    ST: "OK",
    cityWithStateAbbr: "Lehigh, OK",
  },
  {
    zip: "74557",
    ST: "OK",
    cityWithStateAbbr: "Moyers, OK",
  },
  {
    zip: "74558",
    ST: "OK",
    cityWithStateAbbr: "Nashoba, OK",
  },
  {
    zip: "74559",
    ST: "OK",
    cityWithStateAbbr: "Panola, OK",
  },
  {
    zip: "74560",
    ST: "OK",
    cityWithStateAbbr: "Pittsburg, OK",
  },
  {
    zip: "74561",
    ST: "OK",
    cityWithStateAbbr: "Quinton, OK",
  },
  {
    zip: "74562",
    ST: "OK",
    cityWithStateAbbr: "Rattan, OK",
  },
  {
    zip: "74563",
    ST: "OK",
    cityWithStateAbbr: "Red Oak, OK",
  },
  {
    zip: "74565",
    ST: "OK",
    cityWithStateAbbr: "Savanna, OK",
  },
  {
    zip: "74567",
    ST: "OK",
    cityWithStateAbbr: "Snow, OK",
  },
  {
    zip: "74569",
    ST: "OK",
    cityWithStateAbbr: "Stringtown, OK",
  },
  {
    zip: "74570",
    ST: "OK",
    cityWithStateAbbr: "Stuart, OK",
  },
  {
    zip: "74571",
    ST: "OK",
    cityWithStateAbbr: "Talihina, OK",
  },
  {
    zip: "74572",
    ST: "OK",
    cityWithStateAbbr: "Tupelo, OK",
  },
  {
    zip: "74574",
    ST: "OK",
    cityWithStateAbbr: "Tuskahoma, OK",
  },
  {
    zip: "74576",
    ST: "OK",
    cityWithStateAbbr: "Wardville, OK",
  },
  {
    zip: "74577",
    ST: "OK",
    cityWithStateAbbr: "Whitesboro, OK",
  },
  {
    zip: "74578",
    ST: "OK",
    cityWithStateAbbr: "Wilburton, OK",
  },
  {
    zip: "74601",
    ST: "OK",
    cityWithStateAbbr: "Ponca City, OK",
  },
  {
    zip: "74602",
    ST: "OK",
    cityWithStateAbbr: "Ponca City, OK",
  },
  {
    zip: "74604",
    ST: "OK",
    cityWithStateAbbr: "Ponca City, OK",
  },
  {
    zip: "74630",
    ST: "OK",
    cityWithStateAbbr: "Billings, OK",
  },
  {
    zip: "74631",
    ST: "OK",
    cityWithStateAbbr: "Blackwell, OK",
  },
  {
    zip: "74632",
    ST: "OK",
    cityWithStateAbbr: "Braman, OK",
  },
  {
    zip: "74633",
    ST: "OK",
    cityWithStateAbbr: "Burbank, OK",
  },
  {
    zip: "74636",
    ST: "OK",
    cityWithStateAbbr: "Deer Creek, OK",
  },
  {
    zip: "74637",
    ST: "OK",
    cityWithStateAbbr: "Fairfax, OK",
  },
  {
    zip: "74640",
    ST: "OK",
    cityWithStateAbbr: "Hunter, OK",
  },
  {
    zip: "74641",
    ST: "OK",
    cityWithStateAbbr: "Kaw City, OK",
  },
  {
    zip: "74643",
    ST: "OK",
    cityWithStateAbbr: "Lamont, OK",
  },
  {
    zip: "74644",
    ST: "OK",
    cityWithStateAbbr: "Marland, OK",
  },
  {
    zip: "74646",
    ST: "OK",
    cityWithStateAbbr: "Nardin, OK",
  },
  {
    zip: "74647",
    ST: "OK",
    cityWithStateAbbr: "Newkirk, OK",
  },
  {
    zip: "74650",
    ST: "OK",
    cityWithStateAbbr: "Ralston, OK",
  },
  {
    zip: "74651",
    ST: "OK",
    cityWithStateAbbr: "Red Rock, OK",
  },
  {
    zip: "74652",
    ST: "OK",
    cityWithStateAbbr: "Shidler, OK",
  },
  {
    zip: "74653",
    ST: "OK",
    cityWithStateAbbr: "Tonkawa, OK",
  },
  {
    zip: "74701",
    ST: "OK",
    cityWithStateAbbr: "Durant, OK",
  },
  {
    zip: "74702",
    ST: "OK",
    cityWithStateAbbr: "Durant, OK",
  },
  {
    zip: "74720",
    ST: "OK",
    cityWithStateAbbr: "Achille, OK",
  },
  {
    zip: "74721",
    ST: "OK",
    cityWithStateAbbr: "Albany, OK",
  },
  {
    zip: "74722",
    ST: "OK",
    cityWithStateAbbr: "Battiest, OK",
  },
  {
    zip: "74723",
    ST: "OK",
    cityWithStateAbbr: "Bennington, OK",
  },
  {
    zip: "74724",
    ST: "OK",
    cityWithStateAbbr: "Bethel, OK",
  },
  {
    zip: "74726",
    ST: "OK",
    cityWithStateAbbr: "Bokchito, OK",
  },
  {
    zip: "74727",
    ST: "OK",
    cityWithStateAbbr: "Boswell, OK",
  },
  {
    zip: "74728",
    ST: "OK",
    cityWithStateAbbr: "Broken Bow, OK",
  },
  {
    zip: "74729",
    ST: "OK",
    cityWithStateAbbr: "Caddo, OK",
  },
  {
    zip: "74730",
    ST: "OK",
    cityWithStateAbbr: "Calera, OK",
  },
  {
    zip: "74731",
    ST: "OK",
    cityWithStateAbbr: "Cartwright, OK",
  },
  {
    zip: "74733",
    ST: "OK",
    cityWithStateAbbr: "Colbert, OK",
  },
  {
    zip: "74734",
    ST: "OK",
    cityWithStateAbbr: "Eagletown, OK",
  },
  {
    zip: "74735",
    ST: "OK",
    cityWithStateAbbr: "Fort Towson, OK",
  },
  {
    zip: "74736",
    ST: "OK",
    cityWithStateAbbr: "Garvin, OK",
  },
  {
    zip: "74737",
    ST: "OK",
    cityWithStateAbbr: "Golden, OK",
  },
  {
    zip: "74738",
    ST: "OK",
    cityWithStateAbbr: "Grant, OK",
  },
  {
    zip: "74740",
    ST: "OK",
    cityWithStateAbbr: "Haworth, OK",
  },
  {
    zip: "74741",
    ST: "OK",
    cityWithStateAbbr: "Hendrix, OK",
  },
  {
    zip: "74743",
    ST: "OK",
    cityWithStateAbbr: "Hugo, OK",
  },
  {
    zip: "74745",
    ST: "OK",
    cityWithStateAbbr: "Idabel, OK",
  },
  {
    zip: "74747",
    ST: "OK",
    cityWithStateAbbr: "Kemp, OK",
  },
  {
    zip: "74748",
    ST: "OK",
    cityWithStateAbbr: "Kenefic, OK",
  },
  {
    zip: "74750",
    ST: "OK",
    cityWithStateAbbr: "Millerton, OK",
  },
  {
    zip: "74752",
    ST: "OK",
    cityWithStateAbbr: "Pickens, OK",
  },
  {
    zip: "74753",
    ST: "OK",
    cityWithStateAbbr: "Platter, OK",
  },
  {
    zip: "74754",
    ST: "OK",
    cityWithStateAbbr: "Ringold, OK",
  },
  {
    zip: "74755",
    ST: "OK",
    cityWithStateAbbr: "Rufe, OK",
  },
  {
    zip: "74756",
    ST: "OK",
    cityWithStateAbbr: "Sawyer, OK",
  },
  {
    zip: "74759",
    ST: "OK",
    cityWithStateAbbr: "Soper, OK",
  },
  {
    zip: "74760",
    ST: "OK",
    cityWithStateAbbr: "Spencerville, OK",
  },
  {
    zip: "74761",
    ST: "OK",
    cityWithStateAbbr: "Swink, OK",
  },
  {
    zip: "74764",
    ST: "OK",
    cityWithStateAbbr: "Valliant, OK",
  },
  {
    zip: "74766",
    ST: "OK",
    cityWithStateAbbr: "Wright City, OK",
  },
  {
    zip: "74801",
    ST: "OK",
    cityWithStateAbbr: "Shawnee, OK",
  },
  {
    zip: "74802",
    ST: "OK",
    cityWithStateAbbr: "Shawnee, OK",
  },
  {
    zip: "74804",
    ST: "OK",
    cityWithStateAbbr: "Shawnee, OK",
  },
  {
    zip: "74818",
    ST: "OK",
    cityWithStateAbbr: "Seminole, OK",
  },
  {
    zip: "74820",
    ST: "OK",
    cityWithStateAbbr: "Ada, OK",
  },
  {
    zip: "74821",
    ST: "OK",
    cityWithStateAbbr: "Ada, OK",
  },
  {
    zip: "74824",
    ST: "OK",
    cityWithStateAbbr: "Agra, OK",
  },
  {
    zip: "74825",
    ST: "OK",
    cityWithStateAbbr: "Allen, OK",
  },
  {
    zip: "74826",
    ST: "OK",
    cityWithStateAbbr: "Asher, OK",
  },
  {
    zip: "74827",
    ST: "OK",
    cityWithStateAbbr: "Atwood, OK",
  },
  {
    zip: "74829",
    ST: "OK",
    cityWithStateAbbr: "Boley, OK",
  },
  {
    zip: "74830",
    ST: "OK",
    cityWithStateAbbr: "Bowlegs, OK",
  },
  {
    zip: "74831",
    ST: "OK",
    cityWithStateAbbr: "Byars, OK",
  },
  {
    zip: "74832",
    ST: "OK",
    cityWithStateAbbr: "Carney, OK",
  },
  {
    zip: "74833",
    ST: "OK",
    cityWithStateAbbr: "Castle, OK",
  },
  {
    zip: "74834",
    ST: "OK",
    cityWithStateAbbr: "Chandler, OK",
  },
  {
    zip: "74836",
    ST: "OK",
    cityWithStateAbbr: "Connerville, OK",
  },
  {
    zip: "74837",
    ST: "OK",
    cityWithStateAbbr: "Cromwell, OK",
  },
  {
    zip: "74839",
    ST: "OK",
    cityWithStateAbbr: "Dustin, OK",
  },
  {
    zip: "74840",
    ST: "OK",
    cityWithStateAbbr: "Earlsboro, OK",
  },
  {
    zip: "74842",
    ST: "OK",
    cityWithStateAbbr: "Fittstown, OK",
  },
  {
    zip: "74843",
    ST: "OK",
    cityWithStateAbbr: "Fitzhugh, OK",
  },
  {
    zip: "74844",
    ST: "OK",
    cityWithStateAbbr: "Francis, OK",
  },
  {
    zip: "74845",
    ST: "OK",
    cityWithStateAbbr: "Hanna, OK",
  },
  {
    zip: "74848",
    ST: "OK",
    cityWithStateAbbr: "Holdenville, OK",
  },
  {
    zip: "74849",
    ST: "OK",
    cityWithStateAbbr: "Konawa, OK",
  },
  {
    zip: "74850",
    ST: "OK",
    cityWithStateAbbr: "Lamar, OK",
  },
  {
    zip: "74851",
    ST: "OK",
    cityWithStateAbbr: "Mcloud, OK",
  },
  {
    zip: "74852",
    ST: "OK",
    cityWithStateAbbr: "Macomb, OK",
  },
  {
    zip: "74854",
    ST: "OK",
    cityWithStateAbbr: "Maud, OK",
  },
  {
    zip: "74855",
    ST: "OK",
    cityWithStateAbbr: "Meeker, OK",
  },
  {
    zip: "74856",
    ST: "OK",
    cityWithStateAbbr: "Mill Creek, OK",
  },
  {
    zip: "74857",
    ST: "OK",
    cityWithStateAbbr: "Newalla, OK",
  },
  {
    zip: "74859",
    ST: "OK",
    cityWithStateAbbr: "Okemah, OK",
  },
  {
    zip: "74860",
    ST: "OK",
    cityWithStateAbbr: "Paden, OK",
  },
  {
    zip: "74864",
    ST: "OK",
    cityWithStateAbbr: "Prague, OK",
  },
  {
    zip: "74865",
    ST: "OK",
    cityWithStateAbbr: "Roff, OK",
  },
  {
    zip: "74866",
    ST: "OK",
    cityWithStateAbbr: "Saint Louis, OK",
  },
  {
    zip: "74867",
    ST: "OK",
    cityWithStateAbbr: "Sasakwa, OK",
  },
  {
    zip: "74868",
    ST: "OK",
    cityWithStateAbbr: "Seminole, OK",
  },
  {
    zip: "74869",
    ST: "OK",
    cityWithStateAbbr: "Sparks, OK",
  },
  {
    zip: "74871",
    ST: "OK",
    cityWithStateAbbr: "Stonewall, OK",
  },
  {
    zip: "74872",
    ST: "OK",
    cityWithStateAbbr: "Stratford, OK",
  },
  {
    zip: "74873",
    ST: "OK",
    cityWithStateAbbr: "Tecumseh, OK",
  },
  {
    zip: "74875",
    ST: "OK",
    cityWithStateAbbr: "Tryon, OK",
  },
  {
    zip: "74878",
    ST: "OK",
    cityWithStateAbbr: "Wanette, OK",
  },
  {
    zip: "74880",
    ST: "OK",
    cityWithStateAbbr: "Weleetka, OK",
  },
  {
    zip: "74881",
    ST: "OK",
    cityWithStateAbbr: "Wellston, OK",
  },
  {
    zip: "74883",
    ST: "OK",
    cityWithStateAbbr: "Wetumka, OK",
  },
  {
    zip: "74884",
    ST: "OK",
    cityWithStateAbbr: "Wewoka, OK",
  },
  {
    zip: "74901",
    ST: "OK",
    cityWithStateAbbr: "Arkoma, OK",
  },
  {
    zip: "74902",
    ST: "OK",
    cityWithStateAbbr: "Pocola, OK",
  },
  {
    zip: "74930",
    ST: "OK",
    cityWithStateAbbr: "Bokoshe, OK",
  },
  {
    zip: "74931",
    ST: "OK",
    cityWithStateAbbr: "Bunch, OK",
  },
  {
    zip: "74932",
    ST: "OK",
    cityWithStateAbbr: "Cameron, OK",
  },
  {
    zip: "74935",
    ST: "OK",
    cityWithStateAbbr: "Fanshawe, OK",
  },
  {
    zip: "74936",
    ST: "OK",
    cityWithStateAbbr: "Gans, OK",
  },
  {
    zip: "74937",
    ST: "OK",
    cityWithStateAbbr: "Heavener, OK",
  },
  {
    zip: "74939",
    ST: "OK",
    cityWithStateAbbr: "Hodgen, OK",
  },
  {
    zip: "74940",
    ST: "OK",
    cityWithStateAbbr: "Howe, OK",
  },
  {
    zip: "74941",
    ST: "OK",
    cityWithStateAbbr: "Keota, OK",
  },
  {
    zip: "74942",
    ST: "OK",
    cityWithStateAbbr: "Leflore, OK",
  },
  {
    zip: "74943",
    ST: "OK",
    cityWithStateAbbr: "Lequire, OK",
  },
  {
    zip: "74944",
    ST: "OK",
    cityWithStateAbbr: "Mccurtain, OK",
  },
  {
    zip: "74945",
    ST: "OK",
    cityWithStateAbbr: "Marble City, OK",
  },
  {
    zip: "74946",
    ST: "OK",
    cityWithStateAbbr: "Moffett, OK",
  },
  {
    zip: "74947",
    ST: "OK",
    cityWithStateAbbr: "Monroe, OK",
  },
  {
    zip: "74948",
    ST: "OK",
    cityWithStateAbbr: "Muldrow, OK",
  },
  {
    zip: "74949",
    ST: "OK",
    cityWithStateAbbr: "Muse, OK",
  },
  {
    zip: "74951",
    ST: "OK",
    cityWithStateAbbr: "Panama, OK",
  },
  {
    zip: "74953",
    ST: "OK",
    cityWithStateAbbr: "Poteau, OK",
  },
  {
    zip: "74954",
    ST: "OK",
    cityWithStateAbbr: "Roland, OK",
  },
  {
    zip: "74955",
    ST: "OK",
    cityWithStateAbbr: "Sallisaw, OK",
  },
  {
    zip: "74956",
    ST: "OK",
    cityWithStateAbbr: "Shady Point, OK",
  },
  {
    zip: "74957",
    ST: "OK",
    cityWithStateAbbr: "Smithville, OK",
  },
  {
    zip: "74959",
    ST: "OK",
    cityWithStateAbbr: "Spiro, OK",
  },
  {
    zip: "74960",
    ST: "OK",
    cityWithStateAbbr: "Stilwell, OK",
  },
  {
    zip: "74962",
    ST: "OK",
    cityWithStateAbbr: "Vian, OK",
  },
  {
    zip: "74963",
    ST: "OK",
    cityWithStateAbbr: "Watson, OK",
  },
  {
    zip: "74964",
    ST: "OK",
    cityWithStateAbbr: "Watts, OK",
  },
  {
    zip: "74965",
    ST: "OK",
    cityWithStateAbbr: "Westville, OK",
  },
  {
    zip: "74966",
    ST: "OK",
    cityWithStateAbbr: "Wister, OK",
  },
  {
    zip: "75001",
    ST: "TX",
    cityWithStateAbbr: "Addison, TX",
  },
  {
    zip: "75002",
    ST: "TX",
    cityWithStateAbbr: "Allen, TX",
  },
  {
    zip: "75006",
    ST: "TX",
    cityWithStateAbbr: "Carrollton, TX",
  },
  {
    zip: "75007",
    ST: "TX",
    cityWithStateAbbr: "Carrollton, TX",
  },
  {
    zip: "75009",
    ST: "TX",
    cityWithStateAbbr: "Celina, TX",
  },
  {
    zip: "75010",
    ST: "TX",
    cityWithStateAbbr: "Carrollton, TX",
  },
  {
    zip: "75011",
    ST: "TX",
    cityWithStateAbbr: "Carrollton, TX",
  },
  {
    zip: "75013",
    ST: "TX",
    cityWithStateAbbr: "Allen, TX",
  },
  {
    zip: "75014",
    ST: "TX",
    cityWithStateAbbr: "Irving, TX",
  },
  {
    zip: "75015",
    ST: "TX",
    cityWithStateAbbr: "Irving, TX",
  },
  {
    zip: "75016",
    ST: "TX",
    cityWithStateAbbr: "Irving, TX",
  },
  {
    zip: "75017",
    ST: "TX",
    cityWithStateAbbr: "Irving, TX",
  },
  {
    zip: "75019",
    ST: "TX",
    cityWithStateAbbr: "Coppell, TX",
  },
  {
    zip: "75020",
    ST: "TX",
    cityWithStateAbbr: "Denison, TX",
  },
  {
    zip: "75021",
    ST: "TX",
    cityWithStateAbbr: "Denison, TX",
  },
  {
    zip: "75022",
    ST: "TX",
    cityWithStateAbbr: "Flower Mound, TX",
  },
  {
    zip: "75023",
    ST: "TX",
    cityWithStateAbbr: "Plano, TX",
  },
  {
    zip: "75024",
    ST: "TX",
    cityWithStateAbbr: "Plano, TX",
  },
  {
    zip: "75025",
    ST: "TX",
    cityWithStateAbbr: "Plano, TX",
  },
  {
    zip: "75026",
    ST: "TX",
    cityWithStateAbbr: "Plano, TX",
  },
  {
    zip: "75027",
    ST: "TX",
    cityWithStateAbbr: "Flower Mound, TX",
  },
  {
    zip: "75028",
    ST: "TX",
    cityWithStateAbbr: "Flower Mound, TX",
  },
  {
    zip: "75029",
    ST: "TX",
    cityWithStateAbbr: "Lewisville, TX",
  },
  {
    zip: "75030",
    ST: "TX",
    cityWithStateAbbr: "Rowlett, TX",
  },
  {
    zip: "75032",
    ST: "TX",
    cityWithStateAbbr: "Rockwall, TX",
  },
  {
    zip: "75033",
    ST: "TX",
    cityWithStateAbbr: "Frisco, TX",
  },
  {
    zip: "75034",
    ST: "TX",
    cityWithStateAbbr: "Frisco, TX",
  },
  {
    zip: "75035",
    ST: "TX",
    cityWithStateAbbr: "Frisco, TX",
  },
  {
    zip: "75036",
    ST: "TX",
    cityWithStateAbbr: "Frisco, TX",
  },
  {
    zip: "75037",
    ST: "TX",
    cityWithStateAbbr: "Irving, TX",
  },
  {
    zip: "75038",
    ST: "TX",
    cityWithStateAbbr: "Irving, TX",
  },
  {
    zip: "75039",
    ST: "TX",
    cityWithStateAbbr: "Irving, TX",
  },
  {
    zip: "75040",
    ST: "TX",
    cityWithStateAbbr: "Garland, TX",
  },
  {
    zip: "75041",
    ST: "TX",
    cityWithStateAbbr: "Garland, TX",
  },
  {
    zip: "75042",
    ST: "TX",
    cityWithStateAbbr: "Garland, TX",
  },
  {
    zip: "75043",
    ST: "TX",
    cityWithStateAbbr: "Garland, TX",
  },
  {
    zip: "75044",
    ST: "TX",
    cityWithStateAbbr: "Garland, TX",
  },
  {
    zip: "75045",
    ST: "TX",
    cityWithStateAbbr: "Garland, TX",
  },
  {
    zip: "75046",
    ST: "TX",
    cityWithStateAbbr: "Garland, TX",
  },
  {
    zip: "75047",
    ST: "TX",
    cityWithStateAbbr: "Garland, TX",
  },
  {
    zip: "75048",
    ST: "TX",
    cityWithStateAbbr: "Sachse, TX",
  },
  {
    zip: "75049",
    ST: "TX",
    cityWithStateAbbr: "Garland, TX",
  },
  {
    zip: "75050",
    ST: "TX",
    cityWithStateAbbr: "Grand Prairie, TX",
  },
  {
    zip: "75051",
    ST: "TX",
    cityWithStateAbbr: "Grand Prairie, TX",
  },
  {
    zip: "75052",
    ST: "TX",
    cityWithStateAbbr: "Grand Prairie, TX",
  },
  {
    zip: "75053",
    ST: "TX",
    cityWithStateAbbr: "Grand Prairie, TX",
  },
  {
    zip: "75054",
    ST: "TX",
    cityWithStateAbbr: "Grand Prairie, TX",
  },
  {
    zip: "75056",
    ST: "TX",
    cityWithStateAbbr: "The Colony, TX",
  },
  {
    zip: "75057",
    ST: "TX",
    cityWithStateAbbr: "Lewisville, TX",
  },
  {
    zip: "75058",
    ST: "TX",
    cityWithStateAbbr: "Gunter, TX",
  },
  {
    zip: "75060",
    ST: "TX",
    cityWithStateAbbr: "Irving, TX",
  },
  {
    zip: "75061",
    ST: "TX",
    cityWithStateAbbr: "Irving, TX",
  },
  {
    zip: "75062",
    ST: "TX",
    cityWithStateAbbr: "Irving, TX",
  },
  {
    zip: "75063",
    ST: "TX",
    cityWithStateAbbr: "Irving, TX",
  },
  {
    zip: "75065",
    ST: "TX",
    cityWithStateAbbr: "Lake Dallas, TX",
  },
  {
    zip: "75067",
    ST: "TX",
    cityWithStateAbbr: "Lewisville, TX",
  },
  {
    zip: "75068",
    ST: "TX",
    cityWithStateAbbr: "Little Elm, TX",
  },
  {
    zip: "75069",
    ST: "TX",
    cityWithStateAbbr: "Mckinney, TX",
  },
  {
    zip: "75070",
    ST: "TX",
    cityWithStateAbbr: "Mckinney, TX",
  },
  {
    zip: "75071",
    ST: "TX",
    cityWithStateAbbr: "Mckinney, TX",
  },
  {
    zip: "75072",
    ST: "TX",
    cityWithStateAbbr: "Mckinney, TX",
  },
  {
    zip: "75074",
    ST: "TX",
    cityWithStateAbbr: "Plano, TX",
  },
  {
    zip: "75075",
    ST: "TX",
    cityWithStateAbbr: "Plano, TX",
  },
  {
    zip: "75076",
    ST: "TX",
    cityWithStateAbbr: "Pottsboro, TX",
  },
  {
    zip: "75077",
    ST: "TX",
    cityWithStateAbbr: "Lewisville, TX",
  },
  {
    zip: "75078",
    ST: "TX",
    cityWithStateAbbr: "Prosper, TX",
  },
  {
    zip: "75080",
    ST: "TX",
    cityWithStateAbbr: "Richardson, TX",
  },
  {
    zip: "75081",
    ST: "TX",
    cityWithStateAbbr: "Richardson, TX",
  },
  {
    zip: "75082",
    ST: "TX",
    cityWithStateAbbr: "Richardson, TX",
  },
  {
    zip: "75083",
    ST: "TX",
    cityWithStateAbbr: "Richardson, TX",
  },
  {
    zip: "75085",
    ST: "TX",
    cityWithStateAbbr: "Richardson, TX",
  },
  {
    zip: "75086",
    ST: "TX",
    cityWithStateAbbr: "Plano, TX",
  },
  {
    zip: "75087",
    ST: "TX",
    cityWithStateAbbr: "Rockwall, TX",
  },
  {
    zip: "75088",
    ST: "TX",
    cityWithStateAbbr: "Rowlett, TX",
  },
  {
    zip: "75089",
    ST: "TX",
    cityWithStateAbbr: "Rowlett, TX",
  },
  {
    zip: "75090",
    ST: "TX",
    cityWithStateAbbr: "Sherman, TX",
  },
  {
    zip: "75091",
    ST: "TX",
    cityWithStateAbbr: "Sherman, TX",
  },
  {
    zip: "75092",
    ST: "TX",
    cityWithStateAbbr: "Sherman, TX",
  },
  {
    zip: "75093",
    ST: "TX",
    cityWithStateAbbr: "Plano, TX",
  },
  {
    zip: "75094",
    ST: "TX",
    cityWithStateAbbr: "Plano, TX",
  },
  {
    zip: "75097",
    ST: "TX",
    cityWithStateAbbr: "Weston, TX",
  },
  {
    zip: "75098",
    ST: "TX",
    cityWithStateAbbr: "Wylie, TX",
  },
  {
    zip: "75099",
    ST: "TX",
    cityWithStateAbbr: "Coppell, TX",
  },
  {
    zip: "75101",
    ST: "TX",
    cityWithStateAbbr: "Bardwell, TX",
  },
  {
    zip: "75102",
    ST: "TX",
    cityWithStateAbbr: "Barry, TX",
  },
  {
    zip: "75103",
    ST: "TX",
    cityWithStateAbbr: "Canton, TX",
  },
  {
    zip: "75104",
    ST: "TX",
    cityWithStateAbbr: "Cedar Hill, TX",
  },
  {
    zip: "75105",
    ST: "TX",
    cityWithStateAbbr: "Chatfield, TX",
  },
  {
    zip: "75106",
    ST: "TX",
    cityWithStateAbbr: "Cedar Hill, TX",
  },
  {
    zip: "75109",
    ST: "TX",
    cityWithStateAbbr: "Corsicana, TX",
  },
  {
    zip: "75110",
    ST: "TX",
    cityWithStateAbbr: "Corsicana, TX",
  },
  {
    zip: "75114",
    ST: "TX",
    cityWithStateAbbr: "Crandall, TX",
  },
  {
    zip: "75115",
    ST: "TX",
    cityWithStateAbbr: "Desoto, TX",
  },
  {
    zip: "75116",
    ST: "TX",
    cityWithStateAbbr: "Duncanville, TX",
  },
  {
    zip: "75117",
    ST: "TX",
    cityWithStateAbbr: "Edgewood, TX",
  },
  {
    zip: "75118",
    ST: "TX",
    cityWithStateAbbr: "Elmo, TX",
  },
  {
    zip: "75119",
    ST: "TX",
    cityWithStateAbbr: "Ennis, TX",
  },
  {
    zip: "75120",
    ST: "TX",
    cityWithStateAbbr: "Ennis, TX",
  },
  {
    zip: "75121",
    ST: "TX",
    cityWithStateAbbr: "Copeville, TX",
  },
  {
    zip: "75123",
    ST: "TX",
    cityWithStateAbbr: "Desoto, TX",
  },
  {
    zip: "75124",
    ST: "TX",
    cityWithStateAbbr: "Eustace, TX",
  },
  {
    zip: "75125",
    ST: "TX",
    cityWithStateAbbr: "Ferris, TX",
  },
  {
    zip: "75126",
    ST: "TX",
    cityWithStateAbbr: "Forney, TX",
  },
  {
    zip: "75127",
    ST: "TX",
    cityWithStateAbbr: "Fruitvale, TX",
  },
  {
    zip: "75132",
    ST: "TX",
    cityWithStateAbbr: "Fate, TX",
  },
  {
    zip: "75134",
    ST: "TX",
    cityWithStateAbbr: "Lancaster, TX",
  },
  {
    zip: "75135",
    ST: "TX",
    cityWithStateAbbr: "Caddo Mills, TX",
  },
  {
    zip: "75137",
    ST: "TX",
    cityWithStateAbbr: "Duncanville, TX",
  },
  {
    zip: "75138",
    ST: "TX",
    cityWithStateAbbr: "Duncanville, TX",
  },
  {
    zip: "75140",
    ST: "TX",
    cityWithStateAbbr: "Grand Saline, TX",
  },
  {
    zip: "75141",
    ST: "TX",
    cityWithStateAbbr: "Hutchins, TX",
  },
  {
    zip: "75142",
    ST: "TX",
    cityWithStateAbbr: "Kaufman, TX",
  },
  {
    zip: "75143",
    ST: "TX",
    cityWithStateAbbr: "Kemp, TX",
  },
  {
    zip: "75144",
    ST: "TX",
    cityWithStateAbbr: "Kerens, TX",
  },
  {
    zip: "75146",
    ST: "TX",
    cityWithStateAbbr: "Lancaster, TX",
  },
  {
    zip: "75147",
    ST: "TX",
    cityWithStateAbbr: "Mabank, TX",
  },
  {
    zip: "75148",
    ST: "TX",
    cityWithStateAbbr: "Malakoff, TX",
  },
  {
    zip: "75149",
    ST: "TX",
    cityWithStateAbbr: "Mesquite, TX",
  },
  {
    zip: "75150",
    ST: "TX",
    cityWithStateAbbr: "Mesquite, TX",
  },
  {
    zip: "75151",
    ST: "TX",
    cityWithStateAbbr: "Corsicana, TX",
  },
  {
    zip: "75152",
    ST: "TX",
    cityWithStateAbbr: "Palmer, TX",
  },
  {
    zip: "75153",
    ST: "TX",
    cityWithStateAbbr: "Powell, TX",
  },
  {
    zip: "75154",
    ST: "TX",
    cityWithStateAbbr: "Red Oak, TX",
  },
  {
    zip: "75155",
    ST: "TX",
    cityWithStateAbbr: "Rice, TX",
  },
  {
    zip: "75156",
    ST: "TX",
    cityWithStateAbbr: "Mabank, TX",
  },
  {
    zip: "75157",
    ST: "TX",
    cityWithStateAbbr: "Rosser, TX",
  },
  {
    zip: "75158",
    ST: "TX",
    cityWithStateAbbr: "Scurry, TX",
  },
  {
    zip: "75159",
    ST: "TX",
    cityWithStateAbbr: "Seagoville, TX",
  },
  {
    zip: "75160",
    ST: "TX",
    cityWithStateAbbr: "Terrell, TX",
  },
  {
    zip: "75161",
    ST: "TX",
    cityWithStateAbbr: "Terrell, TX",
  },
  {
    zip: "75163",
    ST: "TX",
    cityWithStateAbbr: "Trinidad, TX",
  },
  {
    zip: "75164",
    ST: "TX",
    cityWithStateAbbr: "Josephine, TX",
  },
  {
    zip: "75165",
    ST: "TX",
    cityWithStateAbbr: "Waxahachie, TX",
  },
  {
    zip: "75166",
    ST: "TX",
    cityWithStateAbbr: "Lavon, TX",
  },
  {
    zip: "75167",
    ST: "TX",
    cityWithStateAbbr: "Waxahachie, TX",
  },
  {
    zip: "75168",
    ST: "TX",
    cityWithStateAbbr: "Waxahachie, TX",
  },
  {
    zip: "75169",
    ST: "TX",
    cityWithStateAbbr: "Wills Point, TX",
  },
  {
    zip: "75172",
    ST: "TX",
    cityWithStateAbbr: "Wilmer, TX",
  },
  {
    zip: "75173",
    ST: "TX",
    cityWithStateAbbr: "Nevada, TX",
  },
  {
    zip: "75180",
    ST: "TX",
    cityWithStateAbbr: "Balch Springs, TX",
  },
  {
    zip: "75181",
    ST: "TX",
    cityWithStateAbbr: "Mesquite, TX",
  },
  {
    zip: "75182",
    ST: "TX",
    cityWithStateAbbr: "Sunnyvale, TX",
  },
  {
    zip: "75185",
    ST: "TX",
    cityWithStateAbbr: "Mesquite, TX",
  },
  {
    zip: "75187",
    ST: "TX",
    cityWithStateAbbr: "Mesquite, TX",
  },
  {
    zip: "75189",
    ST: "TX",
    cityWithStateAbbr: "Royse City, TX",
  },
  {
    zip: "75201",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75202",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75203",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75204",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75205",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75206",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75207",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75208",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75209",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75210",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75211",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75212",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75214",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75215",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75216",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75217",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75218",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75219",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75220",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75221",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75222",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75223",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75224",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75225",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75226",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75227",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75228",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75229",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75230",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75231",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75232",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75233",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75234",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75235",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75236",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75237",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75238",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75240",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75241",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75242",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75243",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75244",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75246",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75247",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75248",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75249",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75250",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75251",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75252",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75253",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75254",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75258",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75260",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75261",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75262",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75263",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75264",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75265",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75266",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75267",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75270",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75275",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75277",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75283",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75284",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75285",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75287",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75301",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75303",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75312",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75313",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75315",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75320",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75326",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75336",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75339",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75342",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75354",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75355",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75356",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75357",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75358",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75359",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75360",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75367",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75368",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75370",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75371",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75372",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75373",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75374",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75376",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75378",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75379",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75380",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75381",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75382",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75389",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75390",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75391",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75392",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75393",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75394",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75395",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75397",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75398",
    ST: "TX",
    cityWithStateAbbr: "Dallas, TX",
  },
  {
    zip: "75401",
    ST: "TX",
    cityWithStateAbbr: "Greenville, TX",
  },
  {
    zip: "75402",
    ST: "TX",
    cityWithStateAbbr: "Greenville, TX",
  },
  {
    zip: "75403",
    ST: "TX",
    cityWithStateAbbr: "Greenville, TX",
  },
  {
    zip: "75404",
    ST: "TX",
    cityWithStateAbbr: "Greenville, TX",
  },
  {
    zip: "75407",
    ST: "TX",
    cityWithStateAbbr: "Princeton, TX",
  },
  {
    zip: "75409",
    ST: "TX",
    cityWithStateAbbr: "Anna, TX",
  },
  {
    zip: "75410",
    ST: "TX",
    cityWithStateAbbr: "Alba, TX",
  },
  {
    zip: "75411",
    ST: "TX",
    cityWithStateAbbr: "Arthur City, TX",
  },
  {
    zip: "75412",
    ST: "TX",
    cityWithStateAbbr: "Bagwell, TX",
  },
  {
    zip: "75413",
    ST: "TX",
    cityWithStateAbbr: "Bailey, TX",
  },
  {
    zip: "75414",
    ST: "TX",
    cityWithStateAbbr: "Bells, TX",
  },
  {
    zip: "75415",
    ST: "TX",
    cityWithStateAbbr: "Ben Franklin, TX",
  },
  {
    zip: "75416",
    ST: "TX",
    cityWithStateAbbr: "Blossom, TX",
  },
  {
    zip: "75417",
    ST: "TX",
    cityWithStateAbbr: "Bogata, TX",
  },
  {
    zip: "75418",
    ST: "TX",
    cityWithStateAbbr: "Bonham, TX",
  },
  {
    zip: "75420",
    ST: "TX",
    cityWithStateAbbr: "Brashear, TX",
  },
  {
    zip: "75421",
    ST: "TX",
    cityWithStateAbbr: "Brookston, TX",
  },
  {
    zip: "75422",
    ST: "TX",
    cityWithStateAbbr: "Campbell, TX",
  },
  {
    zip: "75423",
    ST: "TX",
    cityWithStateAbbr: "Celeste, TX",
  },
  {
    zip: "75424",
    ST: "TX",
    cityWithStateAbbr: "Blue Ridge, TX",
  },
  {
    zip: "75425",
    ST: "TX",
    cityWithStateAbbr: "Chicota, TX",
  },
  {
    zip: "75426",
    ST: "TX",
    cityWithStateAbbr: "Clarksville, TX",
  },
  {
    zip: "75428",
    ST: "TX",
    cityWithStateAbbr: "Commerce, TX",
  },
  {
    zip: "75429",
    ST: "TX",
    cityWithStateAbbr: "Commerce, TX",
  },
  {
    zip: "75431",
    ST: "TX",
    cityWithStateAbbr: "Como, TX",
  },
  {
    zip: "75432",
    ST: "TX",
    cityWithStateAbbr: "Cooper, TX",
  },
  {
    zip: "75433",
    ST: "TX",
    cityWithStateAbbr: "Cumby, TX",
  },
  {
    zip: "75434",
    ST: "TX",
    cityWithStateAbbr: "Cunningham, TX",
  },
  {
    zip: "75435",
    ST: "TX",
    cityWithStateAbbr: "Deport, TX",
  },
  {
    zip: "75436",
    ST: "TX",
    cityWithStateAbbr: "Detroit, TX",
  },
  {
    zip: "75437",
    ST: "TX",
    cityWithStateAbbr: "Dike, TX",
  },
  {
    zip: "75438",
    ST: "TX",
    cityWithStateAbbr: "Dodd City, TX",
  },
  {
    zip: "75439",
    ST: "TX",
    cityWithStateAbbr: "Ector, TX",
  },
  {
    zip: "75440",
    ST: "TX",
    cityWithStateAbbr: "Emory, TX",
  },
  {
    zip: "75441",
    ST: "TX",
    cityWithStateAbbr: "Enloe, TX",
  },
  {
    zip: "75442",
    ST: "TX",
    cityWithStateAbbr: "Farmersville, TX",
  },
  {
    zip: "75443",
    ST: "TX",
    cityWithStateAbbr: "Gober, TX",
  },
  {
    zip: "75444",
    ST: "TX",
    cityWithStateAbbr: "Golden, TX",
  },
  {
    zip: "75446",
    ST: "TX",
    cityWithStateAbbr: "Honey Grove, TX",
  },
  {
    zip: "75447",
    ST: "TX",
    cityWithStateAbbr: "Ivanhoe, TX",
  },
  {
    zip: "75448",
    ST: "TX",
    cityWithStateAbbr: "Klondike, TX",
  },
  {
    zip: "75449",
    ST: "TX",
    cityWithStateAbbr: "Ladonia, TX",
  },
  {
    zip: "75450",
    ST: "TX",
    cityWithStateAbbr: "Lake Creek, TX",
  },
  {
    zip: "75451",
    ST: "TX",
    cityWithStateAbbr: "Leesburg, TX",
  },
  {
    zip: "75452",
    ST: "TX",
    cityWithStateAbbr: "Leonard, TX",
  },
  {
    zip: "75453",
    ST: "TX",
    cityWithStateAbbr: "Lone Oak, TX",
  },
  {
    zip: "75454",
    ST: "TX",
    cityWithStateAbbr: "Melissa, TX",
  },
  {
    zip: "75455",
    ST: "TX",
    cityWithStateAbbr: "Mount Pleasant, TX",
  },
  {
    zip: "75456",
    ST: "TX",
    cityWithStateAbbr: "Mount Pleasant, TX",
  },
  {
    zip: "75457",
    ST: "TX",
    cityWithStateAbbr: "Mount Vernon, TX",
  },
  {
    zip: "75458",
    ST: "TX",
    cityWithStateAbbr: "Merit, TX",
  },
  {
    zip: "75459",
    ST: "TX",
    cityWithStateAbbr: "Howe, TX",
  },
  {
    zip: "75460",
    ST: "TX",
    cityWithStateAbbr: "Paris, TX",
  },
  {
    zip: "75461",
    ST: "TX",
    cityWithStateAbbr: "Paris, TX",
  },
  {
    zip: "75462",
    ST: "TX",
    cityWithStateAbbr: "Paris, TX",
  },
  {
    zip: "75468",
    ST: "TX",
    cityWithStateAbbr: "Pattonville, TX",
  },
  {
    zip: "75469",
    ST: "TX",
    cityWithStateAbbr: "Pecan Gap, TX",
  },
  {
    zip: "75470",
    ST: "TX",
    cityWithStateAbbr: "Petty, TX",
  },
  {
    zip: "75471",
    ST: "TX",
    cityWithStateAbbr: "Pickton, TX",
  },
  {
    zip: "75472",
    ST: "TX",
    cityWithStateAbbr: "Point, TX",
  },
  {
    zip: "75473",
    ST: "TX",
    cityWithStateAbbr: "Powderly, TX",
  },
  {
    zip: "75474",
    ST: "TX",
    cityWithStateAbbr: "Quinlan, TX",
  },
  {
    zip: "75475",
    ST: "TX",
    cityWithStateAbbr: "Randolph, TX",
  },
  {
    zip: "75476",
    ST: "TX",
    cityWithStateAbbr: "Ravenna, TX",
  },
  {
    zip: "75477",
    ST: "TX",
    cityWithStateAbbr: "Roxton, TX",
  },
  {
    zip: "75478",
    ST: "TX",
    cityWithStateAbbr: "Saltillo, TX",
  },
  {
    zip: "75479",
    ST: "TX",
    cityWithStateAbbr: "Savoy, TX",
  },
  {
    zip: "75480",
    ST: "TX",
    cityWithStateAbbr: "Scroggins, TX",
  },
  {
    zip: "75481",
    ST: "TX",
    cityWithStateAbbr: "Sulphur Bluff, TX",
  },
  {
    zip: "75482",
    ST: "TX",
    cityWithStateAbbr: "Sulphur Springs, TX",
  },
  {
    zip: "75483",
    ST: "TX",
    cityWithStateAbbr: "Sulphur Springs, TX",
  },
  {
    zip: "75485",
    ST: "TX",
    cityWithStateAbbr: "Westminster, TX",
  },
  {
    zip: "75486",
    ST: "TX",
    cityWithStateAbbr: "Sumner, TX",
  },
  {
    zip: "75487",
    ST: "TX",
    cityWithStateAbbr: "Talco, TX",
  },
  {
    zip: "75488",
    ST: "TX",
    cityWithStateAbbr: "Telephone, TX",
  },
  {
    zip: "75489",
    ST: "TX",
    cityWithStateAbbr: "Tom Bean, TX",
  },
  {
    zip: "75490",
    ST: "TX",
    cityWithStateAbbr: "Trenton, TX",
  },
  {
    zip: "75491",
    ST: "TX",
    cityWithStateAbbr: "Whitewright, TX",
  },
  {
    zip: "75492",
    ST: "TX",
    cityWithStateAbbr: "Windom, TX",
  },
  {
    zip: "75493",
    ST: "TX",
    cityWithStateAbbr: "Winfield, TX",
  },
  {
    zip: "75494",
    ST: "TX",
    cityWithStateAbbr: "Winnsboro, TX",
  },
  {
    zip: "75495",
    ST: "TX",
    cityWithStateAbbr: "Van Alstyne, TX",
  },
  {
    zip: "75496",
    ST: "TX",
    cityWithStateAbbr: "Wolfe City, TX",
  },
  {
    zip: "75497",
    ST: "TX",
    cityWithStateAbbr: "Yantis, TX",
  },
  {
    zip: "75501",
    ST: "TX",
    cityWithStateAbbr: "Texarkana, TX",
  },
  {
    zip: "75503",
    ST: "TX",
    cityWithStateAbbr: "Texarkana, TX",
  },
  {
    zip: "75504",
    ST: "TX",
    cityWithStateAbbr: "Texarkana, TX",
  },
  {
    zip: "75505",
    ST: "TX",
    cityWithStateAbbr: "Texarkana, TX",
  },
  {
    zip: "75507",
    ST: "TX",
    cityWithStateAbbr: "Texarkana, TX",
  },
  {
    zip: "75550",
    ST: "TX",
    cityWithStateAbbr: "Annona, TX",
  },
  {
    zip: "75551",
    ST: "TX",
    cityWithStateAbbr: "Atlanta, TX",
  },
  {
    zip: "75554",
    ST: "TX",
    cityWithStateAbbr: "Avery, TX",
  },
  {
    zip: "75555",
    ST: "TX",
    cityWithStateAbbr: "Bivins, TX",
  },
  {
    zip: "75556",
    ST: "TX",
    cityWithStateAbbr: "Bloomburg, TX",
  },
  {
    zip: "75558",
    ST: "TX",
    cityWithStateAbbr: "Cookville, TX",
  },
  {
    zip: "75559",
    ST: "TX",
    cityWithStateAbbr: "De Kalb, TX",
  },
  {
    zip: "75560",
    ST: "TX",
    cityWithStateAbbr: "Douglassville, TX",
  },
  {
    zip: "75561",
    ST: "TX",
    cityWithStateAbbr: "Hooks, TX",
  },
  {
    zip: "75562",
    ST: "TX",
    cityWithStateAbbr: "Kildare, TX",
  },
  {
    zip: "75563",
    ST: "TX",
    cityWithStateAbbr: "Linden, TX",
  },
  {
    zip: "75564",
    ST: "TX",
    cityWithStateAbbr: "Lodi, TX",
  },
  {
    zip: "75565",
    ST: "TX",
    cityWithStateAbbr: "Mc Leod, TX",
  },
  {
    zip: "75566",
    ST: "TX",
    cityWithStateAbbr: "Marietta, TX",
  },
  {
    zip: "75567",
    ST: "TX",
    cityWithStateAbbr: "Maud, TX",
  },
  {
    zip: "75568",
    ST: "TX",
    cityWithStateAbbr: "Naples, TX",
  },
  {
    zip: "75569",
    ST: "TX",
    cityWithStateAbbr: "Nash, TX",
  },
  {
    zip: "75570",
    ST: "TX",
    cityWithStateAbbr: "New Boston, TX",
  },
  {
    zip: "75571",
    ST: "TX",
    cityWithStateAbbr: "Omaha, TX",
  },
  {
    zip: "75572",
    ST: "TX",
    cityWithStateAbbr: "Queen City, TX",
  },
  {
    zip: "75573",
    ST: "TX",
    cityWithStateAbbr: "Redwater, TX",
  },
  {
    zip: "75574",
    ST: "TX",
    cityWithStateAbbr: "Simms, TX",
  },
  {
    zip: "75599",
    ST: "TX",
    cityWithStateAbbr: "Texarkana, TX",
  },
  {
    zip: "75601",
    ST: "TX",
    cityWithStateAbbr: "Longview, TX",
  },
  {
    zip: "75602",
    ST: "TX",
    cityWithStateAbbr: "Longview, TX",
  },
  {
    zip: "75603",
    ST: "TX",
    cityWithStateAbbr: "Longview, TX",
  },
  {
    zip: "75604",
    ST: "TX",
    cityWithStateAbbr: "Longview, TX",
  },
  {
    zip: "75605",
    ST: "TX",
    cityWithStateAbbr: "Longview, TX",
  },
  {
    zip: "75606",
    ST: "TX",
    cityWithStateAbbr: "Longview, TX",
  },
  {
    zip: "75607",
    ST: "TX",
    cityWithStateAbbr: "Longview, TX",
  },
  {
    zip: "75608",
    ST: "TX",
    cityWithStateAbbr: "Longview, TX",
  },
  {
    zip: "75615",
    ST: "TX",
    cityWithStateAbbr: "Longview, TX",
  },
  {
    zip: "75630",
    ST: "TX",
    cityWithStateAbbr: "Avinger, TX",
  },
  {
    zip: "75631",
    ST: "TX",
    cityWithStateAbbr: "Beckville, TX",
  },
  {
    zip: "75633",
    ST: "TX",
    cityWithStateAbbr: "Carthage, TX",
  },
  {
    zip: "75636",
    ST: "TX",
    cityWithStateAbbr: "Cason, TX",
  },
  {
    zip: "75637",
    ST: "TX",
    cityWithStateAbbr: "Clayton, TX",
  },
  {
    zip: "75638",
    ST: "TX",
    cityWithStateAbbr: "Daingerfield, TX",
  },
  {
    zip: "75639",
    ST: "TX",
    cityWithStateAbbr: "De Berry, TX",
  },
  {
    zip: "75640",
    ST: "TX",
    cityWithStateAbbr: "Diana, TX",
  },
  {
    zip: "75641",
    ST: "TX",
    cityWithStateAbbr: "Easton, TX",
  },
  {
    zip: "75642",
    ST: "TX",
    cityWithStateAbbr: "Elysian Fields, TX",
  },
  {
    zip: "75643",
    ST: "TX",
    cityWithStateAbbr: "Gary, TX",
  },
  {
    zip: "75644",
    ST: "TX",
    cityWithStateAbbr: "Gilmer, TX",
  },
  {
    zip: "75645",
    ST: "TX",
    cityWithStateAbbr: "Gilmer, TX",
  },
  {
    zip: "75647",
    ST: "TX",
    cityWithStateAbbr: "Gladewater, TX",
  },
  {
    zip: "75650",
    ST: "TX",
    cityWithStateAbbr: "Hallsville, TX",
  },
  {
    zip: "75651",
    ST: "TX",
    cityWithStateAbbr: "Harleton, TX",
  },
  {
    zip: "75652",
    ST: "TX",
    cityWithStateAbbr: "Henderson, TX",
  },
  {
    zip: "75653",
    ST: "TX",
    cityWithStateAbbr: "Henderson, TX",
  },
  {
    zip: "75654",
    ST: "TX",
    cityWithStateAbbr: "Henderson, TX",
  },
  {
    zip: "75656",
    ST: "TX",
    cityWithStateAbbr: "Hughes Springs, TX",
  },
  {
    zip: "75657",
    ST: "TX",
    cityWithStateAbbr: "Jefferson, TX",
  },
  {
    zip: "75658",
    ST: "TX",
    cityWithStateAbbr: "Joinerville, TX",
  },
  {
    zip: "75659",
    ST: "TX",
    cityWithStateAbbr: "Jonesville, TX",
  },
  {
    zip: "75660",
    ST: "TX",
    cityWithStateAbbr: "Judson, TX",
  },
  {
    zip: "75661",
    ST: "TX",
    cityWithStateAbbr: "Karnack, TX",
  },
  {
    zip: "75662",
    ST: "TX",
    cityWithStateAbbr: "Kilgore, TX",
  },
  {
    zip: "75663",
    ST: "TX",
    cityWithStateAbbr: "Kilgore, TX",
  },
  {
    zip: "75666",
    ST: "TX",
    cityWithStateAbbr: "Laird Hill, TX",
  },
  {
    zip: "75667",
    ST: "TX",
    cityWithStateAbbr: "Laneville, TX",
  },
  {
    zip: "75668",
    ST: "TX",
    cityWithStateAbbr: "Lone Star, TX",
  },
  {
    zip: "75669",
    ST: "TX",
    cityWithStateAbbr: "Long Branch, TX",
  },
  {
    zip: "75670",
    ST: "TX",
    cityWithStateAbbr: "Marshall, TX",
  },
  {
    zip: "75671",
    ST: "TX",
    cityWithStateAbbr: "Marshall, TX",
  },
  {
    zip: "75672",
    ST: "TX",
    cityWithStateAbbr: "Marshall, TX",
  },
  {
    zip: "75680",
    ST: "TX",
    cityWithStateAbbr: "Minden, TX",
  },
  {
    zip: "75681",
    ST: "TX",
    cityWithStateAbbr: "Mount Enterprise, TX",
  },
  {
    zip: "75682",
    ST: "TX",
    cityWithStateAbbr: "New London, TX",
  },
  {
    zip: "75683",
    ST: "TX",
    cityWithStateAbbr: "Ore City, TX",
  },
  {
    zip: "75684",
    ST: "TX",
    cityWithStateAbbr: "Overton, TX",
  },
  {
    zip: "75685",
    ST: "TX",
    cityWithStateAbbr: "Panola, TX",
  },
  {
    zip: "75686",
    ST: "TX",
    cityWithStateAbbr: "Pittsburg, TX",
  },
  {
    zip: "75687",
    ST: "TX",
    cityWithStateAbbr: "Price, TX",
  },
  {
    zip: "75688",
    ST: "TX",
    cityWithStateAbbr: "Scottsville, TX",
  },
  {
    zip: "75689",
    ST: "TX",
    cityWithStateAbbr: "Selman City, TX",
  },
  {
    zip: "75691",
    ST: "TX",
    cityWithStateAbbr: "Tatum, TX",
  },
  {
    zip: "75692",
    ST: "TX",
    cityWithStateAbbr: "Waskom, TX",
  },
  {
    zip: "75693",
    ST: "TX",
    cityWithStateAbbr: "White Oak, TX",
  },
  {
    zip: "75694",
    ST: "TX",
    cityWithStateAbbr: "Woodlawn, TX",
  },
  {
    zip: "75701",
    ST: "TX",
    cityWithStateAbbr: "Tyler, TX",
  },
  {
    zip: "75702",
    ST: "TX",
    cityWithStateAbbr: "Tyler, TX",
  },
  {
    zip: "75703",
    ST: "TX",
    cityWithStateAbbr: "Tyler, TX",
  },
  {
    zip: "75704",
    ST: "TX",
    cityWithStateAbbr: "Tyler, TX",
  },
  {
    zip: "75705",
    ST: "TX",
    cityWithStateAbbr: "Tyler, TX",
  },
  {
    zip: "75706",
    ST: "TX",
    cityWithStateAbbr: "Tyler, TX",
  },
  {
    zip: "75707",
    ST: "TX",
    cityWithStateAbbr: "Tyler, TX",
  },
  {
    zip: "75708",
    ST: "TX",
    cityWithStateAbbr: "Tyler, TX",
  },
  {
    zip: "75709",
    ST: "TX",
    cityWithStateAbbr: "Tyler, TX",
  },
  {
    zip: "75710",
    ST: "TX",
    cityWithStateAbbr: "Tyler, TX",
  },
  {
    zip: "75711",
    ST: "TX",
    cityWithStateAbbr: "Tyler, TX",
  },
  {
    zip: "75712",
    ST: "TX",
    cityWithStateAbbr: "Tyler, TX",
  },
  {
    zip: "75713",
    ST: "TX",
    cityWithStateAbbr: "Tyler, TX",
  },
  {
    zip: "75750",
    ST: "TX",
    cityWithStateAbbr: "Arp, TX",
  },
  {
    zip: "75751",
    ST: "TX",
    cityWithStateAbbr: "Athens, TX",
  },
  {
    zip: "75752",
    ST: "TX",
    cityWithStateAbbr: "Athens, TX",
  },
  {
    zip: "75754",
    ST: "TX",
    cityWithStateAbbr: "Ben Wheeler, TX",
  },
  {
    zip: "75755",
    ST: "TX",
    cityWithStateAbbr: "Big Sandy, TX",
  },
  {
    zip: "75756",
    ST: "TX",
    cityWithStateAbbr: "Brownsboro, TX",
  },
  {
    zip: "75757",
    ST: "TX",
    cityWithStateAbbr: "Bullard, TX",
  },
  {
    zip: "75758",
    ST: "TX",
    cityWithStateAbbr: "Chandler, TX",
  },
  {
    zip: "75759",
    ST: "TX",
    cityWithStateAbbr: "Cuney, TX",
  },
  {
    zip: "75760",
    ST: "TX",
    cityWithStateAbbr: "Cushing, TX",
  },
  {
    zip: "75762",
    ST: "TX",
    cityWithStateAbbr: "Flint, TX",
  },
  {
    zip: "75763",
    ST: "TX",
    cityWithStateAbbr: "Frankston, TX",
  },
  {
    zip: "75764",
    ST: "TX",
    cityWithStateAbbr: "Gallatin, TX",
  },
  {
    zip: "75765",
    ST: "TX",
    cityWithStateAbbr: "Hawkins, TX",
  },
  {
    zip: "75766",
    ST: "TX",
    cityWithStateAbbr: "Jacksonville, TX",
  },
  {
    zip: "75770",
    ST: "TX",
    cityWithStateAbbr: "Larue, TX",
  },
  {
    zip: "75771",
    ST: "TX",
    cityWithStateAbbr: "Lindale, TX",
  },
  {
    zip: "75772",
    ST: "TX",
    cityWithStateAbbr: "Maydelle, TX",
  },
  {
    zip: "75773",
    ST: "TX",
    cityWithStateAbbr: "Mineola, TX",
  },
  {
    zip: "75778",
    ST: "TX",
    cityWithStateAbbr: "Murchison, TX",
  },
  {
    zip: "75779",
    ST: "TX",
    cityWithStateAbbr: "Neches, TX",
  },
  {
    zip: "75780",
    ST: "TX",
    cityWithStateAbbr: "New Summerfield, TX",
  },
  {
    zip: "75782",
    ST: "TX",
    cityWithStateAbbr: "Poynor, TX",
  },
  {
    zip: "75783",
    ST: "TX",
    cityWithStateAbbr: "Quitman, TX",
  },
  {
    zip: "75784",
    ST: "TX",
    cityWithStateAbbr: "Reklaw, TX",
  },
  {
    zip: "75785",
    ST: "TX",
    cityWithStateAbbr: "Rusk, TX",
  },
  {
    zip: "75788",
    ST: "TX",
    cityWithStateAbbr: "Sacul, TX",
  },
  {
    zip: "75789",
    ST: "TX",
    cityWithStateAbbr: "Troup, TX",
  },
  {
    zip: "75790",
    ST: "TX",
    cityWithStateAbbr: "Van, TX",
  },
  {
    zip: "75791",
    ST: "TX",
    cityWithStateAbbr: "Whitehouse, TX",
  },
  {
    zip: "75792",
    ST: "TX",
    cityWithStateAbbr: "Winona, TX",
  },
  {
    zip: "75797",
    ST: "TX",
    cityWithStateAbbr: "Big Sandy, TX",
  },
  {
    zip: "75798",
    ST: "TX",
    cityWithStateAbbr: "Tyler, TX",
  },
  {
    zip: "75799",
    ST: "TX",
    cityWithStateAbbr: "Tyler, TX",
  },
  {
    zip: "75801",
    ST: "TX",
    cityWithStateAbbr: "Palestine, TX",
  },
  {
    zip: "75802",
    ST: "TX",
    cityWithStateAbbr: "Palestine, TX",
  },
  {
    zip: "75803",
    ST: "TX",
    cityWithStateAbbr: "Palestine, TX",
  },
  {
    zip: "75831",
    ST: "TX",
    cityWithStateAbbr: "Buffalo, TX",
  },
  {
    zip: "75832",
    ST: "TX",
    cityWithStateAbbr: "Cayuga, TX",
  },
  {
    zip: "75833",
    ST: "TX",
    cityWithStateAbbr: "Centerville, TX",
  },
  {
    zip: "75834",
    ST: "TX",
    cityWithStateAbbr: "Centralia, TX",
  },
  {
    zip: "75835",
    ST: "TX",
    cityWithStateAbbr: "Crockett, TX",
  },
  {
    zip: "75838",
    ST: "TX",
    cityWithStateAbbr: "Donie, TX",
  },
  {
    zip: "75839",
    ST: "TX",
    cityWithStateAbbr: "Elkhart, TX",
  },
  {
    zip: "75840",
    ST: "TX",
    cityWithStateAbbr: "Fairfield, TX",
  },
  {
    zip: "75844",
    ST: "TX",
    cityWithStateAbbr: "Grapeland, TX",
  },
  {
    zip: "75845",
    ST: "TX",
    cityWithStateAbbr: "Groveton, TX",
  },
  {
    zip: "75846",
    ST: "TX",
    cityWithStateAbbr: "Jewett, TX",
  },
  {
    zip: "75847",
    ST: "TX",
    cityWithStateAbbr: "Kennard, TX",
  },
  {
    zip: "75848",
    ST: "TX",
    cityWithStateAbbr: "Kirvin, TX",
  },
  {
    zip: "75849",
    ST: "TX",
    cityWithStateAbbr: "Latexo, TX",
  },
  {
    zip: "75850",
    ST: "TX",
    cityWithStateAbbr: "Leona, TX",
  },
  {
    zip: "75851",
    ST: "TX",
    cityWithStateAbbr: "Lovelady, TX",
  },
  {
    zip: "75852",
    ST: "TX",
    cityWithStateAbbr: "Midway, TX",
  },
  {
    zip: "75853",
    ST: "TX",
    cityWithStateAbbr: "Montalba, TX",
  },
  {
    zip: "75855",
    ST: "TX",
    cityWithStateAbbr: "Oakwood, TX",
  },
  {
    zip: "75856",
    ST: "TX",
    cityWithStateAbbr: "Pennington, TX",
  },
  {
    zip: "75858",
    ST: "TX",
    cityWithStateAbbr: "Ratcliff, TX",
  },
  {
    zip: "75859",
    ST: "TX",
    cityWithStateAbbr: "Streetman, TX",
  },
  {
    zip: "75860",
    ST: "TX",
    cityWithStateAbbr: "Teague, TX",
  },
  {
    zip: "75861",
    ST: "TX",
    cityWithStateAbbr: "Tennessee Colony, TX",
  },
  {
    zip: "75862",
    ST: "TX",
    cityWithStateAbbr: "Trinity, TX",
  },
  {
    zip: "75865",
    ST: "TX",
    cityWithStateAbbr: "Woodlake, TX",
  },
  {
    zip: "75880",
    ST: "TX",
    cityWithStateAbbr: "Tennessee Colony, TX",
  },
  {
    zip: "75882",
    ST: "TX",
    cityWithStateAbbr: "Palestine, TX",
  },
  {
    zip: "75884",
    ST: "TX",
    cityWithStateAbbr: "Tennessee Colony, TX",
  },
  {
    zip: "75886",
    ST: "TX",
    cityWithStateAbbr: "Tennessee Colony, TX",
  },
  {
    zip: "75901",
    ST: "TX",
    cityWithStateAbbr: "Lufkin, TX",
  },
  {
    zip: "75902",
    ST: "TX",
    cityWithStateAbbr: "Lufkin, TX",
  },
  {
    zip: "75903",
    ST: "TX",
    cityWithStateAbbr: "Lufkin, TX",
  },
  {
    zip: "75904",
    ST: "TX",
    cityWithStateAbbr: "Lufkin, TX",
  },
  {
    zip: "75915",
    ST: "TX",
    cityWithStateAbbr: "Lufkin, TX",
  },
  {
    zip: "75925",
    ST: "TX",
    cityWithStateAbbr: "Alto, TX",
  },
  {
    zip: "75926",
    ST: "TX",
    cityWithStateAbbr: "Apple Springs, TX",
  },
  {
    zip: "75928",
    ST: "TX",
    cityWithStateAbbr: "Bon Wier, TX",
  },
  {
    zip: "75929",
    ST: "TX",
    cityWithStateAbbr: "Broaddus, TX",
  },
  {
    zip: "75930",
    ST: "TX",
    cityWithStateAbbr: "Bronson, TX",
  },
  {
    zip: "75931",
    ST: "TX",
    cityWithStateAbbr: "Brookeland, TX",
  },
  {
    zip: "75932",
    ST: "TX",
    cityWithStateAbbr: "Burkeville, TX",
  },
  {
    zip: "75933",
    ST: "TX",
    cityWithStateAbbr: "Call, TX",
  },
  {
    zip: "75934",
    ST: "TX",
    cityWithStateAbbr: "Camden, TX",
  },
  {
    zip: "75935",
    ST: "TX",
    cityWithStateAbbr: "Center, TX",
  },
  {
    zip: "75936",
    ST: "TX",
    cityWithStateAbbr: "Chester, TX",
  },
  {
    zip: "75937",
    ST: "TX",
    cityWithStateAbbr: "Chireno, TX",
  },
  {
    zip: "75938",
    ST: "TX",
    cityWithStateAbbr: "Colmesneil, TX",
  },
  {
    zip: "75939",
    ST: "TX",
    cityWithStateAbbr: "Corrigan, TX",
  },
  {
    zip: "75941",
    ST: "TX",
    cityWithStateAbbr: "Diboll, TX",
  },
  {
    zip: "75942",
    ST: "TX",
    cityWithStateAbbr: "Doucette, TX",
  },
  {
    zip: "75943",
    ST: "TX",
    cityWithStateAbbr: "Douglass, TX",
  },
  {
    zip: "75944",
    ST: "TX",
    cityWithStateAbbr: "Etoile, TX",
  },
  {
    zip: "75946",
    ST: "TX",
    cityWithStateAbbr: "Garrison, TX",
  },
  {
    zip: "75948",
    ST: "TX",
    cityWithStateAbbr: "Hemphill, TX",
  },
  {
    zip: "75949",
    ST: "TX",
    cityWithStateAbbr: "Huntington, TX",
  },
  {
    zip: "75951",
    ST: "TX",
    cityWithStateAbbr: "Jasper, TX",
  },
  {
    zip: "75954",
    ST: "TX",
    cityWithStateAbbr: "Joaquin, TX",
  },
  {
    zip: "75956",
    ST: "TX",
    cityWithStateAbbr: "Kirbyville, TX",
  },
  {
    zip: "75958",
    ST: "TX",
    cityWithStateAbbr: "Martinsville, TX",
  },
  {
    zip: "75959",
    ST: "TX",
    cityWithStateAbbr: "Milam, TX",
  },
  {
    zip: "75960",
    ST: "TX",
    cityWithStateAbbr: "Moscow, TX",
  },
  {
    zip: "75961",
    ST: "TX",
    cityWithStateAbbr: "Nacogdoches, TX",
  },
  {
    zip: "75962",
    ST: "TX",
    cityWithStateAbbr: "Nacogdoches, TX",
  },
  {
    zip: "75963",
    ST: "TX",
    cityWithStateAbbr: "Nacogdoches, TX",
  },
  {
    zip: "75964",
    ST: "TX",
    cityWithStateAbbr: "Nacogdoches, TX",
  },
  {
    zip: "75965",
    ST: "TX",
    cityWithStateAbbr: "Nacogdoches, TX",
  },
  {
    zip: "75966",
    ST: "TX",
    cityWithStateAbbr: "Newton, TX",
  },
  {
    zip: "75968",
    ST: "TX",
    cityWithStateAbbr: "Pineland, TX",
  },
  {
    zip: "75969",
    ST: "TX",
    cityWithStateAbbr: "Pollok, TX",
  },
  {
    zip: "75972",
    ST: "TX",
    cityWithStateAbbr: "San Augustine, TX",
  },
  {
    zip: "75973",
    ST: "TX",
    cityWithStateAbbr: "Shelbyville, TX",
  },
  {
    zip: "75974",
    ST: "TX",
    cityWithStateAbbr: "Tenaha, TX",
  },
  {
    zip: "75975",
    ST: "TX",
    cityWithStateAbbr: "Timpson, TX",
  },
  {
    zip: "75976",
    ST: "TX",
    cityWithStateAbbr: "Wells, TX",
  },
  {
    zip: "75977",
    ST: "TX",
    cityWithStateAbbr: "Wiergate, TX",
  },
  {
    zip: "75978",
    ST: "TX",
    cityWithStateAbbr: "Woden, TX",
  },
  {
    zip: "75979",
    ST: "TX",
    cityWithStateAbbr: "Woodville, TX",
  },
  {
    zip: "75980",
    ST: "TX",
    cityWithStateAbbr: "Zavalla, TX",
  },
  {
    zip: "75990",
    ST: "TX",
    cityWithStateAbbr: "Woodville, TX",
  },
  {
    zip: "76001",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76002",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76003",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76004",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76005",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76006",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76007",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76008",
    ST: "TX",
    cityWithStateAbbr: "Aledo, TX",
  },
  {
    zip: "76009",
    ST: "TX",
    cityWithStateAbbr: "Alvarado, TX",
  },
  {
    zip: "76010",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76011",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76012",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76013",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76014",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76015",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76016",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76017",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76018",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76019",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76020",
    ST: "TX",
    cityWithStateAbbr: "Azle, TX",
  },
  {
    zip: "76021",
    ST: "TX",
    cityWithStateAbbr: "Bedford, TX",
  },
  {
    zip: "76022",
    ST: "TX",
    cityWithStateAbbr: "Bedford, TX",
  },
  {
    zip: "76023",
    ST: "TX",
    cityWithStateAbbr: "Boyd, TX",
  },
  {
    zip: "76028",
    ST: "TX",
    cityWithStateAbbr: "Burleson, TX",
  },
  {
    zip: "76031",
    ST: "TX",
    cityWithStateAbbr: "Cleburne, TX",
  },
  {
    zip: "76033",
    ST: "TX",
    cityWithStateAbbr: "Cleburne, TX",
  },
  {
    zip: "76034",
    ST: "TX",
    cityWithStateAbbr: "Colleyville, TX",
  },
  {
    zip: "76035",
    ST: "TX",
    cityWithStateAbbr: "Cresson, TX",
  },
  {
    zip: "76036",
    ST: "TX",
    cityWithStateAbbr: "Crowley, TX",
  },
  {
    zip: "76039",
    ST: "TX",
    cityWithStateAbbr: "Euless, TX",
  },
  {
    zip: "76040",
    ST: "TX",
    cityWithStateAbbr: "Euless, TX",
  },
  {
    zip: "76041",
    ST: "TX",
    cityWithStateAbbr: "Forreston, TX",
  },
  {
    zip: "76043",
    ST: "TX",
    cityWithStateAbbr: "Glen Rose, TX",
  },
  {
    zip: "76044",
    ST: "TX",
    cityWithStateAbbr: "Godley, TX",
  },
  {
    zip: "76048",
    ST: "TX",
    cityWithStateAbbr: "Granbury, TX",
  },
  {
    zip: "76049",
    ST: "TX",
    cityWithStateAbbr: "Granbury, TX",
  },
  {
    zip: "76050",
    ST: "TX",
    cityWithStateAbbr: "Grandview, TX",
  },
  {
    zip: "76051",
    ST: "TX",
    cityWithStateAbbr: "Grapevine, TX",
  },
  {
    zip: "76052",
    ST: "TX",
    cityWithStateAbbr: "Haslet, TX",
  },
  {
    zip: "76053",
    ST: "TX",
    cityWithStateAbbr: "Hurst, TX",
  },
  {
    zip: "76054",
    ST: "TX",
    cityWithStateAbbr: "Hurst, TX",
  },
  {
    zip: "76055",
    ST: "TX",
    cityWithStateAbbr: "Itasca, TX",
  },
  {
    zip: "76058",
    ST: "TX",
    cityWithStateAbbr: "Joshua, TX",
  },
  {
    zip: "76059",
    ST: "TX",
    cityWithStateAbbr: "Keene, TX",
  },
  {
    zip: "76060",
    ST: "TX",
    cityWithStateAbbr: "Kennedale, TX",
  },
  {
    zip: "76061",
    ST: "TX",
    cityWithStateAbbr: "Lillian, TX",
  },
  {
    zip: "76063",
    ST: "TX",
    cityWithStateAbbr: "Mansfield, TX",
  },
  {
    zip: "76064",
    ST: "TX",
    cityWithStateAbbr: "Maypearl, TX",
  },
  {
    zip: "76065",
    ST: "TX",
    cityWithStateAbbr: "Midlothian, TX",
  },
  {
    zip: "76066",
    ST: "TX",
    cityWithStateAbbr: "Millsap, TX",
  },
  {
    zip: "76067",
    ST: "TX",
    cityWithStateAbbr: "Mineral Wells, TX",
  },
  {
    zip: "76068",
    ST: "TX",
    cityWithStateAbbr: "Mineral Wells, TX",
  },
  {
    zip: "76070",
    ST: "TX",
    cityWithStateAbbr: "Nemo, TX",
  },
  {
    zip: "76071",
    ST: "TX",
    cityWithStateAbbr: "Newark, TX",
  },
  {
    zip: "76073",
    ST: "TX",
    cityWithStateAbbr: "Paradise, TX",
  },
  {
    zip: "76077",
    ST: "TX",
    cityWithStateAbbr: "Rainbow, TX",
  },
  {
    zip: "76078",
    ST: "TX",
    cityWithStateAbbr: "Rhome, TX",
  },
  {
    zip: "76082",
    ST: "TX",
    cityWithStateAbbr: "Springtown, TX",
  },
  {
    zip: "76084",
    ST: "TX",
    cityWithStateAbbr: "Venus, TX",
  },
  {
    zip: "76085",
    ST: "TX",
    cityWithStateAbbr: "Weatherford, TX",
  },
  {
    zip: "76086",
    ST: "TX",
    cityWithStateAbbr: "Weatherford, TX",
  },
  {
    zip: "76087",
    ST: "TX",
    cityWithStateAbbr: "Weatherford, TX",
  },
  {
    zip: "76088",
    ST: "TX",
    cityWithStateAbbr: "Weatherford, TX",
  },
  {
    zip: "76092",
    ST: "TX",
    cityWithStateAbbr: "Southlake, TX",
  },
  {
    zip: "76093",
    ST: "TX",
    cityWithStateAbbr: "Rio Vista, TX",
  },
  {
    zip: "76094",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76095",
    ST: "TX",
    cityWithStateAbbr: "Bedford, TX",
  },
  {
    zip: "76096",
    ST: "TX",
    cityWithStateAbbr: "Arlington, TX",
  },
  {
    zip: "76097",
    ST: "TX",
    cityWithStateAbbr: "Burleson, TX",
  },
  {
    zip: "76098",
    ST: "TX",
    cityWithStateAbbr: "Azle, TX",
  },
  {
    zip: "76099",
    ST: "TX",
    cityWithStateAbbr: "Grapevine, TX",
  },
  {
    zip: "76101",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76102",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76103",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76104",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76105",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76106",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76107",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76108",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76109",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76110",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76111",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76112",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76113",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76114",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76115",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76116",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76117",
    ST: "TX",
    cityWithStateAbbr: "Haltom City, TX",
  },
  {
    zip: "76118",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76119",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76120",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76121",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76122",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76123",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76124",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76126",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76127",
    ST: "TX",
    cityWithStateAbbr: "Naval Air Station Jrb, TX",
  },
  {
    zip: "76129",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76130",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76131",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76132",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76133",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76134",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76135",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76136",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76137",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76140",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76147",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76148",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76150",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76155",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76161",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76162",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76163",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76164",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76166",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76177",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76179",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76180",
    ST: "TX",
    cityWithStateAbbr: "North Richland Hills, TX",
  },
  {
    zip: "76181",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76182",
    ST: "TX",
    cityWithStateAbbr: "North Richland Hills, TX",
  },
  {
    zip: "76185",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76190",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76191",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76192",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76193",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76195",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76196",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76197",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76198",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76199",
    ST: "TX",
    cityWithStateAbbr: "Fort Worth, TX",
  },
  {
    zip: "76201",
    ST: "TX",
    cityWithStateAbbr: "Denton, TX",
  },
  {
    zip: "76202",
    ST: "TX",
    cityWithStateAbbr: "Denton, TX",
  },
  {
    zip: "76203",
    ST: "TX",
    cityWithStateAbbr: "Denton, TX",
  },
  {
    zip: "76204",
    ST: "TX",
    cityWithStateAbbr: "Denton, TX",
  },
  {
    zip: "76205",
    ST: "TX",
    cityWithStateAbbr: "Denton, TX",
  },
  {
    zip: "76206",
    ST: "TX",
    cityWithStateAbbr: "Denton, TX",
  },
  {
    zip: "76207",
    ST: "TX",
    cityWithStateAbbr: "Denton, TX",
  },
  {
    zip: "76208",
    ST: "TX",
    cityWithStateAbbr: "Denton, TX",
  },
  {
    zip: "76209",
    ST: "TX",
    cityWithStateAbbr: "Denton, TX",
  },
  {
    zip: "76210",
    ST: "TX",
    cityWithStateAbbr: "Denton, TX",
  },
  {
    zip: "76225",
    ST: "TX",
    cityWithStateAbbr: "Alvord, TX",
  },
  {
    zip: "76226",
    ST: "TX",
    cityWithStateAbbr: "Argyle, TX",
  },
  {
    zip: "76227",
    ST: "TX",
    cityWithStateAbbr: "Aubrey, TX",
  },
  {
    zip: "76228",
    ST: "TX",
    cityWithStateAbbr: "Bellevue, TX",
  },
  {
    zip: "76230",
    ST: "TX",
    cityWithStateAbbr: "Bowie, TX",
  },
  {
    zip: "76233",
    ST: "TX",
    cityWithStateAbbr: "Collinsville, TX",
  },
  {
    zip: "76234",
    ST: "TX",
    cityWithStateAbbr: "Decatur, TX",
  },
  {
    zip: "76238",
    ST: "TX",
    cityWithStateAbbr: "Era, TX",
  },
  {
    zip: "76239",
    ST: "TX",
    cityWithStateAbbr: "Forestburg, TX",
  },
  {
    zip: "76240",
    ST: "TX",
    cityWithStateAbbr: "Gainesville, TX",
  },
  {
    zip: "76241",
    ST: "TX",
    cityWithStateAbbr: "Gainesville, TX",
  },
  {
    zip: "76244",
    ST: "TX",
    cityWithStateAbbr: "Keller, TX",
  },
  {
    zip: "76245",
    ST: "TX",
    cityWithStateAbbr: "Gordonville, TX",
  },
  {
    zip: "76246",
    ST: "TX",
    cityWithStateAbbr: "Greenwood, TX",
  },
  {
    zip: "76247",
    ST: "TX",
    cityWithStateAbbr: "Justin, TX",
  },
  {
    zip: "76248",
    ST: "TX",
    cityWithStateAbbr: "Keller, TX",
  },
  {
    zip: "76249",
    ST: "TX",
    cityWithStateAbbr: "Krum, TX",
  },
  {
    zip: "76250",
    ST: "TX",
    cityWithStateAbbr: "Lindsay, TX",
  },
  {
    zip: "76251",
    ST: "TX",
    cityWithStateAbbr: "Montague, TX",
  },
  {
    zip: "76252",
    ST: "TX",
    cityWithStateAbbr: "Muenster, TX",
  },
  {
    zip: "76253",
    ST: "TX",
    cityWithStateAbbr: "Myra, TX",
  },
  {
    zip: "76255",
    ST: "TX",
    cityWithStateAbbr: "Nocona, TX",
  },
  {
    zip: "76258",
    ST: "TX",
    cityWithStateAbbr: "Pilot Point, TX",
  },
  {
    zip: "76259",
    ST: "TX",
    cityWithStateAbbr: "Ponder, TX",
  },
  {
    zip: "76261",
    ST: "TX",
    cityWithStateAbbr: "Ringgold, TX",
  },
  {
    zip: "76262",
    ST: "TX",
    cityWithStateAbbr: "Roanoke, TX",
  },
  {
    zip: "76263",
    ST: "TX",
    cityWithStateAbbr: "Rosston, TX",
  },
  {
    zip: "76264",
    ST: "TX",
    cityWithStateAbbr: "Sadler, TX",
  },
  {
    zip: "76265",
    ST: "TX",
    cityWithStateAbbr: "Saint Jo, TX",
  },
  {
    zip: "76266",
    ST: "TX",
    cityWithStateAbbr: "Sanger, TX",
  },
  {
    zip: "76267",
    ST: "TX",
    cityWithStateAbbr: "Slidell, TX",
  },
  {
    zip: "76268",
    ST: "TX",
    cityWithStateAbbr: "Southmayd, TX",
  },
  {
    zip: "76270",
    ST: "TX",
    cityWithStateAbbr: "Sunset, TX",
  },
  {
    zip: "76271",
    ST: "TX",
    cityWithStateAbbr: "Tioga, TX",
  },
  {
    zip: "76272",
    ST: "TX",
    cityWithStateAbbr: "Valley View, TX",
  },
  {
    zip: "76273",
    ST: "TX",
    cityWithStateAbbr: "Whitesboro, TX",
  },
  {
    zip: "76301",
    ST: "TX",
    cityWithStateAbbr: "Wichita Falls, TX",
  },
  {
    zip: "76302",
    ST: "TX",
    cityWithStateAbbr: "Wichita Falls, TX",
  },
  {
    zip: "76305",
    ST: "TX",
    cityWithStateAbbr: "Wichita Falls, TX",
  },
  {
    zip: "76306",
    ST: "TX",
    cityWithStateAbbr: "Wichita Falls, TX",
  },
  {
    zip: "76307",
    ST: "TX",
    cityWithStateAbbr: "Wichita Falls, TX",
  },
  {
    zip: "76308",
    ST: "TX",
    cityWithStateAbbr: "Wichita Falls, TX",
  },
  {
    zip: "76309",
    ST: "TX",
    cityWithStateAbbr: "Wichita Falls, TX",
  },
  {
    zip: "76310",
    ST: "TX",
    cityWithStateAbbr: "Wichita Falls, TX",
  },
  {
    zip: "76311",
    ST: "TX",
    cityWithStateAbbr: "Sheppard Afb, TX",
  },
  {
    zip: "76351",
    ST: "TX",
    cityWithStateAbbr: "Archer City, TX",
  },
  {
    zip: "76352",
    ST: "TX",
    cityWithStateAbbr: "Bluegrove, TX",
  },
  {
    zip: "76354",
    ST: "TX",
    cityWithStateAbbr: "Burkburnett, TX",
  },
  {
    zip: "76357",
    ST: "TX",
    cityWithStateAbbr: "Byers, TX",
  },
  {
    zip: "76360",
    ST: "TX",
    cityWithStateAbbr: "Electra, TX",
  },
  {
    zip: "76363",
    ST: "TX",
    cityWithStateAbbr: "Goree, TX",
  },
  {
    zip: "76364",
    ST: "TX",
    cityWithStateAbbr: "Harrold, TX",
  },
  {
    zip: "76365",
    ST: "TX",
    cityWithStateAbbr: "Henrietta, TX",
  },
  {
    zip: "76366",
    ST: "TX",
    cityWithStateAbbr: "Holliday, TX",
  },
  {
    zip: "76367",
    ST: "TX",
    cityWithStateAbbr: "Iowa Park, TX",
  },
  {
    zip: "76369",
    ST: "TX",
    cityWithStateAbbr: "Kamay, TX",
  },
  {
    zip: "76370",
    ST: "TX",
    cityWithStateAbbr: "Megargel, TX",
  },
  {
    zip: "76371",
    ST: "TX",
    cityWithStateAbbr: "Munday, TX",
  },
  {
    zip: "76372",
    ST: "TX",
    cityWithStateAbbr: "Newcastle, TX",
  },
  {
    zip: "76373",
    ST: "TX",
    cityWithStateAbbr: "Oklaunion, TX",
  },
  {
    zip: "76374",
    ST: "TX",
    cityWithStateAbbr: "Olney, TX",
  },
  {
    zip: "76377",
    ST: "TX",
    cityWithStateAbbr: "Petrolia, TX",
  },
  {
    zip: "76379",
    ST: "TX",
    cityWithStateAbbr: "Scotland, TX",
  },
  {
    zip: "76380",
    ST: "TX",
    cityWithStateAbbr: "Seymour, TX",
  },
  {
    zip: "76384",
    ST: "TX",
    cityWithStateAbbr: "Vernon, TX",
  },
  {
    zip: "76385",
    ST: "TX",
    cityWithStateAbbr: "Vernon, TX",
  },
  {
    zip: "76388",
    ST: "TX",
    cityWithStateAbbr: "Weinert, TX",
  },
  {
    zip: "76389",
    ST: "TX",
    cityWithStateAbbr: "Windthorst, TX",
  },
  {
    zip: "76401",
    ST: "TX",
    cityWithStateAbbr: "Stephenville, TX",
  },
  {
    zip: "76402",
    ST: "TX",
    cityWithStateAbbr: "Stephenville, TX",
  },
  {
    zip: "76424",
    ST: "TX",
    cityWithStateAbbr: "Breckenridge, TX",
  },
  {
    zip: "76426",
    ST: "TX",
    cityWithStateAbbr: "Bridgeport, TX",
  },
  {
    zip: "76427",
    ST: "TX",
    cityWithStateAbbr: "Bryson, TX",
  },
  {
    zip: "76429",
    ST: "TX",
    cityWithStateAbbr: "Caddo, TX",
  },
  {
    zip: "76430",
    ST: "TX",
    cityWithStateAbbr: "Albany, TX",
  },
  {
    zip: "76431",
    ST: "TX",
    cityWithStateAbbr: "Chico, TX",
  },
  {
    zip: "76432",
    ST: "TX",
    cityWithStateAbbr: "Blanket, TX",
  },
  {
    zip: "76433",
    ST: "TX",
    cityWithStateAbbr: "Bluff Dale, TX",
  },
  {
    zip: "76435",
    ST: "TX",
    cityWithStateAbbr: "Carbon, TX",
  },
  {
    zip: "76436",
    ST: "TX",
    cityWithStateAbbr: "Carlton, TX",
  },
  {
    zip: "76437",
    ST: "TX",
    cityWithStateAbbr: "Cisco, TX",
  },
  {
    zip: "76439",
    ST: "TX",
    cityWithStateAbbr: "Dennis, TX",
  },
  {
    zip: "76442",
    ST: "TX",
    cityWithStateAbbr: "Comanche, TX",
  },
  {
    zip: "76443",
    ST: "TX",
    cityWithStateAbbr: "Cross Plains, TX",
  },
  {
    zip: "76444",
    ST: "TX",
    cityWithStateAbbr: "De Leon, TX",
  },
  {
    zip: "76445",
    ST: "TX",
    cityWithStateAbbr: "Desdemona, TX",
  },
  {
    zip: "76446",
    ST: "TX",
    cityWithStateAbbr: "Dublin, TX",
  },
  {
    zip: "76448",
    ST: "TX",
    cityWithStateAbbr: "Eastland, TX",
  },
  {
    zip: "76449",
    ST: "TX",
    cityWithStateAbbr: "Graford, TX",
  },
  {
    zip: "76450",
    ST: "TX",
    cityWithStateAbbr: "Graham, TX",
  },
  {
    zip: "76452",
    ST: "TX",
    cityWithStateAbbr: "Energy, TX",
  },
  {
    zip: "76453",
    ST: "TX",
    cityWithStateAbbr: "Gordon, TX",
  },
  {
    zip: "76454",
    ST: "TX",
    cityWithStateAbbr: "Gorman, TX",
  },
  {
    zip: "76455",
    ST: "TX",
    cityWithStateAbbr: "Gustine, TX",
  },
  {
    zip: "76457",
    ST: "TX",
    cityWithStateAbbr: "Hico, TX",
  },
  {
    zip: "76458",
    ST: "TX",
    cityWithStateAbbr: "Jacksboro, TX",
  },
  {
    zip: "76459",
    ST: "TX",
    cityWithStateAbbr: "Jermyn, TX",
  },
  {
    zip: "76460",
    ST: "TX",
    cityWithStateAbbr: "Loving, TX",
  },
  {
    zip: "76461",
    ST: "TX",
    cityWithStateAbbr: "Lingleville, TX",
  },
  {
    zip: "76462",
    ST: "TX",
    cityWithStateAbbr: "Lipan, TX",
  },
  {
    zip: "76463",
    ST: "TX",
    cityWithStateAbbr: "Mingus, TX",
  },
  {
    zip: "76464",
    ST: "TX",
    cityWithStateAbbr: "Moran, TX",
  },
  {
    zip: "76465",
    ST: "TX",
    cityWithStateAbbr: "Morgan Mill, TX",
  },
  {
    zip: "76466",
    ST: "TX",
    cityWithStateAbbr: "Olden, TX",
  },
  {
    zip: "76467",
    ST: "TX",
    cityWithStateAbbr: "Paluxy, TX",
  },
  {
    zip: "76468",
    ST: "TX",
    cityWithStateAbbr: "Proctor, TX",
  },
  {
    zip: "76469",
    ST: "TX",
    cityWithStateAbbr: "Putnam, TX",
  },
  {
    zip: "76470",
    ST: "TX",
    cityWithStateAbbr: "Ranger, TX",
  },
  {
    zip: "76471",
    ST: "TX",
    cityWithStateAbbr: "Rising Star, TX",
  },
  {
    zip: "76472",
    ST: "TX",
    cityWithStateAbbr: "Santo, TX",
  },
  {
    zip: "76474",
    ST: "TX",
    cityWithStateAbbr: "Sidney, TX",
  },
  {
    zip: "76475",
    ST: "TX",
    cityWithStateAbbr: "Strawn, TX",
  },
  {
    zip: "76476",
    ST: "TX",
    cityWithStateAbbr: "Tolar, TX",
  },
  {
    zip: "76481",
    ST: "TX",
    cityWithStateAbbr: "South Bend, TX",
  },
  {
    zip: "76483",
    ST: "TX",
    cityWithStateAbbr: "Throckmorton, TX",
  },
  {
    zip: "76484",
    ST: "TX",
    cityWithStateAbbr: "Palo Pinto, TX",
  },
  {
    zip: "76485",
    ST: "TX",
    cityWithStateAbbr: "Peaster, TX",
  },
  {
    zip: "76486",
    ST: "TX",
    cityWithStateAbbr: "Perrin, TX",
  },
  {
    zip: "76487",
    ST: "TX",
    cityWithStateAbbr: "Poolville, TX",
  },
  {
    zip: "76490",
    ST: "TX",
    cityWithStateAbbr: "Whitt, TX",
  },
  {
    zip: "76491",
    ST: "TX",
    cityWithStateAbbr: "Woodson, TX",
  },
  {
    zip: "76501",
    ST: "TX",
    cityWithStateAbbr: "Temple, TX",
  },
  {
    zip: "76502",
    ST: "TX",
    cityWithStateAbbr: "Temple, TX",
  },
  {
    zip: "76503",
    ST: "TX",
    cityWithStateAbbr: "Temple, TX",
  },
  {
    zip: "76504",
    ST: "TX",
    cityWithStateAbbr: "Temple, TX",
  },
  {
    zip: "76505",
    ST: "TX",
    cityWithStateAbbr: "Temple, TX",
  },
  {
    zip: "76508",
    ST: "TX",
    cityWithStateAbbr: "Temple, TX",
  },
  {
    zip: "76511",
    ST: "TX",
    cityWithStateAbbr: "Bartlett, TX",
  },
  {
    zip: "76513",
    ST: "TX",
    cityWithStateAbbr: "Belton, TX",
  },
  {
    zip: "76518",
    ST: "TX",
    cityWithStateAbbr: "Buckholts, TX",
  },
  {
    zip: "76519",
    ST: "TX",
    cityWithStateAbbr: "Burlington, TX",
  },
  {
    zip: "76520",
    ST: "TX",
    cityWithStateAbbr: "Cameron, TX",
  },
  {
    zip: "76522",
    ST: "TX",
    cityWithStateAbbr: "Copperas Cove, TX",
  },
  {
    zip: "76523",
    ST: "TX",
    cityWithStateAbbr: "Davilla, TX",
  },
  {
    zip: "76524",
    ST: "TX",
    cityWithStateAbbr: "Eddy, TX",
  },
  {
    zip: "76525",
    ST: "TX",
    cityWithStateAbbr: "Evant, TX",
  },
  {
    zip: "76526",
    ST: "TX",
    cityWithStateAbbr: "Flat, TX",
  },
  {
    zip: "76527",
    ST: "TX",
    cityWithStateAbbr: "Florence, TX",
  },
  {
    zip: "76528",
    ST: "TX",
    cityWithStateAbbr: "Gatesville, TX",
  },
  {
    zip: "76530",
    ST: "TX",
    cityWithStateAbbr: "Granger, TX",
  },
  {
    zip: "76531",
    ST: "TX",
    cityWithStateAbbr: "Hamilton, TX",
  },
  {
    zip: "76533",
    ST: "TX",
    cityWithStateAbbr: "Heidenheimer, TX",
  },
  {
    zip: "76534",
    ST: "TX",
    cityWithStateAbbr: "Holland, TX",
  },
  {
    zip: "76537",
    ST: "TX",
    cityWithStateAbbr: "Jarrell, TX",
  },
  {
    zip: "76538",
    ST: "TX",
    cityWithStateAbbr: "Jonesboro, TX",
  },
  {
    zip: "76539",
    ST: "TX",
    cityWithStateAbbr: "Kempner, TX",
  },
  {
    zip: "76540",
    ST: "TX",
    cityWithStateAbbr: "Killeen, TX",
  },
  {
    zip: "76541",
    ST: "TX",
    cityWithStateAbbr: "Killeen, TX",
  },
  {
    zip: "76542",
    ST: "TX",
    cityWithStateAbbr: "Killeen, TX",
  },
  {
    zip: "76543",
    ST: "TX",
    cityWithStateAbbr: "Killeen, TX",
  },
  {
    zip: "76544",
    ST: "TX",
    cityWithStateAbbr: "Fort Hood, TX",
  },
  {
    zip: "76547",
    ST: "TX",
    cityWithStateAbbr: "Killeen, TX",
  },
  {
    zip: "76548",
    ST: "TX",
    cityWithStateAbbr: "Harker Heights, TX",
  },
  {
    zip: "76549",
    ST: "TX",
    cityWithStateAbbr: "Killeen, TX",
  },
  {
    zip: "76550",
    ST: "TX",
    cityWithStateAbbr: "Lampasas, TX",
  },
  {
    zip: "76554",
    ST: "TX",
    cityWithStateAbbr: "Little River Academy, TX",
  },
  {
    zip: "76556",
    ST: "TX",
    cityWithStateAbbr: "Milano, TX",
  },
  {
    zip: "76557",
    ST: "TX",
    cityWithStateAbbr: "Moody, TX",
  },
  {
    zip: "76558",
    ST: "TX",
    cityWithStateAbbr: "Mound, TX",
  },
  {
    zip: "76559",
    ST: "TX",
    cityWithStateAbbr: "Nolanville, TX",
  },
  {
    zip: "76561",
    ST: "TX",
    cityWithStateAbbr: "Oglesby, TX",
  },
  {
    zip: "76564",
    ST: "TX",
    cityWithStateAbbr: "Pendleton, TX",
  },
  {
    zip: "76565",
    ST: "TX",
    cityWithStateAbbr: "Pottsville, TX",
  },
  {
    zip: "76566",
    ST: "TX",
    cityWithStateAbbr: "Purmela, TX",
  },
  {
    zip: "76567",
    ST: "TX",
    cityWithStateAbbr: "Rockdale, TX",
  },
  {
    zip: "76569",
    ST: "TX",
    cityWithStateAbbr: "Rogers, TX",
  },
  {
    zip: "76570",
    ST: "TX",
    cityWithStateAbbr: "Rosebud, TX",
  },
  {
    zip: "76571",
    ST: "TX",
    cityWithStateAbbr: "Salado, TX",
  },
  {
    zip: "76573",
    ST: "TX",
    cityWithStateAbbr: "Schwertner, TX",
  },
  {
    zip: "76574",
    ST: "TX",
    cityWithStateAbbr: "Taylor, TX",
  },
  {
    zip: "76577",
    ST: "TX",
    cityWithStateAbbr: "Thorndale, TX",
  },
  {
    zip: "76578",
    ST: "TX",
    cityWithStateAbbr: "Thrall, TX",
  },
  {
    zip: "76579",
    ST: "TX",
    cityWithStateAbbr: "Troy, TX",
  },
  {
    zip: "76596",
    ST: "TX",
    cityWithStateAbbr: "Gatesville, TX",
  },
  {
    zip: "76597",
    ST: "TX",
    cityWithStateAbbr: "Gatesville, TX",
  },
  {
    zip: "76598",
    ST: "TX",
    cityWithStateAbbr: "Gatesville, TX",
  },
  {
    zip: "76599",
    ST: "TX",
    cityWithStateAbbr: "Gatesville, TX",
  },
  {
    zip: "76621",
    ST: "TX",
    cityWithStateAbbr: "Abbott, TX",
  },
  {
    zip: "76622",
    ST: "TX",
    cityWithStateAbbr: "Aquilla, TX",
  },
  {
    zip: "76623",
    ST: "TX",
    cityWithStateAbbr: "Avalon, TX",
  },
  {
    zip: "76624",
    ST: "TX",
    cityWithStateAbbr: "Axtell, TX",
  },
  {
    zip: "76626",
    ST: "TX",
    cityWithStateAbbr: "Blooming Grove, TX",
  },
  {
    zip: "76627",
    ST: "TX",
    cityWithStateAbbr: "Blum, TX",
  },
  {
    zip: "76628",
    ST: "TX",
    cityWithStateAbbr: "Brandon, TX",
  },
  {
    zip: "76629",
    ST: "TX",
    cityWithStateAbbr: "Bremond, TX",
  },
  {
    zip: "76630",
    ST: "TX",
    cityWithStateAbbr: "Bruceville, TX",
  },
  {
    zip: "76631",
    ST: "TX",
    cityWithStateAbbr: "Bynum, TX",
  },
  {
    zip: "76632",
    ST: "TX",
    cityWithStateAbbr: "Chilton, TX",
  },
  {
    zip: "76633",
    ST: "TX",
    cityWithStateAbbr: "China Spring, TX",
  },
  {
    zip: "76634",
    ST: "TX",
    cityWithStateAbbr: "Clifton, TX",
  },
  {
    zip: "76635",
    ST: "TX",
    cityWithStateAbbr: "Coolidge, TX",
  },
  {
    zip: "76636",
    ST: "TX",
    cityWithStateAbbr: "Covington, TX",
  },
  {
    zip: "76637",
    ST: "TX",
    cityWithStateAbbr: "Cranfills Gap, TX",
  },
  {
    zip: "76638",
    ST: "TX",
    cityWithStateAbbr: "Crawford, TX",
  },
  {
    zip: "76639",
    ST: "TX",
    cityWithStateAbbr: "Dawson, TX",
  },
  {
    zip: "76640",
    ST: "TX",
    cityWithStateAbbr: "Elm Mott, TX",
  },
  {
    zip: "76641",
    ST: "TX",
    cityWithStateAbbr: "Frost, TX",
  },
  {
    zip: "76642",
    ST: "TX",
    cityWithStateAbbr: "Groesbeck, TX",
  },
  {
    zip: "76643",
    ST: "TX",
    cityWithStateAbbr: "Hewitt, TX",
  },
  {
    zip: "76644",
    ST: "TX",
    cityWithStateAbbr: "Laguna Park, TX",
  },
  {
    zip: "76645",
    ST: "TX",
    cityWithStateAbbr: "Hillsboro, TX",
  },
  {
    zip: "76648",
    ST: "TX",
    cityWithStateAbbr: "Hubbard, TX",
  },
  {
    zip: "76649",
    ST: "TX",
    cityWithStateAbbr: "Iredell, TX",
  },
  {
    zip: "76650",
    ST: "TX",
    cityWithStateAbbr: "Irene, TX",
  },
  {
    zip: "76651",
    ST: "TX",
    cityWithStateAbbr: "Italy, TX",
  },
  {
    zip: "76652",
    ST: "TX",
    cityWithStateAbbr: "Kopperl, TX",
  },
  {
    zip: "76653",
    ST: "TX",
    cityWithStateAbbr: "Kosse, TX",
  },
  {
    zip: "76654",
    ST: "TX",
    cityWithStateAbbr: "Leroy, TX",
  },
  {
    zip: "76655",
    ST: "TX",
    cityWithStateAbbr: "Lorena, TX",
  },
  {
    zip: "76656",
    ST: "TX",
    cityWithStateAbbr: "Lott, TX",
  },
  {
    zip: "76657",
    ST: "TX",
    cityWithStateAbbr: "Mc Gregor, TX",
  },
  {
    zip: "76660",
    ST: "TX",
    cityWithStateAbbr: "Malone, TX",
  },
  {
    zip: "76661",
    ST: "TX",
    cityWithStateAbbr: "Marlin, TX",
  },
  {
    zip: "76664",
    ST: "TX",
    cityWithStateAbbr: "Mart, TX",
  },
  {
    zip: "76665",
    ST: "TX",
    cityWithStateAbbr: "Meridian, TX",
  },
  {
    zip: "76666",
    ST: "TX",
    cityWithStateAbbr: "Mertens, TX",
  },
  {
    zip: "76667",
    ST: "TX",
    cityWithStateAbbr: "Mexia, TX",
  },
  {
    zip: "76670",
    ST: "TX",
    cityWithStateAbbr: "Milford, TX",
  },
  {
    zip: "76671",
    ST: "TX",
    cityWithStateAbbr: "Morgan, TX",
  },
  {
    zip: "76673",
    ST: "TX",
    cityWithStateAbbr: "Mount Calm, TX",
  },
  {
    zip: "76676",
    ST: "TX",
    cityWithStateAbbr: "Penelope, TX",
  },
  {
    zip: "76678",
    ST: "TX",
    cityWithStateAbbr: "Prairie Hill, TX",
  },
  {
    zip: "76679",
    ST: "TX",
    cityWithStateAbbr: "Purdon, TX",
  },
  {
    zip: "76680",
    ST: "TX",
    cityWithStateAbbr: "Reagan, TX",
  },
  {
    zip: "76681",
    ST: "TX",
    cityWithStateAbbr: "Richland, TX",
  },
  {
    zip: "76682",
    ST: "TX",
    cityWithStateAbbr: "Riesel, TX",
  },
  {
    zip: "76684",
    ST: "TX",
    cityWithStateAbbr: "Ross, TX",
  },
  {
    zip: "76685",
    ST: "TX",
    cityWithStateAbbr: "Satin, TX",
  },
  {
    zip: "76686",
    ST: "TX",
    cityWithStateAbbr: "Tehuacana, TX",
  },
  {
    zip: "76687",
    ST: "TX",
    cityWithStateAbbr: "Thornton, TX",
  },
  {
    zip: "76689",
    ST: "TX",
    cityWithStateAbbr: "Valley Mills, TX",
  },
  {
    zip: "76690",
    ST: "TX",
    cityWithStateAbbr: "Walnut Springs, TX",
  },
  {
    zip: "76691",
    ST: "TX",
    cityWithStateAbbr: "West, TX",
  },
  {
    zip: "76692",
    ST: "TX",
    cityWithStateAbbr: "Whitney, TX",
  },
  {
    zip: "76693",
    ST: "TX",
    cityWithStateAbbr: "Wortham, TX",
  },
  {
    zip: "76701",
    ST: "TX",
    cityWithStateAbbr: "Waco, TX",
  },
  {
    zip: "76702",
    ST: "TX",
    cityWithStateAbbr: "Waco, TX",
  },
  {
    zip: "76703",
    ST: "TX",
    cityWithStateAbbr: "Waco, TX",
  },
  {
    zip: "76704",
    ST: "TX",
    cityWithStateAbbr: "Waco, TX",
  },
  {
    zip: "76705",
    ST: "TX",
    cityWithStateAbbr: "Waco, TX",
  },
  {
    zip: "76706",
    ST: "TX",
    cityWithStateAbbr: "Waco, TX",
  },
  {
    zip: "76707",
    ST: "TX",
    cityWithStateAbbr: "Waco, TX",
  },
  {
    zip: "76708",
    ST: "TX",
    cityWithStateAbbr: "Waco, TX",
  },
  {
    zip: "76710",
    ST: "TX",
    cityWithStateAbbr: "Waco, TX",
  },
  {
    zip: "76711",
    ST: "TX",
    cityWithStateAbbr: "Waco, TX",
  },
  {
    zip: "76712",
    ST: "TX",
    cityWithStateAbbr: "Woodway, TX",
  },
  {
    zip: "76714",
    ST: "TX",
    cityWithStateAbbr: "Waco, TX",
  },
  {
    zip: "76715",
    ST: "TX",
    cityWithStateAbbr: "Waco, TX",
  },
  {
    zip: "76716",
    ST: "TX",
    cityWithStateAbbr: "Waco, TX",
  },
  {
    zip: "76797",
    ST: "TX",
    cityWithStateAbbr: "Waco, TX",
  },
  {
    zip: "76798",
    ST: "TX",
    cityWithStateAbbr: "Waco, TX",
  },
  {
    zip: "76799",
    ST: "TX",
    cityWithStateAbbr: "Waco, TX",
  },
  {
    zip: "76801",
    ST: "TX",
    cityWithStateAbbr: "Brownwood, TX",
  },
  {
    zip: "76802",
    ST: "TX",
    cityWithStateAbbr: "Early, TX",
  },
  {
    zip: "76803",
    ST: "TX",
    cityWithStateAbbr: "Early, TX",
  },
  {
    zip: "76804",
    ST: "TX",
    cityWithStateAbbr: "Brownwood, TX",
  },
  {
    zip: "76820",
    ST: "TX",
    cityWithStateAbbr: "Art, TX",
  },
  {
    zip: "76821",
    ST: "TX",
    cityWithStateAbbr: "Ballinger, TX",
  },
  {
    zip: "76823",
    ST: "TX",
    cityWithStateAbbr: "Bangs, TX",
  },
  {
    zip: "76824",
    ST: "TX",
    cityWithStateAbbr: "Bend, TX",
  },
  {
    zip: "76825",
    ST: "TX",
    cityWithStateAbbr: "Brady, TX",
  },
  {
    zip: "76827",
    ST: "TX",
    cityWithStateAbbr: "Brookesmith, TX",
  },
  {
    zip: "76828",
    ST: "TX",
    cityWithStateAbbr: "Burkett, TX",
  },
  {
    zip: "76831",
    ST: "TX",
    cityWithStateAbbr: "Castell, TX",
  },
  {
    zip: "76832",
    ST: "TX",
    cityWithStateAbbr: "Cherokee, TX",
  },
  {
    zip: "76834",
    ST: "TX",
    cityWithStateAbbr: "Coleman, TX",
  },
  {
    zip: "76836",
    ST: "TX",
    cityWithStateAbbr: "Doole, TX",
  },
  {
    zip: "76837",
    ST: "TX",
    cityWithStateAbbr: "Eden, TX",
  },
  {
    zip: "76841",
    ST: "TX",
    cityWithStateAbbr: "Fort Mc Kavett, TX",
  },
  {
    zip: "76842",
    ST: "TX",
    cityWithStateAbbr: "Fredonia, TX",
  },
  {
    zip: "76844",
    ST: "TX",
    cityWithStateAbbr: "Goldthwaite, TX",
  },
  {
    zip: "76845",
    ST: "TX",
    cityWithStateAbbr: "Gouldbusk, TX",
  },
  {
    zip: "76848",
    ST: "TX",
    cityWithStateAbbr: "Hext, TX",
  },
  {
    zip: "76849",
    ST: "TX",
    cityWithStateAbbr: "Junction, TX",
  },
  {
    zip: "76852",
    ST: "TX",
    cityWithStateAbbr: "Lohn, TX",
  },
  {
    zip: "76853",
    ST: "TX",
    cityWithStateAbbr: "Lometa, TX",
  },
  {
    zip: "76854",
    ST: "TX",
    cityWithStateAbbr: "London, TX",
  },
  {
    zip: "76855",
    ST: "TX",
    cityWithStateAbbr: "Lowake, TX",
  },
  {
    zip: "76856",
    ST: "TX",
    cityWithStateAbbr: "Mason, TX",
  },
  {
    zip: "76857",
    ST: "TX",
    cityWithStateAbbr: "May, TX",
  },
  {
    zip: "76858",
    ST: "TX",
    cityWithStateAbbr: "Melvin, TX",
  },
  {
    zip: "76859",
    ST: "TX",
    cityWithStateAbbr: "Menard, TX",
  },
  {
    zip: "76861",
    ST: "TX",
    cityWithStateAbbr: "Miles, TX",
  },
  {
    zip: "76862",
    ST: "TX",
    cityWithStateAbbr: "Millersview, TX",
  },
  {
    zip: "76864",
    ST: "TX",
    cityWithStateAbbr: "Mullin, TX",
  },
  {
    zip: "76865",
    ST: "TX",
    cityWithStateAbbr: "Norton, TX",
  },
  {
    zip: "76866",
    ST: "TX",
    cityWithStateAbbr: "Paint Rock, TX",
  },
  {
    zip: "76869",
    ST: "TX",
    cityWithStateAbbr: "Pontotoc, TX",
  },
  {
    zip: "76870",
    ST: "TX",
    cityWithStateAbbr: "Priddy, TX",
  },
  {
    zip: "76871",
    ST: "TX",
    cityWithStateAbbr: "Richland Springs, TX",
  },
  {
    zip: "76872",
    ST: "TX",
    cityWithStateAbbr: "Rochelle, TX",
  },
  {
    zip: "76873",
    ST: "TX",
    cityWithStateAbbr: "Rockwood, TX",
  },
  {
    zip: "76874",
    ST: "TX",
    cityWithStateAbbr: "Roosevelt, TX",
  },
  {
    zip: "76875",
    ST: "TX",
    cityWithStateAbbr: "Rowena, TX",
  },
  {
    zip: "76877",
    ST: "TX",
    cityWithStateAbbr: "San Saba, TX",
  },
  {
    zip: "76878",
    ST: "TX",
    cityWithStateAbbr: "Santa Anna, TX",
  },
  {
    zip: "76880",
    ST: "TX",
    cityWithStateAbbr: "Star, TX",
  },
  {
    zip: "76882",
    ST: "TX",
    cityWithStateAbbr: "Talpa, TX",
  },
  {
    zip: "76883",
    ST: "TX",
    cityWithStateAbbr: "Telegraph, TX",
  },
  {
    zip: "76884",
    ST: "TX",
    cityWithStateAbbr: "Valera, TX",
  },
  {
    zip: "76885",
    ST: "TX",
    cityWithStateAbbr: "Valley Spring, TX",
  },
  {
    zip: "76886",
    ST: "TX",
    cityWithStateAbbr: "Veribest, TX",
  },
  {
    zip: "76887",
    ST: "TX",
    cityWithStateAbbr: "Voca, TX",
  },
  {
    zip: "76888",
    ST: "TX",
    cityWithStateAbbr: "Voss, TX",
  },
  {
    zip: "76890",
    ST: "TX",
    cityWithStateAbbr: "Zephyr, TX",
  },
  {
    zip: "76901",
    ST: "TX",
    cityWithStateAbbr: "San Angelo, TX",
  },
  {
    zip: "76902",
    ST: "TX",
    cityWithStateAbbr: "San Angelo, TX",
  },
  {
    zip: "76903",
    ST: "TX",
    cityWithStateAbbr: "San Angelo, TX",
  },
  {
    zip: "76904",
    ST: "TX",
    cityWithStateAbbr: "San Angelo, TX",
  },
  {
    zip: "76905",
    ST: "TX",
    cityWithStateAbbr: "San Angelo, TX",
  },
  {
    zip: "76906",
    ST: "TX",
    cityWithStateAbbr: "San Angelo, TX",
  },
  {
    zip: "76908",
    ST: "TX",
    cityWithStateAbbr: "Goodfellow Afb, TX",
  },
  {
    zip: "76909",
    ST: "TX",
    cityWithStateAbbr: "San Angelo, TX",
  },
  {
    zip: "76930",
    ST: "TX",
    cityWithStateAbbr: "Barnhart, TX",
  },
  {
    zip: "76932",
    ST: "TX",
    cityWithStateAbbr: "Big Lake, TX",
  },
  {
    zip: "76933",
    ST: "TX",
    cityWithStateAbbr: "Bronte, TX",
  },
  {
    zip: "76934",
    ST: "TX",
    cityWithStateAbbr: "Carlsbad, TX",
  },
  {
    zip: "76935",
    ST: "TX",
    cityWithStateAbbr: "Christoval, TX",
  },
  {
    zip: "76936",
    ST: "TX",
    cityWithStateAbbr: "Eldorado, TX",
  },
  {
    zip: "76937",
    ST: "TX",
    cityWithStateAbbr: "Eola, TX",
  },
  {
    zip: "76939",
    ST: "TX",
    cityWithStateAbbr: "Knickerbocker, TX",
  },
  {
    zip: "76940",
    ST: "TX",
    cityWithStateAbbr: "Mereta, TX",
  },
  {
    zip: "76941",
    ST: "TX",
    cityWithStateAbbr: "Mertzon, TX",
  },
  {
    zip: "76943",
    ST: "TX",
    cityWithStateAbbr: "Ozona, TX",
  },
  {
    zip: "76945",
    ST: "TX",
    cityWithStateAbbr: "Robert Lee, TX",
  },
  {
    zip: "76949",
    ST: "TX",
    cityWithStateAbbr: "Silver, TX",
  },
  {
    zip: "76950",
    ST: "TX",
    cityWithStateAbbr: "Sonora, TX",
  },
  {
    zip: "76951",
    ST: "TX",
    cityWithStateAbbr: "Sterling City, TX",
  },
  {
    zip: "76953",
    ST: "TX",
    cityWithStateAbbr: "Tennyson, TX",
  },
  {
    zip: "76955",
    ST: "TX",
    cityWithStateAbbr: "Vancourt, TX",
  },
  {
    zip: "76957",
    ST: "TX",
    cityWithStateAbbr: "Wall, TX",
  },
  {
    zip: "76958",
    ST: "TX",
    cityWithStateAbbr: "Water Valley, TX",
  },
  {
    zip: "77001",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77002",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77003",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77004",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77005",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77006",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77007",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77008",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77009",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77010",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77011",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77012",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77013",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77014",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77015",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77016",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77017",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77018",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77019",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77020",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77021",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77022",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77023",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77024",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77025",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77026",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77027",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77028",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77029",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77030",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77031",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77032",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77033",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77034",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77035",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77036",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77037",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77038",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77039",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77040",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77041",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77042",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77043",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77044",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77045",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77046",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77047",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77048",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77049",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77050",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77051",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77052",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77053",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77054",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77055",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77056",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77057",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77058",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77059",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77060",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77061",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77062",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77063",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77064",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77065",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77066",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77067",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77068",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77069",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77070",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77071",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77072",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77073",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77074",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77075",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77076",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77077",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77078",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77079",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77080",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77081",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77082",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77083",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77084",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77085",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77086",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77087",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77088",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77089",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77090",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77091",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77092",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77093",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77094",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77095",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77096",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77098",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77099",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77201",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77202",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77203",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77204",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77205",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77206",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77207",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77208",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77209",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77210",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77212",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77213",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77215",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77216",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77217",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77218",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77219",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77220",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77221",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77222",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77223",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77224",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77225",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77226",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77227",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77228",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77229",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77230",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77231",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77233",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77234",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77235",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77236",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77237",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77238",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77240",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77241",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77242",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77243",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77244",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77245",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77248",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77249",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77250",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77251",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77252",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77253",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77254",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77255",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77256",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77257",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77258",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77259",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77261",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77262",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77263",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77265",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77266",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77267",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77268",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77269",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77270",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77271",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77272",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77273",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77274",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77275",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77277",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77279",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77280",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77282",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77284",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77287",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77288",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77289",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77290",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77291",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77292",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77293",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77297",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77299",
    ST: "TX",
    cityWithStateAbbr: "Houston, TX",
  },
  {
    zip: "77301",
    ST: "TX",
    cityWithStateAbbr: "Conroe, TX",
  },
  {
    zip: "77302",
    ST: "TX",
    cityWithStateAbbr: "Conroe, TX",
  },
  {
    zip: "77303",
    ST: "TX",
    cityWithStateAbbr: "Conroe, TX",
  },
  {
    zip: "77304",
    ST: "TX",
    cityWithStateAbbr: "Conroe, TX",
  },
  {
    zip: "77305",
    ST: "TX",
    cityWithStateAbbr: "Conroe, TX",
  },
  {
    zip: "77306",
    ST: "TX",
    cityWithStateAbbr: "Conroe, TX",
  },
  {
    zip: "77315",
    ST: "TX",
    cityWithStateAbbr: "North Houston, TX",
  },
  {
    zip: "77316",
    ST: "TX",
    cityWithStateAbbr: "Montgomery, TX",
  },
  {
    zip: "77318",
    ST: "TX",
    cityWithStateAbbr: "Willis, TX",
  },
  {
    zip: "77320",
    ST: "TX",
    cityWithStateAbbr: "Huntsville, TX",
  },
  {
    zip: "77325",
    ST: "TX",
    cityWithStateAbbr: "Kingwood, TX",
  },
  {
    zip: "77326",
    ST: "TX",
    cityWithStateAbbr: "Ace, TX",
  },
  {
    zip: "77327",
    ST: "TX",
    cityWithStateAbbr: "Cleveland, TX",
  },
  {
    zip: "77328",
    ST: "TX",
    cityWithStateAbbr: "Cleveland, TX",
  },
  {
    zip: "77331",
    ST: "TX",
    cityWithStateAbbr: "Coldspring, TX",
  },
  {
    zip: "77332",
    ST: "TX",
    cityWithStateAbbr: "Dallardsville, TX",
  },
  {
    zip: "77333",
    ST: "TX",
    cityWithStateAbbr: "Dobbin, TX",
  },
  {
    zip: "77334",
    ST: "TX",
    cityWithStateAbbr: "Dodge, TX",
  },
  {
    zip: "77335",
    ST: "TX",
    cityWithStateAbbr: "Goodrich, TX",
  },
  {
    zip: "77336",
    ST: "TX",
    cityWithStateAbbr: "Huffman, TX",
  },
  {
    zip: "77338",
    ST: "TX",
    cityWithStateAbbr: "Humble, TX",
  },
  {
    zip: "77339",
    ST: "TX",
    cityWithStateAbbr: "Kingwood, TX",
  },
  {
    zip: "77340",
    ST: "TX",
    cityWithStateAbbr: "Huntsville, TX",
  },
  {
    zip: "77341",
    ST: "TX",
    cityWithStateAbbr: "Huntsville, TX",
  },
  {
    zip: "77342",
    ST: "TX",
    cityWithStateAbbr: "Huntsville, TX",
  },
  {
    zip: "77343",
    ST: "TX",
    cityWithStateAbbr: "Huntsville, TX",
  },
  {
    zip: "77345",
    ST: "TX",
    cityWithStateAbbr: "Kingwood, TX",
  },
  {
    zip: "77346",
    ST: "TX",
    cityWithStateAbbr: "Humble, TX",
  },
  {
    zip: "77347",
    ST: "TX",
    cityWithStateAbbr: "Humble, TX",
  },
  {
    zip: "77348",
    ST: "TX",
    cityWithStateAbbr: "Huntsville, TX",
  },
  {
    zip: "77350",
    ST: "TX",
    cityWithStateAbbr: "Leggett, TX",
  },
  {
    zip: "77351",
    ST: "TX",
    cityWithStateAbbr: "Livingston, TX",
  },
  {
    zip: "77353",
    ST: "TX",
    cityWithStateAbbr: "Magnolia, TX",
  },
  {
    zip: "77354",
    ST: "TX",
    cityWithStateAbbr: "Magnolia, TX",
  },
  {
    zip: "77355",
    ST: "TX",
    cityWithStateAbbr: "Magnolia, TX",
  },
  {
    zip: "77356",
    ST: "TX",
    cityWithStateAbbr: "Montgomery, TX",
  },
  {
    zip: "77357",
    ST: "TX",
    cityWithStateAbbr: "New Caney, TX",
  },
  {
    zip: "77358",
    ST: "TX",
    cityWithStateAbbr: "New Waverly, TX",
  },
  {
    zip: "77359",
    ST: "TX",
    cityWithStateAbbr: "Oakhurst, TX",
  },
  {
    zip: "77360",
    ST: "TX",
    cityWithStateAbbr: "Onalaska, TX",
  },
  {
    zip: "77362",
    ST: "TX",
    cityWithStateAbbr: "Pinehurst, TX",
  },
  {
    zip: "77363",
    ST: "TX",
    cityWithStateAbbr: "Plantersville, TX",
  },
  {
    zip: "77364",
    ST: "TX",
    cityWithStateAbbr: "Pointblank, TX",
  },
  {
    zip: "77365",
    ST: "TX",
    cityWithStateAbbr: "Porter, TX",
  },
  {
    zip: "77367",
    ST: "TX",
    cityWithStateAbbr: "Riverside, TX",
  },
  {
    zip: "77368",
    ST: "TX",
    cityWithStateAbbr: "Romayor, TX",
  },
  {
    zip: "77369",
    ST: "TX",
    cityWithStateAbbr: "Rye, TX",
  },
  {
    zip: "77371",
    ST: "TX",
    cityWithStateAbbr: "Shepherd, TX",
  },
  {
    zip: "77372",
    ST: "TX",
    cityWithStateAbbr: "Splendora, TX",
  },
  {
    zip: "77373",
    ST: "TX",
    cityWithStateAbbr: "Spring, TX",
  },
  {
    zip: "77374",
    ST: "TX",
    cityWithStateAbbr: "Thicket, TX",
  },
  {
    zip: "77375",
    ST: "TX",
    cityWithStateAbbr: "Tomball, TX",
  },
  {
    zip: "77376",
    ST: "TX",
    cityWithStateAbbr: "Votaw, TX",
  },
  {
    zip: "77377",
    ST: "TX",
    cityWithStateAbbr: "Tomball, TX",
  },
  {
    zip: "77378",
    ST: "TX",
    cityWithStateAbbr: "Willis, TX",
  },
  {
    zip: "77379",
    ST: "TX",
    cityWithStateAbbr: "Spring, TX",
  },
  {
    zip: "77380",
    ST: "TX",
    cityWithStateAbbr: "Spring, TX",
  },
  {
    zip: "77381",
    ST: "TX",
    cityWithStateAbbr: "Spring, TX",
  },
  {
    zip: "77382",
    ST: "TX",
    cityWithStateAbbr: "Spring, TX",
  },
  {
    zip: "77383",
    ST: "TX",
    cityWithStateAbbr: "Spring, TX",
  },
  {
    zip: "77384",
    ST: "TX",
    cityWithStateAbbr: "Conroe, TX",
  },
  {
    zip: "77385",
    ST: "TX",
    cityWithStateAbbr: "Conroe, TX",
  },
  {
    zip: "77386",
    ST: "TX",
    cityWithStateAbbr: "Spring, TX",
  },
  {
    zip: "77387",
    ST: "TX",
    cityWithStateAbbr: "Spring, TX",
  },
  {
    zip: "77388",
    ST: "TX",
    cityWithStateAbbr: "Spring, TX",
  },
  {
    zip: "77389",
    ST: "TX",
    cityWithStateAbbr: "Spring, TX",
  },
  {
    zip: "77391",
    ST: "TX",
    cityWithStateAbbr: "Spring, TX",
  },
  {
    zip: "77393",
    ST: "TX",
    cityWithStateAbbr: "Spring, TX",
  },
  {
    zip: "77396",
    ST: "TX",
    cityWithStateAbbr: "Humble, TX",
  },
  {
    zip: "77399",
    ST: "TX",
    cityWithStateAbbr: "Livingston, TX",
  },
  {
    zip: "77401",
    ST: "TX",
    cityWithStateAbbr: "Bellaire, TX",
  },
  {
    zip: "77402",
    ST: "TX",
    cityWithStateAbbr: "Bellaire, TX",
  },
  {
    zip: "77404",
    ST: "TX",
    cityWithStateAbbr: "Bay City, TX",
  },
  {
    zip: "77406",
    ST: "TX",
    cityWithStateAbbr: "Richmond, TX",
  },
  {
    zip: "77407",
    ST: "TX",
    cityWithStateAbbr: "Richmond, TX",
  },
  {
    zip: "77410",
    ST: "TX",
    cityWithStateAbbr: "Cypress, TX",
  },
  {
    zip: "77411",
    ST: "TX",
    cityWithStateAbbr: "Alief, TX",
  },
  {
    zip: "77412",
    ST: "TX",
    cityWithStateAbbr: "Altair, TX",
  },
  {
    zip: "77413",
    ST: "TX",
    cityWithStateAbbr: "Barker, TX",
  },
  {
    zip: "77414",
    ST: "TX",
    cityWithStateAbbr: "Bay City, TX",
  },
  {
    zip: "77415",
    ST: "TX",
    cityWithStateAbbr: "Cedar Lane, TX",
  },
  {
    zip: "77417",
    ST: "TX",
    cityWithStateAbbr: "Beasley, TX",
  },
  {
    zip: "77418",
    ST: "TX",
    cityWithStateAbbr: "Bellville, TX",
  },
  {
    zip: "77419",
    ST: "TX",
    cityWithStateAbbr: "Blessing, TX",
  },
  {
    zip: "77420",
    ST: "TX",
    cityWithStateAbbr: "Boling, TX",
  },
  {
    zip: "77422",
    ST: "TX",
    cityWithStateAbbr: "Brazoria, TX",
  },
  {
    zip: "77423",
    ST: "TX",
    cityWithStateAbbr: "Brookshire, TX",
  },
  {
    zip: "77426",
    ST: "TX",
    cityWithStateAbbr: "Chappell Hill, TX",
  },
  {
    zip: "77428",
    ST: "TX",
    cityWithStateAbbr: "Collegeport, TX",
  },
  {
    zip: "77429",
    ST: "TX",
    cityWithStateAbbr: "Cypress, TX",
  },
  {
    zip: "77430",
    ST: "TX",
    cityWithStateAbbr: "Damon, TX",
  },
  {
    zip: "77431",
    ST: "TX",
    cityWithStateAbbr: "Danciger, TX",
  },
  {
    zip: "77432",
    ST: "TX",
    cityWithStateAbbr: "Danevang, TX",
  },
  {
    zip: "77433",
    ST: "TX",
    cityWithStateAbbr: "Cypress, TX",
  },
  {
    zip: "77434",
    ST: "TX",
    cityWithStateAbbr: "Eagle Lake, TX",
  },
  {
    zip: "77435",
    ST: "TX",
    cityWithStateAbbr: "East Bernard, TX",
  },
  {
    zip: "77436",
    ST: "TX",
    cityWithStateAbbr: "Egypt, TX",
  },
  {
    zip: "77437",
    ST: "TX",
    cityWithStateAbbr: "El Campo, TX",
  },
  {
    zip: "77440",
    ST: "TX",
    cityWithStateAbbr: "Elmaton, TX",
  },
  {
    zip: "77441",
    ST: "TX",
    cityWithStateAbbr: "Fulshear, TX",
  },
  {
    zip: "77442",
    ST: "TX",
    cityWithStateAbbr: "Garwood, TX",
  },
  {
    zip: "77443",
    ST: "TX",
    cityWithStateAbbr: "Glen Flora, TX",
  },
  {
    zip: "77444",
    ST: "TX",
    cityWithStateAbbr: "Guy, TX",
  },
  {
    zip: "77445",
    ST: "TX",
    cityWithStateAbbr: "Hempstead, TX",
  },
  {
    zip: "77446",
    ST: "TX",
    cityWithStateAbbr: "Prairie View, TX",
  },
  {
    zip: "77447",
    ST: "TX",
    cityWithStateAbbr: "Hockley, TX",
  },
  {
    zip: "77448",
    ST: "TX",
    cityWithStateAbbr: "Hungerford, TX",
  },
  {
    zip: "77449",
    ST: "TX",
    cityWithStateAbbr: "Katy, TX",
  },
  {
    zip: "77450",
    ST: "TX",
    cityWithStateAbbr: "Katy, TX",
  },
  {
    zip: "77451",
    ST: "TX",
    cityWithStateAbbr: "Kendleton, TX",
  },
  {
    zip: "77452",
    ST: "TX",
    cityWithStateAbbr: "Kenney, TX",
  },
  {
    zip: "77453",
    ST: "TX",
    cityWithStateAbbr: "Lane City, TX",
  },
  {
    zip: "77454",
    ST: "TX",
    cityWithStateAbbr: "Lissie, TX",
  },
  {
    zip: "77455",
    ST: "TX",
    cityWithStateAbbr: "Louise, TX",
  },
  {
    zip: "77456",
    ST: "TX",
    cityWithStateAbbr: "Markham, TX",
  },
  {
    zip: "77457",
    ST: "TX",
    cityWithStateAbbr: "Matagorda, TX",
  },
  {
    zip: "77458",
    ST: "TX",
    cityWithStateAbbr: "Midfield, TX",
  },
  {
    zip: "77459",
    ST: "TX",
    cityWithStateAbbr: "Missouri City, TX",
  },
  {
    zip: "77460",
    ST: "TX",
    cityWithStateAbbr: "Nada, TX",
  },
  {
    zip: "77461",
    ST: "TX",
    cityWithStateAbbr: "Needville, TX",
  },
  {
    zip: "77463",
    ST: "TX",
    cityWithStateAbbr: "Old Ocean, TX",
  },
  {
    zip: "77464",
    ST: "TX",
    cityWithStateAbbr: "Orchard, TX",
  },
  {
    zip: "77465",
    ST: "TX",
    cityWithStateAbbr: "Palacios, TX",
  },
  {
    zip: "77466",
    ST: "TX",
    cityWithStateAbbr: "Pattison, TX",
  },
  {
    zip: "77467",
    ST: "TX",
    cityWithStateAbbr: "Pierce, TX",
  },
  {
    zip: "77468",
    ST: "TX",
    cityWithStateAbbr: "Pledger, TX",
  },
  {
    zip: "77469",
    ST: "TX",
    cityWithStateAbbr: "Richmond, TX",
  },
  {
    zip: "77470",
    ST: "TX",
    cityWithStateAbbr: "Rock Island, TX",
  },
  {
    zip: "77471",
    ST: "TX",
    cityWithStateAbbr: "Rosenberg, TX",
  },
  {
    zip: "77473",
    ST: "TX",
    cityWithStateAbbr: "San Felipe, TX",
  },
  {
    zip: "77474",
    ST: "TX",
    cityWithStateAbbr: "Sealy, TX",
  },
  {
    zip: "77475",
    ST: "TX",
    cityWithStateAbbr: "Sheridan, TX",
  },
  {
    zip: "77476",
    ST: "TX",
    cityWithStateAbbr: "Simonton, TX",
  },
  {
    zip: "77477",
    ST: "TX",
    cityWithStateAbbr: "Stafford, TX",
  },
  {
    zip: "77478",
    ST: "TX",
    cityWithStateAbbr: "Sugar Land, TX",
  },
  {
    zip: "77479",
    ST: "TX",
    cityWithStateAbbr: "Sugar Land, TX",
  },
  {
    zip: "77480",
    ST: "TX",
    cityWithStateAbbr: "Sweeny, TX",
  },
  {
    zip: "77481",
    ST: "TX",
    cityWithStateAbbr: "Thompsons, TX",
  },
  {
    zip: "77482",
    ST: "TX",
    cityWithStateAbbr: "Van Vleck, TX",
  },
  {
    zip: "77483",
    ST: "TX",
    cityWithStateAbbr: "Wadsworth, TX",
  },
  {
    zip: "77484",
    ST: "TX",
    cityWithStateAbbr: "Waller, TX",
  },
  {
    zip: "77485",
    ST: "TX",
    cityWithStateAbbr: "Wallis, TX",
  },
  {
    zip: "77486",
    ST: "TX",
    cityWithStateAbbr: "West Columbia, TX",
  },
  {
    zip: "77487",
    ST: "TX",
    cityWithStateAbbr: "Sugar Land, TX",
  },
  {
    zip: "77488",
    ST: "TX",
    cityWithStateAbbr: "Wharton, TX",
  },
  {
    zip: "77489",
    ST: "TX",
    cityWithStateAbbr: "Missouri City, TX",
  },
  {
    zip: "77491",
    ST: "TX",
    cityWithStateAbbr: "Katy, TX",
  },
  {
    zip: "77492",
    ST: "TX",
    cityWithStateAbbr: "Katy, TX",
  },
  {
    zip: "77493",
    ST: "TX",
    cityWithStateAbbr: "Katy, TX",
  },
  {
    zip: "77494",
    ST: "TX",
    cityWithStateAbbr: "Katy, TX",
  },
  {
    zip: "77496",
    ST: "TX",
    cityWithStateAbbr: "Sugar Land, TX",
  },
  {
    zip: "77497",
    ST: "TX",
    cityWithStateAbbr: "Stafford, TX",
  },
  {
    zip: "77498",
    ST: "TX",
    cityWithStateAbbr: "Sugar Land, TX",
  },
  {
    zip: "77501",
    ST: "TX",
    cityWithStateAbbr: "Pasadena, TX",
  },
  {
    zip: "77502",
    ST: "TX",
    cityWithStateAbbr: "Pasadena, TX",
  },
  {
    zip: "77503",
    ST: "TX",
    cityWithStateAbbr: "Pasadena, TX",
  },
  {
    zip: "77504",
    ST: "TX",
    cityWithStateAbbr: "Pasadena, TX",
  },
  {
    zip: "77505",
    ST: "TX",
    cityWithStateAbbr: "Pasadena, TX",
  },
  {
    zip: "77506",
    ST: "TX",
    cityWithStateAbbr: "Pasadena, TX",
  },
  {
    zip: "77507",
    ST: "TX",
    cityWithStateAbbr: "Pasadena, TX",
  },
  {
    zip: "77508",
    ST: "TX",
    cityWithStateAbbr: "Pasadena, TX",
  },
  {
    zip: "77510",
    ST: "TX",
    cityWithStateAbbr: "Santa Fe, TX",
  },
  {
    zip: "77511",
    ST: "TX",
    cityWithStateAbbr: "Alvin, TX",
  },
  {
    zip: "77512",
    ST: "TX",
    cityWithStateAbbr: "Alvin, TX",
  },
  {
    zip: "77514",
    ST: "TX",
    cityWithStateAbbr: "Anahuac, TX",
  },
  {
    zip: "77515",
    ST: "TX",
    cityWithStateAbbr: "Angleton, TX",
  },
  {
    zip: "77516",
    ST: "TX",
    cityWithStateAbbr: "Angleton, TX",
  },
  {
    zip: "77517",
    ST: "TX",
    cityWithStateAbbr: "Santa Fe, TX",
  },
  {
    zip: "77518",
    ST: "TX",
    cityWithStateAbbr: "Bacliff, TX",
  },
  {
    zip: "77519",
    ST: "TX",
    cityWithStateAbbr: "Batson, TX",
  },
  {
    zip: "77520",
    ST: "TX",
    cityWithStateAbbr: "Baytown, TX",
  },
  {
    zip: "77521",
    ST: "TX",
    cityWithStateAbbr: "Baytown, TX",
  },
  {
    zip: "77522",
    ST: "TX",
    cityWithStateAbbr: "Baytown, TX",
  },
  {
    zip: "77523",
    ST: "TX",
    cityWithStateAbbr: "Baytown, TX",
  },
  {
    zip: "77530",
    ST: "TX",
    cityWithStateAbbr: "Channelview, TX",
  },
  {
    zip: "77531",
    ST: "TX",
    cityWithStateAbbr: "Clute, TX",
  },
  {
    zip: "77532",
    ST: "TX",
    cityWithStateAbbr: "Crosby, TX",
  },
  {
    zip: "77533",
    ST: "TX",
    cityWithStateAbbr: "Daisetta, TX",
  },
  {
    zip: "77534",
    ST: "TX",
    cityWithStateAbbr: "Danbury, TX",
  },
  {
    zip: "77535",
    ST: "TX",
    cityWithStateAbbr: "Dayton, TX",
  },
  {
    zip: "77536",
    ST: "TX",
    cityWithStateAbbr: "Deer Park, TX",
  },
  {
    zip: "77538",
    ST: "TX",
    cityWithStateAbbr: "Devers, TX",
  },
  {
    zip: "77539",
    ST: "TX",
    cityWithStateAbbr: "Dickinson, TX",
  },
  {
    zip: "77541",
    ST: "TX",
    cityWithStateAbbr: "Freeport, TX",
  },
  {
    zip: "77542",
    ST: "TX",
    cityWithStateAbbr: "Freeport, TX",
  },
  {
    zip: "77545",
    ST: "TX",
    cityWithStateAbbr: "Fresno, TX",
  },
  {
    zip: "77546",
    ST: "TX",
    cityWithStateAbbr: "Friendswood, TX",
  },
  {
    zip: "77547",
    ST: "TX",
    cityWithStateAbbr: "Galena Park, TX",
  },
  {
    zip: "77549",
    ST: "TX",
    cityWithStateAbbr: "Friendswood, TX",
  },
  {
    zip: "77550",
    ST: "TX",
    cityWithStateAbbr: "Galveston, TX",
  },
  {
    zip: "77551",
    ST: "TX",
    cityWithStateAbbr: "Galveston, TX",
  },
  {
    zip: "77552",
    ST: "TX",
    cityWithStateAbbr: "Galveston, TX",
  },
  {
    zip: "77553",
    ST: "TX",
    cityWithStateAbbr: "Galveston, TX",
  },
  {
    zip: "77554",
    ST: "TX",
    cityWithStateAbbr: "Galveston, TX",
  },
  {
    zip: "77555",
    ST: "TX",
    cityWithStateAbbr: "Galveston, TX",
  },
  {
    zip: "77560",
    ST: "TX",
    cityWithStateAbbr: "Hankamer, TX",
  },
  {
    zip: "77561",
    ST: "TX",
    cityWithStateAbbr: "Hardin, TX",
  },
  {
    zip: "77562",
    ST: "TX",
    cityWithStateAbbr: "Highlands, TX",
  },
  {
    zip: "77563",
    ST: "TX",
    cityWithStateAbbr: "Hitchcock, TX",
  },
  {
    zip: "77564",
    ST: "TX",
    cityWithStateAbbr: "Hull, TX",
  },
  {
    zip: "77565",
    ST: "TX",
    cityWithStateAbbr: "Kemah, TX",
  },
  {
    zip: "77566",
    ST: "TX",
    cityWithStateAbbr: "Lake Jackson, TX",
  },
  {
    zip: "77568",
    ST: "TX",
    cityWithStateAbbr: "La Marque, TX",
  },
  {
    zip: "77571",
    ST: "TX",
    cityWithStateAbbr: "La Porte, TX",
  },
  {
    zip: "77572",
    ST: "TX",
    cityWithStateAbbr: "La Porte, TX",
  },
  {
    zip: "77573",
    ST: "TX",
    cityWithStateAbbr: "League City, TX",
  },
  {
    zip: "77574",
    ST: "TX",
    cityWithStateAbbr: "League City, TX",
  },
  {
    zip: "77575",
    ST: "TX",
    cityWithStateAbbr: "Liberty, TX",
  },
  {
    zip: "77577",
    ST: "TX",
    cityWithStateAbbr: "Liverpool, TX",
  },
  {
    zip: "77578",
    ST: "TX",
    cityWithStateAbbr: "Manvel, TX",
  },
  {
    zip: "77580",
    ST: "TX",
    cityWithStateAbbr: "Mont Belvieu, TX",
  },
  {
    zip: "77581",
    ST: "TX",
    cityWithStateAbbr: "Pearland, TX",
  },
  {
    zip: "77582",
    ST: "TX",
    cityWithStateAbbr: "Raywood, TX",
  },
  {
    zip: "77583",
    ST: "TX",
    cityWithStateAbbr: "Rosharon, TX",
  },
  {
    zip: "77584",
    ST: "TX",
    cityWithStateAbbr: "Pearland, TX",
  },
  {
    zip: "77585",
    ST: "TX",
    cityWithStateAbbr: "Saratoga, TX",
  },
  {
    zip: "77586",
    ST: "TX",
    cityWithStateAbbr: "Seabrook, TX",
  },
  {
    zip: "77587",
    ST: "TX",
    cityWithStateAbbr: "South Houston, TX",
  },
  {
    zip: "77588",
    ST: "TX",
    cityWithStateAbbr: "Pearland, TX",
  },
  {
    zip: "77590",
    ST: "TX",
    cityWithStateAbbr: "Texas City, TX",
  },
  {
    zip: "77591",
    ST: "TX",
    cityWithStateAbbr: "Texas City, TX",
  },
  {
    zip: "77592",
    ST: "TX",
    cityWithStateAbbr: "Texas City, TX",
  },
  {
    zip: "77597",
    ST: "TX",
    cityWithStateAbbr: "Wallisville, TX",
  },
  {
    zip: "77598",
    ST: "TX",
    cityWithStateAbbr: "Webster, TX",
  },
  {
    zip: "77611",
    ST: "TX",
    cityWithStateAbbr: "Bridge City, TX",
  },
  {
    zip: "77612",
    ST: "TX",
    cityWithStateAbbr: "Buna, TX",
  },
  {
    zip: "77613",
    ST: "TX",
    cityWithStateAbbr: "China, TX",
  },
  {
    zip: "77614",
    ST: "TX",
    cityWithStateAbbr: "Deweyville, TX",
  },
  {
    zip: "77615",
    ST: "TX",
    cityWithStateAbbr: "Evadale, TX",
  },
  {
    zip: "77616",
    ST: "TX",
    cityWithStateAbbr: "Fred, TX",
  },
  {
    zip: "77617",
    ST: "TX",
    cityWithStateAbbr: "Gilchrist, TX",
  },
  {
    zip: "77619",
    ST: "TX",
    cityWithStateAbbr: "Groves, TX",
  },
  {
    zip: "77622",
    ST: "TX",
    cityWithStateAbbr: "Hamshire, TX",
  },
  {
    zip: "77623",
    ST: "TX",
    cityWithStateAbbr: "High Island, TX",
  },
  {
    zip: "77624",
    ST: "TX",
    cityWithStateAbbr: "Hillister, TX",
  },
  {
    zip: "77625",
    ST: "TX",
    cityWithStateAbbr: "Kountze, TX",
  },
  {
    zip: "77626",
    ST: "TX",
    cityWithStateAbbr: "Mauriceville, TX",
  },
  {
    zip: "77627",
    ST: "TX",
    cityWithStateAbbr: "Nederland, TX",
  },
  {
    zip: "77629",
    ST: "TX",
    cityWithStateAbbr: "Nome, TX",
  },
  {
    zip: "77630",
    ST: "TX",
    cityWithStateAbbr: "Orange, TX",
  },
  {
    zip: "77631",
    ST: "TX",
    cityWithStateAbbr: "Orange, TX",
  },
  {
    zip: "77632",
    ST: "TX",
    cityWithStateAbbr: "Orange, TX",
  },
  {
    zip: "77639",
    ST: "TX",
    cityWithStateAbbr: "Orangefield, TX",
  },
  {
    zip: "77640",
    ST: "TX",
    cityWithStateAbbr: "Port Arthur, TX",
  },
  {
    zip: "77641",
    ST: "TX",
    cityWithStateAbbr: "Port Arthur, TX",
  },
  {
    zip: "77642",
    ST: "TX",
    cityWithStateAbbr: "Port Arthur, TX",
  },
  {
    zip: "77643",
    ST: "TX",
    cityWithStateAbbr: "Port Arthur, TX",
  },
  {
    zip: "77650",
    ST: "TX",
    cityWithStateAbbr: "Port Bolivar, TX",
  },
  {
    zip: "77651",
    ST: "TX",
    cityWithStateAbbr: "Port Neches, TX",
  },
  {
    zip: "77655",
    ST: "TX",
    cityWithStateAbbr: "Sabine Pass, TX",
  },
  {
    zip: "77656",
    ST: "TX",
    cityWithStateAbbr: "Silsbee, TX",
  },
  {
    zip: "77657",
    ST: "TX",
    cityWithStateAbbr: "Lumberton, TX",
  },
  {
    zip: "77659",
    ST: "TX",
    cityWithStateAbbr: "Sour Lake, TX",
  },
  {
    zip: "77660",
    ST: "TX",
    cityWithStateAbbr: "Spurger, TX",
  },
  {
    zip: "77661",
    ST: "TX",
    cityWithStateAbbr: "Stowell, TX",
  },
  {
    zip: "77662",
    ST: "TX",
    cityWithStateAbbr: "Vidor, TX",
  },
  {
    zip: "77663",
    ST: "TX",
    cityWithStateAbbr: "Village Mills, TX",
  },
  {
    zip: "77664",
    ST: "TX",
    cityWithStateAbbr: "Warren, TX",
  },
  {
    zip: "77665",
    ST: "TX",
    cityWithStateAbbr: "Winnie, TX",
  },
  {
    zip: "77670",
    ST: "TX",
    cityWithStateAbbr: "Vidor, TX",
  },
  {
    zip: "77701",
    ST: "TX",
    cityWithStateAbbr: "Beaumont, TX",
  },
  {
    zip: "77702",
    ST: "TX",
    cityWithStateAbbr: "Beaumont, TX",
  },
  {
    zip: "77703",
    ST: "TX",
    cityWithStateAbbr: "Beaumont, TX",
  },
  {
    zip: "77704",
    ST: "TX",
    cityWithStateAbbr: "Beaumont, TX",
  },
  {
    zip: "77705",
    ST: "TX",
    cityWithStateAbbr: "Beaumont, TX",
  },
  {
    zip: "77706",
    ST: "TX",
    cityWithStateAbbr: "Beaumont, TX",
  },
  {
    zip: "77707",
    ST: "TX",
    cityWithStateAbbr: "Beaumont, TX",
  },
  {
    zip: "77708",
    ST: "TX",
    cityWithStateAbbr: "Beaumont, TX",
  },
  {
    zip: "77709",
    ST: "TX",
    cityWithStateAbbr: "Beaumont, TX",
  },
  {
    zip: "77710",
    ST: "TX",
    cityWithStateAbbr: "Beaumont, TX",
  },
  {
    zip: "77713",
    ST: "TX",
    cityWithStateAbbr: "Beaumont, TX",
  },
  {
    zip: "77720",
    ST: "TX",
    cityWithStateAbbr: "Beaumont, TX",
  },
  {
    zip: "77725",
    ST: "TX",
    cityWithStateAbbr: "Beaumont, TX",
  },
  {
    zip: "77726",
    ST: "TX",
    cityWithStateAbbr: "Beaumont, TX",
  },
  {
    zip: "77801",
    ST: "TX",
    cityWithStateAbbr: "Bryan, TX",
  },
  {
    zip: "77802",
    ST: "TX",
    cityWithStateAbbr: "Bryan, TX",
  },
  {
    zip: "77803",
    ST: "TX",
    cityWithStateAbbr: "Bryan, TX",
  },
  {
    zip: "77805",
    ST: "TX",
    cityWithStateAbbr: "Bryan, TX",
  },
  {
    zip: "77806",
    ST: "TX",
    cityWithStateAbbr: "Bryan, TX",
  },
  {
    zip: "77807",
    ST: "TX",
    cityWithStateAbbr: "Bryan, TX",
  },
  {
    zip: "77808",
    ST: "TX",
    cityWithStateAbbr: "Bryan, TX",
  },
  {
    zip: "77830",
    ST: "TX",
    cityWithStateAbbr: "Anderson, TX",
  },
  {
    zip: "77831",
    ST: "TX",
    cityWithStateAbbr: "Bedias, TX",
  },
  {
    zip: "77833",
    ST: "TX",
    cityWithStateAbbr: "Brenham, TX",
  },
  {
    zip: "77834",
    ST: "TX",
    cityWithStateAbbr: "Brenham, TX",
  },
  {
    zip: "77835",
    ST: "TX",
    cityWithStateAbbr: "Burton, TX",
  },
  {
    zip: "77836",
    ST: "TX",
    cityWithStateAbbr: "Caldwell, TX",
  },
  {
    zip: "77837",
    ST: "TX",
    cityWithStateAbbr: "Calvert, TX",
  },
  {
    zip: "77838",
    ST: "TX",
    cityWithStateAbbr: "Chriesman, TX",
  },
  {
    zip: "77840",
    ST: "TX",
    cityWithStateAbbr: "College Station, TX",
  },
  {
    zip: "77841",
    ST: "TX",
    cityWithStateAbbr: "College Station, TX",
  },
  {
    zip: "77842",
    ST: "TX",
    cityWithStateAbbr: "College Station, TX",
  },
  {
    zip: "77843",
    ST: "TX",
    cityWithStateAbbr: "College Station, TX",
  },
  {
    zip: "77844",
    ST: "TX",
    cityWithStateAbbr: "College Station, TX",
  },
  {
    zip: "77845",
    ST: "TX",
    cityWithStateAbbr: "College Station, TX",
  },
  {
    zip: "77850",
    ST: "TX",
    cityWithStateAbbr: "Concord, TX",
  },
  {
    zip: "77852",
    ST: "TX",
    cityWithStateAbbr: "Deanville, TX",
  },
  {
    zip: "77853",
    ST: "TX",
    cityWithStateAbbr: "Dime Box, TX",
  },
  {
    zip: "77855",
    ST: "TX",
    cityWithStateAbbr: "Flynn, TX",
  },
  {
    zip: "77856",
    ST: "TX",
    cityWithStateAbbr: "Franklin, TX",
  },
  {
    zip: "77857",
    ST: "TX",
    cityWithStateAbbr: "Gause, TX",
  },
  {
    zip: "77859",
    ST: "TX",
    cityWithStateAbbr: "Hearne, TX",
  },
  {
    zip: "77861",
    ST: "TX",
    cityWithStateAbbr: "Iola, TX",
  },
  {
    zip: "77862",
    ST: "TX",
    cityWithStateAbbr: "Kurten, TX",
  },
  {
    zip: "77863",
    ST: "TX",
    cityWithStateAbbr: "Lyons, TX",
  },
  {
    zip: "77864",
    ST: "TX",
    cityWithStateAbbr: "Madisonville, TX",
  },
  {
    zip: "77865",
    ST: "TX",
    cityWithStateAbbr: "Marquez, TX",
  },
  {
    zip: "77866",
    ST: "TX",
    cityWithStateAbbr: "Millican, TX",
  },
  {
    zip: "77867",
    ST: "TX",
    cityWithStateAbbr: "Mumford, TX",
  },
  {
    zip: "77868",
    ST: "TX",
    cityWithStateAbbr: "Navasota, TX",
  },
  {
    zip: "77870",
    ST: "TX",
    cityWithStateAbbr: "New Baden, TX",
  },
  {
    zip: "77871",
    ST: "TX",
    cityWithStateAbbr: "Normangee, TX",
  },
  {
    zip: "77872",
    ST: "TX",
    cityWithStateAbbr: "North Zulch, TX",
  },
  {
    zip: "77873",
    ST: "TX",
    cityWithStateAbbr: "Richards, TX",
  },
  {
    zip: "77875",
    ST: "TX",
    cityWithStateAbbr: "Roans Prairie, TX",
  },
  {
    zip: "77876",
    ST: "TX",
    cityWithStateAbbr: "Shiro, TX",
  },
  {
    zip: "77878",
    ST: "TX",
    cityWithStateAbbr: "Snook, TX",
  },
  {
    zip: "77879",
    ST: "TX",
    cityWithStateAbbr: "Somerville, TX",
  },
  {
    zip: "77880",
    ST: "TX",
    cityWithStateAbbr: "Washington, TX",
  },
  {
    zip: "77881",
    ST: "TX",
    cityWithStateAbbr: "Wellborn, TX",
  },
  {
    zip: "77882",
    ST: "TX",
    cityWithStateAbbr: "Wheelock, TX",
  },
  {
    zip: "77901",
    ST: "TX",
    cityWithStateAbbr: "Victoria, TX",
  },
  {
    zip: "77902",
    ST: "TX",
    cityWithStateAbbr: "Victoria, TX",
  },
  {
    zip: "77903",
    ST: "TX",
    cityWithStateAbbr: "Victoria, TX",
  },
  {
    zip: "77904",
    ST: "TX",
    cityWithStateAbbr: "Victoria, TX",
  },
  {
    zip: "77905",
    ST: "TX",
    cityWithStateAbbr: "Victoria, TX",
  },
  {
    zip: "77950",
    ST: "TX",
    cityWithStateAbbr: "Austwell, TX",
  },
  {
    zip: "77951",
    ST: "TX",
    cityWithStateAbbr: "Bloomington, TX",
  },
  {
    zip: "77954",
    ST: "TX",
    cityWithStateAbbr: "Cuero, TX",
  },
  {
    zip: "77957",
    ST: "TX",
    cityWithStateAbbr: "Edna, TX",
  },
  {
    zip: "77960",
    ST: "TX",
    cityWithStateAbbr: "Fannin, TX",
  },
  {
    zip: "77961",
    ST: "TX",
    cityWithStateAbbr: "Francitas, TX",
  },
  {
    zip: "77962",
    ST: "TX",
    cityWithStateAbbr: "Ganado, TX",
  },
  {
    zip: "77963",
    ST: "TX",
    cityWithStateAbbr: "Goliad, TX",
  },
  {
    zip: "77964",
    ST: "TX",
    cityWithStateAbbr: "Hallettsville, TX",
  },
  {
    zip: "77967",
    ST: "TX",
    cityWithStateAbbr: "Hochheim, TX",
  },
  {
    zip: "77968",
    ST: "TX",
    cityWithStateAbbr: "Inez, TX",
  },
  {
    zip: "77969",
    ST: "TX",
    cityWithStateAbbr: "La Salle, TX",
  },
  {
    zip: "77970",
    ST: "TX",
    cityWithStateAbbr: "La Ward, TX",
  },
  {
    zip: "77971",
    ST: "TX",
    cityWithStateAbbr: "Lolita, TX",
  },
  {
    zip: "77973",
    ST: "TX",
    cityWithStateAbbr: "Mcfaddin, TX",
  },
  {
    zip: "77974",
    ST: "TX",
    cityWithStateAbbr: "Meyersville, TX",
  },
  {
    zip: "77975",
    ST: "TX",
    cityWithStateAbbr: "Moulton, TX",
  },
  {
    zip: "77976",
    ST: "TX",
    cityWithStateAbbr: "Nursery, TX",
  },
  {
    zip: "77977",
    ST: "TX",
    cityWithStateAbbr: "Placedo, TX",
  },
  {
    zip: "77978",
    ST: "TX",
    cityWithStateAbbr: "Point Comfort, TX",
  },
  {
    zip: "77979",
    ST: "TX",
    cityWithStateAbbr: "Port Lavaca, TX",
  },
  {
    zip: "77982",
    ST: "TX",
    cityWithStateAbbr: "Port O Connor, TX",
  },
  {
    zip: "77983",
    ST: "TX",
    cityWithStateAbbr: "Seadrift, TX",
  },
  {
    zip: "77984",
    ST: "TX",
    cityWithStateAbbr: "Shiner, TX",
  },
  {
    zip: "77986",
    ST: "TX",
    cityWithStateAbbr: "Sublime, TX",
  },
  {
    zip: "77987",
    ST: "TX",
    cityWithStateAbbr: "Sweet Home, TX",
  },
  {
    zip: "77988",
    ST: "TX",
    cityWithStateAbbr: "Telferner, TX",
  },
  {
    zip: "77989",
    ST: "TX",
    cityWithStateAbbr: "Thomaston, TX",
  },
  {
    zip: "77990",
    ST: "TX",
    cityWithStateAbbr: "Tivoli, TX",
  },
  {
    zip: "77991",
    ST: "TX",
    cityWithStateAbbr: "Vanderbilt, TX",
  },
  {
    zip: "77993",
    ST: "TX",
    cityWithStateAbbr: "Weesatche, TX",
  },
  {
    zip: "77994",
    ST: "TX",
    cityWithStateAbbr: "Westhoff, TX",
  },
  {
    zip: "77995",
    ST: "TX",
    cityWithStateAbbr: "Yoakum, TX",
  },
  {
    zip: "78001",
    ST: "TX",
    cityWithStateAbbr: "Artesia Wells, TX",
  },
  {
    zip: "78002",
    ST: "TX",
    cityWithStateAbbr: "Atascosa, TX",
  },
  {
    zip: "78003",
    ST: "TX",
    cityWithStateAbbr: "Bandera, TX",
  },
  {
    zip: "78004",
    ST: "TX",
    cityWithStateAbbr: "Bergheim, TX",
  },
  {
    zip: "78005",
    ST: "TX",
    cityWithStateAbbr: "Bigfoot, TX",
  },
  {
    zip: "78006",
    ST: "TX",
    cityWithStateAbbr: "Boerne, TX",
  },
  {
    zip: "78007",
    ST: "TX",
    cityWithStateAbbr: "Calliham, TX",
  },
  {
    zip: "78008",
    ST: "TX",
    cityWithStateAbbr: "Campbellton, TX",
  },
  {
    zip: "78009",
    ST: "TX",
    cityWithStateAbbr: "Castroville, TX",
  },
  {
    zip: "78010",
    ST: "TX",
    cityWithStateAbbr: "Center Point, TX",
  },
  {
    zip: "78011",
    ST: "TX",
    cityWithStateAbbr: "Charlotte, TX",
  },
  {
    zip: "78012",
    ST: "TX",
    cityWithStateAbbr: "Christine, TX",
  },
  {
    zip: "78013",
    ST: "TX",
    cityWithStateAbbr: "Comfort, TX",
  },
  {
    zip: "78014",
    ST: "TX",
    cityWithStateAbbr: "Cotulla, TX",
  },
  {
    zip: "78015",
    ST: "TX",
    cityWithStateAbbr: "Boerne, TX",
  },
  {
    zip: "78016",
    ST: "TX",
    cityWithStateAbbr: "Devine, TX",
  },
  {
    zip: "78017",
    ST: "TX",
    cityWithStateAbbr: "Dilley, TX",
  },
  {
    zip: "78019",
    ST: "TX",
    cityWithStateAbbr: "Encinal, TX",
  },
  {
    zip: "78021",
    ST: "TX",
    cityWithStateAbbr: "Fowlerton, TX",
  },
  {
    zip: "78022",
    ST: "TX",
    cityWithStateAbbr: "George West, TX",
  },
  {
    zip: "78023",
    ST: "TX",
    cityWithStateAbbr: "Helotes, TX",
  },
  {
    zip: "78024",
    ST: "TX",
    cityWithStateAbbr: "Hunt, TX",
  },
  {
    zip: "78025",
    ST: "TX",
    cityWithStateAbbr: "Ingram, TX",
  },
  {
    zip: "78026",
    ST: "TX",
    cityWithStateAbbr: "Jourdanton, TX",
  },
  {
    zip: "78027",
    ST: "TX",
    cityWithStateAbbr: "Kendalia, TX",
  },
  {
    zip: "78028",
    ST: "TX",
    cityWithStateAbbr: "Kerrville, TX",
  },
  {
    zip: "78029",
    ST: "TX",
    cityWithStateAbbr: "Kerrville, TX",
  },
  {
    zip: "78039",
    ST: "TX",
    cityWithStateAbbr: "La Coste, TX",
  },
  {
    zip: "78040",
    ST: "TX",
    cityWithStateAbbr: "Laredo, TX",
  },
  {
    zip: "78041",
    ST: "TX",
    cityWithStateAbbr: "Laredo, TX",
  },
  {
    zip: "78042",
    ST: "TX",
    cityWithStateAbbr: "Laredo, TX",
  },
  {
    zip: "78043",
    ST: "TX",
    cityWithStateAbbr: "Laredo, TX",
  },
  {
    zip: "78044",
    ST: "TX",
    cityWithStateAbbr: "Laredo, TX",
  },
  {
    zip: "78045",
    ST: "TX",
    cityWithStateAbbr: "Laredo, TX",
  },
  {
    zip: "78046",
    ST: "TX",
    cityWithStateAbbr: "Laredo, TX",
  },
  {
    zip: "78049",
    ST: "TX",
    cityWithStateAbbr: "Laredo, TX",
  },
  {
    zip: "78050",
    ST: "TX",
    cityWithStateAbbr: "Leming, TX",
  },
  {
    zip: "78052",
    ST: "TX",
    cityWithStateAbbr: "Lytle, TX",
  },
  {
    zip: "78054",
    ST: "TX",
    cityWithStateAbbr: "Macdona, TX",
  },
  {
    zip: "78055",
    ST: "TX",
    cityWithStateAbbr: "Medina, TX",
  },
  {
    zip: "78056",
    ST: "TX",
    cityWithStateAbbr: "Mico, TX",
  },
  {
    zip: "78057",
    ST: "TX",
    cityWithStateAbbr: "Moore, TX",
  },
  {
    zip: "78058",
    ST: "TX",
    cityWithStateAbbr: "Mountain Home, TX",
  },
  {
    zip: "78059",
    ST: "TX",
    cityWithStateAbbr: "Natalia, TX",
  },
  {
    zip: "78060",
    ST: "TX",
    cityWithStateAbbr: "Oakville, TX",
  },
  {
    zip: "78061",
    ST: "TX",
    cityWithStateAbbr: "Pearsall, TX",
  },
  {
    zip: "78062",
    ST: "TX",
    cityWithStateAbbr: "Peggy, TX",
  },
  {
    zip: "78063",
    ST: "TX",
    cityWithStateAbbr: "Pipe Creek, TX",
  },
  {
    zip: "78064",
    ST: "TX",
    cityWithStateAbbr: "Pleasanton, TX",
  },
  {
    zip: "78065",
    ST: "TX",
    cityWithStateAbbr: "Poteet, TX",
  },
  {
    zip: "78066",
    ST: "TX",
    cityWithStateAbbr: "Rio Medina, TX",
  },
  {
    zip: "78067",
    ST: "TX",
    cityWithStateAbbr: "San Ygnacio, TX",
  },
  {
    zip: "78069",
    ST: "TX",
    cityWithStateAbbr: "Somerset, TX",
  },
  {
    zip: "78070",
    ST: "TX",
    cityWithStateAbbr: "Spring Branch, TX",
  },
  {
    zip: "78071",
    ST: "TX",
    cityWithStateAbbr: "Three Rivers, TX",
  },
  {
    zip: "78072",
    ST: "TX",
    cityWithStateAbbr: "Tilden, TX",
  },
  {
    zip: "78073",
    ST: "TX",
    cityWithStateAbbr: "Von Ormy, TX",
  },
  {
    zip: "78074",
    ST: "TX",
    cityWithStateAbbr: "Waring, TX",
  },
  {
    zip: "78075",
    ST: "TX",
    cityWithStateAbbr: "Whitsett, TX",
  },
  {
    zip: "78076",
    ST: "TX",
    cityWithStateAbbr: "Zapata, TX",
  },
  {
    zip: "78101",
    ST: "TX",
    cityWithStateAbbr: "Adkins, TX",
  },
  {
    zip: "78102",
    ST: "TX",
    cityWithStateAbbr: "Beeville, TX",
  },
  {
    zip: "78104",
    ST: "TX",
    cityWithStateAbbr: "Beeville, TX",
  },
  {
    zip: "78107",
    ST: "TX",
    cityWithStateAbbr: "Berclair, TX",
  },
  {
    zip: "78108",
    ST: "TX",
    cityWithStateAbbr: "Cibolo, TX",
  },
  {
    zip: "78109",
    ST: "TX",
    cityWithStateAbbr: "Converse, TX",
  },
  {
    zip: "78111",
    ST: "TX",
    cityWithStateAbbr: "Ecleto, TX",
  },
  {
    zip: "78112",
    ST: "TX",
    cityWithStateAbbr: "Elmendorf, TX",
  },
  {
    zip: "78113",
    ST: "TX",
    cityWithStateAbbr: "Falls City, TX",
  },
  {
    zip: "78114",
    ST: "TX",
    cityWithStateAbbr: "Floresville, TX",
  },
  {
    zip: "78115",
    ST: "TX",
    cityWithStateAbbr: "Geronimo, TX",
  },
  {
    zip: "78116",
    ST: "TX",
    cityWithStateAbbr: "Gillett, TX",
  },
  {
    zip: "78117",
    ST: "TX",
    cityWithStateAbbr: "Hobson, TX",
  },
  {
    zip: "78118",
    ST: "TX",
    cityWithStateAbbr: "Karnes City, TX",
  },
  {
    zip: "78119",
    ST: "TX",
    cityWithStateAbbr: "Kenedy, TX",
  },
  {
    zip: "78121",
    ST: "TX",
    cityWithStateAbbr: "La Vernia, TX",
  },
  {
    zip: "78122",
    ST: "TX",
    cityWithStateAbbr: "Leesville, TX",
  },
  {
    zip: "78123",
    ST: "TX",
    cityWithStateAbbr: "Mc Queeney, TX",
  },
  {
    zip: "78124",
    ST: "TX",
    cityWithStateAbbr: "Marion, TX",
  },
  {
    zip: "78125",
    ST: "TX",
    cityWithStateAbbr: "Mineral, TX",
  },
  {
    zip: "78130",
    ST: "TX",
    cityWithStateAbbr: "New Braunfels, TX",
  },
  {
    zip: "78131",
    ST: "TX",
    cityWithStateAbbr: "New Braunfels, TX",
  },
  {
    zip: "78132",
    ST: "TX",
    cityWithStateAbbr: "New Braunfels, TX",
  },
  {
    zip: "78133",
    ST: "TX",
    cityWithStateAbbr: "Canyon Lake, TX",
  },
  {
    zip: "78135",
    ST: "TX",
    cityWithStateAbbr: "New Braunfels, TX",
  },
  {
    zip: "78140",
    ST: "TX",
    cityWithStateAbbr: "Nixon, TX",
  },
  {
    zip: "78141",
    ST: "TX",
    cityWithStateAbbr: "Nordheim, TX",
  },
  {
    zip: "78142",
    ST: "TX",
    cityWithStateAbbr: "Normanna, TX",
  },
  {
    zip: "78143",
    ST: "TX",
    cityWithStateAbbr: "Pandora, TX",
  },
  {
    zip: "78144",
    ST: "TX",
    cityWithStateAbbr: "Panna Maria, TX",
  },
  {
    zip: "78145",
    ST: "TX",
    cityWithStateAbbr: "Pawnee, TX",
  },
  {
    zip: "78146",
    ST: "TX",
    cityWithStateAbbr: "Pettus, TX",
  },
  {
    zip: "78147",
    ST: "TX",
    cityWithStateAbbr: "Poth, TX",
  },
  {
    zip: "78148",
    ST: "TX",
    cityWithStateAbbr: "Universal City, TX",
  },
  {
    zip: "78150",
    ST: "TX",
    cityWithStateAbbr: "Jbsa Randolph, TX",
  },
  {
    zip: "78151",
    ST: "TX",
    cityWithStateAbbr: "Runge, TX",
  },
  {
    zip: "78152",
    ST: "TX",
    cityWithStateAbbr: "Saint Hedwig, TX",
  },
  {
    zip: "78154",
    ST: "TX",
    cityWithStateAbbr: "Schertz, TX",
  },
  {
    zip: "78155",
    ST: "TX",
    cityWithStateAbbr: "Seguin, TX",
  },
  {
    zip: "78156",
    ST: "TX",
    cityWithStateAbbr: "Seguin, TX",
  },
  {
    zip: "78159",
    ST: "TX",
    cityWithStateAbbr: "Smiley, TX",
  },
  {
    zip: "78160",
    ST: "TX",
    cityWithStateAbbr: "Stockdale, TX",
  },
  {
    zip: "78161",
    ST: "TX",
    cityWithStateAbbr: "Sutherland Springs, TX",
  },
  {
    zip: "78162",
    ST: "TX",
    cityWithStateAbbr: "Tuleta, TX",
  },
  {
    zip: "78163",
    ST: "TX",
    cityWithStateAbbr: "Bulverde, TX",
  },
  {
    zip: "78164",
    ST: "TX",
    cityWithStateAbbr: "Yorktown, TX",
  },
  {
    zip: "78201",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78202",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78203",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78204",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78205",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78206",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78207",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78208",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78209",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78210",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78211",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78212",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78213",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78214",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78215",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78216",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78217",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78218",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78219",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78220",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78221",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78222",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78223",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78224",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78225",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78226",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78227",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78228",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78229",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78230",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78231",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78232",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78233",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78234",
    ST: "TX",
    cityWithStateAbbr: "Jbsa Ft Sam Houston, TX",
  },
  {
    zip: "78235",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78236",
    ST: "TX",
    cityWithStateAbbr: "Jbsa Lackland, TX",
  },
  {
    zip: "78237",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78238",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78239",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78240",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78241",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78242",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78243",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78244",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78245",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78246",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78247",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78248",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78249",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78250",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78251",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78252",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78253",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78254",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78255",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78256",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78257",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78258",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78259",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78260",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78261",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78263",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78264",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78265",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78266",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78268",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78269",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78270",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78278",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78279",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78280",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78283",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78284",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78285",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78287",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78288",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78289",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78291",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78292",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78293",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78294",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78295",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78296",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78297",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78298",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78299",
    ST: "TX",
    cityWithStateAbbr: "San Antonio, TX",
  },
  {
    zip: "78330",
    ST: "TX",
    cityWithStateAbbr: "Agua Dulce, TX",
  },
  {
    zip: "78332",
    ST: "TX",
    cityWithStateAbbr: "Alice, TX",
  },
  {
    zip: "78333",
    ST: "TX",
    cityWithStateAbbr: "Alice, TX",
  },
  {
    zip: "78335",
    ST: "TX",
    cityWithStateAbbr: "Aransas Pass, TX",
  },
  {
    zip: "78336",
    ST: "TX",
    cityWithStateAbbr: "Aransas Pass, TX",
  },
  {
    zip: "78338",
    ST: "TX",
    cityWithStateAbbr: "Armstrong, TX",
  },
  {
    zip: "78339",
    ST: "TX",
    cityWithStateAbbr: "Banquete, TX",
  },
  {
    zip: "78340",
    ST: "TX",
    cityWithStateAbbr: "Bayside, TX",
  },
  {
    zip: "78341",
    ST: "TX",
    cityWithStateAbbr: "Benavides, TX",
  },
  {
    zip: "78342",
    ST: "TX",
    cityWithStateAbbr: "Ben Bolt, TX",
  },
  {
    zip: "78343",
    ST: "TX",
    cityWithStateAbbr: "Bishop, TX",
  },
  {
    zip: "78344",
    ST: "TX",
    cityWithStateAbbr: "Bruni, TX",
  },
  {
    zip: "78347",
    ST: "TX",
    cityWithStateAbbr: "Chapman Ranch, TX",
  },
  {
    zip: "78349",
    ST: "TX",
    cityWithStateAbbr: "Concepcion, TX",
  },
  {
    zip: "78350",
    ST: "TX",
    cityWithStateAbbr: "Dinero, TX",
  },
  {
    zip: "78351",
    ST: "TX",
    cityWithStateAbbr: "Driscoll, TX",
  },
  {
    zip: "78352",
    ST: "TX",
    cityWithStateAbbr: "Edroy, TX",
  },
  {
    zip: "78353",
    ST: "TX",
    cityWithStateAbbr: "Encino, TX",
  },
  {
    zip: "78355",
    ST: "TX",
    cityWithStateAbbr: "Falfurrias, TX",
  },
  {
    zip: "78357",
    ST: "TX",
    cityWithStateAbbr: "Freer, TX",
  },
  {
    zip: "78358",
    ST: "TX",
    cityWithStateAbbr: "Fulton, TX",
  },
  {
    zip: "78359",
    ST: "TX",
    cityWithStateAbbr: "Gregory, TX",
  },
  {
    zip: "78360",
    ST: "TX",
    cityWithStateAbbr: "Guerra, TX",
  },
  {
    zip: "78361",
    ST: "TX",
    cityWithStateAbbr: "Hebbronville, TX",
  },
  {
    zip: "78362",
    ST: "TX",
    cityWithStateAbbr: "Ingleside, TX",
  },
  {
    zip: "78363",
    ST: "TX",
    cityWithStateAbbr: "Kingsville, TX",
  },
  {
    zip: "78364",
    ST: "TX",
    cityWithStateAbbr: "Kingsville, TX",
  },
  {
    zip: "78368",
    ST: "TX",
    cityWithStateAbbr: "Mathis, TX",
  },
  {
    zip: "78369",
    ST: "TX",
    cityWithStateAbbr: "Mirando City, TX",
  },
  {
    zip: "78370",
    ST: "TX",
    cityWithStateAbbr: "Odem, TX",
  },
  {
    zip: "78371",
    ST: "TX",
    cityWithStateAbbr: "Oilton, TX",
  },
  {
    zip: "78372",
    ST: "TX",
    cityWithStateAbbr: "Orange Grove, TX",
  },
  {
    zip: "78373",
    ST: "TX",
    cityWithStateAbbr: "Port Aransas, TX",
  },
  {
    zip: "78374",
    ST: "TX",
    cityWithStateAbbr: "Portland, TX",
  },
  {
    zip: "78375",
    ST: "TX",
    cityWithStateAbbr: "Premont, TX",
  },
  {
    zip: "78376",
    ST: "TX",
    cityWithStateAbbr: "Realitos, TX",
  },
  {
    zip: "78377",
    ST: "TX",
    cityWithStateAbbr: "Refugio, TX",
  },
  {
    zip: "78379",
    ST: "TX",
    cityWithStateAbbr: "Riviera, TX",
  },
  {
    zip: "78380",
    ST: "TX",
    cityWithStateAbbr: "Robstown, TX",
  },
  {
    zip: "78381",
    ST: "TX",
    cityWithStateAbbr: "Rockport, TX",
  },
  {
    zip: "78382",
    ST: "TX",
    cityWithStateAbbr: "Rockport, TX",
  },
  {
    zip: "78383",
    ST: "TX",
    cityWithStateAbbr: "Sandia, TX",
  },
  {
    zip: "78384",
    ST: "TX",
    cityWithStateAbbr: "San Diego, TX",
  },
  {
    zip: "78385",
    ST: "TX",
    cityWithStateAbbr: "Sarita, TX",
  },
  {
    zip: "78387",
    ST: "TX",
    cityWithStateAbbr: "Sinton, TX",
  },
  {
    zip: "78389",
    ST: "TX",
    cityWithStateAbbr: "Skidmore, TX",
  },
  {
    zip: "78390",
    ST: "TX",
    cityWithStateAbbr: "Taft, TX",
  },
  {
    zip: "78391",
    ST: "TX",
    cityWithStateAbbr: "Tynan, TX",
  },
  {
    zip: "78393",
    ST: "TX",
    cityWithStateAbbr: "Woodsboro, TX",
  },
  {
    zip: "78401",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78402",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78403",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78404",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78405",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78406",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78407",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78408",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78409",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78410",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78411",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78412",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78413",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78414",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78415",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78416",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78417",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78418",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78419",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78426",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78427",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78460",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78463",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78465",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78466",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78467",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78468",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78469",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78472",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78480",
    ST: "TX",
    cityWithStateAbbr: "Corpus Christi, TX",
  },
  {
    zip: "78501",
    ST: "TX",
    cityWithStateAbbr: "Mcallen, TX",
  },
  {
    zip: "78502",
    ST: "TX",
    cityWithStateAbbr: "Mcallen, TX",
  },
  {
    zip: "78503",
    ST: "TX",
    cityWithStateAbbr: "Mcallen, TX",
  },
  {
    zip: "78504",
    ST: "TX",
    cityWithStateAbbr: "Mcallen, TX",
  },
  {
    zip: "78505",
    ST: "TX",
    cityWithStateAbbr: "Mcallen, TX",
  },
  {
    zip: "78516",
    ST: "TX",
    cityWithStateAbbr: "Alamo, TX",
  },
  {
    zip: "78520",
    ST: "TX",
    cityWithStateAbbr: "Brownsville, TX",
  },
  {
    zip: "78521",
    ST: "TX",
    cityWithStateAbbr: "Brownsville, TX",
  },
  {
    zip: "78522",
    ST: "TX",
    cityWithStateAbbr: "Brownsville, TX",
  },
  {
    zip: "78523",
    ST: "TX",
    cityWithStateAbbr: "Brownsville, TX",
  },
  {
    zip: "78526",
    ST: "TX",
    cityWithStateAbbr: "Brownsville, TX",
  },
  {
    zip: "78535",
    ST: "TX",
    cityWithStateAbbr: "Combes, TX",
  },
  {
    zip: "78536",
    ST: "TX",
    cityWithStateAbbr: "Delmita, TX",
  },
  {
    zip: "78537",
    ST: "TX",
    cityWithStateAbbr: "Donna, TX",
  },
  {
    zip: "78538",
    ST: "TX",
    cityWithStateAbbr: "Edcouch, TX",
  },
  {
    zip: "78539",
    ST: "TX",
    cityWithStateAbbr: "Edinburg, TX",
  },
  {
    zip: "78540",
    ST: "TX",
    cityWithStateAbbr: "Edinburg, TX",
  },
  {
    zip: "78541",
    ST: "TX",
    cityWithStateAbbr: "Edinburg, TX",
  },
  {
    zip: "78542",
    ST: "TX",
    cityWithStateAbbr: "Edinburg, TX",
  },
  {
    zip: "78543",
    ST: "TX",
    cityWithStateAbbr: "Elsa, TX",
  },
  {
    zip: "78545",
    ST: "TX",
    cityWithStateAbbr: "Falcon Heights, TX",
  },
  {
    zip: "78547",
    ST: "TX",
    cityWithStateAbbr: "Garciasville, TX",
  },
  {
    zip: "78548",
    ST: "TX",
    cityWithStateAbbr: "Grulla, TX",
  },
  {
    zip: "78549",
    ST: "TX",
    cityWithStateAbbr: "Hargill, TX",
  },
  {
    zip: "78550",
    ST: "TX",
    cityWithStateAbbr: "Harlingen, TX",
  },
  {
    zip: "78551",
    ST: "TX",
    cityWithStateAbbr: "Harlingen, TX",
  },
  {
    zip: "78552",
    ST: "TX",
    cityWithStateAbbr: "Harlingen, TX",
  },
  {
    zip: "78553",
    ST: "TX",
    cityWithStateAbbr: "Harlingen, TX",
  },
  {
    zip: "78557",
    ST: "TX",
    cityWithStateAbbr: "Hidalgo, TX",
  },
  {
    zip: "78558",
    ST: "TX",
    cityWithStateAbbr: "La Blanca, TX",
  },
  {
    zip: "78559",
    ST: "TX",
    cityWithStateAbbr: "La Feria, TX",
  },
  {
    zip: "78560",
    ST: "TX",
    cityWithStateAbbr: "La Joya, TX",
  },
  {
    zip: "78561",
    ST: "TX",
    cityWithStateAbbr: "Lasara, TX",
  },
  {
    zip: "78562",
    ST: "TX",
    cityWithStateAbbr: "La Villa, TX",
  },
  {
    zip: "78563",
    ST: "TX",
    cityWithStateAbbr: "Linn, TX",
  },
  {
    zip: "78564",
    ST: "TX",
    cityWithStateAbbr: "Lopeno, TX",
  },
  {
    zip: "78565",
    ST: "TX",
    cityWithStateAbbr: "Los Ebanos, TX",
  },
  {
    zip: "78566",
    ST: "TX",
    cityWithStateAbbr: "Los Fresnos, TX",
  },
  {
    zip: "78567",
    ST: "TX",
    cityWithStateAbbr: "Los Indios, TX",
  },
  {
    zip: "78568",
    ST: "TX",
    cityWithStateAbbr: "Lozano, TX",
  },
  {
    zip: "78569",
    ST: "TX",
    cityWithStateAbbr: "Lyford, TX",
  },
  {
    zip: "78570",
    ST: "TX",
    cityWithStateAbbr: "Mercedes, TX",
  },
  {
    zip: "78572",
    ST: "TX",
    cityWithStateAbbr: "Mission, TX",
  },
  {
    zip: "78573",
    ST: "TX",
    cityWithStateAbbr: "Mission, TX",
  },
  {
    zip: "78574",
    ST: "TX",
    cityWithStateAbbr: "Mission, TX",
  },
  {
    zip: "78575",
    ST: "TX",
    cityWithStateAbbr: "Olmito, TX",
  },
  {
    zip: "78576",
    ST: "TX",
    cityWithStateAbbr: "Penitas, TX",
  },
  {
    zip: "78577",
    ST: "TX",
    cityWithStateAbbr: "Pharr, TX",
  },
  {
    zip: "78578",
    ST: "TX",
    cityWithStateAbbr: "Port Isabel, TX",
  },
  {
    zip: "78579",
    ST: "TX",
    cityWithStateAbbr: "Progreso, TX",
  },
  {
    zip: "78580",
    ST: "TX",
    cityWithStateAbbr: "Raymondville, TX",
  },
  {
    zip: "78582",
    ST: "TX",
    cityWithStateAbbr: "Rio Grande City, TX",
  },
  {
    zip: "78583",
    ST: "TX",
    cityWithStateAbbr: "Rio Hondo, TX",
  },
  {
    zip: "78584",
    ST: "TX",
    cityWithStateAbbr: "Roma, TX",
  },
  {
    zip: "78585",
    ST: "TX",
    cityWithStateAbbr: "Salineno, TX",
  },
  {
    zip: "78586",
    ST: "TX",
    cityWithStateAbbr: "San Benito, TX",
  },
  {
    zip: "78588",
    ST: "TX",
    cityWithStateAbbr: "San Isidro, TX",
  },
  {
    zip: "78589",
    ST: "TX",
    cityWithStateAbbr: "San Juan, TX",
  },
  {
    zip: "78590",
    ST: "TX",
    cityWithStateAbbr: "San Perlita, TX",
  },
  {
    zip: "78591",
    ST: "TX",
    cityWithStateAbbr: "Santa Elena, TX",
  },
  {
    zip: "78592",
    ST: "TX",
    cityWithStateAbbr: "Santa Maria, TX",
  },
  {
    zip: "78593",
    ST: "TX",
    cityWithStateAbbr: "Santa Rosa, TX",
  },
  {
    zip: "78594",
    ST: "TX",
    cityWithStateAbbr: "Sebastian, TX",
  },
  {
    zip: "78595",
    ST: "TX",
    cityWithStateAbbr: "Sullivan City, TX",
  },
  {
    zip: "78596",
    ST: "TX",
    cityWithStateAbbr: "Weslaco, TX",
  },
  {
    zip: "78597",
    ST: "TX",
    cityWithStateAbbr: "South Padre Island, TX",
  },
  {
    zip: "78598",
    ST: "TX",
    cityWithStateAbbr: "Port Mansfield, TX",
  },
  {
    zip: "78599",
    ST: "TX",
    cityWithStateAbbr: "Weslaco, TX",
  },
  {
    zip: "78602",
    ST: "TX",
    cityWithStateAbbr: "Bastrop, TX",
  },
  {
    zip: "78604",
    ST: "TX",
    cityWithStateAbbr: "Belmont, TX",
  },
  {
    zip: "78605",
    ST: "TX",
    cityWithStateAbbr: "Bertram, TX",
  },
  {
    zip: "78606",
    ST: "TX",
    cityWithStateAbbr: "Blanco, TX",
  },
  {
    zip: "78607",
    ST: "TX",
    cityWithStateAbbr: "Bluffton, TX",
  },
  {
    zip: "78608",
    ST: "TX",
    cityWithStateAbbr: "Briggs, TX",
  },
  {
    zip: "78609",
    ST: "TX",
    cityWithStateAbbr: "Buchanan Dam, TX",
  },
  {
    zip: "78610",
    ST: "TX",
    cityWithStateAbbr: "Buda, TX",
  },
  {
    zip: "78611",
    ST: "TX",
    cityWithStateAbbr: "Burnet, TX",
  },
  {
    zip: "78612",
    ST: "TX",
    cityWithStateAbbr: "Cedar Creek, TX",
  },
  {
    zip: "78613",
    ST: "TX",
    cityWithStateAbbr: "Cedar Park, TX",
  },
  {
    zip: "78614",
    ST: "TX",
    cityWithStateAbbr: "Cost, TX",
  },
  {
    zip: "78615",
    ST: "TX",
    cityWithStateAbbr: "Coupland, TX",
  },
  {
    zip: "78616",
    ST: "TX",
    cityWithStateAbbr: "Dale, TX",
  },
  {
    zip: "78617",
    ST: "TX",
    cityWithStateAbbr: "Del Valle, TX",
  },
  {
    zip: "78618",
    ST: "TX",
    cityWithStateAbbr: "Doss, TX",
  },
  {
    zip: "78619",
    ST: "TX",
    cityWithStateAbbr: "Driftwood, TX",
  },
  {
    zip: "78620",
    ST: "TX",
    cityWithStateAbbr: "Dripping Springs, TX",
  },
  {
    zip: "78621",
    ST: "TX",
    cityWithStateAbbr: "Elgin, TX",
  },
  {
    zip: "78622",
    ST: "TX",
    cityWithStateAbbr: "Fentress, TX",
  },
  {
    zip: "78623",
    ST: "TX",
    cityWithStateAbbr: "Fischer, TX",
  },
  {
    zip: "78624",
    ST: "TX",
    cityWithStateAbbr: "Fredericksburg, TX",
  },
  {
    zip: "78626",
    ST: "TX",
    cityWithStateAbbr: "Georgetown, TX",
  },
  {
    zip: "78627",
    ST: "TX",
    cityWithStateAbbr: "Georgetown, TX",
  },
  {
    zip: "78628",
    ST: "TX",
    cityWithStateAbbr: "Georgetown, TX",
  },
  {
    zip: "78629",
    ST: "TX",
    cityWithStateAbbr: "Gonzales, TX",
  },
  {
    zip: "78630",
    ST: "TX",
    cityWithStateAbbr: "Cedar Park, TX",
  },
  {
    zip: "78631",
    ST: "TX",
    cityWithStateAbbr: "Harper, TX",
  },
  {
    zip: "78632",
    ST: "TX",
    cityWithStateAbbr: "Harwood, TX",
  },
  {
    zip: "78633",
    ST: "TX",
    cityWithStateAbbr: "Georgetown, TX",
  },
  {
    zip: "78634",
    ST: "TX",
    cityWithStateAbbr: "Hutto, TX",
  },
  {
    zip: "78635",
    ST: "TX",
    cityWithStateAbbr: "Hye, TX",
  },
  {
    zip: "78636",
    ST: "TX",
    cityWithStateAbbr: "Johnson City, TX",
  },
  {
    zip: "78638",
    ST: "TX",
    cityWithStateAbbr: "Kingsbury, TX",
  },
  {
    zip: "78639",
    ST: "TX",
    cityWithStateAbbr: "Kingsland, TX",
  },
  {
    zip: "78640",
    ST: "TX",
    cityWithStateAbbr: "Kyle, TX",
  },
  {
    zip: "78641",
    ST: "TX",
    cityWithStateAbbr: "Leander, TX",
  },
  {
    zip: "78642",
    ST: "TX",
    cityWithStateAbbr: "Liberty Hill, TX",
  },
  {
    zip: "78643",
    ST: "TX",
    cityWithStateAbbr: "Llano, TX",
  },
  {
    zip: "78644",
    ST: "TX",
    cityWithStateAbbr: "Lockhart, TX",
  },
  {
    zip: "78645",
    ST: "TX",
    cityWithStateAbbr: "Leander, TX",
  },
  {
    zip: "78646",
    ST: "TX",
    cityWithStateAbbr: "Leander, TX",
  },
  {
    zip: "78648",
    ST: "TX",
    cityWithStateAbbr: "Luling, TX",
  },
  {
    zip: "78650",
    ST: "TX",
    cityWithStateAbbr: "Mc Dade, TX",
  },
  {
    zip: "78651",
    ST: "TX",
    cityWithStateAbbr: "Mc Neil, TX",
  },
  {
    zip: "78652",
    ST: "TX",
    cityWithStateAbbr: "Manchaca, TX",
  },
  {
    zip: "78653",
    ST: "TX",
    cityWithStateAbbr: "Manor, TX",
  },
  {
    zip: "78654",
    ST: "TX",
    cityWithStateAbbr: "Marble Falls, TX",
  },
  {
    zip: "78655",
    ST: "TX",
    cityWithStateAbbr: "Martindale, TX",
  },
  {
    zip: "78656",
    ST: "TX",
    cityWithStateAbbr: "Maxwell, TX",
  },
  {
    zip: "78657",
    ST: "TX",
    cityWithStateAbbr: "Horseshoe Bay, TX",
  },
  {
    zip: "78658",
    ST: "TX",
    cityWithStateAbbr: "Ottine, TX",
  },
  {
    zip: "78659",
    ST: "TX",
    cityWithStateAbbr: "Paige, TX",
  },
  {
    zip: "78660",
    ST: "TX",
    cityWithStateAbbr: "Pflugerville, TX",
  },
  {
    zip: "78661",
    ST: "TX",
    cityWithStateAbbr: "Prairie Lea, TX",
  },
  {
    zip: "78662",
    ST: "TX",
    cityWithStateAbbr: "Red Rock, TX",
  },
  {
    zip: "78663",
    ST: "TX",
    cityWithStateAbbr: "Round Mountain, TX",
  },
  {
    zip: "78664",
    ST: "TX",
    cityWithStateAbbr: "Round Rock, TX",
  },
  {
    zip: "78665",
    ST: "TX",
    cityWithStateAbbr: "Round Rock, TX",
  },
  {
    zip: "78666",
    ST: "TX",
    cityWithStateAbbr: "San Marcos, TX",
  },
  {
    zip: "78667",
    ST: "TX",
    cityWithStateAbbr: "San Marcos, TX",
  },
  {
    zip: "78669",
    ST: "TX",
    cityWithStateAbbr: "Spicewood, TX",
  },
  {
    zip: "78670",
    ST: "TX",
    cityWithStateAbbr: "Staples, TX",
  },
  {
    zip: "78671",
    ST: "TX",
    cityWithStateAbbr: "Stonewall, TX",
  },
  {
    zip: "78672",
    ST: "TX",
    cityWithStateAbbr: "Tow, TX",
  },
  {
    zip: "78673",
    ST: "TX",
    cityWithStateAbbr: "Walburg, TX",
  },
  {
    zip: "78674",
    ST: "TX",
    cityWithStateAbbr: "Weir, TX",
  },
  {
    zip: "78675",
    ST: "TX",
    cityWithStateAbbr: "Willow City, TX",
  },
  {
    zip: "78676",
    ST: "TX",
    cityWithStateAbbr: "Wimberley, TX",
  },
  {
    zip: "78677",
    ST: "TX",
    cityWithStateAbbr: "Wrightsboro, TX",
  },
  {
    zip: "78680",
    ST: "TX",
    cityWithStateAbbr: "Round Rock, TX",
  },
  {
    zip: "78681",
    ST: "TX",
    cityWithStateAbbr: "Round Rock, TX",
  },
  {
    zip: "78682",
    ST: "TX",
    cityWithStateAbbr: "Round Rock, TX",
  },
  {
    zip: "78683",
    ST: "TX",
    cityWithStateAbbr: "Round Rock, TX",
  },
  {
    zip: "78691",
    ST: "TX",
    cityWithStateAbbr: "Pflugerville, TX",
  },
  {
    zip: "78701",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78702",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78703",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78704",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78705",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78708",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78709",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78710",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78711",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78712",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78713",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78714",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78715",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78716",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78717",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78718",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78719",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78720",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78721",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78722",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78723",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78724",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78725",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78726",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78727",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78728",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78729",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78730",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78731",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78732",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78733",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78734",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78735",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78736",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78737",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78738",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78739",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78741",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78742",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78744",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78745",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78746",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78747",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78748",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78749",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78750",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78751",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78752",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78753",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78754",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78755",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78756",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78757",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78758",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78759",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78760",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78761",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78762",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78763",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78764",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78765",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78766",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78767",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78768",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78769",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78772",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78773",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78774",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78778",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78779",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78780",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78781",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78783",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78785",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78789",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78799",
    ST: "TX",
    cityWithStateAbbr: "Austin, TX",
  },
  {
    zip: "78801",
    ST: "TX",
    cityWithStateAbbr: "Uvalde, TX",
  },
  {
    zip: "78802",
    ST: "TX",
    cityWithStateAbbr: "Uvalde, TX",
  },
  {
    zip: "78827",
    ST: "TX",
    cityWithStateAbbr: "Asherton, TX",
  },
  {
    zip: "78828",
    ST: "TX",
    cityWithStateAbbr: "Barksdale, TX",
  },
  {
    zip: "78829",
    ST: "TX",
    cityWithStateAbbr: "Batesville, TX",
  },
  {
    zip: "78830",
    ST: "TX",
    cityWithStateAbbr: "Big Wells, TX",
  },
  {
    zip: "78832",
    ST: "TX",
    cityWithStateAbbr: "Brackettville, TX",
  },
  {
    zip: "78833",
    ST: "TX",
    cityWithStateAbbr: "Camp Wood, TX",
  },
  {
    zip: "78834",
    ST: "TX",
    cityWithStateAbbr: "Carrizo Springs, TX",
  },
  {
    zip: "78836",
    ST: "TX",
    cityWithStateAbbr: "Catarina, TX",
  },
  {
    zip: "78837",
    ST: "TX",
    cityWithStateAbbr: "Comstock, TX",
  },
  {
    zip: "78838",
    ST: "TX",
    cityWithStateAbbr: "Concan, TX",
  },
  {
    zip: "78839",
    ST: "TX",
    cityWithStateAbbr: "Crystal City, TX",
  },
  {
    zip: "78840",
    ST: "TX",
    cityWithStateAbbr: "Del Rio, TX",
  },
  {
    zip: "78841",
    ST: "TX",
    cityWithStateAbbr: "Del Rio, TX",
  },
  {
    zip: "78842",
    ST: "TX",
    cityWithStateAbbr: "Del Rio, TX",
  },
  {
    zip: "78843",
    ST: "TX",
    cityWithStateAbbr: "Laughlin Afb, TX",
  },
  {
    zip: "78847",
    ST: "TX",
    cityWithStateAbbr: "Del Rio, TX",
  },
  {
    zip: "78850",
    ST: "TX",
    cityWithStateAbbr: "D Hanis, TX",
  },
  {
    zip: "78851",
    ST: "TX",
    cityWithStateAbbr: "Dryden, TX",
  },
  {
    zip: "78852",
    ST: "TX",
    cityWithStateAbbr: "Eagle Pass, TX",
  },
  {
    zip: "78853",
    ST: "TX",
    cityWithStateAbbr: "Eagle Pass, TX",
  },
  {
    zip: "78860",
    ST: "TX",
    cityWithStateAbbr: "El Indio, TX",
  },
  {
    zip: "78861",
    ST: "TX",
    cityWithStateAbbr: "Hondo, TX",
  },
  {
    zip: "78870",
    ST: "TX",
    cityWithStateAbbr: "Knippa, TX",
  },
  {
    zip: "78871",
    ST: "TX",
    cityWithStateAbbr: "Langtry, TX",
  },
  {
    zip: "78872",
    ST: "TX",
    cityWithStateAbbr: "La Pryor, TX",
  },
  {
    zip: "78873",
    ST: "TX",
    cityWithStateAbbr: "Leakey, TX",
  },
  {
    zip: "78877",
    ST: "TX",
    cityWithStateAbbr: "Quemado, TX",
  },
  {
    zip: "78879",
    ST: "TX",
    cityWithStateAbbr: "Rio Frio, TX",
  },
  {
    zip: "78880",
    ST: "TX",
    cityWithStateAbbr: "Rocksprings, TX",
  },
  {
    zip: "78881",
    ST: "TX",
    cityWithStateAbbr: "Sabinal, TX",
  },
  {
    zip: "78883",
    ST: "TX",
    cityWithStateAbbr: "Tarpley, TX",
  },
  {
    zip: "78884",
    ST: "TX",
    cityWithStateAbbr: "Utopia, TX",
  },
  {
    zip: "78885",
    ST: "TX",
    cityWithStateAbbr: "Vanderpool, TX",
  },
  {
    zip: "78886",
    ST: "TX",
    cityWithStateAbbr: "Yancey, TX",
  },
  {
    zip: "78931",
    ST: "TX",
    cityWithStateAbbr: "Bleiblerville, TX",
  },
  {
    zip: "78932",
    ST: "TX",
    cityWithStateAbbr: "Carmine, TX",
  },
  {
    zip: "78933",
    ST: "TX",
    cityWithStateAbbr: "Cat Spring, TX",
  },
  {
    zip: "78934",
    ST: "TX",
    cityWithStateAbbr: "Columbus, TX",
  },
  {
    zip: "78935",
    ST: "TX",
    cityWithStateAbbr: "Alleyton, TX",
  },
  {
    zip: "78938",
    ST: "TX",
    cityWithStateAbbr: "Ellinger, TX",
  },
  {
    zip: "78940",
    ST: "TX",
    cityWithStateAbbr: "Fayetteville, TX",
  },
  {
    zip: "78941",
    ST: "TX",
    cityWithStateAbbr: "Flatonia, TX",
  },
  {
    zip: "78942",
    ST: "TX",
    cityWithStateAbbr: "Giddings, TX",
  },
  {
    zip: "78943",
    ST: "TX",
    cityWithStateAbbr: "Glidden, TX",
  },
  {
    zip: "78944",
    ST: "TX",
    cityWithStateAbbr: "Industry, TX",
  },
  {
    zip: "78945",
    ST: "TX",
    cityWithStateAbbr: "La Grange, TX",
  },
  {
    zip: "78946",
    ST: "TX",
    cityWithStateAbbr: "Ledbetter, TX",
  },
  {
    zip: "78947",
    ST: "TX",
    cityWithStateAbbr: "Lexington, TX",
  },
  {
    zip: "78948",
    ST: "TX",
    cityWithStateAbbr: "Lincoln, TX",
  },
  {
    zip: "78949",
    ST: "TX",
    cityWithStateAbbr: "Muldoon, TX",
  },
  {
    zip: "78950",
    ST: "TX",
    cityWithStateAbbr: "New Ulm, TX",
  },
  {
    zip: "78951",
    ST: "TX",
    cityWithStateAbbr: "Oakland, TX",
  },
  {
    zip: "78952",
    ST: "TX",
    cityWithStateAbbr: "Plum, TX",
  },
  {
    zip: "78953",
    ST: "TX",
    cityWithStateAbbr: "Rosanky, TX",
  },
  {
    zip: "78954",
    ST: "TX",
    cityWithStateAbbr: "Round Top, TX",
  },
  {
    zip: "78956",
    ST: "TX",
    cityWithStateAbbr: "Schulenburg, TX",
  },
  {
    zip: "78957",
    ST: "TX",
    cityWithStateAbbr: "Smithville, TX",
  },
  {
    zip: "78959",
    ST: "TX",
    cityWithStateAbbr: "Waelder, TX",
  },
  {
    zip: "78960",
    ST: "TX",
    cityWithStateAbbr: "Warda, TX",
  },
  {
    zip: "78961",
    ST: "TX",
    cityWithStateAbbr: "Warrenton, TX",
  },
  {
    zip: "78962",
    ST: "TX",
    cityWithStateAbbr: "Weimar, TX",
  },
  {
    zip: "78963",
    ST: "TX",
    cityWithStateAbbr: "West Point, TX",
  },
  {
    zip: "79001",
    ST: "TX",
    cityWithStateAbbr: "Adrian, TX",
  },
  {
    zip: "79002",
    ST: "TX",
    cityWithStateAbbr: "Alanreed, TX",
  },
  {
    zip: "79003",
    ST: "TX",
    cityWithStateAbbr: "Allison, TX",
  },
  {
    zip: "79005",
    ST: "TX",
    cityWithStateAbbr: "Booker, TX",
  },
  {
    zip: "79007",
    ST: "TX",
    cityWithStateAbbr: "Borger, TX",
  },
  {
    zip: "79008",
    ST: "TX",
    cityWithStateAbbr: "Borger, TX",
  },
  {
    zip: "79009",
    ST: "TX",
    cityWithStateAbbr: "Bovina, TX",
  },
  {
    zip: "79010",
    ST: "TX",
    cityWithStateAbbr: "Boys Ranch, TX",
  },
  {
    zip: "79011",
    ST: "TX",
    cityWithStateAbbr: "Briscoe, TX",
  },
  {
    zip: "79012",
    ST: "TX",
    cityWithStateAbbr: "Bushland, TX",
  },
  {
    zip: "79013",
    ST: "TX",
    cityWithStateAbbr: "Cactus, TX",
  },
  {
    zip: "79014",
    ST: "TX",
    cityWithStateAbbr: "Canadian, TX",
  },
  {
    zip: "79015",
    ST: "TX",
    cityWithStateAbbr: "Canyon, TX",
  },
  {
    zip: "79016",
    ST: "TX",
    cityWithStateAbbr: "Canyon, TX",
  },
  {
    zip: "79018",
    ST: "TX",
    cityWithStateAbbr: "Channing, TX",
  },
  {
    zip: "79019",
    ST: "TX",
    cityWithStateAbbr: "Claude, TX",
  },
  {
    zip: "79021",
    ST: "TX",
    cityWithStateAbbr: "Cotton Center, TX",
  },
  {
    zip: "79022",
    ST: "TX",
    cityWithStateAbbr: "Dalhart, TX",
  },
  {
    zip: "79024",
    ST: "TX",
    cityWithStateAbbr: "Darrouzett, TX",
  },
  {
    zip: "79025",
    ST: "TX",
    cityWithStateAbbr: "Dawn, TX",
  },
  {
    zip: "79027",
    ST: "TX",
    cityWithStateAbbr: "Dimmitt, TX",
  },
  {
    zip: "79029",
    ST: "TX",
    cityWithStateAbbr: "Dumas, TX",
  },
  {
    zip: "79031",
    ST: "TX",
    cityWithStateAbbr: "Earth, TX",
  },
  {
    zip: "79032",
    ST: "TX",
    cityWithStateAbbr: "Edmonson, TX",
  },
  {
    zip: "79033",
    ST: "TX",
    cityWithStateAbbr: "Farnsworth, TX",
  },
  {
    zip: "79034",
    ST: "TX",
    cityWithStateAbbr: "Follett, TX",
  },
  {
    zip: "79035",
    ST: "TX",
    cityWithStateAbbr: "Friona, TX",
  },
  {
    zip: "79036",
    ST: "TX",
    cityWithStateAbbr: "Fritch, TX",
  },
  {
    zip: "79039",
    ST: "TX",
    cityWithStateAbbr: "Groom, TX",
  },
  {
    zip: "79040",
    ST: "TX",
    cityWithStateAbbr: "Gruver, TX",
  },
  {
    zip: "79041",
    ST: "TX",
    cityWithStateAbbr: "Hale Center, TX",
  },
  {
    zip: "79042",
    ST: "TX",
    cityWithStateAbbr: "Happy, TX",
  },
  {
    zip: "79043",
    ST: "TX",
    cityWithStateAbbr: "Hart, TX",
  },
  {
    zip: "79044",
    ST: "TX",
    cityWithStateAbbr: "Hartley, TX",
  },
  {
    zip: "79045",
    ST: "TX",
    cityWithStateAbbr: "Hereford, TX",
  },
  {
    zip: "79046",
    ST: "TX",
    cityWithStateAbbr: "Higgins, TX",
  },
  {
    zip: "79051",
    ST: "TX",
    cityWithStateAbbr: "Kerrick, TX",
  },
  {
    zip: "79052",
    ST: "TX",
    cityWithStateAbbr: "Kress, TX",
  },
  {
    zip: "79053",
    ST: "TX",
    cityWithStateAbbr: "Lazbuddie, TX",
  },
  {
    zip: "79054",
    ST: "TX",
    cityWithStateAbbr: "Lefors, TX",
  },
  {
    zip: "79056",
    ST: "TX",
    cityWithStateAbbr: "Lipscomb, TX",
  },
  {
    zip: "79057",
    ST: "TX",
    cityWithStateAbbr: "Mclean, TX",
  },
  {
    zip: "79058",
    ST: "TX",
    cityWithStateAbbr: "Masterson, TX",
  },
  {
    zip: "79059",
    ST: "TX",
    cityWithStateAbbr: "Miami, TX",
  },
  {
    zip: "79061",
    ST: "TX",
    cityWithStateAbbr: "Mobeetie, TX",
  },
  {
    zip: "79062",
    ST: "TX",
    cityWithStateAbbr: "Morse, TX",
  },
  {
    zip: "79063",
    ST: "TX",
    cityWithStateAbbr: "Nazareth, TX",
  },
  {
    zip: "79064",
    ST: "TX",
    cityWithStateAbbr: "Olton, TX",
  },
  {
    zip: "79065",
    ST: "TX",
    cityWithStateAbbr: "Pampa, TX",
  },
  {
    zip: "79066",
    ST: "TX",
    cityWithStateAbbr: "Pampa, TX",
  },
  {
    zip: "79068",
    ST: "TX",
    cityWithStateAbbr: "Panhandle, TX",
  },
  {
    zip: "79070",
    ST: "TX",
    cityWithStateAbbr: "Perryton, TX",
  },
  {
    zip: "79072",
    ST: "TX",
    cityWithStateAbbr: "Plainview, TX",
  },
  {
    zip: "79073",
    ST: "TX",
    cityWithStateAbbr: "Plainview, TX",
  },
  {
    zip: "79077",
    ST: "TX",
    cityWithStateAbbr: "Sam Norwood, TX",
  },
  {
    zip: "79078",
    ST: "TX",
    cityWithStateAbbr: "Sanford, TX",
  },
  {
    zip: "79079",
    ST: "TX",
    cityWithStateAbbr: "Shamrock, TX",
  },
  {
    zip: "79080",
    ST: "TX",
    cityWithStateAbbr: "Skellytown, TX",
  },
  {
    zip: "79081",
    ST: "TX",
    cityWithStateAbbr: "Spearman, TX",
  },
  {
    zip: "79082",
    ST: "TX",
    cityWithStateAbbr: "Springlake, TX",
  },
  {
    zip: "79083",
    ST: "TX",
    cityWithStateAbbr: "Stinnett, TX",
  },
  {
    zip: "79084",
    ST: "TX",
    cityWithStateAbbr: "Stratford, TX",
  },
  {
    zip: "79085",
    ST: "TX",
    cityWithStateAbbr: "Summerfield, TX",
  },
  {
    zip: "79086",
    ST: "TX",
    cityWithStateAbbr: "Sunray, TX",
  },
  {
    zip: "79087",
    ST: "TX",
    cityWithStateAbbr: "Texline, TX",
  },
  {
    zip: "79088",
    ST: "TX",
    cityWithStateAbbr: "Tulia, TX",
  },
  {
    zip: "79091",
    ST: "TX",
    cityWithStateAbbr: "Umbarger, TX",
  },
  {
    zip: "79092",
    ST: "TX",
    cityWithStateAbbr: "Vega, TX",
  },
  {
    zip: "79093",
    ST: "TX",
    cityWithStateAbbr: "Waka, TX",
  },
  {
    zip: "79094",
    ST: "TX",
    cityWithStateAbbr: "Wayside, TX",
  },
  {
    zip: "79095",
    ST: "TX",
    cityWithStateAbbr: "Wellington, TX",
  },
  {
    zip: "79096",
    ST: "TX",
    cityWithStateAbbr: "Wheeler, TX",
  },
  {
    zip: "79097",
    ST: "TX",
    cityWithStateAbbr: "White Deer, TX",
  },
  {
    zip: "79098",
    ST: "TX",
    cityWithStateAbbr: "Wildorado, TX",
  },
  {
    zip: "79101",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79102",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79103",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79104",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79105",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79106",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79107",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79108",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79109",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79110",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79111",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79114",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79116",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79117",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79118",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79119",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79120",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79121",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79124",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79159",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79166",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79168",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79172",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79174",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79178",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79185",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79189",
    ST: "TX",
    cityWithStateAbbr: "Amarillo, TX",
  },
  {
    zip: "79201",
    ST: "TX",
    cityWithStateAbbr: "Childress, TX",
  },
  {
    zip: "79220",
    ST: "TX",
    cityWithStateAbbr: "Afton, TX",
  },
  {
    zip: "79221",
    ST: "TX",
    cityWithStateAbbr: "Aiken, TX",
  },
  {
    zip: "79223",
    ST: "TX",
    cityWithStateAbbr: "Cee Vee, TX",
  },
  {
    zip: "79225",
    ST: "TX",
    cityWithStateAbbr: "Chillicothe, TX",
  },
  {
    zip: "79226",
    ST: "TX",
    cityWithStateAbbr: "Clarendon, TX",
  },
  {
    zip: "79227",
    ST: "TX",
    cityWithStateAbbr: "Crowell, TX",
  },
  {
    zip: "79229",
    ST: "TX",
    cityWithStateAbbr: "Dickens, TX",
  },
  {
    zip: "79230",
    ST: "TX",
    cityWithStateAbbr: "Dodson, TX",
  },
  {
    zip: "79231",
    ST: "TX",
    cityWithStateAbbr: "Dougherty, TX",
  },
  {
    zip: "79233",
    ST: "TX",
    cityWithStateAbbr: "Estelline, TX",
  },
  {
    zip: "79234",
    ST: "TX",
    cityWithStateAbbr: "Flomot, TX",
  },
  {
    zip: "79235",
    ST: "TX",
    cityWithStateAbbr: "Floydada, TX",
  },
  {
    zip: "79236",
    ST: "TX",
    cityWithStateAbbr: "Guthrie, TX",
  },
  {
    zip: "79237",
    ST: "TX",
    cityWithStateAbbr: "Hedley, TX",
  },
  {
    zip: "79239",
    ST: "TX",
    cityWithStateAbbr: "Lakeview, TX",
  },
  {
    zip: "79240",
    ST: "TX",
    cityWithStateAbbr: "Lelia Lake, TX",
  },
  {
    zip: "79241",
    ST: "TX",
    cityWithStateAbbr: "Lockney, TX",
  },
  {
    zip: "79243",
    ST: "TX",
    cityWithStateAbbr: "Mcadoo, TX",
  },
  {
    zip: "79244",
    ST: "TX",
    cityWithStateAbbr: "Matador, TX",
  },
  {
    zip: "79245",
    ST: "TX",
    cityWithStateAbbr: "Memphis, TX",
  },
  {
    zip: "79247",
    ST: "TX",
    cityWithStateAbbr: "Odell, TX",
  },
  {
    zip: "79248",
    ST: "TX",
    cityWithStateAbbr: "Paducah, TX",
  },
  {
    zip: "79250",
    ST: "TX",
    cityWithStateAbbr: "Petersburg, TX",
  },
  {
    zip: "79251",
    ST: "TX",
    cityWithStateAbbr: "Quail, TX",
  },
  {
    zip: "79252",
    ST: "TX",
    cityWithStateAbbr: "Quanah, TX",
  },
  {
    zip: "79255",
    ST: "TX",
    cityWithStateAbbr: "Quitaque, TX",
  },
  {
    zip: "79256",
    ST: "TX",
    cityWithStateAbbr: "Roaring Springs, TX",
  },
  {
    zip: "79257",
    ST: "TX",
    cityWithStateAbbr: "Silverton, TX",
  },
  {
    zip: "79258",
    ST: "TX",
    cityWithStateAbbr: "South Plains, TX",
  },
  {
    zip: "79259",
    ST: "TX",
    cityWithStateAbbr: "Tell, TX",
  },
  {
    zip: "79261",
    ST: "TX",
    cityWithStateAbbr: "Turkey, TX",
  },
  {
    zip: "79311",
    ST: "TX",
    cityWithStateAbbr: "Abernathy, TX",
  },
  {
    zip: "79312",
    ST: "TX",
    cityWithStateAbbr: "Amherst, TX",
  },
  {
    zip: "79313",
    ST: "TX",
    cityWithStateAbbr: "Anton, TX",
  },
  {
    zip: "79314",
    ST: "TX",
    cityWithStateAbbr: "Bledsoe, TX",
  },
  {
    zip: "79316",
    ST: "TX",
    cityWithStateAbbr: "Brownfield, TX",
  },
  {
    zip: "79322",
    ST: "TX",
    cityWithStateAbbr: "Crosbyton, TX",
  },
  {
    zip: "79323",
    ST: "TX",
    cityWithStateAbbr: "Denver City, TX",
  },
  {
    zip: "79324",
    ST: "TX",
    cityWithStateAbbr: "Enochs, TX",
  },
  {
    zip: "79325",
    ST: "TX",
    cityWithStateAbbr: "Farwell, TX",
  },
  {
    zip: "79326",
    ST: "TX",
    cityWithStateAbbr: "Fieldton, TX",
  },
  {
    zip: "79329",
    ST: "TX",
    cityWithStateAbbr: "Idalou, TX",
  },
  {
    zip: "79330",
    ST: "TX",
    cityWithStateAbbr: "Justiceburg, TX",
  },
  {
    zip: "79331",
    ST: "TX",
    cityWithStateAbbr: "Lamesa, TX",
  },
  {
    zip: "79336",
    ST: "TX",
    cityWithStateAbbr: "Levelland, TX",
  },
  {
    zip: "79338",
    ST: "TX",
    cityWithStateAbbr: "Levelland, TX",
  },
  {
    zip: "79339",
    ST: "TX",
    cityWithStateAbbr: "Littlefield, TX",
  },
  {
    zip: "79342",
    ST: "TX",
    cityWithStateAbbr: "Loop, TX",
  },
  {
    zip: "79343",
    ST: "TX",
    cityWithStateAbbr: "Lorenzo, TX",
  },
  {
    zip: "79344",
    ST: "TX",
    cityWithStateAbbr: "Maple, TX",
  },
  {
    zip: "79345",
    ST: "TX",
    cityWithStateAbbr: "Meadow, TX",
  },
  {
    zip: "79346",
    ST: "TX",
    cityWithStateAbbr: "Morton, TX",
  },
  {
    zip: "79347",
    ST: "TX",
    cityWithStateAbbr: "Muleshoe, TX",
  },
  {
    zip: "79350",
    ST: "TX",
    cityWithStateAbbr: "New Deal, TX",
  },
  {
    zip: "79351",
    ST: "TX",
    cityWithStateAbbr: "Odonnell, TX",
  },
  {
    zip: "79353",
    ST: "TX",
    cityWithStateAbbr: "Pep, TX",
  },
  {
    zip: "79355",
    ST: "TX",
    cityWithStateAbbr: "Plains, TX",
  },
  {
    zip: "79356",
    ST: "TX",
    cityWithStateAbbr: "Post, TX",
  },
  {
    zip: "79357",
    ST: "TX",
    cityWithStateAbbr: "Ralls, TX",
  },
  {
    zip: "79358",
    ST: "TX",
    cityWithStateAbbr: "Ropesville, TX",
  },
  {
    zip: "79359",
    ST: "TX",
    cityWithStateAbbr: "Seagraves, TX",
  },
  {
    zip: "79360",
    ST: "TX",
    cityWithStateAbbr: "Seminole, TX",
  },
  {
    zip: "79363",
    ST: "TX",
    cityWithStateAbbr: "Shallowater, TX",
  },
  {
    zip: "79364",
    ST: "TX",
    cityWithStateAbbr: "Slaton, TX",
  },
  {
    zip: "79366",
    ST: "TX",
    cityWithStateAbbr: "Ransom Canyon, TX",
  },
  {
    zip: "79367",
    ST: "TX",
    cityWithStateAbbr: "Smyer, TX",
  },
  {
    zip: "79369",
    ST: "TX",
    cityWithStateAbbr: "Spade, TX",
  },
  {
    zip: "79370",
    ST: "TX",
    cityWithStateAbbr: "Spur, TX",
  },
  {
    zip: "79371",
    ST: "TX",
    cityWithStateAbbr: "Sudan, TX",
  },
  {
    zip: "79372",
    ST: "TX",
    cityWithStateAbbr: "Sundown, TX",
  },
  {
    zip: "79373",
    ST: "TX",
    cityWithStateAbbr: "Tahoka, TX",
  },
  {
    zip: "79376",
    ST: "TX",
    cityWithStateAbbr: "Tokio, TX",
  },
  {
    zip: "79377",
    ST: "TX",
    cityWithStateAbbr: "Welch, TX",
  },
  {
    zip: "79378",
    ST: "TX",
    cityWithStateAbbr: "Wellman, TX",
  },
  {
    zip: "79379",
    ST: "TX",
    cityWithStateAbbr: "Whiteface, TX",
  },
  {
    zip: "79380",
    ST: "TX",
    cityWithStateAbbr: "Whitharral, TX",
  },
  {
    zip: "79381",
    ST: "TX",
    cityWithStateAbbr: "Wilson, TX",
  },
  {
    zip: "79382",
    ST: "TX",
    cityWithStateAbbr: "Wolfforth, TX",
  },
  {
    zip: "79383",
    ST: "TX",
    cityWithStateAbbr: "New Home, TX",
  },
  {
    zip: "79401",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79402",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79403",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79404",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79406",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79407",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79408",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79409",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79410",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79411",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79412",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79413",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79414",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79415",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79416",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79423",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79424",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79430",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79452",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79453",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79457",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79464",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79490",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79491",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79493",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79499",
    ST: "TX",
    cityWithStateAbbr: "Lubbock, TX",
  },
  {
    zip: "79501",
    ST: "TX",
    cityWithStateAbbr: "Anson, TX",
  },
  {
    zip: "79502",
    ST: "TX",
    cityWithStateAbbr: "Aspermont, TX",
  },
  {
    zip: "79503",
    ST: "TX",
    cityWithStateAbbr: "Avoca, TX",
  },
  {
    zip: "79504",
    ST: "TX",
    cityWithStateAbbr: "Baird, TX",
  },
  {
    zip: "79505",
    ST: "TX",
    cityWithStateAbbr: "Benjamin, TX",
  },
  {
    zip: "79506",
    ST: "TX",
    cityWithStateAbbr: "Blackwell, TX",
  },
  {
    zip: "79508",
    ST: "TX",
    cityWithStateAbbr: "Buffalo Gap, TX",
  },
  {
    zip: "79510",
    ST: "TX",
    cityWithStateAbbr: "Clyde, TX",
  },
  {
    zip: "79511",
    ST: "TX",
    cityWithStateAbbr: "Coahoma, TX",
  },
  {
    zip: "79512",
    ST: "TX",
    cityWithStateAbbr: "Colorado City, TX",
  },
  {
    zip: "79516",
    ST: "TX",
    cityWithStateAbbr: "Dunn, TX",
  },
  {
    zip: "79517",
    ST: "TX",
    cityWithStateAbbr: "Fluvanna, TX",
  },
  {
    zip: "79518",
    ST: "TX",
    cityWithStateAbbr: "Girard, TX",
  },
  {
    zip: "79519",
    ST: "TX",
    cityWithStateAbbr: "Goldsboro, TX",
  },
  {
    zip: "79520",
    ST: "TX",
    cityWithStateAbbr: "Hamlin, TX",
  },
  {
    zip: "79521",
    ST: "TX",
    cityWithStateAbbr: "Haskell, TX",
  },
  {
    zip: "79525",
    ST: "TX",
    cityWithStateAbbr: "Hawley, TX",
  },
  {
    zip: "79526",
    ST: "TX",
    cityWithStateAbbr: "Hermleigh, TX",
  },
  {
    zip: "79527",
    ST: "TX",
    cityWithStateAbbr: "Ira, TX",
  },
  {
    zip: "79528",
    ST: "TX",
    cityWithStateAbbr: "Jayton, TX",
  },
  {
    zip: "79529",
    ST: "TX",
    cityWithStateAbbr: "Knox City, TX",
  },
  {
    zip: "79530",
    ST: "TX",
    cityWithStateAbbr: "Lawn, TX",
  },
  {
    zip: "79532",
    ST: "TX",
    cityWithStateAbbr: "Loraine, TX",
  },
  {
    zip: "79533",
    ST: "TX",
    cityWithStateAbbr: "Lueders, TX",
  },
  {
    zip: "79534",
    ST: "TX",
    cityWithStateAbbr: "Mc Caulley, TX",
  },
  {
    zip: "79535",
    ST: "TX",
    cityWithStateAbbr: "Maryneal, TX",
  },
  {
    zip: "79536",
    ST: "TX",
    cityWithStateAbbr: "Merkel, TX",
  },
  {
    zip: "79537",
    ST: "TX",
    cityWithStateAbbr: "Nolan, TX",
  },
  {
    zip: "79538",
    ST: "TX",
    cityWithStateAbbr: "Novice, TX",
  },
  {
    zip: "79539",
    ST: "TX",
    cityWithStateAbbr: "O Brien, TX",
  },
  {
    zip: "79540",
    ST: "TX",
    cityWithStateAbbr: "Old Glory, TX",
  },
  {
    zip: "79541",
    ST: "TX",
    cityWithStateAbbr: "Ovalo, TX",
  },
  {
    zip: "79543",
    ST: "TX",
    cityWithStateAbbr: "Roby, TX",
  },
  {
    zip: "79544",
    ST: "TX",
    cityWithStateAbbr: "Rochester, TX",
  },
  {
    zip: "79545",
    ST: "TX",
    cityWithStateAbbr: "Roscoe, TX",
  },
  {
    zip: "79546",
    ST: "TX",
    cityWithStateAbbr: "Rotan, TX",
  },
  {
    zip: "79547",
    ST: "TX",
    cityWithStateAbbr: "Rule, TX",
  },
  {
    zip: "79548",
    ST: "TX",
    cityWithStateAbbr: "Rule, TX",
  },
  {
    zip: "79549",
    ST: "TX",
    cityWithStateAbbr: "Snyder, TX",
  },
  {
    zip: "79550",
    ST: "TX",
    cityWithStateAbbr: "Snyder, TX",
  },
  {
    zip: "79553",
    ST: "TX",
    cityWithStateAbbr: "Stamford, TX",
  },
  {
    zip: "79556",
    ST: "TX",
    cityWithStateAbbr: "Sweetwater, TX",
  },
  {
    zip: "79560",
    ST: "TX",
    cityWithStateAbbr: "Sylvester, TX",
  },
  {
    zip: "79561",
    ST: "TX",
    cityWithStateAbbr: "Trent, TX",
  },
  {
    zip: "79562",
    ST: "TX",
    cityWithStateAbbr: "Tuscola, TX",
  },
  {
    zip: "79563",
    ST: "TX",
    cityWithStateAbbr: "Tye, TX",
  },
  {
    zip: "79565",
    ST: "TX",
    cityWithStateAbbr: "Westbrook, TX",
  },
  {
    zip: "79566",
    ST: "TX",
    cityWithStateAbbr: "Wingate, TX",
  },
  {
    zip: "79567",
    ST: "TX",
    cityWithStateAbbr: "Winters, TX",
  },
  {
    zip: "79601",
    ST: "TX",
    cityWithStateAbbr: "Abilene, TX",
  },
  {
    zip: "79602",
    ST: "TX",
    cityWithStateAbbr: "Abilene, TX",
  },
  {
    zip: "79603",
    ST: "TX",
    cityWithStateAbbr: "Abilene, TX",
  },
  {
    zip: "79604",
    ST: "TX",
    cityWithStateAbbr: "Abilene, TX",
  },
  {
    zip: "79605",
    ST: "TX",
    cityWithStateAbbr: "Abilene, TX",
  },
  {
    zip: "79606",
    ST: "TX",
    cityWithStateAbbr: "Abilene, TX",
  },
  {
    zip: "79607",
    ST: "TX",
    cityWithStateAbbr: "Dyess Afb, TX",
  },
  {
    zip: "79608",
    ST: "TX",
    cityWithStateAbbr: "Abilene, TX",
  },
  {
    zip: "79697",
    ST: "TX",
    cityWithStateAbbr: "Abilene, TX",
  },
  {
    zip: "79698",
    ST: "TX",
    cityWithStateAbbr: "Abilene, TX",
  },
  {
    zip: "79699",
    ST: "TX",
    cityWithStateAbbr: "Abilene, TX",
  },
  {
    zip: "79701",
    ST: "TX",
    cityWithStateAbbr: "Midland, TX",
  },
  {
    zip: "79702",
    ST: "TX",
    cityWithStateAbbr: "Midland, TX",
  },
  {
    zip: "79703",
    ST: "TX",
    cityWithStateAbbr: "Midland, TX",
  },
  {
    zip: "79704",
    ST: "TX",
    cityWithStateAbbr: "Midland, TX",
  },
  {
    zip: "79705",
    ST: "TX",
    cityWithStateAbbr: "Midland, TX",
  },
  {
    zip: "79706",
    ST: "TX",
    cityWithStateAbbr: "Midland, TX",
  },
  {
    zip: "79707",
    ST: "TX",
    cityWithStateAbbr: "Midland, TX",
  },
  {
    zip: "79708",
    ST: "TX",
    cityWithStateAbbr: "Midland, TX",
  },
  {
    zip: "79710",
    ST: "TX",
    cityWithStateAbbr: "Midland, TX",
  },
  {
    zip: "79711",
    ST: "TX",
    cityWithStateAbbr: "Midland, TX",
  },
  {
    zip: "79712",
    ST: "TX",
    cityWithStateAbbr: "Midland, TX",
  },
  {
    zip: "79713",
    ST: "TX",
    cityWithStateAbbr: "Ackerly, TX",
  },
  {
    zip: "79714",
    ST: "TX",
    cityWithStateAbbr: "Andrews, TX",
  },
  {
    zip: "79718",
    ST: "TX",
    cityWithStateAbbr: "Balmorhea, TX",
  },
  {
    zip: "79719",
    ST: "TX",
    cityWithStateAbbr: "Barstow, TX",
  },
  {
    zip: "79720",
    ST: "TX",
    cityWithStateAbbr: "Big Spring, TX",
  },
  {
    zip: "79721",
    ST: "TX",
    cityWithStateAbbr: "Big Spring, TX",
  },
  {
    zip: "79730",
    ST: "TX",
    cityWithStateAbbr: "Coyanosa, TX",
  },
  {
    zip: "79731",
    ST: "TX",
    cityWithStateAbbr: "Crane, TX",
  },
  {
    zip: "79733",
    ST: "TX",
    cityWithStateAbbr: "Forsan, TX",
  },
  {
    zip: "79734",
    ST: "TX",
    cityWithStateAbbr: "Fort Davis, TX",
  },
  {
    zip: "79735",
    ST: "TX",
    cityWithStateAbbr: "Fort Stockton, TX",
  },
  {
    zip: "79738",
    ST: "TX",
    cityWithStateAbbr: "Gail, TX",
  },
  {
    zip: "79739",
    ST: "TX",
    cityWithStateAbbr: "Garden City, TX",
  },
  {
    zip: "79740",
    ST: "TX",
    cityWithStateAbbr: "Girvin, TX",
  },
  {
    zip: "79741",
    ST: "TX",
    cityWithStateAbbr: "Goldsmith, TX",
  },
  {
    zip: "79742",
    ST: "TX",
    cityWithStateAbbr: "Grandfalls, TX",
  },
  {
    zip: "79743",
    ST: "TX",
    cityWithStateAbbr: "Imperial, TX",
  },
  {
    zip: "79744",
    ST: "TX",
    cityWithStateAbbr: "Iraan, TX",
  },
  {
    zip: "79745",
    ST: "TX",
    cityWithStateAbbr: "Kermit, TX",
  },
  {
    zip: "79748",
    ST: "TX",
    cityWithStateAbbr: "Knott, TX",
  },
  {
    zip: "79749",
    ST: "TX",
    cityWithStateAbbr: "Lenorah, TX",
  },
  {
    zip: "79752",
    ST: "TX",
    cityWithStateAbbr: "Mc Camey, TX",
  },
  {
    zip: "79754",
    ST: "TX",
    cityWithStateAbbr: "Mentone, TX",
  },
  {
    zip: "79755",
    ST: "TX",
    cityWithStateAbbr: "Midkiff, TX",
  },
  {
    zip: "79756",
    ST: "TX",
    cityWithStateAbbr: "Monahans, TX",
  },
  {
    zip: "79758",
    ST: "TX",
    cityWithStateAbbr: "Gardendale, TX",
  },
  {
    zip: "79759",
    ST: "TX",
    cityWithStateAbbr: "Notrees, TX",
  },
  {
    zip: "79760",
    ST: "TX",
    cityWithStateAbbr: "Odessa, TX",
  },
  {
    zip: "79761",
    ST: "TX",
    cityWithStateAbbr: "Odessa, TX",
  },
  {
    zip: "79762",
    ST: "TX",
    cityWithStateAbbr: "Odessa, TX",
  },
  {
    zip: "79763",
    ST: "TX",
    cityWithStateAbbr: "Odessa, TX",
  },
  {
    zip: "79764",
    ST: "TX",
    cityWithStateAbbr: "Odessa, TX",
  },
  {
    zip: "79765",
    ST: "TX",
    cityWithStateAbbr: "Odessa, TX",
  },
  {
    zip: "79766",
    ST: "TX",
    cityWithStateAbbr: "Odessa, TX",
  },
  {
    zip: "79768",
    ST: "TX",
    cityWithStateAbbr: "Odessa, TX",
  },
  {
    zip: "79769",
    ST: "TX",
    cityWithStateAbbr: "Odessa, TX",
  },
  {
    zip: "79770",
    ST: "TX",
    cityWithStateAbbr: "Orla, TX",
  },
  {
    zip: "79772",
    ST: "TX",
    cityWithStateAbbr: "Pecos, TX",
  },
  {
    zip: "79776",
    ST: "TX",
    cityWithStateAbbr: "Penwell, TX",
  },
  {
    zip: "79777",
    ST: "TX",
    cityWithStateAbbr: "Pyote, TX",
  },
  {
    zip: "79778",
    ST: "TX",
    cityWithStateAbbr: "Rankin, TX",
  },
  {
    zip: "79780",
    ST: "TX",
    cityWithStateAbbr: "Saragosa, TX",
  },
  {
    zip: "79781",
    ST: "TX",
    cityWithStateAbbr: "Sheffield, TX",
  },
  {
    zip: "79782",
    ST: "TX",
    cityWithStateAbbr: "Stanton, TX",
  },
  {
    zip: "79783",
    ST: "TX",
    cityWithStateAbbr: "Tarzan, TX",
  },
  {
    zip: "79785",
    ST: "TX",
    cityWithStateAbbr: "Toyah, TX",
  },
  {
    zip: "79786",
    ST: "TX",
    cityWithStateAbbr: "Toyahvale, TX",
  },
  {
    zip: "79788",
    ST: "TX",
    cityWithStateAbbr: "Wickett, TX",
  },
  {
    zip: "79789",
    ST: "TX",
    cityWithStateAbbr: "Wink, TX",
  },
  {
    zip: "79821",
    ST: "TX",
    cityWithStateAbbr: "Anthony, TX",
  },
  {
    zip: "79830",
    ST: "TX",
    cityWithStateAbbr: "Alpine, TX",
  },
  {
    zip: "79831",
    ST: "TX",
    cityWithStateAbbr: "Alpine, TX",
  },
  {
    zip: "79832",
    ST: "TX",
    cityWithStateAbbr: "Alpine, TX",
  },
  {
    zip: "79834",
    ST: "TX",
    cityWithStateAbbr: "Big Bend National Park, TX",
  },
  {
    zip: "79835",
    ST: "TX",
    cityWithStateAbbr: "Canutillo, TX",
  },
  {
    zip: "79836",
    ST: "TX",
    cityWithStateAbbr: "Clint, TX",
  },
  {
    zip: "79837",
    ST: "NM",
    cityWithStateAbbr: "Dell City, NM",
  },
  {
    zip: "79838",
    ST: "TX",
    cityWithStateAbbr: "Fabens, TX",
  },
  {
    zip: "79839",
    ST: "TX",
    cityWithStateAbbr: "Fort Hancock, TX",
  },
  {
    zip: "79842",
    ST: "TX",
    cityWithStateAbbr: "Marathon, TX",
  },
  {
    zip: "79843",
    ST: "TX",
    cityWithStateAbbr: "Marfa, TX",
  },
  {
    zip: "79845",
    ST: "TX",
    cityWithStateAbbr: "Presidio, TX",
  },
  {
    zip: "79846",
    ST: "TX",
    cityWithStateAbbr: "Redford, TX",
  },
  {
    zip: "79847",
    ST: "TX",
    cityWithStateAbbr: "Salt Flat, TX",
  },
  {
    zip: "79848",
    ST: "TX",
    cityWithStateAbbr: "Sanderson, TX",
  },
  {
    zip: "79849",
    ST: "TX",
    cityWithStateAbbr: "San Elizario, TX",
  },
  {
    zip: "79851",
    ST: "TX",
    cityWithStateAbbr: "Sierra Blanca, TX",
  },
  {
    zip: "79852",
    ST: "TX",
    cityWithStateAbbr: "Terlingua, TX",
  },
  {
    zip: "79853",
    ST: "TX",
    cityWithStateAbbr: "Tornillo, TX",
  },
  {
    zip: "79854",
    ST: "TX",
    cityWithStateAbbr: "Valentine, TX",
  },
  {
    zip: "79855",
    ST: "TX",
    cityWithStateAbbr: "Van Horn, TX",
  },
  {
    zip: "79901",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79902",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79903",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79904",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79905",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79906",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79907",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79908",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79910",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79911",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79912",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79913",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79914",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79915",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79916",
    ST: "TX",
    cityWithStateAbbr: "Fort Bliss, TX",
  },
  {
    zip: "79917",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79918",
    ST: "TX",
    cityWithStateAbbr: "Fort Bliss, TX",
  },
  {
    zip: "79920",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79922",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79923",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79924",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79925",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79926",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79927",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79928",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79929",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79930",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79931",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79932",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79934",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79935",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79936",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79937",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79938",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79940",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79941",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79942",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79943",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79944",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79945",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79946",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79947",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79948",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79949",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79950",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79951",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79952",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79953",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79954",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79955",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79958",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79960",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79961",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79968",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79976",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79978",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79980",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79990",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79995",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79996",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79997",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79998",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "79999",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "80001",
    ST: "CO",
    cityWithStateAbbr: "Arvada, CO",
  },
  {
    zip: "80002",
    ST: "CO",
    cityWithStateAbbr: "Arvada, CO",
  },
  {
    zip: "80003",
    ST: "CO",
    cityWithStateAbbr: "Arvada, CO",
  },
  {
    zip: "80004",
    ST: "CO",
    cityWithStateAbbr: "Arvada, CO",
  },
  {
    zip: "80005",
    ST: "CO",
    cityWithStateAbbr: "Arvada, CO",
  },
  {
    zip: "80006",
    ST: "CO",
    cityWithStateAbbr: "Arvada, CO",
  },
  {
    zip: "80007",
    ST: "CO",
    cityWithStateAbbr: "Arvada, CO",
  },
  {
    zip: "80010",
    ST: "CO",
    cityWithStateAbbr: "Aurora, CO",
  },
  {
    zip: "80011",
    ST: "CO",
    cityWithStateAbbr: "Aurora, CO",
  },
  {
    zip: "80012",
    ST: "CO",
    cityWithStateAbbr: "Aurora, CO",
  },
  {
    zip: "80013",
    ST: "CO",
    cityWithStateAbbr: "Aurora, CO",
  },
  {
    zip: "80014",
    ST: "CO",
    cityWithStateAbbr: "Aurora, CO",
  },
  {
    zip: "80015",
    ST: "CO",
    cityWithStateAbbr: "Aurora, CO",
  },
  {
    zip: "80016",
    ST: "CO",
    cityWithStateAbbr: "Aurora, CO",
  },
  {
    zip: "80017",
    ST: "CO",
    cityWithStateAbbr: "Aurora, CO",
  },
  {
    zip: "80018",
    ST: "CO",
    cityWithStateAbbr: "Aurora, CO",
  },
  {
    zip: "80019",
    ST: "CO",
    cityWithStateAbbr: "Aurora, CO",
  },
  {
    zip: "80020",
    ST: "CO",
    cityWithStateAbbr: "Broomfield, CO",
  },
  {
    zip: "80021",
    ST: "CO",
    cityWithStateAbbr: "Broomfield, CO",
  },
  {
    zip: "80022",
    ST: "CO",
    cityWithStateAbbr: "Commerce City, CO",
  },
  {
    zip: "80023",
    ST: "CO",
    cityWithStateAbbr: "Broomfield, CO",
  },
  {
    zip: "80024",
    ST: "CO",
    cityWithStateAbbr: "Dupont, CO",
  },
  {
    zip: "80025",
    ST: "CO",
    cityWithStateAbbr: "Eldorado Springs, CO",
  },
  {
    zip: "80026",
    ST: "CO",
    cityWithStateAbbr: "Lafayette, CO",
  },
  {
    zip: "80027",
    ST: "CO",
    cityWithStateAbbr: "Louisville, CO",
  },
  {
    zip: "80030",
    ST: "CO",
    cityWithStateAbbr: "Westminster, CO",
  },
  {
    zip: "80031",
    ST: "CO",
    cityWithStateAbbr: "Westminster, CO",
  },
  {
    zip: "80033",
    ST: "CO",
    cityWithStateAbbr: "Wheat Ridge, CO",
  },
  {
    zip: "80034",
    ST: "CO",
    cityWithStateAbbr: "Wheat Ridge, CO",
  },
  {
    zip: "80035",
    ST: "CO",
    cityWithStateAbbr: "Westminster, CO",
  },
  {
    zip: "80036",
    ST: "CO",
    cityWithStateAbbr: "Westminster, CO",
  },
  {
    zip: "80037",
    ST: "CO",
    cityWithStateAbbr: "Commerce City, CO",
  },
  {
    zip: "80038",
    ST: "CO",
    cityWithStateAbbr: "Broomfield, CO",
  },
  {
    zip: "80040",
    ST: "CO",
    cityWithStateAbbr: "Aurora, CO",
  },
  {
    zip: "80041",
    ST: "CO",
    cityWithStateAbbr: "Aurora, CO",
  },
  {
    zip: "80042",
    ST: "CO",
    cityWithStateAbbr: "Aurora, CO",
  },
  {
    zip: "80044",
    ST: "CO",
    cityWithStateAbbr: "Aurora, CO",
  },
  {
    zip: "80045",
    ST: "CO",
    cityWithStateAbbr: "Aurora, CO",
  },
  {
    zip: "80046",
    ST: "CO",
    cityWithStateAbbr: "Aurora, CO",
  },
  {
    zip: "80047",
    ST: "CO",
    cityWithStateAbbr: "Aurora, CO",
  },
  {
    zip: "80101",
    ST: "CO",
    cityWithStateAbbr: "Agate, CO",
  },
  {
    zip: "80102",
    ST: "CO",
    cityWithStateAbbr: "Bennett, CO",
  },
  {
    zip: "80103",
    ST: "CO",
    cityWithStateAbbr: "Byers, CO",
  },
  {
    zip: "80104",
    ST: "CO",
    cityWithStateAbbr: "Castle Rock, CO",
  },
  {
    zip: "80105",
    ST: "CO",
    cityWithStateAbbr: "Deer Trail, CO",
  },
  {
    zip: "80106",
    ST: "CO",
    cityWithStateAbbr: "Elbert, CO",
  },
  {
    zip: "80107",
    ST: "CO",
    cityWithStateAbbr: "Elizabeth, CO",
  },
  {
    zip: "80108",
    ST: "CO",
    cityWithStateAbbr: "Castle Rock, CO",
  },
  {
    zip: "80109",
    ST: "CO",
    cityWithStateAbbr: "Castle Rock, CO",
  },
  {
    zip: "80110",
    ST: "CO",
    cityWithStateAbbr: "Englewood, CO",
  },
  {
    zip: "80111",
    ST: "CO",
    cityWithStateAbbr: "Englewood, CO",
  },
  {
    zip: "80112",
    ST: "CO",
    cityWithStateAbbr: "Englewood, CO",
  },
  {
    zip: "80113",
    ST: "CO",
    cityWithStateAbbr: "Englewood, CO",
  },
  {
    zip: "80116",
    ST: "CO",
    cityWithStateAbbr: "Franktown, CO",
  },
  {
    zip: "80117",
    ST: "CO",
    cityWithStateAbbr: "Kiowa, CO",
  },
  {
    zip: "80118",
    ST: "CO",
    cityWithStateAbbr: "Larkspur, CO",
  },
  {
    zip: "80120",
    ST: "CO",
    cityWithStateAbbr: "Littleton, CO",
  },
  {
    zip: "80121",
    ST: "CO",
    cityWithStateAbbr: "Littleton, CO",
  },
  {
    zip: "80122",
    ST: "CO",
    cityWithStateAbbr: "Littleton, CO",
  },
  {
    zip: "80123",
    ST: "CO",
    cityWithStateAbbr: "Littleton, CO",
  },
  {
    zip: "80124",
    ST: "CO",
    cityWithStateAbbr: "Lone Tree, CO",
  },
  {
    zip: "80125",
    ST: "CO",
    cityWithStateAbbr: "Littleton, CO",
  },
  {
    zip: "80126",
    ST: "CO",
    cityWithStateAbbr: "Littleton, CO",
  },
  {
    zip: "80127",
    ST: "CO",
    cityWithStateAbbr: "Littleton, CO",
  },
  {
    zip: "80128",
    ST: "CO",
    cityWithStateAbbr: "Littleton, CO",
  },
  {
    zip: "80129",
    ST: "CO",
    cityWithStateAbbr: "Littleton, CO",
  },
  {
    zip: "80130",
    ST: "CO",
    cityWithStateAbbr: "Littleton, CO",
  },
  {
    zip: "80131",
    ST: "CO",
    cityWithStateAbbr: "Louviers, CO",
  },
  {
    zip: "80132",
    ST: "CO",
    cityWithStateAbbr: "Monument, CO",
  },
  {
    zip: "80133",
    ST: "CO",
    cityWithStateAbbr: "Palmer Lake, CO",
  },
  {
    zip: "80134",
    ST: "CO",
    cityWithStateAbbr: "Parker, CO",
  },
  {
    zip: "80135",
    ST: "CO",
    cityWithStateAbbr: "Sedalia, CO",
  },
  {
    zip: "80136",
    ST: "CO",
    cityWithStateAbbr: "Strasburg, CO",
  },
  {
    zip: "80137",
    ST: "CO",
    cityWithStateAbbr: "Watkins, CO",
  },
  {
    zip: "80138",
    ST: "CO",
    cityWithStateAbbr: "Parker, CO",
  },
  {
    zip: "80150",
    ST: "CO",
    cityWithStateAbbr: "Englewood, CO",
  },
  {
    zip: "80151",
    ST: "CO",
    cityWithStateAbbr: "Englewood, CO",
  },
  {
    zip: "80155",
    ST: "CO",
    cityWithStateAbbr: "Englewood, CO",
  },
  {
    zip: "80160",
    ST: "CO",
    cityWithStateAbbr: "Littleton, CO",
  },
  {
    zip: "80161",
    ST: "CO",
    cityWithStateAbbr: "Littleton, CO",
  },
  {
    zip: "80162",
    ST: "CO",
    cityWithStateAbbr: "Littleton, CO",
  },
  {
    zip: "80163",
    ST: "CO",
    cityWithStateAbbr: "Littleton, CO",
  },
  {
    zip: "80165",
    ST: "CO",
    cityWithStateAbbr: "Littleton, CO",
  },
  {
    zip: "80166",
    ST: "CO",
    cityWithStateAbbr: "Littleton, CO",
  },
  {
    zip: "80201",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80202",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80203",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80204",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80205",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80206",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80207",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80208",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80209",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80210",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80211",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80212",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80214",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80215",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80216",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80217",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80218",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80219",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80220",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80221",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80222",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80223",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80224",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80225",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80226",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80227",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80228",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80229",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80230",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80231",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80232",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80233",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80234",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80235",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80236",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80237",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80238",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80239",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80241",
    ST: "CO",
    cityWithStateAbbr: "Thornton, CO",
  },
  {
    zip: "80243",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80244",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80246",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80247",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80248",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80249",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80250",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80251",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80252",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80256",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80257",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80259",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80260",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80261",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80262",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80263",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80264",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80266",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80271",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80273",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80274",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80279",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80280",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80281",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80290",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80291",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80293",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80294",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80295",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80299",
    ST: "CO",
    cityWithStateAbbr: "Denver, CO",
  },
  {
    zip: "80301",
    ST: "CO",
    cityWithStateAbbr: "Boulder, CO",
  },
  {
    zip: "80302",
    ST: "CO",
    cityWithStateAbbr: "Boulder, CO",
  },
  {
    zip: "80303",
    ST: "CO",
    cityWithStateAbbr: "Boulder, CO",
  },
  {
    zip: "80304",
    ST: "CO",
    cityWithStateAbbr: "Boulder, CO",
  },
  {
    zip: "80305",
    ST: "CO",
    cityWithStateAbbr: "Boulder, CO",
  },
  {
    zip: "80306",
    ST: "CO",
    cityWithStateAbbr: "Boulder, CO",
  },
  {
    zip: "80307",
    ST: "CO",
    cityWithStateAbbr: "Boulder, CO",
  },
  {
    zip: "80308",
    ST: "CO",
    cityWithStateAbbr: "Boulder, CO",
  },
  {
    zip: "80309",
    ST: "CO",
    cityWithStateAbbr: "Boulder, CO",
  },
  {
    zip: "80310",
    ST: "CO",
    cityWithStateAbbr: "Boulder, CO",
  },
  {
    zip: "80314",
    ST: "CO",
    cityWithStateAbbr: "Boulder, CO",
  },
  {
    zip: "80321",
    ST: "CO",
    cityWithStateAbbr: "Boulder, CO",
  },
  {
    zip: "80322",
    ST: "CO",
    cityWithStateAbbr: "Boulder, CO",
  },
  {
    zip: "80323",
    ST: "CO",
    cityWithStateAbbr: "Boulder, CO",
  },
  {
    zip: "80328",
    ST: "CO",
    cityWithStateAbbr: "Boulder, CO",
  },
  {
    zip: "80329",
    ST: "CO",
    cityWithStateAbbr: "Boulder, CO",
  },
  {
    zip: "80401",
    ST: "CO",
    cityWithStateAbbr: "Golden, CO",
  },
  {
    zip: "80402",
    ST: "CO",
    cityWithStateAbbr: "Golden, CO",
  },
  {
    zip: "80403",
    ST: "CO",
    cityWithStateAbbr: "Golden, CO",
  },
  {
    zip: "80419",
    ST: "CO",
    cityWithStateAbbr: "Golden, CO",
  },
  {
    zip: "80420",
    ST: "CO",
    cityWithStateAbbr: "Alma, CO",
  },
  {
    zip: "80421",
    ST: "CO",
    cityWithStateAbbr: "Bailey, CO",
  },
  {
    zip: "80422",
    ST: "CO",
    cityWithStateAbbr: "Black Hawk, CO",
  },
  {
    zip: "80423",
    ST: "CO",
    cityWithStateAbbr: "Bond, CO",
  },
  {
    zip: "80424",
    ST: "CO",
    cityWithStateAbbr: "Breckenridge, CO",
  },
  {
    zip: "80425",
    ST: "CO",
    cityWithStateAbbr: "Buffalo Creek, CO",
  },
  {
    zip: "80426",
    ST: "CO",
    cityWithStateAbbr: "Burns, CO",
  },
  {
    zip: "80427",
    ST: "CO",
    cityWithStateAbbr: "Central City, CO",
  },
  {
    zip: "80428",
    ST: "CO",
    cityWithStateAbbr: "Clark, CO",
  },
  {
    zip: "80429",
    ST: "CO",
    cityWithStateAbbr: "Climax, CO",
  },
  {
    zip: "80430",
    ST: "CO",
    cityWithStateAbbr: "Coalmont, CO",
  },
  {
    zip: "80432",
    ST: "CO",
    cityWithStateAbbr: "Como, CO",
  },
  {
    zip: "80433",
    ST: "CO",
    cityWithStateAbbr: "Conifer, CO",
  },
  {
    zip: "80434",
    ST: "CO",
    cityWithStateAbbr: "Cowdrey, CO",
  },
  {
    zip: "80435",
    ST: "CO",
    cityWithStateAbbr: "Dillon, CO",
  },
  {
    zip: "80436",
    ST: "CO",
    cityWithStateAbbr: "Dumont, CO",
  },
  {
    zip: "80437",
    ST: "CO",
    cityWithStateAbbr: "Evergreen, CO",
  },
  {
    zip: "80438",
    ST: "CO",
    cityWithStateAbbr: "Empire, CO",
  },
  {
    zip: "80439",
    ST: "CO",
    cityWithStateAbbr: "Evergreen, CO",
  },
  {
    zip: "80440",
    ST: "CO",
    cityWithStateAbbr: "Fairplay, CO",
  },
  {
    zip: "80442",
    ST: "CO",
    cityWithStateAbbr: "Fraser, CO",
  },
  {
    zip: "80443",
    ST: "CO",
    cityWithStateAbbr: "Frisco, CO",
  },
  {
    zip: "80444",
    ST: "CO",
    cityWithStateAbbr: "Georgetown, CO",
  },
  {
    zip: "80446",
    ST: "CO",
    cityWithStateAbbr: "Granby, CO",
  },
  {
    zip: "80447",
    ST: "CO",
    cityWithStateAbbr: "Grand Lake, CO",
  },
  {
    zip: "80448",
    ST: "CO",
    cityWithStateAbbr: "Grant, CO",
  },
  {
    zip: "80449",
    ST: "CO",
    cityWithStateAbbr: "Hartsel, CO",
  },
  {
    zip: "80451",
    ST: "CO",
    cityWithStateAbbr: "Hot Sulphur Springs, CO",
  },
  {
    zip: "80452",
    ST: "CO",
    cityWithStateAbbr: "Idaho Springs, CO",
  },
  {
    zip: "80453",
    ST: "CO",
    cityWithStateAbbr: "Idledale, CO",
  },
  {
    zip: "80454",
    ST: "CO",
    cityWithStateAbbr: "Indian Hills, CO",
  },
  {
    zip: "80455",
    ST: "CO",
    cityWithStateAbbr: "Jamestown, CO",
  },
  {
    zip: "80456",
    ST: "CO",
    cityWithStateAbbr: "Jefferson, CO",
  },
  {
    zip: "80457",
    ST: "CO",
    cityWithStateAbbr: "Kittredge, CO",
  },
  {
    zip: "80459",
    ST: "CO",
    cityWithStateAbbr: "Kremmling, CO",
  },
  {
    zip: "80461",
    ST: "CO",
    cityWithStateAbbr: "Leadville, CO",
  },
  {
    zip: "80463",
    ST: "CO",
    cityWithStateAbbr: "Mc Coy, CO",
  },
  {
    zip: "80465",
    ST: "CO",
    cityWithStateAbbr: "Morrison, CO",
  },
  {
    zip: "80466",
    ST: "CO",
    cityWithStateAbbr: "Nederland, CO",
  },
  {
    zip: "80467",
    ST: "CO",
    cityWithStateAbbr: "Oak Creek, CO",
  },
  {
    zip: "80468",
    ST: "CO",
    cityWithStateAbbr: "Parshall, CO",
  },
  {
    zip: "80469",
    ST: "CO",
    cityWithStateAbbr: "Phippsburg, CO",
  },
  {
    zip: "80470",
    ST: "CO",
    cityWithStateAbbr: "Pine, CO",
  },
  {
    zip: "80471",
    ST: "CO",
    cityWithStateAbbr: "Pinecliffe, CO",
  },
  {
    zip: "80473",
    ST: "CO",
    cityWithStateAbbr: "Rand, CO",
  },
  {
    zip: "80474",
    ST: "CO",
    cityWithStateAbbr: "Rollinsville, CO",
  },
  {
    zip: "80475",
    ST: "CO",
    cityWithStateAbbr: "Shawnee, CO",
  },
  {
    zip: "80476",
    ST: "CO",
    cityWithStateAbbr: "Silver Plume, CO",
  },
  {
    zip: "80477",
    ST: "CO",
    cityWithStateAbbr: "Steamboat Springs, CO",
  },
  {
    zip: "80478",
    ST: "CO",
    cityWithStateAbbr: "Tabernash, CO",
  },
  {
    zip: "80479",
    ST: "CO",
    cityWithStateAbbr: "Toponas, CO",
  },
  {
    zip: "80480",
    ST: "CO",
    cityWithStateAbbr: "Walden, CO",
  },
  {
    zip: "80481",
    ST: "CO",
    cityWithStateAbbr: "Ward, CO",
  },
  {
    zip: "80482",
    ST: "CO",
    cityWithStateAbbr: "Winter Park, CO",
  },
  {
    zip: "80483",
    ST: "CO",
    cityWithStateAbbr: "Yampa, CO",
  },
  {
    zip: "80487",
    ST: "CO",
    cityWithStateAbbr: "Steamboat Springs, CO",
  },
  {
    zip: "80488",
    ST: "CO",
    cityWithStateAbbr: "Steamboat Springs, CO",
  },
  {
    zip: "80497",
    ST: "CO",
    cityWithStateAbbr: "Silverthorne, CO",
  },
  {
    zip: "80498",
    ST: "CO",
    cityWithStateAbbr: "Silverthorne, CO",
  },
  {
    zip: "80501",
    ST: "CO",
    cityWithStateAbbr: "Longmont, CO",
  },
  {
    zip: "80502",
    ST: "CO",
    cityWithStateAbbr: "Longmont, CO",
  },
  {
    zip: "80503",
    ST: "CO",
    cityWithStateAbbr: "Longmont, CO",
  },
  {
    zip: "80504",
    ST: "CO",
    cityWithStateAbbr: "Longmont, CO",
  },
  {
    zip: "80510",
    ST: "CO",
    cityWithStateAbbr: "Allenspark, CO",
  },
  {
    zip: "80511",
    ST: "CO",
    cityWithStateAbbr: "Estes Park, CO",
  },
  {
    zip: "80512",
    ST: "CO",
    cityWithStateAbbr: "Bellvue, CO",
  },
  {
    zip: "80513",
    ST: "CO",
    cityWithStateAbbr: "Berthoud, CO",
  },
  {
    zip: "80514",
    ST: "CO",
    cityWithStateAbbr: "Dacono, CO",
  },
  {
    zip: "80515",
    ST: "CO",
    cityWithStateAbbr: "Drake, CO",
  },
  {
    zip: "80516",
    ST: "CO",
    cityWithStateAbbr: "Erie, CO",
  },
  {
    zip: "80517",
    ST: "CO",
    cityWithStateAbbr: "Estes Park, CO",
  },
  {
    zip: "80520",
    ST: "CO",
    cityWithStateAbbr: "Firestone, CO",
  },
  {
    zip: "80521",
    ST: "CO",
    cityWithStateAbbr: "Fort Collins, CO",
  },
  {
    zip: "80522",
    ST: "CO",
    cityWithStateAbbr: "Fort Collins, CO",
  },
  {
    zip: "80523",
    ST: "CO",
    cityWithStateAbbr: "Fort Collins, CO",
  },
  {
    zip: "80524",
    ST: "CO",
    cityWithStateAbbr: "Fort Collins, CO",
  },
  {
    zip: "80525",
    ST: "CO",
    cityWithStateAbbr: "Fort Collins, CO",
  },
  {
    zip: "80526",
    ST: "CO",
    cityWithStateAbbr: "Fort Collins, CO",
  },
  {
    zip: "80527",
    ST: "CO",
    cityWithStateAbbr: "Fort Collins, CO",
  },
  {
    zip: "80528",
    ST: "CO",
    cityWithStateAbbr: "Fort Collins, CO",
  },
  {
    zip: "80530",
    ST: "CO",
    cityWithStateAbbr: "Frederick, CO",
  },
  {
    zip: "80532",
    ST: "CO",
    cityWithStateAbbr: "Glen Haven, CO",
  },
  {
    zip: "80533",
    ST: "CO",
    cityWithStateAbbr: "Hygiene, CO",
  },
  {
    zip: "80534",
    ST: "CO",
    cityWithStateAbbr: "Johnstown, CO",
  },
  {
    zip: "80535",
    ST: "CO",
    cityWithStateAbbr: "Laporte, CO",
  },
  {
    zip: "80536",
    ST: "CO",
    cityWithStateAbbr: "Livermore, CO",
  },
  {
    zip: "80537",
    ST: "CO",
    cityWithStateAbbr: "Loveland, CO",
  },
  {
    zip: "80538",
    ST: "CO",
    cityWithStateAbbr: "Loveland, CO",
  },
  {
    zip: "80539",
    ST: "CO",
    cityWithStateAbbr: "Loveland, CO",
  },
  {
    zip: "80540",
    ST: "CO",
    cityWithStateAbbr: "Lyons, CO",
  },
  {
    zip: "80541",
    ST: "CO",
    cityWithStateAbbr: "Masonville, CO",
  },
  {
    zip: "80542",
    ST: "CO",
    cityWithStateAbbr: "Mead, CO",
  },
  {
    zip: "80543",
    ST: "CO",
    cityWithStateAbbr: "Milliken, CO",
  },
  {
    zip: "80544",
    ST: "CO",
    cityWithStateAbbr: "Niwot, CO",
  },
  {
    zip: "80545",
    ST: "CO",
    cityWithStateAbbr: "Red Feather Lakes, CO",
  },
  {
    zip: "80546",
    ST: "CO",
    cityWithStateAbbr: "Severance, CO",
  },
  {
    zip: "80547",
    ST: "CO",
    cityWithStateAbbr: "Timnath, CO",
  },
  {
    zip: "80549",
    ST: "CO",
    cityWithStateAbbr: "Wellington, CO",
  },
  {
    zip: "80550",
    ST: "CO",
    cityWithStateAbbr: "Windsor, CO",
  },
  {
    zip: "80551",
    ST: "CO",
    cityWithStateAbbr: "Windsor, CO",
  },
  {
    zip: "80553",
    ST: "CO",
    cityWithStateAbbr: "Fort Collins, CO",
  },
  {
    zip: "80601",
    ST: "CO",
    cityWithStateAbbr: "Brighton, CO",
  },
  {
    zip: "80602",
    ST: "CO",
    cityWithStateAbbr: "Brighton, CO",
  },
  {
    zip: "80603",
    ST: "CO",
    cityWithStateAbbr: "Brighton, CO",
  },
  {
    zip: "80610",
    ST: "CO",
    cityWithStateAbbr: "Ault, CO",
  },
  {
    zip: "80611",
    ST: "CO",
    cityWithStateAbbr: "Briggsdale, CO",
  },
  {
    zip: "80612",
    ST: "CO",
    cityWithStateAbbr: "Carr, CO",
  },
  {
    zip: "80614",
    ST: "CO",
    cityWithStateAbbr: "Eastlake, CO",
  },
  {
    zip: "80615",
    ST: "CO",
    cityWithStateAbbr: "Eaton, CO",
  },
  {
    zip: "80620",
    ST: "CO",
    cityWithStateAbbr: "Evans, CO",
  },
  {
    zip: "80621",
    ST: "CO",
    cityWithStateAbbr: "Fort Lupton, CO",
  },
  {
    zip: "80622",
    ST: "CO",
    cityWithStateAbbr: "Galeton, CO",
  },
  {
    zip: "80623",
    ST: "CO",
    cityWithStateAbbr: "Gilcrest, CO",
  },
  {
    zip: "80624",
    ST: "CO",
    cityWithStateAbbr: "Gill, CO",
  },
  {
    zip: "80631",
    ST: "CO",
    cityWithStateAbbr: "Greeley, CO",
  },
  {
    zip: "80632",
    ST: "CO",
    cityWithStateAbbr: "Greeley, CO",
  },
  {
    zip: "80633",
    ST: "CO",
    cityWithStateAbbr: "Greeley, CO",
  },
  {
    zip: "80634",
    ST: "CO",
    cityWithStateAbbr: "Greeley, CO",
  },
  {
    zip: "80638",
    ST: "CO",
    cityWithStateAbbr: "Greeley, CO",
  },
  {
    zip: "80639",
    ST: "CO",
    cityWithStateAbbr: "Greeley, CO",
  },
  {
    zip: "80640",
    ST: "CO",
    cityWithStateAbbr: "Henderson, CO",
  },
  {
    zip: "80642",
    ST: "CO",
    cityWithStateAbbr: "Hudson, CO",
  },
  {
    zip: "80643",
    ST: "CO",
    cityWithStateAbbr: "Keenesburg, CO",
  },
  {
    zip: "80644",
    ST: "CO",
    cityWithStateAbbr: "Kersey, CO",
  },
  {
    zip: "80645",
    ST: "CO",
    cityWithStateAbbr: "La Salle, CO",
  },
  {
    zip: "80646",
    ST: "CO",
    cityWithStateAbbr: "Lucerne, CO",
  },
  {
    zip: "80648",
    ST: "CO",
    cityWithStateAbbr: "Nunn, CO",
  },
  {
    zip: "80649",
    ST: "CO",
    cityWithStateAbbr: "Orchard, CO",
  },
  {
    zip: "80650",
    ST: "CO",
    cityWithStateAbbr: "Pierce, CO",
  },
  {
    zip: "80651",
    ST: "CO",
    cityWithStateAbbr: "Platteville, CO",
  },
  {
    zip: "80652",
    ST: "CO",
    cityWithStateAbbr: "Roggen, CO",
  },
  {
    zip: "80653",
    ST: "CO",
    cityWithStateAbbr: "Weldona, CO",
  },
  {
    zip: "80654",
    ST: "CO",
    cityWithStateAbbr: "Wiggins, CO",
  },
  {
    zip: "80701",
    ST: "CO",
    cityWithStateAbbr: "Fort Morgan, CO",
  },
  {
    zip: "80705",
    ST: "CO",
    cityWithStateAbbr: "Log Lane Village, CO",
  },
  {
    zip: "80720",
    ST: "CO",
    cityWithStateAbbr: "Akron, CO",
  },
  {
    zip: "80721",
    ST: "CO",
    cityWithStateAbbr: "Amherst, CO",
  },
  {
    zip: "80722",
    ST: "CO",
    cityWithStateAbbr: "Atwood, CO",
  },
  {
    zip: "80723",
    ST: "CO",
    cityWithStateAbbr: "Brush, CO",
  },
  {
    zip: "80726",
    ST: "CO",
    cityWithStateAbbr: "Crook, CO",
  },
  {
    zip: "80727",
    ST: "CO",
    cityWithStateAbbr: "Eckley, CO",
  },
  {
    zip: "80728",
    ST: "CO",
    cityWithStateAbbr: "Fleming, CO",
  },
  {
    zip: "80729",
    ST: "CO",
    cityWithStateAbbr: "Grover, CO",
  },
  {
    zip: "80731",
    ST: "CO",
    cityWithStateAbbr: "Haxtun, CO",
  },
  {
    zip: "80732",
    ST: "CO",
    cityWithStateAbbr: "Hereford, CO",
  },
  {
    zip: "80733",
    ST: "CO",
    cityWithStateAbbr: "Hillrose, CO",
  },
  {
    zip: "80734",
    ST: "CO",
    cityWithStateAbbr: "Holyoke, CO",
  },
  {
    zip: "80735",
    ST: "CO",
    cityWithStateAbbr: "Idalia, CO",
  },
  {
    zip: "80736",
    ST: "CO",
    cityWithStateAbbr: "Iliff, CO",
  },
  {
    zip: "80737",
    ST: "CO",
    cityWithStateAbbr: "Julesburg, CO",
  },
  {
    zip: "80740",
    ST: "CO",
    cityWithStateAbbr: "Lindon, CO",
  },
  {
    zip: "80741",
    ST: "CO",
    cityWithStateAbbr: "Merino, CO",
  },
  {
    zip: "80742",
    ST: "CO",
    cityWithStateAbbr: "New Raymer, CO",
  },
  {
    zip: "80743",
    ST: "CO",
    cityWithStateAbbr: "Otis, CO",
  },
  {
    zip: "80744",
    ST: "CO",
    cityWithStateAbbr: "Ovid, CO",
  },
  {
    zip: "80745",
    ST: "CO",
    cityWithStateAbbr: "Padroni, CO",
  },
  {
    zip: "80746",
    ST: "CO",
    cityWithStateAbbr: "Paoli, CO",
  },
  {
    zip: "80747",
    ST: "CO",
    cityWithStateAbbr: "Peetz, CO",
  },
  {
    zip: "80749",
    ST: "CO",
    cityWithStateAbbr: "Sedgwick, CO",
  },
  {
    zip: "80750",
    ST: "CO",
    cityWithStateAbbr: "Snyder, CO",
  },
  {
    zip: "80751",
    ST: "CO",
    cityWithStateAbbr: "Sterling, CO",
  },
  {
    zip: "80754",
    ST: "CO",
    cityWithStateAbbr: "Stoneham, CO",
  },
  {
    zip: "80755",
    ST: "CO",
    cityWithStateAbbr: "Vernon, CO",
  },
  {
    zip: "80757",
    ST: "CO",
    cityWithStateAbbr: "Woodrow, CO",
  },
  {
    zip: "80758",
    ST: "CO",
    cityWithStateAbbr: "Wray, CO",
  },
  {
    zip: "80759",
    ST: "CO",
    cityWithStateAbbr: "Yuma, CO",
  },
  {
    zip: "80801",
    ST: "CO",
    cityWithStateAbbr: "Anton, CO",
  },
  {
    zip: "80802",
    ST: "CO",
    cityWithStateAbbr: "Arapahoe, CO",
  },
  {
    zip: "80804",
    ST: "CO",
    cityWithStateAbbr: "Arriba, CO",
  },
  {
    zip: "80805",
    ST: "CO",
    cityWithStateAbbr: "Bethune, CO",
  },
  {
    zip: "80807",
    ST: "CO",
    cityWithStateAbbr: "Burlington, CO",
  },
  {
    zip: "80808",
    ST: "CO",
    cityWithStateAbbr: "Calhan, CO",
  },
  {
    zip: "80809",
    ST: "CO",
    cityWithStateAbbr: "Cascade, CO",
  },
  {
    zip: "80810",
    ST: "CO",
    cityWithStateAbbr: "Cheyenne Wells, CO",
  },
  {
    zip: "80812",
    ST: "CO",
    cityWithStateAbbr: "Cope, CO",
  },
  {
    zip: "80813",
    ST: "CO",
    cityWithStateAbbr: "Cripple Creek, CO",
  },
  {
    zip: "80814",
    ST: "CO",
    cityWithStateAbbr: "Divide, CO",
  },
  {
    zip: "80815",
    ST: "CO",
    cityWithStateAbbr: "Flagler, CO",
  },
  {
    zip: "80816",
    ST: "CO",
    cityWithStateAbbr: "Florissant, CO",
  },
  {
    zip: "80817",
    ST: "CO",
    cityWithStateAbbr: "Fountain, CO",
  },
  {
    zip: "80818",
    ST: "CO",
    cityWithStateAbbr: "Genoa, CO",
  },
  {
    zip: "80819",
    ST: "CO",
    cityWithStateAbbr: "Green Mountain Falls, CO",
  },
  {
    zip: "80820",
    ST: "CO",
    cityWithStateAbbr: "Guffey, CO",
  },
  {
    zip: "80821",
    ST: "CO",
    cityWithStateAbbr: "Hugo, CO",
  },
  {
    zip: "80822",
    ST: "CO",
    cityWithStateAbbr: "Joes, CO",
  },
  {
    zip: "80823",
    ST: "CO",
    cityWithStateAbbr: "Karval, CO",
  },
  {
    zip: "80824",
    ST: "CO",
    cityWithStateAbbr: "Kirk, CO",
  },
  {
    zip: "80825",
    ST: "CO",
    cityWithStateAbbr: "Kit Carson, CO",
  },
  {
    zip: "80826",
    ST: "CO",
    cityWithStateAbbr: "Limon, CO",
  },
  {
    zip: "80827",
    ST: "CO",
    cityWithStateAbbr: "Lake George, CO",
  },
  {
    zip: "80828",
    ST: "CO",
    cityWithStateAbbr: "Limon, CO",
  },
  {
    zip: "80829",
    ST: "CO",
    cityWithStateAbbr: "Manitou Springs, CO",
  },
  {
    zip: "80830",
    ST: "CO",
    cityWithStateAbbr: "Matheson, CO",
  },
  {
    zip: "80831",
    ST: "CO",
    cityWithStateAbbr: "Peyton, CO",
  },
  {
    zip: "80832",
    ST: "CO",
    cityWithStateAbbr: "Ramah, CO",
  },
  {
    zip: "80833",
    ST: "CO",
    cityWithStateAbbr: "Rush, CO",
  },
  {
    zip: "80834",
    ST: "CO",
    cityWithStateAbbr: "Seibert, CO",
  },
  {
    zip: "80835",
    ST: "CO",
    cityWithStateAbbr: "Simla, CO",
  },
  {
    zip: "80836",
    ST: "CO",
    cityWithStateAbbr: "Stratton, CO",
  },
  {
    zip: "80840",
    ST: "CO",
    cityWithStateAbbr: "Usaf Academy, CO",
  },
  {
    zip: "80841",
    ST: "CO",
    cityWithStateAbbr: "Usaf Academy, CO",
  },
  {
    zip: "80860",
    ST: "CO",
    cityWithStateAbbr: "Victor, CO",
  },
  {
    zip: "80861",
    ST: "CO",
    cityWithStateAbbr: "Vona, CO",
  },
  {
    zip: "80862",
    ST: "CO",
    cityWithStateAbbr: "Wild Horse, CO",
  },
  {
    zip: "80863",
    ST: "CO",
    cityWithStateAbbr: "Woodland Park, CO",
  },
  {
    zip: "80864",
    ST: "CO",
    cityWithStateAbbr: "Yoder, CO",
  },
  {
    zip: "80866",
    ST: "CO",
    cityWithStateAbbr: "Woodland Park, CO",
  },
  {
    zip: "80901",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80902",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80903",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80904",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80905",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80906",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80907",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80908",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80909",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80910",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80911",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80912",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80913",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80914",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80915",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80916",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80917",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80918",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80919",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80920",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80921",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80922",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80923",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80924",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80925",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80926",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80927",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80928",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80929",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80930",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80931",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80932",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80933",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80934",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80935",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80936",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80937",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80938",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80939",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80941",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80942",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80943",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80944",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80945",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80946",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80947",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80949",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80950",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80951",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80960",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80962",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80970",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80977",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80995",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "80997",
    ST: "CO",
    cityWithStateAbbr: "Colorado Springs, CO",
  },
  {
    zip: "81001",
    ST: "CO",
    cityWithStateAbbr: "Pueblo, CO",
  },
  {
    zip: "81002",
    ST: "CO",
    cityWithStateAbbr: "Pueblo, CO",
  },
  {
    zip: "81003",
    ST: "CO",
    cityWithStateAbbr: "Pueblo, CO",
  },
  {
    zip: "81004",
    ST: "CO",
    cityWithStateAbbr: "Pueblo, CO",
  },
  {
    zip: "81005",
    ST: "CO",
    cityWithStateAbbr: "Pueblo, CO",
  },
  {
    zip: "81006",
    ST: "CO",
    cityWithStateAbbr: "Pueblo, CO",
  },
  {
    zip: "81007",
    ST: "CO",
    cityWithStateAbbr: "Pueblo, CO",
  },
  {
    zip: "81008",
    ST: "CO",
    cityWithStateAbbr: "Pueblo, CO",
  },
  {
    zip: "81009",
    ST: "CO",
    cityWithStateAbbr: "Pueblo, CO",
  },
  {
    zip: "81010",
    ST: "CO",
    cityWithStateAbbr: "Pueblo, CO",
  },
  {
    zip: "81011",
    ST: "CO",
    cityWithStateAbbr: "Pueblo, CO",
  },
  {
    zip: "81012",
    ST: "CO",
    cityWithStateAbbr: "Pueblo, CO",
  },
  {
    zip: "81019",
    ST: "CO",
    cityWithStateAbbr: "Colorado City, CO",
  },
  {
    zip: "81020",
    ST: "CO",
    cityWithStateAbbr: "Aguilar, CO",
  },
  {
    zip: "81021",
    ST: "CO",
    cityWithStateAbbr: "Arlington, CO",
  },
  {
    zip: "81022",
    ST: "CO",
    cityWithStateAbbr: "Avondale, CO",
  },
  {
    zip: "81023",
    ST: "CO",
    cityWithStateAbbr: "Beulah, CO",
  },
  {
    zip: "81024",
    ST: "CO",
    cityWithStateAbbr: "Boncarbo, CO",
  },
  {
    zip: "81025",
    ST: "CO",
    cityWithStateAbbr: "Boone, CO",
  },
  {
    zip: "81027",
    ST: "CO",
    cityWithStateAbbr: "Branson, CO",
  },
  {
    zip: "81029",
    ST: "CO",
    cityWithStateAbbr: "Campo, CO",
  },
  {
    zip: "81030",
    ST: "CO",
    cityWithStateAbbr: "Cheraw, CO",
  },
  {
    zip: "81033",
    ST: "CO",
    cityWithStateAbbr: "Crowley, CO",
  },
  {
    zip: "81034",
    ST: "CO",
    cityWithStateAbbr: "Ordway, CO",
  },
  {
    zip: "81036",
    ST: "CO",
    cityWithStateAbbr: "Eads, CO",
  },
  {
    zip: "81038",
    ST: "CO",
    cityWithStateAbbr: "Fort Lyon, CO",
  },
  {
    zip: "81039",
    ST: "CO",
    cityWithStateAbbr: "Fowler, CO",
  },
  {
    zip: "81040",
    ST: "CO",
    cityWithStateAbbr: "Gardner, CO",
  },
  {
    zip: "81041",
    ST: "CO",
    cityWithStateAbbr: "Granada, CO",
  },
  {
    zip: "81043",
    ST: "CO",
    cityWithStateAbbr: "Hartman, CO",
  },
  {
    zip: "81044",
    ST: "CO",
    cityWithStateAbbr: "Hasty, CO",
  },
  {
    zip: "81045",
    ST: "CO",
    cityWithStateAbbr: "Haswell, CO",
  },
  {
    zip: "81046",
    ST: "CO",
    cityWithStateAbbr: "Hoehne, CO",
  },
  {
    zip: "81047",
    ST: "CO",
    cityWithStateAbbr: "Holly, CO",
  },
  {
    zip: "81049",
    ST: "CO",
    cityWithStateAbbr: "Kim, CO",
  },
  {
    zip: "81050",
    ST: "CO",
    cityWithStateAbbr: "La Junta, CO",
  },
  {
    zip: "81052",
    ST: "CO",
    cityWithStateAbbr: "Lamar, CO",
  },
  {
    zip: "81054",
    ST: "CO",
    cityWithStateAbbr: "Las Animas, CO",
  },
  {
    zip: "81055",
    ST: "CO",
    cityWithStateAbbr: "La Veta, CO",
  },
  {
    zip: "81057",
    ST: "CO",
    cityWithStateAbbr: "Mc Clave, CO",
  },
  {
    zip: "81058",
    ST: "CO",
    cityWithStateAbbr: "Manzanola, CO",
  },
  {
    zip: "81059",
    ST: "CO",
    cityWithStateAbbr: "Model, CO",
  },
  {
    zip: "81062",
    ST: "CO",
    cityWithStateAbbr: "Olney Springs, CO",
  },
  {
    zip: "81063",
    ST: "CO",
    cityWithStateAbbr: "Ordway, CO",
  },
  {
    zip: "81064",
    ST: "CO",
    cityWithStateAbbr: "Pritchett, CO",
  },
  {
    zip: "81067",
    ST: "CO",
    cityWithStateAbbr: "Rocky Ford, CO",
  },
  {
    zip: "81069",
    ST: "CO",
    cityWithStateAbbr: "Rye, CO",
  },
  {
    zip: "81071",
    ST: "CO",
    cityWithStateAbbr: "Sheridan Lake, CO",
  },
  {
    zip: "81073",
    ST: "CO",
    cityWithStateAbbr: "Springfield, CO",
  },
  {
    zip: "81076",
    ST: "CO",
    cityWithStateAbbr: "Sugar City, CO",
  },
  {
    zip: "81077",
    ST: "CO",
    cityWithStateAbbr: "Swink, CO",
  },
  {
    zip: "81081",
    ST: "CO",
    cityWithStateAbbr: "Trinchera, CO",
  },
  {
    zip: "81082",
    ST: "CO",
    cityWithStateAbbr: "Trinidad, CO",
  },
  {
    zip: "81084",
    ST: "CO",
    cityWithStateAbbr: "Two Buttes, CO",
  },
  {
    zip: "81087",
    ST: "CO",
    cityWithStateAbbr: "Vilas, CO",
  },
  {
    zip: "81089",
    ST: "CO",
    cityWithStateAbbr: "Walsenburg, CO",
  },
  {
    zip: "81090",
    ST: "CO",
    cityWithStateAbbr: "Walsh, CO",
  },
  {
    zip: "81091",
    ST: "CO",
    cityWithStateAbbr: "Weston, CO",
  },
  {
    zip: "81092",
    ST: "CO",
    cityWithStateAbbr: "Wiley, CO",
  },
  {
    zip: "81101",
    ST: "CO",
    cityWithStateAbbr: "Alamosa, CO",
  },
  {
    zip: "81102",
    ST: "CO",
    cityWithStateAbbr: "Alamosa, CO",
  },
  {
    zip: "81120",
    ST: "CO",
    cityWithStateAbbr: "Antonito, CO",
  },
  {
    zip: "81121",
    ST: "CO",
    cityWithStateAbbr: "Arboles, CO",
  },
  {
    zip: "81122",
    ST: "CO",
    cityWithStateAbbr: "Bayfield, CO",
  },
  {
    zip: "81123",
    ST: "CO",
    cityWithStateAbbr: "Blanca, CO",
  },
  {
    zip: "81124",
    ST: "CO",
    cityWithStateAbbr: "Capulin, CO",
  },
  {
    zip: "81125",
    ST: "CO",
    cityWithStateAbbr: "Center, CO",
  },
  {
    zip: "81126",
    ST: "CO",
    cityWithStateAbbr: "Chama, CO",
  },
  {
    zip: "81128",
    ST: "CO",
    cityWithStateAbbr: "Chromo, CO",
  },
  {
    zip: "81129",
    ST: "CO",
    cityWithStateAbbr: "Conejos, CO",
  },
  {
    zip: "81130",
    ST: "CO",
    cityWithStateAbbr: "Creede, CO",
  },
  {
    zip: "81131",
    ST: "CO",
    cityWithStateAbbr: "Crestone, CO",
  },
  {
    zip: "81132",
    ST: "CO",
    cityWithStateAbbr: "Del Norte, CO",
  },
  {
    zip: "81133",
    ST: "CO",
    cityWithStateAbbr: "Fort Garland, CO",
  },
  {
    zip: "81134",
    ST: "CO",
    cityWithStateAbbr: "Garcia, CO",
  },
  {
    zip: "81135",
    ST: "CO",
    cityWithStateAbbr: "Homelake, CO",
  },
  {
    zip: "81136",
    ST: "CO",
    cityWithStateAbbr: "Hooper, CO",
  },
  {
    zip: "81137",
    ST: "CO",
    cityWithStateAbbr: "Ignacio, CO",
  },
  {
    zip: "81138",
    ST: "CO",
    cityWithStateAbbr: "Jaroso, CO",
  },
  {
    zip: "81140",
    ST: "CO",
    cityWithStateAbbr: "La Jara, CO",
  },
  {
    zip: "81141",
    ST: "CO",
    cityWithStateAbbr: "Manassa, CO",
  },
  {
    zip: "81143",
    ST: "CO",
    cityWithStateAbbr: "Moffat, CO",
  },
  {
    zip: "81144",
    ST: "CO",
    cityWithStateAbbr: "Monte Vista, CO",
  },
  {
    zip: "81146",
    ST: "CO",
    cityWithStateAbbr: "Mosca, CO",
  },
  {
    zip: "81147",
    ST: "CO",
    cityWithStateAbbr: "Pagosa Springs, CO",
  },
  {
    zip: "81148",
    ST: "CO",
    cityWithStateAbbr: "Romeo, CO",
  },
  {
    zip: "81149",
    ST: "CO",
    cityWithStateAbbr: "Saguache, CO",
  },
  {
    zip: "81151",
    ST: "CO",
    cityWithStateAbbr: "Sanford, CO",
  },
  {
    zip: "81152",
    ST: "CO",
    cityWithStateAbbr: "San Luis, CO",
  },
  {
    zip: "81153",
    ST: "CO",
    cityWithStateAbbr: "San Pablo, CO",
  },
  {
    zip: "81154",
    ST: "CO",
    cityWithStateAbbr: "South Fork, CO",
  },
  {
    zip: "81155",
    ST: "CO",
    cityWithStateAbbr: "Villa Grove, CO",
  },
  {
    zip: "81157",
    ST: "CO",
    cityWithStateAbbr: "Pagosa Springs, CO",
  },
  {
    zip: "81201",
    ST: "CO",
    cityWithStateAbbr: "Salida, CO",
  },
  {
    zip: "81210",
    ST: "CO",
    cityWithStateAbbr: "Almont, CO",
  },
  {
    zip: "81211",
    ST: "CO",
    cityWithStateAbbr: "Buena Vista, CO",
  },
  {
    zip: "81212",
    ST: "CO",
    cityWithStateAbbr: "Canon City, CO",
  },
  {
    zip: "81215",
    ST: "CO",
    cityWithStateAbbr: "Canon City, CO",
  },
  {
    zip: "81220",
    ST: "CO",
    cityWithStateAbbr: "Cimarron, CO",
  },
  {
    zip: "81221",
    ST: "CO",
    cityWithStateAbbr: "Coal Creek, CO",
  },
  {
    zip: "81222",
    ST: "CO",
    cityWithStateAbbr: "Coaldale, CO",
  },
  {
    zip: "81223",
    ST: "CO",
    cityWithStateAbbr: "Cotopaxi, CO",
  },
  {
    zip: "81224",
    ST: "CO",
    cityWithStateAbbr: "Crested Butte, CO",
  },
  {
    zip: "81225",
    ST: "CO",
    cityWithStateAbbr: "Crested Butte, CO",
  },
  {
    zip: "81226",
    ST: "CO",
    cityWithStateAbbr: "Florence, CO",
  },
  {
    zip: "81227",
    ST: "CO",
    cityWithStateAbbr: "Monarch, CO",
  },
  {
    zip: "81228",
    ST: "CO",
    cityWithStateAbbr: "Granite, CO",
  },
  {
    zip: "81230",
    ST: "CO",
    cityWithStateAbbr: "Gunnison, CO",
  },
  {
    zip: "81231",
    ST: "CO",
    cityWithStateAbbr: "Gunnison, CO",
  },
  {
    zip: "81232",
    ST: "CO",
    cityWithStateAbbr: "Hillside, CO",
  },
  {
    zip: "81233",
    ST: "CO",
    cityWithStateAbbr: "Howard, CO",
  },
  {
    zip: "81235",
    ST: "CO",
    cityWithStateAbbr: "Lake City, CO",
  },
  {
    zip: "81236",
    ST: "CO",
    cityWithStateAbbr: "Nathrop, CO",
  },
  {
    zip: "81237",
    ST: "CO",
    cityWithStateAbbr: "Ohio City, CO",
  },
  {
    zip: "81239",
    ST: "CO",
    cityWithStateAbbr: "Parlin, CO",
  },
  {
    zip: "81240",
    ST: "CO",
    cityWithStateAbbr: "Penrose, CO",
  },
  {
    zip: "81241",
    ST: "CO",
    cityWithStateAbbr: "Pitkin, CO",
  },
  {
    zip: "81242",
    ST: "CO",
    cityWithStateAbbr: "Poncha Springs, CO",
  },
  {
    zip: "81243",
    ST: "CO",
    cityWithStateAbbr: "Powderhorn, CO",
  },
  {
    zip: "81244",
    ST: "CO",
    cityWithStateAbbr: "Rockvale, CO",
  },
  {
    zip: "81247",
    ST: "CO",
    cityWithStateAbbr: "Gunnison, CO",
  },
  {
    zip: "81248",
    ST: "CO",
    cityWithStateAbbr: "Sargents, CO",
  },
  {
    zip: "81251",
    ST: "CO",
    cityWithStateAbbr: "Twin Lakes, CO",
  },
  {
    zip: "81252",
    ST: "CO",
    cityWithStateAbbr: "Westcliffe, CO",
  },
  {
    zip: "81253",
    ST: "CO",
    cityWithStateAbbr: "Wetmore, CO",
  },
  {
    zip: "81290",
    ST: "CO",
    cityWithStateAbbr: "Florence, CO",
  },
  {
    zip: "81301",
    ST: "CO",
    cityWithStateAbbr: "Durango, CO",
  },
  {
    zip: "81302",
    ST: "CO",
    cityWithStateAbbr: "Durango, CO",
  },
  {
    zip: "81303",
    ST: "CO",
    cityWithStateAbbr: "Durango, CO",
  },
  {
    zip: "81320",
    ST: "CO",
    cityWithStateAbbr: "Cahone, CO",
  },
  {
    zip: "81321",
    ST: "CO",
    cityWithStateAbbr: "Cortez, CO",
  },
  {
    zip: "81323",
    ST: "CO",
    cityWithStateAbbr: "Dolores, CO",
  },
  {
    zip: "81324",
    ST: "CO",
    cityWithStateAbbr: "Dove Creek, CO",
  },
  {
    zip: "81325",
    ST: "CO",
    cityWithStateAbbr: "Egnar, CO",
  },
  {
    zip: "81326",
    ST: "CO",
    cityWithStateAbbr: "Hesperus, CO",
  },
  {
    zip: "81327",
    ST: "CO",
    cityWithStateAbbr: "Lewis, CO",
  },
  {
    zip: "81328",
    ST: "CO",
    cityWithStateAbbr: "Mancos, CO",
  },
  {
    zip: "81329",
    ST: "CO",
    cityWithStateAbbr: "Marvel, CO",
  },
  {
    zip: "81330",
    ST: "CO",
    cityWithStateAbbr: "Mesa Verde National Park, CO",
  },
  {
    zip: "81331",
    ST: "CO",
    cityWithStateAbbr: "Pleasant View, CO",
  },
  {
    zip: "81332",
    ST: "CO",
    cityWithStateAbbr: "Rico, CO",
  },
  {
    zip: "81334",
    ST: "CO",
    cityWithStateAbbr: "Towaoc, CO",
  },
  {
    zip: "81335",
    ST: "CO",
    cityWithStateAbbr: "Yellow Jacket, CO",
  },
  {
    zip: "81401",
    ST: "CO",
    cityWithStateAbbr: "Montrose, CO",
  },
  {
    zip: "81402",
    ST: "CO",
    cityWithStateAbbr: "Montrose, CO",
  },
  {
    zip: "81403",
    ST: "CO",
    cityWithStateAbbr: "Montrose, CO",
  },
  {
    zip: "81410",
    ST: "CO",
    cityWithStateAbbr: "Austin, CO",
  },
  {
    zip: "81411",
    ST: "CO",
    cityWithStateAbbr: "Bedrock, CO",
  },
  {
    zip: "81413",
    ST: "CO",
    cityWithStateAbbr: "Cedaredge, CO",
  },
  {
    zip: "81414",
    ST: "CO",
    cityWithStateAbbr: "Cory, CO",
  },
  {
    zip: "81415",
    ST: "CO",
    cityWithStateAbbr: "Crawford, CO",
  },
  {
    zip: "81416",
    ST: "CO",
    cityWithStateAbbr: "Delta, CO",
  },
  {
    zip: "81418",
    ST: "CO",
    cityWithStateAbbr: "Eckert, CO",
  },
  {
    zip: "81419",
    ST: "CO",
    cityWithStateAbbr: "Hotchkiss, CO",
  },
  {
    zip: "81420",
    ST: "CO",
    cityWithStateAbbr: "Lazear, CO",
  },
  {
    zip: "81422",
    ST: "CO",
    cityWithStateAbbr: "Naturita, CO",
  },
  {
    zip: "81423",
    ST: "CO",
    cityWithStateAbbr: "Norwood, CO",
  },
  {
    zip: "81424",
    ST: "CO",
    cityWithStateAbbr: "Nucla, CO",
  },
  {
    zip: "81425",
    ST: "CO",
    cityWithStateAbbr: "Olathe, CO",
  },
  {
    zip: "81426",
    ST: "CO",
    cityWithStateAbbr: "Ophir, CO",
  },
  {
    zip: "81427",
    ST: "CO",
    cityWithStateAbbr: "Ouray, CO",
  },
  {
    zip: "81428",
    ST: "CO",
    cityWithStateAbbr: "Paonia, CO",
  },
  {
    zip: "81429",
    ST: "CO",
    cityWithStateAbbr: "Paradox, CO",
  },
  {
    zip: "81430",
    ST: "CO",
    cityWithStateAbbr: "Placerville, CO",
  },
  {
    zip: "81431",
    ST: "CO",
    cityWithStateAbbr: "Redvale, CO",
  },
  {
    zip: "81432",
    ST: "CO",
    cityWithStateAbbr: "Ridgway, CO",
  },
  {
    zip: "81433",
    ST: "CO",
    cityWithStateAbbr: "Silverton, CO",
  },
  {
    zip: "81434",
    ST: "CO",
    cityWithStateAbbr: "Somerset, CO",
  },
  {
    zip: "81435",
    ST: "CO",
    cityWithStateAbbr: "Telluride, CO",
  },
  {
    zip: "81501",
    ST: "CO",
    cityWithStateAbbr: "Grand Junction, CO",
  },
  {
    zip: "81502",
    ST: "CO",
    cityWithStateAbbr: "Grand Junction, CO",
  },
  {
    zip: "81503",
    ST: "CO",
    cityWithStateAbbr: "Grand Junction, CO",
  },
  {
    zip: "81504",
    ST: "CO",
    cityWithStateAbbr: "Grand Junction, CO",
  },
  {
    zip: "81505",
    ST: "CO",
    cityWithStateAbbr: "Grand Junction, CO",
  },
  {
    zip: "81506",
    ST: "CO",
    cityWithStateAbbr: "Grand Junction, CO",
  },
  {
    zip: "81507",
    ST: "CO",
    cityWithStateAbbr: "Grand Junction, CO",
  },
  {
    zip: "81520",
    ST: "CO",
    cityWithStateAbbr: "Clifton, CO",
  },
  {
    zip: "81521",
    ST: "CO",
    cityWithStateAbbr: "Fruita, CO",
  },
  {
    zip: "81522",
    ST: "CO",
    cityWithStateAbbr: "Gateway, CO",
  },
  {
    zip: "81523",
    ST: "CO",
    cityWithStateAbbr: "Glade Park, CO",
  },
  {
    zip: "81524",
    ST: "CO",
    cityWithStateAbbr: "Loma, CO",
  },
  {
    zip: "81525",
    ST: "CO",
    cityWithStateAbbr: "Mack, CO",
  },
  {
    zip: "81526",
    ST: "CO",
    cityWithStateAbbr: "Palisade, CO",
  },
  {
    zip: "81527",
    ST: "CO",
    cityWithStateAbbr: "Whitewater, CO",
  },
  {
    zip: "81601",
    ST: "CO",
    cityWithStateAbbr: "Glenwood Springs, CO",
  },
  {
    zip: "81602",
    ST: "CO",
    cityWithStateAbbr: "Glenwood Springs, CO",
  },
  {
    zip: "81610",
    ST: "CO",
    cityWithStateAbbr: "Dinosaur, CO",
  },
  {
    zip: "81611",
    ST: "CO",
    cityWithStateAbbr: "Aspen, CO",
  },
  {
    zip: "81612",
    ST: "CO",
    cityWithStateAbbr: "Aspen, CO",
  },
  {
    zip: "81615",
    ST: "CO",
    cityWithStateAbbr: "Snowmass Village, CO",
  },
  {
    zip: "81620",
    ST: "CO",
    cityWithStateAbbr: "Avon, CO",
  },
  {
    zip: "81621",
    ST: "CO",
    cityWithStateAbbr: "Basalt, CO",
  },
  {
    zip: "81623",
    ST: "CO",
    cityWithStateAbbr: "Carbondale, CO",
  },
  {
    zip: "81624",
    ST: "CO",
    cityWithStateAbbr: "Collbran, CO",
  },
  {
    zip: "81625",
    ST: "CO",
    cityWithStateAbbr: "Craig, CO",
  },
  {
    zip: "81626",
    ST: "CO",
    cityWithStateAbbr: "Craig, CO",
  },
  {
    zip: "81630",
    ST: "CO",
    cityWithStateAbbr: "De Beque, CO",
  },
  {
    zip: "81631",
    ST: "CO",
    cityWithStateAbbr: "Eagle, CO",
  },
  {
    zip: "81632",
    ST: "CO",
    cityWithStateAbbr: "Edwards, CO",
  },
  {
    zip: "81633",
    ST: "CO",
    cityWithStateAbbr: "Dinosaur, CO",
  },
  {
    zip: "81635",
    ST: "CO",
    cityWithStateAbbr: "Parachute, CO",
  },
  {
    zip: "81636",
    ST: "CO",
    cityWithStateAbbr: "Battlement Mesa, CO",
  },
  {
    zip: "81637",
    ST: "CO",
    cityWithStateAbbr: "Gypsum, CO",
  },
  {
    zip: "81638",
    ST: "CO",
    cityWithStateAbbr: "Hamilton, CO",
  },
  {
    zip: "81639",
    ST: "CO",
    cityWithStateAbbr: "Hayden, CO",
  },
  {
    zip: "81640",
    ST: "CO",
    cityWithStateAbbr: "Maybell, CO",
  },
  {
    zip: "81641",
    ST: "CO",
    cityWithStateAbbr: "Meeker, CO",
  },
  {
    zip: "81642",
    ST: "CO",
    cityWithStateAbbr: "Meredith, CO",
  },
  {
    zip: "81643",
    ST: "CO",
    cityWithStateAbbr: "Mesa, CO",
  },
  {
    zip: "81645",
    ST: "CO",
    cityWithStateAbbr: "Minturn, CO",
  },
  {
    zip: "81646",
    ST: "CO",
    cityWithStateAbbr: "Molina, CO",
  },
  {
    zip: "81647",
    ST: "CO",
    cityWithStateAbbr: "New Castle, CO",
  },
  {
    zip: "81648",
    ST: "CO",
    cityWithStateAbbr: "Rangely, CO",
  },
  {
    zip: "81649",
    ST: "CO",
    cityWithStateAbbr: "Red Cliff, CO",
  },
  {
    zip: "81650",
    ST: "CO",
    cityWithStateAbbr: "Rifle, CO",
  },
  {
    zip: "81652",
    ST: "CO",
    cityWithStateAbbr: "Silt, CO",
  },
  {
    zip: "81653",
    ST: "CO",
    cityWithStateAbbr: "Slater, CO",
  },
  {
    zip: "81654",
    ST: "CO",
    cityWithStateAbbr: "Snowmass, CO",
  },
  {
    zip: "81655",
    ST: "CO",
    cityWithStateAbbr: "Wolcott, CO",
  },
  {
    zip: "81656",
    ST: "CO",
    cityWithStateAbbr: "Woody Creek, CO",
  },
  {
    zip: "81657",
    ST: "CO",
    cityWithStateAbbr: "Vail, CO",
  },
  {
    zip: "81658",
    ST: "CO",
    cityWithStateAbbr: "Vail, CO",
  },
  {
    zip: "82001",
    ST: "WY",
    cityWithStateAbbr: "Cheyenne, WY",
  },
  {
    zip: "82002",
    ST: "WY",
    cityWithStateAbbr: "Cheyenne, WY",
  },
  {
    zip: "82003",
    ST: "WY",
    cityWithStateAbbr: "Cheyenne, WY",
  },
  {
    zip: "82005",
    ST: "WY",
    cityWithStateAbbr: "Fe Warren Afb, WY",
  },
  {
    zip: "82006",
    ST: "WY",
    cityWithStateAbbr: "Cheyenne, WY",
  },
  {
    zip: "82007",
    ST: "WY",
    cityWithStateAbbr: "Cheyenne, WY",
  },
  {
    zip: "82008",
    ST: "WY",
    cityWithStateAbbr: "Cheyenne, WY",
  },
  {
    zip: "82009",
    ST: "WY",
    cityWithStateAbbr: "Cheyenne, WY",
  },
  {
    zip: "82010",
    ST: "WY",
    cityWithStateAbbr: "Cheyenne, WY",
  },
  {
    zip: "82050",
    ST: "WY",
    cityWithStateAbbr: "Albin, WY",
  },
  {
    zip: "82051",
    ST: "WY",
    cityWithStateAbbr: "Bosler, WY",
  },
  {
    zip: "82052",
    ST: "WY",
    cityWithStateAbbr: "Buford, WY",
  },
  {
    zip: "82053",
    ST: "WY",
    cityWithStateAbbr: "Burns, WY",
  },
  {
    zip: "82054",
    ST: "WY",
    cityWithStateAbbr: "Carpenter, WY",
  },
  {
    zip: "82055",
    ST: "WY",
    cityWithStateAbbr: "Centennial, WY",
  },
  {
    zip: "82058",
    ST: "WY",
    cityWithStateAbbr: "Garrett, WY",
  },
  {
    zip: "82059",
    ST: "WY",
    cityWithStateAbbr: "Granite Canon, WY",
  },
  {
    zip: "82060",
    ST: "WY",
    cityWithStateAbbr: "Hillsdale, WY",
  },
  {
    zip: "82061",
    ST: "WY",
    cityWithStateAbbr: "Horse Creek, WY",
  },
  {
    zip: "82063",
    ST: "CO",
    cityWithStateAbbr: "Jelm, CO",
  },
  {
    zip: "82070",
    ST: "WY",
    cityWithStateAbbr: "Laramie, WY",
  },
  {
    zip: "82071",
    ST: "WY",
    cityWithStateAbbr: "Laramie, WY",
  },
  {
    zip: "82072",
    ST: "WY",
    cityWithStateAbbr: "Laramie, WY",
  },
  {
    zip: "82073",
    ST: "WY",
    cityWithStateAbbr: "Laramie, WY",
  },
  {
    zip: "82081",
    ST: "WY",
    cityWithStateAbbr: "Meriden, WY",
  },
  {
    zip: "82082",
    ST: "WY",
    cityWithStateAbbr: "Pine Bluffs, WY",
  },
  {
    zip: "82083",
    ST: "WY",
    cityWithStateAbbr: "Rock River, WY",
  },
  {
    zip: "82084",
    ST: "WY",
    cityWithStateAbbr: "Tie Siding, WY",
  },
  {
    zip: "82190",
    ST: "WY",
    cityWithStateAbbr: "Yellowstone National Par, WY",
  },
  {
    zip: "82201",
    ST: "WY",
    cityWithStateAbbr: "Wheatland, WY",
  },
  {
    zip: "82210",
    ST: "WY",
    cityWithStateAbbr: "Chugwater, WY",
  },
  {
    zip: "82212",
    ST: "WY",
    cityWithStateAbbr: "Fort Laramie, WY",
  },
  {
    zip: "82213",
    ST: "WY",
    cityWithStateAbbr: "Glendo, WY",
  },
  {
    zip: "82214",
    ST: "WY",
    cityWithStateAbbr: "Guernsey, WY",
  },
  {
    zip: "82215",
    ST: "WY",
    cityWithStateAbbr: "Hartville, WY",
  },
  {
    zip: "82217",
    ST: "WY",
    cityWithStateAbbr: "Hawk Springs, WY",
  },
  {
    zip: "82218",
    ST: "WY",
    cityWithStateAbbr: "Huntley, WY",
  },
  {
    zip: "82219",
    ST: "WY",
    cityWithStateAbbr: "Jay Em, WY",
  },
  {
    zip: "82221",
    ST: "WY",
    cityWithStateAbbr: "Lagrange, WY",
  },
  {
    zip: "82222",
    ST: "WY",
    cityWithStateAbbr: "Lance Creek, WY",
  },
  {
    zip: "82223",
    ST: "WY",
    cityWithStateAbbr: "Lingle, WY",
  },
  {
    zip: "82224",
    ST: "WY",
    cityWithStateAbbr: "Lost Springs, WY",
  },
  {
    zip: "82225",
    ST: "WY",
    cityWithStateAbbr: "Lusk, WY",
  },
  {
    zip: "82227",
    ST: "WY",
    cityWithStateAbbr: "Manville, WY",
  },
  {
    zip: "82229",
    ST: "WY",
    cityWithStateAbbr: "Shawnee, WY",
  },
  {
    zip: "82240",
    ST: "WY",
    cityWithStateAbbr: "Torrington, WY",
  },
  {
    zip: "82242",
    ST: "WY",
    cityWithStateAbbr: "Van Tassell, WY",
  },
  {
    zip: "82243",
    ST: "WY",
    cityWithStateAbbr: "Veteran, WY",
  },
  {
    zip: "82244",
    ST: "WY",
    cityWithStateAbbr: "Yoder, WY",
  },
  {
    zip: "82301",
    ST: "WY",
    cityWithStateAbbr: "Rawlins, WY",
  },
  {
    zip: "82310",
    ST: "WY",
    cityWithStateAbbr: "Jeffrey City, WY",
  },
  {
    zip: "82321",
    ST: "WY",
    cityWithStateAbbr: "Baggs, WY",
  },
  {
    zip: "82322",
    ST: "WY",
    cityWithStateAbbr: "Bairoil, WY",
  },
  {
    zip: "82323",
    ST: "WY",
    cityWithStateAbbr: "Dixon, WY",
  },
  {
    zip: "82324",
    ST: "WY",
    cityWithStateAbbr: "Elk Mountain, WY",
  },
  {
    zip: "82325",
    ST: "WY",
    cityWithStateAbbr: "Encampment, WY",
  },
  {
    zip: "82327",
    ST: "WY",
    cityWithStateAbbr: "Hanna, WY",
  },
  {
    zip: "82329",
    ST: "WY",
    cityWithStateAbbr: "Medicine Bow, WY",
  },
  {
    zip: "82331",
    ST: "WY",
    cityWithStateAbbr: "Saratoga, WY",
  },
  {
    zip: "82332",
    ST: "WY",
    cityWithStateAbbr: "Savery, WY",
  },
  {
    zip: "82334",
    ST: "WY",
    cityWithStateAbbr: "Sinclair, WY",
  },
  {
    zip: "82335",
    ST: "WY",
    cityWithStateAbbr: "Walcott, WY",
  },
  {
    zip: "82336",
    ST: "WY",
    cityWithStateAbbr: "Wamsutter, WY",
  },
  {
    zip: "82401",
    ST: "WY",
    cityWithStateAbbr: "Worland, WY",
  },
  {
    zip: "82410",
    ST: "WY",
    cityWithStateAbbr: "Basin, WY",
  },
  {
    zip: "82411",
    ST: "WY",
    cityWithStateAbbr: "Burlington, WY",
  },
  {
    zip: "82412",
    ST: "WY",
    cityWithStateAbbr: "Byron, WY",
  },
  {
    zip: "82414",
    ST: "WY",
    cityWithStateAbbr: "Cody, WY",
  },
  {
    zip: "82420",
    ST: "WY",
    cityWithStateAbbr: "Cowley, WY",
  },
  {
    zip: "82421",
    ST: "WY",
    cityWithStateAbbr: "Deaver, WY",
  },
  {
    zip: "82422",
    ST: "WY",
    cityWithStateAbbr: "Emblem, WY",
  },
  {
    zip: "82423",
    ST: "WY",
    cityWithStateAbbr: "Frannie, WY",
  },
  {
    zip: "82426",
    ST: "WY",
    cityWithStateAbbr: "Greybull, WY",
  },
  {
    zip: "82428",
    ST: "WY",
    cityWithStateAbbr: "Hyattville, WY",
  },
  {
    zip: "82430",
    ST: "WY",
    cityWithStateAbbr: "Kirby, WY",
  },
  {
    zip: "82431",
    ST: "WY",
    cityWithStateAbbr: "Lovell, WY",
  },
  {
    zip: "82432",
    ST: "WY",
    cityWithStateAbbr: "Manderson, WY",
  },
  {
    zip: "82433",
    ST: "WY",
    cityWithStateAbbr: "Meeteetse, WY",
  },
  {
    zip: "82434",
    ST: "WY",
    cityWithStateAbbr: "Otto, WY",
  },
  {
    zip: "82435",
    ST: "WY",
    cityWithStateAbbr: "Powell, WY",
  },
  {
    zip: "82440",
    ST: "WY",
    cityWithStateAbbr: "Ralston, WY",
  },
  {
    zip: "82441",
    ST: "WY",
    cityWithStateAbbr: "Shell, WY",
  },
  {
    zip: "82442",
    ST: "WY",
    cityWithStateAbbr: "Ten Sleep, WY",
  },
  {
    zip: "82443",
    ST: "WY",
    cityWithStateAbbr: "Thermopolis, WY",
  },
  {
    zip: "82450",
    ST: "WY",
    cityWithStateAbbr: "Wapiti, WY",
  },
  {
    zip: "82501",
    ST: "WY",
    cityWithStateAbbr: "Riverton, WY",
  },
  {
    zip: "82510",
    ST: "WY",
    cityWithStateAbbr: "Arapahoe, WY",
  },
  {
    zip: "82512",
    ST: "WY",
    cityWithStateAbbr: "Crowheart, WY",
  },
  {
    zip: "82513",
    ST: "WY",
    cityWithStateAbbr: "Dubois, WY",
  },
  {
    zip: "82514",
    ST: "WY",
    cityWithStateAbbr: "Fort Washakie, WY",
  },
  {
    zip: "82515",
    ST: "WY",
    cityWithStateAbbr: "Hudson, WY",
  },
  {
    zip: "82516",
    ST: "WY",
    cityWithStateAbbr: "Kinnear, WY",
  },
  {
    zip: "82520",
    ST: "WY",
    cityWithStateAbbr: "Lander, WY",
  },
  {
    zip: "82523",
    ST: "WY",
    cityWithStateAbbr: "Pavillion, WY",
  },
  {
    zip: "82524",
    ST: "WY",
    cityWithStateAbbr: "Saint Stephens, WY",
  },
  {
    zip: "82601",
    ST: "WY",
    cityWithStateAbbr: "Casper, WY",
  },
  {
    zip: "82602",
    ST: "WY",
    cityWithStateAbbr: "Casper, WY",
  },
  {
    zip: "82604",
    ST: "WY",
    cityWithStateAbbr: "Casper, WY",
  },
  {
    zip: "82605",
    ST: "WY",
    cityWithStateAbbr: "Casper, WY",
  },
  {
    zip: "82609",
    ST: "WY",
    cityWithStateAbbr: "Casper, WY",
  },
  {
    zip: "82615",
    ST: "WY",
    cityWithStateAbbr: "Shirley Basin, WY",
  },
  {
    zip: "82620",
    ST: "WY",
    cityWithStateAbbr: "Alcova, WY",
  },
  {
    zip: "82630",
    ST: "WY",
    cityWithStateAbbr: "Arminto, WY",
  },
  {
    zip: "82633",
    ST: "WY",
    cityWithStateAbbr: "Douglas, WY",
  },
  {
    zip: "82635",
    ST: "WY",
    cityWithStateAbbr: "Edgerton, WY",
  },
  {
    zip: "82636",
    ST: "WY",
    cityWithStateAbbr: "Evansville, WY",
  },
  {
    zip: "82637",
    ST: "WY",
    cityWithStateAbbr: "Glenrock, WY",
  },
  {
    zip: "82638",
    ST: "WY",
    cityWithStateAbbr: "Hiland, WY",
  },
  {
    zip: "82639",
    ST: "WY",
    cityWithStateAbbr: "Kaycee, WY",
  },
  {
    zip: "82640",
    ST: "WY",
    cityWithStateAbbr: "Linch, WY",
  },
  {
    zip: "82642",
    ST: "WY",
    cityWithStateAbbr: "Lysite, WY",
  },
  {
    zip: "82643",
    ST: "WY",
    cityWithStateAbbr: "Midwest, WY",
  },
  {
    zip: "82644",
    ST: "WY",
    cityWithStateAbbr: "Mills, WY",
  },
  {
    zip: "82646",
    ST: "WY",
    cityWithStateAbbr: "Natrona, WY",
  },
  {
    zip: "82648",
    ST: "WY",
    cityWithStateAbbr: "Powder River, WY",
  },
  {
    zip: "82649",
    ST: "WY",
    cityWithStateAbbr: "Shoshoni, WY",
  },
  {
    zip: "82701",
    ST: "WY",
    cityWithStateAbbr: "Newcastle, WY",
  },
  {
    zip: "82710",
    ST: "WY",
    cityWithStateAbbr: "Aladdin, WY",
  },
  {
    zip: "82711",
    ST: "WY",
    cityWithStateAbbr: "Alva, WY",
  },
  {
    zip: "82712",
    ST: "WY",
    cityWithStateAbbr: "Beulah, WY",
  },
  {
    zip: "82714",
    ST: "WY",
    cityWithStateAbbr: "Devils Tower, WY",
  },
  {
    zip: "82715",
    ST: "WY",
    cityWithStateAbbr: "Four Corners, WY",
  },
  {
    zip: "82716",
    ST: "WY",
    cityWithStateAbbr: "Gillette, WY",
  },
  {
    zip: "82717",
    ST: "WY",
    cityWithStateAbbr: "Gillette, WY",
  },
  {
    zip: "82718",
    ST: "WY",
    cityWithStateAbbr: "Gillette, WY",
  },
  {
    zip: "82720",
    ST: "WY",
    cityWithStateAbbr: "Hulett, WY",
  },
  {
    zip: "82721",
    ST: "WY",
    cityWithStateAbbr: "Moorcroft, WY",
  },
  {
    zip: "82723",
    ST: "WY",
    cityWithStateAbbr: "Osage, WY",
  },
  {
    zip: "82725",
    ST: "WY",
    cityWithStateAbbr: "Recluse, WY",
  },
  {
    zip: "82727",
    ST: "WY",
    cityWithStateAbbr: "Rozet, WY",
  },
  {
    zip: "82729",
    ST: "WY",
    cityWithStateAbbr: "Sundance, WY",
  },
  {
    zip: "82730",
    ST: "WY",
    cityWithStateAbbr: "Upton, WY",
  },
  {
    zip: "82731",
    ST: "WY",
    cityWithStateAbbr: "Weston, WY",
  },
  {
    zip: "82732",
    ST: "WY",
    cityWithStateAbbr: "Wright, WY",
  },
  {
    zip: "82801",
    ST: "WY",
    cityWithStateAbbr: "Sheridan, WY",
  },
  {
    zip: "82831",
    ST: "WY",
    cityWithStateAbbr: "Arvada, WY",
  },
  {
    zip: "82832",
    ST: "WY",
    cityWithStateAbbr: "Banner, WY",
  },
  {
    zip: "82833",
    ST: "WY",
    cityWithStateAbbr: "Big Horn, WY",
  },
  {
    zip: "82834",
    ST: "WY",
    cityWithStateAbbr: "Buffalo, WY",
  },
  {
    zip: "82835",
    ST: "WY",
    cityWithStateAbbr: "Clearmont, WY",
  },
  {
    zip: "82836",
    ST: "WY",
    cityWithStateAbbr: "Dayton, WY",
  },
  {
    zip: "82837",
    ST: "WY",
    cityWithStateAbbr: "Leiter, WY",
  },
  {
    zip: "82838",
    ST: "WY",
    cityWithStateAbbr: "Parkman, WY",
  },
  {
    zip: "82839",
    ST: "WY",
    cityWithStateAbbr: "Ranchester, WY",
  },
  {
    zip: "82840",
    ST: "WY",
    cityWithStateAbbr: "Saddlestring, WY",
  },
  {
    zip: "82842",
    ST: "WY",
    cityWithStateAbbr: "Story, WY",
  },
  {
    zip: "82844",
    ST: "WY",
    cityWithStateAbbr: "Wolf, WY",
  },
  {
    zip: "82845",
    ST: "WY",
    cityWithStateAbbr: "Wyarno, WY",
  },
  {
    zip: "82901",
    ST: "WY",
    cityWithStateAbbr: "Rock Springs, WY",
  },
  {
    zip: "82902",
    ST: "WY",
    cityWithStateAbbr: "Rock Springs, WY",
  },
  {
    zip: "82922",
    ST: "WY",
    cityWithStateAbbr: "Bondurant, WY",
  },
  {
    zip: "82923",
    ST: "WY",
    cityWithStateAbbr: "Boulder, WY",
  },
  {
    zip: "82925",
    ST: "WY",
    cityWithStateAbbr: "Cora, WY",
  },
  {
    zip: "82929",
    ST: "WY",
    cityWithStateAbbr: "Little America, WY",
  },
  {
    zip: "82930",
    ST: "WY",
    cityWithStateAbbr: "Evanston, WY",
  },
  {
    zip: "82931",
    ST: "WY",
    cityWithStateAbbr: "Evanston, WY",
  },
  {
    zip: "82932",
    ST: "WY",
    cityWithStateAbbr: "Farson, WY",
  },
  {
    zip: "82933",
    ST: "WY",
    cityWithStateAbbr: "Fort Bridger, WY",
  },
  {
    zip: "82934",
    ST: "WY",
    cityWithStateAbbr: "Granger, WY",
  },
  {
    zip: "82935",
    ST: "WY",
    cityWithStateAbbr: "Green River, WY",
  },
  {
    zip: "82936",
    ST: "WY",
    cityWithStateAbbr: "Lonetree, WY",
  },
  {
    zip: "82937",
    ST: "WY",
    cityWithStateAbbr: "Lyman, WY",
  },
  {
    zip: "82938",
    ST: "WY",
    cityWithStateAbbr: "Mc Kinnon, WY",
  },
  {
    zip: "82939",
    ST: "WY",
    cityWithStateAbbr: "Mountain View, WY",
  },
  {
    zip: "82941",
    ST: "WY",
    cityWithStateAbbr: "Pinedale, WY",
  },
  {
    zip: "82942",
    ST: "WY",
    cityWithStateAbbr: "Point Of Rocks, WY",
  },
  {
    zip: "82943",
    ST: "WY",
    cityWithStateAbbr: "Reliance, WY",
  },
  {
    zip: "82944",
    ST: "WY",
    cityWithStateAbbr: "Robertson, WY",
  },
  {
    zip: "82945",
    ST: "WY",
    cityWithStateAbbr: "Superior, WY",
  },
  {
    zip: "83001",
    ST: "WY",
    cityWithStateAbbr: "Jackson, WY",
  },
  {
    zip: "83002",
    ST: "WY",
    cityWithStateAbbr: "Jackson, WY",
  },
  {
    zip: "83011",
    ST: "WY",
    cityWithStateAbbr: "Kelly, WY",
  },
  {
    zip: "83012",
    ST: "WY",
    cityWithStateAbbr: "Moose, WY",
  },
  {
    zip: "83013",
    ST: "WY",
    cityWithStateAbbr: "Moran, WY",
  },
  {
    zip: "83014",
    ST: "WY",
    cityWithStateAbbr: "Wilson, WY",
  },
  {
    zip: "83025",
    ST: "WY",
    cityWithStateAbbr: "Teton Village, WY",
  },
  {
    zip: "83101",
    ST: "WY",
    cityWithStateAbbr: "Kemmerer, WY",
  },
  {
    zip: "83110",
    ST: "WY",
    cityWithStateAbbr: "Afton, WY",
  },
  {
    zip: "83111",
    ST: "ID",
    cityWithStateAbbr: "Auburn, ID",
  },
  {
    zip: "83112",
    ST: "WY",
    cityWithStateAbbr: "Bedford, WY",
  },
  {
    zip: "83113",
    ST: "WY",
    cityWithStateAbbr: "Big Piney, WY",
  },
  {
    zip: "83114",
    ST: "WY",
    cityWithStateAbbr: "Cokeville, WY",
  },
  {
    zip: "83115",
    ST: "WY",
    cityWithStateAbbr: "Daniel, WY",
  },
  {
    zip: "83116",
    ST: "WY",
    cityWithStateAbbr: "Diamondville, WY",
  },
  {
    zip: "83118",
    ST: "WY",
    cityWithStateAbbr: "Etna, WY",
  },
  {
    zip: "83119",
    ST: "WY",
    cityWithStateAbbr: "Fairview, WY",
  },
  {
    zip: "83120",
    ST: "ID",
    cityWithStateAbbr: "Freedom, ID",
  },
  {
    zip: "83121",
    ST: "WY",
    cityWithStateAbbr: "Frontier, WY",
  },
  {
    zip: "83122",
    ST: "WY",
    cityWithStateAbbr: "Grover, WY",
  },
  {
    zip: "83123",
    ST: "WY",
    cityWithStateAbbr: "La Barge, WY",
  },
  {
    zip: "83124",
    ST: "WY",
    cityWithStateAbbr: "Opal, WY",
  },
  {
    zip: "83126",
    ST: "WY",
    cityWithStateAbbr: "Smoot, WY",
  },
  {
    zip: "83127",
    ST: "WY",
    cityWithStateAbbr: "Thayne, WY",
  },
  {
    zip: "83128",
    ST: "WY",
    cityWithStateAbbr: "Alpine, WY",
  },
  {
    zip: "83201",
    ST: "ID",
    cityWithStateAbbr: "Pocatello, ID",
  },
  {
    zip: "83202",
    ST: "ID",
    cityWithStateAbbr: "Pocatello, ID",
  },
  {
    zip: "83203",
    ST: "ID",
    cityWithStateAbbr: "Fort Hall, ID",
  },
  {
    zip: "83204",
    ST: "ID",
    cityWithStateAbbr: "Pocatello, ID",
  },
  {
    zip: "83205",
    ST: "ID",
    cityWithStateAbbr: "Pocatello, ID",
  },
  {
    zip: "83206",
    ST: "ID",
    cityWithStateAbbr: "Pocatello, ID",
  },
  {
    zip: "83209",
    ST: "ID",
    cityWithStateAbbr: "Pocatello, ID",
  },
  {
    zip: "83210",
    ST: "ID",
    cityWithStateAbbr: "Aberdeen, ID",
  },
  {
    zip: "83211",
    ST: "ID",
    cityWithStateAbbr: "American Falls, ID",
  },
  {
    zip: "83212",
    ST: "ID",
    cityWithStateAbbr: "Arbon, ID",
  },
  {
    zip: "83213",
    ST: "ID",
    cityWithStateAbbr: "Arco, ID",
  },
  {
    zip: "83214",
    ST: "ID",
    cityWithStateAbbr: "Arimo, ID",
  },
  {
    zip: "83215",
    ST: "ID",
    cityWithStateAbbr: "Atomic City, ID",
  },
  {
    zip: "83217",
    ST: "ID",
    cityWithStateAbbr: "Bancroft, ID",
  },
  {
    zip: "83218",
    ST: "ID",
    cityWithStateAbbr: "Basalt, ID",
  },
  {
    zip: "83220",
    ST: "ID",
    cityWithStateAbbr: "Bern, ID",
  },
  {
    zip: "83221",
    ST: "ID",
    cityWithStateAbbr: "Blackfoot, ID",
  },
  {
    zip: "83223",
    ST: "ID",
    cityWithStateAbbr: "Bloomington, ID",
  },
  {
    zip: "83226",
    ST: "ID",
    cityWithStateAbbr: "Challis, ID",
  },
  {
    zip: "83227",
    ST: "ID",
    cityWithStateAbbr: "Clayton, ID",
  },
  {
    zip: "83228",
    ST: "ID",
    cityWithStateAbbr: "Clifton, ID",
  },
  {
    zip: "83229",
    ST: "ID",
    cityWithStateAbbr: "Cobalt, ID",
  },
  {
    zip: "83230",
    ST: "ID",
    cityWithStateAbbr: "Conda, ID",
  },
  {
    zip: "83232",
    ST: "ID",
    cityWithStateAbbr: "Dayton, ID",
  },
  {
    zip: "83233",
    ST: "ID",
    cityWithStateAbbr: "Dingle, ID",
  },
  {
    zip: "83234",
    ST: "ID",
    cityWithStateAbbr: "Downey, ID",
  },
  {
    zip: "83235",
    ST: "ID",
    cityWithStateAbbr: "Ellis, ID",
  },
  {
    zip: "83236",
    ST: "ID",
    cityWithStateAbbr: "Firth, ID",
  },
  {
    zip: "83237",
    ST: "ID",
    cityWithStateAbbr: "Franklin, ID",
  },
  {
    zip: "83238",
    ST: "ID",
    cityWithStateAbbr: "Geneva, ID",
  },
  {
    zip: "83239",
    ST: "ID",
    cityWithStateAbbr: "Georgetown, ID",
  },
  {
    zip: "83241",
    ST: "ID",
    cityWithStateAbbr: "Grace, ID",
  },
  {
    zip: "83243",
    ST: "ID",
    cityWithStateAbbr: "Holbrook, ID",
  },
  {
    zip: "83244",
    ST: "ID",
    cityWithStateAbbr: "Howe, ID",
  },
  {
    zip: "83245",
    ST: "ID",
    cityWithStateAbbr: "Inkom, ID",
  },
  {
    zip: "83246",
    ST: "ID",
    cityWithStateAbbr: "Lava Hot Springs, ID",
  },
  {
    zip: "83250",
    ST: "ID",
    cityWithStateAbbr: "Mccammon, ID",
  },
  {
    zip: "83251",
    ST: "ID",
    cityWithStateAbbr: "Mackay, ID",
  },
  {
    zip: "83252",
    ST: "ID",
    cityWithStateAbbr: "Malad City, ID",
  },
  {
    zip: "83253",
    ST: "ID",
    cityWithStateAbbr: "May, ID",
  },
  {
    zip: "83254",
    ST: "ID",
    cityWithStateAbbr: "Montpelier, ID",
  },
  {
    zip: "83255",
    ST: "ID",
    cityWithStateAbbr: "Moore, ID",
  },
  {
    zip: "83256",
    ST: "ID",
    cityWithStateAbbr: "Moreland, ID",
  },
  {
    zip: "83261",
    ST: "ID",
    cityWithStateAbbr: "Paris, ID",
  },
  {
    zip: "83262",
    ST: "ID",
    cityWithStateAbbr: "Pingree, ID",
  },
  {
    zip: "83263",
    ST: "ID",
    cityWithStateAbbr: "Preston, ID",
  },
  {
    zip: "83271",
    ST: "ID",
    cityWithStateAbbr: "Rockland, ID",
  },
  {
    zip: "83272",
    ST: "ID",
    cityWithStateAbbr: "Saint Charles, ID",
  },
  {
    zip: "83274",
    ST: "ID",
    cityWithStateAbbr: "Shelley, ID",
  },
  {
    zip: "83276",
    ST: "ID",
    cityWithStateAbbr: "Soda Springs, ID",
  },
  {
    zip: "83277",
    ST: "ID",
    cityWithStateAbbr: "Springfield, ID",
  },
  {
    zip: "83278",
    ST: "ID",
    cityWithStateAbbr: "Stanley, ID",
  },
  {
    zip: "83281",
    ST: "ID",
    cityWithStateAbbr: "Swanlake, ID",
  },
  {
    zip: "83283",
    ST: "ID",
    cityWithStateAbbr: "Thatcher, ID",
  },
  {
    zip: "83285",
    ST: "ID",
    cityWithStateAbbr: "Wayan, ID",
  },
  {
    zip: "83286",
    ST: "ID",
    cityWithStateAbbr: "Weston, ID",
  },
  {
    zip: "83287",
    ST: "ID",
    cityWithStateAbbr: "Fish Haven, ID",
  },
  {
    zip: "83301",
    ST: "ID",
    cityWithStateAbbr: "Twin Falls, ID",
  },
  {
    zip: "83302",
    ST: "ID",
    cityWithStateAbbr: "Rogerson, ID",
  },
  {
    zip: "83303",
    ST: "ID",
    cityWithStateAbbr: "Twin Falls, ID",
  },
  {
    zip: "83311",
    ST: "ID",
    cityWithStateAbbr: "Albion, ID",
  },
  {
    zip: "83312",
    ST: "ID",
    cityWithStateAbbr: "Almo, ID",
  },
  {
    zip: "83313",
    ST: "ID",
    cityWithStateAbbr: "Bellevue, ID",
  },
  {
    zip: "83314",
    ST: "ID",
    cityWithStateAbbr: "Bliss, ID",
  },
  {
    zip: "83316",
    ST: "ID",
    cityWithStateAbbr: "Buhl, ID",
  },
  {
    zip: "83318",
    ST: "ID",
    cityWithStateAbbr: "Burley, ID",
  },
  {
    zip: "83320",
    ST: "ID",
    cityWithStateAbbr: "Carey, ID",
  },
  {
    zip: "83321",
    ST: "ID",
    cityWithStateAbbr: "Castleford, ID",
  },
  {
    zip: "83322",
    ST: "ID",
    cityWithStateAbbr: "Corral, ID",
  },
  {
    zip: "83323",
    ST: "ID",
    cityWithStateAbbr: "Declo, ID",
  },
  {
    zip: "83324",
    ST: "ID",
    cityWithStateAbbr: "Dietrich, ID",
  },
  {
    zip: "83325",
    ST: "ID",
    cityWithStateAbbr: "Eden, ID",
  },
  {
    zip: "83327",
    ST: "ID",
    cityWithStateAbbr: "Fairfield, ID",
  },
  {
    zip: "83328",
    ST: "ID",
    cityWithStateAbbr: "Filer, ID",
  },
  {
    zip: "83330",
    ST: "ID",
    cityWithStateAbbr: "Gooding, ID",
  },
  {
    zip: "83332",
    ST: "ID",
    cityWithStateAbbr: "Hagerman, ID",
  },
  {
    zip: "83333",
    ST: "ID",
    cityWithStateAbbr: "Hailey, ID",
  },
  {
    zip: "83334",
    ST: "ID",
    cityWithStateAbbr: "Hansen, ID",
  },
  {
    zip: "83335",
    ST: "ID",
    cityWithStateAbbr: "Hazelton, ID",
  },
  {
    zip: "83336",
    ST: "ID",
    cityWithStateAbbr: "Heyburn, ID",
  },
  {
    zip: "83337",
    ST: "ID",
    cityWithStateAbbr: "Hill City, ID",
  },
  {
    zip: "83338",
    ST: "ID",
    cityWithStateAbbr: "Jerome, ID",
  },
  {
    zip: "83340",
    ST: "ID",
    cityWithStateAbbr: "Ketchum, ID",
  },
  {
    zip: "83341",
    ST: "ID",
    cityWithStateAbbr: "Kimberly, ID",
  },
  {
    zip: "83342",
    ST: "ID",
    cityWithStateAbbr: "Malta, ID",
  },
  {
    zip: "83343",
    ST: "ID",
    cityWithStateAbbr: "Minidoka, ID",
  },
  {
    zip: "83344",
    ST: "ID",
    cityWithStateAbbr: "Murtaugh, ID",
  },
  {
    zip: "83346",
    ST: "ID",
    cityWithStateAbbr: "Oakley, ID",
  },
  {
    zip: "83347",
    ST: "ID",
    cityWithStateAbbr: "Paul, ID",
  },
  {
    zip: "83348",
    ST: "ID",
    cityWithStateAbbr: "Picabo, ID",
  },
  {
    zip: "83349",
    ST: "ID",
    cityWithStateAbbr: "Richfield, ID",
  },
  {
    zip: "83350",
    ST: "ID",
    cityWithStateAbbr: "Rupert, ID",
  },
  {
    zip: "83352",
    ST: "ID",
    cityWithStateAbbr: "Shoshone, ID",
  },
  {
    zip: "83353",
    ST: "ID",
    cityWithStateAbbr: "Sun Valley, ID",
  },
  {
    zip: "83354",
    ST: "ID",
    cityWithStateAbbr: "Sun Valley, ID",
  },
  {
    zip: "83355",
    ST: "ID",
    cityWithStateAbbr: "Wendell, ID",
  },
  {
    zip: "83401",
    ST: "ID",
    cityWithStateAbbr: "Idaho Falls, ID",
  },
  {
    zip: "83402",
    ST: "ID",
    cityWithStateAbbr: "Idaho Falls, ID",
  },
  {
    zip: "83403",
    ST: "ID",
    cityWithStateAbbr: "Idaho Falls, ID",
  },
  {
    zip: "83404",
    ST: "ID",
    cityWithStateAbbr: "Idaho Falls, ID",
  },
  {
    zip: "83405",
    ST: "ID",
    cityWithStateAbbr: "Idaho Falls, ID",
  },
  {
    zip: "83406",
    ST: "ID",
    cityWithStateAbbr: "Idaho Falls, ID",
  },
  {
    zip: "83414",
    ST: "WY",
    cityWithStateAbbr: "Alta, WY",
  },
  {
    zip: "83415",
    ST: "ID",
    cityWithStateAbbr: "Idaho Falls, ID",
  },
  {
    zip: "83420",
    ST: "ID",
    cityWithStateAbbr: "Ashton, ID",
  },
  {
    zip: "83421",
    ST: "ID",
    cityWithStateAbbr: "Chester, ID",
  },
  {
    zip: "83422",
    ST: "ID",
    cityWithStateAbbr: "Driggs, ID",
  },
  {
    zip: "83423",
    ST: "ID",
    cityWithStateAbbr: "Dubois, ID",
  },
  {
    zip: "83424",
    ST: "ID",
    cityWithStateAbbr: "Felt, ID",
  },
  {
    zip: "83425",
    ST: "ID",
    cityWithStateAbbr: "Hamer, ID",
  },
  {
    zip: "83427",
    ST: "ID",
    cityWithStateAbbr: "Iona, ID",
  },
  {
    zip: "83428",
    ST: "ID",
    cityWithStateAbbr: "Irwin, ID",
  },
  {
    zip: "83429",
    ST: "ID",
    cityWithStateAbbr: "Island Park, ID",
  },
  {
    zip: "83431",
    ST: "ID",
    cityWithStateAbbr: "Lewisville, ID",
  },
  {
    zip: "83433",
    ST: "ID",
    cityWithStateAbbr: "Macks Inn, ID",
  },
  {
    zip: "83434",
    ST: "ID",
    cityWithStateAbbr: "Menan, ID",
  },
  {
    zip: "83435",
    ST: "ID",
    cityWithStateAbbr: "Monteview, ID",
  },
  {
    zip: "83436",
    ST: "ID",
    cityWithStateAbbr: "Newdale, ID",
  },
  {
    zip: "83438",
    ST: "ID",
    cityWithStateAbbr: "Parker, ID",
  },
  {
    zip: "83440",
    ST: "ID",
    cityWithStateAbbr: "Rexburg, ID",
  },
  {
    zip: "83441",
    ST: "ID",
    cityWithStateAbbr: "Rexburg, ID",
  },
  {
    zip: "83442",
    ST: "ID",
    cityWithStateAbbr: "Rigby, ID",
  },
  {
    zip: "83443",
    ST: "ID",
    cityWithStateAbbr: "Ririe, ID",
  },
  {
    zip: "83444",
    ST: "ID",
    cityWithStateAbbr: "Roberts, ID",
  },
  {
    zip: "83445",
    ST: "ID",
    cityWithStateAbbr: "Saint Anthony, ID",
  },
  {
    zip: "83446",
    ST: "ID",
    cityWithStateAbbr: "Spencer, ID",
  },
  {
    zip: "83448",
    ST: "ID",
    cityWithStateAbbr: "Sugar City, ID",
  },
  {
    zip: "83449",
    ST: "ID",
    cityWithStateAbbr: "Swan Valley, ID",
  },
  {
    zip: "83450",
    ST: "ID",
    cityWithStateAbbr: "Terreton, ID",
  },
  {
    zip: "83451",
    ST: "ID",
    cityWithStateAbbr: "Teton, ID",
  },
  {
    zip: "83452",
    ST: "ID",
    cityWithStateAbbr: "Tetonia, ID",
  },
  {
    zip: "83454",
    ST: "ID",
    cityWithStateAbbr: "Ucon, ID",
  },
  {
    zip: "83455",
    ST: "ID",
    cityWithStateAbbr: "Victor, ID",
  },
  {
    zip: "83460",
    ST: "ID",
    cityWithStateAbbr: "Rexburg, ID",
  },
  {
    zip: "83462",
    ST: "ID",
    cityWithStateAbbr: "Carmen, ID",
  },
  {
    zip: "83463",
    ST: "ID",
    cityWithStateAbbr: "Gibbonsville, ID",
  },
  {
    zip: "83464",
    ST: "ID",
    cityWithStateAbbr: "Leadore, ID",
  },
  {
    zip: "83465",
    ST: "ID",
    cityWithStateAbbr: "Lemhi, ID",
  },
  {
    zip: "83466",
    ST: "ID",
    cityWithStateAbbr: "North Fork, ID",
  },
  {
    zip: "83467",
    ST: "ID",
    cityWithStateAbbr: "Salmon, ID",
  },
  {
    zip: "83468",
    ST: "ID",
    cityWithStateAbbr: "Tendoy, ID",
  },
  {
    zip: "83469",
    ST: "ID",
    cityWithStateAbbr: "Shoup, ID",
  },
  {
    zip: "83501",
    ST: "ID",
    cityWithStateAbbr: "Lewiston, ID",
  },
  {
    zip: "83520",
    ST: "ID",
    cityWithStateAbbr: "Ahsahka, ID",
  },
  {
    zip: "83522",
    ST: "ID",
    cityWithStateAbbr: "Cottonwood, ID",
  },
  {
    zip: "83523",
    ST: "ID",
    cityWithStateAbbr: "Craigmont, ID",
  },
  {
    zip: "83524",
    ST: "ID",
    cityWithStateAbbr: "Culdesac, ID",
  },
  {
    zip: "83525",
    ST: "ID",
    cityWithStateAbbr: "Elk City, ID",
  },
  {
    zip: "83526",
    ST: "ID",
    cityWithStateAbbr: "Ferdinand, ID",
  },
  {
    zip: "83530",
    ST: "ID",
    cityWithStateAbbr: "Grangeville, ID",
  },
  {
    zip: "83531",
    ST: "ID",
    cityWithStateAbbr: "Fenn, ID",
  },
  {
    zip: "83533",
    ST: "ID",
    cityWithStateAbbr: "Greencreek, ID",
  },
  {
    zip: "83535",
    ST: "ID",
    cityWithStateAbbr: "Juliaetta, ID",
  },
  {
    zip: "83536",
    ST: "ID",
    cityWithStateAbbr: "Kamiah, ID",
  },
  {
    zip: "83537",
    ST: "ID",
    cityWithStateAbbr: "Kendrick, ID",
  },
  {
    zip: "83539",
    ST: "ID",
    cityWithStateAbbr: "Kooskia, ID",
  },
  {
    zip: "83540",
    ST: "ID",
    cityWithStateAbbr: "Lapwai, ID",
  },
  {
    zip: "83541",
    ST: "ID",
    cityWithStateAbbr: "Lenore, ID",
  },
  {
    zip: "83542",
    ST: "ID",
    cityWithStateAbbr: "Lucile, ID",
  },
  {
    zip: "83543",
    ST: "ID",
    cityWithStateAbbr: "Nezperce, ID",
  },
  {
    zip: "83544",
    ST: "ID",
    cityWithStateAbbr: "Orofino, ID",
  },
  {
    zip: "83545",
    ST: "ID",
    cityWithStateAbbr: "Peck, ID",
  },
  {
    zip: "83546",
    ST: "ID",
    cityWithStateAbbr: "Pierce, ID",
  },
  {
    zip: "83547",
    ST: "ID",
    cityWithStateAbbr: "Pollock, ID",
  },
  {
    zip: "83548",
    ST: "ID",
    cityWithStateAbbr: "Reubens, ID",
  },
  {
    zip: "83549",
    ST: "ID",
    cityWithStateAbbr: "Riggins, ID",
  },
  {
    zip: "83552",
    ST: "ID",
    cityWithStateAbbr: "Stites, ID",
  },
  {
    zip: "83553",
    ST: "ID",
    cityWithStateAbbr: "Weippe, ID",
  },
  {
    zip: "83554",
    ST: "ID",
    cityWithStateAbbr: "White Bird, ID",
  },
  {
    zip: "83555",
    ST: "ID",
    cityWithStateAbbr: "Winchester, ID",
  },
  {
    zip: "83601",
    ST: "ID",
    cityWithStateAbbr: "Atlanta, ID",
  },
  {
    zip: "83602",
    ST: "ID",
    cityWithStateAbbr: "Banks, ID",
  },
  {
    zip: "83604",
    ST: "ID",
    cityWithStateAbbr: "Bruneau, ID",
  },
  {
    zip: "83605",
    ST: "ID",
    cityWithStateAbbr: "Caldwell, ID",
  },
  {
    zip: "83606",
    ST: "ID",
    cityWithStateAbbr: "Caldwell, ID",
  },
  {
    zip: "83607",
    ST: "ID",
    cityWithStateAbbr: "Caldwell, ID",
  },
  {
    zip: "83610",
    ST: "ID",
    cityWithStateAbbr: "Cambridge, ID",
  },
  {
    zip: "83611",
    ST: "ID",
    cityWithStateAbbr: "Cascade, ID",
  },
  {
    zip: "83612",
    ST: "ID",
    cityWithStateAbbr: "Council, ID",
  },
  {
    zip: "83615",
    ST: "ID",
    cityWithStateAbbr: "Donnelly, ID",
  },
  {
    zip: "83616",
    ST: "ID",
    cityWithStateAbbr: "Eagle, ID",
  },
  {
    zip: "83617",
    ST: "ID",
    cityWithStateAbbr: "Emmett, ID",
  },
  {
    zip: "83619",
    ST: "ID",
    cityWithStateAbbr: "Fruitland, ID",
  },
  {
    zip: "83622",
    ST: "ID",
    cityWithStateAbbr: "Garden Valley, ID",
  },
  {
    zip: "83623",
    ST: "ID",
    cityWithStateAbbr: "Glenns Ferry, ID",
  },
  {
    zip: "83624",
    ST: "ID",
    cityWithStateAbbr: "Grand View, ID",
  },
  {
    zip: "83626",
    ST: "ID",
    cityWithStateAbbr: "Greenleaf, ID",
  },
  {
    zip: "83627",
    ST: "ID",
    cityWithStateAbbr: "Hammett, ID",
  },
  {
    zip: "83628",
    ST: "ID",
    cityWithStateAbbr: "Homedale, ID",
  },
  {
    zip: "83629",
    ST: "ID",
    cityWithStateAbbr: "Horseshoe Bend, ID",
  },
  {
    zip: "83630",
    ST: "ID",
    cityWithStateAbbr: "Huston, ID",
  },
  {
    zip: "83631",
    ST: "ID",
    cityWithStateAbbr: "Idaho City, ID",
  },
  {
    zip: "83632",
    ST: "ID",
    cityWithStateAbbr: "Indian Valley, ID",
  },
  {
    zip: "83633",
    ST: "ID",
    cityWithStateAbbr: "King Hill, ID",
  },
  {
    zip: "83634",
    ST: "ID",
    cityWithStateAbbr: "Kuna, ID",
  },
  {
    zip: "83635",
    ST: "ID",
    cityWithStateAbbr: "Lake Fork, ID",
  },
  {
    zip: "83636",
    ST: "ID",
    cityWithStateAbbr: "Letha, ID",
  },
  {
    zip: "83637",
    ST: "ID",
    cityWithStateAbbr: "Lowman, ID",
  },
  {
    zip: "83638",
    ST: "ID",
    cityWithStateAbbr: "Mccall, ID",
  },
  {
    zip: "83639",
    ST: "ID",
    cityWithStateAbbr: "Marsing, ID",
  },
  {
    zip: "83641",
    ST: "ID",
    cityWithStateAbbr: "Melba, ID",
  },
  {
    zip: "83642",
    ST: "ID",
    cityWithStateAbbr: "Meridian, ID",
  },
  {
    zip: "83643",
    ST: "ID",
    cityWithStateAbbr: "Mesa, ID",
  },
  {
    zip: "83644",
    ST: "ID",
    cityWithStateAbbr: "Middleton, ID",
  },
  {
    zip: "83645",
    ST: "ID",
    cityWithStateAbbr: "Midvale, ID",
  },
  {
    zip: "83646",
    ST: "ID",
    cityWithStateAbbr: "Meridian, ID",
  },
  {
    zip: "83647",
    ST: "ID",
    cityWithStateAbbr: "Mountain Home, ID",
  },
  {
    zip: "83648",
    ST: "ID",
    cityWithStateAbbr: "Mountain Home Afb, ID",
  },
  {
    zip: "83650",
    ST: "ID",
    cityWithStateAbbr: "Murphy, ID",
  },
  {
    zip: "83651",
    ST: "ID",
    cityWithStateAbbr: "Nampa, ID",
  },
  {
    zip: "83652",
    ST: "ID",
    cityWithStateAbbr: "Nampa, ID",
  },
  {
    zip: "83653",
    ST: "ID",
    cityWithStateAbbr: "Nampa, ID",
  },
  {
    zip: "83654",
    ST: "ID",
    cityWithStateAbbr: "New Meadows, ID",
  },
  {
    zip: "83655",
    ST: "ID",
    cityWithStateAbbr: "New Plymouth, ID",
  },
  {
    zip: "83656",
    ST: "ID",
    cityWithStateAbbr: "Notus, ID",
  },
  {
    zip: "83657",
    ST: "ID",
    cityWithStateAbbr: "Ola, ID",
  },
  {
    zip: "83660",
    ST: "ID",
    cityWithStateAbbr: "Parma, ID",
  },
  {
    zip: "83661",
    ST: "ID",
    cityWithStateAbbr: "Payette, ID",
  },
  {
    zip: "83666",
    ST: "ID",
    cityWithStateAbbr: "Placerville, ID",
  },
  {
    zip: "83669",
    ST: "ID",
    cityWithStateAbbr: "Star, ID",
  },
  {
    zip: "83670",
    ST: "ID",
    cityWithStateAbbr: "Sweet, ID",
  },
  {
    zip: "83671",
    ST: "ID",
    cityWithStateAbbr: "Warren, ID",
  },
  {
    zip: "83672",
    ST: "ID",
    cityWithStateAbbr: "Weiser, ID",
  },
  {
    zip: "83676",
    ST: "ID",
    cityWithStateAbbr: "Wilder, ID",
  },
  {
    zip: "83677",
    ST: "ID",
    cityWithStateAbbr: "Yellow Pine, ID",
  },
  {
    zip: "83680",
    ST: "ID",
    cityWithStateAbbr: "Meridian, ID",
  },
  {
    zip: "83686",
    ST: "ID",
    cityWithStateAbbr: "Nampa, ID",
  },
  {
    zip: "83687",
    ST: "ID",
    cityWithStateAbbr: "Nampa, ID",
  },
  {
    zip: "83701",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83702",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83703",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83704",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83705",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83706",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83707",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83708",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83709",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83711",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83712",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83713",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83714",
    ST: "ID",
    cityWithStateAbbr: "Garden City, ID",
  },
  {
    zip: "83715",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83716",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83717",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83719",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83720",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83722",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83724",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83725",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83726",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83728",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83729",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83731",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83732",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83735",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83756",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83799",
    ST: "ID",
    cityWithStateAbbr: "Boise, ID",
  },
  {
    zip: "83801",
    ST: "ID",
    cityWithStateAbbr: "Athol, ID",
  },
  {
    zip: "83802",
    ST: "ID",
    cityWithStateAbbr: "Avery, ID",
  },
  {
    zip: "83803",
    ST: "ID",
    cityWithStateAbbr: "Bayview, ID",
  },
  {
    zip: "83804",
    ST: "ID",
    cityWithStateAbbr: "Blanchard, ID",
  },
  {
    zip: "83805",
    ST: "ID",
    cityWithStateAbbr: "Bonners Ferry, ID",
  },
  {
    zip: "83806",
    ST: "ID",
    cityWithStateAbbr: "Bovill, ID",
  },
  {
    zip: "83808",
    ST: "ID",
    cityWithStateAbbr: "Calder, ID",
  },
  {
    zip: "83809",
    ST: "ID",
    cityWithStateAbbr: "Careywood, ID",
  },
  {
    zip: "83810",
    ST: "ID",
    cityWithStateAbbr: "Cataldo, ID",
  },
  {
    zip: "83811",
    ST: "ID",
    cityWithStateAbbr: "Clark Fork, ID",
  },
  {
    zip: "83812",
    ST: "ID",
    cityWithStateAbbr: "Clarkia, ID",
  },
  {
    zip: "83813",
    ST: "ID",
    cityWithStateAbbr: "Cocolalla, ID",
  },
  {
    zip: "83814",
    ST: "ID",
    cityWithStateAbbr: "Coeur D Alene, ID",
  },
  {
    zip: "83815",
    ST: "ID",
    cityWithStateAbbr: "Coeur D Alene, ID",
  },
  {
    zip: "83816",
    ST: "ID",
    cityWithStateAbbr: "Coeur D Alene, ID",
  },
  {
    zip: "83821",
    ST: "ID",
    cityWithStateAbbr: "Coolin, ID",
  },
  {
    zip: "83822",
    ST: "ID",
    cityWithStateAbbr: "Oldtown, ID",
  },
  {
    zip: "83823",
    ST: "ID",
    cityWithStateAbbr: "Deary, ID",
  },
  {
    zip: "83824",
    ST: "ID",
    cityWithStateAbbr: "Desmet, ID",
  },
  {
    zip: "83825",
    ST: "ID",
    cityWithStateAbbr: "Dover, ID",
  },
  {
    zip: "83826",
    ST: "ID",
    cityWithStateAbbr: "Eastport, ID",
  },
  {
    zip: "83827",
    ST: "ID",
    cityWithStateAbbr: "Elk River, ID",
  },
  {
    zip: "83830",
    ST: "ID",
    cityWithStateAbbr: "Fernwood, ID",
  },
  {
    zip: "83832",
    ST: "ID",
    cityWithStateAbbr: "Genesee, ID",
  },
  {
    zip: "83833",
    ST: "ID",
    cityWithStateAbbr: "Harrison, ID",
  },
  {
    zip: "83834",
    ST: "ID",
    cityWithStateAbbr: "Harvard, ID",
  },
  {
    zip: "83835",
    ST: "ID",
    cityWithStateAbbr: "Hayden, ID",
  },
  {
    zip: "83836",
    ST: "ID",
    cityWithStateAbbr: "Hope, ID",
  },
  {
    zip: "83837",
    ST: "ID",
    cityWithStateAbbr: "Kellogg, ID",
  },
  {
    zip: "83839",
    ST: "ID",
    cityWithStateAbbr: "Kingston, ID",
  },
  {
    zip: "83840",
    ST: "ID",
    cityWithStateAbbr: "Kootenai, ID",
  },
  {
    zip: "83841",
    ST: "ID",
    cityWithStateAbbr: "Laclede, ID",
  },
  {
    zip: "83842",
    ST: "ID",
    cityWithStateAbbr: "Medimont, ID",
  },
  {
    zip: "83843",
    ST: "ID",
    cityWithStateAbbr: "Moscow, ID",
  },
  {
    zip: "83844",
    ST: "ID",
    cityWithStateAbbr: "Moscow, ID",
  },
  {
    zip: "83845",
    ST: "ID",
    cityWithStateAbbr: "Moyie Springs, ID",
  },
  {
    zip: "83846",
    ST: "ID",
    cityWithStateAbbr: "Mullan, ID",
  },
  {
    zip: "83847",
    ST: "ID",
    cityWithStateAbbr: "Naples, ID",
  },
  {
    zip: "83848",
    ST: "ID",
    cityWithStateAbbr: "Nordman, ID",
  },
  {
    zip: "83849",
    ST: "ID",
    cityWithStateAbbr: "Osburn, ID",
  },
  {
    zip: "83850",
    ST: "ID",
    cityWithStateAbbr: "Pinehurst, ID",
  },
  {
    zip: "83851",
    ST: "ID",
    cityWithStateAbbr: "Plummer, ID",
  },
  {
    zip: "83852",
    ST: "ID",
    cityWithStateAbbr: "Ponderay, ID",
  },
  {
    zip: "83853",
    ST: "ID",
    cityWithStateAbbr: "Porthill, ID",
  },
  {
    zip: "83854",
    ST: "ID",
    cityWithStateAbbr: "Post Falls, ID",
  },
  {
    zip: "83855",
    ST: "ID",
    cityWithStateAbbr: "Potlatch, ID",
  },
  {
    zip: "83856",
    ST: "ID",
    cityWithStateAbbr: "Priest River, ID",
  },
  {
    zip: "83857",
    ST: "ID",
    cityWithStateAbbr: "Princeton, ID",
  },
  {
    zip: "83858",
    ST: "ID",
    cityWithStateAbbr: "Rathdrum, ID",
  },
  {
    zip: "83860",
    ST: "ID",
    cityWithStateAbbr: "Sagle, ID",
  },
  {
    zip: "83861",
    ST: "ID",
    cityWithStateAbbr: "Saint Maries, ID",
  },
  {
    zip: "83864",
    ST: "ID",
    cityWithStateAbbr: "Sandpoint, ID",
  },
  {
    zip: "83865",
    ST: "ID",
    cityWithStateAbbr: "Colburn, ID",
  },
  {
    zip: "83866",
    ST: "ID",
    cityWithStateAbbr: "Santa, ID",
  },
  {
    zip: "83867",
    ST: "ID",
    cityWithStateAbbr: "Silverton, ID",
  },
  {
    zip: "83868",
    ST: "ID",
    cityWithStateAbbr: "Smelterville, ID",
  },
  {
    zip: "83869",
    ST: "ID",
    cityWithStateAbbr: "Spirit Lake, ID",
  },
  {
    zip: "83870",
    ST: "ID",
    cityWithStateAbbr: "Tensed, ID",
  },
  {
    zip: "83871",
    ST: "ID",
    cityWithStateAbbr: "Troy, ID",
  },
  {
    zip: "83872",
    ST: "ID",
    cityWithStateAbbr: "Viola, ID",
  },
  {
    zip: "83873",
    ST: "ID",
    cityWithStateAbbr: "Wallace, ID",
  },
  {
    zip: "83874",
    ST: "ID",
    cityWithStateAbbr: "Murray, ID",
  },
  {
    zip: "83876",
    ST: "ID",
    cityWithStateAbbr: "Worley, ID",
  },
  {
    zip: "83877",
    ST: "ID",
    cityWithStateAbbr: "Post Falls, ID",
  },
  {
    zip: "84001",
    ST: "UT",
    cityWithStateAbbr: "Altamont, UT",
  },
  {
    zip: "84002",
    ST: "UT",
    cityWithStateAbbr: "Altonah, UT",
  },
  {
    zip: "84003",
    ST: "UT",
    cityWithStateAbbr: "American Fork, UT",
  },
  {
    zip: "84004",
    ST: "UT",
    cityWithStateAbbr: "Alpine, UT",
  },
  {
    zip: "84005",
    ST: "UT",
    cityWithStateAbbr: "Eagle Mountain, UT",
  },
  {
    zip: "84006",
    ST: "UT",
    cityWithStateAbbr: "Bingham Canyon, UT",
  },
  {
    zip: "84007",
    ST: "UT",
    cityWithStateAbbr: "Bluebell, UT",
  },
  {
    zip: "84008",
    ST: "UT",
    cityWithStateAbbr: "Bonanza, UT",
  },
  {
    zip: "84009",
    ST: "UT",
    cityWithStateAbbr: "South Jordan, UT",
  },
  {
    zip: "84010",
    ST: "UT",
    cityWithStateAbbr: "Bountiful, UT",
  },
  {
    zip: "84011",
    ST: "UT",
    cityWithStateAbbr: "Bountiful, UT",
  },
  {
    zip: "84013",
    ST: "UT",
    cityWithStateAbbr: "Cedar Valley, UT",
  },
  {
    zip: "84014",
    ST: "UT",
    cityWithStateAbbr: "Centerville, UT",
  },
  {
    zip: "84015",
    ST: "UT",
    cityWithStateAbbr: "Clearfield, UT",
  },
  {
    zip: "84016",
    ST: "UT",
    cityWithStateAbbr: "Clearfield, UT",
  },
  {
    zip: "84017",
    ST: "UT",
    cityWithStateAbbr: "Coalville, UT",
  },
  {
    zip: "84018",
    ST: "UT",
    cityWithStateAbbr: "Croydon, UT",
  },
  {
    zip: "84020",
    ST: "UT",
    cityWithStateAbbr: "Draper, UT",
  },
  {
    zip: "84021",
    ST: "UT",
    cityWithStateAbbr: "Duchesne, UT",
  },
  {
    zip: "84022",
    ST: "UT",
    cityWithStateAbbr: "Dugway, UT",
  },
  {
    zip: "84023",
    ST: "UT",
    cityWithStateAbbr: "Dutch John, UT",
  },
  {
    zip: "84024",
    ST: "UT",
    cityWithStateAbbr: "Echo, UT",
  },
  {
    zip: "84025",
    ST: "UT",
    cityWithStateAbbr: "Farmington, UT",
  },
  {
    zip: "84026",
    ST: "UT",
    cityWithStateAbbr: "Fort Duchesne, UT",
  },
  {
    zip: "84027",
    ST: "UT",
    cityWithStateAbbr: "Fruitland, UT",
  },
  {
    zip: "84028",
    ST: "UT",
    cityWithStateAbbr: "Garden City, UT",
  },
  {
    zip: "84029",
    ST: "UT",
    cityWithStateAbbr: "Grantsville, UT",
  },
  {
    zip: "84031",
    ST: "UT",
    cityWithStateAbbr: "Hanna, UT",
  },
  {
    zip: "84032",
    ST: "UT",
    cityWithStateAbbr: "Heber City, UT",
  },
  {
    zip: "84033",
    ST: "UT",
    cityWithStateAbbr: "Henefer, UT",
  },
  {
    zip: "84034",
    ST: "UT",
    cityWithStateAbbr: "Ibapah, UT",
  },
  {
    zip: "84035",
    ST: "UT",
    cityWithStateAbbr: "Jensen, UT",
  },
  {
    zip: "84036",
    ST: "UT",
    cityWithStateAbbr: "Kamas, UT",
  },
  {
    zip: "84037",
    ST: "UT",
    cityWithStateAbbr: "Kaysville, UT",
  },
  {
    zip: "84038",
    ST: "UT",
    cityWithStateAbbr: "Laketown, UT",
  },
  {
    zip: "84039",
    ST: "UT",
    cityWithStateAbbr: "Lapoint, UT",
  },
  {
    zip: "84040",
    ST: "UT",
    cityWithStateAbbr: "Layton, UT",
  },
  {
    zip: "84041",
    ST: "UT",
    cityWithStateAbbr: "Layton, UT",
  },
  {
    zip: "84042",
    ST: "UT",
    cityWithStateAbbr: "Lindon, UT",
  },
  {
    zip: "84043",
    ST: "UT",
    cityWithStateAbbr: "Lehi, UT",
  },
  {
    zip: "84044",
    ST: "UT",
    cityWithStateAbbr: "Magna, UT",
  },
  {
    zip: "84045",
    ST: "UT",
    cityWithStateAbbr: "Saratoga Springs, UT",
  },
  {
    zip: "84046",
    ST: "UT",
    cityWithStateAbbr: "Manila, UT",
  },
  {
    zip: "84047",
    ST: "UT",
    cityWithStateAbbr: "Midvale, UT",
  },
  {
    zip: "84049",
    ST: "UT",
    cityWithStateAbbr: "Midway, UT",
  },
  {
    zip: "84050",
    ST: "UT",
    cityWithStateAbbr: "Morgan, UT",
  },
  {
    zip: "84051",
    ST: "UT",
    cityWithStateAbbr: "Mountain Home, UT",
  },
  {
    zip: "84052",
    ST: "UT",
    cityWithStateAbbr: "Myton, UT",
  },
  {
    zip: "84053",
    ST: "UT",
    cityWithStateAbbr: "Neola, UT",
  },
  {
    zip: "84054",
    ST: "UT",
    cityWithStateAbbr: "North Salt Lake, UT",
  },
  {
    zip: "84055",
    ST: "UT",
    cityWithStateAbbr: "Oakley, UT",
  },
  {
    zip: "84056",
    ST: "UT",
    cityWithStateAbbr: "Hill Afb, UT",
  },
  {
    zip: "84057",
    ST: "UT",
    cityWithStateAbbr: "Orem, UT",
  },
  {
    zip: "84058",
    ST: "UT",
    cityWithStateAbbr: "Orem, UT",
  },
  {
    zip: "84059",
    ST: "UT",
    cityWithStateAbbr: "Orem, UT",
  },
  {
    zip: "84060",
    ST: "UT",
    cityWithStateAbbr: "Park City, UT",
  },
  {
    zip: "84061",
    ST: "UT",
    cityWithStateAbbr: "Peoa, UT",
  },
  {
    zip: "84062",
    ST: "UT",
    cityWithStateAbbr: "Pleasant Grove, UT",
  },
  {
    zip: "84063",
    ST: "UT",
    cityWithStateAbbr: "Randlett, UT",
  },
  {
    zip: "84064",
    ST: "UT",
    cityWithStateAbbr: "Randolph, UT",
  },
  {
    zip: "84065",
    ST: "UT",
    cityWithStateAbbr: "Riverton, UT",
  },
  {
    zip: "84066",
    ST: "UT",
    cityWithStateAbbr: "Roosevelt, UT",
  },
  {
    zip: "84067",
    ST: "UT",
    cityWithStateAbbr: "Roy, UT",
  },
  {
    zip: "84068",
    ST: "UT",
    cityWithStateAbbr: "Park City, UT",
  },
  {
    zip: "84069",
    ST: "UT",
    cityWithStateAbbr: "Rush Valley, UT",
  },
  {
    zip: "84070",
    ST: "UT",
    cityWithStateAbbr: "Sandy, UT",
  },
  {
    zip: "84071",
    ST: "UT",
    cityWithStateAbbr: "Stockton, UT",
  },
  {
    zip: "84072",
    ST: "UT",
    cityWithStateAbbr: "Tabiona, UT",
  },
  {
    zip: "84073",
    ST: "UT",
    cityWithStateAbbr: "Talmage, UT",
  },
  {
    zip: "84074",
    ST: "UT",
    cityWithStateAbbr: "Tooele, UT",
  },
  {
    zip: "84075",
    ST: "UT",
    cityWithStateAbbr: "Syracuse, UT",
  },
  {
    zip: "84076",
    ST: "UT",
    cityWithStateAbbr: "Tridell, UT",
  },
  {
    zip: "84078",
    ST: "UT",
    cityWithStateAbbr: "Vernal, UT",
  },
  {
    zip: "84079",
    ST: "UT",
    cityWithStateAbbr: "Vernal, UT",
  },
  {
    zip: "84080",
    ST: "UT",
    cityWithStateAbbr: "Vernon, UT",
  },
  {
    zip: "84081",
    ST: "UT",
    cityWithStateAbbr: "West Jordan, UT",
  },
  {
    zip: "84082",
    ST: "UT",
    cityWithStateAbbr: "Wallsburg, UT",
  },
  {
    zip: "84083",
    ST: "UT",
    cityWithStateAbbr: "Wendover, UT",
  },
  {
    zip: "84084",
    ST: "UT",
    cityWithStateAbbr: "West Jordan, UT",
  },
  {
    zip: "84085",
    ST: "UT",
    cityWithStateAbbr: "Whiterocks, UT",
  },
  {
    zip: "84086",
    ST: "UT",
    cityWithStateAbbr: "Woodruff, UT",
  },
  {
    zip: "84087",
    ST: "UT",
    cityWithStateAbbr: "Woods Cross, UT",
  },
  {
    zip: "84088",
    ST: "UT",
    cityWithStateAbbr: "West Jordan, UT",
  },
  {
    zip: "84089",
    ST: "UT",
    cityWithStateAbbr: "Clearfield, UT",
  },
  {
    zip: "84090",
    ST: "UT",
    cityWithStateAbbr: "Sandy, UT",
  },
  {
    zip: "84091",
    ST: "UT",
    cityWithStateAbbr: "Sandy, UT",
  },
  {
    zip: "84092",
    ST: "UT",
    cityWithStateAbbr: "Sandy, UT",
  },
  {
    zip: "84093",
    ST: "UT",
    cityWithStateAbbr: "Sandy, UT",
  },
  {
    zip: "84094",
    ST: "UT",
    cityWithStateAbbr: "Sandy, UT",
  },
  {
    zip: "84095",
    ST: "UT",
    cityWithStateAbbr: "South Jordan, UT",
  },
  {
    zip: "84096",
    ST: "UT",
    cityWithStateAbbr: "Herriman, UT",
  },
  {
    zip: "84097",
    ST: "UT",
    cityWithStateAbbr: "Orem, UT",
  },
  {
    zip: "84098",
    ST: "UT",
    cityWithStateAbbr: "Park City, UT",
  },
  {
    zip: "84101",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84102",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84103",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84104",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84105",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84106",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84107",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84108",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84109",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84110",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84111",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84112",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84113",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84114",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84115",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84116",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84117",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84118",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84119",
    ST: "UT",
    cityWithStateAbbr: "West Valley City, UT",
  },
  {
    zip: "84120",
    ST: "UT",
    cityWithStateAbbr: "West Valley City, UT",
  },
  {
    zip: "84121",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84122",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84123",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84124",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84125",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84126",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84127",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84128",
    ST: "UT",
    cityWithStateAbbr: "West Valley City, UT",
  },
  {
    zip: "84129",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84130",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84131",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84132",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84133",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84134",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84136",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84138",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84139",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84141",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84143",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84145",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84147",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84148",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84150",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84151",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84152",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84157",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84158",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84165",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84170",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84171",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84180",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84184",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84189",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84190",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84199",
    ST: "UT",
    cityWithStateAbbr: "Salt Lake City, UT",
  },
  {
    zip: "84201",
    ST: "UT",
    cityWithStateAbbr: "Ogden, UT",
  },
  {
    zip: "84244",
    ST: "UT",
    cityWithStateAbbr: "Ogden, UT",
  },
  {
    zip: "84301",
    ST: "UT",
    cityWithStateAbbr: "Bear River City, UT",
  },
  {
    zip: "84302",
    ST: "UT",
    cityWithStateAbbr: "Brigham City, UT",
  },
  {
    zip: "84304",
    ST: "UT",
    cityWithStateAbbr: "Cache Junction, UT",
  },
  {
    zip: "84305",
    ST: "UT",
    cityWithStateAbbr: "Clarkston, UT",
  },
  {
    zip: "84306",
    ST: "UT",
    cityWithStateAbbr: "Collinston, UT",
  },
  {
    zip: "84307",
    ST: "UT",
    cityWithStateAbbr: "Corinne, UT",
  },
  {
    zip: "84308",
    ST: "UT",
    cityWithStateAbbr: "Cornish, UT",
  },
  {
    zip: "84309",
    ST: "UT",
    cityWithStateAbbr: "Deweyville, UT",
  },
  {
    zip: "84310",
    ST: "UT",
    cityWithStateAbbr: "Eden, UT",
  },
  {
    zip: "84311",
    ST: "UT",
    cityWithStateAbbr: "Fielding, UT",
  },
  {
    zip: "84312",
    ST: "UT",
    cityWithStateAbbr: "Garland, UT",
  },
  {
    zip: "84313",
    ST: "UT",
    cityWithStateAbbr: "Grouse Creek, UT",
  },
  {
    zip: "84314",
    ST: "UT",
    cityWithStateAbbr: "Honeyville, UT",
  },
  {
    zip: "84315",
    ST: "UT",
    cityWithStateAbbr: "Hooper, UT",
  },
  {
    zip: "84316",
    ST: "UT",
    cityWithStateAbbr: "Howell, UT",
  },
  {
    zip: "84317",
    ST: "UT",
    cityWithStateAbbr: "Huntsville, UT",
  },
  {
    zip: "84318",
    ST: "UT",
    cityWithStateAbbr: "Hyde Park, UT",
  },
  {
    zip: "84319",
    ST: "UT",
    cityWithStateAbbr: "Hyrum, UT",
  },
  {
    zip: "84320",
    ST: "UT",
    cityWithStateAbbr: "Lewiston, UT",
  },
  {
    zip: "84321",
    ST: "UT",
    cityWithStateAbbr: "Logan, UT",
  },
  {
    zip: "84322",
    ST: "UT",
    cityWithStateAbbr: "Logan, UT",
  },
  {
    zip: "84323",
    ST: "UT",
    cityWithStateAbbr: "Logan, UT",
  },
  {
    zip: "84324",
    ST: "UT",
    cityWithStateAbbr: "Mantua, UT",
  },
  {
    zip: "84325",
    ST: "UT",
    cityWithStateAbbr: "Mendon, UT",
  },
  {
    zip: "84326",
    ST: "UT",
    cityWithStateAbbr: "Millville, UT",
  },
  {
    zip: "84327",
    ST: "UT",
    cityWithStateAbbr: "Newton, UT",
  },
  {
    zip: "84328",
    ST: "UT",
    cityWithStateAbbr: "Paradise, UT",
  },
  {
    zip: "84329",
    ST: "UT",
    cityWithStateAbbr: "Park Valley, UT",
  },
  {
    zip: "84330",
    ST: "UT",
    cityWithStateAbbr: "Plymouth, UT",
  },
  {
    zip: "84331",
    ST: "UT",
    cityWithStateAbbr: "Portage, UT",
  },
  {
    zip: "84332",
    ST: "UT",
    cityWithStateAbbr: "Providence, UT",
  },
  {
    zip: "84333",
    ST: "UT",
    cityWithStateAbbr: "Richmond, UT",
  },
  {
    zip: "84334",
    ST: "UT",
    cityWithStateAbbr: "Riverside, UT",
  },
  {
    zip: "84335",
    ST: "UT",
    cityWithStateAbbr: "Smithfield, UT",
  },
  {
    zip: "84336",
    ST: "UT",
    cityWithStateAbbr: "Snowville, UT",
  },
  {
    zip: "84337",
    ST: "UT",
    cityWithStateAbbr: "Tremonton, UT",
  },
  {
    zip: "84338",
    ST: "UT",
    cityWithStateAbbr: "Trenton, UT",
  },
  {
    zip: "84339",
    ST: "UT",
    cityWithStateAbbr: "Wellsville, UT",
  },
  {
    zip: "84340",
    ST: "UT",
    cityWithStateAbbr: "Willard, UT",
  },
  {
    zip: "84341",
    ST: "UT",
    cityWithStateAbbr: "Logan, UT",
  },
  {
    zip: "84401",
    ST: "UT",
    cityWithStateAbbr: "Ogden, UT",
  },
  {
    zip: "84402",
    ST: "UT",
    cityWithStateAbbr: "Ogden, UT",
  },
  {
    zip: "84403",
    ST: "UT",
    cityWithStateAbbr: "Ogden, UT",
  },
  {
    zip: "84404",
    ST: "UT",
    cityWithStateAbbr: "Ogden, UT",
  },
  {
    zip: "84405",
    ST: "UT",
    cityWithStateAbbr: "Ogden, UT",
  },
  {
    zip: "84407",
    ST: "UT",
    cityWithStateAbbr: "Ogden, UT",
  },
  {
    zip: "84408",
    ST: "UT",
    cityWithStateAbbr: "Ogden, UT",
  },
  {
    zip: "84409",
    ST: "UT",
    cityWithStateAbbr: "Ogden, UT",
  },
  {
    zip: "84412",
    ST: "UT",
    cityWithStateAbbr: "Ogden, UT",
  },
  {
    zip: "84414",
    ST: "UT",
    cityWithStateAbbr: "Ogden, UT",
  },
  {
    zip: "84415",
    ST: "UT",
    cityWithStateAbbr: "Ogden, UT",
  },
  {
    zip: "84501",
    ST: "UT",
    cityWithStateAbbr: "Price, UT",
  },
  {
    zip: "84510",
    ST: "UT",
    cityWithStateAbbr: "Aneth, UT",
  },
  {
    zip: "84511",
    ST: "UT",
    cityWithStateAbbr: "Blanding, UT",
  },
  {
    zip: "84512",
    ST: "UT",
    cityWithStateAbbr: "Bluff, UT",
  },
  {
    zip: "84513",
    ST: "UT",
    cityWithStateAbbr: "Castle Dale, UT",
  },
  {
    zip: "84515",
    ST: "UT",
    cityWithStateAbbr: "Cisco, UT",
  },
  {
    zip: "84516",
    ST: "UT",
    cityWithStateAbbr: "Clawson, UT",
  },
  {
    zip: "84518",
    ST: "UT",
    cityWithStateAbbr: "Cleveland, UT",
  },
  {
    zip: "84520",
    ST: "UT",
    cityWithStateAbbr: "East Carbon, UT",
  },
  {
    zip: "84521",
    ST: "UT",
    cityWithStateAbbr: "Elmo, UT",
  },
  {
    zip: "84522",
    ST: "UT",
    cityWithStateAbbr: "Emery, UT",
  },
  {
    zip: "84523",
    ST: "UT",
    cityWithStateAbbr: "Ferron, UT",
  },
  {
    zip: "84525",
    ST: "UT",
    cityWithStateAbbr: "Green River, UT",
  },
  {
    zip: "84526",
    ST: "UT",
    cityWithStateAbbr: "Helper, UT",
  },
  {
    zip: "84528",
    ST: "UT",
    cityWithStateAbbr: "Huntington, UT",
  },
  {
    zip: "84529",
    ST: "UT",
    cityWithStateAbbr: "Kenilworth, UT",
  },
  {
    zip: "84530",
    ST: "UT",
    cityWithStateAbbr: "La Sal, UT",
  },
  {
    zip: "84531",
    ST: "UT",
    cityWithStateAbbr: "Mexican Hat, UT",
  },
  {
    zip: "84532",
    ST: "UT",
    cityWithStateAbbr: "Moab, UT",
  },
  {
    zip: "84533",
    ST: "UT",
    cityWithStateAbbr: "Lake Powell, UT",
  },
  {
    zip: "84534",
    ST: "UT",
    cityWithStateAbbr: "Montezuma Creek, UT",
  },
  {
    zip: "84535",
    ST: "UT",
    cityWithStateAbbr: "Monticello, UT",
  },
  {
    zip: "84536",
    ST: "UT",
    cityWithStateAbbr: "Monument Valley, UT",
  },
  {
    zip: "84537",
    ST: "UT",
    cityWithStateAbbr: "Orangeville, UT",
  },
  {
    zip: "84539",
    ST: "UT",
    cityWithStateAbbr: "Sunnyside, UT",
  },
  {
    zip: "84540",
    ST: "UT",
    cityWithStateAbbr: "Thompson, UT",
  },
  {
    zip: "84542",
    ST: "UT",
    cityWithStateAbbr: "Wellington, UT",
  },
  {
    zip: "84601",
    ST: "UT",
    cityWithStateAbbr: "Provo, UT",
  },
  {
    zip: "84602",
    ST: "UT",
    cityWithStateAbbr: "Provo, UT",
  },
  {
    zip: "84603",
    ST: "UT",
    cityWithStateAbbr: "Provo, UT",
  },
  {
    zip: "84604",
    ST: "UT",
    cityWithStateAbbr: "Provo, UT",
  },
  {
    zip: "84605",
    ST: "UT",
    cityWithStateAbbr: "Provo, UT",
  },
  {
    zip: "84606",
    ST: "UT",
    cityWithStateAbbr: "Provo, UT",
  },
  {
    zip: "84620",
    ST: "UT",
    cityWithStateAbbr: "Aurora, UT",
  },
  {
    zip: "84621",
    ST: "UT",
    cityWithStateAbbr: "Axtell, UT",
  },
  {
    zip: "84622",
    ST: "UT",
    cityWithStateAbbr: "Centerfield, UT",
  },
  {
    zip: "84623",
    ST: "UT",
    cityWithStateAbbr: "Chester, UT",
  },
  {
    zip: "84624",
    ST: "UT",
    cityWithStateAbbr: "Delta, UT",
  },
  {
    zip: "84626",
    ST: "UT",
    cityWithStateAbbr: "Elberta, UT",
  },
  {
    zip: "84627",
    ST: "UT",
    cityWithStateAbbr: "Ephraim, UT",
  },
  {
    zip: "84628",
    ST: "UT",
    cityWithStateAbbr: "Eureka, UT",
  },
  {
    zip: "84629",
    ST: "UT",
    cityWithStateAbbr: "Fairview, UT",
  },
  {
    zip: "84630",
    ST: "UT",
    cityWithStateAbbr: "Fayette, UT",
  },
  {
    zip: "84631",
    ST: "UT",
    cityWithStateAbbr: "Fillmore, UT",
  },
  {
    zip: "84632",
    ST: "UT",
    cityWithStateAbbr: "Fountain Green, UT",
  },
  {
    zip: "84633",
    ST: "UT",
    cityWithStateAbbr: "Goshen, UT",
  },
  {
    zip: "84634",
    ST: "UT",
    cityWithStateAbbr: "Gunnison, UT",
  },
  {
    zip: "84635",
    ST: "UT",
    cityWithStateAbbr: "Hinckley, UT",
  },
  {
    zip: "84636",
    ST: "UT",
    cityWithStateAbbr: "Holden, UT",
  },
  {
    zip: "84637",
    ST: "UT",
    cityWithStateAbbr: "Kanosh, UT",
  },
  {
    zip: "84638",
    ST: "UT",
    cityWithStateAbbr: "Leamington, UT",
  },
  {
    zip: "84639",
    ST: "UT",
    cityWithStateAbbr: "Levan, UT",
  },
  {
    zip: "84640",
    ST: "UT",
    cityWithStateAbbr: "Lynndyl, UT",
  },
  {
    zip: "84642",
    ST: "UT",
    cityWithStateAbbr: "Manti, UT",
  },
  {
    zip: "84643",
    ST: "UT",
    cityWithStateAbbr: "Mayfield, UT",
  },
  {
    zip: "84644",
    ST: "UT",
    cityWithStateAbbr: "Meadow, UT",
  },
  {
    zip: "84645",
    ST: "UT",
    cityWithStateAbbr: "Mona, UT",
  },
  {
    zip: "84646",
    ST: "UT",
    cityWithStateAbbr: "Moroni, UT",
  },
  {
    zip: "84647",
    ST: "UT",
    cityWithStateAbbr: "Mount Pleasant, UT",
  },
  {
    zip: "84648",
    ST: "UT",
    cityWithStateAbbr: "Nephi, UT",
  },
  {
    zip: "84649",
    ST: "UT",
    cityWithStateAbbr: "Oak City, UT",
  },
  {
    zip: "84651",
    ST: "UT",
    cityWithStateAbbr: "Payson, UT",
  },
  {
    zip: "84652",
    ST: "UT",
    cityWithStateAbbr: "Redmond, UT",
  },
  {
    zip: "84653",
    ST: "UT",
    cityWithStateAbbr: "Salem, UT",
  },
  {
    zip: "84654",
    ST: "UT",
    cityWithStateAbbr: "Salina, UT",
  },
  {
    zip: "84655",
    ST: "UT",
    cityWithStateAbbr: "Santaquin, UT",
  },
  {
    zip: "84656",
    ST: "UT",
    cityWithStateAbbr: "Scipio, UT",
  },
  {
    zip: "84657",
    ST: "UT",
    cityWithStateAbbr: "Sigurd, UT",
  },
  {
    zip: "84660",
    ST: "UT",
    cityWithStateAbbr: "Spanish Fork, UT",
  },
  {
    zip: "84662",
    ST: "UT",
    cityWithStateAbbr: "Spring City, UT",
  },
  {
    zip: "84663",
    ST: "UT",
    cityWithStateAbbr: "Springville, UT",
  },
  {
    zip: "84664",
    ST: "UT",
    cityWithStateAbbr: "Mapleton, UT",
  },
  {
    zip: "84665",
    ST: "UT",
    cityWithStateAbbr: "Sterling, UT",
  },
  {
    zip: "84667",
    ST: "UT",
    cityWithStateAbbr: "Wales, UT",
  },
  {
    zip: "84701",
    ST: "UT",
    cityWithStateAbbr: "Richfield, UT",
  },
  {
    zip: "84710",
    ST: "UT",
    cityWithStateAbbr: "Alton, UT",
  },
  {
    zip: "84711",
    ST: "UT",
    cityWithStateAbbr: "Annabella, UT",
  },
  {
    zip: "84712",
    ST: "UT",
    cityWithStateAbbr: "Antimony, UT",
  },
  {
    zip: "84713",
    ST: "UT",
    cityWithStateAbbr: "Beaver, UT",
  },
  {
    zip: "84714",
    ST: "UT",
    cityWithStateAbbr: "Beryl, UT",
  },
  {
    zip: "84715",
    ST: "UT",
    cityWithStateAbbr: "Bicknell, UT",
  },
  {
    zip: "84716",
    ST: "UT",
    cityWithStateAbbr: "Boulder, UT",
  },
  {
    zip: "84718",
    ST: "UT",
    cityWithStateAbbr: "Cannonville, UT",
  },
  {
    zip: "84719",
    ST: "UT",
    cityWithStateAbbr: "Brian Head, UT",
  },
  {
    zip: "84720",
    ST: "UT",
    cityWithStateAbbr: "Cedar City, UT",
  },
  {
    zip: "84721",
    ST: "UT",
    cityWithStateAbbr: "Cedar City, UT",
  },
  {
    zip: "84722",
    ST: "UT",
    cityWithStateAbbr: "Central, UT",
  },
  {
    zip: "84723",
    ST: "UT",
    cityWithStateAbbr: "Circleville, UT",
  },
  {
    zip: "84724",
    ST: "UT",
    cityWithStateAbbr: "Elsinore, UT",
  },
  {
    zip: "84725",
    ST: "UT",
    cityWithStateAbbr: "Enterprise, UT",
  },
  {
    zip: "84726",
    ST: "UT",
    cityWithStateAbbr: "Escalante, UT",
  },
  {
    zip: "84728",
    ST: "UT",
    cityWithStateAbbr: "Garrison, UT",
  },
  {
    zip: "84729",
    ST: "UT",
    cityWithStateAbbr: "Glendale, UT",
  },
  {
    zip: "84730",
    ST: "UT",
    cityWithStateAbbr: "Glenwood, UT",
  },
  {
    zip: "84731",
    ST: "UT",
    cityWithStateAbbr: "Greenville, UT",
  },
  {
    zip: "84732",
    ST: "UT",
    cityWithStateAbbr: "Greenwich, UT",
  },
  {
    zip: "84733",
    ST: "UT",
    cityWithStateAbbr: "Gunlock, UT",
  },
  {
    zip: "84734",
    ST: "UT",
    cityWithStateAbbr: "Hanksville, UT",
  },
  {
    zip: "84735",
    ST: "UT",
    cityWithStateAbbr: "Hatch, UT",
  },
  {
    zip: "84736",
    ST: "UT",
    cityWithStateAbbr: "Henrieville, UT",
  },
  {
    zip: "84737",
    ST: "UT",
    cityWithStateAbbr: "Hurricane, UT",
  },
  {
    zip: "84738",
    ST: "UT",
    cityWithStateAbbr: "Ivins, UT",
  },
  {
    zip: "84739",
    ST: "UT",
    cityWithStateAbbr: "Joseph, UT",
  },
  {
    zip: "84740",
    ST: "UT",
    cityWithStateAbbr: "Junction, UT",
  },
  {
    zip: "84741",
    ST: "UT",
    cityWithStateAbbr: "Kanab, UT",
  },
  {
    zip: "84742",
    ST: "UT",
    cityWithStateAbbr: "Kanarraville, UT",
  },
  {
    zip: "84743",
    ST: "UT",
    cityWithStateAbbr: "Kingston, UT",
  },
  {
    zip: "84744",
    ST: "UT",
    cityWithStateAbbr: "Koosharem, UT",
  },
  {
    zip: "84745",
    ST: "UT",
    cityWithStateAbbr: "La Verkin, UT",
  },
  {
    zip: "84746",
    ST: "UT",
    cityWithStateAbbr: "Leeds, UT",
  },
  {
    zip: "84747",
    ST: "UT",
    cityWithStateAbbr: "Loa, UT",
  },
  {
    zip: "84749",
    ST: "UT",
    cityWithStateAbbr: "Lyman, UT",
  },
  {
    zip: "84750",
    ST: "UT",
    cityWithStateAbbr: "Marysvale, UT",
  },
  {
    zip: "84751",
    ST: "UT",
    cityWithStateAbbr: "Milford, UT",
  },
  {
    zip: "84752",
    ST: "UT",
    cityWithStateAbbr: "Minersville, UT",
  },
  {
    zip: "84753",
    ST: "UT",
    cityWithStateAbbr: "Modena, UT",
  },
  {
    zip: "84754",
    ST: "UT",
    cityWithStateAbbr: "Monroe, UT",
  },
  {
    zip: "84755",
    ST: "UT",
    cityWithStateAbbr: "Mount Carmel, UT",
  },
  {
    zip: "84756",
    ST: "UT",
    cityWithStateAbbr: "Newcastle, UT",
  },
  {
    zip: "84757",
    ST: "UT",
    cityWithStateAbbr: "New Harmony, UT",
  },
  {
    zip: "84758",
    ST: "UT",
    cityWithStateAbbr: "Orderville, UT",
  },
  {
    zip: "84759",
    ST: "UT",
    cityWithStateAbbr: "Panguitch, UT",
  },
  {
    zip: "84760",
    ST: "UT",
    cityWithStateAbbr: "Paragonah, UT",
  },
  {
    zip: "84761",
    ST: "UT",
    cityWithStateAbbr: "Parowan, UT",
  },
  {
    zip: "84762",
    ST: "UT",
    cityWithStateAbbr: "Duck Creek Village, UT",
  },
  {
    zip: "84763",
    ST: "UT",
    cityWithStateAbbr: "Rockville, UT",
  },
  {
    zip: "84764",
    ST: "UT",
    cityWithStateAbbr: "Bryce, UT",
  },
  {
    zip: "84765",
    ST: "UT",
    cityWithStateAbbr: "Santa Clara, UT",
  },
  {
    zip: "84766",
    ST: "UT",
    cityWithStateAbbr: "Sevier, UT",
  },
  {
    zip: "84767",
    ST: "UT",
    cityWithStateAbbr: "Springdale, UT",
  },
  {
    zip: "84770",
    ST: "UT",
    cityWithStateAbbr: "Saint George, UT",
  },
  {
    zip: "84771",
    ST: "UT",
    cityWithStateAbbr: "Saint George, UT",
  },
  {
    zip: "84772",
    ST: "UT",
    cityWithStateAbbr: "Summit, UT",
  },
  {
    zip: "84773",
    ST: "UT",
    cityWithStateAbbr: "Teasdale, UT",
  },
  {
    zip: "84774",
    ST: "UT",
    cityWithStateAbbr: "Toquerville, UT",
  },
  {
    zip: "84775",
    ST: "UT",
    cityWithStateAbbr: "Torrey, UT",
  },
  {
    zip: "84776",
    ST: "UT",
    cityWithStateAbbr: "Tropic, UT",
  },
  {
    zip: "84779",
    ST: "UT",
    cityWithStateAbbr: "Virgin, UT",
  },
  {
    zip: "84780",
    ST: "UT",
    cityWithStateAbbr: "Washington, UT",
  },
  {
    zip: "84781",
    ST: "UT",
    cityWithStateAbbr: "Pine Valley, UT",
  },
  {
    zip: "84782",
    ST: "UT",
    cityWithStateAbbr: "Veyo, UT",
  },
  {
    zip: "84783",
    ST: "UT",
    cityWithStateAbbr: "Dammeron Valley, UT",
  },
  {
    zip: "84784",
    ST: "AZ",
    cityWithStateAbbr: "Hildale, AZ",
  },
  {
    zip: "84790",
    ST: "UT",
    cityWithStateAbbr: "Saint George, UT",
  },
  {
    zip: "84791",
    ST: "UT",
    cityWithStateAbbr: "Saint George, UT",
  },
  {
    zip: "85001",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85002",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85003",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85004",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85005",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85006",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85007",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85008",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85009",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85010",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85011",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85012",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85013",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85014",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85015",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85016",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85017",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85018",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85019",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85020",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85021",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85022",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85023",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85024",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85025",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85026",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85027",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85028",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85029",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85030",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85031",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85032",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85033",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85034",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85035",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85036",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85037",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85038",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85039",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85040",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85041",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85042",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85043",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85044",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85045",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85046",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85048",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85050",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85051",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85053",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85054",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85055",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85060",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85061",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85062",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85063",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85064",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85065",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85066",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85067",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85068",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85069",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85070",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85071",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85072",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85073",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85074",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85075",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85076",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85078",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85079",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85080",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85082",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85083",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85085",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85086",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85087",
    ST: "AZ",
    cityWithStateAbbr: "New River, AZ",
  },
  {
    zip: "85097",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85098",
    ST: "AZ",
    cityWithStateAbbr: "Phoenix, AZ",
  },
  {
    zip: "85117",
    ST: "AZ",
    cityWithStateAbbr: "Apache Junction, AZ",
  },
  {
    zip: "85118",
    ST: "AZ",
    cityWithStateAbbr: "Gold Canyon, AZ",
  },
  {
    zip: "85119",
    ST: "AZ",
    cityWithStateAbbr: "Apache Junction, AZ",
  },
  {
    zip: "85120",
    ST: "AZ",
    cityWithStateAbbr: "Apache Junction, AZ",
  },
  {
    zip: "85121",
    ST: "AZ",
    cityWithStateAbbr: "Bapchule, AZ",
  },
  {
    zip: "85122",
    ST: "AZ",
    cityWithStateAbbr: "Casa Grande, AZ",
  },
  {
    zip: "85123",
    ST: "AZ",
    cityWithStateAbbr: "Arizona City, AZ",
  },
  {
    zip: "85128",
    ST: "AZ",
    cityWithStateAbbr: "Coolidge, AZ",
  },
  {
    zip: "85130",
    ST: "AZ",
    cityWithStateAbbr: "Casa Grande, AZ",
  },
  {
    zip: "85131",
    ST: "AZ",
    cityWithStateAbbr: "Eloy, AZ",
  },
  {
    zip: "85132",
    ST: "AZ",
    cityWithStateAbbr: "Florence, AZ",
  },
  {
    zip: "85135",
    ST: "AZ",
    cityWithStateAbbr: "Hayden, AZ",
  },
  {
    zip: "85137",
    ST: "AZ",
    cityWithStateAbbr: "Kearny, AZ",
  },
  {
    zip: "85138",
    ST: "AZ",
    cityWithStateAbbr: "Maricopa, AZ",
  },
  {
    zip: "85139",
    ST: "AZ",
    cityWithStateAbbr: "Maricopa, AZ",
  },
  {
    zip: "85140",
    ST: "AZ",
    cityWithStateAbbr: "San Tan Valley, AZ",
  },
  {
    zip: "85141",
    ST: "AZ",
    cityWithStateAbbr: "Picacho, AZ",
  },
  {
    zip: "85142",
    ST: "AZ",
    cityWithStateAbbr: "Queen Creek, AZ",
  },
  {
    zip: "85143",
    ST: "AZ",
    cityWithStateAbbr: "San Tan Valley, AZ",
  },
  {
    zip: "85145",
    ST: "AZ",
    cityWithStateAbbr: "Red Rock, AZ",
  },
  {
    zip: "85147",
    ST: "AZ",
    cityWithStateAbbr: "Sacaton, AZ",
  },
  {
    zip: "85172",
    ST: "AZ",
    cityWithStateAbbr: "Stanfield, AZ",
  },
  {
    zip: "85173",
    ST: "AZ",
    cityWithStateAbbr: "Superior, AZ",
  },
  {
    zip: "85178",
    ST: "AZ",
    cityWithStateAbbr: "Apache Junction, AZ",
  },
  {
    zip: "85190",
    ST: "AZ",
    cityWithStateAbbr: "Tortilla Flat, AZ",
  },
  {
    zip: "85191",
    ST: "AZ",
    cityWithStateAbbr: "Valley Farms, AZ",
  },
  {
    zip: "85192",
    ST: "AZ",
    cityWithStateAbbr: "Winkelman, AZ",
  },
  {
    zip: "85193",
    ST: "AZ",
    cityWithStateAbbr: "Casa Grande, AZ",
  },
  {
    zip: "85194",
    ST: "AZ",
    cityWithStateAbbr: "Casa Grande, AZ",
  },
  {
    zip: "85201",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85202",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85203",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85204",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85205",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85206",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85207",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85208",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85209",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85210",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85211",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85212",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85213",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85214",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85215",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85216",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85217",
    ST: "AZ",
    cityWithStateAbbr: "Apache Junction, AZ",
  },
  {
    zip: "85218",
    ST: "AZ",
    cityWithStateAbbr: "Apache Junction, AZ",
  },
  {
    zip: "85219",
    ST: "AZ",
    cityWithStateAbbr: "Apache Junction, AZ",
  },
  {
    zip: "85220",
    ST: "AZ",
    cityWithStateAbbr: "Apache Junction, AZ",
  },
  {
    zip: "85221",
    ST: "AZ",
    cityWithStateAbbr: "Casa Grande, AZ",
  },
  {
    zip: "85222",
    ST: "AZ",
    cityWithStateAbbr: "Casa Grande, AZ",
  },
  {
    zip: "85223",
    ST: "AZ",
    cityWithStateAbbr: "Arizona City, AZ",
  },
  {
    zip: "85224",
    ST: "AZ",
    cityWithStateAbbr: "Chandler, AZ",
  },
  {
    zip: "85225",
    ST: "AZ",
    cityWithStateAbbr: "Chandler, AZ",
  },
  {
    zip: "85226",
    ST: "AZ",
    cityWithStateAbbr: "Chandler, AZ",
  },
  {
    zip: "85228",
    ST: "AZ",
    cityWithStateAbbr: "Coolidge, AZ",
  },
  {
    zip: "85230",
    ST: "AZ",
    cityWithStateAbbr: "Casa Grande, AZ",
  },
  {
    zip: "85231",
    ST: "AZ",
    cityWithStateAbbr: "Eloy, AZ",
  },
  {
    zip: "85232",
    ST: "AZ",
    cityWithStateAbbr: "Florence, AZ",
  },
  {
    zip: "85233",
    ST: "AZ",
    cityWithStateAbbr: "Gilbert, AZ",
  },
  {
    zip: "85234",
    ST: "AZ",
    cityWithStateAbbr: "Gilbert, AZ",
  },
  {
    zip: "85235",
    ST: "AZ",
    cityWithStateAbbr: "Winkelman, AZ",
  },
  {
    zip: "85236",
    ST: "AZ",
    cityWithStateAbbr: "Higley, AZ",
  },
  {
    zip: "85237",
    ST: "AZ",
    cityWithStateAbbr: "Kearny, AZ",
  },
  {
    zip: "85238",
    ST: "AZ",
    cityWithStateAbbr: "Maricopa, AZ",
  },
  {
    zip: "85239",
    ST: "AZ",
    cityWithStateAbbr: "Maricopa, AZ",
  },
  {
    zip: "85240",
    ST: "AZ",
    cityWithStateAbbr: "Queen Creek, AZ",
  },
  {
    zip: "85241",
    ST: "AZ",
    cityWithStateAbbr: "Eloy, AZ",
  },
  {
    zip: "85242",
    ST: "AZ",
    cityWithStateAbbr: "Queen Creek, AZ",
  },
  {
    zip: "85243",
    ST: "AZ",
    cityWithStateAbbr: "Queen Creek, AZ",
  },
  {
    zip: "85244",
    ST: "AZ",
    cityWithStateAbbr: "Chandler, AZ",
  },
  {
    zip: "85245",
    ST: "AZ",
    cityWithStateAbbr: "Red Rock, AZ",
  },
  {
    zip: "85246",
    ST: "AZ",
    cityWithStateAbbr: "Chandler, AZ",
  },
  {
    zip: "85247",
    ST: "AZ",
    cityWithStateAbbr: "Chandler, AZ",
  },
  {
    zip: "85248",
    ST: "AZ",
    cityWithStateAbbr: "Chandler, AZ",
  },
  {
    zip: "85249",
    ST: "AZ",
    cityWithStateAbbr: "Chandler, AZ",
  },
  {
    zip: "85250",
    ST: "AZ",
    cityWithStateAbbr: "Scottsdale, AZ",
  },
  {
    zip: "85251",
    ST: "AZ",
    cityWithStateAbbr: "Scottsdale, AZ",
  },
  {
    zip: "85252",
    ST: "AZ",
    cityWithStateAbbr: "Scottsdale, AZ",
  },
  {
    zip: "85253",
    ST: "AZ",
    cityWithStateAbbr: "Paradise Valley, AZ",
  },
  {
    zip: "85254",
    ST: "AZ",
    cityWithStateAbbr: "Scottsdale, AZ",
  },
  {
    zip: "85255",
    ST: "AZ",
    cityWithStateAbbr: "Scottsdale, AZ",
  },
  {
    zip: "85256",
    ST: "AZ",
    cityWithStateAbbr: "Scottsdale, AZ",
  },
  {
    zip: "85257",
    ST: "AZ",
    cityWithStateAbbr: "Scottsdale, AZ",
  },
  {
    zip: "85258",
    ST: "AZ",
    cityWithStateAbbr: "Scottsdale, AZ",
  },
  {
    zip: "85259",
    ST: "AZ",
    cityWithStateAbbr: "Scottsdale, AZ",
  },
  {
    zip: "85260",
    ST: "AZ",
    cityWithStateAbbr: "Scottsdale, AZ",
  },
  {
    zip: "85261",
    ST: "AZ",
    cityWithStateAbbr: "Scottsdale, AZ",
  },
  {
    zip: "85262",
    ST: "AZ",
    cityWithStateAbbr: "Scottsdale, AZ",
  },
  {
    zip: "85263",
    ST: "AZ",
    cityWithStateAbbr: "Rio Verde, AZ",
  },
  {
    zip: "85264",
    ST: "AZ",
    cityWithStateAbbr: "Fort Mcdowell, AZ",
  },
  {
    zip: "85266",
    ST: "AZ",
    cityWithStateAbbr: "Scottsdale, AZ",
  },
  {
    zip: "85267",
    ST: "AZ",
    cityWithStateAbbr: "Scottsdale, AZ",
  },
  {
    zip: "85268",
    ST: "AZ",
    cityWithStateAbbr: "Fountain Hills, AZ",
  },
  {
    zip: "85269",
    ST: "AZ",
    cityWithStateAbbr: "Fountain Hills, AZ",
  },
  {
    zip: "85271",
    ST: "AZ",
    cityWithStateAbbr: "Scottsdale, AZ",
  },
  {
    zip: "85272",
    ST: "AZ",
    cityWithStateAbbr: "Stanfield, AZ",
  },
  {
    zip: "85273",
    ST: "AZ",
    cityWithStateAbbr: "Superior, AZ",
  },
  {
    zip: "85274",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85275",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85277",
    ST: "AZ",
    cityWithStateAbbr: "Mesa, AZ",
  },
  {
    zip: "85280",
    ST: "AZ",
    cityWithStateAbbr: "Tempe, AZ",
  },
  {
    zip: "85281",
    ST: "AZ",
    cityWithStateAbbr: "Tempe, AZ",
  },
  {
    zip: "85282",
    ST: "AZ",
    cityWithStateAbbr: "Tempe, AZ",
  },
  {
    zip: "85283",
    ST: "AZ",
    cityWithStateAbbr: "Tempe, AZ",
  },
  {
    zip: "85284",
    ST: "AZ",
    cityWithStateAbbr: "Tempe, AZ",
  },
  {
    zip: "85285",
    ST: "AZ",
    cityWithStateAbbr: "Tempe, AZ",
  },
  {
    zip: "85286",
    ST: "AZ",
    cityWithStateAbbr: "Chandler, AZ",
  },
  {
    zip: "85287",
    ST: "AZ",
    cityWithStateAbbr: "Tempe, AZ",
  },
  {
    zip: "85291",
    ST: "AZ",
    cityWithStateAbbr: "Coolidge, AZ",
  },
  {
    zip: "85292",
    ST: "AZ",
    cityWithStateAbbr: "Winkelman, AZ",
  },
  {
    zip: "85293",
    ST: "AZ",
    cityWithStateAbbr: "Casa Grande, AZ",
  },
  {
    zip: "85294",
    ST: "AZ",
    cityWithStateAbbr: "Casa Grande, AZ",
  },
  {
    zip: "85295",
    ST: "AZ",
    cityWithStateAbbr: "Gilbert, AZ",
  },
  {
    zip: "85296",
    ST: "AZ",
    cityWithStateAbbr: "Gilbert, AZ",
  },
  {
    zip: "85297",
    ST: "AZ",
    cityWithStateAbbr: "Gilbert, AZ",
  },
  {
    zip: "85298",
    ST: "AZ",
    cityWithStateAbbr: "Gilbert, AZ",
  },
  {
    zip: "85299",
    ST: "AZ",
    cityWithStateAbbr: "Gilbert, AZ",
  },
  {
    zip: "85301",
    ST: "AZ",
    cityWithStateAbbr: "Glendale, AZ",
  },
  {
    zip: "85302",
    ST: "AZ",
    cityWithStateAbbr: "Glendale, AZ",
  },
  {
    zip: "85303",
    ST: "AZ",
    cityWithStateAbbr: "Glendale, AZ",
  },
  {
    zip: "85304",
    ST: "AZ",
    cityWithStateAbbr: "Glendale, AZ",
  },
  {
    zip: "85305",
    ST: "AZ",
    cityWithStateAbbr: "Glendale, AZ",
  },
  {
    zip: "85306",
    ST: "AZ",
    cityWithStateAbbr: "Glendale, AZ",
  },
  {
    zip: "85307",
    ST: "AZ",
    cityWithStateAbbr: "Glendale, AZ",
  },
  {
    zip: "85308",
    ST: "AZ",
    cityWithStateAbbr: "Glendale, AZ",
  },
  {
    zip: "85309",
    ST: "AZ",
    cityWithStateAbbr: "Luke Air Force Base, AZ",
  },
  {
    zip: "85310",
    ST: "AZ",
    cityWithStateAbbr: "Glendale, AZ",
  },
  {
    zip: "85311",
    ST: "AZ",
    cityWithStateAbbr: "Glendale, AZ",
  },
  {
    zip: "85312",
    ST: "AZ",
    cityWithStateAbbr: "Glendale, AZ",
  },
  {
    zip: "85318",
    ST: "AZ",
    cityWithStateAbbr: "Glendale, AZ",
  },
  {
    zip: "85320",
    ST: "AZ",
    cityWithStateAbbr: "Aguila, AZ",
  },
  {
    zip: "85321",
    ST: "AZ",
    cityWithStateAbbr: "Ajo, AZ",
  },
  {
    zip: "85322",
    ST: "AZ",
    cityWithStateAbbr: "Arlington, AZ",
  },
  {
    zip: "85323",
    ST: "AZ",
    cityWithStateAbbr: "Avondale, AZ",
  },
  {
    zip: "85324",
    ST: "AZ",
    cityWithStateAbbr: "Black Canyon City, AZ",
  },
  {
    zip: "85325",
    ST: "AZ",
    cityWithStateAbbr: "Bouse, AZ",
  },
  {
    zip: "85326",
    ST: "AZ",
    cityWithStateAbbr: "Buckeye, AZ",
  },
  {
    zip: "85327",
    ST: "AZ",
    cityWithStateAbbr: "Cave Creek, AZ",
  },
  {
    zip: "85328",
    ST: "AZ",
    cityWithStateAbbr: "Cibola, AZ",
  },
  {
    zip: "85329",
    ST: "AZ",
    cityWithStateAbbr: "Cashion, AZ",
  },
  {
    zip: "85331",
    ST: "AZ",
    cityWithStateAbbr: "Cave Creek, AZ",
  },
  {
    zip: "85332",
    ST: "AZ",
    cityWithStateAbbr: "Congress, AZ",
  },
  {
    zip: "85333",
    ST: "AZ",
    cityWithStateAbbr: "Dateland, AZ",
  },
  {
    zip: "85334",
    ST: "AZ",
    cityWithStateAbbr: "Ehrenberg, AZ",
  },
  {
    zip: "85335",
    ST: "AZ",
    cityWithStateAbbr: "El Mirage, AZ",
  },
  {
    zip: "85336",
    ST: "AZ",
    cityWithStateAbbr: "Gadsden, AZ",
  },
  {
    zip: "85337",
    ST: "AZ",
    cityWithStateAbbr: "Gila Bend, AZ",
  },
  {
    zip: "85338",
    ST: "AZ",
    cityWithStateAbbr: "Goodyear, AZ",
  },
  {
    zip: "85339",
    ST: "AZ",
    cityWithStateAbbr: "Laveen, AZ",
  },
  {
    zip: "85340",
    ST: "AZ",
    cityWithStateAbbr: "Litchfield Park, AZ",
  },
  {
    zip: "85341",
    ST: "AZ",
    cityWithStateAbbr: "Lukeville, AZ",
  },
  {
    zip: "85342",
    ST: "AZ",
    cityWithStateAbbr: "Morristown, AZ",
  },
  {
    zip: "85343",
    ST: "AZ",
    cityWithStateAbbr: "Palo Verde, AZ",
  },
  {
    zip: "85344",
    ST: "AZ",
    cityWithStateAbbr: "Parker, AZ",
  },
  {
    zip: "85345",
    ST: "AZ",
    cityWithStateAbbr: "Peoria, AZ",
  },
  {
    zip: "85346",
    ST: "AZ",
    cityWithStateAbbr: "Quartzsite, AZ",
  },
  {
    zip: "85347",
    ST: "AZ",
    cityWithStateAbbr: "Roll, AZ",
  },
  {
    zip: "85348",
    ST: "AZ",
    cityWithStateAbbr: "Salome, AZ",
  },
  {
    zip: "85349",
    ST: "AZ",
    cityWithStateAbbr: "San Luis, AZ",
  },
  {
    zip: "85350",
    ST: "AZ",
    cityWithStateAbbr: "Somerton, AZ",
  },
  {
    zip: "85351",
    ST: "AZ",
    cityWithStateAbbr: "Sun City, AZ",
  },
  {
    zip: "85352",
    ST: "AZ",
    cityWithStateAbbr: "Tacna, AZ",
  },
  {
    zip: "85353",
    ST: "AZ",
    cityWithStateAbbr: "Tolleson, AZ",
  },
  {
    zip: "85354",
    ST: "AZ",
    cityWithStateAbbr: "Tonopah, AZ",
  },
  {
    zip: "85355",
    ST: "AZ",
    cityWithStateAbbr: "Waddell, AZ",
  },
  {
    zip: "85356",
    ST: "AZ",
    cityWithStateAbbr: "Wellton, AZ",
  },
  {
    zip: "85357",
    ST: "AZ",
    cityWithStateAbbr: "Wenden, AZ",
  },
  {
    zip: "85358",
    ST: "AZ",
    cityWithStateAbbr: "Wickenburg, AZ",
  },
  {
    zip: "85359",
    ST: "AZ",
    cityWithStateAbbr: "Quartzsite, AZ",
  },
  {
    zip: "85360",
    ST: "AZ",
    cityWithStateAbbr: "Wikieup, AZ",
  },
  {
    zip: "85361",
    ST: "AZ",
    cityWithStateAbbr: "Wittmann, AZ",
  },
  {
    zip: "85362",
    ST: "AZ",
    cityWithStateAbbr: "Yarnell, AZ",
  },
  {
    zip: "85363",
    ST: "AZ",
    cityWithStateAbbr: "Youngtown, AZ",
  },
  {
    zip: "85364",
    ST: "AZ",
    cityWithStateAbbr: "Yuma, AZ",
  },
  {
    zip: "85365",
    ST: "AZ",
    cityWithStateAbbr: "Yuma, AZ",
  },
  {
    zip: "85366",
    ST: "AZ",
    cityWithStateAbbr: "Yuma, AZ",
  },
  {
    zip: "85367",
    ST: "AZ",
    cityWithStateAbbr: "Yuma, AZ",
  },
  {
    zip: "85369",
    ST: "CA",
    cityWithStateAbbr: "Yuma, CA",
  },
  {
    zip: "85371",
    ST: "AZ",
    cityWithStateAbbr: "Poston, AZ",
  },
  {
    zip: "85372",
    ST: "AZ",
    cityWithStateAbbr: "Sun City, AZ",
  },
  {
    zip: "85373",
    ST: "AZ",
    cityWithStateAbbr: "Sun City, AZ",
  },
  {
    zip: "85374",
    ST: "AZ",
    cityWithStateAbbr: "Surprise, AZ",
  },
  {
    zip: "85375",
    ST: "AZ",
    cityWithStateAbbr: "Sun City West, AZ",
  },
  {
    zip: "85376",
    ST: "AZ",
    cityWithStateAbbr: "Sun City West, AZ",
  },
  {
    zip: "85377",
    ST: "AZ",
    cityWithStateAbbr: "Carefree, AZ",
  },
  {
    zip: "85378",
    ST: "AZ",
    cityWithStateAbbr: "Surprise, AZ",
  },
  {
    zip: "85379",
    ST: "AZ",
    cityWithStateAbbr: "Surprise, AZ",
  },
  {
    zip: "85380",
    ST: "AZ",
    cityWithStateAbbr: "Peoria, AZ",
  },
  {
    zip: "85381",
    ST: "AZ",
    cityWithStateAbbr: "Peoria, AZ",
  },
  {
    zip: "85382",
    ST: "AZ",
    cityWithStateAbbr: "Peoria, AZ",
  },
  {
    zip: "85383",
    ST: "AZ",
    cityWithStateAbbr: "Peoria, AZ",
  },
  {
    zip: "85385",
    ST: "AZ",
    cityWithStateAbbr: "Peoria, AZ",
  },
  {
    zip: "85387",
    ST: "AZ",
    cityWithStateAbbr: "Surprise, AZ",
  },
  {
    zip: "85388",
    ST: "AZ",
    cityWithStateAbbr: "Surprise, AZ",
  },
  {
    zip: "85390",
    ST: "AZ",
    cityWithStateAbbr: "Wickenburg, AZ",
  },
  {
    zip: "85392",
    ST: "AZ",
    cityWithStateAbbr: "Avondale, AZ",
  },
  {
    zip: "85395",
    ST: "AZ",
    cityWithStateAbbr: "Goodyear, AZ",
  },
  {
    zip: "85396",
    ST: "AZ",
    cityWithStateAbbr: "Buckeye, AZ",
  },
  {
    zip: "85501",
    ST: "AZ",
    cityWithStateAbbr: "Globe, AZ",
  },
  {
    zip: "85502",
    ST: "AZ",
    cityWithStateAbbr: "Globe, AZ",
  },
  {
    zip: "85530",
    ST: "AZ",
    cityWithStateAbbr: "Bylas, AZ",
  },
  {
    zip: "85531",
    ST: "AZ",
    cityWithStateAbbr: "Central, AZ",
  },
  {
    zip: "85532",
    ST: "AZ",
    cityWithStateAbbr: "Claypool, AZ",
  },
  {
    zip: "85533",
    ST: "AZ",
    cityWithStateAbbr: "Clifton, AZ",
  },
  {
    zip: "85534",
    ST: "AZ",
    cityWithStateAbbr: "Duncan, AZ",
  },
  {
    zip: "85535",
    ST: "AZ",
    cityWithStateAbbr: "Eden, AZ",
  },
  {
    zip: "85536",
    ST: "AZ",
    cityWithStateAbbr: "Fort Thomas, AZ",
  },
  {
    zip: "85539",
    ST: "AZ",
    cityWithStateAbbr: "Miami, AZ",
  },
  {
    zip: "85540",
    ST: "AZ",
    cityWithStateAbbr: "Morenci, AZ",
  },
  {
    zip: "85541",
    ST: "AZ",
    cityWithStateAbbr: "Payson, AZ",
  },
  {
    zip: "85542",
    ST: "AZ",
    cityWithStateAbbr: "Peridot, AZ",
  },
  {
    zip: "85543",
    ST: "AZ",
    cityWithStateAbbr: "Pima, AZ",
  },
  {
    zip: "85544",
    ST: "AZ",
    cityWithStateAbbr: "Pine, AZ",
  },
  {
    zip: "85545",
    ST: "AZ",
    cityWithStateAbbr: "Roosevelt, AZ",
  },
  {
    zip: "85546",
    ST: "AZ",
    cityWithStateAbbr: "Safford, AZ",
  },
  {
    zip: "85547",
    ST: "AZ",
    cityWithStateAbbr: "Payson, AZ",
  },
  {
    zip: "85548",
    ST: "AZ",
    cityWithStateAbbr: "Safford, AZ",
  },
  {
    zip: "85550",
    ST: "AZ",
    cityWithStateAbbr: "San Carlos, AZ",
  },
  {
    zip: "85551",
    ST: "AZ",
    cityWithStateAbbr: "Solomon, AZ",
  },
  {
    zip: "85552",
    ST: "AZ",
    cityWithStateAbbr: "Thatcher, AZ",
  },
  {
    zip: "85553",
    ST: "AZ",
    cityWithStateAbbr: "Tonto Basin, AZ",
  },
  {
    zip: "85554",
    ST: "AZ",
    cityWithStateAbbr: "Young, AZ",
  },
  {
    zip: "85601",
    ST: "AZ",
    cityWithStateAbbr: "Arivaca, AZ",
  },
  {
    zip: "85602",
    ST: "AZ",
    cityWithStateAbbr: "Benson, AZ",
  },
  {
    zip: "85603",
    ST: "AZ",
    cityWithStateAbbr: "Bisbee, AZ",
  },
  {
    zip: "85605",
    ST: "AZ",
    cityWithStateAbbr: "Bowie, AZ",
  },
  {
    zip: "85606",
    ST: "AZ",
    cityWithStateAbbr: "Cochise, AZ",
  },
  {
    zip: "85607",
    ST: "AZ",
    cityWithStateAbbr: "Douglas, AZ",
  },
  {
    zip: "85608",
    ST: "AZ",
    cityWithStateAbbr: "Douglas, AZ",
  },
  {
    zip: "85609",
    ST: "AZ",
    cityWithStateAbbr: "Dragoon, AZ",
  },
  {
    zip: "85610",
    ST: "AZ",
    cityWithStateAbbr: "Elfrida, AZ",
  },
  {
    zip: "85611",
    ST: "AZ",
    cityWithStateAbbr: "Elgin, AZ",
  },
  {
    zip: "85613",
    ST: "AZ",
    cityWithStateAbbr: "Fort Huachuca, AZ",
  },
  {
    zip: "85614",
    ST: "AZ",
    cityWithStateAbbr: "Green Valley, AZ",
  },
  {
    zip: "85615",
    ST: "AZ",
    cityWithStateAbbr: "Hereford, AZ",
  },
  {
    zip: "85616",
    ST: "AZ",
    cityWithStateAbbr: "Huachuca City, AZ",
  },
  {
    zip: "85617",
    ST: "AZ",
    cityWithStateAbbr: "Mc Neal, AZ",
  },
  {
    zip: "85618",
    ST: "AZ",
    cityWithStateAbbr: "Mammoth, AZ",
  },
  {
    zip: "85619",
    ST: "AZ",
    cityWithStateAbbr: "Mount Lemmon, AZ",
  },
  {
    zip: "85620",
    ST: "AZ",
    cityWithStateAbbr: "Naco, AZ",
  },
  {
    zip: "85621",
    ST: "AZ",
    cityWithStateAbbr: "Nogales, AZ",
  },
  {
    zip: "85622",
    ST: "AZ",
    cityWithStateAbbr: "Green Valley, AZ",
  },
  {
    zip: "85623",
    ST: "AZ",
    cityWithStateAbbr: "Oracle, AZ",
  },
  {
    zip: "85624",
    ST: "AZ",
    cityWithStateAbbr: "Patagonia, AZ",
  },
  {
    zip: "85625",
    ST: "AZ",
    cityWithStateAbbr: "Pearce, AZ",
  },
  {
    zip: "85626",
    ST: "AZ",
    cityWithStateAbbr: "Pirtleville, AZ",
  },
  {
    zip: "85627",
    ST: "AZ",
    cityWithStateAbbr: "Pomerene, AZ",
  },
  {
    zip: "85628",
    ST: "AZ",
    cityWithStateAbbr: "Nogales, AZ",
  },
  {
    zip: "85629",
    ST: "AZ",
    cityWithStateAbbr: "Sahuarita, AZ",
  },
  {
    zip: "85630",
    ST: "AZ",
    cityWithStateAbbr: "Saint David, AZ",
  },
  {
    zip: "85631",
    ST: "AZ",
    cityWithStateAbbr: "San Manuel, AZ",
  },
  {
    zip: "85632",
    ST: "AZ",
    cityWithStateAbbr: "San Simon, AZ",
  },
  {
    zip: "85633",
    ST: "AZ",
    cityWithStateAbbr: "Sasabe, AZ",
  },
  {
    zip: "85634",
    ST: "AZ",
    cityWithStateAbbr: "Sells, AZ",
  },
  {
    zip: "85635",
    ST: "AZ",
    cityWithStateAbbr: "Sierra Vista, AZ",
  },
  {
    zip: "85636",
    ST: "AZ",
    cityWithStateAbbr: "Sierra Vista, AZ",
  },
  {
    zip: "85637",
    ST: "AZ",
    cityWithStateAbbr: "Sonoita, AZ",
  },
  {
    zip: "85638",
    ST: "AZ",
    cityWithStateAbbr: "Tombstone, AZ",
  },
  {
    zip: "85639",
    ST: "AZ",
    cityWithStateAbbr: "Topawa, AZ",
  },
  {
    zip: "85640",
    ST: "AZ",
    cityWithStateAbbr: "Tumacacori, AZ",
  },
  {
    zip: "85641",
    ST: "AZ",
    cityWithStateAbbr: "Vail, AZ",
  },
  {
    zip: "85643",
    ST: "AZ",
    cityWithStateAbbr: "Willcox, AZ",
  },
  {
    zip: "85644",
    ST: "AZ",
    cityWithStateAbbr: "Willcox, AZ",
  },
  {
    zip: "85645",
    ST: "AZ",
    cityWithStateAbbr: "Amado, AZ",
  },
  {
    zip: "85646",
    ST: "AZ",
    cityWithStateAbbr: "Tubac, AZ",
  },
  {
    zip: "85648",
    ST: "AZ",
    cityWithStateAbbr: "Rio Rico, AZ",
  },
  {
    zip: "85650",
    ST: "AZ",
    cityWithStateAbbr: "Sierra Vista, AZ",
  },
  {
    zip: "85652",
    ST: "AZ",
    cityWithStateAbbr: "Cortaro, AZ",
  },
  {
    zip: "85653",
    ST: "AZ",
    cityWithStateAbbr: "Marana, AZ",
  },
  {
    zip: "85654",
    ST: "AZ",
    cityWithStateAbbr: "Rillito, AZ",
  },
  {
    zip: "85655",
    ST: "AZ",
    cityWithStateAbbr: "Douglas, AZ",
  },
  {
    zip: "85658",
    ST: "AZ",
    cityWithStateAbbr: "Marana, AZ",
  },
  {
    zip: "85662",
    ST: "AZ",
    cityWithStateAbbr: "Nogales, AZ",
  },
  {
    zip: "85670",
    ST: "AZ",
    cityWithStateAbbr: "Fort Huachuca, AZ",
  },
  {
    zip: "85701",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85702",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85703",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85704",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85705",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85706",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85707",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85708",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85709",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85710",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85711",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85712",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85713",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85714",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85715",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85716",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85717",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85718",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85719",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85721",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85722",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85723",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85724",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85725",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85726",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85728",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85730",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85731",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85732",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85733",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85734",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85735",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85736",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85737",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85738",
    ST: "AZ",
    cityWithStateAbbr: "Catalina, AZ",
  },
  {
    zip: "85739",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85740",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85741",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85742",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85743",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85744",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85745",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85746",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85747",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85748",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85749",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85750",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85751",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85752",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85754",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85755",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85756",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85757",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85775",
    ST: "AZ",
    cityWithStateAbbr: "Tucson, AZ",
  },
  {
    zip: "85901",
    ST: "AZ",
    cityWithStateAbbr: "Show Low, AZ",
  },
  {
    zip: "85902",
    ST: "AZ",
    cityWithStateAbbr: "Show Low, AZ",
  },
  {
    zip: "85911",
    ST: "AZ",
    cityWithStateAbbr: "Cibecue, AZ",
  },
  {
    zip: "85912",
    ST: "AZ",
    cityWithStateAbbr: "White Mountain Lake, AZ",
  },
  {
    zip: "85920",
    ST: "AZ",
    cityWithStateAbbr: "Alpine, AZ",
  },
  {
    zip: "85922",
    ST: "AZ",
    cityWithStateAbbr: "Blue, AZ",
  },
  {
    zip: "85923",
    ST: "AZ",
    cityWithStateAbbr: "Clay Springs, AZ",
  },
  {
    zip: "85924",
    ST: "AZ",
    cityWithStateAbbr: "Concho, AZ",
  },
  {
    zip: "85925",
    ST: "AZ",
    cityWithStateAbbr: "Eagar, AZ",
  },
  {
    zip: "85926",
    ST: "AZ",
    cityWithStateAbbr: "Fort Apache, AZ",
  },
  {
    zip: "85927",
    ST: "AZ",
    cityWithStateAbbr: "Greer, AZ",
  },
  {
    zip: "85928",
    ST: "AZ",
    cityWithStateAbbr: "Heber, AZ",
  },
  {
    zip: "85929",
    ST: "AZ",
    cityWithStateAbbr: "Lakeside, AZ",
  },
  {
    zip: "85930",
    ST: "AZ",
    cityWithStateAbbr: "Mcnary, AZ",
  },
  {
    zip: "85931",
    ST: "AZ",
    cityWithStateAbbr: "Forest Lakes, AZ",
  },
  {
    zip: "85932",
    ST: "AZ",
    cityWithStateAbbr: "Nutrioso, AZ",
  },
  {
    zip: "85933",
    ST: "AZ",
    cityWithStateAbbr: "Overgaard, AZ",
  },
  {
    zip: "85934",
    ST: "AZ",
    cityWithStateAbbr: "Pinedale, AZ",
  },
  {
    zip: "85935",
    ST: "AZ",
    cityWithStateAbbr: "Pinetop, AZ",
  },
  {
    zip: "85936",
    ST: "AZ",
    cityWithStateAbbr: "Saint Johns, AZ",
  },
  {
    zip: "85937",
    ST: "AZ",
    cityWithStateAbbr: "Snowflake, AZ",
  },
  {
    zip: "85938",
    ST: "AZ",
    cityWithStateAbbr: "Springerville, AZ",
  },
  {
    zip: "85939",
    ST: "AZ",
    cityWithStateAbbr: "Taylor, AZ",
  },
  {
    zip: "85940",
    ST: "AZ",
    cityWithStateAbbr: "Vernon, AZ",
  },
  {
    zip: "85941",
    ST: "AZ",
    cityWithStateAbbr: "Whiteriver, AZ",
  },
  {
    zip: "85942",
    ST: "AZ",
    cityWithStateAbbr: "Woodruff, AZ",
  },
  {
    zip: "86001",
    ST: "AZ",
    cityWithStateAbbr: "Flagstaff, AZ",
  },
  {
    zip: "86002",
    ST: "AZ",
    cityWithStateAbbr: "Flagstaff, AZ",
  },
  {
    zip: "86003",
    ST: "AZ",
    cityWithStateAbbr: "Flagstaff, AZ",
  },
  {
    zip: "86004",
    ST: "AZ",
    cityWithStateAbbr: "Flagstaff, AZ",
  },
  {
    zip: "86005",
    ST: "AZ",
    cityWithStateAbbr: "Flagstaff, AZ",
  },
  {
    zip: "86011",
    ST: "AZ",
    cityWithStateAbbr: "Flagstaff, AZ",
  },
  {
    zip: "86015",
    ST: "AZ",
    cityWithStateAbbr: "Bellemont, AZ",
  },
  {
    zip: "86016",
    ST: "AZ",
    cityWithStateAbbr: "Gray Mountain, AZ",
  },
  {
    zip: "86017",
    ST: "AZ",
    cityWithStateAbbr: "Munds Park, AZ",
  },
  {
    zip: "86018",
    ST: "AZ",
    cityWithStateAbbr: "Parks, AZ",
  },
  {
    zip: "86020",
    ST: "AZ",
    cityWithStateAbbr: "Cameron, AZ",
  },
  {
    zip: "86021",
    ST: "AZ",
    cityWithStateAbbr: "Colorado City, AZ",
  },
  {
    zip: "86022",
    ST: "AZ",
    cityWithStateAbbr: "Fredonia, AZ",
  },
  {
    zip: "86023",
    ST: "AZ",
    cityWithStateAbbr: "Grand Canyon, AZ",
  },
  {
    zip: "86024",
    ST: "AZ",
    cityWithStateAbbr: "Happy Jack, AZ",
  },
  {
    zip: "86025",
    ST: "AZ",
    cityWithStateAbbr: "Holbrook, AZ",
  },
  {
    zip: "86028",
    ST: "AZ",
    cityWithStateAbbr: "Petrified Forest Natl Pk, AZ",
  },
  {
    zip: "86029",
    ST: "AZ",
    cityWithStateAbbr: "Sun Valley, AZ",
  },
  {
    zip: "86030",
    ST: "AZ",
    cityWithStateAbbr: "Hotevilla, AZ",
  },
  {
    zip: "86031",
    ST: "AZ",
    cityWithStateAbbr: "Indian Wells, AZ",
  },
  {
    zip: "86032",
    ST: "AZ",
    cityWithStateAbbr: "Joseph City, AZ",
  },
  {
    zip: "86033",
    ST: "AZ",
    cityWithStateAbbr: "Kayenta, AZ",
  },
  {
    zip: "86034",
    ST: "AZ",
    cityWithStateAbbr: "Keams Canyon, AZ",
  },
  {
    zip: "86035",
    ST: "AZ",
    cityWithStateAbbr: "Leupp, AZ",
  },
  {
    zip: "86036",
    ST: "AZ",
    cityWithStateAbbr: "Marble Canyon, AZ",
  },
  {
    zip: "86038",
    ST: "AZ",
    cityWithStateAbbr: "Mormon Lake, AZ",
  },
  {
    zip: "86039",
    ST: "AZ",
    cityWithStateAbbr: "Kykotsmovi Village, AZ",
  },
  {
    zip: "86040",
    ST: "AZ",
    cityWithStateAbbr: "Page, AZ",
  },
  {
    zip: "86042",
    ST: "AZ",
    cityWithStateAbbr: "Polacca, AZ",
  },
  {
    zip: "86043",
    ST: "AZ",
    cityWithStateAbbr: "Second Mesa, AZ",
  },
  {
    zip: "86044",
    ST: "AZ",
    cityWithStateAbbr: "Tonalea, AZ",
  },
  {
    zip: "86045",
    ST: "AZ",
    cityWithStateAbbr: "Tuba City, AZ",
  },
  {
    zip: "86046",
    ST: "AZ",
    cityWithStateAbbr: "Williams, AZ",
  },
  {
    zip: "86047",
    ST: "AZ",
    cityWithStateAbbr: "Winslow, AZ",
  },
  {
    zip: "86052",
    ST: "AZ",
    cityWithStateAbbr: "North Rim, AZ",
  },
  {
    zip: "86053",
    ST: "AZ",
    cityWithStateAbbr: "Kaibeto, AZ",
  },
  {
    zip: "86054",
    ST: "AZ",
    cityWithStateAbbr: "Shonto, AZ",
  },
  {
    zip: "86301",
    ST: "AZ",
    cityWithStateAbbr: "Prescott, AZ",
  },
  {
    zip: "86302",
    ST: "AZ",
    cityWithStateAbbr: "Prescott, AZ",
  },
  {
    zip: "86303",
    ST: "AZ",
    cityWithStateAbbr: "Prescott, AZ",
  },
  {
    zip: "86304",
    ST: "AZ",
    cityWithStateAbbr: "Prescott, AZ",
  },
  {
    zip: "86305",
    ST: "AZ",
    cityWithStateAbbr: "Prescott, AZ",
  },
  {
    zip: "86312",
    ST: "AZ",
    cityWithStateAbbr: "Prescott Valley, AZ",
  },
  {
    zip: "86313",
    ST: "AZ",
    cityWithStateAbbr: "Prescott, AZ",
  },
  {
    zip: "86314",
    ST: "AZ",
    cityWithStateAbbr: "Prescott Valley, AZ",
  },
  {
    zip: "86315",
    ST: "AZ",
    cityWithStateAbbr: "Prescott Valley, AZ",
  },
  {
    zip: "86320",
    ST: "AZ",
    cityWithStateAbbr: "Ash Fork, AZ",
  },
  {
    zip: "86321",
    ST: "AZ",
    cityWithStateAbbr: "Bagdad, AZ",
  },
  {
    zip: "86322",
    ST: "AZ",
    cityWithStateAbbr: "Camp Verde, AZ",
  },
  {
    zip: "86323",
    ST: "AZ",
    cityWithStateAbbr: "Chino Valley, AZ",
  },
  {
    zip: "86324",
    ST: "AZ",
    cityWithStateAbbr: "Clarkdale, AZ",
  },
  {
    zip: "86325",
    ST: "AZ",
    cityWithStateAbbr: "Cornville, AZ",
  },
  {
    zip: "86326",
    ST: "AZ",
    cityWithStateAbbr: "Cottonwood, AZ",
  },
  {
    zip: "86327",
    ST: "AZ",
    cityWithStateAbbr: "Dewey, AZ",
  },
  {
    zip: "86329",
    ST: "AZ",
    cityWithStateAbbr: "Humboldt, AZ",
  },
  {
    zip: "86331",
    ST: "AZ",
    cityWithStateAbbr: "Jerome, AZ",
  },
  {
    zip: "86332",
    ST: "AZ",
    cityWithStateAbbr: "Kirkland, AZ",
  },
  {
    zip: "86333",
    ST: "AZ",
    cityWithStateAbbr: "Mayer, AZ",
  },
  {
    zip: "86334",
    ST: "AZ",
    cityWithStateAbbr: "Paulden, AZ",
  },
  {
    zip: "86335",
    ST: "AZ",
    cityWithStateAbbr: "Rimrock, AZ",
  },
  {
    zip: "86336",
    ST: "AZ",
    cityWithStateAbbr: "Sedona, AZ",
  },
  {
    zip: "86337",
    ST: "AZ",
    cityWithStateAbbr: "Seligman, AZ",
  },
  {
    zip: "86338",
    ST: "AZ",
    cityWithStateAbbr: "Skull Valley, AZ",
  },
  {
    zip: "86339",
    ST: "AZ",
    cityWithStateAbbr: "Sedona, AZ",
  },
  {
    zip: "86340",
    ST: "AZ",
    cityWithStateAbbr: "Sedona, AZ",
  },
  {
    zip: "86341",
    ST: "AZ",
    cityWithStateAbbr: "Sedona, AZ",
  },
  {
    zip: "86342",
    ST: "AZ",
    cityWithStateAbbr: "Lake Montezuma, AZ",
  },
  {
    zip: "86343",
    ST: "AZ",
    cityWithStateAbbr: "Crown King, AZ",
  },
  {
    zip: "86351",
    ST: "AZ",
    cityWithStateAbbr: "Sedona, AZ",
  },
  {
    zip: "86401",
    ST: "AZ",
    cityWithStateAbbr: "Kingman, AZ",
  },
  {
    zip: "86402",
    ST: "AZ",
    cityWithStateAbbr: "Kingman, AZ",
  },
  {
    zip: "86403",
    ST: "AZ",
    cityWithStateAbbr: "Lake Havasu City, AZ",
  },
  {
    zip: "86404",
    ST: "AZ",
    cityWithStateAbbr: "Lake Havasu City, AZ",
  },
  {
    zip: "86405",
    ST: "AZ",
    cityWithStateAbbr: "Lake Havasu City, AZ",
  },
  {
    zip: "86406",
    ST: "AZ",
    cityWithStateAbbr: "Lake Havasu City, AZ",
  },
  {
    zip: "86409",
    ST: "AZ",
    cityWithStateAbbr: "Kingman, AZ",
  },
  {
    zip: "86411",
    ST: "AZ",
    cityWithStateAbbr: "Hackberry, AZ",
  },
  {
    zip: "86412",
    ST: "AZ",
    cityWithStateAbbr: "Hualapai, AZ",
  },
  {
    zip: "86413",
    ST: "AZ",
    cityWithStateAbbr: "Golden Valley, AZ",
  },
  {
    zip: "86426",
    ST: "AZ",
    cityWithStateAbbr: "Fort Mohave, AZ",
  },
  {
    zip: "86427",
    ST: "AZ",
    cityWithStateAbbr: "Fort Mohave, AZ",
  },
  {
    zip: "86429",
    ST: "AZ",
    cityWithStateAbbr: "Bullhead City, AZ",
  },
  {
    zip: "86430",
    ST: "AZ",
    cityWithStateAbbr: "Bullhead City, AZ",
  },
  {
    zip: "86431",
    ST: "AZ",
    cityWithStateAbbr: "Chloride, AZ",
  },
  {
    zip: "86432",
    ST: "AZ",
    cityWithStateAbbr: "Littlefield, AZ",
  },
  {
    zip: "86433",
    ST: "AZ",
    cityWithStateAbbr: "Oatman, AZ",
  },
  {
    zip: "86434",
    ST: "AZ",
    cityWithStateAbbr: "Peach Springs, AZ",
  },
  {
    zip: "86435",
    ST: "AZ",
    cityWithStateAbbr: "Supai, AZ",
  },
  {
    zip: "86436",
    ST: "AZ",
    cityWithStateAbbr: "Topock, AZ",
  },
  {
    zip: "86437",
    ST: "AZ",
    cityWithStateAbbr: "Valentine, AZ",
  },
  {
    zip: "86438",
    ST: "AZ",
    cityWithStateAbbr: "Yucca, AZ",
  },
  {
    zip: "86439",
    ST: "AZ",
    cityWithStateAbbr: "Bullhead City, AZ",
  },
  {
    zip: "86440",
    ST: "AZ",
    cityWithStateAbbr: "Mohave Valley, AZ",
  },
  {
    zip: "86441",
    ST: "AZ",
    cityWithStateAbbr: "Dolan Springs, AZ",
  },
  {
    zip: "86442",
    ST: "AZ",
    cityWithStateAbbr: "Bullhead City, AZ",
  },
  {
    zip: "86443",
    ST: "AZ",
    cityWithStateAbbr: "Temple Bar Marina, AZ",
  },
  {
    zip: "86444",
    ST: "AZ",
    cityWithStateAbbr: "Meadview, AZ",
  },
  {
    zip: "86445",
    ST: "AZ",
    cityWithStateAbbr: "Willow Beach, AZ",
  },
  {
    zip: "86446",
    ST: "AZ",
    cityWithStateAbbr: "Mohave Valley, AZ",
  },
  {
    zip: "86502",
    ST: "AZ",
    cityWithStateAbbr: "Chambers, AZ",
  },
  {
    zip: "86503",
    ST: "AZ",
    cityWithStateAbbr: "Chinle, AZ",
  },
  {
    zip: "86504",
    ST: "AZ",
    cityWithStateAbbr: "Fort Defiance, AZ",
  },
  {
    zip: "86505",
    ST: "AZ",
    cityWithStateAbbr: "Ganado, AZ",
  },
  {
    zip: "86506",
    ST: "AZ",
    cityWithStateAbbr: "Houck, AZ",
  },
  {
    zip: "86507",
    ST: "AZ",
    cityWithStateAbbr: "Lukachukai, AZ",
  },
  {
    zip: "86508",
    ST: "AZ",
    cityWithStateAbbr: "Lupton, AZ",
  },
  {
    zip: "86510",
    ST: "AZ",
    cityWithStateAbbr: "Pinon, AZ",
  },
  {
    zip: "86511",
    ST: "AZ",
    cityWithStateAbbr: "Saint Michaels, AZ",
  },
  {
    zip: "86512",
    ST: "AZ",
    cityWithStateAbbr: "Sanders, AZ",
  },
  {
    zip: "86514",
    ST: "AZ",
    cityWithStateAbbr: "Teec Nos Pos, AZ",
  },
  {
    zip: "86515",
    ST: "NM",
    cityWithStateAbbr: "Window Rock, NM",
  },
  {
    zip: "86520",
    ST: "AZ",
    cityWithStateAbbr: "Blue Gap, AZ",
  },
  {
    zip: "86535",
    ST: "AZ",
    cityWithStateAbbr: "Dennehotso, AZ",
  },
  {
    zip: "86538",
    ST: "AZ",
    cityWithStateAbbr: "Many Farms, AZ",
  },
  {
    zip: "86540",
    ST: "AZ",
    cityWithStateAbbr: "Nazlini, AZ",
  },
  {
    zip: "86544",
    ST: "AZ",
    cityWithStateAbbr: "Red Valley, AZ",
  },
  {
    zip: "86545",
    ST: "AZ",
    cityWithStateAbbr: "Rock Point, AZ",
  },
  {
    zip: "86547",
    ST: "AZ",
    cityWithStateAbbr: "Round Rock, AZ",
  },
  {
    zip: "86556",
    ST: "AZ",
    cityWithStateAbbr: "Tsaile, AZ",
  },
  {
    zip: "87001",
    ST: "NM",
    cityWithStateAbbr: "Algodones, NM",
  },
  {
    zip: "87002",
    ST: "NM",
    cityWithStateAbbr: "Belen, NM",
  },
  {
    zip: "87004",
    ST: "NM",
    cityWithStateAbbr: "Bernalillo, NM",
  },
  {
    zip: "87005",
    ST: "NM",
    cityWithStateAbbr: "Bluewater, NM",
  },
  {
    zip: "87006",
    ST: "NM",
    cityWithStateAbbr: "Bosque, NM",
  },
  {
    zip: "87007",
    ST: "NM",
    cityWithStateAbbr: "Casa Blanca, NM",
  },
  {
    zip: "87008",
    ST: "NM",
    cityWithStateAbbr: "Cedar Crest, NM",
  },
  {
    zip: "87009",
    ST: "NM",
    cityWithStateAbbr: "Cedarvale, NM",
  },
  {
    zip: "87010",
    ST: "NM",
    cityWithStateAbbr: "Cerrillos, NM",
  },
  {
    zip: "87011",
    ST: "NM",
    cityWithStateAbbr: "Claunch, NM",
  },
  {
    zip: "87012",
    ST: "NM",
    cityWithStateAbbr: "Coyote, NM",
  },
  {
    zip: "87013",
    ST: "NM",
    cityWithStateAbbr: "Cuba, NM",
  },
  {
    zip: "87014",
    ST: "NM",
    cityWithStateAbbr: "Cubero, NM",
  },
  {
    zip: "87015",
    ST: "NM",
    cityWithStateAbbr: "Edgewood, NM",
  },
  {
    zip: "87016",
    ST: "NM",
    cityWithStateAbbr: "Estancia, NM",
  },
  {
    zip: "87017",
    ST: "NM",
    cityWithStateAbbr: "Gallina, NM",
  },
  {
    zip: "87018",
    ST: "NM",
    cityWithStateAbbr: "Counselor, NM",
  },
  {
    zip: "87020",
    ST: "NM",
    cityWithStateAbbr: "Grants, NM",
  },
  {
    zip: "87021",
    ST: "NM",
    cityWithStateAbbr: "Milan, NM",
  },
  {
    zip: "87022",
    ST: "NM",
    cityWithStateAbbr: "Isleta, NM",
  },
  {
    zip: "87023",
    ST: "NM",
    cityWithStateAbbr: "Jarales, NM",
  },
  {
    zip: "87024",
    ST: "NM",
    cityWithStateAbbr: "Jemez Pueblo, NM",
  },
  {
    zip: "87025",
    ST: "NM",
    cityWithStateAbbr: "Jemez Springs, NM",
  },
  {
    zip: "87026",
    ST: "NM",
    cityWithStateAbbr: "Laguna, NM",
  },
  {
    zip: "87027",
    ST: "NM",
    cityWithStateAbbr: "La Jara, NM",
  },
  {
    zip: "87028",
    ST: "NM",
    cityWithStateAbbr: "La Joya, NM",
  },
  {
    zip: "87029",
    ST: "NM",
    cityWithStateAbbr: "Lindrith, NM",
  },
  {
    zip: "87031",
    ST: "NM",
    cityWithStateAbbr: "Los Lunas, NM",
  },
  {
    zip: "87032",
    ST: "NM",
    cityWithStateAbbr: "Mcintosh, NM",
  },
  {
    zip: "87034",
    ST: "NM",
    cityWithStateAbbr: "Pueblo Of Acoma, NM",
  },
  {
    zip: "87035",
    ST: "NM",
    cityWithStateAbbr: "Moriarty, NM",
  },
  {
    zip: "87036",
    ST: "NM",
    cityWithStateAbbr: "Mountainair, NM",
  },
  {
    zip: "87037",
    ST: "NM",
    cityWithStateAbbr: "Nageezi, NM",
  },
  {
    zip: "87038",
    ST: "NM",
    cityWithStateAbbr: "New Laguna, NM",
  },
  {
    zip: "87040",
    ST: "NM",
    cityWithStateAbbr: "Paguate, NM",
  },
  {
    zip: "87041",
    ST: "NM",
    cityWithStateAbbr: "Pena Blanca, NM",
  },
  {
    zip: "87042",
    ST: "NM",
    cityWithStateAbbr: "Peralta, NM",
  },
  {
    zip: "87043",
    ST: "NM",
    cityWithStateAbbr: "Placitas, NM",
  },
  {
    zip: "87044",
    ST: "NM",
    cityWithStateAbbr: "Ponderosa, NM",
  },
  {
    zip: "87045",
    ST: "NM",
    cityWithStateAbbr: "Prewitt, NM",
  },
  {
    zip: "87046",
    ST: "NM",
    cityWithStateAbbr: "Regina, NM",
  },
  {
    zip: "87047",
    ST: "NM",
    cityWithStateAbbr: "Sandia Park, NM",
  },
  {
    zip: "87048",
    ST: "NM",
    cityWithStateAbbr: "Corrales, NM",
  },
  {
    zip: "87049",
    ST: "NM",
    cityWithStateAbbr: "San Fidel, NM",
  },
  {
    zip: "87051",
    ST: "NM",
    cityWithStateAbbr: "San Rafael, NM",
  },
  {
    zip: "87052",
    ST: "NM",
    cityWithStateAbbr: "Santo Domingo Pueblo, NM",
  },
  {
    zip: "87053",
    ST: "NM",
    cityWithStateAbbr: "San Ysidro, NM",
  },
  {
    zip: "87056",
    ST: "NM",
    cityWithStateAbbr: "Stanley, NM",
  },
  {
    zip: "87059",
    ST: "NM",
    cityWithStateAbbr: "Tijeras, NM",
  },
  {
    zip: "87060",
    ST: "NM",
    cityWithStateAbbr: "Tome, NM",
  },
  {
    zip: "87061",
    ST: "NM",
    cityWithStateAbbr: "Torreon, NM",
  },
  {
    zip: "87062",
    ST: "NM",
    cityWithStateAbbr: "Veguita, NM",
  },
  {
    zip: "87063",
    ST: "NM",
    cityWithStateAbbr: "Willard, NM",
  },
  {
    zip: "87064",
    ST: "NM",
    cityWithStateAbbr: "Youngsville, NM",
  },
  {
    zip: "87068",
    ST: "NM",
    cityWithStateAbbr: "Bosque Farms, NM",
  },
  {
    zip: "87070",
    ST: "NM",
    cityWithStateAbbr: "Clines Corners, NM",
  },
  {
    zip: "87072",
    ST: "NM",
    cityWithStateAbbr: "Cochiti Pueblo, NM",
  },
  {
    zip: "87083",
    ST: "NM",
    cityWithStateAbbr: "Cochiti Lake, NM",
  },
  {
    zip: "87101",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87102",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87103",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87104",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87105",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87106",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87107",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87108",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87109",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87110",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87111",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87112",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87113",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87114",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87115",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87116",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87117",
    ST: "NM",
    cityWithStateAbbr: "Kirtland Afb, NM",
  },
  {
    zip: "87119",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87120",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87121",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87122",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87123",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87124",
    ST: "NM",
    cityWithStateAbbr: "Rio Rancho, NM",
  },
  {
    zip: "87125",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87131",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87144",
    ST: "NM",
    cityWithStateAbbr: "Rio Rancho, NM",
  },
  {
    zip: "87151",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87153",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87154",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87158",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87174",
    ST: "NM",
    cityWithStateAbbr: "Rio Rancho, NM",
  },
  {
    zip: "87176",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87181",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87184",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87185",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87187",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87190",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87191",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87192",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87193",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87194",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87195",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87196",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87197",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87198",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87199",
    ST: "NM",
    cityWithStateAbbr: "Albuquerque, NM",
  },
  {
    zip: "87301",
    ST: "NM",
    cityWithStateAbbr: "Gallup, NM",
  },
  {
    zip: "87302",
    ST: "NM",
    cityWithStateAbbr: "Gallup, NM",
  },
  {
    zip: "87305",
    ST: "NM",
    cityWithStateAbbr: "Gallup, NM",
  },
  {
    zip: "87310",
    ST: "NM",
    cityWithStateAbbr: "Brimhall, NM",
  },
  {
    zip: "87311",
    ST: "NM",
    cityWithStateAbbr: "Church Rock, NM",
  },
  {
    zip: "87312",
    ST: "NM",
    cityWithStateAbbr: "Continental Divide, NM",
  },
  {
    zip: "87313",
    ST: "NM",
    cityWithStateAbbr: "Crownpoint, NM",
  },
  {
    zip: "87315",
    ST: "NM",
    cityWithStateAbbr: "Fence Lake, NM",
  },
  {
    zip: "87316",
    ST: "NM",
    cityWithStateAbbr: "Fort Wingate, NM",
  },
  {
    zip: "87317",
    ST: "NM",
    cityWithStateAbbr: "Gamerco, NM",
  },
  {
    zip: "87319",
    ST: "NM",
    cityWithStateAbbr: "Mentmore, NM",
  },
  {
    zip: "87320",
    ST: "NM",
    cityWithStateAbbr: "Mexican Springs, NM",
  },
  {
    zip: "87321",
    ST: "NM",
    cityWithStateAbbr: "Ramah, NM",
  },
  {
    zip: "87322",
    ST: "NM",
    cityWithStateAbbr: "Rehoboth, NM",
  },
  {
    zip: "87323",
    ST: "NM",
    cityWithStateAbbr: "Thoreau, NM",
  },
  {
    zip: "87325",
    ST: "NM",
    cityWithStateAbbr: "Tohatchi, NM",
  },
  {
    zip: "87326",
    ST: "NM",
    cityWithStateAbbr: "Vanderwagen, NM",
  },
  {
    zip: "87327",
    ST: "NM",
    cityWithStateAbbr: "Zuni, NM",
  },
  {
    zip: "87328",
    ST: "NM",
    cityWithStateAbbr: "Navajo, NM",
  },
  {
    zip: "87347",
    ST: "NM",
    cityWithStateAbbr: "Jamestown, NM",
  },
  {
    zip: "87357",
    ST: "NM",
    cityWithStateAbbr: "Pinehill, NM",
  },
  {
    zip: "87364",
    ST: "NM",
    cityWithStateAbbr: "Sheep Springs, NM",
  },
  {
    zip: "87365",
    ST: "NM",
    cityWithStateAbbr: "Smith Lake, NM",
  },
  {
    zip: "87375",
    ST: "NM",
    cityWithStateAbbr: "Yatahey, NM",
  },
  {
    zip: "87401",
    ST: "NM",
    cityWithStateAbbr: "Farmington, NM",
  },
  {
    zip: "87402",
    ST: "NM",
    cityWithStateAbbr: "Farmington, NM",
  },
  {
    zip: "87410",
    ST: "NM",
    cityWithStateAbbr: "Aztec, NM",
  },
  {
    zip: "87412",
    ST: "NM",
    cityWithStateAbbr: "Blanco, NM",
  },
  {
    zip: "87413",
    ST: "NM",
    cityWithStateAbbr: "Bloomfield, NM",
  },
  {
    zip: "87415",
    ST: "NM",
    cityWithStateAbbr: "Flora Vista, NM",
  },
  {
    zip: "87416",
    ST: "NM",
    cityWithStateAbbr: "Fruitland, NM",
  },
  {
    zip: "87417",
    ST: "NM",
    cityWithStateAbbr: "Kirtland, NM",
  },
  {
    zip: "87418",
    ST: "NM",
    cityWithStateAbbr: "La Plata, NM",
  },
  {
    zip: "87419",
    ST: "NM",
    cityWithStateAbbr: "Navajo Dam, NM",
  },
  {
    zip: "87420",
    ST: "NM",
    cityWithStateAbbr: "Shiprock, NM",
  },
  {
    zip: "87421",
    ST: "NM",
    cityWithStateAbbr: "Waterflow, NM",
  },
  {
    zip: "87455",
    ST: "NM",
    cityWithStateAbbr: "Newcomb, NM",
  },
  {
    zip: "87461",
    ST: "NM",
    cityWithStateAbbr: "Sanostee, NM",
  },
  {
    zip: "87499",
    ST: "NM",
    cityWithStateAbbr: "Farmington, NM",
  },
  {
    zip: "87501",
    ST: "NM",
    cityWithStateAbbr: "Santa Fe, NM",
  },
  {
    zip: "87502",
    ST: "NM",
    cityWithStateAbbr: "Santa Fe, NM",
  },
  {
    zip: "87503",
    ST: "NM",
    cityWithStateAbbr: "Santa Fe, NM",
  },
  {
    zip: "87504",
    ST: "NM",
    cityWithStateAbbr: "Santa Fe, NM",
  },
  {
    zip: "87505",
    ST: "NM",
    cityWithStateAbbr: "Santa Fe, NM",
  },
  {
    zip: "87506",
    ST: "NM",
    cityWithStateAbbr: "Santa Fe, NM",
  },
  {
    zip: "87507",
    ST: "NM",
    cityWithStateAbbr: "Santa Fe, NM",
  },
  {
    zip: "87508",
    ST: "NM",
    cityWithStateAbbr: "Santa Fe, NM",
  },
  {
    zip: "87509",
    ST: "NM",
    cityWithStateAbbr: "Santa Fe, NM",
  },
  {
    zip: "87510",
    ST: "NM",
    cityWithStateAbbr: "Abiquiu, NM",
  },
  {
    zip: "87511",
    ST: "NM",
    cityWithStateAbbr: "Alcalde, NM",
  },
  {
    zip: "87512",
    ST: "NM",
    cityWithStateAbbr: "Amalia, NM",
  },
  {
    zip: "87513",
    ST: "NM",
    cityWithStateAbbr: "Arroyo Hondo, NM",
  },
  {
    zip: "87514",
    ST: "NM",
    cityWithStateAbbr: "Arroyo Seco, NM",
  },
  {
    zip: "87515",
    ST: "NM",
    cityWithStateAbbr: "Canjilon, NM",
  },
  {
    zip: "87516",
    ST: "NM",
    cityWithStateAbbr: "Canones, NM",
  },
  {
    zip: "87517",
    ST: "NM",
    cityWithStateAbbr: "Carson, NM",
  },
  {
    zip: "87518",
    ST: "NM",
    cityWithStateAbbr: "Cebolla, NM",
  },
  {
    zip: "87519",
    ST: "NM",
    cityWithStateAbbr: "Cerro, NM",
  },
  {
    zip: "87520",
    ST: "NM",
    cityWithStateAbbr: "Chama, NM",
  },
  {
    zip: "87521",
    ST: "NM",
    cityWithStateAbbr: "Chamisal, NM",
  },
  {
    zip: "87522",
    ST: "NM",
    cityWithStateAbbr: "Chimayo, NM",
  },
  {
    zip: "87523",
    ST: "NM",
    cityWithStateAbbr: "Cordova, NM",
  },
  {
    zip: "87524",
    ST: "NM",
    cityWithStateAbbr: "Costilla, NM",
  },
  {
    zip: "87525",
    ST: "NM",
    cityWithStateAbbr: "Taos Ski Valley, NM",
  },
  {
    zip: "87527",
    ST: "NM",
    cityWithStateAbbr: "Dixon, NM",
  },
  {
    zip: "87528",
    ST: "NM",
    cityWithStateAbbr: "Dulce, NM",
  },
  {
    zip: "87529",
    ST: "NM",
    cityWithStateAbbr: "El Prado, NM",
  },
  {
    zip: "87530",
    ST: "NM",
    cityWithStateAbbr: "El Rito, NM",
  },
  {
    zip: "87531",
    ST: "NM",
    cityWithStateAbbr: "Embudo, NM",
  },
  {
    zip: "87532",
    ST: "NM",
    cityWithStateAbbr: "Espanola, NM",
  },
  {
    zip: "87533",
    ST: "NM",
    cityWithStateAbbr: "Espanola, NM",
  },
  {
    zip: "87535",
    ST: "NM",
    cityWithStateAbbr: "Glorieta, NM",
  },
  {
    zip: "87537",
    ST: "NM",
    cityWithStateAbbr: "Hernandez, NM",
  },
  {
    zip: "87538",
    ST: "NM",
    cityWithStateAbbr: "Ilfeld, NM",
  },
  {
    zip: "87539",
    ST: "NM",
    cityWithStateAbbr: "La Madera, NM",
  },
  {
    zip: "87540",
    ST: "NM",
    cityWithStateAbbr: "Lamy, NM",
  },
  {
    zip: "87543",
    ST: "NM",
    cityWithStateAbbr: "Llano, NM",
  },
  {
    zip: "87544",
    ST: "NM",
    cityWithStateAbbr: "Los Alamos, NM",
  },
  {
    zip: "87545",
    ST: "NM",
    cityWithStateAbbr: "Los Alamos, NM",
  },
  {
    zip: "87547",
    ST: "NM",
    cityWithStateAbbr: "Los Alamos, NM",
  },
  {
    zip: "87548",
    ST: "NM",
    cityWithStateAbbr: "Medanales, NM",
  },
  {
    zip: "87549",
    ST: "NM",
    cityWithStateAbbr: "Ojo Caliente, NM",
  },
  {
    zip: "87551",
    ST: "NM",
    cityWithStateAbbr: "Los Ojos, NM",
  },
  {
    zip: "87552",
    ST: "NM",
    cityWithStateAbbr: "Pecos, NM",
  },
  {
    zip: "87553",
    ST: "NM",
    cityWithStateAbbr: "Penasco, NM",
  },
  {
    zip: "87554",
    ST: "NM",
    cityWithStateAbbr: "Petaca, NM",
  },
  {
    zip: "87556",
    ST: "NM",
    cityWithStateAbbr: "Questa, NM",
  },
  {
    zip: "87557",
    ST: "NM",
    cityWithStateAbbr: "Ranchos De Taos, NM",
  },
  {
    zip: "87558",
    ST: "NM",
    cityWithStateAbbr: "Red River, NM",
  },
  {
    zip: "87560",
    ST: "NM",
    cityWithStateAbbr: "Ribera, NM",
  },
  {
    zip: "87562",
    ST: "NM",
    cityWithStateAbbr: "Rowe, NM",
  },
  {
    zip: "87564",
    ST: "NM",
    cityWithStateAbbr: "San Cristobal, NM",
  },
  {
    zip: "87565",
    ST: "NM",
    cityWithStateAbbr: "San Jose, NM",
  },
  {
    zip: "87566",
    ST: "NM",
    cityWithStateAbbr: "Ohkay Owingeh, NM",
  },
  {
    zip: "87567",
    ST: "NM",
    cityWithStateAbbr: "Santa Cruz, NM",
  },
  {
    zip: "87569",
    ST: "NM",
    cityWithStateAbbr: "Serafina, NM",
  },
  {
    zip: "87571",
    ST: "NM",
    cityWithStateAbbr: "Taos, NM",
  },
  {
    zip: "87573",
    ST: "NM",
    cityWithStateAbbr: "Tererro, NM",
  },
  {
    zip: "87574",
    ST: "NM",
    cityWithStateAbbr: "Tesuque, NM",
  },
  {
    zip: "87575",
    ST: "NM",
    cityWithStateAbbr: "Tierra Amarilla, NM",
  },
  {
    zip: "87576",
    ST: "NM",
    cityWithStateAbbr: "Trampas, NM",
  },
  {
    zip: "87577",
    ST: "NM",
    cityWithStateAbbr: "Tres Piedras, NM",
  },
  {
    zip: "87578",
    ST: "NM",
    cityWithStateAbbr: "Truchas, NM",
  },
  {
    zip: "87579",
    ST: "NM",
    cityWithStateAbbr: "Vadito, NM",
  },
  {
    zip: "87580",
    ST: "NM",
    cityWithStateAbbr: "Valdez, NM",
  },
  {
    zip: "87581",
    ST: "NM",
    cityWithStateAbbr: "Vallecitos, NM",
  },
  {
    zip: "87582",
    ST: "NM",
    cityWithStateAbbr: "Velarde, NM",
  },
  {
    zip: "87583",
    ST: "NM",
    cityWithStateAbbr: "Villanueva, NM",
  },
  {
    zip: "87592",
    ST: "NM",
    cityWithStateAbbr: "Santa Fe, NM",
  },
  {
    zip: "87594",
    ST: "NM",
    cityWithStateAbbr: "Santa Fe, NM",
  },
  {
    zip: "87701",
    ST: "NM",
    cityWithStateAbbr: "Las Vegas, NM",
  },
  {
    zip: "87710",
    ST: "NM",
    cityWithStateAbbr: "Angel Fire, NM",
  },
  {
    zip: "87711",
    ST: "NM",
    cityWithStateAbbr: "Anton Chico, NM",
  },
  {
    zip: "87712",
    ST: "NM",
    cityWithStateAbbr: "Buena Vista, NM",
  },
  {
    zip: "87713",
    ST: "NM",
    cityWithStateAbbr: "Chacon, NM",
  },
  {
    zip: "87714",
    ST: "NM",
    cityWithStateAbbr: "Cimarron, NM",
  },
  {
    zip: "87715",
    ST: "NM",
    cityWithStateAbbr: "Cleveland, NM",
  },
  {
    zip: "87718",
    ST: "NM",
    cityWithStateAbbr: "Eagle Nest, NM",
  },
  {
    zip: "87722",
    ST: "NM",
    cityWithStateAbbr: "Guadalupita, NM",
  },
  {
    zip: "87723",
    ST: "NM",
    cityWithStateAbbr: "Holman, NM",
  },
  {
    zip: "87724",
    ST: "NM",
    cityWithStateAbbr: "La Loma, NM",
  },
  {
    zip: "87728",
    ST: "NM",
    cityWithStateAbbr: "Maxwell, NM",
  },
  {
    zip: "87729",
    ST: "NM",
    cityWithStateAbbr: "Miami, NM",
  },
  {
    zip: "87730",
    ST: "NM",
    cityWithStateAbbr: "Mills, NM",
  },
  {
    zip: "87731",
    ST: "NM",
    cityWithStateAbbr: "Montezuma, NM",
  },
  {
    zip: "87732",
    ST: "NM",
    cityWithStateAbbr: "Mora, NM",
  },
  {
    zip: "87733",
    ST: "NM",
    cityWithStateAbbr: "Mosquero, NM",
  },
  {
    zip: "87734",
    ST: "NM",
    cityWithStateAbbr: "Ocate, NM",
  },
  {
    zip: "87735",
    ST: "NM",
    cityWithStateAbbr: "Ojo Feliz, NM",
  },
  {
    zip: "87736",
    ST: "NM",
    cityWithStateAbbr: "Rainsville, NM",
  },
  {
    zip: "87740",
    ST: "NM",
    cityWithStateAbbr: "Raton, NM",
  },
  {
    zip: "87742",
    ST: "NM",
    cityWithStateAbbr: "Rociada, NM",
  },
  {
    zip: "87743",
    ST: "NM",
    cityWithStateAbbr: "Roy, NM",
  },
  {
    zip: "87745",
    ST: "NM",
    cityWithStateAbbr: "Sapello, NM",
  },
  {
    zip: "87746",
    ST: "NM",
    cityWithStateAbbr: "Solano, NM",
  },
  {
    zip: "87747",
    ST: "NM",
    cityWithStateAbbr: "Springer, NM",
  },
  {
    zip: "87749",
    ST: "NM",
    cityWithStateAbbr: "Ute Park, NM",
  },
  {
    zip: "87750",
    ST: "NM",
    cityWithStateAbbr: "Valmora, NM",
  },
  {
    zip: "87752",
    ST: "NM",
    cityWithStateAbbr: "Wagon Mound, NM",
  },
  {
    zip: "87753",
    ST: "NM",
    cityWithStateAbbr: "Watrous, NM",
  },
  {
    zip: "87801",
    ST: "NM",
    cityWithStateAbbr: "Socorro, NM",
  },
  {
    zip: "87820",
    ST: "NM",
    cityWithStateAbbr: "Aragon, NM",
  },
  {
    zip: "87821",
    ST: "NM",
    cityWithStateAbbr: "Datil, NM",
  },
  {
    zip: "87823",
    ST: "NM",
    cityWithStateAbbr: "Lemitar, NM",
  },
  {
    zip: "87824",
    ST: "NM",
    cityWithStateAbbr: "Luna, NM",
  },
  {
    zip: "87825",
    ST: "NM",
    cityWithStateAbbr: "Magdalena, NM",
  },
  {
    zip: "87827",
    ST: "NM",
    cityWithStateAbbr: "Pie Town, NM",
  },
  {
    zip: "87828",
    ST: "NM",
    cityWithStateAbbr: "Polvadera, NM",
  },
  {
    zip: "87829",
    ST: "NM",
    cityWithStateAbbr: "Quemado, NM",
  },
  {
    zip: "87830",
    ST: "NM",
    cityWithStateAbbr: "Reserve, NM",
  },
  {
    zip: "87831",
    ST: "NM",
    cityWithStateAbbr: "San Acacia, NM",
  },
  {
    zip: "87832",
    ST: "NM",
    cityWithStateAbbr: "San Antonio, NM",
  },
  {
    zip: "87901",
    ST: "NM",
    cityWithStateAbbr: "Truth Or Consequences, NM",
  },
  {
    zip: "87930",
    ST: "NM",
    cityWithStateAbbr: "Arrey, NM",
  },
  {
    zip: "87931",
    ST: "NM",
    cityWithStateAbbr: "Caballo, NM",
  },
  {
    zip: "87933",
    ST: "NM",
    cityWithStateAbbr: "Derry, NM",
  },
  {
    zip: "87935",
    ST: "NM",
    cityWithStateAbbr: "Elephant Butte, NM",
  },
  {
    zip: "87936",
    ST: "NM",
    cityWithStateAbbr: "Garfield, NM",
  },
  {
    zip: "87937",
    ST: "NM",
    cityWithStateAbbr: "Hatch, NM",
  },
  {
    zip: "87939",
    ST: "NM",
    cityWithStateAbbr: "Monticello, NM",
  },
  {
    zip: "87940",
    ST: "NM",
    cityWithStateAbbr: "Rincon, NM",
  },
  {
    zip: "87941",
    ST: "NM",
    cityWithStateAbbr: "Salem, NM",
  },
  {
    zip: "87942",
    ST: "NM",
    cityWithStateAbbr: "Williamsburg, NM",
  },
  {
    zip: "87943",
    ST: "NM",
    cityWithStateAbbr: "Winston, NM",
  },
  {
    zip: "88001",
    ST: "NM",
    cityWithStateAbbr: "Las Cruces, NM",
  },
  {
    zip: "88002",
    ST: "NM",
    cityWithStateAbbr: "White Sands Missile Rang, NM",
  },
  {
    zip: "88003",
    ST: "NM",
    cityWithStateAbbr: "Las Cruces, NM",
  },
  {
    zip: "88004",
    ST: "NM",
    cityWithStateAbbr: "Las Cruces, NM",
  },
  {
    zip: "88005",
    ST: "NM",
    cityWithStateAbbr: "Las Cruces, NM",
  },
  {
    zip: "88006",
    ST: "NM",
    cityWithStateAbbr: "Las Cruces, NM",
  },
  {
    zip: "88007",
    ST: "NM",
    cityWithStateAbbr: "Las Cruces, NM",
  },
  {
    zip: "88008",
    ST: "NM",
    cityWithStateAbbr: "Santa Teresa, NM",
  },
  {
    zip: "88009",
    ST: "NM",
    cityWithStateAbbr: "Playas, NM",
  },
  {
    zip: "88011",
    ST: "NM",
    cityWithStateAbbr: "Las Cruces, NM",
  },
  {
    zip: "88012",
    ST: "NM",
    cityWithStateAbbr: "Las Cruces, NM",
  },
  {
    zip: "88013",
    ST: "NM",
    cityWithStateAbbr: "Las Cruces, NM",
  },
  {
    zip: "88020",
    ST: "NM",
    cityWithStateAbbr: "Animas, NM",
  },
  {
    zip: "88021",
    ST: "NM",
    cityWithStateAbbr: "Anthony, NM",
  },
  {
    zip: "88022",
    ST: "NM",
    cityWithStateAbbr: "Arenas Valley, NM",
  },
  {
    zip: "88023",
    ST: "NM",
    cityWithStateAbbr: "Bayard, NM",
  },
  {
    zip: "88024",
    ST: "NM",
    cityWithStateAbbr: "Berino, NM",
  },
  {
    zip: "88025",
    ST: "NM",
    cityWithStateAbbr: "Buckhorn, NM",
  },
  {
    zip: "88026",
    ST: "NM",
    cityWithStateAbbr: "Santa Clara, NM",
  },
  {
    zip: "88027",
    ST: "NM",
    cityWithStateAbbr: "Chamberino, NM",
  },
  {
    zip: "88028",
    ST: "NM",
    cityWithStateAbbr: "Cliff, NM",
  },
  {
    zip: "88029",
    ST: "NM",
    cityWithStateAbbr: "Columbus, NM",
  },
  {
    zip: "88030",
    ST: "NM",
    cityWithStateAbbr: "Deming, NM",
  },
  {
    zip: "88031",
    ST: "NM",
    cityWithStateAbbr: "Deming, NM",
  },
  {
    zip: "88032",
    ST: "NM",
    cityWithStateAbbr: "Dona Ana, NM",
  },
  {
    zip: "88033",
    ST: "NM",
    cityWithStateAbbr: "Fairacres, NM",
  },
  {
    zip: "88034",
    ST: "NM",
    cityWithStateAbbr: "Faywood, NM",
  },
  {
    zip: "88036",
    ST: "NM",
    cityWithStateAbbr: "Fort Bayard, NM",
  },
  {
    zip: "88038",
    ST: "NM",
    cityWithStateAbbr: "Gila, NM",
  },
  {
    zip: "88039",
    ST: "NM",
    cityWithStateAbbr: "Glenwood, NM",
  },
  {
    zip: "88040",
    ST: "NM",
    cityWithStateAbbr: "Hachita, NM",
  },
  {
    zip: "88041",
    ST: "NM",
    cityWithStateAbbr: "Hanover, NM",
  },
  {
    zip: "88042",
    ST: "NM",
    cityWithStateAbbr: "Hillsboro, NM",
  },
  {
    zip: "88043",
    ST: "NM",
    cityWithStateAbbr: "Hurley, NM",
  },
  {
    zip: "88044",
    ST: "NM",
    cityWithStateAbbr: "La Mesa, NM",
  },
  {
    zip: "88045",
    ST: "NM",
    cityWithStateAbbr: "Lordsburg, NM",
  },
  {
    zip: "88046",
    ST: "NM",
    cityWithStateAbbr: "Mesilla, NM",
  },
  {
    zip: "88047",
    ST: "NM",
    cityWithStateAbbr: "Mesilla Park, NM",
  },
  {
    zip: "88048",
    ST: "NM",
    cityWithStateAbbr: "Mesquite, NM",
  },
  {
    zip: "88049",
    ST: "NM",
    cityWithStateAbbr: "Mimbres, NM",
  },
  {
    zip: "88051",
    ST: "NM",
    cityWithStateAbbr: "Mule Creek, NM",
  },
  {
    zip: "88052",
    ST: "NM",
    cityWithStateAbbr: "Organ, NM",
  },
  {
    zip: "88053",
    ST: "NM",
    cityWithStateAbbr: "Pinos Altos, NM",
  },
  {
    zip: "88054",
    ST: "NM",
    cityWithStateAbbr: "Radium Springs, NM",
  },
  {
    zip: "88055",
    ST: "NM",
    cityWithStateAbbr: "Redrock, NM",
  },
  {
    zip: "88056",
    ST: "NM",
    cityWithStateAbbr: "Rodeo, NM",
  },
  {
    zip: "88058",
    ST: "NM",
    cityWithStateAbbr: "San Miguel, NM",
  },
  {
    zip: "88061",
    ST: "NM",
    cityWithStateAbbr: "Silver City, NM",
  },
  {
    zip: "88062",
    ST: "NM",
    cityWithStateAbbr: "Silver City, NM",
  },
  {
    zip: "88063",
    ST: "NM",
    cityWithStateAbbr: "Sunland Park, NM",
  },
  {
    zip: "88065",
    ST: "NM",
    cityWithStateAbbr: "Tyrone, NM",
  },
  {
    zip: "88072",
    ST: "NM",
    cityWithStateAbbr: "Vado, NM",
  },
  {
    zip: "88081",
    ST: "NM",
    cityWithStateAbbr: "Chaparral, NM",
  },
  {
    zip: "88101",
    ST: "NM",
    cityWithStateAbbr: "Clovis, NM",
  },
  {
    zip: "88102",
    ST: "NM",
    cityWithStateAbbr: "Clovis, NM",
  },
  {
    zip: "88103",
    ST: "NM",
    cityWithStateAbbr: "Cannon Afb, NM",
  },
  {
    zip: "88112",
    ST: "NM",
    cityWithStateAbbr: "Broadview, NM",
  },
  {
    zip: "88113",
    ST: "NM",
    cityWithStateAbbr: "Causey, NM",
  },
  {
    zip: "88114",
    ST: "NM",
    cityWithStateAbbr: "Crossroads, NM",
  },
  {
    zip: "88115",
    ST: "NM",
    cityWithStateAbbr: "Dora, NM",
  },
  {
    zip: "88116",
    ST: "NM",
    cityWithStateAbbr: "Elida, NM",
  },
  {
    zip: "88118",
    ST: "NM",
    cityWithStateAbbr: "Floyd, NM",
  },
  {
    zip: "88119",
    ST: "NM",
    cityWithStateAbbr: "Fort Sumner, NM",
  },
  {
    zip: "88120",
    ST: "NM",
    cityWithStateAbbr: "Grady, NM",
  },
  {
    zip: "88121",
    ST: "NM",
    cityWithStateAbbr: "House, NM",
  },
  {
    zip: "88122",
    ST: "NM",
    cityWithStateAbbr: "Kenna, NM",
  },
  {
    zip: "88123",
    ST: "NM",
    cityWithStateAbbr: "Lingo, NM",
  },
  {
    zip: "88124",
    ST: "NM",
    cityWithStateAbbr: "Melrose, NM",
  },
  {
    zip: "88125",
    ST: "NM",
    cityWithStateAbbr: "Milnesand, NM",
  },
  {
    zip: "88126",
    ST: "NM",
    cityWithStateAbbr: "Pep, NM",
  },
  {
    zip: "88130",
    ST: "NM",
    cityWithStateAbbr: "Portales, NM",
  },
  {
    zip: "88132",
    ST: "NM",
    cityWithStateAbbr: "Rogers, NM",
  },
  {
    zip: "88133",
    ST: "NM",
    cityWithStateAbbr: "Saint Vrain, NM",
  },
  {
    zip: "88134",
    ST: "NM",
    cityWithStateAbbr: "Taiban, NM",
  },
  {
    zip: "88135",
    ST: "NM",
    cityWithStateAbbr: "Texico, NM",
  },
  {
    zip: "88136",
    ST: "NM",
    cityWithStateAbbr: "Yeso, NM",
  },
  {
    zip: "88201",
    ST: "NM",
    cityWithStateAbbr: "Roswell, NM",
  },
  {
    zip: "88202",
    ST: "NM",
    cityWithStateAbbr: "Roswell, NM",
  },
  {
    zip: "88203",
    ST: "NM",
    cityWithStateAbbr: "Roswell, NM",
  },
  {
    zip: "88210",
    ST: "NM",
    cityWithStateAbbr: "Artesia, NM",
  },
  {
    zip: "88211",
    ST: "NM",
    cityWithStateAbbr: "Artesia, NM",
  },
  {
    zip: "88213",
    ST: "NM",
    cityWithStateAbbr: "Caprock, NM",
  },
  {
    zip: "88220",
    ST: "NM",
    cityWithStateAbbr: "Carlsbad, NM",
  },
  {
    zip: "88221",
    ST: "NM",
    cityWithStateAbbr: "Carlsbad, NM",
  },
  {
    zip: "88230",
    ST: "NM",
    cityWithStateAbbr: "Dexter, NM",
  },
  {
    zip: "88231",
    ST: "NM",
    cityWithStateAbbr: "Eunice, NM",
  },
  {
    zip: "88232",
    ST: "NM",
    cityWithStateAbbr: "Hagerman, NM",
  },
  {
    zip: "88240",
    ST: "NM",
    cityWithStateAbbr: "Hobbs, NM",
  },
  {
    zip: "88241",
    ST: "NM",
    cityWithStateAbbr: "Hobbs, NM",
  },
  {
    zip: "88242",
    ST: "NM",
    cityWithStateAbbr: "Hobbs, NM",
  },
  {
    zip: "88244",
    ST: "NM",
    cityWithStateAbbr: "Hobbs, NM",
  },
  {
    zip: "88250",
    ST: "NM",
    cityWithStateAbbr: "Hope, NM",
  },
  {
    zip: "88252",
    ST: "NM",
    cityWithStateAbbr: "Jal, NM",
  },
  {
    zip: "88253",
    ST: "NM",
    cityWithStateAbbr: "Lake Arthur, NM",
  },
  {
    zip: "88254",
    ST: "NM",
    cityWithStateAbbr: "Lakewood, NM",
  },
  {
    zip: "88255",
    ST: "NM",
    cityWithStateAbbr: "Loco Hills, NM",
  },
  {
    zip: "88256",
    ST: "NM",
    cityWithStateAbbr: "Loving, NM",
  },
  {
    zip: "88260",
    ST: "NM",
    cityWithStateAbbr: "Lovington, NM",
  },
  {
    zip: "88262",
    ST: "NM",
    cityWithStateAbbr: "Mcdonald, NM",
  },
  {
    zip: "88263",
    ST: "NM",
    cityWithStateAbbr: "Malaga, NM",
  },
  {
    zip: "88264",
    ST: "NM",
    cityWithStateAbbr: "Maljamar, NM",
  },
  {
    zip: "88265",
    ST: "NM",
    cityWithStateAbbr: "Monument, NM",
  },
  {
    zip: "88267",
    ST: "NM",
    cityWithStateAbbr: "Tatum, NM",
  },
  {
    zip: "88268",
    ST: "NM",
    cityWithStateAbbr: "Whites City, NM",
  },
  {
    zip: "88301",
    ST: "NM",
    cityWithStateAbbr: "Carrizozo, NM",
  },
  {
    zip: "88310",
    ST: "NM",
    cityWithStateAbbr: "Alamogordo, NM",
  },
  {
    zip: "88311",
    ST: "NM",
    cityWithStateAbbr: "Alamogordo, NM",
  },
  {
    zip: "88312",
    ST: "NM",
    cityWithStateAbbr: "Alto, NM",
  },
  {
    zip: "88314",
    ST: "NM",
    cityWithStateAbbr: "Bent, NM",
  },
  {
    zip: "88316",
    ST: "NM",
    cityWithStateAbbr: "Capitan, NM",
  },
  {
    zip: "88317",
    ST: "NM",
    cityWithStateAbbr: "Cloudcroft, NM",
  },
  {
    zip: "88318",
    ST: "NM",
    cityWithStateAbbr: "Corona, NM",
  },
  {
    zip: "88321",
    ST: "NM",
    cityWithStateAbbr: "Encino, NM",
  },
  {
    zip: "88323",
    ST: "NM",
    cityWithStateAbbr: "Fort Stanton, NM",
  },
  {
    zip: "88324",
    ST: "NM",
    cityWithStateAbbr: "Glencoe, NM",
  },
  {
    zip: "88325",
    ST: "NM",
    cityWithStateAbbr: "High Rolls Mountain Park, NM",
  },
  {
    zip: "88330",
    ST: "NM",
    cityWithStateAbbr: "Holloman Air Force Base, NM",
  },
  {
    zip: "88336",
    ST: "NM",
    cityWithStateAbbr: "Hondo, NM",
  },
  {
    zip: "88337",
    ST: "NM",
    cityWithStateAbbr: "La Luz, NM",
  },
  {
    zip: "88338",
    ST: "NM",
    cityWithStateAbbr: "Lincoln, NM",
  },
  {
    zip: "88339",
    ST: "NM",
    cityWithStateAbbr: "Mayhill, NM",
  },
  {
    zip: "88340",
    ST: "NM",
    cityWithStateAbbr: "Mescalero, NM",
  },
  {
    zip: "88341",
    ST: "NM",
    cityWithStateAbbr: "Nogal, NM",
  },
  {
    zip: "88342",
    ST: "NM",
    cityWithStateAbbr: "Orogrande, NM",
  },
  {
    zip: "88343",
    ST: "NM",
    cityWithStateAbbr: "Picacho, NM",
  },
  {
    zip: "88344",
    ST: "NM",
    cityWithStateAbbr: "Pinon, NM",
  },
  {
    zip: "88345",
    ST: "NM",
    cityWithStateAbbr: "Ruidoso, NM",
  },
  {
    zip: "88346",
    ST: "NM",
    cityWithStateAbbr: "Ruidoso Downs, NM",
  },
  {
    zip: "88347",
    ST: "NM",
    cityWithStateAbbr: "Sacramento, NM",
  },
  {
    zip: "88348",
    ST: "NM",
    cityWithStateAbbr: "San Patricio, NM",
  },
  {
    zip: "88349",
    ST: "NM",
    cityWithStateAbbr: "Sunspot, NM",
  },
  {
    zip: "88350",
    ST: "NM",
    cityWithStateAbbr: "Timberon, NM",
  },
  {
    zip: "88351",
    ST: "NM",
    cityWithStateAbbr: "Tinnie, NM",
  },
  {
    zip: "88352",
    ST: "NM",
    cityWithStateAbbr: "Tularosa, NM",
  },
  {
    zip: "88353",
    ST: "NM",
    cityWithStateAbbr: "Vaughn, NM",
  },
  {
    zip: "88354",
    ST: "NM",
    cityWithStateAbbr: "Weed, NM",
  },
  {
    zip: "88355",
    ST: "NM",
    cityWithStateAbbr: "Ruidoso, NM",
  },
  {
    zip: "88401",
    ST: "NM",
    cityWithStateAbbr: "Tucumcari, NM",
  },
  {
    zip: "88410",
    ST: "NM",
    cityWithStateAbbr: "Amistad, NM",
  },
  {
    zip: "88411",
    ST: "NM",
    cityWithStateAbbr: "Bard, NM",
  },
  {
    zip: "88414",
    ST: "NM",
    cityWithStateAbbr: "Capulin, NM",
  },
  {
    zip: "88415",
    ST: "NM",
    cityWithStateAbbr: "Clayton, NM",
  },
  {
    zip: "88416",
    ST: "NM",
    cityWithStateAbbr: "Conchas Dam, NM",
  },
  {
    zip: "88417",
    ST: "NM",
    cityWithStateAbbr: "Cuervo, NM",
  },
  {
    zip: "88418",
    ST: "NM",
    cityWithStateAbbr: "Des Moines, NM",
  },
  {
    zip: "88419",
    ST: "NM",
    cityWithStateAbbr: "Folsom, NM",
  },
  {
    zip: "88421",
    ST: "NM",
    cityWithStateAbbr: "Garita, NM",
  },
  {
    zip: "88422",
    ST: "NM",
    cityWithStateAbbr: "Gladstone, NM",
  },
  {
    zip: "88424",
    ST: "NM",
    cityWithStateAbbr: "Grenville, NM",
  },
  {
    zip: "88426",
    ST: "NM",
    cityWithStateAbbr: "Logan, NM",
  },
  {
    zip: "88427",
    ST: "NM",
    cityWithStateAbbr: "Mcalister, NM",
  },
  {
    zip: "88430",
    ST: "NM",
    cityWithStateAbbr: "Nara Visa, NM",
  },
  {
    zip: "88431",
    ST: "NM",
    cityWithStateAbbr: "Newkirk, NM",
  },
  {
    zip: "88433",
    ST: "NM",
    cityWithStateAbbr: "Quay, NM",
  },
  {
    zip: "88434",
    ST: "NM",
    cityWithStateAbbr: "San Jon, NM",
  },
  {
    zip: "88435",
    ST: "NM",
    cityWithStateAbbr: "Santa Rosa, NM",
  },
  {
    zip: "88436",
    ST: "NM",
    cityWithStateAbbr: "Sedan, NM",
  },
  {
    zip: "88439",
    ST: "NM",
    cityWithStateAbbr: "Trementina, NM",
  },
  {
    zip: "88510",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88511",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88512",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88513",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88514",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88515",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88516",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88517",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88518",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88519",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88520",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88521",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88523",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88524",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88525",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88526",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88527",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88528",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88529",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88530",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88531",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88532",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88533",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88534",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88535",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88536",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88538",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88539",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88540",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88541",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88542",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88543",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88544",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88545",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88546",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88547",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88548",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88549",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88550",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88553",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88554",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88555",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88556",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88557",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88558",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88559",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88560",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88561",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88562",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88563",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88565",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88566",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88567",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88568",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88569",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88570",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88571",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88572",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88573",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88574",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88575",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88576",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88577",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88578",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88579",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88580",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88581",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88582",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88583",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88584",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88585",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88586",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88587",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88588",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88589",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88590",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88595",
    ST: "TX",
    cityWithStateAbbr: "El Paso, TX",
  },
  {
    zip: "88901",
    ST: "NV",
    cityWithStateAbbr: "The Lakes, NV",
  },
  {
    zip: "88905",
    ST: "NV",
    cityWithStateAbbr: "The Lakes, NV",
  },
  {
    zip: "89001",
    ST: "NV",
    cityWithStateAbbr: "Alamo, NV",
  },
  {
    zip: "89002",
    ST: "NV",
    cityWithStateAbbr: "Henderson, NV",
  },
  {
    zip: "89003",
    ST: "NV",
    cityWithStateAbbr: "Beatty, NV",
  },
  {
    zip: "89004",
    ST: "NV",
    cityWithStateAbbr: "Blue Diamond, NV",
  },
  {
    zip: "89005",
    ST: "NV",
    cityWithStateAbbr: "Boulder City, NV",
  },
  {
    zip: "89006",
    ST: "NV",
    cityWithStateAbbr: "Boulder City, NV",
  },
  {
    zip: "89007",
    ST: "NV",
    cityWithStateAbbr: "Bunkerville, NV",
  },
  {
    zip: "89008",
    ST: "NV",
    cityWithStateAbbr: "Caliente, NV",
  },
  {
    zip: "89009",
    ST: "NV",
    cityWithStateAbbr: "Henderson, NV",
  },
  {
    zip: "89010",
    ST: "NV",
    cityWithStateAbbr: "Dyer, NV",
  },
  {
    zip: "89011",
    ST: "NV",
    cityWithStateAbbr: "Henderson, NV",
  },
  {
    zip: "89012",
    ST: "NV",
    cityWithStateAbbr: "Henderson, NV",
  },
  {
    zip: "89013",
    ST: "NV",
    cityWithStateAbbr: "Goldfield, NV",
  },
  {
    zip: "89014",
    ST: "NV",
    cityWithStateAbbr: "Henderson, NV",
  },
  {
    zip: "89015",
    ST: "NV",
    cityWithStateAbbr: "Henderson, NV",
  },
  {
    zip: "89016",
    ST: "NV",
    cityWithStateAbbr: "Henderson, NV",
  },
  {
    zip: "89017",
    ST: "NV",
    cityWithStateAbbr: "Hiko, NV",
  },
  {
    zip: "89018",
    ST: "NV",
    cityWithStateAbbr: "Indian Springs, NV",
  },
  {
    zip: "89019",
    ST: "CA",
    cityWithStateAbbr: "Jean, CA",
  },
  {
    zip: "89020",
    ST: "NV",
    cityWithStateAbbr: "Amargosa Valley, NV",
  },
  {
    zip: "89021",
    ST: "NV",
    cityWithStateAbbr: "Logandale, NV",
  },
  {
    zip: "89022",
    ST: "NV",
    cityWithStateAbbr: "Manhattan, NV",
  },
  {
    zip: "89023",
    ST: "NV",
    cityWithStateAbbr: "Mercury, NV",
  },
  {
    zip: "89024",
    ST: "NV",
    cityWithStateAbbr: "Mesquite, NV",
  },
  {
    zip: "89025",
    ST: "NV",
    cityWithStateAbbr: "Moapa, NV",
  },
  {
    zip: "89026",
    ST: "NV",
    cityWithStateAbbr: "Jean, NV",
  },
  {
    zip: "89027",
    ST: "NV",
    cityWithStateAbbr: "Mesquite, NV",
  },
  {
    zip: "89028",
    ST: "NV",
    cityWithStateAbbr: "Laughlin, NV",
  },
  {
    zip: "89029",
    ST: "NV",
    cityWithStateAbbr: "Laughlin, NV",
  },
  {
    zip: "89030",
    ST: "NV",
    cityWithStateAbbr: "North Las Vegas, NV",
  },
  {
    zip: "89031",
    ST: "NV",
    cityWithStateAbbr: "North Las Vegas, NV",
  },
  {
    zip: "89032",
    ST: "NV",
    cityWithStateAbbr: "North Las Vegas, NV",
  },
  {
    zip: "89033",
    ST: "NV",
    cityWithStateAbbr: "North Las Vegas, NV",
  },
  {
    zip: "89034",
    ST: "NV",
    cityWithStateAbbr: "Mesquite, NV",
  },
  {
    zip: "89036",
    ST: "NV",
    cityWithStateAbbr: "North Las Vegas, NV",
  },
  {
    zip: "89037",
    ST: "NV",
    cityWithStateAbbr: "Coyote Springs, NV",
  },
  {
    zip: "89039",
    ST: "NV",
    cityWithStateAbbr: "Cal Nev Ari, NV",
  },
  {
    zip: "89040",
    ST: "NV",
    cityWithStateAbbr: "Overton, NV",
  },
  {
    zip: "89041",
    ST: "NV",
    cityWithStateAbbr: "Pahrump, NV",
  },
  {
    zip: "89042",
    ST: "NV",
    cityWithStateAbbr: "Panaca, NV",
  },
  {
    zip: "89043",
    ST: "NV",
    cityWithStateAbbr: "Pioche, NV",
  },
  {
    zip: "89044",
    ST: "NV",
    cityWithStateAbbr: "Henderson, NV",
  },
  {
    zip: "89045",
    ST: "NV",
    cityWithStateAbbr: "Round Mountain, NV",
  },
  {
    zip: "89046",
    ST: "NV",
    cityWithStateAbbr: "Searchlight, NV",
  },
  {
    zip: "89047",
    ST: "NV",
    cityWithStateAbbr: "Silverpeak, NV",
  },
  {
    zip: "89048",
    ST: "NV",
    cityWithStateAbbr: "Pahrump, NV",
  },
  {
    zip: "89049",
    ST: "NV",
    cityWithStateAbbr: "Tonopah, NV",
  },
  {
    zip: "89052",
    ST: "NV",
    cityWithStateAbbr: "Henderson, NV",
  },
  {
    zip: "89053",
    ST: "NV",
    cityWithStateAbbr: "Henderson, NV",
  },
  {
    zip: "89054",
    ST: "NV",
    cityWithStateAbbr: "Sloan, NV",
  },
  {
    zip: "89060",
    ST: "NV",
    cityWithStateAbbr: "Pahrump, NV",
  },
  {
    zip: "89061",
    ST: "NV",
    cityWithStateAbbr: "Pahrump, NV",
  },
  {
    zip: "89067",
    ST: "NV",
    cityWithStateAbbr: "Coyote Springs, NV",
  },
  {
    zip: "89070",
    ST: "NV",
    cityWithStateAbbr: "Indian Springs, NV",
  },
  {
    zip: "89074",
    ST: "NV",
    cityWithStateAbbr: "Henderson, NV",
  },
  {
    zip: "89077",
    ST: "NV",
    cityWithStateAbbr: "Henderson, NV",
  },
  {
    zip: "89081",
    ST: "NV",
    cityWithStateAbbr: "North Las Vegas, NV",
  },
  {
    zip: "89084",
    ST: "NV",
    cityWithStateAbbr: "North Las Vegas, NV",
  },
  {
    zip: "89085",
    ST: "NV",
    cityWithStateAbbr: "North Las Vegas, NV",
  },
  {
    zip: "89086",
    ST: "NV",
    cityWithStateAbbr: "North Las Vegas, NV",
  },
  {
    zip: "89087",
    ST: "NV",
    cityWithStateAbbr: "North Las Vegas, NV",
  },
  {
    zip: "89101",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89102",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89103",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89104",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89105",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89106",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89107",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89108",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89109",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89110",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89111",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89112",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89113",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89114",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89115",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89116",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89117",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89118",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89119",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89120",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89121",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89122",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89123",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89124",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89125",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89126",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89127",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89128",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89129",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89130",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89131",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89132",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89133",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89134",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89135",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89136",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89137",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89138",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89139",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89140",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89141",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89142",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89143",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89144",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89145",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89146",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89147",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89148",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89149",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89150",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89151",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89152",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89153",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89154",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89155",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89156",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89157",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89158",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89159",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89160",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89161",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89162",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89163",
    ST: "NV",
    cityWithStateAbbr: "The Lakes, NV",
  },
  {
    zip: "89164",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89165",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89166",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89169",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89170",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89173",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89177",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89178",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89179",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89180",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89183",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89185",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89191",
    ST: "NV",
    cityWithStateAbbr: "Nellis Afb, NV",
  },
  {
    zip: "89193",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89195",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89199",
    ST: "NV",
    cityWithStateAbbr: "Las Vegas, NV",
  },
  {
    zip: "89301",
    ST: "NV",
    cityWithStateAbbr: "Ely, NV",
  },
  {
    zip: "89310",
    ST: "NV",
    cityWithStateAbbr: "Austin, NV",
  },
  {
    zip: "89311",
    ST: "NV",
    cityWithStateAbbr: "Baker, NV",
  },
  {
    zip: "89314",
    ST: "NV",
    cityWithStateAbbr: "Duckwater, NV",
  },
  {
    zip: "89315",
    ST: "NV",
    cityWithStateAbbr: "Ely, NV",
  },
  {
    zip: "89316",
    ST: "NV",
    cityWithStateAbbr: "Eureka, NV",
  },
  {
    zip: "89317",
    ST: "NV",
    cityWithStateAbbr: "Lund, NV",
  },
  {
    zip: "89318",
    ST: "NV",
    cityWithStateAbbr: "Mc Gill, NV",
  },
  {
    zip: "89319",
    ST: "NV",
    cityWithStateAbbr: "Ruth, NV",
  },
  {
    zip: "89402",
    ST: "NV",
    cityWithStateAbbr: "Crystal Bay, NV",
  },
  {
    zip: "89403",
    ST: "NV",
    cityWithStateAbbr: "Dayton, NV",
  },
  {
    zip: "89404",
    ST: "NV",
    cityWithStateAbbr: "Denio, NV",
  },
  {
    zip: "89405",
    ST: "NV",
    cityWithStateAbbr: "Empire, NV",
  },
  {
    zip: "89406",
    ST: "NV",
    cityWithStateAbbr: "Fallon, NV",
  },
  {
    zip: "89407",
    ST: "NV",
    cityWithStateAbbr: "Fallon, NV",
  },
  {
    zip: "89408",
    ST: "NV",
    cityWithStateAbbr: "Fernley, NV",
  },
  {
    zip: "89409",
    ST: "NV",
    cityWithStateAbbr: "Gabbs, NV",
  },
  {
    zip: "89410",
    ST: "NV",
    cityWithStateAbbr: "Gardnerville, NV",
  },
  {
    zip: "89411",
    ST: "NV",
    cityWithStateAbbr: "Genoa, NV",
  },
  {
    zip: "89412",
    ST: "NV",
    cityWithStateAbbr: "Gerlach, NV",
  },
  {
    zip: "89413",
    ST: "NV",
    cityWithStateAbbr: "Glenbrook, NV",
  },
  {
    zip: "89414",
    ST: "NV",
    cityWithStateAbbr: "Golconda, NV",
  },
  {
    zip: "89415",
    ST: "NV",
    cityWithStateAbbr: "Hawthorne, NV",
  },
  {
    zip: "89418",
    ST: "NV",
    cityWithStateAbbr: "Imlay, NV",
  },
  {
    zip: "89419",
    ST: "NV",
    cityWithStateAbbr: "Lovelock, NV",
  },
  {
    zip: "89420",
    ST: "NV",
    cityWithStateAbbr: "Luning, NV",
  },
  {
    zip: "89421",
    ST: "OR",
    cityWithStateAbbr: "Mc Dermitt, OR",
  },
  {
    zip: "89422",
    ST: "NV",
    cityWithStateAbbr: "Mina, NV",
  },
  {
    zip: "89423",
    ST: "NV",
    cityWithStateAbbr: "Minden, NV",
  },
  {
    zip: "89424",
    ST: "NV",
    cityWithStateAbbr: "Nixon, NV",
  },
  {
    zip: "89425",
    ST: "NV",
    cityWithStateAbbr: "Orovada, NV",
  },
  {
    zip: "89426",
    ST: "NV",
    cityWithStateAbbr: "Paradise Valley, NV",
  },
  {
    zip: "89427",
    ST: "NV",
    cityWithStateAbbr: "Schurz, NV",
  },
  {
    zip: "89428",
    ST: "NV",
    cityWithStateAbbr: "Silver City, NV",
  },
  {
    zip: "89429",
    ST: "NV",
    cityWithStateAbbr: "Silver Springs, NV",
  },
  {
    zip: "89430",
    ST: "NV",
    cityWithStateAbbr: "Smith, NV",
  },
  {
    zip: "89431",
    ST: "NV",
    cityWithStateAbbr: "Sparks, NV",
  },
  {
    zip: "89432",
    ST: "NV",
    cityWithStateAbbr: "Sparks, NV",
  },
  {
    zip: "89433",
    ST: "NV",
    cityWithStateAbbr: "Sun Valley, NV",
  },
  {
    zip: "89434",
    ST: "NV",
    cityWithStateAbbr: "Sparks, NV",
  },
  {
    zip: "89435",
    ST: "NV",
    cityWithStateAbbr: "Sparks, NV",
  },
  {
    zip: "89436",
    ST: "NV",
    cityWithStateAbbr: "Sparks, NV",
  },
  {
    zip: "89438",
    ST: "NV",
    cityWithStateAbbr: "Valmy, NV",
  },
  {
    zip: "89439",
    ST: "CA",
    cityWithStateAbbr: "Verdi, CA",
  },
  {
    zip: "89440",
    ST: "NV",
    cityWithStateAbbr: "Virginia City, NV",
  },
  {
    zip: "89441",
    ST: "NV",
    cityWithStateAbbr: "Sparks, NV",
  },
  {
    zip: "89442",
    ST: "NV",
    cityWithStateAbbr: "Wadsworth, NV",
  },
  {
    zip: "89444",
    ST: "NV",
    cityWithStateAbbr: "Wellington, NV",
  },
  {
    zip: "89445",
    ST: "NV",
    cityWithStateAbbr: "Winnemucca, NV",
  },
  {
    zip: "89446",
    ST: "NV",
    cityWithStateAbbr: "Winnemucca, NV",
  },
  {
    zip: "89447",
    ST: "NV",
    cityWithStateAbbr: "Yerington, NV",
  },
  {
    zip: "89448",
    ST: "NV",
    cityWithStateAbbr: "Zephyr Cove, NV",
  },
  {
    zip: "89449",
    ST: "NV",
    cityWithStateAbbr: "Stateline, NV",
  },
  {
    zip: "89450",
    ST: "NV",
    cityWithStateAbbr: "Incline Village, NV",
  },
  {
    zip: "89451",
    ST: "NV",
    cityWithStateAbbr: "Incline Village, NV",
  },
  {
    zip: "89452",
    ST: "NV",
    cityWithStateAbbr: "Incline Village, NV",
  },
  {
    zip: "89460",
    ST: "NV",
    cityWithStateAbbr: "Gardnerville, NV",
  },
  {
    zip: "89496",
    ST: "NV",
    cityWithStateAbbr: "Fallon, NV",
  },
  {
    zip: "89501",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89502",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89503",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89504",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89505",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89506",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89507",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89508",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89509",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89510",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89511",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89512",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89513",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89515",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89519",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89520",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89521",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89523",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89533",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89555",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89557",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89570",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89595",
    ST: "NV",
    cityWithStateAbbr: "Reno, NV",
  },
  {
    zip: "89701",
    ST: "NV",
    cityWithStateAbbr: "Carson City, NV",
  },
  {
    zip: "89702",
    ST: "NV",
    cityWithStateAbbr: "Carson City, NV",
  },
  {
    zip: "89703",
    ST: "NV",
    cityWithStateAbbr: "Carson City, NV",
  },
  {
    zip: "89704",
    ST: "NV",
    cityWithStateAbbr: "Washoe Valley, NV",
  },
  {
    zip: "89705",
    ST: "NV",
    cityWithStateAbbr: "Carson City, NV",
  },
  {
    zip: "89706",
    ST: "NV",
    cityWithStateAbbr: "Carson City, NV",
  },
  {
    zip: "89711",
    ST: "NV",
    cityWithStateAbbr: "Carson City, NV",
  },
  {
    zip: "89712",
    ST: "NV",
    cityWithStateAbbr: "Carson City, NV",
  },
  {
    zip: "89713",
    ST: "NV",
    cityWithStateAbbr: "Carson City, NV",
  },
  {
    zip: "89714",
    ST: "NV",
    cityWithStateAbbr: "Carson City, NV",
  },
  {
    zip: "89721",
    ST: "NV",
    cityWithStateAbbr: "Carson City, NV",
  },
  {
    zip: "89801",
    ST: "NV",
    cityWithStateAbbr: "Elko, NV",
  },
  {
    zip: "89802",
    ST: "NV",
    cityWithStateAbbr: "Elko, NV",
  },
  {
    zip: "89803",
    ST: "NV",
    cityWithStateAbbr: "Elko, NV",
  },
  {
    zip: "89815",
    ST: "NV",
    cityWithStateAbbr: "Spring Creek, NV",
  },
  {
    zip: "89820",
    ST: "NV",
    cityWithStateAbbr: "Battle Mountain, NV",
  },
  {
    zip: "89821",
    ST: "NV",
    cityWithStateAbbr: "Crescent Valley, NV",
  },
  {
    zip: "89822",
    ST: "NV",
    cityWithStateAbbr: "Carlin, NV",
  },
  {
    zip: "89823",
    ST: "NV",
    cityWithStateAbbr: "Deeth, NV",
  },
  {
    zip: "89825",
    ST: "NV",
    cityWithStateAbbr: "Jackpot, NV",
  },
  {
    zip: "89826",
    ST: "NV",
    cityWithStateAbbr: "Jarbidge, NV",
  },
  {
    zip: "89828",
    ST: "NV",
    cityWithStateAbbr: "Lamoille, NV",
  },
  {
    zip: "89830",
    ST: "NV",
    cityWithStateAbbr: "Montello, NV",
  },
  {
    zip: "89831",
    ST: "NV",
    cityWithStateAbbr: "Mountain City, NV",
  },
  {
    zip: "89832",
    ST: "NV",
    cityWithStateAbbr: "Owyhee, NV",
  },
  {
    zip: "89833",
    ST: "NV",
    cityWithStateAbbr: "Ruby Valley, NV",
  },
  {
    zip: "89834",
    ST: "NV",
    cityWithStateAbbr: "Tuscarora, NV",
  },
  {
    zip: "89835",
    ST: "NV",
    cityWithStateAbbr: "Wells, NV",
  },
  {
    zip: "89883",
    ST: "NV",
    cityWithStateAbbr: "West Wendover, NV",
  },
  {
    zip: "90001",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90002",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90003",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90004",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90005",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90006",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90007",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90008",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90009",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90010",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90011",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90012",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90013",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90014",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90015",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90016",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90017",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90018",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90019",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90020",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90021",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90022",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90023",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90024",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90025",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90026",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90027",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90028",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90029",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90030",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90031",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90032",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90033",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90034",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90035",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90036",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90037",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90038",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90039",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90040",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90041",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90042",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90043",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90044",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90045",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90046",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90047",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90048",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90049",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90050",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90051",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90052",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90053",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90054",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90055",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90056",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90057",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90058",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90059",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90060",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90061",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90062",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90063",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90064",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90065",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90066",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90067",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90068",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90069",
    ST: "CA",
    cityWithStateAbbr: "West Hollywood, CA",
  },
  {
    zip: "90070",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90071",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90072",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90073",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90074",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90075",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90076",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90077",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90078",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90079",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90080",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90081",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90082",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90083",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90084",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90086",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90087",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90088",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90089",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90091",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90093",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90094",
    ST: "CA",
    cityWithStateAbbr: "Playa Vista, CA",
  },
  {
    zip: "90095",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90096",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90099",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90101",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90103",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90189",
    ST: "CA",
    cityWithStateAbbr: "Los Angeles, CA",
  },
  {
    zip: "90201",
    ST: "CA",
    cityWithStateAbbr: "Bell Gardens, CA",
  },
  {
    zip: "90202",
    ST: "CA",
    cityWithStateAbbr: "Bell, CA",
  },
  {
    zip: "90209",
    ST: "CA",
    cityWithStateAbbr: "Beverly Hills, CA",
  },
  {
    zip: "90210",
    ST: "CA",
    cityWithStateAbbr: "Beverly Hills, CA",
  },
  {
    zip: "90211",
    ST: "CA",
    cityWithStateAbbr: "Beverly Hills, CA",
  },
  {
    zip: "90212",
    ST: "CA",
    cityWithStateAbbr: "Beverly Hills, CA",
  },
  {
    zip: "90213",
    ST: "CA",
    cityWithStateAbbr: "Beverly Hills, CA",
  },
  {
    zip: "90220",
    ST: "CA",
    cityWithStateAbbr: "Compton, CA",
  },
  {
    zip: "90221",
    ST: "CA",
    cityWithStateAbbr: "Compton, CA",
  },
  {
    zip: "90222",
    ST: "CA",
    cityWithStateAbbr: "Compton, CA",
  },
  {
    zip: "90223",
    ST: "CA",
    cityWithStateAbbr: "Compton, CA",
  },
  {
    zip: "90224",
    ST: "CA",
    cityWithStateAbbr: "Compton, CA",
  },
  {
    zip: "90230",
    ST: "CA",
    cityWithStateAbbr: "Culver City, CA",
  },
  {
    zip: "90231",
    ST: "CA",
    cityWithStateAbbr: "Culver City, CA",
  },
  {
    zip: "90232",
    ST: "CA",
    cityWithStateAbbr: "Culver City, CA",
  },
  {
    zip: "90233",
    ST: "CA",
    cityWithStateAbbr: "Culver City, CA",
  },
  {
    zip: "90239",
    ST: "CA",
    cityWithStateAbbr: "Downey, CA",
  },
  {
    zip: "90240",
    ST: "CA",
    cityWithStateAbbr: "Downey, CA",
  },
  {
    zip: "90241",
    ST: "CA",
    cityWithStateAbbr: "Downey, CA",
  },
  {
    zip: "90242",
    ST: "CA",
    cityWithStateAbbr: "Downey, CA",
  },
  {
    zip: "90245",
    ST: "CA",
    cityWithStateAbbr: "El Segundo, CA",
  },
  {
    zip: "90247",
    ST: "CA",
    cityWithStateAbbr: "Gardena, CA",
  },
  {
    zip: "90248",
    ST: "CA",
    cityWithStateAbbr: "Gardena, CA",
  },
  {
    zip: "90249",
    ST: "CA",
    cityWithStateAbbr: "Gardena, CA",
  },
  {
    zip: "90250",
    ST: "CA",
    cityWithStateAbbr: "Hawthorne, CA",
  },
  {
    zip: "90251",
    ST: "CA",
    cityWithStateAbbr: "Hawthorne, CA",
  },
  {
    zip: "90254",
    ST: "CA",
    cityWithStateAbbr: "Hermosa Beach, CA",
  },
  {
    zip: "90255",
    ST: "CA",
    cityWithStateAbbr: "Huntington Park, CA",
  },
  {
    zip: "90260",
    ST: "CA",
    cityWithStateAbbr: "Lawndale, CA",
  },
  {
    zip: "90261",
    ST: "CA",
    cityWithStateAbbr: "Lawndale, CA",
  },
  {
    zip: "90262",
    ST: "CA",
    cityWithStateAbbr: "Lynwood, CA",
  },
  {
    zip: "90263",
    ST: "CA",
    cityWithStateAbbr: "Malibu, CA",
  },
  {
    zip: "90264",
    ST: "CA",
    cityWithStateAbbr: "Malibu, CA",
  },
  {
    zip: "90265",
    ST: "CA",
    cityWithStateAbbr: "Malibu, CA",
  },
  {
    zip: "90266",
    ST: "CA",
    cityWithStateAbbr: "Manhattan Beach, CA",
  },
  {
    zip: "90267",
    ST: "CA",
    cityWithStateAbbr: "Manhattan Beach, CA",
  },
  {
    zip: "90270",
    ST: "CA",
    cityWithStateAbbr: "Maywood, CA",
  },
  {
    zip: "90272",
    ST: "CA",
    cityWithStateAbbr: "Pacific Palisades, CA",
  },
  {
    zip: "90274",
    ST: "CA",
    cityWithStateAbbr: "Palos Verdes Peninsula, CA",
  },
  {
    zip: "90275",
    ST: "CA",
    cityWithStateAbbr: "Rancho Palos Verdes, CA",
  },
  {
    zip: "90277",
    ST: "CA",
    cityWithStateAbbr: "Redondo Beach, CA",
  },
  {
    zip: "90278",
    ST: "CA",
    cityWithStateAbbr: "Redondo Beach, CA",
  },
  {
    zip: "90280",
    ST: "CA",
    cityWithStateAbbr: "South Gate, CA",
  },
  {
    zip: "90290",
    ST: "CA",
    cityWithStateAbbr: "Topanga, CA",
  },
  {
    zip: "90291",
    ST: "CA",
    cityWithStateAbbr: "Venice, CA",
  },
  {
    zip: "90292",
    ST: "CA",
    cityWithStateAbbr: "Marina Del Rey, CA",
  },
  {
    zip: "90293",
    ST: "CA",
    cityWithStateAbbr: "Playa Del Rey, CA",
  },
  {
    zip: "90294",
    ST: "CA",
    cityWithStateAbbr: "Venice, CA",
  },
  {
    zip: "90295",
    ST: "CA",
    cityWithStateAbbr: "Marina Del Rey, CA",
  },
  {
    zip: "90296",
    ST: "CA",
    cityWithStateAbbr: "Playa Del Rey, CA",
  },
  {
    zip: "90301",
    ST: "CA",
    cityWithStateAbbr: "Inglewood, CA",
  },
  {
    zip: "90302",
    ST: "CA",
    cityWithStateAbbr: "Inglewood, CA",
  },
  {
    zip: "90303",
    ST: "CA",
    cityWithStateAbbr: "Inglewood, CA",
  },
  {
    zip: "90304",
    ST: "CA",
    cityWithStateAbbr: "Inglewood, CA",
  },
  {
    zip: "90305",
    ST: "CA",
    cityWithStateAbbr: "Inglewood, CA",
  },
  {
    zip: "90306",
    ST: "CA",
    cityWithStateAbbr: "Inglewood, CA",
  },
  {
    zip: "90307",
    ST: "CA",
    cityWithStateAbbr: "Inglewood, CA",
  },
  {
    zip: "90308",
    ST: "CA",
    cityWithStateAbbr: "Inglewood, CA",
  },
  {
    zip: "90309",
    ST: "CA",
    cityWithStateAbbr: "Inglewood, CA",
  },
  {
    zip: "90310",
    ST: "CA",
    cityWithStateAbbr: "Inglewood, CA",
  },
  {
    zip: "90311",
    ST: "CA",
    cityWithStateAbbr: "Inglewood, CA",
  },
  {
    zip: "90312",
    ST: "CA",
    cityWithStateAbbr: "Inglewood, CA",
  },
  {
    zip: "90401",
    ST: "CA",
    cityWithStateAbbr: "Santa Monica, CA",
  },
  {
    zip: "90402",
    ST: "CA",
    cityWithStateAbbr: "Santa Monica, CA",
  },
  {
    zip: "90403",
    ST: "CA",
    cityWithStateAbbr: "Santa Monica, CA",
  },
  {
    zip: "90404",
    ST: "CA",
    cityWithStateAbbr: "Santa Monica, CA",
  },
  {
    zip: "90405",
    ST: "CA",
    cityWithStateAbbr: "Santa Monica, CA",
  },
  {
    zip: "90406",
    ST: "CA",
    cityWithStateAbbr: "Santa Monica, CA",
  },
  {
    zip: "90407",
    ST: "CA",
    cityWithStateAbbr: "Santa Monica, CA",
  },
  {
    zip: "90408",
    ST: "CA",
    cityWithStateAbbr: "Santa Monica, CA",
  },
  {
    zip: "90409",
    ST: "CA",
    cityWithStateAbbr: "Santa Monica, CA",
  },
  {
    zip: "90410",
    ST: "CA",
    cityWithStateAbbr: "Santa Monica, CA",
  },
  {
    zip: "90411",
    ST: "CA",
    cityWithStateAbbr: "Santa Monica, CA",
  },
  {
    zip: "90501",
    ST: "CA",
    cityWithStateAbbr: "Torrance, CA",
  },
  {
    zip: "90502",
    ST: "CA",
    cityWithStateAbbr: "Torrance, CA",
  },
  {
    zip: "90503",
    ST: "CA",
    cityWithStateAbbr: "Torrance, CA",
  },
  {
    zip: "90504",
    ST: "CA",
    cityWithStateAbbr: "Torrance, CA",
  },
  {
    zip: "90505",
    ST: "CA",
    cityWithStateAbbr: "Torrance, CA",
  },
  {
    zip: "90506",
    ST: "CA",
    cityWithStateAbbr: "Torrance, CA",
  },
  {
    zip: "90507",
    ST: "CA",
    cityWithStateAbbr: "Torrance, CA",
  },
  {
    zip: "90508",
    ST: "CA",
    cityWithStateAbbr: "Torrance, CA",
  },
  {
    zip: "90509",
    ST: "CA",
    cityWithStateAbbr: "Torrance, CA",
  },
  {
    zip: "90510",
    ST: "CA",
    cityWithStateAbbr: "Torrance, CA",
  },
  {
    zip: "90601",
    ST: "CA",
    cityWithStateAbbr: "Whittier, CA",
  },
  {
    zip: "90602",
    ST: "CA",
    cityWithStateAbbr: "Whittier, CA",
  },
  {
    zip: "90603",
    ST: "CA",
    cityWithStateAbbr: "Whittier, CA",
  },
  {
    zip: "90604",
    ST: "CA",
    cityWithStateAbbr: "Whittier, CA",
  },
  {
    zip: "90605",
    ST: "CA",
    cityWithStateAbbr: "Whittier, CA",
  },
  {
    zip: "90606",
    ST: "CA",
    cityWithStateAbbr: "Whittier, CA",
  },
  {
    zip: "90607",
    ST: "CA",
    cityWithStateAbbr: "Whittier, CA",
  },
  {
    zip: "90608",
    ST: "CA",
    cityWithStateAbbr: "Whittier, CA",
  },
  {
    zip: "90609",
    ST: "CA",
    cityWithStateAbbr: "Whittier, CA",
  },
  {
    zip: "90610",
    ST: "CA",
    cityWithStateAbbr: "Whittier, CA",
  },
  {
    zip: "90620",
    ST: "CA",
    cityWithStateAbbr: "Buena Park, CA",
  },
  {
    zip: "90621",
    ST: "CA",
    cityWithStateAbbr: "Buena Park, CA",
  },
  {
    zip: "90622",
    ST: "CA",
    cityWithStateAbbr: "Buena Park, CA",
  },
  {
    zip: "90623",
    ST: "CA",
    cityWithStateAbbr: "La Palma, CA",
  },
  {
    zip: "90624",
    ST: "CA",
    cityWithStateAbbr: "Buena Park, CA",
  },
  {
    zip: "90630",
    ST: "CA",
    cityWithStateAbbr: "Cypress, CA",
  },
  {
    zip: "90631",
    ST: "CA",
    cityWithStateAbbr: "La Habra, CA",
  },
  {
    zip: "90632",
    ST: "CA",
    cityWithStateAbbr: "La Habra, CA",
  },
  {
    zip: "90633",
    ST: "CA",
    cityWithStateAbbr: "La Habra, CA",
  },
  {
    zip: "90637",
    ST: "CA",
    cityWithStateAbbr: "La Mirada, CA",
  },
  {
    zip: "90638",
    ST: "CA",
    cityWithStateAbbr: "La Mirada, CA",
  },
  {
    zip: "90639",
    ST: "CA",
    cityWithStateAbbr: "La Mirada, CA",
  },
  {
    zip: "90640",
    ST: "CA",
    cityWithStateAbbr: "Montebello, CA",
  },
  {
    zip: "90650",
    ST: "CA",
    cityWithStateAbbr: "Norwalk, CA",
  },
  {
    zip: "90651",
    ST: "CA",
    cityWithStateAbbr: "Norwalk, CA",
  },
  {
    zip: "90652",
    ST: "CA",
    cityWithStateAbbr: "Norwalk, CA",
  },
  {
    zip: "90660",
    ST: "CA",
    cityWithStateAbbr: "Pico Rivera, CA",
  },
  {
    zip: "90661",
    ST: "CA",
    cityWithStateAbbr: "Pico Rivera, CA",
  },
  {
    zip: "90662",
    ST: "CA",
    cityWithStateAbbr: "Pico Rivera, CA",
  },
  {
    zip: "90670",
    ST: "CA",
    cityWithStateAbbr: "Santa Fe Springs, CA",
  },
  {
    zip: "90680",
    ST: "CA",
    cityWithStateAbbr: "Stanton, CA",
  },
  {
    zip: "90701",
    ST: "CA",
    cityWithStateAbbr: "Artesia, CA",
  },
  {
    zip: "90702",
    ST: "CA",
    cityWithStateAbbr: "Artesia, CA",
  },
  {
    zip: "90703",
    ST: "CA",
    cityWithStateAbbr: "Cerritos, CA",
  },
  {
    zip: "90704",
    ST: "CA",
    cityWithStateAbbr: "Avalon, CA",
  },
  {
    zip: "90706",
    ST: "CA",
    cityWithStateAbbr: "Bellflower, CA",
  },
  {
    zip: "90707",
    ST: "CA",
    cityWithStateAbbr: "Bellflower, CA",
  },
  {
    zip: "90710",
    ST: "CA",
    cityWithStateAbbr: "Harbor City, CA",
  },
  {
    zip: "90711",
    ST: "CA",
    cityWithStateAbbr: "Lakewood, CA",
  },
  {
    zip: "90712",
    ST: "CA",
    cityWithStateAbbr: "Lakewood, CA",
  },
  {
    zip: "90713",
    ST: "CA",
    cityWithStateAbbr: "Lakewood, CA",
  },
  {
    zip: "90714",
    ST: "CA",
    cityWithStateAbbr: "Lakewood, CA",
  },
  {
    zip: "90715",
    ST: "CA",
    cityWithStateAbbr: "Lakewood, CA",
  },
  {
    zip: "90716",
    ST: "CA",
    cityWithStateAbbr: "Hawaiian Gardens, CA",
  },
  {
    zip: "90717",
    ST: "CA",
    cityWithStateAbbr: "Lomita, CA",
  },
  {
    zip: "90720",
    ST: "CA",
    cityWithStateAbbr: "Los Alamitos, CA",
  },
  {
    zip: "90721",
    ST: "CA",
    cityWithStateAbbr: "Los Alamitos, CA",
  },
  {
    zip: "90723",
    ST: "CA",
    cityWithStateAbbr: "Paramount, CA",
  },
  {
    zip: "90731",
    ST: "CA",
    cityWithStateAbbr: "San Pedro, CA",
  },
  {
    zip: "90732",
    ST: "CA",
    cityWithStateAbbr: "San Pedro, CA",
  },
  {
    zip: "90733",
    ST: "CA",
    cityWithStateAbbr: "San Pedro, CA",
  },
  {
    zip: "90734",
    ST: "CA",
    cityWithStateAbbr: "San Pedro, CA",
  },
  {
    zip: "90740",
    ST: "CA",
    cityWithStateAbbr: "Seal Beach, CA",
  },
  {
    zip: "90742",
    ST: "CA",
    cityWithStateAbbr: "Sunset Beach, CA",
  },
  {
    zip: "90743",
    ST: "CA",
    cityWithStateAbbr: "Surfside, CA",
  },
  {
    zip: "90744",
    ST: "CA",
    cityWithStateAbbr: "Wilmington, CA",
  },
  {
    zip: "90745",
    ST: "CA",
    cityWithStateAbbr: "Carson, CA",
  },
  {
    zip: "90746",
    ST: "CA",
    cityWithStateAbbr: "Carson, CA",
  },
  {
    zip: "90747",
    ST: "CA",
    cityWithStateAbbr: "Carson, CA",
  },
  {
    zip: "90748",
    ST: "CA",
    cityWithStateAbbr: "Wilmington, CA",
  },
  {
    zip: "90749",
    ST: "CA",
    cityWithStateAbbr: "Carson, CA",
  },
  {
    zip: "90755",
    ST: "CA",
    cityWithStateAbbr: "Signal Hill, CA",
  },
  {
    zip: "90801",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90802",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90803",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90804",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90805",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90806",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90807",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90808",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90809",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90810",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90813",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90814",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90815",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90822",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90831",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90832",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90833",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90834",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90835",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90840",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90842",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90844",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90846",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90847",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90848",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90853",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "90895",
    ST: "CA",
    cityWithStateAbbr: "Carson, CA",
  },
  {
    zip: "90899",
    ST: "CA",
    cityWithStateAbbr: "Long Beach, CA",
  },
  {
    zip: "91001",
    ST: "CA",
    cityWithStateAbbr: "Altadena, CA",
  },
  {
    zip: "91003",
    ST: "CA",
    cityWithStateAbbr: "Altadena, CA",
  },
  {
    zip: "91006",
    ST: "CA",
    cityWithStateAbbr: "Arcadia, CA",
  },
  {
    zip: "91007",
    ST: "CA",
    cityWithStateAbbr: "Arcadia, CA",
  },
  {
    zip: "91008",
    ST: "CA",
    cityWithStateAbbr: "Duarte, CA",
  },
  {
    zip: "91009",
    ST: "CA",
    cityWithStateAbbr: "Duarte, CA",
  },
  {
    zip: "91010",
    ST: "CA",
    cityWithStateAbbr: "Duarte, CA",
  },
  {
    zip: "91011",
    ST: "CA",
    cityWithStateAbbr: "La Canada Flintridge, CA",
  },
  {
    zip: "91012",
    ST: "CA",
    cityWithStateAbbr: "La Canada Flintridge, CA",
  },
  {
    zip: "91016",
    ST: "CA",
    cityWithStateAbbr: "Monrovia, CA",
  },
  {
    zip: "91017",
    ST: "CA",
    cityWithStateAbbr: "Monrovia, CA",
  },
  {
    zip: "91020",
    ST: "CA",
    cityWithStateAbbr: "Montrose, CA",
  },
  {
    zip: "91021",
    ST: "CA",
    cityWithStateAbbr: "Montrose, CA",
  },
  {
    zip: "91023",
    ST: "CA",
    cityWithStateAbbr: "Mount Wilson, CA",
  },
  {
    zip: "91024",
    ST: "CA",
    cityWithStateAbbr: "Sierra Madre, CA",
  },
  {
    zip: "91025",
    ST: "CA",
    cityWithStateAbbr: "Sierra Madre, CA",
  },
  {
    zip: "91030",
    ST: "CA",
    cityWithStateAbbr: "South Pasadena, CA",
  },
  {
    zip: "91031",
    ST: "CA",
    cityWithStateAbbr: "South Pasadena, CA",
  },
  {
    zip: "91040",
    ST: "CA",
    cityWithStateAbbr: "Sunland, CA",
  },
  {
    zip: "91041",
    ST: "CA",
    cityWithStateAbbr: "Sunland, CA",
  },
  {
    zip: "91042",
    ST: "CA",
    cityWithStateAbbr: "Tujunga, CA",
  },
  {
    zip: "91043",
    ST: "CA",
    cityWithStateAbbr: "Tujunga, CA",
  },
  {
    zip: "91046",
    ST: "CA",
    cityWithStateAbbr: "Verdugo City, CA",
  },
  {
    zip: "91066",
    ST: "CA",
    cityWithStateAbbr: "Arcadia, CA",
  },
  {
    zip: "91077",
    ST: "CA",
    cityWithStateAbbr: "Arcadia, CA",
  },
  {
    zip: "91101",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91102",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91103",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91104",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91105",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91106",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91107",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91108",
    ST: "CA",
    cityWithStateAbbr: "San Marino, CA",
  },
  {
    zip: "91109",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91110",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91114",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91115",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91116",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91117",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91118",
    ST: "CA",
    cityWithStateAbbr: "San Marino, CA",
  },
  {
    zip: "91121",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91123",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91124",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91125",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91126",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91129",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91182",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91184",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91185",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91188",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91189",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91199",
    ST: "CA",
    cityWithStateAbbr: "Pasadena, CA",
  },
  {
    zip: "91201",
    ST: "CA",
    cityWithStateAbbr: "Glendale, CA",
  },
  {
    zip: "91202",
    ST: "CA",
    cityWithStateAbbr: "Glendale, CA",
  },
  {
    zip: "91203",
    ST: "CA",
    cityWithStateAbbr: "Glendale, CA",
  },
  {
    zip: "91204",
    ST: "CA",
    cityWithStateAbbr: "Glendale, CA",
  },
  {
    zip: "91205",
    ST: "CA",
    cityWithStateAbbr: "Glendale, CA",
  },
  {
    zip: "91206",
    ST: "CA",
    cityWithStateAbbr: "Glendale, CA",
  },
  {
    zip: "91207",
    ST: "CA",
    cityWithStateAbbr: "Glendale, CA",
  },
  {
    zip: "91208",
    ST: "CA",
    cityWithStateAbbr: "Glendale, CA",
  },
  {
    zip: "91209",
    ST: "CA",
    cityWithStateAbbr: "Glendale, CA",
  },
  {
    zip: "91210",
    ST: "CA",
    cityWithStateAbbr: "Glendale, CA",
  },
  {
    zip: "91214",
    ST: "CA",
    cityWithStateAbbr: "La Crescenta, CA",
  },
  {
    zip: "91221",
    ST: "CA",
    cityWithStateAbbr: "Glendale, CA",
  },
  {
    zip: "91222",
    ST: "CA",
    cityWithStateAbbr: "Glendale, CA",
  },
  {
    zip: "91224",
    ST: "CA",
    cityWithStateAbbr: "La Crescenta, CA",
  },
  {
    zip: "91225",
    ST: "CA",
    cityWithStateAbbr: "Glendale, CA",
  },
  {
    zip: "91226",
    ST: "CA",
    cityWithStateAbbr: "Glendale, CA",
  },
  {
    zip: "91301",
    ST: "CA",
    cityWithStateAbbr: "Agoura Hills, CA",
  },
  {
    zip: "91302",
    ST: "CA",
    cityWithStateAbbr: "Calabasas, CA",
  },
  {
    zip: "91303",
    ST: "CA",
    cityWithStateAbbr: "Canoga Park, CA",
  },
  {
    zip: "91304",
    ST: "CA",
    cityWithStateAbbr: "Canoga Park, CA",
  },
  {
    zip: "91305",
    ST: "CA",
    cityWithStateAbbr: "Canoga Park, CA",
  },
  {
    zip: "91306",
    ST: "CA",
    cityWithStateAbbr: "Winnetka, CA",
  },
  {
    zip: "91307",
    ST: "CA",
    cityWithStateAbbr: "West Hills, CA",
  },
  {
    zip: "91308",
    ST: "CA",
    cityWithStateAbbr: "West Hills, CA",
  },
  {
    zip: "91309",
    ST: "CA",
    cityWithStateAbbr: "Canoga Park, CA",
  },
  {
    zip: "91310",
    ST: "CA",
    cityWithStateAbbr: "Castaic, CA",
  },
  {
    zip: "91311",
    ST: "CA",
    cityWithStateAbbr: "Chatsworth, CA",
  },
  {
    zip: "91313",
    ST: "CA",
    cityWithStateAbbr: "Chatsworth, CA",
  },
  {
    zip: "91316",
    ST: "CA",
    cityWithStateAbbr: "Encino, CA",
  },
  {
    zip: "91319",
    ST: "CA",
    cityWithStateAbbr: "Newbury Park, CA",
  },
  {
    zip: "91320",
    ST: "CA",
    cityWithStateAbbr: "Newbury Park, CA",
  },
  {
    zip: "91321",
    ST: "CA",
    cityWithStateAbbr: "Newhall, CA",
  },
  {
    zip: "91322",
    ST: "CA",
    cityWithStateAbbr: "Newhall, CA",
  },
  {
    zip: "91324",
    ST: "CA",
    cityWithStateAbbr: "Northridge, CA",
  },
  {
    zip: "91325",
    ST: "CA",
    cityWithStateAbbr: "Northridge, CA",
  },
  {
    zip: "91326",
    ST: "CA",
    cityWithStateAbbr: "Porter Ranch, CA",
  },
  {
    zip: "91327",
    ST: "CA",
    cityWithStateAbbr: "Northridge, CA",
  },
  {
    zip: "91328",
    ST: "CA",
    cityWithStateAbbr: "Northridge, CA",
  },
  {
    zip: "91329",
    ST: "CA",
    cityWithStateAbbr: "Northridge, CA",
  },
  {
    zip: "91330",
    ST: "CA",
    cityWithStateAbbr: "Northridge, CA",
  },
  {
    zip: "91331",
    ST: "CA",
    cityWithStateAbbr: "Pacoima, CA",
  },
  {
    zip: "91333",
    ST: "CA",
    cityWithStateAbbr: "Pacoima, CA",
  },
  {
    zip: "91334",
    ST: "CA",
    cityWithStateAbbr: "Pacoima, CA",
  },
  {
    zip: "91335",
    ST: "CA",
    cityWithStateAbbr: "Reseda, CA",
  },
  {
    zip: "91337",
    ST: "CA",
    cityWithStateAbbr: "Reseda, CA",
  },
  {
    zip: "91340",
    ST: "CA",
    cityWithStateAbbr: "San Fernando, CA",
  },
  {
    zip: "91341",
    ST: "CA",
    cityWithStateAbbr: "San Fernando, CA",
  },
  {
    zip: "91342",
    ST: "CA",
    cityWithStateAbbr: "Sylmar, CA",
  },
  {
    zip: "91343",
    ST: "CA",
    cityWithStateAbbr: "North Hills, CA",
  },
  {
    zip: "91344",
    ST: "CA",
    cityWithStateAbbr: "Granada Hills, CA",
  },
  {
    zip: "91345",
    ST: "CA",
    cityWithStateAbbr: "Mission Hills, CA",
  },
  {
    zip: "91346",
    ST: "CA",
    cityWithStateAbbr: "Mission Hills, CA",
  },
  {
    zip: "91350",
    ST: "CA",
    cityWithStateAbbr: "Santa Clarita, CA",
  },
  {
    zip: "91351",
    ST: "CA",
    cityWithStateAbbr: "Canyon Country, CA",
  },
  {
    zip: "91352",
    ST: "CA",
    cityWithStateAbbr: "Sun Valley, CA",
  },
  {
    zip: "91353",
    ST: "CA",
    cityWithStateAbbr: "Sun Valley, CA",
  },
  {
    zip: "91354",
    ST: "CA",
    cityWithStateAbbr: "Valencia, CA",
  },
  {
    zip: "91355",
    ST: "CA",
    cityWithStateAbbr: "Valencia, CA",
  },
  {
    zip: "91356",
    ST: "CA",
    cityWithStateAbbr: "Tarzana, CA",
  },
  {
    zip: "91357",
    ST: "CA",
    cityWithStateAbbr: "Tarzana, CA",
  },
  {
    zip: "91358",
    ST: "CA",
    cityWithStateAbbr: "Thousand Oaks, CA",
  },
  {
    zip: "91359",
    ST: "CA",
    cityWithStateAbbr: "Westlake Village, CA",
  },
  {
    zip: "91360",
    ST: "CA",
    cityWithStateAbbr: "Thousand Oaks, CA",
  },
  {
    zip: "91361",
    ST: "CA",
    cityWithStateAbbr: "Westlake Village, CA",
  },
  {
    zip: "91362",
    ST: "CA",
    cityWithStateAbbr: "Thousand Oaks, CA",
  },
  {
    zip: "91364",
    ST: "CA",
    cityWithStateAbbr: "Woodland Hills, CA",
  },
  {
    zip: "91365",
    ST: "CA",
    cityWithStateAbbr: "Woodland Hills, CA",
  },
  {
    zip: "91367",
    ST: "CA",
    cityWithStateAbbr: "Woodland Hills, CA",
  },
  {
    zip: "91371",
    ST: "CA",
    cityWithStateAbbr: "Woodland Hills, CA",
  },
  {
    zip: "91372",
    ST: "CA",
    cityWithStateAbbr: "Calabasas, CA",
  },
  {
    zip: "91376",
    ST: "CA",
    cityWithStateAbbr: "Agoura Hills, CA",
  },
  {
    zip: "91377",
    ST: "CA",
    cityWithStateAbbr: "Oak Park, CA",
  },
  {
    zip: "91380",
    ST: "CA",
    cityWithStateAbbr: "Santa Clarita, CA",
  },
  {
    zip: "91381",
    ST: "CA",
    cityWithStateAbbr: "Stevenson Ranch, CA",
  },
  {
    zip: "91382",
    ST: "CA",
    cityWithStateAbbr: "Santa Clarita, CA",
  },
  {
    zip: "91383",
    ST: "CA",
    cityWithStateAbbr: "Santa Clarita, CA",
  },
  {
    zip: "91384",
    ST: "CA",
    cityWithStateAbbr: "Castaic, CA",
  },
  {
    zip: "91385",
    ST: "CA",
    cityWithStateAbbr: "Valencia, CA",
  },
  {
    zip: "91386",
    ST: "CA",
    cityWithStateAbbr: "Canyon Country, CA",
  },
  {
    zip: "91387",
    ST: "CA",
    cityWithStateAbbr: "Canyon Country, CA",
  },
  {
    zip: "91390",
    ST: "CA",
    cityWithStateAbbr: "Santa Clarita, CA",
  },
  {
    zip: "91392",
    ST: "CA",
    cityWithStateAbbr: "Sylmar, CA",
  },
  {
    zip: "91393",
    ST: "CA",
    cityWithStateAbbr: "North Hills, CA",
  },
  {
    zip: "91394",
    ST: "CA",
    cityWithStateAbbr: "Granada Hills, CA",
  },
  {
    zip: "91395",
    ST: "CA",
    cityWithStateAbbr: "Mission Hills, CA",
  },
  {
    zip: "91396",
    ST: "CA",
    cityWithStateAbbr: "Winnetka, CA",
  },
  {
    zip: "91401",
    ST: "CA",
    cityWithStateAbbr: "Van Nuys, CA",
  },
  {
    zip: "91402",
    ST: "CA",
    cityWithStateAbbr: "Panorama City, CA",
  },
  {
    zip: "91403",
    ST: "CA",
    cityWithStateAbbr: "Sherman Oaks, CA",
  },
  {
    zip: "91404",
    ST: "CA",
    cityWithStateAbbr: "Van Nuys, CA",
  },
  {
    zip: "91405",
    ST: "CA",
    cityWithStateAbbr: "Van Nuys, CA",
  },
  {
    zip: "91406",
    ST: "CA",
    cityWithStateAbbr: "Van Nuys, CA",
  },
  {
    zip: "91407",
    ST: "CA",
    cityWithStateAbbr: "Van Nuys, CA",
  },
  {
    zip: "91408",
    ST: "CA",
    cityWithStateAbbr: "Van Nuys, CA",
  },
  {
    zip: "91409",
    ST: "CA",
    cityWithStateAbbr: "Van Nuys, CA",
  },
  {
    zip: "91410",
    ST: "CA",
    cityWithStateAbbr: "Van Nuys, CA",
  },
  {
    zip: "91411",
    ST: "CA",
    cityWithStateAbbr: "Van Nuys, CA",
  },
  {
    zip: "91412",
    ST: "CA",
    cityWithStateAbbr: "Panorama City, CA",
  },
  {
    zip: "91413",
    ST: "CA",
    cityWithStateAbbr: "Sherman Oaks, CA",
  },
  {
    zip: "91416",
    ST: "CA",
    cityWithStateAbbr: "Encino, CA",
  },
  {
    zip: "91423",
    ST: "CA",
    cityWithStateAbbr: "Sherman Oaks, CA",
  },
  {
    zip: "91426",
    ST: "CA",
    cityWithStateAbbr: "Encino, CA",
  },
  {
    zip: "91436",
    ST: "CA",
    cityWithStateAbbr: "Encino, CA",
  },
  {
    zip: "91470",
    ST: "CA",
    cityWithStateAbbr: "Van Nuys, CA",
  },
  {
    zip: "91482",
    ST: "CA",
    cityWithStateAbbr: "Van Nuys, CA",
  },
  {
    zip: "91495",
    ST: "CA",
    cityWithStateAbbr: "Sherman Oaks, CA",
  },
  {
    zip: "91496",
    ST: "CA",
    cityWithStateAbbr: "Van Nuys, CA",
  },
  {
    zip: "91499",
    ST: "CA",
    cityWithStateAbbr: "Van Nuys, CA",
  },
  {
    zip: "91501",
    ST: "CA",
    cityWithStateAbbr: "Burbank, CA",
  },
  {
    zip: "91502",
    ST: "CA",
    cityWithStateAbbr: "Burbank, CA",
  },
  {
    zip: "91503",
    ST: "CA",
    cityWithStateAbbr: "Burbank, CA",
  },
  {
    zip: "91504",
    ST: "CA",
    cityWithStateAbbr: "Burbank, CA",
  },
  {
    zip: "91505",
    ST: "CA",
    cityWithStateAbbr: "Burbank, CA",
  },
  {
    zip: "91506",
    ST: "CA",
    cityWithStateAbbr: "Burbank, CA",
  },
  {
    zip: "91507",
    ST: "CA",
    cityWithStateAbbr: "Burbank, CA",
  },
  {
    zip: "91508",
    ST: "CA",
    cityWithStateAbbr: "Burbank, CA",
  },
  {
    zip: "91510",
    ST: "CA",
    cityWithStateAbbr: "Burbank, CA",
  },
  {
    zip: "91521",
    ST: "CA",
    cityWithStateAbbr: "Burbank, CA",
  },
  {
    zip: "91522",
    ST: "CA",
    cityWithStateAbbr: "Burbank, CA",
  },
  {
    zip: "91523",
    ST: "CA",
    cityWithStateAbbr: "Burbank, CA",
  },
  {
    zip: "91526",
    ST: "CA",
    cityWithStateAbbr: "Burbank, CA",
  },
  {
    zip: "91601",
    ST: "CA",
    cityWithStateAbbr: "North Hollywood, CA",
  },
  {
    zip: "91602",
    ST: "CA",
    cityWithStateAbbr: "North Hollywood, CA",
  },
  {
    zip: "91603",
    ST: "CA",
    cityWithStateAbbr: "North Hollywood, CA",
  },
  {
    zip: "91604",
    ST: "CA",
    cityWithStateAbbr: "Studio City, CA",
  },
  {
    zip: "91605",
    ST: "CA",
    cityWithStateAbbr: "North Hollywood, CA",
  },
  {
    zip: "91606",
    ST: "CA",
    cityWithStateAbbr: "North Hollywood, CA",
  },
  {
    zip: "91607",
    ST: "CA",
    cityWithStateAbbr: "Valley Village, CA",
  },
  {
    zip: "91608",
    ST: "CA",
    cityWithStateAbbr: "Universal City, CA",
  },
  {
    zip: "91609",
    ST: "CA",
    cityWithStateAbbr: "North Hollywood, CA",
  },
  {
    zip: "91610",
    ST: "CA",
    cityWithStateAbbr: "Toluca Lake, CA",
  },
  {
    zip: "91611",
    ST: "CA",
    cityWithStateAbbr: "North Hollywood, CA",
  },
  {
    zip: "91612",
    ST: "CA",
    cityWithStateAbbr: "North Hollywood, CA",
  },
  {
    zip: "91614",
    ST: "CA",
    cityWithStateAbbr: "Studio City, CA",
  },
  {
    zip: "91615",
    ST: "CA",
    cityWithStateAbbr: "North Hollywood, CA",
  },
  {
    zip: "91616",
    ST: "CA",
    cityWithStateAbbr: "North Hollywood, CA",
  },
  {
    zip: "91617",
    ST: "CA",
    cityWithStateAbbr: "Valley Village, CA",
  },
  {
    zip: "91618",
    ST: "CA",
    cityWithStateAbbr: "North Hollywood, CA",
  },
  {
    zip: "91701",
    ST: "CA",
    cityWithStateAbbr: "Rancho Cucamonga, CA",
  },
  {
    zip: "91702",
    ST: "CA",
    cityWithStateAbbr: "Azusa, CA",
  },
  {
    zip: "91706",
    ST: "CA",
    cityWithStateAbbr: "Baldwin Park, CA",
  },
  {
    zip: "91708",
    ST: "CA",
    cityWithStateAbbr: "Chino, CA",
  },
  {
    zip: "91709",
    ST: "CA",
    cityWithStateAbbr: "Chino Hills, CA",
  },
  {
    zip: "91710",
    ST: "CA",
    cityWithStateAbbr: "Chino, CA",
  },
  {
    zip: "91711",
    ST: "CA",
    cityWithStateAbbr: "Claremont, CA",
  },
  {
    zip: "91715",
    ST: "CA",
    cityWithStateAbbr: "City Of Industry, CA",
  },
  {
    zip: "91716",
    ST: "CA",
    cityWithStateAbbr: "City Of Industry, CA",
  },
  {
    zip: "91722",
    ST: "CA",
    cityWithStateAbbr: "Covina, CA",
  },
  {
    zip: "91723",
    ST: "CA",
    cityWithStateAbbr: "Covina, CA",
  },
  {
    zip: "91724",
    ST: "CA",
    cityWithStateAbbr: "Covina, CA",
  },
  {
    zip: "91729",
    ST: "CA",
    cityWithStateAbbr: "Rancho Cucamonga, CA",
  },
  {
    zip: "91730",
    ST: "CA",
    cityWithStateAbbr: "Rancho Cucamonga, CA",
  },
  {
    zip: "91731",
    ST: "CA",
    cityWithStateAbbr: "El Monte, CA",
  },
  {
    zip: "91732",
    ST: "CA",
    cityWithStateAbbr: "El Monte, CA",
  },
  {
    zip: "91733",
    ST: "CA",
    cityWithStateAbbr: "South El Monte, CA",
  },
  {
    zip: "91734",
    ST: "CA",
    cityWithStateAbbr: "El Monte, CA",
  },
  {
    zip: "91735",
    ST: "CA",
    cityWithStateAbbr: "El Monte, CA",
  },
  {
    zip: "91737",
    ST: "CA",
    cityWithStateAbbr: "Rancho Cucamonga, CA",
  },
  {
    zip: "91739",
    ST: "CA",
    cityWithStateAbbr: "Rancho Cucamonga, CA",
  },
  {
    zip: "91740",
    ST: "CA",
    cityWithStateAbbr: "Glendora, CA",
  },
  {
    zip: "91741",
    ST: "CA",
    cityWithStateAbbr: "Glendora, CA",
  },
  {
    zip: "91743",
    ST: "CA",
    cityWithStateAbbr: "Guasti, CA",
  },
  {
    zip: "91744",
    ST: "CA",
    cityWithStateAbbr: "La Puente, CA",
  },
  {
    zip: "91745",
    ST: "CA",
    cityWithStateAbbr: "Hacienda Heights, CA",
  },
  {
    zip: "91746",
    ST: "CA",
    cityWithStateAbbr: "La Puente, CA",
  },
  {
    zip: "91747",
    ST: "CA",
    cityWithStateAbbr: "La Puente, CA",
  },
  {
    zip: "91748",
    ST: "CA",
    cityWithStateAbbr: "Rowland Heights, CA",
  },
  {
    zip: "91749",
    ST: "CA",
    cityWithStateAbbr: "La Puente, CA",
  },
  {
    zip: "91750",
    ST: "CA",
    cityWithStateAbbr: "La Verne, CA",
  },
  {
    zip: "91752",
    ST: "CA",
    cityWithStateAbbr: "Mira Loma, CA",
  },
  {
    zip: "91754",
    ST: "CA",
    cityWithStateAbbr: "Monterey Park, CA",
  },
  {
    zip: "91755",
    ST: "CA",
    cityWithStateAbbr: "Monterey Park, CA",
  },
  {
    zip: "91756",
    ST: "CA",
    cityWithStateAbbr: "Monterey Park, CA",
  },
  {
    zip: "91758",
    ST: "CA",
    cityWithStateAbbr: "Ontario, CA",
  },
  {
    zip: "91759",
    ST: "CA",
    cityWithStateAbbr: "Mt Baldy, CA",
  },
  {
    zip: "91761",
    ST: "CA",
    cityWithStateAbbr: "Ontario, CA",
  },
  {
    zip: "91762",
    ST: "CA",
    cityWithStateAbbr: "Ontario, CA",
  },
  {
    zip: "91763",
    ST: "CA",
    cityWithStateAbbr: "Montclair, CA",
  },
  {
    zip: "91764",
    ST: "CA",
    cityWithStateAbbr: "Ontario, CA",
  },
  {
    zip: "91765",
    ST: "CA",
    cityWithStateAbbr: "Diamond Bar, CA",
  },
  {
    zip: "91766",
    ST: "CA",
    cityWithStateAbbr: "Pomona, CA",
  },
  {
    zip: "91767",
    ST: "CA",
    cityWithStateAbbr: "Pomona, CA",
  },
  {
    zip: "91768",
    ST: "CA",
    cityWithStateAbbr: "Pomona, CA",
  },
  {
    zip: "91769",
    ST: "CA",
    cityWithStateAbbr: "Pomona, CA",
  },
  {
    zip: "91770",
    ST: "CA",
    cityWithStateAbbr: "Rosemead, CA",
  },
  {
    zip: "91771",
    ST: "CA",
    cityWithStateAbbr: "Rosemead, CA",
  },
  {
    zip: "91772",
    ST: "CA",
    cityWithStateAbbr: "Rosemead, CA",
  },
  {
    zip: "91773",
    ST: "CA",
    cityWithStateAbbr: "San Dimas, CA",
  },
  {
    zip: "91775",
    ST: "CA",
    cityWithStateAbbr: "San Gabriel, CA",
  },
  {
    zip: "91776",
    ST: "CA",
    cityWithStateAbbr: "San Gabriel, CA",
  },
  {
    zip: "91778",
    ST: "CA",
    cityWithStateAbbr: "San Gabriel, CA",
  },
  {
    zip: "91780",
    ST: "CA",
    cityWithStateAbbr: "Temple City, CA",
  },
  {
    zip: "91784",
    ST: "CA",
    cityWithStateAbbr: "Upland, CA",
  },
  {
    zip: "91785",
    ST: "CA",
    cityWithStateAbbr: "Upland, CA",
  },
  {
    zip: "91786",
    ST: "CA",
    cityWithStateAbbr: "Upland, CA",
  },
  {
    zip: "91788",
    ST: "CA",
    cityWithStateAbbr: "Walnut, CA",
  },
  {
    zip: "91789",
    ST: "CA",
    cityWithStateAbbr: "Walnut, CA",
  },
  {
    zip: "91790",
    ST: "CA",
    cityWithStateAbbr: "West Covina, CA",
  },
  {
    zip: "91791",
    ST: "CA",
    cityWithStateAbbr: "West Covina, CA",
  },
  {
    zip: "91792",
    ST: "CA",
    cityWithStateAbbr: "West Covina, CA",
  },
  {
    zip: "91793",
    ST: "CA",
    cityWithStateAbbr: "West Covina, CA",
  },
  {
    zip: "91795",
    ST: "CA",
    cityWithStateAbbr: "Walnut, CA",
  },
  {
    zip: "91801",
    ST: "CA",
    cityWithStateAbbr: "Alhambra, CA",
  },
  {
    zip: "91802",
    ST: "CA",
    cityWithStateAbbr: "Alhambra, CA",
  },
  {
    zip: "91803",
    ST: "CA",
    cityWithStateAbbr: "Alhambra, CA",
  },
  {
    zip: "91804",
    ST: "CA",
    cityWithStateAbbr: "Alhambra, CA",
  },
  {
    zip: "91896",
    ST: "CA",
    cityWithStateAbbr: "Alhambra, CA",
  },
  {
    zip: "91901",
    ST: "CA",
    cityWithStateAbbr: "Alpine, CA",
  },
  {
    zip: "91902",
    ST: "CA",
    cityWithStateAbbr: "Bonita, CA",
  },
  {
    zip: "91903",
    ST: "CA",
    cityWithStateAbbr: "Alpine, CA",
  },
  {
    zip: "91905",
    ST: "CA",
    cityWithStateAbbr: "Boulevard, CA",
  },
  {
    zip: "91906",
    ST: "CA",
    cityWithStateAbbr: "Campo, CA",
  },
  {
    zip: "91908",
    ST: "CA",
    cityWithStateAbbr: "Bonita, CA",
  },
  {
    zip: "91909",
    ST: "CA",
    cityWithStateAbbr: "Chula Vista, CA",
  },
  {
    zip: "91910",
    ST: "CA",
    cityWithStateAbbr: "Chula Vista, CA",
  },
  {
    zip: "91911",
    ST: "CA",
    cityWithStateAbbr: "Chula Vista, CA",
  },
  {
    zip: "91912",
    ST: "CA",
    cityWithStateAbbr: "Chula Vista, CA",
  },
  {
    zip: "91913",
    ST: "CA",
    cityWithStateAbbr: "Chula Vista, CA",
  },
  {
    zip: "91914",
    ST: "CA",
    cityWithStateAbbr: "Chula Vista, CA",
  },
  {
    zip: "91915",
    ST: "CA",
    cityWithStateAbbr: "Chula Vista, CA",
  },
  {
    zip: "91916",
    ST: "CA",
    cityWithStateAbbr: "Descanso, CA",
  },
  {
    zip: "91917",
    ST: "CA",
    cityWithStateAbbr: "Dulzura, CA",
  },
  {
    zip: "91921",
    ST: "CA",
    cityWithStateAbbr: "Chula Vista, CA",
  },
  {
    zip: "91931",
    ST: "CA",
    cityWithStateAbbr: "Guatay, CA",
  },
  {
    zip: "91932",
    ST: "CA",
    cityWithStateAbbr: "Imperial Beach, CA",
  },
  {
    zip: "91933",
    ST: "CA",
    cityWithStateAbbr: "Imperial Beach, CA",
  },
  {
    zip: "91934",
    ST: "CA",
    cityWithStateAbbr: "Jacumba, CA",
  },
  {
    zip: "91935",
    ST: "CA",
    cityWithStateAbbr: "Jamul, CA",
  },
  {
    zip: "91941",
    ST: "CA",
    cityWithStateAbbr: "La Mesa, CA",
  },
  {
    zip: "91942",
    ST: "CA",
    cityWithStateAbbr: "La Mesa, CA",
  },
  {
    zip: "91943",
    ST: "CA",
    cityWithStateAbbr: "La Mesa, CA",
  },
  {
    zip: "91944",
    ST: "CA",
    cityWithStateAbbr: "La Mesa, CA",
  },
  {
    zip: "91945",
    ST: "CA",
    cityWithStateAbbr: "Lemon Grove, CA",
  },
  {
    zip: "91946",
    ST: "CA",
    cityWithStateAbbr: "Lemon Grove, CA",
  },
  {
    zip: "91947",
    ST: "CA",
    cityWithStateAbbr: "Lincoln Acres, CA",
  },
  {
    zip: "91948",
    ST: "CA",
    cityWithStateAbbr: "Mount Laguna, CA",
  },
  {
    zip: "91950",
    ST: "CA",
    cityWithStateAbbr: "National City, CA",
  },
  {
    zip: "91951",
    ST: "CA",
    cityWithStateAbbr: "National City, CA",
  },
  {
    zip: "91962",
    ST: "CA",
    cityWithStateAbbr: "Pine Valley, CA",
  },
  {
    zip: "91963",
    ST: "CA",
    cityWithStateAbbr: "Potrero, CA",
  },
  {
    zip: "91976",
    ST: "CA",
    cityWithStateAbbr: "Spring Valley, CA",
  },
  {
    zip: "91977",
    ST: "CA",
    cityWithStateAbbr: "Spring Valley, CA",
  },
  {
    zip: "91978",
    ST: "CA",
    cityWithStateAbbr: "Spring Valley, CA",
  },
  {
    zip: "91979",
    ST: "CA",
    cityWithStateAbbr: "Spring Valley, CA",
  },
  {
    zip: "91980",
    ST: "CA",
    cityWithStateAbbr: "Tecate, CA",
  },
  {
    zip: "91987",
    ST: "CA",
    cityWithStateAbbr: "Tecate, CA",
  },
  {
    zip: "92003",
    ST: "CA",
    cityWithStateAbbr: "Bonsall, CA",
  },
  {
    zip: "92004",
    ST: "CA",
    cityWithStateAbbr: "Borrego Springs, CA",
  },
  {
    zip: "92007",
    ST: "CA",
    cityWithStateAbbr: "Cardiff By The Sea, CA",
  },
  {
    zip: "92008",
    ST: "CA",
    cityWithStateAbbr: "Carlsbad, CA",
  },
  {
    zip: "92009",
    ST: "CA",
    cityWithStateAbbr: "Carlsbad, CA",
  },
  {
    zip: "92010",
    ST: "CA",
    cityWithStateAbbr: "Carlsbad, CA",
  },
  {
    zip: "92011",
    ST: "CA",
    cityWithStateAbbr: "Carlsbad, CA",
  },
  {
    zip: "92013",
    ST: "CA",
    cityWithStateAbbr: "Carlsbad, CA",
  },
  {
    zip: "92014",
    ST: "CA",
    cityWithStateAbbr: "Del Mar, CA",
  },
  {
    zip: "92018",
    ST: "CA",
    cityWithStateAbbr: "Carlsbad, CA",
  },
  {
    zip: "92019",
    ST: "CA",
    cityWithStateAbbr: "El Cajon, CA",
  },
  {
    zip: "92020",
    ST: "CA",
    cityWithStateAbbr: "El Cajon, CA",
  },
  {
    zip: "92021",
    ST: "CA",
    cityWithStateAbbr: "El Cajon, CA",
  },
  {
    zip: "92022",
    ST: "CA",
    cityWithStateAbbr: "El Cajon, CA",
  },
  {
    zip: "92023",
    ST: "CA",
    cityWithStateAbbr: "Encinitas, CA",
  },
  {
    zip: "92024",
    ST: "CA",
    cityWithStateAbbr: "Encinitas, CA",
  },
  {
    zip: "92025",
    ST: "CA",
    cityWithStateAbbr: "Escondido, CA",
  },
  {
    zip: "92026",
    ST: "CA",
    cityWithStateAbbr: "Escondido, CA",
  },
  {
    zip: "92027",
    ST: "CA",
    cityWithStateAbbr: "Escondido, CA",
  },
  {
    zip: "92028",
    ST: "CA",
    cityWithStateAbbr: "Fallbrook, CA",
  },
  {
    zip: "92029",
    ST: "CA",
    cityWithStateAbbr: "Escondido, CA",
  },
  {
    zip: "92030",
    ST: "CA",
    cityWithStateAbbr: "Escondido, CA",
  },
  {
    zip: "92033",
    ST: "CA",
    cityWithStateAbbr: "Escondido, CA",
  },
  {
    zip: "92036",
    ST: "CA",
    cityWithStateAbbr: "Julian, CA",
  },
  {
    zip: "92037",
    ST: "CA",
    cityWithStateAbbr: "La Jolla, CA",
  },
  {
    zip: "92038",
    ST: "CA",
    cityWithStateAbbr: "La Jolla, CA",
  },
  {
    zip: "92039",
    ST: "CA",
    cityWithStateAbbr: "La Jolla, CA",
  },
  {
    zip: "92040",
    ST: "CA",
    cityWithStateAbbr: "Lakeside, CA",
  },
  {
    zip: "92046",
    ST: "CA",
    cityWithStateAbbr: "Escondido, CA",
  },
  {
    zip: "92049",
    ST: "CA",
    cityWithStateAbbr: "Oceanside, CA",
  },
  {
    zip: "92051",
    ST: "CA",
    cityWithStateAbbr: "Oceanside, CA",
  },
  {
    zip: "92052",
    ST: "CA",
    cityWithStateAbbr: "Oceanside, CA",
  },
  {
    zip: "92054",
    ST: "CA",
    cityWithStateAbbr: "Oceanside, CA",
  },
  {
    zip: "92055",
    ST: "CA",
    cityWithStateAbbr: "Camp Pendleton, CA",
  },
  {
    zip: "92056",
    ST: "CA",
    cityWithStateAbbr: "Oceanside, CA",
  },
  {
    zip: "92057",
    ST: "CA",
    cityWithStateAbbr: "Oceanside, CA",
  },
  {
    zip: "92058",
    ST: "CA",
    cityWithStateAbbr: "Oceanside, CA",
  },
  {
    zip: "92059",
    ST: "CA",
    cityWithStateAbbr: "Pala, CA",
  },
  {
    zip: "92060",
    ST: "CA",
    cityWithStateAbbr: "Palomar Mountain, CA",
  },
  {
    zip: "92061",
    ST: "CA",
    cityWithStateAbbr: "Pauma Valley, CA",
  },
  {
    zip: "92064",
    ST: "CA",
    cityWithStateAbbr: "Poway, CA",
  },
  {
    zip: "92065",
    ST: "CA",
    cityWithStateAbbr: "Ramona, CA",
  },
  {
    zip: "92066",
    ST: "CA",
    cityWithStateAbbr: "Ranchita, CA",
  },
  {
    zip: "92067",
    ST: "CA",
    cityWithStateAbbr: "Rancho Santa Fe, CA",
  },
  {
    zip: "92068",
    ST: "CA",
    cityWithStateAbbr: "San Luis Rey, CA",
  },
  {
    zip: "92069",
    ST: "CA",
    cityWithStateAbbr: "San Marcos, CA",
  },
  {
    zip: "92070",
    ST: "CA",
    cityWithStateAbbr: "Santa Ysabel, CA",
  },
  {
    zip: "92071",
    ST: "CA",
    cityWithStateAbbr: "Santee, CA",
  },
  {
    zip: "92072",
    ST: "CA",
    cityWithStateAbbr: "Santee, CA",
  },
  {
    zip: "92074",
    ST: "CA",
    cityWithStateAbbr: "Poway, CA",
  },
  {
    zip: "92075",
    ST: "CA",
    cityWithStateAbbr: "Solana Beach, CA",
  },
  {
    zip: "92078",
    ST: "CA",
    cityWithStateAbbr: "San Marcos, CA",
  },
  {
    zip: "92079",
    ST: "CA",
    cityWithStateAbbr: "San Marcos, CA",
  },
  {
    zip: "92081",
    ST: "CA",
    cityWithStateAbbr: "Vista, CA",
  },
  {
    zip: "92082",
    ST: "CA",
    cityWithStateAbbr: "Valley Center, CA",
  },
  {
    zip: "92083",
    ST: "CA",
    cityWithStateAbbr: "Vista, CA",
  },
  {
    zip: "92084",
    ST: "CA",
    cityWithStateAbbr: "Vista, CA",
  },
  {
    zip: "92085",
    ST: "CA",
    cityWithStateAbbr: "Vista, CA",
  },
  {
    zip: "92086",
    ST: "CA",
    cityWithStateAbbr: "Warner Springs, CA",
  },
  {
    zip: "92088",
    ST: "CA",
    cityWithStateAbbr: "Fallbrook, CA",
  },
  {
    zip: "92091",
    ST: "CA",
    cityWithStateAbbr: "Rancho Santa Fe, CA",
  },
  {
    zip: "92092",
    ST: "CA",
    cityWithStateAbbr: "La Jolla, CA",
  },
  {
    zip: "92093",
    ST: "CA",
    cityWithStateAbbr: "La Jolla, CA",
  },
  {
    zip: "92096",
    ST: "CA",
    cityWithStateAbbr: "San Marcos, CA",
  },
  {
    zip: "92101",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92102",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92103",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92104",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92105",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92106",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92107",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92108",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92109",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92110",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92111",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92112",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92113",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92114",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92115",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92116",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92117",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92118",
    ST: "CA",
    cityWithStateAbbr: "Coronado, CA",
  },
  {
    zip: "92119",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92120",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92121",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92122",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92123",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92124",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92126",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92127",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92128",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92129",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92130",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92131",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92132",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92134",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92135",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92136",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92137",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92138",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92139",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92140",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92142",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92143",
    ST: "CA",
    cityWithStateAbbr: "San Ysidro, CA",
  },
  {
    zip: "92145",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92147",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92149",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92150",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92152",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92153",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92154",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92155",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92158",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92159",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92160",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92161",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92162",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92163",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92164",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92165",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92166",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92167",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92168",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92169",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92170",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92171",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92172",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92173",
    ST: "CA",
    cityWithStateAbbr: "San Ysidro, CA",
  },
  {
    zip: "92174",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92175",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92176",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92177",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92178",
    ST: "CA",
    cityWithStateAbbr: "Coronado, CA",
  },
  {
    zip: "92179",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92182",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92184",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92186",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92187",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92190",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92191",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92192",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92193",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92195",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92196",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92197",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92198",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92199",
    ST: "CA",
    cityWithStateAbbr: "San Diego, CA",
  },
  {
    zip: "92201",
    ST: "CA",
    cityWithStateAbbr: "Indio, CA",
  },
  {
    zip: "92202",
    ST: "CA",
    cityWithStateAbbr: "Indio, CA",
  },
  {
    zip: "92203",
    ST: "CA",
    cityWithStateAbbr: "Indio, CA",
  },
  {
    zip: "92210",
    ST: "CA",
    cityWithStateAbbr: "Indian Wells, CA",
  },
  {
    zip: "92211",
    ST: "CA",
    cityWithStateAbbr: "Palm Desert, CA",
  },
  {
    zip: "92220",
    ST: "CA",
    cityWithStateAbbr: "Banning, CA",
  },
  {
    zip: "92222",
    ST: "CA",
    cityWithStateAbbr: "Bard, CA",
  },
  {
    zip: "92223",
    ST: "CA",
    cityWithStateAbbr: "Beaumont, CA",
  },
  {
    zip: "92225",
    ST: "CA",
    cityWithStateAbbr: "Blythe, CA",
  },
  {
    zip: "92226",
    ST: "CA",
    cityWithStateAbbr: "Blythe, CA",
  },
  {
    zip: "92227",
    ST: "CA",
    cityWithStateAbbr: "Brawley, CA",
  },
  {
    zip: "92230",
    ST: "CA",
    cityWithStateAbbr: "Cabazon, CA",
  },
  {
    zip: "92231",
    ST: "CA",
    cityWithStateAbbr: "Calexico, CA",
  },
  {
    zip: "92232",
    ST: "CA",
    cityWithStateAbbr: "Calexico, CA",
  },
  {
    zip: "92233",
    ST: "CA",
    cityWithStateAbbr: "Calipatria, CA",
  },
  {
    zip: "92234",
    ST: "CA",
    cityWithStateAbbr: "Cathedral City, CA",
  },
  {
    zip: "92235",
    ST: "CA",
    cityWithStateAbbr: "Cathedral City, CA",
  },
  {
    zip: "92236",
    ST: "CA",
    cityWithStateAbbr: "Coachella, CA",
  },
  {
    zip: "92239",
    ST: "CA",
    cityWithStateAbbr: "Desert Center, CA",
  },
  {
    zip: "92240",
    ST: "CA",
    cityWithStateAbbr: "Desert Hot Springs, CA",
  },
  {
    zip: "92241",
    ST: "CA",
    cityWithStateAbbr: "Desert Hot Springs, CA",
  },
  {
    zip: "92242",
    ST: "CA",
    cityWithStateAbbr: "Earp, CA",
  },
  {
    zip: "92243",
    ST: "CA",
    cityWithStateAbbr: "El Centro, CA",
  },
  {
    zip: "92244",
    ST: "CA",
    cityWithStateAbbr: "El Centro, CA",
  },
  {
    zip: "92247",
    ST: "CA",
    cityWithStateAbbr: "La Quinta, CA",
  },
  {
    zip: "92248",
    ST: "CA",
    cityWithStateAbbr: "La Quinta, CA",
  },
  {
    zip: "92249",
    ST: "CA",
    cityWithStateAbbr: "Heber, CA",
  },
  {
    zip: "92250",
    ST: "CA",
    cityWithStateAbbr: "Holtville, CA",
  },
  {
    zip: "92251",
    ST: "CA",
    cityWithStateAbbr: "Imperial, CA",
  },
  {
    zip: "92252",
    ST: "CA",
    cityWithStateAbbr: "Joshua Tree, CA",
  },
  {
    zip: "92253",
    ST: "CA",
    cityWithStateAbbr: "La Quinta, CA",
  },
  {
    zip: "92254",
    ST: "CA",
    cityWithStateAbbr: "Mecca, CA",
  },
  {
    zip: "92255",
    ST: "CA",
    cityWithStateAbbr: "Palm Desert, CA",
  },
  {
    zip: "92256",
    ST: "CA",
    cityWithStateAbbr: "Morongo Valley, CA",
  },
  {
    zip: "92257",
    ST: "CA",
    cityWithStateAbbr: "Niland, CA",
  },
  {
    zip: "92258",
    ST: "CA",
    cityWithStateAbbr: "North Palm Springs, CA",
  },
  {
    zip: "92259",
    ST: "CA",
    cityWithStateAbbr: "Ocotillo, CA",
  },
  {
    zip: "92260",
    ST: "CA",
    cityWithStateAbbr: "Palm Desert, CA",
  },
  {
    zip: "92261",
    ST: "CA",
    cityWithStateAbbr: "Palm Desert, CA",
  },
  {
    zip: "92262",
    ST: "CA",
    cityWithStateAbbr: "Palm Springs, CA",
  },
  {
    zip: "92263",
    ST: "CA",
    cityWithStateAbbr: "Palm Springs, CA",
  },
  {
    zip: "92264",
    ST: "CA",
    cityWithStateAbbr: "Palm Springs, CA",
  },
  {
    zip: "92266",
    ST: "CA",
    cityWithStateAbbr: "Palo Verde, CA",
  },
  {
    zip: "92267",
    ST: "CA",
    cityWithStateAbbr: "Parker Dam, CA",
  },
  {
    zip: "92268",
    ST: "CA",
    cityWithStateAbbr: "Pioneertown, CA",
  },
  {
    zip: "92270",
    ST: "CA",
    cityWithStateAbbr: "Rancho Mirage, CA",
  },
  {
    zip: "92273",
    ST: "CA",
    cityWithStateAbbr: "Seeley, CA",
  },
  {
    zip: "92274",
    ST: "CA",
    cityWithStateAbbr: "Thermal, CA",
  },
  {
    zip: "92275",
    ST: "CA",
    cityWithStateAbbr: "Salton City, CA",
  },
  {
    zip: "92276",
    ST: "CA",
    cityWithStateAbbr: "Thousand Palms, CA",
  },
  {
    zip: "92277",
    ST: "CA",
    cityWithStateAbbr: "Twentynine Palms, CA",
  },
  {
    zip: "92278",
    ST: "CA",
    cityWithStateAbbr: "Twentynine Palms, CA",
  },
  {
    zip: "92280",
    ST: "CA",
    cityWithStateAbbr: "Vidal, CA",
  },
  {
    zip: "92281",
    ST: "CA",
    cityWithStateAbbr: "Westmorland, CA",
  },
  {
    zip: "92282",
    ST: "CA",
    cityWithStateAbbr: "Whitewater, CA",
  },
  {
    zip: "92283",
    ST: "CA",
    cityWithStateAbbr: "Winterhaven, CA",
  },
  {
    zip: "92284",
    ST: "CA",
    cityWithStateAbbr: "Yucca Valley, CA",
  },
  {
    zip: "92285",
    ST: "CA",
    cityWithStateAbbr: "Landers, CA",
  },
  {
    zip: "92286",
    ST: "CA",
    cityWithStateAbbr: "Yucca Valley, CA",
  },
  {
    zip: "92301",
    ST: "CA",
    cityWithStateAbbr: "Adelanto, CA",
  },
  {
    zip: "92304",
    ST: "CA",
    cityWithStateAbbr: "Amboy, CA",
  },
  {
    zip: "92305",
    ST: "CA",
    cityWithStateAbbr: "Angelus Oaks, CA",
  },
  {
    zip: "92307",
    ST: "CA",
    cityWithStateAbbr: "Apple Valley, CA",
  },
  {
    zip: "92308",
    ST: "CA",
    cityWithStateAbbr: "Apple Valley, CA",
  },
  {
    zip: "92309",
    ST: "CA",
    cityWithStateAbbr: "Baker, CA",
  },
  {
    zip: "92310",
    ST: "CA",
    cityWithStateAbbr: "Fort Irwin, CA",
  },
  {
    zip: "92311",
    ST: "CA",
    cityWithStateAbbr: "Barstow, CA",
  },
  {
    zip: "92312",
    ST: "CA",
    cityWithStateAbbr: "Barstow, CA",
  },
  {
    zip: "92313",
    ST: "CA",
    cityWithStateAbbr: "Grand Terrace, CA",
  },
  {
    zip: "92314",
    ST: "CA",
    cityWithStateAbbr: "Big Bear City, CA",
  },
  {
    zip: "92315",
    ST: "CA",
    cityWithStateAbbr: "Big Bear Lake, CA",
  },
  {
    zip: "92316",
    ST: "CA",
    cityWithStateAbbr: "Bloomington, CA",
  },
  {
    zip: "92317",
    ST: "CA",
    cityWithStateAbbr: "Blue Jay, CA",
  },
  {
    zip: "92318",
    ST: "CA",
    cityWithStateAbbr: "Bryn Mawr, CA",
  },
  {
    zip: "92320",
    ST: "CA",
    cityWithStateAbbr: "Calimesa, CA",
  },
  {
    zip: "92321",
    ST: "CA",
    cityWithStateAbbr: "Cedar Glen, CA",
  },
  {
    zip: "92322",
    ST: "CA",
    cityWithStateAbbr: "Cedarpines Park, CA",
  },
  {
    zip: "92323",
    ST: "CA",
    cityWithStateAbbr: "Cima, CA",
  },
  {
    zip: "92324",
    ST: "CA",
    cityWithStateAbbr: "Colton, CA",
  },
  {
    zip: "92325",
    ST: "CA",
    cityWithStateAbbr: "Crestline, CA",
  },
  {
    zip: "92326",
    ST: "CA",
    cityWithStateAbbr: "Crest Park, CA",
  },
  {
    zip: "92327",
    ST: "CA",
    cityWithStateAbbr: "Daggett, CA",
  },
  {
    zip: "92328",
    ST: "CA",
    cityWithStateAbbr: "Death Valley, CA",
  },
  {
    zip: "92329",
    ST: "CA",
    cityWithStateAbbr: "Phelan, CA",
  },
  {
    zip: "92331",
    ST: "CA",
    cityWithStateAbbr: "Fontana, CA",
  },
  {
    zip: "92332",
    ST: "CA",
    cityWithStateAbbr: "Essex, CA",
  },
  {
    zip: "92333",
    ST: "CA",
    cityWithStateAbbr: "Fawnskin, CA",
  },
  {
    zip: "92334",
    ST: "CA",
    cityWithStateAbbr: "Fontana, CA",
  },
  {
    zip: "92335",
    ST: "CA",
    cityWithStateAbbr: "Fontana, CA",
  },
  {
    zip: "92336",
    ST: "CA",
    cityWithStateAbbr: "Fontana, CA",
  },
  {
    zip: "92337",
    ST: "CA",
    cityWithStateAbbr: "Fontana, CA",
  },
  {
    zip: "92338",
    ST: "CA",
    cityWithStateAbbr: "Ludlow, CA",
  },
  {
    zip: "92339",
    ST: "CA",
    cityWithStateAbbr: "Forest Falls, CA",
  },
  {
    zip: "92340",
    ST: "CA",
    cityWithStateAbbr: "Hesperia, CA",
  },
  {
    zip: "92341",
    ST: "CA",
    cityWithStateAbbr: "Green Valley Lake, CA",
  },
  {
    zip: "92342",
    ST: "CA",
    cityWithStateAbbr: "Helendale, CA",
  },
  {
    zip: "92344",
    ST: "CA",
    cityWithStateAbbr: "Hesperia, CA",
  },
  {
    zip: "92345",
    ST: "CA",
    cityWithStateAbbr: "Hesperia, CA",
  },
  {
    zip: "92346",
    ST: "CA",
    cityWithStateAbbr: "Highland, CA",
  },
  {
    zip: "92347",
    ST: "CA",
    cityWithStateAbbr: "Hinkley, CA",
  },
  {
    zip: "92350",
    ST: "CA",
    cityWithStateAbbr: "Loma Linda, CA",
  },
  {
    zip: "92352",
    ST: "CA",
    cityWithStateAbbr: "Lake Arrowhead, CA",
  },
  {
    zip: "92354",
    ST: "CA",
    cityWithStateAbbr: "Loma Linda, CA",
  },
  {
    zip: "92356",
    ST: "CA",
    cityWithStateAbbr: "Lucerne Valley, CA",
  },
  {
    zip: "92357",
    ST: "CA",
    cityWithStateAbbr: "Loma Linda, CA",
  },
  {
    zip: "92358",
    ST: "CA",
    cityWithStateAbbr: "Lytle Creek, CA",
  },
  {
    zip: "92359",
    ST: "CA",
    cityWithStateAbbr: "Mentone, CA",
  },
  {
    zip: "92363",
    ST: "CA",
    cityWithStateAbbr: "Needles, CA",
  },
  {
    zip: "92364",
    ST: "CA",
    cityWithStateAbbr: "Nipton, CA",
  },
  {
    zip: "92365",
    ST: "CA",
    cityWithStateAbbr: "Newberry Springs, CA",
  },
  {
    zip: "92366",
    ST: "CA",
    cityWithStateAbbr: "Mountain Pass, CA",
  },
  {
    zip: "92368",
    ST: "CA",
    cityWithStateAbbr: "Oro Grande, CA",
  },
  {
    zip: "92369",
    ST: "CA",
    cityWithStateAbbr: "Patton, CA",
  },
  {
    zip: "92371",
    ST: "CA",
    cityWithStateAbbr: "Phelan, CA",
  },
  {
    zip: "92372",
    ST: "CA",
    cityWithStateAbbr: "Pinon Hills, CA",
  },
  {
    zip: "92373",
    ST: "CA",
    cityWithStateAbbr: "Redlands, CA",
  },
  {
    zip: "92374",
    ST: "CA",
    cityWithStateAbbr: "Redlands, CA",
  },
  {
    zip: "92375",
    ST: "CA",
    cityWithStateAbbr: "Redlands, CA",
  },
  {
    zip: "92376",
    ST: "CA",
    cityWithStateAbbr: "Rialto, CA",
  },
  {
    zip: "92377",
    ST: "CA",
    cityWithStateAbbr: "Rialto, CA",
  },
  {
    zip: "92378",
    ST: "CA",
    cityWithStateAbbr: "Rimforest, CA",
  },
  {
    zip: "92382",
    ST: "CA",
    cityWithStateAbbr: "Running Springs, CA",
  },
  {
    zip: "92384",
    ST: "CA",
    cityWithStateAbbr: "Shoshone, CA",
  },
  {
    zip: "92385",
    ST: "CA",
    cityWithStateAbbr: "Skyforest, CA",
  },
  {
    zip: "92386",
    ST: "CA",
    cityWithStateAbbr: "Sugarloaf, CA",
  },
  {
    zip: "92389",
    ST: "CA",
    cityWithStateAbbr: "Tecopa, CA",
  },
  {
    zip: "92391",
    ST: "CA",
    cityWithStateAbbr: "Twin Peaks, CA",
  },
  {
    zip: "92392",
    ST: "CA",
    cityWithStateAbbr: "Victorville, CA",
  },
  {
    zip: "92393",
    ST: "CA",
    cityWithStateAbbr: "Victorville, CA",
  },
  {
    zip: "92394",
    ST: "CA",
    cityWithStateAbbr: "Victorville, CA",
  },
  {
    zip: "92395",
    ST: "CA",
    cityWithStateAbbr: "Victorville, CA",
  },
  {
    zip: "92397",
    ST: "CA",
    cityWithStateAbbr: "Wrightwood, CA",
  },
  {
    zip: "92398",
    ST: "CA",
    cityWithStateAbbr: "Yermo, CA",
  },
  {
    zip: "92399",
    ST: "CA",
    cityWithStateAbbr: "Yucaipa, CA",
  },
  {
    zip: "92401",
    ST: "CA",
    cityWithStateAbbr: "San Bernardino, CA",
  },
  {
    zip: "92402",
    ST: "CA",
    cityWithStateAbbr: "San Bernardino, CA",
  },
  {
    zip: "92403",
    ST: "CA",
    cityWithStateAbbr: "San Bernardino, CA",
  },
  {
    zip: "92404",
    ST: "CA",
    cityWithStateAbbr: "San Bernardino, CA",
  },
  {
    zip: "92405",
    ST: "CA",
    cityWithStateAbbr: "San Bernardino, CA",
  },
  {
    zip: "92406",
    ST: "CA",
    cityWithStateAbbr: "San Bernardino, CA",
  },
  {
    zip: "92407",
    ST: "CA",
    cityWithStateAbbr: "San Bernardino, CA",
  },
  {
    zip: "92408",
    ST: "CA",
    cityWithStateAbbr: "San Bernardino, CA",
  },
  {
    zip: "92410",
    ST: "CA",
    cityWithStateAbbr: "San Bernardino, CA",
  },
  {
    zip: "92411",
    ST: "CA",
    cityWithStateAbbr: "San Bernardino, CA",
  },
  {
    zip: "92412",
    ST: "CA",
    cityWithStateAbbr: "San Bernardino, CA",
  },
  {
    zip: "92413",
    ST: "CA",
    cityWithStateAbbr: "San Bernardino, CA",
  },
  {
    zip: "92414",
    ST: "CA",
    cityWithStateAbbr: "San Bernardino, CA",
  },
  {
    zip: "92415",
    ST: "CA",
    cityWithStateAbbr: "San Bernardino, CA",
  },
  {
    zip: "92418",
    ST: "CA",
    cityWithStateAbbr: "San Bernardino, CA",
  },
  {
    zip: "92423",
    ST: "CA",
    cityWithStateAbbr: "San Bernardino, CA",
  },
  {
    zip: "92424",
    ST: "CA",
    cityWithStateAbbr: "San Bernardino, CA",
  },
  {
    zip: "92427",
    ST: "CA",
    cityWithStateAbbr: "San Bernardino, CA",
  },
  {
    zip: "92501",
    ST: "CA",
    cityWithStateAbbr: "Riverside, CA",
  },
  {
    zip: "92502",
    ST: "CA",
    cityWithStateAbbr: "Riverside, CA",
  },
  {
    zip: "92503",
    ST: "CA",
    cityWithStateAbbr: "Riverside, CA",
  },
  {
    zip: "92504",
    ST: "CA",
    cityWithStateAbbr: "Riverside, CA",
  },
  {
    zip: "92505",
    ST: "CA",
    cityWithStateAbbr: "Riverside, CA",
  },
  {
    zip: "92506",
    ST: "CA",
    cityWithStateAbbr: "Riverside, CA",
  },
  {
    zip: "92507",
    ST: "CA",
    cityWithStateAbbr: "Riverside, CA",
  },
  {
    zip: "92508",
    ST: "CA",
    cityWithStateAbbr: "Riverside, CA",
  },
  {
    zip: "92509",
    ST: "CA",
    cityWithStateAbbr: "Riverside, CA",
  },
  {
    zip: "92513",
    ST: "CA",
    cityWithStateAbbr: "Riverside, CA",
  },
  {
    zip: "92514",
    ST: "CA",
    cityWithStateAbbr: "Riverside, CA",
  },
  {
    zip: "92515",
    ST: "CA",
    cityWithStateAbbr: "Riverside, CA",
  },
  {
    zip: "92516",
    ST: "CA",
    cityWithStateAbbr: "Riverside, CA",
  },
  {
    zip: "92517",
    ST: "CA",
    cityWithStateAbbr: "Riverside, CA",
  },
  {
    zip: "92518",
    ST: "CA",
    cityWithStateAbbr: "March Air Reserve Base, CA",
  },
  {
    zip: "92519",
    ST: "CA",
    cityWithStateAbbr: "Riverside, CA",
  },
  {
    zip: "92521",
    ST: "CA",
    cityWithStateAbbr: "Riverside, CA",
  },
  {
    zip: "92522",
    ST: "CA",
    cityWithStateAbbr: "Riverside, CA",
  },
  {
    zip: "92530",
    ST: "CA",
    cityWithStateAbbr: "Lake Elsinore, CA",
  },
  {
    zip: "92531",
    ST: "CA",
    cityWithStateAbbr: "Lake Elsinore, CA",
  },
  {
    zip: "92532",
    ST: "CA",
    cityWithStateAbbr: "Lake Elsinore, CA",
  },
  {
    zip: "92536",
    ST: "CA",
    cityWithStateAbbr: "Aguanga, CA",
  },
  {
    zip: "92539",
    ST: "CA",
    cityWithStateAbbr: "Anza, CA",
  },
  {
    zip: "92543",
    ST: "CA",
    cityWithStateAbbr: "Hemet, CA",
  },
  {
    zip: "92544",
    ST: "CA",
    cityWithStateAbbr: "Hemet, CA",
  },
  {
    zip: "92545",
    ST: "CA",
    cityWithStateAbbr: "Hemet, CA",
  },
  {
    zip: "92546",
    ST: "CA",
    cityWithStateAbbr: "Hemet, CA",
  },
  {
    zip: "92548",
    ST: "CA",
    cityWithStateAbbr: "Homeland, CA",
  },
  {
    zip: "92549",
    ST: "CA",
    cityWithStateAbbr: "Idyllwild, CA",
  },
  {
    zip: "92551",
    ST: "CA",
    cityWithStateAbbr: "Moreno Valley, CA",
  },
  {
    zip: "92552",
    ST: "CA",
    cityWithStateAbbr: "Moreno Valley, CA",
  },
  {
    zip: "92553",
    ST: "CA",
    cityWithStateAbbr: "Moreno Valley, CA",
  },
  {
    zip: "92554",
    ST: "CA",
    cityWithStateAbbr: "Moreno Valley, CA",
  },
  {
    zip: "92555",
    ST: "CA",
    cityWithStateAbbr: "Moreno Valley, CA",
  },
  {
    zip: "92556",
    ST: "CA",
    cityWithStateAbbr: "Moreno Valley, CA",
  },
  {
    zip: "92557",
    ST: "CA",
    cityWithStateAbbr: "Moreno Valley, CA",
  },
  {
    zip: "92561",
    ST: "CA",
    cityWithStateAbbr: "Mountain Center, CA",
  },
  {
    zip: "92562",
    ST: "CA",
    cityWithStateAbbr: "Murrieta, CA",
  },
  {
    zip: "92563",
    ST: "CA",
    cityWithStateAbbr: "Murrieta, CA",
  },
  {
    zip: "92564",
    ST: "CA",
    cityWithStateAbbr: "Murrieta, CA",
  },
  {
    zip: "92567",
    ST: "CA",
    cityWithStateAbbr: "Nuevo, CA",
  },
  {
    zip: "92570",
    ST: "CA",
    cityWithStateAbbr: "Perris, CA",
  },
  {
    zip: "92571",
    ST: "CA",
    cityWithStateAbbr: "Perris, CA",
  },
  {
    zip: "92572",
    ST: "CA",
    cityWithStateAbbr: "Perris, CA",
  },
  {
    zip: "92581",
    ST: "CA",
    cityWithStateAbbr: "San Jacinto, CA",
  },
  {
    zip: "92582",
    ST: "CA",
    cityWithStateAbbr: "San Jacinto, CA",
  },
  {
    zip: "92583",
    ST: "CA",
    cityWithStateAbbr: "San Jacinto, CA",
  },
  {
    zip: "92584",
    ST: "CA",
    cityWithStateAbbr: "Menifee, CA",
  },
  {
    zip: "92585",
    ST: "CA",
    cityWithStateAbbr: "Sun City, CA",
  },
  {
    zip: "92586",
    ST: "CA",
    cityWithStateAbbr: "Sun City, CA",
  },
  {
    zip: "92587",
    ST: "CA",
    cityWithStateAbbr: "Quail Valley, CA",
  },
  {
    zip: "92589",
    ST: "CA",
    cityWithStateAbbr: "Temecula, CA",
  },
  {
    zip: "92590",
    ST: "CA",
    cityWithStateAbbr: "Temecula, CA",
  },
  {
    zip: "92591",
    ST: "CA",
    cityWithStateAbbr: "Temecula, CA",
  },
  {
    zip: "92592",
    ST: "CA",
    cityWithStateAbbr: "Temecula, CA",
  },
  {
    zip: "92593",
    ST: "CA",
    cityWithStateAbbr: "Temecula, CA",
  },
  {
    zip: "92595",
    ST: "CA",
    cityWithStateAbbr: "Wildomar, CA",
  },
  {
    zip: "92596",
    ST: "CA",
    cityWithStateAbbr: "Winchester, CA",
  },
  {
    zip: "92599",
    ST: "CA",
    cityWithStateAbbr: "Perris, CA",
  },
  {
    zip: "92602",
    ST: "CA",
    cityWithStateAbbr: "Irvine, CA",
  },
  {
    zip: "92603",
    ST: "CA",
    cityWithStateAbbr: "Irvine, CA",
  },
  {
    zip: "92604",
    ST: "CA",
    cityWithStateAbbr: "Irvine, CA",
  },
  {
    zip: "92605",
    ST: "CA",
    cityWithStateAbbr: "Huntington Beach, CA",
  },
  {
    zip: "92606",
    ST: "CA",
    cityWithStateAbbr: "Irvine, CA",
  },
  {
    zip: "92607",
    ST: "CA",
    cityWithStateAbbr: "Laguna Niguel, CA",
  },
  {
    zip: "92609",
    ST: "CA",
    cityWithStateAbbr: "El Toro, CA",
  },
  {
    zip: "92610",
    ST: "CA",
    cityWithStateAbbr: "Foothill Ranch, CA",
  },
  {
    zip: "92612",
    ST: "CA",
    cityWithStateAbbr: "Irvine, CA",
  },
  {
    zip: "92614",
    ST: "CA",
    cityWithStateAbbr: "Irvine, CA",
  },
  {
    zip: "92615",
    ST: "CA",
    cityWithStateAbbr: "Huntington Beach, CA",
  },
  {
    zip: "92616",
    ST: "CA",
    cityWithStateAbbr: "Irvine, CA",
  },
  {
    zip: "92617",
    ST: "CA",
    cityWithStateAbbr: "Irvine, CA",
  },
  {
    zip: "92618",
    ST: "CA",
    cityWithStateAbbr: "Irvine, CA",
  },
  {
    zip: "92619",
    ST: "CA",
    cityWithStateAbbr: "Irvine, CA",
  },
  {
    zip: "92620",
    ST: "CA",
    cityWithStateAbbr: "Irvine, CA",
  },
  {
    zip: "92623",
    ST: "CA",
    cityWithStateAbbr: "Irvine, CA",
  },
  {
    zip: "92624",
    ST: "CA",
    cityWithStateAbbr: "Capistrano Beach, CA",
  },
  {
    zip: "92625",
    ST: "CA",
    cityWithStateAbbr: "Corona Del Mar, CA",
  },
  {
    zip: "92626",
    ST: "CA",
    cityWithStateAbbr: "Costa Mesa, CA",
  },
  {
    zip: "92627",
    ST: "CA",
    cityWithStateAbbr: "Costa Mesa, CA",
  },
  {
    zip: "92628",
    ST: "CA",
    cityWithStateAbbr: "Costa Mesa, CA",
  },
  {
    zip: "92629",
    ST: "CA",
    cityWithStateAbbr: "Dana Point, CA",
  },
  {
    zip: "92630",
    ST: "CA",
    cityWithStateAbbr: "Lake Forest, CA",
  },
  {
    zip: "92637",
    ST: "CA",
    cityWithStateAbbr: "Laguna Woods, CA",
  },
  {
    zip: "92646",
    ST: "CA",
    cityWithStateAbbr: "Huntington Beach, CA",
  },
  {
    zip: "92647",
    ST: "CA",
    cityWithStateAbbr: "Huntington Beach, CA",
  },
  {
    zip: "92648",
    ST: "CA",
    cityWithStateAbbr: "Huntington Beach, CA",
  },
  {
    zip: "92649",
    ST: "CA",
    cityWithStateAbbr: "Huntington Beach, CA",
  },
  {
    zip: "92650",
    ST: "CA",
    cityWithStateAbbr: "East Irvine, CA",
  },
  {
    zip: "92651",
    ST: "CA",
    cityWithStateAbbr: "Laguna Beach, CA",
  },
  {
    zip: "92652",
    ST: "CA",
    cityWithStateAbbr: "Laguna Beach, CA",
  },
  {
    zip: "92653",
    ST: "CA",
    cityWithStateAbbr: "Laguna Hills, CA",
  },
  {
    zip: "92654",
    ST: "CA",
    cityWithStateAbbr: "Laguna Hills, CA",
  },
  {
    zip: "92655",
    ST: "CA",
    cityWithStateAbbr: "Midway City, CA",
  },
  {
    zip: "92656",
    ST: "CA",
    cityWithStateAbbr: "Aliso Viejo, CA",
  },
  {
    zip: "92657",
    ST: "CA",
    cityWithStateAbbr: "Newport Coast, CA",
  },
  {
    zip: "92658",
    ST: "CA",
    cityWithStateAbbr: "Newport Beach, CA",
  },
  {
    zip: "92659",
    ST: "CA",
    cityWithStateAbbr: "Newport Beach, CA",
  },
  {
    zip: "92660",
    ST: "CA",
    cityWithStateAbbr: "Newport Beach, CA",
  },
  {
    zip: "92661",
    ST: "CA",
    cityWithStateAbbr: "Newport Beach, CA",
  },
  {
    zip: "92662",
    ST: "CA",
    cityWithStateAbbr: "Newport Beach, CA",
  },
  {
    zip: "92663",
    ST: "CA",
    cityWithStateAbbr: "Newport Beach, CA",
  },
  {
    zip: "92672",
    ST: "CA",
    cityWithStateAbbr: "San Clemente, CA",
  },
  {
    zip: "92673",
    ST: "CA",
    cityWithStateAbbr: "San Clemente, CA",
  },
  {
    zip: "92674",
    ST: "CA",
    cityWithStateAbbr: "San Clemente, CA",
  },
  {
    zip: "92675",
    ST: "CA",
    cityWithStateAbbr: "San Juan Capistrano, CA",
  },
  {
    zip: "92676",
    ST: "CA",
    cityWithStateAbbr: "Silverado, CA",
  },
  {
    zip: "92677",
    ST: "CA",
    cityWithStateAbbr: "Laguna Niguel, CA",
  },
  {
    zip: "92678",
    ST: "CA",
    cityWithStateAbbr: "Trabuco Canyon, CA",
  },
  {
    zip: "92679",
    ST: "CA",
    cityWithStateAbbr: "Trabuco Canyon, CA",
  },
  {
    zip: "92683",
    ST: "CA",
    cityWithStateAbbr: "Westminster, CA",
  },
  {
    zip: "92684",
    ST: "CA",
    cityWithStateAbbr: "Westminster, CA",
  },
  {
    zip: "92685",
    ST: "CA",
    cityWithStateAbbr: "Westminster, CA",
  },
  {
    zip: "92688",
    ST: "CA",
    cityWithStateAbbr: "Rancho Santa Margarita, CA",
  },
  {
    zip: "92690",
    ST: "CA",
    cityWithStateAbbr: "Mission Viejo, CA",
  },
  {
    zip: "92691",
    ST: "CA",
    cityWithStateAbbr: "Mission Viejo, CA",
  },
  {
    zip: "92692",
    ST: "CA",
    cityWithStateAbbr: "Mission Viejo, CA",
  },
  {
    zip: "92693",
    ST: "CA",
    cityWithStateAbbr: "San Juan Capistrano, CA",
  },
  {
    zip: "92694",
    ST: "CA",
    cityWithStateAbbr: "Ladera Ranch, CA",
  },
  {
    zip: "92697",
    ST: "CA",
    cityWithStateAbbr: "Irvine, CA",
  },
  {
    zip: "92698",
    ST: "CA",
    cityWithStateAbbr: "Aliso Viejo, CA",
  },
  {
    zip: "92701",
    ST: "CA",
    cityWithStateAbbr: "Santa Ana, CA",
  },
  {
    zip: "92702",
    ST: "CA",
    cityWithStateAbbr: "Santa Ana, CA",
  },
  {
    zip: "92703",
    ST: "CA",
    cityWithStateAbbr: "Santa Ana, CA",
  },
  {
    zip: "92704",
    ST: "CA",
    cityWithStateAbbr: "Santa Ana, CA",
  },
  {
    zip: "92705",
    ST: "CA",
    cityWithStateAbbr: "Santa Ana, CA",
  },
  {
    zip: "92706",
    ST: "CA",
    cityWithStateAbbr: "Santa Ana, CA",
  },
  {
    zip: "92707",
    ST: "CA",
    cityWithStateAbbr: "Santa Ana, CA",
  },
  {
    zip: "92708",
    ST: "CA",
    cityWithStateAbbr: "Fountain Valley, CA",
  },
  {
    zip: "92711",
    ST: "CA",
    cityWithStateAbbr: "Santa Ana, CA",
  },
  {
    zip: "92712",
    ST: "CA",
    cityWithStateAbbr: "Santa Ana, CA",
  },
  {
    zip: "92725",
    ST: "CA",
    cityWithStateAbbr: "Santa Ana, CA",
  },
  {
    zip: "92728",
    ST: "CA",
    cityWithStateAbbr: "Fountain Valley, CA",
  },
  {
    zip: "92735",
    ST: "CA",
    cityWithStateAbbr: "Santa Ana, CA",
  },
  {
    zip: "92780",
    ST: "CA",
    cityWithStateAbbr: "Tustin, CA",
  },
  {
    zip: "92781",
    ST: "CA",
    cityWithStateAbbr: "Tustin, CA",
  },
  {
    zip: "92782",
    ST: "CA",
    cityWithStateAbbr: "Tustin, CA",
  },
  {
    zip: "92799",
    ST: "CA",
    cityWithStateAbbr: "Santa Ana, CA",
  },
  {
    zip: "92801",
    ST: "CA",
    cityWithStateAbbr: "Anaheim, CA",
  },
  {
    zip: "92802",
    ST: "CA",
    cityWithStateAbbr: "Anaheim, CA",
  },
  {
    zip: "92803",
    ST: "CA",
    cityWithStateAbbr: "Anaheim, CA",
  },
  {
    zip: "92804",
    ST: "CA",
    cityWithStateAbbr: "Anaheim, CA",
  },
  {
    zip: "92805",
    ST: "CA",
    cityWithStateAbbr: "Anaheim, CA",
  },
  {
    zip: "92806",
    ST: "CA",
    cityWithStateAbbr: "Anaheim, CA",
  },
  {
    zip: "92807",
    ST: "CA",
    cityWithStateAbbr: "Anaheim, CA",
  },
  {
    zip: "92808",
    ST: "CA",
    cityWithStateAbbr: "Anaheim, CA",
  },
  {
    zip: "92809",
    ST: "CA",
    cityWithStateAbbr: "Anaheim, CA",
  },
  {
    zip: "92811",
    ST: "CA",
    cityWithStateAbbr: "Atwood, CA",
  },
  {
    zip: "92812",
    ST: "CA",
    cityWithStateAbbr: "Anaheim, CA",
  },
  {
    zip: "92814",
    ST: "CA",
    cityWithStateAbbr: "Anaheim, CA",
  },
  {
    zip: "92815",
    ST: "CA",
    cityWithStateAbbr: "Anaheim, CA",
  },
  {
    zip: "92816",
    ST: "CA",
    cityWithStateAbbr: "Anaheim, CA",
  },
  {
    zip: "92817",
    ST: "CA",
    cityWithStateAbbr: "Anaheim, CA",
  },
  {
    zip: "92821",
    ST: "CA",
    cityWithStateAbbr: "Brea, CA",
  },
  {
    zip: "92822",
    ST: "CA",
    cityWithStateAbbr: "Brea, CA",
  },
  {
    zip: "92823",
    ST: "CA",
    cityWithStateAbbr: "Brea, CA",
  },
  {
    zip: "92825",
    ST: "CA",
    cityWithStateAbbr: "Anaheim, CA",
  },
  {
    zip: "92831",
    ST: "CA",
    cityWithStateAbbr: "Fullerton, CA",
  },
  {
    zip: "92832",
    ST: "CA",
    cityWithStateAbbr: "Fullerton, CA",
  },
  {
    zip: "92833",
    ST: "CA",
    cityWithStateAbbr: "Fullerton, CA",
  },
  {
    zip: "92834",
    ST: "CA",
    cityWithStateAbbr: "Fullerton, CA",
  },
  {
    zip: "92835",
    ST: "CA",
    cityWithStateAbbr: "Fullerton, CA",
  },
  {
    zip: "92836",
    ST: "CA",
    cityWithStateAbbr: "Fullerton, CA",
  },
  {
    zip: "92837",
    ST: "CA",
    cityWithStateAbbr: "Fullerton, CA",
  },
  {
    zip: "92838",
    ST: "CA",
    cityWithStateAbbr: "Fullerton, CA",
  },
  {
    zip: "92840",
    ST: "CA",
    cityWithStateAbbr: "Garden Grove, CA",
  },
  {
    zip: "92841",
    ST: "CA",
    cityWithStateAbbr: "Garden Grove, CA",
  },
  {
    zip: "92842",
    ST: "CA",
    cityWithStateAbbr: "Garden Grove, CA",
  },
  {
    zip: "92843",
    ST: "CA",
    cityWithStateAbbr: "Garden Grove, CA",
  },
  {
    zip: "92844",
    ST: "CA",
    cityWithStateAbbr: "Garden Grove, CA",
  },
  {
    zip: "92845",
    ST: "CA",
    cityWithStateAbbr: "Garden Grove, CA",
  },
  {
    zip: "92846",
    ST: "CA",
    cityWithStateAbbr: "Garden Grove, CA",
  },
  {
    zip: "92850",
    ST: "CA",
    cityWithStateAbbr: "Anaheim, CA",
  },
  {
    zip: "92856",
    ST: "CA",
    cityWithStateAbbr: "Orange, CA",
  },
  {
    zip: "92857",
    ST: "CA",
    cityWithStateAbbr: "Orange, CA",
  },
  {
    zip: "92859",
    ST: "CA",
    cityWithStateAbbr: "Orange, CA",
  },
  {
    zip: "92860",
    ST: "CA",
    cityWithStateAbbr: "Norco, CA",
  },
  {
    zip: "92861",
    ST: "CA",
    cityWithStateAbbr: "Villa Park, CA",
  },
  {
    zip: "92862",
    ST: "CA",
    cityWithStateAbbr: "Orange, CA",
  },
  {
    zip: "92863",
    ST: "CA",
    cityWithStateAbbr: "Orange, CA",
  },
  {
    zip: "92864",
    ST: "CA",
    cityWithStateAbbr: "Orange, CA",
  },
  {
    zip: "92865",
    ST: "CA",
    cityWithStateAbbr: "Orange, CA",
  },
  {
    zip: "92866",
    ST: "CA",
    cityWithStateAbbr: "Orange, CA",
  },
  {
    zip: "92867",
    ST: "CA",
    cityWithStateAbbr: "Orange, CA",
  },
  {
    zip: "92868",
    ST: "CA",
    cityWithStateAbbr: "Orange, CA",
  },
  {
    zip: "92869",
    ST: "CA",
    cityWithStateAbbr: "Orange, CA",
  },
  {
    zip: "92870",
    ST: "CA",
    cityWithStateAbbr: "Placentia, CA",
  },
  {
    zip: "92871",
    ST: "CA",
    cityWithStateAbbr: "Placentia, CA",
  },
  {
    zip: "92877",
    ST: "CA",
    cityWithStateAbbr: "Corona, CA",
  },
  {
    zip: "92878",
    ST: "CA",
    cityWithStateAbbr: "Corona, CA",
  },
  {
    zip: "92879",
    ST: "CA",
    cityWithStateAbbr: "Corona, CA",
  },
  {
    zip: "92880",
    ST: "CA",
    cityWithStateAbbr: "Corona, CA",
  },
  {
    zip: "92881",
    ST: "CA",
    cityWithStateAbbr: "Corona, CA",
  },
  {
    zip: "92882",
    ST: "CA",
    cityWithStateAbbr: "Corona, CA",
  },
  {
    zip: "92883",
    ST: "CA",
    cityWithStateAbbr: "Corona, CA",
  },
  {
    zip: "92885",
    ST: "CA",
    cityWithStateAbbr: "Yorba Linda, CA",
  },
  {
    zip: "92886",
    ST: "CA",
    cityWithStateAbbr: "Yorba Linda, CA",
  },
  {
    zip: "92887",
    ST: "CA",
    cityWithStateAbbr: "Yorba Linda, CA",
  },
  {
    zip: "92899",
    ST: "CA",
    cityWithStateAbbr: "Anaheim, CA",
  },
  {
    zip: "93001",
    ST: "CA",
    cityWithStateAbbr: "Ventura, CA",
  },
  {
    zip: "93002",
    ST: "CA",
    cityWithStateAbbr: "Ventura, CA",
  },
  {
    zip: "93003",
    ST: "CA",
    cityWithStateAbbr: "Ventura, CA",
  },
  {
    zip: "93004",
    ST: "CA",
    cityWithStateAbbr: "Ventura, CA",
  },
  {
    zip: "93005",
    ST: "CA",
    cityWithStateAbbr: "Ventura, CA",
  },
  {
    zip: "93006",
    ST: "CA",
    cityWithStateAbbr: "Ventura, CA",
  },
  {
    zip: "93007",
    ST: "CA",
    cityWithStateAbbr: "Ventura, CA",
  },
  {
    zip: "93009",
    ST: "CA",
    cityWithStateAbbr: "Ventura, CA",
  },
  {
    zip: "93010",
    ST: "CA",
    cityWithStateAbbr: "Camarillo, CA",
  },
  {
    zip: "93011",
    ST: "CA",
    cityWithStateAbbr: "Camarillo, CA",
  },
  {
    zip: "93012",
    ST: "CA",
    cityWithStateAbbr: "Camarillo, CA",
  },
  {
    zip: "93013",
    ST: "CA",
    cityWithStateAbbr: "Carpinteria, CA",
  },
  {
    zip: "93014",
    ST: "CA",
    cityWithStateAbbr: "Carpinteria, CA",
  },
  {
    zip: "93015",
    ST: "CA",
    cityWithStateAbbr: "Fillmore, CA",
  },
  {
    zip: "93016",
    ST: "CA",
    cityWithStateAbbr: "Fillmore, CA",
  },
  {
    zip: "93020",
    ST: "CA",
    cityWithStateAbbr: "Moorpark, CA",
  },
  {
    zip: "93021",
    ST: "CA",
    cityWithStateAbbr: "Moorpark, CA",
  },
  {
    zip: "93022",
    ST: "CA",
    cityWithStateAbbr: "Oak View, CA",
  },
  {
    zip: "93023",
    ST: "CA",
    cityWithStateAbbr: "Ojai, CA",
  },
  {
    zip: "93024",
    ST: "CA",
    cityWithStateAbbr: "Ojai, CA",
  },
  {
    zip: "93030",
    ST: "CA",
    cityWithStateAbbr: "Oxnard, CA",
  },
  {
    zip: "93031",
    ST: "CA",
    cityWithStateAbbr: "Oxnard, CA",
  },
  {
    zip: "93032",
    ST: "CA",
    cityWithStateAbbr: "Oxnard, CA",
  },
  {
    zip: "93033",
    ST: "CA",
    cityWithStateAbbr: "Oxnard, CA",
  },
  {
    zip: "93034",
    ST: "CA",
    cityWithStateAbbr: "Oxnard, CA",
  },
  {
    zip: "93035",
    ST: "CA",
    cityWithStateAbbr: "Oxnard, CA",
  },
  {
    zip: "93036",
    ST: "CA",
    cityWithStateAbbr: "Oxnard, CA",
  },
  {
    zip: "93040",
    ST: "CA",
    cityWithStateAbbr: "Piru, CA",
  },
  {
    zip: "93041",
    ST: "CA",
    cityWithStateAbbr: "Port Hueneme, CA",
  },
  {
    zip: "93042",
    ST: "CA",
    cityWithStateAbbr: "Point Mugu Nawc, CA",
  },
  {
    zip: "93043",
    ST: "CA",
    cityWithStateAbbr: "Port Hueneme Cbc Base, CA",
  },
  {
    zip: "93044",
    ST: "CA",
    cityWithStateAbbr: "Port Hueneme, CA",
  },
  {
    zip: "93060",
    ST: "CA",
    cityWithStateAbbr: "Santa Paula, CA",
  },
  {
    zip: "93061",
    ST: "CA",
    cityWithStateAbbr: "Santa Paula, CA",
  },
  {
    zip: "93062",
    ST: "CA",
    cityWithStateAbbr: "Simi Valley, CA",
  },
  {
    zip: "93063",
    ST: "CA",
    cityWithStateAbbr: "Simi Valley, CA",
  },
  {
    zip: "93064",
    ST: "CA",
    cityWithStateAbbr: "Brandeis, CA",
  },
  {
    zip: "93065",
    ST: "CA",
    cityWithStateAbbr: "Simi Valley, CA",
  },
  {
    zip: "93066",
    ST: "CA",
    cityWithStateAbbr: "Somis, CA",
  },
  {
    zip: "93067",
    ST: "CA",
    cityWithStateAbbr: "Summerland, CA",
  },
  {
    zip: "93094",
    ST: "CA",
    cityWithStateAbbr: "Simi Valley, CA",
  },
  {
    zip: "93099",
    ST: "CA",
    cityWithStateAbbr: "Simi Valley, CA",
  },
  {
    zip: "93101",
    ST: "CA",
    cityWithStateAbbr: "Santa Barbara, CA",
  },
  {
    zip: "93102",
    ST: "CA",
    cityWithStateAbbr: "Santa Barbara, CA",
  },
  {
    zip: "93103",
    ST: "CA",
    cityWithStateAbbr: "Santa Barbara, CA",
  },
  {
    zip: "93105",
    ST: "CA",
    cityWithStateAbbr: "Santa Barbara, CA",
  },
  {
    zip: "93106",
    ST: "CA",
    cityWithStateAbbr: "Santa Barbara, CA",
  },
  {
    zip: "93107",
    ST: "CA",
    cityWithStateAbbr: "Santa Barbara, CA",
  },
  {
    zip: "93108",
    ST: "CA",
    cityWithStateAbbr: "Santa Barbara, CA",
  },
  {
    zip: "93109",
    ST: "CA",
    cityWithStateAbbr: "Santa Barbara, CA",
  },
  {
    zip: "93110",
    ST: "CA",
    cityWithStateAbbr: "Santa Barbara, CA",
  },
  {
    zip: "93111",
    ST: "CA",
    cityWithStateAbbr: "Santa Barbara, CA",
  },
  {
    zip: "93116",
    ST: "CA",
    cityWithStateAbbr: "Goleta, CA",
  },
  {
    zip: "93117",
    ST: "CA",
    cityWithStateAbbr: "Goleta, CA",
  },
  {
    zip: "93118",
    ST: "CA",
    cityWithStateAbbr: "Goleta, CA",
  },
  {
    zip: "93120",
    ST: "CA",
    cityWithStateAbbr: "Santa Barbara, CA",
  },
  {
    zip: "93121",
    ST: "CA",
    cityWithStateAbbr: "Santa Barbara, CA",
  },
  {
    zip: "93130",
    ST: "CA",
    cityWithStateAbbr: "Santa Barbara, CA",
  },
  {
    zip: "93140",
    ST: "CA",
    cityWithStateAbbr: "Santa Barbara, CA",
  },
  {
    zip: "93150",
    ST: "CA",
    cityWithStateAbbr: "Santa Barbara, CA",
  },
  {
    zip: "93160",
    ST: "CA",
    cityWithStateAbbr: "Santa Barbara, CA",
  },
  {
    zip: "93190",
    ST: "CA",
    cityWithStateAbbr: "Santa Barbara, CA",
  },
  {
    zip: "93199",
    ST: "CA",
    cityWithStateAbbr: "Goleta, CA",
  },
  {
    zip: "93201",
    ST: "CA",
    cityWithStateAbbr: "Alpaugh, CA",
  },
  {
    zip: "93202",
    ST: "CA",
    cityWithStateAbbr: "Armona, CA",
  },
  {
    zip: "93203",
    ST: "CA",
    cityWithStateAbbr: "Arvin, CA",
  },
  {
    zip: "93204",
    ST: "CA",
    cityWithStateAbbr: "Avenal, CA",
  },
  {
    zip: "93205",
    ST: "CA",
    cityWithStateAbbr: "Bodfish, CA",
  },
  {
    zip: "93206",
    ST: "CA",
    cityWithStateAbbr: "Buttonwillow, CA",
  },
  {
    zip: "93207",
    ST: "CA",
    cityWithStateAbbr: "California Hot Springs, CA",
  },
  {
    zip: "93208",
    ST: "CA",
    cityWithStateAbbr: "Camp Nelson, CA",
  },
  {
    zip: "93210",
    ST: "CA",
    cityWithStateAbbr: "Coalinga, CA",
  },
  {
    zip: "93212",
    ST: "CA",
    cityWithStateAbbr: "Corcoran, CA",
  },
  {
    zip: "93215",
    ST: "CA",
    cityWithStateAbbr: "Delano, CA",
  },
  {
    zip: "93216",
    ST: "CA",
    cityWithStateAbbr: "Delano, CA",
  },
  {
    zip: "93218",
    ST: "CA",
    cityWithStateAbbr: "Ducor, CA",
  },
  {
    zip: "93219",
    ST: "CA",
    cityWithStateAbbr: "Earlimart, CA",
  },
  {
    zip: "93220",
    ST: "CA",
    cityWithStateAbbr: "Edison, CA",
  },
  {
    zip: "93221",
    ST: "CA",
    cityWithStateAbbr: "Exeter, CA",
  },
  {
    zip: "93222",
    ST: "CA",
    cityWithStateAbbr: "Pine Mountain Club, CA",
  },
  {
    zip: "93223",
    ST: "CA",
    cityWithStateAbbr: "Farmersville, CA",
  },
  {
    zip: "93224",
    ST: "CA",
    cityWithStateAbbr: "Fellows, CA",
  },
  {
    zip: "93225",
    ST: "CA",
    cityWithStateAbbr: "Frazier Park, CA",
  },
  {
    zip: "93226",
    ST: "CA",
    cityWithStateAbbr: "Glennville, CA",
  },
  {
    zip: "93227",
    ST: "CA",
    cityWithStateAbbr: "Goshen, CA",
  },
  {
    zip: "93230",
    ST: "CA",
    cityWithStateAbbr: "Hanford, CA",
  },
  {
    zip: "93232",
    ST: "CA",
    cityWithStateAbbr: "Hanford, CA",
  },
  {
    zip: "93234",
    ST: "CA",
    cityWithStateAbbr: "Huron, CA",
  },
  {
    zip: "93235",
    ST: "CA",
    cityWithStateAbbr: "Ivanhoe, CA",
  },
  {
    zip: "93237",
    ST: "CA",
    cityWithStateAbbr: "Kaweah, CA",
  },
  {
    zip: "93238",
    ST: "CA",
    cityWithStateAbbr: "Kernville, CA",
  },
  {
    zip: "93239",
    ST: "CA",
    cityWithStateAbbr: "Kettleman City, CA",
  },
  {
    zip: "93240",
    ST: "CA",
    cityWithStateAbbr: "Lake Isabella, CA",
  },
  {
    zip: "93241",
    ST: "CA",
    cityWithStateAbbr: "Lamont, CA",
  },
  {
    zip: "93242",
    ST: "CA",
    cityWithStateAbbr: "Laton, CA",
  },
  {
    zip: "93243",
    ST: "CA",
    cityWithStateAbbr: "Lebec, CA",
  },
  {
    zip: "93244",
    ST: "CA",
    cityWithStateAbbr: "Lemon Cove, CA",
  },
  {
    zip: "93245",
    ST: "CA",
    cityWithStateAbbr: "Lemoore, CA",
  },
  {
    zip: "93246",
    ST: "CA",
    cityWithStateAbbr: "Lemoore, CA",
  },
  {
    zip: "93247",
    ST: "CA",
    cityWithStateAbbr: "Lindsay, CA",
  },
  {
    zip: "93249",
    ST: "CA",
    cityWithStateAbbr: "Lost Hills, CA",
  },
  {
    zip: "93250",
    ST: "CA",
    cityWithStateAbbr: "Mc Farland, CA",
  },
  {
    zip: "93251",
    ST: "CA",
    cityWithStateAbbr: "Mc Kittrick, CA",
  },
  {
    zip: "93252",
    ST: "CA",
    cityWithStateAbbr: "Maricopa, CA",
  },
  {
    zip: "93254",
    ST: "CA",
    cityWithStateAbbr: "New Cuyama, CA",
  },
  {
    zip: "93255",
    ST: "CA",
    cityWithStateAbbr: "Onyx, CA",
  },
  {
    zip: "93256",
    ST: "CA",
    cityWithStateAbbr: "Pixley, CA",
  },
  {
    zip: "93257",
    ST: "CA",
    cityWithStateAbbr: "Porterville, CA",
  },
  {
    zip: "93258",
    ST: "CA",
    cityWithStateAbbr: "Porterville, CA",
  },
  {
    zip: "93260",
    ST: "CA",
    cityWithStateAbbr: "Posey, CA",
  },
  {
    zip: "93261",
    ST: "CA",
    cityWithStateAbbr: "Richgrove, CA",
  },
  {
    zip: "93262",
    ST: "CA",
    cityWithStateAbbr: "Sequoia National Park, CA",
  },
  {
    zip: "93263",
    ST: "CA",
    cityWithStateAbbr: "Shafter, CA",
  },
  {
    zip: "93265",
    ST: "CA",
    cityWithStateAbbr: "Springville, CA",
  },
  {
    zip: "93266",
    ST: "CA",
    cityWithStateAbbr: "Stratford, CA",
  },
  {
    zip: "93267",
    ST: "CA",
    cityWithStateAbbr: "Strathmore, CA",
  },
  {
    zip: "93268",
    ST: "CA",
    cityWithStateAbbr: "Taft, CA",
  },
  {
    zip: "93270",
    ST: "CA",
    cityWithStateAbbr: "Terra Bella, CA",
  },
  {
    zip: "93271",
    ST: "CA",
    cityWithStateAbbr: "Three Rivers, CA",
  },
  {
    zip: "93272",
    ST: "CA",
    cityWithStateAbbr: "Tipton, CA",
  },
  {
    zip: "93274",
    ST: "CA",
    cityWithStateAbbr: "Tulare, CA",
  },
  {
    zip: "93275",
    ST: "CA",
    cityWithStateAbbr: "Tulare, CA",
  },
  {
    zip: "93276",
    ST: "CA",
    cityWithStateAbbr: "Tupman, CA",
  },
  {
    zip: "93277",
    ST: "CA",
    cityWithStateAbbr: "Visalia, CA",
  },
  {
    zip: "93278",
    ST: "CA",
    cityWithStateAbbr: "Visalia, CA",
  },
  {
    zip: "93279",
    ST: "CA",
    cityWithStateAbbr: "Visalia, CA",
  },
  {
    zip: "93280",
    ST: "CA",
    cityWithStateAbbr: "Wasco, CA",
  },
  {
    zip: "93282",
    ST: "CA",
    cityWithStateAbbr: "Waukena, CA",
  },
  {
    zip: "93283",
    ST: "CA",
    cityWithStateAbbr: "Weldon, CA",
  },
  {
    zip: "93285",
    ST: "CA",
    cityWithStateAbbr: "Wofford Heights, CA",
  },
  {
    zip: "93286",
    ST: "CA",
    cityWithStateAbbr: "Woodlake, CA",
  },
  {
    zip: "93287",
    ST: "CA",
    cityWithStateAbbr: "Woody, CA",
  },
  {
    zip: "93290",
    ST: "CA",
    cityWithStateAbbr: "Visalia, CA",
  },
  {
    zip: "93291",
    ST: "CA",
    cityWithStateAbbr: "Visalia, CA",
  },
  {
    zip: "93292",
    ST: "CA",
    cityWithStateAbbr: "Visalia, CA",
  },
  {
    zip: "93301",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93302",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93303",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93304",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93305",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93306",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93307",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93308",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93309",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93311",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93312",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93313",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93314",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93380",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93383",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93384",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93385",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93386",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93387",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93388",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93389",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93390",
    ST: "CA",
    cityWithStateAbbr: "Bakersfield, CA",
  },
  {
    zip: "93401",
    ST: "CA",
    cityWithStateAbbr: "San Luis Obispo, CA",
  },
  {
    zip: "93402",
    ST: "CA",
    cityWithStateAbbr: "Los Osos, CA",
  },
  {
    zip: "93403",
    ST: "CA",
    cityWithStateAbbr: "San Luis Obispo, CA",
  },
  {
    zip: "93405",
    ST: "CA",
    cityWithStateAbbr: "San Luis Obispo, CA",
  },
  {
    zip: "93406",
    ST: "CA",
    cityWithStateAbbr: "San Luis Obispo, CA",
  },
  {
    zip: "93407",
    ST: "CA",
    cityWithStateAbbr: "San Luis Obispo, CA",
  },
  {
    zip: "93408",
    ST: "CA",
    cityWithStateAbbr: "San Luis Obispo, CA",
  },
  {
    zip: "93409",
    ST: "CA",
    cityWithStateAbbr: "San Luis Obispo, CA",
  },
  {
    zip: "93410",
    ST: "CA",
    cityWithStateAbbr: "San Luis Obispo, CA",
  },
  {
    zip: "93412",
    ST: "CA",
    cityWithStateAbbr: "Los Osos, CA",
  },
  {
    zip: "93420",
    ST: "CA",
    cityWithStateAbbr: "Arroyo Grande, CA",
  },
  {
    zip: "93421",
    ST: "CA",
    cityWithStateAbbr: "Arroyo Grande, CA",
  },
  {
    zip: "93422",
    ST: "CA",
    cityWithStateAbbr: "Atascadero, CA",
  },
  {
    zip: "93423",
    ST: "CA",
    cityWithStateAbbr: "Atascadero, CA",
  },
  {
    zip: "93424",
    ST: "CA",
    cityWithStateAbbr: "Avila Beach, CA",
  },
  {
    zip: "93426",
    ST: "CA",
    cityWithStateAbbr: "Bradley, CA",
  },
  {
    zip: "93427",
    ST: "CA",
    cityWithStateAbbr: "Buellton, CA",
  },
  {
    zip: "93428",
    ST: "CA",
    cityWithStateAbbr: "Cambria, CA",
  },
  {
    zip: "93429",
    ST: "CA",
    cityWithStateAbbr: "Casmalia, CA",
  },
  {
    zip: "93430",
    ST: "CA",
    cityWithStateAbbr: "Cayucos, CA",
  },
  {
    zip: "93432",
    ST: "CA",
    cityWithStateAbbr: "Creston, CA",
  },
  {
    zip: "93433",
    ST: "CA",
    cityWithStateAbbr: "Grover Beach, CA",
  },
  {
    zip: "93434",
    ST: "CA",
    cityWithStateAbbr: "Guadalupe, CA",
  },
  {
    zip: "93435",
    ST: "CA",
    cityWithStateAbbr: "Harmony, CA",
  },
  {
    zip: "93436",
    ST: "CA",
    cityWithStateAbbr: "Lompoc, CA",
  },
  {
    zip: "93437",
    ST: "CA",
    cityWithStateAbbr: "Lompoc, CA",
  },
  {
    zip: "93438",
    ST: "CA",
    cityWithStateAbbr: "Lompoc, CA",
  },
  {
    zip: "93440",
    ST: "CA",
    cityWithStateAbbr: "Los Alamos, CA",
  },
  {
    zip: "93441",
    ST: "CA",
    cityWithStateAbbr: "Los Olivos, CA",
  },
  {
    zip: "93442",
    ST: "CA",
    cityWithStateAbbr: "Morro Bay, CA",
  },
  {
    zip: "93443",
    ST: "CA",
    cityWithStateAbbr: "Morro Bay, CA",
  },
  {
    zip: "93444",
    ST: "CA",
    cityWithStateAbbr: "Nipomo, CA",
  },
  {
    zip: "93445",
    ST: "CA",
    cityWithStateAbbr: "Oceano, CA",
  },
  {
    zip: "93446",
    ST: "CA",
    cityWithStateAbbr: "Paso Robles, CA",
  },
  {
    zip: "93447",
    ST: "CA",
    cityWithStateAbbr: "Paso Robles, CA",
  },
  {
    zip: "93448",
    ST: "CA",
    cityWithStateAbbr: "Pismo Beach, CA",
  },
  {
    zip: "93449",
    ST: "CA",
    cityWithStateAbbr: "Pismo Beach, CA",
  },
  {
    zip: "93450",
    ST: "CA",
    cityWithStateAbbr: "San Ardo, CA",
  },
  {
    zip: "93451",
    ST: "CA",
    cityWithStateAbbr: "San Miguel, CA",
  },
  {
    zip: "93452",
    ST: "CA",
    cityWithStateAbbr: "San Simeon, CA",
  },
  {
    zip: "93453",
    ST: "CA",
    cityWithStateAbbr: "Santa Margarita, CA",
  },
  {
    zip: "93454",
    ST: "CA",
    cityWithStateAbbr: "Santa Maria, CA",
  },
  {
    zip: "93455",
    ST: "CA",
    cityWithStateAbbr: "Santa Maria, CA",
  },
  {
    zip: "93456",
    ST: "CA",
    cityWithStateAbbr: "Santa Maria, CA",
  },
  {
    zip: "93457",
    ST: "CA",
    cityWithStateAbbr: "Santa Maria, CA",
  },
  {
    zip: "93458",
    ST: "CA",
    cityWithStateAbbr: "Santa Maria, CA",
  },
  {
    zip: "93460",
    ST: "CA",
    cityWithStateAbbr: "Santa Ynez, CA",
  },
  {
    zip: "93461",
    ST: "CA",
    cityWithStateAbbr: "Shandon, CA",
  },
  {
    zip: "93463",
    ST: "CA",
    cityWithStateAbbr: "Solvang, CA",
  },
  {
    zip: "93464",
    ST: "CA",
    cityWithStateAbbr: "Solvang, CA",
  },
  {
    zip: "93465",
    ST: "CA",
    cityWithStateAbbr: "Templeton, CA",
  },
  {
    zip: "93475",
    ST: "CA",
    cityWithStateAbbr: "Oceano, CA",
  },
  {
    zip: "93483",
    ST: "CA",
    cityWithStateAbbr: "Grover Beach, CA",
  },
  {
    zip: "93501",
    ST: "CA",
    cityWithStateAbbr: "Mojave, CA",
  },
  {
    zip: "93502",
    ST: "CA",
    cityWithStateAbbr: "Mojave, CA",
  },
  {
    zip: "93504",
    ST: "CA",
    cityWithStateAbbr: "California City, CA",
  },
  {
    zip: "93505",
    ST: "CA",
    cityWithStateAbbr: "California City, CA",
  },
  {
    zip: "93510",
    ST: "CA",
    cityWithStateAbbr: "Acton, CA",
  },
  {
    zip: "93512",
    ST: "CA",
    cityWithStateAbbr: "Benton, CA",
  },
  {
    zip: "93513",
    ST: "CA",
    cityWithStateAbbr: "Big Pine, CA",
  },
  {
    zip: "93514",
    ST: "CA",
    cityWithStateAbbr: "Bishop, CA",
  },
  {
    zip: "93515",
    ST: "CA",
    cityWithStateAbbr: "Bishop, CA",
  },
  {
    zip: "93516",
    ST: "CA",
    cityWithStateAbbr: "Boron, CA",
  },
  {
    zip: "93517",
    ST: "CA",
    cityWithStateAbbr: "Bridgeport, CA",
  },
  {
    zip: "93518",
    ST: "CA",
    cityWithStateAbbr: "Caliente, CA",
  },
  {
    zip: "93519",
    ST: "CA",
    cityWithStateAbbr: "Cantil, CA",
  },
  {
    zip: "93522",
    ST: "CA",
    cityWithStateAbbr: "Darwin, CA",
  },
  {
    zip: "93523",
    ST: "CA",
    cityWithStateAbbr: "Edwards, CA",
  },
  {
    zip: "93524",
    ST: "CA",
    cityWithStateAbbr: "Edwards, CA",
  },
  {
    zip: "93526",
    ST: "CA",
    cityWithStateAbbr: "Independence, CA",
  },
  {
    zip: "93527",
    ST: "CA",
    cityWithStateAbbr: "Inyokern, CA",
  },
  {
    zip: "93528",
    ST: "CA",
    cityWithStateAbbr: "Johannesburg, CA",
  },
  {
    zip: "93529",
    ST: "CA",
    cityWithStateAbbr: "June Lake, CA",
  },
  {
    zip: "93530",
    ST: "CA",
    cityWithStateAbbr: "Keeler, CA",
  },
  {
    zip: "93531",
    ST: "CA",
    cityWithStateAbbr: "Keene, CA",
  },
  {
    zip: "93532",
    ST: "CA",
    cityWithStateAbbr: "Lake Hughes, CA",
  },
  {
    zip: "93534",
    ST: "CA",
    cityWithStateAbbr: "Lancaster, CA",
  },
  {
    zip: "93535",
    ST: "CA",
    cityWithStateAbbr: "Lancaster, CA",
  },
  {
    zip: "93536",
    ST: "CA",
    cityWithStateAbbr: "Lancaster, CA",
  },
  {
    zip: "93539",
    ST: "CA",
    cityWithStateAbbr: "Lancaster, CA",
  },
  {
    zip: "93541",
    ST: "CA",
    cityWithStateAbbr: "Lee Vining, CA",
  },
  {
    zip: "93542",
    ST: "CA",
    cityWithStateAbbr: "Little Lake, CA",
  },
  {
    zip: "93543",
    ST: "CA",
    cityWithStateAbbr: "Littlerock, CA",
  },
  {
    zip: "93544",
    ST: "CA",
    cityWithStateAbbr: "Llano, CA",
  },
  {
    zip: "93545",
    ST: "CA",
    cityWithStateAbbr: "Lone Pine, CA",
  },
  {
    zip: "93546",
    ST: "CA",
    cityWithStateAbbr: "Mammoth Lakes, CA",
  },
  {
    zip: "93549",
    ST: "CA",
    cityWithStateAbbr: "Olancha, CA",
  },
  {
    zip: "93550",
    ST: "CA",
    cityWithStateAbbr: "Palmdale, CA",
  },
  {
    zip: "93551",
    ST: "CA",
    cityWithStateAbbr: "Palmdale, CA",
  },
  {
    zip: "93552",
    ST: "CA",
    cityWithStateAbbr: "Palmdale, CA",
  },
  {
    zip: "93553",
    ST: "CA",
    cityWithStateAbbr: "Pearblossom, CA",
  },
  {
    zip: "93554",
    ST: "CA",
    cityWithStateAbbr: "Randsburg, CA",
  },
  {
    zip: "93555",
    ST: "CA",
    cityWithStateAbbr: "Ridgecrest, CA",
  },
  {
    zip: "93556",
    ST: "CA",
    cityWithStateAbbr: "Ridgecrest, CA",
  },
  {
    zip: "93558",
    ST: "CA",
    cityWithStateAbbr: "Red Mountain, CA",
  },
  {
    zip: "93560",
    ST: "CA",
    cityWithStateAbbr: "Rosamond, CA",
  },
  {
    zip: "93561",
    ST: "CA",
    cityWithStateAbbr: "Tehachapi, CA",
  },
  {
    zip: "93562",
    ST: "CA",
    cityWithStateAbbr: "Trona, CA",
  },
  {
    zip: "93563",
    ST: "CA",
    cityWithStateAbbr: "Valyermo, CA",
  },
  {
    zip: "93581",
    ST: "CA",
    cityWithStateAbbr: "Tehachapi, CA",
  },
  {
    zip: "93584",
    ST: "CA",
    cityWithStateAbbr: "Lancaster, CA",
  },
  {
    zip: "93586",
    ST: "CA",
    cityWithStateAbbr: "Lancaster, CA",
  },
  {
    zip: "93590",
    ST: "CA",
    cityWithStateAbbr: "Palmdale, CA",
  },
  {
    zip: "93591",
    ST: "CA",
    cityWithStateAbbr: "Palmdale, CA",
  },
  {
    zip: "93592",
    ST: "CA",
    cityWithStateAbbr: "Trona, CA",
  },
  {
    zip: "93596",
    ST: "CA",
    cityWithStateAbbr: "Boron, CA",
  },
  {
    zip: "93599",
    ST: "CA",
    cityWithStateAbbr: "Palmdale, CA",
  },
  {
    zip: "93601",
    ST: "CA",
    cityWithStateAbbr: "Ahwahnee, CA",
  },
  {
    zip: "93602",
    ST: "CA",
    cityWithStateAbbr: "Auberry, CA",
  },
  {
    zip: "93603",
    ST: "CA",
    cityWithStateAbbr: "Badger, CA",
  },
  {
    zip: "93604",
    ST: "CA",
    cityWithStateAbbr: "Bass Lake, CA",
  },
  {
    zip: "93605",
    ST: "CA",
    cityWithStateAbbr: "Big Creek, CA",
  },
  {
    zip: "93606",
    ST: "CA",
    cityWithStateAbbr: "Biola, CA",
  },
  {
    zip: "93607",
    ST: "CA",
    cityWithStateAbbr: "Burrel, CA",
  },
  {
    zip: "93608",
    ST: "CA",
    cityWithStateAbbr: "Cantua Creek, CA",
  },
  {
    zip: "93609",
    ST: "CA",
    cityWithStateAbbr: "Caruthers, CA",
  },
  {
    zip: "93610",
    ST: "CA",
    cityWithStateAbbr: "Chowchilla, CA",
  },
  {
    zip: "93611",
    ST: "CA",
    cityWithStateAbbr: "Clovis, CA",
  },
  {
    zip: "93612",
    ST: "CA",
    cityWithStateAbbr: "Clovis, CA",
  },
  {
    zip: "93613",
    ST: "CA",
    cityWithStateAbbr: "Clovis, CA",
  },
  {
    zip: "93614",
    ST: "CA",
    cityWithStateAbbr: "Coarsegold, CA",
  },
  {
    zip: "93615",
    ST: "CA",
    cityWithStateAbbr: "Cutler, CA",
  },
  {
    zip: "93616",
    ST: "CA",
    cityWithStateAbbr: "Del Rey, CA",
  },
  {
    zip: "93618",
    ST: "CA",
    cityWithStateAbbr: "Dinuba, CA",
  },
  {
    zip: "93619",
    ST: "CA",
    cityWithStateAbbr: "Clovis, CA",
  },
  {
    zip: "93620",
    ST: "CA",
    cityWithStateAbbr: "Dos Palos, CA",
  },
  {
    zip: "93621",
    ST: "CA",
    cityWithStateAbbr: "Dunlap, CA",
  },
  {
    zip: "93622",
    ST: "CA",
    cityWithStateAbbr: "Firebaugh, CA",
  },
  {
    zip: "93623",
    ST: "CA",
    cityWithStateAbbr: "Fish Camp, CA",
  },
  {
    zip: "93624",
    ST: "CA",
    cityWithStateAbbr: "Five Points, CA",
  },
  {
    zip: "93625",
    ST: "CA",
    cityWithStateAbbr: "Fowler, CA",
  },
  {
    zip: "93626",
    ST: "CA",
    cityWithStateAbbr: "Friant, CA",
  },
  {
    zip: "93627",
    ST: "CA",
    cityWithStateAbbr: "Helm, CA",
  },
  {
    zip: "93628",
    ST: "CA",
    cityWithStateAbbr: "Hume, CA",
  },
  {
    zip: "93630",
    ST: "CA",
    cityWithStateAbbr: "Kerman, CA",
  },
  {
    zip: "93631",
    ST: "CA",
    cityWithStateAbbr: "Kingsburg, CA",
  },
  {
    zip: "93633",
    ST: "CA",
    cityWithStateAbbr: "Kings Canyon National Pk, CA",
  },
  {
    zip: "93634",
    ST: "CA",
    cityWithStateAbbr: "Lakeshore, CA",
  },
  {
    zip: "93635",
    ST: "CA",
    cityWithStateAbbr: "Los Banos, CA",
  },
  {
    zip: "93636",
    ST: "CA",
    cityWithStateAbbr: "Madera, CA",
  },
  {
    zip: "93637",
    ST: "CA",
    cityWithStateAbbr: "Madera, CA",
  },
  {
    zip: "93638",
    ST: "CA",
    cityWithStateAbbr: "Madera, CA",
  },
  {
    zip: "93639",
    ST: "CA",
    cityWithStateAbbr: "Madera, CA",
  },
  {
    zip: "93640",
    ST: "CA",
    cityWithStateAbbr: "Mendota, CA",
  },
  {
    zip: "93641",
    ST: "CA",
    cityWithStateAbbr: "Miramonte, CA",
  },
  {
    zip: "93642",
    ST: "CA",
    cityWithStateAbbr: "Mono Hot Springs, CA",
  },
  {
    zip: "93643",
    ST: "CA",
    cityWithStateAbbr: "North Fork, CA",
  },
  {
    zip: "93644",
    ST: "CA",
    cityWithStateAbbr: "Oakhurst, CA",
  },
  {
    zip: "93645",
    ST: "CA",
    cityWithStateAbbr: "O Neals, CA",
  },
  {
    zip: "93646",
    ST: "CA",
    cityWithStateAbbr: "Orange Cove, CA",
  },
  {
    zip: "93647",
    ST: "CA",
    cityWithStateAbbr: "Orosi, CA",
  },
  {
    zip: "93648",
    ST: "CA",
    cityWithStateAbbr: "Parlier, CA",
  },
  {
    zip: "93649",
    ST: "CA",
    cityWithStateAbbr: "Piedra, CA",
  },
  {
    zip: "93650",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93651",
    ST: "CA",
    cityWithStateAbbr: "Prather, CA",
  },
  {
    zip: "93652",
    ST: "CA",
    cityWithStateAbbr: "Raisin City, CA",
  },
  {
    zip: "93653",
    ST: "CA",
    cityWithStateAbbr: "Raymond, CA",
  },
  {
    zip: "93654",
    ST: "CA",
    cityWithStateAbbr: "Reedley, CA",
  },
  {
    zip: "93656",
    ST: "CA",
    cityWithStateAbbr: "Riverdale, CA",
  },
  {
    zip: "93657",
    ST: "CA",
    cityWithStateAbbr: "Sanger, CA",
  },
  {
    zip: "93660",
    ST: "CA",
    cityWithStateAbbr: "San Joaquin, CA",
  },
  {
    zip: "93661",
    ST: "CA",
    cityWithStateAbbr: "Santa Rita Park, CA",
  },
  {
    zip: "93662",
    ST: "CA",
    cityWithStateAbbr: "Selma, CA",
  },
  {
    zip: "93664",
    ST: "CA",
    cityWithStateAbbr: "Shaver Lake, CA",
  },
  {
    zip: "93665",
    ST: "CA",
    cityWithStateAbbr: "South Dos Palos, CA",
  },
  {
    zip: "93666",
    ST: "CA",
    cityWithStateAbbr: "Sultana, CA",
  },
  {
    zip: "93667",
    ST: "CA",
    cityWithStateAbbr: "Tollhouse, CA",
  },
  {
    zip: "93668",
    ST: "CA",
    cityWithStateAbbr: "Tranquillity, CA",
  },
  {
    zip: "93669",
    ST: "CA",
    cityWithStateAbbr: "Wishon, CA",
  },
  {
    zip: "93670",
    ST: "CA",
    cityWithStateAbbr: "Yettem, CA",
  },
  {
    zip: "93673",
    ST: "CA",
    cityWithStateAbbr: "Traver, CA",
  },
  {
    zip: "93675",
    ST: "CA",
    cityWithStateAbbr: "Squaw Valley, CA",
  },
  {
    zip: "93701",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93702",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93703",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93704",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93705",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93706",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93707",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93708",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93709",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93710",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93711",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93712",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93714",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93715",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93716",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93717",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93718",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93720",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93721",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93722",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93723",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93724",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93725",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93726",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93727",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93728",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93729",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93730",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93737",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93740",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93741",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93744",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93745",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93747",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93750",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93755",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93760",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93761",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93764",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93765",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93771",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93772",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93773",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93774",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93775",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93776",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93777",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93778",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93779",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93786",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93790",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93791",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93792",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93793",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93794",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93844",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93888",
    ST: "CA",
    cityWithStateAbbr: "Fresno, CA",
  },
  {
    zip: "93901",
    ST: "CA",
    cityWithStateAbbr: "Salinas, CA",
  },
  {
    zip: "93902",
    ST: "CA",
    cityWithStateAbbr: "Salinas, CA",
  },
  {
    zip: "93905",
    ST: "CA",
    cityWithStateAbbr: "Salinas, CA",
  },
  {
    zip: "93906",
    ST: "CA",
    cityWithStateAbbr: "Salinas, CA",
  },
  {
    zip: "93907",
    ST: "CA",
    cityWithStateAbbr: "Salinas, CA",
  },
  {
    zip: "93908",
    ST: "CA",
    cityWithStateAbbr: "Salinas, CA",
  },
  {
    zip: "93912",
    ST: "CA",
    cityWithStateAbbr: "Salinas, CA",
  },
  {
    zip: "93915",
    ST: "CA",
    cityWithStateAbbr: "Salinas, CA",
  },
  {
    zip: "93920",
    ST: "CA",
    cityWithStateAbbr: "Big Sur, CA",
  },
  {
    zip: "93921",
    ST: "CA",
    cityWithStateAbbr: "Carmel By The Sea, CA",
  },
  {
    zip: "93922",
    ST: "CA",
    cityWithStateAbbr: "Carmel, CA",
  },
  {
    zip: "93923",
    ST: "CA",
    cityWithStateAbbr: "Carmel, CA",
  },
  {
    zip: "93924",
    ST: "CA",
    cityWithStateAbbr: "Carmel Valley, CA",
  },
  {
    zip: "93925",
    ST: "CA",
    cityWithStateAbbr: "Chualar, CA",
  },
  {
    zip: "93926",
    ST: "CA",
    cityWithStateAbbr: "Gonzales, CA",
  },
  {
    zip: "93927",
    ST: "CA",
    cityWithStateAbbr: "Greenfield, CA",
  },
  {
    zip: "93928",
    ST: "CA",
    cityWithStateAbbr: "Jolon, CA",
  },
  {
    zip: "93930",
    ST: "CA",
    cityWithStateAbbr: "King City, CA",
  },
  {
    zip: "93932",
    ST: "CA",
    cityWithStateAbbr: "Lockwood, CA",
  },
  {
    zip: "93933",
    ST: "CA",
    cityWithStateAbbr: "Marina, CA",
  },
  {
    zip: "93940",
    ST: "CA",
    cityWithStateAbbr: "Monterey, CA",
  },
  {
    zip: "93942",
    ST: "CA",
    cityWithStateAbbr: "Monterey, CA",
  },
  {
    zip: "93943",
    ST: "CA",
    cityWithStateAbbr: "Monterey, CA",
  },
  {
    zip: "93944",
    ST: "CA",
    cityWithStateAbbr: "Monterey, CA",
  },
  {
    zip: "93950",
    ST: "CA",
    cityWithStateAbbr: "Pacific Grove, CA",
  },
  {
    zip: "93953",
    ST: "CA",
    cityWithStateAbbr: "Pebble Beach, CA",
  },
  {
    zip: "93954",
    ST: "CA",
    cityWithStateAbbr: "San Lucas, CA",
  },
  {
    zip: "93955",
    ST: "CA",
    cityWithStateAbbr: "Seaside, CA",
  },
  {
    zip: "93960",
    ST: "CA",
    cityWithStateAbbr: "Soledad, CA",
  },
  {
    zip: "93962",
    ST: "CA",
    cityWithStateAbbr: "Spreckels, CA",
  },
  {
    zip: "94002",
    ST: "CA",
    cityWithStateAbbr: "Belmont, CA",
  },
  {
    zip: "94005",
    ST: "CA",
    cityWithStateAbbr: "Brisbane, CA",
  },
  {
    zip: "94010",
    ST: "CA",
    cityWithStateAbbr: "Burlingame, CA",
  },
  {
    zip: "94011",
    ST: "CA",
    cityWithStateAbbr: "Burlingame, CA",
  },
  {
    zip: "94014",
    ST: "CA",
    cityWithStateAbbr: "Daly City, CA",
  },
  {
    zip: "94015",
    ST: "CA",
    cityWithStateAbbr: "Daly City, CA",
  },
  {
    zip: "94016",
    ST: "CA",
    cityWithStateAbbr: "Daly City, CA",
  },
  {
    zip: "94017",
    ST: "CA",
    cityWithStateAbbr: "Daly City, CA",
  },
  {
    zip: "94018",
    ST: "CA",
    cityWithStateAbbr: "El Granada, CA",
  },
  {
    zip: "94019",
    ST: "CA",
    cityWithStateAbbr: "Half Moon Bay, CA",
  },
  {
    zip: "94020",
    ST: "CA",
    cityWithStateAbbr: "La Honda, CA",
  },
  {
    zip: "94021",
    ST: "CA",
    cityWithStateAbbr: "Loma Mar, CA",
  },
  {
    zip: "94022",
    ST: "CA",
    cityWithStateAbbr: "Los Altos, CA",
  },
  {
    zip: "94023",
    ST: "CA",
    cityWithStateAbbr: "Los Altos, CA",
  },
  {
    zip: "94024",
    ST: "CA",
    cityWithStateAbbr: "Los Altos, CA",
  },
  {
    zip: "94025",
    ST: "CA",
    cityWithStateAbbr: "Menlo Park, CA",
  },
  {
    zip: "94026",
    ST: "CA",
    cityWithStateAbbr: "Menlo Park, CA",
  },
  {
    zip: "94027",
    ST: "CA",
    cityWithStateAbbr: "Atherton, CA",
  },
  {
    zip: "94028",
    ST: "CA",
    cityWithStateAbbr: "Portola Valley, CA",
  },
  {
    zip: "94030",
    ST: "CA",
    cityWithStateAbbr: "Millbrae, CA",
  },
  {
    zip: "94035",
    ST: "CA",
    cityWithStateAbbr: "Mountain View, CA",
  },
  {
    zip: "94037",
    ST: "CA",
    cityWithStateAbbr: "Montara, CA",
  },
  {
    zip: "94038",
    ST: "CA",
    cityWithStateAbbr: "Moss Beach, CA",
  },
  {
    zip: "94039",
    ST: "CA",
    cityWithStateAbbr: "Mountain View, CA",
  },
  {
    zip: "94040",
    ST: "CA",
    cityWithStateAbbr: "Mountain View, CA",
  },
  {
    zip: "94041",
    ST: "CA",
    cityWithStateAbbr: "Mountain View, CA",
  },
  {
    zip: "94042",
    ST: "CA",
    cityWithStateAbbr: "Mountain View, CA",
  },
  {
    zip: "94043",
    ST: "CA",
    cityWithStateAbbr: "Mountain View, CA",
  },
  {
    zip: "94044",
    ST: "CA",
    cityWithStateAbbr: "Pacifica, CA",
  },
  {
    zip: "94060",
    ST: "CA",
    cityWithStateAbbr: "Pescadero, CA",
  },
  {
    zip: "94061",
    ST: "CA",
    cityWithStateAbbr: "Redwood City, CA",
  },
  {
    zip: "94062",
    ST: "CA",
    cityWithStateAbbr: "Redwood City, CA",
  },
  {
    zip: "94063",
    ST: "CA",
    cityWithStateAbbr: "Redwood City, CA",
  },
  {
    zip: "94064",
    ST: "CA",
    cityWithStateAbbr: "Redwood City, CA",
  },
  {
    zip: "94065",
    ST: "CA",
    cityWithStateAbbr: "Redwood City, CA",
  },
  {
    zip: "94066",
    ST: "CA",
    cityWithStateAbbr: "San Bruno, CA",
  },
  {
    zip: "94070",
    ST: "CA",
    cityWithStateAbbr: "San Carlos, CA",
  },
  {
    zip: "94074",
    ST: "CA",
    cityWithStateAbbr: "San Gregorio, CA",
  },
  {
    zip: "94080",
    ST: "CA",
    cityWithStateAbbr: "South San Francisco, CA",
  },
  {
    zip: "94083",
    ST: "CA",
    cityWithStateAbbr: "South San Francisco, CA",
  },
  {
    zip: "94085",
    ST: "CA",
    cityWithStateAbbr: "Sunnyvale, CA",
  },
  {
    zip: "94086",
    ST: "CA",
    cityWithStateAbbr: "Sunnyvale, CA",
  },
  {
    zip: "94087",
    ST: "CA",
    cityWithStateAbbr: "Sunnyvale, CA",
  },
  {
    zip: "94088",
    ST: "CA",
    cityWithStateAbbr: "Sunnyvale, CA",
  },
  {
    zip: "94089",
    ST: "CA",
    cityWithStateAbbr: "Sunnyvale, CA",
  },
  {
    zip: "94102",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94103",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94104",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94105",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94107",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94108",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94109",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94110",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94111",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94112",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94114",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94115",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94116",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94117",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94118",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94119",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94120",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94121",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94122",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94123",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94124",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94125",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94126",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94127",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94128",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94129",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94130",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94131",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94132",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94133",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94134",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94137",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94139",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94140",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94141",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94142",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94143",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94144",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94145",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94146",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94147",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94151",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94153",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94156",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94158",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94159",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94160",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94161",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94162",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94163",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94164",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94171",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94172",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94177",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94188",
    ST: "CA",
    cityWithStateAbbr: "San Francisco, CA",
  },
  {
    zip: "94203",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94204",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94205",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94206",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94207",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94208",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94209",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94211",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94229",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94230",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94232",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94234",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94235",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94236",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94237",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94239",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94240",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94244",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94245",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94246",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94247",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94248",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94249",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94250",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94252",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94254",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94256",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94257",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94258",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94259",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94261",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94262",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94263",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94267",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94268",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94269",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94271",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94273",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94274",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94277",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94278",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94279",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94280",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94282",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94283",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94284",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94285",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94286",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94287",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94288",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94289",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94290",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94291",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94293",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94294",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94295",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94296",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94297",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94298",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94299",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "94301",
    ST: "CA",
    cityWithStateAbbr: "Palo Alto, CA",
  },
  {
    zip: "94302",
    ST: "CA",
    cityWithStateAbbr: "Palo Alto, CA",
  },
  {
    zip: "94303",
    ST: "CA",
    cityWithStateAbbr: "Palo Alto, CA",
  },
  {
    zip: "94304",
    ST: "CA",
    cityWithStateAbbr: "Palo Alto, CA",
  },
  {
    zip: "94305",
    ST: "CA",
    cityWithStateAbbr: "Stanford, CA",
  },
  {
    zip: "94306",
    ST: "CA",
    cityWithStateAbbr: "Palo Alto, CA",
  },
  {
    zip: "94309",
    ST: "CA",
    cityWithStateAbbr: "Palo Alto, CA",
  },
  {
    zip: "94401",
    ST: "CA",
    cityWithStateAbbr: "San Mateo, CA",
  },
  {
    zip: "94402",
    ST: "CA",
    cityWithStateAbbr: "San Mateo, CA",
  },
  {
    zip: "94403",
    ST: "CA",
    cityWithStateAbbr: "San Mateo, CA",
  },
  {
    zip: "94404",
    ST: "CA",
    cityWithStateAbbr: "San Mateo, CA",
  },
  {
    zip: "94497",
    ST: "CA",
    cityWithStateAbbr: "San Mateo, CA",
  },
  {
    zip: "94501",
    ST: "CA",
    cityWithStateAbbr: "Alameda, CA",
  },
  {
    zip: "94502",
    ST: "CA",
    cityWithStateAbbr: "Alameda, CA",
  },
  {
    zip: "94503",
    ST: "CA",
    cityWithStateAbbr: "American Canyon, CA",
  },
  {
    zip: "94505",
    ST: "CA",
    cityWithStateAbbr: "Discovery Bay, CA",
  },
  {
    zip: "94506",
    ST: "CA",
    cityWithStateAbbr: "Danville, CA",
  },
  {
    zip: "94507",
    ST: "CA",
    cityWithStateAbbr: "Alamo, CA",
  },
  {
    zip: "94508",
    ST: "CA",
    cityWithStateAbbr: "Angwin, CA",
  },
  {
    zip: "94509",
    ST: "CA",
    cityWithStateAbbr: "Antioch, CA",
  },
  {
    zip: "94510",
    ST: "CA",
    cityWithStateAbbr: "Benicia, CA",
  },
  {
    zip: "94511",
    ST: "CA",
    cityWithStateAbbr: "Bethel Island, CA",
  },
  {
    zip: "94512",
    ST: "CA",
    cityWithStateAbbr: "Birds Landing, CA",
  },
  {
    zip: "94513",
    ST: "CA",
    cityWithStateAbbr: "Brentwood, CA",
  },
  {
    zip: "94514",
    ST: "CA",
    cityWithStateAbbr: "Byron, CA",
  },
  {
    zip: "94515",
    ST: "CA",
    cityWithStateAbbr: "Calistoga, CA",
  },
  {
    zip: "94516",
    ST: "CA",
    cityWithStateAbbr: "Canyon, CA",
  },
  {
    zip: "94517",
    ST: "CA",
    cityWithStateAbbr: "Clayton, CA",
  },
  {
    zip: "94518",
    ST: "CA",
    cityWithStateAbbr: "Concord, CA",
  },
  {
    zip: "94519",
    ST: "CA",
    cityWithStateAbbr: "Concord, CA",
  },
  {
    zip: "94520",
    ST: "CA",
    cityWithStateAbbr: "Concord, CA",
  },
  {
    zip: "94521",
    ST: "CA",
    cityWithStateAbbr: "Concord, CA",
  },
  {
    zip: "94522",
    ST: "CA",
    cityWithStateAbbr: "Concord, CA",
  },
  {
    zip: "94523",
    ST: "CA",
    cityWithStateAbbr: "Pleasant Hill, CA",
  },
  {
    zip: "94524",
    ST: "CA",
    cityWithStateAbbr: "Concord, CA",
  },
  {
    zip: "94525",
    ST: "CA",
    cityWithStateAbbr: "Crockett, CA",
  },
  {
    zip: "94526",
    ST: "CA",
    cityWithStateAbbr: "Danville, CA",
  },
  {
    zip: "94527",
    ST: "CA",
    cityWithStateAbbr: "Concord, CA",
  },
  {
    zip: "94528",
    ST: "CA",
    cityWithStateAbbr: "Diablo, CA",
  },
  {
    zip: "94529",
    ST: "CA",
    cityWithStateAbbr: "Concord, CA",
  },
  {
    zip: "94530",
    ST: "CA",
    cityWithStateAbbr: "El Cerrito, CA",
  },
  {
    zip: "94531",
    ST: "CA",
    cityWithStateAbbr: "Antioch, CA",
  },
  {
    zip: "94533",
    ST: "CA",
    cityWithStateAbbr: "Fairfield, CA",
  },
  {
    zip: "94534",
    ST: "CA",
    cityWithStateAbbr: "Fairfield, CA",
  },
  {
    zip: "94535",
    ST: "CA",
    cityWithStateAbbr: "Travis Afb, CA",
  },
  {
    zip: "94536",
    ST: "CA",
    cityWithStateAbbr: "Fremont, CA",
  },
  {
    zip: "94537",
    ST: "CA",
    cityWithStateAbbr: "Fremont, CA",
  },
  {
    zip: "94538",
    ST: "CA",
    cityWithStateAbbr: "Fremont, CA",
  },
  {
    zip: "94539",
    ST: "CA",
    cityWithStateAbbr: "Fremont, CA",
  },
  {
    zip: "94540",
    ST: "CA",
    cityWithStateAbbr: "Hayward, CA",
  },
  {
    zip: "94541",
    ST: "CA",
    cityWithStateAbbr: "Hayward, CA",
  },
  {
    zip: "94542",
    ST: "CA",
    cityWithStateAbbr: "Hayward, CA",
  },
  {
    zip: "94543",
    ST: "CA",
    cityWithStateAbbr: "Hayward, CA",
  },
  {
    zip: "94544",
    ST: "CA",
    cityWithStateAbbr: "Hayward, CA",
  },
  {
    zip: "94545",
    ST: "CA",
    cityWithStateAbbr: "Hayward, CA",
  },
  {
    zip: "94546",
    ST: "CA",
    cityWithStateAbbr: "Castro Valley, CA",
  },
  {
    zip: "94547",
    ST: "CA",
    cityWithStateAbbr: "Hercules, CA",
  },
  {
    zip: "94548",
    ST: "CA",
    cityWithStateAbbr: "Knightsen, CA",
  },
  {
    zip: "94549",
    ST: "CA",
    cityWithStateAbbr: "Lafayette, CA",
  },
  {
    zip: "94550",
    ST: "CA",
    cityWithStateAbbr: "Livermore, CA",
  },
  {
    zip: "94551",
    ST: "CA",
    cityWithStateAbbr: "Livermore, CA",
  },
  {
    zip: "94552",
    ST: "CA",
    cityWithStateAbbr: "Castro Valley, CA",
  },
  {
    zip: "94553",
    ST: "CA",
    cityWithStateAbbr: "Martinez, CA",
  },
  {
    zip: "94555",
    ST: "CA",
    cityWithStateAbbr: "Fremont, CA",
  },
  {
    zip: "94556",
    ST: "CA",
    cityWithStateAbbr: "Moraga, CA",
  },
  {
    zip: "94557",
    ST: "CA",
    cityWithStateAbbr: "Hayward, CA",
  },
  {
    zip: "94558",
    ST: "CA",
    cityWithStateAbbr: "Napa, CA",
  },
  {
    zip: "94559",
    ST: "CA",
    cityWithStateAbbr: "Napa, CA",
  },
  {
    zip: "94560",
    ST: "CA",
    cityWithStateAbbr: "Newark, CA",
  },
  {
    zip: "94561",
    ST: "CA",
    cityWithStateAbbr: "Oakley, CA",
  },
  {
    zip: "94562",
    ST: "CA",
    cityWithStateAbbr: "Oakville, CA",
  },
  {
    zip: "94563",
    ST: "CA",
    cityWithStateAbbr: "Orinda, CA",
  },
  {
    zip: "94564",
    ST: "CA",
    cityWithStateAbbr: "Pinole, CA",
  },
  {
    zip: "94565",
    ST: "CA",
    cityWithStateAbbr: "Pittsburg, CA",
  },
  {
    zip: "94566",
    ST: "CA",
    cityWithStateAbbr: "Pleasanton, CA",
  },
  {
    zip: "94567",
    ST: "CA",
    cityWithStateAbbr: "Pope Valley, CA",
  },
  {
    zip: "94568",
    ST: "CA",
    cityWithStateAbbr: "Dublin, CA",
  },
  {
    zip: "94569",
    ST: "CA",
    cityWithStateAbbr: "Port Costa, CA",
  },
  {
    zip: "94570",
    ST: "CA",
    cityWithStateAbbr: "Moraga, CA",
  },
  {
    zip: "94571",
    ST: "CA",
    cityWithStateAbbr: "Rio Vista, CA",
  },
  {
    zip: "94572",
    ST: "CA",
    cityWithStateAbbr: "Rodeo, CA",
  },
  {
    zip: "94573",
    ST: "CA",
    cityWithStateAbbr: "Rutherford, CA",
  },
  {
    zip: "94574",
    ST: "CA",
    cityWithStateAbbr: "Saint Helena, CA",
  },
  {
    zip: "94575",
    ST: "CA",
    cityWithStateAbbr: "Moraga, CA",
  },
  {
    zip: "94576",
    ST: "CA",
    cityWithStateAbbr: "Deer Park, CA",
  },
  {
    zip: "94577",
    ST: "CA",
    cityWithStateAbbr: "San Leandro, CA",
  },
  {
    zip: "94578",
    ST: "CA",
    cityWithStateAbbr: "San Leandro, CA",
  },
  {
    zip: "94579",
    ST: "CA",
    cityWithStateAbbr: "San Leandro, CA",
  },
  {
    zip: "94580",
    ST: "CA",
    cityWithStateAbbr: "San Lorenzo, CA",
  },
  {
    zip: "94581",
    ST: "CA",
    cityWithStateAbbr: "Napa, CA",
  },
  {
    zip: "94582",
    ST: "CA",
    cityWithStateAbbr: "San Ramon, CA",
  },
  {
    zip: "94583",
    ST: "CA",
    cityWithStateAbbr: "San Ramon, CA",
  },
  {
    zip: "94585",
    ST: "CA",
    cityWithStateAbbr: "Suisun City, CA",
  },
  {
    zip: "94586",
    ST: "CA",
    cityWithStateAbbr: "Sunol, CA",
  },
  {
    zip: "94587",
    ST: "CA",
    cityWithStateAbbr: "Union City, CA",
  },
  {
    zip: "94588",
    ST: "CA",
    cityWithStateAbbr: "Pleasanton, CA",
  },
  {
    zip: "94589",
    ST: "CA",
    cityWithStateAbbr: "Vallejo, CA",
  },
  {
    zip: "94590",
    ST: "CA",
    cityWithStateAbbr: "Vallejo, CA",
  },
  {
    zip: "94591",
    ST: "CA",
    cityWithStateAbbr: "Vallejo, CA",
  },
  {
    zip: "94592",
    ST: "CA",
    cityWithStateAbbr: "Vallejo, CA",
  },
  {
    zip: "94595",
    ST: "CA",
    cityWithStateAbbr: "Walnut Creek, CA",
  },
  {
    zip: "94596",
    ST: "CA",
    cityWithStateAbbr: "Walnut Creek, CA",
  },
  {
    zip: "94597",
    ST: "CA",
    cityWithStateAbbr: "Walnut Creek, CA",
  },
  {
    zip: "94598",
    ST: "CA",
    cityWithStateAbbr: "Walnut Creek, CA",
  },
  {
    zip: "94599",
    ST: "CA",
    cityWithStateAbbr: "Yountville, CA",
  },
  {
    zip: "94601",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94602",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94603",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94604",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94605",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94606",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94607",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94608",
    ST: "CA",
    cityWithStateAbbr: "Emeryville, CA",
  },
  {
    zip: "94609",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94610",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94611",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94612",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94613",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94614",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94615",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94617",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94618",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94619",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94620",
    ST: "CA",
    cityWithStateAbbr: "Piedmont, CA",
  },
  {
    zip: "94621",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94622",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94623",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94624",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94649",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94659",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94660",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94661",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94662",
    ST: "CA",
    cityWithStateAbbr: "Emeryville, CA",
  },
  {
    zip: "94666",
    ST: "CA",
    cityWithStateAbbr: "Oakland, CA",
  },
  {
    zip: "94701",
    ST: "CA",
    cityWithStateAbbr: "Berkeley, CA",
  },
  {
    zip: "94702",
    ST: "CA",
    cityWithStateAbbr: "Berkeley, CA",
  },
  {
    zip: "94703",
    ST: "CA",
    cityWithStateAbbr: "Berkeley, CA",
  },
  {
    zip: "94704",
    ST: "CA",
    cityWithStateAbbr: "Berkeley, CA",
  },
  {
    zip: "94705",
    ST: "CA",
    cityWithStateAbbr: "Berkeley, CA",
  },
  {
    zip: "94706",
    ST: "CA",
    cityWithStateAbbr: "Albany, CA",
  },
  {
    zip: "94707",
    ST: "CA",
    cityWithStateAbbr: "Berkeley, CA",
  },
  {
    zip: "94708",
    ST: "CA",
    cityWithStateAbbr: "Berkeley, CA",
  },
  {
    zip: "94709",
    ST: "CA",
    cityWithStateAbbr: "Berkeley, CA",
  },
  {
    zip: "94710",
    ST: "CA",
    cityWithStateAbbr: "Berkeley, CA",
  },
  {
    zip: "94712",
    ST: "CA",
    cityWithStateAbbr: "Berkeley, CA",
  },
  {
    zip: "94720",
    ST: "CA",
    cityWithStateAbbr: "Berkeley, CA",
  },
  {
    zip: "94801",
    ST: "CA",
    cityWithStateAbbr: "Richmond, CA",
  },
  {
    zip: "94802",
    ST: "CA",
    cityWithStateAbbr: "Richmond, CA",
  },
  {
    zip: "94803",
    ST: "CA",
    cityWithStateAbbr: "El Sobrante, CA",
  },
  {
    zip: "94804",
    ST: "CA",
    cityWithStateAbbr: "Richmond, CA",
  },
  {
    zip: "94805",
    ST: "CA",
    cityWithStateAbbr: "Richmond, CA",
  },
  {
    zip: "94806",
    ST: "CA",
    cityWithStateAbbr: "San Pablo, CA",
  },
  {
    zip: "94807",
    ST: "CA",
    cityWithStateAbbr: "Richmond, CA",
  },
  {
    zip: "94808",
    ST: "CA",
    cityWithStateAbbr: "Richmond, CA",
  },
  {
    zip: "94820",
    ST: "CA",
    cityWithStateAbbr: "El Sobrante, CA",
  },
  {
    zip: "94850",
    ST: "CA",
    cityWithStateAbbr: "Richmond, CA",
  },
  {
    zip: "94901",
    ST: "CA",
    cityWithStateAbbr: "San Rafael, CA",
  },
  {
    zip: "94903",
    ST: "CA",
    cityWithStateAbbr: "San Rafael, CA",
  },
  {
    zip: "94904",
    ST: "CA",
    cityWithStateAbbr: "Greenbrae, CA",
  },
  {
    zip: "94912",
    ST: "CA",
    cityWithStateAbbr: "San Rafael, CA",
  },
  {
    zip: "94913",
    ST: "CA",
    cityWithStateAbbr: "San Rafael, CA",
  },
  {
    zip: "94914",
    ST: "CA",
    cityWithStateAbbr: "Kentfield, CA",
  },
  {
    zip: "94915",
    ST: "CA",
    cityWithStateAbbr: "San Rafael, CA",
  },
  {
    zip: "94920",
    ST: "CA",
    cityWithStateAbbr: "Belvedere Tiburon, CA",
  },
  {
    zip: "94922",
    ST: "CA",
    cityWithStateAbbr: "Bodega, CA",
  },
  {
    zip: "94923",
    ST: "CA",
    cityWithStateAbbr: "Bodega Bay, CA",
  },
  {
    zip: "94924",
    ST: "CA",
    cityWithStateAbbr: "Bolinas, CA",
  },
  {
    zip: "94925",
    ST: "CA",
    cityWithStateAbbr: "Corte Madera, CA",
  },
  {
    zip: "94926",
    ST: "CA",
    cityWithStateAbbr: "Rohnert Park, CA",
  },
  {
    zip: "94927",
    ST: "CA",
    cityWithStateAbbr: "Rohnert Park, CA",
  },
  {
    zip: "94928",
    ST: "CA",
    cityWithStateAbbr: "Rohnert Park, CA",
  },
  {
    zip: "94929",
    ST: "CA",
    cityWithStateAbbr: "Dillon Beach, CA",
  },
  {
    zip: "94930",
    ST: "CA",
    cityWithStateAbbr: "Fairfax, CA",
  },
  {
    zip: "94931",
    ST: "CA",
    cityWithStateAbbr: "Cotati, CA",
  },
  {
    zip: "94933",
    ST: "CA",
    cityWithStateAbbr: "Forest Knolls, CA",
  },
  {
    zip: "94937",
    ST: "CA",
    cityWithStateAbbr: "Inverness, CA",
  },
  {
    zip: "94938",
    ST: "CA",
    cityWithStateAbbr: "Lagunitas, CA",
  },
  {
    zip: "94939",
    ST: "CA",
    cityWithStateAbbr: "Larkspur, CA",
  },
  {
    zip: "94940",
    ST: "CA",
    cityWithStateAbbr: "Marshall, CA",
  },
  {
    zip: "94941",
    ST: "CA",
    cityWithStateAbbr: "Mill Valley, CA",
  },
  {
    zip: "94942",
    ST: "CA",
    cityWithStateAbbr: "Mill Valley, CA",
  },
  {
    zip: "94945",
    ST: "CA",
    cityWithStateAbbr: "Novato, CA",
  },
  {
    zip: "94946",
    ST: "CA",
    cityWithStateAbbr: "Nicasio, CA",
  },
  {
    zip: "94947",
    ST: "CA",
    cityWithStateAbbr: "Novato, CA",
  },
  {
    zip: "94948",
    ST: "CA",
    cityWithStateAbbr: "Novato, CA",
  },
  {
    zip: "94949",
    ST: "CA",
    cityWithStateAbbr: "Novato, CA",
  },
  {
    zip: "94950",
    ST: "CA",
    cityWithStateAbbr: "Olema, CA",
  },
  {
    zip: "94951",
    ST: "CA",
    cityWithStateAbbr: "Penngrove, CA",
  },
  {
    zip: "94952",
    ST: "CA",
    cityWithStateAbbr: "Petaluma, CA",
  },
  {
    zip: "94953",
    ST: "CA",
    cityWithStateAbbr: "Petaluma, CA",
  },
  {
    zip: "94954",
    ST: "CA",
    cityWithStateAbbr: "Petaluma, CA",
  },
  {
    zip: "94955",
    ST: "CA",
    cityWithStateAbbr: "Petaluma, CA",
  },
  {
    zip: "94956",
    ST: "CA",
    cityWithStateAbbr: "Point Reyes Station, CA",
  },
  {
    zip: "94957",
    ST: "CA",
    cityWithStateAbbr: "Ross, CA",
  },
  {
    zip: "94960",
    ST: "CA",
    cityWithStateAbbr: "San Anselmo, CA",
  },
  {
    zip: "94963",
    ST: "CA",
    cityWithStateAbbr: "San Geronimo, CA",
  },
  {
    zip: "94964",
    ST: "CA",
    cityWithStateAbbr: "San Quentin, CA",
  },
  {
    zip: "94965",
    ST: "CA",
    cityWithStateAbbr: "Sausalito, CA",
  },
  {
    zip: "94966",
    ST: "CA",
    cityWithStateAbbr: "Sausalito, CA",
  },
  {
    zip: "94970",
    ST: "CA",
    cityWithStateAbbr: "Stinson Beach, CA",
  },
  {
    zip: "94971",
    ST: "CA",
    cityWithStateAbbr: "Tomales, CA",
  },
  {
    zip: "94972",
    ST: "CA",
    cityWithStateAbbr: "Valley Ford, CA",
  },
  {
    zip: "94973",
    ST: "CA",
    cityWithStateAbbr: "Woodacre, CA",
  },
  {
    zip: "94974",
    ST: "CA",
    cityWithStateAbbr: "San Quentin, CA",
  },
  {
    zip: "94975",
    ST: "CA",
    cityWithStateAbbr: "Petaluma, CA",
  },
  {
    zip: "94976",
    ST: "CA",
    cityWithStateAbbr: "Corte Madera, CA",
  },
  {
    zip: "94977",
    ST: "CA",
    cityWithStateAbbr: "Larkspur, CA",
  },
  {
    zip: "94978",
    ST: "CA",
    cityWithStateAbbr: "Fairfax, CA",
  },
  {
    zip: "94979",
    ST: "CA",
    cityWithStateAbbr: "San Anselmo, CA",
  },
  {
    zip: "94998",
    ST: "CA",
    cityWithStateAbbr: "Novato, CA",
  },
  {
    zip: "94999",
    ST: "CA",
    cityWithStateAbbr: "Petaluma, CA",
  },
  {
    zip: "95001",
    ST: "CA",
    cityWithStateAbbr: "Aptos, CA",
  },
  {
    zip: "95002",
    ST: "CA",
    cityWithStateAbbr: "Alviso, CA",
  },
  {
    zip: "95003",
    ST: "CA",
    cityWithStateAbbr: "Aptos, CA",
  },
  {
    zip: "95004",
    ST: "CA",
    cityWithStateAbbr: "Aromas, CA",
  },
  {
    zip: "95005",
    ST: "CA",
    cityWithStateAbbr: "Ben Lomond, CA",
  },
  {
    zip: "95006",
    ST: "CA",
    cityWithStateAbbr: "Boulder Creek, CA",
  },
  {
    zip: "95007",
    ST: "CA",
    cityWithStateAbbr: "Brookdale, CA",
  },
  {
    zip: "95008",
    ST: "CA",
    cityWithStateAbbr: "Campbell, CA",
  },
  {
    zip: "95009",
    ST: "CA",
    cityWithStateAbbr: "Campbell, CA",
  },
  {
    zip: "95010",
    ST: "CA",
    cityWithStateAbbr: "Capitola, CA",
  },
  {
    zip: "95011",
    ST: "CA",
    cityWithStateAbbr: "Campbell, CA",
  },
  {
    zip: "95012",
    ST: "CA",
    cityWithStateAbbr: "Castroville, CA",
  },
  {
    zip: "95013",
    ST: "CA",
    cityWithStateAbbr: "Coyote, CA",
  },
  {
    zip: "95014",
    ST: "CA",
    cityWithStateAbbr: "Cupertino, CA",
  },
  {
    zip: "95015",
    ST: "CA",
    cityWithStateAbbr: "Cupertino, CA",
  },
  {
    zip: "95017",
    ST: "CA",
    cityWithStateAbbr: "Davenport, CA",
  },
  {
    zip: "95018",
    ST: "CA",
    cityWithStateAbbr: "Felton, CA",
  },
  {
    zip: "95019",
    ST: "CA",
    cityWithStateAbbr: "Freedom, CA",
  },
  {
    zip: "95020",
    ST: "CA",
    cityWithStateAbbr: "Gilroy, CA",
  },
  {
    zip: "95021",
    ST: "CA",
    cityWithStateAbbr: "Gilroy, CA",
  },
  {
    zip: "95023",
    ST: "CA",
    cityWithStateAbbr: "Hollister, CA",
  },
  {
    zip: "95024",
    ST: "CA",
    cityWithStateAbbr: "Hollister, CA",
  },
  {
    zip: "95026",
    ST: "CA",
    cityWithStateAbbr: "Holy City, CA",
  },
  {
    zip: "95030",
    ST: "CA",
    cityWithStateAbbr: "Los Gatos, CA",
  },
  {
    zip: "95031",
    ST: "CA",
    cityWithStateAbbr: "Los Gatos, CA",
  },
  {
    zip: "95032",
    ST: "CA",
    cityWithStateAbbr: "Los Gatos, CA",
  },
  {
    zip: "95033",
    ST: "CA",
    cityWithStateAbbr: "Los Gatos, CA",
  },
  {
    zip: "95035",
    ST: "CA",
    cityWithStateAbbr: "Milpitas, CA",
  },
  {
    zip: "95036",
    ST: "CA",
    cityWithStateAbbr: "Milpitas, CA",
  },
  {
    zip: "95037",
    ST: "CA",
    cityWithStateAbbr: "Morgan Hill, CA",
  },
  {
    zip: "95038",
    ST: "CA",
    cityWithStateAbbr: "Morgan Hill, CA",
  },
  {
    zip: "95039",
    ST: "CA",
    cityWithStateAbbr: "Moss Landing, CA",
  },
  {
    zip: "95041",
    ST: "CA",
    cityWithStateAbbr: "Mount Hermon, CA",
  },
  {
    zip: "95042",
    ST: "CA",
    cityWithStateAbbr: "New Almaden, CA",
  },
  {
    zip: "95043",
    ST: "CA",
    cityWithStateAbbr: "Paicines, CA",
  },
  {
    zip: "95044",
    ST: "CA",
    cityWithStateAbbr: "Redwood Estates, CA",
  },
  {
    zip: "95045",
    ST: "CA",
    cityWithStateAbbr: "San Juan Bautista, CA",
  },
  {
    zip: "95046",
    ST: "CA",
    cityWithStateAbbr: "San Martin, CA",
  },
  {
    zip: "95050",
    ST: "CA",
    cityWithStateAbbr: "Santa Clara, CA",
  },
  {
    zip: "95051",
    ST: "CA",
    cityWithStateAbbr: "Santa Clara, CA",
  },
  {
    zip: "95052",
    ST: "CA",
    cityWithStateAbbr: "Santa Clara, CA",
  },
  {
    zip: "95053",
    ST: "CA",
    cityWithStateAbbr: "Santa Clara, CA",
  },
  {
    zip: "95054",
    ST: "CA",
    cityWithStateAbbr: "Santa Clara, CA",
  },
  {
    zip: "95055",
    ST: "CA",
    cityWithStateAbbr: "Santa Clara, CA",
  },
  {
    zip: "95056",
    ST: "CA",
    cityWithStateAbbr: "Santa Clara, CA",
  },
  {
    zip: "95060",
    ST: "CA",
    cityWithStateAbbr: "Santa Cruz, CA",
  },
  {
    zip: "95061",
    ST: "CA",
    cityWithStateAbbr: "Santa Cruz, CA",
  },
  {
    zip: "95062",
    ST: "CA",
    cityWithStateAbbr: "Santa Cruz, CA",
  },
  {
    zip: "95063",
    ST: "CA",
    cityWithStateAbbr: "Santa Cruz, CA",
  },
  {
    zip: "95064",
    ST: "CA",
    cityWithStateAbbr: "Santa Cruz, CA",
  },
  {
    zip: "95065",
    ST: "CA",
    cityWithStateAbbr: "Santa Cruz, CA",
  },
  {
    zip: "95066",
    ST: "CA",
    cityWithStateAbbr: "Scotts Valley, CA",
  },
  {
    zip: "95067",
    ST: "CA",
    cityWithStateAbbr: "Scotts Valley, CA",
  },
  {
    zip: "95070",
    ST: "CA",
    cityWithStateAbbr: "Saratoga, CA",
  },
  {
    zip: "95071",
    ST: "CA",
    cityWithStateAbbr: "Saratoga, CA",
  },
  {
    zip: "95073",
    ST: "CA",
    cityWithStateAbbr: "Soquel, CA",
  },
  {
    zip: "95075",
    ST: "CA",
    cityWithStateAbbr: "Tres Pinos, CA",
  },
  {
    zip: "95076",
    ST: "CA",
    cityWithStateAbbr: "Watsonville, CA",
  },
  {
    zip: "95077",
    ST: "CA",
    cityWithStateAbbr: "Watsonville, CA",
  },
  {
    zip: "95101",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95103",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95106",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95108",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95109",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95110",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95111",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95112",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95113",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95115",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95116",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95117",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95118",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95119",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95120",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95121",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95122",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95123",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95124",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95125",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95126",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95127",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95128",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95129",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95130",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95131",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95132",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95133",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95134",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95135",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95136",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95138",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95139",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95140",
    ST: "CA",
    cityWithStateAbbr: "Mount Hamilton, CA",
  },
  {
    zip: "95141",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95148",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95150",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95151",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95152",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95153",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95154",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95155",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95156",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95157",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95158",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95159",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95160",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95161",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95164",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95170",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95172",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95173",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95190",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95191",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95192",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95193",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95194",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95196",
    ST: "CA",
    cityWithStateAbbr: "San Jose, CA",
  },
  {
    zip: "95201",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95202",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95203",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95204",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95205",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95206",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95207",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95208",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95209",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95210",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95211",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95212",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95213",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95215",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95219",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95220",
    ST: "CA",
    cityWithStateAbbr: "Acampo, CA",
  },
  {
    zip: "95221",
    ST: "CA",
    cityWithStateAbbr: "Altaville, CA",
  },
  {
    zip: "95222",
    ST: "CA",
    cityWithStateAbbr: "Angels Camp, CA",
  },
  {
    zip: "95223",
    ST: "CA",
    cityWithStateAbbr: "Arnold, CA",
  },
  {
    zip: "95224",
    ST: "CA",
    cityWithStateAbbr: "Avery, CA",
  },
  {
    zip: "95225",
    ST: "CA",
    cityWithStateAbbr: "Burson, CA",
  },
  {
    zip: "95226",
    ST: "CA",
    cityWithStateAbbr: "Campo Seco, CA",
  },
  {
    zip: "95227",
    ST: "CA",
    cityWithStateAbbr: "Clements, CA",
  },
  {
    zip: "95228",
    ST: "CA",
    cityWithStateAbbr: "Copperopolis, CA",
  },
  {
    zip: "95229",
    ST: "CA",
    cityWithStateAbbr: "Douglas Flat, CA",
  },
  {
    zip: "95230",
    ST: "CA",
    cityWithStateAbbr: "Farmington, CA",
  },
  {
    zip: "95231",
    ST: "CA",
    cityWithStateAbbr: "French Camp, CA",
  },
  {
    zip: "95232",
    ST: "CA",
    cityWithStateAbbr: "Glencoe, CA",
  },
  {
    zip: "95233",
    ST: "CA",
    cityWithStateAbbr: "Hathaway Pines, CA",
  },
  {
    zip: "95234",
    ST: "CA",
    cityWithStateAbbr: "Holt, CA",
  },
  {
    zip: "95236",
    ST: "CA",
    cityWithStateAbbr: "Linden, CA",
  },
  {
    zip: "95237",
    ST: "CA",
    cityWithStateAbbr: "Lockeford, CA",
  },
  {
    zip: "95240",
    ST: "CA",
    cityWithStateAbbr: "Lodi, CA",
  },
  {
    zip: "95241",
    ST: "CA",
    cityWithStateAbbr: "Lodi, CA",
  },
  {
    zip: "95242",
    ST: "CA",
    cityWithStateAbbr: "Lodi, CA",
  },
  {
    zip: "95245",
    ST: "CA",
    cityWithStateAbbr: "Mokelumne Hill, CA",
  },
  {
    zip: "95246",
    ST: "CA",
    cityWithStateAbbr: "Mountain Ranch, CA",
  },
  {
    zip: "95247",
    ST: "CA",
    cityWithStateAbbr: "Murphys, CA",
  },
  {
    zip: "95248",
    ST: "CA",
    cityWithStateAbbr: "Rail Road Flat, CA",
  },
  {
    zip: "95249",
    ST: "CA",
    cityWithStateAbbr: "San Andreas, CA",
  },
  {
    zip: "95250",
    ST: "CA",
    cityWithStateAbbr: "San Andreas, CA",
  },
  {
    zip: "95251",
    ST: "CA",
    cityWithStateAbbr: "Vallecito, CA",
  },
  {
    zip: "95252",
    ST: "CA",
    cityWithStateAbbr: "Valley Springs, CA",
  },
  {
    zip: "95253",
    ST: "CA",
    cityWithStateAbbr: "Victor, CA",
  },
  {
    zip: "95254",
    ST: "CA",
    cityWithStateAbbr: "Wallace, CA",
  },
  {
    zip: "95255",
    ST: "CA",
    cityWithStateAbbr: "West Point, CA",
  },
  {
    zip: "95257",
    ST: "CA",
    cityWithStateAbbr: "Wilseyville, CA",
  },
  {
    zip: "95258",
    ST: "CA",
    cityWithStateAbbr: "Woodbridge, CA",
  },
  {
    zip: "95267",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95269",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95296",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95297",
    ST: "CA",
    cityWithStateAbbr: "Stockton, CA",
  },
  {
    zip: "95301",
    ST: "CA",
    cityWithStateAbbr: "Atwater, CA",
  },
  {
    zip: "95303",
    ST: "CA",
    cityWithStateAbbr: "Ballico, CA",
  },
  {
    zip: "95304",
    ST: "CA",
    cityWithStateAbbr: "Tracy, CA",
  },
  {
    zip: "95305",
    ST: "CA",
    cityWithStateAbbr: "Big Oak Flat, CA",
  },
  {
    zip: "95306",
    ST: "CA",
    cityWithStateAbbr: "Catheys Valley, CA",
  },
  {
    zip: "95307",
    ST: "CA",
    cityWithStateAbbr: "Ceres, CA",
  },
  {
    zip: "95309",
    ST: "CA",
    cityWithStateAbbr: "Chinese Camp, CA",
  },
  {
    zip: "95310",
    ST: "CA",
    cityWithStateAbbr: "Columbia, CA",
  },
  {
    zip: "95311",
    ST: "CA",
    cityWithStateAbbr: "Coulterville, CA",
  },
  {
    zip: "95312",
    ST: "CA",
    cityWithStateAbbr: "Cressey, CA",
  },
  {
    zip: "95313",
    ST: "CA",
    cityWithStateAbbr: "Crows Landing, CA",
  },
  {
    zip: "95314",
    ST: "CA",
    cityWithStateAbbr: "Pinecrest, CA",
  },
  {
    zip: "95315",
    ST: "CA",
    cityWithStateAbbr: "Delhi, CA",
  },
  {
    zip: "95316",
    ST: "CA",
    cityWithStateAbbr: "Denair, CA",
  },
  {
    zip: "95317",
    ST: "CA",
    cityWithStateAbbr: "El Nido, CA",
  },
  {
    zip: "95318",
    ST: "CA",
    cityWithStateAbbr: "El Portal, CA",
  },
  {
    zip: "95319",
    ST: "CA",
    cityWithStateAbbr: "Empire, CA",
  },
  {
    zip: "95320",
    ST: "CA",
    cityWithStateAbbr: "Escalon, CA",
  },
  {
    zip: "95321",
    ST: "CA",
    cityWithStateAbbr: "Groveland, CA",
  },
  {
    zip: "95322",
    ST: "CA",
    cityWithStateAbbr: "Gustine, CA",
  },
  {
    zip: "95323",
    ST: "CA",
    cityWithStateAbbr: "Hickman, CA",
  },
  {
    zip: "95324",
    ST: "CA",
    cityWithStateAbbr: "Hilmar, CA",
  },
  {
    zip: "95325",
    ST: "CA",
    cityWithStateAbbr: "Hornitos, CA",
  },
  {
    zip: "95326",
    ST: "CA",
    cityWithStateAbbr: "Hughson, CA",
  },
  {
    zip: "95327",
    ST: "CA",
    cityWithStateAbbr: "Jamestown, CA",
  },
  {
    zip: "95328",
    ST: "CA",
    cityWithStateAbbr: "Keyes, CA",
  },
  {
    zip: "95329",
    ST: "CA",
    cityWithStateAbbr: "La Grange, CA",
  },
  {
    zip: "95330",
    ST: "CA",
    cityWithStateAbbr: "Lathrop, CA",
  },
  {
    zip: "95333",
    ST: "CA",
    cityWithStateAbbr: "Le Grand, CA",
  },
  {
    zip: "95334",
    ST: "CA",
    cityWithStateAbbr: "Livingston, CA",
  },
  {
    zip: "95335",
    ST: "CA",
    cityWithStateAbbr: "Long Barn, CA",
  },
  {
    zip: "95336",
    ST: "CA",
    cityWithStateAbbr: "Manteca, CA",
  },
  {
    zip: "95337",
    ST: "CA",
    cityWithStateAbbr: "Manteca, CA",
  },
  {
    zip: "95338",
    ST: "CA",
    cityWithStateAbbr: "Mariposa, CA",
  },
  {
    zip: "95340",
    ST: "CA",
    cityWithStateAbbr: "Merced, CA",
  },
  {
    zip: "95341",
    ST: "CA",
    cityWithStateAbbr: "Merced, CA",
  },
  {
    zip: "95343",
    ST: "CA",
    cityWithStateAbbr: "Merced, CA",
  },
  {
    zip: "95344",
    ST: "CA",
    cityWithStateAbbr: "Merced, CA",
  },
  {
    zip: "95345",
    ST: "CA",
    cityWithStateAbbr: "Midpines, CA",
  },
  {
    zip: "95346",
    ST: "CA",
    cityWithStateAbbr: "Mi Wuk Village, CA",
  },
  {
    zip: "95347",
    ST: "CA",
    cityWithStateAbbr: "Moccasin, CA",
  },
  {
    zip: "95348",
    ST: "CA",
    cityWithStateAbbr: "Merced, CA",
  },
  {
    zip: "95350",
    ST: "CA",
    cityWithStateAbbr: "Modesto, CA",
  },
  {
    zip: "95351",
    ST: "CA",
    cityWithStateAbbr: "Modesto, CA",
  },
  {
    zip: "95352",
    ST: "CA",
    cityWithStateAbbr: "Modesto, CA",
  },
  {
    zip: "95353",
    ST: "CA",
    cityWithStateAbbr: "Modesto, CA",
  },
  {
    zip: "95354",
    ST: "CA",
    cityWithStateAbbr: "Modesto, CA",
  },
  {
    zip: "95355",
    ST: "CA",
    cityWithStateAbbr: "Modesto, CA",
  },
  {
    zip: "95356",
    ST: "CA",
    cityWithStateAbbr: "Modesto, CA",
  },
  {
    zip: "95357",
    ST: "CA",
    cityWithStateAbbr: "Modesto, CA",
  },
  {
    zip: "95358",
    ST: "CA",
    cityWithStateAbbr: "Modesto, CA",
  },
  {
    zip: "95360",
    ST: "CA",
    cityWithStateAbbr: "Newman, CA",
  },
  {
    zip: "95361",
    ST: "CA",
    cityWithStateAbbr: "Oakdale, CA",
  },
  {
    zip: "95363",
    ST: "CA",
    cityWithStateAbbr: "Patterson, CA",
  },
  {
    zip: "95364",
    ST: "CA",
    cityWithStateAbbr: "Pinecrest, CA",
  },
  {
    zip: "95365",
    ST: "CA",
    cityWithStateAbbr: "Planada, CA",
  },
  {
    zip: "95366",
    ST: "CA",
    cityWithStateAbbr: "Ripon, CA",
  },
  {
    zip: "95367",
    ST: "CA",
    cityWithStateAbbr: "Riverbank, CA",
  },
  {
    zip: "95368",
    ST: "CA",
    cityWithStateAbbr: "Salida, CA",
  },
  {
    zip: "95369",
    ST: "CA",
    cityWithStateAbbr: "Snelling, CA",
  },
  {
    zip: "95370",
    ST: "CA",
    cityWithStateAbbr: "Sonora, CA",
  },
  {
    zip: "95372",
    ST: "CA",
    cityWithStateAbbr: "Soulsbyville, CA",
  },
  {
    zip: "95373",
    ST: "CA",
    cityWithStateAbbr: "Standard, CA",
  },
  {
    zip: "95374",
    ST: "CA",
    cityWithStateAbbr: "Stevinson, CA",
  },
  {
    zip: "95375",
    ST: "CA",
    cityWithStateAbbr: "Strawberry, CA",
  },
  {
    zip: "95376",
    ST: "CA",
    cityWithStateAbbr: "Tracy, CA",
  },
  {
    zip: "95377",
    ST: "CA",
    cityWithStateAbbr: "Tracy, CA",
  },
  {
    zip: "95378",
    ST: "CA",
    cityWithStateAbbr: "Tracy, CA",
  },
  {
    zip: "95379",
    ST: "CA",
    cityWithStateAbbr: "Tuolumne, CA",
  },
  {
    zip: "95380",
    ST: "CA",
    cityWithStateAbbr: "Turlock, CA",
  },
  {
    zip: "95381",
    ST: "CA",
    cityWithStateAbbr: "Turlock, CA",
  },
  {
    zip: "95382",
    ST: "CA",
    cityWithStateAbbr: "Turlock, CA",
  },
  {
    zip: "95383",
    ST: "CA",
    cityWithStateAbbr: "Twain Harte, CA",
  },
  {
    zip: "95385",
    ST: "CA",
    cityWithStateAbbr: "Vernalis, CA",
  },
  {
    zip: "95386",
    ST: "CA",
    cityWithStateAbbr: "Waterford, CA",
  },
  {
    zip: "95387",
    ST: "CA",
    cityWithStateAbbr: "Westley, CA",
  },
  {
    zip: "95388",
    ST: "CA",
    cityWithStateAbbr: "Winton, CA",
  },
  {
    zip: "95389",
    ST: "CA",
    cityWithStateAbbr: "Yosemite National Park, CA",
  },
  {
    zip: "95391",
    ST: "CA",
    cityWithStateAbbr: "Tracy, CA",
  },
  {
    zip: "95397",
    ST: "CA",
    cityWithStateAbbr: "Modesto, CA",
  },
  {
    zip: "95401",
    ST: "CA",
    cityWithStateAbbr: "Santa Rosa, CA",
  },
  {
    zip: "95402",
    ST: "CA",
    cityWithStateAbbr: "Santa Rosa, CA",
  },
  {
    zip: "95403",
    ST: "CA",
    cityWithStateAbbr: "Santa Rosa, CA",
  },
  {
    zip: "95404",
    ST: "CA",
    cityWithStateAbbr: "Santa Rosa, CA",
  },
  {
    zip: "95405",
    ST: "CA",
    cityWithStateAbbr: "Santa Rosa, CA",
  },
  {
    zip: "95406",
    ST: "CA",
    cityWithStateAbbr: "Santa Rosa, CA",
  },
  {
    zip: "95407",
    ST: "CA",
    cityWithStateAbbr: "Santa Rosa, CA",
  },
  {
    zip: "95409",
    ST: "CA",
    cityWithStateAbbr: "Santa Rosa, CA",
  },
  {
    zip: "95410",
    ST: "CA",
    cityWithStateAbbr: "Albion, CA",
  },
  {
    zip: "95412",
    ST: "CA",
    cityWithStateAbbr: "Annapolis, CA",
  },
  {
    zip: "95415",
    ST: "CA",
    cityWithStateAbbr: "Boonville, CA",
  },
  {
    zip: "95416",
    ST: "CA",
    cityWithStateAbbr: "Boyes Hot Springs, CA",
  },
  {
    zip: "95417",
    ST: "CA",
    cityWithStateAbbr: "Branscomb, CA",
  },
  {
    zip: "95418",
    ST: "CA",
    cityWithStateAbbr: "Calpella, CA",
  },
  {
    zip: "95419",
    ST: "CA",
    cityWithStateAbbr: "Camp Meeker, CA",
  },
  {
    zip: "95420",
    ST: "CA",
    cityWithStateAbbr: "Caspar, CA",
  },
  {
    zip: "95421",
    ST: "CA",
    cityWithStateAbbr: "Cazadero, CA",
  },
  {
    zip: "95422",
    ST: "CA",
    cityWithStateAbbr: "Clearlake, CA",
  },
  {
    zip: "95423",
    ST: "CA",
    cityWithStateAbbr: "Clearlake Oaks, CA",
  },
  {
    zip: "95424",
    ST: "CA",
    cityWithStateAbbr: "Clearlake Park, CA",
  },
  {
    zip: "95425",
    ST: "CA",
    cityWithStateAbbr: "Cloverdale, CA",
  },
  {
    zip: "95426",
    ST: "CA",
    cityWithStateAbbr: "Cobb, CA",
  },
  {
    zip: "95427",
    ST: "CA",
    cityWithStateAbbr: "Comptche, CA",
  },
  {
    zip: "95428",
    ST: "CA",
    cityWithStateAbbr: "Covelo, CA",
  },
  {
    zip: "95429",
    ST: "CA",
    cityWithStateAbbr: "Dos Rios, CA",
  },
  {
    zip: "95430",
    ST: "CA",
    cityWithStateAbbr: "Duncans Mills, CA",
  },
  {
    zip: "95431",
    ST: "CA",
    cityWithStateAbbr: "Eldridge, CA",
  },
  {
    zip: "95432",
    ST: "CA",
    cityWithStateAbbr: "Elk, CA",
  },
  {
    zip: "95433",
    ST: "CA",
    cityWithStateAbbr: "El Verano, CA",
  },
  {
    zip: "95435",
    ST: "CA",
    cityWithStateAbbr: "Finley, CA",
  },
  {
    zip: "95436",
    ST: "CA",
    cityWithStateAbbr: "Forestville, CA",
  },
  {
    zip: "95437",
    ST: "CA",
    cityWithStateAbbr: "Fort Bragg, CA",
  },
  {
    zip: "95439",
    ST: "CA",
    cityWithStateAbbr: "Fulton, CA",
  },
  {
    zip: "95441",
    ST: "CA",
    cityWithStateAbbr: "Geyserville, CA",
  },
  {
    zip: "95442",
    ST: "CA",
    cityWithStateAbbr: "Glen Ellen, CA",
  },
  {
    zip: "95443",
    ST: "CA",
    cityWithStateAbbr: "Glenhaven, CA",
  },
  {
    zip: "95444",
    ST: "CA",
    cityWithStateAbbr: "Graton, CA",
  },
  {
    zip: "95445",
    ST: "CA",
    cityWithStateAbbr: "Gualala, CA",
  },
  {
    zip: "95446",
    ST: "CA",
    cityWithStateAbbr: "Guerneville, CA",
  },
  {
    zip: "95448",
    ST: "CA",
    cityWithStateAbbr: "Healdsburg, CA",
  },
  {
    zip: "95449",
    ST: "CA",
    cityWithStateAbbr: "Hopland, CA",
  },
  {
    zip: "95450",
    ST: "CA",
    cityWithStateAbbr: "Jenner, CA",
  },
  {
    zip: "95451",
    ST: "CA",
    cityWithStateAbbr: "Kelseyville, CA",
  },
  {
    zip: "95452",
    ST: "CA",
    cityWithStateAbbr: "Kenwood, CA",
  },
  {
    zip: "95453",
    ST: "CA",
    cityWithStateAbbr: "Lakeport, CA",
  },
  {
    zip: "95454",
    ST: "CA",
    cityWithStateAbbr: "Laytonville, CA",
  },
  {
    zip: "95456",
    ST: "CA",
    cityWithStateAbbr: "Little River, CA",
  },
  {
    zip: "95457",
    ST: "CA",
    cityWithStateAbbr: "Lower Lake, CA",
  },
  {
    zip: "95458",
    ST: "CA",
    cityWithStateAbbr: "Lucerne, CA",
  },
  {
    zip: "95459",
    ST: "CA",
    cityWithStateAbbr: "Manchester, CA",
  },
  {
    zip: "95460",
    ST: "CA",
    cityWithStateAbbr: "Mendocino, CA",
  },
  {
    zip: "95461",
    ST: "CA",
    cityWithStateAbbr: "Middletown, CA",
  },
  {
    zip: "95462",
    ST: "CA",
    cityWithStateAbbr: "Monte Rio, CA",
  },
  {
    zip: "95463",
    ST: "CA",
    cityWithStateAbbr: "Navarro, CA",
  },
  {
    zip: "95464",
    ST: "CA",
    cityWithStateAbbr: "Nice, CA",
  },
  {
    zip: "95465",
    ST: "CA",
    cityWithStateAbbr: "Occidental, CA",
  },
  {
    zip: "95466",
    ST: "CA",
    cityWithStateAbbr: "Philo, CA",
  },
  {
    zip: "95467",
    ST: "CA",
    cityWithStateAbbr: "Hidden Valley Lake, CA",
  },
  {
    zip: "95468",
    ST: "CA",
    cityWithStateAbbr: "Point Arena, CA",
  },
  {
    zip: "95469",
    ST: "CA",
    cityWithStateAbbr: "Potter Valley, CA",
  },
  {
    zip: "95470",
    ST: "CA",
    cityWithStateAbbr: "Redwood Valley, CA",
  },
  {
    zip: "95471",
    ST: "CA",
    cityWithStateAbbr: "Rio Nido, CA",
  },
  {
    zip: "95472",
    ST: "CA",
    cityWithStateAbbr: "Sebastopol, CA",
  },
  {
    zip: "95473",
    ST: "CA",
    cityWithStateAbbr: "Sebastopol, CA",
  },
  {
    zip: "95476",
    ST: "CA",
    cityWithStateAbbr: "Sonoma, CA",
  },
  {
    zip: "95480",
    ST: "CA",
    cityWithStateAbbr: "Stewarts Point, CA",
  },
  {
    zip: "95481",
    ST: "CA",
    cityWithStateAbbr: "Talmage, CA",
  },
  {
    zip: "95482",
    ST: "CA",
    cityWithStateAbbr: "Ukiah, CA",
  },
  {
    zip: "95485",
    ST: "CA",
    cityWithStateAbbr: "Upper Lake, CA",
  },
  {
    zip: "95486",
    ST: "CA",
    cityWithStateAbbr: "Villa Grande, CA",
  },
  {
    zip: "95487",
    ST: "CA",
    cityWithStateAbbr: "Vineburg, CA",
  },
  {
    zip: "95488",
    ST: "CA",
    cityWithStateAbbr: "Westport, CA",
  },
  {
    zip: "95490",
    ST: "CA",
    cityWithStateAbbr: "Willits, CA",
  },
  {
    zip: "95492",
    ST: "CA",
    cityWithStateAbbr: "Windsor, CA",
  },
  {
    zip: "95493",
    ST: "CA",
    cityWithStateAbbr: "Witter Springs, CA",
  },
  {
    zip: "95494",
    ST: "CA",
    cityWithStateAbbr: "Yorkville, CA",
  },
  {
    zip: "95497",
    ST: "CA",
    cityWithStateAbbr: "The Sea Ranch, CA",
  },
  {
    zip: "95501",
    ST: "CA",
    cityWithStateAbbr: "Eureka, CA",
  },
  {
    zip: "95502",
    ST: "CA",
    cityWithStateAbbr: "Eureka, CA",
  },
  {
    zip: "95503",
    ST: "CA",
    cityWithStateAbbr: "Eureka, CA",
  },
  {
    zip: "95511",
    ST: "CA",
    cityWithStateAbbr: "Alderpoint, CA",
  },
  {
    zip: "95514",
    ST: "CA",
    cityWithStateAbbr: "Blocksburg, CA",
  },
  {
    zip: "95518",
    ST: "CA",
    cityWithStateAbbr: "Arcata, CA",
  },
  {
    zip: "95519",
    ST: "CA",
    cityWithStateAbbr: "Mckinleyville, CA",
  },
  {
    zip: "95521",
    ST: "CA",
    cityWithStateAbbr: "Arcata, CA",
  },
  {
    zip: "95524",
    ST: "CA",
    cityWithStateAbbr: "Bayside, CA",
  },
  {
    zip: "95525",
    ST: "CA",
    cityWithStateAbbr: "Blue Lake, CA",
  },
  {
    zip: "95526",
    ST: "CA",
    cityWithStateAbbr: "Bridgeville, CA",
  },
  {
    zip: "95527",
    ST: "CA",
    cityWithStateAbbr: "Burnt Ranch, CA",
  },
  {
    zip: "95528",
    ST: "CA",
    cityWithStateAbbr: "Carlotta, CA",
  },
  {
    zip: "95531",
    ST: "CA",
    cityWithStateAbbr: "Crescent City, CA",
  },
  {
    zip: "95532",
    ST: "CA",
    cityWithStateAbbr: "Crescent City, CA",
  },
  {
    zip: "95534",
    ST: "CA",
    cityWithStateAbbr: "Cutten, CA",
  },
  {
    zip: "95536",
    ST: "CA",
    cityWithStateAbbr: "Ferndale, CA",
  },
  {
    zip: "95537",
    ST: "CA",
    cityWithStateAbbr: "Fields Landing, CA",
  },
  {
    zip: "95538",
    ST: "CA",
    cityWithStateAbbr: "Fort Dick, CA",
  },
  {
    zip: "95540",
    ST: "CA",
    cityWithStateAbbr: "Fortuna, CA",
  },
  {
    zip: "95542",
    ST: "CA",
    cityWithStateAbbr: "Garberville, CA",
  },
  {
    zip: "95543",
    ST: "CA",
    cityWithStateAbbr: "Gasquet, CA",
  },
  {
    zip: "95545",
    ST: "CA",
    cityWithStateAbbr: "Honeydew, CA",
  },
  {
    zip: "95546",
    ST: "CA",
    cityWithStateAbbr: "Hoopa, CA",
  },
  {
    zip: "95547",
    ST: "CA",
    cityWithStateAbbr: "Hydesville, CA",
  },
  {
    zip: "95548",
    ST: "CA",
    cityWithStateAbbr: "Klamath, CA",
  },
  {
    zip: "95549",
    ST: "CA",
    cityWithStateAbbr: "Kneeland, CA",
  },
  {
    zip: "95550",
    ST: "CA",
    cityWithStateAbbr: "Korbel, CA",
  },
  {
    zip: "95551",
    ST: "CA",
    cityWithStateAbbr: "Loleta, CA",
  },
  {
    zip: "95552",
    ST: "CA",
    cityWithStateAbbr: "Mad River, CA",
  },
  {
    zip: "95553",
    ST: "CA",
    cityWithStateAbbr: "Miranda, CA",
  },
  {
    zip: "95554",
    ST: "CA",
    cityWithStateAbbr: "Myers Flat, CA",
  },
  {
    zip: "95555",
    ST: "CA",
    cityWithStateAbbr: "Orick, CA",
  },
  {
    zip: "95556",
    ST: "CA",
    cityWithStateAbbr: "Orleans, CA",
  },
  {
    zip: "95558",
    ST: "CA",
    cityWithStateAbbr: "Petrolia, CA",
  },
  {
    zip: "95559",
    ST: "CA",
    cityWithStateAbbr: "Phillipsville, CA",
  },
  {
    zip: "95560",
    ST: "CA",
    cityWithStateAbbr: "Redway, CA",
  },
  {
    zip: "95562",
    ST: "CA",
    cityWithStateAbbr: "Rio Dell, CA",
  },
  {
    zip: "95563",
    ST: "CA",
    cityWithStateAbbr: "Salyer, CA",
  },
  {
    zip: "95564",
    ST: "CA",
    cityWithStateAbbr: "Samoa, CA",
  },
  {
    zip: "95565",
    ST: "CA",
    cityWithStateAbbr: "Scotia, CA",
  },
  {
    zip: "95567",
    ST: "CA",
    cityWithStateAbbr: "Smith River, CA",
  },
  {
    zip: "95568",
    ST: "CA",
    cityWithStateAbbr: "Somes Bar, CA",
  },
  {
    zip: "95569",
    ST: "CA",
    cityWithStateAbbr: "Redcrest, CA",
  },
  {
    zip: "95570",
    ST: "CA",
    cityWithStateAbbr: "Trinidad, CA",
  },
  {
    zip: "95571",
    ST: "CA",
    cityWithStateAbbr: "Weott, CA",
  },
  {
    zip: "95573",
    ST: "CA",
    cityWithStateAbbr: "Willow Creek, CA",
  },
  {
    zip: "95585",
    ST: "CA",
    cityWithStateAbbr: "Leggett, CA",
  },
  {
    zip: "95587",
    ST: "CA",
    cityWithStateAbbr: "Piercy, CA",
  },
  {
    zip: "95589",
    ST: "CA",
    cityWithStateAbbr: "Whitethorn, CA",
  },
  {
    zip: "95595",
    ST: "CA",
    cityWithStateAbbr: "Zenia, CA",
  },
  {
    zip: "95601",
    ST: "CA",
    cityWithStateAbbr: "Amador City, CA",
  },
  {
    zip: "95602",
    ST: "CA",
    cityWithStateAbbr: "Auburn, CA",
  },
  {
    zip: "95603",
    ST: "CA",
    cityWithStateAbbr: "Auburn, CA",
  },
  {
    zip: "95604",
    ST: "CA",
    cityWithStateAbbr: "Auburn, CA",
  },
  {
    zip: "95605",
    ST: "CA",
    cityWithStateAbbr: "West Sacramento, CA",
  },
  {
    zip: "95606",
    ST: "CA",
    cityWithStateAbbr: "Brooks, CA",
  },
  {
    zip: "95607",
    ST: "CA",
    cityWithStateAbbr: "Capay, CA",
  },
  {
    zip: "95608",
    ST: "CA",
    cityWithStateAbbr: "Carmichael, CA",
  },
  {
    zip: "95609",
    ST: "CA",
    cityWithStateAbbr: "Carmichael, CA",
  },
  {
    zip: "95610",
    ST: "CA",
    cityWithStateAbbr: "Citrus Heights, CA",
  },
  {
    zip: "95611",
    ST: "CA",
    cityWithStateAbbr: "Citrus Heights, CA",
  },
  {
    zip: "95612",
    ST: "CA",
    cityWithStateAbbr: "Clarksburg, CA",
  },
  {
    zip: "95613",
    ST: "CA",
    cityWithStateAbbr: "Coloma, CA",
  },
  {
    zip: "95614",
    ST: "CA",
    cityWithStateAbbr: "Cool, CA",
  },
  {
    zip: "95615",
    ST: "CA",
    cityWithStateAbbr: "Courtland, CA",
  },
  {
    zip: "95616",
    ST: "CA",
    cityWithStateAbbr: "Davis, CA",
  },
  {
    zip: "95617",
    ST: "CA",
    cityWithStateAbbr: "Davis, CA",
  },
  {
    zip: "95618",
    ST: "CA",
    cityWithStateAbbr: "Davis, CA",
  },
  {
    zip: "95619",
    ST: "CA",
    cityWithStateAbbr: "Diamond Springs, CA",
  },
  {
    zip: "95620",
    ST: "CA",
    cityWithStateAbbr: "Dixon, CA",
  },
  {
    zip: "95621",
    ST: "CA",
    cityWithStateAbbr: "Citrus Heights, CA",
  },
  {
    zip: "95623",
    ST: "CA",
    cityWithStateAbbr: "El Dorado, CA",
  },
  {
    zip: "95624",
    ST: "CA",
    cityWithStateAbbr: "Elk Grove, CA",
  },
  {
    zip: "95625",
    ST: "CA",
    cityWithStateAbbr: "Elmira, CA",
  },
  {
    zip: "95626",
    ST: "CA",
    cityWithStateAbbr: "Elverta, CA",
  },
  {
    zip: "95627",
    ST: "CA",
    cityWithStateAbbr: "Esparto, CA",
  },
  {
    zip: "95628",
    ST: "CA",
    cityWithStateAbbr: "Fair Oaks, CA",
  },
  {
    zip: "95629",
    ST: "CA",
    cityWithStateAbbr: "Fiddletown, CA",
  },
  {
    zip: "95630",
    ST: "CA",
    cityWithStateAbbr: "Folsom, CA",
  },
  {
    zip: "95631",
    ST: "CA",
    cityWithStateAbbr: "Foresthill, CA",
  },
  {
    zip: "95632",
    ST: "CA",
    cityWithStateAbbr: "Galt, CA",
  },
  {
    zip: "95633",
    ST: "CA",
    cityWithStateAbbr: "Garden Valley, CA",
  },
  {
    zip: "95634",
    ST: "CA",
    cityWithStateAbbr: "Georgetown, CA",
  },
  {
    zip: "95635",
    ST: "CA",
    cityWithStateAbbr: "Greenwood, CA",
  },
  {
    zip: "95636",
    ST: "CA",
    cityWithStateAbbr: "Grizzly Flats, CA",
  },
  {
    zip: "95637",
    ST: "CA",
    cityWithStateAbbr: "Guinda, CA",
  },
  {
    zip: "95638",
    ST: "CA",
    cityWithStateAbbr: "Herald, CA",
  },
  {
    zip: "95639",
    ST: "CA",
    cityWithStateAbbr: "Hood, CA",
  },
  {
    zip: "95640",
    ST: "CA",
    cityWithStateAbbr: "Ione, CA",
  },
  {
    zip: "95641",
    ST: "CA",
    cityWithStateAbbr: "Isleton, CA",
  },
  {
    zip: "95642",
    ST: "CA",
    cityWithStateAbbr: "Jackson, CA",
  },
  {
    zip: "95645",
    ST: "CA",
    cityWithStateAbbr: "Knights Landing, CA",
  },
  {
    zip: "95646",
    ST: "CA",
    cityWithStateAbbr: "Kirkwood, CA",
  },
  {
    zip: "95648",
    ST: "CA",
    cityWithStateAbbr: "Lincoln, CA",
  },
  {
    zip: "95650",
    ST: "CA",
    cityWithStateAbbr: "Loomis, CA",
  },
  {
    zip: "95651",
    ST: "CA",
    cityWithStateAbbr: "Lotus, CA",
  },
  {
    zip: "95652",
    ST: "CA",
    cityWithStateAbbr: "Mcclellan, CA",
  },
  {
    zip: "95653",
    ST: "CA",
    cityWithStateAbbr: "Madison, CA",
  },
  {
    zip: "95654",
    ST: "CA",
    cityWithStateAbbr: "Martell, CA",
  },
  {
    zip: "95655",
    ST: "CA",
    cityWithStateAbbr: "Mather, CA",
  },
  {
    zip: "95656",
    ST: "CA",
    cityWithStateAbbr: "Mount Aukum, CA",
  },
  {
    zip: "95658",
    ST: "CA",
    cityWithStateAbbr: "Newcastle, CA",
  },
  {
    zip: "95659",
    ST: "CA",
    cityWithStateAbbr: "Nicolaus, CA",
  },
  {
    zip: "95660",
    ST: "CA",
    cityWithStateAbbr: "North Highlands, CA",
  },
  {
    zip: "95661",
    ST: "CA",
    cityWithStateAbbr: "Roseville, CA",
  },
  {
    zip: "95662",
    ST: "CA",
    cityWithStateAbbr: "Orangevale, CA",
  },
  {
    zip: "95663",
    ST: "CA",
    cityWithStateAbbr: "Penryn, CA",
  },
  {
    zip: "95664",
    ST: "CA",
    cityWithStateAbbr: "Pilot Hill, CA",
  },
  {
    zip: "95665",
    ST: "CA",
    cityWithStateAbbr: "Pine Grove, CA",
  },
  {
    zip: "95666",
    ST: "CA",
    cityWithStateAbbr: "Pioneer, CA",
  },
  {
    zip: "95667",
    ST: "CA",
    cityWithStateAbbr: "Placerville, CA",
  },
  {
    zip: "95668",
    ST: "CA",
    cityWithStateAbbr: "Pleasant Grove, CA",
  },
  {
    zip: "95669",
    ST: "CA",
    cityWithStateAbbr: "Plymouth, CA",
  },
  {
    zip: "95670",
    ST: "CA",
    cityWithStateAbbr: "Rancho Cordova, CA",
  },
  {
    zip: "95671",
    ST: "CA",
    cityWithStateAbbr: "Represa, CA",
  },
  {
    zip: "95672",
    ST: "CA",
    cityWithStateAbbr: "Rescue, CA",
  },
  {
    zip: "95673",
    ST: "CA",
    cityWithStateAbbr: "Rio Linda, CA",
  },
  {
    zip: "95674",
    ST: "CA",
    cityWithStateAbbr: "Rio Oso, CA",
  },
  {
    zip: "95675",
    ST: "CA",
    cityWithStateAbbr: "River Pines, CA",
  },
  {
    zip: "95676",
    ST: "CA",
    cityWithStateAbbr: "Robbins, CA",
  },
  {
    zip: "95677",
    ST: "CA",
    cityWithStateAbbr: "Rocklin, CA",
  },
  {
    zip: "95678",
    ST: "CA",
    cityWithStateAbbr: "Roseville, CA",
  },
  {
    zip: "95679",
    ST: "CA",
    cityWithStateAbbr: "Rumsey, CA",
  },
  {
    zip: "95680",
    ST: "CA",
    cityWithStateAbbr: "Ryde, CA",
  },
  {
    zip: "95681",
    ST: "CA",
    cityWithStateAbbr: "Sheridan, CA",
  },
  {
    zip: "95682",
    ST: "CA",
    cityWithStateAbbr: "Shingle Springs, CA",
  },
  {
    zip: "95683",
    ST: "CA",
    cityWithStateAbbr: "Sloughhouse, CA",
  },
  {
    zip: "95684",
    ST: "CA",
    cityWithStateAbbr: "Somerset, CA",
  },
  {
    zip: "95685",
    ST: "CA",
    cityWithStateAbbr: "Sutter Creek, CA",
  },
  {
    zip: "95686",
    ST: "CA",
    cityWithStateAbbr: "Thornton, CA",
  },
  {
    zip: "95687",
    ST: "CA",
    cityWithStateAbbr: "Vacaville, CA",
  },
  {
    zip: "95688",
    ST: "CA",
    cityWithStateAbbr: "Vacaville, CA",
  },
  {
    zip: "95689",
    ST: "CA",
    cityWithStateAbbr: "Volcano, CA",
  },
  {
    zip: "95690",
    ST: "CA",
    cityWithStateAbbr: "Walnut Grove, CA",
  },
  {
    zip: "95691",
    ST: "CA",
    cityWithStateAbbr: "West Sacramento, CA",
  },
  {
    zip: "95692",
    ST: "CA",
    cityWithStateAbbr: "Wheatland, CA",
  },
  {
    zip: "95693",
    ST: "CA",
    cityWithStateAbbr: "Wilton, CA",
  },
  {
    zip: "95694",
    ST: "CA",
    cityWithStateAbbr: "Winters, CA",
  },
  {
    zip: "95695",
    ST: "CA",
    cityWithStateAbbr: "Woodland, CA",
  },
  {
    zip: "95696",
    ST: "CA",
    cityWithStateAbbr: "Vacaville, CA",
  },
  {
    zip: "95697",
    ST: "CA",
    cityWithStateAbbr: "Yolo, CA",
  },
  {
    zip: "95698",
    ST: "CA",
    cityWithStateAbbr: "Zamora, CA",
  },
  {
    zip: "95699",
    ST: "CA",
    cityWithStateAbbr: "Drytown, CA",
  },
  {
    zip: "95701",
    ST: "CA",
    cityWithStateAbbr: "Alta, CA",
  },
  {
    zip: "95703",
    ST: "CA",
    cityWithStateAbbr: "Applegate, CA",
  },
  {
    zip: "95709",
    ST: "CA",
    cityWithStateAbbr: "Camino, CA",
  },
  {
    zip: "95712",
    ST: "CA",
    cityWithStateAbbr: "Chicago Park, CA",
  },
  {
    zip: "95713",
    ST: "CA",
    cityWithStateAbbr: "Colfax, CA",
  },
  {
    zip: "95714",
    ST: "CA",
    cityWithStateAbbr: "Dutch Flat, CA",
  },
  {
    zip: "95715",
    ST: "CA",
    cityWithStateAbbr: "Emigrant Gap, CA",
  },
  {
    zip: "95717",
    ST: "CA",
    cityWithStateAbbr: "Gold Run, CA",
  },
  {
    zip: "95720",
    ST: "CA",
    cityWithStateAbbr: "Kyburz, CA",
  },
  {
    zip: "95721",
    ST: "CA",
    cityWithStateAbbr: "Echo Lake, CA",
  },
  {
    zip: "95722",
    ST: "CA",
    cityWithStateAbbr: "Meadow Vista, CA",
  },
  {
    zip: "95724",
    ST: "CA",
    cityWithStateAbbr: "Norden, CA",
  },
  {
    zip: "95726",
    ST: "CA",
    cityWithStateAbbr: "Pollock Pines, CA",
  },
  {
    zip: "95728",
    ST: "CA",
    cityWithStateAbbr: "Soda Springs, CA",
  },
  {
    zip: "95735",
    ST: "CA",
    cityWithStateAbbr: "Twin Bridges, CA",
  },
  {
    zip: "95736",
    ST: "CA",
    cityWithStateAbbr: "Weimar, CA",
  },
  {
    zip: "95741",
    ST: "CA",
    cityWithStateAbbr: "Rancho Cordova, CA",
  },
  {
    zip: "95742",
    ST: "CA",
    cityWithStateAbbr: "Rancho Cordova, CA",
  },
  {
    zip: "95746",
    ST: "CA",
    cityWithStateAbbr: "Granite Bay, CA",
  },
  {
    zip: "95747",
    ST: "CA",
    cityWithStateAbbr: "Roseville, CA",
  },
  {
    zip: "95757",
    ST: "CA",
    cityWithStateAbbr: "Elk Grove, CA",
  },
  {
    zip: "95758",
    ST: "CA",
    cityWithStateAbbr: "Elk Grove, CA",
  },
  {
    zip: "95759",
    ST: "CA",
    cityWithStateAbbr: "Elk Grove, CA",
  },
  {
    zip: "95762",
    ST: "CA",
    cityWithStateAbbr: "El Dorado Hills, CA",
  },
  {
    zip: "95763",
    ST: "CA",
    cityWithStateAbbr: "Folsom, CA",
  },
  {
    zip: "95765",
    ST: "CA",
    cityWithStateAbbr: "Rocklin, CA",
  },
  {
    zip: "95776",
    ST: "CA",
    cityWithStateAbbr: "Woodland, CA",
  },
  {
    zip: "95798",
    ST: "CA",
    cityWithStateAbbr: "West Sacramento, CA",
  },
  {
    zip: "95799",
    ST: "CA",
    cityWithStateAbbr: "West Sacramento, CA",
  },
  {
    zip: "95811",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95812",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95813",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95814",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95815",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95816",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95817",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95818",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95819",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95820",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95821",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95822",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95823",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95824",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95825",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95826",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95827",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95828",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95829",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95830",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95831",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95832",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95833",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95834",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95835",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95836",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95837",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95838",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95840",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95841",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95842",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95843",
    ST: "CA",
    cityWithStateAbbr: "Antelope, CA",
  },
  {
    zip: "95851",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95852",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95853",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95860",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95864",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95865",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95866",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95867",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95887",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95894",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95899",
    ST: "CA",
    cityWithStateAbbr: "Sacramento, CA",
  },
  {
    zip: "95901",
    ST: "CA",
    cityWithStateAbbr: "Marysville, CA",
  },
  {
    zip: "95903",
    ST: "CA",
    cityWithStateAbbr: "Beale Afb, CA",
  },
  {
    zip: "95910",
    ST: "CA",
    cityWithStateAbbr: "Alleghany, CA",
  },
  {
    zip: "95912",
    ST: "CA",
    cityWithStateAbbr: "Arbuckle, CA",
  },
  {
    zip: "95913",
    ST: "CA",
    cityWithStateAbbr: "Artois, CA",
  },
  {
    zip: "95914",
    ST: "CA",
    cityWithStateAbbr: "Bangor, CA",
  },
  {
    zip: "95915",
    ST: "CA",
    cityWithStateAbbr: "Belden, CA",
  },
  {
    zip: "95916",
    ST: "CA",
    cityWithStateAbbr: "Berry Creek, CA",
  },
  {
    zip: "95917",
    ST: "CA",
    cityWithStateAbbr: "Biggs, CA",
  },
  {
    zip: "95918",
    ST: "CA",
    cityWithStateAbbr: "Browns Valley, CA",
  },
  {
    zip: "95919",
    ST: "CA",
    cityWithStateAbbr: "Brownsville, CA",
  },
  {
    zip: "95920",
    ST: "CA",
    cityWithStateAbbr: "Butte City, CA",
  },
  {
    zip: "95922",
    ST: "CA",
    cityWithStateAbbr: "Camptonville, CA",
  },
  {
    zip: "95923",
    ST: "CA",
    cityWithStateAbbr: "Canyon Dam, CA",
  },
  {
    zip: "95924",
    ST: "CA",
    cityWithStateAbbr: "Cedar Ridge, CA",
  },
  {
    zip: "95925",
    ST: "CA",
    cityWithStateAbbr: "Challenge, CA",
  },
  {
    zip: "95926",
    ST: "CA",
    cityWithStateAbbr: "Chico, CA",
  },
  {
    zip: "95927",
    ST: "CA",
    cityWithStateAbbr: "Chico, CA",
  },
  {
    zip: "95928",
    ST: "CA",
    cityWithStateAbbr: "Chico, CA",
  },
  {
    zip: "95929",
    ST: "CA",
    cityWithStateAbbr: "Chico, CA",
  },
  {
    zip: "95930",
    ST: "CA",
    cityWithStateAbbr: "Clipper Mills, CA",
  },
  {
    zip: "95932",
    ST: "CA",
    cityWithStateAbbr: "Colusa, CA",
  },
  {
    zip: "95934",
    ST: "CA",
    cityWithStateAbbr: "Crescent Mills, CA",
  },
  {
    zip: "95935",
    ST: "CA",
    cityWithStateAbbr: "Dobbins, CA",
  },
  {
    zip: "95936",
    ST: "CA",
    cityWithStateAbbr: "Downieville, CA",
  },
  {
    zip: "95937",
    ST: "CA",
    cityWithStateAbbr: "Dunnigan, CA",
  },
  {
    zip: "95938",
    ST: "CA",
    cityWithStateAbbr: "Durham, CA",
  },
  {
    zip: "95939",
    ST: "CA",
    cityWithStateAbbr: "Elk Creek, CA",
  },
  {
    zip: "95940",
    ST: "CA",
    cityWithStateAbbr: "Feather Falls, CA",
  },
  {
    zip: "95941",
    ST: "CA",
    cityWithStateAbbr: "Forbestown, CA",
  },
  {
    zip: "95942",
    ST: "CA",
    cityWithStateAbbr: "Forest Ranch, CA",
  },
  {
    zip: "95943",
    ST: "CA",
    cityWithStateAbbr: "Glenn, CA",
  },
  {
    zip: "95944",
    ST: "CA",
    cityWithStateAbbr: "Goodyears Bar, CA",
  },
  {
    zip: "95945",
    ST: "CA",
    cityWithStateAbbr: "Grass Valley, CA",
  },
  {
    zip: "95946",
    ST: "CA",
    cityWithStateAbbr: "Penn Valley, CA",
  },
  {
    zip: "95947",
    ST: "CA",
    cityWithStateAbbr: "Greenville, CA",
  },
  {
    zip: "95948",
    ST: "CA",
    cityWithStateAbbr: "Gridley, CA",
  },
  {
    zip: "95949",
    ST: "CA",
    cityWithStateAbbr: "Grass Valley, CA",
  },
  {
    zip: "95950",
    ST: "CA",
    cityWithStateAbbr: "Grimes, CA",
  },
  {
    zip: "95951",
    ST: "CA",
    cityWithStateAbbr: "Hamilton City, CA",
  },
  {
    zip: "95953",
    ST: "CA",
    cityWithStateAbbr: "Live Oak, CA",
  },
  {
    zip: "95954",
    ST: "CA",
    cityWithStateAbbr: "Magalia, CA",
  },
  {
    zip: "95955",
    ST: "CA",
    cityWithStateAbbr: "Maxwell, CA",
  },
  {
    zip: "95956",
    ST: "CA",
    cityWithStateAbbr: "Meadow Valley, CA",
  },
  {
    zip: "95957",
    ST: "CA",
    cityWithStateAbbr: "Meridian, CA",
  },
  {
    zip: "95958",
    ST: "CA",
    cityWithStateAbbr: "Nelson, CA",
  },
  {
    zip: "95959",
    ST: "CA",
    cityWithStateAbbr: "Nevada City, CA",
  },
  {
    zip: "95960",
    ST: "CA",
    cityWithStateAbbr: "North San Juan, CA",
  },
  {
    zip: "95961",
    ST: "CA",
    cityWithStateAbbr: "Olivehurst, CA",
  },
  {
    zip: "95962",
    ST: "CA",
    cityWithStateAbbr: "Oregon House, CA",
  },
  {
    zip: "95963",
    ST: "CA",
    cityWithStateAbbr: "Orland, CA",
  },
  {
    zip: "95965",
    ST: "CA",
    cityWithStateAbbr: "Oroville, CA",
  },
  {
    zip: "95966",
    ST: "CA",
    cityWithStateAbbr: "Oroville, CA",
  },
  {
    zip: "95967",
    ST: "CA",
    cityWithStateAbbr: "Paradise, CA",
  },
  {
    zip: "95968",
    ST: "CA",
    cityWithStateAbbr: "Palermo, CA",
  },
  {
    zip: "95969",
    ST: "CA",
    cityWithStateAbbr: "Paradise, CA",
  },
  {
    zip: "95970",
    ST: "CA",
    cityWithStateAbbr: "Princeton, CA",
  },
  {
    zip: "95971",
    ST: "CA",
    cityWithStateAbbr: "Quincy, CA",
  },
  {
    zip: "95972",
    ST: "CA",
    cityWithStateAbbr: "Rackerby, CA",
  },
  {
    zip: "95973",
    ST: "CA",
    cityWithStateAbbr: "Chico, CA",
  },
  {
    zip: "95974",
    ST: "CA",
    cityWithStateAbbr: "Richvale, CA",
  },
  {
    zip: "95975",
    ST: "CA",
    cityWithStateAbbr: "Rough And Ready, CA",
  },
  {
    zip: "95976",
    ST: "CA",
    cityWithStateAbbr: "Chico, CA",
  },
  {
    zip: "95977",
    ST: "CA",
    cityWithStateAbbr: "Smartsville, CA",
  },
  {
    zip: "95978",
    ST: "CA",
    cityWithStateAbbr: "Stirling City, CA",
  },
  {
    zip: "95979",
    ST: "CA",
    cityWithStateAbbr: "Stonyford, CA",
  },
  {
    zip: "95980",
    ST: "CA",
    cityWithStateAbbr: "Storrie, CA",
  },
  {
    zip: "95981",
    ST: "CA",
    cityWithStateAbbr: "Strawberry Valley, CA",
  },
  {
    zip: "95982",
    ST: "CA",
    cityWithStateAbbr: "Sutter, CA",
  },
  {
    zip: "95983",
    ST: "CA",
    cityWithStateAbbr: "Taylorsville, CA",
  },
  {
    zip: "95984",
    ST: "CA",
    cityWithStateAbbr: "Twain, CA",
  },
  {
    zip: "95986",
    ST: "CA",
    cityWithStateAbbr: "Washington, CA",
  },
  {
    zip: "95987",
    ST: "CA",
    cityWithStateAbbr: "Williams, CA",
  },
  {
    zip: "95988",
    ST: "CA",
    cityWithStateAbbr: "Willows, CA",
  },
  {
    zip: "95991",
    ST: "CA",
    cityWithStateAbbr: "Yuba City, CA",
  },
  {
    zip: "95992",
    ST: "CA",
    cityWithStateAbbr: "Yuba City, CA",
  },
  {
    zip: "95993",
    ST: "CA",
    cityWithStateAbbr: "Yuba City, CA",
  },
  {
    zip: "96001",
    ST: "CA",
    cityWithStateAbbr: "Redding, CA",
  },
  {
    zip: "96002",
    ST: "CA",
    cityWithStateAbbr: "Redding, CA",
  },
  {
    zip: "96003",
    ST: "CA",
    cityWithStateAbbr: "Redding, CA",
  },
  {
    zip: "96006",
    ST: "CA",
    cityWithStateAbbr: "Adin, CA",
  },
  {
    zip: "96007",
    ST: "CA",
    cityWithStateAbbr: "Anderson, CA",
  },
  {
    zip: "96008",
    ST: "CA",
    cityWithStateAbbr: "Bella Vista, CA",
  },
  {
    zip: "96009",
    ST: "CA",
    cityWithStateAbbr: "Bieber, CA",
  },
  {
    zip: "96010",
    ST: "CA",
    cityWithStateAbbr: "Big Bar, CA",
  },
  {
    zip: "96011",
    ST: "CA",
    cityWithStateAbbr: "Big Bend, CA",
  },
  {
    zip: "96013",
    ST: "CA",
    cityWithStateAbbr: "Burney, CA",
  },
  {
    zip: "96014",
    ST: "CA",
    cityWithStateAbbr: "Callahan, CA",
  },
  {
    zip: "96015",
    ST: "CA",
    cityWithStateAbbr: "Canby, CA",
  },
  {
    zip: "96016",
    ST: "CA",
    cityWithStateAbbr: "Cassel, CA",
  },
  {
    zip: "96017",
    ST: "CA",
    cityWithStateAbbr: "Castella, CA",
  },
  {
    zip: "96019",
    ST: "CA",
    cityWithStateAbbr: "Shasta Lake, CA",
  },
  {
    zip: "96020",
    ST: "CA",
    cityWithStateAbbr: "Chester, CA",
  },
  {
    zip: "96021",
    ST: "CA",
    cityWithStateAbbr: "Corning, CA",
  },
  {
    zip: "96022",
    ST: "CA",
    cityWithStateAbbr: "Cottonwood, CA",
  },
  {
    zip: "96023",
    ST: "CA",
    cityWithStateAbbr: "Dorris, CA",
  },
  {
    zip: "96024",
    ST: "CA",
    cityWithStateAbbr: "Douglas City, CA",
  },
  {
    zip: "96025",
    ST: "CA",
    cityWithStateAbbr: "Dunsmuir, CA",
  },
  {
    zip: "96027",
    ST: "CA",
    cityWithStateAbbr: "Etna, CA",
  },
  {
    zip: "96028",
    ST: "CA",
    cityWithStateAbbr: "Fall River Mills, CA",
  },
  {
    zip: "96029",
    ST: "CA",
    cityWithStateAbbr: "Flournoy, CA",
  },
  {
    zip: "96031",
    ST: "CA",
    cityWithStateAbbr: "Forks Of Salmon, CA",
  },
  {
    zip: "96032",
    ST: "CA",
    cityWithStateAbbr: "Fort Jones, CA",
  },
  {
    zip: "96033",
    ST: "CA",
    cityWithStateAbbr: "French Gulch, CA",
  },
  {
    zip: "96034",
    ST: "CA",
    cityWithStateAbbr: "Gazelle, CA",
  },
  {
    zip: "96035",
    ST: "CA",
    cityWithStateAbbr: "Gerber, CA",
  },
  {
    zip: "96037",
    ST: "CA",
    cityWithStateAbbr: "Greenview, CA",
  },
  {
    zip: "96038",
    ST: "CA",
    cityWithStateAbbr: "Grenada, CA",
  },
  {
    zip: "96039",
    ST: "CA",
    cityWithStateAbbr: "Happy Camp, CA",
  },
  {
    zip: "96040",
    ST: "CA",
    cityWithStateAbbr: "Hat Creek, CA",
  },
  {
    zip: "96041",
    ST: "CA",
    cityWithStateAbbr: "Hayfork, CA",
  },
  {
    zip: "96044",
    ST: "CA",
    cityWithStateAbbr: "Hornbrook, CA",
  },
  {
    zip: "96046",
    ST: "CA",
    cityWithStateAbbr: "Hyampom, CA",
  },
  {
    zip: "96047",
    ST: "CA",
    cityWithStateAbbr: "Igo, CA",
  },
  {
    zip: "96048",
    ST: "CA",
    cityWithStateAbbr: "Junction City, CA",
  },
  {
    zip: "96049",
    ST: "CA",
    cityWithStateAbbr: "Redding, CA",
  },
  {
    zip: "96050",
    ST: "CA",
    cityWithStateAbbr: "Klamath River, CA",
  },
  {
    zip: "96051",
    ST: "CA",
    cityWithStateAbbr: "Lakehead, CA",
  },
  {
    zip: "96052",
    ST: "CA",
    cityWithStateAbbr: "Lewiston, CA",
  },
  {
    zip: "96054",
    ST: "CA",
    cityWithStateAbbr: "Lookout, CA",
  },
  {
    zip: "96055",
    ST: "CA",
    cityWithStateAbbr: "Los Molinos, CA",
  },
  {
    zip: "96056",
    ST: "CA",
    cityWithStateAbbr: "Mcarthur, CA",
  },
  {
    zip: "96057",
    ST: "CA",
    cityWithStateAbbr: "Mccloud, CA",
  },
  {
    zip: "96058",
    ST: "CA",
    cityWithStateAbbr: "Macdoel, CA",
  },
  {
    zip: "96059",
    ST: "CA",
    cityWithStateAbbr: "Manton, CA",
  },
  {
    zip: "96061",
    ST: "CA",
    cityWithStateAbbr: "Mill Creek, CA",
  },
  {
    zip: "96062",
    ST: "CA",
    cityWithStateAbbr: "Millville, CA",
  },
  {
    zip: "96063",
    ST: "CA",
    cityWithStateAbbr: "Mineral, CA",
  },
  {
    zip: "96064",
    ST: "CA",
    cityWithStateAbbr: "Montague, CA",
  },
  {
    zip: "96065",
    ST: "CA",
    cityWithStateAbbr: "Montgomery Creek, CA",
  },
  {
    zip: "96067",
    ST: "CA",
    cityWithStateAbbr: "Mount Shasta, CA",
  },
  {
    zip: "96068",
    ST: "CA",
    cityWithStateAbbr: "Nubieber, CA",
  },
  {
    zip: "96069",
    ST: "CA",
    cityWithStateAbbr: "Oak Run, CA",
  },
  {
    zip: "96070",
    ST: "CA",
    cityWithStateAbbr: "Obrien, CA",
  },
  {
    zip: "96071",
    ST: "CA",
    cityWithStateAbbr: "Old Station, CA",
  },
  {
    zip: "96073",
    ST: "CA",
    cityWithStateAbbr: "Palo Cedro, CA",
  },
  {
    zip: "96074",
    ST: "CA",
    cityWithStateAbbr: "Paskenta, CA",
  },
  {
    zip: "96075",
    ST: "CA",
    cityWithStateAbbr: "Paynes Creek, CA",
  },
  {
    zip: "96076",
    ST: "CA",
    cityWithStateAbbr: "Platina, CA",
  },
  {
    zip: "96078",
    ST: "CA",
    cityWithStateAbbr: "Proberta, CA",
  },
  {
    zip: "96079",
    ST: "CA",
    cityWithStateAbbr: "Shasta Lake, CA",
  },
  {
    zip: "96080",
    ST: "CA",
    cityWithStateAbbr: "Red Bluff, CA",
  },
  {
    zip: "96084",
    ST: "CA",
    cityWithStateAbbr: "Round Mountain, CA",
  },
  {
    zip: "96085",
    ST: "CA",
    cityWithStateAbbr: "Scott Bar, CA",
  },
  {
    zip: "96086",
    ST: "CA",
    cityWithStateAbbr: "Seiad Valley, CA",
  },
  {
    zip: "96087",
    ST: "CA",
    cityWithStateAbbr: "Shasta, CA",
  },
  {
    zip: "96088",
    ST: "CA",
    cityWithStateAbbr: "Shingletown, CA",
  },
  {
    zip: "96089",
    ST: "CA",
    cityWithStateAbbr: "Shasta Lake, CA",
  },
  {
    zip: "96090",
    ST: "CA",
    cityWithStateAbbr: "Tehama, CA",
  },
  {
    zip: "96091",
    ST: "CA",
    cityWithStateAbbr: "Trinity Center, CA",
  },
  {
    zip: "96092",
    ST: "CA",
    cityWithStateAbbr: "Vina, CA",
  },
  {
    zip: "96093",
    ST: "CA",
    cityWithStateAbbr: "Weaverville, CA",
  },
  {
    zip: "96094",
    ST: "CA",
    cityWithStateAbbr: "Weed, CA",
  },
  {
    zip: "96095",
    ST: "CA",
    cityWithStateAbbr: "Whiskeytown, CA",
  },
  {
    zip: "96096",
    ST: "CA",
    cityWithStateAbbr: "Whitmore, CA",
  },
  {
    zip: "96097",
    ST: "CA",
    cityWithStateAbbr: "Yreka, CA",
  },
  {
    zip: "96099",
    ST: "CA",
    cityWithStateAbbr: "Redding, CA",
  },
  {
    zip: "96101",
    ST: "CA",
    cityWithStateAbbr: "Alturas, CA",
  },
  {
    zip: "96103",
    ST: "CA",
    cityWithStateAbbr: "Blairsden Graeagle, CA",
  },
  {
    zip: "96104",
    ST: "CA",
    cityWithStateAbbr: "Cedarville, CA",
  },
  {
    zip: "96105",
    ST: "CA",
    cityWithStateAbbr: "Chilcoot, CA",
  },
  {
    zip: "96106",
    ST: "CA",
    cityWithStateAbbr: "Clio, CA",
  },
  {
    zip: "96107",
    ST: "CA",
    cityWithStateAbbr: "Coleville, CA",
  },
  {
    zip: "96108",
    ST: "CA",
    cityWithStateAbbr: "Davis Creek, CA",
  },
  {
    zip: "96109",
    ST: "CA",
    cityWithStateAbbr: "Doyle, CA",
  },
  {
    zip: "96110",
    ST: "CA",
    cityWithStateAbbr: "Eagleville, CA",
  },
  {
    zip: "96111",
    ST: "CA",
    cityWithStateAbbr: "Floriston, CA",
  },
  {
    zip: "96112",
    ST: "CA",
    cityWithStateAbbr: "Fort Bidwell, CA",
  },
  {
    zip: "96113",
    ST: "CA",
    cityWithStateAbbr: "Herlong, CA",
  },
  {
    zip: "96114",
    ST: "CA",
    cityWithStateAbbr: "Janesville, CA",
  },
  {
    zip: "96115",
    ST: "CA",
    cityWithStateAbbr: "Lake City, CA",
  },
  {
    zip: "96116",
    ST: "CA",
    cityWithStateAbbr: "Likely, CA",
  },
  {
    zip: "96117",
    ST: "CA",
    cityWithStateAbbr: "Litchfield, CA",
  },
  {
    zip: "96118",
    ST: "CA",
    cityWithStateAbbr: "Loyalton, CA",
  },
  {
    zip: "96119",
    ST: "CA",
    cityWithStateAbbr: "Madeline, CA",
  },
  {
    zip: "96120",
    ST: "CA",
    cityWithStateAbbr: "Markleeville, CA",
  },
  {
    zip: "96121",
    ST: "CA",
    cityWithStateAbbr: "Milford, CA",
  },
  {
    zip: "96122",
    ST: "CA",
    cityWithStateAbbr: "Portola, CA",
  },
  {
    zip: "96123",
    ST: "CA",
    cityWithStateAbbr: "Ravendale, CA",
  },
  {
    zip: "96124",
    ST: "CA",
    cityWithStateAbbr: "Calpine, CA",
  },
  {
    zip: "96125",
    ST: "CA",
    cityWithStateAbbr: "Sierra City, CA",
  },
  {
    zip: "96126",
    ST: "CA",
    cityWithStateAbbr: "Sierraville, CA",
  },
  {
    zip: "96127",
    ST: "CA",
    cityWithStateAbbr: "Susanville, CA",
  },
  {
    zip: "96128",
    ST: "CA",
    cityWithStateAbbr: "Standish, CA",
  },
  {
    zip: "96129",
    ST: "CA",
    cityWithStateAbbr: "Beckwourth, CA",
  },
  {
    zip: "96130",
    ST: "CA",
    cityWithStateAbbr: "Susanville, CA",
  },
  {
    zip: "96132",
    ST: "CA",
    cityWithStateAbbr: "Termo, CA",
  },
  {
    zip: "96133",
    ST: "CA",
    cityWithStateAbbr: "Topaz, CA",
  },
  {
    zip: "96134",
    ST: "CA",
    cityWithStateAbbr: "Tulelake, CA",
  },
  {
    zip: "96135",
    ST: "CA",
    cityWithStateAbbr: "Vinton, CA",
  },
  {
    zip: "96136",
    ST: "CA",
    cityWithStateAbbr: "Wendel, CA",
  },
  {
    zip: "96137",
    ST: "CA",
    cityWithStateAbbr: "Westwood, CA",
  },
  {
    zip: "96140",
    ST: "CA",
    cityWithStateAbbr: "Carnelian Bay, CA",
  },
  {
    zip: "96141",
    ST: "CA",
    cityWithStateAbbr: "Homewood, CA",
  },
  {
    zip: "96142",
    ST: "CA",
    cityWithStateAbbr: "Tahoma, CA",
  },
  {
    zip: "96143",
    ST: "CA",
    cityWithStateAbbr: "Kings Beach, CA",
  },
  {
    zip: "96145",
    ST: "CA",
    cityWithStateAbbr: "Tahoe City, CA",
  },
  {
    zip: "96146",
    ST: "CA",
    cityWithStateAbbr: "Olympic Valley, CA",
  },
  {
    zip: "96148",
    ST: "CA",
    cityWithStateAbbr: "Tahoe Vista, CA",
  },
  {
    zip: "96150",
    ST: "CA",
    cityWithStateAbbr: "South Lake Tahoe, CA",
  },
  {
    zip: "96151",
    ST: "CA",
    cityWithStateAbbr: "South Lake Tahoe, CA",
  },
  {
    zip: "96152",
    ST: "CA",
    cityWithStateAbbr: "South Lake Tahoe, CA",
  },
  {
    zip: "96154",
    ST: "CA",
    cityWithStateAbbr: "South Lake Tahoe, CA",
  },
  {
    zip: "96155",
    ST: "CA",
    cityWithStateAbbr: "South Lake Tahoe, CA",
  },
  {
    zip: "96156",
    ST: "CA",
    cityWithStateAbbr: "South Lake Tahoe, CA",
  },
  {
    zip: "96157",
    ST: "CA",
    cityWithStateAbbr: "South Lake Tahoe, CA",
  },
  {
    zip: "96158",
    ST: "CA",
    cityWithStateAbbr: "South Lake Tahoe, CA",
  },
  {
    zip: "96160",
    ST: "CA",
    cityWithStateAbbr: "Truckee, CA",
  },
  {
    zip: "96161",
    ST: "CA",
    cityWithStateAbbr: "Truckee, CA",
  },
  {
    zip: "96162",
    ST: "CA",
    cityWithStateAbbr: "Truckee, CA",
  },
  {
    zip: "96701",
    ST: "HI",
    cityWithStateAbbr: "Aiea, HI",
  },
  {
    zip: "96703",
    ST: "HI",
    cityWithStateAbbr: "Anahola, HI",
  },
  {
    zip: "96704",
    ST: "HI",
    cityWithStateAbbr: "Captain Cook, HI",
  },
  {
    zip: "96705",
    ST: "HI",
    cityWithStateAbbr: "Eleele, HI",
  },
  {
    zip: "96706",
    ST: "HI",
    cityWithStateAbbr: "Ewa Beach, HI",
  },
  {
    zip: "96707",
    ST: "HI",
    cityWithStateAbbr: "Kapolei, HI",
  },
  {
    zip: "96708",
    ST: "HI",
    cityWithStateAbbr: "Haiku, HI",
  },
  {
    zip: "96709",
    ST: "HI",
    cityWithStateAbbr: "Kapolei, HI",
  },
  {
    zip: "96710",
    ST: "HI",
    cityWithStateAbbr: "Hakalau, HI",
  },
  {
    zip: "96712",
    ST: "HI",
    cityWithStateAbbr: "Haleiwa, HI",
  },
  {
    zip: "96713",
    ST: "HI",
    cityWithStateAbbr: "Hana, HI",
  },
  {
    zip: "96714",
    ST: "HI",
    cityWithStateAbbr: "Hanalei, HI",
  },
  {
    zip: "96715",
    ST: "HI",
    cityWithStateAbbr: "Hanamaulu, HI",
  },
  {
    zip: "96716",
    ST: "HI",
    cityWithStateAbbr: "Hanapepe, HI",
  },
  {
    zip: "96717",
    ST: "HI",
    cityWithStateAbbr: "Hauula, HI",
  },
  {
    zip: "96718",
    ST: "HI",
    cityWithStateAbbr: "Hawaii National Park, HI",
  },
  {
    zip: "96719",
    ST: "HI",
    cityWithStateAbbr: "Hawi, HI",
  },
  {
    zip: "96720",
    ST: "HI",
    cityWithStateAbbr: "Hilo, HI",
  },
  {
    zip: "96721",
    ST: "HI",
    cityWithStateAbbr: "Hilo, HI",
  },
  {
    zip: "96722",
    ST: "HI",
    cityWithStateAbbr: "Princeville, HI",
  },
  {
    zip: "96725",
    ST: "HI",
    cityWithStateAbbr: "Holualoa, HI",
  },
  {
    zip: "96726",
    ST: "HI",
    cityWithStateAbbr: "Honaunau, HI",
  },
  {
    zip: "96727",
    ST: "HI",
    cityWithStateAbbr: "Honokaa, HI",
  },
  {
    zip: "96728",
    ST: "HI",
    cityWithStateAbbr: "Honomu, HI",
  },
  {
    zip: "96729",
    ST: "HI",
    cityWithStateAbbr: "Hoolehua, HI",
  },
  {
    zip: "96730",
    ST: "HI",
    cityWithStateAbbr: "Kaaawa, HI",
  },
  {
    zip: "96731",
    ST: "HI",
    cityWithStateAbbr: "Kahuku, HI",
  },
  {
    zip: "96732",
    ST: "HI",
    cityWithStateAbbr: "Kahului, HI",
  },
  {
    zip: "96733",
    ST: "HI",
    cityWithStateAbbr: "Kahului, HI",
  },
  {
    zip: "96734",
    ST: "HI",
    cityWithStateAbbr: "Kailua, HI",
  },
  {
    zip: "96737",
    ST: "HI",
    cityWithStateAbbr: "Ocean View, HI",
  },
  {
    zip: "96738",
    ST: "HI",
    cityWithStateAbbr: "Waikoloa, HI",
  },
  {
    zip: "96739",
    ST: "HI",
    cityWithStateAbbr: "Keauhou, HI",
  },
  {
    zip: "96740",
    ST: "HI",
    cityWithStateAbbr: "Kailua Kona, HI",
  },
  {
    zip: "96741",
    ST: "HI",
    cityWithStateAbbr: "Kalaheo, HI",
  },
  {
    zip: "96742",
    ST: "HI",
    cityWithStateAbbr: "Kalaupapa, HI",
  },
  {
    zip: "96743",
    ST: "HI",
    cityWithStateAbbr: "Kamuela, HI",
  },
  {
    zip: "96744",
    ST: "HI",
    cityWithStateAbbr: "Kaneohe, HI",
  },
  {
    zip: "96745",
    ST: "HI",
    cityWithStateAbbr: "Kailua Kona, HI",
  },
  {
    zip: "96746",
    ST: "HI",
    cityWithStateAbbr: "Kapaa, HI",
  },
  {
    zip: "96747",
    ST: "HI",
    cityWithStateAbbr: "Kaumakani, HI",
  },
  {
    zip: "96748",
    ST: "HI",
    cityWithStateAbbr: "Kaunakakai, HI",
  },
  {
    zip: "96749",
    ST: "HI",
    cityWithStateAbbr: "Keaau, HI",
  },
  {
    zip: "96750",
    ST: "HI",
    cityWithStateAbbr: "Kealakekua, HI",
  },
  {
    zip: "96751",
    ST: "HI",
    cityWithStateAbbr: "Kealia, HI",
  },
  {
    zip: "96752",
    ST: "HI",
    cityWithStateAbbr: "Kekaha, HI",
  },
  {
    zip: "96753",
    ST: "HI",
    cityWithStateAbbr: "Kihei, HI",
  },
  {
    zip: "96754",
    ST: "HI",
    cityWithStateAbbr: "Kilauea, HI",
  },
  {
    zip: "96755",
    ST: "HI",
    cityWithStateAbbr: "Kapaau, HI",
  },
  {
    zip: "96756",
    ST: "HI",
    cityWithStateAbbr: "Koloa, HI",
  },
  {
    zip: "96757",
    ST: "HI",
    cityWithStateAbbr: "Kualapuu, HI",
  },
  {
    zip: "96759",
    ST: "HI",
    cityWithStateAbbr: "Kunia, HI",
  },
  {
    zip: "96760",
    ST: "HI",
    cityWithStateAbbr: "Kurtistown, HI",
  },
  {
    zip: "96761",
    ST: "HI",
    cityWithStateAbbr: "Lahaina, HI",
  },
  {
    zip: "96762",
    ST: "HI",
    cityWithStateAbbr: "Laie, HI",
  },
  {
    zip: "96763",
    ST: "HI",
    cityWithStateAbbr: "Lanai City, HI",
  },
  {
    zip: "96764",
    ST: "HI",
    cityWithStateAbbr: "Laupahoehoe, HI",
  },
  {
    zip: "96765",
    ST: "HI",
    cityWithStateAbbr: "Lawai, HI",
  },
  {
    zip: "96766",
    ST: "HI",
    cityWithStateAbbr: "Lihue, HI",
  },
  {
    zip: "96767",
    ST: "HI",
    cityWithStateAbbr: "Lahaina, HI",
  },
  {
    zip: "96768",
    ST: "HI",
    cityWithStateAbbr: "Makawao, HI",
  },
  {
    zip: "96769",
    ST: "HI",
    cityWithStateAbbr: "Makaweli, HI",
  },
  {
    zip: "96770",
    ST: "HI",
    cityWithStateAbbr: "Maunaloa, HI",
  },
  {
    zip: "96771",
    ST: "HI",
    cityWithStateAbbr: "Mountain View, HI",
  },
  {
    zip: "96772",
    ST: "HI",
    cityWithStateAbbr: "Naalehu, HI",
  },
  {
    zip: "96773",
    ST: "HI",
    cityWithStateAbbr: "Ninole, HI",
  },
  {
    zip: "96774",
    ST: "HI",
    cityWithStateAbbr: "Ookala, HI",
  },
  {
    zip: "96776",
    ST: "HI",
    cityWithStateAbbr: "Paauilo, HI",
  },
  {
    zip: "96777",
    ST: "HI",
    cityWithStateAbbr: "Pahala, HI",
  },
  {
    zip: "96778",
    ST: "HI",
    cityWithStateAbbr: "Pahoa, HI",
  },
  {
    zip: "96779",
    ST: "HI",
    cityWithStateAbbr: "Paia, HI",
  },
  {
    zip: "96780",
    ST: "HI",
    cityWithStateAbbr: "Papaaloa, HI",
  },
  {
    zip: "96781",
    ST: "HI",
    cityWithStateAbbr: "Papaikou, HI",
  },
  {
    zip: "96782",
    ST: "HI",
    cityWithStateAbbr: "Pearl City, HI",
  },
  {
    zip: "96783",
    ST: "HI",
    cityWithStateAbbr: "Pepeekeo, HI",
  },
  {
    zip: "96784",
    ST: "HI",
    cityWithStateAbbr: "Puunene, HI",
  },
  {
    zip: "96785",
    ST: "HI",
    cityWithStateAbbr: "Volcano, HI",
  },
  {
    zip: "96786",
    ST: "HI",
    cityWithStateAbbr: "Wahiawa, HI",
  },
  {
    zip: "96788",
    ST: "HI",
    cityWithStateAbbr: "Pukalani, HI",
  },
  {
    zip: "96789",
    ST: "HI",
    cityWithStateAbbr: "Mililani, HI",
  },
  {
    zip: "96790",
    ST: "HI",
    cityWithStateAbbr: "Kula, HI",
  },
  {
    zip: "96791",
    ST: "HI",
    cityWithStateAbbr: "Waialua, HI",
  },
  {
    zip: "96792",
    ST: "HI",
    cityWithStateAbbr: "Waianae, HI",
  },
  {
    zip: "96793",
    ST: "HI",
    cityWithStateAbbr: "Wailuku, HI",
  },
  {
    zip: "96795",
    ST: "HI",
    cityWithStateAbbr: "Waimanalo, HI",
  },
  {
    zip: "96796",
    ST: "HI",
    cityWithStateAbbr: "Waimea, HI",
  },
  {
    zip: "96797",
    ST: "HI",
    cityWithStateAbbr: "Waipahu, HI",
  },
  {
    zip: "96801",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96802",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96803",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96804",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96805",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96806",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96807",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96808",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96809",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96810",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96811",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96812",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96813",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96814",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96815",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96816",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96817",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96818",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96819",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96820",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96821",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96822",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96823",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96824",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96825",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96826",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96828",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96830",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96836",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96837",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96838",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96839",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96840",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96841",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96843",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96844",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96846",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96847",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96848",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96849",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96850",
    ST: "HI",
    cityWithStateAbbr: "Honolulu, HI",
  },
  {
    zip: "96853",
    ST: "HI",
    cityWithStateAbbr: "Jbphh, HI",
  },
  {
    zip: "96854",
    ST: "HI",
    cityWithStateAbbr: "Wheeler Army Airfield, HI",
  },
  {
    zip: "96857",
    ST: "HI",
    cityWithStateAbbr: "Schofield Barracks, HI",
  },
  {
    zip: "96858",
    ST: "HI",
    cityWithStateAbbr: "Fort Shafter, HI",
  },
  {
    zip: "96859",
    ST: "HI",
    cityWithStateAbbr: "Tripler Army Medical Cen, HI",
  },
  {
    zip: "96860",
    ST: "HI",
    cityWithStateAbbr: "Jbphh, HI",
  },
  {
    zip: "96861",
    ST: "HI",
    cityWithStateAbbr: "Camp H M Smith, HI",
  },
  {
    zip: "96863",
    ST: "HI",
    cityWithStateAbbr: "Mcbh Kaneohe Bay, HI",
  },
  {
    zip: "97001",
    ST: "OR",
    cityWithStateAbbr: "Antelope, OR",
  },
  {
    zip: "97002",
    ST: "OR",
    cityWithStateAbbr: "Aurora, OR",
  },
  {
    zip: "97003",
    ST: "OR",
    cityWithStateAbbr: "Beaverton, OR",
  },
  {
    zip: "97004",
    ST: "OR",
    cityWithStateAbbr: "Beavercreek, OR",
  },
  {
    zip: "97005",
    ST: "OR",
    cityWithStateAbbr: "Beaverton, OR",
  },
  {
    zip: "97006",
    ST: "OR",
    cityWithStateAbbr: "Beaverton, OR",
  },
  {
    zip: "97007",
    ST: "OR",
    cityWithStateAbbr: "Beaverton, OR",
  },
  {
    zip: "97008",
    ST: "OR",
    cityWithStateAbbr: "Beaverton, OR",
  },
  {
    zip: "97009",
    ST: "OR",
    cityWithStateAbbr: "Boring, OR",
  },
  {
    zip: "97010",
    ST: "OR",
    cityWithStateAbbr: "Bridal Veil, OR",
  },
  {
    zip: "97011",
    ST: "OR",
    cityWithStateAbbr: "Brightwood, OR",
  },
  {
    zip: "97013",
    ST: "OR",
    cityWithStateAbbr: "Canby, OR",
  },
  {
    zip: "97014",
    ST: "OR",
    cityWithStateAbbr: "Cascade Locks, OR",
  },
  {
    zip: "97015",
    ST: "OR",
    cityWithStateAbbr: "Clackamas, OR",
  },
  {
    zip: "97016",
    ST: "OR",
    cityWithStateAbbr: "Clatskanie, OR",
  },
  {
    zip: "97017",
    ST: "OR",
    cityWithStateAbbr: "Colton, OR",
  },
  {
    zip: "97018",
    ST: "OR",
    cityWithStateAbbr: "Columbia City, OR",
  },
  {
    zip: "97019",
    ST: "OR",
    cityWithStateAbbr: "Corbett, OR",
  },
  {
    zip: "97020",
    ST: "OR",
    cityWithStateAbbr: "Donald, OR",
  },
  {
    zip: "97021",
    ST: "OR",
    cityWithStateAbbr: "Dufur, OR",
  },
  {
    zip: "97022",
    ST: "OR",
    cityWithStateAbbr: "Eagle Creek, OR",
  },
  {
    zip: "97023",
    ST: "OR",
    cityWithStateAbbr: "Estacada, OR",
  },
  {
    zip: "97024",
    ST: "OR",
    cityWithStateAbbr: "Fairview, OR",
  },
  {
    zip: "97026",
    ST: "OR",
    cityWithStateAbbr: "Gervais, OR",
  },
  {
    zip: "97027",
    ST: "OR",
    cityWithStateAbbr: "Gladstone, OR",
  },
  {
    zip: "97028",
    ST: "OR",
    cityWithStateAbbr: "Government Camp, OR",
  },
  {
    zip: "97029",
    ST: "OR",
    cityWithStateAbbr: "Grass Valley, OR",
  },
  {
    zip: "97030",
    ST: "OR",
    cityWithStateAbbr: "Gresham, OR",
  },
  {
    zip: "97031",
    ST: "OR",
    cityWithStateAbbr: "Hood River, OR",
  },
  {
    zip: "97032",
    ST: "OR",
    cityWithStateAbbr: "Hubbard, OR",
  },
  {
    zip: "97033",
    ST: "OR",
    cityWithStateAbbr: "Kent, OR",
  },
  {
    zip: "97034",
    ST: "OR",
    cityWithStateAbbr: "Lake Oswego, OR",
  },
  {
    zip: "97035",
    ST: "OR",
    cityWithStateAbbr: "Lake Oswego, OR",
  },
  {
    zip: "97036",
    ST: "OR",
    cityWithStateAbbr: "Marylhurst, OR",
  },
  {
    zip: "97037",
    ST: "OR",
    cityWithStateAbbr: "Maupin, OR",
  },
  {
    zip: "97038",
    ST: "OR",
    cityWithStateAbbr: "Molalla, OR",
  },
  {
    zip: "97039",
    ST: "OR",
    cityWithStateAbbr: "Moro, OR",
  },
  {
    zip: "97040",
    ST: "OR",
    cityWithStateAbbr: "Mosier, OR",
  },
  {
    zip: "97041",
    ST: "OR",
    cityWithStateAbbr: "Mount Hood Parkdale, OR",
  },
  {
    zip: "97042",
    ST: "OR",
    cityWithStateAbbr: "Mulino, OR",
  },
  {
    zip: "97044",
    ST: "OR",
    cityWithStateAbbr: "Odell, OR",
  },
  {
    zip: "97045",
    ST: "OR",
    cityWithStateAbbr: "Oregon City, OR",
  },
  {
    zip: "97048",
    ST: "OR",
    cityWithStateAbbr: "Rainier, OR",
  },
  {
    zip: "97049",
    ST: "OR",
    cityWithStateAbbr: "Rhododendron, OR",
  },
  {
    zip: "97050",
    ST: "OR",
    cityWithStateAbbr: "Rufus, OR",
  },
  {
    zip: "97051",
    ST: "OR",
    cityWithStateAbbr: "Saint Helens, OR",
  },
  {
    zip: "97053",
    ST: "OR",
    cityWithStateAbbr: "Warren, OR",
  },
  {
    zip: "97054",
    ST: "OR",
    cityWithStateAbbr: "Deer Island, OR",
  },
  {
    zip: "97055",
    ST: "OR",
    cityWithStateAbbr: "Sandy, OR",
  },
  {
    zip: "97056",
    ST: "OR",
    cityWithStateAbbr: "Scappoose, OR",
  },
  {
    zip: "97057",
    ST: "OR",
    cityWithStateAbbr: "Shaniko, OR",
  },
  {
    zip: "97058",
    ST: "OR",
    cityWithStateAbbr: "The Dalles, OR",
  },
  {
    zip: "97060",
    ST: "OR",
    cityWithStateAbbr: "Troutdale, OR",
  },
  {
    zip: "97062",
    ST: "OR",
    cityWithStateAbbr: "Tualatin, OR",
  },
  {
    zip: "97063",
    ST: "OR",
    cityWithStateAbbr: "Tygh Valley, OR",
  },
  {
    zip: "97064",
    ST: "OR",
    cityWithStateAbbr: "Vernonia, OR",
  },
  {
    zip: "97065",
    ST: "OR",
    cityWithStateAbbr: "Wasco, OR",
  },
  {
    zip: "97067",
    ST: "OR",
    cityWithStateAbbr: "Welches, OR",
  },
  {
    zip: "97068",
    ST: "OR",
    cityWithStateAbbr: "West Linn, OR",
  },
  {
    zip: "97070",
    ST: "OR",
    cityWithStateAbbr: "Wilsonville, OR",
  },
  {
    zip: "97071",
    ST: "OR",
    cityWithStateAbbr: "Woodburn, OR",
  },
  {
    zip: "97075",
    ST: "OR",
    cityWithStateAbbr: "Beaverton, OR",
  },
  {
    zip: "97076",
    ST: "OR",
    cityWithStateAbbr: "Beaverton, OR",
  },
  {
    zip: "97077",
    ST: "OR",
    cityWithStateAbbr: "Beaverton, OR",
  },
  {
    zip: "97078",
    ST: "OR",
    cityWithStateAbbr: "Beaverton, OR",
  },
  {
    zip: "97080",
    ST: "OR",
    cityWithStateAbbr: "Gresham, OR",
  },
  {
    zip: "97086",
    ST: "OR",
    cityWithStateAbbr: "Happy Valley, OR",
  },
  {
    zip: "97089",
    ST: "OR",
    cityWithStateAbbr: "Damascus, OR",
  },
  {
    zip: "97101",
    ST: "OR",
    cityWithStateAbbr: "Amity, OR",
  },
  {
    zip: "97102",
    ST: "OR",
    cityWithStateAbbr: "Arch Cape, OR",
  },
  {
    zip: "97103",
    ST: "OR",
    cityWithStateAbbr: "Astoria, OR",
  },
  {
    zip: "97106",
    ST: "OR",
    cityWithStateAbbr: "Banks, OR",
  },
  {
    zip: "97107",
    ST: "OR",
    cityWithStateAbbr: "Bay City, OR",
  },
  {
    zip: "97108",
    ST: "OR",
    cityWithStateAbbr: "Beaver, OR",
  },
  {
    zip: "97109",
    ST: "OR",
    cityWithStateAbbr: "Buxton, OR",
  },
  {
    zip: "97110",
    ST: "OR",
    cityWithStateAbbr: "Cannon Beach, OR",
  },
  {
    zip: "97111",
    ST: "OR",
    cityWithStateAbbr: "Carlton, OR",
  },
  {
    zip: "97112",
    ST: "OR",
    cityWithStateAbbr: "Cloverdale, OR",
  },
  {
    zip: "97113",
    ST: "OR",
    cityWithStateAbbr: "Cornelius, OR",
  },
  {
    zip: "97114",
    ST: "OR",
    cityWithStateAbbr: "Dayton, OR",
  },
  {
    zip: "97115",
    ST: "OR",
    cityWithStateAbbr: "Dundee, OR",
  },
  {
    zip: "97116",
    ST: "OR",
    cityWithStateAbbr: "Forest Grove, OR",
  },
  {
    zip: "97117",
    ST: "OR",
    cityWithStateAbbr: "Gales Creek, OR",
  },
  {
    zip: "97118",
    ST: "OR",
    cityWithStateAbbr: "Garibaldi, OR",
  },
  {
    zip: "97119",
    ST: "OR",
    cityWithStateAbbr: "Gaston, OR",
  },
  {
    zip: "97121",
    ST: "OR",
    cityWithStateAbbr: "Hammond, OR",
  },
  {
    zip: "97122",
    ST: "OR",
    cityWithStateAbbr: "Hebo, OR",
  },
  {
    zip: "97123",
    ST: "OR",
    cityWithStateAbbr: "Hillsboro, OR",
  },
  {
    zip: "97124",
    ST: "OR",
    cityWithStateAbbr: "Hillsboro, OR",
  },
  {
    zip: "97125",
    ST: "OR",
    cityWithStateAbbr: "Manning, OR",
  },
  {
    zip: "97127",
    ST: "OR",
    cityWithStateAbbr: "Lafayette, OR",
  },
  {
    zip: "97128",
    ST: "OR",
    cityWithStateAbbr: "Mcminnville, OR",
  },
  {
    zip: "97130",
    ST: "OR",
    cityWithStateAbbr: "Manzanita, OR",
  },
  {
    zip: "97131",
    ST: "OR",
    cityWithStateAbbr: "Nehalem, OR",
  },
  {
    zip: "97132",
    ST: "OR",
    cityWithStateAbbr: "Newberg, OR",
  },
  {
    zip: "97133",
    ST: "OR",
    cityWithStateAbbr: "North Plains, OR",
  },
  {
    zip: "97134",
    ST: "OR",
    cityWithStateAbbr: "Oceanside, OR",
  },
  {
    zip: "97135",
    ST: "OR",
    cityWithStateAbbr: "Pacific City, OR",
  },
  {
    zip: "97136",
    ST: "OR",
    cityWithStateAbbr: "Rockaway Beach, OR",
  },
  {
    zip: "97137",
    ST: "OR",
    cityWithStateAbbr: "Saint Paul, OR",
  },
  {
    zip: "97138",
    ST: "OR",
    cityWithStateAbbr: "Seaside, OR",
  },
  {
    zip: "97140",
    ST: "OR",
    cityWithStateAbbr: "Sherwood, OR",
  },
  {
    zip: "97141",
    ST: "OR",
    cityWithStateAbbr: "Tillamook, OR",
  },
  {
    zip: "97143",
    ST: "OR",
    cityWithStateAbbr: "Netarts, OR",
  },
  {
    zip: "97144",
    ST: "OR",
    cityWithStateAbbr: "Timber, OR",
  },
  {
    zip: "97145",
    ST: "OR",
    cityWithStateAbbr: "Tolovana Park, OR",
  },
  {
    zip: "97146",
    ST: "OR",
    cityWithStateAbbr: "Warrenton, OR",
  },
  {
    zip: "97147",
    ST: "OR",
    cityWithStateAbbr: "Wheeler, OR",
  },
  {
    zip: "97148",
    ST: "OR",
    cityWithStateAbbr: "Yamhill, OR",
  },
  {
    zip: "97149",
    ST: "OR",
    cityWithStateAbbr: "Neskowin, OR",
  },
  {
    zip: "97201",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97202",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97203",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97204",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97205",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97206",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97207",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97208",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97209",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97210",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97211",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97212",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97213",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97214",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97215",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97216",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97217",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97218",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97219",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97220",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97221",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97222",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97223",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97224",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97225",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97227",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97228",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97229",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97230",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97231",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97232",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97233",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97236",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97238",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97239",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97240",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97242",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97256",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97258",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97266",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97267",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97268",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97269",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97280",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97281",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97282",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97283",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97286",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97290",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97291",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97292",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97293",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97294",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97296",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97298",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97299",
    ST: "OR",
    cityWithStateAbbr: "Portland, OR",
  },
  {
    zip: "97301",
    ST: "OR",
    cityWithStateAbbr: "Salem, OR",
  },
  {
    zip: "97302",
    ST: "OR",
    cityWithStateAbbr: "Salem, OR",
  },
  {
    zip: "97303",
    ST: "OR",
    cityWithStateAbbr: "Salem, OR",
  },
  {
    zip: "97304",
    ST: "OR",
    cityWithStateAbbr: "Salem, OR",
  },
  {
    zip: "97305",
    ST: "OR",
    cityWithStateAbbr: "Salem, OR",
  },
  {
    zip: "97306",
    ST: "OR",
    cityWithStateAbbr: "Salem, OR",
  },
  {
    zip: "97307",
    ST: "OR",
    cityWithStateAbbr: "Keizer, OR",
  },
  {
    zip: "97308",
    ST: "OR",
    cityWithStateAbbr: "Salem, OR",
  },
  {
    zip: "97309",
    ST: "OR",
    cityWithStateAbbr: "Salem, OR",
  },
  {
    zip: "97310",
    ST: "OR",
    cityWithStateAbbr: "Salem, OR",
  },
  {
    zip: "97311",
    ST: "OR",
    cityWithStateAbbr: "Salem, OR",
  },
  {
    zip: "97312",
    ST: "OR",
    cityWithStateAbbr: "Salem, OR",
  },
  {
    zip: "97314",
    ST: "OR",
    cityWithStateAbbr: "Salem, OR",
  },
  {
    zip: "97317",
    ST: "OR",
    cityWithStateAbbr: "Salem, OR",
  },
  {
    zip: "97321",
    ST: "OR",
    cityWithStateAbbr: "Albany, OR",
  },
  {
    zip: "97322",
    ST: "OR",
    cityWithStateAbbr: "Albany, OR",
  },
  {
    zip: "97324",
    ST: "OR",
    cityWithStateAbbr: "Alsea, OR",
  },
  {
    zip: "97325",
    ST: "OR",
    cityWithStateAbbr: "Aumsville, OR",
  },
  {
    zip: "97326",
    ST: "OR",
    cityWithStateAbbr: "Blodgett, OR",
  },
  {
    zip: "97327",
    ST: "OR",
    cityWithStateAbbr: "Brownsville, OR",
  },
  {
    zip: "97329",
    ST: "OR",
    cityWithStateAbbr: "Cascadia, OR",
  },
  {
    zip: "97330",
    ST: "OR",
    cityWithStateAbbr: "Corvallis, OR",
  },
  {
    zip: "97331",
    ST: "OR",
    cityWithStateAbbr: "Corvallis, OR",
  },
  {
    zip: "97333",
    ST: "OR",
    cityWithStateAbbr: "Corvallis, OR",
  },
  {
    zip: "97335",
    ST: "OR",
    cityWithStateAbbr: "Crabtree, OR",
  },
  {
    zip: "97336",
    ST: "OR",
    cityWithStateAbbr: "Crawfordsville, OR",
  },
  {
    zip: "97338",
    ST: "OR",
    cityWithStateAbbr: "Dallas, OR",
  },
  {
    zip: "97339",
    ST: "OR",
    cityWithStateAbbr: "Corvallis, OR",
  },
  {
    zip: "97341",
    ST: "OR",
    cityWithStateAbbr: "Depoe Bay, OR",
  },
  {
    zip: "97342",
    ST: "OR",
    cityWithStateAbbr: "Detroit, OR",
  },
  {
    zip: "97343",
    ST: "OR",
    cityWithStateAbbr: "Eddyville, OR",
  },
  {
    zip: "97344",
    ST: "OR",
    cityWithStateAbbr: "Falls City, OR",
  },
  {
    zip: "97345",
    ST: "OR",
    cityWithStateAbbr: "Foster, OR",
  },
  {
    zip: "97346",
    ST: "OR",
    cityWithStateAbbr: "Gates, OR",
  },
  {
    zip: "97347",
    ST: "OR",
    cityWithStateAbbr: "Grand Ronde, OR",
  },
  {
    zip: "97348",
    ST: "OR",
    cityWithStateAbbr: "Halsey, OR",
  },
  {
    zip: "97350",
    ST: "OR",
    cityWithStateAbbr: "Idanha, OR",
  },
  {
    zip: "97351",
    ST: "OR",
    cityWithStateAbbr: "Independence, OR",
  },
  {
    zip: "97352",
    ST: "OR",
    cityWithStateAbbr: "Jefferson, OR",
  },
  {
    zip: "97355",
    ST: "OR",
    cityWithStateAbbr: "Lebanon, OR",
  },
  {
    zip: "97357",
    ST: "OR",
    cityWithStateAbbr: "Logsden, OR",
  },
  {
    zip: "97358",
    ST: "OR",
    cityWithStateAbbr: "Lyons, OR",
  },
  {
    zip: "97360",
    ST: "OR",
    cityWithStateAbbr: "Mill City, OR",
  },
  {
    zip: "97361",
    ST: "OR",
    cityWithStateAbbr: "Monmouth, OR",
  },
  {
    zip: "97362",
    ST: "OR",
    cityWithStateAbbr: "Mount Angel, OR",
  },
  {
    zip: "97364",
    ST: "OR",
    cityWithStateAbbr: "Neotsu, OR",
  },
  {
    zip: "97365",
    ST: "OR",
    cityWithStateAbbr: "Newport, OR",
  },
  {
    zip: "97366",
    ST: "OR",
    cityWithStateAbbr: "South Beach, OR",
  },
  {
    zip: "97367",
    ST: "OR",
    cityWithStateAbbr: "Lincoln City, OR",
  },
  {
    zip: "97368",
    ST: "OR",
    cityWithStateAbbr: "Otis, OR",
  },
  {
    zip: "97369",
    ST: "OR",
    cityWithStateAbbr: "Otter Rock, OR",
  },
  {
    zip: "97370",
    ST: "OR",
    cityWithStateAbbr: "Philomath, OR",
  },
  {
    zip: "97371",
    ST: "OR",
    cityWithStateAbbr: "Rickreall, OR",
  },
  {
    zip: "97373",
    ST: "OR",
    cityWithStateAbbr: "Saint Benedict, OR",
  },
  {
    zip: "97374",
    ST: "OR",
    cityWithStateAbbr: "Scio, OR",
  },
  {
    zip: "97375",
    ST: "OR",
    cityWithStateAbbr: "Scotts Mills, OR",
  },
  {
    zip: "97376",
    ST: "OR",
    cityWithStateAbbr: "Seal Rock, OR",
  },
  {
    zip: "97377",
    ST: "OR",
    cityWithStateAbbr: "Shedd, OR",
  },
  {
    zip: "97378",
    ST: "OR",
    cityWithStateAbbr: "Sheridan, OR",
  },
  {
    zip: "97380",
    ST: "OR",
    cityWithStateAbbr: "Siletz, OR",
  },
  {
    zip: "97381",
    ST: "OR",
    cityWithStateAbbr: "Silverton, OR",
  },
  {
    zip: "97383",
    ST: "OR",
    cityWithStateAbbr: "Stayton, OR",
  },
  {
    zip: "97384",
    ST: "OR",
    cityWithStateAbbr: "Mehama, OR",
  },
  {
    zip: "97385",
    ST: "OR",
    cityWithStateAbbr: "Sublimity, OR",
  },
  {
    zip: "97386",
    ST: "OR",
    cityWithStateAbbr: "Sweet Home, OR",
  },
  {
    zip: "97388",
    ST: "OR",
    cityWithStateAbbr: "Gleneden Beach, OR",
  },
  {
    zip: "97389",
    ST: "OR",
    cityWithStateAbbr: "Tangent, OR",
  },
  {
    zip: "97390",
    ST: "OR",
    cityWithStateAbbr: "Tidewater, OR",
  },
  {
    zip: "97391",
    ST: "OR",
    cityWithStateAbbr: "Toledo, OR",
  },
  {
    zip: "97392",
    ST: "OR",
    cityWithStateAbbr: "Turner, OR",
  },
  {
    zip: "97394",
    ST: "OR",
    cityWithStateAbbr: "Waldport, OR",
  },
  {
    zip: "97396",
    ST: "OR",
    cityWithStateAbbr: "Willamina, OR",
  },
  {
    zip: "97401",
    ST: "OR",
    cityWithStateAbbr: "Eugene, OR",
  },
  {
    zip: "97402",
    ST: "OR",
    cityWithStateAbbr: "Eugene, OR",
  },
  {
    zip: "97403",
    ST: "OR",
    cityWithStateAbbr: "Eugene, OR",
  },
  {
    zip: "97404",
    ST: "OR",
    cityWithStateAbbr: "Eugene, OR",
  },
  {
    zip: "97405",
    ST: "OR",
    cityWithStateAbbr: "Eugene, OR",
  },
  {
    zip: "97406",
    ST: "OR",
    cityWithStateAbbr: "Agness, OR",
  },
  {
    zip: "97407",
    ST: "OR",
    cityWithStateAbbr: "Allegany, OR",
  },
  {
    zip: "97408",
    ST: "OR",
    cityWithStateAbbr: "Eugene, OR",
  },
  {
    zip: "97409",
    ST: "OR",
    cityWithStateAbbr: "Alvadore, OR",
  },
  {
    zip: "97410",
    ST: "OR",
    cityWithStateAbbr: "Azalea, OR",
  },
  {
    zip: "97411",
    ST: "OR",
    cityWithStateAbbr: "Bandon, OR",
  },
  {
    zip: "97412",
    ST: "OR",
    cityWithStateAbbr: "Blachly, OR",
  },
  {
    zip: "97413",
    ST: "OR",
    cityWithStateAbbr: "Blue River, OR",
  },
  {
    zip: "97414",
    ST: "OR",
    cityWithStateAbbr: "Broadbent, OR",
  },
  {
    zip: "97415",
    ST: "OR",
    cityWithStateAbbr: "Brookings, OR",
  },
  {
    zip: "97416",
    ST: "OR",
    cityWithStateAbbr: "Camas Valley, OR",
  },
  {
    zip: "97417",
    ST: "OR",
    cityWithStateAbbr: "Canyonville, OR",
  },
  {
    zip: "97419",
    ST: "OR",
    cityWithStateAbbr: "Cheshire, OR",
  },
  {
    zip: "97420",
    ST: "OR",
    cityWithStateAbbr: "Coos Bay, OR",
  },
  {
    zip: "97423",
    ST: "OR",
    cityWithStateAbbr: "Coquille, OR",
  },
  {
    zip: "97424",
    ST: "OR",
    cityWithStateAbbr: "Cottage Grove, OR",
  },
  {
    zip: "97425",
    ST: "OR",
    cityWithStateAbbr: "Crescent, OR",
  },
  {
    zip: "97426",
    ST: "OR",
    cityWithStateAbbr: "Creswell, OR",
  },
  {
    zip: "97427",
    ST: "OR",
    cityWithStateAbbr: "Dorena, OR",
  },
  {
    zip: "97429",
    ST: "OR",
    cityWithStateAbbr: "Days Creek, OR",
  },
  {
    zip: "97430",
    ST: "OR",
    cityWithStateAbbr: "Deadwood, OR",
  },
  {
    zip: "97431",
    ST: "OR",
    cityWithStateAbbr: "Dexter, OR",
  },
  {
    zip: "97432",
    ST: "OR",
    cityWithStateAbbr: "Dillard, OR",
  },
  {
    zip: "97434",
    ST: "OR",
    cityWithStateAbbr: "Dorena, OR",
  },
  {
    zip: "97435",
    ST: "OR",
    cityWithStateAbbr: "Drain, OR",
  },
  {
    zip: "97436",
    ST: "OR",
    cityWithStateAbbr: "Elkton, OR",
  },
  {
    zip: "97437",
    ST: "OR",
    cityWithStateAbbr: "Elmira, OR",
  },
  {
    zip: "97438",
    ST: "OR",
    cityWithStateAbbr: "Fall Creek, OR",
  },
  {
    zip: "97439",
    ST: "OR",
    cityWithStateAbbr: "Florence, OR",
  },
  {
    zip: "97440",
    ST: "OR",
    cityWithStateAbbr: "Eugene, OR",
  },
  {
    zip: "97441",
    ST: "OR",
    cityWithStateAbbr: "Gardiner, OR",
  },
  {
    zip: "97442",
    ST: "OR",
    cityWithStateAbbr: "Glendale, OR",
  },
  {
    zip: "97443",
    ST: "OR",
    cityWithStateAbbr: "Glide, OR",
  },
  {
    zip: "97444",
    ST: "OR",
    cityWithStateAbbr: "Gold Beach, OR",
  },
  {
    zip: "97446",
    ST: "OR",
    cityWithStateAbbr: "Harrisburg, OR",
  },
  {
    zip: "97447",
    ST: "OR",
    cityWithStateAbbr: "Idleyld Park, OR",
  },
  {
    zip: "97448",
    ST: "OR",
    cityWithStateAbbr: "Junction City, OR",
  },
  {
    zip: "97449",
    ST: "OR",
    cityWithStateAbbr: "Lakeside, OR",
  },
  {
    zip: "97450",
    ST: "OR",
    cityWithStateAbbr: "Langlois, OR",
  },
  {
    zip: "97451",
    ST: "OR",
    cityWithStateAbbr: "Lorane, OR",
  },
  {
    zip: "97452",
    ST: "OR",
    cityWithStateAbbr: "Lowell, OR",
  },
  {
    zip: "97453",
    ST: "OR",
    cityWithStateAbbr: "Mapleton, OR",
  },
  {
    zip: "97454",
    ST: "OR",
    cityWithStateAbbr: "Marcola, OR",
  },
  {
    zip: "97455",
    ST: "OR",
    cityWithStateAbbr: "Pleasant Hill, OR",
  },
  {
    zip: "97456",
    ST: "OR",
    cityWithStateAbbr: "Monroe, OR",
  },
  {
    zip: "97457",
    ST: "OR",
    cityWithStateAbbr: "Myrtle Creek, OR",
  },
  {
    zip: "97458",
    ST: "OR",
    cityWithStateAbbr: "Myrtle Point, OR",
  },
  {
    zip: "97459",
    ST: "OR",
    cityWithStateAbbr: "North Bend, OR",
  },
  {
    zip: "97461",
    ST: "OR",
    cityWithStateAbbr: "Noti, OR",
  },
  {
    zip: "97462",
    ST: "OR",
    cityWithStateAbbr: "Oakland, OR",
  },
  {
    zip: "97463",
    ST: "OR",
    cityWithStateAbbr: "Oakridge, OR",
  },
  {
    zip: "97464",
    ST: "OR",
    cityWithStateAbbr: "Ophir, OR",
  },
  {
    zip: "97465",
    ST: "OR",
    cityWithStateAbbr: "Port Orford, OR",
  },
  {
    zip: "97466",
    ST: "OR",
    cityWithStateAbbr: "Powers, OR",
  },
  {
    zip: "97467",
    ST: "OR",
    cityWithStateAbbr: "Reedsport, OR",
  },
  {
    zip: "97469",
    ST: "OR",
    cityWithStateAbbr: "Riddle, OR",
  },
  {
    zip: "97470",
    ST: "OR",
    cityWithStateAbbr: "Roseburg, OR",
  },
  {
    zip: "97471",
    ST: "OR",
    cityWithStateAbbr: "Roseburg, OR",
  },
  {
    zip: "97473",
    ST: "OR",
    cityWithStateAbbr: "Scottsburg, OR",
  },
  {
    zip: "97476",
    ST: "OR",
    cityWithStateAbbr: "Sixes, OR",
  },
  {
    zip: "97477",
    ST: "OR",
    cityWithStateAbbr: "Springfield, OR",
  },
  {
    zip: "97478",
    ST: "OR",
    cityWithStateAbbr: "Springfield, OR",
  },
  {
    zip: "97479",
    ST: "OR",
    cityWithStateAbbr: "Sutherlin, OR",
  },
  {
    zip: "97480",
    ST: "OR",
    cityWithStateAbbr: "Swisshome, OR",
  },
  {
    zip: "97481",
    ST: "OR",
    cityWithStateAbbr: "Tenmile, OR",
  },
  {
    zip: "97482",
    ST: "OR",
    cityWithStateAbbr: "Thurston, OR",
  },
  {
    zip: "97484",
    ST: "OR",
    cityWithStateAbbr: "Tiller, OR",
  },
  {
    zip: "97486",
    ST: "OR",
    cityWithStateAbbr: "Umpqua, OR",
  },
  {
    zip: "97487",
    ST: "OR",
    cityWithStateAbbr: "Veneta, OR",
  },
  {
    zip: "97488",
    ST: "OR",
    cityWithStateAbbr: "Vida, OR",
  },
  {
    zip: "97489",
    ST: "OR",
    cityWithStateAbbr: "Walterville, OR",
  },
  {
    zip: "97490",
    ST: "OR",
    cityWithStateAbbr: "Walton, OR",
  },
  {
    zip: "97491",
    ST: "OR",
    cityWithStateAbbr: "Wedderburn, OR",
  },
  {
    zip: "97492",
    ST: "OR",
    cityWithStateAbbr: "Westfir, OR",
  },
  {
    zip: "97493",
    ST: "OR",
    cityWithStateAbbr: "Westlake, OR",
  },
  {
    zip: "97494",
    ST: "OR",
    cityWithStateAbbr: "Wilbur, OR",
  },
  {
    zip: "97495",
    ST: "OR",
    cityWithStateAbbr: "Winchester, OR",
  },
  {
    zip: "97496",
    ST: "OR",
    cityWithStateAbbr: "Winston, OR",
  },
  {
    zip: "97497",
    ST: "OR",
    cityWithStateAbbr: "Wolf Creek, OR",
  },
  {
    zip: "97498",
    ST: "OR",
    cityWithStateAbbr: "Yachats, OR",
  },
  {
    zip: "97499",
    ST: "OR",
    cityWithStateAbbr: "Yoncalla, OR",
  },
  {
    zip: "97501",
    ST: "OR",
    cityWithStateAbbr: "Medford, OR",
  },
  {
    zip: "97502",
    ST: "OR",
    cityWithStateAbbr: "Central Point, OR",
  },
  {
    zip: "97503",
    ST: "OR",
    cityWithStateAbbr: "White City, OR",
  },
  {
    zip: "97504",
    ST: "OR",
    cityWithStateAbbr: "Medford, OR",
  },
  {
    zip: "97520",
    ST: "OR",
    cityWithStateAbbr: "Ashland, OR",
  },
  {
    zip: "97522",
    ST: "OR",
    cityWithStateAbbr: "Butte Falls, OR",
  },
  {
    zip: "97523",
    ST: "OR",
    cityWithStateAbbr: "Cave Junction, OR",
  },
  {
    zip: "97524",
    ST: "OR",
    cityWithStateAbbr: "Eagle Point, OR",
  },
  {
    zip: "97525",
    ST: "OR",
    cityWithStateAbbr: "Gold Hill, OR",
  },
  {
    zip: "97526",
    ST: "OR",
    cityWithStateAbbr: "Grants Pass, OR",
  },
  {
    zip: "97527",
    ST: "OR",
    cityWithStateAbbr: "Grants Pass, OR",
  },
  {
    zip: "97528",
    ST: "OR",
    cityWithStateAbbr: "Grants Pass, OR",
  },
  {
    zip: "97530",
    ST: "OR",
    cityWithStateAbbr: "Jacksonville, OR",
  },
  {
    zip: "97531",
    ST: "OR",
    cityWithStateAbbr: "Kerby, OR",
  },
  {
    zip: "97532",
    ST: "OR",
    cityWithStateAbbr: "Merlin, OR",
  },
  {
    zip: "97533",
    ST: "OR",
    cityWithStateAbbr: "Murphy, OR",
  },
  {
    zip: "97534",
    ST: "OR",
    cityWithStateAbbr: "O Brien, OR",
  },
  {
    zip: "97535",
    ST: "OR",
    cityWithStateAbbr: "Phoenix, OR",
  },
  {
    zip: "97536",
    ST: "OR",
    cityWithStateAbbr: "Prospect, OR",
  },
  {
    zip: "97537",
    ST: "OR",
    cityWithStateAbbr: "Rogue River, OR",
  },
  {
    zip: "97538",
    ST: "OR",
    cityWithStateAbbr: "Selma, OR",
  },
  {
    zip: "97539",
    ST: "OR",
    cityWithStateAbbr: "Shady Cove, OR",
  },
  {
    zip: "97540",
    ST: "OR",
    cityWithStateAbbr: "Talent, OR",
  },
  {
    zip: "97541",
    ST: "OR",
    cityWithStateAbbr: "Trail, OR",
  },
  {
    zip: "97543",
    ST: "OR",
    cityWithStateAbbr: "Wilderville, OR",
  },
  {
    zip: "97544",
    ST: "OR",
    cityWithStateAbbr: "Williams, OR",
  },
  {
    zip: "97601",
    ST: "OR",
    cityWithStateAbbr: "Klamath Falls, OR",
  },
  {
    zip: "97602",
    ST: "OR",
    cityWithStateAbbr: "Klamath Falls, OR",
  },
  {
    zip: "97603",
    ST: "OR",
    cityWithStateAbbr: "Klamath Falls, OR",
  },
  {
    zip: "97604",
    ST: "OR",
    cityWithStateAbbr: "Crater Lake, OR",
  },
  {
    zip: "97620",
    ST: "OR",
    cityWithStateAbbr: "Adel, OR",
  },
  {
    zip: "97621",
    ST: "OR",
    cityWithStateAbbr: "Beatty, OR",
  },
  {
    zip: "97622",
    ST: "OR",
    cityWithStateAbbr: "Bly, OR",
  },
  {
    zip: "97623",
    ST: "OR",
    cityWithStateAbbr: "Bonanza, OR",
  },
  {
    zip: "97624",
    ST: "OR",
    cityWithStateAbbr: "Chiloquin, OR",
  },
  {
    zip: "97625",
    ST: "OR",
    cityWithStateAbbr: "Dairy, OR",
  },
  {
    zip: "97626",
    ST: "OR",
    cityWithStateAbbr: "Fort Klamath, OR",
  },
  {
    zip: "97627",
    ST: "OR",
    cityWithStateAbbr: "Keno, OR",
  },
  {
    zip: "97630",
    ST: "OR",
    cityWithStateAbbr: "Lakeview, OR",
  },
  {
    zip: "97632",
    ST: "OR",
    cityWithStateAbbr: "Malin, OR",
  },
  {
    zip: "97633",
    ST: "OR",
    cityWithStateAbbr: "Merrill, OR",
  },
  {
    zip: "97634",
    ST: "OR",
    cityWithStateAbbr: "Midland, OR",
  },
  {
    zip: "97635",
    ST: "CA",
    cityWithStateAbbr: "New Pine Creek, CA",
  },
  {
    zip: "97636",
    ST: "OR",
    cityWithStateAbbr: "Paisley, OR",
  },
  {
    zip: "97637",
    ST: "OR",
    cityWithStateAbbr: "Plush, OR",
  },
  {
    zip: "97638",
    ST: "OR",
    cityWithStateAbbr: "Silver Lake, OR",
  },
  {
    zip: "97639",
    ST: "OR",
    cityWithStateAbbr: "Sprague River, OR",
  },
  {
    zip: "97640",
    ST: "OR",
    cityWithStateAbbr: "Summer Lake, OR",
  },
  {
    zip: "97641",
    ST: "OR",
    cityWithStateAbbr: "Christmas Valley, OR",
  },
  {
    zip: "97701",
    ST: "OR",
    cityWithStateAbbr: "Bend, OR",
  },
  {
    zip: "97702",
    ST: "OR",
    cityWithStateAbbr: "Bend, OR",
  },
  {
    zip: "97703",
    ST: "OR",
    cityWithStateAbbr: "Bend, OR",
  },
  {
    zip: "97707",
    ST: "OR",
    cityWithStateAbbr: "Bend, OR",
  },
  {
    zip: "97708",
    ST: "OR",
    cityWithStateAbbr: "Bend, OR",
  },
  {
    zip: "97709",
    ST: "OR",
    cityWithStateAbbr: "Bend, OR",
  },
  {
    zip: "97710",
    ST: "OR",
    cityWithStateAbbr: "Fields, OR",
  },
  {
    zip: "97711",
    ST: "OR",
    cityWithStateAbbr: "Ashwood, OR",
  },
  {
    zip: "97712",
    ST: "OR",
    cityWithStateAbbr: "Brothers, OR",
  },
  {
    zip: "97720",
    ST: "OR",
    cityWithStateAbbr: "Burns, OR",
  },
  {
    zip: "97721",
    ST: "OR",
    cityWithStateAbbr: "Princeton, OR",
  },
  {
    zip: "97722",
    ST: "OR",
    cityWithStateAbbr: "Diamond, OR",
  },
  {
    zip: "97730",
    ST: "OR",
    cityWithStateAbbr: "Camp Sherman, OR",
  },
  {
    zip: "97731",
    ST: "OR",
    cityWithStateAbbr: "Chemult, OR",
  },
  {
    zip: "97732",
    ST: "OR",
    cityWithStateAbbr: "Crane, OR",
  },
  {
    zip: "97733",
    ST: "OR",
    cityWithStateAbbr: "Crescent, OR",
  },
  {
    zip: "97734",
    ST: "OR",
    cityWithStateAbbr: "Culver, OR",
  },
  {
    zip: "97735",
    ST: "OR",
    cityWithStateAbbr: "Fort Rock, OR",
  },
  {
    zip: "97736",
    ST: "OR",
    cityWithStateAbbr: "Frenchglen, OR",
  },
  {
    zip: "97737",
    ST: "OR",
    cityWithStateAbbr: "Gilchrist, OR",
  },
  {
    zip: "97738",
    ST: "OR",
    cityWithStateAbbr: "Hines, OR",
  },
  {
    zip: "97739",
    ST: "OR",
    cityWithStateAbbr: "La Pine, OR",
  },
  {
    zip: "97741",
    ST: "OR",
    cityWithStateAbbr: "Madras, OR",
  },
  {
    zip: "97750",
    ST: "OR",
    cityWithStateAbbr: "Mitchell, OR",
  },
  {
    zip: "97751",
    ST: "OR",
    cityWithStateAbbr: "Paulina, OR",
  },
  {
    zip: "97752",
    ST: "OR",
    cityWithStateAbbr: "Post, OR",
  },
  {
    zip: "97753",
    ST: "OR",
    cityWithStateAbbr: "Powell Butte, OR",
  },
  {
    zip: "97754",
    ST: "OR",
    cityWithStateAbbr: "Prineville, OR",
  },
  {
    zip: "97756",
    ST: "OR",
    cityWithStateAbbr: "Redmond, OR",
  },
  {
    zip: "97758",
    ST: "OR",
    cityWithStateAbbr: "Riley, OR",
  },
  {
    zip: "97759",
    ST: "OR",
    cityWithStateAbbr: "Sisters, OR",
  },
  {
    zip: "97760",
    ST: "OR",
    cityWithStateAbbr: "Terrebonne, OR",
  },
  {
    zip: "97761",
    ST: "OR",
    cityWithStateAbbr: "Warm Springs, OR",
  },
  {
    zip: "97801",
    ST: "OR",
    cityWithStateAbbr: "Pendleton, OR",
  },
  {
    zip: "97810",
    ST: "OR",
    cityWithStateAbbr: "Adams, OR",
  },
  {
    zip: "97812",
    ST: "OR",
    cityWithStateAbbr: "Arlington, OR",
  },
  {
    zip: "97813",
    ST: "OR",
    cityWithStateAbbr: "Athena, OR",
  },
  {
    zip: "97814",
    ST: "OR",
    cityWithStateAbbr: "Baker City, OR",
  },
  {
    zip: "97817",
    ST: "OR",
    cityWithStateAbbr: "Bates, OR",
  },
  {
    zip: "97818",
    ST: "OR",
    cityWithStateAbbr: "Boardman, OR",
  },
  {
    zip: "97819",
    ST: "OR",
    cityWithStateAbbr: "Bridgeport, OR",
  },
  {
    zip: "97820",
    ST: "OR",
    cityWithStateAbbr: "Canyon City, OR",
  },
  {
    zip: "97823",
    ST: "OR",
    cityWithStateAbbr: "Condon, OR",
  },
  {
    zip: "97824",
    ST: "OR",
    cityWithStateAbbr: "Cove, OR",
  },
  {
    zip: "97825",
    ST: "OR",
    cityWithStateAbbr: "Dayville, OR",
  },
  {
    zip: "97826",
    ST: "OR",
    cityWithStateAbbr: "Echo, OR",
  },
  {
    zip: "97827",
    ST: "OR",
    cityWithStateAbbr: "Elgin, OR",
  },
  {
    zip: "97828",
    ST: "OR",
    cityWithStateAbbr: "Enterprise, OR",
  },
  {
    zip: "97830",
    ST: "OR",
    cityWithStateAbbr: "Fossil, OR",
  },
  {
    zip: "97833",
    ST: "OR",
    cityWithStateAbbr: "Haines, OR",
  },
  {
    zip: "97834",
    ST: "OR",
    cityWithStateAbbr: "Halfway, OR",
  },
  {
    zip: "97835",
    ST: "OR",
    cityWithStateAbbr: "Helix, OR",
  },
  {
    zip: "97836",
    ST: "OR",
    cityWithStateAbbr: "Heppner, OR",
  },
  {
    zip: "97837",
    ST: "OR",
    cityWithStateAbbr: "Hereford, OR",
  },
  {
    zip: "97838",
    ST: "OR",
    cityWithStateAbbr: "Hermiston, OR",
  },
  {
    zip: "97839",
    ST: "OR",
    cityWithStateAbbr: "Lexington, OR",
  },
  {
    zip: "97840",
    ST: "OR",
    cityWithStateAbbr: "Oxbow, OR",
  },
  {
    zip: "97841",
    ST: "OR",
    cityWithStateAbbr: "Imbler, OR",
  },
  {
    zip: "97842",
    ST: "OR",
    cityWithStateAbbr: "Imnaha, OR",
  },
  {
    zip: "97843",
    ST: "OR",
    cityWithStateAbbr: "Ione, OR",
  },
  {
    zip: "97844",
    ST: "OR",
    cityWithStateAbbr: "Irrigon, OR",
  },
  {
    zip: "97845",
    ST: "OR",
    cityWithStateAbbr: "John Day, OR",
  },
  {
    zip: "97846",
    ST: "OR",
    cityWithStateAbbr: "Joseph, OR",
  },
  {
    zip: "97848",
    ST: "OR",
    cityWithStateAbbr: "Kimberly, OR",
  },
  {
    zip: "97850",
    ST: "OR",
    cityWithStateAbbr: "La Grande, OR",
  },
  {
    zip: "97856",
    ST: "OR",
    cityWithStateAbbr: "Long Creek, OR",
  },
  {
    zip: "97857",
    ST: "OR",
    cityWithStateAbbr: "Lostine, OR",
  },
  {
    zip: "97859",
    ST: "OR",
    cityWithStateAbbr: "Meacham, OR",
  },
  {
    zip: "97861",
    ST: "OR",
    cityWithStateAbbr: "Mikkalo, OR",
  },
  {
    zip: "97862",
    ST: "OR",
    cityWithStateAbbr: "Milton Freewater, OR",
  },
  {
    zip: "97864",
    ST: "OR",
    cityWithStateAbbr: "Monument, OR",
  },
  {
    zip: "97865",
    ST: "OR",
    cityWithStateAbbr: "Mount Vernon, OR",
  },
  {
    zip: "97867",
    ST: "OR",
    cityWithStateAbbr: "North Powder, OR",
  },
  {
    zip: "97868",
    ST: "OR",
    cityWithStateAbbr: "Pilot Rock, OR",
  },
  {
    zip: "97869",
    ST: "OR",
    cityWithStateAbbr: "Prairie City, OR",
  },
  {
    zip: "97870",
    ST: "OR",
    cityWithStateAbbr: "Richland, OR",
  },
  {
    zip: "97873",
    ST: "OR",
    cityWithStateAbbr: "Seneca, OR",
  },
  {
    zip: "97874",
    ST: "OR",
    cityWithStateAbbr: "Spray, OR",
  },
  {
    zip: "97875",
    ST: "OR",
    cityWithStateAbbr: "Stanfield, OR",
  },
  {
    zip: "97876",
    ST: "OR",
    cityWithStateAbbr: "Summerville, OR",
  },
  {
    zip: "97877",
    ST: "OR",
    cityWithStateAbbr: "Sumpter, OR",
  },
  {
    zip: "97880",
    ST: "OR",
    cityWithStateAbbr: "Ukiah, OR",
  },
  {
    zip: "97882",
    ST: "OR",
    cityWithStateAbbr: "Umatilla, OR",
  },
  {
    zip: "97883",
    ST: "OR",
    cityWithStateAbbr: "Union, OR",
  },
  {
    zip: "97884",
    ST: "OR",
    cityWithStateAbbr: "Unity, OR",
  },
  {
    zip: "97885",
    ST: "OR",
    cityWithStateAbbr: "Wallowa, OR",
  },
  {
    zip: "97886",
    ST: "OR",
    cityWithStateAbbr: "Weston, OR",
  },
  {
    zip: "97901",
    ST: "OR",
    cityWithStateAbbr: "Adrian, OR",
  },
  {
    zip: "97902",
    ST: "OR",
    cityWithStateAbbr: "Arock, OR",
  },
  {
    zip: "97903",
    ST: "OR",
    cityWithStateAbbr: "Brogan, OR",
  },
  {
    zip: "97904",
    ST: "OR",
    cityWithStateAbbr: "Drewsey, OR",
  },
  {
    zip: "97905",
    ST: "OR",
    cityWithStateAbbr: "Durkee, OR",
  },
  {
    zip: "97906",
    ST: "OR",
    cityWithStateAbbr: "Harper, OR",
  },
  {
    zip: "97907",
    ST: "OR",
    cityWithStateAbbr: "Huntington, OR",
  },
  {
    zip: "97908",
    ST: "OR",
    cityWithStateAbbr: "Ironside, OR",
  },
  {
    zip: "97909",
    ST: "OR",
    cityWithStateAbbr: "Jamieson, OR",
  },
  {
    zip: "97910",
    ST: "OR",
    cityWithStateAbbr: "Jordan Valley, OR",
  },
  {
    zip: "97911",
    ST: "OR",
    cityWithStateAbbr: "Juntura, OR",
  },
  {
    zip: "97913",
    ST: "OR",
    cityWithStateAbbr: "Nyssa, OR",
  },
  {
    zip: "97914",
    ST: "OR",
    cityWithStateAbbr: "Ontario, OR",
  },
  {
    zip: "97917",
    ST: "OR",
    cityWithStateAbbr: "Riverside, OR",
  },
  {
    zip: "97918",
    ST: "OR",
    cityWithStateAbbr: "Vale, OR",
  },
  {
    zip: "97920",
    ST: "OR",
    cityWithStateAbbr: "Westfall, OR",
  },
  {
    zip: "98001",
    ST: "WA",
    cityWithStateAbbr: "Auburn, WA",
  },
  {
    zip: "98002",
    ST: "WA",
    cityWithStateAbbr: "Auburn, WA",
  },
  {
    zip: "98003",
    ST: "WA",
    cityWithStateAbbr: "Federal Way, WA",
  },
  {
    zip: "98004",
    ST: "WA",
    cityWithStateAbbr: "Bellevue, WA",
  },
  {
    zip: "98005",
    ST: "WA",
    cityWithStateAbbr: "Bellevue, WA",
  },
  {
    zip: "98006",
    ST: "WA",
    cityWithStateAbbr: "Bellevue, WA",
  },
  {
    zip: "98007",
    ST: "WA",
    cityWithStateAbbr: "Bellevue, WA",
  },
  {
    zip: "98008",
    ST: "WA",
    cityWithStateAbbr: "Bellevue, WA",
  },
  {
    zip: "98009",
    ST: "WA",
    cityWithStateAbbr: "Bellevue, WA",
  },
  {
    zip: "98010",
    ST: "WA",
    cityWithStateAbbr: "Black Diamond, WA",
  },
  {
    zip: "98011",
    ST: "WA",
    cityWithStateAbbr: "Bothell, WA",
  },
  {
    zip: "98012",
    ST: "WA",
    cityWithStateAbbr: "Bothell, WA",
  },
  {
    zip: "98013",
    ST: "WA",
    cityWithStateAbbr: "Burton, WA",
  },
  {
    zip: "98014",
    ST: "WA",
    cityWithStateAbbr: "Carnation, WA",
  },
  {
    zip: "98015",
    ST: "WA",
    cityWithStateAbbr: "Bellevue, WA",
  },
  {
    zip: "98019",
    ST: "WA",
    cityWithStateAbbr: "Duvall, WA",
  },
  {
    zip: "98020",
    ST: "WA",
    cityWithStateAbbr: "Edmonds, WA",
  },
  {
    zip: "98021",
    ST: "WA",
    cityWithStateAbbr: "Bothell, WA",
  },
  {
    zip: "98022",
    ST: "WA",
    cityWithStateAbbr: "Enumclaw, WA",
  },
  {
    zip: "98023",
    ST: "WA",
    cityWithStateAbbr: "Federal Way, WA",
  },
  {
    zip: "98024",
    ST: "WA",
    cityWithStateAbbr: "Fall City, WA",
  },
  {
    zip: "98025",
    ST: "WA",
    cityWithStateAbbr: "Hobart, WA",
  },
  {
    zip: "98026",
    ST: "WA",
    cityWithStateAbbr: "Edmonds, WA",
  },
  {
    zip: "98027",
    ST: "WA",
    cityWithStateAbbr: "Issaquah, WA",
  },
  {
    zip: "98028",
    ST: "WA",
    cityWithStateAbbr: "Kenmore, WA",
  },
  {
    zip: "98029",
    ST: "WA",
    cityWithStateAbbr: "Issaquah, WA",
  },
  {
    zip: "98030",
    ST: "WA",
    cityWithStateAbbr: "Kent, WA",
  },
  {
    zip: "98031",
    ST: "WA",
    cityWithStateAbbr: "Kent, WA",
  },
  {
    zip: "98032",
    ST: "WA",
    cityWithStateAbbr: "Kent, WA",
  },
  {
    zip: "98033",
    ST: "WA",
    cityWithStateAbbr: "Kirkland, WA",
  },
  {
    zip: "98034",
    ST: "WA",
    cityWithStateAbbr: "Kirkland, WA",
  },
  {
    zip: "98035",
    ST: "WA",
    cityWithStateAbbr: "Kent, WA",
  },
  {
    zip: "98036",
    ST: "WA",
    cityWithStateAbbr: "Lynnwood, WA",
  },
  {
    zip: "98037",
    ST: "WA",
    cityWithStateAbbr: "Lynnwood, WA",
  },
  {
    zip: "98038",
    ST: "WA",
    cityWithStateAbbr: "Maple Valley, WA",
  },
  {
    zip: "98039",
    ST: "WA",
    cityWithStateAbbr: "Medina, WA",
  },
  {
    zip: "98040",
    ST: "WA",
    cityWithStateAbbr: "Mercer Island, WA",
  },
  {
    zip: "98041",
    ST: "WA",
    cityWithStateAbbr: "Bothell, WA",
  },
  {
    zip: "98042",
    ST: "WA",
    cityWithStateAbbr: "Kent, WA",
  },
  {
    zip: "98043",
    ST: "WA",
    cityWithStateAbbr: "Mountlake Terrace, WA",
  },
  {
    zip: "98045",
    ST: "WA",
    cityWithStateAbbr: "North Bend, WA",
  },
  {
    zip: "98046",
    ST: "WA",
    cityWithStateAbbr: "Lynnwood, WA",
  },
  {
    zip: "98047",
    ST: "WA",
    cityWithStateAbbr: "Pacific, WA",
  },
  {
    zip: "98050",
    ST: "WA",
    cityWithStateAbbr: "Preston, WA",
  },
  {
    zip: "98051",
    ST: "WA",
    cityWithStateAbbr: "Ravensdale, WA",
  },
  {
    zip: "98052",
    ST: "WA",
    cityWithStateAbbr: "Redmond, WA",
  },
  {
    zip: "98053",
    ST: "WA",
    cityWithStateAbbr: "Redmond, WA",
  },
  {
    zip: "98055",
    ST: "WA",
    cityWithStateAbbr: "Renton, WA",
  },
  {
    zip: "98056",
    ST: "WA",
    cityWithStateAbbr: "Renton, WA",
  },
  {
    zip: "98057",
    ST: "WA",
    cityWithStateAbbr: "Renton, WA",
  },
  {
    zip: "98058",
    ST: "WA",
    cityWithStateAbbr: "Renton, WA",
  },
  {
    zip: "98059",
    ST: "WA",
    cityWithStateAbbr: "Renton, WA",
  },
  {
    zip: "98061",
    ST: "WA",
    cityWithStateAbbr: "Rollingbay, WA",
  },
  {
    zip: "98062",
    ST: "WA",
    cityWithStateAbbr: "Seahurst, WA",
  },
  {
    zip: "98063",
    ST: "WA",
    cityWithStateAbbr: "Federal Way, WA",
  },
  {
    zip: "98064",
    ST: "WA",
    cityWithStateAbbr: "Kent, WA",
  },
  {
    zip: "98065",
    ST: "WA",
    cityWithStateAbbr: "Snoqualmie, WA",
  },
  {
    zip: "98068",
    ST: "WA",
    cityWithStateAbbr: "Snoqualmie Pass, WA",
  },
  {
    zip: "98070",
    ST: "WA",
    cityWithStateAbbr: "Vashon, WA",
  },
  {
    zip: "98071",
    ST: "WA",
    cityWithStateAbbr: "Auburn, WA",
  },
  {
    zip: "98072",
    ST: "WA",
    cityWithStateAbbr: "Woodinville, WA",
  },
  {
    zip: "98073",
    ST: "WA",
    cityWithStateAbbr: "Redmond, WA",
  },
  {
    zip: "98074",
    ST: "WA",
    cityWithStateAbbr: "Sammamish, WA",
  },
  {
    zip: "98075",
    ST: "WA",
    cityWithStateAbbr: "Sammamish, WA",
  },
  {
    zip: "98077",
    ST: "WA",
    cityWithStateAbbr: "Woodinville, WA",
  },
  {
    zip: "98082",
    ST: "WA",
    cityWithStateAbbr: "Mill Creek, WA",
  },
  {
    zip: "98083",
    ST: "WA",
    cityWithStateAbbr: "Kirkland, WA",
  },
  {
    zip: "98087",
    ST: "WA",
    cityWithStateAbbr: "Lynnwood, WA",
  },
  {
    zip: "98089",
    ST: "WA",
    cityWithStateAbbr: "Kent, WA",
  },
  {
    zip: "98092",
    ST: "WA",
    cityWithStateAbbr: "Auburn, WA",
  },
  {
    zip: "98093",
    ST: "WA",
    cityWithStateAbbr: "Federal Way, WA",
  },
  {
    zip: "98101",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98102",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98103",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98104",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98105",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98106",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98107",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98108",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98109",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98110",
    ST: "WA",
    cityWithStateAbbr: "Bainbridge Island, WA",
  },
  {
    zip: "98111",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98112",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98113",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98114",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98115",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98116",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98117",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98118",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98119",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98121",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98122",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98124",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98125",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98126",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98127",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98129",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98131",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98132",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98133",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98134",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98136",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98138",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98139",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98141",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98144",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98145",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98146",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98148",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98154",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98155",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98158",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98160",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98161",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98164",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98165",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98166",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98168",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98170",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98174",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98175",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98177",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98178",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98181",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98185",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98188",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98190",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98191",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98194",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98195",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98198",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98199",
    ST: "WA",
    cityWithStateAbbr: "Seattle, WA",
  },
  {
    zip: "98201",
    ST: "WA",
    cityWithStateAbbr: "Everett, WA",
  },
  {
    zip: "98203",
    ST: "WA",
    cityWithStateAbbr: "Everett, WA",
  },
  {
    zip: "98204",
    ST: "WA",
    cityWithStateAbbr: "Everett, WA",
  },
  {
    zip: "98205",
    ST: "WA",
    cityWithStateAbbr: "Everett, WA",
  },
  {
    zip: "98206",
    ST: "WA",
    cityWithStateAbbr: "Everett, WA",
  },
  {
    zip: "98207",
    ST: "WA",
    cityWithStateAbbr: "Everett, WA",
  },
  {
    zip: "98208",
    ST: "WA",
    cityWithStateAbbr: "Everett, WA",
  },
  {
    zip: "98213",
    ST: "WA",
    cityWithStateAbbr: "Everett, WA",
  },
  {
    zip: "98220",
    ST: "WA",
    cityWithStateAbbr: "Acme, WA",
  },
  {
    zip: "98221",
    ST: "WA",
    cityWithStateAbbr: "Anacortes, WA",
  },
  {
    zip: "98222",
    ST: "WA",
    cityWithStateAbbr: "Blakely Island, WA",
  },
  {
    zip: "98223",
    ST: "WA",
    cityWithStateAbbr: "Arlington, WA",
  },
  {
    zip: "98224",
    ST: "WA",
    cityWithStateAbbr: "Baring, WA",
  },
  {
    zip: "98225",
    ST: "WA",
    cityWithStateAbbr: "Bellingham, WA",
  },
  {
    zip: "98226",
    ST: "WA",
    cityWithStateAbbr: "Bellingham, WA",
  },
  {
    zip: "98227",
    ST: "WA",
    cityWithStateAbbr: "Bellingham, WA",
  },
  {
    zip: "98228",
    ST: "WA",
    cityWithStateAbbr: "Bellingham, WA",
  },
  {
    zip: "98229",
    ST: "WA",
    cityWithStateAbbr: "Bellingham, WA",
  },
  {
    zip: "98230",
    ST: "WA",
    cityWithStateAbbr: "Blaine, WA",
  },
  {
    zip: "98231",
    ST: "WA",
    cityWithStateAbbr: "Blaine, WA",
  },
  {
    zip: "98232",
    ST: "WA",
    cityWithStateAbbr: "Bow, WA",
  },
  {
    zip: "98233",
    ST: "WA",
    cityWithStateAbbr: "Burlington, WA",
  },
  {
    zip: "98235",
    ST: "WA",
    cityWithStateAbbr: "Clearlake, WA",
  },
  {
    zip: "98236",
    ST: "WA",
    cityWithStateAbbr: "Clinton, WA",
  },
  {
    zip: "98237",
    ST: "WA",
    cityWithStateAbbr: "Concrete, WA",
  },
  {
    zip: "98238",
    ST: "WA",
    cityWithStateAbbr: "Conway, WA",
  },
  {
    zip: "98239",
    ST: "WA",
    cityWithStateAbbr: "Coupeville, WA",
  },
  {
    zip: "98240",
    ST: "WA",
    cityWithStateAbbr: "Custer, WA",
  },
  {
    zip: "98241",
    ST: "WA",
    cityWithStateAbbr: "Darrington, WA",
  },
  {
    zip: "98243",
    ST: "WA",
    cityWithStateAbbr: "Deer Harbor, WA",
  },
  {
    zip: "98244",
    ST: "WA",
    cityWithStateAbbr: "Deming, WA",
  },
  {
    zip: "98245",
    ST: "WA",
    cityWithStateAbbr: "Eastsound, WA",
  },
  {
    zip: "98247",
    ST: "WA",
    cityWithStateAbbr: "Everson, WA",
  },
  {
    zip: "98248",
    ST: "WA",
    cityWithStateAbbr: "Ferndale, WA",
  },
  {
    zip: "98249",
    ST: "WA",
    cityWithStateAbbr: "Freeland, WA",
  },
  {
    zip: "98250",
    ST: "WA",
    cityWithStateAbbr: "Friday Harbor, WA",
  },
  {
    zip: "98251",
    ST: "WA",
    cityWithStateAbbr: "Gold Bar, WA",
  },
  {
    zip: "98252",
    ST: "WA",
    cityWithStateAbbr: "Granite Falls, WA",
  },
  {
    zip: "98253",
    ST: "WA",
    cityWithStateAbbr: "Greenbank, WA",
  },
  {
    zip: "98255",
    ST: "WA",
    cityWithStateAbbr: "Hamilton, WA",
  },
  {
    zip: "98256",
    ST: "WA",
    cityWithStateAbbr: "Index, WA",
  },
  {
    zip: "98257",
    ST: "WA",
    cityWithStateAbbr: "La Conner, WA",
  },
  {
    zip: "98258",
    ST: "WA",
    cityWithStateAbbr: "Lake Stevens, WA",
  },
  {
    zip: "98259",
    ST: "WA",
    cityWithStateAbbr: "North Lakewood, WA",
  },
  {
    zip: "98260",
    ST: "WA",
    cityWithStateAbbr: "Langley, WA",
  },
  {
    zip: "98261",
    ST: "WA",
    cityWithStateAbbr: "Lopez Island, WA",
  },
  {
    zip: "98262",
    ST: "WA",
    cityWithStateAbbr: "Lummi Island, WA",
  },
  {
    zip: "98263",
    ST: "WA",
    cityWithStateAbbr: "Lyman, WA",
  },
  {
    zip: "98264",
    ST: "WA",
    cityWithStateAbbr: "Lynden, WA",
  },
  {
    zip: "98266",
    ST: "WA",
    cityWithStateAbbr: "Maple Falls, WA",
  },
  {
    zip: "98267",
    ST: "WA",
    cityWithStateAbbr: "Marblemount, WA",
  },
  {
    zip: "98270",
    ST: "WA",
    cityWithStateAbbr: "Marysville, WA",
  },
  {
    zip: "98271",
    ST: "WA",
    cityWithStateAbbr: "Marysville, WA",
  },
  {
    zip: "98272",
    ST: "WA",
    cityWithStateAbbr: "Monroe, WA",
  },
  {
    zip: "98273",
    ST: "WA",
    cityWithStateAbbr: "Mount Vernon, WA",
  },
  {
    zip: "98274",
    ST: "WA",
    cityWithStateAbbr: "Mount Vernon, WA",
  },
  {
    zip: "98275",
    ST: "WA",
    cityWithStateAbbr: "Mukilteo, WA",
  },
  {
    zip: "98276",
    ST: "WA",
    cityWithStateAbbr: "Nooksack, WA",
  },
  {
    zip: "98277",
    ST: "WA",
    cityWithStateAbbr: "Oak Harbor, WA",
  },
  {
    zip: "98278",
    ST: "WA",
    cityWithStateAbbr: "Oak Harbor, WA",
  },
  {
    zip: "98279",
    ST: "WA",
    cityWithStateAbbr: "Olga, WA",
  },
  {
    zip: "98280",
    ST: "WA",
    cityWithStateAbbr: "Orcas, WA",
  },
  {
    zip: "98281",
    ST: "WA",
    cityWithStateAbbr: "Point Roberts, WA",
  },
  {
    zip: "98282",
    ST: "WA",
    cityWithStateAbbr: "Camano Island, WA",
  },
  {
    zip: "98283",
    ST: "WA",
    cityWithStateAbbr: "Rockport, WA",
  },
  {
    zip: "98284",
    ST: "WA",
    cityWithStateAbbr: "Sedro Woolley, WA",
  },
  {
    zip: "98286",
    ST: "WA",
    cityWithStateAbbr: "Shaw Island, WA",
  },
  {
    zip: "98287",
    ST: "WA",
    cityWithStateAbbr: "Silvana, WA",
  },
  {
    zip: "98288",
    ST: "WA",
    cityWithStateAbbr: "Skykomish, WA",
  },
  {
    zip: "98290",
    ST: "WA",
    cityWithStateAbbr: "Snohomish, WA",
  },
  {
    zip: "98291",
    ST: "WA",
    cityWithStateAbbr: "Snohomish, WA",
  },
  {
    zip: "98292",
    ST: "WA",
    cityWithStateAbbr: "Stanwood, WA",
  },
  {
    zip: "98293",
    ST: "WA",
    cityWithStateAbbr: "Startup, WA",
  },
  {
    zip: "98294",
    ST: "WA",
    cityWithStateAbbr: "Sultan, WA",
  },
  {
    zip: "98295",
    ST: "WA",
    cityWithStateAbbr: "Sumas, WA",
  },
  {
    zip: "98296",
    ST: "WA",
    cityWithStateAbbr: "Snohomish, WA",
  },
  {
    zip: "98297",
    ST: "WA",
    cityWithStateAbbr: "Waldron, WA",
  },
  {
    zip: "98303",
    ST: "WA",
    cityWithStateAbbr: "Anderson Island, WA",
  },
  {
    zip: "98304",
    ST: "WA",
    cityWithStateAbbr: "Ashford, WA",
  },
  {
    zip: "98305",
    ST: "WA",
    cityWithStateAbbr: "Beaver, WA",
  },
  {
    zip: "98310",
    ST: "WA",
    cityWithStateAbbr: "Bremerton, WA",
  },
  {
    zip: "98311",
    ST: "WA",
    cityWithStateAbbr: "Bremerton, WA",
  },
  {
    zip: "98312",
    ST: "WA",
    cityWithStateAbbr: "Bremerton, WA",
  },
  {
    zip: "98314",
    ST: "WA",
    cityWithStateAbbr: "Bremerton, WA",
  },
  {
    zip: "98315",
    ST: "WA",
    cityWithStateAbbr: "Silverdale, WA",
  },
  {
    zip: "98320",
    ST: "WA",
    cityWithStateAbbr: "Brinnon, WA",
  },
  {
    zip: "98321",
    ST: "WA",
    cityWithStateAbbr: "Buckley, WA",
  },
  {
    zip: "98322",
    ST: "WA",
    cityWithStateAbbr: "Burley, WA",
  },
  {
    zip: "98323",
    ST: "WA",
    cityWithStateAbbr: "Carbonado, WA",
  },
  {
    zip: "98324",
    ST: "WA",
    cityWithStateAbbr: "Carlsborg, WA",
  },
  {
    zip: "98325",
    ST: "WA",
    cityWithStateAbbr: "Chimacum, WA",
  },
  {
    zip: "98326",
    ST: "WA",
    cityWithStateAbbr: "Clallam Bay, WA",
  },
  {
    zip: "98327",
    ST: "WA",
    cityWithStateAbbr: "Dupont, WA",
  },
  {
    zip: "98328",
    ST: "WA",
    cityWithStateAbbr: "Eatonville, WA",
  },
  {
    zip: "98329",
    ST: "WA",
    cityWithStateAbbr: "Gig Harbor, WA",
  },
  {
    zip: "98330",
    ST: "WA",
    cityWithStateAbbr: "Elbe, WA",
  },
  {
    zip: "98331",
    ST: "WA",
    cityWithStateAbbr: "Forks, WA",
  },
  {
    zip: "98332",
    ST: "WA",
    cityWithStateAbbr: "Gig Harbor, WA",
  },
  {
    zip: "98333",
    ST: "WA",
    cityWithStateAbbr: "Fox Island, WA",
  },
  {
    zip: "98335",
    ST: "WA",
    cityWithStateAbbr: "Gig Harbor, WA",
  },
  {
    zip: "98336",
    ST: "WA",
    cityWithStateAbbr: "Glenoma, WA",
  },
  {
    zip: "98337",
    ST: "WA",
    cityWithStateAbbr: "Bremerton, WA",
  },
  {
    zip: "98338",
    ST: "WA",
    cityWithStateAbbr: "Graham, WA",
  },
  {
    zip: "98339",
    ST: "WA",
    cityWithStateAbbr: "Port Hadlock, WA",
  },
  {
    zip: "98340",
    ST: "WA",
    cityWithStateAbbr: "Hansville, WA",
  },
  {
    zip: "98342",
    ST: "WA",
    cityWithStateAbbr: "Indianola, WA",
  },
  {
    zip: "98343",
    ST: "WA",
    cityWithStateAbbr: "Joyce, WA",
  },
  {
    zip: "98344",
    ST: "WA",
    cityWithStateAbbr: "Kapowsin, WA",
  },
  {
    zip: "98345",
    ST: "WA",
    cityWithStateAbbr: "Keyport, WA",
  },
  {
    zip: "98346",
    ST: "WA",
    cityWithStateAbbr: "Kingston, WA",
  },
  {
    zip: "98348",
    ST: "WA",
    cityWithStateAbbr: "La Grande, WA",
  },
  {
    zip: "98349",
    ST: "WA",
    cityWithStateAbbr: "Lakebay, WA",
  },
  {
    zip: "98350",
    ST: "WA",
    cityWithStateAbbr: "La Push, WA",
  },
  {
    zip: "98351",
    ST: "WA",
    cityWithStateAbbr: "Longbranch, WA",
  },
  {
    zip: "98352",
    ST: "WA",
    cityWithStateAbbr: "Sumner, WA",
  },
  {
    zip: "98353",
    ST: "WA",
    cityWithStateAbbr: "Manchester, WA",
  },
  {
    zip: "98354",
    ST: "WA",
    cityWithStateAbbr: "Milton, WA",
  },
  {
    zip: "98355",
    ST: "WA",
    cityWithStateAbbr: "Mineral, WA",
  },
  {
    zip: "98356",
    ST: "WA",
    cityWithStateAbbr: "Morton, WA",
  },
  {
    zip: "98357",
    ST: "WA",
    cityWithStateAbbr: "Neah Bay, WA",
  },
  {
    zip: "98358",
    ST: "WA",
    cityWithStateAbbr: "Nordland, WA",
  },
  {
    zip: "98359",
    ST: "WA",
    cityWithStateAbbr: "Olalla, WA",
  },
  {
    zip: "98360",
    ST: "WA",
    cityWithStateAbbr: "Orting, WA",
  },
  {
    zip: "98361",
    ST: "WA",
    cityWithStateAbbr: "Packwood, WA",
  },
  {
    zip: "98362",
    ST: "WA",
    cityWithStateAbbr: "Port Angeles, WA",
  },
  {
    zip: "98363",
    ST: "WA",
    cityWithStateAbbr: "Port Angeles, WA",
  },
  {
    zip: "98364",
    ST: "WA",
    cityWithStateAbbr: "Port Gamble, WA",
  },
  {
    zip: "98365",
    ST: "WA",
    cityWithStateAbbr: "Port Ludlow, WA",
  },
  {
    zip: "98366",
    ST: "WA",
    cityWithStateAbbr: "Port Orchard, WA",
  },
  {
    zip: "98367",
    ST: "WA",
    cityWithStateAbbr: "Port Orchard, WA",
  },
  {
    zip: "98368",
    ST: "WA",
    cityWithStateAbbr: "Port Townsend, WA",
  },
  {
    zip: "98370",
    ST: "WA",
    cityWithStateAbbr: "Poulsbo, WA",
  },
  {
    zip: "98371",
    ST: "WA",
    cityWithStateAbbr: "Puyallup, WA",
  },
  {
    zip: "98372",
    ST: "WA",
    cityWithStateAbbr: "Puyallup, WA",
  },
  {
    zip: "98373",
    ST: "WA",
    cityWithStateAbbr: "Puyallup, WA",
  },
  {
    zip: "98374",
    ST: "WA",
    cityWithStateAbbr: "Puyallup, WA",
  },
  {
    zip: "98375",
    ST: "WA",
    cityWithStateAbbr: "Puyallup, WA",
  },
  {
    zip: "98376",
    ST: "WA",
    cityWithStateAbbr: "Quilcene, WA",
  },
  {
    zip: "98377",
    ST: "WA",
    cityWithStateAbbr: "Randle, WA",
  },
  {
    zip: "98378",
    ST: "WA",
    cityWithStateAbbr: "Retsil, WA",
  },
  {
    zip: "98380",
    ST: "WA",
    cityWithStateAbbr: "Seabeck, WA",
  },
  {
    zip: "98381",
    ST: "WA",
    cityWithStateAbbr: "Sekiu, WA",
  },
  {
    zip: "98382",
    ST: "WA",
    cityWithStateAbbr: "Sequim, WA",
  },
  {
    zip: "98383",
    ST: "WA",
    cityWithStateAbbr: "Silverdale, WA",
  },
  {
    zip: "98384",
    ST: "WA",
    cityWithStateAbbr: "South Colby, WA",
  },
  {
    zip: "98385",
    ST: "WA",
    cityWithStateAbbr: "South Prairie, WA",
  },
  {
    zip: "98386",
    ST: "WA",
    cityWithStateAbbr: "Southworth, WA",
  },
  {
    zip: "98387",
    ST: "WA",
    cityWithStateAbbr: "Spanaway, WA",
  },
  {
    zip: "98388",
    ST: "WA",
    cityWithStateAbbr: "Steilacoom, WA",
  },
  {
    zip: "98390",
    ST: "WA",
    cityWithStateAbbr: "Sumner, WA",
  },
  {
    zip: "98391",
    ST: "WA",
    cityWithStateAbbr: "Bonney Lake, WA",
  },
  {
    zip: "98392",
    ST: "WA",
    cityWithStateAbbr: "Suquamish, WA",
  },
  {
    zip: "98393",
    ST: "WA",
    cityWithStateAbbr: "Tracyton, WA",
  },
  {
    zip: "98394",
    ST: "WA",
    cityWithStateAbbr: "Vaughn, WA",
  },
  {
    zip: "98395",
    ST: "WA",
    cityWithStateAbbr: "Wauna, WA",
  },
  {
    zip: "98396",
    ST: "WA",
    cityWithStateAbbr: "Wilkeson, WA",
  },
  {
    zip: "98397",
    ST: "WA",
    cityWithStateAbbr: "Longmire, WA",
  },
  {
    zip: "98398",
    ST: "WA",
    cityWithStateAbbr: "Paradise Inn, WA",
  },
  {
    zip: "98401",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98402",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98403",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98404",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98405",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98406",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98407",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98408",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98409",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98411",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98412",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98413",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98415",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98416",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98417",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98418",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98419",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98421",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98422",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98424",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98430",
    ST: "WA",
    cityWithStateAbbr: "Camp Murray, WA",
  },
  {
    zip: "98431",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98433",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98438",
    ST: "WA",
    cityWithStateAbbr: "Mcchord Afb, WA",
  },
  {
    zip: "98439",
    ST: "WA",
    cityWithStateAbbr: "Lakewood, WA",
  },
  {
    zip: "98443",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98444",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98445",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98446",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98447",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98448",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98464",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98465",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98466",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98467",
    ST: "WA",
    cityWithStateAbbr: "University Place, WA",
  },
  {
    zip: "98471",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98481",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98490",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98493",
    ST: "WA",
    cityWithStateAbbr: "Tacoma, WA",
  },
  {
    zip: "98496",
    ST: "WA",
    cityWithStateAbbr: "Lakewood, WA",
  },
  {
    zip: "98497",
    ST: "WA",
    cityWithStateAbbr: "Lakewood, WA",
  },
  {
    zip: "98498",
    ST: "WA",
    cityWithStateAbbr: "Lakewood, WA",
  },
  {
    zip: "98499",
    ST: "WA",
    cityWithStateAbbr: "Lakewood, WA",
  },
  {
    zip: "98501",
    ST: "WA",
    cityWithStateAbbr: "Olympia, WA",
  },
  {
    zip: "98502",
    ST: "WA",
    cityWithStateAbbr: "Olympia, WA",
  },
  {
    zip: "98503",
    ST: "WA",
    cityWithStateAbbr: "Lacey, WA",
  },
  {
    zip: "98504",
    ST: "WA",
    cityWithStateAbbr: "Olympia, WA",
  },
  {
    zip: "98505",
    ST: "WA",
    cityWithStateAbbr: "Olympia, WA",
  },
  {
    zip: "98506",
    ST: "WA",
    cityWithStateAbbr: "Olympia, WA",
  },
  {
    zip: "98507",
    ST: "WA",
    cityWithStateAbbr: "Olympia, WA",
  },
  {
    zip: "98508",
    ST: "WA",
    cityWithStateAbbr: "Olympia, WA",
  },
  {
    zip: "98509",
    ST: "WA",
    cityWithStateAbbr: "Lacey, WA",
  },
  {
    zip: "98511",
    ST: "WA",
    cityWithStateAbbr: "Tumwater, WA",
  },
  {
    zip: "98512",
    ST: "WA",
    cityWithStateAbbr: "Olympia, WA",
  },
  {
    zip: "98513",
    ST: "WA",
    cityWithStateAbbr: "Olympia, WA",
  },
  {
    zip: "98516",
    ST: "WA",
    cityWithStateAbbr: "Olympia, WA",
  },
  {
    zip: "98520",
    ST: "WA",
    cityWithStateAbbr: "Aberdeen, WA",
  },
  {
    zip: "98522",
    ST: "WA",
    cityWithStateAbbr: "Adna, WA",
  },
  {
    zip: "98524",
    ST: "WA",
    cityWithStateAbbr: "Allyn, WA",
  },
  {
    zip: "98526",
    ST: "WA",
    cityWithStateAbbr: "Amanda Park, WA",
  },
  {
    zip: "98527",
    ST: "WA",
    cityWithStateAbbr: "Bay Center, WA",
  },
  {
    zip: "98528",
    ST: "WA",
    cityWithStateAbbr: "Belfair, WA",
  },
  {
    zip: "98530",
    ST: "WA",
    cityWithStateAbbr: "Bucoda, WA",
  },
  {
    zip: "98531",
    ST: "WA",
    cityWithStateAbbr: "Centralia, WA",
  },
  {
    zip: "98532",
    ST: "WA",
    cityWithStateAbbr: "Chehalis, WA",
  },
  {
    zip: "98533",
    ST: "WA",
    cityWithStateAbbr: "Cinebar, WA",
  },
  {
    zip: "98535",
    ST: "WA",
    cityWithStateAbbr: "Copalis Beach, WA",
  },
  {
    zip: "98536",
    ST: "WA",
    cityWithStateAbbr: "Copalis Crossing, WA",
  },
  {
    zip: "98537",
    ST: "WA",
    cityWithStateAbbr: "Cosmopolis, WA",
  },
  {
    zip: "98538",
    ST: "WA",
    cityWithStateAbbr: "Curtis, WA",
  },
  {
    zip: "98539",
    ST: "WA",
    cityWithStateAbbr: "Doty, WA",
  },
  {
    zip: "98540",
    ST: "WA",
    cityWithStateAbbr: "East Olympia, WA",
  },
  {
    zip: "98541",
    ST: "WA",
    cityWithStateAbbr: "Elma, WA",
  },
  {
    zip: "98542",
    ST: "WA",
    cityWithStateAbbr: "Ethel, WA",
  },
  {
    zip: "98544",
    ST: "WA",
    cityWithStateAbbr: "Galvin, WA",
  },
  {
    zip: "98546",
    ST: "WA",
    cityWithStateAbbr: "Grapeview, WA",
  },
  {
    zip: "98547",
    ST: "WA",
    cityWithStateAbbr: "Grayland, WA",
  },
  {
    zip: "98548",
    ST: "WA",
    cityWithStateAbbr: "Hoodsport, WA",
  },
  {
    zip: "98550",
    ST: "WA",
    cityWithStateAbbr: "Hoquiam, WA",
  },
  {
    zip: "98552",
    ST: "WA",
    cityWithStateAbbr: "Humptulips, WA",
  },
  {
    zip: "98554",
    ST: "WA",
    cityWithStateAbbr: "Lebam, WA",
  },
  {
    zip: "98555",
    ST: "WA",
    cityWithStateAbbr: "Lilliwaup, WA",
  },
  {
    zip: "98556",
    ST: "WA",
    cityWithStateAbbr: "Littlerock, WA",
  },
  {
    zip: "98557",
    ST: "WA",
    cityWithStateAbbr: "Mccleary, WA",
  },
  {
    zip: "98558",
    ST: "WA",
    cityWithStateAbbr: "Mckenna, WA",
  },
  {
    zip: "98559",
    ST: "WA",
    cityWithStateAbbr: "Malone, WA",
  },
  {
    zip: "98560",
    ST: "WA",
    cityWithStateAbbr: "Matlock, WA",
  },
  {
    zip: "98561",
    ST: "WA",
    cityWithStateAbbr: "Menlo, WA",
  },
  {
    zip: "98562",
    ST: "WA",
    cityWithStateAbbr: "Moclips, WA",
  },
  {
    zip: "98563",
    ST: "WA",
    cityWithStateAbbr: "Montesano, WA",
  },
  {
    zip: "98564",
    ST: "WA",
    cityWithStateAbbr: "Mossyrock, WA",
  },
  {
    zip: "98565",
    ST: "WA",
    cityWithStateAbbr: "Napavine, WA",
  },
  {
    zip: "98566",
    ST: "WA",
    cityWithStateAbbr: "Neilton, WA",
  },
  {
    zip: "98568",
    ST: "WA",
    cityWithStateAbbr: "Oakville, WA",
  },
  {
    zip: "98569",
    ST: "WA",
    cityWithStateAbbr: "Ocean Shores, WA",
  },
  {
    zip: "98570",
    ST: "WA",
    cityWithStateAbbr: "Onalaska, WA",
  },
  {
    zip: "98571",
    ST: "WA",
    cityWithStateAbbr: "Pacific Beach, WA",
  },
  {
    zip: "98572",
    ST: "WA",
    cityWithStateAbbr: "Pe Ell, WA",
  },
  {
    zip: "98575",
    ST: "WA",
    cityWithStateAbbr: "Quinault, WA",
  },
  {
    zip: "98576",
    ST: "WA",
    cityWithStateAbbr: "Rainier, WA",
  },
  {
    zip: "98577",
    ST: "WA",
    cityWithStateAbbr: "Raymond, WA",
  },
  {
    zip: "98579",
    ST: "WA",
    cityWithStateAbbr: "Rochester, WA",
  },
  {
    zip: "98580",
    ST: "WA",
    cityWithStateAbbr: "Roy, WA",
  },
  {
    zip: "98581",
    ST: "WA",
    cityWithStateAbbr: "Ryderwood, WA",
  },
  {
    zip: "98582",
    ST: "WA",
    cityWithStateAbbr: "Salkum, WA",
  },
  {
    zip: "98583",
    ST: "WA",
    cityWithStateAbbr: "Satsop, WA",
  },
  {
    zip: "98584",
    ST: "WA",
    cityWithStateAbbr: "Shelton, WA",
  },
  {
    zip: "98585",
    ST: "WA",
    cityWithStateAbbr: "Silver Creek, WA",
  },
  {
    zip: "98586",
    ST: "WA",
    cityWithStateAbbr: "South Bend, WA",
  },
  {
    zip: "98587",
    ST: "WA",
    cityWithStateAbbr: "Taholah, WA",
  },
  {
    zip: "98588",
    ST: "WA",
    cityWithStateAbbr: "Tahuya, WA",
  },
  {
    zip: "98589",
    ST: "WA",
    cityWithStateAbbr: "Tenino, WA",
  },
  {
    zip: "98590",
    ST: "WA",
    cityWithStateAbbr: "Tokeland, WA",
  },
  {
    zip: "98591",
    ST: "WA",
    cityWithStateAbbr: "Toledo, WA",
  },
  {
    zip: "98592",
    ST: "WA",
    cityWithStateAbbr: "Union, WA",
  },
  {
    zip: "98593",
    ST: "WA",
    cityWithStateAbbr: "Vader, WA",
  },
  {
    zip: "98595",
    ST: "WA",
    cityWithStateAbbr: "Westport, WA",
  },
  {
    zip: "98596",
    ST: "WA",
    cityWithStateAbbr: "Winlock, WA",
  },
  {
    zip: "98597",
    ST: "WA",
    cityWithStateAbbr: "Yelm, WA",
  },
  {
    zip: "98599",
    ST: "WA",
    cityWithStateAbbr: "Olympia, WA",
  },
  {
    zip: "98601",
    ST: "WA",
    cityWithStateAbbr: "Amboy, WA",
  },
  {
    zip: "98602",
    ST: "WA",
    cityWithStateAbbr: "Appleton, WA",
  },
  {
    zip: "98603",
    ST: "WA",
    cityWithStateAbbr: "Ariel, WA",
  },
  {
    zip: "98604",
    ST: "WA",
    cityWithStateAbbr: "Battle Ground, WA",
  },
  {
    zip: "98605",
    ST: "WA",
    cityWithStateAbbr: "Bingen, WA",
  },
  {
    zip: "98606",
    ST: "WA",
    cityWithStateAbbr: "Brush Prairie, WA",
  },
  {
    zip: "98607",
    ST: "WA",
    cityWithStateAbbr: "Camas, WA",
  },
  {
    zip: "98609",
    ST: "WA",
    cityWithStateAbbr: "Carrolls, WA",
  },
  {
    zip: "98610",
    ST: "WA",
    cityWithStateAbbr: "Carson, WA",
  },
  {
    zip: "98611",
    ST: "WA",
    cityWithStateAbbr: "Castle Rock, WA",
  },
  {
    zip: "98612",
    ST: "WA",
    cityWithStateAbbr: "Cathlamet, WA",
  },
  {
    zip: "98613",
    ST: "WA",
    cityWithStateAbbr: "Centerville, WA",
  },
  {
    zip: "98614",
    ST: "WA",
    cityWithStateAbbr: "Chinook, WA",
  },
  {
    zip: "98616",
    ST: "WA",
    cityWithStateAbbr: "Cougar, WA",
  },
  {
    zip: "98617",
    ST: "WA",
    cityWithStateAbbr: "Dallesport, WA",
  },
  {
    zip: "98619",
    ST: "WA",
    cityWithStateAbbr: "Glenwood, WA",
  },
  {
    zip: "98620",
    ST: "WA",
    cityWithStateAbbr: "Goldendale, WA",
  },
  {
    zip: "98621",
    ST: "WA",
    cityWithStateAbbr: "Grays River, WA",
  },
  {
    zip: "98622",
    ST: "WA",
    cityWithStateAbbr: "Heisson, WA",
  },
  {
    zip: "98623",
    ST: "WA",
    cityWithStateAbbr: "Husum, WA",
  },
  {
    zip: "98624",
    ST: "WA",
    cityWithStateAbbr: "Ilwaco, WA",
  },
  {
    zip: "98625",
    ST: "WA",
    cityWithStateAbbr: "Kalama, WA",
  },
  {
    zip: "98626",
    ST: "WA",
    cityWithStateAbbr: "Kelso, WA",
  },
  {
    zip: "98628",
    ST: "WA",
    cityWithStateAbbr: "Klickitat, WA",
  },
  {
    zip: "98629",
    ST: "WA",
    cityWithStateAbbr: "La Center, WA",
  },
  {
    zip: "98631",
    ST: "WA",
    cityWithStateAbbr: "Long Beach, WA",
  },
  {
    zip: "98632",
    ST: "WA",
    cityWithStateAbbr: "Longview, WA",
  },
  {
    zip: "98635",
    ST: "WA",
    cityWithStateAbbr: "Lyle, WA",
  },
  {
    zip: "98637",
    ST: "WA",
    cityWithStateAbbr: "Nahcotta, WA",
  },
  {
    zip: "98638",
    ST: "WA",
    cityWithStateAbbr: "Naselle, WA",
  },
  {
    zip: "98639",
    ST: "WA",
    cityWithStateAbbr: "North Bonneville, WA",
  },
  {
    zip: "98640",
    ST: "WA",
    cityWithStateAbbr: "Ocean Park, WA",
  },
  {
    zip: "98641",
    ST: "WA",
    cityWithStateAbbr: "Oysterville, WA",
  },
  {
    zip: "98642",
    ST: "WA",
    cityWithStateAbbr: "Ridgefield, WA",
  },
  {
    zip: "98643",
    ST: "WA",
    cityWithStateAbbr: "Rosburg, WA",
  },
  {
    zip: "98644",
    ST: "WA",
    cityWithStateAbbr: "Seaview, WA",
  },
  {
    zip: "98645",
    ST: "WA",
    cityWithStateAbbr: "Silverlake, WA",
  },
  {
    zip: "98647",
    ST: "WA",
    cityWithStateAbbr: "Skamokawa, WA",
  },
  {
    zip: "98648",
    ST: "WA",
    cityWithStateAbbr: "Stevenson, WA",
  },
  {
    zip: "98649",
    ST: "WA",
    cityWithStateAbbr: "Toutle, WA",
  },
  {
    zip: "98650",
    ST: "WA",
    cityWithStateAbbr: "Trout Lake, WA",
  },
  {
    zip: "98651",
    ST: "WA",
    cityWithStateAbbr: "Underwood, WA",
  },
  {
    zip: "98660",
    ST: "WA",
    cityWithStateAbbr: "Vancouver, WA",
  },
  {
    zip: "98661",
    ST: "WA",
    cityWithStateAbbr: "Vancouver, WA",
  },
  {
    zip: "98662",
    ST: "WA",
    cityWithStateAbbr: "Vancouver, WA",
  },
  {
    zip: "98663",
    ST: "WA",
    cityWithStateAbbr: "Vancouver, WA",
  },
  {
    zip: "98664",
    ST: "WA",
    cityWithStateAbbr: "Vancouver, WA",
  },
  {
    zip: "98665",
    ST: "WA",
    cityWithStateAbbr: "Vancouver, WA",
  },
  {
    zip: "98666",
    ST: "WA",
    cityWithStateAbbr: "Vancouver, WA",
  },
  {
    zip: "98668",
    ST: "WA",
    cityWithStateAbbr: "Vancouver, WA",
  },
  {
    zip: "98670",
    ST: "WA",
    cityWithStateAbbr: "Wahkiacus, WA",
  },
  {
    zip: "98671",
    ST: "WA",
    cityWithStateAbbr: "Washougal, WA",
  },
  {
    zip: "98672",
    ST: "WA",
    cityWithStateAbbr: "White Salmon, WA",
  },
  {
    zip: "98673",
    ST: "WA",
    cityWithStateAbbr: "Wishram, WA",
  },
  {
    zip: "98674",
    ST: "WA",
    cityWithStateAbbr: "Woodland, WA",
  },
  {
    zip: "98675",
    ST: "WA",
    cityWithStateAbbr: "Yacolt, WA",
  },
  {
    zip: "98682",
    ST: "WA",
    cityWithStateAbbr: "Vancouver, WA",
  },
  {
    zip: "98683",
    ST: "WA",
    cityWithStateAbbr: "Vancouver, WA",
  },
  {
    zip: "98684",
    ST: "WA",
    cityWithStateAbbr: "Vancouver, WA",
  },
  {
    zip: "98685",
    ST: "WA",
    cityWithStateAbbr: "Vancouver, WA",
  },
  {
    zip: "98686",
    ST: "WA",
    cityWithStateAbbr: "Vancouver, WA",
  },
  {
    zip: "98687",
    ST: "WA",
    cityWithStateAbbr: "Vancouver, WA",
  },
  {
    zip: "98801",
    ST: "WA",
    cityWithStateAbbr: "Wenatchee, WA",
  },
  {
    zip: "98802",
    ST: "WA",
    cityWithStateAbbr: "East Wenatchee, WA",
  },
  {
    zip: "98807",
    ST: "WA",
    cityWithStateAbbr: "Wenatchee, WA",
  },
  {
    zip: "98811",
    ST: "WA",
    cityWithStateAbbr: "Ardenvoir, WA",
  },
  {
    zip: "98812",
    ST: "WA",
    cityWithStateAbbr: "Brewster, WA",
  },
  {
    zip: "98813",
    ST: "WA",
    cityWithStateAbbr: "Bridgeport, WA",
  },
  {
    zip: "98814",
    ST: "WA",
    cityWithStateAbbr: "Carlton, WA",
  },
  {
    zip: "98815",
    ST: "WA",
    cityWithStateAbbr: "Cashmere, WA",
  },
  {
    zip: "98816",
    ST: "WA",
    cityWithStateAbbr: "Chelan, WA",
  },
  {
    zip: "98817",
    ST: "WA",
    cityWithStateAbbr: "Chelan Falls, WA",
  },
  {
    zip: "98819",
    ST: "WA",
    cityWithStateAbbr: "Conconully, WA",
  },
  {
    zip: "98821",
    ST: "WA",
    cityWithStateAbbr: "Dryden, WA",
  },
  {
    zip: "98822",
    ST: "WA",
    cityWithStateAbbr: "Entiat, WA",
  },
  {
    zip: "98823",
    ST: "WA",
    cityWithStateAbbr: "Ephrata, WA",
  },
  {
    zip: "98824",
    ST: "WA",
    cityWithStateAbbr: "George, WA",
  },
  {
    zip: "98826",
    ST: "WA",
    cityWithStateAbbr: "Leavenworth, WA",
  },
  {
    zip: "98827",
    ST: "WA",
    cityWithStateAbbr: "Loomis, WA",
  },
  {
    zip: "98828",
    ST: "WA",
    cityWithStateAbbr: "Malaga, WA",
  },
  {
    zip: "98829",
    ST: "WA",
    cityWithStateAbbr: "Malott, WA",
  },
  {
    zip: "98830",
    ST: "WA",
    cityWithStateAbbr: "Mansfield, WA",
  },
  {
    zip: "98831",
    ST: "WA",
    cityWithStateAbbr: "Manson, WA",
  },
  {
    zip: "98832",
    ST: "WA",
    cityWithStateAbbr: "Marlin, WA",
  },
  {
    zip: "98833",
    ST: "WA",
    cityWithStateAbbr: "Mazama, WA",
  },
  {
    zip: "98834",
    ST: "WA",
    cityWithStateAbbr: "Methow, WA",
  },
  {
    zip: "98836",
    ST: "WA",
    cityWithStateAbbr: "Monitor, WA",
  },
  {
    zip: "98837",
    ST: "WA",
    cityWithStateAbbr: "Moses Lake, WA",
  },
  {
    zip: "98840",
    ST: "WA",
    cityWithStateAbbr: "Okanogan, WA",
  },
  {
    zip: "98841",
    ST: "WA",
    cityWithStateAbbr: "Omak, WA",
  },
  {
    zip: "98843",
    ST: "WA",
    cityWithStateAbbr: "Orondo, WA",
  },
  {
    zip: "98844",
    ST: "WA",
    cityWithStateAbbr: "Oroville, WA",
  },
  {
    zip: "98845",
    ST: "WA",
    cityWithStateAbbr: "Palisades, WA",
  },
  {
    zip: "98846",
    ST: "WA",
    cityWithStateAbbr: "Pateros, WA",
  },
  {
    zip: "98847",
    ST: "WA",
    cityWithStateAbbr: "Peshastin, WA",
  },
  {
    zip: "98848",
    ST: "WA",
    cityWithStateAbbr: "Quincy, WA",
  },
  {
    zip: "98849",
    ST: "WA",
    cityWithStateAbbr: "Riverside, WA",
  },
  {
    zip: "98850",
    ST: "WA",
    cityWithStateAbbr: "Rock Island, WA",
  },
  {
    zip: "98851",
    ST: "WA",
    cityWithStateAbbr: "Soap Lake, WA",
  },
  {
    zip: "98852",
    ST: "WA",
    cityWithStateAbbr: "Stehekin, WA",
  },
  {
    zip: "98853",
    ST: "WA",
    cityWithStateAbbr: "Stratford, WA",
  },
  {
    zip: "98855",
    ST: "WA",
    cityWithStateAbbr: "Tonasket, WA",
  },
  {
    zip: "98856",
    ST: "WA",
    cityWithStateAbbr: "Twisp, WA",
  },
  {
    zip: "98857",
    ST: "WA",
    cityWithStateAbbr: "Warden, WA",
  },
  {
    zip: "98858",
    ST: "WA",
    cityWithStateAbbr: "Waterville, WA",
  },
  {
    zip: "98859",
    ST: "WA",
    cityWithStateAbbr: "Wauconda, WA",
  },
  {
    zip: "98860",
    ST: "WA",
    cityWithStateAbbr: "Wilson Creek, WA",
  },
  {
    zip: "98862",
    ST: "WA",
    cityWithStateAbbr: "Winthrop, WA",
  },
  {
    zip: "98901",
    ST: "WA",
    cityWithStateAbbr: "Yakima, WA",
  },
  {
    zip: "98902",
    ST: "WA",
    cityWithStateAbbr: "Yakima, WA",
  },
  {
    zip: "98903",
    ST: "WA",
    cityWithStateAbbr: "Yakima, WA",
  },
  {
    zip: "98904",
    ST: "WA",
    cityWithStateAbbr: "Yakima, WA",
  },
  {
    zip: "98907",
    ST: "WA",
    cityWithStateAbbr: "Yakima, WA",
  },
  {
    zip: "98908",
    ST: "WA",
    cityWithStateAbbr: "Yakima, WA",
  },
  {
    zip: "98909",
    ST: "WA",
    cityWithStateAbbr: "Yakima, WA",
  },
  {
    zip: "98920",
    ST: "WA",
    cityWithStateAbbr: "Brownstown, WA",
  },
  {
    zip: "98921",
    ST: "WA",
    cityWithStateAbbr: "Buena, WA",
  },
  {
    zip: "98922",
    ST: "WA",
    cityWithStateAbbr: "Cle Elum, WA",
  },
  {
    zip: "98923",
    ST: "WA",
    cityWithStateAbbr: "Cowiche, WA",
  },
  {
    zip: "98925",
    ST: "WA",
    cityWithStateAbbr: "Easton, WA",
  },
  {
    zip: "98926",
    ST: "WA",
    cityWithStateAbbr: "Ellensburg, WA",
  },
  {
    zip: "98930",
    ST: "WA",
    cityWithStateAbbr: "Grandview, WA",
  },
  {
    zip: "98932",
    ST: "WA",
    cityWithStateAbbr: "Granger, WA",
  },
  {
    zip: "98933",
    ST: "WA",
    cityWithStateAbbr: "Harrah, WA",
  },
  {
    zip: "98934",
    ST: "WA",
    cityWithStateAbbr: "Kittitas, WA",
  },
  {
    zip: "98935",
    ST: "WA",
    cityWithStateAbbr: "Mabton, WA",
  },
  {
    zip: "98936",
    ST: "WA",
    cityWithStateAbbr: "Moxee, WA",
  },
  {
    zip: "98937",
    ST: "WA",
    cityWithStateAbbr: "Naches, WA",
  },
  {
    zip: "98938",
    ST: "WA",
    cityWithStateAbbr: "Outlook, WA",
  },
  {
    zip: "98939",
    ST: "WA",
    cityWithStateAbbr: "Parker, WA",
  },
  {
    zip: "98940",
    ST: "WA",
    cityWithStateAbbr: "Ronald, WA",
  },
  {
    zip: "98941",
    ST: "WA",
    cityWithStateAbbr: "Roslyn, WA",
  },
  {
    zip: "98942",
    ST: "WA",
    cityWithStateAbbr: "Selah, WA",
  },
  {
    zip: "98943",
    ST: "WA",
    cityWithStateAbbr: "South Cle Elum, WA",
  },
  {
    zip: "98944",
    ST: "WA",
    cityWithStateAbbr: "Sunnyside, WA",
  },
  {
    zip: "98946",
    ST: "WA",
    cityWithStateAbbr: "Thorp, WA",
  },
  {
    zip: "98947",
    ST: "WA",
    cityWithStateAbbr: "Tieton, WA",
  },
  {
    zip: "98948",
    ST: "WA",
    cityWithStateAbbr: "Toppenish, WA",
  },
  {
    zip: "98950",
    ST: "WA",
    cityWithStateAbbr: "Vantage, WA",
  },
  {
    zip: "98951",
    ST: "WA",
    cityWithStateAbbr: "Wapato, WA",
  },
  {
    zip: "98952",
    ST: "WA",
    cityWithStateAbbr: "White Swan, WA",
  },
  {
    zip: "98953",
    ST: "WA",
    cityWithStateAbbr: "Zillah, WA",
  },
  {
    zip: "99001",
    ST: "WA",
    cityWithStateAbbr: "Airway Heights, WA",
  },
  {
    zip: "99003",
    ST: "WA",
    cityWithStateAbbr: "Chattaroy, WA",
  },
  {
    zip: "99004",
    ST: "WA",
    cityWithStateAbbr: "Cheney, WA",
  },
  {
    zip: "99005",
    ST: "WA",
    cityWithStateAbbr: "Colbert, WA",
  },
  {
    zip: "99006",
    ST: "WA",
    cityWithStateAbbr: "Deer Park, WA",
  },
  {
    zip: "99008",
    ST: "WA",
    cityWithStateAbbr: "Edwall, WA",
  },
  {
    zip: "99009",
    ST: "WA",
    cityWithStateAbbr: "Elk, WA",
  },
  {
    zip: "99011",
    ST: "WA",
    cityWithStateAbbr: "Fairchild Air Force Base, WA",
  },
  {
    zip: "99012",
    ST: "WA",
    cityWithStateAbbr: "Fairfield, WA",
  },
  {
    zip: "99013",
    ST: "WA",
    cityWithStateAbbr: "Ford, WA",
  },
  {
    zip: "99014",
    ST: "WA",
    cityWithStateAbbr: "Four Lakes, WA",
  },
  {
    zip: "99016",
    ST: "WA",
    cityWithStateAbbr: "Greenacres, WA",
  },
  {
    zip: "99017",
    ST: "WA",
    cityWithStateAbbr: "Lamont, WA",
  },
  {
    zip: "99018",
    ST: "WA",
    cityWithStateAbbr: "Latah, WA",
  },
  {
    zip: "99019",
    ST: "WA",
    cityWithStateAbbr: "Liberty Lake, WA",
  },
  {
    zip: "99020",
    ST: "WA",
    cityWithStateAbbr: "Marshall, WA",
  },
  {
    zip: "99021",
    ST: "WA",
    cityWithStateAbbr: "Mead, WA",
  },
  {
    zip: "99022",
    ST: "WA",
    cityWithStateAbbr: "Medical Lake, WA",
  },
  {
    zip: "99023",
    ST: "WA",
    cityWithStateAbbr: "Mica, WA",
  },
  {
    zip: "99025",
    ST: "WA",
    cityWithStateAbbr: "Newman Lake, WA",
  },
  {
    zip: "99026",
    ST: "WA",
    cityWithStateAbbr: "Nine Mile Falls, WA",
  },
  {
    zip: "99027",
    ST: "WA",
    cityWithStateAbbr: "Otis Orchards, WA",
  },
  {
    zip: "99029",
    ST: "WA",
    cityWithStateAbbr: "Reardan, WA",
  },
  {
    zip: "99030",
    ST: "WA",
    cityWithStateAbbr: "Rockford, WA",
  },
  {
    zip: "99031",
    ST: "WA",
    cityWithStateAbbr: "Spangle, WA",
  },
  {
    zip: "99032",
    ST: "WA",
    cityWithStateAbbr: "Sprague, WA",
  },
  {
    zip: "99033",
    ST: "WA",
    cityWithStateAbbr: "Tekoa, WA",
  },
  {
    zip: "99034",
    ST: "WA",
    cityWithStateAbbr: "Tumtum, WA",
  },
  {
    zip: "99036",
    ST: "WA",
    cityWithStateAbbr: "Valleyford, WA",
  },
  {
    zip: "99037",
    ST: "WA",
    cityWithStateAbbr: "Veradale, WA",
  },
  {
    zip: "99039",
    ST: "WA",
    cityWithStateAbbr: "Waverly, WA",
  },
  {
    zip: "99040",
    ST: "WA",
    cityWithStateAbbr: "Wellpinit, WA",
  },
  {
    zip: "99101",
    ST: "WA",
    cityWithStateAbbr: "Addy, WA",
  },
  {
    zip: "99102",
    ST: "WA",
    cityWithStateAbbr: "Albion, WA",
  },
  {
    zip: "99103",
    ST: "WA",
    cityWithStateAbbr: "Almira, WA",
  },
  {
    zip: "99104",
    ST: "WA",
    cityWithStateAbbr: "Belmont, WA",
  },
  {
    zip: "99105",
    ST: "WA",
    cityWithStateAbbr: "Benge, WA",
  },
  {
    zip: "99107",
    ST: "WA",
    cityWithStateAbbr: "Boyds, WA",
  },
  {
    zip: "99109",
    ST: "WA",
    cityWithStateAbbr: "Chewelah, WA",
  },
  {
    zip: "99110",
    ST: "WA",
    cityWithStateAbbr: "Clayton, WA",
  },
  {
    zip: "99111",
    ST: "WA",
    cityWithStateAbbr: "Colfax, WA",
  },
  {
    zip: "99113",
    ST: "WA",
    cityWithStateAbbr: "Colton, WA",
  },
  {
    zip: "99114",
    ST: "WA",
    cityWithStateAbbr: "Colville, WA",
  },
  {
    zip: "99115",
    ST: "WA",
    cityWithStateAbbr: "Coulee City, WA",
  },
  {
    zip: "99116",
    ST: "WA",
    cityWithStateAbbr: "Coulee Dam, WA",
  },
  {
    zip: "99117",
    ST: "WA",
    cityWithStateAbbr: "Creston, WA",
  },
  {
    zip: "99118",
    ST: "WA",
    cityWithStateAbbr: "Curlew, WA",
  },
  {
    zip: "99119",
    ST: "WA",
    cityWithStateAbbr: "Cusick, WA",
  },
  {
    zip: "99121",
    ST: "WA",
    cityWithStateAbbr: "Danville, WA",
  },
  {
    zip: "99122",
    ST: "WA",
    cityWithStateAbbr: "Davenport, WA",
  },
  {
    zip: "99123",
    ST: "WA",
    cityWithStateAbbr: "Electric City, WA",
  },
  {
    zip: "99124",
    ST: "WA",
    cityWithStateAbbr: "Elmer City, WA",
  },
  {
    zip: "99125",
    ST: "WA",
    cityWithStateAbbr: "Endicott, WA",
  },
  {
    zip: "99126",
    ST: "WA",
    cityWithStateAbbr: "Evans, WA",
  },
  {
    zip: "99128",
    ST: "WA",
    cityWithStateAbbr: "Farmington, WA",
  },
  {
    zip: "99129",
    ST: "WA",
    cityWithStateAbbr: "Fruitland, WA",
  },
  {
    zip: "99130",
    ST: "WA",
    cityWithStateAbbr: "Garfield, WA",
  },
  {
    zip: "99131",
    ST: "WA",
    cityWithStateAbbr: "Gifford, WA",
  },
  {
    zip: "99133",
    ST: "WA",
    cityWithStateAbbr: "Grand Coulee, WA",
  },
  {
    zip: "99134",
    ST: "WA",
    cityWithStateAbbr: "Harrington, WA",
  },
  {
    zip: "99135",
    ST: "WA",
    cityWithStateAbbr: "Hartline, WA",
  },
  {
    zip: "99136",
    ST: "WA",
    cityWithStateAbbr: "Hay, WA",
  },
  {
    zip: "99137",
    ST: "WA",
    cityWithStateAbbr: "Hunters, WA",
  },
  {
    zip: "99138",
    ST: "WA",
    cityWithStateAbbr: "Inchelium, WA",
  },
  {
    zip: "99139",
    ST: "WA",
    cityWithStateAbbr: "Ione, WA",
  },
  {
    zip: "99140",
    ST: "WA",
    cityWithStateAbbr: "Keller, WA",
  },
  {
    zip: "99141",
    ST: "WA",
    cityWithStateAbbr: "Kettle Falls, WA",
  },
  {
    zip: "99143",
    ST: "WA",
    cityWithStateAbbr: "Lacrosse, WA",
  },
  {
    zip: "99144",
    ST: "WA",
    cityWithStateAbbr: "Lamona, WA",
  },
  {
    zip: "99146",
    ST: "WA",
    cityWithStateAbbr: "Laurier, WA",
  },
  {
    zip: "99147",
    ST: "WA",
    cityWithStateAbbr: "Lincoln, WA",
  },
  {
    zip: "99148",
    ST: "WA",
    cityWithStateAbbr: "Loon Lake, WA",
  },
  {
    zip: "99149",
    ST: "WA",
    cityWithStateAbbr: "Malden, WA",
  },
  {
    zip: "99150",
    ST: "WA",
    cityWithStateAbbr: "Malo, WA",
  },
  {
    zip: "99151",
    ST: "WA",
    cityWithStateAbbr: "Marcus, WA",
  },
  {
    zip: "99152",
    ST: "WA",
    cityWithStateAbbr: "Metaline, WA",
  },
  {
    zip: "99153",
    ST: "WA",
    cityWithStateAbbr: "Metaline Falls, WA",
  },
  {
    zip: "99154",
    ST: "WA",
    cityWithStateAbbr: "Mohler, WA",
  },
  {
    zip: "99155",
    ST: "WA",
    cityWithStateAbbr: "Nespelem, WA",
  },
  {
    zip: "99156",
    ST: "WA",
    cityWithStateAbbr: "Newport, WA",
  },
  {
    zip: "99157",
    ST: "WA",
    cityWithStateAbbr: "Northport, WA",
  },
  {
    zip: "99158",
    ST: "WA",
    cityWithStateAbbr: "Oakesdale, WA",
  },
  {
    zip: "99159",
    ST: "WA",
    cityWithStateAbbr: "Odessa, WA",
  },
  {
    zip: "99160",
    ST: "WA",
    cityWithStateAbbr: "Orient, WA",
  },
  {
    zip: "99161",
    ST: "WA",
    cityWithStateAbbr: "Palouse, WA",
  },
  {
    zip: "99163",
    ST: "WA",
    cityWithStateAbbr: "Pullman, WA",
  },
  {
    zip: "99164",
    ST: "WA",
    cityWithStateAbbr: "Pullman, WA",
  },
  {
    zip: "99166",
    ST: "WA",
    cityWithStateAbbr: "Republic, WA",
  },
  {
    zip: "99167",
    ST: "WA",
    cityWithStateAbbr: "Rice, WA",
  },
  {
    zip: "99169",
    ST: "WA",
    cityWithStateAbbr: "Ritzville, WA",
  },
  {
    zip: "99170",
    ST: "WA",
    cityWithStateAbbr: "Rosalia, WA",
  },
  {
    zip: "99171",
    ST: "WA",
    cityWithStateAbbr: "Saint John, WA",
  },
  {
    zip: "99173",
    ST: "WA",
    cityWithStateAbbr: "Springdale, WA",
  },
  {
    zip: "99174",
    ST: "WA",
    cityWithStateAbbr: "Steptoe, WA",
  },
  {
    zip: "99176",
    ST: "WA",
    cityWithStateAbbr: "Thornton, WA",
  },
  {
    zip: "99179",
    ST: "WA",
    cityWithStateAbbr: "Uniontown, WA",
  },
  {
    zip: "99180",
    ST: "WA",
    cityWithStateAbbr: "Usk, WA",
  },
  {
    zip: "99181",
    ST: "WA",
    cityWithStateAbbr: "Valley, WA",
  },
  {
    zip: "99185",
    ST: "WA",
    cityWithStateAbbr: "Wilbur, WA",
  },
  {
    zip: "99201",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99202",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99203",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99204",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99205",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99206",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99207",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99208",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99209",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99210",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99211",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99212",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99213",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99214",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99215",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99216",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99217",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99218",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99219",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99220",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99223",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99224",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99228",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99251",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99252",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99256",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99258",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99260",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99299",
    ST: "WA",
    cityWithStateAbbr: "Spokane, WA",
  },
  {
    zip: "99301",
    ST: "WA",
    cityWithStateAbbr: "Pasco, WA",
  },
  {
    zip: "99302",
    ST: "WA",
    cityWithStateAbbr: "Pasco, WA",
  },
  {
    zip: "99320",
    ST: "WA",
    cityWithStateAbbr: "Benton City, WA",
  },
  {
    zip: "99321",
    ST: "WA",
    cityWithStateAbbr: "Beverly, WA",
  },
  {
    zip: "99322",
    ST: "WA",
    cityWithStateAbbr: "Bickleton, WA",
  },
  {
    zip: "99323",
    ST: "WA",
    cityWithStateAbbr: "Burbank, WA",
  },
  {
    zip: "99324",
    ST: "WA",
    cityWithStateAbbr: "College Place, WA",
  },
  {
    zip: "99326",
    ST: "WA",
    cityWithStateAbbr: "Connell, WA",
  },
  {
    zip: "99328",
    ST: "WA",
    cityWithStateAbbr: "Dayton, WA",
  },
  {
    zip: "99329",
    ST: "WA",
    cityWithStateAbbr: "Dixie, WA",
  },
  {
    zip: "99330",
    ST: "WA",
    cityWithStateAbbr: "Eltopia, WA",
  },
  {
    zip: "99333",
    ST: "WA",
    cityWithStateAbbr: "Hooper, WA",
  },
  {
    zip: "99335",
    ST: "WA",
    cityWithStateAbbr: "Kahlotus, WA",
  },
  {
    zip: "99336",
    ST: "WA",
    cityWithStateAbbr: "Kennewick, WA",
  },
  {
    zip: "99337",
    ST: "WA",
    cityWithStateAbbr: "Kennewick, WA",
  },
  {
    zip: "99338",
    ST: "WA",
    cityWithStateAbbr: "Kennewick, WA",
  },
  {
    zip: "99341",
    ST: "WA",
    cityWithStateAbbr: "Lind, WA",
  },
  {
    zip: "99343",
    ST: "WA",
    cityWithStateAbbr: "Mesa, WA",
  },
  {
    zip: "99344",
    ST: "WA",
    cityWithStateAbbr: "Othello, WA",
  },
  {
    zip: "99345",
    ST: "WA",
    cityWithStateAbbr: "Paterson, WA",
  },
  {
    zip: "99346",
    ST: "WA",
    cityWithStateAbbr: "Plymouth, WA",
  },
  {
    zip: "99347",
    ST: "WA",
    cityWithStateAbbr: "Pomeroy, WA",
  },
  {
    zip: "99348",
    ST: "WA",
    cityWithStateAbbr: "Prescott, WA",
  },
  {
    zip: "99349",
    ST: "WA",
    cityWithStateAbbr: "Mattawa, WA",
  },
  {
    zip: "99350",
    ST: "WA",
    cityWithStateAbbr: "Prosser, WA",
  },
  {
    zip: "99352",
    ST: "WA",
    cityWithStateAbbr: "Richland, WA",
  },
  {
    zip: "99353",
    ST: "WA",
    cityWithStateAbbr: "West Richland, WA",
  },
  {
    zip: "99354",
    ST: "WA",
    cityWithStateAbbr: "Richland, WA",
  },
  {
    zip: "99356",
    ST: "WA",
    cityWithStateAbbr: "Roosevelt, WA",
  },
  {
    zip: "99357",
    ST: "WA",
    cityWithStateAbbr: "Royal City, WA",
  },
  {
    zip: "99359",
    ST: "WA",
    cityWithStateAbbr: "Starbuck, WA",
  },
  {
    zip: "99360",
    ST: "WA",
    cityWithStateAbbr: "Touchet, WA",
  },
  {
    zip: "99361",
    ST: "WA",
    cityWithStateAbbr: "Waitsburg, WA",
  },
  {
    zip: "99362",
    ST: "WA",
    cityWithStateAbbr: "Walla Walla, WA",
  },
  {
    zip: "99363",
    ST: "WA",
    cityWithStateAbbr: "Wallula, WA",
  },
  {
    zip: "99371",
    ST: "WA",
    cityWithStateAbbr: "Washtucna, WA",
  },
  {
    zip: "99401",
    ST: "WA",
    cityWithStateAbbr: "Anatone, WA",
  },
  {
    zip: "99402",
    ST: "WA",
    cityWithStateAbbr: "Asotin, WA",
  },
  {
    zip: "99403",
    ST: "WA",
    cityWithStateAbbr: "Clarkston, WA",
  },
  {
    zip: "99501",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99502",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99503",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99504",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99505",
    ST: "AK",
    cityWithStateAbbr: "Jber, AK",
  },
  {
    zip: "99506",
    ST: "AK",
    cityWithStateAbbr: "Jber, AK",
  },
  {
    zip: "99507",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99508",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99509",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99510",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99511",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99513",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99514",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99515",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99516",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99517",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99518",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99519",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99520",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99521",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99522",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99523",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99524",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99529",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99530",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99540",
    ST: "AK",
    cityWithStateAbbr: "Indian, AK",
  },
  {
    zip: "99545",
    ST: "AK",
    cityWithStateAbbr: "Kongiganak, AK",
  },
  {
    zip: "99546",
    ST: "AK",
    cityWithStateAbbr: "Adak, AK",
  },
  {
    zip: "99547",
    ST: "AK",
    cityWithStateAbbr: "Atka, AK",
  },
  {
    zip: "99548",
    ST: "AK",
    cityWithStateAbbr: "Chignik Lake, AK",
  },
  {
    zip: "99549",
    ST: "AK",
    cityWithStateAbbr: "Port Heiden, AK",
  },
  {
    zip: "99550",
    ST: "AK",
    cityWithStateAbbr: "Port Lions, AK",
  },
  {
    zip: "99551",
    ST: "AK",
    cityWithStateAbbr: "Akiachak, AK",
  },
  {
    zip: "99552",
    ST: "AK",
    cityWithStateAbbr: "Akiak, AK",
  },
  {
    zip: "99553",
    ST: "AK",
    cityWithStateAbbr: "Akutan, AK",
  },
  {
    zip: "99554",
    ST: "AK",
    cityWithStateAbbr: "Alakanuk, AK",
  },
  {
    zip: "99555",
    ST: "AK",
    cityWithStateAbbr: "Aleknagik, AK",
  },
  {
    zip: "99556",
    ST: "AK",
    cityWithStateAbbr: "Anchor Point, AK",
  },
  {
    zip: "99557",
    ST: "AK",
    cityWithStateAbbr: "Aniak, AK",
  },
  {
    zip: "99558",
    ST: "AK",
    cityWithStateAbbr: "Anvik, AK",
  },
  {
    zip: "99559",
    ST: "AK",
    cityWithStateAbbr: "Bethel, AK",
  },
  {
    zip: "99561",
    ST: "AK",
    cityWithStateAbbr: "Chefornak, AK",
  },
  {
    zip: "99563",
    ST: "AK",
    cityWithStateAbbr: "Chevak, AK",
  },
  {
    zip: "99564",
    ST: "AK",
    cityWithStateAbbr: "Chignik, AK",
  },
  {
    zip: "99565",
    ST: "AK",
    cityWithStateAbbr: "Chignik Lagoon, AK",
  },
  {
    zip: "99566",
    ST: "AK",
    cityWithStateAbbr: "Chitina, AK",
  },
  {
    zip: "99567",
    ST: "AK",
    cityWithStateAbbr: "Chugiak, AK",
  },
  {
    zip: "99568",
    ST: "AK",
    cityWithStateAbbr: "Clam Gulch, AK",
  },
  {
    zip: "99569",
    ST: "AK",
    cityWithStateAbbr: "Clarks Point, AK",
  },
  {
    zip: "99571",
    ST: "AK",
    cityWithStateAbbr: "Cold Bay, AK",
  },
  {
    zip: "99572",
    ST: "AK",
    cityWithStateAbbr: "Cooper Landing, AK",
  },
  {
    zip: "99573",
    ST: "AK",
    cityWithStateAbbr: "Copper Center, AK",
  },
  {
    zip: "99574",
    ST: "AK",
    cityWithStateAbbr: "Cordova, AK",
  },
  {
    zip: "99575",
    ST: "AK",
    cityWithStateAbbr: "Crooked Creek, AK",
  },
  {
    zip: "99576",
    ST: "AK",
    cityWithStateAbbr: "Dillingham, AK",
  },
  {
    zip: "99577",
    ST: "AK",
    cityWithStateAbbr: "Eagle River, AK",
  },
  {
    zip: "99578",
    ST: "AK",
    cityWithStateAbbr: "Eek, AK",
  },
  {
    zip: "99579",
    ST: "AK",
    cityWithStateAbbr: "Egegik, AK",
  },
  {
    zip: "99580",
    ST: "AK",
    cityWithStateAbbr: "Ekwok, AK",
  },
  {
    zip: "99581",
    ST: "AK",
    cityWithStateAbbr: "Emmonak, AK",
  },
  {
    zip: "99583",
    ST: "AK",
    cityWithStateAbbr: "False Pass, AK",
  },
  {
    zip: "99585",
    ST: "AK",
    cityWithStateAbbr: "Marshall, AK",
  },
  {
    zip: "99586",
    ST: "AK",
    cityWithStateAbbr: "Gakona, AK",
  },
  {
    zip: "99587",
    ST: "AK",
    cityWithStateAbbr: "Girdwood, AK",
  },
  {
    zip: "99588",
    ST: "AK",
    cityWithStateAbbr: "Glennallen, AK",
  },
  {
    zip: "99589",
    ST: "AK",
    cityWithStateAbbr: "Goodnews Bay, AK",
  },
  {
    zip: "99590",
    ST: "AK",
    cityWithStateAbbr: "Grayling, AK",
  },
  {
    zip: "99591",
    ST: "AK",
    cityWithStateAbbr: "Saint George Island, AK",
  },
  {
    zip: "99599",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99602",
    ST: "AK",
    cityWithStateAbbr: "Holy Cross, AK",
  },
  {
    zip: "99603",
    ST: "AK",
    cityWithStateAbbr: "Homer, AK",
  },
  {
    zip: "99604",
    ST: "AK",
    cityWithStateAbbr: "Hooper Bay, AK",
  },
  {
    zip: "99605",
    ST: "AK",
    cityWithStateAbbr: "Hope, AK",
  },
  {
    zip: "99606",
    ST: "AK",
    cityWithStateAbbr: "Iliamna, AK",
  },
  {
    zip: "99607",
    ST: "AK",
    cityWithStateAbbr: "Kalskag, AK",
  },
  {
    zip: "99608",
    ST: "AK",
    cityWithStateAbbr: "Karluk, AK",
  },
  {
    zip: "99609",
    ST: "AK",
    cityWithStateAbbr: "Kasigluk, AK",
  },
  {
    zip: "99610",
    ST: "AK",
    cityWithStateAbbr: "Kasilof, AK",
  },
  {
    zip: "99611",
    ST: "AK",
    cityWithStateAbbr: "Kenai, AK",
  },
  {
    zip: "99612",
    ST: "AK",
    cityWithStateAbbr: "King Cove, AK",
  },
  {
    zip: "99613",
    ST: "AK",
    cityWithStateAbbr: "King Salmon, AK",
  },
  {
    zip: "99614",
    ST: "AK",
    cityWithStateAbbr: "Kipnuk, AK",
  },
  {
    zip: "99615",
    ST: "AK",
    cityWithStateAbbr: "Kodiak, AK",
  },
  {
    zip: "99619",
    ST: "AK",
    cityWithStateAbbr: "Kodiak, AK",
  },
  {
    zip: "99620",
    ST: "AK",
    cityWithStateAbbr: "Kotlik, AK",
  },
  {
    zip: "99621",
    ST: "AK",
    cityWithStateAbbr: "Kwethluk, AK",
  },
  {
    zip: "99622",
    ST: "AK",
    cityWithStateAbbr: "Kwigillingok, AK",
  },
  {
    zip: "99623",
    ST: "AK",
    cityWithStateAbbr: "Wasilla, AK",
  },
  {
    zip: "99624",
    ST: "AK",
    cityWithStateAbbr: "Larsen Bay, AK",
  },
  {
    zip: "99625",
    ST: "AK",
    cityWithStateAbbr: "Levelock, AK",
  },
  {
    zip: "99626",
    ST: "AK",
    cityWithStateAbbr: "Lower Kalskag, AK",
  },
  {
    zip: "99627",
    ST: "AK",
    cityWithStateAbbr: "Mc Grath, AK",
  },
  {
    zip: "99628",
    ST: "AK",
    cityWithStateAbbr: "Manokotak, AK",
  },
  {
    zip: "99629",
    ST: "AK",
    cityWithStateAbbr: "Wasilla, AK",
  },
  {
    zip: "99630",
    ST: "AK",
    cityWithStateAbbr: "Mekoryuk, AK",
  },
  {
    zip: "99631",
    ST: "AK",
    cityWithStateAbbr: "Moose Pass, AK",
  },
  {
    zip: "99632",
    ST: "AK",
    cityWithStateAbbr: "Mountain Village, AK",
  },
  {
    zip: "99633",
    ST: "AK",
    cityWithStateAbbr: "Naknek, AK",
  },
  {
    zip: "99634",
    ST: "AK",
    cityWithStateAbbr: "Napakiak, AK",
  },
  {
    zip: "99635",
    ST: "AK",
    cityWithStateAbbr: "Nikiski, AK",
  },
  {
    zip: "99636",
    ST: "AK",
    cityWithStateAbbr: "New Stuyahok, AK",
  },
  {
    zip: "99637",
    ST: "AK",
    cityWithStateAbbr: "Toksook Bay, AK",
  },
  {
    zip: "99638",
    ST: "AK",
    cityWithStateAbbr: "Nikolski, AK",
  },
  {
    zip: "99639",
    ST: "AK",
    cityWithStateAbbr: "Ninilchik, AK",
  },
  {
    zip: "99640",
    ST: "AK",
    cityWithStateAbbr: "Nondalton, AK",
  },
  {
    zip: "99641",
    ST: "AK",
    cityWithStateAbbr: "Nunapitchuk, AK",
  },
  {
    zip: "99643",
    ST: "AK",
    cityWithStateAbbr: "Old Harbor, AK",
  },
  {
    zip: "99644",
    ST: "AK",
    cityWithStateAbbr: "Ouzinkie, AK",
  },
  {
    zip: "99645",
    ST: "AK",
    cityWithStateAbbr: "Palmer, AK",
  },
  {
    zip: "99647",
    ST: "AK",
    cityWithStateAbbr: "Pedro Bay, AK",
  },
  {
    zip: "99648",
    ST: "AK",
    cityWithStateAbbr: "Perryville, AK",
  },
  {
    zip: "99649",
    ST: "AK",
    cityWithStateAbbr: "Pilot Point, AK",
  },
  {
    zip: "99650",
    ST: "AK",
    cityWithStateAbbr: "Pilot Station, AK",
  },
  {
    zip: "99651",
    ST: "AK",
    cityWithStateAbbr: "Platinum, AK",
  },
  {
    zip: "99652",
    ST: "AK",
    cityWithStateAbbr: "Big Lake, AK",
  },
  {
    zip: "99653",
    ST: "AK",
    cityWithStateAbbr: "Port Alsworth, AK",
  },
  {
    zip: "99654",
    ST: "AK",
    cityWithStateAbbr: "Wasilla, AK",
  },
  {
    zip: "99655",
    ST: "AK",
    cityWithStateAbbr: "Quinhagak, AK",
  },
  {
    zip: "99656",
    ST: "AK",
    cityWithStateAbbr: "Red Devil, AK",
  },
  {
    zip: "99657",
    ST: "AK",
    cityWithStateAbbr: "Russian Mission, AK",
  },
  {
    zip: "99658",
    ST: "AK",
    cityWithStateAbbr: "Saint Marys, AK",
  },
  {
    zip: "99659",
    ST: "AK",
    cityWithStateAbbr: "Saint Michael, AK",
  },
  {
    zip: "99660",
    ST: "AK",
    cityWithStateAbbr: "Saint Paul Island, AK",
  },
  {
    zip: "99661",
    ST: "AK",
    cityWithStateAbbr: "Sand Point, AK",
  },
  {
    zip: "99662",
    ST: "AK",
    cityWithStateAbbr: "Scammon Bay, AK",
  },
  {
    zip: "99663",
    ST: "AK",
    cityWithStateAbbr: "Seldovia, AK",
  },
  {
    zip: "99664",
    ST: "AK",
    cityWithStateAbbr: "Seward, AK",
  },
  {
    zip: "99665",
    ST: "AK",
    cityWithStateAbbr: "Shageluk, AK",
  },
  {
    zip: "99666",
    ST: "AK",
    cityWithStateAbbr: "Nunam Iqua, AK",
  },
  {
    zip: "99667",
    ST: "AK",
    cityWithStateAbbr: "Skwentna, AK",
  },
  {
    zip: "99668",
    ST: "AK",
    cityWithStateAbbr: "Sleetmute, AK",
  },
  {
    zip: "99669",
    ST: "AK",
    cityWithStateAbbr: "Soldotna, AK",
  },
  {
    zip: "99670",
    ST: "AK",
    cityWithStateAbbr: "South Naknek, AK",
  },
  {
    zip: "99671",
    ST: "AK",
    cityWithStateAbbr: "Stebbins, AK",
  },
  {
    zip: "99672",
    ST: "AK",
    cityWithStateAbbr: "Sterling, AK",
  },
  {
    zip: "99674",
    ST: "AK",
    cityWithStateAbbr: "Sutton, AK",
  },
  {
    zip: "99675",
    ST: "AK",
    cityWithStateAbbr: "Takotna, AK",
  },
  {
    zip: "99676",
    ST: "AK",
    cityWithStateAbbr: "Talkeetna, AK",
  },
  {
    zip: "99677",
    ST: "AK",
    cityWithStateAbbr: "Tatitlek, AK",
  },
  {
    zip: "99678",
    ST: "AK",
    cityWithStateAbbr: "Togiak, AK",
  },
  {
    zip: "99679",
    ST: "AK",
    cityWithStateAbbr: "Tuluksak, AK",
  },
  {
    zip: "99680",
    ST: "AK",
    cityWithStateAbbr: "Tuntutuliak, AK",
  },
  {
    zip: "99681",
    ST: "AK",
    cityWithStateAbbr: "Tununak, AK",
  },
  {
    zip: "99682",
    ST: "AK",
    cityWithStateAbbr: "Tyonek, AK",
  },
  {
    zip: "99683",
    ST: "AK",
    cityWithStateAbbr: "Trapper Creek, AK",
  },
  {
    zip: "99684",
    ST: "AK",
    cityWithStateAbbr: "Unalakleet, AK",
  },
  {
    zip: "99685",
    ST: "AK",
    cityWithStateAbbr: "Unalaska, AK",
  },
  {
    zip: "99686",
    ST: "AK",
    cityWithStateAbbr: "Valdez, AK",
  },
  {
    zip: "99687",
    ST: "AK",
    cityWithStateAbbr: "Wasilla, AK",
  },
  {
    zip: "99688",
    ST: "AK",
    cityWithStateAbbr: "Willow, AK",
  },
  {
    zip: "99689",
    ST: "AK",
    cityWithStateAbbr: "Yakutat, AK",
  },
  {
    zip: "99690",
    ST: "AK",
    cityWithStateAbbr: "Nightmute, AK",
  },
  {
    zip: "99691",
    ST: "AK",
    cityWithStateAbbr: "Nikolai, AK",
  },
  {
    zip: "99692",
    ST: "AK",
    cityWithStateAbbr: "Dutch Harbor, AK",
  },
  {
    zip: "99693",
    ST: "AK",
    cityWithStateAbbr: "Whittier, AK",
  },
  {
    zip: "99694",
    ST: "AK",
    cityWithStateAbbr: "Houston, AK",
  },
  {
    zip: "99695",
    ST: "AK",
    cityWithStateAbbr: "Anchorage, AK",
  },
  {
    zip: "99697",
    ST: "AK",
    cityWithStateAbbr: "Kodiak, AK",
  },
  {
    zip: "99701",
    ST: "AK",
    cityWithStateAbbr: "Fairbanks, AK",
  },
  {
    zip: "99702",
    ST: "AK",
    cityWithStateAbbr: "Eielson Afb, AK",
  },
  {
    zip: "99703",
    ST: "AK",
    cityWithStateAbbr: "Fort Wainwright, AK",
  },
  {
    zip: "99704",
    ST: "AK",
    cityWithStateAbbr: "Clear, AK",
  },
  {
    zip: "99705",
    ST: "AK",
    cityWithStateAbbr: "North Pole, AK",
  },
  {
    zip: "99706",
    ST: "AK",
    cityWithStateAbbr: "Fairbanks, AK",
  },
  {
    zip: "99707",
    ST: "AK",
    cityWithStateAbbr: "Fairbanks, AK",
  },
  {
    zip: "99708",
    ST: "AK",
    cityWithStateAbbr: "Fairbanks, AK",
  },
  {
    zip: "99709",
    ST: "AK",
    cityWithStateAbbr: "Fairbanks, AK",
  },
  {
    zip: "99710",
    ST: "AK",
    cityWithStateAbbr: "Fairbanks, AK",
  },
  {
    zip: "99711",
    ST: "AK",
    cityWithStateAbbr: "Fairbanks, AK",
  },
  {
    zip: "99712",
    ST: "AK",
    cityWithStateAbbr: "Fairbanks, AK",
  },
  {
    zip: "99714",
    ST: "AK",
    cityWithStateAbbr: "Salcha, AK",
  },
  {
    zip: "99716",
    ST: "AK",
    cityWithStateAbbr: "Two Rivers, AK",
  },
  {
    zip: "99720",
    ST: "AK",
    cityWithStateAbbr: "Allakaket, AK",
  },
  {
    zip: "99721",
    ST: "AK",
    cityWithStateAbbr: "Anaktuvuk Pass, AK",
  },
  {
    zip: "99722",
    ST: "AK",
    cityWithStateAbbr: "Arctic Village, AK",
  },
  {
    zip: "99723",
    ST: "AK",
    cityWithStateAbbr: "Barrow, AK",
  },
  {
    zip: "99724",
    ST: "AK",
    cityWithStateAbbr: "Beaver, AK",
  },
  {
    zip: "99725",
    ST: "AK",
    cityWithStateAbbr: "Ester, AK",
  },
  {
    zip: "99726",
    ST: "AK",
    cityWithStateAbbr: "Bettles Field, AK",
  },
  {
    zip: "99727",
    ST: "AK",
    cityWithStateAbbr: "Buckland, AK",
  },
  {
    zip: "99729",
    ST: "AK",
    cityWithStateAbbr: "Cantwell, AK",
  },
  {
    zip: "99730",
    ST: "AK",
    cityWithStateAbbr: "Central, AK",
  },
  {
    zip: "99731",
    ST: "AK",
    cityWithStateAbbr: "Fort Greely, AK",
  },
  {
    zip: "99732",
    ST: "AK",
    cityWithStateAbbr: "Chicken, AK",
  },
  {
    zip: "99733",
    ST: "AK",
    cityWithStateAbbr: "Circle, AK",
  },
  {
    zip: "99734",
    ST: "AK",
    cityWithStateAbbr: "Prudhoe Bay, AK",
  },
  {
    zip: "99736",
    ST: "AK",
    cityWithStateAbbr: "Deering, AK",
  },
  {
    zip: "99737",
    ST: "AK",
    cityWithStateAbbr: "Delta Junction, AK",
  },
  {
    zip: "99738",
    ST: "AK",
    cityWithStateAbbr: "Eagle, AK",
  },
  {
    zip: "99739",
    ST: "AK",
    cityWithStateAbbr: "Elim, AK",
  },
  {
    zip: "99740",
    ST: "AK",
    cityWithStateAbbr: "Fort Yukon, AK",
  },
  {
    zip: "99741",
    ST: "AK",
    cityWithStateAbbr: "Galena, AK",
  },
  {
    zip: "99742",
    ST: "AK",
    cityWithStateAbbr: "Gambell, AK",
  },
  {
    zip: "99743",
    ST: "AK",
    cityWithStateAbbr: "Healy, AK",
  },
  {
    zip: "99744",
    ST: "AK",
    cityWithStateAbbr: "Anderson, AK",
  },
  {
    zip: "99745",
    ST: "AK",
    cityWithStateAbbr: "Hughes, AK",
  },
  {
    zip: "99746",
    ST: "AK",
    cityWithStateAbbr: "Huslia, AK",
  },
  {
    zip: "99747",
    ST: "AK",
    cityWithStateAbbr: "Kaktovik, AK",
  },
  {
    zip: "99748",
    ST: "AK",
    cityWithStateAbbr: "Kaltag, AK",
  },
  {
    zip: "99749",
    ST: "AK",
    cityWithStateAbbr: "Kiana, AK",
  },
  {
    zip: "99750",
    ST: "AK",
    cityWithStateAbbr: "Kivalina, AK",
  },
  {
    zip: "99751",
    ST: "AK",
    cityWithStateAbbr: "Kobuk, AK",
  },
  {
    zip: "99752",
    ST: "AK",
    cityWithStateAbbr: "Kotzebue, AK",
  },
  {
    zip: "99753",
    ST: "AK",
    cityWithStateAbbr: "Koyuk, AK",
  },
  {
    zip: "99754",
    ST: "AK",
    cityWithStateAbbr: "Koyukuk, AK",
  },
  {
    zip: "99755",
    ST: "AK",
    cityWithStateAbbr: "Denali National Park, AK",
  },
  {
    zip: "99756",
    ST: "AK",
    cityWithStateAbbr: "Manley Hot Springs, AK",
  },
  {
    zip: "99757",
    ST: "AK",
    cityWithStateAbbr: "Lake Minchumina, AK",
  },
  {
    zip: "99758",
    ST: "AK",
    cityWithStateAbbr: "Minto, AK",
  },
  {
    zip: "99759",
    ST: "AK",
    cityWithStateAbbr: "Point Lay, AK",
  },
  {
    zip: "99760",
    ST: "AK",
    cityWithStateAbbr: "Nenana, AK",
  },
  {
    zip: "99761",
    ST: "AK",
    cityWithStateAbbr: "Noatak, AK",
  },
  {
    zip: "99762",
    ST: "AK",
    cityWithStateAbbr: "Nome, AK",
  },
  {
    zip: "99763",
    ST: "AK",
    cityWithStateAbbr: "Noorvik, AK",
  },
  {
    zip: "99764",
    ST: "AK",
    cityWithStateAbbr: "Northway, AK",
  },
  {
    zip: "99765",
    ST: "AK",
    cityWithStateAbbr: "Nulato, AK",
  },
  {
    zip: "99766",
    ST: "AK",
    cityWithStateAbbr: "Point Hope, AK",
  },
  {
    zip: "99767",
    ST: "AK",
    cityWithStateAbbr: "Rampart, AK",
  },
  {
    zip: "99768",
    ST: "AK",
    cityWithStateAbbr: "Ruby, AK",
  },
  {
    zip: "99769",
    ST: "AK",
    cityWithStateAbbr: "Savoonga, AK",
  },
  {
    zip: "99770",
    ST: "AK",
    cityWithStateAbbr: "Selawik, AK",
  },
  {
    zip: "99771",
    ST: "AK",
    cityWithStateAbbr: "Shaktoolik, AK",
  },
  {
    zip: "99772",
    ST: "AK",
    cityWithStateAbbr: "Shishmaref, AK",
  },
  {
    zip: "99773",
    ST: "AK",
    cityWithStateAbbr: "Shungnak, AK",
  },
  {
    zip: "99774",
    ST: "AK",
    cityWithStateAbbr: "Stevens Village, AK",
  },
  {
    zip: "99775",
    ST: "AK",
    cityWithStateAbbr: "Fairbanks, AK",
  },
  {
    zip: "99776",
    ST: "AK",
    cityWithStateAbbr: "Tanacross, AK",
  },
  {
    zip: "99777",
    ST: "AK",
    cityWithStateAbbr: "Tanana, AK",
  },
  {
    zip: "99778",
    ST: "AK",
    cityWithStateAbbr: "Teller, AK",
  },
  {
    zip: "99780",
    ST: "AK",
    cityWithStateAbbr: "Tok, AK",
  },
  {
    zip: "99781",
    ST: "AK",
    cityWithStateAbbr: "Venetie, AK",
  },
  {
    zip: "99782",
    ST: "AK",
    cityWithStateAbbr: "Wainwright, AK",
  },
  {
    zip: "99783",
    ST: "AK",
    cityWithStateAbbr: "Wales, AK",
  },
  {
    zip: "99784",
    ST: "AK",
    cityWithStateAbbr: "White Mountain, AK",
  },
  {
    zip: "99785",
    ST: "AK",
    cityWithStateAbbr: "Brevig Mission, AK",
  },
  {
    zip: "99786",
    ST: "AK",
    cityWithStateAbbr: "Ambler, AK",
  },
  {
    zip: "99788",
    ST: "AK",
    cityWithStateAbbr: "Chalkyitsik, AK",
  },
  {
    zip: "99789",
    ST: "AK",
    cityWithStateAbbr: "Nuiqsut, AK",
  },
  {
    zip: "99790",
    ST: "AK",
    cityWithStateAbbr: "Fairbanks, AK",
  },
  {
    zip: "99791",
    ST: "AK",
    cityWithStateAbbr: "Atqasuk, AK",
  },
  {
    zip: "99801",
    ST: "AK",
    cityWithStateAbbr: "Juneau, AK",
  },
  {
    zip: "99802",
    ST: "AK",
    cityWithStateAbbr: "Juneau, AK",
  },
  {
    zip: "99803",
    ST: "AK",
    cityWithStateAbbr: "Juneau, AK",
  },
  {
    zip: "99811",
    ST: "AK",
    cityWithStateAbbr: "Juneau, AK",
  },
  {
    zip: "99812",
    ST: "AK",
    cityWithStateAbbr: "Juneau, AK",
  },
  {
    zip: "99820",
    ST: "AK",
    cityWithStateAbbr: "Angoon, AK",
  },
  {
    zip: "99821",
    ST: "AK",
    cityWithStateAbbr: "Auke Bay, AK",
  },
  {
    zip: "99824",
    ST: "AK",
    cityWithStateAbbr: "Douglas, AK",
  },
  {
    zip: "99825",
    ST: "AK",
    cityWithStateAbbr: "Elfin Cove, AK",
  },
  {
    zip: "99826",
    ST: "AK",
    cityWithStateAbbr: "Gustavus, AK",
  },
  {
    zip: "99827",
    ST: "AK",
    cityWithStateAbbr: "Haines, AK",
  },
  {
    zip: "99829",
    ST: "AK",
    cityWithStateAbbr: "Hoonah, AK",
  },
  {
    zip: "99830",
    ST: "AK",
    cityWithStateAbbr: "Kake, AK",
  },
  {
    zip: "99832",
    ST: "AK",
    cityWithStateAbbr: "Pelican, AK",
  },
  {
    zip: "99833",
    ST: "AK",
    cityWithStateAbbr: "Petersburg, AK",
  },
  {
    zip: "99835",
    ST: "AK",
    cityWithStateAbbr: "Sitka, AK",
  },
  {
    zip: "99836",
    ST: "AK",
    cityWithStateAbbr: "Port Alexander, AK",
  },
  {
    zip: "99840",
    ST: "AK",
    cityWithStateAbbr: "Skagway, AK",
  },
  {
    zip: "99841",
    ST: "AK",
    cityWithStateAbbr: "Tenakee Springs, AK",
  },
  {
    zip: "99850",
    ST: "AK",
    cityWithStateAbbr: "Juneau, AK",
  },
  {
    zip: "99901",
    ST: "AK",
    cityWithStateAbbr: "Ketchikan, AK",
  },
  {
    zip: "99903",
    ST: "AK",
    cityWithStateAbbr: "Meyers Chuck, AK",
  },
  {
    zip: "99918",
    ST: "AK",
    cityWithStateAbbr: "Coffman Cove, AK",
  },
  {
    zip: "99919",
    ST: "AK",
    cityWithStateAbbr: "Thorne Bay, AK",
  },
  {
    zip: "99921",
    ST: "AK",
    cityWithStateAbbr: "Craig, AK",
  },
  {
    zip: "99922",
    ST: "AK",
    cityWithStateAbbr: "Hydaburg, AK",
  },
  {
    zip: "99923",
    ST: "AK",
    cityWithStateAbbr: "Hyder, AK",
  },
  {
    zip: "99925",
    ST: "AK",
    cityWithStateAbbr: "Klawock, AK",
  },
  {
    zip: "99926",
    ST: "AK",
    cityWithStateAbbr: "Metlakatla, AK",
  },
  {
    zip: "99927",
    ST: "AK",
    cityWithStateAbbr: "Point Baker, AK",
  },
  {
    zip: "99928",
    ST: "AK",
    cityWithStateAbbr: "Ward Cove, AK",
  },
  {
    zip: "99929",
    ST: "AK",
    cityWithStateAbbr: "Wrangell, AK",
  },
  {
    zip: "99950",
    ST: "AK",
    cityWithStateAbbr: "Ketchikan, AK",
  },
];
